var J_ = Object.defineProperty;
var X_ = (e, t, o) => t in e ? J_(e, t, { enumerable: !0, configurable: !0, writable: !0, value: o }) : e[t] = o;
var _e = (e, t, o) => X_(e, typeof t != "symbol" ? t + "" : t, o);
import { unref as k, reactive as eS, computed as F, ref as W, shallowRef as Je, hasInjectionContext as Gl, onMounted as At, nextTick as rt, toValue as ke, watchEffect as Nl, getCurrentInstance as Bo, inject as n1, watch as Me, getCurrentScope as I5, onScopeDispose as Yi, defineComponent as pe, useModel as ct, openBlock as f, createElementBlock as v, normalizeClass as S, Fragment as we, renderList as Ze, toDisplayString as se, createElementVNode as g, mergeModels as Ct, shallowReadonly as bs, toRef as tS, readonly as T0, customRef as oS, createCommentVNode as $, createStaticVNode as Do, useCssVars as Vn, createBlock as U, resolveDynamicComponent as Po, useSlots as Qt, onBeforeUnmount as ei, normalizeStyle as Ge, renderSlot as ve, createTextVNode as Ve, Teleport as D5, withCtx as ee, onUnmounted as Qi, createVNode as de, resolveDirective as k5, withDirectives as Et, createSlots as sn, withModifiers as xe, useTemplateRef as Ro, isRef as Tn, withKeys as ol, mergeProps as Bt, useId as Ns, vModelText as xn, normalizeProps as nl, guardReactiveProps as sl, toRefs as d7, onActivated as nS, onDeactivated as sS, h as vo, useCssModule as H5, useAttrs as iS, vShow as Hi, Comment as u7, Transition as I0, provide as rS, markRaw as lS, mergeDefaults as aS, toRaw as Mc, isReactive as cS, isProxy as dS, render as il, vModelDynamic as Ac, createApp as uS, resolveComponent as hS, shallowReactive as gS } from "vue";
import { createI18n as h7, useI18n as Go } from "vue-i18n";
import { useModal as pS, useSnack as fS, useSnackbar as vS } from "vue-haystack";
const mS = [
  { bgColor: "#DEE3E7", textColor: "#272E35", hoverBgColor: "#555F6D", hoverTextColor: "#FFFFFF" },
  { bgColor: "#FCDEC0", textColor: "#7A4510", hoverBgColor: "#F59638", hoverTextColor: "#FFFFFF" },
  { bgColor: "#FCD9D9", textColor: "#6F2020", hoverBgColor: "#C53434", hoverTextColor: "#FFFFFF" },
  { bgColor: "#FBD5E2", textColor: "#671E36", hoverBgColor: "#C03060", hoverTextColor: "#FFFFFF" },
  { bgColor: "#FBD5EE", textColor: "#671E4E", hoverBgColor: "#B12F86", hoverTextColor: "#FFFFFF" },
  { bgColor: "#F5D5FB", textColor: "#5B1E67", hoverBgColor: "#9939AC", hoverTextColor: "#FFFFFF" },
  { bgColor: "#EDDBFF", textColor: "#4C2277", hoverBgColor: "#8040BF", hoverTextColor: "#FFFFFF" },
  { bgColor: "#E3E0FF", textColor: "#39288A", hoverBgColor: "#634ECA", hoverTextColor: "#FFFFFF" },
  { bgColor: "#D7E4FF", textColor: "#113997", hoverBgColor: "#3062D4", hoverTextColor: "#FFFFFF" },
  { bgColor: "#CCE7FF", textColor: "#0C456E", hoverBgColor: "#0870BA", hoverTextColor: "#FFFFFF" },
  { bgColor: "#C5ECF7", textColor: "#0A495C", hoverBgColor: "#077597", hoverTextColor: "#FFFFFF" },
  { bgColor: "#C5F2EC", textColor: "#0D4A42", hoverBgColor: "#097C69", hoverTextColor: "#FFFFFF" },
  { bgColor: "#C6F1DA", textColor: "#0E4E30", hoverBgColor: "#1D7C4D", hoverTextColor: "#FFFFFF" },
  { bgColor: "#CFF2CF", textColor: "#135315", hoverBgColor: "#347434", hoverTextColor: "#FFFFFF" }
], g7 = 6048e5, CS = 864e5, wS = 6e4, bS = 36e5, yS = 1e3, Lc = Symbol.for("constructDateFrom");
function wt(e, t) {
  return typeof e == "function" ? e(t) : e && typeof e == "object" && Lc in e ? e[Lc](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
}
function et(e, t) {
  return wt(t || e, e);
}
function _i(e, t, o) {
  const n = et(e, o == null ? void 0 : o.in);
  return isNaN(t) ? wt((o == null ? void 0 : o.in) || e, NaN) : (t && n.setDate(n.getDate() + t), n);
}
function Ec(e, t, o) {
  const n = et(e, o == null ? void 0 : o.in);
  if (isNaN(t)) return wt(e, NaN);
  if (!t)
    return n;
  const s = n.getDate(), i = wt(e, n.getTime());
  i.setMonth(n.getMonth() + t + 1, 0);
  const r = i.getDate();
  return s >= r ? i : (n.setFullYear(
    i.getFullYear(),
    i.getMonth(),
    s
  ), n);
}
function _S(e, t) {
  const o = et(e, t == null ? void 0 : t.in).getDay();
  return o === 0 || o === 6;
}
let SS = {};
function Ji() {
  return SS;
}
function cn(e, t) {
  var l, a, c, d;
  const o = Ji(), n = (t == null ? void 0 : t.weekStartsOn) ?? ((a = (l = t == null ? void 0 : t.locale) == null ? void 0 : l.options) == null ? void 0 : a.weekStartsOn) ?? o.weekStartsOn ?? ((d = (c = o.locale) == null ? void 0 : c.options) == null ? void 0 : d.weekStartsOn) ?? 0, s = et(e, t == null ? void 0 : t.in), i = s.getDay(), r = (i < n ? 7 : 0) + i - n;
  return s.setDate(s.getDate() - r), s.setHours(0, 0, 0, 0), s;
}
function Vi(e, t) {
  return cn(e, { ...t, weekStartsOn: 1 });
}
function p7(e, t) {
  const o = et(e, t == null ? void 0 : t.in), n = o.getFullYear(), s = wt(o, 0);
  s.setFullYear(n + 1, 0, 4), s.setHours(0, 0, 0, 0);
  const i = Vi(s), r = wt(o, 0);
  r.setFullYear(n, 0, 4), r.setHours(0, 0, 0, 0);
  const l = Vi(r);
  return o.getTime() >= i.getTime() ? n + 1 : o.getTime() >= l.getTime() ? n : n - 1;
}
function rl(e) {
  const t = et(e), o = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return o.setUTCFullYear(t.getFullYear()), +e - +o;
}
function f7(e, ...t) {
  const o = wt.bind(
    null,
    t.find((n) => typeof n == "object")
  );
  return t.map(o);
}
function lt(e, t) {
  const o = et(e, t == null ? void 0 : t.in);
  return o.setHours(0, 0, 0, 0), o;
}
function v7(e, t, o) {
  const [n, s] = f7(
    o == null ? void 0 : o.in,
    e,
    t
  ), i = lt(n), r = lt(s), l = +i - rl(i), a = +r - rl(r);
  return Math.round((l - a) / CS);
}
function xS(e, t) {
  const o = p7(e, t), n = wt(e, 0);
  return n.setFullYear(o, 0, 4), n.setHours(0, 0, 0, 0), Vi(n);
}
function MS(e) {
  return wt(e, Date.now());
}
function Yn(e, t, o) {
  const [n, s] = f7(
    o == null ? void 0 : o.in,
    e,
    t
  );
  return +lt(n) == +lt(s);
}
function AS(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function V5(e) {
  return !(!AS(e) && typeof e != "number" || isNaN(+et(e)));
}
function Pc(e, t) {
  const o = et(e, t == null ? void 0 : t.in);
  return o.setHours(23, 59, 59, 999), o;
}
function LS(e, t) {
  const o = et(e, t == null ? void 0 : t.in), n = o.getMonth();
  return o.setFullYear(o.getFullYear(), n + 1, 0), o.setHours(23, 59, 59, 999), o;
}
function mr(e, t) {
  const o = et(e, t == null ? void 0 : t.in);
  return o.setDate(1), o.setHours(0, 0, 0, 0), o;
}
function ES(e, t) {
  const o = et(e, t == null ? void 0 : t.in);
  return o.setFullYear(o.getFullYear(), 0, 1), o.setHours(0, 0, 0, 0), o;
}
const PS = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, RS = (e, t, o) => {
  let n;
  const s = PS[e];
  return typeof s == "string" ? n = s : t === 1 ? n = s.one : n = s.other.replace("{{count}}", t.toString()), o != null && o.addSuffix ? o.comparison && o.comparison > 0 ? "in " + n : n + " ago" : n;
};
function Si(e) {
  return (t = {}) => {
    const o = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[o] || e.formats[e.defaultWidth];
  };
}
const FS = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, TS = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, IS = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, DS = {
  date: Si({
    formats: FS,
    defaultWidth: "full"
  }),
  time: Si({
    formats: TS,
    defaultWidth: "full"
  }),
  dateTime: Si({
    formats: IS,
    defaultWidth: "full"
  })
}, kS = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, HS = (e, t, o, n) => kS[e];
function Jo(e) {
  return (t, o) => {
    const n = o != null && o.context ? String(o.context) : "standalone";
    let s;
    if (n === "formatting" && e.formattingValues) {
      const r = e.defaultFormattingWidth || e.defaultWidth, l = o != null && o.width ? String(o.width) : r;
      s = e.formattingValues[l] || e.formattingValues[r];
    } else {
      const r = e.defaultWidth, l = o != null && o.width ? String(o.width) : e.defaultWidth;
      s = e.values[l] || e.values[r];
    }
    const i = e.argumentCallback ? e.argumentCallback(t) : t;
    return s[i];
  };
}
const VS = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, OS = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, BS = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, $S = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, ZS = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, GS = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, NS = (e, t) => {
  const o = Number(e), n = o % 100;
  if (n > 20 || n < 10)
    switch (n % 10) {
      case 1:
        return o + "st";
      case 2:
        return o + "nd";
      case 3:
        return o + "rd";
    }
  return o + "th";
}, zS = {
  ordinalNumber: NS,
  era: Jo({
    values: VS,
    defaultWidth: "wide"
  }),
  quarter: Jo({
    values: OS,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Jo({
    values: BS,
    defaultWidth: "wide"
  }),
  day: Jo({
    values: $S,
    defaultWidth: "wide"
  }),
  dayPeriod: Jo({
    values: ZS,
    defaultWidth: "wide",
    formattingValues: GS,
    defaultFormattingWidth: "wide"
  })
};
function Xo(e) {
  return (t, o = {}) => {
    const n = o.width, s = n && e.matchPatterns[n] || e.matchPatterns[e.defaultMatchWidth], i = t.match(s);
    if (!i)
      return null;
    const r = i[0], l = n && e.parsePatterns[n] || e.parsePatterns[e.defaultParseWidth], a = Array.isArray(l) ? WS(l, (u) => u.test(r)) : (
      // [TODO] -- I challenge you to fix the type
      jS(l, (u) => u.test(r))
    );
    let c;
    c = e.valueCallback ? e.valueCallback(a) : a, c = o.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      o.valueCallback(c)
    ) : c;
    const d = t.slice(r.length);
    return { value: c, rest: d };
  };
}
function jS(e, t) {
  for (const o in e)
    if (Object.prototype.hasOwnProperty.call(e, o) && t(e[o]))
      return o;
}
function WS(e, t) {
  for (let o = 0; o < e.length; o++)
    if (t(e[o]))
      return o;
}
function m7(e) {
  return (t, o = {}) => {
    const n = t.match(e.matchPattern);
    if (!n) return null;
    const s = n[0], i = t.match(e.parsePattern);
    if (!i) return null;
    let r = e.valueCallback ? e.valueCallback(i[0]) : i[0];
    r = o.valueCallback ? o.valueCallback(r) : r;
    const l = t.slice(s.length);
    return { value: r, rest: l };
  };
}
const US = /^(\d+)(th|st|nd|rd)?/i, KS = /\d+/i, qS = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, YS = {
  any: [/^b/i, /^(a|c)/i]
}, QS = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, JS = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, XS = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, ex = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, tx = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, ox = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, nx = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, sx = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, ix = {
  ordinalNumber: m7({
    matchPattern: US,
    parsePattern: KS,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Xo({
    matchPatterns: qS,
    defaultMatchWidth: "wide",
    parsePatterns: YS,
    defaultParseWidth: "any"
  }),
  quarter: Xo({
    matchPatterns: QS,
    defaultMatchWidth: "wide",
    parsePatterns: JS,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Xo({
    matchPatterns: XS,
    defaultMatchWidth: "wide",
    parsePatterns: ex,
    defaultParseWidth: "any"
  }),
  day: Xo({
    matchPatterns: tx,
    defaultMatchWidth: "wide",
    parsePatterns: ox,
    defaultParseWidth: "any"
  }),
  dayPeriod: Xo({
    matchPatterns: nx,
    defaultMatchWidth: "any",
    parsePatterns: sx,
    defaultParseWidth: "any"
  })
}, O5 = {
  code: "en-US",
  formatDistance: RS,
  formatLong: DS,
  formatRelative: HS,
  localize: zS,
  match: ix,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function rx(e, t) {
  const o = et(e, t == null ? void 0 : t.in);
  return v7(o, ES(o)) + 1;
}
function C7(e, t) {
  const o = et(e, t == null ? void 0 : t.in), n = +Vi(o) - +xS(o);
  return Math.round(n / g7) + 1;
}
function B5(e, t) {
  var d, u, h, p;
  const o = et(e, t == null ? void 0 : t.in), n = o.getFullYear(), s = Ji(), i = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((u = (d = t == null ? void 0 : t.locale) == null ? void 0 : d.options) == null ? void 0 : u.firstWeekContainsDate) ?? s.firstWeekContainsDate ?? ((p = (h = s.locale) == null ? void 0 : h.options) == null ? void 0 : p.firstWeekContainsDate) ?? 1, r = wt((t == null ? void 0 : t.in) || e, 0);
  r.setFullYear(n + 1, 0, i), r.setHours(0, 0, 0, 0);
  const l = cn(r, t), a = wt((t == null ? void 0 : t.in) || e, 0);
  a.setFullYear(n, 0, i), a.setHours(0, 0, 0, 0);
  const c = cn(a, t);
  return +o >= +l ? n + 1 : +o >= +c ? n : n - 1;
}
function lx(e, t) {
  var l, a, c, d;
  const o = Ji(), n = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((a = (l = t == null ? void 0 : t.locale) == null ? void 0 : l.options) == null ? void 0 : a.firstWeekContainsDate) ?? o.firstWeekContainsDate ?? ((d = (c = o.locale) == null ? void 0 : c.options) == null ? void 0 : d.firstWeekContainsDate) ?? 1, s = B5(e, t), i = wt((t == null ? void 0 : t.in) || e, 0);
  return i.setFullYear(s, 0, n), i.setHours(0, 0, 0, 0), cn(i, t);
}
function $5(e, t) {
  const o = et(e, t == null ? void 0 : t.in), n = +cn(o, t) - +lx(o, t);
  return Math.round(n / g7) + 1;
}
function st(e, t) {
  const o = e < 0 ? "-" : "", n = Math.abs(e).toString().padStart(t, "0");
  return o + n;
}
const Nn = {
  // Year
  y(e, t) {
    const o = e.getFullYear(), n = o > 0 ? o : 1 - o;
    return st(t === "yy" ? n % 100 : n, t.length);
  },
  // Month
  M(e, t) {
    const o = e.getMonth();
    return t === "M" ? String(o + 1) : st(o + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return st(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const o = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return o.toUpperCase();
      case "aaa":
        return o;
      case "aaaaa":
        return o[0];
      case "aaaa":
      default:
        return o === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return st(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return st(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return st(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return st(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const o = t.length, n = e.getMilliseconds(), s = Math.trunc(
      n * Math.pow(10, o - 3)
    );
    return st(s, t.length);
  }
}, hi = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Rc = {
  // Era
  G: function(e, t, o) {
    const n = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return o.era(n, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return o.era(n, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return o.era(n, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, o) {
    if (t === "yo") {
      const n = e.getFullYear(), s = n > 0 ? n : 1 - n;
      return o.ordinalNumber(s, { unit: "year" });
    }
    return Nn.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, o, n) {
    const s = B5(e, n), i = s > 0 ? s : 1 - s;
    if (t === "YY") {
      const r = i % 100;
      return st(r, 2);
    }
    return t === "Yo" ? o.ordinalNumber(i, { unit: "year" }) : st(i, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const o = p7(e);
    return st(o, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const o = e.getFullYear();
    return st(o, t.length);
  },
  // Quarter
  Q: function(e, t, o) {
    const n = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "Q":
        return String(n);
      // 01, 02, 03, 04
      case "QQ":
        return st(n, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return o.ordinalNumber(n, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return o.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return o.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return o.quarter(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, o) {
    const n = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "q":
        return String(n);
      // 01, 02, 03, 04
      case "qq":
        return st(n, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return o.ordinalNumber(n, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return o.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return o.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return o.quarter(n, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, o) {
    const n = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return Nn.M(e, t);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return o.ordinalNumber(n + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return o.month(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return o.month(n, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return o.month(n, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, o) {
    const n = e.getMonth();
    switch (t) {
      // 1, 2, ..., 12
      case "L":
        return String(n + 1);
      // 01, 02, ..., 12
      case "LL":
        return st(n + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return o.ordinalNumber(n + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return o.month(n, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return o.month(n, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return o.month(n, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, o, n) {
    const s = $5(e, n);
    return t === "wo" ? o.ordinalNumber(s, { unit: "week" }) : st(s, t.length);
  },
  // ISO week of year
  I: function(e, t, o) {
    const n = C7(e);
    return t === "Io" ? o.ordinalNumber(n, { unit: "week" }) : st(n, t.length);
  },
  // Day of the month
  d: function(e, t, o) {
    return t === "do" ? o.ordinalNumber(e.getDate(), { unit: "date" }) : Nn.d(e, t);
  },
  // Day of year
  D: function(e, t, o) {
    const n = rx(e);
    return t === "Do" ? o.ordinalNumber(n, { unit: "dayOfYear" }) : st(n, t.length);
  },
  // Day of week
  E: function(e, t, o) {
    const n = e.getDay();
    switch (t) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return o.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return o.day(n, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return o.day(n, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return o.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, o, n) {
    const s = e.getDay(), i = (s - n.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(i);
      // Padded numerical value
      case "ee":
        return st(i, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return o.ordinalNumber(i, { unit: "day" });
      case "eee":
        return o.day(s, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return o.day(s, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return o.day(s, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return o.day(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, o, n) {
    const s = e.getDay(), i = (s - n.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (same as in `e`)
      case "c":
        return String(i);
      // Padded numerical value
      case "cc":
        return st(i, t.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return o.ordinalNumber(i, { unit: "day" });
      case "ccc":
        return o.day(s, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return o.day(s, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return o.day(s, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return o.day(s, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, o) {
    const n = e.getDay(), s = n === 0 ? 7 : n;
    switch (t) {
      // 2
      case "i":
        return String(s);
      // 02
      case "ii":
        return st(s, t.length);
      // 2nd
      case "io":
        return o.ordinalNumber(s, { unit: "day" });
      // Tue
      case "iii":
        return o.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return o.day(n, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return o.day(n, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return o.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, o) {
    const s = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return o.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return o.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return o.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return o.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, o) {
    const n = e.getHours();
    let s;
    switch (n === 12 ? s = hi.noon : n === 0 ? s = hi.midnight : s = n / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return o.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return o.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return o.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return o.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, o) {
    const n = e.getHours();
    let s;
    switch (n >= 17 ? s = hi.evening : n >= 12 ? s = hi.afternoon : n >= 4 ? s = hi.morning : s = hi.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return o.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return o.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return o.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, o) {
    if (t === "ho") {
      let n = e.getHours() % 12;
      return n === 0 && (n = 12), o.ordinalNumber(n, { unit: "hour" });
    }
    return Nn.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, o) {
    return t === "Ho" ? o.ordinalNumber(e.getHours(), { unit: "hour" }) : Nn.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, o) {
    const n = e.getHours() % 12;
    return t === "Ko" ? o.ordinalNumber(n, { unit: "hour" }) : st(n, t.length);
  },
  // Hour [1-24]
  k: function(e, t, o) {
    let n = e.getHours();
    return n === 0 && (n = 24), t === "ko" ? o.ordinalNumber(n, { unit: "hour" }) : st(n, t.length);
  },
  // Minute
  m: function(e, t, o) {
    return t === "mo" ? o.ordinalNumber(e.getMinutes(), { unit: "minute" }) : Nn.m(e, t);
  },
  // Second
  s: function(e, t, o) {
    return t === "so" ? o.ordinalNumber(e.getSeconds(), { unit: "second" }) : Nn.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return Nn.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, o) {
    const n = e.getTimezoneOffset();
    if (n === 0)
      return "Z";
    switch (t) {
      // Hours and optional minutes
      case "X":
        return Tc(n);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return ys(n);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return ys(n, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, o) {
    const n = e.getTimezoneOffset();
    switch (t) {
      // Hours and optional minutes
      case "x":
        return Tc(n);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return ys(n);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return ys(n, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, o) {
    const n = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Fc(n, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + ys(n, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, o) {
    const n = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Fc(n, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + ys(n, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, o) {
    const n = Math.trunc(+e / 1e3);
    return st(n, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, o) {
    return st(+e, t.length);
  }
};
function Fc(e, t = "") {
  const o = e > 0 ? "-" : "+", n = Math.abs(e), s = Math.trunc(n / 60), i = n % 60;
  return i === 0 ? o + String(s) : o + String(s) + t + st(i, 2);
}
function Tc(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + st(Math.abs(e) / 60, 2) : ys(e, t);
}
function ys(e, t = "") {
  const o = e > 0 ? "-" : "+", n = Math.abs(e), s = st(Math.trunc(n / 60), 2), i = st(n % 60, 2);
  return o + s + t + i;
}
const Ic = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, w7 = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, ax = (e, t) => {
  const o = e.match(/(P+)(p+)?/) || [], n = o[1], s = o[2];
  if (!s)
    return Ic(e, t);
  let i;
  switch (n) {
    case "P":
      i = t.dateTime({ width: "short" });
      break;
    case "PP":
      i = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      i = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      i = t.dateTime({ width: "full" });
      break;
  }
  return i.replace("{{date}}", Ic(n, t)).replace("{{time}}", w7(s, t));
}, D0 = {
  p: w7,
  P: ax
}, cx = /^D+$/, dx = /^Y+$/, ux = ["D", "DD", "YY", "YYYY"];
function b7(e) {
  return cx.test(e);
}
function y7(e) {
  return dx.test(e);
}
function k0(e, t, o) {
  const n = hx(e, t, o);
  if (console.warn(n), ux.includes(e)) throw new RangeError(n);
}
function hx(e, t, o) {
  const n = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${n} to the input \`${o}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const gx = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, px = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, fx = /^'([^]*?)'?$/, vx = /''/g, mx = /[a-zA-Z]/;
function In(e, t, o) {
  var d, u, h, p, C, m, w, y;
  const n = Ji(), s = (o == null ? void 0 : o.locale) ?? n.locale ?? O5, i = (o == null ? void 0 : o.firstWeekContainsDate) ?? ((u = (d = o == null ? void 0 : o.locale) == null ? void 0 : d.options) == null ? void 0 : u.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((p = (h = n.locale) == null ? void 0 : h.options) == null ? void 0 : p.firstWeekContainsDate) ?? 1, r = (o == null ? void 0 : o.weekStartsOn) ?? ((m = (C = o == null ? void 0 : o.locale) == null ? void 0 : C.options) == null ? void 0 : m.weekStartsOn) ?? n.weekStartsOn ?? ((y = (w = n.locale) == null ? void 0 : w.options) == null ? void 0 : y.weekStartsOn) ?? 0, l = et(e, o == null ? void 0 : o.in);
  if (!V5(l))
    throw new RangeError("Invalid time value");
  let a = t.match(px).map((b) => {
    const _ = b[0];
    if (_ === "p" || _ === "P") {
      const M = D0[_];
      return M(b, s.formatLong);
    }
    return b;
  }).join("").match(gx).map((b) => {
    if (b === "''")
      return { isToken: !1, value: "'" };
    const _ = b[0];
    if (_ === "'")
      return { isToken: !1, value: Cx(b) };
    if (Rc[_])
      return { isToken: !0, value: b };
    if (_.match(mx))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + _ + "`"
      );
    return { isToken: !1, value: b };
  });
  s.localize.preprocessor && (a = s.localize.preprocessor(l, a));
  const c = {
    firstWeekContainsDate: i,
    weekStartsOn: r,
    locale: s
  };
  return a.map((b) => {
    if (!b.isToken) return b.value;
    const _ = b.value;
    (!(o != null && o.useAdditionalWeekYearTokens) && y7(_) || !(o != null && o.useAdditionalDayOfYearTokens) && b7(_)) && k0(_, t, String(e));
    const M = Rc[_[0]];
    return M(l, _, s.localize, c);
  }).join("");
}
function Cx(e) {
  const t = e.match(fx);
  return t ? t[1].replace(vx, "'") : e;
}
function wx(e, t) {
  return et(e, t == null ? void 0 : t.in).getDate();
}
function bx(e, t) {
  const o = et(e, t == null ? void 0 : t.in), n = o.getFullYear(), s = o.getMonth(), i = wt(o, 0);
  return i.setFullYear(n, s + 1, 0), i.setHours(0, 0, 0, 0), i.getDate();
}
function yx() {
  return Object.assign({}, Ji());
}
function _x(e, t) {
  const o = et(e, t == null ? void 0 : t.in).getDay();
  return o === 0 ? 7 : o;
}
function m1(e, t) {
  return +et(e) > +et(t);
}
function C1(e, t) {
  return +et(e) < +et(t);
}
function Sx(e, t) {
  const o = xx(t) ? new t(0) : wt(t, 0);
  return o.setFullYear(e.getFullYear(), e.getMonth(), e.getDate()), o.setHours(
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  ), o;
}
function xx(e) {
  var t;
  return typeof e == "function" && ((t = e.prototype) == null ? void 0 : t.constructor) === e;
}
const Mx = 10;
class _7 {
  constructor() {
    _e(this, "subPriority", 0);
  }
  validate(t, o) {
    return !0;
  }
}
class Ax extends _7 {
  constructor(t, o, n, s, i) {
    super(), this.value = t, this.validateValue = o, this.setValue = n, this.priority = s, i && (this.subPriority = i);
  }
  validate(t, o) {
    return this.validateValue(t, this.value, o);
  }
  set(t, o, n) {
    return this.setValue(t, o, this.value, n);
  }
}
class Lx extends _7 {
  constructor(o, n) {
    super();
    _e(this, "priority", Mx);
    _e(this, "subPriority", -1);
    this.context = o || ((s) => wt(n, s));
  }
  set(o, n) {
    return n.timestampIsSet ? o : wt(o, Sx(o, this.context));
  }
}
class tt {
  run(t, o, n, s) {
    const i = this.parse(t, o, n, s);
    return i ? {
      setter: new Ax(
        i.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: i.rest
    } : null;
  }
  validate(t, o, n) {
    return !0;
  }
}
class Ex extends tt {
  constructor() {
    super(...arguments);
    _e(this, "priority", 140);
    _e(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(o, n, s) {
    switch (n) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return s.era(o, { width: "abbreviated" }) || s.era(o, { width: "narrow" });
      // A, B
      case "GGGGG":
        return s.era(o, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return s.era(o, { width: "wide" }) || s.era(o, { width: "abbreviated" }) || s.era(o, { width: "narrow" });
    }
  }
  set(o, n, s) {
    return n.era = s, o.setFullYear(s, 0, 1), o.setHours(0, 0, 0, 0), o;
  }
}
const xt = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, en = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function Mt(e, t) {
  return e && {
    value: t(e.value),
    rest: e.rest
  };
}
function mt(e, t) {
  const o = t.match(e);
  return o ? {
    value: parseInt(o[0], 10),
    rest: t.slice(o[0].length)
  } : null;
}
function tn(e, t) {
  const o = t.match(e);
  if (!o)
    return null;
  if (o[0] === "Z")
    return {
      value: 0,
      rest: t.slice(1)
    };
  const n = o[1] === "+" ? 1 : -1, s = o[2] ? parseInt(o[2], 10) : 0, i = o[3] ? parseInt(o[3], 10) : 0, r = o[5] ? parseInt(o[5], 10) : 0;
  return {
    value: n * (s * bS + i * wS + r * yS),
    rest: t.slice(o[0].length)
  };
}
function S7(e) {
  return mt(xt.anyDigitsSigned, e);
}
function bt(e, t) {
  switch (e) {
    case 1:
      return mt(xt.singleDigit, t);
    case 2:
      return mt(xt.twoDigits, t);
    case 3:
      return mt(xt.threeDigits, t);
    case 4:
      return mt(xt.fourDigits, t);
    default:
      return mt(new RegExp("^\\d{1," + e + "}"), t);
  }
}
function ll(e, t) {
  switch (e) {
    case 1:
      return mt(xt.singleDigitSigned, t);
    case 2:
      return mt(xt.twoDigitsSigned, t);
    case 3:
      return mt(xt.threeDigitsSigned, t);
    case 4:
      return mt(xt.fourDigitsSigned, t);
    default:
      return mt(new RegExp("^-?\\d{1," + e + "}"), t);
  }
}
function Z5(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function x7(e, t) {
  const o = t > 0, n = o ? t : 1 - t;
  let s;
  if (n <= 50)
    s = e || 100;
  else {
    const i = n + 50, r = Math.trunc(i / 100) * 100, l = e >= i % 100;
    s = e + r - (l ? 100 : 0);
  }
  return o ? s : 1 - s;
}
function M7(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
class Px extends tt {
  constructor() {
    super(...arguments);
    _e(this, "priority", 130);
    _e(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(o, n, s) {
    const i = (r) => ({
      year: r,
      isTwoDigitYear: n === "yy"
    });
    switch (n) {
      case "y":
        return Mt(bt(4, o), i);
      case "yo":
        return Mt(
          s.ordinalNumber(o, {
            unit: "year"
          }),
          i
        );
      default:
        return Mt(bt(n.length, o), i);
    }
  }
  validate(o, n) {
    return n.isTwoDigitYear || n.year > 0;
  }
  set(o, n, s) {
    const i = o.getFullYear();
    if (s.isTwoDigitYear) {
      const l = x7(
        s.year,
        i
      );
      return o.setFullYear(l, 0, 1), o.setHours(0, 0, 0, 0), o;
    }
    const r = !("era" in n) || n.era === 1 ? s.year : 1 - s.year;
    return o.setFullYear(r, 0, 1), o.setHours(0, 0, 0, 0), o;
  }
}
class Rx extends tt {
  constructor() {
    super(...arguments);
    _e(this, "priority", 130);
    _e(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(o, n, s) {
    const i = (r) => ({
      year: r,
      isTwoDigitYear: n === "YY"
    });
    switch (n) {
      case "Y":
        return Mt(bt(4, o), i);
      case "Yo":
        return Mt(
          s.ordinalNumber(o, {
            unit: "year"
          }),
          i
        );
      default:
        return Mt(bt(n.length, o), i);
    }
  }
  validate(o, n) {
    return n.isTwoDigitYear || n.year > 0;
  }
  set(o, n, s, i) {
    const r = B5(o, i);
    if (s.isTwoDigitYear) {
      const a = x7(
        s.year,
        r
      );
      return o.setFullYear(
        a,
        0,
        i.firstWeekContainsDate
      ), o.setHours(0, 0, 0, 0), cn(o, i);
    }
    const l = !("era" in n) || n.era === 1 ? s.year : 1 - s.year;
    return o.setFullYear(l, 0, i.firstWeekContainsDate), o.setHours(0, 0, 0, 0), cn(o, i);
  }
}
class Fx extends tt {
  constructor() {
    super(...arguments);
    _e(this, "priority", 130);
    _e(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(o, n) {
    return ll(n === "R" ? 4 : n.length, o);
  }
  set(o, n, s) {
    const i = wt(o, 0);
    return i.setFullYear(s, 0, 4), i.setHours(0, 0, 0, 0), Vi(i);
  }
}
class Tx extends tt {
  constructor() {
    super(...arguments);
    _e(this, "priority", 130);
    _e(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(o, n) {
    return ll(n === "u" ? 4 : n.length, o);
  }
  set(o, n, s) {
    return o.setFullYear(s, 0, 1), o.setHours(0, 0, 0, 0), o;
  }
}
class Ix extends tt {
  constructor() {
    super(...arguments);
    _e(this, "priority", 120);
    _e(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(o, n, s) {
    switch (n) {
      // 1, 2, 3, 4
      case "Q":
      case "QQ":
        return bt(n.length, o);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return s.ordinalNumber(o, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return s.quarter(o, {
          width: "abbreviated",
          context: "formatting"
        }) || s.quarter(o, {
          width: "narrow",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return s.quarter(o, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return s.quarter(o, {
          width: "wide",
          context: "formatting"
        }) || s.quarter(o, {
          width: "abbreviated",
          context: "formatting"
        }) || s.quarter(o, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(o, n) {
    return n >= 1 && n <= 4;
  }
  set(o, n, s) {
    return o.setMonth((s - 1) * 3, 1), o.setHours(0, 0, 0, 0), o;
  }
}
class Dx extends tt {
  constructor() {
    super(...arguments);
    _e(this, "priority", 120);
    _e(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(o, n, s) {
    switch (n) {
      // 1, 2, 3, 4
      case "q":
      case "qq":
        return bt(n.length, o);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return s.ordinalNumber(o, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return s.quarter(o, {
          width: "abbreviated",
          context: "standalone"
        }) || s.quarter(o, {
          width: "narrow",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return s.quarter(o, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return s.quarter(o, {
          width: "wide",
          context: "standalone"
        }) || s.quarter(o, {
          width: "abbreviated",
          context: "standalone"
        }) || s.quarter(o, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(o, n) {
    return n >= 1 && n <= 4;
  }
  set(o, n, s) {
    return o.setMonth((s - 1) * 3, 1), o.setHours(0, 0, 0, 0), o;
  }
}
class kx extends tt {
  constructor() {
    super(...arguments);
    _e(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
    _e(this, "priority", 110);
  }
  parse(o, n, s) {
    const i = (r) => r - 1;
    switch (n) {
      // 1, 2, ..., 12
      case "M":
        return Mt(
          mt(xt.month, o),
          i
        );
      // 01, 02, ..., 12
      case "MM":
        return Mt(bt(2, o), i);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return Mt(
          s.ordinalNumber(o, {
            unit: "month"
          }),
          i
        );
      // Jan, Feb, ..., Dec
      case "MMM":
        return s.month(o, {
          width: "abbreviated",
          context: "formatting"
        }) || s.month(o, { width: "narrow", context: "formatting" });
      // J, F, ..., D
      case "MMMMM":
        return s.month(o, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return s.month(o, { width: "wide", context: "formatting" }) || s.month(o, {
          width: "abbreviated",
          context: "formatting"
        }) || s.month(o, { width: "narrow", context: "formatting" });
    }
  }
  validate(o, n) {
    return n >= 0 && n <= 11;
  }
  set(o, n, s) {
    return o.setMonth(s, 1), o.setHours(0, 0, 0, 0), o;
  }
}
class Hx extends tt {
  constructor() {
    super(...arguments);
    _e(this, "priority", 110);
    _e(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(o, n, s) {
    const i = (r) => r - 1;
    switch (n) {
      // 1, 2, ..., 12
      case "L":
        return Mt(
          mt(xt.month, o),
          i
        );
      // 01, 02, ..., 12
      case "LL":
        return Mt(bt(2, o), i);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return Mt(
          s.ordinalNumber(o, {
            unit: "month"
          }),
          i
        );
      // Jan, Feb, ..., Dec
      case "LLL":
        return s.month(o, {
          width: "abbreviated",
          context: "standalone"
        }) || s.month(o, { width: "narrow", context: "standalone" });
      // J, F, ..., D
      case "LLLLL":
        return s.month(o, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return s.month(o, { width: "wide", context: "standalone" }) || s.month(o, {
          width: "abbreviated",
          context: "standalone"
        }) || s.month(o, { width: "narrow", context: "standalone" });
    }
  }
  validate(o, n) {
    return n >= 0 && n <= 11;
  }
  set(o, n, s) {
    return o.setMonth(s, 1), o.setHours(0, 0, 0, 0), o;
  }
}
function Vx(e, t, o) {
  const n = et(e, o == null ? void 0 : o.in), s = $5(n, o) - t;
  return n.setDate(n.getDate() - s * 7), et(n, o == null ? void 0 : o.in);
}
class Ox extends tt {
  constructor() {
    super(...arguments);
    _e(this, "priority", 100);
    _e(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(o, n, s) {
    switch (n) {
      case "w":
        return mt(xt.week, o);
      case "wo":
        return s.ordinalNumber(o, { unit: "week" });
      default:
        return bt(n.length, o);
    }
  }
  validate(o, n) {
    return n >= 1 && n <= 53;
  }
  set(o, n, s, i) {
    return cn(Vx(o, s, i), i);
  }
}
function Bx(e, t, o) {
  const n = et(e, o == null ? void 0 : o.in), s = C7(n, o) - t;
  return n.setDate(n.getDate() - s * 7), n;
}
class $x extends tt {
  constructor() {
    super(...arguments);
    _e(this, "priority", 100);
    _e(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(o, n, s) {
    switch (n) {
      case "I":
        return mt(xt.week, o);
      case "Io":
        return s.ordinalNumber(o, { unit: "week" });
      default:
        return bt(n.length, o);
    }
  }
  validate(o, n) {
    return n >= 1 && n <= 53;
  }
  set(o, n, s) {
    return Vi(Bx(o, s));
  }
}
const Zx = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Gx = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class Nx extends tt {
  constructor() {
    super(...arguments);
    _e(this, "priority", 90);
    _e(this, "subPriority", 1);
    _e(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(o, n, s) {
    switch (n) {
      case "d":
        return mt(xt.date, o);
      case "do":
        return s.ordinalNumber(o, { unit: "date" });
      default:
        return bt(n.length, o);
    }
  }
  validate(o, n) {
    const s = o.getFullYear(), i = M7(s), r = o.getMonth();
    return i ? n >= 1 && n <= Gx[r] : n >= 1 && n <= Zx[r];
  }
  set(o, n, s) {
    return o.setDate(s), o.setHours(0, 0, 0, 0), o;
  }
}
class zx extends tt {
  constructor() {
    super(...arguments);
    _e(this, "priority", 90);
    _e(this, "subpriority", 1);
    _e(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(o, n, s) {
    switch (n) {
      case "D":
      case "DD":
        return mt(xt.dayOfYear, o);
      case "Do":
        return s.ordinalNumber(o, { unit: "date" });
      default:
        return bt(n.length, o);
    }
  }
  validate(o, n) {
    const s = o.getFullYear();
    return M7(s) ? n >= 1 && n <= 366 : n >= 1 && n <= 365;
  }
  set(o, n, s) {
    return o.setMonth(0, s), o.setHours(0, 0, 0, 0), o;
  }
}
function G5(e, t, o) {
  var u, h, p, C;
  const n = Ji(), s = (o == null ? void 0 : o.weekStartsOn) ?? ((h = (u = o == null ? void 0 : o.locale) == null ? void 0 : u.options) == null ? void 0 : h.weekStartsOn) ?? n.weekStartsOn ?? ((C = (p = n.locale) == null ? void 0 : p.options) == null ? void 0 : C.weekStartsOn) ?? 0, i = et(e, o == null ? void 0 : o.in), r = i.getDay(), a = (t % 7 + 7) % 7, c = 7 - s, d = t < 0 || t > 6 ? t - (r + c) % 7 : (a + c) % 7 - (r + c) % 7;
  return _i(i, d, o);
}
class jx extends tt {
  constructor() {
    super(...arguments);
    _e(this, "priority", 90);
    _e(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(o, n, s) {
    switch (n) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return s.day(o, {
          width: "abbreviated",
          context: "formatting"
        }) || s.day(o, { width: "short", context: "formatting" }) || s.day(o, { width: "narrow", context: "formatting" });
      // T
      case "EEEEE":
        return s.day(o, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return s.day(o, { width: "short", context: "formatting" }) || s.day(o, { width: "narrow", context: "formatting" });
      // Tuesday
      case "EEEE":
      default:
        return s.day(o, { width: "wide", context: "formatting" }) || s.day(o, {
          width: "abbreviated",
          context: "formatting"
        }) || s.day(o, { width: "short", context: "formatting" }) || s.day(o, { width: "narrow", context: "formatting" });
    }
  }
  validate(o, n) {
    return n >= 0 && n <= 6;
  }
  set(o, n, s, i) {
    return o = G5(o, s, i), o.setHours(0, 0, 0, 0), o;
  }
}
class Wx extends tt {
  constructor() {
    super(...arguments);
    _e(this, "priority", 90);
    _e(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(o, n, s, i) {
    const r = (l) => {
      const a = Math.floor((l - 1) / 7) * 7;
      return (l + i.weekStartsOn + 6) % 7 + a;
    };
    switch (n) {
      // 3
      case "e":
      case "ee":
        return Mt(bt(n.length, o), r);
      // 3rd
      case "eo":
        return Mt(
          s.ordinalNumber(o, {
            unit: "day"
          }),
          r
        );
      // Tue
      case "eee":
        return s.day(o, {
          width: "abbreviated",
          context: "formatting"
        }) || s.day(o, { width: "short", context: "formatting" }) || s.day(o, { width: "narrow", context: "formatting" });
      // T
      case "eeeee":
        return s.day(o, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return s.day(o, { width: "short", context: "formatting" }) || s.day(o, { width: "narrow", context: "formatting" });
      // Tuesday
      case "eeee":
      default:
        return s.day(o, { width: "wide", context: "formatting" }) || s.day(o, {
          width: "abbreviated",
          context: "formatting"
        }) || s.day(o, { width: "short", context: "formatting" }) || s.day(o, { width: "narrow", context: "formatting" });
    }
  }
  validate(o, n) {
    return n >= 0 && n <= 6;
  }
  set(o, n, s, i) {
    return o = G5(o, s, i), o.setHours(0, 0, 0, 0), o;
  }
}
class Ux extends tt {
  constructor() {
    super(...arguments);
    _e(this, "priority", 90);
    _e(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(o, n, s, i) {
    const r = (l) => {
      const a = Math.floor((l - 1) / 7) * 7;
      return (l + i.weekStartsOn + 6) % 7 + a;
    };
    switch (n) {
      // 3
      case "c":
      case "cc":
        return Mt(bt(n.length, o), r);
      // 3rd
      case "co":
        return Mt(
          s.ordinalNumber(o, {
            unit: "day"
          }),
          r
        );
      // Tue
      case "ccc":
        return s.day(o, {
          width: "abbreviated",
          context: "standalone"
        }) || s.day(o, { width: "short", context: "standalone" }) || s.day(o, { width: "narrow", context: "standalone" });
      // T
      case "ccccc":
        return s.day(o, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return s.day(o, { width: "short", context: "standalone" }) || s.day(o, { width: "narrow", context: "standalone" });
      // Tuesday
      case "cccc":
      default:
        return s.day(o, { width: "wide", context: "standalone" }) || s.day(o, {
          width: "abbreviated",
          context: "standalone"
        }) || s.day(o, { width: "short", context: "standalone" }) || s.day(o, { width: "narrow", context: "standalone" });
    }
  }
  validate(o, n) {
    return n >= 0 && n <= 6;
  }
  set(o, n, s, i) {
    return o = G5(o, s, i), o.setHours(0, 0, 0, 0), o;
  }
}
function Kx(e, t, o) {
  const n = et(e, o == null ? void 0 : o.in), s = _x(n, o), i = t - s;
  return _i(n, i, o);
}
class qx extends tt {
  constructor() {
    super(...arguments);
    _e(this, "priority", 90);
    _e(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(o, n, s) {
    const i = (r) => r === 0 ? 7 : r;
    switch (n) {
      // 2
      case "i":
      case "ii":
        return bt(n.length, o);
      // 2nd
      case "io":
        return s.ordinalNumber(o, { unit: "day" });
      // Tue
      case "iii":
        return Mt(
          s.day(o, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(o, {
            width: "short",
            context: "formatting"
          }) || s.day(o, {
            width: "narrow",
            context: "formatting"
          }),
          i
        );
      // T
      case "iiiii":
        return Mt(
          s.day(o, {
            width: "narrow",
            context: "formatting"
          }),
          i
        );
      // Tu
      case "iiiiii":
        return Mt(
          s.day(o, {
            width: "short",
            context: "formatting"
          }) || s.day(o, {
            width: "narrow",
            context: "formatting"
          }),
          i
        );
      // Tuesday
      case "iiii":
      default:
        return Mt(
          s.day(o, {
            width: "wide",
            context: "formatting"
          }) || s.day(o, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(o, {
            width: "short",
            context: "formatting"
          }) || s.day(o, {
            width: "narrow",
            context: "formatting"
          }),
          i
        );
    }
  }
  validate(o, n) {
    return n >= 1 && n <= 7;
  }
  set(o, n, s) {
    return o = Kx(o, s), o.setHours(0, 0, 0, 0), o;
  }
}
class Yx extends tt {
  constructor() {
    super(...arguments);
    _e(this, "priority", 80);
    _e(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(o, n, s) {
    switch (n) {
      case "a":
      case "aa":
      case "aaa":
        return s.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return s.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return s.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        }) || s.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(o, n, s) {
    return o.setHours(Z5(s), 0, 0, 0), o;
  }
}
class Qx extends tt {
  constructor() {
    super(...arguments);
    _e(this, "priority", 80);
    _e(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(o, n, s) {
    switch (n) {
      case "b":
      case "bb":
      case "bbb":
        return s.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return s.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return s.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        }) || s.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(o, n, s) {
    return o.setHours(Z5(s), 0, 0, 0), o;
  }
}
class Jx extends tt {
  constructor() {
    super(...arguments);
    _e(this, "priority", 80);
    _e(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(o, n, s) {
    switch (n) {
      case "B":
      case "BB":
      case "BBB":
        return s.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return s.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return s.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        }) || s.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(o, n, s) {
    return o.setHours(Z5(s), 0, 0, 0), o;
  }
}
class Xx extends tt {
  constructor() {
    super(...arguments);
    _e(this, "priority", 70);
    _e(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(o, n, s) {
    switch (n) {
      case "h":
        return mt(xt.hour12h, o);
      case "ho":
        return s.ordinalNumber(o, { unit: "hour" });
      default:
        return bt(n.length, o);
    }
  }
  validate(o, n) {
    return n >= 1 && n <= 12;
  }
  set(o, n, s) {
    const i = o.getHours() >= 12;
    return i && s < 12 ? o.setHours(s + 12, 0, 0, 0) : !i && s === 12 ? o.setHours(0, 0, 0, 0) : o.setHours(s, 0, 0, 0), o;
  }
}
class eM extends tt {
  constructor() {
    super(...arguments);
    _e(this, "priority", 70);
    _e(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(o, n, s) {
    switch (n) {
      case "H":
        return mt(xt.hour23h, o);
      case "Ho":
        return s.ordinalNumber(o, { unit: "hour" });
      default:
        return bt(n.length, o);
    }
  }
  validate(o, n) {
    return n >= 0 && n <= 23;
  }
  set(o, n, s) {
    return o.setHours(s, 0, 0, 0), o;
  }
}
class tM extends tt {
  constructor() {
    super(...arguments);
    _e(this, "priority", 70);
    _e(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(o, n, s) {
    switch (n) {
      case "K":
        return mt(xt.hour11h, o);
      case "Ko":
        return s.ordinalNumber(o, { unit: "hour" });
      default:
        return bt(n.length, o);
    }
  }
  validate(o, n) {
    return n >= 0 && n <= 11;
  }
  set(o, n, s) {
    return o.getHours() >= 12 && s < 12 ? o.setHours(s + 12, 0, 0, 0) : o.setHours(s, 0, 0, 0), o;
  }
}
class oM extends tt {
  constructor() {
    super(...arguments);
    _e(this, "priority", 70);
    _e(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(o, n, s) {
    switch (n) {
      case "k":
        return mt(xt.hour24h, o);
      case "ko":
        return s.ordinalNumber(o, { unit: "hour" });
      default:
        return bt(n.length, o);
    }
  }
  validate(o, n) {
    return n >= 1 && n <= 24;
  }
  set(o, n, s) {
    const i = s <= 24 ? s % 24 : s;
    return o.setHours(i, 0, 0, 0), o;
  }
}
class nM extends tt {
  constructor() {
    super(...arguments);
    _e(this, "priority", 60);
    _e(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(o, n, s) {
    switch (n) {
      case "m":
        return mt(xt.minute, o);
      case "mo":
        return s.ordinalNumber(o, { unit: "minute" });
      default:
        return bt(n.length, o);
    }
  }
  validate(o, n) {
    return n >= 0 && n <= 59;
  }
  set(o, n, s) {
    return o.setMinutes(s, 0, 0), o;
  }
}
class sM extends tt {
  constructor() {
    super(...arguments);
    _e(this, "priority", 50);
    _e(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(o, n, s) {
    switch (n) {
      case "s":
        return mt(xt.second, o);
      case "so":
        return s.ordinalNumber(o, { unit: "second" });
      default:
        return bt(n.length, o);
    }
  }
  validate(o, n) {
    return n >= 0 && n <= 59;
  }
  set(o, n, s) {
    return o.setSeconds(s, 0), o;
  }
}
class iM extends tt {
  constructor() {
    super(...arguments);
    _e(this, "priority", 30);
    _e(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(o, n) {
    const s = (i) => Math.trunc(i * Math.pow(10, -n.length + 3));
    return Mt(bt(n.length, o), s);
  }
  set(o, n, s) {
    return o.setMilliseconds(s), o;
  }
}
class rM extends tt {
  constructor() {
    super(...arguments);
    _e(this, "priority", 10);
    _e(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(o, n) {
    switch (n) {
      case "X":
        return tn(
          en.basicOptionalMinutes,
          o
        );
      case "XX":
        return tn(en.basic, o);
      case "XXXX":
        return tn(
          en.basicOptionalSeconds,
          o
        );
      case "XXXXX":
        return tn(
          en.extendedOptionalSeconds,
          o
        );
      case "XXX":
      default:
        return tn(en.extended, o);
    }
  }
  set(o, n, s) {
    return n.timestampIsSet ? o : wt(
      o,
      o.getTime() - rl(o) - s
    );
  }
}
class lM extends tt {
  constructor() {
    super(...arguments);
    _e(this, "priority", 10);
    _e(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(o, n) {
    switch (n) {
      case "x":
        return tn(
          en.basicOptionalMinutes,
          o
        );
      case "xx":
        return tn(en.basic, o);
      case "xxxx":
        return tn(
          en.basicOptionalSeconds,
          o
        );
      case "xxxxx":
        return tn(
          en.extendedOptionalSeconds,
          o
        );
      case "xxx":
      default:
        return tn(en.extended, o);
    }
  }
  set(o, n, s) {
    return n.timestampIsSet ? o : wt(
      o,
      o.getTime() - rl(o) - s
    );
  }
}
class aM extends tt {
  constructor() {
    super(...arguments);
    _e(this, "priority", 40);
    _e(this, "incompatibleTokens", "*");
  }
  parse(o) {
    return S7(o);
  }
  set(o, n, s) {
    return [wt(o, s * 1e3), { timestampIsSet: !0 }];
  }
}
class cM extends tt {
  constructor() {
    super(...arguments);
    _e(this, "priority", 20);
    _e(this, "incompatibleTokens", "*");
  }
  parse(o) {
    return S7(o);
  }
  set(o, n, s) {
    return [wt(o, s), { timestampIsSet: !0 }];
  }
}
const dM = {
  G: new Ex(),
  y: new Px(),
  Y: new Rx(),
  R: new Fx(),
  u: new Tx(),
  Q: new Ix(),
  q: new Dx(),
  M: new kx(),
  L: new Hx(),
  w: new Ox(),
  I: new $x(),
  d: new Nx(),
  D: new zx(),
  E: new jx(),
  e: new Wx(),
  c: new Ux(),
  i: new qx(),
  a: new Yx(),
  b: new Qx(),
  B: new Jx(),
  h: new Xx(),
  H: new eM(),
  K: new tM(),
  k: new oM(),
  m: new nM(),
  s: new sM(),
  S: new iM(),
  X: new rM(),
  x: new lM(),
  t: new aM(),
  T: new cM()
}, uM = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, hM = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, gM = /^'([^]*?)'?$/, pM = /''/g, fM = /\S/, vM = /[a-zA-Z]/;
function mM(e, t, o, n) {
  var w, y, b, _, M, x, L, A;
  const s = () => wt((n == null ? void 0 : n.in) || o, NaN), i = yx(), r = (n == null ? void 0 : n.locale) ?? i.locale ?? O5, l = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((y = (w = n == null ? void 0 : n.locale) == null ? void 0 : w.options) == null ? void 0 : y.firstWeekContainsDate) ?? i.firstWeekContainsDate ?? ((_ = (b = i.locale) == null ? void 0 : b.options) == null ? void 0 : _.firstWeekContainsDate) ?? 1, a = (n == null ? void 0 : n.weekStartsOn) ?? ((x = (M = n == null ? void 0 : n.locale) == null ? void 0 : M.options) == null ? void 0 : x.weekStartsOn) ?? i.weekStartsOn ?? ((A = (L = i.locale) == null ? void 0 : L.options) == null ? void 0 : A.weekStartsOn) ?? 0;
  if (!t)
    return e ? s() : et(o, n == null ? void 0 : n.in);
  const c = {
    firstWeekContainsDate: l,
    weekStartsOn: a,
    locale: r
  }, d = [new Lx(n == null ? void 0 : n.in, o)], u = t.match(hM).map((R) => {
    const P = R[0];
    if (P in D0) {
      const I = D0[P];
      return I(R, r.formatLong);
    }
    return R;
  }).join("").match(uM), h = [];
  for (let R of u) {
    !(n != null && n.useAdditionalWeekYearTokens) && y7(R) && k0(R, t, e), !(n != null && n.useAdditionalDayOfYearTokens) && b7(R) && k0(R, t, e);
    const P = R[0], I = dM[P];
    if (I) {
      const { incompatibleTokens: B } = I;
      if (Array.isArray(B)) {
        const O = h.find(
          (N) => B.includes(N.token) || N.token === P
        );
        if (O)
          throw new RangeError(
            `The format string mustn't contain \`${O.fullToken}\` and \`${R}\` at the same time`
          );
      } else if (I.incompatibleTokens === "*" && h.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${R}\` and any other token at the same time`
        );
      h.push({ token: P, fullToken: R });
      const H = I.run(
        e,
        R,
        r.match,
        c
      );
      if (!H)
        return s();
      d.push(H.setter), e = H.rest;
    } else {
      if (P.match(vM))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + P + "`"
        );
      if (R === "''" ? R = "'" : P === "'" && (R = CM(R)), e.indexOf(R) === 0)
        e = e.slice(R.length);
      else
        return s();
    }
  }
  if (e.length > 0 && fM.test(e))
    return s();
  const p = d.map((R) => R.priority).sort((R, P) => P - R).filter((R, P, I) => I.indexOf(R) === P).map(
    (R) => d.filter((P) => P.priority === R).sort((P, I) => I.subPriority - P.subPriority)
  ).map((R) => R[0]);
  let C = et(o, n == null ? void 0 : n.in);
  if (isNaN(+C)) return s();
  const m = {};
  for (const R of p) {
    if (!R.validate(C, c))
      return s();
    const P = R.set(C, m, c);
    Array.isArray(P) ? (C = P[0], Object.assign(m, P[1])) : C = P;
  }
  return C;
}
function CM(e) {
  return e.match(gM)[1].replace(pM, "'");
}
function wM(e, t) {
  return Yn(
    wt(e, e),
    MS(e)
  );
}
const Dc = {
  lessThanXSeconds: {
    standalone: {
      one: "weniger als 1 Sekunde",
      other: "weniger als {{count}} Sekunden"
    },
    withPreposition: {
      one: "weniger als 1 Sekunde",
      other: "weniger als {{count}} Sekunden"
    }
  },
  xSeconds: {
    standalone: {
      one: "1 Sekunde",
      other: "{{count}} Sekunden"
    },
    withPreposition: {
      one: "1 Sekunde",
      other: "{{count}} Sekunden"
    }
  },
  halfAMinute: {
    standalone: "eine halbe Minute",
    withPreposition: "einer halben Minute"
  },
  lessThanXMinutes: {
    standalone: {
      one: "weniger als 1 Minute",
      other: "weniger als {{count}} Minuten"
    },
    withPreposition: {
      one: "weniger als 1 Minute",
      other: "weniger als {{count}} Minuten"
    }
  },
  xMinutes: {
    standalone: {
      one: "1 Minute",
      other: "{{count}} Minuten"
    },
    withPreposition: {
      one: "1 Minute",
      other: "{{count}} Minuten"
    }
  },
  aboutXHours: {
    standalone: {
      one: "etwa 1 Stunde",
      other: "etwa {{count}} Stunden"
    },
    withPreposition: {
      one: "etwa 1 Stunde",
      other: "etwa {{count}} Stunden"
    }
  },
  xHours: {
    standalone: {
      one: "1 Stunde",
      other: "{{count}} Stunden"
    },
    withPreposition: {
      one: "1 Stunde",
      other: "{{count}} Stunden"
    }
  },
  xDays: {
    standalone: {
      one: "1 Tag",
      other: "{{count}} Tage"
    },
    withPreposition: {
      one: "1 Tag",
      other: "{{count}} Tagen"
    }
  },
  aboutXWeeks: {
    standalone: {
      one: "etwa 1 Woche",
      other: "etwa {{count}} Wochen"
    },
    withPreposition: {
      one: "etwa 1 Woche",
      other: "etwa {{count}} Wochen"
    }
  },
  xWeeks: {
    standalone: {
      one: "1 Woche",
      other: "{{count}} Wochen"
    },
    withPreposition: {
      one: "1 Woche",
      other: "{{count}} Wochen"
    }
  },
  aboutXMonths: {
    standalone: {
      one: "etwa 1 Monat",
      other: "etwa {{count}} Monate"
    },
    withPreposition: {
      one: "etwa 1 Monat",
      other: "etwa {{count}} Monaten"
    }
  },
  xMonths: {
    standalone: {
      one: "1 Monat",
      other: "{{count}} Monate"
    },
    withPreposition: {
      one: "1 Monat",
      other: "{{count}} Monaten"
    }
  },
  aboutXYears: {
    standalone: {
      one: "etwa 1 Jahr",
      other: "etwa {{count}} Jahre"
    },
    withPreposition: {
      one: "etwa 1 Jahr",
      other: "etwa {{count}} Jahren"
    }
  },
  xYears: {
    standalone: {
      one: "1 Jahr",
      other: "{{count}} Jahre"
    },
    withPreposition: {
      one: "1 Jahr",
      other: "{{count}} Jahren"
    }
  },
  overXYears: {
    standalone: {
      one: "mehr als 1 Jahr",
      other: "mehr als {{count}} Jahre"
    },
    withPreposition: {
      one: "mehr als 1 Jahr",
      other: "mehr als {{count}} Jahren"
    }
  },
  almostXYears: {
    standalone: {
      one: "fast 1 Jahr",
      other: "fast {{count}} Jahre"
    },
    withPreposition: {
      one: "fast 1 Jahr",
      other: "fast {{count}} Jahren"
    }
  }
}, bM = (e, t, o) => {
  let n;
  const s = o != null && o.addSuffix ? Dc[e].withPreposition : Dc[e].standalone;
  return typeof s == "string" ? n = s : t === 1 ? n = s.one : n = s.other.replace("{{count}}", String(t)), o != null && o.addSuffix ? o.comparison && o.comparison > 0 ? "in " + n : "vor " + n : n;
}, yM = {
  full: "EEEE, do MMMM y",
  // Montag, 7. Januar 2018
  long: "do MMMM y",
  // 7. Januar 2018
  medium: "do MMM y",
  // 7. Jan. 2018
  short: "dd.MM.y"
  // 07.01.2018
}, _M = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, SM = {
  full: "{{date}} 'um' {{time}}",
  long: "{{date}} 'um' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, xM = {
  date: Si({
    formats: yM,
    defaultWidth: "full"
  }),
  time: Si({
    formats: _M,
    defaultWidth: "full"
  }),
  dateTime: Si({
    formats: SM,
    defaultWidth: "full"
  })
}, MM = {
  lastWeek: "'letzten' eeee 'um' p",
  yesterday: "'gestern um' p",
  today: "'heute um' p",
  tomorrow: "'morgen um' p",
  nextWeek: "eeee 'um' p",
  other: "P"
}, AM = (e, t, o, n) => MM[e], LM = {
  narrow: ["v.Chr.", "n.Chr."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["vor Christus", "nach Christus"]
}, EM = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. Quartal", "2. Quartal", "3. Quartal", "4. Quartal"]
}, H0 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mär",
    "Apr",
    "Mai",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Okt",
    "Nov",
    "Dez"
  ],
  wide: [
    "Januar",
    "Februar",
    "März",
    "April",
    "Mai",
    "Juni",
    "Juli",
    "August",
    "September",
    "Oktober",
    "November",
    "Dezember"
  ]
}, PM = {
  narrow: H0.narrow,
  abbreviated: [
    "Jan.",
    "Feb.",
    "März",
    "Apr.",
    "Mai",
    "Juni",
    "Juli",
    "Aug.",
    "Sep.",
    "Okt.",
    "Nov.",
    "Dez."
  ],
  wide: H0.wide
}, RM = {
  narrow: ["S", "M", "D", "M", "D", "F", "S"],
  short: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
  abbreviated: ["So.", "Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sa."],
  wide: [
    "Sonntag",
    "Montag",
    "Dienstag",
    "Mittwoch",
    "Donnerstag",
    "Freitag",
    "Samstag"
  ]
}, FM = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachm.",
    evening: "Abend",
    night: "Nacht"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  }
}, TM = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachm.",
    evening: "abends",
    night: "nachts"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  }
}, IM = (e) => Number(e) + ".", DM = {
  ordinalNumber: IM,
  era: Jo({
    values: LM,
    defaultWidth: "wide"
  }),
  quarter: Jo({
    values: EM,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Jo({
    values: H0,
    formattingValues: PM,
    defaultWidth: "wide"
  }),
  day: Jo({
    values: RM,
    defaultWidth: "wide"
  }),
  dayPeriod: Jo({
    values: FM,
    defaultWidth: "wide",
    formattingValues: TM,
    defaultFormattingWidth: "wide"
  })
}, kM = /^(\d+)(\.)?/i, HM = /\d+/i, VM = {
  narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
}, OM = {
  any: [/^v/i, /^n/i]
}, BM = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? Quartal/i
}, $M = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, ZM = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
  wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
}, GM = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^j[aä]/i,
    /^f/i,
    /^mär/i,
    /^ap/i,
    /^mai/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, NM = {
  narrow: /^[smdmf]/i,
  short: /^(so|mo|di|mi|do|fr|sa)/i,
  abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
  wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
}, zM = {
  any: [/^so/i, /^mo/i, /^di/i, /^mi/i, /^do/i, /^f/i, /^sa/i]
}, jM = {
  narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
}, WM = {
  any: {
    am: /^v/i,
    pm: /^n/i,
    midnight: /^Mitte/i,
    noon: /^Mitta/i,
    morning: /morgens/i,
    afternoon: /nachmittags/i,
    // will never be matched. Afternoon is matched by `pm`
    evening: /abends/i,
    night: /nachts/i
    // will never be matched. Night is matched by `pm`
  }
}, UM = {
  ordinalNumber: m7({
    matchPattern: kM,
    parsePattern: HM,
    valueCallback: (e) => parseInt(e)
  }),
  era: Xo({
    matchPatterns: VM,
    defaultMatchWidth: "wide",
    parsePatterns: OM,
    defaultParseWidth: "any"
  }),
  quarter: Xo({
    matchPatterns: BM,
    defaultMatchWidth: "wide",
    parsePatterns: $M,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Xo({
    matchPatterns: ZM,
    defaultMatchWidth: "wide",
    parsePatterns: GM,
    defaultParseWidth: "any"
  }),
  day: Xo({
    matchPatterns: NM,
    defaultMatchWidth: "wide",
    parsePatterns: zM,
    defaultParseWidth: "any"
  }),
  dayPeriod: Xo({
    matchPatterns: jM,
    defaultMatchWidth: "wide",
    parsePatterns: WM,
    defaultParseWidth: "any"
  })
}, KM = {
  code: "de",
  formatDistance: bM,
  formatLong: xM,
  formatRelative: AM,
  localize: DM,
  match: UM,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, qM = "captureStackTrace" in Error;
class N5 extends Error {
  constructor(o = "Unspecified AssertionError", n, s) {
    super(o);
    _e(this, "message");
    this.message = o, qM && Error.captureStackTrace(this, s || N5);
    for (const i in n)
      i in this || (this[i] = n[i]);
  }
  get name() {
    return "AssertionError";
  }
  get ok() {
    return !1;
  }
  toJSON(o) {
    return {
      ...this,
      name: this.name,
      message: this.message,
      ok: !1,
      stack: o !== !1 ? this.stack : void 0
    };
  }
}
function kc(e, t) {
  var o = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), o.push.apply(o, n);
  }
  return o;
}
function Vr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var o = arguments[t] != null ? arguments[t] : {};
    t % 2 ? kc(Object(o), !0).forEach(function(n) {
      YM(e, n, o[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(o)) : kc(Object(o)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(o, n));
    });
  }
  return e;
}
function YM(e, t, o) {
  return t in e ? Object.defineProperty(e, t, {
    value: o,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = o, e;
}
function al(e) {
  return typeof e == "function";
}
function V0(e) {
  return e !== null && typeof e == "object" && !Array.isArray(e);
}
function zl(e) {
  return al(e.$validator) ? Vr({}, e) : {
    $validator: e
  };
}
function A7(e) {
  return typeof e == "object" ? e.$valid : e;
}
function L7(e) {
  return e.$validator || e;
}
function QM(e, t) {
  if (!V0(e)) throw new Error(`[@vuelidate/validators]: First parameter to "withParams" should be an object, provided ${typeof e}`);
  if (!V0(t) && !al(t)) throw new Error("[@vuelidate/validators]: Validator must be a function or object with $validator parameter");
  const o = zl(t);
  return o.$params = Vr(Vr({}, o.$params || {}), e), o;
}
function JM(e, t) {
  if (!al(e) && typeof k(e) != "string") throw new Error(`[@vuelidate/validators]: First parameter to "withMessage" should be string or a function returning a string, provided ${typeof e}`);
  if (!V0(t) && !al(t)) throw new Error("[@vuelidate/validators]: Validator must be a function or object with $validator parameter");
  const o = zl(t);
  return o.$message = e, o;
}
function XM(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  const o = zl(e);
  return Vr(Vr({}, o), {}, {
    $async: !0,
    $watchTargets: t
  });
}
function eA(e) {
  return {
    $validator(t) {
      for (var o = arguments.length, n = new Array(o > 1 ? o - 1 : 0), s = 1; s < o; s++)
        n[s - 1] = arguments[s];
      return k(t).reduce((i, r, l) => {
        const a = Object.entries(r).reduce((c, d) => {
          let [u, h] = d;
          const p = e[u] || {}, C = Object.entries(p).reduce((m, w) => {
            let [y, b] = w;
            const M = L7(b).call(this, h, r, l, ...n), x = A7(M);
            if (m.$data[y] = M, m.$data.$invalid = !x || !!m.$data.$invalid, m.$data.$error = m.$data.$invalid, !x) {
              let L = b.$message || "";
              const A = b.$params || {};
              typeof L == "function" && (L = L({
                $pending: !1,
                $invalid: !x,
                $params: A,
                $model: h,
                $response: M
              })), m.$errors.push({
                $property: u,
                $message: L,
                $params: A,
                $response: M,
                $model: h,
                $pending: !1,
                $validator: y
              });
            }
            return {
              $valid: m.$valid && x,
              $data: m.$data,
              $errors: m.$errors
            };
          }, {
            $valid: !0,
            $data: {},
            $errors: []
          });
          return c.$data[u] = C.$data, c.$errors[u] = C.$errors, {
            $valid: c.$valid && C.$valid,
            $data: c.$data,
            $errors: c.$errors
          };
        }, {
          $valid: !0,
          $data: {},
          $errors: {}
        });
        return {
          $valid: i.$valid && a.$valid,
          $data: i.$data.concat(a.$data),
          $errors: i.$errors.concat(a.$errors)
        };
      }, {
        $valid: !0,
        $data: [],
        $errors: []
      });
    },
    $message: (t) => {
      let {
        $response: o
      } = t;
      return o ? o.$errors.map((n) => Object.values(n).map((s) => s.map((i) => i.$message)).reduce((s, i) => s.concat(i), [])) : [];
    }
  };
}
const z5 = (e) => {
  if (e = k(e), Array.isArray(e)) return !!e.length;
  if (e == null)
    return !1;
  if (e === !1)
    return !0;
  if (e instanceof Date)
    return !isNaN(e.getTime());
  if (typeof e == "object") {
    for (let t in e) return !0;
    return !1;
  }
  return !!String(e).length;
}, tA = (e) => (e = k(e), Array.isArray(e) ? e.length : typeof e == "object" ? Object.keys(e).length : String(e).length);
function ds() {
  for (var e = arguments.length, t = new Array(e), o = 0; o < e; o++)
    t[o] = arguments[o];
  return (n) => (n = k(n), !z5(n) || t.every((s) => (s.lastIndex = 0, s.test(n))));
}
var j5 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  forEach: eA,
  len: tA,
  normalizeValidatorObject: zl,
  regex: ds,
  req: z5,
  unwrap: k,
  unwrapNormalizedValidator: L7,
  unwrapValidatorResponse: A7,
  withAsync: XM,
  withMessage: JM,
  withParams: QM
});
ds(/^[a-zA-Z]*$/);
ds(/^[a-zA-Z0-9]*$/);
ds(/^\d*(\.\d+)?$/);
const oA = /^(?:[A-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9]{2,}(?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
var nA = ds(oA), sA = {
  $validator: nA,
  $message: "Value is not a valid email address",
  $params: {
    type: "email"
  }
};
function iA(e) {
  return typeof e == "string" && (e = e.trim()), z5(e);
}
var rA = {
  $validator: iA,
  $message: "Value is required",
  $params: {
    type: "required"
  }
};
const lA = /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u00a1-\uffff][a-z0-9\u00a1-\uffff_-]{0,62})?[a-z0-9\u00a1-\uffff]\.)+(?:[a-z\u00a1-\uffff]{2,}\.?))(?::\d{2,5})?(?:[/?#]\S*)?$/i;
var aA = ds(lA), cA = {
  $validator: aA,
  $message: "The value is not a valid URL address",
  $params: {
    type: "url"
  }
};
ds(/(^[0-9]*$)|(^-[0-9]+$)/);
ds(/^[-]?\d*(\.\d+)?$/);
var Ra = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function dA(e) {
  if (Object.prototype.hasOwnProperty.call(e, "__esModule")) return e;
  var t = e.default;
  if (typeof t == "function") {
    var o = function n() {
      return this instanceof n ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    o.prototype = t.prototype;
  } else o = {};
  return Object.defineProperty(o, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var s = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(o, n, s.get ? s : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), o;
}
function uA(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var $1 = { exports: {} };
const hA = {}, gA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: hA
}, Symbol.toStringTag, { value: "Module" })), pA = /* @__PURE__ */ dA(gA);
var fA = $1.exports, Hc;
function jl() {
  return Hc || (Hc = 1, (function(e, t) {
    (function(o, n) {
      e.exports = n();
    })(fA, function() {
      var o = o || (function(n, s) {
        var i;
        if (typeof window < "u" && window.crypto && (i = window.crypto), typeof self < "u" && self.crypto && (i = self.crypto), typeof globalThis < "u" && globalThis.crypto && (i = globalThis.crypto), !i && typeof window < "u" && window.msCrypto && (i = window.msCrypto), !i && typeof Ra < "u" && Ra.crypto && (i = Ra.crypto), !i && typeof uA == "function")
          try {
            i = pA;
          } catch {
          }
        var r = function() {
          if (i) {
            if (typeof i.getRandomValues == "function")
              try {
                return i.getRandomValues(new Uint32Array(1))[0];
              } catch {
              }
            if (typeof i.randomBytes == "function")
              try {
                return i.randomBytes(4).readInt32LE();
              } catch {
              }
          }
          throw new Error("Native crypto module could not be used to get secure random number.");
        }, l = Object.create || /* @__PURE__ */ (function() {
          function b() {
          }
          return function(_) {
            var M;
            return b.prototype = _, M = new b(), b.prototype = null, M;
          };
        })(), a = {}, c = a.lib = {}, d = c.Base = /* @__PURE__ */ (function() {
          return {
            /**
             * Creates a new object that inherits from this object.
             *
             * @param {Object} overrides Properties to copy into the new object.
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         field: 'value',
             *
             *         method: function () {
             *         }
             *     });
             */
            extend: function(b) {
              var _ = l(this);
              return b && _.mixIn(b), (!_.hasOwnProperty("init") || this.init === _.init) && (_.init = function() {
                _.$super.init.apply(this, arguments);
              }), _.init.prototype = _, _.$super = this, _;
            },
            /**
             * Extends this object and runs the init method.
             * Arguments to create() will be passed to init().
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var instance = MyType.create();
             */
            create: function() {
              var b = this.extend();
              return b.init.apply(b, arguments), b;
            },
            /**
             * Initializes a newly created object.
             * Override this method to add some logic when your objects are created.
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         init: function () {
             *             // ...
             *         }
             *     });
             */
            init: function() {
            },
            /**
             * Copies properties into this object.
             *
             * @param {Object} properties The properties to mix in.
             *
             * @example
             *
             *     MyType.mixIn({
             *         field: 'value'
             *     });
             */
            mixIn: function(b) {
              for (var _ in b)
                b.hasOwnProperty(_) && (this[_] = b[_]);
              b.hasOwnProperty("toString") && (this.toString = b.toString);
            },
            /**
             * Creates a copy of this object.
             *
             * @return {Object} The clone.
             *
             * @example
             *
             *     var clone = instance.clone();
             */
            clone: function() {
              return this.init.prototype.extend(this);
            }
          };
        })(), u = c.WordArray = d.extend({
          /**
           * Initializes a newly created word array.
           *
           * @param {Array} words (Optional) An array of 32-bit words.
           * @param {number} sigBytes (Optional) The number of significant bytes in the words.
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.create();
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
           */
          init: function(b, _) {
            b = this.words = b || [], _ != s ? this.sigBytes = _ : this.sigBytes = b.length * 4;
          },
          /**
           * Converts this word array to a string.
           *
           * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
           *
           * @return {string} The stringified word array.
           *
           * @example
           *
           *     var string = wordArray + '';
           *     var string = wordArray.toString();
           *     var string = wordArray.toString(CryptoJS.enc.Utf8);
           */
          toString: function(b) {
            return (b || p).stringify(this);
          },
          /**
           * Concatenates a word array to this word array.
           *
           * @param {WordArray} wordArray The word array to append.
           *
           * @return {WordArray} This word array.
           *
           * @example
           *
           *     wordArray1.concat(wordArray2);
           */
          concat: function(b) {
            var _ = this.words, M = b.words, x = this.sigBytes, L = b.sigBytes;
            if (this.clamp(), x % 4)
              for (var A = 0; A < L; A++) {
                var R = M[A >>> 2] >>> 24 - A % 4 * 8 & 255;
                _[x + A >>> 2] |= R << 24 - (x + A) % 4 * 8;
              }
            else
              for (var P = 0; P < L; P += 4)
                _[x + P >>> 2] = M[P >>> 2];
            return this.sigBytes += L, this;
          },
          /**
           * Removes insignificant bits.
           *
           * @example
           *
           *     wordArray.clamp();
           */
          clamp: function() {
            var b = this.words, _ = this.sigBytes;
            b[_ >>> 2] &= 4294967295 << 32 - _ % 4 * 8, b.length = n.ceil(_ / 4);
          },
          /**
           * Creates a copy of this word array.
           *
           * @return {WordArray} The clone.
           *
           * @example
           *
           *     var clone = wordArray.clone();
           */
          clone: function() {
            var b = d.clone.call(this);
            return b.words = this.words.slice(0), b;
          },
          /**
           * Creates a word array filled with random bytes.
           *
           * @param {number} nBytes The number of random bytes to generate.
           *
           * @return {WordArray} The random word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.random(16);
           */
          random: function(b) {
            for (var _ = [], M = 0; M < b; M += 4)
              _.push(r());
            return new u.init(_, b);
          }
        }), h = a.enc = {}, p = h.Hex = {
          /**
           * Converts a word array to a hex string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The hex string.
           *
           * @static
           *
           * @example
           *
           *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
           */
          stringify: function(b) {
            for (var _ = b.words, M = b.sigBytes, x = [], L = 0; L < M; L++) {
              var A = _[L >>> 2] >>> 24 - L % 4 * 8 & 255;
              x.push((A >>> 4).toString(16)), x.push((A & 15).toString(16));
            }
            return x.join("");
          },
          /**
           * Converts a hex string to a word array.
           *
           * @param {string} hexStr The hex string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
           */
          parse: function(b) {
            for (var _ = b.length, M = [], x = 0; x < _; x += 2)
              M[x >>> 3] |= parseInt(b.substr(x, 2), 16) << 24 - x % 8 * 4;
            return new u.init(M, _ / 2);
          }
        }, C = h.Latin1 = {
          /**
           * Converts a word array to a Latin1 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The Latin1 string.
           *
           * @static
           *
           * @example
           *
           *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
           */
          stringify: function(b) {
            for (var _ = b.words, M = b.sigBytes, x = [], L = 0; L < M; L++) {
              var A = _[L >>> 2] >>> 24 - L % 4 * 8 & 255;
              x.push(String.fromCharCode(A));
            }
            return x.join("");
          },
          /**
           * Converts a Latin1 string to a word array.
           *
           * @param {string} latin1Str The Latin1 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
           */
          parse: function(b) {
            for (var _ = b.length, M = [], x = 0; x < _; x++)
              M[x >>> 2] |= (b.charCodeAt(x) & 255) << 24 - x % 4 * 8;
            return new u.init(M, _);
          }
        }, m = h.Utf8 = {
          /**
           * Converts a word array to a UTF-8 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-8 string.
           *
           * @static
           *
           * @example
           *
           *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
           */
          stringify: function(b) {
            try {
              return decodeURIComponent(escape(C.stringify(b)));
            } catch {
              throw new Error("Malformed UTF-8 data");
            }
          },
          /**
           * Converts a UTF-8 string to a word array.
           *
           * @param {string} utf8Str The UTF-8 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
           */
          parse: function(b) {
            return C.parse(unescape(encodeURIComponent(b)));
          }
        }, w = c.BufferedBlockAlgorithm = d.extend({
          /**
           * Resets this block algorithm's data buffer to its initial state.
           *
           * @example
           *
           *     bufferedBlockAlgorithm.reset();
           */
          reset: function() {
            this._data = new u.init(), this._nDataBytes = 0;
          },
          /**
           * Adds new data to this block algorithm's buffer.
           *
           * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
           *
           * @example
           *
           *     bufferedBlockAlgorithm._append('data');
           *     bufferedBlockAlgorithm._append(wordArray);
           */
          _append: function(b) {
            typeof b == "string" && (b = m.parse(b)), this._data.concat(b), this._nDataBytes += b.sigBytes;
          },
          /**
           * Processes available data blocks.
           *
           * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
           *
           * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
           *
           * @return {WordArray} The processed data.
           *
           * @example
           *
           *     var processedData = bufferedBlockAlgorithm._process();
           *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
           */
          _process: function(b) {
            var _, M = this._data, x = M.words, L = M.sigBytes, A = this.blockSize, R = A * 4, P = L / R;
            b ? P = n.ceil(P) : P = n.max((P | 0) - this._minBufferSize, 0);
            var I = P * A, B = n.min(I * 4, L);
            if (I) {
              for (var H = 0; H < I; H += A)
                this._doProcessBlock(x, H);
              _ = x.splice(0, I), M.sigBytes -= B;
            }
            return new u.init(_, B);
          },
          /**
           * Creates a copy of this object.
           *
           * @return {Object} The clone.
           *
           * @example
           *
           *     var clone = bufferedBlockAlgorithm.clone();
           */
          clone: function() {
            var b = d.clone.call(this);
            return b._data = this._data.clone(), b;
          },
          _minBufferSize: 0
        });
        c.Hasher = w.extend({
          /**
           * Configuration options.
           */
          cfg: d.extend(),
          /**
           * Initializes a newly created hasher.
           *
           * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
           *
           * @example
           *
           *     var hasher = CryptoJS.algo.SHA256.create();
           */
          init: function(b) {
            this.cfg = this.cfg.extend(b), this.reset();
          },
          /**
           * Resets this hasher to its initial state.
           *
           * @example
           *
           *     hasher.reset();
           */
          reset: function() {
            w.reset.call(this), this._doReset();
          },
          /**
           * Updates this hasher with a message.
           *
           * @param {WordArray|string} messageUpdate The message to append.
           *
           * @return {Hasher} This hasher.
           *
           * @example
           *
           *     hasher.update('message');
           *     hasher.update(wordArray);
           */
          update: function(b) {
            return this._append(b), this._process(), this;
          },
          /**
           * Finalizes the hash computation.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} messageUpdate (Optional) A final message update.
           *
           * @return {WordArray} The hash.
           *
           * @example
           *
           *     var hash = hasher.finalize();
           *     var hash = hasher.finalize('message');
           *     var hash = hasher.finalize(wordArray);
           */
          finalize: function(b) {
            b && this._append(b);
            var _ = this._doFinalize();
            return _;
          },
          blockSize: 16,
          /**
           * Creates a shortcut function to a hasher's object interface.
           *
           * @param {Hasher} hasher The hasher to create a helper for.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
           */
          _createHelper: function(b) {
            return function(_, M) {
              return new b.init(M).finalize(_);
            };
          },
          /**
           * Creates a shortcut function to the HMAC's object interface.
           *
           * @param {Hasher} hasher The hasher to use in this HMAC helper.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
           */
          _createHmacHelper: function(b) {
            return function(_, M) {
              return new y.HMAC.init(b, M).finalize(_);
            };
          }
        });
        var y = a.algo = {};
        return a;
      })(Math);
      return o;
    });
  })($1)), $1.exports;
}
jl();
var Z1 = { exports: {} }, vA = Z1.exports, Vc;
function mA() {
  return Vc || (Vc = 1, (function(e, t) {
    (function(o, n) {
      e.exports = n(jl());
    })(vA, function(o) {
      return (function(n) {
        var s = o, i = s.lib, r = i.WordArray, l = i.Hasher, a = s.algo, c = [], d = [];
        (function() {
          function p(y) {
            for (var b = n.sqrt(y), _ = 2; _ <= b; _++)
              if (!(y % _))
                return !1;
            return !0;
          }
          function C(y) {
            return (y - (y | 0)) * 4294967296 | 0;
          }
          for (var m = 2, w = 0; w < 64; )
            p(m) && (w < 8 && (c[w] = C(n.pow(m, 1 / 2))), d[w] = C(n.pow(m, 1 / 3)), w++), m++;
        })();
        var u = [], h = a.SHA256 = l.extend({
          _doReset: function() {
            this._hash = new r.init(c.slice(0));
          },
          _doProcessBlock: function(p, C) {
            for (var m = this._hash.words, w = m[0], y = m[1], b = m[2], _ = m[3], M = m[4], x = m[5], L = m[6], A = m[7], R = 0; R < 64; R++) {
              if (R < 16)
                u[R] = p[C + R] | 0;
              else {
                var P = u[R - 15], I = (P << 25 | P >>> 7) ^ (P << 14 | P >>> 18) ^ P >>> 3, B = u[R - 2], H = (B << 15 | B >>> 17) ^ (B << 13 | B >>> 19) ^ B >>> 10;
                u[R] = I + u[R - 7] + H + u[R - 16];
              }
              var O = M & x ^ ~M & L, N = w & y ^ w & b ^ y & b, te = (w << 30 | w >>> 2) ^ (w << 19 | w >>> 13) ^ (w << 10 | w >>> 22), E = (M << 26 | M >>> 6) ^ (M << 21 | M >>> 11) ^ (M << 7 | M >>> 25), j = A + E + O + d[R] + u[R], Z = te + N;
              A = L, L = x, x = M, M = _ + j | 0, _ = b, b = y, y = w, w = j + Z | 0;
            }
            m[0] = m[0] + w | 0, m[1] = m[1] + y | 0, m[2] = m[2] + b | 0, m[3] = m[3] + _ | 0, m[4] = m[4] + M | 0, m[5] = m[5] + x | 0, m[6] = m[6] + L | 0, m[7] = m[7] + A | 0;
          },
          _doFinalize: function() {
            var p = this._data, C = p.words, m = this._nDataBytes * 8, w = p.sigBytes * 8;
            return C[w >>> 5] |= 128 << 24 - w % 32, C[(w + 64 >>> 9 << 4) + 14] = n.floor(m / 4294967296), C[(w + 64 >>> 9 << 4) + 15] = m, p.sigBytes = C.length * 4, this._process(), this._hash;
          },
          clone: function() {
            var p = l.clone.call(this);
            return p._hash = this._hash.clone(), p;
          }
        });
        s.SHA256 = l._createHelper(h), s.HmacSHA256 = l._createHmacHelper(h);
      })(Math), o.SHA256;
    });
  })(Z1)), Z1.exports;
}
mA();
var G1 = { exports: {} }, CA = G1.exports, Oc;
function wA() {
  return Oc || (Oc = 1, (function(e, t) {
    (function(o, n) {
      e.exports = n(jl());
    })(CA, function(o) {
      return (function() {
        var n = o, s = n.lib, i = s.WordArray, r = n.enc;
        r.Base64 = {
          /**
           * Converts a word array to a Base64 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The Base64 string.
           *
           * @static
           *
           * @example
           *
           *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
           */
          stringify: function(a) {
            var c = a.words, d = a.sigBytes, u = this._map;
            a.clamp();
            for (var h = [], p = 0; p < d; p += 3)
              for (var C = c[p >>> 2] >>> 24 - p % 4 * 8 & 255, m = c[p + 1 >>> 2] >>> 24 - (p + 1) % 4 * 8 & 255, w = c[p + 2 >>> 2] >>> 24 - (p + 2) % 4 * 8 & 255, y = C << 16 | m << 8 | w, b = 0; b < 4 && p + b * 0.75 < d; b++)
                h.push(u.charAt(y >>> 6 * (3 - b) & 63));
            var _ = u.charAt(64);
            if (_)
              for (; h.length % 4; )
                h.push(_);
            return h.join("");
          },
          /**
           * Converts a Base64 string to a word array.
           *
           * @param {string} base64Str The Base64 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
           */
          parse: function(a) {
            var c = a.length, d = this._map, u = this._reverseMap;
            if (!u) {
              u = this._reverseMap = [];
              for (var h = 0; h < d.length; h++)
                u[d.charCodeAt(h)] = h;
            }
            var p = d.charAt(64);
            if (p) {
              var C = a.indexOf(p);
              C !== -1 && (c = C);
            }
            return l(a, c, u);
          },
          _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
        };
        function l(a, c, d) {
          for (var u = [], h = 0, p = 0; p < c; p++)
            if (p % 4) {
              var C = d[a.charCodeAt(p - 1)] << p % 4 * 2, m = d[a.charCodeAt(p)] >>> 6 - p % 4 * 2, w = C | m;
              u[h >>> 2] |= w << 24 - h % 4 * 8, h++;
            }
          return i.create(u, h);
        }
      })(), o.enc.Base64;
    });
  })(G1)), G1.exports;
}
wA();
var N1 = { exports: {} }, bA = N1.exports, Bc;
function yA() {
  return Bc || (Bc = 1, (function(e, t) {
    (function(o, n) {
      e.exports = n(jl());
    })(bA, function(o) {
      return o.enc.Utf8;
    });
  })(N1)), N1.exports;
}
yA();
function O0(e) {
  this.message = e;
}
O0.prototype = new Error(), O0.prototype.name = "InvalidCharacterError";
typeof window < "u" && window.atob && window.atob.bind(window);
function $c(e) {
  this.message = e;
}
$c.prototype = new Error(), $c.prototype.name = "InvalidTokenError";
var _A = {
  debug: () => {
  },
  info: () => {
  },
  warn: () => {
  },
  error: () => {
  }
}, Ko, qo, cl = /* @__PURE__ */ ((e) => (e[e.NONE = 0] = "NONE", e[e.ERROR = 1] = "ERROR", e[e.WARN = 2] = "WARN", e[e.INFO = 3] = "INFO", e[e.DEBUG = 4] = "DEBUG", e))(cl || {});
((e) => {
  function t() {
    Ko = 3, qo = _A;
  }
  e.reset = t;
  function o(s) {
    if (!(0 <= s && s <= 4))
      throw new Error("Invalid log level");
    Ko = s;
  }
  e.setLevel = o;
  function n(s) {
    qo = s;
  }
  e.setLogger = n;
})(cl || (cl = {}));
var Uo = class {
  constructor(e) {
    this._name = e;
  }
  /* eslint-disable @typescript-eslint/no-unsafe-enum-comparison */
  debug(...e) {
    Ko >= 4 && qo.debug(Uo._format(this._name, this._method), ...e);
  }
  info(...e) {
    Ko >= 3 && qo.info(Uo._format(this._name, this._method), ...e);
  }
  warn(...e) {
    Ko >= 2 && qo.warn(Uo._format(this._name, this._method), ...e);
  }
  error(...e) {
    Ko >= 1 && qo.error(Uo._format(this._name, this._method), ...e);
  }
  /* eslint-enable @typescript-eslint/no-unsafe-enum-comparison */
  throw(e) {
    throw this.error(e), e;
  }
  create(e) {
    const t = Object.create(this);
    return t._method = e, t.debug("begin"), t;
  }
  static createStatic(e, t) {
    const o = new Uo(`${e}.${t}`);
    return o.debug("begin"), o;
  }
  static _format(e, t) {
    const o = `[${e}]`;
    return t ? `${o} ${t}:` : o;
  }
  /* eslint-disable @typescript-eslint/no-unsafe-enum-comparison */
  // helpers for static class methods
  static debug(e, ...t) {
    Ko >= 4 && qo.debug(Uo._format(e), ...t);
  }
  static info(e, ...t) {
    Ko >= 3 && qo.info(Uo._format(e), ...t);
  }
  static warn(e, ...t) {
    Ko >= 2 && qo.warn(Uo._format(e), ...t);
  }
  static error(e, ...t) {
    Ko >= 1 && qo.error(Uo._format(e), ...t);
  }
  /* eslint-enable @typescript-eslint/no-unsafe-enum-comparison */
};
cl.reset();
var SA = class {
  constructor({
    prefix: e = "oidc.",
    store: t = localStorage
  } = {}) {
    this._logger = new Uo("WebStorageStateStore"), this._store = t, this._prefix = e;
  }
  async set(e, t) {
    this._logger.create(`set('${e}')`), e = this._prefix + e, await this._store.setItem(e, t);
  }
  async get(e) {
    return this._logger.create(`get('${e}')`), e = this._prefix + e, await this._store.getItem(e);
  }
  async remove(e) {
    this._logger.create(`remove('${e}')`), e = this._prefix + e;
    const t = await this._store.getItem(e);
    return await this._store.removeItem(e), t;
  }
  async getAllKeys() {
    this._logger.create("getAllKeys");
    const e = await this._store.length, t = [];
    for (let o = 0; o < e; o++) {
      const n = await this._store.key(o);
      n && n.indexOf(this._prefix) === 0 && t.push(n.substr(this._prefix.length));
    }
    return t;
  }
}, Ls = eS({
  settings: null,
  oidcSettings: null,
  userManager: null,
  refreshUserManager: null,
  user: null,
  token: F(() => {
    var e;
    return ((e = Ls.user) == null ? void 0 : e.access_token) || null;
  }),
  hasExpiresAt: F(
    () => {
      var e;
      return Date.now() / 1e3 > ((e = Ls.user) == null ? void 0 : e.expires_at) || !1;
    }
  ),
  redirect_uri: ""
}), xA = {
  setUser(e) {
    var t;
    Ls.user = e, (t = Ls.userManager) == null || t.storeUser(e);
  },
  async removeUser() {
    var e;
    Ls.user = null, await ((e = Ls.userManager) == null ? void 0 : e.removeUser());
  }
};
function W5() {
  return {
    state: F(() => Ls),
    actions: F(() => xA)
  };
}
W5();
W("OIDC_REDIRECT_URI");
W5();
const Fa = { BASE_URL: "/", DEV: !1, MODE: "production", PROD: !0, SSR: !1, VITE_APP_AG_GRID_LICENSE: "Using_this_{AG_Grid}_Enterprise_key_{AG-114672}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Scayla_AG}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Scayla}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{Scayla}_need_to_be_licensed___{Scayla}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{5_December_2026}____[v3]_[01]_MTc5NjQyODgwMDAwMA==b963acb9189af440c44f6833bc375657", VITE_APP_OIDC_AUTHORITY: "https://login.scayla.com", VITE_APP_OIDC_CLIENT_ID: "355514447302761042", VITE_APP_SCAYLA_API_URL: "https://api.review.scayla.com", VITE_APP_SENTRY_DSN: "https://72329bf821e847c38a4c79be93849f23@glitchtip.scayla.com/2", VITE_APP_SENTRY_ENABLED: "false", VITE_APP_SENTRY_PROJECT_NAME: "scayla-frontend", VITE_APP_SENTRY_VERSION: "dev", VITE_APP_SHOW_EMAIL_FEATURE: "true", VITE_APP_TINY_MCE_API_KEY: "nb1o9f0z1w7lvkth993fzrhi1fnjqfry6wnprsqnvke5kht4", VITE_APP_URL: "https://app.review.scayla.com" };
var MA = Object.create, E7 = Object.defineProperty, AA = Object.getOwnPropertyDescriptor, P7 = Object.getOwnPropertyNames, LA = Object.getPrototypeOf, EA = Object.prototype.hasOwnProperty, Wl = (e, t) => function() {
  return t || (0, e[P7(e)[0]])((t = { exports: {} }).exports, t), t.exports;
}, PA = (e, t, o, n) => {
  if (t && typeof t == "object" || typeof t == "function")
    for (let s of P7(t))
      !EA.call(e, s) && s !== o && E7(e, s, { get: () => t[s], enumerable: !(n = AA(t, s)) || n.enumerable });
  return e;
}, RA = (e, t, o) => (o = e != null ? MA(LA(e)) : {}, PA(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  E7(o, "default", { value: e, enumerable: !0 }),
  e
)), FA = Wl({
  "../../common/temp/node_modules/.pnpm/i18n-iso-countries@7.14.0/node_modules/i18n-iso-countries/codes.json"(e, t) {
    t.exports = [
      ["AF", "AFG", "004", "ISO 3166-2:AF"],
      ["AL", "ALB", "008", "ISO 3166-2:AL"],
      ["DZ", "DZA", "012", "ISO 3166-2:DZ"],
      ["AS", "ASM", "016", "ISO 3166-2:AS"],
      ["AD", "AND", "020", "ISO 3166-2:AD"],
      ["AO", "AGO", "024", "ISO 3166-2:AO"],
      ["AI", "AIA", "660", "ISO 3166-2:AI"],
      ["AQ", "ATA", "010", "ISO 3166-2:AQ"],
      ["AG", "ATG", "028", "ISO 3166-2:AG"],
      ["AR", "ARG", "032", "ISO 3166-2:AR"],
      ["AM", "ARM", "051", "ISO 3166-2:AM"],
      ["AW", "ABW", "533", "ISO 3166-2:AW"],
      ["AU", "AUS", "036", "ISO 3166-2:AU"],
      ["AT", "AUT", "040", "ISO 3166-2:AT"],
      ["AZ", "AZE", "031", "ISO 3166-2:AZ"],
      ["BS", "BHS", "044", "ISO 3166-2:BS"],
      ["BH", "BHR", "048", "ISO 3166-2:BH"],
      ["BD", "BGD", "050", "ISO 3166-2:BD"],
      ["BB", "BRB", "052", "ISO 3166-2:BB"],
      ["BY", "BLR", "112", "ISO 3166-2:BY"],
      ["BE", "BEL", "056", "ISO 3166-2:BE"],
      ["BZ", "BLZ", "084", "ISO 3166-2:BZ"],
      ["BJ", "BEN", "204", "ISO 3166-2:BJ"],
      ["BM", "BMU", "060", "ISO 3166-2:BM"],
      ["BT", "BTN", "064", "ISO 3166-2:BT"],
      ["BO", "BOL", "068", "ISO 3166-2:BO"],
      ["BA", "BIH", "070", "ISO 3166-2:BA"],
      ["BW", "BWA", "072", "ISO 3166-2:BW"],
      ["BV", "BVT", "074", "ISO 3166-2:BV"],
      ["BR", "BRA", "076", "ISO 3166-2:BR"],
      ["IO", "IOT", "086", "ISO 3166-2:IO"],
      ["BN", "BRN", "096", "ISO 3166-2:BN"],
      ["BG", "BGR", "100", "ISO 3166-2:BG"],
      ["BF", "BFA", "854", "ISO 3166-2:BF"],
      ["BI", "BDI", "108", "ISO 3166-2:BI"],
      ["KH", "KHM", "116", "ISO 3166-2:KH"],
      ["CM", "CMR", "120", "ISO 3166-2:CM"],
      ["CA", "CAN", "124", "ISO 3166-2:CA"],
      ["CV", "CPV", "132", "ISO 3166-2:CV"],
      ["KY", "CYM", "136", "ISO 3166-2:KY"],
      ["CF", "CAF", "140", "ISO 3166-2:CF"],
      ["TD", "TCD", "148", "ISO 3166-2:TD"],
      ["CL", "CHL", "152", "ISO 3166-2:CL"],
      ["CN", "CHN", "156", "ISO 3166-2:CN"],
      ["CX", "CXR", "162", "ISO 3166-2:CX"],
      ["CC", "CCK", "166", "ISO 3166-2:CC"],
      ["CO", "COL", "170", "ISO 3166-2:CO"],
      ["KM", "COM", "174", "ISO 3166-2:KM"],
      ["CG", "COG", "178", "ISO 3166-2:CG"],
      ["CD", "COD", "180", "ISO 3166-2:CD"],
      ["CK", "COK", "184", "ISO 3166-2:CK"],
      ["CR", "CRI", "188", "ISO 3166-2:CR"],
      ["CI", "CIV", "384", "ISO 3166-2:CI"],
      ["HR", "HRV", "191", "ISO 3166-2:HR"],
      ["CU", "CUB", "192", "ISO 3166-2:CU"],
      ["CY", "CYP", "196", "ISO 3166-2:CY"],
      ["CZ", "CZE", "203", "ISO 3166-2:CZ"],
      ["DK", "DNK", "208", "ISO 3166-2:DK"],
      ["DJ", "DJI", "262", "ISO 3166-2:DJ"],
      ["DM", "DMA", "212", "ISO 3166-2:DM"],
      ["DO", "DOM", "214", "ISO 3166-2:DO"],
      ["EC", "ECU", "218", "ISO 3166-2:EC"],
      ["EG", "EGY", "818", "ISO 3166-2:EG"],
      ["SV", "SLV", "222", "ISO 3166-2:SV"],
      ["GQ", "GNQ", "226", "ISO 3166-2:GQ"],
      ["ER", "ERI", "232", "ISO 3166-2:ER"],
      ["EE", "EST", "233", "ISO 3166-2:EE"],
      ["ET", "ETH", "231", "ISO 3166-2:ET"],
      ["FK", "FLK", "238", "ISO 3166-2:FK"],
      ["FO", "FRO", "234", "ISO 3166-2:FO"],
      ["FJ", "FJI", "242", "ISO 3166-2:FJ"],
      ["FI", "FIN", "246", "ISO 3166-2:FI"],
      ["FR", "FRA", "250", "ISO 3166-2:FR"],
      ["GF", "GUF", "254", "ISO 3166-2:GF"],
      ["PF", "PYF", "258", "ISO 3166-2:PF"],
      ["TF", "ATF", "260", "ISO 3166-2:TF"],
      ["GA", "GAB", "266", "ISO 3166-2:GA"],
      ["GM", "GMB", "270", "ISO 3166-2:GM"],
      ["GE", "GEO", "268", "ISO 3166-2:GE"],
      ["DE", "DEU", "276", "ISO 3166-2:DE"],
      ["GH", "GHA", "288", "ISO 3166-2:GH"],
      ["GI", "GIB", "292", "ISO 3166-2:GI"],
      ["GR", "GRC", "300", "ISO 3166-2:GR"],
      ["GL", "GRL", "304", "ISO 3166-2:GL"],
      ["GD", "GRD", "308", "ISO 3166-2:GD"],
      ["GP", "GLP", "312", "ISO 3166-2:GP"],
      ["GU", "GUM", "316", "ISO 3166-2:GU"],
      ["GT", "GTM", "320", "ISO 3166-2:GT"],
      ["GN", "GIN", "324", "ISO 3166-2:GN"],
      ["GW", "GNB", "624", "ISO 3166-2:GW"],
      ["GY", "GUY", "328", "ISO 3166-2:GY"],
      ["HT", "HTI", "332", "ISO 3166-2:HT"],
      ["HM", "HMD", "334", "ISO 3166-2:HM"],
      ["VA", "VAT", "336", "ISO 3166-2:VA"],
      ["HN", "HND", "340", "ISO 3166-2:HN"],
      ["HK", "HKG", "344", "ISO 3166-2:HK"],
      ["HU", "HUN", "348", "ISO 3166-2:HU"],
      ["IS", "ISL", "352", "ISO 3166-2:IS"],
      ["IN", "IND", "356", "ISO 3166-2:IN"],
      ["ID", "IDN", "360", "ISO 3166-2:ID"],
      ["IR", "IRN", "364", "ISO 3166-2:IR"],
      ["IQ", "IRQ", "368", "ISO 3166-2:IQ"],
      ["IE", "IRL", "372", "ISO 3166-2:IE"],
      ["IL", "ISR", "376", "ISO 3166-2:IL"],
      ["IT", "ITA", "380", "ISO 3166-2:IT"],
      ["JM", "JAM", "388", "ISO 3166-2:JM"],
      ["JP", "JPN", "392", "ISO 3166-2:JP"],
      ["JO", "JOR", "400", "ISO 3166-2:JO"],
      ["KZ", "KAZ", "398", "ISO 3166-2:KZ"],
      ["KE", "KEN", "404", "ISO 3166-2:KE"],
      ["KI", "KIR", "296", "ISO 3166-2:KI"],
      ["KP", "PRK", "408", "ISO 3166-2:KP"],
      ["KR", "KOR", "410", "ISO 3166-2:KR"],
      ["KW", "KWT", "414", "ISO 3166-2:KW"],
      ["KG", "KGZ", "417", "ISO 3166-2:KG"],
      ["LA", "LAO", "418", "ISO 3166-2:LA"],
      ["LV", "LVA", "428", "ISO 3166-2:LV"],
      ["LB", "LBN", "422", "ISO 3166-2:LB"],
      ["LS", "LSO", "426", "ISO 3166-2:LS"],
      ["LR", "LBR", "430", "ISO 3166-2:LR"],
      ["LY", "LBY", "434", "ISO 3166-2:LY"],
      ["LI", "LIE", "438", "ISO 3166-2:LI"],
      ["LT", "LTU", "440", "ISO 3166-2:LT"],
      ["LU", "LUX", "442", "ISO 3166-2:LU"],
      ["MO", "MAC", "446", "ISO 3166-2:MO"],
      ["MG", "MDG", "450", "ISO 3166-2:MG"],
      ["MW", "MWI", "454", "ISO 3166-2:MW"],
      ["MY", "MYS", "458", "ISO 3166-2:MY"],
      ["MV", "MDV", "462", "ISO 3166-2:MV"],
      ["ML", "MLI", "466", "ISO 3166-2:ML"],
      ["MT", "MLT", "470", "ISO 3166-2:MT"],
      ["MH", "MHL", "584", "ISO 3166-2:MH"],
      ["MQ", "MTQ", "474", "ISO 3166-2:MQ"],
      ["MR", "MRT", "478", "ISO 3166-2:MR"],
      ["MU", "MUS", "480", "ISO 3166-2:MU"],
      ["YT", "MYT", "175", "ISO 3166-2:YT"],
      ["MX", "MEX", "484", "ISO 3166-2:MX"],
      ["FM", "FSM", "583", "ISO 3166-2:FM"],
      ["MD", "MDA", "498", "ISO 3166-2:MD"],
      ["MC", "MCO", "492", "ISO 3166-2:MC"],
      ["MN", "MNG", "496", "ISO 3166-2:MN"],
      ["MS", "MSR", "500", "ISO 3166-2:MS"],
      ["MA", "MAR", "504", "ISO 3166-2:MA"],
      ["MZ", "MOZ", "508", "ISO 3166-2:MZ"],
      ["MM", "MMR", "104", "ISO 3166-2:MM"],
      ["NA", "NAM", "516", "ISO 3166-2:NA"],
      ["NR", "NRU", "520", "ISO 3166-2:NR"],
      ["NP", "NPL", "524", "ISO 3166-2:NP"],
      ["NL", "NLD", "528", "ISO 3166-2:NL"],
      ["NC", "NCL", "540", "ISO 3166-2:NC"],
      ["NZ", "NZL", "554", "ISO 3166-2:NZ"],
      ["NI", "NIC", "558", "ISO 3166-2:NI"],
      ["NE", "NER", "562", "ISO 3166-2:NE"],
      ["NG", "NGA", "566", "ISO 3166-2:NG"],
      ["NU", "NIU", "570", "ISO 3166-2:NU"],
      ["NF", "NFK", "574", "ISO 3166-2:NF"],
      ["MP", "MNP", "580", "ISO 3166-2:MP"],
      ["MK", "MKD", "807", "ISO 3166-2:MK"],
      ["NO", "NOR", "578", "ISO 3166-2:NO"],
      ["OM", "OMN", "512", "ISO 3166-2:OM"],
      ["PK", "PAK", "586", "ISO 3166-2:PK"],
      ["PW", "PLW", "585", "ISO 3166-2:PW"],
      ["PS", "PSE", "275", "ISO 3166-2:PS"],
      ["PA", "PAN", "591", "ISO 3166-2:PA"],
      ["PG", "PNG", "598", "ISO 3166-2:PG"],
      ["PY", "PRY", "600", "ISO 3166-2:PY"],
      ["PE", "PER", "604", "ISO 3166-2:PE"],
      ["PH", "PHL", "608", "ISO 3166-2:PH"],
      ["PN", "PCN", "612", "ISO 3166-2:PN"],
      ["PL", "POL", "616", "ISO 3166-2:PL"],
      ["PT", "PRT", "620", "ISO 3166-2:PT"],
      ["PR", "PRI", "630", "ISO 3166-2:PR"],
      ["QA", "QAT", "634", "ISO 3166-2:QA"],
      ["RE", "REU", "638", "ISO 3166-2:RE"],
      ["RO", "ROU", "642", "ISO 3166-2:RO"],
      ["RU", "RUS", "643", "ISO 3166-2:RU"],
      ["RW", "RWA", "646", "ISO 3166-2:RW"],
      ["SH", "SHN", "654", "ISO 3166-2:SH"],
      ["KN", "KNA", "659", "ISO 3166-2:KN"],
      ["LC", "LCA", "662", "ISO 3166-2:LC"],
      ["PM", "SPM", "666", "ISO 3166-2:PM"],
      ["VC", "VCT", "670", "ISO 3166-2:VC"],
      ["WS", "WSM", "882", "ISO 3166-2:WS"],
      ["SM", "SMR", "674", "ISO 3166-2:SM"],
      ["ST", "STP", "678", "ISO 3166-2:ST"],
      ["SA", "SAU", "682", "ISO 3166-2:SA"],
      ["SN", "SEN", "686", "ISO 3166-2:SN"],
      ["SC", "SYC", "690", "ISO 3166-2:SC"],
      ["SL", "SLE", "694", "ISO 3166-2:SL"],
      ["SG", "SGP", "702", "ISO 3166-2:SG"],
      ["SK", "SVK", "703", "ISO 3166-2:SK"],
      ["SI", "SVN", "705", "ISO 3166-2:SI"],
      ["SB", "SLB", "090", "ISO 3166-2:SB"],
      ["SO", "SOM", "706", "ISO 3166-2:SO"],
      ["ZA", "ZAF", "710", "ISO 3166-2:ZA"],
      ["GS", "SGS", "239", "ISO 3166-2:GS"],
      ["ES", "ESP", "724", "ISO 3166-2:ES"],
      ["LK", "LKA", "144", "ISO 3166-2:LK"],
      ["SD", "SDN", "729", "ISO 3166-2:SD"],
      ["SR", "SUR", "740", "ISO 3166-2:SR"],
      ["SJ", "SJM", "744", "ISO 3166-2:SJ"],
      ["SZ", "SWZ", "748", "ISO 3166-2:SZ"],
      ["SE", "SWE", "752", "ISO 3166-2:SE"],
      ["CH", "CHE", "756", "ISO 3166-2:CH"],
      ["SY", "SYR", "760", "ISO 3166-2:SY"],
      ["TW", "TWN", "158", "ISO 3166-2:TW"],
      ["TJ", "TJK", "762", "ISO 3166-2:TJ"],
      ["TZ", "TZA", "834", "ISO 3166-2:TZ"],
      ["TH", "THA", "764", "ISO 3166-2:TH"],
      ["TL", "TLS", "626", "ISO 3166-2:TL"],
      ["TG", "TGO", "768", "ISO 3166-2:TG"],
      ["TK", "TKL", "772", "ISO 3166-2:TK"],
      ["TO", "TON", "776", "ISO 3166-2:TO"],
      ["TT", "TTO", "780", "ISO 3166-2:TT"],
      ["TN", "TUN", "788", "ISO 3166-2:TN"],
      ["TR", "TUR", "792", "ISO 3166-2:TR"],
      ["TM", "TKM", "795", "ISO 3166-2:TM"],
      ["TC", "TCA", "796", "ISO 3166-2:TC"],
      ["TV", "TUV", "798", "ISO 3166-2:TV"],
      ["UG", "UGA", "800", "ISO 3166-2:UG"],
      ["UA", "UKR", "804", "ISO 3166-2:UA"],
      ["AE", "ARE", "784", "ISO 3166-2:AE"],
      ["GB", "GBR", "826", "ISO 3166-2:GB"],
      ["US", "USA", "840", "ISO 3166-2:US"],
      ["UM", "UMI", "581", "ISO 3166-2:UM"],
      ["UY", "URY", "858", "ISO 3166-2:UY"],
      ["UZ", "UZB", "860", "ISO 3166-2:UZ"],
      ["VU", "VUT", "548", "ISO 3166-2:VU"],
      ["VE", "VEN", "862", "ISO 3166-2:VE"],
      ["VN", "VNM", "704", "ISO 3166-2:VN"],
      ["VG", "VGB", "092", "ISO 3166-2:VG"],
      ["VI", "VIR", "850", "ISO 3166-2:VI"],
      ["WF", "WLF", "876", "ISO 3166-2:WF"],
      ["EH", "ESH", "732", "ISO 3166-2:EH"],
      ["YE", "YEM", "887", "ISO 3166-2:YE"],
      ["ZM", "ZMB", "894", "ISO 3166-2:ZM"],
      ["ZW", "ZWE", "716", "ISO 3166-2:ZW"],
      ["AX", "ALA", "248", "ISO 3166-2:AX"],
      ["BQ", "BES", "535", "ISO 3166-2:BQ"],
      ["CW", "CUW", "531", "ISO 3166-2:CW"],
      ["GG", "GGY", "831", "ISO 3166-2:GG"],
      ["IM", "IMN", "833", "ISO 3166-2:IM"],
      ["JE", "JEY", "832", "ISO 3166-2:JE"],
      ["ME", "MNE", "499", "ISO 3166-2:ME"],
      ["BL", "BLM", "652", "ISO 3166-2:BL"],
      ["MF", "MAF", "663", "ISO 3166-2:MF"],
      ["RS", "SRB", "688", "ISO 3166-2:RS"],
      ["SX", "SXM", "534", "ISO 3166-2:SX"],
      ["SS", "SSD", "728", "ISO 3166-2:SS"],
      ["XK", "XKK", "983", "ISO 3166-2:XK"]
    ];
  }
}), TA = Wl({
  "../../common/temp/node_modules/.pnpm/i18n-iso-countries@7.14.0/node_modules/i18n-iso-countries/supportedLocales.json"(e, t) {
    t.exports = [
      "br",
      "cy",
      "dv",
      "sw",
      "eu",
      "af",
      "am",
      "ha",
      "ku",
      "ml",
      "mt",
      "no",
      "ps",
      "sd",
      "so",
      "sq",
      "ta",
      "tg",
      "tt",
      "ug",
      "ur",
      "vi",
      "ar",
      "az",
      "be",
      "bg",
      "bn",
      "bs",
      "ca",
      "cs",
      "da",
      "de",
      "el",
      "en",
      "es",
      "et",
      "fa",
      "fi",
      "fr",
      "ga",
      "gl",
      "he",
      "hi",
      "hr",
      "hu",
      "hy",
      "id",
      "is",
      "it",
      "ja",
      "ka",
      "kk",
      "km",
      "ko",
      "ky",
      "lt",
      "lv",
      "mk",
      "mn",
      "mr",
      "ms",
      "nb",
      "nl",
      "nn",
      "pl",
      "pt",
      "ro",
      "ru",
      "sk",
      "sl",
      "sr",
      "sv",
      "th",
      "tk",
      "tr",
      "uk",
      "uz",
      "zh"
    ];
  }
}), IA = Wl({
  "../../common/temp/node_modules/.pnpm/diacritics@1.3.0/node_modules/diacritics/index.js"(e) {
    e.remove = r;
    var t = [
      {
        base: " ",
        chars: " "
      },
      {
        base: "0",
        chars: "߀"
      },
      {
        base: "A",
        chars: "ⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ"
      },
      {
        base: "AA",
        chars: "Ꜳ"
      },
      {
        base: "AE",
        chars: "ÆǼǢ"
      },
      {
        base: "AO",
        chars: "Ꜵ"
      },
      {
        base: "AU",
        chars: "Ꜷ"
      },
      {
        base: "AV",
        chars: "ꜸꜺ"
      },
      {
        base: "AY",
        chars: "Ꜽ"
      },
      {
        base: "B",
        chars: "ⒷＢḂḄḆɃƁ"
      },
      {
        base: "C",
        chars: "ⒸＣꜾḈĆCĈĊČÇƇȻ"
      },
      {
        base: "D",
        chars: "ⒹＤḊĎḌḐḒḎĐƊƉᴅꝹ"
      },
      {
        base: "Dh",
        chars: "Ð"
      },
      {
        base: "DZ",
        chars: "ǱǄ"
      },
      {
        base: "Dz",
        chars: "ǲǅ"
      },
      {
        base: "E",
        chars: "ɛⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎᴇ"
      },
      {
        base: "F",
        chars: "ꝼⒻＦḞƑꝻ"
      },
      {
        base: "G",
        chars: "ⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾɢ"
      },
      {
        base: "H",
        chars: "ⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ"
      },
      {
        base: "I",
        chars: "ⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ"
      },
      {
        base: "J",
        chars: "ⒿＪĴɈȷ"
      },
      {
        base: "K",
        chars: "ⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ"
      },
      {
        base: "L",
        chars: "ⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ"
      },
      {
        base: "LJ",
        chars: "Ǉ"
      },
      {
        base: "Lj",
        chars: "ǈ"
      },
      {
        base: "M",
        chars: "ⓂＭḾṀṂⱮƜϻ"
      },
      {
        base: "N",
        chars: "ꞤȠⓃＮǸŃÑṄŇṆŅṊṈƝꞐᴎ"
      },
      {
        base: "NJ",
        chars: "Ǌ"
      },
      {
        base: "Nj",
        chars: "ǋ"
      },
      {
        base: "O",
        chars: "ⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ"
      },
      {
        base: "OE",
        chars: "Œ"
      },
      {
        base: "OI",
        chars: "Ƣ"
      },
      {
        base: "OO",
        chars: "Ꝏ"
      },
      {
        base: "OU",
        chars: "Ȣ"
      },
      {
        base: "P",
        chars: "ⓅＰṔṖƤⱣꝐꝒꝔ"
      },
      {
        base: "Q",
        chars: "ⓆＱꝖꝘɊ"
      },
      {
        base: "R",
        chars: "ⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ"
      },
      {
        base: "S",
        chars: "ⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ"
      },
      {
        base: "T",
        chars: "ⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ"
      },
      {
        base: "Th",
        chars: "Þ"
      },
      {
        base: "TZ",
        chars: "Ꜩ"
      },
      {
        base: "U",
        chars: "ⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ"
      },
      {
        base: "V",
        chars: "ⓋＶṼṾƲꝞɅ"
      },
      {
        base: "VY",
        chars: "Ꝡ"
      },
      {
        base: "W",
        chars: "ⓌＷẀẂŴẆẄẈⱲ"
      },
      {
        base: "X",
        chars: "ⓍＸẊẌ"
      },
      {
        base: "Y",
        chars: "ⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ"
      },
      {
        base: "Z",
        chars: "ⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ"
      },
      {
        base: "a",
        chars: "ⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐɑ"
      },
      {
        base: "aa",
        chars: "ꜳ"
      },
      {
        base: "ae",
        chars: "æǽǣ"
      },
      {
        base: "ao",
        chars: "ꜵ"
      },
      {
        base: "au",
        chars: "ꜷ"
      },
      {
        base: "av",
        chars: "ꜹꜻ"
      },
      {
        base: "ay",
        chars: "ꜽ"
      },
      {
        base: "b",
        chars: "ⓑｂḃḅḇƀƃɓƂ"
      },
      {
        base: "c",
        chars: "ｃⓒćĉċčçḉƈȼꜿↄ"
      },
      {
        base: "d",
        chars: "ⓓｄḋďḍḑḓḏđƌɖɗƋᏧԁꞪ"
      },
      {
        base: "dh",
        chars: "ð"
      },
      {
        base: "dz",
        chars: "ǳǆ"
      },
      {
        base: "e",
        chars: "ⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇǝ"
      },
      {
        base: "f",
        chars: "ⓕｆḟƒ"
      },
      {
        base: "ff",
        chars: "ﬀ"
      },
      {
        base: "fi",
        chars: "ﬁ"
      },
      {
        base: "fl",
        chars: "ﬂ"
      },
      {
        base: "ffi",
        chars: "ﬃ"
      },
      {
        base: "ffl",
        chars: "ﬄ"
      },
      {
        base: "g",
        chars: "ⓖｇǵĝḡğġǧģǥɠꞡꝿᵹ"
      },
      {
        base: "h",
        chars: "ⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ"
      },
      {
        base: "hv",
        chars: "ƕ"
      },
      {
        base: "i",
        chars: "ⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı"
      },
      {
        base: "j",
        chars: "ⓙｊĵǰɉ"
      },
      {
        base: "k",
        chars: "ⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ"
      },
      {
        base: "l",
        chars: "ⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇɭ"
      },
      {
        base: "lj",
        chars: "ǉ"
      },
      {
        base: "m",
        chars: "ⓜｍḿṁṃɱɯ"
      },
      {
        base: "n",
        chars: "ⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥлԉ"
      },
      {
        base: "nj",
        chars: "ǌ"
      },
      {
        base: "o",
        chars: "ⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿꝋꝍɵɔᴑ"
      },
      {
        base: "oe",
        chars: "œ"
      },
      {
        base: "oi",
        chars: "ƣ"
      },
      {
        base: "oo",
        chars: "ꝏ"
      },
      {
        base: "ou",
        chars: "ȣ"
      },
      {
        base: "p",
        chars: "ⓟｐṕṗƥᵽꝑꝓꝕρ"
      },
      {
        base: "q",
        chars: "ⓠｑɋꝗꝙ"
      },
      {
        base: "r",
        chars: "ⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ"
      },
      {
        base: "s",
        chars: "ⓢｓśṥŝṡšṧṣṩșşȿꞩꞅẛʂ"
      },
      {
        base: "ss",
        chars: "ß"
      },
      {
        base: "t",
        chars: "ⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ"
      },
      {
        base: "th",
        chars: "þ"
      },
      {
        base: "tz",
        chars: "ꜩ"
      },
      {
        base: "u",
        chars: "ⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ"
      },
      {
        base: "v",
        chars: "ⓥｖṽṿʋꝟʌ"
      },
      {
        base: "vy",
        chars: "ꝡ"
      },
      {
        base: "w",
        chars: "ⓦｗẁẃŵẇẅẘẉⱳ"
      },
      {
        base: "x",
        chars: "ⓧｘẋẍ"
      },
      {
        base: "y",
        chars: "ⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ"
      },
      {
        base: "z",
        chars: "ⓩｚźẑżžẓẕƶȥɀⱬꝣ"
      }
    ], o = {};
    for (i = 0; i < t.length; i += 1)
      for (n = t[i].chars, s = 0; s < n.length; s += 1)
        o[n[s]] = t[i].base;
    var n, s, i;
    function r(l) {
      return l.replace(/[^\u0000-\u007e]/g, function(a) {
        return o[a] || a;
      });
    }
    e.replacementList = t, e.diacriticsMap = o;
  }
}), DA = Wl({
  "../../common/temp/node_modules/.pnpm/i18n-iso-countries@7.14.0/node_modules/i18n-iso-countries/index.js"(e) {
    var t = FA(), o = TA(), n = IA().remove, s = {}, i = {}, r = {}, l = {}, a = {};
    t.forEach(function(x) {
      const L = x;
      i[L[0]] = L[1], r[L[1]] = L[0], l[L[2]] = L[0], a[L[0]] = L[2];
    });
    function c(x) {
      return ("000" + (x || "")).slice(-3);
    }
    function d(x, L) {
      return Object.prototype.hasOwnProperty.call(x, L);
    }
    function u(x, L) {
      return Object.keys(x).reduce(function(A, R) {
        const P = x[R];
        return A[R] = L(P, R), A;
      }, {});
    }
    function h(x, L) {
      switch (x) {
        case "official":
          return Array.isArray(L) ? L[0] : L;
        case "all":
          return typeof L == "string" ? [L] : L;
        case "alias":
          return Array.isArray(L) ? L[1] || L[0] : L;
        default:
          throw new TypeError(
            "LocaleNameType must be one of these: all, official, alias!"
          );
      }
    }
    e.registerLocale = function(x) {
      if (!x.locale)
        throw new TypeError("Missing localeData.locale");
      if (!x.countries)
        throw new TypeError("Missing localeData.countries");
      s[x.locale] = x.countries;
    };
    function p(x) {
      return r[x];
    }
    e.alpha3ToAlpha2 = p;
    function C(x) {
      return i[x];
    }
    e.alpha2ToAlpha3 = C;
    function m(x) {
      return a[p(x)];
    }
    e.alpha3ToNumeric = m;
    function w(x) {
      return a[x];
    }
    e.alpha2ToNumeric = w;
    function y(x) {
      const L = c(x);
      return C(l[L]);
    }
    e.numericToAlpha3 = y;
    function b(x) {
      const L = c(x);
      return l[L];
    }
    e.numericToAlpha2 = b;
    function _(x) {
      if (typeof x == "string") {
        if (/^[0-9]*$/.test(x))
          return y(x);
        if (x.length === 2)
          return C(x.toUpperCase());
        if (x.length === 3)
          return x.toUpperCase();
      }
      if (typeof x == "number")
        return y(x);
    }
    e.toAlpha3 = _;
    function M(x) {
      if (typeof x == "string") {
        if (/^[0-9]*$/.test(x))
          return b(x);
        if (x.length === 2)
          return x.toUpperCase();
        if (x.length === 3)
          return p(x.toUpperCase());
      }
      if (typeof x == "number")
        return b(x);
    }
    e.toAlpha2 = M, e.getName = function(x, L, A = {}) {
      "select" in A || (A.select = "official");
      try {
        const P = s[L.toLowerCase()][M(x)];
        return h(A.select, P);
      } catch {
        return;
      }
    }, e.getNames = function(x, L = {}) {
      "select" in L || (L.select = "official");
      const A = s[x.toLowerCase()];
      return A === void 0 ? {} : u(A, function(R) {
        return h(L.select, R);
      });
    }, e.getAlpha2Code = function(x, L) {
      const A = (P) => P.toLowerCase(), R = (P, I) => A(P) === A(I);
      try {
        const P = s[L.toLowerCase()];
        for (const I in P)
          if (d(P, I)) {
            if (typeof P[I] == "string" && R(P[I], x))
              return I;
            if (Array.isArray(P[I])) {
              for (const B of P[I])
                if (R(B, x))
                  return I;
            }
          }
        return;
      } catch {
        return;
      }
    }, e.getSimpleAlpha2Code = function(x, L) {
      const A = (P) => n(P.toLowerCase()), R = (P, I) => A(P) === A(I);
      try {
        const P = s[L.toLowerCase()];
        for (const I in P)
          if (d(P, I)) {
            if (typeof P[I] == "string" && R(P[I], x))
              return I;
            if (Array.isArray(P[I])) {
              for (const B of P[I])
                if (R(B, x))
                  return I;
            }
          }
        return;
      } catch {
        return;
      }
    }, e.getAlpha2Codes = function() {
      return i;
    }, e.getAlpha3Code = function(x, L) {
      const A = e.getAlpha2Code(x, L);
      if (A)
        return e.toAlpha3(A);
    }, e.getSimpleAlpha3Code = function(x, L) {
      const A = e.getSimpleAlpha2Code(x, L);
      if (A)
        return e.toAlpha3(A);
    }, e.getAlpha3Codes = function() {
      return r;
    }, e.getNumericCodes = function() {
      return l;
    }, e.langs = function() {
      return Object.keys(s);
    }, e.getSupportedLanguages = function() {
      return o;
    }, e.isValid = function(x) {
      if (!x)
        return !1;
      const L = x.toString().toUpperCase();
      return d(r, L) || d(i, L) || d(l, L);
    };
  }
}), kA = class {
  /**
   * Creates a new ErrorService instance
   *
   * @param logger - LoggerFactory instance for creating the error logger
   */
  constructor(e) {
    /** Logger instance for error reporting */
    _e(this, "logger");
    /**
     * Logs an error message and re-throws the error
     *
     * This method provides a centralized point for error handling that ensures
     * all errors are logged before being propagated. It supports both standard
     * Error objects and ContextAwareError objects.
     *
     * @param error - The error to log and throw (standard Error or ContextAwareError)
     * @throws The same error that was passed in, after logging
     *
     * @example
     * ```typescript
     * try {
     *   await apiCall();
     * } catch (error) {
     *   errorService.throwError(error); // Logs error message and re-throws
     * }
     * ```
     */
    _e(this, "throwError", (e) => {
      throw this.logger.error(e.message)(), e;
    });
    this.logger = e.getLogger("error");
  }
}, w1 = {
  log_raise_error: 1,
  log_with_warnings: 2,
  trace: 3,
  debug: 4,
  info: 5,
  warn: 6,
  error: 7,
  disable: 8
}, HA = class R7 {
  /**
   * Creates a new LoggerFactory with the specified configuration
   *
   * @param logLevel - Global logging level (defaults to "log_with_warnings")
   * @param mockConsole - Console implementation to use (defaults to window.console)
   * @throws Error if the provided logLevel is invalid
   */
  constructor(t = "log_with_warnings", o = null) {
    /**
     * Current global logging level that determines which messages are displayed
     */
    _e(this, "logLevel");
    /**
     * Console implementation used for actual output (allows for testing/mocking)
     */
    _e(this, "mockConsole");
    if (this.logLevel = t, !w1[t])
      throw Error(`Invalid log level ${t} allowed: ${JSON.stringify(w1)}`);
    o ? this.mockConsole = o : this.mockConsole = console;
  }
  /**
   * No-op function used when log messages are filtered out by level
   */
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  dummy() {
  }
  /**
   * Updates the global logging level for all loggers created by this factory
   *
   * @param logWarnings - New logging level to apply
   */
  setLogWarnings(t) {
    this.logLevel = t;
  }
  /**
   * Gets the current global logging level
   *
   * @returns The current LogLevel setting
   */
  getLogWarnings() {
    return this.logLevel;
  }
  /**
   * @return Single log function that can be called, e.g.
   * getSingleLogger(...)('hello wolrd')
   * @param name - badge string, that every log will be marked with
   * @param color - css color of badge, e.g. #FFFAAA
   * @param fn - binded function that will be called eventually, e.g.
   * console.log
   */
  getSingleLoggerColor(t, o, n) {
    return this.getSingleLoggerStyle(t, this.getColorStyle(o), n);
  }
  /**
   * @return Single log function that can be called, e.g.
   * getSingleLogger(...)('hello wolrd')
   * @param name - badge string, that every log will be marked with
   * @param fn - binded function that will be called eventually, e.g.
   * console.log
   */
  getSingleLogger(t, o) {
    const n = this.getRandomColor(t);
    return this.getSingleLoggerStyle(t, this.getColorStyle(n), o);
  }
  /**
   * @return Single log function that can be called, e.g.
   * getSingleLogger(...)('hello wolrd')
   * @param fn - binded function that will be called eventually, e.g.
   * console.log
   * @param name - badge string, that every log will be marked with
   * @param minLevel - initial logging level, .e.g 2
   * @param style - css style, e.g. `font-size: 10px; border-color: red`
   */
  getSingleLoggerStyle(t, o, n, s = "log_with_warnings") {
    return (...i) => {
      if (w1[this.logLevel] > w1[s])
        return this.dummy;
      const r = Array.prototype.slice.call(i), l = r.shift().split("{}"), a = [this.mockConsole, "%c" + t, o];
      for (let c = 0; c < l.length; c++)
        a.push(l[c]), typeof r[c] < "u" && a.push(r[c]);
      if (l.length - 1 !== r.length) {
        if (this.logLevel === "log_with_warnings")
          this.mockConsole.error("MissMatch amount of arguments");
        else if (this.logLevel === "log_raise_error")
          throw new Error("MissMatch amount of arguments");
      }
      return Function.prototype.bind.apply(n, a);
    };
  }
  /**
   * @return logger with badged tag
   * @param name - badge string, that every log will be marked with
   * @param color - css color of badge, e.g. #FFFAAA
   */
  getLoggerColor(t, o) {
    return this.getLoggerStyle(t, this.getColorStyle(o));
  }
  /**
   * @return css for badge
   * @param color - css color, e.g. #FFFAAA
   */
  getColorStyle(t) {
    return `color: white; background-color: ${t}; padding: 2px 6px; border-radius: 2px; font-size: 10px`;
  }
  /**
   * Hash function from https://stackoverflow.com/a/52171480/3872976
   */
  static getHash(t, o = 0) {
    let n = 3735928559 ^ o, s = 1103547991 ^ o;
    for (let i = 0, r; i < t.length; i++)
      r = t.charCodeAt(i), n = Math.imul(n ^ r, 2654435761), s = Math.imul(s ^ r, 1597334677);
    return n = Math.imul(n ^ n >>> 16, 2246822507) ^ Math.imul(s ^ s >>> 13, 3266489909), s = Math.imul(s ^ s >>> 16, 2246822507) ^ Math.imul(n ^ n >>> 13, 3266489909), 4294967296 * (2097151 & s) + (n >>> 0);
  }
  /**
   * Generates a random color based on the hash of the string
   **/
  getRandomColor(t = "") {
    const o = R7.getHash(t);
    let n = "#";
    for (let s = 0; s < 3; s++)
      n += ("00" + ((o >> s * 7 & 127) + 8).toString(16)).substr(-2);
    return n;
  }
  /**
   * @return a logger object with generated colored tag by hash of name
   * @param name - badge string, that every log will be marked with
   */
  getLogger(t) {
    return this.getLoggerColor(t, this.getRandomColor(t));
  }
  /**
   * @return a logger object
   * @param name - badge string, that every log will be marked with
   * @param style - css style, e.g. `font-size: 10px; border-color: red`
   */
  getLoggerStyle(t, o) {
    return {
      // eslint-disable-next-line @typescript-eslint/unbound-method
      trace: this.getSingleLoggerStyle(t, o, this.mockConsole.trace, "trace"),
      // eslint-disable-next-line @typescript-eslint/unbound-method
      debug: this.getSingleLoggerStyle(t, o, this.mockConsole.debug, "debug"),
      // eslint-disable-next-line @typescript-eslint/unbound-method
      log: this.getSingleLoggerStyle(t, o, this.mockConsole.log, "info"),
      // eslint-disable-next-line @typescript-eslint/unbound-method
      warn: this.getSingleLoggerStyle(t, o, this.mockConsole.warn, "warn"),
      // eslint-disable-next-line @typescript-eslint/unbound-method
      error: this.getSingleLoggerStyle(t, o, this.mockConsole.error, "error")
    };
  }
}, F7 = new HA("debug"), VA = new kA(F7);
function U5(e) {
  return F7.getLogger(e);
}
function OA() {
  return VA;
}
function dl(e, t) {
  const { placeholder: o = "?", charCount: n = 2 } = t ?? {};
  if (!e) return o;
  const s = e.trim().split(/\s+/).map((a) => [...a]), i = new Array(s.length).fill("");
  let r = 0, l = s.reduce((a, c) => a + c.length, 0);
  for (; i.join("").length < n && l > 0; ) {
    for (; s[r].length === 0; )
      r = (r + 1) % s.length;
    i[r] += s[r].shift(), l--, r = (r + 1) % s.length;
  }
  return i.join("").toUpperCase();
}
var B0 = RA(DA()), BA = {
  locale: "de",
  countries: {
    AF: "Afghanistan",
    EG: "Ägypten",
    AX: "Åland",
    AL: "Albanien",
    DZ: "Algerien",
    AS: "Amerikanisch-Samoa",
    VI: "Amerikanische Jungferninseln",
    AD: "Andorra",
    AO: "Angola",
    AI: "Anguilla",
    AQ: "Antarktis",
    AG: "Antigua und Barbuda",
    GQ: "Äquatorialguinea",
    AR: "Argentinien",
    AM: "Armenien",
    AW: "Aruba",
    AZ: "Aserbaidschan",
    ET: "Äthiopien",
    AU: "Australien",
    BS: "Bahamas",
    BH: "Bahrain",
    BD: "Bangladesch",
    BB: "Barbados",
    BY: "Belarus",
    BE: "Belgien",
    BZ: "Belize",
    BJ: "Benin",
    BM: "Bermuda",
    BT: "Bhutan",
    BO: "Bolivien",
    BQ: "Bonaire",
    BA: "Bosnien und Herzegowina",
    BW: "Botswana",
    BV: "Bouvetinsel",
    BR: "Brasilien",
    VG: "Britische Jungferninseln",
    IO: "Britisches Territorium im Indischen Ozean",
    BN: "Brunei Darussalam",
    BG: "Bulgarien",
    BF: "Burkina Faso",
    BI: "Burundi",
    CL: "Chile",
    CN: "China",
    CK: "Cookinseln",
    CR: "Costa Rica",
    CI: "Elfenbeinküste",
    CW: "Curaçao",
    DK: "Dänemark",
    DE: "Deutschland",
    DM: "Dominica",
    DO: "Dominikanische Republik",
    DJ: "Dschibuti",
    EC: "Ecuador",
    SV: "El Salvador",
    ER: "Eritrea",
    EE: "Estland",
    FK: "Falklandinseln",
    FO: "Färöer",
    FJ: "Fidschi",
    FI: "Finnland",
    FR: "Frankreich",
    GF: "Französisch-Guayana",
    PF: "Französisch-Polynesien",
    TF: "Französische Süd- und Antarktisgebiete",
    GA: "Gabun",
    GM: "Gambia",
    GE: "Georgien",
    GH: "Ghana",
    GI: "Gibraltar",
    GD: "Grenada",
    GR: "Griechenland",
    GL: "Grönland",
    GP: "Guadeloupe",
    GU: "Guam",
    GT: "Guatemala",
    GG: "Guernsey",
    GN: "Guinea",
    GW: "Guinea-Bissau",
    GY: "Guyana",
    HT: "Haiti",
    HM: "Heard und McDonaldinseln",
    HN: "Honduras",
    HK: ["Hongkong", "Hong Kong"],
    IN: "Indien",
    ID: "Indonesien",
    IM: "Insel Man",
    IQ: "Irak",
    IR: "Iran",
    IE: "Irland",
    IS: "Island",
    IL: "Israel",
    IT: "Italien",
    JM: "Jamaika",
    JP: "Japan",
    YE: "Jemen",
    JE: "Jersey",
    JO: "Jordanien",
    KY: "Kaimaninseln",
    KH: "Kambodscha",
    CM: "Kamerun",
    CA: "Kanada",
    CV: "Kap Verde",
    KZ: "Kasachstan",
    QA: "Katar",
    KE: "Kenia",
    KG: "Kirgisistan",
    KI: "Kiribati",
    CC: "Kokosinseln",
    CO: "Kolumbien",
    KM: "Komoren",
    CD: "Kongo",
    KP: "Nordkorea",
    KR: "Südkorea",
    HR: "Kroatien",
    CU: "Kuba",
    KW: "Kuwait",
    LA: "Laos",
    LS: "Lesotho",
    LV: "Lettland",
    LB: "Libanon",
    LR: "Liberia",
    LY: "Libyen",
    LI: "Liechtenstein",
    LT: "Litauen",
    LU: "Luxemburg",
    MO: "Macao",
    MG: "Madagaskar",
    MW: "Malawi",
    MY: "Malaysia",
    MV: "Malediven",
    ML: "Mali",
    MT: "Malta",
    MA: "Marokko",
    MH: "Marshallinseln",
    MQ: "Martinique",
    MR: "Mauretanien",
    MU: "Mauritius",
    YT: "Mayotte",
    MX: "Mexiko",
    FM: "Mikronesien",
    MD: "Moldawien",
    MC: "Monaco",
    MN: "Mongolei",
    ME: "Montenegro",
    MS: "Montserrat",
    MZ: "Mosambik",
    MM: "Myanmar",
    NA: "Namibia",
    NR: "Nauru",
    NP: "Nepal",
    NC: "Neukaledonien",
    NZ: "Neuseeland",
    NI: "Nicaragua",
    NL: "Niederlande",
    NE: "Niger",
    NG: "Nigeria",
    NU: "Niue",
    MK: "Nordmazedonien",
    MP: "Nördliche Marianen",
    NF: "Norfolkinsel",
    NO: "Norwegen",
    OM: "Oman",
    AT: "Österreich",
    TL: "Osttimor",
    PK: "Pakistan",
    PS: "Staat Palästina",
    PW: "Palau",
    PA: "Panama",
    PG: "Papua-Neuguinea",
    PY: "Paraguay",
    PE: "Peru",
    PH: "Philippinen",
    PN: "Pitcairninseln",
    PL: "Polen",
    PT: "Portugal",
    PR: "Puerto Rico",
    TW: "Taiwan",
    CG: "Republik Kongo",
    RE: "Réunion",
    RW: "Ruanda",
    RO: "Rumänien",
    RU: ["Russische Föderation", "Russland"],
    BL: "Saint-Barthélemy",
    MF: "Saint-Martin",
    SB: "Salomonen",
    ZM: "Sambia",
    WS: "Samoa",
    SM: "San Marino",
    ST: "São Tomé und Príncipe",
    SA: "Saudi-Arabien",
    SE: "Schweden",
    CH: "Schweiz",
    SN: "Senegal",
    RS: "Serbien",
    SC: "Seychellen",
    SL: "Sierra Leone",
    ZW: "Simbabwe",
    SG: "Singapur",
    SX: "Sint Maarten",
    SK: "Slowakei",
    SI: "Slowenien",
    SO: "Somalia",
    ES: "Spanien",
    LK: "Sri Lanka",
    SH: "St. Helena",
    KN: "St. Kitts und Nevis",
    LC: "St. Lucia",
    PM: "Saint-Pierre und Miquelon",
    VC: "St. Vincent und die Grenadinen",
    ZA: "Südafrika",
    SD: "Sudan",
    GS: "Südgeorgien und die Südlichen Sandwichinseln",
    SS: "Südsudan",
    SR: "Suriname",
    SJ: "Svalbard und Jan Mayen",
    SZ: "Eswatini",
    SY: "Syrien, Arabische Republik",
    TJ: "Tadschikistan",
    TZ: ["Tansania, Vereinigte Republik", "Tansania"],
    TH: "Thailand",
    TG: "Togo",
    TK: "Tokelau",
    TO: "Tonga",
    TT: "Trinidad und Tobago",
    TD: "Tschad",
    CZ: ["Tschechische Republik", "Tschechien"],
    TN: "Tunesien",
    TR: "Türkei",
    TM: "Turkmenistan",
    TC: "Turks- und Caicosinseln",
    TV: "Tuvalu",
    UG: "Uganda",
    UA: "Ukraine",
    HU: "Ungarn",
    UM: "United States Minor Outlying Islands",
    UY: "Uruguay",
    UZ: "Usbekistan",
    VU: "Vanuatu",
    VA: "Vatikanstadt",
    VE: "Venezuela",
    AE: "Vereinigte Arabische Emirate",
    US: ["Vereinigte Staaten von Amerika", "Vereinigte Staaten", "USA"],
    GB: ["Vereinigtes Königreich", "Großbritannien"],
    VN: "Vietnam",
    WF: "Wallis und Futuna",
    CX: "Weihnachtsinsel",
    EH: "Westsahara",
    CF: "Zentralafrikanische Republik",
    CY: "Zypern",
    XK: "Kosovo"
  }
}, T7 = {
  locale: "en",
  countries: {
    AF: "Afghanistan",
    AL: "Albania",
    DZ: "Algeria",
    AS: "American Samoa",
    AD: "Andorra",
    AO: "Angola",
    AI: "Anguilla",
    AQ: "Antarctica",
    AG: "Antigua and Barbuda",
    AR: "Argentina",
    AM: "Armenia",
    AW: "Aruba",
    AU: "Australia",
    AT: "Austria",
    AZ: "Azerbaijan",
    BS: "Bahamas",
    BH: "Bahrain",
    BD: "Bangladesh",
    BB: "Barbados",
    BY: "Belarus",
    BE: "Belgium",
    BZ: "Belize",
    BJ: "Benin",
    BM: "Bermuda",
    BT: "Bhutan",
    BO: "Bolivia",
    BA: "Bosnia and Herzegovina",
    BW: "Botswana",
    BV: "Bouvet Island",
    BR: "Brazil",
    IO: "British Indian Ocean Territory",
    BN: "Brunei Darussalam",
    BG: "Bulgaria",
    BF: "Burkina Faso",
    BI: "Burundi",
    KH: "Cambodia",
    CM: "Cameroon",
    CA: "Canada",
    CV: "Cape Verde",
    KY: "Cayman Islands",
    CF: "Central African Republic",
    TD: "Chad",
    CL: "Chile",
    CN: ["People's Republic of China", "China"],
    CX: "Christmas Island",
    CC: "Cocos (Keeling) Islands",
    CO: "Colombia",
    KM: "Comoros",
    CG: ["Republic of the Congo", "Congo"],
    CD: ["Democratic Republic of the Congo", "Congo"],
    CK: "Cook Islands",
    CR: "Costa Rica",
    CI: ["Cote d'Ivoire", "Côte d'Ivoire", "Ivory Coast"],
    HR: "Croatia",
    CU: "Cuba",
    CY: "Cyprus",
    CZ: ["Czech Republic", "Czechia"],
    DK: "Denmark",
    DJ: "Djibouti",
    DM: "Dominica",
    DO: "Dominican Republic",
    EC: "Ecuador",
    EG: "Egypt",
    SV: "El Salvador",
    GQ: "Equatorial Guinea",
    ER: "Eritrea",
    EE: "Estonia",
    ET: "Ethiopia",
    FK: "Falkland Islands (Malvinas)",
    FO: "Faroe Islands",
    FJ: "Fiji",
    FI: "Finland",
    FR: "France",
    GF: "French Guiana",
    PF: "French Polynesia",
    TF: "French Southern Territories",
    GA: "Gabon",
    GM: ["Republic of The Gambia", "The Gambia", "Gambia"],
    GE: "Georgia",
    DE: "Germany",
    GH: "Ghana",
    GI: "Gibraltar",
    GR: "Greece",
    GL: "Greenland",
    GD: "Grenada",
    GP: "Guadeloupe",
    GU: "Guam",
    GT: "Guatemala",
    GN: "Guinea",
    GW: "Guinea-Bissau",
    GY: "Guyana",
    HT: "Haiti",
    HM: "Heard Island and McDonald Islands",
    VA: "Holy See (Vatican City State)",
    HN: "Honduras",
    HK: "Hong Kong",
    HU: "Hungary",
    IS: "Iceland",
    IN: "India",
    ID: "Indonesia",
    IR: ["Islamic Republic of Iran", "Iran"],
    IQ: "Iraq",
    IE: "Ireland",
    IL: "Israel",
    IT: "Italy",
    JM: "Jamaica",
    JP: "Japan",
    JO: "Jordan",
    KZ: "Kazakhstan",
    KE: "Kenya",
    KI: "Kiribati",
    KP: "North Korea",
    KR: ["South Korea", "Korea, Republic of", "Republic of Korea"],
    KW: "Kuwait",
    KG: "Kyrgyzstan",
    LA: "Lao People's Democratic Republic",
    LV: "Latvia",
    LB: "Lebanon",
    LS: "Lesotho",
    LR: "Liberia",
    LY: "Libya",
    LI: "Liechtenstein",
    LT: "Lithuania",
    LU: "Luxembourg",
    MO: "Macao",
    MG: "Madagascar",
    MW: "Malawi",
    MY: "Malaysia",
    MV: "Maldives",
    ML: "Mali",
    MT: "Malta",
    MH: "Marshall Islands",
    MQ: "Martinique",
    MR: "Mauritania",
    MU: "Mauritius",
    YT: "Mayotte",
    MX: "Mexico",
    FM: "Micronesia, Federated States of",
    MD: "Moldova, Republic of",
    MC: "Monaco",
    MN: "Mongolia",
    MS: "Montserrat",
    MA: "Morocco",
    MZ: "Mozambique",
    MM: "Myanmar",
    NA: "Namibia",
    NR: "Nauru",
    NP: "Nepal",
    NL: ["Netherlands", "The Netherlands", "Netherlands (Kingdom of the)"],
    NC: "New Caledonia",
    NZ: "New Zealand",
    NI: "Nicaragua",
    NE: "Niger",
    NG: "Nigeria",
    NU: "Niue",
    NF: "Norfolk Island",
    MK: ["The Republic of North Macedonia", "North Macedonia"],
    MP: "Northern Mariana Islands",
    NO: "Norway",
    OM: "Oman",
    PK: "Pakistan",
    PW: "Palau",
    PS: ["State of Palestine", "Palestine"],
    PA: "Panama",
    PG: "Papua New Guinea",
    PY: "Paraguay",
    PE: "Peru",
    PH: "Philippines",
    PN: ["Pitcairn", "Pitcairn Islands"],
    PL: "Poland",
    PT: "Portugal",
    PR: "Puerto Rico",
    QA: "Qatar",
    RE: "Reunion",
    RO: "Romania",
    RU: ["Russian Federation", "Russia"],
    RW: "Rwanda",
    SH: "Saint Helena",
    KN: "Saint Kitts and Nevis",
    LC: "Saint Lucia",
    PM: "Saint Pierre and Miquelon",
    VC: "Saint Vincent and the Grenadines",
    WS: "Samoa",
    SM: "San Marino",
    ST: "Sao Tome and Principe",
    SA: "Saudi Arabia",
    SN: "Senegal",
    SC: "Seychelles",
    SL: "Sierra Leone",
    SG: "Singapore",
    SK: "Slovakia",
    SI: "Slovenia",
    SB: "Solomon Islands",
    SO: "Somalia",
    ZA: "South Africa",
    GS: "South Georgia and the South Sandwich Islands",
    ES: "Spain",
    LK: "Sri Lanka",
    SD: "Sudan",
    SR: "Suriname",
    SJ: "Svalbard and Jan Mayen",
    SZ: "Eswatini",
    SE: "Sweden",
    CH: "Switzerland",
    SY: "Syrian Arab Republic",
    TW: ["Taiwan, Province of China", "Taiwan"],
    TJ: "Tajikistan",
    TZ: ["United Republic of Tanzania", "Tanzania"],
    TH: "Thailand",
    TL: "Timor-Leste",
    TG: "Togo",
    TK: "Tokelau",
    TO: "Tonga",
    TT: "Trinidad and Tobago",
    TN: "Tunisia",
    TR: ["Türkiye", "Turkey"],
    TM: "Turkmenistan",
    TC: "Turks and Caicos Islands",
    TV: "Tuvalu",
    UG: "Uganda",
    UA: "Ukraine",
    AE: ["United Arab Emirates", "UAE"],
    GB: ["United Kingdom", "UK", "Great Britain"],
    US: ["United States of America", "United States", "USA", "U.S.A.", "US", "U.S."],
    UM: "United States Minor Outlying Islands",
    UY: "Uruguay",
    UZ: "Uzbekistan",
    VU: "Vanuatu",
    VE: "Venezuela",
    VN: "Vietnam",
    VG: "Virgin Islands, British",
    VI: "Virgin Islands, U.S.",
    WF: "Wallis and Futuna",
    EH: "Western Sahara",
    YE: "Yemen",
    ZM: "Zambia",
    ZW: "Zimbabwe",
    AX: ["Åland Islands", "Aland Islands"],
    BQ: "Bonaire, Sint Eustatius and Saba",
    CW: "Curaçao",
    GG: "Guernsey",
    IM: "Isle of Man",
    JE: "Jersey",
    ME: "Montenegro",
    BL: "Saint Barthélemy",
    MF: "Saint Martin (French part)",
    RS: "Serbia",
    SX: "Sint Maarten (Dutch part)",
    SS: "South Sudan",
    XK: "Kosovo"
  }
}, $A = T7.locale;
for (const e of [T7, BA])
  B0.default.registerLocale(e);
function ZA(e) {
  const t = B0.default.getNames(e);
  return Object.keys(t).length > 0 ? t : B0.default.getNames($A);
}
function GA(e) {
  return Object.entries(ZA(e)).map(([t, o]) => ({ id: t, label: o }));
}
var NA = {
  common: {
    validation: {
      empty: "Dieses Feld kann nicht leer sein.",
      fieldRequired: "Dieses Feld darf nicht leer sein.",
      containLeast: "Dieses Feld benötigt mindestens {length} Zeichen.",
      labelRequired: "{label} darf nicht leer sein."
    },
    label: {
      fieldNeedsValid: "Dieses Feld benötigt eine gültige URL.",
      fieldNeedsValid2: "Dieses Feld benötigt eine gültige E-Mail Adresse.",
      welcomeApp: "Willkommen zu unserer Applikation"
    },
    message: {
      paramCompletedSuccess: "{action} erfolgreich abgeschlossen.",
      paramError: "Fehler: {error}"
    }
  }
}, zA = {
  common: {
    validation: {
      empty: "Field can not be empty.",
      fieldRequired: "Field can't be empty.",
      containLeast: "Field must contain at least {length} characters.",
      labelRequired: "{label} can't be empty."
    },
    label: {
      fieldNeedsValid: "Field needs to be a valid URI.",
      fieldNeedsValid2: "Field needs to be a valid email address.",
      welcomeApp: "Welcome to our app"
    },
    message: {
      paramCompletedSuccess: "{action} completed successfully.",
      paramError: "Error: {error}"
    }
  }
}, I7 = h7({
  legacy: !1,
  locale: "en",
  fallbackLocale: "en",
  messages: { de: NA, en: zA },
  missingWarn: !1,
  fallbackWarn: !1
}), K5 = (e, t) => I7.global.t(e, {}), jA = () => I7.global.locale.value;
function Ta(e) {
  return e.replace(/([.\-/ ])\1+/g, "$1").replace(/^[.\-/ ]+|[.\-/ ]+$/g, "");
}
function Ul(e, t) {
  return t === "yy" ? Ta(e.replace(/d+/g, "").replace(/M+/g, "")) : t === "mm" ? Ta(e.replace(/d+/g, "").replace(/y+/g, "")) : t === "yy_mm" ? Ta(e.replace(/d+/g, "")) : e;
}
var WA = { hh: 1, hh_mm: 2, hh_mm_ss: 3, hh_mm_ss_ms: 4 };
function q5(e, t) {
  var i;
  const o = t ? WA[t] : void 0;
  if (!o) return e;
  const n = ((i = /\s*a+$/.exec(e)) == null ? void 0 : i[0]) ?? "";
  let s = n ? e.slice(0, -n.length) : e;
  return o < 4 && (s = s.replace(/\.S+/, "")), o < 3 && (s = s.replace(/:s+/, "")), o < 2 && (s = s.replace(/:m+/, "")), s + n;
}
function Kl(e) {
  return e.toLowerCase().startsWith("de") ? KM : O5;
}
function UA(e) {
  if (e == null || e === "") return;
  const t = e instanceof Date ? e : new Date(e);
  return Number.isNaN(t.getTime()) ? void 0 : t;
}
function D7(e) {
  return Kl(e ?? jA());
}
function Y5(e, t, o = {}) {
  const n = UA(e);
  return n ? In(n, t, { locale: D7(o.locale) }) : "";
}
function Zc(e, t, o = {}) {
  const n = mM(e, t, /* @__PURE__ */ new Date(), { locale: D7(o.locale) });
  return V5(n) ? n : void 0;
}
function Q5(e, t, o = {}) {
  return Y5(e, Ul(t, o.precision), o);
}
function KA(e, t, o, n = {}) {
  const s = Ul(t, n.datePrecision), i = q5(o, n.timePrecision);
  return Y5(e, `${s}${n.separator ?? " "}${i}`, n);
}
function $0(e, t = 2) {
  if (e === 0) return "0 Bytes";
  const o = 1024, n = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"], s = Math.floor(Math.log(e) / Math.log(o));
  return `${parseFloat((e / Math.pow(o, s)).toFixed(t))} ${n[s]}`;
}
function qA(e, t) {
  const o = e.split("/"), n = o.length === 2 ? o[1] : o[0].replace(".", ""), s = t != null && t.includes(".") ? t.split(".").pop() ?? "" : "";
  return {
    ext: n,
    icon: YA(e) ?? QA(s || n)
  };
}
function YA(e) {
  const t = e.toLocaleLowerCase();
  if (t.startsWith("image/"))
    return t === "image/vnd.adobe.photoshop" ? "tetrisly/32-file-Icon-psd" : "phosphor/image-square";
  switch (t) {
    case "application/msword":
    case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
      return "tetrisly/32-file-icon-word";
    case "application/vnd.ms-excel":
    case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
    case "application/vnd.oasis.opendocument.spreadsheet":
      return "tetrisly/32-file-icon-excel";
    case "text/csv":
      return "tetrisly/32-file-icon-spreadsheet";
    case "application/pdf":
      return "tetrisly/32-file-icon-pdf";
    case "application/rtf":
    case "application/vnd.oasis.opendocument.text":
    case "text/html":
    case "text/markdown":
    case "text/plain":
      return "tetrisly/32-file-icon-document";
    case "application/gzip":
    case "application/vnd.rar":
    case "application/x-7z-compressed":
    case "application/x-rar-compressed":
    case "application/x-tar":
    case "application/x-zip-compressed":
    case "application/zip":
      return "tetrisly/32-file-icon-zip";
    case "application/x-photoshop":
      return "tetrisly/32-file-Icon-psd";
    case "application/x-figma":
      return "tetrisly/32-file-icon-figma";
    case "application/vnd.sketch":
    case "application/x-sketch":
      return "tetrisly/32-file-icon-sketch";
    default:
      return;
  }
}
function QA(e) {
  switch (e.toLocaleLowerCase()) {
    case "avif":
    case "bmp":
    case "gif":
    case "heic":
    case "jpeg":
    case "jpg":
    case "png":
    case "svg":
    case "svg+xml":
    case "tif":
    case "tiff":
    case "webp":
      return "phosphor/image-square";
    case "doc":
    case "docx":
      return "tetrisly/32-file-icon-word";
    case "xls":
    case "xlsx":
    case "ods":
      return "tetrisly/32-file-icon-excel";
    case "csv":
      return "tetrisly/32-file-icon-spreadsheet";
    case "pdf":
      return "tetrisly/32-file-icon-pdf";
    case "htm":
    case "html":
    case "md":
    case "odt":
    case "rtf":
    case "txt":
      return "tetrisly/32-file-icon-document";
    case "7z":
    case "gz":
    case "rar":
    case "tar":
    case "zip":
      return "tetrisly/32-file-icon-zip";
    case "psd":
      return "tetrisly/32-file-Icon-psd";
    case "sketch":
      return "tetrisly/32-file-icon-sketch";
    case "fig":
    case "jam":
      return "tetrisly/32-file-icon-figma";
    default:
      return "tetrisly/32-file-icon-file";
  }
}
async function JA(e) {
  var s;
  const t = (s = e.dataTransfer) == null ? void 0 : s.items;
  if (!t) return [];
  const o = [], n = async (i, r = "") => {
    if (i.isFile && await new Promise((l) => {
      i.file((a) => {
        o.push(new File([a], r + a.name, { type: a.type })), l();
      });
    }), i.isDirectory) {
      const l = i.createReader(), c = await (async () => {
        const d = [], u = () => new Promise((p) => {
          l.readEntries((C) => {
            p(C);
          });
        });
        let h = await u();
        for (; h.length > 0; )
          d.push(...h), h = await u();
        return d;
      })();
      await Promise.all(c.map((d) => n(d, r + i.name + "/")));
    }
  };
  return await Promise.all(
    Array.from(t).map(async (i) => {
      var l;
      const r = (l = i.webkitGetAsEntry) == null ? void 0 : l.call(i);
      r && await n(r);
    })
  ), o;
}
var Z0 = U5("core/runtimeData");
function XA(e) {
  try {
    if (typeof document > "u")
      return {};
    const t = document.querySelector(`script[type="application/json"][data-selector="${e}"]`);
    return t != null && t.textContent ? t.textContent.trim() === "// RUNTIME_CONFIGURATION" ? {} : JSON.parse(t.textContent) : {};
  } catch (t) {
    return Z0.error(`Couldn't read JSON data from ${e}`, t)(), {};
  }
}
function eL() {
  try {
    const e = XA("runtime-config");
    return Z0.debug("Runtime config was fetched from meta tag.", e)(), e;
  } catch (e) {
    return Z0.debug("Runtime config could not be fetched from meta tag.", e)(), {};
  }
}
function tL(e, t) {
  if (!t || !e) return [e];
  const o = t.trim().toLowerCase();
  if (!o) return [e];
  const n = Array.from(new Set(o.split(/\s+/).filter(Boolean)));
  if (!n.length) return [e];
  n.sort((c, d) => d.length - c.length);
  const s = (c) => c.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), i = n.map(s).join("|"), r = new RegExp(`(${i})`, "gi"), l = [];
  let a = 0;
  for (const c of e.matchAll(r)) {
    const d = c.index ?? 0, u = c[0];
    if (d > a) {
      const h = e.substring(a, d);
      h.length > 0 && l.push(h);
    }
    l.push({ highlight: u }), a = d + u.length;
  }
  if (a < e.length) {
    const c = e.substring(a);
    c.length > 0 && l.push(c);
  }
  return l.length ? l : [e];
}
function $o(e, t) {
  if (e == null)
    throw new N5(`Expected ${t} to be defined, but received ${e}`);
}
var G0 = W(/* @__PURE__ */ new Date()), b1 = 0, z1;
function k7() {
  const e = 6e4 - Date.now() % 6e4;
  z1 = setTimeout(() => {
    G0.value = /* @__PURE__ */ new Date(), k7();
  }, e);
}
function oL() {
  return b1 += 1, b1 === 1 && (G0.value = /* @__PURE__ */ new Date(), k7()), Yi(() => {
    b1 -= 1, b1 === 0 && z1 && (clearTimeout(z1), z1 = void 0);
  }), G0;
}
function nL(e) {
  return I5() ? (Yi(e), !0) : !1;
}
var Ia = /* @__PURE__ */ new WeakMap(), sL = (...e) => {
  var t;
  const o = e[0], n = (t = Bo()) == null ? void 0 : t.proxy;
  if (n == null && !Gl())
    throw new Error("injectLocal must be called in setup");
  return n && Ia.has(n) && o in Ia.get(n) ? Ia.get(n)[o] : n1(...e);
}, iL = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
var rL = Object.prototype.toString, lL = (e) => rL.call(e) === "[object Object]";
function aL(e, t) {
  var o;
  if (typeof e == "number")
    return e + t;
  const n = ((o = e.match(/^-?\d+\.?\d*/)) == null ? void 0 : o[0]) || "", s = e.slice(n.length), i = Number.parseFloat(n) + t;
  return Number.isNaN(i) ? e : i + s;
}
function yr(e) {
  return e.endsWith("rem") ? Number.parseFloat(e) * 16 : Number.parseFloat(e);
}
function Da(e) {
  return Array.isArray(e) ? e : [e];
}
function cL(e) {
  return Bo();
}
function dL(e, t = !0, o) {
  cL() ? At(e, o) : t ? e() : rt(e);
}
function uL(e, t, o) {
  return Me(
    e,
    t,
    {
      ...o,
      immediate: !0
    }
  );
}
var J5 = iL ? window : void 0;
function hL(e) {
  var t;
  const o = ke(e);
  return (t = o == null ? void 0 : o.$el) != null ? t : o;
}
function gL(...e) {
  const t = [], o = () => {
    t.forEach((l) => l()), t.length = 0;
  }, n = (l, a, c, d) => (l.addEventListener(a, c, d), () => l.removeEventListener(a, c, d)), s = F(() => {
    const l = Da(ke(e[0])).filter((a) => a != null);
    return l.every((a) => typeof a != "string") ? l : void 0;
  }), i = uL(
    () => {
      var l, a;
      return [
        (a = (l = s.value) == null ? void 0 : l.map((c) => hL(c))) != null ? a : [J5].filter((c) => c != null),
        Da(ke(s.value ? e[1] : e[0])),
        Da(k(s.value ? e[2] : e[1])),
        // @ts-expect-error - TypeScript gets the correct types, but somehow still complains
        ke(s.value ? e[3] : e[2])
      ];
    },
    ([l, a, c, d]) => {
      if (o(), !(l != null && l.length) || !(a != null && a.length) || !(c != null && c.length))
        return;
      const u = lL(d) ? { ...d } : d;
      t.push(
        ...l.flatMap(
          (h) => a.flatMap(
            (p) => c.map((C) => n(h, p, C, u))
          )
        )
      );
    },
    { flush: "post" }
  ), r = () => {
    i(), o();
  };
  return nL(o), r;
}
function pL() {
  const e = Je(!1), t = Bo();
  return t && At(() => {
    e.value = !0;
  }, t), e;
}
function fL(e) {
  const t = pL();
  return F(() => (t.value, !!e()));
}
var vL = Symbol("vueuse-ssr-width");
function H7() {
  const e = Gl() ? sL(vL, null) : null;
  return typeof e == "number" ? e : void 0;
}
function sr(e, t = {}) {
  const { window: o = J5, ssrWidth: n = H7() } = t, s = fL(() => o && "matchMedia" in o && typeof o.matchMedia == "function"), i = Je(typeof n == "number"), r = Je(), l = Je(!1), a = (c) => {
    l.value = c.matches;
  };
  return Nl(() => {
    if (i.value) {
      i.value = !s.value;
      const c = ke(e).split(",");
      l.value = c.some((d) => {
        const u = d.includes("not all"), h = d.match(/\(\s*min-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/), p = d.match(/\(\s*max-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/);
        let C = !!(h || p);
        return h && C && (C = n >= yr(h[1])), p && C && (C = n <= yr(p[1])), u ? !C : C;
      });
      return;
    }
    s.value && (r.value = o.matchMedia(ke(e)), l.value = r.value.matches);
  }), gL(r, "change", a, { passive: !0 }), F(() => l.value);
}
function mL(e, t = {}) {
  function o(p, C) {
    let m = ke(e[ke(p)]);
    return C != null && (m = aL(m, C)), typeof m == "number" && (m = `${m}px`), m;
  }
  const { window: n = J5, strategy: s = "min-width", ssrWidth: i = H7() } = t, r = typeof i == "number", l = r ? Je(!1) : { value: !0 };
  r && dL(() => l.value = !!n);
  function a(p, C) {
    return !l.value && r ? p === "min" ? i >= yr(C) : i <= yr(C) : n ? n.matchMedia(`(${p}-width: ${C})`).matches : !1;
  }
  const c = (p) => sr(() => `(min-width: ${o(p)})`, t), d = (p) => sr(() => `(max-width: ${o(p)})`, t), u = Object.keys(e).reduce((p, C) => (Object.defineProperty(p, C, {
    get: () => s === "min-width" ? c(C) : d(C),
    enumerable: !0,
    configurable: !0
  }), p), {});
  function h() {
    const p = Object.keys(e).map((C) => [C, u[C], yr(o(C))]).sort((C, m) => C[2] - m[2]);
    return F(() => p.filter(([, C]) => C.value).map(([C]) => C));
  }
  return Object.assign(u, {
    greaterOrEqual: c,
    smallerOrEqual: d,
    greater(p) {
      return sr(() => `(min-width: ${o(p, 0.1)})`, t);
    },
    smaller(p) {
      return sr(() => `(max-width: ${o(p, -0.1)})`, t);
    },
    between(p, C) {
      return sr(() => `(min-width: ${o(p)}) and (max-width: ${o(C, -0.1)})`, t);
    },
    isGreater(p) {
      return a("min", o(p, 0.1));
    },
    isGreaterOrEqual(p) {
      return a("min", o(p));
    },
    isSmaller(p) {
      return a("max", o(p, -0.1));
    },
    isSmallerOrEqual(p) {
      return a("max", o(p));
    },
    isInBetween(p, C) {
      return a("min", o(p)) && a("max", o(C, -0.1));
    },
    current: h,
    active() {
      const p = h();
      return F(() => p.value.length === 0 ? "" : p.value.at(s === "min-width" ? -1 : 0));
    }
  });
}
var CL = {
  /** Small mobile devices: 440px and up */
  sm: "440px",
  /** Large mobile devices: 600px and up */
  md: "600px",
  /** Small tablets: 760px and up */
  lg: "760px",
  /** Large tablets/small desktops: 1024px and up */
  xl: "1024px",
  /** Large desktops: 1400px and up */
  "2xl": "1400px"
}, wL = () => {
  const e = mL(CL), t = F(
    () => e.greaterOrEqual("2xl").value ? "DESKTOP" : e.between("lg", "2xl").value ? "TABLET" : "MOBILE"
    /* MOBILE */
  ), o = F(
    () => t.value === "DESKTOP"
    /* DESKTOP */
  ), n = F(() => e.greaterOrEqual("xl").value), s = F(
    () => t.value === "TABLET"
    /* TABLET */
  ), i = F(
    () => t.value === "MOBILE"
    /* MOBILE */
  );
  return {
    /** VueUse breakpoints instance for fine-grained breakpoint control */
    breakpoints: e,
    /** Reactive device category (DESKTOP, TABLET, or MOBILE) */
    currentDevice: t,
    /** Reactive boolean for desktop detection */
    isDesktop: o,
    /** Reactive boolean for XL+ screen detection */
    isAtLeastXL: n,
    /** Reactive boolean for tablet detection */
    isTablet: s,
    /** Reactive boolean for mobile detection */
    isMobile: i
  };
};
j5.withMessage(() => K5("common.validation.empty"), rA);
j5.withMessage(() => K5("common.label.fieldNeedsValid"), cA);
j5.withMessage(() => K5("common.label.fieldNeedsValid2"), sA);
var Ts = U5("core/config"), ka = eL(), Ha = {
  NODE_ENV: "development",
  VITE_APP_URL: "http://localhost:8080"
}, V7 = {
  nodeEnv: Eo("NODE_ENV", Ha),
  appUrl: Eo("VITE_APP_URL", Ha),
  scaylaApiUrl: Eo("VITE_APP_SCAYLA_API_URL", Ha, !0)
};
Ts.debug("baseConfig", V7)();
var Gc = {
  VITE_APP_OIDC_CLIENT_ID: void 0,
  VITE_APP_OIDC_AUTHORITY: void 0
}, ul = {
  VITE_APP_OIDC_CLIENT_ID: Eo("VITE_APP_OIDC_CLIENT_ID", Gc, !0),
  VITE_APP_OIDC_AUTHORITY: Eo("VITE_APP_OIDC_AUTHORITY", Gc, !0)
};
$o(ul.VITE_APP_OIDC_CLIENT_ID, "rawAuthConfig.VITE_APP_OIDC_CLIENT_ID");
$o(ul.VITE_APP_OIDC_AUTHORITY, "rawAuthConfig.VITE_APP_OIDC_AUTHORITY");
var N0 = {
  oidcClientId: ul.VITE_APP_OIDC_CLIENT_ID,
  oidcAuthority: ul.VITE_APP_OIDC_AUTHORITY
};
Ts.debug("authConfig", N0)();
var ir = {
  VITE_APP_SENTRY_ENABLED: "false"
}, Vo = {
  VITE_APP_SENTRY_ENABLED: B7("VITE_APP_SENTRY_ENABLED", ir, !0),
  VITE_APP_SENTRY_DSN: Eo("VITE_APP_SENTRY_DSN", ir),
  VITE_APP_SENTRY_ENVIRONMENT: Eo("VITE_APP_SENTRY_ENVIRONMENT", ir),
  VITE_APP_SENTRY_PROJECT_NAME: Eo("VITE_APP_SENTRY_PROJECT_NAME", ir),
  VITE_APP_SENTRY_VERSION: Eo("VITE_APP_SENTRY_VERSION", ir)
};
$o(Vo.VITE_APP_SENTRY_ENABLED, "rawSentryConfig.VITE_APP_SENTRY_ENABLED");
Vo.VITE_APP_SENTRY_ENABLED === !0 && ($o(Vo.VITE_APP_SENTRY_DSN, "VITE_APP_SENTRY_DSN"), $o(Vo.VITE_APP_SENTRY_ENVIRONMENT, "VITE_APP_SENTRY_ENVIRONMENT"), $o(Vo.VITE_APP_SENTRY_PROJECT_NAME, "VITE_APP_SENTRY_PROJECT_NAME"), $o(Vo.VITE_APP_SENTRY_VERSION, "VITE_APP_SENTRY_VERSION"));
var bL = {
  enabled: Vo.VITE_APP_SENTRY_ENABLED,
  dsn: Vo.VITE_APP_SENTRY_DSN,
  projectName: Vo.VITE_APP_SENTRY_PROJECT_NAME,
  env: Vo.VITE_APP_SENTRY_ENVIRONMENT,
  version: Vo.VITE_APP_SENTRY_VERSION
};
Ts.debug("sentryConfig", bL)();
var yL = {
  VITE_APP_SHOW_EMAIL_FEATURE: "false"
}, O7 = {
  VITE_APP_SHOW_EMAIL_FEATURE: B7("VITE_APP_SHOW_EMAIL_FEATURE", yL, !1)
};
O7.VITE_APP_SHOW_EMAIL_FEATURE;
Ts.debug("emailFeatureConfig", O7)();
var _L = {
  VITE_APP_AG_GRID_LICENSE: ""
}, SL = {
  VITE_APP_AG_GRID_LICENSE: Eo("VITE_APP_AG_GRID_LICENSE", _L)
};
$o(SL.VITE_APP_AG_GRID_LICENSE, "rawAgGridlicenseKey.VITE_APP_AG_GRID_LICENSE");
var xL = {
  VITE_APP_TINY_MCE_API_KEY: ""
}, ML = {
  VITE_APP_TINY_MCE_API_KEY: Eo("VITE_APP_TINY_MCE_API_KEY", xL)
}, X5 = {
  apiKey: ML.VITE_APP_TINY_MCE_API_KEY
};
function Eo(e, t, o = !1) {
  if (typeof e == "number") return;
  let n;
  if (t[e] !== void 0 && (Ts.debug("Checking for key in defaultConfig: ", e, t[e]), n = String(t[e])), Fa[e] !== void 0 && (Ts.debug("Checking for key in import.meta.env: ", e, Fa[e]), n = String(Fa[e])), ka[e] !== void 0 && (Ts.debug("Checking for key in dynamicRuntimeConfig: ", e, ka[e]), n = String(ka[e])), o && ($o(n, e), !n))
    throw new Error(`Missing required value for config variable "${e}"`);
  return n;
}
function B7(e, t, o = !1) {
  if (typeof e == "number") return;
  const n = Eo(e, t, o);
  let s;
  if (typeof n == "string" && (s = n.toLowerCase() === "true"), o && ($o(s, e), !s && typeof s != "boolean"))
    throw new Error(`Missing required value for config variable "${e}"`);
  if (typeof s != "boolean" && o)
    throw new Error(
      `Value for config variable "${e}" is required and expected to be a boolean or a string, is "${typeof s}"`
    );
  return s;
}
var e2 = V7.appUrl ?? "";
U5("core/oidc");
W5();
new URL("/oidc-callback", e2).toString();
new URL("/silent-renew.html", e2).toString();
new URL("/sign-out", e2).toString();
N0.oidcAuthority, N0.oidcClientId, typeof window < "u" && new SA({ store: window.localStorage });
const AL = {
  d: "day",
  M: "month",
  y: "year",
  H: "hours",
  h: "hours",
  m: "minutes",
  s: "seconds",
  S: "milliseconds",
  a: "meridiem"
}, LL = ["day", "month", "year"], EL = ["hours", "minutes", "seconds", "milliseconds"];
function PL(e, t) {
  const o = e === "hours" && t.startsWith("h");
  let n, s, i;
  return e === "meridiem" ? (n = 2, s = 0) : e === "milliseconds" ? (n = 3, s = 3) : e === "year" ? (n = t.length === 2 ? 2 : 4, s = n) : e === "month" && t.length >= 3 ? (i = t.length >= 4 ? "long" : "short", n = 2, s = 2) : (n = Math.min(t.length, 2), s = 2), { kind: "section", type: e, token: t, padLength: n, maxDigits: s, twelveHour: o, monthStyle: i };
}
function $7(e) {
  const t = [], o = (s) => {
    if (!s) return;
    const i = t[t.length - 1];
    (i == null ? void 0 : i.kind) === "literal" ? i.text += s : t.push({ kind: "literal", text: s });
  };
  let n = 0;
  for (; n < e.length; ) {
    const s = e[n];
    if (s === "'") {
      let l = n + 1, a = "";
      for (; l < e.length; ) {
        if (e[l] === "'") {
          if (e[l + 1] === "'") {
            a += "'", l += 2;
            continue;
          }
          break;
        }
        a += e[l], l += 1;
      }
      o(a || "'"), n = l + 1;
      continue;
    }
    const i = AL[s];
    if (!i) {
      o(s), n += 1;
      continue;
    }
    let r = n;
    for (; r < e.length && e[r] === s; ) r += 1;
    t.push(PL(i, e.slice(n, r))), n = r;
  }
  return t;
}
function Z7(e) {
  return e.filter((t) => t.kind === "section");
}
function rr(e, t = {}) {
  switch (e.type) {
    case "day": {
      const o = t.month ?? null;
      return o == null ? { min: 1, max: 31 } : { min: 1, max: bx(new Date(t.year ?? 2e3, o - 1)) };
    }
    case "month":
      return { min: 1, max: 12 };
    case "year":
      return e.maxDigits === 2 ? { min: 0, max: 99 } : { min: 1, max: 9999 };
    case "hours":
      return e.twelveHour ? { min: 1, max: 12 } : { min: 0, max: 23 };
    case "minutes":
    case "seconds":
      return { min: 0, max: 59 };
    case "milliseconds":
      return { min: 0, max: 999 };
    case "meridiem":
      return { min: 0, max: 1 };
  }
}
function RL(e, t, o, n, s) {
  const i = t > 0 && t < s && e != null;
  let r = (i ? e : 0) * 10 + o, l = i ? t + 1 : 1;
  r > n.max && (r = o, l = 1);
  const a = l >= s || r * 10 > n.max;
  return { value: r, typed: l, complete: a };
}
function FL(e, t, o) {
  if (e == null) return t > 0 ? o.min : o.max;
  const n = o.max - o.min + 1;
  return o.min + ((e - o.min + t) % n + n) % n;
}
function TL(e, t) {
  return Math.min(t.max, Math.max(t.min, e));
}
function G7(e) {
  return e + (e >= 69 ? 1900 : 2e3);
}
function Nc(e, t) {
  const o = e.map((d) => d.type), n = o.filter((d) => LL.includes(d)), s = EL.filter((d) => o.includes(d)), i = n.filter((d) => t[d] != null).length, r = s.map((d) => t[d] != null), l = o.includes("meridiem") && t.meridiem != null;
  if (!(i > 0 || r.some(Boolean) || l)) return "empty";
  if (i < n.length) return "partial";
  const c = r.indexOf(!1);
  return c !== -1 && r.slice(c).some(Boolean) || s.includes("hours") && t.hours == null && l || n.length === 0 && s.includes("hours") && t.hours == null ? "partial" : "complete";
}
function zc(e, t, o = {}) {
  const n = (m) => e.some((w) => w.type === m), s = n("year") || n("month") || n("day"), i = o.baseDate ?? /* @__PURE__ */ new Date();
  let r;
  t.year != null ? r = t.year < 100 ? G7(t.year) : t.year : r = i.getFullYear();
  const l = t.month ?? (s ? 1 : i.getMonth() + 1), a = t.day ?? (s ? 1 : i.getDate());
  let c = t.hours ?? 0;
  const d = e.find((m) => m.type === "hours");
  d != null && d.twelveHour && (c = c % 12 + (t.meridiem === 1 ? 12 : 0));
  const u = t.minutes ?? 0, h = t.seconds ?? 0, p = t.milliseconds ?? 0, C = new Date(r, l - 1, a, c, u, h, p);
  return r >= 0 && r < 100 && C.setFullYear(r), C.getFullYear() !== r || C.getMonth() !== l - 1 || C.getDate() !== a ? null : C;
}
function Va(e, t) {
  const o = {};
  for (const n of t)
    switch (n.type) {
      case "day":
        o.day = e.getDate();
        break;
      case "month":
        o.month = e.getMonth() + 1;
        break;
      case "year":
        o.year = n.maxDigits === 2 ? e.getFullYear() % 100 : e.getFullYear();
        break;
      case "hours": {
        const s = e.getHours();
        o.hours = n.twelveHour ? s % 12 || 12 : s, n.twelveHour && (o.meridiem = s >= 12 ? 1 : 0);
        break;
      }
      case "minutes":
        o.minutes = e.getMinutes();
        break;
      case "seconds":
        o.seconds = e.getSeconds();
        break;
      case "milliseconds":
        o.milliseconds = e.getMilliseconds();
        break;
      case "meridiem":
        o.meridiem = e.getHours() >= 12 ? 1 : 0;
        break;
    }
  return o;
}
function IL(e, t, o) {
  return e.type === "meridiem" ? t === 1 ? "PM" : "AM" : e.type === "month" && e.monthStyle && o ? o[t - 1] ?? String(t).padStart(e.padLength, "0") : String(t).padStart(e.padLength, "0");
}
function jc(e) {
  return e.normalize("NFD").replace(new RegExp("\\p{Diacritic}", "gu"), "").toLowerCase();
}
function Wc(e, t) {
  const o = jc(e.trim());
  if (!o) return null;
  const n = [];
  return t.forEach((s, i) => {
    jc(s).startsWith(o) && n.push(i + 1);
  }), n.length === 0 ? null : { month: n[0], complete: n.length === 1 };
}
const DL = ["test-id"], kL = ["tabindex", "readonly", "aria-label", "aria-valuemin", "aria-valuemax", "aria-valuenow", "aria-valuetext", "aria-invalid", "test-id", "inputmode", "onFocus", "onKeydown"], HL = /* @__PURE__ */ pe({
  __name: "SCADatetimeInputInline",
  props: /* @__PURE__ */ Ct({
    format: {},
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    testId: { default: void 0 }
  }, {
    modelValue: { default: null },
    modelModifiers: {},
    invalid: { type: Boolean, default: !1 },
    invalidModifiers: {}
  }),
  emits: /* @__PURE__ */ Ct(["next", "prev"], ["update:modelValue", "update:invalid"]),
  setup(e, { expose: t, emit: o }) {
    const n = e, s = ct(e, "modelValue"), i = ct(e, "invalid"), r = o, { t: l, locale: a } = Go(), c = F(() => $7(n.format)), d = F(() => Z7(c.value)), u = F(() => d.value.some((V) => V.type === "meridiem")), h = F(() => Kl(a.value));
    function p(V) {
      return Array.from(
        { length: 12 },
        (Q, ye) => In(new Date(2e3, ye, 1), V, { locale: h.value })
      );
    }
    const C = F(() => p("MMMM")), m = F(() => p("MMM"));
    function w(V) {
      return V === "long" ? C.value : m.value;
    }
    const y = W({}), b = W(0), _ = W(""), M = W(null), x = W(), L = /* @__PURE__ */ new Map();
    function A(V, Q) {
      Q ? L.set(V, Q) : L.delete(V);
    }
    const R = [
      "day",
      "month",
      "year",
      "hours",
      "minutes",
      "seconds",
      "milliseconds",
      "meridiem"
    ];
    function P(V, Q) {
      return R.every((ye) => (V[ye] ?? null) === (Q[ye] ?? null));
    }
    let I;
    function B(V) {
      I = (V == null ? void 0 : V.getTime()) ?? null, s.value = V;
    }
    function H() {
      y.value = s.value ? Va(s.value, d.value) : {}, b.value = 0, _.value = "", i.value = !1, I = void 0;
    }
    Me(
      s,
      (V) => {
        if (((V == null ? void 0 : V.getTime()) ?? null) !== I && !(M.value !== null && (b.value > 0 || _.value !== ""))) {
          if (V && P(Va(V, d.value), y.value)) {
            I = void 0;
            return;
          }
          H();
        }
      },
      { immediate: !0 }
    ), Me(d, H);
    const O = F(() => d.value.every((V) => y.value[V.type] != null));
    function N() {
      if (O.value) {
        const V = zc(d.value, y.value);
        if (V) {
          i.value = !1, B(V);
          return;
        }
      }
      Nc(d.value, y.value) === "empty" && (i.value = !1), s.value !== null && B(null);
    }
    function te() {
      M.value = null, b.value = 0, _.value = "";
      const V = Nc(d.value, y.value);
      if (V === "empty") {
        i.value = !1, s.value !== null && B(null);
        return;
      }
      if (V === "complete") {
        const Q = zc(d.value, y.value);
        if (Q) {
          y.value = Va(Q, d.value), i.value = !1, B(Q);
          return;
        }
      }
      i.value = !0;
    }
    function E(V) {
      const Q = y.value[V.type];
      if (Q != null) {
        const ye = V.type === "month" && V.monthStyle ? w(V.monthStyle) : void 0;
        return IL(V, Q, ye);
      }
      return j(V);
    }
    function j(V) {
      return V.type === "meridiem" ? "AM" : V.type === "month" && V.monthStyle ? V.token : V.type === "day" || V.type === "month" || V.type === "year" ? l(`datetimePicker.sectionChars.${V.type}`).repeat(V.padLength) : V.token[0].repeat(V.padLength);
    }
    function Z(V, Q) {
      y.value = { ...y.value, [V]: Q };
    }
    function Y(V) {
      const Q = c.value[V];
      if ((Q == null ? void 0 : Q.kind) !== "section") return;
      const ye = y.value[Q.type];
      if (ye == null) return;
      const ae = rr(Q, y.value);
      let ie;
      Q.type === "year" && Q.maxDigits === 4 && ye > 0 && ye < 100 ? ie = G7(ye) : ie = TL(ye, ae), ie !== ye && (Z(Q.type, ie), N());
    }
    function le(V) {
      M.value !== null && M.value !== V && Y(M.value), M.value !== V && (b.value = 0, _.value = ""), M.value = V;
    }
    function ge(V) {
      var ye;
      const Q = V.relatedTarget;
      Q && ((ye = x.value) != null && ye.contains(Q)) || te();
    }
    function ce() {
      return c.value.flatMap((V, Q) => V.kind === "section" ? [Q] : []);
    }
    function G(V) {
      var Q;
      (Q = L.get(V)) == null || Q.focus();
    }
    function z(V, Q) {
      const ye = ce(), ae = ye.indexOf(V), ie = ye[ae + Q];
      ie !== void 0 ? G(ie) : r(Q === 1 ? "next" : "prev");
    }
    function oe() {
      const V = ce(), ye = V.find((ae) => {
        const ie = c.value[ae];
        return ie.kind === "section" && y.value[ie.type] == null;
      }) ?? V[0];
      ye !== void 0 && G(ye);
    }
    function q() {
      const V = ce(), Q = V[V.length - 1];
      Q !== void 0 && G(Q);
    }
    const ne = [".", ",", "/", "-", ":", " "];
    function Fe(V, Q, ye) {
      if (n.disabled || n.readonly) return;
      const ae = V.key;
      if (ae === "ArrowLeft" || ae === "ArrowRight") {
        V.preventDefault(), z(ye, ae === "ArrowRight" ? 1 : -1);
        return;
      }
      if (ae === "Home" || ae === "End") {
        V.preventDefault();
        const ie = ce();
        G(ae === "Home" ? ie[0] : ie[ie.length - 1]);
        return;
      }
      if (ae === "ArrowUp" || ae === "ArrowDown") {
        V.preventDefault();
        const ie = rr(Q, y.value);
        Z(Q.type, FL(y.value[Q.type] ?? null, ae === "ArrowUp" ? 1 : -1, ie)), b.value = 0, _.value = "", N();
        return;
      }
      if (ae === "Backspace" || ae === "Delete") {
        V.preventDefault(), Z(Q.type, null), b.value = 0, _.value = "", N();
        return;
      }
      if (/^[0-9]$/.test(ae)) {
        if (V.preventDefault(), Q.type === "meridiem") return;
        const ie = rr(Q, y.value), Oe = RL(
          y.value[Q.type] ?? null,
          b.value,
          Number(ae),
          ie,
          Q.maxDigits
        );
        Z(Q.type, Oe.value), b.value = Oe.typed, _.value = "", N(), Oe.complete && z(ye, 1);
        return;
      }
      if (Q.type === "month" && Q.monthStyle && new RegExp("^\\p{L}$", "u").test(ae)) {
        V.preventDefault();
        const ie = C.value, Oe = Wc(_.value + ae, ie), Dt = Oe ?? Wc(ae, ie);
        _.value = Oe ? _.value + ae : Dt ? ae : "", Dt && (Z("month", Dt.month), b.value = 0, N(), Dt.complete && z(ye, 1));
        return;
      }
      if (u.value && (ae === "a" || ae === "A" || ae === "p" || ae === "P")) {
        V.preventDefault(), Z("meridiem", ae === "a" || ae === "A" ? 0 : 1), N();
        return;
      }
      if (ne.includes(ae)) {
        V.preventDefault(), y.value[Q.type] != null && z(ye, 1);
        return;
      }
      ae.length === 1 && !V.ctrlKey && !V.metaKey && V.preventDefault();
    }
    function We(V) {
      return V.type === "meridiem" || V.type === "month" && V.monthStyle ? "text" : "numeric";
    }
    function Qe(V) {
      V.preventDefault();
      const Q = V.inputType.startsWith("delete") ? ["Backspace"] : [...V.data ?? ""];
      for (const ye of Q) {
        const ae = M.value, ie = ae === null ? void 0 : c.value[ae];
        if ((ie == null ? void 0 : ie.kind) !== "section" || ae === null) return;
        Fe(new KeyboardEvent("keydown", { key: ye }), ie, ae);
      }
    }
    function nt(V) {
      const Q = V.target;
      Q.value !== "" && (Q.value = "");
    }
    function ut(V) {
      n.disabled || V.target.closest('[role="spinbutton"]') || (V.preventDefault(), oe());
    }
    return t({ focus: oe, focusLast: q }), (V, Q) => (f(), v("div", {
      ref_key: "rootRef",
      ref: x,
      class: S([V.$style.root, { [V.$style.disabled]: e.disabled }]),
      role: "group",
      "test-id": e.testId,
      onFocusout: ge,
      onMousedown: ut
    }, [
      (f(!0), v(we, null, Ze(c.value, (ye, ae) => (f(), v(we, {
        key: `${e.format}-${ae}`
      }, [
        ye.kind === "literal" ? (f(), v("span", {
          key: 0,
          class: S(V.$style.literal),
          "aria-hidden": "true"
        }, se(ye.text), 3)) : (f(), v("span", {
          key: 1,
          class: S(V.$style.sectionWrap)
        }, [
          g("span", {
            class: S([V.$style.section, { [V.$style.empty]: y.value[ye.type] == null }]),
            "aria-hidden": "true"
          }, se(E(ye)), 3),
          g("input", {
            ref_for: !0,
            ref: (ie) => A(ae, ie),
            type: "text",
            role: "spinbutton",
            tabindex: e.disabled ? -1 : 0,
            readonly: e.disabled || e.readonly,
            class: S(V.$style.sectionInput),
            "aria-label": k(l)(`datetimePicker.sectionNames.${ye.type}`),
            "aria-valuemin": k(rr)(ye, y.value).min,
            "aria-valuemax": k(rr)(ye, y.value).max,
            "aria-valuenow": y.value[ye.type] ?? void 0,
            "aria-valuetext": ye.type === "month" && ye.monthStyle && y.value[ye.type] != null ? E(ye) : void 0,
            "aria-invalid": i.value || void 0,
            "test-id": `datetime-section-${ye.type}`,
            inputmode: We(ye),
            autocomplete: "off",
            onFocus: (ie) => le(ae),
            onKeydown: (ie) => Fe(ie, ye, ae),
            onBeforeinput: Q[0] || (Q[0] = (ie) => Qe(ie)),
            onInput: Q[1] || (Q[1] = (ie) => nt(ie))
          }, null, 42, kL)
        ], 2))
      ], 64))), 128))
    ], 42, DL));
  }
}), VL = "_root_s666o_1", OL = "_disabled_s666o_15", BL = "_sectionWrap_s666o_19", $L = "_section_s666o_19", ZL = "_empty_s666o_28", GL = "_sectionInput_s666o_32", NL = "_literal_s666o_47", zL = {
  root: VL,
  disabled: OL,
  sectionWrap: BL,
  section: $L,
  empty: ZL,
  sectionInput: GL,
  literal: NL
}, Ce = (e, t) => {
  const o = e.__vccOpts || e;
  for (const [n, s] of t)
    o[n] = s;
  return o;
}, jL = {
  $style: zL
}, Oa = /* @__PURE__ */ Ce(HL, [["__cssModules", jL]]), rs = Math.min, Ln = Math.max, hl = Math.round, y1 = Math.floor, En = (e) => ({
  x: e,
  y: e
}), WL = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function N7(e, t, o) {
  return Ln(e, rs(t, o));
}
function Xi(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function zs(e) {
  return e.split("-")[0];
}
function er(e) {
  return e.split("-")[1];
}
function z7(e) {
  return e === "x" ? "y" : "x";
}
function t2(e) {
  return e === "y" ? "height" : "width";
}
function Mn(e) {
  const t = e[0];
  return t === "t" || t === "b" ? "y" : "x";
}
function o2(e) {
  return z7(Mn(e));
}
function UL(e, t, o) {
  o === void 0 && (o = !1);
  const n = er(e), s = o2(e), i = t2(s);
  let r = s === "x" ? n === (o ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (r = gl(r)), [r, gl(r)];
}
function KL(e) {
  const t = gl(e);
  return [z0(e), t, z0(t)];
}
function z0(e) {
  return e.includes("start") ? e.replace("start", "end") : e.replace("end", "start");
}
const Uc = ["left", "right"], Kc = ["right", "left"], qL = ["top", "bottom"], YL = ["bottom", "top"];
function QL(e, t, o) {
  switch (e) {
    case "top":
    case "bottom":
      return o ? t ? Kc : Uc : t ? Uc : Kc;
    case "left":
    case "right":
      return t ? qL : YL;
    default:
      return [];
  }
}
function JL(e, t, o, n) {
  const s = er(e);
  let i = QL(zs(e), o === "start", n);
  return s && (i = i.map((r) => r + "-" + s), t && (i = i.concat(i.map(z0)))), i;
}
function gl(e) {
  const t = zs(e);
  return WL[t] + e.slice(t.length);
}
function XL(e) {
  var t, o, n, s;
  return {
    top: (t = e.top) != null ? t : 0,
    right: (o = e.right) != null ? o : 0,
    bottom: (n = e.bottom) != null ? n : 0,
    left: (s = e.left) != null ? s : 0
  };
}
function j7(e) {
  return typeof e != "number" ? XL(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function pl(e) {
  const {
    x: t,
    y: o,
    width: n,
    height: s
  } = e;
  return {
    width: n,
    height: s,
    top: o,
    left: t,
    right: t + n,
    bottom: o + s,
    x: t,
    y: o
  };
}
function qc(e, t, o) {
  let {
    reference: n,
    floating: s
  } = e;
  const i = Mn(t), r = o2(t), l = t2(r), a = zs(t), c = i === "y", d = n.x + n.width / 2 - s.width / 2, u = n.y + n.height / 2 - s.height / 2, h = n[l] / 2 - s[l] / 2;
  let p;
  switch (a) {
    case "top":
      p = {
        x: d,
        y: n.y - s.height
      };
      break;
    case "bottom":
      p = {
        x: d,
        y: n.y + n.height
      };
      break;
    case "right":
      p = {
        x: n.x + n.width,
        y: u
      };
      break;
    case "left":
      p = {
        x: n.x - s.width,
        y: u
      };
      break;
    default:
      p = {
        x: n.x,
        y: n.y
      };
  }
  const C = er(t);
  return C && (p[r] += h * (C === "end" ? 1 : -1) * (o && c ? -1 : 1)), p;
}
async function eE(e, t) {
  var o;
  t === void 0 && (t = {});
  const {
    x: n,
    y: s,
    platform: i,
    rects: r,
    elements: l,
    strategy: a
  } = e, {
    boundary: c = "clippingAncestors",
    rootBoundary: d = "viewport",
    elementContext: u = "floating",
    altBoundary: h = !1,
    padding: p = 0
  } = Xi(t, e), C = j7(p), w = l[h ? u === "floating" ? "reference" : "floating" : u], y = pl(await i.getClippingRect({
    element: (o = await (i.isElement == null ? void 0 : i.isElement(w))) == null || o ? w : w.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(l.floating)),
    boundary: c,
    rootBoundary: d,
    strategy: a
  })), b = u === "floating" ? {
    x: n,
    y: s,
    width: r.floating.width,
    height: r.floating.height
  } : r.reference, _ = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(l.floating)), M = await (i.isElement == null ? void 0 : i.isElement(_)) && await (i.getScale == null ? void 0 : i.getScale(_)) || {
    x: 1,
    y: 1
  }, x = pl(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: l,
    rect: b,
    offsetParent: _,
    strategy: a
  }) : b);
  return {
    top: (y.top - x.top + C.top) / M.y,
    bottom: (x.bottom - y.bottom + C.bottom) / M.y,
    left: (y.left - x.left + C.left) / M.x,
    right: (x.right - y.right + C.right) / M.x
  };
}
const tE = 50, oE = async (e, t, o) => {
  const {
    placement: n = "bottom",
    strategy: s = "absolute",
    middleware: i = [],
    platform: r
  } = o, l = r.detectOverflow ? r : {
    ...r,
    detectOverflow: eE
  }, a = await (r.isRTL == null ? void 0 : r.isRTL(t));
  let c = await r.getElementRects({
    reference: e,
    floating: t,
    strategy: s
  }), {
    x: d,
    y: u
  } = qc(c, n, a), h = n, p = 0;
  const C = {};
  for (let m = 0; m < i.length; m++) {
    const w = i[m];
    if (!w)
      continue;
    const {
      name: y,
      fn: b
    } = w, {
      x: _,
      y: M,
      data: x,
      reset: L
    } = await b({
      x: d,
      y: u,
      initialPlacement: n,
      placement: h,
      strategy: s,
      middlewareData: C,
      rects: c,
      platform: l,
      elements: {
        reference: e,
        floating: t
      }
    });
    d = _ ?? d, u = M ?? u, C[y] = {
      ...C[y],
      ...x
    }, L && p < tE && (p++, typeof L == "object" && (L.placement && (h = L.placement), L.rects && (c = L.rects === !0 ? await r.getElementRects({
      reference: e,
      floating: t,
      strategy: s
    }) : L.rects), {
      x: d,
      y: u
    } = qc(c, h, a)), m = -1);
  }
  return {
    x: d,
    y: u,
    placement: h,
    strategy: s,
    middlewareData: C
  };
}, nE = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: o,
      y: n,
      placement: s,
      rects: i,
      platform: r,
      elements: l,
      middlewareData: a
    } = t, {
      element: c,
      padding: d = 0
    } = Xi(e, t) || {};
    if (c == null)
      return {};
    const u = j7(d), h = {
      x: o,
      y: n
    }, p = o2(s), C = t2(p), m = await r.getDimensions(c), w = p === "y", y = w ? "top" : "left", b = w ? "bottom" : "right", _ = w ? "clientHeight" : "clientWidth", M = i.reference[C] + i.reference[p] - h[p] - i.floating[C], x = h[p] - i.reference[p], L = await (r.getOffsetParent == null ? void 0 : r.getOffsetParent(c));
    let A = L ? L[_] : 0;
    (!A || !await (r.isElement == null ? void 0 : r.isElement(L))) && (A = l.floating[_] || i.floating[C]);
    const R = M / 2 - x / 2, P = A / 2 - m[C] / 2 - 1, I = rs(u[y], P), B = rs(u[b], P), H = A - m[C] - B, O = A / 2 - m[C] / 2 + R, N = N7(I, O, H), te = !a.arrow && er(s) != null && O !== N && i.reference[C] / 2 - (O < I ? I : B) - m[C] / 2 < 0, E = te ? O < I ? O - I : O - H : 0;
    return {
      [p]: h[p] + E,
      data: {
        [p]: N,
        centerOffset: O - N - E,
        ...te && {
          alignmentOffset: E
        }
      },
      reset: te
    };
  }
}), sE = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var o, n;
      const {
        placement: s,
        middlewareData: i,
        rects: r,
        initialPlacement: l,
        platform: a,
        elements: c
      } = t, {
        mainAxis: d = !0,
        crossAxis: u = !0,
        fallbackPlacements: h,
        fallbackStrategy: p = "bestFit",
        fallbackAxisSideDirection: C = "none",
        flipAlignment: m = !0,
        ...w
      } = Xi(e, t);
      if ((o = i.arrow) != null && o.alignmentOffset)
        return {};
      const y = zs(s), b = Mn(l), _ = zs(l) === l, M = await (a.isRTL == null ? void 0 : a.isRTL(c.floating)), x = h || (_ || !m ? [gl(l)] : KL(l)), L = C !== "none";
      !h && L && x.push(...JL(l, m, C, M));
      const A = [l, ...x], R = await a.detectOverflow(t, w), P = [];
      let I = ((n = i.flip) == null ? void 0 : n.overflows) || [];
      if (d && P.push(R[y]), u) {
        const N = UL(s, r, M);
        P.push(R[N[0]], R[N[1]]);
      }
      if (I = [...I, {
        placement: s,
        overflows: P
      }], !P.every((N) => N <= 0)) {
        var B, H;
        const N = (((B = i.flip) == null ? void 0 : B.index) || 0) + 1, te = A[N];
        if (te && (!(u === "alignment" ? b !== Mn(te) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        I.every((Z) => Mn(Z.placement) === b ? Z.overflows[0] > 0 : !0)))
          return {
            data: {
              index: N,
              overflows: I
            },
            reset: {
              placement: te
            }
          };
        let E = (H = I.filter((j) => j.overflows[0] <= 0).sort((j, Z) => j.overflows[1] - Z.overflows[1])[0]) == null ? void 0 : H.placement;
        if (!E)
          switch (p) {
            case "bestFit": {
              var O;
              const j = (O = I.filter((Z) => {
                if (L) {
                  const Y = Mn(Z.placement);
                  return Y === b || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  Y === "y";
                }
                return !0;
              }).map((Z) => [Z.placement, Z.overflows.filter((Y) => Y > 0).reduce((Y, le) => Y + le, 0)]).sort((Z, Y) => Z[1] - Y[1])[0]) == null ? void 0 : O[0];
              j && (E = j);
              break;
            }
            case "initialPlacement":
              E = l;
              break;
          }
        if (s !== E)
          return {
            reset: {
              placement: E
            }
          };
      }
      return {};
    }
  };
}, iE = /* @__PURE__ */ new Set(["left", "top"]);
async function rE(e, t) {
  const {
    placement: o,
    platform: n,
    elements: s
  } = e, i = await (n.isRTL == null ? void 0 : n.isRTL(s.floating)), r = zs(o), l = er(o), a = Mn(o) === "y", c = iE.has(r) ? -1 : 1, d = i && a ? -1 : 1, u = Xi(t, e);
  let {
    mainAxis: h,
    crossAxis: p,
    alignmentAxis: C
  } = typeof u == "number" ? {
    mainAxis: u,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: u.mainAxis || 0,
    crossAxis: u.crossAxis || 0,
    alignmentAxis: u.alignmentAxis
  };
  return l && typeof C == "number" && (p = l === "end" ? C * -1 : C), a ? {
    x: p * d,
    y: h * c
  } : {
    x: h * c,
    y: p * d
  };
}
const lE = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var o, n;
      const {
        x: s,
        y: i,
        placement: r,
        middlewareData: l
      } = t, a = await rE(t, e);
      return r === ((o = l.offset) == null ? void 0 : o.placement) && (n = l.arrow) != null && n.alignmentOffset ? {} : {
        x: s + a.x,
        y: i + a.y,
        data: {
          ...a,
          placement: r
        }
      };
    }
  };
}, aE = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: o,
        y: n,
        placement: s,
        platform: i
      } = t, {
        mainAxis: r = !0,
        crossAxis: l = !1,
        limiter: a = {
          fn: (b) => {
            let {
              x: _,
              y: M
            } = b;
            return {
              x: _,
              y: M
            };
          }
        },
        ...c
      } = Xi(e, t), d = {
        x: o,
        y: n
      }, u = await i.detectOverflow(t, c), h = Mn(s), p = z7(h);
      let C = d[p], m = d[h];
      const w = (b, _) => N7(_ + u[b === "y" ? "top" : "left"], _, _ - u[b === "y" ? "bottom" : "right"]);
      r && (C = w(p, C)), l && (m = w(h, m));
      const y = a.fn({
        ...t,
        [p]: C,
        [h]: m
      });
      return {
        ...y,
        data: {
          x: y.x - o,
          y: y.y - n,
          enabled: {
            [p]: r,
            [h]: l
          }
        }
      };
    }
  };
}, cE = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      const {
        placement: o,
        rects: n,
        platform: s,
        elements: i
      } = t, {
        apply: r = () => {
        },
        ...l
      } = Xi(e, t), a = await s.detectOverflow(t, l), c = zs(o), d = er(o), u = Mn(o) === "y", {
        width: h,
        height: p
      } = n.floating;
      let C, m;
      c === "top" || c === "bottom" ? (C = c, m = d === (await (s.isRTL == null ? void 0 : s.isRTL(i.floating)) ? "start" : "end") ? "left" : "right") : (m = c, C = d === "end" ? "top" : "bottom");
      const w = p - a.top - a.bottom, y = h - a.left - a.right, b = rs(p - a[C], w), _ = rs(h - a[m], y), M = t.middlewareData.shift, x = !M;
      let L = b, A = _;
      M != null && M.enabled.x && (A = y), M != null && M.enabled.y && (L = w), x && !d && (u ? A = h - 2 * Ln(a.left, a.right) : L = p - 2 * Ln(a.top, a.bottom)), await r({
        ...t,
        availableWidth: A,
        availableHeight: L
      });
      const R = await s.getDimensions(i.floating);
      return h !== R.width || p !== R.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function ql() {
  return typeof window < "u";
}
function ti(e) {
  return n2(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function fo(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function On(e) {
  var t;
  return (t = (n2(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function n2(e) {
  return ql() ? e instanceof Node || e instanceof fo(e).Node : !1;
}
function dn(e) {
  return ql() ? e instanceof Element || e instanceof fo(e).Element : !1;
}
function us(e) {
  return ql() ? e instanceof HTMLElement || e instanceof fo(e).HTMLElement : !1;
}
function Yc(e) {
  return !ql() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof fo(e).ShadowRoot;
}
function Yl(e) {
  const {
    overflow: t,
    overflowX: o,
    overflowY: n,
    display: s
  } = un(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + n + o) && s !== "inline" && s !== "contents";
}
function dE(e) {
  return /^(table|td|th)$/.test(ti(e));
}
function Ql(e) {
  try {
    if (e.matches(":popover-open"))
      return !0;
  } catch {
  }
  try {
    return e.matches(":modal");
  } catch {
    return !1;
  }
}
const uE = /transform|translate|scale|rotate|perspective|filter/, hE = /paint|layout|strict|content/, ms = (e) => !!e && e !== "none";
let Ba;
function s2(e) {
  const t = dn(e) ? un(e) : e;
  return ms(t.transform) || ms(t.translate) || ms(t.scale) || ms(t.rotate) || ms(t.perspective) || !i2() && (ms(t.backdropFilter) || ms(t.filter)) || uE.test(t.willChange || "") || hE.test(t.contain || "");
}
function gE(e) {
  let t = js(e);
  for (; us(t) && !Or(t); ) {
    if (s2(t))
      return t;
    if (Ql(t))
      return null;
    t = js(t);
  }
  return null;
}
function i2() {
  return Ba == null && (Ba = typeof CSS < "u" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none")), Ba;
}
function Or(e) {
  return /^(html|body|#document)$/.test(ti(e));
}
function un(e) {
  return fo(e).getComputedStyle(e);
}
function Jl(e) {
  return dn(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function js(e) {
  if (ti(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Yc(e) && e.host || // Fallback.
    On(e)
  );
  return Yc(t) ? t.host : t;
}
function W7(e) {
  const t = js(e);
  return Or(t) ? (e.ownerDocument || e).body : us(t) && Yl(t) ? t : W7(t);
}
function Br(e, t, o) {
  var n;
  t === void 0 && (t = []), o === void 0 && (o = !0);
  const s = W7(e), i = s === ((n = e.ownerDocument) == null ? void 0 : n.body), r = fo(s);
  if (i) {
    const l = j0(r);
    return t.concat(r, r.visualViewport || [], Yl(s) ? s : [], l && o ? Br(l) : []);
  } else
    return t.concat(s, Br(s, [], o));
}
function j0(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function U7(e) {
  const t = un(e);
  let o = parseFloat(t.width) || 0, n = parseFloat(t.height) || 0;
  const s = us(e), i = s ? e.offsetWidth : o, r = s ? e.offsetHeight : n, l = hl(o) !== i || hl(n) !== r;
  return l && (o = i, n = r), {
    width: o,
    height: n,
    $: l
  };
}
function r2(e) {
  return dn(e) ? e : e.contextElement;
}
function xi(e) {
  const t = r2(e);
  if (!us(t))
    return En(1);
  const o = t.getBoundingClientRect(), {
    width: n,
    height: s,
    $: i
  } = U7(t);
  let r = (i ? hl(o.width) : o.width) / n, l = (i ? hl(o.height) : o.height) / s;
  return (!r || !Number.isFinite(r)) && (r = 1), (!l || !Number.isFinite(l)) && (l = 1), {
    x: r,
    y: l
  };
}
const pE = /* @__PURE__ */ En(0);
function K7(e) {
  const t = fo(e);
  return !i2() || !t.visualViewport ? pE : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function fE(e, t, o) {
  return t === void 0 && (t = !1), !!o && t && o === fo(e);
}
function Ws(e, t, o, n) {
  t === void 0 && (t = !1), o === void 0 && (o = !1);
  const s = e.getBoundingClientRect(), i = r2(e);
  let r = En(1);
  t && (n ? dn(n) && (r = xi(n)) : r = xi(e));
  const l = fE(i, o, n) ? K7(i) : En(0);
  let a = (s.left + l.x) / r.x, c = (s.top + l.y) / r.y, d = s.width / r.x, u = s.height / r.y;
  if (i && n) {
    const h = fo(i), p = dn(n) ? fo(n) : n;
    let C = h, m = j0(C);
    for (; m && p !== C; ) {
      const w = xi(m), y = m.getBoundingClientRect(), b = un(m), _ = y.left + (m.clientLeft + parseFloat(b.paddingLeft)) * w.x, M = y.top + (m.clientTop + parseFloat(b.paddingTop)) * w.y;
      a *= w.x, c *= w.y, d *= w.x, u *= w.y, a += _, c += M, C = fo(m), m = j0(C);
    }
  }
  return pl({
    width: d,
    height: u,
    x: a,
    y: c
  });
}
function Xl(e, t) {
  const o = Jl(e).scrollLeft;
  return t ? t.left + o : Ws(On(e)).left + o;
}
function q7(e, t) {
  const o = e.getBoundingClientRect(), n = o.left + t.scrollLeft - Xl(e, o), s = o.top + t.scrollTop;
  return {
    x: n,
    y: s
  };
}
function vE(e) {
  let {
    elements: t,
    rect: o,
    offsetParent: n,
    strategy: s
  } = e;
  const i = s === "fixed", r = On(n), l = t ? Ql(t.floating) : !1;
  if (n === r || l && i)
    return o;
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = En(1);
  const d = En(0), u = us(n);
  if ((u || !i) && ((ti(n) !== "body" || Yl(r)) && (a = Jl(n)), u)) {
    const p = Ws(n);
    c = xi(n), d.x = p.x + n.clientLeft, d.y = p.y + n.clientTop;
  }
  const h = r && !u && !i ? q7(r, a) : En(0);
  return {
    width: o.width * c.x,
    height: o.height * c.y,
    x: o.x * c.x - a.scrollLeft * c.x + d.x + h.x,
    y: o.y * c.y - a.scrollTop * c.y + d.y + h.y
  };
}
function mE(e) {
  return e.getClientRects ? Array.from(e.getClientRects()) : [];
}
function CE(e) {
  const t = Jl(e), o = e.ownerDocument.body, n = Ln(e.scrollWidth, e.clientWidth, o.scrollWidth, o.clientWidth), s = Ln(e.scrollHeight, e.clientHeight, o.scrollHeight, o.clientHeight);
  let i = -t.scrollLeft + Xl(e);
  const r = -t.scrollTop;
  return un(o).direction === "rtl" && (i += Ln(e.clientWidth, o.clientWidth) - n), {
    width: n,
    height: s,
    x: i,
    y: r
  };
}
const wE = 25;
function bE(e, t, o) {
  o === void 0 && (o = "viewport");
  const n = o === "layoutViewport", s = fo(e), i = On(e), r = s.visualViewport;
  let l = i.clientWidth, a = i.clientHeight, c = 0, d = 0;
  if (r) {
    const h = !i2() || t === "fixed";
    n ? h || (c = -r.offsetLeft, d = -r.offsetTop) : (l = r.width, a = r.height, h && (c = r.offsetLeft, d = r.offsetTop));
  }
  if (Xl(i) <= 0) {
    const h = i.ownerDocument, p = h.body, C = getComputedStyle(p), m = h.compatMode === "CSS1Compat" && parseFloat(C.marginLeft) + parseFloat(C.marginRight) || 0, w = Math.abs(i.clientWidth - p.clientWidth - m), y = getComputedStyle(i).scrollbarGutter === "stable both-edges" ? w / 2 : w;
    y <= wE && (l -= y);
  }
  return {
    width: l,
    height: a,
    x: c,
    y: d
  };
}
function yE(e, t) {
  const o = Ws(e, !0, t === "fixed"), n = o.top + e.clientTop, s = o.left + e.clientLeft, i = xi(e), r = e.clientWidth * i.x, l = e.clientHeight * i.y, a = s * i.x, c = n * i.y;
  return {
    width: r,
    height: l,
    x: a,
    y: c
  };
}
function Qc(e, t, o) {
  let n;
  if (t === "viewport" || t === "layoutViewport")
    n = bE(e, o, t);
  else if (t === "document")
    n = CE(On(e));
  else if (dn(t))
    n = yE(t, o);
  else {
    const s = K7(e);
    n = {
      x: t.x - s.x,
      y: t.y - s.y,
      width: t.width,
      height: t.height
    };
  }
  return pl(n);
}
function _E(e, t) {
  const o = t.get(e);
  if (o)
    return o;
  let n = Br(e, [], !1).filter((l) => dn(l) && ti(l) !== "body"), s = null;
  const i = un(e).position === "fixed";
  let r = i ? js(e) : e;
  for (; dn(r) && !Or(r); ) {
    const l = un(r), a = s2(r), c = s ? s.position : i ? "fixed" : "";
    !a && (c === "fixed" || c === "absolute" && l.position === "static") ? n = n.filter((u) => u !== r) : s = l, r = js(r);
  }
  return t.set(e, n), n;
}
function SE(e) {
  let {
    element: t,
    boundary: o,
    rootBoundary: n,
    strategy: s
  } = e;
  const r = [...o === "clippingAncestors" ? Ql(t) ? [] : _E(t, this._c) : [].concat(o), n], l = Qc(t, r[0], s);
  let a = l.top, c = l.right, d = l.bottom, u = l.left;
  for (let h = 1; h < r.length; h++) {
    const p = Qc(t, r[h], s);
    a = Ln(p.top, a), c = rs(p.right, c), d = rs(p.bottom, d), u = Ln(p.left, u);
  }
  return {
    width: c - u,
    height: d - a,
    x: u,
    y: a
  };
}
function xE(e) {
  const {
    width: t,
    height: o
  } = U7(e);
  return {
    width: t,
    height: o
  };
}
function ME(e, t, o) {
  const n = us(t), s = On(t), i = o === "fixed", r = Ws(e, !0, i, t);
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const a = En(0);
  if ((n || !i) && ((ti(t) !== "body" || Yl(s)) && (l = Jl(t)), n)) {
    const h = Ws(t, !0, i, t);
    a.x = h.x + t.clientLeft, a.y = h.y + t.clientTop;
  }
  !n && s && (a.x = Xl(s));
  const c = s && !n && !i ? q7(s, l) : En(0), d = r.left + l.scrollLeft - a.x - c.x, u = r.top + l.scrollTop - a.y - c.y;
  return {
    x: d,
    y: u,
    width: r.width,
    height: r.height
  };
}
function $a(e) {
  return un(e).position === "static";
}
function Jc(e, t) {
  if (!us(e) || un(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let o = e.offsetParent;
  return On(e) === o && (o = o.ownerDocument.body), o;
}
function Y7(e, t) {
  const o = fo(e);
  if (Ql(e))
    return o;
  if (!us(e)) {
    let s = js(e);
    for (; s && !Or(s); ) {
      if (dn(s) && !$a(s))
        return s;
      s = js(s);
    }
    return o;
  }
  let n = Jc(e, t);
  for (; n && dE(n) && $a(n); )
    n = Jc(n, t);
  return n && Or(n) && $a(n) && !s2(n) ? o : n || gE(e) || o;
}
const AE = async function(e) {
  const t = this.getOffsetParent || Y7, o = this.getDimensions, n = await o(e.floating);
  return {
    reference: ME(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: n.width,
      height: n.height
    }
  };
};
function LE(e) {
  return un(e).direction === "rtl";
}
const EE = {
  convertOffsetParentRelativeRectToViewportRelativeRect: vE,
  getDocumentElement: On,
  getClippingRect: SE,
  getOffsetParent: Y7,
  getElementRects: AE,
  getClientRects: mE,
  getDimensions: xE,
  getScale: xi,
  isElement: dn,
  isRTL: LE
};
function Q7(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function PE(e, t, o) {
  let n = null, s;
  const i = On(e);
  function r() {
    var d;
    clearTimeout(s), (d = n) == null || d.disconnect(), n = null;
  }
  function l(d, u) {
    d === void 0 && (d = !1), u === void 0 && (u = 1), r();
    const h = e.getBoundingClientRect(), {
      left: p,
      top: C,
      width: m,
      height: w
    } = h;
    if (d || t(), !m || !w)
      return;
    const y = y1(C), b = y1(i.clientWidth - (p + m)), _ = y1(i.clientHeight - (C + w)), M = y1(p), L = {
      rootMargin: -y + "px " + -b + "px " + -_ + "px " + -M + "px",
      threshold: Ln(0, rs(1, u)) || 1
    };
    let A = !0;
    function R(P) {
      const I = P[0].intersectionRatio;
      if (!Q7(h, e.getBoundingClientRect()))
        return l();
      if (I !== u) {
        if (!A)
          return l();
        I ? l(!1, I) : s = setTimeout(() => {
          l(!1, 1e-7);
        }, 1e3);
      }
      A = !1;
    }
    try {
      n = new IntersectionObserver(R, {
        ...L,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(R, L);
    }
    n.observe(e);
  }
  const a = fo(e), c = () => l(o);
  return a.addEventListener("resize", c), l(!0), () => {
    a.removeEventListener("resize", c), r();
  };
}
function W0(e, t, o, n) {
  n === void 0 && (n = {});
  const {
    ancestorScroll: s = !0,
    ancestorResize: i = !0,
    elementResize: r = typeof ResizeObserver == "function",
    layoutShift: l = typeof IntersectionObserver == "function",
    animationFrame: a = !1
  } = n, c = r2(e), d = s || i ? [...c ? Br(c) : [], ...t ? Br(t) : []] : [];
  d.forEach((y) => {
    s && y.addEventListener("scroll", o), i && y.addEventListener("resize", o);
  });
  const u = c && l ? PE(c, o, i) : null;
  let h = -1, p = null;
  r && (p = new ResizeObserver((y) => {
    let [b] = y;
    b && b.target === c && p && t && (p.unobserve(t), cancelAnimationFrame(h), h = requestAnimationFrame(() => {
      var _;
      (_ = p) == null || _.observe(t);
    })), o();
  }), c && !a && p.observe(c), t && p.observe(t));
  let C, m = a ? Ws(e) : null;
  a && w();
  function w() {
    const y = Ws(e);
    m && !Q7(m, y) && o(), m = y, C = requestAnimationFrame(w);
  }
  return o(), () => {
    var y;
    d.forEach((b) => {
      s && b.removeEventListener("scroll", o), i && b.removeEventListener("resize", o);
    }), u == null || u(), (y = p) == null || y.disconnect(), p = null, a && cancelAnimationFrame(C);
  };
}
const J7 = lE, X7 = aE, e3 = sE, RE = cE, FE = nE, t3 = (e, t, o) => {
  const n = /* @__PURE__ */ new Map(), s = o ?? {}, i = {
    ...EE,
    ...s.platform,
    _c: n
  };
  return oE(e, t, {
    ...s,
    platform: i
  });
};
function TE(e) {
  return e != null && typeof e == "object" && "$el" in e;
}
function U0(e) {
  if (TE(e)) {
    const t = e.$el;
    return n2(t) && ti(t) === "#comment" ? null : t;
  }
  return e;
}
function vi(e) {
  return typeof e == "function" ? e() : k(e);
}
function IE(e) {
  return {
    name: "arrow",
    options: e,
    fn(t) {
      const o = U0(vi(e.element));
      return o == null ? {} : FE({
        element: o,
        padding: e.padding
      }).fn(t);
    }
  };
}
function o3(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Xc(e, t) {
  const o = o3(e);
  return Math.round(t * o) / o;
}
function DE(e, t, o) {
  o === void 0 && (o = {});
  const n = o.whileElementsMounted, s = F(() => {
    var A;
    return (A = vi(o.open)) != null ? A : !0;
  }), i = F(() => vi(o.middleware)), r = F(() => {
    var A;
    return (A = vi(o.placement)) != null ? A : "bottom";
  }), l = F(() => {
    var A;
    return (A = vi(o.strategy)) != null ? A : "absolute";
  }), a = F(() => {
    var A;
    return (A = vi(o.transform)) != null ? A : !0;
  }), c = F(() => U0(e.value)), d = F(() => U0(t.value)), u = W(0), h = W(0), p = W(l.value), C = W(r.value), m = Je({}), w = W(!1), y = F(() => {
    const A = {
      position: p.value,
      left: "0",
      top: "0"
    };
    if (!d.value)
      return A;
    const R = Xc(d.value, u.value), P = Xc(d.value, h.value);
    return a.value ? {
      ...A,
      transform: "translate(" + R + "px, " + P + "px)",
      ...o3(d.value) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: p.value,
      left: R + "px",
      top: P + "px"
    };
  });
  let b;
  function _() {
    if (c.value == null || d.value == null)
      return;
    const A = s.value;
    t3(c.value, d.value, {
      middleware: i.value,
      placement: r.value,
      strategy: l.value
    }).then((R) => {
      u.value = R.x, h.value = R.y, p.value = R.strategy, C.value = R.placement, m.value = R.middlewareData, w.value = A !== !1;
    });
  }
  function M() {
    typeof b == "function" && (b(), b = void 0);
  }
  function x() {
    if (M(), n === void 0) {
      _();
      return;
    }
    if (c.value != null && d.value != null) {
      b = n(c.value, d.value, _);
      return;
    }
  }
  function L() {
    s.value || (w.value = !1);
  }
  return Me([i, r, l, s], _, {
    flush: "sync"
  }), Me([c, d], x, {
    flush: "sync"
  }), Me(s, L, {
    flush: "sync"
  }), I5() && Yi(M), {
    x: bs(u),
    y: bs(h),
    strategy: bs(p),
    placement: bs(C),
    middlewareData: bs(m),
    isPositioned: bs(w),
    floatingStyles: y,
    update: _
  };
}
function ea(e) {
  return I5() ? (Yi(e), !0) : !1;
}
const Za = /* @__PURE__ */ new WeakMap(), kE = (...e) => {
  var t;
  const o = e[0], n = (t = Bo()) == null ? void 0 : t.proxy;
  if (n == null && !Gl())
    throw new Error("injectLocal must be called in setup");
  return n && Za.has(n) && o in Za.get(n) ? Za.get(n)[o] : n1(...e);
}, l2 = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const HE = (e) => typeof e < "u", n3 = (e) => e != null, VE = Object.prototype.toString, OE = (e) => VE.call(e) === "[object Object]", Ao = () => {
}, BE = /* @__PURE__ */ $E();
function $E() {
  var e, t;
  return l2 && ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((t = window == null ? void 0 : window.navigator) == null ? void 0 : t.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function ZE(...e) {
  if (e.length !== 1)
    return tS(...e);
  const t = e[0];
  return typeof t == "function" ? T0(oS(() => ({ get: t, set: Ao }))) : W(t);
}
function s3(e, t) {
  function o(...n) {
    return new Promise((s, i) => {
      Promise.resolve(e(() => t.apply(this, n), { fn: t, thisArg: this, args: n })).then(s).catch(i);
    });
  }
  return o;
}
const GE = (e) => e();
function i3(e, t = {}) {
  let o, n, s = Ao;
  const i = (a) => {
    clearTimeout(a), s(), s = Ao;
  };
  let r;
  return (a) => {
    const c = ke(e), d = ke(t.maxWait);
    return o && i(o), c <= 0 || d !== void 0 && d <= 0 ? (n && (i(n), n = null), Promise.resolve(a())) : new Promise((u, h) => {
      s = t.rejectOnCancel ? h : u, r = a, d && !n && (n = setTimeout(() => {
        o && i(o), n = null, u(r());
      }, d)), o = setTimeout(() => {
        n && i(n), n = null, u(a());
      }, c);
    });
  };
}
function ed(e) {
  return e.endsWith("rem") ? Number.parseFloat(e) * 16 : Number.parseFloat(e);
}
function Mi(e) {
  return Array.isArray(e) ? e : [e];
}
function NE(e) {
  return Bo();
}
function Us(e, t = 200, o = {}) {
  return s3(
    i3(t, o),
    e
  );
}
function zE(e, t = 200, o = {}) {
  const n = W(ke(e)), s = Us(() => {
    n.value = e.value;
  }, t, o);
  return Me(e, () => s()), bs(n);
}
function jE(e, t, o = {}) {
  const {
    eventFilter: n = GE,
    ...s
  } = o;
  return Me(
    e,
    s3(
      n,
      t
    ),
    s
  );
}
function a2(e, t = !0, o) {
  NE() ? At(e, o) : t ? e() : rt(e);
}
function WE(e, t, o = {}) {
  const {
    debounce: n = 0,
    maxWait: s = void 0,
    ...i
  } = o;
  return jE(
    e,
    t,
    {
      ...i,
      eventFilter: i3(n, { maxWait: s })
    }
  );
}
function UE(e, t, o) {
  return Me(
    e,
    t,
    {
      ...o,
      immediate: !0
    }
  );
}
function KE(e, t, o) {
  return Me(
    e,
    t,
    {
      ...o,
      once: !0
    }
  );
}
const Bn = l2 ? window : void 0;
function Nt(e) {
  var t;
  const o = ke(e);
  return (t = o == null ? void 0 : o.$el) != null ? t : o;
}
function Xt(...e) {
  const t = [], o = () => {
    t.forEach((l) => l()), t.length = 0;
  }, n = (l, a, c, d) => (l.addEventListener(a, c, d), () => l.removeEventListener(a, c, d)), s = F(() => {
    const l = Mi(ke(e[0])).filter((a) => a != null);
    return l.every((a) => typeof a != "string") ? l : void 0;
  }), i = UE(
    () => {
      var l, a;
      return [
        (a = (l = s.value) == null ? void 0 : l.map((c) => Nt(c))) != null ? a : [Bn].filter((c) => c != null),
        Mi(ke(s.value ? e[1] : e[0])),
        Mi(k(s.value ? e[2] : e[1])),
        // @ts-expect-error - TypeScript gets the correct types, but somehow still complains
        ke(s.value ? e[3] : e[2])
      ];
    },
    ([l, a, c, d]) => {
      if (o(), !(l != null && l.length) || !(a != null && a.length) || !(c != null && c.length))
        return;
      const u = OE(d) ? { ...d } : d;
      t.push(
        ...l.flatMap(
          (h) => a.flatMap(
            (p) => c.map((C) => n(h, p, C, u))
          )
        )
      );
    },
    { flush: "post" }
  ), r = () => {
    i(), o();
  };
  return ea(o), r;
}
let td = !1;
function qE(e, t, o = {}) {
  const { window: n = Bn, ignore: s = [], capture: i = !0, detectIframe: r = !1, controls: l = !1 } = o;
  if (!n)
    return l ? { stop: Ao, cancel: Ao, trigger: Ao } : Ao;
  if (BE && !td) {
    td = !0;
    const w = { passive: !0 };
    Array.from(n.document.body.children).forEach((y) => y.addEventListener("click", Ao, w)), n.document.documentElement.addEventListener("click", Ao, w);
  }
  let a = !0;
  const c = (w) => ke(s).some((y) => {
    if (typeof y == "string")
      return Array.from(n.document.querySelectorAll(y)).some((b) => b === w.target || w.composedPath().includes(b));
    {
      const b = Nt(y);
      return b && (w.target === b || w.composedPath().includes(b));
    }
  });
  function d(w) {
    const y = ke(w);
    return y && y.$.subTree.shapeFlag === 16;
  }
  function u(w, y) {
    const b = ke(w), _ = b.$.subTree && b.$.subTree.children;
    return _ == null || !Array.isArray(_) ? !1 : _.some((M) => M.el === y.target || y.composedPath().includes(M.el));
  }
  const h = (w) => {
    const y = Nt(e);
    if (w.target != null && !(!(y instanceof Element) && d(e) && u(e, w)) && !(!y || y === w.target || w.composedPath().includes(y))) {
      if ("detail" in w && w.detail === 0 && (a = !c(w)), !a) {
        a = !0;
        return;
      }
      t(w);
    }
  };
  let p = !1;
  const C = [
    Xt(n, "click", (w) => {
      p || (p = !0, setTimeout(() => {
        p = !1;
      }, 0), h(w));
    }, { passive: !0, capture: i }),
    Xt(n, "pointerdown", (w) => {
      const y = Nt(e);
      a = !c(w) && !!(y && !w.composedPath().includes(y));
    }, { passive: !0 }),
    r && Xt(n, "blur", (w) => {
      setTimeout(() => {
        var y;
        const b = Nt(e);
        ((y = n.document.activeElement) == null ? void 0 : y.tagName) === "IFRAME" && !(b != null && b.contains(n.document.activeElement)) && t(w);
      }, 0);
    }, { passive: !0 })
  ].filter(Boolean), m = () => C.forEach((w) => w());
  return l ? {
    stop: m,
    cancel: () => {
      a = !1;
    },
    trigger: (w) => {
      a = !0, h(w), a = !1;
    }
  } : m;
}
function YE() {
  const e = Je(!1), t = Bo();
  return t && At(() => {
    e.value = !0;
  }, t), e;
}
function ta(e) {
  const t = YE();
  return F(() => (t.value, !!e()));
}
function QE(e, t, o = {}) {
  const { window: n = Bn, ...s } = o;
  let i;
  const r = ta(() => n && "MutationObserver" in n), l = () => {
    i && (i.disconnect(), i = void 0);
  }, a = F(() => {
    const h = ke(e), p = Mi(h).map(Nt).filter(n3);
    return new Set(p);
  }), c = Me(
    () => a.value,
    (h) => {
      l(), r.value && h.size && (i = new MutationObserver(t), h.forEach((p) => i.observe(p, s)));
    },
    { immediate: !0, flush: "post" }
  ), d = () => i == null ? void 0 : i.takeRecords(), u = () => {
    c(), l();
  };
  return ea(u), {
    isSupported: r,
    stop: u,
    takeRecords: d
  };
}
const JE = Symbol("vueuse-ssr-width");
function XE() {
  const e = Gl() ? kE(JE, null) : null;
  return typeof e == "number" ? e : void 0;
}
function r3(e, t = {}) {
  const { window: o = Bn, ssrWidth: n = XE() } = t, s = ta(() => o && "matchMedia" in o && typeof o.matchMedia == "function"), i = Je(typeof n == "number"), r = Je(), l = Je(!1), a = (c) => {
    l.value = c.matches;
  };
  return Nl(() => {
    if (i.value) {
      i.value = !s.value;
      const c = ke(e).split(",");
      l.value = c.some((d) => {
        const u = d.includes("not all"), h = d.match(/\(\s*min-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/), p = d.match(/\(\s*max-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/);
        let C = !!(h || p);
        return h && C && (C = n >= ed(h[1])), p && C && (C = n <= ed(p[1])), u ? !C : C;
      });
      return;
    }
    s.value && (r.value = o.matchMedia(ke(e)), l.value = r.value.matches);
  }), Xt(r, "change", a, { passive: !0 }), F(() => l.value);
}
function eP(e) {
  return JSON.parse(JSON.stringify(e));
}
function tP(e, t = {}) {
  var o, n;
  const s = Je(!1), i = Je(null);
  let r = 0, l = !0;
  if (l2) {
    const a = typeof t == "function" ? { onDrop: t } : t, c = (o = a.multiple) != null ? o : !0, d = (n = a.preventDefaultForUnhandled) != null ? n : !1, u = (w) => {
      var y, b;
      const _ = Array.from((b = (y = w.dataTransfer) == null ? void 0 : y.files) != null ? b : []);
      return _.length === 0 ? null : c ? _ : [_[0]];
    }, h = (w) => {
      const y = k(a.dataTypes);
      return typeof y == "function" ? y(w) : y != null && y.length ? w.length === 0 ? !1 : w.every(
        (b) => y.some((_) => b.includes(_))
      ) : !0;
    }, p = (w) => {
      const y = Array.from(w ?? []).map((M) => M.type), b = h(y), _ = c || w.length <= 1;
      return b && _;
    }, C = () => /^(?:(?!chrome|android).)*safari/i.test(navigator.userAgent) && !("chrome" in window), m = (w, y) => {
      var b, _, M, x, L, A;
      const R = (b = w.dataTransfer) == null ? void 0 : b.items;
      if (l = (_ = R && p(R)) != null ? _ : !1, d && w.preventDefault(), !C() && !l) {
        w.dataTransfer && (w.dataTransfer.dropEffect = "none");
        return;
      }
      w.preventDefault(), w.dataTransfer && (w.dataTransfer.dropEffect = "copy");
      const P = u(w);
      switch (y) {
        case "enter":
          r += 1, s.value = !0, (M = a.onEnter) == null || M.call(a, null, w);
          break;
        case "over":
          (x = a.onOver) == null || x.call(a, null, w);
          break;
        case "leave":
          r -= 1, r === 0 && (s.value = !1), (L = a.onLeave) == null || L.call(a, null, w);
          break;
        case "drop":
          r = 0, s.value = !1, l && (i.value = P, (A = a.onDrop) == null || A.call(a, P, w));
          break;
      }
    };
    Xt(e, "dragenter", (w) => m(w, "enter")), Xt(e, "dragover", (w) => m(w, "over")), Xt(e, "dragleave", (w) => m(w, "leave")), Xt(e, "drop", (w) => m(w, "drop"));
  }
  return {
    files: i,
    isOverDropZone: s
  };
}
function s1(e, t, o = {}) {
  const { window: n = Bn, ...s } = o;
  let i;
  const r = ta(() => n && "ResizeObserver" in n), l = () => {
    i && (i.disconnect(), i = void 0);
  }, a = F(() => {
    const u = ke(e);
    return Array.isArray(u) ? u.map((h) => Nt(h)) : [Nt(u)];
  }), c = Me(
    a,
    (u) => {
      if (l(), r.value && n) {
        i = new ResizeObserver(t);
        for (const h of u)
          h && i.observe(h, s);
      }
    },
    { immediate: !0, flush: "post" }
  ), d = () => {
    l(), c();
  };
  return ea(d), {
    isSupported: r,
    stop: d
  };
}
function oP(e, t = {}) {
  const {
    reset: o = !0,
    windowResize: n = !0,
    windowScroll: s = !0,
    immediate: i = !0,
    updateTiming: r = "sync"
  } = t, l = Je(0), a = Je(0), c = Je(0), d = Je(0), u = Je(0), h = Je(0), p = Je(0), C = Je(0);
  function m() {
    const y = Nt(e);
    if (!y) {
      o && (l.value = 0, a.value = 0, c.value = 0, d.value = 0, u.value = 0, h.value = 0, p.value = 0, C.value = 0);
      return;
    }
    const b = y.getBoundingClientRect();
    l.value = b.height, a.value = b.bottom, c.value = b.left, d.value = b.right, u.value = b.top, h.value = b.width, p.value = b.x, C.value = b.y;
  }
  function w() {
    r === "sync" ? m() : r === "next-frame" && requestAnimationFrame(() => m());
  }
  return s1(e, w), Me(() => Nt(e), (y) => !y && w()), QE(e, w, {
    attributeFilter: ["style", "class"]
  }), s && Xt("scroll", w, { capture: !0, passive: !0 }), n && Xt("resize", w, { passive: !0 }), a2(() => {
    i && w();
  }), {
    height: l,
    bottom: a,
    left: c,
    right: d,
    top: u,
    width: h,
    x: p,
    y: C,
    update: w
  };
}
function nP(e, t = { width: 0, height: 0 }, o = {}) {
  const { window: n = Bn, box: s = "content-box" } = o, i = F(() => {
    var u, h;
    return (h = (u = Nt(e)) == null ? void 0 : u.namespaceURI) == null ? void 0 : h.includes("svg");
  }), r = Je(t.width), l = Je(t.height), { stop: a } = s1(
    e,
    ([u]) => {
      const h = s === "border-box" ? u.borderBoxSize : s === "content-box" ? u.contentBoxSize : u.devicePixelContentBoxSize;
      if (n && i.value) {
        const p = Nt(e);
        if (p) {
          const C = p.getBoundingClientRect();
          r.value = C.width, l.value = C.height;
        }
      } else if (h) {
        const p = Mi(h);
        r.value = p.reduce((C, { inlineSize: m }) => C + m, 0), l.value = p.reduce((C, { blockSize: m }) => C + m, 0);
      } else
        r.value = u.contentRect.width, l.value = u.contentRect.height;
    },
    o
  );
  a2(() => {
    const u = Nt(e);
    u && (r.value = "offsetWidth" in u ? u.offsetWidth : t.width, l.value = "offsetHeight" in u ? u.offsetHeight : t.height);
  });
  const c = Me(
    () => Nt(e),
    (u) => {
      r.value = u ? t.width : 0, l.value = u ? t.height : 0;
    }
  );
  function d() {
    a(), c();
  }
  return {
    width: r,
    height: l,
    stop: d
  };
}
function sP(e, t, o = {}) {
  const {
    root: n,
    rootMargin: s = "0px",
    threshold: i = 0,
    window: r = Bn,
    immediate: l = !0
  } = o, a = ta(() => r && "IntersectionObserver" in r), c = F(() => {
    const C = ke(e);
    return Mi(C).map(Nt).filter(n3);
  });
  let d = Ao;
  const u = Je(l), h = a.value ? Me(
    () => [c.value, Nt(n), u.value],
    ([C, m]) => {
      if (d(), !u.value || !C.length)
        return;
      const w = new IntersectionObserver(
        t,
        {
          root: Nt(m),
          rootMargin: s,
          threshold: i
        }
      );
      C.forEach((y) => y && w.observe(y)), d = () => {
        w.disconnect(), d = Ao;
      };
    },
    { immediate: l, flush: "post" }
  ) : Ao, p = () => {
    d(), h(), u.value = !1;
  };
  return ea(p), {
    isSupported: a,
    isActive: u,
    pause() {
      d(), u.value = !1;
    },
    resume() {
      u.value = !0;
    },
    stop: p
  };
}
function od(e, t = {}) {
  const {
    window: o = Bn,
    scrollTarget: n,
    threshold: s = 0,
    rootMargin: i,
    once: r = !1
  } = t, l = Je(!1), { stop: a } = sP(
    e,
    (c) => {
      let d = l.value, u = 0;
      for (const h of c)
        h.time >= u && (u = h.time, d = h.isIntersecting);
      l.value = d, r && KE(l, () => {
        a();
      });
    },
    {
      root: n,
      window: o,
      threshold: s,
      rootMargin: ke(i)
    }
  );
  return l;
}
function oo(e, t, o, n = {}) {
  var s, i, r;
  const {
    clone: l = !1,
    passive: a = !1,
    eventName: c,
    deep: d = !1,
    defaultValue: u,
    shouldEmit: h
  } = n, p = Bo(), C = o || (p == null ? void 0 : p.emit) || ((s = p == null ? void 0 : p.$emit) == null ? void 0 : s.bind(p)) || ((r = (i = p == null ? void 0 : p.proxy) == null ? void 0 : i.$emit) == null ? void 0 : r.bind(p == null ? void 0 : p.proxy));
  let m = c;
  t || (t = "modelValue"), m = m || `update:${t.toString()}`;
  const w = (_) => l ? typeof l == "function" ? l(_) : eP(_) : _, y = () => HE(e[t]) ? w(e[t]) : u, b = (_) => {
    h ? h(_) && C(m, _) : C(m, _);
  };
  if (a) {
    const _ = y(), M = W(_);
    let x = !1;
    return Me(
      () => e[t],
      (L) => {
        x || (x = !0, M.value = w(L), rt(() => x = !1));
      }
    ), Me(
      M,
      (L) => {
        !x && (L !== e[t] || d) && b(L);
      },
      { deep: d }
    ), M;
  } else
    return F({
      get() {
        return y();
      },
      set(_) {
        b(_);
      }
    });
}
function l3(e = {}) {
  const {
    window: t = Bn,
    initialWidth: o = Number.POSITIVE_INFINITY,
    initialHeight: n = Number.POSITIVE_INFINITY,
    listenOrientation: s = !0,
    includeScrollbar: i = !0,
    type: r = "inner"
  } = e, l = Je(o), a = Je(n), c = () => {
    if (t)
      if (r === "outer")
        l.value = t.outerWidth, a.value = t.outerHeight;
      else if (r === "visual" && t.visualViewport) {
        const { width: u, height: h, scale: p } = t.visualViewport;
        l.value = Math.round(u * p), a.value = Math.round(h * p);
      } else i ? (l.value = t.innerWidth, a.value = t.innerHeight) : (l.value = t.document.documentElement.clientWidth, a.value = t.document.documentElement.clientHeight);
  };
  c(), a2(c);
  const d = { passive: !0 };
  if (Xt("resize", c, d), t && r === "visual" && t.visualViewport && Xt(t.visualViewport, "resize", c, d), s) {
    const u = r3("(orientation: portrait)");
    Me(u, () => c());
  }
  return { width: l, height: a };
}
const Gt = [];
for (let e = 0; e < 256; ++e)
  Gt.push((e + 256).toString(16).slice(1));
function iP(e, t = 0) {
  return (Gt[e[t + 0]] + Gt[e[t + 1]] + Gt[e[t + 2]] + Gt[e[t + 3]] + "-" + Gt[e[t + 4]] + Gt[e[t + 5]] + "-" + Gt[e[t + 6]] + Gt[e[t + 7]] + "-" + Gt[e[t + 8]] + Gt[e[t + 9]] + "-" + Gt[e[t + 10]] + Gt[e[t + 11]] + Gt[e[t + 12]] + Gt[e[t + 13]] + Gt[e[t + 14]] + Gt[e[t + 15]]).toLowerCase();
}
let Ga;
const rP = new Uint8Array(16);
function lP() {
  if (!Ga) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    Ga = crypto.getRandomValues.bind(crypto);
  }
  return Ga(rP);
}
const aP = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), nd = { randomUUID: aP };
function cP(e, t, o) {
  var s;
  if (nd.randomUUID && !e)
    return nd.randomUUID();
  e = e || {};
  const n = e.random ?? ((s = e.rng) == null ? void 0 : s.call(e)) ?? lP();
  if (n.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return n[6] = n[6] & 15 | 64, n[8] = n[8] & 63 | 128, iP(n);
}
const dP = /* @__PURE__ */ pe({
  __name: "SCALoader",
  props: {
    type: { default: "spinner" },
    appearance: { default: "primary" },
    size: { default: "medium" },
    indeterminate: { type: Boolean, default: !1 },
    inverted: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (t, o) => (f(), v("div", {
      class: S(t.$style.loader)
    }, [
      e.type === "spinner" ? (f(), v("div", {
        key: 0,
        class: S([
          t.$style.spinner,
          {
            [t.$style.appearanceWhite]: e.appearance === "white",
            [t.$style.appearanceGreyscale]: e.appearance === "greyscale",
            [t.$style.sizeSmall]: e.size === "small",
            [t.$style.sizeLarge]: e.size === "large",
            [t.$style.indeterminate]: e.indeterminate,
            [t.$style.inverted]: e.inverted
          }
        ])
      }, null, 2)) : e.type === "dots" ? (f(), v("div", {
        key: 1,
        class: S([
          t.$style.dots,
          {
            [t.$style.sizeSmall]: e.size === "small",
            [t.$style.sizeLarge]: e.size === "large"
          }
        ])
      }, [
        g("span", {
          class: S([
            t.$style.dot,
            {
              [t.$style.appearanceWhite]: e.appearance === "white",
              [t.$style.appearanceGreyscale]: e.appearance === "greyscale",
              [t.$style.inverted]: e.inverted,
              [t.$style.sizeSmall]: e.size === "small",
              [t.$style.sizeLarge]: e.size === "large"
            }
          ])
        }, null, 2),
        g("span", {
          class: S([
            t.$style.dot,
            {
              [t.$style.appearanceWhite]: e.appearance === "white",
              [t.$style.appearanceGreyscale]: e.appearance === "greyscale",
              [t.$style.inverted]: e.inverted,
              [t.$style.sizeSmall]: e.size === "small",
              [t.$style.sizeLarge]: e.size === "large"
            }
          ])
        }, null, 2),
        g("span", {
          class: S([
            t.$style.dot,
            {
              [t.$style.appearanceWhite]: e.appearance === "white",
              [t.$style.appearanceGreyscale]: e.appearance === "greyscale",
              [t.$style.inverted]: e.inverted,
              [t.$style.sizeSmall]: e.size === "small",
              [t.$style.sizeLarge]: e.size === "large"
            }
          ])
        }, null, 2)
      ], 2)) : $("", !0)
    ], 2));
  }
}), uP = "_loader_6oipg_755", hP = "_spinner_6oipg_761", gP = "_spin_6oipg_761", pP = "_appearanceWhite_6oipg_784", fP = "_appearanceGreyscale_6oipg_791", vP = "_sizeSmall_6oipg_798", mP = "_sizeLarge_6oipg_801", CP = "_indeterminate_6oipg_804", wP = "_inverted_6oipg_808", bP = "_dots_6oipg_812", yP = "_dot_6oipg_812", _P = {
  loader: uP,
  spinner: hP,
  spin: gP,
  appearanceWhite: pP,
  appearanceGreyscale: fP,
  sizeSmall: vP,
  sizeLarge: mP,
  indeterminate: CP,
  inverted: wP,
  dots: bP,
  dot: yP,
  "dot-bounce": "_dot-bounce_6oipg_1"
}, SP = {
  $style: _P
}, i1 = /* @__PURE__ */ Ce(dP, [["__cssModules", SP]]), xP = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function a3(e, t) {
  return f(), v("svg", xP, [...t[0] || (t[0] = [
    g("g", { id: "20-fifthbar" }, [
      g("path", {
        id: "Union",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M4.5 3.75C4.5 3.05964 5.05964 2.5 5.75 2.5H10.5V6.75C10.5 7.16421 10.8358 7.5 11.25 7.5H15.5V9.25C15.5 9.66421 15.8358 10 16.25 10C16.6642 10 17 9.66421 17 9.25V6.75C17 6.55109 16.921 6.36032 16.7803 6.21967L11.7803 1.21967C11.6397 1.07902 11.4489 1 11.25 1H5.75C4.23122 1 3 2.23122 3 3.75V16.25C3 17.7688 4.23122 19 5.75 19H8.25C8.66421 19 9 18.6642 9 18.25C9 17.8358 8.66421 17.5 8.25 17.5H5.75C5.05964 17.5 4.5 16.9404 4.5 16.25V3.75ZM14.4393 6L12 3.56066V6H14.4393ZM11.5 14.5607L15.7197 18.7803C16.0126 19.0732 16.4874 19.0732 16.7803 18.7803C17.0732 18.4874 17.0732 18.0126 16.7803 17.7197L12.5607 13.5H15.25C15.6642 13.5 16 13.1642 16 12.75C16 12.3358 15.6642 12 15.25 12H10.75C10.3358 12 10 12.3358 10 12.75V17.25C10 17.6642 10.3358 18 10.75 18C11.1642 18 11.5 17.6642 11.5 17.25V14.5607Z",
        fill: "#4A545E"
      })
    ], -1)
  ])]);
}
const MP = { render: a3 }, AP = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: MP,
  render: a3
}, Symbol.toStringTag, { value: "Module" })), LP = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function c3(e, t) {
  return f(), v("svg", LP, [...t[0] || (t[0] = [
    g("path", {
      fill: "#4A545E",
      d: "m17.516 4.928-2.322-2.322A2.056 2.056 0 0 0 13.73 2H4.88A2.882 2.882 0 0 0 2 4.88v10.838a2.882 2.882 0 0 0 2.88 2.879h10.24a2.882 2.882 0 0 0 2.88-2.88v-9.62a1.64 1.64 0 0 0-.484-1.168Zm-5.761-1.424v2.67H6.159v-2.67h5.596ZM6.159 17.093v-5.525h7.723v5.525H6.159Zm10.337-1.375c0 .667-.479 1.225-1.11 1.349v-5.868c0-.626-.51-1.136-1.136-1.136H5.79c-.626 0-1.135.51-1.135 1.136v5.873a1.377 1.377 0 0 1-1.151-1.355V4.879c0-.681.5-1.247 1.15-1.355v3.02c0 .625.51 1.135 1.136 1.135h6.333c.626 0 1.136-.51 1.136-1.136V3.504h.471c.152 0 .294.06.4.165l2.322 2.322a.148.148 0 0 1 .043.106v9.62h.001Z"
    }, null, -1)
  ])]);
}
const EP = { render: c3 }, PP = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: EP,
  render: c3
}, Symbol.toStringTag, { value: "Module" })), RP = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function d3(e, t) {
  return f(), v("svg", RP, [...t[0] || (t[0] = [
    g("g", { id: "20-sidebar" }, [
      g("path", {
        id: "Union",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M6.5 10C6.5 6.77834 8.77834 4.5 12 4.5C15.2217 4.5 17.5 6.77834 17.5 10C17.5 13.2217 15.2217 15.5 12 15.5C8.77834 15.5 6.5 13.2217 6.5 10ZM12 3C8.13401 3 5 6.13401 5 10C5 13.866 8.13401 17 12 17C15.866 17 19 13.866 19 10C19 6.13401 15.866 3 12 3ZM1 10.0256C1 6.7189 3.30992 3.95166 6.4042 3.24951V4.69511C4.04956 5.3176 2.5 7.37206 2.5 10.0256C2.5 12.6792 4.04956 14.6984 6.4042 15.3088V16.8018C3.30992 16.0996 1 13.3324 1 10.0256ZM7.94832 16.974L7.89351 16.9738H8.00314L7.94832 16.974Z",
        fill: "#4A545E"
      })
    ], -1)
  ])]);
}
const FP = { render: d3 }, TP = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: FP,
  render: d3
}, Symbol.toStringTag, { value: "Module" })), IP = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function u3(e, t) {
  return f(), v("svg", IP, [...t[0] || (t[0] = [
    g("path", {
      d: "M8 8.18262V9.48242H4.75098V8.18262H8ZM8.7002 7.48242V4.2334C8.7002 3.84688 8.38649 3.53334 8 3.5332H4.75098C4.36438 3.5332 4.05078 3.8468 4.05078 4.2334V7.48242C4.05091 7.86891 4.36446 8.18262 4.75098 8.18262V9.48242L4.54688 9.47168C3.60539 9.37624 2.85728 8.62797 2.76172 7.68652L2.75098 7.48242V4.2334C2.75098 3.12883 3.64641 2.2334 4.75098 2.2334H8L8.2041 2.24414C9.21266 2.34651 10 3.19783 10 4.2334V7.48242L9.98926 7.68652C9.89371 8.6279 9.14548 9.37614 8.2041 9.47168L8 9.48242V8.18262C8.38641 8.18249 8.70006 7.86883 8.7002 7.48242Z",
      fill: "#3D4145"
    }, null, -1),
    g("path", {
      d: "M7.19824 8.96436V13.6646H10V14.9644H6.54785C6.18895 14.9644 5.89759 14.6738 5.89746 14.3149V8.96436H7.19824Z",
      fill: "#3D4145"
    }, null, -1),
    g("path", {
      d: "M15.4531 10.5283C15.5165 10.5348 15.5791 10.5444 15.6406 10.5566C15.6727 10.563 15.7039 10.5722 15.7354 10.5801C15.7667 10.5879 15.7984 10.5942 15.8291 10.6035C15.8618 10.6134 15.8938 10.6252 15.9258 10.6367C15.9523 10.6463 15.9789 10.6554 16.0049 10.666C16.0441 10.682 16.0822 10.7003 16.1201 10.7188C16.1361 10.7265 16.1522 10.734 16.168 10.7422C16.207 10.7625 16.2447 10.7849 16.2822 10.8076C16.2989 10.8177 16.3157 10.8274 16.332 10.8379C16.36 10.856 16.3871 10.8751 16.4141 10.8945C16.4424 10.9149 16.4708 10.9352 16.498 10.957C16.5174 10.9725 16.536 10.9887 16.5547 11.0049C16.5811 11.0276 16.6067 11.0511 16.6318 11.0752C16.6518 11.0943 16.6713 11.1138 16.6904 11.1338C16.7184 11.1629 16.7453 11.1929 16.7715 11.2236C16.7835 11.2377 16.795 11.2522 16.8066 11.2666C16.8322 11.2983 16.8563 11.331 16.8799 11.3643C16.8954 11.3862 16.9111 11.4081 16.9258 11.4307C16.9416 11.4551 16.9569 11.4798 16.9717 11.5049C16.9899 11.5358 17.0079 11.5667 17.0244 11.5986C17.0372 11.6232 17.0478 11.6487 17.0596 11.6738C17.0729 11.7023 17.0867 11.7306 17.0986 11.7598C17.1134 11.7956 17.126 11.8323 17.1387 11.8691C17.1465 11.8919 17.1551 11.9144 17.1621 11.9375C17.174 11.9767 17.1839 12.0165 17.1934 12.0566C17.1987 12.0793 17.2044 12.102 17.209 12.125C17.2343 12.252 17.249 12.3831 17.249 12.5176V15.7666L17.2383 15.9707C17.2318 16.0345 17.2213 16.0973 17.209 16.1592C17.2049 16.1796 17.199 16.1995 17.1943 16.2197C17.1852 16.2591 17.1765 16.2984 17.165 16.3369C17.158 16.3607 17.1495 16.3839 17.1416 16.4072C17.129 16.4444 17.1162 16.4814 17.1016 16.5176C17.0931 16.5384 17.0834 16.5586 17.0742 16.5791C17.0588 16.6138 17.0427 16.648 17.0254 16.6816C17.0139 16.7039 17.0025 16.7262 16.9902 16.748C16.9722 16.7801 16.9524 16.8109 16.9326 16.8418C16.9193 16.8627 16.9067 16.884 16.8926 16.9043C16.8747 16.9301 16.855 16.9546 16.8359 16.9795C16.8169 17.0044 16.7985 17.0297 16.7783 17.0537C16.7028 17.1433 16.6192 17.2256 16.5293 17.3008C16.5127 17.3146 16.4955 17.3275 16.4785 17.3408C16.4485 17.3643 16.4181 17.3874 16.3867 17.4092C16.3631 17.4256 16.3388 17.4407 16.3145 17.4561C16.2886 17.4724 16.2629 17.4888 16.2363 17.5039C16.2115 17.518 16.1866 17.5318 16.1611 17.5449C16.1294 17.5612 16.0971 17.5762 16.0645 17.5908C16.0416 17.6011 16.0185 17.6107 15.9951 17.6201C15.9632 17.633 15.9311 17.645 15.8984 17.6562C15.8709 17.6657 15.8435 17.6753 15.8154 17.6836C15.7791 17.6943 15.7422 17.7032 15.7051 17.7119C15.6837 17.7169 15.6623 17.7223 15.6406 17.7266C15.579 17.7388 15.5166 17.7494 15.4531 17.7559L15.249 17.7666H12C11.9311 17.7666 11.863 17.7627 11.7959 17.7559C11.7328 17.7495 11.6706 17.7397 11.6094 17.7275C11.5836 17.7224 11.5586 17.7151 11.5332 17.709C11.4994 17.7009 11.4657 17.6934 11.4326 17.6836C11.4046 17.6753 11.3771 17.6657 11.3496 17.6562C11.317 17.645 11.2848 17.633 11.2529 17.6201C11.2296 17.6107 11.2065 17.6011 11.1836 17.5908C11.1509 17.5762 11.1186 17.5612 11.0869 17.5449C11.0615 17.5318 11.0365 17.518 11.0117 17.5039C10.9851 17.4887 10.9594 17.4724 10.9336 17.4561C10.9093 17.4407 10.8849 17.4256 10.8613 17.4092C10.8299 17.3874 10.7996 17.3643 10.7695 17.3408C10.7529 17.3278 10.7359 17.3153 10.7197 17.3018C10.6275 17.2247 10.5419 17.1401 10.4648 17.0479C10.4527 17.0333 10.4415 17.0179 10.4297 17.0029C10.4028 16.9688 10.3762 16.9343 10.3516 16.8984C10.3404 16.8821 10.3301 16.8653 10.3193 16.8486C10.2981 16.8156 10.2772 16.7823 10.2578 16.748C10.2455 16.7262 10.2342 16.7039 10.2227 16.6816C10.2053 16.648 10.1893 16.6138 10.1738 16.5791C10.1647 16.5586 10.1549 16.5384 10.1465 16.5176C10.1318 16.4814 10.119 16.4444 10.1064 16.4072C10.0985 16.3839 10.0901 16.3607 10.083 16.3369C10.0716 16.2984 10.0628 16.2591 10.0537 16.2197C10.049 16.1995 10.0431 16.1796 10.0391 16.1592C10.0268 16.0974 10.0172 16.0344 10.0107 15.9707L10 15.7666V12.5176C10.0001 11.4131 10.8955 10.5176 12 10.5176H15.249L15.4531 10.5283ZM13.624 11.6426C13.4583 11.6426 13.2989 11.708 13.1816 11.8252C13.0646 11.9424 12.999 12.1019 12.999 12.2676V13.5176H11.749C11.5833 13.5176 11.4239 13.583 11.3066 13.7002C11.1896 13.8174 11.124 13.9769 11.124 14.1426C11.1242 14.308 11.1897 14.4669 11.3066 14.584C11.4239 14.7012 11.5833 14.7676 11.749 14.7676H12.999V16.0176C12.9992 16.183 13.0647 16.3419 13.1816 16.459C13.2989 16.5762 13.4583 16.6426 13.624 16.6426C13.7898 16.6426 13.9492 16.5762 14.0664 16.459C14.1833 16.3419 14.2489 16.183 14.249 16.0176V14.7676H15.499C15.6648 14.7676 15.8242 14.7012 15.9414 14.584C16.0583 14.4669 16.1239 14.308 16.124 14.1426C16.124 13.9769 16.0585 13.8174 15.9414 13.7002C15.8242 13.583 15.6648 13.5176 15.499 13.5176H14.249V12.2676C14.249 12.1019 14.1835 11.9424 14.0664 11.8252C13.9492 11.708 13.7898 11.6426 13.624 11.6426Z",
      fill: "#3D4145"
    }, null, -1)
  ])]);
}
const DP = { render: u3 }, kP = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: DP,
  render: u3
}, Symbol.toStringTag, { value: "Module" })), HP = {
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function h3(e, t) {
  return f(), v("svg", HP, [...t[0] || (t[0] = [
    g("path", {
      d: "M6.50001 13.077L25.1829 13.077M10 10.1053C10 10.3814 9.77614 10.6053 9.5 10.6053C9.22386 10.6053 9 10.3814 9 10.1053C9 9.82916 9.22386 9.6053 9.5 9.6053C9.77614 9.6053 10 9.82916 10 10.1053ZM13 10.1053C13 10.3814 12.7761 10.6053 12.5 10.6053C12.2239 10.6053 12 10.3814 12 10.1053C12 9.82916 12.2239 9.6053 12.5 9.6053C12.7761 9.6053 13 9.82916 13 10.1053ZM16 10.1053C16 10.3814 15.7761 10.6053 15.5 10.6053C15.2239 10.6053 15 10.3814 15 10.1053C15 9.82916 15.2239 9.6053 15.5 9.6053C15.7761 9.6053 16 9.82916 16 10.1053ZM22.5769 6.5L9.42308 6.5C7.80871 6.5 6.5 7.8087 6.5 9.42308L6.5 22.5769C6.5 24.1913 7.80871 25.5 9.42308 25.5L22.5769 25.5C24.1913 25.5 25.5 24.1913 25.5 22.5769L25.5 9.42308C25.5 7.80871 24.1913 6.5 22.5769 6.5Z",
      stroke: "#4D4D4D",
      "stroke-linecap": "round"
    }, null, -1)
  ])]);
}
const VP = { render: h3 }, OP = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: VP,
  render: h3
}, Symbol.toStringTag, { value: "Module" })), BP = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function g3(e, t) {
  return f(), v("svg", BP, [...t[0] || (t[0] = [
    g("path", {
      d: "M13.6753 6.87158V8.17139H10.4263V6.87158H13.6753ZM14.3755 6.17139V2.92236C14.3755 2.53585 14.0618 2.2223 13.6753 2.22217H10.4263C10.0397 2.22217 9.72607 2.53576 9.72607 2.92236V6.17139C9.72621 6.55787 10.0398 6.87158 10.4263 6.87158V8.17139L10.2222 8.16064C9.28069 8.06521 8.53257 7.31693 8.43701 6.37549L8.42627 6.17139V2.92236C8.42627 1.81779 9.3217 0.922363 10.4263 0.922363H13.6753L13.8794 0.933105C14.888 1.03548 15.6753 1.8868 15.6753 2.92236V6.17139L15.6646 6.37549C15.569 7.31687 14.8208 8.0651 13.8794 8.16064L13.6753 8.17139V6.87158C14.0617 6.87145 14.3754 6.55779 14.3755 6.17139Z",
      fill: "#3D4145"
    }, null, -1),
    g("path", {
      d: "M13.8799 11.8394C13.9433 11.8458 14.0058 11.8554 14.0674 11.8677C14.071 11.8684 14.0746 11.8689 14.0781 11.8696L14.2461 11.9116C14.2491 11.9125 14.2519 11.9137 14.2549 11.9146C14.2836 11.9233 14.3116 11.9339 14.3398 11.9438C14.372 11.9552 14.4042 11.9661 14.4355 11.979C14.4658 11.9915 14.4949 12.0062 14.5244 12.02C14.5499 12.032 14.5757 12.0431 14.6006 12.0562C14.6271 12.07 14.6529 12.0851 14.6787 12.1001C14.7115 12.1192 14.7438 12.1388 14.7754 12.1597C14.7916 12.1704 14.8074 12.1817 14.8232 12.1929C14.8581 12.2174 14.8926 12.2424 14.9258 12.269C14.9434 12.2832 14.9604 12.2982 14.9775 12.313C15.008 12.3392 15.0376 12.3661 15.0664 12.394C15.0806 12.4078 15.0946 12.4218 15.1084 12.436C15.1385 12.4669 15.1673 12.4989 15.1953 12.5317C15.21 12.549 15.2241 12.5667 15.2383 12.5845C15.2624 12.6147 15.2853 12.6457 15.3076 12.6772C15.3204 12.6954 15.3335 12.7133 15.3457 12.7319C15.3681 12.766 15.3888 12.801 15.4092 12.8364C15.4209 12.8569 15.4333 12.877 15.4443 12.8979C15.4654 12.9378 15.4846 12.9786 15.5029 13.02C15.5087 13.0331 15.515 13.0459 15.5205 13.0591C15.5652 13.1661 15.6003 13.2776 15.626 13.3931C15.629 13.4068 15.633 13.4203 15.6357 13.4341C15.6613 13.5617 15.6758 13.6935 15.6758 13.8286V17.0776L15.665 17.2817C15.6587 17.3445 15.6488 17.4063 15.6367 17.4673C15.6325 17.4884 15.6259 17.5089 15.6211 17.5298C15.6113 17.5722 15.6014 17.6144 15.5889 17.6558C15.5842 17.6713 15.5783 17.6863 15.5732 17.7017C15.5581 17.7477 15.5418 17.7929 15.5234 17.8374C15.5177 17.8515 15.512 17.8655 15.5059 17.8794C15.4878 17.9206 15.468 17.9608 15.4473 18.0005C15.438 18.0182 15.4287 18.0358 15.4189 18.0532C15.3969 18.0926 15.3732 18.1308 15.3486 18.1685C15.3404 18.1811 15.3328 18.1941 15.3242 18.2065C15.3022 18.2387 15.2787 18.2696 15.2549 18.3003C15.2384 18.3216 15.2224 18.3432 15.2051 18.3638C15.1294 18.4536 15.0462 18.5365 14.9561 18.6118C14.9415 18.624 14.9261 18.6352 14.9111 18.647C14.877 18.6739 14.8425 18.7004 14.8066 18.7251C14.7903 18.7363 14.7735 18.7466 14.7568 18.7573C14.7238 18.7786 14.6906 18.7995 14.6562 18.8188C14.6344 18.8312 14.6121 18.8425 14.5898 18.854C14.5582 18.8703 14.5258 18.8852 14.4932 18.8999C14.4667 18.9118 14.4401 18.9233 14.4131 18.9341C14.387 18.9445 14.3606 18.9541 14.334 18.9634C14.3039 18.9739 14.2739 18.9846 14.2432 18.9937C14.2053 19.0049 14.1667 19.014 14.1279 19.0229C14.1077 19.0276 14.0878 19.0335 14.0674 19.0376C14.0058 19.0499 13.9434 19.0604 13.8799 19.0669L13.6758 19.0776H10.4268L10.2217 19.0669C10.2144 19.0662 10.2074 19.0638 10.2002 19.063C10.1448 19.0567 10.09 19.0493 10.0361 19.0386C10.0088 19.0332 9.98203 19.0256 9.95508 19.019C9.92396 19.0115 9.89284 19.0046 9.8623 18.9956C9.82988 18.9861 9.79832 18.9745 9.7666 18.9634C9.7394 18.9539 9.71219 18.9447 9.68555 18.9341C9.65716 18.9227 9.62929 18.9105 9.60156 18.8979C9.57485 18.8858 9.54853 18.8731 9.52246 18.8599C9.49109 18.8439 9.46008 18.8276 9.42969 18.8101C9.41143 18.7995 9.39387 18.7879 9.37598 18.7769C9.34405 18.7571 9.31195 18.7378 9.28125 18.7163C9.26123 18.7023 9.24213 18.6871 9.22266 18.6724C9.06773 18.5553 8.93053 18.4168 8.81543 18.2603C8.80702 18.2488 8.7982 18.2377 8.79004 18.2261C8.76771 18.1943 8.74705 18.1615 8.72656 18.1284C8.71419 18.1084 8.70211 18.0883 8.69043 18.0679C8.67482 18.0406 8.65985 18.013 8.64551 17.9849C8.63235 17.9591 8.61948 17.9331 8.60742 17.9067C8.59315 17.8755 8.57909 17.8441 8.56641 17.812C8.55662 17.7872 8.54787 17.7621 8.53906 17.7368C8.52812 17.7055 8.51722 17.6741 8.50781 17.6421C8.50055 17.6174 8.49558 17.592 8.48926 17.5669C8.44979 17.4101 8.42578 17.2467 8.42578 17.0776V13.8286C8.42586 13.2074 8.70961 12.6525 9.1543 12.2856C9.5 12.0004 9.94355 11.8286 10.4268 11.8286H13.6758L13.8799 11.8394ZM12.0508 12.9536C11.885 12.9536 11.7256 13.019 11.6084 13.1362C11.4912 13.2534 11.4258 13.4129 11.4258 13.5786V14.8286H10.1758C10.01 14.8286 9.85061 14.894 9.7334 15.0112C9.61619 15.1284 9.55078 15.2879 9.55078 15.4536C9.55091 15.6192 9.6163 15.7779 9.7334 15.895C9.85061 16.0122 10.01 16.0786 10.1758 16.0786H11.4258V17.3286C11.4259 17.4942 11.4913 17.6529 11.6084 17.77C11.7256 17.8872 11.885 17.9536 12.0508 17.9536C12.2164 17.9535 12.3751 17.8871 12.4922 17.77C12.6093 17.6529 12.6757 17.4942 12.6758 17.3286V16.0786H13.9258C14.0914 16.0785 14.2501 16.0121 14.3672 15.895C14.4843 15.7779 14.5507 15.6192 14.5508 15.4536C14.5508 15.2879 14.4844 15.1284 14.3672 15.0112C14.2501 14.8941 14.0914 14.8287 13.9258 14.8286H12.6758V13.5786C12.6758 13.4129 12.6094 13.2534 12.4922 13.1362C12.3751 13.0191 12.2164 12.9537 12.0508 12.9536Z",
      fill: "#3D4145"
    }, null, -1),
    g("path", {
      d: "M9.26465 5.38989L5.62402 5.38989L5.62402 15.3499L9.26465 15.3499L9.26465 16.6497L4.97461 16.6497C4.61562 16.6497 4.32422 16.3583 4.32422 15.9993L4.32422 4.7395C4.32422 4.38052 4.61562 4.08911 4.97461 4.08911L9.26465 4.08911L9.26465 5.38989Z",
      fill: "#3D4145"
    }, null, -1)
  ])]);
}
const $P = { render: g3 }, ZP = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: $P,
  render: g3
}, Symbol.toStringTag, { value: "Module" })), GP = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function p3(e, t) {
  return f(), v("svg", GP, [...t[0] || (t[0] = [
    g("path", {
      d: "M11.5757 16.6637L11.5757 3.83074C11.5757 3.49038 11.7109 3.16397 11.9516 2.92331C12.1922 2.68264 12.5186 2.54744 12.859 2.54744L16.7089 2.54744C17.0492 2.54744 17.3757 2.68264 17.6163 2.92331C17.857 3.16397 17.9922 3.49038 17.9922 3.83074L17.9922 16.6637C17.9922 17.0041 17.857 17.3305 17.6163 17.5711C17.3757 17.8118 17.0492 17.947 16.7089 17.947H12.859C12.5186 17.947 12.1922 17.8118 11.9516 17.5711C11.7109 17.3305 11.5757 17.0041 11.5757 16.6637ZM16.7089 16.6637L16.7089 3.83074L12.859 3.83074L12.859 16.6637H16.7089ZM14.7839 15.3804C14.9743 15.3804 15.1604 15.324 15.3187 15.2182C15.4769 15.1125 15.6003 14.9621 15.6732 14.7863C15.746 14.6104 15.7651 14.4169 15.7279 14.2302C15.6908 14.0435 15.5991 13.872 15.4645 13.7374C15.3299 13.6028 15.1584 13.5111 14.9717 13.474C14.785 13.4368 14.5915 13.4559 14.4156 13.5287C14.2398 13.6016 14.0894 13.7249 13.9837 13.8832C13.8779 14.0415 13.8215 14.2276 13.8215 14.4179C13.8215 14.6732 13.9229 14.918 14.1034 15.0985C14.2839 15.279 14.5287 15.3804 14.7839 15.3804Z",
      fill: "#4A545E"
    }, null, -1),
    g("path", {
      d: "M2.16636 15.5369L5.03493 3.02867C5.11101 2.69693 5.31576 2.409 5.60413 2.22822C5.8925 2.04744 6.24088 1.98862 6.57262 2.0647L10.3251 2.92527C10.6568 3.00135 10.9448 3.2061 11.1255 3.49447C11.3063 3.78284 11.3651 4.13122 11.2891 4.46296L8.42049 16.9712C8.34441 17.303 8.13967 17.5909 7.8513 17.7717C7.56292 17.9525 7.21455 18.0113 6.88281 17.9352L3.13033 17.0746C2.79859 16.9985 2.51066 16.7938 2.32988 16.5054C2.1491 16.217 2.09028 15.8687 2.16636 15.5369ZM7.16967 16.6844L10.0382 4.1761L6.28576 3.31553L3.41719 15.8238L7.16967 16.6844ZM5.58028 15.0033C5.76583 15.0458 5.95982 15.0324 6.13773 14.9647C6.31565 14.897 6.46949 14.778 6.5798 14.6229C6.69012 14.4678 6.75196 14.2834 6.75749 14.0931C6.76303 13.9028 6.71202 13.7152 6.61091 13.5539C6.5098 13.3926 6.36313 13.2649 6.18945 13.187C6.01578 13.1091 5.82289 13.0844 5.63519 13.1161C5.44749 13.1478 5.2734 13.2344 5.13494 13.3651C4.99647 13.4957 4.89986 13.6644 4.85731 13.85C4.80025 14.0988 4.84436 14.3601 4.97995 14.5764C5.11553 14.7926 5.33148 14.9462 5.58028 15.0033Z",
      fill: "#4A545E"
    }, null, -1)
  ])]);
}
const NP = { render: p3 }, zP = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: NP,
  render: p3
}, Symbol.toStringTag, { value: "Module" })), jP = {
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function f3(e, t) {
  return f(), v("svg", jP, [...t[0] || (t[0] = [
    g("path", {
      d: "M13.1737 2.45313L5.03311 1.01563C4.77196 0.96967 4.50325 1.02932 4.28607 1.18145C4.06889 1.33358 3.92103 1.56574 3.87499 1.82688L2.01561 12.3894C1.99287 12.5188 1.99585 12.6514 2.02438 12.7796C2.05291 12.9079 2.10643 13.0292 2.18189 13.1368C2.25734 13.2443 2.35325 13.336 2.46414 13.4064C2.57502 13.4769 2.6987 13.5248 2.82811 13.5475L10.9687 14.985C11.0982 15.0078 11.2309 15.0049 11.3592 14.9764C11.4875 14.9479 11.6089 14.8944 11.7166 14.819C11.8242 14.7435 11.9159 14.6476 11.9864 14.5366C12.0569 14.4257 12.1048 14.302 12.1275 14.1725L13.9869 3.61C14.0324 3.34877 13.9723 3.08014 13.8199 2.86319C13.6674 2.64624 13.435 2.49874 13.1737 2.45313ZM11.1412 14L2.99999 12.5625L4.85936 2L13 3.4375L11.1412 14ZM5.58374 3.65125C5.6069 3.52073 5.68094 3.40475 5.78958 3.32881C5.89823 3.25286 6.03258 3.22317 6.16312 3.24625L11.3506 4.16188C11.4739 4.18347 11.5846 4.25052 11.6609 4.34978C11.7371 4.44904 11.7734 4.57329 11.7624 4.69797C11.7515 4.82266 11.6942 4.93872 11.6019 5.02322C11.5096 5.10773 11.3889 5.15453 11.2637 5.15438C11.2344 5.15434 11.2051 5.15183 11.1762 5.14688L5.98874 4.23063C5.85822 4.20747 5.74224 4.13342 5.6663 4.02478C5.59035 3.91614 5.56066 3.78178 5.58374 3.65125ZM5.23749 5.62125C5.24889 5.55657 5.27291 5.49476 5.3082 5.43937C5.34349 5.38398 5.38934 5.33608 5.44314 5.29841C5.49695 5.26074 5.55765 5.23404 5.62177 5.21984C5.68589 5.20563 5.75219 5.2042 5.81686 5.21563L11.0044 6.13188C11.1285 6.15264 11.2403 6.21947 11.3173 6.31902C11.3943 6.41857 11.431 6.54352 11.42 6.66891C11.4089 6.7943 11.351 6.91091 11.2577 6.99546C11.1645 7.08 11.0427 7.12626 10.9169 7.125C10.8873 7.12506 10.8578 7.12234 10.8287 7.11688L5.64124 6.20125C5.51082 6.17781 5.39505 6.10355 5.31934 5.9948C5.24364 5.88605 5.2142 5.75169 5.23749 5.62125ZM4.89061 7.59063C4.91421 7.46045 4.98843 7.34494 5.09703 7.26938C5.20562 7.19382 5.33973 7.16438 5.46999 7.1875L8.06249 7.64313C8.18572 7.66471 8.29639 7.73172 8.37263 7.83091C8.44888 7.9301 8.48517 8.05427 8.47434 8.17891C8.4635 8.30355 8.40634 8.4196 8.31413 8.50416C8.22191 8.58871 8.10135 8.63562 7.97624 8.63563C7.94691 8.63561 7.91764 8.6331 7.88874 8.62813L5.29499 8.17C5.16459 8.14669 5.04876 8.07259 4.97295 7.96397C4.89713 7.85534 4.86752 7.72107 4.89061 7.59063Z",
      fill: "#555F6D"
    }, null, -1)
  ])]);
}
const WP = { render: f3 }, UP = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: WP,
  render: f3
}, Symbol.toStringTag, { value: "Module" })), KP = {
  viewBox: "0 0 8 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function v3(e, t) {
  return f(), v("svg", KP, [...t[0] || (t[0] = [
    g("circle", {
      id: "dot",
      cx: "4",
      cy: "4",
      r: "4",
      fill: "currentColor"
    }, null, -1)
  ])]);
}
const qP = { render: v3 }, YP = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: qP,
  render: v3
}, Symbol.toStringTag, { value: "Module" })), QP = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function m3(e, t) {
  return f(), v("svg", QP, [...t[0] || (t[0] = [
    g("path", {
      d: "M4 0C1.79086 0 0 1.79086 0 4V16C0 18.2091 1.79086 20 4 20H16C18.2091 20 20 18.2091 20 16V4C20 1.79086 18.2091 0 16 0H5.5L5.5 2H8.25C8.66421 2 9 2.33579 9 2.75V6.75C9 7.16421 8.66421 7.5 8.25 7.5H5.5V10H8.25C8.66421 10 9 10.3358 9 10.75V15.25C9 15.6642 8.66421 16 8.25 16H4.75C4.33579 16 4 15.6642 4 15.25V6.75C4 6.33579 4.33579 6 4.75 6H7.5V3.5H4.75C4.55109 3.5 4.36032 3.42098 4.21967 3.28033C4.07902 3.13968 4 2.94891 4 2.75V0Z",
      fill: "#555F6D"
    }, null, -1),
    g("path", {
      d: "M5.5 14.5V11.5H7.5V14.5H5.5Z",
      fill: "#555F6D"
    }, null, -1)
  ])]);
}
const JP = { render: m3 }, XP = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: JP,
  render: m3
}, Symbol.toStringTag, { value: "Module" })), eR = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function C3(e, t) {
  return f(), v("svg", eR, [...t[0] || (t[0] = [
    g("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M4 0C1.79086 0 0 1.79086 0 4V16C0 18.2091 1.79086 20 4 20H16C18.2091 20 20 18.2091 20 16V4C20 1.79086 18.2091 0 16 0H4ZM4.75 5C4.33579 5 4 5.33579 4 5.75C4 6.16421 4.33579 6.5 4.75 6.5H10.25C10.6642 6.5 11 6.16421 11 5.75C11 5.33579 10.6642 5 10.25 5H4.75ZM4.75 9.5C4.33579 9.5 4 9.83579 4 10.25C4 10.6642 4.33579 11 4.75 11H15.25C15.6642 11 16 10.6642 16 10.25C16 9.83579 15.6642 9.5 15.25 9.5H4.75ZM4.75 13.5C4.33579 13.5 4 13.8358 4 14.25C4 14.6642 4.33579 15 4.75 15H15.25C15.6642 15 16 14.6642 16 14.25C16 13.8358 15.6642 13.5 15.25 13.5H4.75Z",
      fill: "#3062D4"
    }, null, -1)
  ])]);
}
const tR = { render: C3 }, oR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: tR,
  render: C3
}, Symbol.toStringTag, { value: "Module" })), nR = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function w3(e, t) {
  return f(), v("svg", nR, [...t[0] || (t[0] = [
    g("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M4 0C1.79086 0 0 1.79086 0 4V16C0 18.2091 1.79086 20 4 20H16C18.2091 20 20 18.2091 20 16V4C20 1.79086 18.2091 0 16 0H4ZM7.34581 5.29445C7.09419 4.96542 6.62349 4.90266 6.29445 5.15427C5.96542 5.40588 5.90266 5.87659 6.15427 6.20563L9.05588 10L6.15427 13.7945C5.90266 14.1235 5.96542 14.5942 6.29445 14.8458C6.62349 15.0974 7.09419 15.0347 7.34581 14.7056L10 11.2347L12.6543 14.7056C12.9059 15.0347 13.3766 15.0974 13.7056 14.8458C14.0347 14.5942 14.0974 14.1235 13.8458 13.7945L10.9442 10L13.8458 6.20563C14.0974 5.87659 14.0347 5.40588 13.7056 5.15427C13.3766 4.90266 12.9059 4.96542 12.6543 5.29445L10 8.76537L7.34581 5.29445Z",
      fill: "#1D7C4D"
    }, null, -1)
  ])]);
}
const sR = { render: w3 }, iR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sR,
  render: w3
}, Symbol.toStringTag, { value: "Module" })), rR = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function b3(e, t) {
  return f(), v("svg", rR, [...t[0] || (t[0] = [
    g("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M4 4.5C4 2.567 5.50432 1 7.36 1H12.64C14.4957 1 16 2.567 16 4.5C16 5.61548 15.499 6.60909 14.7187 7.25C15.499 7.89092 16 8.88452 16 10C16 11.933 14.4957 13.5 12.64 13.5C11.9261 13.5 11.2642 13.2681 10.72 12.8727V15.5C10.72 17.433 9.21568 19 7.36 19C5.50432 19 4 17.433 4 15.5C4 14.3845 4.50096 13.3909 5.28132 12.75C4.50096 12.1091 4 11.1155 4 10C4 8.88452 4.50096 7.89092 5.28131 7.25C4.50096 6.60908 4 5.61548 4 4.5ZM7.36 8C6.29961 8 5.44 8.89543 5.44 10C5.44 11.1046 6.29961 12 7.36 12H9.28V8H7.36ZM9.28 6.5H7.36C6.29961 6.5 5.44 5.60457 5.44 4.5C5.44 3.39543 6.29961 2.5 7.36 2.5H9.28V6.5ZM12.64 6.5C13.7004 6.5 14.56 5.60457 14.56 4.5C14.56 3.39543 13.7004 2.5 12.64 2.5H10.72V6.5H12.64ZM12.64 8C11.5796 8 10.72 8.89543 10.72 10C10.72 11.1046 11.5796 12 12.64 12C13.7004 12 14.56 11.1046 14.56 10C14.56 8.89543 13.7004 8 12.64 8ZM9.28 13.5H7.36C6.29961 13.5 5.44 14.3954 5.44 15.5C5.44 16.6046 6.29961 17.5 7.36 17.5C8.42039 17.5 9.28 16.6046 9.28 15.5V13.5Z",
      fill: "#8040BF"
    }, null, -1)
  ])]);
}
const lR = { render: b3 }, aR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: lR,
  render: b3
}, Symbol.toStringTag, { value: "Module" })), cR = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function y3(e, t) {
  return f(), v("svg", cR, [...t[0] || (t[0] = [
    g("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M4.75 1.5C4.05964 1.5 3.5 2.05964 3.5 2.75V17.25C3.5 17.9404 4.05964 18.5 4.75 18.5H15.25C15.9404 18.5 16.5 17.9404 16.5 17.25V6.06066L11.9393 1.5H4.75ZM2 2.75C2 1.23122 3.23122 0 4.75 0H12.25C12.4489 0 12.6397 0.0790176 12.7803 0.21967L17.7803 5.21967C17.921 5.36032 18 5.55109 18 5.75V17.25C18 18.7688 16.7688 20 15.25 20H4.75C3.23122 20 2 18.7688 2 17.25V2.75Z",
      fill: "#555F6D"
    }, null, -1)
  ])]);
}
const dR = { render: y3 }, uR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: dR,
  render: y3
}, Symbol.toStringTag, { value: "Module" })), hR = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function _3(e, t) {
  return f(), v("svg", hR, [...t[0] || (t[0] = [
    g("path", {
      d: "M3.5 7.5V9.80769H4.5C4.99404 9.80769 5.5 9.35184 5.5 8.65385C5.5 7.95585 4.99404 7.5 4.5 7.5H3.5Z",
      fill: "#C53434"
    }, null, -1),
    g("path", {
      d: "M9.25 7.5V12.5H9.75C10.3485 12.5 10.8284 12.2132 11.1821 11.7435C11.5461 11.2599 11.75 10.6084 11.75 10C11.75 9.39157 11.5461 8.74007 11.1821 8.25654C10.8284 7.78679 10.3485 7.5 9.75 7.5H9.25Z",
      fill: "#C53434"
    }, null, -1),
    g("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M4 0C1.79086 0 0 1.79086 0 4V16C0 18.2091 1.79086 20 4 20H16C18.2091 20 20 18.2091 20 16V4C20 1.79086 18.2091 0 16 0H4ZM2 6.75C2 6.33579 2.33579 6 2.75 6H4.5C5.93895 6 7 7.24891 7 8.65385C7 10.0588 5.93895 11.3077 4.5 11.3077H3.5V13.25C3.5 13.6642 3.16421 14 2.75 14C2.33579 14 2 13.6642 2 13.25V6.75ZM7.75 6.75C7.75 6.33579 8.08579 6 8.5 6H9.75C10.9015 6 11.7966 6.57882 12.3804 7.35437C12.9539 8.11615 13.25 9.08965 13.25 10C13.25 10.9104 12.9539 11.8839 12.3804 12.6456C11.7966 13.4212 10.9015 14 9.75 14H8.5C8.08579 14 7.75 13.6642 7.75 13.25V6.75ZM14.75 6C14.3358 6 14 6.33579 14 6.75V13.25C14 13.6642 14.3358 14 14.75 14C15.1642 14 15.5 13.6642 15.5 13.25V10.4615H17.25C17.6642 10.4615 18 10.1258 18 9.71154C18 9.29733 17.6642 8.96154 17.25 8.96154H15.5V7.5H17.25C17.6642 7.5 18 7.16421 18 6.75C18 6.33579 17.6642 6 17.25 6H14.75Z",
      fill: "#C53434"
    }, null, -1)
  ])]);
}
const gR = { render: _3 }, pR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: gR,
  render: _3
}, Symbol.toStringTag, { value: "Module" })), fR = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function S3(e, t) {
  return f(), v("svg", fR, [...t[0] || (t[0] = [
    g("path", {
      d: "M7 10.5H5.5V7.5H7C7.82843 7.5 8.5 8.17157 8.5 9C8.5 9.82843 7.82843 10.5 7 10.5Z",
      fill: "#3062D4"
    }, null, -1),
    g("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M4 0C1.79086 0 0 1.79086 0 4V16C0 18.2091 1.79086 20 4 20H16C18.2091 20 20 18.2091 20 16V4C20 1.79086 18.2091 0 16 0H4ZM11.5 8.375C11.5 7.89175 11.8918 7.5 12.375 7.5H13.25C13.973 7.5 14.286 7.70214 14.408 7.81056C14.4754 7.87048 14.5094 7.92374 14.5241 7.95096C14.5279 7.95787 14.5304 7.96317 14.5319 7.96652C14.6465 8.34765 15.0417 8.57515 15.4319 8.47761C15.8337 8.37714 16.0781 7.96994 15.9776 7.5681L15.25 7.75C15.9776 7.5681 15.9773 7.56692 15.9773 7.56692L15.977 7.56571L15.9764 7.56321L15.975 7.55791L15.9718 7.5461C15.9694 7.53769 15.9667 7.52823 15.9635 7.51779C15.957 7.4969 15.9487 7.472 15.9381 7.44369C15.9169 7.38713 15.8863 7.31639 15.8431 7.23654C15.7562 7.07626 15.6184 6.87952 15.4045 6.68944C14.964 6.29786 14.277 6 13.25 6H12.375C11.0633 6 10 7.06332 10 8.375C10 9.18487 10.5505 9.78954 11.0816 10.1465C11.6314 10.5161 12.3378 10.75 13 10.75C13.3378 10.75 13.7564 10.8798 14.0816 11.0984C14.4255 11.3296 14.5 11.5374 14.5 11.625C14.5 12.1082 14.1082 12.5 13.625 12.5H12.75C12.027 12.5 11.714 12.2979 11.592 12.1894C11.5246 12.1295 11.4906 12.0763 11.4759 12.049C11.4735 12.0446 11.4716 12.0409 11.4702 12.0379L11.4681 12.0335C11.3535 11.6523 10.9583 11.4249 10.5681 11.5224C10.1663 11.6229 9.92193 12.0301 10.0224 12.4319L10.75 12.25C10.0224 12.4319 10.0227 12.4331 10.0227 12.4331L10.023 12.4343L10.0236 12.4368L10.025 12.4421L10.0282 12.4539C10.0306 12.4623 10.0333 12.4718 10.0365 12.4822C10.043 12.5031 10.0513 12.528 10.0619 12.5563C10.0831 12.6129 10.1137 12.6836 10.1569 12.7635C10.2438 12.9237 10.3816 13.1205 10.5955 13.3106C11.036 13.7021 11.723 14 12.75 14H13.625C14.9367 14 16 12.9367 16 11.625C16 10.8151 15.4495 10.2105 14.9184 9.85349C14.3686 9.48394 13.6622 9.24999 13 9.24999C12.6622 9.24999 12.2436 9.12016 11.9184 8.90158C11.5745 8.67042 11.5 8.4626 11.5 8.375ZM4.75 6C4.33579 6 4 6.33579 4 6.75V13.25C4 13.6642 4.33579 14 4.75 14C5.16421 14 5.5 13.6642 5.5 13.25V12H7C8.65685 12 10 10.6569 10 9C10 7.34315 8.65685 6 7 6H4.75Z",
      fill: "#3062D4"
    }, null, -1)
  ])]);
}
const vR = { render: S3 }, mR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: vR,
  render: S3
}, Symbol.toStringTag, { value: "Module" })), CR = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function x3(e, t) {
  return f(), v("svg", CR, [...t[0] || (t[0] = [
    g("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M4 0C1.79086 0 0 1.79086 0 4V16C0 18.2091 1.79086 20 4 20H16C18.2091 20 20 18.2091 20 16V4C20 1.79086 18.2091 0 16 0H4ZM4.90856 4.24299C4.68948 4.44666 4.53036 4.72704 4.21212 5.28782L3.46124 6.61095C3.03703 7.35844 2.82493 7.73219 2.77024 8.1223C2.72197 8.46655 2.7604 8.81817 2.88164 9.14172C3.01903 9.50836 3.30615 9.82112 3.8804 10.4467L7.85019 14.771C8.60049 15.5883 8.97564 15.9969 9.41076 16.1494C9.79335 16.2835 10.2066 16.2835 10.5892 16.1494C11.0244 15.9969 11.3995 15.5883 12.1498 14.771L16.1196 10.4467C16.6938 9.82112 16.981 9.50836 17.1184 9.14172C17.2396 8.81817 17.278 8.46655 17.2298 8.1223C17.1751 7.73219 16.963 7.35844 16.5388 6.61095L15.7879 5.28782C15.4696 4.72705 15.3105 4.44666 15.0914 4.24299C14.8976 4.06276 14.6706 3.92686 14.4246 3.84383C14.1467 3.75 13.8375 3.75 13.2189 3.75H6.78109C6.16255 3.75 5.85327 3.75 5.57537 3.84383C5.32945 3.92686 5.10242 4.06276 4.90856 4.24299Z",
      fill: "#F59638"
    }, null, -1)
  ])]);
}
const wR = { render: x3 }, bR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: wR,
  render: x3
}, Symbol.toStringTag, { value: "Module" })), yR = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function M3(e, t) {
  return f(), v("svg", yR, [...t[0] || (t[0] = [
    g("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M4 0C1.79086 0 0 1.79086 0 4V16C0 18.2091 1.79086 20 4 20H16C18.2091 20 20 18.2091 20 16V4C20 1.79086 18.2091 0 16 0H4ZM8.5 2.75C8.5 2.33579 8.16421 2 7.75 2C7.33579 2 7 2.33579 7 2.75V7H2.75C2.33579 7 2 7.33579 2 7.75C2 8.16421 2.33579 8.5 2.75 8.5H7V17.25C7 17.6642 7.33579 18 7.75 18C8.16421 18 8.5 17.6642 8.5 17.25V8.5H17.25C17.6642 8.5 18 8.16421 18 7.75C18 7.33579 17.6642 7 17.25 7H8.5V2.75Z",
      fill: "#1D7C4D"
    }, null, -1)
  ])]);
}
const _R = { render: M3 }, SR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _R,
  render: M3
}, Symbol.toStringTag, { value: "Module" })), xR = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function A3(e, t) {
  return f(), v("svg", xR, [...t[0] || (t[0] = [
    g("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M4 0C1.79086 0 0 1.79086 0 4V16C0 18.2091 1.79086 20 4 20H16C18.2091 20 20 18.2091 20 16V4C20 1.79086 18.2091 0 16 0H4ZM6.46679 6.52939C6.34497 6.13349 5.92529 5.91131 5.52939 6.03312C5.13349 6.15494 4.91131 6.57462 5.03312 6.97052L7.03312 13.4705C7.12131 13.7571 7.37174 13.9637 7.6699 13.9957C7.96806 14.0277 8.25662 13.879 8.40364 13.6177L9.99996 10.7798L11.5963 13.6177C11.7433 13.879 12.0319 14.0277 12.33 13.9957C12.6282 13.9637 12.8786 13.7571 12.9668 13.4705L14.9668 6.97052C15.0886 6.57462 14.8664 6.15494 14.4705 6.03312C14.0746 5.91131 13.6549 6.13349 13.5331 6.52939L12.047 11.3593L10.6536 8.88226C10.5208 8.6461 10.2709 8.49996 9.99996 8.49996C9.729 8.49996 9.47911 8.6461 9.34627 8.88226L7.95292 11.3593L6.46679 6.52939Z",
      fill: "#3062D4"
    }, null, -1)
  ])]);
}
const MR = { render: A3 }, AR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: MR,
  render: A3
}, Symbol.toStringTag, { value: "Module" })), LR = {
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function L3(e, t) {
  return f(), v("svg", LR, [...t[0] || (t[0] = [
    g("path", {
      d: "M13.4808 4.16346C14.3889 4.16346 15.125 3.42731 15.125 2.51923C15.125 1.61115 14.3889 0.875 13.4808 0.875C12.5727 0.875 11.8365 1.61115 11.8365 2.51923M13.4808 4.16346C12.5727 4.16346 11.8365 3.42731 11.8365 2.51923M13.4808 4.16346V11.8365M11.8365 2.51923H4.16346M11.8365 13.4808C11.8365 14.3889 12.5727 15.125 13.4808 15.125C14.3889 15.125 15.125 14.3889 15.125 13.4808C15.125 12.5727 14.3889 11.8365 13.4808 11.8365M11.8365 13.4808C11.8365 12.5727 12.5727 11.8365 13.4808 11.8365M11.8365 13.4808H4.16346M4.16346 2.51923C4.16346 3.42731 3.42731 4.16346 2.51923 4.16346M4.16346 2.51923C4.16346 1.61115 3.42731 0.875 2.51923 0.875C1.61115 0.875 0.875 1.61115 0.875 2.51923C0.875 3.42731 1.61115 4.16346 2.51923 4.16346M2.51923 4.16346V11.8365M4.16346 13.4808C4.16346 14.3889 3.42731 15.125 2.51923 15.125C1.61115 15.125 0.875 14.3889 0.875 13.4808C0.875 12.5727 1.61115 11.8365 2.51923 11.8365M4.16346 13.4808C4.16346 12.5727 3.42731 11.8365 2.51923 11.8365",
      stroke: "black",
      "stroke-linecap": "round"
    }, null, -1)
  ])]);
}
const ER = { render: L3 }, PR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ER,
  render: L3
}, Symbol.toStringTag, { value: "Module" })), RR = {
  viewBox: "0 0 20 20",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
function E3(e, t) {
  return f(), v("svg", RR, [...t[0] || (t[0] = [
    g("path", {
      id: "Icon",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M9.90284 2L12.7972 2.00439C14.1019 2.00637 15.3922 2.2766 16.588 2.79828L17.7868 3.32129C19.1171 3.90166 19.9788 5.21329 19.9833 6.6647L20 12.0537C20.0045 13.5268 18.8218 14.7257 17.3535 14.7458C17.2924 14.8951 17.2137 15.0737 17.1185 15.262C16.9414 15.6126 16.6811 16.05 16.3357 16.385C15.9912 16.7192 15.4405 17.0588 14.7544 16.8885C14.1272 16.7329 13.6315 16.2021 13.2157 15.4783L11.0615 12.0964C10.8443 11.7555 10.9447 11.303 11.2857 11.0858C11.6266 10.8686 12.0791 10.9689 12.2963 11.3099L14.4693 14.7213L14.4781 14.7368C14.8363 15.3645 15.0705 15.4586 15.107 15.4676C15.1075 15.4677 15.1079 15.4678 15.1084 15.468C15.1135 15.4693 15.1187 15.4707 15.1397 15.4625C15.1724 15.4497 15.2328 15.4152 15.3164 15.3342C15.4894 15.1663 15.6623 14.8977 15.8119 14.6017C15.8961 14.4351 15.9646 14.2766 16.015 14.1509L12.4354 8.1308C12.1577 7.66374 11.4293 7.26252 10.7619 7.20318C10.6318 7.19161 10.5753 7.21216 10.5328 7.2337C10.4669 7.26716 10.3771 7.33547 10.2101 7.50524L8.29221 9.45492L8.25155 9.48607C7.62637 9.9652 7.00629 10.1885 6.40767 10.1806C5.81282 10.1729 5.33062 9.93812 4.97496 9.66871C4.46102 9.27941 4.26624 8.71366 4.28178 8.18018C4.29679 7.66487 4.50278 7.16307 4.80562 6.76761L7.21835 3.61703C7.82107 2.85705 8.44753 2.448 8.95337 2.23178C9.20404 2.12463 9.42019 2.06692 9.58279 2.03591C9.66404 2.02041 9.73192 2.01159 9.78411 2.00657C9.81022 2.00406 9.83243 2.00249 9.85046 2.00153L9.87436 2.00048L9.88391 2.00021L9.88807 2.00013L9.88999 2.00009C9.89044 2.00009 9.89181 2.00007 9.90172 2.73201L9.89182 2.00007L9.90284 2ZM9.92235 3.46406C9.91166 3.46515 9.88937 3.46785 9.85704 3.47402C9.78833 3.48712 9.67416 3.51585 9.52881 3.57798C9.24338 3.69999 8.81646 3.95975 8.36923 4.52213L5.96797 7.65774C5.82266 7.84748 5.74995 8.05941 5.74519 8.2228C5.74096 8.36802 5.78534 8.44593 5.85896 8.50169C6.0363 8.63603 6.22307 8.71408 6.42679 8.71674C6.62062 8.71927 6.91605 8.65482 7.3222 8.35332L9.16635 6.47857C9.35409 6.28772 9.58158 6.0747 9.87025 5.92818C10.1824 5.76974 10.5178 5.71167 10.8916 5.7449C11.8941 5.83405 13.1147 6.40858 13.6938 7.38257L17.2016 13.282H17.3159C17.9912 13.282 18.5381 12.7335 18.536 12.0582L18.5193 6.66923C18.5166 5.79838 17.9996 5.0114 17.2014 4.66318L16.0026 4.14017C14.9907 3.69875 13.8989 3.4701 12.795 3.46842L9.92235 3.46406ZM1.19712e-06 6.56585C-0.00161701 4.5433 1.63753 2.90285 3.66007 2.90285H5.78592C6.1902 2.90285 6.51794 3.23058 6.51794 3.63486C6.51794 4.03914 6.1902 4.36688 5.78592 4.36688H3.66007C2.44654 4.36688 1.46306 5.35115 1.46403 6.56467L1.46806 11.598C1.46816 11.7326 1.57738 11.8418 1.71206 11.8418H2.70987L5.48044 16.6066C5.68558 16.9525 5.91763 17.0797 6.10902 17.1334C6.32372 17.1937 6.54162 17.1744 6.69152 17.1424C7.08688 17.058 7.47583 17.3101 7.56025 17.7055C7.64467 18.1008 7.3926 18.4898 6.99723 18.5742C6.71087 18.6353 6.23506 18.6895 5.71313 18.5429C5.16829 18.3899 4.62136 18.0302 4.21892 17.3495L4.21622 17.3449L1.86762 13.3058H1.71206C0.769275 13.3058 0.00478239 12.5419 0.00402815 11.5991L1.19712e-06 6.56585ZM8.99242 12.6609C9.34597 12.4648 9.79153 12.5925 9.98761 12.946L11.5217 15.7119C11.5238 15.7157 11.5258 15.7195 11.5279 15.7234C11.7695 16.125 11.9589 16.1571 12.0317 16.1644C12.1766 16.1791 12.339 16.1246 12.5763 16.0238C12.9484 15.8657 13.3782 16.0392 13.5363 16.4113C13.6943 16.7834 13.5208 17.2132 13.1487 17.3713C13.1422 17.374 13.1354 17.3769 13.1283 17.38C12.9084 17.4737 12.433 17.6764 11.8849 17.6211C11.249 17.557 10.6763 17.1751 10.2409 16.423C10.2319 16.4075 10.2236 16.3919 10.2159 16.3761L8.70732 13.6561C8.51124 13.3026 8.63888 12.857 8.99242 12.6609ZM6.76581 14.4756C7.11636 14.2742 7.5638 14.3952 7.76518 14.7457L8.72626 16.4187C8.74214 16.4413 8.75691 16.465 8.77045 16.4898C8.89382 16.7155 9.0001 16.8039 9.0546 16.838C9.10488 16.8694 9.14282 16.8749 9.17585 16.8743C9.21715 16.8735 9.26207 16.8618 9.30192 16.8451C9.32029 16.8375 9.33318 16.8306 9.33862 16.8275C9.33852 16.8275 9.33873 16.8274 9.33862 16.8275C9.66989 16.6097 10.1165 16.6951 10.343 17.023C10.5729 17.3556 10.4895 17.8115 10.1569 18.0414L9.74081 17.4391C10.1569 18.0414 10.1573 18.0411 10.1569 18.0414L10.1554 18.0424L10.1538 18.0435L10.1503 18.0459L10.1421 18.0514C10.1361 18.0554 10.129 18.06 10.1209 18.0651C10.1048 18.0753 10.0844 18.0876 10.0601 18.1014C10.0119 18.1287 9.94656 18.1625 9.86681 18.1958C9.71044 18.2612 9.47958 18.333 9.20263 18.3381C8.9174 18.3433 8.59463 18.2769 8.27883 18.0796C7.98463 17.8958 7.73181 17.6206 7.52241 17.2572C7.51093 17.2405 7.50004 17.2233 7.48979 17.2055L6.49571 15.475C6.29433 15.1244 6.41526 14.677 6.76581 14.4756Z"
    }, null, -1)
  ])]);
}
const FR = { render: E3 }, TR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: FR,
  render: E3
}, Symbol.toStringTag, { value: "Module" })), IR = {
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function P3(e, t) {
  return f(), v("svg", IR, [...t[0] || (t[0] = [
    g("path", {
      d: "M6.5 16.5237H7H6.5ZM6.5 24.0439H6H6.5ZM24.0385 25.5V25V25.5ZM7.96154 25.5V26H7.96154L7.96154 25.5ZM25.5 16.5238H25H25.5ZM25.5 24.0439H26H25.5ZM24.7266 14.5504L24.3595 14.8899L24.7266 14.5504ZM18.1497 7.43887L17.7826 7.77836L18.1497 7.43887ZM13.8503 7.43887L14.2174 7.77835L13.8503 7.43887ZM7.27339 14.5504L6.9063 14.2109H6.9063L7.27339 14.5504ZM13.0769 18.2194H13.5769H13.0769ZM13.0769 24.7719H12.5769H13.0769ZM18.1923 25.5V25V25.5ZM13.8077 25.5V26V25.5ZM18.9231 18.2195L19.4231 18.2195V18.2195H18.9231ZM18.9231 24.7719H18.4231H18.9231ZM18.1923 17.4914L18.1923 17.9914L18.1923 17.4914ZM13.8077 17.4914L13.8077 17.9914H13.8077L13.8077 17.4914ZM6 16.5237L6 24.0439H7L7 16.5237H6ZM24.0385 25L7.96154 25L7.96154 26L24.0385 26V25ZM25 16.5238V24.0439H26V16.5238H25ZM25.0937 14.2109L18.5168 7.09939L17.7826 7.77836L24.3595 14.8899L25.0937 14.2109ZM13.4832 7.09938L6.9063 14.2109L7.64047 14.8899L14.2174 7.77835L13.4832 7.09938ZM18.5168 7.09939C17.1611 5.63354 14.8389 5.63354 13.4832 7.09938L14.2174 7.77835C15.1772 6.74055 16.8228 6.74055 17.7826 7.77836L18.5168 7.09939ZM26 16.5238C26 15.6665 25.6763 14.8409 25.0937 14.2109L24.3595 14.8899C24.7715 15.3354 25 15.9187 25 16.5238H26ZM7 16.5237C7 15.9186 7.22845 15.3354 7.64047 14.8899L6.9063 14.2109C6.32371 14.8409 6 15.6665 6 16.5237H7ZM6 24.0439C6 25.126 6.87996 26 7.96154 26V25C7.42874 25 7 24.5702 7 24.0439H6ZM24.0385 26C25.12 26 26 25.126 26 24.0439H25C25 24.5702 24.5713 25 24.0385 25V26ZM12.5769 18.2194L12.5769 24.7719H13.5769L13.5769 18.2194H12.5769ZM18.1923 25H13.8077V26H18.1923V25ZM18.4231 18.2195L18.4231 24.7719H19.4231L19.4231 18.2195L18.4231 18.2195ZM18.1923 16.9914L13.8077 16.9914L13.8077 17.9914L18.1923 17.9914L18.1923 16.9914ZM19.4231 18.2195C19.4231 17.5395 18.8703 16.9914 18.1923 16.9914L18.1923 17.9914C18.3215 17.9914 18.4231 18.0953 18.4231 18.2195H19.4231ZM13.5769 18.2194C13.5769 18.0952 13.6785 17.9914 13.8077 17.9914L13.8077 16.9914C13.1297 16.9914 12.5769 17.5395 12.5769 18.2194H13.5769ZM12.5769 24.7719C12.5769 25.4519 13.1297 26 13.8077 26V25C13.6785 25 13.5769 24.8961 13.5769 24.7719H12.5769ZM18.1923 26C18.8703 26 19.4231 25.4519 19.4231 24.7719H18.4231C18.4231 24.8961 18.3215 25 18.1923 25V26Z",
      fill: "#4D4D4D"
    }, null, -1)
  ])]);
}
const DR = { render: P3 }, kR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: DR,
  render: P3
}, Symbol.toStringTag, { value: "Module" })), HR = {
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function R3(e, t) {
  return f(), v("svg", HR, [...t[0] || (t[0] = [
    g("path", {
      d: "M16 21.2778V14.9444M16 12.3056V10.7222M25.5 16C25.5 21.2467 21.2467 25.5 16 25.5C10.7533 25.5 6.5 21.2467 6.5 16C6.5 10.7533 10.7533 6.5 16 6.5C21.2467 6.5 25.5 10.7533 25.5 16Z",
      stroke: "#4D4D4D",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const VR = { render: R3 }, OR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: VR,
  render: R3
}, Symbol.toStringTag, { value: "Module" })), BR = {
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function F3(e, t) {
  return f(), v("svg", BR, [...t[0] || (t[0] = [
    g("path", {
      d: "M8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0ZM5.46582 4.72754V12H6.7832V9.33691H8.12402L9.55273 12H11.0225L9.44922 9.12012C9.49658 9.10102 9.54294 9.08121 9.58789 9.05957C9.97141 8.87254 10.2615 8.60849 10.458 8.26758C10.6568 7.92441 10.7568 7.5199 10.7568 7.05371C10.7568 6.5897 10.6584 6.18297 10.4619 5.83496C10.2678 5.48467 9.97972 5.21265 9.59863 5.01855C9.21988 4.82449 8.75101 4.72754 8.19238 4.72754H5.46582ZM7.99023 5.82812C8.31909 5.82813 8.58762 5.87669 8.7959 5.97363C9.0042 6.06832 9.15992 6.20795 9.26172 6.39258C9.36352 6.57487 9.41406 6.79566 9.41406 7.05371C9.41401 7.31158 9.36346 7.52957 9.26172 7.70703C9.16228 7.88214 9.00807 8.0161 8.7998 8.1084C8.5915 8.1983 8.32366 8.24316 7.99707 8.24316H6.7832V5.82812H7.99023Z",
      fill: "#555F6D"
    }, null, -1)
  ])]);
}
const $R = { render: F3 }, ZR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: $R,
  render: F3
}, Symbol.toStringTag, { value: "Module" })), GR = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function T3(e, t) {
  return f(), v("svg", GR, [...t[0] || (t[0] = [
    g("path", {
      d: "M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z",
      stroke: "#4D4D4D",
      "stroke-width": "2"
    }, null, -1),
    g("path", {
      d: "M20 4H4V20H20V4Z",
      stroke: "#4D4D4D",
      "stroke-width": "2"
    }, null, -1)
  ])]);
}
const NR = { render: T3 }, zR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: NR,
  render: T3
}, Symbol.toStringTag, { value: "Module" })), jR = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function I3(e, t) {
  return f(), v("svg", jR, [...t[0] || (t[0] = [
    g("path", {
      d: "M5 10H19",
      stroke: "#4D4D4D",
      "stroke-width": "2"
    }, null, -1),
    g("path", {
      d: "M5 14H19",
      stroke: "#4D4D4D",
      "stroke-width": "2"
    }, null, -1)
  ])]);
}
const WR = { render: I3 }, UR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: WR,
  render: I3
}, Symbol.toStringTag, { value: "Module" })), KR = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function D3(e, t) {
  return f(), v("svg", KR, [...t[0] || (t[0] = [
    g("path", {
      d: "M9 6L15 12L9 18",
      stroke: "#4D4D4D",
      "stroke-width": "2"
    }, null, -1)
  ])]);
}
const qR = { render: D3 }, YR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: qR,
  render: D3
}, Symbol.toStringTag, { value: "Module" })), QR = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function k3(e, t) {
  return f(), v("svg", QR, [...t[0] || (t[0] = [
    g("path", {
      d: "M9 6L15 12L9 18",
      stroke: "#4D4D4D",
      "stroke-width": "2"
    }, null, -1),
    g("path", {
      d: "M6 20H18",
      stroke: "#4D4D4D",
      "stroke-width": "2"
    }, null, -1)
  ])]);
}
const JR = { render: k3 }, XR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: JR,
  render: k3
}, Symbol.toStringTag, { value: "Module" })), eF = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function H3(e, t) {
  return f(), v("svg", eF, [...t[0] || (t[0] = [
    g("path", {
      d: "M15 6L9 12L15 18",
      stroke: "#4D4D4D",
      "stroke-width": "2"
    }, null, -1)
  ])]);
}
const tF = { render: H3 }, oF = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: tF,
  render: H3
}, Symbol.toStringTag, { value: "Module" })), nF = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function V3(e, t) {
  return f(), v("svg", nF, [...t[0] || (t[0] = [
    g("path", {
      d: "M15 6L9 12L15 18",
      stroke: "#4D4D4D",
      "stroke-width": "2"
    }, null, -1),
    g("path", {
      d: "M6 20H18",
      stroke: "#4D4D4D",
      "stroke-width": "2"
    }, null, -1)
  ])]);
}
const sF = { render: V3 }, iF = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sF,
  render: V3
}, Symbol.toStringTag, { value: "Module" })), rF = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function O3(e, t) {
  return f(), v("svg", rF, [...t[0] || (t[0] = [
    g("path", {
      d: "M5 10H19",
      stroke: "#4D4D4D",
      "stroke-width": "2"
    }, null, -1),
    g("path", {
      d: "M5 14H19",
      stroke: "#4D4D4D",
      "stroke-width": "2"
    }, null, -1),
    g("path", {
      d: "M6 6L18 18",
      stroke: "#4D4D4D",
      "stroke-width": "2"
    }, null, -1)
  ])]);
}
const lF = { render: O3 }, aF = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: lF,
  render: O3
}, Symbol.toStringTag, { value: "Module" })), cF = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function B3(e, t) {
  return f(), v("svg", cF, [...t[0] || (t[0] = [
    g("path", {
      d: "M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z",
      stroke: "#4D4D4D",
      "stroke-width": "2"
    }, null, -1),
    g("path", {
      d: "M20 4H4V20H20V4Z",
      stroke: "#4D4D4D",
      "stroke-width": "2"
    }, null, -1),
    g("path", {
      d: "M5 5L19 19",
      stroke: "#4D4D4D",
      "stroke-width": "2"
    }, null, -1)
  ])]);
}
const dF = { render: B3 }, uF = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: dF,
  render: B3
}, Symbol.toStringTag, { value: "Module" })), hF = {
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function $3(e, t) {
  return f(), v("svg", hF, [...t[0] || (t[0] = [
    g("path", {
      d: "M13 2H3C2.73478 2 2.48043 2.10536 2.29289 2.29289C2.10536 2.48043 2 2.73478 2 3V13C2 13.2652 2.10536 13.5196 2.29289 13.7071C2.48043 13.8946 2.73478 14 3 14H13C13.2652 14 13.5196 13.8946 13.7071 13.7071C13.8946 13.5196 14 13.2652 14 13V3C14 2.73478 13.8946 2.48043 13.7071 2.29289C13.5196 2.10536 13.2652 2 13 2ZM13 13H3V3H13V13Z",
      fill: "#4A545E"
    }, null, -1),
    g("path", {
      d: "M6 10.6667V4.66667H7.16575V9.75553H10V10.6667H6Z",
      fill: "#4A545E"
    }, null, -1)
  ])]);
}
const gF = { render: $3 }, pF = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: gF,
  render: $3
}, Symbol.toStringTag, { value: "Module" })), fF = {
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Z3(e, t) {
  return f(), v("svg", fF, [...t[0] || (t[0] = [
    g("path", {
      d: "M13 2H3C2.73478 2 2.48043 2.10536 2.29289 2.29289C2.10536 2.48043 2 2.73478 2 3V13C2 13.2652 2.10536 13.5196 2.29289 13.7071C2.48043 13.8946 2.73478 14 3 14H13C13.2652 14 13.5196 13.8946 13.7071 13.7071C13.8946 13.5196 14 13.2652 14 13V3C14 2.73478 13.8946 2.48043 13.7071 2.29289C13.5196 2.10536 13.2652 2 13 2ZM13 13H3V3H13V13Z",
      fill: "#4A545E"
    }, null, -1),
    g("path", {
      d: "M4.66667 4.66667H6.07573L7.96276 9.01432H8.03724L9.92427 4.66667H11.3333V10.6667H10.2284V6.5446H10.1695L8.41279 10.6491H7.58721L5.83054 6.53581H5.77157V10.6667H4.66667V4.66667Z",
      fill: "#4A545E"
    }, null, -1)
  ])]);
}
const vF = { render: Z3 }, mF = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: vF,
  render: Z3
}, Symbol.toStringTag, { value: "Module" })), CF = {
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function G3(e, t) {
  return f(), v("svg", CF, [...t[0] || (t[0] = [
    g("path", {
      d: "M13 2H3C2.73478 2 2.48043 2.10536 2.29289 2.29289C2.10536 2.48043 2 2.73478 2 3V13C2 13.2652 2.10536 13.5196 2.29289 13.7071C2.48043 13.8946 2.73478 14 3 14H13C13.2652 14 13.5196 13.8946 13.7071 13.7071C13.8946 13.5196 14 13.2652 14 13V3C14 2.73478 13.8946 2.48043 13.7071 2.29289C13.5196 2.10536 13.2652 2 13 2ZM13 13H3V3H13V13Z",
      fill: "#4A545E"
    }, null, -1),
    g("path", {
      d: "M9.06942 6.44792C9.04291 6.19981 8.93117 6.00663 8.7342 5.86837C8.53912 5.73012 8.28533 5.66099 7.97283 5.66099C7.75314 5.66099 7.56469 5.69413 7.40749 5.76042C7.2503 5.82671 7.13003 5.91667 7.0467 6.0303C6.96336 6.14394 6.92075 6.27368 6.91886 6.41951C6.91886 6.54072 6.94632 6.64584 7.00124 6.73485C7.05806 6.82387 7.13477 6.89962 7.23136 6.96212C7.32795 7.02273 7.43496 7.07387 7.55238 7.11553C7.6698 7.1572 7.78817 7.19224 7.90749 7.22065L8.45295 7.35701C8.67264 7.40815 8.88382 7.47727 9.08647 7.5644C9.29102 7.65152 9.47378 7.76137 9.63477 7.89394C9.79764 8.02652 9.92643 8.18655 10.0211 8.37405C10.1158 8.56155 10.1632 8.78125 10.1632 9.03315C10.1632 9.37406 10.0761 9.67424 9.90181 9.93371C9.72757 10.1913 9.47567 10.393 9.14613 10.5388C8.81848 10.6828 8.4217 10.7547 7.95579 10.7547C7.50314 10.7547 7.11014 10.6847 6.77681 10.5445C6.44537 10.4044 6.1859 10.1998 5.9984 9.93087C5.8128 9.66193 5.71242 9.33428 5.69727 8.94792H6.7342C6.74935 9.15057 6.81185 9.31913 6.9217 9.4536C7.03155 9.58807 7.17454 9.68845 7.35067 9.75474C7.52871 9.82103 7.72757 9.85417 7.94727 9.85417C8.17643 9.85417 8.37719 9.82008 8.54954 9.7519C8.72378 9.68182 8.86014 9.58523 8.95863 9.46212C9.05711 9.33712 9.1073 9.19129 9.1092 9.02462C9.1073 8.87311 9.0628 8.74811 8.97567 8.64962C8.88855 8.54924 8.76639 8.46591 8.6092 8.39962C8.45389 8.33144 8.27208 8.27084 8.06374 8.2178L7.40181 8.04735C6.92264 7.92424 6.54386 7.73769 6.26545 7.48769C5.98893 7.2358 5.85067 6.90152 5.85067 6.48485C5.85067 6.14205 5.94348 5.84186 6.12908 5.58428C6.31658 5.32671 6.57132 5.1269 6.89329 4.98485C7.21526 4.84091 7.57984 4.76894 7.98704 4.76894C8.39992 4.76894 8.76166 4.84091 9.07227 4.98485C9.38477 5.1269 9.63003 5.32481 9.80806 5.5786C9.98609 5.83049 10.0779 6.12027 10.0836 6.44792H9.06942Z",
      fill: "#4A545E"
    }, null, -1)
  ])]);
}
const wF = { render: G3 }, bF = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: wF,
  render: G3
}, Symbol.toStringTag, { value: "Module" })), yF = {
  viewBox: "0 0 9 5",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function N3(e, t) {
  return f(), v("svg", yF, [...t[0] || (t[0] = [
    g("path", {
      d: "M3.91504 4.71191L0.16504 0.961913C0.0593681 0.85624 1.87619e-06 0.712918 1.88272e-06 0.563475C1.88925e-06 0.414032 0.0593681 0.27071 0.16504 0.165038C0.270712 0.0593655 0.414035 -3.57885e-07 0.563478 -3.52466e-07C0.712921 -3.47047e-07 0.856243 0.0593656 0.961915 0.165038L4.31301 3.51707L7.66504 0.165976C7.71736 0.113652 7.77948 0.0721467 7.84784 0.0438294C7.91621 0.0155121 7.98948 0.000937315 8.06348 0.000937318C8.13747 0.000937321 8.21075 0.0155121 8.27911 0.0438294C8.34747 0.0721467 8.40959 0.113652 8.46191 0.165976C8.51424 0.218299 8.55574 0.280416 8.58406 0.34878C8.61238 0.417145 8.62695 0.490417 8.62695 0.564413C8.62695 0.63841 8.61238 0.711682 8.58406 0.780046C8.55574 0.84841 8.51424 0.910527 8.46191 0.962851L4.71191 4.71285C4.6596 4.76523 4.59745 4.80676 4.52904 4.83507C4.46064 4.86338 4.38732 4.87791 4.31328 4.87783C4.23925 4.87774 4.16596 4.86304 4.09762 4.83457C4.02928 4.8061 3.96724 4.76441 3.91504 4.71191Z",
      fill: "#4A545E"
    }, null, -1)
  ])]);
}
const _F = { render: N3 }, SF = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _F,
  render: N3
}, Symbol.toStringTag, { value: "Module" })), xF = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function z3(e, t) {
  return f(), v("svg", xF, [...t[0] || (t[0] = [
    g("path", { d: "M83.19,174.4a8,8,0,0,0,11.21-1.6,52,52,0,0,1,83.2,0,8,8,0,1,0,12.8-9.6A67.88,67.88,0,0,0,163,141.51a40,40,0,1,0-53.94,0A67.88,67.88,0,0,0,81.6,163.2,8,8,0,0,0,83.19,174.4ZM112,112a24,24,0,1,1,24,24A24,24,0,0,1,112,112Zm96-88H64A16,16,0,0,0,48,40V64H32a8,8,0,0,0,0,16H48v40H32a8,8,0,0,0,0,16H48v40H32a8,8,0,0,0,0,16H48v24a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V40A16,16,0,0,0,208,24Zm0,192H64V40H208Z" }, null, -1)
  ])]);
}
const MF = { render: z3 }, AF = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: MF,
  render: z3
}, Symbol.toStringTag, { value: "Module" })), LF = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function j3(e, t) {
  return f(), v("svg", LF, [...t[0] || (t[0] = [
    g("path", { d: "M40,56V200a8,8,0,0,1-16,0V56a8,8,0,0,1,16,0ZM240,96v64a16,16,0,0,1-16,16H72a16,16,0,0,1-16-16V96A16,16,0,0,1,72,80H224A16,16,0,0,1,240,96Zm-16,64V96H72v64H224Z" }, null, -1)
  ])]);
}
const EF = { render: j3 }, PF = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: EF,
  render: j3
}, Symbol.toStringTag, { value: "Module" })), RF = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function W3(e, t) {
  return f(), v("svg", RF, [...t[0] || (t[0] = [
    g("path", { d: "M48,40V216a8,8,0,0,1-16,0V40a8,8,0,0,1,16,0Zm16,64V64A16,16,0,0,1,80,48h96a16,16,0,0,1,16,16v40a16,16,0,0,1-16,16H80A16,16,0,0,1,64,104Zm16,0h96V64H80Zm152,48v40a16,16,0,0,1-16,16H80a16,16,0,0,1-16-16V152a16,16,0,0,1,16-16H216A16,16,0,0,1,232,152Zm-16,40V152H80v40H216Z" }, null, -1)
  ])]);
}
const FF = { render: W3 }, TF = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: FF,
  render: W3
}, Symbol.toStringTag, { value: "Module" })), IF = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256"
};
function U3(e, t) {
  return f(), v("svg", IF, [...t[0] || (t[0] = [
    g("rect", {
      width: "256",
      height: "256",
      fill: "none"
    }, null, -1),
    g("polyline", {
      points: "80 152 32 104 80 56",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1),
    g("polyline", {
      points: "128 152 80 104 128 56",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1),
    g("path", {
      d: "M224,200a96,96,0,0,0-96-96H80",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1)
  ])]);
}
const DF = { render: U3 }, kF = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: DF,
  render: U3
}, Symbol.toStringTag, { value: "Module" })), HF = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256"
};
function K3(e, t) {
  return f(), v("svg", HF, [...t[0] || (t[0] = [
    g("rect", {
      width: "256",
      height: "256",
      fill: "none"
    }, null, -1),
    g("polyline", {
      points: "80 152 32 104 80 56",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1),
    g("path", {
      d: "M224,200a96,96,0,0,0-96-96H32",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1)
  ])]);
}
const VF = { render: K3 }, OF = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: VF,
  render: K3
}, Symbol.toStringTag, { value: "Module" })), BF = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256"
};
function q3(e, t) {
  return f(), v("svg", BF, [...t[0] || (t[0] = [
    g("rect", {
      width: "256",
      height: "256",
      fill: "none"
    }, null, -1),
    g("polyline", {
      points: "176 152 224 104 176 56",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1),
    g("path", {
      d: "M32,200a96,96,0,0,1,96-96h96",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1)
  ])]);
}
const $F = { render: q3 }, ZF = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: $F,
  render: q3
}, Symbol.toStringTag, { value: "Module" })), GF = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function Y3(e, t) {
  return f(), v("svg", GF, [...t[0] || (t[0] = [
    g("path", { d: "M224,128a96,96,0,0,1-94.71,96H128A95.38,95.38,0,0,1,62.1,197.8a8,8,0,0,1,11-11.63A80,80,0,1,0,71.43,71.39a3.07,3.07,0,0,1-.26.25L44.59,96H72a8,8,0,0,1,0,16H24a8,8,0,0,1-8-8V56a8,8,0,0,1,16,0V85.8L60.25,60A96,96,0,0,1,224,128Z" }, null, -1)
  ])]);
}
const NF = { render: Y3 }, zF = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: NF,
  render: Y3
}, Symbol.toStringTag, { value: "Module" })), jF = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256"
};
function Q3(e, t) {
  return f(), v("svg", jF, [...t[0] || (t[0] = [
    g("rect", {
      width: "256",
      height: "256",
      fill: "none"
    }, null, -1),
    g("line", {
      x1: "128",
      y1: "40",
      x2: "128",
      y2: "216",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1),
    g("polyline", {
      points: "56 144 128 216 200 144",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1)
  ])]);
}
const WF = { render: Q3 }, UF = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: WF,
  render: Q3
}, Symbol.toStringTag, { value: "Module" })), KF = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function J3(e, t) {
  return f(), v("svg", KF, [...t[0] || (t[0] = [
    g("path", { d: "M189.66,122.34a8,8,0,0,1,0,11.32l-72,72a8,8,0,0,1-11.32-11.32L164.69,136H32a8,8,0,0,1,0-16H164.69L106.34,61.66a8,8,0,0,1,11.32-11.32ZM216,32a8,8,0,0,0-8,8V216a8,8,0,0,0,16,0V40A8,8,0,0,0,216,32Z" }, null, -1)
  ])]);
}
const qF = { render: J3 }, YF = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: qF,
  render: J3
}, Symbol.toStringTag, { value: "Module" })), QF = {
  viewBox: "0 0 21 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function X3(e, t) {
  return f(), v("svg", QF, [...t[0] || (t[0] = [
    g("path", {
      d: "M18.1536 8.125C18.1536 8.29076 18.0877 8.44973 17.9705 8.56694C17.8533 8.68415 17.6943 8.75 17.5286 8.75C17.3628 8.75 17.2038 8.68415 17.0866 8.56694C16.9694 8.44973 16.9036 8.29076 16.9036 8.125V4.63438L11.7215 9.81719C11.6043 9.93446 11.4452 10.0003 11.2793 10.0003C11.1135 10.0003 10.9544 9.93446 10.8372 9.81719C10.7199 9.69991 10.654 9.54085 10.654 9.375C10.654 9.20915 10.7199 9.05009 10.8372 8.93281L16.0192 3.75H12.5286C12.3628 3.75 12.2038 3.68415 12.0866 3.56694C11.9694 3.44973 11.9036 3.29076 11.9036 3.125C11.9036 2.95924 11.9694 2.80027 12.0866 2.68306C12.2038 2.56585 12.3628 2.5 12.5286 2.5H17.5286C17.6943 2.5 17.8533 2.56585 17.9705 2.68306C18.0877 2.80027 18.1536 2.95924 18.1536 3.125V8.125ZM15.0286 10C14.8628 10 14.7038 10.0658 14.5866 10.1831C14.4694 10.3003 14.4036 10.4592 14.4036 10.625V16.25H4.40356V6.25H10.0286C10.1943 6.25 10.3533 6.18415 10.4705 6.06694C10.5877 5.94973 10.6536 5.79076 10.6536 5.625C10.6536 5.45924 10.5877 5.30027 10.4705 5.18306C10.3533 5.06585 10.1943 5 10.0286 5H4.40356C4.07204 5 3.7541 5.1317 3.51968 5.36612C3.28526 5.60054 3.15356 5.91848 3.15356 6.25V16.25C3.15356 16.5815 3.28526 16.8995 3.51968 17.1339C3.7541 17.3683 4.07204 17.5 4.40356 17.5H14.4036C14.7351 17.5 15.053 17.3683 15.2874 17.1339C15.5219 16.8995 15.6536 16.5815 15.6536 16.25V10.625C15.6536 10.4592 15.5877 10.3003 15.4705 10.1831C15.3533 10.0658 15.1943 10 15.0286 10Z",
      fill: "currentColor"
    }, null, -1)
  ])]);
}
const JF = { render: X3 }, XF = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: JF,
  render: X3
}, Symbol.toStringTag, { value: "Module" })), eT = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256"
};
function eh(e, t) {
  return f(), v("svg", eT, [...t[0] || (t[0] = [
    g("rect", {
      width: "256",
      height: "256",
      fill: "none"
    }, null, -1),
    g("line", {
      x1: "128",
      y1: "216",
      x2: "128",
      y2: "40",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1),
    g("polyline", {
      points: "56 112 128 40 200 112",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1)
  ])]);
}
const tT = { render: eh }, oT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: tT,
  render: eh
}, Symbol.toStringTag, { value: "Module" })), nT = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256"
};
function th(e, t) {
  return f(), v("svg", nT, [...t[0] || (t[0] = [
    Do('<rect width="256" height="256" fill="none"></rect><polyline points="88 96 40 96 40 48" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></polyline><path d="M40,96,68.28,67.72A88,88,0,0,1,192,67" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></path><polyline points="168 160 216 160 216 208" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></polyline><path d="M216,160l-28.28,28.28A88,88,0,0,1,64,189" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></path>', 5)
  ])]);
}
const sT = { render: th }, iT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sT,
  render: th
}, Symbol.toStringTag, { value: "Module" })), rT = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function oh(e, t) {
  return f(), v("svg", rT, [...t[0] || (t[0] = [
    g("path", { d: "M117.66,170.34a8,8,0,0,1,0,11.32l-32,32a8,8,0,0,1-11.32,0l-32-32a8,8,0,0,1,11.32-11.32L72,188.69V48a8,8,0,0,1,16,0V188.69l18.34-18.35A8,8,0,0,1,117.66,170.34Zm96-96-32-32a8,8,0,0,0-11.32,0l-32,32a8,8,0,0,0,11.32,11.32L168,67.31V208a8,8,0,0,0,16,0V67.31l18.34,18.35a8,8,0,0,0,11.32-11.32Z" }, null, -1)
  ])]);
}
const lT = { render: oh }, aT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: lT,
  render: oh
}, Symbol.toStringTag, { value: "Module" })), cT = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256"
};
function nh(e, t) {
  return f(), v("svg", cT, [...t[0] || (t[0] = [
    g("rect", {
      width: "256",
      height: "256",
      fill: "none"
    }, null, -1),
    g("polyline", {
      points: "56 96 24 128 56 160",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1),
    g("polyline", {
      points: "200 96 232 128 200 160",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1),
    g("line", {
      x1: "24",
      y1: "128",
      x2: "232",
      y2: "128",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1)
  ])]);
}
const dT = { render: nh }, uT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: dT,
  render: nh
}, Symbol.toStringTag, { value: "Module" })), hT = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256"
};
function sh(e, t) {
  return f(), v("svg", hT, [...t[0] || (t[0] = [
    Do('<rect width="256" height="256" fill="none"></rect><line x1="128" y1="40" x2="128" y2="216" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></line><line x1="16" y1="128" x2="96" y2="128" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></line><polyline points="64 96 96 128 64 160" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></polyline><line x1="240" y1="128" x2="160" y2="128" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></line><polyline points="192 160 160 128 192 96" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></polyline>', 6)
  ])]);
}
const gT = { render: sh }, pT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: gT,
  render: sh
}, Symbol.toStringTag, { value: "Module" })), fT = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256"
};
function ih(e, t) {
  return f(), v("svg", fT, [...t[0] || (t[0] = [
    Do('<rect width="256" height="256" fill="none"></rect><line x1="216" y1="128" x2="40" y2="128" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></line><line x1="128" y1="16" x2="128" y2="96" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></line><polyline points="160 64 128 96 96 64" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></polyline><line x1="128" y1="240" x2="128" y2="160" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></line><polyline points="96 192 128 160 160 192" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></polyline>', 6)
  ])]);
}
const vT = { render: ih }, mT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: vT,
  render: ih
}, Symbol.toStringTag, { value: "Module" })), CT = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function rh(e, t) {
  return f(), v("svg", CT, [...t[0] || (t[0] = [
    g("path", { d: "M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM122.34,101.66a8,8,0,0,0,11.32,0l32-32a8,8,0,0,0-11.32-11.32L136,76.69V16a8,8,0,0,0-16,0V76.69L101.66,58.34A8,8,0,0,0,90.34,69.66Zm11.32,52.68a8,8,0,0,0-11.32,0l-32,32a8,8,0,0,0,11.32,11.32L120,179.31V240a8,8,0,0,0,16,0V179.31l18.34,18.35a8,8,0,0,0,11.32-11.32Z" }, null, -1)
  ])]);
}
const wT = { render: rh }, bT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: wT,
  render: rh
}, Symbol.toStringTag, { value: "Module" })), yT = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function lh(e, t) {
  return f(), v("svg", yT, [...t[0] || (t[0] = [
    g("path", { d: "M213.66,181.66l-32,32a8,8,0,0,1-11.32-11.32L188.69,184H48a8,8,0,0,1,0-16H188.69l-18.35-18.34a8,8,0,0,1,11.32-11.32l32,32A8,8,0,0,1,213.66,181.66Zm-139.32-64a8,8,0,0,0,11.32-11.32L67.31,88H208a8,8,0,0,0,0-16H67.31L85.66,53.66A8,8,0,0,0,74.34,42.34l-32,32a8,8,0,0,0,0,11.32Z" }, null, -1)
  ])]);
}
const _T = { render: lh }, ST = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _T,
  render: lh
}, Symbol.toStringTag, { value: "Module" })), xT = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256"
};
function ah(e, t) {
  return f(), v("svg", xT, [...t[0] || (t[0] = [
    Do('<rect width="256" height="256" fill="none"></rect><line x1="128" y1="40" x2="128" y2="216" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></line><line x1="96" y1="128" x2="16" y2="128" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></line><polyline points="48 160 16 128 48 96" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></polyline><line x1="160" y1="128" x2="240" y2="128" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></line><polyline points="208 96 240 128 208 160" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></polyline>', 6)
  ])]);
}
const MT = { render: ah }, AT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: MT,
  render: ah
}, Symbol.toStringTag, { value: "Module" })), LT = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256"
};
function ch(e, t) {
  return f(), v("svg", LT, [...t[0] || (t[0] = [
    Do('<rect width="256" height="256" fill="none"></rect><line x1="216" y1="128" x2="40" y2="128" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></line><line x1="128" y1="96" x2="128" y2="16" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></line><polyline points="96 48 128 16 160 48" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></polyline><line x1="128" y1="160" x2="128" y2="240" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></line><polyline points="160 208 128 240 96 208" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></polyline>', 6)
  ])]);
}
const ET = { render: ch }, PT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ET,
  render: ch
}, Symbol.toStringTag, { value: "Module" })), RT = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function dh(e, t) {
  return f(), v("svg", RT, [...t[0] || (t[0] = [
    g("path", { d: "M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM101.66,53.66,120,35.31V96a8,8,0,0,0,16,0V35.31l18.34,18.35a8,8,0,0,0,11.32-11.32l-32-32a8,8,0,0,0-11.32,0l-32,32a8,8,0,0,0,11.32,11.32Zm52.68,148.68L136,220.69V160a8,8,0,0,0-16,0v60.69l-18.34-18.35a8,8,0,0,0-11.32,11.32l32,32a8,8,0,0,0,11.32,0l32-32a8,8,0,0,0-11.32-11.32Z" }, null, -1)
  ])]);
}
const FT = { render: dh }, TT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: FT,
  render: dh
}, Symbol.toStringTag, { value: "Module" })), IT = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function uh(e, t) {
  return f(), v("svg", IT, [...t[0] || (t[0] = [
    g("path", { d: "M128,96H232a8,8,0,0,1,0,16H128a8,8,0,0,1,0-16Zm104,32H128a8,8,0,0,0,0,16H232a8,8,0,0,0,0-16Zm0,32H80a8,8,0,0,0,0,16H232a8,8,0,0,0,0-16Zm0,32H80a8,8,0,0,0,0,16H232a8,8,0,0,0,0-16ZM96,144a8,8,0,0,0,0-16H88V64h32v8a8,8,0,0,0,16,0V56a8,8,0,0,0-8-8H32a8,8,0,0,0-8,8V72a8,8,0,0,0,16,0V64H72v64H64a8,8,0,0,0,0,16Z" }, null, -1)
  ])]);
}
const DT = { render: uh }, kT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: DT,
  render: uh
}, Symbol.toStringTag, { value: "Module" })), HT = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function hh(e, t) {
  return f(), v("svg", HT, [...t[0] || (t[0] = [
    g("path", { d: "M128,24a104,104,0,0,0,0,208c21.51,0,44.1-6.48,60.43-17.33a8,8,0,0,0-8.86-13.33C166,210.38,146.21,216,128,216a88,88,0,1,1,88-88c0,26.45-10.88,32-20,32s-20-5.55-20-32V88a8,8,0,0,0-16,0v4.26a48,48,0,1,0,5.93,65.1c6,12,16.35,18.64,30.07,18.64,22.54,0,36-17.94,36-48A104.11,104.11,0,0,0,128,24Zm0,136a32,32,0,1,1,32-32A32,32,0,0,1,128,160Z" }, null, -1)
  ])]);
}
const VT = { render: hh }, OT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: VT,
  render: hh
}, Symbol.toStringTag, { value: "Module" })), BT = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function gh(e, t) {
  return f(), v("svg", BT, [...t[0] || (t[0] = [
    g("path", { d: "M24,104H48v64H32a8,8,0,0,0,0,16H224a8,8,0,0,0,0-16H208V104h24a8,8,0,0,0,4.19-14.81l-104-64a8,8,0,0,0-8.38,0l-104,64A8,8,0,0,0,24,104Zm40,0H96v64H64Zm80,0v64H112V104Zm48,64H160V104h32ZM128,41.39,203.74,88H52.26ZM248,208a8,8,0,0,1-8,8H16a8,8,0,0,1,0-16H240A8,8,0,0,1,248,208Z" }, null, -1)
  ])]);
}
const $T = { render: gh }, ZT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: $T,
  render: gh
}, Symbol.toStringTag, { value: "Module" })), GT = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function ph(e, t) {
  return f(), v("svg", GT, [...t[0] || (t[0] = [
    g("path", { d: "M232,48V88a8,8,0,0,1-16,0V56H184a8,8,0,0,1,0-16h40A8,8,0,0,1,232,48ZM72,200H40V168a8,8,0,0,0-16,0v40a8,8,0,0,0,8,8H72a8,8,0,0,0,0-16Zm152-40a8,8,0,0,0-8,8v32H184a8,8,0,0,0,0,16h40a8,8,0,0,0,8-8V168A8,8,0,0,0,224,160ZM32,96a8,8,0,0,0,8-8V56H72a8,8,0,0,0,0-16H32a8,8,0,0,0-8,8V88A8,8,0,0,0,32,96ZM80,80a8,8,0,0,0-8,8v80a8,8,0,0,0,16,0V88A8,8,0,0,0,80,80Zm104,88V88a8,8,0,0,0-16,0v80a8,8,0,0,0,16,0ZM144,80a8,8,0,0,0-8,8v80a8,8,0,0,0,16,0V88A8,8,0,0,0,144,80Zm-32,0a8,8,0,0,0-8,8v80a8,8,0,0,0,16,0V88A8,8,0,0,0,112,80Z" }, null, -1)
  ])]);
}
const NT = { render: ph }, zT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: NT,
  render: ph
}, Symbol.toStringTag, { value: "Module" })), jT = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256"
};
function fh(e, t) {
  return f(), v("svg", jT, [...t[0] || (t[0] = [
    g("rect", {
      width: "256",
      height: "256",
      fill: "none"
    }, null, -1),
    g("polyline", {
      points: "80 40 40 40 40 216 80 216",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1),
    g("polyline", {
      points: "176 40 216 40 216 216 176 216",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1)
  ])]);
}
const WT = { render: fh }, UT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: WT,
  render: fh
}, Symbol.toStringTag, { value: "Module" })), KT = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256"
};
function vh(e, t) {
  return f(), v("svg", KT, [...t[0] || (t[0] = [
    g("rect", {
      width: "256",
      height: "256",
      fill: "none"
    }, null, -1),
    g("path", {
      d: "M112,224a95.2,95.2,0,0,1-29-48",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1),
    g("path", {
      d: "M192,152c0,31.67,13.31,59,40,72H61A103.65,103.65,0,0,1,32,152c0-28.21,11.23-50.89,29.47-69.64a8,8,0,0,1,8.67-1.81L95.52,90.83a16,16,0,0,0,20.82-9l21-53.11c4.15-10,15.47-15.32,25.63-11.53a20,20,0,0,1,11.51,26.4L153.13,96.69a16,16,0,0,0,8.93,20.76L187,127.29a8,8,0,0,1,5,7.43Z",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1),
    g("line", {
      x1: "43.93",
      y1: "105.57",
      x2: "192.8",
      y2: "165.12",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1)
  ])]);
}
const qT = { render: vh }, YT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: qT,
  render: vh
}, Symbol.toStringTag, { value: "Module" })), QT = {
  viewBox: "0 0 21 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function mh(e, t) {
  return f(), v("svg", QT, [...t[0] || (t[0] = [
    g("path", {
      opacity: "0.2",
      d: "M18.3589 4.375V7.5H3.35889V4.375C3.35889 4.20924 3.42473 4.05027 3.54195 3.93306C3.65916 3.81585 3.81813 3.75 3.98389 3.75H17.7339C17.8996 3.75 18.0586 3.81585 18.1758 3.93306C18.293 4.05027 18.3589 4.20924 18.3589 4.375Z",
      fill: "none"
    }, null, -1),
    g("path", {
      d: "M17.7339 3.125H3.98389C3.65237 3.125 3.33442 3.2567 3.1 3.49112C2.86558 3.72554 2.73389 4.04348 2.73389 4.375V15.625C2.73389 15.9565 2.86558 16.2745 3.1 16.5089C3.33442 16.7433 3.65237 16.875 3.98389 16.875H17.7339C18.0654 16.875 18.3833 16.7433 18.6178 16.5089C18.8522 16.2745 18.9839 15.9565 18.9839 15.625V4.375C18.9839 4.04348 18.8522 3.72554 18.6178 3.49112C18.3833 3.2567 18.0654 3.125 17.7339 3.125ZM17.7339 4.375V6.875H3.98389V4.375H17.7339ZM17.7339 15.625H3.98389V8.125H17.7339V15.625Z",
      fill: "currentColor"
    }, null, -1)
  ])]);
}
const JT = { render: mh }, XT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: JT,
  render: mh
}, Symbol.toStringTag, { value: "Module" })), eI = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function Ch(e, t) {
  return f(), v("svg", eI, [...t[0] || (t[0] = [
    g("path", { d: "M240,208h-8V72a8,8,0,0,0-8-8H184V40a8,8,0,0,0-8-8H80a8,8,0,0,0-8,8V96H32a8,8,0,0,0-8,8V208H16a8,8,0,0,0,0,16H240a8,8,0,0,0,0-16ZM40,112H80a8,8,0,0,0,8-8V48h80V72a8,8,0,0,0,8,8h40V208H152V168a8,8,0,0,0-8-8H112a8,8,0,0,0-8,8v40H40Zm96,96H120V176h16ZM112,72a8,8,0,0,1,8-8h16a8,8,0,0,1,0,16H120A8,8,0,0,1,112,72Zm0,32a8,8,0,0,1,8-8h16a8,8,0,0,1,0,16H120A8,8,0,0,1,112,104Zm56,0a8,8,0,0,1,8-8h16a8,8,0,0,1,0,16H176A8,8,0,0,1,168,104ZM88,136a8,8,0,0,1-8,8H64a8,8,0,0,1,0-16H80A8,8,0,0,1,88,136Zm0,32a8,8,0,0,1-8,8H64a8,8,0,0,1,0-16H80A8,8,0,0,1,88,168Zm24-32a8,8,0,0,1,8-8h16a8,8,0,0,1,0,16H120A8,8,0,0,1,112,136Zm56,0a8,8,0,0,1,8-8h16a8,8,0,0,1,0,16H176A8,8,0,0,1,168,136Zm0,32a8,8,0,0,1,8-8h16a8,8,0,0,1,0,16H176A8,8,0,0,1,168,168Z" }, null, -1)
  ])]);
}
const tI = { render: Ch }, oI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: tI,
  render: Ch
}, Symbol.toStringTag, { value: "Module" })), nI = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function wh(e, t) {
  return f(), v("svg", nI, [...t[0] || (t[0] = [
    g("path", { d: "M232,224H208V32h8a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16h8V224H24a8,8,0,0,0,0,16H232a8,8,0,0,0,0-16ZM64,32H192V224H160V184a8,8,0,0,0-8-8H104a8,8,0,0,0-8,8v40H64Zm80,192H112V192h32ZM88,64a8,8,0,0,1,8-8h16a8,8,0,0,1,0,16H96A8,8,0,0,1,88,64Zm48,0a8,8,0,0,1,8-8h16a8,8,0,0,1,0,16H144A8,8,0,0,1,136,64ZM88,104a8,8,0,0,1,8-8h16a8,8,0,0,1,0,16H96A8,8,0,0,1,88,104Zm48,0a8,8,0,0,1,8-8h16a8,8,0,0,1,0,16H144A8,8,0,0,1,136,104ZM88,144a8,8,0,0,1,8-8h16a8,8,0,0,1,0,16H96A8,8,0,0,1,88,144Zm48,0a8,8,0,0,1,8-8h16a8,8,0,0,1,0,16H144A8,8,0,0,1,136,144Z" }, null, -1)
  ])]);
}
const sI = { render: wh }, iI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sI,
  render: wh
}, Symbol.toStringTag, { value: "Module" })), rI = {
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function bh(e, t) {
  return f(), v("svg", rI, [...t[0] || (t[0] = [
    g("path", {
      d: "M6.25 9.69727H13.75C13.9158 9.69727 14.0747 9.63142 14.1919 9.51421C14.3092 9.397 14.375 9.23803 14.375 9.07227V5.32227C14.375 5.15651 14.3092 4.99753 14.1919 4.88032C14.0747 4.76311 13.9158 4.69727 13.75 4.69727H6.25C6.08424 4.69727 5.92527 4.76311 5.80806 4.88032C5.69085 4.99753 5.625 5.15651 5.625 5.32227V9.07227C5.625 9.23803 5.69085 9.397 5.80806 9.51421C5.92527 9.63142 6.08424 9.69727 6.25 9.69727ZM6.875 5.94727H13.125V8.44727H6.875V5.94727ZM15.625 2.19727H4.375C4.04348 2.19727 3.72554 2.32896 3.49112 2.56338C3.2567 2.7978 3.125 3.11575 3.125 3.44727V17.1973C3.125 17.5288 3.2567 17.8467 3.49112 18.0811C3.72554 18.3156 4.04348 18.4473 4.375 18.4473H15.625C15.9565 18.4473 16.2745 18.3156 16.5089 18.0811C16.7433 17.8467 16.875 17.5288 16.875 17.1973V3.44727C16.875 3.11575 16.7433 2.7978 16.5089 2.56338C16.2745 2.32896 15.9565 2.19727 15.625 2.19727ZM15.625 17.1973H4.375V3.44727H15.625V17.1973ZM7.8125 11.8848C7.8125 12.0702 7.75752 12.2514 7.6545 12.4056C7.55149 12.5598 7.40507 12.6799 7.23377 12.7509C7.06246 12.8219 6.87396 12.8404 6.6921 12.8043C6.51025 12.7681 6.3432 12.6788 6.21209 12.5477C6.08098 12.4166 5.99169 12.2495 5.95551 12.0677C5.91934 11.8858 5.93791 11.6973 6.00886 11.526C6.07982 11.3547 6.19998 11.2083 6.35415 11.1053C6.50832 11.0022 6.68958 10.9473 6.875 10.9473C7.12364 10.9473 7.3621 11.046 7.53791 11.2219C7.71373 11.3977 7.8125 11.6361 7.8125 11.8848ZM10.9375 11.8848C10.9375 12.0702 10.8825 12.2514 10.7795 12.4056C10.6765 12.5598 10.5301 12.6799 10.3588 12.7509C10.1875 12.8219 9.99896 12.8404 9.8171 12.8043C9.63525 12.7681 9.4682 12.6788 9.33709 12.5477C9.20598 12.4166 9.11669 12.2495 9.08051 12.0677C9.04434 11.8858 9.06291 11.6973 9.13386 11.526C9.20482 11.3547 9.32498 11.2083 9.47915 11.1053C9.63332 11.0022 9.81458 10.9473 10 10.9473C10.2486 10.9473 10.4871 11.046 10.6629 11.2219C10.8387 11.3977 10.9375 11.6361 10.9375 11.8848ZM14.0625 11.8848C14.0625 12.0702 14.0075 12.2514 13.9045 12.4056C13.8015 12.5598 13.6551 12.6799 13.4838 12.7509C13.3125 12.8219 13.124 12.8404 12.9421 12.8043C12.7602 12.7681 12.5932 12.6788 12.4621 12.5477C12.331 12.4166 12.2417 12.2495 12.2055 12.0677C12.1693 11.8858 12.1879 11.6973 12.2589 11.526C12.3298 11.3547 12.45 11.2083 12.6042 11.1053C12.7583 11.0022 12.9396 10.9473 13.125 10.9473C13.3736 10.9473 13.6121 11.046 13.7879 11.2219C13.9637 11.3977 14.0625 11.6361 14.0625 11.8848ZM7.8125 15.0098C7.8125 15.1952 7.75752 15.3764 7.6545 15.5306C7.55149 15.6848 7.40507 15.8049 7.23377 15.8759C7.06246 15.9469 6.87396 15.9654 6.6921 15.9293C6.51025 15.8931 6.3432 15.8038 6.21209 15.6727C6.08098 15.5416 5.99169 15.3745 5.95551 15.1927C5.91934 15.0108 5.93791 14.8223 6.00886 14.651C6.07982 14.4797 6.19998 14.3333 6.35415 14.2303C6.50832 14.1272 6.68958 14.0723 6.875 14.0723C7.12364 14.0723 7.3621 14.171 7.53791 14.3469C7.71373 14.5227 7.8125 14.7611 7.8125 15.0098ZM10.9375 15.0098C10.9375 15.1952 10.8825 15.3764 10.7795 15.5306C10.6765 15.6848 10.5301 15.8049 10.3588 15.8759C10.1875 15.9469 9.99896 15.9654 9.8171 15.9293C9.63525 15.8931 9.4682 15.8038 9.33709 15.6727C9.20598 15.5416 9.11669 15.3745 9.08051 15.1927C9.04434 15.0108 9.06291 14.8223 9.13386 14.651C9.20482 14.4797 9.32498 14.3333 9.47915 14.2303C9.63332 14.1272 9.81458 14.0723 10 14.0723C10.2486 14.0723 10.4871 14.171 10.6629 14.3469C10.8387 14.5227 10.9375 14.7611 10.9375 15.0098ZM14.0625 15.0098C14.0625 15.1952 14.0075 15.3764 13.9045 15.5306C13.8015 15.6848 13.6551 15.8049 13.4838 15.8759C13.3125 15.9469 13.124 15.9654 12.9421 15.9293C12.7602 15.8931 12.5932 15.8038 12.4621 15.6727C12.331 15.5416 12.2417 15.3745 12.2055 15.1927C12.1693 15.0108 12.1879 14.8223 12.2589 14.651C12.3298 14.4797 12.45 14.3333 12.6042 14.2303C12.7583 14.1272 12.9396 14.0723 13.125 14.0723C13.3736 14.0723 13.6121 14.171 13.7879 14.3469C13.9637 14.5227 14.0625 14.7611 14.0625 15.0098Z",
      fill: "currentColor"
    }, null, -1)
  ])]);
}
const lI = { render: bh }, aI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: lI,
  render: bh
}, Symbol.toStringTag, { value: "Module" })), cI = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function yh(e, t) {
  return f(), v("svg", cI, [...t[0] || (t[0] = [
    g("path", { d: "M208,32H184V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM72,48v8a8,8,0,0,0,16,0V48h80v8a8,8,0,0,0,16,0V48h24V80H48V48ZM208,208H48V96H208V208Z" }, null, -1)
  ])]);
}
const dI = { render: yh }, uI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: dI,
  render: yh
}, Symbol.toStringTag, { value: "Module" })), hI = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48",
  fill: "none"
};
function _h(e, t) {
  return f(), v("svg", hI, [...t[0] || (t[0] = [
    g("path", {
      d: "M9.375 39.375V18.375H39.375V26.4C39.375 27.0627 39.9123 27.6 40.575 27.6H41.175C41.8377 27.6 42.375 27.0627 42.375 26.4V9.375C42.375 8.57935 42.0589 7.81629 41.4963 7.25368C40.9337 6.69107 40.1707 6.375 39.375 6.375H34.875V4.875C34.875 4.47718 34.717 4.09564 34.4357 3.81434C34.1544 3.53304 33.7728 3.375 33.375 3.375C32.9772 3.375 32.5956 3.53304 32.3143 3.81434C32.033 4.09564 31.875 4.47718 31.875 4.875V6.375H16.875V4.875C16.875 4.47718 16.717 4.09564 16.4357 3.81434C16.1544 3.53304 15.7728 3.375 15.375 3.375C14.9772 3.375 14.5956 3.53304 14.3143 3.81434C14.033 4.09564 13.875 4.47718 13.875 4.875V6.375H9.375C8.57935 6.375 7.81629 6.69107 7.25368 7.25368C6.69107 7.81629 6.375 8.57935 6.375 9.375V39.375C6.375 40.1706 6.69107 40.9337 7.25368 41.4963C7.81629 42.0589 8.57935 42.375 9.375 42.375H22.8C23.4627 42.375 24 41.8377 24 41.175V40.575C24 39.9123 23.4627 39.375 22.8 39.375H9.375ZM13.875 9.375V10.875C13.875 11.2728 14.033 11.6544 14.3143 11.9357C14.5956 12.217 14.9772 12.375 15.375 12.375C15.7728 12.375 16.1544 12.217 16.4357 11.9357C16.717 11.6544 16.875 11.2728 16.875 10.875V9.375H31.875V10.875C31.875 11.2728 32.033 11.6544 32.3143 11.9357C32.5956 12.217 32.9772 12.375 33.375 12.375C33.7728 12.375 34.1544 12.217 34.4357 11.9357C34.717 11.6544 34.875 11.2728 34.875 10.875V9.375H39.375V15.375H9.375V9.375H13.875Z",
      fill: "#4A545E"
    }, null, -1),
    g("path", {
      d: "M40.8 36C40.8 32.0235 37.5765 28.8 33.6 28.8C29.6236 28.8 26.4 32.0235 26.4 36C26.4 39.9764 29.6236 43.2 33.6 43.2V45.6C28.2981 45.6 24 41.3019 24 36C24 30.6981 28.2981 26.4 33.6 26.4C38.9019 26.4 43.2 30.6981 43.2 36C43.2 41.3019 38.9019 45.6 33.6 45.6V43.2C37.5765 43.2 40.8 39.9764 40.8 36Z",
      fill: "#4A545E"
    }, null, -1),
    g("path", {
      d: "M32.4 31.2C32.4 30.5373 32.9373 30 33.6 30C34.2627 30 34.8 30.5373 34.8 31.2V34.8H38.4C39.0627 34.8 39.6 35.3373 39.6 36C39.6 36.6627 39.0627 37.2 38.4 37.2H34.0805C33.269 37.2 32.5922 36.6244 32.4352 35.8594L32.4 35.5195V31.2Z",
      fill: "#4A545E"
    }, null, -1)
  ])]);
}
const gI = { render: _h }, pI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: gI,
  render: _h
}, Symbol.toStringTag, { value: "Module" })), fI = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function Sh(e, t) {
  return f(), v("svg", fI, [...t[0] || (t[0] = [
    g("path", { d: "M213.66,130.34a8,8,0,0,1,0,11.32l-80,80a8,8,0,0,1-11.32,0l-80-80a8,8,0,0,1,11.32-11.32L128,204.69l74.34-74.35A8,8,0,0,1,213.66,130.34Zm-91.32,11.32a8,8,0,0,0,11.32,0l80-80a8,8,0,0,0-11.32-11.32L128,124.69,53.66,50.34A8,8,0,0,0,42.34,61.66Z" }, null, -1)
  ])]);
}
const vI = { render: Sh }, mI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: vI,
  render: Sh
}, Symbol.toStringTag, { value: "Module" })), CI = {
  viewBox: "0 0 16 16",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
function xh(e, t) {
  return f(), v("svg", CI, [...t[0] || (t[0] = [
    g("path", {
      d: "M8.85378 8.35378L3.85378 13.3538C3.75996 13.4476 3.63272 13.5003 3.50003 13.5003C3.36735 13.5003 3.2401 13.4476 3.14628 13.3538C3.05246 13.26 2.99976 13.1327 2.99976 13C2.99976 12.8674 3.05246 12.7401 3.14628 12.6463L7.79316 8.00003L3.14628 3.35378C3.05246 3.25996 2.99976 3.13272 2.99976 3.00003C2.99976 2.86735 3.05246 2.7401 3.14628 2.64628C3.2401 2.55246 3.36735 2.49976 3.50003 2.49976C3.63272 2.49976 3.75996 2.55246 3.85378 2.64628L8.85378 7.64628C8.90027 7.69272 8.93715 7.74786 8.96231 7.80856C8.98748 7.86926 9.00043 7.93433 9.00043 8.00003C9.00043 8.06574 8.98748 8.1308 8.96231 8.1915C8.93715 8.2522 8.90027 8.30735 8.85378 8.35378ZM13.8538 7.64628L8.85378 2.64628C8.75996 2.55246 8.63272 2.49976 8.50003 2.49976C8.36735 2.49976 8.2401 2.55246 8.14628 2.64628C8.05246 2.7401 7.99976 2.86735 7.99976 3.00003C7.99976 3.13272 8.05246 3.25996 8.14628 3.35378L12.7932 8.00003L8.14628 12.6463C8.05246 12.7401 7.99976 12.8674 7.99976 13C7.99976 13.1327 8.05246 13.26 8.14628 13.3538C8.2401 13.4476 8.36735 13.5003 8.50003 13.5003C8.63272 13.5003 8.75996 13.4476 8.85378 13.3538L13.8538 8.35378C13.9003 8.30735 13.9372 8.2522 13.9623 8.1915C13.9875 8.1308 14.0004 8.06574 14.0004 8.00003C14.0004 7.93433 13.9875 7.86926 13.9623 7.80856C13.9372 7.74786 13.9003 7.69272 13.8538 7.64628Z",
      fill: "currentColor"
    }, null, -1)
  ])]);
}
const wI = { render: xh }, bI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: wI,
  render: xh
}, Symbol.toStringTag, { value: "Module" })), yI = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function Mh(e, t) {
  return f(), v("svg", yI, [...t[0] || (t[0] = [
    g("path", { d: "M213.66,194.34a8,8,0,0,1-11.32,11.32L128,131.31,53.66,205.66a8,8,0,0,1-11.32-11.32l80-80a8,8,0,0,1,11.32,0Zm-160-68.68L128,51.31l74.34,74.35a8,8,0,0,0,11.32-11.32l-80-80a8,8,0,0,0-11.32,0l-80,80a8,8,0,0,0,11.32,11.32Z" }, null, -1)
  ])]);
}
const _I = { render: Mh }, SI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _I,
  render: Mh
}, Symbol.toStringTag, { value: "Module" })), xI = {
  viewBox: "0 0 9 5",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Ah(e, t) {
  return f(), v("svg", xI, [...t[0] || (t[0] = [
    g("path", {
      d: "M3.91504 4.71191L0.16504 0.961913C0.0593681 0.85624 1.87619e-06 0.712918 1.88272e-06 0.563475C1.88925e-06 0.414032 0.0593681 0.27071 0.16504 0.165038C0.270712 0.0593655 0.414035 -3.57885e-07 0.563478 -3.52466e-07C0.712921 -3.47047e-07 0.856243 0.0593656 0.961915 0.165038L4.31301 3.51707L7.66504 0.165976C7.71736 0.113652 7.77948 0.0721467 7.84784 0.0438294C7.91621 0.0155121 7.98948 0.000937315 8.06348 0.000937318C8.13747 0.000937321 8.21075 0.0155121 8.27911 0.0438294C8.34747 0.0721467 8.40959 0.113652 8.46191 0.165976C8.51424 0.218299 8.55574 0.280416 8.58406 0.34878C8.61238 0.417145 8.62695 0.490417 8.62695 0.564413C8.62695 0.63841 8.61238 0.711682 8.58406 0.780046C8.55574 0.84841 8.51424 0.910527 8.46191 0.962851L4.71191 4.71285C4.6596 4.76523 4.59745 4.80676 4.52904 4.83507C4.46064 4.86338 4.38732 4.87791 4.31328 4.87783C4.23925 4.87774 4.16596 4.86304 4.09762 4.83457C4.02928 4.8061 3.96724 4.76441 3.91504 4.71191Z",
      fill: "currentColor"
    }, null, -1)
  ])]);
}
const MI = { render: Ah }, AI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: MI,
  render: Ah
}, Symbol.toStringTag, { value: "Module" })), LI = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 256 256"
};
function Lh(e, t) {
  return f(), v("svg", LI, [...t[0] || (t[0] = [
    g("path", { d: "M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,53.66,90.34L128,164.69l74.34-74.35a8,8,0,0,1,11.32,11.32Z" }, null, -1)
  ])]);
}
const EI = { render: Lh }, PI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: EI,
  render: Lh
}, Symbol.toStringTag, { value: "Module" })), RI = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function Eh(e, t) {
  return f(), v("svg", RI, [...t[0] || (t[0] = [
    g("path", { d: "M165.66,202.34a8,8,0,0,1-11.32,11.32l-80-80a8,8,0,0,1,0-11.32l80-80a8,8,0,0,1,11.32,11.32L91.31,128Z" }, null, -1)
  ])]);
}
const FI = { render: Eh }, TI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: FI,
  render: Eh
}, Symbol.toStringTag, { value: "Module" })), II = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function Ph(e, t) {
  return f(), v("svg", II, [...t[0] || (t[0] = [
    g("path", { d: "M184.49,136.49l-80,80a12,12,0,0,1-17-17L159,128,87.51,56.49a12,12,0,1,1,17-17l80,80A12,12,0,0,1,184.49,136.49Z" }, null, -1)
  ])]);
}
const DI = { render: Ph }, kI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: DI,
  render: Ph
}, Symbol.toStringTag, { value: "Module" })), HI = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256"
};
function Rh(e, t) {
  return f(), v("svg", HI, [...t[0] || (t[0] = [
    g("rect", {
      width: "256",
      height: "256",
      fill: "none"
    }, null, -1),
    g("polyline", {
      points: "96 48 176 128 96 208",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1)
  ])]);
}
const VI = { render: Rh }, OI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: VI,
  render: Rh
}, Symbol.toStringTag, { value: "Module" })), BI = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 256 256"
};
function Fh(e, t) {
  return f(), v("svg", BI, [...t[0] || (t[0] = [
    g("path", {
      d: "M181.66,133.66l-80,80a8,8,0,0,1-11.32-11.32L164.69,128,90.34,53.66a8,8,0,0,1,11.32-11.32l80,80A8,8,0,0,1,181.66,133.66Z",
      fill: "currentColor"
    }, null, -1)
  ])]);
}
const $I = { render: Fh }, ZI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: $I,
  render: Fh
}, Symbol.toStringTag, { value: "Module" })), GI = {
  viewBox: "0 0 10 6",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Th(e, t) {
  return f(), v("svg", GI, [...t[0] || (t[0] = [
    g("path", {
      d: "M5.39844 0.727052L9.14844 4.47705C9.25411 4.58272 9.31347 4.72605 9.31347 4.87549C9.31347 5.02493 9.25411 5.16825 9.14844 5.27393C9.04276 5.3796 8.89944 5.43896 8.75 5.43896C8.60056 5.43896 8.45723 5.3796 8.35156 5.27393L5.00047 1.9219L1.64844 5.27299C1.59611 5.32531 1.534 5.36682 1.46563 5.39514C1.39727 5.42345 1.324 5.43803 1.25 5.43803C1.176 5.43803 1.10273 5.42345 1.03437 5.39514C0.966002 5.36682 0.903885 5.32531 0.851562 5.27299C0.799238 5.22067 0.757733 5.15855 0.729416 5.09018C0.701098 5.02182 0.686523 4.94855 0.686523 4.87455C0.686523 4.80055 0.701098 4.72728 0.729416 4.65892C0.757733 4.59055 0.799238 4.52844 0.851562 4.47611L4.60156 0.726115C4.65388 0.673736 4.71603 0.632201 4.78443 0.60389C4.85284 0.57558 4.92616 0.561052 5.00019 0.56114C5.07423 0.561227 5.14751 0.575927 5.21585 0.604398C5.28419 0.632869 5.34624 0.67455 5.39844 0.727052Z",
      fill: "currentColor"
    }, null, -1)
  ])]);
}
const NI = { render: Th }, zI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: NI,
  render: Th
}, Symbol.toStringTag, { value: "Module" })), jI = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 256 256"
};
function Ih(e, t) {
  return f(), v("svg", jI, [...t[0] || (t[0] = [
    g("path", { d: "M213.66,165.66a8,8,0,0,1-11.32,0L128,91.31,53.66,165.66a8,8,0,0,1-11.32-11.32l80-80a8,8,0,0,1,11.32,0l80,80A8,8,0,0,1,213.66,165.66Z" }, null, -1)
  ])]);
}
const WI = { render: Ih }, UI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: WI,
  render: Ih
}, Symbol.toStringTag, { value: "Module" })), KI = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function Dh(e, t) {
  return f(), v("svg", KI, [...t[0] || (t[0] = [
    g("path", { d: "M232,208a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8V48a8,8,0,0,1,16,0v94.37L90.73,98a8,8,0,0,1,10.07-.38l58.81,44.11L218.73,90a8,8,0,1,1,10.54,12l-64,56a8,8,0,0,1-10.07.38L96.39,114.29,40,163.63V200H224A8,8,0,0,1,232,208Z" }, null, -1)
  ])]);
}
const qI = { render: Dh }, YI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: qI,
  render: Dh
}, Symbol.toStringTag, { value: "Module" })), QI = {
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function kh(e, t) {
  return f(), v("svg", QI, [...t[0] || (t[0] = [
    g("path", {
      d: "M10.8538 6.14625C10.9002 6.19269 10.9371 6.24783 10.9623 6.30853C10.9874 6.36923 11.0004 6.43429 11.0004 6.5C11.0004 6.56571 10.9874 6.63077 10.9623 6.69147C10.9371 6.75217 10.9002 6.80731 10.8538 6.85375L7.35375 10.3538C7.30732 10.4002 7.25217 10.4371 7.19147 10.4623C7.13077 10.4874 7.06571 10.5004 7 10.5004C6.9343 10.5004 6.86923 10.4874 6.80853 10.4623C6.74783 10.4371 6.69269 10.4002 6.64625 10.3538L5.14625 8.85375C5.05243 8.75993 4.99972 8.63268 4.99972 8.5C4.99972 8.36732 5.05243 8.24007 5.14625 8.14625C5.24007 8.05243 5.36732 7.99972 5.5 7.99972C5.63268 7.99972 5.75993 8.05243 5.85375 8.14625L7 9.29313L10.1463 6.14625C10.1927 6.09976 10.2478 6.06288 10.3085 6.03772C10.3692 6.01256 10.4343 5.99961 10.5 5.99961C10.5657 5.99961 10.6308 6.01256 10.6915 6.03772C10.7522 6.06288 10.8073 6.09976 10.8538 6.14625ZM14.5 8C14.5 9.28558 14.1188 10.5423 13.4046 11.6112C12.6903 12.6801 11.6752 13.5132 10.4874 14.0052C9.29973 14.4972 7.99279 14.6259 6.73192 14.3751C5.47104 14.1243 4.31285 13.5052 3.40381 12.5962C2.49477 11.6872 1.8757 10.529 1.6249 9.26809C1.37409 8.00721 1.50282 6.70028 1.99479 5.51256C2.48676 4.32484 3.31988 3.30968 4.3888 2.59545C5.45772 1.88122 6.71442 1.5 8 1.5C9.72335 1.50182 11.3756 2.18722 12.5942 3.40582C13.8128 4.62441 14.4982 6.27665 14.5 8ZM13.5 8C13.5 6.9122 13.1774 5.84883 12.5731 4.94436C11.9687 4.03989 11.1098 3.33494 10.1048 2.91866C9.09977 2.50238 7.9939 2.39346 6.92701 2.60568C5.86011 2.8179 4.8801 3.34172 4.11092 4.11091C3.34173 4.8801 2.8179 5.86011 2.60568 6.927C2.39347 7.9939 2.50238 9.09977 2.91867 10.1048C3.33495 11.1098 4.0399 11.9687 4.94437 12.5731C5.84884 13.1774 6.91221 13.5 8 13.5C9.45819 13.4983 10.8562 12.9184 11.8873 11.8873C12.9184 10.8562 13.4983 9.45818 13.5 8Z",
      fill: "currentColor"
    }, null, -1)
  ])]);
}
const JI = { render: kh }, XI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: JI,
  render: kh
}, Symbol.toStringTag, { value: "Module" })), eD = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256"
};
function Hh(e, t) {
  return f(), v("svg", eD, [...t[0] || (t[0] = [
    g("rect", {
      width: "256",
      height: "256",
      fill: "none"
    }, null, -1),
    g("polyline", {
      points: "40 144 96 200 224 72",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1)
  ])]);
}
const tD = { render: Hh }, oD = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: tD,
  render: Hh
}, Symbol.toStringTag, { value: "Module" })), nD = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256"
};
function Vh(e, t) {
  return f(), v("svg", nD, [...t[0] || (t[0] = [
    g("rect", {
      width: "256",
      height: "256",
      fill: "none"
    }, null, -1),
    g("circle", {
      cx: "128",
      cy: "128",
      r: "104"
    }, null, -1)
  ])]);
}
const sD = { render: Vh }, iD = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sD,
  render: Vh
}, Symbol.toStringTag, { value: "Module" })), rD = {
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Oh(e, t) {
  return f(), v("svg", rD, [...t[0] || (t[0] = [
    g("path", {
      d: "M8 1.5C6.71442 1.5 5.45772 1.88122 4.3888 2.59545C3.31988 3.30968 2.48676 4.32484 1.99479 5.51256C1.50282 6.70028 1.37409 8.00721 1.6249 9.26809C1.8757 10.529 2.49477 11.6872 3.40381 12.5962C4.31285 13.5052 5.47104 14.1243 6.73192 14.3751C7.99279 14.6259 9.29973 14.4972 10.4874 14.0052C11.6752 13.5132 12.6903 12.6801 13.4046 11.6112C14.1188 10.5423 14.5 9.28558 14.5 8C14.4982 6.27665 13.8128 4.62441 12.5942 3.40582C11.3756 2.18722 9.72335 1.50182 8 1.5ZM8 13.5C6.91221 13.5 5.84884 13.1774 4.94437 12.5731C4.0399 11.9687 3.33495 11.1098 2.91867 10.1048C2.50238 9.09977 2.39347 7.9939 2.60568 6.927C2.8179 5.86011 3.34173 4.8801 4.11092 4.11091C4.8801 3.34172 5.86011 2.8179 6.92701 2.60568C7.9939 2.39346 9.09977 2.50238 10.1048 2.91866C11.1098 3.33494 11.9687 4.03989 12.5731 4.94436C13.1774 5.84883 13.5 6.9122 13.5 8C13.4983 9.45818 12.9184 10.8562 11.8873 11.8873C10.8562 12.9184 9.45819 13.4983 8 13.5Z",
      fill: "currentColor"
    }, null, -1)
  ])]);
}
const lD = { render: Oh }, aD = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: lD,
  render: Oh
}, Symbol.toStringTag, { value: "Module" })), cD = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function Bh(e, t) {
  return f(), v("svg", cD, [...t[0] || (t[0] = [
    g("path", { d: "M240,208h-8V88a8,8,0,0,0-8-8H160a8,8,0,0,0-8,8v40H104V40a8,8,0,0,0-8-8H32a8,8,0,0,0-8,8V208H16a8,8,0,0,0,0,16H240a8,8,0,0,0,0-16ZM168,96h48V208H168Zm-16,48v64H104V144ZM40,48H88V208H40ZM72,72V88a8,8,0,0,1-16,0V72a8,8,0,0,1,16,0Zm0,48v16a8,8,0,0,1-16,0V120a8,8,0,0,1,16,0Zm0,48v16a8,8,0,0,1-16,0V168a8,8,0,0,1,16,0Zm48,16V168a8,8,0,0,1,16,0v16a8,8,0,0,1-16,0Zm64,0V168a8,8,0,0,1,16,0v16a8,8,0,0,1-16,0Zm0-48V120a8,8,0,0,1,16,0v16a8,8,0,0,1-16,0Z" }, null, -1)
  ])]);
}
const dD = { render: Bh }, uD = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: dD,
  render: Bh
}, Symbol.toStringTag, { value: "Module" })), hD = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function $h(e, t) {
  return f(), v("svg", hD, [...t[0] || (t[0] = [
    g("path", { d: "M168,152a8,8,0,0,1-8,8H96a8,8,0,0,1,0-16h64A8,8,0,0,1,168,152Zm-8-40H96a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16Zm56-64V216a16,16,0,0,1-16,16H56a16,16,0,0,1-16-16V48A16,16,0,0,1,56,32H92.26a47.92,47.92,0,0,1,71.48,0H200A16,16,0,0,1,216,48ZM96,64h64a32,32,0,0,0-64,0ZM200,48H173.25A47.93,47.93,0,0,1,176,64v8a8,8,0,0,1-8,8H88a8,8,0,0,1-8-8V64a47.93,47.93,0,0,1,2.75-16H56V216H200Z" }, null, -1)
  ])]);
}
const gD = { render: $h }, pD = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: gD,
  render: $h
}, Symbol.toStringTag, { value: "Module" })), fD = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function Zh(e, t) {
  return f(), v("svg", fD, [...t[0] || (t[0] = [
    g("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm64-88a8,8,0,0,1-8,8H128a8,8,0,0,1-8-8V72a8,8,0,0,1,16,0v48h48A8,8,0,0,1,192,128Z" }, null, -1)
  ])]);
}
const vD = { render: Zh }, mD = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: vD,
  render: Zh
}, Symbol.toStringTag, { value: "Module" })), CD = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function Gh(e, t) {
  return f(), v("svg", CD, [...t[0] || (t[0] = [
    g("path", { d: "M69.12,94.15,28.5,128l40.62,33.85a8,8,0,1,1-10.24,12.29l-48-40a8,8,0,0,1,0-12.29l48-40a8,8,0,0,1,10.24,12.3Zm176,27.7-48-40a8,8,0,1,0-10.24,12.3L227.5,128l-40.62,33.85a8,8,0,1,0,10.24,12.29l48-40a8,8,0,0,0,0-12.29ZM162.73,32.48a8,8,0,0,0-10.25,4.79l-64,176a8,8,0,0,0,4.79,10.26A8.14,8.14,0,0,0,96,224a8,8,0,0,0,7.52-5.27l64-176A8,8,0,0,0,162.73,32.48Z" }, null, -1)
  ])]);
}
const wD = { render: Gh }, bD = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: wD,
  render: Gh
}, Symbol.toStringTag, { value: "Module" })), yD = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function Nh(e, t) {
  return f(), v("svg", yD, [...t[0] || (t[0] = [
    g("path", { d: "M104,32H64A16,16,0,0,0,48,48V208a16,16,0,0,0,16,16h40a16,16,0,0,0,16-16V48A16,16,0,0,0,104,32Zm0,176H64V48h40ZM192,32H152a16,16,0,0,0-16,16V208a16,16,0,0,0,16,16h40a16,16,0,0,0,16-16V48A16,16,0,0,0,192,32Zm0,176H152V48h40Z" }, null, -1)
  ])]);
}
const _D = { render: Nh }, SD = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _D,
  render: Nh
}, Symbol.toStringTag, { value: "Module" })), xD = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function zh(e, t) {
  return f(), v("svg", xD, [...t[0] || (t[0] = [
    g("path", { d: "M216,32H88a8,8,0,0,0-8,8V80H40a8,8,0,0,0-8,8V216a8,8,0,0,0,8,8H168a8,8,0,0,0,8-8V176h40a8,8,0,0,0,8-8V40A8,8,0,0,0,216,32ZM160,208H48V96H160Zm48-48H176V88a8,8,0,0,0-8-8H96V48H208Z" }, null, -1)
  ])]);
}
const MD = { render: zh }, AD = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: MD,
  render: zh
}, Symbol.toStringTag, { value: "Module" })), LD = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function jh(e, t) {
  return f(), v("svg", LD, [...t[0] || (t[0] = [
    g("path", { d: "M184,208a8,8,0,0,1-8,8H160a40,40,0,0,1-32-16,40,40,0,0,1-32,16H80a8,8,0,0,1,0-16H96a24,24,0,0,0,24-24V136H104a8,8,0,0,1,0-16h16V80A24,24,0,0,0,96,56H80a8,8,0,0,1,0-16H96a40,40,0,0,1,32,16,40,40,0,0,1,32-16h16a8,8,0,0,1,0,16H160a24,24,0,0,0-24,24v40h16a8,8,0,0,1,0,16H136v40a24,24,0,0,0,24,24h16A8,8,0,0,1,184,208Z" }, null, -1)
  ])]);
}
const ED = { render: jh }, PD = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ED,
  render: jh
}, Symbol.toStringTag, { value: "Module" })), RD = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 256 256"
};
function Wh(e, t) {
  return f(), v("svg", RD, [...t[0] || (t[0] = [
    g("path", { d: "M104,60A12,12,0,1,1,92,48,12,12,0,0,1,104,60Zm60,12a12,12,0,1,0-12-12A12,12,0,0,0,164,72ZM92,116a12,12,0,1,0,12,12A12,12,0,0,0,92,116Zm72,0a12,12,0,1,0,12,12A12,12,0,0,0,164,116ZM92,184a12,12,0,1,0,12,12A12,12,0,0,0,92,184Zm72,0a12,12,0,1,0,12,12A12,12,0,0,0,164,184Z" }, null, -1)
  ])]);
}
const FD = { render: Wh }, TD = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: FD,
  render: Wh
}, Symbol.toStringTag, { value: "Module" })), ID = {
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Uh(e, t) {
  return f(), v("svg", ID, [...t[0] || (t[0] = [
    g("path", {
      d: "M4.5 5.75C4.5 5.89834 4.45601 6.04334 4.3736 6.16668C4.29119 6.29001 4.17406 6.38614 4.03701 6.44291C3.89997 6.49968 3.74917 6.51453 3.60368 6.48559C3.4582 6.45665 3.32456 6.38522 3.21967 6.28033C3.11478 6.17544 3.04335 6.0418 3.01441 5.89632C2.98547 5.75083 3.00032 5.60003 3.05709 5.46299C3.11386 5.32594 3.20999 5.20881 3.33332 5.1264C3.45666 5.04399 3.60166 5 3.75 5C3.94891 5 4.13968 5.07902 4.28033 5.21967C4.42098 5.36032 4.5 5.55109 4.5 5.75ZM8 5C7.85167 5 7.70666 5.04399 7.58332 5.1264C7.45999 5.20881 7.36386 5.32594 7.30709 5.46299C7.25033 5.60003 7.23547 5.75083 7.26441 5.89632C7.29335 6.0418 7.36478 6.17544 7.46967 6.28033C7.57456 6.38522 7.7082 6.45665 7.85368 6.48559C7.99917 6.51453 8.14997 6.49968 8.28701 6.44291C8.42406 6.38614 8.54119 6.29001 8.6236 6.16668C8.70601 6.04334 8.75 5.89834 8.75 5.75C8.75 5.55109 8.67098 5.36032 8.53033 5.21967C8.38968 5.07902 8.19891 5 8 5ZM12.25 6.5C12.3983 6.5 12.5433 6.45601 12.6667 6.3736C12.79 6.29119 12.8861 6.17406 12.9429 6.03701C12.9997 5.89997 13.0145 5.74917 12.9856 5.60368C12.9567 5.4582 12.8852 5.32456 12.7803 5.21967C12.6754 5.11478 12.5418 5.04335 12.3963 5.01441C12.2508 4.98547 12.1 5.00032 11.963 5.05709C11.8259 5.11386 11.7088 5.20999 11.6264 5.33332C11.544 5.45666 11.5 5.60166 11.5 5.75C11.5 5.94891 11.579 6.13968 11.7197 6.28033C11.8603 6.42098 12.0511 6.5 12.25 6.5ZM3.75 9.5C3.60166 9.5 3.45666 9.54399 3.33332 9.6264C3.20999 9.70881 3.11386 9.82594 3.05709 9.96299C3.00032 10.1 2.98547 10.2508 3.01441 10.3963C3.04335 10.5418 3.11478 10.6754 3.21967 10.7803C3.32456 10.8852 3.4582 10.9567 3.60368 10.9856C3.74917 11.0145 3.89997 10.9997 4.03701 10.9429C4.17406 10.8861 4.29119 10.79 4.3736 10.6667C4.45601 10.5433 4.5 10.3983 4.5 10.25C4.5 10.0511 4.42098 9.86032 4.28033 9.71967C4.13968 9.57902 3.94891 9.5 3.75 9.5ZM8 9.5C7.85167 9.5 7.70666 9.54399 7.58332 9.6264C7.45999 9.70881 7.36386 9.82594 7.30709 9.96299C7.25033 10.1 7.23547 10.2508 7.26441 10.3963C7.29335 10.5418 7.36478 10.6754 7.46967 10.7803C7.57456 10.8852 7.7082 10.9567 7.85368 10.9856C7.99917 11.0145 8.14997 10.9997 8.28701 10.9429C8.42406 10.8861 8.54119 10.79 8.6236 10.6667C8.70601 10.5433 8.75 10.3983 8.75 10.25C8.75 10.0511 8.67098 9.86032 8.53033 9.71967C8.38968 9.57902 8.19891 9.5 8 9.5ZM12.25 9.5C12.1017 9.5 11.9567 9.54399 11.8333 9.6264C11.71 9.70881 11.6139 9.82594 11.5571 9.96299C11.5003 10.1 11.4855 10.2508 11.5144 10.3963C11.5434 10.5418 11.6148 10.6754 11.7197 10.7803C11.8246 10.8852 11.9582 10.9567 12.1037 10.9856C12.2492 11.0145 12.4 10.9997 12.537 10.9429C12.6741 10.8861 12.7912 10.79 12.8736 10.6667C12.956 10.5433 13 10.3983 13 10.25C13 10.0511 12.921 9.86032 12.7803 9.71967C12.6397 9.57902 12.4489 9.5 12.25 9.5Z",
      fill: "#4A545E"
    }, null, -1)
  ])]);
}
const DD = { render: Uh }, kD = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: DD,
  render: Uh
}, Symbol.toStringTag, { value: "Module" })), HD = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function Kh(e, t) {
  return f(), v("svg", HD, [...t[0] || (t[0] = [
    g("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm12-88a12,12,0,1,1-12-12A12,12,0,0,1,140,128Zm44,0a12,12,0,1,1-12-12A12,12,0,0,1,184,128Zm-88,0a12,12,0,1,1-12-12A12,12,0,0,1,96,128Z" }, null, -1)
  ])]);
}
const VD = { render: Kh }, OD = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: VD,
  render: Kh
}, Symbol.toStringTag, { value: "Module" })), BD = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 256 256"
};
function qh(e, t) {
  return f(), v("svg", BD, [...t[0] || (t[0] = [
    g("path", { d: "M140,128a12,12,0,1,1-12-12A12,12,0,0,1,140,128ZM128,72a12,12,0,1,0-12-12A12,12,0,0,0,128,72Zm0,112a12,12,0,1,0,12,12A12,12,0,0,0,128,184Z" }, null, -1)
  ])]);
}
const $D = { render: qh }, ZD = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: $D,
  render: qh
}, Symbol.toStringTag, { value: "Module" })), GD = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 256 256"
};
function Yh(e, t) {
  return f(), v("svg", GD, [...t[0] || (t[0] = [
    g("path", { d: "M140,128a12,12,0,1,1-12-12A12,12,0,0,1,140,128Zm56-12a12,12,0,1,0,12,12A12,12,0,0,0,196,116ZM60,116a12,12,0,1,0,12,12A12,12,0,0,0,60,116Z" }, null, -1)
  ])]);
}
const ND = { render: Yh }, zD = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ND,
  render: Yh
}, Symbol.toStringTag, { value: "Module" })), jD = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function Qh(e, t) {
  return f(), v("svg", jD, [...t[0] || (t[0] = [
    g("path", { d: "M224,144v64a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V144a8,8,0,0,1,16,0v56H208V144a8,8,0,0,1,16,0Zm-101.66,5.66a8,8,0,0,0,11.32,0l40-40a8,8,0,0,0-11.32-11.32L136,124.69V32a8,8,0,0,0-16,0v92.69L93.66,98.34a8,8,0,0,0-11.32,11.32Z" }, null, -1)
  ])]);
}
const WD = { render: Qh }, UD = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: WD,
  render: Qh
}, Symbol.toStringTag, { value: "Module" })), KD = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function Jh(e, t) {
  return f(), v("svg", KD, [...t[0] || (t[0] = [
    g("path", { d: "M224,48H32a8,8,0,0,0-8,8V192a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A8,8,0,0,0,224,48Zm-96,85.15L52.57,64H203.43ZM98.71,128,40,181.81V74.19Zm11.84,10.85,12,11.05a8,8,0,0,0,10.82,0l12-11.05,58,53.15H52.57ZM157.29,128,216,74.18V181.82Z" }, null, -1)
  ])]);
}
const qD = { render: Jh }, YD = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: qD,
  render: Jh
}, Symbol.toStringTag, { value: "Module" })), QD = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256"
};
function Xh(e, t) {
  return f(), v("svg", QD, [...t[0] || (t[0] = [
    g("rect", {
      width: "256",
      height: "256",
      fill: "none"
    }, null, -1),
    g("line", {
      x1: "40",
      y1: "160",
      x2: "216",
      y2: "160",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1),
    g("line", {
      x1: "40",
      y1: "96",
      x2: "216",
      y2: "96",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1)
  ])]);
}
const JD = { render: Xh }, XD = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: JD,
  render: Xh
}, Symbol.toStringTag, { value: "Module" })), ek = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256"
};
function e6(e, t) {
  return f(), v("svg", ek, [...t[0] || (t[0] = [
    g("rect", {
      width: "256",
      height: "256",
      fill: "none"
    }, null, -1),
    g("path", {
      d: "M128,56C48,56,16,128,16,128s32,72,112,72,112-72,112-72S208,56,128,56Z",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1),
    g("circle", {
      cx: "128",
      cy: "128",
      r: "40",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1)
  ])]);
}
const tk = { render: e6 }, ok = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: tk,
  render: e6
}, Symbol.toStringTag, { value: "Module" })), nk = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function t6(e, t) {
  return f(), v("svg", nk, [...t[0] || (t[0] = [
    g("path", { d: "M53.92,34.62A8,8,0,1,0,42.08,45.38L61.32,66.55C25,88.84,9.38,123.2,8.69,124.76a8,8,0,0,0,0,6.5c.35.79,8.82,19.57,27.65,38.4C61.43,194.74,93.12,208,128,208a127.11,127.11,0,0,0,52.07-10.83l22,24.21a8,8,0,1,0,11.84-10.76Zm47.33,75.84,41.67,45.85a32,32,0,0,1-41.67-45.85ZM128,192c-30.78,0-57.67-11.19-79.93-33.25A133.16,133.16,0,0,1,25,128c4.69-8.79,19.66-33.39,47.35-49.38l18,19.75a48,48,0,0,0,63.66,70l14.73,16.2A112,112,0,0,1,128,192Zm6-95.43a8,8,0,0,1,3-15.72,48.16,48.16,0,0,1,38.77,42.64,8,8,0,0,1-7.22,8.71,6.39,6.39,0,0,1-.75,0,8,8,0,0,1-8-7.26A32.09,32.09,0,0,0,134,96.57Zm113.28,34.69c-.42.94-10.55,23.37-33.36,43.8a8,8,0,1,1-10.67-11.92A132.77,132.77,0,0,0,231.05,128a133.15,133.15,0,0,0-23.12-30.77C185.67,75.19,158.78,64,128,64a118.37,118.37,0,0,0-19.36,1.57A8,8,0,1,1,106,49.79,134,134,0,0,1,128,48c34.88,0,66.57,13.26,91.66,38.35,18.83,18.83,27.3,37.62,27.65,38.41A8,8,0,0,1,247.31,131.26Z" }, null, -1)
  ])]);
}
const sk = { render: t6 }, ik = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sk,
  render: t6
}, Symbol.toStringTag, { value: "Module" })), rk = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function o6(e, t) {
  return f(), v("svg", rk, [...t[0] || (t[0] = [
    g("path", { d: "M247.31,124.76c-.35-.79-8.82-19.58-27.65-38.41C194.57,61.26,162.88,48,128,48S61.43,61.26,36.34,86.35C17.51,105.18,9,124,8.69,124.76a8,8,0,0,0,0,6.5c.35.79,8.82,19.57,27.65,38.4C61.43,194.74,93.12,208,128,208s66.57-13.26,91.66-38.34c18.83-18.83,27.3-37.61,27.65-38.4A8,8,0,0,0,247.31,124.76ZM128,192c-30.78,0-57.67-11.19-79.93-33.25A133.47,133.47,0,0,1,25,128,133.33,133.33,0,0,1,48.07,97.25C70.33,75.19,97.22,64,128,64s57.67,11.19,79.93,33.25A133.46,133.46,0,0,1,231.05,128C223.84,141.46,192.43,192,128,192Zm0-112a48,48,0,1,0,48,48A48.05,48.05,0,0,0,128,80Zm0,80a32,32,0,1,1,32-32A32,32,0,0,1,128,160Z" }, null, -1)
  ])]);
}
const lk = { render: o6 }, ak = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: lk,
  render: o6
}, Symbol.toStringTag, { value: "Module" })), ck = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function n6(e, t) {
  return f(), v("svg", ck, [...t[0] || (t[0] = [
    g("path", {
      d: "M16.6922 6.43281L12.3172 2.05781C12.2591 1.99979 12.1902 1.95378 12.1143 1.92241C12.0384 1.89105 11.9571 1.87494 11.875 1.875H4.375C4.04348 1.875 3.72554 2.0067 3.49112 2.24112C3.2567 2.47554 3.125 2.79348 3.125 3.125V16.875C3.125 17.2065 3.2567 17.5245 3.49112 17.7589C3.72554 17.9933 4.04348 18.125 4.375 18.125H15.625C15.9565 18.125 16.2745 17.9933 16.5089 17.7589C16.7433 17.5245 16.875 17.2065 16.875 16.875V6.875C16.8751 6.7929 16.859 6.71159 16.8276 6.63572C16.7962 6.55985 16.7502 6.4909 16.6922 6.43281ZM12.5 4.00859L14.7414 6.25H12.5V4.00859ZM15.625 16.875H4.375V3.125H11.25V6.875C11.25 7.04076 11.3158 7.19973 11.4331 7.31694C11.5503 7.43415 11.7092 7.5 11.875 7.5H15.625V16.875Z",
      fill: "#555F6D"
    }, null, -1)
  ])]);
}
const dk = { render: n6 }, uk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: dk,
  render: n6
}, Symbol.toStringTag, { value: "Module" })), hk = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function s6(e, t) {
  return f(), v("svg", hk, [...t[0] || (t[0] = [
    g("path", {
      d: "M15.625 1.875H5.625C5.29348 1.875 4.97554 2.0067 4.74112 2.24112C4.5067 2.47554 4.375 2.79348 4.375 3.125V5H3.125C2.79348 5 2.47554 5.1317 2.24112 5.36612C2.0067 5.60054 1.875 5.91848 1.875 6.25V13.75C1.875 14.0815 2.0067 14.3995 2.24112 14.6339C2.47554 14.8683 2.79348 15 3.125 15H4.375V16.875C4.375 17.2065 4.5067 17.5245 4.74112 17.7589C4.97554 17.9933 5.29348 18.125 5.625 18.125H15.625C15.9565 18.125 16.2745 17.9933 16.5089 17.7589C16.7433 17.5245 16.875 17.2065 16.875 16.875V3.125C16.875 2.79348 16.7433 2.47554 16.5089 2.24112C16.2745 2.0067 15.9565 1.875 15.625 1.875ZM12.5 8.125H15.625V11.875H12.5V8.125ZM15.625 6.875H12.5V6.25C12.5 5.91848 12.3683 5.60054 12.1339 5.36612C11.8995 5.1317 11.5815 5 11.25 5V3.125H15.625V6.875ZM5.625 3.125H10V5H5.625V3.125ZM3.125 6.25H11.25V12.4867C11.25 12.4914 11.25 12.4953 11.25 12.5C11.25 12.5047 11.25 12.5086 11.25 12.5133V13.75H3.125V6.25ZM5.625 15H10V16.875H5.625V15ZM11.25 16.875V15C11.5815 15 11.8995 14.8683 12.1339 14.6339C12.3683 14.3995 12.5 14.0815 12.5 13.75V13.125H15.625V16.875H11.25ZM5.14453 11.475L6.37422 10L5.14453 8.525C5.03844 8.39757 4.98732 8.23322 5.00241 8.0681C5.01751 7.90298 5.09757 7.75062 5.225 7.64453C5.35243 7.53844 5.51678 7.48732 5.6819 7.50241C5.84702 7.51751 5.99938 7.59757 6.10547 7.725L7.1875 9.02344L8.26953 7.725C8.32206 7.6619 8.3865 7.60977 8.45918 7.57158C8.53185 7.53339 8.61134 7.50989 8.6931 7.50241C8.77486 7.49494 8.85729 7.50365 8.93568 7.52803C9.01408 7.55242 9.0869 7.592 9.15 7.64453C9.2131 7.69706 9.26523 7.7615 9.30342 7.83418C9.34161 7.90685 9.36511 7.98634 9.37259 8.0681C9.38006 8.14986 9.37135 8.23229 9.34697 8.31068C9.32258 8.38908 9.283 8.4619 9.23047 8.525L8.00078 10L9.23047 11.475C9.33656 11.6024 9.38768 11.7668 9.37259 11.9319C9.35749 12.097 9.27743 12.2494 9.15 12.3555C9.02257 12.4616 8.85822 12.5127 8.6931 12.4976C8.52798 12.4825 8.37562 12.4024 8.26953 12.275L7.1875 10.9766L6.10547 12.275C5.99938 12.4024 5.84702 12.4825 5.6819 12.4976C5.51678 12.5127 5.35243 12.4616 5.225 12.3555C5.09757 12.2494 5.01751 12.097 5.00241 11.9319C4.98732 11.7668 5.03844 11.6024 5.14453 11.475Z",
      fill: "#00832D"
    }, null, -1)
  ])]);
}
const gk = { render: s6 }, pk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: gk,
  render: s6
}, Symbol.toStringTag, { value: "Module" })), fk = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function i6(e, t) {
  return f(), v("svg", fk, [...t[0] || (t[0] = [
    g("path", { d: "M120,176h-8v-4a28,28,0,0,0-56,0v4H48a8,8,0,0,0-8,8v40a8,8,0,0,0,8,8h72a8,8,0,0,0,8-8V184A8,8,0,0,0,120,176Zm-48-4a12,12,0,0,1,24,0v4H72Zm40,44H56V192h56ZM213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40v88a8,8,0,0,0,16,0V40h88V88a8,8,0,0,0,8,8h48V216H160a8,8,0,0,0,0,16h40a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160Z" }, null, -1)
  ])]);
}
const vk = { render: i6 }, mk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: vk,
  render: i6
}, Symbol.toStringTag, { value: "Module" })), Ck = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function r6(e, t) {
  return f(), v("svg", Ck, [...t[0] || (t[0] = [
    g("path", { d: "M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160ZM200,216H56V40h88V88a8,8,0,0,0,8,8h48V216Zm-45.54-48.85a36.05,36.05,0,1,0-11.31,11.31l11.19,11.2a8,8,0,0,0,11.32-11.32ZM104,148a20,20,0,1,1,20,20A20,20,0,0,1,104,148Z" }, null, -1)
  ])]);
}
const wk = { render: r6 }, bk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: wk,
  render: r6
}, Symbol.toStringTag, { value: "Module" })), yk = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256"
};
function l6(e, t) {
  return f(), v("svg", yk, [...t[0] || (t[0] = [
    g("rect", {
      width: "256",
      height: "256",
      fill: "none"
    }, null, -1),
    g("path", {
      d: "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1),
    g("polyline", {
      points: "152 32 152 88 208 88",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1),
    g("line", {
      x1: "104",
      y1: "152",
      x2: "152",
      y2: "152",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1)
  ])]);
}
const _k = { render: l6 }, Sk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _k,
  render: l6
}, Symbol.toStringTag, { value: "Module" })), xk = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function a6(e, t) {
  return f(), v("svg", xk, [...t[0] || (t[0] = [
    g("path", {
      d: "M17.5 11.875C17.5 12.0408 17.4342 12.1997 17.3169 12.3169C17.1997 12.4342 17.0408 12.5 16.875 12.5H15V13.75H16.25C16.4158 13.75 16.5747 13.8158 16.6919 13.9331C16.8092 14.0503 16.875 14.2092 16.875 14.375C16.875 14.5408 16.8092 14.6997 16.6919 14.8169C16.5747 14.9342 16.4158 15 16.25 15H15V16.25C15 16.4158 14.9342 16.5747 14.8169 16.6919C14.6997 16.8092 14.5408 16.875 14.375 16.875C14.2092 16.875 14.0503 16.8092 13.9331 16.6919C13.8158 16.5747 13.75 16.4158 13.75 16.25V11.875C13.75 11.7092 13.8158 11.5503 13.9331 11.4331C14.0503 11.3158 14.2092 11.25 14.375 11.25H16.875C17.0408 11.25 17.1997 11.3158 17.3169 11.4331C17.4342 11.5503 17.5 11.7092 17.5 11.875ZM7.1875 13.4375C7.1875 14.0177 6.95703 14.5741 6.5468 14.9843C6.13656 15.3945 5.58016 15.625 5 15.625H4.375V16.25C4.375 16.4158 4.30915 16.5747 4.19194 16.6919C4.07473 16.8092 3.91576 16.875 3.75 16.875C3.58424 16.875 3.42527 16.8092 3.30806 16.6919C3.19085 16.5747 3.125 16.4158 3.125 16.25V11.875C3.125 11.7092 3.19085 11.5503 3.30806 11.4331C3.42527 11.3158 3.58424 11.25 3.75 11.25H5C5.58016 11.25 6.13656 11.4805 6.5468 11.8907C6.95703 12.3009 7.1875 12.8573 7.1875 13.4375ZM5.9375 13.4375C5.9375 13.1889 5.83873 12.9504 5.66291 12.7746C5.4871 12.5988 5.24864 12.5 5 12.5H4.375V14.375H5C5.24864 14.375 5.4871 14.2762 5.66291 14.1004C5.83873 13.9246 5.9375 13.6861 5.9375 13.4375ZM12.8125 14.0625C12.8125 14.8084 12.5162 15.5238 11.9887 16.0512C11.4613 16.5787 10.7459 16.875 10 16.875H8.75C8.58424 16.875 8.42527 16.8092 8.30806 16.6919C8.19085 16.5747 8.125 16.4158 8.125 16.25V11.875C8.125 11.7092 8.19085 11.5503 8.30806 11.4331C8.42527 11.3158 8.58424 11.25 8.75 11.25H10C10.7459 11.25 11.4613 11.5463 11.9887 12.0738C12.5162 12.6012 12.8125 13.3166 12.8125 14.0625ZM11.5625 14.0625C11.5625 13.6481 11.3979 13.2507 11.1049 12.9576C10.8118 12.6646 10.4144 12.5 10 12.5H9.375V15.625H10C10.4144 15.625 10.8118 15.4604 11.1049 15.1674C11.3979 14.8743 11.5625 14.4769 11.5625 14.0625ZM3.125 8.75V3.125C3.125 2.79348 3.2567 2.47554 3.49112 2.24112C3.72554 2.0067 4.04348 1.875 4.375 1.875H11.875C11.9571 1.87494 12.0384 1.89105 12.1143 1.92241C12.1902 1.95378 12.2591 1.99979 12.3172 2.05781L16.6922 6.43281C16.7502 6.4909 16.7962 6.55985 16.8276 6.63572C16.859 6.71159 16.8751 6.7929 16.875 6.875V8.75C16.875 8.91576 16.8092 9.07473 16.6919 9.19194C16.5747 9.30915 16.4158 9.375 16.25 9.375C16.0842 9.375 15.9253 9.30915 15.8081 9.19194C15.6908 9.07473 15.625 8.91576 15.625 8.75V7.5H11.875C11.7092 7.5 11.5503 7.43415 11.4331 7.31694C11.3158 7.19973 11.25 7.04076 11.25 6.875V3.125H4.375V8.75C4.375 8.91576 4.30915 9.07473 4.19194 9.19194C4.07473 9.30915 3.91576 9.375 3.75 9.375C3.58424 9.375 3.42527 9.30915 3.30806 9.19194C3.19085 9.07473 3.125 8.91576 3.125 8.75ZM12.5 6.25H14.7414L12.5 4.00859V6.25Z",
      fill: "#FF0000"
    }, null, -1)
  ])]);
}
const Mk = { render: a6 }, Ak = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Mk,
  render: a6
}, Symbol.toStringTag, { value: "Module" })), Lk = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256"
};
function c6(e, t) {
  return f(), v("svg", Lk, [...t[0] || (t[0] = [
    Do('<rect width="256" height="256" fill="none"></rect><path d="M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></path><polyline points="152 32 152 88 208 88" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></polyline><line x1="104" y1="152" x2="152" y2="152" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></line><line x1="128" y1="128" x2="128" y2="176" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></line>', 5)
  ])]);
}
const Ek = { render: c6 }, Pk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ek,
  render: c6
}, Symbol.toStringTag, { value: "Module" })), Rk = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function d6(e, t) {
  return f(), v("svg", Rk, [...t[0] || (t[0] = [
    g("path", {
      d: "M17.5 11.875C17.5 12.0408 17.4342 12.1997 17.3169 12.3169C17.1997 12.4342 17.0408 12.5 16.875 12.5H15.9375V16.25C15.9375 16.4158 15.8717 16.5747 15.7544 16.6919C15.6372 16.8092 15.4783 16.875 15.3125 16.875C15.1467 16.875 14.9878 16.8092 14.8706 16.6919C14.7533 16.5747 14.6875 16.4158 14.6875 16.25V12.5H13.75C13.5842 12.5 13.4253 12.4342 13.3081 12.3169C13.1908 12.1997 13.125 12.0408 13.125 11.875C13.125 11.7092 13.1908 11.5503 13.3081 11.4331C13.4253 11.3158 13.5842 11.25 13.75 11.25H16.875C17.0408 11.25 17.1997 11.3158 17.3169 11.4331C17.4342 11.5503 17.5 11.7092 17.5 11.875ZM7.1875 13.4375C7.1875 14.0177 6.95703 14.5741 6.5468 14.9843C6.13656 15.3945 5.58016 15.625 5 15.625H4.375V16.25C4.375 16.4158 4.30915 16.5747 4.19194 16.6919C4.07473 16.8092 3.91576 16.875 3.75 16.875C3.58424 16.875 3.42527 16.8092 3.30806 16.6919C3.19085 16.5747 3.125 16.4158 3.125 16.25V11.875C3.125 11.7092 3.19085 11.5503 3.30806 11.4331C3.42527 11.3158 3.58424 11.25 3.75 11.25H5C5.58016 11.25 6.13656 11.4805 6.5468 11.8907C6.95703 12.3009 7.1875 12.8573 7.1875 13.4375ZM5.9375 13.4375C5.9375 13.1889 5.83873 12.9504 5.66291 12.7746C5.4871 12.5988 5.24864 12.5 5 12.5H4.375V14.375H5C5.24864 14.375 5.4871 14.2762 5.66291 14.1004C5.83873 13.9246 5.9375 13.6861 5.9375 13.4375ZM12.5 13.4375C12.5 14.0177 12.2695 14.5741 11.8593 14.9843C11.4491 15.3945 10.8927 15.625 10.3125 15.625H9.6875V16.25C9.6875 16.4158 9.62165 16.5747 9.50444 16.6919C9.38723 16.8092 9.22826 16.875 9.0625 16.875C8.89674 16.875 8.73777 16.8092 8.62056 16.6919C8.50335 16.5747 8.4375 16.4158 8.4375 16.25V11.875C8.4375 11.7092 8.50335 11.5503 8.62056 11.4331C8.73777 11.3158 8.89674 11.25 9.0625 11.25H10.3125C10.8927 11.25 11.4491 11.4805 11.8593 11.8907C12.2695 12.3009 12.5 12.8573 12.5 13.4375ZM11.25 13.4375C11.25 13.1889 11.1512 12.9504 10.9754 12.7746C10.7996 12.5988 10.5611 12.5 10.3125 12.5H9.6875V14.375H10.3125C10.5611 14.375 10.7996 14.2762 10.9754 14.1004C11.1512 13.9246 11.25 13.6861 11.25 13.4375ZM3.125 8.75V3.125C3.125 2.79348 3.2567 2.47554 3.49112 2.24112C3.72554 2.0067 4.04348 1.875 4.375 1.875H11.875C11.9571 1.87494 12.0384 1.89105 12.1143 1.92241C12.1902 1.95378 12.2591 1.99979 12.3172 2.05781L16.6922 6.43281C16.7502 6.4909 16.7962 6.55985 16.8276 6.63572C16.859 6.71159 16.8751 6.7929 16.875 6.875V8.75C16.875 8.91576 16.8092 9.07473 16.6919 9.19194C16.5747 9.30915 16.4158 9.375 16.25 9.375C16.0842 9.375 15.9253 9.30915 15.8081 9.19194C15.6908 9.07473 15.625 8.91576 15.625 8.75V7.5H11.875C11.7092 7.5 11.5503 7.43415 11.4331 7.31694C11.3158 7.19973 11.25 7.04076 11.25 6.875V3.125H4.375V8.75C4.375 8.91576 4.30915 9.07473 4.19194 9.19194C4.07473 9.30915 3.91576 9.375 3.75 9.375C3.58424 9.375 3.42527 9.30915 3.30806 9.19194C3.19085 9.07473 3.125 8.91576 3.125 8.75ZM12.5 6.25H14.7414L12.5 4.00859V6.25Z",
      fill: "#F59638"
    }, null, -1)
  ])]);
}
const Fk = { render: d6 }, Tk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Fk,
  render: d6
}, Symbol.toStringTag, { value: "Module" })), Ik = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function u6(e, t) {
  return f(), v("svg", Ik, [...t[0] || (t[0] = [
    g("path", {
      d: "M16.6922 6.43281L12.3172 2.05781C12.2591 1.99979 12.1902 1.95378 12.1143 1.92241C12.0384 1.89105 11.9571 1.87494 11.875 1.875H4.375C4.04348 1.875 3.72554 2.0067 3.49112 2.24112C3.2567 2.47554 3.125 2.79348 3.125 3.125V8.75C3.125 8.91576 3.19085 9.07473 3.30806 9.19194C3.42527 9.30915 3.58424 9.375 3.75 9.375C3.91576 9.375 4.07473 9.30915 4.19194 9.19194C4.30915 9.07473 4.375 8.91576 4.375 8.75V3.125H11.25V6.875C11.25 7.04076 11.3158 7.19973 11.4331 7.31694C11.5503 7.43415 11.7092 7.5 11.875 7.5H15.625V16.875H15C14.8342 16.875 14.6753 16.9408 14.5581 17.0581C14.4408 17.1753 14.375 17.3342 14.375 17.5C14.375 17.6658 14.4408 17.8247 14.5581 17.9419C14.6753 18.0592 14.8342 18.125 15 18.125H15.625C15.9565 18.125 16.2745 17.9933 16.5089 17.7589C16.7433 17.5245 16.875 17.2065 16.875 16.875V6.875C16.8751 6.7929 16.859 6.71159 16.8276 6.63572C16.7962 6.55985 16.7502 6.4909 16.6922 6.43281ZM12.5 4.00859L14.7414 6.25H12.5V4.00859ZM12.1781 11.3281C12.0805 11.2741 11.9701 11.2472 11.8586 11.2502C11.747 11.2532 11.6383 11.2861 11.5437 11.3453L9.98516 12.3187C9.94168 12.0221 9.79302 11.7509 9.56628 11.5547C9.33954 11.3585 9.04984 11.2504 8.75 11.25H3.75C3.41848 11.25 3.10054 11.3817 2.86612 11.6161C2.6317 11.8505 2.5 12.1685 2.5 12.5V16.25C2.5 16.5815 2.6317 16.8995 2.86612 17.1339C3.10054 17.3683 3.41848 17.5 3.75 17.5H8.75C9.04984 17.4996 9.33954 17.3915 9.56628 17.1953C9.79302 16.9991 9.94168 16.7279 9.98516 16.4313L11.5437 17.4047C11.6383 17.4638 11.747 17.4965 11.8585 17.4995C11.97 17.5024 12.0803 17.4755 12.1778 17.4214C12.2754 17.3674 12.3567 17.2882 12.4134 17.1921C12.47 17.096 12.4999 16.9865 12.5 16.875V11.875C12.5001 11.7634 12.4702 11.6538 12.4136 11.5577C12.357 11.4615 12.2757 11.3822 12.1781 11.3281ZM8.75 16.25H3.75V12.5H8.75V16.25ZM11.25 15.7477L10 14.9664V13.7836L11.25 13.0023V15.7477Z",
      fill: "#F59638"
    }, null, -1)
  ])]);
}
const Dk = { render: u6 }, kk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Dk,
  render: u6
}, Symbol.toStringTag, { value: "Module" })), Hk = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function h6(e, t) {
  return f(), v("svg", Hk, [...t[0] || (t[0] = [
    g("path", {
      d: "M15.625 1.875H5.625C5.29348 1.875 4.97554 2.0067 4.74112 2.24112C4.5067 2.47554 4.375 2.79348 4.375 3.125V5H3.125C2.79348 5 2.47554 5.1317 2.24112 5.36612C2.0067 5.60054 1.875 5.91848 1.875 6.25V13.75C1.875 14.0815 2.0067 14.3995 2.24112 14.6339C2.47554 14.8683 2.79348 15 3.125 15H4.375V16.875C4.375 17.2065 4.5067 17.5245 4.74112 17.7589C4.97554 17.9933 5.29348 18.125 5.625 18.125H15.625C15.9565 18.125 16.2745 17.9933 16.5089 17.7589C16.7433 17.5245 16.875 17.2065 16.875 16.875V3.125C16.875 2.79348 16.7433 2.47554 16.5089 2.24112C16.2745 2.0067 15.9565 1.875 15.625 1.875ZM12.5 8.125H15.625V11.875H12.5V8.125ZM5.625 3.125H15.625V6.875H12.5V6.25C12.5 5.91848 12.3683 5.60054 12.1339 5.36612C11.8995 5.1317 11.5815 5 11.25 5H5.625V3.125ZM3.125 6.25H11.25V12.4867C11.25 12.4914 11.25 12.4953 11.25 12.5C11.25 12.5047 11.25 12.5086 11.25 12.5133V13.75H3.125V6.25ZM5.625 16.875V15H11.25C11.5815 15 11.8995 14.8683 12.1339 14.6339C12.3683 14.3995 12.5 14.0815 12.5 13.75V13.125H15.625V16.875H5.625ZM5.33125 12.0266L4.39375 8.27656C4.37225 8.19642 4.36692 8.1128 4.37808 8.03057C4.38923 7.94835 4.41665 7.86917 4.45873 7.79765C4.50081 7.72614 4.55671 7.66372 4.62317 7.61403C4.68963 7.56435 4.76532 7.52839 4.84582 7.50827C4.92632 7.48814 5.01002 7.48425 5.09204 7.49681C5.17406 7.50938 5.25276 7.53815 5.32354 7.58145C5.39433 7.62475 5.45578 7.68171 5.50432 7.74901C5.55286 7.81631 5.58751 7.8926 5.60625 7.97344L6.13437 10.0828L6.62812 9.09375C6.67996 8.98975 6.75977 8.90225 6.85858 8.8411C6.95739 8.77994 7.07129 8.74754 7.1875 8.74754C7.30371 8.74754 7.41761 8.77994 7.51642 8.8411C7.61523 8.90225 7.69504 8.98975 7.74688 9.09375L8.24063 10.0828L8.76875 7.97344C8.81122 7.81513 8.91418 7.67984 9.05545 7.59672C9.19671 7.5136 9.36498 7.4893 9.52399 7.52905C9.683 7.56881 9.82003 7.66943 9.90556 7.80925C9.99109 7.94907 10.0183 8.11689 9.98125 8.27656L9.04375 12.0266C9.0126 12.1503 8.94433 12.2615 8.84811 12.3453C8.75188 12.4291 8.63231 12.4815 8.50547 12.4953C8.48289 12.4978 8.46021 12.4991 8.4375 12.4992C8.32139 12.4993 8.20755 12.467 8.10875 12.406C8.00994 12.3451 7.93008 12.2577 7.87812 12.1539L7.1875 10.7727L6.49688 12.1547C6.43979 12.269 6.34904 12.3631 6.23686 12.4242C6.12467 12.4854 5.99643 12.5107 5.86942 12.4967C5.74241 12.4828 5.62274 12.4302 5.52651 12.3461C5.43029 12.2621 5.36214 12.1505 5.33125 12.0266Z",
      fill: "#3062D4"
    }, null, -1)
  ])]);
}
const Vk = { render: h6 }, Ok = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Vk,
  render: h6
}, Symbol.toStringTag, { value: "Module" })), Bk = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function g6(e, t) {
  return f(), v("svg", Bk, [...t[0] || (t[0] = [
    g("path", {
      d: "M14.375 11.25H13.125C12.9592 11.25 12.8003 11.3158 12.6831 11.4331C12.5658 11.5503 12.5 11.7092 12.5 11.875V16.25C12.5 16.4158 12.5658 16.5747 12.6831 16.6919C12.8003 16.8092 12.9592 16.875 13.125 16.875C13.2908 16.875 13.4497 16.8092 13.5669 16.6919C13.6842 16.5747 13.75 16.4158 13.75 16.25V15.625H14.375C14.9552 15.625 15.5116 15.3945 15.9218 14.9843C16.332 14.5741 16.5625 14.0177 16.5625 13.4375C16.5625 12.8573 16.332 12.3009 15.9218 11.8907C15.5116 11.4805 14.9552 11.25 14.375 11.25ZM14.375 14.375H13.75V12.5H14.375C14.6236 12.5 14.8621 12.5988 15.0379 12.7746C15.2137 12.9504 15.3125 13.1889 15.3125 13.4375C15.3125 13.6861 15.2137 13.9246 15.0379 14.1004C14.8621 14.2762 14.6236 14.375 14.375 14.375ZM10.625 11.875V16.25C10.625 16.4158 10.5592 16.5747 10.4419 16.6919C10.3247 16.8092 10.1658 16.875 10 16.875C9.83424 16.875 9.67527 16.8092 9.55806 16.6919C9.44085 16.5747 9.375 16.4158 9.375 16.25V11.875C9.375 11.7092 9.44085 11.5503 9.55806 11.4331C9.67527 11.3158 9.83424 11.25 10 11.25C10.1658 11.25 10.3247 11.3158 10.4419 11.4331C10.5592 11.5503 10.625 11.7092 10.625 11.875ZM7.5 16.25C7.5 16.4158 7.43415 16.5747 7.31694 16.6919C7.19973 16.8092 7.04076 16.875 6.875 16.875H4.375C4.26481 16.876 4.15633 16.8478 4.06053 16.7934C3.96473 16.7389 3.88504 16.6601 3.82951 16.5649C3.77399 16.4698 3.74462 16.3616 3.74438 16.2514C3.74413 16.1412 3.77303 16.0329 3.82812 15.9375L5.79375 12.5H4.375C4.20924 12.5 4.05027 12.4342 3.93306 12.3169C3.81585 12.1997 3.75 12.0408 3.75 11.875C3.75 11.7092 3.81585 11.5503 3.93306 11.4331C4.05027 11.3158 4.20924 11.25 4.375 11.25H6.875C6.98519 11.249 7.09367 11.2772 7.18947 11.3316C7.28527 11.3861 7.36496 11.4649 7.42049 11.5601C7.47601 11.6552 7.50538 11.7634 7.50562 11.8736C7.50587 11.9838 7.47697 12.0921 7.42188 12.1875L5.45234 15.625H6.875C7.04076 15.625 7.19973 15.6908 7.31694 15.8081C7.43415 15.9253 7.5 16.0842 7.5 16.25ZM16.6922 6.43281L12.3172 2.05781C12.2591 1.99979 12.1902 1.95378 12.1143 1.92241C12.0384 1.89105 11.9571 1.87494 11.875 1.875H4.375C4.04348 1.875 3.72554 2.0067 3.49112 2.24112C3.2567 2.47554 3.125 2.79348 3.125 3.125V8.75C3.125 8.91576 3.19085 9.07473 3.30806 9.19194C3.42527 9.30915 3.58424 9.375 3.75 9.375C3.91576 9.375 4.07473 9.30915 4.19194 9.19194C4.30915 9.07473 4.375 8.91576 4.375 8.75V3.125H11.25V6.875C11.25 7.04076 11.3158 7.19973 11.4331 7.31694C11.5503 7.43415 11.7092 7.5 11.875 7.5H15.625V8.75C15.625 8.91576 15.6908 9.07473 15.8081 9.19194C15.9253 9.30915 16.0842 9.375 16.25 9.375C16.4158 9.375 16.5747 9.30915 16.6919 9.19194C16.8092 9.07473 16.875 8.91576 16.875 8.75V6.875C16.8751 6.7929 16.859 6.71159 16.8276 6.63572C16.7962 6.55985 16.7502 6.4909 16.6922 6.43281ZM12.5 6.25V4.00859L14.7414 6.25H12.5Z",
      fill: "#077597"
    }, null, -1)
  ])]);
}
const $k = { render: g6 }, Zk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: $k,
  render: g6
}, Symbol.toStringTag, { value: "Module" })), Gk = {
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function p6(e, t) {
  return f(), v("svg", Gk, [...t[0] || (t[0] = [
    g("path", {
      d: "M16.6922 6.75508L12.3172 2.38008C12.2591 2.32206 12.1902 2.27605 12.1143 2.24468C12.0384 2.21331 11.9571 2.1972 11.875 2.19727H4.375C4.04348 2.19727 3.72554 2.32896 3.49112 2.56338C3.2567 2.7978 3.125 3.11575 3.125 3.44727V17.1973C3.125 17.5288 3.2567 17.8467 3.49112 18.0811C3.72554 18.3156 4.04348 18.4473 4.375 18.4473H15.625C15.9565 18.4473 16.2745 18.3156 16.5089 18.0811C16.7433 17.8467 16.875 17.5288 16.875 17.1973V7.19727C16.8751 7.11517 16.859 7.03386 16.8276 6.95798C16.7962 6.88211 16.7502 6.81316 16.6922 6.75508ZM12.5 4.33086L14.7414 6.57227H12.5V4.33086ZM15.625 17.1973H4.375V3.44727H11.25V7.19727C11.25 7.36303 11.3158 7.522 11.4331 7.63921C11.5503 7.75642 11.7092 7.82227 11.875 7.82227H15.625V17.1973Z",
      fill: "currentColor"
    }, null, -1)
  ])]);
}
const Nk = { render: p6 }, zk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Nk,
  render: p6
}, Symbol.toStringTag, { value: "Module" })), jk = {
  viewBox: "0 0 21 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function f6(e, t) {
  return f(), v("svg", jk, [...t[0] || (t[0] = [
    g("path", {
      d: "M9.1234 2.14841C8.84057 2.08886 8.54582 2.13007 8.29016 2.26489C8.0345 2.39971 7.83401 2.61966 7.7234 2.88669L7.71871 2.89763L2.71871 15.3922C2.63955 15.5823 2.60859 15.789 2.62859 15.994C2.64859 16.199 2.71892 16.3958 2.83334 16.5671C2.94776 16.7383 3.10272 16.8786 3.28444 16.9756C3.46616 17.0725 3.66901 17.123 3.87496 17.1226H8.87496C9.20648 17.1226 9.52442 16.9909 9.75884 16.7565C9.99326 16.5221 10.125 16.2041 10.125 15.8726V3.37263C10.127 3.08379 10.028 2.80332 9.84511 2.57977C9.66221 2.35621 9.40692 2.20362 9.1234 2.14841ZM8.87496 15.8726H3.87496L3.87965 15.8609L8.87496 3.37263V15.8726ZM18.7789 15.3922L13.7789 2.89763L13.7742 2.88669C13.6611 2.62241 13.4604 2.40517 13.2059 2.27158C12.9513 2.13798 12.6585 2.0962 12.3768 2.15326C12.0951 2.21033 11.8416 2.36275 11.6591 2.58485C11.4766 2.80696 11.3763 3.08517 11.375 3.37263V15.8726C11.375 16.2041 11.5067 16.5221 11.7411 16.7565C11.9755 16.9909 12.2934 17.1226 12.625 17.1226H17.625C17.8308 17.1227 18.0334 17.072 18.215 16.975C18.3965 16.878 18.5512 16.7376 18.6655 16.5664C18.7797 16.3952 18.8499 16.1985 18.8698 15.9936C18.8897 15.7888 18.8588 15.5822 18.7796 15.3922H18.7789ZM12.625 15.8726V3.37263L17.6195 15.8601L17.6242 15.8718L12.625 15.8726Z",
      fill: "currentColor"
    }, null, -1)
  ])]);
}
const Wk = { render: f6 }, Uk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Wk,
  render: f6
}, Symbol.toStringTag, { value: "Module" })), Kk = {
  viewBox: "0 0 21 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function v6(e, t) {
  return f(), v("svg", Kk, [...t[0] || (t[0] = [
    g("path", {
      d: "M5.125 9.62248H17.625C17.9135 9.6226 18.1932 9.52291 18.4166 9.34033C18.6399 9.15775 18.7933 8.90352 18.8506 8.62077C18.9079 8.33801 18.8656 8.04413 18.731 7.78899C18.5963 7.53384 18.3775 7.33314 18.1117 7.22092L18.1008 7.21623L5.60625 2.21623C5.41609 2.1369 5.20926 2.10581 5.00417 2.12573C4.79909 2.14564 4.60211 2.21595 4.43076 2.33039C4.25941 2.44483 4.11901 2.59985 4.02205 2.78166C3.92509 2.96347 3.87457 3.16643 3.875 3.37248V8.37248C3.875 8.704 4.0067 9.02194 4.24112 9.25636C4.47554 9.49078 4.79348 9.62248 5.125 9.62248ZM5.125 3.37248L5.13672 3.37717L17.625 8.37248H5.125V3.37248ZM17.625 10.8725H5.125C4.79348 10.8725 4.47554 11.0042 4.24112 11.2386C4.0067 11.473 3.875 11.791 3.875 12.1225V17.1225C3.87488 17.3283 3.92559 17.531 4.02262 17.7125C4.11964 17.894 4.25999 18.0487 4.43119 18.163C4.6024 18.2772 4.79916 18.3474 5.00401 18.3673C5.20886 18.3872 5.41547 18.3563 5.60547 18.2772L18.1 13.2772L18.1109 13.2725C18.3757 13.1597 18.5934 12.959 18.7274 12.7043C18.8613 12.4496 18.9033 12.1565 18.8462 11.8744C18.7891 11.5924 18.6364 11.3386 18.4139 11.1561C18.1914 10.9736 17.9128 10.8734 17.625 10.8725ZM5.13672 17.117L5.125 17.1225V12.1225H17.625L5.13672 17.117Z",
      fill: "currentColor"
    }, null, -1)
  ])]);
}
const qk = { render: v6 }, Yk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: qk,
  render: v6
}, Symbol.toStringTag, { value: "Module" })), Qk = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function m6(e, t) {
  return f(), v("svg", Qk, [...t[0] || (t[0] = [
    g("path", { d: "M219.31,72,184,36.69A15.86,15.86,0,0,0,172.69,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V83.31A15.86,15.86,0,0,0,219.31,72ZM168,208H88V152h80Zm40,0H184V152a16,16,0,0,0-16-16H88a16,16,0,0,0-16,16v56H48V48H172.69L208,83.31ZM160,72a8,8,0,0,1-8,8H96a8,8,0,0,1,0-16h56A8,8,0,0,1,160,72Z" }, null, -1)
  ])]);
}
const Jk = { render: m6 }, Xk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Jk,
  render: m6
}, Symbol.toStringTag, { value: "Module" })), eH = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function C6(e, t) {
  return f(), v("svg", eH, [...t[0] || (t[0] = [
    g("path", { d: "M216,72H131.31L104,44.69A15.86,15.86,0,0,0,92.69,40H40A16,16,0,0,0,24,56V200.62A15.4,15.4,0,0,0,39.38,216H216.89A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72ZM92.69,56l16,16H40V56ZM216,200H40V88H216ZM104,136h48a8,8,0,0,1,0,16H104a8,8,0,0,1,0-16Z" }, null, -1)
  ])]);
}
const tH = { render: C6 }, oH = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: tH,
  render: C6
}, Symbol.toStringTag, { value: "Module" })), nH = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function w6(e, t) {
  return f(), v("svg", nH, [...t[0] || (t[0] = [
    g("path", { d: "M216,72H131.31L104,44.69A15.86,15.86,0,0,0,92.69,40H40A16,16,0,0,0,24,56V200.62A15.4,15.4,0,0,0,39.38,216H216.89A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72ZM92.69,56l16,16H40V56ZM216,200H40V88H216Zm-88-88a8,8,0,0,1,8,8v16h16a8,8,0,0,1,0,16H136v16a8,8,0,0,1-16,0V152H104a8,8,0,0,1,0-16h16V120A8,8,0,0,1,128,112Z" }, null, -1)
  ])]);
}
const sH = { render: w6 }, iH = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sH,
  render: w6
}, Symbol.toStringTag, { value: "Module" })), rH = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 256 256"
};
function b6(e, t) {
  return f(), v("svg", rH, [...t[0] || (t[0] = [
    g("path", { d: "M216,72H131.31L104,44.69A15.86,15.86,0,0,0,92.69,40H40A16,16,0,0,0,24,56V200.62A15.4,15.4,0,0,0,39.38,216H216.89A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72ZM40,56H92.69l16,16H40ZM216,200H40V88H216Z" }, null, -1)
  ])]);
}
const lH = { render: b6 }, aH = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: lH,
  render: b6
}, Symbol.toStringTag, { value: "Module" })), cH = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 256 256"
};
function y6(e, t) {
  return f(), v("svg", cH, [...t[0] || (t[0] = [
    g("path", { d: "M200,136a8,8,0,0,1-8,8H64a8,8,0,0,1,0-16H192A8,8,0,0,1,200,136Zm32-56H24a8,8,0,0,0,0,16H232a8,8,0,0,0,0-16Zm-80,96H104a8,8,0,0,0,0,16h48a8,8,0,0,0,0-16Z" }, null, -1)
  ])]);
}
const dH = { render: y6 }, uH = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: dH,
  render: y6
}, Symbol.toStringTag, { value: "Module" })), hH = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function _6(e, t) {
  return f(), v("svg", hH, [...t[0] || (t[0] = [
    g("path", { d: "M230.6,49.53A15.81,15.81,0,0,0,216,40H40A16,16,0,0,0,28.19,66.76l.08.09L96,139.17V216a16,16,0,0,0,24.87,13.32l32-21.34A16,16,0,0,0,160,194.66V139.17l67.74-72.32.08-.09A15.8,15.8,0,0,0,230.6,49.53ZM40,56h0Zm106.18,74.58A8,8,0,0,0,144,136v58.66L112,216V136a8,8,0,0,0-2.16-5.47L40,56H216Z" }, null, -1)
  ])]);
}
const gH = { render: _6 }, pH = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: gH,
  render: _6
}, Symbol.toStringTag, { value: "Module" })), fH = {
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function S6(e, t) {
  return f(), v("svg", fH, [...t[0] || (t[0] = [
    g("path", {
      d: "M10 6.57224C9.25836 6.57224 8.53333 6.79217 7.91665 7.20423C7.29996 7.61629 6.81932 8.20196 6.53549 8.88718C6.25166 9.5724 6.1774 10.3264 6.32209 11.0538C6.46679 11.7813 6.82394 12.4494 7.34839 12.9739C7.87283 13.4983 8.54102 13.8555 9.26845 14.0002C9.99588 14.1449 10.7499 14.0706 11.4351 13.7868C12.1203 13.503 12.706 13.0223 13.118 12.4056C13.5301 11.7889 13.75 11.0639 13.75 10.3222C13.749 9.328 13.3536 8.37477 12.6505 7.67173C11.9475 6.9687 10.9943 6.57327 10 6.57224ZM10 12.8222C9.50558 12.8222 9.02223 12.6756 8.61111 12.4009C8.19999 12.1262 7.87956 11.7358 7.69034 11.2789C7.50112 10.8221 7.45161 10.3195 7.54807 9.83452C7.64454 9.34956 7.88264 8.90411 8.23227 8.55447C8.5819 8.20484 9.02736 7.96674 9.51231 7.87028C9.99726 7.77381 10.4999 7.82332 10.9567 8.01254C11.4136 8.20176 11.804 8.52219 12.0787 8.93332C12.3534 9.34444 12.5 9.82779 12.5 10.3222C12.5 10.9853 12.2366 11.6212 11.7678 12.09C11.299 12.5588 10.6631 12.8222 10 12.8222ZM16.875 10.491C16.8782 10.3785 16.8782 10.266 16.875 10.1535L18.0407 8.69724C18.1018 8.62078 18.1441 8.53103 18.1642 8.43523C18.1843 8.33943 18.1816 8.24025 18.1563 8.14568C17.9652 7.4274 17.6794 6.73775 17.3063 6.0949C17.2574 6.01077 17.1896 5.93921 17.1082 5.88591C17.0269 5.8326 16.9342 5.79903 16.8375 5.78787L14.9844 5.58162C14.9073 5.50037 14.8292 5.42224 14.75 5.34724L14.5313 3.48943C14.52 3.39272 14.4863 3.29998 14.4329 3.21859C14.3795 3.13721 14.3077 3.06944 14.2235 3.02068C13.5804 2.64829 12.8908 2.36274 12.1727 2.17146C12.0781 2.1463 11.9788 2.14373 11.883 2.16395C11.7872 2.18417 11.6975 2.22661 11.6211 2.28787L10.1688 3.44724C10.0563 3.44724 9.94379 3.44724 9.83129 3.44724L8.37504 2.28396C8.29858 2.22284 8.20883 2.18054 8.11303 2.16045C8.01722 2.14037 7.91804 2.14307 7.82347 2.16833C7.10531 2.35976 6.4157 2.64559 5.77269 3.01833C5.68857 3.06718 5.617 3.13499 5.5637 3.21637C5.5104 3.29775 5.47683 3.39045 5.46566 3.48708L5.25941 5.34333C5.17816 5.42094 5.10004 5.49906 5.02504 5.57771L3.16722 5.79099C3.07051 5.80224 2.97777 5.83593 2.89639 5.88937C2.815 5.94281 2.74723 6.01453 2.69847 6.0988C2.32609 6.7419 2.04053 7.43149 1.84925 8.14958C1.8241 8.24421 1.82152 8.34343 1.84174 8.43923C1.86196 8.53504 1.90441 8.62476 1.96566 8.70115L3.12504 10.1535C3.12504 10.266 3.12504 10.3785 3.12504 10.491L1.96175 11.9472C1.90064 12.0237 1.85833 12.1134 1.83825 12.2093C1.81816 12.3051 1.82086 12.4042 1.84613 12.4988C2.03721 13.2171 2.32306 13.9067 2.69613 14.5496C2.74498 14.6337 2.81279 14.7053 2.89417 14.7586C2.97555 14.8119 3.06824 14.8454 3.16488 14.8566L5.01801 15.0629C5.09561 15.1441 5.17373 15.2222 5.25238 15.2972L5.46879 17.1551C5.48004 17.2518 5.51373 17.3445 5.56717 17.4259C5.62061 17.5073 5.69233 17.575 5.7766 17.6238C6.4197 17.9962 7.10929 18.2817 7.82738 18.473C7.92201 18.4982 8.02122 18.5008 8.11703 18.4805C8.21284 18.4603 8.30255 18.4179 8.37894 18.3566L9.83129 17.1972C9.94379 17.2004 10.0563 17.2004 10.1688 17.1972L11.625 18.3629C11.7015 18.424 11.7912 18.4663 11.887 18.4864C11.9828 18.5065 12.082 18.5038 12.1766 18.4785C12.8949 18.2874 13.5845 18.0016 14.2274 17.6285C14.3115 17.5796 14.3831 17.5118 14.4364 17.4305C14.4897 17.3491 14.5232 17.2564 14.5344 17.1597L14.7407 15.3066C14.8219 15.2295 14.9 15.1514 14.975 15.0722L16.8329 14.8535C16.9296 14.8422 17.0223 14.8086 17.1037 14.7551C17.1851 14.7017 17.2528 14.63 17.3016 14.5457C17.674 13.9026 17.9595 13.213 18.1508 12.4949C18.176 12.4003 18.1786 12.3011 18.1583 12.2052C18.1381 12.1094 18.0957 12.0197 18.0344 11.9433L16.875 10.491ZM15.6172 9.98318C15.6305 10.209 15.6305 10.4355 15.6172 10.6613C15.6079 10.8159 15.6564 10.9685 15.7532 11.0894L16.8618 12.4746C16.7345 12.8789 16.5717 13.271 16.375 13.6465L14.6094 13.8465C14.4557 13.8635 14.3137 13.937 14.211 14.0527C14.0606 14.2218 13.9004 14.382 13.7313 14.5324C13.6156 14.6351 13.5421 14.7771 13.525 14.9308L13.3289 16.6949C12.9536 16.8916 12.5614 17.0545 12.1571 17.1816L10.7711 16.073C10.6602 15.9844 10.5225 15.9362 10.3805 15.9363H10.343C10.1172 15.9496 9.89073 15.9496 9.66488 15.9363C9.51026 15.927 9.35769 15.9754 9.23676 16.0722L7.84769 17.1816C7.44342 17.0544 7.05125 16.8915 6.67582 16.6949L6.47582 14.9316C6.45875 14.7779 6.38526 14.6359 6.26957 14.5332C6.10043 14.3828 5.94026 14.2226 5.78988 14.0535C5.68717 13.9378 5.5452 13.8643 5.39144 13.8472L3.62738 13.6504C3.43065 13.275 3.26777 12.8828 3.14066 12.4785L4.24925 11.0926C4.34606 10.9716 4.3945 10.8191 4.38519 10.6644C4.37191 10.4386 4.37191 10.2121 4.38519 9.9863C4.3945 9.83168 4.34606 9.67911 4.24925 9.55818L3.14066 8.1699C3.26787 7.76563 3.43075 7.37346 3.62738 6.99802L5.39066 6.79802C5.54442 6.78095 5.68639 6.70747 5.7891 6.59177C5.93948 6.42264 6.09965 6.26247 6.26879 6.11208C6.38494 6.00931 6.45873 5.86702 6.47582 5.71287L6.67191 3.94958C7.0473 3.75286 7.43948 3.58998 7.84379 3.46287L9.22972 4.57146C9.35066 4.66826 9.50323 4.7167 9.65785 4.7074C9.8837 4.69412 10.1101 4.69412 10.336 4.7074C10.4906 4.7167 10.6432 4.66826 10.7641 4.57146L12.1524 3.46287C12.5567 3.59007 12.9488 3.75295 13.3243 3.94958L13.5243 5.71287C13.5413 5.86663 13.6148 6.00859 13.7305 6.1113C13.8996 6.26169 14.0598 6.42186 14.2102 6.59099C14.3129 6.70668 14.4549 6.78017 14.6086 6.79724L16.3727 6.99333C16.5694 7.36873 16.7323 7.7609 16.8594 8.16521L15.7508 9.55115C15.6531 9.6731 15.6046 9.82724 15.6149 9.98318H15.6172Z",
      fill: "currentColor"
    }, null, -1)
  ])]);
}
const vH = { render: S6 }, mH = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: vH,
  render: S6
}, Symbol.toStringTag, { value: "Module" })), CH = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function x6(e, t) {
  return f(), v("svg", CH, [...t[0] || (t[0] = [
    g("path", { d: "M128,24h0A104,104,0,1,0,232,128,104.12,104.12,0,0,0,128,24Zm88,104a87.61,87.61,0,0,1-3.33,24H174.16a157.44,157.44,0,0,0,0-48h38.51A87.61,87.61,0,0,1,216,128ZM102,168H154a115.11,115.11,0,0,1-26,45A115.27,115.27,0,0,1,102,168Zm-3.9-16a140.84,140.84,0,0,1,0-48h59.88a140.84,140.84,0,0,1,0,48ZM40,128a87.61,87.61,0,0,1,3.33-24H81.84a157.44,157.44,0,0,0,0,48H43.33A87.61,87.61,0,0,1,40,128ZM154,88H102a115.11,115.11,0,0,1,26-45A115.27,115.27,0,0,1,154,88Zm52.33,0H170.71a135.28,135.28,0,0,0-22.3-45.6A88.29,88.29,0,0,1,206.37,88ZM107.59,42.4A135.28,135.28,0,0,0,85.29,88H49.63A88.29,88.29,0,0,1,107.59,42.4ZM49.63,168H85.29a135.28,135.28,0,0,0,22.3,45.6A88.29,88.29,0,0,1,49.63,168Zm98.78,45.6a135.28,135.28,0,0,0,22.3-45.6h35.66A88.29,88.29,0,0,1,148.41,213.6Z" }, null, -1)
  ])]);
}
const wH = { render: x6 }, bH = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: wH,
  render: x6
}, Symbol.toStringTag, { value: "Module" })), yH = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256"
};
function M6(e, t) {
  return f(), v("svg", yH, [...t[0] || (t[0] = [
    g("rect", {
      width: "256",
      height: "256",
      fill: "none"
    }, null, -1),
    g("polyline", {
      points: "56 48 208 104 56 160",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1),
    g("line", {
      x1: "208",
      y1: "200",
      x2: "56",
      y2: "200",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1)
  ])]);
}
const _H = { render: M6 }, SH = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _H,
  render: M6
}, Symbol.toStringTag, { value: "Module" })), xH = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256"
};
function A6(e, t) {
  return f(), v("svg", xH, [...t[0] || (t[0] = [
    g("rect", {
      width: "256",
      height: "256",
      fill: "none"
    }, null, -1),
    g("polyline", {
      points: "64 56 216 128 64 200",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1)
  ])]);
}
const MH = { render: A6 }, AH = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: MH,
  render: A6
}, Symbol.toStringTag, { value: "Module" })), LH = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function L6(e, t) {
  return f(), v("svg", LH, [...t[0] || (t[0] = [
    g("path", { d: "M216,48H40A16,16,0,0,0,24,64V192a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V64A16,16,0,0,0,216,48ZM104,144V112h48v32Zm48,16v32H104V160ZM40,112H88v32H40Zm64-16V64h48V96Zm64,16h48v32H168Zm48-16H168V64h48ZM88,64V96H40V64ZM40,160H88v32H40Zm176,32H168V160h48v32Z" }, null, -1)
  ])]);
}
const EH = { render: L6 }, PH = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: EH,
  render: L6
}, Symbol.toStringTag, { value: "Module" })), RH = {
  viewBox: "0 0 15 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function E6(e, t) {
  return f(), v("svg", RH, [...t[0] || (t[0] = [
    g("path", {
      d: "M6.25 2.13409V9.37549C6.25 9.54125 6.18415 9.70022 6.06694 9.81743C5.94973 9.93464 5.79076 10.0005 5.625 10.0005C5.45924 10.0005 5.30027 9.93464 5.18306 9.81743C5.06585 9.70022 5 9.54125 5 9.37549V2.13409L3.56719 3.56768C3.50912 3.62575 3.44018 3.67181 3.36431 3.70324C3.28844 3.73466 3.20712 3.75084 3.125 3.75084C2.95915 3.75084 2.80009 3.68495 2.68281 3.56768C2.62474 3.50961 2.57868 3.44067 2.54725 3.3648C2.51583 3.28893 2.49965 3.20761 2.49965 3.12549C2.49965 2.95964 2.56554 2.80058 2.68281 2.6833L5.18281 0.183304C5.24086 0.125194 5.30979 0.0790945 5.38566 0.0476418C5.46154 0.0161892 5.54287 0 5.625 0C5.70713 0 5.78846 0.0161892 5.86434 0.0476418C5.94021 0.0790945 6.00914 0.125194 6.06719 0.183304L8.56719 2.6833C8.68446 2.80058 8.75035 2.95964 8.75035 3.12549C8.75035 3.29134 8.68446 3.4504 8.56719 3.56768C8.44991 3.68495 8.29085 3.75084 8.125 3.75084C7.95915 3.75084 7.80009 3.68495 7.68281 3.56768L6.25 2.13409ZM11.25 9.0333V6.87549C11.25 6.54397 11.1183 6.22603 10.8839 5.99161C10.6495 5.75719 10.3315 5.62549 10 5.62549H8.75C8.58424 5.62549 8.42527 5.69134 8.30806 5.80855C8.19085 5.92576 8.125 6.08473 8.125 6.25049C8.125 6.41625 8.19085 6.57522 8.30806 6.69243C8.42527 6.80964 8.58424 6.87549 8.75 6.87549H10V13.1567C9.62728 12.776 9.12841 12.5444 8.59702 12.5053C8.06564 12.4663 7.53828 12.6226 7.11393 12.9448C6.68959 13.267 6.39743 13.733 6.29231 14.2554C6.18718 14.7777 6.27631 15.3205 6.54297 15.7817L6.56172 15.8114L8.30078 18.4677C8.39153 18.6064 8.53368 18.7034 8.69594 18.7373C8.8582 18.7712 9.0273 18.7393 9.16602 18.6485C9.30474 18.5578 9.40172 18.4156 9.43564 18.2534C9.46956 18.0911 9.43763 17.922 9.34688 17.7833L7.61797 15.1435C7.49541 14.927 7.46384 14.6708 7.53021 14.4311C7.59658 14.1914 7.75545 13.9879 7.97187 13.8653C8.1883 13.7428 8.44454 13.7112 8.68423 13.7776C8.92393 13.844 9.12744 14.0028 9.25 14.2192C9.25547 14.2294 9.26172 14.2396 9.26797 14.2489L10.1023 15.5231C10.1761 15.6356 10.2842 15.7213 10.4105 15.7675C10.5368 15.8136 10.6747 15.8178 10.8036 15.7794C10.9325 15.7409 11.0455 15.662 11.126 15.5541C11.2064 15.4463 11.2499 15.3155 11.25 15.181V10.6255C11.8391 11.1708 12.3096 11.8316 12.6322 12.5667C12.9548 13.3018 13.1225 14.0954 13.125 14.8981V18.1255C13.125 18.2913 13.1908 18.4502 13.3081 18.5674C13.4253 18.6846 13.5842 18.7505 13.75 18.7505C13.9158 18.7505 14.0747 18.6846 14.1919 18.5674C14.3092 18.4502 14.375 18.2913 14.375 18.1255V14.895C14.3715 13.7372 14.0849 12.5979 13.5402 11.5762C12.9955 10.5545 12.2093 9.68155 11.25 9.0333ZM2.5 5.62549H1.25C0.918479 5.62549 0.600537 5.75719 0.366116 5.99161C0.131696 6.22603 0 6.54397 0 6.87549V15.0005C0 15.1663 0.0658481 15.3252 0.183058 15.4424C0.300269 15.5596 0.45924 15.6255 0.625 15.6255C0.79076 15.6255 0.949731 15.5596 1.06694 15.4424C1.18415 15.3252 1.25 15.1663 1.25 15.0005V6.87549H2.5C2.66576 6.87549 2.82473 6.80964 2.94194 6.69243C3.05915 6.57522 3.125 6.41625 3.125 6.25049C3.125 6.08473 3.05915 5.92576 2.94194 5.80855C2.82473 5.69134 2.66576 5.62549 2.5 5.62549Z",
      fill: "currentColor"
    }, null, -1)
  ])]);
}
const FH = { render: E6 }, TH = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: FH,
  render: E6
}, Symbol.toStringTag, { value: "Module" })), IH = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function P6(e, t) {
  return f(), v("svg", IH, [...t[0] || (t[0] = [
    g("path", { d: "M208,136H48a16,16,0,0,0-16,16v48a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V152A16,16,0,0,0,208,136Zm0,64H48V152H208v48Zm0-160H48A16,16,0,0,0,32,56v48a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V56A16,16,0,0,0,208,40Zm0,64H48V56H208v48ZM192,80a12,12,0,1,1-12-12A12,12,0,0,1,192,80Zm0,96a12,12,0,1,1-12-12A12,12,0,0,1,192,176Z" }, null, -1)
  ])]);
}
const DH = { render: P6 }, kH = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: DH,
  render: P6
}, Symbol.toStringTag, { value: "Module" })), HH = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function R6(e, t) {
  return f(), v("svg", HH, [...t[0] || (t[0] = [
    g("path", { d: "M224,88H175.4l8.47-46.57a8,8,0,0,0-15.74-2.86l-9,49.43H111.4l8.47-46.57a8,8,0,0,0-15.74-2.86L95.14,88H48a8,8,0,0,0,0,16H92.23L83.5,152H32a8,8,0,0,0,0,16H80.6l-8.47,46.57a8,8,0,0,0,6.44,9.3A7.79,7.79,0,0,0,80,224a8,8,0,0,0,7.86-6.57l9-49.43H144.6l-8.47,46.57a8,8,0,0,0,6.44,9.3A7.79,7.79,0,0,0,144,224a8,8,0,0,0,7.86-6.57l9-49.43H208a8,8,0,0,0,0-16H163.77l8.73-48H224a8,8,0,0,0,0-16Zm-76.5,64H99.77l8.73-48h47.73Z" }, null, -1)
  ])]);
}
const VH = { render: R6 }, OH = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: VH,
  render: R6
}, Symbol.toStringTag, { value: "Module" })), BH = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function F6(e, t) {
  return f(), v("svg", BH, [...t[0] || (t[0] = [
    g("path", { d: "M219.31,108.68l-80-80a16,16,0,0,0-22.62,0l-80,80A15.87,15.87,0,0,0,32,120v96a8,8,0,0,0,8,8h64a8,8,0,0,0,8-8V160h32v56a8,8,0,0,0,8,8h64a8,8,0,0,0,8-8V120A15.87,15.87,0,0,0,219.31,108.68ZM208,208H160V152a8,8,0,0,0-8-8H104a8,8,0,0,0-8,8v56H48V120l80-80,80,80Z" }, null, -1)
  ])]);
}
const $H = { render: F6 }, ZH = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: $H,
  render: F6
}, Symbol.toStringTag, { value: "Module" })), GH = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function T6(e, t) {
  return f(), v("svg", GH, [...t[0] || (t[0] = [
    g("path", {
      d: "M16.25 2.5H3.75C3.41848 2.5 3.10054 2.6317 2.86612 2.86612C2.6317 3.10054 2.5 3.41848 2.5 3.75V16.25C2.5 16.5815 2.6317 16.8995 2.86612 17.1339C3.10054 17.3683 3.41848 17.5 3.75 17.5H16.25C16.5815 17.5 16.8995 17.3683 17.1339 17.1339C17.3683 16.8995 17.5 16.5815 17.5 16.25V3.75C17.5 3.41848 17.3683 3.10054 17.1339 2.86612C16.8995 2.6317 16.5815 2.5 16.25 2.5ZM3.75 3.75H16.25V9.79531L14.3211 7.86562C14.0867 7.63138 13.7689 7.4998 13.4375 7.4998C13.1061 7.4998 12.7883 7.63138 12.5539 7.86562L4.16953 16.25H3.75V3.75ZM16.25 16.25H5.9375L13.4375 8.75L16.25 11.5625V16.25ZM7.5 9.375C7.87084 9.375 8.23335 9.26503 8.54169 9.05901C8.85004 8.85298 9.09036 8.56014 9.23227 8.21753C9.37419 7.87492 9.41132 7.49792 9.33897 7.13421C9.26663 6.77049 9.08805 6.4364 8.82583 6.17417C8.5636 5.91195 8.22951 5.73337 7.86579 5.66103C7.50208 5.58868 7.12508 5.62581 6.78247 5.76773C6.43986 5.90964 6.14702 6.14996 5.94099 6.45831C5.73497 6.76665 5.625 7.12916 5.625 7.5C5.625 7.99728 5.82254 8.47419 6.17417 8.82583C6.52581 9.17746 7.00272 9.375 7.5 9.375ZM7.5 6.875C7.62361 6.875 7.74445 6.91166 7.84723 6.98033C7.95001 7.04901 8.03012 7.14662 8.07743 7.26082C8.12473 7.37503 8.13711 7.50069 8.11299 7.62193C8.08888 7.74317 8.02935 7.85453 7.94194 7.94194C7.85453 8.02935 7.74317 8.08888 7.62193 8.11299C7.50069 8.13711 7.37503 8.12473 7.26082 8.07743C7.14662 8.03012 7.04901 7.95001 6.98033 7.84723C6.91166 7.74445 6.875 7.62361 6.875 7.5C6.875 7.33424 6.94085 7.17527 7.05806 7.05806C7.17527 6.94085 7.33424 6.875 7.5 6.875Z",
      fill: "#8040BF"
    }, null, -1)
  ])]);
}
const NH = { render: T6 }, zH = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: NH,
  render: T6
}, Symbol.toStringTag, { value: "Module" })), jH = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function I6(e, t) {
  return f(), v("svg", jH, [...t[0] || (t[0] = [
    g("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm16-40a8,8,0,0,1-8,8,16,16,0,0,1-16-16V128a8,8,0,0,1,0-16,16,16,0,0,1,16,16v40A8,8,0,0,1,144,176ZM112,84a12,12,0,1,1,12,12A12,12,0,0,1,112,84Z" }, null, -1)
  ])]);
}
const WH = { render: I6 }, UH = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: WH,
  render: I6
}, Symbol.toStringTag, { value: "Module" })), KH = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 256 256"
};
function D6(e, t) {
  return f(), v("svg", KH, [...t[0] || (t[0] = [
    g("path", { d: "M216.57,39.43A80,80,0,0,0,83.91,120.78L28.69,176A15.86,15.86,0,0,0,24,187.31V216a16,16,0,0,0,16,16H72a8,8,0,0,0,8-8V208H96a8,8,0,0,0,8-8V184h16a8,8,0,0,0,5.66-2.34l9.56-9.57A79.73,79.73,0,0,0,160,176h.1A80,80,0,0,0,216.57,39.43ZM224,98.1c-1.09,34.09-29.75,61.86-63.89,61.9H160a63.7,63.7,0,0,1-23.65-4.51,8,8,0,0,0-8.84,1.68L116.69,168H96a8,8,0,0,0-8,8v16H72a8,8,0,0,0-8,8v16H40V187.31l58.83-58.82a8,8,0,0,0,1.68-8.84A63.72,63.72,0,0,1,96,95.92c0-34.14,27.81-62.8,61.9-63.89A64,64,0,0,1,224,98.1ZM192,76a12,12,0,1,1-12-12A12,12,0,0,1,192,76Z" }, null, -1)
  ])]);
}
const qH = { render: D6 }, YH = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: qH,
  render: D6
}, Symbol.toStringTag, { value: "Module" })), QH = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function k6(e, t) {
  return f(), v("svg", QH, [...t[0] || (t[0] = [
    g("path", {
      d: "M104,104V208H40a8,8,0,0,1-8-8V104Z",
      opacity: "0.2"
    }, null, -1),
    g("path", { d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,16V96H40V56ZM40,112H96v88H40Zm176,88H112V112H216v88Z" }, null, -1)
  ])]);
}
const JH = { render: k6 }, XH = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: JH,
  render: k6
}, Symbol.toStringTag, { value: "Module" })), eV = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function H6(e, t) {
  return f(), v("svg", eV, [...t[0] || (t[0] = [
    g("path", { d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,16V96H40V56ZM40,112H96v88H40Zm176,88H112V112H216v88Z" }, null, -1)
  ])]);
}
const tV = { render: H6 }, oV = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: tV,
  render: H6
}, Symbol.toStringTag, { value: "Module" })), nV = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256"
};
function V6(e, t) {
  return f(), v("svg", nV, [...t[0] || (t[0] = [
    g("rect", {
      width: "256",
      height: "256",
      fill: "none"
    }, null, -1),
    g("polyline", {
      points: "200 48 48 104 200 160",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1),
    g("line", {
      x1: "200",
      y1: "200",
      x2: "48",
      y2: "200",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1)
  ])]);
}
const sV = { render: V6 }, iV = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sV,
  render: V6
}, Symbol.toStringTag, { value: "Module" })), rV = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256"
};
function O6(e, t) {
  return f(), v("svg", rV, [...t[0] || (t[0] = [
    g("rect", {
      width: "256",
      height: "256",
      fill: "none"
    }, null, -1),
    g("polyline", {
      points: "200 56 48 128 200 200",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1)
  ])]);
}
const lV = { render: O6 }, aV = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: lV,
  render: O6
}, Symbol.toStringTag, { value: "Module" })), cV = {
  viewBox: "0 0 21 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function B6(e, t) {
  return f(), v("svg", cV, [...t[0] || (t[0] = [
    g("path", {
      d: "M19.4036 6.89303C19.3723 7.98104 18.9249 9.0156 18.1536 9.78365L15.4388 12.5001C15.0434 12.8976 14.5731 13.2128 14.055 13.4274C13.537 13.6419 12.9815 13.7516 12.4208 13.7501H12.4169C11.8466 13.7497 11.2822 13.635 10.757 13.4128C10.2318 13.1906 9.75643 12.8654 9.35901 12.4564C8.96159 12.0474 8.65017 11.5629 8.44314 11.0315C8.23611 10.5001 8.13767 9.93262 8.15364 9.36256C8.15831 9.1968 8.22862 9.03968 8.34913 8.92576C8.46964 8.81185 8.63046 8.75047 8.79622 8.75514C8.96198 8.7598 9.1191 8.83012 9.23302 8.95062C9.34693 9.07113 9.40831 9.23195 9.40364 9.39771C9.39226 9.80078 9.46179 10.202 9.60812 10.5778C9.75445 10.9535 9.97461 11.2961 10.2556 11.5853C10.5366 11.8745 10.8727 12.1045 11.244 12.2616C11.6154 12.4187 12.0145 12.4998 12.4177 12.5001C12.8141 12.5011 13.2067 12.4235 13.573 12.2718C13.9392 12.1202 14.2717 11.8974 14.5513 11.6165L17.2661 8.90162C17.8263 8.33444 18.1393 7.56869 18.1368 6.77155C18.1343 5.97441 17.8165 5.21063 17.2528 4.64696C16.6892 4.0833 15.9254 3.76553 15.1282 3.76304C14.3311 3.76054 13.5654 4.07352 12.9982 4.63365L12.1388 5.49303C12.0206 5.60529 11.8633 5.66695 11.7003 5.66486C11.5373 5.66278 11.3816 5.59711 11.2664 5.48186C11.1511 5.36661 11.0855 5.21089 11.0834 5.04792C11.0813 4.88494 11.1429 4.7276 11.2552 4.60943L12.1146 3.75006C12.5111 3.35344 12.9818 3.03882 13.4999 2.82416C14.018 2.60951 14.5733 2.49902 15.1341 2.49902C15.6949 2.49902 16.2502 2.60951 16.7683 2.82416C17.2864 3.03882 17.7572 3.35344 18.1536 3.75006C18.5643 4.16174 18.8869 4.65269 19.1018 5.19302C19.3167 5.73334 19.4194 6.31175 19.4036 6.89303ZM9.16927 14.5047L8.30989 15.3641C8.0296 15.6463 7.69601 15.8699 7.32853 16.022C6.96104 16.1741 6.56698 16.2516 6.16927 16.2501C5.57263 16.2496 4.98952 16.0723 4.49362 15.7405C3.99771 15.4088 3.61127 14.9375 3.38311 14.3862C3.15495 13.8349 3.09532 13.2283 3.21175 12.6432C3.32817 12.058 3.61544 11.5205 4.03724 11.0985L6.74739 8.38365C7.17426 7.95453 7.72029 7.66368 8.31457 7.54887C8.90886 7.43407 9.52393 7.5006 10.0799 7.73984C10.6359 7.97909 11.1071 8.37998 11.4323 8.89045C11.7575 9.40093 11.9218 9.9974 11.9036 10.6024C11.899 10.7682 11.9604 10.929 12.0743 11.0495C12.1882 11.17 12.3453 11.2403 12.5111 11.245C12.6768 11.2496 12.8376 11.1883 12.9582 11.0743C13.0787 10.9604 13.149 10.8033 13.1536 10.6376C13.1686 10.0572 13.0656 9.47982 12.8507 8.94049C12.6358 8.40116 12.3136 7.9111 11.9036 7.50006C11.103 6.69977 10.0173 6.2502 8.88528 6.2502C7.75325 6.2502 6.66756 6.69977 5.86693 7.50006L3.15364 10.2149C2.55695 10.8114 2.15045 11.5713 1.98553 12.3987C1.8206 13.2261 1.90465 14.0838 2.22704 14.8635C2.54944 15.6431 3.09572 16.3097 3.79684 16.779C4.49796 17.2483 5.32246 17.4992 6.16614 17.5001C6.72698 17.5017 7.28257 17.392 7.80074 17.1775C8.31891 16.9629 8.78937 16.6477 9.18489 16.2501L10.0443 15.3907C10.1454 15.2715 10.1983 15.1188 10.1924 14.9627C10.1865 14.8065 10.1223 14.6582 10.0125 14.547C9.90267 14.4358 9.75518 14.3698 9.59909 14.362C9.44301 14.3541 9.28965 14.4051 9.16927 14.5047Z",
      fill: "currentColor"
    }, null, -1)
  ])]);
}
const dV = { render: B6 }, uV = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: dV,
  render: B6
}, Symbol.toStringTag, { value: "Module" })), hV = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function $6(e, t) {
  return f(), v("svg", hV, [...t[0] || (t[0] = [
    g("path", { d: "M80,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H88A8,8,0,0,1,80,64Zm136,56H88a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Zm0,64H88a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16ZM44,52A12,12,0,1,0,56,64,12,12,0,0,0,44,52Zm0,64a12,12,0,1,0,12,12A12,12,0,0,0,44,116Zm0,64a12,12,0,1,0,12,12A12,12,0,0,0,44,180Z" }, null, -1)
  ])]);
}
const gV = { render: $6 }, pV = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: gV,
  render: $6
}, Symbol.toStringTag, { value: "Module" })), fV = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function Z6(e, t) {
  return f(), v("svg", fV, [...t[0] || (t[0] = [
    g("path", { d: "M224,128a8,8,0,0,1-8,8H128a8,8,0,0,1,0-16h88A8,8,0,0,1,224,128ZM128,72h88a8,8,0,0,0,0-16H128a8,8,0,0,0,0,16Zm88,112H128a8,8,0,0,0,0,16h88a8,8,0,0,0,0-16ZM82.34,42.34,56,68.69,45.66,58.34A8,8,0,0,0,34.34,69.66l16,16a8,8,0,0,0,11.32,0l32-32A8,8,0,0,0,82.34,42.34Zm0,64L56,132.69,45.66,122.34a8,8,0,0,0-11.32,11.32l16,16a8,8,0,0,0,11.32,0l32-32a8,8,0,0,0-11.32-11.32Zm0,64L56,196.69,45.66,186.34a8,8,0,0,0-11.32,11.32l16,16a8,8,0,0,0,11.32,0l32-32a8,8,0,0,0-11.32-11.32Z" }, null, -1)
  ])]);
}
const vV = { render: Z6 }, mV = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: vV,
  render: Z6
}, Symbol.toStringTag, { value: "Module" })), CV = {
  viewBox: "0 0 21 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function G6(e, t) {
  return f(), v("svg", CV, [...t[0] || (t[0] = [
    g("path", {
      d: "M7.74951 5.32227C7.74951 5.15651 7.81536 4.99753 7.93257 4.88032C8.04978 4.76311 8.20875 4.69727 8.37451 4.69727H17.7495C17.9153 4.69727 18.0742 4.76311 18.1915 4.88032C18.3087 4.99753 18.3745 5.15651 18.3745 5.32227C18.3745 5.48803 18.3087 5.647 18.1915 5.76421C18.0742 5.88142 17.9153 5.94727 17.7495 5.94727H8.37451C8.20875 5.94727 8.04978 5.88142 7.93257 5.76421C7.81536 5.647 7.74951 5.48803 7.74951 5.32227ZM17.7495 9.69727H8.37451C8.20875 9.69727 8.04978 9.76311 7.93257 9.88032C7.81536 9.99753 7.74951 10.1565 7.74951 10.3223C7.74951 10.488 7.81536 10.647 7.93257 10.7642C8.04978 10.8814 8.20875 10.9473 8.37451 10.9473H17.7495C17.9153 10.9473 18.0742 10.8814 18.1915 10.7642C18.3087 10.647 18.3745 10.488 18.3745 10.3223C18.3745 10.1565 18.3087 9.99753 18.1915 9.88032C18.0742 9.76311 17.9153 9.69727 17.7495 9.69727ZM17.7495 14.6973H8.37451C8.20875 14.6973 8.04978 14.7631 7.93257 14.8803C7.81536 14.9975 7.74951 15.1565 7.74951 15.3223C7.74951 15.488 7.81536 15.647 7.93257 15.7642C8.04978 15.8814 8.20875 15.9473 8.37451 15.9473H17.7495C17.9153 15.9473 18.0742 15.8814 18.1915 15.7642C18.3087 15.647 18.3745 15.488 18.3745 15.3223C18.3745 15.1565 18.3087 14.9975 18.1915 14.8803C18.0742 14.7631 17.9153 14.6973 17.7495 14.6973ZM5.24951 4.69727H3.99951C3.83375 4.69727 3.67478 4.76311 3.55757 4.88032C3.44036 4.99753 3.37451 5.15651 3.37451 5.32227C3.37451 5.48803 3.44036 5.647 3.55757 5.76421C3.67478 5.88142 3.83375 5.94727 3.99951 5.94727H5.24951C5.41527 5.94727 5.57424 5.88142 5.69145 5.76421C5.80866 5.647 5.87451 5.48803 5.87451 5.32227C5.87451 5.15651 5.80866 4.99753 5.69145 4.88032C5.57424 4.76311 5.41527 4.69727 5.24951 4.69727ZM5.24951 9.69727H3.99951C3.83375 9.69727 3.67478 9.76311 3.55757 9.88032C3.44036 9.99753 3.37451 10.1565 3.37451 10.3223C3.37451 10.488 3.44036 10.647 3.55757 10.7642C3.67478 10.8814 3.83375 10.9473 3.99951 10.9473H5.24951C5.41527 10.9473 5.57424 10.8814 5.69145 10.7642C5.80866 10.647 5.87451 10.488 5.87451 10.3223C5.87451 10.1565 5.80866 9.99753 5.69145 9.88032C5.57424 9.76311 5.41527 9.69727 5.24951 9.69727ZM5.24951 14.6973H3.99951C3.83375 14.6973 3.67478 14.7631 3.55757 14.8803C3.44036 14.9975 3.37451 15.1565 3.37451 15.3223C3.37451 15.488 3.44036 15.647 3.55757 15.7642C3.67478 15.8814 3.83375 15.9473 3.99951 15.9473H5.24951C5.41527 15.9473 5.57424 15.8814 5.69145 15.7642C5.80866 15.647 5.87451 15.488 5.87451 15.3223C5.87451 15.1565 5.80866 14.9975 5.69145 14.8803C5.57424 14.7631 5.41527 14.6973 5.24951 14.6973Z",
      fill: "currentColor"
    }, null, -1)
  ])]);
}
const wV = { render: G6 }, bV = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: wV,
  render: G6
}, Symbol.toStringTag, { value: "Module" })), yV = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function N6(e, t) {
  return f(), v("svg", yV, [...t[0] || (t[0] = [
    g("path", { d: "M224,128a8,8,0,0,1-8,8H104a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM104,72H216a8,8,0,0,0,0-16H104a8,8,0,0,0,0,16ZM216,184H104a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16ZM43.58,55.16,48,52.94V104a8,8,0,0,0,16,0V40a8,8,0,0,0-11.58-7.16l-16,8a8,8,0,0,0,7.16,14.32ZM79.77,156.72a23.73,23.73,0,0,0-9.6-15.95,24.86,24.86,0,0,0-34.11,4.7,23.63,23.63,0,0,0-3.57,6.46,8,8,0,1,0,15,5.47,7.84,7.84,0,0,1,1.18-2.13,8.76,8.76,0,0,1,12-1.59A7.91,7.91,0,0,1,63.93,159a7.64,7.64,0,0,1-1.57,5.78,1,1,0,0,0-.08.11L33.59,203.21A8,8,0,0,0,40,216H72a8,8,0,0,0,0-16H56l19.08-25.53A23.47,23.47,0,0,0,79.77,156.72Z" }, null, -1)
  ])]);
}
const _V = { render: N6 }, SV = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _V,
  render: N6
}, Symbol.toStringTag, { value: "Module" })), xV = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function z6(e, t) {
  return f(), v("svg", xV, [...t[0] || (t[0] = [
    g("path", { d: "M32,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H40A8,8,0,0,1,32,64Zm8,72H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16Zm104,48H40a8,8,0,0,0,0,16H144a8,8,0,0,0,0-16Zm88,0H216V168a8,8,0,0,0-16,0v16H184a8,8,0,0,0,0,16h16v16a8,8,0,0,0,16,0V200h16a8,8,0,0,0,0-16Z" }, null, -1)
  ])]);
}
const MV = { render: z6 }, AV = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: MV,
  render: z6
}, Symbol.toStringTag, { value: "Module" })), LV = {
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function j6(e, t) {
  return f(), v("svg", LV, [...t[0] || (t[0] = [
    g("path", {
      d: "M14 8C14 8.13261 13.9473 8.25979 13.8536 8.35355C13.7598 8.44732 13.6326 8.5 13.5 8.5H2.5C2.36739 8.5 2.24021 8.44732 2.14645 8.35355C2.05268 8.25979 2 8.13261 2 8C2 7.86739 2.05268 7.74021 2.14645 7.64645C2.24021 7.55268 2.36739 7.5 2.5 7.5H13.5C13.6326 7.5 13.7598 7.55268 13.8536 7.64645C13.9473 7.74021 14 7.86739 14 8ZM2.5 4.5H13.5C13.6326 4.5 13.7598 4.44732 13.8536 4.35355C13.9473 4.25979 14 4.13261 14 4C14 3.86739 13.9473 3.74021 13.8536 3.64645C13.7598 3.55268 13.6326 3.5 13.5 3.5H2.5C2.36739 3.5 2.24021 3.55268 2.14645 3.64645C2.05268 3.74021 2 3.86739 2 4C2 4.13261 2.05268 4.25979 2.14645 4.35355C2.24021 4.44732 2.36739 4.5 2.5 4.5ZM13.5 11.5H2.5C2.36739 11.5 2.24021 11.5527 2.14645 11.6464C2.05268 11.7402 2 11.8674 2 12C2 12.1326 2.05268 12.2598 2.14645 12.3536C2.24021 12.4473 2.36739 12.5 2.5 12.5H13.5C13.6326 12.5 13.7598 12.4473 13.8536 12.3536C13.9473 12.2598 14 12.1326 14 12C14 11.8674 13.9473 11.7402 13.8536 11.6464C13.7598 11.5527 13.6326 11.5 13.5 11.5Z",
      fill: "currentColor"
    }, null, -1)
  ])]);
}
const EV = { render: j6 }, PV = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: EV,
  render: j6
}, Symbol.toStringTag, { value: "Module" })), RV = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function W6(e, t) {
  return f(), v("svg", RV, [...t[0] || (t[0] = [
    g("path", { d: "M208,80H176V56a48,48,0,0,0-96,0V80H48A16,16,0,0,0,32,96V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V96A16,16,0,0,0,208,80ZM96,56a32,32,0,0,1,64,0V80H96ZM208,208H48V96H208V208Z" }, null, -1)
  ])]);
}
const FV = { render: W6 }, TV = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: FV,
  render: W6
}, Symbol.toStringTag, { value: "Module" })), IV = {
  viewBox: "0 0 21 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function U6(e, t) {
  return f(), v("svg", IV, [...t[0] || (t[0] = [
    g("path", {
      d: "M12.6251 8.99749C12.6251 9.16325 12.5592 9.32222 12.442 9.43944C12.3248 9.55665 12.1658 9.62249 12.0001 9.62249H7.00006C6.8343 9.62249 6.67532 9.55665 6.55812 9.43944C6.4409 9.32222 6.37506 9.16325 6.37506 8.99749C6.37506 8.83173 6.4409 8.67276 6.55812 8.55555C6.67532 8.43834 6.8343 8.37249 7.00006 8.37249H12.0001C12.1658 8.37249 12.3248 8.43834 12.442 8.55555C12.5592 8.67276 12.6251 8.83173 12.6251 8.99749ZM18.6922 18.1897C18.6342 18.2478 18.5653 18.2939 18.4894 18.3253C18.4135 18.3568 18.3322 18.373 18.2501 18.373C18.1679 18.373 18.0866 18.3568 18.0107 18.3253C17.9348 18.2939 17.8659 18.2478 17.8079 18.1897L13.8969 14.278C12.5358 15.4117 10.7899 15.9771 9.02251 15.8564C7.25512 15.7358 5.60229 14.9384 4.40785 13.6301C3.21341 12.3219 2.56932 10.6035 2.60957 8.83242C2.64982 7.06138 3.37131 5.37403 4.62395 4.12138C5.87659 2.86874 7.56394 2.14725 9.33498 2.107C11.106 2.06675 12.8244 2.71084 14.1327 3.90528C15.4409 5.09972 16.2383 6.75255 16.359 8.51994C16.4797 10.2873 15.9143 12.0332 14.7805 13.3944L18.6922 17.3053C18.7504 17.3634 18.7965 17.4323 18.8279 17.5082C18.8594 17.584 18.8755 17.6654 18.8755 17.7475C18.8755 17.8296 18.8594 17.911 18.8279 17.9868C18.7965 18.0627 18.7504 18.1316 18.6922 18.1897ZM9.50006 14.6225C10.6126 14.6225 11.7001 14.2926 12.6251 13.6745C13.5502 13.0564 14.2711 12.1779 14.6969 11.1501C15.1226 10.1223 15.234 8.99125 15.017 7.90011C14.7999 6.80897 14.2642 5.80669 13.4775 5.02002C12.6909 4.23335 11.6886 3.69762 10.5974 3.48058C9.5063 3.26353 8.3753 3.37493 7.34746 3.80067C6.31963 4.22641 5.44112 4.94738 4.82304 5.87241C4.20496 6.79744 3.87506 7.88497 3.87506 8.99749C3.87671 10.4888 4.46987 11.9186 5.52441 12.9731C6.57894 14.0277 8.00872 14.6208 9.50006 14.6225Z",
      fill: "currentColor"
    }, null, -1)
  ])]);
}
const DV = { render: U6 }, kV = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: DV,
  render: U6
}, Symbol.toStringTag, { value: "Module" })), HV = {
  viewBox: "0 0 21 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function K6(e, t) {
  return f(), v("svg", HV, [...t[0] || (t[0] = [
    g("path", {
      d: "M12.6251 8.99749C12.6251 9.16325 12.5592 9.32222 12.442 9.43944C12.3248 9.55665 12.1658 9.62249 12.0001 9.62249H10.1251V11.4975C10.1251 11.6633 10.0592 11.8222 9.942 11.9394C9.82479 12.0566 9.66582 12.1225 9.50006 12.1225C9.3343 12.1225 9.17533 12.0566 9.05812 11.9394C8.94091 11.8222 8.87506 11.6633 8.87506 11.4975V9.62249H7.00006C6.8343 9.62249 6.67532 9.55665 6.55812 9.43944C6.4409 9.32222 6.37506 9.16325 6.37506 8.99749C6.37506 8.83173 6.4409 8.67276 6.55812 8.55555C6.67532 8.43834 6.8343 8.37249 7.00006 8.37249H8.87506V6.49749C8.87506 6.33173 8.94091 6.17276 9.05812 6.05555C9.17533 5.93834 9.3343 5.87249 9.50006 5.87249C9.66582 5.87249 9.82479 5.93834 9.942 6.05555C10.0592 6.17276 10.1251 6.33173 10.1251 6.49749V8.37249H12.0001C12.1658 8.37249 12.3248 8.43834 12.442 8.55555C12.5592 8.67276 12.6251 8.83173 12.6251 8.99749ZM18.6922 18.1897C18.6342 18.2478 18.5653 18.2939 18.4894 18.3253C18.4135 18.3568 18.3322 18.373 18.2501 18.373C18.1679 18.373 18.0866 18.3568 18.0107 18.3253C17.9348 18.2939 17.8659 18.2478 17.8079 18.1897L13.8969 14.278C12.5358 15.4117 10.7899 15.9771 9.02251 15.8564C7.25512 15.7358 5.60229 14.9384 4.40785 13.6301C3.21341 12.3219 2.56932 10.6035 2.60957 8.83242C2.64982 7.06138 3.37131 5.37403 4.62395 4.12138C5.87659 2.86874 7.56394 2.14725 9.33498 2.107C11.106 2.06675 12.8244 2.71084 14.1327 3.90528C15.4409 5.09972 16.2383 6.75255 16.359 8.51994C16.4797 10.2873 15.9143 12.0332 14.7805 13.3944L18.6922 17.3053C18.7504 17.3634 18.7965 17.4323 18.8279 17.5082C18.8594 17.584 18.8755 17.6654 18.8755 17.7475C18.8755 17.8296 18.8594 17.911 18.8279 17.9868C18.7965 18.0627 18.7504 18.1316 18.6922 18.1897ZM9.50006 14.6225C10.6126 14.6225 11.7001 14.2926 12.6251 13.6745C13.5502 13.0564 14.2711 12.1779 14.6969 11.1501C15.1226 10.1223 15.234 8.99125 15.017 7.90011C14.7999 6.80897 14.2642 5.80669 13.4775 5.02002C12.6909 4.23335 11.6886 3.69762 10.5974 3.48058C9.5063 3.26353 8.3753 3.37493 7.34746 3.80067C6.31963 4.22641 5.44112 4.94738 4.82304 5.87241C4.20496 6.79744 3.87506 7.88497 3.87506 8.99749C3.87671 10.4888 4.46987 11.9186 5.52441 12.9731C6.57894 14.0277 8.00872 14.6208 9.50006 14.6225Z",
      fill: "currentColor"
    }, null, -1)
  ])]);
}
const VV = { render: K6 }, OV = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: VV,
  render: K6
}, Symbol.toStringTag, { value: "Module" })), BV = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function q6(e, t) {
  return f(), v("svg", BV, [...t[0] || (t[0] = [
    g("path", { d: "M229.66,218.34l-50.07-50.06a88.11,88.11,0,1,0-11.31,11.31l50.06,50.07a8,8,0,0,0,11.32-11.32ZM40,112a72,72,0,1,1,72,72A72.08,72.08,0,0,1,40,112Z" }, null, -1)
  ])]);
}
const $V = { render: q6 }, ZV = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: $V,
  render: q6
}, Symbol.toStringTag, { value: "Module" })), GV = {
  viewBox: "0 0 21 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Y6(e, t) {
  return f(), v("svg", GV, [...t[0] || (t[0] = [
    g("path", {
      d: "M18.3589 3.75H3.35889C3.19313 3.75 3.03416 3.81585 2.91694 3.93306C2.79973 4.05027 2.73389 4.20924 2.73389 4.375V15C2.73389 15.3315 2.86558 15.6495 3.1 15.8839C3.33442 16.1183 3.65237 16.25 3.98389 16.25H17.7339C18.0654 16.25 18.3833 16.1183 18.6178 15.8839C18.8522 15.6495 18.9839 15.3315 18.9839 15V4.375C18.9839 4.20924 18.918 4.05027 18.8008 3.93306C18.6836 3.81585 18.5246 3.75 18.3589 3.75ZM10.8589 10.4023L4.96592 5H16.7519L10.8589 10.4023ZM8.57061 10L3.98389 14.2039V5.79609L8.57061 10ZM9.49561 10.8477L10.4331 11.7109C10.5484 11.8168 10.6992 11.8755 10.8558 11.8755C11.0123 11.8755 11.1631 11.8168 11.2784 11.7109L12.2159 10.8477L16.7472 15H4.96592L9.49561 10.8477ZM13.1472 10L17.7339 5.79531V14.2047L13.1472 10Z",
      fill: "currentColor"
    }, null, -1)
  ])]);
}
const NV = { render: Y6 }, zV = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: NV,
  render: Y6
}, Symbol.toStringTag, { value: "Module" })), jV = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function Q6(e, t) {
  return f(), v("svg", jV, [...t[0] || (t[0] = [
    g("path", { d: "M120,103.2V176a8,8,0,0,0,16,0V103.2a40,40,0,1,0-16,0ZM128,40a24,24,0,1,1-24,24A24,24,0,0,1,128,40ZM240,176c0,31.18-57.71,48-112,48S16,207.18,16,176c0-7.74,3.81-19.13,22-29.41,12.26-6.94,29.12-12.27,48.77-15.42A8,8,0,1,1,89.27,147c-17.54,2.82-33,7.63-43.42,13.55C37.05,165.5,32,171.14,32,176c0,13.36,36.52,32,96,32s96-18.64,96-32c0-4.86-5.05-10.5-13.85-15.49-10.46-5.92-25.88-10.73-43.42-13.55a8,8,0,1,1,2.54-15.79c19.65,3.15,36.51,8.48,48.77,15.42C236.19,156.87,240,168.26,240,176Z" }, null, -1)
  ])]);
}
const WV = { render: Q6 }, UV = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: WV,
  render: Q6
}, Symbol.toStringTag, { value: "Module" })), KV = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function J6(e, t) {
  return f(), v("svg", KV, [...t[0] || (t[0] = [
    g("path", {
      d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z",
      opacity: "0.2"
    }, null, -1),
    g("path", { d: "M176,128a8,8,0,0,1-8,8H88a8,8,0,0,1,0-16h80A8,8,0,0,1,176,128Zm56,0A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z" }, null, -1)
  ])]);
}
const qV = { render: J6 }, YV = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: qV,
  render: J6
}, Symbol.toStringTag, { value: "Module" })), QV = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function X6(e, t) {
  return f(), v("svg", QV, [...t[0] || (t[0] = [
    g("path", { d: "M176,128a8,8,0,0,1-8,8H88a8,8,0,0,1,0-16h80A8,8,0,0,1,176,128Zm56,0A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z" }, null, -1)
  ])]);
}
const JV = { render: X6 }, XV = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: JV,
  render: X6
}, Symbol.toStringTag, { value: "Module" })), eO = {
  viewBox: "0 0 15 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function e4(e, t) {
  return f(), v("svg", eO, [...t[0] || (t[0] = [
    g("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M10.9023 7.32227C10.9023 6.76998 11.3501 6.32227 11.9023 6.32227C12.4546 6.32227 12.9023 6.76998 12.9023 7.32227C12.9023 7.87455 12.4546 8.32227 11.9023 8.32227C11.3501 8.32227 10.9023 7.87455 10.9023 7.32227ZM6.40234 7.32227C6.40234 6.76998 6.85006 6.32227 7.40234 6.32227C7.95463 6.32227 8.40234 6.76998 8.40234 7.32227C8.40234 7.87455 7.95463 8.32227 7.40234 8.32227C6.85006 8.32227 6.40234 7.87455 6.40234 7.32227ZM2.90234 6.32227C2.35006 6.32227 1.90234 6.76998 1.90234 7.32227C1.90234 7.87455 2.35006 8.32227 2.90234 8.32227C3.45463 8.32227 3.90234 7.87455 3.90234 7.32227C3.90234 6.76998 3.45463 6.32227 2.90234 6.32227Z",
      fill: "currentColor"
    }, null, -1)
  ])]);
}
const tO = { render: e4 }, oO = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: tO,
  render: e4
}, Symbol.toStringTag, { value: "Module" })), nO = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function t4(e, t) {
  return f(), v("svg", nO, [...t[0] || (t[0] = [
    g("path", { d: "M232,112H136V88h8a16,16,0,0,0,16-16V40a16,16,0,0,0-16-16H112A16,16,0,0,0,96,40V72a16,16,0,0,0,16,16h8v24H24a8,8,0,0,0,0,16H56v32H48a16,16,0,0,0-16,16v32a16,16,0,0,0,16,16H80a16,16,0,0,0,16-16V176a16,16,0,0,0-16-16H72V128H184v32h-8a16,16,0,0,0-16,16v32a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V176a16,16,0,0,0-16-16h-8V128h32a8,8,0,0,0,0-16ZM112,40h32V72H112ZM80,208H48V176H80Zm128,0H176V176h32Z" }, null, -1)
  ])]);
}
const sO = { render: t4 }, iO = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sO,
  render: t4
}, Symbol.toStringTag, { value: "Module" })), rO = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256"
};
function o4(e, t) {
  return f(), v("svg", rO, [...t[0] || (t[0] = [
    g("rect", {
      width: "256",
      height: "256",
      fill: "none"
    }, null, -1),
    g("line", {
      x1: "40",
      y1: "160",
      x2: "216",
      y2: "160",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1),
    g("line", {
      x1: "40",
      y1: "96",
      x2: "216",
      y2: "96",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1),
    g("line", {
      x1: "208",
      y1: "40",
      x2: "48",
      y2: "216",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1)
  ])]);
}
const lO = { render: o4 }, aO = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: lO,
  render: o4
}, Symbol.toStringTag, { value: "Module" })), cO = {
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function n4(e, t) {
  return f(), v("svg", cO, [...t[0] || (t[0] = [
    g("path", {
      d: "M14.3538 3.64664L12.3538 1.64664C12.3073 1.60016 12.2522 1.56328 12.1915 1.53811C12.1308 1.51295 12.0657 1.5 12 1.5C11.9343 1.5 11.8692 1.51295 11.8085 1.53811C11.7478 1.56328 11.6927 1.60016 11.6462 1.64664L5.64625 7.64664C5.59983 7.69311 5.56303 7.74827 5.53793 7.80897C5.51284 7.86967 5.49995 7.93471 5.5 8.00039V10.0004C5.5 10.133 5.55268 10.2602 5.64645 10.3539C5.74021 10.4477 5.86739 10.5004 6 10.5004H8C8.06568 10.5004 8.13073 10.4876 8.19143 10.4625C8.25212 10.4374 8.30728 10.4006 8.35375 10.3541L14.3538 4.35414C14.4002 4.30771 14.4371 4.25256 14.4623 4.19186C14.4874 4.13116 14.5004 4.0661 14.5004 4.00039C14.5004 3.93469 14.4874 3.86962 14.4623 3.80892C14.4371 3.74822 14.4002 3.69308 14.3538 3.64664ZM7.79313 9.50039H6.5V8.20727L10.5 4.20727L11.7931 5.50039L7.79313 9.50039ZM12.5 4.79352L11.2069 3.50039L12 2.70727L13.2931 4.00039L12.5 4.79352ZM14 8.00039V13.0004C14 13.2656 13.8946 13.52 13.7071 13.7075C13.5196 13.895 13.2652 14.0004 13 14.0004H3C2.73478 14.0004 2.48043 13.895 2.29289 13.7075C2.10536 13.52 2 13.2656 2 13.0004V3.00039C2 2.73518 2.10536 2.48082 2.29289 2.29329C2.48043 2.10575 2.73478 2.00039 3 2.00039H8C8.13261 2.00039 8.25979 2.05307 8.35355 2.14684C8.44732 2.24061 8.5 2.36779 8.5 2.50039C8.5 2.633 8.44732 2.76018 8.35355 2.85395C8.25979 2.94771 8.13261 3.00039 8 3.00039H3V13.0004H13V8.00039C13 7.86779 13.0527 7.74061 13.1464 7.64684C13.2402 7.55307 13.3674 7.50039 13.5 7.50039C13.6326 7.50039 13.7598 7.55307 13.8536 7.64684C13.9473 7.74061 14 7.86779 14 8.00039Z",
      fill: "currentColor"
    }, null, -1)
  ])]);
}
const dO = { render: n4 }, uO = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: dO,
  render: n4
}, Symbol.toStringTag, { value: "Module" })), hO = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function s4(e, t) {
  return f(), v("svg", hO, [...t[0] || (t[0] = [
    g("path", { d: "M184,112a8,8,0,0,1-8,8H112a8,8,0,0,1,0-16h64A8,8,0,0,1,184,112Zm-8,24H112a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16Zm48-88V208a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V48A16,16,0,0,1,48,32H208A16,16,0,0,1,224,48ZM48,208H72V48H48Zm160,0V48H88V208H208Z" }, null, -1)
  ])]);
}
const gO = { render: s4 }, pO = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: gO,
  render: s4
}, Symbol.toStringTag, { value: "Module" })), fO = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function i4(e, t) {
  return f(), v("svg", fO, [...t[0] || (t[0] = [
    g("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm0,176H48V48H208V208Zm-48-64h-8V80a8,8,0,0,0-14.31-4.91l-56,72A8,8,0,0,0,88,160h48v16a8,8,0,0,0,16,0V160h8a8,8,0,0,0,0-16Zm-24,0H104.36L136,103.32Z" }, null, -1)
  ])]);
}
const vO = { render: i4 }, mO = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: vO,
  render: i4
}, Symbol.toStringTag, { value: "Module" })), CO = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function r4(e, t) {
  return f(), v("svg", CO, [...t[0] || (t[0] = [
    g("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm0,176H48V48H208V208ZM140,80v96a8,8,0,0,1-16,0V95l-11.56,7.71a8,8,0,1,1-8.88-13.32l24-16A8,8,0,0,1,140,80Z" }, null, -1)
  ])]);
}
const wO = { render: r4 }, bO = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: wO,
  render: r4
}, Symbol.toStringTag, { value: "Module" })), yO = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function l4(e, t) {
  return f(), v("svg", yO, [...t[0] || (t[0] = [
    g("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm0,176H48V48H208V208Zm-48-60a36,36,0,0,1-61.71,25.19A8,8,0,1,1,109.71,162,20,20,0,1,0,124,128a8,8,0,0,1-6.55-12.59L136.63,88H104a8,8,0,0,1,0-16h48a8,8,0,0,1,6.55,12.59l-21,30A36.07,36.07,0,0,1,160,148Z" }, null, -1)
  ])]);
}
const _O = { render: l4 }, SO = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _O,
  render: l4
}, Symbol.toStringTag, { value: "Module" })), xO = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function a4(e, t) {
  return f(), v("svg", xO, [...t[0] || (t[0] = [
    g("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm0,176H48V48H208V208Zm-48-32a8,8,0,0,1-8,8H104a8,8,0,0,1-6.4-12.8l43.17-57.56a16,16,0,1,0-27.86-15,8,8,0,0,1-15.09-5.34,32.43,32.43,0,0,1,4.62-8.59,32,32,0,1,1,51.11,38.52L120,168h32A8,8,0,0,1,160,176Z" }, null, -1)
  ])]);
}
const MO = { render: a4 }, AO = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: MO,
  render: a4
}, Symbol.toStringTag, { value: "Module" })), LO = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function c4(e, t) {
  return f(), v("svg", LO, [...t[0] || (t[0] = [
    g("path", {
      d: "M18.3223 10.8649C18.4233 10.8312 18.514 10.7723 18.5858 10.6937C18.6576 10.6151 18.7082 10.5195 18.7327 10.4159C18.7572 10.3123 18.7548 10.2041 18.7258 10.1017C18.6967 9.99925 18.642 9.90593 18.5668 9.83057L9.54416 0.807913C9.42696 0.690792 9.26806 0.625 9.10237 0.625C8.93668 0.625 8.77777 0.690792 8.66057 0.807913L5.48791 3.98448L3.56604 2.05791C3.44876 1.94074 3.28974 1.87496 3.12396 1.87503C2.95819 1.8751 2.79923 1.94103 2.68205 2.0583C2.56488 2.17558 2.4991 2.3346 2.49917 2.50038C2.49924 2.66616 2.56517 2.82512 2.68244 2.94229L4.60432 4.86416L1.17151 8.29463C0.819903 8.64626 0.622375 9.12315 0.622375 9.62041C0.622375 10.1177 0.819903 10.5946 1.17151 10.9462L7.80354 17.5782C8.15517 17.9298 8.63206 18.1274 9.12932 18.1274C9.62658 18.1274 10.1035 17.9298 10.4551 17.5782L16.5871 11.4462L18.3223 10.8649ZM15.8074 10.4556L9.57073 16.6923C9.45353 16.8094 9.29462 16.8752 9.12893 16.8752C8.96324 16.8752 8.80433 16.8094 8.68713 16.6923L2.05744 10.0626C1.94032 9.9454 1.87453 9.78649 1.87453 9.6208C1.87453 9.45511 1.94032 9.29621 2.05744 9.17901L5.48791 5.74776L7.76291 8.02276C7.51324 8.48508 7.43831 9.02183 7.55184 9.53486C7.66537 10.0479 7.95976 10.5029 8.38119 10.8167C8.80262 11.1305 9.32293 11.2822 9.84697 11.2439C10.371 11.2056 10.8638 10.98 11.2351 10.6083C11.6065 10.2366 11.8317 9.74367 11.8695 9.21959C11.9073 8.69552 11.7552 8.17534 11.441 7.75419C11.1268 7.33304 10.6715 7.03904 10.1584 6.92597C9.64529 6.8129 9.10861 6.8883 8.64651 7.13838L6.37229 4.86416L9.10666 2.13369L16.9676 10.0001L16.052 10.3048C15.96 10.3356 15.8763 10.3872 15.8074 10.4556ZM9.02385 8.4001C9.20019 8.18975 9.4528 8.05799 9.72621 8.03374C9.99962 8.0095 10.2715 8.09475 10.4821 8.27078C10.6927 8.44681 10.8248 8.69923 10.8495 8.9726C10.8741 9.24598 10.7893 9.51796 10.6136 9.72882C10.4378 9.93969 10.1856 10.0722 9.91227 10.0972C9.63894 10.1223 9.36683 10.0378 9.15571 9.86244C8.94458 9.68703 8.8117 9.435 8.78625 9.1617C8.7608 8.8884 8.84485 8.61617 9.01995 8.40479C9.01995 8.40479 9.02385 8.40088 9.02385 8.4001ZM18.6449 12.7751C18.5879 12.6894 18.5105 12.6191 18.4198 12.5704C18.329 12.5218 18.2276 12.4964 18.1246 12.4964C18.0217 12.4964 17.9203 12.5218 17.8295 12.5704C17.7387 12.6191 17.6614 12.6894 17.6043 12.7751C17.466 12.9868 16.2496 14.8509 16.2496 16.2501C16.2496 16.7474 16.4472 17.2243 16.7988 17.5759C17.1504 17.9276 17.6274 18.1251 18.1246 18.1251C18.6219 18.1251 19.0988 17.9276 19.4505 17.5759C19.8021 17.2243 19.9996 16.7474 19.9996 16.2501C19.9996 14.8509 18.7832 12.9868 18.6449 12.7782V12.7751ZM18.1246 16.8751C17.9589 16.8751 17.7999 16.8093 17.6827 16.692C17.5655 16.5748 17.4996 16.4159 17.4996 16.2501C17.4996 15.7189 17.8121 14.9751 18.1246 14.3689C18.4371 14.9751 18.7496 15.7235 18.7496 16.2501C18.7496 16.4159 18.6838 16.5748 18.5666 16.692C18.4494 16.8093 18.2904 16.8751 18.1246 16.8751Z",
      fill: "currentColor"
    }, null, -1)
  ])]);
}
const EO = { render: c4 }, PO = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: EO,
  render: c4
}, Symbol.toStringTag, { value: "Module" })), RO = {
  viewBox: "0 0 13 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function d4(e, t) {
  return f(), v("svg", RO, [...t[0] || (t[0] = [
    g("path", {
      d: "M11.0481 1.86813C9.83794 0.669744 8.20314 -0.00174255 6.5 3.39622e-06H6.43312C4.72083 0.0176212 3.08466 0.710211 1.8801 1.92729C0.675541 3.14438 -9.06232e-05 4.78762 9.11719e-09 6.5C9.11719e-09 9.1875 1.66125 11.4413 4.335 12.3856C4.63657 12.492 4.95924 12.5244 5.27594 12.4803C5.59264 12.4362 5.89415 12.3168 6.15518 12.1321C6.41621 11.9474 6.62916 11.7028 6.77615 11.4188C6.92314 11.1348 6.99991 10.8198 7 10.5C7 10.2348 7.10536 9.98043 7.29289 9.7929C7.48043 9.60536 7.73478 9.5 8 9.5H10.8881C11.3418 9.5022 11.7826 9.34917 12.1373 9.06631C12.492 8.78345 12.7393 8.38779 12.8381 7.945C12.9499 7.45294 13.0042 6.94958 13 6.445C12.9936 5.59092 12.8178 4.74659 12.4828 3.96094C12.1477 3.17529 11.6601 2.46395 11.0481 1.86813ZM11.8606 7.725C11.811 7.9456 11.6875 8.14264 11.5107 8.28355C11.3339 8.42447 11.1142 8.50083 10.8881 8.5H8C7.46957 8.5 6.96086 8.71072 6.58579 9.08579C6.21071 9.46086 6 9.96957 6 10.5C5.99977 10.6597 5.96128 10.8171 5.88775 10.9589C5.81423 11.1007 5.7078 11.2228 5.57739 11.315C5.44698 11.4073 5.29637 11.4669 5.13818 11.489C4.97998 11.511 4.8188 11.4949 4.66812 11.4419C2.40562 10.6438 1 8.75 1 6.5C0.999922 5.05111 1.57157 3.66072 2.59075 2.63089C3.60993 1.60106 4.99431 1.01499 6.44312 1H6.49937C7.94824 1.00563 9.33685 1.58049 10.3657 2.60061C11.3946 3.62073 11.9813 5.00436 11.9994 6.45313C12.0031 6.88092 11.9574 7.30771 11.8631 7.725H11.8606ZM7.25 3.25C7.25 3.39834 7.20601 3.54334 7.1236 3.66668C7.04119 3.79002 6.92406 3.88615 6.78701 3.94291C6.64997 3.99968 6.49917 4.01453 6.35368 3.98559C6.2082 3.95665 6.07456 3.88522 5.96967 3.78033C5.86478 3.67544 5.79335 3.54181 5.76441 3.39632C5.73547 3.25084 5.75032 3.10004 5.80709 2.96299C5.86386 2.82595 5.95999 2.70881 6.08332 2.6264C6.20666 2.54399 6.35166 2.5 6.5 2.5C6.69891 2.5 6.88968 2.57902 7.03033 2.71967C7.17098 2.86033 7.25 3.05109 7.25 3.25ZM4.5 4.75C4.5 4.89834 4.45601 5.04334 4.3736 5.16668C4.29119 5.29002 4.17406 5.38615 4.03701 5.44291C3.89997 5.49968 3.74917 5.51453 3.60368 5.48559C3.4582 5.45665 3.32456 5.38522 3.21967 5.28033C3.11478 5.17544 3.04335 5.04181 3.01441 4.89632C2.98547 4.75084 3.00032 4.60004 3.05709 4.46299C3.11386 4.32595 3.20999 4.20881 3.33332 4.1264C3.45666 4.04399 3.60166 4 3.75 4C3.94891 4 4.13968 4.07902 4.28033 4.21967C4.42098 4.36033 4.5 4.55109 4.5 4.75ZM4.5 8.25C4.5 8.39834 4.45601 8.54335 4.3736 8.66668C4.29119 8.79002 4.17406 8.88615 4.03701 8.94291C3.89997 8.99968 3.74917 9.01453 3.60368 8.98559C3.4582 8.95665 3.32456 8.88522 3.21967 8.78033C3.11478 8.67545 3.04335 8.54181 3.01441 8.39632C2.98547 8.25084 3.00032 8.10004 3.05709 7.96299C3.11386 7.82595 3.20999 7.70881 3.33332 7.6264C3.45666 7.54399 3.60166 7.5 3.75 7.5C3.94891 7.5 4.13968 7.57902 4.28033 7.71967C4.42098 7.86033 4.5 8.05109 4.5 8.25ZM10 4.75C10 4.89834 9.95601 5.04334 9.8736 5.16668C9.79119 5.29002 9.67406 5.38615 9.53701 5.44291C9.39997 5.49968 9.24917 5.51453 9.10368 5.48559C8.9582 5.45665 8.82456 5.38522 8.71967 5.28033C8.61478 5.17544 8.54335 5.04181 8.51441 4.89632C8.48547 4.75084 8.50032 4.60004 8.55709 4.46299C8.61386 4.32595 8.70998 4.20881 8.83332 4.1264C8.95666 4.04399 9.10166 4 9.25 4C9.44891 4 9.63968 4.07902 9.78033 4.21967C9.92098 4.36033 10 4.55109 10 4.75Z",
      fill: "currentColor"
    }, null, -1)
  ])]);
}
const FO = { render: d4 }, TO = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: FO,
  render: d4
}, Symbol.toStringTag, { value: "Module" })), IO = {
  viewBox: "0 0 7 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function u4(e, t) {
  return f(), v("svg", IO, [...t[0] || (t[0] = [
    g("path", {
      d: "M3.5 15C2.57205 14.999 1.68238 14.6299 1.02622 13.9738C0.370059 13.3176 0.000992232 12.428 -5.02681e-07 11.5L-1.09278e-07 2.5C-8.0296e-08 1.83696 0.263392 1.20107 0.732233 0.732233C1.20107 0.263392 1.83696 -2.25684e-07 2.5 -1.96701e-07C3.16304 -1.67719e-07 3.79893 0.263392 4.26777 0.732233C4.73661 1.20107 5 1.83696 5 2.5L5 11.5C5 11.8978 4.84196 12.2794 4.56066 12.5607C4.27936 12.842 3.89782 13 3.5 13C3.10217 13 2.72064 12.842 2.43934 12.5607C2.15803 12.2794 2 11.8978 2 11.5L2 4.5C2 4.36739 2.05268 4.24021 2.14645 4.14645C2.24021 4.05268 2.36739 4 2.5 4C2.63261 4 2.75979 4.05268 2.85355 4.14645C2.94732 4.24021 3 4.36739 3 4.5L3 11.5C3 11.6326 3.05268 11.7598 3.14645 11.8536C3.24021 11.9473 3.36739 12 3.5 12C3.63261 12 3.75978 11.9473 3.85355 11.8536C3.94732 11.7598 4 11.6326 4 11.5L4 2.5C4 2.10218 3.84196 1.72064 3.56066 1.43934C3.27936 1.15804 2.89782 1 2.5 1C2.10218 1 1.72064 1.15804 1.43934 1.43934C1.15804 1.72064 1 2.10217 1 2.5L0.999999 11.5C0.999999 12.163 1.26339 12.7989 1.73223 13.2678C2.20107 13.7366 2.83696 14 3.5 14C4.16304 14 4.79893 13.7366 5.26777 13.2678C5.73661 12.7989 6 12.163 6 11.5L6 4.5C6 4.36739 6.05268 4.24021 6.14645 4.14645C6.24021 4.05268 6.36739 4 6.5 4C6.63261 4 6.75978 4.05268 6.85355 4.14645C6.94732 4.24021 7 4.36739 7 4.5L7 11.5C6.99901 12.428 6.62994 13.3176 5.97378 13.9738C5.31761 14.6299 4.42795 14.999 3.5 15Z",
      fill: "currentColor"
    }, null, -1)
  ])]);
}
const DO = { render: u4 }, kO = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: DO,
  render: u4
}, Symbol.toStringTag, { value: "Module" })), HO = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256"
};
function h4(e, t) {
  return f(), v("svg", HO, [...t[0] || (t[0] = [
    g("rect", {
      width: "256",
      height: "256",
      fill: "none"
    }, null, -1),
    g("line", {
      x1: "144",
      y1: "128",
      x2: "80",
      y2: "128",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1),
    g("path", {
      d: "M48.49,221.28A8,8,0,0,0,59.93,231l168-96.09a8,8,0,0,0,0-14l-168-95.85a8,8,0,0,0-11.44,9.67L80,128Z",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1)
  ])]);
}
const VO = { render: h4 }, OO = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: VO,
  render: h4
}, Symbol.toStringTag, { value: "Module" })), BO = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 256 256"
};
function g4(e, t) {
  return f(), v("svg", BO, [...t[0] || (t[0] = [
    g("path", {
      fill: "currentColor",
      d: "M209.66,122.34a8,8,0,0,1,0,11.32l-82.05,82a56,56,0,0,1-79.2-79.21L147.67,35.73a40,40,0,1,1,56.61,56.55L105,193A24,24,0,1,1,71,159L154.3,74.38A8,8,0,1,1,165.7,85.6L82.39,170.31a8,8,0,1,0,11.27,11.36L192.93,81A24,24,0,1,0,159,47L59.76,147.68a40,40,0,1,0,56.53,56.62l82.06-82A8,8,0,0,1,209.66,122.34Z"
    }, null, -1)
  ])]);
}
const $O = { render: g4 }, ZO = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: $O,
  render: g4
}, Symbol.toStringTag, { value: "Module" })), GO = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function p4(e, t) {
  return f(), v("svg", GO, [...t[0] || (t[0] = [
    g("path", { d: "M227.32,73.37,182.63,28.69a16,16,0,0,0-22.63,0L36.69,152A15.86,15.86,0,0,0,32,163.31V208a16,16,0,0,0,16,16H216a8,8,0,0,0,0-16H115.32l112-112A16,16,0,0,0,227.32,73.37ZM136,75.31,152.69,92,68,176.69,51.31,160ZM48,208V179.31L76.69,208Zm48-3.31L79.32,188,164,103.31,180.69,120Zm96-96L147.32,64l24-24L216,84.69Z" }, null, -1)
  ])]);
}
const NO = { render: p4 }, zO = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: NO,
  render: p4
}, Symbol.toStringTag, { value: "Module" })), jO = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function f4(e, t) {
  return f(), v("svg", jO, [...t[0] || (t[0] = [
    g("path", { d: "M227.32,73.37,182.63,28.69a16,16,0,0,0-22.63,0L36.69,152A15.86,15.86,0,0,0,32,163.31V208a16,16,0,0,0,16,16H216a8,8,0,0,0,0-16H115.32l112-112A16,16,0,0,0,227.32,73.37ZM92.69,208H48V163.31l88-88L180.69,120ZM192,108.69,147.32,64l24-24L216,84.69Z" }, null, -1)
  ])]);
}
const WO = { render: f4 }, UO = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: WO,
  render: f4
}, Symbol.toStringTag, { value: "Module" })), KO = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 256 256"
};
function v4(e, t) {
  return f(), v("svg", KO, [...t[0] || (t[0] = [
    g("path", { d: "M227.31,73.37,182.63,28.68a16,16,0,0,0-22.63,0L36.69,152A15.86,15.86,0,0,0,32,163.31V208a16,16,0,0,0,16,16H92.69A15.86,15.86,0,0,0,104,219.31L227.31,96a16,16,0,0,0,0-22.63ZM92.69,208H48V163.31l88-88L180.69,120ZM192,108.68,147.31,64l24-24L216,84.68Z" }, null, -1)
  ])]);
}
const qO = { render: v4 }, YO = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: qO,
  render: v4
}, Symbol.toStringTag, { value: "Module" })), QO = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function m4(e, t) {
  return f(), v("svg", QO, [...t[0] || (t[0] = [
    g("path", { d: "M222.37,158.46l-47.11-21.11-.13-.06a16,16,0,0,0-15.17,1.4,8.12,8.12,0,0,0-.75.56L134.87,160c-15.42-7.49-31.34-23.29-38.83-38.51l20.78-24.71c.2-.25.39-.5.57-.77a16,16,0,0,0,1.32-15.06l0-.12L97.54,33.64a16,16,0,0,0-16.62-9.52A56.26,56.26,0,0,0,32,80c0,79.4,64.6,144,144,144a56.26,56.26,0,0,0,55.88-48.92A16,16,0,0,0,222.37,158.46ZM176,208A128.14,128.14,0,0,1,48,80,40.2,40.2,0,0,1,82.87,40a.61.61,0,0,0,0,.12l21,47L83.2,111.86a6.13,6.13,0,0,0-.57.77,16,16,0,0,0-1,15.7c9.06,18.53,27.73,37.06,46.46,46.11a16,16,0,0,0,15.75-1.14,8.44,8.44,0,0,0,.74-.56L168.89,152l47,21.05h0s.08,0,.11,0A40.21,40.21,0,0,1,176,208Z" }, null, -1)
  ])]);
}
const JO = { render: m4 }, XO = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: JO,
  render: m4
}, Symbol.toStringTag, { value: "Module" })), eB = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256"
};
function C4(e, t) {
  return f(), v("svg", eB, [...t[0] || (t[0] = [
    Do('<rect width="256" height="256" fill="none"></rect><line x1="144" y1="64" x2="184" y2="24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></line><line x1="232" y1="72" x2="192" y2="112" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></line><line x1="224" y1="144" x2="112" y2="32" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></line><path d="M212,132l-58.63,58.63a32,32,0,0,1-45.25,0L65.37,147.88a32,32,0,0,1,0-45.25L124,44" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></path><line x1="86.75" y1="169.25" x2="32" y2="224" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></line>', 6)
  ])]);
}
const tB = { render: C4 }, oB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: tB,
  render: C4
}, Symbol.toStringTag, { value: "Module" })), nB = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function w4(e, t) {
  return f(), v("svg", nB, [...t[0] || (t[0] = [
    g("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm48-88a8,8,0,0,1-8,8H136v32a8,8,0,0,1-16,0V136H88a8,8,0,0,1,0-16h32V88a8,8,0,0,1,16,0v32h32A8,8,0,0,1,176,128Z" }, null, -1)
  ])]);
}
const sB = { render: w4 }, iB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sB,
  render: w4
}, Symbol.toStringTag, { value: "Module" })), rB = {
  viewBox: "0 0 21 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function b4(e, t) {
  return f(), v("svg", rB, [...t[0] || (t[0] = [
    g("path", {
      d: "M18.1536 10C18.1536 10.1658 18.0877 10.3247 17.9705 10.4419C17.8533 10.5592 17.6943 10.625 17.5286 10.625H11.2786V16.875C11.2786 17.0408 11.2127 17.1997 11.0955 17.3169C10.9783 17.4342 10.8193 17.5 10.6536 17.5C10.4878 17.5 10.3288 17.4342 10.2116 17.3169C10.0944 17.1997 10.0286 17.0408 10.0286 16.875V10.625H3.77856C3.6128 10.625 3.45383 10.5592 3.33662 10.4419C3.21941 10.3247 3.15356 10.1658 3.15356 10C3.15356 9.83424 3.21941 9.67527 3.33662 9.55806C3.45383 9.44085 3.6128 9.375 3.77856 9.375H10.0286V3.125C10.0286 2.95924 10.0944 2.80027 10.2116 2.68306C10.3288 2.56585 10.4878 2.5 10.6536 2.5C10.8193 2.5 10.9783 2.56585 11.0955 2.68306C11.2127 2.80027 11.2786 2.95924 11.2786 3.125V9.375H17.5286C17.6943 9.375 17.8533 9.44085 17.9705 9.55806C18.0877 9.67527 18.1536 9.83424 18.1536 10Z",
      fill: "currentColor"
    }, null, -1)
  ])]);
}
const lB = { render: b4 }, aB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: lB,
  render: b4
}, Symbol.toStringTag, { value: "Module" })), cB = {
  viewBox: "0 0 18 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function y4(e, t) {
  return f(), v("svg", cB, [...t[0] || (t[0] = [
    g("path", {
      d: "M15.5211 3.125H14.375V0.625C14.375 0.45924 14.3092 0.300269 14.1919 0.183058C14.0747 0.0658481 13.9158 0 13.75 0H3.75C3.58424 0 3.42527 0.0658481 3.30806 0.183058C3.19085 0.300269 3.125 0.45924 3.125 0.625V3.125H1.97891C0.8875 3.125 0 3.96641 0 5V11.25C0 11.4158 0.065848 11.5747 0.183058 11.6919C0.300268 11.8092 0.45924 11.875 0.625 11.875H3.125V14.375C3.125 14.5408 3.19085 14.6997 3.30806 14.8169C3.42527 14.9342 3.58424 15 3.75 15H13.75C13.9158 15 14.0747 14.9342 14.1919 14.8169C14.3092 14.6997 14.375 14.5408 14.375 14.375V11.875H16.875C17.0408 11.875 17.1997 11.8092 17.3169 11.6919C17.4342 11.5747 17.5 11.4158 17.5 11.25V5C17.5 3.96641 16.6125 3.125 15.5211 3.125ZM4.375 1.25H13.125V3.125H4.375V1.25ZM13.125 13.75H4.375V10H13.125V13.75ZM16.25 10.625H14.375V9.375C14.375 9.20924 14.3092 9.05027 14.1919 8.93306C14.0747 8.81585 13.9158 8.75 13.75 8.75H3.75C3.58424 8.75 3.42527 8.81585 3.30806 8.93306C3.19085 9.05027 3.125 9.20924 3.125 9.375V10.625H1.25V5C1.25 4.65547 1.57734 4.375 1.97891 4.375H15.5211C15.9227 4.375 16.25 4.65547 16.25 5V10.625ZM14.375 6.5625C14.375 6.74792 14.32 6.92918 14.217 7.08335C14.114 7.23752 13.9676 7.35768 13.7963 7.42864C13.625 7.49959 13.4365 7.51816 13.2546 7.48199C13.0727 7.44581 12.9057 7.35652 12.7746 7.22541C12.6435 7.0943 12.5542 6.92725 12.518 6.7454C12.4818 6.56354 12.5004 6.37504 12.5714 6.20373C12.6423 6.03243 12.7625 5.88601 12.9167 5.783C13.0708 5.67998 13.2521 5.625 13.4375 5.625C13.6861 5.625 13.9246 5.72377 14.1004 5.89959C14.2762 6.0754 14.375 6.31386 14.375 6.5625Z",
      fill: "currentColor"
    }, null, -1)
  ])]);
}
const dB = { render: y4 }, uB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: dB,
  render: y4
}, Symbol.toStringTag, { value: "Module" })), hB = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256"
};
function _4(e, t) {
  return f(), v("svg", hB, [...t[0] || (t[0] = [
    g("rect", {
      width: "256",
      height: "256",
      fill: "none"
    }, null, -1),
    g("path", {
      d: "M229.66,98.34a8,8,0,0,0,0-11.31L169,26.34a8,8,0,0,0-11.31,0L100.39,83.8S72.64,69.93,43,93.85a8,8,0,0,0-.65,11.91l107.9,107.89a8,8,0,0,0,12-.83c8.39-11.16,21.57-34.09,10.11-57Z",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1),
    g("line", {
      x1: "96.29",
      y1: "159.71",
      x2: "48",
      y2: "208",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1)
  ])]);
}
const gB = { render: _4 }, pB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: gB,
  render: _4
}, Symbol.toStringTag, { value: "Module" })), fB = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function S4(e, t) {
  return f(), v("svg", fB, [...t[0] || (t[0] = [
    g("path", { d: "M140,180a12,12,0,1,1-12-12A12,12,0,0,1,140,180ZM128,72c-22.06,0-40,16.15-40,36v4a8,8,0,0,0,16,0v-4c0-11,10.77-20,24-20s24,9,24,20-10.77,20-24,20a8,8,0,0,0-8,8v8a8,8,0,0,0,16,0v-.72c18.24-3.35,32-17.9,32-35.28C168,88.15,150.06,72,128,72Zm104,56A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z" }, null, -1)
  ])]);
}
const vB = { render: S4 }, mB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: vB,
  render: S4
}, Symbol.toStringTag, { value: "Module" })), CB = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function x4(e, t) {
  return f(), v("svg", CB, [...t[0] || (t[0] = [
    g("path", { d: "M208,112H48a16,16,0,0,0-16,16v24a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V128A16,16,0,0,0,208,112Zm0,40H48V128H208v24Zm0-112H48A16,16,0,0,0,32,56V80A16,16,0,0,0,48,96H208a16,16,0,0,0,16-16V56A16,16,0,0,0,208,40Zm0,40H48V56H208V80ZM160,216a8,8,0,0,1-8,8H136v16a8,8,0,0,1-16,0V224H104a8,8,0,0,1,0-16h16V192a8,8,0,0,1,16,0v16h16A8,8,0,0,1,160,216Z" }, null, -1)
  ])]);
}
const wB = { render: x4 }, bB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: wB,
  render: x4
}, Symbol.toStringTag, { value: "Module" })), yB = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function M4(e, t) {
  return f(), v("svg", yB, [...t[0] || (t[0] = [
    g("path", { d: "M208,160H48a16,16,0,0,0-16,16v24a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V176A16,16,0,0,0,208,160Zm0,40H48V176H208v24Zm0-112H48a16,16,0,0,0-16,16v24a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V104A16,16,0,0,0,208,88Zm0,40H48V104H208v24ZM96,40a8,8,0,0,1,8-8h16V16a8,8,0,0,1,16,0V32h16a8,8,0,0,1,0,16H136V64a8,8,0,0,1-16,0V48H104A8,8,0,0,1,96,40Z" }, null, -1)
  ])]);
}
const _B = { render: M4 }, SB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _B,
  render: M4
}, Symbol.toStringTag, { value: "Module" })), xB = {
  viewBox: "0 0 21 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function A4(e, t) {
  return f(), v("svg", xB, [...t[0] || (t[0] = [
    g("path", {
      d: "M18.8166 17.38L14.9049 13.4691C16.0387 12.1079 16.604 10.362 16.4834 8.59465C16.3627 6.82726 15.5653 5.17443 14.2571 3.97999C12.9488 2.78555 11.2304 2.14146 9.45937 2.18171C7.68833 2.22196 6.00098 2.94345 4.74834 4.19609C3.4957 5.44873 2.77421 7.13608 2.73396 8.90713C2.69371 10.6782 3.3378 12.3966 4.53224 13.7048C5.72668 15.0131 7.37951 15.8105 9.1469 15.9311C10.9143 16.0518 12.6602 15.4864 14.0213 14.3527L17.9323 18.2644C17.9903 18.3225 18.0593 18.3685 18.1351 18.3999C18.211 18.4314 18.2923 18.4475 18.3744 18.4475C18.4566 18.4475 18.5379 18.4314 18.6138 18.3999C18.6896 18.3685 18.7586 18.3225 18.8166 18.2644C18.8747 18.2063 18.9208 18.1374 18.9522 18.0615C18.9836 17.9856 18.9998 17.9043 18.9998 17.8222C18.9998 17.7401 18.9836 17.6588 18.9522 17.5829C18.9208 17.507 18.8747 17.4381 18.8166 17.38ZM3.99945 9.0722C3.99945 7.95968 4.32935 6.87214 4.94743 5.94712C5.56551 5.02209 6.44402 4.30112 7.47185 3.87538C8.49969 3.44963 9.63069 3.33824 10.7218 3.55528C11.813 3.77232 12.8153 4.30805 13.6019 5.09472C14.3886 5.88139 14.9243 6.88367 15.1414 7.97482C15.3584 9.06596 15.247 10.197 14.8213 11.2248C14.3955 12.2526 13.6746 13.1311 12.7495 13.7492C11.8245 14.3673 10.737 14.6972 9.62445 14.6972C8.13311 14.6955 6.70333 14.1024 5.6488 13.0479C4.59426 11.9933 4.0011 10.5635 3.99945 9.0722Z",
      fill: "currentColor"
    }, null, -1)
  ])]);
}
const MB = { render: A4 }, AB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: MB,
  render: A4
}, Symbol.toStringTag, { value: "Module" })), LB = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256"
};
function L4(e, t) {
  return f(), v("svg", LB, [...t[0] || (t[0] = [
    g("rect", {
      width: "256",
      height: "256",
      fill: "none"
    }, null, -1),
    g("polyline", {
      points: "192 72 192 48 64 48 128 128 64 208 192 208 192 184",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1)
  ])]);
}
const EB = { render: L4 }, PB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: EB,
  render: L4
}, Symbol.toStringTag, { value: "Module" })), RB = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function E4(e, t) {
  return f(), v("svg", RB, [...t[0] || (t[0] = [
    g("path", { d: "M141.66,133.66l-40,40a8,8,0,0,1-11.32-11.32L116.69,136H24a8,8,0,0,1,0-16h92.69L90.34,93.66a8,8,0,0,1,11.32-11.32l40,40A8,8,0,0,1,141.66,133.66ZM200,32H136a8,8,0,0,0,0,16h56V208H136a8,8,0,0,0,0,16h64a8,8,0,0,0,8-8V40A8,8,0,0,0,200,32Z" }, null, -1)
  ])]);
}
const FB = { render: E4 }, TB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: FB,
  render: E4
}, Symbol.toStringTag, { value: "Module" })), IB = {
  viewBox: "0 0 21 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function P4(e, t) {
  return f(), v("svg", IB, [...t[0] || (t[0] = [
    g("path", {
      d: "M10.2339 16.875C10.2339 17.0408 10.168 17.1997 10.0508 17.3169C9.93362 17.4342 9.77465 17.5 9.60889 17.5H4.60889C4.44313 17.5 4.28416 17.4342 4.16695 17.3169C4.04973 17.1997 3.98389 17.0408 3.98389 16.875V3.125C3.98389 2.95924 4.04973 2.80027 4.16695 2.68306C4.28416 2.56585 4.44313 2.5 4.60889 2.5H9.60889C9.77465 2.5 9.93362 2.56585 10.0508 2.68306C10.168 2.80027 10.2339 2.95924 10.2339 3.125C10.2339 3.29076 10.168 3.44973 10.0508 3.56694C9.93362 3.68415 9.77465 3.75 9.60889 3.75H5.23389V16.25H9.60889C9.77465 16.25 9.93362 16.3158 10.0508 16.4331C10.168 16.5503 10.2339 16.7092 10.2339 16.875ZM18.8011 9.55781L15.6761 6.43281C15.5588 6.31554 15.3997 6.24965 15.2339 6.24965C15.068 6.24965 14.909 6.31554 14.7917 6.43281C14.6744 6.55009 14.6085 6.70915 14.6085 6.875C14.6085 7.04085 14.6744 7.19991 14.7917 7.31719L16.8503 9.375H9.60889C9.44313 9.375 9.28416 9.44085 9.16694 9.55806C9.04974 9.67527 8.98389 9.83424 8.98389 10C8.98389 10.1658 9.04974 10.3247 9.16694 10.4419C9.28416 10.5592 9.44313 10.625 9.60889 10.625H16.8503L14.7917 12.6828C14.6744 12.8001 14.6085 12.9591 14.6085 13.125C14.6085 13.2909 14.6744 13.4499 14.7917 13.5672C14.909 13.6845 15.068 13.7503 15.2339 13.7503C15.3997 13.7503 15.5588 13.6845 15.6761 13.5672L18.8011 10.4422C18.8592 10.3841 18.9053 10.3152 18.9367 10.2393C18.9682 10.1635 18.9844 10.0821 18.9844 10C18.9844 9.91787 18.9682 9.83654 18.9367 9.76066C18.9053 9.68479 18.8592 9.61586 18.8011 9.55781Z",
      fill: "currentColor"
    }, null, -1)
  ])]);
}
const DB = { render: P4 }, kB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: DB,
  render: P4
}, Symbol.toStringTag, { value: "Module" })), HB = {
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function R4(e, t) {
  return f(), v("svg", HB, [...t[0] || (t[0] = [
    g("path", {
      d: "M2.5 5.50002H4.5625C4.67265 5.93022 4.92285 6.31153 5.27365 6.58384C5.62446 6.85614 6.05591 7.00394 6.5 7.00394C6.94409 7.00394 7.37554 6.85614 7.72635 6.58384C8.07715 6.31153 8.32735 5.93022 8.4375 5.50002H13.5C13.6326 5.50002 13.7598 5.44734 13.8536 5.35357C13.9473 5.2598 14 5.13262 14 5.00002C14 4.86741 13.9473 4.74023 13.8536 4.64646C13.7598 4.55269 13.6326 4.50002 13.5 4.50002H8.4375C8.32735 4.06981 8.07715 3.6885 7.72635 3.4162C7.37554 3.14389 6.94409 2.99609 6.5 2.99609C6.05591 2.99609 5.62446 3.14389 5.27365 3.4162C4.92285 3.6885 4.67265 4.06981 4.5625 4.50002H2.5C2.36739 4.50002 2.24021 4.55269 2.14645 4.64646C2.05268 4.74023 2 4.86741 2 5.00002C2 5.13262 2.05268 5.2598 2.14645 5.35357C2.24021 5.44734 2.36739 5.50002 2.5 5.50002ZM6.5 4.00002C6.69778 4.00002 6.89112 4.05866 7.05557 4.16855C7.22002 4.27843 7.34819 4.43461 7.42388 4.61733C7.49957 4.80006 7.51937 5.00112 7.48079 5.19511C7.4422 5.38909 7.34696 5.56727 7.20711 5.70712C7.06725 5.84697 6.88907 5.94222 6.69509 5.9808C6.50111 6.01939 6.30004 5.99958 6.11732 5.9239C5.93459 5.84821 5.77841 5.72003 5.66853 5.55559C5.55865 5.39114 5.5 5.1978 5.5 5.00002C5.5 4.7348 5.60536 4.48045 5.79289 4.29291C5.98043 4.10537 6.23478 4.00002 6.5 4.00002ZM13.5 10.5H12.4375C12.3273 10.0698 12.0771 9.6885 11.7263 9.4162C11.3755 9.1439 10.9441 8.99609 10.5 8.99609C10.0559 8.99609 9.62446 9.1439 9.27365 9.4162C8.92285 9.6885 8.67265 10.0698 8.5625 10.5H2.5C2.36739 10.5 2.24021 10.5527 2.14645 10.6465C2.05268 10.7402 2 10.8674 2 11C2 11.1326 2.05268 11.2598 2.14645 11.3536C2.24021 11.4473 2.36739 11.5 2.5 11.5H8.5625C8.67265 11.9302 8.92285 12.3115 9.27365 12.5838C9.62446 12.8561 10.0559 13.0039 10.5 13.0039C10.9441 13.0039 11.3755 12.8561 11.7263 12.5838C12.0771 12.3115 12.3273 11.9302 12.4375 11.5H13.5C13.6326 11.5 13.7598 11.4473 13.8536 11.3536C13.9473 11.2598 14 11.1326 14 11C14 10.8674 13.9473 10.7402 13.8536 10.6465C13.7598 10.5527 13.6326 10.5 13.5 10.5ZM10.5 12C10.3022 12 10.1089 11.9414 9.94443 11.8315C9.77998 11.7216 9.65181 11.5654 9.57612 11.3827C9.50043 11.2 9.48063 10.9989 9.51921 10.8049C9.5578 10.6109 9.65304 10.4328 9.79289 10.2929C9.93275 10.1531 10.1109 10.0578 10.3049 10.0192C10.4989 9.98064 10.7 10.0004 10.8827 10.0761C11.0654 10.1518 11.2216 10.28 11.3315 10.4444C11.4414 10.6089 11.5 10.8022 11.5 11C11.5 11.2652 11.3946 11.5196 11.2071 11.7071C11.0196 11.8947 10.7652 12 10.5 12Z",
      fill: "currentColor"
    }, null, -1)
  ])]);
}
const VB = { render: R4 }, OB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: VB,
  render: R4
}, Symbol.toStringTag, { value: "Module" })), BB = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 256 256"
};
function F4(e, t) {
  return f(), v("svg", BB, [...t[0] || (t[0] = [
    g("path", { d: "M197.58,129.06,146,110l-19-51.62a15.92,15.92,0,0,0-29.88,0L78,110l-51.62,19a15.92,15.92,0,0,0,0,29.88L78,178l19,51.62a15.92,15.92,0,0,0,29.88,0L146,178l51.62-19a15.92,15.92,0,0,0,0-29.88ZM137,164.22a8,8,0,0,0-4.74,4.74L112,223.85,91.78,169A8,8,0,0,0,87,164.22L32.15,144,87,123.78A8,8,0,0,0,91.78,119L112,64.15,132.22,119a8,8,0,0,0,4.74,4.74L191.85,144ZM144,40a8,8,0,0,1,8-8h16V16a8,8,0,0,1,16,0V32h16a8,8,0,0,1,0,16H184V64a8,8,0,0,1-16,0V48H152A8,8,0,0,1,144,40ZM248,88a8,8,0,0,1-8,8h-8v8a8,8,0,0,1-16,0V96h-8a8,8,0,0,1,0-16h8V72a8,8,0,0,1,16,0v8h8A8,8,0,0,1,248,88Z" }, null, -1)
  ])]);
}
const $B = { render: F4 }, ZB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: $B,
  render: F4
}, Symbol.toStringTag, { value: "Module" })), GB = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256"
};
function T4(e, t) {
  return f(), v("svg", GB, [...t[0] || (t[0] = [
    Do('<rect width="256" height="256" fill="none"></rect><line x1="104" y1="48" x2="104" y2="208" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></line><line x1="152" y1="48" x2="152" y2="208" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></line><line x1="152" y1="128" x2="232" y2="128" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></line><line x1="24" y1="128" x2="104" y2="128" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></line><polyline points="200 96 232 128 200 160" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></polyline><polyline points="56 96 24 128 56 160" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></polyline>', 7)
  ])]);
}
const NB = { render: T4 }, zB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: NB,
  render: T4
}, Symbol.toStringTag, { value: "Module" })), jB = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function I4(e, t) {
  return f(), v("svg", jB, [...t[0] || (t[0] = [
    g("path", { d: "M230.91,124A8,8,0,0,1,228,134.91l-96,56a8,8,0,0,1-8.06,0l-96-56A8,8,0,0,1,36,121.09l92,53.65,92-53.65A8,8,0,0,1,230.91,124ZM24,80a8,8,0,0,1,4-6.91l96-56a8,8,0,0,1,8.06,0l96,56a8,8,0,0,1,0,13.82l-96,56a8,8,0,0,1-8.06,0l-96-56A8,8,0,0,1,24,80Zm23.88,0L128,126.74,208.12,80,128,33.26ZM232,192H184a8,8,0,0,0,0,16h48a8,8,0,0,0,0-16Zm-92,23.76-12,7L36,169.09A8,8,0,0,0,28,182.91l96,56a8,8,0,0,0,8.06,0l16-9.33A8,8,0,1,0,140,215.76Z" }, null, -1)
  ])]);
}
const WB = { render: I4 }, UB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: WB,
  render: I4
}, Symbol.toStringTag, { value: "Module" })), KB = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function D4(e, t) {
  return f(), v("svg", KB, [...t[0] || (t[0] = [
    g("path", { d: "M230.91,124A8,8,0,0,1,228,134.91l-96,56a8,8,0,0,1-8.06,0l-96-56A8,8,0,0,1,36,121.09l92,53.65,92-53.65A8,8,0,0,1,230.91,124ZM24,80a8,8,0,0,1,4-6.91l96-56a8,8,0,0,1,8.06,0l96,56a8,8,0,0,1,0,13.82l-96,56a8,8,0,0,1-8.06,0l-96-56A8,8,0,0,1,24,80Zm23.88,0L128,126.74,208.12,80,128,33.26ZM232,192H216V176a8,8,0,0,0-16,0v16H184a8,8,0,0,0,0,16h16v16a8,8,0,0,0,16,0V208h16a8,8,0,0,0,0-16Zm-92,23.76-12,7L36,169.09A8,8,0,0,0,28,182.91l96,56a8,8,0,0,0,8.06,0l16-9.33A8,8,0,1,0,140,215.76Z" }, null, -1)
  ])]);
}
const qB = { render: D4 }, YB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: qB,
  render: D4
}, Symbol.toStringTag, { value: "Module" })), QB = {
  viewBox: "0 0 21 21",
  fill: "black",
  xmlns: "http://www.w3.org/2000/svg"
};
function k4(e, t) {
  return f(), v("svg", QB, [...t[0] || (t[0] = [
    g("path", {
      d: "M19.5604 7.92072C19.4822 7.6805 19.3348 7.46879 19.1365 7.31224C18.9383 7.1557 18.6981 7.06133 18.4463 7.04103L13.8369 6.66915L12.0573 2.36525C11.961 2.13073 11.7972 1.93013 11.5867 1.78895C11.3761 1.64777 11.1283 1.57239 10.8748 1.57239C10.6213 1.57239 10.3736 1.64777 10.163 1.78895C9.95247 1.93013 9.78866 2.13073 9.69241 2.36525L7.91429 6.66837L3.30257 7.04103C3.05036 7.06236 2.81006 7.15764 2.61177 7.31494C2.41347 7.47224 2.26601 7.68456 2.18785 7.92529C2.10969 8.16603 2.10431 8.42448 2.17238 8.66826C2.24046 8.91203 2.37896 9.1303 2.57054 9.29572L6.08616 12.3293L5.01507 16.8652C4.95516 17.1117 4.96983 17.3703 5.05721 17.6084C5.14458 17.8465 5.30073 18.0532 5.50582 18.2024C5.71091 18.3516 5.9557 18.4365 6.20911 18.4463C6.46252 18.4561 6.71314 18.3903 6.92913 18.2574L10.8744 15.8293L14.8221 18.2574C15.0382 18.3888 15.2883 18.4532 15.5409 18.4427C15.7935 18.4321 16.0374 18.3471 16.2418 18.1983C16.4462 18.0494 16.602 17.8434 16.6895 17.6062C16.7771 17.369 16.7925 17.1112 16.7338 16.8652L15.6588 12.3285L19.1744 9.29494C19.3676 9.1298 19.5073 8.91106 19.576 8.66642C19.6447 8.42178 19.6393 8.16226 19.5604 7.92072ZM18.3619 8.34806L14.5573 11.6293C14.4705 11.7041 14.4059 11.8013 14.3707 11.9103C14.3354 12.0193 14.3308 12.1358 14.3573 12.2473L15.5198 17.1535C15.5228 17.1603 15.5231 17.168 15.5206 17.1749C15.5181 17.1819 15.5131 17.1877 15.5065 17.191C15.4924 17.202 15.4885 17.1996 15.4768 17.191L11.2018 14.5621C11.1033 14.5016 10.99 14.4695 10.8744 14.4695C10.7589 14.4695 10.6456 14.5016 10.5471 14.5621L6.2721 17.1926C6.26038 17.1996 6.25725 17.202 6.24241 17.1926C6.23582 17.1892 6.23076 17.1835 6.22829 17.1765C6.22582 17.1695 6.22612 17.1619 6.22913 17.1551L7.39163 12.2488C7.41812 12.1374 7.41348 12.0208 7.37821 11.9118C7.34294 11.8029 7.2784 11.7057 7.19163 11.6309L3.38694 8.34962C3.37757 8.34181 3.36897 8.33478 3.37679 8.31056C3.3846 8.28634 3.39085 8.28947 3.40257 8.2879L8.39632 7.88478C8.51086 7.87496 8.62047 7.83373 8.71309 7.76564C8.80572 7.69755 8.87777 7.60523 8.92132 7.49884L10.8448 2.84181C10.851 2.82853 10.8533 2.82228 10.8721 2.82228C10.8908 2.82228 10.8932 2.82853 10.8994 2.84181L12.8276 7.49884C12.8715 7.60527 12.944 7.69749 13.0371 7.76532C13.1301 7.83315 13.2401 7.87395 13.3549 7.88322L18.3487 8.28634C18.3604 8.28634 18.3674 8.28634 18.3744 8.309C18.3815 8.33166 18.3744 8.34025 18.3619 8.34806Z",
      fill: "currentColor"
    }, null, -1)
  ])]);
}
const JB = { render: k4 }, XB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: JB,
  render: k4
}, Symbol.toStringTag, { value: "Module" })), e$ = {
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function H4(e, t) {
  return f(), v("svg", e$, [...t[0] || (t[0] = [
    g("path", {
      d: "M16.875 4.69727H13.75V4.07227C13.75 3.57498 13.5525 3.09807 13.2008 2.74644C12.8492 2.39481 12.3723 2.19727 11.875 2.19727H8.125C7.62772 2.19727 7.15081 2.39481 6.79917 2.74644C6.44754 3.09807 6.25 3.57498 6.25 4.07227V4.69727H3.125C2.79348 4.69727 2.47554 4.82896 2.24112 5.06338C2.0067 5.2978 1.875 5.61575 1.875 5.94727V15.9473C1.875 16.2788 2.0067 16.5967 2.24112 16.8311C2.47554 17.0656 2.79348 17.1973 3.125 17.1973H16.875C17.2065 17.1973 17.5245 17.0656 17.7589 16.8311C17.9933 16.5967 18.125 16.2788 18.125 15.9473V5.94727C18.125 5.61575 17.9933 5.2978 17.7589 5.06338C17.5245 4.82896 17.2065 4.69727 16.875 4.69727ZM7.5 4.07227C7.5 3.90651 7.56585 3.74753 7.68306 3.63032C7.80027 3.51311 7.95924 3.44727 8.125 3.44727H11.875C12.0408 3.44727 12.1997 3.51311 12.3169 3.63032C12.4342 3.74753 12.5 3.90651 12.5 4.07227V4.69727H7.5V4.07227ZM16.875 5.94727V11.5723H3.125V5.94727H16.875ZM16.875 15.9473H3.125V12.8223H16.875V15.9473Z",
      fill: "currentColor"
    }, null, -1)
  ])]);
}
const t$ = { render: H4 }, o$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: t$,
  render: H4
}, Symbol.toStringTag, { value: "Module" })), n$ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function V4(e, t) {
  return f(), v("svg", n$, [...t[0] || (t[0] = [
    g("path", { d: "M224,48V152a16,16,0,0,1-16,16H99.31l10.35,10.34a8,8,0,0,1-11.32,11.32l-24-24a8,8,0,0,1,0-11.32l24-24a8,8,0,0,1,11.32,11.32L99.31,152H208V48H96v8a8,8,0,0,1-16,0V48A16,16,0,0,1,96,32H208A16,16,0,0,1,224,48ZM168,192a8,8,0,0,0-8,8v8H48V104H156.69l-10.35,10.34a8,8,0,0,0,11.32,11.32l24-24a8,8,0,0,0,0-11.32l-24-24a8,8,0,0,0-11.32,11.32L156.69,88H48a16,16,0,0,0-16,16V208a16,16,0,0,0,16,16H160a16,16,0,0,0,16-16v-8A8,8,0,0,0,168,192Z" }, null, -1)
  ])]);
}
const s$ = { render: V4 }, i$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: s$,
  render: V4
}, Symbol.toStringTag, { value: "Module" })), r$ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function O4(e, t) {
  return f(), v("svg", r$, [...t[0] || (t[0] = [
    g("path", { d: "M224,48H32a8,8,0,0,0-8,8V192a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A8,8,0,0,0,224,48ZM40,112H80v32H40Zm56,0H216v32H96ZM216,64V96H40V64ZM40,160H80v32H40Zm176,32H96V160H216v32Z" }, null, -1)
  ])]);
}
const l$ = { render: O4 }, a$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: l$,
  render: O4
}, Symbol.toStringTag, { value: "Module" })), c$ = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function B4(e, t) {
  return f(), v("svg", c$, [...t[0] || (t[0] = [
    g("g", { "clip-path": "url(#clip0_4192_3982)" }, [
      g("path", {
        d: "M19.9734 12.9454C19.9738 12.9433 19.9738 12.9412 19.9734 12.9391L18.232 7.14067C18.156 6.88256 17.9982 6.65614 17.7823 6.4955C17.5664 6.33487 17.3042 6.24873 17.0352 6.25004H16.25C16.0842 6.25004 15.9253 6.31589 15.8081 6.4331C15.6908 6.55031 15.625 6.70928 15.625 6.87504C15.625 7.0408 15.6908 7.19977 15.8081 7.31698C15.9253 7.43419 16.0842 7.50004 16.25 7.50004H17.0352L18.5352 12.5H16.0938L14.482 7.14067C14.406 6.88256 14.2482 6.65614 14.0323 6.4955C13.8164 6.33487 13.5542 6.24873 13.2852 6.25004H12.5C12.3342 6.25004 12.1753 6.31589 12.0581 6.4331C11.9408 6.55031 11.875 6.70928 11.875 6.87504C11.875 7.0408 11.9408 7.19977 12.0581 7.31698C12.1753 7.43419 12.3342 7.50004 12.5 7.50004H13.2852L14.7852 12.5H12.3438L10.732 7.14067C10.656 6.88256 10.4982 6.65614 10.2823 6.4955C10.0664 6.33487 9.80423 6.24873 9.53516 6.25004H2.96875C2.69901 6.24788 2.43591 6.33363 2.21926 6.49433C2.0026 6.65502 1.84418 6.88191 1.76797 7.14067L0.0289063 12.9375V12.9414C0.0289063 12.9414 0.0289063 12.9454 0.0289063 12.9477C0.0108845 13.0051 0.00115099 13.0649 0 13.125C0 13.2908 0.065848 13.4498 0.183058 13.567C0.300269 13.6842 0.45924 13.75 0.625 13.75H19.375C19.4724 13.75 19.5685 13.7272 19.6555 13.6835C19.7426 13.6397 19.8182 13.5762 19.8763 13.498C19.9345 13.4198 19.9735 13.3291 19.9904 13.2332C20.0073 13.1372 20.0014 13.0387 19.9734 12.9454ZM2.96875 7.50004H9.53906L11.0391 12.5H1.46484L2.96875 7.50004Z",
        fill: "currentColor"
      })
    ], -1),
    g("defs", null, [
      g("clipPath", { id: "clip0_4192_3982" }, [
        g("rect", {
          width: "20",
          height: "20",
          fill: "white"
        })
      ])
    ], -1)
  ])]);
}
const d$ = { render: B4 }, u$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: d$,
  render: B4
}, Symbol.toStringTag, { value: "Module" })), h$ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function $4(e, t) {
  return f(), v("svg", h$, [...t[0] || (t[0] = [
    g("path", { d: "M32,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H40A8,8,0,0,1,32,64ZM64,96a8,8,0,0,0,0,16H192a8,8,0,0,0,0-16Zm152,40H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Zm-24,40H64a8,8,0,0,0,0,16H192a8,8,0,0,0,0-16Z" }, null, -1)
  ])]);
}
const g$ = { render: $4 }, p$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: g$,
  render: $4
}, Symbol.toStringTag, { value: "Module" })), f$ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function Z4(e, t) {
  return f(), v("svg", f$, [...t[0] || (t[0] = [
    g("path", { d: "M32,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H40A8,8,0,0,1,32,64ZM216,96H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Zm0,40H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Zm0,40H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z" }, null, -1)
  ])]);
}
const v$ = { render: Z4 }, m$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: v$,
  render: Z4
}, Symbol.toStringTag, { value: "Module" })), C$ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function G4(e, t) {
  return f(), v("svg", C$, [...t[0] || (t[0] = [
    g("path", { d: "M32,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H40A8,8,0,0,1,32,64Zm8,48H168a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16Zm176,24H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Zm-48,40H40a8,8,0,0,0,0,16H168a8,8,0,0,0,0-16Z" }, null, -1)
  ])]);
}
const w$ = { render: G4 }, b$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: w$,
  render: G4
}, Symbol.toStringTag, { value: "Module" })), y$ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function N4(e, t) {
  return f(), v("svg", y$, [...t[0] || (t[0] = [
    g("path", { d: "M32,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H40A8,8,0,0,1,32,64ZM216,96H88a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Zm0,40H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Zm0,40H88a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z" }, null, -1)
  ])]);
}
const _$ = { render: N4 }, S$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _$,
  render: N4
}, Symbol.toStringTag, { value: "Module" })), x$ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function z4(e, t) {
  return f(), v("svg", x$, [...t[0] || (t[0] = [
    g("path", { d: "M178.48,115.7A44,44,0,0,0,148,40H80a8,8,0,0,0-8,8V200a8,8,0,0,0,8,8h80a48,48,0,0,0,18.48-92.3ZM88,56h60a28,28,0,0,1,0,56H88Zm72,136H88V128h72a32,32,0,0,1,0,64Z" }, null, -1)
  ])]);
}
const M$ = { render: z4 }, A$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: M$,
  render: z4
}, Symbol.toStringTag, { value: "Module" })), L$ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256"
};
function j4(e, t) {
  return f(), v("svg", L$, [...t[0] || (t[0] = [
    Do('<rect width="256" height="256" fill="none"></rect><line x1="40" y1="64" x2="112" y2="64" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></line><line x1="40" y1="104" x2="112" y2="104" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></line><line x1="40" y1="144" x2="112" y2="144" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></line><line x1="40" y1="184" x2="112" y2="184" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></line><line x1="144" y1="64" x2="216" y2="64" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></line><line x1="144" y1="104" x2="216" y2="104" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></line><line x1="144" y1="144" x2="216" y2="144" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></line><line x1="144" y1="184" x2="216" y2="184" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></line>', 9)
  ])]);
}
const E$ = { render: j4 }, P$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: E$,
  render: j4
}, Symbol.toStringTag, { value: "Module" })), R$ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function W4(e, t) {
  return f(), v("svg", R$, [...t[0] || (t[0] = [
    g("path", { d: "M208,56V200a8,8,0,0,1-16,0V136H64v64a8,8,0,0,1-16,0V56a8,8,0,0,1,16,0v64H192V56a8,8,0,0,1,16,0Z" }, null, -1)
  ])]);
}
const F$ = { render: W4 }, T$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: F$,
  render: W4
}, Symbol.toStringTag, { value: "Module" })), I$ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function U4(e, t) {
  return f(), v("svg", I$, [...t[0] || (t[0] = [
    g("path", { d: "M224,128a8,8,0,0,1-8,8H112a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM112,72H216a8,8,0,0,0,0-16H112a8,8,0,0,0,0,16ZM216,184H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16ZM34.34,141.66a8,8,0,0,0,11.32,0l40-40a8,8,0,0,0,0-11.32l-40-40A8,8,0,0,0,34.34,61.66L68.69,96,34.34,130.34A8,8,0,0,0,34.34,141.66Z" }, null, -1)
  ])]);
}
const D$ = { render: U4 }, k$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: D$,
  render: U4
}, Symbol.toStringTag, { value: "Module" })), H$ = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function K4(e, t) {
  return f(), v("svg", H$, [...t[0] || (t[0] = [
    g("path", {
      d: "M18.427 18.073C18.4502 18.0962 18.4687 18.1238 18.4812 18.1542C18.4938 18.1845 18.5003 18.217 18.5003 18.2499C18.5003 18.2827 18.4938 18.3153 18.4812 18.3456C18.4687 18.376 18.4502 18.4035 18.427 18.4268C18.4038 18.45 18.3762 18.4684 18.3459 18.481C18.3155 18.4936 18.283 18.5 18.2501 18.5C18.2173 18.5 18.1848 18.4936 18.1544 18.481C18.1241 18.4684 18.0965 18.45 18.0733 18.4268L16.0001 16.3533L13.927 18.4268C13.8801 18.4737 13.8165 18.5 13.7501 18.5C13.6838 18.5 13.6202 18.4737 13.5733 18.4268C13.5264 18.3799 13.5 18.3162 13.5 18.2499C13.5 18.1836 13.5264 18.1199 13.5733 18.073L15.6467 15.9999L13.5733 13.9268C13.5264 13.8799 13.5 13.8162 13.5 13.7499C13.5 13.6836 13.5264 13.6199 13.5733 13.573C13.6202 13.5261 13.6838 13.4998 13.7501 13.4998C13.8165 13.4998 13.8801 13.5261 13.927 13.573L16.0001 15.6465L18.0733 13.573C18.1202 13.5261 18.1838 13.4998 18.2501 13.4998C18.3165 13.4998 18.3801 13.5261 18.427 13.573C18.4739 13.6199 18.5003 13.6836 18.5003 13.7499C18.5003 13.8162 18.4739 13.8799 18.427 13.9268L16.3536 15.9999L18.427 18.073Z",
      fill: "#272E35"
    }, null, -1),
    g("path", {
      d: "M15.625 4.375C15.625 4.54076 15.5592 4.69973 15.4419 4.81694C15.3247 4.93415 15.1658 5 15 5H12.3258L8.99219 15H11.25C11.4158 15 11.5747 15.0658 11.6919 15.1831C11.8092 15.3003 11.875 15.4592 11.875 15.625C11.875 15.7908 11.8092 15.9497 11.6919 16.0669C11.5747 16.1842 11.4158 16.25 11.25 16.25H5C4.83424 16.25 4.67527 16.1842 4.55806 16.0669C4.44085 15.9497 4.375 15.7908 4.375 15.625C4.375 15.4592 4.44085 15.3003 4.55806 15.1831C4.67527 15.0658 4.83424 15 5 15H7.67422L11.0078 5H8.75C8.58424 5 8.42527 4.93415 8.30806 4.81694C8.19085 4.69973 8.125 4.54076 8.125 4.375C8.125 4.20924 8.19085 4.05027 8.30806 3.93306C8.42527 3.81585 8.58424 3.75 8.75 3.75H15C15.1658 3.75 15.3247 3.81585 15.4419 3.93306C15.5592 4.05027 15.625 4.20924 15.625 4.375Z",
      fill: "#272E35"
    }, null, -1)
  ])]);
}
const V$ = { render: K4 }, O$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: V$,
  render: K4
}, Symbol.toStringTag, { value: "Module" })), B$ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function q4(e, t) {
  return f(), v("svg", B$, [...t[0] || (t[0] = [
    g("path", { d: "M200,56a8,8,0,0,1-8,8H157.77L115.1,192H144a8,8,0,0,1,0,16H64a8,8,0,0,1,0-16H98.23L140.9,64H112a8,8,0,0,1,0-16h80A8,8,0,0,1,200,56Z" }, null, -1)
  ])]);
}
const $$ = { render: q4 }, Z$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: $$,
  render: q4
}, Symbol.toStringTag, { value: "Module" })), G$ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function Y4(e, t) {
  return f(), v("svg", G$, [...t[0] || (t[0] = [
    g("path", { d: "M224,128a8,8,0,0,1-8,8H112a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM112,72H216a8,8,0,0,0,0-16H112a8,8,0,0,0,0,16ZM216,184H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16ZM72,144a8,8,0,0,0,5.66-13.66L43.31,96,77.66,61.66A8,8,0,0,0,66.34,50.34l-40,40a8,8,0,0,0,0,11.32l40,40A8,8,0,0,0,72,144Z" }, null, -1)
  ])]);
}
const N$ = { render: Y4 }, z$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: N$,
  render: Y4
}, Symbol.toStringTag, { value: "Module" })), j$ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256"
};
function Q4(e, t) {
  return f(), v("svg", j$, [...t[0] || (t[0] = [
    Do('<rect width="256" height="256" fill="none"></rect><line x1="48" y1="40" x2="208" y2="216" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></line><line x1="96" y1="200" x2="160" y2="200" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></line><line x1="128" y1="128" x2="128" y2="200" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></line><line x1="128" y1="56" x2="128" y2="80.43" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></line><polyline points="105.79 56 200 56 200 88" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></polyline><polyline points="56 88 56 56 62.55 56" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></polyline>', 7)
  ])]);
}
const W$ = { render: Q4 }, U$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: W$,
  render: Q4
}, Symbol.toStringTag, { value: "Module" })), K$ = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function J4(e, t) {
  return f(), v("svg", K$, [...t[0] || (t[0] = [
    g("path", {
      d: "M16.2502 4.375V6.875C16.2502 7.04076 16.1843 7.19973 16.0671 7.31694C15.9499 7.43415 15.7909 7.5 15.6252 7.5C15.4594 7.5 15.3005 7.43415 15.1832 7.31694C15.066 7.19973 15.0002 7.04076 15.0002 6.875V5H10.6252V15H12.5002C12.6659 15 12.8249 15.0658 12.9421 15.1831C13.0593 15.3003 13.1252 15.4592 13.1252 15.625C13.1252 15.7908 13.0593 15.9497 12.9421 16.0669C12.8249 16.1842 12.6659 16.25 12.5002 16.25H7.50018C7.33442 16.25 7.17545 16.1842 7.05824 16.0669C6.94103 15.9497 6.87518 15.7908 6.87518 15.625C6.87518 15.4592 6.94103 15.3003 7.05824 15.1831C7.17545 15.0658 7.33442 15 7.50018 15H9.37518V5H5.00018V6.875C5.00018 7.04076 4.93433 7.19973 4.81712 7.31694C4.69991 7.43415 4.54094 7.5 4.37518 7.5C4.20942 7.5 4.05045 7.43415 3.93324 7.31694C3.81603 7.19973 3.75018 7.04076 3.75018 6.875V4.375C3.75018 4.20924 3.81603 4.05027 3.93324 3.93306C4.05045 3.81585 4.20942 3.75 4.37518 3.75H15.6252C15.7909 3.75 15.9499 3.81585 16.0671 3.93306C16.1843 4.05027 16.2502 4.20924 16.2502 4.375Z",
      fill: "currentColor"
    }, null, -1)
  ])]);
}
const q$ = { render: J4 }, Y$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: q$,
  render: J4
}, Symbol.toStringTag, { value: "Module" })), Q$ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function X4(e, t) {
  return f(), v("svg", Q$, [...t[0] || (t[0] = [
    g("path", { d: "M112,40a8,8,0,0,0-8,8V64H24A16,16,0,0,0,8,80v96a16,16,0,0,0,16,16h80v16a8,8,0,0,0,16,0V48A8,8,0,0,0,112,40ZM24,176V80h80v96ZM248,80v96a16,16,0,0,1-16,16H144a8,8,0,0,1,0-16h88V80H144a8,8,0,0,1,0-16h88A16,16,0,0,1,248,80ZM88,112a8,8,0,0,1-8,8H72v24a8,8,0,0,1-16,0V120H48a8,8,0,0,1,0-16H80A8,8,0,0,1,88,112Z" }, null, -1)
  ])]);
}
const J$ = { render: X4 }, X$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: J$,
  render: X4
}, Symbol.toStringTag, { value: "Module" })), eZ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function e8(e, t) {
  return f(), v("svg", eZ, [...t[0] || (t[0] = [
    g("path", { d: "M128,40a96,96,0,1,0,96,96A96.11,96.11,0,0,0,128,40Zm0,176a80,80,0,1,1,80-80A80.09,80.09,0,0,1,128,216ZM173.66,90.34a8,8,0,0,1,0,11.32l-40,40a8,8,0,0,1-11.32-11.32l40-40A8,8,0,0,1,173.66,90.34ZM96,16a8,8,0,0,1,8-8h48a8,8,0,0,1,0,16H104A8,8,0,0,1,96,16Z" }, null, -1)
  ])]);
}
const tZ = { render: e8 }, oZ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: tZ,
  render: e8
}, Symbol.toStringTag, { value: "Module" })), nZ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  fill: "currentColor"
};
function t8(e, t) {
  return f(), v("svg", nZ, [...t[0] || (t[0] = [
    g("path", { d: "M216,48H176V40a24,24,0,0,0-24-24H104A24,24,0,0,0,80,40v8H40a8,8,0,0,0,0,16h8V208a16,16,0,0,0,16,16H192a16,16,0,0,0,16-16V64h8a8,8,0,0,0,0-16ZM96,40a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8v8H96Zm96,168H64V64H192ZM112,104v64a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Zm48,0v64a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Z" }, null, -1)
  ])]);
}
const sZ = { render: t8 }, iZ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sZ,
  render: t8
}, Symbol.toStringTag, { value: "Module" })), rZ = {
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function o8(e, t) {
  return f(), v("svg", rZ, [...t[0] || (t[0] = [
    g("path", {
      d: "M16.25 2.82227H3.75C3.41848 2.82227 3.10054 2.95396 2.86612 3.18838C2.6317 3.4228 2.5 3.74075 2.5 4.07227V16.5723C2.5 16.9038 2.6317 17.2217 2.86612 17.4561C3.10054 17.6906 3.41848 17.8223 3.75 17.8223H16.25C16.5815 17.8223 16.8995 17.6906 17.1339 17.4561C17.3683 17.2217 17.5 16.9038 17.5 16.5723V4.07227C17.5 3.74075 17.3683 3.4228 17.1339 3.18838C16.8995 2.95396 16.5815 2.82227 16.25 2.82227ZM16.25 4.07227V12.1973H14.0078C13.8437 12.1968 13.6812 12.229 13.5297 12.2919C13.3781 12.3548 13.2406 12.4472 13.125 12.5637L11.6164 14.0723H8.38359L6.875 12.5637C6.75935 12.4471 6.62168 12.3547 6.46999 12.2918C6.3183 12.2289 6.15562 12.1967 5.99141 12.1973H3.75V4.07227H16.25ZM16.25 16.5723H3.75V13.4473H5.99141L7.5 14.9559C7.61565 15.0724 7.75332 15.1649 7.90501 15.2278C8.0567 15.2907 8.21938 15.3228 8.38359 15.3223H11.6164C11.7806 15.3228 11.9433 15.2907 12.095 15.2278C12.2467 15.1649 12.3843 15.0724 12.5 14.9559L14.0086 13.4473H16.25V16.5723Z",
      fill: "currentColor"
    }, null, -1)
  ])]);
}
const lZ = { render: o8 }, aZ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: lZ,
  render: o8
}, Symbol.toStringTag, { value: "Module" })), cZ = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function n8(e, t) {
  return f(), v("svg", cZ, [...t[0] || (t[0] = [
    g("path", {
      d: "M12.5 8.75H16.25C16.5815 8.75 16.8995 8.6183 17.1339 8.38388C17.3683 8.14946 17.5 7.83152 17.5 7.5V3.75C17.5 3.41848 17.3683 3.10054 17.1339 2.86612C16.8995 2.6317 16.5815 2.5 16.25 2.5H12.5C12.1685 2.5 11.8505 2.6317 11.6161 2.86612C11.3817 3.10054 11.25 3.41848 11.25 3.75V5H10C9.50272 5 9.02581 5.19754 8.67417 5.54917C8.32254 5.90081 8.125 6.37772 8.125 6.875V9.375H5.625V8.75C5.625 8.41848 5.4933 8.10054 5.25888 7.86612C5.02446 7.6317 4.70652 7.5 4.375 7.5H1.875C1.54348 7.5 1.22554 7.6317 0.991117 7.86612C0.756696 8.10054 0.625 8.41848 0.625 8.75V11.25C0.625 11.5815 0.756696 11.8995 0.991117 12.1339C1.22554 12.3683 1.54348 12.5 1.875 12.5H4.375C4.70652 12.5 5.02446 12.3683 5.25888 12.1339C5.4933 11.8995 5.625 11.5815 5.625 11.25V10.625H8.125V13.125C8.125 13.6223 8.32254 14.0992 8.67417 14.4508C9.02581 14.8025 9.50272 15 10 15H11.25V16.25C11.25 16.5815 11.3817 16.8995 11.6161 17.1339C11.8505 17.3683 12.1685 17.5 12.5 17.5H16.25C16.5815 17.5 16.8995 17.3683 17.1339 17.1339C17.3683 16.8995 17.5 16.5815 17.5 16.25V12.5C17.5 12.1685 17.3683 11.8505 17.1339 11.6161C16.8995 11.3817 16.5815 11.25 16.25 11.25H12.5C12.1685 11.25 11.8505 11.3817 11.6161 11.6161C11.3817 11.8505 11.25 12.1685 11.25 12.5V13.75H10C9.83424 13.75 9.67527 13.6842 9.55806 13.5669C9.44085 13.4497 9.375 13.2908 9.375 13.125V6.875C9.375 6.70924 9.44085 6.55027 9.55806 6.43306C9.67527 6.31585 9.83424 6.25 10 6.25H11.25V7.5C11.25 7.83152 11.3817 8.14946 11.6161 8.38388C11.8505 8.6183 12.1685 8.75 12.5 8.75ZM4.375 11.25H1.875V8.75H4.375V11.25ZM12.5 12.5H16.25V16.25H12.5V12.5ZM12.5 3.75H16.25V7.5H12.5V3.75Z",
      fill: "currentColor"
    }, null, -1)
  ])]);
}
const dZ = { render: n8 }, uZ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: dZ,
  render: n8
}, Symbol.toStringTag, { value: "Module" })), hZ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function s8(e, t) {
  return f(), v("svg", hZ, [...t[0] || (t[0] = [
    g("path", { d: "M176,152h32a16,16,0,0,0,16-16V104a16,16,0,0,0-16-16H176a16,16,0,0,0-16,16v8H88V80h8a16,16,0,0,0,16-16V32A16,16,0,0,0,96,16H64A16,16,0,0,0,48,32V64A16,16,0,0,0,64,80h8V192a24,24,0,0,0,24,24h64v8a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V192a16,16,0,0,0-16-16H176a16,16,0,0,0-16,16v8H96a8,8,0,0,1-8-8V128h72v8A16,16,0,0,0,176,152ZM64,32H96V64H64ZM176,192h32v32H176Zm0-88h32v32H176Z" }, null, -1)
  ])]);
}
const gZ = { render: s8 }, pZ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: gZ,
  render: s8
}, Symbol.toStringTag, { value: "Module" })), fZ = {
  viewBox: "0 0 21 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function i8(e, t) {
  return f(), v("svg", fZ, [...t[0] || (t[0] = [
    g("path", {
      d: "M18.25 11.4977V16.4977C18.25 16.6634 18.1842 16.8224 18.0669 16.9396C17.9497 17.0568 17.7908 17.1227 17.625 17.1227H3.875C3.70924 17.1227 3.55027 17.0568 3.43306 16.9396C3.31585 16.8224 3.25 16.6634 3.25 16.4977V11.4977C3.25 11.3319 3.31585 11.173 3.43306 11.0557C3.55027 10.9385 3.70924 10.8727 3.875 10.8727C4.04076 10.8727 4.19973 10.9385 4.31694 11.0557C4.43415 11.173 4.5 11.3319 4.5 11.4977V15.8727H17V11.4977C17 11.3319 17.0658 11.173 17.1831 11.0557C17.3003 10.9385 17.4592 10.8727 17.625 10.8727C17.7908 10.8727 17.9497 10.9385 18.0669 11.0557C18.1842 11.173 18.25 11.3319 18.25 11.4977ZM8.06719 6.31487L10.125 4.25628V11.4977C10.125 11.6634 10.1908 11.8224 10.3081 11.9396C10.4253 12.0568 10.5842 12.1227 10.75 12.1227C10.9158 12.1227 11.0747 12.0568 11.1919 11.9396C11.3092 11.8224 11.375 11.6634 11.375 11.4977V4.25628L13.4328 6.31487C13.5501 6.43215 13.7091 6.49803 13.875 6.49803C14.0409 6.49803 14.1999 6.43215 14.3172 6.31487C14.4345 6.1976 14.5003 6.03854 14.5003 5.87268C14.5003 5.70683 14.4345 5.54777 14.3172 5.4305L11.1922 2.3055C11.1341 2.24739 11.0652 2.20129 10.9893 2.16983C10.9135 2.13838 10.8321 2.12219 10.75 2.12219C10.6679 2.12219 10.5865 2.13838 10.5107 2.16983C10.4348 2.20129 10.3659 2.24739 10.3078 2.3055L7.18281 5.4305C7.06554 5.54777 6.99965 5.70683 6.99965 5.87268C6.99965 6.03854 7.06554 6.1976 7.18281 6.31487C7.30009 6.43215 7.45915 6.49803 7.625 6.49803C7.79085 6.49803 7.94991 6.43215 8.06719 6.31487Z",
      fill: "currentColor"
    }, null, -1)
  ])]);
}
const vZ = { render: i8 }, mZ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: vZ,
  render: i8
}, Symbol.toStringTag, { value: "Module" })), CZ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 256 256"
};
function r8(e, t) {
  return f(), v("svg", CZ, [...t[0] || (t[0] = [
    g("path", { d: "M96.26,37A8,8,0,0,1,102,27.29a104.11,104.11,0,0,1,52,0,8,8,0,0,1-2,15.75,8.15,8.15,0,0,1-2-.26,88,88,0,0,0-44,0A8,8,0,0,1,96.26,37ZM33.35,110a8,8,0,0,0,9.85-5.57,87.88,87.88,0,0,1,22-38.09A8,8,0,0,0,53.8,55.14a103.92,103.92,0,0,0-26,45A8,8,0,0,0,33.35,110ZM150,213.22a88,88,0,0,1-44,0,8,8,0,0,0-4,15.49,104.11,104.11,0,0,0,52,0,8,8,0,0,0-4-15.49Zm62.8-108.77a8,8,0,0,0,15.42-4.28,104,104,0,0,0-26-45,8,8,0,1,0-11.41,11.21A88.14,88.14,0,0,1,212.79,104.45Zm15.44,51.39a103.68,103.68,0,0,1-30.68,49.47A8,8,0,0,1,185.07,203a64,64,0,0,0-114.14,0,8,8,0,0,1-12.48,2.32,103.74,103.74,0,0,1-30.68-49.49,8,8,0,0,1,15.42-4.27,87.58,87.58,0,0,0,19,34.88,79.57,79.57,0,0,1,36.1-28.77,48,48,0,1,1,59.38,0,79.57,79.57,0,0,1,36.1,28.77,87.58,87.58,0,0,0,19-34.88,8,8,0,1,1,15.42,4.28ZM128,152a32,32,0,1,0-32-32A32,32,0,0,0,128,152Z" }, null, -1)
  ])]);
}
const wZ = { render: r8 }, bZ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: wZ,
  render: r8
}, Symbol.toStringTag, { value: "Module" })), yZ = {
  viewBox: "0 0 21 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function l8(e, t) {
  return f(), v("svg", yZ, [...t[0] || (t[0] = [
    g("g", { "clip-path": "url(#clip0_576_9404)" }, [
      g("path", {
        d: "M12.1088 12.3187C13.0886 11.7085 13.843 10.7957 14.2578 9.7186C14.6726 8.64146 14.7254 7.45852 14.408 6.34874C14.0907 5.23897 13.4205 4.26273 12.4989 3.56775C11.5774 2.87276 10.4545 2.49683 9.30025 2.49683C8.14599 2.49683 7.02313 2.87276 6.10155 3.56775C5.17997 4.26273 4.50982 5.23897 4.19247 6.34874C3.87513 7.45852 3.92786 8.64146 4.3427 9.7186C4.75753 10.7957 5.51189 11.7085 6.49165 12.3187C4.87837 12.8468 3.42681 13.8335 2.25962 15.2226C2.20494 15.2851 2.16326 15.358 2.13705 15.4368C2.11083 15.5156 2.10059 15.5989 2.10692 15.6817C2.11326 15.7645 2.13605 15.8453 2.17395 15.9192C2.21186 15.9931 2.26412 16.0588 2.32769 16.1122C2.39125 16.1657 2.46484 16.206 2.54415 16.2307C2.62347 16.2555 2.70691 16.2641 2.78961 16.2562C2.87231 16.2483 2.9526 16.224 3.02579 16.1847C3.09898 16.1454 3.1636 16.0919 3.21587 16.0273C4.78462 14.1554 6.94556 13.125 9.29634 13.125C11.6471 13.125 13.8081 14.1554 15.3799 16.0273C15.4866 16.1543 15.6394 16.2337 15.8047 16.2481C15.97 16.2624 16.1342 16.2106 16.2612 16.1039C16.3882 15.9971 16.4676 15.8444 16.482 15.6791C16.4963 15.5138 16.4445 15.3496 16.3377 15.2226C15.1698 13.8335 13.7182 12.8468 12.1088 12.3187ZM5.23384 7.81245C5.23384 7.00896 5.4721 6.22352 5.9185 5.55545C6.36489 4.88737 6.99937 4.36667 7.74169 4.05919C8.48401 3.75171 9.30085 3.67126 10.0889 3.82801C10.8769 3.98476 11.6008 4.37168 12.169 4.93983C12.7371 5.50798 13.124 6.23185 13.2808 7.0199C13.4375 7.80794 13.3571 8.62478 13.0496 9.3671C12.7421 10.1094 12.2214 10.7439 11.5533 11.1903C10.8853 11.6367 10.0998 11.875 9.29634 11.875C8.21928 11.8737 7.18669 11.4453 6.42509 10.6837C5.66349 9.9221 5.23508 8.88951 5.23384 7.81245ZM20.5659 11.1773L20.2018 10.9671C20.2445 10.741 20.2445 10.5089 20.2018 10.2828L20.5659 10.0726C20.637 10.0316 20.6993 9.97693 20.7493 9.91181C20.7993 9.84668 20.8359 9.77235 20.8572 9.69306C20.8784 9.61377 20.8839 9.53107 20.8732 9.44968C20.8625 9.36828 20.8358 9.2898 20.7948 9.2187C20.7537 9.1476 20.6991 9.08528 20.634 9.0353C20.5689 8.98532 20.4945 8.94865 20.4152 8.9274C20.3359 8.90614 20.2532 8.90071 20.1718 8.91142C20.0905 8.92212 20.012 8.94876 19.9409 8.98979L19.576 9.20073C19.4014 9.05093 19.2007 8.93466 18.9838 8.85776V8.43745C18.9838 8.27169 18.918 8.11272 18.8008 7.99551C18.6836 7.8783 18.5246 7.81245 18.3588 7.81245C18.1931 7.81245 18.0341 7.8783 17.9169 7.99551C17.7997 8.11272 17.7338 8.27169 17.7338 8.43745V8.85776C17.517 8.93466 17.3163 9.05093 17.1417 9.20073L16.7768 8.98979C16.7057 8.94876 16.6272 8.92212 16.5458 8.91142C16.4644 8.90071 16.3817 8.90614 16.3025 8.9274C16.2232 8.94865 16.1488 8.98532 16.0837 9.0353C16.0186 9.08528 15.9639 9.1476 15.9229 9.2187C15.8819 9.2898 15.8552 9.36828 15.8445 9.44968C15.8338 9.53107 15.8393 9.61377 15.8605 9.69306C15.8818 9.77235 15.9184 9.84668 15.9684 9.91181C16.0184 9.97693 16.0807 10.0316 16.1518 10.0726L16.5159 10.2828C16.4732 10.5089 16.4732 10.741 16.5159 10.9671L16.1518 11.1773C16.0807 11.2183 16.0184 11.273 15.9684 11.3381C15.9184 11.4032 15.8818 11.4775 15.8605 11.5568C15.8393 11.6361 15.8338 11.7188 15.8445 11.8002C15.8552 11.8816 15.8819 11.9601 15.9229 12.0312C15.9639 12.1023 16.0186 12.1646 16.0837 12.2146C16.1488 12.2646 16.2232 12.3012 16.3025 12.3225C16.3817 12.3438 16.4644 12.3492 16.5458 12.3385C16.6272 12.3278 16.7057 12.3011 16.7768 12.2601L17.1417 12.0492C17.3163 12.199 17.517 12.3152 17.7338 12.3921V12.8125C17.7338 12.9782 17.7997 13.1372 17.9169 13.2544C18.0341 13.3716 18.1931 13.4375 18.3588 13.4375C18.5246 13.4375 18.6836 13.3716 18.8008 13.2544C18.918 13.1372 18.9838 12.9782 18.9838 12.8125V12.3921C19.2007 12.3152 19.4014 12.199 19.576 12.0492L19.9409 12.2601C20.0358 12.3152 20.1436 12.344 20.2534 12.3437C20.391 12.3438 20.5248 12.2984 20.634 12.2146C20.7432 12.1309 20.8217 12.0134 20.8573 11.8804C20.8929 11.7475 20.8837 11.6065 20.831 11.4794C20.7783 11.3522 20.6851 11.2461 20.5659 11.1773ZM17.7338 10.625C17.7338 10.5013 17.7705 10.3805 17.8392 10.2777C17.9078 10.1749 18.0055 10.0948 18.1197 10.0475C18.2339 10.0002 18.3595 9.98784 18.4808 10.012C18.602 10.0361 18.7134 10.0956 18.8008 10.183C18.8882 10.2704 18.9477 10.3818 18.9718 10.503C18.9959 10.6243 18.9836 10.7499 18.9363 10.8641C18.889 10.9783 18.8089 11.0759 18.7061 11.1446C18.6033 11.2133 18.4825 11.25 18.3588 11.25C18.1931 11.25 18.0341 11.1841 17.9169 11.0669C17.7997 10.9497 17.7338 10.7907 17.7338 10.625Z",
        fill: "currentColor"
      })
    ], -1),
    g("defs", null, [
      g("clipPath", { id: "clip0_576_9404" }, [
        g("rect", {
          width: "20",
          height: "20",
          fill: "white",
          transform: "translate(0.858887)"
        })
      ])
    ], -1)
  ])]);
}
const _Z = { render: l8 }, SZ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _Z,
  render: l8
}, Symbol.toStringTag, { value: "Module" })), xZ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256"
};
function a8(e, t) {
  return f(), v("svg", xZ, [...t[0] || (t[0] = [
    Do('<rect width="256" height="256" fill="none"></rect><line x1="200" y1="136" x2="248" y2="136" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></line><line x1="224" y1="112" x2="224" y2="160" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></line><circle cx="108" cy="100" r="60" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></circle><path d="M24,200c20.55-24.45,49.56-40,84-40s63.45,15.55,84,40" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></path>', 5)
  ])]);
}
const MZ = { render: a8 }, AZ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: MZ,
  render: a8
}, Symbol.toStringTag, { value: "Module" })), LZ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256"
};
function c8(e, t) {
  return f(), v("svg", LZ, [...t[0] || (t[0] = [
    g("rect", {
      width: "256",
      height: "256",
      fill: "none"
    }, null, -1),
    g("circle", {
      cx: "128",
      cy: "96",
      r: "64",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1),
    g("path", {
      d: "M32,216c19.37-33.47,54.55-56,96-56s76.63,22.53,96,56",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1)
  ])]);
}
const EZ = { render: c8 }, PZ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: EZ,
  render: c8
}, Symbol.toStringTag, { value: "Module" })), RZ = {
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function d8(e, t) {
  return f(), v("svg", RZ, [...t[0] || (t[0] = [
    g("path", {
      d: "M24 4.5C20.1433 4.5 16.3731 5.64366 13.1664 7.78634C9.95963 9.92903 7.46027 12.9745 5.98436 16.5377C4.50845 20.1008 4.12228 24.0216 4.8747 27.8043C5.62711 31.5869 7.4843 35.0615 10.2114 37.7886C12.9386 40.5157 16.4131 42.3729 20.1957 43.1253C23.9784 43.8777 27.8992 43.4916 31.4623 42.0156C35.0255 40.5397 38.071 38.0404 40.2137 34.8336C42.3564 31.6269 43.5 27.8567 43.5 24C43.4945 18.83 41.4383 13.8732 37.7826 10.2174C34.1268 6.56167 29.1701 4.50546 24 4.5ZM13.89 37.0312C14.9751 35.3342 16.47 33.9375 18.2369 32.9701C20.0037 32.0027 21.9857 31.4956 24 31.4956C26.0144 31.4956 27.9963 32.0027 29.7632 32.9701C31.53 33.9375 33.0249 35.3342 34.11 37.0312C31.2194 39.2794 27.6619 40.4999 24 40.4999C20.3381 40.4999 16.7806 39.2794 13.89 37.0312ZM18 22.5C18 21.3133 18.3519 20.1533 19.0112 19.1666C19.6705 18.1799 20.6076 17.4108 21.7039 16.9567C22.8003 16.5026 24.0067 16.3838 25.1706 16.6153C26.3344 16.8468 27.4035 17.4182 28.2426 18.2574C29.0818 19.0965 29.6532 20.1656 29.8847 21.3295C30.1162 22.4933 29.9974 23.6997 29.5433 24.7961C29.0892 25.8925 28.3201 26.8295 27.3334 27.4888C26.3467 28.1481 25.1867 28.5 24 28.5C22.4087 28.5 20.8826 27.8679 19.7574 26.7426C18.6321 25.6174 18 24.0913 18 22.5ZM36.33 34.9519C34.6571 32.5276 32.3047 30.6522 29.5688 29.5613C31.0384 28.4037 32.1108 26.817 32.6369 25.0217C33.1629 23.2264 33.1164 21.3118 32.5039 19.5441C31.8914 17.7765 30.7432 16.2437 29.2191 15.1588C27.6951 14.0739 25.8708 13.491 24 13.491C22.1292 13.491 20.305 14.0739 18.7809 15.1588C17.2568 16.2437 16.1086 17.7765 15.4961 19.5441C14.8836 21.3118 14.8371 23.2264 15.3631 25.0217C15.8892 26.817 16.9616 28.4037 18.4313 29.5613C15.6953 30.6522 13.3429 32.5276 11.67 34.9519C9.55607 32.5747 8.17439 29.6371 7.69134 26.4928C7.20829 23.3485 7.64447 20.1317 8.94735 17.2296C10.2502 14.3274 12.3643 11.8638 15.0349 10.1354C17.7055 8.40693 20.8189 7.48734 24 7.48734C27.1812 7.48734 30.2945 8.40693 32.9651 10.1354C35.6357 11.8638 37.7498 14.3274 39.0527 17.2296C40.3555 20.1317 40.7917 23.3485 40.3087 26.4928C39.8256 29.6371 38.4439 32.5747 36.33 34.9519Z",
      fill: "currentColor"
    }, null, -1)
  ])]);
}
const FZ = { render: d8 }, TZ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: FZ,
  render: d8
}, Symbol.toStringTag, { value: "Module" })), IZ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 256 256"
};
function u8(e, t) {
  return f(), v("svg", IZ, [...t[0] || (t[0] = [
    g("path", { d: "M244.8,150.4a8,8,0,0,1-11.2-1.6A51.6,51.6,0,0,0,192,128a8,8,0,0,1-7.37-4.89,8,8,0,0,1,0-6.22A8,8,0,0,1,192,112a24,24,0,1,0-23.24-30,8,8,0,1,1-15.5-4A40,40,0,1,1,219,117.51a67.94,67.94,0,0,1,27.43,21.68A8,8,0,0,1,244.8,150.4ZM190.92,212a8,8,0,1,1-13.84,8,57,57,0,0,0-98.16,0,8,8,0,1,1-13.84-8,72.06,72.06,0,0,1,33.74-29.92,48,48,0,1,1,58.36,0A72.06,72.06,0,0,1,190.92,212ZM128,176a32,32,0,1,0-32-32A32,32,0,0,0,128,176ZM72,120a8,8,0,0,0-8-8A24,24,0,1,1,87.24,82a8,8,0,1,0,15.5-4A40,40,0,1,0,37,117.51,67.94,67.94,0,0,0,9.6,139.19a8,8,0,1,0,12.8,9.61A51.6,51.6,0,0,1,64,128,8,8,0,0,0,72,120Z" }, null, -1)
  ])]);
}
const DZ = { render: u8 }, kZ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: DZ,
  render: u8
}, Symbol.toStringTag, { value: "Module" })), HZ = {
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function h8(e, t) {
  return f(), v("svg", HZ, [...t[0] || (t[0] = [
    g("path", {
      d: "M9.16013 12.6598C9.99779 12.1022 10.6338 11.2897 10.974 10.3427C11.3142 9.39563 11.3406 8.36423 11.0493 7.40101C10.758 6.43779 10.1644 5.59388 9.35641 4.99408C8.54838 4.39428 7.56879 4.07043 6.56248 4.07043C5.55617 4.07043 4.57657 4.39428 3.76855 4.99408C2.96053 5.59388 2.36698 6.43779 2.07567 7.40101C1.78437 8.36423 1.81078 9.39563 2.15099 10.3427C2.49121 11.2897 3.12716 12.1022 3.96482 12.6598C2.44958 13.2183 1.15553 14.2517 0.275759 15.6059C0.229521 15.6747 0.197405 15.7519 0.181276 15.8331C0.165147 15.9144 0.165327 15.998 0.181807 16.0792C0.198286 16.1603 0.230736 16.2374 0.27727 16.306C0.323804 16.3745 0.383494 16.4331 0.45287 16.4783C0.522246 16.5236 0.599925 16.5546 0.68139 16.5695C0.762856 16.5845 0.846484 16.5831 0.927412 16.5655C1.00834 16.5478 1.08496 16.5143 1.1528 16.4668C1.22065 16.4193 1.27838 16.3588 1.32263 16.2887C1.89013 15.4159 2.66666 14.6987 3.58173 14.2022C4.49679 13.7056 5.52139 13.4456 6.56248 13.4456C7.60357 13.4456 8.62817 13.7056 9.54323 14.2022C10.4583 14.6987 11.2348 15.4159 11.8023 16.2887C11.894 16.425 12.0356 16.5197 12.1965 16.5524C12.3575 16.585 12.5248 16.553 12.6623 16.4633C12.7999 16.3736 12.8966 16.2334 12.9315 16.0729C12.9665 15.9125 12.9369 15.7447 12.8492 15.6059C11.9694 14.2517 10.6754 13.2183 9.16013 12.6598ZM3.12498 8.75984C3.12498 8.07996 3.32658 7.41536 3.7043 6.85006C4.08202 6.28477 4.61888 5.84418 5.247 5.584C5.87512 5.32382 6.56629 5.25575 7.2331 5.38839C7.89991 5.52102 8.51241 5.84841 8.99316 6.32916C9.4739 6.8099 9.80129 7.4224 9.93393 8.08921C10.0666 8.75602 9.99849 9.44719 9.73831 10.0753C9.47814 10.7034 9.03754 11.2403 8.47225 11.618C7.90696 11.9957 7.24235 12.1973 6.56248 12.1973C5.65111 12.1963 4.77737 11.8338 4.13294 11.1894C3.48851 10.5449 3.12601 9.6712 3.12498 8.75984ZM19.5422 16.4708C19.4033 16.5613 19.2342 16.593 19.0721 16.5588C18.9099 16.5247 18.7679 16.4276 18.6773 16.2887C18.1105 15.4154 17.3341 14.6978 16.4188 14.2015C15.5036 13.7052 14.4786 13.4459 13.4375 13.4473C13.2717 13.4473 13.1127 13.3815 12.9955 13.2643C12.8783 13.1471 12.8125 12.9881 12.8125 12.8223C12.8125 12.6566 12.8783 12.4976 12.9955 12.3804C13.1127 12.2632 13.2717 12.1973 13.4375 12.1973C13.9437 12.1969 14.4436 12.0846 14.9014 11.8685C15.3592 11.6525 15.7636 11.338 16.0858 10.9475C16.4079 10.557 16.6399 10.1002 16.765 9.60966C16.8902 9.11915 16.9055 8.60705 16.8097 8.10995C16.714 7.61285 16.5097 7.14303 16.2114 6.73405C15.9131 6.32507 15.5281 5.98703 15.084 5.74408C14.6399 5.50113 14.1476 5.35927 13.6423 5.32864C13.137 5.298 12.6311 5.37935 12.1609 5.56687C12.0842 5.60001 12.0017 5.61745 11.9182 5.61816C11.8347 5.61886 11.7519 5.60282 11.6746 5.57098C11.5974 5.53914 11.5274 5.49214 11.4686 5.43277C11.4099 5.37339 11.3636 5.30285 11.3326 5.2253C11.3016 5.14775 11.2864 5.06477 11.288 4.98126C11.2896 4.89775 11.3079 4.81541 11.3419 4.7391C11.3758 4.66279 11.4248 4.59405 11.4857 4.53697C11.5467 4.47988 11.6185 4.43559 11.6969 4.40671C12.773 3.97753 13.9699 3.96209 15.0568 4.36336C16.1437 4.76463 17.0434 5.55418 17.5825 6.57969C18.1215 7.60521 18.2617 8.79403 17.976 9.9168C17.6903 11.0396 16.9988 12.0168 16.0351 12.6598C17.5504 13.2183 18.8444 14.2517 19.7242 15.6059C19.8147 15.7448 19.8464 15.9139 19.8123 16.076C19.7781 16.2382 19.681 16.3802 19.5422 16.4708Z",
      fill: "currentColor"
    }, null, -1)
  ])]);
}
const VZ = { render: h8 }, OZ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: VZ,
  render: h8
}, Symbol.toStringTag, { value: "Module" })), BZ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
};
function g8(e, t) {
  return f(), v("svg", BZ, [...t[0] || (t[0] = [
    g("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm-8-80V80a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0Zm20,36a12,12,0,1,1-12-12A12,12,0,0,1,140,172Z" }, null, -1)
  ])]);
}
const $Z = { render: g8 }, ZZ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: $Z,
  render: g8
}, Symbol.toStringTag, { value: "Module" })), GZ = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function p8(e, t) {
  return f(), v("svg", GZ, [...t[0] || (t[0] = [
    g("path", {
      d: "M12.9422 7.94219L10.8836 10L12.9422 12.0578C13.0003 12.1159 13.0463 12.1848 13.0777 12.2607C13.1092 12.3366 13.1254 12.4179 13.1254 12.5C13.1254 12.5821 13.1092 12.6634 13.0777 12.7393C13.0463 12.8152 13.0003 12.8841 12.9422 12.9422C12.8841 13.0003 12.8152 13.0463 12.7393 13.0777C12.6634 13.1092 12.5821 13.1253 12.5 13.1253C12.4179 13.1253 12.3366 13.1092 12.2607 13.0777C12.1848 13.0463 12.1159 13.0003 12.0578 12.9422L10 10.8836L7.94219 12.9422C7.88412 13.0003 7.81518 13.0463 7.73931 13.0777C7.66344 13.1092 7.58213 13.1253 7.5 13.1253C7.41788 13.1253 7.33656 13.1092 7.26069 13.0777C7.18482 13.0463 7.11588 13.0003 7.05782 12.9422C6.99975 12.8841 6.95368 12.8152 6.92226 12.7393C6.89083 12.6634 6.87466 12.5821 6.87466 12.5C6.87466 12.4179 6.89083 12.3366 6.92226 12.2607C6.95368 12.1848 6.99975 12.1159 7.05782 12.0578L9.11641 10L7.05782 7.94219C6.94054 7.82491 6.87466 7.66585 6.87466 7.5C6.87466 7.33415 6.94054 7.17509 7.05782 7.05781C7.17509 6.94054 7.33415 6.87465 7.5 6.87465C7.66586 6.87465 7.82492 6.94054 7.94219 7.05781L10 9.11641L12.0578 7.05781C12.1159 6.99974 12.1848 6.95368 12.2607 6.92225C12.3366 6.89083 12.4179 6.87465 12.5 6.87465C12.5821 6.87465 12.6634 6.89083 12.7393 6.92225C12.8152 6.95368 12.8841 6.99974 12.9422 7.05781C13.0003 7.11588 13.0463 7.18482 13.0777 7.26069C13.1092 7.33656 13.1254 7.41788 13.1254 7.5C13.1254 7.58212 13.1092 7.66344 13.0777 7.73931C13.0463 7.81518 13.0003 7.88412 12.9422 7.94219ZM18.125 10C18.125 11.607 17.6485 13.1779 16.7557 14.514C15.8629 15.8502 14.594 16.8916 13.1093 17.5065C11.6247 18.1215 9.99099 18.2824 8.4149 17.9689C6.8388 17.6554 5.39106 16.8815 4.25476 15.7452C3.11846 14.6089 2.34463 13.1612 2.03112 11.5851C1.71762 10.009 1.87852 8.37535 2.49348 6.8907C3.10844 5.40605 4.14985 4.1371 5.486 3.24431C6.82214 2.35152 8.39303 1.875 10 1.875C12.1542 1.87727 14.2195 2.73403 15.7427 4.25727C17.266 5.78051 18.1227 7.84581 18.125 10ZM16.875 10C16.875 8.64025 16.4718 7.31104 15.7164 6.18045C14.9609 5.04987 13.8872 4.16868 12.631 3.64833C11.3747 3.12798 9.99238 2.99183 8.65876 3.2571C7.32514 3.52237 6.10013 4.17716 5.13864 5.13864C4.17716 6.10013 3.52238 7.32513 3.2571 8.65875C2.99183 9.99237 3.12798 11.3747 3.64833 12.6309C4.16868 13.8872 5.04987 14.9609 6.18046 15.7164C7.31105 16.4718 8.64026 16.875 10 16.875C11.8227 16.8729 13.5702 16.1479 14.8591 14.8591C16.1479 13.5702 16.8729 11.8227 16.875 10Z",
      fill: "currentColor"
    }, null, -1)
  ])]);
}
const NZ = { render: p8 }, zZ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: NZ,
  render: p8
}, Symbol.toStringTag, { value: "Module" })), jZ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256"
};
function f8(e, t) {
  return f(), v("svg", jZ, [...t[0] || (t[0] = [
    g("rect", {
      width: "256",
      height: "256",
      fill: "none"
    }, null, -1),
    g("line", {
      x1: "200",
      y1: "56",
      x2: "56",
      y2: "200",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1),
    g("line", {
      x1: "200",
      y1: "200",
      x2: "56",
      y2: "56",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1)
  ])]);
}
const WZ = { render: f8 }, UZ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: WZ,
  render: f8
}, Symbol.toStringTag, { value: "Module" })), KZ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 16 16"
};
function v8(e, t) {
  return f(), v("svg", KZ, [...t[0] || (t[0] = [
    g("path", {
      "fill-rule": "evenodd",
      d: "M9.2 1.997a1.698 1.698 0 0 0-2.4 0L1.996 6.8a1.698 1.698 0 0 0 0 2.402L6.8 14.003a1.698 1.698 0 0 0 2.402 0L14.003 9.2a1.698 1.698 0 0 0 0-2.402L9.2 1.997ZM7.25 7.25a.75.75 0 1 0 1.5 0v-2.5a.75.75 0 1 0-1.5 0v2.5Zm0 4a.75.75 0 0 0 1.5 0v-.5a.75.75 0 0 0-1.5 0v.5Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const qZ = { render: v8 }, YZ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: qZ,
  render: v8
}, Symbol.toStringTag, { value: "Module" })), QZ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 16 16"
};
function m8(e, t) {
  return f(), v("svg", QZ, [...t[0] || (t[0] = [
    g("path", {
      "fill-rule": "evenodd",
      d: "M8 10a.785.785 0 0 1-.6-.267L5.15 7.067a.606.606 0 0 1-.07-.698A.765.765 0 0 1 5.75 6h4.5c.284 0 .544.143.67.369.128.225.1.496-.07.698L8.6 9.733A.785.785 0 0 1 8 10Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const JZ = { render: m8 }, XZ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: JZ,
  render: m8
}, Symbol.toStringTag, { value: "Module" })), eG = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 16 16"
};
function C8(e, t) {
  return f(), v("svg", eG, [...t[0] || (t[0] = [
    g("path", {
      "fill-rule": "evenodd",
      d: "M8 11a1 1 0 0 1-.8-.4l-3-4A1 1 0 0 1 5 5h6a1 1 0 0 1 .8 1.6l-3 4a1 1 0 0 1-.8.4Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const tG = { render: C8 }, oG = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: tG,
  render: C8
}, Symbol.toStringTag, { value: "Module" })), nG = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 16 16"
};
function w8(e, t) {
  return f(), v("svg", nG, [...t[0] || (t[0] = [
    g("path", {
      "fill-rule": "evenodd",
      d: "M6 8c0 .236.099.458.267.6l2.666 2.25c.202.17.473.198.698.07a.764.764 0 0 0 .369-.67v-4.5a.765.765 0 0 0-.369-.67.606.606 0 0 0-.698.07L6.267 7.4A.785.785 0 0 0 6 8Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const sG = { render: w8 }, iG = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sG,
  render: w8
}, Symbol.toStringTag, { value: "Module" })), rG = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 16 16"
};
function b8(e, t) {
  return f(), v("svg", rG, [...t[0] || (t[0] = [
    g("path", {
      "fill-rule": "evenodd",
      d: "M5 8a1 1 0 0 0 .4.8l4 3A1 1 0 0 0 11 11V5a1 1 0 0 0-1.6-.8l-4 3A1 1 0 0 0 5 8Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const lG = { render: b8 }, aG = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: lG,
  render: b8
}, Symbol.toStringTag, { value: "Module" })), cG = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 16 16"
};
function y8(e, t) {
  return f(), v("svg", cG, [...t[0] || (t[0] = [
    g("path", {
      "fill-rule": "evenodd",
      d: "M10 8a.785.785 0 0 1-.267.6l-2.666 2.25a.606.606 0 0 1-.698.07.764.764 0 0 1-.369-.67v-4.5c0-.284.143-.544.369-.67a.606.606 0 0 1 .698.07L9.733 7.4A.785.785 0 0 1 10 8Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const dG = { render: y8 }, uG = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: dG,
  render: y8
}, Symbol.toStringTag, { value: "Module" })), hG = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 16 16"
};
function _8(e, t) {
  return f(), v("svg", hG, [...t[0] || (t[0] = [
    g("path", {
      "fill-rule": "evenodd",
      d: "M11 8a1 1 0 0 1-.4.8l-4 3A1 1 0 0 1 5 11V5a1 1 0 0 1 1.6-.8l4 3a1 1 0 0 1 .4.8Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const gG = { render: _8 }, pG = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: gG,
  render: _8
}, Symbol.toStringTag, { value: "Module" })), fG = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 16 16"
};
function S8(e, t) {
  return f(), v("svg", fG, [...t[0] || (t[0] = [
    g("path", {
      "fill-rule": "evenodd",
      d: "M8 6c.236 0 .458.099.6.267l2.25 2.666c.17.202.198.473.07.698a.764.764 0 0 1-.67.369h-4.5a.765.765 0 0 1-.67-.369.606.606 0 0 1 .07-.698L7.4 6.267A.785.785 0 0 1 8 6Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const vG = { render: S8 }, mG = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: vG,
  render: S8
}, Symbol.toStringTag, { value: "Module" })), CG = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 16 16"
};
function x8(e, t) {
  return f(), v("svg", CG, [...t[0] || (t[0] = [
    g("path", {
      "fill-rule": "evenodd",
      d: "M8 5a1 1 0 0 1 .8.4l3 4A1 1 0 0 1 11 11H5a1 1 0 0 1-.8-1.6l3-4A1 1 0 0 1 8 5Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const wG = { render: x8 }, bG = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: wG,
  render: x8
}, Symbol.toStringTag, { value: "Module" })), yG = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 16 16"
};
function M8(e, t) {
  return f(), v("svg", yG, [...t[0] || (t[0] = [
    g("path", {
      "fill-rule": "evenodd",
      d: "M7 10H3.626c-.482 0-.783-.5-.54-.9L7.84 2.299C8.161 1.769 9 1.989 9 2.6V6h3.374c.482 0 .783.5.54.9L8.16 13.701c-.321.53-1.16.31-1.16-.302V10Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const _G = { render: M8 }, SG = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _G,
  render: M8
}, Symbol.toStringTag, { value: "Module" })), xG = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 16 16"
};
function A8(e, t) {
  return f(), v("svg", xG, [...t[0] || (t[0] = [
    g("path", {
      "fill-rule": "evenodd",
      d: "M12.721 4.167a.75.75 0 0 1 .113 1.054l-5.25 6.5a.75.75 0 0 1-1.134.04L3.2 8.26a.75.75 0 1 1 1.1-1.02l2.66 2.865 4.706-5.826a.75.75 0 0 1 1.055-.112Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const MG = { render: A8 }, AG = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: MG,
  render: A8
}, Symbol.toStringTag, { value: "Module" })), LG = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 16 16"
};
function L8(e, t) {
  return f(), v("svg", LG, [...t[0] || (t[0] = [
    g("path", {
      "fill-rule": "evenodd",
      d: "M4.24 5.95a.75.75 0 0 1 1.06.04L8 8.898l2.7-2.908a.75.75 0 1 1 1.1 1.02l-3.25 3.5a.75.75 0 0 1-1.1 0L4.2 7.01a.75.75 0 0 1 .04-1.06Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const EG = { render: L8 }, PG = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: EG,
  render: L8
}, Symbol.toStringTag, { value: "Module" })), RG = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 16 16"
};
function E8(e, t) {
  return f(), v("svg", RG, [...t[0] || (t[0] = [
    g("path", {
      "fill-rule": "evenodd",
      d: "M10.3 4.49a.75.75 0 0 1-.04 1.06l-2.908 2.7 2.908 2.7a.75.75 0 1 1-1.02 1.1L5.74 8.8a.75.75 0 0 1 0-1.1l3.5-3.25a.75.75 0 0 1 1.06.04Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const FG = { render: E8 }, TG = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: FG,
  render: E8
}, Symbol.toStringTag, { value: "Module" })), IG = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 16 16"
};
function P8(e, t) {
  return f(), v("svg", IG, [...t[0] || (t[0] = [
    g("path", {
      "fill-rule": "evenodd",
      d: "M5.7 3.99a.75.75 0 0 1 1.06-.04l3.5 3.25a.75.75 0 0 1 0 1.1l-3.5 3.25a.75.75 0 1 1-1.02-1.1l2.908-2.7-2.908-2.7a.75.75 0 0 1-.04-1.06Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const DG = { render: P8 }, kG = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: DG,
  render: P8
}, Symbol.toStringTag, { value: "Module" })), HG = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 16 16"
};
function R8(e, t) {
  return f(), v("svg", HG, [...t[0] || (t[0] = [
    g("path", {
      "fill-rule": "evenodd",
      d: "M8 5.25a.75.75 0 0 1 .55.24l3.25 3.5a.75.75 0 1 1-1.1 1.02L8 7.102 5.3 10.01a.75.75 0 1 1-1.1-1.02l3.25-3.5A.75.75 0 0 1 8 5.25Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const VG = { render: R8 }, OG = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: VG,
  render: R8
}, Symbol.toStringTag, { value: "Module" })), BG = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 16 16"
};
function F8(e, t) {
  return f(), v("svg", BG, [...t[0] || (t[0] = [
    g("path", {
      "fill-rule": "evenodd",
      d: "M4.22 4.22a.75.75 0 0 1 1.06 0L8 6.94l2.72-2.72a.75.75 0 1 1 1.06 1.06L9.06 8l2.72 2.72a.75.75 0 1 1-1.06 1.06L8 9.06l-2.72 2.72a.75.75 0 0 1-1.06-1.06L6.94 8 4.22 5.28a.75.75 0 0 1 0-1.06Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const $G = { render: F8 }, ZG = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: $G,
  render: F8
}, Symbol.toStringTag, { value: "Module" })), GG = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 16 16"
};
function T8(e, t) {
  return f(), v("svg", GG, [...t[0] || (t[0] = [
    g("circle", {
      cx: "8",
      cy: "8",
      r: "4"
    }, null, -1)
  ])]);
}
const NG = { render: T8 }, zG = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: NG,
  render: T8
}, Symbol.toStringTag, { value: "Module" })), jG = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 16 16"
};
function I8(e, t) {
  return f(), v("svg", jG, [...t[0] || (t[0] = [
    g("path", {
      "fill-rule": "evenodd",
      d: "M8 2a6 6 0 1 1 0 12A6 6 0 0 1 8 2Zm0 6a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0v-2.5A.75.75 0 0 1 8 8Zm0-4a.75.75 0 0 1 .75.75v.5a.75.75 0 0 1-1.5 0v-.5A.75.75 0 0 1 8 4Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const WG = { render: I8 }, UG = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: WG,
  render: I8
}, Symbol.toStringTag, { value: "Module" })), KG = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 16 16"
};
function D8(e, t) {
  return f(), v("svg", KG, [...t[0] || (t[0] = [
    g("path", {
      "fill-rule": "evenodd",
      d: "M3 8a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5A.75.75 0 0 1 3 8Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const qG = { render: D8 }, YG = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: qG,
  render: D8
}, Symbol.toStringTag, { value: "Module" })), QG = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 16 16"
};
function k8(e, t) {
  return f(), v("svg", QG, [...t[0] || (t[0] = [
    g("path", {
      "fill-rule": "evenodd",
      d: "M8 3a.75.75 0 0 1 .75.75v3.5h3.5a.75.75 0 0 1 0 1.5h-3.5v3.5a.75.75 0 0 1-1.5 0v-3.5h-3.5a.75.75 0 0 1 0-1.5h3.5v-3.5A.75.75 0 0 1 8 3Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const JG = { render: k8 }, XG = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: JG,
  render: k8
}, Symbol.toStringTag, { value: "Module" })), eN = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function H8(e, t) {
  return f(), v("svg", eN, [...t[0] || (t[0] = [
    g("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M4 0C1.79086 0 0 1.79086 0 4V16C0 18.2091 1.79086 20 4 20H16C18.2091 20 20 18.2091 20 16V4C20 1.79086 18.2091 0 16 0H4ZM4.75 5C4.33579 5 4 5.33579 4 5.75C4 6.16421 4.33579 6.5 4.75 6.5H10.25C10.6642 6.5 11 6.16421 11 5.75C11 5.33579 10.6642 5 10.25 5H4.75ZM4.75 9.5C4.33579 9.5 4 9.83579 4 10.25C4 10.6642 4.33579 11 4.75 11H15.25C15.6642 11 16 10.6642 16 10.25C16 9.83579 15.6642 9.5 15.25 9.5H4.75ZM4.75 13.5C4.33579 13.5 4 13.8358 4 14.25C4 14.6642 4.33579 15 4.75 15H15.25C15.6642 15 16 14.6642 16 14.25C16 13.8358 15.6642 13.5 15.25 13.5H4.75Z",
      fill: "#3062D4"
    }, null, -1)
  ])]);
}
const tN = { render: H8 }, oN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: tN,
  render: H8
}, Symbol.toStringTag, { value: "Module" })), nN = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function V8(e, t) {
  return f(), v("svg", nN, [...t[0] || (t[0] = [
    g("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M4 0C1.79086 0 0 1.79086 0 4V16C0 18.2091 1.79086 20 4 20H16C18.2091 20 20 18.2091 20 16V4C20 1.79086 18.2091 0 16 0H4ZM7.34581 5.29445C7.09419 4.96542 6.62349 4.90266 6.29445 5.15427C5.96542 5.40588 5.90266 5.87659 6.15427 6.20563L9.05588 10L6.15427 13.7945C5.90266 14.1235 5.96542 14.5942 6.29445 14.8458C6.62349 15.0974 7.09419 15.0347 7.34581 14.7056L10 11.2347L12.6543 14.7056C12.9059 15.0347 13.3766 15.0974 13.7056 14.8458C14.0347 14.5942 14.0974 14.1235 13.8458 13.7945L10.9442 10L13.8458 6.20563C14.0974 5.87659 14.0347 5.40588 13.7056 5.15427C13.3766 4.90266 12.9059 4.96542 12.6543 5.29445L10 8.76537L7.34581 5.29445Z",
      fill: "#1D7C4D"
    }, null, -1)
  ])]);
}
const sN = { render: V8 }, iN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sN,
  render: V8
}, Symbol.toStringTag, { value: "Module" })), rN = {
  viewBox: "0 0 12 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function O8(e, t) {
  return f(), v("svg", rN, [...t[0] || (t[0] = [
    g("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M0 3.5C0 1.567 1.50432 0 3.36 0H8.64C10.4957 0 12 1.567 12 3.5C12 4.61548 11.499 5.60909 10.7187 6.25C11.499 6.89092 12 7.88452 12 9C12 10.933 10.4957 12.5 8.64 12.5C7.92612 12.5 7.26424 12.2681 6.72 11.8727V14.5C6.72 16.433 5.21568 18 3.36 18C1.50432 18 0 16.433 0 14.5C0 13.3845 0.500962 12.3909 1.28132 11.75C0.500962 11.1091 0 10.1155 0 9C0 7.88452 0.500961 6.89092 1.28131 6.25C0.500961 5.60908 0 4.61548 0 3.5ZM3.36 7C2.29961 7 1.44 7.89543 1.44 9C1.44 10.1046 2.29961 11 3.36 11H5.28V7H3.36ZM5.28 5.5H3.36C2.29961 5.5 1.44 4.60457 1.44 3.5C1.44 2.39543 2.29961 1.5 3.36 1.5H5.28V5.5ZM8.64 5.5C9.70039 5.5 10.56 4.60457 10.56 3.5C10.56 2.39543 9.70039 1.5 8.64 1.5H6.72V5.5H8.64ZM8.64 7C7.57961 7 6.72 7.89543 6.72 9C6.72 10.1046 7.57961 11 8.64 11C9.70039 11 10.56 10.1046 10.56 9C10.56 7.89543 9.70039 7 8.64 7ZM5.28 12.5H3.36C2.29961 12.5 1.44 13.3954 1.44 14.5C1.44 15.6046 2.29961 16.5 3.36 16.5C4.42039 16.5 5.28 15.6046 5.28 14.5V12.5Z",
      fill: "#8040BF"
    }, null, -1)
  ])]);
}
const lN = { render: O8 }, aN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: lN,
  render: O8
}, Symbol.toStringTag, { value: "Module" })), cN = {
  viewBox: "0 0 16 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function B8(e, t) {
  return f(), v("svg", cN, [...t[0] || (t[0] = [
    g("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2.75 1.5C2.05964 1.5 1.5 2.05964 1.5 2.75V17.25C1.5 17.9404 2.05964 18.5 2.75 18.5H13.25C13.9404 18.5 14.5 17.9404 14.5 17.25V6.06066L9.93934 1.5H2.75ZM0 2.75C0 1.23122 1.23122 0 2.75 0H10.25C10.4489 0 10.6397 0.0790176 10.7803 0.21967L15.7803 5.21967C15.921 5.36032 16 5.55109 16 5.75V17.25C16 18.7688 14.7688 20 13.25 20H2.75C1.23122 20 0 18.7688 0 17.25V2.75Z",
      fill: "#555F6D"
    }, null, -1)
  ])]);
}
const dN = { render: B8 }, uN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: dN,
  render: B8
}, Symbol.toStringTag, { value: "Module" })), hN = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function $8(e, t) {
  return f(), v("svg", hN, [...t[0] || (t[0] = [
    g("path", {
      d: "M3.5 7.5V9.80769H4.5C4.99404 9.80769 5.5 9.35184 5.5 8.65385C5.5 7.95585 4.99404 7.5 4.5 7.5H3.5Z",
      fill: "#C53434"
    }, null, -1),
    g("path", {
      d: "M9.25 7.5V12.5H9.75C10.3485 12.5 10.8284 12.2132 11.1821 11.7435C11.5461 11.2599 11.75 10.6084 11.75 10C11.75 9.39157 11.5461 8.74007 11.1821 8.25654C10.8284 7.78679 10.3485 7.5 9.75 7.5H9.25Z",
      fill: "#C53434"
    }, null, -1),
    g("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M4 0C1.79086 0 0 1.79086 0 4V16C0 18.2091 1.79086 20 4 20H16C18.2091 20 20 18.2091 20 16V4C20 1.79086 18.2091 0 16 0H4ZM2 6.75C2 6.33579 2.33579 6 2.75 6H4.5C5.93895 6 7 7.24891 7 8.65385C7 10.0588 5.93895 11.3077 4.5 11.3077H3.5V13.25C3.5 13.6642 3.16421 14 2.75 14C2.33579 14 2 13.6642 2 13.25V6.75ZM7.75 6.75C7.75 6.33579 8.08579 6 8.5 6H9.75C10.9015 6 11.7966 6.57882 12.3804 7.35437C12.9539 8.11615 13.25 9.08965 13.25 10C13.25 10.9104 12.9539 11.8839 12.3804 12.6456C11.7966 13.4212 10.9015 14 9.75 14H8.5C8.08579 14 7.75 13.6642 7.75 13.25V6.75ZM14.75 6C14.3358 6 14 6.33579 14 6.75V13.25C14 13.6642 14.3358 14 14.75 14C15.1642 14 15.5 13.6642 15.5 13.25V10.4615H17.25C17.6642 10.4615 18 10.1258 18 9.71154C18 9.29733 17.6642 8.96154 17.25 8.96154H15.5V7.5H17.25C17.6642 7.5 18 7.16421 18 6.75C18 6.33579 17.6642 6 17.25 6H14.75Z",
      fill: "#C53434"
    }, null, -1)
  ])]);
}
const gN = { render: $8 }, pN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: gN,
  render: $8
}, Symbol.toStringTag, { value: "Module" })), fN = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Z8(e, t) {
  return f(), v("svg", fN, [...t[0] || (t[0] = [
    g("path", {
      d: "M7 10.5H5.5V7.5H7C7.82843 7.5 8.5 8.17157 8.5 9C8.5 9.82843 7.82843 10.5 7 10.5Z",
      fill: "#3062D4"
    }, null, -1),
    g("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M4 0C1.79086 0 0 1.79086 0 4V16C0 18.2091 1.79086 20 4 20H16C18.2091 20 20 18.2091 20 16V4C20 1.79086 18.2091 0 16 0H4ZM11.5 8.375C11.5 7.89175 11.8918 7.5 12.375 7.5H13.25C13.973 7.5 14.286 7.70214 14.408 7.81056C14.4754 7.87048 14.5094 7.92374 14.5241 7.95096C14.5279 7.95787 14.5304 7.96317 14.5319 7.96652C14.6465 8.34765 15.0417 8.57515 15.4319 8.47761C15.8337 8.37714 16.0781 7.96994 15.9776 7.5681L15.25 7.75C15.9776 7.5681 15.9773 7.56692 15.9773 7.56692L15.977 7.56571L15.9764 7.56321L15.975 7.55791L15.9718 7.5461C15.9694 7.53769 15.9667 7.52823 15.9635 7.51779C15.957 7.4969 15.9487 7.472 15.9381 7.44369C15.9169 7.38713 15.8863 7.31639 15.8431 7.23654C15.7562 7.07626 15.6184 6.87952 15.4045 6.68944C14.964 6.29786 14.277 6 13.25 6H12.375C11.0633 6 10 7.06332 10 8.375C10 9.18487 10.5505 9.78954 11.0816 10.1465C11.6314 10.5161 12.3378 10.75 13 10.75C13.3378 10.75 13.7564 10.8798 14.0816 11.0984C14.4255 11.3296 14.5 11.5374 14.5 11.625C14.5 12.1082 14.1082 12.5 13.625 12.5H12.75C12.027 12.5 11.714 12.2979 11.592 12.1894C11.5246 12.1295 11.4906 12.0763 11.4759 12.049C11.4735 12.0446 11.4716 12.0409 11.4702 12.0379L11.4681 12.0335C11.3535 11.6523 10.9583 11.4249 10.5681 11.5224C10.1663 11.6229 9.92193 12.0301 10.0224 12.4319L10.75 12.25C10.0224 12.4319 10.0227 12.4331 10.0227 12.4331L10.023 12.4343L10.0236 12.4368L10.025 12.4421L10.0282 12.4539C10.0306 12.4623 10.0333 12.4718 10.0365 12.4822C10.043 12.5031 10.0513 12.528 10.0619 12.5563C10.0831 12.6129 10.1137 12.6836 10.1569 12.7635C10.2438 12.9237 10.3816 13.1205 10.5955 13.3106C11.036 13.7021 11.723 14 12.75 14H13.625C14.9367 14 16 12.9367 16 11.625C16 10.8151 15.4495 10.2105 14.9184 9.85349C14.3686 9.48394 13.6622 9.24999 13 9.24999C12.6622 9.24999 12.2436 9.12016 11.9184 8.90158C11.5745 8.67042 11.5 8.4626 11.5 8.375ZM4.75 6C4.33579 6 4 6.33579 4 6.75V13.25C4 13.6642 4.33579 14 4.75 14C5.16421 14 5.5 13.6642 5.5 13.25V12H7C8.65685 12 10 10.6569 10 9C10 7.34315 8.65685 6 7 6H4.75Z",
      fill: "#3062D4"
    }, null, -1)
  ])]);
}
const vN = { render: Z8 }, mN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: vN,
  render: Z8
}, Symbol.toStringTag, { value: "Module" })), CN = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function G8(e, t) {
  return f(), v("svg", CN, [...t[0] || (t[0] = [
    g("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M4 0C1.79086 0 0 1.79086 0 4V16C0 18.2091 1.79086 20 4 20H16C18.2091 20 20 18.2091 20 16V4C20 1.79086 18.2091 0 16 0H4ZM4.90856 4.24299C4.68948 4.44666 4.53036 4.72704 4.21212 5.28782L3.46124 6.61095C3.03703 7.35844 2.82493 7.73219 2.77024 8.1223C2.72197 8.46655 2.7604 8.81817 2.88164 9.14172C3.01903 9.50836 3.30615 9.82112 3.8804 10.4467L7.85019 14.771C8.60049 15.5883 8.97564 15.9969 9.41076 16.1494C9.79335 16.2835 10.2066 16.2835 10.5892 16.1494C11.0244 15.9969 11.3995 15.5883 12.1498 14.771L16.1196 10.4467C16.6938 9.82112 16.981 9.50836 17.1184 9.14172C17.2396 8.81817 17.278 8.46655 17.2298 8.1223C17.1751 7.73219 16.963 7.35844 16.5388 6.61095L15.7879 5.28782C15.4696 4.72705 15.3105 4.44666 15.0914 4.24299C14.8976 4.06276 14.6706 3.92686 14.4246 3.84383C14.1467 3.75 13.8375 3.75 13.2189 3.75H6.78109C6.16255 3.75 5.85327 3.75 5.57537 3.84383C5.32945 3.92686 5.10242 4.06276 4.90856 4.24299Z",
      fill: "#F59638"
    }, null, -1)
  ])]);
}
const wN = { render: G8 }, bN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: wN,
  render: G8
}, Symbol.toStringTag, { value: "Module" })), yN = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function N8(e, t) {
  return f(), v("svg", yN, [...t[0] || (t[0] = [
    g("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M4 0C1.79086 0 0 1.79086 0 4V16C0 18.2091 1.79086 20 4 20H16C18.2091 20 20 18.2091 20 16V4C20 1.79086 18.2091 0 16 0H4ZM8.5 2.75C8.5 2.33579 8.16421 2 7.75 2C7.33579 2 7 2.33579 7 2.75V7H2.75C2.33579 7 2 7.33579 2 7.75C2 8.16421 2.33579 8.5 2.75 8.5H7V17.25C7 17.6642 7.33579 18 7.75 18C8.16421 18 8.5 17.6642 8.5 17.25V8.5H17.25C17.6642 8.5 18 8.16421 18 7.75C18 7.33579 17.6642 7 17.25 7H8.5V2.75Z",
      fill: "#1D7C4D"
    }, null, -1)
  ])]);
}
const _N = { render: N8 }, SN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _N,
  render: N8
}, Symbol.toStringTag, { value: "Module" })), xN = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function z8(e, t) {
  return f(), v("svg", xN, [...t[0] || (t[0] = [
    g("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M4 0C1.79086 0 0 1.79086 0 4V16C0 18.2091 1.79086 20 4 20H16C18.2091 20 20 18.2091 20 16V4C20 1.79086 18.2091 0 16 0H4ZM6.46679 6.52939C6.34497 6.13349 5.92529 5.91131 5.52939 6.03312C5.13349 6.15494 4.91131 6.57462 5.03312 6.97052L7.03312 13.4705C7.12131 13.7571 7.37174 13.9637 7.6699 13.9957C7.96806 14.0277 8.25662 13.879 8.40364 13.6177L9.99996 10.7798L11.5963 13.6177C11.7433 13.879 12.0319 14.0277 12.33 13.9957C12.6282 13.9637 12.8786 13.7571 12.9668 13.4705L14.9668 6.97052C15.0886 6.57462 14.8664 6.15494 14.4705 6.03312C14.0746 5.91131 13.6549 6.13349 13.5331 6.52939L12.047 11.3593L10.6536 8.88226C10.5208 8.6461 10.2709 8.49996 9.99996 8.49996C9.729 8.49996 9.47911 8.6461 9.34627 8.88226L7.95292 11.3593L6.46679 6.52939Z",
      fill: "#3062D4"
    }, null, -1)
  ])]);
}
const MN = { render: z8 }, AN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: MN,
  render: z8
}, Symbol.toStringTag, { value: "Module" })), LN = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function j8(e, t) {
  return f(), v("svg", LN, [...t[0] || (t[0] = [
    g("path", {
      d: "M4 0C1.79086 0 0 1.79086 0 4V16C0 18.2091 1.79086 20 4 20H16C18.2091 20 20 18.2091 20 16V4C20 1.79086 18.2091 0 16 0H5.5L5.5 2H8.25C8.66421 2 9 2.33579 9 2.75V6.75C9 7.16421 8.66421 7.5 8.25 7.5H5.5V10H8.25C8.66421 10 9 10.3358 9 10.75V15.25C9 15.6642 8.66421 16 8.25 16H4.75C4.33579 16 4 15.6642 4 15.25V6.75C4 6.33579 4.33579 6 4.75 6H7.5V3.5H4.75C4.55109 3.5 4.36032 3.42098 4.21967 3.28033C4.07902 3.13968 4 2.94891 4 2.75V0Z",
      fill: "#555F6D"
    }, null, -1),
    g("path", {
      d: "M5.5 14.5V11.5H7.5V14.5H5.5Z",
      fill: "#555F6D"
    }, null, -1)
  ])]);
}
const EN = { render: j8 }, PN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: EN,
  render: j8
}, Symbol.toStringTag, { value: "Module" })), RN = {
  viewBox: "0 0 32 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function W8(e, t) {
  return f(), v("svg", RN, [...t[0] || (t[0] = [
    g("path", {
      d: "M0.75 6.75C0.75 3.43629 3.43629 0.75 6.75 0.75H20.9216C21.452 0.75 21.9607 0.960714 22.3358 1.33579L30.6642 9.66421C31.0393 10.0393 31.25 10.548 31.25 11.0784V33.25C31.25 36.5637 28.5637 39.25 25.25 39.25H6.75C3.43629 39.25 0.75 36.5637 0.75 33.25V6.75Z",
      fill: "white"
    }, null, -1),
    g("path", {
      d: "M9.75 20.75V25.25H12C13.2426 25.25 14.25 24.2426 14.25 23C14.25 21.7574 13.2426 20.75 12 20.75H9.75Z",
      fill: "white"
    }, null, -1),
    g("path", {
      d: "M22.3358 1.33579L21.8055 1.86612V1.86612L22.3358 1.33579ZM30.6642 9.66421L30.1339 10.1945L30.6642 9.66421ZM9 27.25C9 27.6642 9.33579 28 9.75 28C10.1642 28 10.5 27.6642 10.5 27.25H9ZM9.75 20.75V20C9.33579 20 9 20.3358 9 20.75H9.75ZM21.5224 21.9319C21.6229 22.3337 22.0301 22.5781 22.4319 22.4776C22.8337 22.3771 23.0781 21.9699 22.9776 21.5681L21.5224 21.9319ZM18.4776 26.0681C18.3771 25.6663 17.9699 25.4219 17.5681 25.5224C17.1663 25.6229 16.9219 26.0301 17.0224 26.4319L18.4776 26.0681ZM1.5 6.75C1.5 3.85051 3.85051 1.5 6.75 1.5V0C3.02208 0 0 3.02208 0 6.75H1.5ZM6.75 1.5H20.9216V0H6.75V1.5ZM20.9216 1.5C21.2531 1.5 21.571 1.6317 21.8055 1.86612L22.8661 0.805457C22.3504 0.289731 21.6509 0 20.9216 0V1.5ZM21.8055 1.86612L30.1339 10.1945L31.1945 9.13388L22.8661 0.805456L21.8055 1.86612ZM30.1339 10.1945C30.3683 10.429 30.5 10.7469 30.5 11.0784H32C32 10.3491 31.7103 9.64961 31.1945 9.13388L30.1339 10.1945ZM30.5 11.0784V33.25H32V11.0784H30.5ZM30.5 33.25C30.5 36.1495 28.1495 38.5 25.25 38.5V40C28.9779 40 32 36.9779 32 33.25H30.5ZM25.25 38.5H6.75V40H25.25V38.5ZM6.75 38.5C3.85051 38.5 1.5 36.1495 1.5 33.25H0C0 36.9779 3.02208 40 6.75 40V38.5ZM1.5 33.25V6.75H0V33.25H1.5ZM10.5 27.25V25.25H9V27.25H10.5ZM10.5 25.25V20.75H9V25.25H10.5ZM9.75 21.5H12V20H9.75V21.5ZM12 24.5H9.75V26H12V24.5ZM13.5 23C13.5 23.8284 12.8284 24.5 12 24.5V26C13.6569 26 15 24.6569 15 23H13.5ZM12 21.5C12.8284 21.5 13.5 22.1716 13.5 23H15C15 21.3431 13.6569 20 12 20V21.5ZM20 23.25C19.6622 23.25 19.2436 23.1202 18.9184 22.9016C18.5745 22.6704 18.5 22.4626 18.5 22.375H17C17 23.1849 17.5505 23.7895 18.0816 24.1465C18.6314 24.5161 19.3378 24.75 20 24.75V23.25ZM18.5 22.375C18.5 21.8918 18.8918 21.5 19.375 21.5V20C18.0633 20 17 21.0633 17 22.375H18.5ZM21.5 25.625C21.5 26.1082 21.1082 26.5 20.625 26.5V28C21.9367 28 23 26.9367 23 25.625H21.5ZM20 24.75C20.3378 24.75 20.7564 24.8798 21.0816 25.0984C21.4255 25.3296 21.5 25.5374 21.5 25.625H23C23 24.8151 22.4495 24.2105 21.9184 23.8535C21.3686 23.4839 20.6622 23.25 20 23.25V24.75ZM19.375 21.5H20.25V20H19.375V21.5ZM20.25 21.5C20.973 21.5 21.286 21.7021 21.408 21.8106C21.4754 21.8705 21.5094 21.9237 21.5241 21.951C21.5317 21.9649 21.5343 21.9722 21.5336 21.9704C21.5332 21.9694 21.532 21.966 21.5301 21.9598C21.5291 21.9566 21.528 21.9528 21.5267 21.9482C21.526 21.9459 21.5254 21.9433 21.5246 21.9406C21.5243 21.9393 21.5239 21.9379 21.5235 21.9364C21.5234 21.9357 21.5232 21.935 21.523 21.9342C21.5229 21.9338 21.5227 21.9333 21.5227 21.9331C21.5225 21.9325 21.5224 21.9319 22.25 21.75C22.9776 21.5681 22.9775 21.5675 22.9773 21.5669C22.9773 21.5667 22.9771 21.5661 22.977 21.5657C22.9768 21.5649 22.9766 21.5641 22.9764 21.5632C22.9759 21.5615 22.9755 21.5597 22.975 21.5579C22.974 21.5542 22.973 21.5503 22.9718 21.5461C22.9694 21.5377 22.9667 21.5282 22.9635 21.5178C22.957 21.4969 22.9487 21.472 22.9381 21.4437C22.9169 21.3871 22.8863 21.3164 22.8431 21.2365C22.7562 21.0763 22.6184 20.8795 22.4045 20.6894C21.964 20.2979 21.277 20 20.25 20V21.5ZM20.625 26.5H19.75V28H20.625V26.5ZM19.75 26.5C19.027 26.5 18.714 26.2979 18.592 26.1894C18.5246 26.1295 18.4906 26.0763 18.4759 26.049C18.4683 26.0351 18.4657 26.0278 18.4664 26.0296C18.4668 26.0306 18.468 26.034 18.4699 26.0402C18.4709 26.0434 18.472 26.0472 18.4733 26.0518C18.474 26.0541 18.4746 26.0567 18.4754 26.0594C18.4757 26.0607 18.4761 26.0621 18.4765 26.0636C18.4766 26.0643 18.4768 26.065 18.477 26.0658C18.4771 26.0662 18.4773 26.0667 18.4773 26.0669C18.4775 26.0675 18.4776 26.0681 17.75 26.25C17.0224 26.4319 17.0225 26.4325 17.0227 26.4331C17.0227 26.4333 17.0229 26.4339 17.023 26.4343C17.0232 26.4351 17.0234 26.4359 17.0236 26.4368C17.0241 26.4385 17.0245 26.4403 17.025 26.4421C17.026 26.4458 17.027 26.4497 17.0282 26.4539C17.0306 26.4623 17.0333 26.4718 17.0365 26.4822C17.043 26.5031 17.0513 26.528 17.0619 26.5563C17.0831 26.6129 17.1137 26.6836 17.1569 26.7635C17.2438 26.9237 17.3816 27.1205 17.5955 27.3106C18.036 27.7021 18.723 28 19.75 28V26.5Z",
      fill: "#3062D4"
    }, null, -1)
  ])]);
}
const FN = { render: W8 }, TN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: FN,
  render: W8
}, Symbol.toStringTag, { value: "Module" })), IN = {
  viewBox: "0 0 32 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function U8(e, t) {
  return f(), v("svg", IN, [...t[0] || (t[0] = [
    g("path", {
      d: "M0.75 6.75C0.75 3.43629 3.43629 0.75 6.75 0.75H20.9216C21.452 0.75 21.9607 0.960714 22.3358 1.33579L30.6642 9.66421C31.0393 10.0393 31.25 10.548 31.25 11.0784V33.25C31.25 36.5637 28.5637 39.25 25.25 39.25H6.75C3.43629 39.25 0.75 36.5637 0.75 33.25V6.75Z",
      fill: "white"
    }, null, -1),
    g("path", {
      d: "M8.75 17.75H16.25M8.75 22.25H23.25M8.75 26.75H23.25M8.75 31.25H23.25M0.75 6.75C0.75 3.43629 3.43629 0.75 6.75 0.75H20.9216C21.452 0.75 21.9607 0.960714 22.3358 1.33579L30.6642 9.66421C31.0393 10.0393 31.25 10.548 31.25 11.0784V33.25C31.25 36.5637 28.5637 39.25 25.25 39.25H6.75C3.43629 39.25 0.75 36.5637 0.75 33.25V6.75Z",
      stroke: "#3062D4",
      "stroke-width": "1.5",
      "stroke-linecap": "round"
    }, null, -1)
  ])]);
}
const DN = { render: U8 }, kN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: DN,
  render: U8
}, Symbol.toStringTag, { value: "Module" })), HN = {
  viewBox: "0 0 32 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function K8(e, t) {
  return f(), v("svg", HN, [...t[0] || (t[0] = [
    g("path", {
      d: "M0.75 6.75C0.75 3.43629 3.43629 0.75 6.75 0.75H20.9216C21.452 0.75 21.9607 0.960714 22.3358 1.33579L30.6642 9.66421C31.0393 10.0393 31.25 10.548 31.25 11.0784V33.25C31.25 36.5637 28.5637 39.25 25.25 39.25H6.75C3.43629 39.25 0.75 36.5637 0.75 33.25V6.75Z",
      fill: "white"
    }, null, -1),
    g("path", {
      d: "M22.3358 1.33579L21.8055 1.86612V1.86612L22.3358 1.33579ZM30.6642 9.66421L30.1339 10.1945L30.6642 9.66421ZM18.8666 21.1769C19.1024 20.8363 19.0175 20.3691 18.6769 20.1334C18.3363 19.8976 17.8691 19.9825 17.6334 20.3231L18.8666 21.1769ZM13.1334 26.8231C12.8976 27.1637 12.9825 27.6309 13.3231 27.8666C13.6637 28.1024 14.1309 28.0175 14.3666 27.6769L13.1334 26.8231ZM14.3666 20.3231C14.1309 19.9825 13.6637 19.8976 13.3231 20.1334C12.9825 20.3691 12.8976 20.8363 13.1334 21.1769L14.3666 20.3231ZM17.6334 27.6769C17.8691 28.0175 18.3363 28.1024 18.6769 27.8666C19.0175 27.6309 19.1024 27.1637 18.8666 26.8231L17.6334 27.6769ZM1.5 6.75C1.5 3.85051 3.85051 1.5 6.75 1.5V0C3.02208 0 0 3.02208 0 6.75H1.5ZM6.75 1.5H20.9216V0H6.75V1.5ZM20.9216 1.5C21.2531 1.5 21.571 1.6317 21.8055 1.86612L22.8661 0.805457C22.3504 0.289731 21.6509 0 20.9216 0V1.5ZM21.8055 1.86612L30.1339 10.1945L31.1945 9.13388L22.8661 0.805456L21.8055 1.86612ZM30.1339 10.1945C30.3683 10.429 30.5 10.7469 30.5 11.0784H32C32 10.3491 31.7103 9.64961 31.1945 9.13388L30.1339 10.1945ZM30.5 11.0784V33.25H32V11.0784H30.5ZM30.5 33.25C30.5 36.1495 28.1495 38.5 25.25 38.5V40C28.9779 40 32 36.9779 32 33.25H30.5ZM25.25 38.5H6.75V40H25.25V38.5ZM6.75 38.5C3.85051 38.5 1.5 36.1495 1.5 33.25H0C0 36.9779 3.02208 40 6.75 40V38.5ZM1.5 33.25V6.75H0V33.25H1.5ZM17.6334 20.3231L15.3834 23.5731L16.6166 24.4269L18.8666 21.1769L17.6334 20.3231ZM15.3834 23.5731L13.1334 26.8231L14.3666 27.6769L16.6166 24.4269L15.3834 23.5731ZM13.1334 21.1769L15.3834 24.4269L16.6166 23.5731L14.3666 20.3231L13.1334 21.1769ZM15.3834 24.4269L17.6334 27.6769L18.8666 26.8231L16.6166 23.5731L15.3834 24.4269Z",
      fill: "#1D7C4D"
    }, null, -1)
  ])]);
}
const VN = { render: K8 }, ON = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: VN,
  render: K8
}, Symbol.toStringTag, { value: "Module" })), BN = {
  viewBox: "0 0 32 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function q8(e, t) {
  return f(), v("svg", BN, [...t[0] || (t[0] = [
    Do('<path d="M0.75 6.75C0.75 3.43629 3.43629 0.75 6.75 0.75H20.9216C21.452 0.75 21.9607 0.960714 22.3358 1.33579L30.6642 9.66421C31.0393 10.0393 31.25 10.548 31.25 11.0784V33.25C31.25 36.5637 28.5637 39.25 25.25 39.25H6.75C3.43629 39.25 0.75 36.5637 0.75 33.25V6.75Z" fill="white"></path><path d="M10.5 31.25C10.5 29.7312 11.7312 28.5 13.25 28.5H16V31.25C16 32.7688 14.7688 34 13.25 34C11.7312 34 10.5 32.7688 10.5 31.25Z" fill="white"></path><path d="M10.5 20.25C10.5 18.7312 11.7312 17.5 13.25 17.5H16V23H13.25C11.7312 23 10.5 21.7688 10.5 20.25Z" fill="white"></path><path d="M16 17.5H18.75C20.2688 17.5 21.5 18.7312 21.5 20.25C21.5 21.7688 20.2688 23 18.75 23H16V17.5Z" fill="white"></path><path d="M16 25.75C16 24.2312 17.2312 23 18.75 23C20.2688 23 21.5 24.2312 21.5 25.75C21.5 27.2688 20.2688 28.5 18.75 28.5C17.2312 28.5 16 27.2688 16 25.75Z" fill="white"></path><path d="M10.5 25.75C10.5 24.2312 11.7312 23 13.25 23H16V28.5H13.25C11.7312 28.5 10.5 27.2688 10.5 25.75Z" fill="white"></path><path d="M22.3358 1.33579L21.8055 1.86612V1.86612L22.3358 1.33579ZM30.6642 9.66421L30.1339 10.1945L30.6642 9.66421ZM1.5 6.75C1.5 3.85051 3.85051 1.5 6.75 1.5V0C3.02208 0 0 3.02208 0 6.75H1.5ZM6.75 1.5H20.9216V0H6.75V1.5ZM20.9216 1.5C21.2531 1.5 21.571 1.6317 21.8055 1.86612L22.8661 0.805457C22.3504 0.289731 21.6509 0 20.9216 0V1.5ZM21.8055 1.86612L30.1339 10.1945L31.1945 9.13388L22.8661 0.805456L21.8055 1.86612ZM30.1339 10.1945C30.3683 10.429 30.5 10.7469 30.5 11.0784H32C32 10.3491 31.7103 9.64961 31.1945 9.13388L30.1339 10.1945ZM30.5 11.0784V33.25H32V11.0784H30.5ZM30.5 33.25C30.5 36.1495 28.1495 38.5 25.25 38.5V40C28.9779 40 32 36.9779 32 33.25H30.5ZM25.25 38.5H6.75V40H25.25V38.5ZM6.75 38.5C3.85051 38.5 1.5 36.1495 1.5 33.25H0C0 36.9779 3.02208 40 6.75 40V38.5ZM1.5 33.25V6.75H0V33.25H1.5ZM13.25 29.25H16V27.75H13.25V29.25ZM15.25 28.5V31.25H16.75V28.5H15.25ZM13.25 33.25C12.1454 33.25 11.25 32.3546 11.25 31.25H9.75C9.75 33.183 11.317 34.75 13.25 34.75V33.25ZM15.25 31.25C15.25 32.3546 14.3546 33.25 13.25 33.25V34.75C15.183 34.75 16.75 33.183 16.75 31.25H15.25ZM13.25 27.75C11.317 27.75 9.75 29.317 9.75 31.25H11.25C11.25 30.1454 12.1454 29.25 13.25 29.25V27.75ZM13.25 18.25H16V16.75H13.25V18.25ZM15.25 17.5V23H16.75V17.5H15.25ZM16 22.25H13.25V23.75H16V22.25ZM13.25 22.25C12.1454 22.25 11.25 21.3546 11.25 20.25H9.75C9.75 22.183 11.317 23.75 13.25 23.75V22.25ZM13.25 16.75C11.317 16.75 9.75 18.317 9.75 20.25H11.25C11.25 19.1454 12.1454 18.25 13.25 18.25V16.75ZM16 18.25H18.75V16.75H16V18.25ZM18.75 22.25H16V23.75H18.75V22.25ZM20.75 20.25C20.75 21.3546 19.8546 22.25 18.75 22.25V23.75C20.683 23.75 22.25 22.183 22.25 20.25H20.75ZM18.75 18.25C19.8546 18.25 20.75 19.1454 20.75 20.25H22.25C22.25 18.317 20.683 16.75 18.75 16.75V18.25ZM18.75 27.75C17.6454 27.75 16.75 26.8546 16.75 25.75H15.25C15.25 27.683 16.817 29.25 18.75 29.25V27.75ZM20.75 25.75C20.75 26.8546 19.8546 27.75 18.75 27.75V29.25C20.683 29.25 22.25 27.683 22.25 25.75H20.75ZM18.75 23.75C19.8546 23.75 20.75 24.6454 20.75 25.75H22.25C22.25 23.817 20.683 22.25 18.75 22.25V23.75ZM18.75 22.25C16.817 22.25 15.25 23.817 15.25 25.75H16.75C16.75 24.6454 17.6454 23.75 18.75 23.75V22.25ZM15.25 23V28.5H16.75V23H15.25ZM13.25 27.75C12.1454 27.75 11.25 26.8546 11.25 25.75H9.75C9.75 27.683 11.317 29.25 13.25 29.25V27.75ZM13.25 22.25C11.317 22.25 9.75 23.817 9.75 25.75H11.25C11.25 24.6454 12.1454 23.75 13.25 23.75V22.25Z" fill="#8040BF"></path>', 7)
  ])]);
}
const $N = { render: q8 }, ZN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: $N,
  render: q8
}, Symbol.toStringTag, { value: "Module" })), GN = {
  viewBox: "0 0 32 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Y8(e, t) {
  return f(), v("svg", GN, [...t[0] || (t[0] = [
    g("path", {
      d: "M0.75 6.75C0.75 3.43629 3.43629 0.75 6.75 0.75H20.9216C21.452 0.75 21.9607 0.960714 22.3358 1.33579L30.6642 9.66421C31.0393 10.0393 31.25 10.548 31.25 11.0784V33.25C31.25 36.5637 28.5637 39.25 25.25 39.25H6.75C3.43629 39.25 0.75 36.5637 0.75 33.25V6.75Z",
      fill: "white",
      stroke: "#555F6D",
      "stroke-width": "1.5",
      "stroke-linecap": "round"
    }, null, -1)
  ])]);
}
const NN = { render: Y8 }, zN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: NN,
  render: Y8
}, Symbol.toStringTag, { value: "Module" })), jN = {
  viewBox: "0 0 32 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Q8(e, t) {
  return f(), v("svg", jN, [...t[0] || (t[0] = [
    g("path", {
      d: "M0.75 6.75C0.75 3.43629 3.43629 0.75 6.75 0.75H20.9216C21.452 0.75 21.9607 0.960714 22.3358 1.33579L30.6642 9.66421C31.0393 10.0393 31.25 10.548 31.25 11.0784V33.25C31.25 36.5637 28.5637 39.25 25.25 39.25H6.75C3.43629 39.25 0.75 36.5637 0.75 33.25V6.75Z",
      fill: "white"
    }, null, -1),
    g("path", {
      d: "M13.75 20.75H16C17.7949 20.75 19.25 22.2051 19.25 24C19.25 25.7949 17.7949 27.25 16 27.25H13.75V20.75Z",
      fill: "white"
    }, null, -1),
    g("path", {
      d: "M6.75 20.75V25.25H9C10.2426 25.25 11.25 24.2426 11.25 23C11.25 21.7574 10.2426 20.75 9 20.75H6.75Z",
      fill: "white"
    }, null, -1),
    g("path", {
      d: "M22.3358 1.33579L21.8055 1.86612V1.86612L22.3358 1.33579ZM30.6642 9.66421L30.1339 10.1945L30.6642 9.66421ZM13.75 20.75V20C13.3358 20 13 20.3358 13 20.75H13.75ZM13.75 27.25H13C13 27.6642 13.3358 28 13.75 28V27.25ZM6 27.25C6 27.6642 6.33579 28 6.75 28C7.16421 28 7.5 27.6642 7.5 27.25H6ZM6.75 20.75V20C6.33579 20 6 20.3358 6 20.75H6.75ZM21 27.25C21 27.6642 21.3358 28 21.75 28C22.1642 28 22.5 27.6642 22.5 27.25H21ZM21.75 20.75V20C21.3358 20 21 20.3358 21 20.75H21.75ZM25.25 21.5C25.6642 21.5 26 21.1642 26 20.75C26 20.3358 25.6642 20 25.25 20V21.5ZM25.25 25C25.6642 25 26 24.6642 26 24.25C26 23.8358 25.6642 23.5 25.25 23.5V25ZM1.5 6.75C1.5 3.85051 3.85051 1.5 6.75 1.5V0C3.02208 0 0 3.02208 0 6.75H1.5ZM6.75 1.5H20.9216V0H6.75V1.5ZM20.9216 1.5C21.2531 1.5 21.571 1.6317 21.8055 1.86612L22.8661 0.805457C22.3504 0.289731 21.6509 0 20.9216 0V1.5ZM21.8055 1.86612L30.1339 10.1945L31.1945 9.13388L22.8661 0.805456L21.8055 1.86612ZM30.1339 10.1945C30.3683 10.429 30.5 10.7469 30.5 11.0784H32C32 10.3491 31.7103 9.64961 31.1945 9.13388L30.1339 10.1945ZM30.5 11.0784V33.25H32V11.0784H30.5ZM30.5 33.25C30.5 36.1495 28.1495 38.5 25.25 38.5V40C28.9779 40 32 36.9779 32 33.25H30.5ZM25.25 38.5H6.75V40H25.25V38.5ZM6.75 38.5C3.85051 38.5 1.5 36.1495 1.5 33.25H0C0 36.9779 3.02208 40 6.75 40V38.5ZM1.5 33.25V6.75H0V33.25H1.5ZM13.75 21.5H16V20H13.75V21.5ZM16 26.5H13.75V28H16V26.5ZM14.5 27.25V20.75H13V27.25H14.5ZM18.5 24C18.5 25.3807 17.3807 26.5 16 26.5V28C18.2091 28 20 26.2091 20 24H18.5ZM16 21.5C17.3807 21.5 18.5 22.6193 18.5 24H20C20 21.7909 18.2091 20 16 20V21.5ZM7.5 27.25V25.25H6V27.25H7.5ZM7.5 25.25V20.75H6V25.25H7.5ZM6.75 21.5H9V20H6.75V21.5ZM9 24.5H6.75V26H9V24.5ZM10.5 23C10.5 23.8284 9.82843 24.5 9 24.5V26C10.6569 26 12 24.6569 12 23H10.5ZM9 21.5C9.82843 21.5 10.5 22.1716 10.5 23H12C12 21.3431 10.6569 20 9 20V21.5ZM22.5 27.25V24.25H21V27.25H22.5ZM22.5 24.25V20.75H21V24.25H22.5ZM21.75 21.5H25.25V20H21.75V21.5ZM25.25 23.5H21.75V25H25.25V23.5Z",
      fill: "#C53434"
    }, null, -1)
  ])]);
}
const WN = { render: Q8 }, UN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: WN,
  render: Q8
}, Symbol.toStringTag, { value: "Module" })), KN = {
  viewBox: "0 0 32 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function J8(e, t) {
  return f(), v("svg", KN, [...t[0] || (t[0] = [
    g("path", {
      d: "M0.75 6.75C0.75 3.43629 3.43629 0.75 6.75 0.75H20.9216C21.452 0.75 21.9607 0.960714 22.3358 1.33579L30.6642 9.66421C31.0393 10.0393 31.25 10.548 31.25 11.0784V33.25C31.25 36.5637 28.5637 39.25 25.25 39.25H6.75C3.43629 39.25 0.75 36.5637 0.75 33.25V6.75Z",
      fill: "white"
    }, null, -1),
    g("path", {
      d: "M10.2121 18.2878C10.5304 17.727 10.6895 17.4467 10.9086 17.243C11.1024 17.0628 11.3295 16.9269 11.5754 16.8438C11.8533 16.75 12.1625 16.75 12.7811 16.75H19.2189C19.8375 16.75 20.1467 16.75 20.4246 16.8438C20.6706 16.9269 20.8976 17.0628 21.0914 17.243C21.3105 17.4467 21.4696 17.727 21.7879 18.2878L22.5388 19.6109C22.963 20.3584 23.1751 20.7322 23.2298 21.1223C23.278 21.4665 23.2396 21.8182 23.1184 22.1417C22.981 22.5084 22.6938 22.8211 22.1196 23.4467L18.1498 27.771C17.3995 28.5883 17.0244 28.9969 16.5892 29.1494C16.2067 29.2835 15.7933 29.2835 15.4108 29.1494C14.9756 28.9969 14.6005 28.5883 13.8502 27.771L9.8804 23.4467C9.30615 22.8211 9.01903 22.5084 8.88164 22.1417C8.7604 21.8182 8.72197 21.4665 8.77024 21.1223C8.82493 20.7322 9.03703 20.3584 9.46124 19.6109L10.2121 18.2878Z",
      fill: "#F59638"
    }, null, -1),
    g("path", {
      d: "M22.3358 1.33579L21.8055 1.86612V1.86612L22.3358 1.33579ZM30.6642 9.66421L30.1339 10.1945L30.6642 9.66421ZM10.2121 18.2878L10.8644 18.658L10.2121 18.2878ZM10.9086 17.243L11.4192 17.7923L10.9086 17.243ZM11.5754 16.8438L11.8153 17.5544L11.5754 16.8438ZM20.4246 16.8438L20.6646 16.1332V16.1332L20.4246 16.8438ZM21.0914 17.243L20.5808 17.7923L21.0914 17.243ZM21.7879 18.2878L22.4402 17.9176V17.9176L21.7879 18.2878ZM22.5388 19.6109L21.8865 19.9811V19.9811L22.5388 19.6109ZM23.2298 21.1223L22.487 21.2264L23.2298 21.1223ZM23.1184 22.1417L22.4161 21.8785L22.416 21.8785L23.1184 22.1417ZM22.1196 23.4467L22.6721 23.9539L22.1196 23.4467ZM18.1498 27.771L18.7023 28.2782H18.7023L18.1498 27.771ZM16.5892 29.1494L16.8373 29.8572L16.5892 29.1494ZM15.4108 29.1494L15.1627 29.8572L15.4108 29.1494ZM13.8502 27.771L13.2977 28.2782L13.8502 27.771ZM9.8804 23.4467L10.4329 22.9395L9.8804 23.4467ZM8.88164 22.1417L9.58395 21.8785L8.88164 22.1417ZM8.77024 21.1223L8.0275 21.0182L8.77024 21.1223ZM9.46124 19.6109L10.1135 19.9811L9.46124 19.6109ZM1.5 6.75C1.5 3.85051 3.85051 1.5 6.75 1.5V0C3.02208 0 0 3.02208 0 6.75H1.5ZM6.75 1.5H20.9216V0H6.75V1.5ZM20.9216 1.5C21.2531 1.5 21.571 1.6317 21.8055 1.86612L22.8661 0.805457C22.3504 0.289731 21.6509 0 20.9216 0V1.5ZM21.8055 1.86612L30.1339 10.1945L31.1945 9.13388L22.8661 0.805456L21.8055 1.86612ZM30.1339 10.1945C30.3683 10.429 30.5 10.7469 30.5 11.0784H32C32 10.3491 31.7103 9.64961 31.1945 9.13388L30.1339 10.1945ZM30.5 11.0784V33.25H32V11.0784H30.5ZM30.5 33.25C30.5 36.1495 28.1495 38.5 25.25 38.5V40C28.9779 40 32 36.9779 32 33.25H30.5ZM25.25 38.5H6.75V40H25.25V38.5ZM6.75 38.5C3.85051 38.5 1.5 36.1495 1.5 33.25H0C0 36.9779 3.02208 40 6.75 40V38.5ZM1.5 33.25V6.75H0V33.25H1.5ZM10.8644 18.658C11.2074 18.0535 11.305 17.8985 11.4192 17.7923L10.3979 16.6937C10.0739 16.9949 9.85329 17.4006 9.55984 17.9176L10.8644 18.658ZM11.4192 17.7923C11.5369 17.6829 11.6721 17.6028 11.8153 17.5544L11.3355 16.1332C10.9868 16.2509 10.668 16.4426 10.3979 16.6937L11.4192 17.7923ZM11.8153 17.5544C11.9489 17.5093 12.1106 17.5 12.7811 17.5V16C12.2145 16 11.7577 15.9907 11.3355 16.1332L11.8153 17.5544ZM12.7811 17.5H19.2189V16H12.7811V17.5ZM19.2189 17.5C19.8894 17.5 20.0511 17.5093 20.1847 17.5544L20.6646 16.1332C20.2423 15.9907 19.7855 16 19.2189 16V17.5ZM20.1847 17.5544C20.3279 17.6028 20.4631 17.6829 20.5808 17.7923L21.6021 16.6937C21.332 16.4426 21.0132 16.2509 20.6646 16.1332L20.1847 17.5544ZM20.5808 17.7923C20.695 17.8985 20.7926 18.0535 21.1356 18.658L22.4402 17.9176C22.1467 17.4006 21.9261 16.9949 21.6021 16.6937L20.5808 17.7923ZM21.1356 18.658L21.8865 19.9811L23.191 19.2408L22.4402 17.9176L21.1356 18.658ZM21.8865 19.9811C22.3424 20.7844 22.457 21.0122 22.487 21.2264L23.9725 21.0182C23.8931 20.4522 23.5836 19.9325 23.191 19.2408L21.8865 19.9811ZM22.487 21.2264C22.518 21.4476 22.4931 21.6729 22.4161 21.8785L23.8207 22.4049C23.9861 21.9634 24.038 21.4855 23.9725 21.0182L22.487 21.2264ZM22.416 21.8785C22.3422 22.0757 22.1853 22.2661 21.5671 22.9395L22.6721 23.9539C23.2024 23.3762 23.6198 22.941 23.8207 22.4049L22.416 21.8785ZM21.5671 22.9395L17.5973 27.2638L18.7023 28.2782L22.6721 23.9539L21.5671 22.9395ZM17.5973 27.2638C17.2136 27.6817 16.9564 27.961 16.7426 28.1584C16.5341 28.3509 16.4199 28.414 16.3411 28.4416L16.8373 29.8572C17.1937 29.7323 17.4846 29.5149 17.7601 29.2605C18.0302 29.0112 18.3357 28.6775 18.7023 28.2782L17.5973 27.2638ZM16.3411 28.4416C16.1192 28.5195 15.8808 28.5195 15.6589 28.4416L15.1627 29.8572C15.7059 30.0476 16.2941 30.0476 16.8373 29.8572L16.3411 28.4416ZM15.6589 28.4416C15.5801 28.414 15.4659 28.3509 15.2574 28.1584C15.0436 27.961 14.7864 27.6817 14.4027 27.2638L13.2977 28.2782C13.6643 28.6775 13.9698 29.0112 14.2399 29.2605C14.5154 29.5149 14.8063 29.7323 15.1627 29.8572L15.6589 28.4416ZM14.4027 27.2638L10.4329 22.9395L9.32791 23.9539L13.2977 28.2782L14.4027 27.2638ZM10.4329 22.9395C9.81472 22.2661 9.65782 22.0757 9.58395 21.8785L8.17933 22.4049C8.38023 22.941 8.79758 23.3762 9.32791 23.9539L10.4329 22.9395ZM9.58395 21.8785C9.50689 21.6729 9.48197 21.4476 9.51297 21.2264L8.0275 21.0182C7.96198 21.4855 8.01391 21.9634 8.17933 22.4049L9.58395 21.8785ZM9.51297 21.2264C9.543 21.0122 9.65765 20.7844 10.1135 19.9811L8.80896 19.2408C8.41642 19.9325 8.10685 20.4522 8.0275 21.0182L9.51297 21.2264ZM10.1135 19.9811L10.8644 18.658L9.55984 17.9176L8.80896 19.2408L10.1135 19.9811Z",
      fill: "#F59638"
    }, null, -1)
  ])]);
}
const qN = { render: J8 }, YN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: qN,
  render: J8
}, Symbol.toStringTag, { value: "Module" })), QN = {
  viewBox: "0 0 32 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function X8(e, t) {
  return f(), v("svg", QN, [...t[0] || (t[0] = [
    g("path", {
      d: "M0.75 6.75C0.75 3.43629 3.43629 0.75 6.75 0.75H20.9216C21.452 0.75 21.9607 0.960714 22.3358 1.33579L30.6642 9.66421C31.0393 10.0393 31.25 10.548 31.25 11.0784V33.25C31.25 36.5637 28.5637 39.25 25.25 39.25H6.75C3.43629 39.25 0.75 36.5637 0.75 33.25V6.75Z",
      fill: "white"
    }, null, -1),
    g("path", {
      d: "M8.75 18.75C8.75 17.6454 9.64543 16.75 10.75 16.75H21.25C22.3546 16.75 23.25 17.6454 23.25 18.75V29.25C23.25 30.3546 22.3546 31.25 21.25 31.25H10.75C9.64543 31.25 8.75 30.3546 8.75 29.25V18.75Z",
      fill: "white"
    }, null, -1),
    g("path", {
      d: "M13.75 16.75V31.25M8.75 21.75H23.25M0.75 6.75C0.75 3.43629 3.43629 0.75 6.75 0.75H20.9216C21.452 0.75 21.9607 0.960714 22.3358 1.33579L30.6642 9.66421C31.0393 10.0393 31.25 10.548 31.25 11.0784V33.25C31.25 36.5637 28.5637 39.25 25.25 39.25H6.75C3.43629 39.25 0.75 36.5637 0.75 33.25V6.75ZM10.75 31.25H21.25C22.3546 31.25 23.25 30.3546 23.25 29.25V18.75C23.25 17.6454 22.3546 16.75 21.25 16.75H10.75C9.64543 16.75 8.75 17.6454 8.75 18.75V29.25C8.75 30.3546 9.64543 31.25 10.75 31.25Z",
      stroke: "#1D7C4D",
      "stroke-width": "1.5",
      "stroke-linecap": "round"
    }, null, -1)
  ])]);
}
const JN = { render: X8 }, XN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: JN,
  render: X8
}, Symbol.toStringTag, { value: "Module" })), ez = {
  viewBox: "0 0 32 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function eg(e, t) {
  return f(), v("svg", ez, [...t[0] || (t[0] = [
    g("path", {
      d: "M0.75 6.75C0.75 3.43629 3.43629 0.75 6.75 0.75H20.9216C21.452 0.75 21.9607 0.960714 22.3358 1.33579L30.6642 9.66421C31.0393 10.0393 31.25 10.548 31.25 11.0784V33.25C31.25 36.5637 28.5637 39.25 25.25 39.25H6.75C3.43629 39.25 0.75 36.5637 0.75 33.25V6.75Z",
      fill: "white"
    }, null, -1),
    g("path", {
      d: "M22.3358 1.33579L21.8055 1.86612V1.86612L22.3358 1.33579ZM30.6642 9.66421L30.1339 10.1945L30.6642 9.66421ZM13.75 27.25L13.0332 27.4706C13.1214 27.7572 13.3718 27.9637 13.6699 27.9957C13.9681 28.0277 14.2567 27.8791 14.4037 27.6177L13.75 27.25ZM12.4668 20.5294C12.345 20.1335 11.9253 19.9114 11.5294 20.0332C11.1335 20.155 10.9114 20.5747 11.0332 20.9706L12.4668 20.5294ZM16 23.25L16.6537 22.8823C16.5208 22.6461 16.271 22.5 16 22.5C15.729 22.5 15.4792 22.6461 15.3463 22.8823L16 23.25ZM18.25 27.25L17.5963 27.6177C17.7433 27.8791 18.0319 28.0277 18.3301 27.9957C18.6282 27.9637 18.8786 27.7572 18.9668 27.4706L18.25 27.25ZM20.9668 20.9706C21.0886 20.5747 20.8665 20.155 20.4706 20.0332C20.0747 19.9114 19.655 20.1335 19.5332 20.5294L20.9668 20.9706ZM1.5 6.75C1.5 3.85051 3.85051 1.5 6.75 1.5V0C3.02208 0 0 3.02208 0 6.75H1.5ZM6.75 1.5H20.9216V0H6.75V1.5ZM20.9216 1.5C21.2531 1.5 21.571 1.6317 21.8055 1.86612L22.8661 0.805457C22.3504 0.289731 21.6509 0 20.9216 0V1.5ZM21.8055 1.86612L30.1339 10.1945L31.1945 9.13388L22.8661 0.805456L21.8055 1.86612ZM30.1339 10.1945C30.3683 10.429 30.5 10.7469 30.5 11.0784H32C32 10.3491 31.7103 9.64961 31.1945 9.13388L30.1339 10.1945ZM30.5 11.0784V33.25H32V11.0784H30.5ZM30.5 33.25C30.5 36.1495 28.1495 38.5 25.25 38.5V40C28.9779 40 32 36.9779 32 33.25H30.5ZM25.25 38.5H6.75V40H25.25V38.5ZM6.75 38.5C3.85051 38.5 1.5 36.1495 1.5 33.25H0C0 36.9779 3.02208 40 6.75 40V38.5ZM1.5 33.25V6.75H0V33.25H1.5ZM14.4668 27.0294L12.4668 20.5294L11.0332 20.9706L13.0332 27.4706L14.4668 27.0294ZM14.4037 27.6177L16.6537 23.6177L15.3463 22.8823L13.0963 26.8823L14.4037 27.6177ZM15.3463 23.6177L17.5963 27.6177L18.9037 26.8823L16.6537 22.8823L15.3463 23.6177ZM18.9668 27.4706L20.9668 20.9706L19.5332 20.5294L17.5332 27.0294L18.9668 27.4706Z",
      fill: "#3062D4"
    }, null, -1)
  ])]);
}
const tz = { render: eg }, oz = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: tz,
  render: eg
}, Symbol.toStringTag, { value: "Module" })), nz = {
  viewBox: "0 0 32 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function tg(e, t) {
  return f(), v("svg", nz, [...t[0] || (t[0] = [
    g("path", {
      d: "M0.75 6.75C0.75 3.43629 3.43629 0.75 6.75 0.75H20.9216C21.452 0.75 21.9607 0.960714 22.3358 1.33579L30.6642 9.66421C31.0393 10.0393 31.25 10.548 31.25 11.0784V33.25C31.25 36.5637 28.5637 39.25 25.25 39.25H6.75C3.43629 39.25 0.75 36.5637 0.75 33.25V6.75Z",
      fill: "white"
    }, null, -1),
    g("path", {
      d: "M6.75 18.75H9.75V21.75H6.75V18.75Z",
      fill: "white"
    }, null, -1),
    g("path", {
      d: "M22.3358 1.33579L21.8055 1.86612V1.86612L22.3358 1.33579ZM30.6642 9.66421L30.1339 10.1945L30.6642 9.66421ZM6.75 3.75H6C6 3.94891 6.07902 4.13968 6.21967 4.28033C6.36032 4.42098 6.55109 4.5 6.75 4.5V3.75ZM9.75 3.75H10.5C10.5 3.33579 10.1642 3 9.75 3V3.75ZM9.75 6.75V7.5C10.1642 7.5 10.5 7.16421 10.5 6.75H9.75ZM6.75 6.75V6C6.33579 6 6 6.33579 6 6.75H6.75ZM6.75 9.75H6C6 10.1642 6.33579 10.5 6.75 10.5V9.75ZM9.75 9.75H10.5C10.5 9.33579 10.1642 9 9.75 9V9.75ZM9.75 12.75V13.5C10.1642 13.5 10.5 13.1642 10.5 12.75H9.75ZM6.75 12.75V12C6.33579 12 6 12.3358 6 12.75H6.75ZM6.75 15.75H6C6 16.1642 6.33579 16.5 6.75 16.5V15.75ZM9.75 15.75H10.5C10.5 15.3358 10.1642 15 9.75 15V15.75ZM6.75 18.75V18C6.33579 18 6 18.3358 6 18.75H6.75ZM6.75 21.75H6C6 22.1642 6.33579 22.5 6.75 22.5V21.75ZM9.75 21.75V22.5C10.1642 22.5 10.5 22.1642 10.5 21.75H9.75ZM1.5 6.75C1.5 3.85051 3.85051 1.5 6.75 1.5V0C3.02208 0 0 3.02208 0 6.75H1.5ZM6.75 1.5H20.9216V0H6.75V1.5ZM20.9216 1.5C21.2531 1.5 21.571 1.6317 21.8055 1.86612L22.8661 0.805457C22.3504 0.289731 21.6509 0 20.9216 0V1.5ZM21.8055 1.86612L30.1339 10.1945L31.1945 9.13388L22.8661 0.805456L21.8055 1.86612ZM30.1339 10.1945C30.3683 10.429 30.5 10.7469 30.5 11.0784H32C32 10.3491 31.7103 9.64961 31.1945 9.13388L30.1339 10.1945ZM30.5 11.0784V33.25H32V11.0784H30.5ZM30.5 33.25C30.5 36.1495 28.1495 38.5 25.25 38.5V40C28.9779 40 32 36.9779 32 33.25H30.5ZM25.25 38.5H6.75V40H25.25V38.5ZM6.75 38.5C3.85051 38.5 1.5 36.1495 1.5 33.25H0C0 36.9779 3.02208 40 6.75 40V38.5ZM1.5 33.25V6.75H0V33.25H1.5ZM7.5 3.75L7.5 0.75L6 0.75L6 3.75H7.5ZM6.75 4.5H9.75V3H6.75V4.5ZM9 3.75V6.75H10.5V3.75H9ZM9.75 6H6.75V7.5H9.75V6ZM6 6.75V9.75H7.5V6.75H6ZM6.75 10.5H9.75V9H6.75V10.5ZM9 9.75V12.75H10.5V9.75H9ZM9.75 12H6.75V13.5H9.75V12ZM6 12.75V15.75H7.5V12.75H6ZM6.75 16.5H9.75V15H6.75V16.5ZM9 15.75V18.75H10.5V15.75H9ZM9.75 18H6.75V19.5H9.75V18ZM6 18.75V21.75H7.5V18.75H6ZM6.75 22.5H9.75V21H6.75V22.5ZM10.5 21.75V18.75H9V21.75H10.5Z",
      fill: "#555F6D"
    }, null, -1)
  ])]);
}
const sz = { render: tg }, iz = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sz,
  render: tg
}, Symbol.toStringTag, { value: "Module" })), rz = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function og(e, t) {
  return f(), v("svg", rz, [...t[0] || (t[0] = [
    g("g", { class: "accesibility" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10 2.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM7 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0ZM3.036 6.521a.75.75 0 0 1 .943-.485L10 7.963l6.021-1.927a.75.75 0 0 1 .458 1.428L10.75 9.297v2.472l4.12 6.06a.75.75 0 0 1-1.24.843L10 13.334l-3.63 5.338a.75.75 0 1 1-1.24-.844l4.12-6.059V9.297L3.521 7.464a.75.75 0 0 1-.485-.943Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const lz = { render: og }, az = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: lz,
  render: og
}, Symbol.toStringTag, { value: "Module" })), cz = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function ng(e, t) {
  return f(), v("svg", cz, [...t[0] || (t[0] = [
    g("g", { class: "activity" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M6.489 2a.75.75 0 0 1 .745.598l2.48 11.984 3.085-8.099a.75.75 0 0 1 1.412.03l1.33 3.987h2.709a.75.75 0 0 1 0 1.5H15a.75.75 0 0 1-.711-.513l-.836-2.507-3.252 8.537a.75.75 0 0 1-1.435-.115L6.558 6.734l-.82 4.646A.75.75 0 0 1 5 12H1.75a.75.75 0 0 1 0-1.5h2.62l1.391-7.88A.75.75 0 0 1 6.49 2Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const dz = { render: ng }, uz = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: dz,
  render: ng
}, Symbol.toStringTag, { value: "Module" })), hz = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function sg(e, t) {
  return f(), v("svg", hz, [...t[0] || (t[0] = [
    g("g", { class: "alarm-clock" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M4.78 1.22a.75.75 0 0 1 0 1.06l-2.5 2.5a.75.75 0 1 1-1.06-1.06l2.5-2.5a.75.75 0 0 1 1.06 0Zm10.44 0a.75.75 0 0 1 1.06 0l2.5 2.5a.75.75 0 0 1-1.06 1.06l-2.5-2.5a.75.75 0 0 1 0-1.06ZM10 3.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13ZM2 10a8 8 0 1 1 14.101 5.175l1.773 2.659a.75.75 0 1 1-1.248.832l-1.618-2.427A7.966 7.966 0 0 1 10 18a7.967 7.967 0 0 1-5.008-1.761l-1.618 2.427a.75.75 0 1 1-1.248-.832l1.773-2.66A7.968 7.968 0 0 1 2 10Zm7.75-5a.75.75 0 0 1 .75.75V9.5h1.75a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75v-4.5A.75.75 0 0 1 9.75 5Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const gz = { render: sg }, pz = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: gz,
  render: sg
}, Symbol.toStringTag, { value: "Module" })), fz = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function ig(e, t) {
  return f(), v("svg", fz, [...t[0] || (t[0] = [
    g("g", { class: "alert-fill" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10.567 1.09a1.835 1.835 0 0 0-1.134 0 1.86 1.86 0 0 0-.63.372c-.16.134-.335.31-.525.5L1.963 8.279c-.191.19-.367.366-.501.524a1.86 1.86 0 0 0-.372.631c-.12.369-.12.765 0 1.134.084.258.227.46.372.63.134.16.31.335.5.525l6.316 6.315c.19.191.366.367.524.501.171.145.373.288.631.372.369.12.765.12 1.134 0 .258-.084.46-.227.63-.372.16-.134.335-.31.526-.5l6.314-6.316c.191-.19.367-.366.501-.524.145-.171.288-.373.372-.631.12-.369.12-.765 0-1.134a1.859 1.859 0 0 0-.372-.63c-.134-.16-.31-.335-.5-.525l-6.316-6.315a9.471 9.471 0 0 0-.524-.501 1.86 1.86 0 0 0-.631-.372Zm.183 4.66a.75.75 0 0 0-1.5 0v3.5a.75.75 0 0 0 1.5 0v-3.5Zm0 7a.75.75 0 0 0-1.5 0v1.5a.75.75 0 0 0 1.5 0v-1.5Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const vz = { render: ig }, mz = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: vz,
  render: ig
}, Symbol.toStringTag, { value: "Module" })), Cz = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function rg(e, t) {
  return f(), v("svg", Cz, [...t[0] || (t[0] = [
    g("g", { class: "alert" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10.093 2.515a.303.303 0 0 0-.186 0 .612.612 0 0 0-.114.083c-.105.09-.237.22-.454.437L3.035 9.34a8.803 8.803 0 0 0-.437.454.612.612 0 0 0-.083.114.303.303 0 0 0 0 .186c.003.007.02.04.083.114.09.105.22.237.437.454l6.304 6.304c.217.217.349.347.454.437.074.062.107.08.114.083.06.02.125.02.186 0a.605.605 0 0 0 .114-.083c.105-.09.237-.22.454-.437l6.304-6.304c.217-.217.347-.349.437-.454a.605.605 0 0 0 .083-.114.303.303 0 0 0 0-.186.606.606 0 0 0-.083-.114 8.828 8.828 0 0 0-.437-.454L10.66 3.035a8.802 8.802 0 0 0-.454-.437.611.611 0 0 0-.114-.083Zm-.002-.001h.002-.002Zm7.395 7.577v.002-.002ZM9.91 17.486h-.002.002ZM2.514 9.91v-.002.002Zm6.929-8.82a1.803 1.803 0 0 1 1.114 0c.252.081.45.221.62.365.158.135.333.31.526.502l6.341 6.341c.192.193.367.368.502.526.144.17.284.368.366.62.117.362.117.752 0 1.114-.082.252-.222.45-.366.62-.135.158-.31.333-.502.526l-6.341 6.341c-.193.192-.368.367-.526.502-.17.144-.368.284-.62.366a1.804 1.804 0 0 1-1.114 0 1.83 1.83 0 0 1-.62-.366 9.504 9.504 0 0 1-.526-.502l-6.341-6.341c-.192-.193-.367-.368-.502-.526a1.827 1.827 0 0 1-.366-.62 1.803 1.803 0 0 1 0-1.114c.082-.252.222-.45.366-.62a9.51 9.51 0 0 1 .502-.526l6.341-6.341a9.51 9.51 0 0 1 .526-.502c.17-.144.368-.284.62-.366ZM10 5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 10 5Zm0 7a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0v-1.5A.75.75 0 0 1 10 12Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const wz = { render: rg }, bz = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: wz,
  render: rg
}, Symbol.toStringTag, { value: "Module" })), yz = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function lg(e, t) {
  return f(), v("svg", yz, [...t[0] || (t[0] = [
    g("g", { class: "anchor" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10 2.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM7 4a3 3 0 1 1 3.75 2.905v10.558a7.504 7.504 0 0 0 6.657-6.275l-2.856 1.25a.75.75 0 1 1-.602-1.375l4-1.75A.75.75 0 0 1 19 10a9 9 0 1 1-18 0 .75.75 0 0 1 1.05-.687l4 1.75a.75.75 0 1 1-.6 1.374l-2.856-1.25a7.504 7.504 0 0 0 6.656 6.276V6.905A3.001 3.001 0 0 1 7 4Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const _z = { render: lg }, Sz = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _z,
  render: lg
}, Symbol.toStringTag, { value: "Module" })), xz = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function ag(e, t) {
  return f(), v("svg", xz, [...t[0] || (t[0] = [
    g("g", { class: "apps" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M4.75 3.25a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm6.75 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm5.25 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM4.75 10a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM10 11.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm8.25-1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm-15 8.25a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm8.25-1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm5.25 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Mz = { render: ag }, Az = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Mz,
  render: ag
}, Symbol.toStringTag, { value: "Module" })), Lz = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function cg(e, t) {
  return f(), v("svg", Lz, [...t[0] || (t[0] = [
    g("g", { class: "archive" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M4.92 1h10.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 18.7 2.502c.172.337.24.694.27 1.073.03.365.03.81.03 1.345v11.33A2.75 2.75 0 0 1 16.25 19H3.75A2.75 2.75 0 0 1 1 16.25V4.92c0-.534 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 2.502 1.3c.337-.172.693-.24 1.073-.27C3.94 1 4.385 1 4.92 1ZM3.697 2.525c-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.547c-.046.09-.088.227-.111.515-.024.295-.025.68-.025 1.252V11h2.014a2.75 2.75 0 0 1 2.46 1.52l.144.289a1.25 1.25 0 0 0 1.118.691h3.528a1.25 1.25 0 0 0 1.118-.691l.144-.289a2.75 2.75 0 0 1 2.46-1.52H17.5V4.95c0-.572 0-.957-.025-1.252-.023-.288-.065-.425-.111-.515a1.25 1.25 0 0 0-.547-.547c-.09-.046-.227-.088-.515-.111-.295-.024-.68-.025-1.252-.025H4.95c-.572 0-.957 0-1.253.025ZM17.5 12.5h-2.014a1.25 1.25 0 0 0-1.118.691l-.144.289a2.75 2.75 0 0 1-2.46 1.52H8.236a2.75 2.75 0 0 1-2.46-1.52l-.144-.289a1.25 1.25 0 0 0-1.118-.691H2.5v3.75c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25V12.5Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Ez = { render: cg }, Pz = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ez,
  render: cg
}, Symbol.toStringTag, { value: "Module" })), Rz = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function dg(e, t) {
  return f(), v("svg", Rz, [...t[0] || (t[0] = [
    g("g", { class: "arrow-down-left" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M15.78 4.22a.75.75 0 0 1 0 1.06L6.56 14.5h3.69a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1-.75-.75v-5.5a.75.75 0 0 1 1.5 0v3.69l9.22-9.22a.75.75 0 0 1 1.06 0Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Fz = { render: dg }, Tz = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Fz,
  render: dg
}, Symbol.toStringTag, { value: "Module" })), Iz = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function ug(e, t) {
  return f(), v("svg", Iz, [...t[0] || (t[0] = [
    g("g", { class: "arrow-down-right" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M4.22 4.22a.75.75 0 0 1 1.06 0l9.22 9.22V9.75a.75.75 0 0 1 1.5 0v5.5a.75.75 0 0 1-.75.75h-5.5a.75.75 0 0 1 0-1.5h3.69L4.22 5.28a.75.75 0 0 1 0-1.06Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Dz = { render: ug }, kz = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Dz,
  render: ug
}, Symbol.toStringTag, { value: "Module" })), Hz = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function hg(e, t) {
  return f(), v("svg", Hz, [...t[0] || (t[0] = [
    g("g", { class: "arrow-down" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10 3a.75.75 0 0 1 .75.75v10.764l2.986-2.81a.75.75 0 0 1 1.028 1.092l-4.25 4a.75.75 0 0 1-1.028 0l-4.25-4a.75.75 0 0 1 1.028-1.092l2.986 2.81V3.75A.75.75 0 0 1 10 3Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Vz = { render: hg }, Oz = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Vz,
  render: hg
}, Symbol.toStringTag, { value: "Module" })), Bz = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function gg(e, t) {
  return f(), v("svg", Bz, [...t[0] || (t[0] = [
    g("g", { class: "arrow-left" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M8.264 5.204a.75.75 0 0 1 .032 1.06L5.486 9.25H16.25a.75.75 0 0 1 0 1.5H5.486l2.81 2.986a.75.75 0 1 1-1.092 1.028l-4-4.25a.75.75 0 0 1 0-1.028l4-4.25a.75.75 0 0 1 1.06-.032Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const $z = { render: gg }, Zz = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: $z,
  render: gg
}, Symbol.toStringTag, { value: "Module" })), Gz = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function pg(e, t) {
  return f(), v("svg", Gz, [...t[0] || (t[0] = [
    g("g", { class: "arrow-right" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M11.736 5.204a.75.75 0 0 1 1.06.032l4 4.25a.75.75 0 0 1 0 1.028l-4 4.25a.75.75 0 0 1-1.092-1.028l2.81-2.986H3.75a.75.75 0 0 1 0-1.5h10.764l-2.81-2.986a.75.75 0 0 1 .032-1.06Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Nz = { render: pg }, zz = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Nz,
  render: pg
}, Symbol.toStringTag, { value: "Module" })), jz = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function fg(e, t) {
  return f(), v("svg", jz, [...t[0] || (t[0] = [
    g("g", { class: "arrow-up-left" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M4 4.75A.75.75 0 0 1 4.75 4h5.5a.75.75 0 0 1 0 1.5H6.56l9.22 9.22a.75.75 0 1 1-1.06 1.06L5.5 6.56v3.69a.75.75 0 0 1-1.5 0v-5.5Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Wz = { render: fg }, Uz = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Wz,
  render: fg
}, Symbol.toStringTag, { value: "Module" })), Kz = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function vg(e, t) {
  return f(), v("svg", Kz, [...t[0] || (t[0] = [
    g("g", { class: "arrow-up-right" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M9.75 5.5a.75.75 0 0 1 0-1.5h5.5a.75.75 0 0 1 .75.75v5.5a.75.75 0 0 1-1.5 0V6.56l-9.22 9.22a.75.75 0 0 1-1.06-1.06l9.22-9.22H9.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const qz = { render: vg }, Yz = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: qz,
  render: vg
}, Symbol.toStringTag, { value: "Module" })), Qz = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function mg(e, t) {
  return f(), v("svg", Qz, [...t[0] || (t[0] = [
    g("g", { class: "arrow-up" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M9.486 3.204a.75.75 0 0 1 1.028 0l4.25 4a.75.75 0 1 1-1.028 1.092l-2.986-2.81V16.25a.75.75 0 0 1-1.5 0V5.486l-2.986 2.81a.75.75 0 0 1-1.028-1.092l4.25-4Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Jz = { render: mg }, Xz = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Jz,
  render: mg
}, Symbol.toStringTag, { value: "Module" })), ej = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Cg(e, t) {
  return f(), v("svg", ej, [...t[0] || (t[0] = [
    g("g", { class: "arrowhead-down" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10 13a1 1 0 0 1-.8-.4l-3-4A1 1 0 0 1 7 7h6a1 1 0 0 1 .8 1.6l-3 4a1 1 0 0 1-.8.4Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const tj = { render: Cg }, oj = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: tj,
  render: Cg
}, Symbol.toStringTag, { value: "Module" })), nj = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function wg(e, t) {
  return f(), v("svg", nj, [...t[0] || (t[0] = [
    g("g", { class: "arrowhead-left" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M12.447 13.894A1 1 0 0 1 11.4 13.8l-4-3a1 1 0 0 1 0-1.6l4-3A1 1 0 0 1 13 7v6a1 1 0 0 1-.553.894Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const sj = { render: wg }, ij = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sj,
  render: wg
}, Symbol.toStringTag, { value: "Module" })), rj = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function bg(e, t) {
  return f(), v("svg", rj, [...t[0] || (t[0] = [
    g("g", { class: "arrowhead-right" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M7.553 6.105a1 1 0 0 1 1.048.095l4 3a1 1 0 0 1 0 1.6l-4 3A1 1 0 0 1 7 13V7a1 1 0 0 1 .552-.895Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const lj = { render: bg }, aj = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: lj,
  render: bg
}, Symbol.toStringTag, { value: "Module" })), cj = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function yg(e, t) {
  return f(), v("svg", cj, [...t[0] || (t[0] = [
    g("g", { class: "arrowhead-up" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10 7a1 1 0 0 1 .8.4l3 4A1 1 0 0 1 13 13H7a1 1 0 0 1-.8-1.6l3-4A1 1 0 0 1 10 7Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const dj = { render: yg }, uj = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: dj,
  render: yg
}, Symbol.toStringTag, { value: "Module" })), hj = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function _g(e, t) {
  return f(), v("svg", hj, [...t[0] || (t[0] = [
    g("g", { class: "attachment" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M11.47 2.109a3.85 3.85 0 0 1 5.406 0 3.772 3.772 0 0 1 0 5.372l-8.159 8.073a2.3 2.3 0 0 1-3.23 0 2.26 2.26 0 0 1 0-3.22l7.07-6.996a.75.75 0 0 1 1.056 1.066L6.54 13.401a.761.761 0 0 0 0 1.087.8.8 0 0 0 1.121 0l8.16-8.074a2.272 2.272 0 0 0 0-3.24 2.35 2.35 0 0 0-3.297 0l-7.896 7.813a3.532 3.532 0 0 0-1.13 2.696c.001.251.001.35.005.43.088 1.824 1.565 3.295 3.426 3.383.081.004.182.004.436.004l.195-.001a3.626 3.626 0 0 0 2.54-1.12l5.72-5.659a.75.75 0 1 1 1.055 1.066l-5.726 5.666c-.07.069-.113.112-.158.154A5.126 5.126 0 0 1 7.596 19l-.22.001h-.034c-.223 0-.362 0-.483-.006-2.62-.123-4.727-2.2-4.853-4.809C2 14.065 2 13.927 2 13.707v-.034l.001-.219a5.032 5.032 0 0 1 1.411-3.37c.042-.044.086-.088.156-.157L11.47 2.11Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const gj = { render: _g }, pj = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: gj,
  render: _g
}, Symbol.toStringTag, { value: "Module" })), fj = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Sg(e, t) {
  return f(), v("svg", fj, [...t[0] || (t[0] = [
    g("g", { class: "background" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M6.78 1.22a.75.75 0 0 1 0 1.06l-4.5 4.5a.75.75 0 0 1-1.06-1.06l4.5-4.5a.75.75 0 0 1 1.06 0Zm6 0a.75.75 0 0 1 0 1.06l-10.5 10.5a.75.75 0 0 1-1.06-1.06l10.5-10.5a.75.75 0 0 1 1.06 0Zm6 0a.75.75 0 0 1 0 1.06l-16.5 16.5a.75.75 0 0 1-1.06-1.06l16.5-16.5a.75.75 0 0 1 1.06 0Zm0 6a.75.75 0 0 1 0 1.06l-10.5 10.5a.75.75 0 0 1-1.06-1.06l10.5-10.5a.75.75 0 0 1 1.06 0Zm0 6a.75.75 0 0 1 0 1.06l-4.5 4.5a.75.75 0 1 1-1.06-1.06l4.5-4.5a.75.75 0 0 1 1.06 0Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const vj = { render: Sg }, mj = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: vj,
  render: Sg
}, Symbol.toStringTag, { value: "Module" })), Cj = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function xg(e, t) {
  return f(), v("svg", Cj, [...t[0] || (t[0] = [
    g("g", { class: "backspace" }, [
      g("path", {
        d: "M16.65 16.5H7.66c-.28 0-.46 0-.66-.05-.17-.04-.34-.11-.5-.21-.18-.11-.31-.24-.5-.43l-4.43-4.43C1.21 11.01 1 10.51 1 10c0-.51.21-1.02.57-1.38L6 4.19c.19-.19.32-.32.5-.43.15-.09.32-.17.5-.21.2-.05.37-.05.66-.05h8.99c.64 0 1.02 0 1.39.19.33.17.6.43.77.76.19.38.19.76.19 1.4v8.3c0 .63 0 1.02-.19 1.39-.17.34-.44.6-.77.77-.37.19-.76.19-1.39.19ZM7.66 5c-.289 0-.389.029-.6.24L2.63 9.68c-.09.08-.13.2-.13.32s.05.24.13.32l4.43 4.43c.207.207.308.23.6.25h8.99c.31 0 .64 0 .72-.03a.29.29 0 0 0 .11-.11c.03-.07.03-.4.03-.71v-8.3c0-.31 0-.64-.03-.72a.217.217 0 0 0-.11-.1C17.3 5 16.97 5 16.66 5h-9Zm6.59 8c-.19 0-.38-.07-.53-.22L12 11.06l-1.72 1.72c-.29.29-.77.29-1.06 0a.754.754 0 0 1 0-1.06L10.94 10 9.22 8.28a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0L12 8.94l1.72-1.72c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06L13.06 10l1.72 1.72c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22Z",
        class: "Icon"
      })
    ], -1)
  ])]);
}
const wj = { render: xg }, bj = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: wj,
  render: xg
}, Symbol.toStringTag, { value: "Module" })), yj = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Mg(e, t) {
  return f(), v("svg", yj, [...t[0] || (t[0] = [
    g("g", { class: "backward" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10.36 4.093a.75.75 0 0 1 .39.657v3.884l7.097-4.517A.75.75 0 0 1 19 4.75v10.5a.75.75 0 0 1-1.153.633l-7.097-4.517v3.884a.75.75 0 0 1-1.153.633l-8.25-5.25a.75.75 0 0 1 0-1.266l8.25-5.25a.75.75 0 0 1 .764-.024ZM9.25 6.116 3.147 10l6.103 3.884V6.116ZM11.397 10l6.103 3.884V6.116L11.397 10Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const _j = { render: Mg }, Sj = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _j,
  render: Mg
}, Symbol.toStringTag, { value: "Module" })), xj = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Ag(e, t) {
  return f(), v("svg", xj, [...t[0] || (t[0] = [
    g("g", { class: "bank" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M9.64 1.092a.75.75 0 0 1 .72 0l8.25 4.5A.75.75 0 0 1 18.25 7H1.75a.75.75 0 0 1-.36-1.408l8.25-4.5ZM4.692 5.5H15.31L10 2.604 4.691 5.5ZM2 8.75A.75.75 0 0 1 2.75 8h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 8.75ZM4 11a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 4 11Zm4 0a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 8 11Zm4 0a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 12 11Zm4 0a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 16 11ZM1 18.25a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H1.75a.75.75 0 0 1-.75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Mj = { render: Ag }, Aj = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Mj,
  render: Ag
}, Symbol.toStringTag, { value: "Module" })), Lj = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Lg(e, t) {
  return f(), v("svg", Lj, [...t[0] || (t[0] = [
    g("g", { class: "battery-charging" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M9.817 3.032a.75.75 0 0 1 .53.782l-.32 3.731h2.723a.75.75 0 0 1 .663 1.1l-4.2 7.955a.75.75 0 0 1-1.411-.4l.247-3.745H5.25a.75.75 0 0 1-.658-1.11l4.35-7.955a.75.75 0 0 1 .875-.358Zm-3.302 7.922H8.85a.75.75 0 0 1 .748.8l-.068 1.033 1.976-3.742H9.21a.75.75 0 0 1-.747-.814l.085-.994-2.033 3.717ZM4.847 4h.028a.75.75 0 1 1 0 1.5c-.536 0-.896 0-1.174.022-.27.02-.4.058-.485.098a1.25 1.25 0 0 0-.596.596c-.04.085-.078.215-.098.485-.021.278-.022.638-.022 1.174v4.25c0 .536 0 .896.022 1.174.02.27.058.4.098.485.124.262.334.472.596.596.085.04.215.077.485.098.278.021.638.022 1.174.022a.75.75 0 0 1 0 1.5h-.028c-.501 0-.919 0-1.26-.026-.357-.027-.692-.087-1.013-.238a2.75 2.75 0 0 1-1.31-1.31c-.151-.32-.21-.656-.238-1.012C1 13.072 1 12.654 1 12.154V7.846c0-.501 0-.919.026-1.26.028-.357.087-.692.238-1.013a2.75 2.75 0 0 1 1.31-1.31c.32-.151.656-.21 1.012-.238C3.928 4 4.346 4 4.846 4Zm9.452 1.522a17.145 17.145 0 0 0-1.174-.022.75.75 0 0 1 0-1.5h.028c.501 0 .919 0 1.26.026.357.028.692.087 1.013.238a2.75 2.75 0 0 1 1.31 1.31c.151.32.21.656.238 1.012.026.342.026.76.026 1.26v4.307c0 .5 0 .919-.026 1.26-.027.357-.087.692-.238 1.013a2.75 2.75 0 0 1-1.31 1.31c-.32.151-.656.21-1.012.238-.342.026-.76.026-1.26.026h-.029a.75.75 0 0 1 0-1.5c.536 0 .896 0 1.174-.022.27-.02.4-.057.485-.098a1.25 1.25 0 0 0 .596-.596c.04-.085.077-.215.098-.485.021-.278.022-.638.022-1.174v-4.25c0-.536 0-.896-.022-1.174-.02-.27-.057-.4-.098-.485a1.25 1.25 0 0 0-.596-.596c-.085-.04-.215-.078-.485-.098ZM18.25 8a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0v-2.5a.75.75 0 0 1 .75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Ej = { render: Lg }, Pj = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ej,
  render: Lg
}, Symbol.toStringTag, { value: "Module" })), Rj = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Eg(e, t) {
  return f(), v("svg", Rj, [...t[0] || (t[0] = [
    g("g", { class: "battery-empty" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M4.92 4h8.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 16.7 5.502c.172.337.24.693.27 1.073.03.365.03.81.03 1.345v4.16c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073a2.751 2.751 0 0 1-1.2 1.202c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03H4.92c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 1.3 14.5c-.172-.338-.24-.694-.27-1.074C1 13.06 1 12.615 1 12.08V7.92c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 2.502 4.3c.337-.172.693-.24 1.073-.27C3.94 4 4.385 4 4.92 4ZM3.697 5.525c-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.547c-.046.09-.088.227-.111.514-.024.296-.025.68-.025 1.253v4.1c0 .572 0 .957.025 1.252.023.288.065.425.111.516.12.235.311.426.547.546.09.046.227.088.514.111.296.024.68.025 1.253.025h8.1c.572 0 .957 0 1.252-.025.288-.023.425-.065.516-.111a1.25 1.25 0 0 0 .546-.546c.046-.091.088-.228.111-.515.024-.296.025-.68.025-1.253v-4.1c0-.572 0-.957-.025-1.253-.023-.287-.065-.424-.111-.514a1.25 1.25 0 0 0-.546-.547c-.091-.046-.228-.088-.515-.111-.296-.024-.68-.025-1.253-.025h-8.1c-.572 0-.957 0-1.253.025ZM18.25 8a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0v-2.5a.75.75 0 0 1 .75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Fj = { render: Eg }, Tj = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Fj,
  render: Eg
}, Symbol.toStringTag, { value: "Module" })), Ij = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Pg(e, t) {
  return f(), v("svg", Ij, [...t[0] || (t[0] = [
    g("g", { class: "battery-full" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M4.92 4h8.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 16.7 5.502c.172.337.24.693.27 1.073.03.365.03.81.03 1.345v4.16c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073a2.751 2.751 0 0 1-1.2 1.202c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03H4.92c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 1.3 14.5c-.172-.338-.24-.694-.27-1.074C1 13.06 1 12.615 1 12.08V7.92c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 2.502 4.3c.337-.172.693-.24 1.073-.27C3.94 4 4.385 4 4.92 4ZM3.697 5.525c-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.547c-.046.09-.088.227-.111.514-.024.296-.025.68-.025 1.253v4.1c0 .572 0 .957.025 1.252.023.288.065.425.111.516.12.235.311.426.547.546.09.046.227.088.514.111.296.024.68.025 1.253.025h8.1c.572 0 .957 0 1.252-.025.288-.023.425-.065.516-.111a1.25 1.25 0 0 0 .546-.546c.046-.091.088-.228.111-.515.024-.296.025-.68.025-1.253v-4.1c0-.572 0-.957-.025-1.253-.023-.287-.065-.424-.111-.514a1.25 1.25 0 0 0-.546-.547c-.091-.046-.228-.088-.515-.111-.296-.024-.68-.025-1.253-.025h-8.1c-.572 0-.957 0-1.253.025ZM4.75 7a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0v-4.5A.75.75 0 0 1 4.75 7Zm4 0a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0v-4.5A.75.75 0 0 1 8.75 7Zm4 0a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0v-4.5a.75.75 0 0 1 .75-.75Zm5.5 1a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0v-2.5a.75.75 0 0 1 .75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Dj = { render: Pg }, kj = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Dj,
  render: Pg
}, Symbol.toStringTag, { value: "Module" })), Hj = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Rg(e, t) {
  return f(), v("svg", Hj, [...t[0] || (t[0] = [
    g("g", { class: "battery-low" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M4.92 4h8.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 16.7 5.502c.172.337.24.693.27 1.073.03.365.03.81.03 1.345v4.16c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073a2.751 2.751 0 0 1-1.2 1.202c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03H4.92c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 1.3 14.5c-.172-.338-.24-.694-.27-1.074C1 13.06 1 12.615 1 12.08V7.92c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 2.502 4.3c.337-.172.693-.24 1.073-.27C3.94 4 4.385 4 4.92 4ZM3.697 5.525c-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.547c-.046.09-.088.227-.111.514-.024.296-.025.68-.025 1.253v4.1c0 .572 0 .957.025 1.252.023.288.065.425.111.516.12.235.311.426.547.546.09.046.227.088.514.111.296.024.68.025 1.253.025h8.1c.572 0 .957 0 1.252-.025.288-.023.425-.065.516-.111a1.25 1.25 0 0 0 .546-.546c.046-.091.088-.228.111-.515.024-.296.025-.68.025-1.253v-4.1c0-.572 0-.957-.025-1.253-.023-.287-.065-.424-.111-.514a1.25 1.25 0 0 0-.546-.547c-.091-.046-.228-.088-.515-.111-.296-.024-.68-.025-1.253-.025h-8.1c-.572 0-.957 0-1.253.025ZM4.75 7a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0v-4.5A.75.75 0 0 1 4.75 7Zm13.5 1a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0v-2.5a.75.75 0 0 1 .75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Vj = { render: Rg }, Oj = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Vj,
  render: Rg
}, Symbol.toStringTag, { value: "Module" })), Bj = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Fg(e, t) {
  return f(), v("svg", Bj, [...t[0] || (t[0] = [
    g("g", { class: "battery-medium" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M4.92 4h8.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 16.7 5.502c.172.337.24.693.27 1.073.03.365.03.81.03 1.345v4.16c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073a2.751 2.751 0 0 1-1.2 1.202c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03H4.92c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 1.3 14.5c-.172-.338-.24-.694-.27-1.074C1 13.06 1 12.615 1 12.08V7.92c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 2.502 4.3c.337-.172.693-.24 1.073-.27C3.94 4 4.385 4 4.92 4ZM3.697 5.525c-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.547c-.046.09-.088.227-.111.514-.024.296-.025.68-.025 1.253v4.1c0 .572 0 .957.025 1.252.023.288.065.425.111.516.12.235.311.426.547.546.09.046.227.088.514.111.296.024.68.025 1.253.025h8.1c.572 0 .957 0 1.252-.025.288-.023.425-.065.516-.111a1.25 1.25 0 0 0 .546-.546c.046-.091.088-.228.111-.515.024-.296.025-.68.025-1.253v-4.1c0-.572 0-.957-.025-1.253-.023-.287-.065-.424-.111-.514a1.25 1.25 0 0 0-.546-.547c-.091-.046-.228-.088-.515-.111-.296-.024-.68-.025-1.253-.025h-8.1c-.572 0-.957 0-1.253.025ZM4.75 7a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0v-4.5A.75.75 0 0 1 4.75 7Zm4 0a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0v-4.5A.75.75 0 0 1 8.75 7Zm9.5 1a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0v-2.5a.75.75 0 0 1 .75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const $j = { render: Fg }, Zj = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: $j,
  render: Fg
}, Symbol.toStringTag, { value: "Module" })), Gj = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Tg(e, t) {
  return f(), v("svg", Gj, [...t[0] || (t[0] = [
    g("g", { class: "bell" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M4.56 5.176C4.806 2.703 6.924 1 9.366 1h1.268c2.442 0 4.56 1.703 4.806 4.176v.004l.423 4.496v.002c.14 1.393.741 2.799 1.69 3.808.52.551.524 1.315.323 1.862-.202.548-.72 1.152-1.535 1.152h-3.383a3 3 0 0 1-5.917 0H3.66c-.815 0-1.333-.604-1.535-1.152-.201-.547-.197-1.31.322-1.862.95-1.009 1.551-2.415 1.69-3.808l.424-4.502ZM16.34 15h.007c.002-.002.01-.005.023-.016a.483.483 0 0 0 .127-.375c-.008-.06-.026-.085-.035-.095-1.197-1.27-1.923-2.995-2.091-4.69V9.82l-.424-4.496v-.002C13.784 3.698 12.389 2.5 10.634 2.5H9.365c-1.755 0-3.15 1.198-3.313 2.822v.002l-.424 4.5c-.168 1.695-.895 3.42-2.09 4.69-.01.01-.028.036-.036.095a.482.482 0 0 0 .127.375.086.086 0 0 0 .023.015l.006.001H16.34Zm-7.755 1.5a1.5 1.5 0 0 0 2.83 0h-2.83Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Nj = { render: Tg }, zj = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Nj,
  render: Tg
}, Symbol.toStringTag, { value: "Module" })), jj = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Ig(e, t) {
  return f(), v("svg", jj, [...t[0] || (t[0] = [
    g("g", { class: "block" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10 2.5a7.5 7.5 0 0 0-5.807 12.246L14.746 4.193A7.469 7.469 0 0 0 10 2.5Zm5.807 2.753L5.253 15.807A7.5 7.5 0 0 0 15.807 5.253ZM1 10a9 9 0 1 1 18 0 9 9 0 0 1-18 0Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Wj = { render: Ig }, Uj = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Wj,
  render: Ig
}, Symbol.toStringTag, { value: "Module" })), Kj = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Dg(e, t) {
  return f(), v("svg", Kj, [...t[0] || (t[0] = [
    g("g", { class: "bluetooth-off" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M9.443 1.066a.75.75 0 0 1 .805.123l4.5 4a.75.75 0 0 1 .032 1.091l-2 2a.75.75 0 1 1-1.06-1.06l1.437-1.438L10.5 3.42v2.33a.75.75 0 0 1-1.5 0v-4a.75.75 0 0 1 .443-.684Zm-8.24 1.17a.75.75 0 0 1 1.061-.032l7.991 7.521 4.489 3.96.002.003 3.998 3.498a.75.75 0 1 1-.988 1.128l-3.502-3.064-4.006 3.56A.75.75 0 0 1 9 18.25v-6.867l-2.754 2.43a.75.75 0 0 1-.992-1.125L8.33 9.973 1.236 3.296a.75.75 0 0 1-.032-1.06Zm9.297 9.705v4.639l2.619-2.328-2.619-2.31Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const qj = { render: Dg }, Yj = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: qj,
  render: Dg
}, Symbol.toStringTag, { value: "Module" })), Qj = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function kg(e, t) {
  return f(), v("svg", Qj, [...t[0] || (t[0] = [
    g("g", { class: "bluetooth" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M9.443 1.066a.75.75 0 0 1 .805.123l4.5 4a.75.75 0 0 1-.002 1.123L10.566 10l4.18 3.688a.75.75 0 0 1 .002 1.123l-4.5 4A.75.75 0 0 1 9 18.25v-6.867l-2.754 2.43a.75.75 0 0 1-.992-1.125L8.3 10 5.254 7.312a.75.75 0 1 1 .992-1.124L9 8.618V1.75a.75.75 0 0 1 .443-.684ZM10.5 11.94l2.619 2.311L10.5 16.58v-4.64Zm0-3.882V3.42l2.619 2.328-2.619 2.31Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Jj = { render: kg }, Xj = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Jj,
  render: kg
}, Symbol.toStringTag, { value: "Module" })), eW = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Hg(e, t) {
  return f(), v("svg", eW, [...t[0] || (t[0] = [
    g("g", { class: "bolt" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M11.261 1.047a.75.75 0 0 1 .485.784L11.186 7h5.064a.75.75 0 0 1 .624 1.166l-7 10.5a.75.75 0 0 1-1.371-.478L8.935 13H3.75a.75.75 0 0 1-.617-1.176l7.25-10.5a.75.75 0 0 1 .879-.277ZM5.18 11.5h4.57a.75.75 0 0 1 .747.812l-.258 3.103 4.61-6.915H10.35a.75.75 0 0 1-.746-.83l.332-3.058L5.179 11.5Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const tW = { render: Hg }, oW = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: tW,
  render: Hg
}, Symbol.toStringTag, { value: "Module" })), nW = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Vg(e, t) {
  return f(), v("svg", nW, [...t[0] || (t[0] = [
    g("g", { class: "book" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M7.36 3.62a9.258 9.258 0 0 0-2.97 0c-.344.055-.688.138-1.453.324a7.409 7.409 0 0 0-.298.078.25.25 0 0 0-.133.17 7.372 7.372 0 0 0-.006.307v11.32a9.442 9.442 0 0 0 .003.225.25.25 0 0 0 .31.204c.04-.008.093-.021.18-.042l.015-.004c.333-.08.519-.126.705-.164a10.757 10.757 0 0 1 4.324 0c.186.038.372.084.705.164l.508.123V4.05l-.437-.105c-.765-.186-1.11-.269-1.453-.324Zm3.39.43v12.275l.508-.123c.333-.08.519-.126.705-.164a10.757 10.757 0 0 1 4.324 0c.186.038.372.084.705.164l.015.004c.087.02.14.034.18.042l.037.008a.25.25 0 0 0 .275-.253l.001-.184V4.5a7.262 7.262 0 0 0-.006-.308.25.25 0 0 0-.133-.17 7.358 7.358 0 0 0-.298-.078c-.765-.185-1.11-.268-1.453-.323a9.257 9.257 0 0 0-2.97 0c-.344.055-.688.138-1.453.324l-.437.106ZM4.149 2.139a10.758 10.758 0 0 1 3.452 0c.407.066.81.164 1.531.339l.67.162.144.034.03.005a.251.251 0 0 0 .048 0l.03-.005.144-.034.67-.162c.722-.175 1.124-.273 1.531-.339a10.758 10.758 0 0 1 3.452 0c.407.066.81.164 1.531.339l.034.008.047.011c.185.045.38.091.552.175.482.234.83.677.945 1.2.04.188.04.388.04.578v11.406c0 .132 0 .268-.016.386a1.75 1.75 0 0 1-1.915 1.506 2.988 2.988 0 0 1-.38-.076l-.035-.008a20.3 20.3 0 0 0-.668-.156 9.26 9.26 0 0 0-3.722 0 20.3 20.3 0 0 0-.668.156l-1.044.253a10.96 10.96 0 0 1-.027.006c-.112.027-.23.056-.355.068a1.748 1.748 0 0 1-.34 0 2.426 2.426 0 0 1-.355-.068 10.88 10.88 0 0 1-.027-.006l-1.044-.253a20.319 20.319 0 0 0-.668-.156 9.26 9.26 0 0 0-3.722 0c-.157.032-.316.07-.668.156l-.036.008c-.128.032-.26.064-.38.076a1.75 1.75 0 0 1-1.914-1.506C1 16.125 1 15.989 1 15.857V4.449c0-.189 0-.389.04-.576a1.75 1.75 0 0 1 .945-1.201c.173-.084.367-.13.551-.175l.048-.011.034-.008c.722-.175 1.124-.273 1.53-.339Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const sW = { render: Vg }, iW = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sW,
  render: Vg
}, Symbol.toStringTag, { value: "Module" })), rW = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Og(e, t) {
  return f(), v("svg", rW, [...t[0] || (t[0] = [
    g("g", { class: "bookmark" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M3 3.75A2.75 2.75 0 0 1 5.75 1h8.5A2.75 2.75 0 0 1 17 3.75v14.5a.75.75 0 0 1-1.075.676l-5.384-2.584a1.25 1.25 0 0 0-1.082 0l-5.384 2.584A.75.75 0 0 1 3 18.25V3.75ZM5.75 2.5c-.69 0-1.25.56-1.25 1.25v13.308l4.31-2.069a2.75 2.75 0 0 1 2.38 0l4.31 2.07V3.75c0-.69-.56-1.25-1.25-1.25h-8.5Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const lW = { render: Og }, aW = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: lW,
  render: Og
}, Symbol.toStringTag, { value: "Module" })), cW = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Bg(e, t) {
  return f(), v("svg", cW, [...t[0] || (t[0] = [
    g("g", { class: "border-all" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M3.324 1h13.352c.258 0 .494 0 .692.016.213.018.446.057.677.175.329.168.596.435.764.765.118.23.157.463.175.676.016.198.016.434.016.692v13.352c0 .258 0 .494-.016.692a1.775 1.775 0 0 1-.175.677 1.75 1.75 0 0 1-.765.764 1.77 1.77 0 0 1-.676.175c-.198.016-.434.016-.692.016H3.324c-.258 0-.494 0-.692-.016a1.775 1.775 0 0 1-.676-.175 1.75 1.75 0 0 1-.765-.765 1.774 1.774 0 0 1-.175-.676C1 17.17 1 16.934 1 16.676V3.324c0-.258 0-.494.016-.692a1.77 1.77 0 0 1 .175-.676 1.75 1.75 0 0 1 .765-.765 1.77 1.77 0 0 1 .676-.175C2.83 1 3.066 1 3.324 1ZM2.5 10.75v5.9c0 .292 0 .467.011.596a.625.625 0 0 0 .018.12.25.25 0 0 0 .104.105.638.638 0 0 0 .121.018c.13.01.304.011.596.011h5.9v-6.75H2.5Zm6.75-1.5H2.5v-5.9c0-.292 0-.467.011-.596a.626.626 0 0 1 .018-.12.25.25 0 0 1 .104-.105.626.626 0 0 1 .121-.018c.13-.01.304-.011.596-.011h5.9v6.75Zm1.5 1.5v6.75h5.9c.292 0 .467 0 .596-.011a.636.636 0 0 0 .12-.018.25.25 0 0 0 .105-.105.636.636 0 0 0 .018-.12c.01-.13.011-.304.011-.596v-5.9h-6.75Zm6.75-1.5h-6.75V2.5h5.9c.292 0 .467 0 .596.011a.625.625 0 0 1 .12.018.25.25 0 0 1 .105.104.638.638 0 0 1 .018.121c.01.13.011.304.011.596v5.9Zm-.03-6.62v.002-.001Zm-.1-.1h-.002.001Zm0 14.94h-.002.001ZM2.63 2.53h.002-.001Zm-.1.102a.01.01 0 0 1 0-.001v.001Zm.1 14.838h.002-.001Zm-.1-.1v-.002.001Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const dW = { render: Bg }, uW = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: dW,
  render: Bg
}, Symbol.toStringTag, { value: "Module" })), hW = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function $g(e, t) {
  return f(), v("svg", hW, [...t[0] || (t[0] = [
    g("g", { class: "border-bottom" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M3.324 1H5.25a.75.75 0 1 1 0 1.5h-1.9c-.292 0-.467 0-.596.011a.626.626 0 0 0-.12.018.25.25 0 0 0-.105.104.626.626 0 0 0-.018.121c-.01.13-.011.304-.011.596v1.9a.75.75 0 1 1-1.5 0V3.324c0-.258 0-.494.016-.692a1.77 1.77 0 0 1 .175-.676 1.75 1.75 0 0 1 .765-.765 1.77 1.77 0 0 1 .676-.175C2.83 1 3.066 1 3.324 1ZM2.53 2.63v.002-.001Zm.1-.1h.002-.001Zm14.616-.019a8.336 8.336 0 0 0-.596-.011h-1.9a.75.75 0 0 1 0-1.5h1.926c.258 0 .494 0 .692.016.213.018.446.057.677.175.329.168.596.435.764.765.118.23.157.463.175.676.016.198.016.434.016.692V5.25a.75.75 0 0 1-1.5 0v-1.9c0-.292 0-.467-.011-.596a.638.638 0 0 0-.018-.12.25.25 0 0 0-.105-.105.625.625 0 0 0-.12-.018Zm.123.019h-.001.001Zm.101.1v.002-.001ZM8 1.75A.75.75 0 0 1 8.75 1h2.5a.75.75 0 0 1 0 1.5h-2.5A.75.75 0 0 1 8 1.75Zm2 5a.75.75 0 0 1 .75.75v1.75h1.75a.75.75 0 0 1 0 1.5h-1.75v1.75a.75.75 0 0 1-1.5 0v-1.75H7.5a.75.75 0 0 1 0-1.5h1.75V7.5a.75.75 0 0 1 .75-.75ZM1.75 8a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0v-2.5A.75.75 0 0 1 1.75 8Zm16.5 0a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0v-2.5a.75.75 0 0 1 .75-.75ZM1 18.25a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H1.75a.75.75 0 0 1-.75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const gW = { render: $g }, pW = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: gW,
  render: $g
}, Symbol.toStringTag, { value: "Module" })), fW = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Zg(e, t) {
  return f(), v("svg", fW, [...t[0] || (t[0] = [
    g("g", { class: "border-horizontal" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M3.324 1H5.25a.75.75 0 1 1 0 1.5h-1.9c-.292 0-.467 0-.596.011a.626.626 0 0 0-.12.018.25.25 0 0 0-.105.104.626.626 0 0 0-.018.121c-.01.13-.011.304-.011.596v1.9a.75.75 0 1 1-1.5 0V3.324c0-.258 0-.494.016-.692a1.77 1.77 0 0 1 .175-.676 1.75 1.75 0 0 1 .765-.765 1.77 1.77 0 0 1 .676-.175C2.83 1 3.066 1 3.324 1ZM2.53 2.63v.002-.001Zm.1-.1h.002-.001Zm14.616-.019a8.336 8.336 0 0 0-.596-.011h-1.9a.75.75 0 0 1 0-1.5h1.926c.258 0 .494 0 .692.016.213.018.446.057.677.175.329.168.596.435.764.765.118.23.157.463.175.676.016.198.016.434.016.692V5.25a.75.75 0 0 1-1.5 0v-1.9c0-.292 0-.467-.011-.596a.638.638 0 0 0-.018-.12.25.25 0 0 0-.105-.105.625.625 0 0 0-.12-.018Zm.123.019h-.001.001Zm.101.1v.002-.001ZM8 1.75A.75.75 0 0 1 8.75 1h2.5a.75.75 0 0 1 0 1.5h-2.5A.75.75 0 0 1 8 1.75ZM1 10a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H1.75A.75.75 0 0 1 1 10Zm.75 4a.75.75 0 0 1 .75.75v1.9c0 .292 0 .467.011.596a.625.625 0 0 0 .018.12.25.25 0 0 0 .104.105.638.638 0 0 0 .121.018c.13.01.304.011.596.011h1.9a.75.75 0 0 1 0 1.5H3.324c-.258 0-.494 0-.692-.016a1.775 1.775 0 0 1-.676-.175 1.75 1.75 0 0 1-.765-.765 1.774 1.774 0 0 1-.175-.676C1 17.17 1 16.934 1 16.676V14.75a.75.75 0 0 1 .75-.75Zm.88 3.47h.002-.001Zm-.1-.1v-.002.001ZM18.25 14a.75.75 0 0 1 .75.75v1.926c0 .258 0 .494-.016.692a1.775 1.775 0 0 1-.175.677 1.75 1.75 0 0 1-.765.764 1.77 1.77 0 0 1-.676.175c-.198.016-.434.016-.692.016H14.75a.75.75 0 0 1 0-1.5h1.9c.292 0 .467 0 .596-.011a.636.636 0 0 0 .12-.018.25.25 0 0 0 .105-.105.636.636 0 0 0 .018-.12c.01-.13.011-.304.011-.596v-1.9a.75.75 0 0 1 .75-.75Zm-.88 3.47h-.002.001ZM8 18.25a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const vW = { render: Zg }, mW = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: vW,
  render: Zg
}, Symbol.toStringTag, { value: "Module" })), CW = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Gg(e, t) {
  return f(), v("svg", CW, [...t[0] || (t[0] = [
    g("g", { class: "border-inner" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M3.324 1H5.25a.75.75 0 1 1 0 1.5h-1.9c-.292 0-.467 0-.596.011a.626.626 0 0 0-.12.018.25.25 0 0 0-.105.104.626.626 0 0 0-.018.121c-.01.13-.011.304-.011.596v1.9a.75.75 0 1 1-1.5 0V3.324c0-.258 0-.494.016-.692a1.77 1.77 0 0 1 .175-.676 1.75 1.75 0 0 1 .765-.765 1.77 1.77 0 0 1 .676-.175C2.83 1 3.066 1 3.324 1ZM2.53 2.63v.002-.001Zm.1-.1h.002-.001Zm14.616-.019a8.336 8.336 0 0 0-.596-.011h-1.9a.75.75 0 0 1 0-1.5h1.926c.258 0 .494 0 .692.016.213.018.446.057.677.175.329.168.596.435.764.765.118.23.157.463.175.676.016.198.016.434.016.692V5.25a.75.75 0 0 1-1.5 0v-1.9c0-.292 0-.467-.011-.596a.638.638 0 0 0-.018-.12.25.25 0 0 0-.105-.105.625.625 0 0 0-.12-.018Zm.123.019h-.001.001Zm.101.1v.002-.001ZM10 2a.75.75 0 0 1 .75.75v6.5h6.5a.75.75 0 0 1 0 1.5h-6.5v6.5a.75.75 0 0 1-1.5 0v-6.5h-6.5a.75.75 0 0 1 0-1.5h6.5v-6.5A.75.75 0 0 1 10 2ZM1.75 14a.75.75 0 0 1 .75.75v1.9c0 .292 0 .467.011.596a.625.625 0 0 0 .018.12.25.25 0 0 0 .104.105.638.638 0 0 0 .121.018c.13.01.304.011.596.011h1.9a.75.75 0 0 1 0 1.5H3.324c-.258 0-.494 0-.692-.016a1.775 1.775 0 0 1-.676-.175 1.75 1.75 0 0 1-.765-.765 1.774 1.774 0 0 1-.175-.676C1 17.17 1 16.934 1 16.676V14.75a.75.75 0 0 1 .75-.75Zm.88 3.47h.002-.001Zm-.1-.1v-.002.001ZM18.25 14a.75.75 0 0 1 .75.75v1.926c0 .258 0 .494-.016.692a1.775 1.775 0 0 1-.175.677 1.75 1.75 0 0 1-.765.764 1.77 1.77 0 0 1-.676.175c-.198.016-.434.016-.692.016H14.75a.75.75 0 0 1 0-1.5h1.9c.292 0 .467 0 .596-.011a.636.636 0 0 0 .12-.018.25.25 0 0 0 .105-.105.636.636 0 0 0 .018-.12c.01-.13.011-.304.011-.596v-1.9a.75.75 0 0 1 .75-.75Zm-.88 3.47h-.002.001Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const wW = { render: Gg }, bW = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: wW,
  render: Gg
}, Symbol.toStringTag, { value: "Module" })), yW = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Ng(e, t) {
  return f(), v("svg", yW, [...t[0] || (t[0] = [
    g("g", { class: "border-left" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M17.246 2.511a8.336 8.336 0 0 0-.596-.011h-1.9a.75.75 0 0 1 0-1.5h1.926c.258 0 .494 0 .692.016.213.018.446.057.677.175.329.168.596.435.764.765.118.23.157.463.175.676.016.198.016.434.016.692V5.25a.75.75 0 0 1-1.5 0v-1.9c0-.292 0-.467-.011-.596a.638.638 0 0 0-.018-.12.25.25 0 0 0-.105-.105.625.625 0 0 0-.12-.018Zm.123.019h-.001.001Zm.101.1v.002-.001ZM1.75 1a.75.75 0 0 1 .75.75v16.5a.75.75 0 0 1-1.5 0V1.75A.75.75 0 0 1 1.75 1ZM8 1.75A.75.75 0 0 1 8.75 1h2.5a.75.75 0 0 1 0 1.5h-2.5A.75.75 0 0 1 8 1.75Zm2 5a.75.75 0 0 1 .75.75v1.75h1.75a.75.75 0 0 1 0 1.5h-1.75v1.75a.75.75 0 0 1-1.5 0v-1.75H7.5a.75.75 0 0 1 0-1.5h1.75V7.5a.75.75 0 0 1 .75-.75ZM18.25 8a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0v-2.5a.75.75 0 0 1 .75-.75Zm0 6a.75.75 0 0 1 .75.75v1.926c0 .258 0 .494-.016.692a1.775 1.775 0 0 1-.175.677 1.75 1.75 0 0 1-.765.764 1.77 1.77 0 0 1-.676.175c-.198.016-.434.016-.692.016H14.75a.75.75 0 0 1 0-1.5h1.9c.292 0 .467 0 .596-.011a.636.636 0 0 0 .12-.018.25.25 0 0 0 .105-.105.636.636 0 0 0 .018-.12c.01-.13.011-.304.011-.596v-1.9a.75.75 0 0 1 .75-.75Zm-.88 3.47h-.002.001ZM8 18.25a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const _W = { render: Ng }, SW = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _W,
  render: Ng
}, Symbol.toStringTag, { value: "Module" })), xW = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function zg(e, t) {
  return f(), v("svg", xW, [...t[0] || (t[0] = [
    g("g", { class: "border-right" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M3.324 1h.926a.75.75 0 1 1 0 1.5h-.9c-.292 0-.467 0-.596.011a.626.626 0 0 0-.12.018.25.25 0 0 0-.105.104.626.626 0 0 0-.018.121c-.01.13-.011.304-.011.596v.9a.75.75 0 1 1-1.5 0v-.926c0-.258 0-.494.016-.692a1.77 1.77 0 0 1 .175-.676 1.75 1.75 0 0 1 .765-.765 1.77 1.77 0 0 1 .676-.175C2.83 1 3.066 1 3.324 1ZM2.53 2.63v.002-.001Zm.1-.1h.002-.001ZM8 1.75A.75.75 0 0 1 8.75 1h2.5a.75.75 0 0 1 0 1.5h-2.5A.75.75 0 0 1 8 1.75ZM18.25 1a.75.75 0 0 1 .75.75v16.5a.75.75 0 0 1-1.5 0V1.75a.75.75 0 0 1 .75-.75ZM10 6.75a.75.75 0 0 1 .75.75v1.75h1.75a.75.75 0 0 1 0 1.5h-1.75v1.75a.75.75 0 0 1-1.5 0v-1.75H7.5a.75.75 0 0 1 0-1.5h1.75V7.5a.75.75 0 0 1 .75-.75ZM1.75 8a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0v-2.5A.75.75 0 0 1 1.75 8Zm0 7a.75.75 0 0 1 .75.75v.9c0 .292 0 .467.011.596a.625.625 0 0 0 .018.12.25.25 0 0 0 .104.105.638.638 0 0 0 .121.018c.13.01.304.011.596.011h.9a.75.75 0 0 1 0 1.5h-.926c-.258 0-.494 0-.692-.016a1.775 1.775 0 0 1-.676-.175 1.75 1.75 0 0 1-.765-.765 1.774 1.774 0 0 1-.175-.676C1 17.17 1 16.934 1 16.676v-.926a.75.75 0 0 1 .75-.75Zm.88 2.47h.002-.001Zm-.1-.1v-.002.001Zm5.47.88a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const MW = { render: zg }, AW = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: MW,
  render: zg
}, Symbol.toStringTag, { value: "Module" })), LW = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function jg(e, t) {
  return f(), v("svg", LW, [...t[0] || (t[0] = [
    g("g", { class: "border-style" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M3.324 1H17.25a.75.75 0 0 1 0 1.5H3.35c-.292 0-.467 0-.596.011a.626.626 0 0 0-.12.018.25.25 0 0 0-.105.104.626.626 0 0 0-.018.121c-.01.13-.011.304-.011.596v13.9a.75.75 0 0 1-1.5 0V3.324c0-.258 0-.494.016-.692a1.77 1.77 0 0 1 .175-.676 1.75 1.75 0 0 1 .765-.765 1.77 1.77 0 0 1 .676-.175C2.83 1 3.066 1 3.324 1ZM2.53 2.63v.002-.001Zm.1-.1h.002-.001ZM10 6.75a.75.75 0 0 1 .75.75v1.75h1.75a.75.75 0 0 1 0 1.5h-1.75v1.75a.75.75 0 0 1-1.5 0v-1.75H7.5a.75.75 0 0 1 0-1.5h1.75V7.5a.75.75 0 0 1 .75-.75ZM18.25 8a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0v-2.5a.75.75 0 0 1 .75-.75Zm0 6a.75.75 0 0 1 .75.75v1.926c0 .258 0 .494-.016.692a1.775 1.775 0 0 1-.175.677 1.75 1.75 0 0 1-.765.764 1.77 1.77 0 0 1-.676.175c-.198.016-.434.016-.692.016H14.75a.75.75 0 0 1 0-1.5h1.9c.292 0 .467 0 .596-.011a.636.636 0 0 0 .12-.018.25.25 0 0 0 .105-.105.636.636 0 0 0 .018-.12c.01-.13.011-.304.011-.596v-1.9a.75.75 0 0 1 .75-.75Zm-.88 3.47h-.002.001ZM8 18.25a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const EW = { render: jg }, PW = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: EW,
  render: jg
}, Symbol.toStringTag, { value: "Module" })), RW = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Wg(e, t) {
  return f(), v("svg", RW, [...t[0] || (t[0] = [
    g("g", { class: "border-top" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M1 1.75A.75.75 0 0 1 1.75 1h16.5a.75.75 0 0 1 0 1.5H1.75A.75.75 0 0 1 1 1.75Zm9 5a.75.75 0 0 1 .75.75v1.75h1.75a.75.75 0 0 1 0 1.5h-1.75v1.75a.75.75 0 0 1-1.5 0v-1.75H7.5a.75.75 0 0 1 0-1.5h1.75V7.5a.75.75 0 0 1 .75-.75ZM1.75 8a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0v-2.5A.75.75 0 0 1 1.75 8Zm16.5 0a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0v-2.5a.75.75 0 0 1 .75-.75Zm-16.5 6a.75.75 0 0 1 .75.75v1.9c0 .292 0 .467.011.596a.625.625 0 0 0 .018.12.25.25 0 0 0 .104.105.638.638 0 0 0 .121.018c.13.01.304.011.596.011h1.9a.75.75 0 0 1 0 1.5H3.324c-.258 0-.494 0-.692-.016a1.775 1.775 0 0 1-.676-.175 1.75 1.75 0 0 1-.765-.765 1.774 1.774 0 0 1-.175-.676C1 17.17 1 16.934 1 16.676V14.75a.75.75 0 0 1 .75-.75Zm.88 3.47h.002-.001Zm-.1-.1v-.002.001ZM18.25 14a.75.75 0 0 1 .75.75v1.926c0 .258 0 .494-.016.692a1.775 1.775 0 0 1-.175.677 1.75 1.75 0 0 1-.765.764 1.77 1.77 0 0 1-.676.175c-.198.016-.434.016-.692.016H14.75a.75.75 0 0 1 0-1.5h1.9c.292 0 .467 0 .596-.011a.636.636 0 0 0 .12-.018.25.25 0 0 0 .105-.105.636.636 0 0 0 .018-.12c.01-.13.011-.304.011-.596v-1.9a.75.75 0 0 1 .75-.75Zm-.88 3.47h-.002.001ZM8 18.25a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const FW = { render: Wg }, TW = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: FW,
  render: Wg
}, Symbol.toStringTag, { value: "Module" })), IW = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Ug(e, t) {
  return f(), v("svg", IW, [...t[0] || (t[0] = [
    g("g", { class: "border-vertical" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M3.324 1H5.25a.75.75 0 1 1 0 1.5h-1.9c-.292 0-.467 0-.596.011a.626.626 0 0 0-.12.018.25.25 0 0 0-.105.104.626.626 0 0 0-.018.121c-.01.13-.011.304-.011.596v1.9a.75.75 0 1 1-1.5 0V3.324c0-.258 0-.494.016-.692a1.77 1.77 0 0 1 .175-.676 1.75 1.75 0 0 1 .765-.765 1.77 1.77 0 0 1 .676-.175C2.83 1 3.066 1 3.324 1ZM2.53 2.63v.002-.001Zm.1-.1h.002-.001Zm14.616-.019a8.336 8.336 0 0 0-.596-.011h-1.9a.75.75 0 0 1 0-1.5h1.926c.258 0 .494 0 .692.016.213.018.446.057.677.175.329.168.596.435.764.765.118.23.157.463.175.676.016.198.016.434.016.692V5.25a.75.75 0 0 1-1.5 0v-1.9c0-.292 0-.467-.011-.596a.638.638 0 0 0-.018-.12.25.25 0 0 0-.105-.105.625.625 0 0 0-.12-.018Zm.123.019h-.001.001Zm.101.1v.002-.001ZM10 1a.75.75 0 0 1 .75.75v16.5a.75.75 0 0 1-1.5 0V1.75A.75.75 0 0 1 10 1ZM1.75 8a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0v-2.5A.75.75 0 0 1 1.75 8Zm16.5 0a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0v-2.5a.75.75 0 0 1 .75-.75Zm-16.5 6a.75.75 0 0 1 .75.75v1.9c0 .292 0 .467.011.596a.625.625 0 0 0 .018.12.25.25 0 0 0 .104.105.638.638 0 0 0 .121.018c.13.01.304.011.596.011h1.9a.75.75 0 0 1 0 1.5H3.324c-.258 0-.494 0-.692-.016a1.775 1.775 0 0 1-.676-.175 1.75 1.75 0 0 1-.765-.765 1.774 1.774 0 0 1-.175-.676C1 17.17 1 16.934 1 16.676V14.75a.75.75 0 0 1 .75-.75Zm.88 3.47h.002-.001Zm-.1-.1v-.002.001ZM18.25 14a.75.75 0 0 1 .75.75v1.926c0 .258 0 .494-.016.692a1.775 1.775 0 0 1-.175.677 1.75 1.75 0 0 1-.765.764 1.77 1.77 0 0 1-.676.175c-.198.016-.434.016-.692.016H14.75a.75.75 0 0 1 0-1.5h1.9c.292 0 .467 0 .596-.011a.636.636 0 0 0 .12-.018.25.25 0 0 0 .105-.105.636.636 0 0 0 .018-.12c.01-.13.011-.304.011-.596v-1.9a.75.75 0 0 1 .75-.75Zm-.88 3.47h-.002.001Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const DW = { render: Ug }, kW = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: DW,
  render: Ug
}, Symbol.toStringTag, { value: "Module" })), HW = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 21 20"
};
function Kg(e, t) {
  return f(), v("svg", HW, [...t[0] || (t[0] = [
    g("g", { class: "brackets-curly" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M8.75 2.5A2.5 2.5 0 0 0 6.25 5v.136c0 1.375 0 2.427-.292 3.267-.226.65-.609 1.142-1.16 1.597.551.454.934.947 1.16 1.597.293.84.292 1.892.292 3.267V15a2.5 2.5 0 0 0 2.5 2.5H9A.75.75 0 0 1 9 19h-.25a4 4 0 0 1-4-4c0-1.558-.01-2.34-.208-2.91-.167-.477-.492-.862-1.44-1.454a.75.75 0 0 1 0-1.272c.948-.592 1.273-.977 1.44-1.454.198-.57.208-1.352.208-2.91a4 4 0 0 1 4-4H9a.75.75 0 0 1 0 1.5h-.25Zm3-.75A.75.75 0 0 1 12.5 1h.25a4 4 0 0 1 4 4c0 1.558.01 2.34.208 2.91.167.477.492.862 1.44 1.454a.75.75 0 0 1 0 1.272c-.948.592-1.273.977-1.44 1.454-.198.57-.208 1.352-.208 2.91a4 4 0 0 1-4 4h-.25a.75.75 0 0 1 0-1.5h.25a2.5 2.5 0 0 0 2.5-2.5v-.136c0-1.376 0-2.427.292-3.267.226-.65.609-1.143 1.16-1.597-.551-.455-.934-.947-1.16-1.597-.293-.84-.292-1.892-.292-3.267V5a2.5 2.5 0 0 0-2.5-2.5h-.25a.75.75 0 0 1-.75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const VW = { render: Kg }, OW = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: VW,
  render: Kg
}, Symbol.toStringTag, { value: "Module" })), BW = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function qg(e, t) {
  return f(), v("svg", BW, [...t[0] || (t[0] = [
    g("g", { class: "brain" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M7.62 2.5a1.62 1.62 0 0 0-1.61 1.367.75.75 0 0 1-.74.633h-.15a1.63 1.63 0 0 0-1.63 1.63c0 .229.05.458.13.645a.75.75 0 0 1-.315.944A1.62 1.62 0 0 0 2.5 9.13c0 .323.095.627.257.88a3.615 3.615 0 0 1 1.869-.52c.062-.213.147-.42.255-.612A3.124 3.124 0 0 1 4.5 7.38c0-.517.187-1.001.432-1.382.243-.378.587-.72.983-.919a.75.75 0 0 1 .67 1.342c-.104.052-.26.184-.392.389A1.1 1.1 0 0 0 6 7.38c0 .132.016.26.045.383A2.762 2.762 0 0 1 7.25 7.5a.75.75 0 0 1 0 1.5C6.5 9 6 9.572 6 10.37c0 .436.168.924.666 1.256a.75.75 0 1 1-.832 1.248 2.927 2.927 0 0 1-1.271-1.883 2.12 2.12 0 0 0-1.374.561l-.01.009A2.123 2.123 0 0 0 2.5 13.13c0 1.18.948 2.13 2.12 2.13.026 0 .108-.004.218-.016a2.6 2.6 0 0 0 .25-.036.75.75 0 0 1 .912.715c.02.886.711 1.577 1.62 1.577a1.62 1.62 0 0 0 1.63-1.62v-1.63c-.545 0-.842.112-.994.237-.122.1-.256.294-.256.763a.75.75 0 0 1-1.5 0c0-.78.241-1.462.806-1.924.536-.438 1.24-.576 1.944-.576V4.13A1.63 1.63 0 0 0 7.62 2.5ZM10 2.097A3.126 3.126 0 0 0 7.62 1a3.12 3.12 0 0 0-2.933 2.03 3.13 3.13 0 0 0-2.63 3.748A3.125 3.125 0 0 0 1 9.13c0 .715.242 1.383.652 1.914A3.627 3.627 0 0 0 1 13.13c0 2 1.612 3.63 3.62 3.63h.002A3.09 3.09 0 0 0 7.62 19 3.13 3.13 0 0 0 10 17.91 3.131 3.131 0 0 0 12.38 19a3.116 3.116 0 0 0 2.932-2.02 3.13 3.13 0 0 0 2.63-3.748A3.124 3.124 0 0 0 19 10.88a3.13 3.13 0 0 0-.652-1.914c.413-.591.652-1.31.652-2.086 0-2-1.612-3.63-3.62-3.63h-.002A3.094 3.094 0 0 0 12.38 1 3.12 3.12 0 0 0 10 2.097Zm6.82 6.352a2.12 2.12 0 0 0 .68-1.569c0-1.18-.948-2.13-2.12-2.13-.026 0-.108.004-.218.016a2.5 2.5 0 0 0-.25.036.75.75 0 0 1-.912-.715A1.602 1.602 0 0 0 12.38 2.5a1.63 1.63 0 0 0-1.63 1.63v1.63c.545 0 .842-.112.994-.237.122-.1.256-.294.256-.763a.75.75 0 0 1 1.5 0c0 .78-.241 1.462-.806 1.924-.536.438-1.24.576-1.944.576v8.62c0 .9.728 1.62 1.63 1.62.822 0 1.487-.583 1.61-1.357a.75.75 0 0 1 .74-.633h.15a1.63 1.63 0 0 0 1.63-1.63c0-.229-.05-.458-.13-.645a.75.75 0 0 1 .315-.944 1.62 1.62 0 0 0 .805-1.411c0-.323-.095-.627-.257-.88a3.612 3.612 0 0 1-1.869.52c-.062.213-.148.42-.255.612.242.444.381.954.381 1.498 0 .517-.187 1.001-.432 1.382-.243.378-.587.72-.983.919a.75.75 0 1 1-.67-1.342c.104-.052.26-.184.392-.389a1.1 1.1 0 0 0 .193-.57c0-.132-.016-.26-.045-.383a2.761 2.761 0 0 1-1.205.263.75.75 0 0 1 0-1.5c.75 0 1.25-.572 1.25-1.37 0-.436-.168-.924-.666-1.256a.75.75 0 1 1 .832-1.248 2.927 2.927 0 0 1 1.271 1.883 2.119 2.119 0 0 0 1.374-.561l.01-.009Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const $W = { render: qg }, ZW = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: $W,
  render: qg
}, Symbol.toStringTag, { value: "Module" })), GW = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Yg(e, t) {
  return f(), v("svg", GW, [...t[0] || (t[0] = [
    g("g", { class: "broadcast" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M4.734 2.177a.75.75 0 0 1 .089 1.057C3.559 4.728 3 6.37 3 8s.559 3.272 1.823 4.765a.75.75 0 0 1-1.146.97C2.191 11.978 1.5 9.995 1.5 8s.691-3.978 2.177-5.734a.75.75 0 0 1 1.057-.089Zm10.531 0a.75.75 0 0 1 1.058.089C17.809 4.022 18.5 6.006 18.5 8c0 1.995-.691 3.978-2.177 5.735a.75.75 0 0 1-1.146-.97C16.442 11.272 17 9.63 17 8s-.559-3.272-1.823-4.766a.75.75 0 0 1 .088-1.057ZM7.874 5.334a.75.75 0 0 1-.208 1.04C7.228 6.666 7 7.344 7 8c0 .656.228 1.334.666 1.626a.75.75 0 1 1-.832 1.248C5.772 10.166 5.5 8.844 5.5 8c0-.844.272-2.166 1.334-2.874a.75.75 0 0 1 1.04.208Zm4.252 0a.75.75 0 0 1 1.04-.208C14.228 5.834 14.5 7.156 14.5 8c0 .844-.272 2.166-1.334 2.874a.75.75 0 1 1-.832-1.248C12.772 9.334 13 8.656 13 8c0-.656-.228-1.334-.666-1.626a.75.75 0 0 1-.208-1.04ZM10 7a.75.75 0 0 1 .75.75v.5a.75.75 0 0 1-1.5 0v-.5A.75.75 0 0 1 10 7Zm0 4a.75.75 0 0 1 .75.75v5.5a.75.75 0 0 1-1.5 0v-5.5A.75.75 0 0 1 10 11Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const NW = { render: Yg }, zW = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: NW,
  render: Yg
}, Symbol.toStringTag, { value: "Module" })), jW = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Qg(e, t) {
  return f(), v("svg", jW, [...t[0] || (t[0] = [
    g("g", { class: "brush" }, [
      g("path", {
        d: "M11.25 13a.757.757 0 0 1-.75-.75c0-.02-.03-.72-.78-1.47S8.27 10 8.24 10a.761.761 0 0 1-.52-1.29l6.98-6.97c.48-.48 1.11-.74 1.78-.74C17.87 1 19 2.13 19 3.52c0 .67-.23 1.28-.66 1.75l-6.53 7.48c-.15.17-.35.26-.56.26V13ZM9.67 8.9c.35.18.73.44 1.12.82.35.35.6.71.78 1.03l5.66-6.48c.18-.2.28-.45.28-.72 0-.6-.46-1.06-1.02-1.06-.27 0-.53.11-.72.3l-6.1 6.1v.01ZM4.25 19c-1.66 0-2.79-.56-2.84-.58A.735.735 0 0 1 1 17.8c-.02-.27.11-.52.33-.67.48-.32 1.17-1 1.17-1.38v-1C2.5 12.68 4.18 11 6.25 11 8.42 11 10 12.58 10 14.75c0 1.97-1.3 3.31-2.51 3.71-.9.3-1.61.54-3.24.54Zm-.99-1.58c.29.05.62.08.99.08 1.38 0 1.9-.17 2.76-.46.6-.2 1.49-.97 1.49-2.29s-.9-2.25-2.25-2.25C5.01 12.5 4 13.51 4 14.75v1c0 .63-.35 1.21-.74 1.67Z",
        class: "Icon"
      })
    ], -1)
  ])]);
}
const WW = { render: Qg }, UW = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: WW,
  render: Qg
}, Symbol.toStringTag, { value: "Module" })), KW = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Jg(e, t) {
  return f(), v("svg", KW, [...t[0] || (t[0] = [
    g("g", { class: "bug" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M7.415 1.08a.75.75 0 0 1 1.006.335L8.964 2.5h2.072l.543-1.085a.75.75 0 1 1 1.342.67l-.37.741A2.75 2.75 0 0 1 14 5.25V6.5h.5a1 1 0 0 1 1 1A1.5 1.5 0 0 0 17 6v-.25a.75.75 0 0 1 1.5 0V6a3 3 0 0 1-3 3v1h2.75a.75.75 0 0 1 0 1.5H15.5v1a3 3 0 0 1 3 3v.75a.75.75 0 0 1-1.5 0v-.75a1.5 1.5 0 0 0-1.522-1.5 5.5 5.5 0 0 1-10.956 0H4.5A1.5 1.5 0 0 0 3 15.5v.75a.75.75 0 1 1-1.5 0v-.75a3 3 0 0 1 3-3v-1H1.75a.75.75 0 0 1 0-1.5H4.5V9a3 3 0 0 1-3-3v-.25a.75.75 0 1 1 1.5 0V6a1.5 1.5 0 0 0 1.5 1.5 1 1 0 0 1 1-1H6V5.25a2.75 2.75 0 0 1 1.45-2.424l-.37-.74a.75.75 0 0 1 .335-1.007ZM7.5 6.5h5V5.25c0-.69-.56-1.25-1.25-1.25h-2.5c-.69 0-1.25.56-1.25 1.25V6.5ZM9.25 8v4.25a.75.75 0 0 0 1.5 0V8H14v5.5a4 4 0 0 1-8 0V8h3.25Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const qW = { render: Jg }, YW = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: qW,
  render: Jg
}, Symbol.toStringTag, { value: "Module" })), QW = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Xg(e, t) {
  return f(), v("svg", QW, [...t[0] || (t[0] = [
    g("g", { class: "bulb" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M4 7a6 6 0 1 1 12 0v.493a5.902 5.902 0 0 1-2.628 4.91.835.835 0 0 0-.372.695v1.584C13 15.41 12.41 16 11.682 16H8.318C7.59 16 7 15.41 7 14.682v-1.584c0-.279-.14-.54-.372-.695A5.902 5.902 0 0 1 4 7.493V7Zm6-4.5A4.5 4.5 0 0 0 5.5 7v.493c0 1.472.736 2.846 1.96 3.662a2.335 2.335 0 0 1 1.04 1.943V14.5h3v-1.402c0-.78.39-1.51 1.04-1.943a4.402 4.402 0 0 0 1.96-3.662V7A4.5 4.5 0 0 0 10 2.5ZM8 18.25a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const JW = { render: Xg }, XW = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: JW,
  render: Xg
}, Symbol.toStringTag, { value: "Module" })), eU = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function ep(e, t) {
  return f(), v("svg", eU, [...t[0] || (t[0] = [
    g("g", { class: "calculator" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M2.5 3.75A2.75 2.75 0 0 1 5.25 1h9.5a2.75 2.75 0 0 1 2.75 2.75v12.5A2.75 2.75 0 0 1 14.75 19h-9.5a2.75 2.75 0 0 1-2.75-2.75V3.75ZM5.25 2.5C4.56 2.5 4 3.06 4 3.75V5.5h12V3.75c0-.69-.56-1.25-1.25-1.25h-9.5ZM16 7H4v9.25c0 .69.56 1.25 1.25 1.25h9.5c.69 0 1.25-.56 1.25-1.25V7ZM6 9.25a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5A.75.75 0 0 1 6 9.25Zm3 0a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5A.75.75 0 0 1 9 9.25Zm3 0a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75Zm-6 3a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75Zm3 0a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75Zm3 0a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75Zm-6 3a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75Zm3 0a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75Zm3 0a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const tU = { render: ep }, oU = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: tU,
  render: ep
}, Symbol.toStringTag, { value: "Module" })), nU = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function tp(e, t) {
  return f(), v("svg", nU, [...t[0] || (t[0] = [
    g("g", {
      class: "calendar-check",
      "clip-path": "url(#a)"
    }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M6.75 1a.75.75 0 0 1 .75.75V3h5V1.75a.75.75 0 0 1 1.5 0V3h2.25A2.75 2.75 0 0 1 19 5.75v3a.75.75 0 0 1-.75.75H2.5v6.75c0 .69.56 1.25 1.25 1.25h5a.75.75 0 0 1 0 1.5h-5A2.75 2.75 0 0 1 1 16.25V5.75A2.75 2.75 0 0 1 3.75 3H6V1.75A.75.75 0 0 1 6.75 1ZM6 4.5H3.75c-.69 0-1.25.56-1.25 1.25V8h15V5.75c0-.69-.56-1.25-1.25-1.25H14v.75a.75.75 0 0 1-1.5 0V4.5h-5v.75a.75.75 0 0 1-1.5 0V4.5Zm13.765 8.705a.75.75 0 0 1 .03 1.06l-4.25 4.5a.75.75 0 0 1-1.102-.013l-2.25-2.5a.75.75 0 1 1 1.114-1.004l1.706 1.896 3.692-3.909a.75.75 0 0 1 1.06-.03Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1),
    g("defs", null, [
      g("clipPath", {
        id: "a",
        class: "a"
      }, [
        g("path", { d: "M0 0h20v20H0z" })
      ])
    ], -1)
  ])]);
}
const sU = { render: tp }, iU = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sU,
  render: tp
}, Symbol.toStringTag, { value: "Module" })), rU = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function op(e, t) {
  return f(), v("svg", rU, [...t[0] || (t[0] = [
    g("g", { class: "calendar-close" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M6.75 1a.75.75 0 0 1 .75.75V3h5V1.75a.75.75 0 0 1 1.5 0V3h2.25A2.75 2.75 0 0 1 19 5.75v3a.75.75 0 0 1-.75.75H2.5v6.75c0 .69.56 1.25 1.25 1.25h5a.75.75 0 0 1 0 1.5h-5A2.75 2.75 0 0 1 1 16.25V5.75A2.75 2.75 0 0 1 3.75 3H6V1.75A.75.75 0 0 1 6.75 1ZM6 4.5H3.75c-.69 0-1.25.56-1.25 1.25V8h15V5.75c0-.69-.56-1.25-1.25-1.25H14v.75a.75.75 0 0 1-1.5 0V4.5h-5v.75a.75.75 0 0 1-1.5 0V4.5Zm7.22 8.72a.75.75 0 0 1 1.06 0L16 14.94l1.72-1.72a.75.75 0 1 1 1.06 1.06L17.06 16l1.72 1.72a.75.75 0 1 1-1.06 1.06L16 17.06l-1.72 1.72a.75.75 0 1 1-1.06-1.06L14.94 16l-1.72-1.72a.75.75 0 0 1 0-1.06Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const lU = { render: op }, aU = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: lU,
  render: op
}, Symbol.toStringTag, { value: "Module" })), cU = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function np(e, t) {
  return f(), v("svg", cU, [...t[0] || (t[0] = [
    g("g", { class: "calendar-edit" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M6.75 1a.75.75 0 0 1 .75.75V3h5V1.75a.75.75 0 0 1 1.5 0V3h2.25A2.75 2.75 0 0 1 19 5.75v3a.75.75 0 0 1-.75.75H2.5v6.75c0 .69.56 1.25 1.25 1.25h5a.75.75 0 0 1 0 1.5h-5A2.75 2.75 0 0 1 1 16.25V5.75A2.75 2.75 0 0 1 3.75 3H6V1.75A.75.75 0 0 1 6.75 1ZM6 4.5H3.75c-.69 0-1.25.56-1.25 1.25V8h15V5.75c0-.69-.56-1.25-1.25-1.25H14v.75a.75.75 0 0 1-1.5 0V4.5h-5v.75a.75.75 0 0 1-1.5 0V4.5Zm12.286 9.214a.73.73 0 0 0-1.033 0L13.5 17.467V18.5h1.033l3.753-3.753a.73.73 0 0 0 0-1.033Zm-2.094-1.06a2.23 2.23 0 1 1 3.155 3.154l-3.973 3.972a.75.75 0 0 1-.53.22H12.75a.75.75 0 0 1-.75-.75v-2.094a.75.75 0 0 1 .22-.53l3.972-3.973Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const dU = { render: np }, uU = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: dU,
  render: np
}, Symbol.toStringTag, { value: "Module" })), hU = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function sp(e, t) {
  return f(), v("svg", hU, [...t[0] || (t[0] = [
    g("g", { class: "calendar-minus" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M6.75 1a.75.75 0 0 1 .75.75V3h5V1.75a.75.75 0 0 1 1.5 0V3h2.25A2.75 2.75 0 0 1 19 5.75v3a.75.75 0 0 1-.75.75H2.5v6.75c0 .69.56 1.25 1.25 1.25h5a.75.75 0 0 1 0 1.5h-5A2.75 2.75 0 0 1 1 16.25V5.75A2.75 2.75 0 0 1 3.75 3H6V1.75A.75.75 0 0 1 6.75 1ZM6 4.5H3.75c-.69 0-1.25.56-1.25 1.25V8h15V5.75c0-.69-.56-1.25-1.25-1.25H14v.75a.75.75 0 0 1-1.5 0V4.5h-5v.75a.75.75 0 0 1-1.5 0V4.5Zm6 11.25a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const gU = { render: sp }, pU = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: gU,
  render: sp
}, Symbol.toStringTag, { value: "Module" })), fU = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function ip(e, t) {
  return f(), v("svg", fU, [...t[0] || (t[0] = [
    g("g", { class: "calendar-plus" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M6.75 1a.75.75 0 0 1 .75.75V3h5V1.75a.75.75 0 0 1 1.5 0V3h2.25A2.75 2.75 0 0 1 19 5.75v3a.75.75 0 0 1-.75.75H2.5v6.75c0 .69.56 1.25 1.25 1.25h5a.75.75 0 0 1 0 1.5h-5A2.75 2.75 0 0 1 1 16.25V5.75A2.75 2.75 0 0 1 3.75 3H6V1.75A.75.75 0 0 1 6.75 1ZM6 4.5H3.75c-.69 0-1.25.56-1.25 1.25V8h15V5.75c0-.69-.56-1.25-1.25-1.25H14v.75a.75.75 0 0 1-1.5 0V4.5h-5v.75a.75.75 0 0 1-1.5 0V4.5ZM16 12a.75.75 0 0 1 .75.75v2.5h2.5a.75.75 0 0 1 0 1.5h-2.5v2.5a.75.75 0 0 1-1.5 0v-2.5h-2.5a.75.75 0 0 1 0-1.5h2.5v-2.5A.75.75 0 0 1 16 12Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const vU = { render: ip }, mU = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: vU,
  render: ip
}, Symbol.toStringTag, { value: "Module" })), CU = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function rp(e, t) {
  return f(), v("svg", CU, [...t[0] || (t[0] = [
    g("g", { class: "calendar" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M6.75 1a.75.75 0 0 1 .75.75V3h5V1.75a.75.75 0 0 1 1.5 0V3h2.25A2.75 2.75 0 0 1 19 5.75v10.5A2.75 2.75 0 0 1 16.25 19H3.75A2.75 2.75 0 0 1 1 16.25V5.75A2.75 2.75 0 0 1 3.75 3H6V1.75A.75.75 0 0 1 6.75 1ZM6 4.5H3.75c-.69 0-1.25.56-1.25 1.25V8h15V5.75c0-.69-.56-1.25-1.25-1.25H14v.75a.75.75 0 0 1-1.5 0V4.5h-5v.75a.75.75 0 0 1-1.5 0V4.5Zm11.5 5h-15v6.75c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25V9.5Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const wU = { render: rp }, bU = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: wU,
  render: rp
}, Symbol.toStringTag, { value: "Module" })), yU = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function lp(e, t) {
  return f(), v("svg", yU, [...t[0] || (t[0] = [
    g("g", { class: "camera" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M8.667 2h2.666c.284 0 .588-.002.87.096.245.084.468.222.654.404.213.208.348.48.474.735l.032.064.35.701h1.367c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 18.7 5.502c.172.337.24.693.27 1.073.03.365.03.81.03 1.345v6.16c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073a2.751 2.751 0 0 1-1.2 1.202c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03H4.92c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 1.3 16.5c-.172-.338-.24-.694-.27-1.074C1 15.06 1 14.615 1 14.08V7.92c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 2.502 4.3c.337-.172.693-.24 1.073-.27C3.94 4 4.385 4 4.92 4h1.366l.351-.701a27.5 27.5 0 0 0 .032-.064c.126-.255.262-.527.475-.735a1.75 1.75 0 0 1 .653-.404c.282-.098.586-.097.87-.096Zm-.383 1.514h.002-.002Zm.078-.009a.504.504 0 0 0-.076.009.25.25 0 0 0-.092.057.503.503 0 0 0-.042.064c-.04.07-.09.166-.173.335L7.42 5.085a.75.75 0 0 1-.671.415h-1.8c-.572 0-.957 0-1.253.025-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.547c-.046.09-.088.227-.111.514-.024.296-.025.68-.025 1.253v6.1c0 .572 0 .957.025 1.252.023.288.065.425.111.516.12.235.311.426.547.546.09.046.227.088.514.111.296.024.68.025 1.253.025h10.1c.572 0 .957 0 1.252-.025.288-.023.425-.065.515-.111a1.25 1.25 0 0 0 .547-.546c.046-.091.088-.228.111-.515.024-.296.025-.68.025-1.253v-6.1c0-.572 0-.957-.025-1.253-.023-.287-.065-.424-.111-.514a1.25 1.25 0 0 0-.547-.547c-.09-.046-.227-.088-.515-.111-.295-.024-.68-.025-1.252-.025h-1.8a.75.75 0 0 1-.67-.415L12.02 3.97a6.822 6.822 0 0 0-.173-.335.485.485 0 0 0-.042-.064.25.25 0 0 0-.09-.057m-.002 0a.507.507 0 0 0-.076-.009 6.88 6.88 0 0 0-.377-.005H8.74c-.189 0-.296 0-.377.005m3.443.065.001.001V3.57Zm-3.61 0-.001.001V3.57ZM10 8.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5ZM6 11a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const _U = { render: lp }, SU = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _U,
  render: lp
}, Symbol.toStringTag, { value: "Module" })), xU = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function ap(e, t) {
  return f(), v("svg", xU, [...t[0] || (t[0] = [
    g("g", { class: "card" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M1 5.75A2.75 2.75 0 0 1 3.75 3h12.5A2.75 2.75 0 0 1 19 5.75v8.5A2.75 2.75 0 0 1 16.25 17H3.75A2.75 2.75 0 0 1 1 14.25v-8.5ZM3.75 4.5c-.69 0-1.25.56-1.25 1.25V8h15V5.75c0-.69-.56-1.25-1.25-1.25H3.75Zm13.75 5h-15v4.75c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25V9.5ZM4 12.75a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const MU = { render: ap }, AU = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: MU,
  render: ap
}, Symbol.toStringTag, { value: "Module" })), LU = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function cp(e, t) {
  return f(), v("svg", LU, [...t[0] || (t[0] = [
    g("g", { class: "chart-bar-box" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M1 3.75A2.75 2.75 0 0 1 3.75 1h12.5A2.75 2.75 0 0 1 19 3.75v12.5A2.75 2.75 0 0 1 16.25 19H3.75A2.75 2.75 0 0 1 1 16.25V3.75ZM3.75 2.5c-.69 0-1.25.56-1.25 1.25v12.5c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25V3.75c0-.69-.56-1.25-1.25-1.25H3.75ZM10 5a.75.75 0 0 1 .75.75v8.5a.75.75 0 0 1-1.5 0v-8.5A.75.75 0 0 1 10 5ZM6.75 8a.75.75 0 0 1 .75.75v5.5a.75.75 0 0 1-1.5 0v-5.5A.75.75 0 0 1 6.75 8Zm6.5 2a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5a.75.75 0 0 1 .75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const EU = { render: cp }, PU = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: EU,
  render: cp
}, Symbol.toStringTag, { value: "Module" })), RU = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function dp(e, t) {
  return f(), v("svg", RU, [...t[0] || (t[0] = [
    g("g", { class: "chart-bar" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M6.75 2.75C6.75 1.784 7.534 1 8.5 1h3c.966 0 1.75.784 1.75 1.75V10h3c.966 0 1.75.784 1.75 1.75v5.5A1.75 1.75 0 0 1 16.25 19H3.75A1.75 1.75 0 0 1 2 17.25v-9.5C2 6.784 2.784 6 3.75 6h3V2.75Zm0 4.75h-3a.25.25 0 0 0-.25.25v9.5c0 .138.112.25.25.25h3v-10Zm1.5 10h3.5V2.75a.25.25 0 0 0-.25-.25h-3a.25.25 0 0 0-.25.25V17.5Zm5 0h3a.25.25 0 0 0 .25-.25v-5.5a.25.25 0 0 0-.25-.25h-3v6Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const FU = { render: dp }, TU = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: FU,
  render: dp
}, Symbol.toStringTag, { value: "Module" })), IU = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function up(e, t) {
  return f(), v("svg", IU, [...t[0] || (t[0] = [
    g("g", { class: "chart-line" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M1.75 1a.75.75 0 0 1 .75.75v11.19l4.72-4.72a.75.75 0 0 1 .946-.094l3.947 2.631 5.568-6.495a.75.75 0 1 1 1.138.976l-6 7a.75.75 0 0 1-.985.136L7.846 9.715 2.5 15.061c0 .566 0 .948.025 1.241.023.288.065.425.111.515.12.236.311.427.547.547.09.046.227.088.514.111.296.024.68.025 1.253.025h12.3a.75.75 0 0 1 0 1.5H4.92c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 1.3 17.5c-.172-.338-.24-.694-.27-1.074C1 16.06 1 15.615 1 15.08V1.75A.75.75 0 0 1 1.75 1Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const DU = { render: up }, kU = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: DU,
  render: up
}, Symbol.toStringTag, { value: "Module" })), HU = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function hp(e, t) {
  return f(), v("svg", HU, [...t[0] || (t[0] = [
    g("g", { class: "chart-pie" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M9 1.75A.75.75 0 0 1 9.75 1C14.72 1 19 5.28 19 10.25a.75.75 0 0 1-.75.75h-8.5a.75.75 0 0 1-.75-.75v-8.5Zm1.5.79V9.5h6.96c-.375-3.57-3.39-6.585-6.96-6.96Zm-3.06-.42a.75.75 0 0 1-.394.984A7.502 7.502 0 0 0 10 17.5a7.502 7.502 0 0 0 6.896-4.546.75.75 0 1 1 1.378.592 9 9 0 1 1-11.82-11.82.75.75 0 0 1 .985.393Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const VU = { render: hp }, OU = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: VU,
  render: hp
}, Symbol.toStringTag, { value: "Module" })), BU = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function gp(e, t) {
  return f(), v("svg", BU, [...t[0] || (t[0] = [
    g("g", { class: "chat" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M8 2.5C4.835 2.5 2.5 4.632 2.5 7c0 .838.448 1.805 1.168 2.59l.006.005c.55.598.968 1.054 1.264 1.387.148.167.272.31.368.428.087.107.182.231.247.35l.039.07.064.119a1.448 1.448 0 0 1 .154.436l.024.133.014.079c.032.182.037.378.032.583.34-.36.695-.724.992-1.006.155-.146.307-.283.44-.387.066-.05.143-.107.224-.153l.003-.002c.05-.028.229-.132.461-.132 3.165 0 5.5-2.132 5.5-4.5S11.165 2.5 8 2.5ZM1 7c0-3.43 3.262-6 7-6s7 2.57 7 6c0 3.37-3.146 5.908-6.8 5.998a5.76 5.76 0 0 0-.297.266c-.281.266-.634.629-.985 1a70.088 70.088 0 0 0-1.244 1.357l-.084.094-.028.032a.75.75 0 0 1-1.31-.547l.078-1.17c.025-.376.042-.639.049-.838a1.87 1.87 0 0 0-.008-.332l-.018-.104-.016-.088-.002-.01a1.108 1.108 0 0 0-.047-.086 22.062 22.062 0 0 1-.052-.094c-.008-.01-.034-.048-.094-.122a11.898 11.898 0 0 0-.325-.378c-.287-.322-.697-.769-1.253-1.374C1.674 9.637 1 8.324 1 7Zm15.605.897a.75.75 0 0 1 1.06.038C18.49 8.821 19 9.963 19 11.222c0 1.014-.445 2.01-1.052 2.797-.55.71-.958 1.237-1.24 1.611-.141.188-.247.331-.321.437a2.962 2.962 0 0 0-.093.138 11.672 11.672 0 0 1-.079.163l-.002.017-.024.163c-.017.113-.008.326.038 1.026l.041.627a.75.75 0 0 1-1.313.543l-.001-.002-.023-.026-.07-.08a59.987 59.987 0 0 0-1.043-1.153 22.514 22.514 0 0 0-.823-.848 5.427 5.427 0 0 0-.211-.194 6.635 6.635 0 0 1-2.939-.774.75.75 0 1 1 .71-1.321 5.16 5.16 0 0 0 2.445.598c.23 0 .405.103.45.13l.004.001c.075.044.144.096.201.14.117.093.248.212.379.338.207.198.446.444.683.696l.008-.056.008-.058c.007-.046.018-.122.044-.207a1.36 1.36 0 0 1 .105-.248l.056-.117c.055-.116.143-.246.221-.358.09-.127.207-.286.351-.478a207.3 207.3 0 0 1 1.247-1.621l.004-.005c.469-.606.739-1.289.739-1.879 0-.838-.337-1.625-.933-2.265a.75.75 0 0 1 .038-1.06Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const $U = { render: gp }, ZU = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: $U,
  render: gp
}, Symbol.toStringTag, { value: "Module" })), GU = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function pp(e, t) {
  return f(), v("svg", GU, [...t[0] || (t[0] = [
    g("g", { class: "check-badge-fill" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M7.716 1.532a.75.75 0 0 0-.78.224L5.303 3.622l-2.332.931a.75.75 0 0 0-.472.696L2.496 7.57 1.13 9.576a.75.75 0 0 0 .02.871l1.346 1.803.004 2.501a.75.75 0 0 0 .471.695l2.333.934 1.632 1.864a.75.75 0 0 0 .711.241l2.35-.47 2.354.47a.75.75 0 0 0 .711-.241l1.632-1.864 2.332-.934a.75.75 0 0 0 .472-.695l.004-2.501 1.347-1.803a.75.75 0 0 0 .019-.871L17.502 7.57l-.004-2.321a.75.75 0 0 0-.472-.696l-2.332-.93-1.632-1.867a.75.75 0 0 0-.78-.224l-2.284.685-2.282-.685Zm6.05 6.762a.75.75 0 0 0-1.032-1.088l-4.26 4.035-1.236-1.06a.75.75 0 1 0-.976 1.138l1.75 1.5a.75.75 0 0 0 1.004-.025l4.75-4.5Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const NU = { render: pp }, zU = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: NU,
  render: pp
}, Symbol.toStringTag, { value: "Module" })), jU = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function fp(e, t) {
  return f(), v("svg", jU, [...t[0] || (t[0] = [
    g("g", { class: "check-badge" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M6.935 1.756a.75.75 0 0 1 .78-.224l2.283.685 2.284-.685a.75.75 0 0 1 .78.224l1.632 1.866 2.332.931a.75.75 0 0 1 .472.696l.004 2.321 1.366 2.006a.75.75 0 0 1-.02.871l-1.346 1.803-.004 2.501a.75.75 0 0 1-.472.695l-2.332.934-1.632 1.864a.75.75 0 0 1-.711.241l-2.353-.47-2.35.47a.75.75 0 0 1-.712-.241L5.304 16.38l-2.333-.934a.75.75 0 0 1-.471-.695l-.004-2.501-1.347-1.803a.75.75 0 0 1-.019-.871L2.496 7.57 2.5 5.25a.75.75 0 0 1 .472-.696l2.332-.93 1.631-1.867Zm5.316 1.351-2.038.611a.75.75 0 0 1-.43 0l-2.036-.61-1.432 1.637a.75.75 0 0 1-.287.203L4 5.758l-.003 2.045a.75.75 0 0 1-.13.421L2.67 9.978l1.176 1.573a.75.75 0 0 1 .149.448l.003 2.243 2.03.812a.75.75 0 0 1 .285.202L7.78 16.93l2.072-.414a.747.747 0 0 1 .294 0l2.074.414 1.464-1.673a.75.75 0 0 1 .286-.202l2.03-.812.003-2.243a.75.75 0 0 1 .15-.448l1.175-1.573-1.195-1.754a.75.75 0 0 1-.13-.42L16 5.757l-2.03-.81a.75.75 0 0 1-.286-.203l-1.432-1.638Zm1.543 4.127a.75.75 0 0 1-.028 1.06l-4.75 4.5a.75.75 0 0 1-1.004.025l-1.75-1.5a.75.75 0 1 1 .976-1.138l1.237 1.06 4.26-4.035a.75.75 0 0 1 1.06.028Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const WU = { render: fp }, UU = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: WU,
  render: fp
}, Symbol.toStringTag, { value: "Module" })), KU = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function vp(e, t) {
  return f(), v("svg", KU, [...t[0] || (t[0] = [
    g("g", { class: "check-circle-fill" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10 1a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm3.844 6.709a.75.75 0 0 0-1.188-.918l-3.7 4.79-1.649-1.833a.75.75 0 0 0-1.114 1.004l2.25 2.5a.75.75 0 0 0 1.15-.043l4.25-5.5Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const qU = { render: vp }, YU = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: qU,
  render: vp
}, Symbol.toStringTag, { value: "Module" })), QU = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function mp(e, t) {
  return f(), v("svg", QU, [...t[0] || (t[0] = [
    g("g", { class: "check-circle" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10 2.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15ZM1 10a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm12.709-3.343a.75.75 0 0 1 .135 1.052l-4.25 5.5a.75.75 0 0 1-1.151.043l-2.25-2.5a.75.75 0 1 1 1.114-1.004l1.65 1.832 3.7-4.789a.75.75 0 0 1 1.052-.134Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const JU = { render: mp }, XU = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: JU,
  render: mp
}, Symbol.toStringTag, { value: "Module" })), eK = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Cp(e, t) {
  return f(), v("svg", eK, [...t[0] || (t[0] = [
    g("g", { class: "check-large" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M16.772 5.212a.75.75 0 0 1 .016 1.06l-8.25 8.5a.75.75 0 0 1-1.083-.007l-4.25-4.5a.75.75 0 0 1 1.09-1.03l3.712 3.93 7.705-7.937a.75.75 0 0 1 1.06-.016Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const tK = { render: Cp }, oK = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: tK,
  render: Cp
}, Symbol.toStringTag, { value: "Module" })), nK = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function wp(e, t) {
  return f(), v("svg", nK, [...t[0] || (t[0] = [
    g("g", { class: "check-small" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M15.771 5.71a.75.75 0 0 1 .018 1.061l-7.25 7.5a.75.75 0 0 1-1.089-.01l-3.25-3.5A.75.75 0 1 1 5.3 9.74l2.71 2.92 6.7-6.931a.75.75 0 0 1 1.061-.018Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const sK = { render: wp }, iK = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sK,
  render: wp
}, Symbol.toStringTag, { value: "Module" })), rK = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function bp(e, t) {
  return f(), v("svg", rK, [...t[0] || (t[0] = [
    g("g", { class: "chevron-down-small-circle" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10 2.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15ZM1 10a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm5.24-1.8a.75.75 0 0 1 1.06.04l2.7 2.908 2.7-2.908a.75.75 0 1 1 1.1 1.02l-3.25 3.5a.75.75 0 0 1-1.1 0L6.2 9.26a.75.75 0 0 1 .04-1.06Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const lK = { render: bp }, aK = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: lK,
  render: bp
}, Symbol.toStringTag, { value: "Module" })), cK = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function yp(e, t) {
  return f(), v("svg", cK, [...t[0] || (t[0] = [
    g("g", { class: "chevron-down-small-fill" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10 1a9 9 0 1 0 0 18 9 9 0 0 0 0-18ZM7.3 8.24a.75.75 0 1 0-1.1 1.02l3.25 3.5a.75.75 0 0 0 1.1 0l3.25-3.5a.75.75 0 0 0-1.1-1.02L10 11.148 7.3 8.24Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const dK = { render: yp }, uK = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: dK,
  render: yp
}, Symbol.toStringTag, { value: "Module" })), hK = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function _p(e, t) {
  return f(), v("svg", hK, [...t[0] || (t[0] = [
    g("g", { class: "chevron-down-small" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M6.24 8.2a.75.75 0 0 1 1.06.04l2.7 2.908 2.7-2.908a.75.75 0 1 1 1.1 1.02l-3.25 3.5a.75.75 0 0 1-1.1 0L6.2 9.26a.75.75 0 0 1 .04-1.06Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const gK = { render: _p }, pK = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: gK,
  render: _p
}, Symbol.toStringTag, { value: "Module" })), fK = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Sp(e, t) {
  return f(), v("svg", fK, [...t[0] || (t[0] = [
    g("g", { class: "chevron-down" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M4.232 7.207a.75.75 0 0 1 1.06.025L10 12.164l4.707-4.932a.75.75 0 1 1 1.085 1.036l-5.25 5.5a.75.75 0 0 1-1.085 0l-5.25-5.5a.75.75 0 0 1 .025-1.06Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const vK = { render: Sp }, mK = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: vK,
  render: Sp
}, Symbol.toStringTag, { value: "Module" })), CK = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function xp(e, t) {
  return f(), v("svg", CK, [...t[0] || (t[0] = [
    g("g", { class: "chevron-left-small-circle" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10 2.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15ZM1 10a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm10.8-3.76a.75.75 0 0 1-.04 1.06L8.852 10l2.908 2.7a.75.75 0 1 1-1.02 1.1l-3.5-3.25a.75.75 0 0 1 0-1.1l3.5-3.25a.75.75 0 0 1 1.06.04Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const wK = { render: xp }, bK = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: wK,
  render: xp
}, Symbol.toStringTag, { value: "Module" })), yK = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Mp(e, t) {
  return f(), v("svg", yK, [...t[0] || (t[0] = [
    g("g", { class: "chevron-left-small-fill" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M19 10a9 9 0 1 0-18 0 9 9 0 0 0 18 0Zm-7.24-2.7a.75.75 0 1 0-1.02-1.1l-3.5 3.25a.75.75 0 0 0 0 1.1l3.5 3.25a.75.75 0 1 0 1.02-1.1L8.852 10l2.908-2.7Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const _K = { render: Mp }, SK = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _K,
  render: Mp
}, Symbol.toStringTag, { value: "Module" })), xK = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Ap(e, t) {
  return f(), v("svg", xK, [...t[0] || (t[0] = [
    g("g", { class: "chevron-left-small" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M11.8 6.24a.75.75 0 0 1-.04 1.06L8.852 10l2.908 2.7a.75.75 0 1 1-1.02 1.1l-3.5-3.25a.75.75 0 0 1 0-1.1l3.5-3.25a.75.75 0 0 1 1.06.04Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const MK = { render: Ap }, AK = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: MK,
  render: Ap
}, Symbol.toStringTag, { value: "Module" })), LK = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Lp(e, t) {
  return f(), v("svg", LK, [...t[0] || (t[0] = [
    g("g", { class: "chevron-left" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M12.793 4.232a.75.75 0 0 1-.025 1.06L7.836 10l4.932 4.707a.75.75 0 0 1-1.036 1.085l-5.5-5.25a.75.75 0 0 1 0-1.085l5.5-5.25a.75.75 0 0 1 1.06.025Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const EK = { render: Lp }, PK = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: EK,
  render: Lp
}, Symbol.toStringTag, { value: "Module" })), RK = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Ep(e, t) {
  return f(), v("svg", RK, [...t[0] || (t[0] = [
    g("g", { class: "chevron-right-small-circle" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10 2.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15ZM1 10a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm7.2-3.76a.75.75 0 0 1 1.06-.04l3.5 3.25a.75.75 0 0 1 0 1.1l-3.5 3.25a.75.75 0 0 1-1.02-1.1l2.908-2.7L8.24 7.3a.75.75 0 0 1-.04-1.06Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const FK = { render: Ep }, TK = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: FK,
  render: Ep
}, Symbol.toStringTag, { value: "Module" })), IK = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Pp(e, t) {
  return f(), v("svg", IK, [...t[0] || (t[0] = [
    g("g", { class: "chevron-right-small-fill" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M1 10a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm7.24-2.7a.75.75 0 1 1 1.02-1.1l3.5 3.25a.75.75 0 0 1 0 1.1l-3.5 3.25a.75.75 0 0 1-1.02-1.1l2.908-2.7L8.24 7.3Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const DK = { render: Pp }, kK = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: DK,
  render: Pp
}, Symbol.toStringTag, { value: "Module" })), HK = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Rp(e, t) {
  return f(), v("svg", HK, [...t[0] || (t[0] = [
    g("g", { class: "chevron-right-small" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M8.2 6.24a.75.75 0 0 1 1.06-.04l3.5 3.25a.75.75 0 0 1 0 1.1l-3.5 3.25a.75.75 0 1 1-1.02-1.1l2.908-2.7L8.24 7.3a.75.75 0 0 1-.04-1.06Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const VK = { render: Rp }, OK = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: VK,
  render: Rp
}, Symbol.toStringTag, { value: "Module" })), BK = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Fp(e, t) {
  return f(), v("svg", BK, [...t[0] || (t[0] = [
    g("g", { class: "chevron-right" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M7.207 4.232a.75.75 0 0 1 1.06-.025l5.5 5.25a.75.75 0 0 1 0 1.085l-5.5 5.25a.75.75 0 1 1-1.035-1.085L12.164 10 7.232 5.293a.75.75 0 0 1-.025-1.06Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const $K = { render: Fp }, ZK = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: $K,
  render: Fp
}, Symbol.toStringTag, { value: "Module" })), GK = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Tp(e, t) {
  return f(), v("svg", GK, [...t[0] || (t[0] = [
    g("g", { class: "chevron-up-small-circle" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10 2.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15ZM1 10a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm9-3a.75.75 0 0 1 .55.24l3.25 3.5a.75.75 0 1 1-1.1 1.02L10 8.852 7.3 11.76a.75.75 0 1 1-1.1-1.02l3.25-3.5A.75.75 0 0 1 10 7Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const NK = { render: Tp }, zK = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: NK,
  render: Tp
}, Symbol.toStringTag, { value: "Module" })), jK = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Ip(e, t) {
  return f(), v("svg", jK, [...t[0] || (t[0] = [
    g("g", { class: "chevron-up-small-fill" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10 19a9 9 0 1 1 0-18 9 9 0 0 1 0 18Zm-2.7-7.24a.75.75 0 1 1-1.1-1.02l3.25-3.5a.75.75 0 0 1 1.1 0l3.25 3.5a.75.75 0 1 1-1.1 1.02L10 8.852 7.3 11.76Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const WK = { render: Ip }, UK = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: WK,
  render: Ip
}, Symbol.toStringTag, { value: "Module" })), KK = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Dp(e, t) {
  return f(), v("svg", KK, [...t[0] || (t[0] = [
    g("g", { class: "chevron-up-small" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10 7a.75.75 0 0 1 .55.24l3.25 3.5a.75.75 0 1 1-1.1 1.02L10 8.852 7.3 11.76a.75.75 0 1 1-1.1-1.02l3.25-3.5A.75.75 0 0 1 10 7Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const qK = { render: Dp }, YK = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: qK,
  render: Dp
}, Symbol.toStringTag, { value: "Module" })), QK = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function kp(e, t) {
  return f(), v("svg", QK, [...t[0] || (t[0] = [
    g("g", { class: "chevron-up" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10 6a.75.75 0 0 1 .543.232l5.25 5.5a.75.75 0 0 1-1.085 1.036L10 7.836l-4.707 4.932a.75.75 0 0 1-1.086-1.036l5.25-5.5A.75.75 0 0 1 10 6Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const JK = { render: kp }, XK = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: JK,
  render: kp
}, Symbol.toStringTag, { value: "Module" })), eq = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Hp(e, t) {
  return f(), v("svg", eq, [...t[0] || (t[0] = [
    g("g", { class: "clipboard" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M8.324 1h3.352c.258 0 .494 0 .692.016.213.018.446.057.676.175.33.168.598.435.765.765.118.23.158.463.175.676.009.111.013.235.015.368h.081c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 17.7 4.502c.172.337.24.693.27 1.073.03.365.03.81.03 1.345v8.16c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073a2.751 2.751 0 0 1-1.2 1.202c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03H5.92c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 2.3 17.5c-.172-.338-.24-.694-.27-1.074C2 16.06 2 15.615 2 15.08V6.92c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 3.502 3.3c.337-.172.693-.24 1.073-.27C4.94 3 5.385 3 5.92 3H6c.002-.133.006-.256.015-.368a1.77 1.77 0 0 1 .175-.676 1.75 1.75 0 0 1 .765-.765 1.77 1.77 0 0 1 .676-.175C7.83 1 8.066 1 8.324 1ZM6 4.5h-.05c-.572 0-.957 0-1.253.025-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.547c-.046.09-.088.227-.111.514-.024.296-.025.68-.025 1.253v8.1c0 .572 0 .957.025 1.252.023.288.065.425.111.515.12.236.311.427.547.547.09.046.227.088.514.111.296.024.68.025 1.253.025h8.1c.572 0 .957 0 1.252-.025.288-.023.425-.065.516-.111a1.25 1.25 0 0 0 .546-.547c.046-.09.088-.227.111-.515.024-.295.025-.68.025-1.252v-8.1c0-.572 0-.957-.025-1.253-.023-.287-.065-.424-.111-.514a1.25 1.25 0 0 0-.546-.547c-.091-.046-.228-.088-.515-.111-.296-.024-.68-.025-1.253-.025h-.051a5.464 5.464 0 0 1-.015.368 1.775 1.775 0 0 1-.175.676 1.75 1.75 0 0 1-.764.765c-.23.118-.464.157-.677.175-.198.016-.434.016-.692.016H8.324c-.258 0-.494 0-.692-.016a1.774 1.774 0 0 1-.676-.175 1.75 1.75 0 0 1-.765-.765 1.774 1.774 0 0 1-.175-.676 5.484 5.484 0 0 1-.015-.368Zm1.63-1.97h.001-.001Zm.002-.001a.626.626 0 0 1 .121-.018c.13-.01.304-.011.596-.011h3.3c.292 0 .467 0 .596.011a.625.625 0 0 1 .12.018.25.25 0 0 1 .105.104.638.638 0 0 1 .018.121c.01.13.011.304.011.596v.8c0 .292 0 .467-.011.596a.638.638 0 0 1-.018.12.25.25 0 0 1-.104.105.626.626 0 0 1-.121.018c-.13.01-.304.011-.596.011h-3.3c-.292 0-.467 0-.596-.011a.628.628 0 0 1-.12-.018.25.25 0 0 1-.105-.104.628.628 0 0 1-.018-.121 8.339 8.339 0 0 1-.01-.596v-.8c0-.292 0-.467.011-.596a.628.628 0 0 1 .018-.12.25.25 0 0 1 .104-.105Zm-.103.102v.001-.001Zm0 2.238v-.001.001Zm.1.101h.002-.001Zm4.74 0h-.002.001Zm.1-.1v-.002.001Zm0-2.24v.002-.001Zm-.102-.1h.001-.001Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const tq = { render: Hp }, oq = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: tq,
  render: Hp
}, Symbol.toStringTag, { value: "Module" })), nq = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Vp(e, t) {
  return f(), v("svg", nq, [...t[0] || (t[0] = [
    g("g", { class: "close" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M5.22 5.22a.75.75 0 0 1 1.06 0L10 8.94l3.72-3.72a.75.75 0 1 1 1.06 1.06L11.06 10l3.72 3.72a.75.75 0 1 1-1.06 1.06L10 11.06l-3.72 3.72a.75.75 0 0 1-1.06-1.06L8.94 10 5.22 6.28a.75.75 0 0 1 0-1.06Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const sq = { render: Vp }, iq = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sq,
  render: Vp
}, Symbol.toStringTag, { value: "Module" })), rq = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Op(e, t) {
  return f(), v("svg", rq, [...t[0] || (t[0] = [
    g("g", { class: "cloud" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10 5.5a4.502 4.502 0 0 0-4.372 3.43.75.75 0 0 1-.706.571A2.5 2.5 0 0 0 5 14.5h11a1.5 1.5 0 1 0-.552-2.895.75.75 0 0 1-1.015-.826A4.5 4.5 0 0 0 10 5.5ZM4.322 8.057A6.002 6.002 0 0 1 16 10a3 3 0 1 1 0 6H5a4 4 0 0 1-.678-7.943Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const lq = { render: Op }, aq = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: lq,
  render: Op
}, Symbol.toStringTag, { value: "Module" })), cq = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Bp(e, t) {
  return f(), v("svg", cq, [...t[0] || (t[0] = [
    g("g", { class: "code-2" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M11.424 4.02a.75.75 0 0 1 .556.904l-2.5 10.5a.75.75 0 0 1-1.46-.348l2.5-10.5a.75.75 0 0 1 .904-.556ZM6.8 6.24a.75.75 0 0 1-.04 1.06L3.852 10l2.908 2.7a.75.75 0 1 1-1.02 1.1l-3.5-3.25a.75.75 0 0 1 0-1.1l3.5-3.25a.75.75 0 0 1 1.06.04Zm6.4 0a.75.75 0 0 1 1.06-.04l3.5 3.25a.75.75 0 0 1 0 1.1l-3.5 3.25a.75.75 0 1 1-1.02-1.1l2.908-2.7-2.908-2.7a.75.75 0 0 1-.04-1.06Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const dq = { render: Bp }, uq = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: dq,
  render: Bp
}, Symbol.toStringTag, { value: "Module" })), hq = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function $p(e, t) {
  return f(), v("svg", hq, [...t[0] || (t[0] = [
    g("g", { class: "code" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M6.8 6.24a.75.75 0 0 1-.04 1.06L3.852 10l2.908 2.7a.75.75 0 1 1-1.02 1.1l-3.5-3.25a.75.75 0 0 1 0-1.1l3.5-3.25a.75.75 0 0 1 1.06.04Zm6.4 0a.75.75 0 0 1 1.06-.04l3.5 3.25a.75.75 0 0 1 0 1.1l-3.5 3.25a.75.75 0 1 1-1.02-1.1l2.908-2.7-2.908-2.7a.75.75 0 0 1-.04-1.06Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const gq = { render: $p }, pq = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: gq,
  render: $p
}, Symbol.toStringTag, { value: "Module" })), fq = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Zp(e, t) {
  return f(), v("svg", fq, [...t[0] || (t[0] = [
    g("g", { class: "command" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M1 4.75a3.75 3.75 0 1 1 7.5 0V7h3V4.75a3.75 3.75 0 1 1 3.75 3.75H13v3h2.25a3.75 3.75 0 1 1-3.75 3.75V13h-3v2.25a3.75 3.75 0 1 1-3.75-3.75H7v-3H4.75A3.75 3.75 0 0 1 1 4.75ZM7 7V4.75A2.25 2.25 0 1 0 4.75 7H7Zm1.5 1.5v3h3v-3h-3ZM7 13H4.75A2.25 2.25 0 1 0 7 15.25V13Zm6 0v2.25A2.25 2.25 0 1 0 15.25 13H13Zm0-6h2.25A2.25 2.25 0 1 0 13 4.75V7Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const vq = { render: Zp }, mq = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: vq,
  render: Zp
}, Symbol.toStringTag, { value: "Module" })), Cq = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Gp(e, t) {
  return f(), v("svg", Cq, [...t[0] || (t[0] = [
    g("g", { class: "comment" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M1 3.75A2.75 2.75 0 0 1 3.75 1h12.5A2.75 2.75 0 0 1 19 3.75v9.5A2.75 2.75 0 0 1 16.25 16h-3a1.25 1.25 0 0 0-1 .5l-1.65 2.2a.75.75 0 0 1-1.2 0l-1.65-2.2a1.25 1.25 0 0 0-1-.5h-3A2.75 2.75 0 0 1 1 13.25v-9.5ZM3.75 2.5c-.69 0-1.25.56-1.25 1.25v9.5c0 .69.56 1.25 1.25 1.25h3c.866 0 1.68.408 2.2 1.1L10 17l1.05-1.4a2.75 2.75 0 0 1 2.2-1.1h3c.69 0 1.25-.56 1.25-1.25v-9.5c0-.69-.56-1.25-1.25-1.25H3.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const wq = { render: Gp }, bq = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: wq,
  render: Gp
}, Symbol.toStringTag, { value: "Module" })), yq = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Np(e, t) {
  return f(), v("svg", yq, [...t[0] || (t[0] = [
    g("g", { class: "company" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M5.324 1h5.352c.258 0 .494 0 .692.016.213.018.446.057.676.175.33.168.598.435.765.765.118.23.158.463.175.676.016.198.016.434.016.692V7h1.676c.258 0 .494 0 .692.016.213.018.446.057.676.175.33.168.598.435.765.765.118.23.157.463.175.676.016.198.016.434.016.692V17.5h1.25a.75.75 0 0 1 0 1.5H1.75a.75.75 0 0 1 0-1.5H3V3.324c0-.258 0-.494.016-.692a1.77 1.77 0 0 1 .175-.676 1.75 1.75 0 0 1 .765-.765 1.77 1.77 0 0 1 .676-.175C4.83 1 5.066 1 5.324 1ZM4.5 17.5h7V3.35c0-.292 0-.467-.011-.596a.638.638 0 0 0-.018-.12.25.25 0 0 0-.104-.105.625.625 0 0 0-.121-.018 8.336 8.336 0 0 0-.596-.011h-5.3c-.292 0-.467 0-.596.011a.626.626 0 0 0-.12.018.25.25 0 0 0-.105.104.628.628 0 0 0-.018.121c-.01.13-.011.304-.011.596V17.5Zm.03-14.87v.002-.001Zm.1-.1h.002-.001Zm6.74 0h-.002.001Zm.1.1v.002-.001ZM13 8.5v9h2.5V9.35c0-.292 0-.467-.011-.596a.638.638 0 0 0-.018-.12.25.25 0 0 0-.104-.105.625.625 0 0 0-.121-.018 8.336 8.336 0 0 0-.596-.011H13Zm2.37.03h-.002.001Zm.1.1v.002-.001ZM6 5.75A.75.75 0 0 1 6.75 5h2.5a.75.75 0 0 1 0 1.5h-2.5A.75.75 0 0 1 6 5.75ZM6 10a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5A.75.75 0 0 1 6 10Zm0 4.25a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const _q = { render: Np }, Sq = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _q,
  render: Np
}, Symbol.toStringTag, { value: "Module" })), xq = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function zp(e, t) {
  return f(), v("svg", xq, [...t[0] || (t[0] = [
    g("g", { class: "compass" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10 2.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15ZM1 10a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm13.78-4.78a.75.75 0 0 1 .187.75l-1.502 4.881-.027.089c-.155.506-.277.903-.504 1.241a2.74 2.74 0 0 1-.753.753c-.338.227-.735.349-1.241.504l-.089.027-4.88 1.502a.75.75 0 0 1-.938-.938l1.502-4.88.027-.089c.155-.506.277-.903.504-1.241.2-.298.455-.553.753-.753.338-.227.735-.349 1.241-.504l.089-.027 4.88-1.502a.75.75 0 0 1 .751.187Zm-1.663 1.663L9.59 7.97c-.637.195-.805.255-.936.343a1.25 1.25 0 0 0-.342.342c-.088.131-.148.3-.343.936l-1.086 3.527 3.527-1.086c.637-.195.805-.255.936-.343a1.25 1.25 0 0 0 .342-.342c.088-.131.148-.3.343-.936l1.085-3.527Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Mq = { render: zp }, Aq = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Mq,
  render: zp
}, Symbol.toStringTag, { value: "Module" })), Lq = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function jp(e, t) {
  return f(), v("svg", Lq, [...t[0] || (t[0] = [
    g("g", { class: "copy" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M1 3.75A2.75 2.75 0 0 1 3.75 1h8.5A2.75 2.75 0 0 1 15 3.75V5h1.25A2.75 2.75 0 0 1 19 7.75v8.5A2.75 2.75 0 0 1 16.25 19h-8.5A2.75 2.75 0 0 1 5 16.25V15H3.75A2.75 2.75 0 0 1 1 12.25v-8.5Zm4 9.75V7.75A2.75 2.75 0 0 1 7.75 5h5.75V3.75c0-.69-.56-1.25-1.25-1.25h-8.5c-.69 0-1.25.56-1.25 1.25v8.5c0 .69.56 1.25 1.25 1.25H5Zm2.75-7c-.69 0-1.25.56-1.25 1.25v8.5c0 .69.56 1.25 1.25 1.25h8.5c.69 0 1.25-.56 1.25-1.25v-8.5c0-.69-.56-1.25-1.25-1.25h-8.5Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Eq = { render: jp }, Pq = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Eq,
  render: jp
}, Symbol.toStringTag, { value: "Module" })), Rq = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Wp(e, t) {
  return f(), v("svg", Rq, [...t[0] || (t[0] = [
    g("g", { class: "cpu" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M6.25 1a.75.75 0 0 1 .75.75V3h2.25V1.75a.75.75 0 0 1 1.5 0V3H13V1.75a.75.75 0 0 1 1.5 0V3h.574c.19 0 .374 0 .53.013.171.014.373.047.577.15a1.5 1.5 0 0 1 .655.656c.104.204.137.406.151.577.013.156.013.34.013.53v.199h1.25a.75.75 0 0 1 0 1.5H17v2.25h1.25a.75.75 0 0 1 0 1.5H17v2.25h1.25a.75.75 0 0 1 0 1.5H17v.949c0 .19 0 .374-.013.53a1.517 1.517 0 0 1-.15.577 1.5 1.5 0 0 1-.656.655 1.517 1.517 0 0 1-.577.151c-.156.013-.34.013-.53.013H14.5v1.25a.75.75 0 0 1-1.5 0V17h-2.25v1.25a.75.75 0 0 1-1.5 0V17H7v1.25a.75.75 0 0 1-1.5 0V17h-.574c-.19 0-.374 0-.53-.013a1.517 1.517 0 0 1-.577-.15 1.5 1.5 0 0 1-.656-.656 1.517 1.517 0 0 1-.15-.577C3 15.448 3 15.264 3 15.074v-.949H1.75a.75.75 0 0 1 0-1.5H3v-2.25H1.75a.75.75 0 0 1 0-1.5H3v-2.25H1.75a.75.75 0 0 1 0-1.5H3v-.199c0-.19 0-.374.013-.53a1.53 1.53 0 0 1 .15-.577 1.5 1.5 0 0 1 .656-.656 1.53 1.53 0 0 1 .577-.15C4.552 3 4.736 3 4.926 3H5.5V1.75A.75.75 0 0 1 6.25 1ZM4.509 4.509l-.001.01a6.16 6.16 0 0 0-.008.431v10.1a6.135 6.135 0 0 0 .009.441l.01.001c.087.007.209.008.431.008h10.1a6.173 6.173 0 0 0 .441-.009l.001-.01a6.16 6.16 0 0 0 .008-.431V4.95a6.175 6.175 0 0 0-.009-.441l-.01-.001a6.135 6.135 0 0 0-.431-.008H4.95a6.136 6.136 0 0 0-.441.009ZM7.637 6.5h4.726c.058 0 .139 0 .212.006.088.007.229.027.379.103a1 1 0 0 1 .437.437c.076.15.096.29.103.379.006.073.006.154.006.212v4.726c0 .058 0 .139-.006.212a1.003 1.003 0 0 1-.103.379 1 1 0 0 1-.437.437c-.15.076-.29.096-.379.103-.073.006-.154.006-.212.006H7.637c-.058 0-.139 0-.212-.006a1.003 1.003 0 0 1-.379-.103 1 1 0 0 1-.437-.437 1.003 1.003 0 0 1-.103-.379c-.006-.073-.006-.154-.006-.212V7.637c0-.058 0-.139.006-.212.007-.088.027-.229.103-.379a1 1 0 0 1 .437-.437c.15-.076.29-.096.379-.103.073-.006.154-.006.212-.006ZM8 8v4h4V8H8Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Fq = { render: Wp }, Tq = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Fq,
  render: Wp
}, Symbol.toStringTag, { value: "Module" })), Iq = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Up(e, t) {
  return f(), v("svg", Iq, [...t[0] || (t[0] = [
    g("g", { class: "crown" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10 3a.75.75 0 0 1 .633.347l3.129 4.918L17.9 6.086a.75.75 0 0 1 1.083.819l-2 9.5a.75.75 0 0 1-.734.595H3.75a.75.75 0 0 1-.734-.596l-2-9.5A.75.75 0 0 1 2.1 6.087l4.14 2.179 3.128-4.918A.75.75 0 0 1 10 3Zm0 2.147L7.133 9.653a.75.75 0 0 1-.982.26L2.813 8.158 4.359 15.5h11.283l1.545-7.343-3.338 1.757a.75.75 0 0 1-.982-.261L10 5.147Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Dq = { render: Up }, kq = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Dq,
  render: Up
}, Symbol.toStringTag, { value: "Module" })), Hq = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Kp(e, t) {
  return f(), v("svg", Hq, [...t[0] || (t[0] = [
    g("g", { class: "cursor-arrow-fill" }, [
      g("path", {
        d: "M2.22 2.22a.75.75 0 0 1 .806-.167l14.5 5.75a.75.75 0 0 1 .16 1.307l-2.78 1.986 2.874 2.874a.75.75 0 0 1 0 1.06l-2.75 2.75a.75.75 0 0 1-1.06 0l-2.874-2.874-1.986 2.78a.75.75 0 0 1-1.307-.16l-5.75-14.5a.75.75 0 0 1 .167-.806Z",
        class: "Icon"
      })
    ], -1)
  ])]);
}
const Vq = { render: Kp }, Oq = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Vq,
  render: Kp
}, Symbol.toStringTag, { value: "Module" })), Bq = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function qp(e, t) {
  return f(), v("svg", Bq, [...t[0] || (t[0] = [
    g("g", { class: "cursor-arrow" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M2.22 2.22a.75.75 0 0 1 .806-.167l14.5 5.75a.75.75 0 0 1 .16 1.307l-2.78 1.986 2.874 2.874a.75.75 0 0 1 0 1.06l-2.75 2.75a.75.75 0 0 1-1.06 0l-2.874-2.874-1.986 2.78a.75.75 0 0 1-1.307-.16l-5.75-14.5a.75.75 0 0 1 .167-.806Zm1.867 1.867L8.69 15.694l1.7-2.38a.75.75 0 0 1 1.14-.094l2.97 2.97 1.69-1.69-2.97-2.97a.75.75 0 0 1 .094-1.14l2.38-1.7L4.087 4.087Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const $q = { render: qp }, Zq = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: $q,
  render: qp
}, Symbol.toStringTag, { value: "Module" })), Gq = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Yp(e, t) {
  return f(), v("svg", Gq, [...t[0] || (t[0] = [
    g("g", { class: "cursor-text" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M5 1.75A.75.75 0 0 1 5.75 1h.75c1.114 0 2.183.278 2.986.96.192.163.364.346.514.546.15-.2.322-.383.514-.546.803-.682 1.872-.96 2.986-.96h.75a.75.75 0 0 1 0 1.5h-.75c-.886 0-1.567.222-2.014.603-.428.364-.736.95-.736 1.897v10c0 .947.308 1.533.736 1.897.447.38 1.128.603 2.014.603h.75a.75.75 0 0 1 0 1.5h-.75c-1.114 0-2.183-.278-2.986-.96a3.369 3.369 0 0 1-.514-.546c-.15.2-.322.383-.514.546-.803.682-1.872.96-2.986.96h-.75a.75.75 0 0 1 0-1.5h.75c.886 0 1.567-.222 2.014-.603.428-.364.736-.95.736-1.897V5c0-.947-.308-1.533-.736-1.897C8.067 2.723 7.386 2.5 6.5 2.5h-.75A.75.75 0 0 1 5 1.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Nq = { render: Yp }, zq = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Nq,
  render: Yp
}, Symbol.toStringTag, { value: "Module" })), jq = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Qp(e, t) {
  return f(), v("svg", jq, [...t[0] || (t[0] = [
    g("g", { class: "database" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M1.009 3.386A1.079 1.079 0 0 1 1 3.25c0-.371.188-.653.375-.837.184-.181.416-.318.648-.427.468-.218 1.104-.393 1.85-.534C5.374 1.17 7.487 1 10 1c2.512 0 4.625.17 6.128.452.745.14 1.38.316 1.849.534.232.109.464.246.648.427.187.184.375.466.375.837 0 .047-.003.092-.009.136A.75.75 0 0 1 19 3.5v13a.747.747 0 0 1-.01.125c.007.04.01.082.01.125 0 .371-.188.654-.375.837a2.32 2.32 0 0 1-.648.427c-.468.218-1.104.393-1.85.534C14.626 18.83 12.513 19 10 19c-2.512 0-4.625-.17-6.128-.452-.745-.14-1.38-.316-1.849-.534a2.32 2.32 0 0 1-.648-.427A1.174 1.174 0 0 1 1 16.75c0-.043.004-.084.01-.125A.755.755 0 0 1 1 16.5v-13c0-.039.003-.077.009-.114ZM2.5 4.703V7.57a1.5 1.5 0 0 0 .157.083c.302.14.797.288 1.493.42 1.38.26 3.392.426 5.85.426 2.458 0 4.47-.167 5.85-.426.696-.131 1.19-.28 1.493-.42.07-.032.12-.06.157-.083V4.703a10.37 10.37 0 0 1-1.372.345c-1.503.283-3.616.452-6.128.452s-4.625-.17-6.128-.452A10.37 10.37 0 0 1 2.5 4.703ZM17.11 3.25a8.179 8.179 0 0 0-1.26-.324C14.47 2.666 12.458 2.5 10 2.5c-2.458 0-4.47.167-5.85.426-.54.102-.958.213-1.26.324.302.11.72.222 1.26.324C5.53 3.834 7.542 4 10 4c2.458 0 4.47-.167 5.85-.426a8.18 8.18 0 0 0 1.26-.324Zm.39 5.953a10.37 10.37 0 0 1-1.372.345C14.625 9.83 12.512 10 10 10s-4.625-.17-6.128-.452A10.37 10.37 0 0 1 2.5 9.203v2.868a1.5 1.5 0 0 0 .157.083c.302.14.797.289 1.493.42 1.38.26 3.392.426 5.85.426 2.458 0 4.47-.166 5.85-.426.696-.131 1.19-.28 1.493-.42a1.5 1.5 0 0 0 .157-.083V9.203Zm0 4.5a10.37 10.37 0 0 1-1.372.345c-1.503.283-3.616.452-6.128.452s-4.625-.17-6.128-.452a10.37 10.37 0 0 1-1.372-.345V16.5a.763.763 0 0 1-.003.069c.036.023.088.052.16.085.302.14.797.288 1.493.42 1.38.26 3.392.426 5.85.426 2.458 0 4.47-.166 5.85-.426.696-.132 1.19-.28 1.493-.42.072-.033.124-.062.16-.085a.785.785 0 0 1-.003-.069v-2.797Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Wq = { render: Qp }, Uq = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Wq,
  render: Qp
}, Symbol.toStringTag, { value: "Module" })), Kq = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Jp(e, t) {
  return f(), v("svg", Kq, [...t[0] || (t[0] = [
    g("g", { class: "delete" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M6 3.75A2.75 2.75 0 0 1 8.75 1h2.5A2.75 2.75 0 0 1 14 3.75V4h3.25a.75.75 0 0 1 0 1.5h-.29l-.606 10.902A2.75 2.75 0 0 1 13.608 19H6.392a2.75 2.75 0 0 1-2.746-2.598L3.041 5.5H2.75a.75.75 0 0 1 0-1.5H6v-.25ZM4.543 5.5l.6 10.82a1.25 1.25 0 0 0 1.249 1.18h7.216a1.25 1.25 0 0 0 1.248-1.18l.601-10.82H4.543ZM12.5 4h-5v-.25c0-.69.56-1.25 1.25-1.25h2.5c.69 0 1.25.56 1.25 1.25V4ZM7.75 8a.75.75 0 0 1 .75.75v5.5a.75.75 0 0 1-1.5 0v-5.5A.75.75 0 0 1 7.75 8Zm4.5 0a.75.75 0 0 1 .75.75v5.5a.75.75 0 0 1-1.5 0v-5.5a.75.75 0 0 1 .75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const qq = { render: Jp }, Yq = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: qq,
  render: Jp
}, Symbol.toStringTag, { value: "Module" })), Qq = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Xp(e, t) {
  return f(), v("svg", Qq, [...t[0] || (t[0] = [
    g("g", { class: "desktop" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M4.92 1h10.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 18.7 2.502c.172.337.24.693.27 1.073.03.365.03.81.03 1.345v6.16c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073a2.751 2.751 0 0 1-1.2 1.202c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03h-4.33v2.5h2.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1 0-1.5h2.5V15H4.92c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 1.3 13.5c-.172-.338-.24-.694-.27-1.074C1 12.06 1 11.615 1 11.08V4.92c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 2.502 1.3c.337-.172.693-.24 1.073-.27C3.94 1 4.385 1 4.92 1ZM2.5 11.5c.002.336.008.592.025.803.023.287.065.424.111.514.12.236.311.427.547.547.09.046.227.088.514.111.296.024.68.025 1.253.025h10.1c.572 0 .957 0 1.252-.025.288-.023.425-.065.515-.111a1.25 1.25 0 0 0 .547-.546c.046-.091.088-.228.111-.515.017-.211.023-.467.024-.803H2.501Zm15-1.5h-15V4.95c0-.572 0-.957.025-1.253.023-.287.065-.424.111-.514a1.25 1.25 0 0 1 .547-.547c.09-.046.227-.088.514-.111.296-.024.68-.025 1.253-.025h10.1c.572 0 .957 0 1.252.025.288.023.425.065.515.111.236.12.427.311.547.547.046.09.088.227.111.514.024.296.025.68.025 1.253V10Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Jq = { render: Xp }, Xq = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Jq,
  render: Xp
}, Symbol.toStringTag, { value: "Module" })), eY = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function e9(e, t) {
  return f(), v("svg", eY, [...t[0] || (t[0] = [
    g("g", { class: "devices" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M5.92 2h8.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 17.7 3.502c.172.337.24.693.27 1.073.03.365.03.81.03 1.345v.249l.044.022c.33.168.598.435.765.765.118.23.157.463.175.676.016.198.016.434.016.692v8.352c0 .258 0 .494-.016.692a1.775 1.775 0 0 1-.175.677 1.75 1.75 0 0 1-.765.764 1.77 1.77 0 0 1-.676.175c-.198.016-.434.016-.692.016h-3.352c-.258 0-.494 0-.692-.016a1.775 1.775 0 0 1-.676-.175 1.75 1.75 0 0 1-.787-.809h-6.25c-.534 0-.98 0-1.344-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 1.3 16.5c-.172-.338-.24-.694-.27-1.074C1 15.06 1 14.615 1 14.08v-.33a.75.75 0 0 1 .75-.75H2V5.92c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 3.502 2.3c.337-.172.693-.24 1.073-.27C4.94 2 5.385 2 5.92 2ZM2.5 14.5c.002.336.008.592.025.803.023.287.065.424.111.514.12.236.311.427.547.547.09.046.227.088.514.111.296.024.68.025 1.253.025H11V16H8.651a2.434 2.434 0 0 1-2.025-1.084.934.934 0 0 0-.777-.416H2.5Zm8.5 0H8.651a.934.934 0 0 1-.777-.416A2.434 2.434 0 0 0 5.849 13H3.5V5.95c0-.572 0-.957.025-1.253.023-.287.065-.424.111-.514a1.25 1.25 0 0 1 .547-.547c.09-.046.227-.088.514-.111.296-.024.68-.025 1.253-.025h8.1c.572 0 .957 0 1.252.025.288.023.425.065.516.111.235.12.426.311.546.547.046.09.088.227.111.514.024.296.025.68.025 1.253V6h-3.176c-.258 0-.494 0-.692.016a1.774 1.774 0 0 0-.676.175 1.75 1.75 0 0 0-.765.765c-.118.23-.158.463-.175.676C11 7.83 11 8.066 11 8.324V14.5Zm1.63-6.97h.002-.001Zm.003-.001a.626.626 0 0 1 .121-.018c.13-.01.304-.011.596-.011h3.3c.292 0 .467 0 .596.011a.626.626 0 0 1 .12.018.25.25 0 0 1 .105.104.638.638 0 0 1 .018.121c.01.13.011.304.011.596v8.3c0 .292 0 .467-.011.596a.636.636 0 0 1-.018.12.25.25 0 0 1-.105.105.636.636 0 0 1-.12.018c-.13.01-.304.011-.596.011h-3.3c-.292 0-.467 0-.596-.011a.636.636 0 0 1-.12-.018.25.25 0 0 1-.105-.105.636.636 0 0 1-.018-.12 8.373 8.373 0 0 1-.011-.596v-8.3c0-.292 0-.467.011-.596a.638.638 0 0 1 .018-.12.25.25 0 0 1 .104-.105Zm-.103.102v.001-.001Zm0 9.738v-.001.001Zm.1.101h.002-.001Zm4.74 0h-.002.001Zm.1-9.84v.002-.001Zm-.102-.1h.001-.002Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const tY = { render: e9 }, oY = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: tY,
  render: e9
}, Symbol.toStringTag, { value: "Module" })), nY = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function t9(e, t) {
  return f(), v("svg", nY, [...t[0] || (t[0] = [
    g("g", { class: "diamond" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M5.59 2h8.82c.262 0 .542-.001.806.083.23.073.442.193.623.353.208.183.352.423.487.649l.025.043 2.176 3.308a24.708 24.708 0 0 0 .064.104c.15.249.316.524.375.828.021.108.032.217.032.325a.763.763 0 0 1-.01.193c-.01.098-.03.194-.056.288-.085.302-.272.562-.448.806l-.045.061a.75.75 0 0 1-.042.054l-6.507 7.53a10.46 10.46 0 0 1-.552.726c-.175.201-.392.407-.69.526a1.75 1.75 0 0 1-1.296 0c-.298-.12-.515-.325-.69-.526a10.47 10.47 0 0 1-.552-.726l-6.507-7.53a.747.747 0 0 1-.042-.054l-.044-.06c-.177-.245-.364-.505-.45-.807a1.771 1.771 0 0 1-.055-.288.754.754 0 0 1-.01-.193c0-.108.01-.217.032-.325.059-.304.225-.579.376-.827a20.537 20.537 0 0 0 .063-.105L3.65 3.128l.025-.043c.135-.226.279-.466.487-.65.18-.159.393-.279.623-.352.264-.084.544-.084.806-.083Zm-.77 2.075L2.899 7h5.155L4.821 4.075ZM10 8.5H3.07l6.196 7.17a.766.766 0 0 1 .042.053c.227.316.369.51.484.643.073.084.11.112.12.12a.25.25 0 0 0 .173 0 .765.765 0 0 0 .12-.12c.116-.132.258-.327.485-.643a.736.736 0 0 1 .042-.053l6.196-7.17H10ZM17.102 7h-5.155l3.232-2.925L17.102 7ZM13.58 3.5H6.421L10 6.739 13.58 3.5Zm-3.496 12.988h.001Zm-.166 0h-.001Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const sY = { render: t9 }, iY = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sY,
  render: t9
}, Symbol.toStringTag, { value: "Module" })), rY = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function o9(e, t) {
  return f(), v("svg", rY, [...t[0] || (t[0] = [
    g("g", { class: "dns" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M4.92 2.5h10.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 18.7 4.002c.172.337.24.693.27 1.073.03.365.03.81.03 1.345v.41c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073a2.752 2.752 0 0 1-.563.752c.228.215.42.469.563.752.172.337.24.693.27 1.073.03.365.03.81.03 1.345v.41c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073a2.751 2.751 0 0 1-1.2 1.202c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03H4.92c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 1.3 16c-.172-.338-.24-.694-.27-1.074C1 14.56 1 14.115 1 13.58v-.41c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 1.863 10a2.75 2.75 0 0 1-.563-.752c-.172-.337-.24-.693-.27-1.073C1 7.81 1 7.365 1 6.83v-.41c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 2.502 2.8c.337-.172.693-.24 1.073-.27.365-.03.81-.03 1.345-.03Zm.03 8.25c-.572 0-.957 0-1.253.025-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.546c-.046.091-.088.228-.111.515-.024.296-.025.68-.025 1.253v.35c0 .572 0 .957.025 1.252.023.288.065.425.111.516.12.235.311.426.547.546.09.046.227.088.514.111.296.024.68.025 1.253.025h10.1c.572 0 .957 0 1.252-.025.288-.023.425-.065.515-.111a1.25 1.25 0 0 0 .547-.546c.046-.091.088-.228.111-.515.024-.296.025-.68.025-1.253v-.35c0-.572 0-.957-.025-1.252-.023-.288-.065-.425-.111-.516a1.25 1.25 0 0 0-.547-.546c-.09-.046-.227-.088-.515-.111-.295-.024-.68-.025-1.252-.025H4.95Zm10.1-1.5c.572 0 .957 0 1.252-.025.288-.023.425-.065.515-.111a1.25 1.25 0 0 0 .547-.547c.046-.09.088-.227.111-.514.024-.296.025-.68.025-1.253v-.35c0-.572 0-.957-.025-1.253-.023-.287-.065-.424-.111-.514a1.25 1.25 0 0 0-.547-.547c-.09-.046-.227-.088-.515-.111C16.007 4 15.622 4 15.05 4H4.95c-.572 0-.957 0-1.253.025-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.547c-.046.09-.088.227-.111.514-.024.296-.025.68-.025 1.253v.35c0 .572 0 .957.025 1.253.023.287.065.424.111.514.12.236.311.427.547.547.09.046.227.088.514.111.296.024.68.025 1.253.025h10.1ZM4 6.747a.75.75 0 0 1 .75-.75L7.25 6a.75.75 0 0 1 0 1.5l-2.5-.001a.75.75 0 0 1-.75-.75Zm0 6.502a.75.75 0 0 1 .75-.749l2.5.002a.75.75 0 0 1 0 1.5L4.75 14a.75.75 0 0 1-.75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const lY = { render: o9 }, aY = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: lY,
  render: o9
}, Symbol.toStringTag, { value: "Module" })), cY = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function n9(e, t) {
  return f(), v("svg", cY, [...t[0] || (t[0] = [
    g("g", { class: "download" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10 1a.75.75 0 0 1 .75.75v8.787l1.991-1.838A.75.75 0 1 1 13.76 9.8l-3.25 3a.75.75 0 0 1-1.018 0l-3.25-3A.75.75 0 1 1 7.26 8.7l1.991 1.838V1.75A.75.75 0 0 1 10 1ZM1.75 13a.75.75 0 0 1 .75.75v2.5c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25v-2.5a.75.75 0 0 1 1.5 0v2.5A2.75 2.75 0 0 1 16.25 19H3.75A2.75 2.75 0 0 1 1 16.25v-2.5a.75.75 0 0 1 .75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const dY = { render: n9 }, uY = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: dY,
  render: n9
}, Symbol.toStringTag, { value: "Module" })), hY = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function s9(e, t) {
  return f(), v("svg", hY, [...t[0] || (t[0] = [
    g("g", { class: "drag-drop-horizontal" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M5.75 3.25a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Zm5.5 0a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Zm0 6.75a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Zm1.5 8.25a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm-5.5-6.75a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm-1.5 5.25a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const gY = { render: s9 }, pY = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: gY,
  render: s9
}, Symbol.toStringTag, { value: "Module" })), fY = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function i9(e, t) {
  return f(), v("svg", fY, [...t[0] || (t[0] = [
    g("g", { class: "drag-drop-vertical" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M3.25 8.75a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm6.75 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm8.25-1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm-15 7a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm8.25-1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm5.25 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const vY = { render: i9 }, mY = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: vY,
  render: i9
}, Symbol.toStringTag, { value: "Module" })), CY = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function r9(e, t) {
  return f(), v("svg", CY, [...t[0] || (t[0] = [
    g("g", { class: "edit" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M12.891 2.048a3.579 3.579 0 0 1 5.06 5.06L6.282 18.78a.75.75 0 0 1-.531.22h-4a.75.75 0 0 1-.75-.75v-4a.75.75 0 0 1 .22-.53L12.89 2.048Zm2.53.452c-.55 0-1.08.219-1.47.609l-.39.391L16.5 6.44l.391-.392a2.078 2.078 0 0 0-1.47-3.548Zm.018 5L12.5 4.56l-10 10v2.94h2.94l10-10Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const wY = { render: r9 }, bY = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: wY,
  render: r9
}, Symbol.toStringTag, { value: "Module" })), yY = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function l9(e, t) {
  return f(), v("svg", yY, [...t[0] || (t[0] = [
    g("g", { class: "email" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10 2.5a7.5 7.5 0 1 0 0 15 .75.75 0 0 1 0 1.5 9 9 0 1 1 9-9v2a3 3 0 0 1-5.535 1.605 5 5 0 1 1 1.044-1.441A1.5 1.5 0 0 0 17.5 12v-2A7.5 7.5 0 0 0 10 2.5Zm3.104 9.119a3.5 3.5 0 1 0-6.208-3.238 3.5 3.5 0 0 0 6.208 3.238Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const _Y = { render: l9 }, SY = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _Y,
  render: l9
}, Symbol.toStringTag, { value: "Module" })), xY = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function a9(e, t) {
  return f(), v("svg", xY, [...t[0] || (t[0] = [
    g("g", { class: "emoji-big-smile" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10 2.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15ZM1 10a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm5-1.75a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1A.75.75 0 0 1 6 8.25Zm5.5 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm-4.858 4.062A.75.75 0 0 1 7.25 12h5.5a.75.75 0 0 1 .711.987C12.873 14.752 11.49 15.75 10 15.75c-1.49 0-2.873-.998-3.462-2.763a.75.75 0 0 1 .104-.675ZM8.494 13.5c.436.523.995.75 1.506.75s1.07-.227 1.506-.75H8.494Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const MY = { render: a9 }, AY = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: MY,
  render: a9
}, Symbol.toStringTag, { value: "Module" })), LY = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function c9(e, t) {
  return f(), v("svg", LY, [...t[0] || (t[0] = [
    g("g", { class: "emoji-sad" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10 2.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15ZM1 10a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm5-1.75a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1A.75.75 0 0 1 6 8.25Zm5.5 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75ZM10 12.5c-.937 0-1.744.415-2.08 1.085a.75.75 0 1 1-1.34-.67C7.243 11.585 8.686 11 10 11c1.313 0 2.756.585 3.42 1.915a.75.75 0 1 1-1.34.67c-.336-.67-1.143-1.085-2.08-1.085Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const EY = { render: c9 }, PY = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: EY,
  render: c9
}, Symbol.toStringTag, { value: "Module" })), RY = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function d9(e, t) {
  return f(), v("svg", RY, [...t[0] || (t[0] = [
    g("g", { class: "emoji-smile" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10 2.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15ZM1 10a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm5-1.75a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1A.75.75 0 0 1 6 8.25Zm5.5 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm-4.585 3.83a.75.75 0 0 1 1.006.335c.335.67 1.142 1.085 2.079 1.085.937 0 1.744-.415 2.08-1.085a.75.75 0 1 1 1.34.67C12.757 14.415 11.314 15 10 15c-1.313 0-2.756-.585-3.42-1.915a.75.75 0 0 1 .335-1.006Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const FY = { render: d9 }, TY = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: FY,
  render: d9
}, Symbol.toStringTag, { value: "Module" })), IY = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function u9(e, t) {
  return f(), v("svg", IY, [...t[0] || (t[0] = [
    g("g", { class: "error-fill" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10 1a9 9 0 1 0 0 18 9 9 0 0 0 0-18ZM7.28 6.22a.75.75 0 0 0-1.06 1.06L8.94 10l-2.72 2.72a.75.75 0 1 0 1.06 1.06L10 11.06l2.72 2.72a.75.75 0 1 0 1.06-1.06L11.06 10l2.72-2.72a.75.75 0 0 0-1.06-1.06L10 8.94 7.28 6.22Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const DY = { render: u9 }, kY = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: DY,
  render: u9
}, Symbol.toStringTag, { value: "Module" })), HY = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function h9(e, t) {
  return f(), v("svg", HY, [...t[0] || (t[0] = [
    g("g", { class: "error" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10 2.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15ZM1 10a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm5.22-3.78a.75.75 0 0 1 1.06 0L10 8.94l2.72-2.72a.75.75 0 1 1 1.06 1.06L11.06 10l2.72 2.72a.75.75 0 1 1-1.06 1.06L10 11.06l-2.72 2.72a.75.75 0 0 1-1.06-1.06L8.94 10 6.22 7.28a.75.75 0 0 1 0-1.06Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const VY = { render: h9 }, OY = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: VY,
  render: h9
}, Symbol.toStringTag, { value: "Module" })), BY = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function g9(e, t) {
  return f(), v("svg", BY, [...t[0] || (t[0] = [
    g("g", { class: "extension" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M8.75 2.5A1.75 1.75 0 0 0 7 4.25a.75.75 0 0 1-.75.75h-2.5c-.69 0-1.25.56-1.25 1.25v1.837a3.251 3.251 0 0 1 0 6.326v1.837c0 .69.56 1.25 1.25 1.25h1.837a3.251 3.251 0 0 1 6.326 0h1.837c.69 0 1.25-.56 1.25-1.25v-2.5a.75.75 0 0 1 .75-.75 1.75 1.75 0 1 0 0-3.5.75.75 0 0 1-.75-.75v-2.5C15 5.56 14.44 5 13.75 5h-2.5a.75.75 0 0 1-.75-.75A1.75 1.75 0 0 0 8.75 2.5Zm-3.163 1a3.251 3.251 0 0 1 6.326 0h1.837a2.75 2.75 0 0 1 2.75 2.75v1.837a3.251 3.251 0 0 1 0 6.326v1.837A2.75 2.75 0 0 1 13.75 19h-2.5a.75.75 0 0 1-.75-.75 1.75 1.75 0 1 0-3.5 0 .75.75 0 0 1-.75.75h-2.5A2.75 2.75 0 0 1 1 16.25v-2.5a.75.75 0 0 1 .75-.75 1.75 1.75 0 1 0 0-3.5.75.75 0 0 1-.75-.75v-2.5A2.75 2.75 0 0 1 3.75 3.5h1.837Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const $Y = { render: g9 }, ZY = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: $Y,
  render: g9
}, Symbol.toStringTag, { value: "Module" })), GY = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function p9(e, t) {
  return f(), v("svg", GY, [...t[0] || (t[0] = [
    g("g", { class: "eye-off" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M1.152 3.297a.75.75 0 0 1 1.05-.145l16.5 12.5a.75.75 0 1 1-.905 1.196l-2.673-2.025C13.736 15.988 11.972 17 10 17c-2.034 0-3.846-1.078-5.246-2.28-1.412-1.214-2.5-2.636-3.103-3.502l-.03-.043c-.145-.207-.305-.437-.384-.754a1.878 1.878 0 0 1 0-.842c.079-.317.24-.547.384-.754l.03-.043a20.41 20.41 0 0 1 2.11-2.567L1.297 4.348a.75.75 0 0 1-.145-1.05Zm3.816 3.831a18.753 18.753 0 0 0-2.085 2.51 3.978 3.978 0 0 0-.165.247.194.194 0 0 0-.024.053l-.002.014a.466.466 0 0 0 .002.11c.002.009.005.02.024.053.03.05.073.114.165.247.566.815 1.572 2.123 2.849 3.22C7.02 14.688 8.492 15.5 10 15.5c1.368 0 2.702-.667 3.893-1.61l-2.03-1.538a3 3 0 0 1-4.631-3.508L4.967 7.127ZM8.51 9.813a1.5 1.5 0 0 0 2.072 1.57L8.51 9.813ZM10 4.5c-.605 0-1.204.13-1.793.36a.75.75 0 0 1-.547-1.397A6.404 6.404 0 0 1 10 3c2.034 0 3.846 1.078 5.246 2.28 1.412 1.214 2.5 2.636 3.103 3.502l.03.043c.145.207.305.437.384.754a1.87 1.87 0 0 1 0 .842c-.079.317-.24.547-.385.755a3.998 3.998 0 0 0-1.097-1.06.2.2 0 0 0 .026-.054l.001-.014a.456.456 0 0 0 0-.096c0-.008-.002-.014-.002-.014a.199.199 0 0 0-.024-.053 3.99 3.99 0 0 0-.165-.247c-.566-.815-1.572-2.123-2.849-3.22C12.98 5.312 11.508 4.5 10 4.5Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const NY = { render: p9 }, zY = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: NY,
  render: p9
}, Symbol.toStringTag, { value: "Module" })), jY = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function f9(e, t) {
  return f(), v("svg", jY, [...t[0] || (t[0] = [
    g("g", { class: "eye" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M5.614 6.424C4.306 7.522 3.276 8.83 2.696 9.644a3.979 3.979 0 0 0-.168.247.19.19 0 0 0-.024.05l-.002.013a.44.44 0 0 0 .002.105.19.19 0 0 0 .024.05c.03.05.074.113.168.246.58.815 1.61 2.123 2.918 3.22C6.933 14.684 8.444 15.5 10 15.5s3.067-.817 4.386-1.924c1.308-1.098 2.338-2.406 2.918-3.22.094-.134.138-.197.168-.247a.19.19 0 0 0 .024-.05l.002-.013a.42.42 0 0 0 0-.092l-.002-.013a.19.19 0 0 0-.024-.05 3.993 3.993 0 0 0-.168-.246c-.58-.815-1.61-2.123-2.918-3.22C13.067 5.316 11.556 4.5 10 4.5s-3.067.817-4.386 1.924Zm-.965-1.149C6.082 4.073 7.93 3 10 3s3.918 1.073 5.35 2.275c1.445 1.212 2.56 2.634 3.176 3.5l.03.043c.148.207.314.438.395.757.066.26.066.59 0 .85-.081.319-.247.55-.395.757l-.03.043c-.617.866-1.731 2.287-3.175 3.5C13.918 15.927 12.07 17 10 17s-3.918-1.073-5.35-2.275c-1.445-1.213-2.56-2.634-3.176-3.5a8.876 8.876 0 0 0-.03-.043c-.149-.207-.314-.438-.395-.757a1.853 1.853 0 0 1 0-.85c.081-.319.246-.55.395-.757l.03-.043c.617-.866 1.731-2.288 3.175-3.5ZM10 8.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM7 10a3 3 0 1 1 6 0 3 3 0 0 1-6 0Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const WY = { render: f9 }, UY = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: WY,
  render: f9
}, Symbol.toStringTag, { value: "Module" })), KY = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function v9(e, t) {
  return f(), v("svg", KY, [...t[0] || (t[0] = [
    g("g", {
      class: "file-check",
      "clip-path": "url(#a)"
    }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M5.75 2.5c-.69 0-1.25.56-1.25 1.25v12.5c0 .69.56 1.25 1.25 1.25h3.5a.75.75 0 0 1 0 1.5h-3.5A2.75 2.75 0 0 1 3 16.25V3.75A2.75 2.75 0 0 1 5.75 1h5.5a.75.75 0 0 1 .53.22l5 5c.141.14.22.331.22.53v2.5a.75.75 0 0 1-1.5 0V7.5h-4.25a.75.75 0 0 1-.75-.75V2.5H5.75ZM12 3.56 14.44 6H12V3.56Zm7.765 9.645a.75.75 0 0 1 .03 1.06l-4.25 4.5a.75.75 0 0 1-1.102-.013l-2.25-2.5a.75.75 0 1 1 1.114-1.004l1.706 1.896 3.692-3.909a.75.75 0 0 1 1.06-.03Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1),
    g("defs", null, [
      g("clipPath", {
        id: "a",
        class: "a"
      }, [
        g("path", { d: "M0 0h20v20H0z" })
      ])
    ], -1)
  ])]);
}
const qY = { render: v9 }, YY = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: qY,
  render: v9
}, Symbol.toStringTag, { value: "Module" })), QY = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function m9(e, t) {
  return f(), v("svg", QY, [...t[0] || (t[0] = [
    g("g", { class: "file-close" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M5.75 2.5c-.69 0-1.25.56-1.25 1.25v12.5c0 .69.56 1.25 1.25 1.25h3.5a.75.75 0 0 1 0 1.5h-3.5A2.75 2.75 0 0 1 3 16.25V3.75A2.75 2.75 0 0 1 5.75 1h5.5a.75.75 0 0 1 .53.22l5 5c.141.14.22.331.22.53v2.5a.75.75 0 0 1-1.5 0V7.5h-4.25a.75.75 0 0 1-.75-.75V2.5H5.75ZM12 3.56 14.44 6H12V3.56Zm1.22 9.66a.75.75 0 0 1 1.06 0L16 14.94l1.72-1.72a.75.75 0 1 1 1.06 1.06L17.06 16l1.72 1.72a.75.75 0 1 1-1.06 1.06L16 17.06l-1.72 1.72a.75.75 0 1 1-1.06-1.06L14.94 16l-1.72-1.72a.75.75 0 0 1 0-1.06Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const JY = { render: m9 }, XY = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: JY,
  render: m9
}, Symbol.toStringTag, { value: "Module" })), eQ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function C9(e, t) {
  return f(), v("svg", eQ, [...t[0] || (t[0] = [
    g("g", { class: "file-edit" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M5.75 2.5c-.69 0-1.25.56-1.25 1.25v12.5c0 .69.56 1.25 1.25 1.25h3.5a.75.75 0 0 1 0 1.5h-3.5A2.75 2.75 0 0 1 3 16.25V3.75A2.75 2.75 0 0 1 5.75 1h5.5a.75.75 0 0 1 .53.22l5 5c.141.14.22.331.22.53v2.5a.75.75 0 0 1-1.5 0V7.5h-4.25a.75.75 0 0 1-.75-.75V2.5H5.75ZM12 3.56 14.44 6H12V3.56Zm6.286 10.154a.73.73 0 0 0-1.033 0L13.5 17.467V18.5h1.033l3.753-3.753a.73.73 0 0 0 0-1.033Zm-2.094-1.06a2.23 2.23 0 1 1 3.155 3.154l-3.973 3.972a.75.75 0 0 1-.53.22H12.75a.75.75 0 0 1-.75-.75v-2.094a.75.75 0 0 1 .22-.53l3.972-3.973Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const tQ = { render: C9 }, oQ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: tQ,
  render: C9
}, Symbol.toStringTag, { value: "Module" })), nQ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function w9(e, t) {
  return f(), v("svg", nQ, [...t[0] || (t[0] = [
    g("g", { class: "file-minus" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M5.75 2.5c-.69 0-1.25.56-1.25 1.25v12.5c0 .69.56 1.25 1.25 1.25h3.5a.75.75 0 0 1 0 1.5h-3.5A2.75 2.75 0 0 1 3 16.25V3.75A2.75 2.75 0 0 1 5.75 1h5.5a.75.75 0 0 1 .53.22l5 5c.141.14.22.331.22.53v2.5a.75.75 0 0 1-1.5 0V7.5h-4.25a.75.75 0 0 1-.75-.75V2.5H5.75ZM12 3.56 14.44 6H12V3.56Zm0 12.19a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const sQ = { render: w9 }, iQ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sQ,
  render: w9
}, Symbol.toStringTag, { value: "Module" })), rQ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function b9(e, t) {
  return f(), v("svg", rQ, [...t[0] || (t[0] = [
    g("g", { class: "file-plus" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M5.75 2.5c-.69 0-1.25.56-1.25 1.25v12.5c0 .69.56 1.25 1.25 1.25h3.5a.75.75 0 0 1 0 1.5h-3.5A2.75 2.75 0 0 1 3 16.25V3.75A2.75 2.75 0 0 1 5.75 1h5.5a.75.75 0 0 1 .53.22l5 5c.141.14.22.331.22.53v2.5a.75.75 0 0 1-1.5 0V7.5h-4.25a.75.75 0 0 1-.75-.75V2.5H5.75ZM12 3.56 14.44 6H12V3.56ZM16 12a.75.75 0 0 1 .75.75v2.5h2.5a.75.75 0 0 1 0 1.5h-2.5v2.5a.75.75 0 0 1-1.5 0v-2.5h-2.5a.75.75 0 0 1 0-1.5h2.5v-2.5A.75.75 0 0 1 16 12Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const lQ = { render: b9 }, aQ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: lQ,
  render: b9
}, Symbol.toStringTag, { value: "Module" })), cQ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function y9(e, t) {
  return f(), v("svg", cQ, [...t[0] || (t[0] = [
    g("g", { class: "file" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M5.75 2.5c-.69 0-1.25.56-1.25 1.25v12.5c0 .69.56 1.25 1.25 1.25h8.5c.69 0 1.25-.56 1.25-1.25V7.5h-4.25a.75.75 0 0 1-.75-.75V2.5H5.75ZM12 3.56 14.44 6H12V3.56Zm-9 .19A2.75 2.75 0 0 1 5.75 1h5.5a.75.75 0 0 1 .53.22l5 5c.141.14.22.331.22.53v9.5A2.75 2.75 0 0 1 14.25 19h-8.5A2.75 2.75 0 0 1 3 16.25V3.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const dQ = { render: y9 }, uQ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: dQ,
  render: y9
}, Symbol.toStringTag, { value: "Module" })), hQ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function _9(e, t) {
  return f(), v("svg", hQ, [...t[0] || (t[0] = [
    g("g", { class: "filter" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M1 4.75A.75.75 0 0 1 1.75 4h16.5a.75.75 0 0 1 0 1.5H1.75A.75.75 0 0 1 1 4.75ZM4 10a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H4.75A.75.75 0 0 1 4 10Zm3 5.25a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const gQ = { render: _9 }, pQ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: gQ,
  render: _9
}, Symbol.toStringTag, { value: "Module" })), fQ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function S9(e, t) {
  return f(), v("svg", fQ, [...t[0] || (t[0] = [
    g("g", { class: "fingerprint" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M1.22 4.72C2.517 3.423 4.95 1 10 1c3.93 0 6.377 1.317 7.78 2.72a.75.75 0 1 1-1.06 1.06C15.623 3.684 13.57 2.5 10 2.5c-4.44 0-6.508 2.068-7.712 3.272l-.008.008a.75.75 0 1 1-1.06-1.06Zm2.852 1.244C5.846 4.429 8.088 3.75 10 3.75c3.44 0 5.72 1.2 7.128 2.82C18.515 8.165 19 10.1 19 11.5c0 .876-.055 1.981-.523 2.878a2.857 2.857 0 0 1-1.12 1.183c-.512.294-1.132.439-1.857.439-1.868 0-3.5-1.54-3.5-3.25 0-.686-.24-1.17-.575-1.484-.344-.322-.84-.516-1.425-.516-.827 0-1.803.674-2.008 2.106-.21 1.468.164 2.766 1.85 4.934a.75.75 0 1 1-1.184.92c-1.814-2.332-2.44-4.034-2.15-6.066C6.803 10.576 8.327 9.25 10 9.25c.915 0 1.794.306 2.45.922.665.622 1.05 1.514 1.05 2.578 0 .79.868 1.75 2 1.75.525 0 .874-.105 1.111-.24.234-.134.405-.325.537-.576.282-.54.352-1.31.352-2.184 0-1.1-.39-2.665-1.504-3.945C14.906 6.3 13.06 5.25 10 5.25c-1.588 0-3.47.571-4.947 1.848C3.598 8.358 2.5 10.335 2.5 13.25a.75.75 0 0 1-1.5 0c0-3.336 1.277-5.733 3.072-7.286ZM10 8c-2.757 0-4.417 2.34-4.624 4.328-.12 1.156.008 2.503.546 3.589a.75.75 0 0 1-1.344.666c-.701-1.414-.834-3.067-.694-4.41C4.146 9.658 6.257 6.5 10 6.5c1.492 0 2.662.34 3.568.89a5.284 5.284 0 0 1 1.902 1.999 6.5 6.5 0 0 1 .78 2.833v.028l-.75.001h.75a.75.75 0 0 1-1.5.003v-.002.001-.003a1.597 1.597 0 0 0-.008-.155 5.002 5.002 0 0 0-.586-1.982 3.785 3.785 0 0 0-1.365-1.44C12.151 8.285 11.258 8 10 8Zm4.75 4.251Zm0 0ZM10 12a.75.75 0 0 1 .75.75c0 2.456 1.775 4.75 4.25 4.75.98 0 1.8-.005 2.864-.643a.75.75 0 1 1 .772 1.286C17.208 19 16.034 19 15.018 19H15c-3.525 0-5.75-3.206-5.75-6.25A.75.75 0 0 1 10 12Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const vQ = { render: S9 }, mQ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: vQ,
  render: S9
}, Symbol.toStringTag, { value: "Module" })), CQ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function x9(e, t) {
  return f(), v("svg", CQ, [...t[0] || (t[0] = [
    g("g", { class: "fire" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M8.422 1.076a.75.75 0 0 1 .772.07c2.023 1.483 2.96 3.223 3.175 4.948a6.722 6.722 0 0 1-.06 2.02c.377-.501.61-1.035.706-1.507a.75.75 0 0 1 1.17-.463C16.029 7.456 17.5 9.153 17.5 11.75c0 3.914-3.086 7.25-7.5 7.25s-7.5-3.336-7.5-7.25c0-1.222.207-2.167.72-3.085.495-.883 1.254-1.7 2.25-2.695.947-.948 1.582-1.866 1.98-2.629.407-.781.542-1.354.55-1.615a.75.75 0 0 1 .422-.65Zm.775 2.027c-.11.294-.248.607-.417.931-.47.903-1.197 1.944-2.25 2.996-1.004 1.004-1.62 1.688-2 2.368-.362.644-.53 1.324-.53 2.352 0 3.086 2.414 5.75 6 5.75s6-2.664 6-5.75c0-1.572-.701-2.734-1.879-3.754a5.988 5.988 0 0 1-3.076 2.943.75.75 0 0 1-.95-1.053c.57-1.028.948-2.305.786-3.605-.129-1.028-.6-2.127-1.684-3.178Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const wQ = { render: x9 }, bQ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: wQ,
  render: x9
}, Symbol.toStringTag, { value: "Module" })), yQ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function M9(e, t) {
  return f(), v("svg", yQ, [...t[0] || (t[0] = [
    g("g", { class: "flag" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M4.75 2.5c-.69 0-1.25.56-1.25 1.25v7.75h12.236l-3.083-4.045a.75.75 0 0 1 0-.91L15.736 2.5H4.75ZM3.5 13v5.25a.75.75 0 0 1-1.5 0V3.75A2.75 2.75 0 0 1 4.75 1h12.5a.75.75 0 0 1 .597 1.205L14.193 7l3.654 4.796A.75.75 0 0 1 17.25 13H3.5Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const _Q = { render: M9 }, SQ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _Q,
  render: M9
}, Symbol.toStringTag, { value: "Module" })), xQ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function A9(e, t) {
  return f(), v("svg", xQ, [...t[0] || (t[0] = [
    g("g", {
      class: "folder-check",
      "clip-path": "url(#a)"
    }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M1 4.75A2.75 2.75 0 0 1 3.75 2h6a.75.75 0 0 1 .624.334L12.151 5h4.099A2.75 2.75 0 0 1 19 7.75v1.5a.75.75 0 0 1-1.5 0v-1.5c0-.69-.56-1.25-1.25-1.25H2.5v8.75c0 .69.56 1.25 1.25 1.25h5.5a.75.75 0 0 1 0 1.5h-5.5A2.75 2.75 0 0 1 1 15.25V4.75ZM2.5 5h7.849l-1-1.5H3.75c-.69 0-1.25.56-1.25 1.25V5Zm17.265 8.205a.75.75 0 0 1 .03 1.06l-4.25 4.5a.75.75 0 0 1-1.102-.013l-2.25-2.5a.75.75 0 1 1 1.114-1.004l1.706 1.896 3.692-3.909a.75.75 0 0 1 1.06-.03Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1),
    g("defs", null, [
      g("clipPath", {
        id: "a",
        class: "a"
      }, [
        g("path", { d: "M0 0h20v20H0z" })
      ])
    ], -1)
  ])]);
}
const MQ = { render: A9 }, AQ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: MQ,
  render: A9
}, Symbol.toStringTag, { value: "Module" })), LQ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function L9(e, t) {
  return f(), v("svg", LQ, [...t[0] || (t[0] = [
    g("g", { class: "folder-close" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M1 4.75A2.75 2.75 0 0 1 3.75 2h6a.75.75 0 0 1 .624.334L12.151 5h4.099A2.75 2.75 0 0 1 19 7.75v1.5a.75.75 0 0 1-1.5 0v-1.5c0-.69-.56-1.25-1.25-1.25H2.5v8.75c0 .69.56 1.25 1.25 1.25h5.5a.75.75 0 0 1 0 1.5h-5.5A2.75 2.75 0 0 1 1 15.25V4.75ZM2.5 5h7.849l-1-1.5H3.75c-.69 0-1.25.56-1.25 1.25V5Zm10.72 8.22a.75.75 0 0 1 1.06 0L16 14.94l1.72-1.72a.75.75 0 1 1 1.06 1.06L17.06 16l1.72 1.72a.75.75 0 1 1-1.06 1.06L16 17.06l-1.72 1.72a.75.75 0 1 1-1.06-1.06L14.94 16l-1.72-1.72a.75.75 0 0 1 0-1.06Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const EQ = { render: L9 }, PQ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: EQ,
  render: L9
}, Symbol.toStringTag, { value: "Module" })), RQ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function E9(e, t) {
  return f(), v("svg", RQ, [...t[0] || (t[0] = [
    g("g", { class: "folder-edit" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M1 4.75A2.75 2.75 0 0 1 3.75 2h6a.75.75 0 0 1 .624.334L12.151 5h4.099A2.75 2.75 0 0 1 19 7.75v1.5a.75.75 0 0 1-1.5 0v-1.5c0-.69-.56-1.25-1.25-1.25H2.5v8.75c0 .69.56 1.25 1.25 1.25h5.5a.75.75 0 0 1 0 1.5h-5.5A2.75 2.75 0 0 1 1 15.25V4.75ZM2.5 5h7.849l-1-1.5H3.75c-.69 0-1.25.56-1.25 1.25V5Zm15.786 8.714a.73.73 0 0 0-1.033 0L13.5 17.467V18.5h1.033l3.753-3.753a.73.73 0 0 0 0-1.033Zm-2.094-1.06a2.23 2.23 0 1 1 3.155 3.154l-3.973 3.972a.75.75 0 0 1-.53.22H12.75a.75.75 0 0 1-.75-.75v-2.094a.75.75 0 0 1 .22-.53l3.972-3.973Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const FQ = { render: E9 }, TQ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: FQ,
  render: E9
}, Symbol.toStringTag, { value: "Module" })), IQ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function P9(e, t) {
  return f(), v("svg", IQ, [...t[0] || (t[0] = [
    g("g", { class: "folder-minus" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M1 4.75A2.75 2.75 0 0 1 3.75 2h6a.75.75 0 0 1 .624.334L12.151 5h4.099A2.75 2.75 0 0 1 19 7.75v1.5a.75.75 0 0 1-1.5 0v-1.5c0-.69-.56-1.25-1.25-1.25H2.5v8.75c0 .69.56 1.25 1.25 1.25h5.5a.75.75 0 0 1 0 1.5h-5.5A2.75 2.75 0 0 1 1 15.25V4.75ZM2.5 5h7.849l-1-1.5H3.75c-.69 0-1.25.56-1.25 1.25V5ZM12 15.75a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const DQ = { render: P9 }, kQ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: DQ,
  render: P9
}, Symbol.toStringTag, { value: "Module" })), HQ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function R9(e, t) {
  return f(), v("svg", HQ, [...t[0] || (t[0] = [
    g("g", { class: "folder-plus" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M1 4.75A2.75 2.75 0 0 1 3.75 2h6a.75.75 0 0 1 .624.334L12.151 5h4.099A2.75 2.75 0 0 1 19 7.75v1.5a.75.75 0 0 1-1.5 0v-1.5c0-.69-.56-1.25-1.25-1.25H2.5v8.75c0 .69.56 1.25 1.25 1.25h5.5a.75.75 0 0 1 0 1.5h-5.5A2.75 2.75 0 0 1 1 15.25V4.75ZM2.5 5h7.849l-1-1.5H3.75c-.69 0-1.25.56-1.25 1.25V5ZM16 12a.75.75 0 0 1 .75.75v2.5h2.5a.75.75 0 0 1 0 1.5h-2.5v2.5a.75.75 0 0 1-1.5 0v-2.5h-2.5a.75.75 0 0 1 0-1.5h2.5v-2.5A.75.75 0 0 1 16 12Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const VQ = { render: R9 }, OQ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: VQ,
  render: R9
}, Symbol.toStringTag, { value: "Module" })), BQ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function F9(e, t) {
  return f(), v("svg", BQ, [...t[0] || (t[0] = [
    g("g", { class: "folder" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M1 4.75A2.75 2.75 0 0 1 3.75 2h6a.75.75 0 0 1 .624.334L12.151 5h4.099A2.75 2.75 0 0 1 19 7.75v7.5A2.75 2.75 0 0 1 16.25 18H3.75A2.75 2.75 0 0 1 1 15.25V4.75Zm9.349.25-1-1.5H3.75c-.69 0-1.25.56-1.25 1.25V5h7.849ZM2.5 6.5v8.75c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25v-7.5c0-.69-.56-1.25-1.25-1.25H2.5Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const $Q = { render: F9 }, ZQ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: $Q,
  render: F9
}, Symbol.toStringTag, { value: "Module" })), GQ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function T9(e, t) {
  return f(), v("svg", GQ, [...t[0] || (t[0] = [
    g("g", { class: "format-align-center" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M1 3.25a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H1.75A.75.75 0 0 1 1 3.25Zm4 4.5A.75.75 0 0 1 5.75 7h8.5a.75.75 0 0 1 0 1.5h-8.5A.75.75 0 0 1 5 7.75Zm-4 4.5a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H1.75a.75.75 0 0 1-.75-.75Zm4 4.5a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1-.75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const NQ = { render: T9 }, zQ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: NQ,
  render: T9
}, Symbol.toStringTag, { value: "Module" })), jQ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function I9(e, t) {
  return f(), v("svg", jQ, [...t[0] || (t[0] = [
    g("g", { class: "format-align-justify" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M1 3.25a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H1.75A.75.75 0 0 1 1 3.25Zm0 4.5A.75.75 0 0 1 1.75 7h16.5a.75.75 0 0 1 0 1.5H1.75A.75.75 0 0 1 1 7.75Zm0 4.5a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H1.75a.75.75 0 0 1-.75-.75Zm0 4.5a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H1.75a.75.75 0 0 1-.75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const WQ = { render: I9 }, UQ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: WQ,
  render: I9
}, Symbol.toStringTag, { value: "Module" })), KQ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function D9(e, t) {
  return f(), v("svg", KQ, [...t[0] || (t[0] = [
    g("g", { class: "format-align-left" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M1 3.25a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H1.75A.75.75 0 0 1 1 3.25Zm0 4.5A.75.75 0 0 1 1.75 7h8.5a.75.75 0 0 1 0 1.5h-8.5A.75.75 0 0 1 1 7.75Zm0 4.5a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H1.75a.75.75 0 0 1-.75-.75Zm0 4.5a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1-.75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const qQ = { render: D9 }, YQ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: qQ,
  render: D9
}, Symbol.toStringTag, { value: "Module" })), QQ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function k9(e, t) {
  return f(), v("svg", QQ, [...t[0] || (t[0] = [
    g("g", { class: "format-align-right" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M1 3.25a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H1.75A.75.75 0 0 1 1 3.25Zm8 4.5A.75.75 0 0 1 9.75 7h8.5a.75.75 0 0 1 0 1.5h-8.5A.75.75 0 0 1 9 7.75Zm-8 4.5a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H1.75a.75.75 0 0 1-.75-.75Zm8 4.5a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1-.75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const JQ = { render: k9 }, XQ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: JQ,
  render: k9
}, Symbol.toStringTag, { value: "Module" })), eJ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 21"
};
function H9(e, t) {
  return f(), v("svg", eJ, [...t[0] || (t[0] = [
    g("g", { class: "format-all-small-caps" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M11.987 8h1.765c1.413 0 2.498 1.086 2.498 2.5 0 .535-.113 1.016-.348 1.413.205.14.383.31.534.507.413.543.564 1.22.564 1.83 0 .61-.15 1.287-.564 1.83-.436.571-1.109.92-1.972.92h-2.477c-.048 0-.135 0-.214-.009a.863.863 0 0 1-.522-.242.863.863 0 0 1-.242-.522 1.561 1.561 0 0 1-.009-.214V8.987c0-.048 0-.135.008-.214a.869.869 0 0 1 .243-.522.863.863 0 0 1 .522-.243C11.852 8 11.939 8 11.987 8Zm1.765 3.5c.385 0 .617-.097.746-.213.116-.105.252-.316.252-.787 0-.586-.415-1-.998-1H12.5v2h1.252ZM12.5 13h1.964c.422 0 .643.151.779.33.158.207.257.53.257.92s-.1.713-.257.92c-.136.179-.357.33-.78.33H12.5V13Zm-6-5a.75.75 0 0 1 .704.492l2.75 7.5a.75.75 0 0 1-1.408.516L7.9 14.75H5.1l-.645 1.758a.75.75 0 1 1-1.408-.516l2.75-7.5A.75.75 0 0 1 6.5 8Zm-.851 5.25H7.35l-.85-2.321-.851 2.321Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const tJ = { render: H9 }, oJ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: tJ,
  render: H9
}, Symbol.toStringTag, { value: "Module" })), nJ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function V9(e, t) {
  return f(), v("svg", nJ, [...t[0] || (t[0] = [
    g("g", { class: "format-bold" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M4 2.75C4 1.784 4.784 1 5.75 1H9.5c2.663 0 5 2.154 5 4.875 0 1.485-.696 2.8-1.76 3.69 1.864.692 3.26 2.457 3.26 4.56C16 16.846 13.663 19 11 19H5.75A1.75 1.75 0 0 1 4 17.25V2.75Zm5.5 6.5c1.893 0 3.5-1.54 3.5-3.375S11.393 2.5 9.5 2.5H5.75a.25.25 0 0 0-.25.25v6.5h4Zm-4 1.5H11c1.893 0 3.5 1.54 3.5 3.375S12.893 17.5 11 17.5H5.75a.25.25 0 0 1-.25-.25v-6.5Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const sJ = { render: V9 }, iJ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sJ,
  render: V9
}, Symbol.toStringTag, { value: "Module" })), rJ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function O9(e, t) {
  return f(), v("svg", rJ, [...t[0] || (t[0] = [
    g("g", { class: "format-font-size" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M1 2.75C1 1.784 1.784 1 2.75 1h10.5c.966 0 1.75.784 1.75 1.75v2a.75.75 0 0 1-1.5 0v-2a.25.25 0 0 0-.25-.25h-4.5v15h1.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5h1.5v-15h-4.5a.25.25 0 0 0-.25.25v2a.75.75 0 0 1-1.5 0v-2Zm10.25 7.75c0-.69.56-1.25 1.25-1.25h5.25c.69 0 1.25.56 1.25 1.25v1a.75.75 0 0 1-1.5 0v-.75h-1.625v6.75h.375a.75.75 0 0 1 0 1.5H14a.75.75 0 0 1 0-1.5h.375v-6.75H12.75v.75a.75.75 0 0 1-1.5 0v-1Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const lJ = { render: O9 }, aJ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: lJ,
  render: O9
}, Symbol.toStringTag, { value: "Module" })), cJ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function B9(e, t) {
  return f(), v("svg", cJ, [...t[0] || (t[0] = [
    g("g", { class: "format-indent-decrease" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M1 3.25a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H1.75A.75.75 0 0 1 1 3.25Zm5.591 2.832A.75.75 0 0 1 7 6.75v6.5a.75.75 0 0 1-1.19.608l-4.5-3.25a.75.75 0 0 1 0-1.216l4.5-3.25a.75.75 0 0 1 .781-.06ZM3.031 10 5.5 11.783V8.217L3.031 10ZM9 7.75A.75.75 0 0 1 9.75 7h8.5a.75.75 0 0 1 0 1.5h-8.5A.75.75 0 0 1 9 7.75Zm0 4.5a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1-.75-.75Zm-8 4.5a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H1.75a.75.75 0 0 1-.75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const dJ = { render: B9 }, uJ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: dJ,
  render: B9
}, Symbol.toStringTag, { value: "Module" })), hJ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function $9(e, t) {
  return f(), v("svg", hJ, [...t[0] || (t[0] = [
    g("g", { class: "format-indent-increase" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M1 3.25a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H1.75A.75.75 0 0 1 1 3.25Zm.409 2.832a.75.75 0 0 1 .78.06l4.5 3.25a.75.75 0 0 1 0 1.216l-4.5 3.25A.75.75 0 0 1 1 13.25v-6.5a.75.75 0 0 1 .409-.668ZM2.5 8.217v3.566L4.969 10 2.5 8.217ZM9 7.75A.75.75 0 0 1 9.75 7h8.5a.75.75 0 0 1 0 1.5h-8.5A.75.75 0 0 1 9 7.75Zm0 4.5a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1-.75-.75Zm-8 4.5a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H1.75a.75.75 0 0 1-.75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const gJ = { render: $9 }, pJ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: gJ,
  render: $9
}, Symbol.toStringTag, { value: "Module" })), fJ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Z9(e, t) {
  return f(), v("svg", fJ, [...t[0] || (t[0] = [
    g("g", { class: "format-italic" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M11.237 1H5.75a.75.75 0 0 0 0 1.5h4.628l-2.273 15H3.75a.75.75 0 0 0 0 1.5h10.5a.75.75 0 0 0 0-1.5H9.622l2.273-15h4.355a.75.75 0 0 0 0-1.5h-5.013Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const vJ = { render: Z9 }, mJ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: vJ,
  render: Z9
}, Symbol.toStringTag, { value: "Module" })), CJ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function G9(e, t) {
  return f(), v("svg", CJ, [...t[0] || (t[0] = [
    g("g", { class: "format-letter-spacing" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M1.75 2a.75.75 0 0 1 .75.75v14.5a.75.75 0 0 1-1.5 0V2.75A.75.75 0 0 1 1.75 2Zm16.5 0a.75.75 0 0 1 .75.75v14.5a.75.75 0 0 1-1.5 0V2.75a.75.75 0 0 1 .75-.75ZM5 5.75C5 4.784 5.784 4 6.75 4h6.5c.966 0 1.75.784 1.75 1.75v2a.75.75 0 0 1-1.5 0v-2a.25.25 0 0 0-.25-.25h-2.5v9h1.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5h1.5v-9h-2.5a.25.25 0 0 0-.25.25v2a.75.75 0 0 1-1.5 0v-2Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const wJ = { render: G9 }, bJ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: wJ,
  render: G9
}, Symbol.toStringTag, { value: "Module" })), yJ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function N9(e, t) {
  return f(), v("svg", yJ, [...t[0] || (t[0] = [
    g("g", { class: "format-line-height" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M1.75 1.75A.75.75 0 0 1 2.5 1H17a.75.75 0 0 1 0 1.5H2.5a.75.75 0 0 1-.75-.75Zm3.25 4C5 4.784 5.784 4 6.75 4h6.5c.966 0 1.75.784 1.75 1.75v2a.75.75 0 0 1-1.5 0v-2a.25.25 0 0 0-.25-.25h-2.5v9h1.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5h1.5v-9h-2.5a.25.25 0 0 0-.25.25v2a.75.75 0 0 1-1.5 0v-2Zm-3.25 12.5a.75.75 0 0 1 .75-.75H17a.75.75 0 0 1 0 1.5H2.5a.75.75 0 0 1-.75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const _J = { render: N9 }, SJ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _J,
  render: N9
}, Symbol.toStringTag, { value: "Module" })), xJ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 21"
};
function z9(e, t) {
  return f(), v("svg", xJ, [...t[0] || (t[0] = [
    g("g", { class: "format-lowercase" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M11.75 5a.75.75 0 0 1 .75.75v3.14c.609-.552 1.376-.89 2.25-.89 2.219 0 3.75 2.18 3.75 4.5S16.969 17 14.75 17c-.874 0-1.641-.338-2.25-.89v.14a.75.75 0 0 1-1.5 0V5.75a.75.75 0 0 1 .75-.75Zm.75 7.5c0 1.822 1.155 3 2.25 3s2.25-1.178 2.25-3-1.155-3-2.25-3-2.25 1.178-2.25 3Zm-11 0C1.5 10.064 3.355 8 5.75 8A4.08 4.08 0 0 1 8.5 9.067V8.75a.75.75 0 0 1 1.5 0v7.5a.75.75 0 0 1-1.5 0v-.318A4.08 4.08 0 0 1 5.75 17c-2.395 0-4.25-2.064-4.25-4.5Zm7 0c0-1.706-1.28-3-2.75-3S3 10.794 3 12.5s1.28 3 2.75 3 2.75-1.294 2.75-3Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const MJ = { render: z9 }, AJ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: MJ,
  render: z9
}, Symbol.toStringTag, { value: "Module" })), LJ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function j9(e, t) {
  return f(), v("svg", LJ, [...t[0] || (t[0] = [
    g("g", { class: "format-paragraph-spacing" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M4.491 1.199a.75.75 0 0 1 1.018 0l3.25 3A.75.75 0 1 1 7.74 5.3L5.75 3.463v13.074l1.991-1.838A.75.75 0 1 1 8.76 15.8l-3.25 3a.75.75 0 0 1-1.018 0l-3.25-3a.75.75 0 1 1 1.018-1.1l1.991 1.838V3.463L2.259 5.301A.75.75 0 1 1 1.24 4.2l3.25-3ZM11 4.75a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75ZM11 10a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5A.75.75 0 0 1 11 10Zm0 5.25a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const EJ = { render: j9 }, PJ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: EJ,
  render: j9
}, Symbol.toStringTag, { value: "Module" })), RJ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function W9(e, t) {
  return f(), v("svg", RJ, [...t[0] || (t[0] = [
    g("g", { class: "format-scale-horizontal" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M5 2.75C5 1.784 5.784 1 6.75 1h6.5c.966 0 1.75.784 1.75 1.75v2a.75.75 0 0 1-1.5 0v-2a.25.25 0 0 0-.25-.25h-2.5v9h1.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5h1.5v-9h-2.5a.25.25 0 0 0-.25.25v2a.75.75 0 0 1-1.5 0v-2Zm-.752 10.44a.75.75 0 0 1 .063 1.058l-.89 1.002H16.58l-.89-1.002a.75.75 0 0 1 1.12-.996l2 2.25a.75.75 0 0 1 0 .996l-2 2.25a.75.75 0 0 1-1.12-.996l.89-1.002H3.42l.89 1.002a.75.75 0 0 1-1.12.996l-2-2.25a.75.75 0 0 1 0-.996l2-2.25a.75.75 0 0 1 1.058-.063Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const FJ = { render: W9 }, TJ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: FJ,
  render: W9
}, Symbol.toStringTag, { value: "Module" })), IJ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function U9(e, t) {
  return f(), v("svg", IJ, [...t[0] || (t[0] = [
    g("g", { class: "format-scale-vertical" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M3.502 1.19a.75.75 0 0 1 .996 0l2.25 2a.75.75 0 0 1-.996 1.12L4.75 3.42v13.16l1.002-.89a.75.75 0 0 1 .996 1.12l-2.25 2a.75.75 0 0 1-.996 0l-2.25-2a.75.75 0 0 1 .996-1.12l1.002.89V3.42l-1.002.89a.75.75 0 1 1-.996-1.12l2.25-2ZM9 5.75C9 4.784 9.783 4 10.75 4h6.5c.966 0 1.75.784 1.75 1.75v2a.75.75 0 0 1-1.5 0v-2a.25.25 0 0 0-.25-.25h-2.5v9h1.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5h1.5v-9h-2.5a.25.25 0 0 0-.25.25v2a.75.75 0 0 1-1.5 0v-2Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const DJ = { render: U9 }, kJ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: DJ,
  render: U9
}, Symbol.toStringTag, { value: "Module" })), HJ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 21"
};
function K9(e, t) {
  return f(), v("svg", HJ, [...t[0] || (t[0] = [
    g("g", { class: "format-small-caps" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M6.5 5c.317 0 .6.2.706.498L9.7 12.48l.012.033 1.244 3.484a.75.75 0 0 1-1.412.504L8.47 13.5H4.53l-1.073 3.002a.75.75 0 0 1-1.412-.504l1.244-3.484a.756.756 0 0 1 .012-.033l2.494-6.983A.75.75 0 0 1 6.5 5Zm-1.436 7h2.872L6.5 7.98 5.064 12Zm7.923-4h1.765c1.413 0 2.498 1.086 2.498 2.5 0 .535-.113 1.016-.348 1.413.205.14.383.31.534.507.413.543.564 1.22.564 1.83 0 .61-.15 1.287-.564 1.83-.436.571-1.109.92-1.972.92h-2.477c-.048 0-.135 0-.214-.009a.863.863 0 0 1-.522-.242.863.863 0 0 1-.242-.522 1.561 1.561 0 0 1-.009-.214V8.987c0-.048 0-.135.008-.214a.869.869 0 0 1 .243-.522.863.863 0 0 1 .522-.243C12.852 8 12.939 8 12.987 8Zm1.765 3.5c.385 0 .617-.097.746-.213.116-.105.252-.316.252-.787 0-.586-.415-1-.998-1H13.5v2h1.252ZM13.5 13h1.964c.422 0 .643.151.779.33.158.207.257.53.257.92s-.1.713-.257.92c-.136.179-.356.33-.78.33H13.5V13Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const VJ = { render: K9 }, OJ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: VJ,
  render: K9
}, Symbol.toStringTag, { value: "Module" })), BJ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function q9(e, t) {
  return f(), v("svg", BJ, [...t[0] || (t[0] = [
    g("g", { class: "format-strikethrough" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M3 1.75A.75.75 0 0 1 3.75 1h12.5a.75.75 0 0 1 0 1.5h-5.5v2.75a.75.75 0 0 1-1.5 0V2.5h-5.5A.75.75 0 0 1 3 1.75ZM2 10a.75.75 0 0 1 .75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 10Zm8 3a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0v-4.5A.75.75 0 0 1 10 13Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const $J = { render: q9 }, ZJ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: $J,
  render: q9
}, Symbol.toStringTag, { value: "Module" })), GJ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Y9(e, t) {
  return f(), v("svg", GJ, [...t[0] || (t[0] = [
    g("g", { class: "format-subscript" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M3 5.75C3 4.784 3.784 4 4.75 4h6.5c.966 0 1.75.784 1.75 1.75v2a.75.75 0 0 1-1.5 0v-2a.25.25 0 0 0-.25-.25h-2.5v9h1.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5h1.5v-9h-2.5a.25.25 0 0 0-.25.25v2a.75.75 0 0 1-1.5 0v-2Zm9.44 7.57c.36-.462.953-.82 1.81-.82.844 0 1.53.35 1.936.959.39.585.457 1.311.292 1.973-.112.445-.447.877-.743 1.208-.26.292-.567.587-.87.86h1.385a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.441-1.357l.006-.004.02-.015.084-.062a22.201 22.201 0 0 0 1.245-1.003c.348-.303.69-.623.952-.918.132-.147.235-.278.307-.388a1.208 1.208 0 0 0 .095-.172l.004-.013c.085-.338.027-.612-.084-.777-.093-.14-.282-.291-.688-.291-.393 0-.55.142-.627.242a.662.662 0 0 0-.103.194c-.017.05-.02.08-.02.08A.75.75 0 0 1 12 14.5c0-.282.113-.76.44-1.18Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const NJ = { render: Y9 }, zJ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: NJ,
  render: Y9
}, Symbol.toStringTag, { value: "Module" })), jJ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Q9(e, t) {
  return f(), v("svg", jJ, [...t[0] || (t[0] = [
    g("g", { class: "format-superscript" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M14.44 1.82c.36-.462.953-.82 1.81-.82.843 0 1.53.35 1.936.959.39.585.457 1.311.292 1.973-.112.445-.447.877-.743 1.208-.26.292-.567.587-.87.86h1.385a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.441-1.356v-.001l.006-.004.02-.015.084-.062a22.647 22.647 0 0 0 1.245-1.003c.348-.303.69-.623.952-.918a3.49 3.49 0 0 0 .307-.388 1.204 1.204 0 0 0 .095-.172l.004-.013c.085-.338.027-.612-.083-.777-.094-.14-.282-.291-.689-.291-.393 0-.55.142-.627.242a.662.662 0 0 0-.103.194c-.017.05-.02.08-.02.08A.75.75 0 0 1 14 3c0-.282.113-.76.44-1.18ZM3 5.75C3 4.784 3.784 4 4.75 4h6.5c.966 0 1.75.784 1.75 1.75v2a.75.75 0 0 1-1.5 0v-2a.25.25 0 0 0-.25-.25h-2.5v9h1.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5h1.5v-9h-2.5a.25.25 0 0 0-.25.25v2a.75.75 0 0 1-1.5 0v-2Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const WJ = { render: Q9 }, UJ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: WJ,
  render: Q9
}, Symbol.toStringTag, { value: "Module" })), KJ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 21"
};
function J9(e, t) {
  return f(), v("svg", KJ, [...t[0] || (t[0] = [
    g("g", { class: "format-titlecase" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M5.5 5c.317 0 .6.2.706.498L8.7 12.48l.012.033 1.244 3.484a.75.75 0 0 1-1.412.504L7.47 13.5H3.53l-1.073 3.002a.75.75 0 0 1-1.412-.504l1.244-3.484a.77.77 0 0 1 .012-.033l2.494-6.983A.75.75 0 0 1 5.5 5Zm-1.436 7h2.872L5.5 7.98 4.064 12Zm8.186-7a.75.75 0 0 1 .75.75v3.14c.609-.552 1.376-.89 2.25-.89C17.469 8 19 10.18 19 12.5S17.469 17 15.25 17c-.874 0-1.641-.338-2.25-.89v.14a.75.75 0 0 1-1.5 0V5.75a.75.75 0 0 1 .75-.75Zm.75 7.5c0 1.822 1.155 3 2.25 3s2.25-1.178 2.25-3-1.155-3-2.25-3-2.25 1.178-2.25 3Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const qJ = { render: J9 }, YJ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: qJ,
  render: J9
}, Symbol.toStringTag, { value: "Module" })), QJ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function X9(e, t) {
  return f(), v("svg", QJ, [...t[0] || (t[0] = [
    g("g", { class: "format-underline" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M4.75 1a.75.75 0 0 1 .75.75V11a4.5 4.5 0 1 0 9 0V1.75a.75.75 0 0 1 1.5 0V11a6 6 0 0 1-12 0V1.75A.75.75 0 0 1 4.75 1ZM3 19.25a.75.75 0 0 1 .75-.75h12.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const JJ = { render: X9 }, XJ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: JJ,
  render: X9
}, Symbol.toStringTag, { value: "Module" })), eX = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 21"
};
function ef(e, t) {
  return f(), v("svg", eX, [...t[0] || (t[0] = [
    g("g", { class: "format-uppercase" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M5.5 5c.317 0 .6.2.706.498L8.7 12.48l.012.033 1.244 3.484a.75.75 0 0 1-1.412.504L7.47 13.5H3.53l-1.073 3.002a.75.75 0 0 1-1.412-.504l1.244-3.484a.77.77 0 0 1 .012-.033l2.494-6.983A.75.75 0 0 1 5.5 5Zm-1.436 7h2.872L5.5 7.98 4.064 12Zm7.312-6.624A1.25 1.25 0 0 1 12.25 5h2.523C16.738 5 18 6.664 18 8.375c0 .872-.244 1.654-.727 2.252A3.299 3.299 0 0 1 19 13.5c0 1.822-1.25 3.5-3.273 3.5H12.25a1.25 1.25 0 0 1-.874-.376A1.25 1.25 0 0 1 11 15.75v-9.5c0-.369.177-.675.376-.874Zm3.397 4.874c.564 0 .977-.187 1.251-.472.276-.288.476-.745.476-1.403 0-1.04-.739-1.875-1.727-1.875H12.5v3.75h2.273Zm-2.273 1.5h3.227A1.76 1.76 0 0 1 17.5 13.5c0 1.178-.75 2-1.773 2H12.5v-3.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const tX = { render: ef }, oX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: tX,
  render: ef
}, Symbol.toStringTag, { value: "Module" })), nX = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function tf(e, t) {
  return f(), v("svg", nX, [...t[0] || (t[0] = [
    g("g", { class: "forward" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M9.64 4.093a.75.75 0 0 1 .763.024l8.25 5.25a.75.75 0 0 1 0 1.266l-8.25 5.25a.75.75 0 0 1-1.153-.633v-3.884l-7.097 4.517A.75.75 0 0 1 1 15.25V4.75a.75.75 0 0 1 1.153-.633L9.25 8.634V4.75a.75.75 0 0 1 .39-.657Zm1.11 9.79L16.853 10 10.75 6.116v7.768ZM8.603 10 2.5 6.116v7.768L8.603 10Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const sX = { render: tf }, iX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sX,
  render: tf
}, Symbol.toStringTag, { value: "Module" })), rX = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function of(e, t) {
  return f(), v("svg", rX, [...t[0] || (t[0] = [
    g("g", { class: "fullscreen-exit" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M6.25 1a.75.75 0 0 1 .75.75v2.5A2.75 2.75 0 0 1 4.25 7h-2.5a.75.75 0 0 1 0-1.5h2.5c.69 0 1.25-.56 1.25-1.25v-2.5A.75.75 0 0 1 6.25 1Zm7.5 0a.75.75 0 0 1 .75.75v2.5c0 .69.56 1.25 1.25 1.25h2.5a.75.75 0 0 1 0 1.5h-2.5A2.75 2.75 0 0 1 13 4.25v-2.5a.75.75 0 0 1 .75-.75ZM1 13.75a.75.75 0 0 1 .75-.75h2.5A2.75 2.75 0 0 1 7 15.75v2.5a.75.75 0 0 1-1.5 0v-2.5c0-.69-.56-1.25-1.25-1.25h-2.5a.75.75 0 0 1-.75-.75Zm12 2A2.75 2.75 0 0 1 15.75 13h2.5a.75.75 0 0 1 0 1.5h-2.5c-.69 0-1.25.56-1.25 1.25v2.5a.75.75 0 0 1-1.5 0v-2.5Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const lX = { render: of }, aX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: lX,
  render: of
}, Symbol.toStringTag, { value: "Module" })), cX = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function nf(e, t) {
  return f(), v("svg", cX, [...t[0] || (t[0] = [
    g("g", { class: "fullscreen" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M3.75 2.5c-.69 0-1.25.56-1.25 1.25v2.5a.75.75 0 0 1-1.5 0v-2.5A2.75 2.75 0 0 1 3.75 1h2.5a.75.75 0 0 1 0 1.5h-2.5ZM13 1.75a.75.75 0 0 1 .75-.75h2.5A2.75 2.75 0 0 1 19 3.75v2.5a.75.75 0 0 1-1.5 0v-2.5c0-.69-.56-1.25-1.25-1.25h-2.5a.75.75 0 0 1-.75-.75ZM1.75 13a.75.75 0 0 1 .75.75v2.5c0 .69.56 1.25 1.25 1.25h2.5a.75.75 0 0 1 0 1.5h-2.5A2.75 2.75 0 0 1 1 16.25v-2.5a.75.75 0 0 1 .75-.75Zm16.5 0a.75.75 0 0 1 .75.75v2.5A2.75 2.75 0 0 1 16.25 19h-2.5a.75.75 0 0 1 0-1.5h2.5c.69 0 1.25-.56 1.25-1.25v-2.5a.75.75 0 0 1 .75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const dX = { render: nf }, uX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: dX,
  render: nf
}, Symbol.toStringTag, { value: "Module" })), hX = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function sf(e, t) {
  return f(), v("svg", hX, [...t[0] || (t[0] = [
    g("g", { class: "function" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M9.482 3.663c.108-.423.26-.723.428-.907a.74.74 0 0 1 .59-.256 1 1 0 0 1 1 1 .75.75 0 0 0 1.5 0A2.5 2.5 0 0 0 10.5 1c-.705 0-1.277.284-1.697.744-.4.438-.639 1.007-.78 1.574a.758.758 0 0 0-.01.04L6.93 9H4.5a.75.75 0 0 0 0 1.5h2.14l-1.122 5.837c-.108.423-.26.723-.428.907a.74.74 0 0 1-.59.256 1 1 0 0 1-1-1 .75.75 0 0 0-1.5 0A2.5 2.5 0 0 0 4.5 19c.705 0 1.277-.284 1.697-.744.4-.438.639-1.007.78-1.574a.751.751 0 0 0 .01-.04l1.18-6.142h3.12a.25.25 0 0 1 .19.089L13.517 13l-2.34 2.766a.75.75 0 1 0 1.146.969L14.5 14.16l2.177 2.574a.75.75 0 0 0 1.146-.97L15.483 13l2.34-2.765a.75.75 0 1 0-1.146-.97L14.5 11.84l-1.878-2.22A1.75 1.75 0 0 0 11.286 9h-2.83l1.026-5.337Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const gX = { render: sf }, pX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: gX,
  render: sf
}, Symbol.toStringTag, { value: "Module" })), fX = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function rf(e, t) {
  return f(), v("svg", fX, [...t[0] || (t[0] = [
    g("g", { class: "git-branch" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M5 2.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM2 4a3 3 0 1 1 3.744 2.907c.004.03.006.061.006.093v3.55c.375-.192.8-.3 1.25-.3h6c.69 0 1.25-.56 1.25-1.25 0-.032.002-.063.006-.093A3.001 3.001 0 0 1 15 3a3 3 0 0 1 .744 5.907c.004.03.006.061.006.093A2.75 2.75 0 0 1 13 11.75H7c-.69 0-1.25.56-1.25 1.25a.757.757 0 0 1-.006.093 3.001 3.001 0 1 1-1.488 0A.756.756 0 0 1 4.25 13V7c0-.032.002-.063.006-.093A3.001 3.001 0 0 1 2 4Zm13 .5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm-10 10a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const vX = { render: rf }, mX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: vX,
  render: rf
}, Symbol.toStringTag, { value: "Module" })), CX = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function lf(e, t) {
  return f(), v("svg", CX, [...t[0] || (t[0] = [
    g("g", { class: "git-commit" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10 7a3 3 0 1 0 0 6 3 3 0 0 0 0-6ZM5.562 9.25a4.501 4.501 0 0 1 8.876 0h2.812a.75.75 0 0 1 0 1.5h-2.812a4.501 4.501 0 0 1-8.876 0H2.75a.75.75 0 0 1 0-1.5h2.812Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const wX = { render: lf }, bX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: wX,
  render: lf
}, Symbol.toStringTag, { value: "Module" })), yX = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function af(e, t) {
  return f(), v("svg", yX, [...t[0] || (t[0] = [
    g("g", { class: "git-diff" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M4 2.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM1 4a3 3 0 1 1 3.744 2.907c.004.03.006.061.006.093v5.8c0 .572 0 .957.025 1.252.023.288.065.425.111.516.12.235.311.426.547.546.09.046.227.088.514.111.28.023.64.025 1.165.025l-.83-.664a.75.75 0 0 1 .937-1.172l2.5 2a.75.75 0 0 1 0 1.172l-2.5 2a.75.75 0 0 1-.938-1.172l.83-.664c-.508 0-.935-.001-1.286-.03-.38-.03-.736-.098-1.073-.27a2.75 2.75 0 0 1-1.202-1.2c-.172-.338-.24-.694-.27-1.074-.03-.365-.03-.81-.03-1.345V7c0-.032.002-.063.006-.093A3.001 3.001 0 0 1 1 4Zm11.836-2.469a.75.75 0 0 1-.117 1.055l-.83.664h.941c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27a2.75 2.75 0 0 1 1.202 1.202c.172.337.24.693.27 1.073.03.365.03.81.03 1.345V13a.753.753 0 0 1-.006.093 3.001 3.001 0 1 1-1.488 0A.75.75 0 0 1 15.25 13V7.2c0-.572 0-.957-.025-1.253-.023-.287-.065-.424-.111-.514a1.25 1.25 0 0 0-.546-.547c-.091-.046-.228-.088-.515-.111-.296-.024-.68-.025-1.253-.025h-.912l.83.664a.75.75 0 1 1-.937 1.172l-2.5-2a.75.75 0 0 1 0-1.172l2.5-2a.75.75 0 0 1 1.055.117ZM16 14.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const _X = { render: af }, SX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _X,
  render: af
}, Symbol.toStringTag, { value: "Module" })), xX = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function cf(e, t) {
  return f(), v("svg", xX, [...t[0] || (t[0] = [
    g("g", { class: "git-fork" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M4 2.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM1 4a3 3 0 1 1 3.753 2.905c.002.15.007.276.014.388.017.241.046.358.078.435.127.307.37.55.677.677.077.032.194.061.435.078.247.017.567.017 1.043.017h6c.476 0 .796 0 1.043-.017.241-.017.358-.046.435-.078.307-.127.55-.37.677-.677.032-.077.061-.194.078-.435.007-.112.012-.239.014-.388A3.001 3.001 0 0 1 16 1a3 3 0 0 1 .747 5.906c-.003.18-.008.342-.018.49a2.822 2.822 0 0 1-.188.906 2.75 2.75 0 0 1-1.489 1.489c-.29.12-.59.167-.907.188-.304.021-.675.021-1.12.021H10.75v3.095A3.001 3.001 0 0 1 10 19a3 3 0 0 1-.75-5.905V10H6.975c-.445 0-.816 0-1.12-.02a2.823 2.823 0 0 1-.907-.19 2.75 2.75 0 0 1-1.489-1.488c-.12-.29-.167-.59-.188-.907a9.33 9.33 0 0 1-.018-.489A3.001 3.001 0 0 1 1 4Zm15-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm-6 12a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const MX = { render: cf }, AX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: MX,
  render: cf
}, Symbol.toStringTag, { value: "Module" })), LX = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function df(e, t) {
  return f(), v("svg", LX, [...t[0] || (t[0] = [
    g("g", { class: "git-merge" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M4 2.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM1 4a3 3 0 1 1 3.744 2.907c.004.03.006.061.006.093v2.55c.375-.192.8-.3 1.25-.3h7.095a3.001 3.001 0 1 1 0 1.5H6c-.69 0-1.25.56-1.25 1.25v1a.757.757 0 0 1-.006.093 3.001 3.001 0 1 1-1.488 0A.756.756 0 0 1 3.25 13V7c0-.032.002-.063.006-.093A3.001 3.001 0 0 1 1 4Zm15 4.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm-12 6a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const EX = { render: df }, PX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: EX,
  render: df
}, Symbol.toStringTag, { value: "Module" })), RX = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function uf(e, t) {
  return f(), v("svg", RX, [...t[0] || (t[0] = [
    g("g", { class: "git-pull-request" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M4 2.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM1 4a3 3 0 1 1 3.744 2.907c.004.03.006.061.006.093v6.095a3.001 3.001 0 1 1-1.5 0V7c0-.032.002-.063.006-.093A3.001 3.001 0 0 1 1 4Zm11.836-2.469a.75.75 0 0 1-.117 1.055l-.83.664h.941c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27a2.75 2.75 0 0 1 1.202 1.202c.172.337.24.693.27 1.073.03.365.03.81.03 1.345V13a.753.753 0 0 1-.006.093 3.001 3.001 0 1 1-1.488 0A.75.75 0 0 1 15.25 13V7.2c0-.572 0-.957-.025-1.253-.023-.287-.065-.424-.111-.514a1.25 1.25 0 0 0-.546-.547c-.091-.046-.228-.088-.515-.111-.296-.024-.68-.025-1.253-.025h-.912l.83.664a.75.75 0 1 1-.937 1.172l-2.5-2a.75.75 0 0 1 0-1.172l2.5-2a.75.75 0 0 1 1.055.117ZM4 14.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm12 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const FX = { render: uf }, TX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: FX,
  render: uf
}, Symbol.toStringTag, { value: "Module" })), IX = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function hf(e, t) {
  return f(), v("svg", IX, [...t[0] || (t[0] = [
    g("g", { class: "globe" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M2.537 9.25h3.476c.07-2.056.428-3.93.991-5.359a8.41 8.41 0 0 1 .437-.943A7.507 7.507 0 0 0 2.537 9.25ZM10 1a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm0 1.5c-.172 0-.414.085-.716.41-.303.325-.61.836-.884 1.531-.483 1.227-.816 2.907-.886 4.809h4.972c-.07-1.902-.403-3.582-.886-4.809-.274-.695-.58-1.206-.884-1.532-.302-.324-.544-.409-.716-.409Zm3.987 6.75c-.07-2.056-.428-3.93-.991-5.359a8.4 8.4 0 0 0-.437-.943 7.507 7.507 0 0 1 4.904 6.302h-3.476Zm-1.5 1.5H7.513c.07 1.902.403 3.582.886 4.809.273.695.58 1.206.884 1.531.302.325.544.41.716.41.172 0 .414-.085.716-.41.303-.325.61-.836.884-1.531.483-1.227.816-2.907.886-4.809Zm.072 6.302c.16-.292.305-.609.437-.944.563-1.428.92-3.302.991-5.358h3.476a7.507 7.507 0 0 1-4.904 6.302Zm-5.118 0a8.404 8.404 0 0 1-.437-.944c-.563-1.428-.92-3.302-.991-5.358H2.537a7.507 7.507 0 0 0 4.904 6.302Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const DX = { render: hf }, kX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: DX,
  render: hf
}, Symbol.toStringTag, { value: "Module" })), HX = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function gf(e, t) {
  return f(), v("svg", HX, [...t[0] || (t[0] = [
    g("g", { class: "hashtag" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M9.452 3.028a.75.75 0 0 1 .52.924L9.26 6.5h3.44l.827-2.952a.75.75 0 0 1 1.444.404L14.26 6.5h2.991a.75.75 0 0 1 0 1.5H13.84l-1.12 4h2.531a.75.75 0 0 1 0 1.5H12.3l-.827 2.952a.75.75 0 1 1-1.444-.404l.713-2.548H7.3l-.827 2.952a.75.75 0 1 1-1.444-.404L5.74 13.5H2.75a.75.75 0 0 1 0-1.5h3.411l1.12-4H4.75a.75.75 0 0 1 0-1.5h2.951l.827-2.952a.75.75 0 0 1 .924-.52ZM8.84 8l-1.12 4h3.442l1.12-4H8.84Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const VX = { render: gf }, OX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: VX,
  render: gf
}, Symbol.toStringTag, { value: "Module" })), BX = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function pf(e, t) {
  return f(), v("svg", BX, [...t[0] || (t[0] = [
    g("g", { class: "heading" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M3 1.75A.75.75 0 0 1 3.75 1h4a.75.75 0 0 1 0 1.5H6.5v6.75H14V2.5h-1.25a.75.75 0 0 1 0-1.5h4a.75.75 0 0 1 0 1.5H15.5v15h1.25a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1 0-1.5H14v-6.75H6.5v6.75h1.25a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1 0-1.5H5v-15H3.75A.75.75 0 0 1 3 1.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const $X = { render: pf }, ZX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: $X,
  render: pf
}, Symbol.toStringTag, { value: "Module" })), GX = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function ff(e, t) {
  return f(), v("svg", GX, [...t[0] || (t[0] = [
    g("g", { class: "headphones" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10 2.5A6.5 6.5 0 0 0 3.5 9v2h.58c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 7.7 12.5c.172.338.24.694.27 1.074.03.365.03.81.03 1.345v1.117c0 .196 0 .347-.013.483a2.75 2.75 0 0 1-2.467 2.467 5.123 5.123 0 0 1-.483.013h-.074c-.196 0-.347 0-.483-.013a2.75 2.75 0 0 1-2.467-2.467C2 16.384 2 16.233 2 16.037V9a8 8 0 1 1 16 0v7.037c0 .196 0 .347-.013.483a2.75 2.75 0 0 1-2.467 2.467 5.122 5.122 0 0 1-.483.013h-.074c-.196 0-.347 0-.483-.013a2.75 2.75 0 0 1-2.467-2.467 5.122 5.122 0 0 1-.013-.483V14.92c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073a2.751 2.751 0 0 1 1.2-1.202c.338-.172.694-.24 1.074-.27.365-.03.81-.03 1.345-.03h.58V9A6.5 6.5 0 0 0 10 2.5Zm6.5 10h-.55c-.572 0-.957 0-1.252.025-.288.023-.425.065-.516.111a1.25 1.25 0 0 0-.546.546c-.046.091-.088.228-.111.515-.024.296-.025.68-.025 1.253V16c0 .25 0 .32.006.372a1.25 1.25 0 0 0 1.121 1.122c.052.005.123.006.373.006s.32 0 .373-.006a1.25 1.25 0 0 0 1.121-1.122A4.72 4.72 0 0 0 16.5 16v-3.5Zm-13 0V16c0 .25 0 .32.006.372a1.25 1.25 0 0 0 1.121 1.122c.052.005.123.006.373.006s.32 0 .373-.006a1.25 1.25 0 0 0 1.121-1.122A4.72 4.72 0 0 0 6.5 16v-1.05c0-.572 0-.957-.025-1.252-.023-.288-.065-.425-.111-.516a1.25 1.25 0 0 0-.547-.546c-.09-.046-.227-.088-.514-.111-.296-.024-.68-.025-1.253-.025H3.5Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const NX = { render: ff }, zX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: NX,
  render: ff
}, Symbol.toStringTag, { value: "Module" })), jX = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function vf(e, t) {
  return f(), v("svg", jX, [...t[0] || (t[0] = [
    g("g", { class: "health" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M7 2.75C7 1.784 7.784 1 8.75 1h2.5c.966 0 1.75.784 1.75 1.75V7h4.25c.966 0 1.75.784 1.75 1.75v2.5A1.75 1.75 0 0 1 17.25 13H13v4.25A1.75 1.75 0 0 1 11.25 19h-2.5A1.75 1.75 0 0 1 7 17.25V13H2.75A1.75 1.75 0 0 1 1 11.25v-2.5C1 7.784 1.784 7 2.75 7H7V2.75Zm1.75-.25a.25.25 0 0 0-.25.25v5a.75.75 0 0 1-.75.75h-5a.25.25 0 0 0-.25.25v2.5c0 .138.112.25.25.25h5a.75.75 0 0 1 .75.75v5c0 .138.112.25.25.25h2.5a.25.25 0 0 0 .25-.25v-5a.75.75 0 0 1 .75-.75h5a.25.25 0 0 0 .25-.25v-2.5a.25.25 0 0 0-.25-.25h-5a.75.75 0 0 1-.75-.75v-5a.25.25 0 0 0-.25-.25h-2.5Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const WX = { render: vf }, UX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: WX,
  render: vf
}, Symbol.toStringTag, { value: "Module" })), KX = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function mf(e, t) {
  return f(), v("svg", KX, [...t[0] || (t[0] = [
    g("g", { class: "heart" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M13.511 3.525c-.977.123-2.029.731-2.873 2.098a.75.75 0 0 1-1.276 0c-.844-1.367-1.896-1.975-2.873-2.098-.99-.125-2.006.23-2.804.993-1.58 1.522-1.58 4.088 0 5.61L10 16.208l6.314-6.08c1.58-1.522 1.581-4.088.001-5.61-.798-.762-1.815-1.118-2.804-.993Zm-.188-1.488c1.484-.188 2.94.357 4.03 1.397l.002.002c2.193 2.113 2.193 5.66 0 7.773L10.52 17.79a.75.75 0 0 1-1.04 0l-6.835-6.58c-2.193-2.113-2.193-5.66 0-7.773l.002-.002c1.09-1.04 2.546-1.585 4.03-1.397 1.21.153 2.371.783 3.323 1.912.952-1.129 2.113-1.76 3.323-1.912Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const qX = { render: mf }, YX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: qX,
  render: mf
}, Symbol.toStringTag, { value: "Module" })), QX = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Cf(e, t) {
  return f(), v("svg", QX, [...t[0] || (t[0] = [
    g("g", { class: "help-fill" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10 1a9 9 0 1 0 0 18 9 9 0 0 0 0-18ZM8.5 8A1.5 1.5 0 1 1 10 9.5a.75.75 0 0 0-.75.75v1a.75.75 0 0 0 1.5 0v-.345A3.001 3.001 0 0 0 10 5a3 3 0 0 0-3 3 .75.75 0 0 0 1.5 0Zm2.25 5.75a.75.75 0 0 0-1.5 0v.5a.75.75 0 0 0 1.5 0v-.5Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const JX = { render: Cf }, XX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: JX,
  render: Cf
}, Symbol.toStringTag, { value: "Module" })), eee = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function wf(e, t) {
  return f(), v("svg", eee, [...t[0] || (t[0] = [
    g("g", { class: "help" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10 2.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15ZM1 10a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm9-3.5A1.5 1.5 0 0 0 8.5 8 .75.75 0 0 1 7 8a3 3 0 1 1 3.75 2.905v.345a.75.75 0 0 1-1.5 0v-1A.75.75 0 0 1 10 9.5a1.5 1.5 0 0 0 0-3Zm0 6.5a.75.75 0 0 1 .75.75v.5a.75.75 0 0 1-1.5 0v-.5A.75.75 0 0 1 10 13Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const tee = { render: wf }, oee = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: tee,
  render: wf
}, Symbol.toStringTag, { value: "Module" })), nee = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function bf(e, t) {
  return f(), v("svg", nee, [...t[0] || (t[0] = [
    g("g", { class: "home" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M9.574 1.133a.75.75 0 0 1 .852 0l6.385 4.403A2.75 2.75 0 0 1 18 7.8v8.45A2.75 2.75 0 0 1 15.25 19H4.75A2.75 2.75 0 0 1 2 16.25V7.8c0-.904.444-1.75 1.189-2.264l6.385-4.403ZM8.5 17.5h3v-4.75a.25.25 0 0 0-.25-.25h-2.5a.25.25 0 0 0-.25.25v4.75Zm4.5 0v-4.75A1.75 1.75 0 0 0 11.25 11h-2.5A1.75 1.75 0 0 0 7 12.75v4.75H4.75c-.69 0-1.25-.56-1.25-1.25V7.8c0-.41.202-.795.54-1.029L10 2.661l5.96 4.11c.338.234.54.618.54 1.03v8.449c0 .69-.56 1.25-1.25 1.25H13Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const see = { render: bf }, iee = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: see,
  render: bf
}, Symbol.toStringTag, { value: "Module" })), ree = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function yf(e, t) {
  return f(), v("svg", ree, [...t[0] || (t[0] = [
    g("g", { class: "horizontal-align-center" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M19 10a.75.75 0 0 1-.75.75h-3.787l1.838 1.991A.75.75 0 1 1 15.2 13.76l-3-3.25a.75.75 0 0 1 0-1.018l3-3.25a.75.75 0 1 1 1.1 1.018l-1.837 1.99h3.787A.75.75 0 0 1 19 10Zm-9-9a.75.75 0 0 1 .75.75v16.5a.75.75 0 0 1-1.5 0V1.75A.75.75 0 0 1 10 1ZM4.801 6.241l3 3.25a.75.75 0 0 1 0 1.018l-3 3.25A.75.75 0 1 1 3.7 12.74l1.838-1.991H1.75a.75.75 0 0 1 0-1.5h3.787l-1.838-1.99A.75.75 0 1 1 4.8 6.24Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const lee = { render: yf }, aee = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: lee,
  render: yf
}, Symbol.toStringTag, { value: "Module" })), cee = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function _f(e, t) {
  return f(), v("svg", cee, [...t[0] || (t[0] = [
    g("g", { class: "horizontal-align-left" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M1.75 1a.75.75 0 0 1 .75.75v16.5a.75.75 0 0 1-1.5 0V1.75A.75.75 0 0 1 1.75 1Zm7.514 4.204a.75.75 0 0 1 .032 1.06L6.486 9.25H18.25a.75.75 0 0 1 0 1.5H6.486l2.81 2.986a.75.75 0 1 1-1.092 1.028l-4-4.25a.75.75 0 0 1 0-1.028l4-4.25a.75.75 0 0 1 1.06-.032Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const dee = { render: _f }, uee = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: dee,
  render: _f
}, Symbol.toStringTag, { value: "Module" })), hee = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Sf(e, t) {
  return f(), v("svg", hee, [...t[0] || (t[0] = [
    g("g", { class: "horizontal-align-right" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M18.25 1a.75.75 0 0 1 .75.75v16.5a.75.75 0 0 1-1.5 0V1.75a.75.75 0 0 1 .75-.75Zm-7.514 4.204a.75.75 0 0 1 1.06.032l4 4.25a.75.75 0 0 1 0 1.028l-4 4.25a.75.75 0 0 1-1.092-1.028l2.81-2.986H1.75a.75.75 0 0 1 0-1.5h11.764l-2.81-2.986a.75.75 0 0 1 .032-1.06Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const gee = { render: Sf }, pee = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: gee,
  render: Sf
}, Symbol.toStringTag, { value: "Module" })), fee = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function xf(e, t) {
  return f(), v("svg", fee, [...t[0] || (t[0] = [
    g("g", { class: "hourglass" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M3 1.75A.75.75 0 0 1 3.75 1h12.5a.75.75 0 0 1 0 1.5H15v1.719c0 .478-.125.949-.362 1.364l-2.17 3.797a1.25 1.25 0 0 0 0 1.24l2.17 3.797c.237.415.362.886.362 1.364V17.5h1.25a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1 0-1.5H5v-1.719c0-.478.125-.949.362-1.364l2.17-3.797a1.25 1.25 0 0 0 0-1.24l-2.17-3.797A2.75 2.75 0 0 1 5 4.22V2.5H3.75A.75.75 0 0 1 3 1.75Zm3.5.75v1.719c0 .217.057.431.165.62l2.17 3.797a2.75 2.75 0 0 1 0 2.728l-2.17 3.797a1.25 1.25 0 0 0-.165.62V17.5h7v-1.719a1.25 1.25 0 0 0-.165-.62l-2.17-3.797a2.75 2.75 0 0 1 0-2.728l2.17-3.797a1.25 1.25 0 0 0 .165-.62V2.5h-7Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const vee = { render: xf }, mee = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: vee,
  render: xf
}, Symbol.toStringTag, { value: "Module" })), Cee = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Mf(e, t) {
  return f(), v("svg", Cee, [...t[0] || (t[0] = [
    g("g", {
      class: "image-check",
      "clip-path": "url(#a)"
    }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M19.765.205a.75.75 0 0 1 .03 1.06l-4.25 4.5a.75.75 0 0 1-1.102-.013l-2.25-2.5a.75.75 0 1 1 1.114-1.004l1.706 1.896L18.705.235a.75.75 0 0 1 1.06-.03ZM1 3.75A2.75 2.75 0 0 1 3.75 1h5.5a.75.75 0 0 1 0 1.5h-5.5c-.69 0-1.25.56-1.25 1.25v7.242l4.023-3.32a.75.75 0 0 1 1.018.058l3.08 3.204 3.463-2.308a.75.75 0 0 1 .928.076l3.75 3.5a.75.75 0 0 1 .238.548v3.5A2.75 2.75 0 0 1 16.25 19H3.75A2.75 2.75 0 0 1 1 16.25V3.75Zm10.678 8.283 2.113 2.197a.75.75 0 1 1-1.082 1.04l-5.768-6L2.5 12.937v3.313c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25v-3.174l-3.078-2.873-2.744 1.83Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1),
    g("defs", null, [
      g("clipPath", {
        id: "a",
        class: "a"
      }, [
        g("path", { d: "M0 0h20v20H0z" })
      ])
    ], -1)
  ])]);
}
const wee = { render: Mf }, bee = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: wee,
  render: Mf
}, Symbol.toStringTag, { value: "Module" })), yee = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Af(e, t) {
  return f(), v("svg", yee, [...t[0] || (t[0] = [
    g("g", { class: "image-close" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M13.22.22a.75.75 0 0 1 1.06 0L16 1.94 17.72.22a.75.75 0 1 1 1.06 1.06L17.06 3l1.72 1.72a.75.75 0 0 1-1.06 1.06L16 4.06l-1.72 1.72a.75.75 0 1 1-1.06-1.06L14.94 3l-1.72-1.72a.75.75 0 0 1 0-1.06ZM1 3.75A2.75 2.75 0 0 1 3.75 1h5.5a.75.75 0 0 1 0 1.5h-5.5c-.69 0-1.25.56-1.25 1.25v7.242l4.023-3.32a.75.75 0 0 1 1.018.058l3.08 3.204 3.463-2.308a.75.75 0 0 1 .928.076l3.75 3.5a.75.75 0 0 1 .238.548v3.5A2.75 2.75 0 0 1 16.25 19H3.75A2.75 2.75 0 0 1 1 16.25V3.75Zm10.678 8.283 2.113 2.197a.75.75 0 1 1-1.082 1.04l-5.768-6L2.5 12.937v3.313c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25v-3.174l-3.078-2.873-2.744 1.83Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const _ee = { render: Af }, See = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _ee,
  render: Af
}, Symbol.toStringTag, { value: "Module" })), xee = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Lf(e, t) {
  return f(), v("svg", xee, [...t[0] || (t[0] = [
    g("g", {
      class: "image-edit",
      "clip-path": "url(#a)"
    }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M18.286 1.714a.73.73 0 0 0-1.033 0L13.5 5.467V6.5h1.033l3.753-3.753a.73.73 0 0 0 0-1.033ZM16.192.654a2.23 2.23 0 1 1 3.155 3.154L15.374 7.78a.75.75 0 0 1-.53.22H12.75a.75.75 0 0 1-.75-.75V5.156a.75.75 0 0 1 .22-.53L16.192.653ZM1 3.75A2.75 2.75 0 0 1 3.75 1h5.5a.75.75 0 0 1 0 1.5h-5.5c-.69 0-1.25.56-1.25 1.25v7.242l4.023-3.32a.75.75 0 0 1 1.018.058l3.08 3.204 3.463-2.308a.75.75 0 0 1 .928.076l3.75 3.5a.75.75 0 0 1 .238.548v3.5A2.75 2.75 0 0 1 16.25 19H3.75A2.75 2.75 0 0 1 1 16.25V3.75Zm10.678 8.283 2.113 2.197a.75.75 0 1 1-1.082 1.04l-5.768-6L2.5 12.937v3.313c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25v-3.174l-3.078-2.873-2.744 1.83Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1),
    g("defs", null, [
      g("clipPath", {
        id: "a",
        class: "a"
      }, [
        g("path", { d: "M0 0h20v20H0z" })
      ])
    ], -1)
  ])]);
}
const Mee = { render: Lf }, Aee = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Mee,
  render: Lf
}, Symbol.toStringTag, { value: "Module" })), Lee = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Ef(e, t) {
  return f(), v("svg", Lee, [...t[0] || (t[0] = [
    g("g", { class: "image-minus" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M1 3.75A2.75 2.75 0 0 1 3.75 1h5.5a.75.75 0 0 1 0 1.5h-5.5c-.69 0-1.25.56-1.25 1.25v7.242l4.023-3.32a.75.75 0 0 1 1.018.058l3.08 3.204 3.463-2.308a.75.75 0 0 1 .928.076l3.75 3.5a.75.75 0 0 1 .238.548v3.5A2.75 2.75 0 0 1 16.25 19H3.75A2.75 2.75 0 0 1 1 16.25V3.75Zm10.678 8.283 2.113 2.197a.75.75 0 1 1-1.082 1.04l-5.768-6L2.5 12.937v3.313c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25v-3.174l-3.078-2.873-2.744 1.83ZM12 3.75a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Eee = { render: Ef }, Pee = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Eee,
  render: Ef
}, Symbol.toStringTag, { value: "Module" })), Ree = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Pf(e, t) {
  return f(), v("svg", Ree, [...t[0] || (t[0] = [
    g("g", { class: "image-plus" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M16 0a.75.75 0 0 1 .75.75v2.5h2.5a.75.75 0 0 1 0 1.5h-2.5v2.5a.75.75 0 0 1-1.5 0v-2.5h-2.5a.75.75 0 0 1 0-1.5h2.5V.75A.75.75 0 0 1 16 0ZM1 3.75A2.75 2.75 0 0 1 3.75 1h5.5a.75.75 0 0 1 0 1.5h-5.5c-.69 0-1.25.56-1.25 1.25v7.242l4.023-3.32a.75.75 0 0 1 1.018.058l3.08 3.204 3.463-2.308a.75.75 0 0 1 .928.076l3.75 3.5a.75.75 0 0 1 .238.548v3.5A2.75 2.75 0 0 1 16.25 19H3.75A2.75 2.75 0 0 1 1 16.25V3.75Zm10.678 8.283 2.113 2.197a.75.75 0 1 1-1.082 1.04l-5.768-6L2.5 12.937v3.313c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25v-3.174l-3.078-2.873-2.744 1.83Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Fee = { render: Pf }, Tee = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Fee,
  render: Pf
}, Symbol.toStringTag, { value: "Module" })), Iee = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Rf(e, t) {
  return f(), v("svg", Iee, [...t[0] || (t[0] = [
    g("g", { class: "image" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M1 3.75A2.75 2.75 0 0 1 3.75 1h12.5A2.75 2.75 0 0 1 19 3.75v12.5A2.75 2.75 0 0 1 16.25 19H3.75A2.75 2.75 0 0 1 1 16.25V3.75Zm1.5 9.187v3.313c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25v-3.174l-3.078-2.873-2.744 1.83 2.113 2.197a.75.75 0 1 1-1.082 1.04l-5.768-6L2.5 12.937Zm8.121-2.003L7.541 7.73a.75.75 0 0 0-1.018-.058L2.5 10.992V3.75c0-.69.56-1.25 1.25-1.25h12.5c.69 0 1.25.56 1.25 1.25v7.274l-2.488-2.322a.75.75 0 0 0-.928-.076l-3.463 2.308Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Dee = { render: Rf }, kee = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Dee,
  render: Rf
}, Symbol.toStringTag, { value: "Module" })), Hee = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Ff(e, t) {
  return f(), v("svg", Hee, [...t[0] || (t[0] = [
    g("g", { class: "images" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M16.302 2.525c-.295-.024-.68-.025-1.252-.025h-7.3a.75.75 0 0 1 0-1.5h7.33c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 18.7 2.502c.172.337.24.693.27 1.073.03.365.03.81.03 1.345v7.34a.75.75 0 0 1-1.5 0V4.95c0-.572 0-.957-.025-1.253-.023-.287-.065-.424-.111-.514a1.25 1.25 0 0 0-.547-.547c-.09-.046-.227-.088-.515-.111ZM4.92 4h7.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 15.7 5.502c.172.337.24.693.27 1.073.03.365.03.81.03 1.345v7.161c0 .534 0 .98-.03 1.344-.03.38-.098.736-.27 1.073a2.751 2.751 0 0 1-1.2 1.202c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03H4.92c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 1.3 17.5c-.172-.338-.24-.694-.27-1.074C1 16.06 1 15.615 1 15.08V7.92c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 2.502 4.3c.337-.172.693-.24 1.073-.27C3.94 4 4.385 4 4.92 4ZM2.5 14.846v.204c0 .572 0 .957.025 1.252.023.288.065.425.111.515.12.236.311.427.547.547.09.046.227.088.514.111.296.024.68.025 1.253.025h7.1c.572 0 .957 0 1.252-.025.288-.023.425-.065.516-.111a1.25 1.25 0 0 0 .546-.547c.046-.09.088-.227.111-.515.024-.295.025-.68.025-1.252v-.974l-3.007-2.806-1.753 1.594 1.104 1.427a.75.75 0 0 1-1.187.918L5.99 10.465l-3.49 4.38Zm6.32-3.173L6.593 8.79a.75.75 0 0 0-1.18-.008L2.5 12.439V7.95c0-.572 0-.957.025-1.253.023-.287.065-.424.111-.514a1.25 1.25 0 0 1 .547-.547c.09-.046.227-.088.514-.111.296-.024.68-.025 1.253-.025h7.1c.572 0 .957 0 1.252.025.288.023.425.065.516.111.235.12.426.311.546.547.046.09.088.227.111.514.024.296.025.68.025 1.253v4.074l-2.488-2.322a.75.75 0 0 0-1.017-.007L8.82 11.673Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Vee = { render: Ff }, Oee = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Vee,
  render: Ff
}, Symbol.toStringTag, { value: "Module" })), Bee = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Tf(e, t) {
  return f(), v("svg", Bee, [...t[0] || (t[0] = [
    g("g", { class: "inbox" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M2.644 4.083A2.75 2.75 0 0 1 5.312 2h9.376a2.75 2.75 0 0 1 2.668 2.083l1.622 6.485c.014.06.022.12.022.182v4.5A2.75 2.75 0 0 1 16.25 18H3.75A2.75 2.75 0 0 1 1 15.25v-4.5a.75.75 0 0 1 .022-.182l1.622-6.485ZM5.312 3.5a1.25 1.25 0 0 0-1.213.947L2.71 10h1.803a2.75 2.75 0 0 1 2.46 1.52l.144.289a1.25 1.25 0 0 0 1.118.691h3.528a1.25 1.25 0 0 0 1.118-.691l.144-.289a2.75 2.75 0 0 1 2.46-1.52h1.803L15.9 4.447a1.25 1.25 0 0 0-1.213-.947H5.312Zm12.188 8h-2.014a1.25 1.25 0 0 0-1.118.691l-.144.289a2.75 2.75 0 0 1-2.46 1.52H8.236a2.75 2.75 0 0 1-2.46-1.52l-.144-.289a1.25 1.25 0 0 0-1.118-.691H2.5v3.75c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25V11.5Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const $ee = { render: Tf }, Zee = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: $ee,
  render: Tf
}, Symbol.toStringTag, { value: "Module" })), Gee = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function If(e, t) {
  return f(), v("svg", Gee, [...t[0] || (t[0] = [
    g("g", { class: "info-circle" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10 2.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15ZM1 10a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm9-5a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0v-1.5A.75.75 0 0 1 10 5Zm0 5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 10 10Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Nee = { render: If }, zee = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Nee,
  render: If
}, Symbol.toStringTag, { value: "Module" })), jee = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Df(e, t) {
  return f(), v("svg", jee, [...t[0] || (t[0] = [
    g("g", { class: "info-fill" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10 1a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm0 4a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0v-1.5A.75.75 0 0 1 10 5Zm0 5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 10 10Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Wee = { render: Df }, Uee = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Wee,
  render: Df
}, Symbol.toStringTag, { value: "Module" })), Kee = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function kf(e, t) {
  return f(), v("svg", Kee, [...t[0] || (t[0] = [
    g("g", { class: "key" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M13.75 2.5a3.75 3.75 0 0 0-3.65 4.613.75.75 0 0 1-.2.702l-7.18 7.197a.75.75 0 0 0-.22.53V17.5h2.01c.199 0 .39-.079.53-.22l.21-.21V15a.75.75 0 0 1 .75-.75h2.064l.186-.186V12a.75.75 0 0 1 .75-.75h2.059l1.143-1.145a.75.75 0 0 1 .7-.201A3.75 3.75 0 1 0 13.75 2.5ZM8.5 6.25a5.25 5.25 0 1 1 4.484 5.194L11.9 12.53a.75.75 0 0 1-.53.22H9.75v1.624a.75.75 0 0 1-.22.53l-.624.626a.75.75 0 0 1-.53.22H6.75v1.63a.75.75 0 0 1-.22.53l-.428.43A2.25 2.25 0 0 1 4.51 19H2.25C1.56 19 1 18.44 1 17.75v-2.208c0-.596.236-1.168.657-1.59L8.56 7.036a5.286 5.286 0 0 1-.06-.786Zm4.5 0a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const qee = { render: kf }, Yee = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: qee,
  render: kf
}, Symbol.toStringTag, { value: "Module" })), Qee = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Hf(e, t) {
  return f(), v("svg", Qee, [...t[0] || (t[0] = [
    g("g", {
      class: "keyboard",
      "clip-path": "url(#a)"
    }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M3.92 3h12.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 19.7 4.502c.172.337.24.693.27 1.073.03.365.03.81.03 1.345v6.16c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073a2.751 2.751 0 0 1-1.2 1.202c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03H3.92c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 .3 15.5c-.172-.338-.24-.694-.27-1.074C0 14.06 0 13.615 0 13.08V6.92c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 1.502 3.3c.337-.172.693-.24 1.073-.27C2.94 3 3.385 3 3.92 3ZM2.697 4.525c-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.547c-.046.09-.088.227-.111.514-.024.296-.025.68-.025 1.253v6.1c0 .572 0 .957.025 1.252.023.288.065.425.111.516.12.235.311.426.547.546.09.046.227.088.514.111.296.024.68.025 1.253.025h12.1c.572 0 .957 0 1.252-.025.288-.023.425-.065.515-.111a1.25 1.25 0 0 0 .547-.546c.046-.091.088-.228.111-.515.024-.296.025-.68.025-1.253v-6.1c0-.572 0-.957-.025-1.253-.023-.287-.065-.424-.111-.514a1.25 1.25 0 0 0-.547-.547c-.09-.046-.227-.088-.515-.111-.295-.024-.68-.025-1.252-.025H3.95c-.572 0-.957 0-1.253.025ZM3 7.25a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5A.75.75 0 0 1 3 7.25Zm4 0a.75.75 0 0 1 .75-.75h.5a.75.75 0 1 1 0 1.5h-.5A.75.75 0 0 1 7 7.25Zm4 0a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75Zm-12 3a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h.5a.75.75 0 1 1 0 1.5h-.5a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75Zm-9 3.5a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1),
    g("defs", null, [
      g("clipPath", {
        id: "a",
        class: "a"
      }, [
        g("path", { d: "M0 0h20v20H0z" })
      ])
    ], -1)
  ])]);
}
const Jee = { render: Hf }, Xee = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Jee,
  render: Hf
}, Symbol.toStringTag, { value: "Module" })), ete = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Vf(e, t) {
  return f(), v("svg", ete, [...t[0] || (t[0] = [
    g("g", { class: "label" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M13.794 5.548c-.15-.042-.323-.048-.956-.048H5c-.581 0-.973 0-1.275.025-.293.023-.435.066-.53.113a1.266 1.266 0 0 0-.558.549c-.047.09-.09.225-.113.511-.024.296-.025.68-.025 1.252v4.1c0 .573 0 .956.025 1.252.024.286.066.422.113.511.12.234.315.427.558.549.095.047.237.09.53.113.302.024.694.025 1.275.025h7.837c.633 0 .806-.007.956-.048a1.3 1.3 0 0 0 .421-.206c.123-.09.232-.22.616-.716l2.337-3.02c.14-.181.222-.287.277-.37a.545.545 0 0 0 .047-.08c.01-.04.01-.08 0-.12a.55.55 0 0 0-.047-.08 7.325 7.325 0 0 0-.277-.37L14.83 6.47c-.384-.497-.493-.626-.615-.716a1.295 1.295 0 0 0-.422-.206Zm3.7 4.394-.002-.002.001.002Zm0 .116-.002.002.001-.002ZM12.923 4c.507 0 .9 0 1.273.103.328.092.636.242.91.444.311.23.55.54.857.936l.053.069 2.337 3.02.054.07c.213.272.44.563.532.905.08.297.08.61 0 .906-.093.342-.32.633-.532.905a23.03 23.03 0 0 0-.054.07l-2.337 3.02-.053.069c-.306.396-.546.706-.857.936a2.795 2.795 0 0 1-.91.444c-.373.104-.766.103-1.272.103H4.97c-.544 0-.996 0-1.365-.03-.384-.03-.743-.097-1.083-.268a2.766 2.766 0 0 1-1.218-1.2c-.175-.338-.243-.696-.275-1.076A17.55 17.55 0 0 1 1 12.08V7.919c0-.534 0-.98.03-1.345.032-.38.1-.738.275-1.077a2.766 2.766 0 0 1 1.218-1.2c.34-.17.699-.236 1.083-.267C3.976 4 4.427 4 4.971 4h7.954Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const tte = { render: Vf }, ote = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: tte,
  render: Vf
}, Symbol.toStringTag, { value: "Module" })), nte = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Of(e, t) {
  return f(), v("svg", nte, [...t[0] || (t[0] = [
    g("g", { class: "laptop" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M5.92 2h8.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 17.7 3.502c.172.337.24.693.27 1.073.03.365.03.81.03 1.345V13h.25a.75.75 0 0 1 .75.75v.33c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073a2.751 2.751 0 0 1-1.2 1.202c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03H4.92c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 1.3 16.5c-.172-.338-.24-.694-.27-1.074C1 15.06 1 14.615 1 14.08v-.33a.75.75 0 0 1 .75-.75H2V5.92c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 3.502 2.3c.337-.172.693-.24 1.073-.27C4.94 2 5.385 2 5.92 2ZM2.5 14.5c.002.336.008.592.025.803.023.287.065.424.111.514.12.236.311.427.547.547.09.046.227.088.514.111.296.024.68.025 1.253.025h10.1c.572 0 .957 0 1.252-.025.288-.023.425-.065.515-.111a1.25 1.25 0 0 0 .547-.546c.046-.091.088-.228.111-.515.017-.211.023-.467.024-.803h-3.348a.934.934 0 0 0-.777.416A2.434 2.434 0 0 1 11.349 16H8.65a2.434 2.434 0 0 1-2.025-1.084.934.934 0 0 0-.777-.416H2.5Zm14-1.5h-2.349c-.813 0-1.574.407-2.025 1.084a.934.934 0 0 1-.777.416H8.65a.934.934 0 0 1-.777-.416A2.434 2.434 0 0 0 5.849 13H3.5V5.95c0-.572 0-.957.025-1.253.023-.287.065-.424.111-.514a1.25 1.25 0 0 1 .547-.547c.09-.046.227-.088.514-.111.296-.024.68-.025 1.253-.025h8.1c.572 0 .957 0 1.252.025.288.023.425.065.516.111.235.12.426.311.546.547.046.09.088.227.111.514.024.296.025.68.025 1.253V13Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const ste = { render: Of }, ite = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ste,
  render: Of
}, Symbol.toStringTag, { value: "Module" })), rte = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Bf(e, t) {
  return f(), v("svg", rte, [...t[0] || (t[0] = [
    g("g", { class: "layer-align-bottom-center" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M9.92 1h.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 13.7 2.502c.172.337.24.693.27 1.073.03.365.03.81.03 1.345v7.16c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073a2.751 2.751 0 0 1-1.2 1.202c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03h-.16c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 6.3 14.5c-.172-.338-.24-.694-.27-1.074C6 13.06 6 12.615 6 12.08V4.92c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 7.502 1.3c.337-.172.693-.24 1.073-.27C8.94 1 9.385 1 9.92 1ZM8.697 2.525c-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.547c-.046.09-.088.227-.111.514-.024.296-.025.68-.025 1.253v7.1c0 .572 0 .957.025 1.252.023.288.065.425.111.516.12.235.311.426.547.546.09.046.227.088.514.111.296.024.68.025 1.253.025h.1c.572 0 .957 0 1.252-.025.288-.023.425-.065.516-.111a1.25 1.25 0 0 0 .546-.546c.046-.091.088-.228.111-.515.024-.296.025-.68.025-1.253v-7.1c0-.572 0-.957-.025-1.253-.023-.287-.065-.424-.111-.514a1.25 1.25 0 0 0-.546-.547c-.091-.046-.228-.088-.515-.111-.296-.024-.68-.025-1.253-.025h-.1c-.572 0-.957 0-1.253.025ZM1 18.25a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H1.75a.75.75 0 0 1-.75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const lte = { render: Bf }, ate = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: lte,
  render: Bf
}, Symbol.toStringTag, { value: "Module" })), cte = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function $f(e, t) {
  return f(), v("svg", cte, [...t[0] || (t[0] = [
    g("g", { class: "layer-align-horizontal" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M9.92 1h.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 13.7 2.502c.172.337.24.693.27 1.073.03.365.03.81.03 1.345v4.33h4.25a.75.75 0 0 1 0 1.5H14v4.33c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073a2.751 2.751 0 0 1-1.2 1.202c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03h-.16c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 6.3 17.5c-.172-.338-.24-.694-.27-1.074C6 16.06 6 15.615 6 15.08v-4.33H1.75a.75.75 0 0 1 0-1.5H6V4.92c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 7.502 1.3c.337-.172.693-.24 1.073-.27C8.94 1 9.385 1 9.92 1ZM8.697 2.525c-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.547c-.046.09-.088.227-.111.514-.024.296-.025.68-.025 1.253v10.1c0 .572 0 .957.025 1.252.023.288.065.425.111.515.12.236.311.427.547.547.09.046.227.088.514.111.296.024.68.025 1.253.025h.1c.572 0 .957 0 1.252-.025.288-.023.425-.065.516-.111a1.25 1.25 0 0 0 .546-.547c.046-.09.088-.227.111-.515.024-.295.025-.68.025-1.252V4.95c0-.572 0-.957-.025-1.253-.023-.287-.065-.424-.111-.514a1.25 1.25 0 0 0-.546-.547c-.091-.046-.228-.088-.515-.111-.296-.024-.68-.025-1.253-.025h-.1c-.572 0-.957 0-1.253.025Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const dte = { render: $f }, ute = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: dte,
  render: $f
}, Symbol.toStringTag, { value: "Module" })), hte = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Zf(e, t) {
  return f(), v("svg", hte, [...t[0] || (t[0] = [
    g("g", { class: "layer-align-left-center" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M1.75 1a.75.75 0 0 1 .75.75v16.5a.75.75 0 0 1-1.5 0V1.75A.75.75 0 0 1 1.75 1Zm6.17 5h7.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 18.7 7.502c.172.337.24.693.27 1.073.03.365.03.81.03 1.345v.16c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073a2.751 2.751 0 0 1-1.2 1.202c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03H7.92c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 4.3 12.5c-.172-.338-.24-.694-.27-1.074C4 11.06 4 10.615 4 10.08v-.16c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 5.502 6.3c.337-.172.693-.24 1.073-.27C6.94 6 7.385 6 7.92 6ZM6.697 7.525c-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.547c-.046.09-.088.227-.111.514-.024.296-.025.68-.025 1.253v.1c0 .572 0 .957.025 1.252.023.288.065.425.111.516.12.235.311.426.547.546.09.046.227.088.514.111.296.024.68.025 1.253.025h7.1c.572 0 .957 0 1.252-.025.288-.023.425-.065.515-.111a1.25 1.25 0 0 0 .547-.546c.046-.091.088-.228.111-.515.024-.296.025-.68.025-1.253v-.1c0-.572 0-.957-.025-1.253-.023-.287-.065-.424-.111-.514a1.25 1.25 0 0 0-.547-.547c-.09-.046-.227-.088-.515-.111-.295-.024-.68-.025-1.252-.025h-7.1c-.572 0-.957 0-1.253.025Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const gte = { render: Zf }, pte = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: gte,
  render: Zf
}, Symbol.toStringTag, { value: "Module" })), fte = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Gf(e, t) {
  return f(), v("svg", fte, [...t[0] || (t[0] = [
    g("g", { class: "layer-align-right-center" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M18.25 1a.75.75 0 0 1 .75.75v16.5a.75.75 0 0 1-1.5 0V1.75a.75.75 0 0 1 .75-.75ZM4.92 6h7.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 15.7 7.502c.172.337.24.693.27 1.073.03.365.03.81.03 1.345v.16c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073a2.751 2.751 0 0 1-1.2 1.202c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03H4.92c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 1.3 12.5c-.172-.338-.24-.694-.27-1.074C1 11.06 1 10.615 1 10.08v-.16c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 2.502 6.3c.337-.172.693-.24 1.073-.27C3.94 6 4.385 6 4.92 6ZM3.697 7.525c-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.547c-.046.09-.088.227-.111.514-.024.296-.025.68-.025 1.253v.1c0 .572 0 .957.025 1.252.023.288.065.425.111.516.12.235.311.426.547.546.09.046.227.088.514.111.296.024.68.025 1.253.025h7.1c.572 0 .957 0 1.252-.025.288-.023.425-.065.516-.111a1.25 1.25 0 0 0 .546-.546c.046-.091.088-.228.111-.515.024-.296.025-.68.025-1.253v-.1c0-.572 0-.957-.025-1.253-.023-.287-.065-.424-.111-.514a1.25 1.25 0 0 0-.546-.547c-.091-.046-.228-.088-.515-.111-.296-.024-.68-.025-1.253-.025h-7.1c-.572 0-.957 0-1.253.025Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const vte = { render: Gf }, mte = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: vte,
  render: Gf
}, Symbol.toStringTag, { value: "Module" })), Cte = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Nf(e, t) {
  return f(), v("svg", Cte, [...t[0] || (t[0] = [
    g("g", { class: "layer-align-top-center" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M1 1.75A.75.75 0 0 1 1.75 1h16.5a.75.75 0 0 1 0 1.5H1.75A.75.75 0 0 1 1 1.75ZM9.92 4h.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 13.7 5.502c.172.337.24.693.27 1.073.03.365.03.81.03 1.345v7.16c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073a2.751 2.751 0 0 1-1.2 1.202c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03h-.16c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 6.3 17.5c-.172-.338-.24-.694-.27-1.074C6 16.06 6 15.615 6 15.08V7.92c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 7.502 4.3c.337-.172.693-.24 1.073-.27C8.94 4 9.385 4 9.92 4ZM8.697 5.525c-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.547c-.046.09-.088.227-.111.514-.024.296-.025.68-.025 1.253v7.1c0 .572 0 .957.025 1.252.023.288.065.425.111.515.12.236.311.427.547.547.09.046.227.088.514.111.296.024.68.025 1.253.025h.1c.572 0 .957 0 1.252-.025.288-.023.425-.065.516-.111a1.25 1.25 0 0 0 .546-.547c.046-.09.088-.227.111-.515.024-.295.025-.68.025-1.252v-7.1c0-.572 0-.957-.025-1.253-.023-.287-.065-.424-.111-.514a1.25 1.25 0 0 0-.546-.547c-.091-.046-.228-.088-.515-.111-.296-.024-.68-.025-1.253-.025h-.1c-.572 0-.957 0-1.253.025Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const wte = { render: Nf }, bte = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: wte,
  render: Nf
}, Symbol.toStringTag, { value: "Module" })), yte = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function zf(e, t) {
  return f(), v("svg", yte, [...t[0] || (t[0] = [
    g("g", { class: "layer-align-vertical" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10 1a.75.75 0 0 1 .75.75V6h4.33c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 18.7 7.502c.172.337.24.693.27 1.073.03.365.03.81.03 1.345v.16c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073a2.751 2.751 0 0 1-1.2 1.202c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03h-4.33v4.25a.75.75 0 0 1-1.5 0V14H4.92c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 1.3 12.5c-.172-.338-.24-.694-.27-1.074C1 11.06 1 10.615 1 10.08v-.16c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 2.502 6.3c.337-.172.693-.24 1.073-.27C3.94 6 4.385 6 4.92 6h4.33V1.75A.75.75 0 0 1 10 1ZM3.697 7.525c-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.547c-.046.09-.088.227-.111.514-.024.296-.025.68-.025 1.253v.1c0 .572 0 .957.025 1.252.023.288.065.425.111.516.12.235.311.426.547.546.09.046.227.088.514.111.296.024.68.025 1.253.025h10.1c.572 0 .957 0 1.252-.025.288-.023.425-.065.515-.111a1.25 1.25 0 0 0 .547-.546c.046-.091.088-.228.111-.515.024-.296.025-.68.025-1.253v-.1c0-.572 0-.957-.025-1.253-.023-.287-.065-.424-.111-.514a1.25 1.25 0 0 0-.547-.547c-.09-.046-.227-.088-.515-.111-.295-.024-.68-.025-1.252-.025H4.95c-.572 0-.957 0-1.253.025Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const _te = { render: zf }, Ste = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _te,
  render: zf
}, Symbol.toStringTag, { value: "Module" })), xte = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function jf(e, t) {
  return f(), v("svg", xte, [...t[0] || (t[0] = [
    g("g", { class: "layer-three" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10.236 2.772a1.25 1.25 0 0 0-.472 0c-.152.03-.31.103-.886.4L3.388 6l5.49 2.828c.577.297.734.37.886.4.156.03.316.03.472 0 .152-.03.31-.103.886-.4L16.612 6l-5.49-2.828c-.577-.297-.734-.37-.886-.4ZM9.48 1.3a2.75 2.75 0 0 1 1.04 0c.39.076.75.261 1.209.498l.08.041 6.784 3.495a.75.75 0 0 1 0 1.334l-6.784 3.495-.08.041c-.458.237-.818.422-1.209.498a2.749 2.749 0 0 1-1.04 0c-.39-.076-.75-.261-1.209-.498a20.95 20.95 0 0 0-.08-.041L1.407 6.667a.75.75 0 0 1 0-1.334L8.19 1.838l.08-.041c.458-.237.818-.422 1.209-.498ZM1.083 9.657a.75.75 0 0 1 1.01-.324l6.785 3.495c.577.297.734.37.886.4.156.03.316.03.472 0 .152-.03.31-.103.886-.4l6.785-3.495a.75.75 0 0 1 .686 1.334l-6.784 3.495-.08.041c-.458.237-.818.422-1.209.498a2.749 2.749 0 0 1-1.04 0c-.39-.076-.75-.261-1.209-.498a21.718 21.718 0 0 0-.08-.041l-6.784-3.495a.75.75 0 0 1-.324-1.01Zm0 4a.75.75 0 0 1 1.01-.324l6.785 3.495c.577.297.734.37.886.4.156.03.316.03.472 0 .152-.03.31-.103.886-.4l6.785-3.495a.75.75 0 1 1 .686 1.334l-6.784 3.495-.08.041c-.458.236-.818.422-1.209.498a2.749 2.749 0 0 1-1.04 0c-.39-.076-.75-.262-1.209-.498a20.94 20.94 0 0 0-.08-.041l-6.784-3.495a.75.75 0 0 1-.324-1.01Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Mte = { render: jf }, Ate = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Mte,
  render: jf
}, Symbol.toStringTag, { value: "Module" })), Lte = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Wf(e, t) {
  return f(), v("svg", Lte, [...t[0] || (t[0] = [
    g("g", { class: "layer-two" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10.236 4.772a1.25 1.25 0 0 0-.472 0c-.152.03-.31.103-.886.4L3.388 8l5.49 2.828c.577.297.734.37.886.4.156.03.316.03.472 0 .152-.03.31-.103.886-.4L16.612 8l-5.49-2.828c-.577-.297-.734-.37-.886-.4ZM9.48 3.3a2.75 2.75 0 0 1 1.04 0c.39.076.75.261 1.209.498l.08.041 6.784 3.495a.75.75 0 0 1 0 1.334l-6.784 3.495-.08.041c-.458.237-.818.422-1.209.498a2.749 2.749 0 0 1-1.04 0c-.39-.076-.75-.261-1.209-.498a20.95 20.95 0 0 0-.08-.041L1.407 8.667a.75.75 0 0 1 0-1.334L8.19 3.838l.08-.041c.458-.237.818-.422 1.209-.498Zm-8.397 8.357a.75.75 0 0 1 1.01-.323l6.785 3.495c.577.297.734.37.886.4.156.03.316.03.472 0 .152-.03.31-.103.886-.4l6.785-3.495a.75.75 0 1 1 .686 1.334l-6.784 3.495-.08.041c-.458.236-.818.422-1.209.498a2.749 2.749 0 0 1-1.04 0c-.39-.076-.75-.262-1.209-.498a21.718 21.718 0 0 0-.08-.041l-6.784-3.495a.75.75 0 0 1-.324-1.01Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Ete = { render: Wf }, Pte = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ete,
  render: Wf
}, Symbol.toStringTag, { value: "Module" })), Rte = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Uf(e, t) {
  return f(), v("svg", Rte, [...t[0] || (t[0] = [
    g("g", { class: "layout-swap-horizontal" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M13.993 3.947a.75.75 0 0 1 1.06.046l2.75 3a.75.75 0 0 1 0 1.014l-2.75 3a.75.75 0 0 1-1.106-1.014l1.598-1.743H8.75a.75.75 0 1 1 0-1.5h6.795l-1.598-1.743a.75.75 0 0 1 .046-1.06Zm-7.986 5a.75.75 0 0 1 .046 1.06L4.455 11.75h6.795a.75.75 0 0 1 0 1.5H4.455l1.598 1.743a.75.75 0 0 1-1.106 1.014l-2.75-3a.75.75 0 0 1 0-1.014l2.75-3a.75.75 0 0 1 1.06-.046Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Fte = { render: Uf }, Tte = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Fte,
  render: Uf
}, Symbol.toStringTag, { value: "Module" })), Ite = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Kf(e, t) {
  return f(), v("svg", Ite, [...t[0] || (t[0] = [
    g("g", { class: "layout-swap-vertical" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M6.993 2.197a.75.75 0 0 1 1.014 0l3 2.75a.75.75 0 0 1-1.014 1.106L8.25 4.455v6.795a.75.75 0 0 1-1.5 0V4.455L5.007 6.053a.75.75 0 0 1-1.014-1.106l3-2.75ZM12.5 8a.75.75 0 0 1 .75.75v6.795l1.743-1.598a.75.75 0 0 1 1.014 1.106l-3 2.75a.75.75 0 0 1-1.014 0l-3-2.75a.75.75 0 0 1 1.014-1.106l1.743 1.598V8.75A.75.75 0 0 1 12.5 8Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Dte = { render: Kf }, kte = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Dte,
  render: Kf
}, Symbol.toStringTag, { value: "Module" })), Hte = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function qf(e, t) {
  return f(), v("svg", Hte, [...t[0] || (t[0] = [
    g("g", { class: "link-broken" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M14.405 2.504a9.627 9.627 0 0 0-.398-.004h-.178a3.25 3.25 0 0 0-2.291 1.023L10.28 4.78a.75.75 0 1 1-1.06-1.06l1.264-1.264a4.75 4.75 0 0 1 3.31-1.454C13.85 1 13.908 1 13.998 1h.033c.203 0 .332 0 .445.005a4.75 4.75 0 0 1 4.519 4.519c.005.113.005.242.005.445v.033l-.001.204a4.75 4.75 0 0 1-1.311 3.165c-.04.041-.08.082-.144.145L16.28 10.78a.75.75 0 1 1-1.06-1.06l1.257-1.258.125-.126A3.25 3.25 0 0 0 17.5 6.17l.001-.178c0-.234 0-.325-.004-.398a3.25 3.25 0 0 0-3.091-3.091ZM7.25 2a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-.75.75h-4.5a.75.75 0 0 1 0-1.5H6.5V2.75A.75.75 0 0 1 7.25 2ZM4.78 9.22a.75.75 0 0 1 0 1.06l-1.257 1.258-.125.126a3.25 3.25 0 0 0-.898 2.343c0 .234 0 .325.004.398a3.25 3.25 0 0 0 3.091 3.091c.073.004.164.004.398.004h.178a3.25 3.25 0 0 0 2.291-1.023L9.72 15.22a.75.75 0 1 1 1.06 1.06l-1.264 1.264a4.75 4.75 0 0 1-3.31 1.454C6.15 19 6.092 19 6.002 19H5.97c-.203 0-.332 0-.445-.005a4.75 4.75 0 0 1-4.519-4.519A9.965 9.965 0 0 1 1 14.03v-.032l.001-.204a4.75 4.75 0 0 1 1.454-3.31l.007-.007L3.72 9.22a.75.75 0 0 1 1.06 0ZM12 12.75a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5H13.5v3.75a.75.75 0 0 1-1.5 0v-4.5Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Vte = { render: qf }, Ote = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Vte,
  render: qf
}, Symbol.toStringTag, { value: "Module" })), Bte = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Yf(e, t) {
  return f(), v("svg", Bte, [...t[0] || (t[0] = [
    g("g", { class: "link" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M14.405 2.504a9.627 9.627 0 0 0-.398-.004h-.178a3.25 3.25 0 0 0-2.291 1.023L9.28 5.78c-.165.166-.229.23-.278.284a3.25 3.25 0 0 0 0 4.372c.049.054.113.118.278.284l.25.25a.75.75 0 1 1-1.06 1.06l-.267-.266a10.013 10.013 0 0 1-.311-.319 4.75 4.75 0 0 1 0-6.39c.076-.084.168-.175.311-.32l2.274-2.273.007-.007c.063-.063.104-.104.145-.143a4.75 4.75 0 0 1 3.165-1.31C13.85 1 13.908 1 13.998 1h.033c.203 0 .332 0 .445.005a4.75 4.75 0 0 1 4.519 4.519c.005.113.005.242.005.446v.032l-.001.204a4.75 4.75 0 0 1-1.455 3.31l-.006.007-1.258 1.257a.75.75 0 1 1-1.06-1.06l1.257-1.258.125-.126A3.25 3.25 0 0 0 17.5 6.17l.001-.178c0-.234 0-.325-.004-.398a3.25 3.25 0 0 0-3.091-3.091ZM10.47 9.03a.75.75 0 0 1 1.06-1.06l.267.266c.143.144.235.235.311.319a4.75 4.75 0 0 1 0 6.39c-.076.084-.168.175-.311.32l-2.274 2.273-.007.007c-.063.063-.104.104-.145.143a4.75 4.75 0 0 1-3.165 1.31C6.15 19 6.092 19 6.002 19H5.97c-.204 0-.333 0-.446-.005a4.75 4.75 0 0 1-4.519-4.519A9.965 9.965 0 0 1 1 14.03v-.032l.001-.204a4.75 4.75 0 0 1 1.311-3.165c.04-.041.08-.082.144-.145L3.72 9.22a.75.75 0 0 1 1.06 1.06l-1.257 1.258a3.25 3.25 0 0 0-1.023 2.47c0 .233 0 .324.004.397a3.25 3.25 0 0 0 3.091 3.091c.073.004.164.004.398.004h.178a3.25 3.25 0 0 0 2.291-1.023l2.258-2.257c.165-.166.229-.23.278-.284a3.25 3.25 0 0 0 0-4.372 9.8 9.8 0 0 0-.278-.284l-.25-.25Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const $te = { render: Yf }, Zte = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: $te,
  render: Yf
}, Symbol.toStringTag, { value: "Module" })), Gte = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Qf(e, t) {
  return f(), v("svg", Gte, [...t[0] || (t[0] = [
    g("g", { class: "list-bullet" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M1 4.747a.75.75 0 0 1 .75-.75L4.25 4a.75.75 0 0 1 0 1.5l-2.5-.001a.75.75 0 0 1-.75-.75Zm7 0a.75.75 0 0 1 .75-.75l9.5.006a.75.75 0 1 1 0 1.5l-9.5-.005a.75.75 0 0 1-.75-.75ZM1 10a.75.75 0 0 1 .75-.749l2.5.002a.75.75 0 0 1 0 1.5l-2.5-.002A.75.75 0 0 1 1 10Zm7 0a.75.75 0 0 1 .75-.749l9.5.005a.75.75 0 1 1 0 1.5l-9.5-.005A.75.75 0 0 1 8 10Zm-7 5.25a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Zm7 0a.75.75 0 0 1 .75-.75h9.5a.75.75 0 0 1 0 1.5h-9.5a.75.75 0 0 1-.75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Nte = { render: Qf }, zte = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Nte,
  render: Qf
}, Symbol.toStringTag, { value: "Module" })), jte = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Jf(e, t) {
  return f(), v("svg", jte, [...t[0] || (t[0] = [
    g("g", { class: "list-check" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M5.752 3.193a.75.75 0 0 1 .055 1.059l-2.25 2.5a.75.75 0 0 1-1.133-.022l-1.25-1.5a.75.75 0 0 1 1.152-.96l.696.835 1.67-1.857a.75.75 0 0 1 1.06-.055ZM7 4.75A.75.75 0 0 1 7.75 4h10.5a.75.75 0 0 1 0 1.5H7.75A.75.75 0 0 1 7 4.75Zm0 3.5a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 7 8.25Zm-1.248 2.943a.75.75 0 0 1 .055 1.059l-2.25 2.5a.75.75 0 0 1-1.133-.022l-1.25-1.5a.75.75 0 1 1 1.152-.96l.696.835 1.67-1.857a.75.75 0 0 1 1.06-.055ZM7 12.75a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H7.75a.75.75 0 0 1-.75-.75Zm0 3.5a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1-.75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Wte = { render: Jf }, Ute = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Wte,
  render: Jf
}, Symbol.toStringTag, { value: "Module" })), Kte = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Xf(e, t) {
  return f(), v("svg", Kte, [...t[0] || (t[0] = [
    g("g", { class: "list-ordered" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M4.287 3.057a.75.75 0 0 1 .463.693v5.5a.75.75 0 0 1-1.5 0V5.56l-.97.97a.75.75 0 0 1-1.06-1.06l2.25-2.25a.75.75 0 0 1 .817-.163ZM7 4.75A.75.75 0 0 1 7.75 4h10.5a.75.75 0 0 1 0 1.5H7.75A.75.75 0 0 1 7 4.75Zm0 3.5a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 7 8.25Zm-5.56 4.07c.36-.462.953-.82 1.81-.82.843 0 1.53.35 1.937.959.39.585.456 1.311.29 1.973-.11.445-.446.877-.742 1.208-.26.292-.567.587-.87.86H5.25a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.441-1.357l.006-.004.02-.015a19.974 19.974 0 0 0 .389-.295c.254-.197.594-.47.94-.77.348-.303.69-.623.952-.918.132-.147.235-.278.307-.388a1.215 1.215 0 0 0 .095-.172l.004-.013c.085-.338.027-.612-.084-.777-.093-.14-.281-.291-.688-.291-.393 0-.55.142-.627.242a.662.662 0 0 0-.103.194c-.017.05-.02.08-.02.08A.75.75 0 0 1 1 13.5c0-.282.112-.76.44-1.18Zm5.56.43a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H7.75a.75.75 0 0 1-.75-.75Zm0 3.5a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1-.75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const qte = { render: Xf }, Yte = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: qte,
  render: Xf
}, Symbol.toStringTag, { value: "Module" })), Qte = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function ev(e, t) {
  return f(), v("svg", Qte, [...t[0] || (t[0] = [
    g("g", { class: "list-unordered" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M1 4.75A.75.75 0 0 1 1.75 4h2.5a.75.75 0 0 1 0 1.5h-2.5A.75.75 0 0 1 1 4.75Zm6 0A.75.75 0 0 1 7.75 4h10.5a.75.75 0 0 1 0 1.5H7.75A.75.75 0 0 1 7 4.75Zm0 3.5a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 7 8.25Zm-6 4.5a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Zm6 0a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H7.75a.75.75 0 0 1-.75-.75Zm0 3.5a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1-.75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Jte = { render: ev }, Xte = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Jte,
  render: ev
}, Symbol.toStringTag, { value: "Module" })), eoe = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function tv(e, t) {
  return f(), v("svg", eoe, [...t[0] || (t[0] = [
    g("g", { class: "lock" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M6 5a4 4 0 1 1 8 0v3h1.25A2.75 2.75 0 0 1 18 10.75v5.5A2.75 2.75 0 0 1 15.25 19H4.75A2.75 2.75 0 0 1 2 16.25v-5.5A2.75 2.75 0 0 1 4.75 8H6V5Zm1.5 3h5V5a2.5 2.5 0 0 0-5 0v3ZM4.75 9.5c-.69 0-1.25.56-1.25 1.25v5.5c0 .69.56 1.25 1.25 1.25h10.5c.69 0 1.25-.56 1.25-1.25v-5.5c0-.69-.56-1.25-1.25-1.25H4.75ZM10 12a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0v-1.5A.75.75 0 0 1 10 12Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const toe = { render: tv }, ooe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: toe,
  render: tv
}, Symbol.toStringTag, { value: "Module" })), noe = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function ov(e, t) {
  return f(), v("svg", noe, [...t[0] || (t[0] = [
    g("g", { class: "log-in" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M2 10a.75.75 0 0 1 .75-.75h6.787L7.699 7.259A.75.75 0 1 1 8.8 6.24l3 3.25a.75.75 0 0 1 0 1.018l-3 3.25a.75.75 0 1 1-1.1-1.018l1.838-1.991H2.75A.75.75 0 0 1 2 10Zm8 8.25a.75.75 0 0 1 .75-.75h4.5c.69 0 1.25-.56 1.25-1.25V3.75c0-.69-.56-1.25-1.25-1.25h-4.5a.75.75 0 0 1 0-1.5h4.5A2.75 2.75 0 0 1 18 3.75v12.5A2.75 2.75 0 0 1 15.25 19h-4.5a.75.75 0 0 1-.75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const soe = { render: ov }, ioe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: soe,
  render: ov
}, Symbol.toStringTag, { value: "Module" })), roe = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function nv(e, t) {
  return f(), v("svg", roe, [...t[0] || (t[0] = [
    g("g", { class: "log-out" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M17.801 10.509a.75.75 0 0 0 0-1.018l-3-3.25A.75.75 0 1 0 13.7 7.26l1.838 1.991H8.75a.75.75 0 0 0 0 1.5h6.787l-1.838 1.991A.75.75 0 1 0 14.8 13.76l3-3.25ZM10 18.25a.75.75 0 0 0-.75-.75h-4.5c-.69 0-1.25-.56-1.25-1.25V3.75c0-.69.56-1.25 1.25-1.25h4.5a.75.75 0 0 0 0-1.5h-4.5A2.75 2.75 0 0 0 2 3.75v12.5A2.75 2.75 0 0 0 4.75 19h4.5a.75.75 0 0 0 .75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const loe = { render: nv }, aoe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: loe,
  render: nv
}, Symbol.toStringTag, { value: "Module" })), coe = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function sv(e, t) {
  return f(), v("svg", coe, [...t[0] || (t[0] = [
    g("g", { class: "mail" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M2.564 5.353 10 9.635l7.436-4.282A1.25 1.25 0 0 0 16.25 4.5H3.75a1.25 1.25 0 0 0-1.186.853ZM17.5 7.047l-7.126 4.103a.75.75 0 0 1-.748 0L2.5 7.047v7.203c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25V7.047ZM1 5.75A2.75 2.75 0 0 1 3.75 3h12.5A2.75 2.75 0 0 1 19 5.75v8.5A2.75 2.75 0 0 1 16.25 17H3.75A2.75 2.75 0 0 1 1 14.25v-8.5Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const doe = { render: sv }, uoe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: doe,
  render: sv
}, Symbol.toStringTag, { value: "Module" })), hoe = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function iv(e, t) {
  return f(), v("svg", hoe, [...t[0] || (t[0] = [
    g("g", { class: "map" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M12.828 3.675a3.99 3.99 0 0 0-5.656 0 4.023 4.023 0 0 0 0 5.677L10 12.188l2.828-2.836a4.023 4.023 0 0 0 0-5.677Zm-2.296 10.104H9.468L6.11 10.412a5.523 5.523 0 0 1 0-7.795 5.49 5.49 0 0 1 7.78 0 5.523 5.523 0 0 1 0 7.795l-3.36 3.368Zm0 0a.75.75 0 0 1-1.063 0h1.063ZM8.5 6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm-5.963 4.51a.75.75 0 0 1 .621.86l-.452 2.813c-.105.648-.174 1.085-.198 1.423-.023.33.006.482.045.579.106.266.309.496.582.645.107.058.276.11.628.14.358.03.825.03 1.51.03h9.454c.685 0 1.152 0 1.51-.03.352-.03.52-.082.629-.14.273-.149.475-.379.582-.645.038-.096.067-.249.044-.579-.024-.338-.093-.775-.198-1.423l-.452-2.814a.75.75 0 0 1 1.48-.238l.459 2.847c.097.606.178 1.11.207 1.524.03.429.011.84-.147 1.239a2.779 2.779 0 0 1-1.259 1.407c-.373.202-.781.28-1.221.317-.427.035-.957.035-1.602.035H5.241c-.645 0-1.175 0-1.602-.035-.44-.037-.848-.115-1.221-.317a2.778 2.778 0 0 1-1.259-1.407c-.158-.398-.177-.81-.147-1.24.029-.412.11-.917.207-1.523l.458-2.847a.75.75 0 0 1 .86-.622Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const goe = { render: iv }, poe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: goe,
  render: iv
}, Symbol.toStringTag, { value: "Module" })), foe = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function rv(e, t) {
  return f(), v("svg", foe, [...t[0] || (t[0] = [
    g("g", { class: "marker-pin" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M14.24 4.279a5.941 5.941 0 0 0-8.48 0c-2.347 2.377-2.347 6.234 0 8.611L10 17.183l4.24-4.293c2.347-2.377 2.347-6.234 0-8.611ZM10 18.25l-.534.527-4.773-4.833c-2.924-2.96-2.924-7.758 0-10.72a7.441 7.441 0 0 1 10.614 0c2.924 2.962 2.924 7.76 0 10.72l-4.773 4.832L10 18.25Zm0 0 .534.526a.752.752 0 0 1-1.068.001L10 18.25ZM10 6.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM7 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const voe = { render: rv }, moe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: voe,
  render: rv
}, Symbol.toStringTag, { value: "Module" })), Coe = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function lv(e, t) {
  return f(), v("svg", Coe, [...t[0] || (t[0] = [
    g("g", { class: "math-alpha" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M7.62 4C4.889 4 2.5 6.583 2.5 10c0 3.415 2.397 6 5.13 6 1.358 0 2.36-.534 3.168-1.405.83-.895 1.457-2.153 1.984-3.575v-.002l-.243-.777-.084-.267c-.514-1.647-1.013-3.16-1.77-4.27C9.963 4.644 9.04 4 7.62 4Zm5.962 4.567c-.43-1.313-.931-2.643-1.658-3.708C10.985 3.48 9.64 2.5 7.62 2.5 3.871 2.5 1 5.957 1 10c0 4.044 2.883 7.5 6.63 7.5 1.827 0 3.213-.747 4.268-1.885.663-.714 1.192-1.58 1.632-2.502.223.535.47 1.042.752 1.5C15.125 15.98 16.352 17 18.25 17a.75.75 0 0 0 0-1.5c-1.227 0-2.031-.605-2.692-1.675-.474-.768-.84-1.724-1.19-2.784.316-.906.59-1.837.847-2.706.12-.408.237-.801.351-1.172.423-1.371.81-2.382 1.264-2.938a.75.75 0 0 0-1.16-.95c-.67.82-1.128 2.12-1.537 3.445-.125.407-.248.822-.372 1.242l-.18.605Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const woe = { render: lv }, boe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: woe,
  render: lv
}, Symbol.toStringTag, { value: "Module" })), yoe = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function av(e, t) {
  return f(), v("svg", yoe, [...t[0] || (t[0] = [
    g("g", { class: "math-angle" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M7.487 1.038a.75.75 0 0 1 .475.95L5.94 8.052c3.929 1.611 6.876 5.079 7.482 9.447h4.828V19H1.75a.75.75 0 0 1-.712-.987l5.5-16.5a.75.75 0 0 1 .95-.475ZM11.905 17.5c-.585-3.668-3.076-6.607-6.44-8.02L2.79 17.5h9.114ZM16 7.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM13 9a3 3 0 1 1 6 0 3 3 0 0 1-6 0Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const _oe = { render: av }, Soe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _oe,
  render: av
}, Symbol.toStringTag, { value: "Module" })), xoe = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function cv(e, t) {
  return f(), v("svg", xoe, [...t[0] || (t[0] = [
    g("g", { class: "math-beta" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10 2.5A2.5 2.5 0 0 0 7.5 5v7.743c.527.627 1.262 1.007 2.125 1.007a2.875 2.875 0 0 0 0-5.75v-.01a.75.75 0 0 1 0-1.48V6.5a4.408 4.408 0 0 1 .125 0c.904 0 1.432-.339 1.753-.75.343-.439.497-1.027.497-1.55 0-.246-.148-.681-.513-1.065A2.007 2.007 0 0 0 10 2.5Zm2.094 4.763a3.34 3.34 0 0 0 .59-.589c.595-.76.816-1.697.816-2.474 0-.704-.352-1.494-.925-2.098A3.507 3.507 0 0 0 10 1a4 4 0 0 0-4 4v13.25a.75.75 0 0 0 1.5 0v-3.57c.617.361 1.335.57 2.125.57a4.375 4.375 0 0 0 2.47-7.987Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Moe = { render: cv }, Aoe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Moe,
  render: cv
}, Symbol.toStringTag, { value: "Module" })), Loe = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function dv(e, t) {
  return f(), v("svg", Loe, [...t[0] || (t[0] = [
    g("g", { class: "math-gamma" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M5.262 1.18a.75.75 0 0 1 1.057.082c1.953 2.278 3.525 5.032 4.255 8.001.072-.205.146-.411.223-.619.7-1.876 1.672-3.901 2.872-5.369a.75.75 0 0 1 1.162.95c-1.05 1.282-1.953 3.132-2.628 4.943-.668 1.792-1.085 3.468-1.205 4.398-.124 2.4-.535 3.969-.718 4.665l-.052.2a.75.75 0 1 1-1.456-.363l.054-.206c.18-.687.561-2.14.675-4.4.205-4.076-1.624-8.078-4.32-11.224a.75.75 0 0 1 .08-1.057Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Eoe = { render: dv }, Poe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Eoe,
  render: dv
}, Symbol.toStringTag, { value: "Module" })), Roe = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function uv(e, t) {
  return f(), v("svg", Roe, [...t[0] || (t[0] = [
    g("g", { class: "math-infinite" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M5.5 7a3 3 0 0 0 0 6c1.504 0 2.695-1.203 3.656-3C8.195 8.203 7.004 7 5.5 7ZM10 8.472C8.988 6.882 7.544 5.5 5.5 5.5a4.5 4.5 0 0 0 0 9c2.044 0 3.488-1.382 4.5-2.972 1.012 1.59 2.456 2.972 4.5 2.972a4.5 4.5 0 1 0 0-9c-2.044 0-3.488 1.382-4.5 2.972ZM10.844 10c.961 1.797 2.152 3 3.656 3a3 3 0 1 0 0-6c-1.504 0-2.695 1.203-3.656 3Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Foe = { render: uv }, Toe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Foe,
  render: uv
}, Symbol.toStringTag, { value: "Module" })), Ioe = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function hv(e, t) {
  return f(), v("svg", Ioe, [...t[0] || (t[0] = [
    g("g", { class: "math-omega" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10 2.5A7.5 7.5 0 0 0 2.5 10c0 3.198 2.246 6.467 5.023 7.551A.75.75 0 0 1 7.25 19h-5.5a.75.75 0 0 1 0-1.5h2.837C2.451 15.687 1 12.833 1 10a9 9 0 0 1 18 0c0 2.833-1.451 5.687-3.587 7.5h2.837a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1-.273-1.449C15.254 16.467 17.5 13.2 17.5 10A7.5 7.5 0 0 0 10 2.5Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Doe = { render: hv }, koe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Doe,
  render: hv
}, Symbol.toStringTag, { value: "Module" })), Hoe = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function gv(e, t) {
  return f(), v("svg", Hoe, [...t[0] || (t[0] = [
    g("g", { class: "math-pi" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M4.065 2.948c-.66.341-1.244.998-1.584 2.47a.75.75 0 0 1-1.462-.337c.41-1.777 1.205-2.87 2.358-3.466C4.465 1.053 5.764 1 7 1h11.25a.75.75 0 0 1 0 1.5H14.5V16a1.5 1.5 0 0 0 3 0 .75.75 0 0 1 1.5 0 3 3 0 1 1-6 0V2.5H8v9.54c0 .976 0 1.982-.348 3.077-.356 1.123-1.055 2.28-2.359 3.65a.75.75 0 1 1-1.086-1.034c1.196-1.256 1.747-2.223 2.016-3.07.272-.857.277-1.65.277-2.663V2.505c-1.014.02-1.808.119-2.435.443Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Voe = { render: gv }, Ooe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Voe,
  render: gv
}, Symbol.toStringTag, { value: "Module" })), Boe = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function pv(e, t) {
  return f(), v("svg", Boe, [...t[0] || (t[0] = [
    g("g", { class: "math-sigma" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M3.075 1.423A.75.75 0 0 1 3.75 1h13a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0V2.5H5.296l5.543 7.036a.75.75 0 0 1 0 .928L5.296 17.5H15.75v-1.75a.75.75 0 0 1 1.5 0v2.5a.75.75 0 0 1-.75.75H3.75a.75.75 0 0 1-.59-1.214L9.296 10 3.161 2.214a.75.75 0 0 1-.086-.791Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const $oe = { render: pv }, Zoe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: $oe,
  render: pv
}, Symbol.toStringTag, { value: "Module" })), Goe = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function fv(e, t) {
  return f(), v("svg", Goe, [...t[0] || (t[0] = [
    g("g", { class: "math-sine-wawe" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M3.227 6.56c-.541 1.338-.727 3.1-.727 4.688a.75.75 0 1 1-1.5 0c0-1.662.189-3.65.836-5.25.653-1.616 1.86-3 3.914-3 .85 0 1.561.257 2.146.715.57.446.982 1.053 1.306 1.7.324.649.58 1.383.813 2.117.098.306.188.605.279.901.134.443.268.881.417 1.33.153.459.3.941.442 1.405.09.293.176.58.261.847.228.719.456 1.36.726 1.9.27.54.56.932.889 1.19.313.246.696.396 1.221.396 1.195 0 1.99-.742 2.523-2.063.541-1.337.727-3.1.727-4.687a.75.75 0 0 1 1.5 0c0 1.662-.189 3.65-.836 5.25-.653 1.616-1.86 3-3.914 3-.85 0-1.561-.257-2.146-.715-.57-.446-.982-1.053-1.306-1.7-.324-.65-.58-1.383-.813-2.117-.097-.306-.188-.605-.279-.902a51.62 51.62 0 0 0-.417-1.33c-.153-.458-.3-.94-.442-1.404-.09-.293-.176-.58-.261-.847-.228-.719-.456-1.36-.726-1.9-.27-.54-.56-.933-.889-1.19-.313-.246-.696-.396-1.221-.396-1.195 0-1.99.742-2.523 2.063Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Noe = { render: fv }, zoe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Noe,
  render: fv
}, Symbol.toStringTag, { value: "Module" })), joe = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function vv(e, t) {
  return f(), v("svg", joe, [...t[0] || (t[0] = [
    g("g", { class: "math-square-root" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M13.187 4a2.25 2.25 0 0 0-2.142 1.561L7.214 17.48a.75.75 0 0 1-1.434-.018l-2.077-7.065a1.25 1.25 0 0 0-1.2-.897H1.75a.75.75 0 0 1 0-1.5h.754a2.75 2.75 0 0 1 2.638 1.974l1.39 4.726 3.085-9.598a3.75 3.75 0 0 1 3.57-2.602h5.063a.75.75 0 0 1 0 1.5h-5.063Zm-.864 6.133a.75.75 0 0 1 1.044.19L15 12.683l1.633-2.36a.75.75 0 1 1 1.234.854L15.912 14l1.955 2.823a.75.75 0 1 1-1.234.854L15 15.317l-1.633 2.36a.75.75 0 1 1-1.234-.854L14.088 14l-1.955-2.823a.75.75 0 0 1 .19-1.044Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Woe = { render: vv }, Uoe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Woe,
  render: vv
}, Symbol.toStringTag, { value: "Module" })), Koe = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function mv(e, t) {
  return f(), v("svg", Koe, [...t[0] || (t[0] = [
    g("g", { class: "math-theta" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M5.523 9.25h8.954c-.112-1.85-.636-3.485-1.397-4.681C12.21 3.205 11.104 2.5 10 2.5s-2.211.705-3.08 2.069c-.76 1.196-1.285 2.83-1.397 4.681Zm8.954 1.5H5.523c.112 1.85.636 3.485 1.397 4.681C7.79 16.795 8.896 17.5 10 17.5s2.211-.705 3.08-2.069c.76-1.196 1.285-2.83 1.397-4.681ZM5.655 3.764C6.687 2.142 8.205 1 10 1s3.313 1.142 4.345 2.764C15.383 5.394 16 7.6 16 10c0 2.399-.617 4.606-1.655 6.236C13.313 17.858 11.795 19 10 19s-3.313-1.142-4.345-2.764C4.617 14.606 4 12.4 4 10c0-2.399.617-4.606 1.655-6.236Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const qoe = { render: mv }, Yoe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: qoe,
  render: mv
}, Symbol.toStringTag, { value: "Module" })), Qoe = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Cv(e, t) {
  return f(), v("svg", Qoe, [...t[0] || (t[0] = [
    g("g", { class: "megaphone" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M13.25 1a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0v-1.5a.75.75 0 0 1 .75-.75Zm4.53 1.22a.75.75 0 0 1 0 1.06l-1.5 1.5a.75.75 0 1 1-1.06-1.06l1.5-1.5a.75.75 0 0 1 1.06 0Zm-11.05.52a2.5 2.5 0 0 1 3.53 0l7 7a2.5 2.5 0 0 1 0 3.53 2.5 2.5 0 0 1-2.96.427l-.933.583.601 2.005a.75.75 0 0 1-.315.848l-2.75 1.75a.75.75 0 0 1-.738.038l-2.346-1.173-1.421.888a.75.75 0 0 1-.928-.106l-.23-.229a2.495 2.495 0 0 1-3.505-.041 2.496 2.496 0 0 1-.036-3.5l-.23-.23a.75.75 0 0 1-.105-.928L6.303 5.7a2.502 2.502 0 0 1 .427-2.96Zm.606 4.137-4.384 7.015 3.156 3.156 7.015-4.384-5.787-5.787ZM2.76 15.82a.996.996 0 0 0 .038 1.382l.005.004a.994.994 0 0 0 1.376.034l-1.42-1.42Zm6.55.996 1.146.573 1.913-1.217-.32-1.068-2.74 1.712ZM9.2 3.8a1 1 0 0 0-1.41 0 1 1 0 0 0 0 1.41l7 7a1 1 0 0 0 1.41 0 1 1 0 0 0 0-1.41l-7-7ZM16 6.75a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Joe = { render: Cv }, Xoe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Joe,
  render: Cv
}, Symbol.toStringTag, { value: "Module" })), ene = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function wv(e, t) {
  return f(), v("svg", ene, [...t[0] || (t[0] = [
    g("g", { class: "menu" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M1 4.75A.75.75 0 0 1 1.75 4h16.5a.75.75 0 0 1 0 1.5H1.75A.75.75 0 0 1 1 4.75ZM1 10a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H1.75A.75.75 0 0 1 1 10Zm0 5.25a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H1.75a.75.75 0 0 1-.75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const tne = { render: wv }, one = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: tne,
  render: wv
}, Symbol.toStringTag, { value: "Module" })), nne = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function bv(e, t) {
  return f(), v("svg", nne, [...t[0] || (t[0] = [
    g("g", { class: "message" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M1 4.75A2.75 2.75 0 0 1 3.75 2h12.5A2.75 2.75 0 0 1 19 4.75v7.5A2.75 2.75 0 0 1 16.25 15h-5.63a.25.25 0 0 0-.163.06l-3.219 2.76A.75.75 0 0 1 6 17.25v-2a.25.25 0 0 0-.25-.25h-2A2.75 2.75 0 0 1 1 12.25v-7.5ZM3.75 3.5c-.69 0-1.25.56-1.25 1.25v7.5c0 .69.56 1.25 1.25 1.25h2c.966 0 1.75.784 1.75 1.75v.37l1.981-1.699a1.75 1.75 0 0 1 1.139-.421h5.63c.69 0 1.25-.56 1.25-1.25v-7.5c0-.69-.56-1.25-1.25-1.25H3.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const sne = { render: bv }, ine = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sne,
  render: bv
}, Symbol.toStringTag, { value: "Module" })), rne = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function yv(e, t) {
  return f(), v("svg", rne, [...t[0] || (t[0] = [
    g("g", { class: "mic" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M6 5a4 4 0 1 1 8 0v4a4 4 0 0 1-8 0V5Zm4-2.5A2.5 2.5 0 0 0 7.5 5v4a2.5 2.5 0 0 0 5 0V5A2.5 2.5 0 0 0 10 2.5ZM3.75 8.25A.75.75 0 0 1 4.5 9a5.5 5.5 0 1 0 11 0A.75.75 0 0 1 17 9a7.001 7.001 0 0 1-6.25 6.96v1.54h2.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1 0-1.5h2.5v-1.54A7.001 7.001 0 0 1 3 9a.75.75 0 0 1 .75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const lne = { render: yv }, ane = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: lne,
  render: yv
}, Symbol.toStringTag, { value: "Module" })), cne = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function _v(e, t) {
  return f(), v("svg", cne, [...t[0] || (t[0] = [
    g("g", { class: "minus" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M4 10a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H4.75A.75.75 0 0 1 4 10Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const dne = { render: _v }, une = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: dne,
  render: _v
}, Symbol.toStringTag, { value: "Module" })), hne = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Sv(e, t) {
  return f(), v("svg", hne, [...t[0] || (t[0] = [
    g("g", { class: "mobile" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M3 3.75A2.75 2.75 0 0 1 5.75 1h8.5A2.75 2.75 0 0 1 17 3.75v12.5A2.75 2.75 0 0 1 14.25 19h-8.5A2.75 2.75 0 0 1 3 16.25V3.75ZM5.75 2.5c-.69 0-1.25.56-1.25 1.25v12.5c0 .69.56 1.25 1.25 1.25h8.5c.69 0 1.25-.56 1.25-1.25V3.75c0-.69-.56-1.25-1.25-1.25h-8.5ZM9 15.25a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const gne = { render: Sv }, pne = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: gne,
  render: Sv
}, Symbol.toStringTag, { value: "Module" })), fne = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function xv(e, t) {
  return f(), v("svg", fne, [...t[0] || (t[0] = [
    g("g", { class: "more-horizontal" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M4.75 10a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm6.75 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm5.25 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const vne = { render: xv }, mne = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: vne,
  render: xv
}, Symbol.toStringTag, { value: "Module" })), Cne = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Mv(e, t) {
  return f(), v("svg", Cne, [...t[0] || (t[0] = [
    g("g", { class: "more-vertical" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10 4.75a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm0 6.75a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm-1.5 5.25a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const wne = { render: Mv }, bne = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: wne,
  render: Mv
}, Symbol.toStringTag, { value: "Module" })), yne = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Av(e, t) {
  return f(), v("svg", yne, [...t[0] || (t[0] = [
    g("g", { class: "mouse" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M4 7a6 6 0 1 1 12 0v6a6 6 0 0 1-12 0V7Zm6-4.5A4.5 4.5 0 0 0 5.5 7v6a4.5 4.5 0 1 0 9 0V7A4.5 4.5 0 0 0 10 2.5ZM10 5a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0v-2.5A.75.75 0 0 1 10 5Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const _ne = { render: Av }, Sne = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _ne,
  render: Av
}, Symbol.toStringTag, { value: "Module" })), xne = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Lv(e, t) {
  return f(), v("svg", xne, [...t[0] || (t[0] = [
    g("g", { class: "navigation" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M8.181 2.302a1.922 1.922 0 0 1 3.638 0l5.055 13.996c.318.88.005 1.738-.582 2.238-.593.505-1.501.668-2.297.134l-3.771-2.531a.394.394 0 0 0-.448 0L6.005 18.67c-.796.534-1.704.37-2.296-.134-.588-.5-.9-1.358-.583-2.238L8.181 2.302Zm2.227.51c-.15-.416-.666-.416-.816 0L4.537 16.807a.514.514 0 0 0 .144.586c.145.124.318.145.488.03l3.771-2.53a1.895 1.895 0 0 1 2.12 0l3.771 2.53c.17.115.343.094.488-.03a.514.514 0 0 0 .144-.586L10.408 2.81Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Mne = { render: Lv }, Ane = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Mne,
  render: Lv
}, Symbol.toStringTag, { value: "Module" })), Lne = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Ev(e, t) {
  return f(), v("svg", Lne, [...t[0] || (t[0] = [
    g("g", { class: "notification" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M16 2.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM13 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0ZM1 4.75A2.75 2.75 0 0 1 3.75 2H9a.75.75 0 0 1 0 1.5H3.75c-.69 0-1.25.56-1.25 1.25v11.5c0 .69.56 1.25 1.25 1.25h11.5c.69 0 1.25-.56 1.25-1.25V11a.75.75 0 0 1 1.5 0v5.25A2.75 2.75 0 0 1 15.25 19H3.75A2.75 2.75 0 0 1 1 16.25V4.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Ene = { render: Ev }, Pne = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ene,
  render: Ev
}, Symbol.toStringTag, { value: "Module" })), Rne = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Pv(e, t) {
  return f(), v("svg", Rne, [...t[0] || (t[0] = [
    g("g", { class: "open-in-new" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M14 1.75a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0V3.56l-5.97 5.97a.75.75 0 1 1-1.06-1.06l5.97-5.97h-1.69a.75.75 0 0 1-.75-.75Zm-13 3A2.75 2.75 0 0 1 3.75 2H9a.75.75 0 0 1 0 1.5H3.75c-.69 0-1.25.56-1.25 1.25v11.5c0 .69.56 1.25 1.25 1.25h11.5c.69 0 1.25-.56 1.25-1.25V11a.75.75 0 0 1 1.5 0v5.25A2.75 2.75 0 0 1 15.25 19H3.75A2.75 2.75 0 0 1 1 16.25V4.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Fne = { render: Pv }, Tne = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Fne,
  render: Pv
}, Symbol.toStringTag, { value: "Module" })), Ine = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Rv(e, t) {
  return f(), v("svg", Ine, [...t[0] || (t[0] = [
    g("g", { class: "option" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M1 7a.75.75 0 0 1 .75-.75H7.5a.75.75 0 0 1 .692.462L10.5 12.25h7.75a.75.75 0 0 1 0 1.5H10a.75.75 0 0 1-.692-.461L7 7.75H1.75A.75.75 0 0 1 1 7Zm11 0a.75.75 0 0 1 .75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5A.75.75 0 0 1 12 7Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Dne = { render: Rv }, kne = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Dne,
  render: Rv
}, Symbol.toStringTag, { value: "Module" })), Hne = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Fv(e, t) {
  return f(), v("svg", Hne, [...t[0] || (t[0] = [
    g("g", { class: "package" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M9.657 1.083a.75.75 0 0 1 .687 0l8.25 4.25A.75.75 0 0 1 19 6v8a.75.75 0 0 1-.407.667l-8.25 4.25a.75.75 0 0 1-.686 0l-8.25-4.25A.75.75 0 0 1 1 14V6a.75.75 0 0 1 .407-.667l8.25-4.25ZM2.5 7.197v6.346l6.75 3.477v-6.55L2.5 7.197Zm8.25 3.273v6.55l6.75-3.477V7.197l-6.75 3.273Zm5.823-4.49-2.506 1.215L7.47 3.897 10 2.594l6.573 3.386ZM5.818 4.748 3.429 5.98 10 9.166l2.364-1.146-6.546-3.272Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Vne = { render: Fv }, One = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Vne,
  render: Fv
}, Symbol.toStringTag, { value: "Module" })), Bne = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Tv(e, t) {
  return f(), v("svg", Bne, [...t[0] || (t[0] = [
    g("g", { class: "paintroller" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M2 2.25C2 1.56 2.56 1 3.25 1h11.5c.69 0 1.25.56 1.25 1.25v1h1.15c.47 0 .85.38.85.85v4.55c0 .47-.38.85-.85.85h-7.4V11H10a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h.25V8.85c0-.47.38-.85.85-.85h7.4V4.75H16v1C16 6.44 15.44 7 14.75 7H3.25C2.56 7 2 6.44 2 5.75v-3.5Zm12.5.25h-11v3h11v-3Zm-6 10v5h1v-5h-1Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const $ne = { render: Tv }, Zne = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: $ne,
  render: Tv
}, Symbol.toStringTag, { value: "Module" })), Gne = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Iv(e, t) {
  return f(), v("svg", Gne, [...t[0] || (t[0] = [
    g("g", { class: "paperplane" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M18.672 1.13c.236.16.36.44.321.722l-2 14.5a.75.75 0 0 1-.998.603l-4.8-1.738-2.052 3.419a.75.75 0 0 1-1.373-.212l-1.158-4.866-5.117-1.853a.75.75 0 0 1-.112-1.36l16.5-9.25a.75.75 0 0 1 .79.035ZM8.3 14.17l.504 2.117.954-1.59L8.3 14.17Zm.308-1.484 8.59-8.785-1.563 11.33-7.027-2.545Zm5.461-7.73-7.01 7.17-3.512-1.272 10.522-5.899Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Nne = { render: Iv }, zne = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Nne,
  render: Iv
}, Symbol.toStringTag, { value: "Module" })), jne = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Dv(e, t) {
  return f(), v("svg", jne, [...t[0] || (t[0] = [
    g("g", { class: "paragraph" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M7.364 3.5a3.864 3.864 0 1 0 0 7.727h3.82V3.5h-3.82Zm0-1.5a5.364 5.364 0 1 0 0 10.727h3.82v4.523a.75.75 0 0 0 1.5 0V3.5h1.619v13.75a.75.75 0 0 0 1.5 0V3.5h1.447a.75.75 0 0 0 0-1.5H7.364Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Wne = { render: Dv }, Une = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Wne,
  render: Dv
}, Symbol.toStringTag, { value: "Module" })), Kne = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function kv(e, t) {
  return f(), v("svg", Kne, [...t[0] || (t[0] = [
    g("g", { class: "pause-circle" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10 2.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15ZM1 10a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm6.75-4a.75.75 0 0 1 .75.75v6.5a.75.75 0 0 1-1.5 0v-6.5A.75.75 0 0 1 7.75 6Zm4.5 0a.75.75 0 0 1 .75.75v6.5a.75.75 0 0 1-1.5 0v-6.5a.75.75 0 0 1 .75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const qne = { render: kv }, Yne = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: qne,
  render: kv
}, Symbol.toStringTag, { value: "Module" })), Qne = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Hv(e, t) {
  return f(), v("svg", Qne, [...t[0] || (t[0] = [
    g("g", { class: "pause" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M7.75 4a.75.75 0 0 1 .75.75v10.5a.75.75 0 0 1-1.5 0V4.75A.75.75 0 0 1 7.75 4Zm4.5 0a.75.75 0 0 1 .75.75v10.5a.75.75 0 0 1-1.5 0V4.75a.75.75 0 0 1 .75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Jne = { render: Hv }, Xne = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Jne,
  render: Hv
}, Symbol.toStringTag, { value: "Module" })), ese = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Vv(e, t) {
  return f(), v("svg", ese, [...t[0] || (t[0] = [
    g("g", { class: "phone-call" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M12.25 1.75A.75.75 0 0 1 13 1a6 6 0 0 1 6 6 .75.75 0 0 1-1.5 0A4.5 4.5 0 0 0 13 2.5a.75.75 0 0 1-.75-.75Zm-1 3A.75.75 0 0 1 12 4a4 4 0 0 1 4 4 .75.75 0 0 1-1.5 0A2.5 2.5 0 0 0 12 5.5a.75.75 0 0 1-.75-.75ZM1 5.375A4.375 4.375 0 0 1 5.375 1c.439 0 .86.174 1.17.485l.006.005.096.099a168.388 168.388 0 0 1 1.026 1.06c.282.294.569.597.79.838.11.12.208.23.283.318a2.931 2.931 0 0 1 .162.212l.001.001A.8.8 0 0 1 9 4.209c.114.352.114.73 0 1.082a1.193 1.193 0 0 1-.194.347l-.002.002a4.015 4.015 0 0 1-.197.233c-.14.155-.32.34-.497.522l-.027.028c-.37.379-.711.73-.873.945-.242.322-.293.854-.177 1.176l.001.003.237.498a9.253 9.253 0 0 0 .467.827c.728 1.114 1.276 1.646 2.396 2.394.29.194.666.398 1 .565a12.213 12.213 0 0 0 .606.28l.003.002c.294.096.614.08.897-.046.155-.069.563-.33 1.032-.637l.106-.07c.18-.117.355-.233.5-.324a5.61 5.61 0 0 1 .239-.146 2.17 2.17 0 0 1 .114-.062.997.997 0 0 1 .198-.075 1.75 1.75 0 0 1 .842 0 1.273 1.273 0 0 1 .289.12c.068.037.146.082.227.13.162.099.36.224.559.352.396.255.81.53.966.635A2.892 2.892 0 0 1 19 15.396 3.604 3.604 0 0 1 15.396 19h-2.48a7.564 7.564 0 0 1-3.49-.853 17.784 17.784 0 0 1-7.573-7.573A7.564 7.564 0 0 1 1 7.084v-1.71Zm4.483-2.83a.156.156 0 0 0-.108-.045A2.875 2.875 0 0 0 2.5 5.375v1.71c0 .973.235 1.933.684 2.797a16.283 16.283 0 0 0 6.934 6.934c.864.45 1.824.684 2.798.684h2.48a2.104 2.104 0 0 0 2.104-2.104c0-.465-.232-.9-.62-1.158a70.11 70.11 0 0 0-.947-.622c-.193-.125-.377-.24-.52-.327a4.981 4.981 0 0 0-.15-.087h-.02l-.162.1c-.134.085-.297.193-.478.311l-.109.071c-.407.268-.948.622-1.245.754a2.75 2.75 0 0 1-1.974.1 8.21 8.21 0 0 1-.811-.365 11.205 11.205 0 0 1-1.163-.66c-1.275-.85-1.971-1.524-2.818-2.82a11.498 11.498 0 0 1-.861-1.64c-.274-.76-.18-1.83.389-2.586.223-.296.624-.708.952-1.044l.073-.075c.181-.186.34-.35.458-.48.039-.043.069-.078.091-.105v-.007a11.508 11.508 0 0 0-.228-.255 65.12 65.12 0 0 0-.767-.815 147.705 147.705 0 0 0-1.016-1.049l-.09-.093Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const tse = { render: Vv }, ose = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: tse,
  render: Vv
}, Symbol.toStringTag, { value: "Module" })), nse = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Ov(e, t) {
  return f(), v("svg", nse, [...t[0] || (t[0] = [
    g("g", { class: "phone-callback" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M15.259 1.199a.75.75 0 0 1 .042 1.06L13.463 4.25h4.787a.75.75 0 0 1 0 1.5h-4.787l1.838 1.991A.75.75 0 1 1 14.2 8.76l-3-3.25a.75.75 0 0 1 0-1.018l3-3.25a.75.75 0 0 1 1.06-.042ZM1 5.375A4.375 4.375 0 0 1 5.375 1c.439 0 .86.174 1.17.485l.006.005.096.099a168.388 168.388 0 0 1 1.026 1.06c.282.294.569.597.79.838.11.12.208.23.283.318a2.931 2.931 0 0 1 .162.212l.001.001A.8.8 0 0 1 9 4.209c.114.352.114.73 0 1.082a1.193 1.193 0 0 1-.194.347l-.002.002a4.015 4.015 0 0 1-.197.233c-.14.155-.32.34-.497.522l-.027.028c-.37.379-.711.73-.873.945-.242.322-.293.854-.177 1.176l.001.003.237.498a9.253 9.253 0 0 0 .467.827c.728 1.114 1.276 1.646 2.396 2.394.29.194.666.398 1 .565a12.213 12.213 0 0 0 .606.28l.003.002c.294.096.614.08.897-.046.155-.069.563-.33 1.032-.637l.106-.07c.18-.117.355-.233.5-.324a5.61 5.61 0 0 1 .239-.146 2.17 2.17 0 0 1 .114-.062.997.997 0 0 1 .198-.075 1.75 1.75 0 0 1 .842 0 1.273 1.273 0 0 1 .289.12c.068.037.146.082.227.13.162.099.36.224.559.352.396.255.81.53.966.635A2.892 2.892 0 0 1 19 15.396 3.604 3.604 0 0 1 15.396 19h-2.48a7.564 7.564 0 0 1-3.49-.853 17.784 17.784 0 0 1-7.573-7.573A7.564 7.564 0 0 1 1 7.084v-1.71Zm4.483-2.83a.156.156 0 0 0-.108-.045A2.875 2.875 0 0 0 2.5 5.375v1.71c0 .973.235 1.933.684 2.797a16.283 16.283 0 0 0 6.934 6.934c.864.45 1.824.684 2.798.684h2.48a2.104 2.104 0 0 0 2.104-2.104c0-.465-.232-.9-.62-1.158a70.11 70.11 0 0 0-.947-.622c-.193-.125-.377-.24-.52-.327a4.981 4.981 0 0 0-.15-.087h-.02l-.162.1c-.134.085-.297.193-.478.311l-.109.071c-.407.268-.948.622-1.245.754a2.75 2.75 0 0 1-1.974.1 8.21 8.21 0 0 1-.811-.365 11.205 11.205 0 0 1-1.163-.66c-1.275-.85-1.971-1.524-2.818-2.82a11.498 11.498 0 0 1-.861-1.64c-.274-.76-.18-1.83.389-2.586.223-.296.624-.708.952-1.044l.073-.075c.181-.186.34-.35.458-.48.039-.043.069-.078.091-.105v-.007a11.508 11.508 0 0 0-.228-.255 65.12 65.12 0 0 0-.767-.815 147.705 147.705 0 0 0-1.016-1.049l-.09-.093Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const sse = { render: Ov }, ise = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sse,
  render: Ov
}, Symbol.toStringTag, { value: "Module" })), rse = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Bv(e, t) {
  return f(), v("svg", rse, [...t[0] || (t[0] = [
    g("g", { class: "phone-forwarded" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M14.741 1.199a.75.75 0 0 1 1.06.042l3 3.25a.75.75 0 0 1 0 1.018l-3 3.25A.75.75 0 1 1 14.7 7.74l1.838-1.991H11.75a.75.75 0 0 1 0-1.5h4.787l-1.838-1.991a.75.75 0 0 1 .042-1.06ZM1 5.375A4.375 4.375 0 0 1 5.375 1c.439 0 .86.174 1.17.485l.006.005.096.099a163.167 163.167 0 0 1 1.026 1.06c.282.294.569.597.79.838.11.12.208.23.283.318a2.931 2.931 0 0 1 .162.212l.001.001A.8.8 0 0 1 9 4.209c.114.352.114.73 0 1.082a1.193 1.193 0 0 1-.194.347l-.002.002a4.012 4.012 0 0 1-.197.233c-.14.155-.32.34-.497.522l-.027.028c-.37.379-.711.73-.873.945-.242.322-.293.854-.177 1.176l.001.003.237.498a9.251 9.251 0 0 0 .467.827c.728 1.114 1.276 1.646 2.396 2.394.29.194.666.398 1 .565a12.213 12.213 0 0 0 .606.28l.003.002c.294.096.614.08.897-.046.155-.069.563-.33 1.032-.637l.106-.07c.18-.117.355-.233.5-.324a5.61 5.61 0 0 1 .239-.146 2.17 2.17 0 0 1 .114-.062.997.997 0 0 1 .198-.075c.276-.068.566-.068.842 0a1.27 1.27 0 0 1 .289.12c.068.037.146.082.227.13.162.099.36.224.559.352.396.255.81.53.966.635A2.892 2.892 0 0 1 19 15.396 3.604 3.604 0 0 1 15.396 19h-2.48a7.564 7.564 0 0 1-3.49-.853 17.784 17.784 0 0 1-7.573-7.573A7.564 7.564 0 0 1 1 7.084v-1.71Zm4.483-2.83a.156.156 0 0 0-.108-.045A2.875 2.875 0 0 0 2.5 5.375v1.71c0 .973.235 1.933.684 2.797a16.283 16.283 0 0 0 6.934 6.934c.864.45 1.824.684 2.798.684h2.48a2.104 2.104 0 0 0 2.104-2.104c0-.465-.232-.9-.62-1.158a70.11 70.11 0 0 0-.947-.622c-.193-.125-.377-.24-.52-.327a4.981 4.981 0 0 0-.15-.087h-.02l-.162.1c-.134.085-.297.193-.478.311l-.109.071c-.407.268-.948.622-1.245.754a2.75 2.75 0 0 1-1.974.1 8.21 8.21 0 0 1-.811-.365 11.205 11.205 0 0 1-1.163-.66c-1.275-.85-1.971-1.524-2.818-2.82a11.498 11.498 0 0 1-.861-1.64c-.274-.76-.18-1.83.389-2.586.223-.296.624-.708.952-1.044l.073-.075c.181-.186.34-.35.458-.48a3.52 3.52 0 0 0 .091-.105v-.007a11.508 11.508 0 0 0-.228-.255 55.62 55.62 0 0 0-.767-.815 147.367 147.367 0 0 0-1.016-1.049l-.09-.093Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const lse = { render: Bv }, ase = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: lse,
  render: Bv
}, Symbol.toStringTag, { value: "Module" })), cse = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function $v(e, t) {
  return f(), v("svg", cse, [...t[0] || (t[0] = [
    g("g", { class: "phone-incoming" }, [
      g("g", { class: "Icon" }, [
        g("path", {
          "fill-rule": "evenodd",
          d: "M17.78 2.22a.75.75 0 0 1 0 1.06L13.56 7.5h2.69a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75v-4.5a.75.75 0 0 1 1.5 0v2.69l4.22-4.22a.75.75 0 0 1 1.06 0Z",
          "clip-rule": "evenodd"
        }),
        g("path", {
          "fill-rule": "evenodd",
          d: "M1 5.375A4.375 4.375 0 0 1 5.375 1c.439 0 .86.174 1.17.485l.006.005.096.099a168.388 168.388 0 0 1 1.026 1.06c.282.294.569.597.79.838.11.12.208.23.283.318a2.931 2.931 0 0 1 .162.212l.001.001A.8.8 0 0 1 9 4.209c.114.352.114.73 0 1.082a1.193 1.193 0 0 1-.194.347l-.002.002a4.015 4.015 0 0 1-.197.233c-.14.155-.32.34-.497.522l-.027.028c-.37.379-.711.73-.873.945-.242.322-.293.854-.177 1.176l.001.003.237.498a9.253 9.253 0 0 0 .467.827c.728 1.114 1.276 1.646 2.396 2.394.29.194.666.398 1 .565a12.213 12.213 0 0 0 .606.28l.003.002c.294.096.614.08.897-.046.155-.069.563-.33 1.032-.637l.106-.07c.18-.117.355-.233.5-.324a5.61 5.61 0 0 1 .239-.146 2.17 2.17 0 0 1 .114-.062.997.997 0 0 1 .198-.075 1.75 1.75 0 0 1 .842 0 1.273 1.273 0 0 1 .289.12c.068.037.146.082.227.13.162.099.36.224.559.352.396.255.81.53.966.635A2.892 2.892 0 0 1 19 15.396 3.604 3.604 0 0 1 15.396 19h-2.48a7.564 7.564 0 0 1-3.49-.853 17.784 17.784 0 0 1-7.573-7.573A7.564 7.564 0 0 1 1 7.084v-1.71Zm4.483-2.83a.156.156 0 0 0-.108-.045A2.875 2.875 0 0 0 2.5 5.375v1.71c0 .973.235 1.933.684 2.797a16.283 16.283 0 0 0 6.934 6.934c.864.45 1.824.684 2.798.684h2.48a2.104 2.104 0 0 0 2.104-2.104c0-.465-.232-.9-.62-1.158a70.11 70.11 0 0 0-.947-.622c-.193-.125-.377-.24-.52-.327a4.981 4.981 0 0 0-.15-.087h-.02l-.162.1c-.134.085-.297.193-.478.311l-.109.071c-.407.268-.948.622-1.245.754a2.75 2.75 0 0 1-1.974.1 8.21 8.21 0 0 1-.811-.365 11.205 11.205 0 0 1-1.163-.66c-1.275-.85-1.971-1.524-2.818-2.82a11.498 11.498 0 0 1-.861-1.64c-.274-.76-.18-1.83.389-2.586.223-.296.624-.708.952-1.044l.073-.075c.181-.186.34-.35.458-.48.039-.043.069-.078.091-.105v-.007a11.508 11.508 0 0 0-.228-.255 65.12 65.12 0 0 0-.767-.815 147.705 147.705 0 0 0-1.016-1.049l-.09-.093Z",
          "clip-rule": "evenodd"
        })
      ])
    ], -1)
  ])]);
}
const dse = { render: $v }, use = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: dse,
  render: $v
}, Symbol.toStringTag, { value: "Module" })), hse = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Zv(e, t) {
  return f(), v("svg", hse, [...t[0] || (t[0] = [
    g("g", { class: "phone-missed" }, [
      g("g", { class: "Icon" }, [
        g("path", {
          "fill-rule": "evenodd",
          d: "M12.22 2.22a.75.75 0 0 1 1.06 0L15 3.94l1.72-1.72a.75.75 0 1 1 1.06 1.06L16.06 5l1.72 1.72a.75.75 0 0 1-1.06 1.06L15 6.06l-1.72 1.72a.75.75 0 1 1-1.06-1.06L13.94 5l-1.72-1.72a.75.75 0 0 1 0-1.06Z",
          "clip-rule": "evenodd"
        }),
        g("path", {
          "fill-rule": "evenodd",
          d: "M1 5.375A4.375 4.375 0 0 1 5.375 1c.439 0 .86.174 1.17.485l.006.005.096.099a168.388 168.388 0 0 1 1.026 1.06c.282.294.569.597.79.838.11.12.208.23.283.318a2.931 2.931 0 0 1 .162.212l.001.001A.8.8 0 0 1 9 4.209c.114.352.114.73 0 1.082a1.193 1.193 0 0 1-.194.347l-.002.002a4.015 4.015 0 0 1-.197.233c-.14.155-.32.34-.497.522l-.027.028c-.37.379-.711.73-.873.945-.242.322-.293.854-.177 1.176l.001.003.237.498a9.253 9.253 0 0 0 .467.827c.728 1.114 1.276 1.646 2.396 2.394.29.194.666.398 1 .565a12.213 12.213 0 0 0 .606.28l.003.002c.294.096.614.08.897-.046.155-.069.563-.33 1.032-.637l.106-.07c.18-.117.355-.233.5-.324a5.61 5.61 0 0 1 .239-.146 2.17 2.17 0 0 1 .114-.062.997.997 0 0 1 .198-.075 1.75 1.75 0 0 1 .842 0 1.273 1.273 0 0 1 .289.12c.068.037.146.082.227.13.162.099.36.224.559.352.396.255.81.53.966.635A2.892 2.892 0 0 1 19 15.396 3.604 3.604 0 0 1 15.396 19h-2.48a7.564 7.564 0 0 1-3.49-.853 17.784 17.784 0 0 1-7.573-7.573A7.564 7.564 0 0 1 1 7.084v-1.71Zm4.483-2.83a.156.156 0 0 0-.108-.045A2.875 2.875 0 0 0 2.5 5.375v1.71c0 .973.235 1.933.684 2.797a16.283 16.283 0 0 0 6.934 6.934c.864.45 1.824.684 2.798.684h2.48a2.104 2.104 0 0 0 2.104-2.104c0-.465-.232-.9-.62-1.158a70.11 70.11 0 0 0-.947-.622c-.193-.125-.377-.24-.52-.327a4.981 4.981 0 0 0-.15-.087h-.02l-.162.1c-.134.085-.297.193-.478.311l-.109.071c-.407.268-.948.622-1.245.754a2.75 2.75 0 0 1-1.974.1 8.21 8.21 0 0 1-.811-.365 11.205 11.205 0 0 1-1.163-.66c-1.275-.85-1.971-1.524-2.818-2.82a11.498 11.498 0 0 1-.861-1.64c-.274-.76-.18-1.83.389-2.586.223-.296.624-.708.952-1.044l.073-.075c.181-.186.34-.35.458-.48.039-.043.069-.078.091-.105v-.007a11.508 11.508 0 0 0-.228-.255 65.12 65.12 0 0 0-.767-.815 147.705 147.705 0 0 0-1.016-1.049l-.09-.093Z",
          "clip-rule": "evenodd"
        })
      ])
    ], -1)
  ])]);
}
const gse = { render: Zv }, pse = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: gse,
  render: Zv
}, Symbol.toStringTag, { value: "Module" })), fse = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Gv(e, t) {
  return f(), v("svg", fse, [...t[0] || (t[0] = [
    g("g", { class: "phone-outgoing" }, [
      g("g", { class: "Icon" }, [
        g("path", {
          "fill-rule": "evenodd",
          d: "M12 2.75a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0V4.56l-4.22 4.22a.75.75 0 1 1-1.06-1.06l4.22-4.22h-2.69a.75.75 0 0 1-.75-.75Z",
          "clip-rule": "evenodd"
        }),
        g("path", {
          "fill-rule": "evenodd",
          d: "M1 5.375A4.375 4.375 0 0 1 5.375 1c.439 0 .86.174 1.17.485l.006.005.096.099a168.388 168.388 0 0 1 1.026 1.06c.282.294.569.597.79.838.11.12.208.23.283.318a2.931 2.931 0 0 1 .162.212l.001.001A.8.8 0 0 1 9 4.209c.114.352.114.73 0 1.082a1.193 1.193 0 0 1-.194.347l-.002.002a4.015 4.015 0 0 1-.197.233c-.14.155-.32.34-.497.522l-.027.028c-.37.379-.711.73-.873.945-.242.322-.293.854-.177 1.176l.001.003.237.498a9.253 9.253 0 0 0 .467.827c.728 1.114 1.276 1.646 2.396 2.394.29.194.666.398 1 .565a12.213 12.213 0 0 0 .606.28l.003.002c.294.096.614.08.897-.046.155-.069.563-.33 1.032-.637l.106-.07c.18-.117.355-.233.5-.324a5.61 5.61 0 0 1 .239-.146 2.17 2.17 0 0 1 .114-.062.997.997 0 0 1 .198-.075 1.75 1.75 0 0 1 .842 0 1.273 1.273 0 0 1 .289.12c.068.037.146.082.227.13.162.099.36.224.559.352.396.255.81.53.966.635A2.892 2.892 0 0 1 19 15.396 3.604 3.604 0 0 1 15.396 19h-2.48a7.564 7.564 0 0 1-3.49-.853 17.784 17.784 0 0 1-7.573-7.573A7.564 7.564 0 0 1 1 7.084v-1.71Zm4.483-2.83a.156.156 0 0 0-.108-.045A2.875 2.875 0 0 0 2.5 5.375v1.71c0 .973.235 1.933.684 2.797a16.283 16.283 0 0 0 6.934 6.934c.864.45 1.824.684 2.798.684h2.48a2.104 2.104 0 0 0 2.104-2.104c0-.465-.232-.9-.62-1.158a70.11 70.11 0 0 0-.947-.622c-.193-.125-.377-.24-.52-.327a4.981 4.981 0 0 0-.15-.087h-.02l-.162.1c-.134.085-.297.193-.478.311l-.109.071c-.407.268-.948.622-1.245.754a2.75 2.75 0 0 1-1.974.1 8.21 8.21 0 0 1-.811-.365 11.205 11.205 0 0 1-1.163-.66c-1.275-.85-1.971-1.524-2.818-2.82a11.498 11.498 0 0 1-.861-1.64c-.274-.76-.18-1.83.389-2.586.223-.296.624-.708.952-1.044l.073-.075c.181-.186.34-.35.458-.48.039-.043.069-.078.091-.105v-.007a11.508 11.508 0 0 0-.228-.255 65.12 65.12 0 0 0-.767-.815 147.705 147.705 0 0 0-1.016-1.049l-.09-.093Z",
          "clip-rule": "evenodd"
        })
      ])
    ], -1)
  ])]);
}
const vse = { render: Gv }, mse = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: vse,
  render: Gv
}, Symbol.toStringTag, { value: "Module" })), Cse = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Nv(e, t) {
  return f(), v("svg", Cse, [...t[0] || (t[0] = [
    g("g", { class: "phone" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M1 5.375A4.375 4.375 0 0 1 5.375 1c.439 0 .86.174 1.17.485l.006.005.096.099a168.388 168.388 0 0 1 1.026 1.06c.282.294.569.597.79.838.11.12.208.23.283.318a2.931 2.931 0 0 1 .162.212l.001.001A.8.8 0 0 1 9 4.209c.114.352.114.73 0 1.082a1.193 1.193 0 0 1-.194.347l-.002.002a4.015 4.015 0 0 1-.197.233c-.14.155-.32.34-.497.522l-.027.028c-.37.379-.711.73-.873.945-.242.322-.293.854-.177 1.176l.001.003.237.498a9.253 9.253 0 0 0 .467.827c.728 1.114 1.276 1.646 2.396 2.394.29.194.666.398 1 .565a12.213 12.213 0 0 0 .606.28l.003.002c.294.096.614.08.897-.046.155-.069.563-.33 1.032-.637l.106-.07c.18-.117.355-.233.5-.324a5.61 5.61 0 0 1 .239-.146 2.17 2.17 0 0 1 .114-.062.997.997 0 0 1 .198-.075 1.75 1.75 0 0 1 .842 0 1.273 1.273 0 0 1 .289.12c.068.037.146.082.227.13.162.099.36.224.559.352.396.255.81.53.966.635A2.892 2.892 0 0 1 19 15.396 3.604 3.604 0 0 1 15.396 19h-2.48a7.564 7.564 0 0 1-3.49-.853 17.784 17.784 0 0 1-7.573-7.573A7.564 7.564 0 0 1 1 7.084v-1.71Zm4.483-2.83a.156.156 0 0 0-.108-.045A2.875 2.875 0 0 0 2.5 5.375v1.71c0 .973.235 1.933.684 2.797a16.283 16.283 0 0 0 6.934 6.934c.864.45 1.824.684 2.798.684h2.48a2.104 2.104 0 0 0 2.104-2.104c0-.465-.232-.9-.62-1.158a70.11 70.11 0 0 0-.947-.622c-.193-.125-.377-.24-.52-.327a4.981 4.981 0 0 0-.15-.087h-.02l-.162.1c-.134.085-.297.193-.478.311l-.109.071c-.407.268-.948.622-1.245.754a2.75 2.75 0 0 1-1.974.1 8.21 8.21 0 0 1-.811-.365 11.205 11.205 0 0 1-1.163-.66c-1.275-.85-1.971-1.524-2.818-2.82a11.498 11.498 0 0 1-.861-1.64c-.274-.76-.18-1.83.389-2.586.223-.296.624-.708.952-1.044l.073-.075c.181-.186.34-.35.458-.48.039-.043.069-.078.091-.105v-.007a11.508 11.508 0 0 0-.228-.255 65.12 65.12 0 0 0-.767-.815 147.705 147.705 0 0 0-1.016-1.049l-.09-.093Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const wse = { render: Nv }, bse = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: wse,
  render: Nv
}, Symbol.toStringTag, { value: "Module" })), yse = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function zv(e, t) {
  return f(), v("svg", yse, [...t[0] || (t[0] = [
    g("g", { class: "pin" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M7.51 1h4.98c.341 0 .64 0 .885.02.256.02.533.067.796.21.373.205.67.535.819.942.107.294.098.58.065.829-.03.233-.093.51-.163.815l-.437 1.921c-.085.373-.103.466-.106.553-.003.092.005.184.024.274.019.086.054.177.202.532l1.974 4.718c.141.339.268.641.346.895.082.264.149.582.07.923a1.753 1.753 0 0 1-.803 1.094c-.285.173-.597.227-.882.25-.277.024-.621.024-1.018.024H10.75v3.25a.75.75 0 0 1-1.5 0V15H5.738c-.397 0-.741 0-1.018-.023-.285-.024-.597-.078-.882-.251a1.752 1.752 0 0 1-.802-1.094c-.08-.34-.013-.659.068-.923.08-.254.206-.556.347-.895l1.974-4.718c.149-.355.183-.446.202-.532.02-.09.027-.182.024-.274-.003-.087-.021-.18-.106-.553l-.43-1.891-.007-.03a9.132 9.132 0 0 1-.163-.815 1.716 1.716 0 0 1 .065-.829 1.77 1.77 0 0 1 .82-.941c.262-.144.539-.19.795-.211C6.869 1 7.169 1 7.51 1Zm-.961 1.547a.722.722 0 0 1 .197-.032c.177-.014.415-.015.792-.015h4.924c.377 0 .615 0 .792.015.145.012.191.03.198.032a.277.277 0 0 1 .124.13.69.69 0 0 1-.008.13c-.02.154-.067.362-.145.706l-.43 1.892a10.79 10.79 0 0 1-.013.052c-.066.294-.12.532-.13.778a2.63 2.63 0 0 0 .056.644c.052.24.146.465.264.746l.021.05 1.96 4.687c.16.38.257.614.312.79a.874.874 0 0 1 .036.154.262.262 0 0 1-.116.138.834.834 0 0 1-.228.038 12.8 12.8 0 0 1-.924.018H5.77c-.437 0-.717 0-.924-.018a.834.834 0 0 1-.229-.038.261.261 0 0 1-.115-.138.87.87 0 0 1 .036-.153c.055-.177.152-.412.311-.791L6.81 7.675l.021-.05c.117-.28.212-.506.264-.746a2.63 2.63 0 0 0 .056-.644c-.01-.246-.063-.484-.13-.778l-.013-.052-.43-1.892a8.811 8.811 0 0 1-.145-.706.737.737 0 0 1-.009-.13.278.278 0 0 1 .126-.13Zm-.126.13a.07.07 0 0 1 .001-.007s0 .007-.005.017a.19.19 0 0 1 .004-.01ZM4.501 13.306a.186.186 0 0 1-.005-.015.104.104 0 0 1 .004.024v-.01Zm.115.138Zm10.767 0h-.001.002Zm.116-.138.001.009s0-.01.004-.024a.158.158 0 0 1-.005.015Zm-1.923-10.63a.162.162 0 0 1 .005.011.092.092 0 0 1-.005-.017v.007Zm-.124-.129Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const _se = { render: zv }, Sse = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _se,
  render: zv
}, Symbol.toStringTag, { value: "Module" })), xse = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function jv(e, t) {
  return f(), v("svg", xse, [...t[0] || (t[0] = [
    g("g", { class: "placeholder-2" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M2.537 9.25h14.926a7.501 7.501 0 0 0-14.926 0Zm14.926 1.5H2.537a7.5 7.5 0 0 0 14.926 0ZM1 10a9 9 0 1 1 18 0 9 9 0 0 1-18 0Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Mse = { render: jv }, Ase = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Mse,
  render: jv
}, Symbol.toStringTag, { value: "Module" })), Lse = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Wv(e, t) {
  return f(), v("svg", Lse, [...t[0] || (t[0] = [
    g("g", { class: "placeholder" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10 2.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15ZM1 10a9 9 0 1 1 18 0 9 9 0 0 1-18 0Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Ese = { render: Wv }, Pse = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ese,
  render: Wv
}, Symbol.toStringTag, { value: "Module" })), Rse = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Uv(e, t) {
  return f(), v("svg", Rse, [...t[0] || (t[0] = [
    g("g", { class: "play-circle" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10 2.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15ZM1 10a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm7.409-3.918a.75.75 0 0 1 .78.06l4.5 3.25a.75.75 0 0 1 0 1.216l-4.5 3.25A.75.75 0 0 1 8 13.25v-6.5a.75.75 0 0 1 .409-.668ZM9.5 8.217v3.566L11.969 10 9.5 8.217Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Fse = { render: Uv }, Tse = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Fse,
  render: Uv
}, Symbol.toStringTag, { value: "Module" })), Ise = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Kv(e, t) {
  return f(), v("svg", Ise, [...t[0] || (t[0] = [
    g("g", { class: "play" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M5.394 3.09a.75.75 0 0 1 .768.033l9.5 6.25a.75.75 0 0 1 0 1.254l-9.5 6.25A.75.75 0 0 1 5 16.25V3.75a.75.75 0 0 1 .394-.66ZM6.5 5.14v9.718L13.885 10 6.5 5.141Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Dse = { render: Kv }, kse = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Dse,
  render: Kv
}, Symbol.toStringTag, { value: "Module" })), Hse = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function qv(e, t) {
  return f(), v("svg", Hse, [...t[0] || (t[0] = [
    g("g", { class: "plugin" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M7.75 1a.75.75 0 0 1 .75.75V4h3V1.75a.75.75 0 0 1 1.5 0V4h1.25A2.75 2.75 0 0 1 17 6.75v2.5a6.75 6.75 0 0 1-6.25 6.732v2.268a.75.75 0 0 1-1.5 0v-2.268A6.75 6.75 0 0 1 3 9.25v-2.5A2.75 2.75 0 0 1 5.75 4H7V1.75A.75.75 0 0 1 7.75 1Zm-2 4.5c-.69 0-1.25.56-1.25 1.25v2.5c0 2.9 2.35 5.25 5.25 5.25h.5c2.9 0 5.25-2.35 5.25-5.25v-2.5c0-.69-.56-1.25-1.25-1.25h-8.5Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Vse = { render: qv }, Ose = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Vse,
  render: qv
}, Symbol.toStringTag, { value: "Module" })), Bse = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Yv(e, t) {
  return f(), v("svg", Bse, [...t[0] || (t[0] = [
    g("g", { class: "plus" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10 4a.75.75 0 0 1 .75.75v4.5h4.5a.75.75 0 0 1 0 1.5h-4.5v4.5a.75.75 0 0 1-1.5 0v-4.5h-4.5a.75.75 0 0 1 0-1.5h4.5v-4.5A.75.75 0 0 1 10 4Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const $se = { render: Yv }, Zse = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: $se,
  render: Yv
}, Symbol.toStringTag, { value: "Module" })), Gse = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Qv(e, t) {
  return f(), v("svg", Gse, [...t[0] || (t[0] = [
    g("g", { class: "print" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M4.25 3a1 1 0 0 1 1-1h9.5a1 1 0 0 1 1 1v2h2c.69 0 1.25.56 1.25 1.25v7.5c0 .69-.56 1.25-1.25 1.25h-2v2a1 1 0 0 1-1 1h-9.5a1 1 0 0 1-1-1v-2h-2C1.56 15 1 14.44 1 13.75v-7.5C1 5.56 1.56 5 2.25 5h2V3Zm0 10.5v-2a1 1 0 0 1 1-1h9.5a1 1 0 0 1 1 1v2h1.75v-7h-15v7h1.75Zm1.5-10V5h8.5V3.5h-8.5ZM14 8.75a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75ZM5.75 12v4.5h8.5V12h-8.5ZM7 14.25a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Nse = { render: Qv }, zse = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Nse,
  render: Qv
}, Symbol.toStringTag, { value: "Module" })), jse = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Jv(e, t) {
  return f(), v("svg", jse, [...t[0] || (t[0] = [
    g("g", { class: "questionmark" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10 2.5c-2.472 0-4.5 1.9-4.5 4.75a.75.75 0 0 1-1.5 0C4 3.6 6.673 1 10 1s6 2.6 6 6.25c0 2.118-1.497 3.816-3.084 4.874-.728.485-1.266.927-1.625 1.415-.343.465-.541.997-.541 1.711a.75.75 0 0 1-1.5 0c0-1.036.302-1.88.834-2.601.516-.7 1.228-1.258 2-1.773C13.497 9.934 14.5 8.632 14.5 7.25c0-2.85-2.028-4.75-4.5-4.75ZM10 17a.75.75 0 0 1 .75.75v.5a.75.75 0 0 1-1.5 0v-.5A.75.75 0 0 1 10 17Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Wse = { render: Jv }, Use = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Wse,
  render: Jv
}, Symbol.toStringTag, { value: "Module" })), Kse = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Xv(e, t) {
  return f(), v("svg", Kse, [...t[0] || (t[0] = [
    g("g", { class: "quote" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M6.585 4.546c-.14-.04-.333-.046-1.025-.046h-.61c-.572 0-.957 0-1.253.025-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.547c-.046.09-.088.227-.111.514-.024.296-.025.68-.025 1.253v.1c0 .572 0 .957.025 1.253.023.287.065.424.111.514.12.236.311.427.547.547.09.046.227.088.514.111.296.024.68.025 1.253.025h.55a.75.75 0 0 1 .67 1.085L4.715 13.5h.735a7.002 7.002 0 0 0 .224-.003.25.25 0 0 0 .161-.1l.02-.033a6.82 6.82 0 0 0 .083-.166c.378-.754.55-1.1.697-1.451a11.25 11.25 0 0 0 .84-3.559c.026-.379.026-.766.026-1.61V6.44c0-.692-.007-.885-.046-1.025a1.25 1.25 0 0 0-.87-.87ZM5.66 3c.542 0 .961 0 1.325.1A2.75 2.75 0 0 1 8.9 5.014c.1.364.1.783.1 1.325v.272c0 .803 0 1.244-.03 1.68a12.75 12.75 0 0 1-.952 4.033c-.168.404-.365.798-.725 1.516l-.014.029-.016.032a2.643 2.643 0 0 1-.214.376 1.75 1.75 0 0 1-1.132.7 2.642 2.642 0 0 1-.433.023H3.5a.75.75 0 0 1-.67-1.085l1.458-2.917a9.845 9.845 0 0 1-.713-.028c-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 1.3 9.498c-.172-.337-.24-.693-.27-1.073C1 8.06 1 7.615 1 7.08v-.16c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 2.502 3.3c.337-.172.693-.24 1.073-.27C3.94 3 4.385 3 4.92 3h.741Zm10.923 3.546c-.139-.04-.332-.046-1.024-.046h-.61c-.572 0-.957 0-1.252.025-.288.023-.425.065-.516.111a1.25 1.25 0 0 0-.546.547c-.046.09-.088.227-.111.514-.024.296-.025.68-.025 1.253v.1c0 .572 0 .957.025 1.252.023.288.065.425.111.516.12.235.311.426.546.546.091.046.228.088.515.111.296.024.68.025 1.253.025h.55a.75.75 0 0 1 .67 1.085L14.714 15.5h.736a7 7 0 0 0 .186-.001l.038-.002a.25.25 0 0 0 .161-.1l.02-.033a6.92 6.92 0 0 0 .083-.166c.377-.754.55-1.1.697-1.451.472-1.133.755-2.335.84-3.559.026-.379.026-.766.026-1.61V8.44c0-.692-.007-.885-.046-1.025a1.25 1.25 0 0 0-.87-.87ZM15.661 5c.542 0 .961 0 1.325.1A2.75 2.75 0 0 1 18.9 7.014c.1.364.1.783.1 1.325v.272c0 .803 0 1.244-.03 1.68a12.749 12.749 0 0 1-.952 4.033c-.168.404-.366.798-.725 1.517l-.014.028-.016.032a2.64 2.64 0 0 1-.214.376 1.75 1.75 0 0 1-1.132.7 2.642 2.642 0 0 1-.433.023H13.5a.75.75 0 0 1-.67-1.085l1.458-2.917a9.845 9.845 0 0 1-.713-.028c-.38-.03-.736-.098-1.073-.27a2.751 2.751 0 0 1-1.202-1.2c-.172-.338-.24-.694-.27-1.074C11 10.06 11 9.615 11 9.08v-.16c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 12.5 5.3c.338-.172.694-.24 1.074-.27.365-.03.81-.03 1.345-.03h.741Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const qse = { render: Xv }, Yse = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: qse,
  render: Xv
}, Symbol.toStringTag, { value: "Module" })), Qse = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function em(e, t) {
  return f(), v("svg", Qse, [...t[0] || (t[0] = [
    g("g", { class: "rainbow" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10 7.25c-3.57 0-6.75 3.148-6.75 7a.75.75 0 0 1-1.5 0c0-4.648 3.82-8.5 8.25-8.5s8.25 3.852 8.25 8.5a.75.75 0 0 1-1.5 0c0-3.852-3.18-7-6.75-7ZM10 10c-2.26 0-4.25 1.93-4.25 4.25a.75.75 0 0 1-1.5 0c0-3.163 2.676-5.75 5.75-5.75s5.75 2.587 5.75 5.75a.75.75 0 0 1-1.5 0c0-2.32-1.99-4.25-4.25-4.25Zm0 3c-.66 0-1.25.575-1.25 1.25a.75.75 0 0 1-1.5 0c0-1.518 1.276-2.75 2.75-2.75s2.75 1.232 2.75 2.75a.75.75 0 0 1-1.5 0c0-.675-.59-1.25-1.25-1.25Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Jse = { render: em }, Xse = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Jse,
  render: em
}, Symbol.toStringTag, { value: "Module" })), eie = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function tm(e, t) {
  return f(), v("svg", eie, [...t[0] || (t[0] = [
    g("g", { class: "receipt" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M4.25 2.5a1 1 0 0 0-1 1v13.425l1.364-.818a.75.75 0 0 1 .721-.028L8 17.411l2.665-1.332a.75.75 0 0 1 .694.013l1.641.895V3.5c0-.356.074-.694.208-1H4.25Zm11.088-1.495A.76.76 0 0 0 15.25 1h-11a2.5 2.5 0 0 0-2.5 2.5v14.75a.75.75 0 0 0 1.136.643l2.147-1.288 2.632 1.316a.75.75 0 0 0 .67 0l2.65-1.325 2.406 1.312a.75.75 0 0 0 1.109-.658V8.5h2.363c.058 0 .139 0 .212-.006.088-.007.229-.027.379-.103a1 1 0 0 0 .437-.437.986.986 0 0 0 .103-.379C18 7.502 18 7.421 18 7.363V3.5a2.5 2.5 0 0 0-2.662-2.495ZM14.5 7h2V3.5a1 1 0 1 0-2 0V7ZM5 6.25a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5A.75.75 0 0 1 5 6.25ZM5 9.5a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5A.75.75 0 0 1 5 9.5Zm0 3.25a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const tie = { render: tm }, oie = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: tie,
  render: tm
}, Symbol.toStringTag, { value: "Module" })), nie = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function om(e, t) {
  return f(), v("svg", nie, [...t[0] || (t[0] = [
    g("g", { class: "redo" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M18.25 7a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-.75.75h-4.5a.75.75 0 0 1 0-1.5h2.956C15.032 9.77 12.546 8.875 10 8.875c-3.06 0-6.037 1.295-7.617 3.778a.75.75 0 0 1-1.266-.806C3.037 8.83 6.561 7.375 10 7.375c2.728 0 5.508.915 7.5 2.8V7.75a.75.75 0 0 1 .75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const sie = { render: om }, iie = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sie,
  render: om
}, Symbol.toStringTag, { value: "Module" })), rie = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function nm(e, t) {
  return f(), v("svg", rie, [...t[0] || (t[0] = [
    g("g", { class: "refresh" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10.836 1.281a.75.75 0 0 1-.117 1.055L9.889 3H10a6.981 6.981 0 0 1 4.95 2.05A6.981 6.981 0 0 1 17 10a6.98 6.98 0 0 1-.532 2.68.75.75 0 1 1-1.385-.575A5.48 5.48 0 0 0 15.5 10a5.481 5.481 0 0 0-1.61-3.89A5.481 5.481 0 0 0 10 4.5h-.112l.83.664a.75.75 0 1 1-.937 1.172l-2.5-2a.75.75 0 0 1 0-1.172l2.5-2a.75.75 0 0 1 1.055.117ZM4.512 6.915a.75.75 0 0 1 .405.98A5.481 5.481 0 0 0 4.5 10a5.482 5.482 0 0 0 1.61 3.89A5.483 5.483 0 0 0 10 15.5h.112l-.83-.664a.75.75 0 1 1 .937-1.172l2.5 2a.75.75 0 0 1 0 1.172l-2.5 2a.75.75 0 1 1-.938-1.172l.83-.664H10a6.983 6.983 0 0 1-4.95-2.05A6.981 6.981 0 0 1 3 10c0-.948.189-1.853.531-2.68a.75.75 0 0 1 .98-.405Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const lie = { render: nm }, aie = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: lie,
  render: nm
}, Symbol.toStringTag, { value: "Module" })), cie = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function sm(e, t) {
  return f(), v("svg", cie, [...t[0] || (t[0] = [
    g("g", { class: "repeat" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M8.82 1.262a.75.75 0 0 1-.082 1.057L6.778 4H9.5a7.5 7.5 0 1 1-7.314 5.834.75.75 0 1 1 1.463.332A6 6 0 1 0 9.5 5.5H6.777l1.961 1.68a.75.75 0 1 1-.976 1.14l-3.5-3a.75.75 0 0 1 0-1.14l3.5-3a.75.75 0 0 1 1.057.082Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const die = { render: sm }, uie = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: die,
  render: sm
}, Symbol.toStringTag, { value: "Module" })), hie = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function im(e, t) {
  return f(), v("svg", hie, [...t[0] || (t[0] = [
    g("g", { class: "reply" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M8.544 2.06A.75.75 0 0 1 9 2.75v3.294c1.656.118 3.944.432 5.915 1.741C17.252 9.338 19 12.182 19 17.25a.75.75 0 0 1-1.5 0c0-.538-.274-1.103-.871-1.693-.597-.59-1.455-1.142-2.459-1.633-1.668-.818-3.629-1.418-5.17-1.76v3.086a.75.75 0 0 1-1.27.54l-6.5-6.25a.75.75 0 0 1 0-1.08l6.5-6.25a.75.75 0 0 1 .814-.15Zm8.658 11.997c-.543-2.62-1.763-4.122-3.117-5.022-1.895-1.26-4.203-1.447-5.875-1.536a.75.75 0 0 1-.71-.749V4.512L2.832 9 7.5 13.488V11.25a.75.75 0 0 1 .88-.739c1.718.301 4.29 1.007 6.45 2.066.864.423 1.69.916 2.372 1.48Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const gie = { render: im }, pie = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: gie,
  render: im
}, Symbol.toStringTag, { value: "Module" })), fie = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function rm(e, t) {
  return f(), v("svg", fie, [...t[0] || (t[0] = [
    g("g", { class: "robot" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10 2.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1ZM8 3a2 2 0 1 1 2.75 1.855V5.5h4.426c.258 0 .494 0 .692.016.213.018.446.057.676.175.33.168.598.435.765.765.118.23.157.463.175.676.016.198.016.434.016.692v1.384a2.5 2.5 0 0 1 0 4.584v2.384c0 .258 0 .494-.016.692a1.775 1.775 0 0 1-.175.677 1.75 1.75 0 0 1-.765.764 1.77 1.77 0 0 1-.676.175c-.198.016-.434.016-.692.016H4.824c-.258 0-.494 0-.692-.016a1.775 1.775 0 0 1-.676-.175 1.75 1.75 0 0 1-.765-.765 1.774 1.774 0 0 1-.175-.676c-.016-.198-.016-.434-.016-.692v-2.384a2.5 2.5 0 0 1 0-4.584V7.824c0-.258 0-.494.016-.692a1.77 1.77 0 0 1 .175-.676 1.75 1.75 0 0 1 .765-.765 1.77 1.77 0 0 1 .676-.175c.198-.016.434-.016.692-.016H9.25v-.645A2 2 0 0 1 8 3ZM4 16.15c0 .292 0 .467.011.596a.626.626 0 0 0 .018.12.25.25 0 0 0 .104.105.638.638 0 0 0 .121.018c.13.01.304.011.596.011h10.3c.292 0 .467 0 .596-.011a.636.636 0 0 0 .12-.018.25.25 0 0 0 .105-.105.636.636 0 0 0 .018-.12c.01-.13.011-.304.011-.596v-8.3c0-.292 0-.467-.011-.596a.638.638 0 0 0-.018-.12.25.25 0 0 0-.104-.105.626.626 0 0 0-.121-.018A8.337 8.337 0 0 0 15.15 7H4.85c-.292 0-.467 0-.596.011a.628.628 0 0 0-.12.018.25.25 0 0 0-.105.104.628.628 0 0 0-.018.121c-.01.13-.011.304-.011.596v8.3Zm.03-9.02v.002-.001Zm.1-.1h.002-.001Zm11.74 0h-.002.001Zm.1.1v.002-.001Zm0 9.74v-.002.001Zm-.1.1h-.002.001Zm-11.74 0h.002-.001Zm-.1-.102v.001-.001ZM6 10.25a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75Zm6 0a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75Zm-5 4.5a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const vie = { render: rm }, mie = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: vie,
  render: rm
}, Symbol.toStringTag, { value: "Module" })), Cie = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function lm(e, t) {
  return f(), v("svg", Cie, [...t[0] || (t[0] = [
    g("g", { class: "scissors" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M4.75 2.5a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5ZM1 4.75a3.75 3.75 0 1 1 5.36 3.388l1.926 1.014L17.9 4.086a.75.75 0 1 1 .7 1.328L9.895 10l8.705 4.586a.75.75 0 1 1-.7 1.328l-9.614-5.066-1.925 1.014a3.75 3.75 0 1 1-3.19-.014L6.678 10 3.17 8.152A3.75 3.75 0 0 1 1 4.75ZM4.75 13a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const wie = { render: lm }, bie = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: wie,
  render: lm
}, Symbol.toStringTag, { value: "Module" })), yie = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function am(e, t) {
  return f(), v("svg", yie, [...t[0] || (t[0] = [
    g("g", { class: "search" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M8.5 2.5a6 6 0 1 0 0 12 6 6 0 0 0 0-12ZM1 8.5a7.5 7.5 0 1 1 13.307 4.746l4.473 4.474a.75.75 0 1 1-1.06 1.06l-4.473-4.473A7.5 7.5 0 0 1 1 8.5Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const _ie = { render: am }, Sie = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _ie,
  render: am
}, Symbol.toStringTag, { value: "Module" })), xie = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function cm(e, t) {
  return f(), v("svg", xie, [...t[0] || (t[0] = [
    g("g", { class: "settings" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M7.25 3.25A2.25 2.25 0 0 1 9.5 1h1a2.25 2.25 0 0 1 2.25 2.25v.11l.078-.078a2.25 2.25 0 0 1 3.182 0l.707.708a2.25 2.25 0 0 1 0 3.182l-.078.078h.111A2.25 2.25 0 0 1 19 9.5v1a2.25 2.25 0 0 1-2.25 2.25h-.11l.078.078a2.25 2.25 0 0 1 0 3.182l-.708.707a2.25 2.25 0 0 1-3.182 0l-.078-.078v.111A2.25 2.25 0 0 1 10.5 19h-1a2.25 2.25 0 0 1-2.25-2.25v-.111l-.078.079a2.25 2.25 0 0 1-3.182 0l-.708-.708a2.25 2.25 0 0 1 0-3.182l.079-.078H3.25A2.25 2.25 0 0 1 1 10.5v-1a2.25 2.25 0 0 1 2.25-2.25h.11l-.078-.078a2.25 2.25 0 0 1 0-3.182l.708-.708a2.25 2.25 0 0 1 3.182 0l.078.079V3.25ZM9.5 2.5a.75.75 0 0 0-.75.75v.714c0 1.114-1.346 1.672-2.134.884l-.505-.505a.75.75 0 0 0-1.06 0l-.708.707a.75.75 0 0 0 0 1.06l.505.506c.788.788.23 2.134-.884 2.134H3.25a.75.75 0 0 0-.75.75v1c0 .414.336.75.75.75h.714c1.114 0 1.672 1.346.884 2.134l-.505.505a.75.75 0 0 0 0 1.06l.707.708a.75.75 0 0 0 1.06 0l.506-.505c.788-.788 2.134-.23 2.134.883v.715c0 .414.336.75.75.75h1a.75.75 0 0 0 .75-.75v-.715c0-1.113 1.346-1.67 2.134-.883l.505.505a.75.75 0 0 0 1.06 0l.708-.707a.75.75 0 0 0 0-1.06l-.505-.506c-.788-.788-.23-2.134.883-2.134h.715a.75.75 0 0 0 .75-.75v-1a.75.75 0 0 0-.75-.75h-.715c-1.113 0-1.67-1.346-.883-2.134l.505-.505a.75.75 0 0 0 0-1.06l-.707-.708a.75.75 0 0 0-1.06 0l-.506.505c-.788.788-2.134.23-2.134-.884V3.25a.75.75 0 0 0-.75-.75h-1ZM10 8a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-3.5 2a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Mie = { render: cm }, Aie = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Mie,
  render: cm
}, Symbol.toStringTag, { value: "Module" })), Lie = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function dm(e, t) {
  return f(), v("svg", Lie, [...t[0] || (t[0] = [
    g("g", { class: "share" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M16 2.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM13 4a3 3 0 1 1 .737 1.97l-6.803 3.4a3.012 3.012 0 0 1 0 1.258l6.803 3.401a3 3 0 1 1-.671 1.341l-6.803-3.4a3 3 0 1 1 0-3.94l6.803-3.402A3.012 3.012 0 0 1 13 4ZM4 8.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm12 6a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Eie = { render: dm }, Pie = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Eie,
  render: dm
}, Symbol.toStringTag, { value: "Module" })), Rie = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function um(e, t) {
  return f(), v("svg", Rie, [...t[0] || (t[0] = [
    g("g", { class: "shield" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10.246 2.526a1.195 1.195 0 0 0-.492 0c-.157.033-.322.116-.93.461L3.947 5.755c-.158.09-.248.141-.313.184a.401.401 0 0 0-.06.044.285.285 0 0 0-.06.103c-.005.02-.014.054-.014.458v3.144c0 2.309 1.16 4.444 3.052 5.653l3.008 1.92c.16.103.253.161.324.2a.467.467 0 0 0 .067.034.223.223 0 0 0 .098 0 .512.512 0 0 0 .067-.033 6.84 6.84 0 0 0 .324-.2l3.008-1.921c1.892-1.208 3.052-3.344 3.052-5.653V6.544c0-.404-.009-.439-.015-.458a.286.286 0 0 0-.059-.103.486.486 0 0 0-.06-.044 6.707 6.707 0 0 0-.313-.184l-4.877-2.768c-.608-.345-.773-.428-.93-.461Zm-.199 14.97.002-.001h-.002Zm-.094 0-.002-.001h.002ZM9.445 1.057a2.696 2.696 0 0 1 1.11 0c.416.087.795.303 1.275.576l.086.049 4.877 2.768.06.034c.24.135.494.279.689.495.168.187.294.408.371.646.088.274.088.567.087.849v3.214c0 2.808-1.41 5.426-3.745 6.917l-3.008 1.92-.061.04c-.242.155-.502.322-.796.39-.257.06-.523.06-.78 0-.295-.068-.555-.235-.796-.39l-.061-.04-3.008-1.92C3.41 15.115 2 12.496 2 9.688V6.475c0-.282-.001-.575.087-.849.077-.238.203-.46.371-.646.195-.216.45-.36.69-.495l.059-.034 4.877-2.768.086-.049c.48-.273.86-.489 1.275-.576Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Fie = { render: um }, Tie = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Fie,
  render: um
}, Symbol.toStringTag, { value: "Module" })), Iie = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function hm(e, t) {
  return f(), v("svg", Iie, [...t[0] || (t[0] = [
    g("g", { class: "shirt" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M7.77 3.05c.208.08.37.25.442.463.101.305.223.517.426.668.204.154.59.319 1.362.319.772 0 1.158-.165 1.363-.319.202-.151.324-.363.426-.668a.75.75 0 0 1 1.08-.416l5.75 3.25c.355.2.485.65.291 1.009l-1.75 3.25a.75.75 0 0 1-1.076.268L15 10.151v7.099a.75.75 0 0 1-.75.75h-8.5a.75.75 0 0 1-.75-.75v-7.099l-1.084.723a.75.75 0 0 1-1.076-.268l-1.75-3.25a.75.75 0 0 1 .291-1.009l5.75-3.25a.75.75 0 0 1 .638-.047ZM2.758 7.291l1.01 1.878 1.565-1.043A.75.75 0 0 1 6.5 8.75v7.75h7V8.75a.75.75 0 0 1 1.166-.624l1.564 1.043 1.011-1.878-4.418-2.497c-.142.208-.324.41-.56.587C11.716 5.791 10.977 6 10 6s-1.717-.21-2.262-.619a2.473 2.473 0 0 1-.561-.587L2.759 7.291Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Die = { render: hm }, kie = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Die,
  render: hm
}, Symbol.toStringTag, { value: "Module" })), Hie = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function gm(e, t) {
  return f(), v("svg", Hie, [...t[0] || (t[0] = [
    g("g", { class: "shopping-basket" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M8.618 3.096a.75.75 0 0 1 .286 1.022L7.282 7h5.436l-1.622-2.882a.75.75 0 0 1 1.308-.736L14.439 7h3.811a.75.75 0 0 1 .72.962l-2.5 8.5a.75.75 0 0 1-.72.538H4.25a.75.75 0 0 1-.72-.538l-2.5-8.5A.75.75 0 0 1 1.75 7h3.811l2.035-3.618a.75.75 0 0 1 1.022-.286ZM5.985 8.5H2.752l2.06 7h10.377l2.059-7H5.985ZM6.75 10a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0v-2.5a.75.75 0 0 1 .75-.75ZM10 10a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0v-2.5A.75.75 0 0 1 10 10Zm3.25 0a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0v-2.5a.75.75 0 0 1 .75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Vie = { render: gm }, Oie = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Vie,
  render: gm
}, Symbol.toStringTag, { value: "Module" })), Bie = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function pm(e, t) {
  return f(), v("svg", Bie, [...t[0] || (t[0] = [
    g("g", { class: "shopping-cart" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M9.92 1h.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 13.7 2.502c.172.337.24.693.27 1.073.011.132.018.275.022.428.211.004.403.01.575.024.36.029.696.09 1.02.246.498.24.912.624 1.188 1.103.18.311.265.643.32.999.053.34.084.757.12 1.254l.53 7.16c.043.57.078 1.045.074 1.433-.004.403-.049.784-.211 1.148a2.75 2.75 0 0 1-1.21 1.302c-.35.189-.727.262-1.129.296-.386.032-.861.032-1.433.032H6.164c-.572 0-1.047 0-1.433-.032-.402-.034-.779-.107-1.13-.296a2.75 2.75 0 0 1-1.209-1.302c-.162-.364-.207-.745-.211-1.148-.004-.388.031-.862.073-1.432l.53-7.16c.038-.498.068-.915.12-1.255.056-.356.142-.688.32-.999a2.75 2.75 0 0 1 1.19-1.103c.323-.156.66-.217 1.019-.246.172-.014.364-.02.575-.024a7.58 7.58 0 0 1 .022-.428c.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 7.502 1.3c.337-.172.693-.24 1.073-.27C8.94 1 9.385 1 9.92 1ZM6 5.504V7.25a.75.75 0 0 0 1.5 0V5.5h5v1.75a.75.75 0 0 0 1.5 0V5.504c.174.003.32.008.449.018.268.022.398.06.486.102.227.11.415.284.54.502.05.084.097.212.138.477.042.275.069.632.109 1.166l.525 7.1c.046.61.076 1.02.072 1.338-.003.309-.038.456-.081.552a1.25 1.25 0 0 1-.55.592c-.092.05-.236.096-.544.122-.316.026-.728.027-1.34.027H6.196c-.612 0-1.024 0-1.34-.027-.308-.026-.452-.072-.544-.122a1.25 1.25 0 0 1-.55-.592c-.043-.096-.078-.243-.081-.552-.003-.317.026-.728.072-1.338l.525-7.1c.04-.534.067-.891.11-1.166.04-.265.088-.393.136-.477a1.25 1.25 0 0 1 .54-.502c.089-.043.22-.08.487-.102A7.42 7.42 0 0 1 6 5.504ZM12.492 4H7.508a6.24 6.24 0 0 1 .017-.303c.023-.287.065-.424.111-.514a1.25 1.25 0 0 1 .547-.547c.09-.046.227-.088.514-.111.296-.024.68-.025 1.253-.025h.1c.572 0 .957 0 1.252.025.288.023.425.065.516.111.235.12.426.311.546.547.046.09.088.227.111.514.008.092.013.192.017.303Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const $ie = { render: pm }, Zie = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: $ie,
  render: pm
}, Symbol.toStringTag, { value: "Module" })), Gie = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function fm(e, t) {
  return f(), v("svg", Gie, [...t[0] || (t[0] = [
    g("g", { class: "sidebar-hide" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M1 5.75A2.75 2.75 0 0 1 3.75 3h12.5A2.75 2.75 0 0 1 19 5.75v8.5A2.75 2.75 0 0 1 16.25 17H3.75A2.75 2.75 0 0 1 1 14.25v-8.5Zm5.5 9.75h9.75c.69 0 1.25-.56 1.25-1.25v-8.5c0-.69-.56-1.25-1.25-1.25H6.5v11ZM5 4.5v11H3.75c-.69 0-1.25-.56-1.25-1.25v-8.5c0-.69.56-1.25 1.25-1.25H5Zm6.748 2.69a.75.75 0 0 1 .063 1.058l-.89 1.002h3.829a.75.75 0 0 1 0 1.5h-3.83l.89 1.002a.75.75 0 0 1-1.12.996l-2-2.25a.75.75 0 0 1 0-.996l2-2.25a.75.75 0 0 1 1.058-.063Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Nie = { render: fm }, zie = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Nie,
  render: fm
}, Symbol.toStringTag, { value: "Module" })), jie = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function vm(e, t) {
  return f(), v("svg", jie, [...t[0] || (t[0] = [
    g("g", { class: "sidebar-show" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M1 5.75A2.75 2.75 0 0 1 3.75 3h12.5A2.75 2.75 0 0 1 19 5.75v8.5A2.75 2.75 0 0 1 16.25 17H3.75A2.75 2.75 0 0 1 1 14.25v-8.5Zm5.5 9.75h9.75c.69 0 1.25-.56 1.25-1.25v-8.5c0-.69-.56-1.25-1.25-1.25H6.5v11ZM5 4.5v11H3.75c-.69 0-1.25-.56-1.25-1.25v-8.5c0-.69.56-1.25 1.25-1.25H5Zm7.252 2.69a.75.75 0 0 1 1.059.062l2 2.25a.75.75 0 0 1 0 .996l-2 2.25a.75.75 0 0 1-1.122-.996l.89-1.002H9.25a.75.75 0 0 1 0-1.5h3.83l-.89-1.002a.75.75 0 0 1 .062-1.059Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Wie = { render: vm }, Uie = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Wie,
  render: vm
}, Symbol.toStringTag, { value: "Module" })), Kie = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function mm(e, t) {
  return f(), v("svg", Kie, [...t[0] || (t[0] = [
    g("g", { class: "slider" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M16.25 2.5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Zm-2.646.5a2.751 2.751 0 1 1 0 1.5H1.75a.75.75 0 0 1 0-1.5h11.854ZM6 8.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Zm-2.646.5a2.751 2.751 0 0 1 5.292 0h9.604a.75.75 0 0 1 0 1.5H8.646a2.751 2.751 0 0 1-5.292 0H1.75a.75.75 0 0 1 0-1.5h1.604ZM11.75 15a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Zm-2.646.5a2.751 2.751 0 0 1 5.293 0h3.853a.75.75 0 0 1 0 1.5h-3.854a2.751 2.751 0 0 1-5.292 0H1.75a.75.75 0 0 1 0-1.5h7.354Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const qie = { render: mm }, Yie = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: qie,
  render: mm
}, Symbol.toStringTag, { value: "Module" })), Qie = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Cm(e, t) {
  return f(), v("svg", Qie, [...t[0] || (t[0] = [
    g("g", { class: "speedmeter" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10 2.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15ZM1 10a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm9-4.5A4.5 4.5 0 0 0 5.5 10 .75.75 0 0 1 4 10a6 6 0 0 1 6-6 .75.75 0 0 1 0 1.5Zm4.78-.28a.75.75 0 0 1 0 1.06l-2.938 2.94a2 2 0 1 1-1.06-1.06l2.938-2.94a.75.75 0 0 1 1.06 0ZM10 9.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Jie = { render: Cm }, Xie = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Jie,
  render: Cm
}, Symbol.toStringTag, { value: "Module" })), ere = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function wm(e, t) {
  return f(), v("svg", ere, [...t[0] || (t[0] = [
    g("g", { class: "star-filled" }, [
      g("path", {
        d: "M8.437 2.005c.414-.877 1.46-1.27 2.343-.815.346.178.619.467.783.815l1.785 3.78a.242.242 0 0 0 .177.143l3.993.606c.973.148 1.595 1.073 1.465 2.013-.053.38-.225.737-.496 1.013l-2.889 2.942a.31.31 0 0 0-.079.264l.721 4.157c.16.979-.525 1.884-1.452 2.05a1.7 1.7 0 0 1-1.12-.184l-3.57-1.962a.2.2 0 0 0-.196 0l-3.57 1.962c-.872.478-1.928.113-2.364-.753a1.822 1.822 0 0 1-.17-1.113l.682-4.155a.31.31 0 0 0-.078-.266L1.512 9.56a1.814 1.814 0 0 1-.03-2.495 1.722 1.722 0 0 1 1-.531l3.992-.606a.242.242 0 0 0 .178-.143l1.785-3.78Z",
        class: "Icon"
      })
    ], -1)
  ])]);
}
const tre = { render: wm }, ore = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: tre,
  render: wm
}, Symbol.toStringTag, { value: "Module" })), nre = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function bm(e, t) {
  return f(), v("svg", nre, [...t[0] || (t[0] = [
    g("g", { class: "star-half-filled" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M8.437 2.005c.414-.877 1.46-1.27 2.343-.815.346.178.619.467.783.815l1.785 3.78a.242.242 0 0 0 .177.143l3.993.606c.973.148 1.595 1.073 1.465 2.013-.053.38-.225.737-.496 1.013l-2.889 2.942a.31.31 0 0 0-.079.264l.721 4.157c.16.98-.525 1.884-1.452 2.05a1.7 1.7 0 0 1-1.12-.184l-3.57-1.962a.199.199 0 0 0-.196 0l-3.57 1.962c-.872.478-1.928.113-2.364-.753a1.822 1.822 0 0 1-.17-1.113l.682-4.155a.31.31 0 0 0-.078-.266L1.512 9.56a1.814 1.814 0 0 1-.03-2.495 1.722 1.722 0 0 1 1-.53l3.992-.607a.242.242 0 0 0 .178-.143l1.785-3.78Zm1.656.518c-.094-.048-.231-.023-.3.122l-.003.008C9 8.003 9 13.001 14.39 17.474a.2.2 0 0 0 .133.023.296.296 0 0 0 .183-.122.28.28 0 0 0 .054-.207l-.72-4.157a1.81 1.81 0 0 1 .488-1.56l2.889-2.942c.04-.041.07-.1.08-.168.026-.186-.1-.308-.204-.324L13.3 7.411a1.74 1.74 0 0 1-1.308-.985l-1.786-3.78a.26.26 0 0 0-.113-.123Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const sre = { render: bm }, ire = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sre,
  render: bm
}, Symbol.toStringTag, { value: "Module" })), rre = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function ym(e, t) {
  return f(), v("svg", rre, [...t[0] || (t[0] = [
    g("g", { class: "star" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10.093 2.523c-.094-.048-.231-.023-.3.122l-1.785 3.78a1.74 1.74 0 0 1-1.308.986l-3.993.606a.223.223 0 0 0-.128.07.315.315 0 0 0 .004.422l2.889 2.942c.404.412.581.995.489 1.56l-.682 4.155a.322.322 0 0 0 .029.195c.07.142.207.165.301.113l3.57-1.962a1.699 1.699 0 0 1 1.641 0l3.57 1.962a.2.2 0 0 0 .133.023.296.296 0 0 0 .183-.122.28.28 0 0 0 .054-.207l-.72-4.157a1.81 1.81 0 0 1 .488-1.56l2.889-2.942c.04-.041.07-.1.08-.168.026-.186-.1-.308-.204-.324L13.3 7.411a1.74 1.74 0 0 1-1.308-.985l-1.786-3.78a.26.26 0 0 0-.113-.123Zm-1.656-.518c.414-.877 1.46-1.27 2.343-.815.346.178.619.467.783.815l1.785 3.78a.242.242 0 0 0 .177.143l3.993.606c.973.148 1.595 1.073 1.465 2.013-.053.38-.225.737-.496 1.013l-2.889 2.942a.31.31 0 0 0-.079.264l.721 4.157c.16.98-.525 1.884-1.452 2.05a1.7 1.7 0 0 1-1.12-.184l-3.57-1.962a.199.199 0 0 0-.196 0l-3.57 1.962c-.872.478-1.928.113-2.364-.753a1.822 1.822 0 0 1-.17-1.113l.682-4.155a.31.31 0 0 0-.078-.266L1.512 9.56a1.814 1.814 0 0 1-.03-2.495 1.722 1.722 0 0 1 1-.53l3.992-.607a.242.242 0 0 0 .178-.143l1.785-3.78Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const lre = { render: ym }, are = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: lre,
  render: ym
}, Symbol.toStringTag, { value: "Module" })), cre = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function _m(e, t) {
  return f(), v("svg", cre, [...t[0] || (t[0] = [
    g("g", { class: "stopwatch" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M7 1.75A.75.75 0 0 1 7.75 1h4.5a.75.75 0 0 1 0 1.5h-1.5v.535a8 8 0 1 1-1.5 0V2.5h-1.5A.75.75 0 0 1 7 1.75Zm-2.22.47a.75.75 0 0 1 0 1.06l-2.5 2.5a.75.75 0 1 1-1.06-1.06l2.5-2.5a.75.75 0 0 1 1.06 0Zm10.44 0a.75.75 0 0 1 1.06 0l2.5 2.5a.75.75 0 0 1-1.06 1.06l-2.5-2.5a.75.75 0 0 1 0-1.06ZM10 4.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13ZM9.75 6a.75.75 0 0 1 .75.75v3.75h1.75a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75v-4.5A.75.75 0 0 1 9.75 6Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const dre = { render: _m }, ure = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: dre,
  render: _m
}, Symbol.toStringTag, { value: "Module" })), hre = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Sm(e, t) {
  return f(), v("svg", hre, [...t[0] || (t[0] = [
    g("g", { class: "suitcase" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M8.324 2h3.352c.258 0 .494 0 .692.016.213.018.446.057.676.175.33.168.598.435.765.765.118.23.158.463.175.676.016.198.016.434.016.692V5h2.676c.258 0 .494 0 .692.016.213.018.446.057.677.175.329.168.596.435.764.765.118.23.157.463.175.676.016.198.016.434.016.692v4.352c0 .258 0 .494-.016.692a1.775 1.775 0 0 1-.175.676 1.75 1.75 0 0 1-.809.787v1.845c0 .258 0 .494-.016.692a1.775 1.775 0 0 1-.175.677 1.75 1.75 0 0 1-.765.764 1.77 1.77 0 0 1-.676.175c-.198.016-.434.016-.692.016H4.324c-.258 0-.494 0-.692-.016a1.775 1.775 0 0 1-.676-.175 1.75 1.75 0 0 1-.765-.765 1.774 1.774 0 0 1-.175-.676C2 16.17 2 15.934 2 15.676v-1.845a1.75 1.75 0 0 1-.81-.787 1.774 1.774 0 0 1-.174-.676C1 12.17 1 11.934 1 11.676V7.324c0-.258 0-.494.016-.692a1.77 1.77 0 0 1 .175-.676 1.75 1.75 0 0 1 .765-.765 1.77 1.77 0 0 1 .676-.175C2.83 5 3.066 5 3.324 5H6v-.676c0-.258 0-.494.016-.692a1.77 1.77 0 0 1 .175-.676 1.75 1.75 0 0 1 .765-.765 1.77 1.77 0 0 1 .676-.175C7.83 2 8.066 2 8.324 2ZM3.35 6.5c-.292 0-.467 0-.596.011a.626.626 0 0 0-.12.018.25.25 0 0 0-.105.104.628.628 0 0 0-.018.121c-.01.13-.011.304-.011.596v4.3c0 .292 0 .467.011.596a.626.626 0 0 0 .018.12.25.25 0 0 0 .104.105.638.638 0 0 0 .156.02l.015.001c.124.008.29.008.546.008H7v-.75a.75.75 0 0 1 1.5 0v.75h3v-.75a.75.75 0 0 1 1.5 0v.75h3.65c.257 0 .422 0 .546-.008h.015l.035-.003a.636.636 0 0 0 .12-.018.25.25 0 0 0 .105-.104.636.636 0 0 0 .018-.121c.01-.13.011-.304.011-.596v-4.3c0-.292 0-.467-.011-.596a.638.638 0 0 0-.018-.12.25.25 0 0 0-.105-.105.625.625 0 0 0-.12-.018 8.336 8.336 0 0 0-.596-.011H3.35ZM12.5 5h-5v-.65c0-.292 0-.467.011-.596a.628.628 0 0 1 .018-.12.25.25 0 0 1 .104-.105.626.626 0 0 1 .121-.018c.13-.01.304-.011.596-.011h3.3c.292 0 .467 0 .596.011a.625.625 0 0 1 .12.018.25.25 0 0 1 .105.104.638.638 0 0 1 .018.121c.01.13.011.304.011.596V5Zm-.03-1.37v.002-.001Zm-.1-.1h-.002.001Zm-4.74 0h.002-.001Zm-.1.102v-.001.001Zm9.84 2.898h-.002.001Zm.1.1v.002-.001Zm0 5.74v-.002.001Zm-.1.1h-.002.001ZM16.5 14H13v.25a.75.75 0 0 1-1.5 0V14h-3v.25a.75.75 0 0 1-1.5 0V14H3.5v1.65c0 .292 0 .467.011.596a.626.626 0 0 0 .018.12.25.25 0 0 0 .104.105.638.638 0 0 0 .121.018c.13.01.304.011.596.011h11.3c.292 0 .467 0 .596-.011a.636.636 0 0 0 .12-.018.25.25 0 0 0 .105-.105.636.636 0 0 0 .018-.12c.01-.13.011-.304.011-.596V14Zm-.03 2.37v-.002.001Zm-.1.1h-.002.001Zm-12.74 0h.002-.001Zm-.1-.102v.001-.001Zm-.9-3.898h.002-.001Zm-.1-.102v.001-.001Zm0-5.736a.01.01 0 0 1 0-.001v.001Zm.102-.103h-.001.001Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const gre = { render: Sm }, pre = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: gre,
  render: Sm
}, Symbol.toStringTag, { value: "Module" })), fre = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function xm(e, t) {
  return f(), v("svg", fre, [...t[0] || (t[0] = [
    g("g", { class: "sun" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10 2a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0v-1.5A.75.75 0 0 1 10 2ZM4.22 4.22a.75.75 0 0 1 1.06 0l1 1a.75.75 0 0 1-1.06 1.06l-1-1a.75.75 0 0 1 0-1.06Zm11.56 0a.75.75 0 0 1 0 1.06l-1 1a.75.75 0 1 1-1.06-1.06l1-1a.75.75 0 0 1 1.06 0ZM6 10c0-2.214 1.786-4 4-4s4 1.786 4 4-1.786 4-4 4-4-1.786-4-4Zm4-2.5A2.494 2.494 0 0 0 7.5 10c0 1.386 1.114 2.5 2.5 2.5s2.5-1.114 2.5-2.5-1.114-2.5-2.5-2.5ZM2 10a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5A.75.75 0 0 1 2 10Zm13 0a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5A.75.75 0 0 1 15 10Zm-8.72 3.72a.75.75 0 0 1 0 1.06l-1 1a.75.75 0 0 1-1.06-1.06l1-1a.75.75 0 0 1 1.06 0Zm7.44 0a.75.75 0 0 1 1.06 0l1 1a.75.75 0 1 1-1.06 1.06l-1-1a.75.75 0 0 1 0-1.06ZM10 15a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0v-1.5A.75.75 0 0 1 10 15Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const vre = { render: xm }, mre = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: vre,
  render: xm
}, Symbol.toStringTag, { value: "Module" })), Cre = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Mm(e, t) {
  return f(), v("svg", Cre, [...t[0] || (t[0] = [
    g("g", { class: "tablet" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M1 5.75A2.75 2.75 0 0 1 3.75 3h12.5A2.75 2.75 0 0 1 19 5.75v8.5A2.75 2.75 0 0 1 16.25 17H3.75A2.75 2.75 0 0 1 1 14.25v-8.5ZM3.75 4.5c-.69 0-1.25.56-1.25 1.25v8.5c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25v-8.5c0-.69-.56-1.25-1.25-1.25H3.75ZM9 13.25a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const wre = { render: Mm }, bre = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: wre,
  render: Mm
}, Symbol.toStringTag, { value: "Module" })), yre = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Am(e, t) {
  return f(), v("svg", yre, [...t[0] || (t[0] = [
    g("g", { class: "tag" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M1 3.856A2.856 2.856 0 0 1 3.856 1H9.3c.757 0 1.483.3 2.019.836l6.844 6.844a2.856 2.856 0 0 1 0 4.039l-5.445 5.445a2.856 2.856 0 0 1-4.039 0L1.836 11.32A2.856 2.856 0 0 1 1 9.3V3.857ZM3.856 2.5c-.749 0-1.356.607-1.356 1.356V9.3c0 .36.143.704.397.958l6.844 6.844c.53.53 1.388.53 1.917 0l5.445-5.445c.53-.53.53-1.388 0-1.917l-6.844-6.844a1.356 1.356 0 0 0-.958-.397H3.856ZM6.5 6a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1Zm-2 .5a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const _re = { render: Am }, Sre = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _re,
  render: Am
}, Symbol.toStringTag, { value: "Module" })), xre = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Lm(e, t) {
  return f(), v("svg", xre, [...t[0] || (t[0] = [
    g("g", { class: "target-off" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10 1a.75.75 0 0 1 .75.75v1.29a7.003 7.003 0 0 1 6.21 6.21h1.29a.75.75 0 0 1 0 1.5h-1.29a7.003 7.003 0 0 1-6.21 6.21v1.29a.75.75 0 0 1-1.5 0v-1.29a7.003 7.003 0 0 1-6.21-6.21H1.75a.75.75 0 0 1 0-1.5h1.29a7.003 7.003 0 0 1 6.21-6.21V1.75A.75.75 0 0 1 10 1Zm0 3.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Mre = { render: Lm }, Are = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Mre,
  render: Lm
}, Symbol.toStringTag, { value: "Module" })), Lre = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Em(e, t) {
  return f(), v("svg", Lre, [...t[0] || (t[0] = [
    g("g", { class: "target" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10 1a.75.75 0 0 1 .75.75v1.29a7.003 7.003 0 0 1 6.21 6.21h1.29a.75.75 0 0 1 0 1.5h-1.29a7.003 7.003 0 0 1-6.21 6.21v1.29a.75.75 0 0 1-1.5 0v-1.29a7.003 7.003 0 0 1-6.21-6.21H1.75a.75.75 0 0 1 0-1.5h1.29a7.003 7.003 0 0 1 6.21-6.21V1.75A.75.75 0 0 1 10 1Zm0 3.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11Zm0 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM7 10a3 3 0 1 1 6 0 3 3 0 0 1-6 0Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Ere = { render: Em }, Pre = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ere,
  render: Em
}, Symbol.toStringTag, { value: "Module" })), Rre = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Pm(e, t) {
  return f(), v("svg", Rre, [...t[0] || (t[0] = [
    g("g", { class: "terminal-2" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M4.92 1h10.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 18.7 2.502c.172.337.24.693.27 1.073.03.365.03.81.03 1.345v10.16c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073a2.751 2.751 0 0 1-1.2 1.202c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03H4.92c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 1.3 17.5c-.172-.338-.24-.694-.27-1.074C1 16.06 1 15.615 1 15.08V4.92c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 2.502 1.3c.337-.172.693-.24 1.073-.27C3.94 1 4.385 1 4.92 1ZM3.697 2.525c-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.547c-.046.09-.088.227-.111.514-.024.296-.025.68-.025 1.253v10.1c0 .572 0 .957.025 1.252.023.288.065.425.111.515.12.236.311.427.547.547.09.046.227.088.514.111.296.024.68.025 1.253.025h10.1c.572 0 .957 0 1.252-.025.288-.023.425-.065.515-.111a1.25 1.25 0 0 0 .547-.547c.046-.09.088-.227.111-.515.024-.295.025-.68.025-1.252V4.95c0-.572 0-.957-.025-1.253-.023-.287-.065-.424-.111-.514a1.25 1.25 0 0 0-.547-.547c-.09-.046-.227-.088-.515-.111-.295-.024-.68-.025-1.252-.025H4.95c-.572 0-.957 0-1.253.025ZM5.2 7.24a.75.75 0 0 1 1.06-.04l3.5 3.25a.75.75 0 0 1 0 1.1l-3.5 3.25a.75.75 0 0 1-1.02-1.1L8.148 11 5.24 8.3a.75.75 0 0 1-.04-1.06ZM10 15a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5A.75.75 0 0 1 10 15Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Fre = { render: Pm }, Tre = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Fre,
  render: Pm
}, Symbol.toStringTag, { value: "Module" })), Ire = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Rm(e, t) {
  return f(), v("svg", Ire, [...t[0] || (t[0] = [
    g("g", { class: "terminal" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M4.92 1h10.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 18.7 2.502c.172.337.24.693.27 1.073.03.365.03.81.03 1.345v10.16c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073a2.751 2.751 0 0 1-1.2 1.202c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03H4.92c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 1.3 17.5c-.172-.338-.24-.694-.27-1.074C1 16.06 1 15.615 1 15.08V4.92c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 2.502 1.3c.337-.172.693-.24 1.073-.27C3.94 1 4.385 1 4.92 1ZM3.697 2.525c-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.547c-.046.09-.088.227-.111.514-.024.296-.025.68-.025 1.253v10.1c0 .572 0 .957.025 1.252.023.288.065.425.111.515.12.236.311.427.547.547.09.046.227.088.514.111.296.024.68.025 1.253.025h10.1c.572 0 .957 0 1.252-.025.288-.023.425-.065.515-.111a1.25 1.25 0 0 0 .547-.547c.046-.09.088-.227.111-.515.024-.295.025-.68.025-1.252V4.95c0-.572 0-.957-.025-1.253-.023-.287-.065-.424-.111-.514a1.25 1.25 0 0 0-.547-.547c-.09-.046-.227-.088-.515-.111-.295-.024-.68-.025-1.252-.025H4.95c-.572 0-.957 0-1.253.025ZM5.2 7.24a.75.75 0 0 1 1.06-.04l3.5 3.25a.75.75 0 0 1 0 1.1l-3.5 3.25a.75.75 0 0 1-1.02-1.1L8.148 11 5.24 8.3a.75.75 0 0 1-.04-1.06Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Dre = { render: Rm }, kre = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Dre,
  render: Rm
}, Symbol.toStringTag, { value: "Module" })), Hre = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Fm(e, t) {
  return f(), v("svg", Hre, [...t[0] || (t[0] = [
    g("g", { class: "tetrisly" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M2.137 1h2.226c.058 0 .139 0 .212.006.088.007.229.027.379.103a1 1 0 0 1 .437.437c.076.15.096.29.103.379.006.073.006.154.006.212v2.226c0 .058 0 .139-.006.212a1.003 1.003 0 0 1-.103.379 1 1 0 0 1-.437.437c-.15.076-.29.096-.379.103-.073.006-.154.006-.212.006H2.137c-.058 0-.139 0-.212-.006a1.003 1.003 0 0 1-.379-.103 1 1 0 0 1-.437-.437 1.003 1.003 0 0 1-.103-.379A2.673 2.673 0 0 1 1 4.363V2.137c0-.058 0-.139.006-.212.007-.088.027-.229.103-.379a1 1 0 0 1 .437-.437c.15-.076.29-.096.379-.103C1.998 1 2.079 1 2.137 1ZM2.5 2.5V4H4V2.5H2.5ZM8.887 1h8.976c.058 0 .139 0 .212.006.088.007.229.027.379.103a1 1 0 0 1 .437.437c.077.15.096.29.103.379.006.073.006.154.006.212v2.226c0 .058 0 .139-.006.212a1.003 1.003 0 0 1-.103.379 1 1 0 0 1-.437.437.986.986 0 0 1-.379.103c-.073.006-.154.006-.212.006H12.25v5.613c0 .058 0 .139-.006.212a1.003 1.003 0 0 1-.103.379 1 1 0 0 1-.437.437c-.15.076-.29.096-.379.103a2.648 2.648 0 0 1-.212.006H8.887c-.058 0-.139 0-.212-.006a1.003 1.003 0 0 1-.379-.103 1 1 0 0 1-.437-.437 1.003 1.003 0 0 1-.103-.379c-.006-.073-.006-.154-.006-.212V2.137c0-.058 0-.139.006-.212.007-.088.027-.229.103-.379a1 1 0 0 1 .437-.437c.15-.076.29-.096.379-.103C8.748 1 8.829 1 8.887 1Zm.363 1.5v8.25h1.5V5.137c0-.058 0-.139.006-.212.007-.088.027-.229.103-.379a1 1 0 0 1 .437-.437c.15-.076.29-.096.379-.103.073-.006.154-.006.212-.006H17.5V2.5H9.25Zm-.363 12h2.226c.058 0 .139 0 .212.006.088.007.229.027.379.103a1 1 0 0 1 .437.437c.076.15.096.29.103.379.006.073.006.154.006.212v2.226c0 .058 0 .139-.006.212a1.003 1.003 0 0 1-.103.379 1 1 0 0 1-.437.437.986.986 0 0 1-.379.103 2.648 2.648 0 0 1-.212.006H8.887c-.058 0-.139 0-.212-.006a1.003 1.003 0 0 1-.379-.103 1 1 0 0 1-.437-.437 1.003 1.003 0 0 1-.103-.379c-.006-.073-.006-.154-.006-.212v-2.226c0-.058 0-.139.006-.212.007-.088.027-.229.103-.379a1 1 0 0 1 .437-.437c.15-.076.29-.096.379-.103.073-.006.154-.006.212-.006ZM9.25 16v1.5h1.5V16h-1.5Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Vre = { render: Fm }, Ore = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Vre,
  render: Fm
}, Symbol.toStringTag, { value: "Module" })), Bre = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Tm(e, t) {
  return f(), v("svg", Bre, [...t[0] || (t[0] = [
    g("g", { class: "text" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M2 2.75C2 1.784 2.784 1 3.75 1h12.5c.966 0 1.75.784 1.75 1.75v2a.75.75 0 0 1-1.5 0v-2a.25.25 0 0 0-.25-.25h-5.5v15h2.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1 0-1.5h2.5v-15h-5.5a.25.25 0 0 0-.25.25v2a.75.75 0 0 1-1.5 0v-2Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const $re = { render: Tm }, Zre = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: $re,
  render: Tm
}, Symbol.toStringTag, { value: "Module" })), Gre = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Im(e, t) {
  return f(), v("svg", Gre, [...t[0] || (t[0] = [
    g("g", { class: "thumb-down" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M6.358 1h8.722c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 18.7 2.502c.172.337.24.693.27 1.073.03.365.03.81.03 1.345v3.16c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073a2.751 2.751 0 0 1-1.2 1.202c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03h-.873c-.227 0-.358 0-.457.007a.545.545 0 0 0-.091.012.25.25 0 0 0-.1.075.528.528 0 0 0-.037.086c-.034.092-.07.218-.132.437l-1.462 5.115c-.214.75-.9 1.268-1.681 1.268A2.747 2.747 0 0 1 7.5 16.253V13.85c0-.292 0-.467-.011-.596a.627.627 0 0 0-.018-.12.25.25 0 0 0-.104-.105.638.638 0 0 0-.121-.018A8.375 8.375 0 0 0 6.65 13H5.285c-.69 0-1.257 0-1.71-.04-.466-.042-.903-.132-1.29-.372A2.765 2.765 0 0 1 1.078 11c-.125-.444-.086-.893.005-1.35.083-.417.227-.922.4-1.527l.046-.159 1.17-4.1.034-.12c.202-.71.36-1.266.697-1.694.291-.37.67-.664 1.116-.847C5.05 1 5.623 1 6.358 1Zm1.011 12.03h-.001.001Zm.101.1v.002-.001Zm6.09-1.037-.001.002v-.002Zm.097-.073h.002-.002ZM6.49 2.5c-.932 0-1.182.014-1.376.093a1.23 1.23 0 0 0-.504.385c-.13.165-.213.404-.469 1.299l-1.17 4.1-.037.13c-.183.638-.31 1.084-.38 1.437-.074.371-.062.543-.032.647.082.292.281.553.553.722.097.06.26.12.633.152.378.034.878.035 1.612.035h1.356c.258 0 .494 0 .692.016.213.018.446.057.676.175.33.167.597.435.765.764.118.23.157.464.175.677.016.198.016.434.016.692v2.43c0 .688.558 1.246 1.247 1.246a.25.25 0 0 0 .239-.18l1.461-5.116.024-.083c.093-.328.191-.678.407-.952.188-.239.434-.424.715-.54.13-.053.268-.084.407-.103V2.5H6.49Zm8.51 0v8h.05c.572 0 .957 0 1.252-.025.288-.023.425-.065.515-.111a1.25 1.25 0 0 0 .547-.546c.046-.091.088-.228.111-.515.024-.296.025-.68.025-1.253v-3.1c0-.572 0-.957-.025-1.253-.023-.287-.065-.424-.111-.514a1.25 1.25 0 0 0-.547-.547c-.09-.046-.227-.088-.515-.111-.295-.024-.68-.025-1.252-.025H15Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Nre = { render: Im }, zre = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Nre,
  render: Im
}, Symbol.toStringTag, { value: "Module" })), jre = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Dm(e, t) {
  return f(), v("svg", jre, [...t[0] || (t[0] = [
    g("g", { class: "thumb-up" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M8.07 2.268A1.75 1.75 0 0 1 9.752 1a2.747 2.747 0 0 1 2.746 2.747V6.15c0 .292.001.467.012.596a.638.638 0 0 0 .017.12.25.25 0 0 0 .105.105.628.628 0 0 0 .12.018c.13.01.304.011.596.011h1.366c.69 0 1.257 0 1.71.04.466.042.902.132 1.29.372.576.357 1.017.92 1.206 1.587.126.444.087.893-.004 1.35-.083.417-.228.922-.4 1.527-.016.052-.03.105-.046.16l-1.17 4.099-.035.12c-.202.71-.36 1.265-.697 1.694-.29.37-.67.664-1.116.847-.503.205-1.077.205-1.811.204H4.918c-.534 0-.98 0-1.344-.03-.38-.03-.737-.098-1.074-.27a2.75 2.75 0 0 1-1.202-1.2c-.172-.338-.239-.694-.27-1.074-.03-.365-.03-.81-.03-1.345v-3.16c0-.535 0-.98.03-1.345.031-.38.098-.736.27-1.073A2.75 2.75 0 0 1 2.5 8.3c.337-.172.694-.24 1.074-.27C3.938 8 4.384 8 4.918 8h.874c.226 0 .358 0 .456-.007a.541.541 0 0 0 .092-.012.25.25 0 0 0 .1-.075.542.542 0 0 0 .036-.086c.034-.092.07-.218.133-.436L8.07 2.268Zm-1.63 5.64v-.002.001Zm-.097.072H6.34h.002Zm6.287-1.01h.002-.002Zm-.1-.1-.001-.002v.001ZM9.751 2.5a.248.248 0 0 0-.24.18l-1.46 5.116-.025.083c-.092.328-.19.678-.407.952a1.75 1.75 0 0 1-.714.54c-.13.052-.268.084-.407.103V17.5h7.01c.932 0 1.182-.014 1.376-.093.195-.08.366-.21.504-.385.13-.165.213-.404.468-1.299l1.17-4.1.038-.13c.182-.638.31-1.084.38-1.437.073-.371.062-.543.032-.647a1.266 1.266 0 0 0-.553-.722c-.097-.06-.26-.12-.634-.152-.378-.034-.877-.035-1.611-.035h-1.357c-.257 0-.494 0-.691-.016a1.774 1.774 0 0 1-.677-.175 1.75 1.75 0 0 1-.765-.765 1.775 1.775 0 0 1-.174-.676c-.017-.198-.017-.434-.017-.692v-2.43c0-.688-.558-1.246-1.246-1.246Zm-4.753 15v-8h-.05c-.573 0-.957 0-1.253.025-.287.023-.424.065-.515.111a1.25 1.25 0 0 0-.546.546c-.046.091-.088.228-.112.515-.024.296-.024.68-.024 1.253v3.1c0 .572 0 .957.024 1.252.024.288.066.425.112.515.12.236.31.427.546.547.09.046.228.088.515.111.296.024.68.025 1.253.025h.05Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Wre = { render: Dm }, Ure = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Wre,
  render: Dm
}, Symbol.toStringTag, { value: "Module" })), Kre = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function km(e, t) {
  return f(), v("svg", Kre, [...t[0] || (t[0] = [
    g("g", { class: "ticket" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M4.92 3h10.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 18.7 4.502c.172.337.24.693.27 1.073.03.365.03.81.03 1.345v.83a.75.75 0 0 1-.75.75 1.5 1.5 0 0 0 0 3 .75.75 0 0 1 .75.75v.83c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073a2.751 2.751 0 0 1-1.2 1.202c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03H4.92c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 1.3 15.5c-.172-.338-.24-.694-.27-1.074C1 14.06 1 13.615 1 13.08v-.83a.75.75 0 0 1 .75-.75 1.5 1.5 0 0 0 0-3A.75.75 0 0 1 1 7.75v-.83c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 2.502 3.3c.337-.172.693-.24 1.073-.27C3.94 3 4.385 3 4.92 3ZM13 15.5h2.05c.572 0 .957 0 1.252-.025.288-.023.425-.065.515-.111a1.25 1.25 0 0 0 .547-.546c.046-.091.088-.228.111-.515.024-.296.025-.68.025-1.253v-.145a3.001 3.001 0 0 1 0-5.81V6.95c0-.572 0-.957-.025-1.253-.023-.287-.065-.424-.111-.514a1.25 1.25 0 0 0-.547-.547c-.09-.046-.227-.088-.515-.111-.295-.024-.68-.025-1.252-.025H13v11Zm-1.5-11v11H4.95c-.572 0-.957 0-1.253-.025-.287-.023-.424-.065-.514-.111a1.25 1.25 0 0 1-.547-.546c-.046-.091-.088-.228-.111-.515-.024-.296-.025-.68-.025-1.253v-.145a3.001 3.001 0 0 0 0-5.81V6.95c0-.572 0-.957.025-1.253.023-.287.065-.424.111-.514a1.25 1.25 0 0 1 .547-.547c.09-.046.227-.088.514-.111.296-.024.68-.025 1.253-.025h6.55Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const qre = { render: km }, Yre = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: qre,
  render: km
}, Symbol.toStringTag, { value: "Module" })), Qre = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Hm(e, t) {
  return f(), v("svg", Qre, [...t[0] || (t[0] = [
    g("g", { class: "time-clock" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10 2.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15ZM1 10a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm8.75-5a.75.75 0 0 1 .75.75V9.5h1.75a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75v-4.5A.75.75 0 0 1 9.75 5Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Jre = { render: Hm }, Xre = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Jre,
  render: Hm
}, Symbol.toStringTag, { value: "Module" })), e1e = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Vm(e, t) {
  return f(), v("svg", e1e, [...t[0] || (t[0] = [
    g("g", { class: "toggle-off" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M1 10a5 5 0 0 1 5-5h8a5 5 0 0 1 0 10H6a5 5 0 0 1-5-5Zm5-3.5a3.5 3.5 0 1 0 0 7h8a3.5 3.5 0 1 0 0-7H6Zm-.125 2.75a.625.625 0 1 0 0 1.25.625.625 0 0 0 0-1.25Zm-2.125.625a2.125 2.125 0 1 1 4.25 0 2.125 2.125 0 0 1-4.25 0Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const t1e = { render: Vm }, o1e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: t1e,
  render: Vm
}, Symbol.toStringTag, { value: "Module" })), n1e = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Om(e, t) {
  return f(), v("svg", n1e, [...t[0] || (t[0] = [
    g("g", { class: "toggle-on" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M6 5a5 5 0 0 0 0 10h8a5 5 0 0 0 0-10H6Zm8.125 3a2.125 2.125 0 1 0 0 4.25 2.125 2.125 0 0 0 0-4.25Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const s1e = { render: Om }, i1e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: s1e,
  render: Om
}, Symbol.toStringTag, { value: "Module" })), r1e = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Bm(e, t) {
  return f(), v("svg", r1e, [...t[0] || (t[0] = [
    g("g", { class: "transaction-horizontal" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M13.752 2.19a.75.75 0 0 1 1.059.062l4 4.5A.75.75 0 0 1 18.25 8H1.75a.75.75 0 1 1 0-1.5h14.83l-2.89-3.252a.75.75 0 0 1 .062-1.059ZM1.066 12.442A.75.75 0 0 1 1.75 12h16.5a.75.75 0 0 1 0 1.5H3.42l2.89 3.252a.75.75 0 0 1-1.12.996l-4-4.5a.75.75 0 0 1-.124-.805Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const l1e = { render: Bm }, a1e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: l1e,
  render: Bm
}, Symbol.toStringTag, { value: "Module" })), c1e = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function $m(e, t) {
  return f(), v("svg", c1e, [...t[0] || (t[0] = [
    g("g", { class: "transaction-vertical" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M7.557 1.066A.75.75 0 0 1 8 1.75v16.5a.75.75 0 0 1-1.5 0V3.42L3.248 6.31a.75.75 0 0 1-.996-1.12l4.5-4a.75.75 0 0 1 .805-.124ZM12.75 1a.75.75 0 0 1 .75.75v14.83l3.252-2.89a.75.75 0 0 1 .996 1.12l-4.5 4A.75.75 0 0 1 12 18.25V1.75a.75.75 0 0 1 .75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const d1e = { render: $m }, u1e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: d1e,
  render: $m
}, Symbol.toStringTag, { value: "Module" })), h1e = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Zm(e, t) {
  return f(), v("svg", h1e, [...t[0] || (t[0] = [
    g("g", { class: "tree" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M8.984 1.42a1.437 1.437 0 0 1 2.032 0l2.063 2.064c.561.561.561 1.47 0 2.032l-2.063 2.063a1.44 1.44 0 0 1-.266.21V9.25h2.75A2.75 2.75 0 0 1 16.25 12v.21c.095.059.184.129.266.21l2.063 2.064c.561.561.561 1.47 0 2.032l-2.063 2.063a1.436 1.436 0 0 1-2.032 0l-2.063-2.063a1.436 1.436 0 0 1 0-2.032l2.063-2.063a1.44 1.44 0 0 1 .266-.21V12a1.25 1.25 0 0 0-1.25-1.251h-7c-.69 0-1.25.56-1.25 1.25v.21c.095.059.184.129.266.21l2.063 2.064c.561.561.561 1.47 0 2.032l-2.063 2.063a1.436 1.436 0 0 1-2.032 0l-2.063-2.063a1.437 1.437 0 0 1 0-2.032l2.063-2.063c.082-.082.171-.152.266-.21V12A2.75 2.75 0 0 1 6.5 9.25h2.75V7.79a1.44 1.44 0 0 1-.266-.21L6.921 5.515a1.437 1.437 0 0 1 0-2.032L8.984 1.42ZM10 6.475 11.974 4.5 10 2.526 8.026 4.5 10 6.474Zm-5.5 7.052L2.526 15.5 4.5 17.474 6.474 15.5 4.5 13.526Zm-.045 3.993Zm.09 0ZM15.5 13.525 13.526 15.5l1.974 1.974 1.974-1.974-1.974-1.974Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const g1e = { render: Zm }, p1e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: g1e,
  render: Zm
}, Symbol.toStringTag, { value: "Module" })), f1e = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Gm(e, t) {
  return f(), v("svg", f1e, [...t[0] || (t[0] = [
    g("g", { class: "trend-down" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M1.27 4.174a.75.75 0 0 1 1.056.096L6.87 9.722 10.3 7.15a.75.75 0 0 1 .98.07l6.22 6.22V9.75a.75.75 0 0 1 1.5 0v5.5a.75.75 0 0 1-.75.75h-5.5a.75.75 0 0 1 0-1.5h3.69l-5.76-5.76-3.48 2.61a.75.75 0 0 1-1.026-.12l-5-6a.75.75 0 0 1 .096-1.056Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const v1e = { render: Gm }, m1e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: v1e,
  render: Gm
}, Symbol.toStringTag, { value: "Module" })), C1e = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Nm(e, t) {
  return f(), v("svg", C1e, [...t[0] || (t[0] = [
    g("g", { class: "trend-up" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M12 4.75a.75.75 0 0 1 .75-.75h5.5a.75.75 0 0 1 .75.75v5.5a.75.75 0 0 1-1.5 0V6.56l-6.22 6.22a.75.75 0 0 1-.98.07l-3.43-2.572-4.544 5.452a.75.75 0 0 1-1.152-.96l5-6A.75.75 0 0 1 7.2 8.65l3.48 2.61 5.76-5.76h-3.69a.75.75 0 0 1-.75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const w1e = { render: Nm }, b1e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: w1e,
  render: Nm
}, Symbol.toStringTag, { value: "Module" })), y1e = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function zm(e, t) {
  return f(), v("svg", y1e, [...t[0] || (t[0] = [
    g("g", { class: "turn-off" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10 1a.75.75 0 0 1 .75.75v6.5a.75.75 0 0 1-1.5 0v-6.5A.75.75 0 0 1 10 1ZM4.672 3.656a.75.75 0 0 1 .004 1.061 7.5 7.5 0 1 0 10.647 0 .75.75 0 0 1 1.065-1.056 9 9 0 1 1-12.777 0 .75.75 0 0 1 1.061-.005Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const _1e = { render: zm }, S1e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _1e,
  render: zm
}, Symbol.toStringTag, { value: "Module" })), x1e = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function jm(e, t) {
  return f(), v("svg", x1e, [...t[0] || (t[0] = [
    g("g", { class: "tv" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M4.92 1h10.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 18.7 2.502c.172.337.24.693.27 1.073.03.365.03.81.03 1.345v6.16c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073a2.751 2.751 0 0 1-1.2 1.202c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03H4.92c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 1.3 13.5c-.172-.338-.24-.694-.27-1.074C1 12.06 1 11.615 1 11.08V4.92c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 2.502 1.3c.337-.172.693-.24 1.073-.27C3.94 1 4.385 1 4.92 1ZM3.697 2.525c-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.547c-.046.09-.088.227-.111.514-.024.296-.025.68-.025 1.253v6.1c0 .572 0 .957.025 1.252.023.288.065.425.111.516.12.235.311.426.547.546.09.046.227.088.514.111.296.024.68.025 1.253.025h10.1c.572 0 .957 0 1.252-.025.288-.023.425-.065.515-.111a1.25 1.25 0 0 0 .547-.546c.046-.091.088-.228.111-.515.024-.296.025-.68.025-1.253v-6.1c0-.572 0-.957-.025-1.253-.023-.287-.065-.424-.111-.514a1.25 1.25 0 0 0-.547-.547c-.09-.046-.227-.088-.515-.111-.295-.024-.68-.025-1.252-.025H4.95c-.572 0-.957 0-1.253.025ZM10 17.5c-.937 0-1.744.415-2.08 1.085a.75.75 0 1 1-1.34-.67C7.243 16.585 8.686 16 10 16c1.313 0 2.756.585 3.42 1.915a.75.75 0 1 1-1.34.67c-.336-.67-1.143-1.085-2.08-1.085Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const M1e = { render: jm }, A1e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: M1e,
  render: jm
}, Symbol.toStringTag, { value: "Module" })), L1e = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Wm(e, t) {
  return f(), v("svg", L1e, [...t[0] || (t[0] = [
    g("g", { class: "undo" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M1.75 7a.75.75 0 0 1 .75.75v2.424C4.492 8.29 7.272 7.375 10 7.375c3.44 0 6.963 1.455 8.883 4.472a.75.75 0 1 1-1.266.806C16.037 10.17 13.061 8.875 10 8.875c-2.545 0-5.032.896-6.707 2.625H6.25a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75v-4.5A.75.75 0 0 1 1.75 7Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const E1e = { render: Wm }, P1e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: E1e,
  render: Wm
}, Symbol.toStringTag, { value: "Module" })), R1e = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Um(e, t) {
  return f(), v("svg", R1e, [...t[0] || (t[0] = [
    g("g", { class: "unfold-less" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M6.24 3.2a.75.75 0 0 1 1.06.04L10 6.148l2.7-2.908a.75.75 0 1 1 1.1 1.02l-3.25 3.5a.75.75 0 0 1-1.1 0L6.2 4.26a.75.75 0 0 1 .04-1.06ZM10 12a.75.75 0 0 1 .55.24l3.25 3.5a.75.75 0 1 1-1.1 1.02L10 13.852 7.3 16.76a.75.75 0 1 1-1.1-1.02l3.25-3.5A.75.75 0 0 1 10 12Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const F1e = { render: Um }, T1e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: F1e,
  render: Um
}, Symbol.toStringTag, { value: "Module" })), I1e = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Km(e, t) {
  return f(), v("svg", I1e, [...t[0] || (t[0] = [
    g("g", { class: "unfold-more" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10 2a.75.75 0 0 1 .55.24l3.25 3.5a.75.75 0 1 1-1.1 1.02L10 3.852 7.3 6.76a.75.75 0 1 1-1.1-1.02l3.25-3.5A.75.75 0 0 1 10 2Zm3.76 11.2a.75.75 0 0 1 .04 1.06l-3.25 3.5a.75.75 0 0 1-1.1 0l-3.25-3.5a.75.75 0 1 1 1.1-1.02l2.7 2.908 2.7-2.908a.75.75 0 0 1 1.06-.04Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const D1e = { render: Km }, k1e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: D1e,
  render: Km
}, Symbol.toStringTag, { value: "Module" })), H1e = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function qm(e, t) {
  return f(), v("svg", H1e, [...t[0] || (t[0] = [
    g("g", { class: "unlock" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M6 5a4 4 0 1 1 8 0v.25a.75.75 0 0 1-1.5 0V5a2.5 2.5 0 0 0-5 0v3h7.75A2.75 2.75 0 0 1 18 10.75v5.5A2.75 2.75 0 0 1 15.25 19H4.75A2.75 2.75 0 0 1 2 16.25v-5.5A2.75 2.75 0 0 1 4.75 8H6V5ZM4.75 9.5c-.69 0-1.25.56-1.25 1.25v5.5c0 .69.56 1.25 1.25 1.25h10.5c.69 0 1.25-.56 1.25-1.25v-5.5c0-.69-.56-1.25-1.25-1.25H4.75ZM10 12a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0v-1.5A.75.75 0 0 1 10 12Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const V1e = { render: qm }, O1e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: V1e,
  render: qm
}, Symbol.toStringTag, { value: "Module" })), B1e = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Ym(e, t) {
  return f(), v("svg", B1e, [...t[0] || (t[0] = [
    g("g", { class: "upload" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M9.491 1.199a.75.75 0 0 1 1.018 0l3.25 3A.75.75 0 1 1 12.74 5.3l-1.99-1.837v8.787a.75.75 0 0 1-1.5 0V3.463L7.259 5.301A.75.75 0 1 1 6.24 4.2l3.25-3ZM1.75 13a.75.75 0 0 1 .75.75v2.5c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25v-2.5a.75.75 0 0 1 1.5 0v2.5A2.75 2.75 0 0 1 16.25 19H3.75A2.75 2.75 0 0 1 1 16.25v-2.5a.75.75 0 0 1 .75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const $1e = { render: Ym }, Z1e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: $1e,
  render: Ym
}, Symbol.toStringTag, { value: "Module" })), G1e = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Qm(e, t) {
  return f(), v("svg", G1e, [...t[0] || (t[0] = [
    g("g", {
      class: "user-check",
      "clip-path": "url(#a)"
    }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10 2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5ZM6 5a4 4 0 1 1 8 0 4 4 0 0 1-8 0ZM3 16.625A5.625 5.625 0 0 1 8.625 11h2.125a.75.75 0 0 1 0 1.5H8.625A4.125 4.125 0 0 0 4.5 16.625c0 .483.392.875.875.875H8.75a.75.75 0 0 1 0 1.5H5.375A2.375 2.375 0 0 1 3 16.625Zm16.765-3.42a.75.75 0 0 1 .03 1.06l-4.25 4.5a.75.75 0 0 1-1.102-.013l-2.25-2.5a.75.75 0 1 1 1.114-1.004l1.706 1.896 3.692-3.909a.75.75 0 0 1 1.06-.03Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1),
    g("defs", null, [
      g("clipPath", {
        id: "a",
        class: "a"
      }, [
        g("path", { d: "M0 0h20v20H0z" })
      ])
    ], -1)
  ])]);
}
const N1e = { render: Qm }, z1e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: N1e,
  render: Qm
}, Symbol.toStringTag, { value: "Module" })), j1e = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Jm(e, t) {
  return f(), v("svg", j1e, [...t[0] || (t[0] = [
    g("g", { class: "user-close" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10 2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5ZM6 5a4 4 0 1 1 8 0 4 4 0 0 1-8 0ZM3 16.625A5.625 5.625 0 0 1 8.625 11h2.125a.75.75 0 0 1 0 1.5H8.625A4.125 4.125 0 0 0 4.5 16.625c0 .483.392.875.875.875H8.75a.75.75 0 0 1 0 1.5H5.375A2.375 2.375 0 0 1 3 16.625Zm10.22-3.405a.75.75 0 0 1 1.06 0L16 14.94l1.72-1.72a.75.75 0 1 1 1.06 1.06L17.06 16l1.72 1.72a.75.75 0 1 1-1.06 1.06L16 17.06l-1.72 1.72a.75.75 0 1 1-1.06-1.06L14.94 16l-1.72-1.72a.75.75 0 0 1 0-1.06Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const W1e = { render: Jm }, U1e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: W1e,
  render: Jm
}, Symbol.toStringTag, { value: "Module" })), K1e = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Xm(e, t) {
  return f(), v("svg", K1e, [...t[0] || (t[0] = [
    g("g", { class: "user-edit" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10 2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5ZM6 5a4 4 0 1 1 8 0 4 4 0 0 1-8 0ZM3 16.625A5.625 5.625 0 0 1 8.625 11h2.125a.75.75 0 0 1 0 1.5H8.625A4.125 4.125 0 0 0 4.5 16.625c0 .483.392.875.875.875H8.75a.75.75 0 0 1 0 1.5H5.375A2.375 2.375 0 0 1 3 16.625Zm15.286-2.911a.73.73 0 0 0-1.033 0L13.5 17.467V18.5h1.033l3.753-3.753a.73.73 0 0 0 0-1.033Zm-2.094-1.06a2.23 2.23 0 1 1 3.155 3.154l-3.973 3.972a.75.75 0 0 1-.53.22H12.75a.75.75 0 0 1-.75-.75v-2.094a.75.75 0 0 1 .22-.53l3.972-3.973Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const q1e = { render: Xm }, Y1e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: q1e,
  render: Xm
}, Symbol.toStringTag, { value: "Module" })), Q1e = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function eC(e, t) {
  return f(), v("svg", Q1e, [...t[0] || (t[0] = [
    g("g", { class: "user-minus" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10 2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5ZM6 5a4 4 0 1 1 8 0 4 4 0 0 1-8 0ZM3 16.625A5.625 5.625 0 0 1 8.625 11h2.125a.75.75 0 0 1 0 1.5H8.625A4.125 4.125 0 0 0 4.5 16.625c0 .483.392.875.875.875H8.75a.75.75 0 0 1 0 1.5H5.375A2.375 2.375 0 0 1 3 16.625Zm9-.875a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const J1e = { render: eC }, X1e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: J1e,
  render: eC
}, Symbol.toStringTag, { value: "Module" })), ele = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function tC(e, t) {
  return f(), v("svg", ele, [...t[0] || (t[0] = [
    g("g", { class: "user-plus" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10 2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5ZM6 5a4 4 0 1 1 8 0 4 4 0 0 1-8 0ZM3 16.625A5.625 5.625 0 0 1 8.625 11h2.125a.75.75 0 0 1 0 1.5H8.625A4.125 4.125 0 0 0 4.5 16.625c0 .483.392.875.875.875H8.75a.75.75 0 0 1 0 1.5H5.375A2.375 2.375 0 0 1 3 16.625ZM16 12a.75.75 0 0 1 .75.75v2.5h2.5a.75.75 0 0 1 0 1.5h-2.5v2.5a.75.75 0 0 1-1.5 0v-2.5h-2.5a.75.75 0 0 1 0-1.5h2.5v-2.5A.75.75 0 0 1 16 12Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const tle = { render: tC }, ole = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: tle,
  render: tC
}, Symbol.toStringTag, { value: "Module" })), nle = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function oC(e, t) {
  return f(), v("svg", nle, [...t[0] || (t[0] = [
    g("g", { class: "user" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10 2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5ZM6 5a4 4 0 1 1 8 0 4 4 0 0 1-8 0ZM3 16.625A5.625 5.625 0 0 1 8.625 11h2.75A5.625 5.625 0 0 1 17 16.625 2.375 2.375 0 0 1 14.625 19h-9.25A2.375 2.375 0 0 1 3 16.625ZM8.625 12.5A4.125 4.125 0 0 0 4.5 16.625c0 .483.392.875.875.875h9.25a.875.875 0 0 0 .875-.875 4.125 4.125 0 0 0-4.125-4.125h-2.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const sle = { render: oC }, ile = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sle,
  render: oC
}, Symbol.toStringTag, { value: "Module" })), rle = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function nC(e, t) {
  return f(), v("svg", rle, [...t[0] || (t[0] = [
    g("g", { class: "users" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M7 2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5ZM3 5a4 4 0 1 1 8 0 4 4 0 0 1-8 0Zm9.25-3.25A.75.75 0 0 1 13 1a4 4 0 0 1 0 8 .75.75 0 0 1 0-1.5 2.5 2.5 0 0 0 0-5 .75.75 0 0 1-.75-.75ZM1 16.625A5.625 5.625 0 0 1 6.625 11h.75A5.625 5.625 0 0 1 13 16.625 2.375 2.375 0 0 1 10.625 19h-7.25A2.375 2.375 0 0 1 1 16.625ZM6.625 12.5A4.125 4.125 0 0 0 2.5 16.625c0 .483.392.875.875.875h7.25a.875.875 0 0 0 .875-.875A4.125 4.125 0 0 0 7.375 12.5h-.75Zm5.875-.75a.75.75 0 0 1 .75-.75h.125A5.625 5.625 0 0 1 19 16.625 2.375 2.375 0 0 1 16.625 19H15a.75.75 0 0 1 0-1.5h1.625a.875.875 0 0 0 .875-.875 4.125 4.125 0 0 0-4.125-4.125h-.125a.75.75 0 0 1-.75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const lle = { render: nC }, ale = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: lle,
  render: nC
}, Symbol.toStringTag, { value: "Module" })), cle = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function sC(e, t) {
  return f(), v("svg", cle, [...t[0] || (t[0] = [
    g("g", { class: "vertical-align-bottom" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10 1a.75.75 0 0 1 .75.75v11.764l2.986-2.81a.75.75 0 0 1 1.028 1.092l-4.25 4a.75.75 0 0 1-1.028 0l-4.25-4a.75.75 0 0 1 1.028-1.092l2.986 2.81V1.75A.75.75 0 0 1 10 1ZM1 18.25a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H1.75a.75.75 0 0 1-.75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const dle = { render: sC }, ule = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: dle,
  render: sC
}, Symbol.toStringTag, { value: "Module" })), hle = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function iC(e, t) {
  return f(), v("svg", hle, [...t[0] || (t[0] = [
    g("g", { class: "vertical-align-center" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M19 10a.75.75 0 0 1-.75.75H1.75a.75.75 0 0 1 0-1.5h16.5A.75.75 0 0 1 19 10Zm-5.199-6.259a.75.75 0 0 1-.042 1.06l-3.25 3a.75.75 0 0 1-1.018 0l-3.25-3A.75.75 0 1 1 7.26 3.7l1.99 1.837V1.75a.75.75 0 0 1 1.5 0v3.787l1.991-1.838a.75.75 0 0 1 1.06.042Zm0 12.518a.75.75 0 0 1-1.06.042l-1.991-1.838v3.787a.75.75 0 0 1-1.5 0v-3.787l-1.991 1.838A.75.75 0 1 1 6.24 15.2l3.25-3a.75.75 0 0 1 1.018 0l3.25 3a.75.75 0 0 1 .042 1.06Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const gle = { render: iC }, ple = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: gle,
  render: iC
}, Symbol.toStringTag, { value: "Module" })), fle = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function rC(e, t) {
  return f(), v("svg", fle, [...t[0] || (t[0] = [
    g("g", { class: "vertical-align-top" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M1 1.75A.75.75 0 0 1 1.75 1h16.5a.75.75 0 0 1 0 1.5H1.75A.75.75 0 0 1 1 1.75Zm8.486 2.454a.75.75 0 0 1 1.028 0l4.25 4a.75.75 0 1 1-1.028 1.092l-2.986-2.81V18.25a.75.75 0 0 1-1.5 0V6.486l-2.986 2.81a.75.75 0 1 1-1.028-1.092l4.25-4Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const vle = { render: rC }, mle = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: vle,
  render: rC
}, Symbol.toStringTag, { value: "Module" })), Cle = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function lC(e, t) {
  return f(), v("svg", Cle, [...t[0] || (t[0] = [
    g("g", { class: "video-camera" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M4.92 3h5.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 13.7 4.502c.172.337.24.693.27 1.073.02.246.027.529.029.851l1.471-.883c.372-.223.694-.416.964-.546.273-.132.607-.258.978-.223a1.75 1.75 0 0 1 1.249.706c.22.301.284.652.312.954.027.299.027.675.027 1.108v4.916c0 .434 0 .81-.027 1.108-.028.302-.092.653-.312.954a1.75 1.75 0 0 1-1.249.706c-.371.035-.704-.091-.978-.223-.27-.13-.592-.323-.964-.546L14 13.574c-.002.322-.009.605-.029.85-.03.38-.098.737-.27 1.075A2.751 2.751 0 0 1 12.5 16.7c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03H4.92c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 1.3 15.5c-.172-.338-.24-.694-.27-1.074C1 14.06 1 13.615 1 13.08V6.92c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 2.502 3.3c.337-.172.693-.24 1.073-.27C3.94 3 4.385 3 4.92 3ZM14 11.825l2.213 1.328c.409.245.672.402.872.499.125.06.185.075.202.08a.25.25 0 0 0 .156-.09.99.99 0 0 0 .036-.213c.02-.222.021-.528.021-1.005V7.576c0-.477 0-.783-.021-1.005a.99.99 0 0 0-.036-.213.25.25 0 0 0-.156-.09.984.984 0 0 0-.202.08c-.2.097-.463.253-.872.499L14 8.175v3.65Zm-10.303-7.3c-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.547c-.046.09-.088.227-.111.514-.024.296-.025.68-.025 1.253v6.1c0 .572 0 .957.025 1.252.023.288.065.425.111.516.12.235.311.426.547.546.09.046.227.088.514.111.296.024.68.025 1.253.025h5.1c.572 0 .957 0 1.252-.025.288-.023.425-.065.516-.111a1.25 1.25 0 0 0 .546-.546c.046-.091.088-.228.111-.515.024-.296.025-.68.025-1.253v-6.1c0-.572 0-.957-.025-1.253-.023-.287-.065-.424-.111-.514a1.25 1.25 0 0 0-.546-.547c-.091-.046-.228-.088-.515-.111-.296-.024-.68-.025-1.253-.025h-5.1c-.572 0-.957 0-1.253.025Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const wle = { render: lC }, ble = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: wle,
  render: lC
}, Symbol.toStringTag, { value: "Module" })), yle = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function aC(e, t) {
  return f(), v("svg", yle, [...t[0] || (t[0] = [
    g("g", { class: "video" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M1 4.75A2.75 2.75 0 0 1 3.75 2h12.5A2.75 2.75 0 0 1 19 4.75v10.5A2.75 2.75 0 0 1 16.25 18H3.75A2.75 2.75 0 0 1 1 15.25V4.75Zm1.5 2.5v2H5v-2H2.5ZM5 5.75H2.5v-1c0-.69.56-1.25 1.25-1.25H5v2.25ZM6.5 16.5h7v-13h-7v13Zm8.5-13v2.25h2.5v-1c0-.69-.56-1.25-1.25-1.25H15Zm2.5 3.75H15v2h2.5v-2Zm0 3.5H15v2h2.5v-2Zm0 3.5H15v2.25h1.25c.69 0 1.25-.56 1.25-1.25v-1ZM5 16.5v-2.25H2.5v1c0 .69.56 1.25 1.25 1.25H5Zm-2.5-3.75H5v-2H2.5v2Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const _le = { render: aC }, Sle = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _le,
  render: aC
}, Symbol.toStringTag, { value: "Module" })), xle = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function cC(e, t) {
  return f(), v("svg", xle, [...t[0] || (t[0] = [
    g("g", { class: "view-boxes" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M4.92 1h.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 8.7 2.502c.172.337.24.693.27 1.073.03.365.03.81.03 1.345v.16c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073A2.75 2.75 0 0 1 7.498 8.7c-.337.172-.693.24-1.073.27C6.06 9 5.615 9 5.08 9h-.16c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 1.3 7.498c-.172-.337-.24-.693-.27-1.073C1 6.06 1 5.615 1 5.08v-.16c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 2.502 1.3c.337-.172.693-.24 1.073-.27C3.94 1 4.385 1 4.92 1ZM3.697 2.525c-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.547c-.046.09-.088.227-.111.514-.024.296-.025.68-.025 1.253v.1c0 .572 0 .957.025 1.253.023.287.065.424.111.514.12.236.311.427.547.547.09.046.227.088.514.111.296.024.68.025 1.253.025h.1c.572 0 .957 0 1.253-.025.287-.023.424-.065.514-.111a1.25 1.25 0 0 0 .547-.547c.046-.09.088-.227.111-.514.024-.296.025-.68.025-1.253v-.1c0-.572 0-.957-.025-1.253-.023-.287-.065-.424-.111-.514a1.25 1.25 0 0 0-.547-.547c-.09-.046-.227-.088-.514-.111C6.007 2.5 5.623 2.5 5.05 2.5h-.1c-.572 0-.957 0-1.253.025ZM14.92 1h.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 18.7 2.502c.172.337.24.693.27 1.073.03.365.03.81.03 1.345v.16c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073A2.75 2.75 0 0 1 17.5 8.7c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03h-.16c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 11.3 7.498c-.172-.337-.24-.693-.27-1.073C11 6.06 11 5.615 11 5.08v-.16c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 12.5 1.3c.338-.172.694-.24 1.074-.27.365-.03.81-.03 1.345-.03Zm-1.223 1.525c-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.547c-.046.09-.088.227-.111.514-.024.296-.025.68-.025 1.253v.1c0 .572 0 .957.025 1.253.023.287.065.424.111.514.12.236.311.427.546.547.091.046.228.088.515.111.296.024.68.025 1.253.025h.1c.572 0 .957 0 1.252-.025.288-.023.425-.065.515-.111a1.25 1.25 0 0 0 .547-.547c.046-.09.088-.227.111-.514.024-.296.025-.68.025-1.253v-.1c0-.572 0-.957-.025-1.253-.023-.287-.065-.424-.111-.514a1.25 1.25 0 0 0-.547-.547c-.09-.046-.227-.088-.515-.111-.295-.024-.68-.025-1.252-.025h-.1c-.572 0-.957 0-1.252.025ZM4.92 11h.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 8.7 12.5c.172.338.24.694.27 1.074.03.365.03.81.03 1.345v.16c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073A2.75 2.75 0 0 1 7.498 18.7c-.337.172-.693.24-1.073.27-.365.03-.81.03-1.345.03h-.16c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 1.3 17.5c-.172-.338-.24-.694-.27-1.074C1 16.06 1 15.615 1 15.08v-.16c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 2.502 11.3c.337-.172.693-.24 1.073-.27.365-.03.81-.03 1.345-.03Zm-1.223 1.525c-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.546c-.046.091-.088.228-.111.515-.024.296-.025.68-.025 1.253v.1c0 .572 0 .957.025 1.252.023.288.065.425.111.515.12.236.311.427.547.547.09.046.227.088.514.111.296.024.68.025 1.253.025h.1c.572 0 .957 0 1.253-.025.287-.023.424-.065.514-.111a1.25 1.25 0 0 0 .547-.547c.046-.09.088-.227.111-.515.024-.295.025-.68.025-1.252v-.1c0-.572 0-.957-.025-1.252-.023-.288-.065-.425-.111-.516a1.25 1.25 0 0 0-.547-.546c-.09-.046-.227-.088-.514-.111-.296-.024-.68-.025-1.253-.025h-.1c-.572 0-.957 0-1.253.025ZM14.92 11h.162c.534 0 .98 0 1.344.03.38.03.736.098 1.073.27.518.263.939.684 1.202 1.201.172.338.24.694.27 1.074.03.365.03.81.03 1.345v.16c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073A2.751 2.751 0 0 1 17.5 18.7c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03h-.16c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27a2.751 2.751 0 0 1-1.203-1.2c-.172-.338-.24-.694-.27-1.074-.03-.365-.03-.81-.03-1.345v-.16c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073a2.751 2.751 0 0 1 1.2-1.203c.338-.172.694-.24 1.074-.27.365-.03.81-.03 1.345-.03Zm-1.222 1.525c-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.546c-.046.091-.088.228-.111.515-.024.296-.025.68-.025 1.253v.1c0 .572 0 .957.025 1.252.023.288.065.425.111.515.12.236.311.427.546.547.091.046.228.088.515.111.296.024.68.025 1.253.025h.1c.572 0 .957 0 1.252-.025.288-.023.425-.065.515-.111a1.25 1.25 0 0 0 .547-.547c.046-.09.088-.227.111-.515.024-.295.025-.68.025-1.252v-.1c0-.572 0-.957-.025-1.252-.023-.288-.065-.425-.111-.516a1.25 1.25 0 0 0-.547-.546c-.09-.046-.227-.088-.515-.111-.295-.024-.68-.025-1.252-.025h-.1c-.572 0-.957 0-1.252.025Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Mle = { render: cC }, Ale = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Mle,
  render: cC
}, Symbol.toStringTag, { value: "Module" })), Lle = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function dC(e, t) {
  return f(), v("svg", Lle, [...t[0] || (t[0] = [
    g("g", { class: "view-columns" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M1 3.75A2.75 2.75 0 0 1 3.75 1h12.5A2.75 2.75 0 0 1 19 3.75v12.5A2.75 2.75 0 0 1 16.25 19H3.75A2.75 2.75 0 0 1 1 16.25V3.75Zm9.75 13.75h5.5c.69 0 1.25-.56 1.25-1.25V3.75c0-.69-.56-1.25-1.25-1.25h-5.5v15Zm-1.5-15v15h-5.5c-.69 0-1.25-.56-1.25-1.25V3.75c0-.69.56-1.25 1.25-1.25h5.5Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Ele = { render: dC }, Ple = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ele,
  render: dC
}, Symbol.toStringTag, { value: "Module" })), Rle = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function uC(e, t) {
  return f(), v("svg", Rle, [...t[0] || (t[0] = [
    g("g", { class: "view-dashboard" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M3.963 1h2.074c.196 0 .347 0 .483.013A2.75 2.75 0 0 1 8.987 3.48C9 3.616 9 3.767 9 3.963v.074c0 .196 0 .347-.013.483A2.75 2.75 0 0 1 6.52 6.987 5.128 5.128 0 0 1 6.037 7H3.963c-.196 0-.347 0-.483-.013A2.75 2.75 0 0 1 1.013 4.52C1 4.384 1 4.233 1 4.037a146.281 146.281 0 0 0 0-.074c0-.196 0-.347.013-.483A2.75 2.75 0 0 1 3.48 1.013C3.616 1 3.767 1 3.963 1ZM4 2.5c-.25 0-.32 0-.373.006a1.25 1.25 0 0 0-1.121 1.121A4.685 4.685 0 0 0 2.5 4c0 .25 0 .32.006.373a1.25 1.25 0 0 0 1.121 1.121c.052.005.123.006.373.006h2c.25 0 .32 0 .373-.006a1.25 1.25 0 0 0 1.121-1.121C7.499 4.32 7.5 4.25 7.5 4s0-.32-.006-.373a1.25 1.25 0 0 0-1.121-1.121A4.685 4.685 0 0 0 6 2.5H4ZM14.92 1h.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 18.7 2.502c.172.337.24.693.27 1.073.03.365.03.81.03 1.345v2.16c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073a2.751 2.751 0 0 1-1.2 1.202c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03h-.16c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.751 2.751 0 0 1 11.3 9.498c-.172-.337-.24-.693-.27-1.073C11 8.06 11 7.615 11 7.08V4.92c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 12.5 1.3c.338-.172.694-.24 1.074-.27.365-.03.81-.03 1.345-.03Zm-1.223 1.525c-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.547c-.046.09-.088.227-.111.514-.024.296-.025.68-.025 1.253v2.1c0 .572 0 .957.025 1.253.023.287.065.424.111.514.12.236.311.427.546.547.091.046.228.088.515.111.296.024.68.025 1.253.025h.1c.572 0 .957 0 1.252-.025.288-.023.425-.065.515-.111a1.25 1.25 0 0 0 .547-.546c.046-.091.088-.228.111-.515.024-.296.025-.68.025-1.253v-2.1c0-.572 0-.957-.025-1.253-.023-.287-.065-.424-.111-.514a1.25 1.25 0 0 0-.547-.547c-.09-.046-.227-.088-.515-.111-.295-.024-.68-.025-1.252-.025h-.1c-.572 0-.957 0-1.252.025ZM4.92 9h.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 8.7 10.5c.172.338.24.694.27 1.074.03.365.03.81.03 1.345v2.16c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073A2.75 2.75 0 0 1 7.498 18.7c-.337.172-.693.24-1.073.27-.365.03-.81.03-1.345.03h-.16c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 1.3 17.5c-.172-.338-.24-.694-.27-1.074C1 16.06 1 15.615 1 15.08v-2.16c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 2.502 9.3c.337-.172.693-.24 1.073-.27C3.94 9 4.385 9 4.92 9Zm-1.223 1.525c-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.546c-.046.091-.088.228-.111.515-.024.296-.025.68-.025 1.253v2.1c0 .572 0 .957.025 1.252.023.288.065.425.111.515.12.236.311.427.547.547.09.046.227.088.514.111.296.024.68.025 1.253.025h.1c.572 0 .957 0 1.253-.025.287-.023.424-.065.514-.111a1.25 1.25 0 0 0 .547-.547c.046-.09.088-.227.111-.515.024-.295.025-.68.025-1.252v-2.1c0-.572 0-.957-.025-1.252-.023-.288-.065-.425-.111-.516a1.25 1.25 0 0 0-.547-.546c-.09-.046-.227-.088-.514-.111-.296-.024-.68-.025-1.253-.025h-.1c-.572 0-.957 0-1.253.025ZM13.963 13h2.074c.196 0 .347 0 .483.013a2.75 2.75 0 0 1 2.467 2.467c.013.136.013.287.013.483v.074c0 .196 0 .347-.013.483a2.75 2.75 0 0 1-2.467 2.467 5.122 5.122 0 0 1-.483.013h-2.074c-.196 0-.347 0-.483-.013a2.75 2.75 0 0 1-2.467-2.467 5.124 5.124 0 0 1-.013-.483v-.074c0-.196 0-.347.013-.482a2.75 2.75 0 0 1 2.467-2.468c.136-.013.287-.013.483-.013ZM14 14.5c-.25 0-.32 0-.373.006a1.25 1.25 0 0 0-1.121 1.121A4.696 4.696 0 0 0 12.5 16c0 .25 0 .32.006.372a1.25 1.25 0 0 0 1.121 1.122c.052.005.123.006.373.006h2c.25 0 .32 0 .372-.006a1.25 1.25 0 0 0 1.122-1.122c.005-.051.006-.122.006-.372s0-.32-.006-.373a1.25 1.25 0 0 0-1.122-1.121A4.696 4.696 0 0 0 16 14.5h-2Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Fle = { render: uC }, Tle = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Fle,
  render: uC
}, Symbol.toStringTag, { value: "Module" })), Ile = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function hC(e, t) {
  return f(), v("svg", Ile, [...t[0] || (t[0] = [
    g("g", { class: "view-day" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M1 1.75A.75.75 0 0 1 1.75 1h16.5a.75.75 0 0 1 0 1.5H1.75A.75.75 0 0 1 1 1.75ZM4.92 6h10.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 18.7 7.502c.172.337.24.693.27 1.073.03.365.03.81.03 1.345v.16c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073a2.751 2.751 0 0 1-1.2 1.202c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03H4.92c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 1.3 12.5c-.172-.338-.24-.694-.27-1.074C1 11.06 1 10.615 1 10.08v-.16c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 2.502 6.3c.337-.172.693-.24 1.073-.27C3.94 6 4.385 6 4.92 6ZM3.697 7.525c-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.547c-.046.09-.088.227-.111.514-.024.296-.025.68-.025 1.253v.1c0 .572 0 .957.025 1.252.023.288.065.425.111.516.12.235.311.426.547.546.09.046.227.088.514.111.296.024.68.025 1.253.025h10.1c.572 0 .957 0 1.252-.025.288-.023.425-.065.515-.111a1.25 1.25 0 0 0 .547-.546c.046-.091.088-.228.111-.515.024-.296.025-.68.025-1.253v-.1c0-.572 0-.957-.025-1.253-.023-.287-.065-.424-.111-.514a1.25 1.25 0 0 0-.547-.547c-.09-.046-.227-.088-.515-.111-.295-.024-.68-.025-1.252-.025H4.95c-.572 0-.957 0-1.253.025ZM1 18.25a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H1.75a.75.75 0 0 1-.75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Dle = { render: hC }, kle = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Dle,
  render: hC
}, Symbol.toStringTag, { value: "Module" })), Hle = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function gC(e, t) {
  return f(), v("svg", Hle, [...t[0] || (t[0] = [
    g("g", { class: "view-layout-bottom" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M1 3.75A2.75 2.75 0 0 1 3.75 1h12.5A2.75 2.75 0 0 1 19 3.75v12.5A2.75 2.75 0 0 1 16.25 19H3.75A2.75 2.75 0 0 1 1 16.25V3.75ZM2.5 14v2.25c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25V14h-15Zm15-1.5h-15V3.75c0-.69.56-1.25 1.25-1.25h12.5c.69 0 1.25.56 1.25 1.25v8.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Vle = { render: gC }, Ole = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Vle,
  render: gC
}, Symbol.toStringTag, { value: "Module" })), Ble = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function pC(e, t) {
  return f(), v("svg", Ble, [...t[0] || (t[0] = [
    g("g", { class: "view-layout-grid" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M1 3.75A2.75 2.75 0 0 1 3.75 1h12.5A2.75 2.75 0 0 1 19 3.75v12.5A2.75 2.75 0 0 1 16.25 19H3.75A2.75 2.75 0 0 1 1 16.25V3.75Zm1.5 7v5.5c0 .69.56 1.25 1.25 1.25h5.5v-6.75H2.5Zm6.75-1.5H2.5v-5.5c0-.69.56-1.25 1.25-1.25h5.5v6.75Zm1.5 1.5v6.75h5.5c.69 0 1.25-.56 1.25-1.25v-5.5h-6.75Zm6.75-1.5h-6.75V2.5h5.5c.69 0 1.25.56 1.25 1.25v5.5Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const $le = { render: pC }, Zle = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: $le,
  render: pC
}, Symbol.toStringTag, { value: "Module" })), Gle = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function fC(e, t) {
  return f(), v("svg", Gle, [...t[0] || (t[0] = [
    g("g", { class: "view-layout-left" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M1 3.75A2.75 2.75 0 0 1 3.75 1h12.5A2.75 2.75 0 0 1 19 3.75v12.5A2.75 2.75 0 0 1 16.25 19H3.75A2.75 2.75 0 0 1 1 16.25V3.75ZM7.5 17.5h8.75c.69 0 1.25-.56 1.25-1.25V3.75c0-.69-.56-1.25-1.25-1.25H7.5v15ZM6 2.5v15H3.75c-.69 0-1.25-.56-1.25-1.25V3.75c0-.69.56-1.25 1.25-1.25H6Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Nle = { render: fC }, zle = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Nle,
  render: fC
}, Symbol.toStringTag, { value: "Module" })), jle = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function vC(e, t) {
  return f(), v("svg", jle, [...t[0] || (t[0] = [
    g("g", { class: "view-layout-right" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M1 3.75A2.75 2.75 0 0 1 3.75 1h12.5A2.75 2.75 0 0 1 19 3.75v12.5A2.75 2.75 0 0 1 16.25 19H3.75A2.75 2.75 0 0 1 1 16.25V3.75ZM14 17.5h2.25c.69 0 1.25-.56 1.25-1.25V3.75c0-.69-.56-1.25-1.25-1.25H14v15Zm-1.5-15v15H3.75c-.69 0-1.25-.56-1.25-1.25V3.75c0-.69.56-1.25 1.25-1.25h8.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Wle = { render: vC }, Ule = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Wle,
  render: vC
}, Symbol.toStringTag, { value: "Module" })), Kle = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function mC(e, t) {
  return f(), v("svg", Kle, [...t[0] || (t[0] = [
    g("g", { class: "view-layout-top" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M1 3.75A2.75 2.75 0 0 1 3.75 1h12.5A2.75 2.75 0 0 1 19 3.75v12.5A2.75 2.75 0 0 1 16.25 19H3.75A2.75 2.75 0 0 1 1 16.25V3.75ZM2.5 7.5v8.75c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25V7.5h-15Zm15-1.5h-15V3.75c0-.69.56-1.25 1.25-1.25h12.5c.69 0 1.25.56 1.25 1.25V6Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const qle = { render: mC }, Yle = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: qle,
  render: mC
}, Symbol.toStringTag, { value: "Module" })), Qle = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function CC(e, t) {
  return f(), v("svg", Qle, [...t[0] || (t[0] = [
    g("g", { class: "view-lp" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M4.92 1h10.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 18.7 2.502c.172.337.24.693.27 1.073.03.365.03.81.03 1.345v.16c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073A2.75 2.75 0 0 1 17.5 8.7c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03H4.92c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 1.3 7.498c-.172-.337-.24-.693-.27-1.073C1 6.06 1 5.615 1 5.08v-.16c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 2.502 1.3c.337-.172.693-.24 1.073-.27C3.94 1 4.385 1 4.92 1ZM3.697 2.525c-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.547c-.046.09-.088.227-.111.514-.024.296-.025.68-.025 1.253v.1c0 .572 0 .957.025 1.253.023.287.065.424.111.514.12.236.311.427.547.547.09.046.227.088.514.111.296.024.68.025 1.253.025h10.1c.572 0 .957 0 1.252-.025.288-.023.425-.065.515-.111a1.25 1.25 0 0 0 .547-.547c.046-.09.088-.227.111-.514.024-.296.025-.68.025-1.253v-.1c0-.572 0-.957-.025-1.253-.023-.287-.065-.424-.111-.514a1.25 1.25 0 0 0-.547-.547c-.09-.046-.227-.088-.515-.111-.295-.024-.68-.025-1.252-.025H4.95c-.572 0-.957 0-1.253.025ZM4.92 11h.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 8.7 12.5c.172.338.24.694.27 1.074.03.365.03.81.03 1.345v.16c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073A2.75 2.75 0 0 1 7.498 18.7c-.337.172-.693.24-1.073.27-.365.03-.81.03-1.345.03h-.16c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 1.3 17.5c-.172-.338-.24-.694-.27-1.074C1 16.06 1 15.615 1 15.08v-.16c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 2.502 11.3c.337-.172.693-.24 1.073-.27.365-.03.81-.03 1.345-.03Zm-1.223 1.525c-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.546c-.046.091-.088.228-.111.515-.024.296-.025.68-.025 1.253v.1c0 .572 0 .957.025 1.252.023.288.065.425.111.515.12.236.311.427.547.547.09.046.227.088.514.111.296.024.68.025 1.253.025h.1c.572 0 .957 0 1.253-.025.287-.023.424-.065.514-.111a1.25 1.25 0 0 0 .547-.547c.046-.09.088-.227.111-.515.024-.295.025-.68.025-1.252v-.1c0-.572 0-.957-.025-1.252-.023-.288-.065-.425-.111-.516a1.25 1.25 0 0 0-.547-.546c-.09-.046-.227-.088-.514-.111-.296-.024-.68-.025-1.253-.025h-.1c-.572 0-.957 0-1.253.025ZM14.92 11h.162c.534 0 .98 0 1.344.03.38.03.736.098 1.073.27.518.263.939.684 1.202 1.201.172.338.24.694.27 1.074.03.365.03.81.03 1.345v.16c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073A2.751 2.751 0 0 1 17.5 18.7c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03h-.16c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27a2.751 2.751 0 0 1-1.203-1.2c-.172-.338-.24-.694-.27-1.074-.03-.365-.03-.81-.03-1.345v-.16c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073a2.751 2.751 0 0 1 1.2-1.203c.338-.172.694-.24 1.074-.27.365-.03.81-.03 1.345-.03Zm-1.222 1.525c-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.546c-.046.091-.088.228-.111.515-.024.296-.025.68-.025 1.253v.1c0 .572 0 .957.025 1.252.023.288.065.425.111.515.12.236.311.427.546.547.091.046.228.088.515.111.296.024.68.025 1.253.025h.1c.572 0 .957 0 1.252-.025.288-.023.425-.065.515-.111a1.25 1.25 0 0 0 .547-.547c.046-.09.088-.227.111-.515.024-.295.025-.68.025-1.252v-.1c0-.572 0-.957-.025-1.252-.023-.288-.065-.425-.111-.516a1.25 1.25 0 0 0-.547-.546c-.09-.046-.227-.088-.515-.111-.295-.024-.68-.025-1.252-.025h-.1c-.572 0-.957 0-1.252.025Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Jle = { render: CC }, Xle = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Jle,
  render: CC
}, Symbol.toStringTag, { value: "Module" })), eae = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function wC(e, t) {
  return f(), v("svg", eae, [...t[0] || (t[0] = [
    g("g", { class: "view-rows" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M1 3.75A2.75 2.75 0 0 1 3.75 1h12.5A2.75 2.75 0 0 1 19 3.75v12.5A2.75 2.75 0 0 1 16.25 19H3.75A2.75 2.75 0 0 1 1 16.25V3.75Zm1.5 7v5.5c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25v-5.5h-15Zm15-1.5h-15v-5.5c0-.69.56-1.25 1.25-1.25h12.5c.69 0 1.25.56 1.25 1.25v5.5Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const tae = { render: wC }, oae = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: tae,
  render: wC
}, Symbol.toStringTag, { value: "Module" })), nae = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function bC(e, t) {
  return f(), v("svg", nae, [...t[0] || (t[0] = [
    g("g", { class: "view-schedule" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M4.92 1h10.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 18.7 2.502c.172.337.24.693.27 1.073.03.365.03.81.03 1.345v.16c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073A2.75 2.75 0 0 1 17.5 8.7c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03H4.92c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 1.3 7.498c-.172-.337-.24-.693-.27-1.073C1 6.06 1 5.615 1 5.08v-.16c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 2.502 1.3c.337-.172.693-.24 1.073-.27C3.94 1 4.385 1 4.92 1ZM3.697 2.525c-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.547c-.046.09-.088.227-.111.514-.024.296-.025.68-.025 1.253v.1c0 .572 0 .957.025 1.253.023.287.065.424.111.514.12.236.311.427.547.547.09.046.227.088.514.111.296.024.68.025 1.253.025h10.1c.572 0 .957 0 1.252-.025.288-.023.425-.065.515-.111a1.25 1.25 0 0 0 .547-.547c.046-.09.088-.227.111-.514.024-.296.025-.68.025-1.253v-.1c0-.572 0-.957-.025-1.253-.023-.287-.065-.424-.111-.514a1.25 1.25 0 0 0-.547-.547c-.09-.046-.227-.088-.515-.111-.295-.024-.68-.025-1.252-.025H4.95c-.572 0-.957 0-1.253.025ZM4.92 11h10.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27.518.263.939.684 1.202 1.201.172.338.24.694.27 1.074.03.365.03.81.03 1.345v.16c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073a2.751 2.751 0 0 1-1.2 1.202c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03H4.92c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 1.3 17.5c-.172-.338-.24-.694-.27-1.074C1 16.06 1 15.615 1 15.08v-.16c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 2.502 11.3c.337-.172.693-.24 1.073-.27.365-.03.81-.03 1.345-.03Zm-1.223 1.525c-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.546c-.046.091-.088.228-.111.515-.024.296-.025.68-.025 1.253v.1c0 .572 0 .957.025 1.252.023.288.065.425.111.515.12.236.311.427.547.547.09.046.227.088.514.111.296.024.68.025 1.253.025h10.1c.572 0 .957 0 1.252-.025.288-.023.425-.065.515-.111a1.25 1.25 0 0 0 .547-.547c.046-.09.088-.227.111-.515.024-.295.025-.68.025-1.252v-.1c0-.572 0-.957-.025-1.252-.023-.288-.065-.425-.111-.516a1.25 1.25 0 0 0-.547-.546c-.09-.046-.227-.088-.515-.111-.295-.024-.68-.025-1.252-.025H4.95c-.572 0-.957 0-1.253.025Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const sae = { render: bC }, iae = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sae,
  render: bC
}, Symbol.toStringTag, { value: "Module" })), rae = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function yC(e, t) {
  return f(), v("svg", rae, [...t[0] || (t[0] = [
    g("g", { class: "view-slider" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M9.92 1.25h.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 13.7 2.752c.172.337.24.693.27 1.073.03.365.03.81.03 1.345v10.16c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073a2.751 2.751 0 0 1-1.2 1.202c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03h-.16c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27a2.75 2.75 0 0 1-1.203-1.2c-.172-.338-.24-.694-.27-1.074C6 16.31 6 15.865 6 15.33V5.17c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 7.502 1.55c.337-.172.693-.24 1.073-.27.365-.03.81-.03 1.345-.03ZM8.697 2.775c-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.547c-.046.09-.088.227-.111.514-.024.296-.025.68-.025 1.253v10.1c0 .572 0 .957.025 1.252.023.288.065.425.111.515.12.236.311.427.547.547.09.046.227.088.514.111.296.024.68.025 1.253.025h.1c.572 0 .957 0 1.252-.025.288-.023.425-.065.516-.111a1.25 1.25 0 0 0 .546-.547c.046-.09.088-.227.111-.515.024-.295.025-.68.025-1.252V5.2c0-.572 0-.957-.025-1.253-.023-.287-.065-.424-.111-.514a1.25 1.25 0 0 0-.546-.547c-.091-.046-.228-.088-.515-.111-.296-.024-.68-.025-1.253-.025h-.1c-.572 0-.957 0-1.253.025ZM1.75 4.25A.75.75 0 0 1 2.5 5v10.5a.75.75 0 0 1-1.5 0V5a.75.75 0 0 1 .75-.75Zm16.5 0A.75.75 0 0 1 19 5v10.5a.75.75 0 0 1-1.5 0V5a.75.75 0 0 1 .75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const lae = { render: yC }, aae = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: lae,
  render: yC
}, Symbol.toStringTag, { value: "Module" })), cae = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function _C(e, t) {
  return f(), v("svg", cae, [...t[0] || (t[0] = [
    g("g", { class: "view-table" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M1 3.75A2.75 2.75 0 0 1 3.75 1h12.5A2.75 2.75 0 0 1 19 3.75v12.5A2.75 2.75 0 0 1 16.25 19H3.75A2.75 2.75 0 0 1 1 16.25V3.75ZM2.5 7.5v8.75c0 .69.56 1.25 1.25 1.25H6v-10H2.5ZM6 6H2.5V3.75c0-.69.56-1.25 1.25-1.25H6V6Zm1.5 1.5v10h8.75c.69 0 1.25-.56 1.25-1.25V7.5h-10Zm10-1.5h-10V2.5h8.75c.69 0 1.25.56 1.25 1.25V6Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const dae = { render: _C }, uae = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: dae,
  render: _C
}, Symbol.toStringTag, { value: "Module" })), hae = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function SC(e, t) {
  return f(), v("svg", hae, [...t[0] || (t[0] = [
    g("g", { class: "voice" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M5.75 1a.75.75 0 0 1 .75.75v16.5a.75.75 0 0 1-1.5 0V1.75A.75.75 0 0 1 5.75 1ZM10 4a.75.75 0 0 1 .75.75v10.5a.75.75 0 0 1-1.5 0V4.75A.75.75 0 0 1 10 4Zm8.25 1a.75.75 0 0 1 .75.75v8.5a.75.75 0 0 1-1.5 0v-8.5a.75.75 0 0 1 .75-.75ZM1.75 7a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0v-4.5A.75.75 0 0 1 1.75 7Zm12.5 1a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0v-2.5a.75.75 0 0 1 .75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const gae = { render: SC }, pae = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: gae,
  render: SC
}, Symbol.toStringTag, { value: "Module" })), fae = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function xC(e, t) {
  return f(), v("svg", fae, [...t[0] || (t[0] = [
    g("g", { class: "voicemail" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M4.5 7.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm2.873 4A3.5 3.5 0 1 0 4.5 13h11a3.5 3.5 0 1 0-2.873-1.5H7.373Zm8.127 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const vae = { render: xC }, mae = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: vae,
  render: xC
}, Symbol.toStringTag, { value: "Module" })), Cae = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function MC(e, t) {
  return f(), v("svg", Cae, [...t[0] || (t[0] = [
    g("g", { class: "volume-max" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M14.65 3.3a.75.75 0 0 1 1.05-.15c4.4 3.3 4.4 10.4 0 13.7a.75.75 0 1 1-.9-1.2c3.6-2.7 3.6-8.6 0-11.3a.75.75 0 0 1-.15-1.05Zm-5.1-.237c.274.12.45.39.45.687v12.5a.75.75 0 0 1-1.259.551l-2.372-2.19c-.32-.295-.408-.372-.499-.428a1.252 1.252 0 0 0-.408-.159c-.104-.02-.22-.024-.657-.024H4.78c-.47 0-.861 0-1.182-.023-.335-.024-.65-.076-.954-.21a2.75 2.75 0 0 1-1.41-1.41c-.134-.303-.186-.619-.21-.954C1 11.083 1 10.691 1 10.221V9.78c0-.47 0-.861.023-1.182.024-.335.076-.65.21-.954a2.75 2.75 0 0 1 1.41-1.41c.304-.134.619-.186.954-.21C3.917 6 4.309 6 4.779 6h.026c.437 0 .553-.003.657-.024a1.25 1.25 0 0 0 .408-.16c.09-.055.179-.132.5-.427l2.371-2.19a.75.75 0 0 1 .81-.136Zm-1.05 2.4L7.387 6.491l-.045.04c-.255.237-.457.423-.69.565a2.75 2.75 0 0 1-.897.351c-.267.053-.541.053-.89.053h-.06c-.502 0-.84 0-1.1.02-.254.018-.377.05-.458.086a1.25 1.25 0 0 0-.641.64c-.036.082-.069.205-.087.458-.019.261-.019.599-.019 1.101v.39c0 .502 0 .84.02 1.1.017.255.05.377.086.458.126.287.354.515.64.641.082.036.205.069.458.087.261.019.599.019 1.101.019h.06c.349 0 .623 0 .89.053.318.063.621.182.897.35.233.143.435.33.69.565l.045.041L8.5 14.537V5.463Zm4.08.952a.75.75 0 0 1 1.005-.336c.705.353 1.182.986 1.478 1.67.298.688.437 1.48.437 2.251 0 .772-.14 1.563-.437 2.25-.296.685-.773 1.318-1.478 1.67a.75.75 0 1 1-.67-1.34c.295-.148.568-.453.772-.925.202-.468.313-1.052.313-1.655s-.11-1.187-.313-1.655c-.204-.472-.477-.777-.772-.924a.75.75 0 0 1-.336-1.006Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const wae = { render: MC }, bae = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: wae,
  render: MC
}, Symbol.toStringTag, { value: "Module" })), yae = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function AC(e, t) {
  return f(), v("svg", yae, [...t[0] || (t[0] = [
    g("g", { class: "volume-medium" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M9.55 3.063c.274.12.45.39.45.687v12.5a.75.75 0 0 1-1.259.551l-2.372-2.19c-.32-.295-.408-.372-.499-.428a1.25 1.25 0 0 0-.408-.159c-.104-.02-.22-.024-.657-.024H4.78c-.47 0-.861 0-1.182-.023-.335-.024-.65-.076-.954-.21a2.75 2.75 0 0 1-1.41-1.41c-.134-.303-.186-.619-.21-.954C1 11.083 1 10.69 1 10.221V9.78c0-.47 0-.861.023-1.182.024-.335.076-.65.21-.954a2.75 2.75 0 0 1 1.41-1.41c.304-.134.619-.186.954-.21C3.917 6 4.309 6 4.779 6h.026c.437 0 .553-.003.657-.024a1.25 1.25 0 0 0 .408-.16c.09-.055.179-.132.5-.427l2.371-2.19a.75.75 0 0 1 .81-.136Zm-1.05 2.4L7.387 6.491l-.045.04c-.255.237-.457.423-.69.565a2.75 2.75 0 0 1-.897.351c-.267.053-.541.053-.89.053h-.06c-.502 0-.84 0-1.1.02-.254.017-.377.05-.458.086a1.25 1.25 0 0 0-.641.64c-.036.082-.069.205-.087.458-.019.261-.019.599-.019 1.101v.39c0 .502 0 .84.02 1.1.017.254.05.377.086.458.126.287.354.515.64.641.082.036.205.069.458.087.261.018.599.019 1.101.019h.06c.349 0 .623 0 .89.053.318.063.621.182.897.35.233.143.435.329.69.565l.045.041L8.5 14.537V5.463Zm4.08.952a.75.75 0 0 1 1.005-.336c.705.353 1.182.986 1.478 1.67.298.688.437 1.48.437 2.251 0 .772-.14 1.563-.437 2.25-.296.685-.773 1.318-1.478 1.67a.75.75 0 1 1-.67-1.34c.295-.148.568-.453.772-.925.202-.468.313-1.052.313-1.655s-.11-1.187-.313-1.655c-.204-.473-.477-.777-.772-.924a.75.75 0 0 1-.336-1.006Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const _ae = { render: AC }, Sae = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _ae,
  render: AC
}, Symbol.toStringTag, { value: "Module" })), xae = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function LC(e, t) {
  return f(), v("svg", xae, [...t[0] || (t[0] = [
    g("g", { class: "volume-min" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M9.55 3.063c.274.12.45.39.45.687v12.5a.75.75 0 0 1-1.259.551l-2.372-2.19c-.32-.295-.408-.372-.499-.428a1.25 1.25 0 0 0-.408-.159c-.104-.02-.22-.024-.657-.024H4.78c-.47 0-.861 0-1.182-.023-.335-.024-.65-.076-.954-.21a2.75 2.75 0 0 1-1.41-1.41c-.134-.303-.186-.619-.21-.954C1 11.083 1 10.69 1 10.221V9.78c0-.47 0-.861.023-1.182.024-.335.076-.65.21-.954a2.75 2.75 0 0 1 1.41-1.41c.304-.134.619-.186.954-.21C3.917 6 4.309 6 4.779 6h.026c.437 0 .553-.003.657-.024a1.25 1.25 0 0 0 .408-.16c.09-.055.179-.132.5-.427l2.371-2.19a.75.75 0 0 1 .81-.136Zm-1.05 2.4L7.387 6.491l-.045.04c-.255.237-.457.423-.69.565a2.75 2.75 0 0 1-.897.351c-.267.053-.541.053-.89.053h-.06c-.502 0-.84 0-1.1.02-.254.017-.377.05-.458.086a1.25 1.25 0 0 0-.641.64c-.036.082-.069.205-.087.458-.019.261-.019.599-.019 1.101v.39c0 .502 0 .84.02 1.1.017.254.05.377.086.458.126.287.354.515.64.641.082.036.205.069.458.087.261.018.599.019 1.101.019h.06c.349 0 .623 0 .89.053.318.063.621.182.897.35.233.143.435.329.69.565l.045.041L8.5 14.537V5.463Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Mae = { render: LC }, Aae = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Mae,
  render: LC
}, Symbol.toStringTag, { value: "Module" })), Lae = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function EC(e, t) {
  return f(), v("svg", Lae, [...t[0] || (t[0] = [
    g("g", { class: "volume-mute" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M9.55 3.063c.274.12.45.39.45.687v12.5a.75.75 0 0 1-1.259.551l-2.372-2.19c-.32-.295-.408-.372-.499-.428a1.25 1.25 0 0 0-.408-.159c-.104-.02-.22-.024-.657-.024H4.78c-.47 0-.861 0-1.182-.023-.335-.024-.65-.076-.954-.21a2.75 2.75 0 0 1-1.41-1.41c-.134-.303-.186-.619-.21-.954C1 11.083 1 10.69 1 10.221V9.78c0-.47 0-.861.023-1.182.024-.335.076-.65.21-.954a2.75 2.75 0 0 1 1.41-1.41c.304-.134.619-.186.954-.21C3.917 6 4.309 6 4.779 6h.026c.437 0 .553-.003.657-.024a1.25 1.25 0 0 0 .408-.16c.09-.055.179-.132.5-.427l2.371-2.19a.75.75 0 0 1 .81-.136Zm-1.05 2.4L7.387 6.491l-.045.04c-.255.237-.457.423-.69.565a2.75 2.75 0 0 1-.897.351c-.267.053-.541.053-.89.053h-.06c-.502 0-.84 0-1.1.02-.254.017-.377.05-.458.086a1.25 1.25 0 0 0-.641.64c-.036.082-.069.205-.087.458-.019.261-.019.599-.019 1.101v.39c0 .502 0 .84.02 1.1.017.254.05.377.086.458.126.287.354.515.64.641.082.036.205.069.458.087.261.018.599.019 1.101.019h.06c.349 0 .623 0 .89.053.318.063.621.182.897.35.233.143.435.329.69.565l.045.041L8.5 14.537V5.463Zm4.72 1.757a.75.75 0 0 1 1.06 0L16 8.94l1.72-1.72a.75.75 0 1 1 1.06 1.06L17.06 10l1.72 1.72a.75.75 0 1 1-1.06 1.06L16 11.06l-1.72 1.72a.75.75 0 1 1-1.06-1.06L14.94 10l-1.72-1.72a.75.75 0 0 1 0-1.06Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Eae = { render: EC }, Pae = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Eae,
  render: EC
}, Symbol.toStringTag, { value: "Module" })), Rae = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function PC(e, t) {
  return f(), v("svg", Rae, [...t[0] || (t[0] = [
    g("g", { class: "wallet" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M1 3.75A2.75 2.75 0 0 1 3.75 1h9a.75.75 0 0 1 0 1.5h-9c-.69 0-1.25.56-1.25 1.25V4h13.75A2.75 2.75 0 0 1 19 6.75v9.5A2.75 2.75 0 0 1 16.25 19H3.75A2.75 2.75 0 0 1 1 16.25V3.75ZM2.5 5.5v10.75c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25v-9.5c0-.69-.56-1.25-1.25-1.25H2.5ZM14.25 11a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1Zm-2 .5a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Fae = { render: PC }, Tae = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Fae,
  render: PC
}, Symbol.toStringTag, { value: "Module" })), Iae = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function RC(e, t) {
  return f(), v("svg", Iae, [...t[0] || (t[0] = [
    g("g", { class: "warning-fill" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M12.448 3.386c-1.087-1.848-3.818-1.848-4.905 0L1.379 13.863C.274 15.742 1.702 18 3.832 18h12.327c2.13 0 3.558-2.258 2.453-4.137L12.448 3.386ZM9.25 15.25a.75.75 0 0 0 1.5 0v-1.5a.75.75 0 0 0-1.5 0v1.5Zm0-5a.75.75 0 0 0 1.5 0v-3.5a.75.75 0 0 0-1.5 0v3.5Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Dae = { render: RC }, kae = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Dae,
  render: RC
}, Symbol.toStringTag, { value: "Module" })), Hae = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function FC(e, t) {
  return f(), v("svg", Hae, [...t[0] || (t[0] = [
    g("g", { class: "warning" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M11.162 4.147c-.508-.863-1.816-.863-2.323 0L2.672 14.624c-.473.803.101 1.876 1.161 1.876h12.334c1.06 0 1.634-1.073 1.161-1.876L11.162 4.147Zm-3.616-.761c1.088-1.848 3.82-1.848 4.908 0l6.167 10.477C19.727 15.742 18.298 18 16.167 18H3.833c-2.131 0-3.56-2.258-2.454-4.137L7.546 3.386ZM10 6a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 10 6Zm0 6a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0v-1.5A.75.75 0 0 1 10 12Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Vae = { render: FC }, Oae = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Vae,
  render: FC
}, Symbol.toStringTag, { value: "Module" })), Bae = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function TC(e, t) {
  return f(), v("svg", Bae, [...t[0] || (t[0] = [
    g("g", { class: "watch" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M8.032 1.534A.75.75 0 0 1 8.75 1h2.5a.75.75 0 0 1 .718.534l1.443 4.81c.366.341.68.737.93 1.173a.75.75 0 0 1 .537 1.38 5.016 5.016 0 0 1 0 2.205.75.75 0 0 1-.537 1.381 5.02 5.02 0 0 1-.93 1.172l-1.443 4.81a.75.75 0 0 1-.718.535h-2.5a.75.75 0 0 1-.718-.535l-1.443-4.81A4.986 4.986 0 0 1 5 10c0-1.443.611-2.743 1.589-3.656l1.443-4.81Zm.456 3.699A4.997 4.997 0 0 1 10 5c.527 0 1.035.082 1.512.233l-.82-2.733H9.308l-.82 2.733Zm0 9.534.82 2.733h1.384l.82-2.733A4.998 4.998 0 0 1 10 15a4.997 4.997 0 0 1-1.512-.233ZM10 6.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Zm0 .75a.75.75 0 0 1 .75.75v1.25h.5a.75.75 0 0 1 0 1.5H10a.75.75 0 0 1-.75-.75V8a.75.75 0 0 1 .75-.75Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const $ae = { render: TC }, Zae = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: $ae,
  render: TC
}, Symbol.toStringTag, { value: "Module" })), Gae = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function IC(e, t) {
  return f(), v("svg", Gae, [...t[0] || (t[0] = [
    g("g", { class: "water-drop" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10 2a.75.75 0 0 1 .618.325c.956 1.39 1.917 2.417 2.808 3.37.362.386.711.76 1.045 1.14 1.135 1.297 2.029 2.64 2.029 4.592 0 3.732-2.869 6.823-6.5 6.823-3.632 0-6.5-3.1-6.5-6.823 0-1.948.894-3.29 2.03-4.588.332-.381.682-.756 1.044-1.142.89-.953 1.852-1.982 2.808-3.372A.75.75 0 0 1 10 2ZM6.658 7.826C5.606 9.03 5 10.025 5 11.426c0 2.975 2.274 5.324 5 5.324 2.727 0 5-2.34 5-5.323 0-1.407-.606-2.402-1.658-3.604-.281-.32-.598-.66-.94-1.024-.73-.781-1.57-1.68-2.402-2.771-.831 1.091-1.672 1.99-2.402 2.772-.341.365-.659.705-.94 1.026ZM6.5 11a.75.75 0 0 1 .75.75c0 1.336 1.164 2.5 2.5 2.5a.75.75 0 0 1 0 1.5c-2.164 0-4-1.836-4-4A.75.75 0 0 1 6.5 11Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Nae = { render: IC }, zae = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Nae,
  render: IC
}, Symbol.toStringTag, { value: "Module" })), jae = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function DC(e, t) {
  return f(), v("svg", jae, [...t[0] || (t[0] = [
    g("g", { class: "wifi-off" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M1.198 1.242a.75.75 0 0 1 1.06-.044l2.338 2.153L17.74 14.68a.75.75 0 0 1-.98 1.137l-3.557-3.066a.754.754 0 0 1-.197-.125 4.573 4.573 0 0 0-6.012 0 .75.75 0 1 1-.988-1.129A6.053 6.053 0 0 1 10.011 10L7.52 7.851c-1.05.31-2.003.818-2.762 1.514A.75.75 0 1 1 3.743 8.26a8.21 8.21 0 0 1 2.466-1.538L3.975 4.797a8.162 8.162 0 0 0-1.731 1.142.75.75 0 1 1-.988-1.128 9.324 9.324 0 0 1 1.535-1.082L1.242 2.302a.75.75 0 0 1-.044-1.06Zm16.558 4.697c-2.353-2.058-6.542-2.858-10.31-2.23a.75.75 0 1 1-.246-1.48c4.044-.674 8.743.131 11.544 2.582a.75.75 0 0 1-.988 1.128Zm-6.556.855a.75.75 0 0 1 .884-.585c1.545.314 3.016.99 4.173 2.05a.75.75 0 0 1-1.014 1.106c-.924-.847-2.136-1.417-3.458-1.687a.75.75 0 0 1-.585-.884ZM10 15.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1ZM8 16a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const Wae = { render: DC }, Uae = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Wae,
  render: DC
}, Symbol.toStringTag, { value: "Module" })), Kae = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function kC(e, t) {
  return f(), v("svg", Kae, [...t[0] || (t[0] = [
    g("g", { class: "wifi" }, [
      g("path", {
        "fill-rule": "evenodd",
        d: "M10 3.5c-3.014 0-5.938.848-7.756 2.44a.75.75 0 0 1-.988-1.13C3.438 2.903 6.764 2 10 2c3.236 0 6.562.902 8.744 2.81a.75.75 0 0 1-.988 1.13C15.938 4.347 13.014 3.5 10 3.5Zm0 4c-1.977 0-3.908.641-5.243 1.865A.75.75 0 1 1 3.743 8.26C5.408 6.734 7.727 6 10 6c2.273 0 4.592.734 6.257 2.26a.75.75 0 0 1-1.014 1.105C13.908 8.141 11.977 7.5 10 7.5Zm0 4a4.554 4.554 0 0 0-3.006 1.127.75.75 0 1 1-.988-1.129A6.054 6.054 0 0 1 10 10c1.425 0 2.852.499 3.994 1.498a.75.75 0 0 1-.988 1.129A4.554 4.554 0 0 0 10 11.5Zm0 4a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1ZM8 16a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z",
        class: "Icon",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])]);
}
const qae = { render: kC }, Yae = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: qae,
  render: kC
}, Symbol.toStringTag, { value: "Module" })), Qae = /* @__PURE__ */ Object.assign({
  "../assets/icons/generic/20-fifthbar.svg": AP,
  "../assets/icons/generic/20-save.svg": PP,
  "../assets/icons/generic/20-sidebar.svg": TP,
  "../assets/icons/generic/add-to-folder.svg": kP,
  "../assets/icons/generic/browser.svg": OP,
  "../assets/icons/generic/create-folder.svg": ZP,
  "../assets/icons/generic/dossier-module.svg": zP,
  "../assets/icons/generic/dossier.svg": UP,
  "../assets/icons/generic/dot.svg": YP,
  "../assets/icons/generic/file-small-archive.svg": XP,
  "../assets/icons/generic/file-small-document.svg": oR,
  "../assets/icons/generic/file-small-excel.svg": iR,
  "../assets/icons/generic/file-small-figma.svg": aR,
  "../assets/icons/generic/file-small-file.svg": uR,
  "../assets/icons/generic/file-small-pdf.svg": pR,
  "../assets/icons/generic/file-small-photoshop.svg": mR,
  "../assets/icons/generic/file-small-sketch.svg": bR,
  "../assets/icons/generic/file-small-spreadsheet.svg": SR,
  "../assets/icons/generic/file-small-word.svg": AR,
  "../assets/icons/generic/frame.svg": PR,
  "../assets/icons/generic/handover.svg": TR,
  "../assets/icons/generic/home.svg": kR,
  "../assets/icons/generic/info.svg": OR,
  "../assets/icons/generic/initial-avatar.svg": ZR,
  "../assets/icons/generic/operator-contains.svg": zR,
  "../assets/icons/generic/operator-eq.svg": UR,
  "../assets/icons/generic/operator-gt.svg": YR,
  "../assets/icons/generic/operator-gte.svg": XR,
  "../assets/icons/generic/operator-lt.svg": oF,
  "../assets/icons/generic/operator-lte.svg": iF,
  "../assets/icons/generic/operator-neq.svg": aF,
  "../assets/icons/generic/operator-not-contains.svg": uF,
  "../assets/icons/generic/size-l.svg": pF,
  "../assets/icons/generic/size-m.svg": mF,
  "../assets/icons/generic/size-s.svg": bF,
  "../assets/icons/generic/vector.svg": SF,
  "../assets/icons/phosphor/address-book.svg": AF,
  "../assets/icons/phosphor/align-left-simple.svg": PF,
  "../assets/icons/phosphor/align-left.svg": TF,
  "../assets/icons/phosphor/arrow-bend-double-up-left.svg": kF,
  "../assets/icons/phosphor/arrow-bend-up-left.svg": OF,
  "../assets/icons/phosphor/arrow-bend-up-right.svg": ZF,
  "../assets/icons/phosphor/arrow-counter-clockwise.svg": zF,
  "../assets/icons/phosphor/arrow-down.svg": UF,
  "../assets/icons/phosphor/arrow-line-right.svg": YF,
  "../assets/icons/phosphor/arrow-square-out.svg": XF,
  "../assets/icons/phosphor/arrow-up.svg": oT,
  "../assets/icons/phosphor/arrows-counter-clockwise.svg": iT,
  "../assets/icons/phosphor/arrows-down-up.svg": aT,
  "../assets/icons/phosphor/arrows-horizontal.svg": uT,
  "../assets/icons/phosphor/arrows-in-line-horizontal.svg": pT,
  "../assets/icons/phosphor/arrows-in-line-vertical-menu.svg": mT,
  "../assets/icons/phosphor/arrows-in-line-vertical.svg": bT,
  "../assets/icons/phosphor/arrows-left-right.svg": ST,
  "../assets/icons/phosphor/arrows-out-line-horizontal.svg": AT,
  "../assets/icons/phosphor/arrows-out-line-vertical-menu.svg": PT,
  "../assets/icons/phosphor/arrows-out-line-vertical.svg": TT,
  "../assets/icons/phosphor/article-ny-times.svg": kT,
  "../assets/icons/phosphor/at.svg": OT,
  "../assets/icons/phosphor/bank.svg": ZT,
  "../assets/icons/phosphor/barcode.svg": zT,
  "../assets/icons/phosphor/brackets-square.svg": UT,
  "../assets/icons/phosphor/broom.svg": YT,
  "../assets/icons/phosphor/browser.svg": XT,
  "../assets/icons/phosphor/building-apartment.svg": oI,
  "../assets/icons/phosphor/building.svg": iI,
  "../assets/icons/phosphor/calculator.svg": aI,
  "../assets/icons/phosphor/calendar-blank.svg": uI,
  "../assets/icons/phosphor/calendar-time.svg": pI,
  "../assets/icons/phosphor/caret-double-down.svg": mI,
  "../assets/icons/phosphor/caret-double-right.svg": bI,
  "../assets/icons/phosphor/caret-double-up.svg": SI,
  "../assets/icons/phosphor/caret-down-double-btn.svg": AI,
  "../assets/icons/phosphor/caret-down.svg": PI,
  "../assets/icons/phosphor/caret-left.svg": TI,
  "../assets/icons/phosphor/caret-right-bold.svg": kI,
  "../assets/icons/phosphor/caret-right-menu.svg": OI,
  "../assets/icons/phosphor/caret-right.svg": ZI,
  "../assets/icons/phosphor/caret-top.svg": zI,
  "../assets/icons/phosphor/caret-up.svg": UI,
  "../assets/icons/phosphor/chart-line.svg": YI,
  "../assets/icons/phosphor/check-circle.svg": XI,
  "../assets/icons/phosphor/check.svg": oD,
  "../assets/icons/phosphor/circle-fill.svg": iD,
  "../assets/icons/phosphor/circle.svg": aD,
  "../assets/icons/phosphor/city.svg": uD,
  "../assets/icons/phosphor/clipboard-text.svg": pD,
  "../assets/icons/phosphor/clock.svg": mD,
  "../assets/icons/phosphor/code.svg": bD,
  "../assets/icons/phosphor/columns.svg": SD,
  "../assets/icons/phosphor/copy.svg": AD,
  "../assets/icons/phosphor/cursor-text.svg": PD,
  "../assets/icons/phosphor/dots-six-vertical.svg": TD,
  "../assets/icons/phosphor/dots-six.svg": kD,
  "../assets/icons/phosphor/dots-three-circle.svg": OD,
  "../assets/icons/phosphor/dots-three-vertical.svg": ZD,
  "../assets/icons/phosphor/dots-three.svg": zD,
  "../assets/icons/phosphor/download-simple.svg": UD,
  "../assets/icons/phosphor/envelope.svg": YD,
  "../assets/icons/phosphor/equals.svg": XD,
  "../assets/icons/phosphor/eye-menu.svg": ok,
  "../assets/icons/phosphor/eye-slash.svg": ik,
  "../assets/icons/phosphor/eye.svg": ak,
  "../assets/icons/phosphor/file-empty.svg": uk,
  "../assets/icons/phosphor/file-excel.svg": pk,
  "../assets/icons/phosphor/file-lock.svg": mk,
  "../assets/icons/phosphor/file-magnifying-glass.svg": bk,
  "../assets/icons/phosphor/file-minus.svg": Sk,
  "../assets/icons/phosphor/file-pdf.svg": Ak,
  "../assets/icons/phosphor/file-plus.svg": Pk,
  "../assets/icons/phosphor/file-ppt.svg": Tk,
  "../assets/icons/phosphor/file-video.svg": kk,
  "../assets/icons/phosphor/file-word.svg": Ok,
  "../assets/icons/phosphor/file-zip.svg": Zk,
  "../assets/icons/phosphor/file.svg": zk,
  "../assets/icons/phosphor/flip-horizontal.svg": Uk,
  "../assets/icons/phosphor/flip-vertical.svg": Yk,
  "../assets/icons/phosphor/floppy-disk.svg": Xk,
  "../assets/icons/phosphor/folder-minus.svg": oH,
  "../assets/icons/phosphor/folder-plus.svg": iH,
  "../assets/icons/phosphor/folder.svg": aH,
  "../assets/icons/phosphor/funnel-simple.svg": uH,
  "../assets/icons/phosphor/funnel.svg": pH,
  "../assets/icons/phosphor/gear.svg": mH,
  "../assets/icons/phosphor/globe.svg": bH,
  "../assets/icons/phosphor/greater-than-or-equal.svg": SH,
  "../assets/icons/phosphor/greater-than.svg": AH,
  "../assets/icons/phosphor/grid-nine.svg": PH,
  "../assets/icons/phosphor/hand-deposit.svg": TH,
  "../assets/icons/phosphor/hard-drives.svg": kH,
  "../assets/icons/phosphor/hash.svg": OH,
  "../assets/icons/phosphor/house.svg": ZH,
  "../assets/icons/phosphor/image-square.svg": zH,
  "../assets/icons/phosphor/info.svg": UH,
  "../assets/icons/phosphor/key.svg": YH,
  "../assets/icons/phosphor/layout-duotone.svg": XH,
  "../assets/icons/phosphor/layout.svg": oV,
  "../assets/icons/phosphor/less-than-or-equal.svg": iV,
  "../assets/icons/phosphor/less-than.svg": aV,
  "../assets/icons/phosphor/link.svg": uV,
  "../assets/icons/phosphor/list-bullets.svg": pV,
  "../assets/icons/phosphor/list-checks.svg": mV,
  "../assets/icons/phosphor/list-dashes.svg": bV,
  "../assets/icons/phosphor/list-numbers.svg": SV,
  "../assets/icons/phosphor/list-plus.svg": AV,
  "../assets/icons/phosphor/list.svg": PV,
  "../assets/icons/phosphor/lock-simple.svg": TV,
  "../assets/icons/phosphor/magnifying-glass-minus.svg": kV,
  "../assets/icons/phosphor/magnifying-glass-plus.svg": OV,
  "../assets/icons/phosphor/magnifying-glass.svg": ZV,
  "../assets/icons/phosphor/mail.svg": zV,
  "../assets/icons/phosphor/map-pin-simple-area.svg": UV,
  "../assets/icons/phosphor/minus-circle-duotone.svg": YV,
  "../assets/icons/phosphor/minus-circle.svg": XV,
  "../assets/icons/phosphor/more-horizontal.svg": oO,
  "../assets/icons/phosphor/network.svg": iO,
  "../assets/icons/phosphor/not-equals.svg": aO,
  "../assets/icons/phosphor/note-pencil.svg": uO,
  "../assets/icons/phosphor/notebook.svg": pO,
  "../assets/icons/phosphor/number-square-four.svg": mO,
  "../assets/icons/phosphor/number-square-one.svg": bO,
  "../assets/icons/phosphor/number-square-three.svg": SO,
  "../assets/icons/phosphor/number-square-two.svg": AO,
  "../assets/icons/phosphor/paint-bucket.svg": PO,
  "../assets/icons/phosphor/palette.svg": TO,
  "../assets/icons/phosphor/paper-clip-horizontal.svg": kO,
  "../assets/icons/phosphor/paper-plane-right.svg": OO,
  "../assets/icons/phosphor/paperclip.svg": ZO,
  "../assets/icons/phosphor/pencil-line.svg": zO,
  "../assets/icons/phosphor/pencil-simple-line.svg": UO,
  "../assets/icons/phosphor/pencil-simple.svg": YO,
  "../assets/icons/phosphor/phone.svg": XO,
  "../assets/icons/phosphor/plug.svg": oB,
  "../assets/icons/phosphor/plus-circle.svg": iB,
  "../assets/icons/phosphor/plus.svg": aB,
  "../assets/icons/phosphor/printer.svg": uB,
  "../assets/icons/phosphor/push-pin.svg": pB,
  "../assets/icons/phosphor/question.svg": mB,
  "../assets/icons/phosphor/rows-plus-bottom.svg": bB,
  "../assets/icons/phosphor/rows-plus-top.svg": SB,
  "../assets/icons/phosphor/search.svg": AB,
  "../assets/icons/phosphor/sigma.svg": PB,
  "../assets/icons/phosphor/sign-in.svg": TB,
  "../assets/icons/phosphor/sign-out.svg": kB,
  "../assets/icons/phosphor/sliders-horizontal.svg": OB,
  "../assets/icons/phosphor/sparkle.svg": ZB,
  "../assets/icons/phosphor/split-horizontal.svg": zB,
  "../assets/icons/phosphor/stack-minus.svg": UB,
  "../assets/icons/phosphor/stack-plus.svg": YB,
  "../assets/icons/phosphor/star.svg": XB,
  "../assets/icons/phosphor/suit-case-simple.svg": o$,
  "../assets/icons/phosphor/swap.svg": i$,
  "../assets/icons/phosphor/table.svg": a$,
  "../assets/icons/phosphor/tabs.svg": u$,
  "../assets/icons/phosphor/text-align-center.svg": p$,
  "../assets/icons/phosphor/text-align-justify.svg": m$,
  "../assets/icons/phosphor/text-align-left.svg": b$,
  "../assets/icons/phosphor/text-align-right.svg": S$,
  "../assets/icons/phosphor/text-b.svg": A$,
  "../assets/icons/phosphor/text-columns.svg": P$,
  "../assets/icons/phosphor/text-h.svg": T$,
  "../assets/icons/phosphor/text-indent.svg": k$,
  "../assets/icons/phosphor/text-italic-x.svg": O$,
  "../assets/icons/phosphor/text-italic.svg": Z$,
  "../assets/icons/phosphor/text-outdent.svg": z$,
  "../assets/icons/phosphor/text-t-slash.svg": U$,
  "../assets/icons/phosphor/text-t.svg": Y$,
  "../assets/icons/phosphor/textbox.svg": X$,
  "../assets/icons/phosphor/timer.svg": oZ,
  "../assets/icons/phosphor/trash.svg": iZ,
  "../assets/icons/phosphor/tray.svg": aZ,
  "../assets/icons/phosphor/tree-structure.svg": uZ,
  "../assets/icons/phosphor/tree-view.svg": pZ,
  "../assets/icons/phosphor/upload-simple.svg": mZ,
  "../assets/icons/phosphor/user-circle-dashed.svg": bZ,
  "../assets/icons/phosphor/user-gear.svg": SZ,
  "../assets/icons/phosphor/user-plus.svg": AZ,
  "../assets/icons/phosphor/user.svg": PZ,
  "../assets/icons/phosphor/user_circle.svg": TZ,
  "../assets/icons/phosphor/users-three.svg": kZ,
  "../assets/icons/phosphor/users.svg": OZ,
  "../assets/icons/phosphor/warning-circle.svg": ZZ,
  "../assets/icons/phosphor/x-circle.svg": zZ,
  "../assets/icons/phosphor/x.svg": UZ,
  "../assets/icons/tetrisly/16-alert-full.svg": YZ,
  "../assets/icons/tetrisly/16-arrowhead-down-small.svg": XZ,
  "../assets/icons/tetrisly/16-arrowhead-down.svg": oG,
  "../assets/icons/tetrisly/16-arrowhead-left-small.svg": iG,
  "../assets/icons/tetrisly/16-arrowhead-left.svg": aG,
  "../assets/icons/tetrisly/16-arrowhead-right-small.svg": uG,
  "../assets/icons/tetrisly/16-arrowhead-right.svg": pG,
  "../assets/icons/tetrisly/16-arrowhead-top-small.svg": mG,
  "../assets/icons/tetrisly/16-arrowhead-top.svg": bG,
  "../assets/icons/tetrisly/16-bolt.svg": SG,
  "../assets/icons/tetrisly/16-check.svg": AG,
  "../assets/icons/tetrisly/16-chevron-down.svg": PG,
  "../assets/icons/tetrisly/16-chevron-left.svg": TG,
  "../assets/icons/tetrisly/16-chevron-right.svg": kG,
  "../assets/icons/tetrisly/16-chevron-top.svg": OG,
  "../assets/icons/tetrisly/16-close.svg": ZG,
  "../assets/icons/tetrisly/16-dot.svg": zG,
  "../assets/icons/tetrisly/16-info.svg": UG,
  "../assets/icons/tetrisly/16-minus.svg": YG,
  "../assets/icons/tetrisly/16-plus.svg": XG,
  "../assets/icons/tetrisly/20-file-icon-document.svg": oN,
  "../assets/icons/tetrisly/20-file-icon-excel.svg": iN,
  "../assets/icons/tetrisly/20-file-icon-figma.svg": aN,
  "../assets/icons/tetrisly/20-file-icon-file.svg": uN,
  "../assets/icons/tetrisly/20-file-icon-pdf.svg": pN,
  "../assets/icons/tetrisly/20-file-icon-psd.svg": mN,
  "../assets/icons/tetrisly/20-file-icon-sketch.svg": bN,
  "../assets/icons/tetrisly/20-file-icon-spreadsheet.svg": SN,
  "../assets/icons/tetrisly/20-file-icon-word.svg": AN,
  "../assets/icons/tetrisly/20-file-icon-zip.svg": PN,
  "../assets/icons/tetrisly/32-file-Icon-psd.svg": TN,
  "../assets/icons/tetrisly/32-file-icon-document.svg": kN,
  "../assets/icons/tetrisly/32-file-icon-excel.svg": ON,
  "../assets/icons/tetrisly/32-file-icon-figma.svg": ZN,
  "../assets/icons/tetrisly/32-file-icon-file.svg": zN,
  "../assets/icons/tetrisly/32-file-icon-pdf.svg": UN,
  "../assets/icons/tetrisly/32-file-icon-sketch.svg": YN,
  "../assets/icons/tetrisly/32-file-icon-spreadsheet.svg": XN,
  "../assets/icons/tetrisly/32-file-icon-word.svg": oz,
  "../assets/icons/tetrisly/32-file-icon-zip.svg": iz,
  "../assets/icons/tetrisly/accesibility.svg": az,
  "../assets/icons/tetrisly/activity.svg": uz,
  "../assets/icons/tetrisly/alarm-clock.svg": pz,
  "../assets/icons/tetrisly/alert-fill.svg": mz,
  "../assets/icons/tetrisly/alert.svg": bz,
  "../assets/icons/tetrisly/anchor.svg": Sz,
  "../assets/icons/tetrisly/apps.svg": Az,
  "../assets/icons/tetrisly/archive.svg": Pz,
  "../assets/icons/tetrisly/arrow-down-left.svg": Tz,
  "../assets/icons/tetrisly/arrow-down-right.svg": kz,
  "../assets/icons/tetrisly/arrow-down.svg": Oz,
  "../assets/icons/tetrisly/arrow-left.svg": Zz,
  "../assets/icons/tetrisly/arrow-right.svg": zz,
  "../assets/icons/tetrisly/arrow-up-left.svg": Uz,
  "../assets/icons/tetrisly/arrow-up-right.svg": Yz,
  "../assets/icons/tetrisly/arrow-up.svg": Xz,
  "../assets/icons/tetrisly/arrowhead-down.svg": oj,
  "../assets/icons/tetrisly/arrowhead-left.svg": ij,
  "../assets/icons/tetrisly/arrowhead-right.svg": aj,
  "../assets/icons/tetrisly/arrowhead-up.svg": uj,
  "../assets/icons/tetrisly/attachment.svg": pj,
  "../assets/icons/tetrisly/background.svg": mj,
  "../assets/icons/tetrisly/backspace.svg": bj,
  "../assets/icons/tetrisly/backward.svg": Sj,
  "../assets/icons/tetrisly/bank.svg": Aj,
  "../assets/icons/tetrisly/battery-charging.svg": Pj,
  "../assets/icons/tetrisly/battery-empty.svg": Tj,
  "../assets/icons/tetrisly/battery-full.svg": kj,
  "../assets/icons/tetrisly/battery-low.svg": Oj,
  "../assets/icons/tetrisly/battery-medium.svg": Zj,
  "../assets/icons/tetrisly/bell.svg": zj,
  "../assets/icons/tetrisly/block.svg": Uj,
  "../assets/icons/tetrisly/bluetooth-off.svg": Yj,
  "../assets/icons/tetrisly/bluetooth.svg": Xj,
  "../assets/icons/tetrisly/bolt.svg": oW,
  "../assets/icons/tetrisly/book.svg": iW,
  "../assets/icons/tetrisly/bookmark.svg": aW,
  "../assets/icons/tetrisly/border-all.svg": uW,
  "../assets/icons/tetrisly/border-bottom.svg": pW,
  "../assets/icons/tetrisly/border-horizontal.svg": mW,
  "../assets/icons/tetrisly/border-inner.svg": bW,
  "../assets/icons/tetrisly/border-left.svg": SW,
  "../assets/icons/tetrisly/border-right.svg": AW,
  "../assets/icons/tetrisly/border-style.svg": PW,
  "../assets/icons/tetrisly/border-top.svg": TW,
  "../assets/icons/tetrisly/border-vertical.svg": kW,
  "../assets/icons/tetrisly/brackets-curly.svg": OW,
  "../assets/icons/tetrisly/brain.svg": ZW,
  "../assets/icons/tetrisly/broadcast.svg": zW,
  "../assets/icons/tetrisly/brush.svg": UW,
  "../assets/icons/tetrisly/bug.svg": YW,
  "../assets/icons/tetrisly/bulb.svg": XW,
  "../assets/icons/tetrisly/calculator.svg": oU,
  "../assets/icons/tetrisly/calendar-check.svg": iU,
  "../assets/icons/tetrisly/calendar-close.svg": aU,
  "../assets/icons/tetrisly/calendar-edit.svg": uU,
  "../assets/icons/tetrisly/calendar-minus.svg": pU,
  "../assets/icons/tetrisly/calendar-plus.svg": mU,
  "../assets/icons/tetrisly/calendar.svg": bU,
  "../assets/icons/tetrisly/camera.svg": SU,
  "../assets/icons/tetrisly/card.svg": AU,
  "../assets/icons/tetrisly/chart-bar-box.svg": PU,
  "../assets/icons/tetrisly/chart-bar.svg": TU,
  "../assets/icons/tetrisly/chart-line.svg": kU,
  "../assets/icons/tetrisly/chart-pie.svg": OU,
  "../assets/icons/tetrisly/chat.svg": ZU,
  "../assets/icons/tetrisly/check-badge-fill.svg": zU,
  "../assets/icons/tetrisly/check-badge.svg": UU,
  "../assets/icons/tetrisly/check-circle-fill.svg": YU,
  "../assets/icons/tetrisly/check-circle.svg": XU,
  "../assets/icons/tetrisly/check-large.svg": oK,
  "../assets/icons/tetrisly/check-small.svg": iK,
  "../assets/icons/tetrisly/chevron-down-small-circle.svg": aK,
  "../assets/icons/tetrisly/chevron-down-small-fill.svg": uK,
  "../assets/icons/tetrisly/chevron-down-small.svg": pK,
  "../assets/icons/tetrisly/chevron-down.svg": mK,
  "../assets/icons/tetrisly/chevron-left-small-circle.svg": bK,
  "../assets/icons/tetrisly/chevron-left-small-fill.svg": SK,
  "../assets/icons/tetrisly/chevron-left-small.svg": AK,
  "../assets/icons/tetrisly/chevron-left.svg": PK,
  "../assets/icons/tetrisly/chevron-right-small-circle.svg": TK,
  "../assets/icons/tetrisly/chevron-right-small-fill.svg": kK,
  "../assets/icons/tetrisly/chevron-right-small.svg": OK,
  "../assets/icons/tetrisly/chevron-right.svg": ZK,
  "../assets/icons/tetrisly/chevron-up-small-circle.svg": zK,
  "../assets/icons/tetrisly/chevron-up-small-fill.svg": UK,
  "../assets/icons/tetrisly/chevron-up-small.svg": YK,
  "../assets/icons/tetrisly/chevron-up.svg": XK,
  "../assets/icons/tetrisly/clipboard.svg": oq,
  "../assets/icons/tetrisly/close.svg": iq,
  "../assets/icons/tetrisly/cloud.svg": aq,
  "../assets/icons/tetrisly/code-2.svg": uq,
  "../assets/icons/tetrisly/code.svg": pq,
  "../assets/icons/tetrisly/command.svg": mq,
  "../assets/icons/tetrisly/comment.svg": bq,
  "../assets/icons/tetrisly/company.svg": Sq,
  "../assets/icons/tetrisly/compass.svg": Aq,
  "../assets/icons/tetrisly/copy.svg": Pq,
  "../assets/icons/tetrisly/cpu.svg": Tq,
  "../assets/icons/tetrisly/crown.svg": kq,
  "../assets/icons/tetrisly/cursor-arrow-fill.svg": Oq,
  "../assets/icons/tetrisly/cursor-arrow.svg": Zq,
  "../assets/icons/tetrisly/cursor-text.svg": zq,
  "../assets/icons/tetrisly/database.svg": Uq,
  "../assets/icons/tetrisly/delete.svg": Yq,
  "../assets/icons/tetrisly/desktop.svg": Xq,
  "../assets/icons/tetrisly/devices.svg": oY,
  "../assets/icons/tetrisly/diamond.svg": iY,
  "../assets/icons/tetrisly/dns.svg": aY,
  "../assets/icons/tetrisly/download.svg": uY,
  "../assets/icons/tetrisly/drag-drop-horizontal.svg": pY,
  "../assets/icons/tetrisly/drag-drop-vertical.svg": mY,
  "../assets/icons/tetrisly/edit.svg": bY,
  "../assets/icons/tetrisly/email.svg": SY,
  "../assets/icons/tetrisly/emoji-big-smile.svg": AY,
  "../assets/icons/tetrisly/emoji-sad.svg": PY,
  "../assets/icons/tetrisly/emoji-smile.svg": TY,
  "../assets/icons/tetrisly/error-fill.svg": kY,
  "../assets/icons/tetrisly/error.svg": OY,
  "../assets/icons/tetrisly/extension.svg": ZY,
  "../assets/icons/tetrisly/eye-off.svg": zY,
  "../assets/icons/tetrisly/eye.svg": UY,
  "../assets/icons/tetrisly/file-check.svg": YY,
  "../assets/icons/tetrisly/file-close.svg": XY,
  "../assets/icons/tetrisly/file-edit.svg": oQ,
  "../assets/icons/tetrisly/file-minus.svg": iQ,
  "../assets/icons/tetrisly/file-plus.svg": aQ,
  "../assets/icons/tetrisly/file.svg": uQ,
  "../assets/icons/tetrisly/filter.svg": pQ,
  "../assets/icons/tetrisly/fingerprint.svg": mQ,
  "../assets/icons/tetrisly/fire.svg": bQ,
  "../assets/icons/tetrisly/flag.svg": SQ,
  "../assets/icons/tetrisly/folder-check.svg": AQ,
  "../assets/icons/tetrisly/folder-close.svg": PQ,
  "../assets/icons/tetrisly/folder-edit.svg": TQ,
  "../assets/icons/tetrisly/folder-minus.svg": kQ,
  "../assets/icons/tetrisly/folder-plus.svg": OQ,
  "../assets/icons/tetrisly/folder.svg": ZQ,
  "../assets/icons/tetrisly/format-align-center.svg": zQ,
  "../assets/icons/tetrisly/format-align-justify.svg": UQ,
  "../assets/icons/tetrisly/format-align-left.svg": YQ,
  "../assets/icons/tetrisly/format-align-right.svg": XQ,
  "../assets/icons/tetrisly/format-all-small-caps.svg": oJ,
  "../assets/icons/tetrisly/format-bold.svg": iJ,
  "../assets/icons/tetrisly/format-font-size.svg": aJ,
  "../assets/icons/tetrisly/format-indent-decrease.svg": uJ,
  "../assets/icons/tetrisly/format-indent-increase.svg": pJ,
  "../assets/icons/tetrisly/format-italic.svg": mJ,
  "../assets/icons/tetrisly/format-letter-spacing.svg": bJ,
  "../assets/icons/tetrisly/format-line-height.svg": SJ,
  "../assets/icons/tetrisly/format-lowercase.svg": AJ,
  "../assets/icons/tetrisly/format-paragraph-spacing.svg": PJ,
  "../assets/icons/tetrisly/format-scale-horizontal.svg": TJ,
  "../assets/icons/tetrisly/format-scale-vertical.svg": kJ,
  "../assets/icons/tetrisly/format-small-caps.svg": OJ,
  "../assets/icons/tetrisly/format-strikethrough.svg": ZJ,
  "../assets/icons/tetrisly/format-subscript.svg": zJ,
  "../assets/icons/tetrisly/format-superscript.svg": UJ,
  "../assets/icons/tetrisly/format-titlecase.svg": YJ,
  "../assets/icons/tetrisly/format-underline.svg": XJ,
  "../assets/icons/tetrisly/format-uppercase.svg": oX,
  "../assets/icons/tetrisly/forward.svg": iX,
  "../assets/icons/tetrisly/fullscreen-exit.svg": aX,
  "../assets/icons/tetrisly/fullscreen.svg": uX,
  "../assets/icons/tetrisly/function.svg": pX,
  "../assets/icons/tetrisly/git-branch.svg": mX,
  "../assets/icons/tetrisly/git-commit.svg": bX,
  "../assets/icons/tetrisly/git-diff.svg": SX,
  "../assets/icons/tetrisly/git-fork.svg": AX,
  "../assets/icons/tetrisly/git-merge.svg": PX,
  "../assets/icons/tetrisly/git-pull-request.svg": TX,
  "../assets/icons/tetrisly/globe.svg": kX,
  "../assets/icons/tetrisly/hashtag.svg": OX,
  "../assets/icons/tetrisly/heading.svg": ZX,
  "../assets/icons/tetrisly/headphones.svg": zX,
  "../assets/icons/tetrisly/health.svg": UX,
  "../assets/icons/tetrisly/heart.svg": YX,
  "../assets/icons/tetrisly/help-fill.svg": XX,
  "../assets/icons/tetrisly/help.svg": oee,
  "../assets/icons/tetrisly/home.svg": iee,
  "../assets/icons/tetrisly/horizontal-align-center.svg": aee,
  "../assets/icons/tetrisly/horizontal-align-left.svg": uee,
  "../assets/icons/tetrisly/horizontal-align-right.svg": pee,
  "../assets/icons/tetrisly/hourglass.svg": mee,
  "../assets/icons/tetrisly/image-check.svg": bee,
  "../assets/icons/tetrisly/image-close.svg": See,
  "../assets/icons/tetrisly/image-edit.svg": Aee,
  "../assets/icons/tetrisly/image-minus.svg": Pee,
  "../assets/icons/tetrisly/image-plus.svg": Tee,
  "../assets/icons/tetrisly/image.svg": kee,
  "../assets/icons/tetrisly/images.svg": Oee,
  "../assets/icons/tetrisly/inbox.svg": Zee,
  "../assets/icons/tetrisly/info-circle.svg": zee,
  "../assets/icons/tetrisly/info-fill.svg": Uee,
  "../assets/icons/tetrisly/key.svg": Yee,
  "../assets/icons/tetrisly/keyboard.svg": Xee,
  "../assets/icons/tetrisly/label.svg": ote,
  "../assets/icons/tetrisly/laptop.svg": ite,
  "../assets/icons/tetrisly/layer-align-bottom-center.svg": ate,
  "../assets/icons/tetrisly/layer-align-horizontal.svg": ute,
  "../assets/icons/tetrisly/layer-align-left-center.svg": pte,
  "../assets/icons/tetrisly/layer-align-right-center.svg": mte,
  "../assets/icons/tetrisly/layer-align-top-center.svg": bte,
  "../assets/icons/tetrisly/layer-align-vertical.svg": Ste,
  "../assets/icons/tetrisly/layer-three.svg": Ate,
  "../assets/icons/tetrisly/layer-two.svg": Pte,
  "../assets/icons/tetrisly/layout-swap-horizontal.svg": Tte,
  "../assets/icons/tetrisly/layout-swap-vertical.svg": kte,
  "../assets/icons/tetrisly/link-broken.svg": Ote,
  "../assets/icons/tetrisly/link.svg": Zte,
  "../assets/icons/tetrisly/list-bullet.svg": zte,
  "../assets/icons/tetrisly/list-check.svg": Ute,
  "../assets/icons/tetrisly/list-ordered.svg": Yte,
  "../assets/icons/tetrisly/list-unordered.svg": Xte,
  "../assets/icons/tetrisly/lock.svg": ooe,
  "../assets/icons/tetrisly/log-in.svg": ioe,
  "../assets/icons/tetrisly/log-out.svg": aoe,
  "../assets/icons/tetrisly/mail.svg": uoe,
  "../assets/icons/tetrisly/map.svg": poe,
  "../assets/icons/tetrisly/marker-pin.svg": moe,
  "../assets/icons/tetrisly/math-alpha.svg": boe,
  "../assets/icons/tetrisly/math-angle.svg": Soe,
  "../assets/icons/tetrisly/math-beta.svg": Aoe,
  "../assets/icons/tetrisly/math-gamma.svg": Poe,
  "../assets/icons/tetrisly/math-infinite.svg": Toe,
  "../assets/icons/tetrisly/math-omega.svg": koe,
  "../assets/icons/tetrisly/math-pi.svg": Ooe,
  "../assets/icons/tetrisly/math-sigma.svg": Zoe,
  "../assets/icons/tetrisly/math-sine-wawe.svg": zoe,
  "../assets/icons/tetrisly/math-square-root .svg": Uoe,
  "../assets/icons/tetrisly/math-theta.svg": Yoe,
  "../assets/icons/tetrisly/megaphone.svg": Xoe,
  "../assets/icons/tetrisly/menu.svg": one,
  "../assets/icons/tetrisly/message.svg": ine,
  "../assets/icons/tetrisly/mic.svg": ane,
  "../assets/icons/tetrisly/minus.svg": une,
  "../assets/icons/tetrisly/mobile.svg": pne,
  "../assets/icons/tetrisly/more-horizontal.svg": mne,
  "../assets/icons/tetrisly/more-vertical.svg": bne,
  "../assets/icons/tetrisly/mouse.svg": Sne,
  "../assets/icons/tetrisly/navigation.svg": Ane,
  "../assets/icons/tetrisly/notification.svg": Pne,
  "../assets/icons/tetrisly/open-in-new.svg": Tne,
  "../assets/icons/tetrisly/option.svg": kne,
  "../assets/icons/tetrisly/package.svg": One,
  "../assets/icons/tetrisly/paintroller.svg": Zne,
  "../assets/icons/tetrisly/paperplane.svg": zne,
  "../assets/icons/tetrisly/paragraph.svg": Une,
  "../assets/icons/tetrisly/pause-circle.svg": Yne,
  "../assets/icons/tetrisly/pause.svg": Xne,
  "../assets/icons/tetrisly/phone-call.svg": ose,
  "../assets/icons/tetrisly/phone-callback.svg": ise,
  "../assets/icons/tetrisly/phone-forwarded.svg": ase,
  "../assets/icons/tetrisly/phone-incoming.svg": use,
  "../assets/icons/tetrisly/phone-missed.svg": pse,
  "../assets/icons/tetrisly/phone-outgoing.svg": mse,
  "../assets/icons/tetrisly/phone.svg": bse,
  "../assets/icons/tetrisly/pin.svg": Sse,
  "../assets/icons/tetrisly/placeholder-2.svg": Ase,
  "../assets/icons/tetrisly/placeholder.svg": Pse,
  "../assets/icons/tetrisly/play-circle.svg": Tse,
  "../assets/icons/tetrisly/play.svg": kse,
  "../assets/icons/tetrisly/plugin.svg": Ose,
  "../assets/icons/tetrisly/plus.svg": Zse,
  "../assets/icons/tetrisly/print.svg": zse,
  "../assets/icons/tetrisly/questionmark.svg": Use,
  "../assets/icons/tetrisly/quote.svg": Yse,
  "../assets/icons/tetrisly/rainbow.svg": Xse,
  "../assets/icons/tetrisly/receipt.svg": oie,
  "../assets/icons/tetrisly/redo.svg": iie,
  "../assets/icons/tetrisly/refresh.svg": aie,
  "../assets/icons/tetrisly/repeat.svg": uie,
  "../assets/icons/tetrisly/reply.svg": pie,
  "../assets/icons/tetrisly/robot.svg": mie,
  "../assets/icons/tetrisly/scissors.svg": bie,
  "../assets/icons/tetrisly/search.svg": Sie,
  "../assets/icons/tetrisly/settings.svg": Aie,
  "../assets/icons/tetrisly/share.svg": Pie,
  "../assets/icons/tetrisly/shield.svg": Tie,
  "../assets/icons/tetrisly/shirt.svg": kie,
  "../assets/icons/tetrisly/shopping-basket.svg": Oie,
  "../assets/icons/tetrisly/shopping-cart.svg": Zie,
  "../assets/icons/tetrisly/sidebar-hide.svg": zie,
  "../assets/icons/tetrisly/sidebar-show.svg": Uie,
  "../assets/icons/tetrisly/slider.svg": Yie,
  "../assets/icons/tetrisly/speedmeter.svg": Xie,
  "../assets/icons/tetrisly/star-filled.svg": ore,
  "../assets/icons/tetrisly/star-half-filled.svg": ire,
  "../assets/icons/tetrisly/star.svg": are,
  "../assets/icons/tetrisly/stopwatch.svg": ure,
  "../assets/icons/tetrisly/suitcase.svg": pre,
  "../assets/icons/tetrisly/sun.svg": mre,
  "../assets/icons/tetrisly/tablet.svg": bre,
  "../assets/icons/tetrisly/tag.svg": Sre,
  "../assets/icons/tetrisly/target-off.svg": Are,
  "../assets/icons/tetrisly/target.svg": Pre,
  "../assets/icons/tetrisly/terminal-2.svg": Tre,
  "../assets/icons/tetrisly/terminal.svg": kre,
  "../assets/icons/tetrisly/tetrisly.svg": Ore,
  "../assets/icons/tetrisly/text.svg": Zre,
  "../assets/icons/tetrisly/thumb-down.svg": zre,
  "../assets/icons/tetrisly/thumb-up.svg": Ure,
  "../assets/icons/tetrisly/ticket.svg": Yre,
  "../assets/icons/tetrisly/time-clock.svg": Xre,
  "../assets/icons/tetrisly/toggle-off.svg": o1e,
  "../assets/icons/tetrisly/toggle-on.svg": i1e,
  "../assets/icons/tetrisly/transaction-horizontal.svg": a1e,
  "../assets/icons/tetrisly/transaction-vertical.svg": u1e,
  "../assets/icons/tetrisly/tree.svg": p1e,
  "../assets/icons/tetrisly/trend-down.svg": m1e,
  "../assets/icons/tetrisly/trend-up.svg": b1e,
  "../assets/icons/tetrisly/turn-off.svg": S1e,
  "../assets/icons/tetrisly/tv.svg": A1e,
  "../assets/icons/tetrisly/undo.svg": P1e,
  "../assets/icons/tetrisly/unfold-less.svg": T1e,
  "../assets/icons/tetrisly/unfold-more.svg": k1e,
  "../assets/icons/tetrisly/unlock.svg": O1e,
  "../assets/icons/tetrisly/upload.svg": Z1e,
  "../assets/icons/tetrisly/user-check.svg": z1e,
  "../assets/icons/tetrisly/user-close.svg": U1e,
  "../assets/icons/tetrisly/user-edit.svg": Y1e,
  "../assets/icons/tetrisly/user-minus.svg": X1e,
  "../assets/icons/tetrisly/user-plus.svg": ole,
  "../assets/icons/tetrisly/user.svg": ile,
  "../assets/icons/tetrisly/users.svg": ale,
  "../assets/icons/tetrisly/vertical-align-bottom.svg": ule,
  "../assets/icons/tetrisly/vertical-align-center.svg": ple,
  "../assets/icons/tetrisly/vertical-align-top.svg": mle,
  "../assets/icons/tetrisly/video-camera.svg": ble,
  "../assets/icons/tetrisly/video.svg": Sle,
  "../assets/icons/tetrisly/view-boxes.svg": Ale,
  "../assets/icons/tetrisly/view-columns.svg": Ple,
  "../assets/icons/tetrisly/view-dashboard.svg": Tle,
  "../assets/icons/tetrisly/view-day.svg": kle,
  "../assets/icons/tetrisly/view-layout-bottom.svg": Ole,
  "../assets/icons/tetrisly/view-layout-grid.svg": Zle,
  "../assets/icons/tetrisly/view-layout-left.svg": zle,
  "../assets/icons/tetrisly/view-layout-right.svg": Ule,
  "../assets/icons/tetrisly/view-layout-top.svg": Yle,
  "../assets/icons/tetrisly/view-lp.svg": Xle,
  "../assets/icons/tetrisly/view-rows.svg": oae,
  "../assets/icons/tetrisly/view-schedule.svg": iae,
  "../assets/icons/tetrisly/view-slider.svg": aae,
  "../assets/icons/tetrisly/view-table.svg": uae,
  "../assets/icons/tetrisly/voice.svg": pae,
  "../assets/icons/tetrisly/voicemail.svg": mae,
  "../assets/icons/tetrisly/volume-max.svg": bae,
  "../assets/icons/tetrisly/volume-medium.svg": Sae,
  "../assets/icons/tetrisly/volume-min.svg": Aae,
  "../assets/icons/tetrisly/volume-mute.svg": Pae,
  "../assets/icons/tetrisly/wallet.svg": Tae,
  "../assets/icons/tetrisly/warning-fill.svg": kae,
  "../assets/icons/tetrisly/warning.svg": Oae,
  "../assets/icons/tetrisly/watch.svg": Zae,
  "../assets/icons/tetrisly/water-drop.svg": zae,
  "../assets/icons/tetrisly/wifi-off.svg": Uae,
  "../assets/icons/tetrisly/wifi.svg": Yae
}), sd = Object.entries(Qae).reduce(
  (e, t) => {
    var i;
    const [o, n] = t, s = o.split("/");
    return {
      ...e,
      [`${s[s.length - 2] ?? ""}/${((i = s[s.length - 1]) == null ? void 0 : i.split(".svg")[0]) ?? ""}`]: n
    };
  },
  {}
), Jae = pe({
  name: "SCASvgIcon"
}), Xae = /* @__PURE__ */ pe({
  ...Jae,
  props: {
    size: { default: "20px" },
    icon: {},
    mirrorX: { type: Boolean, default: !1 },
    mirrorY: { type: Boolean, default: !1 },
    color: { default: void 0 }
  },
  setup(e) {
    Vn((r) => ({
      d0aae736: n.value,
      v5cc80f7f: s.value
    }));
    const { logger: t } = OA(), o = e, n = F(() => o.size), s = F(() => o.color), i = F(() => {
      try {
        return sd[o.icon] ?? null;
      } catch (r) {
        return t.warn("Icon not found = " + o.icon)(), t.debug("Error = ", r)(), sd["generic/info"] ?? null;
      }
    });
    return (r, l) => (f(), U(Po(i.value), {
      key: e.icon,
      class: S([r.$style.icon, { [r.$style.mirrorX]: e.mirrorX, [r.$style.mirrorY]: e.mirrorY, [r.$style.colorOverride]: !!s.value }])
    }, null, 8, ["class"]));
  }
}), e0e = "_icon_1af12_1", t0e = "_colorOverride_1af12_10", o0e = "_mirrorX_1af12_13", n0e = "_mirrorY_1af12_16", s0e = {
  icon: e0e,
  colorOverride: t0e,
  mirrorX: o0e,
  mirrorY: n0e
}, i0e = {
  $style: s0e
}, Ae = /* @__PURE__ */ Ce(Xae, [["__cssModules", i0e]]), r0e = ["href", "target", "rel"], l0e = /* @__PURE__ */ pe({
  __name: "SCATooltip",
  props: {
    id: {},
    target: {},
    text: {},
    delay: {},
    helpLink: {},
    linkLabel: {},
    styles: {},
    scrollable: { type: Boolean },
    alwaysVisible: { type: Boolean }
  },
  emits: ["link-click"],
  setup(e, { emit: t }) {
    const o = e, n = t, { t: s } = Go(), i = Qt(), r = F(() => !!o.helpLink || !!o.linkLabel || !!o.scrollable || !!i.default);
    function l(E) {
      o.helpLink || (E.preventDefault(), n("link-click"));
    }
    function a(E) {
      const j = E.trim().split(/\s+/);
      return j.length === 1 ? { top: j[0], right: j[0], bottom: j[0], left: j[0] } : j.length === 2 ? { top: j[0], right: j[1], bottom: j[0], left: j[1] } : j.length === 3 ? { top: j[0], right: j[1], bottom: j[2], left: j[1] } : { top: j[0], right: j[1], bottom: j[2], left: j[3] };
    }
    const c = F(() => {
      const E = o.styles, j = {};
      if (E != null && E.fontSize && (j.fontSize = E.fontSize), E != null && E.textColor && (j.color = E.textColor), E != null && E.maxWidth && (j.maxWidth = E.maxWidth), o.scrollable && (E != null && E.contentPadding)) {
        const Z = a(E.contentPadding);
        j.paddingTop = Z.top, j.paddingBottom = Z.bottom;
      }
      return j;
    }), d = F(() => {
      if (!o.scrollable) return {};
      const E = o.styles, j = {};
      if (E != null && E.maxHeight && (j.maxHeight = E.maxHeight), E != null && E.contentPadding) {
        const Z = a(E.contentPadding);
        j.padding = `0 ${Z.right} 0 ${Z.left}`;
      }
      return j;
    }), u = W(null), h = W(null), p = W(null), C = W("top"), m = W(!1);
    let w = null, y = null;
    const b = () => o.target ?? (o.id ? document.getElementById(o.id) : null), _ = () => {
      const E = b(), j = u.value, Z = h.value, Y = p.value;
      if (!E || !j || !Z || !Y) return;
      const le = E.getBoundingClientRect(), ge = Z.getBoundingClientRect(), ce = 8, G = 20;
      let z = le.left + le.width / 2 - ge.width / 2, oe = le.bottom + 6;
      const q = window.innerWidth - ge.width - ce;
      z < ce && (z = ce), z > q && (z = q);
      const ne = window.innerHeight - ge.height - ce;
      oe > ne ? (oe = le.top - ge.height - 8, C.value = "bottom") : C.value = "top", j.style.left = `${Math.round(z)}px`, j.style.top = `${Math.round(oe)}px`;
      const Fe = le.left + le.width / 2, We = z + ge.width / 2, Qe = Fe - We;
      let nt = ge.width / 2 + Qe;
      nt = Math.max(G, Math.min(ge.width - G, nt)), Y.style.left = `${Math.round(nt)}px`, Y.style.transform = "translateX(-50%)";
    }, M = async () => {
      var E, j;
      w = null, m.value = !0, await rt(), _(), (j = (E = u.value) == null ? void 0 : E.showPopover) == null || j.call(E);
    }, x = () => {
      w && clearTimeout(w), w = window.setTimeout(() => {
        M();
      }, o.delay ?? 600);
    }, L = () => {
      var E, j;
      o.alwaysVisible || (y && (clearTimeout(y), y = null), (j = (E = u.value) == null ? void 0 : E.hidePopover) == null || j.call(E), m.value = !1);
    }, A = () => {
      if (w && (clearTimeout(w), w = null), r.value) {
        y && clearTimeout(y), y = window.setTimeout(L, 120);
        return;
      }
      L();
    }, R = () => {
      r.value && y && (clearTimeout(y), y = null);
    }, P = () => {
      r.value && L();
    }, I = (E) => {
      E.addEventListener("mouseenter", x), E.addEventListener("mouseleave", A), E.addEventListener("mousedown", A);
    }, B = (E) => {
      E.removeEventListener("mouseenter", x), E.removeEventListener("mouseleave", A), E.removeEventListener("mousedown", A);
    };
    let H = null, O = null;
    const N = () => {
      if (!o.id) return !1;
      const E = document.getElementById(o.id);
      return E ? (I(E), O = E, !0) : !1;
    }, te = () => {
      m.value && _();
    };
    return At(() => {
      o.id && !N() && (H = new MutationObserver(() => {
        N() && (H == null || H.disconnect(), H = null);
      }), H.observe(document.body, { childList: !0, subtree: !0 })), window.addEventListener("scroll", te, !0), window.addEventListener("resize", te), o.alwaysVisible && M();
    }), Me(
      () => o.target,
      (E, j) => {
        j && B(j), E && I(E), E && m.value && rt().then(_);
      },
      { immediate: !0 }
    ), ei(() => {
      O && B(O), o.target && B(o.target), H == null || H.disconnect(), H = null, w && clearTimeout(w), y && clearTimeout(y), window.removeEventListener("scroll", te, !0), window.removeEventListener("resize", te);
    }), (E, j) => (f(), v(we, null, [
      m.value ? (f(), v("div", {
        key: 0,
        ref_key: "measureRef",
        ref: h,
        class: S([E.$style.tooltip, { [E.$style.interactive]: r.value, [E.$style.scrollableTooltip]: !!e.scrollable }]),
        style: Ge([c.value, { position: "fixed", top: "-9999px", left: "-9999px", visibility: "hidden" }]),
        "aria-hidden": "true"
      }, [
        g("div", {
          class: S([E.$style.content, { [E.$style.scrollableContent]: !!e.scrollable }]),
          style: Ge(d.value)
        }, [
          g("div", {
            class: S(E.$style.text)
          }, [
            ve(E.$slots, "default", {}, () => [
              Ve(se(e.text), 1)
            ])
          ], 2),
          e.helpLink || e.linkLabel ? (f(), v("a", {
            key: 0,
            class: S(E.$style.helpLink)
          }, se(e.linkLabel ?? k(s)("common.label.help")), 3)) : $("", !0)
        ], 6)
      ], 6)) : $("", !0),
      m.value ? (f(), U(D5, {
        key: 1,
        to: "body"
      }, [
        g("div", {
          ref_key: "tooltipRef",
          ref: u,
          class: S([E.$style.tooltip, { [E.$style.interactive]: r.value, [E.$style.scrollableTooltip]: !!e.scrollable }]),
          style: Ge(c.value),
          popover: "manual",
          onMouseenter: R,
          onMouseleave: P
        }, [
          g("div", {
            class: S([E.$style.content, { [E.$style.scrollableContent]: !!e.scrollable }]),
            style: Ge(d.value)
          }, [
            g("div", {
              class: S(E.$style.text)
            }, [
              ve(E.$slots, "default", {}, () => [
                Ve(se(e.text), 1)
              ])
            ], 2),
            e.helpLink || e.linkLabel ? (f(), v("a", {
              key: 0,
              class: S(E.$style.helpLink),
              href: e.helpLink,
              target: e.helpLink ? "_blank" : void 0,
              rel: e.helpLink ? "noopener noreferrer" : void 0,
              onClick: l
            }, se(e.linkLabel ?? k(s)("common.label.help")), 11, r0e)) : $("", !0)
          ], 6),
          g("div", {
            ref_key: "arrowRef",
            ref: p,
            class: S([E.$style.arrow, C.value === "top" ? E.$style.arrowTop : E.$style.arrowBottom]),
            "aria-hidden": "true"
          }, [...j[0] || (j[0] = [
            g("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              width: "10",
              height: "5",
              viewBox: "0 0 10 5",
              preserveAspectRatio: "none"
            }, [
              g("path", {
                d: "M0.515137 4.05811H9.51514L6.0758 0.618764C5.49001 0.0329781 4.54026 0.0329795 3.95448 0.618766L0.515137 4.05811Z",
                fill: "currentColor"
              })
            ], -1)
          ])], 2)
        ], 38)
      ])) : $("", !0)
    ], 64));
  }
}), a0e = "_tooltip_1toex_1", c0e = "_scrollableTooltip_1toex_22", d0e = "_scrollableContent_1toex_26", u0e = "_interactive_1toex_32", h0e = "_content_1toex_32", g0e = "_text_1toex_39", p0e = "_helpLink_1toex_44", f0e = "_arrow_1toex_51", v0e = "_arrowTop_1toex_65", m0e = "_arrowBottom_1toex_72", C0e = {
  tooltip: a0e,
  scrollableTooltip: c0e,
  scrollableContent: d0e,
  interactive: u0e,
  content: h0e,
  text: g0e,
  helpLink: p0e,
  arrow: f0e,
  arrowTop: v0e,
  arrowBottom: m0e
}, w0e = {
  $style: C0e
}, bo = /* @__PURE__ */ Ce(l0e, [["__cssModules", w0e]]), b0e = /* @__PURE__ */ pe({
  __name: "SCAButton",
  props: {
    type: { default: "default" },
    size: { default: "medium" },
    iconLeft: { default: void 0 },
    iconRight: { default: void 0 },
    iconSize: { default: void 0 },
    iconMirrorX: { type: Boolean, default: !1 },
    iconMirrorY: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    hasDropdown: { type: Boolean, default: !1 },
    intent: { default: "none" },
    loading: { type: Boolean, default: !1 },
    selected: { type: Boolean, default: !1 },
    appearance: { default: "primary" },
    shadow: { type: Boolean, default: !0 },
    title: { default: void 0 },
    tooltip: { default: void 0 },
    gap: { default: "8px" },
    paddingLeft: { default: void 0 },
    paddingRight: { default: void 0 },
    as: { default: "button" }
  },
  setup(e) {
    const t = e, o = `btn-${Date.now().toString(36)}-${Math.random().toString(36).substring(2, 8)}`, n = F(() => t.as === "button"), s = F(() => !n.value && (t.disabled || t.loading)), i = F(() => t.tooltip ?? t.title), r = F(() => ({
      "--button-gap": t.gap,
      "--button-padding-left": t.paddingLeft ?? "12px",
      "--button-padding-right": t.paddingRight ?? "12px"
    }));
    return (l, a) => (f(), U(Po(e.as), {
      id: o,
      class: S([
        l.$style.button,
        {
          [l.$style.typeDefault]: e.type === "default",
          [l.$style.typeGhost]: e.type === "ghost",
          [l.$style.typeBare]: e.type === "bare",
          [l.$style.typeToggle]: e.type === "toggle",
          [l.$style.primary]: e.appearance === "primary",
          [l.$style.secondary]: e.appearance === "secondary",
          [l.$style.inverted]: e.appearance === "inverted",
          [l.$style.reverseInverted]: e.appearance === "reverseInverted",
          [l.$style.sizeSmall]: e.size === "xsmall",
          [l.$style.sizeSmall]: e.size === "small",
          [l.$style.sizeMedium]: e.size === "medium",
          [l.$style.sizeLarge]: e.size === "large",
          [l.$style.intentNone]: e.intent === "none",
          [l.$style.intentSuccess]: e.intent === "success",
          [l.$style.intentDestructive]: e.intent === "destructive",
          [l.$style.shadow]: e.shadow,
          [l.$style.selected]: e.selected,
          [l.$style.hasIconLeft]: !!e.iconLeft,
          [l.$style.inert]: s.value
        }
      ]),
      style: Ge(r.value),
      "data-type": e.type,
      type: n.value ? "button" : void 0,
      disabled: n.value ? e.disabled || e.loading : void 0,
      "aria-disabled": s.value || void 0,
      tabindex: s.value ? -1 : void 0
    }, {
      default: ee(() => [
        e.iconLeft && !e.loading ? (f(), U(Ae, {
          key: 0,
          icon: e.iconLeft,
          size: e.iconSize,
          "mirror-x": e.iconMirrorX,
          "mirror-y": e.iconMirrorY
        }, null, 8, ["icon", "size", "mirror-x", "mirror-y"])) : $("", !0),
        e.iconLeft && e.loading ? (f(), U(i1, {
          key: 1,
          size: "small",
          appearance: e.appearance === "inverted" || e.type === "default" && e.appearance === "primary" ? "white" : "greyscale",
          indeterminate: ""
        }, null, 8, ["appearance"])) : $("", !0),
        l.$slots.default ? (f(), v("span", {
          key: 2,
          class: S(l.$style.label)
        }, [
          ve(l.$slots, "default")
        ], 2)) : $("", !0),
        ve(l.$slots, "special"),
        e.iconRight ? (f(), U(Ae, {
          key: 3,
          icon: e.iconRight,
          size: e.iconSize
        }, null, 8, ["icon", "size"])) : $("", !0),
        e.hasDropdown ? (f(), U(Ae, {
          key: 4,
          icon: "phosphor/caret-down-double-btn",
          size: "9px"
        })) : $("", !0),
        e.tooltip || e.title ? (f(), U(bo, {
          key: 5,
          id: o,
          text: i.value ?? ""
        }, null, 8, ["text"])) : $("", !0)
      ]),
      _: 3
    }, 8, ["class", "style", "data-type", "type", "disabled", "aria-disabled", "tabindex"]));
  }
}), y0e = "_button_1x1rn_747", _0e = "_sizeSmall_1x1rn_761", S0e = "_hasIconLeft_1x1rn_771", x0e = "_sizeMedium_1x1rn_774", M0e = "_sizeLarge_1x1rn_783", A0e = "_inert_1x1rn_798", L0e = "_typeDefault_1x1rn_805", E0e = "_shadow_1x1rn_810", P0e = "_primary_1x1rn_813", R0e = "_intentNone_1x1rn_813", F0e = "_selected_1x1rn_819", T0e = "_intentSuccess_1x1rn_822", I0e = "_intentDestructive_1x1rn_834", D0e = "_secondary_1x1rn_846", k0e = "_inverted_1x1rn_895", H0e = "_typeGhost_1x1rn_906", V0e = "_reverseInverted_1x1rn_990", O0e = "_typeBare_1x1rn_1001", B0e = "_typeToggle_1x1rn_1097", $0e = "_label_1x1rn_1139", Z0e = {
  button: y0e,
  sizeSmall: _0e,
  hasIconLeft: S0e,
  sizeMedium: x0e,
  sizeLarge: M0e,
  inert: A0e,
  typeDefault: L0e,
  shadow: E0e,
  primary: P0e,
  intentNone: R0e,
  selected: F0e,
  intentSuccess: T0e,
  intentDestructive: I0e,
  secondary: D0e,
  inverted: k0e,
  typeGhost: H0e,
  reverseInverted: V0e,
  typeBare: O0e,
  typeToggle: B0e,
  label: $0e
}, G0e = {
  $style: Z0e
}, It = /* @__PURE__ */ Ce(b0e, [["__cssModules", G0e]]), N0e = /* @__PURE__ */ pe({
  __name: "SCAIconButton",
  props: {
    type: { default: "default" },
    size: { default: "medium" },
    icon: {},
    iconSize: { default: void 0 },
    iconMirrorX: { type: Boolean, default: !1 },
    iconMirrorY: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    hasDropdown: { type: Boolean, default: !1 },
    intent: { default: "none" },
    loading: { type: Boolean, default: !1 },
    selected: { type: Boolean, default: !1 },
    appearance: { default: "primary" },
    as: { default: "button" }
  },
  setup(e) {
    return (t, o) => (f(), U(It, {
      as: e.as,
      class: S([
        t.$style.button,
        {
          [t.$style.typeBare]: e.type === "bare",
          [t.$style.xsmall]: e.size === "xsmall",
          [t.$style.sizeSmall]: e.size === "small",
          [t.$style.sizeMedium]: e.size === "medium",
          [t.$style.sizeLarge]: e.size === "large",
          [t.$style.dropDown]: e.hasDropdown
        }
      ]),
      "icon-left": e.icon,
      "icon-size": e.iconSize,
      "icon-mirror-x": e.iconMirrorX,
      "icon-mirror-y": e.iconMirrorY,
      type: e.type,
      size: e.size,
      disabled: e.disabled,
      "has-dropdown": e.hasDropdown,
      intent: e.intent,
      selected: e.selected,
      appearance: e.appearance
    }, null, 8, ["as", "class", "icon-left", "icon-size", "icon-mirror-x", "icon-mirror-y", "type", "size", "disabled", "has-dropdown", "intent", "selected", "appearance"]));
  }
}), z0e = "_button_129ut_747", j0e = "_typeBare_129ut_751", W0e = "_xsmall_129ut_751", U0e = "_dropDown_129ut_756", K0e = "_sizeSmall_129ut_759", q0e = "_sizeMedium_129ut_767", Y0e = "_sizeLarge_129ut_775", Q0e = {
  button: z0e,
  typeBare: j0e,
  xsmall: W0e,
  dropDown: U0e,
  sizeSmall: K0e,
  sizeMedium: q0e,
  sizeLarge: Y0e
}, J0e = {
  $style: Q0e
}, ot = /* @__PURE__ */ Ce(N0e, [["__cssModules", J0e]]), X0e = ["id", "data-popover-open"], id = 300, e5e = /* @__PURE__ */ pe({
  __name: "SCADropdown",
  props: {
    placement: { default: "bottom-start" },
    offsetX: { default: void 0 },
    offsetY: { default: void 0 },
    matchTriggerWidth: { default: void 0 },
    scrollUp: { type: Boolean, default: !1 },
    scrollDown: { type: Boolean, default: !1 },
    triggerAlign: { default: "horizontal" },
    isOpen: { type: Boolean, default: !1 },
    lessBorder: { type: Boolean, default: !1 },
    noBorder: { type: Boolean, default: !1 },
    noPadding: { type: Boolean, default: !1 },
    morePadding: { type: Boolean, default: !1 },
    shadowVariant: { default: "default" },
    trigger: { default: "click" },
    noMobileMargin: { type: Boolean, default: !1 },
    toolbarOffset: { type: Boolean, default: !1 },
    width: { default: void 0 },
    paddingUpset: { type: Boolean },
    gap: { default: void 0 }
  },
  emits: ["opened", "closed", "positioned", "update:isOpen"],
  setup(e, { expose: t, emit: o }) {
    const n = e, s = o, i = cP(), r = W(), l = W(), a = W(), c = W(), d = W(), u = oo(n, "isOpen", s, { passive: !0 }), h = od(c), p = od(d), C = W(!1), m = W(!1), w = W(!1);
    let y;
    const b = W(null), _ = W(null), M = W(!1), x = W(!1);
    function L() {
      var ne;
      u.value && ((ne = r.value) == null || ne.hidePopover());
    }
    t({
      popoverId: i,
      hideNow: L
    });
    function A(ne) {
      var Fe;
      (Fe = r.value) == null || Fe.togglePopover(ne == null ? void 0 : ne.force);
    }
    function R(ne) {
      ne.newState === "open" && (w.value = !0);
    }
    function P(ne) {
      if (u.value = ne.newState === "open", ne.newState === "closed" && (w.value = !1), ne.newState !== ne.oldState) {
        if (ne.newState === "open") {
          C.value = !0, s("opened"), setTimeout(() => {
            m.value = !0;
          }, id);
          return;
        }
        C.value = !1, s("closed"), m.value = !1;
      }
    }
    Me(u, (ne) => {
      ne && setTimeout(() => {
        C.value = !1;
      }, id);
    });
    const I = F(() => n.matchTriggerWidth === "exact" ? "width" : n.matchTriggerWidth === "min" ? "min-width" : n.matchTriggerWidth === "max" ? "max-width" : void 0), B = () => {
      var ne;
      y && (clearTimeout(y), y = void 0), (ne = r.value) == null || ne.showPopover();
    }, H = () => {
      y && clearTimeout(y), y = setTimeout(() => {
        var ne;
        (ne = r.value) == null || ne.hidePopover();
      }, 200);
    }, O = F(() => n.placement);
    function N() {
      const ne = r.value;
      ne && (ne.style.maxHeight = "", ne.style.width = "", ne.style.minWidth = "", ne.style.maxWidth = "");
    }
    const te = F(() => {
      const ne = n.offsetY ?? (n.toolbarOffset ? 7.5 : void 0);
      return [
        J7({ mainAxis: ne, crossAxis: n.offsetX }),
        e3({
          fallbackStrategy: "bestFit"
        }),
        X7({
          crossAxis: !0
        }),
        RE({
          apply({ rects: Fe, elements: We, availableHeight: Qe }) {
            I.value && Object.assign(We.floating.style, {
              [I.value]: `${Fe.reference.width}px`
            }), Object.assign(We.floating.style, {
              maxHeight: `${Math.max(0, Qe)}px`
            });
          }
        })
      ];
    }), { floatingStyles: E, update: j } = DE(a, r, {
      placement: O,
      middleware: te,
      strategy: "fixed"
    });
    Me(r, () => {
      r.value && j();
    });
    let Z, Y = 0;
    Me(u, (ne, Fe) => {
      if (ne ? document.addEventListener("touchstart", q, { capture: !0, passive: !0 }) : document.removeEventListener("touchstart", q, { capture: !0 }), ne !== Fe && (u.value && (w.value = !0), A({ force: u.value })), !u.value) {
        Z == null || Z(), Z = void 0;
        return;
      }
      if (Z == null || Z(), u.value && a.value && r.value) {
        const We = ++Y;
        rt(() => {
          requestAnimationFrame(() => {
            !u.value || !a.value || !r.value || (N(), Promise.resolve(j()).then(() => rt()).then(() => {
              We === Y && (w.value = !1, rt(() => s("positioned")));
            }), Z = W0(a.value, r.value, j, {
              animationFrame: !1
            }));
          });
        });
        return;
      }
      w.value = !1;
    });
    function le(ne) {
      var Fe;
      n.trigger === "hover" && u.value && (Fe = ne.target) != null && Fe.closest("button[popovertarget], input[popovertarget]") && ne.preventDefault();
    }
    function ge(ne) {
      x.value = ne.pointerType !== "mouse";
    }
    function ce(ne) {
      x.value && ne.preventDefault();
    }
    function G() {
      n.trigger === "hover" && (_.value = Date.now(), M.value = !1, b.value = setTimeout(() => {
        M.value || B();
      }, 500));
    }
    function z() {
      M.value = !0, b.value && clearTimeout(b.value);
    }
    function oe(ne) {
      b.value && clearTimeout(b.value), _.value && n.trigger === "hover" && Date.now() - _.value >= 500 && !M.value && ne.cancelable && ne.preventDefault(), _.value = null, M.value = !1;
    }
    const q = (ne) => {
      a.value && !a.value.contains(ne.target) && u.value && H();
    };
    return Qi(() => {
      document.removeEventListener("touchstart", q, { capture: !0 }), Z == null || Z();
    }), (ne, Fe) => (f(), v("div", {
      ref_key: "dropdownRef",
      ref: a,
      class: S(ne.$style.dropdown)
    }, [
      g("div", {
        ref_key: "triggerRef",
        ref: l,
        class: S([ne.$style.trigger, k(u) && ne.$style.triggerOpen]),
        onMouseenter: Fe[2] || (Fe[2] = (We) => n.trigger === "hover" ? B() : null),
        onMouseleave: Fe[3] || (Fe[3] = (We) => n.trigger === "hover" ? H() : null),
        onClickCapture: le,
        onPointerdownPassive: ge,
        onTouchstartPassive: G,
        onTouchmovePassive: z,
        onTouchend: oe,
        onContextmenu: ce
      }, [
        ve(ne.$slots, "trigger", {
          target: k(i),
          isOpen: k(u),
          togglePopover: A,
          popover: r.value,
          onMouseenter: Fe[0] || (Fe[0] = (We) => n.trigger === "hover" ? B() : null),
          onMouseleave: Fe[1] || (Fe[1] = (We) => n.trigger === "hover" ? H() : null)
        }, () => [
          de(ot, {
            popovertarget: k(i),
            size: "small",
            type: "ghost",
            appearance: "secondary",
            icon: `tetrisly/more-${e.triggerAlign}`
          }, null, 8, ["popovertarget", "icon"])
        ])
      ], 34),
      g("div", {
        id: k(i),
        ref_key: "popoverRef",
        ref: r,
        class: S([
          ne.$style.popover,
          e.lessBorder && ne.$style.lessBorder,
          e.noBorder && ne.$style.noBorder,
          (e.noPadding || e.paddingUpset) && ne.$style.noPadding,
          e.shadowVariant === "upward" && ne.$style.shadowUpward,
          m.value && ne.$style.withTransition,
          e.noMobileMargin && ne.$style.noMobileMargin,
          w.value && ne.$style.positioning
        ]),
        popover: "",
        "data-popover-open": k(u) || void 0,
        style: Ge({ transform: k(E).transform }),
        onBeforetoggle: R,
        onToggle: P,
        onMouseenter: Fe[4] || (Fe[4] = (We) => n.trigger === "hover" ? B() : null),
        onMouseleave: Fe[5] || (Fe[5] = (We) => n.trigger === "hover" ? H() : null)
      }, [
        k(u) ? (f(), v("div", {
          key: 0,
          class: S([ne.$style.inner, C.value && ne.$style.animate]),
          style: Ge(n.width ? { width: n.width } : void 0)
        }, [
          e.scrollUp ? (f(), U(Ae, {
            key: 0,
            class: S([ne.$style.scrollIconTop, { [ne.$style.hidden]: k(h) }]),
            icon: "tetrisly/16-chevron-top",
            size: "16px"
          }, null, 8, ["class"])) : $("", !0),
          g("div", {
            class: S([ne.$style.content, e.paddingUpset && ne.$style.paddingUnset, e.morePadding && ne.$style.morePadding])
          }, [
            g("div", {
              ref_key: "topRef",
              ref: c
            }, null, 512),
            g("div", {
              class: S(ne.$style.items),
              style: Ge(n.gap ? { gap: `${n.gap}px` } : void 0)
            }, [
              ve(ne.$slots, "default", { popover: r.value })
            ], 6),
            g("div", {
              ref_key: "bottomRef",
              ref: d
            }, null, 512)
          ], 2),
          e.scrollDown ? (f(), U(Ae, {
            key: 1,
            class: S([ne.$style.scrollIconBottom, { [ne.$style.hidden]: k(p) }]),
            icon: "tetrisly/16-chevron-down",
            size: "16px"
          }, null, 8, ["class"])) : $("", !0)
        ], 6)) : $("", !0)
      ], 46, X0e)
    ], 2));
  }
}), t5e = "_dropdown_35xyj_1", o5e = "_trigger_35xyj_8", n5e = "_popover_35xyj_12", s5e = "_withTransition_35xyj_31", i5e = "_positioning_35xyj_35", r5e = "_inner_35xyj_39", l5e = "_animate_35xyj_43", a5e = "_lessBorder_35xyj_54", c5e = "_noBorder_35xyj_58", d5e = "_noPadding_35xyj_62", u5e = "_shadowUpward_35xyj_66", h5e = "_scrollIconTop_35xyj_70", g5e = "_scrollIconBottom_35xyj_71", p5e = "_hidden_35xyj_85", f5e = "_content_35xyj_89", v5e = "_morePadding_35xyj_93", m5e = "_items_35xyj_98", C5e = "_paddingUnset_35xyj_104", w5e = "_noMobileMargin_35xyj_114", b5e = {
  dropdown: t5e,
  trigger: o5e,
  popover: n5e,
  withTransition: s5e,
  positioning: i5e,
  inner: r5e,
  animate: l5e,
  lessBorder: a5e,
  noBorder: c5e,
  noPadding: d5e,
  shadowUpward: u5e,
  scrollIconTop: h5e,
  scrollIconBottom: g5e,
  hidden: p5e,
  content: f5e,
  morePadding: v5e,
  items: m5e,
  paddingUnset: C5e,
  noMobileMargin: w5e
}, y5e = {
  $style: b5e
}, zt = /* @__PURE__ */ Ce(e5e, [["__cssModules", y5e]]), _5e = ["underline-override"], S5e = /* @__PURE__ */ pe({
  __name: "SCAInputBase",
  props: {
    alert: { type: Boolean, default: !1 },
    appearance: { default: void 0 },
    fixedWidth: { type: Boolean, default: !1 },
    underlineOverride: { type: Boolean, default: void 0 },
    fixedHeight: { type: Boolean, default: !1 },
    focused: { type: Boolean, default: !1 },
    inverted: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = Qt();
    return (o, n) => (f(), v("div", {
      class: S([
        o.$style.root,
        {
          [o.$style.fixedWidth]: e.fixedWidth
        }
      ])
    }, [
      g("div", {
        class: S([
          o.$style.inputBase,
          {
            [o.$style.alert]: e.alert,
            [o.$style.focused]: e.focused,
            [o.$style.fixedWidth]: e.fixedWidth,
            [o.$style.fixedHeight]: e.fixedHeight,
            [o.$style.hasBefore]: k(t).before,
            [o.$style.hasAfter]: k(t).after,
            [o.$style.appearanceBorder]: e.appearance === "border",
            [o.$style.appearanceTypoHeaderXlarge]: e.appearance === "typo-header-xlarge",
            [o.$style.appearanceNoBorder]: e.appearance === "no-border",
            [o.$style.appearanceBottomBorder]: e.appearance === "bottom-border",
            [o.$style.inverted]: e.inverted
          }
        ])
      }, [
        ve(o.$slots, "before"),
        g("div", {
          ref: "inputContainer",
          class: S(o.$style.inputContainer),
          "underline-override": e.underlineOverride
        }, [
          ve(o.$slots, "default")
        ], 10, _5e),
        ve(o.$slots, "after")
      ], 2),
      k(t).footer ? (f(), v("div", {
        key: 0,
        class: S(o.$style.footer)
      }, [
        ve(o.$slots, "footer")
      ], 2)) : $("", !0)
    ], 2));
  }
}), x5e = "_root_1ca6d_752", M5e = "_fixedWidth_1ca6d_757", A5e = "_inputBase_1ca6d_762", L5e = "_hasBefore_1ca6d_781", E5e = "_hasAfter_1ca6d_784", P5e = "_inputContainer_1ca6d_787", R5e = "_appearanceBorder_1ca6d_898", F5e = "_alert_1ca6d_901", T5e = "_focused_1ca6d_901", I5e = "_inverted_1ca6d_942", D5e = "_appearanceTypoHeaderXlarge_1ca6d_968", k5e = "_appearanceBottomBorder_1ca6d_1005", H5e = "_appearanceNoBorder_1ca6d_1033", V5e = "_fixedHeight_1ca6d_1037", O5e = "_footer_1ca6d_1041", B5e = {
  root: x5e,
  fixedWidth: M5e,
  inputBase: A5e,
  hasBefore: L5e,
  hasAfter: E5e,
  inputContainer: P5e,
  appearanceBorder: R5e,
  alert: F5e,
  focused: T5e,
  inverted: I5e,
  appearanceTypoHeaderXlarge: D5e,
  appearanceBottomBorder: k5e,
  appearanceNoBorder: H5e,
  fixedHeight: V5e,
  footer: O5e
}, $5e = {
  $style: B5e
}, $r = /* @__PURE__ */ Ce(S5e, [["__cssModules", $5e]]), Z5e = {
  maxMonths: 12,
  showWeekNumbers: !0,
  weekStartsOn: 1,
  min: null,
  max: null,
  disabledDate: void 0,
  minuteStep: 15
}, G5e = ["dateRange", "datetimeRange", "timeRange"], N5e = ["time", "datetime", "datetimeRange", "timeRange"], z5e = ["date", "datetime", "dateRange", "datetimeRange"];
function HC(e) {
  return G5e.includes(e);
}
function _s(e) {
  return N5e.includes(e);
}
function rd(e) {
  return z5e.includes(e);
}
const j5e = { key: 1 }, W5e = /* @__PURE__ */ pe({
  __name: "SCAHelperText",
  props: {
    intent: { default: void 0 },
    hasNoneIntentIcon: { type: Boolean, default: !1 },
    showIcon: { type: Boolean, default: !0 }
  },
  setup(e) {
    const t = e, o = F(() => {
      switch (t.intent) {
        case "alert":
          return "phosphor/info";
        case "success":
          return "tetrisly/check-large";
        default:
          return "tetrisly/info-fill";
      }
    });
    return (n, s) => (f(), v("div", {
      class: S([n.$style.helperText, { [n.$style.alert]: e.intent === "alert", [n.$style.success]: e.intent === "success" }])
    }, [
      (e.intent || e.hasNoneIntentIcon) && e.showIcon ? (f(), U(Ae, {
        key: 0,
        class: S([n.$style.svg, { [n.$style.alert]: e.intent === "alert", [n.$style.success]: e.intent === "success" }]),
        icon: o.value,
        size: "12px"
      }, null, 8, ["class", "icon"])) : $("", !0),
      n.$slots.default ? (f(), v("span", j5e, [
        ve(n.$slots, "default")
      ])) : $("", !0)
    ], 2));
  }
}), U5e = "_helperText_1lmil_747", K5e = "_alert_1lmil_763", q5e = "_success_1lmil_766", Y5e = {
  helperText: U5e,
  alert: K5e,
  success: q5e
}, Q5e = {
  $style: Y5e
}, r1 = /* @__PURE__ */ Ce(W5e, [["__cssModules", Q5e]]), J5e = ["for"], X5e = /* @__PURE__ */ pe({
  __name: "SCALabel",
  props: {
    appearance: { default: void 0 },
    optional: { type: Boolean, default: !1 },
    optionalText: { default: void 0 },
    required: { type: Boolean, default: !1 },
    htmlFor: { default: void 0 },
    highlited: { type: Boolean, default: !1 },
    tooltipType: { default: "default" },
    tooltipId: { default: void 0 },
    tooltip: { default: void 0 },
    helpLink: { default: void 0 }
  },
  setup(e) {
    const t = e, o = F(() => {
      var p;
      return !!((p = t.tooltip) != null && p.trim());
    }), n = W(!1), s = W(""), i = W(null), r = () => {
      if (i.value) {
        const p = i.value;
        n.value = p.scrollWidth > p.clientWidth, s.value = p.textContent ?? "";
      }
    };
    let l = null;
    const a = () => {
      l && clearTimeout(l), l = window.setTimeout(() => {
        r(), l = null;
      }, 50);
    };
    At(() => {
      r(), window.addEventListener("resize", a);
    }), ei(() => {
      window.removeEventListener("resize", a), l && clearTimeout(l);
    });
    const c = Qt(), d = `lbl-${Date.now().toString(36)}-${Math.random().toString(36).substring(2, 8)}`, u = F(() => {
      const p = c.labelIcon;
      return p ? p({}).some((m) => !(!m || Array.isArray(m.children) && m.children.length === 0)) : !1;
    }), h = F(() => {
      var C;
      const p = (C = c.labelActionLabel) == null ? void 0 : C.call(c, {});
      return p ? p.filter((m) => m.type !== Comment).length : 0;
    });
    return (p, C) => {
      const m = k5("tooltip");
      return f(), v("div", {
        class: S(p.$style.root)
      }, [
        g("label", {
          class: S([
            p.$style.label,
            {
              [p.$style.appearanceTop]: e.appearance === "top",
              [p.$style.highlighted]: e.highlited
            }
          ]),
          for: e.htmlFor
        }, [
          g("div", {
            class: S(p.$style.labelContent)
          }, [
            Et((f(), v("span", {
              id: d,
              ref_key: "textRef",
              ref: i,
              class: S([p.$style.labelText, { [p.$style.required]: e.required }])
            }, [
              ve(p.$slots, "default")
            ], 2)), [
              [m, e.tooltipId]
            ]),
            t.optionalText || t.optional ? (f(), v("span", {
              key: 0,
              class: S(p.$style.optional)
            }, se(e.optionalText ?? p.$t("common.label.optional")), 3)) : $("", !0),
            u.value ? (f(), v("div", {
              key: 1,
              class: S(p.$style.labelIcon)
            }, [
              ve(p.$slots, "labelIcon")
            ], 2)) : $("", !0)
          ], 2),
          e.tooltipType === "default" && (o.value || n.value) ? (f(), U(bo, {
            key: 0,
            id: d,
            text: o.value ? e.tooltip ?? "" : s.value,
            "help-link": o.value ? e.helpLink : void 0
          }, null, 8, ["text", "help-link"])) : $("", !0)
        ], 10, J5e),
        p.$slots.labelActionLabel ? (f(), v("div", {
          key: 0,
          class: S([p.$style.labelActionContainer, h.value < 2 ? p.$style.noGap : ""])
        }, [
          ve(p.$slots, "labelActionLabel")
        ], 2)) : $("", !0)
      ], 2);
    };
  }
}), e2e = "_root_1tv8r_1", t2e = "_labelActionContainer_1tv8r_7", o2e = "_noGap_1tv8r_13", n2e = "_label_1tv8r_7", s2e = "_labelContent_1tv8r_33", i2e = "_labelText_1tv8r_39", r2e = "_optional_1tv8r_47", l2e = "_labelIcon_1tv8r_52", a2e = "_highlighted_1tv8r_57", c2e = "_appearanceTop_1tv8r_68", d2e = {
  root: e2e,
  labelActionContainer: t2e,
  noGap: o2e,
  label: n2e,
  labelContent: s2e,
  labelText: i2e,
  optional: r2e,
  labelIcon: l2e,
  highlighted: a2e,
  appearanceTop: c2e
}, u2e = {
  $style: d2e
}, h2e = /* @__PURE__ */ Ce(X5e, [["__cssModules", u2e]]), g2e = ["data-has-error"], p2e = /* @__PURE__ */ pe({
  __name: "SCAInputWrapper",
  props: {
    label: { default: void 0 },
    labelPosition: { default: void 0 },
    optionalLabelText: { default: void 0 },
    appearance: { default: void 0 },
    helperText: { default: void 0 },
    validationError: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    htmlFor: { default: void 0 },
    highlightLabel: { type: Boolean, default: !1 },
    tooltipType: { default: "default" },
    tooltipId: { default: void 0 },
    tooltip: { default: void 0 },
    helpLink: { default: void 0 }
  },
  emits: ["labelClick"],
  setup(e, { emit: t }) {
    const o = e, n = t, s = F(
      () => o.labelPosition !== "hidden" && (o.label !== void 0 || o.optionalLabelText !== void 0)
    );
    return (i, r) => (f(), v("div", {
      class: S([
        i.$style.root,
        {
          [i.$style.hasLabel]: s.value,
          [i.$style.hasHelperText]: e.helperText,
          [i.$style.labelPositionTop]: e.labelPosition === "top",
          [i.$style.appearanceTypoHeaderXlarge]: e.appearance === "typo-header-xlarge"
        }
      ]),
      "data-has-error": e.validationError || void 0
    }, [
      s.value ? (f(), U(h2e, {
        key: 0,
        class: S([i.$style.label, { [i.$style.highlightLabel]: e.highlightLabel }]),
        "optional-text": e.optionalLabelText,
        required: e.required,
        appearance: e.labelPosition === "top" ? "top" : e.appearance === "typo-header-xlarge" ? "typo-header-xlarge" : void 0,
        "html-for": e.htmlFor,
        highlited: e.highlightLabel,
        "tooltip-type": e.tooltipType,
        "tooltip-id": e.tooltipId,
        tooltip: e.tooltip,
        "help-link": e.helpLink,
        onClick: r[0] || (r[0] = (l) => n("labelClick", l))
      }, {
        labelActionLabel: ee(() => [
          ve(i.$slots, "labelActionWrapper")
        ]),
        labelIcon: ee(() => [
          ve(i.$slots, "labelIcon")
        ]),
        default: ee(() => [
          Ve(se(e.label) + " ", 1)
        ]),
        _: 3
      }, 8, ["class", "optional-text", "required", "appearance", "html-for", "highlited", "tooltip-type", "tooltip-id", "tooltip", "help-link"])) : $("", !0),
      g("div", null, [
        ve(i.$slots, "default"),
        e.helperText ? (f(), U(r1, {
          key: 0,
          intent: e.validationError ? "alert" : void 0,
          "show-icon": !1,
          class: S(i.$style.helperText)
        }, {
          default: ee(() => [
            Ve(se(e.helperText), 1)
          ]),
          _: 1
        }, 8, ["intent", "class"])) : $("", !0)
      ])
    ], 10, g2e));
  }
}), f2e = "_root_ak6ha_1", v2e = "_hasLabel_ak6ha_9", m2e = "_label_ak6ha_13", C2e = "_input_ak6ha_17", w2e = "_helperText_ak6ha_21", b2e = "_hasHelperText_ak6ha_25", y2e = "_labelPositionTop_ak6ha_28", _2e = "_appearanceTypoHeaderXlarge_ak6ha_64", S2e = {
  root: f2e,
  hasLabel: v2e,
  label: m2e,
  input: C2e,
  helperText: w2e,
  hasHelperText: b2e,
  labelPositionTop: y2e,
  appearanceTypoHeaderXlarge: _2e
}, x2e = {
  $style: S2e
}, Is = /* @__PURE__ */ Ce(p2e, [["__cssModules", x2e]]), M2e = /* @__PURE__ */ pe({
  __name: "SCAInput",
  props: {
    label: { default: void 0 },
    labelPosition: { default: void 0 },
    appearance: { default: void 0 },
    helperText: { default: void 0 },
    optionalLabelText: { default: void 0 },
    htmlFor: { default: void 0 },
    validationError: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    prefix: { default: void 0 },
    highlightLabel: { type: Boolean, default: !1 },
    tooltipType: { default: "default" },
    tooltipId: { default: void 0 },
    tooltip: { default: void 0 },
    helpLink: { default: void 0 },
    focused: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = Qt();
    return (o, n) => (f(), U(Is, {
      label: e.label,
      "label-position": e.labelPosition,
      appearance: e.appearance,
      "helper-text": e.helperText,
      "optional-label-text": e.optionalLabelText,
      "validation-error": e.validationError,
      required: e.required,
      "html-for": e.htmlFor,
      "highlight-label": e.highlightLabel,
      "tooltip-type": e.tooltipType,
      "tooltip-id": e.tooltipId,
      tooltip: e.tooltip,
      "help-link": e.helpLink
    }, {
      labelActionWrapper: ee(() => [
        ve(o.$slots, "labelAction")
      ]),
      labelIcon: ee(() => [
        ve(o.$slots, "labelIcon")
      ]),
      default: ee(() => [
        g("div", {
          class: S([o.$style.inputWrapper, { [o.$style.hasPrefixIcon]: k(t).prefixIcon }])
        }, [
          de($r, {
            alert: e.validationError,
            appearance: e.appearance,
            focused: e.focused
          }, sn({
            default: ee(() => [
              ve(o.$slots, "default")
            ]),
            _: 2
          }, [
            e.prefix !== void 0 ? {
              name: "before",
              fn: ee(() => [
                g("div", {
                  class: S(o.$style.prefix)
                }, se(e.prefix), 3)
              ]),
              key: "0"
            } : void 0
          ]), 1032, ["alert", "appearance", "focused"]),
          k(t).prefixIcon ? (f(), v("div", {
            key: 0,
            class: S(o.$style.prefixIcon)
          }, [
            ve(o.$slots, "prefixIcon")
          ], 2)) : $("", !0)
        ], 2)
      ]),
      _: 3
    }, 8, ["label", "label-position", "appearance", "helper-text", "optional-label-text", "validation-error", "required", "html-for", "highlight-label", "tooltip-type", "tooltip-id", "tooltip", "help-link"]));
  }
}), A2e = "_inputWrapper_1mtcj_1", L2e = "_prefix_1mtcj_7", E2e = "_prefixIcon_1mtcj_16", P2e = "_hasPrefixIcon_1mtcj_26", R2e = {
  inputWrapper: A2e,
  prefix: L2e,
  prefixIcon: E2e,
  hasPrefixIcon: P2e
}, F2e = {
  $style: R2e
}, c2 = /* @__PURE__ */ Ce(M2e, [["__cssModules", F2e]]), T2e = /* @__PURE__ */ pe({
  __name: "SCAAvatar",
  props: {
    initials: { default: void 0 },
    size: { default: "medium" },
    shape: { default: "rounded" },
    appearance: { default: "blue" },
    emphasis: { default: "high" },
    bordered: { type: Boolean, default: !1 },
    colorIdx: { default: void 0 },
    hovered: { type: Boolean, default: !1 },
    useHoverColors: { type: Boolean, default: !1 },
    borderColor: { default: void 0 },
    borderWidth: { default: void 0 }
  },
  setup(e) {
    const t = e, o = F(() => t.colorIdx !== void 0 ? mS[t.colorIdx] : void 0), n = F(() => t.initials ? t.size === "x3small" ? t.initials.charAt(0) : t.initials : "");
    return (s, i) => {
      var r, l, a, c;
      return f(), v("div", {
        class: S([
          s.$style.avatar,
          s.$style[`size_${e.size}`],
          {
            [s.$style[`appearance_${e.appearance}_${e.emphasis}`]]: o.value === void 0,
            [s.$style.square]: e.shape === "square",
            [s.$style.hovered]: e.hovered
          },
          { [s.$style.bordered]: e.bordered }
        ]),
        style: Ge({
          ...o.value ? {
            "--color": e.useHoverColors ? (r = o.value) == null ? void 0 : r.hoverBgColor : (l = o.value) == null ? void 0 : l.bgColor,
            "--text-color": e.useHoverColors ? (a = o.value) == null ? void 0 : a.hoverTextColor : (c = o.value) == null ? void 0 : c.textColor
          } : {},
          ...e.borderColor ? { "--border-color-override": e.borderColor } : {},
          ...e.borderWidth ? { "--border-width-override": e.borderWidth } : {}
        })
      }, [
        ve(s.$slots, "default", {}, () => [
          Ve(se(n.value), 1)
        ])
      ], 6);
    };
  }
}), I2e = "_avatar_dtgga_747", D2e = "_bordered_dtgga_769", k2e = "_size_xlarge_dtgga_775", H2e = "_size_large_dtgga_787", V2e = "_size_medium_dtgga_797", O2e = "_size_small_dtgga_806", B2e = "_size_xsmall_dtgga_818", $2e = "_size_x2small_dtgga_828", Z2e = "_size_x3small_dtgga_838", G2e = "_size_80_dtgga_848", N2e = "_hovered_dtgga_858", z2e = "_square_dtgga_861", j2e = "_appearance_blue_high_dtgga_870", W2e = "_appearance_blue_medium_dtgga_874", U2e = "_appearance_blue_low_dtgga_878", K2e = "_appearance_green_high_dtgga_882", q2e = "_appearance_green_medium_dtgga_886", Y2e = "_appearance_green_low_dtgga_890", Q2e = "_appearance_grey_high_dtgga_894", J2e = "_appearance_grey_medium_dtgga_898", X2e = "_appearance_grey_low_dtgga_902", ece = "_appearance_red_high_dtgga_906", tce = "_appearance_red_medium_dtgga_910", oce = "_appearance_red_low_dtgga_914", nce = "_appearance_orange_high_dtgga_918", sce = "_appearance_orange_medium_dtgga_922", ice = "_appearance_orange_low_dtgga_926", rce = "_appearance_raspberry_high_dtgga_930", lce = "_appearance_raspberry_medium_dtgga_934", ace = "_appearance_raspberry_low_dtgga_938", cce = "_appearance_magenta_high_dtgga_942", dce = "_appearance_magenta_medium_dtgga_946", uce = "_appearance_magenta_low_dtgga_950", hce = "_appearance_purple_high_dtgga_954", gce = "_appearance_purple_medium_dtgga_958", pce = "_appearance_purple_low_dtgga_962", fce = "_appearance_grape_high_dtgga_966", vce = "_appearance_grape_medium_dtgga_970", mce = "_appearance_grape_low_dtgga_974", Cce = "_appearance_violet_high_dtgga_978", wce = "_appearance_violet_medium_dtgga_982", bce = "_appearance_violet_low_dtgga_986", yce = "_appearance_cyan_high_dtgga_990", _ce = "_appearance_cyan_medium_dtgga_994", Sce = "_appearance_cyan_low_dtgga_998", xce = "_appearance_teal_high_dtgga_1002", Mce = "_appearance_teal_medium_dtgga_1006", Ace = "_appearance_teal_low_dtgga_1010", Lce = "_appearance_aquamarine_high_dtgga_1014", Ece = "_appearance_aquamarine_medium_dtgga_1018", Pce = "_appearance_aquamarine_low_dtgga_1022", Rce = "_appearance_emerald_high_dtgga_1026", Fce = "_appearance_emerald_medium_dtgga_1030", Tce = "_appearance_emerald_low_dtgga_1034", Ice = "_appearance_white_high_dtgga_1038", Dce = "_appearance_white_medium_dtgga_1042", kce = "_appearance_white_low_dtgga_1046", Hce = {
  avatar: I2e,
  bordered: D2e,
  size_xlarge: k2e,
  size_large: H2e,
  size_medium: V2e,
  size_small: O2e,
  size_xsmall: B2e,
  size_x2small: $2e,
  size_x3small: Z2e,
  size_80: G2e,
  hovered: N2e,
  square: z2e,
  appearance_blue_high: j2e,
  appearance_blue_medium: W2e,
  appearance_blue_low: U2e,
  appearance_green_high: K2e,
  appearance_green_medium: q2e,
  appearance_green_low: Y2e,
  appearance_grey_high: Q2e,
  appearance_grey_medium: J2e,
  appearance_grey_low: X2e,
  appearance_red_high: ece,
  appearance_red_medium: tce,
  appearance_red_low: oce,
  appearance_orange_high: nce,
  appearance_orange_medium: sce,
  appearance_orange_low: ice,
  appearance_raspberry_high: rce,
  appearance_raspberry_medium: lce,
  appearance_raspberry_low: ace,
  appearance_magenta_high: cce,
  appearance_magenta_medium: dce,
  appearance_magenta_low: uce,
  appearance_purple_high: hce,
  appearance_purple_medium: gce,
  appearance_purple_low: pce,
  appearance_grape_high: fce,
  appearance_grape_medium: vce,
  appearance_grape_low: mce,
  appearance_violet_high: Cce,
  appearance_violet_medium: wce,
  appearance_violet_low: bce,
  appearance_cyan_high: yce,
  appearance_cyan_medium: _ce,
  appearance_cyan_low: Sce,
  appearance_teal_high: xce,
  appearance_teal_medium: Mce,
  appearance_teal_low: Ace,
  appearance_aquamarine_high: Lce,
  appearance_aquamarine_medium: Ece,
  appearance_aquamarine_low: Pce,
  appearance_emerald_high: Rce,
  appearance_emerald_medium: Fce,
  appearance_emerald_low: Tce,
  appearance_white_high: Ice,
  appearance_white_medium: Dce,
  appearance_white_low: kce
}, Vce = {
  $style: Hce
}, oi = /* @__PURE__ */ Ce(T2e, [["__cssModules", Vce]]), Oce = {
  ArrowDown: 1,
  ArrowRight: 1,
  ArrowUp: -1,
  ArrowLeft: -1
};
function VC(e, t) {
  const o = e.target;
  return !(o instanceof HTMLInputElement) || o.type !== t || o.disabled || o.tabIndex < 0 ? null : o;
}
function OC(e, t) {
  e.preventDefault(), t.click();
}
function Bce(e) {
  if (!e.name) return [];
  const t = e.form ?? e.getRootNode();
  return Array.from(
    t.querySelectorAll(`input[type="radio"][name="${CSS.escape(e.name)}"]:not([disabled])`)
  );
}
function ld(e, t) {
  const o = Bce(e), n = o.indexOf(e);
  if (n < 0) return !1;
  for (let s = n + t; s >= 0 && s < o.length; s += t)
    if (o[s].focus(), document.activeElement === o[s]) return !0;
  return !1;
}
function ad(e) {
  if (e.key !== "Enter") return;
  const t = VC(e, "checkbox");
  t && OC(e, t);
}
function cd(e) {
  const t = VC(e, "radio");
  if (!t) return;
  if (e.key === "Enter") {
    OC(e, t);
    return;
  }
  const o = Oce[e.key];
  if (o) {
    e.preventDefault(), ld(t, o);
    return;
  }
  e.key === "Tab" && ld(t, e.shiftKey ? -1 : 1) && e.preventDefault();
}
const $ce = /* @__PURE__ */ pe({
  __name: "SCACheckboxBase",
  props: {
    disabled: { type: Boolean, default: !1 },
    checked: { type: Boolean, default: !1 },
    alert: { type: Boolean, default: !1 },
    deselect: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (t, o) => (f(), v("div", {
      class: S([
        t.$style.root,
        {
          [t.$style.disabled]: e.disabled
        }
      ]),
      onKeydown: o[0] || (o[0] = //@ts-ignore
      (...n) => k(ad) && k(ad)(...n))
    }, [
      ve(t.$slots, "default", { checked: e.checked }),
      de(Ae, {
        size: "16px",
        class: S([t.$style.icon, { [t.$style.alert]: e.alert }]),
        icon: e.deselect ? "tetrisly/16-minus" : "tetrisly/16-check"
      }, null, 8, ["class", "icon"])
    ], 34));
  }
}), Zce = "_root_1ujwx_747", Gce = "_disabled_1ujwx_753", Nce = "_icon_1ujwx_759", zce = "_alert_1ujwx_768", jce = {
  root: Zce,
  disabled: Gce,
  icon: Nce,
  alert: zce
}, Wce = {
  $style: jce
}, Zo = /* @__PURE__ */ Ce($ce, [["__cssModules", Wce]]), Uce = /* @__PURE__ */ pe({
  __name: "SCARadioButtonBase",
  props: {
    disabled: { type: Boolean, default: !1 },
    checked: { type: Boolean, default: !1 },
    alert: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (t, o) => (f(), v("div", {
      class: S([
        t.$style.root,
        {
          [t.$style.disabled]: e.disabled
        }
      ]),
      onKeydown: o[0] || (o[0] = //@ts-ignore
      (...n) => k(cd) && k(cd)(...n))
    }, [
      ve(t.$slots, "default", { checked: e.checked }),
      g("div", {
        class: S([
          t.$style.radio,
          {
            [t.$style.alert]: e.alert
          }
        ])
      }, null, 2)
    ], 34));
  }
}), Kce = "_root_181tj_747", qce = "_disabled_181tj_753", Yce = "_radio_181tj_759", Qce = "_alert_181tj_767", Jce = {
  root: Kce,
  disabled: qce,
  radio: Yce,
  alert: Qce
}, Xce = {
  $style: Jce
}, BC = /* @__PURE__ */ Ce(Uce, [["__cssModules", Xce]]), ede = ["disabled"], tde = /* @__PURE__ */ pe({
  __name: "SCAToggle",
  props: {
    disabled: { type: Boolean, default: !1 },
    modelValue: { type: [Boolean, null], default: null },
    alert: { type: Boolean, default: !1 },
    label: { default: void 0 },
    helperText: { default: void 0 },
    required: { type: Boolean, default: !1 },
    noGap: { type: Boolean, default: !1 },
    noPadding: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const s = oo(e, "modelValue", t, { passive: !0 });
    return (i, r) => (f(), v("label", {
      class: S([i.$style.label, e.disabled && i.$style.disabled])
    }, [
      g("div", {
        class: S([i.$style.grid, e.noGap && i.$style.gapUnset, e.noPadding && i.$style.paddingUnset])
      }, [
        g("div", {
          class: S(i.$style.root)
        }, [
          g("button", {
            class: S([
              i.$style.toggler,
              {
                [i.$style.unchecked]: e.modelValue === !1,
                [i.$style.checked]: e.modelValue === !0,
                [i.$style.indeterminate]: e.modelValue === null
              }
            ]),
            type: "button",
            disabled: e.disabled,
            onClick: r[0] || (r[0] = () => {
              s.value = !k(s);
            })
          }, null, 10, ede)
        ], 2),
        g("span", {
          class: S([{ [i.$style.required]: e.required }])
        }, se(e.label), 3)
      ], 2),
      e.helperText ? (f(), U(r1, {
        key: 0,
        intent: e.alert ? "alert" : void 0,
        class: S(i.$style.helperText)
      }, {
        default: ee(() => [
          Ve(se(e.helperText), 1)
        ]),
        _: 1
      }, 8, ["intent", "class"])) : $("", !0)
    ], 2));
  }
}), ode = "_label_8vsmk_747", nde = "_disabled_8vsmk_751", sde = "_grid_8vsmk_755", ide = "_gapUnset_8vsmk_767", rde = "_paddingUnset_8vsmk_771", lde = "_helperText_8vsmk_775", ade = "_root_8vsmk_780", cde = "_toggler_8vsmk_786", dde = "_unchecked_8vsmk_813", ude = "_checked_8vsmk_825", hde = "_indeterminate_8vsmk_825", gde = {
  label: ode,
  disabled: nde,
  grid: sde,
  gapUnset: ide,
  paddingUnset: rde,
  helperText: lde,
  root: ade,
  toggler: cde,
  unchecked: dde,
  checked: ude,
  indeterminate: hde
}, pde = {
  $style: gde
}, $C = /* @__PURE__ */ Ce(tde, [["__cssModules", pde]]), fde = { key: 0 }, vde = /* @__PURE__ */ pe({
  __name: "SCADropdownItem",
  props: /* @__PURE__ */ Ct({
    type: { default: void 0 },
    label: {},
    icon: { default: void 0 },
    avatarInitials: { default: void 0 },
    captionPosition: { default: "horizontal" },
    caption: { default: void 0 },
    expandable: { type: Boolean, default: !1 },
    checked: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    active: { type: Boolean, default: !1 },
    useSmallerVerticalPadding: { type: Boolean, default: !1 },
    useSmallPadding: { type: Boolean, default: !1 },
    useHigherOption: { type: Boolean, default: !1 },
    iconSize: { default: "20px" },
    unsetAll: { type: Boolean, default: !1 },
    unsetGap: { type: Boolean, default: !1 },
    useNeutralIconFill: { type: Boolean, default: !1 }
  }, {
    selected: { type: Boolean, default: !1 },
    selectedModifiers: {}
  }),
  emits: ["update:selected"],
  setup(e) {
    const t = e, o = ct(e, "selected"), n = (s) => {
      if (t.disabled) {
        s.stopPropagation(), s.preventDefault();
        return;
      }
      t.type === "selectable" && (o.value = !o.value);
    };
    return (s, i) => (f(), U(Po(e.type === "toggle" ? "div" : "label"), {
      class: S([
        s.$style.root,
        {
          [s.$style.vertical]: e.captionPosition === "vertical",
          [s.$style.clickable]: !e.disabled && (e.type === "action" || e.type === "toggle"),
          [s.$style.isDisabled]: e.disabled
        }
      ]),
      onClickCapture: n
    }, {
      default: ee(() => [
        g("div", {
          class: S([
            s.$style.itemDiv,
            {
              [s.$style.vertical]: e.captionPosition === "vertical",
              [s.$style.isDisabled]: e.disabled,
              [s.$style.selected]: o.value,
              [s.$style.active]: e.active,
              [s.$style.isRadio]: e.type === "radio",
              [s.$style.isToggle]: e.type === "toggle",
              [s.$style.useSmallerVerticalPadding]: e.useSmallerVerticalPadding,
              [s.$style.useSmallPadding]: e.useSmallPadding,
              [s.$style.useHigherOption]: e.useHigherOption,
              [s.$style.unsetAll]: e.unsetAll,
              [s.$style.unsetGap]: e.unsetGap,
              [s.$style.useNeutralIconFill]: e.useNeutralIconFill
            }
          ])
        }, [
          g("div", {
            class: S([
              s.$style.contentDiv,
              {
                [s.$style.selectPadding]: !o.value && e.type === "selectable"
              }
            ])
          }, [
            e.type === "dropdowntarget" ? (f(), v("button", fde)) : $("", !0),
            e.type === "selectable" && o.value ? (f(), U(Ae, {
              key: 1,
              icon: "tetrisly/check-large"
            })) : $("", !0),
            e.type === "checkbox" ? (f(), U(Zo, {
              key: 2,
              checked: e.checked,
              disabled: e.disabled,
              class: S(s.$style.checkbox)
            }, {
              default: ee(() => [
                ve(s.$slots, "default")
              ]),
              _: 3
            }, 8, ["checked", "disabled", "class"])) : $("", !0),
            e.type === "radio" ? (f(), U(BC, {
              key: 3,
              checked: e.checked,
              disabled: e.disabled,
              class: S(s.$style.radio)
            }, {
              default: ee(() => [
                ve(s.$slots, "default")
              ]),
              _: 3
            }, 8, ["checked", "disabled", "class"])) : $("", !0),
            e.icon ? (f(), U(Ae, {
              key: 4,
              icon: e.icon,
              size: e.iconSize
            }, null, 8, ["icon", "size"])) : $("", !0),
            s.$slots.avatar || e.avatarInitials ? (f(), U(oi, {
              key: 5,
              size: "xsmall",
              initials: e.avatarInitials
            }, {
              default: ee(() => [
                ve(s.$slots, "avatar")
              ]),
              _: 3
            }, 8, ["initials"])) : $("", !0),
            g("div", {
              class: S([s.$style.textDiv, { [s.$style.withLargeIcon]: e.icon && e.iconSize === "20px" }])
            }, [
              g("span", {
                class: S(s.$style.label)
              }, [
                ve(s.$slots, "tag", {}, () => [
                  ve(s.$slots, "label", {}, () => [
                    Ve(se(e.label), 1)
                  ])
                ])
              ], 2),
              e.caption && e.captionPosition === "vertical" ? (f(), v("span", {
                key: 0,
                class: S(s.$style.caption)
              }, se(e.caption), 3)) : $("", !0)
            ], 2),
            e.type === "toggle" ? (f(), U($C, {
              key: 6,
              "model-value": e.checked,
              disabled: e.disabled,
              class: S(s.$style.checkbox),
              "no-padding": "",
              "no-gap": e.unsetGap
            }, null, 8, ["model-value", "disabled", "class", "no-gap"])) : $("", !0)
          ], 2),
          e.caption && e.captionPosition === "horizontal" ? (f(), v("span", {
            key: 0,
            class: S(s.$style.caption)
          }, se(e.caption), 3)) : $("", !0),
          e.expandable ? (f(), U(Ae, {
            key: 1,
            icon: "phosphor/caret-right",
            size: e.iconSize
          }, null, 8, ["size"])) : $("", !0)
        ], 2)
      ]),
      _: 3
    }, 40, ["class"]));
  }
}), mde = "_root_1kgb3_747", Cde = "_vertical_1kgb3_753", wde = "_clickable_1kgb3_756", bde = "_isDisabled_1kgb3_759", yde = "_itemDiv_1kgb3_763", _de = "_useNeutralIconFill_1kgb3_786", Sde = "_selected_1kgb3_790", xde = "_active_1kgb3_800", Mde = "_isRadio_1kgb3_803", Ade = "_isToggle_1kgb3_806", Lde = "_checkbox_1kgb3_806", Ede = "_useSmallerVerticalPadding_1kgb3_813", Pde = "_useSmallPadding_1kgb3_817", Rde = "_useHigherOption_1kgb3_820", Fde = "_unsetAll_1kgb3_827", Tde = "_unsetGap_1kgb3_835", Ide = "_contentDiv_1kgb3_839", Dde = "_selectPadding_1kgb3_846", kde = "_gapSmaller_1kgb3_850", Hde = "_textDiv_1kgb3_855", Vde = "_withLargeIcon_1kgb3_861", Ode = "_label_1kgb3_861", Bde = "_caption_1kgb3_878", $de = "_paddingUnset_1kgb3_888", Zde = {
  root: mde,
  vertical: Cde,
  clickable: wde,
  isDisabled: bde,
  itemDiv: yde,
  useNeutralIconFill: _de,
  selected: Sde,
  active: xde,
  isRadio: Mde,
  isToggle: Ade,
  checkbox: Lde,
  useSmallerVerticalPadding: Ede,
  useSmallPadding: Pde,
  useHigherOption: Rde,
  unsetAll: Fde,
  unsetGap: Tde,
  contentDiv: Ide,
  selectPadding: Dde,
  gapSmaller: kde,
  textDiv: Hde,
  withLargeIcon: Vde,
  label: Ode,
  caption: Bde,
  paddingUnset: $de
}, Gde = {
  $style: Zde
}, d2 = /* @__PURE__ */ Ce(vde, [["__cssModules", Gde]]), Nde = ["src"], zde = /* @__PURE__ */ pe({
  __name: "SCATag",
  props: {
    disabled: { type: Boolean, default: !1 },
    selected: { type: Boolean, default: !1 },
    removable: { type: Boolean, default: !1 },
    avatar: { default: void 0 },
    icon: { default: void 0 },
    iconSize: { default: "12px" },
    iconColor: { default: void 0 },
    variant: { default: "default" },
    overflow: { default: "hidden" },
    as: { default: "div" }
  },
  emits: ["remove", "update:selected"],
  setup(e, { emit: t }) {
    Vn((l) => ({
      e66232b8: n.value
    }));
    const o = e, n = F(() => o.overflow), s = t, i = Qt(), r = () => {
      o.disabled || s("update:selected", !o.selected);
    };
    return (l, a) => (f(), U(Po(e.as), {
      tabindex: "0",
      class: S([
        l.$style.tag,
        {
          [l.$style.disabled]: e.disabled,
          [l.$style.selected]: e.selected,
          [l.$style.avatar]: e.avatar,
          [l.$style.iconLeft]: k(i).iconLeft,
          [l.$style.iconRight]: e.removable || k(i).iconRight,
          [l.$style.variantUnderline]: e.variant === "underline",
          [l.$style.variantBreadcrumb]: e.variant === "breadcrumb",
          [l.$style.variantGhost]: e.variant === "ghost"
        }
      ]),
      onClick: r
    }, {
      default: ee(() => {
        var c, d, u, h, p, C;
        return [
          e.avatar ? (f(), U(oi, {
            key: 0,
            size: "x3small",
            initials: (c = e.avatar) == null ? void 0 : c.initials,
            shape: (d = e.avatar) == null ? void 0 : d.shape,
            appearance: (u = e.avatar) == null ? void 0 : u.appearance,
            emphasis: (h = e.avatar) == null ? void 0 : h.emphasis,
            bordered: !!((p = e.avatar) != null && p.image),
            "color-idx": (C = e.avatar) == null ? void 0 : C.colorIdx,
            "use-hover-colors": !0
          }, {
            default: ee(() => {
              var m, w;
              return [
                (m = e.avatar) != null && m.image ? (f(), v("img", {
                  key: 0,
                  src: (w = e.avatar) == null ? void 0 : w.image,
                  loading: "lazy",
                  alt: "avatar"
                }, null, 8, Nde)) : $("", !0)
              ];
            }),
            _: 1
          }, 8, ["initials", "shape", "appearance", "emphasis", "bordered", "color-idx"])) : $("", !0),
          e.icon ? (f(), U(Ae, {
            key: 1,
            icon: e.icon,
            size: e.iconSize,
            color: e.iconColor
          }, null, 8, ["icon", "size", "color"])) : $("", !0),
          k(i).iconLeft ? (f(), v("div", {
            key: 2,
            class: S(l.$style.iconContainer)
          }, [
            ve(l.$slots, "iconLeft")
          ], 2)) : $("", !0),
          e.variant === "breadcrumb" ? (f(), U(Ae, {
            key: 3,
            size: "12px",
            class: S(l.$style.breadcrumbIcon),
            icon: "phosphor/caret-right"
          }, null, 8, ["class"])) : $("", !0),
          g("div", {
            class: S(l.$style.content)
          }, [
            ve(l.$slots, "default")
          ], 2),
          k(i).iconRight ? (f(), v("div", {
            key: 4,
            class: S(l.$style.iconContainer)
          }, [
            ve(l.$slots, "iconRight")
          ], 2)) : $("", !0),
          e.removable ? (f(), U(Ae, {
            key: 5,
            class: S(l.$style.button),
            size: "12px",
            icon: "phosphor/x",
            onClick: a[0] || (a[0] = xe((m) => s("remove"), ["stop"]))
          }, null, 8, ["class"])) : $("", !0)
        ];
      }),
      _: 3
    }, 8, ["class"]));
  }
}), jde = "_tag_1c8fn_747", Wde = "_disabled_1c8fn_768", Ude = "_button_1c8fn_773", Kde = "_variantUnderline_1c8fn_782", qde = "_selected_1c8fn_793", Yde = "_content_1c8fn_797", Qde = "_variantBreadcrumb_1c8fn_807", Jde = "_breadcrumbIcon_1c8fn_821", Xde = "_variantGhost_1c8fn_837", eue = "_avatar_1c8fn_842", tue = "_iconLeft_1c8fn_845", oue = "_iconRight_1c8fn_848", nue = "_iconContainer_1c8fn_860", sue = {
  tag: jde,
  disabled: Wde,
  button: Ude,
  variantUnderline: Kde,
  selected: qde,
  content: Yde,
  variantBreadcrumb: Qde,
  breadcrumbIcon: Jde,
  variantGhost: Xde,
  avatar: eue,
  iconLeft: tue,
  iconRight: oue,
  iconContainer: nue
}, iue = {
  $style: sue
}, Pn = /* @__PURE__ */ Ce(zde, [["__cssModules", iue]]), rue = { key: 0 }, lue = { key: 2 }, aue = /* @__PURE__ */ pe({
  __name: "SCANoItems",
  props: {
    title: { default: "No items" },
    icon: { default: "tetrisly/list-bullet" },
    loading: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (t, o) => (f(), v("div", {
      class: S(t.$style.noItems)
    }, [
      e.title || e.icon ? (f(), v("h2", rue, [
        e.loading ? (f(), U(i1, {
          key: 0,
          size: "small"
        })) : $("", !0),
        !e.loading && e.icon ? (f(), U(Ae, {
          key: 1,
          icon: e.icon,
          size: "16px"
        }, null, 8, ["icon"])) : $("", !0),
        e.title ? (f(), v("span", lue, se(e.title), 1)) : $("", !0)
      ])) : $("", !0),
      ve(t.$slots, "default")
    ], 2));
  }
}), cue = "_noItems_kov9c_1", due = {
  noItems: cue
}, uue = {
  $style: due
}, tr = /* @__PURE__ */ Ce(aue, [["__cssModules", uue]]);
function u2(e) {
  const t = W(-1);
  function o(w) {
    return t.value === w;
  }
  function n() {
    var b, _;
    const w = e.items.value.length;
    if (w === 0) return -1;
    if ((b = e.searchTerm) != null && b.value) return 0;
    const y = ((_ = e.initialIndex) == null ? void 0 : _.call(e)) ?? 0;
    return y >= 0 && y < w ? y : 0;
  }
  function s(w = !1) {
    rt(() => {
      const y = e.listEl.value, b = t.value;
      if (!y || b < 0) return;
      const _ = y.children[b];
      if (!_) return;
      if (w) {
        y.scrollTop = _.offsetTop - y.clientHeight / 2 + _.offsetHeight / 2;
        return;
      }
      const M = y.scrollTop, x = M + y.clientHeight, L = _.offsetTop, A = L + _.offsetHeight;
      L < M ? y.scrollTop = L : A > x && (y.scrollTop = A - y.clientHeight);
    });
  }
  function i(w) {
    const y = e.items.value.length;
    if (y === 0) return;
    const b = t.value < 0 ? 0 : (t.value + w + y) % y;
    t.value = b, s();
  }
  let r = !1, l = !1, a = !1;
  function c() {
    r = !0;
  }
  function d() {
    l || r || a || e.open();
  }
  Xt(document, ["pointerup", "pointercancel"], () => {
    r = !1;
  });
  function u() {
    var y;
    const w = (y = e.focusAnchor) == null ? void 0 : y.call(e);
    if (!(!w || document.activeElement === w)) {
      l = !0;
      try {
        w.focus();
      } finally {
        l = !1;
      }
    }
  }
  function h() {
    const w = document.activeElement;
    return !(w instanceof HTMLElement) || w === document.body || !w.isConnected ? !1 : typeof w.checkVisibility == "function" ? w.checkVisibility() : w.offsetParent !== null;
  }
  function p(w) {
    e.commit(w), rt(() => {
      h() || u();
    });
  }
  function C() {
    var w, y;
    (w = e.hideList) == null || w.call(e), e.isOpen.value = !1, (y = e.onClose) == null || y.call(e), u();
  }
  function m(w) {
    if (!e.isInert())
      switch (w.key) {
        case "ArrowDown":
          if (w.preventDefault(), !e.isOpen.value) {
            e.open();
            return;
          }
          i(1);
          break;
        case "ArrowUp":
          if (!e.isOpen.value) return;
          w.preventDefault(), i(-1);
          break;
        case "Enter": {
          if (!e.isOpen.value) {
            w.preventDefault(), e.open();
            return;
          }
          const y = e.items.value[t.value];
          if (y === void 0) return;
          w.preventDefault(), p(y);
          break;
        }
        case "Escape":
          if (!e.isOpen.value) return;
          w.preventDefault(), C();
          break;
        // Deliberately *not* prevented: the press closes the list and then travels on, so a single Tab
        // both dismisses the options and moves to the next field. That is only safe because `hideList`
        // has already taken the popover out of the tab order.
        case "Tab":
          if (!e.isOpen.value) return;
          C();
          break;
      }
  }
  return Me(e.isOpen, (w) => {
    if (!w) {
      t.value = -1, a = !0, rt(() => {
        a = !1;
      });
      return;
    }
    t.value = n(), s(!0);
  }), e.searchTerm && Me(e.searchTerm, () => {
    e.isOpen.value && (t.value = n());
  }), Me(
    () => e.items.value.length,
    (w) => {
      if (e.isOpen.value) {
        if (w === 0) {
          t.value = -1;
          return;
        }
        if (t.value < 0) {
          t.value = n(), s(!0);
          return;
        }
        t.value > w - 1 && (t.value = w - 1);
      }
    }
  ), {
    highlightedIndex: t,
    isHighlighted: o,
    handleKeyDown: m,
    handleFocus: d,
    handlePointerDown: c,
    /**
     * Moves focus to the field's own tab stop without the list treating it as "the user asked for me".
     *
     * For a component that is about to remove the element holding focus — a single-select tag input
     * hiding its inline input the moment the field is full — calling this first is what keeps the caret
     * (and therefore the field's focused underline) on the field instead of dropping it to `<body>`.
     */
    focusField: u
  };
}
function hue(e) {
  return !!e && typeof e.hideNow == "function";
}
function h2() {
  const e = Je(null);
  return {
    setDropdown(t) {
      e.value = hue(t) ? t : null;
    },
    hideList() {
      var t;
      (t = e.value) == null || t.hideNow();
    }
  };
}
const gue = ["id", "value", "placeholder", "disabled", "readonly"], pue = /* @__PURE__ */ pe({
  __name: "SCASelectBase",
  props: {
    modelValue: { default: void 0 },
    items: {},
    search: { default: void 0 },
    searchTerm: { default: "" },
    disabled: { type: Boolean, default: !1 },
    placeholder: { default: void 0 },
    icon: { default: void 0 },
    htmlFor: { default: void 0 },
    alert: { type: Boolean, default: !1 },
    hidePopoverOnValueChange: { type: Boolean, default: !0 },
    appearance: { default: void 0 },
    hasMore: { type: Boolean, default: !1 },
    loadingMore: { type: Boolean, default: !1 },
    disableHoverColorTag: { type: Boolean, default: !1 },
    useSmallerVerticalPadding: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "update:searchTerm", "opened", "closed", "loadMore"],
  setup(e, { emit: t }) {
    Vn((E) => ({
      v0a3e4a86: b.value,
      v5d134715: _.value,
      v55ca149b: M.value,
      bad4fd1a: x.value
    }));
    const o = e, n = t, s = W(!1), i = W(o.searchTerm || ""), r = Qt(), l = F(() => !!r.tag), a = Ro("itemsWrapper"), { setDropdown: c, hideList: d } = h2(), u = F(() => o.items.find((E) => E.id === o.modelValue)), h = F(() => A.value.findIndex((E) => E.id === o.modelValue)), p = F(() => {
      var E;
      return !!((E = u.value) != null && E.color) && !s.value;
    }), C = W(!1);
    function m() {
      C.value = !0, H();
    }
    const w = F(
      () => {
        var E;
        return l.value && !!((E = u.value) != null && E.label) && !s.value && !C.value;
      }
    ), y = F(() => {
      var E;
      return p.value ? "" : s.value && o.search ? i.value : ((E = u.value) == null ? void 0 : E.label) ?? "";
    }), b = F(
      () => {
        var E, j;
        return ((j = (E = u.value) == null ? void 0 : E.color) == null ? void 0 : j.bgColor) ?? "var(--color-interaction-neutral-subtle-normal)";
      }
    ), _ = F(() => {
      var E, j;
      return ((j = (E = u.value) == null ? void 0 : E.color) == null ? void 0 : j.textColor) ?? "var(--color-content-primary)";
    }), M = F(() => {
      var E, j;
      return (j = (E = u.value) == null ? void 0 : E.color) == null ? void 0 : j.hoverBgColor;
    }), x = F(() => {
      var E, j;
      return (j = (E = u.value) == null ? void 0 : E.color) == null ? void 0 : j.hoverTextColor;
    }), L = F(() => {
      var E, j;
      return ((j = (E = u.value) == null ? void 0 : E.color) == null ? void 0 : j.bgColor) === "transparent";
    }), A = F(() => {
      const E = o.items.filter((j) => !j.hidden);
      return !o.search || o.search === "custom" ? E : E.filter((j) => j.label.toLocaleLowerCase().includes(i.value.toLocaleLowerCase()));
    });
    Me(
      () => o.searchTerm,
      (E) => {
        E !== i.value && (i.value = E || "");
      }
    ), Me(i, (E) => {
      n("update:searchTerm", E);
    }), Me(
      () => o.modelValue,
      () => {
        o.hidePopoverOnValueChange && (s.value = !1, i.value = "");
      }
    );
    function R(E) {
      i.value = E.target.value, !s.value && !o.disabled && (s.value = !0);
    }
    function P(E) {
      o.disabled || (n("update:modelValue", E), i.value = "", s.value = !1);
    }
    const { isHighlighted: I, handleKeyDown: B, handleFocus: H, handlePointerDown: O } = u2({
      isOpen: s,
      items: A,
      listEl: a,
      searchTerm: i,
      open: N,
      commit: (E) => P(E.id),
      isInert: () => o.disabled,
      initialIndex: () => h.value,
      hideList: d
    });
    function N() {
      o.disabled || (A.value.length > 0 || i.value) && (s.value = !0);
    }
    function te() {
      const E = a.value;
      !E || !o.hasMore || o.loadingMore || E.scrollHeight - E.scrollTop - E.clientHeight < 50 && n("loadMore");
    }
    return (E, j) => (f(), U(zt, {
      ref: k(c),
      "is-open": s.value,
      "onUpdate:isOpen": j[3] || (j[3] = (Z) => s.value = Z),
      "match-trigger-width": "min",
      class: S([E.$style.dropdown, { [E.$style.hovered]: l.value }]),
      onOpened: j[4] || (j[4] = (Z) => E.$emit("opened")),
      onClosed: j[5] || (j[5] = (Z) => E.$emit("closed"))
    }, {
      trigger: ee(() => [
        de($r, {
          appearance: w.value ? "no-border" : e.appearance,
          placeholder: e.placeholder,
          disabled: e.disabled,
          "underline-override": !0,
          onClick: N,
          onPointerdown: k(O)
        }, {
          default: ee(() => {
            var Z;
            return [
              E.$slots.triggerContent ? ve(E.$slots, "triggerContent", { key: 0 }) : (f(), v(we, { key: 1 }, [
                e.icon ? (f(), U(Ae, {
                  key: 0,
                  icon: e.icon,
                  size: "16px"
                }, null, 8, ["icon"])) : $("", !0),
                (Z = u.value) != null && Z.avatarInitials ? (f(), U(oi, {
                  key: 1,
                  size: "x3small",
                  initials: u.value.avatarInitials[0],
                  class: "me-component-gap-xSmall"
                }, null, 8, ["initials"])) : $("", !0),
                p.value && l.value ? (f(), U(Pn, {
                  key: 2,
                  tabindex: "-1",
                  class: S([
                    E.$style.tag,
                    E.$style.active,
                    {
                      [E.$style.noHover]: e.disableHoverColorTag,
                      [E.$style.unsetPadding]: e.disableHoverColorTag && L.value
                    }
                  ])
                }, {
                  default: ee(() => {
                    var Y;
                    return [
                      Ve(se((Y = u.value) == null ? void 0 : Y.label), 1)
                    ];
                  }),
                  _: 1
                }, 8, ["class"])) : $("", !0),
                g("input", {
                  id: e.htmlFor,
                  value: y.value,
                  placeholder: e.placeholder,
                  disabled: e.disabled,
                  readonly: !e.search,
                  onInput: R,
                  onKeydown: j[0] || (j[0] = //@ts-ignore
                  (...Y) => k(B) && k(B)(...Y)),
                  onFocus: m,
                  onBlur: j[1] || (j[1] = (Y) => C.value = !1)
                }, null, 40, gue),
                e.disabled ? $("", !0) : (f(), U(Ae, {
                  key: 3,
                  icon: "phosphor/caret-down",
                  class: S([E.$style.iconColor, E.$style.arrow, { [E.$style.arrowOpen]: s.value }]),
                  size: "12px"
                }, null, 8, ["class"]))
              ], 64))
            ];
          }),
          _: 3
        }, 8, ["appearance", "placeholder", "disabled", "onPointerdown"])
      ]),
      default: ee(() => [
        g("div", {
          ref: "itemsWrapper",
          class: S(E.$style.itemsWrapper),
          onScroll: te
        }, [
          (f(!0), v(we, null, Ze(A.value, (Z, Y) => (f(), U(d2, {
            key: Z.id,
            label: Z.label,
            class: S([
              E.$style.items,
              { [E.$style.selectedItem]: Z.id === e.modelValue },
              { [E.$style.highlighted]: k(I)(Y) },
              { [E.$style.unset]: l.value }
            ]),
            icon: Z.icon,
            "avatar-initials": Z.avatarInitials,
            "unset-all": l.value,
            "use-smaller-vertical-padding": e.useSmallerVerticalPadding,
            type: "action",
            onMousedown: j[2] || (j[2] = xe(() => {
            }, ["prevent"])),
            onClick: (le) => P(Z.id)
          }, sn({ _: 2 }, [
            E.$slots.avatar ? {
              name: "avatar",
              fn: ee(() => [
                ve(E.$slots, "avatar", { item: Z })
              ]),
              key: "0"
            } : void 0,
            E.$slots.tag ? {
              name: "tag",
              fn: ee(() => [
                ve(E.$slots, "tag", { item: Z })
              ]),
              key: "1"
            } : void 0
          ]), 1032, ["label", "class", "icon", "avatar-initials", "unset-all", "use-smaller-vertical-padding", "onClick"]))), 128)),
          A.value.length === 0 ? (f(), U(tr, { key: 0 })) : $("", !0)
        ], 34)
      ]),
      _: 3
    }, 8, ["is-open", "class"]));
  }
}), fue = "_dropdown_1ddbo_747", vue = "_arrow_1ddbo_750", mue = "_hovered_1ddbo_754", Cue = "_itemsWrapper_1ddbo_759", wue = "_items_1ddbo_759", bue = "_highlighted_1ddbo_773", yue = "_selectedItem_1ddbo_776", _ue = "_unset_1ddbo_780", Sue = "_alert_1ddbo_784", xue = "_iconColor_1ddbo_789", Mue = "_arrowOpen_1ddbo_800", Aue = "_tag_1ddbo_806", Lue = "_unsetPadding_1ddbo_814", Eue = "_active_1ddbo_818", Pue = "_noHover_1ddbo_824", Rue = {
  dropdown: fue,
  arrow: vue,
  hovered: mue,
  itemsWrapper: Cue,
  items: wue,
  highlighted: bue,
  selectedItem: yue,
  unset: _ue,
  alert: Sue,
  iconColor: xue,
  arrowOpen: Mue,
  tag: Aue,
  unsetPadding: Lue,
  active: Eue,
  noHover: Pue
}, Fue = {
  $style: Rue
}, ZC = /* @__PURE__ */ Ce(pue, [["__cssModules", Fue]]), Tue = /* @__PURE__ */ pe({
  __name: "SCASelect",
  props: {
    modelValue: { default: void 0 },
    label: { default: void 0 },
    optionalLabelText: { default: void 0 },
    helperText: { default: void 0 },
    validationError: { type: Boolean, default: !1 },
    items: {},
    search: { default: void 0 },
    searchTerm: { default: "" },
    disabled: { type: Boolean, default: !1 },
    placeholder: { default: void 0 },
    icon: { default: void 0 },
    htmlFor: { default: void 0 },
    alert: { type: Boolean, default: !1 },
    hidePopoverOnValueChange: { type: Boolean, default: !0 },
    required: { type: Boolean, default: !1 },
    labelPosition: { default: void 0 },
    appearance: { default: void 0 },
    hasMore: { type: Boolean, default: !1 },
    loadingMore: { type: Boolean, default: !1 },
    tooltip: { default: void 0 },
    helpLink: { default: void 0 },
    disableHoverColorTag: { type: Boolean, default: !1 },
    useSmallerVerticalPadding: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "update:searchTerm", "opened", "closed", "loadMore"],
  setup(e, { emit: t }) {
    const o = e, n = t, s = oo(o, "modelValue", n, { passive: !0 }), i = oo(o, "searchTerm", n, { passive: !0 }), r = F(() => o.items.find((l) => l.id === s.value));
    return (l, a) => (f(), U(Is, {
      label: e.label,
      "label-position": e.labelPosition,
      appearance: e.appearance,
      "helper-text": e.helperText,
      "optional-label-text": e.optionalLabelText,
      "validation-error": e.validationError,
      required: e.required,
      "html-for": e.htmlFor,
      tooltip: e.tooltip,
      "help-link": e.helpLink
    }, {
      default: ee(() => [
        de(ZC, {
          modelValue: k(s),
          "onUpdate:modelValue": a[0] || (a[0] = (c) => Tn(s) ? s.value = c : null),
          "search-term": k(i),
          "onUpdate:searchTerm": a[1] || (a[1] = (c) => Tn(i) ? i.value = c : null),
          items: e.items,
          search: e.search,
          disabled: e.disabled,
          placeholder: e.placeholder,
          icon: e.icon,
          alert: e.alert,
          appearance: e.appearance,
          "hide-popover-on-value-change": e.hidePopoverOnValueChange,
          "has-more": e.hasMore,
          "loading-more": e.loadingMore,
          "html-for": e.htmlFor,
          "disable-hover-color-tag": e.disableHoverColorTag,
          "use-smaller-vertical-padding": e.useSmallerVerticalPadding,
          onOpened: a[2] || (a[2] = (c) => n("opened")),
          onClosed: a[3] || (a[3] = (c) => n("closed")),
          onLoadMore: a[4] || (a[4] = (c) => n("loadMore"))
        }, sn({ _: 2 }, [
          l.$slots.triggerContent ? {
            name: "triggerContent",
            fn: ee(() => [
              ve(l.$slots, "triggerContent", { item: r.value })
            ]),
            key: "0"
          } : void 0,
          l.$slots.tag ? {
            name: "tag",
            fn: ee(({ item: c }) => [
              ve(l.$slots, "tag", { item: c })
            ]),
            key: "1"
          } : void 0
        ]), 1032, ["modelValue", "search-term", "items", "search", "disabled", "placeholder", "icon", "alert", "appearance", "hide-popover-on-value-change", "has-more", "loading-more", "html-for", "disable-hover-color-tag", "use-smaller-vertical-padding"])
      ]),
      _: 3
    }, 8, ["label", "label-position", "appearance", "helper-text", "optional-label-text", "validation-error", "required", "html-for", "tooltip", "help-link"]));
  }
}), Iue = "_root_eqy14_747", Due = "_validationError_eqy14_754", kue = "_label_eqy14_758", Hue = {
  root: Iue,
  validationError: Due,
  label: kue
}, Vue = {
  $style: Hue
}, Ds = /* @__PURE__ */ Ce(Tue, [["__cssModules", Vue]]), Oue = ["disabled", "aria-pressed", "aria-current", "tabindex", "test-id"], Bue = /* @__PURE__ */ pe({
  __name: "CalendarDayCell",
  props: {
    cell: {},
    state: {},
    isRowStart: { type: Boolean, default: !1 },
    isRowEnd: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    testId: { default: void 0 }
  },
  emits: ["select", "hover"],
  setup(e) {
    const t = e, o = F(() => t.state.selected || t.state.rangeStart || t.state.rangeEnd), n = W(null);
    return Me(
      () => t.state.flash,
      (s) => {
        const i = n.value;
        !s || !i || (i.style.animation = "none", i.offsetWidth, i.style.animation = "");
      },
      { flush: "post" }
    ), (s, i) => (f(), v("button", {
      type: "button",
      class: S([
        s.$style.cell,
        {
          [s.$style.otherMonth]: !e.cell.inCurrentMonth,
          [s.$style.disabled]: e.cell.disabled,
          [s.$style.readonly]: e.readonly,
          [s.$style.weekend]: e.cell.isWeekend && e.cell.inCurrentMonth && !o.value
        }
      ]),
      disabled: e.cell.disabled,
      "aria-pressed": e.state.selected || e.state.rangeStart || e.state.rangeEnd,
      "aria-current": e.cell.isToday ? "date" : void 0,
      tabindex: e.cell.inCurrentMonth && !e.cell.disabled ? 0 : -1,
      "test-id": e.testId,
      onClick: i[0] || (i[0] = (r) => s.$emit("select", e.cell.date)),
      onMouseenter: i[1] || (i[1] = (r) => s.$emit("hover", e.cell.date)),
      onFocus: i[2] || (i[2] = (r) => s.$emit("hover", e.cell.date))
    }, [
      g("span", {
        ref_key: "circleRef",
        ref: n,
        class: S([
          s.$style.circle,
          {
            [s.$style.selected]: e.state.selected || e.state.rangeStart || e.state.rangeEnd,
            [s.$style.today]: e.cell.isToday && !o.value,
            [s.$style.flash]: e.state.flash,
            [s.$style.previewEndpoint]: (e.state.previewStart || e.state.previewEnd) && !o.value
          }
        ])
      }, se(e.cell.day), 3)
    ], 42, Oue));
  }
}), $ue = "_cell_17vvj_747", Zue = "_circle_17vvj_762", Gue = "_disabled_17vvj_782", Nue = "_readonly_17vvj_782", zue = "_selected_17vvj_782", jue = "_previewEndpoint_17vvj_782", Wue = "_today_17vvj_798", Uue = "_flash_17vvj_803", Kue = "_otherMonth_17vvj_820", que = "_weekend_17vvj_824", Yue = {
  cell: $ue,
  circle: Zue,
  disabled: Gue,
  readonly: Nue,
  selected: zue,
  previewEndpoint: jue,
  today: Wue,
  flash: Uue,
  "day-flash": "_day-flash_17vvj_1",
  otherMonth: Kue,
  weekend: que
}, Que = {
  $style: Yue
}, Jue = /* @__PURE__ */ Ce(Bue, [["__cssModules", Que]]);
function Xue(e) {
  return { weekStartsOn: e, firstWeekContainsDate: 4 };
}
function e7e(e, t, o) {
  const n = mr(e), s = cn(n, { weekStartsOn: t }), i = v7(n, s), r = wx(LS(e)), l = Math.ceil((i + r) / 7), a = n.getMonth(), c = [];
  let d = s;
  for (let u = 0; u < l; u++) {
    const h = [];
    for (let C = 0; C < 7; C++) {
      const m = _i(d, C);
      h.push({
        date: m,
        day: m.getDate(),
        inCurrentMonth: m.getMonth() === a,
        isToday: wM(m),
        isWeekend: _S(m),
        disabled: o ? o(m) : !1
      });
    }
    const p = _i(d, (4 - t + 7) % 7);
    c.push({ weekNumber: $5(p, Xue(t)), days: h }), d = _i(d, 7);
  }
  return c;
}
function t7e(e, t) {
  const o = cn(new Date(2024, 0, 1), { weekStartsOn: e });
  return Array.from({ length: 7 }, (n, s) => In(_i(o, s), "EEEEEE", { locale: t }));
}
const o7e = ["popovertarget", "test-id"], n7e = ["test-id", "onClick"], s7e = /* @__PURE__ */ pe({
  __name: "CalendarMonthGrid",
  props: {
    month: {},
    weekStartsOn: {},
    showWeekNumbers: { type: Boolean },
    weekdays: {},
    weekLabel: {},
    monthLabel: {},
    years: {},
    yearSelectable: { type: Boolean },
    isDisabled: {},
    getDayState: {},
    readonly: { type: Boolean, default: !1 },
    testId: { default: "sca-calendar-month" }
  },
  emits: ["select", "hover", "selectYear"],
  setup(e, { emit: t }) {
    const o = e, n = t, s = W(!1), i = W(null), r = W(null);
    function l(p, C) {
      C === c.value && (r.value = (p == null ? void 0 : p.$el) ?? p);
    }
    const a = F(() => e7e(o.month, o.weekStartsOn, o.isDisabled)), c = F(() => o.month.getFullYear());
    Me(s, async (p) => {
      if (!p) return;
      await rt();
      const C = i.value, m = r.value;
      !C || !m || (C.scrollTop = m.offsetTop - C.clientHeight / 2 + m.clientHeight / 2);
    });
    function d(p) {
      s.value = !1, n("selectYear", p);
    }
    function u(p) {
      return p.rangeStart && p.rangeEnd ? "none" : p.previewStart || p.previewEnd ? "full" : p.rangeStart ? "right" : p.rangeEnd ? "left" : p.inRange || p.preview ? "full" : "none";
    }
    function h(p) {
      const C = p.days.length;
      let m = null, w = null, y;
      for (const [b, _] of p.days.entries()) {
        const M = o.getDayState(_.date);
        y ?? (y = M.previewDirection);
        const x = u(M);
        if (x === "none") continue;
        const L = x === "right" ? b + 0.5 : b, A = x === "left" ? b + 0.5 : b + 1;
        (m === null || L < m) && (m = L), (w === null || A > w) && (w = A);
      }
      return m === null || w === null ? { left: y === "backward" ? "100%" : "0%", width: "0%" } : { left: `${m / C * 100}%`, width: `${(w - m) / C * 100}%` };
    }
    return (p, C) => (f(), v("div", {
      class: S(p.$style.month)
    }, [
      g("div", {
        class: S(p.$style.periodHeader)
      }, [
        e.yearSelectable ? (f(), U(zt, {
          key: 0,
          "is-open": s.value,
          "onUpdate:isOpen": C[0] || (C[0] = (m) => s.value = m),
          placement: "bottom",
          class: S(p.$style.yearDropdown)
        }, {
          trigger: ee(({ target: m }) => [
            g("button", {
              type: "button",
              class: S(p.$style.periodLabel),
              popovertarget: m,
              "test-id": `${e.testId}-period`
            }, [
              Ve(se(e.monthLabel) + " ", 1),
              de(Ae, {
                class: S([p.$style.caret, { [p.$style.caretOpen]: s.value }]),
                icon: "phosphor/caret-down",
                size: "12px"
              }, null, 8, ["class"])
            ], 10, o7e)
          ]),
          default: ee(() => [
            g("div", {
              ref_key: "yearListEl",
              ref: i,
              class: S(p.$style.yearList)
            }, [
              (f(!0), v(we, null, Ze(e.years, (m) => (f(), v("button", {
                key: m,
                ref_for: !0,
                ref: (w) => l(w, m),
                type: "button",
                class: S([p.$style.yearItem, { [p.$style.yearActive]: m === c.value }]),
                "test-id": `${e.testId}-year-${m}`,
                onClick: (w) => d(m)
              }, se(m), 11, n7e))), 128))
            ], 2)
          ]),
          _: 1
        }, 8, ["is-open", "class"])) : (f(), v("span", {
          key: 1,
          class: S(p.$style.periodLabelStatic)
        }, se(e.monthLabel), 3))
      ], 2),
      g("div", {
        class: S(p.$style.grid)
      }, [
        g("div", {
          class: S(p.$style.weekdayRow)
        }, [
          e.showWeekNumbers ? (f(), v("div", {
            key: 0,
            class: S([p.$style.weekdayCell, p.$style.weekColumn])
          }, se(e.weekLabel), 3)) : $("", !0),
          (f(!0), v(we, null, Ze(e.weekdays, (m, w) => (f(), v("div", {
            key: w,
            class: S(p.$style.weekdayCell)
          }, se(m), 3))), 128))
        ], 2),
        (f(!0), v(we, null, Ze(a.value, (m, w) => (f(), v("div", {
          key: w,
          class: S(p.$style.weekRow)
        }, [
          e.showWeekNumbers ? (f(), v("div", {
            key: 0,
            class: S(p.$style.weekNumber)
          }, se(m.weekNumber), 3)) : $("", !0),
          g("div", {
            class: S(p.$style.daysWrap)
          }, [
            g("span", {
              class: S(p.$style.rangeBar),
              style: Ge(h(m))
            }, null, 6),
            (f(!0), v(we, null, Ze(m.days, (y, b) => (f(), U(Jue, {
              key: y.date.getTime(),
              cell: y,
              state: e.getDayState(y.date),
              "is-row-start": b === 0,
              "is-row-end": b === m.days.length - 1,
              readonly: e.readonly,
              "test-id": `${e.testId}-day-${y.date.getFullYear()}-${y.date.getMonth() + 1}-${y.day}`,
              onSelect: C[1] || (C[1] = (_) => p.$emit("select", _)),
              onHover: C[2] || (C[2] = (_) => p.$emit("hover", _))
            }, null, 8, ["cell", "state", "is-row-start", "is-row-end", "readonly", "test-id"]))), 128))
          ], 2)
        ], 2))), 128))
      ], 2)
    ], 2));
  }
}), i7e = "_month_1dxmj_747", r7e = "_periodHeader_1dxmj_752", l7e = "_yearDropdown_1dxmj_765", a7e = "_periodLabel_1dxmj_769", c7e = "_periodLabelStatic_1dxmj_770", d7e = "_caret_1dxmj_793", u7e = "_caretOpen_1dxmj_802", h7e = "_yearList_1dxmj_810", g7e = "_yearItem_1dxmj_820", p7e = "_yearActive_1dxmj_839", f7e = "_grid_1dxmj_846", v7e = "_weekdayRow_1dxmj_852", m7e = "_weekRow_1dxmj_853", C7e = "_daysWrap_1dxmj_858", w7e = "_rangeBar_1dxmj_864", b7e = "_weekdayCell_1dxmj_873", y7e = "_weekColumn_1dxmj_889", _7e = "_weekNumber_1dxmj_895", S7e = {
  month: i7e,
  periodHeader: r7e,
  yearDropdown: l7e,
  periodLabel: a7e,
  periodLabelStatic: c7e,
  caret: d7e,
  caretOpen: u7e,
  yearList: h7e,
  yearItem: g7e,
  yearActive: p7e,
  grid: f7e,
  weekdayRow: v7e,
  weekRow: m7e,
  daysWrap: C7e,
  rangeBar: w7e,
  weekdayCell: b7e,
  weekColumn: y7e,
  weekNumber: _7e
}, x7e = {
  $style: S7e
}, M7e = /* @__PURE__ */ Ce(s7e, [["__cssModules", x7e]]), A7e = /* @__PURE__ */ pe({
  __name: "TimeCombinedSelect",
  props: {
    modelValue: {},
    minuteStep: { default: 15 },
    placeholder: { default: "hh:mm" },
    disabled: { type: Boolean, default: !1 },
    label: { default: void 0 },
    width: { default: 100 },
    testId: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    Vn((a) => ({
      v8936c9ee: `${a.width}px`
    }));
    const o = e, n = t;
    function s(a) {
      return String(a).padStart(2, "0");
    }
    const i = F(() => {
      const a = [];
      for (let d = 0; d < 24; d++)
        for (let u = 0; u < 60; u += o.minuteStep)
          a.push({ id: d * 60 + u, label: `${s(d)}:${s(u)}` });
      const c = o.modelValue;
      return c && !a.some((d) => d.id === c.hours * 60 + c.minutes) && (a.push({ id: c.hours * 60 + c.minutes, label: `${s(c.hours)}:${s(c.minutes)}` }), a.sort((d, u) => Number(d.id) - Number(u.id))), a;
    }), r = F(() => {
      if (o.modelValue)
        return o.modelValue.hours * 60 + o.modelValue.minutes;
    });
    function l(a) {
      if (a === void 0) return;
      const c = Number(a);
      n("update:modelValue", { hours: Math.floor(c / 60), minutes: c % 60, seconds: 0 });
    }
    return (a, c) => (f(), U(Ds, {
      class: S(a.$style.select),
      label: e.label,
      items: i.value,
      "model-value": r.value,
      placeholder: e.placeholder,
      disabled: e.disabled,
      "test-id": e.testId,
      "onUpdate:modelValue": l
    }, null, 8, ["class", "label", "items", "model-value", "placeholder", "disabled", "test-id"]));
  }
}), L7e = "_select_q0z5s_1", E7e = {
  select: L7e
}, P7e = {
  $style: E7e
}, dd = /* @__PURE__ */ Ce(A7e, [["__cssModules", P7e]]), R7e = /* @__PURE__ */ pe({
  __name: "TimeUnitSelect",
  props: {
    modelValue: {},
    max: {},
    step: { default: 1 },
    placeholder: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    testId: { default: void 0 },
    label: { default: void 0 },
    labelSize: { default: 52 },
    width: { default: 136 },
    gap: { default: 12 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    Vn((r) => ({
      v0fd6f7de: `${r.width}px`,
      v8b9465a6: `${r.labelSize}px`,
      v63eb842e: `${r.gap}px`
    }));
    const o = e, n = t, s = F(() => {
      const r = [];
      for (let l = 0; l <= o.max; l += o.step)
        r.push({ id: l, label: String(l).padStart(2, "0") });
      return r;
    });
    function i(r) {
      r !== void 0 && n("update:modelValue", Number(r));
    }
    return (r, l) => (f(), U(Ds, {
      class: S(r.$style.select),
      label: e.label,
      items: s.value,
      "model-value": e.modelValue ?? void 0,
      placeholder: e.placeholder,
      disabled: e.disabled,
      "test-id": e.testId,
      "onUpdate:modelValue": i
    }, null, 8, ["class", "label", "items", "model-value", "placeholder", "disabled", "test-id"]));
  }
}), F7e = "_select_153zy_1", T7e = {
  select: F7e
}, I7e = {
  $style: T7e
}, _1 = /* @__PURE__ */ Ce(R7e, [["__cssModules", I7e]]), D7e = { key: 0 }, k7e = 100, H7e = 100, V7e = 4, O7e = /* @__PURE__ */ pe({
  __name: "SCACalendarPanel",
  props: /* @__PURE__ */ Ct({
    mode: {},
    inline: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    config: { default: void 0 }
  }, {
    modelValue: { required: !0 },
    modelModifiers: {},
    allDay: { type: Boolean, default: !1 },
    allDayModifiers: {},
    months: { default: 1 },
    monthsModifiers: {},
    columns: { default: 1 },
    columnsModifiers: {}
  }),
  emits: /* @__PURE__ */ Ct(["selectionComplete"], ["update:modelValue", "update:allDay", "update:months", "update:columns"]),
  setup(e, { expose: t, emit: o }) {
    const n = e, s = { ...Z5e, ...n.config }, i = o, r = ct(e, "modelValue"), { t: l, locale: a } = Go(), c = F(() => Kl(a.value)), d = F(() => HC(n.mode)), u = F(() => rd(n.mode)), h = F(() => _s(n.mode)), p = { hours: 0, minutes: 0, seconds: 0 }, C = { hours: 23, minutes: 59, seconds: 59 }, m = W(null), w = W(null), y = W(null), b = W(null), _ = W(null), M = W(null), x = ct(e, "allDay"), L = F(() => x.value ? p : b.value), A = F(() => x.value ? C : _.value);
    function R(he) {
      if (n.readonly) return;
      const T = he ?? !1;
      x.value = T, gt(T);
    }
    const P = W(mr(/* @__PURE__ */ new Date())), I = ct(e, "months"), B = ct(e, "columns"), H = W(!1);
    Me(I, (he) => {
      B.value > he && (B.value = he);
    });
    const O = F(
      () => Array.from({ length: Math.min(I.value, s.maxMonths) }, (he, T) => Ec(P.value, T))
    ), N = F(() => ({
      gridTemplateColumns: `repeat(${B.value}, max-content)`
    })), te = F(() => t7e(s.weekStartsOn, c.value)), E = F(() => {
      const he = (/* @__PURE__ */ new Date()).getFullYear(), T = P.value.getFullYear(), re = s.min ? s.min.getFullYear() : Math.min(he - k7e, T), me = s.max ? s.max.getFullYear() : Math.max(he + H7e, T), Ee = [];
      for (let Ne = re; Ne <= me; Ne++) Ee.push(Ne);
      return Ee;
    }), j = F(
      () => Array.from({ length: s.maxMonths }, (he, T) => ({ id: T + 1, label: String(T + 1) }))
    );
    function Z(he, T = !1) {
      return In(he, T ? "LLL yyyy" : "LLLL yyyy", { locale: c.value });
    }
    function Y(he) {
      const T = O.value;
      return T.length <= 1 ? Z(T[0], he) : `${Z(T[0], he)} - ${Z(T[T.length - 1], he)}`;
    }
    const le = W(!1), ge = F(() => Y(!1)), ce = F(() => le.value ? Y(!0) : ge.value), G = oL();
    function z(he) {
      return G.value ? In(G.value, he ? "dd.MM.yyyy, HH:mm" : "EEE dd. MMM. yyyy, HH:mm", {
        locale: c.value
      }) : "";
    }
    const oe = W(!1), q = F(() => z(!1)), ne = F(() => oe.value ? z(!0) : q.value), Fe = W(null), We = W(null), Qe = W(null);
    let nt = null;
    function ut(he, T) {
      return he ? he.getBoundingClientRect().width <= T - V7e : !0;
    }
    function V() {
      const he = Fe.value;
      if (!he) return;
      const T = he.getBoundingClientRect().width;
      le.value = !ut(We.value, T), oe.value = !ut(Qe.value, T);
    }
    At(() => {
      typeof ResizeObserver < "u" && Fe.value && (nt = new ResizeObserver(() => V()), nt.observe(Fe.value)), rt(V);
    }), ei(() => {
      nt == null || nt.disconnect(), nt = null;
    }), Me([ge, q], () => void rt(V));
    function Q(he) {
      return s.min && C1(lt(he), lt(s.min)) || s.max && m1(lt(he), lt(s.max)) ? !0 : s.disabledDate ? s.disabledDate(he) : !1;
    }
    function ye(he) {
      const T = {
        selected: !1,
        rangeStart: !1,
        rangeEnd: !1,
        inRange: !1,
        preview: !1,
        previewStart: !1,
        previewEnd: !1,
        flash: Yn(he, /* @__PURE__ */ new Date()) ? Dt.value : 0
      };
      if (!d.value)
        return { ...T, selected: m.value ? Yn(he, m.value) : !1 };
      const re = w.value, me = y.value, Ee = { ...T };
      if (re && Yn(he, re) && (Ee.rangeStart = !0), me && Yn(he, me) && (Ee.rangeEnd = !0), re && me && m1(lt(he), lt(re)) && C1(lt(he), lt(me)) && (Ee.inRange = !0), re && !me && M.value && !Q(M.value)) {
        const Ne = M.value, [De, kt] = ae(re, Ne), Ht = lt(he), di = C1(lt(Ne), lt(re));
        Ee.previewDirection = di ? "backward" : "forward", m1(Ht, lt(De)) && C1(Ht, lt(kt)) && (Ee.preview = !0), Yn(Ne, re) || (Yn(he, re) && di && (Ee.rangeStart = !1, Ee.rangeEnd = !0), Yn(he, Ne) && (Ee.preview = !0, di ? Ee.previewStart = !0 : Ee.previewEnd = !0));
      }
      return Ee;
    }
    function ae(he, T) {
      return m1(he, T) ? [T, he] : [he, T];
    }
    function ie(he) {
      P.value = Ec(P.value, he);
    }
    function Oe() {
      const he = /* @__PURE__ */ new Date(), T = lt(he);
      if (P.value = mr(T), Dt.value++, n.readonly || Q(T)) return;
      const re = { hours: he.getHours(), minutes: he.getMinutes(), seconds: he.getSeconds() };
      d.value ? (w.value = T, y.value = T, M.value = null, _s(n.mode) && (b.value = { ...re }, _.value = { ...re }), gt(), n.mode === "dateRange" && i("selectionComplete")) : (m.value = T, _s(n.mode) && (b.value = { ...re }), gt(), n.mode === "date" && i("selectionComplete"));
    }
    const Dt = W(0);
    function ai(he) {
      P.value = new Date(he, P.value.getMonth(), 1);
    }
    function fs(he) {
      d.value && w.value && !y.value && (M.value = he);
    }
    function Le(he) {
      if (n.readonly || Q(he)) return;
      const T = lt(he), re = /* @__PURE__ */ new Date(), me = { hours: re.getHours(), minutes: re.getMinutes(), seconds: re.getSeconds() };
      if (!d.value) {
        m.value = T, _s(n.mode) && (b.value = { ...me }), gt(), n.mode === "date" && i("selectionComplete");
        return;
      }
      if (!w.value || w.value && y.value)
        w.value = T, y.value = null, M.value = null;
      else {
        const [Ee, Ne] = ae(w.value, T);
        w.value = Ee, y.value = Ne, M.value = null, _s(n.mode) && (b.value = { ...me }, _.value = { ...me });
      }
      gt(), n.mode === "dateRange" && w.value && y.value && i("selectionComplete");
    }
    function Te(he, T) {
      he === "start" ? b.value = T : _.value = T, gt();
    }
    function Be(he, T) {
      const re = b.value ? { ...b.value } : { hours: 0, minutes: 0, seconds: 0 };
      re[he] = T, b.value = re, gt();
    }
    function ht(he, T) {
      const re = new Date(he);
      return re.setHours((T == null ? void 0 : T.hours) ?? 0, (T == null ? void 0 : T.minutes) ?? 0, (T == null ? void 0 : T.seconds) ?? 0, 0), re;
    }
    function jo() {
      return n.mode === "date" ? m.value : n.mode === "datetime" ? m.value ? ht(m.value, b.value) : null : n.mode === "time" && b.value ? ht(lt(/* @__PURE__ */ new Date()), b.value) : null;
    }
    function So(he) {
      if (n.mode === "dateRange") return [w.value, y.value];
      if (n.mode === "timeRange") {
        const T = lt(/* @__PURE__ */ new Date());
        return he ? [lt(T), Pc(T)] : [
          b.value ? ht(T, b.value) : null,
          _.value ? ht(T, _.value) : null
        ];
      }
      return he ? [w.value ? lt(w.value) : null, y.value ? Pc(y.value) : null] : [
        w.value ? ht(w.value, b.value) : null,
        y.value ? ht(y.value, _.value) : null
      ];
    }
    let _t = !1;
    function gt(he) {
      const T = d.value ? So(he ?? x.value) : jo();
      _t = !0, r.value = T;
    }
    function ci() {
      if (_t) {
        _t = !1;
        return;
      }
      if (d.value) {
        const [he, T] = r.value ?? [null, null];
        w.value = he ? lt(he) : null, y.value = T ? lt(T) : null, b.value = he ? vs(he) : b.value, _.value = T ? vs(T) : _.value, he && (P.value = mr(he));
      } else {
        const he = r.value;
        m.value = he ? lt(he) : null, he && _s(n.mode) && (b.value = vs(he)), he && rd(n.mode) && (P.value = mr(he));
      }
    }
    function vs(he) {
      return { hours: he.getHours(), minutes: he.getMinutes(), seconds: he.getSeconds() };
    }
    return Me(r, ci, { immediate: !0 }), t({ goToToday: Oe }), (he, T) => {
      var re, me, Ee, Ne;
      return f(), v("div", {
        class: S([he.$style.panel, { [he.$style.inline]: e.inline }]),
        "test-id": "sca-calendar-panel"
      }, [
        u.value ? (f(), v("div", {
          key: 0,
          class: S(he.$style.toolbar)
        }, [
          g("div", {
            class: S(he.$style.toolbarControls)
          }, [
            de(ot, {
              icon: "phosphor/caret-left",
              size: "small",
              type: "default",
              appearance: "secondary",
              title: k(l)("datetimePicker.previousMonth"),
              "test-id": "sca-calendar-prev",
              onClick: T[0] || (T[0] = (De) => ie(-1))
            }, null, 8, ["title"]),
            de(ot, {
              icon: "phosphor/caret-right",
              size: "small",
              type: "default",
              appearance: "secondary",
              title: k(l)("datetimePicker.nextMonth"),
              "test-id": "sca-calendar-next",
              onClick: T[1] || (T[1] = (De) => ie(1))
            }, null, 8, ["title"]),
            s.maxMonths > 1 ? (f(), U(zt, {
              key: 0,
              "is-open": H.value,
              "onUpdate:isOpen": T[3] || (T[3] = (De) => H.value = De),
              "offset-y": 5,
              placement: "bottom-start",
              "padding-upset": ""
            }, {
              trigger: ee(({ togglePopover: De }) => [
                de(ot, {
                  icon: "phosphor/gear",
                  size: "small",
                  type: "default",
                  appearance: "secondary",
                  title: k(l)("datetimePicker.settings"),
                  "test-id": "sca-calendar-settings",
                  onClick: (kt) => De()
                }, null, 8, ["title", "onClick"])
              ]),
              default: ee(() => [
                g("div", {
                  class: S(he.$style.settings)
                }, [
                  de(Ds, {
                    modelValue: I.value,
                    "onUpdate:modelValue": T[2] || (T[2] = (De) => I.value = De),
                    label: k(l)("datetimePicker.months"),
                    items: j.value,
                    "test-id": "sca-calendar-months-select"
                  }, null, 8, ["modelValue", "label", "items"]),
                  g("div", {
                    class: S(he.$style.columnsField)
                  }, [
                    de(c2, {
                      label: k(l)("datetimePicker.columns")
                    }, {
                      default: ee(() => [
                        g("div", {
                          class: S(he.$style.columnsRow)
                        }, [
                          (f(), v(we, null, Ze(4, (De) => de(It, {
                            key: De,
                            class: S(he.$style.columnsButton),
                            size: "small",
                            type: "toggle",
                            appearance: B.value === De ? "primary" : "secondary",
                            "padding-left": "0px",
                            "padding-right": "0px",
                            selected: B.value === De,
                            disabled: De > I.value,
                            "test-id": `sca-calendar-columns-${De}`,
                            onClick: (kt) => B.value = De
                          }, {
                            default: ee(() => [
                              Ve(se(De), 1)
                            ]),
                            _: 2
                          }, 1032, ["class", "appearance", "selected", "disabled", "test-id", "onClick"])), 64))
                        ], 2)
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ], 2)
                ], 2)
              ]),
              _: 1
            }, 8, ["is-open"])) : $("", !0),
            de(It, {
              size: "small",
              type: "default",
              appearance: "secondary",
              "padding-left": "8px",
              "padding-right": "8px",
              onClick: Oe
            }, {
              default: ee(() => [
                Ve(se(k(l)("datetimePicker.today")), 1)
              ]),
              _: 1
            })
          ], 2),
          g("div", {
            ref_key: "toolbarContentRef",
            ref: Fe,
            class: S(he.$style.toolbarContent)
          }, [
            g("span", {
              class: S(he.$style.rangeLabel)
            }, se(ce.value), 3),
            g("span", {
              ref_key: "rangeProbeRef",
              ref: We,
              class: S([he.$style.rangeLabel, he.$style.rangeProbe]),
              "aria-hidden": "true"
            }, se(ge.value), 3),
            g("span", {
              class: S(he.$style.selectionLabel),
              "test-id": "sca-calendar-now"
            }, se(ne.value), 3),
            g("span", {
              ref_key: "nowProbeRef",
              ref: Qe,
              class: S([he.$style.selectionLabel, he.$style.rangeProbe]),
              "aria-hidden": "true"
            }, se(q.value), 3)
          ], 2)
        ], 2)) : $("", !0),
        u.value ? (f(), v("div", {
          key: 1,
          class: S([he.$style.months, { [he.$style.readonly]: e.readonly }]),
          style: Ge(N.value)
        }, [
          (f(!0), v(we, null, Ze(O.value, (De, kt) => (f(), U(M7e, {
            key: De.getTime(),
            month: De,
            "week-starts-on": s.weekStartsOn,
            "show-week-numbers": s.showWeekNumbers,
            weekdays: te.value,
            "week-label": k(l)("datetimePicker.weekShort"),
            "month-label": Z(De),
            years: E.value,
            "year-selectable": !0,
            "is-disabled": Q,
            "get-day-state": ye,
            readonly: e.readonly,
            "test-id": `sca-calendar-month-${kt}`,
            onSelect: Le,
            onHover: fs,
            onSelectYear: ai,
            onMouseleave: T[4] || (T[4] = (Ht) => M.value = null)
          }, null, 8, ["month", "week-starts-on", "show-week-numbers", "weekdays", "week-label", "month-label", "years", "readonly", "test-id"]))), 128))
        ], 6)) : $("", !0),
        h.value ? (f(), v("div", {
          key: 2,
          class: S([he.$style.timeArea, { [he.$style.noBorder]: !u.value, [he.$style.stacked]: e.mode === "time" }]),
          "test-id": "sca-calendar-time"
        }, [
          e.mode === "time" ? (f(), v("div", D7e, [
            de(_1, {
              "model-value": ((re = b.value) == null ? void 0 : re.hours) ?? null,
              label: k(l)("datetimePicker.hours"),
              max: 23,
              placeholder: "hh",
              "test-id": "sca-time-hours",
              "onUpdate:modelValue": T[5] || (T[5] = (De) => Be("hours", De))
            }, null, 8, ["model-value", "label"]),
            de(_1, {
              "model-value": ((me = b.value) == null ? void 0 : me.minutes) ?? null,
              label: k(l)("datetimePicker.minutes"),
              max: 59,
              step: 1,
              placeholder: "mm",
              "test-id": "sca-time-minutes",
              "onUpdate:modelValue": T[6] || (T[6] = (De) => Be("minutes", De))
            }, null, 8, ["model-value", "label"])
          ])) : e.mode === "datetime" ? (f(), v("div", {
            key: 1,
            class: S(he.$style.timeUnitRow)
          }, [
            de(_1, {
              "model-value": ((Ee = b.value) == null ? void 0 : Ee.hours) ?? null,
              label: k(l)("datetimePicker.h"),
              max: 23,
              placeholder: "hh",
              "test-id": "sca-time-hours",
              "label-size": 20,
              width: 85,
              gap: 4,
              "onUpdate:modelValue": T[7] || (T[7] = (De) => Be("hours", De))
            }, null, 8, ["model-value", "label"]),
            de(_1, {
              "model-value": ((Ne = b.value) == null ? void 0 : Ne.minutes) ?? null,
              label: k(l)("datetimePicker.m"),
              max: 59,
              step: 1,
              placeholder: "mm",
              "test-id": "sca-time-minutes",
              "label-size": 32,
              width: 105,
              gap: 4,
              "onUpdate:modelValue": T[8] || (T[8] = (De) => Be("minutes", De))
            }, null, 8, ["model-value", "label"])
          ], 2)) : (f(), v(we, { key: 2 }, [
            de(dd, {
              "model-value": L.value,
              label: k(l)("datetimePicker.start"),
              "minute-step": s.minuteStep,
              disabled: x.value,
              "test-id": "sca-time-start",
              width: 104,
              "onUpdate:modelValue": T[9] || (T[9] = (De) => Te("start", De))
            }, null, 8, ["model-value", "label", "minute-step", "disabled"]),
            de(dd, {
              "model-value": A.value,
              label: k(l)("datetimePicker.end"),
              "minute-step": s.minuteStep,
              disabled: x.value,
              "test-id": "sca-time-end",
              width: 100,
              "onUpdate:modelValue": T[10] || (T[10] = (De) => Te("end", De))
            }, null, 8, ["model-value", "label", "minute-step", "disabled"]),
            g("div", {
              class: S(he.$style.allDayField)
            }, [
              g("span", {
                class: S(he.$style.allDayLable)
              }, se(k(l)("datetimePicker.allDay")), 3),
              de($C, {
                "model-value": x.value,
                class: S(he.$style.allDayToggle),
                "no-padding": "",
                "test-id": "sca-time-allday",
                "onUpdate:modelValue": R
              }, null, 8, ["model-value", "class"])
            ], 2)
          ], 64))
        ], 2)) : $("", !0)
      ], 2);
    };
  }
}), B7e = "_panel_62ll1_747", $7e = "_inline_62ll1_753", Z7e = "_toolbar_62ll1_757", G7e = "_toolbarControls_62ll1_773", N7e = "_toolbarContent_62ll1_779", z7e = "_rangeLabel_62ll1_786", j7e = "_selectionLabel_62ll1_800", W7e = "_rangeProbe_62ll1_815", U7e = "_months_62ll1_823", K7e = "_settings_62ll1_829", q7e = "_columnsField_62ll1_838", Y7e = "_columnsLabel_62ll1_847", Q7e = "_columnsRow_62ll1_857", J7e = "_columnsButton_62ll1_862", X7e = "_timeArea_62ll1_869", e3e = "_noBorder_62ll1_879", t3e = "_stacked_62ll1_889", o3e = "_timeUnitRow_62ll1_896", n3e = "_allDayField_62ll1_902", s3e = "_allDayLable_62ll1_907", i3e = "_allDayToggle_62ll1_920", r3e = {
  panel: B7e,
  inline: $7e,
  toolbar: Z7e,
  toolbarControls: G7e,
  toolbarContent: N7e,
  rangeLabel: z7e,
  selectionLabel: j7e,
  rangeProbe: W7e,
  months: U7e,
  settings: K7e,
  columnsField: q7e,
  columnsLabel: Y7e,
  columnsRow: Q7e,
  columnsButton: J7e,
  timeArea: X7e,
  noBorder: e3e,
  stacked: t3e,
  timeUnitRow: o3e,
  allDayField: n3e,
  allDayLable: s3e,
  allDayToggle: i3e
}, l3e = {
  $style: r3e
}, ud = /* @__PURE__ */ Ce(O7e, [["__cssModules", l3e]]), a3e = ["aria-expanded"], c3e = ["id", "popovertarget", "disabled", "aria-label"], d3e = -4, u3e = 16, h3e = /* @__PURE__ */ pe({
  __name: "SCADatetimePicker",
  props: /* @__PURE__ */ Ct({
    mode: { default: "date" },
    inline: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    appearance: { default: void 0 },
    config: { default: void 0 },
    dateFormat: { default: "dd.MM.yyyy" },
    timeFormat: { default: "HH:mm" },
    datePrecision: { default: void 0 },
    timePrecision: { default: void 0 },
    clearable: { type: Boolean, default: !0 },
    placeholder: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    htmlFor: { default: void 0 },
    alert: { type: Boolean, default: !1 },
    manualInput: { type: Boolean, default: !1 }
  }, {
    modelValue: { default: null },
    modelModifiers: {},
    allDay: { type: Boolean, default: !1 },
    allDayModifiers: {},
    months: { default: 1 },
    monthsModifiers: {},
    columns: { default: 1 },
    columnsModifiers: {},
    isOpen: { type: Boolean, default: !1 },
    isOpenModifiers: {},
    invalid: { type: Boolean, default: !1 },
    invalidModifiers: {}
  }),
  emits: ["update:modelValue", "update:allDay", "update:months", "update:columns", "update:isOpen", "update:invalid"],
  setup(e, { expose: t }) {
    const o = e, { locale: n } = Go(), s = F(() => Kl(n.value)), i = ct(e, "modelValue"), r = ct(e, "allDay"), l = ct(e, "months"), a = ct(e, "columns"), c = ct(e, "isOpen"), d = ct(e, "invalid"), u = F(() => HC(o.mode)), h = W(), p = W(null);
    function C() {
      if (!h.value) return;
      const ce = getComputedStyle(h.value).getPropertyValue("--sca-label-size").trim(), G = Number.parseFloat(ce);
      p.value = Number.isFinite(G) ? G : null;
    }
    const m = F(() => p.value != null ? -(p.value + u3e) : d3e);
    At(C), Me(c, (ce) => ce && C());
    const w = W(!1), y = W(), b = W(), _ = W();
    function M() {
      var ce;
      o.manualInput && ((ce = u.value ? b.value : y.value) == null || ce.focus());
    }
    t({ focus: M });
    const x = W(!1), L = W(!1), A = W(!1);
    Nl(() => {
      d.value = o.manualInput && (x.value || L.value || A.value);
    });
    const R = F({
      get: () => u.value ? null : i.value ?? null,
      set: (ce) => {
        i.value = ce;
      }
    }), P = F({
      get: () => (i.value ?? [null, null])[0] ?? null,
      set: (ce) => {
        const G = i.value ?? [null, null];
        i.value = [ce, G[1]];
      }
    }), I = F({
      get: () => (i.value ?? [null, null])[1] ?? null,
      set: (ce) => {
        const G = i.value ?? [null, null];
        i.value = [G[0], ce];
      }
    }), B = F(() => Ul(o.dateFormat, o.datePrecision)), H = F(() => q5(o.timeFormat, o.timePrecision)), O = F(() => o.mode === "time" || o.mode === "timeRange" ? H.value : _s(o.mode) ? `${B.value} ${H.value}` : B.value);
    function N(ce) {
      return ce ? In(ce, O.value, { locale: s.value }) : "";
    }
    const te = F(() => {
      if (u.value) {
        const [ce, G] = i.value ?? [null, null];
        return !!ce || !!G;
      }
      return !!i.value;
    }), E = F(() => o.clearable && te.value && !o.disabled), j = F(() => N((i.value ?? [null, null])[0])), Z = F(() => N((i.value ?? [null, null])[1])), Y = F(() => u.value ? !j.value && !Z.value ? "" : `${j.value} – ${Z.value}` : N(i.value));
    function le() {
      c.value = !1;
    }
    function ge() {
      i.value = u.value ? [null, null] : null;
    }
    return (ce, G) => e.inline ? (f(), U(ud, {
      key: 0,
      modelValue: i.value,
      "onUpdate:modelValue": G[0] || (G[0] = (z) => i.value = z),
      "all-day": r.value,
      "onUpdate:allDay": G[1] || (G[1] = (z) => r.value = z),
      months: l.value,
      "onUpdate:months": G[2] || (G[2] = (z) => l.value = z),
      columns: a.value,
      "onUpdate:columns": G[3] || (G[3] = (z) => a.value = z),
      mode: e.mode,
      readonly: e.readonly || e.disabled,
      config: e.config,
      inline: "",
      class: S({ [ce.$style.disabledPanel]: e.disabled })
    }, null, 8, ["modelValue", "all-day", "months", "columns", "mode", "readonly", "config", "class"])) : (f(), U(zt, {
      key: 1,
      "is-open": c.value,
      "onUpdate:isOpen": G[19] || (G[19] = (z) => c.value = z),
      class: S(ce.$style.dropdown),
      placement: "bottom-start",
      "padding-upset": "",
      "no-mobile-margin": "",
      "offset-x": m.value,
      "offset-y": 5
    }, {
      trigger: ee(({ target: z }) => [
        e.manualInput ? (f(), U($r, {
          key: 0,
          "underline-override": "",
          appearance: e.appearance,
          focused: c.value || w.value,
          alert: e.alert || d.value
        }, {
          default: ee(() => [
            g("div", {
              ref_key: "offsetScope",
              ref: h,
              class: S(ce.$style.manualTrigger),
              onFocusin: G[12] || (G[12] = (oe) => w.value = !0),
              onFocusout: G[13] || (G[13] = (oe) => w.value = !1)
            }, [
              g("input", {
                readonly: "",
                tabindex: "-1",
                "aria-hidden": "true",
                class: S(ce.$style.styleProbe)
              }, null, 2),
              g("div", {
                class: S([ce.$style.manualContent, { [ce.$style.withClear]: E.value }])
              }, [
                u.value ? (f(), v("div", {
                  key: 0,
                  class: S(ce.$style.manualRangeGroup)
                }, [
                  de(Oa, {
                    ref_key: "startEditor",
                    ref: b,
                    modelValue: P.value,
                    "onUpdate:modelValue": G[4] || (G[4] = (oe) => P.value = oe),
                    invalid: L.value,
                    "onUpdate:invalid": G[5] || (G[5] = (oe) => L.value = oe),
                    format: O.value,
                    disabled: e.disabled,
                    readonly: e.readonly,
                    "test-id": "datetime-manual-start",
                    onNext: G[6] || (G[6] = (oe) => {
                      var q;
                      return (q = _.value) == null ? void 0 : q.focus();
                    })
                  }, null, 8, ["modelValue", "invalid", "format", "disabled", "readonly"]),
                  g("span", {
                    class: S(ce.$style.manualRangeSeparator)
                  }, "–", 2),
                  de(Oa, {
                    ref_key: "endEditor",
                    ref: _,
                    modelValue: I.value,
                    "onUpdate:modelValue": G[7] || (G[7] = (oe) => I.value = oe),
                    invalid: A.value,
                    "onUpdate:invalid": G[8] || (G[8] = (oe) => A.value = oe),
                    format: O.value,
                    disabled: e.disabled,
                    readonly: e.readonly,
                    "test-id": "datetime-manual-end",
                    onPrev: G[9] || (G[9] = (oe) => {
                      var q;
                      return (q = b.value) == null ? void 0 : q.focusLast();
                    })
                  }, null, 8, ["modelValue", "invalid", "format", "disabled", "readonly"])
                ], 2)) : (f(), U(Oa, {
                  key: 1,
                  ref_key: "singleEditor",
                  ref: y,
                  modelValue: R.value,
                  "onUpdate:modelValue": G[10] || (G[10] = (oe) => R.value = oe),
                  invalid: x.value,
                  "onUpdate:invalid": G[11] || (G[11] = (oe) => x.value = oe),
                  format: O.value,
                  disabled: e.disabled,
                  readonly: e.readonly,
                  "test-id": "datetime-manual"
                }, null, 8, ["modelValue", "invalid", "format", "disabled", "readonly"])),
                E.value ? (f(), v("button", {
                  key: 2,
                  type: "button",
                  tabindex: "-1",
                  class: S(ce.$style.clearButton),
                  onClick: xe(ge, ["stop"])
                }, [
                  de(Ae, {
                    icon: "phosphor/x",
                    size: "12px",
                    class: S(ce.$style.clearIcon)
                  }, null, 8, ["class"])
                ], 2)) : $("", !0),
                ve(ce.$slots, "default")
              ], 2)
            ], 34)
          ]),
          _: 3
        }, 8, ["appearance", "focused", "alert"])) : (f(), U($r, {
          key: 1,
          "underline-override": "",
          appearance: e.appearance,
          focused: c.value,
          alert: e.alert
        }, {
          default: ee(() => [
            g("div", {
              ref_key: "offsetScope",
              ref: h,
              class: S([ce.$style.dropdownTrigger, { [ce.$style.disabled]: e.disabled }])
            }, [
              g("input", {
                readonly: "",
                "aria-haspopup": !0,
                "aria-expanded": c.value,
                onKeydown: G[14] || (G[14] = ol(xe((oe) => c.value = !0, ["prevent"]), ["enter"]))
              }, null, 40, a3e),
              g("button", {
                id: e.htmlFor,
                type: "button",
                tabindex: "-1",
                popovertarget: z,
                disabled: e.disabled,
                "aria-label": e.placeholder,
                class: S(ce.$style.triggerButton)
              }, null, 10, c3e),
              g("div", {
                class: S([ce.$style.content, { [ce.$style.withClear]: E.value }])
              }, [
                te.value ? (f(), v(we, { key: 0 }, [
                  u.value ? (f(), v("div", {
                    key: 0,
                    class: S(ce.$style.rangeGroup)
                  }, [
                    g("span", {
                      class: S(j.value ? ce.$style.value : ce.$style.placeholder)
                    }, se(j.value || O.value), 3),
                    g("span", {
                      class: S(ce.$style.rangeSeparator)
                    }, "–", 2),
                    g("span", {
                      class: S(Z.value ? ce.$style.value : ce.$style.placeholder)
                    }, se(Z.value || O.value), 3)
                  ], 2)) : (f(), v("span", {
                    key: 1,
                    class: S(ce.$style.value)
                  }, se(Y.value), 3)),
                  E.value ? (f(), v("button", {
                    key: 2,
                    type: "button",
                    tabindex: "-1",
                    class: S(ce.$style.clearButton),
                    onClick: xe(ge, ["stop"])
                  }, [
                    de(Ae, {
                      icon: "phosphor/x",
                      size: "12px",
                      class: S(ce.$style.clearIcon)
                    }, null, 8, ["class"])
                  ], 2)) : $("", !0)
                ], 64)) : (f(), v("span", {
                  key: 1,
                  class: S(ce.$style.placeholder)
                }, se(e.placeholder), 3)),
                ve(ce.$slots, "default")
              ], 2)
            ], 2)
          ]),
          _: 2
        }, 1032, ["appearance", "focused", "alert"]))
      ]),
      default: ee(() => [
        de(ud, {
          modelValue: i.value,
          "onUpdate:modelValue": G[15] || (G[15] = (z) => i.value = z),
          "all-day": r.value,
          "onUpdate:allDay": G[16] || (G[16] = (z) => r.value = z),
          months: l.value,
          "onUpdate:months": G[17] || (G[17] = (z) => l.value = z),
          columns: a.value,
          "onUpdate:columns": G[18] || (G[18] = (z) => a.value = z),
          mode: e.mode,
          readonly: e.readonly || e.disabled,
          config: e.config,
          onSelectionComplete: le
        }, null, 8, ["modelValue", "all-day", "months", "columns", "mode", "readonly", "config"])
      ]),
      _: 3
    }, 8, ["is-open", "class", "offset-x"]));
  }
}), g3e = "_disabledPanel_5u5ki_1", p3e = "_dropdown_5u5ki_6", f3e = "_manualTrigger_5u5ki_10", v3e = "_styleProbe_5u5ki_14", m3e = "_manualContent_5u5ki_26", C3e = "_withClear_5u5ki_35", w3e = "_manualRangeGroup_5u5ki_38", b3e = "_manualRangeSeparator_5u5ki_45", y3e = "_dropdownTrigger_5u5ki_55", _3e = "_disabled_5u5ki_1", S3e = "_triggerButton_5u5ki_65", x3e = "_content_5u5ki_80", M3e = "_rangeGroup_5u5ki_93", A3e = "_value_5u5ki_100", L3e = "_placeholder_5u5ki_101", E3e = "_rangeSeparator_5u5ki_124", P3e = "_clearButton_5u5ki_134", R3e = "_clearIcon_5u5ki_159", F3e = {
  disabledPanel: g3e,
  dropdown: p3e,
  manualTrigger: f3e,
  styleProbe: v3e,
  manualContent: m3e,
  withClear: C3e,
  manualRangeGroup: w3e,
  manualRangeSeparator: b3e,
  dropdownTrigger: y3e,
  disabled: _3e,
  triggerButton: S3e,
  content: x3e,
  rangeGroup: M3e,
  value: A3e,
  placeholder: L3e,
  rangeSeparator: E3e,
  clearButton: P3e,
  clearIcon: R3e
}, T3e = {
  $style: F3e
}, I3e = /* @__PURE__ */ Ce(h3e, [["__cssModules", T3e]]), S1 = [];
function GC(e) {
  const t = Symbol("dialog");
  S1.push(t), Yi(() => {
    const o = S1.indexOf(t);
    o !== -1 && S1.splice(o, 1);
  }), Xt(window, "keydown", (o) => {
    var n;
    if (S1.at(-1) === t)
      switch (o.key) {
        case "Escape":
          e.onEscape();
          break;
        case "Enter":
          (n = e.onEnter) == null || n.call(e);
          break;
      }
  });
}
const D3e = /* @__PURE__ */ pe({
  __name: "SCAAvatarDialog",
  props: {
    title: {},
    isPreview: { type: Boolean, default: !1 }
  },
  emits: ["close", "confirm"],
  setup(e, { emit: t }) {
    const o = t, n = Qt();
    return GC({
      onEscape: () => o("close"),
      onEnter: () => o("confirm")
    }), (s, i) => (f(), v("div", {
      class: S(s.$style.root)
    }, [
      g("div", {
        class: S(s.$style.dialogHeader)
      }, [
        de(ot, {
          class: S(s.$style.closeButton),
          icon: "phosphor/x",
          type: "bare",
          appearance: "secondary",
          title: s.$t("common.action.close"),
          onClick: i[0] || (i[0] = (r) => o("close"))
        }, null, 8, ["class", "title"]),
        e.isPreview ? $("", !0) : (f(), U(It, {
          key: 0,
          "icon-left": "phosphor/floppy-disk",
          size: "small",
          onClick: i[1] || (i[1] = (r) => o("confirm"))
        }, {
          default: ee(() => [
            Ve(se(s.$t("common.action.save")), 1)
          ]),
          _: 1
        })),
        e.isPreview ? $("", !0) : ve(s.$slots, "toolBar", { key: 1 }),
        g("div", {
          class: S([s.$style.title, { [s.$style.show]: e.isPreview }])
        }, se(e.title), 3)
      ], 2),
      k(n).default ? (f(), v("div", {
        key: 0,
        class: S(s.$style.content)
      }, [
        ve(s.$slots, "default")
      ], 2)) : $("", !0),
      k(n).actions ? (f(), v("div", {
        key: 1,
        class: S([s.$style.dialogHeader, s.$style.border, s.$style.center])
      }, [
        ve(s.$slots, "actions")
      ], 2)) : $("", !0)
    ], 2));
  }
}), k3e = "_root_1qtm8_747", H3e = "_dialogHeader_1qtm8_785", V3e = "_title_1qtm8_798", O3e = "_show_1qtm8_809", B3e = "_border_1qtm8_819", $3e = "_center_1qtm8_824", Z3e = "_content_1qtm8_828", G3e = "_closeButton_1qtm8_832", N3e = {
  root: k3e,
  dialogHeader: H3e,
  title: V3e,
  show: O3e,
  border: B3e,
  center: $3e,
  content: Z3e,
  closeButton: G3e
}, z3e = {
  $style: N3e
}, pst = /* @__PURE__ */ Ce(D3e, [["__cssModules", z3e]]), j3e = /* @__PURE__ */ pe({
  __name: "SCASearchInput",
  props: {
    disabled: { type: Boolean, default: !1 },
    appearance: { default: void 0 },
    fixedWidth: { type: Boolean, default: !1 },
    showClearIcon: { type: Boolean, default: !0 },
    isNavBarSearch: { type: Boolean, default: !1 },
    showShadow: { type: Boolean, default: !1 },
    inverted: { type: Boolean, default: !1 }
  },
  emits: ["clear"],
  setup(e, { emit: t }) {
    const o = t;
    return (n, s) => (f(), U($r, {
      appearance: e.appearance,
      inverted: e.inverted,
      disabled: e.disabled,
      "fixed-width": e.fixedWidth,
      class: S([n.$style.inputBase, { [n.$style.inputBaseNavBar]: e.isNavBarSearch, [n.$style.shadowed]: e.showShadow }]),
      "fixed-height": e.isNavBarSearch
    }, sn({
      default: ee(() => [
        ve(n.$slots, "default"),
        ve(n.$slots, "after")
      ]),
      _: 2
    }, [
      e.showClearIcon ? {
        name: "after",
        fn: ee(() => [
          de(Ae, {
            class: S({
              [n.$style.borderAppearanceMargin]: e.appearance === "border",
              [n.$style.navBarIconClear]: e.isNavBarSearch
            }),
            disabled: e.disabled || !e.showClearIcon,
            size: "12px",
            icon: "phosphor/x",
            onClick: s[0] || (s[0] = (i) => o("clear", i))
          }, null, 8, ["class", "disabled"])
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["appearance", "inverted", "disabled", "fixed-width", "class", "fixed-height"]));
  }
}), W3e = "_searchIcon_h758y_1", U3e = "_borderAppearanceMargin_h758y_6", K3e = "_inputBase_h758y_10", q3e = "_inputBaseNavBar_h758y_17", Y3e = "_navBarIconSearch_h758y_21", Q3e = "_navBarIconClear_h758y_27", J3e = "_shadowed_h758y_32", X3e = {
  searchIcon: W3e,
  borderAppearanceMargin: U3e,
  inputBase: K3e,
  inputBaseNavBar: q3e,
  navBarIconSearch: Y3e,
  navBarIconClear: Q3e,
  shadowed: J3e
}, ehe = {
  $style: X3e
}, oa = /* @__PURE__ */ Ce(j3e, [["__cssModules", ehe]]), the = ["value", "placeholder"], ohe = { key: 0 }, nhe = /* @__PURE__ */ pe({
  __name: "SCADialog",
  props: {
    title: { default: void 0 },
    size: { default: "medium" },
    padding: { default: "medium" },
    hasCloseIcon: { type: Boolean, default: !0 },
    confirmOnEnter: { type: Boolean, default: !0 },
    headerAppearance: { default: "brand" },
    searchTerm: { default: void 0 }
  },
  emits: ["close", "confirm", "update:searchTerm"],
  setup(e, { emit: t }) {
    const o = e, n = t, s = Qt();
    return GC({
      onEscape: () => n("close"),
      onEnter: () => {
        o.confirmOnEnter && n("confirm");
      }
    }), (i, r) => (f(), v("div", {
      class: S([
        i.$style.root,
        {
          [i.$style.sizeSmall]: e.size === "small",
          [i.$style.sizeLarge]: e.size === "large",
          [i.$style.paddingLarge]: e.padding === "large",
          [i.$style.headerPlain]: e.headerAppearance === "plain"
        }
      ])
    }, [
      g("div", {
        class: S(i.$style.dialogHeader)
      }, [
        g("div", {
          class: S(i.$style.actions)
        }, [
          e.hasCloseIcon ? (f(), U(ot, {
            key: 0,
            class: S(i.$style.closeButton),
            icon: "phosphor/x",
            type: e.headerAppearance === "plain" ? "bare" : "ghost",
            appearance: e.headerAppearance === "plain" ? "secondary" : "inverted",
            size: "small",
            title: i.$t("common.action.close"),
            onClick: r[0] || (r[0] = (l) => n("close"))
          }, null, 8, ["class", "type", "appearance", "title"])) : $("", !0),
          k(s).actions ? ve(i.$slots, "actions", { key: 1 }) : $("", !0),
          e.searchTerm !== void 0 ? (f(), U(oa, {
            key: 2,
            appearance: "border",
            inverted: "",
            class: S(i.$style.search),
            "show-clear-icon": e.searchTerm.length > 0,
            onClear: r[2] || (r[2] = (l) => n("update:searchTerm", ""))
          }, {
            default: ee(() => [
              g("input", {
                value: e.searchTerm,
                placeholder: i.$t("common.action.search"),
                onInput: r[1] || (r[1] = (l) => n("update:searchTerm", l.target.value))
              }, null, 40, the)
            ]),
            _: 1
          }, 8, ["class", "show-clear-icon"])) : $("", !0)
        ], 2),
        k(s).dialogHeader ? (f(), v("div", {
          key: 0,
          class: S(i.$style.headerSlot)
        }, [
          ve(i.$slots, "dialogHeader")
        ], 2)) : $("", !0),
        e.title ? (f(), v("div", {
          key: 1,
          class: S(i.$style.title)
        }, se(e.title), 3)) : $("", !0)
      ], 2),
      k(s).contentHeader ? (f(), v("div", ohe, [
        ve(i.$slots, "contentHeader")
      ])) : $("", !0),
      k(s).default ? (f(), v("div", {
        key: 1,
        class: S(i.$style.content)
      }, [
        ve(i.$slots, "default")
      ], 2)) : $("", !0),
      k(s).footer ? (f(), v("div", {
        key: 2,
        class: S(i.$style.footer)
      }, [
        ve(i.$slots, "footer")
      ], 2)) : $("", !0)
    ], 2));
  }
}), she = "_root_pjjd3_747", ihe = "_sizeSmall_pjjd3_768", rhe = "_sizeLarge_pjjd3_771", lhe = "_paddingLarge_pjjd3_774", ahe = "_dialogHeader_pjjd3_777", che = "_headerPlain_pjjd3_783", dhe = "_actions_pjjd3_817", uhe = "_title_pjjd3_825", hhe = "_closeButton_pjjd3_837", ghe = "_content_pjjd3_849", phe = "_headerSlot_pjjd3_857", fhe = "_search_pjjd3_863", vhe = "_footer_pjjd3_869", mhe = {
  root: she,
  sizeSmall: ihe,
  sizeLarge: rhe,
  paddingLarge: lhe,
  dialogHeader: ahe,
  headerPlain: che,
  actions: dhe,
  title: uhe,
  closeButton: hhe,
  content: ghe,
  headerSlot: phe,
  search: fhe,
  footer: vhe
}, Che = {
  $style: mhe
}, whe = /* @__PURE__ */ Ce(nhe, [["__cssModules", Che]]), bhe = { key: 0 }, yhe = /* @__PURE__ */ pe({
  __name: "SCAConfirmationDialog",
  props: {
    title: { default: void 0 },
    text: { default: void 0 },
    showDeleteSecondaryText: { type: Boolean, default: !0 },
    confirmationText: { default: void 0 },
    cancelText: { default: void 0 },
    discardText: { default: void 0 },
    discardIcon: { default: void 0 },
    confirmIcon: { default: void 0 },
    type: { default: "alert" },
    customComponent: { default: void 0 },
    customComponentProps: { default: () => ({}) }
  },
  setup(e) {
    const { t } = Go(), o = e, n = F(
      () => o.title ?? {
        alert: t("common.label.pleaseConfirmAction"),
        save: t("common.action.saveChanges"),
        discard: t("settings.tableBar.label.discardChanges2"),
        delete: t("common.action.deleteRecord")
      }[o.type]
    ), s = F(() => {
      const { text: c, type: d, showDeleteSecondaryText: u } = o;
      if (c)
        return {
          primary: c,
          secondary: d === "delete" && u ? t("common.label.stepCannotUndone") : void 0
        };
      if (d === "discard")
        return { primary: t("common.message.confirmDiscardChanges"), secondary: void 0 };
      if (d === "save")
        return { primary: t("common.label.unsavedChangesLike"), secondary: void 0 };
    }), i = pS(), r = W(void 0), l = (c) => {
      r.value = c;
    }, a = (c, d) => {
      const u = d !== void 0 ? d : r.value;
      u ? i.close({
        action: c,
        payload: u
      }) : i.close(c);
    };
    return (c, d) => (f(), U(whe, {
      title: n.value,
      size: "small",
      padding: "large",
      "header-appearance": "plain",
      onClose: d[7] || (d[7] = (u) => a("cancel")),
      onConfirm: d[8] || (d[8] = (u) => a("confirm"))
    }, {
      footer: ee(() => [
        g("div", {
          class: S(c.$style.actions)
        }, [
          g("div", {
            class: S(c.$style.left)
          }, [
            e.type === "alert" ? (f(), U(It, {
              key: 0,
              size: "small",
              "icon-left": e.confirmIcon ?? "phosphor/check",
              onClick: d[0] || (d[0] = (u) => a("confirm"))
            }, {
              default: ee(() => [
                Ve(se(e.confirmationText ?? k(t)("common.action.ok")), 1)
              ]),
              _: 1
            }, 8, ["icon-left"])) : e.type === "save" ? (f(), U(It, {
              key: 1,
              "icon-left": e.confirmIcon ?? "phosphor/floppy-disk",
              size: "small",
              onClick: d[1] || (d[1] = (u) => a("confirm"))
            }, {
              default: ee(() => [
                Ve(se(e.confirmationText ?? k(t)("common.action.save")), 1)
              ]),
              _: 1
            }, 8, ["icon-left"])) : e.type === "delete" ? (f(), U(It, {
              key: 2,
              "icon-left": e.confirmIcon ?? "phosphor/trash",
              size: "small",
              intent: "destructive",
              onClick: d[2] || (d[2] = (u) => a("confirm"))
            }, {
              default: ee(() => [
                Ve(se(e.confirmationText ?? k(t)("common.action.delete")), 1)
              ]),
              _: 1
            }, 8, ["icon-left"])) : e.type === "discard" ? (f(), U(It, {
              key: 3,
              size: "small",
              intent: "destructive",
              "icon-left": e.confirmIcon ?? e.discardIcon ?? "phosphor/broom",
              onClick: d[3] || (d[3] = (u) => a("confirm"))
            }, {
              default: ee(() => [
                Ve(se(e.confirmationText ?? k(t)("settings.tableBar.label.discard")), 1)
              ]),
              _: 1
            }, 8, ["icon-left"])) : $("", !0),
            e.type === "save" ? (f(), U(It, {
              key: 4,
              size: "small",
              appearance: "secondary",
              onClick: d[4] || (d[4] = (u) => a("abort"))
            }, {
              default: ee(() => [
                Ve(se(e.discardText ?? k(t)("settings.tableBar.label.discard")), 1)
              ]),
              _: 1
            })) : $("", !0),
            e.type === "delete" || e.type === "discard" || e.type === "alert" ? (f(), U(It, {
              key: 5,
              size: "small",
              appearance: "secondary",
              onClick: d[5] || (d[5] = (u) => a("cancel"))
            }, {
              default: ee(() => [
                Ve(se(e.discardText ?? k(t)("common.action.cancel")), 1)
              ]),
              _: 1
            })) : $("", !0)
          ], 2),
          g("div", {
            class: S(c.$style.right)
          }, [
            e.type === "save" ? (f(), U(It, {
              key: 0,
              size: "small",
              appearance: "secondary",
              intent: "none",
              type: "ghost",
              onClick: d[6] || (d[6] = (u) => a("cancel"))
            }, {
              default: ee(() => [
                Ve(se(e.cancelText ?? k(t)("common.action.continueEditing")), 1)
              ]),
              _: 1
            })) : $("", !0)
          ], 2)
        ], 2)
      ]),
      default: ee(() => [
        s.value ? (f(), v("div", {
          key: 0,
          class: S(c.$style.message)
        }, [
          g("span", null, se(s.value.primary), 1),
          s.value.secondary ? (f(), v("span", bhe, " " + se(s.value.secondary), 1)) : $("", !0)
        ], 2)) : $("", !0),
        ve(c.$slots, "content", {
          setPayload: l,
          close: a
        }),
        e.customComponent ? (f(), U(Po(e.customComponent), Bt({ key: 1 }, e.customComponentProps, {
          "set-payload": l,
          onClose: a
        }), null, 16)) : $("", !0)
      ]),
      _: 3
    }, 8, ["title"]));
  }
}), _he = "_actions_1ady5_1", She = "_left_1ady5_6", xhe = "_right_1ady5_10", Mhe = "_message_1ady5_14", Ahe = {
  actions: _he,
  left: She,
  right: xhe,
  message: Mhe
}, Lhe = {
  $style: Ahe
}, fst = /* @__PURE__ */ Ce(yhe, [["__cssModules", Lhe]]), Ehe = "_root_1mj7i_747", Phe = "_itemDiv_1mj7i_755", Rhe = {
  root: Ehe,
  itemDiv: Phe
}, Fhe = {};
function The(e, t) {
  return f(), v("div", {
    class: S(e.$style.root)
  }, [
    g("div", {
      class: S(e.$style.itemDiv)
    }, null, 2)
  ], 2);
}
const Ihe = {
  $style: Rhe
}, vst = /* @__PURE__ */ Ce(Fhe, [["render", The], ["__cssModules", Ihe]]), Dhe = /* @__PURE__ */ pe({
  __name: "SCADropdownGroupHeader",
  props: {
    header: {}
  },
  setup(e) {
    return (t, o) => (f(), v("div", {
      class: S(t.$style.root)
    }, [
      g("span", null, se(e.header), 1)
    ], 2));
  }
}), khe = "_root_h74c5_747", Hhe = {
  root: khe
}, Vhe = {
  $style: Hhe
}, mst = /* @__PURE__ */ Ce(Dhe, [["__cssModules", Vhe]]);
function l1(e) {
  return !!e.isFixed;
}
function _r(e) {
  return e.draggable ?? !l1(e);
}
function Ohe(e) {
  return e.some(l1);
}
function NC(e, t) {
  return e.label || t;
}
function Bhe(e, t) {
  const o = NC(e, t);
  return e.labelSuffix ? `${o} ${e.labelSuffix}` : o;
}
function zC(e, t) {
  return !e || t.readonly ? !1 : !l1(e) || !!e.isEditable;
}
function $he(e, t) {
  return !e || t.readonly || l1(e) ? !1 : t.tabCount > 1 || t.hasFixedTabs;
}
function Zhe(e, t) {
  return !e || t.readonly || t.isEditing ? !1 : _r(e) && !e.disabled;
}
function Ghe(e) {
  let t = -1, o = -1;
  return e.forEach((n, s) => {
    _r(n) && (t === -1 && (t = s), o = s);
  }), { first: t, last: o };
}
function hd(e, t) {
  return t.first === -1 ? e : Math.min(Math.max(e, t.first), t.last);
}
function Nhe(e) {
  const t = W(null), o = W(""), n = W(null);
  function s(a) {
    const c = ke(e.tabs)[a];
    !c || !zC(c, { readonly: ke(e.readonly) }) || (o.value = c.label, t.value = c.key);
  }
  const i = F(() => {
    const a = t.value, c = o.value.trim();
    if (a === null || !c || !e.validateLabel) return null;
    const d = ke(e.tabs).findIndex((u) => u.key === a);
    return d === -1 || e.validateLabel(d, c) ? null : a;
  });
  function r() {
    var u, h;
    const a = t.value;
    if (a === null) return;
    if (i.value === a) {
      const p = ke(e.tabs).findIndex((C) => C.key === a);
      p !== -1 && ((u = e.onInvalidCommit) == null || u.call(e, p, o.value.trim()));
      return;
    }
    t.value = null;
    const c = (h = o.value) == null ? void 0 : h.trim(), d = ke(e.tabs).findIndex((p) => p.key === a);
    !c || d === -1 || e.onRename(d, c);
  }
  const l = F(() => n.value ?? e.pendingEditKey.value);
  return Me([l, () => ke(e.tabs)], ([a, c]) => {
    if (!a) return;
    const d = c.findIndex((u) => u.key === a);
    d !== -1 && (n.value = null, e.pendingEditKey.value = null, s(d));
  }), Me(o, () => e.onLabelResize(t.value)), Me(
    () => ke(e.readonly),
    (a) => {
      a && (n.value = null, e.pendingEditKey.value = null, t.value = null);
    }
  ), {
    editingKey: t,
    editingLabel: o,
    invalidKey: i,
    isEditing: (a) => t.value === a,
    startEdit: s,
    queueRename: (a) => {
      n.value = a;
    },
    commitEdit: r,
    cancelEdit: () => {
      t.value = null;
    }
  };
}
function zhe(e) {
  const t = W(null), o = W(null), n = W("after"), s = F(() => Ghe(ke(e.tabs)));
  function i() {
    t.value = null, o.value = null;
  }
  function r() {
    const d = t.value;
    if (d !== null)
      return ke(e.tabs).find((u) => u.key === d);
  }
  function l(d, u) {
    const h = ke(e.tabs)[u];
    if (ke(e.readonly) || !h || !_r(h)) {
      d.preventDefault();
      return;
    }
    t.value = h.key, d.dataTransfer && (d.dataTransfer.effectAllowed = "move", d.dataTransfer.setData("text/plain", String(u)));
  }
  function a(d, u) {
    var m, w;
    const h = r();
    if (!h || !_r(h)) return;
    const p = ke(e.tabs);
    o.value = ((m = p[hd(u, s.value)]) == null ? void 0 : m.key) ?? null;
    const C = d.currentTarget.getBoundingClientRect();
    n.value = e.isHidden((w = p[u]) == null ? void 0 : w.key) ? d.clientY < C.top + C.height / 2 ? "before" : "after" : d.clientX < C.left + C.width / 2 ? "before" : "after", d.dataTransfer && (d.dataTransfer.dropEffect = "move");
  }
  function c(d) {
    const u = ke(e.tabs), h = t.value, p = o.value;
    if (i(), h === null || ke(e.readonly)) return;
    const C = u.findIndex((x) => x.key === h), m = u[C];
    if (!m || !_r(m)) return;
    const w = p === null ? -1 : u.findIndex((x) => x.key === p), y = e.firstHiddenIndex(), b = Math.max(0, (y === -1 ? u.length : y) - 1), M = hd(d ?? (w === -1 ? b : w), s.value);
    M !== C && e.onReorder(C, M);
  }
  return Xt(document, "dragend", () => {
    t.value !== null && i();
  }), {
    isDragging: F(() => t.value !== null),
    dragOverKey: o,
    dropIndicator: (d) => o.value === d ? n.value : null,
    onDragStart: l,
    onDragOver: a,
    onDrop: (d) => c(d),
    onDragEnd: i,
    onBarDragOver: (d) => {
      t.value !== null && d.dataTransfer && (d.dataTransfer.dropEffect = "move");
    },
    onBarDrop: () => c(null)
  };
}
function jhe(e) {
  const { emits: t } = e;
  function o() {
    const r = { label: ke(e.newTabLabel), key: e.createKey() }, l = [...ke(e.tabs), r];
    return t.updateTabs(l), t.selectTab(l.length - 1), r.key;
  }
  async function n(r) {
    const l = ke(e.tabs)[r];
    if (!l || l1(l)) return;
    const a = e.beforeRemoveTab();
    if (a && !await a(r)) return;
    const c = ke(e.tabs), d = c.findIndex((h) => h.key === l.key);
    if (d === -1) return;
    const u = c.filter((h, p) => p !== d);
    t.updateTabs(u), t.removed({ index: d, key: l.key }), ke(e.selectedIndex) >= u.length && t.selectTab(Math.max(0, u.length - 1));
  }
  function s(r, l) {
    var d;
    const a = ke(e.tabs), c = (d = a[r]) == null ? void 0 : d.key;
    t.updateTabs(a.map((u, h) => h === r ? { ...u, label: l } : u)), c && t.renamed({ index: r, key: c, label: l });
  }
  function i(r, l) {
    const a = [...ke(e.tabs)], [c] = a.splice(r, 1);
    c && (a.splice(l, 0, c), t.updateTabs(a), t.selectTab(l), t.reordered({ fromIndex: r, toIndex: l, key: c.key }));
  }
  return { addTab: o, removeTab: n, renameTab: s, reorderTabs: i };
}
const Whe = 100;
function Uhe(e) {
  const t = W(/* @__PURE__ */ new Set()), o = W(null);
  let n = /* @__PURE__ */ new Set(), s = null;
  function i() {
    const a = e.container();
    if (!a) {
      t.value = /* @__PURE__ */ new Set(), o.value = null;
      return;
    }
    const c = a.style.maxWidth;
    a.style.maxWidth = "";
    const d = a.offsetWidth, u = /* @__PURE__ */ new Set();
    let h = 0;
    for (const p of a.children) {
      const { dataset: C, offsetLeft: m, offsetWidth: w } = p;
      if (!C.tabKey) continue;
      const y = m + w;
      y - d > 1 ? u.add(C.tabKey) : h = Math.max(h, y);
    }
    a.style.maxWidth = c, t.value = u, o.value = u.size > 0 ? h : null;
  }
  function r() {
    s === null && (s = requestAnimationFrame(() => {
      s = null, i();
    }));
  }
  Me(
    () => ke(e.tabs),
    (a) => {
      const c = new Set(a.map((d) => d.key));
      if (t.value.size > 0) {
        const d = /* @__PURE__ */ new Set();
        for (const u of t.value) c.has(u) && d.add(u);
        for (const u of c) n.has(u) || d.add(u);
        t.value = d;
      }
      n = c, rt(r);
    },
    { immediate: !0 }
  );
  const l = Us(r, Whe);
  return s1(e.bar, () => void l()), Yi(() => {
    s !== null && cancelAnimationFrame(s);
  }), {
    hiddenKeys: t,
    hasOverflow: F(() => t.value.size > 0),
    overflowTabs: F(() => {
      const a = t.value;
      if (a.size === 0) return [];
      const c = [];
      return ke(e.tabs).forEach((d, u) => {
        a.has(d.key) && c.push({ tab: d, originalIndex: u });
      }), c;
    }),
    containerStyle: F(() => o.value === null ? void 0 : { maxWidth: `${o.value}px` }),
    isHidden: (a) => a == null ? !1 : t.value.has(a),
    firstHiddenIndex: F(() => {
      const a = t.value;
      return a.size === 0 ? -1 : ke(e.tabs).findIndex((c) => a.has(c.key));
    }),
    remeasure: r
  };
}
const Khe = ["popovertarget", "test-id"], qhe = ["id"], Yhe = /* @__PURE__ */ pe({
  __name: "TabActions",
  props: {
    tab: {},
    index: {},
    variant: {},
    canRename: { type: Boolean },
    canRemove: { type: Boolean },
    readonly: { type: Boolean },
    editing: { type: Boolean },
    hasMenuSlot: { type: Boolean },
    deleteTitle: {},
    menuWidth: { default: void 0 },
    testId: { default: void 0 },
    menuClass: { default: void 0 },
    deleteClass: { default: void 0 }
  },
  emits: ["rename", "remove", "opened", "closed"],
  setup(e, { emit: t }) {
    const o = e, n = t, s = Ns(), i = F(() => o.variant === "overflow" ? "16px" : "12px");
    return (r, l) => !e.readonly && !e.editing && e.hasMenuSlot && e.tab.hasMenu ? (f(), U(zt, {
      key: 0,
      placement: "bottom-start",
      width: e.menuWidth,
      class: S(e.menuClass),
      onClick: l[0] || (l[0] = xe(() => {
      }, ["stop"])),
      onOpened: l[1] || (l[1] = (a) => n("opened")),
      onClosed: l[2] || (l[2] = (a) => n("closed"))
    }, {
      trigger: ee(({ target: a, isOpen: c }) => [
        g("button", {
          class: S([r.$style.triggerBtn, { [r.$style.triggerOpen]: c }]),
          type: "button",
          popovertarget: a,
          "test-id": e.testId ? `${e.testId}-tab-menu-trigger-${e.tab.key}` : void 0
        }, [
          de(Ae, {
            icon: "phosphor/dots-three-circle",
            size: i.value,
            class: S(r.$style.hoveredIcon)
          }, null, 8, ["size", "class"])
        ], 10, Khe)
      ]),
      default: ee(({ popover: a }) => [
        ve(r.$slots, "tabMenu", {
          tab: e.tab,
          index: e.index,
          canRename: e.canRename,
          canRemove: e.canRemove,
          rename: () => n("rename"),
          remove: () => n("remove"),
          close: () => a == null ? void 0 : a.hidePopover()
        })
      ]),
      _: 3
    }, 8, ["width", "class"])) : e.canRemove ? (f(), v("button", {
      key: 1,
      id: k(s),
      type: "button",
      class: S([r.$style.removeBtn, e.deleteClass]),
      onClick: l[3] || (l[3] = xe((a) => n("remove"), ["stop"]))
    }, [
      de(Ae, {
        icon: "phosphor/minus-circle",
        size: i.value,
        class: S(e.variant === "overflow" ? r.$style.rowIcon : r.$style.hoveredIcon)
      }, null, 8, ["size", "class"]),
      de(bo, {
        id: k(s),
        text: e.deleteTitle
      }, null, 8, ["id", "text"])
    ], 10, qhe)) : $("", !0);
  }
}), Qhe = "_triggerBtn_1qh8k_1", Jhe = "_removeBtn_1qh8k_11", Xhe = "_hoveredIcon_1qh8k_23", e6e = "_rowIcon_1qh8k_28", t6e = "_triggerOpen_1qh8k_38", o6e = {
  triggerBtn: Qhe,
  removeBtn: Jhe,
  hoveredIcon: Xhe,
  rowIcon: e6e,
  triggerOpen: t6e
}, n6e = {
  $style: o6e
}, jC = /* @__PURE__ */ Ce(Yhe, [["__cssModules", n6e]]), s6e = /* @__PURE__ */ pe({
  __name: "TabDot",
  props: {
    selected: { type: Boolean }
  },
  setup(e) {
    return (t, o) => (f(), v("span", {
      class: S(t.$style.dotContainer)
    }, [
      g("span", {
        class: S([t.$style.dotMarker, { [t.$style.selected]: e.selected }])
      }, null, 2)
    ], 2));
  }
}), i6e = "_dotContainer_13kb3_1", r6e = "_dotMarker_13kb3_13", l6e = "_selected_13kb3_24", a6e = {
  dotContainer: i6e,
  dotMarker: r6e,
  selected: l6e
}, c6e = {
  $style: a6e
}, WC = /* @__PURE__ */ Ce(s6e, [["__cssModules", c6e]]), d6e = ["data-text"], u6e = ["maxlength", "test-id"], h6e = /* @__PURE__ */ pe({
  __name: "TabRenameInput",
  props: /* @__PURE__ */ Ct({
    variant: {},
    invalid: { type: Boolean, default: !1 },
    maxLength: { default: void 0 },
    testId: { default: void 0 }
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Ct(["commit", "cancel"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const o = t, n = ct(e, "modelValue"), s = Ro("input");
    return At(() => {
      var i, r;
      (i = s.value) == null || i.focus(), (r = s.value) == null || r.select();
    }), (i, r) => (f(), v("span", {
      class: S([i.$style.sizer, e.variant === "overflow" ? i.$style.overflowSizer : i.$style.stripSizer]),
      "data-text": n.value || " "
    }, [
      Et(g("input", {
        ref: "input",
        "onUpdate:modelValue": r[0] || (r[0] = (l) => n.value = l),
        class: S([
          i.$style.input,
          e.variant === "overflow" ? i.$style.overflowInput : i.$style.stripInput,
          { [i.$style.invalid]: e.invalid }
        ]),
        type: "text",
        size: "1",
        maxlength: e.maxLength,
        "test-id": e.testId,
        onBlur: r[1] || (r[1] = (l) => o("commit")),
        onKeydown: [
          r[2] || (r[2] = ol((l) => o("commit"), ["enter"])),
          r[3] || (r[3] = ol((l) => o("cancel"), ["escape"]))
        ],
        onClick: r[4] || (r[4] = xe(() => {
        }, ["stop"])),
        onDblclick: r[5] || (r[5] = xe(() => {
        }, ["stop"]))
      }, null, 42, u6e), [
        [xn, n.value]
      ])
    ], 10, d6e));
  }
}), g6e = "_sizer_1wgwd_1", p6e = "_stripSizer_1wgwd_21", f6e = "_overflowSizer_1wgwd_29", v6e = "_input_1wgwd_35", m6e = "_stripInput_1wgwd_54", C6e = "_overflowInput_1wgwd_61", w6e = "_invalid_1wgwd_65", b6e = {
  sizer: g6e,
  stripSizer: p6e,
  overflowSizer: f6e,
  input: v6e,
  stripInput: m6e,
  overflowInput: C6e,
  invalid: w6e
}, y6e = {
  $style: b6e
}, UC = /* @__PURE__ */ Ce(h6e, [["__cssModules", y6e]]), _6e = ["data-tab-key", "draggable"], S6e = ["disabled", "test-id"], x6e = ["id"], M6e = ["id", "data-text"], A6e = ["data-text"], L6e = /* @__PURE__ */ pe({
  __name: "EditableTab",
  props: /* @__PURE__ */ Ct({
    tab: {},
    index: {},
    state: {},
    hidden: { type: Boolean },
    menuOpen: { type: Boolean },
    hasMenuSlot: { type: Boolean },
    newTabLabel: {},
    deleteTitle: {},
    maxLabelLength: { default: void 0 },
    menuWidth: { default: void 0 },
    testId: { default: void 0 }
  }, {
    editingLabel: { required: !0 },
    editingLabelModifiers: {}
  }),
  emits: /* @__PURE__ */ Ct(["select", "startEdit", "commitEdit", "cancelEdit", "remove", "menuOpened", "menuClosed"], ["update:editingLabel"]),
  setup(e, { emit: t }) {
    const o = e, n = t, s = ct(e, "editingLabel"), { t: i } = Go(), r = Ns(), l = Ns(), a = F(() => NC(o.tab, o.newTabLabel)), c = F(() => o.state.canRename && o.state.draggable);
    return (d, u) => (f(), v("div", {
      class: S([
        d.$style.tabItem,
        {
          [d.$style.selected]: e.state.selected,
          [d.$style.editing]: e.state.editing,
          [d.$style.invalid]: e.state.labelInvalid,
          [d.$style.tabItemMenuOpen]: e.menuOpen,
          [d.$style.hiddenTab]: e.hidden,
          [d.$style.dropBefore]: e.state.dropIndicator === "before",
          [d.$style.dropAfter]: e.state.dropIndicator === "after"
        }
      ]),
      "data-tab-key": e.tab.key,
      draggable: e.state.draggable,
      onClick: u[9] || (u[9] = xe(() => {
      }, ["stop"]))
    }, [
      e.state.editing ? (f(), v(we, { key: 1 }, [
        e.tab.icon ? (f(), v("span", {
          key: 0,
          class: S([
            d.$style.leadingIconWrapper,
            d.$style.editingLeadingIcon,
            { [d.$style.selected]: e.state.selected, [d.$style.invalid]: e.state.labelInvalid }
          ])
        }, [
          de(Ae, {
            icon: e.tab.icon,
            size: "16px",
            class: S(d.$style.leadingIcon)
          }, null, 8, ["icon", "class"])
        ], 2)) : $("", !0),
        de(UC, {
          modelValue: s.value,
          "onUpdate:modelValue": u[2] || (u[2] = (h) => s.value = h),
          variant: "strip",
          invalid: e.state.labelInvalid,
          "max-length": e.maxLabelLength,
          "test-id": e.testId ? `${e.testId}-tab-input-${e.tab.key}` : void 0,
          onCommit: u[3] || (u[3] = (h) => n("commitEdit")),
          onCancel: u[4] || (u[4] = (h) => n("cancelEdit"))
        }, null, 8, ["modelValue", "invalid", "max-length", "test-id"])
      ], 64)) : (f(), v("button", {
        key: 0,
        type: "button",
        class: S([d.$style.tabButton, { [d.$style.selected]: e.state.selected, [d.$style.disabledTab]: e.tab.disabled }]),
        disabled: e.tab.disabled,
        "test-id": e.testId ? `${e.testId}-tab-${e.tab.key}` : void 0,
        onClick: u[0] || (u[0] = (h) => !e.tab.disabled && n("select")),
        onDblclick: u[1] || (u[1] = (h) => !e.tab.disabled && n("startEdit"))
      }, [
        e.tab.icon ? (f(), v("span", {
          key: 0,
          id: e.tab.iconTitle ? k(r) : void 0,
          class: S(d.$style.leadingIconWrapper)
        }, [
          de(Ae, {
            icon: e.tab.icon,
            size: "16px",
            class: S(d.$style.leadingIcon)
          }, null, 8, ["icon", "class"]),
          e.tab.iconTitle ? (f(), U(bo, {
            key: 0,
            id: k(r),
            text: e.tab.iconTitle
          }, null, 8, ["id", "text"])) : $("", !0)
        ], 10, x6e)) : $("", !0),
        g("span", {
          id: c.value ? k(l) : void 0,
          class: S(d.$style.label),
          "data-text": a.value
        }, se(a.value), 11, M6e),
        c.value ? (f(), U(bo, {
          key: 1,
          id: k(l),
          text: k(i)("common.label.tabRenameReorderHint")
        }, null, 8, ["id", "text"])) : $("", !0),
        e.tab.labelSuffix ? (f(), v("span", {
          key: 2,
          class: S(d.$style.labelSuffix),
          "data-text": e.tab.labelSuffix
        }, se(e.tab.labelSuffix), 11, A6e)) : $("", !0),
        e.tab.dot ? (f(), U(WC, {
          key: 3,
          selected: e.state.selected
        }, null, 8, ["selected"])) : $("", !0)
      ], 42, S6e)),
      de(jC, {
        tab: e.tab,
        index: e.index,
        variant: "strip",
        "can-rename": e.state.canRename,
        "can-remove": e.state.canRemove,
        readonly: e.state.readonly,
        editing: e.state.editing,
        "has-menu-slot": e.hasMenuSlot,
        "menu-width": e.menuWidth,
        "delete-title": e.deleteTitle,
        "test-id": e.testId,
        "menu-class": d.$style.menuBtn,
        "delete-class": d.$style.deleteBtn,
        onRename: u[5] || (u[5] = (h) => n("startEdit")),
        onRemove: u[6] || (u[6] = (h) => n("remove")),
        onOpened: u[7] || (u[7] = (h) => n("menuOpened")),
        onClosed: u[8] || (u[8] = (h) => n("menuClosed"))
      }, {
        tabMenu: ee((h) => [
          ve(d.$slots, "tabMenu", nl(sl(h)))
        ]),
        _: 3
      }, 8, ["tab", "index", "can-rename", "can-remove", "readonly", "editing", "has-menu-slot", "menu-width", "delete-title", "test-id", "menu-class", "delete-class"])
    ], 10, _6e));
  }
}), E6e = "_tabItem_5rj9h_1", P6e = "_selected_5rj9h_14", R6e = "_editing_5rj9h_17", F6e = "_invalid_5rj9h_20", T6e = "_deleteBtn_5rj9h_23", I6e = "_menuBtn_5rj9h_23", D6e = "_tabButton_5rj9h_28", k6e = "_disabledTab_5rj9h_53", H6e = "_leadingIconWrapper_5rj9h_58", V6e = "_editingLeadingIcon_5rj9h_63", O6e = "_leadingIcon_5rj9h_58", B6e = "_label_5rj9h_80", $6e = "_labelSuffix_5rj9h_96", Z6e = "_dropBefore_5rj9h_113", G6e = "_dropAfter_5rj9h_114", N6e = "_hiddenTab_5rj9h_133", z6e = "_tabItemMenuOpen_5rj9h_160", j6e = {
  tabItem: E6e,
  selected: P6e,
  editing: R6e,
  invalid: F6e,
  deleteBtn: T6e,
  menuBtn: I6e,
  tabButton: D6e,
  disabledTab: k6e,
  leadingIconWrapper: H6e,
  editingLeadingIcon: V6e,
  leadingIcon: O6e,
  label: B6e,
  labelSuffix: $6e,
  dropBefore: Z6e,
  dropAfter: G6e,
  hiddenTab: N6e,
  tabItemMenuOpen: z6e
}, W6e = {
  $style: j6e
}, U6e = /* @__PURE__ */ Ce(L6e, [["__cssModules", W6e]]), K6e = /* @__PURE__ */ pe({
  __name: "SCADivider",
  props: {
    direction: { default: "horizontal" },
    appearance: { default: "default" },
    margin: { default: void 0 }
  },
  setup(e) {
    const t = e;
    return (o, n) => (f(), v("div", {
      class: S([
        o.$style.root,
        {
          [o.$style.vertical]: t.direction === "vertical",
          [o.$style.appearanceBorder]: t.appearance === "border"
        }
      ]),
      style: Ge({ margin: e.margin }),
      role: "separator"
    }, null, 6));
  }
}), q6e = "_root_2roj9_747", Y6e = "_vertical_2roj9_753", Q6e = "_appearanceBorder_2roj9_756", J6e = {
  root: q6e,
  vertical: Y6e,
  appearanceBorder: Q6e
}, X6e = {
  $style: J6e
}, Sr = /* @__PURE__ */ Ce(K6e, [["__cssModules", X6e]]), e4e = ["draggable"], t4e = /* @__PURE__ */ pe({
  __name: "EditableTabOverflowRow",
  props: /* @__PURE__ */ Ct({
    tab: {},
    index: {},
    state: {},
    hasMenuSlot: { type: Boolean },
    newTabLabel: {},
    deleteTitle: {},
    maxLabelLength: { default: void 0 },
    menuWidth: { default: void 0 },
    testId: { default: void 0 }
  }, {
    editingLabel: { required: !0 },
    editingLabelModifiers: {}
  }),
  emits: /* @__PURE__ */ Ct(["select", "startEdit", "commitEdit", "cancelEdit", "remove"], ["update:editingLabel"]),
  setup(e, { emit: t }) {
    const o = e, n = t, s = ct(e, "editingLabel"), i = F(() => Bhe(o.tab, o.newTabLabel)), r = W(!1);
    function l() {
      r.value = !1, n("startEdit");
    }
    return (a, c) => (f(), v("div", {
      class: S([
        a.$style.overflowItem,
        {
          [a.$style.overflowItemSelected]: e.state.selected,
          [a.$style.overflowItemDisabled]: e.tab.disabled,
          [a.$style.overflowItemMenuOpen]: r.value,
          [a.$style.dropAbove]: e.state.dropIndicator === "before",
          [a.$style.dropBelow]: e.state.dropIndicator === "after"
        }
      ]),
      draggable: e.state.draggable,
      onClick: c[6] || (c[6] = (d) => !e.tab.disabled && !e.state.editing && n("select")),
      onDblclick: c[7] || (c[7] = xe((d) => !e.tab.disabled && n("startEdit"), ["prevent", "stop"]))
    }, [
      e.tab.icon ? (f(), U(Ae, {
        key: 0,
        icon: e.tab.icon,
        size: "16px",
        class: S([a.$style.leadingIcon, { [a.$style.editingIcon]: e.state.editing, [a.$style.invalidIcon]: e.state.labelInvalid }])
      }, null, 8, ["icon", "class"])) : $("", !0),
      e.state.editing ? (f(), U(UC, {
        key: 2,
        modelValue: s.value,
        "onUpdate:modelValue": c[0] || (c[0] = (d) => s.value = d),
        variant: "overflow",
        invalid: e.state.labelInvalid,
        "max-length": e.maxLabelLength,
        "test-id": e.testId ? `${e.testId}-tab-input-${e.tab.key}` : void 0,
        onCommit: c[1] || (c[1] = (d) => n("commitEdit")),
        onCancel: c[2] || (c[2] = (d) => n("cancelEdit"))
      }, null, 8, ["modelValue", "invalid", "max-length", "test-id"])) : (f(), v("span", {
        key: 1,
        class: S(a.$style.overflowItemLabel)
      }, [
        g("span", {
          class: S(a.$style.overflowItemLabelText)
        }, se(i.value), 3),
        e.tab.dot ? (f(), U(WC, {
          key: 0,
          selected: e.state.selected
        }, null, 8, ["selected"])) : $("", !0)
      ], 2)),
      de(jC, {
        tab: e.tab,
        index: e.index,
        variant: "overflow",
        "can-rename": e.state.canRename,
        "can-remove": e.state.canRemove,
        readonly: e.state.readonly,
        editing: e.state.editing,
        "has-menu-slot": e.hasMenuSlot,
        "menu-width": e.menuWidth,
        "delete-title": e.deleteTitle,
        "test-id": e.testId,
        "menu-class": a.$style.overflowRowMenu,
        "delete-class": a.$style.overflowRowBtn,
        onRename: l,
        onRemove: c[3] || (c[3] = (d) => n("remove")),
        onOpened: c[4] || (c[4] = (d) => r.value = !0),
        onClosed: c[5] || (c[5] = (d) => r.value = !1)
      }, {
        tabMenu: ee((d) => [
          ve(a.$slots, "tabMenu", nl(sl(d)))
        ]),
        _: 3
      }, 8, ["tab", "index", "can-rename", "can-remove", "readonly", "editing", "has-menu-slot", "menu-width", "delete-title", "test-id", "menu-class", "delete-class"])
    ], 42, e4e));
  }
}), o4e = "_overflowItem_5l1sa_1", n4e = "_overflowItemSelected_5l1sa_26", s4e = "_overflowItemDisabled_5l1sa_31", i4e = "_overflowItemLabel_5l1sa_37", r4e = "_overflowItemLabelText_5l1sa_45", l4e = "_leadingIcon_5l1sa_52", a4e = "_editingIcon_5l1sa_57", c4e = "_invalidIcon_5l1sa_61", d4e = "_overflowRowMenu_5l1sa_65", u4e = "_overflowItemMenuOpen_5l1sa_80", h4e = "_overflowRowBtn_5l1sa_85", g4e = "_dropAbove_5l1sa_89", p4e = "_dropBelow_5l1sa_90", f4e = {
  overflowItem: o4e,
  overflowItemSelected: n4e,
  overflowItemDisabled: s4e,
  overflowItemLabel: i4e,
  overflowItemLabelText: r4e,
  leadingIcon: l4e,
  editingIcon: a4e,
  invalidIcon: c4e,
  overflowRowMenu: d4e,
  overflowItemMenuOpen: u4e,
  overflowRowBtn: h4e,
  dropAbove: g4e,
  dropBelow: p4e
}, v4e = {
  $style: f4e
}, m4e = /* @__PURE__ */ Ce(t4e, [["__cssModules", v4e]]), C4e = ["test-id"], w4e = 200, b4e = /* @__PURE__ */ pe({
  __name: "EditableTabsOverflowMenu",
  props: /* @__PURE__ */ Ct({
    rows: {},
    rowState: {},
    readonly: { type: Boolean },
    hasSelectedTab: { type: Boolean },
    hasMenuSlot: { type: Boolean },
    addMenu: { type: Boolean },
    addTabTitle: {},
    deleteTitle: {},
    newTabLabel: {},
    maxLabelLength: { default: void 0 },
    menuWidth: { default: void 0 },
    testId: { default: void 0 }
  }, {
    editingLabel: { required: !0 },
    editingLabelModifiers: {}
  }),
  emits: /* @__PURE__ */ Ct(["select", "startEdit", "commitEdit", "cancelEdit", "remove", "add", "rowDragStart", "rowDragOver", "rowDrop", "rowDragEnd"], ["update:editingLabel"]),
  setup(e, { emit: t }) {
    const o = e, n = t, s = ct(e, "editingLabel"), i = W(), r = W(!1);
    function l() {
      var m;
      (m = i.value) == null || m.hideNow();
    }
    let a;
    function c() {
      a && (clearTimeout(a), a = void 0);
    }
    function d(m) {
      n("select", m), c(), a = setTimeout(l, w4e);
    }
    function u(m) {
      c(), n("startEdit", m);
    }
    ei(c);
    function h(m) {
      l(), n("remove", m);
    }
    function p() {
      if (o.addMenu) {
        r.value = !r.value;
        return;
      }
      n("add");
    }
    function C() {
      r.value = !1;
    }
    return (m, w) => (f(), U(zt, {
      ref_key: "dropdownRef",
      ref: i,
      "no-padding": "",
      placement: "bottom-end",
      onClick: w[4] || (w[4] = xe(() => {
      }, ["stop"])),
      onClosed: w[5] || (w[5] = (y) => r.value = !1)
    }, {
      trigger: ee(({ target: y }) => [
        de(ot, {
          class: S({ [m.$style.triggerSelected]: e.hasSelectedTab }),
          size: "small",
          type: "ghost",
          appearance: "secondary",
          icon: "phosphor/dots-three",
          popovertarget: y,
          "test-id": e.testId ? `${e.testId}-overflow-trigger` : void 0
        }, null, 8, ["class", "popovertarget", "test-id"])
      ]),
      default: ee(() => [
        g("div", {
          class: S(m.$style.menu),
          style: Ge({ minWidth: e.menuWidth })
        }, [
          (f(!0), v(we, null, Ze(e.rows, (y) => (f(), U(m4e, {
            key: y.tab.key,
            "editing-label": s.value,
            "onUpdate:editingLabel": w[0] || (w[0] = (b) => s.value = b),
            tab: y.tab,
            index: y.originalIndex,
            state: e.rowState(y.tab, y.originalIndex),
            "has-menu-slot": e.hasMenuSlot,
            "new-tab-label": e.newTabLabel,
            "delete-title": e.deleteTitle,
            "max-label-length": e.maxLabelLength,
            "menu-width": e.menuWidth,
            "test-id": e.testId,
            onSelect: (b) => d(y.originalIndex),
            onStartEdit: (b) => u(y.originalIndex),
            onCommitEdit: w[1] || (w[1] = (b) => n("commitEdit")),
            onCancelEdit: w[2] || (w[2] = (b) => n("cancelEdit")),
            onRemove: (b) => h(y.originalIndex),
            onDragstart: (b) => n("rowDragStart", b, y.originalIndex),
            onDragover: xe((b) => n("rowDragOver", b, y.originalIndex), ["prevent"]),
            onDrop: xe((b) => n("rowDrop", y.originalIndex), ["stop", "prevent"]),
            onDragend: w[3] || (w[3] = (b) => n("rowDragEnd"))
          }, {
            tabMenu: ee((b) => [
              ve(m.$slots, "tabMenu", Bt({ ref_for: !0 }, b))
            ]),
            _: 3
          }, 8, ["editing-label", "tab", "index", "state", "has-menu-slot", "new-tab-label", "delete-title", "max-label-length", "menu-width", "test-id", "onSelect", "onStartEdit", "onRemove", "onDragstart", "onDragover", "onDrop"]))), 128)),
          e.readonly ? $("", !0) : (f(), U(Sr, {
            key: 0,
            appearance: "border",
            class: S(m.$style.divider)
          }, null, 8, ["class"])),
          e.readonly ? $("", !0) : (f(), v("div", {
            key: 1,
            class: S(m.$style.addItem),
            "test-id": e.testId ? `${e.testId}-overflow-add` : void 0,
            onClick: xe(p, ["stop"])
          }, [
            de(Ae, {
              icon: "phosphor/plus",
              size: "16px"
            }),
            g("span", null, se(e.addTabTitle), 1)
          ], 10, C4e)),
          !e.readonly && e.addMenu && r.value ? (f(), v(we, { key: 2 }, [
            de(Sr, {
              appearance: "border",
              class: S(m.$style.divider)
            }, null, 8, ["class"]),
            g("div", {
              class: S(m.$style.addMenu)
            }, [
              ve(m.$slots, "addMenu", { close: C })
            ], 2)
          ], 64)) : $("", !0)
        ], 6)
      ]),
      _: 3
    }, 512));
  }
}), y4e = "_triggerSelected_npyfu_1", _4e = "_menu_npyfu_6", S4e = "_divider_npyfu_14", x4e = "_addMenu_npyfu_18", M4e = "_addItem_npyfu_25", A4e = {
  triggerSelected: y4e,
  menu: _4e,
  divider: S4e,
  addMenu: x4e,
  addItem: M4e
}, L4e = {
  $style: A4e
}, E4e = /* @__PURE__ */ Ce(b4e, [["__cssModules", L4e]]), P4e = ["id", "popovertarget", "test-id"], R4e = ["id", "test-id"], F4e = /* @__PURE__ */ pe({
  __name: "SCAEditableTabsBar",
  props: /* @__PURE__ */ Ct({
    modelValue: {},
    selectedIndex: {},
    readonly: { type: Boolean, default: !1 },
    newTabLabel: { default: void 0 },
    addTabTitle: { default: void 0 },
    deleteTabTitle: { default: void 0 },
    beforeRemoveTab: { type: Function, default: void 0 },
    validateLabel: { type: Function, default: void 0 },
    maxLabelLength: { default: void 0 },
    addMenu: { type: Boolean, default: !1 },
    menuWidth: { default: void 0 },
    testId: { default: void 0 }
  }, {
    pendingEditKey: { default: null },
    pendingEditKeyModifiers: {},
    editingInvalid: { type: Boolean, default: !1 },
    editingInvalidModifiers: {}
  }),
  emits: /* @__PURE__ */ Ct(["update:modelValue", "update:selectedIndex", "rename-tab", "reorder-tab", "remove-tab", "invalid-commit"], ["update:pendingEditKey", "update:editingInvalid"]),
  setup(e, { emit: t }) {
    const o = t, { t: n } = Go(), s = e, i = ct(e, "pendingEditKey"), r = ct(e, "editingInvalid"), l = F(() => s.newTabLabel ?? n("common.label.tabLabel")), a = F(() => s.addTabTitle ?? n("common.action.addTab2")), c = F(() => s.deleteTabTitle ?? n("common.action.removeTab")), d = Ro("bar"), u = Ro("container"), h = Ns(), p = Ns();
    let C = 0;
    const m = () => s.modelValue, w = F(() => Ohe(s.modelValue)), { hasOverflow: y, overflowTabs: b, containerStyle: _, isHidden: M, firstHiddenIndex: x, remeasure: L } = Uhe({
      tabs: m,
      bar: () => d.value,
      container: () => u.value
    }), { addTab: A, removeTab: R, renameTab: P, reorderTabs: I } = jhe({
      tabs: m,
      selectedIndex: () => s.selectedIndex,
      newTabLabel: l,
      beforeRemoveTab: () => s.beforeRemoveTab,
      createKey: () => `${p}-tab-${++C}`,
      emits: {
        updateTabs: (V) => o("update:modelValue", V),
        selectTab: (V) => o("update:selectedIndex", V),
        renamed: (V) => o("rename-tab", V),
        reordered: (V) => o("reorder-tab", V),
        removed: (V) => o("remove-tab", V)
      }
    }), { editingKey: B, editingLabel: H, invalidKey: O, isEditing: N, startEdit: te, queueRename: E, commitEdit: j, cancelEdit: Z } = Nhe({
      tabs: m,
      readonly: () => s.readonly,
      pendingEditKey: i,
      onRename: P,
      validateLabel: (V, Q) => {
        const ye = s.modelValue[V];
        return !s.validateLabel || s.validateLabel({ index: V, key: ye.key, label: Q });
      },
      onInvalidCommit: (V, Q) => {
        const ye = s.modelValue[V];
        o("invalid-commit", { index: V, key: ye.key, label: Q });
      },
      onLabelResize: (V) => {
        M(V) || L();
      }
    });
    function Y(V) {
      B.value === null && o("update:selectedIndex", V);
    }
    Nl(() => {
      r.value = O.value !== null;
    });
    const { dropIndicator: le, onDragStart: ge, onDragOver: ce, onDrop: G, onDragEnd: z, onBarDragOver: oe, onBarDrop: q } = zhe({
      tabs: m,
      readonly: () => s.readonly,
      isHidden: M,
      firstHiddenIndex: () => x.value,
      onReorder: I
    }), ne = W(null);
    function Fe(V) {
      ne.value === V && (ne.value = null);
    }
    function We(V) {
      const Q = s.modelValue[V];
      Q && ne.value === Q.key && (ne.value = null), te(V);
    }
    function Qe(V, Q) {
      const ye = N(V.key), ae = s.readonly;
      return {
        selected: s.selectedIndex === Q,
        editing: ye,
        labelInvalid: O.value === V.key,
        readonly: ae,
        draggable: Zhe(V, { readonly: ae, isEditing: ye }),
        canRename: zC(V, { readonly: ae }),
        canRemove: !ye && $he(V, {
          readonly: ae,
          tabCount: s.modelValue.length,
          hasFixedTabs: w.value
        }),
        dropIndicator: le(V.key)
      };
    }
    function nt() {
      E(A());
    }
    function ut(V) {
      R(V);
    }
    return (V, Q) => {
      var ye;
      return f(), v("div", {
        ref: "bar",
        class: S(V.$style.tabsBar),
        onDragover: Q[6] || (Q[6] = xe(
          //@ts-ignore
          (...ae) => k(oe) && k(oe)(...ae),
          ["prevent"]
        )),
        onDrop: Q[7] || (Q[7] = xe(
          //@ts-ignore
          (...ae) => k(q) && k(q)(...ae),
          ["prevent"]
        ))
      }, [
        g("div", {
          ref: "container",
          class: S(V.$style.tabsContainer),
          style: Ge(k(_))
        }, [
          (f(!0), v(we, null, Ze(e.modelValue, (ae, ie) => (f(), U(U6e, {
            key: ae.key,
            "editing-label": k(H),
            "onUpdate:editingLabel": Q[0] || (Q[0] = (Oe) => Tn(H) ? H.value = Oe : null),
            tab: ae,
            index: ie,
            state: Qe(ae, ie),
            hidden: k(M)(ae.key),
            "menu-open": ne.value === ae.key,
            "has-menu-slot": !!V.$slots.tabMenu,
            "new-tab-label": l.value,
            "delete-title": c.value,
            "max-label-length": e.maxLabelLength,
            "menu-width": e.menuWidth,
            "test-id": e.testId,
            onSelect: (Oe) => Y(ie),
            onStartEdit: (Oe) => We(ie),
            onCommitEdit: k(j),
            onCancelEdit: k(Z),
            onRemove: (Oe) => ut(ie),
            onMenuOpened: (Oe) => ne.value = ae.key,
            onMenuClosed: (Oe) => Fe(ae.key),
            onDragstart: (Oe) => k(ge)(Oe, ie),
            onDragover: xe((Oe) => k(ce)(Oe, ie), ["prevent"]),
            onDrop: xe((Oe) => k(G)(ie), ["stop", "prevent"]),
            onDragend: k(z)
          }, {
            tabMenu: ee((Oe) => [
              ve(V.$slots, "tabMenu", Bt({ ref_for: !0 }, Oe))
            ]),
            _: 3
          }, 8, ["editing-label", "tab", "index", "state", "hidden", "menu-open", "has-menu-slot", "new-tab-label", "delete-title", "max-label-length", "menu-width", "test-id", "onSelect", "onStartEdit", "onCommitEdit", "onCancelEdit", "onRemove", "onMenuOpened", "onMenuClosed", "onDragstart", "onDragover", "onDrop", "onDragend"]))), 128))
        ], 6),
        k(y) ? (f(), U(E4e, {
          key: 0,
          "editing-label": k(H),
          "onUpdate:editingLabel": Q[1] || (Q[1] = (ae) => Tn(H) ? H.value = ae : null),
          rows: k(b),
          "row-state": Qe,
          readonly: e.readonly,
          "has-selected-tab": k(M)((ye = e.modelValue[e.selectedIndex]) == null ? void 0 : ye.key),
          "has-menu-slot": !!V.$slots.tabMenu,
          "add-menu": e.addMenu,
          "add-tab-title": a.value,
          "delete-title": c.value,
          "new-tab-label": l.value,
          "max-label-length": e.maxLabelLength,
          "menu-width": e.menuWidth,
          "test-id": e.testId,
          onSelect: Q[2] || (Q[2] = (ae) => Y(ae)),
          onStartEdit: Q[3] || (Q[3] = (ae) => k(te)(ae)),
          onCommitEdit: k(j),
          onCancelEdit: k(Z),
          onRemove: Q[4] || (Q[4] = (ae) => ut(ae)),
          onAdd: nt,
          onRowDragStart: k(ge),
          onRowDragOver: k(ce),
          onRowDrop: k(G),
          onRowDragEnd: k(z)
        }, {
          tabMenu: ee((ae) => [
            ve(V.$slots, "tabMenu", nl(sl(ae)))
          ]),
          addMenu: ee((ae) => [
            ve(V.$slots, "addMenu", nl(sl(ae)))
          ]),
          _: 3
        }, 8, ["editing-label", "rows", "readonly", "has-selected-tab", "has-menu-slot", "add-menu", "add-tab-title", "delete-title", "new-tab-label", "max-label-length", "menu-width", "test-id", "onCommitEdit", "onCancelEdit", "onRowDragStart", "onRowDragOver", "onRowDrop", "onRowDragEnd"])) : $("", !0),
        !e.readonly && !k(y) && e.addMenu ? (f(), U(zt, {
          key: 1,
          placement: "bottom-start",
          width: e.menuWidth,
          class: S(V.$style.addDropdown),
          onClick: Q[5] || (Q[5] = xe(() => {
          }, ["stop"]))
        }, {
          trigger: ee(({ target: ae, isOpen: ie }) => [
            g("button", {
              id: k(h),
              class: S([V.$style.addBtn, { [V.$style.triggerOpen]: ie }]),
              type: "button",
              popovertarget: ae,
              "test-id": e.testId ? `${e.testId}-add` : void 0
            }, [
              de(Ae, {
                icon: "phosphor/plus-circle",
                size: "12px",
                class: S(V.$style.hoveredIcon)
              }, null, 8, ["class"]),
              de(bo, {
                id: k(h),
                text: a.value
              }, null, 8, ["id", "text"])
            ], 10, P4e)
          ]),
          default: ee(({ popover: ae }) => [
            ve(V.$slots, "addMenu", {
              close: () => ae == null ? void 0 : ae.hidePopover()
            })
          ]),
          _: 3
        }, 8, ["width", "class"])) : !e.readonly && !k(y) ? (f(), v("button", {
          key: 2,
          id: k(h),
          class: S(V.$style.addBtn),
          type: "button",
          "test-id": e.testId ? `${e.testId}-add` : void 0,
          onClick: xe(nt, ["stop"])
        }, [
          de(Ae, {
            icon: "phosphor/plus-circle",
            size: "12px",
            class: S(V.$style.hoveredIcon)
          }, null, 8, ["class"]),
          de(bo, {
            id: k(h),
            text: a.value
          }, null, 8, ["id", "text"])
        ], 10, R4e)) : $("", !0)
      ], 34);
    };
  }
}), T4e = "_tabsBar_1f36e_1", I4e = "_tabsContainer_1f36e_10", D4e = "_addBtn_1f36e_19", k4e = "_hoveredIcon_1f36e_32", H4e = "_triggerOpen_1f36e_43", V4e = "_addDropdown_1f36e_57", O4e = {
  tabsBar: T4e,
  tabsContainer: I4e,
  addBtn: D4e,
  hoveredIcon: k4e,
  triggerOpen: H4e,
  addDropdown: V4e
}, B4e = {
  $style: O4e
}, Cst = /* @__PURE__ */ Ce(F4e, [["__cssModules", B4e]]), $4e = /* @__PURE__ */ pe({
  __name: "SCAToast",
  props: {
    text: {},
    intent: { default: "none" },
    emphasis: { default: "low" },
    closeable: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, o = fS(), n = F(() => t.emphasis !== "high" ? "secondary" : "inverted"), s = F(() => t.emphasis !== "high" ? {
      appearance: "primary",
      type: "bare"
    } : t.intent === "warning" ? {
      appearance: "reverseInverted",
      type: "bare"
    } : {
      appearance: "inverted",
      type: "bare"
    }), i = F(() => {
      switch (t.intent) {
        case "none":
          return;
        case "info":
          return "tetrisly/check-circle-fill";
        case "success":
          return "tetrisly/check-circle-fill";
        case "warning":
          return "tetrisly/warning-fill";
        case "error":
          return "tetrisly/alert-fill";
        default:
          return "tetrisly/info-circle";
      }
    });
    return (r, l) => (f(), v("div", {
      class: S([
        r.$style.toast,
        r.$style[t.emphasis],
        r.$style[t.intent],
        { [r.$style.hasIcon]: t.intent !== "none", [r.$style.isCloseable]: t.closeable }
      ])
    }, [
      g("div", {
        class: S(r.$style.content)
      }, [
        i.value ? (f(), U(Ae, {
          key: 0,
          class: S(r.$style.icon),
          icon: i.value
        }, null, 8, ["class", "icon"])) : $("", !0),
        Ve(" " + se(e.text), 1)
      ], 2),
      r.$slots.default ? (f(), v("div", {
        key: 0,
        class: S(r.$style.actions)
      }, [
        ve(r.$slots, "default", { buttonProps: s.value })
      ], 2)) : $("", !0),
      e.closeable ? (f(), U(ot, {
        key: 1,
        type: "bare",
        appearance: n.value,
        icon: "tetrisly/close",
        onClick: k(o).close
      }, null, 8, ["appearance", "onClick"])) : $("", !0)
    ], 2));
  }
}), Z4e = "_toast_mu1i1_747", G4e = "_content_mu1i1_764", N4e = "_actions_mu1i1_769", z4e = "_info_mu1i1_773", j4e = "_success_mu1i1_776", W4e = "_warning_mu1i1_779", U4e = "_error_mu1i1_782", K4e = "_hasIcon_mu1i1_785", q4e = "_isCloseable_mu1i1_788", Y4e = "_low_mu1i1_791", Q4e = "_icon_mu1i1_796", J4e = "_high_mu1i1_799", X4e = {
  toast: Z4e,
  content: G4e,
  actions: N4e,
  info: z4e,
  success: j4e,
  warning: W4e,
  error: U4e,
  hasIcon: K4e,
  isCloseable: q4e,
  low: Y4e,
  icon: Q4e,
  high: J4e
}, e8e = {
  $style: X4e
}, t8e = /* @__PURE__ */ Ce($4e, [["__cssModules", e8e]]), o8e = 5e3;
function gd(e, t) {
  return vS().push(
    t8e,
    {
      text: e,
      closeable: !0,
      emphasis: "high",
      intent: t
    },
    void 0,
    { time: o8e }
  );
}
const n8e = ["accept", "multiple"], s8e = /* @__PURE__ */ pe({
  __name: "SCADragAndDropField",
  props: {
    extended: { type: Boolean, default: !1 },
    caption: { default: void 0 },
    dataTypes: { default: void 0 },
    multiple: { type: Boolean, default: !0 },
    alert: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    maxSize: { default: void 0 }
  },
  emits: ["files"],
  setup(e, { emit: t }) {
    const { t: o } = Go(), n = e, s = t, i = W(), r = F(() => {
      if (n.caption !== void 0) return n.caption;
      const h = [];
      if (n.dataTypes && n.dataTypes.length > 0) {
        const p = n.dataTypes.map((C) => {
          const m = C.split("/");
          return m.length === 2 ? m[1] : m[0].replace(".", "");
        });
        if (p.length > 0) {
          const C = [];
          if (p.length > 1) {
            const m = p.pop();
            m && C.push(m);
          }
          C.unshift(p.join(", ")), h.push(C.join(` ${o("common.label.or2")} `));
        }
      }
      return n.maxSize && h.push(o("common.label.maxSizeOf", { size: $0(n.maxSize) })), h.join(". ");
    }), { isOverDropZone: l } = tP(i, {
      // specify the types of data to be received.
      dataTypes: n.dataTypes,
      // control multi-file drop
      multiple: n.multiple,
      // whether to prevent default behavior for unhandled events
      preventDefaultForUnhandled: !1,
      // A dropped folder only exists in dataTransfer.items; useDropZone's own file list comes from
      // dataTransfer.files, where it shows up as one unreadable entry and its contents are lost.
      onDrop: (h, p) => void u(p)
    });
    function a(h) {
      if (h.size === 0)
        return gd(o("common.info.fileParamEmpty", { filename: h.name }), "warning"), !1;
      if (n.maxSize !== void 0 && h.size > n.maxSize) {
        const p = o("common.info.fileParamToo", {
          filename: h.name,
          maxSize: $0(n.maxSize)
        });
        return gd(p, "warning"), !1;
      }
      return !0;
    }
    function c(h) {
      const p = h.filter(a);
      p.length > 0 && s("files", p);
    }
    function d(h) {
      const p = h.target;
      p.files && (c(Array.from(p.files)), p.value = "");
    }
    async function u(h) {
      const p = await JA(h);
      c(n.multiple ? p : p.slice(0, 1));
    }
    return (h, p) => {
      var C;
      return f(), v("div", {
        ref_key: "dropZoneRef",
        ref: i,
        class: S([
          h.$style.dragAndDropField,
          {
            [h.$style.isOverDropZone]: k(l),
            [h.$style.alert]: e.alert,
            [h.$style.disabled]: e.disabled,
            [h.$style.extended]: e.extended
          }
        ])
      }, [
        de(Ae, {
          icon: "tetrisly/upload",
          size: "20px",
          class: S(h.$style.icon)
        }, null, 8, ["class"]),
        g("div", {
          class: S(h.$style.content)
        }, [
          g("h6", {
            class: S(h.$style.title)
          }, [
            Ve(se(k(o)("common.action.dragDrop")) + " ", 1),
            g("a", {
              class: S(h.$style.chooseFile)
            }, [
              Ve(se(k(o)("common.placeholder.file")) + " ", 1),
              g("input", {
                type: "file",
                accept: (C = e.dataTypes) == null ? void 0 : C.join(", "),
                multiple: e.multiple,
                onInput: d
              }, null, 40, n8e)
            ], 2),
            Ve(" " + se(k(o)("common.action.upload2")), 1)
          ], 2),
          e.extended ? (f(), v("small", {
            key: 0,
            class: S(h.$style.small)
          }, se(r.value), 3)) : $("", !0)
        ], 2)
      ], 2);
    };
  }
}), i8e = "_dragAndDropField_qljqn_1", r8e = "_extended_qljqn_14", l8e = "_alert_qljqn_21", a8e = "_disabled_qljqn_24", c8e = "_isOverDropZone_qljqn_37", d8e = "_icon_qljqn_41", u8e = "_content_qljqn_45", h8e = "_title_qljqn_52", g8e = "_small_qljqn_61", p8e = "_chooseFile_qljqn_70", f8e = {
  dragAndDropField: i8e,
  extended: r8e,
  alert: l8e,
  disabled: a8e,
  isOverDropZone: c8e,
  icon: d8e,
  content: u8e,
  title: h8e,
  small: g8e,
  chooseFile: p8e
}, v8e = {
  $style: f8e
}, m8e = /* @__PURE__ */ Ce(s8e, [["__cssModules", v8e]]), C8e = /* @__PURE__ */ pe({
  __name: "SCAFileItem",
  props: {
    file: { default: void 0 },
    inverted: { type: Boolean, default: !0 },
    extended: { type: Boolean, default: !0 },
    thumbnail: { type: Boolean, default: !0 },
    percentage: { default: void 0 }
  },
  emits: ["remove"],
  setup(e, { emit: t }) {
    const o = t;
    return (n, s) => (f(), v("div", {
      class: S([n.$style.fileItem, { [n.$style.inverted]: e.inverted }])
    }, [
      e.extended && e.thumbnail ? (f(), U(Ae, {
        key: 0,
        class: S(n.$style.thumbnail),
        icon: k(qA)(e.file.type, e.file.name).icon,
        size: "40px"
      }, null, 8, ["class", "icon"])) : $("", !0),
      g("div", {
        class: S(n.$style.info)
      }, [
        g("div", {
          class: S(n.$style.infoTop)
        }, [
          g("div", {
            class: S(n.$style.fileName)
          }, se(e.file.name), 3),
          de(ot, {
            class: S(n.$style.cancel),
            type: "bare",
            size: "medium",
            appearance: "secondary",
            icon: "tetrisly/close",
            onClick: s[0] || (s[0] = (i) => o("remove"))
          }, null, 8, ["class"])
        ], 2),
        e.extended ? (f(), v("div", {
          key: 0,
          class: S(n.$style.infoBottom)
        }, [
          g("div", {
            class: S(n.$style.details)
          }, [
            g("div", null, se(k($0)(e.file.size)), 1)
          ], 2),
          e.percentage ? (f(), v("div", {
            key: 0,
            class: S(n.$style.percentage)
          }, se(e.percentage) + "%", 3)) : $("", !0)
        ], 2)) : $("", !0)
      ], 2)
    ], 2));
  }
}), w8e = "_fileItem_tatyq_1", b8e = "_isUploaded_tatyq_17", y8e = "_inverted_tatyq_20", _8e = "_thumbnail_tatyq_26", S8e = "_info_tatyq_30", x8e = "_infoTop_tatyq_38", M8e = "_fileName_tatyq_43", A8e = "_cancel_tatyq_50", L8e = "_infoBottom_tatyq_54", E8e = "_details_tatyq_64", P8e = "_percentage_tatyq_82", R8e = {
  fileItem: w8e,
  isUploaded: b8e,
  inverted: y8e,
  thumbnail: _8e,
  info: S8e,
  infoTop: x8e,
  fileName: M8e,
  cancel: A8e,
  infoBottom: L8e,
  details: E8e,
  percentage: P8e
}, F8e = {
  $style: R8e
}, T8e = /* @__PURE__ */ Ce(C8e, [["__cssModules", F8e]]), I8e = /* @__PURE__ */ pe({
  __name: "SCAFileUploader",
  props: {
    extended: { type: Boolean, default: !1 },
    dataTypes: { default: void 0 },
    multiple: { type: Boolean, default: !0 },
    alert: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    label: { default: void 0 },
    helperText: { default: void 0 },
    maxSize: { default: void 0 },
    modelValue: { default: () => [] }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const s = oo(e, "modelValue", t, { passive: !0 });
    function i(l) {
      s.value = [...s.value, ...l];
    }
    function r(l) {
      const a = [...s.value];
      a.splice(l, 1), s.value = a;
    }
    return (l, a) => (f(), v("div", {
      class: S([l.$style.fileUploader, { [l.$style.extended]: e.extended }])
    }, [
      e.label ? (f(), v("label", {
        key: 0,
        class: S(l.$style.label)
      }, se(e.label), 3)) : $("", !0),
      de(m8e, {
        extended: e.extended,
        "data-types": e.dataTypes,
        multiple: e.multiple,
        alert: e.alert,
        disabled: e.disabled,
        "max-size": e.maxSize,
        onFiles: i
      }, null, 8, ["extended", "data-types", "multiple", "alert", "disabled", "max-size"]),
      e.helperText ? (f(), U(r1, {
        key: 1,
        class: S(l.$style.helperText)
      }, {
        default: ee(() => [
          Ve(se(e.helperText), 1)
        ]),
        _: 1
      }, 8, ["class"])) : $("", !0),
      k(s).length > 0 ? (f(), v("div", {
        key: 2,
        class: S(l.$style.items)
      }, [
        (f(!0), v(we, null, Ze(k(s), (c, d) => (f(), U(T8e, {
          key: `${d}_${c.name}`,
          file: c,
          extended: e.extended && k(s).length <= 3,
          onRemove: (u) => r(d)
        }, null, 8, ["file", "extended", "onRemove"]))), 128))
      ], 2)) : $("", !0)
    ], 2));
  }
}), D8e = "_fileUploader_1o85o_1", k8e = "_extended_1o85o_7", H8e = "_items_1o85o_7", V8e = "_label_1o85o_17", O8e = {
  fileUploader: D8e,
  extended: k8e,
  items: H8e,
  label: V8e
}, B8e = {
  $style: O8e
}, wst = /* @__PURE__ */ Ce(I8e, [["__cssModules", B8e]]), $8e = /* @__PURE__ */ pe({
  __name: "SCATextHighlighter",
  props: {
    text: { type: [String, Number, Boolean, Array, null], default: "" },
    searchTerm: { default: "" },
    startLength: { default: 0 }
  },
  setup(e) {
    const t = e, o = F(() => {
      let n = "";
      return t.text == null ? n = "" : typeof t.text == "string" || typeof t.text == "number" ? n = String(t.text) : typeof t.text == "boolean" ? n = t.text ? "true" : "false" : Array.isArray(t.text) ? n = t.text.join(", ") : n = "", !t.searchTerm || t.startLength !== void 0 && t.searchTerm.length <= t.startLength ? [n] : tL(n, t.searchTerm);
    });
    return (n, s) => (f(), v("span", {
      class: S(n.$style.label)
    }, [
      (f(!0), v(we, null, Ze(o.value, (i, r) => (f(), v(we, { key: r }, [
        typeof i == "object" ? (f(), v("span", {
          key: 0,
          class: S(n.$style.highlight)
        }, se(i.highlight), 3)) : (f(), v(we, { key: 1 }, [
          Ve(se(i), 1)
        ], 64))
      ], 64))), 128))
    ], 2));
  }
}), Z8e = "_highlight_jk56p_1", G8e = {
  highlight: Z8e
}, N8e = {
  $style: G8e
}, fl = /* @__PURE__ */ Ce($8e, [["__cssModules", N8e]]);
function KC(e, t, o = {}) {
  const n = oo(e, "searchTerm", t, { passive: !0 }), s = oo(e, "items", t, { passive: !0, deep: !0 }), i = Ro("searchResultsInfiniteRef"), r = n1("inSidebar", W(!0)), l = F(() => r.value), a = F(
    () => !e.disabled && (!e.maxItems || s.value.length < e.maxItems)
  );
  function c(m, w) {
    return m.id != null ? String(m.id) : m.label ? `${m.label}_${w ?? ""}` : JSON.stringify(m);
  }
  function d(m) {
    return s.value.some((w) => c(w) === c(m));
  }
  function u(m) {
    var w;
    return (w = o.isSingleSelect) != null && w.value ? !1 : !d(m) && !a.value;
  }
  const h = F(() => {
    const m = e.inlineSelected ? e.searchResults ?? [] : (e.searchResults ?? []).filter(
      (w) => !s.value.some((y) => c(y) === c(w))
    );
    return e.preserveOrder ? m : m.sort((w, y) => {
      const b = String(w.label ?? ""), _ = String(y.label ?? "");
      return b.localeCompare(_, void 0, { sensitivity: "base", numeric: !0 });
    });
  });
  function p(m) {
    if (e.disabled || e.readonly) return;
    const w = s.value[m], y = [...s.value];
    y.splice(m, 1), s.value = y;
    const b = (e.searchResults ?? []).find((_) => c(_) === c(w));
    b && (b.selected = !1);
  }
  function C() {
    if (!e.hasMore || e.loadingMore) return;
    const m = i.value;
    m && m.scrollHeight - m.scrollTop - m.clientHeight < 50 && t("loadMore");
  }
  return {
    searchTerm: n,
    selectedItems: s,
    searchResultsInfiniteRef: i,
    inSideBar: l,
    canAddMore: a,
    getItemKey: c,
    isSelected: d,
    isDisabledForSelection: u,
    availableItems: h,
    removeSelectedItem: p,
    onScroll: C
  };
}
const z8e = ["draggable", "onDragstart", "onDragover", "onDrop"], j8e = ["id", "placeholder", "disabled"], W8e = { key: 1 }, U8e = ["placeholder"], K8e = ["disabled", "checked", "onChange"], q8e = ["disabled", "checked", "onChange"], Y8e = pe({ inheritAttrs: !1 }), Q8e = /* @__PURE__ */ pe({
  ...Y8e,
  __name: "SCAInputTags",
  props: {
    helperText: { default: void 0 },
    isDraggable: { type: Boolean, default: !1 },
    showArrow: { type: Boolean, default: !1 },
    useDropdownMode: { type: Boolean, default: !1 },
    dropdownWidth: { default: void 0 },
    searchTerm: { default: "" },
    items: {},
    searchResults: { default: () => [] },
    maxItems: { default: void 0 },
    placeholder: { default: "" },
    loading: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    minSearchLength: { default: 0 },
    hasMore: { type: Boolean, default: !1 },
    loadingMore: { type: Boolean, default: !1 },
    isOpenByDefault: { type: Boolean, default: !1 },
    showTooltip: { type: Boolean, default: !1 },
    preserveOrder: { type: Boolean, default: !1 },
    inlineSelected: { type: Boolean, default: !1 },
    renderKey: {},
    label: {},
    labelPosition: {},
    appearance: {},
    optionalLabelText: {},
    htmlFor: {},
    validationError: { type: Boolean },
    required: { type: Boolean },
    prefix: {},
    highlightLabel: { type: Boolean },
    tooltipType: {},
    tooltipId: {},
    tooltip: {},
    helpLink: {},
    focused: { type: Boolean }
  },
  emits: ["update:searchTerm", "update:items", "init", "loadMore", "close", "apply"],
  setup(e, { emit: t }) {
    const o = e, n = t, s = 3, i = 3, r = W(!1), l = W(!1), a = W(!1), c = W(!1), {
      searchTerm: d,
      selectedItems: u,
      searchResultsInfiniteRef: h,
      inSideBar: p,
      getItemKey: C,
      isSelected: m,
      isDisabledForSelection: w,
      availableItems: y,
      removeSelectedItem: b,
      onScroll: _
    } = KC(o, n), M = Ro("placeholderCalcRef"), x = Ro("searchInputRef"), L = Ro("contentRef"), { setDropdown: A, hideList: R } = h2(), { width: P } = nP(M), { isDesktop: I } = wL(), B = F(() => {
      const V = I.value ? 8 : 32;
      return `${Math.max(P.value, V)}px`;
    }), H = F(
      () => l.value ? u.value : u.value.slice(0, s)
    ), O = F(() => d.value ? u.value.filter((V) => V.label.toLowerCase().includes(d.value.toLowerCase())).length : u.value.length), N = F(() => {
      let V = u.value;
      return d.value && (V = V.filter((Q) => Q.label.toLowerCase().includes(d.value.toLowerCase()))), a.value || (V = V.slice(0, i)), V;
    });
    function te() {
      o.disabled || o.readonly || r.value || (r.value = !0, n("init"));
    }
    function E(V) {
      if (w(V)) return;
      const Q = C(V), ye = [...u.value], ae = ye.findIndex((Oe) => C(Oe) === Q);
      ae > -1 ? ye.splice(ae, 1) : ye.unshift(V), u.value = ye;
      const ie = o.searchResults.find((Oe) => C(Oe) === Q);
      ie && (ie.selected = ae === -1);
    }
    const { isHighlighted: j, handleKeyDown: Z, handleFocus: Y, handlePointerDown: le } = u2({
      isOpen: r,
      items: y,
      listEl: h,
      searchTerm: d,
      open: te,
      commit: E,
      isInert: () => o.disabled || o.readonly,
      focusAnchor: () => L.value,
      hideList: R
    }), ge = W(!1), ce = F(() => !o.disabled && !o.readonly && (ge.value || r.value));
    function G() {
      ge.value = !0, Y();
    }
    function z(V) {
      var ye;
      const Q = V.relatedTarget;
      Q && ((ye = L.value) != null && ye.contains(Q)) || (ge.value = !1);
    }
    At(() => {
      o.isOpenByDefault && (r.value = !0);
    }), Me(r, (V) => {
      if (V) return;
      d.value = "";
      const Q = L.value;
      Q && !Q.matches(":hover") || (c.value = !1, n("close"));
    });
    const oe = W(null), q = W(null), ne = W("before");
    function Fe(V, Q) {
      o.isDraggable && V.dataTransfer && (V.dataTransfer.effectAllowed = "move", V.dataTransfer.setData("tagIdx", String(Q)), oe.value = Q);
    }
    function We(V, Q) {
      if (V.preventDefault(), !V.dataTransfer) return;
      V.dataTransfer.dropEffect = "move", q.value = Q;
      const ae = V.currentTarget.getBoundingClientRect();
      ne.value = V.clientX - ae.left < ae.width / 2 ? "before" : "after";
    }
    function Qe() {
      q.value = null;
    }
    function nt(V, Q) {
      var Dt;
      V.preventDefault();
      const ye = Number((Dt = V.dataTransfer) == null ? void 0 : Dt.getData("tagIdx"));
      if (isNaN(ye) || ye === Q) {
        oe.value = null, q.value = null;
        return;
      }
      const ae = [...u.value], [ie] = ae.splice(ye, 1);
      let Oe = Q;
      ne.value === "after" && (Oe = Q + 1), ye < Q && (Oe -= 1), ae.splice(Oe, 0, ie), u.value = ae, oe.value = null, q.value = null;
    }
    function ut() {
      oe.value = null, q.value = null;
    }
    return (V, Q) => {
      const ye = k5("tooltip");
      return f(), v(we, null, [
        de(c2, Bt(V.$attrs, {
          label: e.label,
          "label-position": e.labelPosition,
          appearance: k(u).length > 0 && k(p) || e.useDropdownMode || e.disabled && !e.showArrow ? "no-border" : e.appearance,
          "helper-text": o.useDropdownMode ? void 0 : e.helperText,
          "optional-label-text": e.optionalLabelText,
          "html-for": e.htmlFor,
          "validation-error": e.validationError,
          required: e.required,
          prefix: e.prefix,
          "highlight-label": e.highlightLabel !== void 0 ? e.highlightLabel : !e.disabled && (c.value || r.value),
          tooltip: e.tooltip,
          "help-link": e.helpLink,
          style: { "--sca-label-align": "start", "--sca-input-field-wrapper-padding": "0px", position: "relative" },
          focused: ce.value,
          onMouseenter: Q[12] || (Q[12] = (ae) => c.value = !0),
          onMouseleave: Q[13] || (Q[13] = (ae) => c.value = !1)
        }), {
          labelAction: ee(() => [
            ve(V.$slots, "labelAction")
          ]),
          default: ee(() => [
            g("div", {
              ref: "contentRef",
              class: S([V.$style.content, !e.disabled && !e.readonly && !e.useDropdownMode && c.value && V.$style.hovered]),
              tabindex: "0",
              onClick: te,
              onKeydown: Q[10] || (Q[10] = //@ts-ignore
              (...ae) => k(Z) && k(Z)(...ae)),
              onFocusin: G,
              onFocusout: z,
              onPointerdown: Q[11] || (Q[11] = //@ts-ignore
              (...ae) => k(le) && k(le)(...ae))
            }, [
              r.value && !e.useDropdownMode ? (f(), v("div", {
                key: 0,
                class: S(V.$style.baseInfo)
              }, [
                g("span", null, se(V.$t("common.label.selected")), 1),
                g("span", {
                  class: S([V.$style.badgePlaceholder])
                }, "(" + se(k(u).length) + ")", 3)
              ], 2)) : e.useDropdownMode ? $("", !0) : (f(), v("div", {
                key: 1,
                class: S(V.$style.tags)
              }, [
                k(u).length === 0 && e.placeholder ? (f(), v("span", {
                  key: 0,
                  class: S(V.$style.placeholderText)
                }, se(e.placeholder), 3)) : $("", !0),
                (f(!0), v(we, null, Ze(H.value, (ae, ie) => (f(), v("div", {
                  key: k(C)(ae, ie),
                  class: S([
                    V.$style.tagWrapper,
                    e.isDraggable && oe.value === ie && V.$style.dragging,
                    e.isDraggable && q.value === ie && ne.value === "before" && V.$style.indicateBefore,
                    e.isDraggable && q.value === ie && ne.value === "after" && V.$style.indicateAfter
                  ]),
                  draggable: e.isDraggable && !e.disabled && !e.readonly && !ae.disabled,
                  onDragstart: (Oe) => Fe(Oe, ie),
                  onDragover: (Oe) => We(Oe, ie),
                  onDragleave: Qe,
                  onDrop: (Oe) => nt(Oe, ie),
                  onDragend: ut
                }, [
                  Et((f(), U(Pn, {
                    tabindex: "-1",
                    removable: !e.disabled && !ae.disabled && !e.readonly,
                    disabled: ae.disabled,
                    selected: ae.selected,
                    avatar: ae.avatar,
                    icon: ae.iconFramed ? void 0 : ae.icon,
                    "icon-size": ae.iconSize,
                    "icon-color": ae.iconColor,
                    onRemove: (Oe) => k(b)(ie)
                  }, sn({
                    default: ee(() => [
                      g("div", {
                        class: S(V.$style.tag)
                      }, [
                        e.isDraggable && !e.disabled && !e.readonly && !ae.disabled ? (f(), v("div", {
                          key: 0,
                          class: S(V.$style.tagIcon)
                        }, [
                          de(Ae, {
                            icon: "phosphor/dots-six-vertical",
                            size: "16px"
                          })
                        ], 2)) : $("", !0),
                        g("div", {
                          class: S(V.$style.tagLabel)
                        }, se(ae.label), 3)
                      ], 2)
                    ]),
                    _: 2
                  }, [
                    ae.iconFramed && ae.icon ? {
                      name: "iconLeft",
                      fn: ee(() => [
                        g("div", {
                          class: S(V.$style.iconFrame)
                        }, [
                          de(Ae, {
                            icon: ae.icon,
                            size: "12px",
                            color: ae.iconColor
                          }, null, 8, ["icon", "color"])
                        ], 2)
                      ]),
                      key: "0"
                    } : void 0
                  ]), 1032, ["removable", "disabled", "selected", "avatar", "icon", "icon-size", "icon-color", "onRemove"])), [
                    [ye, e.showTooltip ? ae.id : null]
                  ])
                ], 42, z8e))), 128)),
                k(u).length > s ? (f(), v("button", {
                  key: 1,
                  class: S([V.$style.showAllButton, V.$style.lessMargin]),
                  onClick: Q[0] || (Q[0] = xe((ae) => l.value = !l.value, ["prevent", "stop"]))
                }, [
                  g("span", {
                    class: S(V.$style.buttonText)
                  }, se(l.value ? V.$t("common.action.showLess") : V.$t("common.action.show")), 3),
                  l.value ? $("", !0) : (f(), v("span", {
                    key: 0,
                    class: S(V.$style.badge)
                  }, " (" + se(k(u).length - s) + ") ", 3))
                ], 2)) : $("", !0),
                g("input", {
                  id: e.htmlFor,
                  placeholder: e.placeholder,
                  disabled: e.showArrow && e.disabled,
                  style: Ge({ minWidth: B.value }),
                  class: S(V.$style.searchInputHidden),
                  tabindex: "-1",
                  onClick: te
                }, null, 14, j8e)
              ], 2)),
              g("div", {
                class: S(e.useDropdownMode ? V.$style.searchInputContainer : V.$style.dropdownAnchor),
                style: Ge(e.dropdownWidth ? { "--input-tags-results-width": e.dropdownWidth } : void 0)
              }, [
                e.loading ? (f(), U(i1, {
                  key: 0,
                  class: S(V.$style.loader),
                  size: "small",
                  indeterminate: ""
                }, null, 8, ["class"])) : $("", !0),
                de(zt, {
                  ref: k(A),
                  "is-open": r.value,
                  "onUpdate:isOpen": Q[8] || (Q[8] = (ae) => r.value = ae),
                  "no-padding": !0,
                  "more-padding": !0,
                  "offset-y": 2,
                  width: e.dropdownWidth,
                  onPositioned: Q[9] || (Q[9] = (ae) => {
                    var ie;
                    return (ie = x.value) == null ? void 0 : ie.focus();
                  })
                }, {
                  trigger: ee(({ togglePopover: ae }) => [
                    e.useDropdownMode ? (f(), U(ot, {
                      key: 0,
                      size: "small",
                      appearance: "secondary",
                      icon: "phosphor/plus",
                      disabled: e.disabled,
                      class: S({ [V.$style.active]: r.value }),
                      title: "Add user",
                      onClick: xe(ae, ["stop"])
                    }, null, 8, ["disabled", "class", "onClick"])) : (f(), v("div", W8e))
                  ]),
                  default: ee(() => {
                    var ae;
                    return [
                      g("div", {
                        class: S(V.$style.header)
                      }, [
                        de(ot, {
                          class: S(V.$style.iconButton),
                          title: V.$t("common.action.apply"),
                          icon: "phosphor/check",
                          appearance: "secondary",
                          size: "small",
                          onClick: Q[1] || (Q[1] = xe((ie) => {
                            r.value = !1, V.$emit("apply");
                          }, ["stop", "prevent"]))
                        }, null, 8, ["class", "title"]),
                        de(oa, {
                          appearance: "border",
                          "show-clear-icon": k(d).length > 0,
                          class: S(V.$style.searchInput),
                          onClear: Q[3] || (Q[3] = xe((ie) => d.value = "", ["prevent", "stop"]))
                        }, {
                          default: ee(() => [
                            Et(g("input", {
                              ref: "searchInputRef",
                              "onUpdate:modelValue": Q[2] || (Q[2] = (ie) => Tn(d) ? d.value = ie : null),
                              readonly: !1,
                              placeholder: V.$t("common.action.search")
                            }, null, 8, U8e), [
                              [xn, k(d)]
                            ])
                          ]),
                          _: 1
                        }, 8, ["show-clear-icon", "class"])
                      ], 2),
                      g("div", {
                        class: S(V.$style.borderFull)
                      }, null, 2),
                      ve(V.$slots, "beforeSearchResults"),
                      e.inlineSelected ? $("", !0) : (f(), v(we, { key: 0 }, [
                        g("div", {
                          class: S([V.$style.searchResults, N.value.length === 0 && V.$style.displayNone])
                        }, [
                          (f(!0), v(we, null, Ze(N.value, (ie, Oe) => (f(), v("div", {
                            key: k(C)(ie, Oe),
                            class: S(V.$style.item)
                          }, [
                            de(Zo, {
                              checked: k(m)(ie),
                              disabled: k(w)(ie)
                            }, {
                              default: ee(() => [
                                g("input", {
                                  type: "checkbox",
                                  disabled: k(w)(ie),
                                  checked: k(m)(ie),
                                  onChange: (Dt) => E(ie)
                                }, null, 40, K8e)
                              ]),
                              _: 2
                            }, 1032, ["checked", "disabled"]),
                            de(Pn, {
                              id: k(C)(ie, Oe),
                              disabled: k(w)(ie),
                              selected: k(m)(ie),
                              avatar: ie.avatar,
                              icon: ie.iconFramed ? void 0 : ie.icon,
                              "icon-size": ie.iconSize,
                              "icon-color": ie.iconColor,
                              style: { minWidth: 0 },
                              onMousedown: Q[4] || (Q[4] = xe(() => {
                              }, ["prevent"])),
                              onClick: xe((Dt) => E(ie), ["prevent"])
                            }, sn({
                              default: ee(() => [
                                k(d) ? (f(), U(fl, {
                                  key: 0,
                                  text: ie.label,
                                  "search-term": k(d)
                                }, null, 8, ["text", "search-term"])) : (f(), v(we, { key: 1 }, [
                                  Ve(se(ie.label), 1)
                                ], 64)),
                                ie.label.length > 30 ? (f(), U(bo, {
                                  key: 2,
                                  id: k(C)(ie, Oe),
                                  text: ie.label
                                }, null, 8, ["id", "text"])) : $("", !0)
                              ]),
                              _: 2
                            }, [
                              ie.iconFramed && ie.icon ? {
                                name: "iconLeft",
                                fn: ee(() => [
                                  g("div", {
                                    class: S(V.$style.iconFrame)
                                  }, [
                                    de(Ae, {
                                      icon: ie.icon,
                                      size: "12px",
                                      color: ie.iconColor
                                    }, null, 8, ["icon", "color"])
                                  ], 2)
                                ]),
                                key: "0"
                              } : void 0
                            ]), 1032, ["id", "disabled", "selected", "avatar", "icon", "icon-size", "icon-color", "onClick"])
                          ], 2))), 128)),
                          O.value > i ? (f(), v("button", {
                            key: 0,
                            class: S([V.$style.showAllButton, V.$style.morePadding]),
                            onClick: Q[5] || (Q[5] = xe((ie) => a.value = !a.value, ["prevent", "stop"]))
                          }, [
                            g("span", {
                              class: S(V.$style.buttonText)
                            }, se(a.value ? V.$t("common.action.showLess") : V.$t("common.action.show")), 3),
                            a.value ? $("", !0) : (f(), v("span", {
                              key: 0,
                              class: S(V.$style.badge)
                            }, " (" + se(O.value - i) + ") ", 3))
                          ], 2)) : $("", !0)
                        ], 2),
                        N.value.length > 0 ? (f(), v("div", {
                          key: 0,
                          class: S(V.$style.border)
                        }, null, 2)) : $("", !0)
                      ], 64)),
                      g("div", {
                        ref_key: "searchResultsInfiniteRef",
                        ref: h,
                        class: S(V.$style.searchResults),
                        onScroll: Q[7] || (Q[7] = //@ts-ignore
                        (...ie) => k(_) && k(_)(...ie))
                      }, [
                        (f(!0), v(we, null, Ze(k(y), (ie, Oe) => (f(), v("div", {
                          key: o.renderKey !== void 0 ? `${k(C)(ie, Oe)}-${o.renderKey}` : k(C)(ie, Oe),
                          class: S([V.$style.item, k(j)(Oe) && V.$style.highlighted])
                        }, [
                          de(Zo, {
                            checked: k(m)(ie) || !!ie.indeterminate,
                            deselect: !!ie.indeterminate,
                            disabled: k(w)(ie)
                          }, {
                            default: ee(() => [
                              g("input", {
                                type: "checkbox",
                                disabled: k(w)(ie),
                                checked: k(m)(ie) || !!ie.indeterminate,
                                onChange: (Dt) => E(ie)
                              }, null, 40, q8e)
                            ]),
                            _: 2
                          }, 1032, ["checked", "deselect", "disabled"]),
                          de(Pn, {
                            id: k(C)(ie, Oe),
                            disabled: k(w)(ie),
                            selected: k(m)(ie),
                            avatar: ie.avatar,
                            icon: ie.iconFramed ? void 0 : ie.icon,
                            "icon-size": ie.iconSize,
                            "icon-color": ie.iconColor,
                            style: Ge({ minWidth: 0, marginLeft: ie.level ? `${ie.level * 16}px` : void 0 }),
                            onMousedown: Q[6] || (Q[6] = xe(() => {
                            }, ["prevent"])),
                            onClick: xe((Dt) => E(ie), ["prevent"])
                          }, sn({
                            default: ee(() => [
                              de(fl, {
                                text: ie.label,
                                "search-term": k(d)
                              }, null, 8, ["text", "search-term"]),
                              ie.label.length > 30 ? (f(), U(bo, {
                                key: 0,
                                id: k(C)(ie, Oe),
                                text: ie.label
                              }, null, 8, ["id", "text"])) : $("", !0)
                            ]),
                            _: 2
                          }, [
                            ie.iconFramed && ie.icon ? {
                              name: "iconLeft",
                              fn: ee(() => [
                                g("div", {
                                  class: S(V.$style.iconFrame)
                                }, [
                                  de(Ae, {
                                    icon: ie.icon,
                                    size: "12px",
                                    color: ie.iconColor
                                  }, null, 8, ["icon", "color"])
                                ], 2)
                              ]),
                              key: "0"
                            } : void 0
                          ]), 1032, ["id", "disabled", "selected", "avatar", "icon", "icon-size", "icon-color", "style", "onClick"])
                        ], 2))), 128)),
                        ((ae = e.searchResults) == null ? void 0 : ae.length) === 0 && k(d).length >= o.minSearchLength ? (f(), U(tr, {
                          key: 0,
                          loading: o.loading
                        }, null, 8, ["loading"])) : $("", !0)
                      ], 34)
                    ];
                  }),
                  _: 3
                }, 8, ["is-open", "width"])
              ], 6)
            ], 34),
            e.showArrow && c.value && !e.disabled ? (f(), U(Ae, {
              key: 0,
              icon: r.value ? "phosphor/caret-up" : "phosphor/caret-down",
              class: S(V.$style.arrowIcon),
              size: "12px"
            }, null, 8, ["icon", "class"])) : $("", !0)
          ]),
          _: 3
        }, 16, ["label", "label-position", "appearance", "helper-text", "optional-label-text", "html-for", "validation-error", "required", "prefix", "highlight-label", "tooltip", "help-link", "focused"]),
        e.placeholder ? (f(), v("span", {
          key: 0,
          ref: "placeholderCalcRef",
          class: S(V.$style.placeholderCalculator)
        }, se(e.placeholder ?? ""), 3)) : $("", !0)
      ], 64);
    };
  }
}), J8e = "_content_1q2ih_1", X8e = "_hovered_1q2ih_12", ege = "_disabled_1q2ih_17", tge = "_tags_1q2ih_22", oge = "_placeholderText_1q2ih_28", nge = "_dropdownAnchor_1q2ih_32", sge = "_searchInputHidden_1q2ih_42", ige = "_searchResults_1q2ih_54", rge = "_displayNone_1q2ih_72", lge = "_header_1q2ih_76", age = "_item_1q2ih_82", cge = "_highlighted_1q2ih_95", dge = "_searchInput_1q2ih_42", uge = "_border_1q2ih_104", hge = "_borderFull_1q2ih_109", gge = "_showAllButton_1q2ih_114", pge = "_buttonText_1q2ih_129", fge = "_badge_1q2ih_129", vge = "_lessMargin_1q2ih_159", mge = "_morePadding_1q2ih_163", Cge = "_baseInfo_1q2ih_167", wge = "_badgePlaceholder_1q2ih_176", bge = "_placeholderCalculator_1q2ih_180", yge = "_iconButton_1q2ih_186", _ge = "_tagWrapper_1q2ih_191", Sge = "_indicateBefore_1q2ih_196", xge = "_indicateAfter_1q2ih_196", Mge = "_dragging_1q2ih_211", Age = "_tag_1q2ih_22", Lge = "_tagIcon_1q2ih_218", Ege = "_tagLabel_1q2ih_221", Pge = "_active_1q2ih_227", Rge = "_arrowIcon_1q2ih_231", Fge = "_iconFrame_1q2ih_240", Tge = {
  content: J8e,
  hovered: X8e,
  disabled: ege,
  tags: tge,
  placeholderText: oge,
  dropdownAnchor: nge,
  searchInputHidden: sge,
  searchResults: ige,
  displayNone: rge,
  header: lge,
  item: age,
  highlighted: cge,
  searchInput: dge,
  border: uge,
  borderFull: hge,
  showAllButton: gge,
  buttonText: pge,
  badge: fge,
  lessMargin: vge,
  morePadding: mge,
  baseInfo: Cge,
  badgePlaceholder: wge,
  placeholderCalculator: bge,
  iconButton: yge,
  tagWrapper: _ge,
  indicateBefore: Sge,
  indicateAfter: xge,
  dragging: Mge,
  tag: Age,
  tagIcon: Lge,
  tagLabel: Ege,
  active: Pge,
  arrowIcon: Rge,
  iconFrame: Fge
}, Ige = {
  $style: Tge
}, bst = /* @__PURE__ */ Ce(Q8e, [["__cssModules", Ige]]), Dge = ["tabindex"], kge = ["id", "placeholder"], Hge = ["id", "onMousedown"], Vge = ["src"], Oge = /* @__PURE__ */ pe({
  __name: "SCAInputTagsInline",
  props: {
    isEmail: { type: Boolean, default: !1 },
    resultsAsTags: { type: Boolean, default: !1 },
    showArrow: { type: Boolean, default: !1 },
    keepOpenOnSelect: { type: Boolean, default: !1 },
    searchTerm: { default: "" },
    items: {},
    searchResults: { default: () => [] },
    maxItems: { default: void 0 },
    placeholder: { default: "" },
    loading: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    minSearchLength: { default: 0 },
    hasMore: { type: Boolean, default: !1 },
    loadingMore: { type: Boolean, default: !1 },
    isOpenByDefault: { type: Boolean, default: !1 },
    showTooltip: { type: Boolean, default: !1 },
    preserveOrder: { type: Boolean },
    inlineSelected: { type: Boolean },
    renderKey: {},
    label: {},
    labelPosition: {},
    appearance: {},
    helperText: {},
    optionalLabelText: {},
    htmlFor: {},
    validationError: { type: Boolean },
    required: { type: Boolean },
    prefix: {},
    highlightLabel: { type: Boolean },
    tooltipType: {},
    tooltipId: {},
    tooltip: {},
    helpLink: {},
    focused: { type: Boolean }
  },
  emits: ["update:searchTerm", "update:items", "init", "loadMore", "close"],
  setup(e, { emit: t }) {
    const o = e, n = Ro("contentRef"), s = t, i = W(!1), r = W(!0), l = W(!1), a = F(() => o.maxItems === 1), {
      searchTerm: c,
      selectedItems: d,
      searchResultsInfiniteRef: u,
      inSideBar: h,
      canAddMore: p,
      getItemKey: C,
      isSelected: m,
      isDisabledForSelection: w,
      availableItems: y,
      removeSelectedItem: b,
      onScroll: _
    } = KC(o, s, { isSingleSelect: a }), M = Ro("searchInputRef"), { setDropdown: x, hideList: L } = h2(), A = F(() => p.value && !o.readonly && !o.disabled);
    function R() {
      var G;
      o.disabled || o.readonly || (i.value = !0, (G = M.value) == null || G.focus());
    }
    function P(G) {
      var Fe;
      if (w(G)) return;
      if (a.value) {
        d.value = [G], i.value = !1, c.value = "";
        return;
      }
      const z = C(G), oe = [...d.value], q = oe.findIndex((We) => C(We) === z);
      q > -1 ? oe.splice(q, 1) : oe.push(G), d.value = oe;
      const ne = o.searchResults.find((We) => C(We) === z);
      ne && (ne.selected = q === -1), o.keepOpenOnSelect || (i.value = !1, c.value = ""), window.innerWidth > 768 && ((Fe = M.value) == null || Fe.focus());
    }
    function I(G) {
      var q;
      const z = G.relatedTarget, oe = u.value;
      if (!(z && (oe != null && oe.contains(z) || (q = n.value) != null && q.contains(z)))) {
        if (o.isEmail && B(c.value)) {
          const ne = { label: c.value, id: c.value };
          !m(ne) && !w(ne) && (d.value = a.value ? [ne] : [...d.value, ne]);
        }
        i.value = !1, c.value = "", l.value = !1;
      }
    }
    const B = (G) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(G), H = /* @__PURE__ */ new Set(["Enter", " ", ",", ";"]), { isHighlighted: O, handleKeyDown: N, handleFocus: te, handlePointerDown: E, focusField: j } = u2({
      isOpen: i,
      items: y,
      listEl: u,
      searchTerm: c,
      open: R,
      commit: P,
      isInert: () => o.disabled || o.readonly,
      initialIndex: () => a.value ? y.value.findIndex((G) => m(G)) : 0,
      focusAnchor: () => (p.value ? M.value : null) ?? n.value,
      hideList: L,
      onClose: () => {
        c.value = "";
      }
    }), Z = W(!1), Y = F(() => !o.disabled && !o.readonly && (Z.value || i.value));
    function le() {
      Z.value = !0, te();
    }
    function ge(G) {
      var oe;
      const z = G.relatedTarget;
      z && ((oe = n.value) != null && oe.contains(z)) || (Z.value = !1);
    }
    Me(p, (G) => {
      G || !Z.value || j();
    });
    function ce(G) {
      var oe;
      if (o.disabled || o.readonly) return;
      (oe = M.value) == null || oe.focus();
      const z = G.key.length === 1 && !G.ctrlKey && !G.metaKey && !G.altKey;
      if (!r.value && z) {
        r.value = !0, R();
        return;
      }
      if (H.has(G.key) && o.isEmail && B(c.value)) {
        G.preventDefault(), P({ label: c.value, id: c.value });
        return;
      }
      N(G);
    }
    return qE(n, () => {
      i.value && (i.value = !1, c.value = "", l.value = !1);
    }), At(() => {
      o.isOpenByDefault && (i.value = !0, rt(() => {
        var G;
        return (G = M.value) == null ? void 0 : G.focus();
      }));
    }), Me(c, () => {
      c.value.length > 0 && (i.value = !0);
    }), Me(i, (G) => {
      G && s("init");
    }), (G, z) => {
      const oe = k5("tooltip");
      return f(), U(c2, {
        label: e.label,
        "label-position": e.labelPosition,
        appearance: k(d).length > 0 && k(h) || e.disabled ? "no-border" : e.appearance,
        "helper-text": e.helperText,
        "optional-label-text": e.optionalLabelText,
        "html-for": e.htmlFor,
        "validation-error": e.validationError,
        required: e.required,
        prefix: e.prefix,
        "highlight-label": e.highlightLabel !== void 0 ? e.highlightLabel : !e.disabled && (l.value || i.value),
        tooltip: e.tooltip,
        "help-link": e.helpLink,
        style: {
          "--sca-label-align": "start",
          "--sca-input-field-wrapper-padding": "0px",
          position: "relative"
        },
        focused: Y.value,
        onMouseenter: z[6] || (z[6] = (q) => l.value = !0),
        onMouseleave: z[7] || (z[7] = (q) => l.value = !1),
        onBlur: I
      }, {
        labelAction: ee(() => [
          ve(G.$slots, "labelAction")
        ]),
        default: ee(() => [
          g("div", {
            ref_key: "contentRef",
            ref: n,
            class: S([
              G.$style.content,
              !e.disabled && !e.validationError && l.value && G.$style.hovered,
              !e.validationError && Y.value && G.$style.contentHasFocus
            ]),
            tabindex: A.value ? -1 : 0,
            onClick: R,
            onKeydown: ce,
            onFocusin: le,
            onFocusout: ge,
            onPointerdown: z[5] || (z[5] = //@ts-ignore
            (...q) => k(E) && k(E)(...q))
          }, [
            g("div", {
              class: S(G.$style.tags)
            }, [
              g("div", {
                class: S(G.$style.tagsContainer)
              }, [
                (f(!0), v(we, null, Ze(k(d), (q, ne) => {
                  var Fe, We, Qe;
                  return Et((f(), U(Pn, {
                    key: k(C)(q, ne),
                    tabindex: "-1",
                    removable: !e.disabled && !e.readonly && !q.disabled,
                    disabled: q.disabled,
                    selected: q.selected,
                    avatar: (Fe = q.id) != null && Fe.toString().includes("@") ? void 0 : q.avatar,
                    icon: q.iconFramed ? void 0 : q.icon,
                    "icon-size": q.iconSize,
                    "icon-color": q.iconColor,
                    onRemove: (nt) => k(b)(ne)
                  }, sn({
                    default: ee(() => [
                      Ve(" " + se(q.label), 1)
                    ]),
                    _: 2
                  }, [
                    (We = q.id) != null && We.toString().includes("@") ? {
                      name: "iconLeft",
                      fn: ee(() => [
                        g("div", {
                          class: S(G.$style.emailIconWrapper)
                        }, [
                          de(Ae, {
                            icon: "phosphor/user",
                            size: "12px"
                          })
                        ], 2)
                      ]),
                      key: "0"
                    } : q.iconFramed ? {
                      name: "iconLeft",
                      fn: ee(() => [
                        g("div", {
                          class: S(G.$style.iconFrame)
                        }, [
                          q.icon ? (f(), U(Ae, {
                            key: 0,
                            icon: q.icon,
                            size: "12px",
                            color: q.iconColor
                          }, null, 8, ["icon", "color"])) : $("", !0)
                        ], 2)
                      ]),
                      key: "1"
                    } : void 0
                  ]), 1032, ["removable", "disabled", "selected", "avatar", "icon", "icon-size", "icon-color", "onRemove"])), [
                    [oe, e.showTooltip && !((Qe = q.id) != null && Qe.toString().includes("@")) ? q.id : null]
                  ]);
                }), 128)),
                g("div", {
                  class: S([G.$style.searchInputWrapper, { [G.$style.hidden]: !k(p) }])
                }, [
                  !e.readonly && !e.disabled ? Et((f(), v("input", {
                    key: 0,
                    id: e.htmlFor,
                    ref: "searchInputRef",
                    "onUpdate:modelValue": z[0] || (z[0] = (q) => Tn(c) ? c.value = q : null),
                    placeholder: k(d).length === 0 ? e.placeholder : "",
                    class: S([G.$style.searchInput, k(d).length > 0 && G.$style.hasTags]),
                    autocomplete: "new-password",
                    onBlur: I
                  }, null, 42, kge)), [
                    [xn, k(c)]
                  ]) : $("", !0),
                  g("span", {
                    class: S(G.$style.inputSizer),
                    "aria-hidden": "true"
                  }, se(k(c)), 3)
                ], 2)
              ], 2)
            ], 2),
            g("div", {
              class: S(G.$style.dropdownAnchor)
            }, [
              e.loading ? (f(), U(i1, {
                key: 0,
                class: S(G.$style.loader),
                size: "small",
                indeterminate: ""
              }, null, 8, ["class"])) : $("", !0),
              de(zt, {
                ref: k(x),
                "is-open": i.value,
                "onUpdate:isOpen": z[4] || (z[4] = (q) => i.value = q),
                "padding-upset": !0,
                "offset-y": 2,
                "match-trigger-width": "min"
              }, {
                trigger: ee(() => [...z[8] || (z[8] = [
                  g("div", null, null, -1)
                ])]),
                default: ee(() => [
                  g("div", {
                    class: S(G.$style.searchResultsFrame)
                  }, [
                    g("div", {
                      ref_key: "searchResultsInfiniteRef",
                      ref: u,
                      class: S(G.$style.searchResults),
                      onScroll: z[3] || (z[3] = //@ts-ignore
                      (...q) => k(_) && k(_)(...q))
                    }, [
                      (f(!0), v(we, null, Ze(k(y), (q, ne) => {
                        var Fe, We, Qe, nt, ut, V;
                        return f(), v("div", {
                          key: k(C)(q, ne),
                          class: S([e.resultsAsTags && G.$style.tagRow, k(O)(ne) && G.$style.resultHighlighted]),
                          style: Ge(q.level ? { paddingLeft: `${q.level * 16}px` } : void 0)
                        }, [
                          e.resultsAsTags ? (f(), U(Pn, {
                            key: 0,
                            avatar: q.avatar,
                            icon: q.iconFramed ? void 0 : q.icon,
                            "icon-color": q.iconColor,
                            selected: k(m)(q),
                            onMousedown: xe((Q) => P(q), ["prevent"]),
                            onClick: z[1] || (z[1] = xe(() => {
                            }, ["prevent"]))
                          }, sn({
                            default: ee(() => [
                              k(c) ? (f(), U(fl, {
                                key: 0,
                                text: q.label,
                                "search-term": k(c)
                              }, null, 8, ["text", "search-term"])) : (f(), v(we, { key: 1 }, [
                                Ve(se(q.label), 1)
                              ], 64))
                            ]),
                            _: 2
                          }, [
                            q.iconFramed && q.icon ? {
                              name: "iconLeft",
                              fn: ee(() => [
                                g("div", {
                                  class: S(G.$style.iconFrame)
                                }, [
                                  de(Ae, {
                                    icon: q.icon,
                                    size: "12px",
                                    color: q.iconColor
                                  }, null, 8, ["icon", "color"])
                                ], 2)
                              ]),
                              key: "0"
                            } : void 0
                          ]), 1032, ["avatar", "icon", "icon-color", "selected", "onMousedown"])) : (f(), v("div", {
                            key: 1,
                            id: k(C)(q, ne),
                            class: S(G.$style.itemContainer),
                            onMousedown: xe((Q) => P(q), ["prevent"]),
                            onClick: z[2] || (z[2] = xe(() => {
                            }, ["prevent"]))
                          }, [
                            q.avatar ? (f(), U(oi, {
                              key: 0,
                              size: "xsmall",
                              initials: (Fe = q.avatar) == null ? void 0 : Fe.initials,
                              shape: (We = q.avatar) == null ? void 0 : We.shape,
                              appearance: (Qe = q.avatar) == null ? void 0 : Qe.appearance,
                              emphasis: (nt = q.avatar) == null ? void 0 : nt.emphasis,
                              bordered: !!((ut = q.avatar) != null && ut.image),
                              "color-idx": (V = q.avatar) == null ? void 0 : V.colorIdx,
                              "use-hover-colors": !0
                            }, {
                              default: ee(() => {
                                var Q, ye;
                                return [
                                  (Q = q.avatar) != null && Q.image ? (f(), v("img", {
                                    key: 0,
                                    src: (ye = q.avatar) == null ? void 0 : ye.image,
                                    loading: "lazy",
                                    alt: "avatar"
                                  }, null, 8, Vge)) : $("", !0)
                                ];
                              }),
                              _: 2
                            }, 1032, ["initials", "shape", "appearance", "emphasis", "bordered", "color-idx"])) : $("", !0),
                            g("div", {
                              class: S(G.$style.itemContent)
                            }, [
                              de(fl, {
                                text: q.label,
                                "search-term": k(c)
                              }, null, 8, ["text", "search-term"])
                            ], 2),
                            q.label.length > 30 ? (f(), U(bo, {
                              key: 1,
                              id: k(C)(q, ne),
                              text: q.label
                            }, null, 8, ["id", "text"])) : $("", !0)
                          ], 42, Hge))
                        ], 6);
                      }), 128)),
                      e.searchResults.length === 0 && k(c).length >= o.minSearchLength ? (f(), U(tr, {
                        key: 0,
                        loading: o.loading
                      }, null, 8, ["loading"])) : $("", !0)
                    ], 34)
                  ], 2)
                ]),
                _: 1
              }, 8, ["is-open"])
            ], 2)
          ], 42, Dge),
          e.showArrow && l.value && !e.disabled ? (f(), U(Ae, {
            key: 0,
            icon: i.value ? "phosphor/caret-up" : "phosphor/caret-down",
            class: S(G.$style.arrowIcon),
            size: "12px"
          }, null, 8, ["icon", "class"])) : $("", !0)
        ]),
        _: 3
      }, 8, ["label", "label-position", "appearance", "helper-text", "optional-label-text", "html-for", "validation-error", "required", "prefix", "highlight-label", "tooltip", "help-link", "focused"]);
    };
  }
}), Bge = "_content_1dvvl_1", $ge = "_hovered_1dvvl_12", Zge = "_disabled_1dvvl_28", Gge = "_tags_1dvvl_33", Nge = "_dropdownAnchor_1dvvl_39", zge = "_searchResultsFrame_1dvvl_49", jge = "_searchResults_1dvvl_49", Wge = "_tagsContainer_1dvvl_71", Uge = "_tagRow_1dvvl_79", Kge = "_itemContainer_1dvvl_89", qge = "_resultHighlighted_1dvvl_103", Yge = "_searchInputWrapper_1dvvl_116", Qge = "_searchInput_1dvvl_116", Jge = "_hasTags_1dvvl_147", Xge = "_inputSizer_1dvvl_166", epe = "_itemContent_1dvvl_181", tpe = "_iconFrame_1dvvl_187", ope = "_emailIconWrapper_1dvvl_199", npe = "_contentHasFocus_1dvvl_217", spe = "_hidden_1dvvl_221", ipe = "_arrowIcon_1dvvl_225", rpe = {
  content: Bge,
  hovered: $ge,
  disabled: Zge,
  tags: Gge,
  dropdownAnchor: Nge,
  searchResultsFrame: zge,
  searchResults: jge,
  tagsContainer: Wge,
  tagRow: Uge,
  itemContainer: Kge,
  resultHighlighted: qge,
  searchInputWrapper: Yge,
  searchInput: Qge,
  hasTags: Jge,
  inputSizer: Xge,
  itemContent: epe,
  iconFrame: tpe,
  emailIconWrapper: ope,
  contentHasFocus: npe,
  hidden: spe,
  arrowIcon: ipe
}, lpe = {
  $style: rpe
}, yst = /* @__PURE__ */ Ce(Oge, [["__cssModules", lpe]]), ape = /* @__PURE__ */ pe({
  __name: "SCAInlineMessage",
  props: {
    type: { default: "informative" },
    title: {}
  },
  setup(e) {
    const t = e, o = Qt(), n = F(() => {
      switch (t.type) {
        case "informative":
          return "tetrisly/info-fill";
        case "success":
          return "tetrisly/check-circle-fill";
        case "warning":
          return "tetrisly/warning-fill";
        case "error":
          return "tetrisly/alert-fill";
        default:
          return "tetrisly/info-circle";
      }
    });
    return (s, i) => (f(), v("div", {
      class: S([
        s.$style.root,
        {
          [s.$style.typeInformative]: e.type === "informative",
          [s.$style.typeSuccess]: e.type === "success",
          [s.$style.typeWarning]: e.type === "warning",
          [s.$style.typeError]: e.type === "error"
        }
      ])
    }, [
      de(Ae, {
        class: S(s.$style.icon),
        icon: n.value
      }, null, 8, ["class", "icon"]),
      g("div", null, [
        e.title ? (f(), v("span", {
          key: 0,
          class: S([s.$style.title, { [s.$style.defaultSlot]: k(o).default }])
        }, se(e.title), 3)) : $("", !0),
        ve(s.$slots, "default")
      ])
    ], 2));
  }
}), cpe = "_root_mde6q_747", dpe = "_icon_mde6q_762", upe = "_title_mde6q_768", hpe = "_defaultSlot_mde6q_768", gpe = "_typeInformative_mde6q_771", ppe = "_typeSuccess_mde6q_778", fpe = "_typeWarning_mde6q_784", vpe = "_typeError_mde6q_790", mpe = {
  root: cpe,
  icon: dpe,
  title: upe,
  defaultSlot: hpe,
  typeInformative: gpe,
  typeSuccess: ppe,
  typeWarning: fpe,
  typeError: vpe
}, Cpe = {
  $style: mpe
}, wpe = /* @__PURE__ */ Ce(ape, [["__cssModules", Cpe]]), bpe = ["value", "readonly"], ype = /* @__PURE__ */ pe({
  __name: "SCARichTextPlain",
  props: /* @__PURE__ */ Ct({
    readOnly: { type: Boolean, default: !1 },
    resizable: { type: Boolean, default: !1 },
    minHeight: {},
    maxHeight: { default: void 0 }
  }, {
    modelValue: { required: !1 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, { t: o } = Go(), n = ct(e, "modelValue"), s = F(() => ({
      minHeight: `${t.minHeight}px`,
      ...t.maxHeight === void 0 ? {} : { maxHeight: `${t.maxHeight}px` }
    })), i = (r) => {
      n.value = r.target.value;
    };
    return (r, l) => (f(), v("div", {
      class: S(r.$style.container),
      style: Ge(s.value)
    }, [
      de(wpe, {
        class: S(r.$style.notice),
        type: "warning",
        title: k(o)("richText.plainFallbackNotice")
      }, null, 8, ["class", "title"]),
      g("textarea", {
        class: S([r.$style.plain, e.resizable ? r.$style.resizable : ""]),
        value: n.value ?? "",
        readonly: t.readOnly,
        spellcheck: "false",
        "test-id": "rich-text-plain-fallback",
        onInput: i
      }, null, 42, bpe)
    ], 6));
  }
}), _pe = "_container_8m4hg_1", Spe = "_notice_8m4hg_7", xpe = "_plain_8m4hg_11", Mpe = "_resizable_8m4hg_30", Ape = {
  container: _pe,
  notice: Spe,
  plain: xpe,
  resizable: Mpe
}, Lpe = {
  $style: Ape
}, Epe = /* @__PURE__ */ Ce(ype, [["__cssModules", Lpe]]);
var Ppe = [
  "onActivate",
  "onAddUndo",
  "onBeforeAddUndo",
  "onBeforeExecCommand",
  "onBeforeGetContent",
  "onBeforeRenderUI",
  "onBeforeSetContent",
  "onBeforePaste",
  "onBlur",
  "onChange",
  "onClearUndos",
  "onClick",
  "onContextMenu",
  "onCommentChange",
  "onCompositionEnd",
  "onCompositionStart",
  "onCompositionUpdate",
  "onCopy",
  "onCut",
  "onDblclick",
  "onDeactivate",
  "onDirty",
  "onDrag",
  "onDragDrop",
  "onDragEnd",
  "onDragGesture",
  "onDragOver",
  "onDrop",
  "onExecCommand",
  "onFocus",
  "onFocusIn",
  "onFocusOut",
  "onGetContent",
  "onHide",
  "onInit",
  "onInput",
  "onKeyDown",
  "onKeyPress",
  "onKeyUp",
  "onLoadContent",
  "onMouseDown",
  "onMouseEnter",
  "onMouseLeave",
  "onMouseMove",
  "onMouseOut",
  "onMouseOver",
  "onMouseUp",
  "onNodeChange",
  "onObjectResizeStart",
  "onObjectResized",
  "onObjectSelected",
  "onPaste",
  "onPostProcess",
  "onPostRender",
  "onPreProcess",
  "onProgressState",
  "onRedo",
  "onRemove",
  "onReset",
  "onSaveContent",
  "onSelectionChange",
  "onSetAttrib",
  "onSetContent",
  "onShow",
  "onSubmit",
  "onUndo",
  "onVisualAid"
], Rpe = function(e) {
  return Ppe.map(function(t) {
    return t.toLowerCase();
  }).indexOf(e.toLowerCase()) !== -1;
}, Fpe = function(e, t, o) {
  Object.keys(t).filter(Rpe).forEach(function(n) {
    var s = t[n];
    typeof s == "function" && (n === "onInit" ? s(e, o) : o.on(n.substring(2), function(i) {
      return s(i, o);
    }));
  });
}, Tpe = function(e, t, o, n) {
  var s = e.modelEvents ? e.modelEvents : null, i = Array.isArray(s) ? s.join(" ") : s;
  Me(n, function(r, l) {
    o && typeof r == "string" && r !== l && r !== o.getContent({ format: e.outputFormat }) && o.setContent(r);
  }), o.on(i || "change input undo redo", function() {
    t.emit("update:modelValue", o.getContent({ format: e.outputFormat }));
  });
}, Ipe = function(e, t, o, n, s, i) {
  n.setContent(i()), o.attrs["onUpdate:modelValue"] && Tpe(t, o, n, s), Fpe(e, o.attrs, n);
}, pd = 0, qC = function(e) {
  var t = Date.now(), o = Math.floor(Math.random() * 1e9);
  return pd++, e + "_" + o + pd + String(t);
}, Dpe = function(e) {
  return e !== null && e.tagName.toLowerCase() === "textarea";
}, fd = function(e) {
  return typeof e > "u" || e === "" ? [] : Array.isArray(e) ? e : e.split(" ");
}, kpe = function(e, t) {
  return fd(e).concat(fd(t));
}, Hpe = function(e) {
  return e == null;
}, vd = function() {
  return {
    listeners: [],
    scriptId: qC("tiny-script"),
    scriptLoaded: !1
  };
}, Vpe = function() {
  var e = vd(), t = function(s, i, r, l) {
    var a = i.createElement("script");
    a.referrerPolicy = "origin", a.type = "application/javascript", a.id = s, a.src = r;
    var c = function() {
      a.removeEventListener("load", c), l();
    };
    a.addEventListener("load", c), i.head && i.head.appendChild(a);
  }, o = function(s, i, r) {
    e.scriptLoaded ? r() : (e.listeners.push(r), s.getElementById(e.scriptId) || t(e.scriptId, s, i, function() {
      e.listeners.forEach(function(l) {
        return l();
      }), e.scriptLoaded = !0;
    }));
  }, n = function() {
    e = vd();
  };
  return {
    load: o,
    reinitialize: n
  };
}, Ope = Vpe(), Bpe = function() {
  return typeof window < "u" ? window : global;
}, Cs = function() {
  var e = Bpe();
  return e && e.tinymce ? e.tinymce : null;
}, $pe = {
  apiKey: String,
  licenseKey: String,
  cloudChannel: String,
  id: String,
  init: Object,
  initialValue: String,
  inline: Boolean,
  modelEvents: [String, Array],
  plugins: [String, Array],
  tagName: String,
  toolbar: [String, Array],
  modelValue: String,
  disabled: Boolean,
  tinymceScriptSrc: String,
  outputFormat: {
    type: String,
    validator: function(e) {
      return e === "html" || e === "text";
    }
  }
}, Yo = function() {
  return Yo = Object.assign || function(e) {
    for (var t, o = 1, n = arguments.length; o < n; o++) {
      t = arguments[o];
      for (var s in t) Object.prototype.hasOwnProperty.call(t, s) && (e[s] = t[s]);
    }
    return e;
  }, Yo.apply(this, arguments);
}, Zpe = function(e, t, o, n) {
  return e(n || "div", {
    id: t,
    ref: o
  });
}, Gpe = function(e, t, o) {
  return e("textarea", {
    id: t,
    visibility: "hidden",
    ref: o
  });
}, Na = { selector: void 0, target: void 0 }, Npe = pe({
  props: $pe,
  setup: function(e, t) {
    var o = e.init ? Yo(Yo({}, e.init), Na) : Yo({}, Na), n = d7(e), s = n.disabled, i = n.modelValue, r = n.tagName, l = W(null), a = null, c = e.id || qC("tiny-vue"), d = e.init && e.init.inline || e.inline, u = !!t.attrs["onUpdate:modelValue"], h = !0, p = e.initialValue ? e.initialValue : "", C = "", m = function(b) {
      return u ? function() {
        return i != null && i.value ? i.value : "";
      } : function() {
        return b ? p : C;
      };
    }, w = function() {
      var b = m(h), _ = Yo(Yo({}, o), { readonly: e.disabled, target: l.value, plugins: kpe(o.plugins, e.plugins), toolbar: e.toolbar || o.toolbar, inline: d, license_key: e.licenseKey, setup: function(M) {
        a = M, M.on("init", function(x) {
          return Ipe(x, e, t, M, i, b);
        }), typeof o.setup == "function" && o.setup(M);
      } });
      Dpe(l.value) && (l.value.style.visibility = ""), Cs().init(_), h = !1;
    };
    Me(s, function(b) {
      var _;
      a !== null && (typeof ((_ = a.mode) === null || _ === void 0 ? void 0 : _.set) == "function" ? a.mode.set(b ? "readonly" : "design") : a.setMode(b ? "readonly" : "design"));
    }), Me(r, function(b) {
      var _;
      u || (C = a.getContent()), (_ = Cs()) === null || _ === void 0 || _.remove(a), rt(function() {
        return w();
      });
    }), At(function() {
      if (Cs() !== null)
        w();
      else if (l.value && l.value.ownerDocument) {
        var b = e.cloudChannel ? e.cloudChannel : "7", _ = e.apiKey ? e.apiKey : "no-api-key", M = Hpe(e.tinymceScriptSrc) ? "https://cdn.tiny.cloud/1/".concat(_, "/tinymce/").concat(b, "/tinymce.min.js") : e.tinymceScriptSrc;
        Ope.load(l.value.ownerDocument, M, w);
      }
    }), ei(function() {
      Cs() !== null && Cs().remove(a);
    }), d || (nS(function() {
      h || w();
    }), sS(function() {
      var b;
      u || (C = a.getContent()), (b = Cs()) === null || b === void 0 || b.remove(a);
    }));
    var y = function(b) {
      var _;
      C = a.getContent(), (_ = Cs()) === null || _ === void 0 || _.remove(a), o = Yo(Yo(Yo({}, o), b), Na), rt(function() {
        return w();
      });
    };
    return t.expose({
      rerender: y,
      getEditor: function() {
        return a;
      }
    }), function() {
      return d ? Zpe(vo, c, l, e.tagName) : Gpe(vo, c, l);
    };
  }
});
const zpe = ":root{--color-coolGrey-m4: #1b242c;--color-coolGrey-m3: #272e35;--color-coolGrey-m2: #3a424a;--color-coolGrey-m1: #4a545e;--color-coolGrey-0: #555f6d;--color-coolGrey-p1: #7e8c9a;--color-coolGrey-p2: #9ea8b3;--color-coolGrey-p3: #cfd6dd;--color-coolGrey-p4: #dee3e7;--color-coolGrey-p5: #eaedf0;--color-coolGrey-p6: #f0f3f5;--color-coolGrey-p7: #f5f7f9;--color-coolGrey-p8: #fcfcfd;--color-coolGreyA-m4: #0a141ced;--color-coolGreyA-m3: #0a1219e0;--color-coolGreyA-m2: #1a232ddb;--color-coolGreyA-m1: #1d2936cc;--color-coolGreyA-0: #19273abd;--color-coolGreyA-p1: #1830488f;--color-coolGreyA-p2: #0d264066;--color-coolGreyA-p3: #10305433;--color-coolGreyA-p4: #04294421;--color-coolGreyA-p5: #10284817;--color-coolGreyA-p6: #022f520f;--color-coolGreyA-p7: #002b5e0a;--color-coolGreyA-p8: #1f529e05;--color-neutralGrey-m4: #222222;--color-neutralGrey-m3: #2d2d2d;--color-neutralGrey-m2: #404040;--color-neutralGrey-m1: #525252;--color-neutralGrey-0: #5e5e5e;--color-neutralGrey-p1: #898989;--color-neutralGrey-p2: #a6a6a6;--color-neutralGrey-p3: #d5d5d5;--color-neutralGrey-p4: #e2e2e2;--color-neutralGrey-p5: #ebebeb;--color-neutralGrey-p6: #f2f2f2;--color-neutralGrey-p7: #f7f7f7;--color-neutralGrey-p8: #fcfcfc;--color-neutralGreyA-m4: #111111ed;--color-neutralGreyA-m3: #101010e0;--color-neutralGreyA-m2: #212121db;--color-neutralGreyA-m1: #262626cc;--color-neutralGreyA-0: #252526bd;--color-neutralGreyA-p1: #2c2c2c8f;--color-neutralGreyA-p2: #20202066;--color-neutralGreyA-p3: #2e2e2e33;--color-neutralGreyA-p4: #1f1f1f21;--color-neutralGreyA-p5: #1c1c1c17;--color-neutralGreyA-p6: #2020200f;--color-neutralGreyA-p7: #2e2e2e0a;--color-neutralGreyA-p8: #52525205;--color-warmGrey-m4: #232321;--color-warmGrey-m3: #2f2f2b;--color-warmGrey-m2: #40403a;--color-warmGrey-m1: #52524c;--color-warmGrey-0: #5f5f58;--color-warmGrey-p1: #8b8b84;--color-warmGrey-p2: #a8a89f;--color-warmGrey-p3: #d8d8d2;--color-warmGrey-p4: #e4e4e0;--color-warmGrey-p5: #eaeae6;--color-warmGrey-p6: #f3f3f1;--color-warmGrey-p7: #f7f7f7;--color-warmGrey-p8: #fcfcfc;--color-warmGreyA-m4: #121210ed;--color-warmGreyA-m3: #13130ee0;--color-warmGreyA-m2: #21211adb;--color-warmGreyA-m1: #272720cc;--color-warmGreyA-0: #27271dbd;--color-warmGreyA-p1: #2f2f238f;--color-warmGreyA-p2: #26261066;--color-warmGreyA-p3: #3e3e1d33;--color-warmGreyA-p4: #32321421;--color-warmGreyA-p5: #22220217;--color-warmGreyA-p6: #2f2f0e0f;--color-warmGreyA-p7: #2f2f2c0a;--color-warmGreyA-p8: #52525205;--color-whiteA-m12: #ffffff05;--color-whiteA-m11: #ffffff08;--color-whiteA-m10: #ffffff0d;--color-whiteA-m9: #ffffff14;--color-whiteA-m8: #ffffff1a;--color-whiteA-m7: #ffffff1f;--color-whiteA-m6: #ffffff3d;--color-whiteA-m5: #ffffff66;--color-whiteA-m4: #ffffffa3;--color-whiteA-m3: #ffffffad;--color-whiteA-m2: #ffffffb8;--color-whiteA-m1: #ffffffd1;--color-whiteA-0: #ffffff;--color-transparent: #ffffff00;--color-red-m4: #4a0d0d;--color-red-m3: #6f2020;--color-red-m2: #952d2d;--color-red-m1: #a13636;--color-red-0: #c53434;--color-red-p1: #f26464;--color-red-p2: #f49090;--color-red-p3: #fccfcf;--color-red-p4: #fcd9d9;--color-red-p5: #fee6e6;--color-red-p6: #ffebeb;--color-red-p7: #fef5f5;--color-red-p8: #fffafa;--color-raspberry-m4: #450c1f;--color-raspberry-m3: #671e36;--color-raspberry-m2: #912b4d;--color-raspberry-m1: #9d3457;--color-raspberry-0: #c03060;--color-raspberry-p1: #e4628d;--color-raspberry-p2: #ec8dad;--color-raspberry-p3: #f8cedc;--color-raspberry-p4: #fbd5e2;--color-raspberry-p5: #fde3eb;--color-raspberry-p6: #fdedf2;--color-raspberry-p7: #fef5f8;--color-raspberry-p8: #fffafc;--color-magenta-m4: #410b2f;--color-magenta-m3: #671e4e;--color-magenta-m2: #892969;--color-magenta-m1: #953274;--color-magenta-0: #b12f86;--color-magenta-p1: #de5eb3;--color-magenta-p2: #ec89cb;--color-magenta-p3: #f7cae8;--color-magenta-p4: #fbd5ee;--color-magenta-p5: #fde3f4;--color-magenta-p6: #fdedf8;--color-magenta-p7: #fef5fb;--color-magenta-p8: #fffafd;--color-purple-m4: #410b2f;--color-purple-m3: #5b1e67;--color-purple-m2: #792989;--color-purple-m1: #853295;--color-purple-0: #9939ac;--color-purple-p1: #c466db;--color-purple-p2: #d98dec;--color-purple-p3: #f4caf7;--color-purple-p4: #f5d5fb;--color-purple-p5: #f8e3fd;--color-purple-p6: #faedfd;--color-purple-p7: #fdf5ff;--color-purple-p8: #fefaff;--color-grape-m4: #2e0e4e;--color-grape-m3: #4c2277;--color-grape-m2: #662f9d;--color-grape-m1: #7339ac;--color-grape-0: #8040bf;--color-grape-p1: #ad71ea;--color-grape-p2: #c494f4;--color-grape-p3: #e5d0fb;--color-grape-p4: #eddbff;--color-grape-p5: #f2e5ff;--color-grape-p6: #f6f0ff;--color-grape-p7: #faf5ff;--color-grape-p8: #fcfaff;--color-violet-m4: #1f1264;--color-violet-m3: #39288a;--color-violet-m2: #4e38bc;--color-violet-m1: #573fcf;--color-violet-0: #634eca;--color-violet-p1: #917ef1;--color-violet-p2: #aba2fb;--color-violet-p3: #dcd6ff;--color-violet-p4: #e3e0ff;--color-violet-p5: #eeebff;--color-violet-p6: #f3f0ff;--color-violet-p7: #f7f5ff;--color-violet-p8: #fbfaff;--color-blue-m4: #05205e;--color-blue-m3: #113997;--color-blue-m2: #1e50c0;--color-blue-m1: #2759cd;--color-blue-0: #3062d4;--color-blue-p1: #6792f4;--color-blue-p2: #8db0fb;--color-blue-p3: #cdddff;--color-blue-p4: #d7e4ff;--color-blue-p5: #e5eeff;--color-blue-p6: #edf2ff;--color-blue-p7: #f5f8ff;--color-blue-p8: #fafbff;--color-cyan-m4: #002742;--color-cyan-m3: #0c456e;--color-cyan-m2: #165b8d;--color-cyan-m1: #1b679d;--color-cyan-0: #0870ba;--color-cyan-p1: #5699dc;--color-cyan-p2: #79bcf6;--color-cyan-p3: #c2e3ff;--color-cyan-p4: #cce7ff;--color-cyan-p5: #e0f1ff;--color-cyan-p6: #ebf5ff;--color-cyan-p7: #f0f9ff;--color-cyan-p8: #fafdff;--color-teal-m4: #012a37;--color-teal-m3: #0a495c;--color-teal-m2: #196076;--color-teal-m1: #196c85;--color-teal-0: #077597;--color-teal-p1: #4f9eba;--color-teal-p2: #7ac0dc;--color-teal-p3: #b8e8f5;--color-teal-p4: #c5ecf7;--color-teal-p5: #e0f3fa;--color-teal-p6: #e8f7fc;--color-teal-p7: #f0fbff;--color-teal-p8: #fafeff;--color-aquamarine-m4: #012d26;--color-aquamarine-m3: #0d4a42;--color-aquamarine-m2: #15655a;--color-aquamarine-m1: #1a7061;--color-aquamarine-0: #097c69;--color-aquamarine-p1: #3da497;--color-aquamarine-p2: #6ec9bf;--color-aquamarine-p3: #bee9e4;--color-aquamarine-p4: #c5f2ec;--color-aquamarine-p5: #daf6f3;--color-aquamarine-p6: #e2f8f5;--color-aquamarine-p7: #f0faf9;--color-aquamarine-p8: #fbfefe;--color-green-m4: #062d1b;--color-green-m3: #0e4e30;--color-green-m2: #196742;--color-green-m1: #1e714a;--color-green-0: #1d7c4d;--color-green-p1: #4aa578;--color-green-p2: #75cc9e;--color-green-p3: #c2ebd5;--color-green-p4: #c6f1da;--color-green-p5: #d8f8e7;--color-green-p6: #e6f9ef;--color-green-p7: #f4fbf7;--color-green-p8: #fbfefc;--color-emerald-m4: #0a2e0b;--color-emerald-m3: #135315;--color-emerald-m2: #246626;--color-emerald-m1: #2f6f2f;--color-emerald-0: #347434;--color-emerald-p1: #55a555;--color-emerald-p2: #87c987;--color-emerald-p3: #c6ecc6;--color-emerald-p4: #cff2cf;--color-emerald-p5: #dff6df;--color-emerald-p6: #e6f9e6;--color-emerald-p7: #f4fbf4;--color-emerald-p8: #fbfefb;--color-orange-m4: #482909;--color-orange-m3: #7a4510;--color-orange-m2: #a05c1c;--color-orange-m1: #b4610e;--color-orange-0: #f59638;--color-orange-p1: #f6a351;--color-orange-p2: #feb872;--color-orange-p3: #ffd4a8;--color-orange-p4: #fcdec0;--color-orange-p5: #ffe8d1;--color-orange-p6: #fff0e0;--color-orange-p7: #fff5eb;--color-orange-p8: #fffcfa;--color-semantic-brand-m4: var(--color-blue-m4);--color-semantic-brand-m3: var(--color-blue-m3);--color-semantic-brand-m2: var(--color-blue-m2);--color-semantic-brand-m1: var(--color-blue-m1);--color-semantic-brand-0: var(--color-blue-0);--color-semantic-brand-p1: var(--color-blue-p1);--color-semantic-brand-p2: var(--color-blue-p2);--color-semantic-brand-p3: var(--color-blue-p3);--color-semantic-brand-p4: var(--color-blue-p4);--color-semantic-brand-p5: var(--color-blue-p5);--color-semantic-brand-p6: var(--color-blue-p6);--color-semantic-brand-p7: var(--color-blue-p7);--color-semantic-brand-p8: var(--color-blue-p8);--color-semantic-neutral-m4: var(--color-coolGrey-m4);--color-semantic-neutral-m3: var(--color-coolGrey-m3);--color-semantic-neutral-m2: var(--color-coolGrey-m2);--color-semantic-neutral-m1: var(--color-coolGrey-m1);--color-semantic-neutral-0: var(--color-coolGrey-0);--color-semantic-neutral-p1: var(--color-coolGrey-p1);--color-semantic-neutral-p2: var(--color-coolGrey-p2);--color-semantic-neutral-p3: var(--color-coolGrey-p3);--color-semantic-neutral-p4: var(--color-coolGrey-p4);--color-semantic-neutral-p5: var(--color-coolGrey-p5);--color-semantic-neutral-p6: var(--color-coolGrey-p6);--color-semantic-neutral-p7: var(--color-coolGrey-p7);--color-semantic-neutral-p8: var(--color-coolGrey-p8);--color-semantic-neutralA-m4: var(--color-coolGreyA-m4);--color-semantic-neutralA-m3: var(--color-coolGreyA-m3);--color-semantic-neutralA-m2: var(--color-coolGreyA-m2);--color-semantic-neutralA-m1: var(--color-coolGreyA-m1);--color-semantic-neutralA-0: var(--color-coolGreyA-0);--color-semantic-neutralA-p1: var(--color-coolGreyA-p1);--color-semantic-neutralA-p2: var(--color-coolGreyA-p2);--color-semantic-neutralA-p3: var(--color-coolGreyA-p3);--color-semantic-neutralA-p4: var(--color-coolGreyA-p4);--color-semantic-neutralA-p5: var(--color-coolGreyA-p5);--color-semantic-neutralA-p6: var(--color-coolGreyA-p6);--color-semantic-neutralA-p7: var(--color-coolGreyA-p7);--color-semantic-neutralA-p8: var(--color-coolGreyA-p8);--color-semantic-informative-m4: var(--color-blue-m4);--border-radius-25: 2px;--border-radius-50: 4px;--border-radius-100: 8px;--border-radius-999: 9999px;--color-semantic-informative-m3: var(--color-blue-m3);--color-semantic-informative-m2: var(--color-blue-m2);--color-semantic-informative-m1: var(--color-blue-m1);--color-semantic-informative-0: var(--color-blue-0);--color-semantic-informative-p1: var(--color-blue-p1);--color-semantic-informative-p2: var(--color-blue-p2);--color-semantic-informative-p3: var(--color-blue-p3);--color-semantic-informative-p4: var(--color-blue-p4);--color-semantic-informative-p5: var(--color-blue-p5);--color-semantic-informative-p6: var(--color-blue-p6);--color-semantic-informative-p7: var(--color-blue-p7);--color-semantic-informative-p8: var(--color-blue-p8);--color-semantic-positive-m4: var(--color-green-m4);--color-semantic-positive-m3: var(--color-green-m3);--color-semantic-positive-m2: var(--color-green-m2);--color-semantic-positive-m1: var(--color-green-m1);--color-semantic-positive-0: var(--color-green-0);--color-semantic-positive-p1: var(--color-green-p1);--color-semantic-positive-p2: var(--color-green-p2);--color-semantic-positive-p3: var(--color-green-p3);--color-semantic-positive-p4: var(--color-green-p4);--color-semantic-positive-p5: var(--color-green-p5);--color-semantic-positive-p6: var(--color-green-p6);--color-semantic-positive-p7: var(--color-green-p7);--color-semantic-positive-p8: var(--color-green-p8);--color-semantic-warning-m4: var(--color-orange-m4);--color-semantic-warning-m3: var(--color-orange-m3);--color-semantic-warning-m2: var(--color-orange-m2);--color-semantic-warning-m1: var(--color-orange-m1);--color-semantic-warning-0: var(--color-orange-0);--color-semantic-warning-p1: var(--color-orange-p1);--color-semantic-warning-p2: var(--color-orange-p2);--color-semantic-warning-p3: var(--color-orange-p3);--color-semantic-warning-p4: var(--color-orange-p4);--color-semantic-warning-p5: var(--color-orange-p5);--color-semantic-warning-p6: var(--color-orange-p6);--color-semantic-warning-p7: var(--color-orange-p7);--color-semantic-warning-p8: var(--color-orange-p8);--color-semantic-negative-m4: var(--color-red-m4);--color-semantic-negative-m3: var(--color-red-m3);--color-semantic-negative-m2: var(--color-red-m2);--color-semantic-negative-m1: var(--color-red-m1);--color-semantic-negative-0: var(--color-red-0);--color-semantic-negative-p1: var(--color-red-p1);--color-semantic-negative-p2: var(--color-red-p2);--color-semantic-negative-p3: var(--color-red-p3);--color-semantic-negative-p4: var(--color-red-p4);--color-semantic-negative-p5: var(--color-red-p5);--color-semantic-negative-p6: var(--color-red-p6);--color-semantic-negative-p7: var(--color-red-p7);--color-semantic-negative-p8: var(--color-red-p8);--color-content-primary: var(--color-semantic-neutral-m3);--color-content-secondary: var(--color-semantic-neutral-0);--color-content-tertiary: var(--color-semantic-neutral-p1);--color-content-disabled: var(--color-semantic-neutral-p2);--color-content-primary-inverted: var(--color-whiteA-0);--color-content-secondary-inverted: var(--color-whiteA-m4);--color-content-tertiary-inverted: var(--color-whiteA-m5);--color-content-disabled-inverted: var(--color-whiteA-m6);--color-content-informative-primary: var(--color-semantic-informative-m3);--color-content-informative-secondary: var(--color-semantic-informative-0);--color-content-positive-primary: var(--color-semantic-positive-m3);--color-content-positive-secondary: var(--color-semantic-positive-0);--color-content-warning-primary: var(--color-semantic-warning-m3);--color-content-warning-secondary: var(--color-semantic-warning-0);--color-content-negative-primary: var(--color-semantic-negative-m3);--color-content-negative-secondary: var(--color-semantic-negative-0);--color-content-brand-primary: var(--color-semantic-brand-m3);--color-content-brand-secondary: var(--color-semantic-brand-0);--color-border-default: var(--color-semantic-neutral-p5);--color-border-defaultA: var(--color-semantic-neutralA-p5);--color-border-inverted: var(--color-whiteA-0);--color-border-neutral-strong: var(--color-semantic-neutral-0);--color-border-neutral-subtle: var(--color-semantic-neutral-p3);--color-border-informative-strong: var(--color-semantic-informative-0);--color-border-informative-subtle: var(--color-semantic-informative-p3);--color-border-positive-strong: var(--color-semantic-positive-0);--color-border-positive-subtle: var(--color-semantic-positive-p3);--color-border-warning-strong: var(--color-semantic-warning-0);--color-border-warning-subtle: var(--color-semantic-warning-p3);--color-border-negative-strong: var(--color-semantic-negative-0);--color-border-negative-subtle: var(--color-semantic-negative-p3);--color-border-brand-strong: var(--color-semantic-brand-0);--color-border-brand-subtle: var(--color-semantic-brand-p3);--color-background-default: var(--color-whiteA-0);--color-background-inverted: var(--color-semantic-neutral-m3);--color-background-neutral-strong: var(--color-semantic-neutral-0);--color-background-neutral-muted: var(--color-semantic-neutral-p4);--color-background-neutral-onSubtle: var(--color-semantic-neutral-p5);--color-background-neutral-subtle: var(--color-semantic-neutral-p7);--color-background-neutral-surface: var(--color-semantic-neutral-p8);--color-background-informative-strong: var(--color-semantic-informative-0);--color-background-informative-muted: var(--color-semantic-informative-p4);--color-background-informative-onSubtle: var(--color-semantic-informative-p5);--color-background-informative-subtle: var(--color-semantic-informative-p7);--color-background-informative-surface: var(--color-semantic-informative-p8);--color-background-positive-strong: var(--color-semantic-positive-0);--color-background-positive-muted: var(--color-semantic-positive-p4);--color-background-positive-onSubtle: var(--color-semantic-positive-p5);--color-background-positive-subtle: var(--color-semantic-positive-p7);--color-background-positive-surface: var(--color-semantic-positive-p8);--color-background-warning-strong: var(--color-semantic-warning-0);--color-background-warning-muted: var(--color-semantic-warning-p4);--color-background-warning-onSubtle: var(--color-semantic-warning-p5);--color-background-warning-subtle: var(--color-semantic-warning-p7);--color-background-warning-surface: var(--color-semantic-warning-p8);--color-background-negative-strong: var(--color-semantic-negative-0);--color-background-negative-muted: var(--color-semantic-negative-p4);--color-background-negative-onSubtle: var(--color-semantic-negative-p5);--color-background-negative-subtle: var(--color-semantic-negative-p7);--color-background-negative-surface: var(--color-semantic-negative-p8);--color-background-brand-strong: var(--color-semantic-brand-0);--color-background-brand-muted: var(--color-semantic-brand-p4);--color-background-brand-onSubtle: var(--color-semantic-brand-p5);--color-background-brand-subtle: var(--color-semantic-brand-p7);--color-background-brand-surface: var(--color-semantic-brand-p8);--color-action-primary-normal: var(--color-semantic-brand-0);--color-action-primary-hover: var(--color-semantic-brand-m2);--color-action-primary-active: var(--color-semantic-brand-m3);--color-action-primary-selected: var(--color-semantic-brand-m2);--color-action-primary-subtle-normal: var(--color-semantic-brand-p6);--color-action-primary-subtle-hover: var(--color-semantic-brand-p5);--color-action-primary-subtle-active: var(--color-semantic-brand-p3);--color-action-primary-subtle-selected: var(--color-semantic-brand-p5);--color-action-neutral-normal: var(--color-semantic-neutral-m1);--color-action-neutral-hover: var(--color-semantic-neutral-m2);--color-action-neutral-active: var(--color-semantic-neutral-m3);--color-action-neutral-selected: var(--color-semantic-neutral-m2);--color-action-neutral-subtle-normal: var(--color-semantic-neutral-p6);--color-action-neutral-subtle-hover: var(--color-semantic-neutral-p5);--color-action-neutral-subtle-active: var(--color-semantic-neutral-p3);--color-action-neutral-subtle-selected: var(--color-semantic-neutral-p5);--color-action-success-normal: var(--color-semantic-positive-0);--color-action-success-hover: var(--color-semantic-positive-m2);--color-action-success-active: var(--color-semantic-positive-m3);--color-action-success-selected: var(--color-semantic-positive-m2);--color-action-success-subtle-normal: var(--color-semantic-positive-p6);--color-action-success-subtle-hover: var(--color-semantic-positive-p5);--color-action-success-subtle-active: var(--color-semantic-positive-p3);--color-action-success-subtle-selected: var(--color-semantic-positive-p5);--color-action-destructive-normal: var(--color-semantic-negative-0);--color-action-destructive-hover: var(--color-semantic-negative-m2);--color-action-destructive-active: var(--color-semantic-negative-m3);--color-action-destructive-selected: var(--color-semantic-negative-m2);--color-action-destructive-subtle-normal: var(--color-semantic-negative-p6);--color-action-destructive-subtle-hover: var(--color-semantic-negative-p5);--color-action-destructive-subtle-active: var(--color-semantic-negative-p3);--color-action-destructive-subtle-selected: var(--color-semantic-negative-p5);--color-action-ghost-normal: var(--color-transparent);--color-action-ghost-hover: var(--color-semantic-neutralA-p6);--color-action-ghost-active: var(--color-semantic-neutralA-p5);--color-action-ghost-selected: var(--color-semantic-neutralA-p6);--color-action-ghost-inverted-hover: var(--color-whiteA-m8);--color-action-ghost-inverted-active: var(--color-whiteA-m7);--color-action-ghost-inverted-selected: var(--color-whiteA-m8);--color-action-ghost-destructive-hover: var(--color-semantic-negative-p6);--color-action-ghost-destructive-active: var(--color-semantic-negative-p5);--color-action-ghost-destructive-selected: var(--color-semantic-negative-p6);--color-action-outline-normal: var(--color-semantic-neutral-p3);--color-action-outline-hover: var(--color-semantic-neutral-p2);--color-action-outline-active: var(--color-semantic-neutral-p1);--color-action-outline-selected: var(--color-semantic-neutral-p2);--color-action-inverted-normal: var(--color-whiteA-0);--color-action-inverted-hover: var(--color-whiteA-m1);--color-action-inverted-active: var(--color-whiteA-m2);--color-action-inverted-selected: var(--color-whiteA-m1);--color-action-reverseInverted-normal: var(--color-semantic-neutralA-m3);--color-action-reverseInverted-hover: var(--color-semantic-neutralA-m1);--color-action-reverseInverted-active: var(--color-semantic-neutralA-0);--color-action-reverseInverted-selected: var(--color-semantic-neutralA-m1);--color-interaction-default-normal: var(--color-blue-0);--color-interaction-default-hover: var(--color-blue-m2);--color-interaction-default-active: var(--color-blue-m3);--color-interaction-default-selected: var(--color-blue-m2);--color-interaction-default-subtle-normal: var(--color-blue-p6);--color-interaction-default-subtle-hover: var(--color-blue-p5);--color-interaction-default-subtle-active: var(--color-blue-p3);--color-interaction-default-subtle-selected: var(--color-blue-p5);--color-interaction-neutral-normal: var(--color-semantic-neutral-m1);--color-interaction-neutral-hover: var(--color-semantic-neutral-m2);--color-interaction-neutral-active: var(--color-semantic-neutral-m3);--color-interaction-neutral-selected: var(--color-semantic-neutral-m2);--color-interaction-neutral-subtle-normal: var(--color-semantic-neutral-p6);--color-interaction-neutral-subtle-hover: var(--color-semantic-neutral-p5);--color-interaction-neutral-subtle-active: var(--color-semantic-neutral-p3);--color-interaction-neutral-subtle-selected: var(--color-semantic-neutral-p5);--color-interaction-alert-normal: var(--color-semantic-negative-0);--color-interaction-alert-hover: var(--color-semantic-negative-m2);--color-interaction-alert-active: var(--color-semantic-negative-m3);--color-interaction-alert-selected: var(--color-semantic-negative-m2);--color-interaction-alert-subtle-normal: var(--color-semantic-negative-p6);--color-interaction-alert-subtle-hover: var(--color-semantic-negative-p5);--color-interaction-alert-subtle-active: var(--color-semantic-negative-p3);--color-interaction-alert-subtle-selected: var(--color-semantic-negative-p5);--color-interaction-ghost-normal: var(--color-transparent);--color-interaction-ghost-hover: var(--color-semantic-neutralA-p6);--color-interaction-ghost-active: var(--color-semantic-neutralA-p5);--color-interaction-ghost-selected: var(--color-semantic-neutralA-p6);--color-interaction-ghost-inverted-hover: var(--color-whiteA-m8);--color-interaction-ghost-inverted-normal: var(--color-whiteA-m7);--color-interaction-ghost-inverted-selected: var(--color-whiteA-m8);--color-interaction-ghost-destructive-selected: var(--color-semantic-negative-p6);--color-interaction-ghost-destructive-normal: var(--color-semantic-negative-p5);--color-interaction-ghost-destructive-hover: var(--color-semantic-negative-p6);--color-interaction-disabled-normal: var(--color-semantic-neutral-p2);--color-interaction-disabled-hover: var(--color-semantic-neutral-p1);--color-interaction-disabled-active: var(--color-semantic-neutral-0);--color-interaction-disabled-subtle-normal: var(--color-semantic-neutral-p5);--color-interaction-disabled-subtle-hover: var(--color-semantic-neutral-p4);--color-interaction-disabled-subtle-active: var(--color-semantic-neutral-p3);--color-interaction-border-normal: var(--color-blue-p2);--color-interaction-border-hover: var(--color-blue-p1);--color-interaction-border-active: var(--color-blue-m1);--color-interaction-border-selected: var(--color-blue-0);--color-interaction-border-neutral-normal: var(--color-semantic-neutral-p3);--color-interaction-border-neutral-hover: var(--color-semantic-neutral-p2);--color-interaction-border-neutral-active: var(--color-semantic-neutral-p1);--color-interaction-border-neutral-selected: var(--color-semantic-neutral-p2);--color-interaction-border-alert: var(--color-semantic-negative-p1);--color-interaction-background-modal: var(--color-background-default);--color-interaction-background-modeless: var(--color-background-default);--color-interaction-background-modeless-inverted: var(--color-background-inverted);--color-interaction-background-sidepanel: var(--color-background-default);--color-interaction-background-formField: var(--color-background-default);--color-interaction-background-dimmer: var(--color-semantic-neutralA-0);--color-interaction-inverted-normal: var(--color-whiteA-0);--color-interaction-inverted-hover: var(--color-whiteA-m1);--color-interaction-inverted-active: var(--color-whiteA-m2);--color-interaction-inverted-selected: var(--color-whiteA-m1);--color-interaction-focus-default: var(--color-blue-p1);--color-nonSemantic-grey-content-primary: var(--color-semantic-neutral-m3);--color-nonSemantic-grey-content-secondary: var(--color-semantic-neutral-0);--color-nonSemantic-grey-border-default: var(--color-semantic-neutral-p5);--color-nonSemantic-grey-border-strong: var(--color-semantic-neutral-0);--color-nonSemantic-grey-border-subtle: var(--color-semantic-neutral-p3);--color-nonSemantic-grey-background-strong: var(--color-semantic-neutral-0);--color-nonSemantic-grey-background-muted: var(--color-semantic-neutral-p4);--color-nonSemantic-grey-background-onSubtle: var(--color-semantic-neutral-p5);--color-nonSemantic-grey-background-subtle: var(--color-semantic-neutral-p7);--color-nonSemantic-grey-background-surface: var(--color-semantic-neutral-p8);--color-nonSemantic-white-content-primary: var(--color-whiteA-0);--color-nonSemantic-white-content-secondary: var(--color-whiteA-m4);--color-nonSemantic-white-border-default: var(--color-whiteA-m5);--color-nonSemantic-white-border-strong: var(--color-whiteA-0);--color-nonSemantic-white-border-subtle: var(--color-whiteA-m3);--color-nonSemantic-white-background-strong: var(--color-whiteA-0);--color-nonSemantic-white-background-muted: var(--color-whiteA-m4);--color-nonSemantic-white-background-onSubtle: var(--color-whiteA-m5);--color-nonSemantic-white-background-subtle: var(--color-whiteA-m7);--color-nonSemantic-white-background-surface: var(--color-whiteA-m8);--color-nonSemantic-red-content-primary: var(--color-red-m3);--color-nonSemantic-red-content-secondary: var(--color-red-0);--color-nonSemantic-red-border-default: var(--color-red-p5);--color-nonSemantic-red-border-strong: var(--color-red-0);--color-nonSemantic-red-border-subtle: var(--color-red-p3);--color-nonSemantic-red-background-strong: var(--color-red-0);--color-nonSemantic-red-background-muted: var(--color-red-p4);--color-nonSemantic-red-background-onSubtle: var(--color-red-p5);--color-nonSemantic-red-background-subtle: var(--color-red-p7);--color-nonSemantic-red-background-surface: var(--color-red-p8);--color-nonSemantic-raspberry-content-primary: var(--color-raspberry-m3);--color-nonSemantic-raspberry-content-secondary: var(--color-raspberry-0);--color-nonSemantic-raspberry-border-default: var(--color-raspberry-p5);--color-nonSemantic-raspberry-border-strong: var(--color-raspberry-0);--color-nonSemantic-raspberry-border-subtle: var(--color-raspberry-p3);--color-nonSemantic-raspberry-background-strong: var(--color-raspberry-0);--color-nonSemantic-raspberry-background-muted: var(--color-raspberry-p4);--color-nonSemantic-raspberry-background-onSubtle: var(--color-raspberry-p5);--color-nonSemantic-raspberry-background-subtle: var(--color-raspberry-p7);--color-nonSemantic-raspberry-background-surface: var(--color-raspberry-p8);--color-nonSemantic-magenta-content-primary: var(--color-magenta-m3);--color-nonSemantic-magenta-content-secondary: var(--color-magenta-0);--color-nonSemantic-magenta-border-default: var(--color-magenta-p5);--color-nonSemantic-magenta-border-strong: var(--color-magenta-0);--color-nonSemantic-magenta-border-subtle: var(--color-magenta-p3);--color-nonSemantic-magenta-background-strong: var(--color-magenta-0);--color-nonSemantic-magenta-background-muted: var(--color-magenta-p4);--color-nonSemantic-magenta-background-onSubtle: var(--color-magenta-p5);--color-nonSemantic-magenta-background-subtle: var(--color-magenta-p7);--color-nonSemantic-magenta-background-surface: var(--color-magenta-p8);--color-nonSemantic-purple-content-primary: var(--color-purple-m3);--color-nonSemantic-purple-content-secondary: var(--color-purple-0);--color-nonSemantic-purple-border-default: var(--color-purple-p5);--color-nonSemantic-purple-border-strong: var(--color-purple-0);--color-nonSemantic-purple-border-subtle: var(--color-purple-p3);--color-nonSemantic-purple-background-strong: var(--color-purple-0);--color-nonSemantic-purple-background-muted: var(--color-purple-p4);--color-nonSemantic-purple-background-onSubtle: var(--color-purple-p5);--color-nonSemantic-purple-background-subtle: var(--color-purple-p7);--color-nonSemantic-purple-background-surface: var(--color-purple-p8);--color-nonSemantic-grape-content-primary: var(--color-grape-m3);--color-nonSemantic-grape-content-secondary: var(--color-grape-0);--color-nonSemantic-grape-border-default: var(--color-grape-p5);--color-nonSemantic-grape-border-strong: var(--color-grape-0);--color-nonSemantic-grape-border-subtle: var(--color-grape-p3);--color-nonSemantic-grape-background-strong: var(--color-grape-0);--color-nonSemantic-grape-background-muted: var(--color-grape-p4);--color-nonSemantic-grape-background-onSubtle: var(--color-grape-p5);--color-nonSemantic-grape-background-subtle: var(--color-grape-p7);--color-nonSemantic-grape-background-surface: var(--color-grape-p8);--color-nonSemantic-violet-content-primary: var(--color-violet-m3);--color-nonSemantic-violet-content-secondary: var(--color-violet-0);--color-nonSemantic-violet-border-default: var(--color-violet-p5);--color-nonSemantic-violet-border-strong: var(--color-violet-0);--color-nonSemantic-violet-border-subtle: var(--color-violet-p3);--color-nonSemantic-violet-background-strong: var(--color-violet-0);--color-nonSemantic-violet-background-muted: var(--color-violet-p4);--color-nonSemantic-violet-background-onSubtle: var(--color-violet-p5);--color-nonSemantic-violet-background-subtle: var(--color-violet-p7);--color-nonSemantic-violet-background-surface: var(--color-violet-p8);--color-nonSemantic-blue-content-primary: var(--color-blue-m3);--color-nonSemantic-blue-content-secondary: var(--color-blue-0);--color-nonSemantic-blue-border-default: var(--color-blue-p5);--color-nonSemantic-blue-border-strong: var(--color-blue-0);--color-nonSemantic-blue-border-subtle: var(--color-blue-p3);--color-nonSemantic-blue-background-strong: var(--color-blue-0);--color-nonSemantic-blue-background-muted: var(--color-blue-p4);--color-nonSemantic-blue-background-onSubtle: var(--color-blue-p5);--color-nonSemantic-blue-background-subtle: var(--color-blue-p7);--color-nonSemantic-blue-background-surface: var(--color-blue-p8);--color-nonSemantic-cyan-content-primary: var(--color-cyan-m3);--color-nonSemantic-cyan-content-secondary: var(--color-cyan-0);--color-nonSemantic-cyan-border-default: var(--color-cyan-p5);--color-nonSemantic-cyan-border-strong: var(--color-cyan-0);--color-nonSemantic-cyan-border-subtle: var(--color-cyan-p3);--color-nonSemantic-cyan-background-strong: var(--color-cyan-0);--color-nonSemantic-cyan-background-muted: var(--color-cyan-p4);--color-nonSemantic-cyan-background-onSubtle: var(--color-cyan-p5);--color-nonSemantic-cyan-background-subtle: var(--color-cyan-p7);--color-nonSemantic-cyan-background-surface: var(--color-cyan-p8);--color-nonSemantic-teal-content-primary: var(--color-teal-m3);--color-nonSemantic-teal-content-secondary: var(--color-teal-0);--color-nonSemantic-teal-border-default: var(--color-teal-p5);--color-nonSemantic-teal-border-strong: var(--color-teal-0);--color-nonSemantic-teal-border-subtle: var(--color-teal-p3);--color-nonSemantic-teal-background-strong: var(--color-teal-0);--color-nonSemantic-teal-background-muted: var(--color-teal-p4);--color-nonSemantic-teal-background-onSubtle: var(--color-teal-p5);--color-nonSemantic-teal-background-subtle: var(--color-teal-p7);--color-nonSemantic-teal-background-surface: var(--color-teal-p8);--color-nonSemantic-aquamarine-content-primary: var(--color-aquamarine-m3);--color-nonSemantic-aquamarine-content-secondary: var(--color-aquamarine-0);--color-nonSemantic-aquamarine-border-default: var(--color-aquamarine-p5);--color-nonSemantic-aquamarine-border-strong: var(--color-aquamarine-0);--color-nonSemantic-aquamarine-border-subtle: var(--color-aquamarine-p3);--color-nonSemantic-aquamarine-background-strong: var(--color-aquamarine-0);--color-nonSemantic-aquamarine-background-muted: var(--color-aquamarine-p4);--color-nonSemantic-aquamarine-background-onSubtle: var(--color-aquamarine-p5);--color-nonSemantic-aquamarine-background-subtle: var(--color-aquamarine-p7);--color-nonSemantic-aquamarine-background-surface: var(--color-aquamarine-p8);--color-nonSemantic-green-content-primary: var(--color-green-m3);--color-nonSemantic-green-content-secondary: var(--color-green-0);--color-nonSemantic-green-border-default: var(--color-green-p5);--color-nonSemantic-green-border-strong: var(--color-green-0);--color-nonSemantic-green-border-subtle: var(--color-green-p3);--color-nonSemantic-green-background-strong: var(--color-green-0);--color-nonSemantic-green-background-muted: var(--color-green-p4);--color-nonSemantic-green-background-onSubtle: var(--color-green-p5);--color-nonSemantic-green-background-subtle: var(--color-green-p7);--color-nonSemantic-green-background-surface: var(--color-green-p8);--color-nonSemantic-emerald-content-primary: var(--color-emerald-m3);--color-nonSemantic-emerald-content-secondary: var(--color-emerald-0);--color-nonSemantic-emerald-border-default: var(--color-emerald-p5);--color-nonSemantic-emerald-border-strong: var(--color-emerald-0);--color-nonSemantic-emerald-border-subtle: var(--color-emerald-p3);--color-nonSemantic-emerald-background-strong: var(--color-emerald-0);--color-nonSemantic-emerald-background-muted: var(--color-emerald-p4);--color-nonSemantic-emerald-background-onSubtle: var(--color-emerald-p5);--color-nonSemantic-emerald-background-subtle: var(--color-emerald-p7);--color-nonSemantic-emerald-background-surface: var(--color-emerald-p8);--color-nonSemantic-orange-content-primary: var(--color-orange-m3);--color-nonSemantic-orange-content-secondary: var(--color-orange-0);--color-nonSemantic-orange-border-default: var(--color-orange-p5);--color-nonSemantic-orange-border-strong: var(--color-orange-0);--color-nonSemantic-orange-border-subtle: var(--color-orange-p3);--color-nonSemantic-orange-background-strong: var(--color-orange-0);--color-nonSemantic-orange-background-muted: var(--color-orange-p4);--color-nonSemantic-orange-background-onSubtle: var(--color-orange-p5);--color-nonSemantic-orange-background-subtle: var(--color-orange-p7);--color-nonSemantic-orange-background-surface: var(--color-orange-p8);--border-radius-small: var(--border-radius-25);--border-radius-medium: var(--border-radius-50);--border-radius-large: var(--border-radius-100);--space-component-padding-null: var(--dimension-0);--space-component-padding-xSmall: var(--dimension-50);--space-component-padding-small: var(--dimension-100);--space-component-padding-medium: var(--dimension-150);--space-component-padding-large: var(--dimension-200);--space-component-padding-2xLarge: var(--dimension-300);--space-component-gap-null: var(--dimension-0);--space-component-gap-2xSmall: var(--dimension-25);--space-component-gap-xSmall: var(--dimension-50);--space-component-gap-small: var(--dimension-100);--space-component-gap-medium: var(--dimension-150);--space-component-gap-large: var(--dimension-200);--space-component-gap-2xLarge: var(--dimension-400);--size-2xLarge: var(--dimension-800);--size-large: var(--dimension-600);--size-medium: var(--dimension-500);--size-small: var(--dimension-400);--size-xSmall: var(--dimension-300);--size-2xSmall: var(--dimension-250);--size-3xSmall: var(--dimension-200);--space-component-gap-xLarge: var(--dimension-250);--space-component-padding-3xLarge: var(--dimension-400);--space-component-padding-4xLarge: var(--dimension-500);--space-component-padding-6xLarge: var(--dimension-800);--space-component-padding-2xSmall: var(--dimension-25);--border-radius-full: var(--border-radius-999);--space-component-padding-xLarge: var(--dimension-250);--border-radius-150: 12px;--border-radius-xLarge: var(--border-radius-150);--dimension-0: 0px;--dimension-25: 2px;--dimension-50: 4px;--dimension-100: 8px;--dimension-150: 12px;--dimension-200: 16px;--dimension-250: 20px;--dimension-300: 24px;--dimension-350: 28px;--dimension-400: 32px;--dimension-500: 40px;--dimension-600: 48px;--dimension-700: 56px;--dimension-800: 64px;--dimension-1000: 80px;--dimension-1200: 96px;--dimension-1500: 120px;--dimension-1600: 128px;--dimension-550: 44px;--space-component-padding-5xLarge: var(--dimension-550);--space-component-gap-3xLarge: var(--dimension-550);--size-xLarge: var(--dimension-700);--dimension-900: 72px;--size-3xLarge: var(--dimension-900);--color-interaction-background-sidebarNav: var(--color-background-default);--color-interaction-background-topNav: var(--color-background-default)}html,body{font-family:Inter,sans-serif;font-weight:450;font-size:12px;line-height:16px;letter-spacing:.32px;text-decoration:none}a{cursor:pointer}", jpe = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="20-fifthbar">
<path id="Union" fill-rule="evenodd" clip-rule="evenodd" d="M4.5 3.75C4.5 3.05964 5.05964 2.5 5.75 2.5H10.5V6.75C10.5 7.16421 10.8358 7.5 11.25 7.5H15.5V9.25C15.5 9.66421 15.8358 10 16.25 10C16.6642 10 17 9.66421 17 9.25V6.75C17 6.55109 16.921 6.36032 16.7803 6.21967L11.7803 1.21967C11.6397 1.07902 11.4489 1 11.25 1H5.75C4.23122 1 3 2.23122 3 3.75V16.25C3 17.7688 4.23122 19 5.75 19H8.25C8.66421 19 9 18.6642 9 18.25C9 17.8358 8.66421 17.5 8.25 17.5H5.75C5.05964 17.5 4.5 16.9404 4.5 16.25V3.75ZM14.4393 6L12 3.56066V6H14.4393ZM11.5 14.5607L15.7197 18.7803C16.0126 19.0732 16.4874 19.0732 16.7803 18.7803C17.0732 18.4874 17.0732 18.0126 16.7803 17.7197L12.5607 13.5H15.25C15.6642 13.5 16 13.1642 16 12.75C16 12.3358 15.6642 12 15.25 12H10.75C10.3358 12 10 12.3358 10 12.75V17.25C10 17.6642 10.3358 18 10.75 18C11.1642 18 11.5 17.6642 11.5 17.25V14.5607Z" fill="#4A545E"/>
</g>
</svg>
`, Wpe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
  <path fill="#4A545E" d="m17.516 4.928-2.322-2.322A2.056 2.056 0 0 0 13.73 2H4.88A2.882 2.882 0 0 0 2 4.88v10.838a2.882 2.882 0 0 0 2.88 2.879h10.24a2.882 2.882 0 0 0 2.88-2.88v-9.62a1.64 1.64 0 0 0-.484-1.168Zm-5.761-1.424v2.67H6.159v-2.67h5.596ZM6.159 17.093v-5.525h7.723v5.525H6.159Zm10.337-1.375c0 .667-.479 1.225-1.11 1.349v-5.868c0-.626-.51-1.136-1.136-1.136H5.79c-.626 0-1.135.51-1.135 1.136v5.873a1.377 1.377 0 0 1-1.151-1.355V4.879c0-.681.5-1.247 1.15-1.355v3.02c0 .625.51 1.135 1.136 1.135h6.333c.626 0 1.136-.51 1.136-1.136V3.504h.471c.152 0 .294.06.4.165l2.322 2.322a.148.148 0 0 1 .043.106v9.62h.001Z"/>
</svg>
`, Upe = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="20-sidebar">
<path id="Union" fill-rule="evenodd" clip-rule="evenodd" d="M6.5 10C6.5 6.77834 8.77834 4.5 12 4.5C15.2217 4.5 17.5 6.77834 17.5 10C17.5 13.2217 15.2217 15.5 12 15.5C8.77834 15.5 6.5 13.2217 6.5 10ZM12 3C8.13401 3 5 6.13401 5 10C5 13.866 8.13401 17 12 17C15.866 17 19 13.866 19 10C19 6.13401 15.866 3 12 3ZM1 10.0256C1 6.7189 3.30992 3.95166 6.4042 3.24951V4.69511C4.04956 5.3176 2.5 7.37206 2.5 10.0256C2.5 12.6792 4.04956 14.6984 6.4042 15.3088V16.8018C3.30992 16.0996 1 13.3324 1 10.0256ZM7.94832 16.974L7.89351 16.9738H8.00314L7.94832 16.974Z" fill="#4A545E"/>
</g>
</svg>
`, Kpe = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8 8.18262V9.48242H4.75098V8.18262H8ZM8.7002 7.48242V4.2334C8.7002 3.84688 8.38649 3.53334 8 3.5332H4.75098C4.36438 3.5332 4.05078 3.8468 4.05078 4.2334V7.48242C4.05091 7.86891 4.36446 8.18262 4.75098 8.18262V9.48242L4.54688 9.47168C3.60539 9.37624 2.85728 8.62797 2.76172 7.68652L2.75098 7.48242V4.2334C2.75098 3.12883 3.64641 2.2334 4.75098 2.2334H8L8.2041 2.24414C9.21266 2.34651 10 3.19783 10 4.2334V7.48242L9.98926 7.68652C9.89371 8.6279 9.14548 9.37614 8.2041 9.47168L8 9.48242V8.18262C8.38641 8.18249 8.70006 7.86883 8.7002 7.48242Z" fill="#3D4145"/>
<path d="M7.19824 8.96436V13.6646H10V14.9644H6.54785C6.18895 14.9644 5.89759 14.6738 5.89746 14.3149V8.96436H7.19824Z" fill="#3D4145"/>
<path d="M15.4531 10.5283C15.5165 10.5348 15.5791 10.5444 15.6406 10.5566C15.6727 10.563 15.7039 10.5722 15.7354 10.5801C15.7667 10.5879 15.7984 10.5942 15.8291 10.6035C15.8618 10.6134 15.8938 10.6252 15.9258 10.6367C15.9523 10.6463 15.9789 10.6554 16.0049 10.666C16.0441 10.682 16.0822 10.7003 16.1201 10.7188C16.1361 10.7265 16.1522 10.734 16.168 10.7422C16.207 10.7625 16.2447 10.7849 16.2822 10.8076C16.2989 10.8177 16.3157 10.8274 16.332 10.8379C16.36 10.856 16.3871 10.8751 16.4141 10.8945C16.4424 10.9149 16.4708 10.9352 16.498 10.957C16.5174 10.9725 16.536 10.9887 16.5547 11.0049C16.5811 11.0276 16.6067 11.0511 16.6318 11.0752C16.6518 11.0943 16.6713 11.1138 16.6904 11.1338C16.7184 11.1629 16.7453 11.1929 16.7715 11.2236C16.7835 11.2377 16.795 11.2522 16.8066 11.2666C16.8322 11.2983 16.8563 11.331 16.8799 11.3643C16.8954 11.3862 16.9111 11.4081 16.9258 11.4307C16.9416 11.4551 16.9569 11.4798 16.9717 11.5049C16.9899 11.5358 17.0079 11.5667 17.0244 11.5986C17.0372 11.6232 17.0478 11.6487 17.0596 11.6738C17.0729 11.7023 17.0867 11.7306 17.0986 11.7598C17.1134 11.7956 17.126 11.8323 17.1387 11.8691C17.1465 11.8919 17.1551 11.9144 17.1621 11.9375C17.174 11.9767 17.1839 12.0165 17.1934 12.0566C17.1987 12.0793 17.2044 12.102 17.209 12.125C17.2343 12.252 17.249 12.3831 17.249 12.5176V15.7666L17.2383 15.9707C17.2318 16.0345 17.2213 16.0973 17.209 16.1592C17.2049 16.1796 17.199 16.1995 17.1943 16.2197C17.1852 16.2591 17.1765 16.2984 17.165 16.3369C17.158 16.3607 17.1495 16.3839 17.1416 16.4072C17.129 16.4444 17.1162 16.4814 17.1016 16.5176C17.0931 16.5384 17.0834 16.5586 17.0742 16.5791C17.0588 16.6138 17.0427 16.648 17.0254 16.6816C17.0139 16.7039 17.0025 16.7262 16.9902 16.748C16.9722 16.7801 16.9524 16.8109 16.9326 16.8418C16.9193 16.8627 16.9067 16.884 16.8926 16.9043C16.8747 16.9301 16.855 16.9546 16.8359 16.9795C16.8169 17.0044 16.7985 17.0297 16.7783 17.0537C16.7028 17.1433 16.6192 17.2256 16.5293 17.3008C16.5127 17.3146 16.4955 17.3275 16.4785 17.3408C16.4485 17.3643 16.4181 17.3874 16.3867 17.4092C16.3631 17.4256 16.3388 17.4407 16.3145 17.4561C16.2886 17.4724 16.2629 17.4888 16.2363 17.5039C16.2115 17.518 16.1866 17.5318 16.1611 17.5449C16.1294 17.5612 16.0971 17.5762 16.0645 17.5908C16.0416 17.6011 16.0185 17.6107 15.9951 17.6201C15.9632 17.633 15.9311 17.645 15.8984 17.6562C15.8709 17.6657 15.8435 17.6753 15.8154 17.6836C15.7791 17.6943 15.7422 17.7032 15.7051 17.7119C15.6837 17.7169 15.6623 17.7223 15.6406 17.7266C15.579 17.7388 15.5166 17.7494 15.4531 17.7559L15.249 17.7666H12C11.9311 17.7666 11.863 17.7627 11.7959 17.7559C11.7328 17.7495 11.6706 17.7397 11.6094 17.7275C11.5836 17.7224 11.5586 17.7151 11.5332 17.709C11.4994 17.7009 11.4657 17.6934 11.4326 17.6836C11.4046 17.6753 11.3771 17.6657 11.3496 17.6562C11.317 17.645 11.2848 17.633 11.2529 17.6201C11.2296 17.6107 11.2065 17.6011 11.1836 17.5908C11.1509 17.5762 11.1186 17.5612 11.0869 17.5449C11.0615 17.5318 11.0365 17.518 11.0117 17.5039C10.9851 17.4887 10.9594 17.4724 10.9336 17.4561C10.9093 17.4407 10.8849 17.4256 10.8613 17.4092C10.8299 17.3874 10.7996 17.3643 10.7695 17.3408C10.7529 17.3278 10.7359 17.3153 10.7197 17.3018C10.6275 17.2247 10.5419 17.1401 10.4648 17.0479C10.4527 17.0333 10.4415 17.0179 10.4297 17.0029C10.4028 16.9688 10.3762 16.9343 10.3516 16.8984C10.3404 16.8821 10.3301 16.8653 10.3193 16.8486C10.2981 16.8156 10.2772 16.7823 10.2578 16.748C10.2455 16.7262 10.2342 16.7039 10.2227 16.6816C10.2053 16.648 10.1893 16.6138 10.1738 16.5791C10.1647 16.5586 10.1549 16.5384 10.1465 16.5176C10.1318 16.4814 10.119 16.4444 10.1064 16.4072C10.0985 16.3839 10.0901 16.3607 10.083 16.3369C10.0716 16.2984 10.0628 16.2591 10.0537 16.2197C10.049 16.1995 10.0431 16.1796 10.0391 16.1592C10.0268 16.0974 10.0172 16.0344 10.0107 15.9707L10 15.7666V12.5176C10.0001 11.4131 10.8955 10.5176 12 10.5176H15.249L15.4531 10.5283ZM13.624 11.6426C13.4583 11.6426 13.2989 11.708 13.1816 11.8252C13.0646 11.9424 12.999 12.1019 12.999 12.2676V13.5176H11.749C11.5833 13.5176 11.4239 13.583 11.3066 13.7002C11.1896 13.8174 11.124 13.9769 11.124 14.1426C11.1242 14.308 11.1897 14.4669 11.3066 14.584C11.4239 14.7012 11.5833 14.7676 11.749 14.7676H12.999V16.0176C12.9992 16.183 13.0647 16.3419 13.1816 16.459C13.2989 16.5762 13.4583 16.6426 13.624 16.6426C13.7898 16.6426 13.9492 16.5762 14.0664 16.459C14.1833 16.3419 14.2489 16.183 14.249 16.0176V14.7676H15.499C15.6648 14.7676 15.8242 14.7012 15.9414 14.584C16.0583 14.4669 16.1239 14.308 16.124 14.1426C16.124 13.9769 16.0585 13.8174 15.9414 13.7002C15.8242 13.583 15.6648 13.5176 15.499 13.5176H14.249V12.2676C14.249 12.1019 14.1835 11.9424 14.0664 11.8252C13.9492 11.708 13.7898 11.6426 13.624 11.6426Z" fill="#3D4145"/>
</svg>
`, qpe = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.50001 13.077L25.1829 13.077M10 10.1053C10 10.3814 9.77614 10.6053 9.5 10.6053C9.22386 10.6053 9 10.3814 9 10.1053C9 9.82916 9.22386 9.6053 9.5 9.6053C9.77614 9.6053 10 9.82916 10 10.1053ZM13 10.1053C13 10.3814 12.7761 10.6053 12.5 10.6053C12.2239 10.6053 12 10.3814 12 10.1053C12 9.82916 12.2239 9.6053 12.5 9.6053C12.7761 9.6053 13 9.82916 13 10.1053ZM16 10.1053C16 10.3814 15.7761 10.6053 15.5 10.6053C15.2239 10.6053 15 10.3814 15 10.1053C15 9.82916 15.2239 9.6053 15.5 9.6053C15.7761 9.6053 16 9.82916 16 10.1053ZM22.5769 6.5L9.42308 6.5C7.80871 6.5 6.5 7.8087 6.5 9.42308L6.5 22.5769C6.5 24.1913 7.80871 25.5 9.42308 25.5L22.5769 25.5C24.1913 25.5 25.5 24.1913 25.5 22.5769L25.5 9.42308C25.5 7.80871 24.1913 6.5 22.5769 6.5Z" stroke="#4D4D4D" stroke-linecap="round"/>
</svg>
`, Ype = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.6753 6.87158V8.17139H10.4263V6.87158H13.6753ZM14.3755 6.17139V2.92236C14.3755 2.53585 14.0618 2.2223 13.6753 2.22217H10.4263C10.0397 2.22217 9.72607 2.53576 9.72607 2.92236V6.17139C9.72621 6.55787 10.0398 6.87158 10.4263 6.87158V8.17139L10.2222 8.16064C9.28069 8.06521 8.53257 7.31693 8.43701 6.37549L8.42627 6.17139V2.92236C8.42627 1.81779 9.3217 0.922363 10.4263 0.922363H13.6753L13.8794 0.933105C14.888 1.03548 15.6753 1.8868 15.6753 2.92236V6.17139L15.6646 6.37549C15.569 7.31687 14.8208 8.0651 13.8794 8.16064L13.6753 8.17139V6.87158C14.0617 6.87145 14.3754 6.55779 14.3755 6.17139Z" fill="#3D4145"/>
<path d="M13.8799 11.8394C13.9433 11.8458 14.0058 11.8554 14.0674 11.8677C14.071 11.8684 14.0746 11.8689 14.0781 11.8696L14.2461 11.9116C14.2491 11.9125 14.2519 11.9137 14.2549 11.9146C14.2836 11.9233 14.3116 11.9339 14.3398 11.9438C14.372 11.9552 14.4042 11.9661 14.4355 11.979C14.4658 11.9915 14.4949 12.0062 14.5244 12.02C14.5499 12.032 14.5757 12.0431 14.6006 12.0562C14.6271 12.07 14.6529 12.0851 14.6787 12.1001C14.7115 12.1192 14.7438 12.1388 14.7754 12.1597C14.7916 12.1704 14.8074 12.1817 14.8232 12.1929C14.8581 12.2174 14.8926 12.2424 14.9258 12.269C14.9434 12.2832 14.9604 12.2982 14.9775 12.313C15.008 12.3392 15.0376 12.3661 15.0664 12.394C15.0806 12.4078 15.0946 12.4218 15.1084 12.436C15.1385 12.4669 15.1673 12.4989 15.1953 12.5317C15.21 12.549 15.2241 12.5667 15.2383 12.5845C15.2624 12.6147 15.2853 12.6457 15.3076 12.6772C15.3204 12.6954 15.3335 12.7133 15.3457 12.7319C15.3681 12.766 15.3888 12.801 15.4092 12.8364C15.4209 12.8569 15.4333 12.877 15.4443 12.8979C15.4654 12.9378 15.4846 12.9786 15.5029 13.02C15.5087 13.0331 15.515 13.0459 15.5205 13.0591C15.5652 13.1661 15.6003 13.2776 15.626 13.3931C15.629 13.4068 15.633 13.4203 15.6357 13.4341C15.6613 13.5617 15.6758 13.6935 15.6758 13.8286V17.0776L15.665 17.2817C15.6587 17.3445 15.6488 17.4063 15.6367 17.4673C15.6325 17.4884 15.6259 17.5089 15.6211 17.5298C15.6113 17.5722 15.6014 17.6144 15.5889 17.6558C15.5842 17.6713 15.5783 17.6863 15.5732 17.7017C15.5581 17.7477 15.5418 17.7929 15.5234 17.8374C15.5177 17.8515 15.512 17.8655 15.5059 17.8794C15.4878 17.9206 15.468 17.9608 15.4473 18.0005C15.438 18.0182 15.4287 18.0358 15.4189 18.0532C15.3969 18.0926 15.3732 18.1308 15.3486 18.1685C15.3404 18.1811 15.3328 18.1941 15.3242 18.2065C15.3022 18.2387 15.2787 18.2696 15.2549 18.3003C15.2384 18.3216 15.2224 18.3432 15.2051 18.3638C15.1294 18.4536 15.0462 18.5365 14.9561 18.6118C14.9415 18.624 14.9261 18.6352 14.9111 18.647C14.877 18.6739 14.8425 18.7004 14.8066 18.7251C14.7903 18.7363 14.7735 18.7466 14.7568 18.7573C14.7238 18.7786 14.6906 18.7995 14.6562 18.8188C14.6344 18.8312 14.6121 18.8425 14.5898 18.854C14.5582 18.8703 14.5258 18.8852 14.4932 18.8999C14.4667 18.9118 14.4401 18.9233 14.4131 18.9341C14.387 18.9445 14.3606 18.9541 14.334 18.9634C14.3039 18.9739 14.2739 18.9846 14.2432 18.9937C14.2053 19.0049 14.1667 19.014 14.1279 19.0229C14.1077 19.0276 14.0878 19.0335 14.0674 19.0376C14.0058 19.0499 13.9434 19.0604 13.8799 19.0669L13.6758 19.0776H10.4268L10.2217 19.0669C10.2144 19.0662 10.2074 19.0638 10.2002 19.063C10.1448 19.0567 10.09 19.0493 10.0361 19.0386C10.0088 19.0332 9.98203 19.0256 9.95508 19.019C9.92396 19.0115 9.89284 19.0046 9.8623 18.9956C9.82988 18.9861 9.79832 18.9745 9.7666 18.9634C9.7394 18.9539 9.71219 18.9447 9.68555 18.9341C9.65716 18.9227 9.62929 18.9105 9.60156 18.8979C9.57485 18.8858 9.54853 18.8731 9.52246 18.8599C9.49109 18.8439 9.46008 18.8276 9.42969 18.8101C9.41143 18.7995 9.39387 18.7879 9.37598 18.7769C9.34405 18.7571 9.31195 18.7378 9.28125 18.7163C9.26123 18.7023 9.24213 18.6871 9.22266 18.6724C9.06773 18.5553 8.93053 18.4168 8.81543 18.2603C8.80702 18.2488 8.7982 18.2377 8.79004 18.2261C8.76771 18.1943 8.74705 18.1615 8.72656 18.1284C8.71419 18.1084 8.70211 18.0883 8.69043 18.0679C8.67482 18.0406 8.65985 18.013 8.64551 17.9849C8.63235 17.9591 8.61948 17.9331 8.60742 17.9067C8.59315 17.8755 8.57909 17.8441 8.56641 17.812C8.55662 17.7872 8.54787 17.7621 8.53906 17.7368C8.52812 17.7055 8.51722 17.6741 8.50781 17.6421C8.50055 17.6174 8.49558 17.592 8.48926 17.5669C8.44979 17.4101 8.42578 17.2467 8.42578 17.0776V13.8286C8.42586 13.2074 8.70961 12.6525 9.1543 12.2856C9.5 12.0004 9.94355 11.8286 10.4268 11.8286H13.6758L13.8799 11.8394ZM12.0508 12.9536C11.885 12.9536 11.7256 13.019 11.6084 13.1362C11.4912 13.2534 11.4258 13.4129 11.4258 13.5786V14.8286H10.1758C10.01 14.8286 9.85061 14.894 9.7334 15.0112C9.61619 15.1284 9.55078 15.2879 9.55078 15.4536C9.55091 15.6192 9.6163 15.7779 9.7334 15.895C9.85061 16.0122 10.01 16.0786 10.1758 16.0786H11.4258V17.3286C11.4259 17.4942 11.4913 17.6529 11.6084 17.77C11.7256 17.8872 11.885 17.9536 12.0508 17.9536C12.2164 17.9535 12.3751 17.8871 12.4922 17.77C12.6093 17.6529 12.6757 17.4942 12.6758 17.3286V16.0786H13.9258C14.0914 16.0785 14.2501 16.0121 14.3672 15.895C14.4843 15.7779 14.5507 15.6192 14.5508 15.4536C14.5508 15.2879 14.4844 15.1284 14.3672 15.0112C14.2501 14.8941 14.0914 14.8287 13.9258 14.8286H12.6758V13.5786C12.6758 13.4129 12.6094 13.2534 12.4922 13.1362C12.3751 13.0191 12.2164 12.9537 12.0508 12.9536Z" fill="#3D4145"/>
<path d="M9.26465 5.38989L5.62402 5.38989L5.62402 15.3499L9.26465 15.3499L9.26465 16.6497L4.97461 16.6497C4.61562 16.6497 4.32422 16.3583 4.32422 15.9993L4.32422 4.7395C4.32422 4.38052 4.61562 4.08911 4.97461 4.08911L9.26465 4.08911L9.26465 5.38989Z" fill="#3D4145"/>
</svg>
`, Qpe = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.5757 16.6637L11.5757 3.83074C11.5757 3.49038 11.7109 3.16397 11.9516 2.92331C12.1922 2.68264 12.5186 2.54744 12.859 2.54744L16.7089 2.54744C17.0492 2.54744 17.3757 2.68264 17.6163 2.92331C17.857 3.16397 17.9922 3.49038 17.9922 3.83074L17.9922 16.6637C17.9922 17.0041 17.857 17.3305 17.6163 17.5711C17.3757 17.8118 17.0492 17.947 16.7089 17.947H12.859C12.5186 17.947 12.1922 17.8118 11.9516 17.5711C11.7109 17.3305 11.5757 17.0041 11.5757 16.6637ZM16.7089 16.6637L16.7089 3.83074L12.859 3.83074L12.859 16.6637H16.7089ZM14.7839 15.3804C14.9743 15.3804 15.1604 15.324 15.3187 15.2182C15.4769 15.1125 15.6003 14.9621 15.6732 14.7863C15.746 14.6104 15.7651 14.4169 15.7279 14.2302C15.6908 14.0435 15.5991 13.872 15.4645 13.7374C15.3299 13.6028 15.1584 13.5111 14.9717 13.474C14.785 13.4368 14.5915 13.4559 14.4156 13.5287C14.2398 13.6016 14.0894 13.7249 13.9837 13.8832C13.8779 14.0415 13.8215 14.2276 13.8215 14.4179C13.8215 14.6732 13.9229 14.918 14.1034 15.0985C14.2839 15.279 14.5287 15.3804 14.7839 15.3804Z" fill="#4A545E"/>
<path d="M2.16636 15.5369L5.03493 3.02867C5.11101 2.69693 5.31576 2.409 5.60413 2.22822C5.8925 2.04744 6.24088 1.98862 6.57262 2.0647L10.3251 2.92527C10.6568 3.00135 10.9448 3.2061 11.1255 3.49447C11.3063 3.78284 11.3651 4.13122 11.2891 4.46296L8.42049 16.9712C8.34441 17.303 8.13967 17.5909 7.8513 17.7717C7.56292 17.9525 7.21455 18.0113 6.88281 17.9352L3.13033 17.0746C2.79859 16.9985 2.51066 16.7938 2.32988 16.5054C2.1491 16.217 2.09028 15.8687 2.16636 15.5369ZM7.16967 16.6844L10.0382 4.1761L6.28576 3.31553L3.41719 15.8238L7.16967 16.6844ZM5.58028 15.0033C5.76583 15.0458 5.95982 15.0324 6.13773 14.9647C6.31565 14.897 6.46949 14.778 6.5798 14.6229C6.69012 14.4678 6.75196 14.2834 6.75749 14.0931C6.76303 13.9028 6.71202 13.7152 6.61091 13.5539C6.5098 13.3926 6.36313 13.2649 6.18945 13.187C6.01578 13.1091 5.82289 13.0844 5.63519 13.1161C5.44749 13.1478 5.2734 13.2344 5.13494 13.3651C4.99647 13.4957 4.89986 13.6644 4.85731 13.85C4.80025 14.0988 4.84436 14.3601 4.97995 14.5764C5.11553 14.7926 5.33148 14.9462 5.58028 15.0033Z" fill="#4A545E"/>
</svg>
`, Jpe = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.1737 2.45313L5.03311 1.01563C4.77196 0.96967 4.50325 1.02932 4.28607 1.18145C4.06889 1.33358 3.92103 1.56574 3.87499 1.82688L2.01561 12.3894C1.99287 12.5188 1.99585 12.6514 2.02438 12.7796C2.05291 12.9079 2.10643 13.0292 2.18189 13.1368C2.25734 13.2443 2.35325 13.336 2.46414 13.4064C2.57502 13.4769 2.6987 13.5248 2.82811 13.5475L10.9687 14.985C11.0982 15.0078 11.2309 15.0049 11.3592 14.9764C11.4875 14.9479 11.6089 14.8944 11.7166 14.819C11.8242 14.7435 11.9159 14.6476 11.9864 14.5366C12.0569 14.4257 12.1048 14.302 12.1275 14.1725L13.9869 3.61C14.0324 3.34877 13.9723 3.08014 13.8199 2.86319C13.6674 2.64624 13.435 2.49874 13.1737 2.45313ZM11.1412 14L2.99999 12.5625L4.85936 2L13 3.4375L11.1412 14ZM5.58374 3.65125C5.6069 3.52073 5.68094 3.40475 5.78958 3.32881C5.89823 3.25286 6.03258 3.22317 6.16312 3.24625L11.3506 4.16188C11.4739 4.18347 11.5846 4.25052 11.6609 4.34978C11.7371 4.44904 11.7734 4.57329 11.7624 4.69797C11.7515 4.82266 11.6942 4.93872 11.6019 5.02322C11.5096 5.10773 11.3889 5.15453 11.2637 5.15438C11.2344 5.15434 11.2051 5.15183 11.1762 5.14688L5.98874 4.23063C5.85822 4.20747 5.74224 4.13342 5.6663 4.02478C5.59035 3.91614 5.56066 3.78178 5.58374 3.65125ZM5.23749 5.62125C5.24889 5.55657 5.27291 5.49476 5.3082 5.43937C5.34349 5.38398 5.38934 5.33608 5.44314 5.29841C5.49695 5.26074 5.55765 5.23404 5.62177 5.21984C5.68589 5.20563 5.75219 5.2042 5.81686 5.21563L11.0044 6.13188C11.1285 6.15264 11.2403 6.21947 11.3173 6.31902C11.3943 6.41857 11.431 6.54352 11.42 6.66891C11.4089 6.7943 11.351 6.91091 11.2577 6.99546C11.1645 7.08 11.0427 7.12626 10.9169 7.125C10.8873 7.12506 10.8578 7.12234 10.8287 7.11688L5.64124 6.20125C5.51082 6.17781 5.39505 6.10355 5.31934 5.9948C5.24364 5.88605 5.2142 5.75169 5.23749 5.62125ZM4.89061 7.59063C4.91421 7.46045 4.98843 7.34494 5.09703 7.26938C5.20562 7.19382 5.33973 7.16438 5.46999 7.1875L8.06249 7.64313C8.18572 7.66471 8.29639 7.73172 8.37263 7.83091C8.44888 7.9301 8.48517 8.05427 8.47434 8.17891C8.4635 8.30355 8.40634 8.4196 8.31413 8.50416C8.22191 8.58871 8.10135 8.63562 7.97624 8.63563C7.94691 8.63561 7.91764 8.6331 7.88874 8.62813L5.29499 8.17C5.16459 8.14669 5.04876 8.07259 4.97295 7.96397C4.89713 7.85534 4.86752 7.72107 4.89061 7.59063Z" fill="#555F6D"/>
</svg>
`, Xpe = `<svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle id="dot" cx="4" cy="4" r="4" fill="currentColor" />
</svg>
`, e9e = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 0C1.79086 0 0 1.79086 0 4V16C0 18.2091 1.79086 20 4 20H16C18.2091 20 20 18.2091 20 16V4C20 1.79086 18.2091 0 16 0H5.5L5.5 2H8.25C8.66421 2 9 2.33579 9 2.75V6.75C9 7.16421 8.66421 7.5 8.25 7.5H5.5V10H8.25C8.66421 10 9 10.3358 9 10.75V15.25C9 15.6642 8.66421 16 8.25 16H4.75C4.33579 16 4 15.6642 4 15.25V6.75C4 6.33579 4.33579 6 4.75 6H7.5V3.5H4.75C4.55109 3.5 4.36032 3.42098 4.21967 3.28033C4.07902 3.13968 4 2.94891 4 2.75V0Z" fill="#555F6D"/>
<path d="M5.5 14.5V11.5H7.5V14.5H5.5Z" fill="#555F6D"/>
</svg>
`, t9e = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M4 0C1.79086 0 0 1.79086 0 4V16C0 18.2091 1.79086 20 4 20H16C18.2091 20 20 18.2091 20 16V4C20 1.79086 18.2091 0 16 0H4ZM4.75 5C4.33579 5 4 5.33579 4 5.75C4 6.16421 4.33579 6.5 4.75 6.5H10.25C10.6642 6.5 11 6.16421 11 5.75C11 5.33579 10.6642 5 10.25 5H4.75ZM4.75 9.5C4.33579 9.5 4 9.83579 4 10.25C4 10.6642 4.33579 11 4.75 11H15.25C15.6642 11 16 10.6642 16 10.25C16 9.83579 15.6642 9.5 15.25 9.5H4.75ZM4.75 13.5C4.33579 13.5 4 13.8358 4 14.25C4 14.6642 4.33579 15 4.75 15H15.25C15.6642 15 16 14.6642 16 14.25C16 13.8358 15.6642 13.5 15.25 13.5H4.75Z" fill="#3062D4"/>
</svg>
`, o9e = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M4 0C1.79086 0 0 1.79086 0 4V16C0 18.2091 1.79086 20 4 20H16C18.2091 20 20 18.2091 20 16V4C20 1.79086 18.2091 0 16 0H4ZM7.34581 5.29445C7.09419 4.96542 6.62349 4.90266 6.29445 5.15427C5.96542 5.40588 5.90266 5.87659 6.15427 6.20563L9.05588 10L6.15427 13.7945C5.90266 14.1235 5.96542 14.5942 6.29445 14.8458C6.62349 15.0974 7.09419 15.0347 7.34581 14.7056L10 11.2347L12.6543 14.7056C12.9059 15.0347 13.3766 15.0974 13.7056 14.8458C14.0347 14.5942 14.0974 14.1235 13.8458 13.7945L10.9442 10L13.8458 6.20563C14.0974 5.87659 14.0347 5.40588 13.7056 5.15427C13.3766 4.90266 12.9059 4.96542 12.6543 5.29445L10 8.76537L7.34581 5.29445Z" fill="#1D7C4D"/>
</svg>
`, n9e = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M4 4.5C4 2.567 5.50432 1 7.36 1H12.64C14.4957 1 16 2.567 16 4.5C16 5.61548 15.499 6.60909 14.7187 7.25C15.499 7.89092 16 8.88452 16 10C16 11.933 14.4957 13.5 12.64 13.5C11.9261 13.5 11.2642 13.2681 10.72 12.8727V15.5C10.72 17.433 9.21568 19 7.36 19C5.50432 19 4 17.433 4 15.5C4 14.3845 4.50096 13.3909 5.28132 12.75C4.50096 12.1091 4 11.1155 4 10C4 8.88452 4.50096 7.89092 5.28131 7.25C4.50096 6.60908 4 5.61548 4 4.5ZM7.36 8C6.29961 8 5.44 8.89543 5.44 10C5.44 11.1046 6.29961 12 7.36 12H9.28V8H7.36ZM9.28 6.5H7.36C6.29961 6.5 5.44 5.60457 5.44 4.5C5.44 3.39543 6.29961 2.5 7.36 2.5H9.28V6.5ZM12.64 6.5C13.7004 6.5 14.56 5.60457 14.56 4.5C14.56 3.39543 13.7004 2.5 12.64 2.5H10.72V6.5H12.64ZM12.64 8C11.5796 8 10.72 8.89543 10.72 10C10.72 11.1046 11.5796 12 12.64 12C13.7004 12 14.56 11.1046 14.56 10C14.56 8.89543 13.7004 8 12.64 8ZM9.28 13.5H7.36C6.29961 13.5 5.44 14.3954 5.44 15.5C5.44 16.6046 6.29961 17.5 7.36 17.5C8.42039 17.5 9.28 16.6046 9.28 15.5V13.5Z" fill="#8040BF"/>
</svg>
`, s9e = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M4.75 1.5C4.05964 1.5 3.5 2.05964 3.5 2.75V17.25C3.5 17.9404 4.05964 18.5 4.75 18.5H15.25C15.9404 18.5 16.5 17.9404 16.5 17.25V6.06066L11.9393 1.5H4.75ZM2 2.75C2 1.23122 3.23122 0 4.75 0H12.25C12.4489 0 12.6397 0.0790176 12.7803 0.21967L17.7803 5.21967C17.921 5.36032 18 5.55109 18 5.75V17.25C18 18.7688 16.7688 20 15.25 20H4.75C3.23122 20 2 18.7688 2 17.25V2.75Z" fill="#555F6D"/>
</svg>
`, i9e = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.5 7.5V9.80769H4.5C4.99404 9.80769 5.5 9.35184 5.5 8.65385C5.5 7.95585 4.99404 7.5 4.5 7.5H3.5Z" fill="#C53434"/>
<path d="M9.25 7.5V12.5H9.75C10.3485 12.5 10.8284 12.2132 11.1821 11.7435C11.5461 11.2599 11.75 10.6084 11.75 10C11.75 9.39157 11.5461 8.74007 11.1821 8.25654C10.8284 7.78679 10.3485 7.5 9.75 7.5H9.25Z" fill="#C53434"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M4 0C1.79086 0 0 1.79086 0 4V16C0 18.2091 1.79086 20 4 20H16C18.2091 20 20 18.2091 20 16V4C20 1.79086 18.2091 0 16 0H4ZM2 6.75C2 6.33579 2.33579 6 2.75 6H4.5C5.93895 6 7 7.24891 7 8.65385C7 10.0588 5.93895 11.3077 4.5 11.3077H3.5V13.25C3.5 13.6642 3.16421 14 2.75 14C2.33579 14 2 13.6642 2 13.25V6.75ZM7.75 6.75C7.75 6.33579 8.08579 6 8.5 6H9.75C10.9015 6 11.7966 6.57882 12.3804 7.35437C12.9539 8.11615 13.25 9.08965 13.25 10C13.25 10.9104 12.9539 11.8839 12.3804 12.6456C11.7966 13.4212 10.9015 14 9.75 14H8.5C8.08579 14 7.75 13.6642 7.75 13.25V6.75ZM14.75 6C14.3358 6 14 6.33579 14 6.75V13.25C14 13.6642 14.3358 14 14.75 14C15.1642 14 15.5 13.6642 15.5 13.25V10.4615H17.25C17.6642 10.4615 18 10.1258 18 9.71154C18 9.29733 17.6642 8.96154 17.25 8.96154H15.5V7.5H17.25C17.6642 7.5 18 7.16421 18 6.75C18 6.33579 17.6642 6 17.25 6H14.75Z" fill="#C53434"/>
</svg>
`, r9e = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7 10.5H5.5V7.5H7C7.82843 7.5 8.5 8.17157 8.5 9C8.5 9.82843 7.82843 10.5 7 10.5Z" fill="#3062D4"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M4 0C1.79086 0 0 1.79086 0 4V16C0 18.2091 1.79086 20 4 20H16C18.2091 20 20 18.2091 20 16V4C20 1.79086 18.2091 0 16 0H4ZM11.5 8.375C11.5 7.89175 11.8918 7.5 12.375 7.5H13.25C13.973 7.5 14.286 7.70214 14.408 7.81056C14.4754 7.87048 14.5094 7.92374 14.5241 7.95096C14.5279 7.95787 14.5304 7.96317 14.5319 7.96652C14.6465 8.34765 15.0417 8.57515 15.4319 8.47761C15.8337 8.37714 16.0781 7.96994 15.9776 7.5681L15.25 7.75C15.9776 7.5681 15.9773 7.56692 15.9773 7.56692L15.977 7.56571L15.9764 7.56321L15.975 7.55791L15.9718 7.5461C15.9694 7.53769 15.9667 7.52823 15.9635 7.51779C15.957 7.4969 15.9487 7.472 15.9381 7.44369C15.9169 7.38713 15.8863 7.31639 15.8431 7.23654C15.7562 7.07626 15.6184 6.87952 15.4045 6.68944C14.964 6.29786 14.277 6 13.25 6H12.375C11.0633 6 10 7.06332 10 8.375C10 9.18487 10.5505 9.78954 11.0816 10.1465C11.6314 10.5161 12.3378 10.75 13 10.75C13.3378 10.75 13.7564 10.8798 14.0816 11.0984C14.4255 11.3296 14.5 11.5374 14.5 11.625C14.5 12.1082 14.1082 12.5 13.625 12.5H12.75C12.027 12.5 11.714 12.2979 11.592 12.1894C11.5246 12.1295 11.4906 12.0763 11.4759 12.049C11.4735 12.0446 11.4716 12.0409 11.4702 12.0379L11.4681 12.0335C11.3535 11.6523 10.9583 11.4249 10.5681 11.5224C10.1663 11.6229 9.92193 12.0301 10.0224 12.4319L10.75 12.25C10.0224 12.4319 10.0227 12.4331 10.0227 12.4331L10.023 12.4343L10.0236 12.4368L10.025 12.4421L10.0282 12.4539C10.0306 12.4623 10.0333 12.4718 10.0365 12.4822C10.043 12.5031 10.0513 12.528 10.0619 12.5563C10.0831 12.6129 10.1137 12.6836 10.1569 12.7635C10.2438 12.9237 10.3816 13.1205 10.5955 13.3106C11.036 13.7021 11.723 14 12.75 14H13.625C14.9367 14 16 12.9367 16 11.625C16 10.8151 15.4495 10.2105 14.9184 9.85349C14.3686 9.48394 13.6622 9.24999 13 9.24999C12.6622 9.24999 12.2436 9.12016 11.9184 8.90158C11.5745 8.67042 11.5 8.4626 11.5 8.375ZM4.75 6C4.33579 6 4 6.33579 4 6.75V13.25C4 13.6642 4.33579 14 4.75 14C5.16421 14 5.5 13.6642 5.5 13.25V12H7C8.65685 12 10 10.6569 10 9C10 7.34315 8.65685 6 7 6H4.75Z" fill="#3062D4"/>
</svg>
`, l9e = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M4 0C1.79086 0 0 1.79086 0 4V16C0 18.2091 1.79086 20 4 20H16C18.2091 20 20 18.2091 20 16V4C20 1.79086 18.2091 0 16 0H4ZM4.90856 4.24299C4.68948 4.44666 4.53036 4.72704 4.21212 5.28782L3.46124 6.61095C3.03703 7.35844 2.82493 7.73219 2.77024 8.1223C2.72197 8.46655 2.7604 8.81817 2.88164 9.14172C3.01903 9.50836 3.30615 9.82112 3.8804 10.4467L7.85019 14.771C8.60049 15.5883 8.97564 15.9969 9.41076 16.1494C9.79335 16.2835 10.2066 16.2835 10.5892 16.1494C11.0244 15.9969 11.3995 15.5883 12.1498 14.771L16.1196 10.4467C16.6938 9.82112 16.981 9.50836 17.1184 9.14172C17.2396 8.81817 17.278 8.46655 17.2298 8.1223C17.1751 7.73219 16.963 7.35844 16.5388 6.61095L15.7879 5.28782C15.4696 4.72705 15.3105 4.44666 15.0914 4.24299C14.8976 4.06276 14.6706 3.92686 14.4246 3.84383C14.1467 3.75 13.8375 3.75 13.2189 3.75H6.78109C6.16255 3.75 5.85327 3.75 5.57537 3.84383C5.32945 3.92686 5.10242 4.06276 4.90856 4.24299Z" fill="#F59638"/>
</svg>
`, a9e = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M4 0C1.79086 0 0 1.79086 0 4V16C0 18.2091 1.79086 20 4 20H16C18.2091 20 20 18.2091 20 16V4C20 1.79086 18.2091 0 16 0H4ZM8.5 2.75C8.5 2.33579 8.16421 2 7.75 2C7.33579 2 7 2.33579 7 2.75V7H2.75C2.33579 7 2 7.33579 2 7.75C2 8.16421 2.33579 8.5 2.75 8.5H7V17.25C7 17.6642 7.33579 18 7.75 18C8.16421 18 8.5 17.6642 8.5 17.25V8.5H17.25C17.6642 8.5 18 8.16421 18 7.75C18 7.33579 17.6642 7 17.25 7H8.5V2.75Z" fill="#1D7C4D"/>
</svg>
`, c9e = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M4 0C1.79086 0 0 1.79086 0 4V16C0 18.2091 1.79086 20 4 20H16C18.2091 20 20 18.2091 20 16V4C20 1.79086 18.2091 0 16 0H4ZM6.46679 6.52939C6.34497 6.13349 5.92529 5.91131 5.52939 6.03312C5.13349 6.15494 4.91131 6.57462 5.03312 6.97052L7.03312 13.4705C7.12131 13.7571 7.37174 13.9637 7.6699 13.9957C7.96806 14.0277 8.25662 13.879 8.40364 13.6177L9.99996 10.7798L11.5963 13.6177C11.7433 13.879 12.0319 14.0277 12.33 13.9957C12.6282 13.9637 12.8786 13.7571 12.9668 13.4705L14.9668 6.97052C15.0886 6.57462 14.8664 6.15494 14.4705 6.03312C14.0746 5.91131 13.6549 6.13349 13.5331 6.52939L12.047 11.3593L10.6536 8.88226C10.5208 8.6461 10.2709 8.49996 9.99996 8.49996C9.729 8.49996 9.47911 8.6461 9.34627 8.88226L7.95292 11.3593L6.46679 6.52939Z" fill="#3062D4"/>
</svg>
`, d9e = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.4808 4.16346C14.3889 4.16346 15.125 3.42731 15.125 2.51923C15.125 1.61115 14.3889 0.875 13.4808 0.875C12.5727 0.875 11.8365 1.61115 11.8365 2.51923M13.4808 4.16346C12.5727 4.16346 11.8365 3.42731 11.8365 2.51923M13.4808 4.16346V11.8365M11.8365 2.51923H4.16346M11.8365 13.4808C11.8365 14.3889 12.5727 15.125 13.4808 15.125C14.3889 15.125 15.125 14.3889 15.125 13.4808C15.125 12.5727 14.3889 11.8365 13.4808 11.8365M11.8365 13.4808C11.8365 12.5727 12.5727 11.8365 13.4808 11.8365M11.8365 13.4808H4.16346M4.16346 2.51923C4.16346 3.42731 3.42731 4.16346 2.51923 4.16346M4.16346 2.51923C4.16346 1.61115 3.42731 0.875 2.51923 0.875C1.61115 0.875 0.875 1.61115 0.875 2.51923C0.875 3.42731 1.61115 4.16346 2.51923 4.16346M2.51923 4.16346V11.8365M4.16346 13.4808C4.16346 14.3889 3.42731 15.125 2.51923 15.125C1.61115 15.125 0.875 14.3889 0.875 13.4808C0.875 12.5727 1.61115 11.8365 2.51923 11.8365M4.16346 13.4808C4.16346 12.5727 3.42731 11.8365 2.51923 11.8365" stroke="black" stroke-linecap="round"/>
</svg>
`, u9e = `<svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path id="Icon" fill-rule="evenodd" clip-rule="evenodd" d="M9.90284 2L12.7972 2.00439C14.1019 2.00637 15.3922 2.2766 16.588 2.79828L17.7868 3.32129C19.1171 3.90166 19.9788 5.21329 19.9833 6.6647L20 12.0537C20.0045 13.5268 18.8218 14.7257 17.3535 14.7458C17.2924 14.8951 17.2137 15.0737 17.1185 15.262C16.9414 15.6126 16.6811 16.05 16.3357 16.385C15.9912 16.7192 15.4405 17.0588 14.7544 16.8885C14.1272 16.7329 13.6315 16.2021 13.2157 15.4783L11.0615 12.0964C10.8443 11.7555 10.9447 11.303 11.2857 11.0858C11.6266 10.8686 12.0791 10.9689 12.2963 11.3099L14.4693 14.7213L14.4781 14.7368C14.8363 15.3645 15.0705 15.4586 15.107 15.4676C15.1075 15.4677 15.1079 15.4678 15.1084 15.468C15.1135 15.4693 15.1187 15.4707 15.1397 15.4625C15.1724 15.4497 15.2328 15.4152 15.3164 15.3342C15.4894 15.1663 15.6623 14.8977 15.8119 14.6017C15.8961 14.4351 15.9646 14.2766 16.015 14.1509L12.4354 8.1308C12.1577 7.66374 11.4293 7.26252 10.7619 7.20318C10.6318 7.19161 10.5753 7.21216 10.5328 7.2337C10.4669 7.26716 10.3771 7.33547 10.2101 7.50524L8.29221 9.45492L8.25155 9.48607C7.62637 9.9652 7.00629 10.1885 6.40767 10.1806C5.81282 10.1729 5.33062 9.93812 4.97496 9.66871C4.46102 9.27941 4.26624 8.71366 4.28178 8.18018C4.29679 7.66487 4.50278 7.16307 4.80562 6.76761L7.21835 3.61703C7.82107 2.85705 8.44753 2.448 8.95337 2.23178C9.20404 2.12463 9.42019 2.06692 9.58279 2.03591C9.66404 2.02041 9.73192 2.01159 9.78411 2.00657C9.81022 2.00406 9.83243 2.00249 9.85046 2.00153L9.87436 2.00048L9.88391 2.00021L9.88807 2.00013L9.88999 2.00009C9.89044 2.00009 9.89181 2.00007 9.90172 2.73201L9.89182 2.00007L9.90284 2ZM9.92235 3.46406C9.91166 3.46515 9.88937 3.46785 9.85704 3.47402C9.78833 3.48712 9.67416 3.51585 9.52881 3.57798C9.24338 3.69999 8.81646 3.95975 8.36923 4.52213L5.96797 7.65774C5.82266 7.84748 5.74995 8.05941 5.74519 8.2228C5.74096 8.36802 5.78534 8.44593 5.85896 8.50169C6.0363 8.63603 6.22307 8.71408 6.42679 8.71674C6.62062 8.71927 6.91605 8.65482 7.3222 8.35332L9.16635 6.47857C9.35409 6.28772 9.58158 6.0747 9.87025 5.92818C10.1824 5.76974 10.5178 5.71167 10.8916 5.7449C11.8941 5.83405 13.1147 6.40858 13.6938 7.38257L17.2016 13.282H17.3159C17.9912 13.282 18.5381 12.7335 18.536 12.0582L18.5193 6.66923C18.5166 5.79838 17.9996 5.0114 17.2014 4.66318L16.0026 4.14017C14.9907 3.69875 13.8989 3.4701 12.795 3.46842L9.92235 3.46406ZM1.19712e-06 6.56585C-0.00161701 4.5433 1.63753 2.90285 3.66007 2.90285H5.78592C6.1902 2.90285 6.51794 3.23058 6.51794 3.63486C6.51794 4.03914 6.1902 4.36688 5.78592 4.36688H3.66007C2.44654 4.36688 1.46306 5.35115 1.46403 6.56467L1.46806 11.598C1.46816 11.7326 1.57738 11.8418 1.71206 11.8418H2.70987L5.48044 16.6066C5.68558 16.9525 5.91763 17.0797 6.10902 17.1334C6.32372 17.1937 6.54162 17.1744 6.69152 17.1424C7.08688 17.058 7.47583 17.3101 7.56025 17.7055C7.64467 18.1008 7.3926 18.4898 6.99723 18.5742C6.71087 18.6353 6.23506 18.6895 5.71313 18.5429C5.16829 18.3899 4.62136 18.0302 4.21892 17.3495L4.21622 17.3449L1.86762 13.3058H1.71206C0.769275 13.3058 0.00478239 12.5419 0.00402815 11.5991L1.19712e-06 6.56585ZM8.99242 12.6609C9.34597 12.4648 9.79153 12.5925 9.98761 12.946L11.5217 15.7119C11.5238 15.7157 11.5258 15.7195 11.5279 15.7234C11.7695 16.125 11.9589 16.1571 12.0317 16.1644C12.1766 16.1791 12.339 16.1246 12.5763 16.0238C12.9484 15.8657 13.3782 16.0392 13.5363 16.4113C13.6943 16.7834 13.5208 17.2132 13.1487 17.3713C13.1422 17.374 13.1354 17.3769 13.1283 17.38C12.9084 17.4737 12.433 17.6764 11.8849 17.6211C11.249 17.557 10.6763 17.1751 10.2409 16.423C10.2319 16.4075 10.2236 16.3919 10.2159 16.3761L8.70732 13.6561C8.51124 13.3026 8.63888 12.857 8.99242 12.6609ZM6.76581 14.4756C7.11636 14.2742 7.5638 14.3952 7.76518 14.7457L8.72626 16.4187C8.74214 16.4413 8.75691 16.465 8.77045 16.4898C8.89382 16.7155 9.0001 16.8039 9.0546 16.838C9.10488 16.8694 9.14282 16.8749 9.17585 16.8743C9.21715 16.8735 9.26207 16.8618 9.30192 16.8451C9.32029 16.8375 9.33318 16.8306 9.33862 16.8275C9.33852 16.8275 9.33873 16.8274 9.33862 16.8275C9.66989 16.6097 10.1165 16.6951 10.343 17.023C10.5729 17.3556 10.4895 17.8115 10.1569 18.0414L9.74081 17.4391C10.1569 18.0414 10.1573 18.0411 10.1569 18.0414L10.1554 18.0424L10.1538 18.0435L10.1503 18.0459L10.1421 18.0514C10.1361 18.0554 10.129 18.06 10.1209 18.0651C10.1048 18.0753 10.0844 18.0876 10.0601 18.1014C10.0119 18.1287 9.94656 18.1625 9.86681 18.1958C9.71044 18.2612 9.47958 18.333 9.20263 18.3381C8.9174 18.3433 8.59463 18.2769 8.27883 18.0796C7.98463 17.8958 7.73181 17.6206 7.52241 17.2572C7.51093 17.2405 7.50004 17.2233 7.48979 17.2055L6.49571 15.475C6.29433 15.1244 6.41526 14.677 6.76581 14.4756Z" />
</svg>
`, h9e = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.5 16.5237H7H6.5ZM6.5 24.0439H6H6.5ZM24.0385 25.5V25V25.5ZM7.96154 25.5V26H7.96154L7.96154 25.5ZM25.5 16.5238H25H25.5ZM25.5 24.0439H26H25.5ZM24.7266 14.5504L24.3595 14.8899L24.7266 14.5504ZM18.1497 7.43887L17.7826 7.77836L18.1497 7.43887ZM13.8503 7.43887L14.2174 7.77835L13.8503 7.43887ZM7.27339 14.5504L6.9063 14.2109H6.9063L7.27339 14.5504ZM13.0769 18.2194H13.5769H13.0769ZM13.0769 24.7719H12.5769H13.0769ZM18.1923 25.5V25V25.5ZM13.8077 25.5V26V25.5ZM18.9231 18.2195L19.4231 18.2195V18.2195H18.9231ZM18.9231 24.7719H18.4231H18.9231ZM18.1923 17.4914L18.1923 17.9914L18.1923 17.4914ZM13.8077 17.4914L13.8077 17.9914H13.8077L13.8077 17.4914ZM6 16.5237L6 24.0439H7L7 16.5237H6ZM24.0385 25L7.96154 25L7.96154 26L24.0385 26V25ZM25 16.5238V24.0439H26V16.5238H25ZM25.0937 14.2109L18.5168 7.09939L17.7826 7.77836L24.3595 14.8899L25.0937 14.2109ZM13.4832 7.09938L6.9063 14.2109L7.64047 14.8899L14.2174 7.77835L13.4832 7.09938ZM18.5168 7.09939C17.1611 5.63354 14.8389 5.63354 13.4832 7.09938L14.2174 7.77835C15.1772 6.74055 16.8228 6.74055 17.7826 7.77836L18.5168 7.09939ZM26 16.5238C26 15.6665 25.6763 14.8409 25.0937 14.2109L24.3595 14.8899C24.7715 15.3354 25 15.9187 25 16.5238H26ZM7 16.5237C7 15.9186 7.22845 15.3354 7.64047 14.8899L6.9063 14.2109C6.32371 14.8409 6 15.6665 6 16.5237H7ZM6 24.0439C6 25.126 6.87996 26 7.96154 26V25C7.42874 25 7 24.5702 7 24.0439H6ZM24.0385 26C25.12 26 26 25.126 26 24.0439H25C25 24.5702 24.5713 25 24.0385 25V26ZM12.5769 18.2194L12.5769 24.7719H13.5769L13.5769 18.2194H12.5769ZM18.1923 25H13.8077V26H18.1923V25ZM18.4231 18.2195L18.4231 24.7719H19.4231L19.4231 18.2195L18.4231 18.2195ZM18.1923 16.9914L13.8077 16.9914L13.8077 17.9914L18.1923 17.9914L18.1923 16.9914ZM19.4231 18.2195C19.4231 17.5395 18.8703 16.9914 18.1923 16.9914L18.1923 17.9914C18.3215 17.9914 18.4231 18.0953 18.4231 18.2195H19.4231ZM13.5769 18.2194C13.5769 18.0952 13.6785 17.9914 13.8077 17.9914L13.8077 16.9914C13.1297 16.9914 12.5769 17.5395 12.5769 18.2194H13.5769ZM12.5769 24.7719C12.5769 25.4519 13.1297 26 13.8077 26V25C13.6785 25 13.5769 24.8961 13.5769 24.7719H12.5769ZM18.1923 26C18.8703 26 19.4231 25.4519 19.4231 24.7719H18.4231C18.4231 24.8961 18.3215 25 18.1923 25V26Z" fill="#4D4D4D"/>
</svg>
`, g9e = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16 21.2778V14.9444M16 12.3056V10.7222M25.5 16C25.5 21.2467 21.2467 25.5 16 25.5C10.7533 25.5 6.5 21.2467 6.5 16C6.5 10.7533 10.7533 6.5 16 6.5C21.2467 6.5 25.5 10.7533 25.5 16Z" stroke="#4D4D4D" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`, p9e = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0ZM5.46582 4.72754V12H6.7832V9.33691H8.12402L9.55273 12H11.0225L9.44922 9.12012C9.49658 9.10102 9.54294 9.08121 9.58789 9.05957C9.97141 8.87254 10.2615 8.60849 10.458 8.26758C10.6568 7.92441 10.7568 7.5199 10.7568 7.05371C10.7568 6.5897 10.6584 6.18297 10.4619 5.83496C10.2678 5.48467 9.97972 5.21265 9.59863 5.01855C9.21988 4.82449 8.75101 4.72754 8.19238 4.72754H5.46582ZM7.99023 5.82812C8.31909 5.82813 8.58762 5.87669 8.7959 5.97363C9.0042 6.06832 9.15992 6.20795 9.26172 6.39258C9.36352 6.57487 9.41406 6.79566 9.41406 7.05371C9.41401 7.31158 9.36346 7.52957 9.26172 7.70703C9.16228 7.88214 9.00807 8.0161 8.7998 8.1084C8.5915 8.1983 8.32366 8.24316 7.99707 8.24316H6.7832V5.82812H7.99023Z" fill="#555F6D"/>
</svg>
`, f9e = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z" stroke="#4D4D4D" stroke-width="2"/>
<path d="M20 4H4V20H20V4Z" stroke="#4D4D4D" stroke-width="2"/>
</svg>
`, v9e = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5 10H19" stroke="#4D4D4D" stroke-width="2"/>
<path d="M5 14H19" stroke="#4D4D4D" stroke-width="2"/>
</svg>
`, m9e = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9 6L15 12L9 18" stroke="#4D4D4D" stroke-width="2"/>
</svg>
`, C9e = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9 6L15 12L9 18" stroke="#4D4D4D" stroke-width="2"/>
<path d="M6 20H18" stroke="#4D4D4D" stroke-width="2"/>
</svg>
`, w9e = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15 6L9 12L15 18" stroke="#4D4D4D" stroke-width="2"/>
</svg>
`, b9e = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15 6L9 12L15 18" stroke="#4D4D4D" stroke-width="2"/>
<path d="M6 20H18" stroke="#4D4D4D" stroke-width="2"/>
</svg>
`, y9e = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5 10H19" stroke="#4D4D4D" stroke-width="2"/>
<path d="M5 14H19" stroke="#4D4D4D" stroke-width="2"/>
<path d="M6 6L18 18" stroke="#4D4D4D" stroke-width="2"/>
</svg>
`, _9e = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z" stroke="#4D4D4D" stroke-width="2"/>
<path d="M20 4H4V20H20V4Z" stroke="#4D4D4D" stroke-width="2"/>
<path d="M5 5L19 19" stroke="#4D4D4D" stroke-width="2"/>
</svg>
`, S9e = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13 2H3C2.73478 2 2.48043 2.10536 2.29289 2.29289C2.10536 2.48043 2 2.73478 2 3V13C2 13.2652 2.10536 13.5196 2.29289 13.7071C2.48043 13.8946 2.73478 14 3 14H13C13.2652 14 13.5196 13.8946 13.7071 13.7071C13.8946 13.5196 14 13.2652 14 13V3C14 2.73478 13.8946 2.48043 13.7071 2.29289C13.5196 2.10536 13.2652 2 13 2ZM13 13H3V3H13V13Z" fill="#4A545E"/>
<path d="M6 10.6667V4.66667H7.16575V9.75553H10V10.6667H6Z" fill="#4A545E"/>
</svg>
`, x9e = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13 2H3C2.73478 2 2.48043 2.10536 2.29289 2.29289C2.10536 2.48043 2 2.73478 2 3V13C2 13.2652 2.10536 13.5196 2.29289 13.7071C2.48043 13.8946 2.73478 14 3 14H13C13.2652 14 13.5196 13.8946 13.7071 13.7071C13.8946 13.5196 14 13.2652 14 13V3C14 2.73478 13.8946 2.48043 13.7071 2.29289C13.5196 2.10536 13.2652 2 13 2ZM13 13H3V3H13V13Z" fill="#4A545E"/>
<path d="M4.66667 4.66667H6.07573L7.96276 9.01432H8.03724L9.92427 4.66667H11.3333V10.6667H10.2284V6.5446H10.1695L8.41279 10.6491H7.58721L5.83054 6.53581H5.77157V10.6667H4.66667V4.66667Z" fill="#4A545E"/>
</svg>
`, M9e = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13 2H3C2.73478 2 2.48043 2.10536 2.29289 2.29289C2.10536 2.48043 2 2.73478 2 3V13C2 13.2652 2.10536 13.5196 2.29289 13.7071C2.48043 13.8946 2.73478 14 3 14H13C13.2652 14 13.5196 13.8946 13.7071 13.7071C13.8946 13.5196 14 13.2652 14 13V3C14 2.73478 13.8946 2.48043 13.7071 2.29289C13.5196 2.10536 13.2652 2 13 2ZM13 13H3V3H13V13Z" fill="#4A545E"/>
<path d="M9.06942 6.44792C9.04291 6.19981 8.93117 6.00663 8.7342 5.86837C8.53912 5.73012 8.28533 5.66099 7.97283 5.66099C7.75314 5.66099 7.56469 5.69413 7.40749 5.76042C7.2503 5.82671 7.13003 5.91667 7.0467 6.0303C6.96336 6.14394 6.92075 6.27368 6.91886 6.41951C6.91886 6.54072 6.94632 6.64584 7.00124 6.73485C7.05806 6.82387 7.13477 6.89962 7.23136 6.96212C7.32795 7.02273 7.43496 7.07387 7.55238 7.11553C7.6698 7.1572 7.78817 7.19224 7.90749 7.22065L8.45295 7.35701C8.67264 7.40815 8.88382 7.47727 9.08647 7.5644C9.29102 7.65152 9.47378 7.76137 9.63477 7.89394C9.79764 8.02652 9.92643 8.18655 10.0211 8.37405C10.1158 8.56155 10.1632 8.78125 10.1632 9.03315C10.1632 9.37406 10.0761 9.67424 9.90181 9.93371C9.72757 10.1913 9.47567 10.393 9.14613 10.5388C8.81848 10.6828 8.4217 10.7547 7.95579 10.7547C7.50314 10.7547 7.11014 10.6847 6.77681 10.5445C6.44537 10.4044 6.1859 10.1998 5.9984 9.93087C5.8128 9.66193 5.71242 9.33428 5.69727 8.94792H6.7342C6.74935 9.15057 6.81185 9.31913 6.9217 9.4536C7.03155 9.58807 7.17454 9.68845 7.35067 9.75474C7.52871 9.82103 7.72757 9.85417 7.94727 9.85417C8.17643 9.85417 8.37719 9.82008 8.54954 9.7519C8.72378 9.68182 8.86014 9.58523 8.95863 9.46212C9.05711 9.33712 9.1073 9.19129 9.1092 9.02462C9.1073 8.87311 9.0628 8.74811 8.97567 8.64962C8.88855 8.54924 8.76639 8.46591 8.6092 8.39962C8.45389 8.33144 8.27208 8.27084 8.06374 8.2178L7.40181 8.04735C6.92264 7.92424 6.54386 7.73769 6.26545 7.48769C5.98893 7.2358 5.85067 6.90152 5.85067 6.48485C5.85067 6.14205 5.94348 5.84186 6.12908 5.58428C6.31658 5.32671 6.57132 5.1269 6.89329 4.98485C7.21526 4.84091 7.57984 4.76894 7.98704 4.76894C8.39992 4.76894 8.76166 4.84091 9.07227 4.98485C9.38477 5.1269 9.63003 5.32481 9.80806 5.5786C9.98609 5.83049 10.0779 6.12027 10.0836 6.44792H9.06942Z" fill="#4A545E"/>
</svg>
`, A9e = `<svg width="9" height="5" viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.91504 4.71191L0.16504 0.961913C0.0593681 0.85624 1.87619e-06 0.712918 1.88272e-06 0.563475C1.88925e-06 0.414032 0.0593681 0.27071 0.16504 0.165038C0.270712 0.0593655 0.414035 -3.57885e-07 0.563478 -3.52466e-07C0.712921 -3.47047e-07 0.856243 0.0593656 0.961915 0.165038L4.31301 3.51707L7.66504 0.165976C7.71736 0.113652 7.77948 0.0721467 7.84784 0.0438294C7.91621 0.0155121 7.98948 0.000937315 8.06348 0.000937318C8.13747 0.000937321 8.21075 0.0155121 8.27911 0.0438294C8.34747 0.0721467 8.40959 0.113652 8.46191 0.165976C8.51424 0.218299 8.55574 0.280416 8.58406 0.34878C8.61238 0.417145 8.62695 0.490417 8.62695 0.564413C8.62695 0.63841 8.61238 0.711682 8.58406 0.780046C8.55574 0.84841 8.51424 0.910527 8.46191 0.962851L4.71191 4.71285C4.6596 4.76523 4.59745 4.80676 4.52904 4.83507C4.46064 4.86338 4.38732 4.87791 4.31328 4.87783C4.23925 4.87774 4.16596 4.86304 4.09762 4.83457C4.02928 4.8061 3.96724 4.76441 3.91504 4.71191Z" fill="#4A545E"/>
</svg>
`, L9e = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M83.19,174.4a8,8,0,0,0,11.21-1.6,52,52,0,0,1,83.2,0,8,8,0,1,0,12.8-9.6A67.88,67.88,0,0,0,163,141.51a40,40,0,1,0-53.94,0A67.88,67.88,0,0,0,81.6,163.2,8,8,0,0,0,83.19,174.4ZM112,112a24,24,0,1,1,24,24A24,24,0,0,1,112,112Zm96-88H64A16,16,0,0,0,48,40V64H32a8,8,0,0,0,0,16H48v40H32a8,8,0,0,0,0,16H48v40H32a8,8,0,0,0,0,16H48v24a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V40A16,16,0,0,0,208,24Zm0,192H64V40H208Z"></path></svg>', E9e = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M40,56V200a8,8,0,0,1-16,0V56a8,8,0,0,1,16,0ZM240,96v64a16,16,0,0,1-16,16H72a16,16,0,0,1-16-16V96A16,16,0,0,1,72,80H224A16,16,0,0,1,240,96Zm-16,64V96H72v64H224Z"></path></svg>', P9e = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M48,40V216a8,8,0,0,1-16,0V40a8,8,0,0,1,16,0Zm16,64V64A16,16,0,0,1,80,48h96a16,16,0,0,1,16,16v40a16,16,0,0,1-16,16H80A16,16,0,0,1,64,104Zm16,0h96V64H80Zm152,48v40a16,16,0,0,1-16,16H80a16,16,0,0,1-16-16V152a16,16,0,0,1,16-16H216A16,16,0,0,1,232,152Zm-16,40V152H80v40H216Z"></path></svg>', R9e = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><rect width="256" height="256" fill="none"/><polyline points="80 152 32 104 80 56" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><polyline points="128 152 80 104 128 56" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><path d="M224,200a96,96,0,0,0-96-96H80" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/></svg>', F9e = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><rect width="256" height="256" fill="none"/><polyline points="80 152 32 104 80 56" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><path d="M224,200a96,96,0,0,0-96-96H32" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/></svg>', T9e = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><rect width="256" height="256" fill="none"/><polyline points="176 152 224 104 176 56" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><path d="M32,200a96,96,0,0,1,96-96h96" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/></svg>', I9e = `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M224,128a96,96,0,0,1-94.71,96H128A95.38,95.38,0,0,1,62.1,197.8a8,8,0,0,1,11-11.63A80,80,0,1,0,71.43,71.39a3.07,3.07,0,0,1-.26.25L44.59,96H72a8,8,0,0,1,0,16H24a8,8,0,0,1-8-8V56a8,8,0,0,1,16,0V85.8L60.25,60A96,96,0,0,1,224,128Z"></path></svg>
`, D9e = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><rect width="256" height="256" fill="none"/><line x1="128" y1="40" x2="128" y2="216" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><polyline points="56 144 128 216 200 144" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/></svg>', k9e = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M189.66,122.34a8,8,0,0,1,0,11.32l-72,72a8,8,0,0,1-11.32-11.32L164.69,136H32a8,8,0,0,1,0-16H164.69L106.34,61.66a8,8,0,0,1,11.32-11.32ZM216,32a8,8,0,0,0-8,8V216a8,8,0,0,0,16,0V40A8,8,0,0,0,216,32Z"></path></svg>', H9e = `<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18.1536 8.125C18.1536 8.29076 18.0877 8.44973 17.9705 8.56694C17.8533 8.68415 17.6943 8.75 17.5286 8.75C17.3628 8.75 17.2038 8.68415 17.0866 8.56694C16.9694 8.44973 16.9036 8.29076 16.9036 8.125V4.63438L11.7215 9.81719C11.6043 9.93446 11.4452 10.0003 11.2793 10.0003C11.1135 10.0003 10.9544 9.93446 10.8372 9.81719C10.7199 9.69991 10.654 9.54085 10.654 9.375C10.654 9.20915 10.7199 9.05009 10.8372 8.93281L16.0192 3.75H12.5286C12.3628 3.75 12.2038 3.68415 12.0866 3.56694C11.9694 3.44973 11.9036 3.29076 11.9036 3.125C11.9036 2.95924 11.9694 2.80027 12.0866 2.68306C12.2038 2.56585 12.3628 2.5 12.5286 2.5H17.5286C17.6943 2.5 17.8533 2.56585 17.9705 2.68306C18.0877 2.80027 18.1536 2.95924 18.1536 3.125V8.125ZM15.0286 10C14.8628 10 14.7038 10.0658 14.5866 10.1831C14.4694 10.3003 14.4036 10.4592 14.4036 10.625V16.25H4.40356V6.25H10.0286C10.1943 6.25 10.3533 6.18415 10.4705 6.06694C10.5877 5.94973 10.6536 5.79076 10.6536 5.625C10.6536 5.45924 10.5877 5.30027 10.4705 5.18306C10.3533 5.06585 10.1943 5 10.0286 5H4.40356C4.07204 5 3.7541 5.1317 3.51968 5.36612C3.28526 5.60054 3.15356 5.91848 3.15356 6.25V16.25C3.15356 16.5815 3.28526 16.8995 3.51968 17.1339C3.7541 17.3683 4.07204 17.5 4.40356 17.5H14.4036C14.7351 17.5 15.053 17.3683 15.2874 17.1339C15.5219 16.8995 15.6536 16.5815 15.6536 16.25V10.625C15.6536 10.4592 15.5877 10.3003 15.4705 10.1831C15.3533 10.0658 15.1943 10 15.0286 10Z" fill="currentColor"/>
</svg>
`, V9e = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><rect width="256" height="256" fill="none"/><line x1="128" y1="216" x2="128" y2="40" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><polyline points="56 112 128 40 200 112" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/></svg>', O9e = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><rect width="256" height="256" fill="none"/><polyline points="88 96 40 96 40 48" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><path d="M40,96,68.28,67.72A88,88,0,0,1,192,67" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><polyline points="168 160 216 160 216 208" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><path d="M216,160l-28.28,28.28A88,88,0,0,1,64,189" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/></svg>', B9e = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M117.66,170.34a8,8,0,0,1,0,11.32l-32,32a8,8,0,0,1-11.32,0l-32-32a8,8,0,0,1,11.32-11.32L72,188.69V48a8,8,0,0,1,16,0V188.69l18.34-18.35A8,8,0,0,1,117.66,170.34Zm96-96-32-32a8,8,0,0,0-11.32,0l-32,32a8,8,0,0,0,11.32,11.32L168,67.31V208a8,8,0,0,0,16,0V67.31l18.34,18.35a8,8,0,0,0,11.32-11.32Z"></path></svg>', $9e = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><rect width="256" height="256" fill="none"/><polyline points="56 96 24 128 56 160" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><polyline points="200 96 232 128 200 160" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><line x1="24" y1="128" x2="232" y2="128" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/></svg>', Z9e = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><rect width="256" height="256" fill="none"/><line x1="128" y1="40" x2="128" y2="216" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><line x1="16" y1="128" x2="96" y2="128" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><polyline points="64 96 96 128 64 160" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><line x1="240" y1="128" x2="160" y2="128" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><polyline points="192 160 160 128 192 96" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/></svg>', G9e = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><rect width="256" height="256" fill="none"/><line x1="216" y1="128" x2="40" y2="128" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><line x1="128" y1="16" x2="128" y2="96" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><polyline points="160 64 128 96 96 64" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><line x1="128" y1="240" x2="128" y2="160" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><polyline points="96 192 128 160 160 192" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/></svg>', N9e = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM122.34,101.66a8,8,0,0,0,11.32,0l32-32a8,8,0,0,0-11.32-11.32L136,76.69V16a8,8,0,0,0-16,0V76.69L101.66,58.34A8,8,0,0,0,90.34,69.66Zm11.32,52.68a8,8,0,0,0-11.32,0l-32,32a8,8,0,0,0,11.32,11.32L120,179.31V240a8,8,0,0,0,16,0V179.31l18.34,18.35a8,8,0,0,0,11.32-11.32Z"></path></svg>', z9e = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M213.66,181.66l-32,32a8,8,0,0,1-11.32-11.32L188.69,184H48a8,8,0,0,1,0-16H188.69l-18.35-18.34a8,8,0,0,1,11.32-11.32l32,32A8,8,0,0,1,213.66,181.66Zm-139.32-64a8,8,0,0,0,11.32-11.32L67.31,88H208a8,8,0,0,0,0-16H67.31L85.66,53.66A8,8,0,0,0,74.34,42.34l-32,32a8,8,0,0,0,0,11.32Z"></path></svg>', j9e = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><rect width="256" height="256" fill="none"/><line x1="128" y1="40" x2="128" y2="216" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><line x1="96" y1="128" x2="16" y2="128" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><polyline points="48 160 16 128 48 96" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><line x1="160" y1="128" x2="240" y2="128" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><polyline points="208 96 240 128 208 160" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/></svg>', W9e = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><rect width="256" height="256" fill="none"/><line x1="216" y1="128" x2="40" y2="128" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><line x1="128" y1="96" x2="128" y2="16" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><polyline points="96 48 128 16 160 48" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><line x1="128" y1="160" x2="128" y2="240" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><polyline points="160 208 128 240 96 208" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/></svg>', U9e = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM101.66,53.66,120,35.31V96a8,8,0,0,0,16,0V35.31l18.34,18.35a8,8,0,0,0,11.32-11.32l-32-32a8,8,0,0,0-11.32,0l-32,32a8,8,0,0,0,11.32,11.32Zm52.68,148.68L136,220.69V160a8,8,0,0,0-16,0v60.69l-18.34-18.35a8,8,0,0,0-11.32,11.32l32,32a8,8,0,0,0,11.32,0l32-32a8,8,0,0,0-11.32-11.32Z"></path></svg>', K9e = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M128,96H232a8,8,0,0,1,0,16H128a8,8,0,0,1,0-16Zm104,32H128a8,8,0,0,0,0,16H232a8,8,0,0,0,0-16Zm0,32H80a8,8,0,0,0,0,16H232a8,8,0,0,0,0-16Zm0,32H80a8,8,0,0,0,0,16H232a8,8,0,0,0,0-16ZM96,144a8,8,0,0,0,0-16H88V64h32v8a8,8,0,0,0,16,0V56a8,8,0,0,0-8-8H32a8,8,0,0,0-8,8V72a8,8,0,0,0,16,0V64H72v64H64a8,8,0,0,0,0,16Z"></path></svg>', q9e = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M128,24a104,104,0,0,0,0,208c21.51,0,44.1-6.48,60.43-17.33a8,8,0,0,0-8.86-13.33C166,210.38,146.21,216,128,216a88,88,0,1,1,88-88c0,26.45-10.88,32-20,32s-20-5.55-20-32V88a8,8,0,0,0-16,0v4.26a48,48,0,1,0,5.93,65.1c6,12,16.35,18.64,30.07,18.64,22.54,0,36-17.94,36-48A104.11,104.11,0,0,0,128,24Zm0,136a32,32,0,1,1,32-32A32,32,0,0,1,128,160Z"></path></svg>', Y9e = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M24,104H48v64H32a8,8,0,0,0,0,16H224a8,8,0,0,0,0-16H208V104h24a8,8,0,0,0,4.19-14.81l-104-64a8,8,0,0,0-8.38,0l-104,64A8,8,0,0,0,24,104Zm40,0H96v64H64Zm80,0v64H112V104Zm48,64H160V104h32ZM128,41.39,203.74,88H52.26ZM248,208a8,8,0,0,1-8,8H16a8,8,0,0,1,0-16H240A8,8,0,0,1,248,208Z"></path></svg>', Q9e = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M232,48V88a8,8,0,0,1-16,0V56H184a8,8,0,0,1,0-16h40A8,8,0,0,1,232,48ZM72,200H40V168a8,8,0,0,0-16,0v40a8,8,0,0,0,8,8H72a8,8,0,0,0,0-16Zm152-40a8,8,0,0,0-8,8v32H184a8,8,0,0,0,0,16h40a8,8,0,0,0,8-8V168A8,8,0,0,0,224,160ZM32,96a8,8,0,0,0,8-8V56H72a8,8,0,0,0,0-16H32a8,8,0,0,0-8,8V88A8,8,0,0,0,32,96ZM80,80a8,8,0,0,0-8,8v80a8,8,0,0,0,16,0V88A8,8,0,0,0,80,80Zm104,88V88a8,8,0,0,0-16,0v80a8,8,0,0,0,16,0ZM144,80a8,8,0,0,0-8,8v80a8,8,0,0,0,16,0V88A8,8,0,0,0,144,80Zm-32,0a8,8,0,0,0-8,8v80a8,8,0,0,0,16,0V88A8,8,0,0,0,112,80Z"></path></svg>', J9e = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><rect width="256" height="256" fill="none"/><polyline points="80 40 40 40 40 216 80 216" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><polyline points="176 40 216 40 216 216 176 216" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/></svg>', X9e = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><rect width="256" height="256" fill="none"/><path d="M112,224a95.2,95.2,0,0,1-29-48" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><path d="M192,152c0,31.67,13.31,59,40,72H61A103.65,103.65,0,0,1,32,152c0-28.21,11.23-50.89,29.47-69.64a8,8,0,0,1,8.67-1.81L95.52,90.83a16,16,0,0,0,20.82-9l21-53.11c4.15-10,15.47-15.32,25.63-11.53a20,20,0,0,1,11.51,26.4L153.13,96.69a16,16,0,0,0,8.93,20.76L187,127.29a8,8,0,0,1,5,7.43Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><line x1="43.93" y1="105.57" x2="192.8" y2="165.12" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/></svg>', efe = `<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path opacity="0.2" d="M18.3589 4.375V7.5H3.35889V4.375C3.35889 4.20924 3.42473 4.05027 3.54195 3.93306C3.65916 3.81585 3.81813 3.75 3.98389 3.75H17.7339C17.8996 3.75 18.0586 3.81585 18.1758 3.93306C18.293 4.05027 18.3589 4.20924 18.3589 4.375Z" fill="none"/>
<path d="M17.7339 3.125H3.98389C3.65237 3.125 3.33442 3.2567 3.1 3.49112C2.86558 3.72554 2.73389 4.04348 2.73389 4.375V15.625C2.73389 15.9565 2.86558 16.2745 3.1 16.5089C3.33442 16.7433 3.65237 16.875 3.98389 16.875H17.7339C18.0654 16.875 18.3833 16.7433 18.6178 16.5089C18.8522 16.2745 18.9839 15.9565 18.9839 15.625V4.375C18.9839 4.04348 18.8522 3.72554 18.6178 3.49112C18.3833 3.2567 18.0654 3.125 17.7339 3.125ZM17.7339 4.375V6.875H3.98389V4.375H17.7339ZM17.7339 15.625H3.98389V8.125H17.7339V15.625Z" fill="currentColor"/>
</svg>
`, tfe = `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M240,208h-8V72a8,8,0,0,0-8-8H184V40a8,8,0,0,0-8-8H80a8,8,0,0,0-8,8V96H32a8,8,0,0,0-8,8V208H16a8,8,0,0,0,0,16H240a8,8,0,0,0,0-16ZM40,112H80a8,8,0,0,0,8-8V48h80V72a8,8,0,0,0,8,8h40V208H152V168a8,8,0,0,0-8-8H112a8,8,0,0,0-8,8v40H40Zm96,96H120V176h16ZM112,72a8,8,0,0,1,8-8h16a8,8,0,0,1,0,16H120A8,8,0,0,1,112,72Zm0,32a8,8,0,0,1,8-8h16a8,8,0,0,1,0,16H120A8,8,0,0,1,112,104Zm56,0a8,8,0,0,1,8-8h16a8,8,0,0,1,0,16H176A8,8,0,0,1,168,104ZM88,136a8,8,0,0,1-8,8H64a8,8,0,0,1,0-16H80A8,8,0,0,1,88,136Zm0,32a8,8,0,0,1-8,8H64a8,8,0,0,1,0-16H80A8,8,0,0,1,88,168Zm24-32a8,8,0,0,1,8-8h16a8,8,0,0,1,0,16H120A8,8,0,0,1,112,136Zm56,0a8,8,0,0,1,8-8h16a8,8,0,0,1,0,16H176A8,8,0,0,1,168,136Zm0,32a8,8,0,0,1,8-8h16a8,8,0,0,1,0,16H176A8,8,0,0,1,168,168Z"></path></svg>
`, ofe = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M232,224H208V32h8a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16h8V224H24a8,8,0,0,0,0,16H232a8,8,0,0,0,0-16ZM64,32H192V224H160V184a8,8,0,0,0-8-8H104a8,8,0,0,0-8,8v40H64Zm80,192H112V192h32ZM88,64a8,8,0,0,1,8-8h16a8,8,0,0,1,0,16H96A8,8,0,0,1,88,64Zm48,0a8,8,0,0,1,8-8h16a8,8,0,0,1,0,16H144A8,8,0,0,1,136,64ZM88,104a8,8,0,0,1,8-8h16a8,8,0,0,1,0,16H96A8,8,0,0,1,88,104Zm48,0a8,8,0,0,1,8-8h16a8,8,0,0,1,0,16H144A8,8,0,0,1,136,104ZM88,144a8,8,0,0,1,8-8h16a8,8,0,0,1,0,16H96A8,8,0,0,1,88,144Zm48,0a8,8,0,0,1,8-8h16a8,8,0,0,1,0,16H144A8,8,0,0,1,136,144Z"></path></svg>', nfe = `<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.25 9.69727H13.75C13.9158 9.69727 14.0747 9.63142 14.1919 9.51421C14.3092 9.397 14.375 9.23803 14.375 9.07227V5.32227C14.375 5.15651 14.3092 4.99753 14.1919 4.88032C14.0747 4.76311 13.9158 4.69727 13.75 4.69727H6.25C6.08424 4.69727 5.92527 4.76311 5.80806 4.88032C5.69085 4.99753 5.625 5.15651 5.625 5.32227V9.07227C5.625 9.23803 5.69085 9.397 5.80806 9.51421C5.92527 9.63142 6.08424 9.69727 6.25 9.69727ZM6.875 5.94727H13.125V8.44727H6.875V5.94727ZM15.625 2.19727H4.375C4.04348 2.19727 3.72554 2.32896 3.49112 2.56338C3.2567 2.7978 3.125 3.11575 3.125 3.44727V17.1973C3.125 17.5288 3.2567 17.8467 3.49112 18.0811C3.72554 18.3156 4.04348 18.4473 4.375 18.4473H15.625C15.9565 18.4473 16.2745 18.3156 16.5089 18.0811C16.7433 17.8467 16.875 17.5288 16.875 17.1973V3.44727C16.875 3.11575 16.7433 2.7978 16.5089 2.56338C16.2745 2.32896 15.9565 2.19727 15.625 2.19727ZM15.625 17.1973H4.375V3.44727H15.625V17.1973ZM7.8125 11.8848C7.8125 12.0702 7.75752 12.2514 7.6545 12.4056C7.55149 12.5598 7.40507 12.6799 7.23377 12.7509C7.06246 12.8219 6.87396 12.8404 6.6921 12.8043C6.51025 12.7681 6.3432 12.6788 6.21209 12.5477C6.08098 12.4166 5.99169 12.2495 5.95551 12.0677C5.91934 11.8858 5.93791 11.6973 6.00886 11.526C6.07982 11.3547 6.19998 11.2083 6.35415 11.1053C6.50832 11.0022 6.68958 10.9473 6.875 10.9473C7.12364 10.9473 7.3621 11.046 7.53791 11.2219C7.71373 11.3977 7.8125 11.6361 7.8125 11.8848ZM10.9375 11.8848C10.9375 12.0702 10.8825 12.2514 10.7795 12.4056C10.6765 12.5598 10.5301 12.6799 10.3588 12.7509C10.1875 12.8219 9.99896 12.8404 9.8171 12.8043C9.63525 12.7681 9.4682 12.6788 9.33709 12.5477C9.20598 12.4166 9.11669 12.2495 9.08051 12.0677C9.04434 11.8858 9.06291 11.6973 9.13386 11.526C9.20482 11.3547 9.32498 11.2083 9.47915 11.1053C9.63332 11.0022 9.81458 10.9473 10 10.9473C10.2486 10.9473 10.4871 11.046 10.6629 11.2219C10.8387 11.3977 10.9375 11.6361 10.9375 11.8848ZM14.0625 11.8848C14.0625 12.0702 14.0075 12.2514 13.9045 12.4056C13.8015 12.5598 13.6551 12.6799 13.4838 12.7509C13.3125 12.8219 13.124 12.8404 12.9421 12.8043C12.7602 12.7681 12.5932 12.6788 12.4621 12.5477C12.331 12.4166 12.2417 12.2495 12.2055 12.0677C12.1693 11.8858 12.1879 11.6973 12.2589 11.526C12.3298 11.3547 12.45 11.2083 12.6042 11.1053C12.7583 11.0022 12.9396 10.9473 13.125 10.9473C13.3736 10.9473 13.6121 11.046 13.7879 11.2219C13.9637 11.3977 14.0625 11.6361 14.0625 11.8848ZM7.8125 15.0098C7.8125 15.1952 7.75752 15.3764 7.6545 15.5306C7.55149 15.6848 7.40507 15.8049 7.23377 15.8759C7.06246 15.9469 6.87396 15.9654 6.6921 15.9293C6.51025 15.8931 6.3432 15.8038 6.21209 15.6727C6.08098 15.5416 5.99169 15.3745 5.95551 15.1927C5.91934 15.0108 5.93791 14.8223 6.00886 14.651C6.07982 14.4797 6.19998 14.3333 6.35415 14.2303C6.50832 14.1272 6.68958 14.0723 6.875 14.0723C7.12364 14.0723 7.3621 14.171 7.53791 14.3469C7.71373 14.5227 7.8125 14.7611 7.8125 15.0098ZM10.9375 15.0098C10.9375 15.1952 10.8825 15.3764 10.7795 15.5306C10.6765 15.6848 10.5301 15.8049 10.3588 15.8759C10.1875 15.9469 9.99896 15.9654 9.8171 15.9293C9.63525 15.8931 9.4682 15.8038 9.33709 15.6727C9.20598 15.5416 9.11669 15.3745 9.08051 15.1927C9.04434 15.0108 9.06291 14.8223 9.13386 14.651C9.20482 14.4797 9.32498 14.3333 9.47915 14.2303C9.63332 14.1272 9.81458 14.0723 10 14.0723C10.2486 14.0723 10.4871 14.171 10.6629 14.3469C10.8387 14.5227 10.9375 14.7611 10.9375 15.0098ZM14.0625 15.0098C14.0625 15.1952 14.0075 15.3764 13.9045 15.5306C13.8015 15.6848 13.6551 15.8049 13.4838 15.8759C13.3125 15.9469 13.124 15.9654 12.9421 15.9293C12.7602 15.8931 12.5932 15.8038 12.4621 15.6727C12.331 15.5416 12.2417 15.3745 12.2055 15.1927C12.1693 15.0108 12.1879 14.8223 12.2589 14.651C12.3298 14.4797 12.45 14.3333 12.6042 14.2303C12.7583 14.1272 12.9396 14.0723 13.125 14.0723C13.3736 14.0723 13.6121 14.171 13.7879 14.3469C13.9637 14.5227 14.0625 14.7611 14.0625 15.0098Z" fill="currentColor"/>
</svg>
`, sfe = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M208,32H184V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM72,48v8a8,8,0,0,0,16,0V48h80v8a8,8,0,0,0,16,0V48h24V80H48V48ZM208,208H48V96H208V208Z"></path></svg>', ife = `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
    <path d="M9.375 39.375V18.375H39.375V26.4C39.375 27.0627 39.9123 27.6 40.575 27.6H41.175C41.8377 27.6 42.375 27.0627 42.375 26.4V9.375C42.375 8.57935 42.0589 7.81629 41.4963 7.25368C40.9337 6.69107 40.1707 6.375 39.375 6.375H34.875V4.875C34.875 4.47718 34.717 4.09564 34.4357 3.81434C34.1544 3.53304 33.7728 3.375 33.375 3.375C32.9772 3.375 32.5956 3.53304 32.3143 3.81434C32.033 4.09564 31.875 4.47718 31.875 4.875V6.375H16.875V4.875C16.875 4.47718 16.717 4.09564 16.4357 3.81434C16.1544 3.53304 15.7728 3.375 15.375 3.375C14.9772 3.375 14.5956 3.53304 14.3143 3.81434C14.033 4.09564 13.875 4.47718 13.875 4.875V6.375H9.375C8.57935 6.375 7.81629 6.69107 7.25368 7.25368C6.69107 7.81629 6.375 8.57935 6.375 9.375V39.375C6.375 40.1706 6.69107 40.9337 7.25368 41.4963C7.81629 42.0589 8.57935 42.375 9.375 42.375H22.8C23.4627 42.375 24 41.8377 24 41.175V40.575C24 39.9123 23.4627 39.375 22.8 39.375H9.375ZM13.875 9.375V10.875C13.875 11.2728 14.033 11.6544 14.3143 11.9357C14.5956 12.217 14.9772 12.375 15.375 12.375C15.7728 12.375 16.1544 12.217 16.4357 11.9357C16.717 11.6544 16.875 11.2728 16.875 10.875V9.375H31.875V10.875C31.875 11.2728 32.033 11.6544 32.3143 11.9357C32.5956 12.217 32.9772 12.375 33.375 12.375C33.7728 12.375 34.1544 12.217 34.4357 11.9357C34.717 11.6544 34.875 11.2728 34.875 10.875V9.375H39.375V15.375H9.375V9.375H13.875Z" fill="#4A545E"/>
    <path d="M40.8 36C40.8 32.0235 37.5765 28.8 33.6 28.8C29.6236 28.8 26.4 32.0235 26.4 36C26.4 39.9764 29.6236 43.2 33.6 43.2V45.6C28.2981 45.6 24 41.3019 24 36C24 30.6981 28.2981 26.4 33.6 26.4C38.9019 26.4 43.2 30.6981 43.2 36C43.2 41.3019 38.9019 45.6 33.6 45.6V43.2C37.5765 43.2 40.8 39.9764 40.8 36Z" fill="#4A545E"/>
    <path d="M32.4 31.2C32.4 30.5373 32.9373 30 33.6 30C34.2627 30 34.8 30.5373 34.8 31.2V34.8H38.4C39.0627 34.8 39.6 35.3373 39.6 36C39.6 36.6627 39.0627 37.2 38.4 37.2H34.0805C33.269 37.2 32.5922 36.6244 32.4352 35.8594L32.4 35.5195V31.2Z" fill="#4A545E"/>
</svg>`, rfe = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M213.66,130.34a8,8,0,0,1,0,11.32l-80,80a8,8,0,0,1-11.32,0l-80-80a8,8,0,0,1,11.32-11.32L128,204.69l74.34-74.35A8,8,0,0,1,213.66,130.34Zm-91.32,11.32a8,8,0,0,0,11.32,0l80-80a8,8,0,0,0-11.32-11.32L128,124.69,53.66,50.34A8,8,0,0,0,42.34,61.66Z"></path></svg>', lfe = `<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M8.85378 8.35378L3.85378 13.3538C3.75996 13.4476 3.63272 13.5003 3.50003 13.5003C3.36735 13.5003 3.2401 13.4476 3.14628 13.3538C3.05246 13.26 2.99976 13.1327 2.99976 13C2.99976 12.8674 3.05246 12.7401 3.14628 12.6463L7.79316 8.00003L3.14628 3.35378C3.05246 3.25996 2.99976 3.13272 2.99976 3.00003C2.99976 2.86735 3.05246 2.7401 3.14628 2.64628C3.2401 2.55246 3.36735 2.49976 3.50003 2.49976C3.63272 2.49976 3.75996 2.55246 3.85378 2.64628L8.85378 7.64628C8.90027 7.69272 8.93715 7.74786 8.96231 7.80856C8.98748 7.86926 9.00043 7.93433 9.00043 8.00003C9.00043 8.06574 8.98748 8.1308 8.96231 8.1915C8.93715 8.2522 8.90027 8.30735 8.85378 8.35378ZM13.8538 7.64628L8.85378 2.64628C8.75996 2.55246 8.63272 2.49976 8.50003 2.49976C8.36735 2.49976 8.2401 2.55246 8.14628 2.64628C8.05246 2.7401 7.99976 2.86735 7.99976 3.00003C7.99976 3.13272 8.05246 3.25996 8.14628 3.35378L12.7932 8.00003L8.14628 12.6463C8.05246 12.7401 7.99976 12.8674 7.99976 13C7.99976 13.1327 8.05246 13.26 8.14628 13.3538C8.2401 13.4476 8.36735 13.5003 8.50003 13.5003C8.63272 13.5003 8.75996 13.4476 8.85378 13.3538L13.8538 8.35378C13.9003 8.30735 13.9372 8.2522 13.9623 8.1915C13.9875 8.1308 14.0004 8.06574 14.0004 8.00003C14.0004 7.93433 13.9875 7.86926 13.9623 7.80856C13.9372 7.74786 13.9003 7.69272 13.8538 7.64628Z" fill="currentColor"/>
</svg>
`, afe = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M213.66,194.34a8,8,0,0,1-11.32,11.32L128,131.31,53.66,205.66a8,8,0,0,1-11.32-11.32l80-80a8,8,0,0,1,11.32,0Zm-160-68.68L128,51.31l74.34,74.35a8,8,0,0,0,11.32-11.32l-80-80a8,8,0,0,0-11.32,0l-80,80a8,8,0,0,0,11.32,11.32Z"></path></svg>', cfe = `<svg width="9" height="5" viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.91504 4.71191L0.16504 0.961913C0.0593681 0.85624 1.87619e-06 0.712918 1.88272e-06 0.563475C1.88925e-06 0.414032 0.0593681 0.27071 0.16504 0.165038C0.270712 0.0593655 0.414035 -3.57885e-07 0.563478 -3.52466e-07C0.712921 -3.47047e-07 0.856243 0.0593656 0.961915 0.165038L4.31301 3.51707L7.66504 0.165976C7.71736 0.113652 7.77948 0.0721467 7.84784 0.0438294C7.91621 0.0155121 7.98948 0.000937315 8.06348 0.000937318C8.13747 0.000937321 8.21075 0.0155121 8.27911 0.0438294C8.34747 0.0721467 8.40959 0.113652 8.46191 0.165976C8.51424 0.218299 8.55574 0.280416 8.58406 0.34878C8.61238 0.417145 8.62695 0.490417 8.62695 0.564413C8.62695 0.63841 8.61238 0.711682 8.58406 0.780046C8.55574 0.84841 8.51424 0.910527 8.46191 0.962851L4.71191 4.71285C4.6596 4.76523 4.59745 4.80676 4.52904 4.83507C4.46064 4.86338 4.38732 4.87791 4.31328 4.87783C4.23925 4.87774 4.16596 4.86304 4.09762 4.83457C4.02928 4.8061 3.96724 4.76441 3.91504 4.71191Z" fill="currentColor"/>
</svg>
`, dfe = `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" viewBox="0 0 256 256"><path d="M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,53.66,90.34L128,164.69l74.34-74.35a8,8,0,0,1,11.32,11.32Z"></path></svg>
`, ufe = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M165.66,202.34a8,8,0,0,1-11.32,11.32l-80-80a8,8,0,0,1,0-11.32l80-80a8,8,0,0,1,11.32,11.32L91.31,128Z"></path></svg>', hfe = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M184.49,136.49l-80,80a12,12,0,0,1-17-17L159,128,87.51,56.49a12,12,0,1,1,17-17l80,80A12,12,0,0,1,184.49,136.49Z"></path></svg>', gfe = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><rect width="256" height="256" fill="none"/><polyline points="96 48 176 128 96 208" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/></svg>', pfe = `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 256 256"><path d="M181.66,133.66l-80,80a8,8,0,0,1-11.32-11.32L164.69,128,90.34,53.66a8,8,0,0,1,11.32-11.32l80,80A8,8,0,0,1,181.66,133.66Z" fill="currentColor"></path></svg>
`, ffe = `<svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.39844 0.727052L9.14844 4.47705C9.25411 4.58272 9.31347 4.72605 9.31347 4.87549C9.31347 5.02493 9.25411 5.16825 9.14844 5.27393C9.04276 5.3796 8.89944 5.43896 8.75 5.43896C8.60056 5.43896 8.45723 5.3796 8.35156 5.27393L5.00047 1.9219L1.64844 5.27299C1.59611 5.32531 1.534 5.36682 1.46563 5.39514C1.39727 5.42345 1.324 5.43803 1.25 5.43803C1.176 5.43803 1.10273 5.42345 1.03437 5.39514C0.966002 5.36682 0.903885 5.32531 0.851562 5.27299C0.799238 5.22067 0.757733 5.15855 0.729416 5.09018C0.701098 5.02182 0.686523 4.94855 0.686523 4.87455C0.686523 4.80055 0.701098 4.72728 0.729416 4.65892C0.757733 4.59055 0.799238 4.52844 0.851562 4.47611L4.60156 0.726115C4.65388 0.673736 4.71603 0.632201 4.78443 0.60389C4.85284 0.57558 4.92616 0.561052 5.00019 0.56114C5.07423 0.561227 5.14751 0.575927 5.21585 0.604398C5.28419 0.632869 5.34624 0.67455 5.39844 0.727052Z" fill="currentColor"/>
</svg>
`, vfe = `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" viewBox="0 0 256 256"><path d="M213.66,165.66a8,8,0,0,1-11.32,0L128,91.31,53.66,165.66a8,8,0,0,1-11.32-11.32l80-80a8,8,0,0,1,11.32,0l80,80A8,8,0,0,1,213.66,165.66Z"></path></svg>
`, mfe = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M232,208a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8V48a8,8,0,0,1,16,0v94.37L90.73,98a8,8,0,0,1,10.07-.38l58.81,44.11L218.73,90a8,8,0,1,1,10.54,12l-64,56a8,8,0,0,1-10.07.38L96.39,114.29,40,163.63V200H224A8,8,0,0,1,232,208Z"></path></svg>', Cfe = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.8538 6.14625C10.9002 6.19269 10.9371 6.24783 10.9623 6.30853C10.9874 6.36923 11.0004 6.43429 11.0004 6.5C11.0004 6.56571 10.9874 6.63077 10.9623 6.69147C10.9371 6.75217 10.9002 6.80731 10.8538 6.85375L7.35375 10.3538C7.30732 10.4002 7.25217 10.4371 7.19147 10.4623C7.13077 10.4874 7.06571 10.5004 7 10.5004C6.9343 10.5004 6.86923 10.4874 6.80853 10.4623C6.74783 10.4371 6.69269 10.4002 6.64625 10.3538L5.14625 8.85375C5.05243 8.75993 4.99972 8.63268 4.99972 8.5C4.99972 8.36732 5.05243 8.24007 5.14625 8.14625C5.24007 8.05243 5.36732 7.99972 5.5 7.99972C5.63268 7.99972 5.75993 8.05243 5.85375 8.14625L7 9.29313L10.1463 6.14625C10.1927 6.09976 10.2478 6.06288 10.3085 6.03772C10.3692 6.01256 10.4343 5.99961 10.5 5.99961C10.5657 5.99961 10.6308 6.01256 10.6915 6.03772C10.7522 6.06288 10.8073 6.09976 10.8538 6.14625ZM14.5 8C14.5 9.28558 14.1188 10.5423 13.4046 11.6112C12.6903 12.6801 11.6752 13.5132 10.4874 14.0052C9.29973 14.4972 7.99279 14.6259 6.73192 14.3751C5.47104 14.1243 4.31285 13.5052 3.40381 12.5962C2.49477 11.6872 1.8757 10.529 1.6249 9.26809C1.37409 8.00721 1.50282 6.70028 1.99479 5.51256C2.48676 4.32484 3.31988 3.30968 4.3888 2.59545C5.45772 1.88122 6.71442 1.5 8 1.5C9.72335 1.50182 11.3756 2.18722 12.5942 3.40582C13.8128 4.62441 14.4982 6.27665 14.5 8ZM13.5 8C13.5 6.9122 13.1774 5.84883 12.5731 4.94436C11.9687 4.03989 11.1098 3.33494 10.1048 2.91866C9.09977 2.50238 7.9939 2.39346 6.92701 2.60568C5.86011 2.8179 4.8801 3.34172 4.11092 4.11091C3.34173 4.8801 2.8179 5.86011 2.60568 6.927C2.39347 7.9939 2.50238 9.09977 2.91867 10.1048C3.33495 11.1098 4.0399 11.9687 4.94437 12.5731C5.84884 13.1774 6.91221 13.5 8 13.5C9.45819 13.4983 10.8562 12.9184 11.8873 11.8873C12.9184 10.8562 13.4983 9.45818 13.5 8Z" fill="currentColor"/>
</svg>
`, wfe = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><rect width="256" height="256" fill="none"/><polyline points="40 144 96 200 224 72" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/></svg>', bfe = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><rect width="256" height="256" fill="none"/><circle cx="128" cy="128" r="104"/></svg>', yfe = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8 1.5C6.71442 1.5 5.45772 1.88122 4.3888 2.59545C3.31988 3.30968 2.48676 4.32484 1.99479 5.51256C1.50282 6.70028 1.37409 8.00721 1.6249 9.26809C1.8757 10.529 2.49477 11.6872 3.40381 12.5962C4.31285 13.5052 5.47104 14.1243 6.73192 14.3751C7.99279 14.6259 9.29973 14.4972 10.4874 14.0052C11.6752 13.5132 12.6903 12.6801 13.4046 11.6112C14.1188 10.5423 14.5 9.28558 14.5 8C14.4982 6.27665 13.8128 4.62441 12.5942 3.40582C11.3756 2.18722 9.72335 1.50182 8 1.5ZM8 13.5C6.91221 13.5 5.84884 13.1774 4.94437 12.5731C4.0399 11.9687 3.33495 11.1098 2.91867 10.1048C2.50238 9.09977 2.39347 7.9939 2.60568 6.927C2.8179 5.86011 3.34173 4.8801 4.11092 4.11091C4.8801 3.34172 5.86011 2.8179 6.92701 2.60568C7.9939 2.39346 9.09977 2.50238 10.1048 2.91866C11.1098 3.33494 11.9687 4.03989 12.5731 4.94436C13.1774 5.84883 13.5 6.9122 13.5 8C13.4983 9.45818 12.9184 10.8562 11.8873 11.8873C10.8562 12.9184 9.45819 13.4983 8 13.5Z" fill="currentColor"/>
</svg>
`, _fe = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M240,208h-8V88a8,8,0,0,0-8-8H160a8,8,0,0,0-8,8v40H104V40a8,8,0,0,0-8-8H32a8,8,0,0,0-8,8V208H16a8,8,0,0,0,0,16H240a8,8,0,0,0,0-16ZM168,96h48V208H168Zm-16,48v64H104V144ZM40,48H88V208H40ZM72,72V88a8,8,0,0,1-16,0V72a8,8,0,0,1,16,0Zm0,48v16a8,8,0,0,1-16,0V120a8,8,0,0,1,16,0Zm0,48v16a8,8,0,0,1-16,0V168a8,8,0,0,1,16,0Zm48,16V168a8,8,0,0,1,16,0v16a8,8,0,0,1-16,0Zm64,0V168a8,8,0,0,1,16,0v16a8,8,0,0,1-16,0Zm0-48V120a8,8,0,0,1,16,0v16a8,8,0,0,1-16,0Z"></path></svg>', Sfe = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M168,152a8,8,0,0,1-8,8H96a8,8,0,0,1,0-16h64A8,8,0,0,1,168,152Zm-8-40H96a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16Zm56-64V216a16,16,0,0,1-16,16H56a16,16,0,0,1-16-16V48A16,16,0,0,1,56,32H92.26a47.92,47.92,0,0,1,71.48,0H200A16,16,0,0,1,216,48ZM96,64h64a32,32,0,0,0-64,0ZM200,48H173.25A47.93,47.93,0,0,1,176,64v8a8,8,0,0,1-8,8H88a8,8,0,0,1-8-8V64a47.93,47.93,0,0,1,2.75-16H56V216H200Z"></path></svg>', xfe = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm64-88a8,8,0,0,1-8,8H128a8,8,0,0,1-8-8V72a8,8,0,0,1,16,0v48h48A8,8,0,0,1,192,128Z"></path></svg>', Mfe = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M69.12,94.15,28.5,128l40.62,33.85a8,8,0,1,1-10.24,12.29l-48-40a8,8,0,0,1,0-12.29l48-40a8,8,0,0,1,10.24,12.3Zm176,27.7-48-40a8,8,0,1,0-10.24,12.3L227.5,128l-40.62,33.85a8,8,0,1,0,10.24,12.29l48-40a8,8,0,0,0,0-12.29ZM162.73,32.48a8,8,0,0,0-10.25,4.79l-64,176a8,8,0,0,0,4.79,10.26A8.14,8.14,0,0,0,96,224a8,8,0,0,0,7.52-5.27l64-176A8,8,0,0,0,162.73,32.48Z"></path></svg>', Afe = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M104,32H64A16,16,0,0,0,48,48V208a16,16,0,0,0,16,16h40a16,16,0,0,0,16-16V48A16,16,0,0,0,104,32Zm0,176H64V48h40ZM192,32H152a16,16,0,0,0-16,16V208a16,16,0,0,0,16,16h40a16,16,0,0,0,16-16V48A16,16,0,0,0,192,32Zm0,176H152V48h40Z"></path></svg>', Lfe = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M216,32H88a8,8,0,0,0-8,8V80H40a8,8,0,0,0-8,8V216a8,8,0,0,0,8,8H168a8,8,0,0,0,8-8V176h40a8,8,0,0,0,8-8V40A8,8,0,0,0,216,32ZM160,208H48V96H160Zm48-48H176V88a8,8,0,0,0-8-8H96V48H208Z"></path></svg>', Efe = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M184,208a8,8,0,0,1-8,8H160a40,40,0,0,1-32-16,40,40,0,0,1-32,16H80a8,8,0,0,1,0-16H96a24,24,0,0,0,24-24V136H104a8,8,0,0,1,0-16h16V80A24,24,0,0,0,96,56H80a8,8,0,0,1,0-16H96a40,40,0,0,1,32,16,40,40,0,0,1,32-16h16a8,8,0,0,1,0,16H160a24,24,0,0,0-24,24v40h16a8,8,0,0,1,0,16H136v40a24,24,0,0,0,24,24h16A8,8,0,0,1,184,208Z"></path></svg>', Pfe = `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" viewBox="0 0 256 256"><path d="M104,60A12,12,0,1,1,92,48,12,12,0,0,1,104,60Zm60,12a12,12,0,1,0-12-12A12,12,0,0,0,164,72ZM92,116a12,12,0,1,0,12,12A12,12,0,0,0,92,116Zm72,0a12,12,0,1,0,12,12A12,12,0,0,0,164,116ZM92,184a12,12,0,1,0,12,12A12,12,0,0,0,92,184Zm72,0a12,12,0,1,0,12,12A12,12,0,0,0,164,184Z"></path></svg>
`, Rfe = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.5 5.75C4.5 5.89834 4.45601 6.04334 4.3736 6.16668C4.29119 6.29001 4.17406 6.38614 4.03701 6.44291C3.89997 6.49968 3.74917 6.51453 3.60368 6.48559C3.4582 6.45665 3.32456 6.38522 3.21967 6.28033C3.11478 6.17544 3.04335 6.0418 3.01441 5.89632C2.98547 5.75083 3.00032 5.60003 3.05709 5.46299C3.11386 5.32594 3.20999 5.20881 3.33332 5.1264C3.45666 5.04399 3.60166 5 3.75 5C3.94891 5 4.13968 5.07902 4.28033 5.21967C4.42098 5.36032 4.5 5.55109 4.5 5.75ZM8 5C7.85167 5 7.70666 5.04399 7.58332 5.1264C7.45999 5.20881 7.36386 5.32594 7.30709 5.46299C7.25033 5.60003 7.23547 5.75083 7.26441 5.89632C7.29335 6.0418 7.36478 6.17544 7.46967 6.28033C7.57456 6.38522 7.7082 6.45665 7.85368 6.48559C7.99917 6.51453 8.14997 6.49968 8.28701 6.44291C8.42406 6.38614 8.54119 6.29001 8.6236 6.16668C8.70601 6.04334 8.75 5.89834 8.75 5.75C8.75 5.55109 8.67098 5.36032 8.53033 5.21967C8.38968 5.07902 8.19891 5 8 5ZM12.25 6.5C12.3983 6.5 12.5433 6.45601 12.6667 6.3736C12.79 6.29119 12.8861 6.17406 12.9429 6.03701C12.9997 5.89997 13.0145 5.74917 12.9856 5.60368C12.9567 5.4582 12.8852 5.32456 12.7803 5.21967C12.6754 5.11478 12.5418 5.04335 12.3963 5.01441C12.2508 4.98547 12.1 5.00032 11.963 5.05709C11.8259 5.11386 11.7088 5.20999 11.6264 5.33332C11.544 5.45666 11.5 5.60166 11.5 5.75C11.5 5.94891 11.579 6.13968 11.7197 6.28033C11.8603 6.42098 12.0511 6.5 12.25 6.5ZM3.75 9.5C3.60166 9.5 3.45666 9.54399 3.33332 9.6264C3.20999 9.70881 3.11386 9.82594 3.05709 9.96299C3.00032 10.1 2.98547 10.2508 3.01441 10.3963C3.04335 10.5418 3.11478 10.6754 3.21967 10.7803C3.32456 10.8852 3.4582 10.9567 3.60368 10.9856C3.74917 11.0145 3.89997 10.9997 4.03701 10.9429C4.17406 10.8861 4.29119 10.79 4.3736 10.6667C4.45601 10.5433 4.5 10.3983 4.5 10.25C4.5 10.0511 4.42098 9.86032 4.28033 9.71967C4.13968 9.57902 3.94891 9.5 3.75 9.5ZM8 9.5C7.85167 9.5 7.70666 9.54399 7.58332 9.6264C7.45999 9.70881 7.36386 9.82594 7.30709 9.96299C7.25033 10.1 7.23547 10.2508 7.26441 10.3963C7.29335 10.5418 7.36478 10.6754 7.46967 10.7803C7.57456 10.8852 7.7082 10.9567 7.85368 10.9856C7.99917 11.0145 8.14997 10.9997 8.28701 10.9429C8.42406 10.8861 8.54119 10.79 8.6236 10.6667C8.70601 10.5433 8.75 10.3983 8.75 10.25C8.75 10.0511 8.67098 9.86032 8.53033 9.71967C8.38968 9.57902 8.19891 9.5 8 9.5ZM12.25 9.5C12.1017 9.5 11.9567 9.54399 11.8333 9.6264C11.71 9.70881 11.6139 9.82594 11.5571 9.96299C11.5003 10.1 11.4855 10.2508 11.5144 10.3963C11.5434 10.5418 11.6148 10.6754 11.7197 10.7803C11.8246 10.8852 11.9582 10.9567 12.1037 10.9856C12.2492 11.0145 12.4 10.9997 12.537 10.9429C12.6741 10.8861 12.7912 10.79 12.8736 10.6667C12.956 10.5433 13 10.3983 13 10.25C13 10.0511 12.921 9.86032 12.7803 9.71967C12.6397 9.57902 12.4489 9.5 12.25 9.5Z" fill="#4A545E"/>
</svg>
`, Ffe = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm12-88a12,12,0,1,1-12-12A12,12,0,0,1,140,128Zm44,0a12,12,0,1,1-12-12A12,12,0,0,1,184,128Zm-88,0a12,12,0,1,1-12-12A12,12,0,0,1,96,128Z"></path></svg>', Tfe = `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" viewBox="0 0 256 256"><path d="M140,128a12,12,0,1,1-12-12A12,12,0,0,1,140,128ZM128,72a12,12,0,1,0-12-12A12,12,0,0,0,128,72Zm0,112a12,12,0,1,0,12,12A12,12,0,0,0,128,184Z"></path></svg>
`, Ife = `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" viewBox="0 0 256 256"><path d="M140,128a12,12,0,1,1-12-12A12,12,0,0,1,140,128Zm56-12a12,12,0,1,0,12,12A12,12,0,0,0,196,116ZM60,116a12,12,0,1,0,12,12A12,12,0,0,0,60,116Z"></path></svg>
`, Dfe = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M224,144v64a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V144a8,8,0,0,1,16,0v56H208V144a8,8,0,0,1,16,0Zm-101.66,5.66a8,8,0,0,0,11.32,0l40-40a8,8,0,0,0-11.32-11.32L136,124.69V32a8,8,0,0,0-16,0v92.69L93.66,98.34a8,8,0,0,0-11.32,11.32Z"></path></svg>', kfe = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M224,48H32a8,8,0,0,0-8,8V192a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A8,8,0,0,0,224,48Zm-96,85.15L52.57,64H203.43ZM98.71,128,40,181.81V74.19Zm11.84,10.85,12,11.05a8,8,0,0,0,10.82,0l12-11.05,58,53.15H52.57ZM157.29,128,216,74.18V181.82Z"></path></svg>', Hfe = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><rect width="256" height="256" fill="none"/><line x1="40" y1="160" x2="216" y2="160" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><line x1="40" y1="96" x2="216" y2="96" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/></svg>', Vfe = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><rect width="256" height="256" fill="none"/><path d="M128,56C48,56,16,128,16,128s32,72,112,72,112-72,112-72S208,56,128,56Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><circle cx="128" cy="128" r="40" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/></svg>', Ofe = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M53.92,34.62A8,8,0,1,0,42.08,45.38L61.32,66.55C25,88.84,9.38,123.2,8.69,124.76a8,8,0,0,0,0,6.5c.35.79,8.82,19.57,27.65,38.4C61.43,194.74,93.12,208,128,208a127.11,127.11,0,0,0,52.07-10.83l22,24.21a8,8,0,1,0,11.84-10.76Zm47.33,75.84,41.67,45.85a32,32,0,0,1-41.67-45.85ZM128,192c-30.78,0-57.67-11.19-79.93-33.25A133.16,133.16,0,0,1,25,128c4.69-8.79,19.66-33.39,47.35-49.38l18,19.75a48,48,0,0,0,63.66,70l14.73,16.2A112,112,0,0,1,128,192Zm6-95.43a8,8,0,0,1,3-15.72,48.16,48.16,0,0,1,38.77,42.64,8,8,0,0,1-7.22,8.71,6.39,6.39,0,0,1-.75,0,8,8,0,0,1-8-7.26A32.09,32.09,0,0,0,134,96.57Zm113.28,34.69c-.42.94-10.55,23.37-33.36,43.8a8,8,0,1,1-10.67-11.92A132.77,132.77,0,0,0,231.05,128a133.15,133.15,0,0,0-23.12-30.77C185.67,75.19,158.78,64,128,64a118.37,118.37,0,0,0-19.36,1.57A8,8,0,1,1,106,49.79,134,134,0,0,1,128,48c34.88,0,66.57,13.26,91.66,38.35,18.83,18.83,27.3,37.62,27.65,38.41A8,8,0,0,1,247.31,131.26Z"></path></svg>', Bfe = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M247.31,124.76c-.35-.79-8.82-19.58-27.65-38.41C194.57,61.26,162.88,48,128,48S61.43,61.26,36.34,86.35C17.51,105.18,9,124,8.69,124.76a8,8,0,0,0,0,6.5c.35.79,8.82,19.57,27.65,38.4C61.43,194.74,93.12,208,128,208s66.57-13.26,91.66-38.34c18.83-18.83,27.3-37.61,27.65-38.4A8,8,0,0,0,247.31,124.76ZM128,192c-30.78,0-57.67-11.19-79.93-33.25A133.47,133.47,0,0,1,25,128,133.33,133.33,0,0,1,48.07,97.25C70.33,75.19,97.22,64,128,64s57.67,11.19,79.93,33.25A133.46,133.46,0,0,1,231.05,128C223.84,141.46,192.43,192,128,192Zm0-112a48,48,0,1,0,48,48A48.05,48.05,0,0,0,128,80Zm0,80a32,32,0,1,1,32-32A32,32,0,0,1,128,160Z"></path></svg>', $fe = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16.6922 6.43281L12.3172 2.05781C12.2591 1.99979 12.1902 1.95378 12.1143 1.92241C12.0384 1.89105 11.9571 1.87494 11.875 1.875H4.375C4.04348 1.875 3.72554 2.0067 3.49112 2.24112C3.2567 2.47554 3.125 2.79348 3.125 3.125V16.875C3.125 17.2065 3.2567 17.5245 3.49112 17.7589C3.72554 17.9933 4.04348 18.125 4.375 18.125H15.625C15.9565 18.125 16.2745 17.9933 16.5089 17.7589C16.7433 17.5245 16.875 17.2065 16.875 16.875V6.875C16.8751 6.7929 16.859 6.71159 16.8276 6.63572C16.7962 6.55985 16.7502 6.4909 16.6922 6.43281ZM12.5 4.00859L14.7414 6.25H12.5V4.00859ZM15.625 16.875H4.375V3.125H11.25V6.875C11.25 7.04076 11.3158 7.19973 11.4331 7.31694C11.5503 7.43415 11.7092 7.5 11.875 7.5H15.625V16.875Z" fill="#555F6D"/>
</svg>
`, Zfe = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.625 1.875H5.625C5.29348 1.875 4.97554 2.0067 4.74112 2.24112C4.5067 2.47554 4.375 2.79348 4.375 3.125V5H3.125C2.79348 5 2.47554 5.1317 2.24112 5.36612C2.0067 5.60054 1.875 5.91848 1.875 6.25V13.75C1.875 14.0815 2.0067 14.3995 2.24112 14.6339C2.47554 14.8683 2.79348 15 3.125 15H4.375V16.875C4.375 17.2065 4.5067 17.5245 4.74112 17.7589C4.97554 17.9933 5.29348 18.125 5.625 18.125H15.625C15.9565 18.125 16.2745 17.9933 16.5089 17.7589C16.7433 17.5245 16.875 17.2065 16.875 16.875V3.125C16.875 2.79348 16.7433 2.47554 16.5089 2.24112C16.2745 2.0067 15.9565 1.875 15.625 1.875ZM12.5 8.125H15.625V11.875H12.5V8.125ZM15.625 6.875H12.5V6.25C12.5 5.91848 12.3683 5.60054 12.1339 5.36612C11.8995 5.1317 11.5815 5 11.25 5V3.125H15.625V6.875ZM5.625 3.125H10V5H5.625V3.125ZM3.125 6.25H11.25V12.4867C11.25 12.4914 11.25 12.4953 11.25 12.5C11.25 12.5047 11.25 12.5086 11.25 12.5133V13.75H3.125V6.25ZM5.625 15H10V16.875H5.625V15ZM11.25 16.875V15C11.5815 15 11.8995 14.8683 12.1339 14.6339C12.3683 14.3995 12.5 14.0815 12.5 13.75V13.125H15.625V16.875H11.25ZM5.14453 11.475L6.37422 10L5.14453 8.525C5.03844 8.39757 4.98732 8.23322 5.00241 8.0681C5.01751 7.90298 5.09757 7.75062 5.225 7.64453C5.35243 7.53844 5.51678 7.48732 5.6819 7.50241C5.84702 7.51751 5.99938 7.59757 6.10547 7.725L7.1875 9.02344L8.26953 7.725C8.32206 7.6619 8.3865 7.60977 8.45918 7.57158C8.53185 7.53339 8.61134 7.50989 8.6931 7.50241C8.77486 7.49494 8.85729 7.50365 8.93568 7.52803C9.01408 7.55242 9.0869 7.592 9.15 7.64453C9.2131 7.69706 9.26523 7.7615 9.30342 7.83418C9.34161 7.90685 9.36511 7.98634 9.37259 8.0681C9.38006 8.14986 9.37135 8.23229 9.34697 8.31068C9.32258 8.38908 9.283 8.4619 9.23047 8.525L8.00078 10L9.23047 11.475C9.33656 11.6024 9.38768 11.7668 9.37259 11.9319C9.35749 12.097 9.27743 12.2494 9.15 12.3555C9.02257 12.4616 8.85822 12.5127 8.6931 12.4976C8.52798 12.4825 8.37562 12.4024 8.26953 12.275L7.1875 10.9766L6.10547 12.275C5.99938 12.4024 5.84702 12.4825 5.6819 12.4976C5.51678 12.5127 5.35243 12.4616 5.225 12.3555C5.09757 12.2494 5.01751 12.097 5.00241 11.9319C4.98732 11.7668 5.03844 11.6024 5.14453 11.475Z" fill="#00832D"/>
</svg>
`, Gfe = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M120,176h-8v-4a28,28,0,0,0-56,0v4H48a8,8,0,0,0-8,8v40a8,8,0,0,0,8,8h72a8,8,0,0,0,8-8V184A8,8,0,0,0,120,176Zm-48-4a12,12,0,0,1,24,0v4H72Zm40,44H56V192h56ZM213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40v88a8,8,0,0,0,16,0V40h88V88a8,8,0,0,0,8,8h48V216H160a8,8,0,0,0,0,16h40a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160Z"></path></svg>', Nfe = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160ZM200,216H56V40h88V88a8,8,0,0,0,8,8h48V216Zm-45.54-48.85a36.05,36.05,0,1,0-11.31,11.31l11.19,11.2a8,8,0,0,0,11.32-11.32ZM104,148a20,20,0,1,1,20,20A20,20,0,0,1,104,148Z"></path></svg>', zfe = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><rect width="256" height="256" fill="none"/><path d="M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><polyline points="152 32 152 88 208 88" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><line x1="104" y1="152" x2="152" y2="152" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/></svg>', jfe = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17.5 11.875C17.5 12.0408 17.4342 12.1997 17.3169 12.3169C17.1997 12.4342 17.0408 12.5 16.875 12.5H15V13.75H16.25C16.4158 13.75 16.5747 13.8158 16.6919 13.9331C16.8092 14.0503 16.875 14.2092 16.875 14.375C16.875 14.5408 16.8092 14.6997 16.6919 14.8169C16.5747 14.9342 16.4158 15 16.25 15H15V16.25C15 16.4158 14.9342 16.5747 14.8169 16.6919C14.6997 16.8092 14.5408 16.875 14.375 16.875C14.2092 16.875 14.0503 16.8092 13.9331 16.6919C13.8158 16.5747 13.75 16.4158 13.75 16.25V11.875C13.75 11.7092 13.8158 11.5503 13.9331 11.4331C14.0503 11.3158 14.2092 11.25 14.375 11.25H16.875C17.0408 11.25 17.1997 11.3158 17.3169 11.4331C17.4342 11.5503 17.5 11.7092 17.5 11.875ZM7.1875 13.4375C7.1875 14.0177 6.95703 14.5741 6.5468 14.9843C6.13656 15.3945 5.58016 15.625 5 15.625H4.375V16.25C4.375 16.4158 4.30915 16.5747 4.19194 16.6919C4.07473 16.8092 3.91576 16.875 3.75 16.875C3.58424 16.875 3.42527 16.8092 3.30806 16.6919C3.19085 16.5747 3.125 16.4158 3.125 16.25V11.875C3.125 11.7092 3.19085 11.5503 3.30806 11.4331C3.42527 11.3158 3.58424 11.25 3.75 11.25H5C5.58016 11.25 6.13656 11.4805 6.5468 11.8907C6.95703 12.3009 7.1875 12.8573 7.1875 13.4375ZM5.9375 13.4375C5.9375 13.1889 5.83873 12.9504 5.66291 12.7746C5.4871 12.5988 5.24864 12.5 5 12.5H4.375V14.375H5C5.24864 14.375 5.4871 14.2762 5.66291 14.1004C5.83873 13.9246 5.9375 13.6861 5.9375 13.4375ZM12.8125 14.0625C12.8125 14.8084 12.5162 15.5238 11.9887 16.0512C11.4613 16.5787 10.7459 16.875 10 16.875H8.75C8.58424 16.875 8.42527 16.8092 8.30806 16.6919C8.19085 16.5747 8.125 16.4158 8.125 16.25V11.875C8.125 11.7092 8.19085 11.5503 8.30806 11.4331C8.42527 11.3158 8.58424 11.25 8.75 11.25H10C10.7459 11.25 11.4613 11.5463 11.9887 12.0738C12.5162 12.6012 12.8125 13.3166 12.8125 14.0625ZM11.5625 14.0625C11.5625 13.6481 11.3979 13.2507 11.1049 12.9576C10.8118 12.6646 10.4144 12.5 10 12.5H9.375V15.625H10C10.4144 15.625 10.8118 15.4604 11.1049 15.1674C11.3979 14.8743 11.5625 14.4769 11.5625 14.0625ZM3.125 8.75V3.125C3.125 2.79348 3.2567 2.47554 3.49112 2.24112C3.72554 2.0067 4.04348 1.875 4.375 1.875H11.875C11.9571 1.87494 12.0384 1.89105 12.1143 1.92241C12.1902 1.95378 12.2591 1.99979 12.3172 2.05781L16.6922 6.43281C16.7502 6.4909 16.7962 6.55985 16.8276 6.63572C16.859 6.71159 16.8751 6.7929 16.875 6.875V8.75C16.875 8.91576 16.8092 9.07473 16.6919 9.19194C16.5747 9.30915 16.4158 9.375 16.25 9.375C16.0842 9.375 15.9253 9.30915 15.8081 9.19194C15.6908 9.07473 15.625 8.91576 15.625 8.75V7.5H11.875C11.7092 7.5 11.5503 7.43415 11.4331 7.31694C11.3158 7.19973 11.25 7.04076 11.25 6.875V3.125H4.375V8.75C4.375 8.91576 4.30915 9.07473 4.19194 9.19194C4.07473 9.30915 3.91576 9.375 3.75 9.375C3.58424 9.375 3.42527 9.30915 3.30806 9.19194C3.19085 9.07473 3.125 8.91576 3.125 8.75ZM12.5 6.25H14.7414L12.5 4.00859V6.25Z" fill="#FF0000"/>
</svg>
`, Wfe = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><rect width="256" height="256" fill="none"/><path d="M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><polyline points="152 32 152 88 208 88" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><line x1="104" y1="152" x2="152" y2="152" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><line x1="128" y1="128" x2="128" y2="176" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/></svg>', Ufe = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17.5 11.875C17.5 12.0408 17.4342 12.1997 17.3169 12.3169C17.1997 12.4342 17.0408 12.5 16.875 12.5H15.9375V16.25C15.9375 16.4158 15.8717 16.5747 15.7544 16.6919C15.6372 16.8092 15.4783 16.875 15.3125 16.875C15.1467 16.875 14.9878 16.8092 14.8706 16.6919C14.7533 16.5747 14.6875 16.4158 14.6875 16.25V12.5H13.75C13.5842 12.5 13.4253 12.4342 13.3081 12.3169C13.1908 12.1997 13.125 12.0408 13.125 11.875C13.125 11.7092 13.1908 11.5503 13.3081 11.4331C13.4253 11.3158 13.5842 11.25 13.75 11.25H16.875C17.0408 11.25 17.1997 11.3158 17.3169 11.4331C17.4342 11.5503 17.5 11.7092 17.5 11.875ZM7.1875 13.4375C7.1875 14.0177 6.95703 14.5741 6.5468 14.9843C6.13656 15.3945 5.58016 15.625 5 15.625H4.375V16.25C4.375 16.4158 4.30915 16.5747 4.19194 16.6919C4.07473 16.8092 3.91576 16.875 3.75 16.875C3.58424 16.875 3.42527 16.8092 3.30806 16.6919C3.19085 16.5747 3.125 16.4158 3.125 16.25V11.875C3.125 11.7092 3.19085 11.5503 3.30806 11.4331C3.42527 11.3158 3.58424 11.25 3.75 11.25H5C5.58016 11.25 6.13656 11.4805 6.5468 11.8907C6.95703 12.3009 7.1875 12.8573 7.1875 13.4375ZM5.9375 13.4375C5.9375 13.1889 5.83873 12.9504 5.66291 12.7746C5.4871 12.5988 5.24864 12.5 5 12.5H4.375V14.375H5C5.24864 14.375 5.4871 14.2762 5.66291 14.1004C5.83873 13.9246 5.9375 13.6861 5.9375 13.4375ZM12.5 13.4375C12.5 14.0177 12.2695 14.5741 11.8593 14.9843C11.4491 15.3945 10.8927 15.625 10.3125 15.625H9.6875V16.25C9.6875 16.4158 9.62165 16.5747 9.50444 16.6919C9.38723 16.8092 9.22826 16.875 9.0625 16.875C8.89674 16.875 8.73777 16.8092 8.62056 16.6919C8.50335 16.5747 8.4375 16.4158 8.4375 16.25V11.875C8.4375 11.7092 8.50335 11.5503 8.62056 11.4331C8.73777 11.3158 8.89674 11.25 9.0625 11.25H10.3125C10.8927 11.25 11.4491 11.4805 11.8593 11.8907C12.2695 12.3009 12.5 12.8573 12.5 13.4375ZM11.25 13.4375C11.25 13.1889 11.1512 12.9504 10.9754 12.7746C10.7996 12.5988 10.5611 12.5 10.3125 12.5H9.6875V14.375H10.3125C10.5611 14.375 10.7996 14.2762 10.9754 14.1004C11.1512 13.9246 11.25 13.6861 11.25 13.4375ZM3.125 8.75V3.125C3.125 2.79348 3.2567 2.47554 3.49112 2.24112C3.72554 2.0067 4.04348 1.875 4.375 1.875H11.875C11.9571 1.87494 12.0384 1.89105 12.1143 1.92241C12.1902 1.95378 12.2591 1.99979 12.3172 2.05781L16.6922 6.43281C16.7502 6.4909 16.7962 6.55985 16.8276 6.63572C16.859 6.71159 16.8751 6.7929 16.875 6.875V8.75C16.875 8.91576 16.8092 9.07473 16.6919 9.19194C16.5747 9.30915 16.4158 9.375 16.25 9.375C16.0842 9.375 15.9253 9.30915 15.8081 9.19194C15.6908 9.07473 15.625 8.91576 15.625 8.75V7.5H11.875C11.7092 7.5 11.5503 7.43415 11.4331 7.31694C11.3158 7.19973 11.25 7.04076 11.25 6.875V3.125H4.375V8.75C4.375 8.91576 4.30915 9.07473 4.19194 9.19194C4.07473 9.30915 3.91576 9.375 3.75 9.375C3.58424 9.375 3.42527 9.30915 3.30806 9.19194C3.19085 9.07473 3.125 8.91576 3.125 8.75ZM12.5 6.25H14.7414L12.5 4.00859V6.25Z" fill="#F59638"/>
</svg>
`, Kfe = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16.6922 6.43281L12.3172 2.05781C12.2591 1.99979 12.1902 1.95378 12.1143 1.92241C12.0384 1.89105 11.9571 1.87494 11.875 1.875H4.375C4.04348 1.875 3.72554 2.0067 3.49112 2.24112C3.2567 2.47554 3.125 2.79348 3.125 3.125V8.75C3.125 8.91576 3.19085 9.07473 3.30806 9.19194C3.42527 9.30915 3.58424 9.375 3.75 9.375C3.91576 9.375 4.07473 9.30915 4.19194 9.19194C4.30915 9.07473 4.375 8.91576 4.375 8.75V3.125H11.25V6.875C11.25 7.04076 11.3158 7.19973 11.4331 7.31694C11.5503 7.43415 11.7092 7.5 11.875 7.5H15.625V16.875H15C14.8342 16.875 14.6753 16.9408 14.5581 17.0581C14.4408 17.1753 14.375 17.3342 14.375 17.5C14.375 17.6658 14.4408 17.8247 14.5581 17.9419C14.6753 18.0592 14.8342 18.125 15 18.125H15.625C15.9565 18.125 16.2745 17.9933 16.5089 17.7589C16.7433 17.5245 16.875 17.2065 16.875 16.875V6.875C16.8751 6.7929 16.859 6.71159 16.8276 6.63572C16.7962 6.55985 16.7502 6.4909 16.6922 6.43281ZM12.5 4.00859L14.7414 6.25H12.5V4.00859ZM12.1781 11.3281C12.0805 11.2741 11.9701 11.2472 11.8586 11.2502C11.747 11.2532 11.6383 11.2861 11.5437 11.3453L9.98516 12.3187C9.94168 12.0221 9.79302 11.7509 9.56628 11.5547C9.33954 11.3585 9.04984 11.2504 8.75 11.25H3.75C3.41848 11.25 3.10054 11.3817 2.86612 11.6161C2.6317 11.8505 2.5 12.1685 2.5 12.5V16.25C2.5 16.5815 2.6317 16.8995 2.86612 17.1339C3.10054 17.3683 3.41848 17.5 3.75 17.5H8.75C9.04984 17.4996 9.33954 17.3915 9.56628 17.1953C9.79302 16.9991 9.94168 16.7279 9.98516 16.4313L11.5437 17.4047C11.6383 17.4638 11.747 17.4965 11.8585 17.4995C11.97 17.5024 12.0803 17.4755 12.1778 17.4214C12.2754 17.3674 12.3567 17.2882 12.4134 17.1921C12.47 17.096 12.4999 16.9865 12.5 16.875V11.875C12.5001 11.7634 12.4702 11.6538 12.4136 11.5577C12.357 11.4615 12.2757 11.3822 12.1781 11.3281ZM8.75 16.25H3.75V12.5H8.75V16.25ZM11.25 15.7477L10 14.9664V13.7836L11.25 13.0023V15.7477Z" fill="#F59638"/>
</svg>
`, qfe = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.625 1.875H5.625C5.29348 1.875 4.97554 2.0067 4.74112 2.24112C4.5067 2.47554 4.375 2.79348 4.375 3.125V5H3.125C2.79348 5 2.47554 5.1317 2.24112 5.36612C2.0067 5.60054 1.875 5.91848 1.875 6.25V13.75C1.875 14.0815 2.0067 14.3995 2.24112 14.6339C2.47554 14.8683 2.79348 15 3.125 15H4.375V16.875C4.375 17.2065 4.5067 17.5245 4.74112 17.7589C4.97554 17.9933 5.29348 18.125 5.625 18.125H15.625C15.9565 18.125 16.2745 17.9933 16.5089 17.7589C16.7433 17.5245 16.875 17.2065 16.875 16.875V3.125C16.875 2.79348 16.7433 2.47554 16.5089 2.24112C16.2745 2.0067 15.9565 1.875 15.625 1.875ZM12.5 8.125H15.625V11.875H12.5V8.125ZM5.625 3.125H15.625V6.875H12.5V6.25C12.5 5.91848 12.3683 5.60054 12.1339 5.36612C11.8995 5.1317 11.5815 5 11.25 5H5.625V3.125ZM3.125 6.25H11.25V12.4867C11.25 12.4914 11.25 12.4953 11.25 12.5C11.25 12.5047 11.25 12.5086 11.25 12.5133V13.75H3.125V6.25ZM5.625 16.875V15H11.25C11.5815 15 11.8995 14.8683 12.1339 14.6339C12.3683 14.3995 12.5 14.0815 12.5 13.75V13.125H15.625V16.875H5.625ZM5.33125 12.0266L4.39375 8.27656C4.37225 8.19642 4.36692 8.1128 4.37808 8.03057C4.38923 7.94835 4.41665 7.86917 4.45873 7.79765C4.50081 7.72614 4.55671 7.66372 4.62317 7.61403C4.68963 7.56435 4.76532 7.52839 4.84582 7.50827C4.92632 7.48814 5.01002 7.48425 5.09204 7.49681C5.17406 7.50938 5.25276 7.53815 5.32354 7.58145C5.39433 7.62475 5.45578 7.68171 5.50432 7.74901C5.55286 7.81631 5.58751 7.8926 5.60625 7.97344L6.13437 10.0828L6.62812 9.09375C6.67996 8.98975 6.75977 8.90225 6.85858 8.8411C6.95739 8.77994 7.07129 8.74754 7.1875 8.74754C7.30371 8.74754 7.41761 8.77994 7.51642 8.8411C7.61523 8.90225 7.69504 8.98975 7.74688 9.09375L8.24063 10.0828L8.76875 7.97344C8.81122 7.81513 8.91418 7.67984 9.05545 7.59672C9.19671 7.5136 9.36498 7.4893 9.52399 7.52905C9.683 7.56881 9.82003 7.66943 9.90556 7.80925C9.99109 7.94907 10.0183 8.11689 9.98125 8.27656L9.04375 12.0266C9.0126 12.1503 8.94433 12.2615 8.84811 12.3453C8.75188 12.4291 8.63231 12.4815 8.50547 12.4953C8.48289 12.4978 8.46021 12.4991 8.4375 12.4992C8.32139 12.4993 8.20755 12.467 8.10875 12.406C8.00994 12.3451 7.93008 12.2577 7.87812 12.1539L7.1875 10.7727L6.49688 12.1547C6.43979 12.269 6.34904 12.3631 6.23686 12.4242C6.12467 12.4854 5.99643 12.5107 5.86942 12.4967C5.74241 12.4828 5.62274 12.4302 5.52651 12.3461C5.43029 12.2621 5.36214 12.1505 5.33125 12.0266Z" fill="#3062D4"/>
</svg>
`, Yfe = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.375 11.25H13.125C12.9592 11.25 12.8003 11.3158 12.6831 11.4331C12.5658 11.5503 12.5 11.7092 12.5 11.875V16.25C12.5 16.4158 12.5658 16.5747 12.6831 16.6919C12.8003 16.8092 12.9592 16.875 13.125 16.875C13.2908 16.875 13.4497 16.8092 13.5669 16.6919C13.6842 16.5747 13.75 16.4158 13.75 16.25V15.625H14.375C14.9552 15.625 15.5116 15.3945 15.9218 14.9843C16.332 14.5741 16.5625 14.0177 16.5625 13.4375C16.5625 12.8573 16.332 12.3009 15.9218 11.8907C15.5116 11.4805 14.9552 11.25 14.375 11.25ZM14.375 14.375H13.75V12.5H14.375C14.6236 12.5 14.8621 12.5988 15.0379 12.7746C15.2137 12.9504 15.3125 13.1889 15.3125 13.4375C15.3125 13.6861 15.2137 13.9246 15.0379 14.1004C14.8621 14.2762 14.6236 14.375 14.375 14.375ZM10.625 11.875V16.25C10.625 16.4158 10.5592 16.5747 10.4419 16.6919C10.3247 16.8092 10.1658 16.875 10 16.875C9.83424 16.875 9.67527 16.8092 9.55806 16.6919C9.44085 16.5747 9.375 16.4158 9.375 16.25V11.875C9.375 11.7092 9.44085 11.5503 9.55806 11.4331C9.67527 11.3158 9.83424 11.25 10 11.25C10.1658 11.25 10.3247 11.3158 10.4419 11.4331C10.5592 11.5503 10.625 11.7092 10.625 11.875ZM7.5 16.25C7.5 16.4158 7.43415 16.5747 7.31694 16.6919C7.19973 16.8092 7.04076 16.875 6.875 16.875H4.375C4.26481 16.876 4.15633 16.8478 4.06053 16.7934C3.96473 16.7389 3.88504 16.6601 3.82951 16.5649C3.77399 16.4698 3.74462 16.3616 3.74438 16.2514C3.74413 16.1412 3.77303 16.0329 3.82812 15.9375L5.79375 12.5H4.375C4.20924 12.5 4.05027 12.4342 3.93306 12.3169C3.81585 12.1997 3.75 12.0408 3.75 11.875C3.75 11.7092 3.81585 11.5503 3.93306 11.4331C4.05027 11.3158 4.20924 11.25 4.375 11.25H6.875C6.98519 11.249 7.09367 11.2772 7.18947 11.3316C7.28527 11.3861 7.36496 11.4649 7.42049 11.5601C7.47601 11.6552 7.50538 11.7634 7.50562 11.8736C7.50587 11.9838 7.47697 12.0921 7.42188 12.1875L5.45234 15.625H6.875C7.04076 15.625 7.19973 15.6908 7.31694 15.8081C7.43415 15.9253 7.5 16.0842 7.5 16.25ZM16.6922 6.43281L12.3172 2.05781C12.2591 1.99979 12.1902 1.95378 12.1143 1.92241C12.0384 1.89105 11.9571 1.87494 11.875 1.875H4.375C4.04348 1.875 3.72554 2.0067 3.49112 2.24112C3.2567 2.47554 3.125 2.79348 3.125 3.125V8.75C3.125 8.91576 3.19085 9.07473 3.30806 9.19194C3.42527 9.30915 3.58424 9.375 3.75 9.375C3.91576 9.375 4.07473 9.30915 4.19194 9.19194C4.30915 9.07473 4.375 8.91576 4.375 8.75V3.125H11.25V6.875C11.25 7.04076 11.3158 7.19973 11.4331 7.31694C11.5503 7.43415 11.7092 7.5 11.875 7.5H15.625V8.75C15.625 8.91576 15.6908 9.07473 15.8081 9.19194C15.9253 9.30915 16.0842 9.375 16.25 9.375C16.4158 9.375 16.5747 9.30915 16.6919 9.19194C16.8092 9.07473 16.875 8.91576 16.875 8.75V6.875C16.8751 6.7929 16.859 6.71159 16.8276 6.63572C16.7962 6.55985 16.7502 6.4909 16.6922 6.43281ZM12.5 6.25V4.00859L14.7414 6.25H12.5Z" fill="#077597"/>
</svg>
`, Qfe = `<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16.6922 6.75508L12.3172 2.38008C12.2591 2.32206 12.1902 2.27605 12.1143 2.24468C12.0384 2.21331 11.9571 2.1972 11.875 2.19727H4.375C4.04348 2.19727 3.72554 2.32896 3.49112 2.56338C3.2567 2.7978 3.125 3.11575 3.125 3.44727V17.1973C3.125 17.5288 3.2567 17.8467 3.49112 18.0811C3.72554 18.3156 4.04348 18.4473 4.375 18.4473H15.625C15.9565 18.4473 16.2745 18.3156 16.5089 18.0811C16.7433 17.8467 16.875 17.5288 16.875 17.1973V7.19727C16.8751 7.11517 16.859 7.03386 16.8276 6.95798C16.7962 6.88211 16.7502 6.81316 16.6922 6.75508ZM12.5 4.33086L14.7414 6.57227H12.5V4.33086ZM15.625 17.1973H4.375V3.44727H11.25V7.19727C11.25 7.36303 11.3158 7.522 11.4331 7.63921C11.5503 7.75642 11.7092 7.82227 11.875 7.82227H15.625V17.1973Z" fill="currentColor"/>
</svg>
`, Jfe = `<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.1234 2.14841C8.84057 2.08886 8.54582 2.13007 8.29016 2.26489C8.0345 2.39971 7.83401 2.61966 7.7234 2.88669L7.71871 2.89763L2.71871 15.3922C2.63955 15.5823 2.60859 15.789 2.62859 15.994C2.64859 16.199 2.71892 16.3958 2.83334 16.5671C2.94776 16.7383 3.10272 16.8786 3.28444 16.9756C3.46616 17.0725 3.66901 17.123 3.87496 17.1226H8.87496C9.20648 17.1226 9.52442 16.9909 9.75884 16.7565C9.99326 16.5221 10.125 16.2041 10.125 15.8726V3.37263C10.127 3.08379 10.028 2.80332 9.84511 2.57977C9.66221 2.35621 9.40692 2.20362 9.1234 2.14841ZM8.87496 15.8726H3.87496L3.87965 15.8609L8.87496 3.37263V15.8726ZM18.7789 15.3922L13.7789 2.89763L13.7742 2.88669C13.6611 2.62241 13.4604 2.40517 13.2059 2.27158C12.9513 2.13798 12.6585 2.0962 12.3768 2.15326C12.0951 2.21033 11.8416 2.36275 11.6591 2.58485C11.4766 2.80696 11.3763 3.08517 11.375 3.37263V15.8726C11.375 16.2041 11.5067 16.5221 11.7411 16.7565C11.9755 16.9909 12.2934 17.1226 12.625 17.1226H17.625C17.8308 17.1227 18.0334 17.072 18.215 16.975C18.3965 16.878 18.5512 16.7376 18.6655 16.5664C18.7797 16.3952 18.8499 16.1985 18.8698 15.9936C18.8897 15.7888 18.8588 15.5822 18.7796 15.3922H18.7789ZM12.625 15.8726V3.37263L17.6195 15.8601L17.6242 15.8718L12.625 15.8726Z" fill="currentColor"/>
</svg>
`, Xfe = `<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.125 9.62248H17.625C17.9135 9.6226 18.1932 9.52291 18.4166 9.34033C18.6399 9.15775 18.7933 8.90352 18.8506 8.62077C18.9079 8.33801 18.8656 8.04413 18.731 7.78899C18.5963 7.53384 18.3775 7.33314 18.1117 7.22092L18.1008 7.21623L5.60625 2.21623C5.41609 2.1369 5.20926 2.10581 5.00417 2.12573C4.79909 2.14564 4.60211 2.21595 4.43076 2.33039C4.25941 2.44483 4.11901 2.59985 4.02205 2.78166C3.92509 2.96347 3.87457 3.16643 3.875 3.37248V8.37248C3.875 8.704 4.0067 9.02194 4.24112 9.25636C4.47554 9.49078 4.79348 9.62248 5.125 9.62248ZM5.125 3.37248L5.13672 3.37717L17.625 8.37248H5.125V3.37248ZM17.625 10.8725H5.125C4.79348 10.8725 4.47554 11.0042 4.24112 11.2386C4.0067 11.473 3.875 11.791 3.875 12.1225V17.1225C3.87488 17.3283 3.92559 17.531 4.02262 17.7125C4.11964 17.894 4.25999 18.0487 4.43119 18.163C4.6024 18.2772 4.79916 18.3474 5.00401 18.3673C5.20886 18.3872 5.41547 18.3563 5.60547 18.2772L18.1 13.2772L18.1109 13.2725C18.3757 13.1597 18.5934 12.959 18.7274 12.7043C18.8613 12.4496 18.9033 12.1565 18.8462 11.8744C18.7891 11.5924 18.6364 11.3386 18.4139 11.1561C18.1914 10.9736 17.9128 10.8734 17.625 10.8725ZM5.13672 17.117L5.125 17.1225V12.1225H17.625L5.13672 17.117Z" fill="currentColor"/>
</svg>
`, eve = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M219.31,72,184,36.69A15.86,15.86,0,0,0,172.69,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V83.31A15.86,15.86,0,0,0,219.31,72ZM168,208H88V152h80Zm40,0H184V152a16,16,0,0,0-16-16H88a16,16,0,0,0-16,16v56H48V48H172.69L208,83.31ZM160,72a8,8,0,0,1-8,8H96a8,8,0,0,1,0-16h56A8,8,0,0,1,160,72Z"/></svg>
`, tve = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M216,72H131.31L104,44.69A15.86,15.86,0,0,0,92.69,40H40A16,16,0,0,0,24,56V200.62A15.4,15.4,0,0,0,39.38,216H216.89A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72ZM92.69,56l16,16H40V56ZM216,200H40V88H216ZM104,136h48a8,8,0,0,1,0,16H104a8,8,0,0,1,0-16Z"></path></svg>', ove = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M216,72H131.31L104,44.69A15.86,15.86,0,0,0,92.69,40H40A16,16,0,0,0,24,56V200.62A15.4,15.4,0,0,0,39.38,216H216.89A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72ZM92.69,56l16,16H40V56ZM216,200H40V88H216Zm-88-88a8,8,0,0,1,8,8v16h16a8,8,0,0,1,0,16H136v16a8,8,0,0,1-16,0V152H104a8,8,0,0,1,0-16h16V120A8,8,0,0,1,128,112Z"></path></svg>', nve = `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" viewBox="0 0 256 256"><path d="M216,72H131.31L104,44.69A15.86,15.86,0,0,0,92.69,40H40A16,16,0,0,0,24,56V200.62A15.4,15.4,0,0,0,39.38,216H216.89A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72ZM40,56H92.69l16,16H40ZM216,200H40V88H216Z"></path></svg>
`, sve = `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" viewBox="0 0 256 256"><path d="M200,136a8,8,0,0,1-8,8H64a8,8,0,0,1,0-16H192A8,8,0,0,1,200,136Zm32-56H24a8,8,0,0,0,0,16H232a8,8,0,0,0,0-16Zm-80,96H104a8,8,0,0,0,0,16h48a8,8,0,0,0,0-16Z"></path></svg>
`, ive = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M230.6,49.53A15.81,15.81,0,0,0,216,40H40A16,16,0,0,0,28.19,66.76l.08.09L96,139.17V216a16,16,0,0,0,24.87,13.32l32-21.34A16,16,0,0,0,160,194.66V139.17l67.74-72.32.08-.09A15.8,15.8,0,0,0,230.6,49.53ZM40,56h0Zm106.18,74.58A8,8,0,0,0,144,136v58.66L112,216V136a8,8,0,0,0-2.16-5.47L40,56H216Z"></path></svg>', rve = `<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10 6.57224C9.25836 6.57224 8.53333 6.79217 7.91665 7.20423C7.29996 7.61629 6.81932 8.20196 6.53549 8.88718C6.25166 9.5724 6.1774 10.3264 6.32209 11.0538C6.46679 11.7813 6.82394 12.4494 7.34839 12.9739C7.87283 13.4983 8.54102 13.8555 9.26845 14.0002C9.99588 14.1449 10.7499 14.0706 11.4351 13.7868C12.1203 13.503 12.706 13.0223 13.118 12.4056C13.5301 11.7889 13.75 11.0639 13.75 10.3222C13.749 9.328 13.3536 8.37477 12.6505 7.67173C11.9475 6.9687 10.9943 6.57327 10 6.57224ZM10 12.8222C9.50558 12.8222 9.02223 12.6756 8.61111 12.4009C8.19999 12.1262 7.87956 11.7358 7.69034 11.2789C7.50112 10.8221 7.45161 10.3195 7.54807 9.83452C7.64454 9.34956 7.88264 8.90411 8.23227 8.55447C8.5819 8.20484 9.02736 7.96674 9.51231 7.87028C9.99726 7.77381 10.4999 7.82332 10.9567 8.01254C11.4136 8.20176 11.804 8.52219 12.0787 8.93332C12.3534 9.34444 12.5 9.82779 12.5 10.3222C12.5 10.9853 12.2366 11.6212 11.7678 12.09C11.299 12.5588 10.6631 12.8222 10 12.8222ZM16.875 10.491C16.8782 10.3785 16.8782 10.266 16.875 10.1535L18.0407 8.69724C18.1018 8.62078 18.1441 8.53103 18.1642 8.43523C18.1843 8.33943 18.1816 8.24025 18.1563 8.14568C17.9652 7.4274 17.6794 6.73775 17.3063 6.0949C17.2574 6.01077 17.1896 5.93921 17.1082 5.88591C17.0269 5.8326 16.9342 5.79903 16.8375 5.78787L14.9844 5.58162C14.9073 5.50037 14.8292 5.42224 14.75 5.34724L14.5313 3.48943C14.52 3.39272 14.4863 3.29998 14.4329 3.21859C14.3795 3.13721 14.3077 3.06944 14.2235 3.02068C13.5804 2.64829 12.8908 2.36274 12.1727 2.17146C12.0781 2.1463 11.9788 2.14373 11.883 2.16395C11.7872 2.18417 11.6975 2.22661 11.6211 2.28787L10.1688 3.44724C10.0563 3.44724 9.94379 3.44724 9.83129 3.44724L8.37504 2.28396C8.29858 2.22284 8.20883 2.18054 8.11303 2.16045C8.01722 2.14037 7.91804 2.14307 7.82347 2.16833C7.10531 2.35976 6.4157 2.64559 5.77269 3.01833C5.68857 3.06718 5.617 3.13499 5.5637 3.21637C5.5104 3.29775 5.47683 3.39045 5.46566 3.48708L5.25941 5.34333C5.17816 5.42094 5.10004 5.49906 5.02504 5.57771L3.16722 5.79099C3.07051 5.80224 2.97777 5.83593 2.89639 5.88937C2.815 5.94281 2.74723 6.01453 2.69847 6.0988C2.32609 6.7419 2.04053 7.43149 1.84925 8.14958C1.8241 8.24421 1.82152 8.34343 1.84174 8.43923C1.86196 8.53504 1.90441 8.62476 1.96566 8.70115L3.12504 10.1535C3.12504 10.266 3.12504 10.3785 3.12504 10.491L1.96175 11.9472C1.90064 12.0237 1.85833 12.1134 1.83825 12.2093C1.81816 12.3051 1.82086 12.4042 1.84613 12.4988C2.03721 13.2171 2.32306 13.9067 2.69613 14.5496C2.74498 14.6337 2.81279 14.7053 2.89417 14.7586C2.97555 14.8119 3.06824 14.8454 3.16488 14.8566L5.01801 15.0629C5.09561 15.1441 5.17373 15.2222 5.25238 15.2972L5.46879 17.1551C5.48004 17.2518 5.51373 17.3445 5.56717 17.4259C5.62061 17.5073 5.69233 17.575 5.7766 17.6238C6.4197 17.9962 7.10929 18.2817 7.82738 18.473C7.92201 18.4982 8.02122 18.5008 8.11703 18.4805C8.21284 18.4603 8.30255 18.4179 8.37894 18.3566L9.83129 17.1972C9.94379 17.2004 10.0563 17.2004 10.1688 17.1972L11.625 18.3629C11.7015 18.424 11.7912 18.4663 11.887 18.4864C11.9828 18.5065 12.082 18.5038 12.1766 18.4785C12.8949 18.2874 13.5845 18.0016 14.2274 17.6285C14.3115 17.5796 14.3831 17.5118 14.4364 17.4305C14.4897 17.3491 14.5232 17.2564 14.5344 17.1597L14.7407 15.3066C14.8219 15.2295 14.9 15.1514 14.975 15.0722L16.8329 14.8535C16.9296 14.8422 17.0223 14.8086 17.1037 14.7551C17.1851 14.7017 17.2528 14.63 17.3016 14.5457C17.674 13.9026 17.9595 13.213 18.1508 12.4949C18.176 12.4003 18.1786 12.3011 18.1583 12.2052C18.1381 12.1094 18.0957 12.0197 18.0344 11.9433L16.875 10.491ZM15.6172 9.98318C15.6305 10.209 15.6305 10.4355 15.6172 10.6613C15.6079 10.8159 15.6564 10.9685 15.7532 11.0894L16.8618 12.4746C16.7345 12.8789 16.5717 13.271 16.375 13.6465L14.6094 13.8465C14.4557 13.8635 14.3137 13.937 14.211 14.0527C14.0606 14.2218 13.9004 14.382 13.7313 14.5324C13.6156 14.6351 13.5421 14.7771 13.525 14.9308L13.3289 16.6949C12.9536 16.8916 12.5614 17.0545 12.1571 17.1816L10.7711 16.073C10.6602 15.9844 10.5225 15.9362 10.3805 15.9363H10.343C10.1172 15.9496 9.89073 15.9496 9.66488 15.9363C9.51026 15.927 9.35769 15.9754 9.23676 16.0722L7.84769 17.1816C7.44342 17.0544 7.05125 16.8915 6.67582 16.6949L6.47582 14.9316C6.45875 14.7779 6.38526 14.6359 6.26957 14.5332C6.10043 14.3828 5.94026 14.2226 5.78988 14.0535C5.68717 13.9378 5.5452 13.8643 5.39144 13.8472L3.62738 13.6504C3.43065 13.275 3.26777 12.8828 3.14066 12.4785L4.24925 11.0926C4.34606 10.9716 4.3945 10.8191 4.38519 10.6644C4.37191 10.4386 4.37191 10.2121 4.38519 9.9863C4.3945 9.83168 4.34606 9.67911 4.24925 9.55818L3.14066 8.1699C3.26787 7.76563 3.43075 7.37346 3.62738 6.99802L5.39066 6.79802C5.54442 6.78095 5.68639 6.70747 5.7891 6.59177C5.93948 6.42264 6.09965 6.26247 6.26879 6.11208C6.38494 6.00931 6.45873 5.86702 6.47582 5.71287L6.67191 3.94958C7.0473 3.75286 7.43948 3.58998 7.84379 3.46287L9.22972 4.57146C9.35066 4.66826 9.50323 4.7167 9.65785 4.7074C9.8837 4.69412 10.1101 4.69412 10.336 4.7074C10.4906 4.7167 10.6432 4.66826 10.7641 4.57146L12.1524 3.46287C12.5567 3.59007 12.9488 3.75295 13.3243 3.94958L13.5243 5.71287C13.5413 5.86663 13.6148 6.00859 13.7305 6.1113C13.8996 6.26169 14.0598 6.42186 14.2102 6.59099C14.3129 6.70668 14.4549 6.78017 14.6086 6.79724L16.3727 6.99333C16.5694 7.36873 16.7323 7.7609 16.8594 8.16521L15.7508 9.55115C15.6531 9.6731 15.6046 9.82724 15.6149 9.98318H15.6172Z" fill="currentColor"/>
</svg>
`, lve = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M128,24h0A104,104,0,1,0,232,128,104.12,104.12,0,0,0,128,24Zm88,104a87.61,87.61,0,0,1-3.33,24H174.16a157.44,157.44,0,0,0,0-48h38.51A87.61,87.61,0,0,1,216,128ZM102,168H154a115.11,115.11,0,0,1-26,45A115.27,115.27,0,0,1,102,168Zm-3.9-16a140.84,140.84,0,0,1,0-48h59.88a140.84,140.84,0,0,1,0,48ZM40,128a87.61,87.61,0,0,1,3.33-24H81.84a157.44,157.44,0,0,0,0,48H43.33A87.61,87.61,0,0,1,40,128ZM154,88H102a115.11,115.11,0,0,1,26-45A115.27,115.27,0,0,1,154,88Zm52.33,0H170.71a135.28,135.28,0,0,0-22.3-45.6A88.29,88.29,0,0,1,206.37,88ZM107.59,42.4A135.28,135.28,0,0,0,85.29,88H49.63A88.29,88.29,0,0,1,107.59,42.4ZM49.63,168H85.29a135.28,135.28,0,0,0,22.3,45.6A88.29,88.29,0,0,1,49.63,168Zm98.78,45.6a135.28,135.28,0,0,0,22.3-45.6h35.66A88.29,88.29,0,0,1,148.41,213.6Z"></path></svg>', ave = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><rect width="256" height="256" fill="none"/><polyline points="56 48 208 104 56 160" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><line x1="208" y1="200" x2="56" y2="200" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/></svg>', cve = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><rect width="256" height="256" fill="none"/><polyline points="64 56 216 128 64 200" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/></svg>', dve = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M216,48H40A16,16,0,0,0,24,64V192a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V64A16,16,0,0,0,216,48ZM104,144V112h48v32Zm48,16v32H104V160ZM40,112H88v32H40Zm64-16V64h48V96Zm64,16h48v32H168Zm48-16H168V64h48ZM88,64V96H40V64ZM40,160H88v32H40Zm176,32H168V160h48v32Z"></path></svg>', uve = `<svg width="15" height="19" viewBox="0 0 15 19" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.25 2.13409V9.37549C6.25 9.54125 6.18415 9.70022 6.06694 9.81743C5.94973 9.93464 5.79076 10.0005 5.625 10.0005C5.45924 10.0005 5.30027 9.93464 5.18306 9.81743C5.06585 9.70022 5 9.54125 5 9.37549V2.13409L3.56719 3.56768C3.50912 3.62575 3.44018 3.67181 3.36431 3.70324C3.28844 3.73466 3.20712 3.75084 3.125 3.75084C2.95915 3.75084 2.80009 3.68495 2.68281 3.56768C2.62474 3.50961 2.57868 3.44067 2.54725 3.3648C2.51583 3.28893 2.49965 3.20761 2.49965 3.12549C2.49965 2.95964 2.56554 2.80058 2.68281 2.6833L5.18281 0.183304C5.24086 0.125194 5.30979 0.0790945 5.38566 0.0476418C5.46154 0.0161892 5.54287 0 5.625 0C5.70713 0 5.78846 0.0161892 5.86434 0.0476418C5.94021 0.0790945 6.00914 0.125194 6.06719 0.183304L8.56719 2.6833C8.68446 2.80058 8.75035 2.95964 8.75035 3.12549C8.75035 3.29134 8.68446 3.4504 8.56719 3.56768C8.44991 3.68495 8.29085 3.75084 8.125 3.75084C7.95915 3.75084 7.80009 3.68495 7.68281 3.56768L6.25 2.13409ZM11.25 9.0333V6.87549C11.25 6.54397 11.1183 6.22603 10.8839 5.99161C10.6495 5.75719 10.3315 5.62549 10 5.62549H8.75C8.58424 5.62549 8.42527 5.69134 8.30806 5.80855C8.19085 5.92576 8.125 6.08473 8.125 6.25049C8.125 6.41625 8.19085 6.57522 8.30806 6.69243C8.42527 6.80964 8.58424 6.87549 8.75 6.87549H10V13.1567C9.62728 12.776 9.12841 12.5444 8.59702 12.5053C8.06564 12.4663 7.53828 12.6226 7.11393 12.9448C6.68959 13.267 6.39743 13.733 6.29231 14.2554C6.18718 14.7777 6.27631 15.3205 6.54297 15.7817L6.56172 15.8114L8.30078 18.4677C8.39153 18.6064 8.53368 18.7034 8.69594 18.7373C8.8582 18.7712 9.0273 18.7393 9.16602 18.6485C9.30474 18.5578 9.40172 18.4156 9.43564 18.2534C9.46956 18.0911 9.43763 17.922 9.34688 17.7833L7.61797 15.1435C7.49541 14.927 7.46384 14.6708 7.53021 14.4311C7.59658 14.1914 7.75545 13.9879 7.97187 13.8653C8.1883 13.7428 8.44454 13.7112 8.68423 13.7776C8.92393 13.844 9.12744 14.0028 9.25 14.2192C9.25547 14.2294 9.26172 14.2396 9.26797 14.2489L10.1023 15.5231C10.1761 15.6356 10.2842 15.7213 10.4105 15.7675C10.5368 15.8136 10.6747 15.8178 10.8036 15.7794C10.9325 15.7409 11.0455 15.662 11.126 15.5541C11.2064 15.4463 11.2499 15.3155 11.25 15.181V10.6255C11.8391 11.1708 12.3096 11.8316 12.6322 12.5667C12.9548 13.3018 13.1225 14.0954 13.125 14.8981V18.1255C13.125 18.2913 13.1908 18.4502 13.3081 18.5674C13.4253 18.6846 13.5842 18.7505 13.75 18.7505C13.9158 18.7505 14.0747 18.6846 14.1919 18.5674C14.3092 18.4502 14.375 18.2913 14.375 18.1255V14.895C14.3715 13.7372 14.0849 12.5979 13.5402 11.5762C12.9955 10.5545 12.2093 9.68155 11.25 9.0333ZM2.5 5.62549H1.25C0.918479 5.62549 0.600537 5.75719 0.366116 5.99161C0.131696 6.22603 0 6.54397 0 6.87549V15.0005C0 15.1663 0.0658481 15.3252 0.183058 15.4424C0.300269 15.5596 0.45924 15.6255 0.625 15.6255C0.79076 15.6255 0.949731 15.5596 1.06694 15.4424C1.18415 15.3252 1.25 15.1663 1.25 15.0005V6.87549H2.5C2.66576 6.87549 2.82473 6.80964 2.94194 6.69243C3.05915 6.57522 3.125 6.41625 3.125 6.25049C3.125 6.08473 3.05915 5.92576 2.94194 5.80855C2.82473 5.69134 2.66576 5.62549 2.5 5.62549Z" fill="currentColor"/>
</svg>
`, hve = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M208,136H48a16,16,0,0,0-16,16v48a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V152A16,16,0,0,0,208,136Zm0,64H48V152H208v48Zm0-160H48A16,16,0,0,0,32,56v48a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V56A16,16,0,0,0,208,40Zm0,64H48V56H208v48ZM192,80a12,12,0,1,1-12-12A12,12,0,0,1,192,80Zm0,96a12,12,0,1,1-12-12A12,12,0,0,1,192,176Z"></path></svg>', gve = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M224,88H175.4l8.47-46.57a8,8,0,0,0-15.74-2.86l-9,49.43H111.4l8.47-46.57a8,8,0,0,0-15.74-2.86L95.14,88H48a8,8,0,0,0,0,16H92.23L83.5,152H32a8,8,0,0,0,0,16H80.6l-8.47,46.57a8,8,0,0,0,6.44,9.3A7.79,7.79,0,0,0,80,224a8,8,0,0,0,7.86-6.57l9-49.43H144.6l-8.47,46.57a8,8,0,0,0,6.44,9.3A7.79,7.79,0,0,0,144,224a8,8,0,0,0,7.86-6.57l9-49.43H208a8,8,0,0,0,0-16H163.77l8.73-48H224a8,8,0,0,0,0-16Zm-76.5,64H99.77l8.73-48h47.73Z"></path></svg>', pve = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M219.31,108.68l-80-80a16,16,0,0,0-22.62,0l-80,80A15.87,15.87,0,0,0,32,120v96a8,8,0,0,0,8,8h64a8,8,0,0,0,8-8V160h32v56a8,8,0,0,0,8,8h64a8,8,0,0,0,8-8V120A15.87,15.87,0,0,0,219.31,108.68ZM208,208H160V152a8,8,0,0,0-8-8H104a8,8,0,0,0-8,8v56H48V120l80-80,80,80Z"></path></svg>', fve = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16.25 2.5H3.75C3.41848 2.5 3.10054 2.6317 2.86612 2.86612C2.6317 3.10054 2.5 3.41848 2.5 3.75V16.25C2.5 16.5815 2.6317 16.8995 2.86612 17.1339C3.10054 17.3683 3.41848 17.5 3.75 17.5H16.25C16.5815 17.5 16.8995 17.3683 17.1339 17.1339C17.3683 16.8995 17.5 16.5815 17.5 16.25V3.75C17.5 3.41848 17.3683 3.10054 17.1339 2.86612C16.8995 2.6317 16.5815 2.5 16.25 2.5ZM3.75 3.75H16.25V9.79531L14.3211 7.86562C14.0867 7.63138 13.7689 7.4998 13.4375 7.4998C13.1061 7.4998 12.7883 7.63138 12.5539 7.86562L4.16953 16.25H3.75V3.75ZM16.25 16.25H5.9375L13.4375 8.75L16.25 11.5625V16.25ZM7.5 9.375C7.87084 9.375 8.23335 9.26503 8.54169 9.05901C8.85004 8.85298 9.09036 8.56014 9.23227 8.21753C9.37419 7.87492 9.41132 7.49792 9.33897 7.13421C9.26663 6.77049 9.08805 6.4364 8.82583 6.17417C8.5636 5.91195 8.22951 5.73337 7.86579 5.66103C7.50208 5.58868 7.12508 5.62581 6.78247 5.76773C6.43986 5.90964 6.14702 6.14996 5.94099 6.45831C5.73497 6.76665 5.625 7.12916 5.625 7.5C5.625 7.99728 5.82254 8.47419 6.17417 8.82583C6.52581 9.17746 7.00272 9.375 7.5 9.375ZM7.5 6.875C7.62361 6.875 7.74445 6.91166 7.84723 6.98033C7.95001 7.04901 8.03012 7.14662 8.07743 7.26082C8.12473 7.37503 8.13711 7.50069 8.11299 7.62193C8.08888 7.74317 8.02935 7.85453 7.94194 7.94194C7.85453 8.02935 7.74317 8.08888 7.62193 8.11299C7.50069 8.13711 7.37503 8.12473 7.26082 8.07743C7.14662 8.03012 7.04901 7.95001 6.98033 7.84723C6.91166 7.74445 6.875 7.62361 6.875 7.5C6.875 7.33424 6.94085 7.17527 7.05806 7.05806C7.17527 6.94085 7.33424 6.875 7.5 6.875Z" fill="#8040BF"/>
</svg>
`, vve = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm16-40a8,8,0,0,1-8,8,16,16,0,0,1-16-16V128a8,8,0,0,1,0-16,16,16,0,0,1,16,16v40A8,8,0,0,1,144,176ZM112,84a12,12,0,1,1,12,12A12,12,0,0,1,112,84Z"></path></svg>', mve = `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" viewBox="0 0 256 256"><path d="M216.57,39.43A80,80,0,0,0,83.91,120.78L28.69,176A15.86,15.86,0,0,0,24,187.31V216a16,16,0,0,0,16,16H72a8,8,0,0,0,8-8V208H96a8,8,0,0,0,8-8V184h16a8,8,0,0,0,5.66-2.34l9.56-9.57A79.73,79.73,0,0,0,160,176h.1A80,80,0,0,0,216.57,39.43ZM224,98.1c-1.09,34.09-29.75,61.86-63.89,61.9H160a63.7,63.7,0,0,1-23.65-4.51,8,8,0,0,0-8.84,1.68L116.69,168H96a8,8,0,0,0-8,8v16H72a8,8,0,0,0-8,8v16H40V187.31l58.83-58.82a8,8,0,0,0,1.68-8.84A63.72,63.72,0,0,1,96,95.92c0-34.14,27.81-62.8,61.9-63.89A64,64,0,0,1,224,98.1ZM192,76a12,12,0,1,1-12-12A12,12,0,0,1,192,76Z"></path></svg>
`, Cve = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M104,104V208H40a8,8,0,0,1-8-8V104Z" opacity="0.2"></path><path d="M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,16V96H40V56ZM40,112H96v88H40Zm176,88H112V112H216v88Z"></path></svg>', wve = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,16V96H40V56ZM40,112H96v88H40Zm176,88H112V112H216v88Z"></path></svg>', bve = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><rect width="256" height="256" fill="none"/><polyline points="200 48 48 104 200 160" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><line x1="200" y1="200" x2="48" y2="200" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/></svg>', yve = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><rect width="256" height="256" fill="none"/><polyline points="200 56 48 128 200 200" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/></svg>', _ve = `<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19.4036 6.89303C19.3723 7.98104 18.9249 9.0156 18.1536 9.78365L15.4388 12.5001C15.0434 12.8976 14.5731 13.2128 14.055 13.4274C13.537 13.6419 12.9815 13.7516 12.4208 13.7501H12.4169C11.8466 13.7497 11.2822 13.635 10.757 13.4128C10.2318 13.1906 9.75643 12.8654 9.35901 12.4564C8.96159 12.0474 8.65017 11.5629 8.44314 11.0315C8.23611 10.5001 8.13767 9.93262 8.15364 9.36256C8.15831 9.1968 8.22862 9.03968 8.34913 8.92576C8.46964 8.81185 8.63046 8.75047 8.79622 8.75514C8.96198 8.7598 9.1191 8.83012 9.23302 8.95062C9.34693 9.07113 9.40831 9.23195 9.40364 9.39771C9.39226 9.80078 9.46179 10.202 9.60812 10.5778C9.75445 10.9535 9.97461 11.2961 10.2556 11.5853C10.5366 11.8745 10.8727 12.1045 11.244 12.2616C11.6154 12.4187 12.0145 12.4998 12.4177 12.5001C12.8141 12.5011 13.2067 12.4235 13.573 12.2718C13.9392 12.1202 14.2717 11.8974 14.5513 11.6165L17.2661 8.90162C17.8263 8.33444 18.1393 7.56869 18.1368 6.77155C18.1343 5.97441 17.8165 5.21063 17.2528 4.64696C16.6892 4.0833 15.9254 3.76553 15.1282 3.76304C14.3311 3.76054 13.5654 4.07352 12.9982 4.63365L12.1388 5.49303C12.0206 5.60529 11.8633 5.66695 11.7003 5.66486C11.5373 5.66278 11.3816 5.59711 11.2664 5.48186C11.1511 5.36661 11.0855 5.21089 11.0834 5.04792C11.0813 4.88494 11.1429 4.7276 11.2552 4.60943L12.1146 3.75006C12.5111 3.35344 12.9818 3.03882 13.4999 2.82416C14.018 2.60951 14.5733 2.49902 15.1341 2.49902C15.6949 2.49902 16.2502 2.60951 16.7683 2.82416C17.2864 3.03882 17.7572 3.35344 18.1536 3.75006C18.5643 4.16174 18.8869 4.65269 19.1018 5.19302C19.3167 5.73334 19.4194 6.31175 19.4036 6.89303ZM9.16927 14.5047L8.30989 15.3641C8.0296 15.6463 7.69601 15.8699 7.32853 16.022C6.96104 16.1741 6.56698 16.2516 6.16927 16.2501C5.57263 16.2496 4.98952 16.0723 4.49362 15.7405C3.99771 15.4088 3.61127 14.9375 3.38311 14.3862C3.15495 13.8349 3.09532 13.2283 3.21175 12.6432C3.32817 12.058 3.61544 11.5205 4.03724 11.0985L6.74739 8.38365C7.17426 7.95453 7.72029 7.66368 8.31457 7.54887C8.90886 7.43407 9.52393 7.5006 10.0799 7.73984C10.6359 7.97909 11.1071 8.37998 11.4323 8.89045C11.7575 9.40093 11.9218 9.9974 11.9036 10.6024C11.899 10.7682 11.9604 10.929 12.0743 11.0495C12.1882 11.17 12.3453 11.2403 12.5111 11.245C12.6768 11.2496 12.8376 11.1883 12.9582 11.0743C13.0787 10.9604 13.149 10.8033 13.1536 10.6376C13.1686 10.0572 13.0656 9.47982 12.8507 8.94049C12.6358 8.40116 12.3136 7.9111 11.9036 7.50006C11.103 6.69977 10.0173 6.2502 8.88528 6.2502C7.75325 6.2502 6.66756 6.69977 5.86693 7.50006L3.15364 10.2149C2.55695 10.8114 2.15045 11.5713 1.98553 12.3987C1.8206 13.2261 1.90465 14.0838 2.22704 14.8635C2.54944 15.6431 3.09572 16.3097 3.79684 16.779C4.49796 17.2483 5.32246 17.4992 6.16614 17.5001C6.72698 17.5017 7.28257 17.392 7.80074 17.1775C8.31891 16.9629 8.78937 16.6477 9.18489 16.2501L10.0443 15.3907C10.1454 15.2715 10.1983 15.1188 10.1924 14.9627C10.1865 14.8065 10.1223 14.6582 10.0125 14.547C9.90267 14.4358 9.75518 14.3698 9.59909 14.362C9.44301 14.3541 9.28965 14.4051 9.16927 14.5047Z" fill="currentColor"/>
</svg>
`, Sve = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M80,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H88A8,8,0,0,1,80,64Zm136,56H88a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Zm0,64H88a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16ZM44,52A12,12,0,1,0,56,64,12,12,0,0,0,44,52Zm0,64a12,12,0,1,0,12,12A12,12,0,0,0,44,116Zm0,64a12,12,0,1,0,12,12A12,12,0,0,0,44,180Z"></path></svg>', xve = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M224,128a8,8,0,0,1-8,8H128a8,8,0,0,1,0-16h88A8,8,0,0,1,224,128ZM128,72h88a8,8,0,0,0,0-16H128a8,8,0,0,0,0,16Zm88,112H128a8,8,0,0,0,0,16h88a8,8,0,0,0,0-16ZM82.34,42.34,56,68.69,45.66,58.34A8,8,0,0,0,34.34,69.66l16,16a8,8,0,0,0,11.32,0l32-32A8,8,0,0,0,82.34,42.34Zm0,64L56,132.69,45.66,122.34a8,8,0,0,0-11.32,11.32l16,16a8,8,0,0,0,11.32,0l32-32a8,8,0,0,0-11.32-11.32Zm0,64L56,196.69,45.66,186.34a8,8,0,0,0-11.32,11.32l16,16a8,8,0,0,0,11.32,0l32-32a8,8,0,0,0-11.32-11.32Z"></path></svg>', Mve = `<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.74951 5.32227C7.74951 5.15651 7.81536 4.99753 7.93257 4.88032C8.04978 4.76311 8.20875 4.69727 8.37451 4.69727H17.7495C17.9153 4.69727 18.0742 4.76311 18.1915 4.88032C18.3087 4.99753 18.3745 5.15651 18.3745 5.32227C18.3745 5.48803 18.3087 5.647 18.1915 5.76421C18.0742 5.88142 17.9153 5.94727 17.7495 5.94727H8.37451C8.20875 5.94727 8.04978 5.88142 7.93257 5.76421C7.81536 5.647 7.74951 5.48803 7.74951 5.32227ZM17.7495 9.69727H8.37451C8.20875 9.69727 8.04978 9.76311 7.93257 9.88032C7.81536 9.99753 7.74951 10.1565 7.74951 10.3223C7.74951 10.488 7.81536 10.647 7.93257 10.7642C8.04978 10.8814 8.20875 10.9473 8.37451 10.9473H17.7495C17.9153 10.9473 18.0742 10.8814 18.1915 10.7642C18.3087 10.647 18.3745 10.488 18.3745 10.3223C18.3745 10.1565 18.3087 9.99753 18.1915 9.88032C18.0742 9.76311 17.9153 9.69727 17.7495 9.69727ZM17.7495 14.6973H8.37451C8.20875 14.6973 8.04978 14.7631 7.93257 14.8803C7.81536 14.9975 7.74951 15.1565 7.74951 15.3223C7.74951 15.488 7.81536 15.647 7.93257 15.7642C8.04978 15.8814 8.20875 15.9473 8.37451 15.9473H17.7495C17.9153 15.9473 18.0742 15.8814 18.1915 15.7642C18.3087 15.647 18.3745 15.488 18.3745 15.3223C18.3745 15.1565 18.3087 14.9975 18.1915 14.8803C18.0742 14.7631 17.9153 14.6973 17.7495 14.6973ZM5.24951 4.69727H3.99951C3.83375 4.69727 3.67478 4.76311 3.55757 4.88032C3.44036 4.99753 3.37451 5.15651 3.37451 5.32227C3.37451 5.48803 3.44036 5.647 3.55757 5.76421C3.67478 5.88142 3.83375 5.94727 3.99951 5.94727H5.24951C5.41527 5.94727 5.57424 5.88142 5.69145 5.76421C5.80866 5.647 5.87451 5.48803 5.87451 5.32227C5.87451 5.15651 5.80866 4.99753 5.69145 4.88032C5.57424 4.76311 5.41527 4.69727 5.24951 4.69727ZM5.24951 9.69727H3.99951C3.83375 9.69727 3.67478 9.76311 3.55757 9.88032C3.44036 9.99753 3.37451 10.1565 3.37451 10.3223C3.37451 10.488 3.44036 10.647 3.55757 10.7642C3.67478 10.8814 3.83375 10.9473 3.99951 10.9473H5.24951C5.41527 10.9473 5.57424 10.8814 5.69145 10.7642C5.80866 10.647 5.87451 10.488 5.87451 10.3223C5.87451 10.1565 5.80866 9.99753 5.69145 9.88032C5.57424 9.76311 5.41527 9.69727 5.24951 9.69727ZM5.24951 14.6973H3.99951C3.83375 14.6973 3.67478 14.7631 3.55757 14.8803C3.44036 14.9975 3.37451 15.1565 3.37451 15.3223C3.37451 15.488 3.44036 15.647 3.55757 15.7642C3.67478 15.8814 3.83375 15.9473 3.99951 15.9473H5.24951C5.41527 15.9473 5.57424 15.8814 5.69145 15.7642C5.80866 15.647 5.87451 15.488 5.87451 15.3223C5.87451 15.1565 5.80866 14.9975 5.69145 14.8803C5.57424 14.7631 5.41527 14.6973 5.24951 14.6973Z" fill="currentColor"/>
</svg>
`, Ave = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M224,128a8,8,0,0,1-8,8H104a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM104,72H216a8,8,0,0,0,0-16H104a8,8,0,0,0,0,16ZM216,184H104a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16ZM43.58,55.16,48,52.94V104a8,8,0,0,0,16,0V40a8,8,0,0,0-11.58-7.16l-16,8a8,8,0,0,0,7.16,14.32ZM79.77,156.72a23.73,23.73,0,0,0-9.6-15.95,24.86,24.86,0,0,0-34.11,4.7,23.63,23.63,0,0,0-3.57,6.46,8,8,0,1,0,15,5.47,7.84,7.84,0,0,1,1.18-2.13,8.76,8.76,0,0,1,12-1.59A7.91,7.91,0,0,1,63.93,159a7.64,7.64,0,0,1-1.57,5.78,1,1,0,0,0-.08.11L33.59,203.21A8,8,0,0,0,40,216H72a8,8,0,0,0,0-16H56l19.08-25.53A23.47,23.47,0,0,0,79.77,156.72Z"></path></svg>', Lve = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M32,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H40A8,8,0,0,1,32,64Zm8,72H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16Zm104,48H40a8,8,0,0,0,0,16H144a8,8,0,0,0,0-16Zm88,0H216V168a8,8,0,0,0-16,0v16H184a8,8,0,0,0,0,16h16v16a8,8,0,0,0,16,0V200h16a8,8,0,0,0,0-16Z"></path></svg>', Eve = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14 8C14 8.13261 13.9473 8.25979 13.8536 8.35355C13.7598 8.44732 13.6326 8.5 13.5 8.5H2.5C2.36739 8.5 2.24021 8.44732 2.14645 8.35355C2.05268 8.25979 2 8.13261 2 8C2 7.86739 2.05268 7.74021 2.14645 7.64645C2.24021 7.55268 2.36739 7.5 2.5 7.5H13.5C13.6326 7.5 13.7598 7.55268 13.8536 7.64645C13.9473 7.74021 14 7.86739 14 8ZM2.5 4.5H13.5C13.6326 4.5 13.7598 4.44732 13.8536 4.35355C13.9473 4.25979 14 4.13261 14 4C14 3.86739 13.9473 3.74021 13.8536 3.64645C13.7598 3.55268 13.6326 3.5 13.5 3.5H2.5C2.36739 3.5 2.24021 3.55268 2.14645 3.64645C2.05268 3.74021 2 3.86739 2 4C2 4.13261 2.05268 4.25979 2.14645 4.35355C2.24021 4.44732 2.36739 4.5 2.5 4.5ZM13.5 11.5H2.5C2.36739 11.5 2.24021 11.5527 2.14645 11.6464C2.05268 11.7402 2 11.8674 2 12C2 12.1326 2.05268 12.2598 2.14645 12.3536C2.24021 12.4473 2.36739 12.5 2.5 12.5H13.5C13.6326 12.5 13.7598 12.4473 13.8536 12.3536C13.9473 12.2598 14 12.1326 14 12C14 11.8674 13.9473 11.7402 13.8536 11.6464C13.7598 11.5527 13.6326 11.5 13.5 11.5Z" fill="currentColor"/>
</svg>
`, Pve = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M208,80H176V56a48,48,0,0,0-96,0V80H48A16,16,0,0,0,32,96V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V96A16,16,0,0,0,208,80ZM96,56a32,32,0,0,1,64,0V80H96ZM208,208H48V96H208V208Z"></path></svg>', Rve = `<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.6251 8.99749C12.6251 9.16325 12.5592 9.32222 12.442 9.43944C12.3248 9.55665 12.1658 9.62249 12.0001 9.62249H7.00006C6.8343 9.62249 6.67532 9.55665 6.55812 9.43944C6.4409 9.32222 6.37506 9.16325 6.37506 8.99749C6.37506 8.83173 6.4409 8.67276 6.55812 8.55555C6.67532 8.43834 6.8343 8.37249 7.00006 8.37249H12.0001C12.1658 8.37249 12.3248 8.43834 12.442 8.55555C12.5592 8.67276 12.6251 8.83173 12.6251 8.99749ZM18.6922 18.1897C18.6342 18.2478 18.5653 18.2939 18.4894 18.3253C18.4135 18.3568 18.3322 18.373 18.2501 18.373C18.1679 18.373 18.0866 18.3568 18.0107 18.3253C17.9348 18.2939 17.8659 18.2478 17.8079 18.1897L13.8969 14.278C12.5358 15.4117 10.7899 15.9771 9.02251 15.8564C7.25512 15.7358 5.60229 14.9384 4.40785 13.6301C3.21341 12.3219 2.56932 10.6035 2.60957 8.83242C2.64982 7.06138 3.37131 5.37403 4.62395 4.12138C5.87659 2.86874 7.56394 2.14725 9.33498 2.107C11.106 2.06675 12.8244 2.71084 14.1327 3.90528C15.4409 5.09972 16.2383 6.75255 16.359 8.51994C16.4797 10.2873 15.9143 12.0332 14.7805 13.3944L18.6922 17.3053C18.7504 17.3634 18.7965 17.4323 18.8279 17.5082C18.8594 17.584 18.8755 17.6654 18.8755 17.7475C18.8755 17.8296 18.8594 17.911 18.8279 17.9868C18.7965 18.0627 18.7504 18.1316 18.6922 18.1897ZM9.50006 14.6225C10.6126 14.6225 11.7001 14.2926 12.6251 13.6745C13.5502 13.0564 14.2711 12.1779 14.6969 11.1501C15.1226 10.1223 15.234 8.99125 15.017 7.90011C14.7999 6.80897 14.2642 5.80669 13.4775 5.02002C12.6909 4.23335 11.6886 3.69762 10.5974 3.48058C9.5063 3.26353 8.3753 3.37493 7.34746 3.80067C6.31963 4.22641 5.44112 4.94738 4.82304 5.87241C4.20496 6.79744 3.87506 7.88497 3.87506 8.99749C3.87671 10.4888 4.46987 11.9186 5.52441 12.9731C6.57894 14.0277 8.00872 14.6208 9.50006 14.6225Z" fill="currentColor"/>
</svg>
`, Fve = `<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.6251 8.99749C12.6251 9.16325 12.5592 9.32222 12.442 9.43944C12.3248 9.55665 12.1658 9.62249 12.0001 9.62249H10.1251V11.4975C10.1251 11.6633 10.0592 11.8222 9.942 11.9394C9.82479 12.0566 9.66582 12.1225 9.50006 12.1225C9.3343 12.1225 9.17533 12.0566 9.05812 11.9394C8.94091 11.8222 8.87506 11.6633 8.87506 11.4975V9.62249H7.00006C6.8343 9.62249 6.67532 9.55665 6.55812 9.43944C6.4409 9.32222 6.37506 9.16325 6.37506 8.99749C6.37506 8.83173 6.4409 8.67276 6.55812 8.55555C6.67532 8.43834 6.8343 8.37249 7.00006 8.37249H8.87506V6.49749C8.87506 6.33173 8.94091 6.17276 9.05812 6.05555C9.17533 5.93834 9.3343 5.87249 9.50006 5.87249C9.66582 5.87249 9.82479 5.93834 9.942 6.05555C10.0592 6.17276 10.1251 6.33173 10.1251 6.49749V8.37249H12.0001C12.1658 8.37249 12.3248 8.43834 12.442 8.55555C12.5592 8.67276 12.6251 8.83173 12.6251 8.99749ZM18.6922 18.1897C18.6342 18.2478 18.5653 18.2939 18.4894 18.3253C18.4135 18.3568 18.3322 18.373 18.2501 18.373C18.1679 18.373 18.0866 18.3568 18.0107 18.3253C17.9348 18.2939 17.8659 18.2478 17.8079 18.1897L13.8969 14.278C12.5358 15.4117 10.7899 15.9771 9.02251 15.8564C7.25512 15.7358 5.60229 14.9384 4.40785 13.6301C3.21341 12.3219 2.56932 10.6035 2.60957 8.83242C2.64982 7.06138 3.37131 5.37403 4.62395 4.12138C5.87659 2.86874 7.56394 2.14725 9.33498 2.107C11.106 2.06675 12.8244 2.71084 14.1327 3.90528C15.4409 5.09972 16.2383 6.75255 16.359 8.51994C16.4797 10.2873 15.9143 12.0332 14.7805 13.3944L18.6922 17.3053C18.7504 17.3634 18.7965 17.4323 18.8279 17.5082C18.8594 17.584 18.8755 17.6654 18.8755 17.7475C18.8755 17.8296 18.8594 17.911 18.8279 17.9868C18.7965 18.0627 18.7504 18.1316 18.6922 18.1897ZM9.50006 14.6225C10.6126 14.6225 11.7001 14.2926 12.6251 13.6745C13.5502 13.0564 14.2711 12.1779 14.6969 11.1501C15.1226 10.1223 15.234 8.99125 15.017 7.90011C14.7999 6.80897 14.2642 5.80669 13.4775 5.02002C12.6909 4.23335 11.6886 3.69762 10.5974 3.48058C9.5063 3.26353 8.3753 3.37493 7.34746 3.80067C6.31963 4.22641 5.44112 4.94738 4.82304 5.87241C4.20496 6.79744 3.87506 7.88497 3.87506 8.99749C3.87671 10.4888 4.46987 11.9186 5.52441 12.9731C6.57894 14.0277 8.00872 14.6208 9.50006 14.6225Z" fill="currentColor"/>
</svg>
`, Tve = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M229.66,218.34l-50.07-50.06a88.11,88.11,0,1,0-11.31,11.31l50.06,50.07a8,8,0,0,0,11.32-11.32ZM40,112a72,72,0,1,1,72,72A72.08,72.08,0,0,1,40,112Z"></path></svg>', Ive = `<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18.3589 3.75H3.35889C3.19313 3.75 3.03416 3.81585 2.91694 3.93306C2.79973 4.05027 2.73389 4.20924 2.73389 4.375V15C2.73389 15.3315 2.86558 15.6495 3.1 15.8839C3.33442 16.1183 3.65237 16.25 3.98389 16.25H17.7339C18.0654 16.25 18.3833 16.1183 18.6178 15.8839C18.8522 15.6495 18.9839 15.3315 18.9839 15V4.375C18.9839 4.20924 18.918 4.05027 18.8008 3.93306C18.6836 3.81585 18.5246 3.75 18.3589 3.75ZM10.8589 10.4023L4.96592 5H16.7519L10.8589 10.4023ZM8.57061 10L3.98389 14.2039V5.79609L8.57061 10ZM9.49561 10.8477L10.4331 11.7109C10.5484 11.8168 10.6992 11.8755 10.8558 11.8755C11.0123 11.8755 11.1631 11.8168 11.2784 11.7109L12.2159 10.8477L16.7472 15H4.96592L9.49561 10.8477ZM13.1472 10L17.7339 5.79531V14.2047L13.1472 10Z" fill="currentColor"/>
</svg>
`, Dve = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M120,103.2V176a8,8,0,0,0,16,0V103.2a40,40,0,1,0-16,0ZM128,40a24,24,0,1,1-24,24A24,24,0,0,1,128,40ZM240,176c0,31.18-57.71,48-112,48S16,207.18,16,176c0-7.74,3.81-19.13,22-29.41,12.26-6.94,29.12-12.27,48.77-15.42A8,8,0,1,1,89.27,147c-17.54,2.82-33,7.63-43.42,13.55C37.05,165.5,32,171.14,32,176c0,13.36,36.52,32,96,32s96-18.64,96-32c0-4.86-5.05-10.5-13.85-15.49-10.46-5.92-25.88-10.73-43.42-13.55a8,8,0,1,1,2.54-15.79c19.65,3.15,36.51,8.48,48.77,15.42C236.19,156.87,240,168.26,240,176Z"></path></svg>', kve = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z" opacity="0.2"></path><path d="M176,128a8,8,0,0,1-8,8H88a8,8,0,0,1,0-16h80A8,8,0,0,1,176,128Zm56,0A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z"></path></svg>', Hve = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M176,128a8,8,0,0,1-8,8H88a8,8,0,0,1,0-16h80A8,8,0,0,1,176,128Zm56,0A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z"></path></svg>', Vve = `<svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M10.9023 7.32227C10.9023 6.76998 11.3501 6.32227 11.9023 6.32227C12.4546 6.32227 12.9023 6.76998 12.9023 7.32227C12.9023 7.87455 12.4546 8.32227 11.9023 8.32227C11.3501 8.32227 10.9023 7.87455 10.9023 7.32227ZM6.40234 7.32227C6.40234 6.76998 6.85006 6.32227 7.40234 6.32227C7.95463 6.32227 8.40234 6.76998 8.40234 7.32227C8.40234 7.87455 7.95463 8.32227 7.40234 8.32227C6.85006 8.32227 6.40234 7.87455 6.40234 7.32227ZM2.90234 6.32227C2.35006 6.32227 1.90234 6.76998 1.90234 7.32227C1.90234 7.87455 2.35006 8.32227 2.90234 8.32227C3.45463 8.32227 3.90234 7.87455 3.90234 7.32227C3.90234 6.76998 3.45463 6.32227 2.90234 6.32227Z" fill="currentColor"/>
</svg>
`, Ove = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M232,112H136V88h8a16,16,0,0,0,16-16V40a16,16,0,0,0-16-16H112A16,16,0,0,0,96,40V72a16,16,0,0,0,16,16h8v24H24a8,8,0,0,0,0,16H56v32H48a16,16,0,0,0-16,16v32a16,16,0,0,0,16,16H80a16,16,0,0,0,16-16V176a16,16,0,0,0-16-16H72V128H184v32h-8a16,16,0,0,0-16,16v32a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V176a16,16,0,0,0-16-16h-8V128h32a8,8,0,0,0,0-16ZM112,40h32V72H112ZM80,208H48V176H80Zm128,0H176V176h32Z"></path></svg>', Bve = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><rect width="256" height="256" fill="none"/><line x1="40" y1="160" x2="216" y2="160" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><line x1="40" y1="96" x2="216" y2="96" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><line x1="208" y1="40" x2="48" y2="216" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/></svg>', $ve = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.3538 3.64664L12.3538 1.64664C12.3073 1.60016 12.2522 1.56328 12.1915 1.53811C12.1308 1.51295 12.0657 1.5 12 1.5C11.9343 1.5 11.8692 1.51295 11.8085 1.53811C11.7478 1.56328 11.6927 1.60016 11.6462 1.64664L5.64625 7.64664C5.59983 7.69311 5.56303 7.74827 5.53793 7.80897C5.51284 7.86967 5.49995 7.93471 5.5 8.00039V10.0004C5.5 10.133 5.55268 10.2602 5.64645 10.3539C5.74021 10.4477 5.86739 10.5004 6 10.5004H8C8.06568 10.5004 8.13073 10.4876 8.19143 10.4625C8.25212 10.4374 8.30728 10.4006 8.35375 10.3541L14.3538 4.35414C14.4002 4.30771 14.4371 4.25256 14.4623 4.19186C14.4874 4.13116 14.5004 4.0661 14.5004 4.00039C14.5004 3.93469 14.4874 3.86962 14.4623 3.80892C14.4371 3.74822 14.4002 3.69308 14.3538 3.64664ZM7.79313 9.50039H6.5V8.20727L10.5 4.20727L11.7931 5.50039L7.79313 9.50039ZM12.5 4.79352L11.2069 3.50039L12 2.70727L13.2931 4.00039L12.5 4.79352ZM14 8.00039V13.0004C14 13.2656 13.8946 13.52 13.7071 13.7075C13.5196 13.895 13.2652 14.0004 13 14.0004H3C2.73478 14.0004 2.48043 13.895 2.29289 13.7075C2.10536 13.52 2 13.2656 2 13.0004V3.00039C2 2.73518 2.10536 2.48082 2.29289 2.29329C2.48043 2.10575 2.73478 2.00039 3 2.00039H8C8.13261 2.00039 8.25979 2.05307 8.35355 2.14684C8.44732 2.24061 8.5 2.36779 8.5 2.50039C8.5 2.633 8.44732 2.76018 8.35355 2.85395C8.25979 2.94771 8.13261 3.00039 8 3.00039H3V13.0004H13V8.00039C13 7.86779 13.0527 7.74061 13.1464 7.64684C13.2402 7.55307 13.3674 7.50039 13.5 7.50039C13.6326 7.50039 13.7598 7.55307 13.8536 7.64684C13.9473 7.74061 14 7.86779 14 8.00039Z" fill="currentColor"/>
</svg>
`, Zve = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M184,112a8,8,0,0,1-8,8H112a8,8,0,0,1,0-16h64A8,8,0,0,1,184,112Zm-8,24H112a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16Zm48-88V208a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V48A16,16,0,0,1,48,32H208A16,16,0,0,1,224,48ZM48,208H72V48H48Zm160,0V48H88V208H208Z"></path></svg>', Gve = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm0,176H48V48H208V208Zm-48-64h-8V80a8,8,0,0,0-14.31-4.91l-56,72A8,8,0,0,0,88,160h48v16a8,8,0,0,0,16,0V160h8a8,8,0,0,0,0-16Zm-24,0H104.36L136,103.32Z"></path></svg>', Nve = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm0,176H48V48H208V208ZM140,80v96a8,8,0,0,1-16,0V95l-11.56,7.71a8,8,0,1,1-8.88-13.32l24-16A8,8,0,0,1,140,80Z"></path></svg>', zve = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm0,176H48V48H208V208Zm-48-60a36,36,0,0,1-61.71,25.19A8,8,0,1,1,109.71,162,20,20,0,1,0,124,128a8,8,0,0,1-6.55-12.59L136.63,88H104a8,8,0,0,1,0-16h48a8,8,0,0,1,6.55,12.59l-21,30A36.07,36.07,0,0,1,160,148Z"></path></svg>', jve = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm0,176H48V48H208V208Zm-48-32a8,8,0,0,1-8,8H104a8,8,0,0,1-6.4-12.8l43.17-57.56a16,16,0,1,0-27.86-15,8,8,0,0,1-15.09-5.34,32.43,32.43,0,0,1,4.62-8.59,32,32,0,1,1,51.11,38.52L120,168h32A8,8,0,0,1,160,176Z"></path></svg>', Wve = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18.3223 10.8649C18.4233 10.8312 18.514 10.7723 18.5858 10.6937C18.6576 10.6151 18.7082 10.5195 18.7327 10.4159C18.7572 10.3123 18.7548 10.2041 18.7258 10.1017C18.6967 9.99925 18.642 9.90593 18.5668 9.83057L9.54416 0.807913C9.42696 0.690792 9.26806 0.625 9.10237 0.625C8.93668 0.625 8.77777 0.690792 8.66057 0.807913L5.48791 3.98448L3.56604 2.05791C3.44876 1.94074 3.28974 1.87496 3.12396 1.87503C2.95819 1.8751 2.79923 1.94103 2.68205 2.0583C2.56488 2.17558 2.4991 2.3346 2.49917 2.50038C2.49924 2.66616 2.56517 2.82512 2.68244 2.94229L4.60432 4.86416L1.17151 8.29463C0.819903 8.64626 0.622375 9.12315 0.622375 9.62041C0.622375 10.1177 0.819903 10.5946 1.17151 10.9462L7.80354 17.5782C8.15517 17.9298 8.63206 18.1274 9.12932 18.1274C9.62658 18.1274 10.1035 17.9298 10.4551 17.5782L16.5871 11.4462L18.3223 10.8649ZM15.8074 10.4556L9.57073 16.6923C9.45353 16.8094 9.29462 16.8752 9.12893 16.8752C8.96324 16.8752 8.80433 16.8094 8.68713 16.6923L2.05744 10.0626C1.94032 9.9454 1.87453 9.78649 1.87453 9.6208C1.87453 9.45511 1.94032 9.29621 2.05744 9.17901L5.48791 5.74776L7.76291 8.02276C7.51324 8.48508 7.43831 9.02183 7.55184 9.53486C7.66537 10.0479 7.95976 10.5029 8.38119 10.8167C8.80262 11.1305 9.32293 11.2822 9.84697 11.2439C10.371 11.2056 10.8638 10.98 11.2351 10.6083C11.6065 10.2366 11.8317 9.74367 11.8695 9.21959C11.9073 8.69552 11.7552 8.17534 11.441 7.75419C11.1268 7.33304 10.6715 7.03904 10.1584 6.92597C9.64529 6.8129 9.10861 6.8883 8.64651 7.13838L6.37229 4.86416L9.10666 2.13369L16.9676 10.0001L16.052 10.3048C15.96 10.3356 15.8763 10.3872 15.8074 10.4556ZM9.02385 8.4001C9.20019 8.18975 9.4528 8.05799 9.72621 8.03374C9.99962 8.0095 10.2715 8.09475 10.4821 8.27078C10.6927 8.44681 10.8248 8.69923 10.8495 8.9726C10.8741 9.24598 10.7893 9.51796 10.6136 9.72882C10.4378 9.93969 10.1856 10.0722 9.91227 10.0972C9.63894 10.1223 9.36683 10.0378 9.15571 9.86244C8.94458 9.68703 8.8117 9.435 8.78625 9.1617C8.7608 8.8884 8.84485 8.61617 9.01995 8.40479C9.01995 8.40479 9.02385 8.40088 9.02385 8.4001ZM18.6449 12.7751C18.5879 12.6894 18.5105 12.6191 18.4198 12.5704C18.329 12.5218 18.2276 12.4964 18.1246 12.4964C18.0217 12.4964 17.9203 12.5218 17.8295 12.5704C17.7387 12.6191 17.6614 12.6894 17.6043 12.7751C17.466 12.9868 16.2496 14.8509 16.2496 16.2501C16.2496 16.7474 16.4472 17.2243 16.7988 17.5759C17.1504 17.9276 17.6274 18.1251 18.1246 18.1251C18.6219 18.1251 19.0988 17.9276 19.4505 17.5759C19.8021 17.2243 19.9996 16.7474 19.9996 16.2501C19.9996 14.8509 18.7832 12.9868 18.6449 12.7782V12.7751ZM18.1246 16.8751C17.9589 16.8751 17.7999 16.8093 17.6827 16.692C17.5655 16.5748 17.4996 16.4159 17.4996 16.2501C17.4996 15.7189 17.8121 14.9751 18.1246 14.3689C18.4371 14.9751 18.7496 15.7235 18.7496 16.2501C18.7496 16.4159 18.6838 16.5748 18.5666 16.692C18.4494 16.8093 18.2904 16.8751 18.1246 16.8751Z" fill="currentColor"/>
</svg>
`, Uve = `<svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.0481 1.86813C9.83794 0.669744 8.20314 -0.00174255 6.5 3.39622e-06H6.43312C4.72083 0.0176212 3.08466 0.710211 1.8801 1.92729C0.675541 3.14438 -9.06232e-05 4.78762 9.11719e-09 6.5C9.11719e-09 9.1875 1.66125 11.4413 4.335 12.3856C4.63657 12.492 4.95924 12.5244 5.27594 12.4803C5.59264 12.4362 5.89415 12.3168 6.15518 12.1321C6.41621 11.9474 6.62916 11.7028 6.77615 11.4188C6.92314 11.1348 6.99991 10.8198 7 10.5C7 10.2348 7.10536 9.98043 7.29289 9.7929C7.48043 9.60536 7.73478 9.5 8 9.5H10.8881C11.3418 9.5022 11.7826 9.34917 12.1373 9.06631C12.492 8.78345 12.7393 8.38779 12.8381 7.945C12.9499 7.45294 13.0042 6.94958 13 6.445C12.9936 5.59092 12.8178 4.74659 12.4828 3.96094C12.1477 3.17529 11.6601 2.46395 11.0481 1.86813ZM11.8606 7.725C11.811 7.9456 11.6875 8.14264 11.5107 8.28355C11.3339 8.42447 11.1142 8.50083 10.8881 8.5H8C7.46957 8.5 6.96086 8.71072 6.58579 9.08579C6.21071 9.46086 6 9.96957 6 10.5C5.99977 10.6597 5.96128 10.8171 5.88775 10.9589C5.81423 11.1007 5.7078 11.2228 5.57739 11.315C5.44698 11.4073 5.29637 11.4669 5.13818 11.489C4.97998 11.511 4.8188 11.4949 4.66812 11.4419C2.40562 10.6438 1 8.75 1 6.5C0.999922 5.05111 1.57157 3.66072 2.59075 2.63089C3.60993 1.60106 4.99431 1.01499 6.44312 1H6.49937C7.94824 1.00563 9.33685 1.58049 10.3657 2.60061C11.3946 3.62073 11.9813 5.00436 11.9994 6.45313C12.0031 6.88092 11.9574 7.30771 11.8631 7.725H11.8606ZM7.25 3.25C7.25 3.39834 7.20601 3.54334 7.1236 3.66668C7.04119 3.79002 6.92406 3.88615 6.78701 3.94291C6.64997 3.99968 6.49917 4.01453 6.35368 3.98559C6.2082 3.95665 6.07456 3.88522 5.96967 3.78033C5.86478 3.67544 5.79335 3.54181 5.76441 3.39632C5.73547 3.25084 5.75032 3.10004 5.80709 2.96299C5.86386 2.82595 5.95999 2.70881 6.08332 2.6264C6.20666 2.54399 6.35166 2.5 6.5 2.5C6.69891 2.5 6.88968 2.57902 7.03033 2.71967C7.17098 2.86033 7.25 3.05109 7.25 3.25ZM4.5 4.75C4.5 4.89834 4.45601 5.04334 4.3736 5.16668C4.29119 5.29002 4.17406 5.38615 4.03701 5.44291C3.89997 5.49968 3.74917 5.51453 3.60368 5.48559C3.4582 5.45665 3.32456 5.38522 3.21967 5.28033C3.11478 5.17544 3.04335 5.04181 3.01441 4.89632C2.98547 4.75084 3.00032 4.60004 3.05709 4.46299C3.11386 4.32595 3.20999 4.20881 3.33332 4.1264C3.45666 4.04399 3.60166 4 3.75 4C3.94891 4 4.13968 4.07902 4.28033 4.21967C4.42098 4.36033 4.5 4.55109 4.5 4.75ZM4.5 8.25C4.5 8.39834 4.45601 8.54335 4.3736 8.66668C4.29119 8.79002 4.17406 8.88615 4.03701 8.94291C3.89997 8.99968 3.74917 9.01453 3.60368 8.98559C3.4582 8.95665 3.32456 8.88522 3.21967 8.78033C3.11478 8.67545 3.04335 8.54181 3.01441 8.39632C2.98547 8.25084 3.00032 8.10004 3.05709 7.96299C3.11386 7.82595 3.20999 7.70881 3.33332 7.6264C3.45666 7.54399 3.60166 7.5 3.75 7.5C3.94891 7.5 4.13968 7.57902 4.28033 7.71967C4.42098 7.86033 4.5 8.05109 4.5 8.25ZM10 4.75C10 4.89834 9.95601 5.04334 9.8736 5.16668C9.79119 5.29002 9.67406 5.38615 9.53701 5.44291C9.39997 5.49968 9.24917 5.51453 9.10368 5.48559C8.9582 5.45665 8.82456 5.38522 8.71967 5.28033C8.61478 5.17544 8.54335 5.04181 8.51441 4.89632C8.48547 4.75084 8.50032 4.60004 8.55709 4.46299C8.61386 4.32595 8.70998 4.20881 8.83332 4.1264C8.95666 4.04399 9.10166 4 9.25 4C9.44891 4 9.63968 4.07902 9.78033 4.21967C9.92098 4.36033 10 4.55109 10 4.75Z" fill="currentColor"/>
</svg>
`, Kve = `<svg width="7" height="15" viewBox="0 0 7 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.5 15C2.57205 14.999 1.68238 14.6299 1.02622 13.9738C0.370059 13.3176 0.000992232 12.428 -5.02681e-07 11.5L-1.09278e-07 2.5C-8.0296e-08 1.83696 0.263392 1.20107 0.732233 0.732233C1.20107 0.263392 1.83696 -2.25684e-07 2.5 -1.96701e-07C3.16304 -1.67719e-07 3.79893 0.263392 4.26777 0.732233C4.73661 1.20107 5 1.83696 5 2.5L5 11.5C5 11.8978 4.84196 12.2794 4.56066 12.5607C4.27936 12.842 3.89782 13 3.5 13C3.10217 13 2.72064 12.842 2.43934 12.5607C2.15803 12.2794 2 11.8978 2 11.5L2 4.5C2 4.36739 2.05268 4.24021 2.14645 4.14645C2.24021 4.05268 2.36739 4 2.5 4C2.63261 4 2.75979 4.05268 2.85355 4.14645C2.94732 4.24021 3 4.36739 3 4.5L3 11.5C3 11.6326 3.05268 11.7598 3.14645 11.8536C3.24021 11.9473 3.36739 12 3.5 12C3.63261 12 3.75978 11.9473 3.85355 11.8536C3.94732 11.7598 4 11.6326 4 11.5L4 2.5C4 2.10218 3.84196 1.72064 3.56066 1.43934C3.27936 1.15804 2.89782 1 2.5 1C2.10218 1 1.72064 1.15804 1.43934 1.43934C1.15804 1.72064 1 2.10217 1 2.5L0.999999 11.5C0.999999 12.163 1.26339 12.7989 1.73223 13.2678C2.20107 13.7366 2.83696 14 3.5 14C4.16304 14 4.79893 13.7366 5.26777 13.2678C5.73661 12.7989 6 12.163 6 11.5L6 4.5C6 4.36739 6.05268 4.24021 6.14645 4.14645C6.24021 4.05268 6.36739 4 6.5 4C6.63261 4 6.75978 4.05268 6.85355 4.14645C6.94732 4.24021 7 4.36739 7 4.5L7 11.5C6.99901 12.428 6.62994 13.3176 5.97378 13.9738C5.31761 14.6299 4.42795 14.999 3.5 15Z" fill="currentColor"/>
</svg>
`, qve = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><rect width="256" height="256" fill="none"/><line x1="144" y1="128" x2="80" y2="128" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><path d="M48.49,221.28A8,8,0,0,0,59.93,231l168-96.09a8,8,0,0,0,0-14l-168-95.85a8,8,0,0,0-11.44,9.67L80,128Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/></svg>', Yve = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 256 256"><path fill="currentColor" d="M209.66,122.34a8,8,0,0,1,0,11.32l-82.05,82a56,56,0,0,1-79.2-79.21L147.67,35.73a40,40,0,1,1,56.61,56.55L105,193A24,24,0,1,1,71,159L154.3,74.38A8,8,0,1,1,165.7,85.6L82.39,170.31a8,8,0,1,0,11.27,11.36L192.93,81A24,24,0,1,0,159,47L59.76,147.68a40,40,0,1,0,56.53,56.62l82.06-82A8,8,0,0,1,209.66,122.34Z"></path></svg>', Qve = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M227.32,73.37,182.63,28.69a16,16,0,0,0-22.63,0L36.69,152A15.86,15.86,0,0,0,32,163.31V208a16,16,0,0,0,16,16H216a8,8,0,0,0,0-16H115.32l112-112A16,16,0,0,0,227.32,73.37ZM136,75.31,152.69,92,68,176.69,51.31,160ZM48,208V179.31L76.69,208Zm48-3.31L79.32,188,164,103.31,180.69,120Zm96-96L147.32,64l24-24L216,84.69Z"></path></svg>', Jve = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M227.32,73.37,182.63,28.69a16,16,0,0,0-22.63,0L36.69,152A15.86,15.86,0,0,0,32,163.31V208a16,16,0,0,0,16,16H216a8,8,0,0,0,0-16H115.32l112-112A16,16,0,0,0,227.32,73.37ZM92.69,208H48V163.31l88-88L180.69,120ZM192,108.69,147.32,64l24-24L216,84.69Z"></path></svg>', Xve = `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" viewBox="0 0 256 256"><path d="M227.31,73.37,182.63,28.68a16,16,0,0,0-22.63,0L36.69,152A15.86,15.86,0,0,0,32,163.31V208a16,16,0,0,0,16,16H92.69A15.86,15.86,0,0,0,104,219.31L227.31,96a16,16,0,0,0,0-22.63ZM92.69,208H48V163.31l88-88L180.69,120ZM192,108.68,147.31,64l24-24L216,84.68Z"></path></svg>
`, eme = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M222.37,158.46l-47.11-21.11-.13-.06a16,16,0,0,0-15.17,1.4,8.12,8.12,0,0,0-.75.56L134.87,160c-15.42-7.49-31.34-23.29-38.83-38.51l20.78-24.71c.2-.25.39-.5.57-.77a16,16,0,0,0,1.32-15.06l0-.12L97.54,33.64a16,16,0,0,0-16.62-9.52A56.26,56.26,0,0,0,32,80c0,79.4,64.6,144,144,144a56.26,56.26,0,0,0,55.88-48.92A16,16,0,0,0,222.37,158.46ZM176,208A128.14,128.14,0,0,1,48,80,40.2,40.2,0,0,1,82.87,40a.61.61,0,0,0,0,.12l21,47L83.2,111.86a6.13,6.13,0,0,0-.57.77,16,16,0,0,0-1,15.7c9.06,18.53,27.73,37.06,46.46,46.11a16,16,0,0,0,15.75-1.14,8.44,8.44,0,0,0,.74-.56L168.89,152l47,21.05h0s.08,0,.11,0A40.21,40.21,0,0,1,176,208Z"></path></svg>', tme = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><rect width="256" height="256" fill="none"/><line x1="144" y1="64" x2="184" y2="24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><line x1="232" y1="72" x2="192" y2="112" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><line x1="224" y1="144" x2="112" y2="32" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><path d="M212,132l-58.63,58.63a32,32,0,0,1-45.25,0L65.37,147.88a32,32,0,0,1,0-45.25L124,44" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><line x1="86.75" y1="169.25" x2="32" y2="224" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/></svg>', ome = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm48-88a8,8,0,0,1-8,8H136v32a8,8,0,0,1-16,0V136H88a8,8,0,0,1,0-16h32V88a8,8,0,0,1,16,0v32h32A8,8,0,0,1,176,128Z"></path></svg>', nme = `<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18.1536 10C18.1536 10.1658 18.0877 10.3247 17.9705 10.4419C17.8533 10.5592 17.6943 10.625 17.5286 10.625H11.2786V16.875C11.2786 17.0408 11.2127 17.1997 11.0955 17.3169C10.9783 17.4342 10.8193 17.5 10.6536 17.5C10.4878 17.5 10.3288 17.4342 10.2116 17.3169C10.0944 17.1997 10.0286 17.0408 10.0286 16.875V10.625H3.77856C3.6128 10.625 3.45383 10.5592 3.33662 10.4419C3.21941 10.3247 3.15356 10.1658 3.15356 10C3.15356 9.83424 3.21941 9.67527 3.33662 9.55806C3.45383 9.44085 3.6128 9.375 3.77856 9.375H10.0286V3.125C10.0286 2.95924 10.0944 2.80027 10.2116 2.68306C10.3288 2.56585 10.4878 2.5 10.6536 2.5C10.8193 2.5 10.9783 2.56585 11.0955 2.68306C11.2127 2.80027 11.2786 2.95924 11.2786 3.125V9.375H17.5286C17.6943 9.375 17.8533 9.44085 17.9705 9.55806C18.0877 9.67527 18.1536 9.83424 18.1536 10Z" fill="currentColor"/>
</svg>
`, sme = `<svg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.5211 3.125H14.375V0.625C14.375 0.45924 14.3092 0.300269 14.1919 0.183058C14.0747 0.0658481 13.9158 0 13.75 0H3.75C3.58424 0 3.42527 0.0658481 3.30806 0.183058C3.19085 0.300269 3.125 0.45924 3.125 0.625V3.125H1.97891C0.8875 3.125 0 3.96641 0 5V11.25C0 11.4158 0.065848 11.5747 0.183058 11.6919C0.300268 11.8092 0.45924 11.875 0.625 11.875H3.125V14.375C3.125 14.5408 3.19085 14.6997 3.30806 14.8169C3.42527 14.9342 3.58424 15 3.75 15H13.75C13.9158 15 14.0747 14.9342 14.1919 14.8169C14.3092 14.6997 14.375 14.5408 14.375 14.375V11.875H16.875C17.0408 11.875 17.1997 11.8092 17.3169 11.6919C17.4342 11.5747 17.5 11.4158 17.5 11.25V5C17.5 3.96641 16.6125 3.125 15.5211 3.125ZM4.375 1.25H13.125V3.125H4.375V1.25ZM13.125 13.75H4.375V10H13.125V13.75ZM16.25 10.625H14.375V9.375C14.375 9.20924 14.3092 9.05027 14.1919 8.93306C14.0747 8.81585 13.9158 8.75 13.75 8.75H3.75C3.58424 8.75 3.42527 8.81585 3.30806 8.93306C3.19085 9.05027 3.125 9.20924 3.125 9.375V10.625H1.25V5C1.25 4.65547 1.57734 4.375 1.97891 4.375H15.5211C15.9227 4.375 16.25 4.65547 16.25 5V10.625ZM14.375 6.5625C14.375 6.74792 14.32 6.92918 14.217 7.08335C14.114 7.23752 13.9676 7.35768 13.7963 7.42864C13.625 7.49959 13.4365 7.51816 13.2546 7.48199C13.0727 7.44581 12.9057 7.35652 12.7746 7.22541C12.6435 7.0943 12.5542 6.92725 12.518 6.7454C12.4818 6.56354 12.5004 6.37504 12.5714 6.20373C12.6423 6.03243 12.7625 5.88601 12.9167 5.783C13.0708 5.67998 13.2521 5.625 13.4375 5.625C13.6861 5.625 13.9246 5.72377 14.1004 5.89959C14.2762 6.0754 14.375 6.31386 14.375 6.5625Z" fill="currentColor"/>
</svg>
`, ime = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><rect width="256" height="256" fill="none"/><path d="M229.66,98.34a8,8,0,0,0,0-11.31L169,26.34a8,8,0,0,0-11.31,0L100.39,83.8S72.64,69.93,43,93.85a8,8,0,0,0-.65,11.91l107.9,107.89a8,8,0,0,0,12-.83c8.39-11.16,21.57-34.09,10.11-57Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><line x1="96.29" y1="159.71" x2="48" y2="208" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/></svg>', rme = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M140,180a12,12,0,1,1-12-12A12,12,0,0,1,140,180ZM128,72c-22.06,0-40,16.15-40,36v4a8,8,0,0,0,16,0v-4c0-11,10.77-20,24-20s24,9,24,20-10.77,20-24,20a8,8,0,0,0-8,8v8a8,8,0,0,0,16,0v-.72c18.24-3.35,32-17.9,32-35.28C168,88.15,150.06,72,128,72Zm104,56A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z"></path></svg>', lme = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M208,112H48a16,16,0,0,0-16,16v24a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V128A16,16,0,0,0,208,112Zm0,40H48V128H208v24Zm0-112H48A16,16,0,0,0,32,56V80A16,16,0,0,0,48,96H208a16,16,0,0,0,16-16V56A16,16,0,0,0,208,40Zm0,40H48V56H208V80ZM160,216a8,8,0,0,1-8,8H136v16a8,8,0,0,1-16,0V224H104a8,8,0,0,1,0-16h16V192a8,8,0,0,1,16,0v16h16A8,8,0,0,1,160,216Z"></path></svg>', ame = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M208,160H48a16,16,0,0,0-16,16v24a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V176A16,16,0,0,0,208,160Zm0,40H48V176H208v24Zm0-112H48a16,16,0,0,0-16,16v24a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V104A16,16,0,0,0,208,88Zm0,40H48V104H208v24ZM96,40a8,8,0,0,1,8-8h16V16a8,8,0,0,1,16,0V32h16a8,8,0,0,1,0,16H136V64a8,8,0,0,1-16,0V48H104A8,8,0,0,1,96,40Z"></path></svg>', cme = `<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18.8166 17.38L14.9049 13.4691C16.0387 12.1079 16.604 10.362 16.4834 8.59465C16.3627 6.82726 15.5653 5.17443 14.2571 3.97999C12.9488 2.78555 11.2304 2.14146 9.45937 2.18171C7.68833 2.22196 6.00098 2.94345 4.74834 4.19609C3.4957 5.44873 2.77421 7.13608 2.73396 8.90713C2.69371 10.6782 3.3378 12.3966 4.53224 13.7048C5.72668 15.0131 7.37951 15.8105 9.1469 15.9311C10.9143 16.0518 12.6602 15.4864 14.0213 14.3527L17.9323 18.2644C17.9903 18.3225 18.0593 18.3685 18.1351 18.3999C18.211 18.4314 18.2923 18.4475 18.3744 18.4475C18.4566 18.4475 18.5379 18.4314 18.6138 18.3999C18.6896 18.3685 18.7586 18.3225 18.8166 18.2644C18.8747 18.2063 18.9208 18.1374 18.9522 18.0615C18.9836 17.9856 18.9998 17.9043 18.9998 17.8222C18.9998 17.7401 18.9836 17.6588 18.9522 17.5829C18.9208 17.507 18.8747 17.4381 18.8166 17.38ZM3.99945 9.0722C3.99945 7.95968 4.32935 6.87214 4.94743 5.94712C5.56551 5.02209 6.44402 4.30112 7.47185 3.87538C8.49969 3.44963 9.63069 3.33824 10.7218 3.55528C11.813 3.77232 12.8153 4.30805 13.6019 5.09472C14.3886 5.88139 14.9243 6.88367 15.1414 7.97482C15.3584 9.06596 15.247 10.197 14.8213 11.2248C14.3955 12.2526 13.6746 13.1311 12.7495 13.7492C11.8245 14.3673 10.737 14.6972 9.62445 14.6972C8.13311 14.6955 6.70333 14.1024 5.6488 13.0479C4.59426 11.9933 4.0011 10.5635 3.99945 9.0722Z" fill="currentColor"/>
</svg>
`, dme = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><rect width="256" height="256" fill="none"/><polyline points="192 72 192 48 64 48 128 128 64 208 192 208 192 184" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/></svg>', ume = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M141.66,133.66l-40,40a8,8,0,0,1-11.32-11.32L116.69,136H24a8,8,0,0,1,0-16h92.69L90.34,93.66a8,8,0,0,1,11.32-11.32l40,40A8,8,0,0,1,141.66,133.66ZM200,32H136a8,8,0,0,0,0,16h56V208H136a8,8,0,0,0,0,16h64a8,8,0,0,0,8-8V40A8,8,0,0,0,200,32Z"></path></svg>', hme = `<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.2339 16.875C10.2339 17.0408 10.168 17.1997 10.0508 17.3169C9.93362 17.4342 9.77465 17.5 9.60889 17.5H4.60889C4.44313 17.5 4.28416 17.4342 4.16695 17.3169C4.04973 17.1997 3.98389 17.0408 3.98389 16.875V3.125C3.98389 2.95924 4.04973 2.80027 4.16695 2.68306C4.28416 2.56585 4.44313 2.5 4.60889 2.5H9.60889C9.77465 2.5 9.93362 2.56585 10.0508 2.68306C10.168 2.80027 10.2339 2.95924 10.2339 3.125C10.2339 3.29076 10.168 3.44973 10.0508 3.56694C9.93362 3.68415 9.77465 3.75 9.60889 3.75H5.23389V16.25H9.60889C9.77465 16.25 9.93362 16.3158 10.0508 16.4331C10.168 16.5503 10.2339 16.7092 10.2339 16.875ZM18.8011 9.55781L15.6761 6.43281C15.5588 6.31554 15.3997 6.24965 15.2339 6.24965C15.068 6.24965 14.909 6.31554 14.7917 6.43281C14.6744 6.55009 14.6085 6.70915 14.6085 6.875C14.6085 7.04085 14.6744 7.19991 14.7917 7.31719L16.8503 9.375H9.60889C9.44313 9.375 9.28416 9.44085 9.16694 9.55806C9.04974 9.67527 8.98389 9.83424 8.98389 10C8.98389 10.1658 9.04974 10.3247 9.16694 10.4419C9.28416 10.5592 9.44313 10.625 9.60889 10.625H16.8503L14.7917 12.6828C14.6744 12.8001 14.6085 12.9591 14.6085 13.125C14.6085 13.2909 14.6744 13.4499 14.7917 13.5672C14.909 13.6845 15.068 13.7503 15.2339 13.7503C15.3997 13.7503 15.5588 13.6845 15.6761 13.5672L18.8011 10.4422C18.8592 10.3841 18.9053 10.3152 18.9367 10.2393C18.9682 10.1635 18.9844 10.0821 18.9844 10C18.9844 9.91787 18.9682 9.83654 18.9367 9.76066C18.9053 9.68479 18.8592 9.61586 18.8011 9.55781Z" fill="currentColor"/>
</svg>
`, gme = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2.5 5.50002H4.5625C4.67265 5.93022 4.92285 6.31153 5.27365 6.58384C5.62446 6.85614 6.05591 7.00394 6.5 7.00394C6.94409 7.00394 7.37554 6.85614 7.72635 6.58384C8.07715 6.31153 8.32735 5.93022 8.4375 5.50002H13.5C13.6326 5.50002 13.7598 5.44734 13.8536 5.35357C13.9473 5.2598 14 5.13262 14 5.00002C14 4.86741 13.9473 4.74023 13.8536 4.64646C13.7598 4.55269 13.6326 4.50002 13.5 4.50002H8.4375C8.32735 4.06981 8.07715 3.6885 7.72635 3.4162C7.37554 3.14389 6.94409 2.99609 6.5 2.99609C6.05591 2.99609 5.62446 3.14389 5.27365 3.4162C4.92285 3.6885 4.67265 4.06981 4.5625 4.50002H2.5C2.36739 4.50002 2.24021 4.55269 2.14645 4.64646C2.05268 4.74023 2 4.86741 2 5.00002C2 5.13262 2.05268 5.2598 2.14645 5.35357C2.24021 5.44734 2.36739 5.50002 2.5 5.50002ZM6.5 4.00002C6.69778 4.00002 6.89112 4.05866 7.05557 4.16855C7.22002 4.27843 7.34819 4.43461 7.42388 4.61733C7.49957 4.80006 7.51937 5.00112 7.48079 5.19511C7.4422 5.38909 7.34696 5.56727 7.20711 5.70712C7.06725 5.84697 6.88907 5.94222 6.69509 5.9808C6.50111 6.01939 6.30004 5.99958 6.11732 5.9239C5.93459 5.84821 5.77841 5.72003 5.66853 5.55559C5.55865 5.39114 5.5 5.1978 5.5 5.00002C5.5 4.7348 5.60536 4.48045 5.79289 4.29291C5.98043 4.10537 6.23478 4.00002 6.5 4.00002ZM13.5 10.5H12.4375C12.3273 10.0698 12.0771 9.6885 11.7263 9.4162C11.3755 9.1439 10.9441 8.99609 10.5 8.99609C10.0559 8.99609 9.62446 9.1439 9.27365 9.4162C8.92285 9.6885 8.67265 10.0698 8.5625 10.5H2.5C2.36739 10.5 2.24021 10.5527 2.14645 10.6465C2.05268 10.7402 2 10.8674 2 11C2 11.1326 2.05268 11.2598 2.14645 11.3536C2.24021 11.4473 2.36739 11.5 2.5 11.5H8.5625C8.67265 11.9302 8.92285 12.3115 9.27365 12.5838C9.62446 12.8561 10.0559 13.0039 10.5 13.0039C10.9441 13.0039 11.3755 12.8561 11.7263 12.5838C12.0771 12.3115 12.3273 11.9302 12.4375 11.5H13.5C13.6326 11.5 13.7598 11.4473 13.8536 11.3536C13.9473 11.2598 14 11.1326 14 11C14 10.8674 13.9473 10.7402 13.8536 10.6465C13.7598 10.5527 13.6326 10.5 13.5 10.5ZM10.5 12C10.3022 12 10.1089 11.9414 9.94443 11.8315C9.77998 11.7216 9.65181 11.5654 9.57612 11.3827C9.50043 11.2 9.48063 10.9989 9.51921 10.8049C9.5578 10.6109 9.65304 10.4328 9.79289 10.2929C9.93275 10.1531 10.1109 10.0578 10.3049 10.0192C10.4989 9.98064 10.7 10.0004 10.8827 10.0761C11.0654 10.1518 11.2216 10.28 11.3315 10.4444C11.4414 10.6089 11.5 10.8022 11.5 11C11.5 11.2652 11.3946 11.5196 11.2071 11.7071C11.0196 11.8947 10.7652 12 10.5 12Z" fill="currentColor"/>
</svg>
`, pme = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" viewBox="0 0 256 256"><path d="M197.58,129.06,146,110l-19-51.62a15.92,15.92,0,0,0-29.88,0L78,110l-51.62,19a15.92,15.92,0,0,0,0,29.88L78,178l19,51.62a15.92,15.92,0,0,0,29.88,0L146,178l51.62-19a15.92,15.92,0,0,0,0-29.88ZM137,164.22a8,8,0,0,0-4.74,4.74L112,223.85,91.78,169A8,8,0,0,0,87,164.22L32.15,144,87,123.78A8,8,0,0,0,91.78,119L112,64.15,132.22,119a8,8,0,0,0,4.74,4.74L191.85,144ZM144,40a8,8,0,0,1,8-8h16V16a8,8,0,0,1,16,0V32h16a8,8,0,0,1,0,16H184V64a8,8,0,0,1-16,0V48H152A8,8,0,0,1,144,40ZM248,88a8,8,0,0,1-8,8h-8v8a8,8,0,0,1-16,0V96h-8a8,8,0,0,1,0-16h8V72a8,8,0,0,1,16,0v8h8A8,8,0,0,1,248,88Z"></path></svg>', fme = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><rect width="256" height="256" fill="none"/><line x1="104" y1="48" x2="104" y2="208" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><line x1="152" y1="48" x2="152" y2="208" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><line x1="152" y1="128" x2="232" y2="128" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><line x1="24" y1="128" x2="104" y2="128" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><polyline points="200 96 232 128 200 160" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><polyline points="56 96 24 128 56 160" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/></svg>', vme = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M230.91,124A8,8,0,0,1,228,134.91l-96,56a8,8,0,0,1-8.06,0l-96-56A8,8,0,0,1,36,121.09l92,53.65,92-53.65A8,8,0,0,1,230.91,124ZM24,80a8,8,0,0,1,4-6.91l96-56a8,8,0,0,1,8.06,0l96,56a8,8,0,0,1,0,13.82l-96,56a8,8,0,0,1-8.06,0l-96-56A8,8,0,0,1,24,80Zm23.88,0L128,126.74,208.12,80,128,33.26ZM232,192H184a8,8,0,0,0,0,16h48a8,8,0,0,0,0-16Zm-92,23.76-12,7L36,169.09A8,8,0,0,0,28,182.91l96,56a8,8,0,0,0,8.06,0l16-9.33A8,8,0,1,0,140,215.76Z"></path></svg>', mme = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M230.91,124A8,8,0,0,1,228,134.91l-96,56a8,8,0,0,1-8.06,0l-96-56A8,8,0,0,1,36,121.09l92,53.65,92-53.65A8,8,0,0,1,230.91,124ZM24,80a8,8,0,0,1,4-6.91l96-56a8,8,0,0,1,8.06,0l96,56a8,8,0,0,1,0,13.82l-96,56a8,8,0,0,1-8.06,0l-96-56A8,8,0,0,1,24,80Zm23.88,0L128,126.74,208.12,80,128,33.26ZM232,192H216V176a8,8,0,0,0-16,0v16H184a8,8,0,0,0,0,16h16v16a8,8,0,0,0,16,0V208h16a8,8,0,0,0,0-16Zm-92,23.76-12,7L36,169.09A8,8,0,0,0,28,182.91l96,56a8,8,0,0,0,8.06,0l16-9.33A8,8,0,1,0,140,215.76Z"></path></svg>', Cme = `<svg width="21" height="21" viewBox="0 0 21 21" fill="black" xmlns="http://www.w3.org/2000/svg">
    <path d="M19.5604 7.92072C19.4822 7.6805 19.3348 7.46879 19.1365 7.31224C18.9383 7.1557 18.6981 7.06133 18.4463 7.04103L13.8369 6.66915L12.0573 2.36525C11.961 2.13073 11.7972 1.93013 11.5867 1.78895C11.3761 1.64777 11.1283 1.57239 10.8748 1.57239C10.6213 1.57239 10.3736 1.64777 10.163 1.78895C9.95247 1.93013 9.78866 2.13073 9.69241 2.36525L7.91429 6.66837L3.30257 7.04103C3.05036 7.06236 2.81006 7.15764 2.61177 7.31494C2.41347 7.47224 2.26601 7.68456 2.18785 7.92529C2.10969 8.16603 2.10431 8.42448 2.17238 8.66826C2.24046 8.91203 2.37896 9.1303 2.57054 9.29572L6.08616 12.3293L5.01507 16.8652C4.95516 17.1117 4.96983 17.3703 5.05721 17.6084C5.14458 17.8465 5.30073 18.0532 5.50582 18.2024C5.71091 18.3516 5.9557 18.4365 6.20911 18.4463C6.46252 18.4561 6.71314 18.3903 6.92913 18.2574L10.8744 15.8293L14.8221 18.2574C15.0382 18.3888 15.2883 18.4532 15.5409 18.4427C15.7935 18.4321 16.0374 18.3471 16.2418 18.1983C16.4462 18.0494 16.602 17.8434 16.6895 17.6062C16.7771 17.369 16.7925 17.1112 16.7338 16.8652L15.6588 12.3285L19.1744 9.29494C19.3676 9.1298 19.5073 8.91106 19.576 8.66642C19.6447 8.42178 19.6393 8.16226 19.5604 7.92072ZM18.3619 8.34806L14.5573 11.6293C14.4705 11.7041 14.4059 11.8013 14.3707 11.9103C14.3354 12.0193 14.3308 12.1358 14.3573 12.2473L15.5198 17.1535C15.5228 17.1603 15.5231 17.168 15.5206 17.1749C15.5181 17.1819 15.5131 17.1877 15.5065 17.191C15.4924 17.202 15.4885 17.1996 15.4768 17.191L11.2018 14.5621C11.1033 14.5016 10.99 14.4695 10.8744 14.4695C10.7589 14.4695 10.6456 14.5016 10.5471 14.5621L6.2721 17.1926C6.26038 17.1996 6.25725 17.202 6.24241 17.1926C6.23582 17.1892 6.23076 17.1835 6.22829 17.1765C6.22582 17.1695 6.22612 17.1619 6.22913 17.1551L7.39163 12.2488C7.41812 12.1374 7.41348 12.0208 7.37821 11.9118C7.34294 11.8029 7.2784 11.7057 7.19163 11.6309L3.38694 8.34962C3.37757 8.34181 3.36897 8.33478 3.37679 8.31056C3.3846 8.28634 3.39085 8.28947 3.40257 8.2879L8.39632 7.88478C8.51086 7.87496 8.62047 7.83373 8.71309 7.76564C8.80572 7.69755 8.87777 7.60523 8.92132 7.49884L10.8448 2.84181C10.851 2.82853 10.8533 2.82228 10.8721 2.82228C10.8908 2.82228 10.8932 2.82853 10.8994 2.84181L12.8276 7.49884C12.8715 7.60527 12.944 7.69749 13.0371 7.76532C13.1301 7.83315 13.2401 7.87395 13.3549 7.88322L18.3487 8.28634C18.3604 8.28634 18.3674 8.28634 18.3744 8.309C18.3815 8.33166 18.3744 8.34025 18.3619 8.34806Z" fill="currentColor"/>
</svg>
`, wme = `<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16.875 4.69727H13.75V4.07227C13.75 3.57498 13.5525 3.09807 13.2008 2.74644C12.8492 2.39481 12.3723 2.19727 11.875 2.19727H8.125C7.62772 2.19727 7.15081 2.39481 6.79917 2.74644C6.44754 3.09807 6.25 3.57498 6.25 4.07227V4.69727H3.125C2.79348 4.69727 2.47554 4.82896 2.24112 5.06338C2.0067 5.2978 1.875 5.61575 1.875 5.94727V15.9473C1.875 16.2788 2.0067 16.5967 2.24112 16.8311C2.47554 17.0656 2.79348 17.1973 3.125 17.1973H16.875C17.2065 17.1973 17.5245 17.0656 17.7589 16.8311C17.9933 16.5967 18.125 16.2788 18.125 15.9473V5.94727C18.125 5.61575 17.9933 5.2978 17.7589 5.06338C17.5245 4.82896 17.2065 4.69727 16.875 4.69727ZM7.5 4.07227C7.5 3.90651 7.56585 3.74753 7.68306 3.63032C7.80027 3.51311 7.95924 3.44727 8.125 3.44727H11.875C12.0408 3.44727 12.1997 3.51311 12.3169 3.63032C12.4342 3.74753 12.5 3.90651 12.5 4.07227V4.69727H7.5V4.07227ZM16.875 5.94727V11.5723H3.125V5.94727H16.875ZM16.875 15.9473H3.125V12.8223H16.875V15.9473Z" fill="currentColor"/>
</svg>
`, bme = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M224,48V152a16,16,0,0,1-16,16H99.31l10.35,10.34a8,8,0,0,1-11.32,11.32l-24-24a8,8,0,0,1,0-11.32l24-24a8,8,0,0,1,11.32,11.32L99.31,152H208V48H96v8a8,8,0,0,1-16,0V48A16,16,0,0,1,96,32H208A16,16,0,0,1,224,48ZM168,192a8,8,0,0,0-8,8v8H48V104H156.69l-10.35,10.34a8,8,0,0,0,11.32,11.32l24-24a8,8,0,0,0,0-11.32l-24-24a8,8,0,0,0-11.32,11.32L156.69,88H48a16,16,0,0,0-16,16V208a16,16,0,0,0,16,16H160a16,16,0,0,0,16-16v-8A8,8,0,0,0,168,192Z"></path></svg>', yme = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M224,48H32a8,8,0,0,0-8,8V192a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A8,8,0,0,0,224,48ZM40,112H80v32H40Zm56,0H216v32H96ZM216,64V96H40V64ZM40,160H80v32H40Zm176,32H96V160H216v32Z"></path></svg>', _me = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_4192_3982)">
<path d="M19.9734 12.9454C19.9738 12.9433 19.9738 12.9412 19.9734 12.9391L18.232 7.14067C18.156 6.88256 17.9982 6.65614 17.7823 6.4955C17.5664 6.33487 17.3042 6.24873 17.0352 6.25004H16.25C16.0842 6.25004 15.9253 6.31589 15.8081 6.4331C15.6908 6.55031 15.625 6.70928 15.625 6.87504C15.625 7.0408 15.6908 7.19977 15.8081 7.31698C15.9253 7.43419 16.0842 7.50004 16.25 7.50004H17.0352L18.5352 12.5H16.0938L14.482 7.14067C14.406 6.88256 14.2482 6.65614 14.0323 6.4955C13.8164 6.33487 13.5542 6.24873 13.2852 6.25004H12.5C12.3342 6.25004 12.1753 6.31589 12.0581 6.4331C11.9408 6.55031 11.875 6.70928 11.875 6.87504C11.875 7.0408 11.9408 7.19977 12.0581 7.31698C12.1753 7.43419 12.3342 7.50004 12.5 7.50004H13.2852L14.7852 12.5H12.3438L10.732 7.14067C10.656 6.88256 10.4982 6.65614 10.2823 6.4955C10.0664 6.33487 9.80423 6.24873 9.53516 6.25004H2.96875C2.69901 6.24788 2.43591 6.33363 2.21926 6.49433C2.0026 6.65502 1.84418 6.88191 1.76797 7.14067L0.0289063 12.9375V12.9414C0.0289063 12.9414 0.0289063 12.9454 0.0289063 12.9477C0.0108845 13.0051 0.00115099 13.0649 0 13.125C0 13.2908 0.065848 13.4498 0.183058 13.567C0.300269 13.6842 0.45924 13.75 0.625 13.75H19.375C19.4724 13.75 19.5685 13.7272 19.6555 13.6835C19.7426 13.6397 19.8182 13.5762 19.8763 13.498C19.9345 13.4198 19.9735 13.3291 19.9904 13.2332C20.0073 13.1372 20.0014 13.0387 19.9734 12.9454ZM2.96875 7.50004H9.53906L11.0391 12.5H1.46484L2.96875 7.50004Z" fill="currentColor"/>
</g>
<defs>
<clipPath id="clip0_4192_3982">
<rect width="20" height="20" fill="white"/>
</clipPath>
</defs>
</svg>
`, Sme = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M32,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H40A8,8,0,0,1,32,64ZM64,96a8,8,0,0,0,0,16H192a8,8,0,0,0,0-16Zm152,40H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Zm-24,40H64a8,8,0,0,0,0,16H192a8,8,0,0,0,0-16Z"></path></svg>', xme = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M32,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H40A8,8,0,0,1,32,64ZM216,96H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Zm0,40H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Zm0,40H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z"></path></svg>', Mme = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M32,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H40A8,8,0,0,1,32,64Zm8,48H168a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16Zm176,24H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Zm-48,40H40a8,8,0,0,0,0,16H168a8,8,0,0,0,0-16Z"></path></svg>', Ame = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M32,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H40A8,8,0,0,1,32,64ZM216,96H88a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Zm0,40H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Zm0,40H88a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z"></path></svg>', Lme = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M178.48,115.7A44,44,0,0,0,148,40H80a8,8,0,0,0-8,8V200a8,8,0,0,0,8,8h80a48,48,0,0,0,18.48-92.3ZM88,56h60a28,28,0,0,1,0,56H88Zm72,136H88V128h72a32,32,0,0,1,0,64Z"></path></svg>', Eme = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><rect width="256" height="256" fill="none"/><line x1="40" y1="64" x2="112" y2="64" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><line x1="40" y1="104" x2="112" y2="104" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><line x1="40" y1="144" x2="112" y2="144" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><line x1="40" y1="184" x2="112" y2="184" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><line x1="144" y1="64" x2="216" y2="64" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><line x1="144" y1="104" x2="216" y2="104" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><line x1="144" y1="144" x2="216" y2="144" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><line x1="144" y1="184" x2="216" y2="184" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/></svg>', Pme = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M208,56V200a8,8,0,0,1-16,0V136H64v64a8,8,0,0,1-16,0V56a8,8,0,0,1,16,0v64H192V56a8,8,0,0,1,16,0Z"></path></svg>', Rme = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M224,128a8,8,0,0,1-8,8H112a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM112,72H216a8,8,0,0,0,0-16H112a8,8,0,0,0,0,16ZM216,184H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16ZM34.34,141.66a8,8,0,0,0,11.32,0l40-40a8,8,0,0,0,0-11.32l-40-40A8,8,0,0,0,34.34,61.66L68.69,96,34.34,130.34A8,8,0,0,0,34.34,141.66Z"></path></svg>', Fme = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18.427 18.073C18.4502 18.0962 18.4687 18.1238 18.4812 18.1542C18.4938 18.1845 18.5003 18.217 18.5003 18.2499C18.5003 18.2827 18.4938 18.3153 18.4812 18.3456C18.4687 18.376 18.4502 18.4035 18.427 18.4268C18.4038 18.45 18.3762 18.4684 18.3459 18.481C18.3155 18.4936 18.283 18.5 18.2501 18.5C18.2173 18.5 18.1848 18.4936 18.1544 18.481C18.1241 18.4684 18.0965 18.45 18.0733 18.4268L16.0001 16.3533L13.927 18.4268C13.8801 18.4737 13.8165 18.5 13.7501 18.5C13.6838 18.5 13.6202 18.4737 13.5733 18.4268C13.5264 18.3799 13.5 18.3162 13.5 18.2499C13.5 18.1836 13.5264 18.1199 13.5733 18.073L15.6467 15.9999L13.5733 13.9268C13.5264 13.8799 13.5 13.8162 13.5 13.7499C13.5 13.6836 13.5264 13.6199 13.5733 13.573C13.6202 13.5261 13.6838 13.4998 13.7501 13.4998C13.8165 13.4998 13.8801 13.5261 13.927 13.573L16.0001 15.6465L18.0733 13.573C18.1202 13.5261 18.1838 13.4998 18.2501 13.4998C18.3165 13.4998 18.3801 13.5261 18.427 13.573C18.4739 13.6199 18.5003 13.6836 18.5003 13.7499C18.5003 13.8162 18.4739 13.8799 18.427 13.9268L16.3536 15.9999L18.427 18.073Z" fill="#272E35"/>
<path d="M15.625 4.375C15.625 4.54076 15.5592 4.69973 15.4419 4.81694C15.3247 4.93415 15.1658 5 15 5H12.3258L8.99219 15H11.25C11.4158 15 11.5747 15.0658 11.6919 15.1831C11.8092 15.3003 11.875 15.4592 11.875 15.625C11.875 15.7908 11.8092 15.9497 11.6919 16.0669C11.5747 16.1842 11.4158 16.25 11.25 16.25H5C4.83424 16.25 4.67527 16.1842 4.55806 16.0669C4.44085 15.9497 4.375 15.7908 4.375 15.625C4.375 15.4592 4.44085 15.3003 4.55806 15.1831C4.67527 15.0658 4.83424 15 5 15H7.67422L11.0078 5H8.75C8.58424 5 8.42527 4.93415 8.30806 4.81694C8.19085 4.69973 8.125 4.54076 8.125 4.375C8.125 4.20924 8.19085 4.05027 8.30806 3.93306C8.42527 3.81585 8.58424 3.75 8.75 3.75H15C15.1658 3.75 15.3247 3.81585 15.4419 3.93306C15.5592 4.05027 15.625 4.20924 15.625 4.375Z" fill="#272E35"/>
</svg>
`, Tme = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M200,56a8,8,0,0,1-8,8H157.77L115.1,192H144a8,8,0,0,1,0,16H64a8,8,0,0,1,0-16H98.23L140.9,64H112a8,8,0,0,1,0-16h80A8,8,0,0,1,200,56Z"></path></svg>', Ime = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M224,128a8,8,0,0,1-8,8H112a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM112,72H216a8,8,0,0,0,0-16H112a8,8,0,0,0,0,16ZM216,184H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16ZM72,144a8,8,0,0,0,5.66-13.66L43.31,96,77.66,61.66A8,8,0,0,0,66.34,50.34l-40,40a8,8,0,0,0,0,11.32l40,40A8,8,0,0,0,72,144Z"></path></svg>', Dme = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><rect width="256" height="256" fill="none"/><line x1="48" y1="40" x2="208" y2="216" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><line x1="96" y1="200" x2="160" y2="200" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><line x1="128" y1="128" x2="128" y2="200" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><line x1="128" y1="56" x2="128" y2="80.43" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><polyline points="105.79 56 200 56 200 88" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><polyline points="56 88 56 56 62.55 56" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/></svg>', kme = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16.2502 4.375V6.875C16.2502 7.04076 16.1843 7.19973 16.0671 7.31694C15.9499 7.43415 15.7909 7.5 15.6252 7.5C15.4594 7.5 15.3005 7.43415 15.1832 7.31694C15.066 7.19973 15.0002 7.04076 15.0002 6.875V5H10.6252V15H12.5002C12.6659 15 12.8249 15.0658 12.9421 15.1831C13.0593 15.3003 13.1252 15.4592 13.1252 15.625C13.1252 15.7908 13.0593 15.9497 12.9421 16.0669C12.8249 16.1842 12.6659 16.25 12.5002 16.25H7.50018C7.33442 16.25 7.17545 16.1842 7.05824 16.0669C6.94103 15.9497 6.87518 15.7908 6.87518 15.625C6.87518 15.4592 6.94103 15.3003 7.05824 15.1831C7.17545 15.0658 7.33442 15 7.50018 15H9.37518V5H5.00018V6.875C5.00018 7.04076 4.93433 7.19973 4.81712 7.31694C4.69991 7.43415 4.54094 7.5 4.37518 7.5C4.20942 7.5 4.05045 7.43415 3.93324 7.31694C3.81603 7.19973 3.75018 7.04076 3.75018 6.875V4.375C3.75018 4.20924 3.81603 4.05027 3.93324 3.93306C4.05045 3.81585 4.20942 3.75 4.37518 3.75H15.6252C15.7909 3.75 15.9499 3.81585 16.0671 3.93306C16.1843 4.05027 16.2502 4.20924 16.2502 4.375Z" fill="currentColor"/>
</svg>
`, Hme = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M112,40a8,8,0,0,0-8,8V64H24A16,16,0,0,0,8,80v96a16,16,0,0,0,16,16h80v16a8,8,0,0,0,16,0V48A8,8,0,0,0,112,40ZM24,176V80h80v96ZM248,80v96a16,16,0,0,1-16,16H144a8,8,0,0,1,0-16h88V80H144a8,8,0,0,1,0-16h88A16,16,0,0,1,248,80ZM88,112a8,8,0,0,1-8,8H72v24a8,8,0,0,1-16,0V120H48a8,8,0,0,1,0-16H80A8,8,0,0,1,88,112Z"></path></svg>', Vme = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M128,40a96,96,0,1,0,96,96A96.11,96.11,0,0,0,128,40Zm0,176a80,80,0,1,1,80-80A80.09,80.09,0,0,1,128,216ZM173.66,90.34a8,8,0,0,1,0,11.32l-40,40a8,8,0,0,1-11.32-11.32l40-40A8,8,0,0,1,173.66,90.34ZM96,16a8,8,0,0,1,8-8h48a8,8,0,0,1,0,16H104A8,8,0,0,1,96,16Z"></path></svg>', Ome = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M216,48H176V40a24,24,0,0,0-24-24H104A24,24,0,0,0,80,40v8H40a8,8,0,0,0,0,16h8V208a16,16,0,0,0,16,16H192a16,16,0,0,0,16-16V64h8a8,8,0,0,0,0-16ZM96,40a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8v8H96Zm96,168H64V64H192ZM112,104v64a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Zm48,0v64a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Z"/></svg>
`, Bme = `<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16.25 2.82227H3.75C3.41848 2.82227 3.10054 2.95396 2.86612 3.18838C2.6317 3.4228 2.5 3.74075 2.5 4.07227V16.5723C2.5 16.9038 2.6317 17.2217 2.86612 17.4561C3.10054 17.6906 3.41848 17.8223 3.75 17.8223H16.25C16.5815 17.8223 16.8995 17.6906 17.1339 17.4561C17.3683 17.2217 17.5 16.9038 17.5 16.5723V4.07227C17.5 3.74075 17.3683 3.4228 17.1339 3.18838C16.8995 2.95396 16.5815 2.82227 16.25 2.82227ZM16.25 4.07227V12.1973H14.0078C13.8437 12.1968 13.6812 12.229 13.5297 12.2919C13.3781 12.3548 13.2406 12.4472 13.125 12.5637L11.6164 14.0723H8.38359L6.875 12.5637C6.75935 12.4471 6.62168 12.3547 6.46999 12.2918C6.3183 12.2289 6.15562 12.1967 5.99141 12.1973H3.75V4.07227H16.25ZM16.25 16.5723H3.75V13.4473H5.99141L7.5 14.9559C7.61565 15.0724 7.75332 15.1649 7.90501 15.2278C8.0567 15.2907 8.21938 15.3228 8.38359 15.3223H11.6164C11.7806 15.3228 11.9433 15.2907 12.095 15.2278C12.2467 15.1649 12.3843 15.0724 12.5 14.9559L14.0086 13.4473H16.25V16.5723Z" fill="currentColor"/>
</svg>
`, $me = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.5 8.75H16.25C16.5815 8.75 16.8995 8.6183 17.1339 8.38388C17.3683 8.14946 17.5 7.83152 17.5 7.5V3.75C17.5 3.41848 17.3683 3.10054 17.1339 2.86612C16.8995 2.6317 16.5815 2.5 16.25 2.5H12.5C12.1685 2.5 11.8505 2.6317 11.6161 2.86612C11.3817 3.10054 11.25 3.41848 11.25 3.75V5H10C9.50272 5 9.02581 5.19754 8.67417 5.54917C8.32254 5.90081 8.125 6.37772 8.125 6.875V9.375H5.625V8.75C5.625 8.41848 5.4933 8.10054 5.25888 7.86612C5.02446 7.6317 4.70652 7.5 4.375 7.5H1.875C1.54348 7.5 1.22554 7.6317 0.991117 7.86612C0.756696 8.10054 0.625 8.41848 0.625 8.75V11.25C0.625 11.5815 0.756696 11.8995 0.991117 12.1339C1.22554 12.3683 1.54348 12.5 1.875 12.5H4.375C4.70652 12.5 5.02446 12.3683 5.25888 12.1339C5.4933 11.8995 5.625 11.5815 5.625 11.25V10.625H8.125V13.125C8.125 13.6223 8.32254 14.0992 8.67417 14.4508C9.02581 14.8025 9.50272 15 10 15H11.25V16.25C11.25 16.5815 11.3817 16.8995 11.6161 17.1339C11.8505 17.3683 12.1685 17.5 12.5 17.5H16.25C16.5815 17.5 16.8995 17.3683 17.1339 17.1339C17.3683 16.8995 17.5 16.5815 17.5 16.25V12.5C17.5 12.1685 17.3683 11.8505 17.1339 11.6161C16.8995 11.3817 16.5815 11.25 16.25 11.25H12.5C12.1685 11.25 11.8505 11.3817 11.6161 11.6161C11.3817 11.8505 11.25 12.1685 11.25 12.5V13.75H10C9.83424 13.75 9.67527 13.6842 9.55806 13.5669C9.44085 13.4497 9.375 13.2908 9.375 13.125V6.875C9.375 6.70924 9.44085 6.55027 9.55806 6.43306C9.67527 6.31585 9.83424 6.25 10 6.25H11.25V7.5C11.25 7.83152 11.3817 8.14946 11.6161 8.38388C11.8505 8.6183 12.1685 8.75 12.5 8.75ZM4.375 11.25H1.875V8.75H4.375V11.25ZM12.5 12.5H16.25V16.25H12.5V12.5ZM12.5 3.75H16.25V7.5H12.5V3.75Z" fill="currentColor"/>
</svg>
`, Zme = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M176,152h32a16,16,0,0,0,16-16V104a16,16,0,0,0-16-16H176a16,16,0,0,0-16,16v8H88V80h8a16,16,0,0,0,16-16V32A16,16,0,0,0,96,16H64A16,16,0,0,0,48,32V64A16,16,0,0,0,64,80h8V192a24,24,0,0,0,24,24h64v8a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V192a16,16,0,0,0-16-16H176a16,16,0,0,0-16,16v8H96a8,8,0,0,1-8-8V128h72v8A16,16,0,0,0,176,152ZM64,32H96V64H64ZM176,192h32v32H176Zm0-88h32v32H176Z"></path></svg>', Gme = `<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18.25 11.4977V16.4977C18.25 16.6634 18.1842 16.8224 18.0669 16.9396C17.9497 17.0568 17.7908 17.1227 17.625 17.1227H3.875C3.70924 17.1227 3.55027 17.0568 3.43306 16.9396C3.31585 16.8224 3.25 16.6634 3.25 16.4977V11.4977C3.25 11.3319 3.31585 11.173 3.43306 11.0557C3.55027 10.9385 3.70924 10.8727 3.875 10.8727C4.04076 10.8727 4.19973 10.9385 4.31694 11.0557C4.43415 11.173 4.5 11.3319 4.5 11.4977V15.8727H17V11.4977C17 11.3319 17.0658 11.173 17.1831 11.0557C17.3003 10.9385 17.4592 10.8727 17.625 10.8727C17.7908 10.8727 17.9497 10.9385 18.0669 11.0557C18.1842 11.173 18.25 11.3319 18.25 11.4977ZM8.06719 6.31487L10.125 4.25628V11.4977C10.125 11.6634 10.1908 11.8224 10.3081 11.9396C10.4253 12.0568 10.5842 12.1227 10.75 12.1227C10.9158 12.1227 11.0747 12.0568 11.1919 11.9396C11.3092 11.8224 11.375 11.6634 11.375 11.4977V4.25628L13.4328 6.31487C13.5501 6.43215 13.7091 6.49803 13.875 6.49803C14.0409 6.49803 14.1999 6.43215 14.3172 6.31487C14.4345 6.1976 14.5003 6.03854 14.5003 5.87268C14.5003 5.70683 14.4345 5.54777 14.3172 5.4305L11.1922 2.3055C11.1341 2.24739 11.0652 2.20129 10.9893 2.16983C10.9135 2.13838 10.8321 2.12219 10.75 2.12219C10.6679 2.12219 10.5865 2.13838 10.5107 2.16983C10.4348 2.20129 10.3659 2.24739 10.3078 2.3055L7.18281 5.4305C7.06554 5.54777 6.99965 5.70683 6.99965 5.87268C6.99965 6.03854 7.06554 6.1976 7.18281 6.31487C7.30009 6.43215 7.45915 6.49803 7.625 6.49803C7.79085 6.49803 7.94991 6.43215 8.06719 6.31487Z" fill="currentColor"/>
</svg>
`, Nme = `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" viewBox="0 0 256 256"><path d="M96.26,37A8,8,0,0,1,102,27.29a104.11,104.11,0,0,1,52,0,8,8,0,0,1-2,15.75,8.15,8.15,0,0,1-2-.26,88,88,0,0,0-44,0A8,8,0,0,1,96.26,37ZM33.35,110a8,8,0,0,0,9.85-5.57,87.88,87.88,0,0,1,22-38.09A8,8,0,0,0,53.8,55.14a103.92,103.92,0,0,0-26,45A8,8,0,0,0,33.35,110ZM150,213.22a88,88,0,0,1-44,0,8,8,0,0,0-4,15.49,104.11,104.11,0,0,0,52,0,8,8,0,0,0-4-15.49Zm62.8-108.77a8,8,0,0,0,15.42-4.28,104,104,0,0,0-26-45,8,8,0,1,0-11.41,11.21A88.14,88.14,0,0,1,212.79,104.45Zm15.44,51.39a103.68,103.68,0,0,1-30.68,49.47A8,8,0,0,1,185.07,203a64,64,0,0,0-114.14,0,8,8,0,0,1-12.48,2.32,103.74,103.74,0,0,1-30.68-49.49,8,8,0,0,1,15.42-4.27,87.58,87.58,0,0,0,19,34.88,79.57,79.57,0,0,1,36.1-28.77,48,48,0,1,1,59.38,0,79.57,79.57,0,0,1,36.1,28.77,87.58,87.58,0,0,0,19-34.88,8,8,0,1,1,15.42,4.28ZM128,152a32,32,0,1,0-32-32A32,32,0,0,0,128,152Z"></path></svg>
`, zme = `<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_576_9404)">
<path d="M12.1088 12.3187C13.0886 11.7085 13.843 10.7957 14.2578 9.7186C14.6726 8.64146 14.7254 7.45852 14.408 6.34874C14.0907 5.23897 13.4205 4.26273 12.4989 3.56775C11.5774 2.87276 10.4545 2.49683 9.30025 2.49683C8.14599 2.49683 7.02313 2.87276 6.10155 3.56775C5.17997 4.26273 4.50982 5.23897 4.19247 6.34874C3.87513 7.45852 3.92786 8.64146 4.3427 9.7186C4.75753 10.7957 5.51189 11.7085 6.49165 12.3187C4.87837 12.8468 3.42681 13.8335 2.25962 15.2226C2.20494 15.2851 2.16326 15.358 2.13705 15.4368C2.11083 15.5156 2.10059 15.5989 2.10692 15.6817C2.11326 15.7645 2.13605 15.8453 2.17395 15.9192C2.21186 15.9931 2.26412 16.0588 2.32769 16.1122C2.39125 16.1657 2.46484 16.206 2.54415 16.2307C2.62347 16.2555 2.70691 16.2641 2.78961 16.2562C2.87231 16.2483 2.9526 16.224 3.02579 16.1847C3.09898 16.1454 3.1636 16.0919 3.21587 16.0273C4.78462 14.1554 6.94556 13.125 9.29634 13.125C11.6471 13.125 13.8081 14.1554 15.3799 16.0273C15.4866 16.1543 15.6394 16.2337 15.8047 16.2481C15.97 16.2624 16.1342 16.2106 16.2612 16.1039C16.3882 15.9971 16.4676 15.8444 16.482 15.6791C16.4963 15.5138 16.4445 15.3496 16.3377 15.2226C15.1698 13.8335 13.7182 12.8468 12.1088 12.3187ZM5.23384 7.81245C5.23384 7.00896 5.4721 6.22352 5.9185 5.55545C6.36489 4.88737 6.99937 4.36667 7.74169 4.05919C8.48401 3.75171 9.30085 3.67126 10.0889 3.82801C10.8769 3.98476 11.6008 4.37168 12.169 4.93983C12.7371 5.50798 13.124 6.23185 13.2808 7.0199C13.4375 7.80794 13.3571 8.62478 13.0496 9.3671C12.7421 10.1094 12.2214 10.7439 11.5533 11.1903C10.8853 11.6367 10.0998 11.875 9.29634 11.875C8.21928 11.8737 7.18669 11.4453 6.42509 10.6837C5.66349 9.9221 5.23508 8.88951 5.23384 7.81245ZM20.5659 11.1773L20.2018 10.9671C20.2445 10.741 20.2445 10.5089 20.2018 10.2828L20.5659 10.0726C20.637 10.0316 20.6993 9.97693 20.7493 9.91181C20.7993 9.84668 20.8359 9.77235 20.8572 9.69306C20.8784 9.61377 20.8839 9.53107 20.8732 9.44968C20.8625 9.36828 20.8358 9.2898 20.7948 9.2187C20.7537 9.1476 20.6991 9.08528 20.634 9.0353C20.5689 8.98532 20.4945 8.94865 20.4152 8.9274C20.3359 8.90614 20.2532 8.90071 20.1718 8.91142C20.0905 8.92212 20.012 8.94876 19.9409 8.98979L19.576 9.20073C19.4014 9.05093 19.2007 8.93466 18.9838 8.85776V8.43745C18.9838 8.27169 18.918 8.11272 18.8008 7.99551C18.6836 7.8783 18.5246 7.81245 18.3588 7.81245C18.1931 7.81245 18.0341 7.8783 17.9169 7.99551C17.7997 8.11272 17.7338 8.27169 17.7338 8.43745V8.85776C17.517 8.93466 17.3163 9.05093 17.1417 9.20073L16.7768 8.98979C16.7057 8.94876 16.6272 8.92212 16.5458 8.91142C16.4644 8.90071 16.3817 8.90614 16.3025 8.9274C16.2232 8.94865 16.1488 8.98532 16.0837 9.0353C16.0186 9.08528 15.9639 9.1476 15.9229 9.2187C15.8819 9.2898 15.8552 9.36828 15.8445 9.44968C15.8338 9.53107 15.8393 9.61377 15.8605 9.69306C15.8818 9.77235 15.9184 9.84668 15.9684 9.91181C16.0184 9.97693 16.0807 10.0316 16.1518 10.0726L16.5159 10.2828C16.4732 10.5089 16.4732 10.741 16.5159 10.9671L16.1518 11.1773C16.0807 11.2183 16.0184 11.273 15.9684 11.3381C15.9184 11.4032 15.8818 11.4775 15.8605 11.5568C15.8393 11.6361 15.8338 11.7188 15.8445 11.8002C15.8552 11.8816 15.8819 11.9601 15.9229 12.0312C15.9639 12.1023 16.0186 12.1646 16.0837 12.2146C16.1488 12.2646 16.2232 12.3012 16.3025 12.3225C16.3817 12.3438 16.4644 12.3492 16.5458 12.3385C16.6272 12.3278 16.7057 12.3011 16.7768 12.2601L17.1417 12.0492C17.3163 12.199 17.517 12.3152 17.7338 12.3921V12.8125C17.7338 12.9782 17.7997 13.1372 17.9169 13.2544C18.0341 13.3716 18.1931 13.4375 18.3588 13.4375C18.5246 13.4375 18.6836 13.3716 18.8008 13.2544C18.918 13.1372 18.9838 12.9782 18.9838 12.8125V12.3921C19.2007 12.3152 19.4014 12.199 19.576 12.0492L19.9409 12.2601C20.0358 12.3152 20.1436 12.344 20.2534 12.3437C20.391 12.3438 20.5248 12.2984 20.634 12.2146C20.7432 12.1309 20.8217 12.0134 20.8573 11.8804C20.8929 11.7475 20.8837 11.6065 20.831 11.4794C20.7783 11.3522 20.6851 11.2461 20.5659 11.1773ZM17.7338 10.625C17.7338 10.5013 17.7705 10.3805 17.8392 10.2777C17.9078 10.1749 18.0055 10.0948 18.1197 10.0475C18.2339 10.0002 18.3595 9.98784 18.4808 10.012C18.602 10.0361 18.7134 10.0956 18.8008 10.183C18.8882 10.2704 18.9477 10.3818 18.9718 10.503C18.9959 10.6243 18.9836 10.7499 18.9363 10.8641C18.889 10.9783 18.8089 11.0759 18.7061 11.1446C18.6033 11.2133 18.4825 11.25 18.3588 11.25C18.1931 11.25 18.0341 11.1841 17.9169 11.0669C17.7997 10.9497 17.7338 10.7907 17.7338 10.625Z" fill="currentColor"/>
</g>
<defs>
<clipPath id="clip0_576_9404">
<rect width="20" height="20" fill="white" transform="translate(0.858887)"/>
</clipPath>
</defs>
</svg>
`, jme = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><rect width="256" height="256" fill="none"/><line x1="200" y1="136" x2="248" y2="136" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><line x1="224" y1="112" x2="224" y2="160" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><circle cx="108" cy="100" r="60" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><path d="M24,200c20.55-24.45,49.56-40,84-40s63.45,15.55,84,40" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/></svg>', Wme = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><rect width="256" height="256" fill="none"/><circle cx="128" cy="96" r="64" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><path d="M32,216c19.37-33.47,54.55-56,96-56s76.63,22.53,96,56" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/></svg>', Ume = `<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M24 4.5C20.1433 4.5 16.3731 5.64366 13.1664 7.78634C9.95963 9.92903 7.46027 12.9745 5.98436 16.5377C4.50845 20.1008 4.12228 24.0216 4.8747 27.8043C5.62711 31.5869 7.4843 35.0615 10.2114 37.7886C12.9386 40.5157 16.4131 42.3729 20.1957 43.1253C23.9784 43.8777 27.8992 43.4916 31.4623 42.0156C35.0255 40.5397 38.071 38.0404 40.2137 34.8336C42.3564 31.6269 43.5 27.8567 43.5 24C43.4945 18.83 41.4383 13.8732 37.7826 10.2174C34.1268 6.56167 29.1701 4.50546 24 4.5ZM13.89 37.0312C14.9751 35.3342 16.47 33.9375 18.2369 32.9701C20.0037 32.0027 21.9857 31.4956 24 31.4956C26.0144 31.4956 27.9963 32.0027 29.7632 32.9701C31.53 33.9375 33.0249 35.3342 34.11 37.0312C31.2194 39.2794 27.6619 40.4999 24 40.4999C20.3381 40.4999 16.7806 39.2794 13.89 37.0312ZM18 22.5C18 21.3133 18.3519 20.1533 19.0112 19.1666C19.6705 18.1799 20.6076 17.4108 21.7039 16.9567C22.8003 16.5026 24.0067 16.3838 25.1706 16.6153C26.3344 16.8468 27.4035 17.4182 28.2426 18.2574C29.0818 19.0965 29.6532 20.1656 29.8847 21.3295C30.1162 22.4933 29.9974 23.6997 29.5433 24.7961C29.0892 25.8925 28.3201 26.8295 27.3334 27.4888C26.3467 28.1481 25.1867 28.5 24 28.5C22.4087 28.5 20.8826 27.8679 19.7574 26.7426C18.6321 25.6174 18 24.0913 18 22.5ZM36.33 34.9519C34.6571 32.5276 32.3047 30.6522 29.5688 29.5613C31.0384 28.4037 32.1108 26.817 32.6369 25.0217C33.1629 23.2264 33.1164 21.3118 32.5039 19.5441C31.8914 17.7765 30.7432 16.2437 29.2191 15.1588C27.6951 14.0739 25.8708 13.491 24 13.491C22.1292 13.491 20.305 14.0739 18.7809 15.1588C17.2568 16.2437 16.1086 17.7765 15.4961 19.5441C14.8836 21.3118 14.8371 23.2264 15.3631 25.0217C15.8892 26.817 16.9616 28.4037 18.4313 29.5613C15.6953 30.6522 13.3429 32.5276 11.67 34.9519C9.55607 32.5747 8.17439 29.6371 7.69134 26.4928C7.20829 23.3485 7.64447 20.1317 8.94735 17.2296C10.2502 14.3274 12.3643 11.8638 15.0349 10.1354C17.7055 8.40693 20.8189 7.48734 24 7.48734C27.1812 7.48734 30.2945 8.40693 32.9651 10.1354C35.6357 11.8638 37.7498 14.3274 39.0527 17.2296C40.3555 20.1317 40.7917 23.3485 40.3087 26.4928C39.8256 29.6371 38.4439 32.5747 36.33 34.9519Z" fill="currentColor"/>
</svg>
`, Kme = `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" viewBox="0 0 256 256"><path d="M244.8,150.4a8,8,0,0,1-11.2-1.6A51.6,51.6,0,0,0,192,128a8,8,0,0,1-7.37-4.89,8,8,0,0,1,0-6.22A8,8,0,0,1,192,112a24,24,0,1,0-23.24-30,8,8,0,1,1-15.5-4A40,40,0,1,1,219,117.51a67.94,67.94,0,0,1,27.43,21.68A8,8,0,0,1,244.8,150.4ZM190.92,212a8,8,0,1,1-13.84,8,57,57,0,0,0-98.16,0,8,8,0,1,1-13.84-8,72.06,72.06,0,0,1,33.74-29.92,48,48,0,1,1,58.36,0A72.06,72.06,0,0,1,190.92,212ZM128,176a32,32,0,1,0-32-32A32,32,0,0,0,128,176ZM72,120a8,8,0,0,0-8-8A24,24,0,1,1,87.24,82a8,8,0,1,0,15.5-4A40,40,0,1,0,37,117.51,67.94,67.94,0,0,0,9.6,139.19a8,8,0,1,0,12.8,9.61A51.6,51.6,0,0,1,64,128,8,8,0,0,0,72,120Z"></path></svg>
`, qme = `<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.16013 12.6598C9.99779 12.1022 10.6338 11.2897 10.974 10.3427C11.3142 9.39563 11.3406 8.36423 11.0493 7.40101C10.758 6.43779 10.1644 5.59388 9.35641 4.99408C8.54838 4.39428 7.56879 4.07043 6.56248 4.07043C5.55617 4.07043 4.57657 4.39428 3.76855 4.99408C2.96053 5.59388 2.36698 6.43779 2.07567 7.40101C1.78437 8.36423 1.81078 9.39563 2.15099 10.3427C2.49121 11.2897 3.12716 12.1022 3.96482 12.6598C2.44958 13.2183 1.15553 14.2517 0.275759 15.6059C0.229521 15.6747 0.197405 15.7519 0.181276 15.8331C0.165147 15.9144 0.165327 15.998 0.181807 16.0792C0.198286 16.1603 0.230736 16.2374 0.27727 16.306C0.323804 16.3745 0.383494 16.4331 0.45287 16.4783C0.522246 16.5236 0.599925 16.5546 0.68139 16.5695C0.762856 16.5845 0.846484 16.5831 0.927412 16.5655C1.00834 16.5478 1.08496 16.5143 1.1528 16.4668C1.22065 16.4193 1.27838 16.3588 1.32263 16.2887C1.89013 15.4159 2.66666 14.6987 3.58173 14.2022C4.49679 13.7056 5.52139 13.4456 6.56248 13.4456C7.60357 13.4456 8.62817 13.7056 9.54323 14.2022C10.4583 14.6987 11.2348 15.4159 11.8023 16.2887C11.894 16.425 12.0356 16.5197 12.1965 16.5524C12.3575 16.585 12.5248 16.553 12.6623 16.4633C12.7999 16.3736 12.8966 16.2334 12.9315 16.0729C12.9665 15.9125 12.9369 15.7447 12.8492 15.6059C11.9694 14.2517 10.6754 13.2183 9.16013 12.6598ZM3.12498 8.75984C3.12498 8.07996 3.32658 7.41536 3.7043 6.85006C4.08202 6.28477 4.61888 5.84418 5.247 5.584C5.87512 5.32382 6.56629 5.25575 7.2331 5.38839C7.89991 5.52102 8.51241 5.84841 8.99316 6.32916C9.4739 6.8099 9.80129 7.4224 9.93393 8.08921C10.0666 8.75602 9.99849 9.44719 9.73831 10.0753C9.47814 10.7034 9.03754 11.2403 8.47225 11.618C7.90696 11.9957 7.24235 12.1973 6.56248 12.1973C5.65111 12.1963 4.77737 11.8338 4.13294 11.1894C3.48851 10.5449 3.12601 9.6712 3.12498 8.75984ZM19.5422 16.4708C19.4033 16.5613 19.2342 16.593 19.0721 16.5588C18.9099 16.5247 18.7679 16.4276 18.6773 16.2887C18.1105 15.4154 17.3341 14.6978 16.4188 14.2015C15.5036 13.7052 14.4786 13.4459 13.4375 13.4473C13.2717 13.4473 13.1127 13.3815 12.9955 13.2643C12.8783 13.1471 12.8125 12.9881 12.8125 12.8223C12.8125 12.6566 12.8783 12.4976 12.9955 12.3804C13.1127 12.2632 13.2717 12.1973 13.4375 12.1973C13.9437 12.1969 14.4436 12.0846 14.9014 11.8685C15.3592 11.6525 15.7636 11.338 16.0858 10.9475C16.4079 10.557 16.6399 10.1002 16.765 9.60966C16.8902 9.11915 16.9055 8.60705 16.8097 8.10995C16.714 7.61285 16.5097 7.14303 16.2114 6.73405C15.9131 6.32507 15.5281 5.98703 15.084 5.74408C14.6399 5.50113 14.1476 5.35927 13.6423 5.32864C13.137 5.298 12.6311 5.37935 12.1609 5.56687C12.0842 5.60001 12.0017 5.61745 11.9182 5.61816C11.8347 5.61886 11.7519 5.60282 11.6746 5.57098C11.5974 5.53914 11.5274 5.49214 11.4686 5.43277C11.4099 5.37339 11.3636 5.30285 11.3326 5.2253C11.3016 5.14775 11.2864 5.06477 11.288 4.98126C11.2896 4.89775 11.3079 4.81541 11.3419 4.7391C11.3758 4.66279 11.4248 4.59405 11.4857 4.53697C11.5467 4.47988 11.6185 4.43559 11.6969 4.40671C12.773 3.97753 13.9699 3.96209 15.0568 4.36336C16.1437 4.76463 17.0434 5.55418 17.5825 6.57969C18.1215 7.60521 18.2617 8.79403 17.976 9.9168C17.6903 11.0396 16.9988 12.0168 16.0351 12.6598C17.5504 13.2183 18.8444 14.2517 19.7242 15.6059C19.8147 15.7448 19.8464 15.9139 19.8123 16.076C19.7781 16.2382 19.681 16.3802 19.5422 16.4708Z" fill="currentColor"/>
</svg>
`, Yme = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm-8-80V80a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0Zm20,36a12,12,0,1,1-12-12A12,12,0,0,1,140,172Z"></path></svg>', Qme = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.9422 7.94219L10.8836 10L12.9422 12.0578C13.0003 12.1159 13.0463 12.1848 13.0777 12.2607C13.1092 12.3366 13.1254 12.4179 13.1254 12.5C13.1254 12.5821 13.1092 12.6634 13.0777 12.7393C13.0463 12.8152 13.0003 12.8841 12.9422 12.9422C12.8841 13.0003 12.8152 13.0463 12.7393 13.0777C12.6634 13.1092 12.5821 13.1253 12.5 13.1253C12.4179 13.1253 12.3366 13.1092 12.2607 13.0777C12.1848 13.0463 12.1159 13.0003 12.0578 12.9422L10 10.8836L7.94219 12.9422C7.88412 13.0003 7.81518 13.0463 7.73931 13.0777C7.66344 13.1092 7.58213 13.1253 7.5 13.1253C7.41788 13.1253 7.33656 13.1092 7.26069 13.0777C7.18482 13.0463 7.11588 13.0003 7.05782 12.9422C6.99975 12.8841 6.95368 12.8152 6.92226 12.7393C6.89083 12.6634 6.87466 12.5821 6.87466 12.5C6.87466 12.4179 6.89083 12.3366 6.92226 12.2607C6.95368 12.1848 6.99975 12.1159 7.05782 12.0578L9.11641 10L7.05782 7.94219C6.94054 7.82491 6.87466 7.66585 6.87466 7.5C6.87466 7.33415 6.94054 7.17509 7.05782 7.05781C7.17509 6.94054 7.33415 6.87465 7.5 6.87465C7.66586 6.87465 7.82492 6.94054 7.94219 7.05781L10 9.11641L12.0578 7.05781C12.1159 6.99974 12.1848 6.95368 12.2607 6.92225C12.3366 6.89083 12.4179 6.87465 12.5 6.87465C12.5821 6.87465 12.6634 6.89083 12.7393 6.92225C12.8152 6.95368 12.8841 6.99974 12.9422 7.05781C13.0003 7.11588 13.0463 7.18482 13.0777 7.26069C13.1092 7.33656 13.1254 7.41788 13.1254 7.5C13.1254 7.58212 13.1092 7.66344 13.0777 7.73931C13.0463 7.81518 13.0003 7.88412 12.9422 7.94219ZM18.125 10C18.125 11.607 17.6485 13.1779 16.7557 14.514C15.8629 15.8502 14.594 16.8916 13.1093 17.5065C11.6247 18.1215 9.99099 18.2824 8.4149 17.9689C6.8388 17.6554 5.39106 16.8815 4.25476 15.7452C3.11846 14.6089 2.34463 13.1612 2.03112 11.5851C1.71762 10.009 1.87852 8.37535 2.49348 6.8907C3.10844 5.40605 4.14985 4.1371 5.486 3.24431C6.82214 2.35152 8.39303 1.875 10 1.875C12.1542 1.87727 14.2195 2.73403 15.7427 4.25727C17.266 5.78051 18.1227 7.84581 18.125 10ZM16.875 10C16.875 8.64025 16.4718 7.31104 15.7164 6.18045C14.9609 5.04987 13.8872 4.16868 12.631 3.64833C11.3747 3.12798 9.99238 2.99183 8.65876 3.2571C7.32514 3.52237 6.10013 4.17716 5.13864 5.13864C4.17716 6.10013 3.52238 7.32513 3.2571 8.65875C2.99183 9.99237 3.12798 11.3747 3.64833 12.6309C4.16868 13.8872 5.04987 14.9609 6.18046 15.7164C7.31105 16.4718 8.64026 16.875 10 16.875C11.8227 16.8729 13.5702 16.1479 14.8591 14.8591C16.1479 13.5702 16.8729 11.8227 16.875 10Z" fill="currentColor"/>
</svg>
`, Jme = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><rect width="256" height="256" fill="none"/><line x1="200" y1="56" x2="56" y2="200" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><line x1="200" y1="200" x2="56" y2="56" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/></svg>', Xme = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M9.2 1.997a1.698 1.698 0 0 0-2.4 0L1.996 6.8a1.698 1.698 0 0 0 0 2.402L6.8 14.003a1.698 1.698 0 0 0 2.402 0L14.003 9.2a1.698 1.698 0 0 0 0-2.402L9.2 1.997ZM7.25 7.25a.75.75 0 1 0 1.5 0v-2.5a.75.75 0 1 0-1.5 0v2.5Zm0 4a.75.75 0 0 0 1.5 0v-.5a.75.75 0 0 0-1.5 0v.5Z" clip-rule="evenodd"/>
</svg>
`, eCe = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M8 10a.785.785 0 0 1-.6-.267L5.15 7.067a.606.606 0 0 1-.07-.698A.765.765 0 0 1 5.75 6h4.5c.284 0 .544.143.67.369.128.225.1.496-.07.698L8.6 9.733A.785.785 0 0 1 8 10Z" clip-rule="evenodd"/>
</svg>
`, tCe = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M8 11a1 1 0 0 1-.8-.4l-3-4A1 1 0 0 1 5 5h6a1 1 0 0 1 .8 1.6l-3 4a1 1 0 0 1-.8.4Z" clip-rule="evenodd"/>
</svg>
`, oCe = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M6 8c0 .236.099.458.267.6l2.666 2.25c.202.17.473.198.698.07a.764.764 0 0 0 .369-.67v-4.5a.765.765 0 0 0-.369-.67.606.606 0 0 0-.698.07L6.267 7.4A.785.785 0 0 0 6 8Z" clip-rule="evenodd"/>
</svg>
`, nCe = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M5 8a1 1 0 0 0 .4.8l4 3A1 1 0 0 0 11 11V5a1 1 0 0 0-1.6-.8l-4 3A1 1 0 0 0 5 8Z" clip-rule="evenodd"/>
</svg>
`, sCe = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M10 8a.785.785 0 0 1-.267.6l-2.666 2.25a.606.606 0 0 1-.698.07.764.764 0 0 1-.369-.67v-4.5c0-.284.143-.544.369-.67a.606.606 0 0 1 .698.07L9.733 7.4A.785.785 0 0 1 10 8Z" clip-rule="evenodd"/>
</svg>
`, iCe = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M11 8a1 1 0 0 1-.4.8l-4 3A1 1 0 0 1 5 11V5a1 1 0 0 1 1.6-.8l4 3a1 1 0 0 1 .4.8Z" clip-rule="evenodd"/>
</svg>
`, rCe = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M8 6c.236 0 .458.099.6.267l2.25 2.666c.17.202.198.473.07.698a.764.764 0 0 1-.67.369h-4.5a.765.765 0 0 1-.67-.369.606.606 0 0 1 .07-.698L7.4 6.267A.785.785 0 0 1 8 6Z" clip-rule="evenodd"/>
</svg>
`, lCe = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M8 5a1 1 0 0 1 .8.4l3 4A1 1 0 0 1 11 11H5a1 1 0 0 1-.8-1.6l3-4A1 1 0 0 1 8 5Z" clip-rule="evenodd"/>
</svg>
`, aCe = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M7 10H3.626c-.482 0-.783-.5-.54-.9L7.84 2.299C8.161 1.769 9 1.989 9 2.6V6h3.374c.482 0 .783.5.54.9L8.16 13.701c-.321.53-1.16.31-1.16-.302V10Z" clip-rule="evenodd"/>
</svg>
`, cCe = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M12.721 4.167a.75.75 0 0 1 .113 1.054l-5.25 6.5a.75.75 0 0 1-1.134.04L3.2 8.26a.75.75 0 1 1 1.1-1.02l2.66 2.865 4.706-5.826a.75.75 0 0 1 1.055-.112Z" clip-rule="evenodd"/>
</svg>
`, dCe = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M4.24 5.95a.75.75 0 0 1 1.06.04L8 8.898l2.7-2.908a.75.75 0 1 1 1.1 1.02l-3.25 3.5a.75.75 0 0 1-1.1 0L4.2 7.01a.75.75 0 0 1 .04-1.06Z" clip-rule="evenodd"/>
</svg>
`, uCe = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M10.3 4.49a.75.75 0 0 1-.04 1.06l-2.908 2.7 2.908 2.7a.75.75 0 1 1-1.02 1.1L5.74 8.8a.75.75 0 0 1 0-1.1l3.5-3.25a.75.75 0 0 1 1.06.04Z" clip-rule="evenodd"/>
</svg>
`, hCe = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M5.7 3.99a.75.75 0 0 1 1.06-.04l3.5 3.25a.75.75 0 0 1 0 1.1l-3.5 3.25a.75.75 0 1 1-1.02-1.1l2.908-2.7-2.908-2.7a.75.75 0 0 1-.04-1.06Z" clip-rule="evenodd"/>
</svg>
`, gCe = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M8 5.25a.75.75 0 0 1 .55.24l3.25 3.5a.75.75 0 1 1-1.1 1.02L8 7.102 5.3 10.01a.75.75 0 1 1-1.1-1.02l3.25-3.5A.75.75 0 0 1 8 5.25Z" clip-rule="evenodd"/>
</svg>
`, pCe = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M4.22 4.22a.75.75 0 0 1 1.06 0L8 6.94l2.72-2.72a.75.75 0 1 1 1.06 1.06L9.06 8l2.72 2.72a.75.75 0 1 1-1.06 1.06L8 9.06l-2.72 2.72a.75.75 0 0 1-1.06-1.06L6.94 8 4.22 5.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd"/>
</svg>
`, fCe = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
  <circle cx="8" cy="8" r="4"/>
</svg>
`, vCe = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M8 2a6 6 0 1 1 0 12A6 6 0 0 1 8 2Zm0 6a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0v-2.5A.75.75 0 0 1 8 8Zm0-4a.75.75 0 0 1 .75.75v.5a.75.75 0 0 1-1.5 0v-.5A.75.75 0 0 1 8 4Z" clip-rule="evenodd"/>
</svg>
`, mCe = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M3 8a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5A.75.75 0 0 1 3 8Z" clip-rule="evenodd"/>
</svg>
`, CCe = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M8 3a.75.75 0 0 1 .75.75v3.5h3.5a.75.75 0 0 1 0 1.5h-3.5v3.5a.75.75 0 0 1-1.5 0v-3.5h-3.5a.75.75 0 0 1 0-1.5h3.5v-3.5A.75.75 0 0 1 8 3Z" clip-rule="evenodd"/>
</svg>
`, wCe = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M4 0C1.79086 0 0 1.79086 0 4V16C0 18.2091 1.79086 20 4 20H16C18.2091 20 20 18.2091 20 16V4C20 1.79086 18.2091 0 16 0H4ZM4.75 5C4.33579 5 4 5.33579 4 5.75C4 6.16421 4.33579 6.5 4.75 6.5H10.25C10.6642 6.5 11 6.16421 11 5.75C11 5.33579 10.6642 5 10.25 5H4.75ZM4.75 9.5C4.33579 9.5 4 9.83579 4 10.25C4 10.6642 4.33579 11 4.75 11H15.25C15.6642 11 16 10.6642 16 10.25C16 9.83579 15.6642 9.5 15.25 9.5H4.75ZM4.75 13.5C4.33579 13.5 4 13.8358 4 14.25C4 14.6642 4.33579 15 4.75 15H15.25C15.6642 15 16 14.6642 16 14.25C16 13.8358 15.6642 13.5 15.25 13.5H4.75Z" fill="#3062D4"/>
</svg>
`, bCe = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M4 0C1.79086 0 0 1.79086 0 4V16C0 18.2091 1.79086 20 4 20H16C18.2091 20 20 18.2091 20 16V4C20 1.79086 18.2091 0 16 0H4ZM7.34581 5.29445C7.09419 4.96542 6.62349 4.90266 6.29445 5.15427C5.96542 5.40588 5.90266 5.87659 6.15427 6.20563L9.05588 10L6.15427 13.7945C5.90266 14.1235 5.96542 14.5942 6.29445 14.8458C6.62349 15.0974 7.09419 15.0347 7.34581 14.7056L10 11.2347L12.6543 14.7056C12.9059 15.0347 13.3766 15.0974 13.7056 14.8458C14.0347 14.5942 14.0974 14.1235 13.8458 13.7945L10.9442 10L13.8458 6.20563C14.0974 5.87659 14.0347 5.40588 13.7056 5.15427C13.3766 4.90266 12.9059 4.96542 12.6543 5.29445L10 8.76537L7.34581 5.29445Z" fill="#1D7C4D"/>
</svg>
`, yCe = `<svg width="12" height="18" viewBox="0 0 12 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M0 3.5C0 1.567 1.50432 0 3.36 0H8.64C10.4957 0 12 1.567 12 3.5C12 4.61548 11.499 5.60909 10.7187 6.25C11.499 6.89092 12 7.88452 12 9C12 10.933 10.4957 12.5 8.64 12.5C7.92612 12.5 7.26424 12.2681 6.72 11.8727V14.5C6.72 16.433 5.21568 18 3.36 18C1.50432 18 0 16.433 0 14.5C0 13.3845 0.500962 12.3909 1.28132 11.75C0.500962 11.1091 0 10.1155 0 9C0 7.88452 0.500961 6.89092 1.28131 6.25C0.500961 5.60908 0 4.61548 0 3.5ZM3.36 7C2.29961 7 1.44 7.89543 1.44 9C1.44 10.1046 2.29961 11 3.36 11H5.28V7H3.36ZM5.28 5.5H3.36C2.29961 5.5 1.44 4.60457 1.44 3.5C1.44 2.39543 2.29961 1.5 3.36 1.5H5.28V5.5ZM8.64 5.5C9.70039 5.5 10.56 4.60457 10.56 3.5C10.56 2.39543 9.70039 1.5 8.64 1.5H6.72V5.5H8.64ZM8.64 7C7.57961 7 6.72 7.89543 6.72 9C6.72 10.1046 7.57961 11 8.64 11C9.70039 11 10.56 10.1046 10.56 9C10.56 7.89543 9.70039 7 8.64 7ZM5.28 12.5H3.36C2.29961 12.5 1.44 13.3954 1.44 14.5C1.44 15.6046 2.29961 16.5 3.36 16.5C4.42039 16.5 5.28 15.6046 5.28 14.5V12.5Z" fill="#8040BF"/>
</svg>
`, _Ce = `<svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M2.75 1.5C2.05964 1.5 1.5 2.05964 1.5 2.75V17.25C1.5 17.9404 2.05964 18.5 2.75 18.5H13.25C13.9404 18.5 14.5 17.9404 14.5 17.25V6.06066L9.93934 1.5H2.75ZM0 2.75C0 1.23122 1.23122 0 2.75 0H10.25C10.4489 0 10.6397 0.0790176 10.7803 0.21967L15.7803 5.21967C15.921 5.36032 16 5.55109 16 5.75V17.25C16 18.7688 14.7688 20 13.25 20H2.75C1.23122 20 0 18.7688 0 17.25V2.75Z" fill="#555F6D"/>
</svg>
`, SCe = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.5 7.5V9.80769H4.5C4.99404 9.80769 5.5 9.35184 5.5 8.65385C5.5 7.95585 4.99404 7.5 4.5 7.5H3.5Z" fill="#C53434"/>
<path d="M9.25 7.5V12.5H9.75C10.3485 12.5 10.8284 12.2132 11.1821 11.7435C11.5461 11.2599 11.75 10.6084 11.75 10C11.75 9.39157 11.5461 8.74007 11.1821 8.25654C10.8284 7.78679 10.3485 7.5 9.75 7.5H9.25Z" fill="#C53434"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M4 0C1.79086 0 0 1.79086 0 4V16C0 18.2091 1.79086 20 4 20H16C18.2091 20 20 18.2091 20 16V4C20 1.79086 18.2091 0 16 0H4ZM2 6.75C2 6.33579 2.33579 6 2.75 6H4.5C5.93895 6 7 7.24891 7 8.65385C7 10.0588 5.93895 11.3077 4.5 11.3077H3.5V13.25C3.5 13.6642 3.16421 14 2.75 14C2.33579 14 2 13.6642 2 13.25V6.75ZM7.75 6.75C7.75 6.33579 8.08579 6 8.5 6H9.75C10.9015 6 11.7966 6.57882 12.3804 7.35437C12.9539 8.11615 13.25 9.08965 13.25 10C13.25 10.9104 12.9539 11.8839 12.3804 12.6456C11.7966 13.4212 10.9015 14 9.75 14H8.5C8.08579 14 7.75 13.6642 7.75 13.25V6.75ZM14.75 6C14.3358 6 14 6.33579 14 6.75V13.25C14 13.6642 14.3358 14 14.75 14C15.1642 14 15.5 13.6642 15.5 13.25V10.4615H17.25C17.6642 10.4615 18 10.1258 18 9.71154C18 9.29733 17.6642 8.96154 17.25 8.96154H15.5V7.5H17.25C17.6642 7.5 18 7.16421 18 6.75C18 6.33579 17.6642 6 17.25 6H14.75Z" fill="#C53434"/>
</svg>
`, xCe = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7 10.5H5.5V7.5H7C7.82843 7.5 8.5 8.17157 8.5 9C8.5 9.82843 7.82843 10.5 7 10.5Z" fill="#3062D4"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M4 0C1.79086 0 0 1.79086 0 4V16C0 18.2091 1.79086 20 4 20H16C18.2091 20 20 18.2091 20 16V4C20 1.79086 18.2091 0 16 0H4ZM11.5 8.375C11.5 7.89175 11.8918 7.5 12.375 7.5H13.25C13.973 7.5 14.286 7.70214 14.408 7.81056C14.4754 7.87048 14.5094 7.92374 14.5241 7.95096C14.5279 7.95787 14.5304 7.96317 14.5319 7.96652C14.6465 8.34765 15.0417 8.57515 15.4319 8.47761C15.8337 8.37714 16.0781 7.96994 15.9776 7.5681L15.25 7.75C15.9776 7.5681 15.9773 7.56692 15.9773 7.56692L15.977 7.56571L15.9764 7.56321L15.975 7.55791L15.9718 7.5461C15.9694 7.53769 15.9667 7.52823 15.9635 7.51779C15.957 7.4969 15.9487 7.472 15.9381 7.44369C15.9169 7.38713 15.8863 7.31639 15.8431 7.23654C15.7562 7.07626 15.6184 6.87952 15.4045 6.68944C14.964 6.29786 14.277 6 13.25 6H12.375C11.0633 6 10 7.06332 10 8.375C10 9.18487 10.5505 9.78954 11.0816 10.1465C11.6314 10.5161 12.3378 10.75 13 10.75C13.3378 10.75 13.7564 10.8798 14.0816 11.0984C14.4255 11.3296 14.5 11.5374 14.5 11.625C14.5 12.1082 14.1082 12.5 13.625 12.5H12.75C12.027 12.5 11.714 12.2979 11.592 12.1894C11.5246 12.1295 11.4906 12.0763 11.4759 12.049C11.4735 12.0446 11.4716 12.0409 11.4702 12.0379L11.4681 12.0335C11.3535 11.6523 10.9583 11.4249 10.5681 11.5224C10.1663 11.6229 9.92193 12.0301 10.0224 12.4319L10.75 12.25C10.0224 12.4319 10.0227 12.4331 10.0227 12.4331L10.023 12.4343L10.0236 12.4368L10.025 12.4421L10.0282 12.4539C10.0306 12.4623 10.0333 12.4718 10.0365 12.4822C10.043 12.5031 10.0513 12.528 10.0619 12.5563C10.0831 12.6129 10.1137 12.6836 10.1569 12.7635C10.2438 12.9237 10.3816 13.1205 10.5955 13.3106C11.036 13.7021 11.723 14 12.75 14H13.625C14.9367 14 16 12.9367 16 11.625C16 10.8151 15.4495 10.2105 14.9184 9.85349C14.3686 9.48394 13.6622 9.24999 13 9.24999C12.6622 9.24999 12.2436 9.12016 11.9184 8.90158C11.5745 8.67042 11.5 8.4626 11.5 8.375ZM4.75 6C4.33579 6 4 6.33579 4 6.75V13.25C4 13.6642 4.33579 14 4.75 14C5.16421 14 5.5 13.6642 5.5 13.25V12H7C8.65685 12 10 10.6569 10 9C10 7.34315 8.65685 6 7 6H4.75Z" fill="#3062D4"/>
</svg>
`, MCe = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M4 0C1.79086 0 0 1.79086 0 4V16C0 18.2091 1.79086 20 4 20H16C18.2091 20 20 18.2091 20 16V4C20 1.79086 18.2091 0 16 0H4ZM4.90856 4.24299C4.68948 4.44666 4.53036 4.72704 4.21212 5.28782L3.46124 6.61095C3.03703 7.35844 2.82493 7.73219 2.77024 8.1223C2.72197 8.46655 2.7604 8.81817 2.88164 9.14172C3.01903 9.50836 3.30615 9.82112 3.8804 10.4467L7.85019 14.771C8.60049 15.5883 8.97564 15.9969 9.41076 16.1494C9.79335 16.2835 10.2066 16.2835 10.5892 16.1494C11.0244 15.9969 11.3995 15.5883 12.1498 14.771L16.1196 10.4467C16.6938 9.82112 16.981 9.50836 17.1184 9.14172C17.2396 8.81817 17.278 8.46655 17.2298 8.1223C17.1751 7.73219 16.963 7.35844 16.5388 6.61095L15.7879 5.28782C15.4696 4.72705 15.3105 4.44666 15.0914 4.24299C14.8976 4.06276 14.6706 3.92686 14.4246 3.84383C14.1467 3.75 13.8375 3.75 13.2189 3.75H6.78109C6.16255 3.75 5.85327 3.75 5.57537 3.84383C5.32945 3.92686 5.10242 4.06276 4.90856 4.24299Z" fill="#F59638"/>
</svg>
`, ACe = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M4 0C1.79086 0 0 1.79086 0 4V16C0 18.2091 1.79086 20 4 20H16C18.2091 20 20 18.2091 20 16V4C20 1.79086 18.2091 0 16 0H4ZM8.5 2.75C8.5 2.33579 8.16421 2 7.75 2C7.33579 2 7 2.33579 7 2.75V7H2.75C2.33579 7 2 7.33579 2 7.75C2 8.16421 2.33579 8.5 2.75 8.5H7V17.25C7 17.6642 7.33579 18 7.75 18C8.16421 18 8.5 17.6642 8.5 17.25V8.5H17.25C17.6642 8.5 18 8.16421 18 7.75C18 7.33579 17.6642 7 17.25 7H8.5V2.75Z" fill="#1D7C4D"/>
</svg>
`, LCe = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M4 0C1.79086 0 0 1.79086 0 4V16C0 18.2091 1.79086 20 4 20H16C18.2091 20 20 18.2091 20 16V4C20 1.79086 18.2091 0 16 0H4ZM6.46679 6.52939C6.34497 6.13349 5.92529 5.91131 5.52939 6.03312C5.13349 6.15494 4.91131 6.57462 5.03312 6.97052L7.03312 13.4705C7.12131 13.7571 7.37174 13.9637 7.6699 13.9957C7.96806 14.0277 8.25662 13.879 8.40364 13.6177L9.99996 10.7798L11.5963 13.6177C11.7433 13.879 12.0319 14.0277 12.33 13.9957C12.6282 13.9637 12.8786 13.7571 12.9668 13.4705L14.9668 6.97052C15.0886 6.57462 14.8664 6.15494 14.4705 6.03312C14.0746 5.91131 13.6549 6.13349 13.5331 6.52939L12.047 11.3593L10.6536 8.88226C10.5208 8.6461 10.2709 8.49996 9.99996 8.49996C9.729 8.49996 9.47911 8.6461 9.34627 8.88226L7.95292 11.3593L6.46679 6.52939Z" fill="#3062D4"/>
</svg>
`, ECe = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 0C1.79086 0 0 1.79086 0 4V16C0 18.2091 1.79086 20 4 20H16C18.2091 20 20 18.2091 20 16V4C20 1.79086 18.2091 0 16 0H5.5L5.5 2H8.25C8.66421 2 9 2.33579 9 2.75V6.75C9 7.16421 8.66421 7.5 8.25 7.5H5.5V10H8.25C8.66421 10 9 10.3358 9 10.75V15.25C9 15.6642 8.66421 16 8.25 16H4.75C4.33579 16 4 15.6642 4 15.25V6.75C4 6.33579 4.33579 6 4.75 6H7.5V3.5H4.75C4.55109 3.5 4.36032 3.42098 4.21967 3.28033C4.07902 3.13968 4 2.94891 4 2.75V0Z" fill="#555F6D"/>
<path d="M5.5 14.5V11.5H7.5V14.5H5.5Z" fill="#555F6D"/>
</svg>
`, PCe = `<svg width="32" height="40" viewBox="0 0 32 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.75 6.75C0.75 3.43629 3.43629 0.75 6.75 0.75H20.9216C21.452 0.75 21.9607 0.960714 22.3358 1.33579L30.6642 9.66421C31.0393 10.0393 31.25 10.548 31.25 11.0784V33.25C31.25 36.5637 28.5637 39.25 25.25 39.25H6.75C3.43629 39.25 0.75 36.5637 0.75 33.25V6.75Z" fill="white"/>
<path d="M9.75 20.75V25.25H12C13.2426 25.25 14.25 24.2426 14.25 23C14.25 21.7574 13.2426 20.75 12 20.75H9.75Z" fill="white"/>
<path d="M22.3358 1.33579L21.8055 1.86612V1.86612L22.3358 1.33579ZM30.6642 9.66421L30.1339 10.1945L30.6642 9.66421ZM9 27.25C9 27.6642 9.33579 28 9.75 28C10.1642 28 10.5 27.6642 10.5 27.25H9ZM9.75 20.75V20C9.33579 20 9 20.3358 9 20.75H9.75ZM21.5224 21.9319C21.6229 22.3337 22.0301 22.5781 22.4319 22.4776C22.8337 22.3771 23.0781 21.9699 22.9776 21.5681L21.5224 21.9319ZM18.4776 26.0681C18.3771 25.6663 17.9699 25.4219 17.5681 25.5224C17.1663 25.6229 16.9219 26.0301 17.0224 26.4319L18.4776 26.0681ZM1.5 6.75C1.5 3.85051 3.85051 1.5 6.75 1.5V0C3.02208 0 0 3.02208 0 6.75H1.5ZM6.75 1.5H20.9216V0H6.75V1.5ZM20.9216 1.5C21.2531 1.5 21.571 1.6317 21.8055 1.86612L22.8661 0.805457C22.3504 0.289731 21.6509 0 20.9216 0V1.5ZM21.8055 1.86612L30.1339 10.1945L31.1945 9.13388L22.8661 0.805456L21.8055 1.86612ZM30.1339 10.1945C30.3683 10.429 30.5 10.7469 30.5 11.0784H32C32 10.3491 31.7103 9.64961 31.1945 9.13388L30.1339 10.1945ZM30.5 11.0784V33.25H32V11.0784H30.5ZM30.5 33.25C30.5 36.1495 28.1495 38.5 25.25 38.5V40C28.9779 40 32 36.9779 32 33.25H30.5ZM25.25 38.5H6.75V40H25.25V38.5ZM6.75 38.5C3.85051 38.5 1.5 36.1495 1.5 33.25H0C0 36.9779 3.02208 40 6.75 40V38.5ZM1.5 33.25V6.75H0V33.25H1.5ZM10.5 27.25V25.25H9V27.25H10.5ZM10.5 25.25V20.75H9V25.25H10.5ZM9.75 21.5H12V20H9.75V21.5ZM12 24.5H9.75V26H12V24.5ZM13.5 23C13.5 23.8284 12.8284 24.5 12 24.5V26C13.6569 26 15 24.6569 15 23H13.5ZM12 21.5C12.8284 21.5 13.5 22.1716 13.5 23H15C15 21.3431 13.6569 20 12 20V21.5ZM20 23.25C19.6622 23.25 19.2436 23.1202 18.9184 22.9016C18.5745 22.6704 18.5 22.4626 18.5 22.375H17C17 23.1849 17.5505 23.7895 18.0816 24.1465C18.6314 24.5161 19.3378 24.75 20 24.75V23.25ZM18.5 22.375C18.5 21.8918 18.8918 21.5 19.375 21.5V20C18.0633 20 17 21.0633 17 22.375H18.5ZM21.5 25.625C21.5 26.1082 21.1082 26.5 20.625 26.5V28C21.9367 28 23 26.9367 23 25.625H21.5ZM20 24.75C20.3378 24.75 20.7564 24.8798 21.0816 25.0984C21.4255 25.3296 21.5 25.5374 21.5 25.625H23C23 24.8151 22.4495 24.2105 21.9184 23.8535C21.3686 23.4839 20.6622 23.25 20 23.25V24.75ZM19.375 21.5H20.25V20H19.375V21.5ZM20.25 21.5C20.973 21.5 21.286 21.7021 21.408 21.8106C21.4754 21.8705 21.5094 21.9237 21.5241 21.951C21.5317 21.9649 21.5343 21.9722 21.5336 21.9704C21.5332 21.9694 21.532 21.966 21.5301 21.9598C21.5291 21.9566 21.528 21.9528 21.5267 21.9482C21.526 21.9459 21.5254 21.9433 21.5246 21.9406C21.5243 21.9393 21.5239 21.9379 21.5235 21.9364C21.5234 21.9357 21.5232 21.935 21.523 21.9342C21.5229 21.9338 21.5227 21.9333 21.5227 21.9331C21.5225 21.9325 21.5224 21.9319 22.25 21.75C22.9776 21.5681 22.9775 21.5675 22.9773 21.5669C22.9773 21.5667 22.9771 21.5661 22.977 21.5657C22.9768 21.5649 22.9766 21.5641 22.9764 21.5632C22.9759 21.5615 22.9755 21.5597 22.975 21.5579C22.974 21.5542 22.973 21.5503 22.9718 21.5461C22.9694 21.5377 22.9667 21.5282 22.9635 21.5178C22.957 21.4969 22.9487 21.472 22.9381 21.4437C22.9169 21.3871 22.8863 21.3164 22.8431 21.2365C22.7562 21.0763 22.6184 20.8795 22.4045 20.6894C21.964 20.2979 21.277 20 20.25 20V21.5ZM20.625 26.5H19.75V28H20.625V26.5ZM19.75 26.5C19.027 26.5 18.714 26.2979 18.592 26.1894C18.5246 26.1295 18.4906 26.0763 18.4759 26.049C18.4683 26.0351 18.4657 26.0278 18.4664 26.0296C18.4668 26.0306 18.468 26.034 18.4699 26.0402C18.4709 26.0434 18.472 26.0472 18.4733 26.0518C18.474 26.0541 18.4746 26.0567 18.4754 26.0594C18.4757 26.0607 18.4761 26.0621 18.4765 26.0636C18.4766 26.0643 18.4768 26.065 18.477 26.0658C18.4771 26.0662 18.4773 26.0667 18.4773 26.0669C18.4775 26.0675 18.4776 26.0681 17.75 26.25C17.0224 26.4319 17.0225 26.4325 17.0227 26.4331C17.0227 26.4333 17.0229 26.4339 17.023 26.4343C17.0232 26.4351 17.0234 26.4359 17.0236 26.4368C17.0241 26.4385 17.0245 26.4403 17.025 26.4421C17.026 26.4458 17.027 26.4497 17.0282 26.4539C17.0306 26.4623 17.0333 26.4718 17.0365 26.4822C17.043 26.5031 17.0513 26.528 17.0619 26.5563C17.0831 26.6129 17.1137 26.6836 17.1569 26.7635C17.2438 26.9237 17.3816 27.1205 17.5955 27.3106C18.036 27.7021 18.723 28 19.75 28V26.5Z" fill="#3062D4"/>
</svg>
`, RCe = `<svg width="32" height="40" viewBox="0 0 32 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.75 6.75C0.75 3.43629 3.43629 0.75 6.75 0.75H20.9216C21.452 0.75 21.9607 0.960714 22.3358 1.33579L30.6642 9.66421C31.0393 10.0393 31.25 10.548 31.25 11.0784V33.25C31.25 36.5637 28.5637 39.25 25.25 39.25H6.75C3.43629 39.25 0.75 36.5637 0.75 33.25V6.75Z" fill="white"/>
<path d="M8.75 17.75H16.25M8.75 22.25H23.25M8.75 26.75H23.25M8.75 31.25H23.25M0.75 6.75C0.75 3.43629 3.43629 0.75 6.75 0.75H20.9216C21.452 0.75 21.9607 0.960714 22.3358 1.33579L30.6642 9.66421C31.0393 10.0393 31.25 10.548 31.25 11.0784V33.25C31.25 36.5637 28.5637 39.25 25.25 39.25H6.75C3.43629 39.25 0.75 36.5637 0.75 33.25V6.75Z" stroke="#3062D4" stroke-width="1.5" stroke-linecap="round"/>
</svg>
`, FCe = `<svg width="32" height="40" viewBox="0 0 32 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.75 6.75C0.75 3.43629 3.43629 0.75 6.75 0.75H20.9216C21.452 0.75 21.9607 0.960714 22.3358 1.33579L30.6642 9.66421C31.0393 10.0393 31.25 10.548 31.25 11.0784V33.25C31.25 36.5637 28.5637 39.25 25.25 39.25H6.75C3.43629 39.25 0.75 36.5637 0.75 33.25V6.75Z" fill="white"/>
<path d="M22.3358 1.33579L21.8055 1.86612V1.86612L22.3358 1.33579ZM30.6642 9.66421L30.1339 10.1945L30.6642 9.66421ZM18.8666 21.1769C19.1024 20.8363 19.0175 20.3691 18.6769 20.1334C18.3363 19.8976 17.8691 19.9825 17.6334 20.3231L18.8666 21.1769ZM13.1334 26.8231C12.8976 27.1637 12.9825 27.6309 13.3231 27.8666C13.6637 28.1024 14.1309 28.0175 14.3666 27.6769L13.1334 26.8231ZM14.3666 20.3231C14.1309 19.9825 13.6637 19.8976 13.3231 20.1334C12.9825 20.3691 12.8976 20.8363 13.1334 21.1769L14.3666 20.3231ZM17.6334 27.6769C17.8691 28.0175 18.3363 28.1024 18.6769 27.8666C19.0175 27.6309 19.1024 27.1637 18.8666 26.8231L17.6334 27.6769ZM1.5 6.75C1.5 3.85051 3.85051 1.5 6.75 1.5V0C3.02208 0 0 3.02208 0 6.75H1.5ZM6.75 1.5H20.9216V0H6.75V1.5ZM20.9216 1.5C21.2531 1.5 21.571 1.6317 21.8055 1.86612L22.8661 0.805457C22.3504 0.289731 21.6509 0 20.9216 0V1.5ZM21.8055 1.86612L30.1339 10.1945L31.1945 9.13388L22.8661 0.805456L21.8055 1.86612ZM30.1339 10.1945C30.3683 10.429 30.5 10.7469 30.5 11.0784H32C32 10.3491 31.7103 9.64961 31.1945 9.13388L30.1339 10.1945ZM30.5 11.0784V33.25H32V11.0784H30.5ZM30.5 33.25C30.5 36.1495 28.1495 38.5 25.25 38.5V40C28.9779 40 32 36.9779 32 33.25H30.5ZM25.25 38.5H6.75V40H25.25V38.5ZM6.75 38.5C3.85051 38.5 1.5 36.1495 1.5 33.25H0C0 36.9779 3.02208 40 6.75 40V38.5ZM1.5 33.25V6.75H0V33.25H1.5ZM17.6334 20.3231L15.3834 23.5731L16.6166 24.4269L18.8666 21.1769L17.6334 20.3231ZM15.3834 23.5731L13.1334 26.8231L14.3666 27.6769L16.6166 24.4269L15.3834 23.5731ZM13.1334 21.1769L15.3834 24.4269L16.6166 23.5731L14.3666 20.3231L13.1334 21.1769ZM15.3834 24.4269L17.6334 27.6769L18.8666 26.8231L16.6166 23.5731L15.3834 24.4269Z" fill="#1D7C4D"/>
</svg>
`, TCe = `<svg width="32" height="40" viewBox="0 0 32 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.75 6.75C0.75 3.43629 3.43629 0.75 6.75 0.75H20.9216C21.452 0.75 21.9607 0.960714 22.3358 1.33579L30.6642 9.66421C31.0393 10.0393 31.25 10.548 31.25 11.0784V33.25C31.25 36.5637 28.5637 39.25 25.25 39.25H6.75C3.43629 39.25 0.75 36.5637 0.75 33.25V6.75Z" fill="white"/>
<path d="M10.5 31.25C10.5 29.7312 11.7312 28.5 13.25 28.5H16V31.25C16 32.7688 14.7688 34 13.25 34C11.7312 34 10.5 32.7688 10.5 31.25Z" fill="white"/>
<path d="M10.5 20.25C10.5 18.7312 11.7312 17.5 13.25 17.5H16V23H13.25C11.7312 23 10.5 21.7688 10.5 20.25Z" fill="white"/>
<path d="M16 17.5H18.75C20.2688 17.5 21.5 18.7312 21.5 20.25C21.5 21.7688 20.2688 23 18.75 23H16V17.5Z" fill="white"/>
<path d="M16 25.75C16 24.2312 17.2312 23 18.75 23C20.2688 23 21.5 24.2312 21.5 25.75C21.5 27.2688 20.2688 28.5 18.75 28.5C17.2312 28.5 16 27.2688 16 25.75Z" fill="white"/>
<path d="M10.5 25.75C10.5 24.2312 11.7312 23 13.25 23H16V28.5H13.25C11.7312 28.5 10.5 27.2688 10.5 25.75Z" fill="white"/>
<path d="M22.3358 1.33579L21.8055 1.86612V1.86612L22.3358 1.33579ZM30.6642 9.66421L30.1339 10.1945L30.6642 9.66421ZM1.5 6.75C1.5 3.85051 3.85051 1.5 6.75 1.5V0C3.02208 0 0 3.02208 0 6.75H1.5ZM6.75 1.5H20.9216V0H6.75V1.5ZM20.9216 1.5C21.2531 1.5 21.571 1.6317 21.8055 1.86612L22.8661 0.805457C22.3504 0.289731 21.6509 0 20.9216 0V1.5ZM21.8055 1.86612L30.1339 10.1945L31.1945 9.13388L22.8661 0.805456L21.8055 1.86612ZM30.1339 10.1945C30.3683 10.429 30.5 10.7469 30.5 11.0784H32C32 10.3491 31.7103 9.64961 31.1945 9.13388L30.1339 10.1945ZM30.5 11.0784V33.25H32V11.0784H30.5ZM30.5 33.25C30.5 36.1495 28.1495 38.5 25.25 38.5V40C28.9779 40 32 36.9779 32 33.25H30.5ZM25.25 38.5H6.75V40H25.25V38.5ZM6.75 38.5C3.85051 38.5 1.5 36.1495 1.5 33.25H0C0 36.9779 3.02208 40 6.75 40V38.5ZM1.5 33.25V6.75H0V33.25H1.5ZM13.25 29.25H16V27.75H13.25V29.25ZM15.25 28.5V31.25H16.75V28.5H15.25ZM13.25 33.25C12.1454 33.25 11.25 32.3546 11.25 31.25H9.75C9.75 33.183 11.317 34.75 13.25 34.75V33.25ZM15.25 31.25C15.25 32.3546 14.3546 33.25 13.25 33.25V34.75C15.183 34.75 16.75 33.183 16.75 31.25H15.25ZM13.25 27.75C11.317 27.75 9.75 29.317 9.75 31.25H11.25C11.25 30.1454 12.1454 29.25 13.25 29.25V27.75ZM13.25 18.25H16V16.75H13.25V18.25ZM15.25 17.5V23H16.75V17.5H15.25ZM16 22.25H13.25V23.75H16V22.25ZM13.25 22.25C12.1454 22.25 11.25 21.3546 11.25 20.25H9.75C9.75 22.183 11.317 23.75 13.25 23.75V22.25ZM13.25 16.75C11.317 16.75 9.75 18.317 9.75 20.25H11.25C11.25 19.1454 12.1454 18.25 13.25 18.25V16.75ZM16 18.25H18.75V16.75H16V18.25ZM18.75 22.25H16V23.75H18.75V22.25ZM20.75 20.25C20.75 21.3546 19.8546 22.25 18.75 22.25V23.75C20.683 23.75 22.25 22.183 22.25 20.25H20.75ZM18.75 18.25C19.8546 18.25 20.75 19.1454 20.75 20.25H22.25C22.25 18.317 20.683 16.75 18.75 16.75V18.25ZM18.75 27.75C17.6454 27.75 16.75 26.8546 16.75 25.75H15.25C15.25 27.683 16.817 29.25 18.75 29.25V27.75ZM20.75 25.75C20.75 26.8546 19.8546 27.75 18.75 27.75V29.25C20.683 29.25 22.25 27.683 22.25 25.75H20.75ZM18.75 23.75C19.8546 23.75 20.75 24.6454 20.75 25.75H22.25C22.25 23.817 20.683 22.25 18.75 22.25V23.75ZM18.75 22.25C16.817 22.25 15.25 23.817 15.25 25.75H16.75C16.75 24.6454 17.6454 23.75 18.75 23.75V22.25ZM15.25 23V28.5H16.75V23H15.25ZM13.25 27.75C12.1454 27.75 11.25 26.8546 11.25 25.75H9.75C9.75 27.683 11.317 29.25 13.25 29.25V27.75ZM13.25 22.25C11.317 22.25 9.75 23.817 9.75 25.75H11.25C11.25 24.6454 12.1454 23.75 13.25 23.75V22.25Z" fill="#8040BF"/>
</svg>
`, ICe = `<svg width="32" height="40" viewBox="0 0 32 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.75 6.75C0.75 3.43629 3.43629 0.75 6.75 0.75H20.9216C21.452 0.75 21.9607 0.960714 22.3358 1.33579L30.6642 9.66421C31.0393 10.0393 31.25 10.548 31.25 11.0784V33.25C31.25 36.5637 28.5637 39.25 25.25 39.25H6.75C3.43629 39.25 0.75 36.5637 0.75 33.25V6.75Z" fill="white" stroke="#555F6D" stroke-width="1.5" stroke-linecap="round"/>
</svg>
`, DCe = `<svg width="32" height="40" viewBox="0 0 32 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.75 6.75C0.75 3.43629 3.43629 0.75 6.75 0.75H20.9216C21.452 0.75 21.9607 0.960714 22.3358 1.33579L30.6642 9.66421C31.0393 10.0393 31.25 10.548 31.25 11.0784V33.25C31.25 36.5637 28.5637 39.25 25.25 39.25H6.75C3.43629 39.25 0.75 36.5637 0.75 33.25V6.75Z" fill="white"/>
<path d="M13.75 20.75H16C17.7949 20.75 19.25 22.2051 19.25 24C19.25 25.7949 17.7949 27.25 16 27.25H13.75V20.75Z" fill="white"/>
<path d="M6.75 20.75V25.25H9C10.2426 25.25 11.25 24.2426 11.25 23C11.25 21.7574 10.2426 20.75 9 20.75H6.75Z" fill="white"/>
<path d="M22.3358 1.33579L21.8055 1.86612V1.86612L22.3358 1.33579ZM30.6642 9.66421L30.1339 10.1945L30.6642 9.66421ZM13.75 20.75V20C13.3358 20 13 20.3358 13 20.75H13.75ZM13.75 27.25H13C13 27.6642 13.3358 28 13.75 28V27.25ZM6 27.25C6 27.6642 6.33579 28 6.75 28C7.16421 28 7.5 27.6642 7.5 27.25H6ZM6.75 20.75V20C6.33579 20 6 20.3358 6 20.75H6.75ZM21 27.25C21 27.6642 21.3358 28 21.75 28C22.1642 28 22.5 27.6642 22.5 27.25H21ZM21.75 20.75V20C21.3358 20 21 20.3358 21 20.75H21.75ZM25.25 21.5C25.6642 21.5 26 21.1642 26 20.75C26 20.3358 25.6642 20 25.25 20V21.5ZM25.25 25C25.6642 25 26 24.6642 26 24.25C26 23.8358 25.6642 23.5 25.25 23.5V25ZM1.5 6.75C1.5 3.85051 3.85051 1.5 6.75 1.5V0C3.02208 0 0 3.02208 0 6.75H1.5ZM6.75 1.5H20.9216V0H6.75V1.5ZM20.9216 1.5C21.2531 1.5 21.571 1.6317 21.8055 1.86612L22.8661 0.805457C22.3504 0.289731 21.6509 0 20.9216 0V1.5ZM21.8055 1.86612L30.1339 10.1945L31.1945 9.13388L22.8661 0.805456L21.8055 1.86612ZM30.1339 10.1945C30.3683 10.429 30.5 10.7469 30.5 11.0784H32C32 10.3491 31.7103 9.64961 31.1945 9.13388L30.1339 10.1945ZM30.5 11.0784V33.25H32V11.0784H30.5ZM30.5 33.25C30.5 36.1495 28.1495 38.5 25.25 38.5V40C28.9779 40 32 36.9779 32 33.25H30.5ZM25.25 38.5H6.75V40H25.25V38.5ZM6.75 38.5C3.85051 38.5 1.5 36.1495 1.5 33.25H0C0 36.9779 3.02208 40 6.75 40V38.5ZM1.5 33.25V6.75H0V33.25H1.5ZM13.75 21.5H16V20H13.75V21.5ZM16 26.5H13.75V28H16V26.5ZM14.5 27.25V20.75H13V27.25H14.5ZM18.5 24C18.5 25.3807 17.3807 26.5 16 26.5V28C18.2091 28 20 26.2091 20 24H18.5ZM16 21.5C17.3807 21.5 18.5 22.6193 18.5 24H20C20 21.7909 18.2091 20 16 20V21.5ZM7.5 27.25V25.25H6V27.25H7.5ZM7.5 25.25V20.75H6V25.25H7.5ZM6.75 21.5H9V20H6.75V21.5ZM9 24.5H6.75V26H9V24.5ZM10.5 23C10.5 23.8284 9.82843 24.5 9 24.5V26C10.6569 26 12 24.6569 12 23H10.5ZM9 21.5C9.82843 21.5 10.5 22.1716 10.5 23H12C12 21.3431 10.6569 20 9 20V21.5ZM22.5 27.25V24.25H21V27.25H22.5ZM22.5 24.25V20.75H21V24.25H22.5ZM21.75 21.5H25.25V20H21.75V21.5ZM25.25 23.5H21.75V25H25.25V23.5Z" fill="#C53434"/>
</svg>
`, kCe = `<svg width="32" height="40" viewBox="0 0 32 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.75 6.75C0.75 3.43629 3.43629 0.75 6.75 0.75H20.9216C21.452 0.75 21.9607 0.960714 22.3358 1.33579L30.6642 9.66421C31.0393 10.0393 31.25 10.548 31.25 11.0784V33.25C31.25 36.5637 28.5637 39.25 25.25 39.25H6.75C3.43629 39.25 0.75 36.5637 0.75 33.25V6.75Z" fill="white"/>
<path d="M10.2121 18.2878C10.5304 17.727 10.6895 17.4467 10.9086 17.243C11.1024 17.0628 11.3295 16.9269 11.5754 16.8438C11.8533 16.75 12.1625 16.75 12.7811 16.75H19.2189C19.8375 16.75 20.1467 16.75 20.4246 16.8438C20.6706 16.9269 20.8976 17.0628 21.0914 17.243C21.3105 17.4467 21.4696 17.727 21.7879 18.2878L22.5388 19.6109C22.963 20.3584 23.1751 20.7322 23.2298 21.1223C23.278 21.4665 23.2396 21.8182 23.1184 22.1417C22.981 22.5084 22.6938 22.8211 22.1196 23.4467L18.1498 27.771C17.3995 28.5883 17.0244 28.9969 16.5892 29.1494C16.2067 29.2835 15.7933 29.2835 15.4108 29.1494C14.9756 28.9969 14.6005 28.5883 13.8502 27.771L9.8804 23.4467C9.30615 22.8211 9.01903 22.5084 8.88164 22.1417C8.7604 21.8182 8.72197 21.4665 8.77024 21.1223C8.82493 20.7322 9.03703 20.3584 9.46124 19.6109L10.2121 18.2878Z" fill="#F59638"/>
<path d="M22.3358 1.33579L21.8055 1.86612V1.86612L22.3358 1.33579ZM30.6642 9.66421L30.1339 10.1945L30.6642 9.66421ZM10.2121 18.2878L10.8644 18.658L10.2121 18.2878ZM10.9086 17.243L11.4192 17.7923L10.9086 17.243ZM11.5754 16.8438L11.8153 17.5544L11.5754 16.8438ZM20.4246 16.8438L20.6646 16.1332V16.1332L20.4246 16.8438ZM21.0914 17.243L20.5808 17.7923L21.0914 17.243ZM21.7879 18.2878L22.4402 17.9176V17.9176L21.7879 18.2878ZM22.5388 19.6109L21.8865 19.9811V19.9811L22.5388 19.6109ZM23.2298 21.1223L22.487 21.2264L23.2298 21.1223ZM23.1184 22.1417L22.4161 21.8785L22.416 21.8785L23.1184 22.1417ZM22.1196 23.4467L22.6721 23.9539L22.1196 23.4467ZM18.1498 27.771L18.7023 28.2782H18.7023L18.1498 27.771ZM16.5892 29.1494L16.8373 29.8572L16.5892 29.1494ZM15.4108 29.1494L15.1627 29.8572L15.4108 29.1494ZM13.8502 27.771L13.2977 28.2782L13.8502 27.771ZM9.8804 23.4467L10.4329 22.9395L9.8804 23.4467ZM8.88164 22.1417L9.58395 21.8785L8.88164 22.1417ZM8.77024 21.1223L8.0275 21.0182L8.77024 21.1223ZM9.46124 19.6109L10.1135 19.9811L9.46124 19.6109ZM1.5 6.75C1.5 3.85051 3.85051 1.5 6.75 1.5V0C3.02208 0 0 3.02208 0 6.75H1.5ZM6.75 1.5H20.9216V0H6.75V1.5ZM20.9216 1.5C21.2531 1.5 21.571 1.6317 21.8055 1.86612L22.8661 0.805457C22.3504 0.289731 21.6509 0 20.9216 0V1.5ZM21.8055 1.86612L30.1339 10.1945L31.1945 9.13388L22.8661 0.805456L21.8055 1.86612ZM30.1339 10.1945C30.3683 10.429 30.5 10.7469 30.5 11.0784H32C32 10.3491 31.7103 9.64961 31.1945 9.13388L30.1339 10.1945ZM30.5 11.0784V33.25H32V11.0784H30.5ZM30.5 33.25C30.5 36.1495 28.1495 38.5 25.25 38.5V40C28.9779 40 32 36.9779 32 33.25H30.5ZM25.25 38.5H6.75V40H25.25V38.5ZM6.75 38.5C3.85051 38.5 1.5 36.1495 1.5 33.25H0C0 36.9779 3.02208 40 6.75 40V38.5ZM1.5 33.25V6.75H0V33.25H1.5ZM10.8644 18.658C11.2074 18.0535 11.305 17.8985 11.4192 17.7923L10.3979 16.6937C10.0739 16.9949 9.85329 17.4006 9.55984 17.9176L10.8644 18.658ZM11.4192 17.7923C11.5369 17.6829 11.6721 17.6028 11.8153 17.5544L11.3355 16.1332C10.9868 16.2509 10.668 16.4426 10.3979 16.6937L11.4192 17.7923ZM11.8153 17.5544C11.9489 17.5093 12.1106 17.5 12.7811 17.5V16C12.2145 16 11.7577 15.9907 11.3355 16.1332L11.8153 17.5544ZM12.7811 17.5H19.2189V16H12.7811V17.5ZM19.2189 17.5C19.8894 17.5 20.0511 17.5093 20.1847 17.5544L20.6646 16.1332C20.2423 15.9907 19.7855 16 19.2189 16V17.5ZM20.1847 17.5544C20.3279 17.6028 20.4631 17.6829 20.5808 17.7923L21.6021 16.6937C21.332 16.4426 21.0132 16.2509 20.6646 16.1332L20.1847 17.5544ZM20.5808 17.7923C20.695 17.8985 20.7926 18.0535 21.1356 18.658L22.4402 17.9176C22.1467 17.4006 21.9261 16.9949 21.6021 16.6937L20.5808 17.7923ZM21.1356 18.658L21.8865 19.9811L23.191 19.2408L22.4402 17.9176L21.1356 18.658ZM21.8865 19.9811C22.3424 20.7844 22.457 21.0122 22.487 21.2264L23.9725 21.0182C23.8931 20.4522 23.5836 19.9325 23.191 19.2408L21.8865 19.9811ZM22.487 21.2264C22.518 21.4476 22.4931 21.6729 22.4161 21.8785L23.8207 22.4049C23.9861 21.9634 24.038 21.4855 23.9725 21.0182L22.487 21.2264ZM22.416 21.8785C22.3422 22.0757 22.1853 22.2661 21.5671 22.9395L22.6721 23.9539C23.2024 23.3762 23.6198 22.941 23.8207 22.4049L22.416 21.8785ZM21.5671 22.9395L17.5973 27.2638L18.7023 28.2782L22.6721 23.9539L21.5671 22.9395ZM17.5973 27.2638C17.2136 27.6817 16.9564 27.961 16.7426 28.1584C16.5341 28.3509 16.4199 28.414 16.3411 28.4416L16.8373 29.8572C17.1937 29.7323 17.4846 29.5149 17.7601 29.2605C18.0302 29.0112 18.3357 28.6775 18.7023 28.2782L17.5973 27.2638ZM16.3411 28.4416C16.1192 28.5195 15.8808 28.5195 15.6589 28.4416L15.1627 29.8572C15.7059 30.0476 16.2941 30.0476 16.8373 29.8572L16.3411 28.4416ZM15.6589 28.4416C15.5801 28.414 15.4659 28.3509 15.2574 28.1584C15.0436 27.961 14.7864 27.6817 14.4027 27.2638L13.2977 28.2782C13.6643 28.6775 13.9698 29.0112 14.2399 29.2605C14.5154 29.5149 14.8063 29.7323 15.1627 29.8572L15.6589 28.4416ZM14.4027 27.2638L10.4329 22.9395L9.32791 23.9539L13.2977 28.2782L14.4027 27.2638ZM10.4329 22.9395C9.81472 22.2661 9.65782 22.0757 9.58395 21.8785L8.17933 22.4049C8.38023 22.941 8.79758 23.3762 9.32791 23.9539L10.4329 22.9395ZM9.58395 21.8785C9.50689 21.6729 9.48197 21.4476 9.51297 21.2264L8.0275 21.0182C7.96198 21.4855 8.01391 21.9634 8.17933 22.4049L9.58395 21.8785ZM9.51297 21.2264C9.543 21.0122 9.65765 20.7844 10.1135 19.9811L8.80896 19.2408C8.41642 19.9325 8.10685 20.4522 8.0275 21.0182L9.51297 21.2264ZM10.1135 19.9811L10.8644 18.658L9.55984 17.9176L8.80896 19.2408L10.1135 19.9811Z" fill="#F59638"/>
</svg>
`, HCe = `<svg width="32" height="40" viewBox="0 0 32 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.75 6.75C0.75 3.43629 3.43629 0.75 6.75 0.75H20.9216C21.452 0.75 21.9607 0.960714 22.3358 1.33579L30.6642 9.66421C31.0393 10.0393 31.25 10.548 31.25 11.0784V33.25C31.25 36.5637 28.5637 39.25 25.25 39.25H6.75C3.43629 39.25 0.75 36.5637 0.75 33.25V6.75Z" fill="white"/>
<path d="M8.75 18.75C8.75 17.6454 9.64543 16.75 10.75 16.75H21.25C22.3546 16.75 23.25 17.6454 23.25 18.75V29.25C23.25 30.3546 22.3546 31.25 21.25 31.25H10.75C9.64543 31.25 8.75 30.3546 8.75 29.25V18.75Z" fill="white"/>
<path d="M13.75 16.75V31.25M8.75 21.75H23.25M0.75 6.75C0.75 3.43629 3.43629 0.75 6.75 0.75H20.9216C21.452 0.75 21.9607 0.960714 22.3358 1.33579L30.6642 9.66421C31.0393 10.0393 31.25 10.548 31.25 11.0784V33.25C31.25 36.5637 28.5637 39.25 25.25 39.25H6.75C3.43629 39.25 0.75 36.5637 0.75 33.25V6.75ZM10.75 31.25H21.25C22.3546 31.25 23.25 30.3546 23.25 29.25V18.75C23.25 17.6454 22.3546 16.75 21.25 16.75H10.75C9.64543 16.75 8.75 17.6454 8.75 18.75V29.25C8.75 30.3546 9.64543 31.25 10.75 31.25Z" stroke="#1D7C4D" stroke-width="1.5" stroke-linecap="round"/>
</svg>
`, VCe = `<svg width="32" height="40" viewBox="0 0 32 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.75 6.75C0.75 3.43629 3.43629 0.75 6.75 0.75H20.9216C21.452 0.75 21.9607 0.960714 22.3358 1.33579L30.6642 9.66421C31.0393 10.0393 31.25 10.548 31.25 11.0784V33.25C31.25 36.5637 28.5637 39.25 25.25 39.25H6.75C3.43629 39.25 0.75 36.5637 0.75 33.25V6.75Z" fill="white"/>
<path d="M22.3358 1.33579L21.8055 1.86612V1.86612L22.3358 1.33579ZM30.6642 9.66421L30.1339 10.1945L30.6642 9.66421ZM13.75 27.25L13.0332 27.4706C13.1214 27.7572 13.3718 27.9637 13.6699 27.9957C13.9681 28.0277 14.2567 27.8791 14.4037 27.6177L13.75 27.25ZM12.4668 20.5294C12.345 20.1335 11.9253 19.9114 11.5294 20.0332C11.1335 20.155 10.9114 20.5747 11.0332 20.9706L12.4668 20.5294ZM16 23.25L16.6537 22.8823C16.5208 22.6461 16.271 22.5 16 22.5C15.729 22.5 15.4792 22.6461 15.3463 22.8823L16 23.25ZM18.25 27.25L17.5963 27.6177C17.7433 27.8791 18.0319 28.0277 18.3301 27.9957C18.6282 27.9637 18.8786 27.7572 18.9668 27.4706L18.25 27.25ZM20.9668 20.9706C21.0886 20.5747 20.8665 20.155 20.4706 20.0332C20.0747 19.9114 19.655 20.1335 19.5332 20.5294L20.9668 20.9706ZM1.5 6.75C1.5 3.85051 3.85051 1.5 6.75 1.5V0C3.02208 0 0 3.02208 0 6.75H1.5ZM6.75 1.5H20.9216V0H6.75V1.5ZM20.9216 1.5C21.2531 1.5 21.571 1.6317 21.8055 1.86612L22.8661 0.805457C22.3504 0.289731 21.6509 0 20.9216 0V1.5ZM21.8055 1.86612L30.1339 10.1945L31.1945 9.13388L22.8661 0.805456L21.8055 1.86612ZM30.1339 10.1945C30.3683 10.429 30.5 10.7469 30.5 11.0784H32C32 10.3491 31.7103 9.64961 31.1945 9.13388L30.1339 10.1945ZM30.5 11.0784V33.25H32V11.0784H30.5ZM30.5 33.25C30.5 36.1495 28.1495 38.5 25.25 38.5V40C28.9779 40 32 36.9779 32 33.25H30.5ZM25.25 38.5H6.75V40H25.25V38.5ZM6.75 38.5C3.85051 38.5 1.5 36.1495 1.5 33.25H0C0 36.9779 3.02208 40 6.75 40V38.5ZM1.5 33.25V6.75H0V33.25H1.5ZM14.4668 27.0294L12.4668 20.5294L11.0332 20.9706L13.0332 27.4706L14.4668 27.0294ZM14.4037 27.6177L16.6537 23.6177L15.3463 22.8823L13.0963 26.8823L14.4037 27.6177ZM15.3463 23.6177L17.5963 27.6177L18.9037 26.8823L16.6537 22.8823L15.3463 23.6177ZM18.9668 27.4706L20.9668 20.9706L19.5332 20.5294L17.5332 27.0294L18.9668 27.4706Z" fill="#3062D4"/>
</svg>
`, OCe = `<svg width="32" height="40" viewBox="0 0 32 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.75 6.75C0.75 3.43629 3.43629 0.75 6.75 0.75H20.9216C21.452 0.75 21.9607 0.960714 22.3358 1.33579L30.6642 9.66421C31.0393 10.0393 31.25 10.548 31.25 11.0784V33.25C31.25 36.5637 28.5637 39.25 25.25 39.25H6.75C3.43629 39.25 0.75 36.5637 0.75 33.25V6.75Z" fill="white"/>
<path d="M6.75 18.75H9.75V21.75H6.75V18.75Z" fill="white"/>
<path d="M22.3358 1.33579L21.8055 1.86612V1.86612L22.3358 1.33579ZM30.6642 9.66421L30.1339 10.1945L30.6642 9.66421ZM6.75 3.75H6C6 3.94891 6.07902 4.13968 6.21967 4.28033C6.36032 4.42098 6.55109 4.5 6.75 4.5V3.75ZM9.75 3.75H10.5C10.5 3.33579 10.1642 3 9.75 3V3.75ZM9.75 6.75V7.5C10.1642 7.5 10.5 7.16421 10.5 6.75H9.75ZM6.75 6.75V6C6.33579 6 6 6.33579 6 6.75H6.75ZM6.75 9.75H6C6 10.1642 6.33579 10.5 6.75 10.5V9.75ZM9.75 9.75H10.5C10.5 9.33579 10.1642 9 9.75 9V9.75ZM9.75 12.75V13.5C10.1642 13.5 10.5 13.1642 10.5 12.75H9.75ZM6.75 12.75V12C6.33579 12 6 12.3358 6 12.75H6.75ZM6.75 15.75H6C6 16.1642 6.33579 16.5 6.75 16.5V15.75ZM9.75 15.75H10.5C10.5 15.3358 10.1642 15 9.75 15V15.75ZM6.75 18.75V18C6.33579 18 6 18.3358 6 18.75H6.75ZM6.75 21.75H6C6 22.1642 6.33579 22.5 6.75 22.5V21.75ZM9.75 21.75V22.5C10.1642 22.5 10.5 22.1642 10.5 21.75H9.75ZM1.5 6.75C1.5 3.85051 3.85051 1.5 6.75 1.5V0C3.02208 0 0 3.02208 0 6.75H1.5ZM6.75 1.5H20.9216V0H6.75V1.5ZM20.9216 1.5C21.2531 1.5 21.571 1.6317 21.8055 1.86612L22.8661 0.805457C22.3504 0.289731 21.6509 0 20.9216 0V1.5ZM21.8055 1.86612L30.1339 10.1945L31.1945 9.13388L22.8661 0.805456L21.8055 1.86612ZM30.1339 10.1945C30.3683 10.429 30.5 10.7469 30.5 11.0784H32C32 10.3491 31.7103 9.64961 31.1945 9.13388L30.1339 10.1945ZM30.5 11.0784V33.25H32V11.0784H30.5ZM30.5 33.25C30.5 36.1495 28.1495 38.5 25.25 38.5V40C28.9779 40 32 36.9779 32 33.25H30.5ZM25.25 38.5H6.75V40H25.25V38.5ZM6.75 38.5C3.85051 38.5 1.5 36.1495 1.5 33.25H0C0 36.9779 3.02208 40 6.75 40V38.5ZM1.5 33.25V6.75H0V33.25H1.5ZM7.5 3.75L7.5 0.75L6 0.75L6 3.75H7.5ZM6.75 4.5H9.75V3H6.75V4.5ZM9 3.75V6.75H10.5V3.75H9ZM9.75 6H6.75V7.5H9.75V6ZM6 6.75V9.75H7.5V6.75H6ZM6.75 10.5H9.75V9H6.75V10.5ZM9 9.75V12.75H10.5V9.75H9ZM9.75 12H6.75V13.5H9.75V12ZM6 12.75V15.75H7.5V12.75H6ZM6.75 16.5H9.75V15H6.75V16.5ZM9 15.75V18.75H10.5V15.75H9ZM9.75 18H6.75V19.5H9.75V18ZM6 18.75V21.75H7.5V18.75H6ZM6.75 22.5H9.75V21H6.75V22.5ZM10.5 21.75V18.75H9V21.75H10.5Z" fill="#555F6D"/>
</svg>
`, BCe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="accesibility">
    <path fill-rule="evenodd" d="M10 2.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM7 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0ZM3.036 6.521a.75.75 0 0 1 .943-.485L10 7.963l6.021-1.927a.75.75 0 0 1 .458 1.428L10.75 9.297v2.472l4.12 6.06a.75.75 0 0 1-1.24.843L10 13.334l-3.63 5.338a.75.75 0 1 1-1.24-.844l4.12-6.059V9.297L3.521 7.464a.75.75 0 0 1-.485-.943Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, $Ce = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="activity">
    <path fill-rule="evenodd" d="M6.489 2a.75.75 0 0 1 .745.598l2.48 11.984 3.085-8.099a.75.75 0 0 1 1.412.03l1.33 3.987h2.709a.75.75 0 0 1 0 1.5H15a.75.75 0 0 1-.711-.513l-.836-2.507-3.252 8.537a.75.75 0 0 1-1.435-.115L6.558 6.734l-.82 4.646A.75.75 0 0 1 5 12H1.75a.75.75 0 0 1 0-1.5h2.62l1.391-7.88A.75.75 0 0 1 6.49 2Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, ZCe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="alarm-clock">
    <path fill-rule="evenodd" d="M4.78 1.22a.75.75 0 0 1 0 1.06l-2.5 2.5a.75.75 0 1 1-1.06-1.06l2.5-2.5a.75.75 0 0 1 1.06 0Zm10.44 0a.75.75 0 0 1 1.06 0l2.5 2.5a.75.75 0 0 1-1.06 1.06l-2.5-2.5a.75.75 0 0 1 0-1.06ZM10 3.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13ZM2 10a8 8 0 1 1 14.101 5.175l1.773 2.659a.75.75 0 1 1-1.248.832l-1.618-2.427A7.966 7.966 0 0 1 10 18a7.967 7.967 0 0 1-5.008-1.761l-1.618 2.427a.75.75 0 1 1-1.248-.832l1.773-2.66A7.968 7.968 0 0 1 2 10Zm7.75-5a.75.75 0 0 1 .75.75V9.5h1.75a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75v-4.5A.75.75 0 0 1 9.75 5Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, GCe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="alert-fill">
    <path fill-rule="evenodd" d="M10.567 1.09a1.835 1.835 0 0 0-1.134 0 1.86 1.86 0 0 0-.63.372c-.16.134-.335.31-.525.5L1.963 8.279c-.191.19-.367.366-.501.524a1.86 1.86 0 0 0-.372.631c-.12.369-.12.765 0 1.134.084.258.227.46.372.63.134.16.31.335.5.525l6.316 6.315c.19.191.366.367.524.501.171.145.373.288.631.372.369.12.765.12 1.134 0 .258-.084.46-.227.63-.372.16-.134.335-.31.526-.5l6.314-6.316c.191-.19.367-.366.501-.524.145-.171.288-.373.372-.631.12-.369.12-.765 0-1.134a1.859 1.859 0 0 0-.372-.63c-.134-.16-.31-.335-.5-.525l-6.316-6.315a9.471 9.471 0 0 0-.524-.501 1.86 1.86 0 0 0-.631-.372Zm.183 4.66a.75.75 0 0 0-1.5 0v3.5a.75.75 0 0 0 1.5 0v-3.5Zm0 7a.75.75 0 0 0-1.5 0v1.5a.75.75 0 0 0 1.5 0v-1.5Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, NCe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="alert">
    <path fill-rule="evenodd" d="M10.093 2.515a.303.303 0 0 0-.186 0 .612.612 0 0 0-.114.083c-.105.09-.237.22-.454.437L3.035 9.34a8.803 8.803 0 0 0-.437.454.612.612 0 0 0-.083.114.303.303 0 0 0 0 .186c.003.007.02.04.083.114.09.105.22.237.437.454l6.304 6.304c.217.217.349.347.454.437.074.062.107.08.114.083.06.02.125.02.186 0a.605.605 0 0 0 .114-.083c.105-.09.237-.22.454-.437l6.304-6.304c.217-.217.347-.349.437-.454a.605.605 0 0 0 .083-.114.303.303 0 0 0 0-.186.606.606 0 0 0-.083-.114 8.828 8.828 0 0 0-.437-.454L10.66 3.035a8.802 8.802 0 0 0-.454-.437.611.611 0 0 0-.114-.083Zm-.002-.001h.002-.002Zm7.395 7.577v.002-.002ZM9.91 17.486h-.002.002ZM2.514 9.91v-.002.002Zm6.929-8.82a1.803 1.803 0 0 1 1.114 0c.252.081.45.221.62.365.158.135.333.31.526.502l6.341 6.341c.192.193.367.368.502.526.144.17.284.368.366.62.117.362.117.752 0 1.114-.082.252-.222.45-.366.62-.135.158-.31.333-.502.526l-6.341 6.341c-.193.192-.368.367-.526.502-.17.144-.368.284-.62.366a1.804 1.804 0 0 1-1.114 0 1.83 1.83 0 0 1-.62-.366 9.504 9.504 0 0 1-.526-.502l-6.341-6.341c-.192-.193-.367-.368-.502-.526a1.827 1.827 0 0 1-.366-.62 1.803 1.803 0 0 1 0-1.114c.082-.252.222-.45.366-.62a9.51 9.51 0 0 1 .502-.526l6.341-6.341a9.51 9.51 0 0 1 .526-.502c.17-.144.368-.284.62-.366ZM10 5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 10 5Zm0 7a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0v-1.5A.75.75 0 0 1 10 12Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, zCe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="anchor">
    <path fill-rule="evenodd" d="M10 2.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM7 4a3 3 0 1 1 3.75 2.905v10.558a7.504 7.504 0 0 0 6.657-6.275l-2.856 1.25a.75.75 0 1 1-.602-1.375l4-1.75A.75.75 0 0 1 19 10a9 9 0 1 1-18 0 .75.75 0 0 1 1.05-.687l4 1.75a.75.75 0 1 1-.6 1.374l-2.856-1.25a7.504 7.504 0 0 0 6.656 6.276V6.905A3.001 3.001 0 0 1 7 4Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, jCe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="apps">
    <path fill-rule="evenodd" d="M4.75 3.25a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm6.75 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm5.25 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM4.75 10a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM10 11.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm8.25-1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm-15 8.25a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm8.25-1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm5.25 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, WCe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="archive">
    <path fill-rule="evenodd" d="M4.92 1h10.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 18.7 2.502c.172.337.24.694.27 1.073.03.365.03.81.03 1.345v11.33A2.75 2.75 0 0 1 16.25 19H3.75A2.75 2.75 0 0 1 1 16.25V4.92c0-.534 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 2.502 1.3c.337-.172.693-.24 1.073-.27C3.94 1 4.385 1 4.92 1ZM3.697 2.525c-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.547c-.046.09-.088.227-.111.515-.024.295-.025.68-.025 1.252V11h2.014a2.75 2.75 0 0 1 2.46 1.52l.144.289a1.25 1.25 0 0 0 1.118.691h3.528a1.25 1.25 0 0 0 1.118-.691l.144-.289a2.75 2.75 0 0 1 2.46-1.52H17.5V4.95c0-.572 0-.957-.025-1.252-.023-.288-.065-.425-.111-.515a1.25 1.25 0 0 0-.547-.547c-.09-.046-.227-.088-.515-.111-.295-.024-.68-.025-1.252-.025H4.95c-.572 0-.957 0-1.253.025ZM17.5 12.5h-2.014a1.25 1.25 0 0 0-1.118.691l-.144.289a2.75 2.75 0 0 1-2.46 1.52H8.236a2.75 2.75 0 0 1-2.46-1.52l-.144-.289a1.25 1.25 0 0 0-1.118-.691H2.5v3.75c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25V12.5Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, UCe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="arrow-down-left">
    <path fill-rule="evenodd" d="M15.78 4.22a.75.75 0 0 1 0 1.06L6.56 14.5h3.69a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1-.75-.75v-5.5a.75.75 0 0 1 1.5 0v3.69l9.22-9.22a.75.75 0 0 1 1.06 0Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, KCe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="arrow-down-right">
    <path fill-rule="evenodd" d="M4.22 4.22a.75.75 0 0 1 1.06 0l9.22 9.22V9.75a.75.75 0 0 1 1.5 0v5.5a.75.75 0 0 1-.75.75h-5.5a.75.75 0 0 1 0-1.5h3.69L4.22 5.28a.75.75 0 0 1 0-1.06Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, qCe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="arrow-down">
    <path fill-rule="evenodd" d="M10 3a.75.75 0 0 1 .75.75v10.764l2.986-2.81a.75.75 0 0 1 1.028 1.092l-4.25 4a.75.75 0 0 1-1.028 0l-4.25-4a.75.75 0 0 1 1.028-1.092l2.986 2.81V3.75A.75.75 0 0 1 10 3Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, YCe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="arrow-left">
    <path fill-rule="evenodd" d="M8.264 5.204a.75.75 0 0 1 .032 1.06L5.486 9.25H16.25a.75.75 0 0 1 0 1.5H5.486l2.81 2.986a.75.75 0 1 1-1.092 1.028l-4-4.25a.75.75 0 0 1 0-1.028l4-4.25a.75.75 0 0 1 1.06-.032Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, QCe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="arrow-right">
    <path fill-rule="evenodd" d="M11.736 5.204a.75.75 0 0 1 1.06.032l4 4.25a.75.75 0 0 1 0 1.028l-4 4.25a.75.75 0 0 1-1.092-1.028l2.81-2.986H3.75a.75.75 0 0 1 0-1.5h10.764l-2.81-2.986a.75.75 0 0 1 .032-1.06Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, JCe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="arrow-up-left">
    <path fill-rule="evenodd" d="M4 4.75A.75.75 0 0 1 4.75 4h5.5a.75.75 0 0 1 0 1.5H6.56l9.22 9.22a.75.75 0 1 1-1.06 1.06L5.5 6.56v3.69a.75.75 0 0 1-1.5 0v-5.5Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, XCe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="arrow-up-right">
    <path fill-rule="evenodd" d="M9.75 5.5a.75.75 0 0 1 0-1.5h5.5a.75.75 0 0 1 .75.75v5.5a.75.75 0 0 1-1.5 0V6.56l-9.22 9.22a.75.75 0 0 1-1.06-1.06l9.22-9.22H9.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, ewe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="arrow-up">
    <path fill-rule="evenodd" d="M9.486 3.204a.75.75 0 0 1 1.028 0l4.25 4a.75.75 0 1 1-1.028 1.092l-2.986-2.81V16.25a.75.75 0 0 1-1.5 0V5.486l-2.986 2.81a.75.75 0 0 1-1.028-1.092l4.25-4Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, twe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="arrowhead-down">
    <path fill-rule="evenodd" d="M10 13a1 1 0 0 1-.8-.4l-3-4A1 1 0 0 1 7 7h6a1 1 0 0 1 .8 1.6l-3 4a1 1 0 0 1-.8.4Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, owe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="arrowhead-left">
    <path fill-rule="evenodd" d="M12.447 13.894A1 1 0 0 1 11.4 13.8l-4-3a1 1 0 0 1 0-1.6l4-3A1 1 0 0 1 13 7v6a1 1 0 0 1-.553.894Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, nwe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="arrowhead-right">
    <path fill-rule="evenodd" d="M7.553 6.105a1 1 0 0 1 1.048.095l4 3a1 1 0 0 1 0 1.6l-4 3A1 1 0 0 1 7 13V7a1 1 0 0 1 .552-.895Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, swe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="arrowhead-up">
    <path fill-rule="evenodd" d="M10 7a1 1 0 0 1 .8.4l3 4A1 1 0 0 1 13 13H7a1 1 0 0 1-.8-1.6l3-4A1 1 0 0 1 10 7Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, iwe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="attachment">
    <path fill-rule="evenodd" d="M11.47 2.109a3.85 3.85 0 0 1 5.406 0 3.772 3.772 0 0 1 0 5.372l-8.159 8.073a2.3 2.3 0 0 1-3.23 0 2.26 2.26 0 0 1 0-3.22l7.07-6.996a.75.75 0 0 1 1.056 1.066L6.54 13.401a.761.761 0 0 0 0 1.087.8.8 0 0 0 1.121 0l8.16-8.074a2.272 2.272 0 0 0 0-3.24 2.35 2.35 0 0 0-3.297 0l-7.896 7.813a3.532 3.532 0 0 0-1.13 2.696c.001.251.001.35.005.43.088 1.824 1.565 3.295 3.426 3.383.081.004.182.004.436.004l.195-.001a3.626 3.626 0 0 0 2.54-1.12l5.72-5.659a.75.75 0 1 1 1.055 1.066l-5.726 5.666c-.07.069-.113.112-.158.154A5.126 5.126 0 0 1 7.596 19l-.22.001h-.034c-.223 0-.362 0-.483-.006-2.62-.123-4.727-2.2-4.853-4.809C2 14.065 2 13.927 2 13.707v-.034l.001-.219a5.032 5.032 0 0 1 1.411-3.37c.042-.044.086-.088.156-.157L11.47 2.11Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, rwe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="background">
    <path fill-rule="evenodd" d="M6.78 1.22a.75.75 0 0 1 0 1.06l-4.5 4.5a.75.75 0 0 1-1.06-1.06l4.5-4.5a.75.75 0 0 1 1.06 0Zm6 0a.75.75 0 0 1 0 1.06l-10.5 10.5a.75.75 0 0 1-1.06-1.06l10.5-10.5a.75.75 0 0 1 1.06 0Zm6 0a.75.75 0 0 1 0 1.06l-16.5 16.5a.75.75 0 0 1-1.06-1.06l16.5-16.5a.75.75 0 0 1 1.06 0Zm0 6a.75.75 0 0 1 0 1.06l-10.5 10.5a.75.75 0 0 1-1.06-1.06l10.5-10.5a.75.75 0 0 1 1.06 0Zm0 6a.75.75 0 0 1 0 1.06l-4.5 4.5a.75.75 0 1 1-1.06-1.06l4.5-4.5a.75.75 0 0 1 1.06 0Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, lwe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="backspace">
    <path d="M16.65 16.5H7.66c-.28 0-.46 0-.66-.05-.17-.04-.34-.11-.5-.21-.18-.11-.31-.24-.5-.43l-4.43-4.43C1.21 11.01 1 10.51 1 10c0-.51.21-1.02.57-1.38L6 4.19c.19-.19.32-.32.5-.43.15-.09.32-.17.5-.21.2-.05.37-.05.66-.05h8.99c.64 0 1.02 0 1.39.19.33.17.6.43.77.76.19.38.19.76.19 1.4v8.3c0 .63 0 1.02-.19 1.39-.17.34-.44.6-.77.77-.37.19-.76.19-1.39.19ZM7.66 5c-.289 0-.389.029-.6.24L2.63 9.68c-.09.08-.13.2-.13.32s.05.24.13.32l4.43 4.43c.207.207.308.23.6.25h8.99c.31 0 .64 0 .72-.03a.29.29 0 0 0 .11-.11c.03-.07.03-.4.03-.71v-8.3c0-.31 0-.64-.03-.72a.217.217 0 0 0-.11-.1C17.3 5 16.97 5 16.66 5h-9Zm6.59 8c-.19 0-.38-.07-.53-.22L12 11.06l-1.72 1.72c-.29.29-.77.29-1.06 0a.754.754 0 0 1 0-1.06L10.94 10 9.22 8.28a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0L12 8.94l1.72-1.72c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06L13.06 10l1.72 1.72c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22Z" class="Icon"/>
  </g>
</svg>
`, awe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="backward">
    <path fill-rule="evenodd" d="M10.36 4.093a.75.75 0 0 1 .39.657v3.884l7.097-4.517A.75.75 0 0 1 19 4.75v10.5a.75.75 0 0 1-1.153.633l-7.097-4.517v3.884a.75.75 0 0 1-1.153.633l-8.25-5.25a.75.75 0 0 1 0-1.266l8.25-5.25a.75.75 0 0 1 .764-.024ZM9.25 6.116 3.147 10l6.103 3.884V6.116ZM11.397 10l6.103 3.884V6.116L11.397 10Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, cwe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="bank">
    <path fill-rule="evenodd" d="M9.64 1.092a.75.75 0 0 1 .72 0l8.25 4.5A.75.75 0 0 1 18.25 7H1.75a.75.75 0 0 1-.36-1.408l8.25-4.5ZM4.692 5.5H15.31L10 2.604 4.691 5.5ZM2 8.75A.75.75 0 0 1 2.75 8h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 8.75ZM4 11a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 4 11Zm4 0a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 8 11Zm4 0a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 12 11Zm4 0a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 16 11ZM1 18.25a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H1.75a.75.75 0 0 1-.75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, dwe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="battery-charging">
    <path fill-rule="evenodd" d="M9.817 3.032a.75.75 0 0 1 .53.782l-.32 3.731h2.723a.75.75 0 0 1 .663 1.1l-4.2 7.955a.75.75 0 0 1-1.411-.4l.247-3.745H5.25a.75.75 0 0 1-.658-1.11l4.35-7.955a.75.75 0 0 1 .875-.358Zm-3.302 7.922H8.85a.75.75 0 0 1 .748.8l-.068 1.033 1.976-3.742H9.21a.75.75 0 0 1-.747-.814l.085-.994-2.033 3.717ZM4.847 4h.028a.75.75 0 1 1 0 1.5c-.536 0-.896 0-1.174.022-.27.02-.4.058-.485.098a1.25 1.25 0 0 0-.596.596c-.04.085-.078.215-.098.485-.021.278-.022.638-.022 1.174v4.25c0 .536 0 .896.022 1.174.02.27.058.4.098.485.124.262.334.472.596.596.085.04.215.077.485.098.278.021.638.022 1.174.022a.75.75 0 0 1 0 1.5h-.028c-.501 0-.919 0-1.26-.026-.357-.027-.692-.087-1.013-.238a2.75 2.75 0 0 1-1.31-1.31c-.151-.32-.21-.656-.238-1.012C1 13.072 1 12.654 1 12.154V7.846c0-.501 0-.919.026-1.26.028-.357.087-.692.238-1.013a2.75 2.75 0 0 1 1.31-1.31c.32-.151.656-.21 1.012-.238C3.928 4 4.346 4 4.846 4Zm9.452 1.522a17.145 17.145 0 0 0-1.174-.022.75.75 0 0 1 0-1.5h.028c.501 0 .919 0 1.26.026.357.028.692.087 1.013.238a2.75 2.75 0 0 1 1.31 1.31c.151.32.21.656.238 1.012.026.342.026.76.026 1.26v4.307c0 .5 0 .919-.026 1.26-.027.357-.087.692-.238 1.013a2.75 2.75 0 0 1-1.31 1.31c-.32.151-.656.21-1.012.238-.342.026-.76.026-1.26.026h-.029a.75.75 0 0 1 0-1.5c.536 0 .896 0 1.174-.022.27-.02.4-.057.485-.098a1.25 1.25 0 0 0 .596-.596c.04-.085.077-.215.098-.485.021-.278.022-.638.022-1.174v-4.25c0-.536 0-.896-.022-1.174-.02-.27-.057-.4-.098-.485a1.25 1.25 0 0 0-.596-.596c-.085-.04-.215-.078-.485-.098ZM18.25 8a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0v-2.5a.75.75 0 0 1 .75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, uwe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="battery-empty">
    <path fill-rule="evenodd" d="M4.92 4h8.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 16.7 5.502c.172.337.24.693.27 1.073.03.365.03.81.03 1.345v4.16c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073a2.751 2.751 0 0 1-1.2 1.202c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03H4.92c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 1.3 14.5c-.172-.338-.24-.694-.27-1.074C1 13.06 1 12.615 1 12.08V7.92c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 2.502 4.3c.337-.172.693-.24 1.073-.27C3.94 4 4.385 4 4.92 4ZM3.697 5.525c-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.547c-.046.09-.088.227-.111.514-.024.296-.025.68-.025 1.253v4.1c0 .572 0 .957.025 1.252.023.288.065.425.111.516.12.235.311.426.547.546.09.046.227.088.514.111.296.024.68.025 1.253.025h8.1c.572 0 .957 0 1.252-.025.288-.023.425-.065.516-.111a1.25 1.25 0 0 0 .546-.546c.046-.091.088-.228.111-.515.024-.296.025-.68.025-1.253v-4.1c0-.572 0-.957-.025-1.253-.023-.287-.065-.424-.111-.514a1.25 1.25 0 0 0-.546-.547c-.091-.046-.228-.088-.515-.111-.296-.024-.68-.025-1.253-.025h-8.1c-.572 0-.957 0-1.253.025ZM18.25 8a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0v-2.5a.75.75 0 0 1 .75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, hwe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="battery-full">
    <path fill-rule="evenodd" d="M4.92 4h8.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 16.7 5.502c.172.337.24.693.27 1.073.03.365.03.81.03 1.345v4.16c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073a2.751 2.751 0 0 1-1.2 1.202c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03H4.92c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 1.3 14.5c-.172-.338-.24-.694-.27-1.074C1 13.06 1 12.615 1 12.08V7.92c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 2.502 4.3c.337-.172.693-.24 1.073-.27C3.94 4 4.385 4 4.92 4ZM3.697 5.525c-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.547c-.046.09-.088.227-.111.514-.024.296-.025.68-.025 1.253v4.1c0 .572 0 .957.025 1.252.023.288.065.425.111.516.12.235.311.426.547.546.09.046.227.088.514.111.296.024.68.025 1.253.025h8.1c.572 0 .957 0 1.252-.025.288-.023.425-.065.516-.111a1.25 1.25 0 0 0 .546-.546c.046-.091.088-.228.111-.515.024-.296.025-.68.025-1.253v-4.1c0-.572 0-.957-.025-1.253-.023-.287-.065-.424-.111-.514a1.25 1.25 0 0 0-.546-.547c-.091-.046-.228-.088-.515-.111-.296-.024-.68-.025-1.253-.025h-8.1c-.572 0-.957 0-1.253.025ZM4.75 7a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0v-4.5A.75.75 0 0 1 4.75 7Zm4 0a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0v-4.5A.75.75 0 0 1 8.75 7Zm4 0a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0v-4.5a.75.75 0 0 1 .75-.75Zm5.5 1a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0v-2.5a.75.75 0 0 1 .75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, gwe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="battery-low">
    <path fill-rule="evenodd" d="M4.92 4h8.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 16.7 5.502c.172.337.24.693.27 1.073.03.365.03.81.03 1.345v4.16c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073a2.751 2.751 0 0 1-1.2 1.202c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03H4.92c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 1.3 14.5c-.172-.338-.24-.694-.27-1.074C1 13.06 1 12.615 1 12.08V7.92c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 2.502 4.3c.337-.172.693-.24 1.073-.27C3.94 4 4.385 4 4.92 4ZM3.697 5.525c-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.547c-.046.09-.088.227-.111.514-.024.296-.025.68-.025 1.253v4.1c0 .572 0 .957.025 1.252.023.288.065.425.111.516.12.235.311.426.547.546.09.046.227.088.514.111.296.024.68.025 1.253.025h8.1c.572 0 .957 0 1.252-.025.288-.023.425-.065.516-.111a1.25 1.25 0 0 0 .546-.546c.046-.091.088-.228.111-.515.024-.296.025-.68.025-1.253v-4.1c0-.572 0-.957-.025-1.253-.023-.287-.065-.424-.111-.514a1.25 1.25 0 0 0-.546-.547c-.091-.046-.228-.088-.515-.111-.296-.024-.68-.025-1.253-.025h-8.1c-.572 0-.957 0-1.253.025ZM4.75 7a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0v-4.5A.75.75 0 0 1 4.75 7Zm13.5 1a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0v-2.5a.75.75 0 0 1 .75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, pwe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="battery-medium">
    <path fill-rule="evenodd" d="M4.92 4h8.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 16.7 5.502c.172.337.24.693.27 1.073.03.365.03.81.03 1.345v4.16c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073a2.751 2.751 0 0 1-1.2 1.202c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03H4.92c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 1.3 14.5c-.172-.338-.24-.694-.27-1.074C1 13.06 1 12.615 1 12.08V7.92c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 2.502 4.3c.337-.172.693-.24 1.073-.27C3.94 4 4.385 4 4.92 4ZM3.697 5.525c-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.547c-.046.09-.088.227-.111.514-.024.296-.025.68-.025 1.253v4.1c0 .572 0 .957.025 1.252.023.288.065.425.111.516.12.235.311.426.547.546.09.046.227.088.514.111.296.024.68.025 1.253.025h8.1c.572 0 .957 0 1.252-.025.288-.023.425-.065.516-.111a1.25 1.25 0 0 0 .546-.546c.046-.091.088-.228.111-.515.024-.296.025-.68.025-1.253v-4.1c0-.572 0-.957-.025-1.253-.023-.287-.065-.424-.111-.514a1.25 1.25 0 0 0-.546-.547c-.091-.046-.228-.088-.515-.111-.296-.024-.68-.025-1.253-.025h-8.1c-.572 0-.957 0-1.253.025ZM4.75 7a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0v-4.5A.75.75 0 0 1 4.75 7Zm4 0a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0v-4.5A.75.75 0 0 1 8.75 7Zm9.5 1a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0v-2.5a.75.75 0 0 1 .75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, fwe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="bell">
    <path fill-rule="evenodd" d="M4.56 5.176C4.806 2.703 6.924 1 9.366 1h1.268c2.442 0 4.56 1.703 4.806 4.176v.004l.423 4.496v.002c.14 1.393.741 2.799 1.69 3.808.52.551.524 1.315.323 1.862-.202.548-.72 1.152-1.535 1.152h-3.383a3 3 0 0 1-5.917 0H3.66c-.815 0-1.333-.604-1.535-1.152-.201-.547-.197-1.31.322-1.862.95-1.009 1.551-2.415 1.69-3.808l.424-4.502ZM16.34 15h.007c.002-.002.01-.005.023-.016a.483.483 0 0 0 .127-.375c-.008-.06-.026-.085-.035-.095-1.197-1.27-1.923-2.995-2.091-4.69V9.82l-.424-4.496v-.002C13.784 3.698 12.389 2.5 10.634 2.5H9.365c-1.755 0-3.15 1.198-3.313 2.822v.002l-.424 4.5c-.168 1.695-.895 3.42-2.09 4.69-.01.01-.028.036-.036.095a.482.482 0 0 0 .127.375.086.086 0 0 0 .023.015l.006.001H16.34Zm-7.755 1.5a1.5 1.5 0 0 0 2.83 0h-2.83Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, vwe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="block">
    <path fill-rule="evenodd" d="M10 2.5a7.5 7.5 0 0 0-5.807 12.246L14.746 4.193A7.469 7.469 0 0 0 10 2.5Zm5.807 2.753L5.253 15.807A7.5 7.5 0 0 0 15.807 5.253ZM1 10a9 9 0 1 1 18 0 9 9 0 0 1-18 0Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, mwe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="bluetooth-off">
    <path fill-rule="evenodd" d="M9.443 1.066a.75.75 0 0 1 .805.123l4.5 4a.75.75 0 0 1 .032 1.091l-2 2a.75.75 0 1 1-1.06-1.06l1.437-1.438L10.5 3.42v2.33a.75.75 0 0 1-1.5 0v-4a.75.75 0 0 1 .443-.684Zm-8.24 1.17a.75.75 0 0 1 1.061-.032l7.991 7.521 4.489 3.96.002.003 3.998 3.498a.75.75 0 1 1-.988 1.128l-3.502-3.064-4.006 3.56A.75.75 0 0 1 9 18.25v-6.867l-2.754 2.43a.75.75 0 0 1-.992-1.125L8.33 9.973 1.236 3.296a.75.75 0 0 1-.032-1.06Zm9.297 9.705v4.639l2.619-2.328-2.619-2.31Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Cwe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="bluetooth">
    <path fill-rule="evenodd" d="M9.443 1.066a.75.75 0 0 1 .805.123l4.5 4a.75.75 0 0 1-.002 1.123L10.566 10l4.18 3.688a.75.75 0 0 1 .002 1.123l-4.5 4A.75.75 0 0 1 9 18.25v-6.867l-2.754 2.43a.75.75 0 0 1-.992-1.125L8.3 10 5.254 7.312a.75.75 0 1 1 .992-1.124L9 8.618V1.75a.75.75 0 0 1 .443-.684ZM10.5 11.94l2.619 2.311L10.5 16.58v-4.64Zm0-3.882V3.42l2.619 2.328-2.619 2.31Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, wwe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="bolt">
    <path fill-rule="evenodd" d="M11.261 1.047a.75.75 0 0 1 .485.784L11.186 7h5.064a.75.75 0 0 1 .624 1.166l-7 10.5a.75.75 0 0 1-1.371-.478L8.935 13H3.75a.75.75 0 0 1-.617-1.176l7.25-10.5a.75.75 0 0 1 .879-.277ZM5.18 11.5h4.57a.75.75 0 0 1 .747.812l-.258 3.103 4.61-6.915H10.35a.75.75 0 0 1-.746-.83l.332-3.058L5.179 11.5Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, bwe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="book">
    <path fill-rule="evenodd" d="M7.36 3.62a9.258 9.258 0 0 0-2.97 0c-.344.055-.688.138-1.453.324a7.409 7.409 0 0 0-.298.078.25.25 0 0 0-.133.17 7.372 7.372 0 0 0-.006.307v11.32a9.442 9.442 0 0 0 .003.225.25.25 0 0 0 .31.204c.04-.008.093-.021.18-.042l.015-.004c.333-.08.519-.126.705-.164a10.757 10.757 0 0 1 4.324 0c.186.038.372.084.705.164l.508.123V4.05l-.437-.105c-.765-.186-1.11-.269-1.453-.324Zm3.39.43v12.275l.508-.123c.333-.08.519-.126.705-.164a10.757 10.757 0 0 1 4.324 0c.186.038.372.084.705.164l.015.004c.087.02.14.034.18.042l.037.008a.25.25 0 0 0 .275-.253l.001-.184V4.5a7.262 7.262 0 0 0-.006-.308.25.25 0 0 0-.133-.17 7.358 7.358 0 0 0-.298-.078c-.765-.185-1.11-.268-1.453-.323a9.257 9.257 0 0 0-2.97 0c-.344.055-.688.138-1.453.324l-.437.106ZM4.149 2.139a10.758 10.758 0 0 1 3.452 0c.407.066.81.164 1.531.339l.67.162.144.034.03.005a.251.251 0 0 0 .048 0l.03-.005.144-.034.67-.162c.722-.175 1.124-.273 1.531-.339a10.758 10.758 0 0 1 3.452 0c.407.066.81.164 1.531.339l.034.008.047.011c.185.045.38.091.552.175.482.234.83.677.945 1.2.04.188.04.388.04.578v11.406c0 .132 0 .268-.016.386a1.75 1.75 0 0 1-1.915 1.506 2.988 2.988 0 0 1-.38-.076l-.035-.008a20.3 20.3 0 0 0-.668-.156 9.26 9.26 0 0 0-3.722 0 20.3 20.3 0 0 0-.668.156l-1.044.253a10.96 10.96 0 0 1-.027.006c-.112.027-.23.056-.355.068a1.748 1.748 0 0 1-.34 0 2.426 2.426 0 0 1-.355-.068 10.88 10.88 0 0 1-.027-.006l-1.044-.253a20.319 20.319 0 0 0-.668-.156 9.26 9.26 0 0 0-3.722 0c-.157.032-.316.07-.668.156l-.036.008c-.128.032-.26.064-.38.076a1.75 1.75 0 0 1-1.914-1.506C1 16.125 1 15.989 1 15.857V4.449c0-.189 0-.389.04-.576a1.75 1.75 0 0 1 .945-1.201c.173-.084.367-.13.551-.175l.048-.011.034-.008c.722-.175 1.124-.273 1.53-.339Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, ywe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="bookmark">
    <path fill-rule="evenodd" d="M3 3.75A2.75 2.75 0 0 1 5.75 1h8.5A2.75 2.75 0 0 1 17 3.75v14.5a.75.75 0 0 1-1.075.676l-5.384-2.584a1.25 1.25 0 0 0-1.082 0l-5.384 2.584A.75.75 0 0 1 3 18.25V3.75ZM5.75 2.5c-.69 0-1.25.56-1.25 1.25v13.308l4.31-2.069a2.75 2.75 0 0 1 2.38 0l4.31 2.07V3.75c0-.69-.56-1.25-1.25-1.25h-8.5Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, _we = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="border-all">
    <path fill-rule="evenodd" d="M3.324 1h13.352c.258 0 .494 0 .692.016.213.018.446.057.677.175.329.168.596.435.764.765.118.23.157.463.175.676.016.198.016.434.016.692v13.352c0 .258 0 .494-.016.692a1.775 1.775 0 0 1-.175.677 1.75 1.75 0 0 1-.765.764 1.77 1.77 0 0 1-.676.175c-.198.016-.434.016-.692.016H3.324c-.258 0-.494 0-.692-.016a1.775 1.775 0 0 1-.676-.175 1.75 1.75 0 0 1-.765-.765 1.774 1.774 0 0 1-.175-.676C1 17.17 1 16.934 1 16.676V3.324c0-.258 0-.494.016-.692a1.77 1.77 0 0 1 .175-.676 1.75 1.75 0 0 1 .765-.765 1.77 1.77 0 0 1 .676-.175C2.83 1 3.066 1 3.324 1ZM2.5 10.75v5.9c0 .292 0 .467.011.596a.625.625 0 0 0 .018.12.25.25 0 0 0 .104.105.638.638 0 0 0 .121.018c.13.01.304.011.596.011h5.9v-6.75H2.5Zm6.75-1.5H2.5v-5.9c0-.292 0-.467.011-.596a.626.626 0 0 1 .018-.12.25.25 0 0 1 .104-.105.626.626 0 0 1 .121-.018c.13-.01.304-.011.596-.011h5.9v6.75Zm1.5 1.5v6.75h5.9c.292 0 .467 0 .596-.011a.636.636 0 0 0 .12-.018.25.25 0 0 0 .105-.105.636.636 0 0 0 .018-.12c.01-.13.011-.304.011-.596v-5.9h-6.75Zm6.75-1.5h-6.75V2.5h5.9c.292 0 .467 0 .596.011a.625.625 0 0 1 .12.018.25.25 0 0 1 .105.104.638.638 0 0 1 .018.121c.01.13.011.304.011.596v5.9Zm-.03-6.62v.002-.001Zm-.1-.1h-.002.001Zm0 14.94h-.002.001ZM2.63 2.53h.002-.001Zm-.1.102a.01.01 0 0 1 0-.001v.001Zm.1 14.838h.002-.001Zm-.1-.1v-.002.001Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Swe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="border-bottom">
    <path fill-rule="evenodd" d="M3.324 1H5.25a.75.75 0 1 1 0 1.5h-1.9c-.292 0-.467 0-.596.011a.626.626 0 0 0-.12.018.25.25 0 0 0-.105.104.626.626 0 0 0-.018.121c-.01.13-.011.304-.011.596v1.9a.75.75 0 1 1-1.5 0V3.324c0-.258 0-.494.016-.692a1.77 1.77 0 0 1 .175-.676 1.75 1.75 0 0 1 .765-.765 1.77 1.77 0 0 1 .676-.175C2.83 1 3.066 1 3.324 1ZM2.53 2.63v.002-.001Zm.1-.1h.002-.001Zm14.616-.019a8.336 8.336 0 0 0-.596-.011h-1.9a.75.75 0 0 1 0-1.5h1.926c.258 0 .494 0 .692.016.213.018.446.057.677.175.329.168.596.435.764.765.118.23.157.463.175.676.016.198.016.434.016.692V5.25a.75.75 0 0 1-1.5 0v-1.9c0-.292 0-.467-.011-.596a.638.638 0 0 0-.018-.12.25.25 0 0 0-.105-.105.625.625 0 0 0-.12-.018Zm.123.019h-.001.001Zm.101.1v.002-.001ZM8 1.75A.75.75 0 0 1 8.75 1h2.5a.75.75 0 0 1 0 1.5h-2.5A.75.75 0 0 1 8 1.75Zm2 5a.75.75 0 0 1 .75.75v1.75h1.75a.75.75 0 0 1 0 1.5h-1.75v1.75a.75.75 0 0 1-1.5 0v-1.75H7.5a.75.75 0 0 1 0-1.5h1.75V7.5a.75.75 0 0 1 .75-.75ZM1.75 8a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0v-2.5A.75.75 0 0 1 1.75 8Zm16.5 0a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0v-2.5a.75.75 0 0 1 .75-.75ZM1 18.25a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H1.75a.75.75 0 0 1-.75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, xwe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="border-horizontal">
    <path fill-rule="evenodd" d="M3.324 1H5.25a.75.75 0 1 1 0 1.5h-1.9c-.292 0-.467 0-.596.011a.626.626 0 0 0-.12.018.25.25 0 0 0-.105.104.626.626 0 0 0-.018.121c-.01.13-.011.304-.011.596v1.9a.75.75 0 1 1-1.5 0V3.324c0-.258 0-.494.016-.692a1.77 1.77 0 0 1 .175-.676 1.75 1.75 0 0 1 .765-.765 1.77 1.77 0 0 1 .676-.175C2.83 1 3.066 1 3.324 1ZM2.53 2.63v.002-.001Zm.1-.1h.002-.001Zm14.616-.019a8.336 8.336 0 0 0-.596-.011h-1.9a.75.75 0 0 1 0-1.5h1.926c.258 0 .494 0 .692.016.213.018.446.057.677.175.329.168.596.435.764.765.118.23.157.463.175.676.016.198.016.434.016.692V5.25a.75.75 0 0 1-1.5 0v-1.9c0-.292 0-.467-.011-.596a.638.638 0 0 0-.018-.12.25.25 0 0 0-.105-.105.625.625 0 0 0-.12-.018Zm.123.019h-.001.001Zm.101.1v.002-.001ZM8 1.75A.75.75 0 0 1 8.75 1h2.5a.75.75 0 0 1 0 1.5h-2.5A.75.75 0 0 1 8 1.75ZM1 10a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H1.75A.75.75 0 0 1 1 10Zm.75 4a.75.75 0 0 1 .75.75v1.9c0 .292 0 .467.011.596a.625.625 0 0 0 .018.12.25.25 0 0 0 .104.105.638.638 0 0 0 .121.018c.13.01.304.011.596.011h1.9a.75.75 0 0 1 0 1.5H3.324c-.258 0-.494 0-.692-.016a1.775 1.775 0 0 1-.676-.175 1.75 1.75 0 0 1-.765-.765 1.774 1.774 0 0 1-.175-.676C1 17.17 1 16.934 1 16.676V14.75a.75.75 0 0 1 .75-.75Zm.88 3.47h.002-.001Zm-.1-.1v-.002.001ZM18.25 14a.75.75 0 0 1 .75.75v1.926c0 .258 0 .494-.016.692a1.775 1.775 0 0 1-.175.677 1.75 1.75 0 0 1-.765.764 1.77 1.77 0 0 1-.676.175c-.198.016-.434.016-.692.016H14.75a.75.75 0 0 1 0-1.5h1.9c.292 0 .467 0 .596-.011a.636.636 0 0 0 .12-.018.25.25 0 0 0 .105-.105.636.636 0 0 0 .018-.12c.01-.13.011-.304.011-.596v-1.9a.75.75 0 0 1 .75-.75Zm-.88 3.47h-.002.001ZM8 18.25a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Mwe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="border-inner">
    <path fill-rule="evenodd" d="M3.324 1H5.25a.75.75 0 1 1 0 1.5h-1.9c-.292 0-.467 0-.596.011a.626.626 0 0 0-.12.018.25.25 0 0 0-.105.104.626.626 0 0 0-.018.121c-.01.13-.011.304-.011.596v1.9a.75.75 0 1 1-1.5 0V3.324c0-.258 0-.494.016-.692a1.77 1.77 0 0 1 .175-.676 1.75 1.75 0 0 1 .765-.765 1.77 1.77 0 0 1 .676-.175C2.83 1 3.066 1 3.324 1ZM2.53 2.63v.002-.001Zm.1-.1h.002-.001Zm14.616-.019a8.336 8.336 0 0 0-.596-.011h-1.9a.75.75 0 0 1 0-1.5h1.926c.258 0 .494 0 .692.016.213.018.446.057.677.175.329.168.596.435.764.765.118.23.157.463.175.676.016.198.016.434.016.692V5.25a.75.75 0 0 1-1.5 0v-1.9c0-.292 0-.467-.011-.596a.638.638 0 0 0-.018-.12.25.25 0 0 0-.105-.105.625.625 0 0 0-.12-.018Zm.123.019h-.001.001Zm.101.1v.002-.001ZM10 2a.75.75 0 0 1 .75.75v6.5h6.5a.75.75 0 0 1 0 1.5h-6.5v6.5a.75.75 0 0 1-1.5 0v-6.5h-6.5a.75.75 0 0 1 0-1.5h6.5v-6.5A.75.75 0 0 1 10 2ZM1.75 14a.75.75 0 0 1 .75.75v1.9c0 .292 0 .467.011.596a.625.625 0 0 0 .018.12.25.25 0 0 0 .104.105.638.638 0 0 0 .121.018c.13.01.304.011.596.011h1.9a.75.75 0 0 1 0 1.5H3.324c-.258 0-.494 0-.692-.016a1.775 1.775 0 0 1-.676-.175 1.75 1.75 0 0 1-.765-.765 1.774 1.774 0 0 1-.175-.676C1 17.17 1 16.934 1 16.676V14.75a.75.75 0 0 1 .75-.75Zm.88 3.47h.002-.001Zm-.1-.1v-.002.001ZM18.25 14a.75.75 0 0 1 .75.75v1.926c0 .258 0 .494-.016.692a1.775 1.775 0 0 1-.175.677 1.75 1.75 0 0 1-.765.764 1.77 1.77 0 0 1-.676.175c-.198.016-.434.016-.692.016H14.75a.75.75 0 0 1 0-1.5h1.9c.292 0 .467 0 .596-.011a.636.636 0 0 0 .12-.018.25.25 0 0 0 .105-.105.636.636 0 0 0 .018-.12c.01-.13.011-.304.011-.596v-1.9a.75.75 0 0 1 .75-.75Zm-.88 3.47h-.002.001Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Awe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="border-left">
    <path fill-rule="evenodd" d="M17.246 2.511a8.336 8.336 0 0 0-.596-.011h-1.9a.75.75 0 0 1 0-1.5h1.926c.258 0 .494 0 .692.016.213.018.446.057.677.175.329.168.596.435.764.765.118.23.157.463.175.676.016.198.016.434.016.692V5.25a.75.75 0 0 1-1.5 0v-1.9c0-.292 0-.467-.011-.596a.638.638 0 0 0-.018-.12.25.25 0 0 0-.105-.105.625.625 0 0 0-.12-.018Zm.123.019h-.001.001Zm.101.1v.002-.001ZM1.75 1a.75.75 0 0 1 .75.75v16.5a.75.75 0 0 1-1.5 0V1.75A.75.75 0 0 1 1.75 1ZM8 1.75A.75.75 0 0 1 8.75 1h2.5a.75.75 0 0 1 0 1.5h-2.5A.75.75 0 0 1 8 1.75Zm2 5a.75.75 0 0 1 .75.75v1.75h1.75a.75.75 0 0 1 0 1.5h-1.75v1.75a.75.75 0 0 1-1.5 0v-1.75H7.5a.75.75 0 0 1 0-1.5h1.75V7.5a.75.75 0 0 1 .75-.75ZM18.25 8a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0v-2.5a.75.75 0 0 1 .75-.75Zm0 6a.75.75 0 0 1 .75.75v1.926c0 .258 0 .494-.016.692a1.775 1.775 0 0 1-.175.677 1.75 1.75 0 0 1-.765.764 1.77 1.77 0 0 1-.676.175c-.198.016-.434.016-.692.016H14.75a.75.75 0 0 1 0-1.5h1.9c.292 0 .467 0 .596-.011a.636.636 0 0 0 .12-.018.25.25 0 0 0 .105-.105.636.636 0 0 0 .018-.12c.01-.13.011-.304.011-.596v-1.9a.75.75 0 0 1 .75-.75Zm-.88 3.47h-.002.001ZM8 18.25a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Lwe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="border-right">
    <path fill-rule="evenodd" d="M3.324 1h.926a.75.75 0 1 1 0 1.5h-.9c-.292 0-.467 0-.596.011a.626.626 0 0 0-.12.018.25.25 0 0 0-.105.104.626.626 0 0 0-.018.121c-.01.13-.011.304-.011.596v.9a.75.75 0 1 1-1.5 0v-.926c0-.258 0-.494.016-.692a1.77 1.77 0 0 1 .175-.676 1.75 1.75 0 0 1 .765-.765 1.77 1.77 0 0 1 .676-.175C2.83 1 3.066 1 3.324 1ZM2.53 2.63v.002-.001Zm.1-.1h.002-.001ZM8 1.75A.75.75 0 0 1 8.75 1h2.5a.75.75 0 0 1 0 1.5h-2.5A.75.75 0 0 1 8 1.75ZM18.25 1a.75.75 0 0 1 .75.75v16.5a.75.75 0 0 1-1.5 0V1.75a.75.75 0 0 1 .75-.75ZM10 6.75a.75.75 0 0 1 .75.75v1.75h1.75a.75.75 0 0 1 0 1.5h-1.75v1.75a.75.75 0 0 1-1.5 0v-1.75H7.5a.75.75 0 0 1 0-1.5h1.75V7.5a.75.75 0 0 1 .75-.75ZM1.75 8a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0v-2.5A.75.75 0 0 1 1.75 8Zm0 7a.75.75 0 0 1 .75.75v.9c0 .292 0 .467.011.596a.625.625 0 0 0 .018.12.25.25 0 0 0 .104.105.638.638 0 0 0 .121.018c.13.01.304.011.596.011h.9a.75.75 0 0 1 0 1.5h-.926c-.258 0-.494 0-.692-.016a1.775 1.775 0 0 1-.676-.175 1.75 1.75 0 0 1-.765-.765 1.774 1.774 0 0 1-.175-.676C1 17.17 1 16.934 1 16.676v-.926a.75.75 0 0 1 .75-.75Zm.88 2.47h.002-.001Zm-.1-.1v-.002.001Zm5.47.88a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Ewe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="border-style">
    <path fill-rule="evenodd" d="M3.324 1H17.25a.75.75 0 0 1 0 1.5H3.35c-.292 0-.467 0-.596.011a.626.626 0 0 0-.12.018.25.25 0 0 0-.105.104.626.626 0 0 0-.018.121c-.01.13-.011.304-.011.596v13.9a.75.75 0 0 1-1.5 0V3.324c0-.258 0-.494.016-.692a1.77 1.77 0 0 1 .175-.676 1.75 1.75 0 0 1 .765-.765 1.77 1.77 0 0 1 .676-.175C2.83 1 3.066 1 3.324 1ZM2.53 2.63v.002-.001Zm.1-.1h.002-.001ZM10 6.75a.75.75 0 0 1 .75.75v1.75h1.75a.75.75 0 0 1 0 1.5h-1.75v1.75a.75.75 0 0 1-1.5 0v-1.75H7.5a.75.75 0 0 1 0-1.5h1.75V7.5a.75.75 0 0 1 .75-.75ZM18.25 8a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0v-2.5a.75.75 0 0 1 .75-.75Zm0 6a.75.75 0 0 1 .75.75v1.926c0 .258 0 .494-.016.692a1.775 1.775 0 0 1-.175.677 1.75 1.75 0 0 1-.765.764 1.77 1.77 0 0 1-.676.175c-.198.016-.434.016-.692.016H14.75a.75.75 0 0 1 0-1.5h1.9c.292 0 .467 0 .596-.011a.636.636 0 0 0 .12-.018.25.25 0 0 0 .105-.105.636.636 0 0 0 .018-.12c.01-.13.011-.304.011-.596v-1.9a.75.75 0 0 1 .75-.75Zm-.88 3.47h-.002.001ZM8 18.25a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Pwe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="border-top">
    <path fill-rule="evenodd" d="M1 1.75A.75.75 0 0 1 1.75 1h16.5a.75.75 0 0 1 0 1.5H1.75A.75.75 0 0 1 1 1.75Zm9 5a.75.75 0 0 1 .75.75v1.75h1.75a.75.75 0 0 1 0 1.5h-1.75v1.75a.75.75 0 0 1-1.5 0v-1.75H7.5a.75.75 0 0 1 0-1.5h1.75V7.5a.75.75 0 0 1 .75-.75ZM1.75 8a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0v-2.5A.75.75 0 0 1 1.75 8Zm16.5 0a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0v-2.5a.75.75 0 0 1 .75-.75Zm-16.5 6a.75.75 0 0 1 .75.75v1.9c0 .292 0 .467.011.596a.625.625 0 0 0 .018.12.25.25 0 0 0 .104.105.638.638 0 0 0 .121.018c.13.01.304.011.596.011h1.9a.75.75 0 0 1 0 1.5H3.324c-.258 0-.494 0-.692-.016a1.775 1.775 0 0 1-.676-.175 1.75 1.75 0 0 1-.765-.765 1.774 1.774 0 0 1-.175-.676C1 17.17 1 16.934 1 16.676V14.75a.75.75 0 0 1 .75-.75Zm.88 3.47h.002-.001Zm-.1-.1v-.002.001ZM18.25 14a.75.75 0 0 1 .75.75v1.926c0 .258 0 .494-.016.692a1.775 1.775 0 0 1-.175.677 1.75 1.75 0 0 1-.765.764 1.77 1.77 0 0 1-.676.175c-.198.016-.434.016-.692.016H14.75a.75.75 0 0 1 0-1.5h1.9c.292 0 .467 0 .596-.011a.636.636 0 0 0 .12-.018.25.25 0 0 0 .105-.105.636.636 0 0 0 .018-.12c.01-.13.011-.304.011-.596v-1.9a.75.75 0 0 1 .75-.75Zm-.88 3.47h-.002.001ZM8 18.25a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Rwe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="border-vertical">
    <path fill-rule="evenodd" d="M3.324 1H5.25a.75.75 0 1 1 0 1.5h-1.9c-.292 0-.467 0-.596.011a.626.626 0 0 0-.12.018.25.25 0 0 0-.105.104.626.626 0 0 0-.018.121c-.01.13-.011.304-.011.596v1.9a.75.75 0 1 1-1.5 0V3.324c0-.258 0-.494.016-.692a1.77 1.77 0 0 1 .175-.676 1.75 1.75 0 0 1 .765-.765 1.77 1.77 0 0 1 .676-.175C2.83 1 3.066 1 3.324 1ZM2.53 2.63v.002-.001Zm.1-.1h.002-.001Zm14.616-.019a8.336 8.336 0 0 0-.596-.011h-1.9a.75.75 0 0 1 0-1.5h1.926c.258 0 .494 0 .692.016.213.018.446.057.677.175.329.168.596.435.764.765.118.23.157.463.175.676.016.198.016.434.016.692V5.25a.75.75 0 0 1-1.5 0v-1.9c0-.292 0-.467-.011-.596a.638.638 0 0 0-.018-.12.25.25 0 0 0-.105-.105.625.625 0 0 0-.12-.018Zm.123.019h-.001.001Zm.101.1v.002-.001ZM10 1a.75.75 0 0 1 .75.75v16.5a.75.75 0 0 1-1.5 0V1.75A.75.75 0 0 1 10 1ZM1.75 8a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0v-2.5A.75.75 0 0 1 1.75 8Zm16.5 0a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0v-2.5a.75.75 0 0 1 .75-.75Zm-16.5 6a.75.75 0 0 1 .75.75v1.9c0 .292 0 .467.011.596a.625.625 0 0 0 .018.12.25.25 0 0 0 .104.105.638.638 0 0 0 .121.018c.13.01.304.011.596.011h1.9a.75.75 0 0 1 0 1.5H3.324c-.258 0-.494 0-.692-.016a1.775 1.775 0 0 1-.676-.175 1.75 1.75 0 0 1-.765-.765 1.774 1.774 0 0 1-.175-.676C1 17.17 1 16.934 1 16.676V14.75a.75.75 0 0 1 .75-.75Zm.88 3.47h.002-.001Zm-.1-.1v-.002.001ZM18.25 14a.75.75 0 0 1 .75.75v1.926c0 .258 0 .494-.016.692a1.775 1.775 0 0 1-.175.677 1.75 1.75 0 0 1-.765.764 1.77 1.77 0 0 1-.676.175c-.198.016-.434.016-.692.016H14.75a.75.75 0 0 1 0-1.5h1.9c.292 0 .467 0 .596-.011a.636.636 0 0 0 .12-.018.25.25 0 0 0 .105-.105.636.636 0 0 0 .018-.12c.01-.13.011-.304.011-.596v-1.9a.75.75 0 0 1 .75-.75Zm-.88 3.47h-.002.001Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Fwe = `<svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" fill="currentColor" viewBox="0 0 21 20">
  <g class="brackets-curly">
    <path fill-rule="evenodd" d="M8.75 2.5A2.5 2.5 0 0 0 6.25 5v.136c0 1.375 0 2.427-.292 3.267-.226.65-.609 1.142-1.16 1.597.551.454.934.947 1.16 1.597.293.84.292 1.892.292 3.267V15a2.5 2.5 0 0 0 2.5 2.5H9A.75.75 0 0 1 9 19h-.25a4 4 0 0 1-4-4c0-1.558-.01-2.34-.208-2.91-.167-.477-.492-.862-1.44-1.454a.75.75 0 0 1 0-1.272c.948-.592 1.273-.977 1.44-1.454.198-.57.208-1.352.208-2.91a4 4 0 0 1 4-4H9a.75.75 0 0 1 0 1.5h-.25Zm3-.75A.75.75 0 0 1 12.5 1h.25a4 4 0 0 1 4 4c0 1.558.01 2.34.208 2.91.167.477.492.862 1.44 1.454a.75.75 0 0 1 0 1.272c-.948.592-1.273.977-1.44 1.454-.198.57-.208 1.352-.208 2.91a4 4 0 0 1-4 4h-.25a.75.75 0 0 1 0-1.5h.25a2.5 2.5 0 0 0 2.5-2.5v-.136c0-1.376 0-2.427.292-3.267.226-.65.609-1.143 1.16-1.597-.551-.455-.934-.947-1.16-1.597-.293-.84-.292-1.892-.292-3.267V5a2.5 2.5 0 0 0-2.5-2.5h-.25a.75.75 0 0 1-.75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Twe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="brain">
    <path fill-rule="evenodd" d="M7.62 2.5a1.62 1.62 0 0 0-1.61 1.367.75.75 0 0 1-.74.633h-.15a1.63 1.63 0 0 0-1.63 1.63c0 .229.05.458.13.645a.75.75 0 0 1-.315.944A1.62 1.62 0 0 0 2.5 9.13c0 .323.095.627.257.88a3.615 3.615 0 0 1 1.869-.52c.062-.213.147-.42.255-.612A3.124 3.124 0 0 1 4.5 7.38c0-.517.187-1.001.432-1.382.243-.378.587-.72.983-.919a.75.75 0 0 1 .67 1.342c-.104.052-.26.184-.392.389A1.1 1.1 0 0 0 6 7.38c0 .132.016.26.045.383A2.762 2.762 0 0 1 7.25 7.5a.75.75 0 0 1 0 1.5C6.5 9 6 9.572 6 10.37c0 .436.168.924.666 1.256a.75.75 0 1 1-.832 1.248 2.927 2.927 0 0 1-1.271-1.883 2.12 2.12 0 0 0-1.374.561l-.01.009A2.123 2.123 0 0 0 2.5 13.13c0 1.18.948 2.13 2.12 2.13.026 0 .108-.004.218-.016a2.6 2.6 0 0 0 .25-.036.75.75 0 0 1 .912.715c.02.886.711 1.577 1.62 1.577a1.62 1.62 0 0 0 1.63-1.62v-1.63c-.545 0-.842.112-.994.237-.122.1-.256.294-.256.763a.75.75 0 0 1-1.5 0c0-.78.241-1.462.806-1.924.536-.438 1.24-.576 1.944-.576V4.13A1.63 1.63 0 0 0 7.62 2.5ZM10 2.097A3.126 3.126 0 0 0 7.62 1a3.12 3.12 0 0 0-2.933 2.03 3.13 3.13 0 0 0-2.63 3.748A3.125 3.125 0 0 0 1 9.13c0 .715.242 1.383.652 1.914A3.627 3.627 0 0 0 1 13.13c0 2 1.612 3.63 3.62 3.63h.002A3.09 3.09 0 0 0 7.62 19 3.13 3.13 0 0 0 10 17.91 3.131 3.131 0 0 0 12.38 19a3.116 3.116 0 0 0 2.932-2.02 3.13 3.13 0 0 0 2.63-3.748A3.124 3.124 0 0 0 19 10.88a3.13 3.13 0 0 0-.652-1.914c.413-.591.652-1.31.652-2.086 0-2-1.612-3.63-3.62-3.63h-.002A3.094 3.094 0 0 0 12.38 1 3.12 3.12 0 0 0 10 2.097Zm6.82 6.352a2.12 2.12 0 0 0 .68-1.569c0-1.18-.948-2.13-2.12-2.13-.026 0-.108.004-.218.016a2.5 2.5 0 0 0-.25.036.75.75 0 0 1-.912-.715A1.602 1.602 0 0 0 12.38 2.5a1.63 1.63 0 0 0-1.63 1.63v1.63c.545 0 .842-.112.994-.237.122-.1.256-.294.256-.763a.75.75 0 0 1 1.5 0c0 .78-.241 1.462-.806 1.924-.536.438-1.24.576-1.944.576v8.62c0 .9.728 1.62 1.63 1.62.822 0 1.487-.583 1.61-1.357a.75.75 0 0 1 .74-.633h.15a1.63 1.63 0 0 0 1.63-1.63c0-.229-.05-.458-.13-.645a.75.75 0 0 1 .315-.944 1.62 1.62 0 0 0 .805-1.411c0-.323-.095-.627-.257-.88a3.612 3.612 0 0 1-1.869.52c-.062.213-.148.42-.255.612.242.444.381.954.381 1.498 0 .517-.187 1.001-.432 1.382-.243.378-.587.72-.983.919a.75.75 0 1 1-.67-1.342c.104-.052.26-.184.392-.389a1.1 1.1 0 0 0 .193-.57c0-.132-.016-.26-.045-.383a2.761 2.761 0 0 1-1.205.263.75.75 0 0 1 0-1.5c.75 0 1.25-.572 1.25-1.37 0-.436-.168-.924-.666-1.256a.75.75 0 1 1 .832-1.248 2.927 2.927 0 0 1 1.271 1.883 2.119 2.119 0 0 0 1.374-.561l.01-.009Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Iwe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="broadcast">
    <path fill-rule="evenodd" d="M4.734 2.177a.75.75 0 0 1 .089 1.057C3.559 4.728 3 6.37 3 8s.559 3.272 1.823 4.765a.75.75 0 0 1-1.146.97C2.191 11.978 1.5 9.995 1.5 8s.691-3.978 2.177-5.734a.75.75 0 0 1 1.057-.089Zm10.531 0a.75.75 0 0 1 1.058.089C17.809 4.022 18.5 6.006 18.5 8c0 1.995-.691 3.978-2.177 5.735a.75.75 0 0 1-1.146-.97C16.442 11.272 17 9.63 17 8s-.559-3.272-1.823-4.766a.75.75 0 0 1 .088-1.057ZM7.874 5.334a.75.75 0 0 1-.208 1.04C7.228 6.666 7 7.344 7 8c0 .656.228 1.334.666 1.626a.75.75 0 1 1-.832 1.248C5.772 10.166 5.5 8.844 5.5 8c0-.844.272-2.166 1.334-2.874a.75.75 0 0 1 1.04.208Zm4.252 0a.75.75 0 0 1 1.04-.208C14.228 5.834 14.5 7.156 14.5 8c0 .844-.272 2.166-1.334 2.874a.75.75 0 1 1-.832-1.248C12.772 9.334 13 8.656 13 8c0-.656-.228-1.334-.666-1.626a.75.75 0 0 1-.208-1.04ZM10 7a.75.75 0 0 1 .75.75v.5a.75.75 0 0 1-1.5 0v-.5A.75.75 0 0 1 10 7Zm0 4a.75.75 0 0 1 .75.75v5.5a.75.75 0 0 1-1.5 0v-5.5A.75.75 0 0 1 10 11Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Dwe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="brush">
    <path d="M11.25 13a.757.757 0 0 1-.75-.75c0-.02-.03-.72-.78-1.47S8.27 10 8.24 10a.761.761 0 0 1-.52-1.29l6.98-6.97c.48-.48 1.11-.74 1.78-.74C17.87 1 19 2.13 19 3.52c0 .67-.23 1.28-.66 1.75l-6.53 7.48c-.15.17-.35.26-.56.26V13ZM9.67 8.9c.35.18.73.44 1.12.82.35.35.6.71.78 1.03l5.66-6.48c.18-.2.28-.45.28-.72 0-.6-.46-1.06-1.02-1.06-.27 0-.53.11-.72.3l-6.1 6.1v.01ZM4.25 19c-1.66 0-2.79-.56-2.84-.58A.735.735 0 0 1 1 17.8c-.02-.27.11-.52.33-.67.48-.32 1.17-1 1.17-1.38v-1C2.5 12.68 4.18 11 6.25 11 8.42 11 10 12.58 10 14.75c0 1.97-1.3 3.31-2.51 3.71-.9.3-1.61.54-3.24.54Zm-.99-1.58c.29.05.62.08.99.08 1.38 0 1.9-.17 2.76-.46.6-.2 1.49-.97 1.49-2.29s-.9-2.25-2.25-2.25C5.01 12.5 4 13.51 4 14.75v1c0 .63-.35 1.21-.74 1.67Z" class="Icon"/>
  </g>
</svg>
`, kwe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="bug">
    <path fill-rule="evenodd" d="M7.415 1.08a.75.75 0 0 1 1.006.335L8.964 2.5h2.072l.543-1.085a.75.75 0 1 1 1.342.67l-.37.741A2.75 2.75 0 0 1 14 5.25V6.5h.5a1 1 0 0 1 1 1A1.5 1.5 0 0 0 17 6v-.25a.75.75 0 0 1 1.5 0V6a3 3 0 0 1-3 3v1h2.75a.75.75 0 0 1 0 1.5H15.5v1a3 3 0 0 1 3 3v.75a.75.75 0 0 1-1.5 0v-.75a1.5 1.5 0 0 0-1.522-1.5 5.5 5.5 0 0 1-10.956 0H4.5A1.5 1.5 0 0 0 3 15.5v.75a.75.75 0 1 1-1.5 0v-.75a3 3 0 0 1 3-3v-1H1.75a.75.75 0 0 1 0-1.5H4.5V9a3 3 0 0 1-3-3v-.25a.75.75 0 1 1 1.5 0V6a1.5 1.5 0 0 0 1.5 1.5 1 1 0 0 1 1-1H6V5.25a2.75 2.75 0 0 1 1.45-2.424l-.37-.74a.75.75 0 0 1 .335-1.007ZM7.5 6.5h5V5.25c0-.69-.56-1.25-1.25-1.25h-2.5c-.69 0-1.25.56-1.25 1.25V6.5ZM9.25 8v4.25a.75.75 0 0 0 1.5 0V8H14v5.5a4 4 0 0 1-8 0V8h3.25Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Hwe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="bulb">
    <path fill-rule="evenodd" d="M4 7a6 6 0 1 1 12 0v.493a5.902 5.902 0 0 1-2.628 4.91.835.835 0 0 0-.372.695v1.584C13 15.41 12.41 16 11.682 16H8.318C7.59 16 7 15.41 7 14.682v-1.584c0-.279-.14-.54-.372-.695A5.902 5.902 0 0 1 4 7.493V7Zm6-4.5A4.5 4.5 0 0 0 5.5 7v.493c0 1.472.736 2.846 1.96 3.662a2.335 2.335 0 0 1 1.04 1.943V14.5h3v-1.402c0-.78.39-1.51 1.04-1.943a4.402 4.402 0 0 0 1.96-3.662V7A4.5 4.5 0 0 0 10 2.5ZM8 18.25a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Vwe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="calculator">
    <path fill-rule="evenodd" d="M2.5 3.75A2.75 2.75 0 0 1 5.25 1h9.5a2.75 2.75 0 0 1 2.75 2.75v12.5A2.75 2.75 0 0 1 14.75 19h-9.5a2.75 2.75 0 0 1-2.75-2.75V3.75ZM5.25 2.5C4.56 2.5 4 3.06 4 3.75V5.5h12V3.75c0-.69-.56-1.25-1.25-1.25h-9.5ZM16 7H4v9.25c0 .69.56 1.25 1.25 1.25h9.5c.69 0 1.25-.56 1.25-1.25V7ZM6 9.25a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5A.75.75 0 0 1 6 9.25Zm3 0a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5A.75.75 0 0 1 9 9.25Zm3 0a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75Zm-6 3a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75Zm3 0a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75Zm3 0a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75Zm-6 3a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75Zm3 0a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75Zm3 0a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Owe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="calendar-check" clip-path="url(#a)">
    <path fill-rule="evenodd" d="M6.75 1a.75.75 0 0 1 .75.75V3h5V1.75a.75.75 0 0 1 1.5 0V3h2.25A2.75 2.75 0 0 1 19 5.75v3a.75.75 0 0 1-.75.75H2.5v6.75c0 .69.56 1.25 1.25 1.25h5a.75.75 0 0 1 0 1.5h-5A2.75 2.75 0 0 1 1 16.25V5.75A2.75 2.75 0 0 1 3.75 3H6V1.75A.75.75 0 0 1 6.75 1ZM6 4.5H3.75c-.69 0-1.25.56-1.25 1.25V8h15V5.75c0-.69-.56-1.25-1.25-1.25H14v.75a.75.75 0 0 1-1.5 0V4.5h-5v.75a.75.75 0 0 1-1.5 0V4.5Zm13.765 8.705a.75.75 0 0 1 .03 1.06l-4.25 4.5a.75.75 0 0 1-1.102-.013l-2.25-2.5a.75.75 0 1 1 1.114-1.004l1.706 1.896 3.692-3.909a.75.75 0 0 1 1.06-.03Z" class="Icon" clip-rule="evenodd"/>
  </g>
  <defs>
    <clipPath id="a" class="a">
      <path d="M0 0h20v20H0z"/>
    </clipPath>
  </defs>
</svg>
`, Bwe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="calendar-close">
    <path fill-rule="evenodd" d="M6.75 1a.75.75 0 0 1 .75.75V3h5V1.75a.75.75 0 0 1 1.5 0V3h2.25A2.75 2.75 0 0 1 19 5.75v3a.75.75 0 0 1-.75.75H2.5v6.75c0 .69.56 1.25 1.25 1.25h5a.75.75 0 0 1 0 1.5h-5A2.75 2.75 0 0 1 1 16.25V5.75A2.75 2.75 0 0 1 3.75 3H6V1.75A.75.75 0 0 1 6.75 1ZM6 4.5H3.75c-.69 0-1.25.56-1.25 1.25V8h15V5.75c0-.69-.56-1.25-1.25-1.25H14v.75a.75.75 0 0 1-1.5 0V4.5h-5v.75a.75.75 0 0 1-1.5 0V4.5Zm7.22 8.72a.75.75 0 0 1 1.06 0L16 14.94l1.72-1.72a.75.75 0 1 1 1.06 1.06L17.06 16l1.72 1.72a.75.75 0 1 1-1.06 1.06L16 17.06l-1.72 1.72a.75.75 0 1 1-1.06-1.06L14.94 16l-1.72-1.72a.75.75 0 0 1 0-1.06Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, $we = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="calendar-edit">
    <path fill-rule="evenodd" d="M6.75 1a.75.75 0 0 1 .75.75V3h5V1.75a.75.75 0 0 1 1.5 0V3h2.25A2.75 2.75 0 0 1 19 5.75v3a.75.75 0 0 1-.75.75H2.5v6.75c0 .69.56 1.25 1.25 1.25h5a.75.75 0 0 1 0 1.5h-5A2.75 2.75 0 0 1 1 16.25V5.75A2.75 2.75 0 0 1 3.75 3H6V1.75A.75.75 0 0 1 6.75 1ZM6 4.5H3.75c-.69 0-1.25.56-1.25 1.25V8h15V5.75c0-.69-.56-1.25-1.25-1.25H14v.75a.75.75 0 0 1-1.5 0V4.5h-5v.75a.75.75 0 0 1-1.5 0V4.5Zm12.286 9.214a.73.73 0 0 0-1.033 0L13.5 17.467V18.5h1.033l3.753-3.753a.73.73 0 0 0 0-1.033Zm-2.094-1.06a2.23 2.23 0 1 1 3.155 3.154l-3.973 3.972a.75.75 0 0 1-.53.22H12.75a.75.75 0 0 1-.75-.75v-2.094a.75.75 0 0 1 .22-.53l3.972-3.973Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Zwe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="calendar-minus">
    <path fill-rule="evenodd" d="M6.75 1a.75.75 0 0 1 .75.75V3h5V1.75a.75.75 0 0 1 1.5 0V3h2.25A2.75 2.75 0 0 1 19 5.75v3a.75.75 0 0 1-.75.75H2.5v6.75c0 .69.56 1.25 1.25 1.25h5a.75.75 0 0 1 0 1.5h-5A2.75 2.75 0 0 1 1 16.25V5.75A2.75 2.75 0 0 1 3.75 3H6V1.75A.75.75 0 0 1 6.75 1ZM6 4.5H3.75c-.69 0-1.25.56-1.25 1.25V8h15V5.75c0-.69-.56-1.25-1.25-1.25H14v.75a.75.75 0 0 1-1.5 0V4.5h-5v.75a.75.75 0 0 1-1.5 0V4.5Zm6 11.25a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Gwe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="calendar-plus">
    <path fill-rule="evenodd" d="M6.75 1a.75.75 0 0 1 .75.75V3h5V1.75a.75.75 0 0 1 1.5 0V3h2.25A2.75 2.75 0 0 1 19 5.75v3a.75.75 0 0 1-.75.75H2.5v6.75c0 .69.56 1.25 1.25 1.25h5a.75.75 0 0 1 0 1.5h-5A2.75 2.75 0 0 1 1 16.25V5.75A2.75 2.75 0 0 1 3.75 3H6V1.75A.75.75 0 0 1 6.75 1ZM6 4.5H3.75c-.69 0-1.25.56-1.25 1.25V8h15V5.75c0-.69-.56-1.25-1.25-1.25H14v.75a.75.75 0 0 1-1.5 0V4.5h-5v.75a.75.75 0 0 1-1.5 0V4.5ZM16 12a.75.75 0 0 1 .75.75v2.5h2.5a.75.75 0 0 1 0 1.5h-2.5v2.5a.75.75 0 0 1-1.5 0v-2.5h-2.5a.75.75 0 0 1 0-1.5h2.5v-2.5A.75.75 0 0 1 16 12Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Nwe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="calendar">
    <path fill-rule="evenodd" d="M6.75 1a.75.75 0 0 1 .75.75V3h5V1.75a.75.75 0 0 1 1.5 0V3h2.25A2.75 2.75 0 0 1 19 5.75v10.5A2.75 2.75 0 0 1 16.25 19H3.75A2.75 2.75 0 0 1 1 16.25V5.75A2.75 2.75 0 0 1 3.75 3H6V1.75A.75.75 0 0 1 6.75 1ZM6 4.5H3.75c-.69 0-1.25.56-1.25 1.25V8h15V5.75c0-.69-.56-1.25-1.25-1.25H14v.75a.75.75 0 0 1-1.5 0V4.5h-5v.75a.75.75 0 0 1-1.5 0V4.5Zm11.5 5h-15v6.75c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25V9.5Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, zwe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="camera">
    <path fill-rule="evenodd" d="M8.667 2h2.666c.284 0 .588-.002.87.096.245.084.468.222.654.404.213.208.348.48.474.735l.032.064.35.701h1.367c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 18.7 5.502c.172.337.24.693.27 1.073.03.365.03.81.03 1.345v6.16c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073a2.751 2.751 0 0 1-1.2 1.202c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03H4.92c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 1.3 16.5c-.172-.338-.24-.694-.27-1.074C1 15.06 1 14.615 1 14.08V7.92c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 2.502 4.3c.337-.172.693-.24 1.073-.27C3.94 4 4.385 4 4.92 4h1.366l.351-.701a27.5 27.5 0 0 0 .032-.064c.126-.255.262-.527.475-.735a1.75 1.75 0 0 1 .653-.404c.282-.098.586-.097.87-.096Zm-.383 1.514h.002-.002Zm.078-.009a.504.504 0 0 0-.076.009.25.25 0 0 0-.092.057.503.503 0 0 0-.042.064c-.04.07-.09.166-.173.335L7.42 5.085a.75.75 0 0 1-.671.415h-1.8c-.572 0-.957 0-1.253.025-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.547c-.046.09-.088.227-.111.514-.024.296-.025.68-.025 1.253v6.1c0 .572 0 .957.025 1.252.023.288.065.425.111.516.12.235.311.426.547.546.09.046.227.088.514.111.296.024.68.025 1.253.025h10.1c.572 0 .957 0 1.252-.025.288-.023.425-.065.515-.111a1.25 1.25 0 0 0 .547-.546c.046-.091.088-.228.111-.515.024-.296.025-.68.025-1.253v-6.1c0-.572 0-.957-.025-1.253-.023-.287-.065-.424-.111-.514a1.25 1.25 0 0 0-.547-.547c-.09-.046-.227-.088-.515-.111-.295-.024-.68-.025-1.252-.025h-1.8a.75.75 0 0 1-.67-.415L12.02 3.97a6.822 6.822 0 0 0-.173-.335.485.485 0 0 0-.042-.064.25.25 0 0 0-.09-.057m-.002 0a.507.507 0 0 0-.076-.009 6.88 6.88 0 0 0-.377-.005H8.74c-.189 0-.296 0-.377.005m3.443.065.001.001V3.57Zm-3.61 0-.001.001V3.57ZM10 8.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5ZM6 11a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, jwe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="card">
    <path fill-rule="evenodd" d="M1 5.75A2.75 2.75 0 0 1 3.75 3h12.5A2.75 2.75 0 0 1 19 5.75v8.5A2.75 2.75 0 0 1 16.25 17H3.75A2.75 2.75 0 0 1 1 14.25v-8.5ZM3.75 4.5c-.69 0-1.25.56-1.25 1.25V8h15V5.75c0-.69-.56-1.25-1.25-1.25H3.75Zm13.75 5h-15v4.75c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25V9.5ZM4 12.75a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Wwe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="chart-bar-box">
    <path fill-rule="evenodd" d="M1 3.75A2.75 2.75 0 0 1 3.75 1h12.5A2.75 2.75 0 0 1 19 3.75v12.5A2.75 2.75 0 0 1 16.25 19H3.75A2.75 2.75 0 0 1 1 16.25V3.75ZM3.75 2.5c-.69 0-1.25.56-1.25 1.25v12.5c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25V3.75c0-.69-.56-1.25-1.25-1.25H3.75ZM10 5a.75.75 0 0 1 .75.75v8.5a.75.75 0 0 1-1.5 0v-8.5A.75.75 0 0 1 10 5ZM6.75 8a.75.75 0 0 1 .75.75v5.5a.75.75 0 0 1-1.5 0v-5.5A.75.75 0 0 1 6.75 8Zm6.5 2a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5a.75.75 0 0 1 .75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Uwe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="chart-bar">
    <path fill-rule="evenodd" d="M6.75 2.75C6.75 1.784 7.534 1 8.5 1h3c.966 0 1.75.784 1.75 1.75V10h3c.966 0 1.75.784 1.75 1.75v5.5A1.75 1.75 0 0 1 16.25 19H3.75A1.75 1.75 0 0 1 2 17.25v-9.5C2 6.784 2.784 6 3.75 6h3V2.75Zm0 4.75h-3a.25.25 0 0 0-.25.25v9.5c0 .138.112.25.25.25h3v-10Zm1.5 10h3.5V2.75a.25.25 0 0 0-.25-.25h-3a.25.25 0 0 0-.25.25V17.5Zm5 0h3a.25.25 0 0 0 .25-.25v-5.5a.25.25 0 0 0-.25-.25h-3v6Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Kwe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="chart-line">
    <path fill-rule="evenodd" d="M1.75 1a.75.75 0 0 1 .75.75v11.19l4.72-4.72a.75.75 0 0 1 .946-.094l3.947 2.631 5.568-6.495a.75.75 0 1 1 1.138.976l-6 7a.75.75 0 0 1-.985.136L7.846 9.715 2.5 15.061c0 .566 0 .948.025 1.241.023.288.065.425.111.515.12.236.311.427.547.547.09.046.227.088.514.111.296.024.68.025 1.253.025h12.3a.75.75 0 0 1 0 1.5H4.92c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 1.3 17.5c-.172-.338-.24-.694-.27-1.074C1 16.06 1 15.615 1 15.08V1.75A.75.75 0 0 1 1.75 1Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, qwe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="chart-pie">
    <path fill-rule="evenodd" d="M9 1.75A.75.75 0 0 1 9.75 1C14.72 1 19 5.28 19 10.25a.75.75 0 0 1-.75.75h-8.5a.75.75 0 0 1-.75-.75v-8.5Zm1.5.79V9.5h6.96c-.375-3.57-3.39-6.585-6.96-6.96Zm-3.06-.42a.75.75 0 0 1-.394.984A7.502 7.502 0 0 0 10 17.5a7.502 7.502 0 0 0 6.896-4.546.75.75 0 1 1 1.378.592 9 9 0 1 1-11.82-11.82.75.75 0 0 1 .985.393Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Ywe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="chat">
    <path fill-rule="evenodd" d="M8 2.5C4.835 2.5 2.5 4.632 2.5 7c0 .838.448 1.805 1.168 2.59l.006.005c.55.598.968 1.054 1.264 1.387.148.167.272.31.368.428.087.107.182.231.247.35l.039.07.064.119a1.448 1.448 0 0 1 .154.436l.024.133.014.079c.032.182.037.378.032.583.34-.36.695-.724.992-1.006.155-.146.307-.283.44-.387.066-.05.143-.107.224-.153l.003-.002c.05-.028.229-.132.461-.132 3.165 0 5.5-2.132 5.5-4.5S11.165 2.5 8 2.5ZM1 7c0-3.43 3.262-6 7-6s7 2.57 7 6c0 3.37-3.146 5.908-6.8 5.998a5.76 5.76 0 0 0-.297.266c-.281.266-.634.629-.985 1a70.088 70.088 0 0 0-1.244 1.357l-.084.094-.028.032a.75.75 0 0 1-1.31-.547l.078-1.17c.025-.376.042-.639.049-.838a1.87 1.87 0 0 0-.008-.332l-.018-.104-.016-.088-.002-.01a1.108 1.108 0 0 0-.047-.086 22.062 22.062 0 0 1-.052-.094c-.008-.01-.034-.048-.094-.122a11.898 11.898 0 0 0-.325-.378c-.287-.322-.697-.769-1.253-1.374C1.674 9.637 1 8.324 1 7Zm15.605.897a.75.75 0 0 1 1.06.038C18.49 8.821 19 9.963 19 11.222c0 1.014-.445 2.01-1.052 2.797-.55.71-.958 1.237-1.24 1.611-.141.188-.247.331-.321.437a2.962 2.962 0 0 0-.093.138 11.672 11.672 0 0 1-.079.163l-.002.017-.024.163c-.017.113-.008.326.038 1.026l.041.627a.75.75 0 0 1-1.313.543l-.001-.002-.023-.026-.07-.08a59.987 59.987 0 0 0-1.043-1.153 22.514 22.514 0 0 0-.823-.848 5.427 5.427 0 0 0-.211-.194 6.635 6.635 0 0 1-2.939-.774.75.75 0 1 1 .71-1.321 5.16 5.16 0 0 0 2.445.598c.23 0 .405.103.45.13l.004.001c.075.044.144.096.201.14.117.093.248.212.379.338.207.198.446.444.683.696l.008-.056.008-.058c.007-.046.018-.122.044-.207a1.36 1.36 0 0 1 .105-.248l.056-.117c.055-.116.143-.246.221-.358.09-.127.207-.286.351-.478a207.3 207.3 0 0 1 1.247-1.621l.004-.005c.469-.606.739-1.289.739-1.879 0-.838-.337-1.625-.933-2.265a.75.75 0 0 1 .038-1.06Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Qwe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="check-badge-fill">
    <path fill-rule="evenodd" d="M7.716 1.532a.75.75 0 0 0-.78.224L5.303 3.622l-2.332.931a.75.75 0 0 0-.472.696L2.496 7.57 1.13 9.576a.75.75 0 0 0 .02.871l1.346 1.803.004 2.501a.75.75 0 0 0 .471.695l2.333.934 1.632 1.864a.75.75 0 0 0 .711.241l2.35-.47 2.354.47a.75.75 0 0 0 .711-.241l1.632-1.864 2.332-.934a.75.75 0 0 0 .472-.695l.004-2.501 1.347-1.803a.75.75 0 0 0 .019-.871L17.502 7.57l-.004-2.321a.75.75 0 0 0-.472-.696l-2.332-.93-1.632-1.867a.75.75 0 0 0-.78-.224l-2.284.685-2.282-.685Zm6.05 6.762a.75.75 0 0 0-1.032-1.088l-4.26 4.035-1.236-1.06a.75.75 0 1 0-.976 1.138l1.75 1.5a.75.75 0 0 0 1.004-.025l4.75-4.5Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Jwe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="check-badge">
    <path fill-rule="evenodd" d="M6.935 1.756a.75.75 0 0 1 .78-.224l2.283.685 2.284-.685a.75.75 0 0 1 .78.224l1.632 1.866 2.332.931a.75.75 0 0 1 .472.696l.004 2.321 1.366 2.006a.75.75 0 0 1-.02.871l-1.346 1.803-.004 2.501a.75.75 0 0 1-.472.695l-2.332.934-1.632 1.864a.75.75 0 0 1-.711.241l-2.353-.47-2.35.47a.75.75 0 0 1-.712-.241L5.304 16.38l-2.333-.934a.75.75 0 0 1-.471-.695l-.004-2.501-1.347-1.803a.75.75 0 0 1-.019-.871L2.496 7.57 2.5 5.25a.75.75 0 0 1 .472-.696l2.332-.93 1.631-1.867Zm5.316 1.351-2.038.611a.75.75 0 0 1-.43 0l-2.036-.61-1.432 1.637a.75.75 0 0 1-.287.203L4 5.758l-.003 2.045a.75.75 0 0 1-.13.421L2.67 9.978l1.176 1.573a.75.75 0 0 1 .149.448l.003 2.243 2.03.812a.75.75 0 0 1 .285.202L7.78 16.93l2.072-.414a.747.747 0 0 1 .294 0l2.074.414 1.464-1.673a.75.75 0 0 1 .286-.202l2.03-.812.003-2.243a.75.75 0 0 1 .15-.448l1.175-1.573-1.195-1.754a.75.75 0 0 1-.13-.42L16 5.757l-2.03-.81a.75.75 0 0 1-.286-.203l-1.432-1.638Zm1.543 4.127a.75.75 0 0 1-.028 1.06l-4.75 4.5a.75.75 0 0 1-1.004.025l-1.75-1.5a.75.75 0 1 1 .976-1.138l1.237 1.06 4.26-4.035a.75.75 0 0 1 1.06.028Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Xwe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="check-circle-fill">
    <path fill-rule="evenodd" d="M10 1a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm3.844 6.709a.75.75 0 0 0-1.188-.918l-3.7 4.79-1.649-1.833a.75.75 0 0 0-1.114 1.004l2.25 2.5a.75.75 0 0 0 1.15-.043l4.25-5.5Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, ebe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="check-circle">
    <path fill-rule="evenodd" d="M10 2.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15ZM1 10a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm12.709-3.343a.75.75 0 0 1 .135 1.052l-4.25 5.5a.75.75 0 0 1-1.151.043l-2.25-2.5a.75.75 0 1 1 1.114-1.004l1.65 1.832 3.7-4.789a.75.75 0 0 1 1.052-.134Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, tbe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="check-large">
    <path fill-rule="evenodd" d="M16.772 5.212a.75.75 0 0 1 .016 1.06l-8.25 8.5a.75.75 0 0 1-1.083-.007l-4.25-4.5a.75.75 0 0 1 1.09-1.03l3.712 3.93 7.705-7.937a.75.75 0 0 1 1.06-.016Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, obe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="check-small">
    <path fill-rule="evenodd" d="M15.771 5.71a.75.75 0 0 1 .018 1.061l-7.25 7.5a.75.75 0 0 1-1.089-.01l-3.25-3.5A.75.75 0 1 1 5.3 9.74l2.71 2.92 6.7-6.931a.75.75 0 0 1 1.061-.018Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, nbe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="chevron-down-small-circle">
    <path fill-rule="evenodd" d="M10 2.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15ZM1 10a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm5.24-1.8a.75.75 0 0 1 1.06.04l2.7 2.908 2.7-2.908a.75.75 0 1 1 1.1 1.02l-3.25 3.5a.75.75 0 0 1-1.1 0L6.2 9.26a.75.75 0 0 1 .04-1.06Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, sbe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="chevron-down-small-fill">
    <path fill-rule="evenodd" d="M10 1a9 9 0 1 0 0 18 9 9 0 0 0 0-18ZM7.3 8.24a.75.75 0 1 0-1.1 1.02l3.25 3.5a.75.75 0 0 0 1.1 0l3.25-3.5a.75.75 0 0 0-1.1-1.02L10 11.148 7.3 8.24Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, ibe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="chevron-down-small">
    <path fill-rule="evenodd" d="M6.24 8.2a.75.75 0 0 1 1.06.04l2.7 2.908 2.7-2.908a.75.75 0 1 1 1.1 1.02l-3.25 3.5a.75.75 0 0 1-1.1 0L6.2 9.26a.75.75 0 0 1 .04-1.06Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, rbe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="chevron-down">
    <path fill-rule="evenodd" d="M4.232 7.207a.75.75 0 0 1 1.06.025L10 12.164l4.707-4.932a.75.75 0 1 1 1.085 1.036l-5.25 5.5a.75.75 0 0 1-1.085 0l-5.25-5.5a.75.75 0 0 1 .025-1.06Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, lbe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="chevron-left-small-circle">
    <path fill-rule="evenodd" d="M10 2.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15ZM1 10a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm10.8-3.76a.75.75 0 0 1-.04 1.06L8.852 10l2.908 2.7a.75.75 0 1 1-1.02 1.1l-3.5-3.25a.75.75 0 0 1 0-1.1l3.5-3.25a.75.75 0 0 1 1.06.04Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, abe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="chevron-left-small-fill">
    <path fill-rule="evenodd" d="M19 10a9 9 0 1 0-18 0 9 9 0 0 0 18 0Zm-7.24-2.7a.75.75 0 1 0-1.02-1.1l-3.5 3.25a.75.75 0 0 0 0 1.1l3.5 3.25a.75.75 0 1 0 1.02-1.1L8.852 10l2.908-2.7Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, cbe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="chevron-left-small">
    <path fill-rule="evenodd" d="M11.8 6.24a.75.75 0 0 1-.04 1.06L8.852 10l2.908 2.7a.75.75 0 1 1-1.02 1.1l-3.5-3.25a.75.75 0 0 1 0-1.1l3.5-3.25a.75.75 0 0 1 1.06.04Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, dbe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="chevron-left">
    <path fill-rule="evenodd" d="M12.793 4.232a.75.75 0 0 1-.025 1.06L7.836 10l4.932 4.707a.75.75 0 0 1-1.036 1.085l-5.5-5.25a.75.75 0 0 1 0-1.085l5.5-5.25a.75.75 0 0 1 1.06.025Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, ube = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="chevron-right-small-circle">
    <path fill-rule="evenodd" d="M10 2.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15ZM1 10a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm7.2-3.76a.75.75 0 0 1 1.06-.04l3.5 3.25a.75.75 0 0 1 0 1.1l-3.5 3.25a.75.75 0 0 1-1.02-1.1l2.908-2.7L8.24 7.3a.75.75 0 0 1-.04-1.06Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, hbe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="chevron-right-small-fill">
    <path fill-rule="evenodd" d="M1 10a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm7.24-2.7a.75.75 0 1 1 1.02-1.1l3.5 3.25a.75.75 0 0 1 0 1.1l-3.5 3.25a.75.75 0 0 1-1.02-1.1l2.908-2.7L8.24 7.3Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, gbe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="chevron-right-small">
    <path fill-rule="evenodd" d="M8.2 6.24a.75.75 0 0 1 1.06-.04l3.5 3.25a.75.75 0 0 1 0 1.1l-3.5 3.25a.75.75 0 1 1-1.02-1.1l2.908-2.7L8.24 7.3a.75.75 0 0 1-.04-1.06Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, pbe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="chevron-right">
    <path fill-rule="evenodd" d="M7.207 4.232a.75.75 0 0 1 1.06-.025l5.5 5.25a.75.75 0 0 1 0 1.085l-5.5 5.25a.75.75 0 1 1-1.035-1.085L12.164 10 7.232 5.293a.75.75 0 0 1-.025-1.06Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, fbe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="chevron-up-small-circle">
    <path fill-rule="evenodd" d="M10 2.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15ZM1 10a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm9-3a.75.75 0 0 1 .55.24l3.25 3.5a.75.75 0 1 1-1.1 1.02L10 8.852 7.3 11.76a.75.75 0 1 1-1.1-1.02l3.25-3.5A.75.75 0 0 1 10 7Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, vbe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="chevron-up-small-fill">
    <path fill-rule="evenodd" d="M10 19a9 9 0 1 1 0-18 9 9 0 0 1 0 18Zm-2.7-7.24a.75.75 0 1 1-1.1-1.02l3.25-3.5a.75.75 0 0 1 1.1 0l3.25 3.5a.75.75 0 1 1-1.1 1.02L10 8.852 7.3 11.76Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, mbe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="chevron-up-small">
    <path fill-rule="evenodd" d="M10 7a.75.75 0 0 1 .55.24l3.25 3.5a.75.75 0 1 1-1.1 1.02L10 8.852 7.3 11.76a.75.75 0 1 1-1.1-1.02l3.25-3.5A.75.75 0 0 1 10 7Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Cbe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="chevron-up">
    <path fill-rule="evenodd" d="M10 6a.75.75 0 0 1 .543.232l5.25 5.5a.75.75 0 0 1-1.085 1.036L10 7.836l-4.707 4.932a.75.75 0 0 1-1.086-1.036l5.25-5.5A.75.75 0 0 1 10 6Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, wbe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="clipboard">
    <path fill-rule="evenodd" d="M8.324 1h3.352c.258 0 .494 0 .692.016.213.018.446.057.676.175.33.168.598.435.765.765.118.23.158.463.175.676.009.111.013.235.015.368h.081c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 17.7 4.502c.172.337.24.693.27 1.073.03.365.03.81.03 1.345v8.16c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073a2.751 2.751 0 0 1-1.2 1.202c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03H5.92c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 2.3 17.5c-.172-.338-.24-.694-.27-1.074C2 16.06 2 15.615 2 15.08V6.92c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 3.502 3.3c.337-.172.693-.24 1.073-.27C4.94 3 5.385 3 5.92 3H6c.002-.133.006-.256.015-.368a1.77 1.77 0 0 1 .175-.676 1.75 1.75 0 0 1 .765-.765 1.77 1.77 0 0 1 .676-.175C7.83 1 8.066 1 8.324 1ZM6 4.5h-.05c-.572 0-.957 0-1.253.025-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.547c-.046.09-.088.227-.111.514-.024.296-.025.68-.025 1.253v8.1c0 .572 0 .957.025 1.252.023.288.065.425.111.515.12.236.311.427.547.547.09.046.227.088.514.111.296.024.68.025 1.253.025h8.1c.572 0 .957 0 1.252-.025.288-.023.425-.065.516-.111a1.25 1.25 0 0 0 .546-.547c.046-.09.088-.227.111-.515.024-.295.025-.68.025-1.252v-8.1c0-.572 0-.957-.025-1.253-.023-.287-.065-.424-.111-.514a1.25 1.25 0 0 0-.546-.547c-.091-.046-.228-.088-.515-.111-.296-.024-.68-.025-1.253-.025h-.051a5.464 5.464 0 0 1-.015.368 1.775 1.775 0 0 1-.175.676 1.75 1.75 0 0 1-.764.765c-.23.118-.464.157-.677.175-.198.016-.434.016-.692.016H8.324c-.258 0-.494 0-.692-.016a1.774 1.774 0 0 1-.676-.175 1.75 1.75 0 0 1-.765-.765 1.774 1.774 0 0 1-.175-.676 5.484 5.484 0 0 1-.015-.368Zm1.63-1.97h.001-.001Zm.002-.001a.626.626 0 0 1 .121-.018c.13-.01.304-.011.596-.011h3.3c.292 0 .467 0 .596.011a.625.625 0 0 1 .12.018.25.25 0 0 1 .105.104.638.638 0 0 1 .018.121c.01.13.011.304.011.596v.8c0 .292 0 .467-.011.596a.638.638 0 0 1-.018.12.25.25 0 0 1-.104.105.626.626 0 0 1-.121.018c-.13.01-.304.011-.596.011h-3.3c-.292 0-.467 0-.596-.011a.628.628 0 0 1-.12-.018.25.25 0 0 1-.105-.104.628.628 0 0 1-.018-.121 8.339 8.339 0 0 1-.01-.596v-.8c0-.292 0-.467.011-.596a.628.628 0 0 1 .018-.12.25.25 0 0 1 .104-.105Zm-.103.102v.001-.001Zm0 2.238v-.001.001Zm.1.101h.002-.001Zm4.74 0h-.002.001Zm.1-.1v-.002.001Zm0-2.24v.002-.001Zm-.102-.1h.001-.001Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, bbe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="close">
    <path fill-rule="evenodd" d="M5.22 5.22a.75.75 0 0 1 1.06 0L10 8.94l3.72-3.72a.75.75 0 1 1 1.06 1.06L11.06 10l3.72 3.72a.75.75 0 1 1-1.06 1.06L10 11.06l-3.72 3.72a.75.75 0 0 1-1.06-1.06L8.94 10 5.22 6.28a.75.75 0 0 1 0-1.06Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, ybe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="cloud">
    <path fill-rule="evenodd" d="M10 5.5a4.502 4.502 0 0 0-4.372 3.43.75.75 0 0 1-.706.571A2.5 2.5 0 0 0 5 14.5h11a1.5 1.5 0 1 0-.552-2.895.75.75 0 0 1-1.015-.826A4.5 4.5 0 0 0 10 5.5ZM4.322 8.057A6.002 6.002 0 0 1 16 10a3 3 0 1 1 0 6H5a4 4 0 0 1-.678-7.943Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, _be = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="code-2">
    <path fill-rule="evenodd" d="M11.424 4.02a.75.75 0 0 1 .556.904l-2.5 10.5a.75.75 0 0 1-1.46-.348l2.5-10.5a.75.75 0 0 1 .904-.556ZM6.8 6.24a.75.75 0 0 1-.04 1.06L3.852 10l2.908 2.7a.75.75 0 1 1-1.02 1.1l-3.5-3.25a.75.75 0 0 1 0-1.1l3.5-3.25a.75.75 0 0 1 1.06.04Zm6.4 0a.75.75 0 0 1 1.06-.04l3.5 3.25a.75.75 0 0 1 0 1.1l-3.5 3.25a.75.75 0 1 1-1.02-1.1l2.908-2.7-2.908-2.7a.75.75 0 0 1-.04-1.06Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Sbe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="code">
    <path fill-rule="evenodd" d="M6.8 6.24a.75.75 0 0 1-.04 1.06L3.852 10l2.908 2.7a.75.75 0 1 1-1.02 1.1l-3.5-3.25a.75.75 0 0 1 0-1.1l3.5-3.25a.75.75 0 0 1 1.06.04Zm6.4 0a.75.75 0 0 1 1.06-.04l3.5 3.25a.75.75 0 0 1 0 1.1l-3.5 3.25a.75.75 0 1 1-1.02-1.1l2.908-2.7-2.908-2.7a.75.75 0 0 1-.04-1.06Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, xbe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="command">
    <path fill-rule="evenodd" d="M1 4.75a3.75 3.75 0 1 1 7.5 0V7h3V4.75a3.75 3.75 0 1 1 3.75 3.75H13v3h2.25a3.75 3.75 0 1 1-3.75 3.75V13h-3v2.25a3.75 3.75 0 1 1-3.75-3.75H7v-3H4.75A3.75 3.75 0 0 1 1 4.75ZM7 7V4.75A2.25 2.25 0 1 0 4.75 7H7Zm1.5 1.5v3h3v-3h-3ZM7 13H4.75A2.25 2.25 0 1 0 7 15.25V13Zm6 0v2.25A2.25 2.25 0 1 0 15.25 13H13Zm0-6h2.25A2.25 2.25 0 1 0 13 4.75V7Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Mbe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="comment">
    <path fill-rule="evenodd" d="M1 3.75A2.75 2.75 0 0 1 3.75 1h12.5A2.75 2.75 0 0 1 19 3.75v9.5A2.75 2.75 0 0 1 16.25 16h-3a1.25 1.25 0 0 0-1 .5l-1.65 2.2a.75.75 0 0 1-1.2 0l-1.65-2.2a1.25 1.25 0 0 0-1-.5h-3A2.75 2.75 0 0 1 1 13.25v-9.5ZM3.75 2.5c-.69 0-1.25.56-1.25 1.25v9.5c0 .69.56 1.25 1.25 1.25h3c.866 0 1.68.408 2.2 1.1L10 17l1.05-1.4a2.75 2.75 0 0 1 2.2-1.1h3c.69 0 1.25-.56 1.25-1.25v-9.5c0-.69-.56-1.25-1.25-1.25H3.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Abe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="company">
    <path fill-rule="evenodd" d="M5.324 1h5.352c.258 0 .494 0 .692.016.213.018.446.057.676.175.33.168.598.435.765.765.118.23.158.463.175.676.016.198.016.434.016.692V7h1.676c.258 0 .494 0 .692.016.213.018.446.057.676.175.33.168.598.435.765.765.118.23.157.463.175.676.016.198.016.434.016.692V17.5h1.25a.75.75 0 0 1 0 1.5H1.75a.75.75 0 0 1 0-1.5H3V3.324c0-.258 0-.494.016-.692a1.77 1.77 0 0 1 .175-.676 1.75 1.75 0 0 1 .765-.765 1.77 1.77 0 0 1 .676-.175C4.83 1 5.066 1 5.324 1ZM4.5 17.5h7V3.35c0-.292 0-.467-.011-.596a.638.638 0 0 0-.018-.12.25.25 0 0 0-.104-.105.625.625 0 0 0-.121-.018 8.336 8.336 0 0 0-.596-.011h-5.3c-.292 0-.467 0-.596.011a.626.626 0 0 0-.12.018.25.25 0 0 0-.105.104.628.628 0 0 0-.018.121c-.01.13-.011.304-.011.596V17.5Zm.03-14.87v.002-.001Zm.1-.1h.002-.001Zm6.74 0h-.002.001Zm.1.1v.002-.001ZM13 8.5v9h2.5V9.35c0-.292 0-.467-.011-.596a.638.638 0 0 0-.018-.12.25.25 0 0 0-.104-.105.625.625 0 0 0-.121-.018 8.336 8.336 0 0 0-.596-.011H13Zm2.37.03h-.002.001Zm.1.1v.002-.001ZM6 5.75A.75.75 0 0 1 6.75 5h2.5a.75.75 0 0 1 0 1.5h-2.5A.75.75 0 0 1 6 5.75ZM6 10a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5A.75.75 0 0 1 6 10Zm0 4.25a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Lbe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="compass">
    <path fill-rule="evenodd" d="M10 2.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15ZM1 10a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm13.78-4.78a.75.75 0 0 1 .187.75l-1.502 4.881-.027.089c-.155.506-.277.903-.504 1.241a2.74 2.74 0 0 1-.753.753c-.338.227-.735.349-1.241.504l-.089.027-4.88 1.502a.75.75 0 0 1-.938-.938l1.502-4.88.027-.089c.155-.506.277-.903.504-1.241.2-.298.455-.553.753-.753.338-.227.735-.349 1.241-.504l.089-.027 4.88-1.502a.75.75 0 0 1 .751.187Zm-1.663 1.663L9.59 7.97c-.637.195-.805.255-.936.343a1.25 1.25 0 0 0-.342.342c-.088.131-.148.3-.343.936l-1.086 3.527 3.527-1.086c.637-.195.805-.255.936-.343a1.25 1.25 0 0 0 .342-.342c.088-.131.148-.3.343-.936l1.085-3.527Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Ebe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="copy">
    <path fill-rule="evenodd" d="M1 3.75A2.75 2.75 0 0 1 3.75 1h8.5A2.75 2.75 0 0 1 15 3.75V5h1.25A2.75 2.75 0 0 1 19 7.75v8.5A2.75 2.75 0 0 1 16.25 19h-8.5A2.75 2.75 0 0 1 5 16.25V15H3.75A2.75 2.75 0 0 1 1 12.25v-8.5Zm4 9.75V7.75A2.75 2.75 0 0 1 7.75 5h5.75V3.75c0-.69-.56-1.25-1.25-1.25h-8.5c-.69 0-1.25.56-1.25 1.25v8.5c0 .69.56 1.25 1.25 1.25H5Zm2.75-7c-.69 0-1.25.56-1.25 1.25v8.5c0 .69.56 1.25 1.25 1.25h8.5c.69 0 1.25-.56 1.25-1.25v-8.5c0-.69-.56-1.25-1.25-1.25h-8.5Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Pbe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="cpu">
    <path fill-rule="evenodd" d="M6.25 1a.75.75 0 0 1 .75.75V3h2.25V1.75a.75.75 0 0 1 1.5 0V3H13V1.75a.75.75 0 0 1 1.5 0V3h.574c.19 0 .374 0 .53.013.171.014.373.047.577.15a1.5 1.5 0 0 1 .655.656c.104.204.137.406.151.577.013.156.013.34.013.53v.199h1.25a.75.75 0 0 1 0 1.5H17v2.25h1.25a.75.75 0 0 1 0 1.5H17v2.25h1.25a.75.75 0 0 1 0 1.5H17v.949c0 .19 0 .374-.013.53a1.517 1.517 0 0 1-.15.577 1.5 1.5 0 0 1-.656.655 1.517 1.517 0 0 1-.577.151c-.156.013-.34.013-.53.013H14.5v1.25a.75.75 0 0 1-1.5 0V17h-2.25v1.25a.75.75 0 0 1-1.5 0V17H7v1.25a.75.75 0 0 1-1.5 0V17h-.574c-.19 0-.374 0-.53-.013a1.517 1.517 0 0 1-.577-.15 1.5 1.5 0 0 1-.656-.656 1.517 1.517 0 0 1-.15-.577C3 15.448 3 15.264 3 15.074v-.949H1.75a.75.75 0 0 1 0-1.5H3v-2.25H1.75a.75.75 0 0 1 0-1.5H3v-2.25H1.75a.75.75 0 0 1 0-1.5H3v-.199c0-.19 0-.374.013-.53a1.53 1.53 0 0 1 .15-.577 1.5 1.5 0 0 1 .656-.656 1.53 1.53 0 0 1 .577-.15C4.552 3 4.736 3 4.926 3H5.5V1.75A.75.75 0 0 1 6.25 1ZM4.509 4.509l-.001.01a6.16 6.16 0 0 0-.008.431v10.1a6.135 6.135 0 0 0 .009.441l.01.001c.087.007.209.008.431.008h10.1a6.173 6.173 0 0 0 .441-.009l.001-.01a6.16 6.16 0 0 0 .008-.431V4.95a6.175 6.175 0 0 0-.009-.441l-.01-.001a6.135 6.135 0 0 0-.431-.008H4.95a6.136 6.136 0 0 0-.441.009ZM7.637 6.5h4.726c.058 0 .139 0 .212.006.088.007.229.027.379.103a1 1 0 0 1 .437.437c.076.15.096.29.103.379.006.073.006.154.006.212v4.726c0 .058 0 .139-.006.212a1.003 1.003 0 0 1-.103.379 1 1 0 0 1-.437.437c-.15.076-.29.096-.379.103-.073.006-.154.006-.212.006H7.637c-.058 0-.139 0-.212-.006a1.003 1.003 0 0 1-.379-.103 1 1 0 0 1-.437-.437 1.003 1.003 0 0 1-.103-.379c-.006-.073-.006-.154-.006-.212V7.637c0-.058 0-.139.006-.212.007-.088.027-.229.103-.379a1 1 0 0 1 .437-.437c.15-.076.29-.096.379-.103.073-.006.154-.006.212-.006ZM8 8v4h4V8H8Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Rbe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="crown">
    <path fill-rule="evenodd" d="M10 3a.75.75 0 0 1 .633.347l3.129 4.918L17.9 6.086a.75.75 0 0 1 1.083.819l-2 9.5a.75.75 0 0 1-.734.595H3.75a.75.75 0 0 1-.734-.596l-2-9.5A.75.75 0 0 1 2.1 6.087l4.14 2.179 3.128-4.918A.75.75 0 0 1 10 3Zm0 2.147L7.133 9.653a.75.75 0 0 1-.982.26L2.813 8.158 4.359 15.5h11.283l1.545-7.343-3.338 1.757a.75.75 0 0 1-.982-.261L10 5.147Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Fbe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="cursor-arrow-fill">
    <path d="M2.22 2.22a.75.75 0 0 1 .806-.167l14.5 5.75a.75.75 0 0 1 .16 1.307l-2.78 1.986 2.874 2.874a.75.75 0 0 1 0 1.06l-2.75 2.75a.75.75 0 0 1-1.06 0l-2.874-2.874-1.986 2.78a.75.75 0 0 1-1.307-.16l-5.75-14.5a.75.75 0 0 1 .167-.806Z" class="Icon"/>
  </g>
</svg>
`, Tbe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="cursor-arrow">
    <path fill-rule="evenodd" d="M2.22 2.22a.75.75 0 0 1 .806-.167l14.5 5.75a.75.75 0 0 1 .16 1.307l-2.78 1.986 2.874 2.874a.75.75 0 0 1 0 1.06l-2.75 2.75a.75.75 0 0 1-1.06 0l-2.874-2.874-1.986 2.78a.75.75 0 0 1-1.307-.16l-5.75-14.5a.75.75 0 0 1 .167-.806Zm1.867 1.867L8.69 15.694l1.7-2.38a.75.75 0 0 1 1.14-.094l2.97 2.97 1.69-1.69-2.97-2.97a.75.75 0 0 1 .094-1.14l2.38-1.7L4.087 4.087Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Ibe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="cursor-text">
    <path fill-rule="evenodd" d="M5 1.75A.75.75 0 0 1 5.75 1h.75c1.114 0 2.183.278 2.986.96.192.163.364.346.514.546.15-.2.322-.383.514-.546.803-.682 1.872-.96 2.986-.96h.75a.75.75 0 0 1 0 1.5h-.75c-.886 0-1.567.222-2.014.603-.428.364-.736.95-.736 1.897v10c0 .947.308 1.533.736 1.897.447.38 1.128.603 2.014.603h.75a.75.75 0 0 1 0 1.5h-.75c-1.114 0-2.183-.278-2.986-.96a3.369 3.369 0 0 1-.514-.546c-.15.2-.322.383-.514.546-.803.682-1.872.96-2.986.96h-.75a.75.75 0 0 1 0-1.5h.75c.886 0 1.567-.222 2.014-.603.428-.364.736-.95.736-1.897V5c0-.947-.308-1.533-.736-1.897C8.067 2.723 7.386 2.5 6.5 2.5h-.75A.75.75 0 0 1 5 1.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Dbe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="database">
    <path fill-rule="evenodd" d="M1.009 3.386A1.079 1.079 0 0 1 1 3.25c0-.371.188-.653.375-.837.184-.181.416-.318.648-.427.468-.218 1.104-.393 1.85-.534C5.374 1.17 7.487 1 10 1c2.512 0 4.625.17 6.128.452.745.14 1.38.316 1.849.534.232.109.464.246.648.427.187.184.375.466.375.837 0 .047-.003.092-.009.136A.75.75 0 0 1 19 3.5v13a.747.747 0 0 1-.01.125c.007.04.01.082.01.125 0 .371-.188.654-.375.837a2.32 2.32 0 0 1-.648.427c-.468.218-1.104.393-1.85.534C14.626 18.83 12.513 19 10 19c-2.512 0-4.625-.17-6.128-.452-.745-.14-1.38-.316-1.849-.534a2.32 2.32 0 0 1-.648-.427A1.174 1.174 0 0 1 1 16.75c0-.043.004-.084.01-.125A.755.755 0 0 1 1 16.5v-13c0-.039.003-.077.009-.114ZM2.5 4.703V7.57a1.5 1.5 0 0 0 .157.083c.302.14.797.288 1.493.42 1.38.26 3.392.426 5.85.426 2.458 0 4.47-.167 5.85-.426.696-.131 1.19-.28 1.493-.42.07-.032.12-.06.157-.083V4.703a10.37 10.37 0 0 1-1.372.345c-1.503.283-3.616.452-6.128.452s-4.625-.17-6.128-.452A10.37 10.37 0 0 1 2.5 4.703ZM17.11 3.25a8.179 8.179 0 0 0-1.26-.324C14.47 2.666 12.458 2.5 10 2.5c-2.458 0-4.47.167-5.85.426-.54.102-.958.213-1.26.324.302.11.72.222 1.26.324C5.53 3.834 7.542 4 10 4c2.458 0 4.47-.167 5.85-.426a8.18 8.18 0 0 0 1.26-.324Zm.39 5.953a10.37 10.37 0 0 1-1.372.345C14.625 9.83 12.512 10 10 10s-4.625-.17-6.128-.452A10.37 10.37 0 0 1 2.5 9.203v2.868a1.5 1.5 0 0 0 .157.083c.302.14.797.289 1.493.42 1.38.26 3.392.426 5.85.426 2.458 0 4.47-.166 5.85-.426.696-.131 1.19-.28 1.493-.42a1.5 1.5 0 0 0 .157-.083V9.203Zm0 4.5a10.37 10.37 0 0 1-1.372.345c-1.503.283-3.616.452-6.128.452s-4.625-.17-6.128-.452a10.37 10.37 0 0 1-1.372-.345V16.5a.763.763 0 0 1-.003.069c.036.023.088.052.16.085.302.14.797.288 1.493.42 1.38.26 3.392.426 5.85.426 2.458 0 4.47-.166 5.85-.426.696-.132 1.19-.28 1.493-.42.072-.033.124-.062.16-.085a.785.785 0 0 1-.003-.069v-2.797Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, kbe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="delete">
    <path fill-rule="evenodd" d="M6 3.75A2.75 2.75 0 0 1 8.75 1h2.5A2.75 2.75 0 0 1 14 3.75V4h3.25a.75.75 0 0 1 0 1.5h-.29l-.606 10.902A2.75 2.75 0 0 1 13.608 19H6.392a2.75 2.75 0 0 1-2.746-2.598L3.041 5.5H2.75a.75.75 0 0 1 0-1.5H6v-.25ZM4.543 5.5l.6 10.82a1.25 1.25 0 0 0 1.249 1.18h7.216a1.25 1.25 0 0 0 1.248-1.18l.601-10.82H4.543ZM12.5 4h-5v-.25c0-.69.56-1.25 1.25-1.25h2.5c.69 0 1.25.56 1.25 1.25V4ZM7.75 8a.75.75 0 0 1 .75.75v5.5a.75.75 0 0 1-1.5 0v-5.5A.75.75 0 0 1 7.75 8Zm4.5 0a.75.75 0 0 1 .75.75v5.5a.75.75 0 0 1-1.5 0v-5.5a.75.75 0 0 1 .75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Hbe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="desktop">
    <path fill-rule="evenodd" d="M4.92 1h10.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 18.7 2.502c.172.337.24.693.27 1.073.03.365.03.81.03 1.345v6.16c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073a2.751 2.751 0 0 1-1.2 1.202c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03h-4.33v2.5h2.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1 0-1.5h2.5V15H4.92c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 1.3 13.5c-.172-.338-.24-.694-.27-1.074C1 12.06 1 11.615 1 11.08V4.92c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 2.502 1.3c.337-.172.693-.24 1.073-.27C3.94 1 4.385 1 4.92 1ZM2.5 11.5c.002.336.008.592.025.803.023.287.065.424.111.514.12.236.311.427.547.547.09.046.227.088.514.111.296.024.68.025 1.253.025h10.1c.572 0 .957 0 1.252-.025.288-.023.425-.065.515-.111a1.25 1.25 0 0 0 .547-.546c.046-.091.088-.228.111-.515.017-.211.023-.467.024-.803H2.501Zm15-1.5h-15V4.95c0-.572 0-.957.025-1.253.023-.287.065-.424.111-.514a1.25 1.25 0 0 1 .547-.547c.09-.046.227-.088.514-.111.296-.024.68-.025 1.253-.025h10.1c.572 0 .957 0 1.252.025.288.023.425.065.515.111.236.12.427.311.547.547.046.09.088.227.111.514.024.296.025.68.025 1.253V10Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Vbe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="devices">
    <path fill-rule="evenodd" d="M5.92 2h8.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 17.7 3.502c.172.337.24.693.27 1.073.03.365.03.81.03 1.345v.249l.044.022c.33.168.598.435.765.765.118.23.157.463.175.676.016.198.016.434.016.692v8.352c0 .258 0 .494-.016.692a1.775 1.775 0 0 1-.175.677 1.75 1.75 0 0 1-.765.764 1.77 1.77 0 0 1-.676.175c-.198.016-.434.016-.692.016h-3.352c-.258 0-.494 0-.692-.016a1.775 1.775 0 0 1-.676-.175 1.75 1.75 0 0 1-.787-.809h-6.25c-.534 0-.98 0-1.344-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 1.3 16.5c-.172-.338-.24-.694-.27-1.074C1 15.06 1 14.615 1 14.08v-.33a.75.75 0 0 1 .75-.75H2V5.92c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 3.502 2.3c.337-.172.693-.24 1.073-.27C4.94 2 5.385 2 5.92 2ZM2.5 14.5c.002.336.008.592.025.803.023.287.065.424.111.514.12.236.311.427.547.547.09.046.227.088.514.111.296.024.68.025 1.253.025H11V16H8.651a2.434 2.434 0 0 1-2.025-1.084.934.934 0 0 0-.777-.416H2.5Zm8.5 0H8.651a.934.934 0 0 1-.777-.416A2.434 2.434 0 0 0 5.849 13H3.5V5.95c0-.572 0-.957.025-1.253.023-.287.065-.424.111-.514a1.25 1.25 0 0 1 .547-.547c.09-.046.227-.088.514-.111.296-.024.68-.025 1.253-.025h8.1c.572 0 .957 0 1.252.025.288.023.425.065.516.111.235.12.426.311.546.547.046.09.088.227.111.514.024.296.025.68.025 1.253V6h-3.176c-.258 0-.494 0-.692.016a1.774 1.774 0 0 0-.676.175 1.75 1.75 0 0 0-.765.765c-.118.23-.158.463-.175.676C11 7.83 11 8.066 11 8.324V14.5Zm1.63-6.97h.002-.001Zm.003-.001a.626.626 0 0 1 .121-.018c.13-.01.304-.011.596-.011h3.3c.292 0 .467 0 .596.011a.626.626 0 0 1 .12.018.25.25 0 0 1 .105.104.638.638 0 0 1 .018.121c.01.13.011.304.011.596v8.3c0 .292 0 .467-.011.596a.636.636 0 0 1-.018.12.25.25 0 0 1-.105.105.636.636 0 0 1-.12.018c-.13.01-.304.011-.596.011h-3.3c-.292 0-.467 0-.596-.011a.636.636 0 0 1-.12-.018.25.25 0 0 1-.105-.105.636.636 0 0 1-.018-.12 8.373 8.373 0 0 1-.011-.596v-8.3c0-.292 0-.467.011-.596a.638.638 0 0 1 .018-.12.25.25 0 0 1 .104-.105Zm-.103.102v.001-.001Zm0 9.738v-.001.001Zm.1.101h.002-.001Zm4.74 0h-.002.001Zm.1-9.84v.002-.001Zm-.102-.1h.001-.002Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Obe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="diamond">
    <path fill-rule="evenodd" d="M5.59 2h8.82c.262 0 .542-.001.806.083.23.073.442.193.623.353.208.183.352.423.487.649l.025.043 2.176 3.308a24.708 24.708 0 0 0 .064.104c.15.249.316.524.375.828.021.108.032.217.032.325a.763.763 0 0 1-.01.193c-.01.098-.03.194-.056.288-.085.302-.272.562-.448.806l-.045.061a.75.75 0 0 1-.042.054l-6.507 7.53a10.46 10.46 0 0 1-.552.726c-.175.201-.392.407-.69.526a1.75 1.75 0 0 1-1.296 0c-.298-.12-.515-.325-.69-.526a10.47 10.47 0 0 1-.552-.726l-6.507-7.53a.747.747 0 0 1-.042-.054l-.044-.06c-.177-.245-.364-.505-.45-.807a1.771 1.771 0 0 1-.055-.288.754.754 0 0 1-.01-.193c0-.108.01-.217.032-.325.059-.304.225-.579.376-.827a20.537 20.537 0 0 0 .063-.105L3.65 3.128l.025-.043c.135-.226.279-.466.487-.65.18-.159.393-.279.623-.352.264-.084.544-.084.806-.083Zm-.77 2.075L2.899 7h5.155L4.821 4.075ZM10 8.5H3.07l6.196 7.17a.766.766 0 0 1 .042.053c.227.316.369.51.484.643.073.084.11.112.12.12a.25.25 0 0 0 .173 0 .765.765 0 0 0 .12-.12c.116-.132.258-.327.485-.643a.736.736 0 0 1 .042-.053l6.196-7.17H10ZM17.102 7h-5.155l3.232-2.925L17.102 7ZM13.58 3.5H6.421L10 6.739 13.58 3.5Zm-3.496 12.988h.001Zm-.166 0h-.001Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Bbe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="dns">
    <path fill-rule="evenodd" d="M4.92 2.5h10.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 18.7 4.002c.172.337.24.693.27 1.073.03.365.03.81.03 1.345v.41c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073a2.752 2.752 0 0 1-.563.752c.228.215.42.469.563.752.172.337.24.693.27 1.073.03.365.03.81.03 1.345v.41c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073a2.751 2.751 0 0 1-1.2 1.202c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03H4.92c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 1.3 16c-.172-.338-.24-.694-.27-1.074C1 14.56 1 14.115 1 13.58v-.41c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 1.863 10a2.75 2.75 0 0 1-.563-.752c-.172-.337-.24-.693-.27-1.073C1 7.81 1 7.365 1 6.83v-.41c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 2.502 2.8c.337-.172.693-.24 1.073-.27.365-.03.81-.03 1.345-.03Zm.03 8.25c-.572 0-.957 0-1.253.025-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.546c-.046.091-.088.228-.111.515-.024.296-.025.68-.025 1.253v.35c0 .572 0 .957.025 1.252.023.288.065.425.111.516.12.235.311.426.547.546.09.046.227.088.514.111.296.024.68.025 1.253.025h10.1c.572 0 .957 0 1.252-.025.288-.023.425-.065.515-.111a1.25 1.25 0 0 0 .547-.546c.046-.091.088-.228.111-.515.024-.296.025-.68.025-1.253v-.35c0-.572 0-.957-.025-1.252-.023-.288-.065-.425-.111-.516a1.25 1.25 0 0 0-.547-.546c-.09-.046-.227-.088-.515-.111-.295-.024-.68-.025-1.252-.025H4.95Zm10.1-1.5c.572 0 .957 0 1.252-.025.288-.023.425-.065.515-.111a1.25 1.25 0 0 0 .547-.547c.046-.09.088-.227.111-.514.024-.296.025-.68.025-1.253v-.35c0-.572 0-.957-.025-1.253-.023-.287-.065-.424-.111-.514a1.25 1.25 0 0 0-.547-.547c-.09-.046-.227-.088-.515-.111C16.007 4 15.622 4 15.05 4H4.95c-.572 0-.957 0-1.253.025-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.547c-.046.09-.088.227-.111.514-.024.296-.025.68-.025 1.253v.35c0 .572 0 .957.025 1.253.023.287.065.424.111.514.12.236.311.427.547.547.09.046.227.088.514.111.296.024.68.025 1.253.025h10.1ZM4 6.747a.75.75 0 0 1 .75-.75L7.25 6a.75.75 0 0 1 0 1.5l-2.5-.001a.75.75 0 0 1-.75-.75Zm0 6.502a.75.75 0 0 1 .75-.749l2.5.002a.75.75 0 0 1 0 1.5L4.75 14a.75.75 0 0 1-.75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, $be = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="download">
    <path fill-rule="evenodd" d="M10 1a.75.75 0 0 1 .75.75v8.787l1.991-1.838A.75.75 0 1 1 13.76 9.8l-3.25 3a.75.75 0 0 1-1.018 0l-3.25-3A.75.75 0 1 1 7.26 8.7l1.991 1.838V1.75A.75.75 0 0 1 10 1ZM1.75 13a.75.75 0 0 1 .75.75v2.5c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25v-2.5a.75.75 0 0 1 1.5 0v2.5A2.75 2.75 0 0 1 16.25 19H3.75A2.75 2.75 0 0 1 1 16.25v-2.5a.75.75 0 0 1 .75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Zbe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="drag-drop-horizontal">
    <path fill-rule="evenodd" d="M5.75 3.25a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Zm5.5 0a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Zm0 6.75a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Zm1.5 8.25a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm-5.5-6.75a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm-1.5 5.25a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Gbe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="drag-drop-vertical">
    <path fill-rule="evenodd" d="M3.25 8.75a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm6.75 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm8.25-1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm-15 7a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm8.25-1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm5.25 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Nbe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="edit">
    <path fill-rule="evenodd" d="M12.891 2.048a3.579 3.579 0 0 1 5.06 5.06L6.282 18.78a.75.75 0 0 1-.531.22h-4a.75.75 0 0 1-.75-.75v-4a.75.75 0 0 1 .22-.53L12.89 2.048Zm2.53.452c-.55 0-1.08.219-1.47.609l-.39.391L16.5 6.44l.391-.392a2.078 2.078 0 0 0-1.47-3.548Zm.018 5L12.5 4.56l-10 10v2.94h2.94l10-10Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, zbe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="email">
    <path fill-rule="evenodd" d="M10 2.5a7.5 7.5 0 1 0 0 15 .75.75 0 0 1 0 1.5 9 9 0 1 1 9-9v2a3 3 0 0 1-5.535 1.605 5 5 0 1 1 1.044-1.441A1.5 1.5 0 0 0 17.5 12v-2A7.5 7.5 0 0 0 10 2.5Zm3.104 9.119a3.5 3.5 0 1 0-6.208-3.238 3.5 3.5 0 0 0 6.208 3.238Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, jbe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="emoji-big-smile">
    <path fill-rule="evenodd" d="M10 2.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15ZM1 10a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm5-1.75a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1A.75.75 0 0 1 6 8.25Zm5.5 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm-4.858 4.062A.75.75 0 0 1 7.25 12h5.5a.75.75 0 0 1 .711.987C12.873 14.752 11.49 15.75 10 15.75c-1.49 0-2.873-.998-3.462-2.763a.75.75 0 0 1 .104-.675ZM8.494 13.5c.436.523.995.75 1.506.75s1.07-.227 1.506-.75H8.494Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Wbe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="emoji-sad">
    <path fill-rule="evenodd" d="M10 2.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15ZM1 10a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm5-1.75a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1A.75.75 0 0 1 6 8.25Zm5.5 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75ZM10 12.5c-.937 0-1.744.415-2.08 1.085a.75.75 0 1 1-1.34-.67C7.243 11.585 8.686 11 10 11c1.313 0 2.756.585 3.42 1.915a.75.75 0 1 1-1.34.67c-.336-.67-1.143-1.085-2.08-1.085Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Ube = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="emoji-smile">
    <path fill-rule="evenodd" d="M10 2.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15ZM1 10a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm5-1.75a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1A.75.75 0 0 1 6 8.25Zm5.5 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm-4.585 3.83a.75.75 0 0 1 1.006.335c.335.67 1.142 1.085 2.079 1.085.937 0 1.744-.415 2.08-1.085a.75.75 0 1 1 1.34.67C12.757 14.415 11.314 15 10 15c-1.313 0-2.756-.585-3.42-1.915a.75.75 0 0 1 .335-1.006Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Kbe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="error-fill">
    <path fill-rule="evenodd" d="M10 1a9 9 0 1 0 0 18 9 9 0 0 0 0-18ZM7.28 6.22a.75.75 0 0 0-1.06 1.06L8.94 10l-2.72 2.72a.75.75 0 1 0 1.06 1.06L10 11.06l2.72 2.72a.75.75 0 1 0 1.06-1.06L11.06 10l2.72-2.72a.75.75 0 0 0-1.06-1.06L10 8.94 7.28 6.22Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, qbe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="error">
    <path fill-rule="evenodd" d="M10 2.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15ZM1 10a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm5.22-3.78a.75.75 0 0 1 1.06 0L10 8.94l2.72-2.72a.75.75 0 1 1 1.06 1.06L11.06 10l2.72 2.72a.75.75 0 1 1-1.06 1.06L10 11.06l-2.72 2.72a.75.75 0 0 1-1.06-1.06L8.94 10 6.22 7.28a.75.75 0 0 1 0-1.06Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Ybe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="extension">
    <path fill-rule="evenodd" d="M8.75 2.5A1.75 1.75 0 0 0 7 4.25a.75.75 0 0 1-.75.75h-2.5c-.69 0-1.25.56-1.25 1.25v1.837a3.251 3.251 0 0 1 0 6.326v1.837c0 .69.56 1.25 1.25 1.25h1.837a3.251 3.251 0 0 1 6.326 0h1.837c.69 0 1.25-.56 1.25-1.25v-2.5a.75.75 0 0 1 .75-.75 1.75 1.75 0 1 0 0-3.5.75.75 0 0 1-.75-.75v-2.5C15 5.56 14.44 5 13.75 5h-2.5a.75.75 0 0 1-.75-.75A1.75 1.75 0 0 0 8.75 2.5Zm-3.163 1a3.251 3.251 0 0 1 6.326 0h1.837a2.75 2.75 0 0 1 2.75 2.75v1.837a3.251 3.251 0 0 1 0 6.326v1.837A2.75 2.75 0 0 1 13.75 19h-2.5a.75.75 0 0 1-.75-.75 1.75 1.75 0 1 0-3.5 0 .75.75 0 0 1-.75.75h-2.5A2.75 2.75 0 0 1 1 16.25v-2.5a.75.75 0 0 1 .75-.75 1.75 1.75 0 1 0 0-3.5.75.75 0 0 1-.75-.75v-2.5A2.75 2.75 0 0 1 3.75 3.5h1.837Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Qbe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="eye-off">
    <path fill-rule="evenodd" d="M1.152 3.297a.75.75 0 0 1 1.05-.145l16.5 12.5a.75.75 0 1 1-.905 1.196l-2.673-2.025C13.736 15.988 11.972 17 10 17c-2.034 0-3.846-1.078-5.246-2.28-1.412-1.214-2.5-2.636-3.103-3.502l-.03-.043c-.145-.207-.305-.437-.384-.754a1.878 1.878 0 0 1 0-.842c.079-.317.24-.547.384-.754l.03-.043a20.41 20.41 0 0 1 2.11-2.567L1.297 4.348a.75.75 0 0 1-.145-1.05Zm3.816 3.831a18.753 18.753 0 0 0-2.085 2.51 3.978 3.978 0 0 0-.165.247.194.194 0 0 0-.024.053l-.002.014a.466.466 0 0 0 .002.11c.002.009.005.02.024.053.03.05.073.114.165.247.566.815 1.572 2.123 2.849 3.22C7.02 14.688 8.492 15.5 10 15.5c1.368 0 2.702-.667 3.893-1.61l-2.03-1.538a3 3 0 0 1-4.631-3.508L4.967 7.127ZM8.51 9.813a1.5 1.5 0 0 0 2.072 1.57L8.51 9.813ZM10 4.5c-.605 0-1.204.13-1.793.36a.75.75 0 0 1-.547-1.397A6.404 6.404 0 0 1 10 3c2.034 0 3.846 1.078 5.246 2.28 1.412 1.214 2.5 2.636 3.103 3.502l.03.043c.145.207.305.437.384.754a1.87 1.87 0 0 1 0 .842c-.079.317-.24.547-.385.755a3.998 3.998 0 0 0-1.097-1.06.2.2 0 0 0 .026-.054l.001-.014a.456.456 0 0 0 0-.096c0-.008-.002-.014-.002-.014a.199.199 0 0 0-.024-.053 3.99 3.99 0 0 0-.165-.247c-.566-.815-1.572-2.123-2.849-3.22C12.98 5.312 11.508 4.5 10 4.5Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Jbe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="eye">
    <path fill-rule="evenodd" d="M5.614 6.424C4.306 7.522 3.276 8.83 2.696 9.644a3.979 3.979 0 0 0-.168.247.19.19 0 0 0-.024.05l-.002.013a.44.44 0 0 0 .002.105.19.19 0 0 0 .024.05c.03.05.074.113.168.246.58.815 1.61 2.123 2.918 3.22C6.933 14.684 8.444 15.5 10 15.5s3.067-.817 4.386-1.924c1.308-1.098 2.338-2.406 2.918-3.22.094-.134.138-.197.168-.247a.19.19 0 0 0 .024-.05l.002-.013a.42.42 0 0 0 0-.092l-.002-.013a.19.19 0 0 0-.024-.05 3.993 3.993 0 0 0-.168-.246c-.58-.815-1.61-2.123-2.918-3.22C13.067 5.316 11.556 4.5 10 4.5s-3.067.817-4.386 1.924Zm-.965-1.149C6.082 4.073 7.93 3 10 3s3.918 1.073 5.35 2.275c1.445 1.212 2.56 2.634 3.176 3.5l.03.043c.148.207.314.438.395.757.066.26.066.59 0 .85-.081.319-.247.55-.395.757l-.03.043c-.617.866-1.731 2.287-3.175 3.5C13.918 15.927 12.07 17 10 17s-3.918-1.073-5.35-2.275c-1.445-1.213-2.56-2.634-3.176-3.5a8.876 8.876 0 0 0-.03-.043c-.149-.207-.314-.438-.395-.757a1.853 1.853 0 0 1 0-.85c.081-.319.246-.55.395-.757l.03-.043c.617-.866 1.731-2.288 3.175-3.5ZM10 8.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM7 10a3 3 0 1 1 6 0 3 3 0 0 1-6 0Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Xbe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="file-check" clip-path="url(#a)">
    <path fill-rule="evenodd" d="M5.75 2.5c-.69 0-1.25.56-1.25 1.25v12.5c0 .69.56 1.25 1.25 1.25h3.5a.75.75 0 0 1 0 1.5h-3.5A2.75 2.75 0 0 1 3 16.25V3.75A2.75 2.75 0 0 1 5.75 1h5.5a.75.75 0 0 1 .53.22l5 5c.141.14.22.331.22.53v2.5a.75.75 0 0 1-1.5 0V7.5h-4.25a.75.75 0 0 1-.75-.75V2.5H5.75ZM12 3.56 14.44 6H12V3.56Zm7.765 9.645a.75.75 0 0 1 .03 1.06l-4.25 4.5a.75.75 0 0 1-1.102-.013l-2.25-2.5a.75.75 0 1 1 1.114-1.004l1.706 1.896 3.692-3.909a.75.75 0 0 1 1.06-.03Z" class="Icon" clip-rule="evenodd"/>
  </g>
  <defs>
    <clipPath id="a" class="a">
      <path d="M0 0h20v20H0z"/>
    </clipPath>
  </defs>
</svg>
`, eye = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="file-close">
    <path fill-rule="evenodd" d="M5.75 2.5c-.69 0-1.25.56-1.25 1.25v12.5c0 .69.56 1.25 1.25 1.25h3.5a.75.75 0 0 1 0 1.5h-3.5A2.75 2.75 0 0 1 3 16.25V3.75A2.75 2.75 0 0 1 5.75 1h5.5a.75.75 0 0 1 .53.22l5 5c.141.14.22.331.22.53v2.5a.75.75 0 0 1-1.5 0V7.5h-4.25a.75.75 0 0 1-.75-.75V2.5H5.75ZM12 3.56 14.44 6H12V3.56Zm1.22 9.66a.75.75 0 0 1 1.06 0L16 14.94l1.72-1.72a.75.75 0 1 1 1.06 1.06L17.06 16l1.72 1.72a.75.75 0 1 1-1.06 1.06L16 17.06l-1.72 1.72a.75.75 0 1 1-1.06-1.06L14.94 16l-1.72-1.72a.75.75 0 0 1 0-1.06Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, tye = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="file-edit">
    <path fill-rule="evenodd" d="M5.75 2.5c-.69 0-1.25.56-1.25 1.25v12.5c0 .69.56 1.25 1.25 1.25h3.5a.75.75 0 0 1 0 1.5h-3.5A2.75 2.75 0 0 1 3 16.25V3.75A2.75 2.75 0 0 1 5.75 1h5.5a.75.75 0 0 1 .53.22l5 5c.141.14.22.331.22.53v2.5a.75.75 0 0 1-1.5 0V7.5h-4.25a.75.75 0 0 1-.75-.75V2.5H5.75ZM12 3.56 14.44 6H12V3.56Zm6.286 10.154a.73.73 0 0 0-1.033 0L13.5 17.467V18.5h1.033l3.753-3.753a.73.73 0 0 0 0-1.033Zm-2.094-1.06a2.23 2.23 0 1 1 3.155 3.154l-3.973 3.972a.75.75 0 0 1-.53.22H12.75a.75.75 0 0 1-.75-.75v-2.094a.75.75 0 0 1 .22-.53l3.972-3.973Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, oye = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="file-minus">
    <path fill-rule="evenodd" d="M5.75 2.5c-.69 0-1.25.56-1.25 1.25v12.5c0 .69.56 1.25 1.25 1.25h3.5a.75.75 0 0 1 0 1.5h-3.5A2.75 2.75 0 0 1 3 16.25V3.75A2.75 2.75 0 0 1 5.75 1h5.5a.75.75 0 0 1 .53.22l5 5c.141.14.22.331.22.53v2.5a.75.75 0 0 1-1.5 0V7.5h-4.25a.75.75 0 0 1-.75-.75V2.5H5.75ZM12 3.56 14.44 6H12V3.56Zm0 12.19a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, nye = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="file-plus">
    <path fill-rule="evenodd" d="M5.75 2.5c-.69 0-1.25.56-1.25 1.25v12.5c0 .69.56 1.25 1.25 1.25h3.5a.75.75 0 0 1 0 1.5h-3.5A2.75 2.75 0 0 1 3 16.25V3.75A2.75 2.75 0 0 1 5.75 1h5.5a.75.75 0 0 1 .53.22l5 5c.141.14.22.331.22.53v2.5a.75.75 0 0 1-1.5 0V7.5h-4.25a.75.75 0 0 1-.75-.75V2.5H5.75ZM12 3.56 14.44 6H12V3.56ZM16 12a.75.75 0 0 1 .75.75v2.5h2.5a.75.75 0 0 1 0 1.5h-2.5v2.5a.75.75 0 0 1-1.5 0v-2.5h-2.5a.75.75 0 0 1 0-1.5h2.5v-2.5A.75.75 0 0 1 16 12Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, sye = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="file">
    <path fill-rule="evenodd" d="M5.75 2.5c-.69 0-1.25.56-1.25 1.25v12.5c0 .69.56 1.25 1.25 1.25h8.5c.69 0 1.25-.56 1.25-1.25V7.5h-4.25a.75.75 0 0 1-.75-.75V2.5H5.75ZM12 3.56 14.44 6H12V3.56Zm-9 .19A2.75 2.75 0 0 1 5.75 1h5.5a.75.75 0 0 1 .53.22l5 5c.141.14.22.331.22.53v9.5A2.75 2.75 0 0 1 14.25 19h-8.5A2.75 2.75 0 0 1 3 16.25V3.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, iye = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="filter">
    <path fill-rule="evenodd" d="M1 4.75A.75.75 0 0 1 1.75 4h16.5a.75.75 0 0 1 0 1.5H1.75A.75.75 0 0 1 1 4.75ZM4 10a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H4.75A.75.75 0 0 1 4 10Zm3 5.25a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, rye = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="fingerprint">
    <path fill-rule="evenodd" d="M1.22 4.72C2.517 3.423 4.95 1 10 1c3.93 0 6.377 1.317 7.78 2.72a.75.75 0 1 1-1.06 1.06C15.623 3.684 13.57 2.5 10 2.5c-4.44 0-6.508 2.068-7.712 3.272l-.008.008a.75.75 0 1 1-1.06-1.06Zm2.852 1.244C5.846 4.429 8.088 3.75 10 3.75c3.44 0 5.72 1.2 7.128 2.82C18.515 8.165 19 10.1 19 11.5c0 .876-.055 1.981-.523 2.878a2.857 2.857 0 0 1-1.12 1.183c-.512.294-1.132.439-1.857.439-1.868 0-3.5-1.54-3.5-3.25 0-.686-.24-1.17-.575-1.484-.344-.322-.84-.516-1.425-.516-.827 0-1.803.674-2.008 2.106-.21 1.468.164 2.766 1.85 4.934a.75.75 0 1 1-1.184.92c-1.814-2.332-2.44-4.034-2.15-6.066C6.803 10.576 8.327 9.25 10 9.25c.915 0 1.794.306 2.45.922.665.622 1.05 1.514 1.05 2.578 0 .79.868 1.75 2 1.75.525 0 .874-.105 1.111-.24.234-.134.405-.325.537-.576.282-.54.352-1.31.352-2.184 0-1.1-.39-2.665-1.504-3.945C14.906 6.3 13.06 5.25 10 5.25c-1.588 0-3.47.571-4.947 1.848C3.598 8.358 2.5 10.335 2.5 13.25a.75.75 0 0 1-1.5 0c0-3.336 1.277-5.733 3.072-7.286ZM10 8c-2.757 0-4.417 2.34-4.624 4.328-.12 1.156.008 2.503.546 3.589a.75.75 0 0 1-1.344.666c-.701-1.414-.834-3.067-.694-4.41C4.146 9.658 6.257 6.5 10 6.5c1.492 0 2.662.34 3.568.89a5.284 5.284 0 0 1 1.902 1.999 6.5 6.5 0 0 1 .78 2.833v.028l-.75.001h.75a.75.75 0 0 1-1.5.003v-.002.001-.003a1.597 1.597 0 0 0-.008-.155 5.002 5.002 0 0 0-.586-1.982 3.785 3.785 0 0 0-1.365-1.44C12.151 8.285 11.258 8 10 8Zm4.75 4.251Zm0 0ZM10 12a.75.75 0 0 1 .75.75c0 2.456 1.775 4.75 4.25 4.75.98 0 1.8-.005 2.864-.643a.75.75 0 1 1 .772 1.286C17.208 19 16.034 19 15.018 19H15c-3.525 0-5.75-3.206-5.75-6.25A.75.75 0 0 1 10 12Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, lye = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="fire">
    <path fill-rule="evenodd" d="M8.422 1.076a.75.75 0 0 1 .772.07c2.023 1.483 2.96 3.223 3.175 4.948a6.722 6.722 0 0 1-.06 2.02c.377-.501.61-1.035.706-1.507a.75.75 0 0 1 1.17-.463C16.029 7.456 17.5 9.153 17.5 11.75c0 3.914-3.086 7.25-7.5 7.25s-7.5-3.336-7.5-7.25c0-1.222.207-2.167.72-3.085.495-.883 1.254-1.7 2.25-2.695.947-.948 1.582-1.866 1.98-2.629.407-.781.542-1.354.55-1.615a.75.75 0 0 1 .422-.65Zm.775 2.027c-.11.294-.248.607-.417.931-.47.903-1.197 1.944-2.25 2.996-1.004 1.004-1.62 1.688-2 2.368-.362.644-.53 1.324-.53 2.352 0 3.086 2.414 5.75 6 5.75s6-2.664 6-5.75c0-1.572-.701-2.734-1.879-3.754a5.988 5.988 0 0 1-3.076 2.943.75.75 0 0 1-.95-1.053c.57-1.028.948-2.305.786-3.605-.129-1.028-.6-2.127-1.684-3.178Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, aye = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="flag">
    <path fill-rule="evenodd" d="M4.75 2.5c-.69 0-1.25.56-1.25 1.25v7.75h12.236l-3.083-4.045a.75.75 0 0 1 0-.91L15.736 2.5H4.75ZM3.5 13v5.25a.75.75 0 0 1-1.5 0V3.75A2.75 2.75 0 0 1 4.75 1h12.5a.75.75 0 0 1 .597 1.205L14.193 7l3.654 4.796A.75.75 0 0 1 17.25 13H3.5Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, cye = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="folder-check" clip-path="url(#a)">
    <path fill-rule="evenodd" d="M1 4.75A2.75 2.75 0 0 1 3.75 2h6a.75.75 0 0 1 .624.334L12.151 5h4.099A2.75 2.75 0 0 1 19 7.75v1.5a.75.75 0 0 1-1.5 0v-1.5c0-.69-.56-1.25-1.25-1.25H2.5v8.75c0 .69.56 1.25 1.25 1.25h5.5a.75.75 0 0 1 0 1.5h-5.5A2.75 2.75 0 0 1 1 15.25V4.75ZM2.5 5h7.849l-1-1.5H3.75c-.69 0-1.25.56-1.25 1.25V5Zm17.265 8.205a.75.75 0 0 1 .03 1.06l-4.25 4.5a.75.75 0 0 1-1.102-.013l-2.25-2.5a.75.75 0 1 1 1.114-1.004l1.706 1.896 3.692-3.909a.75.75 0 0 1 1.06-.03Z" class="Icon" clip-rule="evenodd"/>
  </g>
  <defs>
    <clipPath id="a" class="a">
      <path d="M0 0h20v20H0z"/>
    </clipPath>
  </defs>
</svg>
`, dye = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="folder-close">
    <path fill-rule="evenodd" d="M1 4.75A2.75 2.75 0 0 1 3.75 2h6a.75.75 0 0 1 .624.334L12.151 5h4.099A2.75 2.75 0 0 1 19 7.75v1.5a.75.75 0 0 1-1.5 0v-1.5c0-.69-.56-1.25-1.25-1.25H2.5v8.75c0 .69.56 1.25 1.25 1.25h5.5a.75.75 0 0 1 0 1.5h-5.5A2.75 2.75 0 0 1 1 15.25V4.75ZM2.5 5h7.849l-1-1.5H3.75c-.69 0-1.25.56-1.25 1.25V5Zm10.72 8.22a.75.75 0 0 1 1.06 0L16 14.94l1.72-1.72a.75.75 0 1 1 1.06 1.06L17.06 16l1.72 1.72a.75.75 0 1 1-1.06 1.06L16 17.06l-1.72 1.72a.75.75 0 1 1-1.06-1.06L14.94 16l-1.72-1.72a.75.75 0 0 1 0-1.06Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, uye = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="folder-edit">
    <path fill-rule="evenodd" d="M1 4.75A2.75 2.75 0 0 1 3.75 2h6a.75.75 0 0 1 .624.334L12.151 5h4.099A2.75 2.75 0 0 1 19 7.75v1.5a.75.75 0 0 1-1.5 0v-1.5c0-.69-.56-1.25-1.25-1.25H2.5v8.75c0 .69.56 1.25 1.25 1.25h5.5a.75.75 0 0 1 0 1.5h-5.5A2.75 2.75 0 0 1 1 15.25V4.75ZM2.5 5h7.849l-1-1.5H3.75c-.69 0-1.25.56-1.25 1.25V5Zm15.786 8.714a.73.73 0 0 0-1.033 0L13.5 17.467V18.5h1.033l3.753-3.753a.73.73 0 0 0 0-1.033Zm-2.094-1.06a2.23 2.23 0 1 1 3.155 3.154l-3.973 3.972a.75.75 0 0 1-.53.22H12.75a.75.75 0 0 1-.75-.75v-2.094a.75.75 0 0 1 .22-.53l3.972-3.973Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, hye = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="folder-minus">
    <path fill-rule="evenodd" d="M1 4.75A2.75 2.75 0 0 1 3.75 2h6a.75.75 0 0 1 .624.334L12.151 5h4.099A2.75 2.75 0 0 1 19 7.75v1.5a.75.75 0 0 1-1.5 0v-1.5c0-.69-.56-1.25-1.25-1.25H2.5v8.75c0 .69.56 1.25 1.25 1.25h5.5a.75.75 0 0 1 0 1.5h-5.5A2.75 2.75 0 0 1 1 15.25V4.75ZM2.5 5h7.849l-1-1.5H3.75c-.69 0-1.25.56-1.25 1.25V5ZM12 15.75a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, gye = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="folder-plus">
    <path fill-rule="evenodd" d="M1 4.75A2.75 2.75 0 0 1 3.75 2h6a.75.75 0 0 1 .624.334L12.151 5h4.099A2.75 2.75 0 0 1 19 7.75v1.5a.75.75 0 0 1-1.5 0v-1.5c0-.69-.56-1.25-1.25-1.25H2.5v8.75c0 .69.56 1.25 1.25 1.25h5.5a.75.75 0 0 1 0 1.5h-5.5A2.75 2.75 0 0 1 1 15.25V4.75ZM2.5 5h7.849l-1-1.5H3.75c-.69 0-1.25.56-1.25 1.25V5ZM16 12a.75.75 0 0 1 .75.75v2.5h2.5a.75.75 0 0 1 0 1.5h-2.5v2.5a.75.75 0 0 1-1.5 0v-2.5h-2.5a.75.75 0 0 1 0-1.5h2.5v-2.5A.75.75 0 0 1 16 12Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, pye = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="folder">
    <path fill-rule="evenodd" d="M1 4.75A2.75 2.75 0 0 1 3.75 2h6a.75.75 0 0 1 .624.334L12.151 5h4.099A2.75 2.75 0 0 1 19 7.75v7.5A2.75 2.75 0 0 1 16.25 18H3.75A2.75 2.75 0 0 1 1 15.25V4.75Zm9.349.25-1-1.5H3.75c-.69 0-1.25.56-1.25 1.25V5h7.849ZM2.5 6.5v8.75c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25v-7.5c0-.69-.56-1.25-1.25-1.25H2.5Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, fye = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="format-align-center">
    <path fill-rule="evenodd" d="M1 3.25a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H1.75A.75.75 0 0 1 1 3.25Zm4 4.5A.75.75 0 0 1 5.75 7h8.5a.75.75 0 0 1 0 1.5h-8.5A.75.75 0 0 1 5 7.75Zm-4 4.5a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H1.75a.75.75 0 0 1-.75-.75Zm4 4.5a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1-.75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, vye = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="format-align-justify">
    <path fill-rule="evenodd" d="M1 3.25a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H1.75A.75.75 0 0 1 1 3.25Zm0 4.5A.75.75 0 0 1 1.75 7h16.5a.75.75 0 0 1 0 1.5H1.75A.75.75 0 0 1 1 7.75Zm0 4.5a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H1.75a.75.75 0 0 1-.75-.75Zm0 4.5a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H1.75a.75.75 0 0 1-.75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, mye = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="format-align-left">
    <path fill-rule="evenodd" d="M1 3.25a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H1.75A.75.75 0 0 1 1 3.25Zm0 4.5A.75.75 0 0 1 1.75 7h8.5a.75.75 0 0 1 0 1.5h-8.5A.75.75 0 0 1 1 7.75Zm0 4.5a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H1.75a.75.75 0 0 1-.75-.75Zm0 4.5a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1-.75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Cye = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="format-align-right">
    <path fill-rule="evenodd" d="M1 3.25a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H1.75A.75.75 0 0 1 1 3.25Zm8 4.5A.75.75 0 0 1 9.75 7h8.5a.75.75 0 0 1 0 1.5h-8.5A.75.75 0 0 1 9 7.75Zm-8 4.5a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H1.75a.75.75 0 0 1-.75-.75Zm8 4.5a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1-.75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, wye = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" fill="currentColor" viewBox="0 0 20 21">
  <g class="format-all-small-caps">
    <path fill-rule="evenodd" d="M11.987 8h1.765c1.413 0 2.498 1.086 2.498 2.5 0 .535-.113 1.016-.348 1.413.205.14.383.31.534.507.413.543.564 1.22.564 1.83 0 .61-.15 1.287-.564 1.83-.436.571-1.109.92-1.972.92h-2.477c-.048 0-.135 0-.214-.009a.863.863 0 0 1-.522-.242.863.863 0 0 1-.242-.522 1.561 1.561 0 0 1-.009-.214V8.987c0-.048 0-.135.008-.214a.869.869 0 0 1 .243-.522.863.863 0 0 1 .522-.243C11.852 8 11.939 8 11.987 8Zm1.765 3.5c.385 0 .617-.097.746-.213.116-.105.252-.316.252-.787 0-.586-.415-1-.998-1H12.5v2h1.252ZM12.5 13h1.964c.422 0 .643.151.779.33.158.207.257.53.257.92s-.1.713-.257.92c-.136.179-.357.33-.78.33H12.5V13Zm-6-5a.75.75 0 0 1 .704.492l2.75 7.5a.75.75 0 0 1-1.408.516L7.9 14.75H5.1l-.645 1.758a.75.75 0 1 1-1.408-.516l2.75-7.5A.75.75 0 0 1 6.5 8Zm-.851 5.25H7.35l-.85-2.321-.851 2.321Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, bye = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="format-bold">
    <path fill-rule="evenodd" d="M4 2.75C4 1.784 4.784 1 5.75 1H9.5c2.663 0 5 2.154 5 4.875 0 1.485-.696 2.8-1.76 3.69 1.864.692 3.26 2.457 3.26 4.56C16 16.846 13.663 19 11 19H5.75A1.75 1.75 0 0 1 4 17.25V2.75Zm5.5 6.5c1.893 0 3.5-1.54 3.5-3.375S11.393 2.5 9.5 2.5H5.75a.25.25 0 0 0-.25.25v6.5h4Zm-4 1.5H11c1.893 0 3.5 1.54 3.5 3.375S12.893 17.5 11 17.5H5.75a.25.25 0 0 1-.25-.25v-6.5Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, yye = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="format-font-size">
    <path fill-rule="evenodd" d="M1 2.75C1 1.784 1.784 1 2.75 1h10.5c.966 0 1.75.784 1.75 1.75v2a.75.75 0 0 1-1.5 0v-2a.25.25 0 0 0-.25-.25h-4.5v15h1.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5h1.5v-15h-4.5a.25.25 0 0 0-.25.25v2a.75.75 0 0 1-1.5 0v-2Zm10.25 7.75c0-.69.56-1.25 1.25-1.25h5.25c.69 0 1.25.56 1.25 1.25v1a.75.75 0 0 1-1.5 0v-.75h-1.625v6.75h.375a.75.75 0 0 1 0 1.5H14a.75.75 0 0 1 0-1.5h.375v-6.75H12.75v.75a.75.75 0 0 1-1.5 0v-1Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, _ye = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="format-indent-decrease">
    <path fill-rule="evenodd" d="M1 3.25a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H1.75A.75.75 0 0 1 1 3.25Zm5.591 2.832A.75.75 0 0 1 7 6.75v6.5a.75.75 0 0 1-1.19.608l-4.5-3.25a.75.75 0 0 1 0-1.216l4.5-3.25a.75.75 0 0 1 .781-.06ZM3.031 10 5.5 11.783V8.217L3.031 10ZM9 7.75A.75.75 0 0 1 9.75 7h8.5a.75.75 0 0 1 0 1.5h-8.5A.75.75 0 0 1 9 7.75Zm0 4.5a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1-.75-.75Zm-8 4.5a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H1.75a.75.75 0 0 1-.75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Sye = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="format-indent-increase">
    <path fill-rule="evenodd" d="M1 3.25a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H1.75A.75.75 0 0 1 1 3.25Zm.409 2.832a.75.75 0 0 1 .78.06l4.5 3.25a.75.75 0 0 1 0 1.216l-4.5 3.25A.75.75 0 0 1 1 13.25v-6.5a.75.75 0 0 1 .409-.668ZM2.5 8.217v3.566L4.969 10 2.5 8.217ZM9 7.75A.75.75 0 0 1 9.75 7h8.5a.75.75 0 0 1 0 1.5h-8.5A.75.75 0 0 1 9 7.75Zm0 4.5a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1-.75-.75Zm-8 4.5a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H1.75a.75.75 0 0 1-.75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, xye = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="format-italic">
    <path fill-rule="evenodd" d="M11.237 1H5.75a.75.75 0 0 0 0 1.5h4.628l-2.273 15H3.75a.75.75 0 0 0 0 1.5h10.5a.75.75 0 0 0 0-1.5H9.622l2.273-15h4.355a.75.75 0 0 0 0-1.5h-5.013Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Mye = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="format-letter-spacing">
    <path fill-rule="evenodd" d="M1.75 2a.75.75 0 0 1 .75.75v14.5a.75.75 0 0 1-1.5 0V2.75A.75.75 0 0 1 1.75 2Zm16.5 0a.75.75 0 0 1 .75.75v14.5a.75.75 0 0 1-1.5 0V2.75a.75.75 0 0 1 .75-.75ZM5 5.75C5 4.784 5.784 4 6.75 4h6.5c.966 0 1.75.784 1.75 1.75v2a.75.75 0 0 1-1.5 0v-2a.25.25 0 0 0-.25-.25h-2.5v9h1.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5h1.5v-9h-2.5a.25.25 0 0 0-.25.25v2a.75.75 0 0 1-1.5 0v-2Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Aye = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="format-line-height">
    <path fill-rule="evenodd" d="M1.75 1.75A.75.75 0 0 1 2.5 1H17a.75.75 0 0 1 0 1.5H2.5a.75.75 0 0 1-.75-.75Zm3.25 4C5 4.784 5.784 4 6.75 4h6.5c.966 0 1.75.784 1.75 1.75v2a.75.75 0 0 1-1.5 0v-2a.25.25 0 0 0-.25-.25h-2.5v9h1.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5h1.5v-9h-2.5a.25.25 0 0 0-.25.25v2a.75.75 0 0 1-1.5 0v-2Zm-3.25 12.5a.75.75 0 0 1 .75-.75H17a.75.75 0 0 1 0 1.5H2.5a.75.75 0 0 1-.75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Lye = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" fill="currentColor" viewBox="0 0 20 21">
  <g class="format-lowercase">
    <path fill-rule="evenodd" d="M11.75 5a.75.75 0 0 1 .75.75v3.14c.609-.552 1.376-.89 2.25-.89 2.219 0 3.75 2.18 3.75 4.5S16.969 17 14.75 17c-.874 0-1.641-.338-2.25-.89v.14a.75.75 0 0 1-1.5 0V5.75a.75.75 0 0 1 .75-.75Zm.75 7.5c0 1.822 1.155 3 2.25 3s2.25-1.178 2.25-3-1.155-3-2.25-3-2.25 1.178-2.25 3Zm-11 0C1.5 10.064 3.355 8 5.75 8A4.08 4.08 0 0 1 8.5 9.067V8.75a.75.75 0 0 1 1.5 0v7.5a.75.75 0 0 1-1.5 0v-.318A4.08 4.08 0 0 1 5.75 17c-2.395 0-4.25-2.064-4.25-4.5Zm7 0c0-1.706-1.28-3-2.75-3S3 10.794 3 12.5s1.28 3 2.75 3 2.75-1.294 2.75-3Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Eye = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="format-paragraph-spacing">
    <path fill-rule="evenodd" d="M4.491 1.199a.75.75 0 0 1 1.018 0l3.25 3A.75.75 0 1 1 7.74 5.3L5.75 3.463v13.074l1.991-1.838A.75.75 0 1 1 8.76 15.8l-3.25 3a.75.75 0 0 1-1.018 0l-3.25-3a.75.75 0 1 1 1.018-1.1l1.991 1.838V3.463L2.259 5.301A.75.75 0 1 1 1.24 4.2l3.25-3ZM11 4.75a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75ZM11 10a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5A.75.75 0 0 1 11 10Zm0 5.25a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Pye = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="format-scale-horizontal">
    <path fill-rule="evenodd" d="M5 2.75C5 1.784 5.784 1 6.75 1h6.5c.966 0 1.75.784 1.75 1.75v2a.75.75 0 0 1-1.5 0v-2a.25.25 0 0 0-.25-.25h-2.5v9h1.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5h1.5v-9h-2.5a.25.25 0 0 0-.25.25v2a.75.75 0 0 1-1.5 0v-2Zm-.752 10.44a.75.75 0 0 1 .063 1.058l-.89 1.002H16.58l-.89-1.002a.75.75 0 0 1 1.12-.996l2 2.25a.75.75 0 0 1 0 .996l-2 2.25a.75.75 0 0 1-1.12-.996l.89-1.002H3.42l.89 1.002a.75.75 0 0 1-1.12.996l-2-2.25a.75.75 0 0 1 0-.996l2-2.25a.75.75 0 0 1 1.058-.063Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Rye = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="format-scale-vertical">
    <path fill-rule="evenodd" d="M3.502 1.19a.75.75 0 0 1 .996 0l2.25 2a.75.75 0 0 1-.996 1.12L4.75 3.42v13.16l1.002-.89a.75.75 0 0 1 .996 1.12l-2.25 2a.75.75 0 0 1-.996 0l-2.25-2a.75.75 0 0 1 .996-1.12l1.002.89V3.42l-1.002.89a.75.75 0 1 1-.996-1.12l2.25-2ZM9 5.75C9 4.784 9.783 4 10.75 4h6.5c.966 0 1.75.784 1.75 1.75v2a.75.75 0 0 1-1.5 0v-2a.25.25 0 0 0-.25-.25h-2.5v9h1.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5h1.5v-9h-2.5a.25.25 0 0 0-.25.25v2a.75.75 0 0 1-1.5 0v-2Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Fye = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" fill="currentColor" viewBox="0 0 20 21">
  <g class="format-small-caps">
    <path fill-rule="evenodd" d="M6.5 5c.317 0 .6.2.706.498L9.7 12.48l.012.033 1.244 3.484a.75.75 0 0 1-1.412.504L8.47 13.5H4.53l-1.073 3.002a.75.75 0 0 1-1.412-.504l1.244-3.484a.756.756 0 0 1 .012-.033l2.494-6.983A.75.75 0 0 1 6.5 5Zm-1.436 7h2.872L6.5 7.98 5.064 12Zm7.923-4h1.765c1.413 0 2.498 1.086 2.498 2.5 0 .535-.113 1.016-.348 1.413.205.14.383.31.534.507.413.543.564 1.22.564 1.83 0 .61-.15 1.287-.564 1.83-.436.571-1.109.92-1.972.92h-2.477c-.048 0-.135 0-.214-.009a.863.863 0 0 1-.522-.242.863.863 0 0 1-.242-.522 1.561 1.561 0 0 1-.009-.214V8.987c0-.048 0-.135.008-.214a.869.869 0 0 1 .243-.522.863.863 0 0 1 .522-.243C12.852 8 12.939 8 12.987 8Zm1.765 3.5c.385 0 .617-.097.746-.213.116-.105.252-.316.252-.787 0-.586-.415-1-.998-1H13.5v2h1.252ZM13.5 13h1.964c.422 0 .643.151.779.33.158.207.257.53.257.92s-.1.713-.257.92c-.136.179-.356.33-.78.33H13.5V13Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Tye = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="format-strikethrough">
    <path fill-rule="evenodd" d="M3 1.75A.75.75 0 0 1 3.75 1h12.5a.75.75 0 0 1 0 1.5h-5.5v2.75a.75.75 0 0 1-1.5 0V2.5h-5.5A.75.75 0 0 1 3 1.75ZM2 10a.75.75 0 0 1 .75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 10Zm8 3a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0v-4.5A.75.75 0 0 1 10 13Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Iye = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="format-subscript">
    <path fill-rule="evenodd" d="M3 5.75C3 4.784 3.784 4 4.75 4h6.5c.966 0 1.75.784 1.75 1.75v2a.75.75 0 0 1-1.5 0v-2a.25.25 0 0 0-.25-.25h-2.5v9h1.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5h1.5v-9h-2.5a.25.25 0 0 0-.25.25v2a.75.75 0 0 1-1.5 0v-2Zm9.44 7.57c.36-.462.953-.82 1.81-.82.844 0 1.53.35 1.936.959.39.585.457 1.311.292 1.973-.112.445-.447.877-.743 1.208-.26.292-.567.587-.87.86h1.385a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.441-1.357l.006-.004.02-.015.084-.062a22.201 22.201 0 0 0 1.245-1.003c.348-.303.69-.623.952-.918.132-.147.235-.278.307-.388a1.208 1.208 0 0 0 .095-.172l.004-.013c.085-.338.027-.612-.084-.777-.093-.14-.282-.291-.688-.291-.393 0-.55.142-.627.242a.662.662 0 0 0-.103.194c-.017.05-.02.08-.02.08A.75.75 0 0 1 12 14.5c0-.282.113-.76.44-1.18Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Dye = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="format-superscript">
    <path fill-rule="evenodd" d="M14.44 1.82c.36-.462.953-.82 1.81-.82.843 0 1.53.35 1.936.959.39.585.457 1.311.292 1.973-.112.445-.447.877-.743 1.208-.26.292-.567.587-.87.86h1.385a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.441-1.356v-.001l.006-.004.02-.015.084-.062a22.647 22.647 0 0 0 1.245-1.003c.348-.303.69-.623.952-.918a3.49 3.49 0 0 0 .307-.388 1.204 1.204 0 0 0 .095-.172l.004-.013c.085-.338.027-.612-.083-.777-.094-.14-.282-.291-.689-.291-.393 0-.55.142-.627.242a.662.662 0 0 0-.103.194c-.017.05-.02.08-.02.08A.75.75 0 0 1 14 3c0-.282.113-.76.44-1.18ZM3 5.75C3 4.784 3.784 4 4.75 4h6.5c.966 0 1.75.784 1.75 1.75v2a.75.75 0 0 1-1.5 0v-2a.25.25 0 0 0-.25-.25h-2.5v9h1.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5h1.5v-9h-2.5a.25.25 0 0 0-.25.25v2a.75.75 0 0 1-1.5 0v-2Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, kye = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" fill="currentColor" viewBox="0 0 20 21">
  <g class="format-titlecase">
    <path fill-rule="evenodd" d="M5.5 5c.317 0 .6.2.706.498L8.7 12.48l.012.033 1.244 3.484a.75.75 0 0 1-1.412.504L7.47 13.5H3.53l-1.073 3.002a.75.75 0 0 1-1.412-.504l1.244-3.484a.77.77 0 0 1 .012-.033l2.494-6.983A.75.75 0 0 1 5.5 5Zm-1.436 7h2.872L5.5 7.98 4.064 12Zm8.186-7a.75.75 0 0 1 .75.75v3.14c.609-.552 1.376-.89 2.25-.89C17.469 8 19 10.18 19 12.5S17.469 17 15.25 17c-.874 0-1.641-.338-2.25-.89v.14a.75.75 0 0 1-1.5 0V5.75a.75.75 0 0 1 .75-.75Zm.75 7.5c0 1.822 1.155 3 2.25 3s2.25-1.178 2.25-3-1.155-3-2.25-3-2.25 1.178-2.25 3Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Hye = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="format-underline">
    <path fill-rule="evenodd" d="M4.75 1a.75.75 0 0 1 .75.75V11a4.5 4.5 0 1 0 9 0V1.75a.75.75 0 0 1 1.5 0V11a6 6 0 0 1-12 0V1.75A.75.75 0 0 1 4.75 1ZM3 19.25a.75.75 0 0 1 .75-.75h12.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Vye = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" fill="currentColor" viewBox="0 0 20 21">
  <g class="format-uppercase">
    <path fill-rule="evenodd" d="M5.5 5c.317 0 .6.2.706.498L8.7 12.48l.012.033 1.244 3.484a.75.75 0 0 1-1.412.504L7.47 13.5H3.53l-1.073 3.002a.75.75 0 0 1-1.412-.504l1.244-3.484a.77.77 0 0 1 .012-.033l2.494-6.983A.75.75 0 0 1 5.5 5Zm-1.436 7h2.872L5.5 7.98 4.064 12Zm7.312-6.624A1.25 1.25 0 0 1 12.25 5h2.523C16.738 5 18 6.664 18 8.375c0 .872-.244 1.654-.727 2.252A3.299 3.299 0 0 1 19 13.5c0 1.822-1.25 3.5-3.273 3.5H12.25a1.25 1.25 0 0 1-.874-.376A1.25 1.25 0 0 1 11 15.75v-9.5c0-.369.177-.675.376-.874Zm3.397 4.874c.564 0 .977-.187 1.251-.472.276-.288.476-.745.476-1.403 0-1.04-.739-1.875-1.727-1.875H12.5v3.75h2.273Zm-2.273 1.5h3.227A1.76 1.76 0 0 1 17.5 13.5c0 1.178-.75 2-1.773 2H12.5v-3.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Oye = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="forward">
    <path fill-rule="evenodd" d="M9.64 4.093a.75.75 0 0 1 .763.024l8.25 5.25a.75.75 0 0 1 0 1.266l-8.25 5.25a.75.75 0 0 1-1.153-.633v-3.884l-7.097 4.517A.75.75 0 0 1 1 15.25V4.75a.75.75 0 0 1 1.153-.633L9.25 8.634V4.75a.75.75 0 0 1 .39-.657Zm1.11 9.79L16.853 10 10.75 6.116v7.768ZM8.603 10 2.5 6.116v7.768L8.603 10Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Bye = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="fullscreen-exit">
    <path fill-rule="evenodd" d="M6.25 1a.75.75 0 0 1 .75.75v2.5A2.75 2.75 0 0 1 4.25 7h-2.5a.75.75 0 0 1 0-1.5h2.5c.69 0 1.25-.56 1.25-1.25v-2.5A.75.75 0 0 1 6.25 1Zm7.5 0a.75.75 0 0 1 .75.75v2.5c0 .69.56 1.25 1.25 1.25h2.5a.75.75 0 0 1 0 1.5h-2.5A2.75 2.75 0 0 1 13 4.25v-2.5a.75.75 0 0 1 .75-.75ZM1 13.75a.75.75 0 0 1 .75-.75h2.5A2.75 2.75 0 0 1 7 15.75v2.5a.75.75 0 0 1-1.5 0v-2.5c0-.69-.56-1.25-1.25-1.25h-2.5a.75.75 0 0 1-.75-.75Zm12 2A2.75 2.75 0 0 1 15.75 13h2.5a.75.75 0 0 1 0 1.5h-2.5c-.69 0-1.25.56-1.25 1.25v2.5a.75.75 0 0 1-1.5 0v-2.5Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, $ye = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="fullscreen">
    <path fill-rule="evenodd" d="M3.75 2.5c-.69 0-1.25.56-1.25 1.25v2.5a.75.75 0 0 1-1.5 0v-2.5A2.75 2.75 0 0 1 3.75 1h2.5a.75.75 0 0 1 0 1.5h-2.5ZM13 1.75a.75.75 0 0 1 .75-.75h2.5A2.75 2.75 0 0 1 19 3.75v2.5a.75.75 0 0 1-1.5 0v-2.5c0-.69-.56-1.25-1.25-1.25h-2.5a.75.75 0 0 1-.75-.75ZM1.75 13a.75.75 0 0 1 .75.75v2.5c0 .69.56 1.25 1.25 1.25h2.5a.75.75 0 0 1 0 1.5h-2.5A2.75 2.75 0 0 1 1 16.25v-2.5a.75.75 0 0 1 .75-.75Zm16.5 0a.75.75 0 0 1 .75.75v2.5A2.75 2.75 0 0 1 16.25 19h-2.5a.75.75 0 0 1 0-1.5h2.5c.69 0 1.25-.56 1.25-1.25v-2.5a.75.75 0 0 1 .75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Zye = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="function">
    <path fill-rule="evenodd" d="M9.482 3.663c.108-.423.26-.723.428-.907a.74.74 0 0 1 .59-.256 1 1 0 0 1 1 1 .75.75 0 0 0 1.5 0A2.5 2.5 0 0 0 10.5 1c-.705 0-1.277.284-1.697.744-.4.438-.639 1.007-.78 1.574a.758.758 0 0 0-.01.04L6.93 9H4.5a.75.75 0 0 0 0 1.5h2.14l-1.122 5.837c-.108.423-.26.723-.428.907a.74.74 0 0 1-.59.256 1 1 0 0 1-1-1 .75.75 0 0 0-1.5 0A2.5 2.5 0 0 0 4.5 19c.705 0 1.277-.284 1.697-.744.4-.438.639-1.007.78-1.574a.751.751 0 0 0 .01-.04l1.18-6.142h3.12a.25.25 0 0 1 .19.089L13.517 13l-2.34 2.766a.75.75 0 1 0 1.146.969L14.5 14.16l2.177 2.574a.75.75 0 0 0 1.146-.97L15.483 13l2.34-2.765a.75.75 0 1 0-1.146-.97L14.5 11.84l-1.878-2.22A1.75 1.75 0 0 0 11.286 9h-2.83l1.026-5.337Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Gye = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="git-branch">
    <path fill-rule="evenodd" d="M5 2.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM2 4a3 3 0 1 1 3.744 2.907c.004.03.006.061.006.093v3.55c.375-.192.8-.3 1.25-.3h6c.69 0 1.25-.56 1.25-1.25 0-.032.002-.063.006-.093A3.001 3.001 0 0 1 15 3a3 3 0 0 1 .744 5.907c.004.03.006.061.006.093A2.75 2.75 0 0 1 13 11.75H7c-.69 0-1.25.56-1.25 1.25a.757.757 0 0 1-.006.093 3.001 3.001 0 1 1-1.488 0A.756.756 0 0 1 4.25 13V7c0-.032.002-.063.006-.093A3.001 3.001 0 0 1 2 4Zm13 .5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm-10 10a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Nye = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="git-commit">
    <path fill-rule="evenodd" d="M10 7a3 3 0 1 0 0 6 3 3 0 0 0 0-6ZM5.562 9.25a4.501 4.501 0 0 1 8.876 0h2.812a.75.75 0 0 1 0 1.5h-2.812a4.501 4.501 0 0 1-8.876 0H2.75a.75.75 0 0 1 0-1.5h2.812Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, zye = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="git-diff">
    <path fill-rule="evenodd" d="M4 2.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM1 4a3 3 0 1 1 3.744 2.907c.004.03.006.061.006.093v5.8c0 .572 0 .957.025 1.252.023.288.065.425.111.516.12.235.311.426.547.546.09.046.227.088.514.111.28.023.64.025 1.165.025l-.83-.664a.75.75 0 0 1 .937-1.172l2.5 2a.75.75 0 0 1 0 1.172l-2.5 2a.75.75 0 0 1-.938-1.172l.83-.664c-.508 0-.935-.001-1.286-.03-.38-.03-.736-.098-1.073-.27a2.75 2.75 0 0 1-1.202-1.2c-.172-.338-.24-.694-.27-1.074-.03-.365-.03-.81-.03-1.345V7c0-.032.002-.063.006-.093A3.001 3.001 0 0 1 1 4Zm11.836-2.469a.75.75 0 0 1-.117 1.055l-.83.664h.941c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27a2.75 2.75 0 0 1 1.202 1.202c.172.337.24.693.27 1.073.03.365.03.81.03 1.345V13a.753.753 0 0 1-.006.093 3.001 3.001 0 1 1-1.488 0A.75.75 0 0 1 15.25 13V7.2c0-.572 0-.957-.025-1.253-.023-.287-.065-.424-.111-.514a1.25 1.25 0 0 0-.546-.547c-.091-.046-.228-.088-.515-.111-.296-.024-.68-.025-1.253-.025h-.912l.83.664a.75.75 0 1 1-.937 1.172l-2.5-2a.75.75 0 0 1 0-1.172l2.5-2a.75.75 0 0 1 1.055.117ZM16 14.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, jye = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="git-fork">
    <path fill-rule="evenodd" d="M4 2.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM1 4a3 3 0 1 1 3.753 2.905c.002.15.007.276.014.388.017.241.046.358.078.435.127.307.37.55.677.677.077.032.194.061.435.078.247.017.567.017 1.043.017h6c.476 0 .796 0 1.043-.017.241-.017.358-.046.435-.078.307-.127.55-.37.677-.677.032-.077.061-.194.078-.435.007-.112.012-.239.014-.388A3.001 3.001 0 0 1 16 1a3 3 0 0 1 .747 5.906c-.003.18-.008.342-.018.49a2.822 2.822 0 0 1-.188.906 2.75 2.75 0 0 1-1.489 1.489c-.29.12-.59.167-.907.188-.304.021-.675.021-1.12.021H10.75v3.095A3.001 3.001 0 0 1 10 19a3 3 0 0 1-.75-5.905V10H6.975c-.445 0-.816 0-1.12-.02a2.823 2.823 0 0 1-.907-.19 2.75 2.75 0 0 1-1.489-1.488c-.12-.29-.167-.59-.188-.907a9.33 9.33 0 0 1-.018-.489A3.001 3.001 0 0 1 1 4Zm15-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm-6 12a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Wye = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="git-merge">
    <path fill-rule="evenodd" d="M4 2.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM1 4a3 3 0 1 1 3.744 2.907c.004.03.006.061.006.093v2.55c.375-.192.8-.3 1.25-.3h7.095a3.001 3.001 0 1 1 0 1.5H6c-.69 0-1.25.56-1.25 1.25v1a.757.757 0 0 1-.006.093 3.001 3.001 0 1 1-1.488 0A.756.756 0 0 1 3.25 13V7c0-.032.002-.063.006-.093A3.001 3.001 0 0 1 1 4Zm15 4.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm-12 6a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Uye = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="git-pull-request">
    <path fill-rule="evenodd" d="M4 2.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM1 4a3 3 0 1 1 3.744 2.907c.004.03.006.061.006.093v6.095a3.001 3.001 0 1 1-1.5 0V7c0-.032.002-.063.006-.093A3.001 3.001 0 0 1 1 4Zm11.836-2.469a.75.75 0 0 1-.117 1.055l-.83.664h.941c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27a2.75 2.75 0 0 1 1.202 1.202c.172.337.24.693.27 1.073.03.365.03.81.03 1.345V13a.753.753 0 0 1-.006.093 3.001 3.001 0 1 1-1.488 0A.75.75 0 0 1 15.25 13V7.2c0-.572 0-.957-.025-1.253-.023-.287-.065-.424-.111-.514a1.25 1.25 0 0 0-.546-.547c-.091-.046-.228-.088-.515-.111-.296-.024-.68-.025-1.253-.025h-.912l.83.664a.75.75 0 1 1-.937 1.172l-2.5-2a.75.75 0 0 1 0-1.172l2.5-2a.75.75 0 0 1 1.055.117ZM4 14.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm12 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Kye = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="globe">
    <path fill-rule="evenodd" d="M2.537 9.25h3.476c.07-2.056.428-3.93.991-5.359a8.41 8.41 0 0 1 .437-.943A7.507 7.507 0 0 0 2.537 9.25ZM10 1a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm0 1.5c-.172 0-.414.085-.716.41-.303.325-.61.836-.884 1.531-.483 1.227-.816 2.907-.886 4.809h4.972c-.07-1.902-.403-3.582-.886-4.809-.274-.695-.58-1.206-.884-1.532-.302-.324-.544-.409-.716-.409Zm3.987 6.75c-.07-2.056-.428-3.93-.991-5.359a8.4 8.4 0 0 0-.437-.943 7.507 7.507 0 0 1 4.904 6.302h-3.476Zm-1.5 1.5H7.513c.07 1.902.403 3.582.886 4.809.273.695.58 1.206.884 1.531.302.325.544.41.716.41.172 0 .414-.085.716-.41.303-.325.61-.836.884-1.531.483-1.227.816-2.907.886-4.809Zm.072 6.302c.16-.292.305-.609.437-.944.563-1.428.92-3.302.991-5.358h3.476a7.507 7.507 0 0 1-4.904 6.302Zm-5.118 0a8.404 8.404 0 0 1-.437-.944c-.563-1.428-.92-3.302-.991-5.358H2.537a7.507 7.507 0 0 0 4.904 6.302Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, qye = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="hashtag">
    <path fill-rule="evenodd" d="M9.452 3.028a.75.75 0 0 1 .52.924L9.26 6.5h3.44l.827-2.952a.75.75 0 0 1 1.444.404L14.26 6.5h2.991a.75.75 0 0 1 0 1.5H13.84l-1.12 4h2.531a.75.75 0 0 1 0 1.5H12.3l-.827 2.952a.75.75 0 1 1-1.444-.404l.713-2.548H7.3l-.827 2.952a.75.75 0 1 1-1.444-.404L5.74 13.5H2.75a.75.75 0 0 1 0-1.5h3.411l1.12-4H4.75a.75.75 0 0 1 0-1.5h2.951l.827-2.952a.75.75 0 0 1 .924-.52ZM8.84 8l-1.12 4h3.442l1.12-4H8.84Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Yye = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="heading">
    <path fill-rule="evenodd" d="M3 1.75A.75.75 0 0 1 3.75 1h4a.75.75 0 0 1 0 1.5H6.5v6.75H14V2.5h-1.25a.75.75 0 0 1 0-1.5h4a.75.75 0 0 1 0 1.5H15.5v15h1.25a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1 0-1.5H14v-6.75H6.5v6.75h1.25a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1 0-1.5H5v-15H3.75A.75.75 0 0 1 3 1.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Qye = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="headphones">
    <path fill-rule="evenodd" d="M10 2.5A6.5 6.5 0 0 0 3.5 9v2h.58c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 7.7 12.5c.172.338.24.694.27 1.074.03.365.03.81.03 1.345v1.117c0 .196 0 .347-.013.483a2.75 2.75 0 0 1-2.467 2.467 5.123 5.123 0 0 1-.483.013h-.074c-.196 0-.347 0-.483-.013a2.75 2.75 0 0 1-2.467-2.467C2 16.384 2 16.233 2 16.037V9a8 8 0 1 1 16 0v7.037c0 .196 0 .347-.013.483a2.75 2.75 0 0 1-2.467 2.467 5.122 5.122 0 0 1-.483.013h-.074c-.196 0-.347 0-.483-.013a2.75 2.75 0 0 1-2.467-2.467 5.122 5.122 0 0 1-.013-.483V14.92c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073a2.751 2.751 0 0 1 1.2-1.202c.338-.172.694-.24 1.074-.27.365-.03.81-.03 1.345-.03h.58V9A6.5 6.5 0 0 0 10 2.5Zm6.5 10h-.55c-.572 0-.957 0-1.252.025-.288.023-.425.065-.516.111a1.25 1.25 0 0 0-.546.546c-.046.091-.088.228-.111.515-.024.296-.025.68-.025 1.253V16c0 .25 0 .32.006.372a1.25 1.25 0 0 0 1.121 1.122c.052.005.123.006.373.006s.32 0 .373-.006a1.25 1.25 0 0 0 1.121-1.122A4.72 4.72 0 0 0 16.5 16v-3.5Zm-13 0V16c0 .25 0 .32.006.372a1.25 1.25 0 0 0 1.121 1.122c.052.005.123.006.373.006s.32 0 .373-.006a1.25 1.25 0 0 0 1.121-1.122A4.72 4.72 0 0 0 6.5 16v-1.05c0-.572 0-.957-.025-1.252-.023-.288-.065-.425-.111-.516a1.25 1.25 0 0 0-.547-.546c-.09-.046-.227-.088-.514-.111-.296-.024-.68-.025-1.253-.025H3.5Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Jye = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="health">
    <path fill-rule="evenodd" d="M7 2.75C7 1.784 7.784 1 8.75 1h2.5c.966 0 1.75.784 1.75 1.75V7h4.25c.966 0 1.75.784 1.75 1.75v2.5A1.75 1.75 0 0 1 17.25 13H13v4.25A1.75 1.75 0 0 1 11.25 19h-2.5A1.75 1.75 0 0 1 7 17.25V13H2.75A1.75 1.75 0 0 1 1 11.25v-2.5C1 7.784 1.784 7 2.75 7H7V2.75Zm1.75-.25a.25.25 0 0 0-.25.25v5a.75.75 0 0 1-.75.75h-5a.25.25 0 0 0-.25.25v2.5c0 .138.112.25.25.25h5a.75.75 0 0 1 .75.75v5c0 .138.112.25.25.25h2.5a.25.25 0 0 0 .25-.25v-5a.75.75 0 0 1 .75-.75h5a.25.25 0 0 0 .25-.25v-2.5a.25.25 0 0 0-.25-.25h-5a.75.75 0 0 1-.75-.75v-5a.25.25 0 0 0-.25-.25h-2.5Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Xye = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="heart">
    <path fill-rule="evenodd" d="M13.511 3.525c-.977.123-2.029.731-2.873 2.098a.75.75 0 0 1-1.276 0c-.844-1.367-1.896-1.975-2.873-2.098-.99-.125-2.006.23-2.804.993-1.58 1.522-1.58 4.088 0 5.61L10 16.208l6.314-6.08c1.58-1.522 1.581-4.088.001-5.61-.798-.762-1.815-1.118-2.804-.993Zm-.188-1.488c1.484-.188 2.94.357 4.03 1.397l.002.002c2.193 2.113 2.193 5.66 0 7.773L10.52 17.79a.75.75 0 0 1-1.04 0l-6.835-6.58c-2.193-2.113-2.193-5.66 0-7.773l.002-.002c1.09-1.04 2.546-1.585 4.03-1.397 1.21.153 2.371.783 3.323 1.912.952-1.129 2.113-1.76 3.323-1.912Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, e_e = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="help-fill">
    <path fill-rule="evenodd" d="M10 1a9 9 0 1 0 0 18 9 9 0 0 0 0-18ZM8.5 8A1.5 1.5 0 1 1 10 9.5a.75.75 0 0 0-.75.75v1a.75.75 0 0 0 1.5 0v-.345A3.001 3.001 0 0 0 10 5a3 3 0 0 0-3 3 .75.75 0 0 0 1.5 0Zm2.25 5.75a.75.75 0 0 0-1.5 0v.5a.75.75 0 0 0 1.5 0v-.5Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, t_e = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="help">
    <path fill-rule="evenodd" d="M10 2.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15ZM1 10a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm9-3.5A1.5 1.5 0 0 0 8.5 8 .75.75 0 0 1 7 8a3 3 0 1 1 3.75 2.905v.345a.75.75 0 0 1-1.5 0v-1A.75.75 0 0 1 10 9.5a1.5 1.5 0 0 0 0-3Zm0 6.5a.75.75 0 0 1 .75.75v.5a.75.75 0 0 1-1.5 0v-.5A.75.75 0 0 1 10 13Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, o_e = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="home">
    <path fill-rule="evenodd" d="M9.574 1.133a.75.75 0 0 1 .852 0l6.385 4.403A2.75 2.75 0 0 1 18 7.8v8.45A2.75 2.75 0 0 1 15.25 19H4.75A2.75 2.75 0 0 1 2 16.25V7.8c0-.904.444-1.75 1.189-2.264l6.385-4.403ZM8.5 17.5h3v-4.75a.25.25 0 0 0-.25-.25h-2.5a.25.25 0 0 0-.25.25v4.75Zm4.5 0v-4.75A1.75 1.75 0 0 0 11.25 11h-2.5A1.75 1.75 0 0 0 7 12.75v4.75H4.75c-.69 0-1.25-.56-1.25-1.25V7.8c0-.41.202-.795.54-1.029L10 2.661l5.96 4.11c.338.234.54.618.54 1.03v8.449c0 .69-.56 1.25-1.25 1.25H13Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, n_e = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="horizontal-align-center">
    <path fill-rule="evenodd" d="M19 10a.75.75 0 0 1-.75.75h-3.787l1.838 1.991A.75.75 0 1 1 15.2 13.76l-3-3.25a.75.75 0 0 1 0-1.018l3-3.25a.75.75 0 1 1 1.1 1.018l-1.837 1.99h3.787A.75.75 0 0 1 19 10Zm-9-9a.75.75 0 0 1 .75.75v16.5a.75.75 0 0 1-1.5 0V1.75A.75.75 0 0 1 10 1ZM4.801 6.241l3 3.25a.75.75 0 0 1 0 1.018l-3 3.25A.75.75 0 1 1 3.7 12.74l1.838-1.991H1.75a.75.75 0 0 1 0-1.5h3.787l-1.838-1.99A.75.75 0 1 1 4.8 6.24Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, s_e = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="horizontal-align-left">
    <path fill-rule="evenodd" d="M1.75 1a.75.75 0 0 1 .75.75v16.5a.75.75 0 0 1-1.5 0V1.75A.75.75 0 0 1 1.75 1Zm7.514 4.204a.75.75 0 0 1 .032 1.06L6.486 9.25H18.25a.75.75 0 0 1 0 1.5H6.486l2.81 2.986a.75.75 0 1 1-1.092 1.028l-4-4.25a.75.75 0 0 1 0-1.028l4-4.25a.75.75 0 0 1 1.06-.032Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, i_e = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="horizontal-align-right">
    <path fill-rule="evenodd" d="M18.25 1a.75.75 0 0 1 .75.75v16.5a.75.75 0 0 1-1.5 0V1.75a.75.75 0 0 1 .75-.75Zm-7.514 4.204a.75.75 0 0 1 1.06.032l4 4.25a.75.75 0 0 1 0 1.028l-4 4.25a.75.75 0 0 1-1.092-1.028l2.81-2.986H1.75a.75.75 0 0 1 0-1.5h11.764l-2.81-2.986a.75.75 0 0 1 .032-1.06Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, r_e = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="hourglass">
    <path fill-rule="evenodd" d="M3 1.75A.75.75 0 0 1 3.75 1h12.5a.75.75 0 0 1 0 1.5H15v1.719c0 .478-.125.949-.362 1.364l-2.17 3.797a1.25 1.25 0 0 0 0 1.24l2.17 3.797c.237.415.362.886.362 1.364V17.5h1.25a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1 0-1.5H5v-1.719c0-.478.125-.949.362-1.364l2.17-3.797a1.25 1.25 0 0 0 0-1.24l-2.17-3.797A2.75 2.75 0 0 1 5 4.22V2.5H3.75A.75.75 0 0 1 3 1.75Zm3.5.75v1.719c0 .217.057.431.165.62l2.17 3.797a2.75 2.75 0 0 1 0 2.728l-2.17 3.797a1.25 1.25 0 0 0-.165.62V17.5h7v-1.719a1.25 1.25 0 0 0-.165-.62l-2.17-3.797a2.75 2.75 0 0 1 0-2.728l2.17-3.797a1.25 1.25 0 0 0 .165-.62V2.5h-7Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, l_e = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="image-check" clip-path="url(#a)">
    <path fill-rule="evenodd" d="M19.765.205a.75.75 0 0 1 .03 1.06l-4.25 4.5a.75.75 0 0 1-1.102-.013l-2.25-2.5a.75.75 0 1 1 1.114-1.004l1.706 1.896L18.705.235a.75.75 0 0 1 1.06-.03ZM1 3.75A2.75 2.75 0 0 1 3.75 1h5.5a.75.75 0 0 1 0 1.5h-5.5c-.69 0-1.25.56-1.25 1.25v7.242l4.023-3.32a.75.75 0 0 1 1.018.058l3.08 3.204 3.463-2.308a.75.75 0 0 1 .928.076l3.75 3.5a.75.75 0 0 1 .238.548v3.5A2.75 2.75 0 0 1 16.25 19H3.75A2.75 2.75 0 0 1 1 16.25V3.75Zm10.678 8.283 2.113 2.197a.75.75 0 1 1-1.082 1.04l-5.768-6L2.5 12.937v3.313c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25v-3.174l-3.078-2.873-2.744 1.83Z" class="Icon" clip-rule="evenodd"/>
  </g>
  <defs>
    <clipPath id="a" class="a">
      <path d="M0 0h20v20H0z"/>
    </clipPath>
  </defs>
</svg>
`, a_e = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="image-close">
    <path fill-rule="evenodd" d="M13.22.22a.75.75 0 0 1 1.06 0L16 1.94 17.72.22a.75.75 0 1 1 1.06 1.06L17.06 3l1.72 1.72a.75.75 0 0 1-1.06 1.06L16 4.06l-1.72 1.72a.75.75 0 1 1-1.06-1.06L14.94 3l-1.72-1.72a.75.75 0 0 1 0-1.06ZM1 3.75A2.75 2.75 0 0 1 3.75 1h5.5a.75.75 0 0 1 0 1.5h-5.5c-.69 0-1.25.56-1.25 1.25v7.242l4.023-3.32a.75.75 0 0 1 1.018.058l3.08 3.204 3.463-2.308a.75.75 0 0 1 .928.076l3.75 3.5a.75.75 0 0 1 .238.548v3.5A2.75 2.75 0 0 1 16.25 19H3.75A2.75 2.75 0 0 1 1 16.25V3.75Zm10.678 8.283 2.113 2.197a.75.75 0 1 1-1.082 1.04l-5.768-6L2.5 12.937v3.313c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25v-3.174l-3.078-2.873-2.744 1.83Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, c_e = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="image-edit" clip-path="url(#a)">
    <path fill-rule="evenodd" d="M18.286 1.714a.73.73 0 0 0-1.033 0L13.5 5.467V6.5h1.033l3.753-3.753a.73.73 0 0 0 0-1.033ZM16.192.654a2.23 2.23 0 1 1 3.155 3.154L15.374 7.78a.75.75 0 0 1-.53.22H12.75a.75.75 0 0 1-.75-.75V5.156a.75.75 0 0 1 .22-.53L16.192.653ZM1 3.75A2.75 2.75 0 0 1 3.75 1h5.5a.75.75 0 0 1 0 1.5h-5.5c-.69 0-1.25.56-1.25 1.25v7.242l4.023-3.32a.75.75 0 0 1 1.018.058l3.08 3.204 3.463-2.308a.75.75 0 0 1 .928.076l3.75 3.5a.75.75 0 0 1 .238.548v3.5A2.75 2.75 0 0 1 16.25 19H3.75A2.75 2.75 0 0 1 1 16.25V3.75Zm10.678 8.283 2.113 2.197a.75.75 0 1 1-1.082 1.04l-5.768-6L2.5 12.937v3.313c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25v-3.174l-3.078-2.873-2.744 1.83Z" class="Icon" clip-rule="evenodd"/>
  </g>
  <defs>
    <clipPath id="a" class="a">
      <path d="M0 0h20v20H0z"/>
    </clipPath>
  </defs>
</svg>
`, d_e = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="image-minus">
    <path fill-rule="evenodd" d="M1 3.75A2.75 2.75 0 0 1 3.75 1h5.5a.75.75 0 0 1 0 1.5h-5.5c-.69 0-1.25.56-1.25 1.25v7.242l4.023-3.32a.75.75 0 0 1 1.018.058l3.08 3.204 3.463-2.308a.75.75 0 0 1 .928.076l3.75 3.5a.75.75 0 0 1 .238.548v3.5A2.75 2.75 0 0 1 16.25 19H3.75A2.75 2.75 0 0 1 1 16.25V3.75Zm10.678 8.283 2.113 2.197a.75.75 0 1 1-1.082 1.04l-5.768-6L2.5 12.937v3.313c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25v-3.174l-3.078-2.873-2.744 1.83ZM12 3.75a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, u_e = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="image-plus">
    <path fill-rule="evenodd" d="M16 0a.75.75 0 0 1 .75.75v2.5h2.5a.75.75 0 0 1 0 1.5h-2.5v2.5a.75.75 0 0 1-1.5 0v-2.5h-2.5a.75.75 0 0 1 0-1.5h2.5V.75A.75.75 0 0 1 16 0ZM1 3.75A2.75 2.75 0 0 1 3.75 1h5.5a.75.75 0 0 1 0 1.5h-5.5c-.69 0-1.25.56-1.25 1.25v7.242l4.023-3.32a.75.75 0 0 1 1.018.058l3.08 3.204 3.463-2.308a.75.75 0 0 1 .928.076l3.75 3.5a.75.75 0 0 1 .238.548v3.5A2.75 2.75 0 0 1 16.25 19H3.75A2.75 2.75 0 0 1 1 16.25V3.75Zm10.678 8.283 2.113 2.197a.75.75 0 1 1-1.082 1.04l-5.768-6L2.5 12.937v3.313c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25v-3.174l-3.078-2.873-2.744 1.83Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, h_e = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="image">
    <path fill-rule="evenodd" d="M1 3.75A2.75 2.75 0 0 1 3.75 1h12.5A2.75 2.75 0 0 1 19 3.75v12.5A2.75 2.75 0 0 1 16.25 19H3.75A2.75 2.75 0 0 1 1 16.25V3.75Zm1.5 9.187v3.313c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25v-3.174l-3.078-2.873-2.744 1.83 2.113 2.197a.75.75 0 1 1-1.082 1.04l-5.768-6L2.5 12.937Zm8.121-2.003L7.541 7.73a.75.75 0 0 0-1.018-.058L2.5 10.992V3.75c0-.69.56-1.25 1.25-1.25h12.5c.69 0 1.25.56 1.25 1.25v7.274l-2.488-2.322a.75.75 0 0 0-.928-.076l-3.463 2.308Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, g_e = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="images">
    <path fill-rule="evenodd" d="M16.302 2.525c-.295-.024-.68-.025-1.252-.025h-7.3a.75.75 0 0 1 0-1.5h7.33c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 18.7 2.502c.172.337.24.693.27 1.073.03.365.03.81.03 1.345v7.34a.75.75 0 0 1-1.5 0V4.95c0-.572 0-.957-.025-1.253-.023-.287-.065-.424-.111-.514a1.25 1.25 0 0 0-.547-.547c-.09-.046-.227-.088-.515-.111ZM4.92 4h7.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 15.7 5.502c.172.337.24.693.27 1.073.03.365.03.81.03 1.345v7.161c0 .534 0 .98-.03 1.344-.03.38-.098.736-.27 1.073a2.751 2.751 0 0 1-1.2 1.202c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03H4.92c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 1.3 17.5c-.172-.338-.24-.694-.27-1.074C1 16.06 1 15.615 1 15.08V7.92c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 2.502 4.3c.337-.172.693-.24 1.073-.27C3.94 4 4.385 4 4.92 4ZM2.5 14.846v.204c0 .572 0 .957.025 1.252.023.288.065.425.111.515.12.236.311.427.547.547.09.046.227.088.514.111.296.024.68.025 1.253.025h7.1c.572 0 .957 0 1.252-.025.288-.023.425-.065.516-.111a1.25 1.25 0 0 0 .546-.547c.046-.09.088-.227.111-.515.024-.295.025-.68.025-1.252v-.974l-3.007-2.806-1.753 1.594 1.104 1.427a.75.75 0 0 1-1.187.918L5.99 10.465l-3.49 4.38Zm6.32-3.173L6.593 8.79a.75.75 0 0 0-1.18-.008L2.5 12.439V7.95c0-.572 0-.957.025-1.253.023-.287.065-.424.111-.514a1.25 1.25 0 0 1 .547-.547c.09-.046.227-.088.514-.111.296-.024.68-.025 1.253-.025h7.1c.572 0 .957 0 1.252.025.288.023.425.065.516.111.235.12.426.311.546.547.046.09.088.227.111.514.024.296.025.68.025 1.253v4.074l-2.488-2.322a.75.75 0 0 0-1.017-.007L8.82 11.673Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, p_e = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="inbox">
    <path fill-rule="evenodd" d="M2.644 4.083A2.75 2.75 0 0 1 5.312 2h9.376a2.75 2.75 0 0 1 2.668 2.083l1.622 6.485c.014.06.022.12.022.182v4.5A2.75 2.75 0 0 1 16.25 18H3.75A2.75 2.75 0 0 1 1 15.25v-4.5a.75.75 0 0 1 .022-.182l1.622-6.485ZM5.312 3.5a1.25 1.25 0 0 0-1.213.947L2.71 10h1.803a2.75 2.75 0 0 1 2.46 1.52l.144.289a1.25 1.25 0 0 0 1.118.691h3.528a1.25 1.25 0 0 0 1.118-.691l.144-.289a2.75 2.75 0 0 1 2.46-1.52h1.803L15.9 4.447a1.25 1.25 0 0 0-1.213-.947H5.312Zm12.188 8h-2.014a1.25 1.25 0 0 0-1.118.691l-.144.289a2.75 2.75 0 0 1-2.46 1.52H8.236a2.75 2.75 0 0 1-2.46-1.52l-.144-.289a1.25 1.25 0 0 0-1.118-.691H2.5v3.75c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25V11.5Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, f_e = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="info-circle">
    <path fill-rule="evenodd" d="M10 2.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15ZM1 10a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm9-5a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0v-1.5A.75.75 0 0 1 10 5Zm0 5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 10 10Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, v_e = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="info-fill">
    <path fill-rule="evenodd" d="M10 1a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm0 4a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0v-1.5A.75.75 0 0 1 10 5Zm0 5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 10 10Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, m_e = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="key">
    <path fill-rule="evenodd" d="M13.75 2.5a3.75 3.75 0 0 0-3.65 4.613.75.75 0 0 1-.2.702l-7.18 7.197a.75.75 0 0 0-.22.53V17.5h2.01c.199 0 .39-.079.53-.22l.21-.21V15a.75.75 0 0 1 .75-.75h2.064l.186-.186V12a.75.75 0 0 1 .75-.75h2.059l1.143-1.145a.75.75 0 0 1 .7-.201A3.75 3.75 0 1 0 13.75 2.5ZM8.5 6.25a5.25 5.25 0 1 1 4.484 5.194L11.9 12.53a.75.75 0 0 1-.53.22H9.75v1.624a.75.75 0 0 1-.22.53l-.624.626a.75.75 0 0 1-.53.22H6.75v1.63a.75.75 0 0 1-.22.53l-.428.43A2.25 2.25 0 0 1 4.51 19H2.25C1.56 19 1 18.44 1 17.75v-2.208c0-.596.236-1.168.657-1.59L8.56 7.036a5.286 5.286 0 0 1-.06-.786Zm4.5 0a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, C_e = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="keyboard" clip-path="url(#a)">
    <path fill-rule="evenodd" d="M3.92 3h12.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 19.7 4.502c.172.337.24.693.27 1.073.03.365.03.81.03 1.345v6.16c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073a2.751 2.751 0 0 1-1.2 1.202c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03H3.92c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 .3 15.5c-.172-.338-.24-.694-.27-1.074C0 14.06 0 13.615 0 13.08V6.92c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 1.502 3.3c.337-.172.693-.24 1.073-.27C2.94 3 3.385 3 3.92 3ZM2.697 4.525c-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.547c-.046.09-.088.227-.111.514-.024.296-.025.68-.025 1.253v6.1c0 .572 0 .957.025 1.252.023.288.065.425.111.516.12.235.311.426.547.546.09.046.227.088.514.111.296.024.68.025 1.253.025h12.1c.572 0 .957 0 1.252-.025.288-.023.425-.065.515-.111a1.25 1.25 0 0 0 .547-.546c.046-.091.088-.228.111-.515.024-.296.025-.68.025-1.253v-6.1c0-.572 0-.957-.025-1.253-.023-.287-.065-.424-.111-.514a1.25 1.25 0 0 0-.547-.547c-.09-.046-.227-.088-.515-.111-.295-.024-.68-.025-1.252-.025H3.95c-.572 0-.957 0-1.253.025ZM3 7.25a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5A.75.75 0 0 1 3 7.25Zm4 0a.75.75 0 0 1 .75-.75h.5a.75.75 0 1 1 0 1.5h-.5A.75.75 0 0 1 7 7.25Zm4 0a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75Zm-12 3a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h.5a.75.75 0 1 1 0 1.5h-.5a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75Zm-9 3.5a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
  <defs>
    <clipPath id="a" class="a">
      <path d="M0 0h20v20H0z"/>
    </clipPath>
  </defs>
</svg>
`, w_e = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="label">
    <path fill-rule="evenodd" d="M13.794 5.548c-.15-.042-.323-.048-.956-.048H5c-.581 0-.973 0-1.275.025-.293.023-.435.066-.53.113a1.266 1.266 0 0 0-.558.549c-.047.09-.09.225-.113.511-.024.296-.025.68-.025 1.252v4.1c0 .573 0 .956.025 1.252.024.286.066.422.113.511.12.234.315.427.558.549.095.047.237.09.53.113.302.024.694.025 1.275.025h7.837c.633 0 .806-.007.956-.048a1.3 1.3 0 0 0 .421-.206c.123-.09.232-.22.616-.716l2.337-3.02c.14-.181.222-.287.277-.37a.545.545 0 0 0 .047-.08c.01-.04.01-.08 0-.12a.55.55 0 0 0-.047-.08 7.325 7.325 0 0 0-.277-.37L14.83 6.47c-.384-.497-.493-.626-.615-.716a1.295 1.295 0 0 0-.422-.206Zm3.7 4.394-.002-.002.001.002Zm0 .116-.002.002.001-.002ZM12.923 4c.507 0 .9 0 1.273.103.328.092.636.242.91.444.311.23.55.54.857.936l.053.069 2.337 3.02.054.07c.213.272.44.563.532.905.08.297.08.61 0 .906-.093.342-.32.633-.532.905a23.03 23.03 0 0 0-.054.07l-2.337 3.02-.053.069c-.306.396-.546.706-.857.936a2.795 2.795 0 0 1-.91.444c-.373.104-.766.103-1.272.103H4.97c-.544 0-.996 0-1.365-.03-.384-.03-.743-.097-1.083-.268a2.766 2.766 0 0 1-1.218-1.2c-.175-.338-.243-.696-.275-1.076A17.55 17.55 0 0 1 1 12.08V7.919c0-.534 0-.98.03-1.345.032-.38.1-.738.275-1.077a2.766 2.766 0 0 1 1.218-1.2c.34-.17.699-.236 1.083-.267C3.976 4 4.427 4 4.971 4h7.954Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, b_e = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="laptop">
    <path fill-rule="evenodd" d="M5.92 2h8.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 17.7 3.502c.172.337.24.693.27 1.073.03.365.03.81.03 1.345V13h.25a.75.75 0 0 1 .75.75v.33c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073a2.751 2.751 0 0 1-1.2 1.202c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03H4.92c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 1.3 16.5c-.172-.338-.24-.694-.27-1.074C1 15.06 1 14.615 1 14.08v-.33a.75.75 0 0 1 .75-.75H2V5.92c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 3.502 2.3c.337-.172.693-.24 1.073-.27C4.94 2 5.385 2 5.92 2ZM2.5 14.5c.002.336.008.592.025.803.023.287.065.424.111.514.12.236.311.427.547.547.09.046.227.088.514.111.296.024.68.025 1.253.025h10.1c.572 0 .957 0 1.252-.025.288-.023.425-.065.515-.111a1.25 1.25 0 0 0 .547-.546c.046-.091.088-.228.111-.515.017-.211.023-.467.024-.803h-3.348a.934.934 0 0 0-.777.416A2.434 2.434 0 0 1 11.349 16H8.65a2.434 2.434 0 0 1-2.025-1.084.934.934 0 0 0-.777-.416H2.5Zm14-1.5h-2.349c-.813 0-1.574.407-2.025 1.084a.934.934 0 0 1-.777.416H8.65a.934.934 0 0 1-.777-.416A2.434 2.434 0 0 0 5.849 13H3.5V5.95c0-.572 0-.957.025-1.253.023-.287.065-.424.111-.514a1.25 1.25 0 0 1 .547-.547c.09-.046.227-.088.514-.111.296-.024.68-.025 1.253-.025h8.1c.572 0 .957 0 1.252.025.288.023.425.065.516.111.235.12.426.311.546.547.046.09.088.227.111.514.024.296.025.68.025 1.253V13Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, y_e = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="layer-align-bottom-center">
    <path fill-rule="evenodd" d="M9.92 1h.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 13.7 2.502c.172.337.24.693.27 1.073.03.365.03.81.03 1.345v7.16c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073a2.751 2.751 0 0 1-1.2 1.202c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03h-.16c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 6.3 14.5c-.172-.338-.24-.694-.27-1.074C6 13.06 6 12.615 6 12.08V4.92c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 7.502 1.3c.337-.172.693-.24 1.073-.27C8.94 1 9.385 1 9.92 1ZM8.697 2.525c-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.547c-.046.09-.088.227-.111.514-.024.296-.025.68-.025 1.253v7.1c0 .572 0 .957.025 1.252.023.288.065.425.111.516.12.235.311.426.547.546.09.046.227.088.514.111.296.024.68.025 1.253.025h.1c.572 0 .957 0 1.252-.025.288-.023.425-.065.516-.111a1.25 1.25 0 0 0 .546-.546c.046-.091.088-.228.111-.515.024-.296.025-.68.025-1.253v-7.1c0-.572 0-.957-.025-1.253-.023-.287-.065-.424-.111-.514a1.25 1.25 0 0 0-.546-.547c-.091-.046-.228-.088-.515-.111-.296-.024-.68-.025-1.253-.025h-.1c-.572 0-.957 0-1.253.025ZM1 18.25a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H1.75a.75.75 0 0 1-.75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, __e = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="layer-align-horizontal">
    <path fill-rule="evenodd" d="M9.92 1h.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 13.7 2.502c.172.337.24.693.27 1.073.03.365.03.81.03 1.345v4.33h4.25a.75.75 0 0 1 0 1.5H14v4.33c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073a2.751 2.751 0 0 1-1.2 1.202c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03h-.16c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 6.3 17.5c-.172-.338-.24-.694-.27-1.074C6 16.06 6 15.615 6 15.08v-4.33H1.75a.75.75 0 0 1 0-1.5H6V4.92c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 7.502 1.3c.337-.172.693-.24 1.073-.27C8.94 1 9.385 1 9.92 1ZM8.697 2.525c-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.547c-.046.09-.088.227-.111.514-.024.296-.025.68-.025 1.253v10.1c0 .572 0 .957.025 1.252.023.288.065.425.111.515.12.236.311.427.547.547.09.046.227.088.514.111.296.024.68.025 1.253.025h.1c.572 0 .957 0 1.252-.025.288-.023.425-.065.516-.111a1.25 1.25 0 0 0 .546-.547c.046-.09.088-.227.111-.515.024-.295.025-.68.025-1.252V4.95c0-.572 0-.957-.025-1.253-.023-.287-.065-.424-.111-.514a1.25 1.25 0 0 0-.546-.547c-.091-.046-.228-.088-.515-.111-.296-.024-.68-.025-1.253-.025h-.1c-.572 0-.957 0-1.253.025Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, S_e = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="layer-align-left-center">
    <path fill-rule="evenodd" d="M1.75 1a.75.75 0 0 1 .75.75v16.5a.75.75 0 0 1-1.5 0V1.75A.75.75 0 0 1 1.75 1Zm6.17 5h7.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 18.7 7.502c.172.337.24.693.27 1.073.03.365.03.81.03 1.345v.16c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073a2.751 2.751 0 0 1-1.2 1.202c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03H7.92c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 4.3 12.5c-.172-.338-.24-.694-.27-1.074C4 11.06 4 10.615 4 10.08v-.16c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 5.502 6.3c.337-.172.693-.24 1.073-.27C6.94 6 7.385 6 7.92 6ZM6.697 7.525c-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.547c-.046.09-.088.227-.111.514-.024.296-.025.68-.025 1.253v.1c0 .572 0 .957.025 1.252.023.288.065.425.111.516.12.235.311.426.547.546.09.046.227.088.514.111.296.024.68.025 1.253.025h7.1c.572 0 .957 0 1.252-.025.288-.023.425-.065.515-.111a1.25 1.25 0 0 0 .547-.546c.046-.091.088-.228.111-.515.024-.296.025-.68.025-1.253v-.1c0-.572 0-.957-.025-1.253-.023-.287-.065-.424-.111-.514a1.25 1.25 0 0 0-.547-.547c-.09-.046-.227-.088-.515-.111-.295-.024-.68-.025-1.252-.025h-7.1c-.572 0-.957 0-1.253.025Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, x_e = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="layer-align-right-center">
    <path fill-rule="evenodd" d="M18.25 1a.75.75 0 0 1 .75.75v16.5a.75.75 0 0 1-1.5 0V1.75a.75.75 0 0 1 .75-.75ZM4.92 6h7.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 15.7 7.502c.172.337.24.693.27 1.073.03.365.03.81.03 1.345v.16c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073a2.751 2.751 0 0 1-1.2 1.202c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03H4.92c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 1.3 12.5c-.172-.338-.24-.694-.27-1.074C1 11.06 1 10.615 1 10.08v-.16c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 2.502 6.3c.337-.172.693-.24 1.073-.27C3.94 6 4.385 6 4.92 6ZM3.697 7.525c-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.547c-.046.09-.088.227-.111.514-.024.296-.025.68-.025 1.253v.1c0 .572 0 .957.025 1.252.023.288.065.425.111.516.12.235.311.426.547.546.09.046.227.088.514.111.296.024.68.025 1.253.025h7.1c.572 0 .957 0 1.252-.025.288-.023.425-.065.516-.111a1.25 1.25 0 0 0 .546-.546c.046-.091.088-.228.111-.515.024-.296.025-.68.025-1.253v-.1c0-.572 0-.957-.025-1.253-.023-.287-.065-.424-.111-.514a1.25 1.25 0 0 0-.546-.547c-.091-.046-.228-.088-.515-.111-.296-.024-.68-.025-1.253-.025h-7.1c-.572 0-.957 0-1.253.025Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, M_e = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="layer-align-top-center">
    <path fill-rule="evenodd" d="M1 1.75A.75.75 0 0 1 1.75 1h16.5a.75.75 0 0 1 0 1.5H1.75A.75.75 0 0 1 1 1.75ZM9.92 4h.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 13.7 5.502c.172.337.24.693.27 1.073.03.365.03.81.03 1.345v7.16c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073a2.751 2.751 0 0 1-1.2 1.202c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03h-.16c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 6.3 17.5c-.172-.338-.24-.694-.27-1.074C6 16.06 6 15.615 6 15.08V7.92c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 7.502 4.3c.337-.172.693-.24 1.073-.27C8.94 4 9.385 4 9.92 4ZM8.697 5.525c-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.547c-.046.09-.088.227-.111.514-.024.296-.025.68-.025 1.253v7.1c0 .572 0 .957.025 1.252.023.288.065.425.111.515.12.236.311.427.547.547.09.046.227.088.514.111.296.024.68.025 1.253.025h.1c.572 0 .957 0 1.252-.025.288-.023.425-.065.516-.111a1.25 1.25 0 0 0 .546-.547c.046-.09.088-.227.111-.515.024-.295.025-.68.025-1.252v-7.1c0-.572 0-.957-.025-1.253-.023-.287-.065-.424-.111-.514a1.25 1.25 0 0 0-.546-.547c-.091-.046-.228-.088-.515-.111-.296-.024-.68-.025-1.253-.025h-.1c-.572 0-.957 0-1.253.025Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, A_e = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="layer-align-vertical">
    <path fill-rule="evenodd" d="M10 1a.75.75 0 0 1 .75.75V6h4.33c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 18.7 7.502c.172.337.24.693.27 1.073.03.365.03.81.03 1.345v.16c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073a2.751 2.751 0 0 1-1.2 1.202c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03h-4.33v4.25a.75.75 0 0 1-1.5 0V14H4.92c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 1.3 12.5c-.172-.338-.24-.694-.27-1.074C1 11.06 1 10.615 1 10.08v-.16c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 2.502 6.3c.337-.172.693-.24 1.073-.27C3.94 6 4.385 6 4.92 6h4.33V1.75A.75.75 0 0 1 10 1ZM3.697 7.525c-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.547c-.046.09-.088.227-.111.514-.024.296-.025.68-.025 1.253v.1c0 .572 0 .957.025 1.252.023.288.065.425.111.516.12.235.311.426.547.546.09.046.227.088.514.111.296.024.68.025 1.253.025h10.1c.572 0 .957 0 1.252-.025.288-.023.425-.065.515-.111a1.25 1.25 0 0 0 .547-.546c.046-.091.088-.228.111-.515.024-.296.025-.68.025-1.253v-.1c0-.572 0-.957-.025-1.253-.023-.287-.065-.424-.111-.514a1.25 1.25 0 0 0-.547-.547c-.09-.046-.227-.088-.515-.111-.295-.024-.68-.025-1.252-.025H4.95c-.572 0-.957 0-1.253.025Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, L_e = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="layer-three">
    <path fill-rule="evenodd" d="M10.236 2.772a1.25 1.25 0 0 0-.472 0c-.152.03-.31.103-.886.4L3.388 6l5.49 2.828c.577.297.734.37.886.4.156.03.316.03.472 0 .152-.03.31-.103.886-.4L16.612 6l-5.49-2.828c-.577-.297-.734-.37-.886-.4ZM9.48 1.3a2.75 2.75 0 0 1 1.04 0c.39.076.75.261 1.209.498l.08.041 6.784 3.495a.75.75 0 0 1 0 1.334l-6.784 3.495-.08.041c-.458.237-.818.422-1.209.498a2.749 2.749 0 0 1-1.04 0c-.39-.076-.75-.261-1.209-.498a20.95 20.95 0 0 0-.08-.041L1.407 6.667a.75.75 0 0 1 0-1.334L8.19 1.838l.08-.041c.458-.237.818-.422 1.209-.498ZM1.083 9.657a.75.75 0 0 1 1.01-.324l6.785 3.495c.577.297.734.37.886.4.156.03.316.03.472 0 .152-.03.31-.103.886-.4l6.785-3.495a.75.75 0 0 1 .686 1.334l-6.784 3.495-.08.041c-.458.237-.818.422-1.209.498a2.749 2.749 0 0 1-1.04 0c-.39-.076-.75-.261-1.209-.498a21.718 21.718 0 0 0-.08-.041l-6.784-3.495a.75.75 0 0 1-.324-1.01Zm0 4a.75.75 0 0 1 1.01-.324l6.785 3.495c.577.297.734.37.886.4.156.03.316.03.472 0 .152-.03.31-.103.886-.4l6.785-3.495a.75.75 0 1 1 .686 1.334l-6.784 3.495-.08.041c-.458.236-.818.422-1.209.498a2.749 2.749 0 0 1-1.04 0c-.39-.076-.75-.262-1.209-.498a20.94 20.94 0 0 0-.08-.041l-6.784-3.495a.75.75 0 0 1-.324-1.01Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, E_e = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="layer-two">
    <path fill-rule="evenodd" d="M10.236 4.772a1.25 1.25 0 0 0-.472 0c-.152.03-.31.103-.886.4L3.388 8l5.49 2.828c.577.297.734.37.886.4.156.03.316.03.472 0 .152-.03.31-.103.886-.4L16.612 8l-5.49-2.828c-.577-.297-.734-.37-.886-.4ZM9.48 3.3a2.75 2.75 0 0 1 1.04 0c.39.076.75.261 1.209.498l.08.041 6.784 3.495a.75.75 0 0 1 0 1.334l-6.784 3.495-.08.041c-.458.237-.818.422-1.209.498a2.749 2.749 0 0 1-1.04 0c-.39-.076-.75-.261-1.209-.498a20.95 20.95 0 0 0-.08-.041L1.407 8.667a.75.75 0 0 1 0-1.334L8.19 3.838l.08-.041c.458-.237.818-.422 1.209-.498Zm-8.397 8.357a.75.75 0 0 1 1.01-.323l6.785 3.495c.577.297.734.37.886.4.156.03.316.03.472 0 .152-.03.31-.103.886-.4l6.785-3.495a.75.75 0 1 1 .686 1.334l-6.784 3.495-.08.041c-.458.236-.818.422-1.209.498a2.749 2.749 0 0 1-1.04 0c-.39-.076-.75-.262-1.209-.498a21.718 21.718 0 0 0-.08-.041l-6.784-3.495a.75.75 0 0 1-.324-1.01Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, P_e = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="layout-swap-horizontal">
    <path fill-rule="evenodd" d="M13.993 3.947a.75.75 0 0 1 1.06.046l2.75 3a.75.75 0 0 1 0 1.014l-2.75 3a.75.75 0 0 1-1.106-1.014l1.598-1.743H8.75a.75.75 0 1 1 0-1.5h6.795l-1.598-1.743a.75.75 0 0 1 .046-1.06Zm-7.986 5a.75.75 0 0 1 .046 1.06L4.455 11.75h6.795a.75.75 0 0 1 0 1.5H4.455l1.598 1.743a.75.75 0 0 1-1.106 1.014l-2.75-3a.75.75 0 0 1 0-1.014l2.75-3a.75.75 0 0 1 1.06-.046Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, R_e = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="layout-swap-vertical">
    <path fill-rule="evenodd" d="M6.993 2.197a.75.75 0 0 1 1.014 0l3 2.75a.75.75 0 0 1-1.014 1.106L8.25 4.455v6.795a.75.75 0 0 1-1.5 0V4.455L5.007 6.053a.75.75 0 0 1-1.014-1.106l3-2.75ZM12.5 8a.75.75 0 0 1 .75.75v6.795l1.743-1.598a.75.75 0 0 1 1.014 1.106l-3 2.75a.75.75 0 0 1-1.014 0l-3-2.75a.75.75 0 0 1 1.014-1.106l1.743 1.598V8.75A.75.75 0 0 1 12.5 8Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, F_e = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="link-broken">
    <path fill-rule="evenodd" d="M14.405 2.504a9.627 9.627 0 0 0-.398-.004h-.178a3.25 3.25 0 0 0-2.291 1.023L10.28 4.78a.75.75 0 1 1-1.06-1.06l1.264-1.264a4.75 4.75 0 0 1 3.31-1.454C13.85 1 13.908 1 13.998 1h.033c.203 0 .332 0 .445.005a4.75 4.75 0 0 1 4.519 4.519c.005.113.005.242.005.445v.033l-.001.204a4.75 4.75 0 0 1-1.311 3.165c-.04.041-.08.082-.144.145L16.28 10.78a.75.75 0 1 1-1.06-1.06l1.257-1.258.125-.126A3.25 3.25 0 0 0 17.5 6.17l.001-.178c0-.234 0-.325-.004-.398a3.25 3.25 0 0 0-3.091-3.091ZM7.25 2a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-.75.75h-4.5a.75.75 0 0 1 0-1.5H6.5V2.75A.75.75 0 0 1 7.25 2ZM4.78 9.22a.75.75 0 0 1 0 1.06l-1.257 1.258-.125.126a3.25 3.25 0 0 0-.898 2.343c0 .234 0 .325.004.398a3.25 3.25 0 0 0 3.091 3.091c.073.004.164.004.398.004h.178a3.25 3.25 0 0 0 2.291-1.023L9.72 15.22a.75.75 0 1 1 1.06 1.06l-1.264 1.264a4.75 4.75 0 0 1-3.31 1.454C6.15 19 6.092 19 6.002 19H5.97c-.203 0-.332 0-.445-.005a4.75 4.75 0 0 1-4.519-4.519A9.965 9.965 0 0 1 1 14.03v-.032l.001-.204a4.75 4.75 0 0 1 1.454-3.31l.007-.007L3.72 9.22a.75.75 0 0 1 1.06 0ZM12 12.75a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5H13.5v3.75a.75.75 0 0 1-1.5 0v-4.5Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, T_e = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="link">
    <path fill-rule="evenodd" d="M14.405 2.504a9.627 9.627 0 0 0-.398-.004h-.178a3.25 3.25 0 0 0-2.291 1.023L9.28 5.78c-.165.166-.229.23-.278.284a3.25 3.25 0 0 0 0 4.372c.049.054.113.118.278.284l.25.25a.75.75 0 1 1-1.06 1.06l-.267-.266a10.013 10.013 0 0 1-.311-.319 4.75 4.75 0 0 1 0-6.39c.076-.084.168-.175.311-.32l2.274-2.273.007-.007c.063-.063.104-.104.145-.143a4.75 4.75 0 0 1 3.165-1.31C13.85 1 13.908 1 13.998 1h.033c.203 0 .332 0 .445.005a4.75 4.75 0 0 1 4.519 4.519c.005.113.005.242.005.446v.032l-.001.204a4.75 4.75 0 0 1-1.455 3.31l-.006.007-1.258 1.257a.75.75 0 1 1-1.06-1.06l1.257-1.258.125-.126A3.25 3.25 0 0 0 17.5 6.17l.001-.178c0-.234 0-.325-.004-.398a3.25 3.25 0 0 0-3.091-3.091ZM10.47 9.03a.75.75 0 0 1 1.06-1.06l.267.266c.143.144.235.235.311.319a4.75 4.75 0 0 1 0 6.39c-.076.084-.168.175-.311.32l-2.274 2.273-.007.007c-.063.063-.104.104-.145.143a4.75 4.75 0 0 1-3.165 1.31C6.15 19 6.092 19 6.002 19H5.97c-.204 0-.333 0-.446-.005a4.75 4.75 0 0 1-4.519-4.519A9.965 9.965 0 0 1 1 14.03v-.032l.001-.204a4.75 4.75 0 0 1 1.311-3.165c.04-.041.08-.082.144-.145L3.72 9.22a.75.75 0 0 1 1.06 1.06l-1.257 1.258a3.25 3.25 0 0 0-1.023 2.47c0 .233 0 .324.004.397a3.25 3.25 0 0 0 3.091 3.091c.073.004.164.004.398.004h.178a3.25 3.25 0 0 0 2.291-1.023l2.258-2.257c.165-.166.229-.23.278-.284a3.25 3.25 0 0 0 0-4.372 9.8 9.8 0 0 0-.278-.284l-.25-.25Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, I_e = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="list-bullet">
    <path fill-rule="evenodd" d="M1 4.747a.75.75 0 0 1 .75-.75L4.25 4a.75.75 0 0 1 0 1.5l-2.5-.001a.75.75 0 0 1-.75-.75Zm7 0a.75.75 0 0 1 .75-.75l9.5.006a.75.75 0 1 1 0 1.5l-9.5-.005a.75.75 0 0 1-.75-.75ZM1 10a.75.75 0 0 1 .75-.749l2.5.002a.75.75 0 0 1 0 1.5l-2.5-.002A.75.75 0 0 1 1 10Zm7 0a.75.75 0 0 1 .75-.749l9.5.005a.75.75 0 1 1 0 1.5l-9.5-.005A.75.75 0 0 1 8 10Zm-7 5.25a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Zm7 0a.75.75 0 0 1 .75-.75h9.5a.75.75 0 0 1 0 1.5h-9.5a.75.75 0 0 1-.75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, D_e = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="list-check">
    <path fill-rule="evenodd" d="M5.752 3.193a.75.75 0 0 1 .055 1.059l-2.25 2.5a.75.75 0 0 1-1.133-.022l-1.25-1.5a.75.75 0 0 1 1.152-.96l.696.835 1.67-1.857a.75.75 0 0 1 1.06-.055ZM7 4.75A.75.75 0 0 1 7.75 4h10.5a.75.75 0 0 1 0 1.5H7.75A.75.75 0 0 1 7 4.75Zm0 3.5a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 7 8.25Zm-1.248 2.943a.75.75 0 0 1 .055 1.059l-2.25 2.5a.75.75 0 0 1-1.133-.022l-1.25-1.5a.75.75 0 1 1 1.152-.96l.696.835 1.67-1.857a.75.75 0 0 1 1.06-.055ZM7 12.75a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H7.75a.75.75 0 0 1-.75-.75Zm0 3.5a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1-.75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, k_e = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="list-ordered">
    <path fill-rule="evenodd" d="M4.287 3.057a.75.75 0 0 1 .463.693v5.5a.75.75 0 0 1-1.5 0V5.56l-.97.97a.75.75 0 0 1-1.06-1.06l2.25-2.25a.75.75 0 0 1 .817-.163ZM7 4.75A.75.75 0 0 1 7.75 4h10.5a.75.75 0 0 1 0 1.5H7.75A.75.75 0 0 1 7 4.75Zm0 3.5a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 7 8.25Zm-5.56 4.07c.36-.462.953-.82 1.81-.82.843 0 1.53.35 1.937.959.39.585.456 1.311.29 1.973-.11.445-.446.877-.742 1.208-.26.292-.567.587-.87.86H5.25a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.441-1.357l.006-.004.02-.015a19.974 19.974 0 0 0 .389-.295c.254-.197.594-.47.94-.77.348-.303.69-.623.952-.918.132-.147.235-.278.307-.388a1.215 1.215 0 0 0 .095-.172l.004-.013c.085-.338.027-.612-.084-.777-.093-.14-.281-.291-.688-.291-.393 0-.55.142-.627.242a.662.662 0 0 0-.103.194c-.017.05-.02.08-.02.08A.75.75 0 0 1 1 13.5c0-.282.112-.76.44-1.18Zm5.56.43a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H7.75a.75.75 0 0 1-.75-.75Zm0 3.5a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1-.75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, H_e = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="list-unordered">
    <path fill-rule="evenodd" d="M1 4.75A.75.75 0 0 1 1.75 4h2.5a.75.75 0 0 1 0 1.5h-2.5A.75.75 0 0 1 1 4.75Zm6 0A.75.75 0 0 1 7.75 4h10.5a.75.75 0 0 1 0 1.5H7.75A.75.75 0 0 1 7 4.75Zm0 3.5a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 7 8.25Zm-6 4.5a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Zm6 0a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H7.75a.75.75 0 0 1-.75-.75Zm0 3.5a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1-.75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, V_e = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="lock">
    <path fill-rule="evenodd" d="M6 5a4 4 0 1 1 8 0v3h1.25A2.75 2.75 0 0 1 18 10.75v5.5A2.75 2.75 0 0 1 15.25 19H4.75A2.75 2.75 0 0 1 2 16.25v-5.5A2.75 2.75 0 0 1 4.75 8H6V5Zm1.5 3h5V5a2.5 2.5 0 0 0-5 0v3ZM4.75 9.5c-.69 0-1.25.56-1.25 1.25v5.5c0 .69.56 1.25 1.25 1.25h10.5c.69 0 1.25-.56 1.25-1.25v-5.5c0-.69-.56-1.25-1.25-1.25H4.75ZM10 12a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0v-1.5A.75.75 0 0 1 10 12Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, O_e = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="log-in">
    <path fill-rule="evenodd" d="M2 10a.75.75 0 0 1 .75-.75h6.787L7.699 7.259A.75.75 0 1 1 8.8 6.24l3 3.25a.75.75 0 0 1 0 1.018l-3 3.25a.75.75 0 1 1-1.1-1.018l1.838-1.991H2.75A.75.75 0 0 1 2 10Zm8 8.25a.75.75 0 0 1 .75-.75h4.5c.69 0 1.25-.56 1.25-1.25V3.75c0-.69-.56-1.25-1.25-1.25h-4.5a.75.75 0 0 1 0-1.5h4.5A2.75 2.75 0 0 1 18 3.75v12.5A2.75 2.75 0 0 1 15.25 19h-4.5a.75.75 0 0 1-.75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, B_e = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="log-out">
    <path fill-rule="evenodd" d="M17.801 10.509a.75.75 0 0 0 0-1.018l-3-3.25A.75.75 0 1 0 13.7 7.26l1.838 1.991H8.75a.75.75 0 0 0 0 1.5h6.787l-1.838 1.991A.75.75 0 1 0 14.8 13.76l3-3.25ZM10 18.25a.75.75 0 0 0-.75-.75h-4.5c-.69 0-1.25-.56-1.25-1.25V3.75c0-.69.56-1.25 1.25-1.25h4.5a.75.75 0 0 0 0-1.5h-4.5A2.75 2.75 0 0 0 2 3.75v12.5A2.75 2.75 0 0 0 4.75 19h4.5a.75.75 0 0 0 .75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, $_e = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="mail">
    <path fill-rule="evenodd" d="M2.564 5.353 10 9.635l7.436-4.282A1.25 1.25 0 0 0 16.25 4.5H3.75a1.25 1.25 0 0 0-1.186.853ZM17.5 7.047l-7.126 4.103a.75.75 0 0 1-.748 0L2.5 7.047v7.203c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25V7.047ZM1 5.75A2.75 2.75 0 0 1 3.75 3h12.5A2.75 2.75 0 0 1 19 5.75v8.5A2.75 2.75 0 0 1 16.25 17H3.75A2.75 2.75 0 0 1 1 14.25v-8.5Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Z_e = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="map">
    <path fill-rule="evenodd" d="M12.828 3.675a3.99 3.99 0 0 0-5.656 0 4.023 4.023 0 0 0 0 5.677L10 12.188l2.828-2.836a4.023 4.023 0 0 0 0-5.677Zm-2.296 10.104H9.468L6.11 10.412a5.523 5.523 0 0 1 0-7.795 5.49 5.49 0 0 1 7.78 0 5.523 5.523 0 0 1 0 7.795l-3.36 3.368Zm0 0a.75.75 0 0 1-1.063 0h1.063ZM8.5 6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm-5.963 4.51a.75.75 0 0 1 .621.86l-.452 2.813c-.105.648-.174 1.085-.198 1.423-.023.33.006.482.045.579.106.266.309.496.582.645.107.058.276.11.628.14.358.03.825.03 1.51.03h9.454c.685 0 1.152 0 1.51-.03.352-.03.52-.082.629-.14.273-.149.475-.379.582-.645.038-.096.067-.249.044-.579-.024-.338-.093-.775-.198-1.423l-.452-2.814a.75.75 0 0 1 1.48-.238l.459 2.847c.097.606.178 1.11.207 1.524.03.429.011.84-.147 1.239a2.779 2.779 0 0 1-1.259 1.407c-.373.202-.781.28-1.221.317-.427.035-.957.035-1.602.035H5.241c-.645 0-1.175 0-1.602-.035-.44-.037-.848-.115-1.221-.317a2.778 2.778 0 0 1-1.259-1.407c-.158-.398-.177-.81-.147-1.24.029-.412.11-.917.207-1.523l.458-2.847a.75.75 0 0 1 .86-.622Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, G_e = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="marker-pin">
    <path fill-rule="evenodd" d="M14.24 4.279a5.941 5.941 0 0 0-8.48 0c-2.347 2.377-2.347 6.234 0 8.611L10 17.183l4.24-4.293c2.347-2.377 2.347-6.234 0-8.611ZM10 18.25l-.534.527-4.773-4.833c-2.924-2.96-2.924-7.758 0-10.72a7.441 7.441 0 0 1 10.614 0c2.924 2.962 2.924 7.76 0 10.72l-4.773 4.832L10 18.25Zm0 0 .534.526a.752.752 0 0 1-1.068.001L10 18.25ZM10 6.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM7 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, N_e = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="math-alpha">
    <path fill-rule="evenodd" d="M7.62 4C4.889 4 2.5 6.583 2.5 10c0 3.415 2.397 6 5.13 6 1.358 0 2.36-.534 3.168-1.405.83-.895 1.457-2.153 1.984-3.575v-.002l-.243-.777-.084-.267c-.514-1.647-1.013-3.16-1.77-4.27C9.963 4.644 9.04 4 7.62 4Zm5.962 4.567c-.43-1.313-.931-2.643-1.658-3.708C10.985 3.48 9.64 2.5 7.62 2.5 3.871 2.5 1 5.957 1 10c0 4.044 2.883 7.5 6.63 7.5 1.827 0 3.213-.747 4.268-1.885.663-.714 1.192-1.58 1.632-2.502.223.535.47 1.042.752 1.5C15.125 15.98 16.352 17 18.25 17a.75.75 0 0 0 0-1.5c-1.227 0-2.031-.605-2.692-1.675-.474-.768-.84-1.724-1.19-2.784.316-.906.59-1.837.847-2.706.12-.408.237-.801.351-1.172.423-1.371.81-2.382 1.264-2.938a.75.75 0 0 0-1.16-.95c-.67.82-1.128 2.12-1.537 3.445-.125.407-.248.822-.372 1.242l-.18.605Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, z_e = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="math-angle">
    <path fill-rule="evenodd" d="M7.487 1.038a.75.75 0 0 1 .475.95L5.94 8.052c3.929 1.611 6.876 5.079 7.482 9.447h4.828V19H1.75a.75.75 0 0 1-.712-.987l5.5-16.5a.75.75 0 0 1 .95-.475ZM11.905 17.5c-.585-3.668-3.076-6.607-6.44-8.02L2.79 17.5h9.114ZM16 7.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM13 9a3 3 0 1 1 6 0 3 3 0 0 1-6 0Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, j_e = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="math-beta">
    <path fill-rule="evenodd" d="M10 2.5A2.5 2.5 0 0 0 7.5 5v7.743c.527.627 1.262 1.007 2.125 1.007a2.875 2.875 0 0 0 0-5.75v-.01a.75.75 0 0 1 0-1.48V6.5a4.408 4.408 0 0 1 .125 0c.904 0 1.432-.339 1.753-.75.343-.439.497-1.027.497-1.55 0-.246-.148-.681-.513-1.065A2.007 2.007 0 0 0 10 2.5Zm2.094 4.763a3.34 3.34 0 0 0 .59-.589c.595-.76.816-1.697.816-2.474 0-.704-.352-1.494-.925-2.098A3.507 3.507 0 0 0 10 1a4 4 0 0 0-4 4v13.25a.75.75 0 0 0 1.5 0v-3.57c.617.361 1.335.57 2.125.57a4.375 4.375 0 0 0 2.47-7.987Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, W_e = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="math-gamma">
    <path fill-rule="evenodd" d="M5.262 1.18a.75.75 0 0 1 1.057.082c1.953 2.278 3.525 5.032 4.255 8.001.072-.205.146-.411.223-.619.7-1.876 1.672-3.901 2.872-5.369a.75.75 0 0 1 1.162.95c-1.05 1.282-1.953 3.132-2.628 4.943-.668 1.792-1.085 3.468-1.205 4.398-.124 2.4-.535 3.969-.718 4.665l-.052.2a.75.75 0 1 1-1.456-.363l.054-.206c.18-.687.561-2.14.675-4.4.205-4.076-1.624-8.078-4.32-11.224a.75.75 0 0 1 .08-1.057Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, U_e = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="math-infinite">
    <path fill-rule="evenodd" d="M5.5 7a3 3 0 0 0 0 6c1.504 0 2.695-1.203 3.656-3C8.195 8.203 7.004 7 5.5 7ZM10 8.472C8.988 6.882 7.544 5.5 5.5 5.5a4.5 4.5 0 0 0 0 9c2.044 0 3.488-1.382 4.5-2.972 1.012 1.59 2.456 2.972 4.5 2.972a4.5 4.5 0 1 0 0-9c-2.044 0-3.488 1.382-4.5 2.972ZM10.844 10c.961 1.797 2.152 3 3.656 3a3 3 0 1 0 0-6c-1.504 0-2.695 1.203-3.656 3Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, K_e = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="math-omega">
    <path fill-rule="evenodd" d="M10 2.5A7.5 7.5 0 0 0 2.5 10c0 3.198 2.246 6.467 5.023 7.551A.75.75 0 0 1 7.25 19h-5.5a.75.75 0 0 1 0-1.5h2.837C2.451 15.687 1 12.833 1 10a9 9 0 0 1 18 0c0 2.833-1.451 5.687-3.587 7.5h2.837a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1-.273-1.449C15.254 16.467 17.5 13.2 17.5 10A7.5 7.5 0 0 0 10 2.5Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, q_e = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="math-pi">
    <path fill-rule="evenodd" d="M4.065 2.948c-.66.341-1.244.998-1.584 2.47a.75.75 0 0 1-1.462-.337c.41-1.777 1.205-2.87 2.358-3.466C4.465 1.053 5.764 1 7 1h11.25a.75.75 0 0 1 0 1.5H14.5V16a1.5 1.5 0 0 0 3 0 .75.75 0 0 1 1.5 0 3 3 0 1 1-6 0V2.5H8v9.54c0 .976 0 1.982-.348 3.077-.356 1.123-1.055 2.28-2.359 3.65a.75.75 0 1 1-1.086-1.034c1.196-1.256 1.747-2.223 2.016-3.07.272-.857.277-1.65.277-2.663V2.505c-1.014.02-1.808.119-2.435.443Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Y_e = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="math-sigma">
    <path fill-rule="evenodd" d="M3.075 1.423A.75.75 0 0 1 3.75 1h13a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0V2.5H5.296l5.543 7.036a.75.75 0 0 1 0 .928L5.296 17.5H15.75v-1.75a.75.75 0 0 1 1.5 0v2.5a.75.75 0 0 1-.75.75H3.75a.75.75 0 0 1-.59-1.214L9.296 10 3.161 2.214a.75.75 0 0 1-.086-.791Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Q_e = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="math-sine-wawe">
    <path fill-rule="evenodd" d="M3.227 6.56c-.541 1.338-.727 3.1-.727 4.688a.75.75 0 1 1-1.5 0c0-1.662.189-3.65.836-5.25.653-1.616 1.86-3 3.914-3 .85 0 1.561.257 2.146.715.57.446.982 1.053 1.306 1.7.324.649.58 1.383.813 2.117.098.306.188.605.279.901.134.443.268.881.417 1.33.153.459.3.941.442 1.405.09.293.176.58.261.847.228.719.456 1.36.726 1.9.27.54.56.932.889 1.19.313.246.696.396 1.221.396 1.195 0 1.99-.742 2.523-2.063.541-1.337.727-3.1.727-4.687a.75.75 0 0 1 1.5 0c0 1.662-.189 3.65-.836 5.25-.653 1.616-1.86 3-3.914 3-.85 0-1.561-.257-2.146-.715-.57-.446-.982-1.053-1.306-1.7-.324-.65-.58-1.383-.813-2.117-.097-.306-.188-.605-.279-.902a51.62 51.62 0 0 0-.417-1.33c-.153-.458-.3-.94-.442-1.404-.09-.293-.176-.58-.261-.847-.228-.719-.456-1.36-.726-1.9-.27-.54-.56-.933-.889-1.19-.313-.246-.696-.396-1.221-.396-1.195 0-1.99.742-2.523 2.063Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, J_e = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="math-square-root">
    <path fill-rule="evenodd" d="M13.187 4a2.25 2.25 0 0 0-2.142 1.561L7.214 17.48a.75.75 0 0 1-1.434-.018l-2.077-7.065a1.25 1.25 0 0 0-1.2-.897H1.75a.75.75 0 0 1 0-1.5h.754a2.75 2.75 0 0 1 2.638 1.974l1.39 4.726 3.085-9.598a3.75 3.75 0 0 1 3.57-2.602h5.063a.75.75 0 0 1 0 1.5h-5.063Zm-.864 6.133a.75.75 0 0 1 1.044.19L15 12.683l1.633-2.36a.75.75 0 1 1 1.234.854L15.912 14l1.955 2.823a.75.75 0 1 1-1.234.854L15 15.317l-1.633 2.36a.75.75 0 1 1-1.234-.854L14.088 14l-1.955-2.823a.75.75 0 0 1 .19-1.044Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, X_e = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="math-theta">
    <path fill-rule="evenodd" d="M5.523 9.25h8.954c-.112-1.85-.636-3.485-1.397-4.681C12.21 3.205 11.104 2.5 10 2.5s-2.211.705-3.08 2.069c-.76 1.196-1.285 2.83-1.397 4.681Zm8.954 1.5H5.523c.112 1.85.636 3.485 1.397 4.681C7.79 16.795 8.896 17.5 10 17.5s2.211-.705 3.08-2.069c.76-1.196 1.285-2.83 1.397-4.681ZM5.655 3.764C6.687 2.142 8.205 1 10 1s3.313 1.142 4.345 2.764C15.383 5.394 16 7.6 16 10c0 2.399-.617 4.606-1.655 6.236C13.313 17.858 11.795 19 10 19s-3.313-1.142-4.345-2.764C4.617 14.606 4 12.4 4 10c0-2.399.617-4.606 1.655-6.236Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, eSe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="megaphone">
    <path fill-rule="evenodd" d="M13.25 1a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0v-1.5a.75.75 0 0 1 .75-.75Zm4.53 1.22a.75.75 0 0 1 0 1.06l-1.5 1.5a.75.75 0 1 1-1.06-1.06l1.5-1.5a.75.75 0 0 1 1.06 0Zm-11.05.52a2.5 2.5 0 0 1 3.53 0l7 7a2.5 2.5 0 0 1 0 3.53 2.5 2.5 0 0 1-2.96.427l-.933.583.601 2.005a.75.75 0 0 1-.315.848l-2.75 1.75a.75.75 0 0 1-.738.038l-2.346-1.173-1.421.888a.75.75 0 0 1-.928-.106l-.23-.229a2.495 2.495 0 0 1-3.505-.041 2.496 2.496 0 0 1-.036-3.5l-.23-.23a.75.75 0 0 1-.105-.928L6.303 5.7a2.502 2.502 0 0 1 .427-2.96Zm.606 4.137-4.384 7.015 3.156 3.156 7.015-4.384-5.787-5.787ZM2.76 15.82a.996.996 0 0 0 .038 1.382l.005.004a.994.994 0 0 0 1.376.034l-1.42-1.42Zm6.55.996 1.146.573 1.913-1.217-.32-1.068-2.74 1.712ZM9.2 3.8a1 1 0 0 0-1.41 0 1 1 0 0 0 0 1.41l7 7a1 1 0 0 0 1.41 0 1 1 0 0 0 0-1.41l-7-7ZM16 6.75a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, tSe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="menu">
    <path fill-rule="evenodd" d="M1 4.75A.75.75 0 0 1 1.75 4h16.5a.75.75 0 0 1 0 1.5H1.75A.75.75 0 0 1 1 4.75ZM1 10a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H1.75A.75.75 0 0 1 1 10Zm0 5.25a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H1.75a.75.75 0 0 1-.75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, oSe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="message">
    <path fill-rule="evenodd" d="M1 4.75A2.75 2.75 0 0 1 3.75 2h12.5A2.75 2.75 0 0 1 19 4.75v7.5A2.75 2.75 0 0 1 16.25 15h-5.63a.25.25 0 0 0-.163.06l-3.219 2.76A.75.75 0 0 1 6 17.25v-2a.25.25 0 0 0-.25-.25h-2A2.75 2.75 0 0 1 1 12.25v-7.5ZM3.75 3.5c-.69 0-1.25.56-1.25 1.25v7.5c0 .69.56 1.25 1.25 1.25h2c.966 0 1.75.784 1.75 1.75v.37l1.981-1.699a1.75 1.75 0 0 1 1.139-.421h5.63c.69 0 1.25-.56 1.25-1.25v-7.5c0-.69-.56-1.25-1.25-1.25H3.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, nSe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="mic">
    <path fill-rule="evenodd" d="M6 5a4 4 0 1 1 8 0v4a4 4 0 0 1-8 0V5Zm4-2.5A2.5 2.5 0 0 0 7.5 5v4a2.5 2.5 0 0 0 5 0V5A2.5 2.5 0 0 0 10 2.5ZM3.75 8.25A.75.75 0 0 1 4.5 9a5.5 5.5 0 1 0 11 0A.75.75 0 0 1 17 9a7.001 7.001 0 0 1-6.25 6.96v1.54h2.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1 0-1.5h2.5v-1.54A7.001 7.001 0 0 1 3 9a.75.75 0 0 1 .75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, sSe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="minus">
    <path fill-rule="evenodd" d="M4 10a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H4.75A.75.75 0 0 1 4 10Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, iSe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="mobile">
    <path fill-rule="evenodd" d="M3 3.75A2.75 2.75 0 0 1 5.75 1h8.5A2.75 2.75 0 0 1 17 3.75v12.5A2.75 2.75 0 0 1 14.25 19h-8.5A2.75 2.75 0 0 1 3 16.25V3.75ZM5.75 2.5c-.69 0-1.25.56-1.25 1.25v12.5c0 .69.56 1.25 1.25 1.25h8.5c.69 0 1.25-.56 1.25-1.25V3.75c0-.69-.56-1.25-1.25-1.25h-8.5ZM9 15.25a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, rSe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="more-horizontal">
    <path fill-rule="evenodd" d="M4.75 10a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm6.75 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm5.25 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, lSe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="more-vertical">
    <path fill-rule="evenodd" d="M10 4.75a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm0 6.75a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm-1.5 5.25a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, aSe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="mouse">
    <path fill-rule="evenodd" d="M4 7a6 6 0 1 1 12 0v6a6 6 0 0 1-12 0V7Zm6-4.5A4.5 4.5 0 0 0 5.5 7v6a4.5 4.5 0 1 0 9 0V7A4.5 4.5 0 0 0 10 2.5ZM10 5a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0v-2.5A.75.75 0 0 1 10 5Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, cSe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="navigation">
    <path fill-rule="evenodd" d="M8.181 2.302a1.922 1.922 0 0 1 3.638 0l5.055 13.996c.318.88.005 1.738-.582 2.238-.593.505-1.501.668-2.297.134l-3.771-2.531a.394.394 0 0 0-.448 0L6.005 18.67c-.796.534-1.704.37-2.296-.134-.588-.5-.9-1.358-.583-2.238L8.181 2.302Zm2.227.51c-.15-.416-.666-.416-.816 0L4.537 16.807a.514.514 0 0 0 .144.586c.145.124.318.145.488.03l3.771-2.53a1.895 1.895 0 0 1 2.12 0l3.771 2.53c.17.115.343.094.488-.03a.514.514 0 0 0 .144-.586L10.408 2.81Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, dSe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="notification">
    <path fill-rule="evenodd" d="M16 2.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM13 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0ZM1 4.75A2.75 2.75 0 0 1 3.75 2H9a.75.75 0 0 1 0 1.5H3.75c-.69 0-1.25.56-1.25 1.25v11.5c0 .69.56 1.25 1.25 1.25h11.5c.69 0 1.25-.56 1.25-1.25V11a.75.75 0 0 1 1.5 0v5.25A2.75 2.75 0 0 1 15.25 19H3.75A2.75 2.75 0 0 1 1 16.25V4.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, uSe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="open-in-new">
    <path fill-rule="evenodd" d="M14 1.75a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0V3.56l-5.97 5.97a.75.75 0 1 1-1.06-1.06l5.97-5.97h-1.69a.75.75 0 0 1-.75-.75Zm-13 3A2.75 2.75 0 0 1 3.75 2H9a.75.75 0 0 1 0 1.5H3.75c-.69 0-1.25.56-1.25 1.25v11.5c0 .69.56 1.25 1.25 1.25h11.5c.69 0 1.25-.56 1.25-1.25V11a.75.75 0 0 1 1.5 0v5.25A2.75 2.75 0 0 1 15.25 19H3.75A2.75 2.75 0 0 1 1 16.25V4.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, hSe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="option">
    <path fill-rule="evenodd" d="M1 7a.75.75 0 0 1 .75-.75H7.5a.75.75 0 0 1 .692.462L10.5 12.25h7.75a.75.75 0 0 1 0 1.5H10a.75.75 0 0 1-.692-.461L7 7.75H1.75A.75.75 0 0 1 1 7Zm11 0a.75.75 0 0 1 .75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5A.75.75 0 0 1 12 7Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, gSe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="package">
    <path fill-rule="evenodd" d="M9.657 1.083a.75.75 0 0 1 .687 0l8.25 4.25A.75.75 0 0 1 19 6v8a.75.75 0 0 1-.407.667l-8.25 4.25a.75.75 0 0 1-.686 0l-8.25-4.25A.75.75 0 0 1 1 14V6a.75.75 0 0 1 .407-.667l8.25-4.25ZM2.5 7.197v6.346l6.75 3.477v-6.55L2.5 7.197Zm8.25 3.273v6.55l6.75-3.477V7.197l-6.75 3.273Zm5.823-4.49-2.506 1.215L7.47 3.897 10 2.594l6.573 3.386ZM5.818 4.748 3.429 5.98 10 9.166l2.364-1.146-6.546-3.272Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, pSe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="paintroller">
    <path fill-rule="evenodd" d="M2 2.25C2 1.56 2.56 1 3.25 1h11.5c.69 0 1.25.56 1.25 1.25v1h1.15c.47 0 .85.38.85.85v4.55c0 .47-.38.85-.85.85h-7.4V11H10a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h.25V8.85c0-.47.38-.85.85-.85h7.4V4.75H16v1C16 6.44 15.44 7 14.75 7H3.25C2.56 7 2 6.44 2 5.75v-3.5Zm12.5.25h-11v3h11v-3Zm-6 10v5h1v-5h-1Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, fSe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="paperplane">
    <path fill-rule="evenodd" d="M18.672 1.13c.236.16.36.44.321.722l-2 14.5a.75.75 0 0 1-.998.603l-4.8-1.738-2.052 3.419a.75.75 0 0 1-1.373-.212l-1.158-4.866-5.117-1.853a.75.75 0 0 1-.112-1.36l16.5-9.25a.75.75 0 0 1 .79.035ZM8.3 14.17l.504 2.117.954-1.59L8.3 14.17Zm.308-1.484 8.59-8.785-1.563 11.33-7.027-2.545Zm5.461-7.73-7.01 7.17-3.512-1.272 10.522-5.899Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, vSe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="paragraph">
    <path fill-rule="evenodd" d="M7.364 3.5a3.864 3.864 0 1 0 0 7.727h3.82V3.5h-3.82Zm0-1.5a5.364 5.364 0 1 0 0 10.727h3.82v4.523a.75.75 0 0 0 1.5 0V3.5h1.619v13.75a.75.75 0 0 0 1.5 0V3.5h1.447a.75.75 0 0 0 0-1.5H7.364Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, mSe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="pause-circle">
    <path fill-rule="evenodd" d="M10 2.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15ZM1 10a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm6.75-4a.75.75 0 0 1 .75.75v6.5a.75.75 0 0 1-1.5 0v-6.5A.75.75 0 0 1 7.75 6Zm4.5 0a.75.75 0 0 1 .75.75v6.5a.75.75 0 0 1-1.5 0v-6.5a.75.75 0 0 1 .75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, CSe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="pause">
    <path fill-rule="evenodd" d="M7.75 4a.75.75 0 0 1 .75.75v10.5a.75.75 0 0 1-1.5 0V4.75A.75.75 0 0 1 7.75 4Zm4.5 0a.75.75 0 0 1 .75.75v10.5a.75.75 0 0 1-1.5 0V4.75a.75.75 0 0 1 .75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, wSe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="phone-call">
    <path fill-rule="evenodd" d="M12.25 1.75A.75.75 0 0 1 13 1a6 6 0 0 1 6 6 .75.75 0 0 1-1.5 0A4.5 4.5 0 0 0 13 2.5a.75.75 0 0 1-.75-.75Zm-1 3A.75.75 0 0 1 12 4a4 4 0 0 1 4 4 .75.75 0 0 1-1.5 0A2.5 2.5 0 0 0 12 5.5a.75.75 0 0 1-.75-.75ZM1 5.375A4.375 4.375 0 0 1 5.375 1c.439 0 .86.174 1.17.485l.006.005.096.099a168.388 168.388 0 0 1 1.026 1.06c.282.294.569.597.79.838.11.12.208.23.283.318a2.931 2.931 0 0 1 .162.212l.001.001A.8.8 0 0 1 9 4.209c.114.352.114.73 0 1.082a1.193 1.193 0 0 1-.194.347l-.002.002a4.015 4.015 0 0 1-.197.233c-.14.155-.32.34-.497.522l-.027.028c-.37.379-.711.73-.873.945-.242.322-.293.854-.177 1.176l.001.003.237.498a9.253 9.253 0 0 0 .467.827c.728 1.114 1.276 1.646 2.396 2.394.29.194.666.398 1 .565a12.213 12.213 0 0 0 .606.28l.003.002c.294.096.614.08.897-.046.155-.069.563-.33 1.032-.637l.106-.07c.18-.117.355-.233.5-.324a5.61 5.61 0 0 1 .239-.146 2.17 2.17 0 0 1 .114-.062.997.997 0 0 1 .198-.075 1.75 1.75 0 0 1 .842 0 1.273 1.273 0 0 1 .289.12c.068.037.146.082.227.13.162.099.36.224.559.352.396.255.81.53.966.635A2.892 2.892 0 0 1 19 15.396 3.604 3.604 0 0 1 15.396 19h-2.48a7.564 7.564 0 0 1-3.49-.853 17.784 17.784 0 0 1-7.573-7.573A7.564 7.564 0 0 1 1 7.084v-1.71Zm4.483-2.83a.156.156 0 0 0-.108-.045A2.875 2.875 0 0 0 2.5 5.375v1.71c0 .973.235 1.933.684 2.797a16.283 16.283 0 0 0 6.934 6.934c.864.45 1.824.684 2.798.684h2.48a2.104 2.104 0 0 0 2.104-2.104c0-.465-.232-.9-.62-1.158a70.11 70.11 0 0 0-.947-.622c-.193-.125-.377-.24-.52-.327a4.981 4.981 0 0 0-.15-.087h-.02l-.162.1c-.134.085-.297.193-.478.311l-.109.071c-.407.268-.948.622-1.245.754a2.75 2.75 0 0 1-1.974.1 8.21 8.21 0 0 1-.811-.365 11.205 11.205 0 0 1-1.163-.66c-1.275-.85-1.971-1.524-2.818-2.82a11.498 11.498 0 0 1-.861-1.64c-.274-.76-.18-1.83.389-2.586.223-.296.624-.708.952-1.044l.073-.075c.181-.186.34-.35.458-.48.039-.043.069-.078.091-.105v-.007a11.508 11.508 0 0 0-.228-.255 65.12 65.12 0 0 0-.767-.815 147.705 147.705 0 0 0-1.016-1.049l-.09-.093Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, bSe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="phone-callback">
    <path fill-rule="evenodd" d="M15.259 1.199a.75.75 0 0 1 .042 1.06L13.463 4.25h4.787a.75.75 0 0 1 0 1.5h-4.787l1.838 1.991A.75.75 0 1 1 14.2 8.76l-3-3.25a.75.75 0 0 1 0-1.018l3-3.25a.75.75 0 0 1 1.06-.042ZM1 5.375A4.375 4.375 0 0 1 5.375 1c.439 0 .86.174 1.17.485l.006.005.096.099a168.388 168.388 0 0 1 1.026 1.06c.282.294.569.597.79.838.11.12.208.23.283.318a2.931 2.931 0 0 1 .162.212l.001.001A.8.8 0 0 1 9 4.209c.114.352.114.73 0 1.082a1.193 1.193 0 0 1-.194.347l-.002.002a4.015 4.015 0 0 1-.197.233c-.14.155-.32.34-.497.522l-.027.028c-.37.379-.711.73-.873.945-.242.322-.293.854-.177 1.176l.001.003.237.498a9.253 9.253 0 0 0 .467.827c.728 1.114 1.276 1.646 2.396 2.394.29.194.666.398 1 .565a12.213 12.213 0 0 0 .606.28l.003.002c.294.096.614.08.897-.046.155-.069.563-.33 1.032-.637l.106-.07c.18-.117.355-.233.5-.324a5.61 5.61 0 0 1 .239-.146 2.17 2.17 0 0 1 .114-.062.997.997 0 0 1 .198-.075 1.75 1.75 0 0 1 .842 0 1.273 1.273 0 0 1 .289.12c.068.037.146.082.227.13.162.099.36.224.559.352.396.255.81.53.966.635A2.892 2.892 0 0 1 19 15.396 3.604 3.604 0 0 1 15.396 19h-2.48a7.564 7.564 0 0 1-3.49-.853 17.784 17.784 0 0 1-7.573-7.573A7.564 7.564 0 0 1 1 7.084v-1.71Zm4.483-2.83a.156.156 0 0 0-.108-.045A2.875 2.875 0 0 0 2.5 5.375v1.71c0 .973.235 1.933.684 2.797a16.283 16.283 0 0 0 6.934 6.934c.864.45 1.824.684 2.798.684h2.48a2.104 2.104 0 0 0 2.104-2.104c0-.465-.232-.9-.62-1.158a70.11 70.11 0 0 0-.947-.622c-.193-.125-.377-.24-.52-.327a4.981 4.981 0 0 0-.15-.087h-.02l-.162.1c-.134.085-.297.193-.478.311l-.109.071c-.407.268-.948.622-1.245.754a2.75 2.75 0 0 1-1.974.1 8.21 8.21 0 0 1-.811-.365 11.205 11.205 0 0 1-1.163-.66c-1.275-.85-1.971-1.524-2.818-2.82a11.498 11.498 0 0 1-.861-1.64c-.274-.76-.18-1.83.389-2.586.223-.296.624-.708.952-1.044l.073-.075c.181-.186.34-.35.458-.48.039-.043.069-.078.091-.105v-.007a11.508 11.508 0 0 0-.228-.255 65.12 65.12 0 0 0-.767-.815 147.705 147.705 0 0 0-1.016-1.049l-.09-.093Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, ySe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="phone-forwarded">
    <path fill-rule="evenodd" d="M14.741 1.199a.75.75 0 0 1 1.06.042l3 3.25a.75.75 0 0 1 0 1.018l-3 3.25A.75.75 0 1 1 14.7 7.74l1.838-1.991H11.75a.75.75 0 0 1 0-1.5h4.787l-1.838-1.991a.75.75 0 0 1 .042-1.06ZM1 5.375A4.375 4.375 0 0 1 5.375 1c.439 0 .86.174 1.17.485l.006.005.096.099a163.167 163.167 0 0 1 1.026 1.06c.282.294.569.597.79.838.11.12.208.23.283.318a2.931 2.931 0 0 1 .162.212l.001.001A.8.8 0 0 1 9 4.209c.114.352.114.73 0 1.082a1.193 1.193 0 0 1-.194.347l-.002.002a4.012 4.012 0 0 1-.197.233c-.14.155-.32.34-.497.522l-.027.028c-.37.379-.711.73-.873.945-.242.322-.293.854-.177 1.176l.001.003.237.498a9.251 9.251 0 0 0 .467.827c.728 1.114 1.276 1.646 2.396 2.394.29.194.666.398 1 .565a12.213 12.213 0 0 0 .606.28l.003.002c.294.096.614.08.897-.046.155-.069.563-.33 1.032-.637l.106-.07c.18-.117.355-.233.5-.324a5.61 5.61 0 0 1 .239-.146 2.17 2.17 0 0 1 .114-.062.997.997 0 0 1 .198-.075c.276-.068.566-.068.842 0a1.27 1.27 0 0 1 .289.12c.068.037.146.082.227.13.162.099.36.224.559.352.396.255.81.53.966.635A2.892 2.892 0 0 1 19 15.396 3.604 3.604 0 0 1 15.396 19h-2.48a7.564 7.564 0 0 1-3.49-.853 17.784 17.784 0 0 1-7.573-7.573A7.564 7.564 0 0 1 1 7.084v-1.71Zm4.483-2.83a.156.156 0 0 0-.108-.045A2.875 2.875 0 0 0 2.5 5.375v1.71c0 .973.235 1.933.684 2.797a16.283 16.283 0 0 0 6.934 6.934c.864.45 1.824.684 2.798.684h2.48a2.104 2.104 0 0 0 2.104-2.104c0-.465-.232-.9-.62-1.158a70.11 70.11 0 0 0-.947-.622c-.193-.125-.377-.24-.52-.327a4.981 4.981 0 0 0-.15-.087h-.02l-.162.1c-.134.085-.297.193-.478.311l-.109.071c-.407.268-.948.622-1.245.754a2.75 2.75 0 0 1-1.974.1 8.21 8.21 0 0 1-.811-.365 11.205 11.205 0 0 1-1.163-.66c-1.275-.85-1.971-1.524-2.818-2.82a11.498 11.498 0 0 1-.861-1.64c-.274-.76-.18-1.83.389-2.586.223-.296.624-.708.952-1.044l.073-.075c.181-.186.34-.35.458-.48a3.52 3.52 0 0 0 .091-.105v-.007a11.508 11.508 0 0 0-.228-.255 55.62 55.62 0 0 0-.767-.815 147.367 147.367 0 0 0-1.016-1.049l-.09-.093Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, _Se = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="phone-incoming">
    <g class="Icon">
      <path fill-rule="evenodd" d="M17.78 2.22a.75.75 0 0 1 0 1.06L13.56 7.5h2.69a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75v-4.5a.75.75 0 0 1 1.5 0v2.69l4.22-4.22a.75.75 0 0 1 1.06 0Z" clip-rule="evenodd"/>
      <path fill-rule="evenodd" d="M1 5.375A4.375 4.375 0 0 1 5.375 1c.439 0 .86.174 1.17.485l.006.005.096.099a168.388 168.388 0 0 1 1.026 1.06c.282.294.569.597.79.838.11.12.208.23.283.318a2.931 2.931 0 0 1 .162.212l.001.001A.8.8 0 0 1 9 4.209c.114.352.114.73 0 1.082a1.193 1.193 0 0 1-.194.347l-.002.002a4.015 4.015 0 0 1-.197.233c-.14.155-.32.34-.497.522l-.027.028c-.37.379-.711.73-.873.945-.242.322-.293.854-.177 1.176l.001.003.237.498a9.253 9.253 0 0 0 .467.827c.728 1.114 1.276 1.646 2.396 2.394.29.194.666.398 1 .565a12.213 12.213 0 0 0 .606.28l.003.002c.294.096.614.08.897-.046.155-.069.563-.33 1.032-.637l.106-.07c.18-.117.355-.233.5-.324a5.61 5.61 0 0 1 .239-.146 2.17 2.17 0 0 1 .114-.062.997.997 0 0 1 .198-.075 1.75 1.75 0 0 1 .842 0 1.273 1.273 0 0 1 .289.12c.068.037.146.082.227.13.162.099.36.224.559.352.396.255.81.53.966.635A2.892 2.892 0 0 1 19 15.396 3.604 3.604 0 0 1 15.396 19h-2.48a7.564 7.564 0 0 1-3.49-.853 17.784 17.784 0 0 1-7.573-7.573A7.564 7.564 0 0 1 1 7.084v-1.71Zm4.483-2.83a.156.156 0 0 0-.108-.045A2.875 2.875 0 0 0 2.5 5.375v1.71c0 .973.235 1.933.684 2.797a16.283 16.283 0 0 0 6.934 6.934c.864.45 1.824.684 2.798.684h2.48a2.104 2.104 0 0 0 2.104-2.104c0-.465-.232-.9-.62-1.158a70.11 70.11 0 0 0-.947-.622c-.193-.125-.377-.24-.52-.327a4.981 4.981 0 0 0-.15-.087h-.02l-.162.1c-.134.085-.297.193-.478.311l-.109.071c-.407.268-.948.622-1.245.754a2.75 2.75 0 0 1-1.974.1 8.21 8.21 0 0 1-.811-.365 11.205 11.205 0 0 1-1.163-.66c-1.275-.85-1.971-1.524-2.818-2.82a11.498 11.498 0 0 1-.861-1.64c-.274-.76-.18-1.83.389-2.586.223-.296.624-.708.952-1.044l.073-.075c.181-.186.34-.35.458-.48.039-.043.069-.078.091-.105v-.007a11.508 11.508 0 0 0-.228-.255 65.12 65.12 0 0 0-.767-.815 147.705 147.705 0 0 0-1.016-1.049l-.09-.093Z" clip-rule="evenodd"/>
    </g>
  </g>
</svg>
`, SSe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="phone-missed">
    <g class="Icon">
      <path fill-rule="evenodd" d="M12.22 2.22a.75.75 0 0 1 1.06 0L15 3.94l1.72-1.72a.75.75 0 1 1 1.06 1.06L16.06 5l1.72 1.72a.75.75 0 0 1-1.06 1.06L15 6.06l-1.72 1.72a.75.75 0 1 1-1.06-1.06L13.94 5l-1.72-1.72a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd"/>
      <path fill-rule="evenodd" d="M1 5.375A4.375 4.375 0 0 1 5.375 1c.439 0 .86.174 1.17.485l.006.005.096.099a168.388 168.388 0 0 1 1.026 1.06c.282.294.569.597.79.838.11.12.208.23.283.318a2.931 2.931 0 0 1 .162.212l.001.001A.8.8 0 0 1 9 4.209c.114.352.114.73 0 1.082a1.193 1.193 0 0 1-.194.347l-.002.002a4.015 4.015 0 0 1-.197.233c-.14.155-.32.34-.497.522l-.027.028c-.37.379-.711.73-.873.945-.242.322-.293.854-.177 1.176l.001.003.237.498a9.253 9.253 0 0 0 .467.827c.728 1.114 1.276 1.646 2.396 2.394.29.194.666.398 1 .565a12.213 12.213 0 0 0 .606.28l.003.002c.294.096.614.08.897-.046.155-.069.563-.33 1.032-.637l.106-.07c.18-.117.355-.233.5-.324a5.61 5.61 0 0 1 .239-.146 2.17 2.17 0 0 1 .114-.062.997.997 0 0 1 .198-.075 1.75 1.75 0 0 1 .842 0 1.273 1.273 0 0 1 .289.12c.068.037.146.082.227.13.162.099.36.224.559.352.396.255.81.53.966.635A2.892 2.892 0 0 1 19 15.396 3.604 3.604 0 0 1 15.396 19h-2.48a7.564 7.564 0 0 1-3.49-.853 17.784 17.784 0 0 1-7.573-7.573A7.564 7.564 0 0 1 1 7.084v-1.71Zm4.483-2.83a.156.156 0 0 0-.108-.045A2.875 2.875 0 0 0 2.5 5.375v1.71c0 .973.235 1.933.684 2.797a16.283 16.283 0 0 0 6.934 6.934c.864.45 1.824.684 2.798.684h2.48a2.104 2.104 0 0 0 2.104-2.104c0-.465-.232-.9-.62-1.158a70.11 70.11 0 0 0-.947-.622c-.193-.125-.377-.24-.52-.327a4.981 4.981 0 0 0-.15-.087h-.02l-.162.1c-.134.085-.297.193-.478.311l-.109.071c-.407.268-.948.622-1.245.754a2.75 2.75 0 0 1-1.974.1 8.21 8.21 0 0 1-.811-.365 11.205 11.205 0 0 1-1.163-.66c-1.275-.85-1.971-1.524-2.818-2.82a11.498 11.498 0 0 1-.861-1.64c-.274-.76-.18-1.83.389-2.586.223-.296.624-.708.952-1.044l.073-.075c.181-.186.34-.35.458-.48.039-.043.069-.078.091-.105v-.007a11.508 11.508 0 0 0-.228-.255 65.12 65.12 0 0 0-.767-.815 147.705 147.705 0 0 0-1.016-1.049l-.09-.093Z" clip-rule="evenodd"/>
    </g>
  </g>
</svg>
`, xSe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="phone-outgoing">
    <g class="Icon">
      <path fill-rule="evenodd" d="M12 2.75a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0V4.56l-4.22 4.22a.75.75 0 1 1-1.06-1.06l4.22-4.22h-2.69a.75.75 0 0 1-.75-.75Z" clip-rule="evenodd"/>
      <path fill-rule="evenodd" d="M1 5.375A4.375 4.375 0 0 1 5.375 1c.439 0 .86.174 1.17.485l.006.005.096.099a168.388 168.388 0 0 1 1.026 1.06c.282.294.569.597.79.838.11.12.208.23.283.318a2.931 2.931 0 0 1 .162.212l.001.001A.8.8 0 0 1 9 4.209c.114.352.114.73 0 1.082a1.193 1.193 0 0 1-.194.347l-.002.002a4.015 4.015 0 0 1-.197.233c-.14.155-.32.34-.497.522l-.027.028c-.37.379-.711.73-.873.945-.242.322-.293.854-.177 1.176l.001.003.237.498a9.253 9.253 0 0 0 .467.827c.728 1.114 1.276 1.646 2.396 2.394.29.194.666.398 1 .565a12.213 12.213 0 0 0 .606.28l.003.002c.294.096.614.08.897-.046.155-.069.563-.33 1.032-.637l.106-.07c.18-.117.355-.233.5-.324a5.61 5.61 0 0 1 .239-.146 2.17 2.17 0 0 1 .114-.062.997.997 0 0 1 .198-.075 1.75 1.75 0 0 1 .842 0 1.273 1.273 0 0 1 .289.12c.068.037.146.082.227.13.162.099.36.224.559.352.396.255.81.53.966.635A2.892 2.892 0 0 1 19 15.396 3.604 3.604 0 0 1 15.396 19h-2.48a7.564 7.564 0 0 1-3.49-.853 17.784 17.784 0 0 1-7.573-7.573A7.564 7.564 0 0 1 1 7.084v-1.71Zm4.483-2.83a.156.156 0 0 0-.108-.045A2.875 2.875 0 0 0 2.5 5.375v1.71c0 .973.235 1.933.684 2.797a16.283 16.283 0 0 0 6.934 6.934c.864.45 1.824.684 2.798.684h2.48a2.104 2.104 0 0 0 2.104-2.104c0-.465-.232-.9-.62-1.158a70.11 70.11 0 0 0-.947-.622c-.193-.125-.377-.24-.52-.327a4.981 4.981 0 0 0-.15-.087h-.02l-.162.1c-.134.085-.297.193-.478.311l-.109.071c-.407.268-.948.622-1.245.754a2.75 2.75 0 0 1-1.974.1 8.21 8.21 0 0 1-.811-.365 11.205 11.205 0 0 1-1.163-.66c-1.275-.85-1.971-1.524-2.818-2.82a11.498 11.498 0 0 1-.861-1.64c-.274-.76-.18-1.83.389-2.586.223-.296.624-.708.952-1.044l.073-.075c.181-.186.34-.35.458-.48.039-.043.069-.078.091-.105v-.007a11.508 11.508 0 0 0-.228-.255 65.12 65.12 0 0 0-.767-.815 147.705 147.705 0 0 0-1.016-1.049l-.09-.093Z" clip-rule="evenodd"/>
    </g>
  </g>
</svg>
`, MSe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="phone">
    <path fill-rule="evenodd" d="M1 5.375A4.375 4.375 0 0 1 5.375 1c.439 0 .86.174 1.17.485l.006.005.096.099a168.388 168.388 0 0 1 1.026 1.06c.282.294.569.597.79.838.11.12.208.23.283.318a2.931 2.931 0 0 1 .162.212l.001.001A.8.8 0 0 1 9 4.209c.114.352.114.73 0 1.082a1.193 1.193 0 0 1-.194.347l-.002.002a4.015 4.015 0 0 1-.197.233c-.14.155-.32.34-.497.522l-.027.028c-.37.379-.711.73-.873.945-.242.322-.293.854-.177 1.176l.001.003.237.498a9.253 9.253 0 0 0 .467.827c.728 1.114 1.276 1.646 2.396 2.394.29.194.666.398 1 .565a12.213 12.213 0 0 0 .606.28l.003.002c.294.096.614.08.897-.046.155-.069.563-.33 1.032-.637l.106-.07c.18-.117.355-.233.5-.324a5.61 5.61 0 0 1 .239-.146 2.17 2.17 0 0 1 .114-.062.997.997 0 0 1 .198-.075 1.75 1.75 0 0 1 .842 0 1.273 1.273 0 0 1 .289.12c.068.037.146.082.227.13.162.099.36.224.559.352.396.255.81.53.966.635A2.892 2.892 0 0 1 19 15.396 3.604 3.604 0 0 1 15.396 19h-2.48a7.564 7.564 0 0 1-3.49-.853 17.784 17.784 0 0 1-7.573-7.573A7.564 7.564 0 0 1 1 7.084v-1.71Zm4.483-2.83a.156.156 0 0 0-.108-.045A2.875 2.875 0 0 0 2.5 5.375v1.71c0 .973.235 1.933.684 2.797a16.283 16.283 0 0 0 6.934 6.934c.864.45 1.824.684 2.798.684h2.48a2.104 2.104 0 0 0 2.104-2.104c0-.465-.232-.9-.62-1.158a70.11 70.11 0 0 0-.947-.622c-.193-.125-.377-.24-.52-.327a4.981 4.981 0 0 0-.15-.087h-.02l-.162.1c-.134.085-.297.193-.478.311l-.109.071c-.407.268-.948.622-1.245.754a2.75 2.75 0 0 1-1.974.1 8.21 8.21 0 0 1-.811-.365 11.205 11.205 0 0 1-1.163-.66c-1.275-.85-1.971-1.524-2.818-2.82a11.498 11.498 0 0 1-.861-1.64c-.274-.76-.18-1.83.389-2.586.223-.296.624-.708.952-1.044l.073-.075c.181-.186.34-.35.458-.48.039-.043.069-.078.091-.105v-.007a11.508 11.508 0 0 0-.228-.255 65.12 65.12 0 0 0-.767-.815 147.705 147.705 0 0 0-1.016-1.049l-.09-.093Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, ASe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="pin">
    <path fill-rule="evenodd" d="M7.51 1h4.98c.341 0 .64 0 .885.02.256.02.533.067.796.21.373.205.67.535.819.942.107.294.098.58.065.829-.03.233-.093.51-.163.815l-.437 1.921c-.085.373-.103.466-.106.553-.003.092.005.184.024.274.019.086.054.177.202.532l1.974 4.718c.141.339.268.641.346.895.082.264.149.582.07.923a1.753 1.753 0 0 1-.803 1.094c-.285.173-.597.227-.882.25-.277.024-.621.024-1.018.024H10.75v3.25a.75.75 0 0 1-1.5 0V15H5.738c-.397 0-.741 0-1.018-.023-.285-.024-.597-.078-.882-.251a1.752 1.752 0 0 1-.802-1.094c-.08-.34-.013-.659.068-.923.08-.254.206-.556.347-.895l1.974-4.718c.149-.355.183-.446.202-.532.02-.09.027-.182.024-.274-.003-.087-.021-.18-.106-.553l-.43-1.891-.007-.03a9.132 9.132 0 0 1-.163-.815 1.716 1.716 0 0 1 .065-.829 1.77 1.77 0 0 1 .82-.941c.262-.144.539-.19.795-.211C6.869 1 7.169 1 7.51 1Zm-.961 1.547a.722.722 0 0 1 .197-.032c.177-.014.415-.015.792-.015h4.924c.377 0 .615 0 .792.015.145.012.191.03.198.032a.277.277 0 0 1 .124.13.69.69 0 0 1-.008.13c-.02.154-.067.362-.145.706l-.43 1.892a10.79 10.79 0 0 1-.013.052c-.066.294-.12.532-.13.778a2.63 2.63 0 0 0 .056.644c.052.24.146.465.264.746l.021.05 1.96 4.687c.16.38.257.614.312.79a.874.874 0 0 1 .036.154.262.262 0 0 1-.116.138.834.834 0 0 1-.228.038 12.8 12.8 0 0 1-.924.018H5.77c-.437 0-.717 0-.924-.018a.834.834 0 0 1-.229-.038.261.261 0 0 1-.115-.138.87.87 0 0 1 .036-.153c.055-.177.152-.412.311-.791L6.81 7.675l.021-.05c.117-.28.212-.506.264-.746a2.63 2.63 0 0 0 .056-.644c-.01-.246-.063-.484-.13-.778l-.013-.052-.43-1.892a8.811 8.811 0 0 1-.145-.706.737.737 0 0 1-.009-.13.278.278 0 0 1 .126-.13Zm-.126.13a.07.07 0 0 1 .001-.007s0 .007-.005.017a.19.19 0 0 1 .004-.01ZM4.501 13.306a.186.186 0 0 1-.005-.015.104.104 0 0 1 .004.024v-.01Zm.115.138Zm10.767 0h-.001.002Zm.116-.138.001.009s0-.01.004-.024a.158.158 0 0 1-.005.015Zm-1.923-10.63a.162.162 0 0 1 .005.011.092.092 0 0 1-.005-.017v.007Zm-.124-.129Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, LSe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="placeholder-2">
    <path fill-rule="evenodd" d="M2.537 9.25h14.926a7.501 7.501 0 0 0-14.926 0Zm14.926 1.5H2.537a7.5 7.5 0 0 0 14.926 0ZM1 10a9 9 0 1 1 18 0 9 9 0 0 1-18 0Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, ESe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="placeholder">
    <path fill-rule="evenodd" d="M10 2.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15ZM1 10a9 9 0 1 1 18 0 9 9 0 0 1-18 0Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, PSe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="play-circle">
    <path fill-rule="evenodd" d="M10 2.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15ZM1 10a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm7.409-3.918a.75.75 0 0 1 .78.06l4.5 3.25a.75.75 0 0 1 0 1.216l-4.5 3.25A.75.75 0 0 1 8 13.25v-6.5a.75.75 0 0 1 .409-.668ZM9.5 8.217v3.566L11.969 10 9.5 8.217Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, RSe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="play">
    <path fill-rule="evenodd" d="M5.394 3.09a.75.75 0 0 1 .768.033l9.5 6.25a.75.75 0 0 1 0 1.254l-9.5 6.25A.75.75 0 0 1 5 16.25V3.75a.75.75 0 0 1 .394-.66ZM6.5 5.14v9.718L13.885 10 6.5 5.141Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, FSe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="plugin">
    <path fill-rule="evenodd" d="M7.75 1a.75.75 0 0 1 .75.75V4h3V1.75a.75.75 0 0 1 1.5 0V4h1.25A2.75 2.75 0 0 1 17 6.75v2.5a6.75 6.75 0 0 1-6.25 6.732v2.268a.75.75 0 0 1-1.5 0v-2.268A6.75 6.75 0 0 1 3 9.25v-2.5A2.75 2.75 0 0 1 5.75 4H7V1.75A.75.75 0 0 1 7.75 1Zm-2 4.5c-.69 0-1.25.56-1.25 1.25v2.5c0 2.9 2.35 5.25 5.25 5.25h.5c2.9 0 5.25-2.35 5.25-5.25v-2.5c0-.69-.56-1.25-1.25-1.25h-8.5Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, TSe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="plus">
    <path fill-rule="evenodd" d="M10 4a.75.75 0 0 1 .75.75v4.5h4.5a.75.75 0 0 1 0 1.5h-4.5v4.5a.75.75 0 0 1-1.5 0v-4.5h-4.5a.75.75 0 0 1 0-1.5h4.5v-4.5A.75.75 0 0 1 10 4Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, ISe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="print">
    <path fill-rule="evenodd" d="M4.25 3a1 1 0 0 1 1-1h9.5a1 1 0 0 1 1 1v2h2c.69 0 1.25.56 1.25 1.25v7.5c0 .69-.56 1.25-1.25 1.25h-2v2a1 1 0 0 1-1 1h-9.5a1 1 0 0 1-1-1v-2h-2C1.56 15 1 14.44 1 13.75v-7.5C1 5.56 1.56 5 2.25 5h2V3Zm0 10.5v-2a1 1 0 0 1 1-1h9.5a1 1 0 0 1 1 1v2h1.75v-7h-15v7h1.75Zm1.5-10V5h8.5V3.5h-8.5ZM14 8.75a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75ZM5.75 12v4.5h8.5V12h-8.5ZM7 14.25a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, DSe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="questionmark">
    <path fill-rule="evenodd" d="M10 2.5c-2.472 0-4.5 1.9-4.5 4.75a.75.75 0 0 1-1.5 0C4 3.6 6.673 1 10 1s6 2.6 6 6.25c0 2.118-1.497 3.816-3.084 4.874-.728.485-1.266.927-1.625 1.415-.343.465-.541.997-.541 1.711a.75.75 0 0 1-1.5 0c0-1.036.302-1.88.834-2.601.516-.7 1.228-1.258 2-1.773C13.497 9.934 14.5 8.632 14.5 7.25c0-2.85-2.028-4.75-4.5-4.75ZM10 17a.75.75 0 0 1 .75.75v.5a.75.75 0 0 1-1.5 0v-.5A.75.75 0 0 1 10 17Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, kSe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="quote">
    <path fill-rule="evenodd" d="M6.585 4.546c-.14-.04-.333-.046-1.025-.046h-.61c-.572 0-.957 0-1.253.025-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.547c-.046.09-.088.227-.111.514-.024.296-.025.68-.025 1.253v.1c0 .572 0 .957.025 1.253.023.287.065.424.111.514.12.236.311.427.547.547.09.046.227.088.514.111.296.024.68.025 1.253.025h.55a.75.75 0 0 1 .67 1.085L4.715 13.5h.735a7.002 7.002 0 0 0 .224-.003.25.25 0 0 0 .161-.1l.02-.033a6.82 6.82 0 0 0 .083-.166c.378-.754.55-1.1.697-1.451a11.25 11.25 0 0 0 .84-3.559c.026-.379.026-.766.026-1.61V6.44c0-.692-.007-.885-.046-1.025a1.25 1.25 0 0 0-.87-.87ZM5.66 3c.542 0 .961 0 1.325.1A2.75 2.75 0 0 1 8.9 5.014c.1.364.1.783.1 1.325v.272c0 .803 0 1.244-.03 1.68a12.75 12.75 0 0 1-.952 4.033c-.168.404-.365.798-.725 1.516l-.014.029-.016.032a2.643 2.643 0 0 1-.214.376 1.75 1.75 0 0 1-1.132.7 2.642 2.642 0 0 1-.433.023H3.5a.75.75 0 0 1-.67-1.085l1.458-2.917a9.845 9.845 0 0 1-.713-.028c-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 1.3 9.498c-.172-.337-.24-.693-.27-1.073C1 8.06 1 7.615 1 7.08v-.16c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 2.502 3.3c.337-.172.693-.24 1.073-.27C3.94 3 4.385 3 4.92 3h.741Zm10.923 3.546c-.139-.04-.332-.046-1.024-.046h-.61c-.572 0-.957 0-1.252.025-.288.023-.425.065-.516.111a1.25 1.25 0 0 0-.546.547c-.046.09-.088.227-.111.514-.024.296-.025.68-.025 1.253v.1c0 .572 0 .957.025 1.252.023.288.065.425.111.516.12.235.311.426.546.546.091.046.228.088.515.111.296.024.68.025 1.253.025h.55a.75.75 0 0 1 .67 1.085L14.714 15.5h.736a7 7 0 0 0 .186-.001l.038-.002a.25.25 0 0 0 .161-.1l.02-.033a6.92 6.92 0 0 0 .083-.166c.377-.754.55-1.1.697-1.451.472-1.133.755-2.335.84-3.559.026-.379.026-.766.026-1.61V8.44c0-.692-.007-.885-.046-1.025a1.25 1.25 0 0 0-.87-.87ZM15.661 5c.542 0 .961 0 1.325.1A2.75 2.75 0 0 1 18.9 7.014c.1.364.1.783.1 1.325v.272c0 .803 0 1.244-.03 1.68a12.749 12.749 0 0 1-.952 4.033c-.168.404-.366.798-.725 1.517l-.014.028-.016.032a2.64 2.64 0 0 1-.214.376 1.75 1.75 0 0 1-1.132.7 2.642 2.642 0 0 1-.433.023H13.5a.75.75 0 0 1-.67-1.085l1.458-2.917a9.845 9.845 0 0 1-.713-.028c-.38-.03-.736-.098-1.073-.27a2.751 2.751 0 0 1-1.202-1.2c-.172-.338-.24-.694-.27-1.074C11 10.06 11 9.615 11 9.08v-.16c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 12.5 5.3c.338-.172.694-.24 1.074-.27.365-.03.81-.03 1.345-.03h.741Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, HSe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="rainbow">
    <path fill-rule="evenodd" d="M10 7.25c-3.57 0-6.75 3.148-6.75 7a.75.75 0 0 1-1.5 0c0-4.648 3.82-8.5 8.25-8.5s8.25 3.852 8.25 8.5a.75.75 0 0 1-1.5 0c0-3.852-3.18-7-6.75-7ZM10 10c-2.26 0-4.25 1.93-4.25 4.25a.75.75 0 0 1-1.5 0c0-3.163 2.676-5.75 5.75-5.75s5.75 2.587 5.75 5.75a.75.75 0 0 1-1.5 0c0-2.32-1.99-4.25-4.25-4.25Zm0 3c-.66 0-1.25.575-1.25 1.25a.75.75 0 0 1-1.5 0c0-1.518 1.276-2.75 2.75-2.75s2.75 1.232 2.75 2.75a.75.75 0 0 1-1.5 0c0-.675-.59-1.25-1.25-1.25Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, VSe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="receipt">
    <path fill-rule="evenodd" d="M4.25 2.5a1 1 0 0 0-1 1v13.425l1.364-.818a.75.75 0 0 1 .721-.028L8 17.411l2.665-1.332a.75.75 0 0 1 .694.013l1.641.895V3.5c0-.356.074-.694.208-1H4.25Zm11.088-1.495A.76.76 0 0 0 15.25 1h-11a2.5 2.5 0 0 0-2.5 2.5v14.75a.75.75 0 0 0 1.136.643l2.147-1.288 2.632 1.316a.75.75 0 0 0 .67 0l2.65-1.325 2.406 1.312a.75.75 0 0 0 1.109-.658V8.5h2.363c.058 0 .139 0 .212-.006.088-.007.229-.027.379-.103a1 1 0 0 0 .437-.437.986.986 0 0 0 .103-.379C18 7.502 18 7.421 18 7.363V3.5a2.5 2.5 0 0 0-2.662-2.495ZM14.5 7h2V3.5a1 1 0 1 0-2 0V7ZM5 6.25a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5A.75.75 0 0 1 5 6.25ZM5 9.5a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5A.75.75 0 0 1 5 9.5Zm0 3.25a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, OSe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="redo">
    <path fill-rule="evenodd" d="M18.25 7a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-.75.75h-4.5a.75.75 0 0 1 0-1.5h2.956C15.032 9.77 12.546 8.875 10 8.875c-3.06 0-6.037 1.295-7.617 3.778a.75.75 0 0 1-1.266-.806C3.037 8.83 6.561 7.375 10 7.375c2.728 0 5.508.915 7.5 2.8V7.75a.75.75 0 0 1 .75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, BSe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="refresh">
    <path fill-rule="evenodd" d="M10.836 1.281a.75.75 0 0 1-.117 1.055L9.889 3H10a6.981 6.981 0 0 1 4.95 2.05A6.981 6.981 0 0 1 17 10a6.98 6.98 0 0 1-.532 2.68.75.75 0 1 1-1.385-.575A5.48 5.48 0 0 0 15.5 10a5.481 5.481 0 0 0-1.61-3.89A5.481 5.481 0 0 0 10 4.5h-.112l.83.664a.75.75 0 1 1-.937 1.172l-2.5-2a.75.75 0 0 1 0-1.172l2.5-2a.75.75 0 0 1 1.055.117ZM4.512 6.915a.75.75 0 0 1 .405.98A5.481 5.481 0 0 0 4.5 10a5.482 5.482 0 0 0 1.61 3.89A5.483 5.483 0 0 0 10 15.5h.112l-.83-.664a.75.75 0 1 1 .937-1.172l2.5 2a.75.75 0 0 1 0 1.172l-2.5 2a.75.75 0 1 1-.938-1.172l.83-.664H10a6.983 6.983 0 0 1-4.95-2.05A6.981 6.981 0 0 1 3 10c0-.948.189-1.853.531-2.68a.75.75 0 0 1 .98-.405Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, $Se = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="repeat">
    <path fill-rule="evenodd" d="M8.82 1.262a.75.75 0 0 1-.082 1.057L6.778 4H9.5a7.5 7.5 0 1 1-7.314 5.834.75.75 0 1 1 1.463.332A6 6 0 1 0 9.5 5.5H6.777l1.961 1.68a.75.75 0 1 1-.976 1.14l-3.5-3a.75.75 0 0 1 0-1.14l3.5-3a.75.75 0 0 1 1.057.082Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, ZSe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="reply">
    <path fill-rule="evenodd" d="M8.544 2.06A.75.75 0 0 1 9 2.75v3.294c1.656.118 3.944.432 5.915 1.741C17.252 9.338 19 12.182 19 17.25a.75.75 0 0 1-1.5 0c0-.538-.274-1.103-.871-1.693-.597-.59-1.455-1.142-2.459-1.633-1.668-.818-3.629-1.418-5.17-1.76v3.086a.75.75 0 0 1-1.27.54l-6.5-6.25a.75.75 0 0 1 0-1.08l6.5-6.25a.75.75 0 0 1 .814-.15Zm8.658 11.997c-.543-2.62-1.763-4.122-3.117-5.022-1.895-1.26-4.203-1.447-5.875-1.536a.75.75 0 0 1-.71-.749V4.512L2.832 9 7.5 13.488V11.25a.75.75 0 0 1 .88-.739c1.718.301 4.29 1.007 6.45 2.066.864.423 1.69.916 2.372 1.48Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, GSe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="robot">
    <path fill-rule="evenodd" d="M10 2.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1ZM8 3a2 2 0 1 1 2.75 1.855V5.5h4.426c.258 0 .494 0 .692.016.213.018.446.057.676.175.33.168.598.435.765.765.118.23.157.463.175.676.016.198.016.434.016.692v1.384a2.5 2.5 0 0 1 0 4.584v2.384c0 .258 0 .494-.016.692a1.775 1.775 0 0 1-.175.677 1.75 1.75 0 0 1-.765.764 1.77 1.77 0 0 1-.676.175c-.198.016-.434.016-.692.016H4.824c-.258 0-.494 0-.692-.016a1.775 1.775 0 0 1-.676-.175 1.75 1.75 0 0 1-.765-.765 1.774 1.774 0 0 1-.175-.676c-.016-.198-.016-.434-.016-.692v-2.384a2.5 2.5 0 0 1 0-4.584V7.824c0-.258 0-.494.016-.692a1.77 1.77 0 0 1 .175-.676 1.75 1.75 0 0 1 .765-.765 1.77 1.77 0 0 1 .676-.175c.198-.016.434-.016.692-.016H9.25v-.645A2 2 0 0 1 8 3ZM4 16.15c0 .292 0 .467.011.596a.626.626 0 0 0 .018.12.25.25 0 0 0 .104.105.638.638 0 0 0 .121.018c.13.01.304.011.596.011h10.3c.292 0 .467 0 .596-.011a.636.636 0 0 0 .12-.018.25.25 0 0 0 .105-.105.636.636 0 0 0 .018-.12c.01-.13.011-.304.011-.596v-8.3c0-.292 0-.467-.011-.596a.638.638 0 0 0-.018-.12.25.25 0 0 0-.104-.105.626.626 0 0 0-.121-.018A8.337 8.337 0 0 0 15.15 7H4.85c-.292 0-.467 0-.596.011a.628.628 0 0 0-.12.018.25.25 0 0 0-.105.104.628.628 0 0 0-.018.121c-.01.13-.011.304-.011.596v8.3Zm.03-9.02v.002-.001Zm.1-.1h.002-.001Zm11.74 0h-.002.001Zm.1.1v.002-.001Zm0 9.74v-.002.001Zm-.1.1h-.002.001Zm-11.74 0h.002-.001Zm-.1-.102v.001-.001ZM6 10.25a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75Zm6 0a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75Zm-5 4.5a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, NSe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="scissors">
    <path fill-rule="evenodd" d="M4.75 2.5a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5ZM1 4.75a3.75 3.75 0 1 1 5.36 3.388l1.926 1.014L17.9 4.086a.75.75 0 1 1 .7 1.328L9.895 10l8.705 4.586a.75.75 0 1 1-.7 1.328l-9.614-5.066-1.925 1.014a3.75 3.75 0 1 1-3.19-.014L6.678 10 3.17 8.152A3.75 3.75 0 0 1 1 4.75ZM4.75 13a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, zSe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="search">
    <path fill-rule="evenodd" d="M8.5 2.5a6 6 0 1 0 0 12 6 6 0 0 0 0-12ZM1 8.5a7.5 7.5 0 1 1 13.307 4.746l4.473 4.474a.75.75 0 1 1-1.06 1.06l-4.473-4.473A7.5 7.5 0 0 1 1 8.5Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, jSe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="settings">
    <path fill-rule="evenodd" d="M7.25 3.25A2.25 2.25 0 0 1 9.5 1h1a2.25 2.25 0 0 1 2.25 2.25v.11l.078-.078a2.25 2.25 0 0 1 3.182 0l.707.708a2.25 2.25 0 0 1 0 3.182l-.078.078h.111A2.25 2.25 0 0 1 19 9.5v1a2.25 2.25 0 0 1-2.25 2.25h-.11l.078.078a2.25 2.25 0 0 1 0 3.182l-.708.707a2.25 2.25 0 0 1-3.182 0l-.078-.078v.111A2.25 2.25 0 0 1 10.5 19h-1a2.25 2.25 0 0 1-2.25-2.25v-.111l-.078.079a2.25 2.25 0 0 1-3.182 0l-.708-.708a2.25 2.25 0 0 1 0-3.182l.079-.078H3.25A2.25 2.25 0 0 1 1 10.5v-1a2.25 2.25 0 0 1 2.25-2.25h.11l-.078-.078a2.25 2.25 0 0 1 0-3.182l.708-.708a2.25 2.25 0 0 1 3.182 0l.078.079V3.25ZM9.5 2.5a.75.75 0 0 0-.75.75v.714c0 1.114-1.346 1.672-2.134.884l-.505-.505a.75.75 0 0 0-1.06 0l-.708.707a.75.75 0 0 0 0 1.06l.505.506c.788.788.23 2.134-.884 2.134H3.25a.75.75 0 0 0-.75.75v1c0 .414.336.75.75.75h.714c1.114 0 1.672 1.346.884 2.134l-.505.505a.75.75 0 0 0 0 1.06l.707.708a.75.75 0 0 0 1.06 0l.506-.505c.788-.788 2.134-.23 2.134.883v.715c0 .414.336.75.75.75h1a.75.75 0 0 0 .75-.75v-.715c0-1.113 1.346-1.67 2.134-.883l.505.505a.75.75 0 0 0 1.06 0l.708-.707a.75.75 0 0 0 0-1.06l-.505-.506c-.788-.788-.23-2.134.883-2.134h.715a.75.75 0 0 0 .75-.75v-1a.75.75 0 0 0-.75-.75h-.715c-1.113 0-1.67-1.346-.883-2.134l.505-.505a.75.75 0 0 0 0-1.06l-.707-.708a.75.75 0 0 0-1.06 0l-.506.505c-.788.788-2.134.23-2.134-.884V3.25a.75.75 0 0 0-.75-.75h-1ZM10 8a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-3.5 2a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, WSe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="share">
    <path fill-rule="evenodd" d="M16 2.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM13 4a3 3 0 1 1 .737 1.97l-6.803 3.4a3.012 3.012 0 0 1 0 1.258l6.803 3.401a3 3 0 1 1-.671 1.341l-6.803-3.4a3 3 0 1 1 0-3.94l6.803-3.402A3.012 3.012 0 0 1 13 4ZM4 8.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm12 6a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, USe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="shield">
    <path fill-rule="evenodd" d="M10.246 2.526a1.195 1.195 0 0 0-.492 0c-.157.033-.322.116-.93.461L3.947 5.755c-.158.09-.248.141-.313.184a.401.401 0 0 0-.06.044.285.285 0 0 0-.06.103c-.005.02-.014.054-.014.458v3.144c0 2.309 1.16 4.444 3.052 5.653l3.008 1.92c.16.103.253.161.324.2a.467.467 0 0 0 .067.034.223.223 0 0 0 .098 0 .512.512 0 0 0 .067-.033 6.84 6.84 0 0 0 .324-.2l3.008-1.921c1.892-1.208 3.052-3.344 3.052-5.653V6.544c0-.404-.009-.439-.015-.458a.286.286 0 0 0-.059-.103.486.486 0 0 0-.06-.044 6.707 6.707 0 0 0-.313-.184l-4.877-2.768c-.608-.345-.773-.428-.93-.461Zm-.199 14.97.002-.001h-.002Zm-.094 0-.002-.001h.002ZM9.445 1.057a2.696 2.696 0 0 1 1.11 0c.416.087.795.303 1.275.576l.086.049 4.877 2.768.06.034c.24.135.494.279.689.495.168.187.294.408.371.646.088.274.088.567.087.849v3.214c0 2.808-1.41 5.426-3.745 6.917l-3.008 1.92-.061.04c-.242.155-.502.322-.796.39-.257.06-.523.06-.78 0-.295-.068-.555-.235-.796-.39l-.061-.04-3.008-1.92C3.41 15.115 2 12.496 2 9.688V6.475c0-.282-.001-.575.087-.849.077-.238.203-.46.371-.646.195-.216.45-.36.69-.495l.059-.034 4.877-2.768.086-.049c.48-.273.86-.489 1.275-.576Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, KSe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="shirt">
    <path fill-rule="evenodd" d="M7.77 3.05c.208.08.37.25.442.463.101.305.223.517.426.668.204.154.59.319 1.362.319.772 0 1.158-.165 1.363-.319.202-.151.324-.363.426-.668a.75.75 0 0 1 1.08-.416l5.75 3.25c.355.2.485.65.291 1.009l-1.75 3.25a.75.75 0 0 1-1.076.268L15 10.151v7.099a.75.75 0 0 1-.75.75h-8.5a.75.75 0 0 1-.75-.75v-7.099l-1.084.723a.75.75 0 0 1-1.076-.268l-1.75-3.25a.75.75 0 0 1 .291-1.009l5.75-3.25a.75.75 0 0 1 .638-.047ZM2.758 7.291l1.01 1.878 1.565-1.043A.75.75 0 0 1 6.5 8.75v7.75h7V8.75a.75.75 0 0 1 1.166-.624l1.564 1.043 1.011-1.878-4.418-2.497c-.142.208-.324.41-.56.587C11.716 5.791 10.977 6 10 6s-1.717-.21-2.262-.619a2.473 2.473 0 0 1-.561-.587L2.759 7.291Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, qSe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="shopping-basket">
    <path fill-rule="evenodd" d="M8.618 3.096a.75.75 0 0 1 .286 1.022L7.282 7h5.436l-1.622-2.882a.75.75 0 0 1 1.308-.736L14.439 7h3.811a.75.75 0 0 1 .72.962l-2.5 8.5a.75.75 0 0 1-.72.538H4.25a.75.75 0 0 1-.72-.538l-2.5-8.5A.75.75 0 0 1 1.75 7h3.811l2.035-3.618a.75.75 0 0 1 1.022-.286ZM5.985 8.5H2.752l2.06 7h10.377l2.059-7H5.985ZM6.75 10a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0v-2.5a.75.75 0 0 1 .75-.75ZM10 10a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0v-2.5A.75.75 0 0 1 10 10Zm3.25 0a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0v-2.5a.75.75 0 0 1 .75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, YSe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="shopping-cart">
    <path fill-rule="evenodd" d="M9.92 1h.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 13.7 2.502c.172.337.24.693.27 1.073.011.132.018.275.022.428.211.004.403.01.575.024.36.029.696.09 1.02.246.498.24.912.624 1.188 1.103.18.311.265.643.32.999.053.34.084.757.12 1.254l.53 7.16c.043.57.078 1.045.074 1.433-.004.403-.049.784-.211 1.148a2.75 2.75 0 0 1-1.21 1.302c-.35.189-.727.262-1.129.296-.386.032-.861.032-1.433.032H6.164c-.572 0-1.047 0-1.433-.032-.402-.034-.779-.107-1.13-.296a2.75 2.75 0 0 1-1.209-1.302c-.162-.364-.207-.745-.211-1.148-.004-.388.031-.862.073-1.432l.53-7.16c.038-.498.068-.915.12-1.255.056-.356.142-.688.32-.999a2.75 2.75 0 0 1 1.19-1.103c.323-.156.66-.217 1.019-.246.172-.014.364-.02.575-.024a7.58 7.58 0 0 1 .022-.428c.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 7.502 1.3c.337-.172.693-.24 1.073-.27C8.94 1 9.385 1 9.92 1ZM6 5.504V7.25a.75.75 0 0 0 1.5 0V5.5h5v1.75a.75.75 0 0 0 1.5 0V5.504c.174.003.32.008.449.018.268.022.398.06.486.102.227.11.415.284.54.502.05.084.097.212.138.477.042.275.069.632.109 1.166l.525 7.1c.046.61.076 1.02.072 1.338-.003.309-.038.456-.081.552a1.25 1.25 0 0 1-.55.592c-.092.05-.236.096-.544.122-.316.026-.728.027-1.34.027H6.196c-.612 0-1.024 0-1.34-.027-.308-.026-.452-.072-.544-.122a1.25 1.25 0 0 1-.55-.592c-.043-.096-.078-.243-.081-.552-.003-.317.026-.728.072-1.338l.525-7.1c.04-.534.067-.891.11-1.166.04-.265.088-.393.136-.477a1.25 1.25 0 0 1 .54-.502c.089-.043.22-.08.487-.102A7.42 7.42 0 0 1 6 5.504ZM12.492 4H7.508a6.24 6.24 0 0 1 .017-.303c.023-.287.065-.424.111-.514a1.25 1.25 0 0 1 .547-.547c.09-.046.227-.088.514-.111.296-.024.68-.025 1.253-.025h.1c.572 0 .957 0 1.252.025.288.023.425.065.516.111.235.12.426.311.546.547.046.09.088.227.111.514.008.092.013.192.017.303Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, QSe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="sidebar-hide">
    <path fill-rule="evenodd" d="M1 5.75A2.75 2.75 0 0 1 3.75 3h12.5A2.75 2.75 0 0 1 19 5.75v8.5A2.75 2.75 0 0 1 16.25 17H3.75A2.75 2.75 0 0 1 1 14.25v-8.5Zm5.5 9.75h9.75c.69 0 1.25-.56 1.25-1.25v-8.5c0-.69-.56-1.25-1.25-1.25H6.5v11ZM5 4.5v11H3.75c-.69 0-1.25-.56-1.25-1.25v-8.5c0-.69.56-1.25 1.25-1.25H5Zm6.748 2.69a.75.75 0 0 1 .063 1.058l-.89 1.002h3.829a.75.75 0 0 1 0 1.5h-3.83l.89 1.002a.75.75 0 0 1-1.12.996l-2-2.25a.75.75 0 0 1 0-.996l2-2.25a.75.75 0 0 1 1.058-.063Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, JSe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="sidebar-show">
    <path fill-rule="evenodd" d="M1 5.75A2.75 2.75 0 0 1 3.75 3h12.5A2.75 2.75 0 0 1 19 5.75v8.5A2.75 2.75 0 0 1 16.25 17H3.75A2.75 2.75 0 0 1 1 14.25v-8.5Zm5.5 9.75h9.75c.69 0 1.25-.56 1.25-1.25v-8.5c0-.69-.56-1.25-1.25-1.25H6.5v11ZM5 4.5v11H3.75c-.69 0-1.25-.56-1.25-1.25v-8.5c0-.69.56-1.25 1.25-1.25H5Zm7.252 2.69a.75.75 0 0 1 1.059.062l2 2.25a.75.75 0 0 1 0 .996l-2 2.25a.75.75 0 0 1-1.122-.996l.89-1.002H9.25a.75.75 0 0 1 0-1.5h3.83l-.89-1.002a.75.75 0 0 1 .062-1.059Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, XSe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="slider">
    <path fill-rule="evenodd" d="M16.25 2.5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Zm-2.646.5a2.751 2.751 0 1 1 0 1.5H1.75a.75.75 0 0 1 0-1.5h11.854ZM6 8.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Zm-2.646.5a2.751 2.751 0 0 1 5.292 0h9.604a.75.75 0 0 1 0 1.5H8.646a2.751 2.751 0 0 1-5.292 0H1.75a.75.75 0 0 1 0-1.5h1.604ZM11.75 15a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Zm-2.646.5a2.751 2.751 0 0 1 5.293 0h3.853a.75.75 0 0 1 0 1.5h-3.854a2.751 2.751 0 0 1-5.292 0H1.75a.75.75 0 0 1 0-1.5h7.354Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, exe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="speedmeter">
    <path fill-rule="evenodd" d="M10 2.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15ZM1 10a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm9-4.5A4.5 4.5 0 0 0 5.5 10 .75.75 0 0 1 4 10a6 6 0 0 1 6-6 .75.75 0 0 1 0 1.5Zm4.78-.28a.75.75 0 0 1 0 1.06l-2.938 2.94a2 2 0 1 1-1.06-1.06l2.938-2.94a.75.75 0 0 1 1.06 0ZM10 9.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, txe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="star-filled">
    <path d="M8.437 2.005c.414-.877 1.46-1.27 2.343-.815.346.178.619.467.783.815l1.785 3.78a.242.242 0 0 0 .177.143l3.993.606c.973.148 1.595 1.073 1.465 2.013-.053.38-.225.737-.496 1.013l-2.889 2.942a.31.31 0 0 0-.079.264l.721 4.157c.16.979-.525 1.884-1.452 2.05a1.7 1.7 0 0 1-1.12-.184l-3.57-1.962a.2.2 0 0 0-.196 0l-3.57 1.962c-.872.478-1.928.113-2.364-.753a1.822 1.822 0 0 1-.17-1.113l.682-4.155a.31.31 0 0 0-.078-.266L1.512 9.56a1.814 1.814 0 0 1-.03-2.495 1.722 1.722 0 0 1 1-.531l3.992-.606a.242.242 0 0 0 .178-.143l1.785-3.78Z" class="Icon"/>
  </g>
</svg>
`, oxe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="star-half-filled">
    <path fill-rule="evenodd" d="M8.437 2.005c.414-.877 1.46-1.27 2.343-.815.346.178.619.467.783.815l1.785 3.78a.242.242 0 0 0 .177.143l3.993.606c.973.148 1.595 1.073 1.465 2.013-.053.38-.225.737-.496 1.013l-2.889 2.942a.31.31 0 0 0-.079.264l.721 4.157c.16.98-.525 1.884-1.452 2.05a1.7 1.7 0 0 1-1.12-.184l-3.57-1.962a.199.199 0 0 0-.196 0l-3.57 1.962c-.872.478-1.928.113-2.364-.753a1.822 1.822 0 0 1-.17-1.113l.682-4.155a.31.31 0 0 0-.078-.266L1.512 9.56a1.814 1.814 0 0 1-.03-2.495 1.722 1.722 0 0 1 1-.53l3.992-.607a.242.242 0 0 0 .178-.143l1.785-3.78Zm1.656.518c-.094-.048-.231-.023-.3.122l-.003.008C9 8.003 9 13.001 14.39 17.474a.2.2 0 0 0 .133.023.296.296 0 0 0 .183-.122.28.28 0 0 0 .054-.207l-.72-4.157a1.81 1.81 0 0 1 .488-1.56l2.889-2.942c.04-.041.07-.1.08-.168.026-.186-.1-.308-.204-.324L13.3 7.411a1.74 1.74 0 0 1-1.308-.985l-1.786-3.78a.26.26 0 0 0-.113-.123Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, nxe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="star">
    <path fill-rule="evenodd" d="M10.093 2.523c-.094-.048-.231-.023-.3.122l-1.785 3.78a1.74 1.74 0 0 1-1.308.986l-3.993.606a.223.223 0 0 0-.128.07.315.315 0 0 0 .004.422l2.889 2.942c.404.412.581.995.489 1.56l-.682 4.155a.322.322 0 0 0 .029.195c.07.142.207.165.301.113l3.57-1.962a1.699 1.699 0 0 1 1.641 0l3.57 1.962a.2.2 0 0 0 .133.023.296.296 0 0 0 .183-.122.28.28 0 0 0 .054-.207l-.72-4.157a1.81 1.81 0 0 1 .488-1.56l2.889-2.942c.04-.041.07-.1.08-.168.026-.186-.1-.308-.204-.324L13.3 7.411a1.74 1.74 0 0 1-1.308-.985l-1.786-3.78a.26.26 0 0 0-.113-.123Zm-1.656-.518c.414-.877 1.46-1.27 2.343-.815.346.178.619.467.783.815l1.785 3.78a.242.242 0 0 0 .177.143l3.993.606c.973.148 1.595 1.073 1.465 2.013-.053.38-.225.737-.496 1.013l-2.889 2.942a.31.31 0 0 0-.079.264l.721 4.157c.16.98-.525 1.884-1.452 2.05a1.7 1.7 0 0 1-1.12-.184l-3.57-1.962a.199.199 0 0 0-.196 0l-3.57 1.962c-.872.478-1.928.113-2.364-.753a1.822 1.822 0 0 1-.17-1.113l.682-4.155a.31.31 0 0 0-.078-.266L1.512 9.56a1.814 1.814 0 0 1-.03-2.495 1.722 1.722 0 0 1 1-.53l3.992-.607a.242.242 0 0 0 .178-.143l1.785-3.78Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, sxe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="stopwatch">
    <path fill-rule="evenodd" d="M7 1.75A.75.75 0 0 1 7.75 1h4.5a.75.75 0 0 1 0 1.5h-1.5v.535a8 8 0 1 1-1.5 0V2.5h-1.5A.75.75 0 0 1 7 1.75Zm-2.22.47a.75.75 0 0 1 0 1.06l-2.5 2.5a.75.75 0 1 1-1.06-1.06l2.5-2.5a.75.75 0 0 1 1.06 0Zm10.44 0a.75.75 0 0 1 1.06 0l2.5 2.5a.75.75 0 0 1-1.06 1.06l-2.5-2.5a.75.75 0 0 1 0-1.06ZM10 4.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13ZM9.75 6a.75.75 0 0 1 .75.75v3.75h1.75a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75v-4.5A.75.75 0 0 1 9.75 6Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, ixe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="suitcase">
    <path fill-rule="evenodd" d="M8.324 2h3.352c.258 0 .494 0 .692.016.213.018.446.057.676.175.33.168.598.435.765.765.118.23.158.463.175.676.016.198.016.434.016.692V5h2.676c.258 0 .494 0 .692.016.213.018.446.057.677.175.329.168.596.435.764.765.118.23.157.463.175.676.016.198.016.434.016.692v4.352c0 .258 0 .494-.016.692a1.775 1.775 0 0 1-.175.676 1.75 1.75 0 0 1-.809.787v1.845c0 .258 0 .494-.016.692a1.775 1.775 0 0 1-.175.677 1.75 1.75 0 0 1-.765.764 1.77 1.77 0 0 1-.676.175c-.198.016-.434.016-.692.016H4.324c-.258 0-.494 0-.692-.016a1.775 1.775 0 0 1-.676-.175 1.75 1.75 0 0 1-.765-.765 1.774 1.774 0 0 1-.175-.676C2 16.17 2 15.934 2 15.676v-1.845a1.75 1.75 0 0 1-.81-.787 1.774 1.774 0 0 1-.174-.676C1 12.17 1 11.934 1 11.676V7.324c0-.258 0-.494.016-.692a1.77 1.77 0 0 1 .175-.676 1.75 1.75 0 0 1 .765-.765 1.77 1.77 0 0 1 .676-.175C2.83 5 3.066 5 3.324 5H6v-.676c0-.258 0-.494.016-.692a1.77 1.77 0 0 1 .175-.676 1.75 1.75 0 0 1 .765-.765 1.77 1.77 0 0 1 .676-.175C7.83 2 8.066 2 8.324 2ZM3.35 6.5c-.292 0-.467 0-.596.011a.626.626 0 0 0-.12.018.25.25 0 0 0-.105.104.628.628 0 0 0-.018.121c-.01.13-.011.304-.011.596v4.3c0 .292 0 .467.011.596a.626.626 0 0 0 .018.12.25.25 0 0 0 .104.105.638.638 0 0 0 .156.02l.015.001c.124.008.29.008.546.008H7v-.75a.75.75 0 0 1 1.5 0v.75h3v-.75a.75.75 0 0 1 1.5 0v.75h3.65c.257 0 .422 0 .546-.008h.015l.035-.003a.636.636 0 0 0 .12-.018.25.25 0 0 0 .105-.104.636.636 0 0 0 .018-.121c.01-.13.011-.304.011-.596v-4.3c0-.292 0-.467-.011-.596a.638.638 0 0 0-.018-.12.25.25 0 0 0-.105-.105.625.625 0 0 0-.12-.018 8.336 8.336 0 0 0-.596-.011H3.35ZM12.5 5h-5v-.65c0-.292 0-.467.011-.596a.628.628 0 0 1 .018-.12.25.25 0 0 1 .104-.105.626.626 0 0 1 .121-.018c.13-.01.304-.011.596-.011h3.3c.292 0 .467 0 .596.011a.625.625 0 0 1 .12.018.25.25 0 0 1 .105.104.638.638 0 0 1 .018.121c.01.13.011.304.011.596V5Zm-.03-1.37v.002-.001Zm-.1-.1h-.002.001Zm-4.74 0h.002-.001Zm-.1.102v-.001.001Zm9.84 2.898h-.002.001Zm.1.1v.002-.001Zm0 5.74v-.002.001Zm-.1.1h-.002.001ZM16.5 14H13v.25a.75.75 0 0 1-1.5 0V14h-3v.25a.75.75 0 0 1-1.5 0V14H3.5v1.65c0 .292 0 .467.011.596a.626.626 0 0 0 .018.12.25.25 0 0 0 .104.105.638.638 0 0 0 .121.018c.13.01.304.011.596.011h11.3c.292 0 .467 0 .596-.011a.636.636 0 0 0 .12-.018.25.25 0 0 0 .105-.105.636.636 0 0 0 .018-.12c.01-.13.011-.304.011-.596V14Zm-.03 2.37v-.002.001Zm-.1.1h-.002.001Zm-12.74 0h.002-.001Zm-.1-.102v.001-.001Zm-.9-3.898h.002-.001Zm-.1-.102v.001-.001Zm0-5.736a.01.01 0 0 1 0-.001v.001Zm.102-.103h-.001.001Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, rxe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="sun">
    <path fill-rule="evenodd" d="M10 2a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0v-1.5A.75.75 0 0 1 10 2ZM4.22 4.22a.75.75 0 0 1 1.06 0l1 1a.75.75 0 0 1-1.06 1.06l-1-1a.75.75 0 0 1 0-1.06Zm11.56 0a.75.75 0 0 1 0 1.06l-1 1a.75.75 0 1 1-1.06-1.06l1-1a.75.75 0 0 1 1.06 0ZM6 10c0-2.214 1.786-4 4-4s4 1.786 4 4-1.786 4-4 4-4-1.786-4-4Zm4-2.5A2.494 2.494 0 0 0 7.5 10c0 1.386 1.114 2.5 2.5 2.5s2.5-1.114 2.5-2.5-1.114-2.5-2.5-2.5ZM2 10a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5A.75.75 0 0 1 2 10Zm13 0a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5A.75.75 0 0 1 15 10Zm-8.72 3.72a.75.75 0 0 1 0 1.06l-1 1a.75.75 0 0 1-1.06-1.06l1-1a.75.75 0 0 1 1.06 0Zm7.44 0a.75.75 0 0 1 1.06 0l1 1a.75.75 0 1 1-1.06 1.06l-1-1a.75.75 0 0 1 0-1.06ZM10 15a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0v-1.5A.75.75 0 0 1 10 15Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, lxe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="tablet">
    <path fill-rule="evenodd" d="M1 5.75A2.75 2.75 0 0 1 3.75 3h12.5A2.75 2.75 0 0 1 19 5.75v8.5A2.75 2.75 0 0 1 16.25 17H3.75A2.75 2.75 0 0 1 1 14.25v-8.5ZM3.75 4.5c-.69 0-1.25.56-1.25 1.25v8.5c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25v-8.5c0-.69-.56-1.25-1.25-1.25H3.75ZM9 13.25a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, axe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="tag">
    <path fill-rule="evenodd" d="M1 3.856A2.856 2.856 0 0 1 3.856 1H9.3c.757 0 1.483.3 2.019.836l6.844 6.844a2.856 2.856 0 0 1 0 4.039l-5.445 5.445a2.856 2.856 0 0 1-4.039 0L1.836 11.32A2.856 2.856 0 0 1 1 9.3V3.857ZM3.856 2.5c-.749 0-1.356.607-1.356 1.356V9.3c0 .36.143.704.397.958l6.844 6.844c.53.53 1.388.53 1.917 0l5.445-5.445c.53-.53.53-1.388 0-1.917l-6.844-6.844a1.356 1.356 0 0 0-.958-.397H3.856ZM6.5 6a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1Zm-2 .5a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, cxe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="target-off">
    <path fill-rule="evenodd" d="M10 1a.75.75 0 0 1 .75.75v1.29a7.003 7.003 0 0 1 6.21 6.21h1.29a.75.75 0 0 1 0 1.5h-1.29a7.003 7.003 0 0 1-6.21 6.21v1.29a.75.75 0 0 1-1.5 0v-1.29a7.003 7.003 0 0 1-6.21-6.21H1.75a.75.75 0 0 1 0-1.5h1.29a7.003 7.003 0 0 1 6.21-6.21V1.75A.75.75 0 0 1 10 1Zm0 3.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, dxe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="target">
    <path fill-rule="evenodd" d="M10 1a.75.75 0 0 1 .75.75v1.29a7.003 7.003 0 0 1 6.21 6.21h1.29a.75.75 0 0 1 0 1.5h-1.29a7.003 7.003 0 0 1-6.21 6.21v1.29a.75.75 0 0 1-1.5 0v-1.29a7.003 7.003 0 0 1-6.21-6.21H1.75a.75.75 0 0 1 0-1.5h1.29a7.003 7.003 0 0 1 6.21-6.21V1.75A.75.75 0 0 1 10 1Zm0 3.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11Zm0 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM7 10a3 3 0 1 1 6 0 3 3 0 0 1-6 0Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, uxe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="terminal-2">
    <path fill-rule="evenodd" d="M4.92 1h10.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 18.7 2.502c.172.337.24.693.27 1.073.03.365.03.81.03 1.345v10.16c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073a2.751 2.751 0 0 1-1.2 1.202c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03H4.92c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 1.3 17.5c-.172-.338-.24-.694-.27-1.074C1 16.06 1 15.615 1 15.08V4.92c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 2.502 1.3c.337-.172.693-.24 1.073-.27C3.94 1 4.385 1 4.92 1ZM3.697 2.525c-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.547c-.046.09-.088.227-.111.514-.024.296-.025.68-.025 1.253v10.1c0 .572 0 .957.025 1.252.023.288.065.425.111.515.12.236.311.427.547.547.09.046.227.088.514.111.296.024.68.025 1.253.025h10.1c.572 0 .957 0 1.252-.025.288-.023.425-.065.515-.111a1.25 1.25 0 0 0 .547-.547c.046-.09.088-.227.111-.515.024-.295.025-.68.025-1.252V4.95c0-.572 0-.957-.025-1.253-.023-.287-.065-.424-.111-.514a1.25 1.25 0 0 0-.547-.547c-.09-.046-.227-.088-.515-.111-.295-.024-.68-.025-1.252-.025H4.95c-.572 0-.957 0-1.253.025ZM5.2 7.24a.75.75 0 0 1 1.06-.04l3.5 3.25a.75.75 0 0 1 0 1.1l-3.5 3.25a.75.75 0 0 1-1.02-1.1L8.148 11 5.24 8.3a.75.75 0 0 1-.04-1.06ZM10 15a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5A.75.75 0 0 1 10 15Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, hxe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="terminal">
    <path fill-rule="evenodd" d="M4.92 1h10.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 18.7 2.502c.172.337.24.693.27 1.073.03.365.03.81.03 1.345v10.16c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073a2.751 2.751 0 0 1-1.2 1.202c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03H4.92c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 1.3 17.5c-.172-.338-.24-.694-.27-1.074C1 16.06 1 15.615 1 15.08V4.92c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 2.502 1.3c.337-.172.693-.24 1.073-.27C3.94 1 4.385 1 4.92 1ZM3.697 2.525c-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.547c-.046.09-.088.227-.111.514-.024.296-.025.68-.025 1.253v10.1c0 .572 0 .957.025 1.252.023.288.065.425.111.515.12.236.311.427.547.547.09.046.227.088.514.111.296.024.68.025 1.253.025h10.1c.572 0 .957 0 1.252-.025.288-.023.425-.065.515-.111a1.25 1.25 0 0 0 .547-.547c.046-.09.088-.227.111-.515.024-.295.025-.68.025-1.252V4.95c0-.572 0-.957-.025-1.253-.023-.287-.065-.424-.111-.514a1.25 1.25 0 0 0-.547-.547c-.09-.046-.227-.088-.515-.111-.295-.024-.68-.025-1.252-.025H4.95c-.572 0-.957 0-1.253.025ZM5.2 7.24a.75.75 0 0 1 1.06-.04l3.5 3.25a.75.75 0 0 1 0 1.1l-3.5 3.25a.75.75 0 0 1-1.02-1.1L8.148 11 5.24 8.3a.75.75 0 0 1-.04-1.06Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, gxe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="tetrisly">
    <path fill-rule="evenodd" d="M2.137 1h2.226c.058 0 .139 0 .212.006.088.007.229.027.379.103a1 1 0 0 1 .437.437c.076.15.096.29.103.379.006.073.006.154.006.212v2.226c0 .058 0 .139-.006.212a1.003 1.003 0 0 1-.103.379 1 1 0 0 1-.437.437c-.15.076-.29.096-.379.103-.073.006-.154.006-.212.006H2.137c-.058 0-.139 0-.212-.006a1.003 1.003 0 0 1-.379-.103 1 1 0 0 1-.437-.437 1.003 1.003 0 0 1-.103-.379A2.673 2.673 0 0 1 1 4.363V2.137c0-.058 0-.139.006-.212.007-.088.027-.229.103-.379a1 1 0 0 1 .437-.437c.15-.076.29-.096.379-.103C1.998 1 2.079 1 2.137 1ZM2.5 2.5V4H4V2.5H2.5ZM8.887 1h8.976c.058 0 .139 0 .212.006.088.007.229.027.379.103a1 1 0 0 1 .437.437c.077.15.096.29.103.379.006.073.006.154.006.212v2.226c0 .058 0 .139-.006.212a1.003 1.003 0 0 1-.103.379 1 1 0 0 1-.437.437.986.986 0 0 1-.379.103c-.073.006-.154.006-.212.006H12.25v5.613c0 .058 0 .139-.006.212a1.003 1.003 0 0 1-.103.379 1 1 0 0 1-.437.437c-.15.076-.29.096-.379.103a2.648 2.648 0 0 1-.212.006H8.887c-.058 0-.139 0-.212-.006a1.003 1.003 0 0 1-.379-.103 1 1 0 0 1-.437-.437 1.003 1.003 0 0 1-.103-.379c-.006-.073-.006-.154-.006-.212V2.137c0-.058 0-.139.006-.212.007-.088.027-.229.103-.379a1 1 0 0 1 .437-.437c.15-.076.29-.096.379-.103C8.748 1 8.829 1 8.887 1Zm.363 1.5v8.25h1.5V5.137c0-.058 0-.139.006-.212.007-.088.027-.229.103-.379a1 1 0 0 1 .437-.437c.15-.076.29-.096.379-.103.073-.006.154-.006.212-.006H17.5V2.5H9.25Zm-.363 12h2.226c.058 0 .139 0 .212.006.088.007.229.027.379.103a1 1 0 0 1 .437.437c.076.15.096.29.103.379.006.073.006.154.006.212v2.226c0 .058 0 .139-.006.212a1.003 1.003 0 0 1-.103.379 1 1 0 0 1-.437.437.986.986 0 0 1-.379.103 2.648 2.648 0 0 1-.212.006H8.887c-.058 0-.139 0-.212-.006a1.003 1.003 0 0 1-.379-.103 1 1 0 0 1-.437-.437 1.003 1.003 0 0 1-.103-.379c-.006-.073-.006-.154-.006-.212v-2.226c0-.058 0-.139.006-.212.007-.088.027-.229.103-.379a1 1 0 0 1 .437-.437c.15-.076.29-.096.379-.103.073-.006.154-.006.212-.006ZM9.25 16v1.5h1.5V16h-1.5Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, pxe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="text">
    <path fill-rule="evenodd" d="M2 2.75C2 1.784 2.784 1 3.75 1h12.5c.966 0 1.75.784 1.75 1.75v2a.75.75 0 0 1-1.5 0v-2a.25.25 0 0 0-.25-.25h-5.5v15h2.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1 0-1.5h2.5v-15h-5.5a.25.25 0 0 0-.25.25v2a.75.75 0 0 1-1.5 0v-2Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, fxe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="thumb-down">
    <path fill-rule="evenodd" d="M6.358 1h8.722c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 18.7 2.502c.172.337.24.693.27 1.073.03.365.03.81.03 1.345v3.16c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073a2.751 2.751 0 0 1-1.2 1.202c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03h-.873c-.227 0-.358 0-.457.007a.545.545 0 0 0-.091.012.25.25 0 0 0-.1.075.528.528 0 0 0-.037.086c-.034.092-.07.218-.132.437l-1.462 5.115c-.214.75-.9 1.268-1.681 1.268A2.747 2.747 0 0 1 7.5 16.253V13.85c0-.292 0-.467-.011-.596a.627.627 0 0 0-.018-.12.25.25 0 0 0-.104-.105.638.638 0 0 0-.121-.018A8.375 8.375 0 0 0 6.65 13H5.285c-.69 0-1.257 0-1.71-.04-.466-.042-.903-.132-1.29-.372A2.765 2.765 0 0 1 1.078 11c-.125-.444-.086-.893.005-1.35.083-.417.227-.922.4-1.527l.046-.159 1.17-4.1.034-.12c.202-.71.36-1.266.697-1.694.291-.37.67-.664 1.116-.847C5.05 1 5.623 1 6.358 1Zm1.011 12.03h-.001.001Zm.101.1v.002-.001Zm6.09-1.037-.001.002v-.002Zm.097-.073h.002-.002ZM6.49 2.5c-.932 0-1.182.014-1.376.093a1.23 1.23 0 0 0-.504.385c-.13.165-.213.404-.469 1.299l-1.17 4.1-.037.13c-.183.638-.31 1.084-.38 1.437-.074.371-.062.543-.032.647.082.292.281.553.553.722.097.06.26.12.633.152.378.034.878.035 1.612.035h1.356c.258 0 .494 0 .692.016.213.018.446.057.676.175.33.167.597.435.765.764.118.23.157.464.175.677.016.198.016.434.016.692v2.43c0 .688.558 1.246 1.247 1.246a.25.25 0 0 0 .239-.18l1.461-5.116.024-.083c.093-.328.191-.678.407-.952.188-.239.434-.424.715-.54.13-.053.268-.084.407-.103V2.5H6.49Zm8.51 0v8h.05c.572 0 .957 0 1.252-.025.288-.023.425-.065.515-.111a1.25 1.25 0 0 0 .547-.546c.046-.091.088-.228.111-.515.024-.296.025-.68.025-1.253v-3.1c0-.572 0-.957-.025-1.253-.023-.287-.065-.424-.111-.514a1.25 1.25 0 0 0-.547-.547c-.09-.046-.227-.088-.515-.111-.295-.024-.68-.025-1.252-.025H15Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, vxe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="thumb-up">
    <path fill-rule="evenodd" d="M8.07 2.268A1.75 1.75 0 0 1 9.752 1a2.747 2.747 0 0 1 2.746 2.747V6.15c0 .292.001.467.012.596a.638.638 0 0 0 .017.12.25.25 0 0 0 .105.105.628.628 0 0 0 .12.018c.13.01.304.011.596.011h1.366c.69 0 1.257 0 1.71.04.466.042.902.132 1.29.372.576.357 1.017.92 1.206 1.587.126.444.087.893-.004 1.35-.083.417-.228.922-.4 1.527-.016.052-.03.105-.046.16l-1.17 4.099-.035.12c-.202.71-.36 1.265-.697 1.694-.29.37-.67.664-1.116.847-.503.205-1.077.205-1.811.204H4.918c-.534 0-.98 0-1.344-.03-.38-.03-.737-.098-1.074-.27a2.75 2.75 0 0 1-1.202-1.2c-.172-.338-.239-.694-.27-1.074-.03-.365-.03-.81-.03-1.345v-3.16c0-.535 0-.98.03-1.345.031-.38.098-.736.27-1.073A2.75 2.75 0 0 1 2.5 8.3c.337-.172.694-.24 1.074-.27C3.938 8 4.384 8 4.918 8h.874c.226 0 .358 0 .456-.007a.541.541 0 0 0 .092-.012.25.25 0 0 0 .1-.075.542.542 0 0 0 .036-.086c.034-.092.07-.218.133-.436L8.07 2.268Zm-1.63 5.64v-.002.001Zm-.097.072H6.34h.002Zm6.287-1.01h.002-.002Zm-.1-.1-.001-.002v.001ZM9.751 2.5a.248.248 0 0 0-.24.18l-1.46 5.116-.025.083c-.092.328-.19.678-.407.952a1.75 1.75 0 0 1-.714.54c-.13.052-.268.084-.407.103V17.5h7.01c.932 0 1.182-.014 1.376-.093.195-.08.366-.21.504-.385.13-.165.213-.404.468-1.299l1.17-4.1.038-.13c.182-.638.31-1.084.38-1.437.073-.371.062-.543.032-.647a1.266 1.266 0 0 0-.553-.722c-.097-.06-.26-.12-.634-.152-.378-.034-.877-.035-1.611-.035h-1.357c-.257 0-.494 0-.691-.016a1.774 1.774 0 0 1-.677-.175 1.75 1.75 0 0 1-.765-.765 1.775 1.775 0 0 1-.174-.676c-.017-.198-.017-.434-.017-.692v-2.43c0-.688-.558-1.246-1.246-1.246Zm-4.753 15v-8h-.05c-.573 0-.957 0-1.253.025-.287.023-.424.065-.515.111a1.25 1.25 0 0 0-.546.546c-.046.091-.088.228-.112.515-.024.296-.024.68-.024 1.253v3.1c0 .572 0 .957.024 1.252.024.288.066.425.112.515.12.236.31.427.546.547.09.046.228.088.515.111.296.024.68.025 1.253.025h.05Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, mxe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="ticket">
    <path fill-rule="evenodd" d="M4.92 3h10.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 18.7 4.502c.172.337.24.693.27 1.073.03.365.03.81.03 1.345v.83a.75.75 0 0 1-.75.75 1.5 1.5 0 0 0 0 3 .75.75 0 0 1 .75.75v.83c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073a2.751 2.751 0 0 1-1.2 1.202c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03H4.92c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 1.3 15.5c-.172-.338-.24-.694-.27-1.074C1 14.06 1 13.615 1 13.08v-.83a.75.75 0 0 1 .75-.75 1.5 1.5 0 0 0 0-3A.75.75 0 0 1 1 7.75v-.83c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 2.502 3.3c.337-.172.693-.24 1.073-.27C3.94 3 4.385 3 4.92 3ZM13 15.5h2.05c.572 0 .957 0 1.252-.025.288-.023.425-.065.515-.111a1.25 1.25 0 0 0 .547-.546c.046-.091.088-.228.111-.515.024-.296.025-.68.025-1.253v-.145a3.001 3.001 0 0 1 0-5.81V6.95c0-.572 0-.957-.025-1.253-.023-.287-.065-.424-.111-.514a1.25 1.25 0 0 0-.547-.547c-.09-.046-.227-.088-.515-.111-.295-.024-.68-.025-1.252-.025H13v11Zm-1.5-11v11H4.95c-.572 0-.957 0-1.253-.025-.287-.023-.424-.065-.514-.111a1.25 1.25 0 0 1-.547-.546c-.046-.091-.088-.228-.111-.515-.024-.296-.025-.68-.025-1.253v-.145a3.001 3.001 0 0 0 0-5.81V6.95c0-.572 0-.957.025-1.253.023-.287.065-.424.111-.514a1.25 1.25 0 0 1 .547-.547c.09-.046.227-.088.514-.111.296-.024.68-.025 1.253-.025h6.55Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Cxe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="time-clock">
    <path fill-rule="evenodd" d="M10 2.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15ZM1 10a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm8.75-5a.75.75 0 0 1 .75.75V9.5h1.75a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75v-4.5A.75.75 0 0 1 9.75 5Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, wxe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="toggle-off">
    <path fill-rule="evenodd" d="M1 10a5 5 0 0 1 5-5h8a5 5 0 0 1 0 10H6a5 5 0 0 1-5-5Zm5-3.5a3.5 3.5 0 1 0 0 7h8a3.5 3.5 0 1 0 0-7H6Zm-.125 2.75a.625.625 0 1 0 0 1.25.625.625 0 0 0 0-1.25Zm-2.125.625a2.125 2.125 0 1 1 4.25 0 2.125 2.125 0 0 1-4.25 0Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, bxe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="toggle-on">
    <path fill-rule="evenodd" d="M6 5a5 5 0 0 0 0 10h8a5 5 0 0 0 0-10H6Zm8.125 3a2.125 2.125 0 1 0 0 4.25 2.125 2.125 0 0 0 0-4.25Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, yxe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="transaction-horizontal">
    <path fill-rule="evenodd" d="M13.752 2.19a.75.75 0 0 1 1.059.062l4 4.5A.75.75 0 0 1 18.25 8H1.75a.75.75 0 1 1 0-1.5h14.83l-2.89-3.252a.75.75 0 0 1 .062-1.059ZM1.066 12.442A.75.75 0 0 1 1.75 12h16.5a.75.75 0 0 1 0 1.5H3.42l2.89 3.252a.75.75 0 0 1-1.12.996l-4-4.5a.75.75 0 0 1-.124-.805Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, _xe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="transaction-vertical">
    <path fill-rule="evenodd" d="M7.557 1.066A.75.75 0 0 1 8 1.75v16.5a.75.75 0 0 1-1.5 0V3.42L3.248 6.31a.75.75 0 0 1-.996-1.12l4.5-4a.75.75 0 0 1 .805-.124ZM12.75 1a.75.75 0 0 1 .75.75v14.83l3.252-2.89a.75.75 0 0 1 .996 1.12l-4.5 4A.75.75 0 0 1 12 18.25V1.75a.75.75 0 0 1 .75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Sxe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="tree">
    <path fill-rule="evenodd" d="M8.984 1.42a1.437 1.437 0 0 1 2.032 0l2.063 2.064c.561.561.561 1.47 0 2.032l-2.063 2.063a1.44 1.44 0 0 1-.266.21V9.25h2.75A2.75 2.75 0 0 1 16.25 12v.21c.095.059.184.129.266.21l2.063 2.064c.561.561.561 1.47 0 2.032l-2.063 2.063a1.436 1.436 0 0 1-2.032 0l-2.063-2.063a1.436 1.436 0 0 1 0-2.032l2.063-2.063a1.44 1.44 0 0 1 .266-.21V12a1.25 1.25 0 0 0-1.25-1.251h-7c-.69 0-1.25.56-1.25 1.25v.21c.095.059.184.129.266.21l2.063 2.064c.561.561.561 1.47 0 2.032l-2.063 2.063a1.436 1.436 0 0 1-2.032 0l-2.063-2.063a1.437 1.437 0 0 1 0-2.032l2.063-2.063c.082-.082.171-.152.266-.21V12A2.75 2.75 0 0 1 6.5 9.25h2.75V7.79a1.44 1.44 0 0 1-.266-.21L6.921 5.515a1.437 1.437 0 0 1 0-2.032L8.984 1.42ZM10 6.475 11.974 4.5 10 2.526 8.026 4.5 10 6.474Zm-5.5 7.052L2.526 15.5 4.5 17.474 6.474 15.5 4.5 13.526Zm-.045 3.993Zm.09 0ZM15.5 13.525 13.526 15.5l1.974 1.974 1.974-1.974-1.974-1.974Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, xxe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="trend-down">
    <path fill-rule="evenodd" d="M1.27 4.174a.75.75 0 0 1 1.056.096L6.87 9.722 10.3 7.15a.75.75 0 0 1 .98.07l6.22 6.22V9.75a.75.75 0 0 1 1.5 0v5.5a.75.75 0 0 1-.75.75h-5.5a.75.75 0 0 1 0-1.5h3.69l-5.76-5.76-3.48 2.61a.75.75 0 0 1-1.026-.12l-5-6a.75.75 0 0 1 .096-1.056Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Mxe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="trend-up">
    <path fill-rule="evenodd" d="M12 4.75a.75.75 0 0 1 .75-.75h5.5a.75.75 0 0 1 .75.75v5.5a.75.75 0 0 1-1.5 0V6.56l-6.22 6.22a.75.75 0 0 1-.98.07l-3.43-2.572-4.544 5.452a.75.75 0 0 1-1.152-.96l5-6A.75.75 0 0 1 7.2 8.65l3.48 2.61 5.76-5.76h-3.69a.75.75 0 0 1-.75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Axe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="turn-off">
    <path fill-rule="evenodd" d="M10 1a.75.75 0 0 1 .75.75v6.5a.75.75 0 0 1-1.5 0v-6.5A.75.75 0 0 1 10 1ZM4.672 3.656a.75.75 0 0 1 .004 1.061 7.5 7.5 0 1 0 10.647 0 .75.75 0 0 1 1.065-1.056 9 9 0 1 1-12.777 0 .75.75 0 0 1 1.061-.005Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Lxe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="tv">
    <path fill-rule="evenodd" d="M4.92 1h10.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 18.7 2.502c.172.337.24.693.27 1.073.03.365.03.81.03 1.345v6.16c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073a2.751 2.751 0 0 1-1.2 1.202c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03H4.92c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 1.3 13.5c-.172-.338-.24-.694-.27-1.074C1 12.06 1 11.615 1 11.08V4.92c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 2.502 1.3c.337-.172.693-.24 1.073-.27C3.94 1 4.385 1 4.92 1ZM3.697 2.525c-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.547c-.046.09-.088.227-.111.514-.024.296-.025.68-.025 1.253v6.1c0 .572 0 .957.025 1.252.023.288.065.425.111.516.12.235.311.426.547.546.09.046.227.088.514.111.296.024.68.025 1.253.025h10.1c.572 0 .957 0 1.252-.025.288-.023.425-.065.515-.111a1.25 1.25 0 0 0 .547-.546c.046-.091.088-.228.111-.515.024-.296.025-.68.025-1.253v-6.1c0-.572 0-.957-.025-1.253-.023-.287-.065-.424-.111-.514a1.25 1.25 0 0 0-.547-.547c-.09-.046-.227-.088-.515-.111-.295-.024-.68-.025-1.252-.025H4.95c-.572 0-.957 0-1.253.025ZM10 17.5c-.937 0-1.744.415-2.08 1.085a.75.75 0 1 1-1.34-.67C7.243 16.585 8.686 16 10 16c1.313 0 2.756.585 3.42 1.915a.75.75 0 1 1-1.34.67c-.336-.67-1.143-1.085-2.08-1.085Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Exe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="undo">
    <path fill-rule="evenodd" d="M1.75 7a.75.75 0 0 1 .75.75v2.424C4.492 8.29 7.272 7.375 10 7.375c3.44 0 6.963 1.455 8.883 4.472a.75.75 0 1 1-1.266.806C16.037 10.17 13.061 8.875 10 8.875c-2.545 0-5.032.896-6.707 2.625H6.25a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75v-4.5A.75.75 0 0 1 1.75 7Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Pxe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="unfold-less">
    <path fill-rule="evenodd" d="M6.24 3.2a.75.75 0 0 1 1.06.04L10 6.148l2.7-2.908a.75.75 0 1 1 1.1 1.02l-3.25 3.5a.75.75 0 0 1-1.1 0L6.2 4.26a.75.75 0 0 1 .04-1.06ZM10 12a.75.75 0 0 1 .55.24l3.25 3.5a.75.75 0 1 1-1.1 1.02L10 13.852 7.3 16.76a.75.75 0 1 1-1.1-1.02l3.25-3.5A.75.75 0 0 1 10 12Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Rxe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="unfold-more">
    <path fill-rule="evenodd" d="M10 2a.75.75 0 0 1 .55.24l3.25 3.5a.75.75 0 1 1-1.1 1.02L10 3.852 7.3 6.76a.75.75 0 1 1-1.1-1.02l3.25-3.5A.75.75 0 0 1 10 2Zm3.76 11.2a.75.75 0 0 1 .04 1.06l-3.25 3.5a.75.75 0 0 1-1.1 0l-3.25-3.5a.75.75 0 1 1 1.1-1.02l2.7 2.908 2.7-2.908a.75.75 0 0 1 1.06-.04Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Fxe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="unlock">
    <path fill-rule="evenodd" d="M6 5a4 4 0 1 1 8 0v.25a.75.75 0 0 1-1.5 0V5a2.5 2.5 0 0 0-5 0v3h7.75A2.75 2.75 0 0 1 18 10.75v5.5A2.75 2.75 0 0 1 15.25 19H4.75A2.75 2.75 0 0 1 2 16.25v-5.5A2.75 2.75 0 0 1 4.75 8H6V5ZM4.75 9.5c-.69 0-1.25.56-1.25 1.25v5.5c0 .69.56 1.25 1.25 1.25h10.5c.69 0 1.25-.56 1.25-1.25v-5.5c0-.69-.56-1.25-1.25-1.25H4.75ZM10 12a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0v-1.5A.75.75 0 0 1 10 12Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Txe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="upload">
    <path fill-rule="evenodd" d="M9.491 1.199a.75.75 0 0 1 1.018 0l3.25 3A.75.75 0 1 1 12.74 5.3l-1.99-1.837v8.787a.75.75 0 0 1-1.5 0V3.463L7.259 5.301A.75.75 0 1 1 6.24 4.2l3.25-3ZM1.75 13a.75.75 0 0 1 .75.75v2.5c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25v-2.5a.75.75 0 0 1 1.5 0v2.5A2.75 2.75 0 0 1 16.25 19H3.75A2.75 2.75 0 0 1 1 16.25v-2.5a.75.75 0 0 1 .75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Ixe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="user-check" clip-path="url(#a)">
    <path fill-rule="evenodd" d="M10 2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5ZM6 5a4 4 0 1 1 8 0 4 4 0 0 1-8 0ZM3 16.625A5.625 5.625 0 0 1 8.625 11h2.125a.75.75 0 0 1 0 1.5H8.625A4.125 4.125 0 0 0 4.5 16.625c0 .483.392.875.875.875H8.75a.75.75 0 0 1 0 1.5H5.375A2.375 2.375 0 0 1 3 16.625Zm16.765-3.42a.75.75 0 0 1 .03 1.06l-4.25 4.5a.75.75 0 0 1-1.102-.013l-2.25-2.5a.75.75 0 1 1 1.114-1.004l1.706 1.896 3.692-3.909a.75.75 0 0 1 1.06-.03Z" class="Icon" clip-rule="evenodd"/>
  </g>
  <defs>
    <clipPath id="a" class="a">
      <path d="M0 0h20v20H0z"/>
    </clipPath>
  </defs>
</svg>
`, Dxe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="user-close">
    <path fill-rule="evenodd" d="M10 2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5ZM6 5a4 4 0 1 1 8 0 4 4 0 0 1-8 0ZM3 16.625A5.625 5.625 0 0 1 8.625 11h2.125a.75.75 0 0 1 0 1.5H8.625A4.125 4.125 0 0 0 4.5 16.625c0 .483.392.875.875.875H8.75a.75.75 0 0 1 0 1.5H5.375A2.375 2.375 0 0 1 3 16.625Zm10.22-3.405a.75.75 0 0 1 1.06 0L16 14.94l1.72-1.72a.75.75 0 1 1 1.06 1.06L17.06 16l1.72 1.72a.75.75 0 1 1-1.06 1.06L16 17.06l-1.72 1.72a.75.75 0 1 1-1.06-1.06L14.94 16l-1.72-1.72a.75.75 0 0 1 0-1.06Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, kxe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="user-edit">
    <path fill-rule="evenodd" d="M10 2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5ZM6 5a4 4 0 1 1 8 0 4 4 0 0 1-8 0ZM3 16.625A5.625 5.625 0 0 1 8.625 11h2.125a.75.75 0 0 1 0 1.5H8.625A4.125 4.125 0 0 0 4.5 16.625c0 .483.392.875.875.875H8.75a.75.75 0 0 1 0 1.5H5.375A2.375 2.375 0 0 1 3 16.625Zm15.286-2.911a.73.73 0 0 0-1.033 0L13.5 17.467V18.5h1.033l3.753-3.753a.73.73 0 0 0 0-1.033Zm-2.094-1.06a2.23 2.23 0 1 1 3.155 3.154l-3.973 3.972a.75.75 0 0 1-.53.22H12.75a.75.75 0 0 1-.75-.75v-2.094a.75.75 0 0 1 .22-.53l3.972-3.973Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Hxe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="user-minus">
    <path fill-rule="evenodd" d="M10 2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5ZM6 5a4 4 0 1 1 8 0 4 4 0 0 1-8 0ZM3 16.625A5.625 5.625 0 0 1 8.625 11h2.125a.75.75 0 0 1 0 1.5H8.625A4.125 4.125 0 0 0 4.5 16.625c0 .483.392.875.875.875H8.75a.75.75 0 0 1 0 1.5H5.375A2.375 2.375 0 0 1 3 16.625Zm9-.875a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Vxe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="user-plus">
    <path fill-rule="evenodd" d="M10 2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5ZM6 5a4 4 0 1 1 8 0 4 4 0 0 1-8 0ZM3 16.625A5.625 5.625 0 0 1 8.625 11h2.125a.75.75 0 0 1 0 1.5H8.625A4.125 4.125 0 0 0 4.5 16.625c0 .483.392.875.875.875H8.75a.75.75 0 0 1 0 1.5H5.375A2.375 2.375 0 0 1 3 16.625ZM16 12a.75.75 0 0 1 .75.75v2.5h2.5a.75.75 0 0 1 0 1.5h-2.5v2.5a.75.75 0 0 1-1.5 0v-2.5h-2.5a.75.75 0 0 1 0-1.5h2.5v-2.5A.75.75 0 0 1 16 12Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Oxe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="user">
    <path fill-rule="evenodd" d="M10 2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5ZM6 5a4 4 0 1 1 8 0 4 4 0 0 1-8 0ZM3 16.625A5.625 5.625 0 0 1 8.625 11h2.75A5.625 5.625 0 0 1 17 16.625 2.375 2.375 0 0 1 14.625 19h-9.25A2.375 2.375 0 0 1 3 16.625ZM8.625 12.5A4.125 4.125 0 0 0 4.5 16.625c0 .483.392.875.875.875h9.25a.875.875 0 0 0 .875-.875 4.125 4.125 0 0 0-4.125-4.125h-2.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Bxe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="users">
    <path fill-rule="evenodd" d="M7 2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5ZM3 5a4 4 0 1 1 8 0 4 4 0 0 1-8 0Zm9.25-3.25A.75.75 0 0 1 13 1a4 4 0 0 1 0 8 .75.75 0 0 1 0-1.5 2.5 2.5 0 0 0 0-5 .75.75 0 0 1-.75-.75ZM1 16.625A5.625 5.625 0 0 1 6.625 11h.75A5.625 5.625 0 0 1 13 16.625 2.375 2.375 0 0 1 10.625 19h-7.25A2.375 2.375 0 0 1 1 16.625ZM6.625 12.5A4.125 4.125 0 0 0 2.5 16.625c0 .483.392.875.875.875h7.25a.875.875 0 0 0 .875-.875A4.125 4.125 0 0 0 7.375 12.5h-.75Zm5.875-.75a.75.75 0 0 1 .75-.75h.125A5.625 5.625 0 0 1 19 16.625 2.375 2.375 0 0 1 16.625 19H15a.75.75 0 0 1 0-1.5h1.625a.875.875 0 0 0 .875-.875 4.125 4.125 0 0 0-4.125-4.125h-.125a.75.75 0 0 1-.75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, $xe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="vertical-align-bottom">
    <path fill-rule="evenodd" d="M10 1a.75.75 0 0 1 .75.75v11.764l2.986-2.81a.75.75 0 0 1 1.028 1.092l-4.25 4a.75.75 0 0 1-1.028 0l-4.25-4a.75.75 0 0 1 1.028-1.092l2.986 2.81V1.75A.75.75 0 0 1 10 1ZM1 18.25a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H1.75a.75.75 0 0 1-.75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Zxe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="vertical-align-center">
    <path fill-rule="evenodd" d="M19 10a.75.75 0 0 1-.75.75H1.75a.75.75 0 0 1 0-1.5h16.5A.75.75 0 0 1 19 10Zm-5.199-6.259a.75.75 0 0 1-.042 1.06l-3.25 3a.75.75 0 0 1-1.018 0l-3.25-3A.75.75 0 1 1 7.26 3.7l1.99 1.837V1.75a.75.75 0 0 1 1.5 0v3.787l1.991-1.838a.75.75 0 0 1 1.06.042Zm0 12.518a.75.75 0 0 1-1.06.042l-1.991-1.838v3.787a.75.75 0 0 1-1.5 0v-3.787l-1.991 1.838A.75.75 0 1 1 6.24 15.2l3.25-3a.75.75 0 0 1 1.018 0l3.25 3a.75.75 0 0 1 .042 1.06Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Gxe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="vertical-align-top">
    <path fill-rule="evenodd" d="M1 1.75A.75.75 0 0 1 1.75 1h16.5a.75.75 0 0 1 0 1.5H1.75A.75.75 0 0 1 1 1.75Zm8.486 2.454a.75.75 0 0 1 1.028 0l4.25 4a.75.75 0 1 1-1.028 1.092l-2.986-2.81V18.25a.75.75 0 0 1-1.5 0V6.486l-2.986 2.81a.75.75 0 1 1-1.028-1.092l4.25-4Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Nxe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="video-camera">
    <path fill-rule="evenodd" d="M4.92 3h5.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 13.7 4.502c.172.337.24.693.27 1.073.02.246.027.529.029.851l1.471-.883c.372-.223.694-.416.964-.546.273-.132.607-.258.978-.223a1.75 1.75 0 0 1 1.249.706c.22.301.284.652.312.954.027.299.027.675.027 1.108v4.916c0 .434 0 .81-.027 1.108-.028.302-.092.653-.312.954a1.75 1.75 0 0 1-1.249.706c-.371.035-.704-.091-.978-.223-.27-.13-.592-.323-.964-.546L14 13.574c-.002.322-.009.605-.029.85-.03.38-.098.737-.27 1.075A2.751 2.751 0 0 1 12.5 16.7c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03H4.92c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 1.3 15.5c-.172-.338-.24-.694-.27-1.074C1 14.06 1 13.615 1 13.08V6.92c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 2.502 3.3c.337-.172.693-.24 1.073-.27C3.94 3 4.385 3 4.92 3ZM14 11.825l2.213 1.328c.409.245.672.402.872.499.125.06.185.075.202.08a.25.25 0 0 0 .156-.09.99.99 0 0 0 .036-.213c.02-.222.021-.528.021-1.005V7.576c0-.477 0-.783-.021-1.005a.99.99 0 0 0-.036-.213.25.25 0 0 0-.156-.09.984.984 0 0 0-.202.08c-.2.097-.463.253-.872.499L14 8.175v3.65Zm-10.303-7.3c-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.547c-.046.09-.088.227-.111.514-.024.296-.025.68-.025 1.253v6.1c0 .572 0 .957.025 1.252.023.288.065.425.111.516.12.235.311.426.547.546.09.046.227.088.514.111.296.024.68.025 1.253.025h5.1c.572 0 .957 0 1.252-.025.288-.023.425-.065.516-.111a1.25 1.25 0 0 0 .546-.546c.046-.091.088-.228.111-.515.024-.296.025-.68.025-1.253v-6.1c0-.572 0-.957-.025-1.253-.023-.287-.065-.424-.111-.514a1.25 1.25 0 0 0-.546-.547c-.091-.046-.228-.088-.515-.111-.296-.024-.68-.025-1.253-.025h-5.1c-.572 0-.957 0-1.253.025Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, zxe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="video">
    <path fill-rule="evenodd" d="M1 4.75A2.75 2.75 0 0 1 3.75 2h12.5A2.75 2.75 0 0 1 19 4.75v10.5A2.75 2.75 0 0 1 16.25 18H3.75A2.75 2.75 0 0 1 1 15.25V4.75Zm1.5 2.5v2H5v-2H2.5ZM5 5.75H2.5v-1c0-.69.56-1.25 1.25-1.25H5v2.25ZM6.5 16.5h7v-13h-7v13Zm8.5-13v2.25h2.5v-1c0-.69-.56-1.25-1.25-1.25H15Zm2.5 3.75H15v2h2.5v-2Zm0 3.5H15v2h2.5v-2Zm0 3.5H15v2.25h1.25c.69 0 1.25-.56 1.25-1.25v-1ZM5 16.5v-2.25H2.5v1c0 .69.56 1.25 1.25 1.25H5Zm-2.5-3.75H5v-2H2.5v2Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, jxe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="view-boxes">
    <path fill-rule="evenodd" d="M4.92 1h.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 8.7 2.502c.172.337.24.693.27 1.073.03.365.03.81.03 1.345v.16c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073A2.75 2.75 0 0 1 7.498 8.7c-.337.172-.693.24-1.073.27C6.06 9 5.615 9 5.08 9h-.16c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 1.3 7.498c-.172-.337-.24-.693-.27-1.073C1 6.06 1 5.615 1 5.08v-.16c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 2.502 1.3c.337-.172.693-.24 1.073-.27C3.94 1 4.385 1 4.92 1ZM3.697 2.525c-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.547c-.046.09-.088.227-.111.514-.024.296-.025.68-.025 1.253v.1c0 .572 0 .957.025 1.253.023.287.065.424.111.514.12.236.311.427.547.547.09.046.227.088.514.111.296.024.68.025 1.253.025h.1c.572 0 .957 0 1.253-.025.287-.023.424-.065.514-.111a1.25 1.25 0 0 0 .547-.547c.046-.09.088-.227.111-.514.024-.296.025-.68.025-1.253v-.1c0-.572 0-.957-.025-1.253-.023-.287-.065-.424-.111-.514a1.25 1.25 0 0 0-.547-.547c-.09-.046-.227-.088-.514-.111C6.007 2.5 5.623 2.5 5.05 2.5h-.1c-.572 0-.957 0-1.253.025ZM14.92 1h.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 18.7 2.502c.172.337.24.693.27 1.073.03.365.03.81.03 1.345v.16c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073A2.75 2.75 0 0 1 17.5 8.7c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03h-.16c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 11.3 7.498c-.172-.337-.24-.693-.27-1.073C11 6.06 11 5.615 11 5.08v-.16c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 12.5 1.3c.338-.172.694-.24 1.074-.27.365-.03.81-.03 1.345-.03Zm-1.223 1.525c-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.547c-.046.09-.088.227-.111.514-.024.296-.025.68-.025 1.253v.1c0 .572 0 .957.025 1.253.023.287.065.424.111.514.12.236.311.427.546.547.091.046.228.088.515.111.296.024.68.025 1.253.025h.1c.572 0 .957 0 1.252-.025.288-.023.425-.065.515-.111a1.25 1.25 0 0 0 .547-.547c.046-.09.088-.227.111-.514.024-.296.025-.68.025-1.253v-.1c0-.572 0-.957-.025-1.253-.023-.287-.065-.424-.111-.514a1.25 1.25 0 0 0-.547-.547c-.09-.046-.227-.088-.515-.111-.295-.024-.68-.025-1.252-.025h-.1c-.572 0-.957 0-1.252.025ZM4.92 11h.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 8.7 12.5c.172.338.24.694.27 1.074.03.365.03.81.03 1.345v.16c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073A2.75 2.75 0 0 1 7.498 18.7c-.337.172-.693.24-1.073.27-.365.03-.81.03-1.345.03h-.16c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 1.3 17.5c-.172-.338-.24-.694-.27-1.074C1 16.06 1 15.615 1 15.08v-.16c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 2.502 11.3c.337-.172.693-.24 1.073-.27.365-.03.81-.03 1.345-.03Zm-1.223 1.525c-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.546c-.046.091-.088.228-.111.515-.024.296-.025.68-.025 1.253v.1c0 .572 0 .957.025 1.252.023.288.065.425.111.515.12.236.311.427.547.547.09.046.227.088.514.111.296.024.68.025 1.253.025h.1c.572 0 .957 0 1.253-.025.287-.023.424-.065.514-.111a1.25 1.25 0 0 0 .547-.547c.046-.09.088-.227.111-.515.024-.295.025-.68.025-1.252v-.1c0-.572 0-.957-.025-1.252-.023-.288-.065-.425-.111-.516a1.25 1.25 0 0 0-.547-.546c-.09-.046-.227-.088-.514-.111-.296-.024-.68-.025-1.253-.025h-.1c-.572 0-.957 0-1.253.025ZM14.92 11h.162c.534 0 .98 0 1.344.03.38.03.736.098 1.073.27.518.263.939.684 1.202 1.201.172.338.24.694.27 1.074.03.365.03.81.03 1.345v.16c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073A2.751 2.751 0 0 1 17.5 18.7c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03h-.16c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27a2.751 2.751 0 0 1-1.203-1.2c-.172-.338-.24-.694-.27-1.074-.03-.365-.03-.81-.03-1.345v-.16c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073a2.751 2.751 0 0 1 1.2-1.203c.338-.172.694-.24 1.074-.27.365-.03.81-.03 1.345-.03Zm-1.222 1.525c-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.546c-.046.091-.088.228-.111.515-.024.296-.025.68-.025 1.253v.1c0 .572 0 .957.025 1.252.023.288.065.425.111.515.12.236.311.427.546.547.091.046.228.088.515.111.296.024.68.025 1.253.025h.1c.572 0 .957 0 1.252-.025.288-.023.425-.065.515-.111a1.25 1.25 0 0 0 .547-.547c.046-.09.088-.227.111-.515.024-.295.025-.68.025-1.252v-.1c0-.572 0-.957-.025-1.252-.023-.288-.065-.425-.111-.516a1.25 1.25 0 0 0-.547-.546c-.09-.046-.227-.088-.515-.111-.295-.024-.68-.025-1.252-.025h-.1c-.572 0-.957 0-1.252.025Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Wxe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="view-columns">
    <path fill-rule="evenodd" d="M1 3.75A2.75 2.75 0 0 1 3.75 1h12.5A2.75 2.75 0 0 1 19 3.75v12.5A2.75 2.75 0 0 1 16.25 19H3.75A2.75 2.75 0 0 1 1 16.25V3.75Zm9.75 13.75h5.5c.69 0 1.25-.56 1.25-1.25V3.75c0-.69-.56-1.25-1.25-1.25h-5.5v15Zm-1.5-15v15h-5.5c-.69 0-1.25-.56-1.25-1.25V3.75c0-.69.56-1.25 1.25-1.25h5.5Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Uxe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="view-dashboard">
    <path fill-rule="evenodd" d="M3.963 1h2.074c.196 0 .347 0 .483.013A2.75 2.75 0 0 1 8.987 3.48C9 3.616 9 3.767 9 3.963v.074c0 .196 0 .347-.013.483A2.75 2.75 0 0 1 6.52 6.987 5.128 5.128 0 0 1 6.037 7H3.963c-.196 0-.347 0-.483-.013A2.75 2.75 0 0 1 1.013 4.52C1 4.384 1 4.233 1 4.037a146.281 146.281 0 0 0 0-.074c0-.196 0-.347.013-.483A2.75 2.75 0 0 1 3.48 1.013C3.616 1 3.767 1 3.963 1ZM4 2.5c-.25 0-.32 0-.373.006a1.25 1.25 0 0 0-1.121 1.121A4.685 4.685 0 0 0 2.5 4c0 .25 0 .32.006.373a1.25 1.25 0 0 0 1.121 1.121c.052.005.123.006.373.006h2c.25 0 .32 0 .373-.006a1.25 1.25 0 0 0 1.121-1.121C7.499 4.32 7.5 4.25 7.5 4s0-.32-.006-.373a1.25 1.25 0 0 0-1.121-1.121A4.685 4.685 0 0 0 6 2.5H4ZM14.92 1h.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 18.7 2.502c.172.337.24.693.27 1.073.03.365.03.81.03 1.345v2.16c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073a2.751 2.751 0 0 1-1.2 1.202c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03h-.16c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.751 2.751 0 0 1 11.3 9.498c-.172-.337-.24-.693-.27-1.073C11 8.06 11 7.615 11 7.08V4.92c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 12.5 1.3c.338-.172.694-.24 1.074-.27.365-.03.81-.03 1.345-.03Zm-1.223 1.525c-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.547c-.046.09-.088.227-.111.514-.024.296-.025.68-.025 1.253v2.1c0 .572 0 .957.025 1.253.023.287.065.424.111.514.12.236.311.427.546.547.091.046.228.088.515.111.296.024.68.025 1.253.025h.1c.572 0 .957 0 1.252-.025.288-.023.425-.065.515-.111a1.25 1.25 0 0 0 .547-.546c.046-.091.088-.228.111-.515.024-.296.025-.68.025-1.253v-2.1c0-.572 0-.957-.025-1.253-.023-.287-.065-.424-.111-.514a1.25 1.25 0 0 0-.547-.547c-.09-.046-.227-.088-.515-.111-.295-.024-.68-.025-1.252-.025h-.1c-.572 0-.957 0-1.252.025ZM4.92 9h.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 8.7 10.5c.172.338.24.694.27 1.074.03.365.03.81.03 1.345v2.16c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073A2.75 2.75 0 0 1 7.498 18.7c-.337.172-.693.24-1.073.27-.365.03-.81.03-1.345.03h-.16c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 1.3 17.5c-.172-.338-.24-.694-.27-1.074C1 16.06 1 15.615 1 15.08v-2.16c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 2.502 9.3c.337-.172.693-.24 1.073-.27C3.94 9 4.385 9 4.92 9Zm-1.223 1.525c-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.546c-.046.091-.088.228-.111.515-.024.296-.025.68-.025 1.253v2.1c0 .572 0 .957.025 1.252.023.288.065.425.111.515.12.236.311.427.547.547.09.046.227.088.514.111.296.024.68.025 1.253.025h.1c.572 0 .957 0 1.253-.025.287-.023.424-.065.514-.111a1.25 1.25 0 0 0 .547-.547c.046-.09.088-.227.111-.515.024-.295.025-.68.025-1.252v-2.1c0-.572 0-.957-.025-1.252-.023-.288-.065-.425-.111-.516a1.25 1.25 0 0 0-.547-.546c-.09-.046-.227-.088-.514-.111-.296-.024-.68-.025-1.253-.025h-.1c-.572 0-.957 0-1.253.025ZM13.963 13h2.074c.196 0 .347 0 .483.013a2.75 2.75 0 0 1 2.467 2.467c.013.136.013.287.013.483v.074c0 .196 0 .347-.013.483a2.75 2.75 0 0 1-2.467 2.467 5.122 5.122 0 0 1-.483.013h-2.074c-.196 0-.347 0-.483-.013a2.75 2.75 0 0 1-2.467-2.467 5.124 5.124 0 0 1-.013-.483v-.074c0-.196 0-.347.013-.482a2.75 2.75 0 0 1 2.467-2.468c.136-.013.287-.013.483-.013ZM14 14.5c-.25 0-.32 0-.373.006a1.25 1.25 0 0 0-1.121 1.121A4.696 4.696 0 0 0 12.5 16c0 .25 0 .32.006.372a1.25 1.25 0 0 0 1.121 1.122c.052.005.123.006.373.006h2c.25 0 .32 0 .372-.006a1.25 1.25 0 0 0 1.122-1.122c.005-.051.006-.122.006-.372s0-.32-.006-.373a1.25 1.25 0 0 0-1.122-1.121A4.696 4.696 0 0 0 16 14.5h-2Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Kxe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="view-day">
    <path fill-rule="evenodd" d="M1 1.75A.75.75 0 0 1 1.75 1h16.5a.75.75 0 0 1 0 1.5H1.75A.75.75 0 0 1 1 1.75ZM4.92 6h10.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 18.7 7.502c.172.337.24.693.27 1.073.03.365.03.81.03 1.345v.16c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073a2.751 2.751 0 0 1-1.2 1.202c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03H4.92c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 1.3 12.5c-.172-.338-.24-.694-.27-1.074C1 11.06 1 10.615 1 10.08v-.16c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 2.502 6.3c.337-.172.693-.24 1.073-.27C3.94 6 4.385 6 4.92 6ZM3.697 7.525c-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.547c-.046.09-.088.227-.111.514-.024.296-.025.68-.025 1.253v.1c0 .572 0 .957.025 1.252.023.288.065.425.111.516.12.235.311.426.547.546.09.046.227.088.514.111.296.024.68.025 1.253.025h10.1c.572 0 .957 0 1.252-.025.288-.023.425-.065.515-.111a1.25 1.25 0 0 0 .547-.546c.046-.091.088-.228.111-.515.024-.296.025-.68.025-1.253v-.1c0-.572 0-.957-.025-1.253-.023-.287-.065-.424-.111-.514a1.25 1.25 0 0 0-.547-.547c-.09-.046-.227-.088-.515-.111-.295-.024-.68-.025-1.252-.025H4.95c-.572 0-.957 0-1.253.025ZM1 18.25a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H1.75a.75.75 0 0 1-.75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, qxe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="view-layout-bottom">
    <path fill-rule="evenodd" d="M1 3.75A2.75 2.75 0 0 1 3.75 1h12.5A2.75 2.75 0 0 1 19 3.75v12.5A2.75 2.75 0 0 1 16.25 19H3.75A2.75 2.75 0 0 1 1 16.25V3.75ZM2.5 14v2.25c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25V14h-15Zm15-1.5h-15V3.75c0-.69.56-1.25 1.25-1.25h12.5c.69 0 1.25.56 1.25 1.25v8.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Yxe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="view-layout-grid">
    <path fill-rule="evenodd" d="M1 3.75A2.75 2.75 0 0 1 3.75 1h12.5A2.75 2.75 0 0 1 19 3.75v12.5A2.75 2.75 0 0 1 16.25 19H3.75A2.75 2.75 0 0 1 1 16.25V3.75Zm1.5 7v5.5c0 .69.56 1.25 1.25 1.25h5.5v-6.75H2.5Zm6.75-1.5H2.5v-5.5c0-.69.56-1.25 1.25-1.25h5.5v6.75Zm1.5 1.5v6.75h5.5c.69 0 1.25-.56 1.25-1.25v-5.5h-6.75Zm6.75-1.5h-6.75V2.5h5.5c.69 0 1.25.56 1.25 1.25v5.5Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Qxe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="view-layout-left">
    <path fill-rule="evenodd" d="M1 3.75A2.75 2.75 0 0 1 3.75 1h12.5A2.75 2.75 0 0 1 19 3.75v12.5A2.75 2.75 0 0 1 16.25 19H3.75A2.75 2.75 0 0 1 1 16.25V3.75ZM7.5 17.5h8.75c.69 0 1.25-.56 1.25-1.25V3.75c0-.69-.56-1.25-1.25-1.25H7.5v15ZM6 2.5v15H3.75c-.69 0-1.25-.56-1.25-1.25V3.75c0-.69.56-1.25 1.25-1.25H6Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Jxe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="view-layout-right">
    <path fill-rule="evenodd" d="M1 3.75A2.75 2.75 0 0 1 3.75 1h12.5A2.75 2.75 0 0 1 19 3.75v12.5A2.75 2.75 0 0 1 16.25 19H3.75A2.75 2.75 0 0 1 1 16.25V3.75ZM14 17.5h2.25c.69 0 1.25-.56 1.25-1.25V3.75c0-.69-.56-1.25-1.25-1.25H14v15Zm-1.5-15v15H3.75c-.69 0-1.25-.56-1.25-1.25V3.75c0-.69.56-1.25 1.25-1.25h8.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, Xxe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="view-layout-top">
    <path fill-rule="evenodd" d="M1 3.75A2.75 2.75 0 0 1 3.75 1h12.5A2.75 2.75 0 0 1 19 3.75v12.5A2.75 2.75 0 0 1 16.25 19H3.75A2.75 2.75 0 0 1 1 16.25V3.75ZM2.5 7.5v8.75c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25V7.5h-15Zm15-1.5h-15V3.75c0-.69.56-1.25 1.25-1.25h12.5c.69 0 1.25.56 1.25 1.25V6Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, eMe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="view-lp">
    <path fill-rule="evenodd" d="M4.92 1h10.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 18.7 2.502c.172.337.24.693.27 1.073.03.365.03.81.03 1.345v.16c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073A2.75 2.75 0 0 1 17.5 8.7c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03H4.92c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 1.3 7.498c-.172-.337-.24-.693-.27-1.073C1 6.06 1 5.615 1 5.08v-.16c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 2.502 1.3c.337-.172.693-.24 1.073-.27C3.94 1 4.385 1 4.92 1ZM3.697 2.525c-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.547c-.046.09-.088.227-.111.514-.024.296-.025.68-.025 1.253v.1c0 .572 0 .957.025 1.253.023.287.065.424.111.514.12.236.311.427.547.547.09.046.227.088.514.111.296.024.68.025 1.253.025h10.1c.572 0 .957 0 1.252-.025.288-.023.425-.065.515-.111a1.25 1.25 0 0 0 .547-.547c.046-.09.088-.227.111-.514.024-.296.025-.68.025-1.253v-.1c0-.572 0-.957-.025-1.253-.023-.287-.065-.424-.111-.514a1.25 1.25 0 0 0-.547-.547c-.09-.046-.227-.088-.515-.111-.295-.024-.68-.025-1.252-.025H4.95c-.572 0-.957 0-1.253.025ZM4.92 11h.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 8.7 12.5c.172.338.24.694.27 1.074.03.365.03.81.03 1.345v.16c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073A2.75 2.75 0 0 1 7.498 18.7c-.337.172-.693.24-1.073.27-.365.03-.81.03-1.345.03h-.16c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 1.3 17.5c-.172-.338-.24-.694-.27-1.074C1 16.06 1 15.615 1 15.08v-.16c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 2.502 11.3c.337-.172.693-.24 1.073-.27.365-.03.81-.03 1.345-.03Zm-1.223 1.525c-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.546c-.046.091-.088.228-.111.515-.024.296-.025.68-.025 1.253v.1c0 .572 0 .957.025 1.252.023.288.065.425.111.515.12.236.311.427.547.547.09.046.227.088.514.111.296.024.68.025 1.253.025h.1c.572 0 .957 0 1.253-.025.287-.023.424-.065.514-.111a1.25 1.25 0 0 0 .547-.547c.046-.09.088-.227.111-.515.024-.295.025-.68.025-1.252v-.1c0-.572 0-.957-.025-1.252-.023-.288-.065-.425-.111-.516a1.25 1.25 0 0 0-.547-.546c-.09-.046-.227-.088-.514-.111-.296-.024-.68-.025-1.253-.025h-.1c-.572 0-.957 0-1.253.025ZM14.92 11h.162c.534 0 .98 0 1.344.03.38.03.736.098 1.073.27.518.263.939.684 1.202 1.201.172.338.24.694.27 1.074.03.365.03.81.03 1.345v.16c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073A2.751 2.751 0 0 1 17.5 18.7c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03h-.16c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27a2.751 2.751 0 0 1-1.203-1.2c-.172-.338-.24-.694-.27-1.074-.03-.365-.03-.81-.03-1.345v-.16c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073a2.751 2.751 0 0 1 1.2-1.203c.338-.172.694-.24 1.074-.27.365-.03.81-.03 1.345-.03Zm-1.222 1.525c-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.546c-.046.091-.088.228-.111.515-.024.296-.025.68-.025 1.253v.1c0 .572 0 .957.025 1.252.023.288.065.425.111.515.12.236.311.427.546.547.091.046.228.088.515.111.296.024.68.025 1.253.025h.1c.572 0 .957 0 1.252-.025.288-.023.425-.065.515-.111a1.25 1.25 0 0 0 .547-.547c.046-.09.088-.227.111-.515.024-.295.025-.68.025-1.252v-.1c0-.572 0-.957-.025-1.252-.023-.288-.065-.425-.111-.516a1.25 1.25 0 0 0-.547-.546c-.09-.046-.227-.088-.515-.111-.295-.024-.68-.025-1.252-.025h-.1c-.572 0-.957 0-1.252.025Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, tMe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="view-rows">
    <path fill-rule="evenodd" d="M1 3.75A2.75 2.75 0 0 1 3.75 1h12.5A2.75 2.75 0 0 1 19 3.75v12.5A2.75 2.75 0 0 1 16.25 19H3.75A2.75 2.75 0 0 1 1 16.25V3.75Zm1.5 7v5.5c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25v-5.5h-15Zm15-1.5h-15v-5.5c0-.69.56-1.25 1.25-1.25h12.5c.69 0 1.25.56 1.25 1.25v5.5Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, oMe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="view-schedule">
    <path fill-rule="evenodd" d="M4.92 1h10.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 18.7 2.502c.172.337.24.693.27 1.073.03.365.03.81.03 1.345v.16c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073A2.75 2.75 0 0 1 17.5 8.7c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03H4.92c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 1.3 7.498c-.172-.337-.24-.693-.27-1.073C1 6.06 1 5.615 1 5.08v-.16c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 2.502 1.3c.337-.172.693-.24 1.073-.27C3.94 1 4.385 1 4.92 1ZM3.697 2.525c-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.547c-.046.09-.088.227-.111.514-.024.296-.025.68-.025 1.253v.1c0 .572 0 .957.025 1.253.023.287.065.424.111.514.12.236.311.427.547.547.09.046.227.088.514.111.296.024.68.025 1.253.025h10.1c.572 0 .957 0 1.252-.025.288-.023.425-.065.515-.111a1.25 1.25 0 0 0 .547-.547c.046-.09.088-.227.111-.514.024-.296.025-.68.025-1.253v-.1c0-.572 0-.957-.025-1.253-.023-.287-.065-.424-.111-.514a1.25 1.25 0 0 0-.547-.547c-.09-.046-.227-.088-.515-.111-.295-.024-.68-.025-1.252-.025H4.95c-.572 0-.957 0-1.253.025ZM4.92 11h10.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27.518.263.939.684 1.202 1.201.172.338.24.694.27 1.074.03.365.03.81.03 1.345v.16c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073a2.751 2.751 0 0 1-1.2 1.202c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03H4.92c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 1.3 17.5c-.172-.338-.24-.694-.27-1.074C1 16.06 1 15.615 1 15.08v-.16c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 2.502 11.3c.337-.172.693-.24 1.073-.27.365-.03.81-.03 1.345-.03Zm-1.223 1.525c-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.546c-.046.091-.088.228-.111.515-.024.296-.025.68-.025 1.253v.1c0 .572 0 .957.025 1.252.023.288.065.425.111.515.12.236.311.427.547.547.09.046.227.088.514.111.296.024.68.025 1.253.025h10.1c.572 0 .957 0 1.252-.025.288-.023.425-.065.515-.111a1.25 1.25 0 0 0 .547-.547c.046-.09.088-.227.111-.515.024-.295.025-.68.025-1.252v-.1c0-.572 0-.957-.025-1.252-.023-.288-.065-.425-.111-.516a1.25 1.25 0 0 0-.547-.546c-.09-.046-.227-.088-.515-.111-.295-.024-.68-.025-1.252-.025H4.95c-.572 0-.957 0-1.253.025Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, nMe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="view-slider">
    <path fill-rule="evenodd" d="M9.92 1.25h.16c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27A2.75 2.75 0 0 1 13.7 2.752c.172.337.24.693.27 1.073.03.365.03.81.03 1.345v10.16c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073a2.751 2.751 0 0 1-1.2 1.202c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03h-.16c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27a2.75 2.75 0 0 1-1.203-1.2c-.172-.338-.24-.694-.27-1.074C6 16.31 6 15.865 6 15.33V5.17c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 7.502 1.55c.337-.172.693-.24 1.073-.27.365-.03.81-.03 1.345-.03ZM8.697 2.775c-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.547c-.046.09-.088.227-.111.514-.024.296-.025.68-.025 1.253v10.1c0 .572 0 .957.025 1.252.023.288.065.425.111.515.12.236.311.427.547.547.09.046.227.088.514.111.296.024.68.025 1.253.025h.1c.572 0 .957 0 1.252-.025.288-.023.425-.065.516-.111a1.25 1.25 0 0 0 .546-.547c.046-.09.088-.227.111-.515.024-.295.025-.68.025-1.252V5.2c0-.572 0-.957-.025-1.253-.023-.287-.065-.424-.111-.514a1.25 1.25 0 0 0-.546-.547c-.091-.046-.228-.088-.515-.111-.296-.024-.68-.025-1.253-.025h-.1c-.572 0-.957 0-1.253.025ZM1.75 4.25A.75.75 0 0 1 2.5 5v10.5a.75.75 0 0 1-1.5 0V5a.75.75 0 0 1 .75-.75Zm16.5 0A.75.75 0 0 1 19 5v10.5a.75.75 0 0 1-1.5 0V5a.75.75 0 0 1 .75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, sMe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="view-table">
    <path fill-rule="evenodd" d="M1 3.75A2.75 2.75 0 0 1 3.75 1h12.5A2.75 2.75 0 0 1 19 3.75v12.5A2.75 2.75 0 0 1 16.25 19H3.75A2.75 2.75 0 0 1 1 16.25V3.75ZM2.5 7.5v8.75c0 .69.56 1.25 1.25 1.25H6v-10H2.5ZM6 6H2.5V3.75c0-.69.56-1.25 1.25-1.25H6V6Zm1.5 1.5v10h8.75c.69 0 1.25-.56 1.25-1.25V7.5h-10Zm10-1.5h-10V2.5h8.75c.69 0 1.25.56 1.25 1.25V6Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, iMe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="voice">
    <path fill-rule="evenodd" d="M5.75 1a.75.75 0 0 1 .75.75v16.5a.75.75 0 0 1-1.5 0V1.75A.75.75 0 0 1 5.75 1ZM10 4a.75.75 0 0 1 .75.75v10.5a.75.75 0 0 1-1.5 0V4.75A.75.75 0 0 1 10 4Zm8.25 1a.75.75 0 0 1 .75.75v8.5a.75.75 0 0 1-1.5 0v-8.5a.75.75 0 0 1 .75-.75ZM1.75 7a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0v-4.5A.75.75 0 0 1 1.75 7Zm12.5 1a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0v-2.5a.75.75 0 0 1 .75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, rMe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="voicemail">
    <path fill-rule="evenodd" d="M4.5 7.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm2.873 4A3.5 3.5 0 1 0 4.5 13h11a3.5 3.5 0 1 0-2.873-1.5H7.373Zm8.127 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, lMe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="volume-max">
    <path fill-rule="evenodd" d="M14.65 3.3a.75.75 0 0 1 1.05-.15c4.4 3.3 4.4 10.4 0 13.7a.75.75 0 1 1-.9-1.2c3.6-2.7 3.6-8.6 0-11.3a.75.75 0 0 1-.15-1.05Zm-5.1-.237c.274.12.45.39.45.687v12.5a.75.75 0 0 1-1.259.551l-2.372-2.19c-.32-.295-.408-.372-.499-.428a1.252 1.252 0 0 0-.408-.159c-.104-.02-.22-.024-.657-.024H4.78c-.47 0-.861 0-1.182-.023-.335-.024-.65-.076-.954-.21a2.75 2.75 0 0 1-1.41-1.41c-.134-.303-.186-.619-.21-.954C1 11.083 1 10.691 1 10.221V9.78c0-.47 0-.861.023-1.182.024-.335.076-.65.21-.954a2.75 2.75 0 0 1 1.41-1.41c.304-.134.619-.186.954-.21C3.917 6 4.309 6 4.779 6h.026c.437 0 .553-.003.657-.024a1.25 1.25 0 0 0 .408-.16c.09-.055.179-.132.5-.427l2.371-2.19a.75.75 0 0 1 .81-.136Zm-1.05 2.4L7.387 6.491l-.045.04c-.255.237-.457.423-.69.565a2.75 2.75 0 0 1-.897.351c-.267.053-.541.053-.89.053h-.06c-.502 0-.84 0-1.1.02-.254.018-.377.05-.458.086a1.25 1.25 0 0 0-.641.64c-.036.082-.069.205-.087.458-.019.261-.019.599-.019 1.101v.39c0 .502 0 .84.02 1.1.017.255.05.377.086.458.126.287.354.515.64.641.082.036.205.069.458.087.261.019.599.019 1.101.019h.06c.349 0 .623 0 .89.053.318.063.621.182.897.35.233.143.435.33.69.565l.045.041L8.5 14.537V5.463Zm4.08.952a.75.75 0 0 1 1.005-.336c.705.353 1.182.986 1.478 1.67.298.688.437 1.48.437 2.251 0 .772-.14 1.563-.437 2.25-.296.685-.773 1.318-1.478 1.67a.75.75 0 1 1-.67-1.34c.295-.148.568-.453.772-.925.202-.468.313-1.052.313-1.655s-.11-1.187-.313-1.655c-.204-.472-.477-.777-.772-.924a.75.75 0 0 1-.336-1.006Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, aMe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="volume-medium">
    <path fill-rule="evenodd" d="M9.55 3.063c.274.12.45.39.45.687v12.5a.75.75 0 0 1-1.259.551l-2.372-2.19c-.32-.295-.408-.372-.499-.428a1.25 1.25 0 0 0-.408-.159c-.104-.02-.22-.024-.657-.024H4.78c-.47 0-.861 0-1.182-.023-.335-.024-.65-.076-.954-.21a2.75 2.75 0 0 1-1.41-1.41c-.134-.303-.186-.619-.21-.954C1 11.083 1 10.69 1 10.221V9.78c0-.47 0-.861.023-1.182.024-.335.076-.65.21-.954a2.75 2.75 0 0 1 1.41-1.41c.304-.134.619-.186.954-.21C3.917 6 4.309 6 4.779 6h.026c.437 0 .553-.003.657-.024a1.25 1.25 0 0 0 .408-.16c.09-.055.179-.132.5-.427l2.371-2.19a.75.75 0 0 1 .81-.136Zm-1.05 2.4L7.387 6.491l-.045.04c-.255.237-.457.423-.69.565a2.75 2.75 0 0 1-.897.351c-.267.053-.541.053-.89.053h-.06c-.502 0-.84 0-1.1.02-.254.017-.377.05-.458.086a1.25 1.25 0 0 0-.641.64c-.036.082-.069.205-.087.458-.019.261-.019.599-.019 1.101v.39c0 .502 0 .84.02 1.1.017.254.05.377.086.458.126.287.354.515.64.641.082.036.205.069.458.087.261.018.599.019 1.101.019h.06c.349 0 .623 0 .89.053.318.063.621.182.897.35.233.143.435.329.69.565l.045.041L8.5 14.537V5.463Zm4.08.952a.75.75 0 0 1 1.005-.336c.705.353 1.182.986 1.478 1.67.298.688.437 1.48.437 2.251 0 .772-.14 1.563-.437 2.25-.296.685-.773 1.318-1.478 1.67a.75.75 0 1 1-.67-1.34c.295-.148.568-.453.772-.925.202-.468.313-1.052.313-1.655s-.11-1.187-.313-1.655c-.204-.473-.477-.777-.772-.924a.75.75 0 0 1-.336-1.006Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, cMe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="volume-min">
    <path fill-rule="evenodd" d="M9.55 3.063c.274.12.45.39.45.687v12.5a.75.75 0 0 1-1.259.551l-2.372-2.19c-.32-.295-.408-.372-.499-.428a1.25 1.25 0 0 0-.408-.159c-.104-.02-.22-.024-.657-.024H4.78c-.47 0-.861 0-1.182-.023-.335-.024-.65-.076-.954-.21a2.75 2.75 0 0 1-1.41-1.41c-.134-.303-.186-.619-.21-.954C1 11.083 1 10.69 1 10.221V9.78c0-.47 0-.861.023-1.182.024-.335.076-.65.21-.954a2.75 2.75 0 0 1 1.41-1.41c.304-.134.619-.186.954-.21C3.917 6 4.309 6 4.779 6h.026c.437 0 .553-.003.657-.024a1.25 1.25 0 0 0 .408-.16c.09-.055.179-.132.5-.427l2.371-2.19a.75.75 0 0 1 .81-.136Zm-1.05 2.4L7.387 6.491l-.045.04c-.255.237-.457.423-.69.565a2.75 2.75 0 0 1-.897.351c-.267.053-.541.053-.89.053h-.06c-.502 0-.84 0-1.1.02-.254.017-.377.05-.458.086a1.25 1.25 0 0 0-.641.64c-.036.082-.069.205-.087.458-.019.261-.019.599-.019 1.101v.39c0 .502 0 .84.02 1.1.017.254.05.377.086.458.126.287.354.515.64.641.082.036.205.069.458.087.261.018.599.019 1.101.019h.06c.349 0 .623 0 .89.053.318.063.621.182.897.35.233.143.435.329.69.565l.045.041L8.5 14.537V5.463Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, dMe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="volume-mute">
    <path fill-rule="evenodd" d="M9.55 3.063c.274.12.45.39.45.687v12.5a.75.75 0 0 1-1.259.551l-2.372-2.19c-.32-.295-.408-.372-.499-.428a1.25 1.25 0 0 0-.408-.159c-.104-.02-.22-.024-.657-.024H4.78c-.47 0-.861 0-1.182-.023-.335-.024-.65-.076-.954-.21a2.75 2.75 0 0 1-1.41-1.41c-.134-.303-.186-.619-.21-.954C1 11.083 1 10.69 1 10.221V9.78c0-.47 0-.861.023-1.182.024-.335.076-.65.21-.954a2.75 2.75 0 0 1 1.41-1.41c.304-.134.619-.186.954-.21C3.917 6 4.309 6 4.779 6h.026c.437 0 .553-.003.657-.024a1.25 1.25 0 0 0 .408-.16c.09-.055.179-.132.5-.427l2.371-2.19a.75.75 0 0 1 .81-.136Zm-1.05 2.4L7.387 6.491l-.045.04c-.255.237-.457.423-.69.565a2.75 2.75 0 0 1-.897.351c-.267.053-.541.053-.89.053h-.06c-.502 0-.84 0-1.1.02-.254.017-.377.05-.458.086a1.25 1.25 0 0 0-.641.64c-.036.082-.069.205-.087.458-.019.261-.019.599-.019 1.101v.39c0 .502 0 .84.02 1.1.017.254.05.377.086.458.126.287.354.515.64.641.082.036.205.069.458.087.261.018.599.019 1.101.019h.06c.349 0 .623 0 .89.053.318.063.621.182.897.35.233.143.435.329.69.565l.045.041L8.5 14.537V5.463Zm4.72 1.757a.75.75 0 0 1 1.06 0L16 8.94l1.72-1.72a.75.75 0 1 1 1.06 1.06L17.06 10l1.72 1.72a.75.75 0 1 1-1.06 1.06L16 11.06l-1.72 1.72a.75.75 0 1 1-1.06-1.06L14.94 10l-1.72-1.72a.75.75 0 0 1 0-1.06Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, uMe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="wallet">
    <path fill-rule="evenodd" d="M1 3.75A2.75 2.75 0 0 1 3.75 1h9a.75.75 0 0 1 0 1.5h-9c-.69 0-1.25.56-1.25 1.25V4h13.75A2.75 2.75 0 0 1 19 6.75v9.5A2.75 2.75 0 0 1 16.25 19H3.75A2.75 2.75 0 0 1 1 16.25V3.75ZM2.5 5.5v10.75c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25v-9.5c0-.69-.56-1.25-1.25-1.25H2.5ZM14.25 11a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1Zm-2 .5a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, hMe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="warning-fill">
    <path fill-rule="evenodd" d="M12.448 3.386c-1.087-1.848-3.818-1.848-4.905 0L1.379 13.863C.274 15.742 1.702 18 3.832 18h12.327c2.13 0 3.558-2.258 2.453-4.137L12.448 3.386ZM9.25 15.25a.75.75 0 0 0 1.5 0v-1.5a.75.75 0 0 0-1.5 0v1.5Zm0-5a.75.75 0 0 0 1.5 0v-3.5a.75.75 0 0 0-1.5 0v3.5Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, gMe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="warning">
    <path fill-rule="evenodd" d="M11.162 4.147c-.508-.863-1.816-.863-2.323 0L2.672 14.624c-.473.803.101 1.876 1.161 1.876h12.334c1.06 0 1.634-1.073 1.161-1.876L11.162 4.147Zm-3.616-.761c1.088-1.848 3.82-1.848 4.908 0l6.167 10.477C19.727 15.742 18.298 18 16.167 18H3.833c-2.131 0-3.56-2.258-2.454-4.137L7.546 3.386ZM10 6a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 10 6Zm0 6a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0v-1.5A.75.75 0 0 1 10 12Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, pMe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="watch">
    <path fill-rule="evenodd" d="M8.032 1.534A.75.75 0 0 1 8.75 1h2.5a.75.75 0 0 1 .718.534l1.443 4.81c.366.341.68.737.93 1.173a.75.75 0 0 1 .537 1.38 5.016 5.016 0 0 1 0 2.205.75.75 0 0 1-.537 1.381 5.02 5.02 0 0 1-.93 1.172l-1.443 4.81a.75.75 0 0 1-.718.535h-2.5a.75.75 0 0 1-.718-.535l-1.443-4.81A4.986 4.986 0 0 1 5 10c0-1.443.611-2.743 1.589-3.656l1.443-4.81Zm.456 3.699A4.997 4.997 0 0 1 10 5c.527 0 1.035.082 1.512.233l-.82-2.733H9.308l-.82 2.733Zm0 9.534.82 2.733h1.384l.82-2.733A4.998 4.998 0 0 1 10 15a4.997 4.997 0 0 1-1.512-.233ZM10 6.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Zm0 .75a.75.75 0 0 1 .75.75v1.25h.5a.75.75 0 0 1 0 1.5H10a.75.75 0 0 1-.75-.75V8a.75.75 0 0 1 .75-.75Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, fMe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="water-drop">
    <path fill-rule="evenodd" d="M10 2a.75.75 0 0 1 .618.325c.956 1.39 1.917 2.417 2.808 3.37.362.386.711.76 1.045 1.14 1.135 1.297 2.029 2.64 2.029 4.592 0 3.732-2.869 6.823-6.5 6.823-3.632 0-6.5-3.1-6.5-6.823 0-1.948.894-3.29 2.03-4.588.332-.381.682-.756 1.044-1.142.89-.953 1.852-1.982 2.808-3.372A.75.75 0 0 1 10 2ZM6.658 7.826C5.606 9.03 5 10.025 5 11.426c0 2.975 2.274 5.324 5 5.324 2.727 0 5-2.34 5-5.323 0-1.407-.606-2.402-1.658-3.604-.281-.32-.598-.66-.94-1.024-.73-.781-1.57-1.68-2.402-2.771-.831 1.091-1.672 1.99-2.402 2.772-.341.365-.659.705-.94 1.026ZM6.5 11a.75.75 0 0 1 .75.75c0 1.336 1.164 2.5 2.5 2.5a.75.75 0 0 1 0 1.5c-2.164 0-4-1.836-4-4A.75.75 0 0 1 6.5 11Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, vMe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="wifi-off">
    <path fill-rule="evenodd" d="M1.198 1.242a.75.75 0 0 1 1.06-.044l2.338 2.153L17.74 14.68a.75.75 0 0 1-.98 1.137l-3.557-3.066a.754.754 0 0 1-.197-.125 4.573 4.573 0 0 0-6.012 0 .75.75 0 1 1-.988-1.129A6.053 6.053 0 0 1 10.011 10L7.52 7.851c-1.05.31-2.003.818-2.762 1.514A.75.75 0 1 1 3.743 8.26a8.21 8.21 0 0 1 2.466-1.538L3.975 4.797a8.162 8.162 0 0 0-1.731 1.142.75.75 0 1 1-.988-1.128 9.324 9.324 0 0 1 1.535-1.082L1.242 2.302a.75.75 0 0 1-.044-1.06Zm16.558 4.697c-2.353-2.058-6.542-2.858-10.31-2.23a.75.75 0 1 1-.246-1.48c4.044-.674 8.743.131 11.544 2.582a.75.75 0 0 1-.988 1.128Zm-6.556.855a.75.75 0 0 1 .884-.585c1.545.314 3.016.99 4.173 2.05a.75.75 0 0 1-1.014 1.106c-.924-.847-2.136-1.417-3.458-1.687a.75.75 0 0 1-.585-.884ZM10 15.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1ZM8 16a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, mMe = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g class="wifi">
    <path fill-rule="evenodd" d="M10 3.5c-3.014 0-5.938.848-7.756 2.44a.75.75 0 0 1-.988-1.13C3.438 2.903 6.764 2 10 2c3.236 0 6.562.902 8.744 2.81a.75.75 0 0 1-.988 1.13C15.938 4.347 13.014 3.5 10 3.5Zm0 4c-1.977 0-3.908.641-5.243 1.865A.75.75 0 1 1 3.743 8.26C5.408 6.734 7.727 6 10 6c2.273 0 4.592.734 6.257 2.26a.75.75 0 0 1-1.014 1.105C13.908 8.141 11.977 7.5 10 7.5Zm0 4a4.554 4.554 0 0 0-3.006 1.127.75.75 0 1 1-.988-1.129A6.054 6.054 0 0 1 10 10c1.425 0 2.852.499 3.994 1.498a.75.75 0 0 1-.988 1.129A4.554 4.554 0 0 0 10 11.5Zm0 4a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1ZM8 16a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z" class="Icon" clip-rule="evenodd"/>
  </g>
</svg>
`, CMe = /* @__PURE__ */ Object.assign({
  "../assets/icons/generic/20-fifthbar.svg": jpe,
  "../assets/icons/generic/20-save.svg": Wpe,
  "../assets/icons/generic/20-sidebar.svg": Upe,
  "../assets/icons/generic/add-to-folder.svg": Kpe,
  "../assets/icons/generic/browser.svg": qpe,
  "../assets/icons/generic/create-folder.svg": Ype,
  "../assets/icons/generic/dossier-module.svg": Qpe,
  "../assets/icons/generic/dossier.svg": Jpe,
  "../assets/icons/generic/dot.svg": Xpe,
  "../assets/icons/generic/file-small-archive.svg": e9e,
  "../assets/icons/generic/file-small-document.svg": t9e,
  "../assets/icons/generic/file-small-excel.svg": o9e,
  "../assets/icons/generic/file-small-figma.svg": n9e,
  "../assets/icons/generic/file-small-file.svg": s9e,
  "../assets/icons/generic/file-small-pdf.svg": i9e,
  "../assets/icons/generic/file-small-photoshop.svg": r9e,
  "../assets/icons/generic/file-small-sketch.svg": l9e,
  "../assets/icons/generic/file-small-spreadsheet.svg": a9e,
  "../assets/icons/generic/file-small-word.svg": c9e,
  "../assets/icons/generic/frame.svg": d9e,
  "../assets/icons/generic/handover.svg": u9e,
  "../assets/icons/generic/home.svg": h9e,
  "../assets/icons/generic/info.svg": g9e,
  "../assets/icons/generic/initial-avatar.svg": p9e,
  "../assets/icons/generic/operator-contains.svg": f9e,
  "../assets/icons/generic/operator-eq.svg": v9e,
  "../assets/icons/generic/operator-gt.svg": m9e,
  "../assets/icons/generic/operator-gte.svg": C9e,
  "../assets/icons/generic/operator-lt.svg": w9e,
  "../assets/icons/generic/operator-lte.svg": b9e,
  "../assets/icons/generic/operator-neq.svg": y9e,
  "../assets/icons/generic/operator-not-contains.svg": _9e,
  "../assets/icons/generic/size-l.svg": S9e,
  "../assets/icons/generic/size-m.svg": x9e,
  "../assets/icons/generic/size-s.svg": M9e,
  "../assets/icons/generic/vector.svg": A9e,
  "../assets/icons/phosphor/address-book.svg": L9e,
  "../assets/icons/phosphor/align-left-simple.svg": E9e,
  "../assets/icons/phosphor/align-left.svg": P9e,
  "../assets/icons/phosphor/arrow-bend-double-up-left.svg": R9e,
  "../assets/icons/phosphor/arrow-bend-up-left.svg": F9e,
  "../assets/icons/phosphor/arrow-bend-up-right.svg": T9e,
  "../assets/icons/phosphor/arrow-counter-clockwise.svg": I9e,
  "../assets/icons/phosphor/arrow-down.svg": D9e,
  "../assets/icons/phosphor/arrow-line-right.svg": k9e,
  "../assets/icons/phosphor/arrow-square-out.svg": H9e,
  "../assets/icons/phosphor/arrow-up.svg": V9e,
  "../assets/icons/phosphor/arrows-counter-clockwise.svg": O9e,
  "../assets/icons/phosphor/arrows-down-up.svg": B9e,
  "../assets/icons/phosphor/arrows-horizontal.svg": $9e,
  "../assets/icons/phosphor/arrows-in-line-horizontal.svg": Z9e,
  "../assets/icons/phosphor/arrows-in-line-vertical-menu.svg": G9e,
  "../assets/icons/phosphor/arrows-in-line-vertical.svg": N9e,
  "../assets/icons/phosphor/arrows-left-right.svg": z9e,
  "../assets/icons/phosphor/arrows-out-line-horizontal.svg": j9e,
  "../assets/icons/phosphor/arrows-out-line-vertical-menu.svg": W9e,
  "../assets/icons/phosphor/arrows-out-line-vertical.svg": U9e,
  "../assets/icons/phosphor/article-ny-times.svg": K9e,
  "../assets/icons/phosphor/at.svg": q9e,
  "../assets/icons/phosphor/bank.svg": Y9e,
  "../assets/icons/phosphor/barcode.svg": Q9e,
  "../assets/icons/phosphor/brackets-square.svg": J9e,
  "../assets/icons/phosphor/broom.svg": X9e,
  "../assets/icons/phosphor/browser.svg": efe,
  "../assets/icons/phosphor/building-apartment.svg": tfe,
  "../assets/icons/phosphor/building.svg": ofe,
  "../assets/icons/phosphor/calculator.svg": nfe,
  "../assets/icons/phosphor/calendar-blank.svg": sfe,
  "../assets/icons/phosphor/calendar-time.svg": ife,
  "../assets/icons/phosphor/caret-double-down.svg": rfe,
  "../assets/icons/phosphor/caret-double-right.svg": lfe,
  "../assets/icons/phosphor/caret-double-up.svg": afe,
  "../assets/icons/phosphor/caret-down-double-btn.svg": cfe,
  "../assets/icons/phosphor/caret-down.svg": dfe,
  "../assets/icons/phosphor/caret-left.svg": ufe,
  "../assets/icons/phosphor/caret-right-bold.svg": hfe,
  "../assets/icons/phosphor/caret-right-menu.svg": gfe,
  "../assets/icons/phosphor/caret-right.svg": pfe,
  "../assets/icons/phosphor/caret-top.svg": ffe,
  "../assets/icons/phosphor/caret-up.svg": vfe,
  "../assets/icons/phosphor/chart-line.svg": mfe,
  "../assets/icons/phosphor/check-circle.svg": Cfe,
  "../assets/icons/phosphor/check.svg": wfe,
  "../assets/icons/phosphor/circle-fill.svg": bfe,
  "../assets/icons/phosphor/circle.svg": yfe,
  "../assets/icons/phosphor/city.svg": _fe,
  "../assets/icons/phosphor/clipboard-text.svg": Sfe,
  "../assets/icons/phosphor/clock.svg": xfe,
  "../assets/icons/phosphor/code.svg": Mfe,
  "../assets/icons/phosphor/columns.svg": Afe,
  "../assets/icons/phosphor/copy.svg": Lfe,
  "../assets/icons/phosphor/cursor-text.svg": Efe,
  "../assets/icons/phosphor/dots-six-vertical.svg": Pfe,
  "../assets/icons/phosphor/dots-six.svg": Rfe,
  "../assets/icons/phosphor/dots-three-circle.svg": Ffe,
  "../assets/icons/phosphor/dots-three-vertical.svg": Tfe,
  "../assets/icons/phosphor/dots-three.svg": Ife,
  "../assets/icons/phosphor/download-simple.svg": Dfe,
  "../assets/icons/phosphor/envelope.svg": kfe,
  "../assets/icons/phosphor/equals.svg": Hfe,
  "../assets/icons/phosphor/eye-menu.svg": Vfe,
  "../assets/icons/phosphor/eye-slash.svg": Ofe,
  "../assets/icons/phosphor/eye.svg": Bfe,
  "../assets/icons/phosphor/file-empty.svg": $fe,
  "../assets/icons/phosphor/file-excel.svg": Zfe,
  "../assets/icons/phosphor/file-lock.svg": Gfe,
  "../assets/icons/phosphor/file-magnifying-glass.svg": Nfe,
  "../assets/icons/phosphor/file-minus.svg": zfe,
  "../assets/icons/phosphor/file-pdf.svg": jfe,
  "../assets/icons/phosphor/file-plus.svg": Wfe,
  "../assets/icons/phosphor/file-ppt.svg": Ufe,
  "../assets/icons/phosphor/file-video.svg": Kfe,
  "../assets/icons/phosphor/file-word.svg": qfe,
  "../assets/icons/phosphor/file-zip.svg": Yfe,
  "../assets/icons/phosphor/file.svg": Qfe,
  "../assets/icons/phosphor/flip-horizontal.svg": Jfe,
  "../assets/icons/phosphor/flip-vertical.svg": Xfe,
  "../assets/icons/phosphor/floppy-disk.svg": eve,
  "../assets/icons/phosphor/folder-minus.svg": tve,
  "../assets/icons/phosphor/folder-plus.svg": ove,
  "../assets/icons/phosphor/folder.svg": nve,
  "../assets/icons/phosphor/funnel-simple.svg": sve,
  "../assets/icons/phosphor/funnel.svg": ive,
  "../assets/icons/phosphor/gear.svg": rve,
  "../assets/icons/phosphor/globe.svg": lve,
  "../assets/icons/phosphor/greater-than-or-equal.svg": ave,
  "../assets/icons/phosphor/greater-than.svg": cve,
  "../assets/icons/phosphor/grid-nine.svg": dve,
  "../assets/icons/phosphor/hand-deposit.svg": uve,
  "../assets/icons/phosphor/hard-drives.svg": hve,
  "../assets/icons/phosphor/hash.svg": gve,
  "../assets/icons/phosphor/house.svg": pve,
  "../assets/icons/phosphor/image-square.svg": fve,
  "../assets/icons/phosphor/info.svg": vve,
  "../assets/icons/phosphor/key.svg": mve,
  "../assets/icons/phosphor/layout-duotone.svg": Cve,
  "../assets/icons/phosphor/layout.svg": wve,
  "../assets/icons/phosphor/less-than-or-equal.svg": bve,
  "../assets/icons/phosphor/less-than.svg": yve,
  "../assets/icons/phosphor/link.svg": _ve,
  "../assets/icons/phosphor/list-bullets.svg": Sve,
  "../assets/icons/phosphor/list-checks.svg": xve,
  "../assets/icons/phosphor/list-dashes.svg": Mve,
  "../assets/icons/phosphor/list-numbers.svg": Ave,
  "../assets/icons/phosphor/list-plus.svg": Lve,
  "../assets/icons/phosphor/list.svg": Eve,
  "../assets/icons/phosphor/lock-simple.svg": Pve,
  "../assets/icons/phosphor/magnifying-glass-minus.svg": Rve,
  "../assets/icons/phosphor/magnifying-glass-plus.svg": Fve,
  "../assets/icons/phosphor/magnifying-glass.svg": Tve,
  "../assets/icons/phosphor/mail.svg": Ive,
  "../assets/icons/phosphor/map-pin-simple-area.svg": Dve,
  "../assets/icons/phosphor/minus-circle-duotone.svg": kve,
  "../assets/icons/phosphor/minus-circle.svg": Hve,
  "../assets/icons/phosphor/more-horizontal.svg": Vve,
  "../assets/icons/phosphor/network.svg": Ove,
  "../assets/icons/phosphor/not-equals.svg": Bve,
  "../assets/icons/phosphor/note-pencil.svg": $ve,
  "../assets/icons/phosphor/notebook.svg": Zve,
  "../assets/icons/phosphor/number-square-four.svg": Gve,
  "../assets/icons/phosphor/number-square-one.svg": Nve,
  "../assets/icons/phosphor/number-square-three.svg": zve,
  "../assets/icons/phosphor/number-square-two.svg": jve,
  "../assets/icons/phosphor/paint-bucket.svg": Wve,
  "../assets/icons/phosphor/palette.svg": Uve,
  "../assets/icons/phosphor/paper-clip-horizontal.svg": Kve,
  "../assets/icons/phosphor/paper-plane-right.svg": qve,
  "../assets/icons/phosphor/paperclip.svg": Yve,
  "../assets/icons/phosphor/pencil-line.svg": Qve,
  "../assets/icons/phosphor/pencil-simple-line.svg": Jve,
  "../assets/icons/phosphor/pencil-simple.svg": Xve,
  "../assets/icons/phosphor/phone.svg": eme,
  "../assets/icons/phosphor/plug.svg": tme,
  "../assets/icons/phosphor/plus-circle.svg": ome,
  "../assets/icons/phosphor/plus.svg": nme,
  "../assets/icons/phosphor/printer.svg": sme,
  "../assets/icons/phosphor/push-pin.svg": ime,
  "../assets/icons/phosphor/question.svg": rme,
  "../assets/icons/phosphor/rows-plus-bottom.svg": lme,
  "../assets/icons/phosphor/rows-plus-top.svg": ame,
  "../assets/icons/phosphor/search.svg": cme,
  "../assets/icons/phosphor/sigma.svg": dme,
  "../assets/icons/phosphor/sign-in.svg": ume,
  "../assets/icons/phosphor/sign-out.svg": hme,
  "../assets/icons/phosphor/sliders-horizontal.svg": gme,
  "../assets/icons/phosphor/sparkle.svg": pme,
  "../assets/icons/phosphor/split-horizontal.svg": fme,
  "../assets/icons/phosphor/stack-minus.svg": vme,
  "../assets/icons/phosphor/stack-plus.svg": mme,
  "../assets/icons/phosphor/star.svg": Cme,
  "../assets/icons/phosphor/suit-case-simple.svg": wme,
  "../assets/icons/phosphor/swap.svg": bme,
  "../assets/icons/phosphor/table.svg": yme,
  "../assets/icons/phosphor/tabs.svg": _me,
  "../assets/icons/phosphor/text-align-center.svg": Sme,
  "../assets/icons/phosphor/text-align-justify.svg": xme,
  "../assets/icons/phosphor/text-align-left.svg": Mme,
  "../assets/icons/phosphor/text-align-right.svg": Ame,
  "../assets/icons/phosphor/text-b.svg": Lme,
  "../assets/icons/phosphor/text-columns.svg": Eme,
  "../assets/icons/phosphor/text-h.svg": Pme,
  "../assets/icons/phosphor/text-indent.svg": Rme,
  "../assets/icons/phosphor/text-italic-x.svg": Fme,
  "../assets/icons/phosphor/text-italic.svg": Tme,
  "../assets/icons/phosphor/text-outdent.svg": Ime,
  "../assets/icons/phosphor/text-t-slash.svg": Dme,
  "../assets/icons/phosphor/text-t.svg": kme,
  "../assets/icons/phosphor/textbox.svg": Hme,
  "../assets/icons/phosphor/timer.svg": Vme,
  "../assets/icons/phosphor/trash.svg": Ome,
  "../assets/icons/phosphor/tray.svg": Bme,
  "../assets/icons/phosphor/tree-structure.svg": $me,
  "../assets/icons/phosphor/tree-view.svg": Zme,
  "../assets/icons/phosphor/upload-simple.svg": Gme,
  "../assets/icons/phosphor/user-circle-dashed.svg": Nme,
  "../assets/icons/phosphor/user-gear.svg": zme,
  "../assets/icons/phosphor/user-plus.svg": jme,
  "../assets/icons/phosphor/user.svg": Wme,
  "../assets/icons/phosphor/user_circle.svg": Ume,
  "../assets/icons/phosphor/users-three.svg": Kme,
  "../assets/icons/phosphor/users.svg": qme,
  "../assets/icons/phosphor/warning-circle.svg": Yme,
  "../assets/icons/phosphor/x-circle.svg": Qme,
  "../assets/icons/phosphor/x.svg": Jme,
  "../assets/icons/tetrisly/16-alert-full.svg": Xme,
  "../assets/icons/tetrisly/16-arrowhead-down-small.svg": eCe,
  "../assets/icons/tetrisly/16-arrowhead-down.svg": tCe,
  "../assets/icons/tetrisly/16-arrowhead-left-small.svg": oCe,
  "../assets/icons/tetrisly/16-arrowhead-left.svg": nCe,
  "../assets/icons/tetrisly/16-arrowhead-right-small.svg": sCe,
  "../assets/icons/tetrisly/16-arrowhead-right.svg": iCe,
  "../assets/icons/tetrisly/16-arrowhead-top-small.svg": rCe,
  "../assets/icons/tetrisly/16-arrowhead-top.svg": lCe,
  "../assets/icons/tetrisly/16-bolt.svg": aCe,
  "../assets/icons/tetrisly/16-check.svg": cCe,
  "../assets/icons/tetrisly/16-chevron-down.svg": dCe,
  "../assets/icons/tetrisly/16-chevron-left.svg": uCe,
  "../assets/icons/tetrisly/16-chevron-right.svg": hCe,
  "../assets/icons/tetrisly/16-chevron-top.svg": gCe,
  "../assets/icons/tetrisly/16-close.svg": pCe,
  "../assets/icons/tetrisly/16-dot.svg": fCe,
  "../assets/icons/tetrisly/16-info.svg": vCe,
  "../assets/icons/tetrisly/16-minus.svg": mCe,
  "../assets/icons/tetrisly/16-plus.svg": CCe,
  "../assets/icons/tetrisly/20-file-icon-document.svg": wCe,
  "../assets/icons/tetrisly/20-file-icon-excel.svg": bCe,
  "../assets/icons/tetrisly/20-file-icon-figma.svg": yCe,
  "../assets/icons/tetrisly/20-file-icon-file.svg": _Ce,
  "../assets/icons/tetrisly/20-file-icon-pdf.svg": SCe,
  "../assets/icons/tetrisly/20-file-icon-psd.svg": xCe,
  "../assets/icons/tetrisly/20-file-icon-sketch.svg": MCe,
  "../assets/icons/tetrisly/20-file-icon-spreadsheet.svg": ACe,
  "../assets/icons/tetrisly/20-file-icon-word.svg": LCe,
  "../assets/icons/tetrisly/20-file-icon-zip.svg": ECe,
  "../assets/icons/tetrisly/32-file-Icon-psd.svg": PCe,
  "../assets/icons/tetrisly/32-file-icon-document.svg": RCe,
  "../assets/icons/tetrisly/32-file-icon-excel.svg": FCe,
  "../assets/icons/tetrisly/32-file-icon-figma.svg": TCe,
  "../assets/icons/tetrisly/32-file-icon-file.svg": ICe,
  "../assets/icons/tetrisly/32-file-icon-pdf.svg": DCe,
  "../assets/icons/tetrisly/32-file-icon-sketch.svg": kCe,
  "../assets/icons/tetrisly/32-file-icon-spreadsheet.svg": HCe,
  "../assets/icons/tetrisly/32-file-icon-word.svg": VCe,
  "../assets/icons/tetrisly/32-file-icon-zip.svg": OCe,
  "../assets/icons/tetrisly/accesibility.svg": BCe,
  "../assets/icons/tetrisly/activity.svg": $Ce,
  "../assets/icons/tetrisly/alarm-clock.svg": ZCe,
  "../assets/icons/tetrisly/alert-fill.svg": GCe,
  "../assets/icons/tetrisly/alert.svg": NCe,
  "../assets/icons/tetrisly/anchor.svg": zCe,
  "../assets/icons/tetrisly/apps.svg": jCe,
  "../assets/icons/tetrisly/archive.svg": WCe,
  "../assets/icons/tetrisly/arrow-down-left.svg": UCe,
  "../assets/icons/tetrisly/arrow-down-right.svg": KCe,
  "../assets/icons/tetrisly/arrow-down.svg": qCe,
  "../assets/icons/tetrisly/arrow-left.svg": YCe,
  "../assets/icons/tetrisly/arrow-right.svg": QCe,
  "../assets/icons/tetrisly/arrow-up-left.svg": JCe,
  "../assets/icons/tetrisly/arrow-up-right.svg": XCe,
  "../assets/icons/tetrisly/arrow-up.svg": ewe,
  "../assets/icons/tetrisly/arrowhead-down.svg": twe,
  "../assets/icons/tetrisly/arrowhead-left.svg": owe,
  "../assets/icons/tetrisly/arrowhead-right.svg": nwe,
  "../assets/icons/tetrisly/arrowhead-up.svg": swe,
  "../assets/icons/tetrisly/attachment.svg": iwe,
  "../assets/icons/tetrisly/background.svg": rwe,
  "../assets/icons/tetrisly/backspace.svg": lwe,
  "../assets/icons/tetrisly/backward.svg": awe,
  "../assets/icons/tetrisly/bank.svg": cwe,
  "../assets/icons/tetrisly/battery-charging.svg": dwe,
  "../assets/icons/tetrisly/battery-empty.svg": uwe,
  "../assets/icons/tetrisly/battery-full.svg": hwe,
  "../assets/icons/tetrisly/battery-low.svg": gwe,
  "../assets/icons/tetrisly/battery-medium.svg": pwe,
  "../assets/icons/tetrisly/bell.svg": fwe,
  "../assets/icons/tetrisly/block.svg": vwe,
  "../assets/icons/tetrisly/bluetooth-off.svg": mwe,
  "../assets/icons/tetrisly/bluetooth.svg": Cwe,
  "../assets/icons/tetrisly/bolt.svg": wwe,
  "../assets/icons/tetrisly/book.svg": bwe,
  "../assets/icons/tetrisly/bookmark.svg": ywe,
  "../assets/icons/tetrisly/border-all.svg": _we,
  "../assets/icons/tetrisly/border-bottom.svg": Swe,
  "../assets/icons/tetrisly/border-horizontal.svg": xwe,
  "../assets/icons/tetrisly/border-inner.svg": Mwe,
  "../assets/icons/tetrisly/border-left.svg": Awe,
  "../assets/icons/tetrisly/border-right.svg": Lwe,
  "../assets/icons/tetrisly/border-style.svg": Ewe,
  "../assets/icons/tetrisly/border-top.svg": Pwe,
  "../assets/icons/tetrisly/border-vertical.svg": Rwe,
  "../assets/icons/tetrisly/brackets-curly.svg": Fwe,
  "../assets/icons/tetrisly/brain.svg": Twe,
  "../assets/icons/tetrisly/broadcast.svg": Iwe,
  "../assets/icons/tetrisly/brush.svg": Dwe,
  "../assets/icons/tetrisly/bug.svg": kwe,
  "../assets/icons/tetrisly/bulb.svg": Hwe,
  "../assets/icons/tetrisly/calculator.svg": Vwe,
  "../assets/icons/tetrisly/calendar-check.svg": Owe,
  "../assets/icons/tetrisly/calendar-close.svg": Bwe,
  "../assets/icons/tetrisly/calendar-edit.svg": $we,
  "../assets/icons/tetrisly/calendar-minus.svg": Zwe,
  "../assets/icons/tetrisly/calendar-plus.svg": Gwe,
  "../assets/icons/tetrisly/calendar.svg": Nwe,
  "../assets/icons/tetrisly/camera.svg": zwe,
  "../assets/icons/tetrisly/card.svg": jwe,
  "../assets/icons/tetrisly/chart-bar-box.svg": Wwe,
  "../assets/icons/tetrisly/chart-bar.svg": Uwe,
  "../assets/icons/tetrisly/chart-line.svg": Kwe,
  "../assets/icons/tetrisly/chart-pie.svg": qwe,
  "../assets/icons/tetrisly/chat.svg": Ywe,
  "../assets/icons/tetrisly/check-badge-fill.svg": Qwe,
  "../assets/icons/tetrisly/check-badge.svg": Jwe,
  "../assets/icons/tetrisly/check-circle-fill.svg": Xwe,
  "../assets/icons/tetrisly/check-circle.svg": ebe,
  "../assets/icons/tetrisly/check-large.svg": tbe,
  "../assets/icons/tetrisly/check-small.svg": obe,
  "../assets/icons/tetrisly/chevron-down-small-circle.svg": nbe,
  "../assets/icons/tetrisly/chevron-down-small-fill.svg": sbe,
  "../assets/icons/tetrisly/chevron-down-small.svg": ibe,
  "../assets/icons/tetrisly/chevron-down.svg": rbe,
  "../assets/icons/tetrisly/chevron-left-small-circle.svg": lbe,
  "../assets/icons/tetrisly/chevron-left-small-fill.svg": abe,
  "../assets/icons/tetrisly/chevron-left-small.svg": cbe,
  "../assets/icons/tetrisly/chevron-left.svg": dbe,
  "../assets/icons/tetrisly/chevron-right-small-circle.svg": ube,
  "../assets/icons/tetrisly/chevron-right-small-fill.svg": hbe,
  "../assets/icons/tetrisly/chevron-right-small.svg": gbe,
  "../assets/icons/tetrisly/chevron-right.svg": pbe,
  "../assets/icons/tetrisly/chevron-up-small-circle.svg": fbe,
  "../assets/icons/tetrisly/chevron-up-small-fill.svg": vbe,
  "../assets/icons/tetrisly/chevron-up-small.svg": mbe,
  "../assets/icons/tetrisly/chevron-up.svg": Cbe,
  "../assets/icons/tetrisly/clipboard.svg": wbe,
  "../assets/icons/tetrisly/close.svg": bbe,
  "../assets/icons/tetrisly/cloud.svg": ybe,
  "../assets/icons/tetrisly/code-2.svg": _be,
  "../assets/icons/tetrisly/code.svg": Sbe,
  "../assets/icons/tetrisly/command.svg": xbe,
  "../assets/icons/tetrisly/comment.svg": Mbe,
  "../assets/icons/tetrisly/company.svg": Abe,
  "../assets/icons/tetrisly/compass.svg": Lbe,
  "../assets/icons/tetrisly/copy.svg": Ebe,
  "../assets/icons/tetrisly/cpu.svg": Pbe,
  "../assets/icons/tetrisly/crown.svg": Rbe,
  "../assets/icons/tetrisly/cursor-arrow-fill.svg": Fbe,
  "../assets/icons/tetrisly/cursor-arrow.svg": Tbe,
  "../assets/icons/tetrisly/cursor-text.svg": Ibe,
  "../assets/icons/tetrisly/database.svg": Dbe,
  "../assets/icons/tetrisly/delete.svg": kbe,
  "../assets/icons/tetrisly/desktop.svg": Hbe,
  "../assets/icons/tetrisly/devices.svg": Vbe,
  "../assets/icons/tetrisly/diamond.svg": Obe,
  "../assets/icons/tetrisly/dns.svg": Bbe,
  "../assets/icons/tetrisly/download.svg": $be,
  "../assets/icons/tetrisly/drag-drop-horizontal.svg": Zbe,
  "../assets/icons/tetrisly/drag-drop-vertical.svg": Gbe,
  "../assets/icons/tetrisly/edit.svg": Nbe,
  "../assets/icons/tetrisly/email.svg": zbe,
  "../assets/icons/tetrisly/emoji-big-smile.svg": jbe,
  "../assets/icons/tetrisly/emoji-sad.svg": Wbe,
  "../assets/icons/tetrisly/emoji-smile.svg": Ube,
  "../assets/icons/tetrisly/error-fill.svg": Kbe,
  "../assets/icons/tetrisly/error.svg": qbe,
  "../assets/icons/tetrisly/extension.svg": Ybe,
  "../assets/icons/tetrisly/eye-off.svg": Qbe,
  "../assets/icons/tetrisly/eye.svg": Jbe,
  "../assets/icons/tetrisly/file-check.svg": Xbe,
  "../assets/icons/tetrisly/file-close.svg": eye,
  "../assets/icons/tetrisly/file-edit.svg": tye,
  "../assets/icons/tetrisly/file-minus.svg": oye,
  "../assets/icons/tetrisly/file-plus.svg": nye,
  "../assets/icons/tetrisly/file.svg": sye,
  "../assets/icons/tetrisly/filter.svg": iye,
  "../assets/icons/tetrisly/fingerprint.svg": rye,
  "../assets/icons/tetrisly/fire.svg": lye,
  "../assets/icons/tetrisly/flag.svg": aye,
  "../assets/icons/tetrisly/folder-check.svg": cye,
  "../assets/icons/tetrisly/folder-close.svg": dye,
  "../assets/icons/tetrisly/folder-edit.svg": uye,
  "../assets/icons/tetrisly/folder-minus.svg": hye,
  "../assets/icons/tetrisly/folder-plus.svg": gye,
  "../assets/icons/tetrisly/folder.svg": pye,
  "../assets/icons/tetrisly/format-align-center.svg": fye,
  "../assets/icons/tetrisly/format-align-justify.svg": vye,
  "../assets/icons/tetrisly/format-align-left.svg": mye,
  "../assets/icons/tetrisly/format-align-right.svg": Cye,
  "../assets/icons/tetrisly/format-all-small-caps.svg": wye,
  "../assets/icons/tetrisly/format-bold.svg": bye,
  "../assets/icons/tetrisly/format-font-size.svg": yye,
  "../assets/icons/tetrisly/format-indent-decrease.svg": _ye,
  "../assets/icons/tetrisly/format-indent-increase.svg": Sye,
  "../assets/icons/tetrisly/format-italic.svg": xye,
  "../assets/icons/tetrisly/format-letter-spacing.svg": Mye,
  "../assets/icons/tetrisly/format-line-height.svg": Aye,
  "../assets/icons/tetrisly/format-lowercase.svg": Lye,
  "../assets/icons/tetrisly/format-paragraph-spacing.svg": Eye,
  "../assets/icons/tetrisly/format-scale-horizontal.svg": Pye,
  "../assets/icons/tetrisly/format-scale-vertical.svg": Rye,
  "../assets/icons/tetrisly/format-small-caps.svg": Fye,
  "../assets/icons/tetrisly/format-strikethrough.svg": Tye,
  "../assets/icons/tetrisly/format-subscript.svg": Iye,
  "../assets/icons/tetrisly/format-superscript.svg": Dye,
  "../assets/icons/tetrisly/format-titlecase.svg": kye,
  "../assets/icons/tetrisly/format-underline.svg": Hye,
  "../assets/icons/tetrisly/format-uppercase.svg": Vye,
  "../assets/icons/tetrisly/forward.svg": Oye,
  "../assets/icons/tetrisly/fullscreen-exit.svg": Bye,
  "../assets/icons/tetrisly/fullscreen.svg": $ye,
  "../assets/icons/tetrisly/function.svg": Zye,
  "../assets/icons/tetrisly/git-branch.svg": Gye,
  "../assets/icons/tetrisly/git-commit.svg": Nye,
  "../assets/icons/tetrisly/git-diff.svg": zye,
  "../assets/icons/tetrisly/git-fork.svg": jye,
  "../assets/icons/tetrisly/git-merge.svg": Wye,
  "../assets/icons/tetrisly/git-pull-request.svg": Uye,
  "../assets/icons/tetrisly/globe.svg": Kye,
  "../assets/icons/tetrisly/hashtag.svg": qye,
  "../assets/icons/tetrisly/heading.svg": Yye,
  "../assets/icons/tetrisly/headphones.svg": Qye,
  "../assets/icons/tetrisly/health.svg": Jye,
  "../assets/icons/tetrisly/heart.svg": Xye,
  "../assets/icons/tetrisly/help-fill.svg": e_e,
  "../assets/icons/tetrisly/help.svg": t_e,
  "../assets/icons/tetrisly/home.svg": o_e,
  "../assets/icons/tetrisly/horizontal-align-center.svg": n_e,
  "../assets/icons/tetrisly/horizontal-align-left.svg": s_e,
  "../assets/icons/tetrisly/horizontal-align-right.svg": i_e,
  "../assets/icons/tetrisly/hourglass.svg": r_e,
  "../assets/icons/tetrisly/image-check.svg": l_e,
  "../assets/icons/tetrisly/image-close.svg": a_e,
  "../assets/icons/tetrisly/image-edit.svg": c_e,
  "../assets/icons/tetrisly/image-minus.svg": d_e,
  "../assets/icons/tetrisly/image-plus.svg": u_e,
  "../assets/icons/tetrisly/image.svg": h_e,
  "../assets/icons/tetrisly/images.svg": g_e,
  "../assets/icons/tetrisly/inbox.svg": p_e,
  "../assets/icons/tetrisly/info-circle.svg": f_e,
  "../assets/icons/tetrisly/info-fill.svg": v_e,
  "../assets/icons/tetrisly/key.svg": m_e,
  "../assets/icons/tetrisly/keyboard.svg": C_e,
  "../assets/icons/tetrisly/label.svg": w_e,
  "../assets/icons/tetrisly/laptop.svg": b_e,
  "../assets/icons/tetrisly/layer-align-bottom-center.svg": y_e,
  "../assets/icons/tetrisly/layer-align-horizontal.svg": __e,
  "../assets/icons/tetrisly/layer-align-left-center.svg": S_e,
  "../assets/icons/tetrisly/layer-align-right-center.svg": x_e,
  "../assets/icons/tetrisly/layer-align-top-center.svg": M_e,
  "../assets/icons/tetrisly/layer-align-vertical.svg": A_e,
  "../assets/icons/tetrisly/layer-three.svg": L_e,
  "../assets/icons/tetrisly/layer-two.svg": E_e,
  "../assets/icons/tetrisly/layout-swap-horizontal.svg": P_e,
  "../assets/icons/tetrisly/layout-swap-vertical.svg": R_e,
  "../assets/icons/tetrisly/link-broken.svg": F_e,
  "../assets/icons/tetrisly/link.svg": T_e,
  "../assets/icons/tetrisly/list-bullet.svg": I_e,
  "../assets/icons/tetrisly/list-check.svg": D_e,
  "../assets/icons/tetrisly/list-ordered.svg": k_e,
  "../assets/icons/tetrisly/list-unordered.svg": H_e,
  "../assets/icons/tetrisly/lock.svg": V_e,
  "../assets/icons/tetrisly/log-in.svg": O_e,
  "../assets/icons/tetrisly/log-out.svg": B_e,
  "../assets/icons/tetrisly/mail.svg": $_e,
  "../assets/icons/tetrisly/map.svg": Z_e,
  "../assets/icons/tetrisly/marker-pin.svg": G_e,
  "../assets/icons/tetrisly/math-alpha.svg": N_e,
  "../assets/icons/tetrisly/math-angle.svg": z_e,
  "../assets/icons/tetrisly/math-beta.svg": j_e,
  "../assets/icons/tetrisly/math-gamma.svg": W_e,
  "../assets/icons/tetrisly/math-infinite.svg": U_e,
  "../assets/icons/tetrisly/math-omega.svg": K_e,
  "../assets/icons/tetrisly/math-pi.svg": q_e,
  "../assets/icons/tetrisly/math-sigma.svg": Y_e,
  "../assets/icons/tetrisly/math-sine-wawe.svg": Q_e,
  "../assets/icons/tetrisly/math-square-root .svg": J_e,
  "../assets/icons/tetrisly/math-theta.svg": X_e,
  "../assets/icons/tetrisly/megaphone.svg": eSe,
  "../assets/icons/tetrisly/menu.svg": tSe,
  "../assets/icons/tetrisly/message.svg": oSe,
  "../assets/icons/tetrisly/mic.svg": nSe,
  "../assets/icons/tetrisly/minus.svg": sSe,
  "../assets/icons/tetrisly/mobile.svg": iSe,
  "../assets/icons/tetrisly/more-horizontal.svg": rSe,
  "../assets/icons/tetrisly/more-vertical.svg": lSe,
  "../assets/icons/tetrisly/mouse.svg": aSe,
  "../assets/icons/tetrisly/navigation.svg": cSe,
  "../assets/icons/tetrisly/notification.svg": dSe,
  "../assets/icons/tetrisly/open-in-new.svg": uSe,
  "../assets/icons/tetrisly/option.svg": hSe,
  "../assets/icons/tetrisly/package.svg": gSe,
  "../assets/icons/tetrisly/paintroller.svg": pSe,
  "../assets/icons/tetrisly/paperplane.svg": fSe,
  "../assets/icons/tetrisly/paragraph.svg": vSe,
  "../assets/icons/tetrisly/pause-circle.svg": mSe,
  "../assets/icons/tetrisly/pause.svg": CSe,
  "../assets/icons/tetrisly/phone-call.svg": wSe,
  "../assets/icons/tetrisly/phone-callback.svg": bSe,
  "../assets/icons/tetrisly/phone-forwarded.svg": ySe,
  "../assets/icons/tetrisly/phone-incoming.svg": _Se,
  "../assets/icons/tetrisly/phone-missed.svg": SSe,
  "../assets/icons/tetrisly/phone-outgoing.svg": xSe,
  "../assets/icons/tetrisly/phone.svg": MSe,
  "../assets/icons/tetrisly/pin.svg": ASe,
  "../assets/icons/tetrisly/placeholder-2.svg": LSe,
  "../assets/icons/tetrisly/placeholder.svg": ESe,
  "../assets/icons/tetrisly/play-circle.svg": PSe,
  "../assets/icons/tetrisly/play.svg": RSe,
  "../assets/icons/tetrisly/plugin.svg": FSe,
  "../assets/icons/tetrisly/plus.svg": TSe,
  "../assets/icons/tetrisly/print.svg": ISe,
  "../assets/icons/tetrisly/questionmark.svg": DSe,
  "../assets/icons/tetrisly/quote.svg": kSe,
  "../assets/icons/tetrisly/rainbow.svg": HSe,
  "../assets/icons/tetrisly/receipt.svg": VSe,
  "../assets/icons/tetrisly/redo.svg": OSe,
  "../assets/icons/tetrisly/refresh.svg": BSe,
  "../assets/icons/tetrisly/repeat.svg": $Se,
  "../assets/icons/tetrisly/reply.svg": ZSe,
  "../assets/icons/tetrisly/robot.svg": GSe,
  "../assets/icons/tetrisly/scissors.svg": NSe,
  "../assets/icons/tetrisly/search.svg": zSe,
  "../assets/icons/tetrisly/settings.svg": jSe,
  "../assets/icons/tetrisly/share.svg": WSe,
  "../assets/icons/tetrisly/shield.svg": USe,
  "../assets/icons/tetrisly/shirt.svg": KSe,
  "../assets/icons/tetrisly/shopping-basket.svg": qSe,
  "../assets/icons/tetrisly/shopping-cart.svg": YSe,
  "../assets/icons/tetrisly/sidebar-hide.svg": QSe,
  "../assets/icons/tetrisly/sidebar-show.svg": JSe,
  "../assets/icons/tetrisly/slider.svg": XSe,
  "../assets/icons/tetrisly/speedmeter.svg": exe,
  "../assets/icons/tetrisly/star-filled.svg": txe,
  "../assets/icons/tetrisly/star-half-filled.svg": oxe,
  "../assets/icons/tetrisly/star.svg": nxe,
  "../assets/icons/tetrisly/stopwatch.svg": sxe,
  "../assets/icons/tetrisly/suitcase.svg": ixe,
  "../assets/icons/tetrisly/sun.svg": rxe,
  "../assets/icons/tetrisly/tablet.svg": lxe,
  "../assets/icons/tetrisly/tag.svg": axe,
  "../assets/icons/tetrisly/target-off.svg": cxe,
  "../assets/icons/tetrisly/target.svg": dxe,
  "../assets/icons/tetrisly/terminal-2.svg": uxe,
  "../assets/icons/tetrisly/terminal.svg": hxe,
  "../assets/icons/tetrisly/tetrisly.svg": gxe,
  "../assets/icons/tetrisly/text.svg": pxe,
  "../assets/icons/tetrisly/thumb-down.svg": fxe,
  "../assets/icons/tetrisly/thumb-up.svg": vxe,
  "../assets/icons/tetrisly/ticket.svg": mxe,
  "../assets/icons/tetrisly/time-clock.svg": Cxe,
  "../assets/icons/tetrisly/toggle-off.svg": wxe,
  "../assets/icons/tetrisly/toggle-on.svg": bxe,
  "../assets/icons/tetrisly/transaction-horizontal.svg": yxe,
  "../assets/icons/tetrisly/transaction-vertical.svg": _xe,
  "../assets/icons/tetrisly/tree.svg": Sxe,
  "../assets/icons/tetrisly/trend-down.svg": xxe,
  "../assets/icons/tetrisly/trend-up.svg": Mxe,
  "../assets/icons/tetrisly/turn-off.svg": Axe,
  "../assets/icons/tetrisly/tv.svg": Lxe,
  "../assets/icons/tetrisly/undo.svg": Exe,
  "../assets/icons/tetrisly/unfold-less.svg": Pxe,
  "../assets/icons/tetrisly/unfold-more.svg": Rxe,
  "../assets/icons/tetrisly/unlock.svg": Fxe,
  "../assets/icons/tetrisly/upload.svg": Txe,
  "../assets/icons/tetrisly/user-check.svg": Ixe,
  "../assets/icons/tetrisly/user-close.svg": Dxe,
  "../assets/icons/tetrisly/user-edit.svg": kxe,
  "../assets/icons/tetrisly/user-minus.svg": Hxe,
  "../assets/icons/tetrisly/user-plus.svg": Vxe,
  "../assets/icons/tetrisly/user.svg": Oxe,
  "../assets/icons/tetrisly/users.svg": Bxe,
  "../assets/icons/tetrisly/vertical-align-bottom.svg": $xe,
  "../assets/icons/tetrisly/vertical-align-center.svg": Zxe,
  "../assets/icons/tetrisly/vertical-align-top.svg": Gxe,
  "../assets/icons/tetrisly/video-camera.svg": Nxe,
  "../assets/icons/tetrisly/video.svg": zxe,
  "../assets/icons/tetrisly/view-boxes.svg": jxe,
  "../assets/icons/tetrisly/view-columns.svg": Wxe,
  "../assets/icons/tetrisly/view-dashboard.svg": Uxe,
  "../assets/icons/tetrisly/view-day.svg": Kxe,
  "../assets/icons/tetrisly/view-layout-bottom.svg": qxe,
  "../assets/icons/tetrisly/view-layout-grid.svg": Yxe,
  "../assets/icons/tetrisly/view-layout-left.svg": Qxe,
  "../assets/icons/tetrisly/view-layout-right.svg": Jxe,
  "../assets/icons/tetrisly/view-layout-top.svg": Xxe,
  "../assets/icons/tetrisly/view-lp.svg": eMe,
  "../assets/icons/tetrisly/view-rows.svg": tMe,
  "../assets/icons/tetrisly/view-schedule.svg": oMe,
  "../assets/icons/tetrisly/view-slider.svg": nMe,
  "../assets/icons/tetrisly/view-table.svg": sMe,
  "../assets/icons/tetrisly/voice.svg": iMe,
  "../assets/icons/tetrisly/voicemail.svg": rMe,
  "../assets/icons/tetrisly/volume-max.svg": lMe,
  "../assets/icons/tetrisly/volume-medium.svg": aMe,
  "../assets/icons/tetrisly/volume-min.svg": cMe,
  "../assets/icons/tetrisly/volume-mute.svg": dMe,
  "../assets/icons/tetrisly/wallet.svg": uMe,
  "../assets/icons/tetrisly/warning-fill.svg": hMe,
  "../assets/icons/tetrisly/warning.svg": gMe,
  "../assets/icons/tetrisly/watch.svg": pMe,
  "../assets/icons/tetrisly/water-drop.svg": fMe,
  "../assets/icons/tetrisly/wifi-off.svg": vMe,
  "../assets/icons/tetrisly/wifi.svg": mMe
}), Vt = Object.entries(CMe).reduce(
  (e, [t, o]) => {
    var r;
    const n = t.split("/"), s = `${n[n.length - 2] ?? ""}/${((r = n[n.length - 1]) == null ? void 0 : r.split(".svg")[0]) ?? ""}`, i = o.replace("<svg ", '<svg width="16" height="16" fill="currentColor" ');
    return { ...e, [s]: i };
  },
  {}
), wMe = "7", bMe = 1e4, yMe = /\/1\/invalid-[\w-]+\//;
let K0, YC = !1;
const _Me = () => window.tinymce, QC = () => {
  var t;
  const e = (t = _Me()) == null ? void 0 : t.baseURL;
  return typeof e != "string" || yMe.test(e);
}, SMe = () => {
  YC = !0;
}, xMe = () => new Promise((e) => {
  const t = document.createElement("script");
  t.referrerPolicy = "origin", t.type = "application/javascript", t.src = `https://cdn.tiny.cloud/1/${X5.apiKey}/tinymce/${wMe}/tinymce.min.js`;
  const o = () => {
    t.removeEventListener("load", n), t.removeEventListener("error", s);
  }, n = () => {
    window.clearTimeout(i), o(), e(!QC());
  }, s = () => {
    window.clearTimeout(i), o(), t.remove(), K0 = void 0, e(!1);
  }, i = window.setTimeout(s, bMe);
  t.addEventListener("load", n), t.addEventListener("error", s), document.head.appendChild(t);
}), MMe = () => YC || !X5.apiKey ? Promise.resolve(!1) : (K0 ?? (K0 = xMe()), K0), AMe = {
  undo: "phosphor/arrow-bend-up-left",
  redo: "phosphor/arrow-bend-up-right",
  bold: "phosphor/text-b",
  italic: "phosphor/text-italic",
  "highlight-bg-color": "phosphor/pencil-simple-line",
  link: "phosphor/link",
  "align-left": "phosphor/text-align-left",
  "align-center": "phosphor/text-align-center",
  "align-right": "phosphor/text-align-right",
  "align-justify": "phosphor/text-align-justify",
  "unordered-list": "phosphor/list-plus",
  "ordered-list": "phosphor/list-numbers",
  outdent: "phosphor/text-outdent",
  indent: "phosphor/text-indent",
  "remove-formatting": "phosphor/text-italic-x",
  help: "phosphor/question",
  sourcecode: "phosphor/code",
  "chevron-down": "phosphor/caret-down"
};
function LMe(e, t = 24) {
  const o = `width="${t}" height="${t}"`;
  return e.includes("width=") ? e.replace(/\bwidth="[^"]*"/, `width="${t}"`).replace(/\bheight="[^"]*"/, `height="${t}"`) : e.replace("<svg", `<svg ${o}`);
}
const EMe = 10, PMe = /* @__PURE__ */ pe({
  __name: "SCATinyMCEEditor",
  props: /* @__PURE__ */ Ct({
    readOnly: { type: Boolean, default: !1 },
    toolbarCode: { type: Boolean, default: !1 },
    locale: { default: "en" },
    stickyToolbarTop: { default: void 0 },
    unlimitedHeight: { type: Boolean, default: !1 },
    resizable: { type: Boolean, default: !1 },
    minHeight: {},
    maxHeight: { default: void 0 }
  }, {
    modelValue: { required: !1 },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Ct(["unusable"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const o = /tiny\.cloud\/docs\/tinymce\/[^\s"')]+\/invalid-api-key/, n = e, s = t, i = F(() => n.locale === "de" ? "de" : "en"), r = ct(e, "modelValue"), l = W(null);
    let a;
    const c = () => {
      var w, y;
      const m = (y = (w = l.value) == null ? void 0 : w.getBody) == null ? void 0 : y.call(w);
      m && (m.style.caretColor = n.readOnly ? "transparent" : "");
    }, d = (m) => {
      var w, y;
      return (((y = (w = m.notificationManager) == null ? void 0 : w.getNotifications) == null ? void 0 : y.call(w)) ?? []).some(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (b) => {
          var _, M, x;
          return o.test(
            String(((_ = b == null ? void 0 : b.settings) == null ? void 0 : _.text) ?? ((x = (M = b == null ? void 0 : b.getEl) == null ? void 0 : M.call(b)) == null ? void 0 : x.textContent) ?? "")
          );
        }
      );
    }, u = (m) => {
      var w, y;
      return QC() || d(m) || // A legitimately disabled editor also reports "readonly" here, so this half of the check must
      // stay opt-in — it only tells us something is wrong when we asked for an editable instance.
      !n.readOnly && ((y = (w = m.mode) == null ? void 0 : w.get) == null ? void 0 : y.call(w)) === "readonly";
    }, h = F(() => ({
      branding: !1,
      icons: "thin",
      skin: "borderless",
      content_style: zpe,
      onboarding: !1,
      plugins: "autoresize",
      min_height: n.minHeight,
      ...n.maxHeight === void 0 ? {} : { max_height: n.maxHeight },
      autoresize_bottom_margin: EMe,
      statusbar: !1,
      language: i.value,
      mobile: {
        menubar: !0
      },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      setup: (m) => {
        l.value = m;
        const w = () => {
          Object.entries(AMe).forEach(([y, b]) => {
            const _ = Vt[b];
            if (_) {
              const M = y === "chevron-down" ? 12 : 20;
              m.ui.registry.addIcon(y, LMe(_, M));
            }
          });
        };
        m.on("init", () => {
          if (u(m)) {
            l.value = null, SMe(), a = window.setTimeout(() => {
              m.remove(), s("unusable");
            });
            return;
          }
          w(), c();
          const y = m.getBody();
          y && (y.style.overflowY = n.stickyToolbarTop !== void 0 ? "hidden" : "");
        }), m.on("click", (y) => {
          const b = y.target;
          b.tagName === "A" && window.open(b.href, "_blank");
        });
      }
    }));
    Me(() => n.readOnly, c), Me(
      () => n.stickyToolbarTop,
      (m) => {
        var y, b;
        const w = (b = (y = l.value) == null ? void 0 : y.getBody) == null ? void 0 : b.call(y);
        w && (w.style.overflowY = m !== void 0 ? "hidden" : "");
      }
    ), ei(() => window.clearTimeout(a));
    const p = F(
      () => "autoresize advlist autolink lists link image charmap preview anchor searchreplace visualblocks code fullscreen insertdatetime table code help wordcount"
    ), C = F(() => {
      let m = "undo redo | formatselect | bold italic backcolor | link |      alignleft aligncenter alignright alignjustify |      bullist numlist outdent indent | removeformat | help | code";
      return n.toolbarCode ? `${m} | code` : m;
    });
    return (m, w) => (f(), v("div", {
      class: S([
        m.$style.editor,
        e.stickyToolbarTop ? m.$style.stickyToolbar : "",
        e.unlimitedHeight ? m.$style.unlimitedHeight : "",
        e.resizable ? m.$style.resizable : ""
      ]),
      style: Ge(e.stickyToolbarTop ? { "--notes-sticky-top": e.stickyToolbarTop } : void 0)
    }, [
      (f(), U(k(Npe), {
        key: i.value,
        modelValue: r.value,
        "onUpdate:modelValue": w[0] || (w[0] = (y) => r.value = y),
        init: h.value,
        disabled: e.readOnly,
        plugins: p.value,
        toolbar: C.value,
        "api-key": k(X5).apiKey
      }, null, 8, ["modelValue", "init", "disabled", "plugins", "toolbar", "api-key"]))
    ], 6));
  }
}), RMe = "_editor_1bbar_747", FMe = "_unlimitedHeight_1bbar_819", TMe = "_resizable_1bbar_823", IMe = "_stickyToolbar_1bbar_831", DMe = {
  editor: RMe,
  unlimitedHeight: FMe,
  resizable: TMe,
  stickyToolbar: IMe
}, kMe = {
  $style: DMe
}, HMe = /* @__PURE__ */ Ce(PMe, [["__cssModules", kMe]]), za = 191, ja = 500, VMe = /* @__PURE__ */ pe({
  __name: "SCARichText",
  props: /* @__PURE__ */ Ct({
    placeholder: { default: "" },
    readOnly: { type: Boolean, default: !1 },
    toolbarCode: { type: Boolean, default: !1 },
    locale: { default: "en" },
    stickyToolbarTop: { default: void 0 },
    unlimitedHeight: { type: Boolean, default: !1 },
    resizable: { type: Boolean, default: !1 }
  }, {
    modelValue: { required: !1 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, o = ct(e, "modelValue"), n = W("pending"), s = F(() => ({
      minHeight: `${za}px`,
      ...t.unlimitedHeight ? {} : { maxHeight: `${ja}px` }
    }));
    return At(async () => {
      n.value = await MMe() ? "cloud" : "plain";
    }), (i, r) => n.value === "pending" ? (f(), v("div", {
      key: 0,
      class: S(i.$style.pending),
      style: Ge(s.value)
    }, null, 6)) : n.value === "plain" ? (f(), U(Epe, {
      key: 1,
      modelValue: o.value,
      "onUpdate:modelValue": r[0] || (r[0] = (l) => o.value = l),
      "read-only": e.readOnly,
      resizable: e.resizable,
      "min-height": za,
      "max-height": e.unlimitedHeight ? void 0 : ja
    }, null, 8, ["modelValue", "read-only", "resizable", "max-height"])) : n.value === "cloud" ? (f(), U(HMe, {
      key: 2,
      modelValue: o.value,
      "onUpdate:modelValue": r[1] || (r[1] = (l) => o.value = l),
      "read-only": e.readOnly,
      "toolbar-code": e.toolbarCode,
      locale: e.locale,
      "sticky-toolbar-top": e.stickyToolbarTop,
      "unlimited-height": e.unlimitedHeight,
      resizable: e.resizable,
      "min-height": za,
      "max-height": e.unlimitedHeight ? void 0 : ja,
      onUnusable: r[2] || (r[2] = (l) => n.value = "plain")
    }, null, 8, ["modelValue", "read-only", "toolbar-code", "locale", "sticky-toolbar-top", "unlimited-height", "resizable", "max-height"])) : $("", !0);
  }
}), OMe = "_pending_xivjc_1", BMe = {
  pending: OMe
}, $Me = {
  $style: BMe
}, _st = /* @__PURE__ */ Ce(VMe, [["__cssModules", $Me]]), ZMe = /* @__PURE__ */ pe({
  __name: "SCAAlertBanner",
  props: {
    type: { default: void 0 },
    text: { default: void 0 }
  },
  emits: ["close"],
  setup(e, { emit: t }) {
    const o = e, n = t, s = F(() => {
      switch (o.type) {
        case "success":
          return "tetrisly/check-circle-fill";
        case "warning":
          return "tetrisly/warning-fill";
        case "error":
          return "tetrisly/alert-fill";
        default:
          return "tetrisly/info-fill";
      }
    });
    return (i, r) => (f(), v("div", {
      class: S([
        i.$style.root,
        {
          [i.$style.typeSuccess]: e.type === "success",
          [i.$style.typeWarning]: e.type === "warning",
          [i.$style.typeError]: e.type === "error"
        }
      ])
    }, [
      g("div", {
        class: S(i.$style.infoActionContainer)
      }, [
        g("div", {
          class: S(i.$style.container)
        }, [
          de(Ae, {
            class: S(i.$style.icon),
            icon: s.value
          }, null, 8, ["class", "icon"]),
          e.text ? (f(), v("div", {
            key: 0,
            class: S(i.$style.label)
          }, se(e.text), 3)) : $("", !0)
        ], 2),
        g("div", {
          class: S(i.$style.container)
        }, [
          ve(i.$slots, "default")
        ], 2)
      ], 2),
      de(ot, {
        icon: "tetrisly/close",
        type: "ghost",
        appearance: e.type === "warning" ? "reverseInverted" : "inverted",
        onClick: r[0] || (r[0] = (l) => n("close"))
      }, null, 8, ["appearance"])
    ], 2));
  }
}), GMe = "_root_y6hjr_747", NMe = "_typeSuccess_y6hjr_763", zMe = "_typeWarning_y6hjr_766", jMe = "_typeError_y6hjr_770", WMe = "_infoActionContainer_y6hjr_774", UMe = "_container_y6hjr_781", KMe = "_icon_y6hjr_787", qMe = {
  root: GMe,
  typeSuccess: NMe,
  typeWarning: zMe,
  typeError: jMe,
  infoActionContainer: WMe,
  container: UMe,
  icon: KMe
}, YMe = {
  $style: qMe
}, Sst = /* @__PURE__ */ Ce(ZMe, [["__cssModules", YMe]]), QMe = { key: 1 }, JMe = /* @__PURE__ */ pe({
  __name: "SCABadge",
  props: {
    appearance: { default: "blue" },
    emphasis: { default: "high" },
    iconBefore: { default: void 0 },
    iconAfter: { default: void 0 },
    size: { default: "medium" }
  },
  setup(e) {
    const t = e, o = Qt(), n = F(() => !!o.default), s = F(() => t.size === "small" ? "10px" : "16px");
    return (i, r) => (f(), v("div", {
      class: S([
        i.$style.badge,
        i.$style[`appearance_${e.appearance}_${e.emphasis}`],
        { [i.$style.iconOnly]: !n.value, [i.$style.small]: e.size === "small" }
      ])
    }, [
      e.iconBefore ? (f(), U(Ae, {
        key: 0,
        icon: e.iconBefore,
        size: s.value
      }, null, 8, ["icon", "size"])) : $("", !0),
      n.value ? (f(), v("div", QMe, [
        ve(i.$slots, "default")
      ])) : $("", !0),
      e.iconAfter ? (f(), U(Ae, {
        key: 2,
        icon: e.iconAfter,
        size: s.value
      }, null, 8, ["icon", "size"])) : $("", !0)
    ], 2));
  }
}), XMe = "_badge_evg09_747", eAe = "_appearance_blue_high_evg09_763", tAe = "_appearance_blue_medium_evg09_767", oAe = "_appearance_blue_low_evg09_771", nAe = "_appearance_green_high_evg09_775", sAe = "_appearance_green_medium_evg09_779", iAe = "_appearance_green_low_evg09_783", rAe = "_appearance_grey_high_evg09_787", lAe = "_appearance_grey_medium_evg09_791", aAe = "_appearance_grey_low_evg09_795", cAe = "_appearance_red_high_evg09_799", dAe = "_appearance_red_medium_evg09_803", uAe = "_appearance_red_low_evg09_807", hAe = "_appearance_orange_high_evg09_811", gAe = "_appearance_orange_medium_evg09_815", pAe = "_appearance_orange_low_evg09_819", fAe = "_appearance_raspberry_high_evg09_823", vAe = "_appearance_raspberry_medium_evg09_827", mAe = "_appearance_raspberry_low_evg09_831", CAe = "_appearance_magenta_high_evg09_835", wAe = "_appearance_magenta_medium_evg09_839", bAe = "_appearance_magenta_low_evg09_843", yAe = "_appearance_purple_high_evg09_847", _Ae = "_appearance_purple_medium_evg09_851", SAe = "_appearance_purple_low_evg09_855", xAe = "_appearance_grape_high_evg09_859", MAe = "_appearance_grape_medium_evg09_863", AAe = "_appearance_grape_low_evg09_867", LAe = "_appearance_violet_high_evg09_871", EAe = "_appearance_violet_medium_evg09_875", PAe = "_appearance_violet_low_evg09_879", RAe = "_appearance_cyan_high_evg09_883", FAe = "_appearance_cyan_medium_evg09_887", TAe = "_appearance_cyan_low_evg09_891", IAe = "_appearance_teal_high_evg09_895", DAe = "_appearance_teal_medium_evg09_899", kAe = "_appearance_teal_low_evg09_903", HAe = "_appearance_aquamarine_high_evg09_907", VAe = "_appearance_aquamarine_medium_evg09_911", OAe = "_appearance_aquamarine_low_evg09_915", BAe = "_appearance_emerald_high_evg09_919", $Ae = "_appearance_emerald_medium_evg09_923", ZAe = "_appearance_emerald_low_evg09_927", GAe = "_appearance_white_high_evg09_931", NAe = "_appearance_white_medium_evg09_935", zAe = "_appearance_white_low_evg09_939", jAe = "_iconOnly_evg09_943", WAe = "_small_evg09_946", UAe = {
  badge: XMe,
  appearance_blue_high: eAe,
  appearance_blue_medium: tAe,
  appearance_blue_low: oAe,
  appearance_green_high: nAe,
  appearance_green_medium: sAe,
  appearance_green_low: iAe,
  appearance_grey_high: rAe,
  appearance_grey_medium: lAe,
  appearance_grey_low: aAe,
  appearance_red_high: cAe,
  appearance_red_medium: dAe,
  appearance_red_low: uAe,
  appearance_orange_high: hAe,
  appearance_orange_medium: gAe,
  appearance_orange_low: pAe,
  appearance_raspberry_high: fAe,
  appearance_raspberry_medium: vAe,
  appearance_raspberry_low: mAe,
  appearance_magenta_high: CAe,
  appearance_magenta_medium: wAe,
  appearance_magenta_low: bAe,
  appearance_purple_high: yAe,
  appearance_purple_medium: _Ae,
  appearance_purple_low: SAe,
  appearance_grape_high: xAe,
  appearance_grape_medium: MAe,
  appearance_grape_low: AAe,
  appearance_violet_high: LAe,
  appearance_violet_medium: EAe,
  appearance_violet_low: PAe,
  appearance_cyan_high: RAe,
  appearance_cyan_medium: FAe,
  appearance_cyan_low: TAe,
  appearance_teal_high: IAe,
  appearance_teal_medium: DAe,
  appearance_teal_low: kAe,
  appearance_aquamarine_high: HAe,
  appearance_aquamarine_medium: VAe,
  appearance_aquamarine_low: OAe,
  appearance_emerald_high: BAe,
  appearance_emerald_medium: $Ae,
  appearance_emerald_low: ZAe,
  appearance_white_high: GAe,
  appearance_white_medium: NAe,
  appearance_white_low: zAe,
  iconOnly: jAe,
  small: WAe
}, KAe = {
  $style: UAe
}, xst = /* @__PURE__ */ Ce(JMe, [["__cssModules", KAe]]), qAe = /* @__PURE__ */ pe({
  __name: "SCAButtonGroup",
  setup(e) {
    const t = Qt();
    return (o, n) => (f(), v("div", {
      class: S(o.$style.buttonGroup)
    }, [
      t.default ? ve(o.$slots, "default", { key: 0 }) : $("", !0)
    ], 2));
  }
}), YAe = "_buttonGroup_hxxcf_747", QAe = {
  buttonGroup: YAe
}, JAe = {
  $style: QAe
}, Mst = /* @__PURE__ */ Ce(qAe, [["__cssModules", JAe]]), XAe = /* @__PURE__ */ pe({
  __name: "SCACheckbox",
  props: {
    disabled: { type: Boolean, default: !1 },
    checked: { type: Boolean, default: !1 },
    alert: { type: Boolean, default: !1 },
    label: { default: void 0 },
    helperText: { default: void 0 },
    required: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (t, o) => (f(), v("label", null, [
      g("div", {
        class: S(t.$style.grid)
      }, [
        de(Zo, {
          checked: e.checked,
          disabled: e.disabled,
          alert: e.alert
        }, {
          default: ee(() => [
            ve(t.$slots, "default")
          ]),
          _: 3
        }, 8, ["checked", "disabled", "alert"]),
        g("span", {
          class: S([{ [t.$style.required]: e.required }])
        }, se(e.label), 3)
      ], 2),
      e.helperText ? (f(), U(r1, {
        key: 0,
        intent: e.alert ? "alert" : void 0,
        class: S(t.$style.helperText)
      }, {
        default: ee(() => [
          Ve(se(e.helperText), 1)
        ]),
        _: 1
      }, 8, ["intent", "class"])) : $("", !0)
    ]));
  }
}), eLe = "_grid_rfxsu_747", tLe = "_helperText_rfxsu_762", oLe = "_disabled_rfxsu_767", nLe = {
  grid: eLe,
  helperText: tLe,
  disabled: oLe
}, sLe = {
  $style: nLe
}, iLe = /* @__PURE__ */ Ce(XAe, [["__cssModules", sLe]]), rLe = /* @__PURE__ */ pe({
  __name: "SCACheckboxGroup",
  props: {
    columns: { default: void 0 },
    label: { default: void 0 },
    labelPosition: { default: void 0 },
    optionalLabelText: { default: void 0 },
    appearance: { default: void 0 },
    helperText: { default: void 0 },
    validationError: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    htmlFor: { default: void 0 }
  },
  setup(e) {
    Vn((n) => ({
      v32d4f85e: o.value
    }));
    const t = e, o = F(() => t.columns ?? 1);
    return (n, s) => (f(), U(Is, {
      label: e.label,
      "label-position": e.labelPosition,
      "optional-label-text": e.optionalLabelText,
      appearance: e.appearance,
      "helper-text": e.helperText,
      "validation-error": e.validationError,
      required: e.required,
      "html-for": e.htmlFor,
      style: { "--sca-label-align": "flex-start" }
    }, {
      default: ee(() => [
        g("div", {
          class: S([n.$style.checkboxGrid, { [n.$style.columns]: e.columns }])
        }, [
          ve(n.$slots, "default")
        ], 2)
      ]),
      _: 3
    }, 8, ["label", "label-position", "optional-label-text", "appearance", "helper-text", "validation-error", "required", "html-for"]));
  }
}), lLe = "_checkboxGrid_rftxn_747", aLe = "_columns_rftxn_752", cLe = {
  checkboxGrid: lLe,
  columns: aLe
}, dLe = {
  $style: cLe
}, Ast = /* @__PURE__ */ Ce(rLe, [["__cssModules", dLe]]), uLe = ["draggable", "onClick", "onDragstart", "onMouseenter"], Wa = "itemKey", lr = "dragging-key/", hLe = /* @__PURE__ */ pe({
  __name: "SCADragAndDropList",
  props: {
    modelValue: {},
    disabled: { type: Boolean, default: !1 },
    dropGroup: { default: void 0 },
    itemClass: { default: void 0 },
    selectedId: { default: null },
    appearance: { default: "default" },
    isMobile: { type: Boolean, default: !1 },
    disabledForeignKeys: { default: void 0 }
  },
  emits: ["update:modelValue", "reordered", "select", "drag-start", "drag-end", "drop-foreign"],
  setup(e, { emit: t }) {
    const o = e, n = t, s = W(), i = W([]), r = W(!1), l = W(!1), a = W(null), c = W(null), d = W(null), u = oo(o, "modelValue", n, { passive: !0 }), h = (R, P, I) => {
      const B = P < 0 ? R.length + P : P;
      if (B >= 0 && B < R.length) {
        const H = I < 0 ? R.length + I : I, [O] = R.splice(P, 1);
        R.splice(H, 0, O);
      }
    }, p = () => {
      o.disabled || (l.value = !1, c.value = null, a.value = null, n("drag-end"));
    };
    At(() => {
      document.addEventListener("dragend", p, { passive: !0 });
    }), Qi(() => {
      window.removeEventListener("dragend", p);
    });
    const C = (R, P) => {
      if (!o.disabled) {
        if (!R.dataTransfer)
          throw new Error("Failed to drag/drop: dataTransfer not available");
        R.dataTransfer.dropEffect = "move", R.dataTransfer.effectAllowed = "move", R.dataTransfer.setData(Wa, P.key), R.dataTransfer.setData(`${lr}${P.key}`, ""), o.dropGroup && R.dataTransfer.setData(`drag-group/${o.dropGroup}`, ""), l.value = !0, c.value = P.key, n("drag-start");
      }
    }, m = (R) => u.value.findIndex((P) => P.key === R), w = (R) => {
      let P = !0, I = null;
      if (i.value.find(([H], O) => {
        if (!H) return !1;
        const N = H.getBoundingClientRect();
        return N.top <= R && N.bottom >= R ? (R - N.top > N.height / 2 && (P = !1), I = O, !0) : !1;
      }), I === null && i.value.length > 0) {
        const H = i.value[0][0].getBoundingClientRect(), O = i.value[i.value.length - 1][0].getBoundingClientRect();
        R < H.top ? (I = 0, P = !0) : R > O.bottom && (I = i.value.length - 1, P = !1);
      }
      return { index: I, offset: P ? 0 : 1 };
    }, y = (R) => {
      var B;
      if (o.disabled)
        return;
      if (!R.dataTransfer)
        throw new Error("Failed to drag/drop: dataTransfer not available");
      if (o.dropGroup && !R.dataTransfer.types.includes(`drag-group/${o.dropGroup}`)) {
        R.dataTransfer.dropEffect = "none", a.value = null;
        return;
      }
      if ((B = o.disabledForeignKeys) != null && B.length && R.dataTransfer.types.some(
        (H) => H.startsWith(lr) && o.disabledForeignKeys.some((O) => O.toLowerCase() === H.slice(lr.length))
      )) {
        R.dataTransfer.dropEffect = "none", document.body.style.cursor = "not-allowed", a.value = null;
        return;
      }
      document.body.style.cursor = "", R.dataTransfer.dropEffect = "move";
      const { index: P, offset: I } = w(R.clientY);
      a.value = P !== null ? P + I : null;
    }, b = () => {
      a.value = null, document.body.style.cursor = "";
    }, _ = W(!1), M = (R) => {
      var P;
      if (!(o.disabled || !R.dataTransfer)) {
        if (o.dropGroup && !R.dataTransfer.types.includes(`drag-group/${o.dropGroup}`)) {
          R.dataTransfer.dropEffect = "none", _.value = !1;
          return;
        }
        if ((P = o.disabledForeignKeys) != null && P.length && R.dataTransfer.types.some(
          (I) => I.startsWith(lr) && o.disabledForeignKeys.some((B) => B.toLowerCase() === I.slice(lr.length))
        )) {
          R.dataTransfer.dropEffect = "none", document.body.style.cursor = "not-allowed", _.value = !1;
          return;
        }
        R.dataTransfer.dropEffect = "move", document.body.style.cursor = "", _.value = !0;
      }
    }, x = () => {
      _.value = !1, document.body.style.cursor = "";
    }, L = (R) => {
      var I;
      if (_.value = !1, o.disabled || !R.dataTransfer || o.dropGroup && !R.dataTransfer.types.includes(`drag-group/${o.dropGroup}`)) return;
      const P = R.dataTransfer.getData(Wa);
      if ((I = o.disabledForeignKeys) != null && I.includes(P)) {
        document.body.style.cursor = "";
        return;
      }
      n("drop-foreign", P, 0), l.value = !1, document.body.style.cursor = "";
    }, A = (R) => {
      var B;
      if (o.disabled)
        return;
      if (!R.dataTransfer)
        throw new Error("Failed to drag/drop: dataTransfer not available");
      if (o.dropGroup && !R.dataTransfer.types.includes(`drag-group/${o.dropGroup}`)) return;
      const P = R.dataTransfer.getData(Wa), I = m(P);
      if (I === -1 && ((B = o.disabledForeignKeys) != null && B.includes(P))) {
        l.value = !1, a.value = null, document.body.style.cursor = "";
        return;
      }
      if (I !== -1) {
        const { index: H, offset: O } = w(R.clientY);
        if (H === null) return;
        let N = H + O;
        I < H && (N = H + O - 1), I > H && (N = H + O), h(u.value, I, N), n("reordered", P, I, N);
      } else {
        const { index: H, offset: O } = w(R.clientY);
        let N;
        H === null ? N = u.value.length : N = H + O, n("drop-foreign", P, N);
      }
      l.value = !1, document.body.style.cursor = "", a.value = null;
    };
    return (R, P) => (f(), v("div", null, [
      k(u).length > 0 ? (f(), v("div", {
        key: 0,
        ref_key: "dropzoneRef",
        ref: s,
        class: S(R.$style.dropzone),
        onDrop: A,
        onDragenter: P[4] || (P[4] = xe(() => {
        }, ["prevent"])),
        onDragover: xe(y, ["prevent"]),
        onDragleave: xe(b, ["prevent"])
      }, [
        (f(!0), v(we, null, Ze(k(u), (I, B) => (f(), v("div", {
          ref_for: !0,
          ref: (H) => i.value[B] = [H, I],
          key: I.key,
          class: S([
            R.$style.element,
            e.itemClass,
            {
              [R.$style.selected]: e.selectedId === I.key,
              [R.$style.indicateDrop]: a.value === B || a.value !== null && a.value >= k(u).length && B === k(u).length - 1,
              [R.$style.dropAfter]: a.value !== null && a.value >= k(u).length && B === k(u).length - 1
            }
          ]),
          draggable: !e.disabled && r.value,
          onClick: (H) => R.$emit("select", I.key),
          onDragstart: (H) => C(H, I),
          onDragend: P[0] || (P[0] = (H) => r.value = !1),
          onMousedown: P[1] || (P[1] = (H) => r.value = !0),
          onMouseup: P[2] || (P[2] = (H) => r.value = !1),
          onMouseenter: (H) => d.value = I.key,
          onMouseleave: P[3] || (P[3] = (H) => d.value = null)
        }, [
          !e.isMobile && !e.disabled && (e.appearance === "default" || d.value === I.key || l.value && c.value === I.key) ? (f(), v("div", {
            key: 0,
            "data-handle": "true",
            class: S(R.$style.dragHandle)
          }, [
            de(Ae, { icon: "phosphor/dots-six-vertical" })
          ], 2)) : $("", !0),
          e.isMobile || e.appearance === "minimal" && !(d.value === I.key || l.value && c.value === I.key) ? (f(), v("div", {
            key: 1,
            class: S(R.$style.index)
          }, se(B + 1), 3)) : $("", !0),
          ve(R.$slots, "default", {
            key: I.key,
            index: B,
            data: I.data
          }, () => [
            g("div", null, se(I.key), 1)
          ])
        ], 42, uLe))), 128))
      ], 34)) : (f(), v("div", {
        key: 1,
        class: S([R.$style.emptyDropzone, { [R.$style.emptyDropzoneActive]: _.value }]),
        onDrop: L,
        onDragenter: P[5] || (P[5] = xe((I) => _.value = !0, ["prevent"])),
        onDragover: xe(M, ["prevent"]),
        onDragleave: xe(x, ["prevent"])
      }, [
        de(k(tr))
      ], 34))
    ]));
  }
}), gLe = "_emptyDropzone_5h88h_1", pLe = "_emptyDropzoneActive_5h88h_6", fLe = "_element_5h88h_10", vLe = "_dragHandle_5h88h_20", mLe = "_index_5h88h_27", CLe = "_indicateDrop_5h88h_33", wLe = "_dropAfter_5h88h_43", bLe = "_selected_5h88h_47", yLe = {
  emptyDropzone: gLe,
  emptyDropzoneActive: pLe,
  element: fLe,
  dragHandle: vLe,
  index: mLe,
  indicateDrop: CLe,
  dropAfter: wLe,
  selected: bLe
}, _Le = {
  $style: yLe
}, Lst = /* @__PURE__ */ Ce(hLe, [["__cssModules", _Le]]), SLe = ["draggable", "onDragstart", "onDragover", "onDrop", "onDragenter", "onDragleave", "onClick"], xLe = { class: "icon" }, MLe = ["checked", "onClick"], ALe = /* @__PURE__ */ pe({
  __name: "SCAFileGallery",
  props: {
    items: {},
    keyExtractor: {},
    iconExtractor: {},
    nameExtractor: {},
    isFolder: {},
    handleDragStart: {},
    selectedItems: {},
    loading: { type: Boolean, default: !1 },
    draggable: { type: Boolean, default: !0 }
  },
  emits: ["update:selected-items", "item-click", "drop-on-item", "drop-on-container"],
  setup(e, { emit: t }) {
    const o = e, n = t, s = H5(), i = W(null), r = W(null), l = W(!1);
    function a(b) {
      const _ = o.selectedItems.indexOf(b);
      let M;
      _ === -1 ? M = [...o.selectedItems, b] : M = o.selectedItems.filter((x) => x !== b), n("update:selected-items", M);
    }
    function c(b) {
      n("item-click", b);
    }
    function d(b, _) {
      _.dataTransfer && (_.dataTransfer.dropEffect = _.dataTransfer.types.includes("Files") ? "copy" : "move");
      const M = _.currentTarget.getBoundingClientRect(), x = _.clientY - M.top, L = M.height;
      o.isFolder(b) ? i.value = "on" : i.value = x < L / 2 ? "top" : "bottom", r.value = o.keyExtractor(b);
    }
    function u(b) {
      r.value = o.keyExtractor(b);
    }
    function h(b, _) {
      const M = _.relatedTarget;
      M != null && M.closest(`.${s.galleryItem}`) || (r.value = null, i.value = null);
    }
    function p(b, _) {
      n("drop-on-item", {
        targetItem: b,
        position: i.value,
        event: _
      }), r.value = null, i.value = null, l.value = !1;
    }
    function C(b) {
      b.preventDefault(), b.dataTransfer && (b.dataTransfer.dropEffect = b.dataTransfer.types.includes("Files") ? "copy" : "move");
    }
    function m() {
      l.value = !0;
    }
    function w(b) {
      const _ = b.currentTarget, M = b.relatedTarget;
      _.contains(M) || (l.value = !1);
    }
    function y(b) {
      n("drop-on-container", { event: b }), l.value = !1;
    }
    return (b, _) => (f(), U(k(g2), {
      loading: e.loading,
      overlay: "",
      class: S(b.$style.galleryContainer),
      onDragover: xe(C, ["prevent"]),
      onDrop: xe(y, ["prevent"]),
      onDragenter: xe(m, ["prevent"]),
      onDragleave: xe(w, ["prevent"])
    }, {
      default: ee(() => [
        g("div", {
          class: S(b.$style.galleryGrid)
        }, [
          (f(!0), v(we, null, Ze(e.items, (M) => (f(), v("div", {
            key: e.keyExtractor(M),
            class: S([
              b.$style.galleryItem,
              { [b.$style.selected]: e.selectedItems.includes(e.keyExtractor(M)) },
              { [b.$style.dragOverTop]: r.value === e.keyExtractor(M) && i.value === "top" },
              { [b.$style.dragOverBottom]: r.value === e.keyExtractor(M) && i.value === "bottom" },
              { [b.$style.dragOverOn]: r.value === e.keyExtractor(M) && i.value === "on" }
            ]),
            draggable: e.draggable,
            onDragstart: (x) => e.handleDragStart(M.id, x),
            onDragover: xe((x) => d(M, x), ["prevent"]),
            onDrop: xe((x) => p(M, x), ["prevent", "stop"]),
            onDragenter: (x) => u(M),
            onDragleave: (x) => h(M, x),
            onClick: (x) => c(M)
          }, [
            de(k(Ae), {
              icon: e.iconExtractor(M),
              size: "45px"
            }, null, 8, ["icon"]),
            g("div", xLe, [
              de(k(Zo), {
                checked: e.selectedItems.includes(e.keyExtractor(M)),
                class: S(b.$style.checkbox),
                onClick: xe((x) => a(e.keyExtractor(M)), ["stop"])
              }, {
                default: ee(() => [
                  g("input", {
                    type: "checkbox",
                    checked: e.selectedItems.includes(e.keyExtractor(M)),
                    onClick: xe((x) => a(e.keyExtractor(M)), ["stop"])
                  }, null, 8, MLe)
                ]),
                _: 2
              }, 1032, ["checked", "class", "onClick"])
            ]),
            g("div", {
              class: S(b.$style.name)
            }, se(e.nameExtractor(M)), 3)
          ], 42, SLe))), 128))
        ], 2),
        e.items.length === 0 && !e.loading ? (f(), v("div", {
          key: 0,
          class: S([b.$style.empty, { [b.$style.emptyDragOver]: l.value }])
        }, [
          de(k(tr), {
            title: b.$t("common.emptyState.empty2")
          }, null, 8, ["title"])
        ], 2)) : $("", !0)
      ]),
      _: 1
    }, 8, ["loading", "class"]));
  }
}), LLe = "_galleryContainer_185wn_1", ELe = "_galleryGrid_185wn_6", PLe = "_galleryItem_185wn_12", RLe = "_selected_185wn_25", FLe = "_dragOverTop_185wn_31", TLe = "_dragOverBottom_185wn_34", ILe = "_dragOverOn_185wn_37", DLe = "_icon_185wn_41", kLe = "_name_185wn_46", HLe = "_checkbox_185wn_62", VLe = "_empty_185wn_68", OLe = "_emptyDragOver_185wn_76", BLe = {
  galleryContainer: LLe,
  galleryGrid: ELe,
  galleryItem: PLe,
  selected: RLe,
  dragOverTop: FLe,
  dragOverBottom: TLe,
  dragOverOn: ILe,
  icon: DLe,
  name: kLe,
  checkbox: HLe,
  empty: VLe,
  emptyDragOver: OLe
}, $Le = {
  $style: BLe
}, Est = /* @__PURE__ */ Ce(ALe, [["__cssModules", $Le]]), ZLe = pe({ inheritAttrs: !1 }), GLe = /* @__PURE__ */ pe({
  ...ZLe,
  __name: "SCAFilterSetItem",
  props: {
    disabled: { type: Boolean, default: !1 },
    isMobile: { type: Boolean, default: !1 },
    selected: { type: Boolean, default: !1 },
    editable: { type: Boolean, default: !1 },
    tooltip: { default: void 0 },
    as: { default: "div" }
  },
  emits: ["click", "edit"],
  setup(e, { emit: t }) {
    const o = iS(), n = Ns(), s = W(!1), i = t;
    return (r, l) => (f(), v(we, null, [
      (f(), U(Po(e.as), Bt({ id: k(n) }, k(o), {
        tabindex: "0",
        class: [
          r.$style.filterSetItem,
          {
            [r.$style.selected]: e.selected,
            [r.$style.hovered]: s.value,
            [r.$style.mobile]: e.isMobile
          }
        ],
        onClick: l[1] || (l[1] = (a) => i("click", a)),
        onMouseover: l[2] || (l[2] = (a) => s.value = !0),
        onMouseleave: l[3] || (l[3] = (a) => s.value = !1)
      }), {
        default: ee(() => [
          g("div", {
            class: S(r.$style.content)
          }, [
            ve(r.$slots, "default")
          ], 2),
          Et(g("div", {
            class: S([
              r.$style.editIcon,
              {
                [r.$style.selected]: e.selected,
                [r.$style.hovered]: s.value,
                [r.$style.mobile]: e.isMobile
              }
            ]),
            onClick: l[0] || (l[0] = xe((a) => i("edit"), ["stop"]))
          }, [
            de(Ae, {
              icon: "phosphor/pencil-simple",
              size: "12px"
            })
          ], 2), [
            [Hi, e.editable && (s.value || e.isMobile)]
          ])
        ]),
        _: 3
      }, 16, ["id", "class"])),
      e.tooltip ? (f(), U(bo, {
        key: 0,
        id: k(n),
        text: e.tooltip ?? ""
      }, null, 8, ["id", "text"])) : $("", !0)
    ], 64));
  }
}), NLe = "_filterSetItem_1sb8m_747", zLe = "_content_1sb8m_769", jLe = "_editIcon_1sb8m_775", WLe = "_mobile_1sb8m_793", ULe = "_hovered_1sb8m_805", KLe = "_selected_1sb8m_814", qLe = {
  filterSetItem: NLe,
  content: zLe,
  editIcon: jLe,
  mobile: WLe,
  hovered: ULe,
  selected: KLe
}, YLe = {
  $style: qLe
}, x1 = /* @__PURE__ */ Ce(GLe, [["__cssModules", YLe]]), QLe = /* @__PURE__ */ pe({
  __name: "SCAInlineBanner",
  props: {
    type: { default: void 0 },
    title: { default: void 0 },
    description: { default: void 0 },
    hasCloseButton: { type: Boolean, default: !1 },
    noIcon: { type: Boolean, default: !1 },
    icon: { default: void 0 }
  },
  emits: ["close"],
  setup(e, { emit: t }) {
    const o = e, n = t, s = F(() => {
      if (o.icon)
        return o.icon;
      switch (o.type) {
        case "informative":
          return "tetrisly/info-fill";
        case "success":
          return "tetrisly/check-circle-fill";
        case "warning":
          return "tetrisly/warning-fill";
        case "error":
          return "tetrisly/alert-fill";
        default:
          return "tetrisly/info-fill";
      }
    });
    return (i, r) => (f(), v("div", {
      class: S([
        i.$style.root,
        {
          [i.$style.typeInformative]: e.type === "informative",
          [i.$style.typeSuccess]: e.type === "success",
          [i.$style.typeWarning]: e.type === "warning",
          [i.$style.typeError]: e.type === "error",
          [i.$style.closeButtonPadding]: e.hasCloseButton
        }
      ])
    }, [
      e.noIcon ? $("", !0) : (f(), U(Ae, {
        key: 0,
        class: S(i.$style.icon),
        icon: s.value
      }, null, 8, ["class", "icon"])),
      g("div", {
        class: S(i.$style.contentContainer)
      }, [
        e.title || e.description ? (f(), v(we, { key: 0 }, [
          e.title ? (f(), v("div", {
            key: 0,
            class: S(i.$style.title)
          }, se(e.title), 3)) : $("", !0),
          e.description ? (f(), v("div", {
            key: 1,
            class: S(i.$style.description)
          }, se(e.description), 3)) : $("", !0)
        ], 64)) : $("", !0),
        g("div", {
          class: S(i.$style.actionContainer)
        }, [
          i.$slots.default ? ve(i.$slots, "default", { key: 0 }) : $("", !0)
        ], 2)
      ], 2),
      e.hasCloseButton ? (f(), U(ot, {
        key: 1,
        class: S(i.$style.closeButton),
        icon: "tetrisly/close",
        type: "ghost",
        appearance: "secondary",
        size: "small",
        onClick: r[0] || (r[0] = (l) => n("close"))
      }, null, 8, ["class"])) : $("", !0)
    ], 2));
  }
}), JLe = "_root_1hc8d_747", XLe = "_closeButtonPadding_1hc8d_766", eEe = "_typeInformative_1hc8d_769", tEe = "_title_1hc8d_774", oEe = "_typeSuccess_1hc8d_777", nEe = "_typeWarning_1hc8d_785", sEe = "_typeError_1hc8d_793", iEe = "_description_1hc8d_812", rEe = "_contentContainer_1hc8d_822", lEe = "_closeButton_1hc8d_766", aEe = "_actionContainer_1hc8d_836", cEe = "_icon_1hc8d_855", dEe = {
  root: JLe,
  closeButtonPadding: XLe,
  typeInformative: eEe,
  title: tEe,
  typeSuccess: oEe,
  typeWarning: nEe,
  typeError: sEe,
  description: iEe,
  contentContainer: rEe,
  closeButton: lEe,
  actionContainer: aEe,
  icon: cEe
}, uEe = {
  $style: dEe
}, hEe = /* @__PURE__ */ Ce(QLe, [["__cssModules", uEe]]), gEe = ["disabled"], pEe = ["data-text"], fEe = /* @__PURE__ */ pe({
  __name: "SCATab",
  props: {
    icon: { default: void 0 },
    selected: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    type: { default: "default" },
    dot: { type: Boolean, default: !1 },
    label: { default: void 0 }
  },
  setup(e) {
    const t = Qt();
    return (o, n) => (f(), v("button", {
      class: S([
        o.$style.button,
        {
          [o.$style.typeDefault]: e.type === "default",
          [o.$style.typeGhost]: e.type === "ghost",
          [o.$style.selected]: e.selected
        }
      ]),
      type: "button",
      disabled: e.disabled
    }, [
      g("div", {
        class: S(o.$style.container)
      }, [
        e.icon ? (f(), U(Ae, {
          key: 0,
          size: "20px",
          class: S(o.$style.icon),
          icon: e.icon
        }, null, 8, ["class", "icon"])) : $("", !0),
        k(t).default ? (f(), v("div", {
          key: 1,
          class: S(o.$style.lblContainer)
        }, [
          g("span", {
            class: S(o.$style.lblText),
            "data-text": e.label
          }, [
            g("span", {
              class: S(o.$style.lblTextInner)
            }, [
              ve(o.$slots, "default")
            ], 2)
          ], 10, pEe),
          e.dot ? (f(), v("div", {
            key: 0,
            class: S(o.$style.dotContainer)
          }, [
            de(Ae, {
              class: S(o.$style.dotIcon),
              size: "6px",
              icon: "generic/dot"
            }, null, 8, ["class"])
          ], 2)) : $("", !0)
        ], 2)) : $("", !0)
      ], 2)
    ], 10, gEe));
  }
}), vEe = "_icon_g2b89_747", mEe = "_dotIcon_g2b89_755", CEe = "_dotContainer_g2b89_759", wEe = "_lblContainer_g2b89_767", bEe = "_lblText_g2b89_771", yEe = "_lblTextInner_g2b89_786", _Ee = "_container_g2b89_790", SEe = "_button_g2b89_797", xEe = "_typeDefault_g2b89_810", MEe = "_selected_g2b89_825", AEe = "_typeGhost_g2b89_845", LEe = {
  icon: vEe,
  dotIcon: mEe,
  dotContainer: CEe,
  lblContainer: wEe,
  lblText: bEe,
  lblTextInner: yEe,
  container: _Ee,
  button: SEe,
  typeDefault: xEe,
  selected: MEe,
  typeGhost: AEe
}, EEe = {
  $style: LEe
}, PEe = /* @__PURE__ */ Ce(fEe, [["__cssModules", EEe]]), REe = /* @__PURE__ */ pe({
  __name: "SCATabGroup",
  props: {
    icon: { default: void 0 },
    selected: { type: Boolean, default: !1 },
    alignItemsStretch: { type: Boolean, default: !1 },
    type: { default: "default" },
    noBorder: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (t, o) => (f(), v("div", {
      class: S([
        t.$style.tabGroup,
        {
          [t.$style.typeGhost]: e.type === "ghost",
          [t.$style.alignItemsStretch]: e.alignItemsStretch,
          [t.$style.noBorder]: e.noBorder
        }
      ])
    }, [
      ve(t.$slots, "default")
    ], 2));
  }
}), FEe = "_tabGroup_152fv_747", TEe = "_noBorder_152fv_754", IEe = "_alignItemsStretch_152fv_757", DEe = "_typeGhost_152fv_764", kEe = {
  tabGroup: FEe,
  noBorder: TEe,
  alignItemsStretch: IEe,
  typeGhost: DEe
}, HEe = {
  $style: kEe
}, VEe = /* @__PURE__ */ Ce(REe, [["__cssModules", HEe]]), OEe = ["data-sca-overflow-index"], BEe = ["data-selected"], $Ee = ["data-sca-overflow-index"], ZEe = /* @__PURE__ */ pe({
  __name: "SCAOverflowContainer",
  props: {
    type: { default: void 0 },
    items: { default: () => [] },
    actions: { default: () => [] },
    dropdownActions: { default: () => [] },
    isRecordView: { type: Boolean, default: !1 },
    lessGap: { type: Boolean, default: !1 },
    filterItems: { default: () => [] },
    linkComponent: { default: void 0 }
  },
  setup(e) {
    const t = e, o = W(!1), n = W(/* @__PURE__ */ new Set()), s = W(/* @__PURE__ */ new Set()), i = W(/* @__PURE__ */ new Set()), r = Ro("itemsContainer"), l = W([]), a = F(() => t.items.map((O) => ({ ...O, props: O.props }))), c = F(
      () => {
        var O;
        return a.value.length > 0 && ((O = a.value[0]) != null && O.props) && "type" in a.value[0].props ? a.value[0].props.type : "default";
      }
    ), d = F(() => t.dropdownActions), u = F(() => t.actions), h = (O) => (O == null ? void 0 : O.isDropdownTrigger) === !0, p = F(() => !t.actions || s.value.size === 0 ? [] : Array.from(s.value).sort((O, N) => O - N).map((O) => {
      var te;
      const N = (te = t.actions) == null ? void 0 : te[O];
      return N ? { ...N, __originalIndex: O } : void 0;
    }).filter((O) => !!O)), C = F(() => {
      var O;
      return (O = l.value) == null ? void 0 : O.some((N) => {
        var te;
        return ((te = N == null ? void 0 : N.props) == null ? void 0 : te.selected) === !0;
      });
    }), m = Qt(), w = F(() => {
      var O;
      return (((O = m.default) == null ? void 0 : O.call(m)) ?? []).filter((N) => N.type !== u7);
    }), y = F(() => w.value.length > 0), b = W(/* @__PURE__ */ new Set()), _ = F(() => s.value.size === 0 ? [] : w.value.filter(
      (O, N) => !x(O) && b.value.has(N)
    )), M = F(
      () => (t.filterItems ?? []).filter((O, N) => i.value.has(N))
    ), x = (O) => "props" in O && O.props && "ignore-overflow" in O.props ? !0 : "type" in O && typeof O.type == "object" && "props" in O.type && "ignore-overflow" in O.type.props, L = (O) => {
      typeof (O == null ? void 0 : O.onClick) == "function" && O.onClick();
    }, A = (O, N) => {
      O.to || (N.preventDefault(), N.stopPropagation(), L(O));
    }, R = (O) => O.metaKey || O.ctrlKey || O.shiftKey || O.altKey || O.button !== 0, P = (O, N) => {
      O.href && R(N) || (N.preventDefault(), N.stopPropagation(), L(O));
    }, I = (O) => {
      typeof (O == null ? void 0 : O.onEdit) == "function" && O.onEdit();
    };
    function B() {
      if (!r.value) {
        n.value = /* @__PURE__ */ new Set(), l.value = [], s.value = /* @__PURE__ */ new Set(), b.value = /* @__PURE__ */ new Set(), i.value = /* @__PURE__ */ new Set();
        return;
      }
      const O = /* @__PURE__ */ new Set(), N = [], te = /* @__PURE__ */ new Set(), E = /* @__PURE__ */ new Set(), j = /* @__PURE__ */ new Set(), Z = r.value.querySelectorAll("[data-sca-overflow-container-item]"), Y = oP(r.value);
      Z.forEach((le) => {
        const ge = le, ce = ge.getAttribute("data-sca-overflow-type") ?? "item", G = ge.getAttribute("data-sca-overflow-index"), z = G !== null ? parseInt(G, 10) : -1, oe = ge.getBoundingClientRect(), q = oe.left - Y.left.value + oe.width;
        Y.width.value - q >= 1 || (ce === "action" && z >= 0 ? (te.add(z), E.add(z)) : ce === "filter" && z >= 0 ? j.add(z) : z >= 0 && (N.push(t.items[z]), O.add(z)));
      }), l.value = N, n.value = O, s.value = te, b.value = E, i.value = j;
    }
    const H = W(0);
    return WE(
      [H, () => t.items, () => t.filterItems, () => w.value],
      () => {
        B();
      },
      { debounce: 250 }
    ), s1(r, () => {
      H.value = H.value + 1;
    }), (O, N) => (f(), v("div", {
      class: S([
        O.$style.root,
        {
          [O.$style.moreGap]: e.isRecordView
        }
      ])
    }, [
      g("div", {
        ref: "itemsContainer",
        class: S([O.$style.items])
      }, [
        e.type === "SCATag" ? (f(!0), v(we, { key: 0 }, Ze(e.items, (te, E) => (f(), U(Pn, Bt({
          key: `item_${E}`
        }, { ref_for: !0 }, te.props, {
          as: te.to ? t.linkComponent : void 0,
          to: te.to,
          overflow: "visible",
          "data-sca-overflow-container-item": "",
          onClick: (j) => A(te, j)
        }), {
          default: ee(() => [
            Ve(se(te.label), 1)
          ]),
          _: 2
        }, 1040, ["as", "to", "onClick"]))), 128)) : e.type === "SCATab" ? (f(), U(VEe, {
          key: 1,
          class: S({ [O.$style.items]: !0, [O.$style.lessGap]: e.lessGap }),
          type: c.value
        }, {
          default: ee(() => [
            e.isRecordView && u.value.length > 0 ? (f(), v(we, { key: 0 }, [
              g("div", {
                class: S(O.$style.inner)
              }, [
                (f(!0), v(we, null, Ze(u.value, (te, E) => {
                  var j, Z;
                  return f(), v(we, {
                    key: `action_${E}`
                  }, [
                    h(te) ? (f(), U(zt, {
                      key: `dropdown_action_${E}`,
                      "no-padding": "",
                      class: S({ [O.$style.hidden]: e.isRecordView && s.value.has(E) })
                    }, {
                      trigger: ee(({ target: Y }) => [
                        de(ot, {
                          size: "xsmall",
                          appearance: "secondary",
                          icon: "phosphor/dots-three",
                          title: O.$t("common.label.options"),
                          popovertarget: Y,
                          "data-sca-overflow-container-item": "",
                          "data-sca-overflow-index": E,
                          "data-sca-overflow-type": "action"
                        }, null, 8, ["title", "popovertarget", "data-sca-overflow-index"])
                      ]),
                      default: ee(({ popover: Y }) => [
                        (f(!0), v(we, null, Ze(d.value, (le, ge) => {
                          var ce;
                          return f(), U(It, Bt({
                            key: `dr_action_${ge}`
                          }, { ref_for: !0 }, le.props, {
                            class: O.$style.action,
                            disabled: ((ce = le == null ? void 0 : le.props) == null ? void 0 : ce.disabled) ?? !1,
                            onClick: xe((G) => {
                              L(le), Y == null || Y.hidePopover();
                            }, ["prevent", "stop"])
                          }), {
                            default: ee(() => [
                              Ve(se(le.label), 1)
                            ]),
                            _: 2
                          }, 1040, ["class", "disabled", "onClick"]);
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["class"])) : (f(), U(ot, Bt({
                      key: `action_${E}`,
                      size: "small",
                      appearance: "secondary",
                      class: { [O.$style.hidden]: e.isRecordView && s.value.has(E) }
                    }, { ref_for: !0 }, te.props, {
                      icon: ((j = te == null ? void 0 : te.props) == null ? void 0 : j.icon) ?? "",
                      disabled: ((Z = te == null ? void 0 : te.props) == null ? void 0 : Z.disabled) ?? !1,
                      "data-sca-overflow-container-item": "",
                      "data-sca-overflow-index": E,
                      "data-sca-overflow-type": "action",
                      onClick: xe((Y) => L(te), ["prevent", "stop"])
                    }), null, 16, ["class", "icon", "disabled", "data-sca-overflow-index", "onClick"]))
                  ], 64);
                }), 128))
              ], 2),
              de(Sr, {
                direction: "vertical",
                class: "mx-component-gap-2xSmall"
              })
            ], 64)) : $("", !0),
            (f(!0), v(we, null, Ze(a.value, (te, E) => (f(), U(PEe, Bt({
              key: `item_${E}`
            }, { ref_for: !0 }, te.props, {
              label: te.label,
              class: { [O.$style.lessPadding]: e.isRecordView, [O.$style.hidden]: e.isRecordView && n.value.has(E) },
              "data-sca-overflow-container-item": "",
              "data-sca-overflow-index": E,
              "data-sca-overflow-type": "item",
              onClick: xe((j) => L(te), ["prevent", "stop"])
            }), {
              default: ee(() => [
                g("span", {
                  class: S(O.$style.labelWithCount)
                }, [
                  Ve(se(te.label) + " ", 1),
                  e.isRecordView && te.count ? (f(), v("span", {
                    key: 0,
                    class: S(O.$style.count)
                  }, se(te.count), 3)) : $("", !0)
                ], 2)
              ]),
              _: 2
            }, 1040, ["label", "class", "data-sca-overflow-index", "onClick"]))), 128))
          ]),
          _: 1
        }, 8, ["class", "type"])) : y.value && w.value.length > 0 ? (f(!0), v(we, { key: 2 }, Ze(w.value, (te, E) => (f(), v(we, {
          key: `slot_${E}`
        }, [
          te.type === Sr ? (f(), U(Po(te), { key: 0 })) : (f(), v("div", {
            key: 1,
            "data-sca-overflow-container-item": "",
            "data-sca-overflow-index": E,
            "data-sca-overflow-type": "action",
            class: S({ [O.$style.hidden]: b.value.has(E) })
          }, [
            (f(), U(Po(te)))
          ], 10, OEe))
        ], 64))), 128)) : e.type === "SCAFilterSetItem" ? (f(!0), v(we, { key: 3 }, Ze(e.items, (te, E) => (f(), U(x1, Bt({
          key: `item_${E}`
        }, { ref_for: !0 }, te.props, {
          as: te.href ? "a" : void 0,
          href: te.href,
          class: { [O.$style.hidden]: n.value.has(E) },
          "data-sca-overflow-container-item": "",
          "data-sca-overflow-index": E,
          "data-sca-overflow-type": "item",
          onClick: (j) => P(te, j),
          onEdit: (j) => I(te)
        }), {
          default: ee(() => [
            Ve(se(te.label), 1)
          ]),
          _: 2
        }, 1040, ["as", "href", "class", "data-sca-overflow-index", "onClick", "onEdit"]))), 128)) : $("", !0),
        (f(!0), v(we, null, Ze(t.filterItems ?? [], (te, E) => (f(), U(x1, Bt({
          key: `filterItem_${E}`
        }, { ref_for: !0 }, te.props, {
          as: te.href ? "a" : void 0,
          href: te.href,
          class: [O.$style.filterItem, { [O.$style.hidden]: i.value.has(E) }],
          "data-sca-overflow-container-item": "",
          "data-sca-overflow-index": E,
          "data-sca-overflow-type": "filter",
          onClick: (j) => P(te, j),
          onEdit: (j) => I(te)
        }), {
          default: ee(() => [
            Ve(se(te.label), 1)
          ]),
          _: 2
        }, 1040, ["as", "href", "class", "data-sca-overflow-index", "onClick", "onEdit"]))), 128))
      ], 2),
      l.value && l.value.length > 0 || _.value.length > 0 || M.value.length > 0 ? (f(), U(zt, {
        key: 0,
        "is-open": o.value,
        "onUpdate:isOpen": N[0] || (N[0] = (te) => o.value = te),
        "no-padding": ""
      }, {
        trigger: ee(({ togglePopover: te }) => [
          g("div", {
            class: S([O.$style.trigger, { [O.$style.recordTrigger]: e.isRecordView || y.value }]),
            "data-selected": C.value
          }, [
            de(Ae, {
              icon: "phosphor/dots-three",
              onClick: xe(te, ["prevent", "stop"])
            }, null, 8, ["onClick"])
          ], 10, BEe)
        ]),
        default: ee(({ popover: te }) => [
          g("div", {
            class: S([O.$style.hiddenItems, { [O.$style.hiddenItemsSlots]: y.value }])
          }, [
            e.type === "SCAFilterSetItem" ? (f(!0), v(we, { key: 0 }, Ze(l.value, (E, j) => {
              var Z, Y;
              return f(), v("div", {
                key: `hiddenItem_${j}`,
                class: "flex items-center gap-component-padding-xSmall"
              }, [
                de(x1, Bt({ ref_for: !0 }, E.props, {
                  as: E.href ? "a" : void 0,
                  href: E.href,
                  selected: ((Z = E == null ? void 0 : E.props) == null ? void 0 : Z.selected) ?? !1,
                  disabled: ((Y = E == null ? void 0 : E.props) == null ? void 0 : Y.disabled) ?? !1,
                  onClick: (le) => P(E, le),
                  onEdit: (le) => I(E)
                }), {
                  default: ee(() => [
                    Ve(se(E.label), 1)
                  ]),
                  _: 2
                }, 1040, ["as", "href", "selected", "disabled", "onClick", "onEdit"])
              ]);
            }), 128)) : y.value ? (f(), v(we, { key: 1 }, [
              (f(!0), v(we, null, Ze(_.value, (E, j) => (f(), v("div", {
                key: `overflow_slot_${j}`,
                "data-sca-overflow-container-item": "",
                "data-sca-overflow-index": j,
                "data-sca-overflow-type": "action"
              }, [
                (f(), U(Po(E)))
              ], 8, $Ee))), 128)),
              M.value.length > 0 ? (f(), v("div", {
                key: 0,
                class: S([O.$style.hiddenFilterItems, { [O.$style.hiddenFilterItemsBorder]: _.value.length > 0 }])
              }, [
                (f(!0), v(we, null, Ze(M.value, (E, j) => {
                  var Z, Y;
                  return f(), v("div", {
                    key: `hiddenFilter_${j}`,
                    class: S(O.$style.hiddenFilterItem)
                  }, [
                    de(x1, Bt({ ref_for: !0 }, E.props, {
                      as: E.href ? "a" : void 0,
                      href: E.href,
                      selected: ((Z = E == null ? void 0 : E.props) == null ? void 0 : Z.selected) ?? !1,
                      disabled: ((Y = E == null ? void 0 : E.props) == null ? void 0 : Y.disabled) ?? !1,
                      onClick: (le) => P(E, le),
                      onEdit: (le) => I(E)
                    }), {
                      default: ee(() => [
                        Ve(se(E.label), 1)
                      ]),
                      _: 2
                    }, 1040, ["as", "href", "selected", "disabled", "onClick", "onEdit"])
                  ], 2);
                }), 128))
              ], 2)) : $("", !0)
            ], 64)) : (f(), v(we, { key: 2 }, [
              e.isRecordView && p.value.length > 0 ? (f(), v(we, { key: 0 }, [
                g("div", {
                  class: S([O.$style.inner, { [O.$style.hide]: p.value.length === 0 }])
                }, [
                  (f(!0), v(we, null, Ze(p.value, (E, j) => {
                    var Z, Y;
                    return f(), v(we, {
                      key: `hidden_action_${j}`
                    }, [
                      h(E) ? (f(), U(zt, {
                        key: 1,
                        "no-padding": ""
                      }, {
                        trigger: ee(({ target: le }) => [
                          de(ot, {
                            size: "xsmall",
                            appearance: "secondary",
                            icon: "phosphor/dots-three",
                            title: O.$t("common.label.options"),
                            popovertarget: le,
                            "data-sca-overflow-container-item": "",
                            "data-sca-overflow-index": E.__originalIndex ?? j,
                            "data-sca-overflow-type": "action"
                          }, null, 8, ["title", "popovertarget", "data-sca-overflow-index"])
                        ]),
                        default: ee(({ popover: le }) => [
                          (f(!0), v(we, null, Ze(d.value, (ge, ce) => {
                            var G;
                            return f(), U(It, Bt({
                              key: `hidden_dr_action_${ce}`
                            }, { ref_for: !0 }, ge.props, {
                              class: O.$style.action,
                              disabled: ((G = ge == null ? void 0 : ge.props) == null ? void 0 : G.disabled) ?? !1,
                              onClick: xe((z) => {
                                L(ge), le == null || le.hidePopover(), te == null || te.hidePopover();
                              }, ["prevent", "stop"])
                            }), {
                              default: ee(() => [
                                Ve(se(ge.label), 1)
                              ]),
                              _: 2
                            }, 1040, ["class", "disabled", "onClick"]);
                          }), 128))
                        ]),
                        _: 2
                      }, 1024)) : (f(), U(ot, Bt({
                        key: 0,
                        size: "small",
                        appearance: "secondary"
                      }, { ref_for: !0 }, E.props, {
                        icon: ((Z = E == null ? void 0 : E.props) == null ? void 0 : Z.icon) ?? "",
                        disabled: ((Y = E == null ? void 0 : E.props) == null ? void 0 : Y.disabled) ?? !1,
                        "data-sca-overflow-container-item": "",
                        "data-sca-overflow-index": E.__originalIndex ?? j,
                        "data-sca-overflow-type": "action",
                        onClick: xe((le) => {
                          L(E), te == null || te.hidePopover();
                        }, ["prevent", "stop"])
                      }), null, 16, ["icon", "disabled", "data-sca-overflow-index", "onClick"]))
                    ], 64);
                  }), 128))
                ], 2),
                de(Sr, {
                  class: S([O.$style.divider, u.value.length === 0 && O.$style.hide]),
                  appearance: "border"
                }, null, 8, ["class"])
              ], 64)) : $("", !0),
              (f(!0), v(we, null, Ze(l.value, (E, j) => {
                var Z, Y, le;
                return f(), U(It, {
                  key: `hiddenItem_${j}`,
                  size: "small",
                  intent: "none",
                  appearance: "secondary",
                  type: "ghost",
                  class: S({
                    [O.$style.hiddenItemButton]: e.isRecordView,
                    [O.$style.selected]: e.isRecordView && ((Z = E == null ? void 0 : E.props) == null ? void 0 : Z.selected)
                  }),
                  selected: ((Y = E == null ? void 0 : E.props) == null ? void 0 : Y.selected) ?? !1,
                  disabled: ((le = E == null ? void 0 : E.props) == null ? void 0 : le.disabled) ?? !1,
                  onClick: xe((ge) => {
                    L(E), te == null || te.hidePopover();
                  }, ["prevent", "stop"])
                }, {
                  default: ee(() => [
                    g("span", {
                      class: S(O.$style.labelWithCount)
                    }, [
                      Ve(se(E.label) + " ", 1),
                      e.isRecordView && E.count ? (f(), v("span", {
                        key: 0,
                        class: S(O.$style.count)
                      }, se(E.count), 3)) : $("", !0)
                    ], 2)
                  ]),
                  _: 2
                }, 1032, ["class", "selected", "disabled", "onClick"]);
              }), 128))
            ], 64))
          ], 2)
        ]),
        _: 1
      }, 8, ["is-open"])) : $("", !0)
    ], 2));
  }
}), GEe = "_root_x4bvk_1", NEe = "_moreGap_x4bvk_9", zEe = "_items_x4bvk_13", jEe = "_lessGap_x4bvk_25", WEe = "_lessPadding_x4bvk_29", UEe = "_labelWithCount_x4bvk_34", KEe = "_count_x4bvk_40", qEe = "_hiddenItems_x4bvk_45", YEe = "_hiddenItemsSlots_x4bvk_53", QEe = "_filterItem_x4bvk_61", JEe = "_hiddenFilterItems_x4bvk_65", XEe = "_hiddenFilterItemsBorder_x4bvk_75", ePe = "_hiddenFilterItem_x4bvk_65", tPe = "_hiddenItemButton_x4bvk_86", oPe = "_selected_x4bvk_91", nPe = "_trigger_x4bvk_96", sPe = "_recordTrigger_x4bvk_121", iPe = "_hidden_x4bvk_45", rPe = "_divider_x4bvk_136", lPe = "_action_x4bvk_141", aPe = "_inner_x4bvk_152", cPe = "_hide_x4bvk_158", dPe = {
  root: GEe,
  moreGap: NEe,
  items: zEe,
  lessGap: jEe,
  lessPadding: WEe,
  labelWithCount: UEe,
  count: KEe,
  hiddenItems: qEe,
  hiddenItemsSlots: YEe,
  filterItem: QEe,
  hiddenFilterItems: JEe,
  hiddenFilterItemsBorder: XEe,
  hiddenFilterItem: ePe,
  hiddenItemButton: tPe,
  selected: oPe,
  trigger: nPe,
  recordTrigger: sPe,
  hidden: iPe,
  divider: rPe,
  action: lPe,
  inner: aPe,
  hide: cPe
}, uPe = {
  $style: dPe
}, Pst = /* @__PURE__ */ Ce(ZEe, [["__cssModules", uPe]]), hPe = ["title"], gPe = /* @__PURE__ */ pe({
  __name: "SCAPagination",
  props: {
    currentIdx: { default: 0 },
    numOfPages: { default: void 0 },
    pageMaxItems: { default: 25 },
    childItemCount: { default: 0 },
    paginationOptions: { default: () => [25, 50, 100, 200] },
    maxItems: {},
    maxItemsTotal: { default: 0 }
  },
  emits: ["update:currentIdx", "update:pageMaxItems"],
  setup(e, { emit: t }) {
    const o = e, n = t, s = oo(o, "currentIdx", void 0, { passive: !0 }), i = oo(o, "pageMaxItems", n, { passive: !0 }), r = (d) => {
      let u = Math.max(0, d);
      o.numOfPages != null && (u = Math.min(u, o.numOfPages)), s.value = u;
    }, l = F(
      () => o.paginationOptions.map((d) => ({ id: d, label: d.toString() }))
    ), a = F(() => s.value * i.value), c = F(() => o.maxItems === void 0 ? s.value * i.value + i.value : o.maxItems ? Math.min(o.maxItems, s.value * i.value + i.value) : s.value);
    return At(() => {
      var d;
      i.value = ((d = l.value.find((u) => u.id === o.pageMaxItems)) == null ? void 0 : d.id) ?? l.value[0].id;
    }), (d, u) => (f(), v("div", {
      class: S(d.$style.container)
    }, [
      g("div", {
        class: S(d.$style.pagination)
      }, [
        de(ot, {
          disabled: k(s) === 0,
          type: "ghost",
          size: "small",
          appearance: "secondary",
          icon: "tetrisly/horizontal-align-left",
          onClick: u[0] || (u[0] = (h) => r(0))
        }, null, 8, ["disabled"]),
        de(ot, {
          disabled: k(s) === 0,
          type: "ghost",
          size: "small",
          appearance: "secondary",
          icon: "tetrisly/chevron-left",
          onClick: u[1] || (u[1] = (h) => r((k(s) ?? 0) - 1))
        }, null, 8, ["disabled"]),
        e.maxItemsTotal ? (f(), v("span", {
          key: 0,
          class: S([d.$style.text, d.$style.help]),
          title: d.$t("common.label.valuesBracketsRepresent")
        }, [
          Ve(se(a.value) + " - " + se(c.value) + " ", 1),
          e.childItemCount > 0 ? (f(), v(we, { key: 0 }, [
            Ve(" (+" + se(e.childItemCount) + ") ", 1)
          ], 64)) : $("", !0),
          o.maxItems !== void 0 ? (f(), v(we, { key: 1 }, [
            o.maxItems < o.maxItemsTotal ? (f(), v(we, { key: 0 }, [
              Ve(se(d.$t("common.label.paramParamResults", { max: o.maxItems, maxTotal: o.maxItemsTotal })), 1)
            ], 64)) : (f(), v(we, { key: 1 }, [
              Ve(se(d.$t("common.label.paramResults", { max: o.maxItems })), 1)
            ], 64))
          ], 64)) : $("", !0)
        ], 10, hPe)) : (f(), v("span", {
          key: 1,
          class: S(d.$style.text)
        }, [
          Ve(se(a.value) + " - " + se(c.value) + " ", 1),
          o.maxItems !== void 0 ? (f(), v(we, { key: 0 }, [
            Ve(se(d.$t("common.label.paramResults", { max: o.maxItems })), 1)
          ], 64)) : $("", !0)
        ], 2)),
        de(ot, {
          disabled: k(s) === void 0 || e.numOfPages !== void 0 && k(s) >= e.numOfPages - 1,
          type: "ghost",
          size: "small",
          appearance: "secondary",
          icon: "tetrisly/chevron-right",
          onClick: u[2] || (u[2] = (h) => r((k(s) ?? 0) + 1))
        }, null, 8, ["disabled"]),
        de(ot, {
          disabled: k(s) === void 0 || e.numOfPages === void 0 || k(s) >= e.numOfPages - 1,
          type: "ghost",
          size: "small",
          appearance: "secondary",
          icon: "tetrisly/horizontal-align-right",
          onClick: u[3] || (u[3] = (h) => r(e.numOfPages - 1))
        }, null, 8, ["disabled"])
      ], 2),
      de(ZC, {
        modelValue: k(i),
        "onUpdate:modelValue": u[4] || (u[4] = (h) => Tn(i) ? i.value = h : null),
        items: l.value,
        search: "client",
        "label-position": "hidden"
      }, {
        triggerContent: ee(() => [
          g("div", {
            class: S(d.$style.paginationSelection)
          }, [
            Ve(se(k(i)) + " ", 1),
            de(Ae, {
              icon: "tetrisly/chevron-down-small",
              class: S(d.$style.iconColor),
              size: "16px"
            }, null, 8, ["class"])
          ], 2)
        ]),
        _: 1
      }, 8, ["modelValue", "items"])
    ], 2));
  }
}), pPe = "_pagination_p20jy_1", fPe = "_text_p20jy_6", vPe = "_pageBtn_p20jy_16", mPe = "_pageGroup_p20jy_19", CPe = "_help_p20jy_24", wPe = "_container_p20jy_28", bPe = "_paginationSelection_p20jy_37", yPe = "_iconColor_p20jy_46", _Pe = {
  pagination: pPe,
  text: fPe,
  pageBtn: vPe,
  pageGroup: mPe,
  help: CPe,
  container: wPe,
  paginationSelection: bPe,
  iconColor: yPe
}, SPe = {
  $style: _Pe
}, Rst = /* @__PURE__ */ Ce(gPe, [["__cssModules", SPe]]), xPe = { key: 0 }, MPe = { key: 1 }, APe = /* @__PURE__ */ pe({
  __name: "SCAPill",
  props: {
    type: { default: "boolean" },
    selected: { type: Boolean, default: !1 },
    appearance: { default: "default" },
    icon: { default: void 0 },
    avatar: { type: Boolean, default: !1 },
    label: {},
    value: { default: void 0 },
    prefix: { default: void 0 },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const o = t;
    return (n, s) => (f(), v("label", {
      class: S([
        n.$style.main,
        {
          [n.$style.inverted]: e.appearance === "inverted",
          [n.$style.selectable]: e.type === "selectable",
          [n.$style.selected]: e.selected,
          [n.$style.avatar]: e.avatar,
          [n.$style.disabled]: e.disabled,
          [n.$style.hasPrefix]: e.prefix
        }
      ]),
      onClick: s[0] || (s[0] = (i) => o("click"))
    }, [
      e.selected && e.type === "boolean" ? (f(), U(Ae, {
        key: 0,
        icon: "tetrisly/check-large",
        class: S(n.$style.checkbox)
      }, null, 8, ["class"])) : $("", !0),
      e.icon ? (f(), U(Ae, {
        key: 1,
        class: S(n.$style.icon),
        icon: e.icon
      }, null, 8, ["class", "icon"])) : $("", !0),
      g("div", {
        class: S(n.$style.contentDiv)
      }, [
        e.prefix ? (f(), v("span", {
          key: 0,
          class: S(n.$style.prefix)
        }, se(e.prefix), 3)) : $("", !0),
        e.avatar ? (f(), U(oi, {
          key: 1,
          size: "xsmall"
        })) : $("", !0),
        g("div", {
          class: S(n.$style.iconDiv)
        }, [
          e.value ? $("", !0) : (f(), v("span", xPe, se(e.label), 1)),
          e.value ? (f(), v("span", MPe, se(e.value), 1)) : $("", !0),
          e.type === "selectable" ? (f(), U(Ae, {
            key: 2,
            icon: e.value ? "tetrisly/close" : "tetrisly/chevron-down-small"
          }, null, 8, ["icon"])) : $("", !0)
        ], 2)
      ], 2)
    ], 2));
  }
}), LPe = "_contentDiv_32390_747", EPe = "_iconDiv_32390_754", PPe = "_prefix_32390_760", RPe = "_main_32390_764", FPe = "_avatar_32390_780", TPe = "_hasPrefix_32390_780", IPe = "_disabled_32390_783", DPe = "_inverted_32390_795", kPe = "_selected_32390_809", HPe = "_selectable_32390_824", VPe = {
  contentDiv: LPe,
  iconDiv: EPe,
  prefix: PPe,
  main: RPe,
  avatar: FPe,
  hasPrefix: TPe,
  disabled: IPe,
  inverted: DPe,
  selected: kPe,
  selectable: HPe
}, OPe = {
  $style: VPe
}, Fst = /* @__PURE__ */ Ce(APe, [["__cssModules", OPe]]), BPe = ["aria-valuenow"], $Pe = /* @__PURE__ */ pe({
  __name: "SCAProgressBar",
  props: {
    value: { default: 0 },
    alert: { type: Boolean, default: !1 },
    appearance: { default: "default" }
  },
  setup(e) {
    const t = e, o = F(() => Math.min(100, Math.max(0, Math.round(t.value))));
    return (n, s) => (f(), v("div", {
      class: S([n.$style.track, { [n.$style.inverted]: e.appearance === "inverted" }]),
      role: "progressbar",
      "aria-valuenow": o.value,
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }, [
      g("div", {
        class: S([n.$style.fill, { [n.$style.alert]: e.alert }]),
        style: Ge({ width: `${o.value}%` })
      }, null, 6)
    ], 10, BPe));
  }
}), ZPe = "_track_6gzs7_1", GPe = "_inverted_6gzs7_8", NPe = "_fill_6gzs7_12", zPe = "_alert_6gzs7_18", jPe = {
  track: ZPe,
  inverted: GPe,
  fill: NPe,
  alert: zPe
}, WPe = {
  $style: jPe
}, Tst = /* @__PURE__ */ Ce($Pe, [["__cssModules", WPe]]), UPe = /* @__PURE__ */ pe({
  __name: "SCARadioButton",
  props: {
    disabled: { type: Boolean, default: !1 },
    checked: { type: Boolean, default: !1 },
    alert: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    label: { default: void 0 },
    helperText: { default: void 0 },
    noGap: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (t, o) => (f(), v("label", null, [
      g("div", {
        class: S([t.$style.grid, { [t.$style.noGap]: e.noGap }])
      }, [
        de(BC, {
          checked: e.checked,
          disabled: e.disabled,
          alert: e.alert,
          class: S(t.$style.radio)
        }, {
          default: ee(() => [
            ve(t.$slots, "default")
          ]),
          _: 3
        }, 8, ["checked", "disabled", "alert", "class"]),
        g("span", {
          class: S([{ [t.$style.required]: e.required }])
        }, se(e.label), 3)
      ], 2),
      e.helperText ? (f(), U(r1, {
        key: 0,
        intent: e.alert ? "alert" : void 0,
        class: S(t.$style.helperText)
      }, {
        default: ee(() => [
          Ve(se(e.helperText), 1)
        ]),
        _: 1
      }, 8, ["intent", "class"])) : $("", !0)
    ]));
  }
}), KPe = "_grid_a1zlo_747", qPe = "_noGap_a1zlo_761", YPe = "_helperText_a1zlo_765", QPe = "_disabled_a1zlo_770", JPe = {
  grid: KPe,
  noGap: qPe,
  helperText: YPe,
  disabled: QPe
}, XPe = {
  $style: JPe
}, Ist = /* @__PURE__ */ Ce(UPe, [["__cssModules", XPe]]), eRe = /* @__PURE__ */ pe({
  __name: "SCARadioButtonGroup",
  props: {
    columns: { default: void 0 },
    label: { default: void 0 },
    labelPosition: { default: void 0 },
    optionalLabelText: { default: void 0 },
    appearance: { default: void 0 },
    helperText: { default: void 0 },
    validationError: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    htmlFor: { default: void 0 }
  },
  setup(e) {
    Vn((n) => ({
      v289e3e37: o.value
    }));
    const t = e, o = F(() => t.columns ?? 1);
    return (n, s) => (f(), U(Is, {
      label: e.label,
      "label-position": e.labelPosition,
      "optional-label-text": e.optionalLabelText,
      appearance: e.appearance,
      "helper-text": e.helperText,
      "validation-error": e.validationError,
      required: e.required,
      "html-for": e.htmlFor
    }, {
      default: ee(() => [
        g("div", {
          class: S([n.$style.radioGrid, { [n.$style.columns]: e.columns }])
        }, [
          ve(n.$slots, "default")
        ], 2)
      ]),
      _: 3
    }, 8, ["label", "label-position", "optional-label-text", "appearance", "helper-text", "validation-error", "required", "html-for"]));
  }
}), tRe = "_radioGrid_ggh29_747", oRe = "_columns_ggh29_752", nRe = {
  radioGrid: tRe,
  columns: oRe
}, sRe = {
  $style: nRe
}, Dst = /* @__PURE__ */ Ce(eRe, [["__cssModules", sRe]]), iRe = ["id"], rRe = { key: 0 }, lRe = pe({
  inheritAttrs: !1
}), aRe = /* @__PURE__ */ pe({
  ...lRe,
  __name: "SCASidebarNavigationItem",
  props: {
    label: {},
    expandable: { type: Boolean, default: !1 },
    expanded: { type: Boolean, default: !1 },
    selected: { type: Boolean, default: !1 },
    isActive: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    icon: { default: void 0 },
    as: { default: "button" },
    level: { default: 0 },
    favorite: { type: Boolean, default: !1 },
    isMini: { type: Boolean, default: !1 }
  },
  emits: ["update:expanded"],
  setup(e, { emit: t }) {
    const o = H5(), n = e, s = t, i = Qt(), r = Ns(), l = F(() => !!i.default), a = F(() => !!i.actions), c = W(null), d = W(!1), u = W(null);
    s1(c, () => {
      const Y = c.value;
      d.value = !!Y && Y.scrollWidth > Y.clientWidth;
    });
    const h = W(!1), p = r3("(hover: hover)"), C = F(() => navigator.maxTouchPoints > 0), m = F(() => h.value ? !0 : C.value && n.isActive);
    function w() {
      n.disabled || p.value && (h.value = !0);
    }
    function y() {
      p.value && (h.value = !1);
    }
    const b = oo(n, "expanded", s, { passive: !0 }), _ = F(() => [
      o.sidebarNavItem,
      {
        [o.selected]: n.selected,
        [o.disabled]: n.disabled,
        [o.nested]: n.level > 0,
        [o.isExpanded]: b.value,
        [o.isExpandable]: n.expandable
      }
    ]), M = F(() => [
      o.inner,
      {
        [o.nested]: n.level > 0,
        [o.isExpandable]: n.expandable
      }
    ]), x = F(() => [o.expander, { [o.isExpanded]: b.value }]), L = F(() => [o.children, { [o.hasIcon]: !!n.icon }]), A = F(() => ({
      "--indent-level": n.level,
      "--initial-padding": n.isMini ? "16px" : "40px",
      "--min-height": n.isMini ? "24px" : "32px"
    })), R = () => {
      b.value = !b.value;
    }, P = () => {
      n.expandable && (n.selected ? b.value = !0 : R());
    }, I = W(null), B = W(null), H = W(!1), O = W(!1);
    function N() {
      O.value = !0, !(n.disabled || !a.value) && (B.value = Date.now(), H.value = !1, I.value = setTimeout(() => {
        H.value || (h.value = !0);
      }, 500));
    }
    function te() {
      H.value = !0, I.value && clearTimeout(I.value);
    }
    function E(Y) {
      I.value && clearTimeout(I.value), B.value && Date.now() - B.value >= 500 && !H.value && Y.cancelable && Y.preventDefault(), B.value = null, H.value = !1, O.value = !1;
    }
    function j(Y) {
      O.value && Y.preventDefault();
    }
    const Z = (Y) => {
      u.value && !u.value.contains(Y.target) && (h.value = !1);
    };
    return Me(h, (Y) => {
      Y ? rt(() => {
        document.addEventListener("touchstart", Z, { capture: !0, passive: !0 });
      }) : document.removeEventListener("touchstart", Z, { capture: !0 });
    }), Qi(() => {
      document.removeEventListener("touchstart", Z, { capture: !0 });
    }), (Y, le) => (f(), v("div", null, [
      g("div", {
        ref_key: "itemRef",
        ref: u,
        class: S(_.value),
        style: Ge(A.value),
        onClick: P,
        onMouseenter: w,
        onMouseleave: y,
        onTouchstartPassive: N,
        onTouchmovePassive: te,
        onTouchend: E,
        onContextmenu: j
      }, [
        (f(), U(Po(e.as), Bt(Y.$attrs, { class: M.value }), {
          default: ee(() => [
            g("span", {
              class: S(Y.$style.expanderContainer)
            }, [
              e.expandable ? (f(), U(Ae, {
                key: 0,
                icon: "phosphor/caret-right",
                size: "12px",
                class: S([...x.value, { [Y.$style.iconActive]: n.isActive }]),
                onClick: xe(R, ["stop", "prevent"])
              }, null, 8, ["class"])) : $("", !0)
            ], 2),
            e.icon ? (f(), U(Ae, {
              key: 0,
              icon: e.icon,
              class: S([Y.$style.icon, { [Y.$style.iconActive]: n.isActive }]),
              size: "20px"
            }, null, 8, ["icon", "class"])) : $("", !0),
            g("div", {
              id: k(r),
              ref_key: "labelRef",
              ref: c,
              class: S(Y.$style.label)
            }, [
              typeof e.label == "string" ? (f(), v(we, { key: 0 }, [
                Ve(se(e.label), 1)
              ], 64)) : (f(!0), v(we, { key: 1 }, Ze(e.label, (ge, ce) => (f(), v(we, { key: ce }, [
                typeof ge == "object" ? (f(), v("span", rRe, se(ge.highlight), 1)) : (f(), v(we, { key: 1 }, [
                  Ve(se(ge), 1)
                ], 64))
              ], 64))), 128)),
              d.value ? (f(), U(bo, {
                key: 2,
                id: k(r),
                text: typeof e.label == "string" ? e.label : Array.isArray(e.label) ? e.label.map((ge) => typeof ge == "object" ? ge.highlight : ge).join("") : ""
              }, null, 8, ["id", "text"])) : $("", !0)
            ], 10, iRe),
            a.value && m.value ? (f(), U(zt, {
              key: 1,
              class: S(Y.$style.actions),
              "less-border": "",
              onClosed: le[0] || (le[0] = (ge) => h.value = !1)
            }, {
              trigger: ee(({ target: ge, togglePopover: ce }) => [
                de(ot, {
                  type: "ghost",
                  icon: "phosphor/more-horizontal",
                  size: "small",
                  class: S(Y.$style.actionButton),
                  popovertarget: ge,
                  onClick: xe(ce, ["prevent", "stop"])
                }, null, 8, ["class", "popovertarget", "onClick"])
              ]),
              default: ee(() => [
                g("div", {
                  class: S(Y.$style.actionButtons)
                }, [
                  ve(Y.$slots, "actions", {}, () => [
                    le[1] || (le[1] = Ve("No actions", -1))
                  ])
                ], 2)
              ]),
              _: 3
            }, 8, ["class"])) : $("", !0)
          ]),
          _: 3
        }, 16, ["class"]))
      ], 38),
      l.value ? Et((f(), v("div", {
        key: 0,
        class: S(L.value)
      }, [
        ve(Y.$slots, "default")
      ], 2)), [
        [Hi, k(b)]
      ]) : $("", !0)
    ]));
  }
}), cRe = "_sidebarNavItem_5dym6_747", dRe = "_isExpanded_5dym6_754", uRe = "_nested_5dym6_754", hRe = "_children_5dym6_754", gRe = "_inner_5dym6_754", pRe = "_disabled_5dym6_758", fRe = "_selected_5dym6_758", vRe = "_isExpandable_5dym6_770", mRe = "_label_5dym6_776", CRe = "_icon_5dym6_793", wRe = "_iconActive_5dym6_797", bRe = "_expander_5dym6_813", yRe = "_actionButton_5dym6_829", _Re = "_expanderContainer_5dym6_844", SRe = "_actionButtons_5dym6_881", xRe = "_favoriteIcon_5dym6_887", MRe = {
  sidebarNavItem: cRe,
  isExpanded: dRe,
  nested: uRe,
  children: hRe,
  inner: gRe,
  disabled: pRe,
  selected: fRe,
  isExpandable: vRe,
  label: mRe,
  icon: CRe,
  iconActive: wRe,
  expander: bRe,
  actionButton: yRe,
  expanderContainer: _Re,
  actionButtons: SRe,
  favoriteIcon: xRe
}, ARe = {
  $style: MRe
}, kst = /* @__PURE__ */ Ce(aRe, [["__cssModules", ARe]]), Hst = /* @__PURE__ */ pe({
  __name: "SCASkeletonItem",
  props: {
    width: { default: "100%" },
    height: { default: "24px" },
    baseColor: { default: "var(--color-border-default)" },
    shineColor: { default: "var(--color-coolGrey-p3)" },
    borderRadius: { default: "var(--border-radius-large)" }
  },
  setup(e) {
    return (t, o) => (f(), v("div", {
      class: "skeleton",
      style: Ge({
        width: e.width,
        height: e.height,
        "--skeleton-base": e.baseColor,
        "--skeleton-shine": e.shineColor,
        "--skeleton-radius": e.borderRadius
      })
    }, null, 4));
  }
}), LRe = /* @__PURE__ */ pe({
  __name: "SCASplitButton",
  props: {
    active: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    leftDisabled: { type: Boolean, default: !1 },
    rightDisabled: { type: Boolean, default: !1 },
    size: { default: "xsmall" },
    type: { default: "ghost" },
    appearance: { default: "secondary" },
    leftIcon: { default: "phosphor/plus" },
    rightIcon: { default: "phosphor/caret-down-double-btn" },
    title: { default: "" },
    popoverTarget: { default: void 0 }
  },
  emits: ["left-click", "right-click"],
  setup(e) {
    const t = e, o = F(() => t.disabled || t.leftDisabled), n = F(() => t.disabled || t.rightDisabled);
    return (s, i) => (f(), v("div", {
      class: S([
        s.$style.buttonInner,
        {
          [s.$style.active]: e.active
        }
      ])
    }, [
      de(ot, {
        size: e.size,
        appearance: e.appearance,
        type: e.type,
        icon: e.leftIcon ?? "",
        title: e.title,
        disabled: o.value,
        class: S(s.$style.button),
        onClick: i[0] || (i[0] = (r) => s.$emit("left-click", r))
      }, null, 8, ["size", "appearance", "type", "icon", "title", "disabled", "class"]),
      de(ot, {
        size: e.size,
        appearance: e.appearance,
        type: e.type,
        icon: e.rightIcon ?? "",
        title: e.title,
        disabled: n.value,
        popovertarget: e.popoverTarget,
        class: S([s.$style.button, s.$style.trigger]),
        onClick: i[1] || (i[1] = (r) => s.$emit("right-click", r))
      }, null, 8, ["size", "appearance", "type", "icon", "title", "disabled", "popovertarget", "class"])
    ], 2));
  }
}), ERe = "_buttonInner_qb4bt_1", PRe = "_button_qb4bt_1", RRe = "_trigger_qb4bt_46", FRe = "_active_qb4bt_50", TRe = {
  buttonInner: ERe,
  button: PRe,
  trigger: RRe,
  active: FRe
}, IRe = {
  $style: TRe
}, Vst = /* @__PURE__ */ Ce(LRe, [["__cssModules", IRe]]), DRe = /* @__PURE__ */ pe({
  __name: "SCAStateBox",
  props: {
    overlay: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    hasError: { type: Boolean, default: !1 },
    overflow: { type: Boolean, default: !0 },
    loadingDebounce: { default: 0 }
  },
  setup(e) {
    const t = e, o = zE(ZE(t, "loading"), t.loadingDebounce), n = F(() => t.loading && o.value), s = F(() => t.hasError ? !1 : t.overlay && t.loading), i = F(() => !t.hasError && (!n.value || s.value)), r = F(() => t.hasError || n.value);
    return (l, a) => (f(), v("div", {
      class: S([l.$style.stateBox, { [l.$style.noOverflow]: !e.overflow }])
    }, [
      r.value ? (f(), v("div", {
        key: 0,
        class: S([{ [l.$style.overlay]: s.value }, "d-flex align-items-center justify-content-center p-4"])
      }, [
        e.hasError ? (f(), U(hEe, {
          key: 0,
          type: "error",
          title: l.$t("common.message.errorError2"),
          description: l.$t("common.message.componentLoadError")
        }, {
          default: ee(() => [
            l.$slots.action ? ve(l.$slots, "action", { key: 0 }) : $("", !0)
          ]),
          _: 3
        }, 8, ["title", "description"])) : n.value ? (f(), U(i1, {
          key: 1,
          class: S(l.$style.loader)
        }, null, 8, ["class"])) : $("", !0)
      ], 2)) : $("", !0),
      i.value ? ve(l.$slots, "default", { key: 1 }) : $("", !0)
    ], 2));
  }
}), kRe = "_stateBox_1ss5m_1", HRe = "_noOverflow_1ss5m_6", VRe = "_overlay_1ss5m_9", ORe = "_loader_1ss5m_19", BRe = {
  stateBox: kRe,
  noOverflow: HRe,
  overlay: VRe,
  loader: ORe
}, $Re = {
  $style: BRe
}, g2 = /* @__PURE__ */ Ce(DRe, [["__cssModules", $Re]]), ZRe = { key: 1 }, GRe = /* @__PURE__ */ pe({
  __name: "SCAStatus",
  props: {
    appearance: { default: "blue" },
    emphasis: { default: "medium" },
    hideDot: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = Qt(), o = F(() => !!t.default);
    return (n, s) => (f(), v("div", {
      class: S([
        n.$style.status,
        n.$style[`appearance_${e.appearance}_${e.emphasis}`],
        {
          [n.$style.dotOnly]: !o.value
        }
      ])
    }, [
      e.hideDot ? $("", !0) : (f(), U(Ae, {
        key: 0,
        class: S(n.$style.dot),
        icon: "generic/dot",
        size: "8px"
      }, null, 8, ["class"])),
      o.value ? (f(), v("div", ZRe, [
        ve(n.$slots, "default")
      ])) : $("", !0)
    ], 2));
  }
}), NRe = "_status_1q6vn_747", zRe = "_appearance_blue_high_1q6vn_763", jRe = "_appearance_blue_medium_1q6vn_767", WRe = "_appearance_blue_low_1q6vn_771", URe = "_appearance_green_high_1q6vn_775", KRe = "_appearance_green_medium_1q6vn_779", qRe = "_appearance_green_low_1q6vn_783", YRe = "_appearance_grey_high_1q6vn_787", QRe = "_appearance_grey_medium_1q6vn_791", JRe = "_appearance_grey_low_1q6vn_795", XRe = "_appearance_red_high_1q6vn_799", eFe = "_appearance_red_medium_1q6vn_803", tFe = "_appearance_red_low_1q6vn_807", oFe = "_appearance_orange_high_1q6vn_811", nFe = "_appearance_orange_medium_1q6vn_815", sFe = "_appearance_orange_low_1q6vn_819", iFe = "_appearance_raspberry_high_1q6vn_823", rFe = "_appearance_raspberry_medium_1q6vn_827", lFe = "_appearance_raspberry_low_1q6vn_831", aFe = "_appearance_magenta_high_1q6vn_835", cFe = "_appearance_magenta_medium_1q6vn_839", dFe = "_appearance_magenta_low_1q6vn_843", uFe = "_appearance_purple_high_1q6vn_847", hFe = "_appearance_purple_medium_1q6vn_851", gFe = "_appearance_purple_low_1q6vn_855", pFe = "_appearance_grape_high_1q6vn_859", fFe = "_appearance_grape_medium_1q6vn_863", vFe = "_appearance_grape_low_1q6vn_867", mFe = "_appearance_violet_high_1q6vn_871", CFe = "_appearance_violet_medium_1q6vn_875", wFe = "_appearance_violet_low_1q6vn_879", bFe = "_appearance_cyan_high_1q6vn_883", yFe = "_appearance_cyan_medium_1q6vn_887", _Fe = "_appearance_cyan_low_1q6vn_891", SFe = "_appearance_teal_high_1q6vn_895", xFe = "_appearance_teal_medium_1q6vn_899", MFe = "_appearance_teal_low_1q6vn_903", AFe = "_appearance_aquamarine_high_1q6vn_907", LFe = "_appearance_aquamarine_medium_1q6vn_911", EFe = "_appearance_aquamarine_low_1q6vn_915", PFe = "_appearance_emerald_high_1q6vn_919", RFe = "_appearance_emerald_medium_1q6vn_923", FFe = "_appearance_emerald_low_1q6vn_927", TFe = "_appearance_white_high_1q6vn_931", IFe = "_appearance_white_medium_1q6vn_935", DFe = "_appearance_white_low_1q6vn_939", kFe = "_dotOnly_1q6vn_943", HFe = "_dot_1q6vn_943", VFe = {
  status: NRe,
  appearance_blue_high: zRe,
  appearance_blue_medium: jRe,
  appearance_blue_low: WRe,
  appearance_green_high: URe,
  appearance_green_medium: KRe,
  appearance_green_low: qRe,
  appearance_grey_high: YRe,
  appearance_grey_medium: QRe,
  appearance_grey_low: JRe,
  appearance_red_high: XRe,
  appearance_red_medium: eFe,
  appearance_red_low: tFe,
  appearance_orange_high: oFe,
  appearance_orange_medium: nFe,
  appearance_orange_low: sFe,
  appearance_raspberry_high: iFe,
  appearance_raspberry_medium: rFe,
  appearance_raspberry_low: lFe,
  appearance_magenta_high: aFe,
  appearance_magenta_medium: cFe,
  appearance_magenta_low: dFe,
  appearance_purple_high: uFe,
  appearance_purple_medium: hFe,
  appearance_purple_low: gFe,
  appearance_grape_high: pFe,
  appearance_grape_medium: fFe,
  appearance_grape_low: vFe,
  appearance_violet_high: mFe,
  appearance_violet_medium: CFe,
  appearance_violet_low: wFe,
  appearance_cyan_high: bFe,
  appearance_cyan_medium: yFe,
  appearance_cyan_low: _Fe,
  appearance_teal_high: SFe,
  appearance_teal_medium: xFe,
  appearance_teal_low: MFe,
  appearance_aquamarine_high: AFe,
  appearance_aquamarine_medium: LFe,
  appearance_aquamarine_low: EFe,
  appearance_emerald_high: PFe,
  appearance_emerald_medium: RFe,
  appearance_emerald_low: FFe,
  appearance_white_high: TFe,
  appearance_white_medium: IFe,
  appearance_white_low: DFe,
  dotOnly: kFe,
  dot: HFe
}, OFe = {
  $style: VFe
}, Ost = /* @__PURE__ */ Ce(GRe, [["__cssModules", OFe]]), BFe = pe({
  inheritAttrs: !1
}), $Fe = /* @__PURE__ */ pe({
  ...BFe,
  __name: "SCATopNavigationItem",
  props: {
    label: { default: void 0 },
    selected: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    icon: { default: void 0 },
    as: { default: "button" },
    appearance: { default: "normal" },
    viewMode: { default: "text" },
    actionIconActive: { type: Boolean, default: !1 },
    active: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, o = Qt(), n = F(() => t.viewMode === "symbolAndText" ? "14px" : "20px"), s = F(() => {
      var r;
      const i = (r = o.actionIcon) == null ? void 0 : r.call(o, {});
      return i ? i.some((l) => l.type !== u7) : !1;
    });
    return (i, r) => (f(), U(Po(e.as), Bt(i.$attrs, {
      class: [
        i.$style.topNavItem,
        {
          [i.$style.selected]: e.selected,
          [i.$style.disabled]: e.disabled,
          [i.$style.appearanceInverted]: e.appearance === "inverted",
          [i.$style.hasIcon]: e.icon,
          [i.$style.modeSymbolAndText]: e.viewMode === "symbolAndText",
          [i.$style.modeSymbol]: e.viewMode === "symbol",
          [i.$style.active]: e.active
        }
      ]
    }), {
      default: ee(() => [
        e.icon ? (f(), U(Ae, {
          key: 0,
          icon: e.icon,
          size: n.value
        }, null, 8, ["icon", "size"])) : $("", !0),
        e.label ? (f(), v("span", {
          key: 1,
          class: S([i.$style.label, { [i.$style.labelCompact]: e.viewMode === "symbolAndText" }])
        }, se(e.label), 3)) : $("", !0),
        s.value ? (f(), v("div", {
          key: 2,
          class: S([
            i.$style.actionIcon,
            {
              [i.$style.actionIconActive]: e.actionIconActive,
              [i.$style.modeSymbolAndText]: e.viewMode === "symbolAndText",
              [i.$style.modeSymbol]: e.viewMode === "symbol"
            }
          ])
        }, [
          ve(i.$slots, "actionIcon")
        ], 2)) : $("", !0)
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), ZFe = "_topNavItem_1eeld_747", GFe = "_hasIcon_1eeld_765", NFe = "_modeSymbolAndText_1eeld_772", zFe = "_modeSymbol_1eeld_772", jFe = "_actionIcon_1eeld_785", WFe = "_disabled_1eeld_789", UFe = "_active_1eeld_789", KFe = "_selected_1eeld_793", qFe = "_appearanceInverted_1eeld_803", YFe = "_labelCompact_1eeld_826", QFe = "_actionIconActive_1eeld_872", JFe = {
  topNavItem: ZFe,
  hasIcon: GFe,
  modeSymbolAndText: NFe,
  modeSymbol: zFe,
  actionIcon: jFe,
  disabled: WFe,
  active: UFe,
  selected: KFe,
  appearanceInverted: qFe,
  labelCompact: YFe,
  actionIconActive: QFe
}, XFe = {
  $style: JFe
}, Bst = /* @__PURE__ */ Ce($Fe, [["__cssModules", XFe]]), eTe = /* @__PURE__ */ pe({
  __name: "SCAWorkspaceItem",
  props: {
    title: {},
    subtitle: {},
    selected: { type: Boolean, default: !1 },
    icon: { default: void 0 },
    expandable: { type: Boolean, default: !1 },
    expanded: { type: Boolean, default: !1 },
    highlighted: { type: Boolean, default: !1 },
    focused: { type: Boolean, default: !1 },
    level: { default: 0 }
  },
  emits: ["click", "toggle-expand"],
  setup(e) {
    const t = e, o = F(() => `${4 + t.level * 28}px`);
    return (n, s) => (f(), v("button", {
      tabindex: "0",
      class: S([
        n.$style.workspaceItem,
        {
          [n.$style.selected]: e.selected,
          [n.$style.highlighted]: e.highlighted,
          [n.$style.focused]: e.focused
        }
      ]),
      style: Ge({ paddingLeft: o.value }),
      onClick: s[1] || (s[1] = (i) => n.$emit("click"))
    }, [
      g("div", {
        class: S(n.$style.inner)
      }, [
        g("div", {
          class: S(n.$style.avatarAndTitles)
        }, [
          ve(n.$slots, "avatar", {}, () => [
            de(oi, {
              size: "small",
              shape: "square",
              appearance: e.selected || e.focused ? "blue" : "white",
              bordered: !e.selected && !e.focused,
              initials: k(dl)(e.title)
            }, {
              default: ee(() => [
                e.icon ? (f(), U(Ae, {
                  key: 0,
                  icon: e.icon,
                  class: S(n.$style.avatarIcon)
                }, null, 8, ["icon", "class"])) : $("", !0)
              ]),
              _: 1
            }, 8, ["appearance", "bordered", "initials"])
          ]),
          g("div", {
            class: S(n.$style.titles)
          }, [
            de(I0, {
              name: "slide-scale",
              mode: "out-in"
            }, {
              default: ee(() => [
                (f(), v("div", {
                  key: e.title,
                  class: S(n.$style.title)
                }, se(e.title), 3))
              ]),
              _: 1
            }),
            de(I0, {
              name: "slide-scale",
              mode: "out-in"
            }, {
              default: ee(() => [
                (f(), v("div", {
                  key: e.subtitle,
                  class: S(n.$style.subtitle)
                }, se(e.subtitle), 3))
              ]),
              _: 1
            })
          ], 2)
        ], 2),
        g("div", {
          class: S(n.$style.expanderIconContainer)
        }, [
          e.expandable ? (f(), U(Ae, {
            key: 0,
            icon: "phosphor/caret-down",
            class: S([n.$style.expanderIcon, { [n.$style.expandedIcon]: e.expanded }]),
            size: "16px",
            onClick: s[0] || (s[0] = xe((i) => n.$emit("toggle-expand"), ["stop"]))
          }, null, 8, ["class"])) : $("", !0)
        ], 2)
      ], 2)
    ], 6));
  }
}), tTe = "_workspaceItem_dd5an_747", oTe = "_inner_dd5an_757", nTe = "_avatarIcon_dd5an_765", sTe = "_expanderIconContainer_dd5an_768", iTe = "_expanderIcon_dd5an_768", rTe = "_expandedIcon_dd5an_778", lTe = "_selected_dd5an_781", aTe = "_highlighted_dd5an_791", cTe = "_focused_dd5an_800", dTe = "_avatarAndTitles_dd5an_811", uTe = "_titles_dd5an_820", hTe = "_title_dd5an_820", gTe = "_subtitle_dd5an_845", pTe = {
  workspaceItem: tTe,
  inner: oTe,
  avatarIcon: nTe,
  expanderIconContainer: sTe,
  expanderIcon: iTe,
  expandedIcon: rTe,
  selected: lTe,
  highlighted: aTe,
  focused: cTe,
  avatarAndTitles: dTe,
  titles: uTe,
  title: hTe,
  subtitle: gTe
}, fTe = {
  $style: pTe
}, $st = /* @__PURE__ */ Ce(eTe, [["__cssModules", fTe]]), vTe = /* @__PURE__ */ pe({
  __name: "SCASplitter",
  emits: ["resize"],
  setup(e, { expose: t, emit: o }) {
    const n = o, s = W(), i = W([]), r = W(!1), l = W(null), { width: a } = l3(), c = F(() => i.value.filter((_) => _.visible && !_.isOverlay));
    rS("splitterContext", {
      registerPanel: (_) => {
        const M = i.value.findIndex((x) => x.id === _.id);
        M === -1 ? i.value.push(_) : i.value[M] = { ..._ }, y();
      },
      unregisterPanel: (_) => {
        i.value = i.value.filter((M) => M.id !== _), y();
      },
      updatePanelSize: (_, M) => {
        const x = i.value.find((L) => L.id === _);
        if (x) {
          const L = x.minSize ?? 0, A = x.maxSize ?? 1 / 0;
          x.size = Math.max(L, Math.min(A, M)), y(), n("resize", { panels: [...i.value] });
        }
      },
      onResizeStart: (_) => {
        r.value = !0, l.value = _;
      },
      onResizeEnd: () => {
        r.value = !1, l.value = null;
      },
      get panels() {
        return T0(i.value);
      }
    }), Me(
      c,
      (_, M) => {
        _.length != M.length && w();
      },
      { deep: !0 }
    );
    const w = () => {
      if (!s.value) return;
      const _ = a.value, L = (c.value.length - 1) * 12, A = _ - L;
      let R = 0;
      if (c.value.forEach((P) => {
        P.size ? R += P.size : R += P.minSize ?? 0;
      }), R > A) {
        const P = c.value.filter((I) => I.size && I.size > (I.minSize ?? 0));
        if (P.length > 0) {
          const I = R - A;
          P.sort((H, O) => (O.size ?? 0) - (H.size ?? 0));
          let B = I;
          for (const H of P) {
            const O = H.minSize ?? 0, N = H.size ?? 0, te = N - O;
            if (te > 0) {
              const E = Math.min(B, te);
              if (H.size = N - E, B -= E, B <= 0) break;
            }
          }
        }
      }
      y();
    }, y = () => {
      if (!s.value) return;
      const _ = i.value.filter((A) => (A.visible || A.isTransitioning) && !A.isOverlay).sort((A, R) => (A.order ?? 0) - (R.order ?? 0)), M = "12px", x = [];
      _.forEach((A, R) => {
        !A.visible && A.isTransitioning ? x.push("0") : A.size !== void 0 && A.size !== null ? A.isOverlay ? x.push("0") : x.push(`${A.size}px`) : A.minSize ? x.push(`minmax(${A.minSize}px, 1fr)`) : x.push("1fr"), R < _.length - 1 && x.push(A.isTransitioning && !A.visible ? "0" : M);
      });
      const L = x.join(" ");
      s.value.style.gridTemplateColumns = L, s.value.style.gridTemplateRows = "100%";
    }, b = F(() => ({
      display: "grid",
      width: "100%",
      height: "100%",
      gap: "0px"
    }));
    return Me(a, () => {
      r.value || y();
    }), At(() => {
      y();
    }), t({
      updateGridTemplate: y,
      panels: T0(i)
    }), (_, M) => (f(), v("div", {
      ref_key: "containerRef",
      ref: s,
      class: S([_.$style.splitter, { [_.$style.resizing]: r.value }]),
      style: Ge(b.value)
    }, [
      ve(_.$slots, "default")
    ], 6));
  }
}), mTe = "_splitter_ti8f0_1", CTe = "_resizing_ti8f0_6", wTe = {
  splitter: mTe,
  resizing: CTe
}, bTe = {
  $style: wTe
}, Zst = /* @__PURE__ */ Ce(vTe, [["__cssModules", bTe]]), yTe = ["data-panel-id"], _Te = /* @__PURE__ */ pe({
  __name: "SCASplitterPanel",
  props: {
    id: {},
    size: { default: void 0 },
    minSize: { default: void 0 },
    maxSize: { default: void 0 },
    visible: { type: Boolean, default: !0 },
    autofill: { type: Boolean, default: !1 },
    isOverlay: { type: Boolean, default: !1 },
    order: { default: void 0 },
    isTransitioning: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, o = n1("splitterContext"), n = F(() => ({
      overflow: "hidden",
      display: t.visible ? "block" : "none"
    }));
    return At(() => {
      o && o.registerPanel({
        id: t.id,
        size: t.size,
        minSize: t.minSize,
        maxSize: t.maxSize,
        visible: t.visible,
        isOverlay: t.isOverlay,
        order: t.order,
        isTransitioning: t.isTransitioning
      });
    }), Qi(() => {
      o && o.unregisterPanel(t.id);
    }), Me(
      () => t.visible,
      (s) => {
        o && o.registerPanel({
          id: t.id,
          size: t.size,
          minSize: t.minSize,
          maxSize: t.maxSize,
          visible: s,
          isOverlay: t.isOverlay,
          order: t.order,
          isTransitioning: t.isTransitioning
        });
      }
    ), Me(
      [() => t.size, () => t.minSize, () => t.maxSize, () => t.isOverlay, () => t.isTransitioning],
      () => {
        o && o.registerPanel({
          id: t.id,
          size: t.size,
          minSize: t.minSize,
          maxSize: t.maxSize,
          visible: t.visible,
          isOverlay: t.isOverlay,
          order: t.order,
          isTransitioning: t.isTransitioning
        });
      }
    ), (s, i) => (f(), v("div", {
      class: S(s.$style.splitterPanel),
      style: Ge(e.isTransitioning ? null : n.value),
      "data-panel-id": e.id
    }, [
      ve(s.$slots, "default")
    ], 14, yTe));
  }
}), STe = "_splitterPanel_19hrh_1", xTe = {
  splitterPanel: STe
}, MTe = {
  $style: xTe
}, Gst = /* @__PURE__ */ Ce(_Te, [["__cssModules", MTe]]), ATe = /* @__PURE__ */ pe({
  __name: "SCASplitterResizer",
  props: {
    leftPanelId: {},
    rightPanelId: {},
    disabled: { type: Boolean }
  },
  setup(e) {
    const t = e, { width: o } = l3(), n = n1("splitterContext"), s = W(!1), i = W(0), r = W(0), l = W(0), a = F(() => n == null ? void 0 : n.panels.find((p) => p.id === t.leftPanelId)), c = F(() => n == null ? void 0 : n.panels.find((p) => p.id === t.rightPanelId)), d = (p) => {
      t.disabled || !n || !a.value || !c.value || (s.value = !0, i.value = p.clientX, r.value = a.value.size ?? 0, l.value = c.value.size ?? 0, n.onResizeStart(t.leftPanelId), document.body.style.setProperty("cursor", "col-resize", "important"), document.body.style.setProperty("user-select", "none", "important"), document.addEventListener("mousemove", u), document.addEventListener("mouseup", h));
    }, u = (p) => {
      if (!s.value || !n || !a.value || !c.value) return;
      let m = p.clientX - i.value;
      const w = a.value.size === void 0, y = c.value.size === void 0, b = a.value.minSize ?? 0, _ = a.value.maxSize ?? 1 / 0, M = c.value.minSize ?? 0, x = c.value.maxSize ?? 1 / 0;
      let L = r.value + m, A = l.value - m;
      w || (L > _ && (m -= L - _, L = _, A = l.value - m), L < b && (m += b - L, L = b, A = l.value - m)), y || (A > x && (m -= A - x, A = x, L = r.value + m), A < M && (m += M - A, A = M, L = r.value + m));
      const R = n.panels.filter((H) => H.visible && !H.isOverlay), P = Math.max(R.length - 1, 0) * 12, I = R.reduce((H, O) => O.id === a.value.id ? H + (w ? O.size ?? O.minSize ?? 0 : L) : O.id === c.value.id ? H + (y ? O.size ?? O.minSize ?? 0 : A) : H + (O.size ?? O.minSize ?? 0), 0), B = o.value - P;
      if (I > B) {
        const H = I - B;
        w ? y || (A -= H, A < M && (A = M), L = r.value + (l.value - A)) : (L -= H, L < b && (L = b), A = l.value - (L - r.value));
      }
      w || n.updatePanelSize(t.leftPanelId, L), y || n.updatePanelSize(t.rightPanelId, A);
    }, h = () => {
      n && (s.value = !1, n.onResizeEnd(t.leftPanelId), document.removeEventListener("mousemove", u), document.removeEventListener("mouseup", h), document.body.style.removeProperty("cursor"), document.body.style.removeProperty("user-select"));
    };
    return (p, C) => (f(), v("div", {
      class: S([
        p.$style.splitterResizer,
        {
          [p.$style.resizer]: s.value,
          [p.$style.disabled]: e.disabled
        }
      ]),
      onMousedown: d
    }, [
      g("div", {
        class: S(p.$style.resizerHandle)
      }, null, 2)
    ], 34));
  }
}), LTe = "_splitterResizer_18mh4_1", ETe = "_disabled_18mh4_13", PTe = "_resizerHandle_18mh4_16", RTe = "_resizer_18mh4_16", FTe = {
  splitterResizer: LTe,
  disabled: ETe,
  resizerHandle: PTe,
  resizer: RTe
}, TTe = {
  $style: FTe
}, Nst = /* @__PURE__ */ Ce(ATe, [["__cssModules", TTe]]);
var ls = class {
  constructor() {
    this.allSyncListeners = /* @__PURE__ */ new Map(), this.allAsyncListeners = /* @__PURE__ */ new Map(), this.globalSyncListeners = /* @__PURE__ */ new Set(), this.globalAsyncListeners = /* @__PURE__ */ new Set(), this.asyncFunctionsQueue = [], this.scheduled = !1, this.firedEvents = {};
  }
  setFrameworkOverrides(e) {
    this.frameworkOverrides = e;
  }
  getListeners(e, t, o) {
    const n = t ? this.allAsyncListeners : this.allSyncListeners;
    let s = n.get(e);
    return !s && o && (s = /* @__PURE__ */ new Set(), n.set(e, s)), s;
  }
  noRegisteredListenersExist() {
    return this.allSyncListeners.size === 0 && this.allAsyncListeners.size === 0 && this.globalSyncListeners.size === 0 && this.globalAsyncListeners.size === 0;
  }
  addEventListener(e, t, o = !1) {
    this.getListeners(e, o, !0).add(t);
  }
  removeEventListener(e, t, o = !1) {
    const n = this.getListeners(e, o, !1);
    n && (n.delete(t), n.size === 0 && (o ? this.allAsyncListeners : this.allSyncListeners).delete(e));
  }
  addGlobalListener(e, t = !1) {
    this.getGlobalListeners(t).add(e);
  }
  removeGlobalListener(e, t = !1) {
    this.getGlobalListeners(t).delete(e);
  }
  dispatchEvent(e) {
    this.dispatchToListeners(e, !0), this.dispatchToListeners(e, !1), this.firedEvents[e.type] = !0;
  }
  dispatchEventOnce(e) {
    this.firedEvents[e.type] || this.dispatchEvent(e);
  }
  dispatchToListeners(e, t) {
    const o = e.type;
    if (t && "event" in e) {
      const l = e.event;
      l instanceof Event && (e.eventPath = l.composedPath());
    }
    const { frameworkOverrides: n } = this, s = (l) => {
      const a = n ? () => n.wrapIncoming(l) : l;
      t ? this.dispatchAsync(a) : a();
    }, i = this.getListeners(o, t, !1);
    if (((i == null ? void 0 : i.size) ?? 0) > 0) {
      const l = new Set(i);
      for (const a of l)
        i != null && i.has(a) && s(() => a(e));
    }
    const r = this.getGlobalListeners(t);
    if (r.size > 0) {
      const l = new Set(r);
      for (const a of l)
        s(() => a(o, e));
    }
  }
  getGlobalListeners(e) {
    return e ? this.globalAsyncListeners : this.globalSyncListeners;
  }
  // this gets called inside the grid's thread, for each event that it
  // wants to set async. the grid then batches the events into one setTimeout()
  // because setTimeout() is an expensive operation. ideally we would have
  // each event in it's own setTimeout(), but we batch for performance.
  dispatchAsync(e) {
    if (this.asyncFunctionsQueue.push(e), !this.scheduled) {
      const t = () => {
        window.setTimeout(this.flushAsyncQueue.bind(this), 0);
      };
      this.frameworkOverrides ? this.frameworkOverrides.wrapIncoming(t) : t(), this.scheduled = !0;
    }
  }
  // this happens in the next VM turn only, and empties the queue of events
  flushAsyncQueue() {
    this.scheduled = !1;
    const e = this.asyncFunctionsQueue.slice();
    this.asyncFunctionsQueue = [], e.forEach((t) => t());
  }
};
function Ft(e) {
  return e == null || e === "" ? null : e;
}
function ue(e) {
  return e != null && e !== "";
}
function Xe(e) {
  return !ue(e);
}
function Co(e) {
  return e != null && typeof e.toString == "function" ? e.toString() : null;
}
function Zr(e, t) {
  const o = e ? JSON.stringify(e) : null, n = t ? JSON.stringify(t) : null;
  return o === n;
}
function vl(e, t, o = !1) {
  const n = e == null, s = t == null;
  if (e && e.toNumber && (e = e.toNumber()), t && t.toNumber && (t = t.toNumber()), n && s)
    return 0;
  if (n)
    return -1;
  if (s)
    return 1;
  function i(r, l) {
    return r > l ? 1 : r < l ? -1 : 0;
  }
  if (typeof e != "string" || !o)
    return i(e, t);
  try {
    return e.localeCompare(t);
  } catch {
    return i(e, t);
  }
}
var ITe = /[&<>"']/g, DTe = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;"
};
function ni(e) {
  return (e == null ? void 0 : e.toString().toString()) ?? null;
}
function xr(e) {
  var t;
  return ((t = ni(e)) == null ? void 0 : t.replace(ITe, (o) => DTe[o])) ?? null;
}
function Ks(e) {
  return e.eRootDiv.getRootNode();
}
function Ue(e) {
  return Ks(e).activeElement;
}
function Pt(e) {
  const { gos: t, eRootDiv: o } = e;
  let n = null;
  const s = t.get("getDocument");
  return s && ue(s) ? n = s() : o && (n = o.ownerDocument), n && ue(n) ? n : document;
}
function Oi(e) {
  const t = Ue(e);
  return t === null || t === Pt(e).body;
}
function JC(e) {
  return Pt(e).defaultView || window;
}
function na(e) {
  let t = null, o = null;
  try {
    t = Pt(e).fullscreenElement;
  } catch {
  } finally {
    t || (t = Ks(e));
    const n = t.querySelector("body");
    n ? o = n : t instanceof ShadowRoot ? o = t : t instanceof Document ? o = t == null ? void 0 : t.documentElement : o = t;
  }
  return o;
}
function kTe(e) {
  const t = na(e);
  return (t == null ? void 0 : t.clientWidth) ?? (window.innerWidth || -1);
}
function HTe(e) {
  const t = na(e);
  return (t == null ? void 0 : t.clientHeight) ?? (window.innerHeight || -1);
}
function io(e, t, o) {
  o == null || typeof o == "string" && o == "" ? p2(e, t) : _o(e, t, o);
}
function _o(e, t, o) {
  e.setAttribute(XC(t), o.toString());
}
function p2(e, t) {
  e.removeAttribute(XC(t));
}
function XC(e) {
  return `aria-${e}`;
}
function no(e, t) {
  t ? e.setAttribute("role", t) : e.removeAttribute("role");
}
function VTe(e) {
  let t;
  return e === "asc" ? t = "ascending" : e === "desc" ? t = "descending" : e === "mixed" ? t = "other" : t = "none", t;
}
function OTe(e) {
  return parseInt(e.getAttribute("aria-posinset"), 10);
}
function BTe(e) {
  return e.getAttribute("aria-label");
}
function ft(e, t) {
  io(e, "label", t);
}
function as(e, t) {
  io(e, "labelledby", t);
}
function sa(e, t) {
  io(e, "describedby", t);
}
function ew(e, t) {
  io(e, "live", t);
}
function $Te(e, t) {
  io(e, "atomic", t);
}
function ZTe(e, t) {
  io(e, "relevant", t);
}
function GTe(e, t) {
  io(e, "invalid", t);
}
function ia(e, t) {
  io(e, "level", t);
}
function ml(e, t) {
  io(e, "disabled", t);
}
function f2(e, t) {
  io(e, "hidden", t);
}
function tw(e, t) {
  io(e, "activedescendant", t);
}
function Fo(e, t) {
  _o(e, "expanded", t);
}
function ow(e) {
  p2(e, "expanded");
}
function ra(e, t) {
  _o(e, "setsize", t);
}
function la(e, t) {
  _o(e, "posinset", t);
}
function NTe(e, t) {
  _o(e, "multiselectable", t);
}
function zTe(e, t) {
  _o(e, "rowcount", t);
}
function Gr(e, t) {
  _o(e, "rowindex", t);
}
function jTe(e, t) {
  _o(e, "rowspan", t);
}
function WTe(e, t) {
  _o(e, "colcount", t);
}
function v2(e, t) {
  _o(e, "colindex", t);
}
function nw(e, t) {
  _o(e, "colspan", t);
}
function UTe(e, t) {
  _o(e, "sort", t);
}
function KTe(e) {
  p2(e, "sort");
}
function m2(e, t) {
  io(e, "selected", t);
}
function sw(e, t) {
  _o(e, "checked", t === void 0 ? "mixed" : t);
}
function qTe(e, t) {
  io(e, "controls", t);
}
function C2(e, t) {
  qTe(e, t.id), as(t, e.id);
}
function md(e, t) {
  io(e, "owns", t);
}
function YTe(e, t) {
  io(e, "haspopup", t === !1 ? null : t);
}
function aa(e, t) {
  return t === void 0 ? e("ariaIndeterminate", "indeterminate") : t === !0 ? e("ariaChecked", "checked") : e("ariaUnchecked", "unchecked");
}
function Cd(e, t, o) {
  const n = e.parentElement;
  let s = n && n.firstChild;
  for (; s; )
    t && s.classList.toggle(t, s === e), s = s.nextSibling;
}
var QTe = "[tabindex], input, select, button, textarea, [href]", iw = "[disabled], .ag-disabled:not(.ag-button), .ag-disabled *";
function w2(e) {
  const t = Element.prototype.matches || Element.prototype.msMatchesSelector, n = t.call(e, "input, select, button, textarea"), s = t.call(e, iw), i = ro(e);
  return n && !s && i;
}
function He(e, t, o = {}) {
  const { skipAriaHidden: n } = o;
  e.classList.toggle("ag-hidden", !t), n || f2(e, !t);
}
function rw(e, t, o = {}) {
  const { skipAriaHidden: n } = o;
  e.classList.toggle("ag-invisible", !t), n || f2(e, !t);
}
function qs(e, t) {
  const o = "disabled", n = t ? (i) => i.setAttribute(o, "") : (i) => i.removeAttribute(o);
  n(e);
  const s = e.querySelectorAll("input") ?? [];
  for (const i of s)
    n(i);
}
function ks(e, t, o) {
  let n = 0;
  for (; e; ) {
    if (e.classList.contains(t))
      return !0;
    if (e = e.parentElement, typeof o == "number") {
      if (++n > o)
        break;
    } else if (e === o)
      break;
  }
  return !1;
}
function si(e) {
  const {
    height: t,
    width: o,
    borderTopWidth: n,
    borderRightWidth: s,
    borderBottomWidth: i,
    borderLeftWidth: r,
    paddingTop: l,
    paddingRight: a,
    paddingBottom: c,
    paddingLeft: d,
    marginTop: u,
    marginRight: h,
    marginBottom: p,
    marginLeft: C,
    boxSizing: m
  } = window.getComputedStyle(e);
  return {
    height: parseFloat(t || "0"),
    width: parseFloat(o || "0"),
    borderTopWidth: parseFloat(n || "0"),
    borderRightWidth: parseFloat(s || "0"),
    borderBottomWidth: parseFloat(i || "0"),
    borderLeftWidth: parseFloat(r || "0"),
    paddingTop: parseFloat(l || "0"),
    paddingRight: parseFloat(a || "0"),
    paddingBottom: parseFloat(c || "0"),
    paddingLeft: parseFloat(d || "0"),
    marginTop: parseFloat(u || "0"),
    marginRight: parseFloat(h || "0"),
    marginBottom: parseFloat(p || "0"),
    marginLeft: parseFloat(C || "0"),
    boxSizing: m
  };
}
function ca(e) {
  const t = si(e);
  return t.boxSizing === "border-box" ? t.height - t.paddingTop - t.paddingBottom : t.height;
}
function Bi(e) {
  const t = si(e);
  return t.boxSizing === "border-box" ? t.width - t.paddingLeft - t.paddingRight : t.width;
}
function b2(e) {
  const { height: t, marginBottom: o, marginTop: n } = si(e);
  return Math.floor(t + o + n);
}
function Nr(e) {
  const { width: t, marginLeft: o, marginRight: n } = si(e);
  return Math.floor(t + o + n);
}
function lw(e) {
  const t = e.getBoundingClientRect(), { borderTopWidth: o, borderLeftWidth: n, borderRightWidth: s, borderBottomWidth: i } = si(e);
  return {
    top: t.top + (o || 0),
    left: t.left + (n || 0),
    right: t.right + (s || 0),
    bottom: t.bottom + (i || 0)
  };
}
function Cl(e, t) {
  let o = e.scrollLeft;
  return t && (o = Math.abs(o)), o;
}
function wl(e, t, o) {
  o && (t *= -1), e.scrollLeft = t;
}
function it(e) {
  for (; e && e.firstChild; )
    e.removeChild(e.firstChild);
}
function Kt(e) {
  e && e.parentNode && e.parentNode.removeChild(e);
}
function aw(e) {
  return !!e.offsetParent;
}
function ro(e) {
  const t = e;
  return t.checkVisibility ? t.checkVisibility({ checkVisibilityCSS: !0 }) : !(!aw(e) || window.getComputedStyle(e).visibility !== "visible");
}
function y2(e) {
  const t = document.createElement("div");
  return t.innerHTML = (e || "").trim(), t.firstChild;
}
function cw(e, t, o) {
  o && o.nextSibling === t || (e.firstChild ? o ? o.nextSibling ? e.insertBefore(t, o.nextSibling) : e.appendChild(t) : e.firstChild && e.firstChild !== t && e.insertAdjacentElement("afterbegin", t) : e.appendChild(t));
}
function dw(e, t) {
  for (let o = 0; o < t.length; o++) {
    const n = t[o], s = e.children[o];
    s !== n && e.insertBefore(n, s);
  }
}
function JTe(e) {
  return e.replace(/[A-Z]/g, (t) => `-${t.toLocaleLowerCase()}`);
}
function a1(e, t) {
  if (t)
    for (const o of Object.keys(t)) {
      const n = t[o];
      if (!o || !o.length || n == null)
        continue;
      const s = JTe(o), i = n.toString(), r = i.replace(/\s*!important/g, ""), l = r.length != i.length ? "important" : void 0;
      e.style.setProperty(s, r, l);
    }
}
function Hs(e) {
  return () => {
    const t = e();
    return t ? _2(t) || uw(t) : !0;
  };
}
function _2(e) {
  return e.clientWidth < e.scrollWidth;
}
function uw(e) {
  return e.clientHeight < e.scrollHeight;
}
function bl(e, t) {
  t === "flex" ? (e.style.removeProperty("width"), e.style.removeProperty("minWidth"), e.style.removeProperty("maxWidth"), e.style.flex = "1 1 auto") : rn(e, t);
}
function rn(e, t) {
  t = S2(t), e.style.width = t, e.style.maxWidth = t, e.style.minWidth = t;
}
function Mr(e, t) {
  t = S2(t), e.style.height = t, e.style.maxHeight = t, e.style.minHeight = t;
}
function S2(e) {
  return typeof e == "number" ? `${e}px` : e;
}
function da(e) {
  return e instanceof Node || e instanceof HTMLElement;
}
function mo(e, t, o) {
  o == null || o === "" ? e.removeAttribute(t) : e.setAttribute(t, o.toString());
}
function mn(e, t, o) {
  const s = JC(e).ResizeObserver, i = s ? new s(o) : null;
  return i == null || i.observe(t), () => i == null ? void 0 : i.disconnect();
}
function yo(e, t) {
  const o = JC(e);
  o.requestAnimationFrame ? o.requestAnimationFrame(t) : o.webkitRequestAnimationFrame ? o.webkitRequestAnimationFrame(t) : o.setTimeout(t, 0);
}
var hw = "data-ref", Ua;
function wd() {
  return Ua ?? (Ua = document.createTextNode(" ")), Ua.cloneNode();
}
function c1(e) {
  const { attrs: t, children: o, cls: n, ref: s, role: i, tag: r } = e, l = document.createElement(r);
  if (n && (l.className = n), s && l.setAttribute(hw, s), i && l.setAttribute("role", i), t)
    for (const a of Object.keys(t))
      l.setAttribute(a, t[a]);
  if (o)
    if (typeof o == "string")
      l.textContent = o;
    else {
      let a = !0;
      for (const c of o)
        c && (typeof c == "string" ? (l.appendChild(document.createTextNode(c)), a = !1) : typeof c == "function" ? l.appendChild(c()) : (a && (l.appendChild(wd()), a = !1), l.append(c1(c)), l.appendChild(wd())));
    }
  return l;
}
var XTe = ["touchstart", "touchend", "touchmove", "touchcancel", "scroll"], eIe = ["wheel"], Ka = {}, gw = /* @__PURE__ */ (() => {
  const e = {
    select: "input",
    change: "input",
    submit: "form",
    reset: "form",
    error: "img",
    load: "img",
    abort: "img"
  };
  return (o) => {
    if (typeof Ka[o] == "boolean")
      return Ka[o];
    const n = document.createElement(e[o] || "div");
    return o = "on" + o, Ka[o] = o in n;
  };
})();
function q0(e, t) {
  return !t || !e ? !1 : oIe(t).indexOf(e) >= 0;
}
function tIe(e) {
  const t = [];
  let o = e.target;
  for (; o; )
    t.push(o), o = o.parentElement;
  return t;
}
function oIe(e) {
  const t = e;
  return t.path ? t.path : t.composedPath ? t.composedPath() : tIe(t);
}
function nIe(e, t, o) {
  const n = sIe(t);
  let s;
  n != null && (s = { passive: n }), e.addEventListener(t, o, s);
}
var sIe = (e) => {
  const t = XTe.includes(e), o = eIe.includes(e);
  if (t)
    return !0;
  if (o)
    return !1;
};
function pw(e, t, o) {
  if (o === 0)
    return !1;
  const n = Math.abs(e.clientX - t.clientX), s = Math.abs(e.clientY - t.clientY);
  return Math.max(n, s) <= o;
}
function zr(e, t) {
  return e.gos.isElementInThisInstance(t.target);
}
function Y0(e, t, o) {
  const s = e.getBoundingClientRect().height, i = kTe(o) - 2, r = HTe(o) - 2;
  if (!e.offsetParent)
    return;
  const a = lw(e.offsetParent), { clientY: c, clientX: d } = t;
  let u = c - a.top - s / 2, h = d - a.left - 10;
  const p = Pt(o), C = p.defaultView || window, m = C.pageYOffset || p.documentElement.scrollTop, w = C.pageXOffset || p.documentElement.scrollLeft;
  i > 0 && h + e.clientWidth > i + w && (h = i + w - e.clientWidth), h < 0 && (h = 0), r > 0 && u + e.clientHeight > r + m && (u = r + m - e.clientHeight), u < 0 && (u = 0), e.style.left = `${h}px`, e.style.top = `${u}px`;
}
function iIe(e, t) {
  return t;
}
function fw(e) {
  return (e == null ? void 0 : e.getLocaleTextFunc()) ?? iIe;
}
function vw(e, t, o, n) {
  const s = t[o];
  return e.getLocaleTextFunc()(
    o,
    typeof s == "function" ? s(n) : s,
    n
  );
}
function rIe(e) {
  return (t, o, n) => e({
    key: t,
    defaultValue: o,
    variableValues: n
  });
}
function lIe(e) {
  return (t, o, n) => {
    let s = e && e[t];
    if (s && n && n.length) {
      let i = 0;
      for (; !(i >= n.length || s.indexOf("${variable}") === -1); )
        s = s.replace("${variable}", n[i++]);
    }
    return s ?? o;
  };
}
var Cn = class {
  constructor() {
    this.destroyFunctions = [], this.destroyed = !1, this.__v_skip = !0, this.propertyListenerId = 0, this.lastChangeSetIdLookup = {}, this.isAlive = () => !this.destroyed;
  }
  preWireBeans(e) {
    this.beans = e, this.stubContext = e.context, this.eventSvc = e.eventSvc, this.gos = e.gos;
  }
  // this was a test constructor niall built, when active, it prints after 5 seconds all beans/components that are
  // not destroyed. to use, create a new grid, then api.destroy() before 5 seconds. then anything that gets printed
  // points to a bean or component that was not properly disposed of.
  // constructor() {
  //     setTimeout(()=> {
  //         if (this.isAlive()) {
  //             let prototype: any = Object.getPrototypeOf(this);
  //             const constructor: any = prototype.constructor;
  //             const constructorString = constructor.toString();
  //             const beanName = constructorString.substring(9, constructorString.indexOf("("));
  //             console.log('is alive ' + beanName);
  //         }
  //     }, 5000);
  // }
  destroy() {
    const { destroyFunctions: e } = this;
    for (let t = 0; t < e.length; t++)
      e[t]();
    e.length = 0, this.destroyed = !0, this.dispatchLocalEvent({ type: "destroyed" });
  }
  /** Add a local event listener against this BeanStub */
  addEventListener(e, t, o) {
    this.localEventService || (this.localEventService = new ls()), this.localEventService.addEventListener(e, t, o);
  }
  /** Remove a local event listener from this BeanStub */
  removeEventListener(e, t, o) {
    var n;
    (n = this.localEventService) == null || n.removeEventListener(e, t, o);
  }
  dispatchLocalEvent(e) {
    var t;
    (t = this.localEventService) == null || t.dispatchEvent(e);
  }
  addManagedElementListeners(e, t) {
    return this._setupListeners(e, t);
  }
  addManagedEventListeners(e) {
    return this._setupListeners(this.eventSvc, e);
  }
  addManagedListeners(e, t) {
    return this._setupListeners(e, t);
  }
  _setupListeners(e, t) {
    const o = [];
    for (const n of Object.keys(t)) {
      const s = t[n];
      s && o.push(this._setupListener(e, n, s));
    }
    return o;
  }
  _setupListener(e, t, o) {
    if (this.destroyed)
      return () => null;
    let n;
    if (aIe(e))
      e.__addEventListener(t, o), n = () => (e.__removeEventListener(t, o), null);
    else {
      const s = cIe(e);
      e instanceof HTMLElement ? nIe(e, t, o) : s ? e.addListener(t, o) : e.addEventListener(t, o), n = s ? () => (e.removeListener(t, o), null) : () => (e.removeEventListener(t, o), null);
    }
    return this.destroyFunctions.push(n), () => (n(), this.destroyFunctions = this.destroyFunctions.filter((s) => s !== n), null);
  }
  /**
   * Setup a managed property listener for the given property.
   * However, stores the destroy function in the beanStub so that if this bean
   * is a component the destroy function will be called when the component is destroyed
   * as opposed to being cleaned up only when the properties service is destroyed.
   */
  setupPropertyListener(e, t) {
    const { gos: o } = this;
    o.addPropertyEventListener(e, t);
    const n = () => (o.removePropertyEventListener(e, t), null);
    return this.destroyFunctions.push(n), () => (n(), this.destroyFunctions = this.destroyFunctions.filter((s) => s !== n), null);
  }
  /**
   * Setup a managed property listener for the given GridOption property.
   * @param event GridOption property to listen to changes for.
   * @param listener Listener to run when property value changes
   */
  addManagedPropertyListener(e, t) {
    return this.destroyed ? () => null : this.setupPropertyListener(e, t);
  }
  /**
   * Setup managed property listeners for the given set of GridOption properties.
   * The listener will be run if any of the property changes but will only run once if
   * multiple of the properties change within the same framework lifecycle event.
   * Works on the basis that GridOptionsService updates all properties *before* any property change events are fired.
   * @param events Array of GridOption properties to listen for changes too.
   * @param listener Shared listener to run if any of the properties change
   */
  addManagedPropertyListeners(e, t) {
    if (this.destroyed)
      return;
    const o = e.join("-") + this.propertyListenerId++, n = (s) => {
      if (s.changeSet) {
        if (s.changeSet && s.changeSet.id === this.lastChangeSetIdLookup[o])
          return;
        this.lastChangeSetIdLookup[o] = s.changeSet.id;
      }
      const i = {
        type: "propertyChanged",
        changeSet: s.changeSet,
        source: s.source
      };
      t(i);
    };
    e.forEach((s) => this.setupPropertyListener(s, n));
  }
  getLocaleTextFunc() {
    return fw(this.beans.localeSvc);
  }
  addDestroyFunc(e) {
    this.isAlive() ? this.destroyFunctions.push(e) : e();
  }
  /** doesn't throw an error if `bean` is undefined */
  createOptionalManagedBean(e, t) {
    return e ? this.createManagedBean(e, t) : void 0;
  }
  createManagedBean(e, t) {
    const o = this.createBean(e, t);
    return this.addDestroyFunc(this.destroyBean.bind(this, e, t)), o;
  }
  createBean(e, t, o) {
    return (t || this.stubContext).createBean(e, o);
  }
  /**
   * Destroys a bean and returns undefined to support destruction and clean up in a single line.
   * this.dateComp = this.context.destroyBean(this.dateComp);
   */
  destroyBean(e, t) {
    return (t || this.stubContext).destroyBean(e);
  }
  /**
   * Destroys an array of beans and returns an empty array to support destruction and clean up in a single line.
   * this.dateComps = this.context.destroyBeans(this.dateComps);
   */
  destroyBeans(e, t) {
    return (t || this.stubContext).destroyBeans(e);
  }
};
function aIe(e) {
  return e.__addEventListener !== void 0;
}
function cIe(e) {
  return e.eventServiceType === "global";
}
var K = class extends Cn {
}, bd = {};
function x2(e, t) {
  bd[t] || (e(), bd[t] = !0);
}
var dIe = {
  pending: !1,
  funcs: []
}, uIe = {
  pending: !1,
  funcs: []
};
function Q0(e, t = "setTimeout", o) {
  const n = t === "raf" ? uIe : dIe;
  if (n.funcs.push(e), n.pending)
    return;
  n.pending = !0;
  const s = () => {
    const i = n.funcs.slice();
    n.funcs.length = 0, n.pending = !1, i.forEach((r) => r());
  };
  t === "raf" ? yo(o, s) : window.setTimeout(s, 0);
}
function Rt(e, t, o) {
  let n;
  return function(...s) {
    const i = this;
    window.clearTimeout(n), n = window.setTimeout(function() {
      e.isAlive() && t.apply(i, s);
    }, o);
  };
}
function yd(e, t) {
  let o = 0;
  return function(...n) {
    const s = this, i = Date.now();
    i - o < t || (o = i, e.apply(s, n));
  };
}
function mw(e, t, o, n = 100) {
  const s = Date.now();
  let i = null, r = !1;
  const l = () => {
    i != null && (window.clearInterval(i), i = null);
  };
  e.addDestroyFunc(l);
  const a = () => {
    const c = Date.now() - s > n;
    (t() || c) && (o(), r = !0, l());
  };
  a(), r || (i = window.setInterval(a, 10));
}
var Cw = /* @__PURE__ */ new Set(["__proto__", "constructor", "prototype"]);
function hIe(e, t) {
  if (e != null) {
    if (Array.isArray(e)) {
      for (let o = 0; o < e.length; o++)
        t(o.toString(), e[o]);
      return;
    }
    for (const o of Object.keys(e).filter((n) => !Cw.has(n)))
      t(o, e[o]);
  }
}
function qt(e, t, o = !0, n = !1) {
  ue(t) && hIe(t, (s, i) => {
    let r = e[s];
    r !== i && (n && r == null && i != null && typeof i == "object" && i.constructor === Object && (r = {}, e[s] = r), _d(i) && _d(r) && !Array.isArray(r) ? qt(r, i, o, n) : (o || i !== void 0) && (e[s] = i));
  });
}
function _d(e) {
  return typeof e == "object" && e !== null;
}
var M2 = class Ss {
  /**
   * @param providedOptions
   * @returns Shallow copy of the provided options with global options merged in.
   */
  static applyGlobalGridOptions(t) {
    if (!Ss.gridOptions)
      return { ...t };
    let o = {};
    return qt(o, Ss.gridOptions, !0, !0), Ss.mergeStrategy === "deep" ? qt(o, t, !0, !0) : o = { ...o, ...t }, Ss.gridOptions.context && (o.context = Ss.gridOptions.context), t.context && (Ss.mergeStrategy === "deep" && o.context && qt(t.context, o.context, !0, !0), o.context = t.context), o;
  }
};
M2.gridOptions = void 0;
M2.mergeStrategy = "shallow";
var gIe = M2, pIe = {
  suppressContextMenu: !1,
  preventDefaultOnContextMenu: !1,
  allowContextMenuWithControlKey: !1,
  suppressMenuHide: !0,
  enableBrowserTooltips: !1,
  tooltipTrigger: "hover",
  tooltipShowDelay: 2e3,
  tooltipHideDelay: 1e4,
  tooltipMouseTrack: !1,
  tooltipShowMode: "standard",
  tooltipInteraction: !1,
  copyHeadersToClipboard: !1,
  copyGroupHeadersToClipboard: !1,
  clipboardDelimiter: "	",
  suppressCopyRowsToClipboard: !1,
  suppressCopySingleCellRanges: !1,
  suppressLastEmptyLineOnPaste: !1,
  suppressClipboardPaste: !1,
  suppressClipboardApi: !1,
  suppressCutToClipboard: !1,
  maintainColumnOrder: !1,
  enableStrictPivotColumnOrder: !1,
  suppressFieldDotNotation: !1,
  allowDragFromColumnsToolPanel: !1,
  suppressMovableColumns: !1,
  suppressColumnMoveAnimation: !1,
  suppressMoveWhenColumnDragging: !1,
  suppressDragLeaveHidesColumns: !1,
  suppressRowGroupHidesColumns: !1,
  suppressAutoSize: !1,
  autoSizePadding: 20,
  skipHeaderOnAutoSize: !1,
  singleClickEdit: !1,
  suppressClickEdit: !1,
  readOnlyEdit: !1,
  stopEditingWhenCellsLoseFocus: !1,
  enterNavigatesVertically: !1,
  enterNavigatesVerticallyAfterEdit: !1,
  enableCellEditingOnBackspace: !1,
  undoRedoCellEditing: !1,
  undoRedoCellEditingLimit: 10,
  suppressCsvExport: !1,
  suppressExcelExport: !1,
  cacheQuickFilter: !1,
  includeHiddenColumnsInQuickFilter: !1,
  excludeChildrenWhenTreeDataFiltering: !1,
  enableAdvancedFilter: !1,
  includeHiddenColumnsInAdvancedFilter: !1,
  enableCharts: !1,
  masterDetail: !1,
  keepDetailRows: !1,
  keepDetailRowsCount: 10,
  detailRowAutoHeight: !1,
  tabIndex: 0,
  rowBuffer: 10,
  valueCache: !1,
  valueCacheNeverExpires: !1,
  enableCellExpressions: !1,
  suppressTouch: !1,
  suppressFocusAfterRefresh: !1,
  suppressBrowserResizeObserver: !1,
  suppressPropertyNamesCheck: !1,
  suppressChangeDetection: !1,
  debug: !1,
  suppressLoadingOverlay: !1,
  suppressNoRowsOverlay: !1,
  pagination: !1,
  paginationPageSize: 100,
  paginationPageSizeSelector: !0,
  paginationAutoPageSize: !1,
  paginateChildRows: !1,
  suppressPaginationPanel: !1,
  pivotMode: !1,
  pivotPanelShow: "never",
  pivotDefaultExpanded: 0,
  pivotSuppressAutoColumn: !1,
  suppressExpandablePivotGroups: !1,
  functionsReadOnly: !1,
  suppressAggFuncInHeader: !1,
  alwaysAggregateAtRootLevel: !1,
  aggregateOnlyChangedColumns: !1,
  suppressAggFilteredOnly: !1,
  removePivotHeaderRowWhenSingleValueColumn: !1,
  animateRows: !0,
  cellFlashDuration: 500,
  cellFadeDuration: 1e3,
  allowShowChangeAfterFilter: !1,
  domLayout: "normal",
  ensureDomOrder: !1,
  enableRtl: !1,
  suppressColumnVirtualisation: !1,
  suppressMaxRenderedRowRestriction: !1,
  suppressRowVirtualisation: !1,
  rowDragManaged: !1,
  rowDragInsertDelay: 500,
  suppressRowDrag: !1,
  suppressMoveWhenRowDragging: !1,
  rowDragEntireRow: !1,
  rowDragMultiRow: !1,
  embedFullWidthRows: !1,
  groupDisplayType: "singleColumn",
  groupDefaultExpanded: 0,
  groupMaintainOrder: !1,
  groupSelectsChildren: !1,
  groupSuppressBlankHeader: !1,
  groupSelectsFiltered: !1,
  showOpenedGroup: !1,
  groupRemoveSingleChildren: !1,
  groupRemoveLowestSingleChildren: !1,
  groupHideOpenParents: !1,
  groupAllowUnbalanced: !1,
  rowGroupPanelShow: "never",
  suppressMakeColumnVisibleAfterUnGroup: !1,
  treeData: !1,
  rowGroupPanelSuppressSort: !1,
  suppressGroupRowsSticky: !1,
  rowModelType: "clientSide",
  asyncTransactionWaitMillis: 50,
  suppressModelUpdateAfterUpdateTransaction: !1,
  cacheOverflowSize: 1,
  infiniteInitialRowCount: 1,
  serverSideInitialRowCount: 1,
  cacheBlockSize: 100,
  maxBlocksInCache: -1,
  maxConcurrentDatasourceRequests: 2,
  blockLoadDebounceMillis: 0,
  purgeClosedRowNodes: !1,
  serverSideSortAllLevels: !1,
  serverSideOnlyRefreshFilteredGroups: !1,
  serverSidePivotResultFieldSeparator: "_",
  viewportRowModelPageSize: 5,
  viewportRowModelBufferSize: 5,
  alwaysShowHorizontalScroll: !1,
  alwaysShowVerticalScroll: !1,
  debounceVerticalScrollbar: !1,
  suppressHorizontalScroll: !1,
  suppressScrollOnNewData: !1,
  suppressScrollWhenPopupsAreOpen: !1,
  suppressAnimationFrame: !1,
  suppressMiddleClickScrolls: !1,
  suppressPreventDefaultOnMouseWheel: !1,
  rowMultiSelectWithClick: !1,
  suppressRowDeselection: !1,
  suppressRowClickSelection: !1,
  suppressCellFocus: !1,
  suppressHeaderFocus: !1,
  suppressMultiRangeSelection: !1,
  enableCellTextSelection: !1,
  enableRangeSelection: !1,
  enableRangeHandle: !1,
  enableFillHandle: !1,
  fillHandleDirection: "xy",
  suppressClearOnFillReduction: !1,
  accentedSort: !1,
  unSortIcon: !1,
  suppressMultiSort: !1,
  alwaysMultiSort: !1,
  suppressMaintainUnsortedOrder: !1,
  suppressRowHoverHighlight: !1,
  suppressRowTransform: !1,
  columnHoverHighlight: !1,
  deltaSort: !1,
  enableGroupEdit: !1,
  groupLockGroupColumns: 0,
  serverSideEnableClientSideSort: !1,
  suppressServerSideFullWidthLoadingRow: !1,
  pivotMaxGeneratedColumns: -1,
  columnMenu: "new",
  reactiveCustomComponents: !0,
  suppressSetFilterByDefault: !1,
  rowNumbers: !1,
  enableFilterHandlers: !1
}, ww = "https://www.ag-grid.com";
function cs(e, t, ...o) {
  e.get("debug") && console.log("AG Grid: " + t, ...o);
}
function Ar(e, ...t) {
  x2(() => console.warn("AG Grid: " + e, ...t), e + (t == null ? void 0 : t.join("")));
}
function Ai(e, ...t) {
  x2(() => console.error("AG Grid: " + e, ...t), e + (t == null ? void 0 : t.join("")));
}
var be = "34.2.0", Sd = 2e3, xd = 100, bw = "_version_", j1 = null, Li = `${ww}/javascript-data-grid`;
function fIe(e) {
  j1 = e;
}
function vIe(e) {
  Li = e;
}
function yw(e, t, o) {
  return (j1 == null ? void 0 : j1(e, t)) ?? [bIe(e, t, o)];
}
function A2(e, t, o, n, s) {
  e(`${n ? "warning" : "error"} #${t}`, ...yw(t, o, s));
}
function mIe(e) {
  if (!e)
    return String(e);
  const t = {};
  for (const o of Object.keys(e))
    typeof e[o] != "object" && typeof e[o] != "function" && (t[o] = e[o]);
  return JSON.stringify(t);
}
function CIe(e) {
  let t = e;
  return e instanceof Error ? t = e.toString() : typeof e == "object" && (t = mIe(e)), t;
}
function yl(e) {
  return e === void 0 ? "undefined" : e === null ? "null" : e;
}
function J0(e, t) {
  return `${e}?${t.toString()}`;
}
function wIe(e, t, o) {
  const n = Array.from(t.entries()).sort((i, r) => r[1].length - i[1].length);
  let s = J0(e, t);
  for (const [i, r] of n) {
    if (i === bw)
      continue;
    const l = s.length - o;
    if (l <= 0)
      break;
    const a = "...", c = l + a.length, d = r.length - c > xd ? r.slice(0, r.length - c) + a : r.slice(0, xd) + a;
    t.set(i, d), s = J0(e, t);
  }
  return s;
}
function _w(e, t) {
  const o = new URLSearchParams();
  if (o.append(bw, be), t)
    for (const i of Object.keys(t))
      o.append(i, CIe(t[i]));
  const n = `${Li}/errors/${e}`, s = J0(n, o);
  return s.length <= Sd ? s : wIe(n, o, Sd);
}
var bIe = (e, t, o) => {
  const n = _w(e, t);
  return `${o ? o + ` 
` : ""}Visit ${n}${o ? "" : ` 
  Alternatively register the ValidationModule to see the full message in the console.`}`;
};
function X(...e) {
  A2(Ar, e[0], e[1], !0);
}
function qe(...e) {
  A2(Ai, e[0], e[1], !1);
}
function Cr(e, t, o) {
  A2(Ai, e, t, !1, o);
}
function yIe(e, t) {
  const o = t[0];
  return `error #${o} ` + yw(o, t[1], e).join(" ");
}
function ln(...e) {
  return yIe(void 0, e);
}
function Sw(e, t) {
  return e.get("rowModelType") === t;
}
function dt(e, t) {
  return Sw(e, "clientSide");
}
function $n(e, t) {
  return Sw(e, "serverSide");
}
function jt(e, t) {
  return e.get("domLayout") === t;
}
function os(e) {
  return _l(e) !== void 0;
}
function xw(e) {
  return typeof e.get("getRowHeight") == "function";
}
function _Ie(e, t) {
  return t ? !e.get("enableStrictPivotColumnOrder") : e.get("maintainColumnOrder");
}
function Dn(e, t, o = !1, n) {
  const { gos: s, environment: i } = e;
  if (n == null && (n = i.getDefaultRowHeight()), xw(s)) {
    if (o)
      return { height: n, estimated: !0 };
    const a = {
      node: t,
      data: t.data
    }, c = s.getCallback("getRowHeight")(a);
    if (X0(c))
      return c === 0 && X(23), { height: Math.max(1, c), estimated: !1 };
  }
  if (t.detail && s.get("masterDetail"))
    return SIe(s);
  const r = s.get("rowHeight");
  return { height: r && X0(r) ? r : n, estimated: !1 };
}
function SIe(e) {
  if (e.get("detailRowAutoHeight"))
    return { height: 1, estimated: !1 };
  const t = e.get("detailRowHeight");
  return X0(t) ? { height: t, estimated: !1 } : { height: 300, estimated: !1 };
}
function Vs(e) {
  const { environment: t, gos: o } = e, n = o.get("rowHeight");
  if (!n || Xe(n))
    return t.getDefaultRowHeight();
  const s = t.refreshRowHeightVariable();
  return s !== -1 ? s : (X(24), t.getDefaultRowHeight());
}
function X0(e) {
  return !isNaN(e) && typeof e == "number" && isFinite(e);
}
function Mw(e, t, o) {
  const n = t[e.getDomDataKey()];
  return n ? n[o] : void 0;
}
function Ys(e, t, o, n) {
  const s = e.getDomDataKey();
  let i = t[s];
  Xe(i) && (i = {}, t[s] = i), i[o] = n;
}
function Ei(e) {
  return e.get("ensureDomOrder") ? !1 : e.get("animateRows");
}
function ua(e) {
  return !(e.get("paginateChildRows") || e.get("groupHideOpenParents") || jt(e, "print"));
}
function Oo(e) {
  const t = e.get("autoGroupColumnDef");
  return !(t != null && t.comparator) && !e.get("treeData");
}
function jr(e) {
  const t = e.get("groupAggFiltering");
  if (typeof t == "function")
    return e.getCallback("groupAggFiltering");
  if (t === !0)
    return () => !0;
}
function or(e) {
  return e.get("grandTotalRow");
}
function Aw(e) {
  const t = e.get("groupTotalRow");
  return typeof t == "function" ? e.getCallback("groupTotalRow") : () => t ?? void 0;
}
function Lw(e) {
  return e.get("groupHideOpenParents") ? !0 : e.get("groupDisplayType") === "multipleColumns";
}
function L2(e, t) {
  return t ? !1 : e.get("groupDisplayType") === "groupRows";
}
function Ew(e, t, o) {
  return !!t.group && !t.footer && L2(e, o);
}
function Qs(e) {
  const t = e.getCallback("getRowId");
  return t === void 0 ? t : (o) => {
    let n = t(o);
    return typeof n != "string" && (x2(() => X(25, { id: n }), "getRowIdString"), n = String(n)), n;
  };
}
function xIe(e, t) {
  const o = e.get("groupHideParentOfSingleChild");
  return !!(o === !0 || o === "leafGroupsOnly" && t.leafGroup || e.get("groupRemoveSingleChildren") || e.get("groupRemoveLowestSingleChildren") && t.leafGroup);
}
function MIe(e) {
  const t = e.get("maxConcurrentDatasourceRequests");
  return t > 0 ? t : void 0;
}
function Pw(e, t) {
  const o = e.get("suppressGroupChangesColumnVisibility");
  if (o === !0 || t && o === "suppressHideOnGroup" || !t && o === "suppressShowOnUngroup")
    return !1;
  const n = e.get("suppressRowGroupHidesColumns");
  if (t && n === !0)
    return !1;
  const s = e.get("suppressMakeColumnVisibleAfterUnGroup");
  return !(!t && s === !0);
}
function Os(e) {
  return (e == null ? void 0 : e.checkboxes) ?? !0;
}
function W1(e) {
  return (e == null ? void 0 : e.mode) === "multiRow" && (e.headerCheckbox ?? !0);
}
function Wr(e) {
  if (typeof e == "object")
    return e.checkboxLocation ?? "selectionColumn";
}
function qa(e) {
  return (e == null ? void 0 : e.hideDisabledCheckboxes) ?? !1;
}
function AIe(e) {
  return typeof e.get("rowSelection") != "string";
}
function kn(e) {
  const t = e.get("cellSelection");
  return t !== void 0 ? !!t : e.get("enableRangeSelection");
}
function Rw(e) {
  const t = e.get("rowSelection") ?? "single";
  if (typeof t == "string") {
    const o = e.get("suppressRowClickSelection"), n = e.get("suppressRowDeselection");
    return o && n ? !1 : o ? "enableDeselection" : n ? "enableSelection" : !0;
  }
  return t.mode === "singleRow" || t.mode === "multiRow" ? t.enableClickSelection ?? !1 : !1;
}
function LIe(e) {
  const t = Rw(e);
  return t === !0 || t === "enableSelection";
}
function EIe(e) {
  const t = Rw(e);
  return t === !0 || t === "enableDeselection";
}
function e5(e) {
  const t = e.get("rowSelection");
  return typeof t == "string" ? e.get("isRowSelectable") : t == null ? void 0 : t.isRowSelectable;
}
function _l(e) {
  const t = "beanName" in e && e.beanName === "gos" ? e.get("rowSelection") : e.rowSelection;
  if (typeof t == "string")
    switch (t) {
      case "multiple":
        return "multiRow";
      case "single":
        return "singleRow";
      default:
        return;
    }
  switch (t == null ? void 0 : t.mode) {
    case "multiRow":
    case "singleRow":
      return t.mode;
    default:
      return;
  }
}
function Ur(e) {
  return _l(e) === "multiRow";
}
function PIe(e) {
  const t = e.get("rowSelection");
  return typeof t == "string" ? e.get("rowMultiSelectWithClick") : (t == null ? void 0 : t.enableSelectionWithoutKeys) ?? !1;
}
function Sl(e) {
  const t = e.get("rowSelection");
  if (typeof t == "string") {
    const o = e.get("groupSelectsChildren"), n = e.get("groupSelectsFiltered");
    return o && n ? "filteredDescendants" : o ? "descendants" : "self";
  }
  return (t == null ? void 0 : t.mode) === "multiRow" ? t.groupSelects : void 0;
}
function Fw(e, t = !0) {
  const o = e.get("rowSelection");
  return typeof o != "object" ? t ? "all" : void 0 : o.mode === "multiRow" ? o.selectAll : "all";
}
function Kr(e) {
  const t = Sl(e);
  return t === "descendants" || t === "filteredDescendants";
}
function Md(e) {
  const t = e.get("rowSelection");
  return typeof t == "object" && t.masterSelects || "self";
}
function RIe(e) {
  return e.isModuleRegistered("SetFilter") && !e.get("suppressSetFilterByDefault");
}
function $t(e) {
  return e.get("columnMenu") === "legacy";
}
function Tw(e) {
  return !$t(e);
}
function FIe(e) {
  return !e || e.length < 2 ? e : "on" + e[0].toUpperCase() + e.substring(1);
}
function TIe(e, t, o) {
  typeof e != "object" && (e = {});
  const n = { ...e };
  return o.forEach((s) => {
    const i = t[s];
    typeof i < "u" && (n[s] = i);
  }), n;
}
function IIe(e, t) {
  if (!e)
    return;
  const o = {};
  let n = !1;
  if (Object.keys(e).forEach((r) => {
    o[r] = e[r], n = !0;
  }), !n)
    return;
  const s = {
    type: "gridOptionsChanged",
    options: o
  };
  t.dispatchEvent(s);
  const i = {
    type: "componentStateChanged",
    ...o
  };
  t.dispatchEvent(i);
}
function Pe(e, t) {
  return e.addCommon(t);
}
function E2(e) {
  return e.get("treeData") ? e.get("treeDataParentIdField") ? "treeSelfRef" : e.get("treeDataChildrenField") ? "treeNested" : "treePath" : "group";
}
function Ad({ gos: e }, t) {
  return t.button === 2 || t.ctrlKey && e.get("allowContextMenuWithControlKey");
}
var DIe = {
  resizable: !0,
  sortable: !0
}, kIe = 0;
function Iw() {
  return kIe++;
}
function hn(e) {
  return e instanceof Zn;
}
var Zn = class extends K {
  constructor(e, t, o, n) {
    super(), this.colDef = e, this.userProvidedColDef = t, this.colId = o, this.primary = n, this.isColumn = !0, this.instanceId = Iw(), this.autoHeaderHeight = null, this.moving = !1, this.resizing = !1, this.menuVisible = !1, this.lastLeftPinned = !1, this.firstRightPinned = !1, this.filterActive = !1, this.colEventSvc = new ls(), this.tooltipEnabled = !1, this.rowGroupActive = !1, this.pivotActive = !1, this.aggregationActive = !1, this.flex = null, this.colIdSanitised = xr(o);
  }
  destroy() {
    var e;
    super.destroy(), (e = this.beans.rowSpanSvc) == null || e.deregister(this);
  }
  getInstanceId() {
    return this.instanceId;
  }
  setState() {
    const {
      colDef: e,
      beans: { sortSvc: t, pinnedCols: o, colFlex: n }
    } = this;
    t == null || t.initCol(this);
    const s = e.hide;
    s !== void 0 ? this.visible = !s : this.visible = !e.initialHide, o == null || o.initCol(this), n == null || n.initCol(this);
  }
  // gets called when user provides an alternative colDef, eg
  setColDef(e, t, o) {
    var s;
    const n = e.spanRows !== this.colDef.spanRows;
    this.colDef = e, this.userProvidedColDef = t, this.initMinAndMaxWidths(), this.initDotNotation(), this.initTooltip(), n && ((s = this.beans.rowSpanSvc) == null || s.deregister(this), this.initRowSpan()), this.dispatchColEvent("colDefChanged", o);
  }
  getUserProvidedColDef() {
    return this.userProvidedColDef;
  }
  getParent() {
    return this.parent;
  }
  getOriginalParent() {
    return this.originalParent;
  }
  // this is done after constructor as it uses gridOptionsService
  postConstruct() {
    this.setState(), this.initMinAndMaxWidths(), this.resetActualWidth("gridInitializing"), this.initDotNotation(), this.initTooltip(), this.initRowSpan(), this.addPivotListener();
  }
  initDotNotation() {
    const {
      gos: e,
      colDef: { field: t, tooltipField: o }
    } = this, n = e.get("suppressFieldDotNotation");
    this.fieldContainsDots = ue(t) && t.indexOf(".") >= 0 && !n, this.tooltipFieldContainsDots = ue(o) && o.indexOf(".") >= 0 && !n;
  }
  initMinAndMaxWidths() {
    const e = this.colDef;
    this.minWidth = e.minWidth ?? this.beans.environment.getDefaultColumnMinWidth(), this.maxWidth = e.maxWidth ?? Number.MAX_SAFE_INTEGER;
  }
  initTooltip() {
    var e;
    (e = this.beans.tooltipSvc) == null || e.initCol(this);
  }
  initRowSpan() {
    var e;
    this.colDef.spanRows && ((e = this.beans.rowSpanSvc) == null || e.register(this));
  }
  addPivotListener() {
    const e = this.beans.pivotColDefSvc, t = this.colDef.pivotValueColumn;
    !e || !t || this.addManagedListeners(t, {
      colDefChanged: (o) => {
        const n = e.recreateColDef(this.colDef);
        this.setColDef(n, n, o.source);
      }
    });
  }
  resetActualWidth(e) {
    const t = this.calculateColInitialWidth(this.colDef);
    this.setActualWidth(t, e, !0);
  }
  calculateColInitialWidth(e) {
    let t;
    const o = e.width, n = e.initialWidth;
    return o != null ? t = o : n != null ? t = n : t = 200, Math.max(Math.min(t, this.maxWidth), this.minWidth);
  }
  isEmptyGroup() {
    return !1;
  }
  isRowGroupDisplayed(e) {
    var t;
    return ((t = this.beans.showRowGroupCols) == null ? void 0 : t.isRowGroupDisplayed(this, e)) ?? !1;
  }
  isPrimary() {
    return this.primary;
  }
  isFilterAllowed() {
    return !!this.colDef.filter;
  }
  isFieldContainsDots() {
    return this.fieldContainsDots;
  }
  isTooltipEnabled() {
    return this.tooltipEnabled;
  }
  isTooltipFieldContainsDots() {
    return this.tooltipFieldContainsDots;
  }
  getHighlighted() {
    return this.highlighted;
  }
  __addEventListener(e, t) {
    this.colEventSvc.addEventListener(e, t);
  }
  __removeEventListener(e, t) {
    this.colEventSvc.removeEventListener(e, t);
  }
  /**
   * PUBLIC USE ONLY: for internal use within AG Grid use the `__addEventListener` and `__removeEventListener` methods.
   */
  addEventListener(e, t) {
    var n, s, i;
    this.frameworkEventListenerService = (s = (n = this.beans.frameworkOverrides).createLocalEventListenerWrapper) == null ? void 0 : s.call(
      n,
      this.frameworkEventListenerService,
      this.colEventSvc
    );
    const o = ((i = this.frameworkEventListenerService) == null ? void 0 : i.wrap(e, t)) ?? t;
    this.colEventSvc.addEventListener(e, o);
  }
  /**
   * PUBLIC USE ONLY: for internal use within AG Grid use the `__addEventListener` and `__removeEventListener` methods.
   */
  removeEventListener(e, t) {
    var n;
    const o = ((n = this.frameworkEventListenerService) == null ? void 0 : n.unwrap(e, t)) ?? t;
    this.colEventSvc.removeEventListener(e, o);
  }
  createColumnFunctionCallbackParams(e) {
    return Pe(this.gos, {
      node: e,
      data: e.data,
      column: this,
      colDef: this.colDef
    });
  }
  isSuppressNavigable(e) {
    var t;
    return ((t = this.beans.cellNavigation) == null ? void 0 : t.isSuppressNavigable(this, e)) ?? !1;
  }
  isCellEditable(e) {
    var t;
    return ((t = this.beans.editSvc) == null ? void 0 : t.isCellEditable({ rowNode: e, column: this })) ?? !1;
  }
  isSuppressFillHandle() {
    return !!this.colDef.suppressFillHandle;
  }
  isAutoHeight() {
    return !!this.colDef.autoHeight;
  }
  isAutoHeaderHeight() {
    return !!this.colDef.autoHeaderHeight;
  }
  isRowDrag(e) {
    return this.isColumnFunc(e, this.colDef.rowDrag);
  }
  isDndSource(e) {
    return this.isColumnFunc(e, this.colDef.dndSource);
  }
  isCellCheckboxSelection(e) {
    var t;
    return ((t = this.beans.selectionSvc) == null ? void 0 : t.isCellCheckboxSelection(this, e)) ?? !1;
  }
  isSuppressPaste(e) {
    var t;
    return this.isColumnFunc(e, ((t = this.colDef) == null ? void 0 : t.suppressPaste) ?? null);
  }
  isResizable() {
    return !!this.getColDefValue("resizable");
  }
  /** Get value from ColDef or default if it exists. */
  getColDefValue(e) {
    return this.colDef[e] ?? DIe[e];
  }
  isColumnFunc(e, t) {
    if (typeof t == "boolean")
      return t;
    if (typeof t == "function") {
      const o = this.createColumnFunctionCallbackParams(e);
      return t(o);
    }
    return !1;
  }
  createColumnEvent(e, t) {
    return Pe(this.gos, {
      type: e,
      column: this,
      columns: [this],
      source: t
    });
  }
  isMoving() {
    return this.moving;
  }
  getSort() {
    return this.sort;
  }
  isSortable() {
    return !!this.getColDefValue("sortable");
  }
  /** @deprecated v32 use col.getSort() === 'asc */
  isSortAscending() {
    return this.sort === "asc";
  }
  /** @deprecated v32 use col.getSort() === 'desc */
  isSortDescending() {
    return this.sort === "desc";
  }
  /** @deprecated v32 use col.getSort() === undefined */
  isSortNone() {
    return Xe(this.sort);
  }
  /** @deprecated v32 use col.getSort() !== undefined */
  isSorting() {
    return ue(this.sort);
  }
  getSortIndex() {
    return this.sortIndex;
  }
  isMenuVisible() {
    return this.menuVisible;
  }
  getAggFunc() {
    return this.aggFunc;
  }
  getLeft() {
    return this.left;
  }
  getOldLeft() {
    return this.oldLeft;
  }
  getRight() {
    return this.left + this.actualWidth;
  }
  setLeft(e, t) {
    this.oldLeft = this.left, this.left !== e && (this.left = e, this.dispatchColEvent("leftChanged", t));
  }
  isFilterActive() {
    return this.filterActive;
  }
  /** @deprecated v33 Use `api.isColumnHovered(column)` instead. */
  isHovered() {
    var e;
    return X(261), !!((e = this.beans.colHover) != null && e.isHovered(this));
  }
  setFirstRightPinned(e, t) {
    this.firstRightPinned !== e && (this.firstRightPinned = e, this.dispatchColEvent("firstRightPinnedChanged", t));
  }
  setLastLeftPinned(e, t) {
    this.lastLeftPinned !== e && (this.lastLeftPinned = e, this.dispatchColEvent("lastLeftPinnedChanged", t));
  }
  isFirstRightPinned() {
    return this.firstRightPinned;
  }
  isLastLeftPinned() {
    return this.lastLeftPinned;
  }
  isPinned() {
    return this.pinned === "left" || this.pinned === "right";
  }
  isPinnedLeft() {
    return this.pinned === "left";
  }
  isPinnedRight() {
    return this.pinned === "right";
  }
  getPinned() {
    return this.pinned;
  }
  setVisible(e, t) {
    const o = e === !0;
    this.visible !== o && (this.visible = o, this.dispatchColEvent("visibleChanged", t)), this.dispatchStateUpdatedEvent("hide");
  }
  isVisible() {
    return this.visible;
  }
  isSpanHeaderHeight() {
    return !this.getColDef().suppressSpanHeaderHeight;
  }
  /**
   * Returns the first parent that is not a padding group.
   */
  getFirstRealParent() {
    let e = this.getOriginalParent();
    for (; e && e.isPadding(); )
      e = e.getOriginalParent();
    return e;
  }
  getColumnGroupPaddingInfo() {
    let e = this.getParent();
    if (!e || !e.isPadding())
      return { numberOfParents: 0, isSpanningTotal: !1 };
    const t = e.getPaddingLevel() + 1;
    let o = !0;
    for (; e; ) {
      if (!e.isPadding()) {
        o = !1;
        break;
      }
      e = e.getParent();
    }
    return { numberOfParents: t, isSpanningTotal: o };
  }
  getColDef() {
    return this.colDef;
  }
  getDefinition() {
    return this.colDef;
  }
  getColumnGroupShow() {
    return this.colDef.columnGroupShow;
  }
  getColId() {
    return this.colId;
  }
  getId() {
    return this.colId;
  }
  getUniqueId() {
    return this.colId;
  }
  getActualWidth() {
    return this.actualWidth;
  }
  getAutoHeaderHeight() {
    return this.autoHeaderHeight;
  }
  /** Returns true if the header height has changed */
  setAutoHeaderHeight(e) {
    const t = e !== this.autoHeaderHeight;
    return this.autoHeaderHeight = e, t;
  }
  createBaseColDefParams(e) {
    return Pe(this.gos, {
      node: e,
      data: e.data,
      colDef: this.colDef,
      column: this
    });
  }
  getColSpan(e) {
    if (Xe(this.colDef.colSpan))
      return 1;
    const t = this.createBaseColDefParams(e), o = this.colDef.colSpan(t);
    return Math.max(o, 1);
  }
  getRowSpan(e) {
    if (Xe(this.colDef.rowSpan))
      return 1;
    const t = this.createBaseColDefParams(e), o = this.colDef.rowSpan(t);
    return Math.max(o, 1);
  }
  setActualWidth(e, t, o = !1) {
    e = Math.max(e, this.minWidth), e = Math.min(e, this.maxWidth), this.actualWidth !== e && (this.actualWidth = e, this.flex != null && t !== "flex" && t !== "gridInitializing" && (this.flex = null), o || this.fireColumnWidthChangedEvent(t)), this.dispatchStateUpdatedEvent("width");
  }
  fireColumnWidthChangedEvent(e) {
    this.dispatchColEvent("widthChanged", e);
  }
  isGreaterThanMax(e) {
    return e > this.maxWidth;
  }
  getMinWidth() {
    return this.minWidth;
  }
  getMaxWidth() {
    return this.maxWidth;
  }
  getFlex() {
    return this.flex;
  }
  isRowGroupActive() {
    return this.rowGroupActive;
  }
  isPivotActive() {
    return this.pivotActive;
  }
  isAnyFunctionActive() {
    return this.isPivotActive() || this.isRowGroupActive() || this.isValueActive();
  }
  isAnyFunctionAllowed() {
    return this.isAllowPivot() || this.isAllowRowGroup() || this.isAllowValue();
  }
  isValueActive() {
    return this.aggregationActive;
  }
  isAllowPivot() {
    return this.colDef.enablePivot === !0;
  }
  isAllowValue() {
    return this.colDef.enableValue === !0;
  }
  isAllowRowGroup() {
    return this.colDef.enableRowGroup === !0;
  }
  dispatchColEvent(e, t, o) {
    const n = this.createColumnEvent(e, t);
    o && qt(n, o), this.colEventSvc.dispatchEvent(n);
  }
  dispatchStateUpdatedEvent(e) {
    this.colEventSvc.dispatchEvent({
      type: "columnStateUpdated",
      key: e
    });
  }
};
function Lt(e) {
  return e instanceof Lr;
}
var Lr = class extends K {
  constructor(e, t, o, n) {
    super(), this.colGroupDef = e, this.groupId = t, this.padding = o, this.level = n, this.isColumn = !1, this.expandable = !1, this.instanceId = Iw(), this.expandableListenerRemoveCallback = null, this.expanded = !!(e != null && e.openByDefault);
  }
  destroy() {
    this.expandableListenerRemoveCallback && this.reset(null, void 0), super.destroy();
  }
  reset(e, t) {
    this.colGroupDef = e, this.level = t, this.originalParent = null, this.expandableListenerRemoveCallback && this.expandableListenerRemoveCallback(), this.children = void 0, this.expandable = void 0;
  }
  getInstanceId() {
    return this.instanceId;
  }
  getOriginalParent() {
    return this.originalParent;
  }
  getLevel() {
    return this.level;
  }
  isVisible() {
    return this.children ? this.children.some((e) => e.isVisible()) : !1;
  }
  isPadding() {
    return this.padding;
  }
  setExpanded(e) {
    this.expanded = e === void 0 ? !1 : e, this.dispatchLocalEvent({ type: "expandedChanged" });
  }
  isExpandable() {
    return this.expandable;
  }
  isExpanded() {
    return this.expanded;
  }
  getGroupId() {
    return this.groupId;
  }
  getId() {
    return this.getGroupId();
  }
  setChildren(e) {
    this.children = e;
  }
  getChildren() {
    return this.children;
  }
  getColGroupDef() {
    return this.colGroupDef;
  }
  getLeafColumns() {
    const e = [];
    return this.addLeafColumns(e), e;
  }
  forEachLeafColumn(e) {
    if (this.children)
      for (const t of this.children)
        hn(t) ? e(t) : Lt(t) && t.forEachLeafColumn(e);
  }
  addLeafColumns(e) {
    this.children && this.children.forEach((t) => {
      hn(t) ? e.push(t) : Lt(t) && t.addLeafColumns(e);
    });
  }
  getColumnGroupShow() {
    const e = this.colGroupDef;
    if (e)
      return e.columnGroupShow;
  }
  // need to check that this group has at least one col showing when both expanded and contracted.
  // if not, then we don't allow expanding and contracting on this group
  setupExpandable() {
    this.setExpandable(), this.expandableListenerRemoveCallback && this.expandableListenerRemoveCallback();
    const e = this.onColumnVisibilityChanged.bind(this);
    this.getLeafColumns().forEach((t) => t.__addEventListener("visibleChanged", e)), this.expandableListenerRemoveCallback = () => {
      this.getLeafColumns().forEach((t) => t.__removeEventListener("visibleChanged", e)), this.expandableListenerRemoveCallback = null;
    };
  }
  setExpandable() {
    if (this.isPadding())
      return;
    let e = !1, t = !1, o = !1;
    const n = this.findChildrenRemovingPadding();
    for (let i = 0, r = n.length; i < r; i++) {
      const l = n[i];
      if (!l.isVisible())
        continue;
      const a = l.getColumnGroupShow();
      a === "open" ? (e = !0, o = !0) : a === "closed" ? (t = !0, o = !0) : (e = !0, t = !0);
    }
    const s = e && t && o;
    this.expandable !== s && (this.expandable = s, this.dispatchLocalEvent({ type: "expandableChanged" }));
  }
  findChildrenRemovingPadding() {
    const e = [], t = (o) => {
      o.forEach((n) => {
        Lt(n) && n.isPadding() ? t(n.children) : e.push(n);
      });
    };
    return t(this.children), e;
  }
  onColumnVisibilityChanged() {
    this.setExpandable();
  }
}, HIe = {
  numericColumn: {
    headerClass: "ag-right-aligned-header",
    cellClass: "ag-right-aligned-cell"
  },
  rightAligned: {
    headerClass: "ag-right-aligned-header",
    cellClass: "ag-right-aligned-cell"
  }
};
function Ld(e, t, o) {
  const n = {}, s = e.gos;
  return Object.assign(n, s.get("defaultColGroupDef")), Object.assign(n, t), s.validateColDef(n, o), n;
}
var VIe = class {
  constructor() {
    this.existingKeys = {};
  }
  addExistingKeys(e) {
    for (let t = 0; t < e.length; t++)
      this.existingKeys[e[t]] = !0;
  }
  getUniqueKey(e, t) {
    e = Co(e);
    let o = 0;
    for (; ; ) {
      let n = e ?? t;
      if (n ? o !== 0 && (n += "_" + o) : n = o, !this.existingKeys[n]) {
        const s = String(n);
        return e && o > 0 && X(273, { providedId: e, usedId: s }), this.existingKeys[s] = !0, s;
      }
      o++;
    }
  }
}, bn = Object.freeze([]);
function Ke(e) {
  if (e != null && e.length)
    return e[e.length - 1];
}
function No(e, t, o) {
  if (e === t)
    return !0;
  if (!e || !t)
    return e == null && t == null;
  const n = e.length;
  if (n !== t.length)
    return !1;
  for (let s = 0; s < n; s++)
    if (e[s] !== t[s] && !(o != null && o(e[s], t[s])))
      return !1;
  return !0;
}
function ar(e, t) {
  if (e)
    for (const o of e)
      t(o);
}
function Zt(e, t) {
  const o = e.indexOf(t);
  o >= 0 && e.splice(o, 1);
}
function Ed(e, t, o) {
  for (let n = 0; n < t.length; n++)
    Zt(e, t[n]);
  for (let n = t.length - 1; n >= 0; n--)
    e.splice(o, 0, t[n]);
}
var $i = "ag-Grid-AutoColumn", Dw = "ag-Grid-SelectionColumn", kw = "ag-Grid-RowNumbersColumn", OIe = "ag-Grid-HierarchyColumn";
function Hw(e) {
  const t = [], o = (n) => {
    for (let s = 0; s < n.length; s++) {
      const i = n[s];
      hn(i) ? t.push(i) : Lt(i) && o(i.getChildren());
    }
  };
  return o(e), t;
}
function yn(e) {
  return e.reduce((t, o) => t + o.getActualWidth(), 0);
}
function Js(e, t, o) {
  const n = {};
  if (!t)
    return;
  Rn(null, t, (i) => {
    n[i.getInstanceId()] = i;
  }), o && Rn(null, o, (i) => {
    n[i.getInstanceId()] = null;
  });
  const s = Object.values(n).filter((i) => i != null);
  e.context.destroyBeans(s);
}
function ha(e) {
  return e.getId().startsWith($i);
}
function hs(e) {
  const t = typeof e == "string" ? e : "getColId" in e ? e.getColId() : e.colId;
  return (t == null ? void 0 : t.startsWith(Dw)) ?? !1;
}
function ns(e) {
  const t = typeof e == "string" ? e : "getColId" in e ? e.getColId() : e.colId;
  return (t == null ? void 0 : t.startsWith(kw)) ?? !1;
}
function BIe(e) {
  return hs(e) || ns(e);
}
function xl(e) {
  let t = [];
  return e instanceof Array ? t = e : typeof e == "string" && (t = e.split(",")), t;
}
function P2(e, t) {
  return No(e, t, (o, n) => o.getColId() === n.getColId());
}
function R2(e) {
  e.map = {}, e.list.forEach((t) => e.map[t.getId()] = t);
}
function Bs(e) {
  return e === "optionsUpdated" ? "gridOptionsChanged" : e;
}
function qr(e, t) {
  const o = e === t, n = e.getColDef() === t, s = e.getColId() == t;
  return o || n || s;
}
var $Ie = (e, t) => (o, n) => {
  const s = {
    value1: void 0,
    value2: void 0
  };
  let i = !1;
  return e && (e[o] !== void 0 && (s.value1 = e[o], i = !0), ue(n) && e[n] !== void 0 && (s.value2 = e[n], i = !0)), !i && t && (t[o] !== void 0 && (s.value1 = t[o]), ue(n) && t[n] !== void 0 && (s.value2 = t[n])), s;
};
function ZIe(e, t = null, o, n, s) {
  const i = new VIe(), { existingCols: r, existingGroups: l, existingColKeys: a } = GIe(n);
  i.addExistingKeys(a);
  const c = Vw(
    e,
    t,
    0,
    o,
    r,
    i,
    l,
    s
  ), { colGroupSvc: d } = e, u = (d == null ? void 0 : d.findMaxDepth(c, 0)) ?? 0, h = d ? d.balanceColumnTree(c, 0, u, i) : c;
  return Rn(null, h, (C, m) => {
    Lt(C) && C.setupExpandable(), C.originalParent = m;
  }), {
    columnTree: h,
    treeDepth: u
  };
}
function GIe(e) {
  const t = [], o = [], n = [];
  return e && Rn(null, e, (s) => {
    if (Lt(s)) {
      const i = s;
      o.push(i);
    } else {
      const i = s;
      n.push(i.getId()), t.push(i);
    }
  }), { existingCols: t, existingGroups: o, existingColKeys: n };
}
function Vw(e, t, o, n, s, i, r, l) {
  if (!t)
    return [];
  const { colGroupSvc: a } = e, c = new Array(t.length);
  for (let d = 0; d < c.length; d++) {
    const u = t[d];
    a && KIe(u) ? c[d] = a.createProvidedColumnGroup(
      n,
      u,
      o,
      s,
      i,
      r,
      l
    ) : c[d] = NIe(e, n, u, s, i, l);
  }
  return c;
}
function NIe(e, t, o, n, s, i) {
  var a;
  const r = jIe(o, n);
  r && (n == null || n.splice(r.idx, 1));
  let l = r == null ? void 0 : r.column;
  if (l) {
    const c = Zi(e, o, l.getColId());
    l.setColDef(c, o, i), zIe(e, l, c, i);
  } else {
    const c = s.getUniqueKey(o.colId, o.field), d = Zi(e, o, c);
    l = new Zn(d, o, c, t), e.context.createBean(l);
  }
  return (a = e.dataTypeSvc) == null || a.addColumnListeners(l), l;
}
function Ow(e, t, o, n, s, i, r, l) {
  const { sortSvc: a, pinnedCols: c, colFlex: d } = e;
  o !== void 0 && t.setVisible(!o, l), a && (a.updateColSort(t, n, l), s !== void 0 && a.setColSortIndex(t, s)), i !== void 0 && (c == null || c.setColPinned(t, i)), r !== void 0 && (d == null || d.setColFlex(t, r));
}
function zIe(e, t, o, n) {
  Ow(
    e,
    t,
    o.hide,
    o.sort,
    o.sortIndex,
    o.pinned,
    o.flex,
    n
  );
  const s = t.getFlex();
  if (!(s != null && s > 0))
    if (o.width != null)
      t.setActualWidth(o.width, n);
    else {
      const i = t.getActualWidth();
      t.setActualWidth(i, n);
    }
}
function jIe(e, t) {
  if (t)
    for (let o = 0; o < t.length; o++) {
      const n = t[o].getUserProvidedColDef();
      if (!n)
        continue;
      if (e.colId != null) {
        if (t[o].getId() === e.colId)
          return { idx: o, column: t[o] };
        continue;
      }
      if (e.field != null) {
        if (n.field === e.field)
          return { idx: o, column: t[o] };
        continue;
      }
      if (n === e)
        return { idx: o, column: t[o] };
    }
}
function Zi(e, t, o, n) {
  const { gos: s, dataTypeSvc: i } = e, r = {}, l = s.get("defaultColDef");
  qt(r, l, !1, !0);
  const a = WIe(e, r, t, o);
  a && UIe(e, a, r);
  const c = r.cellDataType;
  qt(r, t, !1, !0), c !== void 0 && (r.cellDataType = c);
  const d = s.get("autoGroupColumnDef"), u = Oo(s);
  return t.rowGroup && d && u && qt(
    r,
    { sort: d.sort, initialSort: d.initialSort },
    !1,
    !0
  ), i && (i.postProcess(r), i.validateColDef(r)), s.validateColDef(r, o, n), r;
}
function WIe(e, t, o, n) {
  var r;
  const s = (r = e.dataTypeSvc) == null ? void 0 : r.updateColDefAndGetColumnType(t, o, n), i = o.type ?? s ?? t.type;
  return t.type = i, i ? xl(i) : void 0;
}
function UIe(e, t, o) {
  if (!t.length)
    return;
  const n = Object.assign({}, HIe), s = e.gos.get("columnTypes") || {};
  for (const i of Object.keys(s)) {
    const r = s[i];
    i in n ? X(34, { key: i }) : (r.type && X(35), n[i] = r);
  }
  t.forEach((i) => {
    const r = n[i.trim()];
    r ? qt(o, r, !1, !0) : X(36, { t: i });
  });
}
function KIe(e) {
  return e.children !== void 0;
}
function Rn(e, t, o) {
  if (t)
    for (let n = 0; n < t.length; n++) {
      const s = t[n];
      Lt(s) && Rn(s, s.getChildren(), o), o(s, e);
    }
}
function Bw(e, t) {
  const o = [], n = [], s = [];
  return e.forEach((r) => {
    const l = r.getColDef().lockPosition;
    l === "right" ? s.push(r) : l === "left" || l === !0 ? o.push(r) : n.push(r);
  }), t.get("enableRtl") ? [...s, ...n, ...o] : [...o, ...n, ...s];
}
function $w(e, t) {
  let o = !0;
  return Rn(null, t, (n) => {
    if (!Lt(n))
      return;
    const s = n, i = s.getColGroupDef();
    if (!(i && i.marryChildren))
      return;
    const l = [];
    s.getLeafColumns().forEach((h) => {
      const p = e.indexOf(h);
      l.push(p);
    });
    const a = Math.max.apply(Math, l), c = Math.min.apply(Math, l), d = a - c, u = s.getLeafColumns().length - 1;
    d > u && (o = !1);
  }), o;
}
function Zw(e, t) {
  if (!e || e.length == 0)
    return;
  const o = t(e[0]);
  for (let n = 1; n < e.length; n++)
    if (o !== t(e[n]))
      return;
  return o;
}
function Gw(e, t, o) {
  if (!t.length)
    return;
  const n = t.length === 1 ? t[0] : null, s = Zw(t, (i) => i.getPinned());
  e.dispatchEvent({
    type: "columnPinned",
    // mistake in typing, 'undefined' should be allowed, as 'null' means 'not pinned'
    pinned: s ?? null,
    columns: t,
    column: n,
    source: o
  });
}
function qIe(e, t, o) {
  if (!t.length)
    return;
  const n = t.length === 1 ? t[0] : null, s = Zw(t, (i) => i.isVisible());
  e.dispatchEvent({
    type: "columnVisible",
    visible: s,
    columns: t,
    column: n,
    source: o
  });
}
function Nw(e, t, o, n) {
  e.dispatchEvent({
    type: t,
    columns: o,
    column: o && o.length == 1 ? o[0] : null,
    source: n
  });
}
function Gi(e, t, o, n, s = null) {
  t != null && t.length && e.dispatchEvent({
    type: "columnResized",
    columns: t,
    column: t.length === 1 ? t[0] : null,
    flexColumns: s,
    finished: o,
    source: n
  });
}
function eo(e, t, o) {
  var x;
  const {
    colModel: n,
    rowGroupColsSvc: s,
    pivotColsSvc: i,
    autoColSvc: r,
    selectionColSvc: l,
    colAnimation: a,
    visibleCols: c,
    pivotResultCols: d,
    environment: u,
    valueColsSvc: h,
    eventSvc: p,
    gos: C
  } = e, m = n.getColDefCols() ?? [], w = l == null ? void 0 : l.getColumns();
  if (!m.length && !(w != null && w.length))
    return !1;
  if (t != null && t.state && !t.state.forEach)
    return X(32), !1;
  const y = (L, A, R, P, I) => {
    if (!L)
      return;
    const B = $Ie(A, t.defaultState), H = B("flex").value1;
    if (Ow(
      e,
      L,
      B("hide").value1,
      B("sort").value1,
      B("sortIndex").value1,
      B("pinned").value1,
      H,
      o
    ), H == null) {
      const O = B("width").value1;
      if (O != null) {
        const N = L.getColDef().minWidth ?? u.getDefaultColumnMinWidth();
        N != null && O >= N && L.setActualWidth(O, o);
      }
    }
    I || !L.isPrimary() || (h == null || h.syncColumnWithState(L, o, B), s == null || s.syncColumnWithState(L, o, B, R), i == null || i.syncColumnWithState(L, o, B, P));
  }, b = (L, A, R) => {
    var ge, ce;
    const P = jw(e, o), I = A.slice(), B = {}, H = {}, O = [], N = [], te = [];
    let E = 0;
    const j = (s == null ? void 0 : s.columns.slice()) ?? [], Z = (i == null ? void 0 : i.columns.slice()) ?? [];
    L.forEach((G) => {
      const z = G.colId;
      if (z.startsWith($i)) {
        O.push(G), te.push(G);
        return;
      }
      if (hs(z)) {
        N.push(G), te.push(G);
        return;
      }
      const q = R(z);
      q ? (y(q, G, B, H, !1), Zt(I, q)) : (te.push(G), E += 1);
    });
    const Y = (G) => y(G, null, B, H, !1);
    I.forEach(Y), s == null || s.sortColumns(Pd.bind(s, B, j)), i == null || i.sortColumns(Pd.bind(i, H, Z)), n.refreshCols(!1);
    const le = (G, z, oe = []) => {
      z.forEach((q) => {
        const ne = G(q.colId);
        Zt(oe, ne), y(ne, q, null, null, !0);
      }), oe.forEach(Y);
    };
    return le(
      (G) => (r == null ? void 0 : r.getColumn(G)) ?? null,
      O,
      (ge = r == null ? void 0 : r.getColumns()) == null ? void 0 : ge.slice()
    ), le(
      (G) => (l == null ? void 0 : l.getColumn(G)) ?? null,
      N,
      (ce = l == null ? void 0 : l.getColumns()) == null ? void 0 : ce.slice()
    ), YIe(t, n, C), c.refresh(o), p.dispatchEvent({
      type: "columnEverythingChanged",
      source: o
    }), P(), { unmatchedAndAutoStates: te, unmatchedCount: E };
  };
  a == null || a.start();
  let { unmatchedAndAutoStates: _, unmatchedCount: M } = b(
    t.state || [],
    m,
    (L) => n.getColDefCol(L)
  );
  if (_.length > 0 || ue(t.defaultState)) {
    const L = ((x = d == null ? void 0 : d.getPivotResultCols()) == null ? void 0 : x.list) ?? [];
    M = b(
      _,
      L,
      (A) => (d == null ? void 0 : d.getPivotResultCol(A)) ?? null
    ).unmatchedCount;
  }
  return a == null || a.finish(), M === 0;
}
function zw(e, t) {
  var b, _;
  const { colModel: o, autoColSvc: n, selectionColSvc: s, eventSvc: i, gos: r } = e, l = o.getColDefCols();
  if (!(l != null && l.length))
    return;
  const a = o.getColDefColTree(), c = Hw(a), d = [];
  let u = 1e3, h = 1e3;
  const p = (M) => {
    const x = Ww(M);
    Xe(x.rowGroupIndex) && x.rowGroup && (x.rowGroupIndex = u++), Xe(x.pivotIndex) && x.pivot && (x.pivotIndex = h++), d.push(x);
  };
  (b = n == null ? void 0 : n.getColumns()) == null || b.forEach(p), (_ = s == null ? void 0 : s.getColumns()) == null || _.forEach(p), c == null || c.forEach(p), eo(e, { state: d }, t);
  const C = (n == null ? void 0 : n.getColumns()) ?? [], y = [...(s == null ? void 0 : s.getColumns()) ?? [], ...C, ...l].map((M) => ({ colId: M.colId }));
  eo(e, { state: y, applyOrder: !0 }, t), i.dispatchEvent(Pe(r, { type: "columnsReset", source: t }));
}
function jw(e, t) {
  const { rowGroupColsSvc: o, pivotColsSvc: n, valueColsSvc: s, colModel: i, sortSvc: r, eventSvc: l } = e, a = {
    rowGroupColumns: (o == null ? void 0 : o.columns.slice()) ?? [],
    pivotColumns: (n == null ? void 0 : n.columns.slice()) ?? [],
    valueColumns: (s == null ? void 0 : s.columns.slice()) ?? []
  }, c = Ml(e), d = {};
  return c.forEach((u) => {
    d[u.colId] = u;
  }), () => {
    const u = (L, A, R, P) => {
      const I = A.map(P), B = R.map(P);
      if (No(I, B))
        return;
      const O = new Set(A);
      R.forEach((te) => {
        O.delete(te) || O.add(te);
      });
      const N = [...O];
      l.dispatchEvent({
        type: L,
        columns: N,
        column: N.length === 1 ? N[0] : null,
        source: t
      });
    }, h = (L) => {
      const A = [];
      return i.forAllCols((R) => {
        const P = d[R.getColId()];
        P && L(P, R) && A.push(R);
      }), A;
    }, p = (L) => L.getColId();
    u(
      "columnRowGroupChanged",
      a.rowGroupColumns,
      (o == null ? void 0 : o.columns) ?? [],
      p
    ), u(
      "columnPivotChanged",
      a.pivotColumns,
      (n == null ? void 0 : n.columns) ?? [],
      p
    );
    const m = h((L, A) => {
      const R = L.aggFunc != null, P = R != A.isValueActive(), I = R && L.aggFunc != A.getAggFunc();
      return P || I;
    });
    m.length > 0 && Nw(l, "columnValueChanged", m, t), Gi(l, h((L, A) => L.width != A.getActualWidth()), !0, t), Gw(l, h((L, A) => L.pinned != A.getPinned()), t), qIe(l, h((L, A) => L.hide == A.isVisible()), t);
    const M = h((L, A) => L.sort != A.getSort() || L.sortIndex != A.getSortIndex());
    M.length > 0 && (r == null || r.dispatchSortChangedEvents(t, M));
    const x = Ml(e);
    JIe(c, x, t, i, l);
  };
}
function Ml(e) {
  const { colModel: t, rowGroupColsSvc: o, pivotColsSvc: n } = e, s = t.getColDefCols();
  if (Xe(s) || !t.isAlive())
    return [];
  const i = o == null ? void 0 : o.columns, r = n == null ? void 0 : n.columns, l = [], a = (d) => {
    const u = d.isRowGroupActive() && i ? i.indexOf(d) : null, h = d.isPivotActive() && r ? r.indexOf(d) : null, p = d.isValueActive() ? d.getAggFunc() : null, C = d.getSort() != null ? d.getSort() : null, m = d.getSortIndex() != null ? d.getSortIndex() : null;
    l.push({
      colId: d.getColId(),
      width: d.getActualWidth(),
      hide: !d.isVisible(),
      pinned: d.getPinned(),
      sort: C,
      sortIndex: m,
      aggFunc: p,
      rowGroup: d.isRowGroupActive(),
      rowGroupIndex: u,
      pivot: d.isPivotActive(),
      pivotIndex: h,
      flex: d.getFlex() ?? null
    });
  };
  t.forAllCols((d) => a(d));
  const c = new Map(
    t.getCols().map((d, u) => [d.getColId(), u])
  );
  return l.sort((d, u) => {
    const h = c.has(d.colId) ? c.get(d.colId) : -1, p = c.has(u.colId) ? c.get(u.colId) : -1;
    return h - p;
  }), l;
}
function Ww(e) {
  const t = (C, m) => C ?? m ?? null, o = e.getColDef(), n = t(o.sort, o.initialSort), s = t(o.sortIndex, o.initialSortIndex), i = t(o.hide, o.initialHide), r = t(o.pinned, o.initialPinned), l = t(o.width, o.initialWidth), a = t(o.flex, o.initialFlex);
  let c = t(o.rowGroupIndex, o.initialRowGroupIndex), d = t(o.rowGroup, o.initialRowGroup);
  c == null && (d == null || d == !1) && (c = null, d = null);
  let u = t(o.pivotIndex, o.initialPivotIndex), h = t(o.pivot, o.initialPivot);
  u == null && (h == null || h == !1) && (u = null, h = null);
  const p = t(o.aggFunc, o.initialAggFunc);
  return {
    colId: e.getColId(),
    sort: n,
    sortIndex: s,
    hide: i,
    pinned: r,
    width: l,
    flex: a,
    rowGroup: d,
    rowGroupIndex: c,
    pivot: h,
    pivotIndex: u,
    aggFunc: p
  };
}
function YIe(e, t, o) {
  if (!e.applyOrder || !e.state)
    return;
  const n = [];
  e.state.forEach((s) => {
    s.colId != null && n.push(s.colId);
  }), QIe(t.cols, n, t, o);
}
function QIe(e, t, o, n) {
  if (e == null)
    return;
  let s = [];
  const i = {};
  t.forEach((l) => {
    if (i[l])
      return;
    const a = e.map[l];
    a && (s.push(a), i[l] = !0);
  });
  let r = 0;
  if (e.list.forEach((l) => {
    const a = l.getColId();
    if (i[a] != null)
      return;
    a.startsWith($i) ? s.splice(r++, 0, l) : s.push(l);
  }), s = Bw(s, n), !$w(s, o.getColTree())) {
    X(39);
    return;
  }
  e.list = s;
}
function JIe(e, t, o, n, s) {
  const i = {};
  t.forEach((d) => i[d.colId] = d);
  const r = {};
  e.forEach((d) => {
    i[d.colId] && (r[d.colId] = !0);
  });
  const l = e.filter((d) => r[d.colId]), a = t.filter((d) => r[d.colId]), c = [];
  a.forEach((d, u) => {
    const h = l && l[u];
    if (h && h.colId !== d.colId) {
      const p = n.getCol(h.colId);
      p && c.push(p);
    }
  }), c.length && s.dispatchEvent({
    type: "columnMoved",
    columns: c,
    column: c.length === 1 ? c[0] : null,
    finished: !0,
    source: o
  });
}
var Pd = (e, t, o, n) => {
  const s = e[o.getId()], i = e[n.getId()], r = s != null, l = i != null;
  if (r && l)
    return s - i;
  if (r)
    return -1;
  if (l)
    return 1;
  const a = t.indexOf(o), c = t.indexOf(n), d = a >= 0, u = c >= 0;
  return d && u ? a - c : d ? -1 : 1;
}, XIe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "colModel", this.pivotMode = !1, this.ready = !1, this.changeEventsDispatching = !1;
  }
  postConstruct() {
    this.pivotMode = this.gos.get("pivotMode"), this.addManagedPropertyListeners(
      [
        "groupDisplayType",
        "treeData",
        "treeDataDisplayType",
        "groupHideOpenParents",
        "rowNumbers",
        "hidePaddedHeaderRows"
      ],
      (e) => this.refreshAll(Bs(e.source))
    ), this.addManagedPropertyListeners(
      ["defaultColDef", "defaultColGroupDef", "columnTypes", "suppressFieldDotNotation"],
      this.recreateColumnDefs.bind(this)
    ), this.addManagedPropertyListener(
      "pivotMode",
      (e) => this.setPivotMode(this.gos.get("pivotMode"), Bs(e.source))
    );
  }
  // called from SyncService, when grid has finished initialising
  createColsFromColDefs(e) {
    var b, _, M;
    const { beans: t } = this, {
      valueCache: o,
      colAutosize: n,
      rowGroupColsSvc: s,
      pivotColsSvc: i,
      valueColsSvc: r,
      visibleCols: l,
      eventSvc: a,
      groupHierarchyColSvc: c
    } = t, d = this.colDefs ? jw(t, e) : void 0;
    o == null || o.expire();
    const u = (b = this.colDefCols) == null ? void 0 : b.list, h = (_ = this.colDefCols) == null ? void 0 : _.tree, p = ZIe(t, this.colDefs, !0, h, e);
    Js(t, (M = this.colDefCols) == null ? void 0 : M.tree, p.columnTree);
    const C = p.columnTree, m = p.treeDepth, w = Hw(C), y = {};
    w.forEach((x) => y[x.getId()] = x), this.colDefCols = { tree: C, treeDepth: m, list: w, map: y }, this.createColumnsForService([c], this.colDefCols), s == null || s.extractCols(e, u), i == null || i.extractCols(e, u), r == null || r.extractCols(e, u), this.ready = !0, this.refreshCols(!0), l.refresh(e), a.dispatchEvent({
      type: "columnEverythingChanged",
      source: e
    }), d && (this.changeEventsDispatching = !0, d(), this.changeEventsDispatching = !1), a.dispatchEvent({
      type: "newColumnsLoaded",
      source: e
    }), e === "gridInitializing" && (n == null || n.applyAutosizeStrategy());
  }
  // called from: buildAutoGroupColumns (events 'groupDisplayType', 'treeData', 'treeDataDisplayType', 'groupHideOpenParents')
  // createColsFromColDefs (recreateColumnDefs, setColumnsDefs),
  // setPivotMode, applyColumnState,
  // functionColsService.setPrimaryColList, functionColsService.updatePrimaryColList,
  // pivotResultCols.setPivotResultCols
  refreshCols(e) {
    var m;
    if (!this.colDefCols)
      return;
    const t = (m = this.cols) == null ? void 0 : m.tree;
    this.saveColOrder();
    const {
      autoColSvc: o,
      selectionColSvc: n,
      rowNumbersSvc: s,
      quickFilter: i,
      pivotResultCols: r,
      showRowGroupCols: l,
      rowAutoHeight: a,
      visibleCols: c,
      colViewport: d,
      eventSvc: u
    } = this.beans, h = this.selectCols(r, this.colDefCols);
    this.createColumnsForService([o, n, s], h);
    const p = _Ie(this.gos, this.showingPivotResult);
    (!e || p) && this.restoreColOrder(h), this.positionLockedCols(h), l == null || l.refresh(), i == null || i.refreshCols(), this.setColSpanActive(), a == null || a.setAutoHeightActive(h), c.clear(), d.clear(), !No(t, this.cols.tree) && u.dispatchEvent({
      type: "gridColumnsChanged"
    });
  }
  createColumnsForService(e, t) {
    for (const o of e)
      o && (o.createColumns(t, (n) => {
        this.lastOrder = n(this.lastOrder), this.lastPivotOrder = n(this.lastPivotOrder);
      }), o.addColumns(t));
  }
  selectCols(e, t) {
    const o = (e == null ? void 0 : e.getPivotResultCols()) ?? null;
    this.showingPivotResult = o != null;
    const { map: n, list: s, tree: i, treeDepth: r } = o ?? t;
    return this.cols = {
      list: s.slice(),
      map: { ...n },
      tree: i.slice(),
      treeDepth: r
    }, o && (o.list.some((a) => {
      var c;
      return ((c = this.cols) == null ? void 0 : c.map[a.getColId()]) !== void 0;
    }) || (this.lastPivotOrder = null)), this.cols;
  }
  getColsToShow() {
    if (!this.cols)
      return [];
    const { valueColsSvc: e, selectionColSvc: t, gos: o } = this.beans, n = this.isPivotMode() && !this.showingPivotResult, s = t == null ? void 0 : t.isSelectionColumnEnabled(), i = o.get("rowNumbers"), r = e == null ? void 0 : e.columns;
    return this.cols.list.filter((a) => {
      const c = ha(a);
      if (n) {
        const d = r == null ? void 0 : r.includes(a);
        return c || d || s && hs(a) || i && ns(a);
      } else
        return c || a.isVisible();
    });
  }
  // on events 'groupDisplayType', 'treeData', 'treeDataDisplayType', 'groupHideOpenParents'
  refreshAll(e) {
    this.ready && (this.refreshCols(!1), this.beans.visibleCols.refresh(e));
  }
  setColsVisible(e, t = !1, o) {
    eo(
      this.beans,
      {
        state: e.map((n) => ({
          colId: typeof n == "string" ? n : n.getColId(),
          hide: !t
        }))
      },
      o
    );
  }
  /**
   * Restores provided columns order to the previous order in this.lastPivotOrder / this.lastOrder
   * If columns are not in the last order:
   *  - Check column groups, and apply column after the last column in the lowest shared group
   *  - If no sibling is found, apply the column at the end of the cols
   */
  restoreColOrder(e) {
    const t = this.showingPivotResult ? this.lastPivotOrder : this.lastOrder;
    if (!t)
      return;
    const o = t.filter((u) => e.map[u.getId()] != null);
    if (o.length === 0)
      return;
    if (o.length === e.list.length) {
      e.list = o;
      return;
    }
    const n = (u) => {
      const h = u.getOriginalParent();
      return h ? h.getChildren().length > 1 ? !0 : n(h) : !1;
    };
    if (!o.some((u) => n(u))) {
      const u = new Set(o);
      for (const h of e.list)
        u.has(h) || o.push(h);
      e.list = o;
      return;
    }
    const s = /* @__PURE__ */ new Map();
    for (let u = 0; u < o.length; u++) {
      const h = o[u];
      s.set(h, u);
    }
    const i = e.list.filter((u) => !s.has(u));
    if (i.length === 0) {
      e.list = o;
      return;
    }
    const r = (u, h) => {
      const p = h ? h.getOriginalParent() : u.getOriginalParent();
      if (!p)
        return null;
      let C = null, m = null;
      for (const w of p.getChildren())
        if (!(w === h || w === u)) {
          if (w instanceof Zn) {
            const y = s.get(w);
            if (y == null)
              continue;
            (C == null || C < y) && (C = y, m = w);
            continue;
          }
          w.forEachLeafColumn((y) => {
            const b = s.get(y);
            b != null && (C == null || C < b) && (C = b, m = y);
          });
        }
      return m ?? r(u, p);
    }, l = [], a = /* @__PURE__ */ new Map();
    for (const u of i) {
      const h = r(u, null);
      if (h == null) {
        l.push(u);
        continue;
      }
      const p = a.get(h);
      p === void 0 ? a.set(h, u) : Array.isArray(p) ? p.push(u) : a.set(h, [p, u]);
    }
    const c = new Array(e.list.length);
    let d = c.length - 1;
    for (let u = l.length - 1; u >= 0; u--)
      c[d--] = l[u];
    for (let u = o.length - 1; u >= 0; u--) {
      const h = o[u], p = a.get(h);
      if (p)
        if (Array.isArray(p))
          for (let C = p.length - 1; C >= 0; C--) {
            const m = p[C];
            c[d--] = m;
          }
        else
          c[d--] = p;
      c[d--] = h;
    }
    e.list = c;
  }
  positionLockedCols(e) {
    e.list = Bw(e.list, this.gos);
  }
  saveColOrder() {
    var e, t;
    this.showingPivotResult ? this.lastPivotOrder = ((e = this.cols) == null ? void 0 : e.list) ?? null : this.lastOrder = ((t = this.cols) == null ? void 0 : t.list) ?? null;
  }
  getColumnDefs() {
    var e, t;
    return this.colDefCols ? (t = this.beans.colDefFactory) == null ? void 0 : t.getColumnDefs(
      this.colDefCols.list,
      this.showingPivotResult,
      this.lastOrder,
      ((e = this.cols) == null ? void 0 : e.list) ?? []
    ) : void 0;
  }
  setColSpanActive() {
    var e;
    this.colSpanActive = !!((e = this.cols) != null && e.list.some((t) => t.getColDef().colSpan != null));
  }
  isPivotMode() {
    return this.pivotMode;
  }
  setPivotMode(e, t) {
    if (e === this.pivotMode || (this.pivotMode = e, !this.ready))
      return;
    this.refreshCols(!1);
    const { visibleCols: o, eventSvc: n } = this.beans;
    o.refresh(t), n.dispatchEvent({
      type: "columnPivotModeChanged"
    });
  }
  // + clientSideRowModel
  isPivotActive() {
    var t;
    const e = (t = this.beans.pivotColsSvc) == null ? void 0 : t.columns;
    return this.pivotMode && !!(e != null && e.length);
  }
  // called when dataTypes change
  recreateColumnDefs(e) {
    var o;
    if (!this.cols)
      return;
    (o = this.beans.autoColSvc) == null || o.updateColumns(e);
    const t = Bs(e.source);
    this.createColsFromColDefs(t);
  }
  setColumnDefs(e, t) {
    this.colDefs = e, this.createColsFromColDefs(t);
  }
  destroy() {
    var e;
    Js(this.beans, (e = this.colDefCols) == null ? void 0 : e.tree), super.destroy();
  }
  getColTree() {
    var e;
    return ((e = this.cols) == null ? void 0 : e.tree) ?? [];
  }
  // + columnSelectPanel
  getColDefColTree() {
    var e;
    return ((e = this.colDefCols) == null ? void 0 : e.tree) ?? [];
  }
  // + clientSideRowController -> sorting, building quick filter text
  // + headerRenderer -> sorting (clearing icon)
  getColDefCols() {
    var e;
    return ((e = this.colDefCols) == null ? void 0 : e.list) ?? null;
  }
  // + moveColumnController
  getCols() {
    var e;
    return ((e = this.cols) == null ? void 0 : e.list) ?? [];
  }
  forAllCols(e) {
    var i, r, l, a, c;
    const { pivotResultCols: t, autoColSvc: o, selectionColSvc: n, groupHierarchyColSvc: s } = this.beans;
    ar((i = this.colDefCols) == null ? void 0 : i.list, e), ar((r = o == null ? void 0 : o.columns) == null ? void 0 : r.list, e), ar((l = n == null ? void 0 : n.columns) == null ? void 0 : l.list, e), ar((a = s == null ? void 0 : s.columns) == null ? void 0 : a.list, e), ar((c = t == null ? void 0 : t.getPivotResultCols()) == null ? void 0 : c.list, e);
  }
  getColsForKeys(e) {
    return e ? e.map((t) => this.getCol(t)).filter((t) => t != null) : [];
  }
  getColDefCol(e) {
    var t;
    return (t = this.colDefCols) != null && t.list ? this.getColFromCollection(e, this.colDefCols) : null;
  }
  getCol(e) {
    return e == null ? null : this.getColFromCollection(e, this.cols);
  }
  /**
   * Get column exclusively by ID.
   *
   * Note getCol/getColFromCollection have poor performance when col has been removed.
   */
  getColById(e) {
    var t;
    return ((t = this.cols) == null ? void 0 : t.map[e]) ?? null;
  }
  getColFromCollection(e, t) {
    if (t == null)
      return null;
    const { map: o, list: n } = t;
    if (typeof e == "string" && o[e])
      return o[e];
    for (let l = 0; l < n.length; l++)
      if (qr(n[l], e))
        return n[l];
    const { autoColSvc: s, selectionColSvc: i, groupHierarchyColSvc: r } = this.beans;
    return (s == null ? void 0 : s.getColumn(e)) ?? (i == null ? void 0 : i.getColumn(e)) ?? (r == null ? void 0 : r.getColumn(e)) ?? null;
  }
}, F2 = class extends K {
  constructor() {
    super(...arguments), this.dispatchColumnChangedEvent = Nw, this.columns = [], this.columnIndexMap = {}, this.updateIndexMap = () => {
      this.columnIndexMap = {}, this.columns.forEach((e, t) => this.columnIndexMap[e.getId()] = t);
    };
  }
  wireBeans(e) {
    this.colModel = e.colModel, this.aggFuncSvc = e.aggFuncSvc, this.visibleCols = e.visibleCols, this.groupHierarchCols = e.groupHierarchyColSvc;
  }
  sortColumns(e) {
    const { groupHierarchCols: t } = this;
    this.columns.sort((o, n) => (t == null ? void 0 : t.compareVirtualColumns(o, n)) ?? e(o, n)), this.updateIndexMap();
  }
  setColumns(e, t) {
    this.setColList(e, this.columns, this.eventName, !0, !0, this.columnProcessors.set, t);
  }
  addColumns(e, t) {
    this.updateColList(e, this.columns, !0, !0, this.columnProcessors.add, this.eventName, t);
  }
  removeColumns(e, t) {
    this.updateColList(e, this.columns, !1, !0, this.columnProcessors.remove, this.eventName, t);
  }
  getColumnIndex(e) {
    return this.columnIndexMap[e];
  }
  setColList(e = [], t, o, n, s, i, r) {
    const l = this.colModel.getCols();
    if (!l || l.length === 0)
      return;
    const a = /* @__PURE__ */ new Map();
    t.forEach((d, u) => a.set(d, u)), t.length = 0, ue(e) && e.forEach((d) => {
      const u = this.colModel.getColDefCol(d);
      u && t.push(u);
    }), t.forEach((d, u) => {
      const h = a.get(d);
      if (h === void 0) {
        a.set(d, 0);
        return;
      }
      n && h !== u || a.delete(d);
    }), this.updateIndexMap();
    const c = this.colModel.getColDefCols();
    c == null || c.forEach((d) => {
      const u = t.indexOf(d) >= 0;
      i(d, u, r);
    }), s && this.colModel.refreshCols(!1), this.visibleCols.refresh(r), this.dispatchColumnChangedEvent(this.eventSvc, o, [...a.keys()], r);
  }
  updateColList(e = [], t, o, n, s, i, r) {
    if (!e || e.length === 0)
      return;
    let l = !1;
    const a = /* @__PURE__ */ new Set();
    if (e.forEach((d) => {
      if (!d)
        return;
      const u = this.colModel.getColDefCol(d);
      if (u) {
        if (a.add(u), o) {
          if (t.indexOf(u) >= 0)
            return;
          t.push(u);
        } else {
          const h = t.indexOf(u);
          if (h < 0)
            return;
          for (let p = h + 1; p < t.length; p++)
            a.add(t[p]);
          Zt(t, u);
        }
        s(u, o, r), l = !0;
      }
    }), !l)
      return;
    this.updateIndexMap(), n && this.colModel.refreshCols(!1), this.visibleCols.refresh(r);
    const c = Array.from(a);
    this.eventSvc.dispatchEvent({
      type: i,
      columns: c,
      column: c.length === 1 ? c[0] : null,
      source: r
    });
  }
  extractCols(e, t = []) {
    const o = this.columns, n = [], s = [], { setFlagFunc: i, getIndexFunc: r, getInitialIndexFunc: l, getValueFunc: a, getInitialValueFunc: c } = this.columnExtractors, d = this.colModel.getColDefCols();
    d == null || d.forEach((p) => {
      const C = !t.includes(p), m = p.getColDef(), w = a(m), y = c(m), b = r(m), _ = l(m);
      let M;
      w !== void 0 ? M = w : b !== void 0 ? b === null ? M = !1 : M = b >= 0 : C ? y !== void 0 ? M = y : _ !== void 0 ? M = _ != null && _ >= 0 : M = !1 : M = o.indexOf(p) >= 0, M && ((C ? b != null || _ != null : b != null) ? n.push(p) : s.push(p));
    });
    const u = (p) => {
      const C = p.getColDef();
      return r(C) ?? l(C);
    };
    n.sort((p, C) => u(p) - u(C));
    const h = [...n];
    return o.forEach((p) => {
      var C;
      s.indexOf(p) >= 0 && ((C = this.groupHierarchCols) == null || C.expandColumnInto(h, p));
    }), s.forEach((p) => {
      h.indexOf(p) < 0 && h.push(p);
    }), o.forEach((p) => {
      h.indexOf(p) < 0 && i(p, !1, e);
    }), h.forEach((p) => {
      o.indexOf(p) < 0 && i(p, !0, e);
    }), this.columns = h, this.updateIndexMap(), this.columns;
  }
  restoreColumnOrder(e, t) {
    const o = this.columns, n = this.colModel.getColDefCols();
    if (!o.length || !n)
      return e;
    const s = Object.keys(t), i = new Set(s), r = new Set(s), l = new Set(
      o.map((_) => {
        const M = _.getColId();
        return r.delete(M), M;
      }).concat(s)
    ), a = [], c = {};
    let d = 0;
    for (let _ = 0; _ < n.length; _++) {
      const M = n[_].getColId();
      l.has(M) && (a.push(M), c[M] = d++);
    }
    let u = 1e3, h = !1, p = 0;
    const C = this.columnOrdering.enableProp, m = this.columnOrdering.initialEnableProp, w = this.columnOrdering.indexProp, y = this.columnOrdering.initialIndexProp, b = (_) => {
      const M = c[_];
      for (let x = p; x < M; x++) {
        const L = a[x];
        r.has(L) && (t[L][w] = u++, r.delete(L));
      }
      p = M;
    };
    return o.forEach((_) => {
      const M = _.getColId();
      if (i.has(M))
        b(M), t[M][w] = u++;
      else {
        const x = _.getColDef();
        (x[w] === null || x[w] === void 0 && x[y] == null) && (h || (x[C] || x[C] === void 0 && x[m] ? b(M) : (r.forEach((R) => {
          t[R][w] = u + c[R];
        }), u += a.length, h = !0)), e[M] || (e[M] = { colId: M }), e[M][w] = u++);
      }
    }), e;
  }
}, Uw = class {
  constructor() {
    this.existingIds = {};
  }
  getInstanceIdForKey(e) {
    const t = this.existingIds[e];
    let o;
    return typeof t != "number" ? o = 0 : o = t + 1, this.existingIds[e] = o, o;
  }
};
function d1(e, t, o) {
  return o && e.addDestroyFunc(() => t.destroyBean(o)), o ?? e;
}
var J = null;
function Rd(e) {
  return typeof (e == null ? void 0 : e.getGui) == "function";
}
var Kw = class {
  constructor(e) {
    this.cssClassStates = {}, this.getGui = e;
  }
  toggleCss(e, t) {
    var n;
    if (!e)
      return;
    if (e.indexOf(" ") >= 0) {
      const s = (e || "").split(" ");
      if (s.length > 1) {
        s.forEach((i) => this.toggleCss(i, t));
        return;
      }
    }
    this.cssClassStates[e] !== t && e.length && ((n = this.getGui()) == null || n.classList.toggle(e, t), this.cssClassStates[e] = t);
  }
}, eDe = 0, u1 = class extends Cn {
  constructor(e, t) {
    super(), this.suppressDataRefValidation = !1, this.displayed = !0, this.visible = !0, this.compId = eDe++, this.cssManager = new Kw(() => this.eGui), this.componentSelectors = new Map((t ?? []).map((o) => [o.selector, o])), e && this.setTemplate(e);
  }
  preConstruct() {
    var t, o, n;
    this.wireTemplate(this.getGui());
    const e = "component-" + ((o = (t = Object.getPrototypeOf(this)) == null ? void 0 : t.constructor) == null ? void 0 : o.name);
    (n = this.css) == null || n.forEach((s) => this.beans.environment.addGlobalCSS(s, e));
  }
  wireTemplate(e, t) {
    e && this.gos && (this.applyElementsToComponent(e), this.createChildComponentsFromTags(e, t));
  }
  getCompId() {
    return this.compId;
  }
  getDataRefAttribute(e) {
    return e.getAttribute ? e.getAttribute(hw) : null;
  }
  applyElementsToComponent(e, t, o, n = null) {
    if (t === void 0 && (t = this.getDataRefAttribute(e)), t) {
      const s = this[t];
      if (s === J)
        this[t] = n ?? e;
      else {
        const i = o && o[t];
        if (!this.suppressDataRefValidation && !i)
          throw new Error(`data-ref: ${t} on ${this.constructor.name} with ${s}`);
      }
    }
  }
  // for registered components only, eg creates AgCheckbox instance from ag-checkbox HTML tag
  createChildComponentsFromTags(e, t) {
    const o = [];
    for (const n of e.childNodes ?? [])
      o.push(n);
    o.forEach((n) => {
      if (!(n instanceof HTMLElement))
        return;
      const s = this.createComponentFromElement(
        n,
        (i) => {
          const r = i.getGui();
          if (r)
            for (const l of n.attributes ?? [])
              r.setAttribute(l.name, l.value);
        },
        t
      );
      if (s) {
        if (s.addItems && n.children.length) {
          this.createChildComponentsFromTags(n, t);
          const i = Array.prototype.slice.call(n.children);
          s.addItems(i);
        }
        this.swapComponentForNode(s, e, n);
      } else n.childNodes && this.createChildComponentsFromTags(n, t);
    });
  }
  createComponentFromElement(e, t, o) {
    const n = e.nodeName, s = this.getDataRefAttribute(e), i = n.indexOf("AG-") === 0, r = i ? this.componentSelectors.get(n) : null;
    let l = null;
    if (r) {
      const a = o && s ? o[s] : void 0;
      l = new r.component(a), l.setParentComponent(
        this
      ), this.createBean(l, null, t);
    } else if (i)
      throw new Error(`selector: ${n}`);
    return this.applyElementsToComponent(e, s, o, l), l;
  }
  swapComponentForNode(e, t, o) {
    const n = e.getGui();
    t.replaceChild(n, o), t.insertBefore(document.createComment(o.nodeName), n), this.addDestroyFunc(this.destroyBean.bind(this, e));
  }
  activateTabIndex(e) {
    const t = this.gos.get("tabIndex");
    e || (e = []), e.length || e.push(this.getGui()), e.forEach((o) => o.setAttribute("tabindex", t.toString()));
  }
  setTemplate(e, t, o) {
    let n;
    typeof e == "string" || e == null ? n = y2(e) : n = c1(e), this.setTemplateFromElement(n, t, o);
  }
  setTemplateFromElement(e, t, o, n = !1) {
    if (this.eGui = e, this.suppressDataRefValidation = n, t)
      for (let s = 0; s < t.length; s++) {
        const i = t[s];
        this.componentSelectors.set(i.selector, i);
      }
    this.wireTemplate(e, o);
  }
  getGui() {
    return this.eGui;
  }
  getFocusableElement() {
    return this.eGui;
  }
  getAriaElement() {
    return this.getFocusableElement();
  }
  setParentComponent(e) {
    this.parentComponent = e;
  }
  getParentComponent() {
    return this.parentComponent;
  }
  // this method is for older code, that wants to provide the gui element,
  // it is not intended for this to be in ag-Stack
  setGui(e) {
    this.eGui = e;
  }
  queryForHtmlElement(e) {
    return this.eGui.querySelector(e);
  }
  getContainerAndElement(e, t) {
    let o = t;
    return e == null ? null : (o || (o = this.eGui), da(e) ? {
      element: e,
      parent: o
    } : {
      element: e.getGui(),
      parent: o
    });
  }
  prependChild(e, t) {
    const { element: o, parent: n } = this.getContainerAndElement(e, t) || {};
    !o || !n || n.insertAdjacentElement("afterbegin", o);
  }
  appendChild(e, t) {
    const { element: o, parent: n } = this.getContainerAndElement(e, t) || {};
    !o || !n || n.appendChild(o);
  }
  isDisplayed() {
    return this.displayed;
  }
  setVisible(e, t = {}) {
    if (e !== this.visible) {
      this.visible = e;
      const { skipAriaHidden: o } = t;
      rw(this.eGui, e, { skipAriaHidden: o });
    }
  }
  setDisplayed(e, t = {}) {
    if (e !== this.displayed) {
      this.displayed = e;
      const { skipAriaHidden: o } = t;
      He(this.eGui, e, { skipAriaHidden: o });
      const n = {
        type: "displayChanged",
        visible: this.displayed
      };
      this.dispatchLocalEvent(n);
    }
  }
  destroy() {
    this.parentComponent && (this.parentComponent = void 0), super.destroy();
  }
  addGuiEventListener(e, t, o) {
    this.eGui.addEventListener(e, t, o), this.addDestroyFunc(() => this.eGui.removeEventListener(e, t));
  }
  addCss(e) {
    this.cssManager.toggleCss(e, !0);
  }
  removeCss(e) {
    this.cssManager.toggleCss(e, !1);
  }
  toggleCss(e, t) {
    this.cssManager.toggleCss(e, t);
  }
  registerCSS(e) {
    this.css || (this.css = []), this.css.push(e);
  }
}, Re = class extends u1 {
};
function qw(e) {
  return typeof e == "object" && !!e.component;
}
function tDe(e) {
  return typeof e.then == "function";
}
function oDe(e, t) {
  return new Ye((o) => {
    o(window.setInterval(e, t));
  });
}
var Ye = class wr {
  constructor(t) {
    this.status = 0, this.resolution = null, this.waiters = [], t(
      (o) => this.onDone(o),
      (o) => this.onReject(o)
    );
  }
  static all(t) {
    return t.length ? new wr((o) => {
      let n = t.length;
      const s = new Array(n);
      t.forEach((i, r) => {
        i.then((l) => {
          s[r] = l, n--, n === 0 && o(s);
        });
      });
    }) : wr.resolve();
  }
  static resolve(t = null) {
    return new wr((o) => o(t));
  }
  then(t) {
    return new wr((o) => {
      this.status === 1 ? o(t(this.resolution)) : this.waiters.push((n) => o(t(n)));
    });
  }
  onDone(t) {
    this.status = 1, this.resolution = t, this.waiters.forEach((o) => o(t));
  }
  onReject(t) {
  }
};
function nDe(e) {
  return e ? e.prototype && "getGui" in e.prototype : !1;
}
function Yw(e, t, o, n) {
  const { name: s } = o;
  let i, r, l, a, c, d;
  if (t) {
    const u = t, h = u[s + "Selector"], p = h ? h(n) : null, C = (m) => {
      typeof m == "string" ? i = m : m != null && m !== !0 && (e.isFrameworkComponent(m) ? l = m : r = m);
    };
    p ? (C(p.component), a = p.params, c = p.popup, d = p.popupPosition) : C(u[s]);
  }
  return { compName: i, jsComp: r, fwComp: l, paramsFromSelector: a, popupFromSelector: c, popupPositionFromSelector: d };
}
var sDe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "userCompFactory";
  }
  wireBeans(e) {
    this.agCompUtils = e.agCompUtils, this.registry = e.registry, this.frameworkCompWrapper = e.frameworkCompWrapper, this.gridOptions = e.gridOptions;
  }
  getCompDetailsFromGridOptions(e, t, o, n = !1) {
    return this.getCompDetails(this.gridOptions, e, t, o, n);
  }
  getCompDetails(e, t, o, n, s = !1) {
    var _;
    const { name: i, cellRenderer: r } = t;
    let { compName: l, jsComp: a, fwComp: c, paramsFromSelector: d, popupFromSelector: u, popupPositionFromSelector: h } = Yw(this.beans.frameworkOverrides, e, t, n), p, C;
    const m = (M) => {
      const x = this.registry.getUserComponent(i, M);
      x && (a = x.componentFromFramework ? void 0 : x.component, c = x.componentFromFramework ? x.component : void 0, p = x.params, C = x.processParams);
    };
    if (l != null && m(l), a == null && c == null && o != null && m(o), a && r && !nDe(a) && (a = (_ = this.agCompUtils) == null ? void 0 : _.adaptFunction(t, a)), !a && !c) {
      const { validation: M } = this.beans;
      s && (l !== o || !o) ? l ? M != null && M.isProvidedUserComp(l) || qe(50, { compName: l }) : o ? M || qe(260, {
        ...this.gos.getModuleErrorParams(),
        propName: i,
        compName: o
      }) : qe(216, { name: i }) : o && !M && qe(146, { comp: o });
      return;
    }
    const w = this.mergeParams(
      e,
      t,
      n,
      d,
      p,
      C
    ), y = a == null, b = a ?? c;
    return {
      componentFromFramework: y,
      componentClass: b,
      params: w,
      type: t,
      popupFromSelector: u,
      popupPositionFromSelector: h,
      newAgStackInstance: () => this.newAgStackInstance(b, y, w, t)
    };
  }
  newAgStackInstance(e, t, o, n) {
    var l;
    const s = !t;
    let i;
    s ? i = new e() : i = this.frameworkCompWrapper.wrap(
      e,
      n.mandatoryMethods,
      n.optionalMethods,
      n
    ), this.createBean(i);
    const r = (l = i.init) == null ? void 0 : l.call(i, o);
    return r == null ? Ye.resolve(i) : r.then(() => i);
  }
  /**
   * merges params with application provided params
   * used by Floating Filter
   */
  mergeParams(e, t, o, n = null, s, i) {
    const r = { ...o, ...s }, l = e, a = l && l[t.name + "Params"];
    if (typeof a == "function") {
      const c = a(o);
      qt(r, c);
    } else typeof a == "object" && qt(r, a);
    return qt(r, n), i ? i(r) : r;
  }
}, iDe = {
  name: "dateComponent",
  mandatoryMethods: ["getDate", "setDate"],
  optionalMethods: ["afterGuiAttached", "setInputPlaceholder", "setInputAriaLabel", "setDisabled", "refresh"]
}, rDe = {
  name: "dragAndDropImageComponent",
  mandatoryMethods: ["setIcon", "setLabel"]
}, lDe = { name: "headerComponent", optionalMethods: ["refresh"] }, aDe = { name: "innerHeaderComponent" }, cDe = { name: "innerHeaderGroupComponent" }, dDe = { name: "headerGroupComponent" }, uDe = {
  name: "innerRenderer",
  cellRenderer: !0,
  optionalMethods: ["afterGuiAttached"]
}, hDe = {
  name: "cellRenderer",
  optionalMethods: ["refresh", "afterGuiAttached"],
  cellRenderer: !0
}, gDe = {
  name: "cellRenderer",
  optionalMethods: ["refresh", "afterGuiAttached"]
}, pDe = { name: "loadingCellRenderer", cellRenderer: !0 }, fDe = {
  name: "cellEditor",
  mandatoryMethods: ["getValue"],
  optionalMethods: [
    "isPopup",
    "isCancelBeforeStart",
    "isCancelAfterEnd",
    "getPopupPosition",
    "focusIn",
    "focusOut",
    "afterGuiAttached",
    "refresh"
  ]
}, vDe = { name: "loadingOverlayComponent", optionalMethods: ["refresh"] }, mDe = { name: "noRowsOverlayComponent", optionalMethods: ["refresh"] }, CDe = { name: "tooltipComponent" }, T2 = {
  name: "filter",
  mandatoryMethods: ["isFilterActive", "doesFilterPass", "getModel", "setModel"],
  optionalMethods: [
    "afterGuiAttached",
    "afterGuiDetached",
    "onNewRowsLoaded",
    "getModelAsString",
    "onFloatingFilterChanged",
    "onAnyFilterChanged",
    "refresh"
  ]
}, wDe = {
  name: "floatingFilterComponent",
  mandatoryMethods: ["onParentModelChanged"],
  optionalMethods: ["afterGuiAttached", "refresh"]
}, bDe = {
  name: "fullWidthCellRenderer",
  optionalMethods: ["refresh", "afterGuiAttached"],
  cellRenderer: !0
}, yDe = { name: "loadingCellRenderer", cellRenderer: !0 }, _De = {
  name: "groupRowRenderer",
  optionalMethods: ["afterGuiAttached"],
  cellRenderer: !0
}, SDe = { name: "detailCellRenderer", optionalMethods: ["refresh"], cellRenderer: !0 };
function xDe(e, t) {
  return e.getCompDetailsFromGridOptions(rDe, "agDragAndDropImage", t, !0);
}
function M1(e, t, o) {
  return e.getCompDetails(t, uDe, void 0, o);
}
function MDe(e, t, o) {
  return e.getCompDetails(t, lDe, "agColumnHeader", o);
}
function ADe(e, t, o) {
  return e.getCompDetails(t, aDe, void 0, o);
}
function LDe(e, t) {
  const o = t.columnGroup.getColGroupDef();
  return e.getCompDetails(o, dDe, "agColumnGroupHeader", t);
}
function EDe(e, t, o) {
  return e.getCompDetails(t, cDe, void 0, o);
}
function PDe(e, t) {
  return e.getCompDetailsFromGridOptions(bDe, void 0, t, !0);
}
function RDe(e, t) {
  return e.getCompDetailsFromGridOptions(yDe, "agLoadingCellRenderer", t, !0);
}
function FDe(e, t) {
  return e.getCompDetailsFromGridOptions(_De, "agGroupRowRenderer", t, !0);
}
function TDe(e, t) {
  return e.getCompDetailsFromGridOptions(SDe, "agDetailCellRenderer", t, !0);
}
function Ni(e, t, o) {
  return e.getCompDetails(t, hDe, void 0, o);
}
function Qw(e, t, o) {
  return e.getCompDetails(
    t,
    gDe,
    void 0,
    o
  );
}
function Fd(e, t, o) {
  return e.getCompDetails(t, pDe, "agSkeletonCellRenderer", o, !0);
}
function Jw(e, t, o) {
  return e.getCompDetails(t, fDe, "agCellEditor", o, !0);
}
function IDe(e, t, o, n) {
  const s = t.filter;
  return qw(s) && (t = {
    filter: s.component,
    filterParams: t.filterParams
  }), e.getCompDetails(t, T2, n, o, !0);
}
function DDe(e, t, o) {
  return e.getCompDetails(t, iDe, "agDateInput", o, !0);
}
function kDe(e, t) {
  return e.getCompDetailsFromGridOptions(vDe, "agLoadingOverlay", t, !0);
}
function HDe(e, t) {
  return e.getCompDetailsFromGridOptions(mDe, "agNoRowsOverlay", t, !0);
}
function VDe(e, t) {
  return e.getCompDetails(t.colDef, CDe, "agTooltipComponent", t, !0);
}
function ODe(e, t, o, n) {
  return e.getCompDetails(t, wDe, n, o);
}
function Xw(e, t) {
  return Yw(e, t, T2);
}
function Ya(e, t, o) {
  return e.mergeParams(t, T2, o);
}
function zi(e) {
  const t = e;
  return t != null && t.getFrameworkComponentInstance != null ? t.getFrameworkComponentInstance() : e;
}
function BDe(e) {
  return typeof e == "object" && !!e.getComp;
}
var D = {
  BACKSPACE: "Backspace",
  TAB: "Tab",
  ENTER: "Enter",
  ESCAPE: "Escape",
  SPACE: " ",
  LEFT: "ArrowLeft",
  UP: "ArrowUp",
  RIGHT: "ArrowRight",
  DOWN: "ArrowDown",
  DELETE: "Delete",
  F2: "F2",
  PAGE_UP: "PageUp",
  PAGE_DOWN: "PageDown",
  PAGE_HOME: "Home",
  PAGE_END: "End",
  // these should be used with `event.code` instead of `event.key`
  // as `event.key` changes when non-latin keyboards are used
  A: "KeyA",
  C: "KeyC",
  D: "KeyD",
  V: "KeyV",
  X: "KeyX",
  Y: "KeyY",
  Z: "KeyZ"
}, ga = class extends u1 {
  isPopup() {
    return !0;
  }
  setParentComponent(e) {
    e.addCss("ag-has-popup"), super.setParentComponent(e);
  }
  destroy() {
    const e = this.parentComponent;
    e && e.isAlive() && e.getGui().classList.remove("ag-has-popup"), super.destroy();
  }
}, Qa, Ja, Xa, e0, t5, o5, t0;
function Gn() {
  return Qa === void 0 && (Qa = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)), Qa;
}
function I2() {
  return Ja === void 0 && (Ja = /(firefox)/i.test(navigator.userAgent)), Ja;
}
function eb() {
  return Xa === void 0 && (Xa = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform)), Xa;
}
function ss() {
  return e0 === void 0 && (e0 = /iPad|iPhone|iPod/.test(navigator.platform) || navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1), e0;
}
function n5(e) {
  if (!e)
    return null;
  const t = e.tabIndex, o = e.getAttribute("tabIndex");
  return t === -1 && (o === null || o === "" && !I2()) ? null : t.toString();
}
function $De() {
  if (t0 !== void 0)
    return t0;
  if (!document.body)
    return -1;
  let e = 1e6;
  const t = I2() ? 6e6 : 1e9, o = document.createElement("div");
  for (document.body.appendChild(o); ; ) {
    const n = e * 2;
    if (o.style.height = n + "px", n > t || o.clientHeight !== n)
      break;
    e = n;
  }
  return document.body.removeChild(o), t0 = e, e;
}
function ZDe() {
  return o5 == null && tb(), o5;
}
function tb() {
  const e = document.body, t = document.createElement("div");
  t.style.width = t.style.height = "100px", t.style.opacity = "0", t.style.overflow = "scroll", t.style.msOverflowStyle = "scrollbar", t.style.position = "absolute", e.appendChild(t);
  let o = t.offsetWidth - t.clientWidth;
  o === 0 && t.clientWidth === 0 && (o = null), t.parentNode && t.parentNode.removeChild(t), o != null && (o5 = o, t5 = o === 0);
}
function ob() {
  return t5 == null && tb(), t5;
}
var D2 = "T", GDe = new RegExp(`[${D2} ]`), NDe = new RegExp(`^\\d{4}-\\d{2}-\\d{2}(${D2}\\d{2}:\\d{2}:\\d{2}\\D?)?`);
function on(e, t) {
  return e.toString().padStart(t, "0");
}
function to(e, t = !0, o = D2) {
  if (!e)
    return null;
  let n = [e.getFullYear(), e.getMonth() + 1, e.getDate()].map((s) => on(s, 2)).join("-");
  return t && (n += o + [e.getHours(), e.getMinutes(), e.getSeconds()].map((s) => on(s, 2)).join(":")), n;
}
function Ci(e, t = !0) {
  return e ? t ? [
    String(e.getFullYear()),
    String(e.getMonth() + 1),
    on(e.getDate(), 2),
    on(e.getHours(), 2),
    `:${on(e.getMinutes(), 2)}`,
    `:${on(e.getSeconds(), 2)}`
  ] : [e.getFullYear(), e.getMonth() + 1, on(e.getDate(), 2)].map(String) : null;
}
var o0 = (e) => {
  if (e > 3 && e < 21)
    return "th";
  switch (e % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
  }
  return "th";
}, Al = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
], n0 = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
function s5(e, t) {
  if (t == null)
    return to(e, !1);
  const o = on(e.getFullYear(), 4), n = {
    YYYY: () => o.slice(o.length - 4, o.length),
    YY: () => o.slice(o.length - 2, o.length),
    Y: () => `${e.getFullYear()}`,
    MMMM: () => Al[e.getMonth()],
    MMM: () => Al[e.getMonth()].slice(0, 3),
    MM: () => on(e.getMonth() + 1, 2),
    Mo: () => `${e.getMonth() + 1}${o0(e.getMonth() + 1)}`,
    M: () => `${e.getMonth() + 1}`,
    Do: () => `${e.getDate()}${o0(e.getDate())}`,
    DD: () => on(e.getDate(), 2),
    D: () => `${e.getDate()}`,
    dddd: () => n0[e.getDay()],
    ddd: () => n0[e.getDay()].slice(0, 3),
    dd: () => n0[e.getDay()].slice(0, 2),
    do: () => `${e.getDay()}${o0(e.getDay())}`,
    d: () => `${e.getDay()}`
  }, s = new RegExp(Object.keys(n).join("|"), "g");
  return t.replace(s, (i) => i in n ? n[i]() : i);
}
function U1(e, t = !1) {
  return !!Wt(e, t);
}
function zDe(e) {
  return U1(e, !0);
}
function Wt(e, t = !1, o) {
  if (!e || !o && !NDe.test(e))
    return null;
  const [n, s] = e.split(GDe);
  if (!n)
    return null;
  const i = n.split("-").map((p) => parseInt(p, 10));
  if (i.filter((p) => !isNaN(p)).length !== 3)
    return null;
  const [r, l, a] = i, c = new Date(r, l - 1, a);
  if (c.getFullYear() !== r || c.getMonth() !== l - 1 || c.getDate() !== a || !s && t)
    return null;
  if (!s || s === "00:00:00")
    return c;
  const [d, u, h] = s.split(":").map((p) => parseInt(p, 10));
  if (d >= 0 && d < 24)
    c.setHours(d);
  else if (t)
    return null;
  if (u >= 0 && u < 60)
    c.setMinutes(u);
  else if (t)
    return null;
  if (h >= 0 && h < 60)
    c.setSeconds(h);
  else if (t)
    return null;
  return c;
}
function Yr(e) {
  const { inputValue: t, allSuggestions: o, hideIrrelevant: n, filterByPercentageOfBestMatch: s } = e;
  let i = (o ?? []).map(
    (a, c) => ({
      value: a,
      relevance: jDe(t, a),
      idx: c
    })
  );
  if (i.sort((a, c) => a.relevance - c.relevance), n && (i = i.filter(
    (a) => a.relevance < Math.max(a.value.length, t.length)
  )), i.length > 0 && s && s > 0) {
    const c = i[0].relevance * s;
    i = i.filter((d) => c - d.relevance < 0);
  }
  const r = [], l = [];
  for (const a of i)
    r.push(a.value), l.push(a.idx);
  return { values: r, indices: l };
}
function jDe(e, t) {
  e.length < t.length && ([e, t] = [t, e]);
  let o = [], n = [];
  const s = e.length, i = t.length;
  for (let l = 0; l <= i; l++)
    o[l] = l;
  let r = 0;
  for (let l = 1; l <= s; l++) {
    n[0] = l;
    for (let a = 1; a <= i; a++) {
      const c = e[l - 1], d = t[a - 1];
      if (c.toLocaleLowerCase() === d.toLocaleLowerCase())
        ++r, c === d && ++r, l > 1 && a > 1 && e[l - 2].toLocaleLowerCase() === t[a - 2].toLocaleLowerCase() && (++r, e[l - 2] === t[a - 2] && ++r), l < s / 2 - 10 && ++r, n[a] = o[a - 1];
      else {
        const u = n[a - 1], h = o[a], p = o[a - 1];
        n[a] = 1 + Math.min(u, h, p);
      }
    }
    [o, n] = [n, o];
  }
  return o[i] / (r + 1);
}
function k2(e) {
  var o;
  return e.altKey || e.ctrlKey || e.metaKey ? !1 : ((o = e.key) == null ? void 0 : o.length) === 1;
}
var i5 = !1, Ll = 0;
function WDe(e) {
  Ll > 0 || (e.addEventListener("keydown", El), e.addEventListener("mousedown", El));
}
function UDe(e) {
  Ll > 0 || (e.removeEventListener("keydown", El), e.removeEventListener("mousedown", El));
}
function El(e) {
  const t = i5, o = e.type === "keydown";
  o && (e.ctrlKey || e.metaKey || e.altKey) || t !== o && (i5 = o);
}
function KDe(e) {
  const t = Pt(e);
  return WDe(t), Ll++, () => {
    Ll--, UDe(t);
  };
}
function pa() {
  return i5;
}
function Fn(e, t, o = !1) {
  const n = QTe;
  let s = iw;
  t && (s += ", " + t), o && (s += ', [tabindex="-1"]');
  const i = Array.prototype.slice.apply(e.querySelectorAll(n)).filter((a) => ro(a)), r = Array.prototype.slice.apply(e.querySelectorAll(s));
  return r.length ? ((a, c) => a.filter((d) => c.indexOf(d) === -1))(i, r) : i;
}
function so(e, t = !1, o = !1, n = !1) {
  const s = Fn(
    e,
    n ? ".ag-tab-guard" : null,
    o
  ), i = t ? Ke(s) : s[0];
  return i ? (i.focus({ preventScroll: !0 }), !0) : !1;
}
function Yt(e, t, o, n) {
  const s = Fn(t, o ? ':not([tabindex="-1"])' : null), i = Ue(e);
  let r;
  o ? r = s.findIndex((a) => a.contains(i)) : r = s.indexOf(i);
  const l = r + (n ? -1 : 1);
  return l < 0 || l >= s.length ? null : s[l];
}
function H2(e, t = 5) {
  let o = 0;
  for (; e && n5(e) === null && ++o <= t; )
    e = e.parentElement;
  return n5(e) === null ? null : e;
}
var qDe = (
  /*css*/
  ".ag-label{white-space:nowrap}:where(.ag-ltr) .ag-label{margin-right:var(--ag-spacing)}:where(.ag-rtl) .ag-label{margin-left:var(--ag-spacing)}:where(.ag-label-align-right) .ag-label{order:1}:where(.ag-ltr) :where(.ag-label-align-right) .ag-label{margin-left:var(--ag-spacing)}:where(.ag-rtl) :where(.ag-label-align-right) .ag-label{margin-right:var(--ag-spacing)}.ag-label-align-right>*{flex:none}.ag-label-align-top{align-items:flex-start;flex-direction:column;>*{align-self:stretch}}.ag-label-ellipsis{flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}:where(.ag-label-align-top) .ag-label{margin-bottom:calc(var(--ag-spacing)*.5)}"
), YDe = class extends u1 {
  constructor(e, t, o) {
    super(t, o), this.labelSeparator = "", this.labelAlignment = "left", this.disabled = !1, this.label = "", this.config = e || {}, this.registerCSS(qDe);
  }
  postConstruct() {
    this.addCss("ag-labeled"), this.eLabel.classList.add("ag-label");
    const { labelSeparator: e, label: t, labelWidth: o, labelAlignment: n, disabled: s } = this.config;
    s != null && this.setDisabled(s), e != null && this.setLabelSeparator(e), t != null && this.setLabel(t), o != null && this.setLabelWidth(o), this.setLabelAlignment(n || this.labelAlignment), this.refreshLabel();
  }
  refreshLabel() {
    const { label: e, eLabel: t } = this;
    it(t), typeof e == "string" ? t.innerText = e + this.labelSeparator : e && t.appendChild(e), e === "" ? (He(t, !1), no(t, "presentation")) : (He(t, !0), no(t, null));
  }
  setLabelSeparator(e) {
    return this.labelSeparator === e ? this : (this.labelSeparator = e, this.label != null && this.refreshLabel(), this);
  }
  getLabelId() {
    const e = this.eLabel;
    return e.id = e.id || `ag-${this.getCompId()}-label`, e.id;
  }
  getLabel() {
    return this.label;
  }
  setLabel(e) {
    return this.label === e ? this : (this.label = e, this.refreshLabel(), this);
  }
  setLabelAlignment(e) {
    const o = this.getGui().classList;
    return o.toggle("ag-label-align-left", e === "left"), o.toggle("ag-label-align-right", e === "right"), o.toggle("ag-label-align-top", e === "top"), this;
  }
  setLabelEllipsis(e) {
    return this.eLabel.classList.toggle("ag-label-ellipsis", e), this;
  }
  setLabelWidth(e) {
    return this.label == null ? this : (bl(this.eLabel, e), this);
  }
  setDisabled(e) {
    e = !!e;
    const t = this.getGui();
    return qs(t, e), t.classList.toggle("ag-disabled", e), this.disabled = e, this;
  }
  isDisabled() {
    return !!this.disabled;
  }
}, nb = class extends YDe {
  constructor(e, t, o, n) {
    super(e, t, o), this.className = n;
  }
  postConstruct() {
    super.postConstruct();
    const { width: e, value: t, onValueChange: o } = this.config;
    e != null && this.setWidth(e), t != null && this.setValue(t), o != null && this.onValueChange(o), this.className && this.addCss(this.className), this.refreshAriaLabelledBy();
  }
  setLabel(e) {
    return super.setLabel(e), this.refreshAriaLabelledBy(), this;
  }
  refreshAriaLabelledBy() {
    const e = this.getAriaElement(), t = this.getLabelId(), o = this.getLabel();
    o == null || o == "" || BTe(e) !== null ? as(e, "") : as(e, t ?? "");
  }
  setAriaLabel(e) {
    return ft(this.getAriaElement(), e), this.refreshAriaLabelledBy(), this;
  }
  onValueChange(e) {
    return this.addManagedListeners(this, { fieldValueChanged: () => e(this.getValue()) }), this;
  }
  getWidth() {
    return this.getGui().clientWidth;
  }
  setWidth(e) {
    return rn(this.getGui(), e), this;
  }
  getPreviousValue() {
    return this.previousValue;
  }
  getValue() {
    return this.value;
  }
  setValue(e, t) {
    return this.value === e ? this : (this.previousValue = this.value, this.value = e, t || this.dispatchLocalEvent({ type: "fieldValueChanged" }), this);
  }
};
function QDe(e) {
  return {
    tag: "div",
    role: "presentation",
    children: [
      { tag: "div", ref: "eLabel", cls: "ag-input-field-label" },
      {
        tag: "div",
        ref: "eWrapper",
        cls: "ag-wrapper ag-input-wrapper",
        role: "presentation",
        children: [{ tag: e, ref: "eInput", cls: "ag-input-field-input" }]
      }
    ]
  };
}
var Es = class extends nb {
  constructor(e, t, o = "text", n = "input") {
    super(e, (e == null ? void 0 : e.template) ?? QDe(n), [], t), this.inputType = o, this.displayFieldTag = n, this.eLabel = J, this.eWrapper = J, this.eInput = J;
  }
  postConstruct() {
    super.postConstruct(), this.setInputType(this.inputType);
    const { eLabel: e, eWrapper: t, eInput: o, className: n } = this;
    e.classList.add(`${n}-label`), t.classList.add(`${n}-input-wrapper`), o.classList.add(`${n}-input`), this.addCss("ag-input-field"), o.id = o.id || `ag-${this.getCompId()}-input`;
    const { inputName: s, inputWidth: i } = this.config;
    s != null && this.setInputName(s), i != null && this.setInputWidth(i), this.addInputListeners(), this.activateTabIndex([o]);
  }
  addInputListeners() {
    this.addManagedElementListeners(this.eInput, {
      input: (e) => this.setValue(e.target.value)
    });
  }
  setInputType(e) {
    this.displayFieldTag === "input" && (this.inputType = e, mo(this.eInput, "type", e));
  }
  getInputElement() {
    return this.eInput;
  }
  setInputWidth(e) {
    return bl(this.eWrapper, e), this;
  }
  setInputName(e) {
    return this.getInputElement().setAttribute("name", e), this;
  }
  getFocusableElement() {
    return this.eInput;
  }
  setMaxLength(e) {
    const t = this.eInput;
    return t.maxLength = e, this;
  }
  setInputPlaceholder(e) {
    return mo(this.eInput, "placeholder", e), this;
  }
  setInputAriaLabel(e) {
    return ft(this.eInput, e), this.refreshAriaLabelledBy(), this;
  }
  setDisabled(e) {
    return qs(this.eInput, e), super.setDisabled(e);
  }
  setAutoComplete(e) {
    if (e === !0)
      mo(this.eInput, "autocomplete", null);
    else {
      const t = typeof e == "string" ? e : "off";
      mo(this.eInput, "autocomplete", t);
    }
    return this;
  }
}, fa = class extends Es {
  constructor(e, t = "ag-checkbox", o = "checkbox") {
    super(e, t, o), this.labelAlignment = "right", this.selected = !1, this.readOnly = !1, this.passive = !1;
  }
  postConstruct() {
    super.postConstruct();
    const { readOnly: e, passive: t } = this.config;
    typeof e == "boolean" && this.setReadOnly(e), typeof t == "boolean" && this.setPassive(t);
  }
  addInputListeners() {
    this.addManagedElementListeners(this.eInput, { click: this.onCheckboxClick.bind(this) }), this.addManagedElementListeners(this.eLabel, { click: this.toggle.bind(this) });
  }
  getNextValue() {
    return this.selected === void 0 ? !0 : !this.selected;
  }
  setPassive(e) {
    this.passive = e;
  }
  isReadOnly() {
    return this.readOnly;
  }
  setReadOnly(e) {
    this.eWrapper.classList.toggle("ag-disabled", e), this.eInput.disabled = e, this.readOnly = e;
  }
  setDisabled(e) {
    return this.eWrapper.classList.toggle("ag-disabled", e), super.setDisabled(e);
  }
  toggle() {
    if (this.eInput.disabled)
      return;
    const e = this.isSelected(), t = this.getNextValue();
    this.passive ? this.dispatchChange(t, e) : this.setValue(t);
  }
  getValue() {
    return this.isSelected();
  }
  setValue(e, t) {
    return this.refreshSelectedClass(e), this.setSelected(e, t), this;
  }
  setName(e) {
    const t = this.getInputElement();
    return t.name = e, this;
  }
  isSelected() {
    return this.selected;
  }
  setSelected(e, t) {
    if (this.isSelected() === e)
      return;
    this.previousValue = this.isSelected(), e = this.selected = typeof e == "boolean" ? e : void 0;
    const o = this.eInput;
    o.checked = e, o.indeterminate = e === void 0, t || this.dispatchChange(this.selected, this.previousValue);
  }
  dispatchChange(e, t, o) {
    this.dispatchLocalEvent({ type: "fieldValueChanged", selected: e, previousValue: t, event: o });
    const n = this.getInputElement();
    this.eventSvc.dispatchEvent({
      type: "checkboxChanged",
      id: n.id,
      name: n.name,
      selected: e,
      previousValue: t
    });
  }
  onCheckboxClick(e) {
    if (this.passive || this.eInput.disabled)
      return;
    const t = this.isSelected(), o = this.selected = e.target.checked;
    this.refreshSelectedClass(o), this.dispatchChange(o, t, e);
  }
  refreshSelectedClass(e) {
    const t = this.eWrapper.classList;
    t.toggle("ag-checked", e === !0), t.toggle("ag-indeterminate", e == null);
  }
}, ii = {
  selector: "AG-CHECKBOX",
  component: fa
}, JDe = class extends fa {
  constructor(e) {
    super(e, "ag-radio-button", "radio");
  }
  isSelected() {
    return this.eInput.checked;
  }
  toggle() {
    this.eInput.disabled || this.isSelected() || this.setValue(!0);
  }
  addInputListeners() {
    super.addInputListeners(), this.addManagedEventListeners({ checkboxChanged: this.onChange.bind(this) });
  }
  /**
   * This ensures that if another radio button in the same named group is selected, we deselect this radio button.
   * By default the browser does this for you, but we are managing classes ourselves in order to ensure input
   * elements are styled correctly in IE11, and the DOM 'changed' event is only fired when a button is selected,
   * not deselected, so we need to use our own event.
   */
  onChange(e) {
    const t = this.eInput;
    e.selected && e.name && t.name && t.name === e.name && e.id && t.id !== e.id && this.setValue(!1, !0);
  }
}, XDe = (
  /*css*/
  '.ag-toggle-button{flex:none;min-width:unset;width:unset}.ag-toggle-button-input-wrapper{background-color:var(--ag-toggle-button-off-background-color);border-radius:calc(var(--ag-toggle-button-height)*.5);flex:none;height:var(--ag-toggle-button-height);max-width:var(--ag-toggle-button-width);min-width:var(--ag-toggle-button-width);position:relative;transition:background-color .1s;:where(.ag-toggle-button-input){-webkit-appearance:none;-moz-appearance:none;appearance:none;cursor:pointer;display:block;height:var(--ag-toggle-button-height);margin:0;max-width:var(--ag-toggle-button-width);min-width:var(--ag-toggle-button-width);opacity:0}&:before{background-color:var(--ag-toggle-button-switch-background-color);border-radius:100%;content:"";display:block;height:calc(var(--ag-toggle-button-height) - var(--ag-toggle-button-switch-inset)*2);left:var(--ag-toggle-button-switch-inset);pointer-events:none;position:absolute;top:var(--ag-toggle-button-switch-inset);transition:left .1s;width:calc(var(--ag-toggle-button-height) - var(--ag-toggle-button-switch-inset)*2)}&.ag-checked{background-color:var(--ag-toggle-button-on-background-color);&:before{left:calc(100% - var(--ag-toggle-button-height) + var(--ag-toggle-button-switch-inset))}}&:focus-within{box-shadow:var(--ag-focus-shadow)}&.ag-disabled{opacity:.5}}'
), eke = class extends fa {
  constructor(e) {
    super(e, "ag-toggle-button"), this.registerCSS(XDe);
  }
  setValue(e, t) {
    return super.setValue(e, t), this.toggleCss("ag-selected", this.getValue()), this;
  }
}, tke = {
  selector: "AG-TOGGLE-BUTTON",
  component: eke
}, an = class extends Es {
  constructor(e, t = "ag-text-field", o = "text") {
    super(e, t, o);
  }
  postConstruct() {
    super.postConstruct(), this.config.allowedCharPattern && this.preventDisallowedCharacters();
  }
  setValue(e, t) {
    const o = this.eInput;
    return o.value !== e && (o.value = ue(e) ? e : ""), super.setValue(e, t);
  }
  /** Used to set an initial value into the input without necessarily setting `this.value` or triggering events (e.g. to set an invalid value) */
  setStartValue(e) {
    this.setValue(e, !0);
  }
  preventDisallowedCharacters() {
    const e = new RegExp(`[${this.config.allowedCharPattern}]`), t = (o) => {
      k2(o) && o.key && !e.test(o.key) && o.preventDefault();
    };
    this.addManagedListeners(this.eInput, {
      keydown: t,
      paste: (o) => {
        var s;
        const n = (s = o.clipboardData) == null ? void 0 : s.getData("text");
        n && n.split("").some((i) => !e.test(i)) && o.preventDefault();
      }
    });
  }
}, zo = {
  selector: "AG-INPUT-TEXT-FIELD",
  component: an
}, oke = class extends Es {
  constructor(e) {
    super(e, "ag-text-area", null, "textarea");
  }
  setValue(e, t) {
    const o = super.setValue(e, t);
    return this.eInput.value = e, o;
  }
  setCols(e) {
    return this.eInput.cols = e, this;
  }
  setRows(e) {
    return this.eInput.rows = e, this;
  }
}, nke = {
  selector: "AG-INPUT-TEXT-AREA",
  component: oke
}, va = class extends an {
  constructor(e) {
    super(e, "ag-number-field", "number");
  }
  postConstruct() {
    super.postConstruct();
    const e = this.eInput;
    this.addManagedListeners(e, {
      blur: () => {
        const i = parseFloat(e.value), r = isNaN(i) ? "" : this.normalizeValue(i.toString());
        this.value !== r && this.setValue(r);
      },
      wheel: this.onWheel.bind(this)
    }), e.step = "any";
    const { precision: t, min: o, max: n, step: s } = this.config;
    typeof t == "number" && this.setPrecision(t), typeof o == "number" && this.setMin(o), typeof n == "number" && this.setMax(n), typeof s == "number" && this.setStep(s);
  }
  onWheel(e) {
    Ue(this.beans) === this.eInput && e.preventDefault();
  }
  normalizeValue(e) {
    return e === "" ? "" : (this.precision != null && (e = this.adjustPrecision(e)), e);
  }
  adjustPrecision(e, t) {
    const o = this.precision;
    if (o == null)
      return e;
    if (t) {
      const s = parseFloat(e).toFixed(o);
      return parseFloat(s).toString();
    }
    const n = String(e).split(".");
    if (n.length > 1) {
      if (n[1].length <= o)
        return e;
      if (o > 0)
        return `${n[0]}.${n[1].slice(0, o)}`;
    }
    return n[0];
  }
  setMin(e) {
    return this.min === e ? this : (this.min = e, mo(this.eInput, "min", e), this);
  }
  setMax(e) {
    return this.max === e ? this : (this.max = e, mo(this.eInput, "max", e), this);
  }
  setPrecision(e) {
    return this.precision = e, this;
  }
  setStep(e) {
    return this.step === e ? this : (this.step = e, mo(this.eInput, "step", e), this);
  }
  setValue(e, t) {
    return this.setValueOrInputValue(
      (o) => super.setValue(o, t),
      () => this,
      e
    );
  }
  setStartValue(e) {
    return this.setValueOrInputValue(
      (t) => super.setValue(t, !0),
      (t) => {
        this.eInput.value = t;
      },
      e
    );
  }
  setValueOrInputValue(e, t, o) {
    if (ue(o)) {
      let n = this.isScientificNotation(o);
      if (n && this.eInput.validity.valid)
        return e(o);
      if (!n) {
        o = this.adjustPrecision(o);
        const s = this.normalizeValue(o);
        n = o != s;
      }
      if (n)
        return t(o);
    }
    return e(o);
  }
  getValue() {
    const e = this.eInput;
    if (!e.validity.valid)
      return;
    const t = e.value;
    return this.isScientificNotation(t) ? this.adjustPrecision(t, !0) : super.getValue();
  }
  isScientificNotation(e) {
    return typeof e == "string" && e.includes("e");
  }
}, ske = {
  selector: "AG-INPUT-NUMBER-FIELD",
  component: va
}, br = class extends an {
  constructor(e) {
    super(e, "ag-date-field", "date");
  }
  postConstruct() {
    super.postConstruct();
    const e = Gn();
    this.addManagedListeners(this.eInput, {
      wheel: this.onWheel.bind(this),
      mousedown: () => {
        this.isDisabled() || e || this.eInput.focus();
      }
    }), this.eInput.step = "any";
  }
  onWheel(e) {
    Ue(this.beans) === this.eInput && e.preventDefault();
  }
  setMin(e) {
    const t = e instanceof Date ? to(e ?? null, !!this.includeTime) ?? void 0 : e;
    return this.min === t ? this : (this.min = t, mo(this.eInput, "min", t), this);
  }
  setMax(e) {
    const t = e instanceof Date ? to(e ?? null, !!this.includeTime) ?? void 0 : e;
    return this.max === t ? this : (this.max = t, mo(this.eInput, "max", t), this);
  }
  setStep(e) {
    return this.step === e ? this : (this.step = e, mo(this.eInput, "step", e), this);
  }
  setIncludeTime(e) {
    return this.includeTime === e ? this : (this.includeTime = e, super.setInputType(e ? "datetime-local" : "date"), e && this.setStep(1), this);
  }
  getDate() {
    if (this.eInput.validity.valid)
      return Wt(this.getValue()) ?? void 0;
  }
  setDate(e, t) {
    this.setValue(to(e ?? null, this.includeTime), t);
  }
}, sb = {
  selector: "AG-INPUT-DATE-FIELD",
  component: br
}, ike = (
  /*css*/
  ".ag-list-item{align-items:center;display:flex;height:var(--ag-list-item-height);overflow:hidden;text-overflow:ellipsis;white-space:nowrap;&.ag-active-item{background-color:var(--ag-row-hover-color)}}"
), rke = "ag-active-item", lke = (e, t) => ({
  tag: "div",
  cls: `ag-list-item ag-${e}-list-item`,
  attrs: { role: "option" },
  children: [
    {
      tag: "span",
      ref: "eText",
      children: t
    }
  ]
}), ake = class extends u1 {
  constructor(e, t, o) {
    super(lke(e, t)), this.label = t, this.value = o, this.eText = J;
  }
  postConstruct() {
    this.createTooltip(), this.addEventListeners();
  }
  setHighlighted(e) {
    const t = this.getGui();
    t.classList.toggle(rke, e), m2(t, e), this.dispatchLocalEvent({
      type: "itemHighlighted",
      highlighted: e
    });
  }
  getHeight() {
    return this.getGui().clientHeight;
  }
  setIndex(e, t) {
    const o = this.getGui();
    la(o, e), ra(o, t);
  }
  createTooltip() {
    const e = {
      getTooltipValue: () => this.label,
      getGui: () => this.getGui(),
      getLocation: () => "UNKNOWN",
      // only show tooltips for items where the text cannot be fully displayed
      shouldDisplayTooltip: () => _2(this.eText)
    }, t = this.createOptionalManagedBean(
      this.beans.registry.createDynamicBean(
        "highlightTooltipFeature",
        !1,
        e,
        this
      )
    );
    t && (this.tooltipFeature = t);
  }
  addEventListeners() {
    const e = this.getParentComponent();
    e && (this.addGuiEventListener("mouseover", () => {
      e.highlightItem(this);
    }), this.addGuiEventListener("mousedown", (t) => {
      t.preventDefault(), t.stopPropagation(), e.setValue(this.value);
    }));
  }
}, cke = class extends u1 {
  constructor(e = "default") {
    super({ tag: "div", cls: `ag-list ag-${e}-list` }), this.cssIdentifier = e, this.options = [], this.listItems = [], this.highlightedItem = null, this.registerCSS(ike);
  }
  postConstruct() {
    const e = this.getGui();
    this.addManagedElementListeners(e, { mouseleave: () => this.clearHighlighted() });
  }
  handleKeyDown(e) {
    const t = e.key;
    switch (t) {
      case D.ENTER:
        if (!this.highlightedItem)
          this.setValue(this.getValue());
        else {
          const o = this.listItems.indexOf(this.highlightedItem);
          this.setValueByIndex(o);
        }
        break;
      case D.DOWN:
      case D.UP:
        e.preventDefault(), this.navigate(t);
        break;
      case D.PAGE_DOWN:
      case D.PAGE_UP:
      case D.PAGE_HOME:
      case D.PAGE_END:
        e.preventDefault(), this.navigateToPage(t);
        break;
    }
  }
  addOptions(e) {
    return e.forEach((t) => this.addOption(t)), this;
  }
  addOption(e) {
    const { value: t, text: o } = e, n = o ?? t;
    return this.options.push({ value: t, text: n }), this.renderOption(t, n), this.updateIndices(), this;
  }
  clearOptions() {
    this.options = [], this.reset(!0), this.listItems.forEach((e) => {
      e.destroy();
    }), it(this.getGui()), this.listItems = [], this.refreshAriaRole();
  }
  setValue(e, t) {
    if (this.value === e)
      return this.fireItemSelected(), this;
    if (e == null)
      return this.reset(t), this;
    const o = this.options.findIndex((n) => n.value === e);
    if (o !== -1) {
      const n = this.options[o];
      this.value = n.value, this.displayValue = n.text, this.highlightItem(this.listItems[o]), t || this.fireChangeEvent();
    }
    return this;
  }
  setValueByIndex(e) {
    return this.setValue(this.options[e].value);
  }
  getValue() {
    return this.value;
  }
  getDisplayValue() {
    return this.displayValue;
  }
  refreshHighlighted() {
    this.clearHighlighted();
    const e = this.options.findIndex((t) => t.value === this.value);
    e !== -1 && this.highlightItem(this.listItems[e]);
  }
  highlightItem(e) {
    const t = e.getGui();
    if (!ro(t))
      return;
    this.clearHighlighted(), e.setHighlighted(!0), this.highlightedItem = e;
    const o = this.getGui(), { scrollTop: n, clientHeight: s } = o, { offsetTop: i, offsetHeight: r } = t;
    (i + r > n + s || i < n) && t.scrollIntoView({ block: "nearest" });
  }
  hideItemTooltip() {
    var e, t;
    (t = (e = this.highlightedItem) == null ? void 0 : e.tooltipFeature) == null || t.attemptToHideTooltip();
  }
  destroy() {
    this.hideItemTooltip(), super.destroy();
  }
  reset(e) {
    this.value = null, this.displayValue = null, this.clearHighlighted(), e || this.fireChangeEvent();
  }
  clearHighlighted() {
    var e;
    (e = this.highlightedItem) == null || e.setHighlighted(!1), this.highlightedItem = null;
  }
  renderOption(e, t) {
    const o = new ake(this.cssIdentifier, t, e);
    o.setParentComponent(this);
    const n = this.createManagedBean(o);
    this.listItems.push(n), this.getGui().appendChild(n.getGui());
  }
  navigate(e) {
    const t = e === D.DOWN;
    let o;
    const { listItems: n, highlightedItem: s } = this;
    if (!s)
      o = t ? n[0] : Ke(n);
    else {
      let r = n.indexOf(s) + (t ? 1 : -1);
      r = Math.min(Math.max(r, 0), n.length - 1), o = n[r];
    }
    this.highlightItem(o);
  }
  navigateToPage(e) {
    const { listItems: t, highlightedItem: o } = this;
    if (!o || t.length === 0)
      return;
    const n = t.indexOf(o), s = this.options.length - 1, i = t[0].getHeight(), r = Math.floor(this.getGui().clientHeight / i);
    let l = -1;
    e === D.PAGE_HOME ? l = 0 : e === D.PAGE_END ? l = s : e === D.PAGE_DOWN ? l = Math.min(n + r, s) : e === D.PAGE_UP && (l = Math.max(n - r, 0)), l !== -1 && this.highlightItem(t[l]);
  }
  refreshAriaRole() {
    no(this.getGui(), this.options.length === 0 ? "presentation" : "listbox");
  }
  updateIndices() {
    this.refreshAriaRole();
    const e = this.listItems, t = e.length;
    e.forEach((o, n) => {
      o.setIndex(n + 1, t);
    });
  }
  fireChangeEvent() {
    this.dispatchLocalEvent({ type: "fieldValueChanged" }), this.fireItemSelected();
  }
  fireItemSelected() {
    this.dispatchLocalEvent({ type: "selectedItem" });
  }
}, dke = (
  /*css*/
  ".ag-picker-field-display{flex:1 1 auto}.ag-picker-field{align-items:center;display:flex}.ag-picker-field-icon{border:0;cursor:pointer;display:flex;margin:0;padding:0}.ag-picker-field-wrapper{background-color:var(--ag-picker-button-background-color);border:var(--ag-picker-button-border);border-radius:5px;min-height:max(var(--ag-list-item-height),calc(var(--ag-spacing)*4));overflow:hidden;&:where(.ag-picker-has-focus),&:where(:focus-within){background-color:var(--ag-picker-button-focus-background-color);border:var(--ag-picker-button-focus-border);box-shadow:var(--ag-focus-shadow);&:where(.invalid){box-shadow:var(--ag-focus-error-shadow)}}&:where(.invalid){background-color:var(--ag-input-invalid-background-color);border:var(--ag-input-invalid-border);color:var(--ag-input-invalid-text-color)}&:disabled{opacity:.5}}"
), uke = {
  tag: "div",
  cls: "ag-picker-field",
  role: "presentation",
  children: [
    { tag: "div", ref: "eLabel" },
    {
      tag: "div",
      ref: "eWrapper",
      cls: "ag-wrapper ag-picker-field-wrapper ag-picker-collapsed",
      children: [
        { tag: "div", ref: "eDisplayField", cls: "ag-picker-field-display" },
        { tag: "div", ref: "eIcon", cls: "ag-picker-field-icon", attrs: { "aria-hidden": "true" } }
      ]
    }
  ]
}, ib = class extends nb {
  constructor(e) {
    if (super(e, (e == null ? void 0 : e.template) || uke, (e == null ? void 0 : e.agComponents) || [], e == null ? void 0 : e.className), this.isPickerDisplayed = !1, this.skipClick = !1, this.pickerGap = 4, this.hideCurrentPicker = null, this.eLabel = J, this.eWrapper = J, this.eDisplayField = J, this.eIcon = J, this.registerCSS(dke), this.ariaRole = e == null ? void 0 : e.ariaRole, this.onPickerFocusIn = this.onPickerFocusIn.bind(this), this.onPickerFocusOut = this.onPickerFocusOut.bind(this), !e)
      return;
    const { pickerGap: t, maxPickerHeight: o, variableWidth: n, minPickerWidth: s, maxPickerWidth: i } = e;
    t != null && (this.pickerGap = t), this.variableWidth = !!n, o != null && this.setPickerMaxHeight(o), s != null && this.setPickerMinWidth(s), i != null && this.setPickerMaxWidth(i);
  }
  postConstruct() {
    super.postConstruct(), this.setupAria();
    const e = `ag-${this.getCompId()}-display`;
    this.eDisplayField.setAttribute("id", e);
    const t = this.getAriaElement();
    this.addManagedElementListeners(t, { keydown: this.onKeyDown.bind(this) }), this.addManagedElementListeners(this.eLabel, { mousedown: this.onLabelOrWrapperMouseDown.bind(this) }), this.addManagedElementListeners(this.eWrapper, { mousedown: this.onLabelOrWrapperMouseDown.bind(this) });
    const { pickerIcon: o, inputWidth: n } = this.config;
    if (o) {
      const s = this.beans.iconSvc.createIconNoSpan(o);
      s && this.eIcon.appendChild(s);
    }
    n != null && this.setInputWidth(n);
  }
  setupAria() {
    const e = this.getAriaElement();
    e.setAttribute("tabindex", this.gos.get("tabIndex").toString()), Fo(e, !1), this.ariaRole && no(e, this.ariaRole);
  }
  onLabelOrWrapperMouseDown(e) {
    if (e) {
      const t = this.getFocusableElement();
      if (t !== this.eWrapper && (e == null ? void 0 : e.target) === t)
        return;
      e.preventDefault(), this.getFocusableElement().focus();
    }
    if (this.skipClick) {
      this.skipClick = !1;
      return;
    }
    this.isDisabled() || (this.isPickerDisplayed ? this.hidePicker() : this.showPicker());
  }
  onKeyDown(e) {
    switch (e.key) {
      case D.UP:
      case D.DOWN:
      case D.ENTER:
      case D.SPACE:
        e.preventDefault(), this.onLabelOrWrapperMouseDown();
        break;
      case D.ESCAPE:
        this.isPickerDisplayed && (e.preventDefault(), e.stopPropagation(), this.hideCurrentPicker && this.hideCurrentPicker());
        break;
    }
  }
  showPicker() {
    this.isPickerDisplayed = !0, this.pickerComponent || (this.pickerComponent = this.createPickerComponent());
    const e = this.pickerComponent.getGui();
    e.addEventListener("focusin", this.onPickerFocusIn), e.addEventListener("focusout", this.onPickerFocusOut), this.hideCurrentPicker = this.renderAndPositionPicker(), this.toggleExpandedStyles(!0);
  }
  renderAndPositionPicker() {
    const e = this.pickerComponent.getGui();
    this.gos.get("suppressScrollWhenPopupsAreOpen") || ([this.destroyMouseWheelFunc] = this.addManagedEventListeners({
      bodyScroll: () => {
        this.hidePicker();
      }
    }));
    const t = this.getLocaleTextFunc(), {
      config: { pickerAriaLabelKey: o, pickerAriaLabelValue: n, modalPicker: s = !0 },
      maxPickerHeight: i,
      minPickerWidth: r,
      maxPickerWidth: l,
      variableWidth: a,
      beans: c,
      eWrapper: d
    } = this, u = {
      modal: s,
      eChild: e,
      closeOnEsc: !0,
      closedCallback: () => {
        const m = Oi(c);
        this.beforeHidePicker(), m && this.isAlive() && this.getFocusableElement().focus();
      },
      ariaLabel: t(o, n),
      anchorToElement: d
    };
    e.style.position = "absolute";
    const h = c.popupSvc, p = h.addPopup(u);
    a ? (r && (e.style.minWidth = r), e.style.width = S2(Nr(d)), l && (e.style.maxWidth = l)) : bl(e, l ?? Nr(d));
    const C = i ?? `${ca(h.getPopupParent())}px`;
    return e.style.setProperty("max-height", C), this.alignPickerToComponent(), p.hideFunc;
  }
  alignPickerToComponent() {
    if (!this.pickerComponent)
      return;
    const {
      pickerGap: e,
      config: { pickerType: t },
      beans: { popupSvc: o, gos: n },
      eWrapper: s,
      pickerComponent: i
    } = this, r = n.get("enableRtl") ? "right" : "left";
    o.positionPopupByComponent({
      type: t,
      eventSource: s,
      ePopup: i.getGui(),
      position: "under",
      alignSide: r,
      keepWithinBounds: !0,
      nudgeY: e
    });
  }
  beforeHidePicker() {
    this.destroyMouseWheelFunc && (this.destroyMouseWheelFunc(), this.destroyMouseWheelFunc = void 0), this.toggleExpandedStyles(!1);
    const e = this.pickerComponent.getGui();
    e.removeEventListener("focusin", this.onPickerFocusIn), e.removeEventListener("focusout", this.onPickerFocusOut), this.isPickerDisplayed = !1, this.pickerComponent = void 0, this.hideCurrentPicker = null;
  }
  toggleExpandedStyles(e) {
    if (!this.isAlive())
      return;
    const t = this.getAriaElement();
    Fo(t, e);
    const o = this.eWrapper.classList;
    o.toggle("ag-picker-expanded", e), o.toggle("ag-picker-collapsed", !e);
  }
  onPickerFocusIn() {
    this.togglePickerHasFocus(!0);
  }
  onPickerFocusOut(e) {
    var t;
    (t = this.pickerComponent) != null && t.getGui().contains(e.relatedTarget) || this.togglePickerHasFocus(!1);
  }
  togglePickerHasFocus(e) {
    this.pickerComponent && this.eWrapper.classList.toggle("ag-picker-has-focus", e);
  }
  hidePicker() {
    this.hideCurrentPicker && (this.hideCurrentPicker(), this.dispatchLocalEvent({
      type: "pickerHidden"
    }));
  }
  setInputWidth(e) {
    return bl(this.eWrapper, e), this;
  }
  getFocusableElement() {
    return this.eWrapper;
  }
  setPickerGap(e) {
    return this.pickerGap = e, this;
  }
  setPickerMinWidth(e) {
    return typeof e == "number" && (e = `${e}px`), this.minPickerWidth = e ?? void 0, this;
  }
  setPickerMaxWidth(e) {
    return typeof e == "number" && (e = `${e}px`), this.maxPickerWidth = e ?? void 0, this;
  }
  setPickerMaxHeight(e) {
    return typeof e == "number" && (e = `${e}px`), this.maxPickerHeight = e ?? void 0, this;
  }
  destroy() {
    this.hidePicker(), super.destroy();
  }
}, hke = (
  /*css*/
  ".ag-select{align-items:center;display:flex;&.ag-disabled{opacity:.5}}:where(.ag-select){.ag-picker-field-wrapper{cursor:default}&.ag-disabled .ag-picker-field-wrapper:focus{box-shadow:none}&:not(.ag-cell-editor,.ag-label-align-top){min-height:var(--ag-list-item-height)}.ag-picker-field-display{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ag-picker-field-icon{align-items:center;display:flex}}:where(.ag-ltr) :where(.ag-select){.ag-picker-field-wrapper{padding-left:calc(var(--ag-cell-horizontal-padding)/2);padding-right:var(--ag-spacing)}}:where(.ag-rtl) :where(.ag-select){.ag-picker-field-wrapper{padding-left:var(--ag-spacing);padding-right:calc(var(--ag-cell-horizontal-padding)/2)}}.ag-select-list{background-color:var(--ag-picker-list-background-color);border:var(--ag-picker-list-border);border-radius:var(--ag-border-radius);box-shadow:var(--ag-dropdown-shadow);overflow:hidden auto}.ag-select-list-item{cursor:default;-webkit-user-select:none;-moz-user-select:none;user-select:none;:where(span){overflow:hidden;text-overflow:ellipsis;white-space:nowrap}}:where(.ag-ltr) .ag-select-list-item{padding-left:calc(var(--ag-cell-horizontal-padding)/2)}:where(.ag-rtl) .ag-select-list-item{padding-right:calc(var(--ag-cell-horizontal-padding)/2)}"
), V2 = class extends ib {
  constructor(e) {
    super({
      pickerAriaLabelKey: "ariaLabelSelectField",
      pickerAriaLabelValue: "Select Field",
      pickerType: "ag-list",
      className: "ag-select",
      pickerIcon: "selectOpen",
      ariaRole: "combobox",
      ...e
    }), this.registerCSS(hke);
  }
  postConstruct() {
    this.tooltipFeature = this.createOptionalManagedBean(
      this.beans.registry.createDynamicBean(
        "tooltipFeature",
        !1,
        {
          shouldDisplayTooltip: Hs(() => this.eDisplayField),
          getGui: () => this.getGui()
        }
      )
    ), super.postConstruct(), this.createListComponent(), this.eWrapper.tabIndex = this.gos.get("tabIndex");
    const { options: e, value: t, placeholder: o } = this.config;
    e != null && this.addOptions(e), t != null && this.setValue(t, !0), o && t == null && (this.eDisplayField.textContent = o), this.addManagedElementListeners(this.eWrapper, { focusout: this.onWrapperFocusOut.bind(this) });
  }
  onWrapperFocusOut(e) {
    this.eWrapper.contains(e.relatedTarget) || this.hidePicker();
  }
  createListComponent() {
    const e = this.createBean(
      new cke("select")
    );
    this.listComponent = e, e.setParentComponent(this);
    const t = e.getAriaElement(), o = `ag-select-list-${e.getCompId()}`;
    t.setAttribute("id", o), C2(this.getAriaElement(), t), e.addManagedElementListeners(e.getGui(), {
      mousedown: (n) => {
        n == null || n.preventDefault();
      }
    }), e.addManagedListeners(e, {
      selectedItem: () => {
        this.hidePicker(), this.dispatchLocalEvent({ type: "selectedItem" });
      },
      fieldValueChanged: () => {
        this.listComponent && (this.setValue(this.listComponent.getValue(), !1, !0), this.hidePicker());
      }
    });
  }
  createPickerComponent() {
    return this.listComponent;
  }
  beforeHidePicker() {
    var e;
    (e = this.listComponent) == null || e.hideItemTooltip(), super.beforeHidePicker();
  }
  onKeyDown(e) {
    var o;
    const { key: t } = e;
    switch (t === D.TAB && this.hidePicker(), t) {
      case D.ENTER:
      case D.UP:
      case D.DOWN:
      case D.PAGE_UP:
      case D.PAGE_DOWN:
      case D.PAGE_HOME:
      case D.PAGE_END:
        e.preventDefault(), this.isPickerDisplayed ? (o = this.listComponent) == null || o.handleKeyDown(e) : super.onKeyDown(e);
        break;
      case D.ESCAPE:
        super.onKeyDown(e);
        break;
      case D.SPACE:
        this.isPickerDisplayed ? e.preventDefault() : super.onKeyDown(e);
        break;
    }
  }
  showPicker() {
    const e = this.listComponent;
    e && (super.showPicker(), e.refreshHighlighted());
  }
  addOptions(e) {
    return e.forEach((t) => this.addOption(t)), this;
  }
  addOption(e) {
    return this.listComponent.addOption(e), this;
  }
  clearOptions() {
    var e;
    return (e = this.listComponent) == null || e.clearOptions(), this.setValue(void 0, !0), this;
  }
  setValue(e, t, o) {
    const {
      listComponent: n,
      config: { placeholder: s },
      eDisplayField: i,
      tooltipFeature: r
    } = this;
    if (this.value === e || !n)
      return this;
    if (o || n.setValue(e, !0), n.getValue() === this.getValue())
      return this;
    let a = n.getDisplayValue();
    return a == null && s && (a = s), i.textContent = a, r == null || r.setTooltipAndRefresh(a ?? null), super.setValue(e, t);
  }
  destroy() {
    this.listComponent = this.destroyBean(this.listComponent), super.destroy();
  }
}, gke = {
  selector: "AG-SELECT",
  component: V2
}, pke = (
  /*css*/
  ':where(.ag-root-wrapper,.ag-external,.ag-popup,.ag-dnd-ghost,.ag-chart),:where(.ag-root-wrapper,.ag-external,.ag-popup,.ag-dnd-ghost,.ag-chart) :where([class^=ag-]){box-sizing:border-box;&:after,&:before{box-sizing:border-box}&:where(div,span,label):focus-visible{box-shadow:inset var(--ag-focus-shadow);outline:none;&:where(.invalid){box-shadow:inset var(--ag-focus-error-shadow)}}&:where(button){color:inherit}}:where(.ag-root-wrapper,ag-external,.ag-popup,.ag-dnd-ghost,.ag-chart) :where([class^=ag-]) ::-ms-clear{display:none}.ag-hidden{display:none!important}.ag-invisible{visibility:hidden!important}.ag-popup-child{top:0;z-index:5;&:where(:not(.ag-tooltip-custom)){box-shadow:var(--ag-popup-shadow)}}.ag-input-wrapper,.ag-picker-field-wrapper{align-items:center;display:flex;flex:1 1 auto;line-height:normal;position:relative}.ag-input-field{align-items:center;display:flex;flex-direction:row}.ag-input-field-input:where(:not([type=checkbox],[type=radio])){flex:1 1 auto;min-width:0;width:100%}.ag-chart,.ag-dnd-ghost,.ag-external,.ag-popup,.ag-root-wrapper{cursor:default;line-height:normal;white-space:normal;-webkit-font-smoothing:antialiased;background-color:var(--ag-background-color);color:var(--ag-text-color);color-scheme:var(--ag-browser-color-scheme);font-family:var(--ag-font-family);font-size:var(--ag-font-size);--ag-indentation-level:0}:where(.ag-icon):before{align-items:center;background-color:currentcolor;color:inherit;content:"";display:flex;font-family:inherit;font-size:var(--ag-icon-size);font-style:normal;font-variant:normal;height:var(--ag-icon-size);justify-content:center;line-height:var(--ag-icon-size);-webkit-mask-size:contain;mask-size:contain;text-transform:none;width:var(--ag-icon-size)}.ag-icon{background-position:50%;background-repeat:no-repeat;background-size:contain;color:var(--ag-icon-color);display:block;height:var(--ag-icon-size);position:relative;-webkit-user-select:none;-moz-user-select:none;user-select:none;width:var(--ag-icon-size)}.ag-disabled,[disabled]{.ag-icon{opacity:.5}&.ag-icon-grip{opacity:.35}}.ag-resizer{pointer-events:none;position:absolute;-webkit-user-select:none;-moz-user-select:none;user-select:none;z-index:1}:where(.ag-resizer){&.ag-resizer-topLeft{cursor:nwse-resize;height:5px;left:0;top:0;width:5px}&.ag-resizer-top{cursor:ns-resize;height:5px;left:5px;right:5px;top:0}&.ag-resizer-topRight{cursor:nesw-resize;height:5px;right:0;top:0;width:5px}&.ag-resizer-right{bottom:5px;cursor:ew-resize;right:0;top:5px;width:5px}&.ag-resizer-bottomRight{bottom:0;cursor:nwse-resize;height:5px;right:0;width:5px}&.ag-resizer-bottom{bottom:0;cursor:ns-resize;height:5px;left:5px;right:5px}&.ag-resizer-bottomLeft{bottom:0;cursor:nesw-resize;height:5px;left:0;width:5px}&.ag-resizer-left{bottom:5px;cursor:ew-resize;left:0;top:5px;width:5px}}'
), a7, c7, O2 = typeof window != "object" || !((c7 = (a7 = window == null ? void 0 : window.document) == null ? void 0 : a7.fonts) != null && c7.forEach), ji = (e, t, o, n, s, i) => {
  if (O2)
    return;
  n && (e = `@layer ${CSS.escape(n)} { ${e} }`);
  let r = Pi.map.get(t);
  if (r || (r = [], Pi.map.set(t, r)), r.find((d) => d.css === e))
    return;
  const l = document.createElement("style");
  i && l.setAttribute("nonce", i), l.dataset.agGlobalCss = o, l.textContent = e;
  const a = { css: e, el: l, priority: s };
  let c;
  for (const d of r) {
    if (d.priority > s)
      break;
    c = d;
  }
  if (c) {
    c.el.insertAdjacentElement("afterend", l);
    const d = r.indexOf(c);
    r.splice(d + 1, 0, a);
  } else
    t.insertBefore(l, t.querySelector(":not(title, meta)")), r.push(a);
}, rb = (e, t, o, n) => {
  ji(pke, e, "shared", t, 0, o), n == null || n.forEach(
    (s, i) => s.forEach((r) => ji(r, e, i, t, 0, o))
  );
}, fke = (e) => {
  Pi.grids.add(e);
}, vke = (e) => {
  if (Pi.grids.delete(e), Pi.grids.size === 0) {
    Pi.map = /* @__PURE__ */ new WeakMap();
    for (const t of document.head.querySelectorAll("style[data-ag-global-css]"))
      t.remove();
  }
}, Td, Pi = (Td = typeof window == "object" ? window : {}).agStyleInjectionState ?? (Td.agStyleInjectionState = {
  map: /* @__PURE__ */ new WeakMap(),
  grids: /* @__PURE__ */ new Set()
}), To = (e) => new lb(e), Qn = "$default", mke = 0, lb = class {
  constructor({ feature: e, params: t, modeParams: o = {}, css: n, cssImports: s }) {
    this.feature = e, this.css = n, this.cssImports = s, this.modeParams = {
      // NOTE: it's important that default is defined first, putting it
      // first in iteration order, because when merging params the default
      // params override any prior modal params, so modal params in this
      // part need to come after default params to prevent them from being
      // immediately overridden.
      [Qn]: {
        ...o[Qn] ?? {},
        ...t ?? {}
      },
      ...o
    };
  }
  use(e, t, o) {
    let n = this._inject;
    if (n == null) {
      let { css: s } = this;
      if (s) {
        const i = `ag-theme-${this.feature ?? "part"}-${++mke}`;
        typeof s == "function" && (s = s()), s = `:where(.${i}) {
${s}
}
`;
        for (const r of this.cssImports ?? [])
          s = `@import url(${JSON.stringify(r)});
${s}`;
        n = { css: s, class: i };
      } else
        n = !1;
      this._inject = n;
    }
    return n && e && ji(n.css, e, n.class, t, 1, o), n ? n.class : !1;
  }
}, Cke = (e) => e.replace(/[A-Z]/g, (t) => `-${t}`).toLowerCase(), ab = (e) => `--ag-${Cke(e)}`, gn = (e) => `var(${ab(e)})`, wke = (e, t, o) => Math.max(t, Math.min(o, e)), bke = (e) => {
  const t = /* @__PURE__ */ new Map();
  return (o) => {
    const n = o;
    return t.has(n) || t.set(n, e(o)), t.get(n);
  };
}, Qo = (e) => ({ ref: "accentColor", mix: e }), xo = (e) => ({ ref: "foregroundColor", mix: e }), Lo = (e) => ({
  ref: "foregroundColor",
  mix: e,
  onto: "backgroundColor"
}), yke = (e) => ({
  ref: "foregroundColor",
  mix: e,
  onto: "headerBackgroundColor"
}), po = { ref: "backgroundColor" }, wi = { ref: "foregroundColor" }, Sn = { ref: "accentColor" }, Pl = {
  backgroundColor: "#fff",
  foregroundColor: "#181d1f",
  borderColor: xo(0.15),
  chromeBackgroundColor: Lo(0.02),
  browserColorScheme: "light"
}, _ke = {
  ...Pl,
  textColor: wi,
  accentColor: "#2196f3",
  invalidColor: "#e02525",
  fontFamily: [
    "-apple-system",
    "BlinkMacSystemFont",
    "Segoe UI",
    "Roboto",
    "Oxygen-Sans",
    "Ubuntu",
    "Cantarell",
    "Helvetica Neue",
    "sans-serif"
  ],
  subtleTextColor: {
    ref: "textColor",
    mix: 0.5
  },
  borderWidth: 1,
  borderRadius: 4,
  spacing: 8,
  fontSize: 14,
  focusShadow: {
    spread: 3,
    color: Qo(0.5)
  },
  focusErrorShadow: {
    spread: 3,
    color: {
      ref: "invalidColor",
      onto: "backgroundColor",
      mix: 0.5
    }
  },
  popupShadow: "0 0 16px #00000026",
  cardShadow: "0 1px 4px 1px #00000018",
  dropdownShadow: { ref: "cardShadow" },
  listItemHeight: {
    calc: "max(iconSize, dataFontSize) + widgetVerticalSpacing"
  },
  dragAndDropImageBackgroundColor: po,
  dragAndDropImageBorder: !0,
  dragAndDropImageNotAllowedBorder: {
    color: {
      ref: "invalidColor",
      onto: "dragAndDropImageBackgroundColor",
      mix: 0.5
    }
  },
  dragAndDropImageShadow: {
    ref: "popupShadow"
  },
  iconSize: 16,
  iconColor: "inherit",
  toggleButtonWidth: 28,
  toggleButtonHeight: 18,
  toggleButtonOnBackgroundColor: Sn,
  toggleButtonOffBackgroundColor: Lo(0.3),
  toggleButtonSwitchBackgroundColor: po,
  toggleButtonSwitchInset: 2,
  tooltipBackgroundColor: {
    ref: "chromeBackgroundColor"
  },
  tooltipErrorBackgroundColor: {
    ref: "invalidColor",
    onto: "backgroundColor",
    mix: 0.1
  },
  tooltipTextColor: {
    ref: "textColor"
  },
  tooltipErrorTextColor: {
    ref: "invalidColor"
  },
  tooltipBorder: !0,
  tooltipErrorBorder: {
    color: {
      ref: "invalidColor",
      onto: "backgroundColor",
      mix: 0.25
    }
  }
}, Ske = [
  "colorScheme",
  "color",
  "length",
  "scale",
  "borderStyle",
  "border",
  "shadow",
  "image",
  "fontFamily",
  "fontWeight",
  "duration"
], xke = bke((e) => (e = e.toLowerCase(), Ske.find((t) => e.endsWith(t.toLowerCase())) ?? "length")), ma = (e) => typeof e == "object" && (e != null && e.ref) ? gn(e.ref) : typeof e == "string" ? e : typeof e == "number" ? String(e) : !1, B2 = (e) => {
  if (typeof e == "string")
    return e;
  if (e && "ref" in e) {
    const t = gn(e.ref);
    return e.mix == null ? t : `color-mix(in srgb, ${e.onto ? gn(e.onto) : "transparent"}, ${t} ${wke(e.mix * 100, 0, 100)}%)`;
  }
  return !1;
}, Mke = ma, bi = (e) => typeof e == "string" ? e : typeof e == "number" ? `${e}px` : e && "calc" in e ? `calc(${e.calc.replace(/ ?[*/+] ?/g, " $& ").replace(/-?\b[a-z][a-z0-9]*\b(?![-(])/gi, (o) => o[0] === "-" ? o : ` ${gn(o)} `)})` : e && "ref" in e ? gn(e.ref) : !1, Ake = ma, r5 = (e, t) => typeof e == "string" ? e : e === !0 ? r5({}, t) : e === !1 ? t === "columnBorder" ? r5({ color: "transparent" }, t) : "none" : e && "ref" in e ? gn(e.ref) : cb(e.style ?? "solid") + " " + bi(e.width ?? { ref: "borderWidth" }) + " " + B2(e.color ?? { ref: "borderColor" }), Lke = (e) => typeof e == "string" ? e : e === !1 ? "none" : e && "ref" in e ? gn(e.ref) : [
  bi(e.offsetX ?? 0),
  bi(e.offsetY ?? 0),
  bi(e.radius ?? 0),
  bi(e.spread ?? 0),
  B2(e.color ?? { ref: "foregroundColor" })
].join(" "), cb = ma, db = (e) => typeof e == "string" ? e.includes(",") ? e : Id(e) : e && "googleFont" in e ? db(e.googleFont) : e && "ref" in e ? gn(e.ref) : Array.isArray(e) ? e.map((t) => (typeof t == "object" && "googleFont" in t && (t = t.googleFont), Id(t))).join(", ") : !1, Id = (e) => (
  // don't quote var() expressions or quote safe identifier names, so that
  // people can specify fonts like sans-serif which are keywords not strings,
  // or var(--my-var)
  /^[\w-]+$|\w\(/.test(e) ? e : JSON.stringify(e)
), Eke = ma, $2 = (e) => typeof e == "string" ? e : e && "url" in e ? `url(${JSON.stringify(e.url)})` : e && "svg" in e ? $2({ url: `data:image/svg+xml,${encodeURIComponent(e.svg)}` }) : e && "ref" in e ? gn(e.ref) : !1, Pke = (e, t, o) => typeof e == "string" ? e : typeof e == "number" ? (e >= 10 && o.warn(104, { value: e, param: t }), `${e}s`) : e && "ref" in e ? gn(e.ref) : !1, Rke = {
  color: B2,
  colorScheme: Mke,
  length: bi,
  scale: Ake,
  border: r5,
  borderStyle: cb,
  shadow: Lke,
  image: $2,
  fontFamily: db,
  fontWeight: Eke,
  duration: Pke
}, Fke = (e, t, o) => {
  const n = xke(e);
  return Rke[n](t, e, o);
}, Tke = (e) => new ub(e), ub = class hb {
  constructor(t, o = []) {
    this.themeLogger = t, this.parts = o;
  }
  withPart(t) {
    return typeof t == "function" && (t = t()), t instanceof lb ? new hb(this.themeLogger, [...this.parts, t]) : (this.themeLogger.preInitErr(259, "Invalid part", { part: t }), this);
  }
  withoutPart(t) {
    return this.withPart(To({ feature: t }));
  }
  withParams(t, o = Qn) {
    return this.withPart(
      To({
        modeParams: { [o]: t }
      })
    );
  }
  /**
   * Called by a grid instance when it starts using the theme. This installs
   * the theme's parts into document head, or the shadow DOM if the provided
   * container is within a shadow root.
   */
  _startUse({ styleContainer: t, cssLayer: o, nonce: n, loadThemeGoogleFonts: s, moduleCss: i }) {
    if (O2)
      return;
    Dke(), rb(t, o, n, i);
    const r = Ike(this);
    if (r.length > 0)
      for (const l of r)
        s && Hke(l, n);
    for (const l of this.parts)
      l.use(t, o, n);
  }
  /**
   * Return CSS that that applies the params of this theme to elements with
   * the provided class name
   */
  _getCssClass() {
    return this._cssClassCache ?? (this._cssClassCache = Dd(this.parts).map((t) => t.use(void 0, void 0, void 0)).filter(Boolean).join(" "));
  }
  _getModeParams() {
    let t = this._paramsCache;
    if (!t) {
      const o = {
        // NOTE: defining the default mode here is important, it ensures
        // that the default mode is first in iteration order, which puts
        // it first in outputted CSS, allowing other modes to override it
        [Qn]: { ..._ke }
      };
      for (const n of Dd(this.parts))
        for (const s of Object.keys(n.modeParams)) {
          const i = n.modeParams[s];
          if (i) {
            const r = o[s] ?? (o[s] = {}), l = /* @__PURE__ */ new Set();
            for (const a of Object.keys(i)) {
              const c = i[a];
              c !== void 0 && (r[a] = c, l.add(a));
            }
            if (s === Qn)
              for (const a of Object.keys(o)) {
                const c = o[a];
                if (a !== Qn)
                  for (const d of l)
                    delete c[d];
              }
          }
        }
      this._paramsCache = t = o;
    }
    return t;
  }
  /**
   * Return the CSS chunk that is inserted into the grid DOM, and will
   * therefore be removed automatically when the grid is destroyed or it
   * starts to use a new theme.
   *
   * @param className a unique class name on the grid wrapper used to scope the returned CSS to the grid instance
   */
  _getPerInstanceCss(t) {
    const o = "##SELECTOR##";
    let n = this._paramsCssCache;
    if (!n) {
      let s = "", i = "";
      const r = this._getModeParams();
      for (const a of Object.keys(r)) {
        const c = r[a];
        if (a !== Qn) {
          const u = `:where([data-ag-theme-mode="${typeof CSS == "object" ? CSS.escape(a) : a}"]) & {
`;
          s += u, i += u;
        }
        for (const d of Object.keys(c).sort()) {
          const u = c[d], h = Fke(d, u, this.themeLogger);
          if (h === !1)
            this.themeLogger.error(107, { key: d, value: u });
          else {
            const p = ab(d), C = p.replace("--ag-", "--ag-inherited-");
            s += `	${p}: var(${C}, ${h});
`, i += `	${C}: var(${p});
`;
          }
        }
        a !== Qn && (s += `}
`, i += `}
`);
      }
      let l = `${o} {
${s}}
`;
      l += `:has(> ${o}):not(${o}) {
${i}}
`, this._paramsCssCache = n = l;
    }
    return n.replaceAll(o, `:where(.${t})`);
  }
}, Dd = (e) => {
  const t = /* @__PURE__ */ new Map();
  for (const n of e)
    t.set(n.feature, n);
  const o = [];
  for (const n of e)
    (!n.feature || t.get(n.feature) === n) && o.push(n);
  return o;
}, Ike = (e) => {
  const t = /* @__PURE__ */ new Set(), o = (i) => {
    if (Array.isArray(i))
      i.forEach(o);
    else {
      const r = i == null ? void 0 : i.googleFont;
      typeof r == "string" && t.add(r);
    }
  };
  return Object.values(e._getModeParams()).flatMap((i) => Object.values(i)).forEach(o), Array.from(t).sort();
}, kd = !1, Dke = () => {
  if (!kd) {
    kd = !0;
    for (const e of Array.from(document.head.querySelectorAll('style[data-ag-scope="legacy"]')))
      e.remove();
  }
}, kke = /* @__PURE__ */ new Set(), Hke = async (e, t) => {
  kke.add(e);
  const o = `@import url('https://${Vke}/css2?family=${encodeURIComponent(e)}:wght@100;200;300;400;500;600;700;800;900&display=swap');
`;
  ji(o, document.head, `googleFont:${e}`, void 0, 0, t);
}, Vke = "fonts.googleapis.com", Oke = 1, Bke = class {
  constructor(e) {
    this.beans = {}, this.createdBeans = [], this.destroyed = !1, this.instanceId = Oke++, !(!e || !e.beanClasses) && (this.beanDestroyComparator = e.beanDestroyComparator, this.init(e));
  }
  init(e) {
    var t;
    this.id = e.id, this.beans.context = this, this.destroyCallback = e.destroyCallback;
    for (const o of Object.keys(e.providedBeanInstances))
      this.beans[o] = e.providedBeanInstances[o];
    e.beanClasses.forEach((o) => {
      const n = new o();
      n.beanName ? this.beans[n.beanName] = n : console.error(`Bean ${o.name} is missing beanName`), this.createdBeans.push(n);
    }), (t = e.derivedBeans) == null || t.forEach((o) => {
      const { beanName: n, bean: s } = o(this);
      this.beans[n] = s, this.createdBeans.push(s);
    }), e.beanInitComparator && this.createdBeans.sort(e.beanInitComparator), this.initBeans(this.createdBeans);
  }
  getBeanInstances() {
    return Object.values(this.beans);
  }
  createBean(e, t) {
    return this.initBeans([e], t), e;
  }
  initBeans(e, t) {
    const o = this.beans;
    e.forEach((n) => {
      var s, i;
      (s = n.preWireBeans) == null || s.call(n, o), (i = n.wireBeans) == null || i.call(n, o);
    }), e.forEach((n) => {
      var s;
      return (s = n.preConstruct) == null ? void 0 : s.call(n);
    }), t && e.forEach(t), e.forEach((n) => {
      var s;
      return (s = n.postConstruct) == null ? void 0 : s.call(n);
    });
  }
  getBeans() {
    return this.beans;
  }
  getBean(e) {
    return this.beans[e];
  }
  getId() {
    return this.id;
  }
  destroy() {
    var t;
    if (this.destroyed)
      return;
    this.destroyed = !0;
    const e = this.getBeanInstances();
    this.beanDestroyComparator && e.sort(this.beanDestroyComparator), this.destroyBeans(e), this.beans = {}, this.createdBeans = [], (t = this.destroyCallback) == null || t.call(this);
  }
  /**
   * Destroys a bean and returns undefined to support destruction and clean up in a single line.
   * this.dateComp = this.context.destroyBean(this.dateComp);
   */
  destroyBean(e) {
    var t;
    (t = e == null ? void 0 : e.destroy) == null || t.call(e);
  }
  /**
   * Destroys an array of beans and returns an empty array to support destruction and clean up in a single line.
   * this.dateComps = this.context.destroyBeans(this.dateComps);
   */
  destroyBeans(e) {
    if (e)
      for (let t = 0; t < e.length; t++)
        this.destroyBean(e[t]);
    return [];
  }
  isDestroyed() {
    return this.destroyed;
  }
}, $ke = 0, Zke = class extends Cn {
  constructor() {
    super(...arguments), this.beanName = "environment", this.paramsClass = `ag-theme-params-${++$ke}`, this.globalCSS = [];
  }
  wireBeans(e) {
    this.eRootDiv = e.eRootDiv;
  }
  postConstruct() {
    const { gos: e, eRootDiv: t } = this;
    e.setInstanceDomData(t), this.eStyleContainer = e.get("themeStyleContainer") ?? (t.getRootNode() === document ? document.head : t), this.cssLayer = e.get("themeCssLayer"), this.styleNonce = e.get("styleNonce"), this.addManagedPropertyListener("theme", () => this.handleThemeChange()), this.handleThemeChange(), this.initVariables(), this.addDestroyFunc(() => vke(this)), this.mutationObserver = new MutationObserver(() => {
      this.fireStylesChangedEvent("themeChanged");
    }), this.addDestroyFunc(() => this.mutationObserver.disconnect());
  }
  applyThemeClasses(e, t = []) {
    const { theme: o } = this;
    let n;
    o ? n = `${this.paramsClass} ${o._getCssClass()}` : n = this.applyLegacyThemeClasses();
    for (const s of Array.from(e.classList))
      s.startsWith("ag-theme-") && e.classList.remove(s);
    if (n) {
      const s = e.className;
      e.className = `${s}${s ? " " : ""}${n}${t != null && t.length ? ` ${t.join(" ")}` : ""}`;
    }
  }
  applyLegacyThemeClasses() {
    let e = "";
    this.mutationObserver.disconnect();
    let t = this.eRootDiv;
    for (; t; ) {
      let o = !1;
      for (const n of Array.from(t.classList))
        n.startsWith("ag-theme-") && (o = !0, e = e ? `${e} ${n}` : n);
      o && this.mutationObserver.observe(t, {
        attributes: !0,
        attributeFilter: ["class"]
      }), t = t.parentElement;
    }
    return e;
  }
  addGlobalCSS(e, t) {
    this.theme ? ji(e, this.eStyleContainer, t, this.cssLayer, 0, this.styleNonce) : this.globalCSS.push([e, t]);
  }
  handleThemeChange() {
    const { gos: e, theme: t } = this, o = e.get("theme");
    let n;
    if (o === "legacy")
      n = void 0;
    else {
      const s = o ?? this.getDefaultTheme();
      s instanceof ub ? n = s : this.themeError(s);
    }
    n !== t && this.handleNewTheme(n), this.postProcessThemeChange(n, o);
  }
  handleNewTheme(e) {
    const { gos: t, eRootDiv: o, globalCSS: n } = this, s = this.getAdditionalCss();
    if (e) {
      fke(this), rb(this.eStyleContainer, this.cssLayer, this.styleNonce, s);
      for (const [r, l] of n)
        ji(r, this.eStyleContainer, l, this.cssLayer, 0, this.styleNonce);
      n.length = 0;
    }
    this.theme = e, e == null || e._startUse({
      loadThemeGoogleFonts: t.get("loadThemeGoogleFonts"),
      styleContainer: this.eStyleContainer,
      cssLayer: this.cssLayer,
      nonce: this.styleNonce,
      moduleCss: s
    });
    let i = this.eParamsStyle;
    if (!i) {
      i = this.eParamsStyle = c1({ tag: "style" });
      const r = t.get("styleNonce");
      r && i.setAttribute("nonce", r), o.appendChild(i);
    }
    O2 || (i.textContent = (e == null ? void 0 : e._getPerInstanceCss(this.paramsClass)) || ""), this.applyThemeClasses(o), this.fireStylesChangedEvent("themeChanged");
  }
}, Gke = class extends Cn {
  constructor() {
    super(...arguments), this.beanName = "registry";
  }
  registerDynamicBeans(e) {
    if (e) {
      this.dynamicBeans ?? (this.dynamicBeans = {});
      for (const t of Object.keys(e))
        this.dynamicBeans[t] = e[t];
    }
  }
  createDynamicBean(e, t, ...o) {
    if (!this.dynamicBeans)
      throw new Error(this.getDynamicError(e, !0));
    const n = this.dynamicBeans[e];
    if (n == null) {
      if (t)
        throw new Error(this.getDynamicError(e, !1));
      return;
    }
    return new n(...o);
  }
}, Nke = class extends Cn {
  constructor() {
    super(...arguments), this.beanName = "eventSvc", this.eventServiceType = "global", this.globalSvc = new ls();
  }
  addListener(e, t, o) {
    this.globalSvc.addEventListener(e, t, o);
  }
  removeListener(e, t, o) {
    this.globalSvc.removeEventListener(e, t, o);
  }
  addGlobalListener(e, t = !1) {
    this.globalSvc.addGlobalListener(e, t);
  }
  removeGlobalListener(e, t = !1) {
    this.globalSvc.removeGlobalListener(e, t);
  }
  dispatchEvent(e) {
    this.globalSvc.dispatchEvent(this.gos.addCommon(e));
  }
  dispatchEventOnce(e) {
    this.globalSvc.dispatchEventOnce(this.gos.addCommon(e));
  }
}, gb = class extends Cn {
  constructor(e, t) {
    super(), this.ctrl = e, t && (this.beans = t);
  }
  postConstruct() {
    this.refreshTooltip();
  }
  /**
   *
   * @param tooltip The tooltip value
   * @param allowEmptyString Set it to true to allow the title to be set to `''`. This is necessary
   * when the browser adds a default tooltip the element and the tooltip service will be displayed
   * next to a browser tooltip causing confusion.
   */
  setBrowserTooltip(e, t) {
    const o = "title", n = this.ctrl.getGui();
    n && (e != null && (e != "" || t) ? n.setAttribute(o, e) : n.removeAttribute(o));
  }
  updateTooltipText() {
    const { getTooltipValue: e } = this.ctrl;
    e && (this.tooltip = e());
  }
  createTooltipFeatureIfNeeded() {
    if (this.tooltipManager == null) {
      const e = this.beans.registry.createDynamicBean("tooltipStateManager", !0, this.ctrl, () => this.tooltip);
      e && (this.tooltipManager = this.createBean(e, this.beans.context));
    }
  }
  attemptToShowTooltip() {
    var e;
    (e = this.tooltipManager) == null || e.prepareToShowTooltip();
  }
  attemptToHideTooltip() {
    var e;
    (e = this.tooltipManager) == null || e.hideTooltip();
  }
  setTooltipAndRefresh(e) {
    this.tooltip = e, this.refreshTooltip();
  }
  refreshTooltip(e) {
    this.browserTooltips = this.beans.gos.get("enableBrowserTooltips"), this.updateTooltipText(), this.browserTooltips ? (this.setBrowserTooltip(this.tooltip), this.tooltipManager = this.destroyBean(this.tooltipManager, this.beans.context)) : (this.setBrowserTooltip(e ? "" : null, e), this.createTooltipFeatureIfNeeded());
  }
  destroy() {
    this.tooltipManager = this.destroyBean(this.tooltipManager, this.beans.context), super.destroy();
  }
}, zke = 1e3, jke = 1e3, Hd = 100, Vd, A1 = !1, Wke = class extends Cn {
  constructor(e, t) {
    super(), this.tooltipCtrl = e, this.getTooltipValue = t, this.interactionEnabled = !1, this.isInteractingWithTooltip = !1, this.state = 0, this.tooltipInstanceCount = 0, this.tooltipMouseTrack = !1;
  }
  wireBeans(e) {
    this.popupSvc = e.popupSvc;
  }
  postConstruct() {
    this.gos.get("tooltipInteraction") && (this.interactionEnabled = !0), this.tooltipTrigger = this.getTooltipTrigger(), this.tooltipMouseTrack = this.gos.get("tooltipMouseTrack");
    const e = this.tooltipCtrl.getGui();
    this.tooltipTrigger === 0 && this.addManagedListeners(e, {
      mouseenter: this.onMouseEnter.bind(this),
      mouseleave: this.onMouseLeave.bind(this)
    }), this.tooltipTrigger === 1 && this.addManagedListeners(e, {
      focusin: this.onFocusIn.bind(this),
      focusout: this.onFocusOut.bind(this)
    }), this.addManagedListeners(e, { mousemove: this.onMouseMove.bind(this) }), this.interactionEnabled || this.addManagedListeners(e, {
      mousedown: this.onMouseDown.bind(this),
      keydown: this.onKeyDown.bind(this)
    });
  }
  getGridOptionsTooltipDelay(e) {
    const t = this.gos.get(e);
    return Math.max(200, t);
  }
  getTooltipDelay(e) {
    var t, o, n, s;
    return e === "show" ? ((o = (t = this.tooltipCtrl).getTooltipShowDelayOverride) == null ? void 0 : o.call(t)) ?? this.getGridOptionsTooltipDelay("tooltipShowDelay") : ((s = (n = this.tooltipCtrl).getTooltipHideDelayOverride) == null ? void 0 : s.call(n)) ?? this.getGridOptionsTooltipDelay("tooltipHideDelay");
  }
  destroy() {
    this.setToDoNothing(), super.destroy();
  }
  getTooltipTrigger() {
    const e = this.gos.get("tooltipTrigger");
    return !e || e === "hover" ? 0 : 1;
  }
  onMouseEnter(e) {
    this.interactionEnabled && this.interactiveTooltipTimeoutId && (this.unlockService(), this.startHideTimeout()), !ss() && (A1 ? this.showTooltipTimeoutId = window.setTimeout(() => {
      this.prepareToShowTooltip(e);
    }, Hd) : this.prepareToShowTooltip(e));
  }
  onMouseMove(e) {
    this.lastMouseEvent && (this.lastMouseEvent = e), this.tooltipMouseTrack && this.state === 2 && this.tooltipComp && this.positionTooltip();
  }
  onMouseDown() {
    this.setToDoNothing();
  }
  onMouseLeave() {
    this.interactionEnabled ? this.lockService() : this.setToDoNothing();
  }
  onFocusIn() {
    this.prepareToShowTooltip();
  }
  onFocusOut(e) {
    var s;
    const t = e.relatedTarget, o = this.tooltipCtrl.getGui(), n = (s = this.tooltipComp) == null ? void 0 : s.getGui();
    this.isInteractingWithTooltip || o.contains(t) || this.interactionEnabled && (n != null && n.contains(t)) || this.setToDoNothing();
  }
  onKeyDown() {
    this.isInteractingWithTooltip && (this.isInteractingWithTooltip = !1), this.setToDoNothing();
  }
  prepareToShowTooltip(e) {
    if (this.state != 0 || A1)
      return;
    let t = 0;
    e && (t = this.isLastTooltipHiddenRecently() ? 200 : this.getTooltipDelay("show")), this.lastMouseEvent = e || null, this.showTooltipTimeoutId = window.setTimeout(this.showTooltip.bind(this), t), this.state = 1;
  }
  isLastTooltipHiddenRecently() {
    return Date.now() - Vd < zke;
  }
  setToDoNothing(e) {
    !e && this.state === 2 && this.hideTooltip(), this.onBodyScrollEventCallback && (this.onBodyScrollEventCallback(), this.onBodyScrollEventCallback = void 0), this.clearEventHandlers(), this.onDocumentKeyDownCallback && (this.onDocumentKeyDownCallback(), this.onDocumentKeyDownCallback = void 0), this.clearTimeouts(), this.state = 0, this.lastMouseEvent = null;
  }
  showTooltip() {
    var s, i;
    const e = this.getTooltipValue(), t = this.tooltipCtrl;
    if (!ue(e) || t.shouldDisplayTooltip && !t.shouldDisplayTooltip()) {
      this.setToDoNothing();
      return;
    }
    const o = this.gos.addCommon({
      location: ((s = t.getLocation) == null ? void 0 : s.call(t)) ?? "UNKNOWN",
      value: e,
      hideTooltipCallback: () => this.hideTooltip(!0),
      ...(i = t.getAdditionalParams) == null ? void 0 : i.call(t)
    });
    this.state = 2, this.tooltipInstanceCount++;
    const n = this.newTooltipComponentCallback.bind(this, this.tooltipInstanceCount);
    this.createTooltipComp(o, n);
  }
  hideTooltip(e) {
    !e && this.isInteractingWithTooltip || (this.tooltipComp && (this.destroyTooltipComp(), Vd = Date.now()), this.eventSvc.dispatchEvent({
      type: "tooltipHide",
      parentGui: this.tooltipCtrl.getGui()
    }), e && (this.isInteractingWithTooltip = !1), this.setToDoNothing(!0));
  }
  newTooltipComponentCallback(e, t) {
    var r;
    if (this.state !== 2 || this.tooltipInstanceCount !== e) {
      this.destroyBean(t);
      return;
    }
    const n = t.getGui();
    this.tooltipComp = t, n.classList.contains("ag-tooltip") || n.classList.add("ag-tooltip-custom"), this.tooltipTrigger === 0 && n.classList.add("ag-tooltip-animate"), this.interactionEnabled && n.classList.add("ag-tooltip-interactive");
    const s = this.getLocaleTextFunc(), i = (r = this.popupSvc) == null ? void 0 : r.addPopup({
      eChild: n,
      ariaLabel: s("ariaLabelTooltip", "Tooltip")
    });
    if (i && (this.tooltipPopupDestroyFunc = i.hideFunc), this.positionTooltip(), this.tooltipTrigger === 1) {
      const l = () => this.setToDoNothing();
      [this.onBodyScrollEventCallback] = this.addManagedEventListeners({
        bodyScroll: l
      }), this.setEventHandlers(l);
    }
    this.interactionEnabled && ([this.tooltipMouseEnterListener, this.tooltipMouseLeaveListener] = this.addManagedElementListeners(n, {
      mouseenter: this.onTooltipMouseEnter.bind(this),
      mouseleave: this.onTooltipMouseLeave.bind(this)
    }), [this.onDocumentKeyDownCallback] = this.addManagedElementListeners(Pt(this.beans), {
      keydown: (l) => {
        n.contains(l == null ? void 0 : l.target) || this.onKeyDown();
      }
    }), this.tooltipTrigger === 1 && ([this.tooltipFocusInListener, this.tooltipFocusOutListener] = this.addManagedElementListeners(n, {
      focusin: this.onTooltipFocusIn.bind(this),
      focusout: this.onTooltipFocusOut.bind(this)
    }))), this.eventSvc.dispatchEvent({
      type: "tooltipShow",
      tooltipGui: n,
      parentGui: this.tooltipCtrl.getGui()
    }), this.startHideTimeout();
  }
  onTooltipMouseEnter() {
    this.isInteractingWithTooltip = !0, this.unlockService();
  }
  onTooltipMouseLeave() {
    this.isTooltipFocused() || (this.isInteractingWithTooltip = !1, this.lockService());
  }
  onTooltipFocusIn() {
    this.isInteractingWithTooltip = !0;
  }
  isTooltipFocused() {
    var o;
    const e = (o = this.tooltipComp) == null ? void 0 : o.getGui(), t = Ue(this.beans);
    return !!e && e.contains(t);
  }
  onTooltipFocusOut(e) {
    const t = this.tooltipCtrl.getGui();
    this.isTooltipFocused() || (this.isInteractingWithTooltip = !1, t.contains(e.relatedTarget) ? this.startHideTimeout() : this.hideTooltip());
  }
  positionTooltip() {
    var t, o;
    const e = {
      type: "tooltip",
      ePopup: this.tooltipComp.getGui(),
      nudgeY: 18,
      skipObserver: this.tooltipMouseTrack
    };
    this.lastMouseEvent ? (t = this.popupSvc) == null || t.positionPopupUnderMouseEvent({
      ...e,
      mouseEvent: this.lastMouseEvent
    }) : (o = this.popupSvc) == null || o.positionPopupByComponent({
      ...e,
      eventSource: this.tooltipCtrl.getGui(),
      position: "under",
      keepWithinBounds: !0,
      nudgeY: 5
    });
  }
  destroyTooltipComp() {
    this.tooltipComp.getGui().classList.add("ag-tooltip-hiding");
    const e = this.tooltipPopupDestroyFunc, t = this.tooltipComp, o = this.tooltipTrigger === 0 ? jke : 0;
    window.setTimeout(() => {
      e(), this.destroyBean(t);
    }, o), this.clearTooltipListeners(), this.tooltipPopupDestroyFunc = void 0, this.tooltipComp = void 0;
  }
  clearTooltipListeners() {
    [
      this.tooltipMouseEnterListener,
      this.tooltipMouseLeaveListener,
      this.tooltipFocusInListener,
      this.tooltipFocusOutListener
    ].forEach((e) => {
      e && e();
    }), this.tooltipMouseEnterListener = this.tooltipMouseLeaveListener = this.tooltipFocusInListener = this.tooltipFocusOutListener = null;
  }
  lockService() {
    A1 = !0, this.interactiveTooltipTimeoutId = window.setTimeout(() => {
      this.unlockService(), this.setToDoNothing();
    }, Hd);
  }
  unlockService() {
    A1 = !1, this.clearInteractiveTimeout();
  }
  startHideTimeout() {
    this.clearHideTimeout(), this.hideTooltipTimeoutId = window.setTimeout(this.hideTooltip.bind(this), this.getTooltipDelay("hide"));
  }
  clearShowTimeout() {
    this.showTooltipTimeoutId && (window.clearTimeout(this.showTooltipTimeoutId), this.showTooltipTimeoutId = void 0);
  }
  clearHideTimeout() {
    this.hideTooltipTimeoutId && (window.clearTimeout(this.hideTooltipTimeoutId), this.hideTooltipTimeoutId = void 0);
  }
  clearInteractiveTimeout() {
    this.interactiveTooltipTimeoutId && (window.clearTimeout(this.interactiveTooltipTimeoutId), this.interactiveTooltipTimeoutId = void 0);
  }
  clearTimeouts() {
    this.clearShowTimeout(), this.clearHideTimeout(), this.clearInteractiveTimeout();
  }
}, Uke = class extends gb {
  constructor(e, t, o) {
    super(e, o), this.highlightTracker = t, this.onHighlight = this.onHighlight.bind(this);
  }
  postConstruct() {
    super.postConstruct(), this.wireHighlightListeners();
  }
  wireHighlightListeners() {
    this.addManagedPropertyListener("tooltipTrigger", ({ currentValue: e }) => {
      this.setTooltipMode(e);
    }), this.setTooltipMode(this.gos.get("tooltipTrigger")), this.highlightTracker.addEventListener("itemHighlighted", this.onHighlight);
  }
  onHighlight(e) {
    this.tooltipMode === 1 && (e.highlighted ? this.attemptToShowTooltip() : this.attemptToHideTooltip());
  }
  setTooltipMode(e = "focus") {
    this.tooltipMode = e === "focus" ? 1 : 0;
  }
  destroy() {
    this.highlightTracker.removeEventListener("itemHighlighted", this.onHighlight), super.destroy();
  }
}, L1 = 0, Kke = 200, qke = class extends Cn {
  constructor() {
    super(...arguments), this.beanName = "popupSvc", this.popupList = [];
  }
  getPopupParent() {
    const e = this.gos.get("popupParent");
    return e || this.getDefaultPopupParent();
  }
  positionPopupUnderMouseEvent(e) {
    const { ePopup: t, nudgeX: o, nudgeY: n, skipObserver: s } = e;
    this.positionPopup({
      ePopup: t,
      nudgeX: o,
      nudgeY: n,
      keepWithinBounds: !0,
      skipObserver: s,
      updatePosition: () => this.calculatePointerAlign(e.mouseEvent),
      postProcessCallback: () => this.callPostProcessPopup(e, e.type, e.ePopup, null, e.mouseEvent)
    });
  }
  calculatePointerAlign(e) {
    const t = this.getParentRect();
    return {
      x: e.clientX - t.left,
      y: e.clientY - t.top
    };
  }
  positionPopupByComponent(e) {
    const {
      ePopup: t,
      nudgeX: o,
      nudgeY: n,
      keepWithinBounds: s,
      eventSource: i,
      alignSide: r = "left",
      position: l = "over",
      type: a
    } = e, c = i.getBoundingClientRect(), d = this.getParentRect();
    this.setAlignedTo(i, t);
    const u = () => {
      let h = c.left - d.left;
      r === "right" && (h -= t.offsetWidth - c.width);
      let p;
      return l === "over" ? (p = c.top - d.top, this.setAlignedStyles(t, "over")) : (this.setAlignedStyles(t, "under"), this.shouldRenderUnderOrAbove(t, c, d, e.nudgeY || 0) === "under" ? p = c.top - d.top + c.height : p = c.top - t.offsetHeight - (n || 0) * 2 - d.top), { x: h, y: p };
    };
    this.positionPopup({
      ePopup: t,
      nudgeX: o,
      nudgeY: n,
      keepWithinBounds: s,
      updatePosition: u,
      postProcessCallback: () => this.callPostProcessPopup(e, a, t, i, null)
    });
  }
  shouldRenderUnderOrAbove(e, t, o, n) {
    const s = o.bottom - t.bottom, i = t.top - o.top, r = e.offsetHeight + n;
    return s > r ? "under" : i > r || i > s ? "above" : "under";
  }
  setAlignedStyles(e, t) {
    const o = this.getPopupIndex(e);
    if (o === -1)
      return;
    const n = this.popupList[o], { alignedToElement: s } = n;
    !s || (["right", "left", "over", "above", "under"].forEach((r) => {
      s.classList.remove(`ag-has-popup-positioned-${r}`), e.classList.remove(`ag-popup-positioned-${r}`);
    }), !t) || (s.classList.add(`ag-has-popup-positioned-${t}`), e.classList.add(`ag-popup-positioned-${t}`));
  }
  setAlignedTo(e, t) {
    const o = this.getPopupIndex(t);
    if (o !== -1) {
      const n = this.popupList[o];
      n.alignedToElement = e;
    }
  }
  positionPopup(e) {
    const { ePopup: t, keepWithinBounds: o, nudgeX: n, nudgeY: s, skipObserver: i, updatePosition: r } = e, l = { width: 0, height: 0 }, a = (c = !1) => {
      let { x: d, y: u } = r();
      c && t.clientWidth === l.width && t.clientHeight === l.height || (l.width = t.clientWidth, l.height = t.clientHeight, n && (d += n), s && (u += s), o && (d = this.keepXYWithinBounds(
        t,
        d,
        1
        /* Horizontal */
      ), u = this.keepXYWithinBounds(
        t,
        u,
        0
        /* Vertical */
      )), t.style.left = `${d}px`, t.style.top = `${u}px`, e.postProcessCallback && e.postProcessCallback());
    };
    if (a(), !i) {
      const c = mn(this.beans, t, () => a(!0));
      setTimeout(() => c(), Kke);
    }
  }
  getParentRect() {
    const e = Pt(this.beans);
    let t = this.getPopupParent();
    return t === e.body ? t = e.documentElement : getComputedStyle(t).position === "static" && (t = t.offsetParent), lw(t);
  }
  keepXYWithinBounds(e, t, o) {
    const n = o === 0, s = n ? "clientHeight" : "clientWidth", i = n ? "top" : "left", r = n ? "height" : "width", l = n ? "scrollTop" : "scrollLeft", a = Pt(this.beans), c = a.documentElement, d = this.getPopupParent(), u = e.getBoundingClientRect(), h = d.getBoundingClientRect(), p = a.documentElement.getBoundingClientRect(), C = d === a.body, m = Math.ceil(u[r]);
    let y = C ? (n ? b2 : Nr)(c) + c[l] : d[s];
    C && (y -= Math.abs(p[i] - h[i]));
    const b = y - m;
    return Math.min(Math.max(t, 0), Math.abs(b));
  }
  addPopup(e) {
    const { eChild: t, ariaLabel: o, ariaOwns: n, alwaysOnTop: s, positionCallback: i, anchorToElement: r } = e, l = this.getPopupIndex(t);
    if (l !== -1)
      return { hideFunc: this.popupList[l].hideFunc };
    this.initialisePopupPosition(t);
    const a = this.createPopupWrapper(t, !!s, o, n), c = this.addEventListenersToPopup({ ...e, wrapperEl: a });
    return i && i(), this.addPopupToPopupList(t, a, c, r), {
      hideFunc: c
    };
  }
  initialisePopupPosition(e) {
    const o = this.getPopupParent().getBoundingClientRect();
    ue(e.style.top) || (e.style.top = `${o.top * -1}px`), ue(e.style.left) || (e.style.left = `${o.left * -1}px`);
  }
  createPopupWrapper(e, t, o, n) {
    const s = this.getPopupParent(), { environment: i, gos: r } = this.beans, l = c1({ tag: "div" });
    return i.applyThemeClasses(l), l.classList.add("ag-popup"), e.classList.add(r.get("enableRtl") ? "ag-rtl" : "ag-ltr", "ag-popup-child"), e.hasAttribute("role") || no(e, "dialog"), o ? ft(e, o) : n && (e.id || (e.id = `popup-component-${L1}`), md(n, e.id)), l.appendChild(e), s.appendChild(l), t ? this.setAlwaysOnTop(e, !0) : this.bringPopupToFront(e), l;
  }
  addEventListenersToPopup(e) {
    const t = this.beans, o = Pt(t), n = this.getPopupParent(), { wrapperEl: s, eChild: i, closedCallback: r, afterGuiAttached: l, closeOnEsc: a, modal: c, ariaOwns: d } = e;
    let u = !1;
    const h = (w) => {
      if (!s.contains(Ue(t)))
        return;
      w.key === D.ESCAPE && !this.isStopPropagation(w) && m({ keyboardEvent: w });
    }, p = (w) => m({ mouseEvent: w }), C = (w) => m({ touchEvent: w }), m = (w = {}) => {
      const { mouseEvent: y, touchEvent: b, keyboardEvent: _, forceHide: M } = w;
      !M && // we don't hide popup if the event was on the child, or any
      // children of this child
      (this.isEventFromCurrentPopup({ mouseEvent: y, touchEvent: b }, i) || // this method should only be called once. the client can have different
      // paths, each one wanting to close, so this method may be called multiple times.
      u) || (u = !0, n.removeChild(s), o.removeEventListener("keydown", h), o.removeEventListener("mousedown", p), o.removeEventListener("touchstart", C), o.removeEventListener("contextmenu", p), this.eventSvc.removeListener("dragStarted", p), r && r(y || b || _), this.removePopupFromPopupList(i, d));
    };
    return l && l({ hidePopup: m }), window.setTimeout(() => {
      a && o.addEventListener("keydown", h), c && (o.addEventListener("mousedown", p), this.eventSvc.addListener("dragStarted", p), o.addEventListener("touchstart", C), o.addEventListener("contextmenu", p));
    }, 0), m;
  }
  addPopupToPopupList(e, t, o, n) {
    this.popupList.push({
      element: e,
      wrapper: t,
      hideFunc: o,
      instanceId: L1,
      isAnchored: !!n
    }), n && this.setPopupPositionRelatedToElement(e, n), L1 = L1 + 1;
  }
  getPopupIndex(e) {
    return this.popupList.findIndex((t) => t.element === e);
  }
  setPopupPositionRelatedToElement(e, t) {
    const o = this.getPopupIndex(e);
    if (o === -1)
      return;
    const n = this.popupList[o];
    if (n.stopAnchoringPromise && n.stopAnchoringPromise.then((i) => i && i()), n.stopAnchoringPromise = void 0, n.isAnchored = !1, !t)
      return;
    const s = this.keepPopupPositionedRelativeTo({
      element: t,
      ePopup: e,
      hidePopup: n.hideFunc
    });
    return n.stopAnchoringPromise = s, n.isAnchored = !0, s;
  }
  removePopupFromPopupList(e, t) {
    this.setAlignedStyles(e, null), this.setPopupPositionRelatedToElement(e, null), t && md(t, null), this.popupList = this.popupList.filter((o) => o.element !== e);
  }
  keepPopupPositionedRelativeTo(e) {
    const t = this.getPopupParent(), o = t.getBoundingClientRect(), { element: n, ePopup: s } = e, i = n.getBoundingClientRect(), r = (u) => parseInt(u.substring(0, u.length - 1), 10), l = (u, h) => {
      const p = o[u] - i[u], C = r(s.style[u]);
      return {
        initialDiff: p,
        lastDiff: p,
        initial: C,
        last: C,
        direction: h
      };
    }, a = l(
      "top",
      0
      /* Vertical */
    ), c = l(
      "left",
      1
      /* Horizontal */
    ), d = this.beans.frameworkOverrides;
    return new Ye((u) => {
      d.wrapIncoming(() => {
        oDe(() => {
          const h = t.getBoundingClientRect(), p = n.getBoundingClientRect();
          if (p.top == 0 && p.left == 0 && p.height == 0 && p.width == 0) {
            e.hidePopup();
            return;
          }
          const m = (w, y) => {
            const b = r(s.style[y]);
            w.last !== b && (w.initial = b, w.last = b);
            const _ = h[y] - p[y];
            if (_ != w.lastDiff) {
              const M = this.keepXYWithinBounds(
                s,
                w.initial + w.initialDiff - _,
                w.direction
              );
              s.style[y] = `${M}px`, w.last = M;
            }
            w.lastDiff = _;
          };
          m(a, "top"), m(c, "left");
        }, 200).then((h) => {
          u(() => {
            h != null && window.clearInterval(h);
          });
        });
      }, "popupPositioning");
    });
  }
  isEventFromCurrentPopup(e, t) {
    const { mouseEvent: o, touchEvent: n } = e, s = o || n;
    if (!s)
      return !1;
    const i = this.getPopupIndex(t);
    if (i === -1)
      return !1;
    for (let r = i; r < this.popupList.length; r++) {
      const l = this.popupList[r];
      if (q0(l.element, s))
        return !0;
    }
    return this.isElementWithinCustomPopup(s.target);
  }
  isElementWithinCustomPopup(e) {
    const t = Pt(this.beans);
    for (; e && e !== t.body; ) {
      if (e.classList.contains("ag-custom-component-popup") || e.parentElement === null)
        return !0;
      e = e.parentElement;
    }
    return !1;
  }
  getWrapper(e) {
    for (; !e.classList.contains("ag-popup") && e.parentElement; )
      e = e.parentElement;
    return e.classList.contains("ag-popup") ? e : null;
  }
  setAlwaysOnTop(e, t) {
    const o = this.getWrapper(e);
    o && (o.classList.toggle("ag-always-on-top", !!t), t && this.bringPopupToFront(o));
  }
  /** @returns true if moved */
  bringPopupToFront(e) {
    const t = this.getPopupParent(), o = Array.prototype.slice.call(t.querySelectorAll(".ag-popup")), n = o.length, s = this.getWrapper(e);
    if (!s || n <= 1 || !t.contains(e))
      return;
    const i = [], r = [];
    for (const h of o)
      h !== s && (h.classList.contains("ag-always-on-top") ? r.push(h) : i.push(h));
    const l = [], a = r.length, u = s.classList.contains("ag-always-on-top") || !a ? [...i, ...r, s] : [...i, s, ...r];
    for (let h = 0; h <= n; h++) {
      const p = u[h];
      if (o[h] === u[h] || p === s)
        continue;
      p.querySelectorAll("div").forEach((m) => {
        m.scrollTop !== 0 && l.push([m, m.scrollTop]);
      }), h === 0 ? t.insertAdjacentElement("afterbegin", p) : u[h - 1].insertAdjacentElement("afterend", p);
    }
    for (; l.length; ) {
      const h = l.pop();
      h[0].scrollTop = h[1];
    }
  }
}, Yke = class extends ga {
  constructor() {
    super({ tag: "div", cls: "ag-tooltip" });
  }
  // will need to type params
  init(e) {
    const { value: t } = e, o = this.getGui();
    o.textContent = ni(t);
    const n = e.location.replace(/([a-z])([A-Z0-9])/g, "$1-$2").toLowerCase();
    o.classList.add(`ag-${n}-tooltip`);
  }
}, Qke = class extends Cn {
  constructor() {
    super(...arguments), this.beanName = "dragSvc", this.dragEndFunctions = [], this.dragSources = [];
  }
  destroy() {
    const { dragSources: e } = this;
    e.forEach(this.removeListener.bind(this)), e.length = 0, super.destroy();
  }
  removeListener(e) {
    const t = e.dragSource.eElement, o = e.mouseDownListener;
    if (t.removeEventListener("mousedown", o), e.touchEnabled) {
      const n = e.touchStartListener;
      t.removeEventListener("touchstart", n, { passive: !0 });
    }
  }
  removeDragSource(e) {
    const { dragSources: t } = this, o = t.find((n) => n.dragSource === e);
    o && (this.removeListener(o), Zt(t, o));
  }
  addDragSource(e) {
    const t = this.onMouseDown.bind(this, e), { eElement: o, includeTouch: n, stopPropagationForTouch: s } = e;
    o.addEventListener("mousedown", t);
    let i = null;
    const r = this.gos.get("suppressTouch");
    n && !r && (i = (l) => {
      w2(l.target) || (s && l.stopPropagation(), this.onTouchStart(e, l));
    }, o.addEventListener("touchstart", i, { passive: !1 })), this.dragSources.push({
      dragSource: e,
      mouseDownListener: t,
      touchStartListener: i,
      touchEnabled: !!n
    });
  }
  // gets called whenever mouse down on any drag source
  onTouchStart(e, t) {
    this.currentDragParams = e, this.dragging = !1;
    const o = t.touches[0];
    this.touchLastTime = o, this.touchStart = o;
    const n = (a) => this.onTouchMove(a, e.eElement), s = (a) => this.onTouchUp(a, e.eElement), i = (a) => {
      a.cancelable && a.preventDefault();
    }, r = t.target, l = [
      // Prevents the page document from moving while we are dragging items around.
      // preventDefault needs to be called in the touchmove listener and never inside the
      // touchstart, because using touchstart causes the click event to be cancelled on touch devices.
      {
        target: Ks(this.beans),
        type: "touchmove",
        listener: i,
        options: { passive: !1 }
      },
      { target: r, type: "touchmove", listener: n, options: { passive: !0 } },
      { target: r, type: "touchend", listener: s, options: { passive: !0 } },
      { target: r, type: "touchcancel", listener: s, options: { passive: !0 } }
    ];
    this.addTemporaryEvents(l), e.dragStartPixels === 0 && this.onCommonMove(o, this.touchStart, e.eElement);
  }
  // gets called whenever mouse down on any drag source
  onMouseDown(e, t) {
    const o = t;
    if (e.skipMouseEvent && e.skipMouseEvent(t) || o._alreadyProcessedByDragService || (o._alreadyProcessedByDragService = !0, t.button !== 0))
      return;
    this.shouldPreventMouseEvent(t) && t.preventDefault(), this.currentDragParams = e, this.dragging = !1, this.mouseStartEvent = t, this.startTarget = t.target;
    const n = (c) => this.onMouseMove(c, e.eElement), s = (c) => this.onMouseUp(c, e.eElement), i = (c) => c.preventDefault(), r = (c) => {
      c.key === D.ESCAPE && this.cancelDrag(e.eElement);
    }, l = Ks(this.beans), a = [
      { target: l, type: "mousemove", listener: n },
      { target: l, type: "mouseup", listener: s },
      { target: l, type: "contextmenu", listener: i },
      { target: l, type: "keydown", listener: r }
    ];
    this.addTemporaryEvents(a), e.dragStartPixels === 0 && this.onMouseMove(t, e.eElement);
  }
  addTemporaryEvents(e) {
    e.forEach((t) => {
      const { target: o, type: n, listener: s, options: i } = t;
      o.addEventListener(n, s, i);
    }), this.dragEndFunctions.push(() => {
      e.forEach((t) => {
        const { target: o, type: n, listener: s, options: i } = t;
        o.removeEventListener(n, s, i);
      });
    });
  }
  // returns true if the event is close to the original event by X pixels either vertically or horizontally.
  // we only start dragging after X pixels so this allows us to know if we should start dragging yet.
  isEventNearStartEvent(e, t) {
    const { dragStartPixels: o } = this.currentDragParams, n = ue(o) ? o : 4;
    return pw(e, t, n);
  }
  getFirstActiveTouch(e) {
    for (let t = 0; t < e.length; t++)
      if (e[t].identifier === this.touchStart.identifier)
        return e[t];
    return null;
  }
  onCommonMove(e, t, o) {
    var n;
    if (!this.dragging) {
      if (this.isEventNearStartEvent(e, t))
        return;
      if (this.dragging = !0, this.eventSvc.dispatchEvent({
        type: "dragStarted",
        target: o
      }), this.currentDragParams.onDragStart(t), !this.currentDragParams) {
        this.dragging = !1;
        return;
      }
      this.currentDragParams.onDragging(t);
    }
    (n = this.currentDragParams) == null || n.onDragging(e);
  }
  onTouchMove(e, t) {
    const o = this.getFirstActiveTouch(e.touches);
    o && this.onCommonMove(o, this.touchStart, t);
  }
  // only gets called after a mouse down - as this is only added after mouseDown
  // and is removed when mouseUp happens
  onMouseMove(e, t) {
    var o;
    Gn() && ((o = Pt(this.beans).getSelection()) == null || o.removeAllRanges()), this.shouldPreventMouseEvent(e) && e.preventDefault(), this.onCommonMove(e, this.mouseStartEvent, t);
  }
  shouldPreventMouseEvent(e) {
    const t = e.type === "mousemove", o = (n) => {
      const s = n.target, i = s == null ? void 0 : s.tagName.toLocaleLowerCase();
      return !!(i != null && i.match("^a$|textarea|input|select|button"));
    };
    return t && e.cancelable && zr(this.beans, e) && !o(e);
  }
  onTouchUp(e, t) {
    let o = this.getFirstActiveTouch(e.changedTouches);
    o || (o = this.touchLastTime), this.onUpCommon(o, t);
  }
  onMouseUp(e, t) {
    this.onUpCommon(e, t);
  }
  onUpCommon(e, t) {
    this.dragging && (this.dragging = !1, this.currentDragParams.onDragStop(e), this.eventSvc.dispatchEvent({
      type: "dragStopped",
      target: t
    })), this.resetDragProperties();
  }
  cancelDrag(e) {
    var t, o;
    this.eventSvc.dispatchEvent({
      type: "dragCancelled",
      target: e
    }), (o = (t = this.currentDragParams) == null ? void 0 : t.onDragCancel) == null || o.call(t), this.resetDragProperties();
  }
  resetDragProperties() {
    this.mouseStartEvent = null, this.startTarget = null, this.touchStart = null, this.touchLastTime = null, this.currentDragParams = null;
    const { dragEndFunctions: e } = this;
    e.forEach((t) => t()), e.length = 0;
  }
}, Jke = class extends Cn {
  constructor() {
    super(...arguments), this.beanName = "dragAndDrop", this.dragSourceAndParamsList = [], this.dragItem = null, this.lastMouseEvent = null, this.lastDraggingEvent = null, this.dragSource = null, this.dragImageParent = null, this.dragImageCompPromise = null, this.dragImageComp = null, this.dragImageLastIcon = void 0, this.dragImageLastLabel = void 0, this.dropTargets = [], this.lastDropTarget = null;
  }
  addDragSource(e, t = !1) {
    const o = {
      dragSource: e,
      eElement: e.eElement,
      dragStartPixels: e.dragStartPixels,
      onDragStart: (n) => this.onDragStart(e, n),
      onDragStop: this.onDragStop.bind(this),
      onDragging: this.onDragging.bind(this),
      onDragCancel: this.onDragCancel.bind(this),
      includeTouch: t
    };
    this.dragSourceAndParamsList.push(o), this.beans.dragSvc.addDragSource(o);
  }
  setDragImageCompIcon(e, t = !1) {
    const o = this.dragImageComp;
    o && (t || this.dragImageLastIcon !== e) && (this.dragImageLastIcon = e, o.setIcon(e, t));
  }
  removeDragSource(e) {
    var s;
    const { dragSourceAndParamsList: t, beans: o } = this, n = t.find((i) => i.dragSource === e);
    n && ((s = o.dragSvc) == null || s.removeDragSource(n), Zt(t, n));
  }
  destroy() {
    const { dragSourceAndParamsList: e, dropTargets: t, beans: o } = this, n = o.dragSvc;
    for (const s of e)
      n == null || n.removeDragSource(s);
    e.length = 0, t.length = 0, this.clearDragAndDropProperties(), super.destroy();
  }
  nudge() {
    const e = this.lastMouseEvent;
    e && this.onDragging(e, !0);
  }
  onDragStart(e, t) {
    var o;
    this.lastMouseEvent = t, this.dragSource = e, this.dragItem = e.getDragItem(), (o = e.onDragStarted) == null || o.call(e), this.createAndUpdateDragImageComp(e);
  }
  onDragStop(e) {
    var n, s;
    const { dragSource: t, lastDropTarget: o } = this;
    if ((n = t == null ? void 0 : t.onDragStopped) == null || n.call(t), o) {
      const i = this.dropTargetEvent(o, e, !1);
      (s = o.onDragStop) == null || s.call(o, i);
    }
    this.clearDragAndDropProperties();
  }
  onDragCancel() {
    var n, s;
    const { dragSource: e, lastDropTarget: t, lastMouseEvent: o } = this;
    if ((n = e == null ? void 0 : e.onDragCancelled) == null || n.call(e), t && o) {
      const i = this.dropTargetEvent(t, o, !1);
      (s = t.onDragCancel) == null || s.call(t, i);
    }
    this.clearDragAndDropProperties();
  }
  onDragging(e, t = !1) {
    var l, a, c;
    this.positionDragImageComp(e);
    const o = this.findCurrentDropTarget(e), { lastDropTarget: n, dragSource: s, dragItem: i } = this;
    let r = !1;
    if (o !== n) {
      if (r = !0, n) {
        const d = this.dropTargetEvent(n, e, t);
        (l = n.onDragLeave) == null || l.call(n, d);
      }
      if (n !== null && !o ? this.handleExit(s, i) : n === null && o && this.handleEnter(s, i), o) {
        const d = this.dropTargetEvent(o, e, t);
        (a = o.onDragEnter) == null || a.call(o, d);
      }
      this.lastDropTarget = o;
    } else if (o) {
      const d = this.dropTargetEvent(o, e, t);
      (c = o.onDragging) == null || c.call(o, d), d != null && d.changed && (r = !0);
    }
    this.lastMouseEvent = e, r && this.updateDragImageComp();
  }
  clearDragAndDropProperties() {
    this.removeDragImageComp(this.dragImageComp), this.dragImageCompPromise = null, this.dragImageParent = null, this.dragImageLastIcon = void 0, this.dragImageLastLabel = void 0, this.lastMouseEvent = null, this.lastDraggingEvent = null, this.lastDropTarget = null, this.dragItem = null, this.dragSource = null;
  }
  getAllContainersFromDropTarget(e) {
    const t = e.getSecondaryContainers ? e.getSecondaryContainers() : null, o = [[e.getContainer()]];
    return t ? o.concat(t) : o;
  }
  // checks if the mouse is on the drop target. it checks eContainer and eSecondaryContainers
  isMouseOnDropTarget(e, t) {
    const o = this.getAllContainersFromDropTarget(t);
    let n = !1;
    const s = (l, a) => {
      for (const c of a) {
        const { width: d, height: u, left: h, right: p, top: C, bottom: m } = c.getBoundingClientRect();
        if (d === 0 || u === 0)
          return !1;
        const w = l.clientX >= h && l.clientX < p, y = l.clientY >= C && l.clientY < m;
        if (!w || !y)
          return !1;
      }
      return !0;
    };
    for (const l of o)
      if (s(e, l)) {
        n = !0;
        break;
      }
    const { eElement: i, type: r } = this.dragSource;
    return t.targetContainsSource && !t.getContainer().contains(i) ? !1 : n && t.isInterestedIn(r, i);
  }
  findCurrentDropTarget(e) {
    const t = this.dropTargets.filter((i) => this.isMouseOnDropTarget(e, i)), o = t.length;
    if (o === 0)
      return null;
    if (o === 1)
      return t[0];
    const s = Ks(this.beans).elementsFromPoint(e.clientX, e.clientY);
    for (const i of s)
      for (const r of t)
        if (this.getAllContainersFromDropTarget(r).flatMap((a) => a).indexOf(i) !== -1)
          return r;
    return null;
  }
  addDropTarget(e) {
    this.dropTargets.push(e);
  }
  removeDropTarget(e) {
    this.dropTargets = this.dropTargets.filter((t) => t.getContainer() !== e.getContainer());
  }
  hasExternalDropZones() {
    return this.dropTargets.some((e) => e.external);
  }
  findExternalZone(e) {
    return this.dropTargets.find((t) => t.external && t.getContainer() === e) || null;
  }
  dropTargetEvent(e, t, o) {
    const { dragSource: n, dragItem: s, lastDraggingEvent: i, lastMouseEvent: r } = this, l = e.getContainer(), a = l.getBoundingClientRect(), { clientX: c, clientY: d } = t, u = c - ((r == null ? void 0 : r.clientX) || 0), h = d - ((r == null ? void 0 : r.clientY) || 0), p = this.createEvent({
      event: t,
      x: c - a.left,
      // relative x
      y: d - a.top,
      // relative y
      vDirection: h > 0 ? "down" : h < 0 ? "up" : null,
      hDirection: u < 0 ? "left" : u > 0 ? "right" : null,
      dragSource: n,
      fromNudge: o,
      dragItem: s,
      dropZoneTarget: l,
      dropTarget: (i == null ? void 0 : i.dropTarget) ?? null,
      // updated by rowDragFeature
      changed: !!(i != null && i.changed)
    });
    return this.lastDraggingEvent = p, p;
  }
  positionDragImageComp(e) {
    var o;
    const t = (o = this.dragImageComp) == null ? void 0 : o.getGui();
    t && Y0(t, e, this.beans);
  }
  removeDragImageComp(e) {
    var t;
    if (this.dragImageComp === e && (this.dragImageComp = null), e) {
      const o = e.getGui();
      (t = this.dragImageParent) == null || t.removeChild(o), this.destroyBean(e);
    }
  }
  createAndUpdateDragImageComp(e) {
    const t = this.createDragImageComp(e) ?? null;
    this.dragImageCompPromise = t, t == null || t.then((o) => {
      if (t !== this.dragImageCompPromise || !this.lastMouseEvent || !this.isAlive()) {
        this.destroyBean(o);
        return;
      }
      this.dragImageCompPromise = null, this.dragImageLastIcon = void 0, this.dragImageLastLabel = void 0;
      const n = this.dragImageComp;
      n !== o && (this.dragImageComp = o, this.removeDragImageComp(n)), o && (this.appendDragImageComp(o), this.updateDragImageComp());
    });
  }
  appendDragImageComp(e) {
    const t = e.getGui(), o = t.style;
    o.setProperty("position", "absolute"), o.setProperty("z-index", "9999"), this.gos.setInstanceDomData(t), this.beans.environment.applyThemeClasses(t), o.top = "20px", o.left = "20px";
    const n = na(this.beans);
    this.dragImageParent = n, n ? n.appendChild(t) : this.warnNoBody();
  }
  updateDragImageComp() {
    var r;
    const { dragImageComp: e, dragSource: t, lastDropTarget: o, lastDraggingEvent: n, dragImageLastLabel: s } = this;
    if (!e)
      return;
    this.setDragImageCompIcon(((r = o == null ? void 0 : o.getIconName) == null ? void 0 : r.call(o, n)) ?? null);
    let i = t == null ? void 0 : t.dragItemName;
    typeof i == "function" && (i = i(n)), i || (i = ""), s !== i && (this.dragImageLastLabel = i, e.setLabel(i));
  }
}, Hn = /* @__PURE__ */ ((e) => (e[e.ToolPanel = 0] = "ToolPanel", e[e.HeaderCell = 1] = "HeaderCell", e[e.RowDrag = 2] = "RowDrag", e[e.ChartPanel = 3] = "ChartPanel", e[e.AdvancedFilterBuilder = 4] = "AdvancedFilterBuilder", e))(Hn || {}), Xke = class extends Jke {
  createEvent(e) {
    return Pe(this.gos, e);
  }
  createDragImageComp(e) {
    const { gos: t, beans: o } = this, n = xDe(
      o.userCompFactory,
      Pe(t, {
        dragSource: e
      })
    );
    return n == null ? void 0 : n.newAgStackInstance();
  }
  handleEnter(e, t) {
    var o;
    (o = e == null ? void 0 : e.onGridEnter) == null || o.call(e, t);
  }
  handleExit(e, t) {
    var o;
    (o = e == null ? void 0 : e.onGridExit) == null || o.call(e, t);
  }
  warnNoBody() {
    X(54);
  }
  isDropZoneWithinThisGrid(e) {
    return this.beans.ctrlsSvc.getGridBodyCtrl().eGridBody.contains(e.dropZoneTarget);
  }
  registerGridDropTarget(e, t) {
    const o = {
      getContainer: e,
      isInterestedIn: (n) => n === 1 || n === 0,
      getIconName: () => "notAllowed"
    };
    this.addDropTarget(o), t.addDestroyFunc(() => this.removeDropTarget(o));
  }
};
function pb(e, t) {
  return e + "_" + t;
}
function St(e) {
  return e instanceof Qr;
}
var Qr = class extends K {
  constructor(e, t, o, n) {
    super(), this.providedColumnGroup = e, this.groupId = t, this.partId = o, this.pinned = n, this.isColumn = !1, this.displayedChildren = [], this.autoHeaderHeight = null, this.parent = null, this.colIdSanitised = xr(this.getUniqueId());
  }
  // as the user is adding and removing columns, the groups are recalculated.
  // this reset clears out all children, ready for children to be added again
  reset() {
    this.parent = null, this.children = null, this.displayedChildren = null;
  }
  getParent() {
    return this.parent;
  }
  getUniqueId() {
    return pb(this.groupId, this.partId);
  }
  isEmptyGroup() {
    return this.displayedChildren.length === 0;
  }
  isMoving() {
    const e = this.getProvidedColumnGroup().getLeafColumns();
    return !e || e.length === 0 ? !1 : e.every((t) => t.isMoving());
  }
  checkLeft() {
    if (this.displayedChildren.forEach((e) => {
      St(e) && e.checkLeft();
    }), this.displayedChildren.length > 0)
      if (this.gos.get("enableRtl")) {
        const t = Ke(this.displayedChildren).getLeft();
        this.setLeft(t);
      } else {
        const e = this.displayedChildren[0].getLeft();
        this.setLeft(e);
      }
    else
      this.setLeft(null);
  }
  getLeft() {
    return this.left;
  }
  getOldLeft() {
    return this.oldLeft;
  }
  setLeft(e) {
    this.oldLeft = this.left, this.left !== e && (this.left = e, this.dispatchLocalEvent({ type: "leftChanged" }));
  }
  getPinned() {
    return this.pinned;
  }
  getGroupId() {
    return this.groupId;
  }
  getPartId() {
    return this.partId;
  }
  getActualWidth() {
    var t;
    let e = 0;
    return (t = this.displayedChildren) == null || t.forEach((o) => {
      e += o.getActualWidth();
    }), e;
  }
  isResizable() {
    if (!this.displayedChildren)
      return !1;
    let e = !1;
    return this.displayedChildren.forEach((t) => {
      t.isResizable() && (e = !0);
    }), e;
  }
  getMinWidth() {
    let e = 0;
    return this.displayedChildren.forEach((t) => {
      e += t.getMinWidth();
    }), e;
  }
  addChild(e) {
    this.children || (this.children = []), this.children.push(e);
  }
  getDisplayedChildren() {
    return this.displayedChildren;
  }
  getLeafColumns() {
    const e = [];
    return this.addLeafColumns(e), e;
  }
  getDisplayedLeafColumns() {
    const e = [];
    return this.addDisplayedLeafColumns(e), e;
  }
  getDefinition() {
    return this.providedColumnGroup.getColGroupDef();
  }
  getColGroupDef() {
    return this.providedColumnGroup.getColGroupDef();
  }
  isPadding() {
    return this.providedColumnGroup.isPadding();
  }
  isExpandable() {
    return this.providedColumnGroup.isExpandable();
  }
  isExpanded() {
    return this.providedColumnGroup.isExpanded();
  }
  setExpanded(e) {
    this.providedColumnGroup.setExpanded(e);
  }
  isAutoHeaderHeight() {
    var e;
    return !!((e = this.getColGroupDef()) != null && e.autoHeaderHeight);
  }
  getAutoHeaderHeight() {
    return this.autoHeaderHeight;
  }
  /** Returns true if the header height has changed */
  setAutoHeaderHeight(e) {
    const t = e !== this.autoHeaderHeight;
    return this.autoHeaderHeight = e, t;
  }
  addDisplayedLeafColumns(e) {
    this.displayedChildren.forEach((t) => {
      hn(t) ? e.push(t) : St(t) && t.addDisplayedLeafColumns(e);
    });
  }
  addLeafColumns(e) {
    this.children.forEach((t) => {
      hn(t) ? e.push(t) : St(t) && t.addLeafColumns(e);
    });
  }
  getChildren() {
    return this.children;
  }
  getColumnGroupShow() {
    return this.providedColumnGroup.getColumnGroupShow();
  }
  getProvidedColumnGroup() {
    return this.providedColumnGroup;
  }
  getPaddingLevel() {
    const e = this.getParent();
    return !this.isPadding() || !e || !e.isPadding() ? 0 : 1 + e.getPaddingLevel();
  }
  calculateDisplayedColumns() {
    this.displayedChildren = [];
    let e = this;
    for (; e != null && e.isPadding(); )
      e = e.getParent();
    if (!(e ? e.getProvidedColumnGroup().isExpandable() : !1)) {
      this.displayedChildren = this.children, this.dispatchLocalEvent({ type: "displayedChildrenChanged" });
      return;
    }
    this.children.forEach((o) => {
      var i;
      if (St(o) && !((i = o.displayedChildren) != null && i.length))
        return;
      switch (o.getColumnGroupShow()) {
        case "open":
          e.getProvidedColumnGroup().isExpanded() && this.displayedChildren.push(o);
          break;
        case "closed":
          e.getProvidedColumnGroup().isExpanded() || this.displayedChildren.push(o);
          break;
        default:
          this.displayedChildren.push(o);
          break;
      }
    }), this.dispatchLocalEvent({ type: "displayedChildrenChanged" });
  }
}, Rl = "row-group-", Z2 = "t-", G2 = "b-", eHe = 0, pn = class {
  constructor(e) {
    this.master = !1, this.detail = void 0, this.rowIndex = null, this.key = null, this.sourceRowIndex = -1, this.childrenMapped = null, this.treeParent = null, this.treeNodeFlags = 0, this.displayed = !1, this.rowTop = null, this.oldRowTop = null, this.selectable = !0, this.__objectId = eHe++, this.alreadyRendered = !1, this.hovered = !1, this.__selected = !1, this.beans = e;
  }
  /**
   * Replaces the data on the `rowNode`. When this method is called, the grid refreshes the entire rendered row if it is displayed.
   */
  setData(e) {
    this.setDataCommon(e, !1);
  }
  // similar to setRowData, however it is expected that the data is the same data item. this
  // is intended to be used with Redux type stores, where the whole data can be changed. we are
  // guaranteed that the data is the same entity (so grid doesn't need to worry about the id of the
  // underlying data changing, hence doesn't need to worry about selection). the grid, upon receiving
  // dataChanged event, refreshes the cells rather than rip them all out (so user can show transitions).
  /**
   * Updates the data on the `rowNode`. When this method is called, the grid refreshes the entire rendered row if it is displayed.
   */
  updateData(e) {
    this.setDataCommon(e, !0);
  }
  setDataCommon(e, t) {
    var l, a, c;
    const { valueCache: o, eventSvc: n } = this.beans, s = this.data;
    this.data = e, o == null || o.onDataChanged(), this.updateDataOnDetailNode(), this.resetQuickFilterAggregateText();
    const i = this.createDataChangedEvent(e, s, t);
    if ((l = this.__localEventService) == null || l.dispatchEvent(i), this.sibling) {
      this.sibling.data = e;
      const d = this.sibling.createDataChangedEvent(e, s, t);
      (a = this.sibling.__localEventService) == null || a.dispatchEvent(d);
    }
    n.dispatchEvent({ type: "rowNodeDataChanged", node: this });
    const r = this.pinnedSibling;
    r && (r.data = e, (c = r.__localEventService) == null || c.dispatchEvent(
      r.createDataChangedEvent(e, s, t)
    ), n.dispatchEvent({ type: "rowNodeDataChanged", node: r }));
  }
  // when we are doing master / detail, the detail node is lazy created, but then kept around.
  // so if we show / hide the detail, the same detail rowNode is used. so we need to keep the data
  // in sync, otherwise expand/collapse of the detail would still show the old values.
  updateDataOnDetailNode() {
    this.detailNode && (this.detailNode.data = this.data);
  }
  createDataChangedEvent(e, t, o) {
    return {
      type: "dataChanged",
      node: this,
      oldData: t,
      newData: e,
      update: o
    };
  }
  getRowIndexString() {
    return this.rowIndex == null ? (qe(13), null) : this.rowPinned === "top" ? Z2 + this.rowIndex : this.rowPinned === "bottom" ? G2 + this.rowIndex : this.rowIndex.toString();
  }
  setDataAndId(e, t) {
    var r, l;
    const { selectionSvc: o } = this.beans, n = (r = o == null ? void 0 : o.createDaemonNode) == null ? void 0 : r.call(o, this), s = this.data;
    this.data = e, this.updateDataOnDetailNode(), this.setId(t), o && (o.updateRowSelectable(this), o.syncInRowNode(this, n));
    const i = this.createDataChangedEvent(e, s, !1);
    (l = this.__localEventService) == null || l.dispatchEvent(i);
  }
  setId(e) {
    var o;
    const t = Qs(this.beans.gos);
    if (t)
      if (this.data) {
        const n = ((o = this.parent) == null ? void 0 : o.getRoute()) ?? [];
        this.id = t({
          data: this.data,
          parentKeys: n.length > 0 ? n : void 0,
          level: this.level,
          rowPinned: this.rowPinned
        }), this.id.startsWith(Rl) && qe(14, {
          groupPrefix: Rl
        });
      } else
        this.id = void 0;
    else
      this.id = e;
  }
  setRowTop(e) {
    this.oldRowTop = this.rowTop, this.rowTop !== e && (this.rowTop = e, this.dispatchRowEvent("topChanged"), this.setDisplayed(e !== null));
  }
  clearRowTopAndRowIndex() {
    this.oldRowTop = null, this.setRowTop(null), this.setRowIndex(null);
  }
  setHovered(e) {
    this.hovered = e;
  }
  isHovered() {
    return this.hovered;
  }
  /**
   * Sets the row height.
   * Call if you want to change the height initially assigned to the row.
   * After calling, you must call `api.onRowHeightChanged()` so the grid knows it needs to work out the placement of the rows. */
  setRowHeight(e, t = !1) {
    this.rowHeight = e, this.rowHeightEstimated = t, this.dispatchRowEvent("heightChanged");
  }
  setExpanded(e, t, o) {
    var n;
    (n = this.beans.expansionSvc) == null || n.setExpanded(this, e, t, o);
  }
  /**
   * Replaces the value on the `rowNode` for the specified column. When complete,
   * the grid refreshes the rendered cell on the required row only.
   * **Note**: This method only fires `onCellEditRequest` when the Grid is in **Read Only** mode.
   * **Note**: This method defers to EditModule if available and batches the edit when `fullRow` or `batchEdit` is enabled.
   *
   * @param colKey The column where the value should be updated
   * @param newValue The new value
   * @param eventSource The source of the event
   * @returns `true` if the value was changed, otherwise `false`.
   */
  setDataValue(e, t, o) {
    const { colModel: n, valueSvc: s, gos: i, editSvc: r } = this.beans, l = typeof e != "string" ? e : n.getCol(e) ?? n.getColDefCol(e);
    if (!l)
      return !1;
    const a = s.getValueForDisplay(l, this, void 0, void 0, "api").value;
    if (i.get("readOnlyEdit")) {
      const {
        beans: { eventSvc: u },
        data: h,
        rowIndex: p,
        rowPinned: C
      } = this;
      return u.dispatchEvent({
        type: "cellEditRequest",
        event: null,
        rowIndex: p,
        rowPinned: C,
        column: l,
        colDef: l.colDef,
        data: h,
        node: this,
        oldValue: a,
        newValue: t,
        value: t,
        source: o
      }), !1;
    }
    if (r && !r.committing) {
      const u = r.setDataValue({ rowNode: this, column: l }, t, o);
      if (u != null)
        return u;
    }
    const c = s.setValue(this, l, t, o);
    this.dispatchCellChangedEvent(l, t, a);
    const d = this.pinnedSibling;
    return d && c && d.dispatchCellChangedEvent(l, t, a), c;
  }
  updateHasChildren() {
    let e = this.group && !this.footer || this.childrenAfterGroup && this.childrenAfterGroup.length > 0;
    const { rowChildrenSvc: t } = this.beans;
    t && (e = t.getHasChildrenValue(this)), e !== this.__hasChildren && (this.__hasChildren = !!e, this.dispatchRowEvent("hasChildrenChanged"));
  }
  hasChildren() {
    return this.__hasChildren == null && this.updateHasChildren(), this.__hasChildren;
  }
  dispatchCellChangedEvent(e, t, o) {
    var s;
    const n = {
      type: "cellChanged",
      node: this,
      column: e,
      newValue: t,
      oldValue: o
    };
    (s = this.__localEventService) == null || s.dispatchEvent(n);
  }
  /**
   * The first time `quickFilter` runs, the grid creates a one-off string representation of the row.
   * This string is then used for the quick filter instead of hitting each column separately.
   * When you edit, using grid editing, this string gets cleared down.
   * However, if you edit without using grid editing, you need to clear this string down for the row to be updated with the new values.
   * Otherwise, new values would not work with the `quickFilter`. */
  resetQuickFilterAggregateText() {
    this.quickFilterAggregateText = null;
  }
  /** Returns:
   * - `true` if the node can be expanded, i.e it is a group or master row.
   * - `false` if the node cannot be expanded
   */
  isExpandable() {
    var e;
    return ((e = this.beans.expansionSvc) == null ? void 0 : e.isExpandable(this)) ?? !1;
  }
  /** Returns:
   * - `true` if node is selected,
   * - `false` if the node isn't selected
   * - `undefined` if it's partially selected (group where not all children are selected). */
  isSelected() {
    return this.footer ? this.sibling.isSelected() : this.rowPinned && this.pinnedSibling ? this.pinnedSibling.isSelected() : this.__selected;
  }
  /** Perform a depth-first search of this node and its children. */
  depthFirstSearch(e) {
    var t;
    (t = this.childrenAfterGroup) == null || t.forEach((o) => o.depthFirstSearch(e)), e(this);
  }
  dispatchRowEvent(e) {
    var t;
    (t = this.__localEventService) == null || t.dispatchEvent({
      type: e,
      node: this
    });
  }
  /**
   * Select (or deselect) the node.
   * @param newValue -`true` for selection, `false` for deselection.
   * @param clearSelection - If selecting, then passing `true` selects the node exclusively (i.e. NOT do multi select). If doing deselection, `clearSelection` has no impact.
   * @param source - Source property that appears in the `selectionChanged` event.
   */
  setSelected(e, t = !1, o = "api") {
    var n;
    (n = this.beans.selectionSvc) == null || n.setNodesSelected({
      nodes: [this],
      newValue: e,
      clearSelection: t,
      source: o
    });
  }
  /**
   * Returns:
   * - `true` if node is either pinned to the `top` or `bottom`
   * - `false` if the node isn't pinned
   */
  isRowPinned() {
    return !!this.rowPinned;
  }
  __addEventListener(e, t) {
    this.__localEventService || (this.__localEventService = new ls()), this.__localEventService.addEventListener(e, t);
  }
  __removeEventListener(e, t) {
    this.removeLocalListener(e, t);
  }
  /**
   * PUBLIC USE ONLY: for internal use within AG Grid use the `__addEventListener` and `__removeEventListener` methods.
   */
  addEventListener(e, t) {
    var n, s, i, r;
    (n = this.beans.validation) == null || n.checkRowEvents(e), this.__localEventService || (this.__localEventService = new ls()), this.frameworkEventListenerService = (i = (s = this.beans.frameworkOverrides).createLocalEventListenerWrapper) == null ? void 0 : i.call(
      s,
      this.frameworkEventListenerService,
      this.__localEventService
    );
    const o = ((r = this.frameworkEventListenerService) == null ? void 0 : r.wrap(e, t)) ?? t;
    this.__localEventService.addEventListener(e, o);
  }
  /**
   * PUBLIC USE ONLY: for internal use within AG Grid use the `__addEventListener` and `__removeEventListener` methods.
   */
  removeEventListener(e, t) {
    var n;
    const o = ((n = this.frameworkEventListenerService) == null ? void 0 : n.unwrap(e, t)) ?? t;
    this.removeLocalListener(e, o);
  }
  removeLocalListener(e, t) {
    var o, n;
    (o = this.__localEventService) == null || o.removeEventListener(e, t), (n = this.__localEventService) != null && n.noRegisteredListenersExist() && (this.__localEventService = null);
  }
  /**
   * @deprecated v32.2.0 Check `node.detail` then user provided callback `isFullWidthRow` instead.
   *
   * Returns:
   * - `true` if the node is a full width cell
   * - `false` if the node is not a full width cell
   */
  isFullWidthCell() {
    if (X(61), this.detail)
      return !0;
    const e = this.beans.gos.getCallback("isFullWidthRow");
    return e ? e({ rowNode: this }) : !1;
  }
  /**
   * Returns the route of keys to the row node. Returns undefined if the node has no key.
   */
  getRoute() {
    if (this.level === -1)
      return [];
    if (this.key == null)
      return;
    const e = [];
    let t = this;
    for (; t && t.key != null; )
      e.push(t.key), t = t.parent;
    return e.reverse();
  }
  setDisplayed(e) {
    this.displayed !== e && (this.displayed = e, this.dispatchRowEvent("displayedChanged"));
  }
  setRowIndex(e) {
    this.rowIndex !== e && (this.rowIndex = e, this.dispatchRowEvent("rowIndexChanged"));
  }
  setAllChildrenCount(e) {
    this.allChildrenCount !== e && (this.allChildrenCount = e, this.dispatchRowEvent("allChildrenCountChanged"));
  }
  setUiLevel(e) {
    this.uiLevel !== e && (this.uiLevel = e, this.dispatchRowEvent("uiLevelChanged"));
  }
  getFirstChild() {
    var e;
    return this.childStore ? this.childStore.getFirstNode() : ((e = this.childrenAfterSort) == null ? void 0 : e[0]) ?? null;
  }
};
function fb(e, t, o) {
  return Pe(t, {
    type: o,
    node: e,
    data: e.data,
    rowIndex: e.rowIndex,
    rowPinned: e.rowPinned
  });
}
var tHe = /* @__PURE__ */ new Set(["__localEventService", "__objectId", "sticky", "__autoHeights", "__checkAutoHeightsDebounced", "childStore"]);
function vb(e, t) {
  const o = new pn(t);
  return Object.keys(e).forEach((n) => {
    tHe.has(n) || (o[n] = e[n]);
  }), o.oldRowTop = null, o;
}
var mb = {
  agSetColumnFilter: "agSetColumnFilterHandler",
  agMultiColumnFilter: "agMultiColumnFilterHandler",
  agGroupColumnFilter: "agGroupColumnFilterHandler",
  agNumberColumnFilter: "agNumberColumnFilterHandler",
  agDateColumnFilter: "agDateColumnFilterHandler",
  agTextColumnFilter: "agTextColumnFilterHandler"
}, oHe = new Set(Object.values(mb));
function zn(e, t) {
  const o = e.filterUi;
  if (!o)
    return null;
  if (o.created)
    return o.promise;
  if (t)
    return null;
  const n = o.create(o.refreshed), s = o;
  return s.created = !0, s.promise = n, n;
}
function nHe(e, t, o, n, s, i) {
  var r;
  return (r = t.refresh) == null || r.call(t, { ...o, model: n, source: i }), e().then((l) => {
    if (l) {
      const { filter: a, filterParams: c } = l;
      Cb(a, c, n, s, i);
    }
  });
}
function Cb(e, t, o, n, s) {
  var i;
  (i = e == null ? void 0 : e.refresh) == null || i.call(e, {
    ...t,
    model: o,
    state: n,
    source: s
  });
}
function wb(e, t, o) {
  const n = e();
  n != null && n.created && n.promise.then((s) => {
    const i = t();
    Cb(s, n.filterParams, i, o() ?? { model: i }, "ui");
  });
}
function Od(e, t, o, n, s, i, r) {
  let l, a = !1, c;
  switch (e) {
    case "apply": {
      const d = n();
      c = (d == null ? void 0 : d.model) ?? null, r && (c = r(c)), l = {
        // keep the other UI state
        state: d == null ? void 0 : d.state,
        model: c
      }, a = !0;
      break;
    }
    case "clear": {
      l = {
        // wipe other UI state
        model: null
      };
      break;
    }
    case "reset": {
      l = {
        // wipe other UI state
        model: null
      }, a = !0, c = null;
      break;
    }
    case "cancel": {
      l = {
        // wipe other UI state
        model: o()
      };
      break;
    }
  }
  s(l), a ? i(c) : wb(t, o, n);
}
function Ot(e, t) {
  return e[t] ?? null;
}
function ze(e) {
  return c1(e);
}
function sHe(e) {
  return {
    tag: "div",
    cls: e
  };
}
var N2 = class extends Re {
  constructor(e) {
    const { className: t = "ag-filter-apply-panel" } = e ?? {};
    super(sHe(t)), this.listeners = [], this.validationMessage = null, this.className = t;
  }
  updateButtons(e, t) {
    const o = this.buttons;
    if (this.buttons = e, o === e)
      return;
    const n = this.getGui();
    it(n);
    let s;
    this.destroyListeners();
    const i = document.createDocumentFragment(), r = this.className, l = ({ type: c, label: d }) => {
      const u = (y) => {
        this.dispatchLocalEvent({
          type: c,
          event: y
        });
      };
      ["apply", "clear", "reset", "cancel"].includes(c) || X(75);
      const h = c === "apply", C = ze({
        tag: "button",
        attrs: { type: h && t ? "submit" : "button" },
        ref: `${c}FilterButton`,
        cls: `ag-button ag-standard-button ${r}-button${h ? " " + r + "-apply-button" : ""}`,
        children: d
      });
      this.activateTabIndex([C]), h && (s = C);
      const m = (y) => {
        y.key === D.ENTER && (y.preventDefault(), u(y));
      }, w = this.listeners;
      C.addEventListener("click", u), w.push(() => C.removeEventListener("click", u)), C.addEventListener("keydown", m), w.push(() => C.removeEventListener("keydown", m)), i.append(C);
    };
    e.forEach((c) => l(c)), this.eApply = s;
    const a = this.validationTooltipFeature;
    s && !a ? this.validationTooltipFeature = this.createOptionalManagedBean(
      this.beans.registry.createDynamicBean("tooltipFeature", !1, {
        getGui: () => this.eApply,
        getLocation: () => "advancedFilter",
        getTooltipShowDelayOverride: () => 1e3
      })
    ) : !s && a && (this.validationTooltipFeature = this.destroyBean(a)), n.append(i);
  }
  getApplyButton() {
    return this.eApply;
  }
  updateValidity(e, t = null) {
    var n;
    const o = this.eApply;
    o && (qs(o, e === !1), this.validationMessage = t ?? null, (n = this.validationTooltipFeature) == null || n.setTooltipAndRefresh(this.validationMessage));
  }
  destroyListeners() {
    this.listeners.forEach((e) => e()), this.listeners = [];
  }
  destroy() {
    this.destroyListeners(), super.destroy();
  }
}, iHe = {
  selector: "AG-FILTER-BUTTON",
  component: N2
}, rHe = {
  applyFilter: "Apply",
  clearFilter: "Clear",
  resetFilter: "Reset",
  cancelFilter: "Cancel",
  textFilter: "Text Filter",
  numberFilter: "Number Filter",
  dateFilter: "Date Filter",
  setFilter: "Set Filter",
  filterOoo: "Filter...",
  empty: "Choose one",
  equals: "Equals",
  notEqual: "Does not equal",
  lessThan: "Less than",
  greaterThan: "Greater than",
  inRange: "Between",
  inRangeStart: "From",
  inRangeEnd: "To",
  lessThanOrEqual: "Less than or equal to",
  greaterThanOrEqual: "Greater than or equal to",
  contains: "Contains",
  notContains: "Does not contain",
  startsWith: "Begins with",
  endsWith: "Ends with",
  blank: "Blank",
  notBlank: "Not blank",
  before: "Before",
  after: "After",
  andCondition: "AND",
  orCondition: "OR",
  dateFormatOoo: "yyyy-mm-dd",
  filterSummaryInactive: "is (All)",
  filterSummaryContains: "contains",
  filterSummaryNotContains: "does not contain",
  filterSummaryTextEquals: "equals",
  filterSummaryTextNotEqual: "does not equal",
  filterSummaryStartsWith: "begins with",
  filterSummaryEndsWith: "ends with",
  filterSummaryBlank: "is blank",
  filterSummaryNotBlank: "is not blank",
  filterSummaryEquals: "=",
  filterSummaryNotEqual: "!=",
  filterSummaryGreaterThan: ">",
  filterSummaryGreaterThanOrEqual: ">=",
  filterSummaryLessThan: "<",
  filterSummaryLessThanOrEqual: "<=",
  filterSummaryInRange: "between",
  filterSummaryInRangeValues: (e) => `(${e[0]}, ${e[1]})`,
  filterSummaryTextQuote: (e) => `"${e[0]}"`
};
function ts(e, t, o) {
  return vw(e, rHe, t, o);
}
function z2(e, t) {
  const { debounceMs: o } = e;
  return Ca(e) ? (o != null && X(71), 0) : o ?? t;
}
function Ca(e) {
  var t;
  return (((t = e.buttons) == null ? void 0 : t.indexOf("apply")) ?? -1) >= 0;
}
var lHe = class extends Re {
  constructor(e, t, o, n, s, i) {
    super(), this.column = e, this.wrapper = t, this.eventParent = o, this.updateModel = n, this.isGlobalButtons = s, this.enableGlobalButtonCheck = i, this.hidePopup = null, this.applyActive = !1;
  }
  postConstruct() {
    const { comp: e, params: t } = this.wrapper, o = t, n = o.useForm, s = n ? "form" : "div";
    this.setTemplate({
      tag: s,
      cls: "ag-filter-wrapper"
    }), n && this.addManagedElementListeners(this.getGui(), {
      submit: (i) => {
        i == null || i.preventDefault();
      },
      keydown: this.handleKeyDown.bind(this)
    }), this.appendChild(e.getGui()), this.params = o, this.resetButtonsPanel(o), this.addManagedListeners(this.eventParent, {
      filterParamsChanged: ({ column: i, params: r }) => {
        i === this.column && this.resetButtonsPanel(r, this.params);
      },
      filterStateChanged: ({ column: i, state: r }) => {
        var l;
        i === this.column && ((l = this.eButtons) == null || l.updateValidity(r.valid !== !1));
      },
      filterAction: ({ column: i, action: r, event: l }) => {
        i === this.column && this.afterAction(r, l);
      },
      ...this.enableGlobalButtonCheck ? {
        filterGlobalButtons: ({ isGlobal: i }) => {
          if (i !== this.isGlobalButtons) {
            this.isGlobalButtons = i;
            const r = this.params;
            this.resetButtonsPanel(r, r, !0);
          }
        }
      } : void 0
    });
  }
  afterGuiAttached(e) {
    e && (this.hidePopup = e.hidePopup);
  }
  resetButtonsPanel(e, t, o) {
    const { buttons: n, readOnly: s } = t ?? {}, { buttons: i, readOnly: r, useForm: l } = e;
    if (!o && s === r && Zr(n, i))
      return;
    const a = i && i.length > 0 && !e.readOnly && !this.isGlobalButtons;
    let c = this.eButtons;
    if (a) {
      const d = i.map((u) => {
        const h = `${u}Filter`;
        return { type: u, label: ts(this, h) };
      });
      if (this.applyActive = Ca(this.params), !c) {
        c = this.createBean(new N2()), this.appendChild(c.getGui());
        const u = this.column, h = (p) => ({ event: C }) => {
          this.updateModel(u, p), this.afterAction(p, C);
        };
        c == null || c.addManagedListeners(c, {
          apply: h("apply"),
          clear: h("clear"),
          reset: h("reset"),
          cancel: h("cancel")
        }), this.eButtons = c;
      }
      c.updateButtons(d, l);
    } else
      this.applyActive = !1, c && (Kt(c.getGui()), this.eButtons = this.destroyBean(c));
  }
  close(e) {
    const t = this.hidePopup;
    if (!t)
      return;
    const o = e, n = o && o.key;
    let s;
    (n === D.ENTER || n === D.SPACE) && (s = { keyboardEvent: o }), t(s), this.hidePopup = null;
  }
  afterAction(e, t) {
    const { params: o, applyActive: n } = this, s = o == null ? void 0 : o.closeOnApply;
    switch (e) {
      case "apply": {
        t == null || t.preventDefault(), s && n && this.close(t);
        break;
      }
      case "reset": {
        s && n && this.close();
        break;
      }
      case "cancel": {
        s && this.close(t);
        break;
      }
    }
  }
  handleKeyDown(e) {
    !e.defaultPrevented && e.key === D.ENTER && this.applyActive && (this.updateModel(this.column, "apply"), this.afterAction("apply", e));
  }
  destroy() {
    this.hidePopup = null, this.eButtons = this.destroyBean(this.eButtons);
  }
}, aHe = { tag: "div", cls: "ag-filter" }, bb = class extends Re {
  constructor(e, t, o) {
    super(aHe), this.column = e, this.source = t, this.enableGlobalButtonCheck = o, this.wrapper = null;
  }
  postConstruct() {
    var e;
    (e = this.beans.colFilter) == null || e.activeFilterComps.add(this), this.createFilter(!0), this.addManagedEventListeners({ filterDestroyed: this.onFilterDestroyed.bind(this) });
  }
  hasFilter() {
    return this.wrapper != null;
  }
  getFilter() {
    var e;
    return ((e = this.wrapper) == null ? void 0 : e.then((t) => t.comp)) ?? null;
  }
  afterInit() {
    var e;
    return ((e = this.wrapper) == null ? void 0 : e.then(() => {
    })) ?? Ye.resolve();
  }
  afterGuiAttached(e) {
    var t;
    this.afterGuiAttachedParams = e, (t = this.wrapper) == null || t.then((o) => {
      var n, s, i;
      (n = this.comp) == null || n.afterGuiAttached(e), (i = (s = o == null ? void 0 : o.comp) == null ? void 0 : s.afterGuiAttached) == null || i.call(s, e);
    });
  }
  afterGuiDetached() {
    var e;
    (e = this.wrapper) == null || e.then((t) => {
      var o, n;
      (n = (o = t == null ? void 0 : t.comp) == null ? void 0 : o.afterGuiDetached) == null || n.call(o);
    });
  }
  createFilter(e) {
    const {
      column: t,
      source: o,
      beans: { colFilter: n }
    } = this, s = n.getFilterUiForDisplay(t) ?? null;
    this.wrapper = s, s == null || s.then((i) => {
      var c;
      if (!i)
        return;
      const { isHandler: r, comp: l } = i;
      let a;
      if (r) {
        const d = !!this.enableGlobalButtonCheck, u = this.createBean(
          new lHe(
            t,
            i,
            n,
            n.updateModel.bind(n),
            d && n.isGlobalButtons,
            d
          )
        );
        this.comp = u, a = u.getGui();
      } else
        a = l.getGui(), ue(a) || X(69, { guiFromFilter: a });
      this.appendChild(a), e ? this.eventSvc.dispatchEvent({
        type: "filterOpened",
        column: t,
        source: o,
        eGui: this.getGui()
      }) : (c = l.afterGuiAttached) == null || c.call(l, this.afterGuiAttachedParams);
    });
  }
  onFilterDestroyed(e) {
    const { source: t, column: o } = e;
    (t === "api" || t === "paramsUpdated") && o.getId() === this.column.getId() && this.beans.colModel.getColDefCol(this.column) && (it(this.getGui()), this.comp = this.destroyBean(this.comp), this.createFilter());
  }
  destroy() {
    var e;
    (e = this.beans.colFilter) == null || e.activeFilterComps.delete(this), this.eventSvc.dispatchEvent({
      type: "filterClosed",
      column: this.column
    }), this.wrapper = null, this.comp = this.destroyBean(this.comp), this.afterGuiAttachedParams = void 0, super.destroy();
  }
}, Bd = {
  january: "January",
  february: "February",
  march: "March",
  april: "April",
  may: "May",
  june: "June",
  july: "July",
  august: "August",
  september: "September",
  october: "October",
  november: "November",
  december: "December"
}, $d = [
  "january",
  "february",
  "march",
  "april",
  "may",
  "june",
  "july",
  "august",
  "september",
  "october",
  "november",
  "december"
];
function cHe(e, t) {
  return e == null ? -1 : t == null ? 1 : parseFloat(e) - parseFloat(t);
}
function Zd(e) {
  return e instanceof Date && !isNaN(e.getTime());
}
var l5 = {
  number: () => {
  },
  boolean: () => ({
    maxNumConditions: 1,
    debounceMs: 0,
    filterOptions: [
      "empty",
      {
        displayKey: "true",
        displayName: "True",
        predicate: (e, t) => t,
        numberOfInputs: 0
      },
      {
        displayKey: "false",
        displayName: "False",
        predicate: (e, t) => t === !1,
        numberOfInputs: 0
      }
    ]
  }),
  date: () => ({ isValidDate: Zd }),
  dateString: ({ dataTypeDefinition: e }) => ({
    comparator: (t, o) => {
      const n = e.dateParser(o);
      return o == null || n < t ? -1 : n > t ? 1 : 0;
    },
    isValidDate: (t) => typeof t == "string" && Zd(e.dateParser(t))
  }),
  dateTime: (e) => l5.date(e),
  dateTimeString: (e) => l5.dateString(e),
  object: () => {
  },
  text: () => {
  }
}, a5 = {
  number: () => ({ comparator: cHe }),
  boolean: ({ t: e }) => ({
    valueFormatter: (t) => ue(t.value) ? e(String(t.value), t.value ? "True" : "False") : e("blanks", "(Blanks)")
  }),
  date: ({ formatValue: e, t }) => ({
    valueFormatter: (o) => {
      const n = e(o);
      return ue(n) ? n : t("blanks", "(Blanks)");
    },
    treeList: !0,
    treeListFormatter: (o, n) => {
      if (o === "NaN")
        return t("invalidDate", "Invalid Date");
      if (n === 1 && o != null) {
        const s = $d[Number(o) - 1];
        return t(s, Bd[s]);
      }
      return o ?? t("blanks", "(Blanks)");
    },
    treeListPathGetter: (o) => Ci(o, !1)
  }),
  dateString: ({ formatValue: e, dataTypeDefinition: t, t: o }) => ({
    valueFormatter: (n) => {
      const s = e(n);
      return ue(s) ? s : o("blanks", "(Blanks)");
    },
    treeList: !0,
    treeListPathGetter: (n) => Ci(t.dateParser(n ?? void 0), !1),
    treeListFormatter: (n, s) => {
      if (s === 1 && n != null) {
        const i = $d[Number(n) - 1];
        return o(i, Bd[i]);
      }
      return n ?? o("blanks", "(Blanks)");
    }
  }),
  dateTime: (e) => {
    const t = a5.date(e);
    return t.treeListPathGetter = Ci, t;
  },
  dateTimeString(e) {
    const t = e.dataTypeDefinition.dateParser, o = a5.dateString(e);
    return o.treeListPathGetter = (n) => Ci(t(n ?? void 0)), o;
  },
  object: ({ formatValue: e, t }) => ({
    valueFormatter: (o) => {
      const n = e(o);
      return ue(n) ? n : t("blanks", "(Blanks)");
    }
  }),
  text: () => {
  }
};
function dHe(e, t, o, n, s, i, r) {
  let l = t, a = o;
  const c = e === "agSetColumnFilter";
  !a && n.baseDataType === "object" && !c && (a = ({ column: p, node: C }) => s({ column: p, node: C, value: i.valueSvc.getValue(p, C) }));
  const u = (c ? a5 : l5)[n.baseDataType], h = u({ dataTypeDefinition: n, formatValue: s, t: r });
  return l = typeof t == "object" ? {
    ...h,
    ...t
  } : h, { filterParams: l, filterValueGetter: a };
}
var uHe = {
  boolean: "agTextColumnFilter",
  date: "agDateColumnFilter",
  dateString: "agDateColumnFilter",
  dateTime: "agDateColumnFilter",
  dateTimeString: "agDateColumnFilter",
  number: "agNumberColumnFilter",
  object: "agTextColumnFilter",
  text: "agTextColumnFilter"
}, hHe = {
  boolean: "agTextColumnFloatingFilter",
  date: "agDateColumnFloatingFilter",
  dateString: "agDateColumnFloatingFilter",
  dateTime: "agDateColumnFloatingFilter",
  dateTimeString: "agDateColumnFloatingFilter",
  number: "agNumberColumnFloatingFilter",
  object: "agTextColumnFloatingFilter",
  text: "agTextColumnFloatingFilter"
};
function gHe(e, t = !1) {
  return (t ? hHe : uHe)[e ?? "text"];
}
var yb = "ag-resizer-wrapper", jn = (e, t) => ({
  tag: "div",
  ref: `${e}Resizer`,
  cls: `ag-resizer ag-resizer-${t}`
}), pHe = {
  tag: "div",
  cls: yb,
  children: [
    jn("eTopLeft", "topLeft"),
    jn("eTop", "top"),
    jn("eTopRight", "topRight"),
    jn("eRight", "right"),
    jn("eBottomRight", "bottomRight"),
    jn("eBottom", "bottom"),
    jn("eBottomLeft", "bottomLeft"),
    jn("eLeft", "left")
  ]
}, wa = class extends K {
  constructor(e, t) {
    super(), this.element = e, this.dragStartPosition = {
      x: 0,
      y: 0
    }, this.position = {
      x: 0,
      y: 0
    }, this.lastSize = {
      width: -1,
      height: -1
    }, this.positioned = !1, this.resizersAdded = !1, this.resizeListeners = [], this.boundaryEl = null, this.isResizing = !1, this.isMoving = !1, this.resizable = {}, this.movable = !1, this.currentResizer = null, this.config = Object.assign({}, { popup: !1 }, t);
  }
  wireBeans(e) {
    this.popupSvc = e.popupSvc, this.dragSvc = e.dragSvc;
  }
  center(e) {
    const { clientHeight: t, clientWidth: o } = this.offsetParent, n = o / 2 - this.getWidth() / 2, s = t / 2 - this.getHeight() / 2;
    this.offsetElement(n, s, e);
  }
  initialisePosition(e) {
    if (this.positioned)
      return;
    const { centered: t, forcePopupParentAsOffsetParent: o, minWidth: n, width: s, minHeight: i, height: r, x: l, y: a } = this.config;
    this.offsetParent || this.setOffsetParent();
    let c = 0, d = 0;
    const u = ro(this.element);
    if (u) {
      const h = this.findBoundaryElement(), p = window.getComputedStyle(h);
      if (p.minWidth != null) {
        const C = h.offsetWidth - this.element.offsetWidth;
        d = parseInt(p.minWidth, 10) - C;
      }
      if (p.minHeight != null) {
        const C = h.offsetHeight - this.element.offsetHeight;
        c = parseInt(p.minHeight, 10) - C;
      }
    }
    if (this.minHeight = i || c, this.minWidth = n || d, s && this.setWidth(s), r && this.setHeight(r), (!s || !r) && this.refreshSize(), t)
      this.center(e);
    else if (l || a)
      this.offsetElement(l, a, e);
    else if (u && o) {
      let h = this.boundaryEl, p = !0;
      if (h || (h = this.findBoundaryElement(), p = !1), h) {
        const C = parseFloat(h.style.top), m = parseFloat(h.style.left);
        p ? this.offsetElement(isNaN(m) ? 0 : m, isNaN(C) ? 0 : C, e) : this.setPosition(m, C);
      }
    }
    this.positioned = !!this.offsetParent;
  }
  isPositioned() {
    return this.positioned;
  }
  getPosition() {
    return this.position;
  }
  setMovable(e, t) {
    var n, s;
    if (!this.config.popup || e === this.movable)
      return;
    this.movable = e;
    const o = this.moveElementDragListener || {
      eElement: t,
      onDragStart: this.onMoveStart.bind(this),
      onDragging: this.onMove.bind(this),
      onDragStop: this.onMoveEnd.bind(this)
    };
    e ? ((n = this.dragSvc) == null || n.addDragSource(o), this.moveElementDragListener = o) : ((s = this.dragSvc) == null || s.removeDragSource(o), this.moveElementDragListener = void 0);
  }
  setResizable(e) {
    if (this.clearResizeListeners(), e ? this.addResizers() : this.removeResizers(), typeof e == "boolean") {
      if (e === !1)
        return;
      e = {
        topLeft: e,
        top: e,
        topRight: e,
        right: e,
        bottomRight: e,
        bottom: e,
        bottomLeft: e,
        left: e
      };
    }
    Object.keys(e).forEach((t) => {
      var r;
      const n = !!e[t], s = this.getResizerElement(t), i = {
        dragStartPixels: 0,
        eElement: s,
        onDragStart: (l) => this.onResizeStart(l, t),
        onDragging: this.onResize.bind(this),
        onDragStop: (l) => this.onResizeEnd(l, t)
      };
      (n || !this.isAlive() && !n) && (n ? ((r = this.dragSvc) == null || r.addDragSource(i), this.resizeListeners.push(i), s.style.pointerEvents = "all") : s.style.pointerEvents = "none", this.resizable[t] = n);
    });
  }
  removeSizeFromEl() {
    this.element.style.removeProperty("height"), this.element.style.removeProperty("width"), this.element.style.removeProperty("flex");
  }
  restoreLastSize() {
    this.element.style.flex = "0 0 auto";
    const { height: e, width: t } = this.lastSize;
    t !== -1 && (this.element.style.width = `${t}px`), e !== -1 && (this.element.style.height = `${e}px`);
  }
  getHeight() {
    return this.element.offsetHeight;
  }
  setHeight(e) {
    const { popup: t } = this.config, o = this.element;
    let n = !1;
    if (typeof e == "string" && e.indexOf("%") !== -1)
      Mr(o, e), e = b2(o), n = !0;
    else if (e = Math.max(this.minHeight, e), this.positioned) {
      const s = this.getAvailableHeight();
      s && e > s && (e = s);
    }
    this.getHeight() !== e && (n ? (o.style.maxHeight = "unset", o.style.minHeight = "unset") : t ? Mr(o, e) : (o.style.height = `${e}px`, o.style.flex = "0 0 auto", this.lastSize.height = typeof e == "number" ? e : parseFloat(e)));
  }
  getAvailableHeight() {
    const { popup: e, forcePopupParentAsOffsetParent: t } = this.config;
    this.positioned || this.initialisePosition();
    const { clientHeight: o } = this.offsetParent;
    if (!o)
      return null;
    const n = this.element.getBoundingClientRect(), s = this.offsetParent.getBoundingClientRect(), i = e ? this.position.y : n.top, r = e ? 0 : s.top;
    let l = 0;
    if (t) {
      const c = this.element.parentElement;
      if (c) {
        const { bottom: d } = c.getBoundingClientRect();
        l = d - n.bottom;
      }
    }
    return o + r - i - l;
  }
  getWidth() {
    return this.element.offsetWidth;
  }
  setWidth(e) {
    const t = this.element, { popup: o } = this.config;
    let n = !1;
    if (typeof e == "string" && e.indexOf("%") !== -1)
      rn(t, e), e = Nr(t), n = !0;
    else if (this.positioned) {
      e = Math.max(this.minWidth, e);
      const { clientWidth: s } = this.offsetParent, i = o ? this.position.x : this.element.getBoundingClientRect().left;
      s && e + i > s && (e = s - i);
    }
    this.getWidth() !== e && (n ? (t.style.maxWidth = "unset", t.style.minWidth = "unset") : this.config.popup ? rn(t, e) : (t.style.width = `${e}px`, t.style.flex = " unset", this.lastSize.width = typeof e == "number" ? e : parseFloat(e)));
  }
  offsetElement(e = 0, t = 0, o) {
    var i;
    const { forcePopupParentAsOffsetParent: n } = this.config, s = n ? this.boundaryEl : this.element;
    s && ((i = this.popupSvc) == null || i.positionPopup({
      ePopup: s,
      keepWithinBounds: !0,
      skipObserver: this.movable || this.isResizable(),
      updatePosition: () => ({ x: e, y: t }),
      postProcessCallback: o
    }), this.setPosition(parseFloat(s.style.left), parseFloat(s.style.top)));
  }
  constrainSizeToAvailableHeight(e) {
    var o, n;
    if (!this.config.forcePopupParentAsOffsetParent)
      return;
    const t = () => {
      const s = this.getAvailableHeight();
      this.element.style.setProperty("max-height", `${s}px`);
    };
    e && this.popupSvc ? ((o = this.resizeObserverSubscriber) == null || o.call(this), this.resizeObserverSubscriber = mn(
      this.beans,
      (n = this.popupSvc) == null ? void 0 : n.getPopupParent(),
      t
    )) : (this.element.style.removeProperty("max-height"), this.resizeObserverSubscriber && (this.resizeObserverSubscriber(), this.resizeObserverSubscriber = void 0));
  }
  setPosition(e, t) {
    this.position.x = e, this.position.y = t;
  }
  updateDragStartPosition(e, t) {
    this.dragStartPosition = { x: e, y: t };
  }
  calculateMouseMovement(e) {
    const { e: t, isLeft: o, isTop: n, anywhereWithin: s, topBuffer: i } = e, r = t.clientX - this.dragStartPosition.x, l = t.clientY - this.dragStartPosition.y, a = this.shouldSkipX(t, !!o, !!s, r) ? 0 : r, c = this.shouldSkipY(t, !!n, i, l) ? 0 : l;
    return { movementX: a, movementY: c };
  }
  shouldSkipX(e, t, o, n) {
    const s = this.element.getBoundingClientRect(), i = this.offsetParent.getBoundingClientRect(), r = this.boundaryEl.getBoundingClientRect(), l = this.config.popup ? this.position.x : s.left;
    let a = l <= 0 && i.left >= e.clientX || i.right <= e.clientX && i.right <= r.right;
    return a ? !0 : (t ? a = // skip if we are moving to the left and the cursor
    // is positioned to the right of the left side anchor
    n < 0 && e.clientX > l + i.left || // skip if we are moving to the right and the cursor
    // is positioned to the left of the dialog
    n > 0 && e.clientX < l + i.left : o ? a = n < 0 && e.clientX > r.right || n > 0 && e.clientX < l + i.left : a = // if the movement is bound to the right side of the dialog
    // we skip if we are moving to the left and the cursor
    // is to the right of the dialog
    n < 0 && e.clientX > r.right || // or skip if we are moving to the right and the cursor
    // is to the left of the right side anchor
    n > 0 && e.clientX < r.right, a);
  }
  shouldSkipY(e, t, o = 0, n) {
    const s = this.element.getBoundingClientRect(), i = this.offsetParent.getBoundingClientRect(), r = this.boundaryEl.getBoundingClientRect(), l = this.config.popup ? this.position.y : s.top;
    let a = l <= 0 && i.top >= e.clientY || i.bottom <= e.clientY && i.bottom <= r.bottom;
    return a ? !0 : (t ? a = // skip if we are moving to towards top and the cursor is
    // below the top anchor + topBuffer
    // note: topBuffer is used when moving the dialog using the title bar
    n < 0 && e.clientY > l + i.top + o || // skip if we are moving to the bottom and the cursor is
    // above the top anchor
    n > 0 && e.clientY < l + i.top : a = // skip if we are moving towards the top and the cursor
    // is below the bottom anchor
    n < 0 && e.clientY > r.bottom || // skip if we are moving towards the bottom and the cursor
    // is above the bottom anchor
    n > 0 && e.clientY < r.bottom, a);
  }
  createResizeMap() {
    const e = (t) => ({
      element: this.element.querySelector(`[data-ref=${t}Resizer]`)
    });
    this.resizerMap = {
      topLeft: e("eTopLeft"),
      top: e("eTop"),
      topRight: e("eTopRight"),
      right: e("eRight"),
      bottomRight: e("eBottomRight"),
      bottom: e("eBottom"),
      bottomLeft: e("eBottomLeft"),
      left: e("eLeft")
    };
  }
  addResizers() {
    if (this.resizersAdded)
      return;
    const e = this.element;
    e && (e.appendChild(ze(pHe)), this.createResizeMap(), this.resizersAdded = !0);
  }
  removeResizers() {
    this.resizerMap = void 0;
    const e = this.element.querySelector(`.${yb}`);
    e && this.element.removeChild(e), this.resizersAdded = !1;
  }
  getResizerElement(e) {
    return this.resizerMap[e].element;
  }
  onResizeStart(e, t) {
    this.boundaryEl = this.findBoundaryElement(), this.positioned || this.initialisePosition(), this.currentResizer = {
      isTop: !!t.match(/top/i),
      isRight: !!t.match(/right/i),
      isBottom: !!t.match(/bottom/i),
      isLeft: !!t.match(/left/i)
    }, this.element.classList.add("ag-resizing"), this.resizerMap[t].element.classList.add("ag-active");
    const { popup: o, forcePopupParentAsOffsetParent: n } = this.config;
    !o && !n && this.applySizeToSiblings(this.currentResizer.isBottom || this.currentResizer.isTop), this.isResizing = !0, this.updateDragStartPosition(e.clientX, e.clientY);
  }
  getSiblings() {
    const t = this.element.parentElement;
    return t ? Array.prototype.slice.call(t.children).filter((o) => !o.classList.contains("ag-hidden")) : null;
  }
  getMinSizeOfSiblings() {
    const e = this.getSiblings() || [];
    let t = 0, o = 0;
    for (let n = 0; n < e.length; n++) {
      const s = e[n], i = !!s.style.flex && s.style.flex !== "0 0 auto";
      if (s === this.element)
        continue;
      let r = this.minHeight || 0, l = this.minWidth || 0;
      if (i) {
        const a = window.getComputedStyle(s);
        a.minHeight && (r = parseInt(a.minHeight, 10)), a.minWidth && (l = parseInt(a.minWidth, 10));
      } else
        r = s.offsetHeight, l = s.offsetWidth;
      t += r, o += l;
    }
    return { height: t, width: o };
  }
  applySizeToSiblings(e) {
    let t = null;
    const o = this.getSiblings();
    if (o) {
      for (let n = 0; n < o.length; n++) {
        const s = o[n];
        s !== t && (e ? s.style.height = `${s.offsetHeight}px` : s.style.width = `${s.offsetWidth}px`, s.style.flex = "0 0 auto", s === this.element && (t = o[n + 1]));
      }
      t && (t.style.removeProperty("height"), t.style.removeProperty("min-height"), t.style.removeProperty("max-height"), t.style.flex = "1 1 auto");
    }
  }
  isResizable() {
    return Object.values(this.resizable).some((e) => e);
  }
  onResize(e) {
    if (!this.isResizing || !this.currentResizer)
      return;
    const { popup: t, forcePopupParentAsOffsetParent: o } = this.config, { isTop: n, isRight: s, isBottom: i, isLeft: r } = this.currentResizer, l = s || r, a = i || n, { movementX: c, movementY: d } = this.calculateMouseMovement({ e, isLeft: r, isTop: n }), u = this.position.x, h = this.position.y;
    let p = 0, C = 0;
    if (l && c) {
      const m = r ? -1 : 1, w = this.getWidth(), y = w + c * m;
      let b = !1;
      r && (p = w - y, (u + p <= 0 || y <= this.minWidth) && (b = !0, p = 0)), b || this.setWidth(y);
    }
    if (a && d) {
      const m = n ? -1 : 1, w = this.getHeight(), y = w + d * m;
      let b = !1;
      n ? (C = w - y, (h + C <= 0 || y <= this.minHeight) && (b = !0, C = 0)) : !this.config.popup && !this.config.forcePopupParentAsOffsetParent && w < y && this.getMinSizeOfSiblings().height + y > this.element.parentElement.offsetHeight && (b = !0), b || this.setHeight(y);
    }
    this.updateDragStartPosition(e.clientX, e.clientY), ((t || o) && p || C) && this.offsetElement(u + p, h + C);
  }
  onResizeEnd(e, t) {
    this.isResizing = !1, this.currentResizer = null, this.boundaryEl = null, this.element.classList.remove("ag-resizing"), this.resizerMap[t].element.classList.remove("ag-active"), this.dispatchLocalEvent({ type: "resize" });
  }
  refreshSize() {
    const e = this.element;
    this.config.popup && (this.config.width || this.setWidth(e.offsetWidth), this.config.height || this.setHeight(e.offsetHeight));
  }
  onMoveStart(e) {
    this.boundaryEl = this.findBoundaryElement(), this.positioned || this.initialisePosition(), this.isMoving = !0, this.element.classList.add("ag-moving"), this.updateDragStartPosition(e.clientX, e.clientY);
  }
  onMove(e) {
    if (!this.isMoving)
      return;
    const { x: t, y: o } = this.position;
    let n;
    this.config.calculateTopBuffer && (n = this.config.calculateTopBuffer());
    const { movementX: s, movementY: i } = this.calculateMouseMovement({
      e,
      isTop: !0,
      anywhereWithin: !0,
      topBuffer: n
    });
    this.offsetElement(t + s, o + i), this.updateDragStartPosition(e.clientX, e.clientY);
  }
  onMoveEnd() {
    this.isMoving = !1, this.boundaryEl = null, this.element.classList.remove("ag-moving");
  }
  setOffsetParent() {
    this.config.forcePopupParentAsOffsetParent && this.popupSvc ? this.offsetParent = this.popupSvc.getPopupParent() : this.offsetParent = this.element.offsetParent;
  }
  findBoundaryElement() {
    let e = this.element;
    for (; e; ) {
      if (window.getComputedStyle(e).position !== "static")
        return e;
      e = e.parentElement;
    }
    return this.element;
  }
  clearResizeListeners() {
    var e;
    for (; this.resizeListeners.length; ) {
      const t = this.resizeListeners.pop();
      (e = this.dragSvc) == null || e.removeDragSource(t);
    }
  }
  destroy() {
    var e;
    super.destroy(), this.moveElementDragListener && ((e = this.dragSvc) == null || e.removeDragSource(this.moveElementDragListener)), this.constrainSizeToAvailableHeight(!1), this.clearResizeListeners(), this.removeResizers();
  }
}, _b = "__ag_Grid_Stop_Propagation";
function vt(e) {
  e[_b] = !0;
}
function wo(e) {
  return e[_b] === !0;
}
var Sb = "ag-focus-managed", gs = class extends K {
  constructor(e, t = {}) {
    super(), this.eFocusable = e, this.callbacks = t, this.callbacks = {
      shouldStopEventPropagation: () => !1,
      onTabKeyDown: (o) => {
        if (o.defaultPrevented)
          return;
        const n = Yt(this.beans, this.eFocusable, !1, o.shiftKey);
        n && (n.focus(), o.preventDefault());
      },
      ...t
    };
  }
  postConstruct() {
    const {
      eFocusable: e,
      callbacks: { onFocusIn: t, onFocusOut: o }
    } = this;
    e.classList.add(Sb), this.addKeyDownListeners(e), t && this.addManagedElementListeners(e, { focusin: t }), o && this.addManagedElementListeners(e, { focusout: o });
  }
  addKeyDownListeners(e) {
    this.addManagedElementListeners(e, {
      keydown: (t) => {
        if (t.defaultPrevented || wo(t))
          return;
        const { callbacks: o } = this;
        if (o.shouldStopEventPropagation(t)) {
          vt(t);
          return;
        }
        t.key === D.TAB ? o.onTabKeyDown(t) : o.handleKeyDown && o.handleKeyDown(t);
      }
    });
  }
}, xb = class extends Re {
  constructor(e, t) {
    super(), this.filterNameKey = e, this.cssIdentifier = t, this.applyActive = !1, this.debouncePending = !1, this.defaultDebounceMs = 0;
  }
  postConstruct() {
    const e = {
      tag: "div",
      cls: `ag-filter-body-wrapper ag-${this.cssIdentifier}-body-wrapper`,
      children: [this.createBodyTemplate()]
    };
    this.setTemplate(e, this.getAgComponents()), this.createManagedBean(
      new gs(this.getFocusableElement(), {
        handleKeyDown: this.handleKeyDown.bind(this)
      })
    ), this.positionableFeature = this.createBean(
      new wa(this.getPositionableElement(), {
        forcePopupParentAsOffsetParent: !0
      })
    );
  }
  handleKeyDown(e) {
  }
  init(e) {
    const t = e;
    this.setParams(t), this.setModelIntoUi(t.state.model, !0).then(() => this.updateUiVisibility());
  }
  refresh(e) {
    const t = e, o = this.params;
    this.params = t, t.source === "colDef" && this.updateParams(t, o);
    const s = t.state, i = this.state;
    return this.state = s, (s.model !== i.model || s.state !== i.state) && this.setModelIntoUi(s.model), !0;
  }
  /** Called on init only. Override in subclasses */
  setParams(e) {
    this.params = e, this.state = e.state, this.commonUpdateParams(e);
  }
  /** Called on refresh only. Override in subclasses */
  updateParams(e, t) {
    this.commonUpdateParams(e, t);
  }
  commonUpdateParams(e, t) {
    this.applyActive = Ca(e), this.setupApplyDebounced();
  }
  /**
   * @deprecated v34 Use the same method on the filter handler (`api.getColumnFilterHandler()`) instead.
   */
  doesFilterPass(e) {
    X(283);
    const { getHandler: t, model: o, column: n } = this.params;
    return t().doesFilterPass({
      ...e,
      model: o,
      handlerParams: this.beans.colFilter.getHandlerParams(n)
    });
  }
  getFilterTitle() {
    return this.translate(this.filterNameKey);
  }
  /**
   * @deprecated v34 Filters are active when they have a model. Use `api.getColumnFilterModel()` instead.
   */
  isFilterActive() {
    return X(284), this.params.model != null;
  }
  setupApplyDebounced() {
    const e = z2(this.params, this.defaultDebounceMs), t = Rt(this, this.checkApplyDebounce.bind(this), e);
    this.applyDebounced = () => {
      this.debouncePending = !0, t();
    };
  }
  checkApplyDebounce() {
    this.debouncePending && (this.debouncePending = !1, this.doApplyModel());
  }
  /**
   * @deprecated v34 Use (`api.getColumnFilterModel()`) instead.
   */
  getModel() {
    return X(285), this.params.model;
  }
  /**
   * @deprecated v34 Use (`api.setColumnFilterModel()`) instead.
   */
  setModel(e) {
    X(286);
    const { beans: t, params: o } = this;
    return t.colFilter.setModelForColumnLegacy(o.column, e);
  }
  /**
   * Applies changes made in the UI to the filter, and returns true if the model has changed.
   */
  applyModel(e = "api") {
    return this.doApplyModel();
  }
  canApply(e) {
    return !0;
  }
  doApplyModel(e) {
    const { params: t, state: o } = this, n = !this.areModelsEqual(t.model, o.model);
    return n && t.onAction("apply", e), n;
  }
  /**
   * @deprecated v34 Internal method - should only be called by the grid.
   */
  onNewRowsLoaded() {
  }
  /**
   * By default, if the change came from a floating filter it will be applied immediately, otherwise if there is no
   * apply button it will be applied after a debounce, otherwise it will not be applied at all. This behaviour can
   * be adjusted by using the apply parameter.
   */
  onUiChanged(e, t = !1) {
    this.updateUiVisibility();
    const o = this.getModelFromUi(), n = {
      model: o,
      state: this.getState(),
      valid: this.canApply(o)
    };
    this.state = n;
    const s = this.params;
    s.onStateChange(n), s.onUiChange(this.getUiChangeEventParams()), this.gos.get("enableFilterHandlers") || this.eventSvc.dispatchEvent({
      type: "filterModified",
      column: s.column,
      filterInstance: this
    }), e ?? (e = this.applyActive ? void 0 : "debounce"), e === "immediately" ? this.doApplyModel({ afterFloatingFilter: t, afterDataChange: !1 }) : e === "debounce" && this.applyDebounced();
  }
  getState() {
  }
  getUiChangeEventParams() {
  }
  afterGuiAttached(e) {
    this.lastContainerType = e == null ? void 0 : e.container, this.refreshFilterResizer(e == null ? void 0 : e.container);
  }
  refreshFilterResizer(e) {
    const { positionableFeature: t, gos: o } = this;
    if (!t)
      return;
    const n = e === "floatingFilter" || e === "columnFilter";
    n ? (t.restoreLastSize(), t.setResizable(
      o.get("enableRtl") ? { bottom: !0, bottomLeft: !0, left: !0 } : { bottom: !0, bottomRight: !0, right: !0 }
    )) : (t.removeSizeFromEl(), t.setResizable(!1)), t.constrainSizeToAvailableHeight(n);
  }
  afterGuiDetached() {
    var e;
    this.checkApplyDebounce(), (e = this.positionableFeature) == null || e.constrainSizeToAvailableHeight(!1);
  }
  destroy() {
    this.positionableFeature = this.destroyBean(this.positionableFeature), super.destroy();
  }
  translate(e) {
    return ts(this, e);
  }
  // override to control positionable feature
  getPositionableElement() {
    return this.getGui();
  }
  areModelsEqual(e, t) {
    return e === t || e == null && t == null ? !0 : e == null || t == null ? !1 : this.areNonNullModelsEqual(e, t);
  }
};
function Mb(e) {
  return !!e.operator;
}
function fHe(e, t, o) {
  if (t == null)
    return null;
  let n = null;
  const { compName: s, jsComp: i, fwComp: r } = Xw(e, t);
  return s ? n = {
    agSetColumnFilter: "agSetColumnFloatingFilter",
    agMultiColumnFilter: "agMultiColumnFloatingFilter",
    agGroupColumnFilter: "agGroupColumnFloatingFilter",
    agNumberColumnFilter: "agNumberColumnFloatingFilter",
    agDateColumnFilter: "agDateColumnFloatingFilter",
    agTextColumnFilter: "agTextColumnFloatingFilter"
  }[s] : i == null && r == null && t.filter === !0 && (n = o()), n;
}
var Ho = {
  AUTO_HEIGHT: "ag-layout-auto-height",
  NORMAL: "ag-layout-normal",
  PRINT: "ag-layout-print"
}, j2 = class extends K {
  constructor(e) {
    super(), this.view = e;
  }
  postConstruct() {
    this.addManagedPropertyListener("domLayout", this.updateLayoutClasses.bind(this)), this.updateLayoutClasses();
  }
  updateLayoutClasses() {
    const e = this.gos.get("domLayout"), t = {
      autoHeight: e === "autoHeight",
      normal: e === "normal",
      print: e === "print"
    }, o = t.autoHeight ? Ho.AUTO_HEIGHT : t.print ? Ho.PRINT : Ho.NORMAL;
    this.view.updateLayoutClasses(o, t);
  }
}, Wn = "Viewport", Gd = "fakeVScrollComp", s0 = [
  "fakeHScrollComp",
  "centerHeader",
  "topCenter",
  "bottomCenter",
  "stickyTopCenter",
  "stickyBottomCenter"
], Nd = 100, i0 = 150, vHe = class extends K {
  constructor(e) {
    super(), this.clearRetryListenerFncs = [], this.lastScrollSource = [null, null], this.scrollLeft = -1, this.nextScrollTop = -1, this.scrollTop = -1, this.lastOffsetHeight = -1, this.lastScrollTop = -1, this.lastIsHorizontalScrollShowing = !1, this.scrollTimer = 0, this.isScrollActive = !1, this.isVerticalPositionInvalidated = !0, this.isHorizontalPositionInvalidated = !0, this.eBodyViewport = e, this.resetLastHScrollDebounced = Rt(
      this,
      () => this.lastScrollSource[
        1
        /* Horizontal */
      ] = null,
      i0
    ), this.resetLastVScrollDebounced = Rt(
      this,
      () => this.lastScrollSource[
        0
        /* Vertical */
      ] = null,
      i0
    );
  }
  wireBeans(e) {
    this.ctrlsSvc = e.ctrlsSvc, this.animationFrameSvc = e.animationFrameSvc, this.visibleCols = e.visibleCols;
  }
  destroy() {
    super.destroy(), this.clearRetryListenerFncs = [], window.clearTimeout(this.scrollTimer);
  }
  postConstruct() {
    this.enableRtl = this.gos.get("enableRtl");
    const e = this.invalidateVerticalScroll.bind(this), t = this.invalidateHorizontalScroll.bind(this);
    this.addManagedEventListeners({
      displayedColumnsWidthChanged: this.onDisplayedColumnsWidthChanged.bind(this),
      gridSizeChanged: e,
      // We only invalidate horizontal scrolling when the viewport switches
      // between scrollable and non-scrollable, avoiding unnecessary
      // invalidation on every gridSizeChanged event. If more properties
      // require invalidation, read/write DOM cycles may be needed.
      scrollGapChanged: t
    }), this.addManagedElementListeners(this.eBodyViewport, {
      scroll: e
    }), this.ctrlsSvc.whenReady(this, (o) => {
      this.centerRowsCtrl = o.center, this.onDisplayedColumnsWidthChanged(), this.addScrollListener();
    });
  }
  invalidateHorizontalScroll() {
    this.isHorizontalPositionInvalidated = !0;
  }
  invalidateVerticalScroll() {
    this.isVerticalPositionInvalidated = !0;
  }
  addScrollListener() {
    this.addHorizontalScrollListeners(), this.addVerticalScrollListeners();
  }
  addHorizontalScrollListeners() {
    this.addManagedElementListeners(this.centerRowsCtrl.eViewport, {
      scroll: this.onHScroll.bind(this, Wn)
    });
    for (const e of s0) {
      const t = this.ctrlsSvc.get(e);
      this.registerScrollPartner(t, this.onHScroll.bind(this, e));
    }
  }
  addVerticalScrollListeners() {
    const e = this.ctrlsSvc.get("fakeVScrollComp"), t = this.gos.get("debounceVerticalScrollbar"), o = t ? Rt(this, this.onVScroll.bind(this, Wn), Nd) : this.onVScroll.bind(this, Wn), n = t ? Rt(this, this.onVScroll.bind(this, Gd), Nd) : this.onVScroll.bind(this, Gd);
    this.addManagedElementListeners(this.eBodyViewport, { scroll: o }), this.registerScrollPartner(e, n);
  }
  registerScrollPartner(e, t) {
    e.onScrollCallback(t);
  }
  onDisplayedColumnsWidthChanged() {
    this.enableRtl && this.horizontallyScrollHeaderCenterAndFloatingCenter();
  }
  horizontallyScrollHeaderCenterAndFloatingCenter(e) {
    this.centerRowsCtrl != null && (e === void 0 && (e = this.centerRowsCtrl.getCenterViewportScrollLeft()), this.setScrollLeftForAllContainersExceptCurrent(Math.abs(e)));
  }
  setScrollLeftForAllContainersExceptCurrent(e) {
    for (const t of [...s0, Wn]) {
      if (this.lastScrollSource[
        1
        /* Horizontal */
      ] === t)
        continue;
      const o = this.getViewportForSource(t);
      wl(o, e, this.enableRtl);
    }
  }
  getViewportForSource(e) {
    return e === Wn ? this.centerRowsCtrl.eViewport : this.ctrlsSvc.get(e).eViewport;
  }
  isControllingScroll(e, t) {
    return this.lastScrollSource[t] == null ? (t === 0 ? this.lastScrollSource[0] = e : this.lastScrollSource[1] = e, !0) : this.lastScrollSource[t] === e;
  }
  onHScroll(e) {
    if (!this.isControllingScroll(
      e,
      1
      /* Horizontal */
    ))
      return;
    const t = this.centerRowsCtrl.eViewport, { scrollLeft: o } = t;
    if (this.shouldBlockScrollUpdate(1, o, !0))
      return;
    const n = Cl(this.getViewportForSource(e), this.enableRtl);
    this.doHorizontalScroll(n), this.resetLastHScrollDebounced();
  }
  onVScroll(e) {
    if (!this.isControllingScroll(
      e,
      0
      /* Vertical */
    ))
      return;
    let t;
    if (e === Wn ? t = this.eBodyViewport.scrollTop : t = this.ctrlsSvc.get("fakeVScrollComp").getScrollPosition(), this.shouldBlockScrollUpdate(0, t, !0))
      return;
    const { animationFrameSvc: o } = this;
    o == null || o.setScrollTop(t), this.nextScrollTop = t, e === Wn ? this.ctrlsSvc.get("fakeVScrollComp").setScrollPosition(t) : this.eBodyViewport.scrollTop = t, o != null && o.active ? o.schedule() : this.scrollGridIfNeeded(!0), this.resetLastVScrollDebounced();
  }
  doHorizontalScroll(e) {
    const t = this.ctrlsSvc.get("fakeHScrollComp").getScrollPosition();
    this.scrollLeft === e && e === t || (this.scrollLeft = e, this.fireScrollEvent(
      1
      /* Horizontal */
    ), this.horizontallyScrollHeaderCenterAndFloatingCenter(e), this.centerRowsCtrl.onHorizontalViewportChanged(!0));
  }
  isScrolling() {
    return this.isScrollActive;
  }
  fireScrollEvent(e) {
    const t = {
      type: "bodyScroll",
      direction: e === 1 ? "horizontal" : "vertical",
      left: this.scrollLeft,
      top: this.scrollTop
    };
    this.isScrollActive = !0, this.eventSvc.dispatchEvent(t), window.clearTimeout(this.scrollTimer), this.scrollTimer = window.setTimeout(() => {
      this.scrollTimer = 0, this.isScrollActive = !1, this.eventSvc.dispatchEvent({
        ...t,
        type: "bodyScrollEnd"
      });
    }, i0);
  }
  shouldBlockScrollUpdate(e, t, o = !1) {
    return o && !ss() ? !1 : e === 0 ? this.shouldBlockVerticalScroll(t) : this.shouldBlockHorizontalScroll(t);
  }
  shouldBlockVerticalScroll(e) {
    const t = ca(this.eBodyViewport), { scrollHeight: o } = this.eBodyViewport;
    return e < 0 || e + t > o;
  }
  shouldBlockHorizontalScroll(e) {
    const t = this.centerRowsCtrl.getCenterWidth(), { scrollWidth: o } = this.centerRowsCtrl.eViewport;
    if (this.enableRtl) {
      if (e > 0)
        return !0;
    } else if (e < 0)
      return !0;
    return Math.abs(e) + t > o;
  }
  redrawRowsAfterScroll() {
    this.fireScrollEvent(
      0
      /* Vertical */
    );
  }
  // this is to cater for AG-3274, where grid is removed from the dom and then inserted back in again.
  // (which happens with some implementations of tabbing). this can result in horizontal scroll getting
  // reset back to the left, however no scroll event is fired. so we need to get header to also scroll
  // back to the left to be kept in sync.
  // adding and removing the grid from the DOM both resets the scroll position and
  // triggers a resize event, so notify listeners if the scroll position has changed
  checkScrollLeft() {
    const e = this.scrollLeft;
    let t = !1;
    for (const o of s0)
      if (this.getViewportForSource(o).scrollLeft !== e) {
        t = !0;
        break;
      }
    t && this.onHScroll(Wn);
  }
  scrollGridIfNeeded(e = !1) {
    const t = this.scrollTop != this.nextScrollTop;
    return t && (this.scrollTop = this.nextScrollTop, e && this.invalidateVerticalScroll(), this.redrawRowsAfterScroll()), t;
  }
  // called by scrollHorizontally method and alignedGridsService
  setHorizontalScrollPosition(e, t = !1) {
    const n = this.centerRowsCtrl.eViewport.scrollWidth - this.centerRowsCtrl.getCenterWidth();
    !t && this.shouldBlockScrollUpdate(1, e) && (this.enableRtl ? e = e > 0 ? 0 : n : e = Math.min(Math.max(e, 0), n)), wl(this.centerRowsCtrl.eViewport, Math.abs(e), this.enableRtl), this.doHorizontalScroll(e);
  }
  setVerticalScrollPosition(e) {
    this.invalidateVerticalScroll(), this.eBodyViewport.scrollTop = e;
  }
  getVScrollPosition() {
    if (!this.isVerticalPositionInvalidated) {
      const { lastOffsetHeight: o, lastScrollTop: n } = this;
      return {
        top: n,
        bottom: n + o
      };
    }
    this.isVerticalPositionInvalidated = !1;
    const { scrollTop: e, offsetHeight: t } = this.eBodyViewport;
    return this.lastScrollTop = e, this.lastOffsetHeight = t, {
      top: e,
      bottom: e + t
    };
  }
  /** Get an approximate scroll position that returns the last real value read.
   * This is useful for avoiding repeated DOM reads that force the browser to recalculate styles.
   * This can have big performance improvements but may not be 100% accurate so only use if this is acceptable.
   */
  getApproximateVScollPosition() {
    return this.lastScrollTop >= 0 && this.lastOffsetHeight >= 0 ? {
      top: this.scrollTop,
      bottom: this.scrollTop + this.lastOffsetHeight
    } : this.getVScrollPosition();
  }
  getHScrollPosition() {
    return this.centerRowsCtrl.getHScrollPosition();
  }
  isHorizontalScrollShowing() {
    return this.isHorizontalPositionInvalidated && (this.lastIsHorizontalScrollShowing = this.centerRowsCtrl.isHorizontalScrollShowing(), this.isHorizontalPositionInvalidated = !1), this.lastIsHorizontalScrollShowing;
  }
  // called by the headerRootComp and moveColumnController
  scrollHorizontally(e) {
    const t = this.centerRowsCtrl.eViewport.scrollLeft;
    return this.setHorizontalScrollPosition(t + e), this.centerRowsCtrl.eViewport.scrollLeft - t;
  }
  // gets called by rowRenderer when new data loaded, as it will want to scroll to the top
  scrollToTop() {
    this.eBodyViewport.scrollTop = 0;
  }
  // Valid values for position are bottom, middle and top
  ensureNodeVisible(e, t = null) {
    const { rowModel: o } = this.beans, n = o.getRowCount();
    let s = -1;
    for (let i = 0; i < n; i++) {
      const r = o.getRow(i);
      if (typeof e == "function") {
        if (r && e(r)) {
          s = i;
          break;
        }
      } else if (e === r || e === r.data) {
        s = i;
        break;
      }
    }
    s >= 0 && this.ensureIndexVisible(s, t);
  }
  // Valid values for position are bottom, middle and top
  // position should be {'top','middle','bottom', or undefined/null}.
  // if undefined/null, then the grid will to the minimal amount of scrolling,
  // eg if grid needs to scroll up, it scrolls until row is on top,
  //    if grid needs to scroll down, it scrolls until row is on bottom,
  //    if row is already in view, grid does not scroll
  ensureIndexVisible(e, t, o = 0) {
    if (jt(this.gos, "print"))
      return;
    const { rowModel: n } = this.beans, s = n.getRowCount();
    if (typeof e != "number" || e < 0 || e >= s) {
      X(88, { index: e });
      return;
    }
    this.clearRetryListeners();
    const { frameworkOverrides: i, pageBounds: r, rowContainerHeight: l, rowRenderer: a } = this.beans;
    i.wrapIncoming(() => {
      var C, m;
      const c = this.ctrlsSvc.getGridBodyCtrl(), d = n.getRow(e);
      let u, h, p = 0;
      this.invalidateVerticalScroll();
      do {
        const { stickyTopHeight: w, stickyBottomHeight: y } = c, b = d.rowTop, _ = d.rowHeight, M = r.getPixelOffset(), x = d.rowTop - M, L = x + d.rowHeight, A = this.getVScrollPosition(), R = l.divStretchOffset, P = A.top + R, I = A.bottom + R, B = I - P, H = l.getScrollPositionForPixel(x), O = l.getScrollPositionForPixel(L - B), N = Math.min((H + O) / 2, x), te = P + w > x, E = I - y < L;
        let j = null;
        t === "top" ? j = H - w : t === "bottom" ? j = O + y : t === "middle" ? j = N : te ? j = H - w : E && (O - H > B ? j = H - w : j = O + y), j !== null && (this.setVerticalScrollPosition(j), a.redraw({ afterScroll: !0 })), u = b !== d.rowTop || _ !== d.rowHeight, h = w !== c.stickyTopHeight || y !== c.stickyBottomHeight, p++;
      } while ((u || h) && p < 10);
      if ((C = this.animationFrameSvc) == null || C.flushAllFrames(), o < 10 && (d != null && d.stub || !((m = this.beans.rowAutoHeight) != null && m.areRowsMeasured()))) {
        const w = this.getVScrollPosition().top;
        this.clearRetryListenerFncs = this.addManagedEventListeners({
          bodyScroll: () => {
            const y = this.getVScrollPosition().top;
            w !== y && this.clearRetryListeners();
          },
          modelUpdated: () => {
            this.clearRetryListeners(), !(e >= n.getRowCount()) && this.ensureIndexVisible(e, t, o + 1);
          }
        });
      }
    });
  }
  clearRetryListeners() {
    this.clearRetryListenerFncs.forEach((e) => e()), this.clearRetryListenerFncs = [];
  }
  ensureColumnVisible(e, t = "auto") {
    const { colModel: o, frameworkOverrides: n } = this.beans, s = o.getCol(e);
    if (!s || s.isPinned() || !this.visibleCols.isColDisplayed(s))
      return;
    const i = this.getPositionedHorizontalScroll(s, t);
    n.wrapIncoming(() => {
      var r;
      i !== null && this.centerRowsCtrl.setCenterViewportScrollLeft(i), this.centerRowsCtrl.onHorizontalViewportChanged(), (r = this.animationFrameSvc) == null || r.flushAllFrames();
    });
  }
  getPositionedHorizontalScroll(e, t) {
    const { columnBeforeStart: o, columnAfterEnd: n } = this.isColumnOutsideViewport(e), s = this.centerRowsCtrl.getCenterWidth() < e.getActualWidth(), i = this.centerRowsCtrl.getCenterWidth(), r = this.enableRtl;
    let l = (r ? o : n) || s, a = r ? n : o;
    t !== "auto" && (l = t === "start", a = t === "end");
    const c = t === "middle";
    if (l || a || c) {
      const { colLeft: d, colMiddle: u, colRight: h } = this.getColumnBounds(e);
      return c ? u - i / 2 : l ? r ? h : d : r ? d - i : h - i;
    }
    return null;
  }
  isColumnOutsideViewport(e) {
    const { start: t, end: o } = this.getViewportBounds(), { colLeft: n, colRight: s } = this.getColumnBounds(e), i = this.enableRtl, r = i ? t > s : o < s, l = i ? o < n : t > n;
    return { columnBeforeStart: r, columnAfterEnd: l };
  }
  getColumnBounds(e) {
    const t = this.enableRtl, o = this.visibleCols.bodyWidth, n = e.getActualWidth(), s = e.getLeft(), i = t ? -1 : 1, r = t ? o - s : s, l = r + n * i, a = r + n / 2 * i;
    return { colLeft: r, colMiddle: a, colRight: l };
  }
  getViewportBounds() {
    const e = this.centerRowsCtrl.getCenterWidth(), t = this.centerRowsCtrl.getCenterViewportScrollLeft(), o = t, n = e + t;
    return { start: o, end: n, width: e };
  }
}, W2 = class extends K {
  constructor(e, t = !1) {
    super(), this.callback = e, this.addSpacer = t;
  }
  postConstruct() {
    const e = this.setWidth.bind(this);
    this.addManagedPropertyListener("domLayout", e), this.addManagedEventListeners({
      columnContainerWidthChanged: e,
      displayedColumnsChanged: e,
      leftPinnedWidthChanged: e
    }), this.addSpacer && this.addManagedEventListeners({
      rightPinnedWidthChanged: e,
      scrollVisibilityChanged: e,
      scrollbarWidthChanged: e
    }), this.setWidth();
  }
  setWidth() {
    const e = jt(this.gos, "print"), { visibleCols: t, scrollVisibleSvc: o } = this.beans, n = t.bodyWidth, s = t.getColsLeftWidth(), i = t.getDisplayedColumnsRightWidth();
    let r;
    e ? r = n + s + i : (r = n, this.addSpacer && (this.gos.get("enableRtl") ? s : i) === 0 && o.verticalScrollShowing && (r += o.getScrollbarWidth())), this.callback(r);
  }
}, mHe = class extends K {
  constructor(e) {
    super(), this.centerContainerCtrl = e;
  }
  wireBeans(e) {
    this.scrollVisibleSvc = e.scrollVisibleSvc;
  }
  postConstruct() {
    this.beans.ctrlsSvc.whenReady(this, (e) => {
      this.gridBodyCtrl = e.gridBodyCtrl, this.listenForResize();
    }), this.addManagedEventListeners({ scrollbarWidthChanged: this.onScrollbarWidthChanged.bind(this) }), this.addManagedPropertyListeners(["alwaysShowHorizontalScroll", "alwaysShowVerticalScroll"], () => {
      this.checkViewportAndScrolls();
    });
  }
  listenForResize() {
    const { beans: e, centerContainerCtrl: t, gridBodyCtrl: o } = this, n = () => {
      yo(e, () => {
        this.onCenterViewportResized();
      });
    };
    t.registerViewportResizeListener(n), o.registerBodyViewportResizeListener(n);
  }
  onScrollbarWidthChanged() {
    this.checkViewportAndScrolls();
  }
  onCenterViewportResized() {
    if (this.scrollVisibleSvc.updateScrollGap(), this.centerContainerCtrl.isViewportInTheDOMTree()) {
      const { pinnedCols: e, colFlex: t } = this.beans;
      e == null || e.keepPinnedColumnsNarrowerThanViewport(), this.checkViewportAndScrolls();
      const o = this.centerContainerCtrl.getCenterWidth();
      o !== this.centerWidth && (this.centerWidth = o, t == null || t.refreshFlexedColumns({
        viewportWidth: this.centerWidth,
        updateBodyWidths: !0,
        fireResizedEvent: !0
      }));
    } else
      this.bodyHeight = 0;
  }
  // gets called every time the viewport size changes. we use this to check visibility of scrollbars
  // in the grid panel, and also to check size and position of viewport for row and column virtualisation.
  checkViewportAndScrolls() {
    this.updateScrollVisibleService(), this.checkBodyHeight(), this.onHorizontalViewportChanged(), this.gridBodyCtrl.scrollFeature.checkScrollLeft();
  }
  getBodyHeight() {
    return this.bodyHeight;
  }
  checkBodyHeight() {
    const e = this.gridBodyCtrl.eBodyViewport, t = ca(e);
    this.bodyHeight !== t && (this.bodyHeight = t, this.eventSvc.dispatchEvent({
      type: "bodyHeightChanged"
    }));
  }
  updateScrollVisibleService() {
    this.updateScrollVisibleServiceImpl(), setTimeout(this.updateScrollVisibleServiceImpl.bind(this), 500);
  }
  updateScrollVisibleServiceImpl() {
    if (!this.isAlive())
      return;
    const e = {
      horizontalScrollShowing: this.centerContainerCtrl.isHorizontalScrollShowing(),
      verticalScrollShowing: this.gridBodyCtrl.isVerticalScrollShowing()
    };
    this.scrollVisibleSvc.setScrollsVisible(e);
  }
  // this gets called whenever a change in the viewport, so we can inform column controller it has to work
  // out the virtual columns again. gets called from following locations:
  // + ensureColVisible, scroll, init, layoutChanged, displayedColumnsChanged
  onHorizontalViewportChanged() {
    const e = this.centerContainerCtrl.getCenterWidth(), t = this.centerContainerCtrl.getViewportScrollLeft();
    this.beans.colViewport.setScrollPosition(e, t);
  }
};
function K1(e, t, o, n) {
  var i;
  const s = (i = t.getColDef().cellRendererParams) == null ? void 0 : i.suppressMouseEventHandling;
  return Ab(e, t, o, n, s);
}
function CHe(e, t, o, n) {
  const s = t == null ? void 0 : t.suppressMouseEventHandling;
  return Ab(e, void 0, o, n, s);
}
function Ab(e, t, o, n, s) {
  return s ? s(
    Pe(e, {
      column: t,
      node: o,
      event: n
    })
  ) : !1;
}
function Lb(e, t, o) {
  let n = t;
  for (; n; ) {
    const s = Mw(e, n, o);
    if (s)
      return s;
    n = n.parentElement;
  }
  return null;
}
var Fl = "cellCtrl";
function U2(e, t) {
  return Lb(e, t, Fl);
}
var Tl = "renderedRow";
function wHe(e, t) {
  return Lb(e, t, Tl);
}
function c5(e, t, o, n, s) {
  const i = n ? n.getColDef().suppressKeyboardEvent : void 0;
  if (!i)
    return !1;
  const r = Pe(e, {
    event: t,
    editing: s,
    column: n,
    node: o,
    data: o.data,
    colDef: n.getColDef()
  });
  return !!(i && i(r));
}
function bHe(e) {
  const { pinnedRowModel: t, rowModel: o } = e, [n, s] = [
    (t == null ? void 0 : t.isEmpty("top")) ?? !0,
    (t == null ? void 0 : t.isEmpty("bottom")) ?? !0
  ], i = n ? null : "top";
  let r, l;
  s ? (r = null, l = o.getRowCount() - 1) : (r = "bottom", l = (t == null ? void 0 : t.getPinnedBottomRowCount()) ?? -1);
  const { visibleCols: a, rangeSvc: c } = e, d = a.allCols;
  !c || !(d != null && d.length) || c.setCellRange({
    rowStartIndex: 0,
    rowStartPinned: i,
    rowEndIndex: l,
    rowEndPinned: r
  });
}
var yHe = 65, _He = 67, SHe = 86, xHe = 68, MHe = 90, AHe = 89;
function LHe(e) {
  const { keyCode: t } = e;
  let o;
  switch (t) {
    case yHe:
      o = D.A;
      break;
    case _He:
      o = D.C;
      break;
    case SHe:
      o = D.V;
      break;
    case xHe:
      o = D.D;
      break;
    case MHe:
      o = D.Z;
      break;
    case AHe:
      o = D.Y;
      break;
    default:
      o = e.code;
  }
  return o;
}
var EHe = class extends K {
  constructor(e) {
    super(), this.element = e;
  }
  postConstruct() {
    var e;
    this.addKeyboardListeners(), this.addMouseListeners(), (e = this.beans.touchSvc) == null || e.mockRowContextMenu(this), this.editSvc = this.beans.editSvc;
  }
  addKeyboardListeners() {
    const e = "keydown", t = this.processKeyboardEvent.bind(this, e);
    this.addManagedElementListeners(this.element, { [e]: t });
  }
  addMouseListeners() {
    ["dblclick", "contextmenu", "mouseover", "mouseout", "click", gw("touchstart") ? "touchstart" : "mousedown"].forEach((o) => {
      const n = this.processMouseEvent.bind(this, o);
      this.addManagedElementListeners(this.element, { [o]: n });
    });
  }
  processMouseEvent(e, t) {
    var s;
    if (!zr(this.beans, t) || wo(t))
      return;
    const { cellCtrl: o, rowCtrl: n } = this.getControlsForEventTarget(t.target);
    e === "contextmenu" ? (o != null && o.column && o.dispatchCellContextMenuEvent(t), (s = this.beans.contextMenuSvc) == null || s.handleContextMenuMouseEvent(t, void 0, n, o)) : (o && o.onMouseEvent(e, t), n && n.onMouseEvent(e, t));
  }
  getControlsForEventTarget(e) {
    const { gos: t } = this;
    return {
      cellCtrl: U2(t, e),
      rowCtrl: wHe(t, e)
    };
  }
  processKeyboardEvent(e, t) {
    const { cellCtrl: o, rowCtrl: n } = this.getControlsForEventTarget(t.target);
    t.defaultPrevented || (o ? this.processCellKeyboardEvent(o, e, t) : n != null && n.isFullWidth() && this.processFullWidthRowKeyboardEvent(n, e, t));
  }
  processCellKeyboardEvent(e, t, o) {
    var i, r;
    const n = ((i = this.editSvc) == null ? void 0 : i.isEditing(e, { withOpenEditor: !0 })) ?? !1;
    !c5(
      this.gos,
      o,
      e.rowNode,
      e.column,
      n
    ) && t === "keydown" && (!n && ((r = this.beans.navigation) != null && r.handlePageScrollingKey(o)) || e.onKeyDown(o), this.doGridOperations(o, n), k2(o) && e.processCharacter(o)), t === "keydown" && this.eventSvc.dispatchEvent(e.createEvent(o, "cellKeyDown"));
  }
  processFullWidthRowKeyboardEvent(e, t, o) {
    const { rowNode: n } = e, { focusSvc: s, navigation: i } = this.beans, r = s.getFocusedCell(), l = r == null ? void 0 : r.column;
    if (!c5(this.gos, o, n, l, !1)) {
      const c = o.key;
      if (t === "keydown")
        switch (c) {
          case D.PAGE_HOME:
          case D.PAGE_END:
          case D.PAGE_UP:
          case D.PAGE_DOWN:
            i == null || i.handlePageScrollingKey(o, !0);
            break;
          case D.LEFT:
          case D.RIGHT:
            if (!this.gos.get("embedFullWidthRows"))
              break;
          case D.UP:
          case D.DOWN:
            e.onKeyboardNavigate(o);
            break;
          case D.TAB:
            e.onTabKeyDown(o);
            break;
        }
    }
    t === "keydown" && this.eventSvc.dispatchEvent(e.createRowEvent("cellKeyDown", o));
  }
  doGridOperations(e, t) {
    if (!e.ctrlKey && !e.metaKey || t || !zr(this.beans, e))
      return;
    const o = LHe(e), { clipboardSvc: n, undoRedo: s } = this.beans;
    if (o === D.A)
      return this.onCtrlAndA(e);
    if (o === D.C)
      return this.onCtrlAndC(n, e);
    if (o === D.D)
      return this.onCtrlAndD(n, e);
    if (o === D.V)
      return this.onCtrlAndV(n, e);
    if (o === D.X)
      return this.onCtrlAndX(n, e);
    if (o === D.Y)
      return this.onCtrlAndY(s);
    if (o === D.Z)
      return this.onCtrlAndZ(s, e);
  }
  onCtrlAndA(e) {
    const {
      beans: { rowModel: t, rangeSvc: o, selectionSvc: n },
      gos: s
    } = this;
    o && kn(s) && t.isRowsToRender() ? bHe(this.beans) : n && (n == null || n.selectAllRowNodes({ source: "keyboardSelectAll", selectAll: Fw(s) })), e.preventDefault();
  }
  onCtrlAndC(e, t) {
    var n;
    if (!e || this.gos.get("enableCellTextSelection"))
      return;
    const { cellCtrl: o } = this.getControlsForEventTarget(t.target);
    (n = this.editSvc) != null && n.isEditing(o, { withOpenEditor: !0 }) || (t.preventDefault(), e.copyToClipboard());
  }
  onCtrlAndX(e, t) {
    var n;
    if (!e || this.gos.get("enableCellTextSelection") || this.gos.get("suppressCutToClipboard"))
      return;
    const { cellCtrl: o } = this.getControlsForEventTarget(t.target);
    (n = this.editSvc) != null && n.isEditing(o, { withOpenEditor: !0 }) || (t.preventDefault(), e.cutToClipboard(void 0, "ui"));
  }
  onCtrlAndV(e, t) {
    var n;
    const { cellCtrl: o } = this.getControlsForEventTarget(t.target);
    (n = this.editSvc) != null && n.isEditing(o, { withOpenEditor: !0 }) || e && !this.gos.get("suppressClipboardPaste") && e.pasteFromClipboard();
  }
  onCtrlAndD(e, t) {
    e && !this.gos.get("suppressClipboardPaste") && e.copyRangeDown(), t.preventDefault();
  }
  onCtrlAndZ(e, t) {
    !this.gos.get("undoRedoCellEditing") || !e || (t.preventDefault(), t.shiftKey ? e.redo("ui") : e.undo("ui"));
  }
  onCtrlAndY(e) {
    e == null || e.redo("ui");
  }
}, Eb = class extends K {
  constructor(e, t) {
    super(), this.eContainer = e, this.eViewport = t;
  }
  postConstruct() {
    this.addManagedEventListeners({
      rowContainerHeightChanged: this.onHeightChanged.bind(this, this.beans.rowContainerHeight)
    });
  }
  onHeightChanged(e) {
    const t = e.uiContainerHeight, o = t != null ? `${t}px` : "";
    this.eContainer.style.height = o, this.eViewport && (this.eViewport.style.height = o);
  }
}, E1 = (e) => e.topRowCtrls, P1 = (e) => e.getStickyTopRowCtrls(), R1 = (e) => e.getStickyBottomRowCtrls(), F1 = (e) => e.bottomRowCtrls, T1 = (e) => e.allRowCtrls, r0 = (e) => e.getCtrls("top"), l0 = (e) => e.getCtrls("center"), a0 = (e) => e.getCtrls("bottom"), PHe = {
  center: {
    type: "center",
    name: "center-cols",
    getRowCtrls: T1,
    getSpannedRowCtrls: l0
  },
  left: {
    type: "left",
    name: "pinned-left-cols",
    pinnedType: "left",
    getRowCtrls: T1,
    getSpannedRowCtrls: l0
  },
  right: {
    type: "right",
    name: "pinned-right-cols",
    pinnedType: "right",
    getRowCtrls: T1,
    getSpannedRowCtrls: l0
  },
  fullWidth: {
    type: "fullWidth",
    name: "full-width",
    fullWidth: !0,
    getRowCtrls: T1
  },
  topCenter: {
    type: "center",
    name: "floating-top",
    getRowCtrls: E1,
    getSpannedRowCtrls: r0
  },
  topLeft: {
    type: "left",
    name: "pinned-left-floating",
    container: "ag-pinned-left-floating-top",
    pinnedType: "left",
    getRowCtrls: E1,
    getSpannedRowCtrls: r0
  },
  topRight: {
    type: "right",
    name: "pinned-right-floating",
    container: "ag-pinned-right-floating-top",
    pinnedType: "right",
    getRowCtrls: E1,
    getSpannedRowCtrls: r0
  },
  topFullWidth: {
    type: "fullWidth",
    name: "floating-top-full-width",
    fullWidth: !0,
    getRowCtrls: E1
  },
  stickyTopCenter: {
    type: "center",
    name: "sticky-top",
    getRowCtrls: P1
  },
  stickyTopLeft: {
    type: "left",
    name: "pinned-left-sticky-top",
    container: "ag-pinned-left-sticky-top",
    pinnedType: "left",
    getRowCtrls: P1
  },
  stickyTopRight: {
    type: "right",
    name: "pinned-right-sticky-top",
    container: "ag-pinned-right-sticky-top",
    pinnedType: "right",
    getRowCtrls: P1
  },
  stickyTopFullWidth: {
    type: "fullWidth",
    name: "sticky-top-full-width",
    fullWidth: !0,
    getRowCtrls: P1
  },
  stickyBottomCenter: {
    type: "center",
    name: "sticky-bottom",
    getRowCtrls: R1
  },
  stickyBottomLeft: {
    type: "left",
    name: "pinned-left-sticky-bottom",
    container: "ag-pinned-left-sticky-bottom",
    pinnedType: "left",
    getRowCtrls: R1
  },
  stickyBottomRight: {
    type: "right",
    name: "pinned-right-sticky-bottom",
    container: "ag-pinned-right-sticky-bottom",
    pinnedType: "right",
    getRowCtrls: R1
  },
  stickyBottomFullWidth: {
    type: "fullWidth",
    name: "sticky-bottom-full-width",
    fullWidth: !0,
    getRowCtrls: R1
  },
  bottomCenter: {
    type: "center",
    name: "floating-bottom",
    getRowCtrls: F1,
    getSpannedRowCtrls: a0
  },
  bottomLeft: {
    type: "left",
    name: "pinned-left-floating-bottom",
    container: "ag-pinned-left-floating-bottom",
    pinnedType: "left",
    getRowCtrls: F1,
    getSpannedRowCtrls: a0
  },
  bottomRight: {
    type: "right",
    name: "pinned-right-floating-bottom",
    container: "ag-pinned-right-floating-bottom",
    pinnedType: "right",
    getRowCtrls: F1,
    getSpannedRowCtrls: a0
  },
  bottomFullWidth: {
    type: "fullWidth",
    name: "floating-bottom-full-width",
    fullWidth: !0,
    getRowCtrls: F1
  }
};
function Pb(e) {
  return `ag-${h1(e).name}-viewport`;
}
function q1(e) {
  const t = h1(e);
  return t.container ?? `ag-${t.name}-container`;
}
function RHe(e) {
  return `ag-${h1(e).name}-spanned-cells-container`;
}
function h1(e) {
  return PHe[e];
}
var FHe = ["topCenter", "topLeft", "topRight"], THe = ["bottomCenter", "bottomLeft", "bottomRight"], IHe = ["center", "left", "right"], DHe = ["center", "left", "right", "fullWidth"], kHe = ["stickyTopCenter", "stickyBottomCenter", "center", "topCenter", "bottomCenter"], HHe = ["left", "bottomLeft", "topLeft", "stickyTopLeft", "stickyBottomLeft"], VHe = ["right", "bottomRight", "topRight", "stickyTopRight", "stickyBottomRight"], Rb = ["stickyTopCenter", "stickyTopLeft", "stickyTopRight"], Fb = ["stickyBottomCenter", "stickyBottomLeft", "stickyBottomRight"], OHe = [
  ...Rb,
  "stickyTopFullWidth",
  ...Fb,
  "stickyBottomFullWidth"
], BHe = [
  ...FHe,
  ...THe,
  ...IHe,
  ...Rb,
  ...Fb
], $He = class extends K {
  constructor(e) {
    super(), this.name = e, this.visible = !0, this.EMPTY_CTRLS = [], this.options = h1(e);
  }
  postConstruct() {
    this.enableRtl = this.gos.get("enableRtl"), this.forContainers(["center"], () => {
      this.viewportSizeFeature = this.createManagedBean(new mHe(this)), this.addManagedEventListeners({
        stickyTopOffsetChanged: this.onStickyTopOffsetChanged.bind(this)
      });
    });
  }
  onStickyTopOffsetChanged(e) {
    this.comp.setOffsetTop(`${e.offset}px`);
  }
  registerWithCtrlsService() {
    this.options.fullWidth || this.beans.ctrlsSvc.register(this.name, this);
  }
  forContainers(e, t) {
    e.indexOf(this.name) >= 0 && t();
  }
  setComp(e, t, o, n) {
    this.comp = e, this.eContainer = t, this.eSpannedContainer = o, this.eViewport = n, this.createManagedBean(new EHe(this.eViewport ?? this.eContainer)), this.addPreventScrollWhileDragging(), this.listenOnDomOrder();
    const { pinnedCols: s, rangeSvc: i } = this.beans, r = () => this.onPinnedWidthChanged();
    this.forContainers(HHe, () => {
      this.pinnedWidthFeature = this.createOptionalManagedBean(
        s == null ? void 0 : s.createPinnedWidthFeature(!0, this.eContainer, this.eSpannedContainer)
      ), this.addManagedEventListeners({ leftPinnedWidthChanged: r });
    }), this.forContainers(VHe, () => {
      this.pinnedWidthFeature = this.createOptionalManagedBean(
        s == null ? void 0 : s.createPinnedWidthFeature(!1, this.eContainer, this.eSpannedContainer)
      ), this.addManagedEventListeners({ rightPinnedWidthChanged: r });
    }), this.forContainers(
      DHe,
      () => this.createManagedBean(
        new Eb(this.eContainer, this.name === "center" ? n : void 0)
      )
    ), i && this.forContainers(
      BHe,
      () => this.createManagedBean(i.createDragListenerFeature(this.eContainer))
    ), this.forContainers(
      kHe,
      () => this.createManagedBean(new W2((l) => this.comp.setContainerWidth(`${l}px`)))
    ), this.visible = this.isContainerVisible(), this.addListeners(), this.registerWithCtrlsService();
  }
  onScrollCallback(e) {
    this.addManagedElementListeners(this.eViewport, { scroll: e });
  }
  addListeners() {
    const { spannedRowRenderer: e, gos: t } = this.beans, o = this.onDisplayedColumnsChanged.bind(this);
    this.addManagedEventListeners({
      displayedColumnsChanged: o,
      displayedColumnsWidthChanged: o,
      displayedRowsChanged: (n) => this.onDisplayedRowsChanged(n.afterScroll)
    }), o(), this.onDisplayedRowsChanged(), e && this.options.getSpannedRowCtrls && t.get("enableCellSpan") && this.addManagedListeners(e, {
      spannedRowsUpdated: () => {
        const n = this.options.getSpannedRowCtrls(e);
        n && this.comp.setSpannedRowCtrls(n, !1);
      }
    });
  }
  listenOnDomOrder() {
    if (OHe.indexOf(this.name) >= 0) {
      this.comp.setDomOrder(!0);
      return;
    }
    const t = () => {
      const o = this.gos.get("ensureDomOrder"), n = jt(this.gos, "print");
      this.comp.setDomOrder(o || n);
    };
    this.addManagedPropertyListener("domLayout", t), t();
  }
  onDisplayedColumnsChanged() {
    this.forContainers(["center"], () => this.onHorizontalViewportChanged());
  }
  // this methods prevents the grid views from being scrolled while the dragService is being used
  // eg. the view should not scroll up and down while dragging rows using the rowDragComp.
  addPreventScrollWhileDragging() {
    const { dragSvc: e } = this.beans;
    if (!e)
      return;
    const t = (o) => {
      e.dragging && o.cancelable && o.preventDefault();
    };
    this.eContainer.addEventListener("touchmove", t, { passive: !1 }), this.addDestroyFunc(() => this.eContainer.removeEventListener("touchmove", t));
  }
  // this gets called whenever a change in the viewport, so we can inform column controller it has to work
  // out the virtual columns again. gets called from following locations:
  // + ensureColVisible, scroll, init, layoutChanged, displayedColumnsChanged
  onHorizontalViewportChanged(e = !1) {
    const t = this.getCenterWidth(), o = this.getCenterViewportScrollLeft();
    this.beans.colViewport.setScrollPosition(t, o, e);
  }
  hasHorizontalScrollGap() {
    return this.eContainer.clientWidth - this.eViewport.clientWidth < 0;
  }
  hasVerticalScrollGap() {
    return this.eContainer.clientHeight - this.eViewport.clientHeight < 0;
  }
  getCenterWidth() {
    return Bi(this.eViewport);
  }
  getCenterViewportScrollLeft() {
    return Cl(this.eViewport, this.enableRtl);
  }
  registerViewportResizeListener(e) {
    const t = mn(this.beans, this.eViewport, e);
    this.addDestroyFunc(() => t());
  }
  isViewportInTheDOMTree() {
    return aw(this.eViewport);
  }
  getViewportScrollLeft() {
    return Cl(this.eViewport, this.enableRtl);
  }
  isHorizontalScrollShowing() {
    return this.gos.get("alwaysShowHorizontalScroll") || _2(this.eViewport);
  }
  setHorizontalScroll(e) {
    this.comp.setHorizontalScroll(e);
  }
  getHScrollPosition() {
    return {
      left: this.eViewport.scrollLeft,
      right: this.eViewport.scrollLeft + this.eViewport.offsetWidth
    };
  }
  setCenterViewportScrollLeft(e) {
    wl(this.eViewport, e, this.enableRtl);
  }
  isContainerVisible() {
    return !(this.options.pinnedType != null) || !!this.pinnedWidthFeature && this.pinnedWidthFeature.getWidth() > 0;
  }
  onPinnedWidthChanged() {
    const e = this.isContainerVisible();
    this.visible != e && (this.visible = e, this.onDisplayedRowsChanged());
  }
  onDisplayedRowsChanged(e = !1) {
    const t = this.options.getRowCtrls(this.beans.rowRenderer);
    if (!this.visible || t.length === 0) {
      this.comp.setRowCtrls({ rowCtrls: this.EMPTY_CTRLS });
      return;
    }
    const o = jt(this.gos, "print"), s = this.gos.get("embedFullWidthRows") || o, i = t.filter((r) => {
      const l = r.isFullWidth();
      return this.options.fullWidth ? !s && l : s || !l;
    });
    this.comp.setRowCtrls({ rowCtrls: i, useFlushSync: e });
  }
}, Tb = "ag-force-vertical-scroll", ZHe = "ag-selectable", GHe = "ag-column-moving", NHe = class extends K {
  constructor() {
    super(...arguments), this.stickyTopHeight = 0, this.stickyBottomHeight = 0;
  }
  wireBeans(e) {
    this.ctrlsSvc = e.ctrlsSvc, this.colModel = e.colModel, this.scrollVisibleSvc = e.scrollVisibleSvc, this.pinnedRowModel = e.pinnedRowModel, this.filterManager = e.filterManager, this.rowGroupColsSvc = e.rowGroupColsSvc;
  }
  setComp(e, t, o, n, s, i, r) {
    var l, a;
    this.comp = e, this.eGridBody = t, this.eBodyViewport = o, this.eTop = n, this.eBottom = s, this.eStickyTop = i, this.eStickyBottom = r, this.eCenterColsViewport = o.querySelector(`.${Pb("center")}`), this.eFullWidthContainer = o.querySelector(`.${q1("fullWidth")}`), this.eStickyTopFullWidthContainer = i.querySelector(
      `.${q1("stickyTopFullWidth")}`
    ), this.eStickyBottomFullWidthContainer = r.querySelector(
      `.${q1("stickyBottomFullWidth")}`
    ), this.setCellTextSelection(this.gos.get("enableCellTextSelection")), this.addManagedPropertyListener(
      "enableCellTextSelection",
      (c) => this.setCellTextSelection(c.currentValue)
    ), this.createManagedBean(new j2(this.comp)), this.scrollFeature = this.createManagedBean(new vHe(o)), (l = this.beans.rowDragSvc) == null || l.setupRowDrag(o, this), this.setupRowAnimationCssClass(), this.addEventListeners(), this.addFocusListeners([n, o, s, i, r]), this.setGridRootRole(), this.onGridColumnsChanged(), this.addBodyViewportListener(), this.setFloatingHeights(), this.disableBrowserDragging(), this.addStopEditingWhenGridLosesFocus(), this.updateScrollingClasses(), (a = this.filterManager) == null || a.setupAdvFilterHeaderComp(n), this.ctrlsSvc.register("gridBodyCtrl", this);
  }
  addEventListeners() {
    const e = this.setFloatingHeights.bind(this), t = this.setGridRootRole.bind(this), o = this.toggleRowResizeStyles.bind(this);
    this.addManagedEventListeners({
      gridColumnsChanged: this.onGridColumnsChanged.bind(this),
      scrollVisibilityChanged: this.onScrollVisibilityChanged.bind(this),
      scrollGapChanged: this.updateScrollingClasses.bind(this),
      pinnedRowDataChanged: e,
      pinnedHeightChanged: e,
      pinnedRowsChanged: e,
      headerHeightChanged: this.setStickyTopOffsetTop.bind(this),
      columnRowGroupChanged: t,
      columnPivotChanged: t,
      rowResizeStarted: o,
      rowResizeEnded: o
    }), this.addManagedPropertyListener("treeData", t);
  }
  toggleRowResizeStyles(e) {
    const t = e.type === "rowResizeStarted";
    this.eBodyViewport.classList.toggle("ag-prevent-animation", t);
  }
  onGridColumnsChanged() {
    const e = this.beans.colModel.getCols();
    this.comp.setColumnCount(e.length);
  }
  onScrollVisibilityChanged() {
    const { scrollVisibleSvc: e } = this, t = e.verticalScrollShowing;
    this.setVerticalScrollPaddingVisible(t), this.setStickyWidth(t), this.setStickyBottomOffsetBottom();
    const o = t && e.getScrollbarWidth() || 0, n = ob() ? 16 : 0, s = `calc(100% + ${o + n}px)`;
    yo(this.beans, () => this.comp.setBodyViewportWidth(s)), this.updateScrollingClasses();
  }
  setGridRootRole() {
    const { rowGroupColsSvc: e, colModel: t } = this;
    let o = this.gos.get("treeData");
    if (!o) {
      const n = t.isPivotMode();
      o = (e ? e.columns.length : 0) >= (n ? 2 : 1);
    }
    this.comp.setGridRootRole(o ? "treegrid" : "grid");
  }
  addFocusListeners(e) {
    e.forEach((t) => {
      this.addManagedElementListeners(t, {
        focusin: (o) => {
          const { target: n } = o, s = ks(n, "ag-root", t);
          t.classList.toggle("ag-has-focus", !s);
        },
        focusout: (o) => {
          const { target: n, relatedTarget: s } = o, i = t.contains(s), r = ks(
            s,
            "ag-root",
            t
          );
          ks(n, "ag-root", t) || (!i || r) && t.classList.remove("ag-has-focus");
        }
      });
    });
  }
  // used by ColumnAnimationService
  setColumnMovingCss(e) {
    this.comp.setColumnMovingCss(GHe, e);
  }
  setCellTextSelection(e = !1) {
    this.comp.setCellSelectableCss(ZHe, e);
  }
  updateScrollingClasses() {
    const {
      eGridBody: { classList: e },
      scrollVisibleSvc: t
    } = this;
    e.toggle("ag-body-vertical-content-no-gap", !t.verticalScrollGap), e.toggle("ag-body-horizontal-content-no-gap", !t.horizontalScrollGap);
  }
  // if we do not do this, then the user can select a pic in the grid (eg an image in a custom cell renderer)
  // and then that will start the browser native drag n' drop, which messes up with our own drag and drop.
  disableBrowserDragging() {
    this.addManagedElementListeners(this.eGridBody, {
      dragstart: (e) => {
        if (e.target instanceof HTMLImageElement)
          return e.preventDefault(), !1;
      }
    });
  }
  addStopEditingWhenGridLosesFocus() {
    var e;
    (e = this.beans.editSvc) == null || e.addStopEditingWhenGridLosesFocus([
      this.eBodyViewport,
      this.eBottom,
      this.eTop,
      this.eStickyTop,
      this.eStickyBottom
    ]);
  }
  updateRowCount() {
    var s, i;
    const e = (((s = this.ctrlsSvc.getHeaderRowContainerCtrl()) == null ? void 0 : s.getRowCount()) ?? 0) + (((i = this.filterManager) == null ? void 0 : i.getHeaderRowCount()) ?? 0), { rowModel: t } = this.beans, o = t.isLastRowIndexKnown() ? t.getRowCount() : -1, n = o === -1 ? -1 : e + o;
    this.comp.setRowCount(n);
  }
  registerBodyViewportResizeListener(e) {
    this.comp.registerBodyViewportResizeListener(e);
  }
  setVerticalScrollPaddingVisible(e) {
    const t = e ? "scroll" : "hidden";
    this.comp.setPinnedTopBottomOverflowY(t);
  }
  isVerticalScrollShowing() {
    const e = this.gos.get("alwaysShowVerticalScroll"), t = e ? Tb : null, o = jt(this.gos, "normal");
    return this.comp.setAlwaysVerticalScrollClass(t, e), e || o && uw(this.eBodyViewport);
  }
  setupRowAnimationCssClass() {
    const { rowContainerHeight: e, environment: t } = this.beans;
    let o = t.sizesMeasured;
    const n = () => {
      const s = o && Ei(this.gos) && !e.stretching, i = s ? "ag-row-animation" : "ag-row-no-animation";
      this.comp.setRowAnimationCssOnBodyViewport(i, s);
    };
    n(), this.addManagedEventListeners({ heightScaleChanged: n }), this.addManagedPropertyListener("animateRows", n), this.addManagedEventListeners({
      gridStylesChanged: () => {
        !o && t.sizesMeasured && (o = !0, n());
      }
    });
  }
  addBodyViewportListener() {
    const {
      eBodyViewport: e,
      eStickyTop: t,
      eStickyBottom: o,
      eTop: n,
      eBottom: s,
      beans: { popupSvc: i, touchSvc: r }
    } = this, l = this.onBodyViewportContextMenu.bind(this);
    this.addManagedElementListeners(e, { contextmenu: l }), r == null || r.mockBodyContextMenu(this, l), this.addManagedElementListeners(e, {
      wheel: this.onBodyViewportWheel.bind(this, i)
    });
    const a = this.onStickyWheel.bind(this);
    for (const d of [t, o, n, s])
      this.addManagedElementListeners(d, { wheel: a });
    const c = this.onHorizontalWheel.bind(this);
    for (const d of ["left", "right", "topLeft", "topRight", "bottomLeft", "bottomRight"])
      this.addManagedElementListeners(this.ctrlsSvc.get(d).eContainer, {
        wheel: c
      });
    this.addFullWidthContainerWheelListener();
  }
  addFullWidthContainerWheelListener() {
    this.addManagedElementListeners(this.eFullWidthContainer, {
      wheel: (e) => this.onFullWidthContainerWheel(e)
    });
  }
  onFullWidthContainerWheel(e) {
    const { deltaX: t, deltaY: o, shiftKey: n } = e;
    (n || Math.abs(t) > Math.abs(o)) && zr(this.beans, e) && this.scrollGridBodyToMatchEvent(e);
  }
  onStickyWheel(e) {
    const { deltaY: t } = e;
    this.scrollVertically(t) > 0 && e.preventDefault();
  }
  onHorizontalWheel(e) {
    const { deltaX: t, deltaY: o, shiftKey: n } = e;
    (n || Math.abs(t) > Math.abs(o)) && this.scrollGridBodyToMatchEvent(e);
  }
  scrollGridBodyToMatchEvent(e) {
    const { deltaX: t, deltaY: o } = e;
    e.preventDefault(), this.eCenterColsViewport.scrollBy({ left: t || o });
  }
  onBodyViewportContextMenu(e, t, o) {
    var s;
    if (!e && !o)
      return;
    this.gos.get("preventDefaultOnContextMenu") && (e || o).preventDefault();
    const { target: n } = e || t;
    (n === this.eBodyViewport || n === this.ctrlsSvc.get("center").eViewport) && ((s = this.beans.contextMenuSvc) == null || s.showContextMenu({
      mouseEvent: e,
      touchEvent: o,
      value: null,
      anchorToElement: this.eGridBody,
      source: "ui"
    }));
  }
  onBodyViewportWheel(e, t) {
    this.gos.get("suppressScrollWhenPopupsAreOpen") && e != null && e.hasAnchoredPopup() && t.preventDefault();
  }
  // called by rowDragFeature
  scrollVertically(e) {
    const t = this.eBodyViewport.scrollTop;
    return this.scrollFeature.setVerticalScrollPosition(t + e), this.eBodyViewport.scrollTop - t;
  }
  setFloatingHeights() {
    const {
      pinnedRowModel: e,
      beans: { environment: t }
    } = this, o = e == null ? void 0 : e.getPinnedTopTotalHeight(), n = e == null ? void 0 : e.getPinnedBottomTotalHeight(), s = t.getPinnedRowBorderWidth(), i = t.getRowBorderWidth(), r = s - i, l = o ? r + o : 0, a = n ? r + n : 0;
    this.comp.setTopHeight(l), this.comp.setBottomHeight(a), this.comp.setTopInvisible(l <= 0), this.comp.setBottomInvisible(a <= 0), this.setStickyTopOffsetTop(), this.setStickyBottomOffsetBottom();
  }
  setStickyTopHeight(e = 0) {
    this.comp.setStickyTopHeight(`${e}px`), this.stickyTopHeight = e;
  }
  setStickyBottomHeight(e = 0) {
    this.comp.setStickyBottomHeight(`${e}px`), this.stickyBottomHeight = e;
  }
  setStickyWidth(e) {
    if (!e)
      this.comp.setStickyTopWidth("100%"), this.comp.setStickyBottomWidth("100%");
    else {
      const t = this.scrollVisibleSvc.getScrollbarWidth();
      this.comp.setStickyTopWidth(`calc(100% - ${t}px)`), this.comp.setStickyBottomWidth(`calc(100% - ${t}px)`);
    }
  }
  setStickyTopOffsetTop() {
    var s, i;
    const t = this.ctrlsSvc.get("gridHeaderCtrl").headerHeight + (((s = this.filterManager) == null ? void 0 : s.getHeaderHeight()) ?? 0), o = ((i = this.pinnedRowModel) == null ? void 0 : i.getPinnedTopTotalHeight()) ?? 0;
    let n = 0;
    t > 0 && (n += t), o > 0 && (n += o), n > 0 && (n += 1), this.comp.setStickyTopTop(`${n}px`);
  }
  setStickyBottomOffsetBottom() {
    const { pinnedRowModel: e, scrollVisibleSvc: t, comp: o } = this, n = (e == null ? void 0 : e.getPinnedBottomTotalHeight()) ?? 0, i = t.horizontalScrollShowing && t.getScrollbarWidth() || 0, r = n + i;
    o.setStickyBottomBottom(`${r}px`);
  }
};
function zHe(e, t) {
  var o;
  return ((o = U2(e, t.target)) == null ? void 0 : o.getFocusedCellPosition()) ?? null;
}
function zd(e, t) {
  const o = jt(e.gos, "normal"), n = t;
  let s, i;
  n.clientX != null || n.clientY != null ? (s = n.clientX, i = n.clientY) : (s = n.x, i = n.y);
  const { pageFirstPixel: r } = e.pageBounds.getCurrentPagePixelRange();
  if (i += r, o) {
    const l = e.ctrlsSvc.getScrollFeature(), a = l.getVScrollPosition(), c = l.getHScrollPosition();
    s += c.left, i += a.top;
  }
  return { x: s, y: i };
}
var Ib = class extends Re {
  constructor(e, t) {
    super(), this.direction = t, this.eViewport = J, this.eContainer = J, this.hideTimeout = 0, this.setTemplate(e);
  }
  postConstruct() {
    this.addManagedEventListeners({
      scrollVisibilityChanged: this.onScrollVisibilityChanged.bind(this)
    }), this.onScrollVisibilityChanged(), this.toggleCss("ag-apple-scrollbar", eb() || ss());
  }
  destroy() {
    super.destroy(), window.clearTimeout(this.hideTimeout);
  }
  initialiseInvisibleScrollbar() {
    this.invisibleScrollbar === void 0 && (this.invisibleScrollbar = ob(), this.invisibleScrollbar && (this.hideAndShowInvisibleScrollAsNeeded(), this.addActiveListenerToggles()));
  }
  addActiveListenerToggles() {
    const e = this.getGui(), t = () => this.toggleCss("ag-scrollbar-active", !0), o = () => this.toggleCss("ag-scrollbar-active", !1);
    this.addManagedListeners(e, {
      mouseenter: t,
      mousedown: t,
      touchstart: t,
      mouseleave: o,
      touchend: o
    });
  }
  onScrollVisibilityChanged() {
    this.invisibleScrollbar === void 0 && this.initialiseInvisibleScrollbar(), yo(this.beans, () => this.setScrollVisible());
  }
  hideAndShowInvisibleScrollAsNeeded() {
    this.addManagedEventListeners({
      bodyScroll: (e) => {
        e.direction === this.direction && (this.hideTimeout && (window.clearTimeout(this.hideTimeout), this.hideTimeout = 0), this.toggleCss("ag-scrollbar-scrolling", !0));
      },
      bodyScrollEnd: () => {
        this.hideTimeout = window.setTimeout(() => {
          this.toggleCss("ag-scrollbar-scrolling", !1), this.hideTimeout = 0;
        }, 400);
      }
    });
  }
  attemptSettingScrollPosition(e) {
    const t = this.eViewport;
    mw(
      this,
      () => ro(t),
      () => this.setScrollPosition(e),
      100
    );
  }
  onScrollCallback(e) {
    this.addManagedElementListeners(this.eViewport, { scroll: e });
  }
}, jHe = {
  tag: "div",
  cls: "ag-body-horizontal-scroll",
  attrs: { "aria-hidden": "true" },
  children: [
    { tag: "div", ref: "eLeftSpacer", cls: "ag-horizontal-left-spacer" },
    {
      tag: "div",
      ref: "eViewport",
      cls: "ag-body-horizontal-scroll-viewport",
      children: [{ tag: "div", ref: "eContainer", cls: "ag-body-horizontal-scroll-container" }]
    },
    { tag: "div", ref: "eRightSpacer", cls: "ag-horizontal-right-spacer" }
  ]
}, WHe = class extends Ib {
  constructor() {
    super(jHe, "horizontal"), this.eLeftSpacer = J, this.eRightSpacer = J, this.setScrollVisibleDebounce = 0;
  }
  wireBeans(e) {
    this.visibleCols = e.visibleCols, this.scrollVisibleSvc = e.scrollVisibleSvc;
  }
  postConstruct() {
    super.postConstruct();
    const e = this.setFakeHScrollSpacerWidths.bind(this);
    this.addManagedEventListeners({
      displayedColumnsChanged: e,
      displayedColumnsWidthChanged: e,
      pinnedRowDataChanged: this.refreshCompBottom.bind(this)
    }), this.addManagedPropertyListener("domLayout", e), this.beans.ctrlsSvc.register("fakeHScrollComp", this), this.createManagedBean(new W2((t) => this.eContainer.style.width = `${t}px`)), this.addManagedPropertyListeners(["suppressHorizontalScroll"], this.onScrollVisibilityChanged.bind(this));
  }
  destroy() {
    window.clearTimeout(this.setScrollVisibleDebounce), super.destroy();
  }
  initialiseInvisibleScrollbar() {
    this.invisibleScrollbar === void 0 && (this.enableRtl = this.gos.get("enableRtl"), super.initialiseInvisibleScrollbar(), this.invisibleScrollbar && this.refreshCompBottom());
  }
  refreshCompBottom() {
    var t;
    if (!this.invisibleScrollbar)
      return;
    const e = ((t = this.beans.pinnedRowModel) == null ? void 0 : t.getPinnedBottomTotalHeight()) ?? 0;
    this.getGui().style.bottom = `${e}px`;
  }
  onScrollVisibilityChanged() {
    super.onScrollVisibilityChanged(), this.setFakeHScrollSpacerWidths();
  }
  setFakeHScrollSpacerWidths() {
    const e = this.scrollVisibleSvc.verticalScrollShowing;
    let t = this.visibleCols.getDisplayedColumnsRightWidth();
    const o = !this.enableRtl && e, n = this.scrollVisibleSvc.getScrollbarWidth();
    o && (t += n), rn(this.eRightSpacer, t), this.eRightSpacer.classList.toggle("ag-scroller-corner", t <= n);
    let s = this.visibleCols.getColsLeftWidth();
    this.enableRtl && e && (s += n), rn(this.eLeftSpacer, s), this.eLeftSpacer.classList.toggle("ag-scroller-corner", s <= n);
  }
  setScrollVisible() {
    const e = this.scrollVisibleSvc.horizontalScrollShowing, t = this.invisibleScrollbar, o = this.gos.get("suppressHorizontalScroll"), n = e && this.scrollVisibleSvc.getScrollbarWidth() || 0, i = o ? 0 : n === 0 && t ? 16 : n, r = () => {
      this.setScrollVisibleDebounce = 0, this.toggleCss("ag-scrollbar-invisible", t), Mr(this.getGui(), i), Mr(this.eViewport, i), Mr(this.eContainer, i), i || this.eContainer.style.setProperty("min-height", "1px"), this.setVisible(e, { skipAriaHidden: !0 });
    };
    window.clearTimeout(this.setScrollVisibleDebounce), e ? this.setScrollVisibleDebounce = window.setTimeout(r, 100) : r();
  }
  getScrollPosition() {
    return Cl(this.eViewport, this.enableRtl);
  }
  setScrollPosition(e) {
    ro(this.eViewport) || this.attemptSettingScrollPosition(e), wl(this.eViewport, e, this.enableRtl);
  }
}, UHe = {
  selector: "AG-FAKE-HORIZONTAL-SCROLL",
  component: WHe
}, KHe = {
  tag: "div",
  cls: "ag-body-vertical-scroll",
  attrs: { "aria-hidden": "true" },
  children: [
    {
      tag: "div",
      ref: "eViewport",
      cls: "ag-body-vertical-scroll-viewport",
      children: [{ tag: "div", ref: "eContainer", cls: "ag-body-vertical-scroll-container" }]
    }
  ]
}, qHe = class extends Ib {
  constructor() {
    super(KHe, "vertical");
  }
  postConstruct() {
    super.postConstruct(), this.createManagedBean(new Eb(this.eContainer));
    const { ctrlsSvc: e } = this.beans;
    e.register("fakeVScrollComp", this), this.addManagedEventListeners({
      rowContainerHeightChanged: this.onRowContainerHeightChanged.bind(this, e)
    });
  }
  setScrollVisible() {
    const { scrollVisibleSvc: e } = this.beans, t = e.verticalScrollShowing, o = this.invisibleScrollbar, n = t && e.getScrollbarWidth() || 0, s = n === 0 && o ? 16 : n;
    this.toggleCss("ag-scrollbar-invisible", o), rn(this.getGui(), s), rn(this.eViewport, s), rn(this.eContainer, s), this.setDisplayed(t, { skipAriaHidden: !0 });
  }
  onRowContainerHeightChanged(e) {
    const o = e.getGridBodyCtrl().eBodyViewport, n = this.getScrollPosition(), s = o.scrollTop;
    n != s && this.setScrollPosition(s, !0);
  }
  getScrollPosition() {
    return this.eViewport.scrollTop;
  }
  setScrollPosition(e, t) {
    !t && !ro(this.eViewport) && this.attemptSettingScrollPosition(e), this.eViewport.scrollTop = e;
  }
}, YHe = {
  selector: "AG-FAKE-VERTICAL-SCROLL",
  component: qHe
}, QHe = "ag-column-first", JHe = "ag-column-last";
function Db(e, t, o, n) {
  return Xe(e) ? [] : Vb(e.headerClass, e, t, o, n);
}
function kb(e, t, o, n) {
  return Xe(e) ? [] : Vb(e.toolPanelClass, e, t, o, n);
}
function Hb(e, t, o) {
  e.toggleCss(QHe, o.isColAtEdge(t, "first")), e.toggleCss(JHe, o.isColAtEdge(t, "last"));
}
function XHe(e, t, o, n) {
  return Pe(t, {
    // bad naming, as colDef here can be a group or a column,
    // however most people won't appreciate the difference,
    // so keeping it as colDef to avoid confusion.
    colDef: e,
    column: o,
    columnGroup: n
  });
}
function Vb(e, t, o, n, s) {
  if (Xe(e))
    return [];
  let i;
  if (typeof e == "function") {
    const r = XHe(t, o, n, s);
    i = e(r);
  } else
    i = e;
  return typeof i == "string" ? [i] : Array.isArray(i) ? [...i] : [];
}
function Ob(e, t, o) {
  t.addManagedElementListeners(o, {
    keydown: (n) => {
      if (!n.defaultPrevented && n.key === D.TAB) {
        const s = n.shiftKey;
        Yt(e, o, !1, s) || fn(e, s) && n.preventDefault();
      }
    }
  });
}
function eVe(e, t) {
  return e.ctrlsSvc.get("gridCtrl").focusInnerElement(t);
}
function $s(e) {
  var t;
  return e.gos.get("suppressHeaderFocus") || !!((t = e.overlays) != null && t.isExclusive());
}
function ba(e) {
  var t;
  return e.gos.get("suppressCellFocus") || !!((t = e.overlays) != null && t.isExclusive());
}
function fn(e, t, o = !1) {
  const n = e.ctrlsSvc.get("gridCtrl");
  return !o && n.focusNextInnerContainer(t) ? !0 : ((o || !t && !n.isDetailGrid()) && n.forceFocusOutOfContainer(t), !1);
}
function nn(e) {
  var t;
  return ((t = e.ctrlsSvc.getHeaderRowContainerCtrl()) == null ? void 0 : t.getRowCount()) ?? 0;
}
function K2(e) {
  const t = [], o = e.ctrlsSvc.getHeaderRowContainerCtrls();
  for (const n of o) {
    if (!n)
      continue;
    const s = n.getGroupRowCount() || 0;
    for (let i = 0; i < s; i++) {
      const r = n.getGroupRowCtrlAtIndex(i), l = t[i];
      if (r) {
        const a = tVe(e, r);
        (l == null || a > l) && (t[i] = a);
      }
    }
  }
  return t;
}
function tVe(e, t) {
  let n = e.colModel.isPivotMode() ? nVe(e) : Bb(e);
  const s = t.getHeaderCellCtrls();
  for (const i of s) {
    const { column: r } = i, l = r.getAutoHeaderHeight();
    l != null && l > n && r.isAutoHeaderHeight() && (n = l);
  }
  return n;
}
function q2(e) {
  let o = e.colModel.isPivotMode() ? oVe(e) : g1(e);
  return e.colModel.forAllCols((n) => {
    const s = n.getAutoHeaderHeight();
    s != null && s > o && n.isAutoHeaderHeight() && (o = s);
  }), o;
}
function g1(e) {
  return e.gos.get("headerHeight") ?? e.environment.getDefaultHeaderHeight();
}
function Y2(e) {
  return e.gos.get("floatingFiltersHeight") ?? g1(e);
}
function Bb(e) {
  return e.gos.get("groupHeaderHeight") ?? g1(e);
}
function oVe(e) {
  return e.gos.get("pivotHeaderHeight") ?? g1(e);
}
function nVe(e) {
  return e.gos.get("pivotGroupHeaderHeight") ?? Bb(e);
}
var sVe = class extends K {
  setComp(e, t, o) {
    this.comp = e, this.eGui = t;
    const { beans: n } = this, { headerNavigation: s, touchSvc: i, ctrlsSvc: r } = n;
    s && this.createManagedBean(
      new gs(o, {
        onTabKeyDown: this.onTabKeyDown.bind(this),
        handleKeyDown: this.handleKeyDown.bind(this),
        onFocusOut: this.onFocusOut.bind(this)
      })
    ), this.addManagedEventListeners({
      columnPivotModeChanged: this.onPivotModeChanged.bind(this, n),
      displayedColumnsChanged: this.onDisplayedColumnsChanged.bind(this, n)
    }), this.onPivotModeChanged(n), this.setupHeaderHeight();
    const l = this.onHeaderContextMenu.bind(this);
    this.addManagedElementListeners(this.eGui, { contextmenu: l }), i == null || i.mockHeaderContextMenu(this, l), r.register("gridHeaderCtrl", this);
  }
  setupHeaderHeight() {
    const e = this.setHeaderHeight.bind(this);
    e(), this.addManagedPropertyListeners(
      [
        "headerHeight",
        "pivotHeaderHeight",
        "groupHeaderHeight",
        "pivotGroupHeaderHeight",
        "floatingFiltersHeight"
      ],
      e
    ), this.addManagedEventListeners({
      headerRowsChanged: e,
      columnHeaderHeightChanged: e,
      // add this to the animation frame to avoid a feedback loop
      columnGroupHeaderHeightChanged: () => yo(this.beans, () => e()),
      gridStylesChanged: e,
      advancedFilterEnabledChanged: e
    });
  }
  setHeaderHeight() {
    var i;
    const { beans: e } = this;
    let t = 0;
    const o = K2(e).reduce((r, l) => r + l, 0), n = q2(e);
    if ((i = e.filterManager) != null && i.hasFloatingFilters() && (t += Y2(e)), t += o, t += n, this.headerHeight === t)
      return;
    this.headerHeight = t;
    const s = `${t + 1}px`;
    this.comp.setHeightAndMinHeight(s), this.eventSvc.dispatchEvent({
      type: "headerHeightChanged"
    });
  }
  onPivotModeChanged(e) {
    const t = e.colModel.isPivotMode();
    this.comp.toggleCss("ag-pivot-on", t), this.comp.toggleCss("ag-pivot-off", !t);
  }
  onDisplayedColumnsChanged(e) {
    const o = e.visibleCols.allCols.some((n) => n.isSpanHeaderHeight());
    this.comp.toggleCss("ag-header-allow-overflow", o);
  }
  onTabKeyDown(e) {
    const t = this.gos.get("enableRtl"), o = e.shiftKey, n = o !== t ? "LEFT" : "RIGHT", { beans: s } = this, { headerNavigation: i, focusSvc: r } = s;
    (i.navigateHorizontally(n, !0, e) || !o && r.focusOverlay(!1) || fn(s, o, !0)) && e.preventDefault();
  }
  handleKeyDown(e) {
    let t = null;
    const { headerNavigation: o } = this.beans;
    switch (e.key) {
      case D.LEFT:
        t = "LEFT";
      case D.RIGHT: {
        ue(t) || (t = "RIGHT"), o.navigateHorizontally(t, !1, e) && e.preventDefault();
        break;
      }
      case D.UP:
        t = "UP";
      case D.DOWN: {
        ue(t) || (t = "DOWN"), o.navigateVertically(t, e) && e.preventDefault();
        break;
      }
      default:
        return;
    }
  }
  onFocusOut(e) {
    const { relatedTarget: t } = e, { eGui: o, beans: n } = this;
    !t && o.contains(Ue(n)) || o.contains(t) || (n.focusSvc.focusedHeader = null);
  }
  onHeaderContextMenu(e, t, o) {
    var r;
    const { menuSvc: n, ctrlsSvc: s } = this.beans;
    if (!e && !o || !(n != null && n.isHeaderContextMenuEnabled()))
      return;
    const { target: i } = e ?? t;
    (i === this.eGui || i === ((r = s.getHeaderRowContainerCtrl()) == null ? void 0 : r.eViewport)) && n.showHeaderContextMenu(void 0, e, o);
  }
}, Q2 = class extends Re {
  constructor(e, t) {
    super(e), this.ctrl = t;
  }
  getCtrl() {
    return this.ctrl;
  }
}, iVe = {
  tag: "div",
  cls: "ag-header-cell",
  role: "columnheader",
  children: [
    { tag: "div", ref: "eResize", cls: "ag-header-cell-resize", role: "presentation" },
    { tag: "div", ref: "eHeaderCompWrapper", cls: "ag-header-cell-comp-wrapper", role: "presentation" }
  ]
}, rVe = class extends Q2 {
  constructor(e) {
    super(iVe, e), this.eResize = J, this.eHeaderCompWrapper = J, this.headerCompVersion = 0;
  }
  postConstruct() {
    const e = this.getGui(), t = () => {
      const n = this.ctrl.getSelectAllGui();
      n && (this.eResize.insertAdjacentElement("afterend", n), this.addDestroyFunc(() => n.remove()));
    }, o = {
      setWidth: (n) => e.style.width = n,
      toggleCss: (n, s) => this.toggleCss(n, s),
      setUserStyles: (n) => a1(e, n),
      setAriaSort: (n) => n ? UTe(e, n) : KTe(e),
      setUserCompDetails: (n) => this.setUserCompDetails(n),
      getUserCompInstance: () => this.headerComp,
      refreshSelectAllGui: t,
      removeSelectAllGui: () => {
        var n;
        return (n = this.ctrl.getSelectAllGui()) == null ? void 0 : n.remove();
      }
    };
    this.ctrl.setComp(o, this.getGui(), this.eResize, this.eHeaderCompWrapper, void 0), t();
  }
  destroy() {
    this.destroyHeaderComp(), super.destroy();
  }
  destroyHeaderComp() {
    this.headerComp && (this.eHeaderCompWrapper.removeChild(this.headerCompGui), this.headerComp = this.destroyBean(this.headerComp), this.headerCompGui = void 0);
  }
  setUserCompDetails(e) {
    this.headerCompVersion++;
    const t = this.headerCompVersion;
    e.newAgStackInstance().then((o) => this.afterCompCreated(t, o));
  }
  afterCompCreated(e, t) {
    if (e != this.headerCompVersion || !this.isAlive()) {
      this.destroyBean(t);
      return;
    }
    this.destroyHeaderComp(), this.headerComp = t, this.headerCompGui = t.getGui(), this.eHeaderCompWrapper.appendChild(this.headerCompGui), this.ctrl.setDragSource(this.getGui());
  }
}, lVe = {
  tag: "div",
  cls: "ag-header-group-cell",
  role: "columnheader",
  children: [
    { tag: "div", ref: "eHeaderCompWrapper", cls: "ag-header-cell-comp-wrapper", role: "presentation" },
    { tag: "div", ref: "eResize", cls: "ag-header-cell-resize", role: "presentation" }
  ]
}, aVe = class extends Q2 {
  constructor(e) {
    super(lVe, e), this.eResize = J, this.eHeaderCompWrapper = J;
  }
  postConstruct() {
    const e = this.getGui(), t = (n, s) => s != null ? e.setAttribute(n, s) : e.removeAttribute(n), o = {
      toggleCss: (n, s) => this.toggleCss(n, s),
      setUserStyles: (n) => a1(e, n),
      setHeaderWrapperHidden: (n) => {
        n ? this.eHeaderCompWrapper.style.setProperty("display", "none") : this.eHeaderCompWrapper.style.removeProperty("display");
      },
      setHeaderWrapperMaxHeight: (n) => {
        n != null ? this.eHeaderCompWrapper.style.setProperty("max-height", `${n}px`) : this.eHeaderCompWrapper.style.removeProperty("max-height"), this.eHeaderCompWrapper.classList.toggle("ag-header-cell-comp-wrapper-limited-height", n != null);
      },
      setResizableDisplayed: (n) => He(this.eResize, n),
      setWidth: (n) => e.style.width = n,
      setAriaExpanded: (n) => t("aria-expanded", n),
      setUserCompDetails: (n) => this.setUserCompDetails(n),
      getUserCompInstance: () => this.headerGroupComp
    };
    this.ctrl.setComp(o, e, this.eResize, this.eHeaderCompWrapper, void 0);
  }
  setUserCompDetails(e) {
    e.newAgStackInstance().then((t) => this.afterHeaderCompCreated(t));
  }
  afterHeaderCompCreated(e) {
    const t = () => this.destroyBean(e);
    if (!this.isAlive()) {
      t();
      return;
    }
    const o = this.getGui(), n = e.getGui();
    this.eHeaderCompWrapper.appendChild(n), this.addDestroyFunc(t), this.headerGroupComp = e, this.ctrl.setDragSource(o);
  }
}, cVe = {
  tag: "div",
  cls: "ag-header-cell ag-floating-filter",
  role: "gridcell",
  children: [
    { tag: "div", ref: "eFloatingFilterBody", role: "presentation" },
    {
      tag: "div",
      ref: "eButtonWrapper",
      cls: "ag-floating-filter-button ag-hidden",
      role: "presentation",
      children: [
        {
          tag: "button",
          ref: "eButtonShowMainFilter",
          cls: "ag-button ag-floating-filter-button-button",
          attrs: { type: "button", tabindex: "-1" }
        }
      ]
    }
  ]
}, dVe = class extends Q2 {
  constructor(e) {
    super(cVe, e), this.eFloatingFilterBody = J, this.eButtonWrapper = J, this.eButtonShowMainFilter = J;
  }
  postConstruct() {
    const e = this.getGui(), t = {
      toggleCss: (o, n) => this.toggleCss(o, n),
      setUserStyles: (o) => a1(e, o),
      addOrRemoveBodyCssClass: (o, n) => this.eFloatingFilterBody.classList.toggle(o, n),
      setButtonWrapperDisplayed: (o) => He(this.eButtonWrapper, o),
      setCompDetails: (o) => this.setCompDetails(o),
      getFloatingFilterComp: () => this.compPromise,
      setWidth: (o) => e.style.width = o,
      setMenuIcon: (o) => this.eButtonShowMainFilter.appendChild(o)
    };
    this.ctrl.setComp(t, e, this.eButtonShowMainFilter, this.eFloatingFilterBody, void 0);
  }
  setCompDetails(e) {
    if (!e) {
      this.destroyFloatingFilterComp(), this.compPromise = null;
      return;
    }
    this.compPromise = e.newAgStackInstance(), this.compPromise.then((t) => this.afterCompCreated(t));
  }
  destroy() {
    this.destroyFloatingFilterComp(), super.destroy();
  }
  destroyFloatingFilterComp() {
    this.floatingFilterComp && (this.eFloatingFilterBody.removeChild(this.floatingFilterComp.getGui()), this.floatingFilterComp = this.destroyBean(this.floatingFilterComp));
  }
  afterCompCreated(e) {
    if (e) {
      if (!this.isAlive()) {
        this.destroyBean(e);
        return;
      }
      this.destroyFloatingFilterComp(), this.floatingFilterComp = e, this.eFloatingFilterBody.appendChild(e.getGui()), e.afterGuiAttached && e.afterGuiAttached();
    }
  }
}, uVe = class extends Re {
  constructor(e) {
    super({ tag: "div", cls: e.headerRowClass, role: "row" }), this.ctrl = e, this.headerComps = {};
  }
  postConstruct() {
    this.getGui().setAttribute("tabindex", String(this.gos.get("tabIndex"))), Gr(this.getGui(), this.ctrl.getAriaRowIndex());
    const t = {
      setHeight: (o) => this.getGui().style.height = o,
      setTop: (o) => this.getGui().style.top = o,
      setHeaderCtrls: (o, n) => this.setHeaderCtrls(o, n),
      setWidth: (o) => this.getGui().style.width = o,
      setRowIndex: (o) => Gr(this.getGui(), o)
    };
    this.ctrl.setComp(t, void 0);
  }
  destroy() {
    this.setHeaderCtrls([], !1), super.destroy();
  }
  setHeaderCtrls(e, t) {
    if (!this.isAlive())
      return;
    const o = this.headerComps;
    if (this.headerComps = {}, e.forEach((n) => {
      const s = n.instanceId;
      let i = o[s];
      delete o[s], i == null && (i = this.createHeaderComp(n), this.getGui().appendChild(i.getGui())), this.headerComps[s] = i;
    }), Object.values(o).forEach((n) => {
      this.getGui().removeChild(n.getGui()), this.destroyBean(n);
    }), t) {
      const n = Object.values(this.headerComps);
      n.sort(
        (i, r) => {
          const l = i.getCtrl().column.getLeft(), a = r.getCtrl().column.getLeft();
          return l - a;
        }
      );
      const s = n.map((i) => i.getGui());
      dw(this.getGui(), s);
    }
  }
  createHeaderComp(e) {
    let t;
    switch (this.ctrl.type) {
      case "group":
        t = new aVe(e);
        break;
      case "filter":
        t = new dVe(e);
        break;
      default:
        t = new rVe(e);
        break;
    }
    return this.createBean(t), t.setParentComponent(this), t;
  }
}, J2 = class extends K {
  constructor(e, t, o, n) {
    super(), this.columnOrGroup = e, this.eCell = t, this.colsSpanning = n, this.columnOrGroup = e, this.ariaEl = t.querySelector("[role=columnheader]") || t, this.beans = o;
  }
  setColsSpanning(e) {
    this.colsSpanning = e, this.onLeftChanged();
  }
  getColumnOrGroup() {
    const { beans: e, colsSpanning: t } = this;
    return e.gos.get("enableRtl") && t ? Ke(t) : this.columnOrGroup;
  }
  postConstruct() {
    const e = this.onLeftChanged.bind(this);
    this.addManagedListeners(this.columnOrGroup, { leftChanged: e }), this.setLeftFirstTime(), this.addManagedEventListeners({ displayedColumnsWidthChanged: e }), this.addManagedPropertyListener("domLayout", e);
  }
  setLeftFirstTime() {
    const { gos: e, colAnimation: t } = this.beans, o = e.get("suppressColumnMoveAnimation"), n = ue(this.columnOrGroup.getOldLeft());
    (t == null ? void 0 : t.isActive()) && n && !o ? this.animateInLeft() : this.onLeftChanged();
  }
  animateInLeft() {
    const e = this.getColumnOrGroup(), t = this.modifyLeftForPrintLayout(e, e.getOldLeft()), o = this.modifyLeftForPrintLayout(e, e.getLeft());
    this.setLeft(t), this.actualLeft = o, this.beans.colAnimation.executeNextVMTurn(() => {
      this.actualLeft === o && this.setLeft(o);
    });
  }
  onLeftChanged() {
    const e = this.getColumnOrGroup(), t = e.getLeft();
    this.actualLeft = this.modifyLeftForPrintLayout(e, t), this.setLeft(this.actualLeft);
  }
  modifyLeftForPrintLayout(e, t) {
    const { gos: o, visibleCols: n } = this.beans;
    if (!jt(o, "print") || e.getPinned() === "left")
      return t;
    const i = n.getColsLeftWidth();
    if (e.getPinned() === "right") {
      const r = n.bodyWidth;
      return i + r + t;
    }
    return i + t;
  }
  setLeft(e) {
    if (ue(e) && (this.eCell.style.left = `${e}px`), St(this.columnOrGroup)) {
      const t = this.columnOrGroup.getLeafColumns();
      if (!t.length)
        return;
      t.length > 1 && nw(this.ariaEl, t.length);
    }
  }
}, hVe = 0, $b = "headerCtrl", X2 = class extends K {
  constructor(e, t) {
    super(), this.column = e, this.rowCtrl = t, this.resizeToggleTimeout = 0, this.resizeMultiplier = 1, this.resizeFeature = null, this.lastFocusEvent = null, this.dragSource = null, this.reAttemptToFocus = !1, this.instanceId = e.getUniqueId() + "-" + hVe++;
  }
  postConstruct() {
    const e = this.refreshTabIndex.bind(this);
    this.addManagedPropertyListeners(["suppressHeaderFocus"], e), this.addManagedEventListeners({
      overlayExclusiveChanged: e
    });
  }
  setComp(e, t, o, n, s) {
    t.setAttribute("col-id", this.column.colIdSanitised), this.wireComp(e, t, o, n, s), this.reAttemptToFocus && (this.reAttemptToFocus = !1, this.focus(this.lastFocusEvent ?? void 0));
  }
  shouldStopEventPropagation(e) {
    const { headerRowIndex: t, column: o } = this.beans.focusSvc.focusedHeader, n = o.getDefinition(), s = n && n.suppressHeaderKeyboardEvent;
    if (!ue(s))
      return !1;
    const i = Pe(this.gos, {
      colDef: n,
      column: o,
      headerRowIndex: t,
      event: e
    });
    return !!s(i);
  }
  getWrapperHasFocus() {
    return Ue(this.beans) === this.eGui;
  }
  setGui(e, t) {
    this.eGui = e, this.addDomData(t), t.addManagedListeners(this.beans.eventSvc, {
      displayedColumnsChanged: this.onDisplayedColumnsChanged.bind(this)
    }), t.addManagedElementListeners(this.eGui, {
      focus: this.onGuiFocus.bind(this)
    }), this.onDisplayedColumnsChanged(), this.refreshTabIndex();
  }
  refreshHeaderStyles() {
    const e = this.column.getDefinition();
    if (!e)
      return;
    const { headerStyle: t } = e;
    let o;
    if (typeof t == "function") {
      const n = this.getHeaderClassParams();
      o = t(n);
    } else
      o = t;
    o && this.comp.setUserStyles(o);
  }
  onGuiFocus() {
    this.eventSvc.dispatchEvent({
      type: "headerFocused",
      column: this.column
    });
  }
  setupAutoHeight(e) {
    const { wrapperElement: t, checkMeasuringCallback: o, compBean: n } = e, { beans: s } = this, i = (u) => {
      if (!this.isAlive() || !n.isAlive())
        return;
      const { paddingTop: h, paddingBottom: p, borderBottomWidth: C, borderTopWidth: m } = si(this.eGui), w = h + p + C + m, b = t.offsetHeight + w;
      if (u < 5) {
        const _ = Pt(s), M = !_ || !_.contains(t), x = b == 0;
        if (M || x) {
          Q0(() => i(u + 1), "raf", s);
          return;
        }
      }
      this.setColHeaderHeight(this.column, b);
    };
    let r = !1, l;
    const a = () => {
      const u = this.column.isAutoHeaderHeight();
      u && !r && c(), !u && r && d();
    }, c = () => {
      r = !0, this.comp.toggleCss("ag-header-cell-auto-height", !0), i(0), l = mn(this.beans, t, () => i(0));
    }, d = () => {
      r = !1, l && l(), this.comp.toggleCss("ag-header-cell-auto-height", !1), l = void 0;
    };
    a(), n.addDestroyFunc(() => d()), n.addManagedListeners(this.column, { widthChanged: () => r && i(0) }), n.addManagedEventListeners({
      sortChanged: () => {
        r && window.setTimeout(() => i(0));
      }
    }), o && o(a);
  }
  onDisplayedColumnsChanged() {
    const { comp: e, column: t, beans: o, eGui: n } = this;
    !e || !t || !n || (Hb(e, t, o.visibleCols), v2(n, o.visibleCols.getAriaColIndex(t)));
  }
  addResizeAndMoveKeyboardListeners(e) {
    e.addManagedListeners(this.eGui, {
      keydown: this.onGuiKeyDown.bind(this),
      keyup: this.onGuiKeyUp.bind(this)
    });
  }
  refreshTabIndex() {
    const e = $s(this.beans);
    this.eGui && mo(this.eGui, "tabindex", e ? null : "-1");
  }
  onGuiKeyDown(e) {
    var i;
    const t = Ue(this.beans), o = e.key === D.LEFT || e.key === D.RIGHT;
    if (this.isResizing && (e.preventDefault(), e.stopImmediatePropagation()), // if elements within the header are focused, we don't process the event
    t !== this.eGui || // if shiftKey and altKey are not pressed, it's cell navigation so we don't process the event
    !e.shiftKey && !e.altKey || ((this.isResizing || o) && (e.preventDefault(), e.stopImmediatePropagation()), !o))
      return;
    const s = e.key === D.LEFT !== this.gos.get("enableRtl") ? "left" : "right";
    if (e.altKey) {
      this.isResizing = !0, this.resizeMultiplier += 1;
      const r = this.getViewportAdjustedResizeDiff(e);
      this.resizeHeader(r, e.shiftKey), (i = this.resizeFeature) == null || i.toggleColumnResizing(!0);
    } else
      this.moveHeader(s);
  }
  moveHeader(e) {
    var t;
    (t = this.beans.colMoves) == null || t.moveHeader(e, this.eGui, this.column, this.rowCtrl.pinned, this);
  }
  getViewportAdjustedResizeDiff(e) {
    const t = this.getResizeDiff(e), { pinnedCols: o } = this.beans;
    return o ? o.getHeaderResizeDiff(t, this.column) : t;
  }
  getResizeDiff(e) {
    const { gos: t, column: o } = this;
    let n = e.key === D.LEFT !== t.get("enableRtl");
    const s = o.getPinned(), i = t.get("enableRtl");
    return s && i !== (s === "right") && (n = !n), (n ? -1 : 1) * this.resizeMultiplier;
  }
  onGuiKeyUp() {
    this.isResizing && (this.resizeToggleTimeout && (window.clearTimeout(this.resizeToggleTimeout), this.resizeToggleTimeout = 0), this.isResizing = !1, this.resizeMultiplier = 1, this.resizeToggleTimeout = window.setTimeout(() => {
      var e;
      (e = this.resizeFeature) == null || e.toggleColumnResizing(!1);
    }, 150));
  }
  handleKeyDown(e) {
    const t = this.getWrapperHasFocus();
    switch (e.key) {
      case D.PAGE_DOWN:
      case D.PAGE_UP:
      case D.PAGE_HOME:
      case D.PAGE_END:
        t && e.preventDefault();
    }
  }
  addDomData(e) {
    const t = $b, { eGui: o, gos: n } = this;
    Ys(n, o, t, this), e.addDestroyFunc(() => Ys(n, o, t, null));
  }
  focus(e) {
    if (!this.isAlive())
      return !1;
    const { eGui: t } = this;
    return t ? (t.focus(), this.lastFocusEvent = e || null) : this.reAttemptToFocus = !0, !0;
  }
  focusThis() {
    this.beans.focusSvc.focusedHeader = { headerRowIndex: this.rowCtrl.rowIndex, column: this.column };
  }
  removeDragSource() {
    var e;
    this.dragSource && ((e = this.beans.dragAndDrop) == null || e.removeDragSource(this.dragSource), this.dragSource = null);
  }
  handleContextMenuMouseEvent(e, t, o) {
    const n = e ?? t, { menuSvc: s, gos: i } = this.beans;
    i.get("preventDefaultOnContextMenu") && n.preventDefault(), s != null && s.isHeaderContextMenuEnabled(o) && s.showHeaderContextMenu(o, e, t), this.dispatchColumnMouseEvent("columnHeaderContextMenu", o);
  }
  dispatchColumnMouseEvent(e, t) {
    this.eventSvc.dispatchEvent({
      type: e,
      column: t
    });
  }
  setColHeaderHeight(e, t) {
    if (!e.setAutoHeaderHeight(t))
      return;
    const { eventSvc: o } = this;
    e.isColumn ? o.dispatchEvent({
      type: "columnHeaderHeightChanged",
      column: e,
      columns: [e],
      source: "autosizeColumnHeaderHeight"
    }) : o.dispatchEvent({
      type: "columnGroupHeaderHeightChanged",
      columnGroup: e,
      source: "autosizeColumnGroupHeaderHeight"
    });
  }
  clearComponent() {
    this.removeDragSource(), this.resizeFeature = null, this.comp = null, this.eGui = null;
  }
  destroy() {
    super.destroy(), this.column = null, this.lastFocusEvent = null, this.rowCtrl = null;
  }
}, gVe = class extends X2 {
  constructor() {
    super(...arguments), this.refreshFunctions = {}, this.userHeaderClasses = /* @__PURE__ */ new Set(), this.ariaDescriptionProperties = /* @__PURE__ */ new Map();
  }
  wireComp(e, t, o, n, s) {
    this.comp = e;
    const { rowCtrl: i, column: r, beans: l } = this, { colResize: a, context: c, colHover: d, rangeSvc: u } = l, h = d1(this, c, s);
    this.setGui(t, h), this.updateState(), this.setupWidth(h), this.setupMovingCss(h), this.setupMenuClass(h), this.setupSortableClass(h), this.setupWrapTextClass(), this.refreshSpanHeaderHeight(), this.setupAutoHeight({
      wrapperElement: n,
      checkMeasuringCallback: (C) => this.setRefreshFunction("measuring", C),
      compBean: h
    }), this.addColumnHoverListener(h), this.setupFilterClass(h), this.setupStylesFromColDef(), this.setupClassesFromColDef(), this.setupTooltip(), this.addActiveHeaderMouseListeners(h), this.setupSelectAll(h), this.setupUserComp(), this.refreshAria(), a ? this.resizeFeature = h.createManagedBean(
      a.createResizeFeature(i.pinned, r, o, e, this)
    ) : He(o, !1), d == null || d.createHoverFeature(h, [r], t), u == null || u.createRangeHighlightFeature(h, r, e), h.createManagedBean(new J2(r, t, l)), h.createManagedBean(
      new gs(t, {
        shouldStopEventPropagation: (C) => this.shouldStopEventPropagation(C),
        onTabKeyDown: () => null,
        handleKeyDown: this.handleKeyDown.bind(this),
        onFocusIn: this.onFocusIn.bind(this),
        onFocusOut: this.onFocusOut.bind(this)
      })
    ), this.addResizeAndMoveKeyboardListeners(h), h.addManagedPropertyListeners(
      ["suppressMovableColumns", "suppressMenuHide", "suppressAggFuncInHeader", "enableAdvancedFilter"],
      () => this.refresh()
    ), h.addManagedListeners(r, { colDefChanged: () => this.refresh() }), h.addManagedListeners(r, { headerHighlightChanged: this.onHeaderHighlightChanged.bind(this) });
    const p = () => this.checkDisplayName();
    h.addManagedEventListeners({
      columnValueChanged: p,
      columnRowGroupChanged: p,
      columnPivotChanged: p,
      headerHeightChanged: this.onHeaderHeightChanged.bind(this)
    }), h.addDestroyFunc(() => {
      this.refreshFunctions = {}, this.selectAllFeature = null, this.dragSourceElement = void 0, this.userCompDetails = null, this.userHeaderClasses.clear(), this.ariaDescriptionProperties.clear(), this.clearComponent();
    });
  }
  resizeHeader(e, t) {
    var o;
    (o = this.beans.colResize) == null || o.resizeHeader(this.column, e, t);
  }
  getHeaderClassParams() {
    const { column: e, beans: t } = this, o = e.colDef;
    return Pe(t.gos, {
      colDef: o,
      column: e,
      floatingFilter: !1
    });
  }
  setupUserComp() {
    const e = this.lookupUserCompDetails();
    e && this.setCompDetails(e);
  }
  setCompDetails(e) {
    this.userCompDetails = e, this.comp.setUserCompDetails(e);
  }
  lookupUserCompDetails() {
    const e = this.createParams(), t = this.column.getColDef();
    return MDe(this.beans.userCompFactory, t, e);
  }
  createParams() {
    const { menuSvc: e, sortSvc: t, colFilter: o, gos: n } = this.beans;
    return Pe(n, {
      column: this.column,
      displayName: this.displayName,
      enableSorting: this.column.isSortable(),
      enableMenu: this.menuEnabled,
      enableFilterButton: this.openFilterEnabled && !!(e != null && e.isHeaderFilterButtonEnabled(this.column)),
      enableFilterIcon: !!o && (!this.openFilterEnabled || $t(this.gos)),
      showColumnMenu: (i, r) => {
        e == null || e.showColumnMenu({
          column: this.column,
          buttonElement: i,
          positionBy: "button",
          onClosedCallback: r
        });
      },
      showColumnMenuAfterMouseClick: (i, r) => {
        e == null || e.showColumnMenu({
          column: this.column,
          mouseEvent: i,
          positionBy: "mouse",
          onClosedCallback: r
        });
      },
      showFilter: (i) => {
        e == null || e.showFilterMenu({
          column: this.column,
          buttonElement: i,
          containerType: "columnFilter",
          positionBy: "button"
        });
      },
      progressSort: (i) => {
        t == null || t.progressSort(this.column, !!i, "uiColumnSorted");
      },
      setSort: (i, r) => {
        t == null || t.setSortForColumn(this.column, i, !!r, "uiColumnSorted");
      },
      eGridHeader: this.eGui,
      setTooltip: (i, r) => {
        n.assertModuleRegistered("Tooltip", 3), this.setupTooltip(i, r);
      }
    });
  }
  setupSelectAll(e) {
    var o;
    const { selectionSvc: t } = this.beans;
    t && (this.selectAllFeature = e.createOptionalManagedBean(t.createSelectAllFeature(this.column)), (o = this.selectAllFeature) == null || o.setComp(this), e.addManagedPropertyListener("rowSelection", () => {
      var s;
      const n = t.createSelectAllFeature(this.column);
      n && !this.selectAllFeature ? (this.selectAllFeature = e.createManagedBean(n), (s = this.selectAllFeature) == null || s.setComp(this), this.comp.refreshSelectAllGui()) : this.selectAllFeature && !n && (this.comp.removeSelectAllGui(), this.selectAllFeature = this.destroyBean(this.selectAllFeature));
    }));
  }
  getSelectAllGui() {
    var e;
    return (e = this.selectAllFeature) == null ? void 0 : e.getCheckboxGui();
  }
  handleKeyDown(e) {
    var t;
    super.handleKeyDown(e), e.key === D.SPACE && ((t = this.selectAllFeature) == null || t.onSpaceKeyDown(e)), e.key === D.ENTER && this.onEnterKeyDown(e), e.key === D.DOWN && e.altKey && this.showMenuOnKeyPress(e, !1);
  }
  onEnterKeyDown(e) {
    var t;
    e.ctrlKey || e.metaKey ? this.showMenuOnKeyPress(e, !0) : this.sortable && ((t = this.beans.sortSvc) == null || t.progressSort(this.column, e.shiftKey, "uiColumnSorted"));
  }
  showMenuOnKeyPress(e, t) {
    const o = this.comp.getUserCompInstance();
    jd(o) && o.onMenuKeyboardShortcut(t) && e.preventDefault();
  }
  onFocusIn(e) {
    this.eGui.contains(e.relatedTarget) || (this.focusThis(), this.announceAriaDescription()), pa() && this.setActiveHeader(!0);
  }
  onFocusOut(e) {
    this.eGui.contains(e.relatedTarget) || this.setActiveHeader(!1);
  }
  setupTooltip(e, t) {
    var o;
    this.tooltipFeature = (o = this.beans.tooltipSvc) == null ? void 0 : o.setupHeaderTooltip(
      this.tooltipFeature,
      this,
      e,
      t
    );
  }
  setupStylesFromColDef() {
    this.setRefreshFunction("headerStyles", this.refreshHeaderStyles.bind(this)), this.refreshHeaderStyles();
  }
  setupClassesFromColDef() {
    const e = () => {
      const t = this.column.getColDef(), o = Db(t, this.gos, this.column, null), n = this.userHeaderClasses;
      this.userHeaderClasses = new Set(o), o.forEach((s) => {
        n.has(s) ? n.delete(s) : this.comp.toggleCss(s, !0);
      }), n.forEach((s) => this.comp.toggleCss(s, !1));
    };
    this.setRefreshFunction("headerClasses", e), e();
  }
  setDragSource(e) {
    var t;
    this.dragSourceElement = e, this.removeDragSource(), !(!e || !this.draggable) && (this.dragSource = ((t = this.beans.colMoves) == null ? void 0 : t.setDragSourceForHeader(e, this.column, this.displayName)) ?? null);
  }
  updateState() {
    const { menuSvc: e } = this.beans;
    this.menuEnabled = !!(e != null && e.isColumnMenuInHeaderEnabled(this.column)), this.openFilterEnabled = !!(e != null && e.isFilterMenuInHeaderEnabled(this.column)), this.sortable = this.column.isSortable(), this.displayName = this.calculateDisplayName(), this.draggable = this.workOutDraggable();
  }
  setRefreshFunction(e, t) {
    this.refreshFunctions[e] = t;
  }
  refresh() {
    this.updateState(), this.refreshHeaderComp(), this.refreshAria(), Object.values(this.refreshFunctions).forEach((e) => e());
  }
  refreshHeaderComp() {
    const e = this.lookupUserCompDetails();
    if (!e)
      return;
    (this.comp.getUserCompInstance() != null && this.userCompDetails.componentClass == e.componentClass ? this.attemptHeaderCompRefresh(e.params) : !1) ? this.setDragSource(this.dragSourceElement) : this.setCompDetails(e);
  }
  attemptHeaderCompRefresh(e) {
    const t = this.comp.getUserCompInstance();
    return !t || !t.refresh ? !1 : t.refresh(e);
  }
  calculateDisplayName() {
    return this.beans.colNames.getDisplayNameForColumn(this.column, "header", !0);
  }
  checkDisplayName() {
    this.displayName !== this.calculateDisplayName() && this.refresh();
  }
  workOutDraggable() {
    const e = this.column.getColDef();
    return !!(!this.gos.get("suppressMovableColumns") && !e.suppressMovable && !e.lockPosition) || !!e.enableRowGroup || !!e.enablePivot;
  }
  setupWidth(e) {
    const t = () => {
      const o = this.column.getActualWidth();
      this.comp.setWidth(`${o}px`);
    };
    e.addManagedListeners(this.column, { widthChanged: t }), t();
  }
  setupMovingCss(e) {
    const t = () => {
      this.comp.toggleCss("ag-header-cell-moving", this.column.isMoving());
    };
    e.addManagedListeners(this.column, { movingChanged: t }), t();
  }
  setupMenuClass(e) {
    const t = () => {
      var o;
      (o = this.comp) == null || o.toggleCss("ag-column-menu-visible", this.column.isMenuVisible());
    };
    e.addManagedListeners(this.column, { menuVisibleChanged: t }), t();
  }
  setupSortableClass(e) {
    const t = () => {
      this.comp.toggleCss("ag-header-cell-sortable", !!this.sortable);
    };
    t(), this.setRefreshFunction("updateSortable", t), e.addManagedEventListeners({ sortChanged: this.refreshAriaSort.bind(this) });
  }
  setupFilterClass(e) {
    const t = () => {
      const o = this.column.isFilterActive();
      this.comp.toggleCss("ag-header-cell-filtered", o), this.refreshAria();
    };
    e.addManagedListeners(this.column, { filterActiveChanged: t }), t();
  }
  setupWrapTextClass() {
    const e = () => {
      const t = !!this.column.getColDef().wrapHeaderText;
      this.comp.toggleCss("ag-header-cell-wrap-text", t);
    };
    e(), this.setRefreshFunction("wrapText", e);
  }
  onHeaderHighlightChanged() {
    const e = this.column.getHighlighted(), t = e === 0, o = e === 1;
    this.comp.toggleCss("ag-header-highlight-before", t), this.comp.toggleCss("ag-header-highlight-after", o);
  }
  onDisplayedColumnsChanged() {
    super.onDisplayedColumnsChanged(), this.isAlive() && this.onHeaderHeightChanged();
  }
  onHeaderHeightChanged() {
    this.refreshSpanHeaderHeight();
  }
  refreshSpanHeaderHeight() {
    var h;
    const { eGui: e, column: t, comp: o, beans: n } = this, s = K2(this.beans), i = s.reduce((p, C) => p += C, 0) === 0;
    if (o.toggleCss("ag-header-parent-hidden", i), !t.isSpanHeaderHeight()) {
      e.style.removeProperty("top"), e.style.removeProperty("height"), o.toggleCss("ag-header-span-height", !1), o.toggleCss("ag-header-span-total", !1);
      return;
    }
    const { numberOfParents: r, isSpanningTotal: l } = this.column.getColumnGroupPaddingInfo();
    o.toggleCss("ag-header-span-height", r > 0);
    const a = q2(n);
    if (r === 0) {
      o.toggleCss("ag-header-span-total", !1), e.style.setProperty("top", "0px"), e.style.setProperty("height", `${a}px`);
      return;
    }
    o.toggleCss("ag-header-span-total", l);
    const c = (((h = this.column.getFirstRealParent()) == null ? void 0 : h.getLevel()) ?? -1) + 1, d = s.length - c;
    let u = 0;
    for (let p = 0; p < d; p++)
      u += s[s.length - 1 - p];
    e.style.setProperty("top", `${-u}px`), e.style.setProperty("height", `${a + u}px`);
  }
  refreshAriaSort() {
    var e;
    if (this.sortable) {
      const t = this.getLocaleTextFunc(), o = ((e = this.beans.sortSvc) == null ? void 0 : e.getDisplaySortForColumn(this.column)) || null;
      this.comp.setAriaSort(VTe(o)), this.setAriaDescriptionProperty("sort", t("ariaSortableColumn", "Press ENTER to sort"));
    } else
      this.comp.setAriaSort(), this.setAriaDescriptionProperty("sort", null);
  }
  refreshAriaMenu() {
    if (this.menuEnabled) {
      const e = this.getLocaleTextFunc();
      this.setAriaDescriptionProperty("menu", e("ariaMenuColumn", "Press ALT DOWN to open column menu"));
    } else
      this.setAriaDescriptionProperty("menu", null);
  }
  refreshAriaFilterButton() {
    if (this.openFilterEnabled && !$t(this.gos)) {
      const e = this.getLocaleTextFunc();
      this.setAriaDescriptionProperty(
        "filterButton",
        e("ariaFilterColumn", "Press CTRL ENTER to open filter")
      );
    } else
      this.setAriaDescriptionProperty("filterButton", null);
  }
  refreshAriaFiltered() {
    const e = this.getLocaleTextFunc();
    this.column.isFilterActive() ? this.setAriaDescriptionProperty("filter", e("ariaColumnFiltered", "Column Filtered")) : this.setAriaDescriptionProperty("filter", null);
  }
  setAriaDescriptionProperty(e, t) {
    t != null ? this.ariaDescriptionProperties.set(e, t) : this.ariaDescriptionProperties.delete(e);
  }
  announceAriaDescription() {
    var t;
    if (!this.eGui.contains(Ue(this.beans)))
      return;
    const e = Array.from(this.ariaDescriptionProperties.keys()).sort((o, n) => o === "filter" ? -1 : n.charCodeAt(0) - o.charCodeAt(0)).map((o) => this.ariaDescriptionProperties.get(o)).join(". ");
    (t = this.beans.ariaAnnounce) == null || t.announceValue(e, "columnHeader");
  }
  refreshAria() {
    this.refreshAriaSort(), this.refreshAriaMenu(), this.refreshAriaFilterButton(), this.refreshAriaFiltered();
  }
  addColumnHoverListener(e) {
    var t;
    (t = this.beans.colHover) == null || t.addHeaderColumnHoverListener(e, this.comp, this.column);
  }
  addActiveHeaderMouseListeners(e) {
    const t = (s) => this.handleMouseOverChange(s.type === "mouseenter"), o = () => {
      this.setActiveHeader(!0), this.dispatchColumnMouseEvent("columnHeaderClicked", this.column);
    }, n = (s) => this.handleContextMenuMouseEvent(s, void 0, this.column);
    e.addManagedListeners(this.eGui, {
      mouseenter: t,
      mouseleave: t,
      click: o,
      contextmenu: n
    });
  }
  handleMouseOverChange(e) {
    this.setActiveHeader(e), this.eventSvc.dispatchEvent({
      type: e ? "columnHeaderMouseOver" : "columnHeaderMouseLeave",
      column: this.column
    });
  }
  setActiveHeader(e) {
    this.comp.toggleCss("ag-header-active", e);
  }
  getAnchorElementForMenu(e) {
    const t = this.comp.getUserCompInstance();
    return jd(t) ? t.getAnchorElementForMenu(e) : this.eGui;
  }
  destroy() {
    this.tooltipFeature = this.destroyBean(this.tooltipFeature), super.destroy();
  }
};
function jd(e) {
  return typeof (e == null ? void 0 : e.getAnchorElementForMenu) == "function" && typeof e.onMenuKeyboardShortcut == "function";
}
var pVe = 0, c0 = class extends K {
  constructor(e, t, o) {
    super(), this.rowIndex = e, this.pinned = t, this.type = o, this.instanceId = pVe++, this.comp = null, this.allCtrls = [];
    let n = "ag-header-row-column";
    o === "group" ? n = "ag-header-row-group" : o === "filter" && (n = "ag-header-row-filter"), this.headerRowClass = `ag-header-row ${n}`;
  }
  setRowIndex(e) {
    var t;
    this.rowIndex = e, (t = this.comp) == null || t.setRowIndex(this.getAriaRowIndex()), this.onRowHeightChanged();
  }
  postConstruct() {
    this.isPrintLayout = jt(this.gos, "print"), this.isEnsureDomOrder = this.gos.get("ensureDomOrder");
  }
  /** Checks that every header cell that is currently visible has been rendered.
   * Can only be false under some circumstances when using React
   */
  areCellsRendered() {
    return this.comp ? this.allCtrls.every((e) => e.eGui != null) : !1;
  }
  /**
   *
   * @param comp Proxy to the actual component
   * @param initCompState Should the component be initialised with the current state of the controller. Default: true
   */
  setComp(e, t, o = !0) {
    this.comp = e, t = d1(this, this.beans.context, t), o && (this.setRowIndex(this.rowIndex), this.onVirtualColumnsChanged()), this.setWidth(), this.addEventListeners(t);
  }
  getAriaRowIndex() {
    return this.rowIndex + 1;
  }
  addEventListeners(e) {
    const t = this.onRowHeightChanged.bind(this), o = this.onDisplayedColumnsChanged.bind(this);
    e.addManagedEventListeners({
      columnResized: this.setWidth.bind(this),
      displayedColumnsChanged: o,
      virtualColumnsChanged: (n) => this.onVirtualColumnsChanged(n.afterScroll),
      columnGroupHeaderHeightChanged: t,
      columnHeaderHeightChanged: t,
      gridStylesChanged: t,
      advancedFilterEnabledChanged: t
    }), e.addManagedPropertyListener("domLayout", o), e.addManagedPropertyListener("ensureDomOrder", (n) => this.isEnsureDomOrder = n.currentValue), e.addManagedPropertyListeners(
      [
        "headerHeight",
        "pivotHeaderHeight",
        "groupHeaderHeight",
        "pivotGroupHeaderHeight",
        "floatingFiltersHeight"
      ],
      t
    );
  }
  onDisplayedColumnsChanged() {
    this.isPrintLayout = jt(this.gos, "print"), this.onVirtualColumnsChanged(), this.setWidth(), this.onRowHeightChanged();
  }
  setWidth() {
    if (!this.comp)
      return;
    const e = this.getWidthForRow();
    this.comp.setWidth(`${e}px`);
  }
  getWidthForRow() {
    const { visibleCols: e } = this.beans;
    return this.isPrintLayout ? this.pinned != null ? 0 : e.getContainerWidth("right") + e.getContainerWidth("left") + e.getContainerWidth(null) : e.getContainerWidth(this.pinned);
  }
  onRowHeightChanged() {
    if (!this.comp)
      return;
    const { topOffset: e, rowHeight: t } = this.getTopAndHeight();
    this.comp.setTop(e + "px"), this.comp.setHeight(t + "px");
  }
  getTopAndHeight() {
    let e = 0;
    const t = K2(this.beans);
    for (let s = 0; s < t.length; s++) {
      if (s === this.rowIndex && this.type === "group")
        return { topOffset: e, rowHeight: t[s] };
      e += t[s];
    }
    const o = q2(this.beans);
    if (this.type === "column")
      return { topOffset: e, rowHeight: o };
    e += o;
    const n = Y2(this.beans);
    return { topOffset: e, rowHeight: n };
  }
  onVirtualColumnsChanged(e = !1) {
    if (!this.comp)
      return;
    const t = this.getUpdatedHeaderCtrls(), o = this.isEnsureDomOrder || this.isPrintLayout;
    this.comp.setHeaderCtrls(t, o, e);
  }
  /**
   * Recycles the header cell ctrls and creates new ones for the columns in the viewport
   * @returns The updated header cell ctrls
   */
  getUpdatedHeaderCtrls() {
    const e = this.ctrlsById;
    this.ctrlsById = /* @__PURE__ */ new Map();
    const t = this.getColumnsInViewport();
    for (const n of t)
      this.recycleAndCreateHeaderCtrls(n, this.ctrlsById, e);
    const o = (n) => {
      const { focusSvc: s, visibleCols: i } = this.beans;
      return s.isHeaderWrapperFocused(n) ? i.isVisible(n.column) : !1;
    };
    if (e)
      for (const [n, s] of e)
        o(s) ? this.ctrlsById.set(n, s) : this.destroyBean(s);
    return this.allCtrls = Array.from(this.ctrlsById.values()), this.allCtrls;
  }
  /** Get the current header cell ctrls */
  getHeaderCellCtrls() {
    return this.allCtrls;
  }
  recycleAndCreateHeaderCtrls(e, t, o) {
    if (e.isEmptyGroup())
      return;
    const n = e.getUniqueId();
    let s;
    if (o && (s = o.get(n), o.delete(n)), s && s.column != e && (this.destroyBean(s), s = void 0), s == null)
      switch (this.type) {
        case "filter": {
          s = this.createBean(
            this.beans.registry.createDynamicBean(
              "headerFilterCellCtrl",
              !0,
              e,
              this
            )
          );
          break;
        }
        case "group":
          s = this.createBean(
            this.beans.registry.createDynamicBean(
              "headerGroupCellCtrl",
              !0,
              e,
              this
            )
          );
          break;
        default:
          s = this.createBean(new gVe(e, this));
          break;
      }
    t.set(n, s);
  }
  getColumnsInViewport() {
    if (!this.isPrintLayout)
      return this.getComponentsToRender();
    if (this.pinned)
      return [];
    const e = [];
    return ["left", null, "right"].forEach((t) => {
      e.push(...this.getComponentsToRender(t));
    }), e;
  }
  getComponentsToRender(e = this.pinned) {
    return this.type === "group" ? this.beans.colViewport.getHeadersToRender(e, this.rowIndex) : this.beans.colViewport.getColumnHeadersToRender(e);
  }
  focusHeader(e, t) {
    const o = this.allCtrls.find((s) => s.column == e);
    return o ? o.focus(t) : !1;
  }
  destroy() {
    this.allCtrls = this.destroyBeans(this.allCtrls), this.ctrlsById = void 0, this.comp = null, super.destroy();
  }
}, fVe = class extends K {
  constructor(e) {
    super(), this.pinned = e, this.hidden = !1, this.includeFloatingFilter = !1, this.groupsRowCtrls = [];
  }
  setComp(e, t) {
    this.comp = e, this.eViewport = t;
    const { pinnedCols: o, ctrlsSvc: n, colModel: s, colMoves: i } = this.beans;
    this.setupCenterWidth(), o == null || o.setupHeaderPinnedWidth(this), this.setupDragAndDrop(i, this.eViewport);
    const r = this.refresh.bind(this, !0);
    this.addManagedEventListeners({
      displayedColumnsChanged: r,
      advancedFilterEnabledChanged: r
    });
    const l = `${typeof this.pinned == "string" ? this.pinned : "center"}Header`;
    n.register(l, this), s.ready && this.refresh();
  }
  getAllCtrls() {
    const e = [...this.groupsRowCtrls];
    return this.columnsRowCtrl && e.push(this.columnsRowCtrl), this.filtersRowCtrl && e.push(this.filtersRowCtrl), e;
  }
  refresh(e = !1) {
    const { focusSvc: t, filterManager: o, visibleCols: n } = this.beans;
    let s = 0;
    const i = t.getFocusHeaderToUseAfterRefresh(), r = () => {
      const u = n.headerGroupRowCount;
      s = u;
      const h = this.groupsRowCtrls.length;
      if (h !== u) {
        if (h > u) {
          for (let p = u; p < h; p++)
            this.destroyBean(this.groupsRowCtrls[p]);
          this.groupsRowCtrls.length = u;
          return;
        }
        for (let p = h; p < u; p++) {
          const C = this.createBean(new c0(p, this.pinned, "group"));
          this.groupsRowCtrls.push(C);
        }
      }
    }, l = () => {
      const u = s++;
      if (this.hidden) {
        this.columnsRowCtrl = this.destroyBean(this.columnsRowCtrl);
        return;
      }
      this.columnsRowCtrl == null || !e ? (this.columnsRowCtrl = this.destroyBean(this.columnsRowCtrl), this.columnsRowCtrl = this.createBean(new c0(u, this.pinned, "column"))) : this.columnsRowCtrl.rowIndex !== u && this.columnsRowCtrl.setRowIndex(u);
    }, a = () => {
      this.includeFloatingFilter = !!(o != null && o.hasFloatingFilters()) && !this.hidden;
      const u = () => {
        this.filtersRowCtrl = this.destroyBean(this.filtersRowCtrl);
      };
      if (!this.includeFloatingFilter) {
        u();
        return;
      }
      e || u();
      const h = s++;
      this.filtersRowCtrl ? this.filtersRowCtrl.rowIndex !== h && this.filtersRowCtrl.setRowIndex(h) : this.filtersRowCtrl = this.createBean(new c0(h, this.pinned, "filter"));
    }, c = this.getAllCtrls();
    r(), l(), a();
    const d = this.getAllCtrls();
    this.comp.setCtrls(d), this.restoreFocusOnHeader(t, i), c.length !== d.length && this.beans.eventSvc.dispatchEvent({
      type: "headerRowsChanged"
    });
  }
  getHeaderCtrlForColumn(e) {
    const t = (o) => o == null ? void 0 : o.getHeaderCellCtrls().find((n) => n.column === e);
    if (hn(e))
      return t(this.columnsRowCtrl);
    if (this.groupsRowCtrls.length !== 0)
      for (let o = 0; o < this.groupsRowCtrls.length; o++) {
        const n = t(this.groupsRowCtrls[o]);
        if (n)
          return n;
      }
  }
  getHtmlElementForColumnHeader(e) {
    var t;
    return ((t = this.getHeaderCtrlForColumn(e)) == null ? void 0 : t.eGui) ?? null;
  }
  getRowType(e) {
    var t;
    return (t = this.getAllCtrls()[e]) == null ? void 0 : t.type;
  }
  focusHeader(e, t, o) {
    const s = this.getAllCtrls()[e];
    return s ? s.focusHeader(t, o) : !1;
  }
  getGroupRowCount() {
    return this.groupsRowCtrls.length;
  }
  getGroupRowCtrlAtIndex(e) {
    return this.groupsRowCtrls[e];
  }
  getRowCount() {
    return this.groupsRowCtrls.length + (this.columnsRowCtrl ? 1 : 0) + (this.filtersRowCtrl ? 1 : 0);
  }
  setHorizontalScroll(e) {
    this.comp.setViewportScrollLeft(e);
  }
  onScrollCallback(e) {
    this.addManagedElementListeners(this.eViewport, { scroll: e });
  }
  destroy() {
    this.filtersRowCtrl = this.destroyBean(this.filtersRowCtrl), this.columnsRowCtrl = this.destroyBean(this.columnsRowCtrl), this.groupsRowCtrls = this.destroyBeans(this.groupsRowCtrls), super.destroy();
  }
  setupDragAndDrop(e, t) {
    const o = e == null ? void 0 : e.createBodyDropTarget(this.pinned, t);
    o && this.createManagedBean(o);
  }
  restoreFocusOnHeader(e, t) {
    if (!t)
      return;
    const { column: o } = t;
    o.getPinned() == this.pinned && e.focusHeaderPosition({ headerPosition: t });
  }
  setupCenterWidth() {
    this.pinned == null && this.createManagedBean(new W2((e) => this.comp.setCenterWidth(`${e}px`), !0));
  }
}, vVe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "menuSvc";
  }
  postConstruct() {
    const { enterpriseMenuFactory: e, filterMenuFactory: t } = this.beans;
    this.activeMenuFactory = e ?? t;
  }
  showColumnMenu(e) {
    this.showColumnMenuCommon(this.activeMenuFactory, e, "columnMenu");
  }
  showFilterMenu(e) {
    this.showColumnMenuCommon(Wd(this.beans), e, e.containerType, !0);
  }
  showHeaderContextMenu(e, t, o) {
    var n;
    (n = this.activeMenuFactory) == null || n.showMenuAfterContextMenuEvent(e, t, o);
  }
  hidePopupMenu() {
    var e, t;
    (e = this.beans.contextMenuSvc) == null || e.hideActiveMenu(), (t = this.activeMenuFactory) == null || t.hideActiveMenu();
  }
  hideFilterMenu() {
    var e;
    (e = Wd(this.beans)) == null || e.hideActiveMenu();
  }
  isColumnMenuInHeaderEnabled(e) {
    var o;
    const { suppressHeaderMenuButton: t } = e.getColDef();
    return !t && !!((o = this.activeMenuFactory) != null && o.isMenuEnabled(e)) && ($t(this.gos) || !!this.beans.enterpriseMenuFactory);
  }
  isFilterMenuInHeaderEnabled(e) {
    var t;
    return !e.getColDef().suppressHeaderFilterButton && !!((t = this.beans.filterManager) != null && t.isFilterAllowed(e));
  }
  isHeaderContextMenuEnabled(e) {
    const t = e && hn(e) ? e.getColDef() : e == null ? void 0 : e.getColGroupDef();
    return !(t != null && t.suppressHeaderContextMenu) && this.gos.get("columnMenu") === "new";
  }
  isHeaderMenuButtonAlwaysShowEnabled() {
    return this.isSuppressMenuHide();
  }
  isHeaderMenuButtonEnabled() {
    const e = !this.isSuppressMenuHide();
    return !(ss() && e);
  }
  isHeaderFilterButtonEnabled(e) {
    return this.isFilterMenuInHeaderEnabled(e) && !$t(this.gos) && !this.isFloatingFilterButtonDisplayed(e);
  }
  isFilterMenuItemEnabled(e) {
    var t;
    return !!((t = this.beans.filterManager) != null && t.isFilterAllowed(e)) && !$t(this.gos) && !this.isFilterMenuInHeaderEnabled(e) && !this.isFloatingFilterButtonDisplayed(e);
  }
  isFloatingFilterButtonEnabled(e) {
    return !e.getColDef().suppressFloatingFilterButton;
  }
  isFloatingFilterButtonDisplayed(e) {
    return !!e.getColDef().floatingFilter && this.isFloatingFilterButtonEnabled(e);
  }
  isSuppressMenuHide() {
    const e = this.gos, t = e.get("suppressMenuHide");
    return $t(e) ? e.exists("suppressMenuHide") ? t : !1 : t;
  }
  showColumnMenuCommon(e, t, o, n) {
    const { positionBy: s, onClosedCallback: i } = t, r = t.column;
    if (s === "button") {
      const { buttonElement: l } = t;
      e == null || e.showMenuAfterButtonClick(r, l, o, i, n);
    } else if (s === "mouse") {
      const { mouseEvent: l } = t;
      e == null || e.showMenuAfterMouseEvent(r, l, o, i, n);
    } else if (r) {
      const l = this.beans, a = l.ctrlsSvc;
      a.getScrollFeature().ensureColumnVisible(r, "auto"), yo(l, () => {
        var d;
        const c = (d = a.getHeaderRowContainerCtrl(r.getPinned())) == null ? void 0 : d.getHeaderCtrlForColumn(r);
        c && (e == null || e.showMenuAfterButtonClick(
          r,
          c.getAnchorElementForMenu(n),
          o,
          i,
          n
        ));
      });
    }
  }
};
function Il(e, t, o) {
  e.menuVisible !== t && (e.menuVisible = t, e.dispatchColEvent("menuVisibleChanged", o));
}
function Wd(e) {
  const { enterpriseMenuFactory: t, filterMenuFactory: o, gos: n } = e;
  return t && $t(n) ? t : o;
}
var ya = class extends ga {
  constructor() {
    super(...arguments), this.errorMessages = null;
  }
  init(e) {
    this.params = e, this.initialiseEditor(e), this.eEditor.onValueChange(() => e.validate());
  }
  destroy() {
    this.errorMessages = null;
  }
}, Zb = class extends Re {
  constructor() {
    super();
  }
}, mVe = {
  tag: "span",
  cls: "ag-overlay-loading-center"
}, CVe = class extends Zb {
  init() {
    var t;
    const e = Ft((t = this.gos.get("overlayLoadingTemplate")) == null ? void 0 : t.trim());
    if (this.setTemplate(e ?? mVe), !e) {
      const n = this.getLocaleTextFunc()("loadingOoo", "Loading...");
      this.getGui().textContent = n, this.beans.ariaAnnounce.announceValue(n, "overlay");
    }
  }
}, wVe = { tag: "span", cls: "ag-overlay-no-rows-center" }, bVe = class extends Zb {
  init() {
    var t;
    const e = Ft((t = this.gos.get("overlayNoRowsTemplate")) == null ? void 0 : t.trim());
    if (this.setTemplate(e ?? wVe), !e) {
      const n = this.getLocaleTextFunc()("noRowsToShow", "No Rows To Show");
      this.getGui().textContent = n, this.beans.ariaAnnounce.announceValue(n, "overlay");
    }
  }
};
function Ri(e, t, o) {
  const n = Ie(e, t, o);
  if (n) {
    const { className: i } = n;
    if (typeof i == "string" && i.indexOf("ag-icon") > -1 || typeof i == "object" && i["ag-icon"])
      return n;
  }
  const s = ze({ tag: "span" });
  return s.appendChild(n), s;
}
function Ie(e, t, o) {
  var i;
  let n = null;
  e === "smallDown" ? X(262) : e === "smallLeft" ? X(263) : e === "smallRight" && X(264);
  const s = o && o.getColDef().icons;
  if (s && (n = s[e]), t.gos && !n) {
    const r = t.gos.get("icons");
    r && (n = r[e]);
  }
  if (n) {
    let r;
    if (typeof n == "function")
      r = n();
    else if (typeof n == "string")
      r = n;
    else {
      X(38, { iconName: e });
      return;
    }
    if (typeof r == "string")
      return y2(r);
    if (da(r))
      return r;
    X(133, { iconName: e });
    return;
  } else {
    const r = t.registry.getIcon(e);
    return r || (i = t.validation) == null || i.validateIcon(e), ze({
      tag: "span",
      cls: `ag-icon ag-icon-${r ?? e}`,
      role: "presentation",
      attrs: { unselectable: "on" }
    });
  }
}
var yVe = (
  /*css*/
  ".ag-dnd-ghost{align-items:center;background-color:var(--ag-drag-and-drop-image-background-color);border:var(--ag-drag-and-drop-image-border);border-radius:var(--ag-border-radius);box-shadow:var(--ag-drag-and-drop-image-shadow);color:var(--ag-text-color);cursor:move;display:flex;font-weight:500;gap:var(--ag-cell-widget-spacing);height:var(--ag-header-height);overflow:hidden;padding-left:var(--ag-cell-horizontal-padding);padding-right:var(--ag-cell-horizontal-padding);text-overflow:ellipsis;transform:translateY(calc(var(--ag-spacing)*2));white-space:nowrap}.ag-dnd-ghost-not-allowed{border:var(--ag-drag-and-drop-image-not-allowed-border)}"
), _Ve = {
  tag: "div",
  children: [
    {
      tag: "div",
      ref: "eGhost",
      cls: "ag-dnd-ghost ag-unselectable",
      children: [
        { tag: "span", ref: "eIcon", cls: "ag-dnd-ghost-icon ag-shake-left-to-right" },
        { tag: "div", ref: "eLabel", cls: "ag-dnd-ghost-label" }
      ]
    }
  ]
}, SVe = class extends Re {
  constructor() {
    super(), this.dragSource = null, this.eIcon = J, this.eLabel = J, this.eGhost = J, this.registerCSS(yVe);
  }
  postConstruct() {
    const e = (t) => Ri(t, this.beans, null);
    this.dropIconMap = {
      pinned: e("columnMovePin"),
      hide: e("columnMoveHide"),
      move: e("columnMoveMove"),
      left: e("columnMoveLeft"),
      right: e("columnMoveRight"),
      group: e("columnMoveGroup"),
      aggregate: e("columnMoveValue"),
      pivot: e("columnMovePivot"),
      notAllowed: e("dropNotAllowed")
    };
  }
  init(e) {
    this.dragSource = e.dragSource, this.setTemplate(_Ve), this.beans.environment.applyThemeClasses(this.eGhost);
  }
  destroy() {
    this.dragSource = null, super.destroy();
  }
  setIcon(e, t) {
    const { eGhost: o, eIcon: n, dragSource: s, dropIconMap: i, gos: r } = this;
    it(n);
    let l = null;
    e || (e = s != null && s.getDefaultIconName ? s.getDefaultIconName() : "notAllowed"), l = i[e], o.classList.toggle("ag-dnd-ghost-not-allowed", e === "notAllowed"), n.classList.toggle("ag-shake-left-to-right", t), !(l === i.hide && r.get("suppressDragLeaveHidesColumns")) && l && n.appendChild(l);
  }
  setLabel(e) {
    this.eLabel.textContent = e;
  }
}, xVe = (
  /*css*/
  ".ag-checkbox-cell{height:100%}"
), MVe = {
  tag: "div",
  cls: "ag-cell-wrapper ag-checkbox-cell",
  role: "presentation",
  children: [
    {
      tag: "ag-checkbox",
      ref: "eCheckbox",
      role: "presentation"
    }
  ]
}, AVe = class extends Re {
  constructor() {
    super(MVe, [ii]), this.eCheckbox = J, this.registerCSS(xVe);
  }
  init(e) {
    this.refresh(e);
    const { eCheckbox: t, beans: o } = this, n = t.getInputElement();
    n.setAttribute("tabindex", "-1"), ew(n, "polite"), this.addManagedListeners(n, {
      click: (s) => {
        if (vt(s), t.isDisabled())
          return;
        const i = t.getValue();
        this.onCheckboxChanged(i);
      },
      dblclick: (s) => {
        vt(s);
      }
    }), this.addManagedElementListeners(e.eGridCell, {
      keydown: (s) => {
        if (s.key === D.SPACE && !t.isDisabled()) {
          e.eGridCell === Ue(o) && t.toggle();
          const i = t.getValue();
          this.onCheckboxChanged(i), s.preventDefault();
        }
      }
    });
  }
  refresh(e) {
    return this.params = e, this.updateCheckbox(e), !0;
  }
  updateCheckbox(e) {
    let t, o = !0;
    const { value: n, column: s, node: i } = e;
    if (i.group && s)
      if (typeof n == "boolean")
        t = n;
      else {
        const u = s.getColId();
        u.startsWith($i) ? t = n == null || n === "" ? void 0 : n === "true" : i.aggData && i.aggData[u] !== void 0 || i.sourceRowIndex >= 0 ? t = n ?? void 0 : o = !1;
      }
    else
      t = n ?? void 0;
    const { eCheckbox: r } = this;
    if (!o) {
      r.setDisplayed(!1);
      return;
    }
    r.setValue(t);
    const l = e.disabled ?? !(s != null && s.isCellEditable(i));
    r.setDisabled(l);
    const a = this.getLocaleTextFunc(), c = aa(a, t), d = l ? c : `${a("ariaToggleCellValue", "Press SPACE to toggle cell value")} (${c})`;
    r.setInputAriaLabel(d);
  }
  onCheckboxChanged(e) {
    var r, l, a, c;
    const { params: t } = this, { column: o, node: n, value: s } = t;
    (l = (r = this.beans) == null ? void 0 : r.editSvc) == null || l.setEditingCells(
      [
        {
          column: o,
          colId: o.getColId(),
          rowIndex: n.rowIndex,
          rowPinned: n.rowPinned,
          state: "changed",
          oldValue: s,
          newValue: s
        }
      ],
      { update: !0, forceRefreshOfEditCellsOnly: !0 }
    );
    const i = n.setDataValue(o, e, "renderer");
    (c = this.beans.editSvc) == null || c.stopEditing(
      {
        rowNode: n,
        column: o
      },
      { source: (a = this.beans.editSvc) != null && a.isBatchEditing() ? "ui" : "api" }
    ), i || this.updateCheckbox(t);
  }
}, Ud = class {
  constructor(e, t) {
    this.beans = e, this.floating = t, this.all = /* @__PURE__ */ new Set(), this.visible = /* @__PURE__ */ new Set(), this.order = [], this.queued = /* @__PURE__ */ new Set();
  }
  size() {
    return this.visible.size;
  }
  add(e) {
    const { all: t, visible: o, order: n } = this;
    t.has(e) || (t.add(e), o.add(e), n.push(e), this.sort());
  }
  delete(e) {
    this.all.delete(e), this.visible.delete(e), this.queued.delete(e.id), Zt(this.order, e);
  }
  has(e) {
    return this.visible.has(e);
  }
  forEach(e) {
    this.order.forEach(e);
  }
  getByIndex(e) {
    return this.order[e];
  }
  getById(e) {
    for (const t of this.visible)
      if (t.id == e)
        return t;
  }
  clear() {
    const { all: e, visible: t, order: o, queued: n } = this;
    e.clear(), n.clear(), t.clear(), o.length = 0;
  }
  sort() {
    const { sortSvc: e, rowNodeSorter: t, gos: o } = this.beans, n = (e == null ? void 0 : e.getSortOptions()) ?? [], s = PVe(this.order);
    if (this.order.sort((r, l) => {
      var a, c;
      return (((a = r.pinnedSibling) == null ? void 0 : a.rowIndex) ?? 0) - (((c = l.pinnedSibling) == null ? void 0 : c.rowIndex) ?? 0);
    }), this.order = (t == null ? void 0 : t.doFullSort(this.order, n)) ?? this.order, !s)
      return;
    const i = or(o);
    i === "bottom" || i === "pinnedBottom" ? this.order.push(s) : this.order.unshift(s);
  }
  hide(e) {
    const { all: t, visible: o } = this;
    t.forEach((n) => e(n) ? o.delete(n) : o.add(n)), this.order = Array.from(o), this.sort();
  }
  queue(e) {
    this.queued.add(e);
  }
  unqueue(e) {
    this.queued.delete(e);
  }
  forEachQueued(e) {
    this.queued.forEach(e);
  }
};
function Gb(e) {
  var o;
  if (e.level === -1)
    return !0;
  const t = e.parent;
  return (o = t == null ? void 0 : t.childrenAfterSort) != null && o.some((n) => n == e) ? Gb(t) : !1;
}
function d0(e, t) {
  const { gos: o, rowModel: n, filterManager: s } = e;
  return $n(o) ? !n.getRowNode(t.id) : s != null && s.isAnyFilterPresent() ? !Gb(t) : o.get("pivotMode") ? !t.group : !1;
}
function LVe(e) {
  return !!e.footer && e.level === -1;
}
function EVe(e) {
  return !!e.pinnedSibling && LVe(e.pinnedSibling);
}
function PVe(e) {
  var o;
  const t = e.findIndex(EVe);
  if (t > -1)
    return (o = e.splice(t, 1)) == null ? void 0 : o[0];
}
var Kd = class extends K {
  postConstruct() {
    const { gos: e, beans: t } = this;
    this.top = new Ud(t, "top"), this.bottom = new Ud(t, "bottom");
    const o = (s) => d0(t, s.pinnedSibling), n = () => {
      const s = e.get("isRowPinned");
      s && e.get("enableRowPinning") && t.rowModel.forEachNode((i) => this.pinRow(i, s(i)), !0), this.refreshRowPositions(), this.dispatchRowPinnedEvents();
    };
    this.addManagedEventListeners({
      gridStylesChanged: this.onGridStylesChanges.bind(this),
      modelUpdated: ({ keepRenderedRows: s }) => {
        this.tryToEmptyQueues(), this.pinGrandTotalRow(), this.forContainers((r) => r.hide(o));
        const i = this.refreshRowPositions();
        (!s || i) && this.dispatchRowPinnedEvents();
      },
      columnRowGroupChanged: () => {
        this.forContainers(FVe), this.refreshRowPositions();
      },
      rowNodeDataChanged: ({ node: s }) => {
        const i = e.get("isRowPinnable");
        ((i == null ? void 0 : i(s)) ?? !0) || this.pinRow(s, null);
      },
      firstDataRendered: n
    }), this.addManagedPropertyListener("pivotMode", () => {
      this.forContainers((s) => s.hide(o)), this.dispatchRowPinnedEvents();
    }), this.addManagedPropertyListener("grandTotalRow", ({ currentValue: s }) => {
      this._grandTotalPinned = s === "pinnedBottom" ? "bottom" : s === "pinnedTop" ? "top" : null;
    }), this.addManagedPropertyListener("isRowPinned", n);
  }
  destroy() {
    this.reset(!1), super.destroy();
  }
  reset(e = !0) {
    this.forContainers((t) => {
      const o = [];
      t.forEach((n) => o.push(n)), o.forEach((n) => this.pinRow(n, null)), t.clear();
    }), e && this.dispatchRowPinnedEvents();
  }
  pinRow(e, t, o) {
    var r;
    if (e.footer && e.level > -1)
      return;
    if (e.footer && e.level === -1) {
      this._grandTotalPinned = t, IVe(this.beans);
      return;
    }
    const n = e.rowPinned ?? ((r = e.pinnedSibling) == null ? void 0 : r.rowPinned);
    if (n != null && t != null && t != n) {
      const l = e.rowPinned ? e : e.pinnedSibling, a = e.rowPinned ? e.pinnedSibling : e;
      this.pinRow(l, null, o), this.pinRow(a, t, o);
      return;
    }
    const i = o && TVe(this.beans, e, o);
    if (i) {
      i.forEach((l) => this.pinRow(l, t));
      return;
    }
    if (t == null) {
      const l = e.rowPinned ? e : e.pinnedSibling, a = this.findPinnedRowNode(l);
      if (!a)
        return;
      a.delete(l);
      const c = l.pinnedSibling;
      u0(l), this.refreshRowPositions(t), this.dispatchRowPinnedEvents(c);
    } else {
      const l = qd(this.beans, e, t), a = this.getContainer(t);
      a.add(l), d0(this.beans, e) && a.hide((c) => d0(this.beans, c.pinnedSibling)), this.refreshRowPositions(t), this.dispatchRowPinnedEvents(e);
    }
  }
  isManual() {
    return !0;
  }
  isEmpty(e) {
    return this.getContainer(e).size() === 0;
  }
  isRowsToRender(e) {
    return !this.isEmpty(e);
  }
  ensureRowHeightsValid() {
    let e = !1, t = 0;
    const o = (n) => {
      if (n.rowHeightEstimated) {
        const s = Dn(this.beans, n);
        n.setRowTop(t), n.setRowHeight(s.height), t += s.height, e = !0;
      }
    };
    return this.bottom.forEach(o), t = 0, this.top.forEach(o), this.eventSvc.dispatchEvent({
      type: "pinnedHeightChanged"
    }), e;
  }
  getPinnedTopTotalHeight() {
    return Yd(this.top);
  }
  getPinnedBottomTotalHeight() {
    return Yd(this.bottom);
  }
  getPinnedTopRowCount() {
    return this.top.size();
  }
  getPinnedBottomRowCount() {
    return this.bottom.size();
  }
  getPinnedTopRow(e) {
    return this.top.getByIndex(e);
  }
  getPinnedBottomRow(e) {
    return this.bottom.getByIndex(e);
  }
  getPinnedRowById(e, t) {
    return this.getContainer(t).getById(e);
  }
  forEachPinnedRow(e, t) {
    this.getContainer(e).forEach(t);
  }
  getPinnedState() {
    const e = (t) => {
      const o = [];
      return this.forEachPinnedRow(t, (n) => o.push(n.pinnedSibling.id)), o;
    };
    return {
      top: e("top"),
      bottom: e("bottom")
    };
  }
  setPinnedState(e) {
    this.forContainers((t, o) => {
      for (const n of e[o]) {
        const s = this.beans.rowModel.getRowNode(n);
        s ? this.pinRow(s, o) : t.queue(n);
      }
    });
  }
  getGrandTotalPinned() {
    return this._grandTotalPinned;
  }
  setGrandTotalPinned(e) {
    this._grandTotalPinned = e;
  }
  tryToEmptyQueues() {
    this.forContainers((e, t) => {
      const o = /* @__PURE__ */ new Set();
      e.forEachQueued((n) => {
        const s = this.beans.rowModel.getRowNode(n);
        s && o.add(s);
      });
      for (const n of o)
        e.unqueue(n.id), this.pinRow(n, t);
    });
  }
  pinGrandTotalRow() {
    var l;
    const { gos: e, beans: t, _grandTotalPinned: o } = this, n = t.rowModel;
    if (!dt(e))
      return;
    const s = (l = n.rootNode) == null ? void 0 : l.sibling;
    if (!s)
      return;
    const i = s.pinnedSibling, r = i && this.findPinnedRowNode(i);
    if (o) {
      if (r && r.floating !== o && (r.delete(i), u0(i)), !r || r.floating !== o) {
        const a = qd(t, s, o);
        this.getContainer(o).add(a);
      }
    } else {
      if (!r)
        return;
      r.delete(i), u0(i);
    }
  }
  onGridStylesChanges(e) {
    e.rowHeightChanged && this.forContainers(
      (t) => t.forEach((o) => o.setRowHeight(o.rowHeight, !0))
    );
  }
  getContainer(e) {
    return e === "top" ? this.top : this.bottom;
  }
  findPinnedRowNode(e) {
    if (this.top.has(e))
      return this.top;
    if (this.bottom.has(e))
      return this.bottom;
  }
  refreshRowPositions(e) {
    const t = (n) => RVe(this.beans, n);
    if (e)
      return t(this.getContainer(e));
    let o = !1;
    return this.forContainers((n) => {
      const s = t(n);
      o || (o = s);
    }), o;
  }
  forContainers(e) {
    e(this.top, "top"), e(this.bottom, "bottom");
  }
  dispatchRowPinnedEvents(e) {
    this.eventSvc.dispatchEvent({ type: "pinnedRowsChanged" }), e == null || e.dispatchRowEvent("rowPinned");
  }
};
function RVe(e, t) {
  let o = 0, n = !1;
  return t.forEach((s, i) => {
    if (n || (n = s.rowTop !== o), s.setRowTop(o), s.rowHeightEstimated || s.rowHeight == null) {
      const r = Dn(e, s).height;
      n || (n = s.rowHeight !== r), s.setRowHeight(r);
    }
    s.setRowIndex(i), o += s.rowHeight;
  }), n;
}
function qd(e, t, o) {
  if (t.pinnedSibling)
    return t.pinnedSibling;
  const n = vb(t, e);
  n.setRowTop(null), n.setRowIndex(null), n.rowPinned = o;
  const s = o === "top" ? Z2 : G2;
  return n.id = `${s}${o}-${t.id}`, n.pinnedSibling = t, t.pinnedSibling = n, n;
}
function u0(e) {
  if (!e.pinnedSibling)
    return;
  e.rowPinned = null, e.setRowTop(null), e.setRowIndex(null);
  const t = e.pinnedSibling;
  e.pinnedSibling = void 0, t && (t.pinnedSibling = void 0, t.rowPinned = null);
}
function FVe(e) {
  const t = /* @__PURE__ */ new Set();
  e.forEach((o) => {
    o.group && t.add(o);
  }), t.forEach((o) => e.delete(o));
}
function TVe(e, t, o) {
  var i;
  const { rowSpanSvc: n } = e, s = (o && (n == null ? void 0 : n.isCellSpanning(o, t))) ?? !1;
  if (o && s)
    return (i = n == null ? void 0 : n.getCellSpan(o, t)) == null ? void 0 : i.spannedNodes;
}
function Yd(e) {
  const t = e.size();
  if (t === 0)
    return 0;
  const o = e.getByIndex(t - 1);
  return o === void 0 ? 0 : o.rowTop + o.rowHeight;
}
function IVe({ gos: e, rowModel: t }) {
  dt(e) && t.refreshModel({ step: "map" });
}
var Qd = class extends K {
  constructor() {
    super(...arguments), this.nextId = 0, this.pinnedTopRows = { cache: {}, order: [] }, this.pinnedBottomRows = { cache: {}, order: [] };
  }
  postConstruct() {
    const e = this.gos;
    this.setPinnedRowData(e.get("pinnedTopRowData"), "top"), this.setPinnedRowData(e.get("pinnedBottomRowData"), "bottom"), this.addManagedPropertyListener("pinnedTopRowData", (t) => this.setPinnedRowData(t.currentValue, "top")), this.addManagedPropertyListener("pinnedBottomRowData", (t) => this.setPinnedRowData(t.currentValue, "bottom")), this.addManagedEventListeners({ gridStylesChanged: this.onGridStylesChanges.bind(this) });
  }
  reset() {
  }
  isEmpty(e) {
    return this.getCache(e).order.length === 0;
  }
  isRowsToRender(e) {
    return !this.isEmpty(e);
  }
  isManual() {
    return !1;
  }
  pinRow(e, t) {
  }
  onGridStylesChanges(e) {
    if (e.rowHeightChanged) {
      const t = (o) => {
        o.setRowHeight(o.rowHeight, !0);
      };
      cr(this.pinnedBottomRows, t), cr(this.pinnedTopRows, t);
    }
  }
  ensureRowHeightsValid() {
    let e = !1, t = 0;
    const o = (n) => {
      if (n.rowHeightEstimated) {
        const s = Dn(this.beans, n);
        n.setRowTop(t), n.setRowHeight(s.height), t += s.height, e = !0;
      }
    };
    return cr(this.pinnedBottomRows, o), t = 0, cr(this.pinnedTopRows, o), this.eventSvc.dispatchEvent({
      type: "pinnedHeightChanged"
    }), e;
  }
  setPinnedRowData(e, t) {
    this.updateNodesFromRowData(e, t), this.eventSvc.dispatchEvent({
      type: "pinnedRowDataChanged"
    });
  }
  /**
   * Updates existing RowNode instances and creates new ones if necessary
   *
   * Setting data as `undefined` will clear row nodes
   */
  updateNodesFromRowData(e, t) {
    const o = this.getCache(t);
    if (e === void 0) {
      o.order.length = 0, o.cache = {};
      return;
    }
    const n = Qs(this.gos), s = t === "top" ? Z2 : G2, i = new Set(o.order), r = [], l = /* @__PURE__ */ new Set();
    let a = 0, c = -1;
    for (const d of e) {
      const u = (n == null ? void 0 : n({ data: d, level: 0, rowPinned: t })) ?? s + this.nextId++;
      if (l.has(u)) {
        X(96, { id: u, data: d });
        continue;
      }
      c++, l.add(u), r.push(u);
      const h = Er(o, u);
      if (h !== void 0)
        h.data !== d && h.updateData(d), a += this.setRowTopAndRowIndex(h, a, c), i.delete(u);
      else {
        const p = new pn(this.beans);
        p.id = u, p.data = d, p.rowPinned = t, a += this.setRowTopAndRowIndex(p, a, c), o.cache[u] = p, o.order.push(u);
      }
    }
    i.forEach((d) => {
      var u;
      (u = Er(o, d)) == null || u.clearRowTopAndRowIndex(), delete o.cache[d];
    }), o.order = r;
  }
  setRowTopAndRowIndex(e, t, o) {
    return e.setRowTop(t), e.setRowHeight(Dn(this.beans, e).height), e.setRowIndex(o), e.rowHeight;
  }
  getPinnedTopTotalHeight() {
    return Jd(this.pinnedTopRows);
  }
  getPinnedBottomTotalHeight() {
    return Jd(this.pinnedBottomRows);
  }
  getPinnedTopRowCount() {
    return u5(this.pinnedTopRows);
  }
  getPinnedBottomRowCount() {
    return u5(this.pinnedBottomRows);
  }
  getPinnedTopRow(e) {
    return d5(this.pinnedTopRows, e);
  }
  getPinnedBottomRow(e) {
    return d5(this.pinnedBottomRows, e);
  }
  getPinnedRowById(e, t) {
    return Er(this.getCache(t), e);
  }
  forEachPinnedRow(e, t) {
    return cr(this.getCache(e), t);
  }
  getCache(e) {
    return e === "top" ? this.pinnedTopRows : this.pinnedBottomRows;
  }
  getPinnedState() {
    return { top: [], bottom: [] };
  }
  setPinnedState() {
  }
  getGrandTotalPinned() {
  }
  setGrandTotalPinned() {
  }
};
function Jd(e) {
  const t = u5(e);
  if (t === 0)
    return 0;
  const o = d5(e, t - 1);
  return o === void 0 ? 0 : o.rowTop + o.rowHeight;
}
function Er(e, t) {
  return e.cache[t];
}
function d5(e, t) {
  return Er(e, e.order[t]);
}
function cr(e, t) {
  e.order.forEach((o, n) => {
    const s = Er(e, o);
    s && t(s, n);
  });
}
function u5(e) {
  return e.order.length;
}
var DVe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "pinnedRowModel";
  }
  postConstruct() {
    const { gos: e } = this, t = () => {
      const o = e.get("enableRowPinning"), n = or(e), i = !!o || (n === "pinnedBottom" || n === "pinnedTop"), r = i ? this.inner instanceof Qd : this.inner instanceof Kd;
      this.inner && r && this.destroyBean(this.inner), (r || !this.inner) && (this.inner = this.createManagedBean(
        i ? new Kd() : new Qd()
      ));
    };
    this.addManagedPropertyListeners(["enableRowPinning", "grandTotalRow"], t), t();
  }
  reset() {
    return this.inner.reset();
  }
  isEmpty(e) {
    return this.inner.isEmpty(e);
  }
  isManual() {
    return this.inner.isManual();
  }
  isRowsToRender(e) {
    return this.inner.isRowsToRender(e);
  }
  pinRow(e, t, o) {
    return this.inner.pinRow(e, t, o);
  }
  ensureRowHeightsValid() {
    return this.inner.ensureRowHeightsValid();
  }
  getPinnedRowById(e, t) {
    return this.inner.getPinnedRowById(e, t);
  }
  getPinnedTopTotalHeight() {
    return this.inner.getPinnedTopTotalHeight();
  }
  getPinnedBottomTotalHeight() {
    return this.inner.getPinnedBottomTotalHeight();
  }
  getPinnedTopRowCount() {
    return this.inner.getPinnedTopRowCount();
  }
  getPinnedBottomRowCount() {
    return this.inner.getPinnedBottomRowCount();
  }
  getPinnedTopRow(e) {
    return this.inner.getPinnedTopRow(e);
  }
  getPinnedBottomRow(e) {
    return this.inner.getPinnedBottomRow(e);
  }
  forEachPinnedRow(e, t) {
    return this.inner.forEachPinnedRow(e, t);
  }
  getPinnedState() {
    return this.inner.getPinnedState();
  }
  setPinnedState(e) {
    return this.inner.setPinnedState(e);
  }
  setGrandTotalPinned(e) {
    return this.inner.setGrandTotalPinned(e);
  }
  getGrandTotalPinned() {
    return this.inner.getGrandTotalPinned();
  }
}, kVe = "ROOT_NODE_ID", Nb = class extends K {
  constructor() {
    super(...arguments), this.nextId = 0, this.allNodesMap = {}, this.rootNode = null;
  }
  getRowNode(e) {
    return this.allNodesMap[e];
  }
  extractRowData() {
    var e, t;
    return (t = (e = this.rootNode) == null ? void 0 : e.allLeafChildren) == null ? void 0 : t.map((o) => o.data);
  }
  activate(e) {
    this.rootNode = e, e.group = !0, e.level = -1, e.id = kVe, e.allLeafChildren = [], e.childrenAfterGroup = [], e.childrenAfterSort = [], e.childrenAfterAggFilter = [], e.childrenAfterFilter = [], this.updateRootSiblingArrays(e);
  }
  deactivate() {
    this.rootNode && (this.allNodesMap = {}, this.rootNode = null);
  }
  destroy() {
    super.destroy(), this.allNodesMap = {}, this.rootNode = null;
  }
  setNewRowData(e) {
    const t = this.rootNode;
    t && (this.dispatchRowDataUpdateStartedEvent(e), t.childrenAfterFilter = null, t.childrenAfterGroup = null, t.childrenAfterAggFilter = null, t.childrenAfterSort = null, t.childrenMapped = null, t.updateHasChildren(), this.allNodesMap = {}, this.nextId = 0, this.loadNewRowData(e), this.updateRootSiblingArrays(t));
  }
  updateRootSiblingArrays(e) {
    const t = e.sibling;
    t && (t.childrenAfterFilter = e.childrenAfterFilter, t.childrenAfterGroup = e.childrenAfterGroup, t.childrenAfterAggFilter = e.childrenAfterAggFilter, t.childrenAfterSort = e.childrenAfterSort, t.childrenMapped = e.childrenMapped, t.allLeafChildren = e.allLeafChildren);
  }
  loadNewRowData(e) {
    this.rootNode.allLeafChildren = (e == null ? void 0 : e.map((t, o) => this.createRowNode(t, o))) ?? [];
  }
  setImmutableRowData(e, t) {
    var C;
    const o = Qs(this.gos), n = !this.gos.get("suppressMaintainUnsortedOrder"), s = e.changedRowNodes, i = /* @__PURE__ */ new Set(), r = this.rootNode, l = r.allLeafChildren, a = l.length;
    let c = !1, d = !1, u = !1, h = !1;
    for (let m = 0, w = -1, y = t.length; m < y; m++) {
      const b = t[m];
      let _ = this.getRowNode(
        o({ data: b, level: 0 })
      );
      if (!_)
        c = !0, _ = this.createRowNode(b, -1), s.add(_);
      else {
        if (n) {
          const M = _.sourceRowIndex;
          h || (h = M <= w || // A node was moved up, so order changed
          c), w = M;
        }
        _.data !== b && (u = !0, _.updateData(b), s.update(_));
      }
      i.add(_);
    }
    const p = [];
    for (let m = 0; m < a; m++) {
      const w = l[m];
      i.has(w) || (d = !0, w.isSelected() && p.push(w), w.pinnedSibling && ((C = this.beans.pinnedRowModel) == null || C.pinRow(w.pinnedSibling, null)), this.rowNodeDeleted(w), s.remove(w));
    }
    if (c || d || h) {
      const m = new Array(i.size);
      let w = 0;
      if (!n)
        for (let b = 0; b < a; ++b) {
          const _ = l[b];
          i.delete(_) && (_.sourceRowIndex = w, m[w++] = _);
        }
      for (const b of i)
        b.sourceRowIndex = w, m[w++] = b;
      r.allLeafChildren = m;
      const y = r.sibling;
      y && (y.allLeafChildren = m), e.rowNodesOrderChanged || (e.rowNodesOrderChanged = h);
    }
    (c || d || h || u) && (this.deselectNodes(p), e.rowDataUpdated = !0);
  }
  /** Called when a node needs to be deleted */
  rowNodeDeleted(e) {
    e.clearRowTopAndRowIndex();
    const t = e.id, o = this.allNodesMap;
    o[t] === e && delete o[t];
  }
  updateRowData(e, t) {
    this.dispatchRowDataUpdateStartedEvent(e.add);
    const o = {
      changedRowNodes: t,
      rowNodeTransaction: { remove: [], update: [], add: [] },
      rowsInserted: !1
    }, n = [], s = Qs(this.gos);
    return this.executeRemove(s, e, o, n), this.executeUpdate(s, e, o, n), this.executeAdd(e, o), this.deselectNodes(n), o;
  }
  executeAdd(e, t) {
    const o = e.add;
    if (!(o != null && o.length))
      return;
    let n = this.rootNode.allLeafChildren, s = n.length;
    if (typeof e.addIndex == "number" && (s = this.sanitizeAddIndex(e.addIndex), s > 0 && this.gos.get("treeData") && this.gos.get("getDataPath")))
      for (let u = 0; u < n.length; u++) {
        const h = n[u];
        if ((h == null ? void 0 : h.rowIndex) == s - 1) {
          s = u + 1;
          break;
        }
      }
    const i = o.length, r = t.changedRowNodes, l = new Array(i);
    for (let d = 0; d < i; d++) {
      const u = this.createRowNode(o[d], s + d);
      r.add(u), l[d] = u;
    }
    const a = this.rootNode;
    if (s < n.length) {
      const d = n.slice(0, s), u = n.slice(s, n.length), h = d.length + l.length;
      for (let p = 0, C = u.length; p < C; ++p)
        u[p].sourceRowIndex = h + p;
      n = [...d, ...l, ...u], t.rowsInserted = !0;
    } else
      n = n.concat(l);
    a.allLeafChildren = n;
    const c = a.sibling;
    c && (c.allLeafChildren = n), t.rowNodeTransaction.add = l;
  }
  executeRemove(e, t, { changedRowNodes: o, rowNodeTransaction: n }, s) {
    var c, d;
    const { remove: i } = t;
    if (!(i != null && i.length))
      return;
    const r = {};
    i.forEach((u) => {
      var p;
      const h = this.lookupRowNode(e, u);
      h && (h.isSelected() && s.push(h), h.pinnedSibling && ((p = this.beans.pinnedRowModel) == null || p.pinRow(h.pinnedSibling, null)), h.clearRowTopAndRowIndex(), r[h.id] = !0, delete this.allNodesMap[h.id], n.remove.push(h), o.remove(h));
    });
    const l = this.rootNode;
    l.allLeafChildren = ((c = l.allLeafChildren) == null ? void 0 : c.filter((u) => !r[u.id])) ?? null, (d = l.allLeafChildren) == null || d.forEach((u, h) => {
      u.sourceRowIndex = h;
    });
    const a = l.sibling;
    a && (a.allLeafChildren = l.allLeafChildren);
  }
  executeUpdate(e, t, { changedRowNodes: o, rowNodeTransaction: n }, s) {
    const { update: i } = t;
    i != null && i.length && i.forEach((r) => {
      const l = this.lookupRowNode(e, r);
      l && (l.updateData(r), !l.selectable && l.isSelected() && s.push(l), n.update.push(l), o.update(l));
    });
  }
  dispatchRowDataUpdateStartedEvent(e) {
    this.eventSvc.dispatchEvent({
      type: "rowDataUpdateStarted",
      firstRowData: e != null && e.length ? e[0] : null
    });
  }
  deselectNodes(e) {
    var s;
    const t = "rowDataChanged", o = this.beans.selectionSvc, n = e.length > 0;
    n && (o == null || o.setNodesSelected({
      newValue: !1,
      nodes: e,
      suppressFinishActions: !0,
      source: t
    })), (s = o == null ? void 0 : o.updateGroupsFromChildrenSelections) == null || s.call(o, t), n && this.eventSvc.dispatchEvent({
      type: "selectionChanged",
      source: t,
      selectedNodes: (o == null ? void 0 : o.getSelectedNodes()) ?? null,
      serverSideState: null
    });
  }
  sanitizeAddIndex(e) {
    var o;
    const t = ((o = this.rootNode.allLeafChildren) == null ? void 0 : o.length) ?? 0;
    return e < 0 || e >= t || Number.isNaN(e) ? t : Math.ceil(e);
  }
  createRowNode(e, t) {
    const o = new pn(this.beans);
    return o.parent = this.rootNode, o.level = 0, o.group = !1, o.expanded = !1, o.sourceRowIndex = t, o.setDataAndId(e, String(this.nextId)), this.allNodesMap[o.id] && X(2, { nodeId: o.id }), this.allNodesMap[o.id] = o, this.nextId++, o;
  }
  lookupRowNode(e, t) {
    var n, s;
    let o;
    if (e) {
      const i = e({ data: t, level: 0 });
      if (o = this.allNodesMap[i], !o)
        return qe(4, { id: i }), null;
    } else if (o = (s = (n = this.rootNode) == null ? void 0 : n.allLeafChildren) == null ? void 0 : s.find((i) => i.data === t), !o)
      return qe(5, { data: t }), null;
    return o || null;
  }
};
function p1(e) {
  return !!(e.rowPinned && e.pinnedSibling);
}
function Mo(e, t, o, n) {
  const s = t === "top";
  if (!o)
    return Mo(
      e,
      t,
      s ? e.getPinnedTopRow(0) : e.getPinnedBottomRow(0),
      n
    );
  if (!n) {
    const a = s ? e.getPinnedTopRowCount() : e.getPinnedBottomRowCount();
    return Mo(
      e,
      t,
      o,
      s ? e.getPinnedTopRow(a - 1) : e.getPinnedBottomRow(a - 1)
    );
  }
  let i = !1, r = !1;
  const l = [];
  return e.forEachPinnedRow(t, (a) => {
    if (a === o && !i) {
      i = !0, l.push(a);
      return;
    }
    if (i && a === n) {
      r = !0, l.push(a);
      return;
    }
    i && !r && l.push(a);
  }), l;
}
var HVe = {
  tag: "div",
  cls: "ag-selection-checkbox",
  role: "presentation",
  children: [
    {
      tag: "ag-checkbox",
      ref: "eCheckbox",
      role: "presentation"
    }
  ]
}, VVe = class extends Re {
  constructor() {
    super(HVe, [ii]), this.eCheckbox = J;
  }
  postConstruct() {
    this.eCheckbox.setPassive(!0);
  }
  onDataChanged() {
    this.onSelectionChanged();
  }
  onSelectableChanged() {
    this.showOrHideSelect();
  }
  onSelectionChanged() {
    const e = this.getLocaleTextFunc(), { rowNode: t, eCheckbox: o } = this, n = t.isSelected(), s = aa(e, n), [i, r] = t.selectable ? ["ariaRowToggleSelection", "Press Space to toggle row selection"] : ["ariaRowSelectionDisabled", "Row Selection is disabled for this row"], l = e(i, r);
    o.setValue(n, !0), o.setInputAriaLabel(`${l} (${s})`);
  }
  init(e) {
    if (this.rowNode = e.rowNode, this.column = e.column, this.overrides = e.overrides, this.onSelectionChanged(), this.addManagedListeners(this.eCheckbox.getInputElement(), {
      // we don't want double click on this icon to open a group
      dblclick: vt,
      click: (n) => {
        var s;
        vt(n), (s = this.beans.selectionSvc) == null || s.handleSelectionEvent(n, this.rowNode, "checkboxSelected");
      }
    }), this.addManagedListeners(this.rowNode, {
      rowSelected: this.onSelectionChanged.bind(this),
      dataChanged: this.onDataChanged.bind(this),
      selectableChanged: this.onSelectableChanged.bind(this)
    }), this.addManagedPropertyListener("rowSelection", ({ currentValue: n, previousValue: s }) => {
      const i = typeof n == "object" ? qa(n) : void 0, r = typeof s == "object" ? qa(s) : void 0;
      i !== r && this.onSelectableChanged();
    }), e5(this.gos) || typeof this.getIsVisible() == "function") {
      const n = this.showOrHideSelect.bind(this);
      this.addManagedEventListeners({ displayedColumnsChanged: n }), this.addManagedListeners(this.rowNode, {
        dataChanged: n,
        cellChanged: n
      }), this.showOrHideSelect();
    }
    this.eCheckbox.getInputElement().setAttribute("tabindex", "-1");
  }
  showOrHideSelect() {
    const { column: e, rowNode: t, overrides: o, gos: n } = this, s = t.selectable, i = this.getIsVisible();
    let r;
    if (typeof i == "function") {
      const u = o == null ? void 0 : o.callbackParams;
      if (!e)
        r = i({ ...u, node: t, data: t.data });
      else {
        const h = e.createColumnFunctionCallbackParams(t);
        r = i({ ...u, ...h });
      }
    } else
      r = i ?? !1;
    const l = s && !r || !s && r, a = s || r, c = n.get("rowSelection"), d = c && typeof c != "string" ? !qa(c) : !!(e != null && e.getColDef().showDisabledCheckboxes);
    if (this.setVisible(a && (l ? d : !0)), this.setDisplayed(a && (l ? d : !0)), a && this.eCheckbox.setDisabled(l), o != null && o.removeHidden) {
      this.setDisplayed(a);
      return;
    }
  }
  getIsVisible() {
    var o, n;
    const e = this.overrides;
    if (e)
      return e.isVisible;
    const t = this.gos.get("rowSelection");
    return t && typeof t != "string" ? Os(t) : (n = (o = this.column) == null ? void 0 : o.getColDef()) == null ? void 0 : n.checkboxSelection;
  }
}, OVe = class {
  constructor(e, t) {
    this.rowModel = e, this.pinnedRowModel = t, this.selectAll = !1, this.rootId = null, this.endId = null, this.cachedRange = [];
  }
  reset() {
    this.rootId = null, this.endId = null, this.cachedRange.length = 0;
  }
  setRoot(e) {
    this.rootId = e.id, this.endId = null, this.cachedRange.length = 0;
  }
  setEndRange(e) {
    this.endId = e.id, this.cachedRange.length = 0;
  }
  getRange() {
    if (this.cachedRange.length === 0) {
      const e = this.getRoot(), t = this.getEnd();
      if (e == null || t == null)
        return this.cachedRange;
      this.cachedRange = this.getNodesInRange(e, t) ?? [];
    }
    return this.cachedRange;
  }
  isInRange(e) {
    return this.rootId === null ? !1 : this.getRange().some((t) => t.id === e.id);
  }
  getRoot(e) {
    if (this.rootId)
      return this.getRowNode(this.rootId);
    if (e)
      return this.setRoot(e), e;
  }
  getEnd() {
    if (this.endId)
      return this.getRowNode(this.endId);
  }
  getRowNode(e) {
    let t;
    const { rowModel: o, pinnedRowModel: n } = this;
    return t ?? (t = o.getRowNode(e)), n != null && n.isManual() && (t ?? (t = n.getPinnedRowById(e, "top")), t ?? (t = n.getPinnedRowById(e, "bottom"))), t;
  }
  /**
   * Truncates the range to the given node (assumed to be within the current range).
   * Returns nodes that remain in the current range and those that should be removed
   *
   * @param node - Node at which to truncate the range
   * @returns Object of nodes to either keep or discard (i.e. deselect) from the range
   */
  truncate(e) {
    const t = this.getRange();
    if (t.length === 0)
      return { keep: [], discard: [] };
    const o = t[0].id === this.rootId, n = t.findIndex((s) => s.id === e.id);
    if (n > -1) {
      const s = t.slice(0, n), i = t.slice(n + 1);
      return this.setEndRange(e), o ? { keep: s, discard: i } : { keep: i, discard: s };
    } else
      return { keep: t, discard: [] };
  }
  /**
   * Extends the range to the given node. Returns nodes that remain in the current range
   * and those that should be removed.
   *
   * @param node - Node marking the new end of the range
   * @returns Object of nodes to either keep or discard (i.e. deselect) from the range
   */
  extend(e, t = !1) {
    const o = this.getRoot();
    if (o == null) {
      const s = this.getRange().slice();
      return t && e.depthFirstSearch((i) => !i.group && s.push(i)), s.push(e), this.setRoot(e), { keep: s, discard: [] };
    }
    const n = this.getNodesInRange(o, e);
    if (!n)
      return this.setRoot(e), { keep: [e], discard: [] };
    if (n.find((s) => s.id === this.endId))
      return this.setEndRange(e), { keep: this.getRange(), discard: [] };
    {
      const s = this.getRange().slice();
      return this.setEndRange(e), { keep: this.getRange(), discard: s };
    }
  }
  getNodesInRange(e, t) {
    const { pinnedRowModel: o, rowModel: n } = this;
    if (!(o != null && o.isManual()))
      return n.getNodesInRangeForSelection(e, t);
    if (e.rowPinned === "top" && !t.rowPinned)
      return Mo(o, "top", e, void 0).concat(n.getNodesInRangeForSelection(n.getRow(0), t) ?? []);
    if (e.rowPinned === "bottom" && !t.rowPinned) {
      const s = Mo(o, "bottom", void 0, e), i = n.getRowCount(), r = n.getRow(i - 1);
      return (n.getNodesInRangeForSelection(t, r) ?? []).concat(s);
    }
    if (!e.rowPinned && !t.rowPinned)
      return n.getNodesInRangeForSelection(e, t);
    if (e.rowPinned === "top" && t.rowPinned === "top")
      return Mo(o, "top", e, t);
    if (e.rowPinned === "bottom" && t.rowPinned === "top") {
      const s = Mo(o, "top", t, void 0), i = Mo(o, "bottom", void 0, e), r = n.getRow(0), l = n.getRow(n.getRowCount() - 1);
      return s.concat(n.getNodesInRangeForSelection(r, l) ?? []).concat(i);
    }
    if (!e.rowPinned && t.rowPinned === "top")
      return Mo(o, "top", t, void 0).concat(n.getNodesInRangeForSelection(n.getRow(0), e) ?? []);
    if (e.rowPinned === "top" && t.rowPinned === "bottom") {
      const s = Mo(o, "top", e, void 0), i = Mo(o, "bottom", void 0, t), r = n.getRow(0), l = n.getRow(n.getRowCount() - 1);
      return s.concat(n.getNodesInRangeForSelection(r, l) ?? []).concat(i);
    }
    if (e.rowPinned === "bottom" && t.rowPinned === "bottom")
      return Mo(o, "bottom", e, t);
    if (!e.rowPinned && t.rowPinned === "bottom") {
      const s = Mo(o, "bottom", void 0, t), i = n.getRow(n.getRowCount());
      return (n.getNodesInRangeForSelection(e, i) ?? []).concat(s);
    }
    return null;
  }
}, BVe = class extends K {
  constructor(e) {
    super(), this.column = e, this.cbSelectAllVisible = !1, this.processingEventFromCheckbox = !1;
  }
  onSpaceKeyDown(e) {
    const t = this.cbSelectAll;
    t.isDisplayed() && !t.getGui().contains(Ue(this.beans)) && (e.preventDefault(), t.setValue(!t.getValue()));
  }
  getCheckboxGui() {
    return this.cbSelectAll.getGui();
  }
  setComp(e) {
    this.headerCellCtrl = e;
    const t = this.createManagedBean(new fa());
    this.cbSelectAll = t, t.addCss("ag-header-select-all"), no(t.getGui(), "presentation"), this.showOrHideSelectAll();
    const o = this.updateStateOfCheckbox.bind(this);
    this.addManagedEventListeners({
      newColumnsLoaded: () => this.showOrHideSelectAll(),
      displayedColumnsChanged: this.onDisplayedColumnsChanged.bind(this),
      selectionChanged: o,
      paginationChanged: o,
      modelUpdated: o
    }), this.addManagedPropertyListener("rowSelection", ({ currentValue: n, previousValue: s }) => {
      const i = (r) => typeof r == "string" || !r || r.mode === "singleRow" ? void 0 : r.selectAll;
      i(n) !== i(s) && this.showOrHideSelectAll(), this.updateStateOfCheckbox();
    }), this.addManagedListeners(t, { fieldValueChanged: this.onCbSelectAll.bind(this) }), t.getInputElement().setAttribute("tabindex", "-1"), this.refreshSelectAllLabel();
  }
  onDisplayedColumnsChanged(e) {
    this.isAlive() && this.showOrHideSelectAll(e.source === "uiColumnMoved");
  }
  showOrHideSelectAll(e = !1) {
    const t = this.isCheckboxSelection();
    this.cbSelectAllVisible = t, this.cbSelectAll.setDisplayed(t), t && (this.checkRightRowModelType("selectAllCheckbox"), this.checkSelectionType("selectAllCheckbox"), this.updateStateOfCheckbox()), this.refreshSelectAllLabel(e);
  }
  updateStateOfCheckbox() {
    if (!this.cbSelectAllVisible || this.processingEventFromCheckbox)
      return;
    this.processingEventFromCheckbox = !0;
    const e = this.getSelectAllMode(), t = this.beans.selectionSvc, o = this.cbSelectAll, n = t.getSelectAllState(e);
    o.setValue(n);
    const s = t.hasNodesToSelect(e);
    o.setDisabled(!s), this.refreshSelectAllLabel(), this.processingEventFromCheckbox = !1;
  }
  refreshSelectAllLabel(e = !1) {
    const t = this.getLocaleTextFunc(), { headerCellCtrl: o, cbSelectAll: n, cbSelectAllVisible: s } = this, i = n.getValue(), r = aa(t, i), l = t("ariaRowSelectAll", "Press Space to toggle all rows selection");
    o.setAriaDescriptionProperty(
      "selectAll",
      s ? `${l} (${r})` : null
    ), n.setInputAriaLabel(t("ariaHeaderSelection", "Column with Header Selection")), e || o.announceAriaDescription();
  }
  checkSelectionType(e) {
    return Ur(this.gos) ? !0 : (X(128, { feature: e }), !1);
  }
  checkRightRowModelType(e) {
    const { gos: t, rowModel: o } = this.beans;
    return dt(t) || $n(t) ? !0 : (X(129, { feature: e, rowModel: o.getType() }), !1);
  }
  onCbSelectAll() {
    if (this.processingEventFromCheckbox || !this.cbSelectAllVisible)
      return;
    const e = this.cbSelectAll.getValue(), t = this.getSelectAllMode();
    let o = "uiSelectAll";
    t === "currentPage" ? o = "uiSelectAllCurrentPage" : t === "filtered" && (o = "uiSelectAllFiltered");
    const n = { source: o, selectAll: t }, s = this.beans.selectionSvc;
    e ? s.selectAllRowNodes(n) : s.deselectAllRowNodes(n);
  }
  /**
   * Checkbox is enabled when either the `headerCheckbox` option is enabled in the new selection API
   * or `headerCheckboxSelection` is enabled in the legacy API.
   */
  isCheckboxSelection() {
    const { column: e, gos: t, beans: o } = this, i = typeof t.get("rowSelection") == "object" ? "headerCheckbox" : "headerCheckboxSelection";
    return zb(o, e) && this.checkRightRowModelType(i) && this.checkSelectionType(i);
  }
  getSelectAllMode() {
    const e = Fw(this.gos, !1);
    if (e)
      return e;
    const { headerCheckboxSelectionCurrentPageOnly: t, headerCheckboxSelectionFilteredOnly: o } = this.column.getColDef();
    return t ? "currentPage" : o ? "filtered" : "all";
  }
  destroy() {
    super.destroy(), this.cbSelectAll = void 0, this.headerCellCtrl = void 0;
  }
};
function zb({ gos: e, selectionColSvc: t }, o) {
  const n = e.get("rowSelection"), s = o.getColDef(), { headerCheckboxSelection: i } = s;
  let r = !1;
  if (typeof n == "object") {
    const a = hs(o), c = ha(o);
    (Wr(n) === "autoGroupColumn" && c || a && (t != null && t.isSelectionColumnEnabled())) && (r = W1(n));
  } else
    typeof i == "function" ? r = i(Pe(e, { column: o, colDef: s })) : r = !!i;
  return r;
}
var $Ve = class extends K {
  postConstruct() {
    const { gos: e, beans: t } = this;
    this.selectionCtx = new OVe(t.rowModel, t.pinnedRowModel), this.addManagedPropertyListeners(["isRowSelectable", "rowSelection"], () => {
      const o = e5(e);
      o !== this.isRowSelectable && (this.isRowSelectable = o, this.updateSelectable());
    }), this.isRowSelectable = e5(e), this.addManagedEventListeners({
      cellValueChanged: (o) => this.updateRowSelectable(o.node),
      rowNodeDataChanged: (o) => this.updateRowSelectable(o.node)
    });
  }
  destroy() {
    super.destroy(), this.selectionCtx.reset();
  }
  createCheckboxSelectionComponent() {
    return new VVe();
  }
  createSelectAllFeature(e) {
    if (zb(this.beans, e))
      return new BVe(e);
  }
  isMultiSelect() {
    return Ur(this.gos);
  }
  onRowCtrlSelected(e, t, o) {
    const n = !!e.rowNode.isSelected();
    e.forEachGui(o, (s) => {
      s.rowComp.toggleCss("ag-row-selected", n);
      const i = s.element;
      m2(i, n), i.contains(Ue(this.beans)) && t(s);
    });
  }
  announceAriaRowSelection(e) {
    var s;
    if (this.isRowSelectionBlocked(e))
      return;
    const t = e.isSelected();
    if (!e.selectable)
      return;
    const n = this.getLocaleTextFunc()(
      t ? "ariaRowDeselect" : "ariaRowSelect",
      `Press SPACE to ${t ? "deselect" : "select"} this row`
    );
    (s = this.beans.ariaAnnounce) == null || s.announceValue(n, "rowSelection");
  }
  isRowSelectionBlocked(e) {
    return !e.selectable || e.rowPinned && !p1(e) || !os(this.gos);
  }
  updateRowSelectable(e, t) {
    var n;
    const o = e.rowPinned && e.pinnedSibling ? (
      // If row node is pinned sibling, copy selectable status over from sibling row node
      e.pinnedSibling.selectable
    ) : (
      // otherwise calculate selectable state directly
      ((n = this.isRowSelectable) == null ? void 0 : n.call(this, e)) ?? !0
    );
    return this.setRowSelectable(e, o, t), o;
  }
  setRowSelectable(e, t, o) {
    if (e.selectable !== t) {
      if (e.selectable = t, e.dispatchRowEvent("selectableChanged"), o)
        return;
      if (Kr(this.gos)) {
        const s = this.calculateSelectedFromChildren(e);
        this.setNodesSelected({ nodes: [e], newValue: s ?? !1, source: "selectableChanged" });
        return;
      }
      e.isSelected() && !e.selectable && this.setNodesSelected({ nodes: [e], newValue: !1, source: "selectableChanged" });
    }
  }
  calculateSelectedFromChildren(e) {
    var n;
    let t = !1, o = !1;
    if (!((n = e.childrenAfterGroup) != null && n.length))
      return e.selectable ? e.__selected : null;
    for (let s = 0; s < e.childrenAfterGroup.length; s++) {
      const i = e.childrenAfterGroup[s];
      let r = i.isSelected();
      if (!i.selectable) {
        const l = this.calculateSelectedFromChildren(i);
        if (l === null)
          continue;
        r = l;
      }
      switch (r) {
        case !0:
          t = !0;
          break;
        case !1:
          o = !0;
          break;
        default:
          return;
      }
    }
    if (!(t && o))
      return t ? !0 : o ? !1 : e.selectable ? e.__selected : null;
  }
  selectRowNode(e, t, o, n = "api") {
    const s = !e.selectable && t, i = e.__selected === t;
    if (s || i)
      return !1;
    e.__selected = t, e.dispatchRowEvent("rowSelected");
    const r = e.sibling;
    r && r.footer && r.__localEventService && r.dispatchRowEvent("rowSelected");
    const l = e.pinnedSibling;
    return l && l.rowPinned && l.__localEventService && l.dispatchRowEvent("rowSelected"), this.eventSvc.dispatchEvent({
      ...fb(e, this.gos, "rowSelected"),
      event: o || null,
      source: n
    }), !0;
  }
  isCellCheckboxSelection(e, t) {
    const o = this.gos.get("rowSelection");
    if (o && typeof o != "string") {
      const n = hs(e) && Os(o);
      return e.isColumnFunc(t, n);
    } else
      return e.isColumnFunc(t, e.colDef.checkboxSelection);
  }
  inferNodeSelections(e, t, o, n) {
    const { gos: s, selectionCtx: i } = this, r = e.isSelected(), l = Kr(s), a = LIe(s), c = EIe(s), d = this.isMultiSelect(), u = n === "rowClicked";
    if (u && !(a || c))
      return null;
    if (t && o && d) {
      const h = i.getRoot();
      if (h)
        if (h.isSelected()) {
          const p = i.isInRange(e) ? i.truncate(e) : i.extend(e, l);
          return {
            deselect: p.discard,
            select: p.keep,
            reset: !1
          };
        } else {
          const p = i.extend(e, l);
          return {
            select: [],
            deselect: p.keep,
            reset: !1
          };
        }
      else return null;
    } else if (t && d) {
      const h = i.selectAll ? this.beans.rowModel.getRow(0) : void 0, p = i.getRoot(h), C = i.isInRange(e) ? i.truncate(e) : i.extend(e, l);
      return {
        select: C.keep,
        deselect: C.discard,
        reset: i.selectAll || !!(p && !p.isSelected())
      };
    } else if (o) {
      if (u) {
        const h = !r;
        return h && !a || !h && !c ? null : (i.setRoot(e), {
          node: e,
          newValue: h,
          clearSelection: !1
        });
      }
      return i.setRoot(e), {
        node: e,
        newValue: !r,
        clearSelection: !d
      };
    } else {
      i.setRoot(e);
      const h = PIe(s), p = Sl(s) === "filteredDescendants", C = u && (!h || !a);
      if (p && r === void 0 && dt(s))
        return {
          node: e,
          newValue: !1,
          checkFilteredNodes: !0,
          clearSelection: !d || C
        };
      if (u) {
        const m = r ? !h : a;
        return m === r && !C || m && !a || !m && !c ? null : {
          node: e,
          newValue: m,
          clearSelection: !d || C,
          keepDescendants: e.group && l
        };
      }
      return {
        node: e,
        newValue: !r,
        clearSelection: !d || C
      };
    }
  }
}, Y1 = {
  TAB_GUARD: "ag-tab-guard",
  TAB_GUARD_TOP: "ag-tab-guard-top",
  TAB_GUARD_BOTTOM: "ag-tab-guard-bottom"
}, ZVe = class extends K {
  constructor(e) {
    super(), this.skipTabGuardFocus = !1, this.forcingFocusOut = !1, this.allowFocus = !1;
    const {
      comp: t,
      eTopGuard: o,
      eBottomGuard: n,
      focusTrapActive: s,
      forceFocusOutWhenTabGuardsAreEmpty: i,
      isFocusableContainer: r,
      focusInnerElement: l,
      onFocusIn: a,
      onFocusOut: c,
      shouldStopEventPropagation: d,
      onTabKeyDown: u,
      handleKeyDown: h,
      isEmpty: p,
      eFocusableElement: C
    } = e;
    this.comp = t, this.eTopGuard = o, this.eBottomGuard = n, this.providedFocusInnerElement = l, this.eFocusableElement = C, this.focusTrapActive = !!s, this.forceFocusOutWhenTabGuardsAreEmpty = !!i, this.isFocusableContainer = !!r, this.providedFocusIn = a, this.providedFocusOut = c, this.providedShouldStopEventPropagation = d, this.providedOnTabKeyDown = u, this.providedHandleKeyDown = h, this.providedIsEmpty = p;
  }
  postConstruct() {
    this.createManagedBean(
      new gs(this.eFocusableElement, {
        shouldStopEventPropagation: () => this.shouldStopEventPropagation(),
        onTabKeyDown: (e) => this.onTabKeyDown(e),
        handleKeyDown: (e) => this.handleKeyDown(e),
        onFocusIn: (e) => this.onFocusIn(e),
        onFocusOut: (e) => this.onFocusOut(e)
      })
    ), this.activateTabGuards(), [this.eTopGuard, this.eBottomGuard].forEach(
      (e) => this.addManagedElementListeners(e, { focus: this.onFocus.bind(this) })
    );
  }
  handleKeyDown(e) {
    this.providedHandleKeyDown && this.providedHandleKeyDown(e);
  }
  tabGuardsAreActive() {
    return !!this.eTopGuard && this.eTopGuard.hasAttribute("tabIndex");
  }
  shouldStopEventPropagation() {
    return this.providedShouldStopEventPropagation ? this.providedShouldStopEventPropagation() : !1;
  }
  activateTabGuards() {
    if (this.forcingFocusOut)
      return;
    const e = this.gos.get("tabIndex");
    this.comp.setTabIndex(e.toString());
  }
  deactivateTabGuards() {
    this.comp.setTabIndex();
  }
  onFocus(e) {
    if (this.isFocusableContainer && !this.eFocusableElement.contains(e.relatedTarget) && !this.allowFocus) {
      this.findNextElementOutsideAndFocus(e.target === this.eBottomGuard);
      return;
    }
    if (this.skipTabGuardFocus) {
      this.skipTabGuardFocus = !1;
      return;
    }
    if (this.forceFocusOutWhenTabGuardsAreEmpty && (this.providedIsEmpty ? this.providedIsEmpty() : Fn(this.eFocusableElement, ".ag-tab-guard").length === 0)) {
      this.findNextElementOutsideAndFocus(e.target === this.eBottomGuard);
      return;
    }
    if (this.isFocusableContainer && this.eFocusableElement.contains(e.relatedTarget))
      return;
    const t = e.target === this.eBottomGuard;
    !(this.providedFocusInnerElement ? this.providedFocusInnerElement(t) : this.focusInnerElement(t)) && this.forceFocusOutWhenTabGuardsAreEmpty && this.findNextElementOutsideAndFocus(e.target === this.eBottomGuard);
  }
  findNextElementOutsideAndFocus(e) {
    var a;
    const t = Pt(this.beans), o = Fn(t.body, null, !0), n = o.indexOf(e ? this.eTopGuard : this.eBottomGuard);
    if (n === -1)
      return;
    let s, i;
    e ? (s = 0, i = n) : (s = n + 1, i = o.length);
    const r = o.slice(s, i), l = this.gos.get("tabIndex");
    r.sort((c, d) => {
      const u = parseInt(c.getAttribute("tabindex") || "0"), h = parseInt(d.getAttribute("tabindex") || "0");
      return h === l ? 1 : u === l ? -1 : u === 0 ? 1 : h === 0 ? -1 : u - h;
    }), (a = r[e ? r.length - 1 : 0]) == null || a.focus();
  }
  onFocusIn(e) {
    this.focusTrapActive || this.forcingFocusOut || (this.providedFocusIn && this.providedFocusIn(e), this.isFocusableContainer || this.deactivateTabGuards());
  }
  onFocusOut(e) {
    this.focusTrapActive || (this.providedFocusOut && this.providedFocusOut(e), this.eFocusableElement.contains(e.relatedTarget) || this.activateTabGuards());
  }
  onTabKeyDown(e) {
    if (this.providedOnTabKeyDown) {
      this.providedOnTabKeyDown(e);
      return;
    }
    if (this.focusTrapActive || e.defaultPrevented)
      return;
    const t = this.tabGuardsAreActive();
    t && this.deactivateTabGuards();
    const o = this.getNextFocusableElement(e.shiftKey);
    t && setTimeout(() => this.activateTabGuards(), 0), o && (o.focus(), e.preventDefault());
  }
  focusInnerElement(e = !1) {
    const t = Fn(this.eFocusableElement);
    return this.tabGuardsAreActive() && (t.splice(0, 1), t.splice(t.length - 1, 1)), t.length ? (t[e ? t.length - 1 : 0].focus({ preventScroll: !0 }), !0) : !1;
  }
  getNextFocusableElement(e) {
    return Yt(this.beans, this.eFocusableElement, !1, e);
  }
  forceFocusOutOfContainer(e = !1) {
    if (this.forcingFocusOut)
      return;
    const t = e ? this.eTopGuard : this.eBottomGuard;
    this.activateTabGuards(), this.skipTabGuardFocus = !0, this.forcingFocusOut = !0, t.focus(), window.setTimeout(() => {
      this.forcingFocusOut = !1, this.activateTabGuards();
    });
  }
  isTabGuard(e, t) {
    return e === this.eTopGuard && !t || e === this.eBottomGuard && (t ?? !0);
  }
  setAllowFocus(e) {
    this.allowFocus = e;
  }
}, jb = class extends K {
  constructor(e) {
    super(), this.comp = e;
  }
  initialiseTabGuard(e) {
    this.eTopGuard = this.createTabGuard("top"), this.eBottomGuard = this.createTabGuard("bottom"), this.eFocusableElement = this.comp.getFocusableElement();
    const { eTopGuard: t, eBottomGuard: o, eFocusableElement: n } = this, s = [t, o], i = {
      setTabIndex: (w) => {
        s.forEach(
          (y) => w != null ? y.setAttribute("tabindex", w) : y.removeAttribute("tabindex")
        );
      }
    };
    this.addTabGuards(t, o);
    const {
      focusTrapActive: r = !1,
      onFocusIn: l,
      onFocusOut: a,
      focusInnerElement: c,
      handleKeyDown: d,
      onTabKeyDown: u,
      shouldStopEventPropagation: h,
      isEmpty: p,
      forceFocusOutWhenTabGuardsAreEmpty: C,
      isFocusableContainer: m
    } = e;
    this.tabGuardCtrl = this.createManagedBean(
      new ZVe({
        comp: i,
        focusTrapActive: r,
        eTopGuard: t,
        eBottomGuard: o,
        eFocusableElement: n,
        onFocusIn: l,
        onFocusOut: a,
        focusInnerElement: c,
        handleKeyDown: d,
        onTabKeyDown: u,
        shouldStopEventPropagation: h,
        isEmpty: p,
        forceFocusOutWhenTabGuardsAreEmpty: C,
        isFocusableContainer: m
      })
    );
  }
  getTabGuardCtrl() {
    return this.tabGuardCtrl;
  }
  createTabGuard(e) {
    const t = Pt(this.beans).createElement("div"), o = e === "top" ? Y1.TAB_GUARD_TOP : Y1.TAB_GUARD_BOTTOM;
    return t.classList.add(Y1.TAB_GUARD, o), no(t, "presentation"), t;
  }
  addTabGuards(e, t) {
    const o = this.eFocusableElement;
    o.insertAdjacentElement("afterbegin", e), o.insertAdjacentElement("beforeend", t);
  }
  removeAllChildrenExceptTabGuards() {
    const e = [this.eTopGuard, this.eBottomGuard];
    it(this.comp.getFocusableElement()), this.addTabGuards(...e);
  }
  forceFocusOutOfContainer(e = !1) {
    this.tabGuardCtrl.forceFocusOutOfContainer(e);
  }
  appendChild(e, t, o) {
    da(t) || (t = t.getGui());
    const { eBottomGuard: n } = this;
    n ? n.insertAdjacentElement("beforebegin", t) : e(t, o);
  }
  destroy() {
    const { eTopGuard: e, eBottomGuard: t } = this;
    Kt(e), Kt(t), super.destroy();
  }
}, ri = class extends Re {
  initialiseTabGuard(e) {
    this.tabGuardFeature = this.createManagedBean(new jb(this)), this.tabGuardFeature.initialiseTabGuard(e);
  }
  forceFocusOutOfContainer(e = !1) {
    this.tabGuardFeature.forceFocusOutOfContainer(e);
  }
  appendChild(e, t) {
    this.tabGuardFeature.appendChild(super.appendChild.bind(this), e, t);
  }
}, _n = class {
  constructor(e, t = !1) {
    this.DOUBLE_TAP_MILLIS = 500, this.destroyFuncs = [], this.touching = !1, this.localEventService = new ls(), this.preventMouseClick = t;
    const o = this.onTouchStart.bind(this), n = this.onTouchMove.bind(this), s = this.onTouchEnd.bind(this);
    e.addEventListener("touchstart", o, { passive: !0 }), e.addEventListener("touchmove", n, { passive: !0 }), e.addEventListener("touchend", s, { passive: !1 }), this.destroyFuncs.push(() => {
      e.removeEventListener("touchstart", o, { passive: !0 }), e.removeEventListener("touchmove", n, { passive: !0 }), e.removeEventListener("touchend", s, { passive: !1 });
    });
  }
  getActiveTouch(e) {
    for (let t = 0; t < e.length; t++)
      if (e[t].identifier === this.touchStart.identifier)
        return e[t];
    return null;
  }
  addEventListener(e, t) {
    this.localEventService.addEventListener(e, t);
  }
  removeEventListener(e, t) {
    this.localEventService.removeEventListener(e, t);
  }
  onTouchStart(e) {
    if (this.touching)
      return;
    this.touchStart = e.touches[0], this.touching = !0, this.moved = !1;
    const t = this.touchStart;
    window.setTimeout(() => {
      const o = this.touchStart === t;
      if (this.touching && o && !this.moved) {
        this.moved = !0;
        const n = {
          type: "longTap",
          touchStart: this.touchStart,
          touchEvent: e
        };
        this.localEventService.dispatchEvent(n);
      }
    }, 500);
  }
  onTouchMove(e) {
    if (!this.touching)
      return;
    const t = this.getActiveTouch(e.touches);
    if (!t)
      return;
    !pw(t, this.touchStart, 4) && (this.moved = !0);
  }
  onTouchEnd(e) {
    if (this.touching) {
      if (!this.moved) {
        const t = {
          type: "tap",
          touchStart: this.touchStart
        };
        this.localEventService.dispatchEvent(t), this.checkForDoubleTap();
      }
      this.preventMouseClick && e.cancelable && e.preventDefault(), this.touching = !1;
    }
  }
  checkForDoubleTap() {
    const e = Date.now();
    if (this.lastTapTime && this.lastTapTime > 0)
      if (e - this.lastTapTime > this.DOUBLE_TAP_MILLIS) {
        const o = {
          type: "doubleTap",
          touchStart: this.touchStart
        };
        this.localEventService.dispatchEvent(o), this.lastTapTime = null;
      } else
        this.lastTapTime = e;
    else
      this.lastTapTime = e;
  }
  destroy() {
    this.destroyFuncs.forEach((e) => e());
  }
}, Wb = class {
  constructor(e) {
    this.tickingInterval = null, this.onScrollCallback = null, this.scrollContainer = e.scrollContainer, this.scrollHorizontally = e.scrollAxis.indexOf("x") !== -1, this.scrollVertically = e.scrollAxis.indexOf("y") !== -1, this.scrollByTick = e.scrollByTick != null ? e.scrollByTick : 20, e.onScrollCallback && (this.onScrollCallback = e.onScrollCallback), this.scrollVertically && (this.getVerticalPosition = e.getVerticalPosition, this.setVerticalPosition = e.setVerticalPosition), this.scrollHorizontally && (this.getHorizontalPosition = e.getHorizontalPosition, this.setHorizontalPosition = e.setHorizontalPosition), this.shouldSkipVerticalScroll = e.shouldSkipVerticalScroll || (() => !1), this.shouldSkipHorizontalScroll = e.shouldSkipHorizontalScroll || (() => !1);
  }
  check(e, t = !1) {
    const o = t || this.shouldSkipVerticalScroll();
    if (o && this.shouldSkipHorizontalScroll())
      return;
    const n = this.scrollContainer.getBoundingClientRect(), s = this.scrollByTick;
    this.tickLeft = e.clientX < n.left + s, this.tickRight = e.clientX > n.right - s, this.tickUp = e.clientY < n.top + s && !o, this.tickDown = e.clientY > n.bottom - s && !o, this.tickLeft || this.tickRight || this.tickUp || this.tickDown ? this.ensureTickingStarted() : this.ensureCleared();
  }
  ensureTickingStarted() {
    this.tickingInterval === null && (this.tickingInterval = window.setInterval(this.doTick.bind(this), 100), this.tickCount = 0);
  }
  doTick() {
    this.tickCount++;
    const e = this.tickCount > 20 ? 200 : this.tickCount > 10 ? 80 : 40;
    if (this.scrollVertically) {
      const t = this.getVerticalPosition();
      this.tickUp && this.setVerticalPosition(t - e), this.tickDown && this.setVerticalPosition(t + e);
    }
    if (this.scrollHorizontally) {
      const t = this.getHorizontalPosition();
      this.tickLeft && this.setHorizontalPosition(t - e), this.tickRight && this.setHorizontalPosition(t + e);
    }
    this.onScrollCallback && this.onScrollCallback();
  }
  ensureCleared() {
    this.tickingInterval && (window.clearInterval(this.tickingInterval), this.tickingInterval = null);
  }
}, Ub = class {
  constructor(e = "javascript") {
    this.frameworkName = e, this.renderingEngine = "vanilla", this.batchFrameworkComps = !1, this.wrapIncoming = (t) => t(), this.wrapOutgoing = (t) => t(), this.baseDocLink = `${ww}/${this.frameworkName}-data-grid`, vIe(this.baseDocLink);
  }
  frameworkComponent(e) {
    return null;
  }
  isFrameworkComponent(e) {
    return !1;
  }
  getDocLink(e) {
    return `${this.baseDocLink}${e ? `/${e}` : ""}`;
  }
};
function GVe(e) {
  return {
    beanName: "gridApi",
    bean: e.getBean("apiFunctionSvc").api
  };
}
var NVe = [
  // Validate license first
  "licenseManager",
  // core beans only
  "environment",
  "eventSvc",
  "gos",
  "paginationAutoPageSizeSvc",
  "apiFunctionSvc",
  "gridApi",
  "registry",
  "agCompUtils",
  "userCompFactory",
  "rowContainerHeight",
  "horizontalResizeSvc",
  "localeSvc",
  "pinnedRowModel",
  "dragSvc",
  "colGroupSvc",
  "visibleCols",
  "popupSvc",
  "selectionSvc",
  "colFilter",
  "quickFilter",
  "filterManager",
  "colModel",
  "headerNavigation",
  "pageBounds",
  "pagination",
  "pageBoundsListener",
  "rowSpanSvc",
  "stickyRowSvc",
  "rowRenderer",
  "expressionSvc",
  "alignedGridsSvc",
  "navigation",
  "valueCache",
  "valueSvc",
  "autoWidthCalc",
  "filterMenuFactory",
  "dragAndDrop",
  "focusSvc",
  "cellNavigation",
  "cellStyles",
  "scrollVisibleSvc",
  "sortSvc",
  "colHover",
  "colAnimation",
  "autoColSvc",
  "selectionColSvc",
  "changeDetectionSvc",
  "animationFrameSvc",
  "undoRedo",
  "colDefFactory",
  "rowStyleSvc",
  "rowNodeBlockLoader",
  "rowNodeSorter",
  "ctrlsSvc",
  "pinnedCols",
  "dataTypeSvc",
  "syncSvc",
  "overlays",
  "stateSvc",
  "expansionSvc",
  "apiEventSvc",
  "ariaAnnounce",
  "menuSvc",
  "colMoves",
  "colAutosize",
  "colFlex",
  "colResize",
  "pivotColsSvc",
  "valueColsSvc",
  "rowGroupColsSvc",
  "colNames",
  "colViewport",
  "pivotResultCols",
  "showRowGroupCols",
  "validation"
  // Have validations run last
], Xd = Object.fromEntries(
  NVe.map((e, t) => [e, t])
);
function zVe(e, t) {
  const o = (e.beanName ? Xd[e.beanName] : void 0) ?? Number.MAX_SAFE_INTEGER, n = (t.beanName ? Xd[t.beanName] : void 0) ?? Number.MAX_SAFE_INTEGER;
  return o - n;
}
function jVe(e, t) {
  return (e == null ? void 0 : e.beanName) === "gridDestroySvc" ? -1 : (t == null ? void 0 : t.beanName) === "gridDestroySvc" ? 1 : 0;
}
var WVe = { tag: "div", cls: "ag-pinned-left-header", role: "rowgroup" }, UVe = { tag: "div", cls: "ag-pinned-right-header", role: "rowgroup" }, KVe = {
  tag: "div",
  cls: "ag-header-viewport",
  role: "rowgroup",
  attrs: { tabindex: "-1" },
  children: [{ tag: "div", ref: "eCenterContainer", cls: "ag-header-container", role: "presentation" }]
}, h0 = class extends Re {
  constructor(e) {
    super(), this.eCenterContainer = J, this.headerRowComps = {}, this.rowCompsList = [], this.pinned = e;
  }
  postConstruct() {
    this.selectAndSetTemplate();
    const e = {
      setDisplayed: (o) => this.setDisplayed(o),
      setCtrls: (o) => this.setCtrls(o),
      // only gets called for center section
      setCenterWidth: (o) => this.eCenterContainer.style.width = o,
      setViewportScrollLeft: (o) => this.getGui().scrollLeft = o,
      // only gets called for pinned sections
      setPinnedContainerWidth: (o) => {
        const n = this.getGui();
        n.style.width = o, n.style.maxWidth = o, n.style.minWidth = o;
      }
    };
    this.createManagedBean(new fVe(this.pinned)).setComp(e, this.getGui());
  }
  selectAndSetTemplate() {
    const e = this.pinned == "left", t = this.pinned == "right", o = e ? WVe : t ? UVe : KVe;
    this.setTemplate(o), this.eRowContainer = this.eCenterContainer !== J ? this.eCenterContainer : this.getGui();
  }
  destroy() {
    this.setCtrls([]), super.destroy();
  }
  destroyRowComp(e) {
    this.destroyBean(e), this.eRowContainer.removeChild(e.getGui());
  }
  setCtrls(e) {
    const t = this.headerRowComps;
    this.headerRowComps = {}, this.rowCompsList = [];
    let o;
    const n = (s) => {
      const i = s.getGui();
      i.parentElement != this.eRowContainer && this.eRowContainer.appendChild(i), o && cw(this.eRowContainer, i, o), o = i;
    };
    e.forEach((s) => {
      const i = s.instanceId, r = t[i];
      delete t[i];
      const l = r || this.createBean(new uVe(s));
      this.headerRowComps[i] = l, this.rowCompsList.push(l), n(l);
    }), Object.values(t).forEach((s) => this.destroyRowComp(s));
  }
}, qVe = { tag: "div", cls: "ag-header", role: "presentation" }, YVe = class extends Re {
  constructor() {
    super(qVe);
  }
  postConstruct() {
    const e = {
      toggleCss: (n, s) => this.toggleCss(n, s),
      setHeightAndMinHeight: (n) => {
        this.getGui().style.height = n, this.getGui().style.minHeight = n;
      }
    };
    this.createManagedBean(new sVe()).setComp(e, this.getGui(), this.getFocusableElement());
    const o = (n) => {
      this.createManagedBean(n), this.appendChild(n);
    };
    o(new h0("left")), o(new h0(null)), o(new h0("right"));
  }
}, QVe = {
  selector: "AG-HEADER-ROOT",
  component: YVe
}, JVe = class extends Re {
  constructor(e, t, o, n, s) {
    super(), this.cellCtrl = t, this.rendererVersion = 0, this.editorVersion = 0, this.beans = e, this.gos = e.gos, this.column = t.column, this.rowNode = t.rowNode, this.eRow = n;
    const i = ze({
      tag: "div",
      role: t.getCellAriaRole(),
      attrs: {
        "comp-id": `${this.getCompId()}`,
        "col-id": t.column.colIdSanitised
      }
    });
    this.eCell = i;
    let r;
    t.isCellSpanning() ? (r = ze({
      tag: "div",
      cls: "ag-spanned-cell-wrapper",
      role: "presentation"
    }), r.appendChild(i), this.setTemplateFromElement(r)) : this.setTemplateFromElement(i), this.cellCssManager = new Kw(() => i), this.forceWrapper = t.isForceWrapper(), this.refreshWrapper(!1);
    const l = {
      toggleCss: (a, c) => this.cellCssManager.toggleCss(a, c),
      setUserStyles: (a) => a1(i, a),
      getFocusableElement: () => i,
      setIncludeSelection: (a) => this.includeSelection = a,
      setIncludeRowDrag: (a) => this.includeRowDrag = a,
      setIncludeDndSource: (a) => this.includeDndSource = a,
      setRenderDetails: (a, c, d) => this.setRenderDetails(a, c, d),
      setEditDetails: (a, c, d) => this.setEditDetails(a, c, d),
      getCellEditor: () => this.cellEditor || null,
      getCellRenderer: () => this.cellRenderer || null,
      getParentOfValue: () => this.getParentOfValue(),
      refreshEditStyles: (a, c) => this.refreshEditStyles(a, c)
    };
    t.setComp(l, i, r, this.eCellWrapper, o, s, void 0);
  }
  getParentOfValue() {
    return this.eCellValue ?? this.eCellWrapper ?? this.eCell;
  }
  setRenderDetails(e, t, o) {
    var i;
    if (this.cellEditor && !this.cellEditorPopupWrapper)
      return;
    this.firstRender = this.firstRender == null;
    const s = this.refreshWrapper(!1);
    this.refreshEditStyles(!1), e ? !(o || s) && this.refreshCellRenderer(e) || (this.destroyRenderer(), this.createCellRendererInstance(e)) : (this.destroyRenderer(), this.insertValueWithoutCellRenderer(t)), (i = this.rowDraggingComp) == null || i.refreshVisibility();
  }
  setEditDetails(e, t, o) {
    e ? this.createCellEditorInstance(e, t, o) : this.destroyEditor();
  }
  removeControls() {
    const e = this.beans.context;
    this.checkboxSelectionComp = e.destroyBean(this.checkboxSelectionComp), this.dndSourceComp = e.destroyBean(this.dndSourceComp), this.rowDraggingComp = e.destroyBean(this.rowDraggingComp);
  }
  // returns true if wrapper was changed
  refreshWrapper(e) {
    const t = this.includeRowDrag || this.includeDndSource || this.includeSelection, o = t || this.forceWrapper, n = o && this.eCellWrapper == null;
    n && (this.eCellWrapper = ze({ tag: "div", cls: "ag-cell-wrapper", role: "presentation" }), this.eCell.appendChild(this.eCellWrapper));
    const s = !o && this.eCellWrapper != null;
    s && (Kt(this.eCellWrapper), this.eCellWrapper = void 0), this.cellCssManager.toggleCss("ag-cell-value", !o);
    const i = !e && o, r = i && this.eCellValue == null;
    r && (this.eCellValue = ze({ tag: "span", cls: "ag-cell-value", role: "presentation" }), this.eCellWrapper.appendChild(this.eCellValue));
    const l = !i && this.eCellValue != null;
    l && (Kt(this.eCellValue), this.eCellValue = void 0);
    const a = n || s || r || l;
    return a && this.removeControls(), !e && t && this.addControls(), a;
  }
  addControls() {
    const { cellCtrl: e, eCellWrapper: t, eCellValue: o, includeRowDrag: n, includeDndSource: s, includeSelection: i } = this, r = (l) => {
      l && t.insertBefore(l.getGui(), o);
    };
    n && this.rowDraggingComp == null && (this.rowDraggingComp = e.createRowDragComp(), r(this.rowDraggingComp)), s && this.dndSourceComp == null && (this.dndSourceComp = e.createDndSource(), r(this.dndSourceComp)), i && this.checkboxSelectionComp == null && (this.checkboxSelectionComp = e.createSelectionCheckbox(), r(this.checkboxSelectionComp));
  }
  createCellEditorInstance(e, t, o) {
    const n = this.editorVersion, s = e.newAgStackInstance(), { params: i } = e;
    s.then((l) => this.afterCellEditorCreated(n, l, i, t, o)), Xe(this.cellEditor) && i.cellStartedEdit && this.cellCtrl.focusCell(!0);
  }
  insertValueWithoutCellRenderer(e) {
    const t = this.getParentOfValue();
    it(t);
    const o = ni(e);
    o != null && (t.textContent = o);
  }
  destroyRenderer() {
    const { context: e } = this.beans;
    this.cellRenderer = e.destroyBean(this.cellRenderer), Kt(this.cellRendererGui), this.cellRendererGui = null, this.rendererVersion++;
  }
  destroyEditor() {
    var o, n;
    const { context: e } = this.beans;
    (((o = this.cellEditorPopupWrapper) == null ? void 0 : o.getGui().contains(Ue(this.beans))) || this.cellCtrl.hasBrowserFocus()) && this.eCell.focus({ preventScroll: !0 }), (n = this.hideEditorPopup) == null || n.call(this), this.hideEditorPopup = void 0, this.cellEditor = e.destroyBean(this.cellEditor), this.cellEditorPopupWrapper = e.destroyBean(this.cellEditorPopupWrapper), Kt(this.cellEditorGui), this.cellCtrl.disableEditorTooltipFeature(), this.cellEditorGui = null, this.editorVersion++;
  }
  refreshCellRenderer(e) {
    var o;
    if (((o = this.cellRenderer) == null ? void 0 : o.refresh) == null || this.cellRendererClass !== e.componentClass)
      return !1;
    const t = this.cellRenderer.refresh(e.params);
    return t === !0 || t === void 0;
  }
  createCellRendererInstance(e) {
    var i;
    const t = this.rendererVersion, o = (r) => (l) => {
      if (this.rendererVersion !== t || !this.isAlive())
        return;
      const c = r.newAgStackInstance(), d = this.afterCellRendererCreated.bind(
        this,
        t,
        r.componentClass
      );
      c == null || c.then(d);
    }, { animationFrameSvc: n } = this.beans;
    let s;
    if (n != null && n.active && this.firstRender ? s = (r, l = !1) => {
      n.createTask(
        o(r),
        this.rowNode.rowIndex,
        "p2",
        r.componentFromFramework,
        l
      );
    } : s = (r) => o(r)(), (i = e.params) != null && i.deferRender && !this.cellCtrl.rowNode.group) {
      const { loadingComp: r, onReady: l } = this.cellCtrl.getDeferLoadingCellRenderer();
      r && (s(r), l.then(() => s(e, !0)));
    } else
      s(e);
  }
  afterCellRendererCreated(e, t, o) {
    if (!this.isAlive() || e !== this.rendererVersion) {
      this.beans.context.destroyBean(o);
      return;
    }
    this.cellRenderer = o, this.cellRendererClass = t;
    const s = o.getGui();
    if (this.cellRendererGui = s, s != null) {
      const i = this.getParentOfValue();
      it(i), i.appendChild(s);
    }
  }
  afterCellEditorCreated(e, t, o, n, s) {
    var c;
    const i = e !== this.editorVersion, { context: r } = this.beans;
    if (i) {
      r.destroyBean(t);
      return;
    }
    if (t.isCancelBeforeStart && t.isCancelBeforeStart()) {
      r.destroyBean(t), this.cellCtrl.stopEditing(!0);
      return;
    }
    if (!t.getGui) {
      X(97, { colId: this.column.getId() }), r.destroyBean(t);
      return;
    }
    this.cellEditor = t, this.cellEditorGui = t.getGui();
    const a = n || t.isPopup !== void 0 && t.isPopup();
    a ? this.addPopupCellEditor(o, s) : this.addInCellEditor(), this.refreshEditStyles(!0, a), (c = t.afterGuiAttached) == null || c.call(t), this.cellCtrl.enableEditorTooltipFeature(t), this.cellCtrl.cellEditorAttached();
  }
  refreshEditStyles(e, t) {
    const { cellCssManager: o } = this;
    o.toggleCss("ag-cell-inline-editing", e && !t), o.toggleCss("ag-cell-popup-editing", e && !!t), o.toggleCss("ag-cell-not-inline-editing", !e || !!t);
  }
  addInCellEditor() {
    const { eCell: e } = this;
    e.contains(Ue(this.beans)) && e.focus(), this.destroyRenderer(), this.refreshWrapper(!0), it(this.getParentOfValue()), this.cellEditorGui && this.getParentOfValue().appendChild(this.cellEditorGui);
  }
  addPopupCellEditor(e, t) {
    var M;
    const { gos: o, context: n, popupSvc: s, editSvc: i } = this.beans;
    o.get("editType") === "fullRow" && X(98);
    const r = this.cellEditorPopupWrapper = n.createBean(
      i.createPopupEditorWrapper(e)
    ), { cellEditor: l, cellEditorGui: a, eCell: c, rowNode: d, column: u, cellCtrl: h } = this, p = r.getGui();
    a && p.appendChild(a);
    const C = o.get("stopEditingWhenCellsLoseFocus"), m = t ?? ((M = l.getPopupPosition) == null ? void 0 : M.call(l)) ?? "over", w = o.get("enableRtl"), y = {
      ePopup: p,
      column: u,
      rowNode: d,
      type: "popupCellEditor",
      eventSource: c,
      position: m,
      alignSide: w ? "right" : "left",
      keepWithinBounds: !0
    }, b = s.positionPopupByComponent.bind(s, y), _ = s.addPopup({
      modal: C,
      eChild: p,
      closeOnEsc: !0,
      closedCallback: () => {
        h.onPopupEditorClosed();
      },
      anchorToElement: c,
      positionCallback: b,
      ariaOwns: c
    });
    _ && (this.hideEditorPopup = _.hideFunc);
  }
  detach() {
    this.eRow.removeChild(this.getGui());
  }
  // if the row is also getting destroyed, then we don't need to remove from dom,
  // as the row will also get removed, so no need to take out the cells from the row
  // if the row is going (removing is an expensive operation, so only need to remove
  // the top part)
  //
  // note - this is NOT called by context, as we don't wire / unwire the CellComp for performance reasons.
  destroy() {
    this.destroyRenderer(), this.destroyEditor(), this.removeControls(), super.destroy();
  }
}, XVe = class extends Re {
  constructor(e, t, o) {
    super(), this.cellComps = /* @__PURE__ */ new Map(), this.beans = t, this.rowCtrl = e;
    const n = ze({ tag: "div", role: "row", attrs: { "comp-id": `${this.getCompId()}` } });
    this.setInitialStyle(n, o), this.setTemplateFromElement(n);
    const s = n.style;
    this.domOrder = this.rowCtrl.getDomOrder();
    const i = {
      setDomOrder: (r) => this.domOrder = r,
      setCellCtrls: (r) => this.setCellCtrls(r),
      showFullWidth: (r) => this.showFullWidth(r),
      getFullWidthCellRenderer: () => this.fullWidthCellRenderer,
      getFullWidthCellRendererParams: () => this.fullWidthCellRendererParams,
      toggleCss: (r, l) => this.toggleCss(r, l),
      setUserStyles: (r) => a1(n, r),
      setTop: (r) => s.top = r,
      setTransform: (r) => s.transform = r,
      setRowIndex: (r) => n.setAttribute("row-index", r),
      setRowId: (r) => n.setAttribute("row-id", r),
      setRowBusinessKey: (r) => n.setAttribute("row-business-key", r),
      refreshFullWidth: (r) => {
        var a, c;
        const l = r();
        return this.fullWidthCellRendererParams = l, ((c = (a = this.fullWidthCellRenderer) == null ? void 0 : a.refresh) == null ? void 0 : c.call(a, l)) ?? !1;
      }
    };
    e.setComp(i, this.getGui(), o, void 0), this.addDestroyFunc(() => {
      e.unsetComp(o);
    });
  }
  setInitialStyle(e, t) {
    const o = this.rowCtrl.getInitialTransform(t);
    if (o)
      e.style.setProperty("transform", o);
    else {
      const n = this.rowCtrl.getInitialRowTop(t);
      n && e.style.setProperty("top", n);
    }
  }
  showFullWidth(e) {
    const t = (n) => {
      if (this.isAlive()) {
        const s = n.getGui();
        this.getGui().appendChild(s), this.rowCtrl.setupDetailRowAutoHeight(s), this.setFullWidthRowComp(n, e.params);
      } else
        this.beans.context.destroyBean(n);
    };
    e.newAgStackInstance().then(t);
  }
  setCellCtrls(e) {
    const t = new Map(this.cellComps);
    for (const o of e) {
      const n = o.instanceId;
      this.cellComps.has(n) ? t.delete(n) : this.newCellComp(o);
    }
    this.destroyCells(t), this.ensureDomOrder(e);
  }
  ensureDomOrder(e) {
    if (!this.domOrder)
      return;
    const t = [];
    for (const o of e) {
      const n = this.cellComps.get(o.instanceId);
      n && t.push(n.getGui());
    }
    dw(this.getGui(), t);
  }
  newCellComp(e) {
    var n;
    const t = ((n = this.beans.editSvc) == null ? void 0 : n.isEditing(e, { withOpenEditor: !0 })) ?? !1, o = new JVe(this.beans, e, this.rowCtrl.printLayout, this.getGui(), t);
    this.cellComps.set(e.instanceId, o), this.getGui().appendChild(o.getGui());
  }
  destroy() {
    super.destroy(), this.destroyCells(this.cellComps);
  }
  setFullWidthRowComp(e, t) {
    this.fullWidthCellRenderer = e, this.fullWidthCellRendererParams = t, this.addDestroyFunc(() => {
      this.fullWidthCellRenderer = this.beans.context.destroyBean(this.fullWidthCellRenderer), this.fullWidthCellRendererParams = void 0;
    });
  }
  destroyCells(e) {
    for (const t of e.values()) {
      if (!t)
        return;
      const o = t.cellCtrl.instanceId;
      if (this.cellComps.get(o) !== t)
        return;
      t.detach(), t.destroy(), this.cellComps.delete(o);
    }
  }
};
function eOe(e, t, o) {
  const n = !!o.gos.get("enableCellSpan") && !!t.getSpannedRowCtrls, s = {
    tag: "div",
    ref: "eContainer",
    cls: q1(e),
    role: "rowgroup"
  };
  if (t.type === "center" || n) {
    const i = {
      tag: "div",
      ref: "eSpannedContainer",
      cls: `ag-spanning-container ${RHe(e)}`,
      role: "presentation"
    };
    return s.role = "presentation", {
      tag: "div",
      ref: "eViewport",
      cls: `ag-viewport ${Pb(e)}`,
      role: "rowgroup",
      children: [s, n ? i : null]
    };
  }
  return s;
}
var tOe = class extends Re {
  constructor(e) {
    super(), this.eViewport = J, this.eContainer = J, this.eSpannedContainer = J, this.rowCompsNoSpan = {}, this.rowCompsWithSpan = {}, this.name = e == null ? void 0 : e.name, this.options = h1(this.name);
  }
  postConstruct() {
    this.setTemplate(eOe(this.name, this.options, this.beans));
    const e = {
      setHorizontalScroll: (o) => this.eViewport.scrollLeft = o,
      setViewportHeight: (o) => this.eViewport.style.height = o,
      setRowCtrls: ({ rowCtrls: o }) => this.setRowCtrls(o),
      setSpannedRowCtrls: (o) => this.setRowCtrls(o, !0),
      setDomOrder: (o) => {
        this.domOrder = o;
      },
      setContainerWidth: (o) => {
        this.eContainer.style.width = o, this.eSpannedContainer && (this.eSpannedContainer.style.width = o);
      },
      setOffsetTop: (o) => {
        const n = `translateY(${o})`;
        this.eContainer.style.transform = n, this.eSpannedContainer && (this.eSpannedContainer.style.transform = n);
      }
    };
    this.createManagedBean(new $He(this.name)).setComp(e, this.eContainer, this.eSpannedContainer, this.eViewport);
  }
  destroy() {
    this.setRowCtrls([]), this.setRowCtrls([], !0), super.destroy(), this.lastPlacedElement = null;
  }
  setRowCtrls(e, t) {
    const { beans: o, options: n } = this, s = t ? this.eSpannedContainer : this.eContainer, i = t ? { ...this.rowCompsWithSpan } : { ...this.rowCompsNoSpan }, r = {};
    t ? this.rowCompsWithSpan = r : this.rowCompsNoSpan = r, this.lastPlacedElement = null;
    const l = [];
    for (const a of e) {
      const c = a.instanceId, d = i[c];
      let u;
      if (d)
        u = d, delete i[c];
      else {
        if (!a.rowNode.displayed)
          continue;
        u = new XVe(a, o, n.type);
      }
      r[c] = u, l.push([u, !d]);
    }
    this.removeOldRows(Object.values(i), s), this.addRowNodes(l, s);
  }
  addRowNodes(e, t) {
    const { domOrder: o } = this;
    for (const [n, s] of e) {
      const i = n.getGui();
      o ? this.ensureDomOrder(i, t) : s && t.appendChild(i);
    }
  }
  removeOldRows(e, t) {
    for (const o of e)
      t.removeChild(o.getGui()), o.destroy();
  }
  ensureDomOrder(e, t) {
    cw(t, e, this.lastPlacedElement), this.lastPlacedElement = e;
  }
}, oOe = {
  selector: "AG-ROW-CONTAINER",
  component: tOe
};
function dr(e, t) {
  return t.map((o) => {
    const n = `e${o[0].toUpperCase() + o.substring(1)}RowContainer`;
    return e[n] = { name: o }, {
      tag: "ag-row-container",
      ref: n,
      attrs: { name: o }
    };
  });
}
function nOe(e) {
  const t = {}, o = {
    tag: "div",
    ref: "eGridRoot",
    cls: "ag-root ag-unselectable",
    children: [
      { tag: "ag-header-root" },
      {
        tag: "div",
        ref: "eTop",
        cls: "ag-floating-top",
        role: "presentation",
        children: dr(t, ["topLeft", "topCenter", "topRight", "topFullWidth"])
      },
      {
        tag: "div",
        ref: "eBody",
        cls: "ag-body",
        role: "presentation",
        children: [
          {
            tag: "div",
            ref: "eBodyViewport",
            cls: "ag-body-viewport",
            role: "presentation",
            children: dr(t, ["left", "center", "right", "fullWidth"])
          },
          { tag: "ag-fake-vertical-scroll" }
        ]
      },
      {
        tag: "div",
        ref: "eStickyTop",
        cls: "ag-sticky-top",
        role: "presentation",
        children: dr(t, [
          "stickyTopLeft",
          "stickyTopCenter",
          "stickyTopRight",
          "stickyTopFullWidth"
        ])
      },
      {
        tag: "div",
        ref: "eStickyBottom",
        cls: "ag-sticky-bottom",
        role: "presentation",
        children: dr(t, [
          "stickyBottomLeft",
          "stickyBottomCenter",
          "stickyBottomRight",
          "stickyBottomFullWidth"
        ])
      },
      {
        tag: "div",
        ref: "eBottom",
        cls: "ag-floating-bottom",
        role: "presentation",
        children: dr(t, [
          "bottomLeft",
          "bottomCenter",
          "bottomRight",
          "bottomFullWidth"
        ])
      },
      { tag: "ag-fake-horizontal-scroll" },
      e ? { tag: "ag-overlay-wrapper" } : null
    ]
  };
  return { paramsMap: t, elementParams: o };
}
var sOe = class extends Re {
  constructor() {
    super(...arguments), this.eGridRoot = J, this.eBodyViewport = J, this.eStickyTop = J, this.eStickyBottom = J, this.eTop = J, this.eBottom = J, this.eBody = J;
  }
  postConstruct() {
    const { overlays: e, rangeSvc: t } = this.beans, o = e == null ? void 0 : e.getOverlayWrapperSelector(), { paramsMap: n, elementParams: s } = nOe(!!o);
    this.setTemplate(
      s,
      [
        ...o ? [o] : [],
        UHe,
        YHe,
        QVe,
        oOe
      ],
      n
    );
    const i = (l, a) => {
      const c = `${l}px`;
      a.style.minHeight = c, a.style.height = c;
    }, r = {
      setRowAnimationCssOnBodyViewport: (l, a) => this.setRowAnimationCssOnBodyViewport(l, a),
      setColumnCount: (l) => WTe(this.getGui(), l),
      setRowCount: (l) => zTe(this.getGui(), l),
      setTopHeight: (l) => i(l, this.eTop),
      setBottomHeight: (l) => i(l, this.eBottom),
      setTopInvisible: (l) => this.eTop.classList.toggle("ag-invisible", l),
      setBottomInvisible: (l) => this.eBottom.classList.toggle("ag-invisible", l),
      setStickyTopHeight: (l) => this.eStickyTop.style.height = l,
      setStickyTopTop: (l) => this.eStickyTop.style.top = l,
      setStickyTopWidth: (l) => this.eStickyTop.style.width = l,
      setStickyBottomHeight: (l) => {
        this.eStickyBottom.style.height = l, this.eStickyBottom.classList.toggle("ag-invisible", l === "0px");
      },
      setStickyBottomBottom: (l) => this.eStickyBottom.style.bottom = l,
      setStickyBottomWidth: (l) => this.eStickyBottom.style.width = l,
      setColumnMovingCss: (l, a) => this.toggleCss(l, a),
      updateLayoutClasses: (l, a) => {
        const c = [this.eBodyViewport.classList, this.eBody.classList];
        for (const d of c)
          d.toggle(Ho.AUTO_HEIGHT, a.autoHeight), d.toggle(Ho.NORMAL, a.normal), d.toggle(Ho.PRINT, a.print);
        this.toggleCss(Ho.AUTO_HEIGHT, a.autoHeight), this.toggleCss(Ho.NORMAL, a.normal), this.toggleCss(Ho.PRINT, a.print);
      },
      setAlwaysVerticalScrollClass: (l, a) => this.eBodyViewport.classList.toggle(Tb, a),
      registerBodyViewportResizeListener: (l) => {
        const a = mn(this.beans, this.eBodyViewport, l);
        this.addDestroyFunc(() => a());
      },
      setPinnedTopBottomOverflowY: (l) => this.eTop.style.overflowY = this.eBottom.style.overflowY = l,
      setCellSelectableCss: (l, a) => {
        [this.eTop, this.eBodyViewport, this.eBottom].forEach(
          (c) => c.classList.toggle(l, a)
        );
      },
      setBodyViewportWidth: (l) => this.eBodyViewport.style.width = l,
      setGridRootRole: (l) => no(this.eGridRoot, l)
    };
    this.ctrl = this.createManagedBean(new NHe()), this.ctrl.setComp(
      r,
      this.getGui(),
      this.eBodyViewport,
      this.eTop,
      this.eBottom,
      this.eStickyTop,
      this.eStickyBottom
    ), (t && kn(this.gos) || Ur(this.gos)) && NTe(this.getGui(), !0);
  }
  setRowAnimationCssOnBodyViewport(e, t) {
    const o = this.eBodyViewport.classList;
    o.toggle("ag-row-animation", t), o.toggle("ag-row-no-animation", !t);
  }
}, iOe = {
  selector: "AG-GRID-BODY",
  component: sOe
}, rOe = class extends K {
  constructor() {
    super(...arguments), this.additionalFocusableContainers = /* @__PURE__ */ new Set();
  }
  setComp(e, t, o) {
    this.view = e, this.eGridHostDiv = t, this.eGui = o, this.eGui.setAttribute("grid-id", this.beans.context.getId());
    const { dragAndDrop: n, ctrlsSvc: s } = this.beans;
    n == null || n.registerGridDropTarget(() => this.eGui, this), this.createManagedBean(new j2(this.view)), this.view.setRtlClass(this.gos.get("enableRtl") ? "ag-rtl" : "ag-ltr");
    const i = mn(this.beans, this.eGridHostDiv, this.onGridSizeChanged.bind(this));
    this.addDestroyFunc(() => i()), s.register("gridCtrl", this);
  }
  isDetailGrid() {
    var t;
    const e = H2(this.getGui());
    return ((t = e == null ? void 0 : e.getAttribute("row-id")) == null ? void 0 : t.startsWith("detail")) || !1;
  }
  getOptionalSelectors() {
    var t, o, n, s, i;
    const e = this.beans;
    return {
      paginationSelector: (t = e.pagination) == null ? void 0 : t.getPaginationSelector(),
      gridHeaderDropZonesSelector: (o = e.registry) == null ? void 0 : o.getSelector("AG-GRID-HEADER-DROP-ZONES"),
      sideBarSelector: (n = e.sideBar) == null ? void 0 : n.getSelector(),
      statusBarSelector: (s = e.registry) == null ? void 0 : s.getSelector("AG-STATUS-BAR"),
      watermarkSelector: (i = e.licenseManager) == null ? void 0 : i.getWatermarkSelector()
    };
  }
  onGridSizeChanged() {
    this.eventSvc.dispatchEvent({
      type: "gridSizeChanged",
      clientWidth: this.eGridHostDiv.clientWidth,
      clientHeight: this.eGridHostDiv.clientHeight
    });
  }
  destroyGridUi() {
    this.view.destroyGridUi();
  }
  getGui() {
    return this.eGui;
  }
  setResizeCursor(e) {
    const { view: t } = this;
    if (e === !1)
      t.setCursor(null);
    else {
      const o = e === 1 ? "ew-resize" : "ns-resize";
      t.setCursor(o);
    }
  }
  disableUserSelect(e) {
    this.view.setUserSelect(e ? "none" : null);
  }
  focusNextInnerContainer(e) {
    const t = this.getFocusableContainers(), { indexWithFocus: o, nextIndex: n } = this.getNextFocusableIndex(t, e);
    if (n < 0 || n >= t.length)
      return !1;
    if (n === 0) {
      if (o > 0) {
        const { visibleCols: s, focusSvc: i } = this.beans, r = s.allCols, l = Ke(r);
        if (i.focusGridView({ column: l, backwards: !0 }))
          return !0;
      }
      return !1;
    }
    return this.focusContainer(t[n], e);
  }
  focusInnerElement(e) {
    const t = this.gos.getCallback("focusGridInnerElement");
    if (t && t({ fromBottom: !!e }))
      return !0;
    const o = this.getFocusableContainers(), { focusSvc: n, visibleCols: s } = this.beans, i = s.allCols;
    if (e) {
      if (o.length > 1)
        return this.focusContainer(Ke(o), e);
      const r = Ke(i);
      if (n.focusGridView({ column: r, backwards: e }))
        return !0;
    }
    if (this.gos.get("headerHeight") === 0 || $s(this.beans)) {
      if (n.focusGridView({ column: i[0], backwards: e }))
        return !0;
      for (let r = 1; r < o.length; r++)
        if (so(o[r].getGui(), e))
          return !0;
      return !1;
    }
    return n.focusFirstHeader();
  }
  forceFocusOutOfContainer(e = !1) {
    this.view.forceFocusOutOfContainer(e);
  }
  addFocusableContainer(e) {
    this.additionalFocusableContainers.add(e);
  }
  removeFocusableContainer(e) {
    this.additionalFocusableContainers.delete(e);
  }
  allowFocusForNextCoreContainer(e) {
    var i;
    const t = this.view.getFocusableContainers(), { nextIndex: o, indexWithFocus: n } = this.getNextFocusableIndex(t, e);
    if (n === -1 || o < 0 || o >= t.length)
      return;
    const s = t[o];
    (i = s.setAllowFocus) == null || i.call(s, !0), setTimeout(() => {
      var r;
      (r = s.setAllowFocus) == null || r.call(s, !1);
    });
  }
  isFocusable() {
    var t, o;
    const e = this.beans;
    return !ba(e) || !$s(e) || !!((o = (t = e.sideBar) == null ? void 0 : t.comp) != null && o.isDisplayed());
  }
  getNextFocusableIndex(e, t) {
    const o = Ue(this.beans), n = e.findIndex((i) => i.getGui().contains(o)), s = n + (t ? -1 : 1);
    return {
      indexWithFocus: n,
      nextIndex: s
    };
  }
  focusContainer(e, t) {
    var n, s;
    (n = e.setAllowFocus) == null || n.call(e, !0);
    const o = so(e.getGui(), t, !1, !0);
    return (s = e.setAllowFocus) == null || s.call(e, !1), o;
  }
  getFocusableContainers() {
    return [...this.view.getFocusableContainers(), ...this.additionalFocusableContainers];
  }
  destroy() {
    this.additionalFocusableContainers.clear(), super.destroy();
  }
}, lOe = class extends ri {
  constructor(e) {
    super(), this.gridBody = J, this.sideBar = J, this.pagination = J, this.rootWrapperBody = J, this.eGridDiv = e;
  }
  postConstruct() {
    const e = {
      destroyGridUi: () => this.destroyBean(this),
      setRtlClass: (i) => this.addCss(i),
      forceFocusOutOfContainer: this.forceFocusOutOfContainer.bind(this),
      updateLayoutClasses: this.updateLayoutClasses.bind(this),
      getFocusableContainers: this.getFocusableContainers.bind(this),
      setUserSelect: (i) => {
        this.getGui().style.userSelect = i ?? "", this.getGui().style.webkitUserSelect = i ?? "";
      },
      setCursor: (i) => {
        this.getGui().style.cursor = i ?? "";
      }
    }, t = this.createManagedBean(new rOe()), o = t.getOptionalSelectors(), n = this.createTemplate(o), s = [iOe, ...Object.values(o).filter((i) => !!i)];
    this.setTemplate(n, s), t.setComp(e, this.eGridDiv, this.getGui()), this.insertGridIntoDom(), this.initialiseTabGuard({
      // we want to override the default behaviour to do nothing for onTabKeyDown
      onTabKeyDown: () => {
      },
      focusInnerElement: (i) => t.focusInnerElement(i),
      forceFocusOutWhenTabGuardsAreEmpty: !0,
      isEmpty: () => !t.isFocusable()
    });
  }
  insertGridIntoDom() {
    const e = this.getGui();
    this.eGridDiv.appendChild(e), this.addDestroyFunc(() => {
      this.eGridDiv.removeChild(e), cs(this.gos, "Grid removed from DOM");
    });
  }
  updateLayoutClasses(e, t) {
    const o = this.rootWrapperBody.classList, { AUTO_HEIGHT: n, NORMAL: s, PRINT: i } = Ho, { autoHeight: r, normal: l, print: a } = t;
    o.toggle(n, r), o.toggle(s, l), o.toggle(i, a), this.toggleCss(n, r), this.toggleCss(s, l), this.toggleCss(i, a);
  }
  createTemplate(e) {
    const t = e.gridHeaderDropZonesSelector ? { tag: "ag-grid-header-drop-zones" } : null, o = e.sideBarSelector ? {
      tag: "ag-side-bar",
      ref: "sideBar"
    } : null, n = e.statusBarSelector ? { tag: "ag-status-bar" } : null, s = e.watermarkSelector ? { tag: "ag-watermark" } : null, i = e.paginationSelector ? { tag: "ag-pagination", ref: "pagination" } : null;
    return {
      tag: "div",
      cls: "ag-root-wrapper",
      role: "presentation",
      children: [
        t,
        {
          tag: "div",
          ref: "rootWrapperBody",
          cls: "ag-root-wrapper-body",
          role: "presentation",
          children: [{ tag: "ag-grid-body", ref: "gridBody" }, o]
        },
        n,
        i,
        s
      ]
    };
  }
  getFocusableElement() {
    return this.rootWrapperBody;
  }
  forceFocusOutOfContainer(e = !1) {
    var t;
    if (!e && ((t = this.pagination) != null && t.isDisplayed())) {
      this.pagination.forceFocusOutOfContainer(e);
      return;
    }
    super.forceFocusOutOfContainer(e);
  }
  getFocusableContainers() {
    const e = [this.gridBody];
    return [this.sideBar, this.pagination].forEach((t) => {
      t && e.push(t);
    }), e.filter((t) => ro(t.getGui()));
  }
}, $e = (e, t) => {
  for (const o of Object.keys(t))
    t[o] = e;
  return t;
}, eu = {
  dispatchEvent: "CommunityCore",
  // this is always registered
  ...$e("CommunityCore", {
    destroy: 0,
    getGridId: 0,
    getGridOption: 0,
    isDestroyed: 0,
    setGridOption: 0,
    updateGridOptions: 0,
    isModuleRegistered: 0
  }),
  ...$e("GridState", {
    getState: 0,
    setState: 0
  }),
  ...$e("SharedRowSelection", {
    setNodesSelected: 0,
    selectAll: 0,
    deselectAll: 0,
    selectAllFiltered: 0,
    deselectAllFiltered: 0,
    selectAllOnCurrentPage: 0,
    deselectAllOnCurrentPage: 0,
    getSelectedNodes: 0,
    getSelectedRows: 0
  }),
  ...$e("RowApi", {
    redrawRows: 0,
    setRowNodeExpanded: 0,
    getRowNode: 0,
    addRenderedRowListener: 0,
    getRenderedNodes: 0,
    forEachNode: 0,
    getFirstDisplayedRowIndex: 0,
    getLastDisplayedRowIndex: 0,
    getDisplayedRowAtIndex: 0,
    getDisplayedRowCount: 0
  }),
  ...$e("ScrollApi", {
    getVerticalPixelRange: 0,
    getHorizontalPixelRange: 0,
    ensureColumnVisible: 0,
    ensureIndexVisible: 0,
    ensureNodeVisible: 0
  }),
  ...$e("KeyboardNavigation", {
    getFocusedCell: 0,
    clearFocusedCell: 0,
    setFocusedCell: 0,
    tabToNextCell: 0,
    tabToPreviousCell: 0,
    setFocusedHeader: 0
  }),
  ...$e("EventApi", {
    addEventListener: 0,
    addGlobalListener: 0,
    removeEventListener: 0,
    removeGlobalListener: 0
  }),
  ...$e("ValueCache", {
    expireValueCache: 0
  }),
  ...$e("CellApi", {
    getCellValue: 0
  }),
  ...$e("SharedMenu", {
    showColumnMenu: 0,
    hidePopupMenu: 0
  }),
  ...$e("Sort", {
    onSortChanged: 0
  }),
  ...$e("PinnedRow", {
    getPinnedTopRowCount: 0,
    getPinnedBottomRowCount: 0,
    getPinnedTopRow: 0,
    getPinnedBottomRow: 0,
    forEachPinnedRow: 0
  }),
  ...$e("Overlay", {
    showLoadingOverlay: 0,
    showNoRowsOverlay: 0,
    hideOverlay: 0
  }),
  ...$e("RenderApi", {
    setGridAriaProperty: 0,
    refreshCells: 0,
    refreshHeader: 0,
    isAnimationFrameQueueEmpty: 0,
    flushAllAnimationFrames: 0,
    getSizesForCurrentTheme: 0,
    getCellRendererInstances: 0
  }),
  ...$e("HighlightChanges", {
    flashCells: 0
  }),
  ...$e("RowDrag", {
    addRowDropZone: 0,
    removeRowDropZone: 0,
    getRowDropZoneParams: 0,
    getRowDropPositionIndicator: 0,
    setRowDropPositionIndicator: 0
  }),
  ...$e("ColumnApi", {
    getColumnDefs: 0,
    getColumnDef: 0,
    getDisplayNameForColumn: 0,
    getColumn: 0,
    getColumns: 0,
    applyColumnState: 0,
    getColumnState: 0,
    resetColumnState: 0,
    isPinning: 0,
    isPinningLeft: 0,
    isPinningRight: 0,
    getDisplayedColAfter: 0,
    getDisplayedColBefore: 0,
    setColumnsVisible: 0,
    setColumnsPinned: 0,
    getAllGridColumns: 0,
    getDisplayedLeftColumns: 0,
    getDisplayedCenterColumns: 0,
    getDisplayedRightColumns: 0,
    getAllDisplayedColumns: 0,
    getAllDisplayedVirtualColumns: 0
  }),
  ...$e("ColumnAutoSize", {
    sizeColumnsToFit: 0,
    autoSizeColumns: 0,
    autoSizeAllColumns: 0
  }),
  ...$e("ColumnGroup", {
    setColumnGroupOpened: 0,
    getColumnGroup: 0,
    getProvidedColumnGroup: 0,
    getDisplayNameForColumnGroup: 0,
    getColumnGroupState: 0,
    setColumnGroupState: 0,
    resetColumnGroupState: 0,
    getLeftDisplayedColumnGroups: 0,
    getCenterDisplayedColumnGroups: 0,
    getRightDisplayedColumnGroups: 0,
    getAllDisplayedColumnGroups: 0
  }),
  ...$e("ColumnMove", {
    moveColumnByIndex: 0,
    moveColumns: 0
  }),
  ...$e("ColumnResize", {
    setColumnWidths: 0
  }),
  ...$e("ColumnHover", {
    isColumnHovered: 0
  }),
  ...$e("EditCore", {
    getCellEditorInstances: 0,
    getEditingCells: 0,
    getEditRowValues: 0,
    stopEditing: 0,
    startEditingCell: 0,
    isEditing: 0,
    validateEdit: 0
  }),
  ...$e("BatchEdit", {
    startBatchEdit: 0,
    cancelBatchEdit: 0,
    commitBatchEdit: 0,
    isBatchEditing: 0
  }),
  ...$e("UndoRedoEdit", {
    undoCellEditing: 0,
    redoCellEditing: 0,
    getCurrentUndoSize: 0,
    getCurrentRedoSize: 0
  }),
  ...$e("FilterCore", {
    isAnyFilterPresent: 0,
    onFilterChanged: 0
  }),
  ...$e("ColumnFilter", {
    isColumnFilterPresent: 0,
    getColumnFilterInstance: 0,
    destroyFilter: 0,
    setFilterModel: 0,
    getFilterModel: 0,
    getColumnFilterModel: 0,
    setColumnFilterModel: 0,
    showColumnFilter: 0,
    hideColumnFilter: 0,
    getColumnFilterHandler: 0,
    doFilterAction: 0
  }),
  ...$e("QuickFilter", {
    isQuickFilterPresent: 0,
    getQuickFilter: 0,
    resetQuickFilter: 0
  }),
  ...$e("Find", {
    findGetActiveMatch: 0,
    findGetTotalMatches: 0,
    findGoTo: 0,
    findNext: 0,
    findPrevious: 0,
    findGetNumMatches: 0,
    findGetParts: 0,
    findClearActive: 0,
    findRefresh: 0
  }),
  ...$e("Pagination", {
    paginationIsLastPageFound: 0,
    paginationGetPageSize: 0,
    paginationGetCurrentPage: 0,
    paginationGetTotalPages: 0,
    paginationGetRowCount: 0,
    paginationGoToNextPage: 0,
    paginationGoToPreviousPage: 0,
    paginationGoToFirstPage: 0,
    paginationGoToLastPage: 0,
    paginationGoToPage: 0
  }),
  ...$e("CsrmSsrmSharedApi", {
    expandAll: 0,
    collapseAll: 0
  }),
  ...$e("SsrmInfiniteSharedApi", {
    setRowCount: 0,
    getCacheBlockState: 0,
    isLastRowIndexKnown: 0
  }),
  ...$e("ClientSideRowModelApi", {
    onGroupExpandedOrCollapsed: 0,
    refreshClientSideRowModel: 0,
    isRowDataEmpty: 0,
    forEachLeafNode: 0,
    forEachNodeAfterFilter: 0,
    forEachNodeAfterFilterAndSort: 0,
    applyTransaction: 0,
    applyTransactionAsync: 0,
    flushAsyncTransactions: 0,
    getBestCostNodeSelection: 0,
    onRowHeightChanged: 0,
    resetRowHeights: 0
  }),
  ...$e("CsvExport", {
    getDataAsCsv: 0,
    exportDataAsCsv: 0
  }),
  ...$e("InfiniteRowModel", {
    refreshInfiniteCache: 0,
    purgeInfiniteCache: 0,
    getInfiniteRowCount: 0
  }),
  ...$e("AdvancedFilter", {
    getAdvancedFilterModel: 0,
    setAdvancedFilterModel: 0,
    showAdvancedFilterBuilder: 0,
    hideAdvancedFilterBuilder: 0
  }),
  ...$e("IntegratedCharts", {
    getChartModels: 0,
    getChartRef: 0,
    getChartImageDataURL: 0,
    downloadChart: 0,
    openChartToolPanel: 0,
    closeChartToolPanel: 0,
    createRangeChart: 0,
    createPivotChart: 0,
    createCrossFilterChart: 0,
    updateChart: 0,
    restoreChart: 0
  }),
  ...$e("Clipboard", {
    copyToClipboard: 0,
    cutToClipboard: 0,
    copySelectedRowsToClipboard: 0,
    copySelectedRangeToClipboard: 0,
    copySelectedRangeDown: 0,
    pasteFromClipboard: 0
  }),
  ...$e("ExcelExport", {
    getDataAsExcel: 0,
    exportDataAsExcel: 0,
    getSheetDataForExcel: 0,
    getMultipleSheetsAsExcel: 0,
    exportMultipleSheetsAsExcel: 0
  }),
  ...$e("SharedMasterDetail", {
    addDetailGridInfo: 0,
    removeDetailGridInfo: 0,
    getDetailGridInfo: 0,
    forEachDetailGridInfo: 0
  }),
  ...$e("ContextMenu", {
    showContextMenu: 0
  }),
  ...$e("ColumnMenu", {
    showColumnChooser: 0,
    hideColumnChooser: 0
  }),
  ...$e("CellSelection", {
    getCellRanges: 0,
    addCellRange: 0,
    clearRangeSelection: 0,
    clearCellSelection: 0
  }),
  ...$e("SharedRowGrouping", {
    setRowGroupColumns: 0,
    removeRowGroupColumns: 0,
    addRowGroupColumns: 0,
    getRowGroupColumns: 0,
    moveRowGroupColumn: 0
  }),
  ...$e("SharedAggregation", {
    addAggFuncs: 0,
    clearAggFuncs: 0,
    setColumnAggFunc: 0
  }),
  ...$e("SharedPivot", {
    isPivotMode: 0,
    getPivotResultColumn: 0,
    setValueColumns: 0,
    getValueColumns: 0,
    removeValueColumns: 0,
    addValueColumns: 0,
    setPivotColumns: 0,
    removePivotColumns: 0,
    addPivotColumns: 0,
    getPivotColumns: 0,
    setPivotResultColumns: 0,
    getPivotResultColumns: 0
  }),
  ...$e("ServerSideRowModelApi", {
    getServerSideSelectionState: 0,
    setServerSideSelectionState: 0,
    applyServerSideTransaction: 0,
    applyServerSideTransactionAsync: 0,
    applyServerSideRowData: 0,
    retryServerSideLoads: 0,
    flushServerSideAsyncTransactions: 0,
    refreshServerSide: 0,
    getServerSideGroupLevelState: 0,
    onRowHeightChanged: 0,
    resetRowHeights: 0
  }),
  ...$e("SideBar", {
    isSideBarVisible: 0,
    setSideBarVisible: 0,
    setSideBarPosition: 0,
    openToolPanel: 0,
    closeToolPanel: 0,
    getOpenedToolPanel: 0,
    refreshToolPanel: 0,
    isToolPanelShowing: 0,
    getToolPanelInstance: 0,
    getSideBar: 0
  }),
  ...$e("StatusBar", {
    getStatusPanel: 0
  })
}, g0 = {
  isDestroyed: () => !0,
  destroy() {
  },
  preConstruct() {
  },
  postConstruct() {
  },
  preWireBeans() {
  },
  wireBeans() {
  }
}, aOe = (e, t) => e.eventSvc.dispatchEvent(t), Kb = class {
};
Reflect.defineProperty(Kb, "name", { value: "GridApi" });
var cOe = class extends K {
  constructor() {
    super(), this.beanName = "apiFunctionSvc", this.api = new Kb(), this.fns = {
      ...g0,
      // dispatchEvent is used by frameworks, also used by aligned grids to identify a grid api instance
      dispatchEvent: aOe
    }, this.preDestroyLink = "";
    const { api: e } = this;
    for (const t of Object.keys(eu))
      e[t] = this.makeApi(t)[t];
  }
  postConstruct() {
    this.preDestroyLink = this.beans.frameworkOverrides.getDocLink("grid-lifecycle/#grid-pre-destroyed");
  }
  addFunction(e, t) {
    var s;
    const { fns: o, beans: n } = this;
    o !== g0 && (o[e] = ((s = n == null ? void 0 : n.validation) == null ? void 0 : s.validateApiFunction(e, t)) ?? t);
  }
  makeApi(e) {
    return {
      [e]: (...t) => {
        const {
          beans: o,
          fns: { [e]: n }
        } = this;
        return n ? n(o, ...t) : this.apiNotFound(e);
      }
    };
  }
  apiNotFound(e) {
    const { beans: t, gos: o, preDestroyLink: n } = this;
    if (!t)
      X(26, { fnName: e, preDestroyLink: n });
    else {
      const s = eu[e];
      o.assertModuleRegistered(s, `api.${e}`) && X(27, { fnName: e, module: s });
    }
  }
  destroy() {
    super.destroy(), this.fns = g0, this.beans = null;
  }
};
function dOe(e) {
  return e.context.getId();
}
function uOe(e) {
  e.gridDestroySvc.destroy();
}
function hOe(e) {
  return e.gridDestroySvc.destroyCalled;
}
function gOe(e, t) {
  return e.gos.get(t);
}
function pOe(e, t, o) {
  qb(e, { [t]: o });
}
function qb(e, t) {
  e.gos.updateGridOptions({ options: t });
}
function fOe(e, t) {
  const o = t.replace(/Module$/, "");
  return e.gos.isModuleRegistered(o);
}
var vOe = { tag: "div", cls: "ag-drag-handle ag-row-drag", attrs: { draggable: "true" } }, mOe = class extends Re {
  constructor(e, t, o) {
    super(vOe), this.rowNode = e, this.column = t, this.eCell = o;
  }
  postConstruct() {
    this.getGui().appendChild(Ie("rowDrag", this.beans, null)), this.addGuiEventListener("mousedown", (t) => {
      t.stopPropagation();
    }), this.addDragSource(), this.checkVisibility();
  }
  addDragSource() {
    this.addGuiEventListener("dragstart", this.onDragStart.bind(this));
  }
  onDragStart(e) {
    const { rowNode: t, column: o, eCell: n, gos: s } = this, i = o.getColDef().dndSourceOnRowDrag, r = e.dataTransfer;
    if (r.setDragImage(n, 0, 0), i) {
      const l = Pe(s, {
        rowNode: t,
        dragEvent: e
      });
      i(l);
    } else
      try {
        const l = JSON.stringify(t.data);
        r.setData("application/json", l), r.setData("text/plain", l);
      } catch {
      }
  }
  checkVisibility() {
    const e = this.column.isDndSource(this.rowNode);
    this.setDisplayed(e);
  }
};
function COe(e, t) {
  var o, n;
  (n = (o = e.rowDragSvc) == null ? void 0 : o.rowDragFeature) == null || n.addRowDropZone(t);
}
function wOe(e, t) {
  var n, s;
  const o = (n = e.dragAndDrop) == null ? void 0 : n.findExternalZone(t.getContainer());
  o && ((s = e.dragAndDrop) == null || s.removeDropTarget(o));
}
function bOe(e, t) {
  var o, n;
  return (n = (o = e.rowDragSvc) == null ? void 0 : o.rowDragFeature) == null ? void 0 : n.getRowDropZone(t);
}
function yOe(e) {
  const t = e.rowDropHighlightSvc;
  return t ? { row: t.row, dropIndicatorPosition: t.position } : { row: null, dropIndicatorPosition: "none" };
}
function _Oe(e, t) {
  const o = e.rowDropHighlightSvc;
  if (!o)
    return;
  const n = t == null ? void 0 : t.row;
  let s = t == null ? void 0 : t.dropIndicatorPosition;
  s !== "above" && s !== "below" && s !== "inside" && (s = "none");
  const i = n == null ? void 0 : n.rowIndex;
  i == null || s === "none" ? o.clear() : o.set(n, s);
}
var SOe = class extends Qke {
  shouldPreventMouseEvent(e) {
    return this.gos.get("enableCellTextSelection") && super.shouldPreventMouseEvent(e);
  }
}, xOe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "horizontalResizeSvc";
  }
  addResizeBar(e) {
    const t = {
      dragStartPixels: e.dragStartPixels || 0,
      eElement: e.eResizeBar,
      onDragStart: this.onDragStart.bind(this, e),
      onDragStop: this.onDragStop.bind(this, e),
      onDragging: this.onDragging.bind(this, e),
      onDragCancel: this.onDragStop.bind(this, e),
      includeTouch: !0,
      stopPropagationForTouch: !0
    }, { dragSvc: o } = this.beans;
    return o.addDragSource(t), () => o.removeDragSource(t);
  }
  onDragStart(e, t) {
    this.dragStartX = t.clientX, this.setResizeIcons();
    const o = t instanceof MouseEvent && t.shiftKey === !0;
    e.onResizeStart(o);
  }
  setResizeIcons() {
    const e = this.beans.ctrlsSvc.get("gridCtrl");
    e.setResizeCursor(
      1
      /* Horizontal */
    ), e.disableUserSelect(!0);
  }
  onDragStop(e) {
    e.onResizeEnd(this.resizeAmount), this.resetIcons();
  }
  resetIcons() {
    const e = this.beans.ctrlsSvc.get("gridCtrl");
    e.setResizeCursor(!1), e.disableUserSelect(!1);
  }
  onDragging(e, t) {
    this.resizeAmount = t.clientX - this.dragStartX, e.onResizing(this.resizeAmount);
  }
}, MOe = {
  tag: "div",
  cls: "ag-drag-handle ag-row-drag",
  attrs: { "aria-hidden": "true" }
}, AOe = class extends Re {
  constructor(e, t, o, n, s, i = !1) {
    super(), this.cellValueFn = e, this.rowNode = t, this.column = o, this.customGui = n, this.dragStartPixels = s, this.alwaysVisible = i, this.dragSource = null;
  }
  isCustomGui() {
    return this.customGui != null;
  }
  postConstruct() {
    const { beans: e, customGui: t } = this;
    t ? this.setDragElement(t, this.dragStartPixels) : (this.setTemplate(MOe), this.getGui().appendChild(Ie("rowDrag", e, null)), this.addDragSource()), this.alwaysVisible || this.initCellDrag();
  }
  initCellDrag() {
    const { beans: e, gos: t, rowNode: o } = this, n = this.refreshVisibility.bind(this);
    this.addManagedPropertyListener("suppressRowDrag", n), this.addManagedListeners(o, {
      dataChanged: n,
      cellChanged: n
    }), this.addManagedListeners(
      e.eventSvc,
      // For managed row drag, we do not show the component if sort, filter or grouping is active
      t.get("rowDragManaged") ? {
        sortChanged: n,
        filterChanged: n,
        columnRowGroupChanged: n,
        newColumnsLoaded: n
      } : { newColumnsLoaded: n }
    );
  }
  setDragElement(e, t) {
    this.setTemplateFromElement(e, void 0, void 0, !0), this.addDragSource(t);
  }
  refreshVisibility() {
    if (this.alwaysVisible)
      return;
    const e = { skipAriaHidden: !0 };
    if (this.isNeverDisplayed()) {
      this.setDisplayed(!1, e);
      return;
    }
    const t = this.column;
    let o = typeof (t == null ? void 0 : t.getColDef().rowDrag) == "function", n = !t || this.isCustomGui() || t.isRowDrag(this.rowNode);
    n && this.rowNode.footer && this.gos.get("rowDragManaged") && (n = !1, o = !0), this.setDisplayed(o || n, e), this.setVisible(n, e);
  }
  isNeverDisplayed() {
    var o, n;
    const { gos: e, beans: t } = this;
    return !!(e.get("suppressRowDrag") || e.get("rowDragManaged") && ((o = t.rowDragSvc.rowDragFeature) != null && o.shouldPreventRowMove()) && !((n = t.dragAndDrop) != null && n.hasExternalDropZones()));
  }
  getSelectedNodes() {
    var n;
    const e = this.rowNode;
    if (!this.gos.get("rowDragMultiRow"))
      return [e];
    const o = ((n = this.beans.selectionSvc) == null ? void 0 : n.getSelectedNodes()) ?? [];
    return o.indexOf(e) !== -1 ? o : [e];
  }
  getDragItem() {
    const { column: e, rowNode: t } = this;
    return {
      rowNode: t,
      rowNodes: this.getSelectedNodes(),
      columns: e ? [e] : void 0,
      defaultTextValue: this.cellValueFn()
    };
  }
  getRowDragText(e) {
    if (e) {
      const t = e.getColDef();
      if (t.rowDragText)
        return t.rowDragText;
    }
    return this.gos.get("rowDragText");
  }
  addDragSource(e = 4) {
    if (this.dragSource && this.removeDragSource(), this.gos.get("rowDragManaged") && this.rowNode.footer)
      return;
    const t = this.getGui();
    this.gos.get("enableCellTextSelection") && (this.removeMouseDownListener(), this.mouseDownListener = this.addManagedElementListeners(t, {
      mousedown: (n) => {
        n == null || n.preventDefault();
      }
    })[0]);
    const o = this.getLocaleTextFunc();
    this.dragSource = {
      type: 2,
      eElement: t,
      dragItemName: (n) => {
        var l, a;
        const s = (n == null ? void 0 : n.dragItem) || this.getDragItem(), i = (((l = n == null ? void 0 : n.dropTarget) == null ? void 0 : l.rows.length) ?? ((a = s.rowNodes) == null ? void 0 : a.length)) || 1, r = this.getRowDragText(this.column);
        return r ? r(s, i) : i === 1 ? this.cellValueFn() : `${i} ${o("rowDragRows", "rows")}`;
      },
      getDragItem: () => this.getDragItem(),
      dragStartPixels: e,
      dragSourceDomDataKey: this.gos.getDomDataKey()
    }, this.beans.dragAndDrop.addDragSource(this.dragSource, !0);
  }
  destroy() {
    this.removeDragSource(), this.removeMouseDownListener(), super.destroy();
  }
  removeDragSource() {
    this.dragSource && (this.beans.dragAndDrop.removeDragSource(this.dragSource), this.dragSource = null);
  }
  removeMouseDownListener() {
    this.mouseDownListener && (this.mouseDownListener(), this.mouseDownListener = void 0);
  }
};
function wn(e) {
  const t = e.rowModel;
  return t.getType() === "clientSide" ? t : void 0;
}
function _a(e) {
  const t = e.rowModel;
  return t.getType() === "infinite" ? t : void 0;
}
function LOe(e) {
  const t = e.rowModel;
  return t.getType() === "serverSide" ? t : void 0;
}
function EOe(e) {
  const { rowIndex: t, rowPinned: o, column: n } = e;
  return `${t}.${o ?? "null"}.${n.getId()}`;
}
function ec(e, t) {
  const o = e.column === t.column, n = e.rowPinned === t.rowPinned, s = e.rowIndex === t.rowIndex;
  return o && n && s;
}
function POe(e, t) {
  switch (e.rowPinned) {
    case "top":
      if (t.rowPinned !== "top")
        return !0;
      break;
    case "bottom":
      if (t.rowPinned !== "bottom")
        return !1;
      break;
    default:
      if (ue(t.rowPinned))
        return t.rowPinned !== "top";
      break;
  }
  return e.rowIndex < t.rowIndex;
}
function Yb(e, t) {
  return !e && !t ? !0 : e && !t || !e && t ? !1 : e.rowIndex === t.rowIndex && e.rowPinned == t.rowPinned;
}
function ROe(e) {
  let t = 0, o;
  const { pinnedRowModel: n, rowModel: s, pageBounds: i } = e;
  return n != null && n.getPinnedTopRowCount() ? o = "top" : s.getRowCount() ? (o = null, t = i.getFirstRow()) : n != null && n.getPinnedBottomRowCount() && (o = "bottom"), o === void 0 ? null : { rowIndex: t, rowPinned: o };
}
function FOe(e) {
  let t, o = null;
  const { pinnedRowModel: n, pageBounds: s } = e, i = n == null ? void 0 : n.getPinnedBottomRowCount(), r = n == null ? void 0 : n.getPinnedTopRowCount();
  return i ? (o = "bottom", t = i - 1) : e.rowModel.getRowCount() ? (o = null, t = s.getLastRow()) : r && (o = "top", t = r - 1), t === void 0 ? null : { rowIndex: t, rowPinned: o };
}
function vn(e, t) {
  var o, n;
  switch (t.rowPinned) {
    case "top":
      return (o = e.pinnedRowModel) == null ? void 0 : o.getPinnedTopRow(t.rowIndex);
    case "bottom":
      return (n = e.pinnedRowModel) == null ? void 0 : n.getPinnedBottomRow(t.rowIndex);
    default:
      return e.rowModel.getRow(t.rowIndex);
  }
}
function yi(e, t) {
  var s;
  const o = (s = e.spannedRowRenderer) == null ? void 0 : s.getCellByPosition(t);
  if (o)
    return o;
  const n = e.rowRenderer.getRowByPosition(t);
  return n ? n.getCellCtrl(t.column) : null;
}
function TOe(e, t, o) {
  const { rowModel: n, pinnedRowModel: s } = e;
  let i;
  return i ?? (i = n == null ? void 0 : n.getRowNode(t)), o ? i ?? (i = s == null ? void 0 : s.getPinnedRowById(t, o)) : (i ?? (i = s == null ? void 0 : s.getPinnedRowById(t, "top")), i ?? (i = s == null ? void 0 : s.getPinnedRowById(t, "bottom"))), i;
}
function Dl(e, t, o = !1) {
  const { rowIndex: n, rowPinned: s } = t, { pageBounds: i, pinnedRowModel: r, rowModel: l } = e;
  if (n === 0)
    return s === "top" ? null : s === "bottom" && l.isRowsToRender() ? { rowIndex: i.getLastRow(), rowPinned: null } : r != null && r.isRowsToRender("top") ? { rowIndex: r.getPinnedTopRowCount() - 1, rowPinned: "top" } : null;
  if (o) {
    const a = s ? void 0 : l.getRow(n);
    return Qb(e, a, !0) ?? { rowIndex: n - 1, rowPinned: s };
  }
  return { rowIndex: n - 1, rowPinned: s };
}
function tu(e, t, o = !1) {
  const { rowIndex: n, rowPinned: s } = t, { pageBounds: i, pinnedRowModel: r, rowModel: l } = e;
  if (IOe(e, t))
    return s === "bottom" ? null : s === "top" && l.isRowsToRender() ? { rowIndex: i.getFirstRow(), rowPinned: null } : r != null && r.isRowsToRender("bottom") ? { rowIndex: 0, rowPinned: "bottom" } : null;
  if (o) {
    const a = s ? void 0 : l.getRow(n);
    return Qb(e, a) ?? { rowIndex: n + 1, rowPinned: s };
  }
  return { rowIndex: n + 1, rowPinned: s };
}
function Qb(e, t, o = !1) {
  const { gos: n, rowRenderer: s } = e;
  if (!(t != null && t.sticky) || !ua(n))
    return;
  const i = s.getStickyTopRowCtrls(), r = s.getStickyBottomRowCtrls(), l = !r.some((u) => u.rowNode.rowIndex === t.rowIndex), a = l ? i : r, c = (o ? -1 : 1) * (l ? -1 : 1);
  let d;
  for (let u = 0; u < a.length; u++)
    if (a[u].rowNode.rowIndex === t.rowIndex) {
      d = a[u + c];
      break;
    }
  return d ? { rowIndex: d.rowNode.rowIndex, rowPinned: null } : void 0;
}
function IOe(e, t) {
  const { rowPinned: o, rowIndex: n } = t, { pinnedRowModel: s, pageBounds: i } = e;
  return o === "top" ? ((s == null ? void 0 : s.getPinnedTopRowCount()) ?? 0) - 1 <= n : o === "bottom" ? ((s == null ? void 0 : s.getPinnedBottomRowCount()) ?? 0) - 1 <= n : i.getLastRow() <= n;
}
var Wi = class {
  constructor(e, t) {
    this.active = !0, this.nodeIdsToColumns = {}, this.mapToItems = {}, this.keepingColumns = e, this.pathRoot = {
      rowNode: t,
      children: null
    }, this.mapToItems[t.id] = this.pathRoot;
  }
  depthFirstSearchChangedPath(e, t) {
    const { rowNode: o, children: n } = e;
    if (n)
      for (let s = 0; s < n.length; ++s)
        this.depthFirstSearchChangedPath(n[s], t);
    t(o);
  }
  depthFirstSearchEverything(e, t, o) {
    const n = e.childrenAfterGroup;
    if (n)
      for (let s = 0, i = n.length; s < i; ++s) {
        const r = n[s];
        r.childrenAfterGroup ? this.depthFirstSearchEverything(r, t, o) : o && t(r);
      }
    t(e);
  }
  // traverseLeafNodes -> used when NOT doing changed path, ie traversing everything. the callback
  // will be called for child nodes in addition to parent nodes.
  forEachChangedNodeDepthFirst(e, t = !1, o = !1) {
    this.active && !o ? this.depthFirstSearchChangedPath(this.pathRoot, e) : this.depthFirstSearchEverything(this.pathRoot.rowNode, e, t);
  }
  executeFromRootNode(e) {
    e(this.pathRoot.rowNode);
  }
  createPathItems(e) {
    let t = e, o = 0;
    for (; !this.mapToItems[t.id]; ) {
      const n = {
        rowNode: t,
        children: null
      };
      this.mapToItems[t.id] = n, o++, t = t.parent;
    }
    return o;
  }
  populateColumnsMap(e, t) {
    if (!this.keepingColumns || !t)
      return;
    let o = e;
    for (; o; )
      this.nodeIdsToColumns[o.id] || (this.nodeIdsToColumns[o.id] = {}), t.forEach((n) => this.nodeIdsToColumns[o.id][n.getId()] = !0), o = o.parent;
  }
  linkPathItems(e, t) {
    let o = e;
    for (let n = 0; n < t; n++) {
      const s = this.mapToItems[o.id], i = this.mapToItems[o.parent.id];
      i.children || (i.children = []), i.children.push(s), o = o.parent;
    }
  }
  // called by
  // 1) change detection (provides cols) and
  // 2) groupStage if doing transaction update (doesn't provide cols)
  addParentNode(e, t) {
    if (!e || e.isRowPinned())
      return;
    const o = this.createPathItems(e);
    this.linkPathItems(e, o), this.populateColumnsMap(e, t);
  }
  canSkip(e) {
    return this.active && !this.mapToItems[e.id];
  }
  getValueColumnsForNode(e, t) {
    if (!this.keepingColumns)
      return t;
    const o = this.nodeIdsToColumns[e.id];
    return t.filter((s) => o[s.getId()]);
  }
  getNotValueColumnsForNode(e, t) {
    if (!this.keepingColumns)
      return null;
    const o = this.nodeIdsToColumns[e.id];
    return t.filter((s) => !o[s.getId()]);
  }
}, DOe = class {
  constructor(e, t) {
    this.beans = e, this.groupThrottled = !1, this.oldVScroll = null, this.groupTimer = null, this.groupTarget = null, this.onGroupThrottle = () => {
      var n;
      this.groupTimer = null, this.groupThrottled = !0, (n = this.beans.dragAndDrop) == null || n.nudge();
    };
    const o = () => t.scrollFeature.getVScrollPosition().top;
    this.autoScroll = new Wb({
      scrollContainer: t.eBodyViewport,
      scrollAxis: "y",
      getVerticalPosition: o,
      setVerticalPosition: (n) => t.scrollFeature.setVerticalScrollPosition(n),
      onScrollCallback: () => {
        var i;
        const n = o(), s = this.oldVScroll;
        this.oldVScroll = n, s !== null && s !== n && ((i = this.beans.dragAndDrop) == null || i.nudge());
      }
    });
  }
  updateGroup(e, t) {
    var o, n;
    this.groupTarget && this.groupTarget !== e && this.clearGroup(), e && (t && this.groupThrottled && !e.expanded && ((o = e.childrenAfterSort) != null && o.length) && e.isExpandable() && e.setExpanded(!0, void 0, !0), e.expanded && ((n = e.childrenAfterSort) != null && n.length) && (this.groupThrottled = !0, this.groupTarget = e));
  }
  startGroup(e) {
    this.groupTarget = e, this.groupTimer === null && (this.groupTimer = window.setTimeout(this.onGroupThrottle, this.beans.gos.get("rowDragInsertDelay")));
  }
  clearGroup() {
    this.groupThrottled = !1, this.groupTarget = null;
    const e = this.groupTimer;
    e !== null && (this.groupTimer = null, window.clearTimeout(e));
  }
  clear() {
    this.clearGroup(), this.autoScroll.ensureCleared(), this.oldVScroll = null;
  }
}, kOe = class extends K {
  constructor(e) {
    super(), this.eContainer = e, this.lastDraggingEvent = null, this.nudger = null;
  }
  postConstruct() {
    const e = this.beans;
    this.clientSideRowModel = wn(e), e.ctrlsSvc.whenReady(this, (t) => {
      this.nudger = new DOe(e, t.gridBodyCtrl);
    });
  }
  destroy() {
    var e;
    super.destroy(), (e = this.nudger) == null || e.clear(), this.nudger = null, this.lastDraggingEvent = null, this.eContainer = null;
  }
  getContainer() {
    return this.eContainer;
  }
  isInterestedIn(e) {
    return e === 2;
  }
  getIconName(e) {
    var t;
    return ((t = e == null ? void 0 : e.dropTarget) == null ? void 0 : t.allowed) === !1 || this.gos.get("rowDragManaged") && this.shouldPreventRowMove() ? "notAllowed" : "move";
  }
  shouldPreventRowMove() {
    const { rowGroupColsSvc: e, filterManager: t, sortSvc: o } = this.beans;
    return !!(((e == null ? void 0 : e.columns) ?? []).length || (t == null ? void 0 : t.isAnyFilterPresent()) || (o == null ? void 0 : o.isSortActive()));
  }
  getRowNodes(e) {
    var o;
    if (!this.isFromThisGrid(e))
      return e.dragItem.rowNodes || [];
    const t = e.dragItem.rowNode;
    if (this.gos.get("rowDragMultiRow")) {
      const n = (o = this.beans.selectionSvc) == null ? void 0 : o.getSelectedNodes();
      if (n && n.indexOf(t) >= 0)
        return n.slice().sort(OOe);
    }
    return [t];
  }
  onDragEnter(e) {
    this.dragging(e, !0);
  }
  onDragging(e) {
    this.dragging(e, !1);
  }
  dragging(e, t) {
    var r, l;
    const { lastDraggingEvent: o, beans: n } = this;
    if (t) {
      const a = this.getRowNodes(e);
      e.dragItem.rowNodes = a, su(a, !0);
    }
    this.lastDraggingEvent = e;
    const s = e.fromNudge, i = this.makeRowsDrop(o, e, s, !1);
    (r = n.rowDropHighlightSvc) == null || r.fromDrag(e), t && this.dispatchGridEvent("rowDragEnter", e), this.dispatchGridEvent("rowDragMove", e), !s && (i != null && i.rowDragManaged) && i.moved && i.allowed && i.sameGrid && !i.suppressMoveWhenRowDragging && this.dropRows(i), (l = this.nudger) == null || l.autoScroll.check(e.event);
  }
  isFromThisGrid(e) {
    return e.dragSource.dragSourceDomDataKey === this.gos.getDomDataKey();
  }
  makeRowsDrop(e, t, o, n) {
    var M;
    const { beans: s, gos: i, clientSideRowModel: r } = this, l = this.newRowsDrop(t, n);
    if (t.dropTarget = l, t.changed = !1, !l)
      return null;
    let { sameGrid: a, rootNode: c, source: d, target: u, rows: h } = l;
    u ?? (u = r.getRow(r.getRowCount() - 1) ?? null);
    const C = (
      // We don't yet support drag and drop with grouping
      E2(i) !== "group" && // We don't yet support moving tree rows from a different grid in a structured way
      a
    );
    let m = null;
    if (u != null && u.footer) {
      const x = Q1(r, -1, u) ?? Q1(r, 1, u);
      m = u.sibling ?? c, u = x ?? null;
    }
    u != null && u.detail && (u = u.parent), l.moved && (l.moved = d !== u);
    let w = 0.5;
    if (u && (a && l.moved && (m || !C) ? w = d.rowIndex > u.rowIndex ? -0.5 : 0.5 : w = (l.y - u.rowTop - u.rowHeight / 2) / u.rowHeight || 0), !C && a && u && l.moved) {
      const x = BOe(r, l);
      x && (w = d.rowIndex > x.rowIndex ? -0.5 : 0.5, u = x, l.moved && (l.moved = d !== u));
    }
    const y = this.nudger;
    y == null || y.updateGroup(u, o), C && !m && y && (!u || w >= 0.5 && u.rowIndex === s.pageBounds.getLastRow() ? m = c : l.moved && this.targetShouldBeParent(u, w, h) && (y.groupThrottled && (m = u), !o && (!m || u && !u.expanded && ((M = u.childrenAfterSort) != null && M.length)) && y.startGroup(u)), m ?? (m = (u == null ? void 0 : u.parent) ?? c));
    let b = !1;
    if (m) {
      if (m === u && m !== c) {
        const x = m.expanded ? Q1(r, 1, u) : null;
        (x == null ? void 0 : x.parent) === m ? (u = x, w = -0.5) : b = !0;
      }
      if (u && !b) {
        let x = u;
        for (; x && x !== c && x !== m; )
          u = x, x = x.parent;
      }
    }
    l.target = u, l.newParent = m, l.moved && (l.moved = d !== u);
    const _ = w < 0 ? "above" : "below";
    return l.position = l.moved ? b ? "inside" : _ : "none", this.validateRowsDrop(l, C, _, n), t.changed || (t.changed = VOe(e == null ? void 0 : e.dropTarget, l)), l;
  }
  newRowsDrop(e, t) {
    const { beans: o, gos: n, clientSideRowModel: s } = this, i = s.rootNode, r = n.get("rowDragManaged"), l = n.get("suppressMoveWhenRowDragging"), a = this.isFromThisGrid(e);
    let { rowNode: c, rowNodes: d } = e.dragItem;
    if (d || (d = c ? [c] : []), c || (c = d[0]), !c || !i)
      return null;
    const u = this.beans.dragAndDrop.isDropZoneWithinThisGrid(e);
    let h = !0;
    r && (!d.length || this.shouldPreventRowMove() || (l || !a) && !u) && (h = !1);
    const p = zd(o, e).y, C = this.getOverNode(p);
    return {
      api: o.gridApi,
      context: o.gridOptions.context,
      draggingEvent: e,
      rowDragManaged: r,
      suppressMoveWhenRowDragging: l,
      sameGrid: a,
      withinGrid: u,
      rootNode: i,
      moved: c !== C,
      y: p,
      overNode: C,
      overIndex: (C == null ? void 0 : C.rowIndex) ?? -1,
      position: "none",
      source: c,
      target: C ?? null,
      newParent: null,
      rows: d,
      allowed: h,
      highlight: !t && r && l && (u || !a)
    };
  }
  validateRowsDrop(e, t, o, n) {
    const { rowDragManaged: s, suppressMoveWhenRowDragging: i } = e;
    t || (e.newParent = null), i && !e.moved && (e.allowed = !1);
    const r = (!s || e.allowed) && this.gos.get("isRowValidDropPosition");
    if (r) {
      t && e.newParent && ou(e.rows, e.newParent) && (e.newParent = null);
      const l = r(e);
      if (!l)
        e.allowed = !1;
      else if (typeof l == "object") {
        l.rows !== void 0 && (e.rows = l.rows ?? []), t && l.newParent !== void 0 && (e.newParent = l.newParent), l.target !== void 0 && (e.target = l.target), l.position && (e.position = l.position), l.allowed !== void 0 ? e.allowed = l.allowed : s || (e.allowed = !0);
        const a = e.draggingEvent;
        l.changed && a && (a.changed = !0), !n && l.highlight !== void 0 && (e.highlight = l.highlight);
      }
    }
    s && (e.rows = this.filterRows(e)), t && e.newParent && ou(e.rows, e.newParent) && (e.newParent = null), i && (!e.rows.length || e.position === "none") && (e.allowed = !1), (!e.allowed || !e.newParent) && e.position === "inside" && (e.position = o);
  }
  targetShouldBeParent(e, t, o) {
    const n = e.rowIndex, s = 0.25;
    if (t < -0.5 + s)
      return !1;
    if (t < 0.5 - s)
      return !0;
    let i, r = n + 1;
    const l = this.clientSideRowModel;
    do
      i = l.getRow(r++);
    while (i && i.footer);
    const a = e.childrenAfterGroup;
    if (i && i.parent === e && (a != null && a.length)) {
      const c = new Set(o);
      for (const d of a)
        if (d.rowIndex !== null && !c.has(d))
          return !0;
    }
    return !1;
  }
  addRowDropZone(e) {
    if (!e.getContainer()) {
      X(55);
      return;
    }
    const t = this.beans.dragAndDrop;
    if (t.findExternalZone(e.getContainer())) {
      X(56);
      return;
    }
    const o = e.fromGrid ? e : {
      getContainer: e.getContainer,
      onDragEnter: e.onDragEnter && ((s) => e.onDragEnter(this.rowDragEvent("rowDragEnter", s))),
      onDragLeave: e.onDragLeave && ((s) => e.onDragLeave(this.rowDragEvent("rowDragLeave", s))),
      onDragging: e.onDragging && ((s) => e.onDragging(this.rowDragEvent("rowDragMove", s))),
      onDragStop: e.onDragStop && ((s) => e.onDragStop(this.rowDragEvent("rowDragEnd", s))),
      onDragCancel: e.onDragCancel && ((s) => e.onDragCancel(this.rowDragEvent("rowDragCancel", s)))
    }, n = {
      isInterestedIn: (s) => s === 2,
      getIconName: () => "move",
      external: !0,
      ...o
    };
    t.addDropTarget(n), this.addDestroyFunc(() => t.removeDropTarget(n));
  }
  getRowDropZone(e) {
    return {
      getContainer: this.getContainer.bind(this),
      onDragEnter: (o) => {
        var n;
        this.onDragEnter(o), (n = e == null ? void 0 : e.onDragEnter) == null || n.call(e, this.rowDragEvent("rowDragEnter", o));
      },
      onDragLeave: (o) => {
        var n;
        this.onDragLeave(o), (n = e == null ? void 0 : e.onDragLeave) == null || n.call(e, this.rowDragEvent("rowDragLeave", o));
      },
      onDragging: (o) => {
        var n;
        this.onDragging(o), (n = e == null ? void 0 : e.onDragging) == null || n.call(e, this.rowDragEvent("rowDragMove", o));
      },
      onDragStop: (o) => {
        var n;
        this.onDragStop(o), (n = e == null ? void 0 : e.onDragStop) == null || n.call(e, this.rowDragEvent("rowDragEnd", o));
      },
      onDragCancel: (o) => {
        var n;
        this.onDragCancel(o), (n = e == null ? void 0 : e.onDragCancel) == null || n.call(e, this.rowDragEvent("rowDragCancel", o));
      },
      fromGrid: !0
    };
  }
  getOverNode(e) {
    const { pageBounds: t, rowModel: o } = this.beans, s = e > t.getCurrentPagePixelRange().pageLastPixel ? -1 : o.getRowIndexAtPixel(e);
    return s >= 0 ? o.getRow(s) : void 0;
  }
  rowDragEvent(e, t) {
    const o = this.beans, { dragItem: n, dropTarget: s, event: i, vDirection: r } = t, l = (s == null ? void 0 : s.rootNode) === this.clientSideRowModel.rootNode, a = l ? s.y : zd(o, t).y, c = l ? s.overNode : this.getOverNode(a), d = l ? s.overIndex : (c == null ? void 0 : c.rowIndex) ?? -1;
    return {
      api: o.gridApi,
      context: o.gridOptions.context,
      type: e,
      event: i,
      node: n.rowNode,
      nodes: n.rowNodes,
      overIndex: d,
      overNode: c,
      y: a,
      vDirection: r,
      rowsDrop: s
    };
  }
  dispatchGridEvent(e, t) {
    const o = this.rowDragEvent(e, t);
    this.eventSvc.dispatchEvent(o);
  }
  onDragLeave(e) {
    this.dispatchGridEvent("rowDragLeave", e), this.stopDragging(e);
  }
  onDragStop(e) {
    const t = this.makeRowsDrop(this.lastDraggingEvent, e, !1, !0);
    this.dispatchGridEvent("rowDragEnd", e), t != null && t.allowed && t.rowDragManaged && (t.suppressMoveWhenRowDragging || !t.sameGrid) && this.dropRows(t), this.stopDragging(e);
  }
  onDragCancel(e) {
    this.dispatchGridEvent("rowDragCancel", e), this.stopDragging(e);
  }
  stopDragging(e) {
    var t, o;
    (t = this.nudger) == null || t.clear(), (o = this.beans.rowDropHighlightSvc) == null || o.fromDrag(null), su(e.dragItem.rowNodes, !1);
  }
  /** Drag and drop. Returns false if at least a row was moved, otherwise true */
  dropRows(e) {
    return e.sameGrid ? this.moveRows(e) : this.addRows(e);
  }
  addRows({ position: e, target: t, rows: o }) {
    const n = Qs(this.gos), s = this.clientSideRowModel, i = o.filter(
      ({ data: l, rowPinned: a }) => !s.getRowNode((n == null ? void 0 : n({ data: l, level: 0, rowPinned: a })) ?? l.id)
    ).map(({ data: l }) => l);
    if (i.length === 0)
      return !1;
    const r = t ? nu(t) + (e === "above" ? 0 : 1) : void 0;
    return s.updateRowData({ add: i, addIndex: r }), !0;
  }
  filterRows({ newParent: e, rows: t }) {
    const o = this.clientSideRowModel;
    let n;
    for (let s = 0, i = t.length; s < i; ++s) {
      let r = !0;
      const l = t[s];
      !l || l.footer || l.rowTop === null && l !== o.getRowNode(l.id) || e && l.parent !== e && HOe(l, e) ? r = !1 : h5(l) || (r = !1), r ? n == null || n.push(l) : n ?? (n = t.slice(0, s));
    }
    return n ?? t;
  }
  moveRows({ position: e, target: t, rows: o, newParent: n, rootNode: s }) {
    let i = !1;
    const r = /* @__PURE__ */ new Set();
    for (const d of o) {
      n && d.parent !== n && (d.treeParent = n, i = !0);
      const u = h5(d);
      u && r.add(u);
    }
    if (!i && r.size === 0)
      return !1;
    const l = this.beans.focusSvc, a = l.getFocusedCell(), c = a && yi(this.beans, a);
    return r.size && this.reorderLeafChildren(r, ...this.getMoveRowsBounds(r, t, e === "above")) && (i = !0), i ? (this.clientSideRowModel.refreshModel({
      step: "group",
      keepRenderedRows: !0,
      animate: !this.gos.get("suppressAnimationFrame"),
      changedPath: new Wi(!1, s),
      rowNodesOrderChanged: !0
    }), c ? c.focusCell() : l.clearFocusedCell(), !0) : !1;
  }
  /** For reorderLeafChildren, returns min index of the rows to move, the target index and the max index of the rows to move. */
  getMoveRowsBounds(e, t, o) {
    var l;
    const n = ((l = this.clientSideRowModel.rootNode) == null ? void 0 : l.allLeafChildren.length) ?? 0;
    let s = nu(t);
    s < 0 || s >= n ? s = n : o || ++s;
    let i = s, r = Math.min(s, n - 1);
    for (const a of e) {
      const c = a.sourceRowIndex;
      c < i && (i = c), c > r && (r = c);
    }
    return [i, s, r];
  }
  /** Reorders the children of the root node, so that the rows to move are in the correct order.
   * @param leafs The valid set of rows to move, as returned by getValidRowsToMove
   * @param firstAffectedLeafIdx The first index of the rows to move
   * @param targetPositionIdx The target index, where the rows will be moved
   * @param lastAffectedLeafIndex The last index of the rows to move
   * @returns True if the order of the rows changed, false otherwise
   */
  reorderLeafChildren(e, t, o, n) {
    var a;
    let s = !1;
    const i = (a = this.clientSideRowModel.rootNode) == null ? void 0 : a.allLeafChildren;
    if (!e.size || !i)
      return !1;
    let r = t;
    for (let c = t; c < o; ++c) {
      const d = i[c];
      e.has(d) || (d.sourceRowIndex !== r && (d.sourceRowIndex = r, i[r] = d, s = !0), ++r);
    }
    let l = n;
    for (let c = n; c >= o; --c) {
      const d = i[c];
      e.has(d) || (d.sourceRowIndex !== l && (d.sourceRowIndex = l, i[l] = d, s = !0), --l);
    }
    for (const c of e)
      c.sourceRowIndex !== r && (c.sourceRowIndex = r, i[r] = c, s = !0), ++r;
    return s;
  }
}, Q1 = (e, t, o) => {
  if (o) {
    const n = e.getRowCount();
    let s = o.rowIndex + t;
    for (; s >= 0 && s < n; ) {
      const i = e.getRow(s);
      if (!i || !i.footer && !i.detail)
        return i;
      s += t;
    }
  }
}, HOe = (e, t) => {
  let o = t;
  for (; o; ) {
    if (o === e)
      return !0;
    o = o.parent;
  }
  return !1;
}, ou = (e, t) => {
  for (let o = 0, n = e.length; o < n; ++o)
    if (e[o].parent !== t)
      return !1;
  return !0;
}, nu = (e) => {
  const t = h5(e);
  return t !== void 0 ? t.sourceRowIndex : -1;
}, h5 = (e) => {
  for (; e; ) {
    if (e.sourceRowIndex >= 0)
      return e;
    const t = e.childrenAfterGroup;
    if (!(t != null && t.length))
      return;
    e = t[0];
  }
}, VOe = (e, t) => e !== t && (!e || e.sameGrid !== t.sameGrid || e.allowed !== t.allowed || e.position !== t.position || e.target !== t.target || e.source !== t.source || e.newParent !== t.newParent || !No(e.rows, t.rows)), OOe = ({ rowIndex: e }, { rowIndex: t }) => e !== null && t !== null ? e - t : 0, su = (e, t) => {
  for (let o = 0, n = (e == null ? void 0 : e.length) || 0; o < n; ++o) {
    const s = e[o];
    s.dragging !== t && (s.dragging = t, s.dispatchRowEvent("draggingChanged"));
  }
}, BOe = (e, t) => {
  let o = null, n = t.target;
  if (n && t.rows.indexOf(n) < 0)
    return null;
  const s = t.source;
  if (!n || !s)
    return null;
  let i = n.rowIndex - s.rowIndex;
  const r = i < 0 ? -1 : 1;
  i = t.suppressMoveWhenRowDragging ? Math.abs(i) : 1;
  const l = new Set(t.rows);
  do {
    const a = Q1(e, r, n);
    if (!a)
      break;
    l.has(a) || (o = a, --i), n = a;
  } while (i > 0);
  return o;
}, $Oe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "rowDragSvc";
  }
  setupRowDrag(e, t) {
    const o = t.createManagedBean(new kOe(e)), n = this.beans.dragAndDrop;
    n.addDropTarget(o), t.addDestroyFunc(() => n.removeDropTarget(o)), this.rowDragFeature = o;
  }
  createRowDragComp(e, t, o, n, s, i) {
    return new AOe(e, t, o, n, s, i);
  }
  createRowDragCompForRow(e, t) {
    if (kn(this.gos))
      return;
    const o = this.getLocaleTextFunc();
    return this.createRowDragComp(
      () => `1 ${o("rowDragRow", "row")}`,
      e,
      void 0,
      t,
      void 0,
      !0
    );
  }
  createRowDragCompForCell(e, t, o, n, s, i) {
    const r = this.gos;
    return r.get("rowDragManaged") && (!dt(r) || r.get("pagination")) ? void 0 : this.createRowDragComp(
      o,
      e,
      t,
      n,
      s,
      i
    );
  }
}, ZOe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "rowDropHighlightSvc", this.uiLevel = 0, this.dragging = !1, this.row = null, this.position = "none";
  }
  postConstruct() {
    this.addManagedEventListeners({
      modelUpdated: this.onModelUpdated.bind(this)
    });
  }
  onModelUpdated() {
    const e = this.row, t = this.dragging;
    !e || e.rowIndex === null || this.position === "none" ? this.clear() : this.set(e, this.position), this.dragging = t;
  }
  destroy() {
    this.clear(), super.destroy();
  }
  clear() {
    const e = this.row;
    this.dragging = !1, e && (this.uiLevel = 0, this.position = "none", this.row = null, e.dispatchRowEvent("rowHighlightChanged"));
  }
  set(e, t) {
    const o = e !== this.row, n = e.uiLevel, s = t !== this.position, i = n !== this.uiLevel;
    this.dragging = !1, (o || s || i) && (o && this.clear(), this.uiLevel = n, this.position = t, this.row = e, e.dispatchRowEvent("rowHighlightChanged"));
  }
  fromDrag(e) {
    const t = e == null ? void 0 : e.dropTarget;
    if (t) {
      const { highlight: o, target: n, position: s } = t;
      if (o && n && s !== "none") {
        this.set(n, s), this.dragging = !0;
        return;
      }
    }
    this.dragging && this.clear();
  }
}, Jb = {
  moduleName: "Drag",
  version: be,
  beans: [SOe]
}, GOe = {
  moduleName: "DragAndDrop",
  version: be,
  dynamicBeans: {
    dndSourceComp: mOe
  },
  icons: {
    // drag handle used to pick up draggable rows
    rowDrag: "grip"
  }
}, f1 = {
  moduleName: "SharedDragAndDrop",
  version: be,
  beans: [Xke],
  dependsOn: [Jb],
  userComponents: {
    agDragAndDropImage: SVe
  },
  icons: {
    // shown on drag and drop image component icon while dragging column to the side of the grid to pin
    columnMovePin: "pin",
    // shown on drag and drop image component icon while dragging over part of the page that is not a drop zone
    columnMoveHide: "eye-slash",
    // shown on drag and drop image component icon while dragging columns to reorder
    columnMoveMove: "arrows",
    // animating icon shown when dragging a column to the right of the grid causes horizontal scrolling
    columnMoveLeft: "left",
    // animating icon shown when dragging a column to the left of the grid causes horizontal scrolling
    columnMoveRight: "right",
    // shown on drag and drop image component icon while dragging over Row Groups drop zone
    columnMoveGroup: "group",
    // shown on drag and drop image component icon while dragging over Values drop zone
    columnMoveValue: "aggregation",
    // shown on drag and drop image component icon while dragging over pivot drop zone
    columnMovePivot: "pivot",
    // shown on drag and drop image component icon while dragging over drop zone that doesn't support it, e.g.
    // string column over aggregation drop zone
    dropNotAllowed: "not-allowed",
    // drag handle used to pick up draggable rows
    rowDrag: "grip"
  }
}, NOe = {
  moduleName: "RowDrag",
  version: be,
  beans: [ZOe, $Oe],
  apiFunctions: {
    addRowDropZone: COe,
    removeRowDropZone: wOe,
    getRowDropZoneParams: bOe,
    getRowDropPositionIndicator: yOe,
    setRowDropPositionIndicator: _Oe
  },
  dependsOn: [f1]
}, Xb = {
  moduleName: "HorizontalResize",
  version: be,
  beans: [xOe],
  dependsOn: [Jb]
}, zOe = (
  /*css*/
  ":where(.ag-ltr) :where(.ag-column-moving){.ag-cell,.ag-header-cell,.ag-spanned-cell-wrapper{transition:left .2s}.ag-header-group-cell{transition:left .2s,width .2s}}:where(.ag-rtl) :where(.ag-column-moving){.ag-cell,.ag-header-cell,.ag-spanned-cell-wrapper{transition:right .2s}.ag-header-group-cell{transition:right .2s,width .2s}}"
), jOe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "colAnimation", this.executeNextFuncs = [], this.executeLaterFuncs = [], this.active = !1, this.activeNext = !1, this.suppressAnimation = !1, this.animationThreadCount = 0;
  }
  postConstruct() {
    this.beans.ctrlsSvc.whenReady(this, (e) => this.gridBodyCtrl = e.gridBodyCtrl);
  }
  isActive() {
    return this.active && !this.suppressAnimation;
  }
  setSuppressAnimation(e) {
    this.suppressAnimation = e;
  }
  start() {
    if (this.active)
      return;
    const { gos: e } = this;
    e.get("suppressColumnMoveAnimation") || e.get("enableRtl") || (this.ensureAnimationCssClassPresent(), this.active = !0, this.activeNext = !0);
  }
  finish() {
    this.active && this.flush(
      () => this.activeNext = !1,
      () => this.active = !1
    );
  }
  executeNextVMTurn(e) {
    this.activeNext ? this.executeNextFuncs.push(e) : e();
  }
  executeLaterVMTurn(e) {
    this.active ? this.executeLaterFuncs.push(e) : e();
  }
  ensureAnimationCssClassPresent() {
    this.animationThreadCount++;
    const e = this.animationThreadCount, { gridBodyCtrl: t } = this;
    t.setColumnMovingCss(!0), this.executeLaterFuncs.push(() => {
      this.animationThreadCount === e && t.setColumnMovingCss(!1);
    });
  }
  flush(e, t) {
    const { executeNextFuncs: o, executeLaterFuncs: n } = this;
    if (o.length === 0 && n.length === 0) {
      e(), t();
      return;
    }
    const s = (i) => {
      for (; i.length; ) {
        const r = i.pop();
        r && r();
      }
    };
    this.beans.frameworkOverrides.wrapIncoming(() => {
      window.setTimeout(() => {
        e(), s(o);
      }, 0), window.setTimeout(() => {
        t(), s(n);
      }, 200);
    });
  }
};
function WOe(e, t, o) {
  var n;
  (n = e.colMoves) == null || n.moveColumnByIndex(t, o, "api");
}
function UOe(e, t, o) {
  var n;
  (n = e.colMoves) == null || n.moveColumns(t, o, "api");
}
var KOe = class extends K {
  constructor(e) {
    super(), this.pinned = e, this.columnsToAggregate = [], this.columnsToGroup = [], this.columnsToPivot = [];
  }
  /** Callback for when drag enters */
  onDragEnter(e) {
    if (this.clearColumnsList(), this.gos.get("functionsReadOnly"))
      return;
    const t = e.dragItem.columns;
    t && t.forEach((o) => {
      o.isPrimary() && (o.isAnyFunctionActive() || (o.isAllowValue() ? this.columnsToAggregate.push(o) : o.isAllowRowGroup() ? this.columnsToGroup.push(o) : o.isAllowPivot() && this.columnsToPivot.push(o)));
    });
  }
  getIconName() {
    return this.columnsToAggregate.length + this.columnsToGroup.length + this.columnsToPivot.length > 0 ? this.pinned ? "pinned" : "move" : null;
  }
  /** Callback for when drag leaves */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onDragLeave(e) {
    this.clearColumnsList();
  }
  clearColumnsList() {
    this.columnsToAggregate.length = 0, this.columnsToGroup.length = 0, this.columnsToPivot.length = 0;
  }
  /** Callback for when dragging */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onDragging(e) {
  }
  /** Callback for when drag stops */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onDragStop(e) {
    const { valueColsSvc: t, rowGroupColsSvc: o, pivotColsSvc: n } = this.beans;
    this.columnsToAggregate.length > 0 && (t == null || t.addColumns(this.columnsToAggregate, "toolPanelDragAndDrop")), this.columnsToGroup.length > 0 && (o == null || o.addColumns(this.columnsToGroup, "toolPanelDragAndDrop")), this.columnsToPivot.length > 0 && (n == null || n.addColumns(this.columnsToPivot, "toolPanelDragAndDrop"));
  }
  onDragCancel() {
    this.clearColumnsList();
  }
};
function qOe(e, t) {
  !t || t.length <= 1 || t.filter((n) => e.indexOf(n) < 0).length > 0 || t.sort((n, s) => {
    const i = e.indexOf(n), r = e.indexOf(s);
    return i - r;
  });
}
function YOe(e) {
  const t = [...e];
  return e.forEach((o) => {
    var i;
    let n = null, s = o.getParent();
    for (; s != null && s.getDisplayedLeafColumns().length === 1; )
      n = s, s = s.getParent();
    n != null && (!!((i = n.getColGroupDef()) != null && i.marryChildren) ? (
      // when marry children is true, we also have to move hidden
      // columns within the group, so grab them from the `providedColumnGroup`
      n.getProvidedColumnGroup().getLeafColumns()
    ) : n.getLeafColumns()).forEach((a) => {
      t.includes(a) || t.push(a);
    });
  }), t;
}
function QOe(e, t, o, n) {
  const s = n.allCols;
  let i = null, r = null;
  for (let l = 0; l < e.length; l++) {
    const a = e[l], c = o.getProposedColumnOrder(t, a);
    if (!o.doesOrderPassRules(c))
      continue;
    const d = c.filter((h) => s.includes(h));
    if (r === null)
      r = d;
    else if (!No(d, r))
      break;
    const u = XOe(c);
    (i === null || u < i.fragCount) && (i = { move: a, fragCount: u });
  }
  return i;
}
function ey(e) {
  const { isFromHeader: t, fromLeft: o, xPosition: n, fromEnter: s, fakeEvent: i, pinned: r, gos: l, colModel: a, colMoves: c, visibleCols: d } = e;
  let { allMovingColumns: u } = e;
  t && (u = YOe(u));
  const h = u.slice();
  qOe(a.getCols(), h);
  const p = tBe({
    movingCols: h,
    draggingRight: o,
    xPosition: n,
    pinned: r,
    gos: l,
    colModel: a,
    visibleCols: d
  }), C = JOe(h, a);
  if (p.length === 0)
    return;
  const m = p[0];
  if (C !== null && (t || !s) && !i && (!o && m >= C || o && m <= C))
    return;
  const y = QOe(p, h, c, d);
  if (!y)
    return;
  const b = y.move;
  if (!(b > a.getCols().length - h.length))
    return { columns: h, toIndex: b };
}
function ty(e) {
  const { columns: t, toIndex: o } = ey(e) || {}, { finished: n, colMoves: s } = e;
  return !t || o == null ? null : (s.moveColumns(t, o, "uiColumnMoved", n), n ? null : { columns: t, toIndex: o });
}
function JOe(e, t) {
  const o = t.getCols(), n = e.map((a) => o.indexOf(a)).sort((a, c) => a - c), s = n[0];
  return Ke(n) - s !== n.length - 1 ? null : s;
}
function XOe(e) {
  function t(n) {
    const s = [];
    let i = n.getOriginalParent();
    for (; i != null; )
      s.push(i), i = i.getOriginalParent();
    return s;
  }
  let o = 0;
  for (let n = 0; n < e.length - 1; n++) {
    let s = t(e[n]), i = t(e[n + 1]);
    [s, i] = s.length > i.length ? [s, i] : [i, s], s.forEach((r) => {
      i.indexOf(r) === -1 && o++;
    });
  }
  return o;
}
function eBe(e, t) {
  switch (t) {
    case "left":
      return e.leftCols;
    case "right":
      return e.rightCols;
    default:
      return e.centerCols;
  }
}
function tBe(e) {
  const { movingCols: t, draggingRight: o, xPosition: n, pinned: s, gos: i, colModel: r, visibleCols: l } = e;
  if (i.get("suppressMovableColumns") || t.some((_) => _.getColDef().suppressMovable))
    return [];
  const c = eBe(l, s), d = r.getCols(), u = c.filter((_) => t.includes(_)), h = c.filter((_) => !t.includes(_)), p = d.filter((_) => !t.includes(_));
  let C = 0, m = n;
  if (o) {
    let _ = 0;
    u.forEach((M) => _ += M.getActualWidth()), m -= _;
  }
  if (m > 0) {
    for (let _ = 0; _ < h.length; _++) {
      const M = h[_];
      if (m -= M.getActualWidth(), m < 0)
        break;
      C++;
    }
    o && C++;
  }
  let w;
  if (C > 0) {
    const _ = h[C - 1];
    w = p.indexOf(_) + 1;
  } else
    w = p.indexOf(h[0]), w === -1 && (w = 0);
  const y = [w], b = (_, M) => _ - M;
  if (o) {
    let _ = w + 1;
    const M = d.length - 1;
    for (; _ <= M; )
      y.push(_), _++;
    y.sort(b);
  } else {
    let _ = w;
    const M = d.length - 1;
    let x = d[_];
    for (; _ <= M && c.indexOf(x) < 0; )
      _++, y.push(_), x = d[_];
    _ = w - 1;
    const L = 0;
    for (; _ >= L; )
      y.push(_), _--;
    y.sort(b).reverse();
  }
  return y;
}
function g5(e) {
  var c;
  const { pinned: t, fromKeyboard: o, gos: n, ctrlsSvc: s, useHeaderRow: i, skipScrollPadding: r } = e;
  let l = (c = s.getHeaderRowContainerCtrl(t)) == null ? void 0 : c.eViewport, { x: a } = e;
  return l ? (o && (a -= l.getBoundingClientRect().left), n.get("enableRtl") && (i && (l = l.querySelector(".ag-header-row")), a = l.clientWidth - a), t == null && !r && (a += s.get("center").getCenterViewportScrollLeft()), a) : 0;
}
function p0(e, t) {
  for (const o of e)
    o.moving = t, o.dispatchColEvent("movingChanged", "uiColumnMoved");
}
var iu = 7, p5 = 100, I1 = p5 / 2, oBe = 5, nBe = 100, sBe = class extends K {
  constructor(e) {
    super(), this.pinned = e, this.needToMoveLeft = !1, this.needToMoveRight = !1, this.lastMovedInfo = null, this.isCenterContainer = !ue(e);
  }
  postConstruct() {
    this.beans.ctrlsSvc.whenReady(this, (e) => {
      this.gridBodyCon = e.gridBodyCtrl;
    });
  }
  getIconName() {
    const { pinned: e, lastDraggingEvent: t } = this, { dragItem: o } = t || {}, n = (o == null ? void 0 : o.columns) ?? [];
    for (const s of n) {
      const i = s.getPinned();
      if (s.getColDef().lockPinned) {
        if (i == e)
          return "move";
        continue;
      }
      const r = o == null ? void 0 : o.containerType;
      if (r === e || !e)
        return "move";
      if (e && (!i || r !== e))
        return "pinned";
    }
    return "notAllowed";
  }
  onDragEnter(e) {
    const t = e.dragItem, o = t.columns;
    if (e.dragSource.type === 0)
      this.setColumnsVisible(o, !0, "uiColumnDragged");
    else {
      const s = t.visibleState, i = (o || []).filter(
        (r) => s[r.getId()] && !r.isVisible()
      );
      this.setColumnsVisible(i, !0, "uiColumnDragged");
    }
    this.gos.get("suppressMoveWhenColumnDragging") || this.attemptToPinColumns(o, this.pinned), this.onDragging(e, !0, !0);
  }
  onDragging(e = this.lastDraggingEvent, t = !1, o = !1, n = !1) {
    const { gos: s, ctrlsSvc: i } = this.beans, r = s.get("suppressMoveWhenColumnDragging");
    if (n && !r) {
      this.finishColumnMoving();
      return;
    }
    if (this.lastDraggingEvent = e, !e || !n && Xe(e.hDirection))
      return;
    const l = g5({
      x: e.x,
      pinned: this.pinned,
      gos: s,
      ctrlsSvc: i
    });
    t || this.checkCenterForScrolling(l), r ? this.handleColumnDragWhileSuppressingMovement(e, t, o, l, n) : this.handleColumnDragWhileAllowingMovement(e, t, o, l, n);
  }
  onDragLeave() {
    this.ensureIntervalCleared(), this.clearHighlighted(), this.updateDragItemContainerType(), this.lastMovedInfo = null;
  }
  onDragStop() {
    this.onDragging(this.lastDraggingEvent, !1, !0, !0), this.ensureIntervalCleared(), this.lastMovedInfo = null;
  }
  onDragCancel() {
    this.clearHighlighted(), this.ensureIntervalCleared(), this.lastMovedInfo = null;
  }
  setColumnsVisible(e, t, o) {
    if (!(e != null && e.length))
      return;
    const n = e.filter((s) => !s.getColDef().lockVisible);
    n.length && this.beans.colModel.setColsVisible(n, t, o);
  }
  finishColumnMoving() {
    this.clearHighlighted();
    const e = this.lastMovedInfo;
    if (!e)
      return;
    const { columns: t, toIndex: o } = e;
    this.beans.colMoves.moveColumns(t, o, "uiColumnMoved", !0);
  }
  updateDragItemContainerType() {
    const { lastDraggingEvent: e } = this;
    if (this.gos.get("suppressMoveWhenColumnDragging") || !e)
      return;
    const t = e.dragItem;
    t && (t.containerType = this.pinned);
  }
  handleColumnDragWhileSuppressingMovement(e, t, o, n, s) {
    const i = this.getAllMovingColumns(e, !0);
    if (s) {
      const r = this.isAttemptingToPin(i);
      r && this.attemptToPinColumns(i, void 0, !0);
      const { fromLeft: l, xPosition: a } = this.getNormalisedXPositionInfo(i, r) || {};
      if (l == null || a == null) {
        this.finishColumnMoving();
        return;
      }
      this.moveColumnsAfterHighlight({
        allMovingColumns: i,
        xPosition: a,
        fromEnter: t,
        fakeEvent: o,
        fromLeft: l
      });
    } else {
      if (!this.beans.dragAndDrop.isDropZoneWithinThisGrid(e))
        return;
      this.highlightHoveredColumn(i, n);
    }
  }
  handleColumnDragWhileAllowingMovement(e, t, o, n, s) {
    const i = this.getAllMovingColumns(e), r = this.normaliseDirection(e.hDirection) === "right", l = e.dragSource.type === 1, a = this.getMoveColumnParams({
      allMovingColumns: i,
      isFromHeader: l,
      xPosition: n,
      fromLeft: r,
      fromEnter: t,
      fakeEvent: o
    }), c = ty({ ...a, finished: s });
    c && (this.lastMovedInfo = c);
  }
  getAllMovingColumns(e, t = !1) {
    const o = e.dragSource.getDragItem();
    let n = null;
    t ? (n = o.columnsInSplit, n || (n = o.columns)) : n = o.columns;
    const s = (i) => i.getColDef().lockPinned ? i.getPinned() == this.pinned : !0;
    return n ? n.filter(s) : [];
  }
  getMoveColumnParams(e) {
    const { allMovingColumns: t, isFromHeader: o, xPosition: n, fromLeft: s, fromEnter: i, fakeEvent: r } = e, { gos: l, colModel: a, colMoves: c, visibleCols: d } = this.beans;
    return {
      allMovingColumns: t,
      isFromHeader: o,
      fromLeft: s,
      xPosition: n,
      pinned: this.pinned,
      fromEnter: i,
      fakeEvent: r,
      gos: l,
      colModel: a,
      colMoves: c,
      visibleCols: d
    };
  }
  highlightHoveredColumn(e, t) {
    var d;
    const { gos: o, colModel: n } = this.beans, s = o.get("enableRtl"), i = n.getCols().filter((u) => u.isVisible() && u.getPinned() === this.pinned);
    let r = null, l = null, a = null;
    for (const u of i) {
      if (l = u.getActualWidth(), r = this.getNormalisedColumnLeft(u, 0, s), r != null) {
        const h = r + l;
        if (r <= t && h >= t) {
          a = u;
          break;
        }
      }
      r = null, l = null;
    }
    if (a)
      e.indexOf(a) !== -1 && (a = null);
    else {
      for (let u = i.length - 1; u >= 0; u--) {
        const h = i[u], p = i[u].getParent();
        if (!p) {
          a = h;
          break;
        }
        const C = p == null ? void 0 : p.getDisplayedLeafColumns();
        if (C.length) {
          a = Ke(C);
          break;
        }
      }
      if (!a)
        return;
      r = this.getNormalisedColumnLeft(a, 0, s), l = a.getActualWidth();
    }
    if (((d = this.lastHighlightedColumn) == null ? void 0 : d.column) !== a && this.clearHighlighted(), a == null || r == null || l == null)
      return;
    let c;
    t - r < l / 2 !== s ? c = 0 : c = 1, ru(a, c), this.lastHighlightedColumn = { column: a, position: c };
  }
  getNormalisedXPositionInfo(e, t) {
    const { gos: o, visibleCols: n } = this.beans, s = o.get("enableRtl"), { firstMovingCol: i, column: r, position: l } = this.getColumnMoveAndTargetInfo(
      e,
      t,
      s
    );
    if (!i || !r || l == null)
      return;
    const a = n.allCols, c = a.indexOf(i), d = a.indexOf(r), u = l === 0 !== s, h = c < d || c === d && !u;
    let p = 0;
    if (u ? h && (p -= 1) : h || (p += 1), d + p === c)
      return;
    const C = a[d + p];
    if (!C)
      return;
    const m = this.getNormalisedColumnLeft(C, 20, s);
    return { fromLeft: h, xPosition: m };
  }
  getColumnMoveAndTargetInfo(e, t, o) {
    const n = this.lastHighlightedColumn || {}, { firstMovingCol: s, lastMovingCol: i } = iBe(e);
    if (!s || !i || n.column || !t)
      return {
        firstMovingCol: s,
        ...n
      };
    const l = this.getPinDirection() === "left";
    return {
      firstMovingCol: s,
      position: l ? 1 : 0,
      column: l !== o ? s : i
    };
  }
  normaliseDirection(e) {
    if (this.gos.get("enableRtl"))
      switch (e) {
        case "left":
          return "right";
        case "right":
          return "left";
      }
    return e;
  }
  getNormalisedColumnLeft(e, t, o) {
    const { gos: n, ctrlsSvc: s } = this.beans, i = e.getLeft();
    if (i == null)
      return null;
    const r = e.getActualWidth();
    return g5({
      x: o ? i + r - t : i + t,
      pinned: e.getPinned(),
      useHeaderRow: o,
      skipScrollPadding: !0,
      gos: n,
      ctrlsSvc: s
    });
  }
  isAttemptingToPin(e) {
    const t = this.needToMoveLeft || this.needToMoveRight, o = this.failedMoveAttempts > iu;
    return t && o || e.some((n) => n.getPinned() !== this.pinned);
  }
  moveColumnsAfterHighlight(e) {
    const { allMovingColumns: t, xPosition: o, fromEnter: n, fakeEvent: s, fromLeft: i } = e, r = this.getMoveColumnParams({
      allMovingColumns: t,
      isFromHeader: !0,
      xPosition: o,
      fromLeft: i,
      fromEnter: n,
      fakeEvent: s
    }), { columns: l, toIndex: a } = ey(r) || {};
    l && a != null && (this.lastMovedInfo = {
      columns: l,
      toIndex: a
    }), this.finishColumnMoving();
  }
  clearHighlighted() {
    const { lastHighlightedColumn: e } = this;
    e && (ru(e.column, null), this.lastHighlightedColumn = null);
  }
  checkCenterForScrolling(e) {
    if (!this.isCenterContainer)
      return;
    const t = this.beans.ctrlsSvc.get("center"), o = t.getCenterViewportScrollLeft(), n = o + t.getCenterWidth();
    let s, i;
    this.gos.get("enableRtl") ? (s = e < o + I1, i = e > n - I1) : (i = e < o + I1, s = e > n - I1), this.needToMoveRight = s, this.needToMoveLeft = i, i || s ? this.ensureIntervalStarted() : this.ensureIntervalCleared();
  }
  ensureIntervalStarted() {
    this.movingIntervalId || (this.intervalCount = 0, this.failedMoveAttempts = 0, this.movingIntervalId = window.setInterval(this.moveInterval.bind(this), nBe), this.beans.dragAndDrop.setDragImageCompIcon(this.needToMoveLeft ? "left" : "right", !0));
  }
  ensureIntervalCleared() {
    this.movingIntervalId && (window.clearInterval(this.movingIntervalId), this.movingIntervalId = null, this.failedMoveAttempts = 0, this.beans.dragAndDrop.setDragImageCompIcon(this.getIconName()));
  }
  moveInterval() {
    var n;
    let e;
    this.intervalCount++, e = 10 + this.intervalCount * oBe, e > p5 && (e = p5);
    let t = null;
    const o = this.gridBodyCon.scrollFeature;
    if (this.needToMoveLeft ? t = o.scrollHorizontally(-e) : this.needToMoveRight && (t = o.scrollHorizontally(e)), t !== 0)
      this.onDragging(this.lastDraggingEvent), this.failedMoveAttempts = 0;
    else {
      this.failedMoveAttempts++;
      const { pinnedCols: s, dragAndDrop: i, gos: r } = this.beans;
      if (this.failedMoveAttempts <= iu + 1 || !s)
        return;
      if (i.setDragImageCompIcon("pinned"), !r.get("suppressMoveWhenColumnDragging")) {
        const l = (n = this.lastDraggingEvent) == null ? void 0 : n.dragItem.columns;
        this.attemptToPinColumns(l, void 0, !0);
      }
    }
  }
  getPinDirection() {
    if (this.needToMoveLeft || this.pinned === "left")
      return "left";
    if (this.needToMoveRight || this.pinned === "right")
      return "right";
  }
  attemptToPinColumns(e, t, o = !1) {
    const n = (e || []).filter((r) => !r.getColDef().lockPinned);
    if (!n.length)
      return 0;
    o && (t = this.getPinDirection());
    const { pinnedCols: s, dragAndDrop: i } = this.beans;
    return s == null || s.setColsPinned(n, t, "uiColumnDragged"), o && i.nudge(), n.length;
  }
  destroy() {
    super.destroy(), this.lastDraggingEvent = null, this.clearHighlighted(), this.lastMovedInfo = null;
  }
};
function ru(e, t) {
  e.highlighted !== t && (e.highlighted = t, e.dispatchColEvent("headerHighlightChanged", "uiColumnMoved"));
}
function iBe(e) {
  const t = e.length;
  let o, n;
  for (let s = 0; s < t; s++) {
    if (!o) {
      const i = e[s];
      i.getLeft() != null && (o = i);
    }
    if (!n) {
      const i = e[t - 1 - s];
      i.getLeft() != null && (n = i);
    }
    if (o && n)
      break;
  }
  return { firstMovingCol: o, lastMovingCol: n };
}
var rBe = class extends K {
  constructor(e, t) {
    super(), this.pinned = e, this.eContainer = t;
  }
  postConstruct() {
    const { ctrlsSvc: e, dragAndDrop: t } = this.beans, o = this.pinned;
    e.whenReady(this, (n) => {
      let s;
      const i = n.gridBodyCtrl.eBodyViewport;
      switch (o) {
        case "left":
          s = [
            [i, n.left.eContainer],
            [n.bottomLeft.eContainer],
            [n.topLeft.eContainer]
          ];
          break;
        case "right":
          s = [
            [i, n.right.eContainer],
            [n.bottomRight.eContainer],
            [n.topRight.eContainer]
          ];
          break;
        default:
          s = [
            [i, n.center.eViewport],
            [n.bottomCenter.eViewport],
            [n.topCenter.eViewport]
          ];
          break;
      }
      this.eSecondaryContainers = s;
    }), this.moveColumnFeature = this.createManagedBean(new sBe(o)), this.bodyDropPivotTarget = this.createManagedBean(new KOe(o)), t.addDropTarget(this), this.addDestroyFunc(() => t.removeDropTarget(this));
  }
  isInterestedIn(e) {
    return e === 1 || e === 0 && this.gos.get("allowDragFromColumnsToolPanel");
  }
  getSecondaryContainers() {
    return this.eSecondaryContainers;
  }
  getContainer() {
    return this.eContainer;
  }
  getIconName() {
    return this.currentDropListener.getIconName();
  }
  // we want to use the bodyPivotTarget if the user is dragging columns in from the toolPanel
  // and we are in pivot mode, as it has to logic to set pivot/value/group on the columns when
  // dropped into the grid's body.
  isDropColumnInPivotMode(e) {
    return this.beans.colModel.isPivotMode() && e.dragSource.type === 0;
  }
  onDragEnter(e) {
    this.currentDropListener = this.isDropColumnInPivotMode(e) ? this.bodyDropPivotTarget : this.moveColumnFeature, this.currentDropListener.onDragEnter(e);
  }
  onDragLeave(e) {
    this.currentDropListener.onDragLeave(e);
  }
  onDragging(e) {
    this.currentDropListener.onDragging(e);
  }
  onDragStop(e) {
    this.currentDropListener.onDragStop(e);
  }
  onDragCancel() {
    this.currentDropListener.onDragCancel();
  }
}, lBe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "colMoves";
  }
  moveColumnByIndex(e, t, o) {
    const n = this.beans.colModel.getCols();
    if (!n)
      return;
    const s = n[e];
    this.moveColumns([s], t, o);
  }
  moveColumns(e, t, o, n = !0) {
    const { colModel: s, colAnimation: i, visibleCols: r, eventSvc: l } = this.beans, a = s.getCols();
    if (!a)
      return;
    if (t > a.length - e.length) {
      X(30, { toIndex: t });
      return;
    }
    i == null || i.start();
    const c = s.getColsForKeys(e);
    this.doesMovePassRules(c, t) && (Ed(s.getCols(), c, t), r.refresh(o), l.dispatchEvent({
      type: "columnMoved",
      columns: c,
      column: c.length === 1 ? c[0] : null,
      toIndex: t,
      finished: n,
      source: o
    })), i == null || i.finish();
  }
  doesMovePassRules(e, t) {
    const o = this.getProposedColumnOrder(e, t);
    return this.doesOrderPassRules(o);
  }
  doesOrderPassRules(e) {
    const { colModel: t, gos: o } = this.beans;
    return !(!$w(e, t.getColTree()) || !((s) => {
      const i = (c) => c ? c === "left" || c === !0 ? -1 : 1 : 0, r = o.get("enableRtl");
      let l = r ? 1 : -1, a = !0;
      return s.forEach((c) => {
        const d = i(c.getColDef().lockPosition);
        r ? d > l && (a = !1) : d < l && (a = !1), l = d;
      }), a;
    })(e));
  }
  getProposedColumnOrder(e, t) {
    const n = this.beans.colModel.getCols().slice();
    return Ed(n, e, t), n;
  }
  createBodyDropTarget(e, t) {
    return new rBe(e, t);
  }
  moveHeader(e, t, o, n, s) {
    const { ctrlsSvc: i, gos: r, colModel: l, visibleCols: a, focusSvc: c } = this.beans, d = t.getBoundingClientRect(), u = d.left, h = St(o), p = h ? d.width : o.getActualWidth(), C = e === "left" !== r.get("enableRtl"), m = g5({
      x: C ? u - 20 : u + p + 20,
      pinned: n,
      fromKeyboard: !0,
      gos: r,
      ctrlsSvc: i
    }), w = c.focusedHeader;
    ty({
      allMovingColumns: h ? o.getLeafColumns() : [o],
      isFromHeader: !0,
      fromLeft: e === "right",
      xPosition: m,
      pinned: n,
      fromEnter: !1,
      fakeEvent: !1,
      gos: r,
      colModel: l,
      colMoves: this,
      visibleCols: a,
      finished: !0
    });
    let y;
    if (h) {
      const b = o.getDisplayedLeafColumns();
      y = C ? b[0] : Ke(b);
    } else
      y = o;
    if (i.getScrollFeature().ensureColumnVisible(y, "auto"), (!s.isAlive() || r.get("ensureDomOrder")) && w) {
      let b;
      if (h) {
        const _ = o.getGroupId(), M = o.getLeafColumns();
        if (!M.length)
          return;
        const x = M[0].getParent();
        if (!x)
          return;
        b = aBe(x, _);
      } else
        b = o;
      b && c.focusHeaderPosition({
        headerPosition: {
          ...w,
          column: b
        }
      });
    }
  }
  setDragSourceForHeader(e, t, o) {
    const { gos: n, colModel: s, dragAndDrop: i, visibleCols: r } = this.beans;
    let l = !n.get("suppressDragLeaveHidesColumns");
    const a = St(t), c = a ? t.getProvidedColumnGroup().getLeafColumns() : [t], u = {
      type: 1,
      eElement: e,
      getDefaultIconName: () => l ? "hide" : "notAllowed",
      getDragItem: a ? () => dBe(t, r.allCols) : () => cBe(t),
      dragItemName: o,
      onDragStarted: () => {
        l = !n.get("suppressDragLeaveHidesColumns"), p0(c, !0);
      },
      onDragStopped: () => p0(c, !1),
      onDragCancelled: () => p0(c, !1),
      onGridEnter: (h) => {
        if (l) {
          const { columns: p = [], visibleState: C } = h ?? {}, m = a ? (y) => !C || C[y.getColId()] : () => !0, w = p.filter(
            (y) => !y.getColDef().lockVisible && m(y)
          );
          s.setColsVisible(w, !0, "uiColumnMoved");
        }
      },
      onGridExit: (h) => {
        var p;
        if (l) {
          const C = ((p = h == null ? void 0 : h.columns) == null ? void 0 : p.filter((m) => !m.getColDef().lockVisible)) || [];
          s.setColsVisible(C, !1, "uiColumnMoved");
        }
      }
    };
    return i.addDragSource(u, !0), u;
  }
};
function aBe(e, t) {
  for (; e; ) {
    if (e.getGroupId() === t)
      return e;
    e = e.getParent();
  }
}
function cBe(e) {
  const t = {};
  return t[e.getId()] = e.isVisible(), {
    columns: [e],
    visibleState: t,
    containerType: e.pinned
  };
}
function dBe(e, t) {
  var l;
  const o = e.getProvidedColumnGroup().getLeafColumns(), n = {};
  o.forEach((a) => n[a.getId()] = a.isVisible());
  const s = [];
  t.forEach((a) => {
    o.indexOf(a) >= 0 && (s.push(a), Zt(o, a));
  }), o.forEach((a) => s.push(a));
  const i = [], r = e.getLeafColumns();
  for (const a of s)
    r.indexOf(a) !== -1 && i.push(a);
  return {
    columns: s,
    columnsInSplit: i,
    visibleState: n,
    containerType: (l = i[0]) == null ? void 0 : l.pinned
  };
}
var tc = {
  moduleName: "ColumnMove",
  version: be,
  beans: [lBe, jOe],
  apiFunctions: {
    moveColumnByIndex: WOe,
    moveColumns: UOe
  },
  dependsOn: [f1],
  css: [zOe]
}, uBe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "autoWidthCalc";
  }
  postConstruct() {
    this.beans.ctrlsSvc.whenReady(this, (e) => {
      this.centerRowContainerCtrl = e.center;
    });
  }
  // this is the trick: we create a dummy container and clone all the cells
  // into the dummy, then check the dummy's width. then destroy the dummy
  // as we don't need it any more.
  // drawback: only the cells visible on the screen are considered
  getPreferredWidthForColumn(e, t) {
    const o = this.getHeaderCellForColumn(e);
    if (!o)
      return -1;
    const n = this.beans.rowRenderer.getAllCellsNotSpanningForColumn(e);
    return t || n.push(o), this.getPreferredWidthForElements(n);
  }
  getPreferredWidthForColumnGroup(e) {
    const t = this.getHeaderCellForColumn(e);
    return t ? this.getPreferredWidthForElements([t]) : -1;
  }
  getPreferredWidthForElements(e, t) {
    const o = document.createElement("form");
    o.style.position = "fixed";
    const n = this.centerRowContainerCtrl.eContainer;
    e.forEach((i) => this.cloneItemIntoDummy(i, o)), n.appendChild(o);
    const s = o.offsetWidth;
    return n.removeChild(o), t = t ?? this.gos.get("autoSizePadding"), s + t;
  }
  getHeaderCellForColumn(e) {
    let t = null;
    return this.beans.ctrlsSvc.getHeaderRowContainerCtrls().forEach((o) => {
      const n = o.getHtmlElementForColumnHeader(e);
      n != null && (t = n);
    }), t;
  }
  cloneItemIntoDummy(e, t) {
    const o = e.cloneNode(!0);
    o.style.width = "", o.style.position = "static", o.style.left = "";
    const n = document.createElement("div"), s = n.classList;
    ["ag-header-cell", "ag-header-group-cell"].some((l) => o.classList.contains(l)) ? (s.add("ag-header", "ag-header-row"), n.style.position = "static") : s.add("ag-row");
    let r = e.parentElement;
    for (; r; ) {
      if (["ag-header-row", "ag-row"].some((a) => r.classList.contains(a))) {
        for (let a = 0; a < r.classList.length; a++) {
          const c = r.classList[a];
          c != "ag-row-position-absolute" && s.add(c);
        }
        break;
      }
      r = r.parentElement;
    }
    n.appendChild(o), t.appendChild(n);
  }
}, oy = {
  moduleName: "AutoWidth",
  version: be,
  beans: [uBe]
};
function hBe(e, t, o = !0, n = "api") {
  var s;
  (s = e.colResize) == null || s.setColumnWidths(t, !1, o, n);
}
var gBe = class extends K {
  constructor(e, t, o, n) {
    super(), this.comp = e, this.eResize = t, this.pinned = o, this.columnGroup = n;
  }
  postConstruct() {
    if (!this.columnGroup.isResizable()) {
      this.comp.setResizableDisplayed(!1);
      return;
    }
    const { horizontalResizeSvc: e, gos: t, colAutosize: o } = this.beans, n = e.addResizeBar({
      eResizeBar: this.eResize,
      onResizeStart: this.onResizeStart.bind(this),
      onResizing: this.onResizing.bind(this, !1),
      onResizeEnd: this.onResizing.bind(this, !0)
    });
    this.addDestroyFunc(n), !t.get("suppressAutoSize") && o && this.addDestroyFunc(
      o.addColumnGroupResize(
        this.eResize,
        this.columnGroup,
        () => this.resizeLeafColumnsToFit("uiColumnResized")
      )
    );
  }
  onResizeStart(e) {
    const {
      columnsToResize: t,
      resizeStartWidth: o,
      resizeRatios: n,
      groupAfterColumns: s,
      groupAfterStartWidth: i,
      groupAfterRatios: r
    } = this.getInitialValues(e);
    this.resizeCols = t, this.resizeStartWidth = o, this.resizeRatios = n, this.resizeTakeFromCols = s, this.resizeTakeFromStartWidth = i, this.resizeTakeFromRatios = r, this.toggleColumnResizing(!0);
  }
  onResizing(e, t, o = "uiColumnResized") {
    const n = this.normaliseDragChange(t), s = this.resizeStartWidth + n;
    this.resizeColumnsFromLocalValues(s, o, e);
  }
  getInitialValues(e) {
    var a;
    const t = (c) => c.reduce((d, u) => d + u.getActualWidth(), 0), o = (c, d) => c.map((u) => u.getActualWidth() / d), n = this.getColumnsToResize(), s = t(n), i = o(n, s), r = {
      columnsToResize: n,
      resizeStartWidth: s,
      resizeRatios: i
    };
    let l = null;
    if (e && (l = ((a = this.beans.colGroupSvc) == null ? void 0 : a.getGroupAtDirection(this.columnGroup, "After")) ?? null), l) {
      const c = l.getDisplayedLeafColumns(), d = r.groupAfterColumns = c.filter(
        (h) => h.isResizable()
      ), u = r.groupAfterStartWidth = t(d);
      r.groupAfterRatios = o(d, u);
    } else
      r.groupAfterColumns = void 0, r.groupAfterStartWidth = void 0, r.groupAfterRatios = void 0;
    return r;
  }
  resizeLeafColumnsToFit(e) {
    const t = this.beans.autoWidthCalc.getPreferredWidthForColumnGroup(this.columnGroup), o = this.getInitialValues();
    t > o.resizeStartWidth && this.resizeColumns(o, t, e, !0);
  }
  resizeColumnsFromLocalValues(e, t, o = !0) {
    if (!this.resizeCols || !this.resizeRatios)
      return;
    const n = {
      columnsToResize: this.resizeCols,
      resizeStartWidth: this.resizeStartWidth,
      resizeRatios: this.resizeRatios,
      groupAfterColumns: this.resizeTakeFromCols,
      groupAfterStartWidth: this.resizeTakeFromStartWidth,
      groupAfterRatios: this.resizeTakeFromRatios
    };
    this.resizeColumns(n, e, t, o);
  }
  resizeColumns(e, t, o, n = !0) {
    var u;
    const {
      columnsToResize: s,
      resizeStartWidth: i,
      resizeRatios: r,
      groupAfterColumns: l,
      groupAfterStartWidth: a,
      groupAfterRatios: c
    } = e, d = [];
    if (d.push({
      columns: s,
      ratios: r,
      width: t
    }), l) {
      const h = t - i;
      d.push({
        columns: l,
        ratios: c,
        width: a - h
      });
    }
    (u = this.beans.colResize) == null || u.resizeColumnSets({
      resizeSets: d,
      finished: n,
      source: o
    }), n && this.toggleColumnResizing(!1);
  }
  toggleColumnResizing(e) {
    this.comp.toggleCss("ag-column-resizing", e);
  }
  getColumnsToResize() {
    return this.columnGroup.getDisplayedLeafColumns().filter((t) => t.isResizable());
  }
  // optionally inverts the drag, depending on pinned and RTL
  // note - this method is duplicated in RenderedHeaderCell - should refactor out?
  normaliseDragChange(e) {
    let t = e;
    return this.gos.get("enableRtl") ? this.pinned !== "left" && (t *= -1) : this.pinned === "right" && (t *= -1), t;
  }
  destroy() {
    super.destroy(), this.resizeCols = void 0, this.resizeRatios = void 0, this.resizeTakeFromCols = void 0, this.resizeTakeFromRatios = void 0;
  }
}, pBe = class extends K {
  constructor(e, t, o, n, s) {
    super(), this.pinned = e, this.column = t, this.eResize = o, this.comp = n, this.ctrl = s;
  }
  postConstruct() {
    const e = [];
    let t, o;
    const n = () => {
      if (He(this.eResize, t), !t)
        return;
      const { horizontalResizeSvc: r, colAutosize: l } = this.beans, a = r.addResizeBar({
        eResizeBar: this.eResize,
        onResizeStart: this.onResizeStart.bind(this),
        onResizing: this.onResizing.bind(this, !1),
        onResizeEnd: this.onResizing.bind(this, !0)
      });
      e.push(a), o && l && e.push(l.addColumnAutosize(this.eResize, this.column));
    }, s = () => {
      e.forEach((r) => r()), e.length = 0;
    }, i = () => {
      const r = this.column.isResizable(), l = !this.gos.get("suppressAutoSize") && !this.column.getColDef().suppressAutoSize;
      (r !== t || l !== o) && (t = r, o = l, s(), n());
    };
    i(), this.addDestroyFunc(s), this.ctrl.setRefreshFunction("resize", i);
  }
  onResizing(e, t) {
    const { column: o, lastResizeAmount: n, resizeStartWidth: s, beans: i } = this, r = this.normaliseResizeAmount(t), l = s + r, a = [{ key: o, newWidth: l }], { pinnedCols: c, ctrlsSvc: d, colResize: u } = i;
    if (this.column.getPinned()) {
      const h = (c == null ? void 0 : c.leftWidth) ?? 0, p = (c == null ? void 0 : c.rightWidth) ?? 0, C = Bi(d.getGridBodyCtrl().eBodyViewport) - 50;
      if (h + p + (r - n) > C)
        return;
    }
    this.lastResizeAmount = r, u == null || u.setColumnWidths(a, this.resizeWithShiftKey, e, "uiColumnResized"), e && this.toggleColumnResizing(!1);
  }
  onResizeStart(e) {
    this.resizeStartWidth = this.column.getActualWidth(), this.lastResizeAmount = 0, this.resizeWithShiftKey = e, this.toggleColumnResizing(!0);
  }
  toggleColumnResizing(e) {
    this.column.resizing = e, this.comp.toggleCss("ag-column-resizing", e);
  }
  // optionally inverts the drag, depending on pinned and RTL
  // note - this method is duplicated in RenderedHeaderGroupCell - should refactor out?
  normaliseResizeAmount(e) {
    let t = e;
    const o = this.pinned !== "left", n = this.pinned === "right";
    return this.gos.get("enableRtl") ? o && (t *= -1) : n && (t *= -1), t;
  }
}, fBe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "colResize";
  }
  setColumnWidths(e, t, o, n) {
    const s = [], { colModel: i, gos: r, visibleCols: l } = this.beans;
    e.forEach((a) => {
      const c = i.getColDefCol(a.key) || i.getCol(a.key);
      if (!c)
        return;
      if (s.push({
        width: a.newWidth,
        ratios: [1],
        columns: [c]
      }), r.get("colResizeDefault") === "shift" && (t = !t), t) {
        const u = l.getColAfter(c);
        if (!u)
          return;
        const h = c.getActualWidth() - a.newWidth, p = u.getActualWidth() + h;
        s.push({
          width: p,
          ratios: [1],
          columns: [u]
        });
      }
    }), s.length !== 0 && this.resizeColumnSets({
      resizeSets: s,
      finished: o,
      source: n
    });
  }
  // method takes sets of columns and resizes them. either all sets will be resized, or nothing
  // be resized. this is used for example when user tries to resize a group and holds shift key,
  // then both the current group (grows), and the adjacent group (shrinks), will get resized,
  // so that's two sets for this method.
  resizeColumnSets(e) {
    const { resizeSets: t, finished: o, source: n } = e;
    if (!(!t || t.every((d) => vBe(d)))) {
      if (o) {
        const d = t && t.length > 0 ? t[0].columns : null;
        Gi(this.eventSvc, d, o, n);
      }
      return;
    }
    const i = [], r = [];
    t.forEach((d) => {
      const { width: u, columns: h, ratios: p } = d, C = {}, m = {};
      h.forEach((b) => r.push(b));
      let w = !0, y = 0;
      for (; w; ) {
        if (y++, y > 1e3) {
          qe(31);
          break;
        }
        w = !1;
        const b = [];
        let _ = 0, M = u;
        h.forEach((L, A) => {
          if (m[L.getId()])
            M -= C[L.getId()];
          else {
            b.push(L);
            const P = p[A];
            _ += P;
          }
        });
        const x = 1 / _;
        b.forEach((L, A) => {
          const R = A === b.length - 1;
          let P;
          R ? P = M : (P = Math.round(p[A] * u * x), M -= P);
          const I = L.getMinWidth(), B = L.getMaxWidth();
          P < I ? (P = I, m[L.getId()] = !0, w = !0) : B > 0 && P > B && (P = B, m[L.getId()] = !0, w = !0), C[L.getId()] = P;
        });
      }
      h.forEach((b) => {
        const _ = C[b.getId()];
        b.getActualWidth() !== _ && (b.setActualWidth(_, n), i.push(b));
      });
    });
    const l = i.length > 0;
    let a = [];
    if (l) {
      const { colFlex: d, visibleCols: u, colViewport: h } = this.beans;
      a = (d == null ? void 0 : d.refreshFlexedColumns({
        resizingCols: r,
        skipSetLeft: !0
      })) ?? [], u.setLeftValues(n), u.updateBodyWidths(), h.checkViewportColumns();
    }
    const c = r.concat(a);
    (l || o) && Gi(this.eventSvc, c, o, n, a);
  }
  resizeHeader(e, t, o) {
    if (!e.isResizable())
      return;
    const n = e.getActualWidth(), s = e.getMinWidth(), i = e.getMaxWidth(), r = Math.min(Math.max(n + t, s), i);
    this.setColumnWidths([{ key: e, newWidth: r }], o, !0, "uiColumnResized");
  }
  createResizeFeature(e, t, o, n, s) {
    return new pBe(e, t, o, n, s);
  }
  createGroupResizeFeature(e, t, o, n) {
    return new gBe(e, t, o, n);
  }
};
function vBe(e) {
  const { columns: t, width: o } = e;
  let n = 0, s = 0, i = !0;
  t.forEach((a) => {
    const c = a.getMinWidth();
    n += c || 0;
    const d = a.getMaxWidth();
    d > 0 ? s += d : i = !1;
  });
  const r = o >= n, l = !i || o <= s;
  return r && l;
}
var mBe = {
  moduleName: "ColumnResize",
  version: be,
  beans: [fBe],
  apiFunctions: {
    setColumnWidths: hBe
  },
  dependsOn: [Xb, oy]
}, CBe = class extends K {
  constructor(e, t) {
    super(), this.removeChildListenersFuncs = [], this.columnGroup = t, this.comp = e;
  }
  postConstruct() {
    this.addListenersToChildrenColumns(), this.addManagedListeners(this.columnGroup, {
      displayedChildrenChanged: this.onDisplayedChildrenChanged.bind(this)
    }), this.onWidthChanged(), this.addDestroyFunc(this.removeListenersOnChildrenColumns.bind(this));
  }
  addListenersToChildrenColumns() {
    this.removeListenersOnChildrenColumns();
    const e = this.onWidthChanged.bind(this);
    this.columnGroup.getLeafColumns().forEach((t) => {
      t.__addEventListener("widthChanged", e), t.__addEventListener("visibleChanged", e), this.removeChildListenersFuncs.push(() => {
        t.__removeEventListener("widthChanged", e), t.__removeEventListener("visibleChanged", e);
      });
    });
  }
  removeListenersOnChildrenColumns() {
    this.removeChildListenersFuncs.forEach((e) => e()), this.removeChildListenersFuncs = [];
  }
  onDisplayedChildrenChanged() {
    this.addListenersToChildrenColumns(), this.onWidthChanged();
  }
  onWidthChanged() {
    const e = this.columnGroup.getActualWidth();
    this.comp.setWidth(`${e}px`), this.comp.toggleCss("ag-hidden", e === 0);
  }
}, wBe = class extends X2 {
  constructor() {
    super(...arguments), this.onSuppressColMoveChange = () => {
      !this.isAlive() || this.isSuppressMoving() ? this.removeDragSource() : this.dragSource || this.setDragSource(this.eGui);
    };
  }
  wireComp(e, t, o, n, s) {
    const { column: i, beans: r } = this, { context: l, colNames: a, colHover: c, rangeSvc: d, colResize: u } = r;
    this.comp = e, s = d1(this, l, s), this.setGui(t, s), this.displayName = a.getDisplayNameForColumnGroup(i, "header"), this.refreshHeaderStyles(), this.addClasses(), this.setupMovingCss(s), this.setupExpandable(s), this.setupTooltip(), this.setupAutoHeight({
      wrapperElement: n,
      compBean: s
    }), this.setupUserComp(), this.addHeaderMouseListeners(s), this.addManagedPropertyListener("groupHeaderHeight", this.refreshMaxHeaderHeight.bind(this)), this.refreshMaxHeaderHeight();
    const h = this.rowCtrl.pinned, p = i.getProvidedColumnGroup().getLeafColumns();
    c == null || c.createHoverFeature(s, p, t), d == null || d.createRangeHighlightFeature(s, i, e), s.createManagedBean(new J2(i, t, r)), s.createManagedBean(new CBe(e, i)), u ? this.resizeFeature = s.createManagedBean(
      u.createGroupResizeFeature(e, o, h, i)
    ) : e.setResizableDisplayed(!1), s.createManagedBean(
      new gs(t, {
        shouldStopEventPropagation: this.shouldStopEventPropagation.bind(this),
        onTabKeyDown: () => {
        },
        handleKeyDown: this.handleKeyDown.bind(this),
        onFocusIn: this.onFocusIn.bind(this)
      })
    ), this.addHighlightListeners(s, p), s.addManagedPropertyListener("suppressMovableColumns", this.onSuppressColMoveChange), this.addResizeAndMoveKeyboardListeners(s), s.addDestroyFunc(() => this.clearComponent());
  }
  getHeaderClassParams() {
    const { column: e, beans: t } = this, o = e.getDefinition();
    return Pe(t.gos, {
      colDef: o,
      columnGroup: e,
      floatingFilter: !1
    });
  }
  refreshMaxHeaderHeight() {
    const { gos: e, comp: t } = this, o = e.get("groupHeaderHeight");
    o != null ? o === 0 ? t.setHeaderWrapperHidden(!0) : t.setHeaderWrapperMaxHeight(o) : (t.setHeaderWrapperHidden(!1), t.setHeaderWrapperMaxHeight(null));
  }
  addHighlightListeners(e, t) {
    if (this.beans.gos.get("suppressMoveWhenColumnDragging"))
      for (const o of t)
        e.addManagedListeners(o, {
          headerHighlightChanged: this.onLeafColumnHighlightChanged.bind(this, o)
        });
  }
  onLeafColumnHighlightChanged(e) {
    const t = this.column.getDisplayedLeafColumns(), o = t[0] === e, n = Ke(t) === e;
    if (!o && !n)
      return;
    const s = e.getHighlighted(), i = !!this.rowCtrl.getHeaderCellCtrls().find((a) => a.column.isMoving());
    let r = !1, l = !1;
    if (i) {
      const a = this.beans.gos.get("enableRtl"), c = s === 1, d = s === 0;
      o && (a ? l = c : r = d), n && (a ? r = d : l = c);
    }
    this.comp.toggleCss("ag-header-highlight-before", r), this.comp.toggleCss("ag-header-highlight-after", l);
  }
  resizeHeader(e, t) {
    const { resizeFeature: o } = this;
    if (!o)
      return;
    const n = o.getInitialValues(t);
    o.resizeColumns(n, n.resizeStartWidth + e, "uiColumnResized", !0);
  }
  resizeLeafColumnsToFit(e) {
    var t;
    (t = this.resizeFeature) == null || t.resizeLeafColumnsToFit(e);
  }
  setupUserComp() {
    const { colGroupSvc: e, userCompFactory: t, gos: o, enterpriseMenuFactory: n } = this.beans, s = this.column, i = s.getProvidedColumnGroup(), r = Pe(o, {
      displayName: this.displayName,
      columnGroup: s,
      setExpanded: (a) => {
        e.setColumnGroupOpened(i, a, "gridInitializing");
      },
      setTooltip: (a, c) => {
        o.assertModuleRegistered("Tooltip", 3), this.setupTooltip(a, c);
      },
      showColumnMenu: (a, c) => n == null ? void 0 : n.showMenuAfterButtonClick(
        i,
        a,
        "columnMenu",
        c
      ),
      showColumnMenuAfterMouseClick: (a, c) => n == null ? void 0 : n.showMenuAfterMouseEvent(
        i,
        a,
        "columnMenu",
        c
      ),
      eGridHeader: this.eGui
    }), l = LDe(t, r);
    l && this.comp.setUserCompDetails(l);
  }
  addHeaderMouseListeners(e) {
    const t = (s) => this.handleMouseOverChange(s.type === "mouseenter"), o = () => this.dispatchColumnMouseEvent("columnHeaderClicked", this.column.getProvidedColumnGroup()), n = (s) => this.handleContextMenuMouseEvent(s, void 0, this.column.getProvidedColumnGroup());
    e.addManagedListeners(this.eGui, {
      mouseenter: t,
      mouseleave: t,
      click: o,
      contextmenu: n
    });
  }
  handleMouseOverChange(e) {
    this.eventSvc.dispatchEvent({
      type: e ? "columnHeaderMouseOver" : "columnHeaderMouseLeave",
      column: this.column.getProvidedColumnGroup()
    });
  }
  setupTooltip(e, t) {
    var o;
    this.tooltipFeature = (o = this.beans.tooltipSvc) == null ? void 0 : o.setupHeaderGroupTooltip(
      this.tooltipFeature,
      this,
      e,
      t
    );
  }
  setupExpandable(e) {
    const t = this.column.getProvidedColumnGroup();
    this.refreshExpanded();
    const o = this.refreshExpanded.bind(this);
    e.addManagedListeners(t, {
      expandedChanged: o,
      expandableChanged: o
    });
  }
  refreshExpanded() {
    const { column: e } = this;
    this.expandable = e.isExpandable();
    const t = e.isExpanded();
    this.expandable ? this.comp.setAriaExpanded(t ? "true" : "false") : this.comp.setAriaExpanded(void 0), this.refreshHeaderStyles();
  }
  addClasses() {
    const { column: e } = this, t = e.getColGroupDef(), o = Db(t, this.gos, null, e);
    e.isPadding() ? (o.push("ag-header-group-cell-no-group"), e.getLeafColumns().every((s) => s.isSpanHeaderHeight()) && o.push("ag-header-span-height")) : (o.push("ag-header-group-cell-with-group"), t != null && t.wrapHeaderText && o.push("ag-header-cell-wrap-text")), o.forEach((n) => this.comp.toggleCss(n, !0));
  }
  setupMovingCss(e) {
    const { column: t } = this, n = t.getProvidedColumnGroup().getLeafColumns(), s = () => this.comp.toggleCss("ag-header-cell-moving", t.isMoving());
    n.forEach((i) => {
      e.addManagedListeners(i, { movingChanged: s });
    }), s();
  }
  onFocusIn(e) {
    this.eGui.contains(e.relatedTarget) || this.focusThis();
  }
  handleKeyDown(e) {
    super.handleKeyDown(e);
    const t = this.getWrapperHasFocus();
    if (!(!this.expandable || !t) && e.key === D.ENTER) {
      const o = this.column, n = !o.isExpanded();
      this.beans.colGroupSvc.setColumnGroupOpened(
        o.getProvidedColumnGroup(),
        n,
        "uiColumnExpanded"
      );
    }
  }
  // unlike columns, this will only get called once, as we don't react on props on column groups
  // (we will always destroy and recreate this comp if something changes)
  setDragSource(e) {
    var t;
    !this.isAlive() || this.isSuppressMoving() || (this.removeDragSource(), e && (this.dragSource = ((t = this.beans.colMoves) == null ? void 0 : t.setDragSourceForHeader(e, this.column, this.displayName)) ?? null));
  }
  isSuppressMoving() {
    return this.gos.get("suppressMovableColumns") || this.column.getLeafColumns().some((e) => e.getColDef().suppressMovable || e.getColDef().lockPosition);
  }
  destroy() {
    this.tooltipFeature = this.destroyBean(this.tooltipFeature), super.destroy();
  }
};
function bBe(e, t, o) {
  var n;
  (n = e.colGroupSvc) == null || n.setColumnGroupOpened(t, o, "api");
}
function yBe(e, t, o) {
  var n;
  return ((n = e.colGroupSvc) == null ? void 0 : n.getColumnGroup(t, o)) ?? null;
}
function _Be(e, t) {
  var o;
  return ((o = e.colGroupSvc) == null ? void 0 : o.getProvidedColGroup(t)) ?? null;
}
function SBe(e, t, o) {
  return e.colNames.getDisplayNameForColumnGroup(t, o) || "";
}
function xBe(e) {
  var t;
  return ((t = e.colGroupSvc) == null ? void 0 : t.getColumnGroupState()) ?? [];
}
function MBe(e, t) {
  var o;
  (o = e.colGroupSvc) == null || o.setColumnGroupState(t, "api");
}
function ABe(e) {
  var t;
  (t = e.colGroupSvc) == null || t.resetColumnGroupState("api");
}
function LBe(e) {
  return e.visibleCols.treeLeft;
}
function EBe(e) {
  return e.visibleCols.treeCenter;
}
function PBe(e) {
  return e.visibleCols.treeRight;
}
function RBe(e) {
  return e.visibleCols.getAllTrees();
}
function FBe(e, t) {
  for (let o = 0; o < t.length; o++) {
    const n = e.indexOf(t[o]);
    n >= 0 && (e[n] = e[e.length - 1], e.pop());
  }
}
var TBe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "visibleCols", this.colsAndGroupsMap = {}, this.leftCols = [], this.rightCols = [], this.centerCols = [], this.allCols = [], this.headerGroupRowCount = 0, this.bodyWidth = 0, this.leftWidth = 0, this.rightWidth = 0, this.isBodyWidthDirty = !0;
  }
  refresh(e, t = !1) {
    const { colFlex: o, colModel: n, colGroupSvc: s, colViewport: i, selectionColSvc: r } = this.beans;
    t || this.buildTrees(n, s), s == null || s.updateOpenClosedVisibility(), this.leftCols = f0(this.treeLeft), this.centerCols = f0(this.treeCenter), this.rightCols = f0(this.treeRight), r == null || r.refreshVisibility(this.leftCols, this.centerCols, this.rightCols), this.joinColsAriaOrder(n), this.joinCols(), this.headerGroupRowCount = this.getHeaderRowCount(), this.setLeftValues(e), this.autoHeightCols = this.allCols.filter((l) => l.isAutoHeight()), o == null || o.refreshFlexedColumns(), this.updateBodyWidths(), this.setFirstRightAndLastLeftPinned(n, this.leftCols, this.rightCols, e), i.checkViewportColumns(!1), this.eventSvc.dispatchEvent({
      type: "displayedColumnsChanged",
      source: e
    });
  }
  getHeaderRowCount() {
    if (!this.gos.get("hidePaddedHeaderRows"))
      return this.beans.colModel.cols.treeDepth;
    let e = 0;
    for (const t of this.allCols) {
      let o = t.getParent();
      for (; o; ) {
        if (!o.isPadding()) {
          const n = o.getProvidedColumnGroup().getLevel() + 1;
          n > e && (e = n);
          break;
        }
        o = o.getParent();
      }
    }
    return e;
  }
  // after setColumnWidth or updateGroupsAndPresentedCols
  updateBodyWidths() {
    const e = yn(this.centerCols), t = yn(this.leftCols), o = yn(this.rightCols);
    this.isBodyWidthDirty = this.bodyWidth !== e, (this.bodyWidth !== e || this.leftWidth !== t || this.rightWidth !== o) && (this.bodyWidth = e, this.leftWidth = t, this.rightWidth = o, this.eventSvc.dispatchEvent({
      type: "columnContainerWidthChanged"
    }), this.eventSvc.dispatchEvent({
      type: "displayedColumnsWidthChanged"
    }));
  }
  // sets the left pixel position of each column
  setLeftValues(e) {
    this.setLeftValuesOfCols(e), this.setLeftValuesOfGroups();
  }
  setFirstRightAndLastLeftPinned(e, t, o, n) {
    let s, i;
    this.gos.get("enableRtl") ? (s = t ? t[0] : null, i = o ? Ke(o) : null) : (s = t ? Ke(t) : null, i = o ? o[0] : null), e.getCols().forEach((r) => {
      r.setLastLeftPinned(r === s, n), r.setFirstRightPinned(r === i, n);
    });
  }
  buildTrees(e, t) {
    const o = e.getColsToShow(), n = o.filter((a) => a.getPinned() == "left"), s = o.filter((a) => a.getPinned() == "right"), i = o.filter((a) => a.getPinned() != "left" && a.getPinned() != "right"), r = new Uw(), l = (a) => t ? t.createColumnGroups(a) : a.columns;
    this.treeLeft = l({
      columns: n,
      idCreator: r,
      pinned: "left",
      oldDisplayedGroups: this.treeLeft
    }), this.treeRight = l({
      columns: s,
      idCreator: r,
      pinned: "right",
      oldDisplayedGroups: this.treeRight
    }), this.treeCenter = l({
      columns: i,
      idCreator: r,
      pinned: null,
      oldDisplayedGroups: this.treeCenter
    }), this.updateColsAndGroupsMap();
  }
  clear() {
    this.leftCols = [], this.rightCols = [], this.centerCols = [], this.allCols = [], this.ariaOrderColumns = [];
  }
  joinColsAriaOrder(e) {
    const t = e.getCols(), o = [], n = [], s = [];
    for (const i of t) {
      const r = i.getPinned();
      r ? r === !0 || r === "left" ? o.push(i) : s.push(i) : n.push(i);
    }
    this.ariaOrderColumns = o.concat(n).concat(s);
  }
  getAriaColIndex(e) {
    let t;
    return St(e) ? t = e.getLeafColumns()[0] : t = e, this.ariaOrderColumns.indexOf(t) + 1;
  }
  setLeftValuesOfGroups() {
    [this.treeLeft, this.treeRight, this.treeCenter].forEach((e) => {
      e.forEach((t) => {
        St(t) && t.checkLeft();
      });
    });
  }
  setLeftValuesOfCols(e) {
    const { colModel: t } = this.beans;
    if (!t.getColDefCols())
      return;
    const n = t.getCols().slice(0), s = this.gos.get("enableRtl");
    [this.leftCols, this.rightCols, this.centerCols].forEach((i) => {
      if (s) {
        let r = yn(i);
        i.forEach((l) => {
          r -= l.getActualWidth(), l.setLeft(r, e);
        });
      } else {
        let r = 0;
        i.forEach((l) => {
          l.setLeft(r, e), r += l.getActualWidth();
        });
      }
      FBe(n, i);
    }), n.forEach((i) => {
      i.setLeft(null, e);
    });
  }
  joinCols() {
    this.gos.get("enableRtl") ? this.allCols = this.rightCols.concat(this.centerCols).concat(this.leftCols) : this.allCols = this.leftCols.concat(this.centerCols).concat(this.rightCols);
  }
  getAllTrees() {
    return this.treeLeft && this.treeRight && this.treeCenter ? this.treeLeft.concat(this.treeCenter).concat(this.treeRight) : null;
  }
  // gridPanel -> ensureColumnVisible
  isColDisplayed(e) {
    return this.allCols.indexOf(e) >= 0;
  }
  getLeftColsForRow(e) {
    const {
      leftCols: t,
      beans: { colModel: o }
    } = this;
    return o.colSpanActive ? this.getColsForRow(e, t) : t;
  }
  getRightColsForRow(e) {
    const {
      rightCols: t,
      beans: { colModel: o }
    } = this;
    return o.colSpanActive ? this.getColsForRow(e, t) : t;
  }
  getColsForRow(e, t, o, n) {
    const s = [];
    let i = null;
    for (let r = 0; r < t.length; r++) {
      const l = t[r], a = t.length - r, c = Math.min(l.getColSpan(e), a), d = [l];
      if (c > 1) {
        const h = c - 1;
        for (let p = 1; p <= h; p++)
          d.push(t[r + p]);
        r += h;
      }
      let u;
      o ? (u = !1, d.forEach((h) => {
        o(h) && (u = !0);
      })) : u = !0, u && (s.length === 0 && i && (n && n(l)) && s.push(i), s.push(l)), i = l;
    }
    return s;
  }
  getContainerWidth(e) {
    switch (e) {
      case "left":
        return this.leftWidth;
      case "right":
        return this.rightWidth;
      default:
        return this.bodyWidth;
    }
  }
  getColBefore(e) {
    const t = this.allCols, o = t.indexOf(e);
    return o > 0 ? t[o - 1] : null;
  }
  isPinningLeft() {
    return this.leftCols.length > 0;
  }
  isPinningRight() {
    return this.rightCols.length > 0;
  }
  updateColsAndGroupsMap() {
    this.colsAndGroupsMap = {};
    const e = (t) => {
      this.colsAndGroupsMap[t.getUniqueId()] = t;
    };
    Zs(this.treeCenter, !1, e), Zs(this.treeLeft, !1, e), Zs(this.treeRight, !1, e);
  }
  isVisible(e) {
    return this.colsAndGroupsMap[e.getUniqueId()] === e;
  }
  getFirstColumn() {
    const e = this.gos.get("enableRtl"), t = ["leftCols", "centerCols", "rightCols"];
    e && t.reverse();
    for (let o = 0; o < t.length; o++) {
      const n = this[t[o]];
      if (n.length)
        return e ? Ke(n) : n[0];
    }
    return null;
  }
  // used by:
  // + rowRenderer -> for navigation
  getColAfter(e) {
    const t = this.allCols, o = t.indexOf(e);
    return o < t.length - 1 ? t[o + 1] : null;
  }
  // used by:
  // + angularGrid -> setting pinned body width
  // note: this should be cached
  getColsLeftWidth() {
    return yn(this.leftCols);
  }
  // note: this should be cached
  getDisplayedColumnsRightWidth() {
    return yn(this.rightCols);
  }
  isColAtEdge(e, t) {
    const o = this.allCols;
    if (!o.length)
      return !1;
    const n = t === "first";
    let s;
    if (St(e)) {
      const i = e.getDisplayedLeafColumns();
      if (!i.length)
        return !1;
      s = n ? i[0] : Ke(i);
    } else
      s = e;
    return (n ? o[0] : Ke(o)) === s;
  }
};
function Zs(e, t, o) {
  if (e)
    for (let n = 0; n < e.length; n++) {
      const s = e[n];
      if (St(s)) {
        const i = t ? s.getDisplayedChildren() : s.getChildren();
        Zs(i, t, o);
      }
      o(s);
    }
}
function f0(e) {
  const t = [];
  return Zs(e, !0, (o) => {
    hn(o) && t.push(o);
  }), t;
}
var IBe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "colGroupSvc";
  }
  getColumnGroupState() {
    const e = [], t = this.beans.colModel.getColTree();
    return Rn(null, t, (o) => {
      Lt(o) && e.push({
        groupId: o.getGroupId(),
        open: o.isExpanded()
      });
    }), e;
  }
  resetColumnGroupState(e) {
    const t = this.beans.colModel.getColDefColTree();
    if (!t)
      return;
    const o = [];
    Rn(null, t, (n) => {
      if (Lt(n)) {
        const s = n.getColGroupDef(), i = {
          groupId: n.getGroupId(),
          open: s ? s.openByDefault : void 0
        };
        o.push(i);
      }
    }), this.setColumnGroupState(o, e);
  }
  setColumnGroupState(e, t) {
    const { colModel: o, colAnimation: n, visibleCols: s, eventSvc: i } = this.beans;
    if (!o.getColTree().length)
      return;
    n == null || n.start();
    const l = [];
    e.forEach((a) => {
      const c = a.groupId, d = a.open, u = this.getProvidedColGroup(c);
      u && u.isExpanded() !== d && (u.setExpanded(d), l.push(u));
    }), s.refresh(t, !0), l.length && i.dispatchEvent({
      type: "columnGroupOpened",
      columnGroup: l.length === 1 ? l[0] : void 0,
      columnGroups: l
    }), n == null || n.finish();
  }
  // called by headerRenderer - when a header is opened or closed
  setColumnGroupOpened(e, t, o) {
    let n;
    Lt(e) ? n = e.getId() : n = e || "", this.setColumnGroupState([{ groupId: n, open: t }], o);
  }
  getProvidedColGroup(e) {
    let t = null;
    return Rn(null, this.beans.colModel.getColTree(), (o) => {
      Lt(o) && o.getId() === e && (t = o);
    }), t;
  }
  getGroupAtDirection(e, t) {
    const o = e.getProvidedColumnGroup().getLevel() + e.getPaddingLevel(), n = e.getDisplayedLeafColumns(), s = t === "After" ? Ke(n) : n[0], i = `getCol${t}`;
    for (; ; ) {
      const r = this.beans.visibleCols[i](s);
      if (!r)
        return null;
      const l = this.getColGroupAtLevel(r, o);
      if (l !== e)
        return l;
    }
  }
  getColGroupAtLevel(e, t) {
    let o = e.getParent(), n, s;
    for (; n = o.getProvidedColumnGroup().getLevel(), s = o.getPaddingLevel(), !(n + s <= t); )
      o = o.getParent();
    return o;
  }
  updateOpenClosedVisibility() {
    const e = this.beans.visibleCols.getAllTrees();
    Zs(e, !1, (t) => {
      St(t) && t.calculateDisplayedColumns();
    });
  }
  // returns the group with matching colId and instanceId. If instanceId is missing,
  // matches only on the colId.
  getColumnGroup(e, t) {
    if (!e)
      return null;
    if (St(e))
      return e;
    const o = this.beans.visibleCols.getAllTrees(), n = typeof t == "number";
    let s = null;
    return Zs(o, !1, (i) => {
      if (St(i)) {
        const r = i;
        let l;
        n ? l = e === r.getGroupId() && t === r.getPartId() : l = e === r.getGroupId(), l && (s = r);
      }
    }), s;
  }
  createColumnGroups(e) {
    const { columns: t, idCreator: o, pinned: n, oldDisplayedGroups: s, isStandaloneStructure: i } = e, r = this.mapOldGroupsById(s), l = [];
    let a = t;
    for (; a.length; ) {
      const c = a;
      a = [];
      let d = 0;
      const u = (h) => {
        const p = d;
        d = h;
        const C = c[p], w = (St(C) ? C.getProvidedColumnGroup() : C).getOriginalParent();
        if (w == null) {
          for (let b = p; b < h; b++)
            l.push(c[b]);
          return;
        }
        const y = this.createColumnGroup(
          w,
          o,
          r,
          n,
          i
        );
        for (let b = p; b < h; b++)
          y.addChild(c[b]);
        a.push(y);
      };
      for (let h = 1; h < c.length; h++) {
        const p = c[h], m = (St(p) ? p.getProvidedColumnGroup() : p).getOriginalParent(), w = c[d], b = (St(w) ? w.getProvidedColumnGroup() : w).getOriginalParent();
        m !== b && u(h);
      }
      d < c.length && u(c.length);
    }
    return i || this.setupParentsIntoCols(l, null), l;
  }
  createProvidedColumnGroup(e, t, o, n, s, i, r) {
    const l = s.getUniqueKey(t.groupId || null, null), a = Ld(this.beans, t, l), c = new Lr(a, l, !1, o);
    this.createBean(c);
    const d = this.findExistingGroup(t, i);
    d && i.splice(d.idx, 1);
    const u = d == null ? void 0 : d.group;
    u && c.setExpanded(u.isExpanded());
    const h = Vw(
      this.beans,
      a.children,
      o + 1,
      e,
      n,
      s,
      i,
      r
    );
    return c.setChildren(h), c;
  }
  balanceColumnTree(e, t, o, n) {
    const s = [];
    for (let i = 0; i < e.length; i++) {
      const r = e[i];
      if (Lt(r)) {
        const l = r, a = this.balanceColumnTree(
          l.getChildren(),
          t + 1,
          o,
          n
        );
        l.setChildren(a), s.push(l);
      } else {
        let l, a;
        for (let c = t; c < o; c++) {
          const d = n.getUniqueKey(null, null), u = Ld(this.beans, null, d), h = new Lr(u, d, !0, c);
          this.createBean(h), a && a.setChildren([h]), a = h, l || (l = a);
        }
        if (l && a)
          if (s.push(l), e.some((d) => Lt(d))) {
            a.setChildren([r]);
            continue;
          } else {
            a.setChildren(e);
            break;
          }
        s.push(r);
      }
    }
    return s;
  }
  findDepth(e) {
    let t = 0, o = e;
    for (; o && o[0] && Lt(o[0]); )
      t++, o = o[0].getChildren();
    return t;
  }
  findMaxDepth(e, t) {
    let o = t;
    for (let n = 0; n < e.length; n++) {
      const s = e[n];
      if (Lt(s)) {
        const i = s, r = this.findMaxDepth(i.getChildren(), t + 1);
        o < r && (o = r);
      }
    }
    return o;
  }
  /**
   * Inserts dummy group columns in the hierarchy above auto-generated columns
   * in order to ensure auto-generated columns are leaf nodes (and therefore are
   * displayed correctly)
   */
  balanceTreeForAutoCols(e, t) {
    const o = [];
    return e.forEach((n) => {
      let s = n;
      for (let i = t - 1; i >= 0; i--) {
        const r = new Lr(null, `FAKE_PATH_${n.getId()}}_${i}`, !0, i);
        this.createBean(r), r.setChildren([s]), s.originalParent = r, s = r;
      }
      t === 0 && (n.originalParent = null), o.push(s);
    }), o;
  }
  findExistingGroup(e, t) {
    if (e.groupId != null)
      for (let n = 0; n < t.length; n++) {
        const s = t[n];
        if (s.getColGroupDef() && s.getId() === e.groupId)
          return { idx: n, group: s };
      }
  }
  createColumnGroup(e, t, o, n, s) {
    const i = e.getGroupId(), r = t.getInstanceIdForKey(i), l = pb(i, r);
    let a = o[l];
    return a && a.getProvidedColumnGroup() !== e && (a = null), ue(a) ? a.reset() : (a = new Qr(e, i, r, n), s || this.createBean(a)), a;
  }
  // returns back a 2d map of ColumnGroup as follows: groupId -> instanceId -> ColumnGroup
  mapOldGroupsById(e) {
    const t = {}, o = (n) => {
      n.forEach((s) => {
        if (St(s)) {
          const i = s;
          t[s.getUniqueId()] = i, o(i.getChildren());
        }
      });
    };
    return e && o(e), t;
  }
  setupParentsIntoCols(e, t) {
    e.forEach((o) => {
      if (o.parent !== t && (this.beans.colViewport.colsWithinViewportHash = ""), o.parent = t, St(o)) {
        const n = o;
        this.setupParentsIntoCols(n.getChildren(), n);
      }
    });
  }
}, DBe = {
  moduleName: "ColumnGroup",
  version: be,
  dynamicBeans: { headerGroupCellCtrl: wBe },
  beans: [IBe],
  apiFunctions: {
    getAllDisplayedColumnGroups: RBe,
    getCenterDisplayedColumnGroups: EBe,
    getColumnGroup: yBe,
    getColumnGroupState: xBe,
    getDisplayNameForColumnGroup: SBe,
    getLeftDisplayedColumnGroups: LBe,
    getProvidedColumnGroup: _Be,
    getRightDisplayedColumnGroups: PBe,
    resetColumnGroupState: ABe,
    setColumnGroupOpened: bBe,
    setColumnGroupState: MBe
  }
}, kBe = { tag: "div", cls: "ag-skeleton-container" }, HBe = class extends Re {
  constructor() {
    super(kBe);
  }
  init(e) {
    const t = `ag-cell-skeleton-renderer-${this.getCompId()}`;
    this.getGui().setAttribute("id", t), this.addDestroyFunc(() => as(e.eParentOfValue)), as(e.eParentOfValue, t), e.deferRender ? this.setupLoading(e) : e.node.failedLoad ? this.setupFailed() : this.setupLoading(e);
  }
  setupFailed() {
    const e = this.getLocaleTextFunc();
    this.getGui().textContent = e("loadingError", "ERR");
    const t = e("ariaSkeletonCellLoadingFailed", "Row failed to load");
    ft(this.getGui(), t);
  }
  setupLoading(e) {
    const t = ze({
      tag: "div",
      cls: "ag-skeleton-effect"
    }), o = e.node.rowIndex;
    if (o != null) {
      const i = 75 + 25 * (o % 2 === 0 ? Math.sin(o) : Math.cos(o));
      t.style.width = `${i}%`;
    }
    this.getGui().appendChild(t);
    const n = this.getLocaleTextFunc(), s = e.deferRender ? n("ariaDeferSkeletonCellLoading", "Cell is loading") : n("ariaSkeletonCellLoading", "Row data is loading");
    ft(this.getGui(), s);
  }
  refresh(e) {
    return !1;
  }
}, VBe = {
  moduleName: "CheckboxCellRenderer",
  version: be,
  userComponents: {
    agCheckboxCellRenderer: AVe
  }
}, OBe = {
  moduleName: "SkeletonCellRenderer",
  version: be,
  userComponents: {
    agSkeletonCellRenderer: HBe
  }
};
function BBe(e, t) {
  const o = e.colModel.getColDefCol(t);
  return o ? o.getColDef() : null;
}
function $Be(e) {
  return e.colModel.getColumnDefs();
}
function ZBe(e, t, o) {
  return e.colNames.getDisplayNameForColumn(t, o) || "";
}
function GBe(e, t) {
  return e.colModel.getColDefCol(t);
}
function NBe(e) {
  return e.colModel.getColDefCols();
}
function zBe(e, t) {
  return eo(e, t, "api");
}
function jBe(e) {
  return Ml(e);
}
function WBe(e) {
  zw(e, "api");
}
function UBe(e) {
  return e.visibleCols.isPinningLeft() || e.visibleCols.isPinningRight();
}
function KBe(e) {
  return e.visibleCols.isPinningLeft();
}
function qBe(e) {
  return e.visibleCols.isPinningRight();
}
function YBe(e, t) {
  return e.visibleCols.getColAfter(t);
}
function QBe(e, t) {
  return e.visibleCols.getColBefore(t);
}
function JBe(e, t, o) {
  e.colModel.setColsVisible(t, o, "api");
}
function XBe(e, t, o) {
  var n;
  (n = e.pinnedCols) == null || n.setColsPinned(t, o, "api");
}
function e$e(e) {
  return e.colModel.getCols();
}
function t$e(e) {
  return e.visibleCols.leftCols;
}
function o$e(e) {
  return e.visibleCols.centerCols;
}
function n$e(e) {
  return e.visibleCols.rightCols;
}
function s$e(e) {
  return e.visibleCols.allCols;
}
function i$e(e) {
  return e.colViewport.getViewportColumns();
}
function f5(e, t) {
  if (!e)
    return;
  const o = e, n = {};
  return Object.keys(o).forEach((s) => {
    if (t && t.indexOf(s) >= 0 || Cw.has(s))
      return;
    const i = o[s];
    typeof i == "object" && i !== null && i.constructor === Object ? n[s] = f5(i) : n[s] = i;
  }), n;
}
var r$e = class extends K {
  constructor() {
    super(...arguments), this.beanName = "colDefFactory";
  }
  wireBeans(e) {
    this.rowGroupColsSvc = e.rowGroupColsSvc, this.pivotColsSvc = e.pivotColsSvc;
  }
  getColumnDefs(e, t, o, n) {
    var l, a;
    const s = e.slice();
    t ? s.sort((c, d) => o.indexOf(c) - o.indexOf(d)) : o && s.sort((c, d) => n.indexOf(c) - n.indexOf(d));
    const i = (l = this.rowGroupColsSvc) == null ? void 0 : l.columns, r = (a = this.pivotColsSvc) == null ? void 0 : a.columns;
    return this.buildColumnDefs(s, i, r);
  }
  buildColumnDefs(e, t = [], o = []) {
    const n = [], s = {};
    return e.forEach((i) => {
      const r = this.createDefFromColumn(i, t, o);
      let l = !0, a = r, c = i.getOriginalParent(), d = null;
      for (; c; ) {
        let u = null;
        if (c.isPadding()) {
          c = c.getOriginalParent();
          continue;
        }
        const h = s[c.getGroupId()];
        if (h) {
          h.children.push(a), l = !1;
          break;
        }
        if (u = this.createDefFromGroup(c), u && (u.children = [a], s[u.groupId] = u, a = u, c = c.getOriginalParent()), c != null && d === c) {
          l = !1;
          break;
        }
        d = c;
      }
      l && n.push(a);
    }), n;
  }
  createDefFromGroup(e) {
    const t = f5(e.getColGroupDef(), ["children"]);
    return t && (t.groupId = e.getGroupId()), t;
  }
  createDefFromColumn(e, t, o) {
    const n = f5(e.getColDef());
    return n.colId = e.getColId(), n.width = e.getActualWidth(), n.rowGroup = e.isRowGroupActive(), n.rowGroupIndex = e.isRowGroupActive() ? t.indexOf(e) : null, n.pivot = e.isPivotActive(), n.pivotIndex = e.isPivotActive() ? o.indexOf(e) : null, n.aggFunc = e.isValueActive() ? e.getAggFunc() : null, n.hide = e.isVisible() ? void 0 : !0, n.pinned = e.isPinned() ? e.getPinned() : null, n.sort = e.getSort() ? e.getSort() : null, n.sortIndex = e.getSortIndex() != null ? e.getSortIndex() : null, n;
  }
}, l$e = class extends K {
  constructor() {
    super(...arguments), this.beanName = "colFlex";
  }
  refreshFlexedColumns(e = {}) {
    const t = e.source ?? "flex";
    e.viewportWidth != null && (this.flexViewportWidth = e.viewportWidth);
    const o = this.flexViewportWidth, { visibleCols: n, colDelayRenderSvc: s } = this.beans, i = n.centerCols;
    let r = -1;
    if (e.resizingCols) {
      const m = new Set(e.resizingCols);
      for (let w = i.length - 1; w >= 0; w--)
        if (m.has(i[w])) {
          r = w;
          break;
        }
    }
    let l = !1;
    const a = i.map((m, w) => {
      const y = m.getFlex(), b = y != null && y > 0 && w > r;
      return l || (l = b), {
        col: m,
        isFlex: b,
        flex: Math.max(0, y ?? 0),
        initialSize: m.getActualWidth(),
        min: m.getMinWidth(),
        max: m.getMaxWidth(),
        targetSize: 0
      };
    });
    if (l && (s == null || s.hideColumns("colFlex")), !o || !l)
      return [];
    let c = a.length, d = a.reduce((m, w) => m + w.flex, 0), u = o;
    const h = (m, w) => {
      m.frozenSize = w, m.col.setActualWidth(w, t), u -= w, d -= m.flex, c -= 1;
    }, p = (m) => m.frozenSize != null;
    for (const m of a)
      m.isFlex || h(m, m.initialSize);
    for (; c > 0; ) {
      const m = Math.round(d < 1 ? u * d : u);
      let w, y = 0, b = 0;
      for (const x of a) {
        if (p(x))
          continue;
        w = x, b += m * (x.flex / d);
        const L = b - y, A = Math.round(L);
        x.targetSize = A, y += A;
      }
      w && (w.targetSize += m - y);
      let _ = 0;
      for (const x of a) {
        if (p(x))
          continue;
        const L = x.targetSize, A = Math.min(Math.max(L, x.min), x.max);
        _ += A - L, x.violationType = A === L ? void 0 : A < L ? "max" : "min", x.targetSize = A;
      }
      const M = _ === 0 ? "all" : _ > 0 ? "min" : "max";
      for (const x of a)
        p(x) || (M === "all" || x.violationType === M) && h(x, x.targetSize);
    }
    e.skipSetLeft || n.setLeftValues(t), e.updateBodyWidths && n.updateBodyWidths();
    const C = a.filter((m) => m.isFlex && !m.violationType).map((m) => m.col);
    if (e.fireResizedEvent) {
      const m = a.filter((y) => y.initialSize !== y.frozenSize).map((y) => y.col), w = a.filter((y) => y.flex).map((y) => y.col);
      Gi(this.eventSvc, m, !0, t, w);
    }
    return s == null || s.revealColumns("colFlex"), C;
  }
  initCol(e) {
    const { flex: t, initialFlex: o } = e.colDef;
    t !== void 0 ? e.flex = t : o !== void 0 && (e.flex = o);
  }
  // this method should only be used by the colModel to
  // change flex when required by the applyColumnState method.
  setColFlex(e, t) {
    e.flex = t ?? null, e.dispatchStateUpdatedEvent("flex");
  }
};
function Pr(e, t, o) {
  if (!t || !e)
    return;
  if (!o)
    return e[t];
  const n = t.split(".");
  let s = e;
  for (let i = 0; i < n.length; i++) {
    if (s == null)
      return;
    s = s[n[i]];
  }
  return s;
}
var a$e = [
  "dateTimeString",
  "dateString",
  "text",
  "number",
  "boolean",
  "date"
], c$e = class extends K {
  constructor() {
    super(...arguments), this.beanName = "dataTypeSvc", this.dataTypeDefinitions = {}, this.isPendingInference = !1, this.isColumnTypeOverrideInDataTypeDefinitions = !1, this.columnStateUpdatesPendingInference = {}, this.columnStateUpdateListenerDestroyFuncs = [], this.columnDefinitionPropsPerDataType = {
      number() {
        return { cellEditor: "agNumberCellEditor" };
      },
      boolean() {
        return {
          cellEditor: "agCheckboxCellEditor",
          cellRenderer: "agCheckboxCellRenderer",
          getFindText: () => null,
          suppressKeyboardEvent: (e) => !!e.colDef.editable && e.event.key === D.SPACE
        };
      },
      date({ formatValue: e }) {
        return { cellEditor: "agDateCellEditor", keyCreator: e };
      },
      dateString({ formatValue: e }) {
        return { cellEditor: "agDateStringCellEditor", keyCreator: e };
      },
      dateTime(e) {
        return this.date(e);
      },
      dateTimeString(e) {
        return this.dateString(e);
      },
      object({ formatValue: e, colModel: t, colId: o }) {
        return {
          cellEditorParams: {
            useFormatter: !0
          },
          comparator: (n, s) => {
            const i = t.getColDefCol(o), r = i == null ? void 0 : i.getColDef();
            if (!i || !r)
              return 0;
            const l = n == null ? "" : e({ column: i, node: null, value: n }), a = s == null ? "" : e({ column: i, node: null, value: s });
            return l === a ? 0 : l > a ? 1 : -1;
          },
          keyCreator: e
        };
      },
      text() {
        return {};
      }
    };
  }
  wireBeans(e) {
    this.colModel = e.colModel;
  }
  postConstruct() {
    this.processDataTypeDefinitions(), this.addManagedPropertyListener("dataTypeDefinitions", (e) => {
      this.processDataTypeDefinitions(), this.colModel.recreateColumnDefs(e);
    });
  }
  processDataTypeDefinitions() {
    const e = this.getDefaultDataTypes(), t = {}, o = {}, n = (d) => (u) => {
      const { column: h, node: p, value: C } = u;
      let m = h.getColDef().valueFormatter;
      return m === d.groupSafeValueFormatter && (m = d.valueFormatter), this.beans.valueSvc.formatValue(h, p, C, m);
    };
    for (const d of Object.keys(e)) {
      const u = e[d], h = {
        ...u,
        groupSafeValueFormatter: cu(u, this.gos)
      };
      t[d] = h, o[d] = n(h);
    }
    const s = this.gos.get("dataTypeDefinitions") ?? {}, i = {};
    for (const d of Object.keys(s)) {
      const u = s[d], h = this.processDataTypeDefinition(
        u,
        s,
        [d],
        e
      );
      h && (t[d] = h, u.dataTypeMatcher && (i[d] = u.dataTypeMatcher), o[d] = n(h));
    }
    const { valueParser: r, valueFormatter: l } = e.object, { valueParser: a, valueFormatter: c } = t.object;
    this.hasObjectValueParser = a !== r, this.hasObjectValueFormatter = c !== l, this.formatValueFuncs = o, this.dataTypeDefinitions = t, this.dataTypeMatchers = this.sortKeysInMatchers(i, e);
  }
  /**
   * Sorts the keys in the matchers object.
   * Does not mutate the original object, creates a copy of it with sorted keys instead.
   */
  sortKeysInMatchers(e, t) {
    const o = { ...e };
    for (const n of a$e)
      delete o[n], o[n] = e[n] ?? t[n].dataTypeMatcher;
    return o;
  }
  processDataTypeDefinition(e, t, o, n) {
    let s;
    const i = e.extendsDataType;
    if (e.columnTypes && (this.isColumnTypeOverrideInDataTypeDefinitions = !0), e.extendsDataType === e.baseDataType) {
      let r = n[i];
      const l = t[i];
      if (r && l && (r = l), !au(e, r, i))
        return;
      s = lu(r, e);
    } else {
      if (o.includes(i)) {
        X(44);
        return;
      }
      const r = t[i];
      if (!au(e, r, i))
        return;
      const l = this.processDataTypeDefinition(
        r,
        t,
        [...o, i],
        n
      );
      if (!l)
        return;
      s = lu(l, e);
    }
    return {
      ...s,
      groupSafeValueFormatter: cu(s, this.gos)
    };
  }
  updateColDefAndGetColumnType(e, t, o) {
    let { cellDataType: n } = t;
    const { field: s } = t;
    if (n === void 0 && (n = e.cellDataType), (n == null || n === !0) && (n = this.canInferCellDataType(e, t) ? this.inferCellDataType(s, o) : !1), !n) {
      e.cellDataType = !1;
      return;
    }
    const i = this.dataTypeDefinitions[n];
    if (!i) {
      X(47, { cellDataType: n });
      return;
    }
    return e.cellDataType = n, i.groupSafeValueFormatter && (e.valueFormatter = i.groupSafeValueFormatter), i.valueParser && (e.valueParser = i.valueParser), i.suppressDefaultProperties || this.setColDefPropertiesForBaseDataType(e, n, i, o), i.columnTypes;
  }
  addColumnListeners(e) {
    if (!this.isPendingInference)
      return;
    const t = this.columnStateUpdatesPendingInference[e.getColId()];
    if (!t)
      return;
    const o = (n) => {
      t.add(n.key);
    };
    e.__addEventListener("columnStateUpdated", o), this.columnStateUpdateListenerDestroyFuncs.push(
      () => e.__removeEventListener("columnStateUpdated", o)
    );
  }
  canInferCellDataType(e, t) {
    const { gos: o } = this;
    if (!dt(o))
      return !1;
    const n = { cellRenderer: !0, valueGetter: !0, valueParser: !0, refData: !0 };
    if (v0(t, n))
      return !1;
    const s = t.type === null ? e.type : t.type;
    if (s) {
      const i = o.get("columnTypes") ?? {};
      if (xl(s).some((l) => {
        const a = i[l.trim()];
        return a && v0(a, n);
      }))
        return !1;
    }
    return !v0(e, n);
  }
  inferCellDataType(e, t) {
    if (!e)
      return;
    let o;
    const n = this.getInitialData();
    if (n) {
      const i = e.indexOf(".") >= 0 && !this.gos.get("suppressFieldDotNotation");
      o = Pr(n, e, i);
    } else
      this.initWaitForRowData(t);
    return o == null ? void 0 : Object.keys(this.dataTypeMatchers).find(
      (i) => this.dataTypeMatchers[i](o)
    ) ?? "object";
  }
  getInitialData() {
    var t;
    const e = this.gos.get("rowData");
    if (e != null && e.length)
      return e[0];
    if (this.initialData)
      return this.initialData;
    {
      const o = (t = this.beans.rowModel.rootNode) == null ? void 0 : t.allLeafChildren;
      if (o != null && o.length)
        return o[0].data;
    }
    return null;
  }
  initWaitForRowData(e) {
    if (this.columnStateUpdatesPendingInference[e] = /* @__PURE__ */ new Set(), this.isPendingInference)
      return;
    this.isPendingInference = !0;
    const t = this.isColumnTypeOverrideInDataTypeDefinitions, { colAutosize: o, eventSvc: n } = this.beans;
    t && o && (o.shouldQueueResizeOperations = !0);
    const [s] = this.addManagedEventListeners({
      rowDataUpdateStarted: (i) => {
        const { firstRowData: r } = i;
        r && (s == null || s(), this.isPendingInference = !1, this.processColumnsPendingInference(r, t), this.columnStateUpdatesPendingInference = {}, t && (o == null || o.processResizeOperations()), n.dispatchEvent({
          type: "dataTypesInferred"
        }));
      }
    });
  }
  processColumnsPendingInference(e, t) {
    this.initialData = e;
    const o = [];
    this.destroyColumnStateUpdateListeners();
    const n = {}, s = {};
    for (const i of Object.keys(this.columnStateUpdatesPendingInference)) {
      const r = this.columnStateUpdatesPendingInference[i], l = this.colModel.getCol(i);
      if (!l)
        return;
      const a = l.getColDef();
      if (!this.resetColDefIntoCol(l, "cellDataTypeInferred"))
        return;
      const c = l.getColDef();
      if (t && c.type && c.type !== a.type) {
        const d = u$e(l, r);
        d.rowGroup && d.rowGroupIndex == null && (n[i] = d), d.pivot && d.pivotIndex == null && (s[i] = d), o.push(d);
      }
    }
    t && o.push(
      ...this.generateColumnStateForRowGroupAndPivotIndexes(
        n,
        s
      )
    ), o.length && eo(this.beans, { state: o }, "cellDataTypeInferred"), this.initialData = null;
  }
  generateColumnStateForRowGroupAndPivotIndexes(e, t) {
    const o = {}, { rowGroupColsSvc: n, pivotColsSvc: s } = this.beans;
    return n == null || n.restoreColumnOrder(o, e), s == null || s.restoreColumnOrder(o, t), Object.values(o);
  }
  resetColDefIntoCol(e, t) {
    const o = e.getUserProvidedColDef();
    if (!o)
      return !1;
    const n = Zi(this.beans, o, e.getColId());
    return e.setColDef(n, o, t), !0;
  }
  getDateStringTypeDefinition(e) {
    const { dateString: t } = this.dataTypeDefinitions;
    return e ? this.getDataTypeDefinition(e) ?? t : t;
  }
  getDateParserFunction(e) {
    return this.getDateStringTypeDefinition(e).dateParser;
  }
  getDateFormatterFunction(e) {
    return this.getDateStringTypeDefinition(e).dateFormatter;
  }
  getDateIncludesTimeFlag(e) {
    return e === "dateTime" || e === "dateTimeString";
  }
  getDataTypeDefinition(e) {
    const t = e.getColDef();
    if (t.cellDataType)
      return this.dataTypeDefinitions[t.cellDataType];
  }
  getBaseDataType(e) {
    var t;
    return (t = this.getDataTypeDefinition(e)) == null ? void 0 : t.baseDataType;
  }
  checkType(e, t) {
    var n;
    if (t == null)
      return !0;
    const o = (n = this.getDataTypeDefinition(e)) == null ? void 0 : n.dataTypeMatcher;
    return o ? o(t) : !0;
  }
  validateColDef(e) {
    const t = (o) => X(48, { property: o });
    if (e.cellDataType === "object") {
      const { object: o } = this.dataTypeDefinitions;
      e.valueFormatter === o.groupSafeValueFormatter && !this.hasObjectValueFormatter && t("Formatter"), e.editable && e.valueParser === o.valueParser && !this.hasObjectValueParser && t("Parser");
    }
  }
  postProcess(e) {
    var r;
    const t = e.cellDataType;
    if (!t || typeof t != "string")
      return;
    const { dataTypeDefinitions: o, beans: n, formatValueFuncs: s } = this, i = o[t];
    i && ((r = n.colFilter) == null || r.setColDefPropsForDataType(e, i, s[t]));
  }
  // noinspection JSUnusedGlobalSymbols
  getFormatValue(e) {
    return this.formatValueFuncs[e];
  }
  isColPendingInference(e) {
    return this.isPendingInference && !!this.columnStateUpdatesPendingInference[e];
  }
  setColDefPropertiesForBaseDataType(e, t, o, n) {
    const s = this.formatValueFuncs[t], i = this.columnDefinitionPropsPerDataType[o.baseDataType]({
      colDef: e,
      cellDataType: t,
      colModel: this.colModel,
      dataTypeDefinition: o,
      colId: n,
      formatValue: s
    });
    Object.assign(e, i);
  }
  getDateObjectTypeDef(e) {
    const t = this.getLocaleTextFunc(), o = this.getDateIncludesTimeFlag(e);
    return {
      baseDataType: e,
      valueParser: (n) => Wt(n.newValue && String(n.newValue)),
      valueFormatter: (n) => n.value == null ? "" : !(n.value instanceof Date) || isNaN(n.value.getTime()) ? t("invalidDate", "Invalid Date") : to(n.value, o) ?? "",
      dataTypeMatcher: (n) => n instanceof Date
    };
  }
  getDateStringTypeDef(e) {
    const t = this.getDateIncludesTimeFlag(e);
    return {
      baseDataType: e,
      dateParser: (o) => Wt(o) ?? void 0,
      dateFormatter: (o) => to(o ?? null, t) ?? void 0,
      valueParser: (o) => U1(String(o.newValue)) ? o.newValue : null,
      valueFormatter: (o) => U1(String(o.value)) ? String(o.value) : "",
      dataTypeMatcher: (o) => typeof o == "string" && U1(o)
    };
  }
  getDefaultDataTypes() {
    const e = this.getLocaleTextFunc();
    return {
      number: {
        baseDataType: "number",
        // can be empty space with legacy copy
        valueParser: (t) => {
          var o, n;
          return ((n = (o = t.newValue) == null ? void 0 : o.trim) == null ? void 0 : n.call(o)) === "" ? null : Number(t.newValue);
        },
        valueFormatter: (t) => t.value == null ? "" : typeof t.value != "number" || isNaN(t.value) ? e("invalidNumber", "Invalid Number") : String(t.value),
        dataTypeMatcher: (t) => typeof t == "number"
      },
      text: {
        baseDataType: "text",
        valueParser: (t) => t.newValue === "" ? null : Co(t.newValue),
        dataTypeMatcher: (t) => typeof t == "string"
      },
      boolean: {
        baseDataType: "boolean",
        valueParser: (t) => {
          var o, n;
          return t.newValue == null ? t.newValue : ((n = (o = t.newValue) == null ? void 0 : o.trim) == null ? void 0 : n.call(o)) === "" ? null : String(t.newValue).toLowerCase() === "true";
        },
        valueFormatter: (t) => t.value == null ? "" : String(t.value),
        dataTypeMatcher: (t) => typeof t == "boolean"
      },
      date: this.getDateObjectTypeDef("date"),
      dateString: this.getDateStringTypeDef("dateString"),
      dateTime: this.getDateObjectTypeDef("dateTime"),
      dateTimeString: {
        ...this.getDateStringTypeDef("dateTimeString"),
        dataTypeMatcher: (t) => typeof t == "string" && zDe(t)
      },
      object: {
        baseDataType: "object",
        valueParser: () => null,
        valueFormatter: (t) => Co(t.value) ?? ""
      }
    };
  }
  destroyColumnStateUpdateListeners() {
    this.columnStateUpdateListenerDestroyFuncs.forEach((e) => e()), this.columnStateUpdateListenerDestroyFuncs = [];
  }
  destroy() {
    this.dataTypeDefinitions = {}, this.dataTypeMatchers = {}, this.formatValueFuncs = {}, this.columnStateUpdatesPendingInference = {}, this.destroyColumnStateUpdateListeners(), super.destroy();
  }
};
function lu(e, t) {
  const o = {
    ...e,
    ...t
  };
  return e.columnTypes && t.columnTypes && t.appendColumnTypes && (o.columnTypes = [
    ...xl(e.columnTypes),
    ...xl(t.columnTypes)
  ]), o;
}
function au(e, t, o) {
  return t ? t.baseDataType !== e.baseDataType ? (X(46), !1) : !0 : (X(45, { parentCellDataType: o }), !1);
}
function cu(e, t) {
  if (e.valueFormatter)
    return (o) => {
      var n, s;
      if ((n = o.node) != null && n.group) {
        const i = (o.colDef.pivotValueColumn ?? o.column).getAggFunc();
        if (i) {
          if (i === "first" || i === "last")
            return e.valueFormatter(o);
          if (e.baseDataType === "number" && i !== "count") {
            if (typeof o.value == "number")
              return e.valueFormatter(o);
            if (typeof o.value == "object") {
              if (!o.value)
                return;
              if ("toNumber" in o.value)
                return e.valueFormatter({
                  ...o,
                  value: o.value.toNumber()
                });
              if ("value" in o.value)
                return e.valueFormatter({
                  ...o,
                  value: o.value.value
                });
            }
          }
          return;
        }
      } else if (t.get("groupHideOpenParents") && o.column.isRowGroupActive() && typeof o.value == "string" && !((s = e.dataTypeMatcher) != null && s.call(e, o.value)))
        return;
      return e.valueFormatter(o);
    };
}
function d$e(e, t, o, n) {
  if (!t[o])
    return !1;
  const s = e[o];
  return s === null ? (t[o] = !1, !1) : n === void 0 ? !!s : s === n;
}
function v0(e, t) {
  return [
    ["cellRenderer", "agSparklineCellRenderer"],
    ["valueGetter", void 0],
    ["valueParser", void 0],
    ["refData", void 0]
  ].some(
    ([o, n]) => d$e(e, t, o, n)
  );
}
function u$e(e, t) {
  const o = Ww(e);
  return t.forEach((n) => {
    delete o[n], n === "rowGroup" ? delete o.rowGroupIndex : n === "pivot" && delete o.pivotIndex;
  }), o;
}
var h$e = {
  moduleName: "DataType",
  version: be,
  beans: [c$e],
  dependsOn: [VBe]
}, g$e = {
  moduleName: "ColumnFlex",
  version: be,
  beans: [l$e]
}, ny = {
  moduleName: "ColumnApi",
  version: be,
  beans: [r$e],
  apiFunctions: {
    getColumnDef: BBe,
    getDisplayNameForColumn: ZBe,
    getColumn: GBe,
    getColumns: NBe,
    applyColumnState: zBe,
    getColumnState: jBe,
    resetColumnState: WBe,
    isPinning: UBe,
    isPinningLeft: KBe,
    isPinningRight: qBe,
    getDisplayedColAfter: YBe,
    getDisplayedColBefore: QBe,
    setColumnsVisible: JBe,
    setColumnsPinned: XBe,
    getAllGridColumns: e$e,
    getDisplayedLeftColumns: t$e,
    getDisplayedCenterColumns: o$e,
    getDisplayedRightColumns: n$e,
    getAllDisplayedColumns: s$e,
    getAllDisplayedVirtualColumns: i$e,
    getColumnDefs: $Be
  }
};
function p$e(e) {
  if (!e || e == null)
    return null;
  const t = /([a-z])([A-Z])/g, o = /([A-Z]+)([A-Z])([a-z])/g;
  return e.replace(t, "$1 $2").replace(o, "$1 $2$3").replace(/\./g, " ").split(" ").map((s) => s.substring(0, 1).toUpperCase() + (s.length > 1 ? s.substring(1, s.length) : "")).join(" ");
}
var f$e = class extends K {
  constructor() {
    super(...arguments), this.beanName = "colNames";
  }
  getDisplayNameForColumn(e, t, o = !1) {
    if (!e)
      return null;
    const n = this.getHeaderName(e.getColDef(), e, null, null, t), { aggColNameSvc: s } = this.beans;
    return o && s ? s.getHeaderName(e, n) : n;
  }
  getDisplayNameForProvidedColumnGroup(e, t, o) {
    const n = t == null ? void 0 : t.getColGroupDef();
    return n ? this.getHeaderName(n, null, e, t, o) : null;
  }
  getDisplayNameForColumnGroup(e, t) {
    return this.getDisplayNameForProvidedColumnGroup(e, e.getProvidedColumnGroup(), t);
  }
  // location is where the column is going to appear, ie who is calling us
  getHeaderName(e, t, o, n, s) {
    var r;
    const i = e.headerValueGetter;
    if (i) {
      const l = Pe(this.gos, {
        colDef: e,
        column: t,
        columnGroup: o,
        providedColumnGroup: n,
        location: s
      });
      return typeof i == "function" ? i(l) : typeof i == "string" ? ((r = this.beans.expressionSvc) == null ? void 0 : r.evaluate(i, l)) ?? null : "";
    } else {
      if (e.headerName != null)
        return e.headerName;
      if (e.field)
        return p$e(e.field);
    }
    return "";
  }
}, v$e = class extends K {
  constructor() {
    super(...arguments), this.beanName = "colViewport", this.colsWithinViewport = [], this.headerColsWithinViewport = [], this.colsWithinViewportHash = "", this.rowsOfHeadersToRenderLeft = {}, this.rowsOfHeadersToRenderRight = {}, this.rowsOfHeadersToRenderCenter = {}, this.columnsToRenderLeft = [], this.columnsToRenderRight = [], this.columnsToRenderCenter = [];
  }
  wireBeans(e) {
    this.visibleCols = e.visibleCols, this.colModel = e.colModel;
  }
  postConstruct() {
    this.suppressColumnVirtualisation = this.gos.get("suppressColumnVirtualisation");
  }
  setScrollPosition(e, t, o = !1) {
    const { visibleCols: n } = this, s = n.isBodyWidthDirty;
    if (!(e === this.scrollWidth && t === this.scrollPosition && !s)) {
      if (this.scrollWidth = e, this.scrollPosition = t, n.isBodyWidthDirty = !0, this.gos.get("enableRtl")) {
        const r = n.bodyWidth;
        this.viewportLeft = r - t - e, this.viewportRight = r - t;
      } else
        this.viewportLeft = t, this.viewportRight = e + t;
      this.colModel.ready && this.checkViewportColumns(o);
    }
  }
  /**
   * Returns the columns that are currently rendered in the viewport.
   */
  getColumnHeadersToRender(e) {
    switch (e) {
      case "left":
        return this.columnsToRenderLeft;
      case "right":
        return this.columnsToRenderRight;
      default:
        return this.columnsToRenderCenter;
    }
  }
  /**
   * Returns the column groups that are currently rendered in the viewport at a specific header row index.
   */
  getHeadersToRender(e, t) {
    let o;
    switch (e) {
      case "left":
        o = this.rowsOfHeadersToRenderLeft[t];
        break;
      case "right":
        o = this.rowsOfHeadersToRenderRight[t];
        break;
      default:
        o = this.rowsOfHeadersToRenderCenter[t];
        break;
    }
    return o ?? [];
  }
  extractViewportColumns() {
    const e = this.visibleCols.centerCols;
    this.isColumnVirtualisationSuppressed() ? (this.colsWithinViewport = e, this.headerColsWithinViewport = e) : (this.colsWithinViewport = e.filter(this.isColumnInRowViewport.bind(this)), this.headerColsWithinViewport = e.filter(this.isColumnInHeaderViewport.bind(this)));
  }
  isColumnVirtualisationSuppressed() {
    return this.suppressColumnVirtualisation || this.viewportRight === 0;
  }
  clear() {
    this.rowsOfHeadersToRenderLeft = {}, this.rowsOfHeadersToRenderRight = {}, this.rowsOfHeadersToRenderCenter = {}, this.colsWithinViewportHash = "";
  }
  isColumnInHeaderViewport(e) {
    return e.isAutoHeaderHeight() || m$e(e) ? !0 : this.isColumnInRowViewport(e);
  }
  isColumnInRowViewport(e) {
    if (e.isAutoHeight())
      return !0;
    const t = e.getLeft() || 0, o = t + e.getActualWidth(), n = this.viewportLeft - 200, s = this.viewportRight + 200, i = t < n && o < n, r = t > s && o > s;
    return !i && !r;
  }
  // used by Grid API only
  getViewportColumns() {
    const { leftCols: e, rightCols: t } = this.visibleCols;
    return this.colsWithinViewport.concat(e).concat(t);
  }
  // + rowRenderer
  // if we are not column spanning, this just returns back the virtual centre columns,
  // however if we are column spanning, then different rows can have different virtual
  // columns, so we have to work out the list for each individual row.
  getColsWithinViewport(e) {
    if (!this.colModel.colSpanActive)
      return this.colsWithinViewport;
    const t = (i) => {
      const r = i.getLeft();
      return ue(r) && r > this.viewportLeft;
    }, o = this.isColumnVirtualisationSuppressed() ? void 0 : this.isColumnInRowViewport.bind(this), { visibleCols: n } = this, s = n.centerCols;
    return n.getColsForRow(e, s, o, t);
  }
  // checks what columns are currently displayed due to column virtualisation. dispatches an event
  // if the list of columns has changed.
  // + setColumnWidth(), setViewportPosition(), setColumnDefs(), sizeColumnsToFit()
  checkViewportColumns(e = !1) {
    this.extractViewport() && this.eventSvc.dispatchEvent({
      type: "virtualColumnsChanged",
      afterScroll: e
    });
  }
  calculateHeaderRows() {
    const { leftCols: e, rightCols: t } = this.visibleCols;
    this.columnsToRenderLeft = e, this.columnsToRenderRight = t, this.columnsToRenderCenter = this.colsWithinViewport;
    const o = (n) => {
      const s = /* @__PURE__ */ new Set(), i = {};
      for (const r of n) {
        let l = r.getParent();
        const a = r.isSpanHeaderHeight();
        for (; l && !s.has(l); ) {
          if (a && l.isPadding()) {
            l = l.getParent();
            continue;
          }
          const d = l.getProvidedColumnGroup().getLevel();
          i[d] ?? (i[d] = []), i[d].push(l), s.add(l), l = l.getParent();
        }
      }
      return i;
    };
    this.rowsOfHeadersToRenderLeft = o(e), this.rowsOfHeadersToRenderRight = o(t), this.rowsOfHeadersToRenderCenter = o(this.headerColsWithinViewport);
  }
  extractViewport() {
    const e = (n) => `${n.getId()}-${n.getPinned() || "normal"}`;
    this.extractViewportColumns();
    const t = this.getViewportColumns().map(e).join("#"), o = this.colsWithinViewportHash !== t;
    return o && (this.colsWithinViewportHash = t, this.calculateHeaderRows()), o;
  }
};
function m$e(e) {
  for (; e; ) {
    if (e.isAutoHeaderHeight())
      return !0;
    e = e.getParent();
  }
  return !1;
}
var C$e = class extends K {
  constructor() {
    super(...arguments), this.beanName = "agCompUtils";
  }
  adaptFunction(e, t) {
    if (!e.cellRenderer)
      return null;
    class o {
      refresh() {
        return !1;
      }
      getGui() {
        return this.eGui;
      }
      init(s) {
        const i = t(s), r = typeof i;
        if (r === "string" || r === "number" || r === "boolean") {
          this.eGui = y2("<span>" + i + "</span>");
          return;
        }
        if (i == null) {
          this.eGui = ze({ tag: "span" });
          return;
        }
        this.eGui = i;
      }
    }
    return o;
  }
}, w$e = {
  moduleName: "CellRendererFunction",
  version: be,
  beans: [C$e]
}, b$e = class extends Gke {
  constructor() {
    super(...arguments), this.agGridDefaults = {}, this.agGridDefaultOverrides = {}, this.jsComps = {}, this.selectors = {}, this.icons = {};
  }
  postConstruct() {
    const e = this.gos.get("components");
    if (e != null)
      for (const t of Object.keys(e))
        this.jsComps[t] = e[t];
  }
  registerModule(e) {
    const { icons: t, userComponents: o, dynamicBeans: n, selectors: s } = e;
    if (o) {
      const i = (r, l, a, c) => {
        this.agGridDefaults[r] = l, (a || c) && (this.agGridDefaultOverrides[r] = { params: a, processParams: c });
      };
      for (const r of Object.keys(o)) {
        let l = o[r];
        if (BDe(l) && (l = l.getComp(this.beans)), typeof l == "object") {
          const { classImp: a, params: c, processParams: d } = l;
          i(r, a, c, d);
        } else
          i(r, l);
      }
    }
    if (this.registerDynamicBeans(n), s == null || s.forEach((i) => {
      this.selectors[i.selector] = i;
    }), t)
      for (const i of Object.keys(t))
        this.icons[i] = t[i];
  }
  getUserComponent(e, t) {
    var l;
    const o = (a, c, d, u) => ({
      componentFromFramework: c,
      component: a,
      params: d,
      processParams: u
    }), { frameworkOverrides: n } = this.beans, s = n.frameworkComponent(t, this.gos.get("components"));
    if (s != null)
      return o(s, !0);
    const i = this.jsComps[t];
    if (i) {
      const a = n.isFrameworkComponent(i);
      return o(i, a);
    }
    const r = this.agGridDefaults[t];
    if (r) {
      const a = this.agGridDefaultOverrides[t];
      return o(r, !1, a == null ? void 0 : a.params, a == null ? void 0 : a.processParams);
    }
    return (l = this.beans.validation) == null || l.missingUserComponent(e, t, this.agGridDefaults, this.jsComps), null;
  }
  getSelector(e) {
    return this.selectors[e];
  }
  getIcon(e) {
    return this.icons[e];
  }
  getDynamicError(e, t) {
    var o;
    return t ? ln(279, { name: e }) : ((o = this.beans.validation) == null ? void 0 : o.missingDynamicBean(e)) ?? ln(256);
  }
}, y$e = 23, _$e = class extends K {
  constructor() {
    super(...arguments), this.beanName = "ctrlsSvc", this.params = {}, this.ready = !1, this.readyCallbacks = [];
  }
  postConstruct() {
    var e, t;
    this.addEventListener(
      "ready",
      () => {
        this.updateReady(), this.ready && (this.readyCallbacks.forEach((o) => o(this.params)), this.readyCallbacks.length = 0);
      },
      ((t = (e = this.beans.frameworkOverrides).runWhenReadyAsync) == null ? void 0 : t.call(e)) ?? !1
    );
  }
  updateReady() {
    const e = Object.values(this.params);
    this.ready = e.length === y$e && e.every((t) => (t == null ? void 0 : t.isAlive()) ?? !1);
  }
  whenReady(e, t) {
    this.ready ? t(this.params) : this.readyCallbacks.push(t), e.addDestroyFunc(() => {
      const o = this.readyCallbacks.indexOf(t);
      o >= 0 && this.readyCallbacks.splice(o, 1);
    });
  }
  register(e, t) {
    this.params[e] = t, this.updateReady(), this.ready && this.dispatchLocalEvent({ type: "ready" }), t.addDestroyFunc(() => {
      this.updateReady();
    });
  }
  get(e) {
    return this.params[e];
  }
  getGridBodyCtrl() {
    return this.params.gridBodyCtrl;
  }
  getHeaderRowContainerCtrls() {
    const { leftHeader: e, centerHeader: t, rightHeader: o } = this.params;
    return [e, o, t];
  }
  getHeaderRowContainerCtrl(e) {
    const t = this.params;
    switch (e) {
      case "left":
        return t.leftHeader;
      case "right":
        return t.rightHeader;
      default:
        return t.centerHeader;
    }
  }
  getScrollFeature() {
    return this.getGridBodyCtrl().scrollFeature;
  }
}, sy = /* @__PURE__ */ new Set(), kl = {}, Gs = {}, J1, iy = !1, ry = !1, S$e = !1;
function x$e(e) {
  const [t, o] = e.version.split(".") || [], [n, s] = J1.split(".") || [];
  return t === n && o === s;
}
function M$e(e) {
  J1 || (J1 = e.version);
  const t = (o) => `You are using incompatible versions of AG Grid modules. Major and minor versions should always match across modules. ${o} Please update all modules to the same version.`;
  if (e.version ? x$e(e) || Ai(
    t(
      `'${e.moduleName}' is version ${e.version} but the other modules are version ${J1}.`
    )
  ) : Ai(t(`'${e.moduleName}' is incompatible.`)), e.validate) {
    const o = e.validate();
    o.isValid || Ai(`${o.message}`);
  }
}
function Ui(e, t, o = !1) {
  o || (iy = !0), M$e(e);
  const n = e.rowModels ?? ["all"];
  sy.add(e);
  let s;
  t !== void 0 ? (ry = !0, Gs[t] === void 0 && (Gs[t] = {}), s = Gs[t]) : s = kl, n.forEach((i) => {
    s[i] === void 0 && (s[i] = {}), s[i][e.moduleName] = e;
  }), e.dependsOn && e.dependsOn.forEach((i) => Ui(i, t, o));
}
function A$e(e) {
  delete Gs[e];
}
function v5(e, t, o) {
  const n = (s) => {
    var i, r, l;
    return !!((i = kl[s]) != null && i[e]) || !!((l = (r = Gs[t]) == null ? void 0 : r[s]) != null && l[e]);
  };
  return n(o) || n("all");
}
function oc() {
  return ry;
}
function L$e(e, t) {
  const o = Gs[e] ?? {};
  return [
    ...Object.values(kl.all ?? {}),
    ...Object.values(o.all ?? {}),
    ...Object.values(kl[t] ?? {}),
    ...Object.values(o[t] ?? {})
  ];
}
function E$e() {
  return new Set(sy);
}
function P$e(e, t) {
  const o = Gs[e] ?? {};
  return [...Object.values(o.all ?? {}), ...Object.values(o[t] ?? {})];
}
function R$e() {
  return iy;
}
function F$e() {
  return S$e;
}
var du = class {
  /**
   * @deprecated v33 Use `registerModules([module])` instead.
   */
  static register(e) {
    Ui(e, void 0);
  }
  /**
   * Globally register the given modules for all grids.
   * @param modules - modules to register
   */
  static registerModules(e) {
    e.forEach((t) => Ui(t, void 0));
  }
}, T$e = (
  /*css*/
  '.ag-aria-description-container{border:0;z-index:9999;clip:rect(1px,1px,1px,1px);height:1px;overflow:hidden;padding:0;position:absolute;white-space:nowrap;width:1px}.ag-unselectable{-webkit-user-select:none;-moz-user-select:none;user-select:none}.ag-selectable{-webkit-user-select:text;-moz-user-select:text;user-select:text}.ag-tab-guard{display:block;height:0;position:absolute;width:0}:where(.ag-virtual-list-viewport) .ag-tab-guard{position:sticky}.ag-tab-guard-top{top:1px}.ag-tab-guard-bottom{bottom:1px}.ag-shake-left-to-right{animation-direction:alternate;animation-duration:.2s;animation-iteration-count:infinite;animation-name:ag-shake-left-to-right}@keyframes ag-shake-left-to-right{0%{padding-left:6px;padding-right:2px}to{padding-left:2px;padding-right:6px}}.ag-body-horizontal-scroll-viewport,.ag-body-vertical-scroll-viewport,.ag-body-viewport,.ag-center-cols-viewport,.ag-floating-bottom-viewport,.ag-floating-top-viewport,.ag-header-viewport,.ag-sticky-bottom-viewport,.ag-sticky-top-viewport,.ag-virtual-list-viewport{flex:1 1 auto;height:100%;min-width:0;overflow:hidden;position:relative}.ag-viewport{position:relative}.ag-spanning-container{position:absolute;top:0;z-index:1}.ag-body-viewport,.ag-center-cols-viewport,.ag-floating-bottom-viewport,.ag-floating-top-viewport,.ag-header-viewport,.ag-sticky-bottom-viewport,.ag-sticky-top-viewport{overflow-x:auto;-ms-overflow-style:none!important;scrollbar-width:none!important;&::-webkit-scrollbar{display:none!important}}.ag-body-viewport{display:flex;overflow-x:hidden;&:where(.ag-layout-normal){overflow-y:auto;-webkit-overflow-scrolling:touch}}.ag-floating-bottom-container,.ag-floating-top-container,.ag-sticky-bottom-container,.ag-sticky-top-container{min-height:1px}.ag-center-cols-viewport{min-height:100%;width:100%}.ag-body-horizontal-scroll-viewport{overflow-x:scroll}.ag-body-vertical-scroll-viewport{overflow-y:scroll}.ag-virtual-list-viewport{overflow:auto;width:100%}.ag-body-container,.ag-body-horizontal-scroll-container,.ag-body-vertical-scroll-container,.ag-center-cols-container,.ag-floating-bottom-container,.ag-floating-bottom-full-width-container,.ag-floating-top-container,.ag-full-width-container,.ag-header-container,.ag-pinned-left-cols-container,.ag-pinned-right-cols-container,.ag-sticky-bottom-container,.ag-sticky-top-container,.ag-virtual-list-container{position:relative}.ag-floating-bottom-container,.ag-floating-top-container,.ag-header-container,.ag-pinned-left-floating-bottom,.ag-pinned-left-floating-top,.ag-pinned-right-floating-bottom,.ag-pinned-right-floating-top,.ag-sticky-bottom-container,.ag-sticky-top-container{height:100%;white-space:nowrap}.ag-center-cols-container,.ag-pinned-right-cols-container{display:block}.ag-body-horizontal-scroll-container{height:100%}.ag-body-vertical-scroll-container{width:100%}.ag-floating-bottom-full-width-container,.ag-floating-top-full-width-container,.ag-full-width-container,.ag-sticky-bottom-full-width-container,.ag-sticky-top-full-width-container{pointer-events:none;position:absolute;top:0}:where(.ag-ltr) .ag-floating-bottom-full-width-container,:where(.ag-ltr) .ag-floating-top-full-width-container,:where(.ag-ltr) .ag-full-width-container,:where(.ag-ltr) .ag-sticky-bottom-full-width-container,:where(.ag-ltr) .ag-sticky-top-full-width-container{left:0}:where(.ag-rtl) .ag-floating-bottom-full-width-container,:where(.ag-rtl) .ag-floating-top-full-width-container,:where(.ag-rtl) .ag-full-width-container,:where(.ag-rtl) .ag-sticky-bottom-full-width-container,:where(.ag-rtl) .ag-sticky-top-full-width-container{right:0}.ag-full-width-container{width:100%}.ag-floating-bottom-full-width-container,.ag-floating-top-full-width-container{display:inline-block;height:100%;overflow:hidden;width:100%}.ag-virtual-list-container{overflow:hidden}.ag-body{display:flex;flex:1 1 auto;flex-direction:row!important;min-height:0;position:relative}.ag-body-horizontal-scroll,.ag-body-vertical-scroll{display:flex;min-height:0;min-width:0;position:relative;&:where(.ag-scrollbar-invisible){bottom:0;position:absolute;&:where(.ag-apple-scrollbar){opacity:0;transition:opacity .4s;visibility:hidden;&:where(.ag-scrollbar-scrolling,.ag-scrollbar-active){opacity:1;visibility:visible}}}}.ag-body-horizontal-scroll{width:100%;&:where(.ag-scrollbar-invisible){left:0;right:0}}.ag-body-vertical-scroll{height:100%;&:where(.ag-scrollbar-invisible){top:0;z-index:10}}:where(.ag-ltr) .ag-body-vertical-scroll{&:where(.ag-scrollbar-invisible){right:0}}:where(.ag-rtl) .ag-body-vertical-scroll{&:where(.ag-scrollbar-invisible){left:0}}.ag-force-vertical-scroll{overflow-y:scroll!important}.ag-horizontal-left-spacer,.ag-horizontal-right-spacer{height:100%;min-width:0;overflow-x:scroll;&:where(.ag-scroller-corner){overflow-x:hidden}}:where(.ag-row-animation) .ag-row{transition:transform .4s,top .4s,opacity .2s;&:where(.ag-after-created){transition:transform .4s,top .4s,height .4s,opacity .2s}}:where(.ag-row-animation.ag-prevent-animation) .ag-row{transition:none!important;&:where(.ag-row.ag-after-created){transition:none!important}}:where(.ag-row-no-animation) .ag-row{transition:none}.ag-row-loading{align-items:center;display:flex}.ag-row-position-absolute{position:absolute}.ag-row-position-relative{position:relative}.ag-full-width-row{overflow:hidden;pointer-events:all}.ag-row-inline-editing{z-index:1}.ag-row-dragging{z-index:2}.ag-stub-cell{align-items:center;display:flex}.ag-cell{display:inline-block;height:100%;position:absolute;white-space:nowrap;&:focus-visible{box-shadow:none}}.ag-cell-value{flex:1 1 auto}.ag-cell-value,.ag-group-value{overflow:hidden;text-overflow:ellipsis}.ag-cell-wrap-text{white-space:normal;word-break:break-word}:where(.ag-cell) .ag-icon{display:inline-block;vertical-align:middle}.ag-floating-top{display:flex;overflow:hidden;position:relative;white-space:nowrap;width:100%}:where(.ag-floating-top:not(.ag-invisible)){border-bottom:var(--ag-pinned-row-border)}.ag-floating-bottom{display:flex;overflow:hidden;position:relative;white-space:nowrap;width:100%}:where(.ag-floating-bottom:not(.ag-invisible)){border-top:var(--ag-pinned-row-border)}.ag-sticky-bottom,.ag-sticky-top{background-color:var(--ag-background-color);display:flex;height:0;overflow:hidden;position:absolute;width:100%;z-index:1}.ag-opacity-zero{opacity:0!important}.ag-cell-label-container{align-items:center;display:flex;flex-direction:row-reverse;height:100%;justify-content:space-between;width:100%}:where(.ag-right-aligned-header){.ag-cell-label-container{flex-direction:row}.ag-header-cell-text{text-align:end}}.ag-column-group-icons{display:block;>*{cursor:pointer}}:where(.ag-ltr){direction:ltr;.ag-body,.ag-body-horizontal-scroll,.ag-body-viewport,.ag-floating-bottom,.ag-floating-top,.ag-header,.ag-sticky-bottom,.ag-sticky-top{flex-direction:row}}:where(.ag-rtl){direction:rtl;text-align:right;.ag-body,.ag-body-horizontal-scroll,.ag-body-viewport,.ag-floating-bottom,.ag-floating-top,.ag-header,.ag-sticky-bottom,.ag-sticky-top{flex-direction:row-reverse}.ag-icon-contracted,.ag-icon-expanded,.ag-icon-tree-closed{display:block}}:where(.ag-rtl){.ag-icon-contracted,.ag-icon-expanded,.ag-icon-tree-closed{transform:rotate(180deg)}}:where(.ag-rtl){.ag-icon-contracted,.ag-icon-expanded,.ag-icon-tree-closed{transform:rotate(-180deg)}}.ag-measurement-container{height:0;overflow:hidden;visibility:hidden;width:0}.ag-measurement-element-border{display:inline-block;&:before{border-left:var(--ag-internal-measurement-border);content:"";display:block}}.ag-group{position:relative;width:100%}.ag-group-title-bar{align-items:center;display:flex;padding:var(--ag-spacing)}.ag-group-title{display:inline;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}:where(.ag-group-title-bar) .ag-group-title{cursor:default}.ag-group-toolbar{align-items:center;display:flex;padding:var(--ag-spacing)}.ag-group-container{display:flex}.ag-disabled .ag-group-container{pointer-events:none}.ag-disabled-group-container,.ag-disabled-group-title-bar{opacity:.5}.ag-group-container-horizontal{flex-flow:row wrap}.ag-group-container-vertical{flex-direction:column}.ag-group-title-bar-icon{cursor:pointer;flex:none}:where(.ag-ltr) .ag-group-title-bar-icon{margin-right:var(--ag-spacing)}:where(.ag-rtl) .ag-group-title-bar-icon{margin-left:var(--ag-spacing)}:where(.ag-group-item-alignment-stretch) .ag-group-item{align-items:stretch}:where(.ag-group-item-alignment-start) .ag-group-item{align-items:flex-start}:where(.ag-group-item-alignment-end) .ag-group-item{align-items:flex-end}:where(.ag-ltr) .ag-row:not(.ag-row-level-0) .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}:where(.ag-rtl) .ag-row:not(.ag-row-level-0) .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}:where(.ag-ltr) .ag-row-group-leaf-indent{margin-left:calc(var(--ag-cell-widget-spacing) + var(--ag-icon-size))}:where(.ag-rtl) .ag-row-group-leaf-indent{margin-right:calc(var(--ag-cell-widget-spacing) + var(--ag-icon-size))}.ag-value-change-delta{padding:0 2px}.ag-value-change-delta-up{color:var(--ag-value-change-delta-up-color)}.ag-value-change-delta-down{color:var(--ag-value-change-delta-down-color)}.ag-value-change-value{background-color:transparent;border-radius:1px;padding-left:1px;padding-right:1px;transition:background-color 1s}.ag-value-change-value-highlight{background-color:var(--ag-value-change-value-highlight-background-color);transition:background-color .1s}.ag-cell-data-changed{background-color:var(--ag-value-change-value-highlight-background-color)!important}.ag-cell-data-changed-animation{background-color:transparent}.ag-cell-highlight{background-color:var(--ag-range-selection-highlight-color)!important}.ag-row,.ag-spanned-row{color:var(--ag-cell-text-color);font-family:var(--ag-cell-font-family);font-size:var(--ag-data-font-size);white-space:nowrap;--ag-internal-content-line-height:calc(min(var(--ag-row-height), var(--ag-line-height, 1000px)) - var(--ag-internal-row-border-width, 1px) - 2px)}.ag-row{background-color:var(--ag-background-color);border-bottom:var(--ag-row-border);height:var(--ag-row-height);width:100%;&.ag-row-editing-invalid{background-color:var(--ag-full-row-edit-invalid-background-color)}}:where(.ag-body-vertical-content-no-gap>div>div>div,.ag-body-vertical-content-no-gap>div>div>div>div)>.ag-row-last{border-bottom-color:transparent}.ag-sticky-bottom{border-top:var(--ag-row-border);box-sizing:content-box!important}.ag-group-contracted,.ag-group-expanded{cursor:pointer}.ag-cell,.ag-full-width-row .ag-cell-wrapper.ag-row-group{border:1px solid transparent;line-height:var(--ag-internal-content-line-height);-webkit-font-smoothing:subpixel-antialiased}:where(.ag-ltr) .ag-cell{border-right:var(--ag-column-border)}:where(.ag-rtl) .ag-cell{border-left:var(--ag-column-border)}.ag-spanned-cell-wrapper{background-color:var(--ag-background-color);position:absolute}.ag-spanned-cell-wrapper>.ag-spanned-cell{display:block;position:relative}:where(.ag-ltr) :where(.ag-body-horizontal-content-no-gap) .ag-column-last{border-right-color:transparent}:where(.ag-rtl) :where(.ag-body-horizontal-content-no-gap) .ag-column-last{border-left-color:transparent}.ag-cell-wrapper{align-items:center;display:flex;>:where(:not(.ag-cell-value,.ag-group-value)){align-items:center;display:flex;height:var(--ag-internal-content-line-height)}&:where(.ag-row-group){align-items:flex-start}:where(.ag-full-width-row) &:where(.ag-row-group){align-items:center;height:100%}}:where(.ag-ltr) .ag-cell-wrapper{padding-left:calc(var(--ag-indentation-level)*var(--ag-row-group-indent-size))}:where(.ag-rtl) .ag-cell-wrapper{padding-right:calc(var(--ag-indentation-level)*var(--ag-row-group-indent-size))}:where(.ag-cell-wrap-text:not(.ag-cell-auto-height)) .ag-cell-wrapper{align-items:normal;height:100%;:where(.ag-cell-value){height:100%}}:where(.ag-ltr) .ag-row>.ag-cell-wrapper.ag-row-group{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size)*var(--ag-indentation-level))}:where(.ag-rtl) .ag-row>.ag-cell-wrapper.ag-row-group{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size)*var(--ag-indentation-level))}.ag-cell-focus:not(.ag-cell-range-selected):focus-within,.ag-cell-range-single-cell,.ag-cell-range-single-cell.ag-cell-range-handle,.ag-context-menu-open .ag-cell-focus:not(.ag-cell-range-selected),.ag-context-menu-open .ag-full-width-row.ag-row-focus .ag-cell-wrapper.ag-row-group,.ag-full-width-row.ag-row-focus:focus .ag-cell-wrapper.ag-row-group{border:1px solid;border-color:var(--ag-range-selection-border-color);border-style:var(--ag-range-selection-border-style);outline:initial}.ag-full-width-row.ag-row-focus:focus{box-shadow:none}:where(.ag-ltr) .ag-group-contracted,:where(.ag-ltr) .ag-group-expanded,:where(.ag-ltr) .ag-row-drag,:where(.ag-ltr) .ag-selection-checkbox{margin-right:var(--ag-cell-widget-spacing)}:where(.ag-rtl) .ag-group-contracted,:where(.ag-rtl) .ag-group-expanded,:where(.ag-rtl) .ag-row-drag,:where(.ag-rtl) .ag-selection-checkbox{margin-left:var(--ag-cell-widget-spacing)}:where(.ag-ltr) .ag-group-child-count{margin-left:3px}:where(.ag-rtl) .ag-group-child-count{margin-right:3px}.ag-row-highlight-above:after,.ag-row-highlight-below:after,.ag-row-highlight-inside:after{background-color:var(--ag-range-selection-border-color);content:"";height:1px;pointer-events:none;position:absolute;width:calc(100% - 1px)}:where(.ag-ltr) .ag-row-highlight-above:after,:where(.ag-ltr) .ag-row-highlight-below:after,:where(.ag-ltr) .ag-row-highlight-inside:after{left:1px}:where(.ag-rtl) .ag-row-highlight-above:after,:where(.ag-rtl) .ag-row-highlight-below:after,:where(.ag-rtl) .ag-row-highlight-inside:after{right:1px}.ag-row-highlight-above:after{top:0}.ag-row-highlight-below:after{bottom:0}.ag-row-highlight-indent:after{display:block;width:auto}:where(.ag-ltr) .ag-row-highlight-indent:after{left:calc((var(--ag-cell-widget-spacing) + var(--ag-icon-size))*2 + var(--ag-cell-horizontal-padding) + var(--ag-row-highlight-level)*var(--ag-row-group-indent-size));right:1px}:where(.ag-rtl) .ag-row-highlight-indent:after{left:1px;right:calc((var(--ag-cell-widget-spacing) + var(--ag-icon-size))*2 + var(--ag-cell-horizontal-padding) + var(--ag-row-highlight-level)*var(--ag-row-group-indent-size))}.ag-row-highlight-inside:after{background-color:var(--ag-selected-row-background-color);border:1px solid var(--ag-range-selection-border-color);display:block;height:auto;inset:0;width:auto}.ag-row-odd{background-color:var(--ag-odd-row-background-color)}.ag-row-selected:before{background-color:var(--ag-selected-row-background-color);content:"";display:block;inset:0;pointer-events:none;position:absolute}.ag-row-hover.ag-full-width-row.ag-row-group:before,.ag-row-hover:not(.ag-full-width-row):before{background-color:var(--ag-row-hover-color);content:"";display:block;inset:0;pointer-events:none;position:absolute}.ag-row-hover.ag-row-selected:before{background-color:var(--ag-row-hover-color);background-image:linear-gradient(var(--ag-selected-row-background-color),var(--ag-selected-row-background-color))}.ag-row.ag-full-width-row.ag-row-group>*{position:relative}.ag-column-hover{background-color:var(--ag-column-hover-color)}.ag-header-range-highlight{background-color:var(--ag-range-header-highlight-color)}.ag-right-aligned-cell{font-variant-numeric:tabular-nums}:where(.ag-ltr) .ag-right-aligned-cell{text-align:right}:where(.ag-rtl) .ag-right-aligned-cell{text-align:left}.ag-right-aligned-cell .ag-cell-value,.ag-right-aligned-cell .ag-group-value{margin-left:auto}:where(.ag-ltr) .ag-cell:not(.ag-cell-inline-editing),:where(.ag-ltr) .ag-full-width-row .ag-cell-wrapper.ag-row-group{padding-left:calc(var(--ag-cell-horizontal-padding) - 1px + var(--ag-row-group-indent-size)*var(--ag-indentation-level));padding-right:calc(var(--ag-cell-horizontal-padding) - 1px)}:where(.ag-rtl) .ag-cell:not(.ag-cell-inline-editing),:where(.ag-rtl) .ag-full-width-row .ag-cell-wrapper.ag-row-group{padding-left:calc(var(--ag-cell-horizontal-padding) - 1px);padding-right:calc(var(--ag-cell-horizontal-padding) - 1px + var(--ag-row-group-indent-size)*var(--ag-indentation-level))}.ag-row>.ag-cell-wrapper{padding-left:calc(var(--ag-cell-horizontal-padding) - 1px);padding-right:calc(var(--ag-cell-horizontal-padding) - 1px)}.ag-row-dragging{cursor:move;opacity:.5}.ag-details-row{background-color:var(--ag-background-color);padding:calc(var(--ag-spacing)*3.75)}.ag-layout-auto-height,.ag-layout-print{.ag-center-cols-container,.ag-center-cols-viewport{min-height:150px}}.ag-overlay-loading-wrapper{background-color:var(--ag-modal-overlay-background-color)}.ag-skeleton-container{align-content:center;height:100%;width:100%}.ag-skeleton-effect{animation:ag-skeleton-loading 1.5s ease-in-out .5s infinite;background-color:var(--ag-row-loading-skeleton-effect-color);border-radius:.25rem;height:1em;width:100%}:where(.ag-ltr) .ag-right-aligned-cell .ag-skeleton-effect{margin-left:auto}:where(.ag-rtl) .ag-right-aligned-cell .ag-skeleton-effect{margin-right:auto}@keyframes ag-skeleton-loading{0%{background-color:var(--ag-row-loading-skeleton-effect-color)}50%{background-color:color-mix(in srgb,transparent,var(--ag-row-loading-skeleton-effect-color) 40%)}to{background-color:var(--ag-row-loading-skeleton-effect-color)}}.ag-loading{align-items:center;display:flex;height:100%}:where(.ag-ltr) .ag-loading{padding-left:var(--ag-cell-horizontal-padding)}:where(.ag-rtl) .ag-loading{padding-right:var(--ag-cell-horizontal-padding)}:where(.ag-ltr) .ag-loading-icon{padding-right:var(--ag-cell-widget-spacing)}:where(.ag-rtl) .ag-loading-icon{padding-left:var(--ag-cell-widget-spacing)}.ag-icon-loading{animation-duration:1s;animation-iteration-count:infinite;animation-name:spin;animation-timing-function:linear}@keyframes spin{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}.ag-header{background-color:var(--ag-header-background-color);border-bottom:var(--ag-header-row-border);color:var(--ag-header-text-color);display:flex;font-family:var(--ag-header-font-family);font-size:var(--ag-header-font-size);font-weight:var(--ag-header-font-weight);overflow:hidden;white-space:nowrap;width:100%}.ag-header-row{height:var(--ag-header-height);position:absolute}.ag-floating-filter-button-button,.ag-header-cell-filter-button,.ag-header-cell-menu-button,.ag-header-expand-icon,.ag-panel-title-bar-button,:where(.ag-header-cell-sortable) .ag-header-cell-label{cursor:pointer}:where(.ag-ltr) .ag-header-expand-icon{margin-left:4px}:where(.ag-rtl) .ag-header-expand-icon{margin-right:4px}.ag-header-row:where(:not(:first-child)){:where(.ag-header-cell:not(.ag-header-span-height.ag-header-span-total,.ag-header-parent-hidden),.ag-header-group-cell.ag-header-group-cell-with-group){border-top:var(--ag-header-row-border)}}.ag-header-row:where(:not(.ag-header-row-column-group)){overflow:hidden}:where(.ag-header.ag-header-allow-overflow) .ag-header-row{overflow:visible}.ag-header-cell{display:inline-flex;overflow:hidden}.ag-header-group-cell{contain:paint;display:flex}.ag-header-cell,.ag-header-group-cell{align-items:center;gap:var(--ag-cell-widget-spacing);height:100%;padding:0 var(--ag-cell-horizontal-padding);position:absolute}@property --ag-internal-moving-color{syntax:"<color>";inherits:false;initial-value:transparent}@property --ag-internal-hover-color{syntax:"<color>";inherits:false;initial-value:transparent}.ag-header-cell:where(:not(.ag-floating-filter)),.ag-header-group-cell{&:before{background-image:linear-gradient(var(--ag-internal-hover-color),var(--ag-internal-hover-color)),linear-gradient(var(--ag-internal-moving-color),var(--ag-internal-moving-color));content:"";inset:0;position:absolute;--ag-internal-moving-color:transparent;--ag-internal-hover-color:transparent;transition:--ag-internal-moving-color var(--ag-header-cell-background-transition-duration),--ag-internal-hover-color var(--ag-header-cell-background-transition-duration)}&:where(:hover):before{--ag-internal-hover-color:var(--ag-header-cell-hover-background-color)}&:where(.ag-header-cell-moving):before{--ag-internal-moving-color:var(--ag-header-cell-moving-background-color);--ag-internal-hover-color:var(--ag-header-cell-hover-background-color)}}:where(.ag-header-cell:not(.ag-floating-filter) *,.ag-header-group-cell *){position:relative;z-index:1}.ag-header-cell-menu-button:where(:not(.ag-header-menu-always-show)){opacity:0;transition:opacity .2s}.ag-header-cell-filter-button,:where(.ag-header-cell.ag-header-active) .ag-header-cell-menu-button{opacity:1}.ag-header-cell-label,.ag-header-group-cell-label{align-items:center;align-self:stretch;display:flex;flex:1 1 auto;overflow:hidden;padding:5px 0}:where(.ag-ltr) .ag-sort-indicator-icon{padding-left:var(--ag-spacing)}:where(.ag-rtl) .ag-sort-indicator-icon{padding-right:var(--ag-spacing)}.ag-header-cell-label{text-overflow:ellipsis}.ag-header-group-cell-label.ag-sticky-label{flex:none;max-width:100%;overflow:visible;position:sticky}:where(.ag-ltr) .ag-header-group-cell-label.ag-sticky-label{left:var(--ag-cell-horizontal-padding)}:where(.ag-rtl) .ag-header-group-cell-label.ag-sticky-label{right:var(--ag-cell-horizontal-padding)}.ag-header-cell-text,.ag-header-group-text{overflow:hidden;text-overflow:ellipsis}.ag-header-cell-text{word-break:break-word}.ag-header-cell-comp-wrapper{width:100%}:where(.ag-header-group-cell) .ag-header-cell-comp-wrapper{display:flex}:where(.ag-header-cell:not(.ag-header-cell-auto-height)) .ag-header-cell-comp-wrapper{align-items:center;display:flex;height:100%}.ag-header-cell-wrap-text .ag-header-cell-comp-wrapper{white-space:normal}.ag-header-cell-comp-wrapper-limited-height>*{overflow:hidden}:where(.ag-right-aligned-header) .ag-header-cell-label{flex-direction:row-reverse}:where(.ag-ltr) :where(.ag-header-cell:not(.ag-right-aligned-header)){.ag-header-label-icon,.ag-header-menu-icon{margin-left:var(--ag-spacing)}}:where(.ag-rtl) :where(.ag-header-cell:not(.ag-right-aligned-header)){.ag-header-label-icon,.ag-header-menu-icon{margin-right:var(--ag-spacing)}}:where(.ag-ltr) :where(.ag-header-cell.ag-right-aligned-header){.ag-header-label-icon,.ag-header-menu-icon{margin-right:var(--ag-spacing)}}:where(.ag-rtl) :where(.ag-header-cell.ag-right-aligned-header){.ag-header-label-icon,.ag-header-menu-icon{margin-left:var(--ag-spacing)}}.ag-header-cell:after,.ag-header-group-cell:where(:not(.ag-header-span-height.ag-header-group-cell-no-group)):after{content:"";height:var(--ag-header-column-border-height);position:absolute;top:calc(50% - var(--ag-header-column-border-height)*.5);z-index:1}:where(.ag-ltr) .ag-header-cell:after,:where(.ag-ltr) .ag-header-group-cell:where(:not(.ag-header-span-height.ag-header-group-cell-no-group)):after{border-right:var(--ag-header-column-border);right:0}:where(.ag-rtl) .ag-header-cell:after,:where(.ag-rtl) .ag-header-group-cell:where(:not(.ag-header-span-height.ag-header-group-cell-no-group)):after{border-left:var(--ag-header-column-border);left:0}.ag-header-highlight-after:after,.ag-header-highlight-before:after{background-color:var(--ag-accent-color);content:"";height:100%;position:absolute;width:1px}:where(.ag-ltr) .ag-header-highlight-before:after{left:0}:where(.ag-rtl) .ag-header-highlight-before:after{right:0}:where(.ag-ltr) .ag-header-highlight-after:after{right:0;:where(.ag-pinned-left-header) &{right:1px}}:where(.ag-rtl) .ag-header-highlight-after:after{left:0;:where(.ag-pinned-left-header) &{left:1px}}.ag-header-cell-resize{align-items:center;cursor:ew-resize;display:flex;height:100%;position:absolute;top:0;width:8px;z-index:2;&:after{background-color:var(--ag-header-column-resize-handle-color);content:"";height:var(--ag-header-column-resize-handle-height);position:absolute;top:calc(50% - var(--ag-header-column-resize-handle-height)*.5);width:var(--ag-header-column-resize-handle-width);z-index:1}}:where(.ag-ltr) .ag-header-cell-resize{right:-3px;&:after{left:calc(50% - var(--ag-header-column-resize-handle-width))}}:where(.ag-rtl) .ag-header-cell-resize{left:-3px;&:after{right:calc(50% - var(--ag-header-column-resize-handle-width))}}:where(.ag-header-cell.ag-header-span-height) .ag-header-cell-resize:after{height:calc(100% - var(--ag-spacing)*4);top:calc(var(--ag-spacing)*2)}.ag-header-group-cell-no-group:where(.ag-header-span-height){display:none}.ag-sort-indicator-container{display:flex;gap:var(--ag-spacing)}.ag-layout-print{&.ag-body{display:block;height:unset}&.ag-root-wrapper{display:inline-block}.ag-body-horizontal-scroll,.ag-body-vertical-scroll{display:none}&.ag-force-vertical-scroll{overflow-y:visible!important}}@media print{.ag-root-wrapper.ag-layout-print{display:table;.ag-body-horizontal-scroll-viewport,.ag-body-viewport,.ag-center-cols-container,.ag-center-cols-viewport,.ag-root,.ag-root-wrapper-body,.ag-virtual-list-viewport{display:block!important;height:auto!important;overflow:hidden!important}.ag-cell,.ag-row{-moz-column-break-inside:avoid;break-inside:avoid}}}ag-grid,ag-grid-angular{display:block}.ag-root-wrapper{border:var(--ag-wrapper-border);border-radius:var(--ag-wrapper-border-radius);display:flex;flex-direction:column;overflow:hidden;position:relative;&.ag-layout-normal{height:100%}}.ag-root-wrapper-body{display:flex;flex-direction:row;&.ag-layout-normal{flex:1 1 auto;height:0;min-height:0}}.ag-root{display:flex;flex-direction:column;position:relative;&.ag-layout-auto-height,&.ag-layout-normal{flex:1 1 auto;overflow:hidden;width:0}&.ag-layout-normal{height:100%}}.ag-virtual-list-item{height:var(--ag-list-item-height);position:absolute;width:100%}.ag-list-item-hovered:after{background-color:var(--ag-accent-color);content:"";height:1px;left:0;position:absolute;right:0}.ag-item-highlight-top:after{top:0}.ag-item-highlight-bottom:after{bottom:0}.ag-drag-handle{color:var(--ag-drag-handle-color);cursor:grab;:where(.ag-icon){color:var(--ag-drag-handle-color)}}.ag-chart-menu-icon,.ag-chart-settings-next,.ag-chart-settings-prev,.ag-column-group-icons,.ag-column-select-header-icon,.ag-filter-toolpanel-expand,.ag-floating-filter-button-button,.ag-group-title-bar-icon,.ag-header-cell-filter-button,.ag-header-cell-menu-button,.ag-header-expand-icon,.ag-panel-title-bar-button,.ag-panel-title-bar-button-icon,.ag-set-filter-group-icons,:where(.ag-group-contracted) .ag-icon,:where(.ag-group-expanded) .ag-icon{background-color:var(--ag-icon-button-background-color);border-radius:var(--ag-icon-button-border-radius);box-shadow:0 0 0 var(--ag-icon-button-background-spread) var(--ag-icon-button-background-color);color:var(--ag-icon-button-color);&:hover{background-color:var(--ag-icon-button-hover-background-color);box-shadow:0 0 0 var(--ag-icon-button-background-spread) var(--ag-icon-button-hover-background-color);color:var(--ag-icon-button-hover-color)}}.ag-filter-active{background-image:linear-gradient(var(--ag-icon-button-active-background-color),var(--ag-icon-button-active-background-color));border-radius:1px;outline:solid var(--ag-icon-button-background-spread) var(--ag-icon-button-active-background-color);position:relative;&:after{background-color:var(--ag-icon-button-active-indicator-color);border-radius:50%;content:"";height:6px;position:absolute;top:-1px;width:6px}:where(.ag-icon-filter){clip-path:path("M8,0C8,4.415 11.585,8 16,8L16,16L0,16L0,0L8,0Z");color:var(--ag-icon-button-active-color)}}:where(.ag-ltr) .ag-filter-active{&:after{right:-1px}}:where(.ag-rtl) .ag-filter-active{&:after{left:-1px}}.ag-menu{background-color:var(--ag-menu-background-color);border:var(--ag-menu-border);border-radius:var(--ag-border-radius);box-shadow:var(--ag-menu-shadow);color:var(--ag-menu-text-color);max-height:100%;overflow-y:auto;position:absolute;-webkit-user-select:none;-moz-user-select:none;user-select:none}'
), I$e = {
  wrapperBorder: !0,
  rowBorder: !0,
  headerRowBorder: !0,
  footerRowBorder: {
    ref: "rowBorder"
  },
  columnBorder: {
    style: "solid",
    width: 1,
    color: "transparent"
  },
  headerColumnBorder: !1,
  headerColumnBorderHeight: "100%",
  pinnedColumnBorder: !0,
  pinnedRowBorder: !0,
  sidePanelBorder: !0,
  sideBarPanelWidth: 250,
  sideBarBackgroundColor: {
    ref: "chromeBackgroundColor"
  },
  sideButtonBarBackgroundColor: {
    ref: "sideBarBackgroundColor"
  },
  sideButtonBarTopPadding: 0,
  sideButtonSelectedUnderlineWidth: 2,
  sideButtonSelectedUnderlineColor: "transparent",
  sideButtonSelectedUnderlineTransitionDuration: 0,
  sideButtonBackgroundColor: "transparent",
  sideButtonTextColor: { ref: "textColor" },
  sideButtonHoverBackgroundColor: { ref: "sideButtonBackgroundColor" },
  sideButtonHoverTextColor: { ref: "sideButtonTextColor" },
  sideButtonSelectedBackgroundColor: po,
  sideButtonSelectedTextColor: { ref: "sideButtonTextColor" },
  sideButtonBorder: "solid 1px transparent",
  sideButtonSelectedBorder: !0,
  sideButtonLeftPadding: { ref: "spacing" },
  sideButtonRightPadding: { ref: "spacing" },
  sideButtonVerticalPadding: { calc: "spacing * 3" },
  headerBackgroundColor: {
    ref: "chromeBackgroundColor"
  },
  headerFontFamily: {
    ref: "fontFamily"
  },
  cellFontFamily: {
    ref: "fontFamily"
  },
  headerFontWeight: 500,
  headerFontSize: {
    ref: "fontSize"
  },
  dataFontSize: {
    ref: "fontSize"
  },
  headerTextColor: {
    ref: "textColor"
  },
  headerCellHoverBackgroundColor: "transparent",
  headerCellMovingBackgroundColor: { ref: "headerCellHoverBackgroundColor" },
  headerCellBackgroundTransitionDuration: "0.2s",
  cellTextColor: {
    ref: "textColor"
  },
  rangeSelectionBorderStyle: "solid",
  rangeSelectionBorderColor: Sn,
  rangeSelectionBackgroundColor: Qo(0.2),
  rangeSelectionChartBackgroundColor: "#0058FF1A",
  rangeSelectionChartCategoryBackgroundColor: "#00FF841A",
  rangeSelectionHighlightColor: Qo(0.5),
  rangeHeaderHighlightColor: yke(0.08),
  rowNumbersSelectedColor: Qo(0.5),
  rowHoverColor: Qo(0.08),
  columnHoverColor: Qo(0.05),
  selectedRowBackgroundColor: Qo(0.12),
  modalOverlayBackgroundColor: {
    ref: "backgroundColor",
    mix: 0.66
  },
  oddRowBackgroundColor: po,
  wrapperBorderRadius: 8,
  cellHorizontalPadding: {
    calc: "spacing * 2 * cellHorizontalPaddingScale"
  },
  cellWidgetSpacing: {
    calc: "spacing * 1.5"
  },
  cellHorizontalPaddingScale: 1,
  rowGroupIndentSize: {
    calc: "cellWidgetSpacing + iconSize"
  },
  valueChangeDeltaUpColor: "#43a047",
  valueChangeDeltaDownColor: "#e53935",
  valueChangeValueHighlightBackgroundColor: "#16a08580",
  rowHeight: {
    calc: "max(iconSize, dataFontSize) + spacing * 3.25 * rowVerticalPaddingScale"
  },
  rowVerticalPaddingScale: 1,
  headerHeight: {
    calc: "max(iconSize, dataFontSize) + spacing * 4 * headerVerticalPaddingScale"
  },
  headerVerticalPaddingScale: 1,
  paginationPanelHeight: {
    ref: "rowHeight",
    calc: "max(rowHeight, 22px)"
  },
  dragHandleColor: xo(0.7),
  headerColumnResizeHandleHeight: "30%",
  headerColumnResizeHandleWidth: 2,
  headerColumnResizeHandleColor: {
    ref: "borderColor"
  },
  widgetContainerHorizontalPadding: {
    calc: "spacing * 1.5"
  },
  widgetContainerVerticalPadding: {
    calc: "spacing * 1.5"
  },
  widgetHorizontalSpacing: {
    calc: "spacing * 1.5"
  },
  widgetVerticalSpacing: {
    ref: "spacing"
  },
  iconButtonColor: { ref: "iconColor" },
  iconButtonBackgroundColor: "transparent",
  iconButtonBackgroundSpread: 4,
  iconButtonBorderRadius: 1,
  iconButtonHoverColor: { ref: "iconButtonColor" },
  iconButtonHoverBackgroundColor: xo(0.1),
  iconButtonActiveColor: Sn,
  iconButtonActiveBackgroundColor: Qo(0.28),
  iconButtonActiveIndicatorColor: Sn,
  menuBorder: {
    color: xo(0.2)
  },
  menuBackgroundColor: Lo(0.03),
  menuTextColor: Lo(0.95),
  menuShadow: {
    ref: "popupShadow"
  },
  menuSeparatorColor: {
    ref: "borderColor"
  },
  setFilterIndentSize: {
    ref: "iconSize"
  },
  chartMenuPanelWidth: 260,
  chartMenuLabelColor: xo(0.8),
  dialogShadow: {
    ref: "popupShadow"
  },
  cellEditingBorder: {
    color: Sn
  },
  cellEditingShadow: { ref: "cardShadow" },
  fullRowEditInvalidBackgroundColor: {
    ref: "invalidColor",
    onto: "backgroundColor",
    mix: 0.25
  },
  dialogBorder: {
    color: xo(0.2)
  },
  panelBackgroundColor: po,
  panelTitleBarBackgroundColor: {
    ref: "headerBackgroundColor"
  },
  panelTitleBarIconColor: {
    ref: "headerTextColor"
  },
  panelTitleBarTextColor: {
    ref: "headerTextColor"
  },
  panelTitleBarFontWeight: {
    ref: "headerFontWeight"
  },
  panelTitleBarBorder: !0,
  columnSelectIndentSize: {
    ref: "iconSize"
  },
  toolPanelSeparatorBorder: !0,
  columnDropCellBackgroundColor: xo(0.07),
  columnDropCellTextColor: {
    ref: "textColor"
  },
  columnDropCellDragHandleColor: {
    ref: "textColor"
  },
  columnDropCellBorder: {
    color: xo(0.13)
  },
  selectCellBackgroundColor: xo(0.07),
  selectCellBorder: {
    color: xo(0.13)
  },
  advancedFilterBuilderButtonBarBorder: !0,
  advancedFilterBuilderIndentSize: {
    calc: "spacing * 2 + iconSize"
  },
  advancedFilterBuilderJoinPillColor: "#f08e8d",
  advancedFilterBuilderColumnPillColor: "#a6e194",
  advancedFilterBuilderOptionPillColor: "#f3c08b",
  advancedFilterBuilderValuePillColor: "#85c0e4",
  filterPanelApplyButtonColor: po,
  filterPanelApplyButtonBackgroundColor: Sn,
  filterPanelCardSubtleColor: {
    ref: "textColor",
    mix: 0.7
  },
  filterPanelCardSubtleHoverColor: { ref: "textColor" },
  findMatchColor: wi,
  findMatchBackgroundColor: "#ffff00",
  findActiveMatchColor: wi,
  findActiveMatchBackgroundColor: "#ffa500",
  filterToolPanelGroupIndent: {
    ref: "spacing"
  },
  rowLoadingSkeletonEffectColor: xo(0.15),
  statusBarLabelColor: wi,
  statusBarLabelFontWeight: 500,
  statusBarValueColor: wi,
  statusBarValueFontWeight: 500,
  pinnedSourceRowTextColor: {
    ref: "textColor"
  },
  pinnedSourceRowBackgroundColor: {
    ref: "backgroundColor"
  },
  pinnedSourceRowFontWeight: 600,
  pinnedRowFontWeight: 600,
  pinnedRowBackgroundColor: {
    ref: "backgroundColor"
  },
  pinnedRowTextColor: {
    ref: "textColor"
  }
}, D$e = (
  /*css*/
  ".ag-cell-batch-edit{background-color:var(--ag-cell-batch-edit-background-color);color:var(--ag-cell-batch-edit-text-color);display:inherit}.ag-row-batch-edit{background-color:var(--ag-row-batch-edit-background-color);color:var(--ag-row-batch-edit-text-color)}"
), ly = {
  cellBatchEditBackgroundColor: "rgba(220 181 139 / 16%)",
  cellBatchEditTextColor: "#422f00",
  rowBatchEditBackgroundColor: {
    ref: "cellBatchEditBackgroundColor"
  },
  rowBatchEditTextColor: {
    ref: "cellBatchEditTextColor"
  }
}, k$e = {
  ...ly,
  cellBatchEditTextColor: "#f3d0b3"
}, H$e = () => To({
  feature: "batchEditStyle",
  params: ly,
  css: D$e
}), V$e = /* @__PURE__ */ H$e(), O$e = (
  /*css*/
  ":where(.ag-button){background:none;border:none;color:inherit;cursor:pointer;font-family:inherit;font-size:inherit;font-weight:inherit;letter-spacing:inherit;line-height:inherit;margin:0;padding:0;text-indent:inherit;text-shadow:inherit;text-transform:inherit;word-spacing:inherit;&:disabled{cursor:default}&:focus-visible{box-shadow:var(--ag-focus-shadow);outline:none}}.ag-standard-button{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:var(--ag-button-background-color);border:var(--ag-button-border);border-radius:var(--ag-button-border-radius);color:var(--ag-button-text-color);cursor:pointer;font-weight:var(--ag-button-font-weight);padding:var(--ag-button-vertical-padding) var(--ag-button-horizontal-padding);&:hover{background-color:var(--ag-button-hover-background-color);border:var(--ag-button-hover-border);color:var(--ag-button-hover-text-color)}&:active{background-color:var(--ag-button-active-background-color);border:var(--ag-button-active-border);color:var(--ag-button-active-text-color)}&:disabled{background-color:var(--ag-button-disabled-background-color);border:var(--ag-button-disabled-border);color:var(--ag-button-disabled-text-color)}}"
), B$e = {
  buttonTextColor: "inherit",
  buttonFontWeight: "normal",
  buttonBackgroundColor: "transparent",
  buttonBorder: !1,
  buttonBorderRadius: { ref: "borderRadius" },
  buttonHorizontalPadding: { calc: "spacing * 2" },
  buttonVerticalPadding: { ref: "spacing" },
  buttonHoverTextColor: { ref: "buttonTextColor" },
  buttonHoverBackgroundColor: { ref: "buttonBackgroundColor" },
  buttonHoverBorder: { ref: "buttonBorder" },
  buttonActiveTextColor: { ref: "buttonHoverTextColor" },
  buttonActiveBackgroundColor: { ref: "buttonHoverBackgroundColor" },
  buttonActiveBorder: { ref: "buttonHoverBorder" },
  buttonDisabledTextColor: { ref: "inputDisabledTextColor" },
  buttonDisabledBackgroundColor: { ref: "inputDisabledBackgroundColor" },
  buttonDisabledBorder: { ref: "inputDisabledBorder" }
}, $$e = () => To({
  feature: "buttonStyle",
  params: {
    ...B$e,
    buttonBackgroundColor: po,
    buttonBorder: !0,
    buttonHoverBackgroundColor: { ref: "rowHoverColor" },
    buttonActiveBorder: { color: Sn }
  },
  css: O$e
}), Z$e = /* @__PURE__ */ $$e(), G$e = (
  /*css*/
  ".ag-column-drop-vertical-empty-message{align-items:center;border:dashed var(--ag-border-width);border-color:var(--ag-border-color);display:flex;inset:0;justify-content:center;margin:calc(var(--ag-spacing)*1.5) calc(var(--ag-spacing)*2);overflow:hidden;padding:calc(var(--ag-spacing)*2);position:absolute}"
), N$e = () => To({
  feature: "columnDropStyle",
  css: G$e
}), ay = /* @__PURE__ */ N$e(), z$e = {
  warn: (...e) => {
    X(e[0], e[1]);
  },
  error: (...e) => {
    qe(e[0], e[1]);
  },
  preInitErr: (...e) => {
    Cr(e[0], e[2], e[1]);
  }
}, j$e = () => Tke(z$e).withParams(I$e).withPart(Z$e).withPart(ay).withPart(V$e), W$e = (
  /*css*/
  '.ag-checkbox-input-wrapper,.ag-radio-button-input-wrapper{background-color:var(--ag-checkbox-unchecked-background-color);border:solid var(--ag-checkbox-border-width) var(--ag-checkbox-unchecked-border-color);flex:none;height:var(--ag-icon-size);position:relative;width:var(--ag-icon-size);:where(input){-webkit-appearance:none;-moz-appearance:none;appearance:none;cursor:pointer;display:block;height:var(--ag-icon-size);margin:0;opacity:0;width:var(--ag-icon-size)}&:after{content:"";display:block;inset:0;-webkit-mask-position:center;mask-position:center;-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat;pointer-events:none;position:absolute}&:where(.ag-checked){background-color:var(--ag-checkbox-checked-background-color);border-color:var(--ag-checkbox-checked-border-color);&:after{background-color:var(--ag-checkbox-checked-shape-color)}}&:where(:focus-within,:active){box-shadow:var(--ag-focus-shadow)}&:where(.ag-disabled){filter:grayscale();opacity:.5}}.ag-checkbox-input-wrapper{border-radius:var(--ag-checkbox-border-radius);&:where(.ag-checked):after{-webkit-mask-image:var(--ag-checkbox-checked-shape-image);mask-image:var(--ag-checkbox-checked-shape-image)}&:where(.ag-indeterminate){background-color:var(--ag-checkbox-indeterminate-background-color);border-color:var(--ag-checkbox-indeterminate-border-color);&:after{background-color:var(--ag-checkbox-indeterminate-shape-color);-webkit-mask-image:var(--ag-checkbox-indeterminate-shape-image);mask-image:var(--ag-checkbox-indeterminate-shape-image)}}}.ag-cell-editing-error .ag-checkbox-input-wrapper:focus-within{box-shadow:var(--ag-focus-error-shadow)}.ag-radio-button-input-wrapper{border-radius:100%;&:where(.ag-checked):after{-webkit-mask-image:var(--ag-radio-checked-shape-image);mask-image:var(--ag-radio-checked-shape-image)}}'
), U$e = () => To({
  feature: "checkboxStyle",
  params: {
    checkboxBorderWidth: 1,
    checkboxBorderRadius: {
      ref: "borderRadius"
    },
    checkboxUncheckedBackgroundColor: po,
    checkboxUncheckedBorderColor: Lo(0.3),
    checkboxCheckedBackgroundColor: Sn,
    checkboxCheckedBorderColor: { ref: "checkboxCheckedBackgroundColor" },
    checkboxCheckedShapeImage: {
      svg: '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="7" fill="none"><path stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.75" d="M1 3.5 3.5 6l5-5"/></svg>'
    },
    checkboxCheckedShapeColor: po,
    checkboxIndeterminateBackgroundColor: Lo(0.3),
    checkboxIndeterminateBorderColor: { ref: "checkboxIndeterminateBackgroundColor" },
    checkboxIndeterminateShapeImage: {
      svg: '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="2" fill="none"><rect width="10" height="2" fill="#000" rx="1"/></svg>'
    },
    checkboxIndeterminateShapeColor: po,
    radioCheckedShapeImage: {
      svg: '<svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" fill="none"><circle cx="3" cy="3" r="3" fill="#000"/></svg>'
    }
  },
  css: W$e
}), K$e = /* @__PURE__ */ U$e(), cy = () => ({
  ...Pl,
  ...k$e,
  backgroundColor: "hsl(217, 0%, 17%)",
  foregroundColor: "#FFF",
  chromeBackgroundColor: Lo(0.05),
  rowHoverColor: Qo(0.15),
  selectedRowBackgroundColor: Qo(0.2),
  menuBackgroundColor: Lo(0.1),
  browserColorScheme: "dark",
  popupShadow: "0 0px 20px #000A",
  cardShadow: "0 1px 4px 1px #000A",
  advancedFilterBuilderJoinPillColor: "#7a3a37",
  advancedFilterBuilderColumnPillColor: "#355f2d",
  advancedFilterBuilderOptionPillColor: "#5a3168",
  advancedFilterBuilderValuePillColor: "#374c86",
  filterPanelApplyButtonColor: wi,
  findMatchColor: po,
  findActiveMatchColor: po,
  checkboxUncheckedBorderColor: Lo(0.4),
  toggleButtonOffBackgroundColor: Lo(0.4),
  rowBatchEditBackgroundColor: Lo(0.1)
}), q$e = () => ({
  ...cy(),
  backgroundColor: "#1f2836"
}), Y$e = () => To({
  feature: "colorScheme",
  params: Pl,
  modeParams: {
    light: Pl,
    dark: cy(),
    "dark-blue": q$e()
  }
}), Q$e = /* @__PURE__ */ Y$e(), J$e = (
  /*css*/
  `.ag-icon-aggregation:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M24 6H8v2l8 8-8 8v2h16v-2H11l8-8-8-8h13z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-arrows:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M7.515 11.171 2.687 16l4.828 4.829-1.414 1.414L-.142 16l6.243-6.243zm16.97 0 1.414-1.414L32.142 16l-6.243 6.243-1.414-1.414L29.313 16zM16.028 13.2l2.829 2.828-2.829 2.829-2.828-2.829zm-4.857 11.285L16 29.313l4.829-4.828 1.414 1.414L16 32.142l-6.243-6.243zm0-16.97L9.757 6.101 16-.142l6.243 6.243-1.414 1.414L16 2.687z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-asc:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m5.333 16 1.88 1.88 7.453-7.44v16.227h2.667V10.44l7.44 7.453L26.666 16 15.999 5.333 5.332 16z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-cancel:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M16 2.667A13.32 13.32 0 0 0 2.667 16c0 7.373 5.96 13.333 13.333 13.333S29.333 23.373 29.333 16 23.373 2.667 16 2.667m6.667 18.12-1.88 1.88L16 17.88l-4.787 4.787-1.88-1.88L14.12 16l-4.787-4.787 1.88-1.88L16 14.12l4.787-4.787 1.88 1.88L17.88 16z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-chart:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Echart%3C/title%3E%3Cg fill='%23000' fill-rule='nonzero'%3E%3Cpath d='M14 7h4v18h-4zM8 17h4v8H8zM20 13h4v12h-4z'/%3E%3C/g%3E%3C/svg%3E")}.ag-icon-color-picker:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M23.907 17.587 10.574 4.254l-1.88 1.88 3.173 3.173-8.28 8.28 10.16 10.16zm-16.547 0 6.387-6.387 6.387 6.387zm18.387 2s-2.667 2.893-2.667 4.667c0 1.467 1.2 2.667 2.667 2.667s2.667-1.2 2.667-2.667c0-1.773-2.667-4.667-2.667-4.667' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-columns:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M26 25H6V7h20zM12 11H8v12h4zm6 0h-4v12h4zm6 12V11h-4v12z' style='fill-rule:nonzero' transform='translate(0 -1)'/%3E%3C/svg%3E")}.ag-icon-contracted:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m12 6 10 10-10 10-2-2 8-8-8-8z'/%3E%3C/svg%3E")}.ag-icon-copy:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M22 1.333H6A2.675 2.675 0 0 0 3.333 4v18.667H6V4h16zm4 5.334H11.333a2.675 2.675 0 0 0-2.667 2.667v18.667c0 1.467 1.2 2.667 2.667 2.667H26c1.467 0 2.667-1.2 2.667-2.667V9.334c0-1.467-1.2-2.667-2.667-2.667M26 28H11.333V9.333H26z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-cross:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M15.984 13.894 27.05 2.828l2.122 2.122-11.066 11.066 11.066 11.066-2.122 2.12-11.066-11.066L4.918 29.202l-2.12-2.12 11.066-11.066L2.798 4.95l2.12-2.122z'/%3E%3C/svg%3E")}.ag-icon-csv:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M384 131.9c-7.753-8.433-110.425-128.473-114.9-133L48-.1C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48zm-35.9 2.1H257V27.9zM30 479V27h200l1 105c0 13.3-1.3 29 12 29h111l1 318z' style='fill-rule:nonzero' transform='translate(3.934 -.054)scale(.06285)'/%3E%3Cpath d='M.688-.226a.2.2 0 0 1-.017.074.28.28 0 0 1-.145.14.412.412 0 0 1-.234.013.28.28 0 0 1-.202-.168.468.468 0 0 1-.04-.19q0-.086.025-.155a.319.319 0 0 1 .182-.191.4.4 0 0 1 .134-.025q.087 0 .155.035a.3.3 0 0 1 .104.085.17.17 0 0 1 .036.097.06.06 0 0 1-.018.044.06.06 0 0 1-.042.019.06.06 0 0 1-.042-.013.2.2 0 0 1-.031-.046.2.2 0 0 0-.066-.079.16.16 0 0 0-.095-.027.17.17 0 0 0-.142.068.3.3 0 0 0-.053.193.4.4 0 0 0 .023.139.2.2 0 0 0 .067.083.2.2 0 0 0 .1.027q.063 0 .106-.031a.2.2 0 0 0 .065-.091.2.2 0 0 1 .023-.046q.014-.018.044-.018a.06.06 0 0 1 .044.018.06.06 0 0 1 .019.045' style='fill-rule:nonzero' transform='matrix(8.39799 0 0 12.455 7.122 25.977)'/%3E%3Cpath d='M.622-.215a.2.2 0 0 1-.033.117.23.23 0 0 1-.098.081.4.4 0 0 1-.153.029.34.34 0 0 1-.175-.04.23.23 0 0 1-.079-.077.17.17 0 0 1-.031-.093q0-.027.019-.045a.06.06 0 0 1 .046-.019.06.06 0 0 1 .039.014.1.1 0 0 1 .027.044.3.3 0 0 0 .03.057q.015.023.044.038.03.015.076.015.065 0 .105-.03a.09.09 0 0 0 .04-.075.08.08 0 0 0-.022-.058.14.14 0 0 0-.056-.034 1 1 0 0 0-.092-.025.7.7 0 0 1-.129-.042.2.2 0 0 1-.083-.066.17.17 0 0 1-.03-.104q0-.058.032-.105a.2.2 0 0 1 .093-.07.4.4 0 0 1 .144-.025q.066 0 .114.016a.3.3 0 0 1 .08.044.2.2 0 0 1 .046.057q.015.03.015.058a.07.07 0 0 1-.018.046.06.06 0 0 1-.046.021q-.025 0-.038-.012a.2.2 0 0 1-.028-.041.2.2 0 0 0-.047-.063Q.387-.625.326-.625a.15.15 0 0 0-.09.025q-.035.024-.035.059 0 .021.012.037a.1.1 0 0 0 .032.027.4.4 0 0 0 .111.036q.06.015.11.031.048.018.083.042a.2.2 0 0 1 .054.062.2.2 0 0 1 .019.091' style='fill-rule:nonzero' transform='matrix(8.39799 0 0 12.455 13.339 25.977)'/%3E%3Cpath d='m.184-.633.162.48.163-.483q.013-.038.019-.053a.062.062 0 0 1 .061-.039q.018 0 .034.009a.1.1 0 0 1 .025.025q.009.015.009.031L.654-.64l-.007.025-.009.024-.173.468-.019.051a.2.2 0 0 1-.021.042.1.1 0 0 1-.033.03.1.1 0 0 1-.049.012.1.1 0 0 1-.05-.011A.1.1 0 0 1 .26-.03a.2.2 0 0 1-.021-.042L.22-.123.05-.587.041-.612.033-.638.03-.662q0-.025.02-.046a.07.07 0 0 1 .05-.02q.037 0 .053.023.015.023.031.072' style='fill-rule:nonzero' transform='matrix(8.39799 0 0 12.455 18.94 25.977)'/%3E%3C/svg%3E")}.ag-icon-cut:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M13.775 15.198 3.835 2.945a1.501 1.501 0 0 1 2.33-1.89l14.997 18.488A6.003 6.003 0 0 1 29.657 25c0 3.311-2.688 6-6 6s-6-2.689-6-6c0-1.335.437-2.569 1.176-3.566l-3.127-3.855-3.001 3.7A5.97 5.97 0 0 1 14 25c0 3.311-2.689 6-6 6s-6-2.689-6-6a6.003 6.003 0 0 1 8.315-5.536zm9.882 6.702a3.1 3.1 0 0 0-3.1 3.1c0 1.711 1.389 3.1 3.1 3.1s3.1-1.389 3.1-3.1-1.389-3.1-3.1-3.1M8 21.95a3.05 3.05 0 1 0 .001 6.101A3.05 3.05 0 0 0 8 21.95m9.63-11.505 1.932 2.381 8.015-9.881a1.5 1.5 0 0 0-2.329-1.89z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-desc:before,.ag-icon-down:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m26.667 16-1.88-1.88-7.453 7.44V5.333h-2.667V21.56l-7.44-7.453L5.334 16l10.667 10.667z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-excel:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M384 131.9c-7.753-8.433-110.425-128.473-114.9-133L48-.1C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48zm-35.9 2.1H257V27.9zM30 479V27h200l1 105c0 13.3-1.3 29 12 29h111l1 318z' style='fill-rule:nonzero' transform='translate(3.934 -.054)scale(.06285)'/%3E%3Cpath d='m.052-.139.16-.234-.135-.208a.4.4 0 0 1-.028-.052.1.1 0 0 1-.01-.042.05.05 0 0 1 .018-.037.07.07 0 0 1 .045-.016q.03 0 .047.018a1 1 0 0 1 .047.066l.107.174.115-.174.024-.038.019-.026.021-.015a.1.1 0 0 1 .027-.005.06.06 0 0 1 .044.016.05.05 0 0 1 .018.039q0 .033-.038.089l-.141.211.152.234a.3.3 0 0 1 .03.051.1.1 0 0 1 .009.038.1.1 0 0 1-.008.031.1.1 0 0 1-.024.023.1.1 0 0 1-.034.008.1.1 0 0 1-.035-.008.1.1 0 0 1-.023-.022L.427-.067.301-.265l-.134.204-.022.034-.016.019a.1.1 0 0 1-.022.015.1.1 0 0 1-.03.005.06.06 0 0 1-.044-.016.06.06 0 0 1-.017-.047q0-.036.036-.088' style='fill-rule:nonzero' transform='matrix(17.82892 0 0 16.50777 10.371 25.928)'/%3E%3C/svg%3E")}.ag-icon-expanded:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M20 26 10 16 20 6l2 2-8 8 8 8z'/%3E%3C/svg%3E")}.ag-icon-eye-slash:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eeye-slash%3C/title%3E%3Cpath fill='%23000' fill-rule='nonzero' d='M8.95 10.364 7 8.414 8.414 7l2.32 2.32A13.2 13.2 0 0 1 16.5 8c5.608 0 10.542 3.515 12.381 8.667L29 17l-.119.333a13 13 0 0 1-4.255 5.879l1.466 1.466-1.414 1.414-1.754-1.753A13.2 13.2 0 0 1 16.5 26c-5.608 0-10.542-3.515-12.381-8.667L4 17l.119-.333a13 13 0 0 1 4.83-6.303m1.445 1.445A11.02 11.02 0 0 0 6.148 17c1.646 4.177 5.728 7 10.352 7 1.76 0 3.441-.409 4.94-1.146l-1.878-1.878A5.06 5.06 0 0 1 16.5 22c-2.789 0-5.05-2.239-5.05-5 0-1.158.398-2.223 1.065-3.07zm1.855-.974 1.794 1.795A5.07 5.07 0 0 1 16.5 12c2.789 0 5.05 2.239 5.05 5 0 .9-.24 1.745-.661 2.474l2.305 2.306A11 11 0 0 0 26.852 17c-1.646-4.177-5.728-7-10.352-7-1.495 0-2.933.295-4.25.835'/%3E%3C/svg%3E")}.ag-icon-eye:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M16.5 23c4.624 0 8.706-2.823 10.352-7-1.646-4.177-5.728-7-10.352-7s-8.706 2.823-10.352 7c1.646 4.177 5.728 7 10.352 7M4.119 15.667C5.958 10.515 10.892 7 16.5 7s10.542 3.515 12.381 8.667L29 16l-.119.333C27.042 21.485 22.108 25 16.5 25S5.958 21.485 4.119 16.333L4 16zM16.5 21c2.789 0 5.049-2.239 5.049-5s-2.26-5-5.049-5-5.049 2.239-5.049 5 2.26 5 5.049 5' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-filter:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m28 8-8 8v5l-6 6V16L6 8V6h22zM9 8l7 7v7l2-2v-5l7-7z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-first:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M24.273 22.12 18.153 16l6.12-6.12L22.393 8l-8 8 8 8zM7.727 8h2.667v16H7.727z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-group:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M14 7v1H9V7zm0-3v1H5.001V4zm-7 7H5v-1h2zm0-3H5V7h2zM3 5H1V4h2zm11 5v1H9v-1zm-7 4H5v-1h2zm7-1v1H9v-1z' style='fill-rule:nonzero' transform='matrix(2 0 0 2 0 -2)'/%3E%3C/svg%3E")}.ag-icon-last:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m7.727 9.88 6.12 6.12-6.12 6.12L9.607 24l8-8-8-8zM21.607 8h2.667v16h-2.667z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-left:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M26.667 14.667H10.44l7.453-7.453L16 5.334 5.333 16.001 16 26.668l1.88-1.88-7.44-7.453h16.227z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-linked:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M5.2 16a4.136 4.136 0 0 1 4.133-4.133h5.333V9.334H9.333a6.67 6.67 0 0 0-6.667 6.667 6.67 6.67 0 0 0 6.667 6.667h5.333v-2.533H9.333A4.136 4.136 0 0 1 5.2 16.002zm5.467 1.333h10.667v-2.667H10.667zm12-8h-5.333v2.533h5.333a4.136 4.136 0 0 1 4.133 4.133 4.136 4.136 0 0 1-4.133 4.133h-5.333v2.533h5.333a6.67 6.67 0 0 0 6.667-6.667 6.67 6.67 0 0 0-6.667-6.667z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-loading:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M17 29h-2v-8h2zm-3.586-9L7 26.414 5.586 25 12 18.586zm13 5L25 26.414 18.586 20 20 18.586zM29 17h-8v-2h8zm-18 0H3v-2h8zm2.414-5L12 13.414 5.586 7 7 5.586zm13-5L20 13.414 18.586 12 25 5.586zM17 11h-2V3h2z' style='fill-rule:nonzero' transform='translate(-3.692 -3.692)scale(1.23077)'/%3E%3C/svg%3E")}.ag-icon-maximize:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M14 30H2V18h2.828v7.05l8.254-8.252 2.12 2.12-8.252 8.254H14zm4-28h12v12h-2.828V6.95l-8.254 8.252-2.12-2.12 8.252-8.254H18z'/%3E%3C/svg%3E")}.ag-icon-menu:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M20 13H0v-2h20zm0-6H0V5h20zm0-6H0v-2h20z' style='fill-rule:nonzero' transform='translate(6 9)'/%3E%3C/svg%3E")}.ag-icon-menu-alt:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='%23000' d='M16 19a3 3 0 1 0 0-6 3 3 0 0 0 0 6M16 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6M16 27a3 3 0 1 0 0-6 3 3 0 0 0 0 6'/%3E%3C/svg%3E")}.ag-icon-minimize:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M2 18h12v12h-2.828v-7.05l-8.254 8.252-2.12-2.12 8.252-8.254H2zm28-4H18V2h2.828v7.05L29.082.798l2.12 2.12-8.252 8.254H30z'/%3E%3C/svg%3E")}.ag-icon-minus:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M6.572 6.572a13.32 13.32 0 0 0 0 18.856 13.32 13.32 0 0 0 18.856 0 13.32 13.32 0 0 0 0-18.856 13.32 13.32 0 0 0-18.856 0m17.527 8.099v2.658H7.901v-2.658z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-next:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M10.94 6 9.06 7.88 17.167 16 9.06 24.12 10.94 26l10-10z' style='fill-rule:nonzero' transform='translate(1)'/%3E%3C/svg%3E")}.ag-icon-none:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Enone%3C/title%3E%3Cg fill='%23000' fill-rule='nonzero'%3E%3Cpath d='M23.708 14.645 16 6.939l-7.708 7.706 1.416 1.416L16 9.767l6.292 6.294zM23.708 20.355 16 28.061l-7.708-7.706 1.416-1.416L16 25.233l6.292-6.294z'/%3E%3C/g%3E%3C/svg%3E")}.ag-icon-not-allowed:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M16 2.667C8.64 2.667 2.667 8.64 2.667 16S8.64 29.333 16 29.333 29.333 23.36 29.333 16 23.36 2.667 16 2.667M5.333 16c0-5.893 4.773-10.667 10.667-10.667 2.467 0 4.733.84 6.533 2.253L7.586 22.533A10.54 10.54 0 0 1 5.333 16M16 26.667c-2.467 0-4.733-.84-6.533-2.253L24.414 9.467A10.54 10.54 0 0 1 26.667 16c0 5.893-4.773 10.667-10.667 10.667' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-paste:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M25.334 4H19.76C19.2 2.453 17.733 1.333 16 1.333S12.8 2.453 12.24 4H6.667A2.675 2.675 0 0 0 4 6.667V28c0 1.467 1.2 2.667 2.667 2.667h18.667c1.467 0 2.667-1.2 2.667-2.667V6.667C28.001 5.2 26.801 4 25.334 4M16 4c.733 0 1.333.6 1.333 1.333s-.6 1.333-1.333 1.333-1.333-.6-1.333-1.333S15.267 4 16 4m9.333 24H6.666V6.667h2.667v4h13.333v-4h2.667z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-pin:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m10.78 19.777-4.668-4.666s.032-1 .67-1.87c1.366-1.86 4.052-1.96 6.056-1.572l3.158-3.108c-.7-2.342 3.352-5.046 3.352-5.046l9.166 9.168q-.334.447-.67.894c-1.074 1.426-2.538 2.63-4.272 2.338l-3.32 3.218c.046.344.042.03.118 1.152.144 2.13-.64 4.324-2.632 5.34l-.746.364-4.798-4.798-7.292 7.294-1.416-1.416zm8.24-13.672c-.688.568-1.416 1.45-1.024 2.072l.49.722-4.986 4.988c-1.988-.506-4.346-.636-5.156.614l9.02 9.032q.14-.099.272-.21c1.226-1.08.764-3.04.498-4.9l4.79-4.79s1.47.938 2.936-.776l-6.79-6.79q-.026.019-.05.038' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-pivot:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M25.128 2.002c2.56.096 4.772 2.292 4.87 4.87a712 712 0 0 1 0 18.256c-.096 2.56-2.292 4.772-4.87 4.87a712 712 0 0 1-18.256 0c-2.558-.096-4.772-2.29-4.87-4.87a712 712 0 0 1 0-18.256c.096-2.56 2.292-4.772 4.87-4.87a712 712 0 0 1 18.256 0m2.966 7.954H9.892v18.136c5.086.13 10.18.098 15.264-.096 1.48-.094 2.746-1.35 2.84-2.84.192-5.064.226-10.134.098-15.2M3.968 24.1q.015.528.036 1.056c.094 1.484 1.354 2.746 2.84 2.84l1.012.036V24.1zM22 15.414l-.292.294-1.416-1.416L23 11.586l2.708 2.706-1.416 1.416-.292-.294v3.592c-.032 2.604-2.246 4.892-4.872 4.992L15.414 24l.294.292-1.416 1.416L11.586 23l2.706-2.708 1.416 1.416-.322.32c3.372.03 6.578-.164 6.614-3.034zM3.88 18.038c.002 1.346.012 2.694.038 4.04h3.938v-4.04zm.05-6.062a681 681 0 0 0-.044 4.042h3.97v-4.042zm5.962-7.99Q8.449 3.999 7.006 4c-1.57.02-2.946 1.348-3.004 2.922q-.02 1.517-.042 3.034h3.896v-2.02h2.036zm14.244-.016v3.966h3.898q-.017-.546-.038-1.092c-.094-1.48-1.35-2.746-2.84-2.84q-.51-.019-1.02-.034m-8.14-.054q-2.035.022-4.07.048v3.972h4.07zm6.106.008a213 213 0 0 0-4.07-.022v4.034h4.07z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-plus:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M6.572 6.572a13.32 13.32 0 0 0 0 18.856 13.32 13.32 0 0 0 18.856 0 13.32 13.32 0 0 0 0-18.856 13.32 13.32 0 0 0-18.856 0m17.527 8.099v2.658h-6.77v6.77h-2.658v-6.77h-6.77v-2.658h6.77v-6.77h2.658v6.77z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-previous:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M21.94 7.88 20.06 6l-10 10 10 10 1.88-1.88L13.833 16z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-right:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m16 5.333-1.88 1.88 7.44 7.453H5.333v2.667H21.56l-7.44 7.453 1.88 1.88 10.667-10.667L16 5.332z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-save:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M15.708 2.355 8 10.061.292 2.355 1.708.939 8 7.233 14.292.939z' style='fill-rule:nonzero' transform='translate(8 14)'/%3E%3Cpath d='M5 26h22v2H5zM15 4h2v18h-2z'/%3E%3C/svg%3E")}.ag-icon-small-down:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M7.334 10.667 16 21.334l8.667-10.667z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-small-left:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M21.333 7.334 10.666 16l10.667 8.667z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-small-right:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M10.667 24.666 21.334 16 10.667 7.333z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-small-up:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M7.334 21.333 16 10.666l8.667 10.667z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-tick:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M11.586 22.96 27.718 6.828 29.84 8.95 11.586 27.202 2.4 18.016l2.12-2.122z'/%3E%3C/svg%3E")}.ag-icon-tree-closed:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m11.94 6-1.88 1.88L18.167 16l-8.107 8.12L11.94 26l10-10z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-tree-indeterminate:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M6 13.5h20v3H6z'/%3E%3C/svg%3E")}.ag-icon-tree-open:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M24.12 9.06 16 17.167 7.88 9.06 6 10.94l10 10 10-10z' style='fill-rule:nonzero' transform='translate(0 1)'/%3E%3C/svg%3E")}.ag-icon-unlinked:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M22.667 9.333h-5.333v2.533h5.333a4.136 4.136 0 0 1 4.133 4.133c0 1.907-1.307 3.507-3.08 3.973l1.947 1.947c2.173-1.107 3.667-3.32 3.667-5.92a6.67 6.67 0 0 0-6.667-6.667zm-1.334 5.334h-2.92l2.667 2.667h.253zM2.667 5.693 6.814 9.84A6.65 6.65 0 0 0 2.667 16a6.67 6.67 0 0 0 6.667 6.667h5.333v-2.533H9.334a4.136 4.136 0 0 1-4.133-4.133c0-2.12 1.613-3.867 3.68-4.093l2.76 2.76h-.973v2.667h3.64l3.027 3.027v2.307h2.307l5.347 5.333 1.68-1.68L4.362 4.002 2.669 5.695z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-up:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m5.333 16 1.88 1.88 7.453-7.44v16.227h2.667V10.44l7.44 7.453L26.666 16 15.999 5.333 5.332 16z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-grip:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M8 24H6v-4h2zm6 0h-2v-4h2zm6 0h-2v-4h2zm6 0h-2v-4h2zM8 18H6v-4h2zm6 0h-2v-4h2zm6 0h-2v-4h2zm6 0h-2v-4h2zM8 12H6V8h2zm6 0h-2V8h2zm6 0h-2V8h2zm6 0h-2V8h2z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-settings:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='%23000' d='M30 8h-4.1c-.5-2.3-2.5-4-4.9-4s-4.4 1.7-4.9 4H2v2h14.1c.5 2.3 2.5 4 4.9 4s4.4-1.7 4.9-4H30zm-9 4c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3M2 24h4.1c.5 2.3 2.5 4 4.9 4s4.4-1.7 4.9-4H30v-2H15.9c-.5-2.3-2.5-4-4.9-4s-4.4 1.7-4.9 4H2zm9-4c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3'/%3E%3C/svg%3E")}.ag-icon-column-arrow:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M11 4a1 1 0 0 1 1 1v22a1 1 0 1 1-2 0V5a1 1 0 0 1 1-1' clip-rule='evenodd'/%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M2 13a1 1 0 0 1 1-1h23.5a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1' clip-rule='evenodd'/%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M2 4h18v24H2zm2 2v20h14V6zM26.793 13 23 9.207l1.414-1.414L29.621 13l-5.207 5.207L23 16.793z' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-un-pin:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='m6.112 15.111 3.272 3.271 1.436-1.402-2.476-2.479c.81-1.25 3.168-1.12 5.156-.614l4.986-4.988-.49-.722c-.392-.622.336-1.504 1.024-2.072l.008-.007.01-.006.032-.025 1.447 1.447 1.432-1.397-2.601-2.602s-4.052 2.704-3.352 5.046l-3.158 3.108c-2.004-.388-4.69-.288-6.056 1.572-.638.87-.67 1.87-.67 1.87m.581 11.582.014.014 5.502-5.501 4.783 4.783.746-.364c1.992-1.016 2.776-3.21 2.632-5.34-.055-.805-.068-.87-.088-.97-.008-.04-.017-.085-.03-.182l3.32-3.218c1.734.292 3.198-.912 4.272-2.338q.337-.447.67-.894l-.001-.001-.007-.007-.007-.007-.007-.007-3.87-3.87 1.585-1.584-1.414-1.414-14.381 14.38-1.237 1.209-5.69 5.687 1.417 1.416zM23.21 10.206l2.65 2.651c-1.465 1.714-2.935.776-2.935.776l-4.79 4.79q.041.291.087.583c.257 1.676.513 3.35-.585 4.317a4 4 0 0 1-.272.21l-3.739-3.744z' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-pinned-top:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' d='m16.708 10.878 8.708 8.706L24 21l-6.292-6.294V27h-2V14.706L9.416 21 8 19.584q4.348-4.344 8.691-8.69zM25 6H8v2h17z'/%3E%3C/svg%3E")}.ag-icon-pinned-bottom:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' d='M16.708 22.122 8 13.416 9.416 12l6.292 6.294V6h2v12.294L24 12l1.416 1.416-8.691 8.69zM7.416 28h17v-2h-17z'/%3E%3C/svg%3E")}.ag-icon-chevron-up:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M3.479 10.521a.75.75 0 0 1 0-1.06l4-4a.75.75 0 0 1 1.06 0l4 4a.75.75 0 0 1-1.06 1.06l-3.47-3.47-3.47 3.47a.75.75 0 0 1-1.06 0' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-chevron-down:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M12.521 5.461a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 0 1 1.06-1.06l3.47 3.47 3.47-3.47a.75.75 0 0 1 1.06 0' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-chevron-left:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M10.53 12.512a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 0 1 0-1.06l4-4a.75.75 0 0 1 1.06 1.06l-3.47 3.47 3.47 3.47a.75.75 0 0 1 0 1.06' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-chevron-right:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M5.47 3.47a.75.75 0 0 1 1.06 0l4 4a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 0 1-1.06-1.06L8.94 8 5.47 4.53a.75.75 0 0 1 0-1.06' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-filter-add:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' d='M19.834 8H8c0 .304.06.612.258.842 2.716 2.854 6.682 5.548 6.742 7.974V21l2-1.5v-2.684c.056-2.267 2.968-4.417 5.49-6.75v3.087c-1.081.974-2.245 1.968-3.232 3.005a1.05 1.05 0 0 0-.258.682v3.66L13 25c0-2.74.066-5.482-.002-8.222a1.05 1.05 0 0 0-.256-.62C10.026 13.304 6.06 10.61 6 8.184V6h13.834z'/%3E%3Cpath fill='currentColor' d='M26 6h2.946v2.002H26v3.313h-2.002V8.002h-2.946V6h2.946V3.04H26z'/%3E%3C/svg%3E")}.ag-icon-edit:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' d='M6.222 25.778h1.611l14.834-14.811-1.611-1.611-14.834 14.81zM4 28v-4.733L22.644 4.656a2.26 2.26 0 0 1 1.567-.634q.423 0 .833.167.412.166.734.478l1.589 1.6q.333.322.483.733t.15.822q0 .423-.161.839-.162.416-.472.728L8.733 28zm17.856-17.833-.8-.811 1.61 1.61z'/%3E%3C/svg%3E")}`
), X$e = /* @__PURE__ */ To({
  feature: "iconSet",
  css: J$e
}), eZe = (e) => {
  const t = [];
  {
    const { icons: o, mask: n } = e;
    for (const s of Object.keys(o)) {
      const i = $2(o[s]);
      n ? t.push(`.ag-icon-${s}::before { mask-image: ${i}; }`) : t.push(`.ag-icon-${s}::before { background-image: ${i}; ${tZe} }`);
    }
  }
  return To({
    css: t.join(`;
`),
    cssImports: e.cssImports
  });
}, tZe = "background-color: unset; mask-image: unset; -webkit-mask-image: unset;", dy = {
  aggregation: '<path d="M18 7V4H6l6 8-6 8h12v-3"/>',
  arrows: '<polyline points="5 9 2 12 5 15"/><polyline points="9 5 12 2 15 5"/><polyline points="15 19 12 22 9 19"/><polyline points="19 9 22 12 19 15"/><line x1="2" x2="22" y1="12" y2="12"/><line x1="12" x2="12" y1="2" y2="22"/>',
  asc: '<path d="m5 12 7-7 7 7"/><path d="M12 19V5"/>',
  cancel: '<path d="m18 6-12 12"/><path d="m6 6 12 12"/>',
  chart: '<line x1="18" x2="18" y1="20" y2="10"/><line x1="12" x2="12" y1="20" y2="4"/><line x1="6" x2="6" y1="20" y2="14"/>',
  "color-picker": '<path d="m19 11-8-8-8.6 8.6a2 2 0 0 0 0 2.8l5.2 5.2c.8.8 2 .8 2.8 0L19 11Z"/><path d="m5 2 5 5"/><path d="M2 13h15"/><path d="M22 20a2 2 0 1 1-4 0c0-1.6 1.7-2.4 2-4 .3 1.6 2 2.4 2 4Z"/>',
  columns: '<path d="M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2V9M9 21H5a2 2 0 0 1-2-2V9m0 0h18"/>',
  contracted: '<path d="m9 18 6-6-6-6"/>',
  copy: '<rect width="14" height="14" x="8" y="8" rx="2" ry="2"/><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"/>',
  cross: '<path d="M18 6 6 18"/><path d="m6 6 12 12"/>',
  csv: '<path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"/><polyline points="14 2 14 8 20 8"/><path d="M8 13h2"/><path d="M8 17h2"/><path d="M14 13h2"/><path d="M14 17h2"/>',
  cut: '<circle cx="6" cy="6" r="3"/><path d="M8.12 8.12 12 12"/><path d="M20 4 8.12 15.88"/><circle cx="6" cy="18" r="3"/><path d="M14.8 14.8 20 20"/>',
  desc: '<path d="M12 5v14"/><path d="m19 12-7 7-7-7"/>',
  down: '<path d="M12 5v14"/><path d="m19 12-7 7-7-7"/>',
  excel: '<path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"/><polyline points="14 2 14 8 20 8"/><path d="M8 13h2"/><path d="M8 17h2"/><path d="M14 13h2"/><path d="M14 17h2"/>',
  expanded: '<path d="m15 18-6-6 6-6"/>',
  "eye-slash": '<path d="M9.88 9.88a3 3 0 1 0 4.24 4.24"/><path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68"/><path d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61"/><line x1="2" x2="22" y1="2" y2="22"/>',
  eye: '<path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"/><circle cx="12" cy="12" r="3"/>',
  filter: '<path d="M3 6h18"/><path d="M7 12h10"/><path d="M10 18h4"/>',
  first: '<path d="m17 18-6-6 6-6"/><path d="M7 6v12"/>',
  group: '<path d="M16 12H3"/><path d="M16 18H3"/><path d="M10 6H3"/><path d="M21 18V8a2 2 0 0 0-2-2h-5"/><path d="m16 8-2-2 2-2"/>',
  last: '<path d="m7 18 6-6-6-6"/><path d="M17 6v12"/>',
  left: '<path d="m12 19-7-7 7-7"/><path d="M19 12H5"/>',
  linked: '<path d="M9 17H7A5 5 0 0 1 7 7h2"/><path d="M15 7h2a5 5 0 1 1 0 10h-2"/><line x1="8" x2="16" y1="12" y2="12"/>',
  loading: '<line x1="12" x2="12" y1="2" y2="6"/><line x1="12" x2="12" y1="18" y2="22"/><line x1="4.93" x2="7.76" y1="4.93" y2="7.76"/><line x1="16.24" x2="19.07" y1="16.24" y2="19.07"/><line x1="2" x2="6" y1="12" y2="12"/><line x1="18" x2="22" y1="12" y2="12"/><line x1="4.93" x2="7.76" y1="19.07" y2="16.24"/><line x1="16.24" x2="19.07" y1="7.76" y2="4.93"/>',
  maximize: '<polyline points="15 3 21 3 21 9"/><polyline points="9 21 3 21 3 15"/><line x1="21" x2="14" y1="3" y2="10"/><line x1="3" x2="10" y1="21" y2="14"/>',
  menu: '<line x1="4" x2="20" y1="12" y2="12"/><line x1="4" x2="20" y1="6" y2="6"/><line x1="4" x2="20" y1="18" y2="18"/>',
  "menu-alt": '<circle cx="12" cy="5" r="0.75" fill="#D9D9D9"/><circle cx="12" cy="12" r="0.75" fill="#D9D9D9"/><circle cx="12" cy="19" r="0.75" fill="#D9D9D9"/>',
  minimize: '<polyline points="4 14 10 14 10 20"/><polyline points="20 10 14 10 14 4"/><line x1="14" x2="21" y1="10" y2="3"/><line x1="3" x2="10" y1="21" y2="14"/>',
  minus: '<circle cx="12" cy="12" r="10"/><path d="M8 12h8"/>',
  next: '<path d="m9 18 6-6-6-6"/>',
  none: '<path d="m7 15 5 5 5-5"/><path d="m7 9 5-5 5 5"/>',
  "not-allowed": '<circle cx="12" cy="12" r="10"/><path d="m4.9 4.9 14.2 14.2"/>',
  paste: '<path d="M15 2H9a1 1 0 0 0-1 1v2c0 .6.4 1 1 1h6c.6 0 1-.4 1-1V3c0-.6-.4-1-1-1Z"/><path d="M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2M16 4h2a2 2 0 0 1 2 2v2M11 14h10"/><path d="m17 10 4 4-4 4"/>',
  pin: '<line x1="12" x2="12" y1="17" y2="22"/><path d="M5 17h14v-1.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V6h1a2 2 0 0 0 0-4H8a2 2 0 0 0 0 4h1v4.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24Z"/>',
  pivot: '<path d="M15 3v18"/><rect width="18" height="18" x="3" y="3" rx="2"/><path d="M21 9H3"/><path d="M21 15H3"/>',
  plus: '<circle cx="12" cy="12" r="10"/><path d="M8 12h8"/><path d="M12 8v8"/>',
  previous: '<path d="m15 18-6-6 6-6"/>',
  right: '<path d="M5 12h14"/><path d="m12 5 7 7-7 7"/>',
  save: '<path d="M12 17V3"/><path d="m6 11 6 6 6-6"/><path d="M19 21H5"/>',
  "small-left": '<path d="m15 18-6-6 6-6"/>',
  "small-right": '<path d="m9 18 6-6-6-6"/>',
  tick: '<path d="M20 6 9 17l-5-5"/>',
  "tree-closed": '<path d="m9 18 6-6-6-6"/>',
  "tree-indeterminate": '<path d="M5 12h14"/>',
  "tree-open": '<path d="m6 9 6 6 6-6"/>',
  unlinked: '<path d="M9 17H7A5 5 0 0 1 7 7"/><path d="M15 7h2a5 5 0 0 1 4 8"/><line x1="8" x2="12" y1="12" y2="12"/><line x1="2" x2="22" y1="2" y2="22"/>',
  up: '<path d="m5 12 7-7 7 7"/><path d="M12 19V5"/>',
  grip: '<circle cx="5" cy="8" r="0.5"/><circle cx="12" cy="8" r="0.5"/><circle cx="19" cy="8" r="0.5"/><circle cx="5" cy="16" r="0.5"/><circle cx="12" cy="16" r="0.5"/><circle cx="19" cy="16" r="0.5"/><g stroke="none" fill="currentColor"><circle cx="5" cy="8" r="1"/><circle cx="12" cy="8" r="1"/><circle cx="19" cy="8" r="1"/><circle cx="5" cy="16" r="1"/><circle cx="12" cy="16" r="1"/><circle cx="19" cy="16" r="1"/></g>',
  settings: '<path d="M20 7h-9"/><path d="M14 17H5"/><circle cx="17" cy="17" r="3"/><circle cx="7" cy="7" r="3"/>'
}, uy = {
  "column-arrow": '<svg xmlns="http://www.w3.org/2000/svg" class="ag-icon" fill="none" viewBox="0 0 32 32"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 26C0 28.2092 1.79086 30 4 30H14C16.2091 30 18 28.2092 18 26V15H25.8786L24.4394 16.4393C23.8536 17.0251 23.8536 17.9749 24.4394 18.5607C25.0252 19.1464 25.9748 19.1464 26.5606 18.5607L30.5606 14.5607C31.1464 13.9749 31.1464 13.0251 30.5606 12.4393L26.5606 8.43934C25.9748 7.85356 25.0252 7.85356 24.4394 8.43934C23.8536 9.02512 23.8536 9.97488 24.4394 10.5607L25.8786 12H18V6C18 3.79086 16.2091 2 14 2H4C1.79086 2 0 3.79086 0 6V26ZM14 5H10.5V12H15V6C15 5.44772 14.5523 5 14 5ZM4 5H7.5V12H3V6C3 5.44772 3.44772 5 4 5ZM10.5 15H15V26C15 26.5522 14.5523 27 14 27H10.5V15ZM4 27H7.5V15H3V26C3 26.5522 3.44772 27 4 27Z" fill="currentColor"/></svg>',
  "small-down": '<svg xmlns="http://www.w3.org/2000/svg" class="ag-icon" fill="black" stroke="none" viewBox="0 0 32 32"><path d="M7.334 10.667 16 21.334l8.667-10.667H7.334Z"/></svg>',
  "small-up": '<svg xmlns="http://www.w3.org/2000/svg" class="ag-icon" fill="black" stroke="none" viewBox="0 0 32 32"><path d="M7.334 21.333 16 10.666l8.667 10.667H7.334Z"/></svg>',
  "pinned-top": '<svg xmlns="http://www.w3.org/2000/svg" class="ag-icon" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M12.53 3.72A.75.75 0 0 1 12 5H4a.75.75 0 0 1 0-1.5h8a.75.75 0 0 1 .53.22ZM3.269 10.744a.75.75 0 0 1 .2-.524l4-4a.75.75 0 0 1 1.06 0l4 4a.75.75 0 1 1-1.06 1.06L8.75 8.56V14a.75.75 0 0 1-1.5 0V8.56l-2.72 2.72a.75.75 0 0 1-1.26-.536Z"/></svg>',
  "pinned-bottom": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="ag-icon" viewBox="0 0 16 16"><path fill="currentColor" d="M3.47 12.28A.75.75 0 0 1 4 11h8a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.53-.22ZM12.731 5.256a.75.75 0 0 1-.2.524l-4 4a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 1 1 1.06-1.06l2.72 2.72V2a.75.75 0 0 1 1.5 0v5.44l2.72-2.72a.75.75 0 0 1 1.26.536Z"/></svg>',
  "un-pin": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="ag-icon" viewBox="0 0 16 16"><path fill="currentColor" d="M8 11a.75.75 0 0 0-.75.75v3.333a.75.75 0 1 0 1.5 0V11.75A.75.75 0 0 0 8 11Z"/><path fill="currentColor" d="M13.11 1.436a.75.75 0 0 0-1.22-.872l-10 14a.75.75 0 1 0 1.22.872L5.207 12.5h7.376a.75.75 0 0 0 .75-.75v-1.174a2.08 2.08 0 0 0-1.153-1.863l-1.185-.599-.005-.002a.58.58 0 0 1-.323-.522V5.165a2.083 2.083 0 0 0 1.854-2.904l.589-.825Zm-3.943 5.52v.634a2.08 2.08 0 0 0 1.153 1.863l1.185.6.005.002a.58.58 0 0 1 .323.522V11H6.28l2.887-4.044ZM9.277 1H5.25a2.084 2.084 0 0 0-.083 4.165v1.676l1.5-2.132v-.292a.75.75 0 0 0-.75-.75H5.25a.584.584 0 0 1 0-1.167h2.972L9.277 1Z"/></svg>',
  "chevron-down": '<svg width="16" height="16" viewBox="0 0 16 16" class="ag-icon" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 6L8 10L4 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  "chevron-up": '<svg width="16" height="16" viewBox="0 0 16 16" class="ag-icon" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 10L8 6L12 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  "chevron-left": '<svg width="16" height="16" viewBox="0 0 16 16" class="ag-icon" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 12L6 8L10 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  "chevron-right": '<svg width="16" height="16" viewBox="0 0 16 16" class="ag-icon" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  "filter-add": '<svg width="16" height="16" viewBox="0 0 16 16" class="ag-icon" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.12126 7.75L10.8517 7.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><path d="M6.65934 11.748L9.32778 11.748" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><path d="M12.2943 1.04872V6.19184M14.9886 3.74341H9.68478" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><path d="M8.25488 3C8.04799 3.18323 7.91706 3.45099 7.91699 3.74902C7.91713 4.04868 8.04988 4.31681 8.25879 4.5H2C1.58579 4.5 1.25 4.16421 1.25 3.75C1.25 3.33579 1.58579 3 2 3H8.25488Z" fill="currentColor"/></svg>',
  edit: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.5 10.6262V12.5012H5.375L10.905 6.97122L9.03 5.09622L3.5 10.6262ZM12.355 5.52122C12.4014 5.47497 12.4381 5.42002 12.4632 5.35953C12.4883 5.29905 12.5012 5.23421 12.5012 5.16872C12.5012 5.10324 12.4883 5.0384 12.4632 4.97791C12.4381 4.91742 12.4014 4.86248 12.355 4.81622L11.185 3.64622C11.1387 3.59987 11.0838 3.5631 11.0233 3.53801C10.9628 3.51291 10.898 3.5 10.8325 3.5C10.767 3.5 10.7022 3.51291 10.6417 3.53801C10.5812 3.5631 10.5263 3.59987 10.48 3.64622L9.565 4.56122L11.44 6.43622L12.355 5.52122Z" fill="currentColor"/></svg>'
}, oZe = (e = {}) => {
  let t = "";
  for (const o of [...Object.keys(dy), ...Object.keys(uy)]) {
    const n = nZe(o, e.strokeWidth);
    t += `.ag-icon-${o}::before { mask-image: url('data:image/svg+xml,${encodeURIComponent(n)}'); }
`;
  }
  return t;
}, nZe = (e, t = 1.5) => {
  const o = uy[e];
  if (o)
    return o;
  const n = dy[e];
  if (!n)
    throw new Error(`Missing icon data for ${e}`);
  return `<svg xmlns="http://www.w3.org/2000/svg" class="ag-icon" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke="black" stroke-width="${t}" viewBox="0 0 24 24"><style>* { vector-effect: non-scaling-stroke; }</style>` + n + "</svg>";
}, sZe = (e = {}) => To({
  feature: "iconSet",
  css: () => oZe(e)
}), iZe = /* @__PURE__ */ sZe(), rZe = (
  /*css*/
  ':where(.ag-input-field-input[type=number]:not(.ag-number-field-input-stepper)){-webkit-appearance:textfield;-moz-appearance:textfield;appearance:textfield;&::-webkit-inner-spin-button,&::-webkit-outer-spin-button{-webkit-appearance:none;appearance:none;margin:0}}.ag-input-field-input:where(input:not([type]),input[type=text],input[type=number],input[type=tel],input[type=date],input[type=datetime-local],textarea){background-color:var(--ag-input-background-color);border:var(--ag-input-border);border-radius:var(--ag-input-border-radius);color:var(--ag-input-text-color);font-family:inherit;font-size:inherit;line-height:inherit;margin:0;min-height:var(--ag-input-height);padding:0;&:where(:disabled){background-color:var(--ag-input-disabled-background-color);border:var(--ag-input-disabled-border);color:var(--ag-input-disabled-text-color)}&:where(:focus){background-color:var(--ag-input-focus-background-color);border:var(--ag-input-focus-border);box-shadow:var(--ag-input-focus-shadow);color:var(--ag-input-focus-text-color);outline:none}&:where(:invalid){background-color:var(--ag-input-invalid-background-color);border:var(--ag-input-invalid-border);color:var(--ag-input-invalid-text-color)}&:where(.invalid){background-color:var(--ag-input-invalid-background-color);border:var(--ag-input-invalid-border);color:var(--ag-input-invalid-text-color)}&::-moz-placeholder{color:var(--ag-input-placeholder-text-color)}&::placeholder{color:var(--ag-input-placeholder-text-color)}}:where(.ag-ltr) .ag-input-field-input:where(input:not([type]),input[type=text],input[type=number],input[type=tel],input[type=date],input[type=datetime-local],textarea){padding-left:var(--ag-input-padding-start)}:where(.ag-rtl) .ag-input-field-input:where(input:not([type]),input[type=text],input[type=number],input[type=tel],input[type=date],input[type=datetime-local],textarea){padding-right:var(--ag-input-padding-start)}:where(.ag-column-select-header-filter-wrapper,.ag-filter-toolpanel-search,.ag-mini-filter,.ag-filter-filter,.ag-filter-add-select){.ag-input-wrapper:before{background-color:currentcolor;color:var(--ag-input-icon-color);content:"";display:block;height:12px;-webkit-mask-image:url("data:image/svg+xml;charset=utf-8;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMS41Ij48cGF0aCBkPSJNNS4zIDlhMy43IDMuNyAwIDEgMCAwLTcuNSAzLjcgMy43IDAgMCAwIDAgNy41Wk0xMC41IDEwLjUgOC4zIDguMiIvPjwvc3ZnPg==");mask-image:url("data:image/svg+xml;charset=utf-8;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMS41Ij48cGF0aCBkPSJNNS4zIDlhMy43IDMuNyAwIDEgMCAwLTcuNSAzLjcgMy43IDAgMCAwIDAgNy41Wk0xMC41IDEwLjUgOC4zIDguMiIvPjwvc3ZnPg==");-webkit-mask-position:center;mask-position:center;-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat;opacity:.5;position:absolute;width:12px}}:where(.ag-ltr) :where(.ag-column-select-header-filter-wrapper,.ag-filter-toolpanel-search,.ag-mini-filter,.ag-filter-filter,.ag-filter-add-select){.ag-input-wrapper:before{margin-left:var(--ag-spacing)}.ag-number-field-input,.ag-text-field-input{padding-left:calc(var(--ag-spacing)*1.5 + 12px)}}:where(.ag-rtl) :where(.ag-column-select-header-filter-wrapper,.ag-filter-toolpanel-search,.ag-mini-filter,.ag-filter-filter,.ag-filter-add-select){.ag-input-wrapper:before{margin-right:var(--ag-spacing)}.ag-number-field-input,.ag-text-field-input{padding-right:calc(var(--ag-spacing)*1.5 + 12px)}}'
), lZe = (
  /*css*/
  ".ag-input-field-input:where(input:not([type]),input[type=text],input[type=number],input[type=tel],input[type=date],input[type=datetime-local],textarea){&:focus{box-shadow:var(--ag-focus-shadow);&:where(.invalid),&:where(:invalid){box-shadow:var(--ag-focus-error-shadow)}}}"
), aZe = {
  inputBackgroundColor: "transparent",
  inputBorder: !1,
  inputBorderRadius: 0,
  inputTextColor: {
    ref: "textColor"
  },
  inputPlaceholderTextColor: {
    ref: "inputTextColor",
    mix: 0.5
  },
  inputPaddingStart: 0,
  inputHeight: {
    calc: "max(iconSize, fontSize) + spacing * 2"
  },
  inputFocusBackgroundColor: {
    ref: "inputBackgroundColor"
  },
  inputFocusBorder: {
    ref: "inputBorder"
  },
  inputFocusShadow: "none",
  inputFocusTextColor: {
    ref: "inputTextColor"
  },
  inputDisabledBackgroundColor: {
    ref: "inputBackgroundColor"
  },
  inputDisabledBorder: {
    ref: "inputBorder"
  },
  inputDisabledTextColor: {
    ref: "inputTextColor"
  },
  inputInvalidBackgroundColor: {
    ref: "inputBackgroundColor"
  },
  inputInvalidBorder: {
    ref: "inputBorder"
  },
  inputInvalidTextColor: {
    ref: "inputTextColor"
  },
  inputIconColor: {
    ref: "inputTextColor"
  },
  pickerButtonBorder: !1,
  pickerButtonFocusBorder: { ref: "inputFocusBorder" },
  pickerButtonBackgroundColor: { ref: "backgroundColor" },
  pickerButtonFocusBackgroundColor: { ref: "backgroundColor" },
  pickerListBorder: !1,
  pickerListBackgroundColor: { ref: "backgroundColor" },
  colorPickerThumbSize: 18,
  colorPickerTrackSize: 12,
  colorPickerThumbBorderWidth: 3,
  colorPickerTrackBorderRadius: 12,
  colorPickerColorBorderRadius: 4
}, cZe = () => To({
  feature: "inputStyle",
  params: {
    ...aZe,
    inputBackgroundColor: po,
    inputBorder: !0,
    inputBorderRadius: {
      ref: "borderRadius"
    },
    inputPaddingStart: {
      ref: "spacing"
    },
    inputFocusBorder: {
      color: Sn
    },
    inputFocusShadow: {
      ref: "focusShadow"
    },
    inputDisabledBackgroundColor: Lo(0.06),
    inputDisabledTextColor: {
      ref: "textColor",
      mix: 0.5
    },
    inputInvalidBorder: {
      color: { ref: "invalidColor" }
    },
    pickerButtonBorder: !0,
    pickerListBorder: !0
  },
  css: () => rZe + lZe
}), dZe = /* @__PURE__ */ cZe(), uZe = (
  /*css*/
  '.ag-tabs-header{background-color:var(--ag-tab-bar-background-color);border-bottom:var(--ag-tab-bar-border);display:flex;flex:1;gap:var(--ag-tab-spacing);padding:var(--ag-tab-bar-top-padding) var(--ag-tab-bar-horizontal-padding) 0}.ag-tabs-header-wrapper{display:flex}.ag-tabs-close-button-wrapper{align-items:center;border:0;display:flex;padding:var(--ag-spacing)}:where(.ag-ltr) .ag-tabs-close-button-wrapper{border-right:solid var(--ag-border-width) var(--ag-border-color)}:where(.ag-rtl) .ag-tabs-close-button-wrapper{border-left:solid var(--ag-border-width) var(--ag-border-color)}.ag-tabs-close-button{background-color:unset;border:0;cursor:pointer;padding:0}.ag-tab{align-items:center;background-color:var(--ag-tab-background-color);border-left:var(--ag-tab-selected-border-width) solid transparent;border-right:var(--ag-tab-selected-border-width) solid transparent;color:var(--ag-tab-text-color);cursor:pointer;display:flex;flex:1;justify-content:center;padding:var(--ag-tab-top-padding) var(--ag-tab-horizontal-padding) var(--ag-tab-bottom-padding);position:relative;&:hover{background-color:var(--ag-tab-hover-background-color);color:var(--ag-tab-hover-text-color)}&.ag-tab-selected{background-color:var(--ag-tab-selected-background-color);color:var(--ag-tab-selected-text-color)}&:after{background-color:var(--ag-tab-selected-underline-color);bottom:0;content:"";display:block;height:var(--ag-tab-selected-underline-width);left:0;opacity:0;position:absolute;right:0;transition:opacity var(--ag-tab-selected-underline-transition-duration)}&.ag-tab-selected:after{opacity:1}}:where(.ag-ltr) .ag-tab{&.ag-tab-selected{&:where(:not(:first-of-type)){border-left-color:var(--ag-tab-selected-border-color)}&:where(:not(:last-of-type)){border-right-color:var(--ag-tab-selected-border-color)}}}:where(.ag-rtl) .ag-tab{&.ag-tab-selected{&:where(:not(:first-of-type)){border-right-color:var(--ag-tab-selected-border-color)}&:where(:not(:last-of-type)){border-left-color:var(--ag-tab-selected-border-color)}}}'
), hZe = {
  tabBarBackgroundColor: "transparent",
  tabBarHorizontalPadding: 0,
  tabBarTopPadding: 0,
  tabBackgroundColor: "transparent",
  tabTextColor: {
    ref: "textColor"
  },
  tabHorizontalPadding: {
    ref: "spacing"
  },
  tabTopPadding: {
    ref: "spacing"
  },
  tabBottomPadding: {
    ref: "spacing"
  },
  tabSpacing: "0",
  tabHoverBackgroundColor: {
    ref: "tabBackgroundColor"
  },
  tabHoverTextColor: {
    ref: "tabTextColor"
  },
  tabSelectedBackgroundColor: {
    ref: "tabBackgroundColor"
  },
  tabSelectedTextColor: {
    ref: "tabTextColor"
  },
  tabSelectedBorderWidth: { ref: "borderWidth" },
  tabSelectedBorderColor: "transparent",
  tabSelectedUnderlineColor: "transparent",
  tabSelectedUnderlineWidth: 0,
  tabSelectedUnderlineTransitionDuration: 0,
  tabBarBorder: !1
}, gZe = () => To({
  feature: "tabStyle",
  params: {
    ...hZe,
    tabBarBorder: !0,
    tabBarBackgroundColor: xo(0.05),
    tabTextColor: {
      ref: "textColor",
      mix: 0.7
    },
    tabSelectedTextColor: {
      ref: "textColor"
    },
    tabHoverTextColor: {
      ref: "textColor"
    },
    tabSelectedBorderColor: {
      ref: "borderColor"
    },
    tabSelectedBackgroundColor: po
  },
  css: uZe
}), pZe = /* @__PURE__ */ gZe(), fZe = () => j$e().withPart(K$e).withPart(Q$e).withPart(iZe).withPart(pZe).withPart(dZe).withPart(ay).withParams({
  fontFamily: [
    { googleFont: "IBM Plex Sans" },
    "-apple-system",
    "BlinkMacSystemFont",
    "Segoe UI",
    "Roboto",
    "Oxygen-Sans",
    "Ubuntu"
  ]
}), hy = /* @__PURE__ */ fZe(), vZe = {
  cssName: "--ag-cell-horizontal-padding",
  changeKey: "cellHorizontalPaddingChanged",
  defaultValue: 16
}, mZe = {
  cssName: "--ag-indentation-level",
  changeKey: "indentationLevelChanged",
  defaultValue: 0,
  noWarn: !0,
  cacheDefault: !0
}, CZe = {
  cssName: "--ag-row-group-indent-size",
  changeKey: "rowGroupIndentSizeChanged",
  defaultValue: 0
}, uu = {
  cssName: "--ag-row-height",
  changeKey: "rowHeightChanged",
  defaultValue: 42
}, hu = {
  cssName: "--ag-header-height",
  changeKey: "headerHeightChanged",
  defaultValue: 48
}, gu = {
  cssName: "--ag-list-item-height",
  changeKey: "listItemHeightChanged",
  defaultValue: 24
}, m0 = {
  cssName: "--ag-row-border",
  changeKey: "rowBorderWidthChanged",
  defaultValue: 1,
  border: !0
}, pu = {
  cssName: "--ag-pinned-row-border",
  changeKey: "pinnedRowBorderWidthChanged",
  defaultValue: 1,
  border: !0
};
function wZe(e, t) {
  t.sort((o, n) => o.moduleName.localeCompare(n.moduleName)).forEach((o) => {
    const n = o.css;
    n && e.set(`module-${o.moduleName}`, n);
  });
}
var bZe = class extends Zke {
  constructor() {
    super(...arguments), this.sizeEls = /* @__PURE__ */ new Map(), this.lastKnownValues = /* @__PURE__ */ new Map(), this.sizesMeasured = !1;
  }
  initVariables() {
    this.addManagedPropertyListener("rowHeight", () => this.refreshRowHeightVariable()), this.getSizeEl(uu), this.getSizeEl(hu), this.getSizeEl(gu), this.getSizeEl(m0), this.getSizeEl(pu), this.refreshRowBorderWidthVariable();
  }
  getPinnedRowBorderWidth() {
    return this.getCSSVariablePixelValue(pu);
  }
  getRowBorderWidth() {
    return this.getCSSVariablePixelValue(m0);
  }
  getDefaultRowHeight() {
    return this.getCSSVariablePixelValue(uu);
  }
  getDefaultHeaderHeight() {
    return this.getCSSVariablePixelValue(hu);
  }
  getDefaultCellHorizontalPadding() {
    return this.getCSSVariablePixelValue(vZe);
  }
  getCellPaddingLeft() {
    const e = this.getDefaultCellHorizontalPadding(), t = this.getCSSVariablePixelValue(mZe), o = this.getCSSVariablePixelValue(CZe);
    return e - 1 + o * t;
  }
  getCellPadding() {
    const e = this.getDefaultCellHorizontalPadding() - 1;
    return this.getCellPaddingLeft() + e;
  }
  getDefaultColumnMinWidth() {
    return Math.min(36, this.getDefaultRowHeight());
  }
  getDefaultListItemHeight() {
    return this.getCSSVariablePixelValue(gu);
  }
  refreshRowHeightVariable() {
    const { eRootDiv: e } = this, t = e.style.getPropertyValue("--ag-line-height").trim(), o = this.gos.get("rowHeight");
    if (o == null || isNaN(o) || !isFinite(o))
      return t !== null && e.style.setProperty("--ag-line-height", null), -1;
    const n = `${o}px`;
    return t != n ? (e.style.setProperty("--ag-line-height", n), o) : t != "" ? parseFloat(t) : -1;
  }
  getCSSVariablePixelValue(e) {
    const t = this.lastKnownValues.get(e);
    if (t != null)
      return t;
    const o = this.measureSizeEl(e);
    return o === "detached" || o === "no-styles" ? (e.cacheDefault && this.lastKnownValues.set(e, e.defaultValue), e.defaultValue) : (this.lastKnownValues.set(e, o), o);
  }
  measureSizeEl(e) {
    const t = this.getSizeEl(e);
    if (t.offsetParent == null)
      return "detached";
    const o = t.offsetWidth;
    return o === C0 ? "no-styles" : (this.sizesMeasured = !0, o);
  }
  getMeasurementContainer() {
    let e = this.eMeasurementContainer;
    return e || (e = this.eMeasurementContainer = ze({ tag: "div", cls: "ag-measurement-container" }), this.eRootDiv.appendChild(e)), e;
  }
  getSizeEl(e) {
    let t = this.sizeEls.get(e);
    if (t)
      return t;
    const o = this.getMeasurementContainer();
    t = ze({ tag: "div" });
    const { border: n, noWarn: s } = e;
    n ? (t.className = "ag-measurement-element-border", t.style.setProperty(
      "--ag-internal-measurement-border",
      `var(${e.cssName}, solid ${C0}px)`
    )) : t.style.width = `var(${e.cssName}, ${C0}px)`, o.appendChild(t), this.sizeEls.set(e, t);
    let i = this.measureSizeEl(e);
    i === "no-styles" && !s && X(9, { variable: e });
    const r = mn(this.beans, t, () => {
      const l = this.measureSizeEl(e);
      l === "detached" || l === "no-styles" || (this.lastKnownValues.set(e, l), l !== i && (i = l, this.fireStylesChangedEvent(e.changeKey)));
    });
    return this.addDestroyFunc(() => r()), t;
  }
  fireStylesChangedEvent(e) {
    e === "rowBorderWidthChanged" && this.refreshRowBorderWidthVariable(), this.eventSvc.dispatchEvent({
      type: "gridStylesChanged",
      [e]: !0
    });
  }
  refreshRowBorderWidthVariable() {
    const e = this.getCSSVariablePixelValue(m0);
    this.eRootDiv.style.setProperty("--ag-internal-row-border-width", `${e}px`);
  }
  postProcessThemeChange(e, t) {
    e && getComputedStyle(this.getMeasurementContainer()).getPropertyValue("--ag-legacy-styles-loaded") && qe(t ? 106 : 239);
  }
  getAdditionalCss() {
    const e = /* @__PURE__ */ new Map();
    return e.set("core", [T$e]), wZe(e, Array.from(E$e())), e;
  }
  getDefaultTheme() {
    return hy;
  }
  themeError(e) {
    qe(240, { theme: e });
  }
}, C0 = 15538, yZe = class extends Nke {
  postConstruct() {
    const { globalListener: e, globalSyncListener: t } = this.beans;
    e && this.addGlobalListener(e, !0), t && this.addGlobalListener(t, !1);
  }
};
function gy(e, t, o) {
  const n = e.visibleCols.headerGroupRowCount;
  if (o >= n)
    return {
      column: t,
      headerRowIndex: o
    };
  let s = t.getParent();
  for (; s && s.getProvidedColumnGroup().getLevel() > o; )
    s = s.getParent();
  const i = t.isSpanHeaderHeight();
  return !s || i && s.isPadding() ? {
    column: t,
    headerRowIndex: n
  } : {
    column: s,
    headerRowIndex: s.getProvidedColumnGroup().getLevel()
  };
}
var _Ze = class extends K {
  constructor() {
    super(...arguments), this.beanName = "headerNavigation", this.currentHeaderRowWithoutSpan = -1;
  }
  postConstruct() {
    const e = this.beans;
    e.ctrlsSvc.whenReady(this, (o) => {
      this.gridBodyCon = o.gridBodyCtrl;
    });
    const t = Pt(e);
    this.addManagedElementListeners(t, {
      mousedown: () => {
        this.currentHeaderRowWithoutSpan = -1;
      }
    });
  }
  getHeaderPositionForColumn(e, t) {
    let o;
    const { colModel: n, colGroupSvc: s, ctrlsSvc: i } = this.beans;
    if (typeof e == "string" ? (o = n.getCol(e), o || (o = (s == null ? void 0 : s.getColumnGroup(e)) ?? null)) : o = e, !o)
      return null;
    const r = i.getHeaderRowContainerCtrl(), l = r == null ? void 0 : r.getAllCtrls(), a = Ke(l || []).type === "filter", c = nn(this.beans) - 1;
    let d = -1, u = o;
    for (; u; )
      d++, u = u.getParent();
    let h = d;
    return t && a && h === c - 1 && h++, h === -1 ? null : {
      headerRowIndex: h,
      column: o
    };
  }
  /*
   * This method navigates grid header vertically
   * @return {boolean} true to preventDefault on the event that caused this navigation.
   */
  navigateVertically(e, t) {
    const { focusSvc: o, visibleCols: n } = this.beans, { focusedHeader: s } = o;
    if (!s)
      return !1;
    const { headerRowIndex: i } = s, r = s.column, l = nn(this.beans), a = this.getHeaderRowType(i), c = n.headerGroupRowCount;
    let {
      headerRowIndex: d,
      column: u,
      headerRowIndexWithoutSpan: h
    } = e === "UP" ? SZe(a, r, i) : xZe(r, i, c), p = !1;
    return d < 0 && (d = 0, u = r, p = !0), d >= l ? (d = -1, this.currentHeaderRowWithoutSpan = -1) : h !== void 0 && (this.currentHeaderRowWithoutSpan = h), !p && !u ? !1 : o.focusHeaderPosition({
      headerPosition: { headerRowIndex: d, column: u },
      allowUserOverride: !0,
      event: t
    });
  }
  /*
   * This method navigates grid header horizontally
   * @returns {boolean} true to preventDefault on the event that caused this navigation.
   */
  navigateHorizontally(e, t = !1, o) {
    const { focusSvc: n, gos: s } = this.beans, i = { ...n.focusedHeader };
    let r, l;
    this.currentHeaderRowWithoutSpan !== -1 ? i.headerRowIndex = this.currentHeaderRowWithoutSpan : this.currentHeaderRowWithoutSpan = i.headerRowIndex, e === "LEFT" !== s.get("enableRtl") ? (l = "Before", r = this.findHeader(i, l)) : (l = "After", r = this.findHeader(i, l));
    const a = s.getCallback("tabToNextHeader");
    if (t && a) {
      const c = n.focusHeaderPositionFromUserFunc({
        userFunc: a,
        headerPosition: r,
        direction: l
      });
      if (c) {
        const { headerRowIndex: d } = n.focusedHeader || {};
        d != null && d != i.headerRowIndex && (this.currentHeaderRowWithoutSpan = d);
      }
      return c;
    }
    return r || !t ? n.focusHeaderPosition({
      headerPosition: r,
      direction: l,
      fromTab: t,
      allowUserOverride: !0,
      event: o
    }) : this.focusNextHeaderRow(i, l, o);
  }
  focusNextHeaderRow(e, t, o) {
    const n = this.beans, s = e.headerRowIndex;
    let i = null, r;
    const l = nn(n), a = this.beans.visibleCols.allCols;
    if (t === "Before") {
      if (s <= 0)
        return !1;
      i = Ke(a), r = s - 1, this.currentHeaderRowWithoutSpan -= 1;
    } else
      i = a[0], r = s + 1, this.currentHeaderRowWithoutSpan < l ? this.currentHeaderRowWithoutSpan += 1 : this.currentHeaderRowWithoutSpan = -1;
    let { column: c, headerRowIndex: d } = gy(this.beans, i, r);
    return d >= l && (d = -1), n.focusSvc.focusHeaderPosition({
      headerPosition: { column: c, headerRowIndex: d },
      direction: t,
      fromTab: !0,
      allowUserOverride: !0,
      event: o
    });
  }
  scrollToColumn(e, t = "After") {
    if (e.getPinned())
      return;
    let o;
    if (St(e)) {
      const n = e.getDisplayedLeafColumns();
      o = t === "Before" ? Ke(n) : n[0];
    } else
      o = e;
    this.gridBodyCon.scrollFeature.ensureColumnVisible(o);
  }
  findHeader(e, t) {
    const { colGroupSvc: o, visibleCols: n } = this.beans;
    let s = e.column;
    if (s instanceof Qr) {
      const a = s.getDisplayedLeafColumns();
      s = t === "Before" ? a[0] : a[a.length - 1];
    }
    const i = t === "Before" ? n.getColBefore(s) : n.getColAfter(s);
    if (!i)
      return;
    const r = n.headerGroupRowCount;
    if (e.headerRowIndex >= r)
      return {
        headerRowIndex: e.headerRowIndex,
        column: i
      };
    const l = o == null ? void 0 : o.getColGroupAtLevel(i, e.headerRowIndex);
    return l ? l.isPadding() && i.isSpanHeaderHeight() ? {
      headerRowIndex: n.headerGroupRowCount,
      column: i
    } : {
      headerRowIndex: e.headerRowIndex,
      column: l ?? i
    } : {
      headerRowIndex: i instanceof Zn && i.isSpanHeaderHeight() ? n.headerGroupRowCount : e.headerRowIndex,
      column: i
    };
  }
  getHeaderRowType(e) {
    const t = this.beans.ctrlsSvc.getHeaderRowContainerCtrl();
    if (t)
      return t.getRowType(e);
  }
};
function SZe(e, t, o) {
  const n = o - 1;
  if (e !== "filter") {
    const s = t instanceof Zn && t.isSpanHeaderHeight();
    let i = t.getParent();
    for (; i && // skip if row isn't visible or col is padding and spanned
    (i.getProvidedColumnGroup().getLevel() > n || s && i.isPadding()); )
      i = i.getParent();
    if (i)
      return s ? {
        column: i,
        headerRowIndex: i.getProvidedColumnGroup().getLevel(),
        headerRowIndexWithoutSpan: n
      } : {
        column: i,
        headerRowIndex: n,
        headerRowIndexWithoutSpan: n
      };
  }
  return {
    column: t,
    headerRowIndex: n,
    headerRowIndexWithoutSpan: n
  };
}
function xZe(e, t, o) {
  const n = t + 1, s = {
    column: e,
    headerRowIndex: n,
    headerRowIndexWithoutSpan: n
  };
  if (e instanceof Qr) {
    if (n >= o)
      return {
        column: e.getDisplayedLeafColumns()[0],
        headerRowIndex: o,
        headerRowIndexWithoutSpan: n
      };
    let r = e.getDisplayedChildren()[0];
    if (r instanceof Qr && r.isPadding()) {
      const a = r.getDisplayedLeafColumns()[0];
      a.isSpanHeaderHeight() && (r = a);
    }
    s.column = r, r instanceof Zn && r.isSpanHeaderHeight() && (s.headerRowIndex = o, s.headerRowIndexWithoutSpan = n);
  }
  return s;
}
var MZe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "focusSvc", this.focusFallbackTimeout = null, this.needsFocusRestored = !1;
  }
  wireBeans(e) {
    this.colModel = e.colModel, this.visibleCols = e.visibleCols, this.rowRenderer = e.rowRenderer, this.navigation = e.navigation, this.filterManager = e.filterManager, this.overlays = e.overlays;
  }
  postConstruct() {
    const e = this.clearFocusedCell.bind(this);
    this.addManagedEventListeners({
      columnPivotModeChanged: e,
      newColumnsLoaded: this.onColumnEverythingChanged.bind(this),
      columnGroupOpened: e,
      columnRowGroupChanged: e
    }), this.addDestroyFunc(KDe(this.beans));
  }
  attemptToRecoverFocus() {
    this.needsFocusRestored = !0, this.focusFallbackTimeout != null && clearTimeout(this.focusFallbackTimeout), this.focusFallbackTimeout = window.setTimeout(this.setFocusRecovered.bind(this), 100);
  }
  setFocusRecovered() {
    this.needsFocusRestored = !1, this.focusFallbackTimeout != null && (clearTimeout(this.focusFallbackTimeout), this.focusFallbackTimeout = null);
  }
  /**
   * Specifies whether to take focus, as grid either already has focus, or lost it due
   * to a destroyed cell
   * @returns true if the grid should re-take focus, otherwise false
   */
  shouldTakeFocus() {
    return this.gos.get("suppressFocusAfterRefresh") ? (this.setFocusRecovered(), !1) : this.needsFocusRestored ? (this.setFocusRecovered(), !0) : this.doesRowOrCellHaveBrowserFocus();
  }
  onColumnEverythingChanged() {
    if (!this.focusedCell)
      return;
    const e = this.focusedCell.column, t = this.colModel.getCol(e.getId());
    e !== t && this.clearFocusedCell();
  }
  // we check if the browser is focusing something, and if it is, and
  // it's the cell we think is focused, then return the cell. so this
  // methods returns the cell if a) we think it has focus and b) the
  // browser thinks it has focus. this then returns nothing if we
  // first focus a cell, then second click outside the grid, as then the
  // grid cell will still be focused as far as the grid is concerned,
  // however the browser focus will have moved somewhere else.
  getFocusCellToUseAfterRefresh() {
    const { gos: e, focusedCell: t } = this;
    return e.get("suppressFocusAfterRefresh") || e.get("suppressCellFocus") || !t || !this.doesRowOrCellHaveBrowserFocus() ? null : t;
  }
  getFocusHeaderToUseAfterRefresh() {
    return this.gos.get("suppressFocusAfterRefresh") || !this.focusedHeader || !this.isDomDataPresentInHierarchy(Ue(this.beans), $b) ? null : this.focusedHeader;
  }
  /**
   * Check for both cells and rows, as a row might be destroyed and the dom data removed before the cell if the
   * row is animating out.
   */
  doesRowOrCellHaveBrowserFocus() {
    const e = Ue(this.beans);
    return this.isDomDataPresentInHierarchy(e, Fl) ? !0 : this.isDomDataPresentInHierarchy(e, Tl);
  }
  isDomDataPresentInHierarchy(e, t) {
    let o = e;
    for (; o; ) {
      if (Mw(this.gos, o, t))
        return !0;
      o = o.parentNode;
    }
    return !1;
  }
  getFocusedCell() {
    return this.focusedCell;
  }
  getFocusEventParams(e) {
    const { rowIndex: t, rowPinned: o, column: n } = e, s = {
      rowIndex: t,
      rowPinned: o,
      column: n,
      isFullWidthCell: !1
    }, i = this.rowRenderer.getRowByPosition({ rowIndex: t, rowPinned: o });
    return i && (s.isFullWidthCell = i.isFullWidth()), s;
  }
  clearFocusedCell() {
    if (this.focusedCell == null)
      return;
    const e = this.getFocusEventParams(this.focusedCell);
    this.focusedCell = null, this.eventSvc.dispatchEvent({
      type: "cellFocusCleared",
      ...e
    });
  }
  setFocusedCell(e) {
    this.setFocusRecovered();
    const {
      column: t,
      rowIndex: o,
      rowPinned: n,
      forceBrowserFocus: s = !1,
      preventScrollOnBrowserFocus: i = !1,
      sourceEvent: r
    } = e, l = this.colModel.getCol(t);
    if (!l) {
      this.focusedCell = null;
      return;
    }
    this.focusedCell = {
      rowIndex: o,
      rowPinned: Ft(n),
      column: l
    };
    const a = this.getFocusEventParams(this.focusedCell);
    this.eventSvc.dispatchEvent({
      type: "cellFocused",
      ...a,
      ...this.previousCellFocusParams && { previousParams: this.previousCellFocusParams },
      forceBrowserFocus: s,
      preventScrollOnBrowserFocus: i,
      sourceEvent: r
    }), this.previousCellFocusParams = a;
  }
  isCellFocused(e) {
    return this.focusedCell == null ? !1 : ec(e, this.focusedCell);
  }
  isHeaderWrapperFocused(e) {
    if (this.focusedHeader == null)
      return !1;
    const {
      column: t,
      rowCtrl: { rowIndex: o, pinned: n }
    } = e, { column: s, headerRowIndex: i } = this.focusedHeader;
    return t === s && o === i && n == s.getPinned();
  }
  focusHeaderPosition(e) {
    var a;
    if (this.setFocusRecovered(), $s(this.beans))
      return !1;
    const { direction: t, fromTab: o, allowUserOverride: n, event: s, fromCell: i, rowWithoutSpanValue: r } = e;
    let { headerPosition: l } = e;
    if (i && ((a = this.filterManager) != null && a.isAdvFilterHeaderActive()))
      return this.focusAdvancedFilter(l);
    if (n) {
      const c = this.focusedHeader, d = nn(this.beans);
      if (o) {
        const u = this.gos.getCallback("tabToNextHeader");
        u && (l = this.getHeaderPositionFromUserFunc({
          userFunc: u,
          direction: t,
          currentPosition: c,
          headerPosition: l,
          headerRowCount: d
        }));
      } else {
        const u = this.gos.getCallback("navigateToNextHeader");
        if (u && s) {
          const h = {
            key: s.key,
            previousHeaderPosition: c,
            nextHeaderPosition: l,
            headerRowCount: d,
            event: s
          };
          l = u(h);
        }
      }
    }
    return l ? this.focusProvidedHeaderPosition({
      headerPosition: l,
      direction: t,
      event: s,
      fromCell: i,
      rowWithoutSpanValue: r
    }) : !1;
  }
  focusHeaderPositionFromUserFunc(e) {
    if ($s(this.beans))
      return !1;
    const { userFunc: t, headerPosition: o, direction: n, event: s } = e, i = this.focusedHeader, r = nn(this.beans), l = this.getHeaderPositionFromUserFunc({
      userFunc: t,
      direction: n,
      currentPosition: i,
      headerPosition: o,
      headerRowCount: r
    });
    return !!l && this.focusProvidedHeaderPosition({
      headerPosition: l,
      direction: n,
      event: s
    });
  }
  getHeaderPositionFromUserFunc(e) {
    const { userFunc: t, direction: o, currentPosition: n, headerPosition: s, headerRowCount: i } = e, l = t({
      backwards: o === "Before",
      previousHeaderPosition: n,
      nextHeaderPosition: s,
      headerRowCount: i
    });
    return l === !0 ? n : l === !1 ? null : l;
  }
  focusProvidedHeaderPosition(e) {
    const { headerPosition: t, direction: o, fromCell: n, rowWithoutSpanValue: s, event: i } = e, { column: r, headerRowIndex: l } = t, { filterManager: a, ctrlsSvc: c, headerNavigation: d } = this.beans;
    if (l === -1)
      return a != null && a.isAdvFilterHeaderActive() ? this.focusAdvancedFilter(t) : this.focusGridView({ column: r, event: i });
    d == null || d.scrollToColumn(r, o);
    const u = c.getHeaderRowContainerCtrl(r.getPinned()), h = (u == null ? void 0 : u.focusHeader(t.headerRowIndex, r, i)) || !1;
    return d && h && (s != null || n) && (d.currentHeaderRowWithoutSpan = s ?? -1), h;
  }
  focusFirstHeader() {
    var o;
    if ((o = this.overlays) != null && o.isExclusive() && this.focusOverlay())
      return !0;
    const e = this.visibleCols.allCols[0];
    if (!e)
      return !1;
    const t = gy(this.beans, e, 0);
    return this.focusHeaderPosition({
      headerPosition: t,
      rowWithoutSpanValue: 0
    });
  }
  focusLastHeader(e) {
    var n;
    if ((n = this.overlays) != null && n.isExclusive() && this.focusOverlay(!0))
      return !0;
    const t = nn(this.beans) - 1, o = Ke(this.visibleCols.allCols);
    return this.focusHeaderPosition({
      headerPosition: { headerRowIndex: t, column: o },
      rowWithoutSpanValue: -1,
      event: e
    });
  }
  focusPreviousFromFirstCell(e) {
    var t;
    return (t = this.filterManager) != null && t.isAdvFilterHeaderActive() ? this.focusAdvancedFilter(null) : this.focusLastHeader(e);
  }
  isAnyCellFocused() {
    return !!this.focusedCell;
  }
  isRowFocused(e, t) {
    return this.focusedCell == null ? !1 : this.focusedCell.rowIndex === e && this.focusedCell.rowPinned === Ft(t);
  }
  focusOverlay(e) {
    var o, n;
    const t = ((o = this.overlays) == null ? void 0 : o.isVisible()) && ((n = this.overlays.eWrapper) == null ? void 0 : n.getGui());
    return !!t && so(t, e);
  }
  focusGridView(e) {
    var i, r, l, a, c, d;
    const { backwards: t = !1, canFocusOverlay: o = !0, event: n } = e;
    if ((i = this.overlays) != null && i.isExclusive())
      return o && this.focusOverlay(t);
    if (ba(this.beans))
      return t && !$s(this.beans) ? this.focusLastHeader() : o && this.focusOverlay(t) ? !0 : t ? !1 : fn(this.beans, t);
    const s = t ? FOe(this.beans) : ROe(this.beans);
    if (s) {
      const u = e.column ?? ((r = this.focusedHeader) == null ? void 0 : r.column), { rowIndex: h, rowPinned: p } = s, C = vn(this.beans, s);
      if (!u || !C || h == null)
        return !1;
      if (u.isSuppressNavigable(C)) {
        const m = this.gos.get("enableRtl");
        let w;
        return !n || n.key === D.TAB ? w = m ? D.LEFT : D.RIGHT : w = n.key, (l = this.beans.navigation) == null || l.navigateToNextCell(
          null,
          w,
          { rowIndex: h, column: u, rowPinned: p || null },
          !0
        ), !0;
      }
      if ((a = this.navigation) == null || a.ensureCellVisible({ rowIndex: h, column: u, rowPinned: p }), t) {
        const m = this.rowRenderer.getRowByPosition(s);
        if (m != null && m.isFullWidth() && ((c = this.navigation) != null && c.tryToFocusFullWidthRow(s, t)))
          return !0;
      }
      return this.setFocusedCell({
        rowIndex: h,
        column: u,
        rowPinned: Ft(p),
        forceBrowserFocus: !0
      }), (d = this.beans.rangeSvc) == null || d.setRangeToCell({ rowIndex: h, rowPinned: p, column: u }), !0;
    }
    return !!(o && this.focusOverlay(t) || t && this.focusLastHeader());
  }
  focusAdvancedFilter(e) {
    var t;
    return this.advFilterFocusColumn = e == null ? void 0 : e.column, ((t = this.beans.advancedFilter) == null ? void 0 : t.getCtrl().focusHeaderComp()) ?? !1;
  }
  focusNextFromAdvancedFilter(e, t) {
    var n;
    const o = (t ? void 0 : this.advFilterFocusColumn) ?? ((n = this.visibleCols.allCols) == null ? void 0 : n[0]);
    return e ? this.focusHeaderPosition({
      headerPosition: {
        column: o,
        headerRowIndex: nn(this.beans) - 1
      }
    }) : this.focusGridView({ column: o });
  }
  clearAdvancedFilterColumn() {
    this.advFilterFocusColumn = void 0;
  }
}, AZe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "scrollVisibleSvc";
  }
  wireBeans(e) {
    this.ctrlsSvc = e.ctrlsSvc, this.colAnimation = e.colAnimation;
  }
  postConstruct() {
    this.horizontalScrollShowing = this.gos.get("alwaysShowHorizontalScroll") === !0, this.verticalScrollShowing = this.gos.get("alwaysShowVerticalScroll") === !0, this.getScrollbarWidth(), this.addManagedEventListeners({
      displayedColumnsChanged: this.updateScrollVisible.bind(this),
      displayedColumnsWidthChanged: this.updateScrollVisible.bind(this)
    });
  }
  updateScrollVisible() {
    const { colAnimation: e } = this;
    e != null && e.isActive() ? e.executeLaterVMTurn(() => {
      e.executeLaterVMTurn(() => this.updateScrollVisibleImpl());
    }) : this.updateScrollVisibleImpl();
  }
  updateScrollVisibleImpl() {
    var o;
    const e = this.ctrlsSvc.get("center");
    if (!e || (o = this.colAnimation) != null && o.isActive())
      return;
    const t = {
      horizontalScrollShowing: e.isHorizontalScrollShowing(),
      verticalScrollShowing: this.verticalScrollShowing
    };
    this.setScrollsVisible(t), this.updateScrollGap();
  }
  updateScrollGap() {
    const e = this.ctrlsSvc.get("center"), t = e.hasHorizontalScrollGap(), o = e.hasVerticalScrollGap();
    (this.horizontalScrollGap !== t || this.verticalScrollGap !== o) && (this.horizontalScrollGap = t, this.verticalScrollGap = o, this.eventSvc.dispatchEvent({
      type: "scrollGapChanged"
    }));
  }
  setScrollsVisible(e) {
    (this.horizontalScrollShowing !== e.horizontalScrollShowing || this.verticalScrollShowing !== e.verticalScrollShowing) && (this.horizontalScrollShowing = e.horizontalScrollShowing, this.verticalScrollShowing = e.verticalScrollShowing, this.eventSvc.dispatchEvent({
      type: "scrollVisibilityChanged"
    }));
  }
  // the user might be using some non-standard scrollbar, eg a scrollbar that has zero
  // width and overlays (like the Safari scrollbar, but presented in Chrome). so we
  // allow the user to provide the scroll width before we work it out.
  getScrollbarWidth() {
    if (this.scrollbarWidth == null) {
      const e = this.gos.get("scrollbarWidth"), o = typeof e == "number" && e >= 0 ? e : ZDe();
      o != null && (this.scrollbarWidth = o, this.eventSvc.dispatchEvent({
        type: "scrollbarWidthChanged"
      }));
    }
    return this.scrollbarWidth;
  }
}, LZe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "gridDestroySvc", this.destroyCalled = !1;
  }
  destroy() {
    var n;
    if (this.destroyCalled)
      return;
    const { stateSvc: e, ctrlsSvc: t, context: o } = this.beans;
    this.eventSvc.dispatchEvent({
      type: "gridPreDestroyed",
      state: (e == null ? void 0 : e.getState()) ?? {}
    }), this.destroyCalled = !0, (n = t.get("gridCtrl")) == null || n.destroyGridUi(), o.destroy(), super.destroy();
  }
}, Rr = /* @__PURE__ */ new Set(["gridPreDestroyed", "fillStart", "pasteStart"]), EZe = [
  "columnEverythingChanged",
  "newColumnsLoaded",
  "columnPivotModeChanged",
  "pivotMaxColumnsExceeded",
  "columnRowGroupChanged",
  "expandOrCollapseAll",
  "columnPivotChanged",
  "gridColumnsChanged",
  "columnValueChanged",
  "columnMoved",
  "columnVisible",
  "columnPinned",
  "columnGroupOpened",
  "columnResized",
  "displayedColumnsChanged",
  "virtualColumnsChanged",
  "columnHeaderMouseOver",
  "columnHeaderMouseLeave",
  "columnHeaderClicked",
  "columnHeaderContextMenu",
  "asyncTransactionsFlushed",
  "rowGroupOpened",
  "rowDataUpdated",
  "pinnedRowDataChanged",
  "pinnedRowsChanged",
  "rangeSelectionChanged",
  "cellSelectionChanged",
  "chartCreated",
  "chartRangeSelectionChanged",
  "chartOptionsChanged",
  "chartDestroyed",
  "toolPanelVisibleChanged",
  "toolPanelSizeChanged",
  "modelUpdated",
  "cutStart",
  "cutEnd",
  "pasteStart",
  "pasteEnd",
  "fillStart",
  "fillEnd",
  "cellSelectionDeleteStart",
  "cellSelectionDeleteEnd",
  "rangeDeleteStart",
  "rangeDeleteEnd",
  "undoStarted",
  "undoEnded",
  "redoStarted",
  "redoEnded",
  "cellClicked",
  "cellDoubleClicked",
  "cellMouseDown",
  "cellContextMenu",
  "cellValueChanged",
  "cellEditRequest",
  "rowValueChanged",
  "headerFocused",
  "cellFocused",
  "rowSelected",
  "selectionChanged",
  "tooltipShow",
  "tooltipHide",
  "cellKeyDown",
  "cellMouseOver",
  "cellMouseOut",
  "filterChanged",
  "filterModified",
  "filterUiChanged",
  "filterOpened",
  "floatingFilterUiChanged",
  "advancedFilterBuilderVisibleChanged",
  "sortChanged",
  "virtualRowRemoved",
  "rowClicked",
  "rowDoubleClicked",
  "gridReady",
  "gridPreDestroyed",
  "gridSizeChanged",
  "viewportChanged",
  "firstDataRendered",
  "dragStarted",
  "dragStopped",
  "dragCancelled",
  "rowEditingStarted",
  "rowEditingStopped",
  "cellEditingStarted",
  "cellEditingStopped",
  "bodyScroll",
  "bodyScrollEnd",
  "paginationChanged",
  "componentStateChanged",
  "storeRefreshed",
  "stateUpdated",
  "columnMenuVisibleChanged",
  "contextMenuVisibleChanged",
  "rowDragEnter",
  "rowDragMove",
  "rowDragLeave",
  "rowDragEnd",
  "rowDragCancel",
  "findChanged",
  "rowResizeStarted",
  "rowResizeEnded",
  "columnsReset",
  "bulkEditingStarted",
  "bulkEditingStopped",
  "batchEditingStarted",
  "batchEditingStopped"
], Sa = EZe.reduce(
  (e, t) => (e[t] = FIe(t), e),
  {}
), ur = (e, t) => ({
  tag: "span",
  ref: `eSort${e}`,
  cls: `ag-sort-indicator-icon ag-sort-${t} ag-hidden`,
  attrs: { "aria-hidden": "true" }
}), PZe = {
  tag: "span",
  cls: "ag-sort-indicator-container",
  children: [
    ur("Order", "order"),
    ur("Asc", "ascending-icon"),
    ur("Desc", "descending-icon"),
    ur("Mixed", "mixed-icon"),
    ur("None", "none-icon")
  ]
}, nc = class extends Re {
  constructor(e) {
    super(), this.eSortOrder = J, this.eSortAsc = J, this.eSortDesc = J, this.eSortMixed = J, this.eSortNone = J, e || this.setTemplate(PZe);
  }
  attachCustomElements(e, t, o, n, s) {
    this.eSortOrder = e, this.eSortAsc = t, this.eSortDesc = o, this.eSortMixed = n, this.eSortNone = s;
  }
  setupSort(e, t = !1) {
    if (this.column = e, this.suppressOrder = t, this.setupMultiSortIndicator(), !e.isSortable() && !e.getColDef().showRowGroup)
      return;
    this.addInIcon("sortAscending", this.eSortAsc, e), this.addInIcon("sortDescending", this.eSortDesc, e), this.addInIcon("sortUnSort", this.eSortNone, e);
    const o = this.updateIcons.bind(this), n = this.onSortChanged.bind(this);
    this.addManagedPropertyListener("unSortIcon", o), this.addManagedEventListeners({
      newColumnsLoaded: o,
      // Watch global events, as row group columns can effect their display column.
      sortChanged: n,
      // when grouping changes so can sort indexes and icons
      columnRowGroupChanged: n
    }), this.onSortChanged();
  }
  addInIcon(e, t, o) {
    if (t == null)
      return;
    const n = Ie(e, this.beans, o);
    n && t.appendChild(n);
  }
  onSortChanged() {
    this.updateIcons(), this.suppressOrder || this.updateSortOrder();
  }
  updateIcons() {
    const { eSortAsc: e, eSortDesc: t, eSortNone: o, column: n, gos: s, beans: i } = this, r = i.sortSvc.getDisplaySortForColumn(n);
    if (e && He(e, r === "asc", { skipAriaHidden: !0 }), t && He(t, r === "desc", { skipAriaHidden: !0 }), o) {
      const l = !n.getColDef().unSortIcon && !s.get("unSortIcon"), a = r == null;
      He(o, !l && a, { skipAriaHidden: !0 });
    }
  }
  setupMultiSortIndicator() {
    const { eSortMixed: e, column: t, gos: o } = this;
    this.addInIcon("sortUnSort", e, t);
    const n = t.getColDef().showRowGroup;
    Oo(o) && n && (this.addManagedEventListeners({
      // Watch global events, as row group columns can effect their display column.
      sortChanged: this.updateMultiSortIndicator.bind(this),
      // when grouping changes so can sort indexes and icons
      columnRowGroupChanged: this.updateMultiSortIndicator.bind(this)
    }), this.updateMultiSortIndicator());
  }
  updateMultiSortIndicator() {
    const { eSortMixed: e, beans: t, column: o } = this;
    if (e) {
      const n = t.sortSvc.getDisplaySortForColumn(o) === "mixed";
      He(e, n, { skipAriaHidden: !0 });
    }
  }
  // we listen here for global sort events, NOT column sort events, as we want to do this
  // when sorting has been set on all column (if we listened just for our col (where we
  // set the asc / desc icons) then it's possible other cols are yet to get their sorting state.
  updateSortOrder() {
    const {
      eSortOrder: e,
      column: t,
      beans: { sortSvc: o }
    } = this;
    if (!e)
      return;
    const n = o.getColumnsWithSortingOrdered(), s = o.getDisplaySortIndexForColumn(t) ?? -1, i = n.some(
      (l) => o.getDisplaySortIndexForColumn(l) ?? !1
    ), r = s >= 0 && i;
    He(e, r, { skipAriaHidden: !0 }), s >= 0 ? e.textContent = (s + 1).toString() : it(e);
  }
}, RZe = {
  selector: "AG-SORT-INDICATOR",
  component: nc
}, Jr = ["asc", "desc", null], FZe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "sortSvc";
  }
  progressSort(e, t, o) {
    const n = this.getNextSortDirection(e);
    this.setSortForColumn(e, n, t, o);
  }
  progressSortFromEvent(e, t) {
    const n = this.gos.get("multiSortKey") === "ctrl" ? t.ctrlKey || t.metaKey : t.shiftKey;
    this.progressSort(e, n, "uiColumnSorted");
  }
  setSortForColumn(e, t, o, n) {
    var d;
    t !== "asc" && t !== "desc" && (t = null);
    const { gos: s, showRowGroupCols: i } = this.beans, r = Oo(s);
    let l = [e];
    if (r && e.getColDef().showRowGroup) {
      const u = (d = i == null ? void 0 : i.getSourceColumnsForGroupColumn) == null ? void 0 : d.call(i, e), h = u == null ? void 0 : u.filter((p) => p.isSortable());
      h && (l = [e, ...h]);
    }
    l.forEach((u) => this.setColSort(u, t, n));
    const a = (o || s.get("alwaysMultiSort")) && !s.get("suppressMultiSort"), c = [];
    if (!a) {
      const u = this.clearSortBarTheseColumns(l, n);
      c.push(...u);
    }
    this.updateSortIndex(e), c.push(...l), this.dispatchSortChangedEvents(n, c);
  }
  updateSortIndex(e) {
    const { gos: t, colModel: o, showRowGroupCols: n } = this.beans, s = Oo(t), i = n == null ? void 0 : n.getShowRowGroupCol(e.getId()), r = s && i || e, l = this.getColumnsWithSortingOrdered();
    o.forAllCols((d) => this.setColSortIndex(d, null));
    const a = l.filter((d) => s && d.getColDef().showRowGroup ? !1 : d !== r);
    (r.getSort() ? [...a, r] : a).forEach((d, u) => this.setColSortIndex(d, u));
  }
  // gets called by API, so if data changes, use can call this, which will end up
  // working out the sort order again of the rows.
  onSortChanged(e, t) {
    this.dispatchSortChangedEvents(e, t);
  }
  isSortActive() {
    let e = !1;
    return this.beans.colModel.forAllCols((t) => {
      t.getSort() && (e = !0);
    }), e;
  }
  dispatchSortChangedEvents(e, t) {
    const o = {
      type: "sortChanged",
      source: e
    };
    t && (o.columns = t), this.eventSvc.dispatchEvent(o);
  }
  clearSortBarTheseColumns(e, t) {
    const o = [];
    return this.beans.colModel.forAllCols((n) => {
      e.includes(n) || (n.getSort() && o.push(n), this.setColSort(n, void 0, t));
    }), o;
  }
  getNextSortDirection(e) {
    const t = e.getColDef().sortingOrder ?? this.gos.get("sortingOrder") ?? Jr, o = t.indexOf(e.getSort()), n = o < 0, s = o == t.length - 1;
    return n || s ? t[0] : t[o + 1];
  }
  /**
   * @returns a map of sort indexes for every sorted column, if groups sort primaries then they will have equivalent indices
   */
  getIndexedSortMap() {
    const { gos: e, colModel: t, showRowGroupCols: o, rowGroupColsSvc: n } = this.beans;
    let s = [];
    if (t.forAllCols((c) => {
      c.getSort() && s.push(c);
    }), t.isPivotMode()) {
      const c = Oo(e);
      s = s.filter((d) => {
        const u = !!d.getAggFunc(), h = !d.isPrimary(), p = c ? o == null ? void 0 : o.getShowRowGroupCol(d.getId()) : d.getColDef().showRowGroup;
        return u || h || p;
      });
    }
    const i = (n == null ? void 0 : n.columns.filter((c) => !!c.getSort())) ?? [], r = {};
    s.forEach((c, d) => r[c.getId()] = d), s.sort((c, d) => {
      const u = c.getSortIndex(), h = d.getSortIndex();
      if (u != null && h != null)
        return u - h;
      if (u == null && h == null) {
        const p = r[c.getId()], C = r[d.getId()];
        return p > C ? 1 : -1;
      } else return h == null ? -1 : 1;
    });
    const l = Oo(e) && !!i.length;
    l && (s = [
      ...new Set(
        // if linked sorting, replace all columns with the display group column for index purposes, and ensure uniqueness
        s.map((c) => (o == null ? void 0 : o.getShowRowGroupCol(c.getId())) ?? c)
      )
    ]);
    const a = /* @__PURE__ */ new Map();
    return s.forEach((c, d) => a.set(c, d)), l && i.forEach((c) => {
      const d = o.getShowRowGroupCol(c.getId());
      a.set(c, a.get(d));
    }), a;
  }
  getColumnsWithSortingOrdered() {
    return [...this.getIndexedSortMap().entries()].sort(([, e], [, t]) => e - t).map(([e]) => e);
  }
  // used by server side row models, to sent sort to server
  getSortModel() {
    return this.getColumnsWithSortingOrdered().filter((e) => e.getSort()).map((e) => ({
      sort: e.getSort(),
      colId: e.getId()
    }));
  }
  getSortOptions() {
    return this.getColumnsWithSortingOrdered().filter((e) => e.getSort()).map((e) => ({
      sort: e.getSort(),
      column: e
    }));
  }
  canColumnDisplayMixedSort(e) {
    const t = Oo(this.gos), o = !!e.getColDef().showRowGroup;
    return t && o;
  }
  getDisplaySortForColumn(e) {
    var r;
    const t = (r = this.beans.showRowGroupCols) == null ? void 0 : r.getSourceColumnsForGroupColumn(e);
    if (!this.canColumnDisplayMixedSort(e) || !(t != null && t.length))
      return e.getSort();
    const n = e.getColDef().field != null || !!e.getColDef().valueGetter ? [e, ...t] : t, s = n[0].getSort();
    return n.every((l) => l.getSort() == s) ? s : "mixed";
  }
  getDisplaySortIndexForColumn(e) {
    return this.getIndexedSortMap().get(e);
  }
  setupHeader(e, t, o) {
    let n = 0;
    e.addManagedListeners(t, {
      movingChanged: () => {
        n = Date.now();
      }
    }), o && e.addManagedElementListeners(o, {
      click: (i) => {
        const r = t.isMoving(), a = Date.now() - n < 50;
        r || a || this.progressSortFromEvent(t, i);
      }
    });
    const s = () => {
      var r;
      const i = t.getSort();
      if (e.toggleCss("ag-header-cell-sorted-asc", i === "asc"), e.toggleCss("ag-header-cell-sorted-desc", i === "desc"), e.toggleCss("ag-header-cell-sorted-none", !i), t.getColDef().showRowGroup) {
        const l = (r = this.beans.showRowGroupCols) == null ? void 0 : r.getSourceColumnsForGroupColumn(t), c = !(l == null ? void 0 : l.every(
          (d) => t.getSort() == d.getSort()
        ));
        e.toggleCss("ag-header-cell-sorted-mixed", c);
      }
    };
    e.addManagedEventListeners({
      sortChanged: s,
      columnRowGroupChanged: s
    });
  }
  initCol(e) {
    const { sort: t, initialSort: o, sortIndex: n, initialSortIndex: s } = e.colDef;
    t !== void 0 ? (t === "asc" || t === "desc") && (e.sort = t) : (o === "asc" || o === "desc") && (e.sort = o), n !== void 0 ? n !== null && (e.sortIndex = n) : s !== null && (e.sortIndex = s);
  }
  updateColSort(e, t, o) {
    t !== void 0 && (t === "desc" || t === "asc" ? this.setColSort(e, t, o) : this.setColSort(e, void 0, o));
  }
  setColSort(e, t, o) {
    e.sort !== t && (e.sort = t, e.dispatchColEvent("sortChanged", o)), e.dispatchStateUpdatedEvent("sort");
  }
  setColSortIndex(e, t) {
    e.sortIndex = t, e.dispatchStateUpdatedEvent("sortIndex");
  }
  createSortIndicator(e) {
    return new nc(e);
  }
  getSortIndicatorSelector() {
    return RZe;
  }
}, Fi = {
  agSetColumnFilter: "SetFilter",
  agSetColumnFloatingFilter: "SetFilter",
  agMultiColumnFilter: "MultiFilter",
  agMultiColumnFloatingFilter: "MultiFilter",
  agGroupColumnFilter: "GroupFilter",
  agGroupColumnFloatingFilter: "GroupFilter",
  agGroupCellRenderer: "GroupCellRenderer",
  agGroupRowRenderer: "GroupCellRenderer",
  agRichSelect: "RichSelect",
  agRichSelectCellEditor: "RichSelect",
  agDetailCellRenderer: "SharedMasterDetail",
  agSparklineCellRenderer: "Sparklines",
  agDragAndDropImage: "SharedDragAndDrop",
  agColumnHeader: "ColumnHeaderComp",
  agColumnGroupHeader: "ColumnGroupHeaderComp",
  agSortIndicator: "Sort",
  agAnimateShowChangeCellRenderer: "HighlightChanges",
  agAnimateSlideCellRenderer: "HighlightChanges",
  agLoadingCellRenderer: "LoadingCellRenderer",
  agSkeletonCellRenderer: "SkeletonCellRenderer",
  agCheckboxCellRenderer: "CheckboxCellRenderer",
  agLoadingOverlay: "Overlay",
  agNoRowsOverlay: "Overlay",
  agTooltipComponent: "Tooltip",
  agReadOnlyFloatingFilter: "CustomFilter",
  agTextColumnFilter: "TextFilter",
  agNumberColumnFilter: "NumberFilter",
  agDateColumnFilter: "DateFilter",
  agDateInput: "DateFilter",
  agTextColumnFloatingFilter: "TextFilter",
  agNumberColumnFloatingFilter: "NumberFilter",
  agDateColumnFloatingFilter: "DateFilter",
  agCellEditor: "TextEditor",
  agSelectCellEditor: "SelectEditor",
  agTextCellEditor: "TextEditor",
  agNumberCellEditor: "NumberEditor",
  agDateCellEditor: "DateEditor",
  agDateStringCellEditor: "DateEditor",
  agCheckboxCellEditor: "CheckboxEditor",
  agLargeTextCellEditor: "LargeTextEditor",
  agMenuItem: "MenuItem",
  agColumnsToolPanel: "ColumnsToolPanel",
  agFiltersToolPanel: "FiltersToolPanel",
  agNewFiltersToolPanel: "NewFiltersToolPanel",
  agAggregationComponent: "StatusBar",
  agSelectedRowCountComponent: "StatusBar",
  agTotalRowCountComponent: "StatusBar",
  agFilteredRowCountComponent: "StatusBar",
  agTotalAndFilteredRowCountComponent: "StatusBar",
  agFindCellRenderer: "Find"
}, TZe = () => ({
  checkboxSelection: { version: "32.2", message: "Use `rowSelection.checkboxes` in `GridOptions` instead." },
  headerCheckboxSelection: {
    version: "32.2",
    message: "Use `rowSelection.headerCheckbox = true` in `GridOptions` instead."
  },
  headerCheckboxSelectionFilteredOnly: {
    version: "32.2",
    message: 'Use `rowSelection.selectAll = "filtered"` in `GridOptions` instead.'
  },
  headerCheckboxSelectionCurrentPageOnly: {
    version: "32.2",
    message: 'Use `rowSelection.selectAll = "currentPage"` in `GridOptions` instead.'
  },
  showDisabledCheckboxes: {
    version: "32.2",
    message: "Use `rowSelection.hideDisabledCheckboxes = true` in `GridOptions` instead."
  }
}), IZe = {
  aggFunc: "SharedAggregation",
  autoHeight: "RowAutoHeight",
  cellClass: "CellStyle",
  cellClassRules: "CellStyle",
  cellEditor: ({ cellEditor: e, editable: t }) => t ? typeof e == "string" ? Fi[e] ?? "CustomEditor" : "CustomEditor" : null,
  cellRenderer: ({ cellRenderer: e }) => typeof e != "string" ? null : Fi[e],
  cellStyle: "CellStyle",
  columnChooserParams: "ColumnMenu",
  contextMenuItems: "ContextMenu",
  dndSource: "DragAndDrop",
  dndSourceOnRowDrag: "DragAndDrop",
  editable: ({ editable: e, cellEditor: t }) => e && !t ? "TextEditor" : null,
  enableCellChangeFlash: "HighlightChanges",
  enablePivot: "SharedPivot",
  enableRowGroup: "SharedRowGrouping",
  enableValue: "SharedAggregation",
  filter: ({ filter: e }) => e && typeof e != "string" && typeof e != "boolean" ? "CustomFilter" : typeof e == "string" ? Fi[e] ?? "ColumnFilter" : "ColumnFilter",
  floatingFilter: "ColumnFilter",
  getQuickFilterText: "QuickFilter",
  headerTooltip: "Tooltip",
  mainMenuItems: "ColumnMenu",
  menuTabs: (e) => {
    var o;
    const t = ["columnsMenuTab", "generalMenuTab"];
    return (o = e.menuTabs) != null && o.some((n) => t.includes(n)) ? "ColumnMenu" : null;
  },
  pivot: "SharedPivot",
  pivotIndex: "SharedPivot",
  rowDrag: "RowDrag",
  rowGroup: "SharedRowGrouping",
  rowGroupIndex: "SharedRowGrouping",
  tooltipField: "Tooltip",
  tooltipValueGetter: "Tooltip",
  spanRows: "CellSpan",
  rowGroupingHierarchy: "SharedRowGrouping"
}, DZe = () => ({
  autoHeight: {
    supportedRowModels: ["clientSide", "serverSide"],
    validate: (t, { paginationAutoPageSize: o }) => o ? "colDef.autoHeight is not supported with paginationAutoPageSize." : null
  },
  cellRendererParams: {
    validate: (t) => (t.rowGroup != null || t.rowGroupIndex != null || t.cellRenderer === "agGroupCellRenderer") && "checkbox" in t.cellRendererParams ? 'Since v33.0, `cellRendererParams.checkbox` has been deprecated. Use `rowSelection.checkboxLocation = "autoGroupColumn"` instead.' : null
  },
  flex: {
    validate: (t, o) => o.autoSizeStrategy ? "colDef.flex is not supported with gridOptions.autoSizeStrategy" : null
  },
  headerCheckboxSelection: {
    supportedRowModels: ["clientSide", "serverSide"],
    validate: (t, { rowSelection: o }) => o === "multiple" ? null : "headerCheckboxSelection is only supported with rowSelection=multiple"
  },
  headerCheckboxSelectionCurrentPageOnly: {
    supportedRowModels: ["clientSide"],
    validate: (t, { rowSelection: o }) => o === "multiple" ? null : "headerCheckboxSelectionCurrentPageOnly is only supported with rowSelection=multiple"
  },
  headerCheckboxSelectionFilteredOnly: {
    supportedRowModels: ["clientSide"],
    validate: (t, { rowSelection: o }) => o === "multiple" ? null : "headerCheckboxSelectionFilteredOnly is only supported with rowSelection=multiple"
  },
  headerValueGetter: {
    validate: (t) => {
      const o = t.headerValueGetter;
      return typeof o == "function" || typeof o == "string" ? null : "headerValueGetter must be a function or a valid string expression";
    }
  },
  icons: {
    validate: ({ icons: t }) => {
      if (t) {
        if (t.smallDown)
          return ln(262);
        if (t.smallLeft)
          return ln(263);
        if (t.smallRight)
          return ln(264);
      }
      return null;
    }
  },
  sortingOrder: {
    validate: (t) => {
      const o = t.sortingOrder;
      if (Array.isArray(o) && o.length > 0) {
        const n = o.filter((s) => !Jr.includes(s));
        if (n.length > 0)
          return `sortingOrder must be an array with elements from [${Jr.map(yl).join()}], currently it includes [${n.map(yl).join()}]`;
      } else if (!Array.isArray(o) || o.length <= 0)
        return `sortingOrder must be an array with at least one element, currently it's ${o}`;
      return null;
    }
  },
  type: {
    validate: (t) => {
      const o = t.type;
      return o instanceof Array ? o.some((s) => typeof s != "string") ? "if colDef.type is supplied an array it should be of type 'string[]'" : null : typeof o == "string" ? null : "colDef.type should be of type 'string' | 'string[]'";
    }
  },
  rowSpan: {
    validate: (t, { suppressRowTransform: o }) => o ? null : "colDef.rowSpan requires suppressRowTransform to be enabled."
  },
  spanRows: {
    dependencies: {
      editable: { required: [!1, void 0] },
      rowDrag: { required: [!1, void 0] },
      colSpan: { required: [void 0] },
      rowSpan: { required: [void 0] }
    },
    validate: (t, {
      rowSelection: o,
      cellSelection: n,
      suppressRowTransform: s,
      enableCellSpan: i,
      rowDragEntireRow: r,
      enableCellTextSelection: l
    }) => typeof o == "object" && (o == null ? void 0 : o.mode) === "singleRow" && o != null && o.enableClickSelection ? "colDef.spanRows is not supported with rowSelection.clickSelection" : n ? "colDef.spanRows is not supported with cellSelection." : s ? "colDef.spanRows is not supported with suppressRowTransform." : i ? r ? "colDef.spanRows is not supported with rowDragEntireRow." : l ? "colDef.spanRows is not supported with enableCellTextSelection." : null : "colDef.spanRows requires enableCellSpan to be enabled."
  },
  rowGroupingHierarchy: {
    validate(t, { groupHierarchyConfig: o = {} }, n) {
      var r;
      const s = /* @__PURE__ */ new Set([
        "year",
        "quarter",
        "month",
        "formattedMonth",
        "day",
        "hour",
        "minute",
        "second"
      ]), i = [];
      if ((r = t.rowGroupingHierarchy) == null || r.forEach((l) => {
        var a;
        if (typeof l == "object")
          return (a = n.validation) == null || a.validateColDef(l), null;
        !s.has(l) && !(l in o) && i.push(l);
      }), i.length > 0) {
        const l = `The following parts of colDef.rowGroupingHierarchy are not recognised: ${i.map((c) => `"${c}"`).join(", ")}.`, a = `Choose one of ${[...s].map((c) => `"${c}"`).join(", ")}, or define your own parts in gridOptions.groupHierarchyConfig.`;
        return `${l}
${a}`;
      }
      return null;
    }
  }
}), kZe = {
  headerName: void 0,
  columnGroupShow: void 0,
  headerStyle: void 0,
  headerClass: void 0,
  toolPanelClass: void 0,
  headerValueGetter: void 0,
  pivotKeys: void 0,
  groupId: void 0,
  colId: void 0,
  sort: void 0,
  initialSort: void 0,
  field: void 0,
  type: void 0,
  cellDataType: void 0,
  tooltipComponent: void 0,
  tooltipField: void 0,
  headerTooltip: void 0,
  cellClass: void 0,
  showRowGroup: void 0,
  filter: void 0,
  initialAggFunc: void 0,
  defaultAggFunc: void 0,
  aggFunc: void 0,
  pinned: void 0,
  initialPinned: void 0,
  chartDataType: void 0,
  cellAriaRole: void 0,
  cellEditorPopupPosition: void 0,
  headerGroupComponent: void 0,
  headerGroupComponentParams: void 0,
  cellStyle: void 0,
  cellRenderer: void 0,
  cellRendererParams: void 0,
  cellEditor: void 0,
  cellEditorParams: void 0,
  filterParams: void 0,
  pivotValueColumn: void 0,
  headerComponent: void 0,
  headerComponentParams: void 0,
  floatingFilterComponent: void 0,
  floatingFilterComponentParams: void 0,
  tooltipComponentParams: void 0,
  refData: void 0,
  columnChooserParams: void 0,
  children: void 0,
  sortingOrder: void 0,
  allowedAggFuncs: void 0,
  menuTabs: void 0,
  pivotTotalColumnIds: void 0,
  cellClassRules: void 0,
  icons: void 0,
  sortIndex: void 0,
  initialSortIndex: void 0,
  flex: void 0,
  initialFlex: void 0,
  width: void 0,
  initialWidth: void 0,
  minWidth: void 0,
  maxWidth: void 0,
  rowGroupIndex: void 0,
  initialRowGroupIndex: void 0,
  pivotIndex: void 0,
  initialPivotIndex: void 0,
  suppressColumnsToolPanel: void 0,
  suppressFiltersToolPanel: void 0,
  openByDefault: void 0,
  marryChildren: void 0,
  suppressStickyLabel: void 0,
  hide: void 0,
  initialHide: void 0,
  rowGroup: void 0,
  initialRowGroup: void 0,
  pivot: void 0,
  initialPivot: void 0,
  checkboxSelection: void 0,
  showDisabledCheckboxes: void 0,
  headerCheckboxSelection: void 0,
  headerCheckboxSelectionFilteredOnly: void 0,
  headerCheckboxSelectionCurrentPageOnly: void 0,
  suppressHeaderMenuButton: void 0,
  suppressMovable: void 0,
  lockPosition: void 0,
  lockVisible: void 0,
  lockPinned: void 0,
  unSortIcon: void 0,
  suppressSizeToFit: void 0,
  suppressAutoSize: void 0,
  enableRowGroup: void 0,
  enablePivot: void 0,
  enableValue: void 0,
  editable: void 0,
  suppressPaste: void 0,
  suppressNavigable: void 0,
  enableCellChangeFlash: void 0,
  rowDrag: void 0,
  dndSource: void 0,
  autoHeight: void 0,
  wrapText: void 0,
  sortable: void 0,
  resizable: void 0,
  singleClickEdit: void 0,
  floatingFilter: void 0,
  cellEditorPopup: void 0,
  suppressFillHandle: void 0,
  wrapHeaderText: void 0,
  autoHeaderHeight: void 0,
  dndSourceOnRowDrag: void 0,
  valueGetter: void 0,
  valueSetter: void 0,
  filterValueGetter: void 0,
  keyCreator: void 0,
  valueFormatter: void 0,
  valueParser: void 0,
  comparator: void 0,
  equals: void 0,
  pivotComparator: void 0,
  suppressKeyboardEvent: void 0,
  suppressHeaderKeyboardEvent: void 0,
  colSpan: void 0,
  rowSpan: void 0,
  spanRows: void 0,
  getQuickFilterText: void 0,
  onCellValueChanged: void 0,
  onCellClicked: void 0,
  onCellDoubleClicked: void 0,
  onCellContextMenu: void 0,
  rowDragText: void 0,
  tooltipValueGetter: void 0,
  cellRendererSelector: void 0,
  cellEditorSelector: void 0,
  suppressSpanHeaderHeight: void 0,
  useValueFormatterForExport: void 0,
  useValueParserForImport: void 0,
  mainMenuItems: void 0,
  contextMenuItems: void 0,
  suppressFloatingFilterButton: void 0,
  suppressHeaderFilterButton: void 0,
  suppressHeaderContextMenu: void 0,
  loadingCellRenderer: void 0,
  loadingCellRendererParams: void 0,
  loadingCellRendererSelector: void 0,
  context: void 0,
  dateComponent: void 0,
  dateComponentParams: void 0,
  getFindText: void 0,
  rowGroupingHierarchy: void 0
}, HZe = () => Object.keys(kZe), VZe = () => ({
  objectName: "colDef",
  allProperties: HZe(),
  docsUrl: "column-properties/",
  deprecations: TZe(),
  validations: DZe()
}), OZe = [
  "overlayLoadingTemplate",
  "overlayNoRowsTemplate",
  "gridId",
  "quickFilterText",
  "rowModelType",
  "editType",
  "domLayout",
  "clipboardDelimiter",
  "rowGroupPanelShow",
  "multiSortKey",
  "pivotColumnGroupTotals",
  "pivotRowTotals",
  "pivotPanelShow",
  "fillHandleDirection",
  "groupDisplayType",
  "treeDataDisplayType",
  "treeDataChildrenField",
  "treeDataParentIdField",
  "colResizeDefault",
  "tooltipTrigger",
  "serverSidePivotResultFieldSeparator",
  "columnMenu",
  "tooltipShowMode",
  "invalidEditValueMode",
  "grandTotalRow",
  "themeCssLayer",
  "findSearchValue",
  "styleNonce",
  "renderingMode"
], BZe = [
  "components",
  "rowStyle",
  "context",
  "autoGroupColumnDef",
  "localeText",
  "icons",
  "datasource",
  "dragAndDropImageComponentParams",
  "serverSideDatasource",
  "viewportDatasource",
  "groupRowRendererParams",
  "aggFuncs",
  "fullWidthCellRendererParams",
  "defaultColGroupDef",
  "defaultColDef",
  "defaultCsvExportParams",
  "defaultExcelExportParams",
  "columnTypes",
  "rowClassRules",
  "detailCellRendererParams",
  "loadingCellRendererParams",
  "loadingOverlayComponentParams",
  "noRowsOverlayComponentParams",
  "popupParent",
  "themeStyleContainer",
  "statusBar",
  "chartThemeOverrides",
  "customChartThemes",
  "chartToolPanelsDef",
  "dataTypeDefinitions",
  "advancedFilterParent",
  "advancedFilterBuilderParams",
  "advancedFilterParams",
  "initialState",
  "autoSizeStrategy",
  "selectionColumnDef",
  "findOptions",
  "filterHandlers",
  "groupHierarchyConfig"
], $Ze = [
  "sortingOrder",
  "alignedGrids",
  "rowData",
  "columnDefs",
  "excelStyles",
  "pinnedTopRowData",
  "pinnedBottomRowData",
  "chartThemes",
  "rowClass",
  "paginationPageSizeSelector"
], py = [
  "rowHeight",
  "detailRowHeight",
  "rowBuffer",
  "headerHeight",
  "groupHeaderHeight",
  "groupLockGroupColumns",
  "floatingFiltersHeight",
  "pivotHeaderHeight",
  "pivotGroupHeaderHeight",
  "groupDefaultExpanded",
  "pivotDefaultExpanded",
  "viewportRowModelPageSize",
  "viewportRowModelBufferSize",
  "autoSizePadding",
  "maxBlocksInCache",
  "maxConcurrentDatasourceRequests",
  "tooltipShowDelay",
  "tooltipHideDelay",
  "cacheOverflowSize",
  "paginationPageSize",
  "cacheBlockSize",
  "infiniteInitialRowCount",
  "serverSideInitialRowCount",
  "scrollbarWidth",
  "asyncTransactionWaitMillis",
  "blockLoadDebounceMillis",
  "keepDetailRowsCount",
  "undoRedoCellEditingLimit",
  "cellFlashDuration",
  "cellFadeDuration",
  "tabIndex",
  "pivotMaxGeneratedColumns",
  "rowDragInsertDelay"
], ZZe = ["theme", "rowSelection"], GZe = [
  "cellSelection",
  "sideBar",
  "rowNumbers",
  "suppressGroupChangesColumnVisibility",
  "groupAggFiltering",
  "suppressStickyTotalRow",
  "groupHideParentOfSingleChild",
  "enableRowPinning"
], fy = [
  "loadThemeGoogleFonts",
  "suppressMakeColumnVisibleAfterUnGroup",
  "suppressRowClickSelection",
  "suppressCellFocus",
  "suppressHeaderFocus",
  "suppressHorizontalScroll",
  "groupSelectsChildren",
  "alwaysShowHorizontalScroll",
  "alwaysShowVerticalScroll",
  "debug",
  "enableBrowserTooltips",
  "enableCellExpressions",
  "groupSuppressBlankHeader",
  "suppressMenuHide",
  "suppressRowDeselection",
  "unSortIcon",
  "suppressMultiSort",
  "alwaysMultiSort",
  "singleClickEdit",
  "suppressLoadingOverlay",
  "suppressNoRowsOverlay",
  "suppressAutoSize",
  "skipHeaderOnAutoSize",
  "suppressColumnMoveAnimation",
  "suppressMoveWhenColumnDragging",
  "suppressMovableColumns",
  "suppressFieldDotNotation",
  "enableRangeSelection",
  "enableRangeHandle",
  "enableFillHandle",
  "suppressClearOnFillReduction",
  "deltaSort",
  "suppressTouch",
  "allowContextMenuWithControlKey",
  "suppressContextMenu",
  "suppressDragLeaveHidesColumns",
  "suppressRowGroupHidesColumns",
  "suppressMiddleClickScrolls",
  "suppressPreventDefaultOnMouseWheel",
  "suppressCopyRowsToClipboard",
  "copyHeadersToClipboard",
  "copyGroupHeadersToClipboard",
  "pivotMode",
  "suppressAggFuncInHeader",
  "suppressColumnVirtualisation",
  "alwaysAggregateAtRootLevel",
  "suppressFocusAfterRefresh",
  "functionsReadOnly",
  "animateRows",
  "groupSelectsFiltered",
  "groupRemoveSingleChildren",
  "groupRemoveLowestSingleChildren",
  "enableRtl",
  "enableCellSpan",
  "suppressClickEdit",
  "rowDragEntireRow",
  "rowDragManaged",
  "suppressRowDrag",
  "suppressMoveWhenRowDragging",
  "rowDragMultiRow",
  "enableGroupEdit",
  "embedFullWidthRows",
  "suppressPaginationPanel",
  "groupHideOpenParents",
  "groupAllowUnbalanced",
  "pagination",
  "paginationAutoPageSize",
  "suppressScrollOnNewData",
  "suppressScrollWhenPopupsAreOpen",
  "purgeClosedRowNodes",
  "cacheQuickFilter",
  "includeHiddenColumnsInQuickFilter",
  "ensureDomOrder",
  "accentedSort",
  "suppressChangeDetection",
  "valueCache",
  "valueCacheNeverExpires",
  "aggregateOnlyChangedColumns",
  "suppressAnimationFrame",
  "suppressExcelExport",
  "suppressCsvExport",
  "includeHiddenColumnsInAdvancedFilter",
  "suppressMultiRangeSelection",
  "enterNavigatesVerticallyAfterEdit",
  "enterNavigatesVertically",
  "suppressPropertyNamesCheck",
  "rowMultiSelectWithClick",
  "suppressRowHoverHighlight",
  "suppressRowTransform",
  "suppressClipboardPaste",
  "suppressLastEmptyLineOnPaste",
  "enableCharts",
  "suppressMaintainUnsortedOrder",
  "enableCellTextSelection",
  "suppressBrowserResizeObserver",
  "suppressMaxRenderedRowRestriction",
  "excludeChildrenWhenTreeDataFiltering",
  "tooltipMouseTrack",
  "tooltipInteraction",
  "keepDetailRows",
  "paginateChildRows",
  "preventDefaultOnContextMenu",
  "undoRedoCellEditing",
  "allowDragFromColumnsToolPanel",
  "pivotSuppressAutoColumn",
  "suppressExpandablePivotGroups",
  "debounceVerticalScrollbar",
  "detailRowAutoHeight",
  "serverSideSortAllLevels",
  "serverSideEnableClientSideSort",
  "serverSideOnlyRefreshFilteredGroups",
  "suppressAggFilteredOnly",
  "showOpenedGroup",
  "suppressClipboardApi",
  "suppressModelUpdateAfterUpdateTransaction",
  "stopEditingWhenCellsLoseFocus",
  "groupMaintainOrder",
  "columnHoverHighlight",
  "readOnlyEdit",
  "suppressRowVirtualisation",
  "enableCellEditingOnBackspace",
  "resetRowDataOnUpdate",
  "removePivotHeaderRowWhenSingleValueColumn",
  "suppressCopySingleCellRanges",
  "suppressGroupRowsSticky",
  "suppressCutToClipboard",
  "rowGroupPanelSuppressSort",
  "allowShowChangeAfterFilter",
  "enableAdvancedFilter",
  "masterDetail",
  "treeData",
  "reactiveCustomComponents",
  "applyQuickFilterBeforePivotOrAgg",
  "suppressServerSideFullWidthLoadingRow",
  "suppressAdvancedFilterEval",
  "loading",
  "maintainColumnOrder",
  "enableStrictPivotColumnOrder",
  "suppressSetFilterByDefault",
  "enableFilterHandlers",
  "suppressStartEditOnTab",
  "hidePaddedHeaderRows",
  "ssrmExpandAllAffectsAllRows"
], NZe = [
  "doesExternalFilterPass",
  "processPivotResultColDef",
  "processPivotResultColGroupDef",
  "getBusinessKeyForNode",
  "isRowSelectable",
  "rowDragText",
  "groupRowRenderer",
  "dragAndDropImageComponent",
  "fullWidthCellRenderer",
  "loadingCellRenderer",
  "loadingOverlayComponent",
  "noRowsOverlayComponent",
  "detailCellRenderer",
  "quickFilterParser",
  "quickFilterMatcher",
  "getLocaleText",
  "isExternalFilterPresent",
  "getRowHeight",
  "getRowClass",
  "getRowStyle",
  "getFullRowEditValidationErrors",
  "getContextMenuItems",
  "getMainMenuItems",
  "processRowPostCreate",
  "processCellForClipboard",
  "getGroupRowAgg",
  "isFullWidthRow",
  "sendToClipboard",
  "focusGridInnerElement",
  "navigateToNextHeader",
  "tabToNextHeader",
  "navigateToNextCell",
  "tabToNextCell",
  "processCellFromClipboard",
  "getDocument",
  "postProcessPopup",
  "getChildCount",
  "getDataPath",
  "isRowMaster",
  "postSortRows",
  "processHeaderForClipboard",
  "processUnpinnedColumns",
  "processGroupHeaderForClipboard",
  "paginationNumberFormatter",
  "processDataFromClipboard",
  "getServerSideGroupKey",
  "isServerSideGroup",
  "createChartContainer",
  "getChartToolbarItems",
  "fillOperation",
  "isApplyServerSideTransaction",
  "getServerSideGroupLevelParams",
  "isServerSideGroupOpenByDefault",
  "isGroupOpenByDefault",
  "initialGroupOrderComparator",
  "loadingCellRendererSelector",
  "getRowId",
  "chartMenuItems",
  "groupTotalRow",
  "alwaysPassFilter",
  "isRowPinnable",
  "isRowPinned",
  "isRowValidDropPosition"
], m5 = () => [
  ...$Ze,
  ...BZe,
  ...OZe,
  ...py,
  ...NZe,
  ...fy,
  ...GZe,
  ...ZZe
], zZe = () => ({
  suppressLoadingOverlay: { version: "32", message: "Use `loading`=false instead." },
  enableFillHandle: { version: "32.2", message: "Use `cellSelection.handle` instead." },
  enableRangeHandle: { version: "32.2", message: "Use `cellSelection.handle` instead." },
  enableRangeSelection: { version: "32.2", message: "Use `cellSelection = true` instead." },
  suppressMultiRangeSelection: {
    version: "32.2",
    message: "Use `cellSelection.suppressMultiRanges` instead."
  },
  suppressClearOnFillReduction: {
    version: "32.2",
    message: "Use `cellSelection.handle.suppressClearOnFillReduction` instead."
  },
  fillHandleDirection: { version: "32.2", message: "Use `cellSelection.handle.direction` instead." },
  fillOperation: { version: "32.2", message: "Use `cellSelection.handle.setFillValue` instead." },
  suppressRowClickSelection: {
    version: "32.2",
    message: "Use `rowSelection.enableClickSelection` instead."
  },
  suppressRowDeselection: { version: "32.2", message: "Use `rowSelection.enableClickSelection` instead." },
  rowMultiSelectWithClick: {
    version: "32.2",
    message: "Use `rowSelection.enableSelectionWithoutKeys` instead."
  },
  groupSelectsChildren: {
    version: "32.2",
    message: 'Use `rowSelection.groupSelects = "descendants"` instead.'
  },
  groupSelectsFiltered: {
    version: "32.2",
    message: 'Use `rowSelection.groupSelects = "filteredDescendants"` instead.'
  },
  isRowSelectable: { version: "32.2", message: "Use `selectionOptions.isRowSelectable` instead." },
  suppressCopySingleCellRanges: { version: "32.2", message: "Use `rowSelection.copySelectedRows` instead." },
  suppressCopyRowsToClipboard: { version: "32.2", message: "Use `rowSelection.copySelectedRows` instead." },
  onRangeSelectionChanged: { version: "32.2", message: "Use `onCellSelectionChanged` instead." },
  onRangeDeleteStart: { version: "32.2", message: "Use `onCellSelectionDeleteStart` instead." },
  onRangeDeleteEnd: { version: "32.2", message: "Use `onCellSelectionDeleteEnd` instead." },
  suppressBrowserResizeObserver: {
    version: "32.2",
    message: "The grid always uses the browser's ResizeObserver, this grid option has no effect."
  },
  onColumnEverythingChanged: {
    version: "32.2",
    message: "Either use `onDisplayedColumnsChanged` which is fired at the same time, or use one of the more specific column events."
  },
  groupRemoveSingleChildren: {
    version: "33",
    message: "Use `groupHideParentOfSingleChild` instead."
  },
  groupRemoveLowestSingleChildren: {
    version: "33",
    message: 'Use `groupHideParentOfSingleChild: "leafGroupsOnly"` instead.'
  },
  suppressRowGroupHidesColumns: {
    version: "33",
    message: 'Use `suppressGroupChangesColumnVisibility: "suppressHideOnGroup"` instead.'
  },
  suppressMakeColumnVisibleAfterUnGroup: {
    version: "33",
    message: 'Use `suppressGroupChangesColumnVisibility: "suppressShowOnUngroup"` instead.'
  },
  unSortIcon: { version: "33", message: "Use `defaultColDef.unSortIcon` instead." },
  sortingOrder: { version: "33", message: "Use `defaultColDef.sortingOrder` instead." },
  suppressPropertyNamesCheck: {
    version: "33",
    message: "`gridOptions` and `columnDefs` both have a `context` property that should be used for arbitrary user data. This means that column definitions and gridOptions should only contain valid properties making this property redundant."
  },
  suppressAdvancedFilterEval: {
    version: "34",
    message: "Advanced filter no longer uses function evaluation, so this option has no effect."
  }
});
function Wo(e, t, o) {
  return typeof t == "number" || t == null ? t == null || t >= o ? null : `${e}: value should be greater than or equal to ${o}` : `${e}: value should be a number`;
}
var jZe = {
  alignedGrids: "AlignedGrids",
  allowContextMenuWithControlKey: "ContextMenu",
  autoSizeStrategy: "ColumnAutoSize",
  cellSelection: "CellSelection",
  columnHoverHighlight: "ColumnHover",
  datasource: "InfiniteRowModel",
  doesExternalFilterPass: "ExternalFilter",
  editType: "EditCore",
  invalidEditValueMode: "EditCore",
  enableAdvancedFilter: "AdvancedFilter",
  enableCellSpan: "CellSpan",
  enableCharts: "IntegratedCharts",
  enableRangeSelection: "CellSelection",
  enableRowPinning: "PinnedRow",
  findSearchValue: "Find",
  getFullRowEditValidationErrors: "EditCore",
  getContextMenuItems: "ContextMenu",
  getLocaleText: "Locale",
  getMainMenuItems: "ColumnMenu",
  getRowClass: "RowStyle",
  getRowStyle: "RowStyle",
  groupTotalRow: "SharedRowGrouping",
  grandTotalRow: "SharedRowGrouping",
  initialState: "GridState",
  isExternalFilterPresent: "ExternalFilter",
  isRowPinnable: "PinnedRow",
  isRowPinned: "PinnedRow",
  localeText: "Locale",
  masterDetail: "SharedMasterDetail",
  pagination: "Pagination",
  pinnedBottomRowData: "PinnedRow",
  pinnedTopRowData: "PinnedRow",
  pivotMode: "SharedPivot",
  pivotPanelShow: "RowGroupingPanel",
  quickFilterText: "QuickFilter",
  rowClass: "RowStyle",
  rowClassRules: "RowStyle",
  rowData: "ClientSideRowModel",
  rowDragManaged: "RowDrag",
  rowGroupPanelShow: "RowGroupingPanel",
  rowNumbers: "RowNumbers",
  rowSelection: "SharedRowSelection",
  rowStyle: "RowStyle",
  serverSideDatasource: "ServerSideRowModel",
  sideBar: "SideBar",
  statusBar: "StatusBar",
  treeData: "SharedTreeData",
  undoRedoCellEditing: "UndoRedoEdit",
  valueCache: "ValueCache",
  viewportDatasource: "ViewportRowModel"
}, WZe = () => {
  const e = {
    autoSizePadding: {
      validate({ autoSizePadding: o }) {
        return Wo("autoSizePadding", o, 0);
      }
    },
    cacheBlockSize: {
      supportedRowModels: ["serverSide", "infinite"],
      validate({ cacheBlockSize: o }) {
        return Wo("cacheBlockSize", o, 1);
      }
    },
    cacheOverflowSize: {
      validate({ cacheOverflowSize: o }) {
        return Wo("cacheOverflowSize", o, 1);
      }
    },
    datasource: {
      supportedRowModels: ["infinite"]
    },
    domLayout: {
      validate: (o) => {
        const n = o.domLayout, s = ["autoHeight", "normal", "print"];
        return n && !s.includes(n) ? `domLayout must be one of [${s.join()}], currently it's ${n}` : null;
      }
    },
    enableFillHandle: {
      dependencies: {
        enableRangeSelection: { required: [!0] }
      }
    },
    enableRangeHandle: {
      dependencies: {
        enableRangeSelection: { required: [!0] }
      }
    },
    enableRangeSelection: {
      dependencies: {
        rowDragEntireRow: { required: [!1, void 0] }
      }
    },
    enableRowPinning: {
      supportedRowModels: ["clientSide"],
      validate({ enableRowPinning: o, pinnedTopRowData: n, pinnedBottomRowData: s }) {
        return o && (n || s) ? "Manual row pinning cannot be used together with pinned row data. Either set `enableRowPinning` to `false`, or remove `pinnedTopRowData` and `pinnedBottomRowData`." : null;
      }
    },
    isRowPinnable: {
      supportedRowModels: ["clientSide"],
      validate({ enableRowPinning: o, isRowPinnable: n, pinnedTopRowData: s, pinnedBottomRowData: i }) {
        return n && (s || i) ? "Manual row pinning cannot be used together with pinned row data. Either remove `isRowPinnable`, or remove `pinnedTopRowData` and `pinnedBottomRowData`." : !o && n ? "`isRowPinnable` requires `enableRowPinning` to be set." : null;
      }
    },
    isRowPinned: {
      supportedRowModels: ["clientSide"],
      validate({ enableRowPinning: o, isRowPinned: n, pinnedTopRowData: s, pinnedBottomRowData: i }) {
        return n && (s || i) ? "Manual row pinning cannot be used together with pinned row data. Either remove `isRowPinned`, or remove `pinnedTopRowData` and `pinnedBottomRowData`." : !o && n ? "`isRowPinned` requires `enableRowPinning` to be set." : null;
      }
    },
    groupDefaultExpanded: {
      supportedRowModels: ["clientSide"]
    },
    groupHideOpenParents: {
      supportedRowModels: ["clientSide", "serverSide"],
      dependencies: {
        groupTotalRow: { required: [void 0, "bottom"] },
        treeData: {
          required: [void 0, !1],
          reason: "Tree Data has values at the group level so it doesn't make sense to hide them."
        }
      }
    },
    groupHideParentOfSingleChild: {
      dependencies: {
        groupHideOpenParents: { required: [void 0, !1] }
      }
    },
    groupRemoveLowestSingleChildren: {
      dependencies: {
        groupHideOpenParents: { required: [void 0, !1] },
        groupRemoveSingleChildren: { required: [void 0, !1] }
      }
    },
    groupRemoveSingleChildren: {
      dependencies: {
        groupHideOpenParents: { required: [void 0, !1] },
        groupRemoveLowestSingleChildren: { required: [void 0, !1] }
      }
    },
    groupSelectsChildren: {
      dependencies: {
        rowSelection: { required: ["multiple"] }
      }
    },
    groupHierarchyConfig: {
      validate({ groupHierarchyConfig: o = {} }, n, s) {
        var i;
        for (const r of Object.keys(o))
          (i = s.validation) == null || i.validateColDef(o[r]);
        return null;
      }
    },
    icons: {
      validate: ({ icons: o }) => {
        if (o) {
          if (o.smallDown)
            return ln(262);
          if (o.smallLeft)
            return ln(263);
          if (o.smallRight)
            return ln(264);
        }
        return null;
      }
    },
    infiniteInitialRowCount: {
      validate({ infiniteInitialRowCount: o }) {
        return Wo("infiniteInitialRowCount", o, 1);
      }
    },
    initialGroupOrderComparator: {
      supportedRowModels: ["clientSide"]
    },
    ssrmExpandAllAffectsAllRows: {
      validate: (o) => {
        if (typeof o.ssrmExpandAllAffectsAllRows == "boolean") {
          if (o.rowModelType !== "serverSide")
            return "'ssrmExpandAllAffectsAllRows' is only supported with the Server Side Row Model.";
          if (o.ssrmExpandAllAffectsAllRows && typeof o.getRowId != "function")
            return "'getRowId' callback must be provided for Server Side Row Model grouping to work correctly.";
        }
        return null;
      }
    },
    keepDetailRowsCount: {
      validate({ keepDetailRowsCount: o }) {
        return Wo("keepDetailRowsCount", o, 1);
      }
    },
    paginationPageSize: {
      validate({ paginationPageSize: o }) {
        return Wo("paginationPageSize", o, 1);
      }
    },
    paginationPageSizeSelector: {
      validate: (o) => {
        const n = o.paginationPageSizeSelector;
        return typeof n == "boolean" || n == null || n.length ? null : `'paginationPageSizeSelector' cannot be an empty array.
                    If you want to hide the page size selector, set paginationPageSizeSelector to false.`;
      }
    },
    pivotMode: {
      dependencies: {
        treeData: {
          required: [!1, void 0],
          reason: "Pivot Mode is not supported with Tree Data."
        }
      }
    },
    quickFilterText: {
      supportedRowModels: ["clientSide"]
    },
    rowBuffer: {
      validate({ rowBuffer: o }) {
        return Wo("rowBuffer", o, 0);
      }
    },
    rowClass: {
      validate: (o) => typeof o.rowClass == "function" ? "rowClass should not be a function, please use getRowClass instead" : null
    },
    rowData: {
      supportedRowModels: ["clientSide"]
    },
    rowDragManaged: {
      supportedRowModels: ["clientSide"],
      dependencies: {
        pagination: {
          required: [!1, void 0]
        }
      }
    },
    rowSelection: {
      validate({ rowSelection: o }) {
        return o && typeof o == "string" ? 'As of version 32.2.1, using `rowSelection` with the values "single" or "multiple" has been deprecated. Use the object value instead.' : o && typeof o != "object" ? "Expected `RowSelectionOptions` object for the `rowSelection` property." : o && o.mode !== "multiRow" && o.mode !== "singleRow" ? `Selection mode "${o.mode}" is invalid. Use one of 'singleRow' or 'multiRow'.` : null;
      }
    },
    rowStyle: {
      validate: (o) => {
        const n = o.rowStyle;
        return n && typeof n == "function" ? "rowStyle should be an object of key/value styles, not be a function, use getRowStyle() instead" : null;
      }
    },
    serverSideDatasource: {
      supportedRowModels: ["serverSide"]
    },
    serverSideInitialRowCount: {
      supportedRowModels: ["serverSide"],
      validate({ serverSideInitialRowCount: o }) {
        return Wo("serverSideInitialRowCount", o, 1);
      }
    },
    serverSideOnlyRefreshFilteredGroups: {
      supportedRowModels: ["serverSide"]
    },
    serverSideSortAllLevels: {
      supportedRowModels: ["serverSide"]
    },
    sortingOrder: {
      validate: (o) => {
        const n = o.sortingOrder;
        if (Array.isArray(n) && n.length > 0) {
          const s = n.filter((i) => !Jr.includes(i));
          if (s.length > 0)
            return `sortingOrder must be an array with elements from [${Jr.map(yl).join()}], currently it includes [${s.map(yl).join()}]`;
        } else if (!Array.isArray(n) || n.length <= 0)
          return `sortingOrder must be an array with at least one element, currently it's ${n}`;
        return null;
      }
    },
    tooltipHideDelay: {
      validate: (o) => o.tooltipHideDelay && o.tooltipHideDelay < 0 ? "tooltipHideDelay should not be lower than 0" : null
    },
    tooltipShowDelay: {
      validate: (o) => o.tooltipShowDelay && o.tooltipShowDelay < 0 ? "tooltipShowDelay should not be lower than 0" : null
    },
    treeData: {
      supportedRowModels: ["clientSide", "serverSide"],
      validate: (o) => {
        const n = o.rowModelType ?? "clientSide";
        switch (n) {
          case "clientSide": {
            const { treeDataChildrenField: s, treeDataParentIdField: i, getDataPath: r, getRowId: l } = o;
            if (!s && !i && !r)
              return "treeData requires either 'treeDataChildrenField' or 'treeDataParentIdField' or 'getDataPath' in the clientSide row model.";
            if (s) {
              if (r)
                return "Cannot use both 'treeDataChildrenField' and 'getDataPath' at the same time.";
              if (i)
                return "Cannot use both 'treeDataChildrenField' and 'treeDataParentIdField' at the same time.";
            }
            if (i) {
              if (!l)
                return "getRowId callback not provided, tree data with parent id cannot be built.";
              if (r)
                return "Cannot use both 'treeDataParentIdField' and 'getDataPath' at the same time.";
            }
            return null;
          }
          case "serverSide": {
            const s = `treeData requires 'isServerSideGroup' and 'getServerSideGroupKey' in the ${n} row model.`;
            return o.isServerSideGroup && o.getServerSideGroupKey ? null : s;
          }
        }
        return null;
      }
    },
    viewportDatasource: {
      supportedRowModels: ["viewport"]
    },
    viewportRowModelBufferSize: {
      validate({ viewportRowModelBufferSize: o }) {
        return Wo("viewportRowModelBufferSize", o, 0);
      }
    },
    viewportRowModelPageSize: {
      validate({ viewportRowModelPageSize: o }) {
        return Wo("viewportRowModelPageSize", o, 1);
      }
    },
    rowDragEntireRow: {
      dependencies: {
        cellSelection: { required: [void 0] }
      }
    },
    autoGroupColumnDef: {
      validate({ autoGroupColumnDef: o, showOpenedGroup: n }) {
        return o != null && o.field && n ? "autoGroupColumnDef.field and showOpenedGroup are not supported when used together." : o != null && o.valueGetter && n ? "autoGroupColumnDef.valueGetter and showOpenedGroup are not supported when used together." : null;
      }
    },
    renderingMode: {
      validate: (o) => {
        const n = o.renderingMode, s = ["default", "legacy"];
        return n && !s.includes(n) ? `renderingMode must be one of [${s.join()}], currently it's ${n}` : null;
      }
    }
  }, t = {};
  return fy.forEach((o) => {
    t[o] = { expectedType: "boolean" };
  }), py.forEach((o) => {
    t[o] = { expectedType: "number" };
  }), qt(t, e), t;
}, UZe = () => ({
  objectName: "gridOptions",
  allProperties: [...m5(), ...Object.values(Sa)],
  propertyExceptions: ["api"],
  docsUrl: "grid-options/",
  deprecations: zZe(),
  validations: WZe()
}), KZe = 0, qZe = 0, fu = "__ag_grid_instance", YZe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "gos", this.domDataKey = "__AG_" + Math.random().toString(), this.instanceId = qZe++, this.gridReadyFired = !1, this.queueEvents = [], this.propEventSvc = new ls(), this.globalEventHandlerFactory = (e) => (t, o) => {
      if (!this.isAlive())
        return;
      const n = Rr.has(t);
      if (n && !e || !n && e || !QZe(t))
        return;
      const s = (i, r) => {
        const l = Sa[i], a = this.gridOptions[l];
        typeof a == "function" && this.beans.frameworkOverrides.wrapOutgoing(() => a(r));
      };
      if (this.gridReadyFired)
        s(t, o);
      else if (t === "gridReady") {
        s(t, o), this.gridReadyFired = !0;
        for (const i of this.queueEvents)
          s(i.eventName, i.event);
        this.queueEvents = [];
      } else
        this.queueEvents.push({ eventName: t, event: o });
    };
  }
  wireBeans(e) {
    this.gridOptions = e.gridOptions, this.validation = e.validation, this.api = e.gridApi, this.gridId = e.context.getId();
  }
  // This is quicker then having code call gridOptionsService.get('context')
  get gridOptionsContext() {
    return this.gridOptions.context;
  }
  postConstruct() {
    this.validateGridOptions(this.gridOptions), this.eventSvc.addGlobalListener(this.globalEventHandlerFactory().bind(this), !0), this.eventSvc.addGlobalListener(this.globalEventHandlerFactory(!0).bind(this), !1), this.propEventSvc.setFrameworkOverrides(this.beans.frameworkOverrides), this.addManagedEventListeners({
      gridOptionsChanged: ({ options: e }) => {
        this.updateGridOptions({ options: e, force: !0, source: "optionsUpdated" });
      }
    });
  }
  destroy() {
    super.destroy(), this.queueEvents = [];
  }
  /**
   * Get the raw value of the GridOptions property provided.
   * @param property
   */
  get(e) {
    return this.gridOptions[e] ?? pIe[e];
  }
  /**
   * Get the GridOption callback but wrapped so that the common params of api and context are automatically applied to the params.
   * @param property GridOption callback properties based on the fact that this property has a callback with params extending AgGridCommon
   */
  getCallback(e) {
    return this.mergeGridCommonParams(this.gridOptions[e]);
  }
  /**
   * Returns `true` if a value has been specified for this GridOption.
   * @param property GridOption property
   */
  exists(e) {
    return ue(this.gridOptions[e]);
  }
  /**
   * Wrap the user callback and attach the api and context to the params object on the way through.
   * @param callback User provided callback
   * @returns Wrapped callback where the params object not require api and context
   */
  mergeGridCommonParams(e) {
    return e && ((o) => e(this.addCommon(o)));
  }
  updateGridOptions({
    options: e,
    force: t,
    source: o = "api"
  }) {
    const n = { id: KZe++, properties: [] }, s = [], { gridOptions: i, validation: r } = this;
    for (const l of Object.keys(e)) {
      const a = e[l];
      r == null || r.warnOnInitialPropertyUpdate(o, l);
      const c = t || typeof a == "object" && o === "api", d = i[l];
      if (c || d !== a) {
        i[l] = a;
        const u = {
          type: l,
          currentValue: a,
          previousValue: d,
          changeSet: n,
          source: o
        };
        s.push(u);
      }
    }
    this.validateGridOptions(this.gridOptions), n.properties = s.map((l) => l.type), s.forEach((l) => {
      cs(this, `Updated property ${l.type} from`, l.previousValue, " to ", l.currentValue), this.propEventSvc.dispatchEvent(l);
    });
  }
  addPropertyEventListener(e, t) {
    this.propEventSvc.addEventListener(e, t);
  }
  removePropertyEventListener(e, t) {
    this.propEventSvc.removeEventListener(e, t);
  }
  getDomDataKey() {
    return this.domDataKey;
  }
  /** Prefer _addGridCommonParams from gridOptionsUtils for bundle size savings */
  addCommon(e) {
    return e.api = this.api, e.context = this.gridOptionsContext, e;
  }
  validateOptions(e, t) {
    for (const o of Object.keys(e)) {
      const n = e[o];
      if (n == null || n === !1)
        continue;
      let s = t[o];
      typeof s == "function" && (s = s(e, this.gridOptions, this.beans)), s && this.assertModuleRegistered(s, o);
    }
  }
  validateGridOptions(e) {
    var t;
    this.validateOptions(e, jZe), (t = this.validation) == null || t.processGridOptions(e);
  }
  validateColDef(e, t, o) {
    var n, s;
    (o || !((n = this.beans.dataTypeSvc) != null && n.isColPendingInference(t))) && (this.validateOptions(e, IZe), (s = this.validation) == null || s.validateColDef(e));
  }
  assertModuleRegistered(e, t) {
    const o = Array.isArray(e) ? e.some((n) => this.isModuleRegistered(n)) : this.isModuleRegistered(e);
    return o || qe(200, {
      ...this.getModuleErrorParams(),
      moduleName: e,
      reasonOrId: t
    }), o;
  }
  getModuleErrorParams() {
    return {
      gridId: this.gridId,
      gridScoped: oc(),
      rowModelType: this.get("rowModelType"),
      isUmd: F$e()
    };
  }
  isModuleRegistered(e) {
    return v5(e, this.gridId, this.get("rowModelType"));
  }
  setInstanceDomData(e) {
    e[fu] = this.instanceId;
  }
  isElementInThisInstance(e) {
    let t = e;
    for (; t; ) {
      const o = t[fu];
      if (ue(o))
        return o === this.instanceId;
      t = t.parentElement;
    }
    return !1;
  }
};
function QZe(e) {
  return !!Sa[e];
}
function vy(e) {
  const t = { "aria-hidden": "true" };
  return {
    tag: "div",
    cls: "ag-cell-label-container",
    role: "presentation",
    children: [
      {
        tag: "span",
        ref: "eMenu",
        cls: "ag-header-icon ag-header-cell-menu-button",
        attrs: t
      },
      {
        tag: "span",
        ref: "eFilterButton",
        cls: "ag-header-icon ag-header-cell-filter-button",
        attrs: t
      },
      {
        tag: "div",
        ref: "eLabel",
        cls: "ag-header-cell-label",
        role: "presentation",
        children: [
          { tag: "span", ref: "eText", cls: "ag-header-cell-text" },
          {
            tag: "span",
            ref: "eFilter",
            cls: "ag-header-icon ag-header-label-icon ag-filter-icon",
            attrs: t
          },
          e ? { tag: "ag-sort-indicator", ref: "eSortIndicator" } : null
        ]
      }
    ]
  };
}
var JZe = vy(!0), XZe = vy(!1), eGe = class extends Re {
  constructor() {
    super(...arguments), this.eFilter = J, this.eFilterButton = J, this.eSortIndicator = J, this.eMenu = J, this.eLabel = J, this.eText = J, this.eSortOrder = J, this.eSortAsc = J, this.eSortDesc = J, this.eSortMixed = J, this.eSortNone = J, this.isLoadingInnerComponent = !1;
  }
  refresh(e) {
    var o, n, s;
    const t = this.params;
    if (this.params = e, this.workOutTemplate(e, !!((o = this.beans) != null && o.sortSvc)) != this.currentTemplate || this.workOutShowMenu() != this.currentShowMenu || e.enableSorting != this.currentSort || this.currentSuppressMenuHide != null && this.shouldSuppressMenuHide() != this.currentSuppressMenuHide || t.enableFilterButton != e.enableFilterButton || t.enableFilterIcon != e.enableFilterIcon)
      return !1;
    if (this.innerHeaderComponent) {
      const i = { ...e };
      qt(i, e.innerHeaderComponentParams), (s = (n = this.innerHeaderComponent).refresh) == null || s.call(n, i);
    } else
      this.setDisplayName(e);
    return !0;
  }
  workOutTemplate(e, t) {
    const o = e.template;
    return o ? o != null && o.trim ? o.trim() : o : t ? JZe : XZe;
  }
  init(e) {
    this.params = e;
    const { sortSvc: t, touchSvc: o, rowNumbersSvc: n, userCompFactory: s } = this.beans, i = t == null ? void 0 : t.getSortIndicatorSelector();
    this.currentTemplate = this.workOutTemplate(e, !!i), this.setTemplate(this.currentTemplate, i ? [i] : void 0), o == null || o.setupForHeader(this), this.setMenu(), this.setupSort(), n == null || n.setupForHeader(this), this.setupFilterIcon(), this.setupFilterButton(), this.workOutInnerHeaderComponent(s, e), this.setDisplayName(e);
  }
  workOutInnerHeaderComponent(e, t) {
    const o = ADe(e, t, t);
    o && (this.isLoadingInnerComponent = !0, o.newAgStackInstance().then((n) => {
      this.isLoadingInnerComponent = !1, n && (this.isAlive() ? (this.innerHeaderComponent = n, this.eText && this.eText.appendChild(n.getGui())) : this.destroyBean(n));
    }));
  }
  setDisplayName(e) {
    const { displayName: t } = e, o = this.currentDisplayName;
    this.currentDisplayName = t, !(!this.eText || o === t || this.innerHeaderComponent || this.isLoadingInnerComponent) && (this.eText.textContent = ni(t));
  }
  addInIcon(e, t, o) {
    const n = Ie(e, this.beans, o);
    n && t.appendChild(n);
  }
  workOutShowMenu() {
    var e;
    return this.params.enableMenu && !!((e = this.beans.menuSvc) != null && e.isHeaderMenuButtonEnabled());
  }
  shouldSuppressMenuHide() {
    var e;
    return !!((e = this.beans.menuSvc) != null && e.isHeaderMenuButtonAlwaysShowEnabled());
  }
  setMenu() {
    if (!this.eMenu)
      return;
    if (this.currentShowMenu = this.workOutShowMenu(), !this.currentShowMenu) {
      Kt(this.eMenu), this.eMenu = void 0;
      return;
    }
    const { gos: e, eMenu: t, params: o } = this, n = $t(e);
    this.addInIcon(n ? "menu" : "menuAlt", t, o.column), t.classList.toggle("ag-header-menu-icon", !n);
    const s = this.shouldSuppressMenuHide();
    this.currentSuppressMenuHide = s, this.addManagedElementListeners(t, { click: () => this.showColumnMenu(this.eMenu) }), this.toggleMenuAlwaysShow(s);
  }
  toggleMenuAlwaysShow(e) {
    var t;
    (t = this.eMenu) == null || t.classList.toggle("ag-header-menu-always-show", e);
  }
  showColumnMenu(e) {
    const { currentSuppressMenuHide: t, params: o } = this;
    t || this.toggleMenuAlwaysShow(!0), o.showColumnMenu(e, () => {
      t || this.toggleMenuAlwaysShow(!1);
    });
  }
  onMenuKeyboardShortcut(e) {
    var a;
    const { params: t, gos: o, beans: n, eMenu: s, eFilterButton: i } = this, r = t.column, l = $t(o);
    if (e && !l) {
      if ((a = n.menuSvc) != null && a.isFilterMenuInHeaderEnabled(r))
        return t.showFilter(i ?? s ?? this.getGui()), !0;
    } else if (t.enableMenu)
      return this.showColumnMenu(s ?? i ?? this.getGui()), !0;
    return !1;
  }
  setupSort() {
    const { sortSvc: e } = this.beans;
    if (!e)
      return;
    const { enableSorting: t, column: o } = this.params;
    if (this.currentSort = t, !this.eSortIndicator) {
      this.eSortIndicator = this.createBean(e.createSortIndicator(!0));
      const { eSortIndicator: n, eSortOrder: s, eSortAsc: i, eSortDesc: r, eSortMixed: l, eSortNone: a } = this;
      n.attachCustomElements(s, i, r, l, a);
    }
    this.eSortIndicator.setupSort(o), this.currentSort && e.setupHeader(this, o, this.eLabel);
  }
  setupFilterIcon() {
    const { eFilter: e, params: t } = this;
    if (!e)
      return;
    const o = () => {
      const n = t.column.isFilterActive();
      He(e, n, { skipAriaHidden: !0 });
    };
    this.configureFilter(t.enableFilterIcon, e, o, "filterActive");
  }
  setupFilterButton() {
    const { eFilterButton: e, params: t } = this;
    if (!e)
      return;
    this.configureFilter(
      t.enableFilterButton,
      e,
      this.onFilterChangedButton.bind(this),
      "filter"
    ) ? this.addManagedElementListeners(e, {
      click: () => t.showFilter(e)
    }) : this.eFilterButton = void 0;
  }
  configureFilter(e, t, o, n) {
    if (!e)
      return Kt(t), !1;
    const s = this.params.column;
    return this.addInIcon(n, t, s), this.addManagedListeners(s, { filterChanged: o }), o(), !0;
  }
  onFilterChangedButton() {
    const e = this.params.column.isFilterActive();
    this.eFilterButton.classList.toggle("ag-filter-active", e);
  }
  getAnchorElementForMenu(e) {
    const { eFilterButton: t, eMenu: o } = this;
    return e ? t ?? o ?? this.getGui() : o ?? t ?? this.getGui();
  }
  destroy() {
    super.destroy(), this.innerHeaderComponent && (this.destroyBean(this.innerHeaderComponent), this.innerHeaderComponent = void 0);
  }
}, tGe = {
  tag: "div",
  cls: "ag-header-group-cell-label",
  role: "presentation",
  children: [
    { tag: "span", ref: "agLabel", cls: "ag-header-group-text", role: "presentation" },
    { tag: "span", ref: "agOpened", cls: "ag-header-icon ag-header-expand-icon ag-header-expand-icon-expanded" },
    { tag: "span", ref: "agClosed", cls: "ag-header-icon ag-header-expand-icon ag-header-expand-icon-collapsed" }
  ]
}, oGe = class extends Re {
  constructor() {
    super(tGe), this.agOpened = J, this.agClosed = J, this.agLabel = J, this.isLoadingInnerComponent = !1;
  }
  init(e) {
    const { userCompFactory: t, touchSvc: o } = this.beans;
    this.params = e, this.checkWarnings(), this.workOutInnerHeaderGroupComponent(t, e), this.setupLabel(e), this.addGroupExpandIcon(e), this.setupExpandIcons(), o == null || o.setupForHeaderGroup(this);
  }
  checkWarnings() {
    this.params.template && X(89);
  }
  workOutInnerHeaderGroupComponent(e, t) {
    const o = EDe(e, t, t);
    o && (this.isLoadingInnerComponent = !0, o.newAgStackInstance().then((n) => {
      this.isLoadingInnerComponent = !1, n && (this.isAlive() ? (this.innerHeaderGroupComponent = n, this.agLabel.appendChild(n.getGui())) : this.destroyBean(n));
    }));
  }
  setupExpandIcons() {
    const {
      agOpened: e,
      agClosed: t,
      params: { columnGroup: o },
      beans: n
    } = this;
    this.addInIcon("columnGroupOpened", e), this.addInIcon("columnGroupClosed", t);
    const s = (a) => {
      if (wo(a))
        return;
      const c = !o.isExpanded();
      n.colGroupSvc.setColumnGroupOpened(
        o.getProvidedColumnGroup(),
        c,
        "uiColumnExpanded"
      );
    };
    this.addTouchAndClickListeners(n, t, s), this.addTouchAndClickListeners(n, e, s);
    const i = (a) => {
      vt(a);
    };
    this.addManagedElementListeners(t, { dblclick: i }), this.addManagedElementListeners(e, { dblclick: i }), this.addManagedElementListeners(this.getGui(), { dblclick: s }), this.updateIconVisibility();
    const r = o.getProvidedColumnGroup(), l = this.updateIconVisibility.bind(this);
    this.addManagedListeners(r, {
      expandedChanged: l,
      expandableChanged: l
    });
  }
  addTouchAndClickListeners(e, t, o) {
    var n;
    (n = e.touchSvc) == null || n.setupForHeaderGroupElement(this, t, o), this.addManagedElementListeners(t, { click: o });
  }
  updateIconVisibility() {
    const {
      agOpened: e,
      agClosed: t,
      params: { columnGroup: o }
    } = this;
    if (o.isExpandable()) {
      const n = o.isExpanded();
      He(e, n), He(t, !n);
    } else
      He(e, !1), He(t, !1);
  }
  addInIcon(e, t) {
    const o = Ie(e, this.beans, null);
    o && t.appendChild(o);
  }
  addGroupExpandIcon(e) {
    if (!e.columnGroup.isExpandable()) {
      const { agOpened: t, agClosed: o } = this;
      He(t, !1), He(o, !1);
      return;
    }
  }
  setupLabel(e) {
    var s;
    const { displayName: t, columnGroup: o } = e, n = this.innerHeaderGroupComponent || this.isLoadingInnerComponent;
    ue(t) && !n && (this.agLabel.textContent = ni(t)), this.toggleCss("ag-sticky-label", !((s = o.getColGroupDef()) != null && s.suppressStickyLabel));
  }
  destroy() {
    super.destroy(), this.innerHeaderGroupComponent && (this.destroyBean(this.innerHeaderGroupComponent), this.innerHeaderGroupComponent = void 0);
  }
}, nGe = {
  moduleName: "ColumnHeaderComp",
  version: be,
  userComponents: {
    agColumnHeader: eGe
  },
  icons: {
    // button to launch legacy column menu
    menu: "menu",
    // button to launch new enterprise column menu
    menuAlt: "menu-alt"
  }
}, sGe = {
  moduleName: "ColumnGroupHeaderComp",
  version: be,
  userComponents: {
    agColumnGroupHeader: oGe
  },
  icons: {
    // header column group shown when expanded (click to contract)
    columnGroupOpened: "expanded",
    // header column group shown when contracted (click to expand)
    columnGroupClosed: "contracted"
  }
}, iGe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "animationFrameSvc", this.p1 = { list: [], sorted: !1 }, this.p2 = { list: [], sorted: !1 }, this.f1 = { list: [], sorted: !1 }, this.destroyTasks = [], this.ticking = !1, this.scrollGoingDown = !0, this.lastScrollTop = 0, this.taskCount = 0;
  }
  setScrollTop(e) {
    this.scrollGoingDown = e >= this.lastScrollTop, e === 0 && (this.scrollGoingDown = !0), this.lastScrollTop = e;
  }
  postConstruct() {
    this.active = !this.gos.get("suppressAnimationFrame"), this.batchFrameworkComps = this.beans.frameworkOverrides.batchFrameworkComps;
  }
  // this method is for our AG Grid sanity only - if animation frames are turned off,
  // then no place in the code should be looking to add any work to be done in animation
  // frames. this stops bugs - where some code is asking for a frame to be executed
  // when it should not.
  verify() {
    this.active === !1 && X(92);
  }
  createTask(e, t, o, n, s = !1) {
    this.verify();
    let i = o;
    n && this.batchFrameworkComps && (i = "f1");
    const r = { task: e, index: t, createOrder: ++this.taskCount, deferred: s };
    this.addTaskToList(this[i], r), this.schedule();
  }
  addTaskToList(e, t) {
    e.list.push(t), e.sorted = !1;
  }
  sortTaskList(e) {
    if (e.sorted)
      return;
    const t = this.scrollGoingDown ? 1 : -1;
    e.list.sort((o, n) => o.deferred !== n.deferred ? o.deferred ? -1 : 1 : o.index !== n.index ? t * (n.index - o.index) : n.createOrder - o.createOrder), e.sorted = !0;
  }
  addDestroyTask(e) {
    this.verify(), this.destroyTasks.push(e), this.schedule();
  }
  executeFrame(e) {
    const { p1: t, p2: o, f1: n, destroyTasks: s, beans: i } = this, { ctrlsSvc: r, frameworkOverrides: l } = i, a = t.list, c = o.list, d = n.list, u = Date.now();
    let h = 0;
    const p = e <= 0, C = r.getScrollFeature();
    for (; p || h < e; ) {
      if (!C.scrollGridIfNeeded()) {
        let w;
        if (a.length)
          this.sortTaskList(t), w = a.pop().task;
        else if (c.length)
          this.sortTaskList(o), w = c.pop().task;
        else if (d.length)
          l.wrapOutgoing(() => {
            for (; (p || h < e) && !C.scrollGridIfNeeded(); ) {
              if (d.length)
                this.sortTaskList(n), w = d.pop().task, w();
              else
                break;
              h = Date.now() - u;
            }
          }), w = () => {
          };
        else if (s.length)
          w = s.pop();
        else
          break;
        w();
      }
      h = Date.now() - u;
    }
    a.length || c.length || d.length || s.length ? this.requestFrame() : this.ticking = !1;
  }
  flushAllFrames() {
    this.active && this.executeFrame(-1);
  }
  schedule() {
    this.active && (this.ticking || (this.ticking = !0, this.requestFrame()));
  }
  requestFrame() {
    const e = this.executeFrame.bind(this, 60);
    yo(this.beans, e);
  }
  isQueueEmpty() {
    return !this.ticking;
  }
}, rGe = {
  moduleName: "AnimationFrame",
  version: be,
  beans: [iGe]
}, lGe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "iconSvc";
  }
  createIconNoSpan(e, t) {
    return Ie(e, this.beans, t == null ? void 0 : t.column);
  }
}, aGe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "touchSvc";
  }
  mockBodyContextMenu(e, t) {
    this.mockContextMenu(e, e.eBodyViewport, t);
  }
  mockHeaderContextMenu(e, t) {
    this.mockContextMenu(e, e.eGui, t);
  }
  mockRowContextMenu(e) {
    if (!ss())
      return;
    const t = (o, n, s) => {
      var l;
      const { rowCtrl: i, cellCtrl: r } = e.getControlsForEventTarget((s == null ? void 0 : s.target) ?? null);
      r != null && r.column && r.dispatchCellContextMenuEvent(s ?? null), (l = this.beans.contextMenuSvc) == null || l.handleContextMenuMouseEvent(void 0, s, i, r);
    };
    this.mockContextMenu(e, e.element, t);
  }
  handleCellDoubleClick(e, t) {
    return (() => {
      if (!ss() || gw("dblclick"))
        return !1;
      const n = Date.now(), s = n - e.lastIPadMouseClickEvent < 200;
      return e.lastIPadMouseClickEvent = n, s;
    })() ? (e.onCellDoubleClicked(t), t.preventDefault(), !0) : !1;
  }
  setupForHeader(e) {
    const { gos: t, sortSvc: o, menuSvc: n } = this.beans;
    if (t.get("suppressTouch"))
      return;
    const { params: s, eMenu: i, eFilterButton: r } = e, l = new _n(e.getGui(), !0), a = e.shouldSuppressMenuHide(), c = a && ue(i) && s.enableMenu, d = c ? new _n(i, !0) : l;
    if (s.enableMenu || n != null && n.isHeaderContextMenuEnabled(s.column)) {
      const u = c ? "tap" : "longTap", h = (p) => s.showColumnMenuAfterMouseClick(p.touchStart);
      e.addManagedListeners(d, { [u]: h });
    }
    if (s.enableSorting) {
      const u = (h) => {
        const p = h.touchStart.target;
        a && (i != null && i.contains(p) || r != null && r.contains(p)) || o == null || o.progressSort(s.column, !1, "uiColumnSorted");
      };
      e.addManagedListeners(l, { tap: u });
    }
    if (s.enableFilterButton && r) {
      const u = new _n(r, !0);
      e.addManagedListeners(u, {
        tap: () => s.showFilter(r)
      }), e.addDestroyFunc(() => u.destroy());
    }
    e.addDestroyFunc(() => l.destroy()), c && e.addDestroyFunc(() => d.destroy());
  }
  setupForHeaderGroup(e) {
    var o;
    const t = e.params;
    if ((o = this.beans.menuSvc) != null && o.isHeaderContextMenuEnabled(
      t.columnGroup.getProvidedColumnGroup()
    )) {
      const n = new _n(t.eGridHeader, !0), s = (i) => t.showColumnMenuAfterMouseClick(i.touchStart);
      e.addManagedListeners(n, { longTap: s }), e.addDestroyFunc(() => n.destroy());
    }
  }
  setupForHeaderGroupElement(e, t, o) {
    const n = new _n(t, !0);
    e.addManagedListeners(n, { tap: o }), e.addDestroyFunc(() => n.destroy());
  }
  mockContextMenu(e, t, o) {
    if (!ss())
      return;
    const n = new _n(t), s = (i) => {
      zr(this.beans, i.touchEvent) && o(void 0, i.touchStart, i.touchEvent);
    };
    e.addManagedListeners(n, { longTap: s }), e.addDestroyFunc(() => n.destroy());
  }
}, cGe = {
  moduleName: "Touch",
  version: be,
  beans: [aGe]
}, dGe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "cellNavigation";
  }
  wireBeans(e) {
    this.rowSpanSvc = e.rowSpanSvc;
  }
  // returns null if no cell to focus on, ie at the end of the grid
  getNextCellToFocus(e, t, o = !1) {
    return o ? this.getNextCellToFocusWithCtrlPressed(e, t) : this.getNextCellToFocusWithoutCtrlPressed(e, t);
  }
  getNextCellToFocusWithCtrlPressed(e, t) {
    const o = e === D.UP, n = e === D.DOWN, s = e === D.LEFT;
    let i, r;
    const { pageBounds: l, gos: a, visibleCols: c, pinnedRowModel: d } = this.beans, { rowPinned: u } = t;
    if (o || n)
      u && d ? o ? r = 0 : r = u === "top" ? d.getPinnedTopRowCount() - 1 : d.getPinnedBottomRowCount() - 1 : r = o ? l.getFirstRow() : l.getLastRow(), i = t.column;
    else {
      const h = a.get("enableRtl");
      r = t.rowIndex, i = (s !== h ? c.allCols : [...c.allCols].reverse()).find(
        (C) => this.isCellGoodToFocusOn({
          rowIndex: r,
          rowPinned: null,
          column: C
        })
      );
    }
    return i ? {
      rowIndex: r,
      rowPinned: u,
      column: i
    } : null;
  }
  getNextCellToFocusWithoutCtrlPressed(e, t) {
    let o = t, n = !1;
    for (; !n; ) {
      switch (e) {
        case D.UP:
          o = this.getCellAbove(o);
          break;
        case D.DOWN:
          o = this.getCellBelow(o);
          break;
        case D.RIGHT:
          o = this.gos.get("enableRtl") ? this.getCellToLeft(o) : this.getCellToRight(o);
          break;
        case D.LEFT:
          o = this.gos.get("enableRtl") ? this.getCellToRight(o) : this.getCellToLeft(o);
          break;
        default:
          o = null, X(8, { key: e });
          break;
      }
      o ? n = this.isCellGoodToFocusOn(o) : n = !0;
    }
    return o;
  }
  isCellGoodToFocusOn(e) {
    const t = e.column;
    let o;
    const { pinnedRowModel: n, rowModel: s } = this.beans;
    switch (e.rowPinned) {
      case "top":
        o = n == null ? void 0 : n.getPinnedTopRow(e.rowIndex);
        break;
      case "bottom":
        o = n == null ? void 0 : n.getPinnedBottomRow(e.rowIndex);
        break;
      default:
        o = s.getRow(e.rowIndex);
        break;
    }
    return o ? !this.isSuppressNavigable(t, o) : !1;
  }
  getCellToLeft(e) {
    if (!e)
      return null;
    const t = this.beans.visibleCols.getColBefore(e.column);
    return t ? {
      rowIndex: e.rowIndex,
      column: t,
      rowPinned: e.rowPinned
    } : null;
  }
  getCellToRight(e) {
    if (!e)
      return null;
    const t = this.beans.visibleCols.getColAfter(e.column);
    return t ? {
      rowIndex: e.rowIndex,
      column: t,
      rowPinned: e.rowPinned
    } : null;
  }
  getCellBelow(e) {
    var n;
    if (!e)
      return null;
    const t = ((n = this.rowSpanSvc) == null ? void 0 : n.getCellEnd(e)) ?? e, o = tu(this.beans, t, !0);
    return o ? {
      rowIndex: o.rowIndex,
      column: e.column,
      rowPinned: o.rowPinned
    } : null;
  }
  getCellAbove(e) {
    var n;
    if (!e)
      return null;
    const t = ((n = this.rowSpanSvc) == null ? void 0 : n.getCellStart(e)) ?? e, o = Dl(
      this.beans,
      {
        rowIndex: t.rowIndex,
        rowPinned: t.rowPinned
      },
      !0
    );
    return o ? {
      rowIndex: o.rowIndex,
      column: e.column,
      rowPinned: o.rowPinned
    } : null;
  }
  getNextTabbedCell(e, t) {
    return t ? this.getNextTabbedCellBackwards(e) : this.getNextTabbedCellForwards(e);
  }
  getNextTabbedCellForwards(e) {
    const { visibleCols: t, pagination: o } = this.beans, n = t.allCols;
    let s = e.rowIndex, i = e.rowPinned, r = t.getColAfter(e.column);
    if (!r) {
      r = n[0];
      const l = tu(this.beans, e, !0);
      if (Xe(l) || !l.rowPinned && !((o == null ? void 0 : o.isRowInPage(l.rowIndex)) ?? !0))
        return null;
      s = l ? l.rowIndex : null, i = l ? l.rowPinned : null;
    }
    return { rowIndex: s, column: r, rowPinned: i };
  }
  getNextTabbedCellBackwards(e) {
    const { beans: t } = this, { visibleCols: o, pagination: n } = t, s = o.allCols;
    let i = e.rowIndex, r = e.rowPinned, l = o.getColBefore(e.column);
    if (!l) {
      l = Ke(s);
      const a = Dl(t, { rowIndex: e.rowIndex, rowPinned: e.rowPinned }, !0);
      if (Xe(a) || !a.rowPinned && !((n == null ? void 0 : n.isRowInPage(a.rowIndex)) ?? !0))
        return null;
      i = a ? a.rowIndex : null, r = a ? a.rowPinned : null;
    }
    return { rowIndex: i, column: l, rowPinned: r };
  }
  isSuppressNavigable(e, t) {
    const { suppressNavigable: o } = e.colDef;
    if (typeof o == "boolean")
      return o;
    if (typeof o == "function") {
      const n = e.createColumnFunctionCallbackParams(t);
      return o(n);
    }
    return !1;
  }
};
function uGe(e) {
  return e.focusSvc.getFocusedCell();
}
function hGe(e) {
  return e.focusSvc.clearFocusedCell();
}
function gGe(e, t, o, n) {
  e.focusSvc.setFocusedCell({ rowIndex: t, column: o, rowPinned: n, forceBrowserFocus: !0 });
}
function pGe(e, t) {
  var o;
  return ((o = e.navigation) == null ? void 0 : o.tabToNextCell(!1, t)) ?? !1;
}
function fGe(e, t) {
  var o;
  return ((o = e.navigation) == null ? void 0 : o.tabToNextCell(!0, t)) ?? !1;
}
function vGe(e, t, o = !1) {
  var s;
  const n = (s = e.headerNavigation) == null ? void 0 : s.getHeaderPositionForColumn(t, o);
  n && e.focusSvc.focusHeaderPosition({ headerPosition: n });
}
var mGe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "editModelSvc", this.edits = /* @__PURE__ */ new Map(), this.cellValidations = new my(), this.rowValidations = new Cy(), this.suspendEdits = !1;
  }
  suspend(e) {
    this.suspendEdits = e;
  }
  removeEdits({ rowNode: e, column: t }) {
    if (!this.hasEdits({ rowNode: e }) || !e)
      return;
    const o = this.getEditRow(e);
    t ? o.delete(t) : o.clear(), o.size === 0 && this.edits.delete(e);
  }
  getEditRow(e, t = {}) {
    if (this.suspendEdits || this.edits.size === 0)
      return;
    const o = e && this.edits.get(e);
    if (o)
      return o;
    if (t.checkSiblings) {
      const n = e.pinnedSibling;
      if (n)
        return this.getEditRow(n);
    }
  }
  getEditRowDataValue(e, { checkSiblings: t } = {}) {
    if (!e || this.edits.size === 0)
      return;
    const o = this.getEditRow(e), n = e.pinnedSibling, s = t && n && this.getEditRow(n);
    if (!o && !s)
      return;
    const i = Object.assign({}, e.data), r = (l, a) => l.forEach(({ pendingValue: c }, d) => {
      c !== Io && (a[d.getColId()] = c);
    });
    return o && r(o, i), s && r(s, i), i;
  }
  getEdit(e, t) {
    const o = this._getEdit(e);
    return t && o ? { ...o } : o;
  }
  _getEdit(e) {
    var t;
    if (!this.suspendEdits && this.edits.size !== 0)
      return e.rowNode && e.column && ((t = this.getEditRow(e.rowNode)) == null ? void 0 : t.get(e.column));
  }
  getEditMap(e = !0) {
    if (this.suspendEdits || this.edits.size === 0)
      return /* @__PURE__ */ new Map();
    if (!e)
      return this.edits;
    const t = /* @__PURE__ */ new Map();
    return this.edits.forEach((o, n) => {
      const s = /* @__PURE__ */ new Map();
      o.forEach(
        ({ editorState: i, ...r }, l) => (
          // Ensure we copy the cell data to avoid reference issues
          s.set(l, { ...r })
        )
      ), t.set(n, s);
    }), t;
  }
  setEditMap(e) {
    this.edits.clear(), e.forEach((t, o) => {
      const n = /* @__PURE__ */ new Map();
      t.forEach(
        (s, i) => (
          // Ensure we copy the cell data to avoid reference issues
          n.set(i, { ...s })
        )
      ), this.edits.set(o, n);
    });
  }
  setEdit(e, t) {
    (this.edits.size === 0 || !this.edits.has(e.rowNode)) && this.edits.set(e.rowNode, /* @__PURE__ */ new Map());
    const o = this._getEdit(e), n = Object.assign({
      editorState: {
        isCancelAfterEnd: void 0,
        isCancelBeforeStart: void 0
      },
      ...o,
      ...t
    });
    return this.getEditRow(e.rowNode).set(e.column, n), n;
  }
  clearEditValue(e) {
    var n;
    const { rowNode: t, column: o } = e;
    if (t)
      if (o) {
        const s = this._getEdit(e);
        s && (s.editorValue = void 0, s.pendingValue = s.sourceValue, s.state = "changed");
      } else
        (n = this.getEditRow(t)) == null || n.forEach((s) => {
          s.editorValue = void 0, s.pendingValue = s.sourceValue, s.state = "changed";
        });
  }
  getState(e) {
    var t;
    if (!this.suspendEdits)
      return (t = this.getEdit(e)) == null ? void 0 : t.state;
  }
  getEditPositions(e) {
    if (this.suspendEdits || (e ?? this.edits).size === 0)
      return [];
    const t = [];
    return (e ?? this.edits).forEach((o, n) => {
      for (const s of o.keys()) {
        const { editorState: i, ...r } = o.get(s);
        t.push({
          rowNode: n,
          column: s,
          ...r
        });
      }
    }), t;
  }
  hasRowEdits(e, t) {
    return this.suspendEdits || this.edits.size === 0 ? !1 : !!this.getEditRow(e, t);
  }
  hasEdits(e = {}, t = {}) {
    var i;
    if (this.suspendEdits || this.edits.size === 0)
      return !1;
    const { rowNode: o, column: n } = e, { withOpenEditor: s } = t;
    if (o) {
      const r = this.getEditRow(o, t);
      return r ? n ? s ? ((i = this.getEdit(e)) == null ? void 0 : i.state) === "editing" : r.has(n) ?? !1 : r.size !== 0 ? s ? Array.from(r.values()).some(({ state: l }) => l === "editing") : !0 : !1 : !1;
    }
    return s ? this.getEditPositions().some(({ state: r }) => r === "editing") : this.edits.size > 0;
  }
  start(e) {
    const t = this.getEditRow(e.rowNode) ?? /* @__PURE__ */ new Map(), { rowNode: o, column: n } = e;
    n && !t.has(n) && t.set(n, {
      editorValue: void 0,
      pendingValue: Io,
      sourceValue: this.beans.valueSvc.getValue(n, o, !1, "api"),
      state: "editing",
      editorState: {
        isCancelAfterEnd: void 0,
        isCancelBeforeStart: void 0
      }
    }), this.edits.set(o, t);
  }
  stop(e) {
    this.hasEdits(e) && (e ? this.removeEdits(e) : this.clear());
  }
  clear() {
    for (const e of this.edits.values())
      e.clear();
    this.edits.clear();
  }
  getCellValidationModel() {
    return this.cellValidations;
  }
  getRowValidationModel() {
    return this.rowValidations;
  }
  setCellValidationModel(e) {
    this.cellValidations = e;
  }
  setRowValidationModel(e) {
    this.rowValidations = e;
  }
  destroy() {
    super.destroy(), this.clear();
  }
}, my = class {
  constructor() {
    this.cellValidations = /* @__PURE__ */ new Map();
  }
  getCellValidation(e) {
    var n, s;
    const { rowNode: t, column: o } = e || {};
    return (s = (n = this.cellValidations) == null ? void 0 : n.get(t)) == null ? void 0 : s.get(o);
  }
  hasCellValidation(e) {
    return !e || !e.rowNode || !e.column ? this.cellValidations.size > 0 : !!this.getCellValidation(e);
  }
  setCellValidation(e, t) {
    const { rowNode: o, column: n } = e;
    this.cellValidations.has(o) || this.cellValidations.set(o, /* @__PURE__ */ new Map()), this.cellValidations.get(o).set(n, t);
  }
  clearCellValidation(e) {
    var n;
    const { rowNode: t, column: o } = e;
    (n = this.cellValidations.get(t)) == null || n.delete(o);
  }
  setCellValidationMap(e) {
    this.cellValidations = e;
  }
  getCellValidationMap() {
    return this.cellValidations;
  }
  clearCellValidationMap() {
    this.cellValidations.clear();
  }
}, Cy = class {
  constructor() {
    this.rowValidations = /* @__PURE__ */ new Map();
  }
  getRowValidation(e) {
    const { rowNode: t } = e || {};
    return this.rowValidations.get(t);
  }
  hasRowValidation(e) {
    return !e || !e.rowNode ? this.rowValidations.size > 0 : !!this.getRowValidation(e);
  }
  setRowValidation({ rowNode: e }, t) {
    this.rowValidations.set(e, t);
  }
  clearRowValidation({ rowNode: e }) {
    this.rowValidations.delete(e);
  }
  setRowValidationMap(e) {
    this.rowValidations = e;
  }
  getRowValidationMap() {
    return this.rowValidations;
  }
  clearRowValidationMap() {
    this.rowValidations.clear();
  }
};
function sc(e, t = {}) {
  var c;
  const { rowIndex: o, rowId: n, rowCtrl: s, rowPinned: i } = t;
  if (s)
    return s;
  const { rowModel: r, rowRenderer: l } = e;
  let { rowNode: a } = t;
  return a || (n ? a = TOe(e, n, i) : o != null && (a = r.getRow(o))), (c = l.getRowCtrls(a ? [a] : [])) == null ? void 0 : c[0];
}
function pt(e, t = {}) {
  var d;
  const { cellCtrl: o, colId: n, columnId: s, column: i } = t;
  if (o)
    return o;
  const r = e.colModel.getCol(n ?? s ?? C5(i)), l = t.rowCtrl ?? sc(e, t), a = (l == null ? void 0 : l.getCellCtrl(r)) ?? void 0;
  if (a)
    return a;
  const c = t.rowNode ?? (l == null ? void 0 : l.rowNode);
  if (c)
    return (d = e.rowRenderer.getCellCtrls([c], [r])) == null ? void 0 : d[0];
}
function vu(e) {
  const { editSvc: t } = e;
  t != null && t.isBatchEditing() ? Ti(e) : t == null || t.stopEditing(void 0, { source: "api" });
}
function CGe(e, t, o) {
  const { gos: n, popupSvc: s } = t;
  if (!n.get("stopEditingWhenCellsLoseFocus"))
    return;
  const i = (r) => {
    const l = r.relatedTarget;
    if (n5(l) === null) {
      vu(t);
      return;
    }
    let a = (
      // see if click came from inside the viewports
      o.some((c) => c.contains(l)) && // and also that it's not from a detail grid
      n.isElementInThisInstance(l)
    );
    a || (a = !!s && (s.getActivePopups().some((c) => c.contains(l)) || s.isElementWithinCustomPopup(l))), a || vu(t);
  };
  o.forEach((r) => e.addManagedElementListeners(r, { focusout: i }));
}
function C5(e) {
  if (e)
    return typeof e == "string" ? e : e.getColId();
}
var Io = Symbol("unedited");
function wy(e, t = {}) {
  var s;
  const o = [], n = e.rowRenderer.getCellCtrls(t.rowNodes, t.columns);
  for (const i of n) {
    const r = (s = i.comp) == null ? void 0 : s.getCellEditor();
    r && o.push({
      ctrl: i,
      editor: zi(r)
    });
  }
  return o;
}
var wGe = (e, t = {}) => wy(e, t).map((o) => o.editor);
function bGe(e, t, o, n, s, i) {
  var u;
  t.length === 0 && (o != null && o.rowNode) && (o != null && o.column) && Ki(e, o, { key: n, event: s, cellStartedEdit: i });
  const { valueSvc: r, editSvc: l, editModelSvc: a } = e, { rowNode: c, column: d } = o ?? {};
  for (const h of t) {
    const { rowNode: p, column: C } = h, m = pt(e, h);
    if (!m) {
      if (p && C) {
        const y = r.getValue(C, p, void 0, "api"), M = ((o == null ? void 0 : o.rowNode) === p && (o == null ? void 0 : o.column) === C && n || void 0) ?? (l == null ? void 0 : l.getCellDataValue(h, !1)) ?? ((u = r.getValueForDisplay(C, p)) == null ? void 0 : u.value) ?? y ?? Io;
        a == null || a.setEdit(h, {
          pendingValue: M,
          sourceValue: y,
          state: "editing"
        });
      }
      continue;
    }
    const w = i && c === m.rowNode && m.column === d;
    Ki(
      e,
      { rowNode: c, column: m.column },
      {
        key: w ? n : null,
        event: w ? s : null,
        cellStartedEdit: w && i
      }
    );
  }
}
function An({
  pendingValue: e,
  sourceValue: t
}) {
  return e === Io && (e = t), e !== t;
}
function Ki(e, t, o) {
  var y, b, _, M, x, L, A, R, P, I;
  const n = e.gos.get("enableGroupEdit"), { key: s, event: i, cellStartedEdit: r, silent: l } = o ?? {}, a = pt(e, t), c = (y = a == null ? void 0 : a.comp) == null ? void 0 : y.getCellEditor(), d = yy(e, t, s, r && !l), u = (b = e.editModelSvc) == null ? void 0 : b.getEdit(t);
  let h = d.value;
  if (h === void 0 && (h = u == null ? void 0 : u.sourceValue), (_ = e.editModelSvc) == null || _.setEdit(t, {
    editorValue: h,
    state: "editing"
  }), c) {
    (M = c.refresh) == null || M.call(c, d);
    return;
  }
  const p = t.column.getColDef(), C = Jw(e.userCompFactory, p, d), m = (C == null ? void 0 : C.popupFromSelector) != null ? C.popupFromSelector : !!p.cellEditorPopup, w = (C == null ? void 0 : C.popupPositionFromSelector) != null ? C.popupPositionFromSelector : p.cellEditorPopupPosition;
  if (_y(C.params, i), a) {
    a.editCompDetails = C, (x = a.comp) == null || x.setEditDetails(C, m, w, e.gos.get("reactiveCustomComponents")), (L = a == null ? void 0 : a.rowCtrl) == null || L.refreshRow({ suppressFlash: !0 });
    const B = (A = e.editModelSvc) == null ? void 0 : A.getEdit(t, !0);
    !l && !((R = B == null ? void 0 : B.editorState) != null && R.cellStartedEditing) && ((P = e.editSvc) == null || P.dispatchCellEvent(
      t,
      i,
      "cellEditingStarted",
      n ? { value: h } : {}
    ), (I = e.editModelSvc) == null || I.setEdit(t, { editorState: { cellStartedEditing: !0 } }));
  }
}
function by(e, t, o) {
  var i, r;
  const n = { editorValueExists: !1 };
  if (ic(e)) {
    const l = (i = t.getValidationErrors) == null ? void 0 : i.call(t);
    if (((l == null ? void 0 : l.length) ?? 0) > 0)
      return n;
  }
  if (o != null && o.isCancelling)
    return n;
  if (o != null && o.isStopping) {
    const l = (r = t == null ? void 0 : t.isCancelAfterEnd) == null ? void 0 : r.call(t);
    if (l)
      return { ...n, isCancelAfterEnd: l };
  }
  return {
    editorValue: t.getValue(),
    editorValueExists: !0
  };
}
function yy(e, t, o, n) {
  var y, b, _, M;
  const { valueSvc: s, gos: i, editSvc: r } = e, l = e.gos.get("enableGroupEdit"), a = pt(e, t), c = ((y = t.rowNode) == null ? void 0 : y.rowIndex) ?? void 0, d = r == null ? void 0 : r.isBatchEditing(), u = e.colModel.getCol(t.column.getId()), { rowNode: h, column: p } = t, C = (b = a.comp) == null ? void 0 : b.getCellEditor(), m = (r == null ? void 0 : r.getCellDataValue(t, !1)) ?? (C ? (_ = by(e, C)) == null ? void 0 : _.editorValue : void 0), w = m === Io ? (M = s.getValueForDisplay(u, h)) == null ? void 0 : M.value : m;
  return Pe(i, {
    value: l ? m : w,
    eventKey: o ?? null,
    column: p,
    colDef: p.getColDef(),
    rowIndex: c,
    node: h,
    data: h.data,
    cellStartedEdit: n ?? !1,
    onKeyDown: a == null ? void 0 : a.onKeyDown.bind(a),
    stopEditing: (x) => {
      r.stopEditing(t, { source: d ? "ui" : "api", suppressNavigateAfterEdit: x }), Hl(e, t);
    },
    eGridCell: a == null ? void 0 : a.eGui,
    parseValue: (x) => s.parseValue(u, h, x, a == null ? void 0 : a.value),
    formatValue: a == null ? void 0 : a.formatValue.bind(a),
    validate: () => {
      r == null || r.validateEdit();
    }
  });
}
function w5(e, t) {
  const { editModelSvc: o } = e;
  o == null || o.getEditMap().forEach((n, s) => {
    n.forEach((i, r) => {
      !t && (i.state === "editing" || i.pendingValue === Io) || !An(i) && (i.state !== "editing" || t) && (o == null || o.removeEdits({ rowNode: s, column: r }));
    });
  });
}
function yGe(e, t) {
  var c;
  const o = (c = t.comp) == null ? void 0 : c.getCellEditor();
  if (!(o != null && o.refresh))
    return;
  const { eventKey: n, cellStartedEdit: s } = t.editCompDetails.params, { column: i } = t, r = yy(e, t, n, s), l = i.getColDef(), a = Jw(e.userCompFactory, l, r);
  o.refresh(_y(a.params, n));
}
function _y(e, t) {
  var o;
  return t instanceof KeyboardEvent && e.column.getColDef().cellEditor === "agNumberCellEditor" ? e.suppressPreventDefault = ["-", "+", ".", "e"].includes((t == null ? void 0 : t.key) ?? "") || e.suppressPreventDefault : (o = t == null ? void 0 : t.preventDefault) == null || o.call(t), e;
}
function Ps(e, t) {
  var o;
  (o = e.editModelSvc) == null || o.getEditPositions().forEach((n) => {
    var c, d;
    const s = pt(e, n);
    if (!s)
      return;
    const i = (c = s.comp) == null ? void 0 : c.getCellEditor();
    if (!i)
      return;
    const { editorValue: r, editorValueExists: l, isCancelAfterEnd: a } = by(e, i, t);
    a && ((d = e.editModelSvc) == null || d.setEdit(n, { editorState: { isCancelAfterEnd: a } })), X1(e, n, r, void 0, !l, t);
  });
}
function X1(e, t, o, n, s, i) {
  const { editModelSvc: r, valueSvc: l } = e;
  if (!r)
    return;
  const { rowNode: a, column: c } = t;
  if (!(a && c))
    return;
  let d = r.getEdit(t, !0);
  d != null && d.sourceValue || (d = r.setEdit(t, {
    sourceValue: l.getValue(c, a, void 0, "api"),
    pendingValue: d ? d.editorValue : Io
  })), r.setEdit(t, {
    editorValue: s ? d.sourceValue : o
  }), i != null && i.persist && _Ge(e, t);
}
function _Ge(e, t) {
  const { editModelSvc: o } = e, n = o == null ? void 0 : o.getEdit(t, !0);
  o == null || o.setEdit(t, {
    pendingValue: n == null ? void 0 : n.editorValue
  });
}
function Ti(e, t, o) {
  var n;
  t || (t = (n = e.editModelSvc) == null ? void 0 : n.getEditPositions()), t.forEach((s) => Hl(e, s, o));
}
function Hl(e, t, o) {
  var c, d;
  const n = e.gos.get("enableGroupEdit"), { editModelSvc: s } = e, i = pt(e, t), r = s == null ? void 0 : s.getEdit(t, !0);
  if (!i) {
    r && (s == null || s.setEdit(t, { state: "changed" }));
    return;
  }
  const { comp: l } = i;
  if (l && !l.getCellEditor()) {
    if (i == null || i.refreshCell(), r) {
      s == null || s.setEdit(t, { state: "changed" });
      const u = n ? mu(o, r) : {
        valueChanged: !1,
        newValue: void 0,
        oldValue: r.sourceValue
      };
      Cu(e, t, u, o);
    }
    return;
  }
  if (ic(e)) {
    const u = (d = (c = l == null ? void 0 : l.getCellEditor()) == null ? void 0 : c.getValidationErrors) == null ? void 0 : d.call(c), h = s == null ? void 0 : s.getCellValidationModel();
    u != null && u.length ? h == null || h.setCellValidation(t, { errorMessages: u }) : h == null || h.clearCellValidation(t);
  }
  s == null || s.setEdit(t, { state: "changed" }), l == null || l.setEditDetails(), l == null || l.refreshEditStyles(!1, !1), i == null || i.refreshCell({ force: !0, suppressFlash: !0 });
  const a = s == null ? void 0 : s.getEdit(t);
  if (a && a.state === "changed") {
    const u = n ? mu(o, a) : {
      valueChanged: An(a) && !(o != null && o.cancel),
      newValue: o != null && o.cancel || a.editorState.isCancelAfterEnd ? void 0 : (a == null ? void 0 : a.editorValue) ?? (r == null ? void 0 : r.pendingValue),
      oldValue: a == null ? void 0 : a.sourceValue
    };
    Cu(e, t, u, o);
  }
}
function mu(e, t) {
  return e != null && e.cancel ? {
    valueChanged: !1,
    oldValue: t.sourceValue,
    newValue: void 0,
    value: t.sourceValue
  } : {
    valueChanged: !1,
    oldValue: t.sourceValue,
    newValue: t.pendingValue,
    value: t.sourceValue
  };
}
function Cu(e, t, o, { silent: n, event: s } = {}) {
  const { editSvc: i, editModelSvc: r } = e, l = r == null ? void 0 : r.getEdit(t), { editorState: a } = l || {}, { isCancelBeforeStart: c } = a || {};
  !n && !c && (i == null || i.dispatchCellEvent(t, s, "cellEditingStopped", o), r == null || r.setEdit(t, { editorState: { cellStoppedEditing: !0 } }));
}
function ic(e) {
  var r;
  const { gos: t, colModel: o } = e, n = !!t.get("getFullRowEditValidationErrors"), s = (r = o.getColumnDefs()) == null ? void 0 : r.filter((l) => l.editable).some(({ cellEditorParams: l }) => {
    const { minLength: a, maxLength: c, getValidationErrors: d, min: u, max: h } = l || {};
    return a !== void 0 || c !== void 0 || d !== void 0 || u !== void 0 || h !== void 0;
  }), i = e.gridApi.getCellEditorInstances().some((l) => l.getValidationElement || l.getValidationErrors);
  return s || n || i;
}
function Xs(e, t) {
  var h, p, C, m, w, y, b, _;
  if (!(t || ic(e)))
    return;
  const o = wy(e), n = new my(), { ariaAnnounce: s, localeSvc: i, editModelSvc: r, gos: l } = e, a = l.get("editType") === "fullRow", d = fw(i)("ariaValidationErrorPrefix", "Cell Editor Validation");
  for (const M of o) {
    const { ctrl: x, editor: L } = M, { rowNode: A, column: R } = x, P = ((h = L.getValidationErrors) == null ? void 0 : h.call(L)) ?? [], I = ((p = L.getValidationElement) == null ? void 0 : p.call(L, !1)) || !((C = L.isPopup) != null && C.call(L)) && x.eGui;
    if (I) {
      const B = P != null && P.length > 0, H = B ? P.join(". ") : "";
      GTe(I, B), B && s.announceValue(`${d} ${P}`, "editorValidation"), I instanceof HTMLInputElement ? I.setCustomValidity(H) : I.classList.toggle("invalid", B);
    }
    (P == null ? void 0 : P.length) > 0 && n.setCellValidation(
      {
        rowNode: A,
        column: R
      },
      {
        errorMessages: P
      }
    );
  }
  Ps(e, { persist: !1 }), r == null || r.setCellValidationModel(n);
  const u = /* @__PURE__ */ new Set();
  for (const { ctrl: M } of o)
    u.add(M.rowCtrl);
  if (a) {
    const M = SGe(e);
    r == null || r.setRowValidationModel(M);
  }
  for (const M of u.values()) {
    (m = M.rowEditStyleFeature) == null || m.applyRowStyles();
    for (const x of M.getAllCellCtrls())
      (w = x.tooltipFeature) == null || w.refreshTooltip(!0), (y = x.editorTooltipFeature) == null || y.refreshTooltip(!0), (_ = (b = x.editStyleFeature) == null ? void 0 : b.applyCellStyles) == null || _.call(b);
  }
}
var SGe = (e) => {
  var s;
  const t = new Cy(), o = e.gos.get("getFullRowEditValidationErrors"), n = (s = e.editModelSvc) == null ? void 0 : s.getEditMap();
  if (!n)
    return t;
  for (const i of n.keys()) {
    const r = n.get(i);
    if (!r)
      continue;
    const l = [], { rowIndex: a, rowPinned: c } = i;
    for (const u of r.keys()) {
      const h = r.get(u);
      if (!h)
        continue;
      const { editorValue: p, pendingValue: C, sourceValue: m } = h, w = p ?? (C === Io ? void 0 : C) ?? m;
      l.push({
        column: u,
        colId: u.getColId(),
        rowIndex: a,
        rowPinned: c,
        oldValue: m,
        newValue: w
      });
    }
    const d = (o == null ? void 0 : o({ editorsState: l })) ?? [];
    d.length > 0 && t.setRowValidation(
      {
        rowNode: i
      },
      { errorMessages: d }
    );
  }
  return t;
};
function xGe(e) {
  var n;
  Xs(e, !0);
  const t = (n = e.editModelSvc) == null ? void 0 : n.getCellValidationModel().getCellValidationMap();
  if (!t)
    return null;
  const o = [];
  return t.forEach((s, i) => {
    s.forEach(({ errorMessages: r }, l) => {
      o.push({
        column: l,
        rowIndex: i.rowIndex,
        rowPinned: i.rowPinned,
        messages: r ?? null
      });
    });
  }), o;
}
function MGe(e, t, o, { rowNode: n, column: s }, i) {
  return Pe(e.gos, {
    type: o,
    node: n,
    data: n.data,
    value: i,
    column: s,
    colDef: s.getColDef(),
    rowPinned: n.rowPinned,
    event: t,
    rowIndex: n.rowIndex
  });
}
function AGe(e, t = !1) {
  return e === D.DELETE ? !0 : !t && e === D.BACKSPACE ? eb() : !1;
}
var LGe = class extends K {
  constructor(e, t, o, n) {
    super(), this.cellCtrl = e, this.rowNode = o, this.rowCtrl = n, this.beans = t;
  }
  init() {
    this.eGui = this.cellCtrl.eGui;
  }
  onKeyDown(e) {
    const t = e.key;
    switch (t) {
      case D.ENTER:
        this.onEnterKeyDown(e);
        break;
      case D.F2:
        this.onF2KeyDown(e);
        break;
      case D.ESCAPE:
        this.onEscapeKeyDown(e);
        break;
      case D.TAB:
        this.onTabKeyDown(e);
        break;
      case D.BACKSPACE:
      case D.DELETE:
        this.onBackspaceOrDeleteKeyDown(t, e);
        break;
      case D.DOWN:
      case D.UP:
      case D.RIGHT:
      case D.LEFT:
        this.onNavigationKeyDown(e, t);
        break;
    }
  }
  onNavigationKeyDown(e, t) {
    var s, i;
    const { cellCtrl: o, beans: n } = this;
    if (!((s = n.editSvc) != null && s.isEditing(o, { withOpenEditor: !0 }))) {
      if (e.shiftKey && o.isRangeSelectionEnabled())
        this.onShiftRangeSelect(e);
      else {
        const r = o.getFocusedCellPosition();
        (i = n.navigation) == null || i.navigateToNextCell(e, t, r, !0);
      }
      e.preventDefault();
    }
  }
  onShiftRangeSelect(e) {
    const { rangeSvc: t, navigation: o } = this.beans;
    if (!t)
      return;
    const n = t.extendLatestRangeInDirection(e);
    n && (e.key === D.LEFT || e.key === D.RIGHT ? o == null || o.ensureColumnVisible(n.column) : o == null || o.ensureRowVisible(n.rowIndex));
  }
  onTabKeyDown(e) {
    var t;
    (t = this.beans.navigation) == null || t.onTabKeyDown(this.cellCtrl, e);
  }
  onBackspaceOrDeleteKeyDown(e, t) {
    var c;
    const { cellCtrl: o, beans: n, rowNode: s } = this, { gos: i, rangeSvc: r, eventSvc: l, editSvc: a } = n;
    if (l.dispatchEvent({ type: "keyShortcutChangedCellStart" }), AGe(e, i.get("enableCellEditingOnBackspace")) && !(a != null && a.isEditing(o, { withOpenEditor: !0 }))) {
      if (r && kn(i))
        r.clearCellRangeCellValues({ dispatchWrapperEvents: !0, wrapperEventSource: "deleteKey" });
      else if (o.isCellEditable()) {
        const { column: d } = o, u = this.beans.valueSvc.getDeleteValue(d, s);
        s.setDataValue(d, u, "cellClear");
      }
    } else a != null && a.isEditing(o, { withOpenEditor: !0 }) || (c = n.editSvc) == null || c.startEditing(o, { startedEdit: !0, event: t });
    l.dispatchEvent({ type: "keyShortcutChangedCellEnd" });
  }
  onEnterKeyDown(e) {
    var c;
    const { cellCtrl: t, beans: o } = this, { editSvc: n, navigation: s } = o, i = n == null ? void 0 : n.isEditing(t, { withOpenEditor: !0 }), r = t.rowNode, l = n == null ? void 0 : n.isRowEditing(r, { withOpenEditor: !0 }), a = (d) => {
      (n == null ? void 0 : n.startEditing(d, {
        startedEdit: !0,
        event: e,
        source: "edit"
      })) && e.preventDefault();
    };
    if (i || l) {
      if (this.isCtrlEnter(e)) {
        n == null || n.applyBulkEdit(t, ((c = o == null ? void 0 : o.rangeSvc) == null ? void 0 : c.getCellRanges()) || []);
        return;
      }
      if (Xs(o), (n == null ? void 0 : n.checkNavWithValidation(void 0, e)) === "block-stop")
        return;
      n != null && n.isEditing(t, { withOpenEditor: !0 }) ? n == null || n.stopEditing(t, {
        event: e,
        source: "edit"
      }) : l && !t.isCellEditable() ? n == null || n.stopEditing({ rowNode: r }, { event: e, source: "edit" }) : a(t);
    } else if (o.gos.get("enterNavigatesVertically")) {
      const d = e.shiftKey ? D.UP : D.DOWN;
      s == null || s.navigateToNextCell(null, d, t.cellPosition, !1);
    } else {
      if (n != null && n.hasValidationErrors())
        return;
      n != null && n.hasValidationErrors(t) && n.revertSingleCellEdit(t, !0), a(t);
    }
  }
  isCtrlEnter(e) {
    return (e.ctrlKey || e.metaKey) && e.key === D.ENTER;
  }
  onF2KeyDown(e) {
    const {
      cellCtrl: t,
      beans: { editSvc: o }
    } = this;
    o != null && o.isEditing() && (Xs(this.beans), (o == null ? void 0 : o.checkNavWithValidation(void 0, e)) === "block-stop") || o == null || o.startEditing(t, { startedEdit: !0, event: e });
  }
  onEscapeKeyDown(e) {
    const {
      cellCtrl: t,
      beans: { editSvc: o }
    } = this;
    (o == null ? void 0 : o.checkNavWithValidation(t, e)) === "block-stop" && o.revertSingleCellEdit(t), o == null || o.stopEditing(t, {
      event: e,
      cancel: !0
    });
  }
  processCharacter(e) {
    var r;
    const o = e.target !== this.eGui, {
      beans: { editSvc: n },
      cellCtrl: s
    } = this;
    if (o || n != null && n.isEditing(s, { withOpenEditor: !0 }))
      return;
    if (e.key === D.SPACE)
      this.onSpaceKeyDown(e);
    else if (n != null && n.isCellEditable(s, "ui")) {
      if (n != null && n.hasValidationErrors() && !(n != null && n.hasValidationErrors(s)))
        return;
      n == null || n.startEditing(s, { startedEdit: !0, event: e, source: "api" });
      const l = s.editCompDetails;
      !((r = l == null ? void 0 : l.params) != null && r.suppressPreventDefault) && e.preventDefault();
    }
  }
  onSpaceKeyDown(e) {
    var s;
    const { gos: t, editSvc: o } = this.beans, { rowNode: n } = this.cellCtrl;
    !(o != null && o.isEditing(this.cellCtrl, { withOpenEditor: !0 })) && os(t) && ((s = this.beans.selectionSvc) == null || s.handleSelectionEvent(e, n, "spaceKey")), e.preventDefault();
  }
}, EGe = class extends K {
  constructor(e, t, o) {
    super(), this.cellCtrl = e, this.column = o, this.beans = t;
  }
  onMouseEvent(e, t) {
    if (!wo(t))
      switch (e) {
        case "click":
          this.onCellClicked(t);
          break;
        case "mousedown":
        case "touchstart":
          this.onMouseDown(t);
          break;
        case "dblclick":
          this.onCellDoubleClicked(t);
          break;
        case "mouseout":
          this.onMouseOut(t);
          break;
        case "mouseover":
          this.onMouseOver(t);
          break;
      }
  }
  onCellClicked(e) {
    var m;
    if ((m = this.beans.touchSvc) != null && m.handleCellDoubleClick(this, e))
      return;
    const { eventSvc: t, rangeSvc: o, editSvc: n, editModelSvc: s, frameworkOverrides: i, gos: r } = this.beans, l = e.ctrlKey || e.metaKey, { cellCtrl: a } = this, { column: c, cellPosition: d, rowNode: u } = a, h = K1(r, c, u, e);
    o && l && !h && o.getCellRangeCount(d) > 1 && o.intersectLastRange(!0);
    const p = a.createEvent(e, "cellClicked");
    p.isEventHandlingSuppressed = h, t.dispatchEvent(p);
    const C = c.getColDef();
    if (C.onCellClicked && window.setTimeout(() => {
      i.wrapOutgoing(() => {
        C.onCellClicked(p);
      });
    }, 0), !h && (s == null ? void 0 : s.getState(a)) !== "editing") {
      const w = n == null ? void 0 : n.isEditing(), y = (s == null ? void 0 : s.getCellValidationModel().getCellValidationMap().size) ?? 0, b = (s == null ? void 0 : s.getRowValidationModel().getRowValidationMap().size) ?? 0;
      if (w && (y > 0 || b > 0))
        return;
      n != null && n.shouldStartEditing(a, e) ? n == null || n.startEditing(a, { event: e }) : n != null && n.shouldStopEditing(a, e) && (this.beans.gos.get("editType") === "fullRow" ? n == null || n.stopEditing(a, {
        event: e,
        source: "edit"
      }) : n == null || n.stopEditing(void 0, {
        event: e,
        source: "edit"
      }));
    }
  }
  onCellDoubleClicked(e) {
    const { column: t, beans: o, cellCtrl: n } = this, { eventSvc: s, frameworkOverrides: i, editSvc: r, editModelSvc: l, gos: a } = o, c = K1(a, n.column, n.rowNode, e), d = t.getColDef(), u = n.createEvent(
      e,
      "cellDoubleClicked"
    );
    if (u.isEventHandlingSuppressed = c, s.dispatchEvent(u), typeof d.onCellDoubleClicked == "function" && window.setTimeout(() => {
      i.wrapOutgoing(() => {
        d.onCellDoubleClicked(u);
      });
    }, 0), !c && r != null && r.shouldStartEditing(n, e) && (l == null ? void 0 : l.getState(n)) !== "editing") {
      const h = r == null ? void 0 : r.isEditing(), p = (l == null ? void 0 : l.getCellValidationModel().getCellValidationMap().size) ?? 0, C = (l == null ? void 0 : l.getRowValidationModel().getRowValidationMap().size) ?? 0;
      if (h && (p > 0 || C > 0))
        return;
      r == null || r.startEditing(n, { event: e });
    }
  }
  onMouseDown(e) {
    const { ctrlKey: t, metaKey: o, shiftKey: n } = e, s = e.target, { cellCtrl: i, beans: r } = this, { eventSvc: l, rangeSvc: a, rowNumbersSvc: c, focusSvc: d, gos: u, editSvc: h } = r, { column: p, rowNode: C, cellPosition: m } = i, w = K1(u, p, C, e), y = () => {
      const x = i.createEvent(e, "cellMouseDown");
      x.isEventHandlingSuppressed = w, l.dispatchEvent(x);
    };
    if (w) {
      y();
      return;
    }
    if (this.isRightClickInExistingRange(e))
      return;
    const b = a && !a.isEmpty(), _ = this.containsWidget(s), M = ns(p);
    if (c && M && !c.handleMouseDownOnCell(m, e)) {
      a && e.preventDefault(), e.stopImmediatePropagation();
      return;
    }
    if (!n || !b) {
      const x = h == null ? void 0 : h.isEditing(i), A = u.get("enableCellTextSelection") && e.defaultPrevented, R = (Gn() || A) && !x && !w2(s) && !_;
      i.focusCell(R, e);
    }
    if (n && b && !d.isCellFocused(m)) {
      e.preventDefault();
      const x = d.getFocusedCell();
      if (x) {
        const { column: L, rowIndex: A, rowPinned: R } = x;
        h != null && h.isEditing(x) && (h == null || h.stopEditing(x)), d.setFocusedCell({
          column: L,
          rowIndex: A,
          rowPinned: R,
          forceBrowserFocus: !0,
          preventScrollOnBrowserFocus: !0,
          sourceEvent: e
        });
      }
    }
    if (!_) {
      if (a) {
        M && e.preventDefault();
        const x = Ad(r, e) && M;
        if (n)
          a.extendLatestRangeToCell(m);
        else if (!x) {
          const L = t || o;
          a.setRangeToCell(m, L);
        }
      }
      y();
    }
  }
  isRightClickInExistingRange(e) {
    const { rangeSvc: t } = this.beans;
    if (t) {
      const o = t.isCellInAnyRange(this.cellCtrl.cellPosition), n = Ad(this.beans, e);
      if (o && n)
        return !0;
    }
    return !1;
  }
  containsWidget(e) {
    return ks(e, "ag-selection-checkbox", 3) || ks(e, "ag-drag-handle", 3);
  }
  onMouseOut(e) {
    if (this.mouseStayingInsideCell(e))
      return;
    const { eventSvc: t, colHover: o } = this.beans;
    t.dispatchEvent(this.cellCtrl.createEvent(e, "cellMouseOut")), o == null || o.clearMouseOver();
  }
  onMouseOver(e) {
    if (this.mouseStayingInsideCell(e))
      return;
    const { eventSvc: t, colHover: o } = this.beans;
    t.dispatchEvent(this.cellCtrl.createEvent(e, "cellMouseOver")), o == null || o.setMouseOver([this.column]);
  }
  mouseStayingInsideCell(e) {
    if (!e.target || !e.relatedTarget)
      return !1;
    const t = this.cellCtrl.eGui, o = t.contains(e.target), n = t.contains(e.relatedTarget);
    return o && n;
  }
}, PGe = class extends K {
  constructor(e, t) {
    super(), this.cellCtrl = e, this.beans = t, this.column = e.column, this.rowNode = e.rowNode;
  }
  setupRowSpan() {
    this.rowSpan = this.column.getRowSpan(this.rowNode), this.addManagedListeners(this.beans.eventSvc, { newColumnsLoaded: () => this.onNewColumnsLoaded() });
  }
  init() {
    this.eSetLeft = this.cellCtrl.getRootElement(), this.eContent = this.cellCtrl.eGui;
    const e = this.cellCtrl.getCellSpan();
    if (e || (this.setupColSpan(), this.setupRowSpan()), this.onLeftChanged(), this.onWidthChanged(), e || this._legacyApplyRowSpan(), e) {
      const t = this.refreshSpanHeight.bind(this, e);
      t(), this.addManagedListeners(this.beans.eventSvc, {
        paginationChanged: t,
        recalculateRowBounds: t,
        pinnedHeightChanged: t
      });
    }
  }
  refreshSpanHeight(e) {
    const t = e.getCellHeight();
    t != null && (this.eContent.style.height = `${t}px`);
  }
  onNewColumnsLoaded() {
    const e = this.column.getRowSpan(this.rowNode);
    this.rowSpan !== e && (this.rowSpan = e, this._legacyApplyRowSpan(!0));
  }
  onDisplayColumnsChanged() {
    const e = this.getColSpanningList();
    No(this.colsSpanning, e) || (this.colsSpanning = e, this.onWidthChanged(), this.onLeftChanged());
  }
  setupColSpan() {
    this.column.getColDef().colSpan != null && (this.colsSpanning = this.getColSpanningList(), this.addManagedListeners(this.beans.eventSvc, {
      // because we are col spanning, a reorder of the cols can change what cols we are spanning over
      displayedColumnsChanged: this.onDisplayColumnsChanged.bind(this),
      // because we are spanning over multiple cols, we check for width any time any cols width changes.
      // this is expensive - really we should be explicitly checking only the cols we are spanning over
      // instead of every col, however it would be tricky code to track the cols we are spanning over, so
      // because hardly anyone will be using colSpan, am favouring this easier way for more maintainable code.
      displayedColumnsWidthChanged: this.onWidthChanged.bind(this)
    }));
  }
  onWidthChanged() {
    if (!this.eContent)
      return;
    const e = this.getCellWidth();
    this.eContent.style.width = `${e}px`;
  }
  getCellWidth() {
    return this.colsSpanning ? this.colsSpanning.reduce((e, t) => e + t.getActualWidth(), 0) : this.column.getActualWidth();
  }
  getColSpanningList() {
    const { column: e, rowNode: t } = this, o = e.getColSpan(t), n = [];
    if (o === 1)
      n.push(e);
    else {
      let s = e;
      const i = e.getPinned();
      for (let r = 0; s && r < o && (n.push(s), s = this.beans.visibleCols.getColAfter(s), !(!s || Xe(s) || i !== s.getPinned())); r++)
        ;
    }
    return n;
  }
  onLeftChanged() {
    if (!this.eSetLeft)
      return;
    const e = this.modifyLeftForPrintLayout(this.getCellLeft());
    this.eSetLeft.style.left = e + "px";
  }
  getCellLeft() {
    let e;
    return this.beans.gos.get("enableRtl") && this.colsSpanning ? e = Ke(this.colsSpanning) : e = this.column, e.getLeft();
  }
  modifyLeftForPrintLayout(e) {
    if (!this.cellCtrl.printLayout || this.column.getPinned() === "left")
      return e;
    const { visibleCols: t } = this.beans, o = t.getColsLeftWidth();
    if (this.column.getPinned() === "right") {
      const n = t.bodyWidth;
      return o + n + (e || 0);
    }
    return o + (e || 0);
  }
  _legacyApplyRowSpan(e) {
    if (this.rowSpan === 1 && !e)
      return;
    const o = Vs(this.beans) * this.rowSpan;
    this.eContent.style.height = `${o}px`, this.eContent.style.zIndex = "1";
  }
  // overriding to make public, as we don't dispose this bean via context
  destroy() {
    super.destroy();
  }
}, RGe = "ag-cell", FGe = "ag-cell-auto-height", TGe = "ag-cell-normal-height", IGe = "ag-cell-focus", DGe = "ag-cell-first-right-pinned", kGe = "ag-cell-last-left-pinned", HGe = "ag-cell-not-inline-editing", VGe = "ag-cell-wrap-text", OGe = 0, Ii = class extends K {
  constructor(e, t, o, n) {
    super(), this.column = e, this.rowNode = t, this.rowCtrl = n, this.rangeFeature = void 0, this.rowResizeFeature = void 0, this.positionFeature = void 0, this.customStyleFeature = void 0, this.editStyleFeature = void 0, this.mouseListener = void 0, this.keyboardListener = void 0, this.suppressRefreshCell = !1, this.onCompAttachedFuncs = [], this.onEditorAttachedFuncs = [], this.focusEventWhileNotReady = null, this.hasBeenFocused = !1, this.hasEdit = !1, this.tooltipFeature = void 0, this.editorTooltipFeature = void 0, this.beans = o, this.gos = o.gos, this.editSvc = o.editSvc, this.hasEdit = !!o.editSvc;
    const { colId: s } = e;
    this.instanceId = s + "-" + OGe++, this.createCellPosition(), this.updateAndFormatValue(!1);
  }
  addFeatures() {
    var n, s;
    const { beans: e } = this;
    this.positionFeature = new PGe(this, e), this.customStyleFeature = (n = e.cellStyles) == null ? void 0 : n.createCellCustomStyleFeature(this, e), this.editStyleFeature = (s = e.editSvc) == null ? void 0 : s.createCellStyleFeature(this, e), this.mouseListener = new EGe(this, e, this.column), this.keyboardListener = new LGe(this, e, this.rowNode, this.rowCtrl), this.enableTooltipFeature();
    const { rangeSvc: t } = e;
    t && kn(e.gos) && (this.rangeFeature = t.createCellRangeFeature(e, this)), ns(this.column) && (this.rowResizeFeature = this.beans.rowNumbersSvc.createRowNumbersRowResizerFeature(e, this));
  }
  isCellSpanning() {
    return !1;
  }
  getCellSpan() {
  }
  removeFeatures() {
    const e = this.beans.context;
    this.positionFeature = e.destroyBean(this.positionFeature), this.editorTooltipFeature = e.destroyBean(this.editorTooltipFeature), this.customStyleFeature = e.destroyBean(this.customStyleFeature), this.editStyleFeature = e.destroyBean(this.editStyleFeature), this.mouseListener = e.destroyBean(this.mouseListener), this.keyboardListener = e.destroyBean(this.keyboardListener), this.rangeFeature = e.destroyBean(this.rangeFeature), this.rowResizeFeature = e.destroyBean(this.rowResizeFeature), this.disableTooltipFeature();
  }
  enableTooltipFeature(e, t) {
    var o;
    this.tooltipFeature = (o = this.beans.tooltipSvc) == null ? void 0 : o.enableCellTooltipFeature(this, e, t);
  }
  disableTooltipFeature() {
    this.tooltipFeature = this.beans.context.destroyBean(this.tooltipFeature);
  }
  enableEditorTooltipFeature(e) {
    var t;
    this.editorTooltipFeature && this.disableEditorTooltipFeature(), this.editorTooltipFeature = (t = this.beans.tooltipSvc) == null ? void 0 : t.setupCellEditorTooltip(this, e), Xs(this.beans);
  }
  disableEditorTooltipFeature() {
    this.editorTooltipFeature = this.beans.context.destroyBean(this.editorTooltipFeature);
  }
  setComp(e, t, o, n, s, i, r) {
    var l, a, c, d, u, h, p, C, m;
    this.comp = e, this.eGui = t, this.printLayout = s, r ?? (r = this), this.addDomData(r), this.addFeatures(), r.addDestroyFunc(() => this.removeFeatures()), this.onSuppressCellFocusChanged(this.beans.gos.get("suppressCellFocus")), this.setupFocus(), this.applyStaticCssClasses(), this.setWrapText(), this.onFirstRightPinnedChanged(), this.onLastLeftPinnedChanged(), this.onColumnHover(), this.setupControlComps(), this.setupAutoHeight(n, r), this.refreshFirstAndLastStyles(), this.refreshAriaColIndex(), (l = this.positionFeature) == null || l.init(), (a = this.customStyleFeature) == null || a.setComp(e), (c = this.editStyleFeature) == null || c.setComp(e), (d = this.tooltipFeature) == null || d.refreshTooltip(), (u = this.keyboardListener) == null || u.init(), (h = this.rangeFeature) == null || h.setComp(e), (p = this.rowResizeFeature) == null || p.refreshRowResizer(), i && this.isCellEditable() || this.hasEdit && ((C = this.editSvc) != null && C.isEditing(this, { withOpenEditor: !0 })) ? (m = this.editSvc) == null || m.startEditing(this, {
      startedEdit: !1,
      source: "api",
      silent: !0,
      continueEditing: !0
    }) : this.showValue(!1, !0), this.onCompAttachedFuncs.length && (this.onCompAttachedFuncs.forEach((w) => w()), this.onCompAttachedFuncs = []);
  }
  setupAutoHeight(e, t) {
    var o;
    this.isAutoHeight = ((o = this.beans.rowAutoHeight) == null ? void 0 : o.setupCellAutoHeight(this, e, t)) ?? !1;
  }
  getCellAriaRole() {
    return this.column.getColDef().cellAriaRole ?? "gridcell";
  }
  isCellRenderer() {
    const e = this.column.getColDef();
    return e.cellRenderer != null || e.cellRendererSelector != null;
  }
  getValueToDisplay() {
    return this.valueFormatted ?? this.value;
  }
  getDeferLoadingCellRenderer() {
    var a, c;
    const { beans: e, column: t } = this, { userCompFactory: o, ctrlsSvc: n, eventSvc: s } = e, i = t.getColDef(), r = this.createCellRendererParams();
    r.deferRender = !0;
    const l = Fd(o, i, r);
    if ((c = (a = n.getGridBodyCtrl()) == null ? void 0 : a.scrollFeature) != null && c.isScrolling()) {
      let d;
      const u = new Ye((h) => {
        d = h;
      });
      return this.addManagedListeners(s, {
        bodyScrollEnd: () => d()
      }), { loadingComp: l, onReady: u };
    }
    return { loadingComp: l, onReady: Ye.resolve() };
  }
  showValue(e, t) {
    var u, h, p, C;
    const { beans: o, column: n, rowNode: s, rangeFeature: i } = this, { userCompFactory: r } = o;
    let l = this.getValueToDisplay(), a;
    const c = s.stub && ((u = s.groupData) == null ? void 0 : u[n.getId()]) == null, d = n.getColDef();
    if (c || this.isCellRenderer()) {
      const m = this.createCellRendererParams();
      !c || ns(n) ? a = Ni(r, d, m) : a = Fd(r, d, m);
    }
    if (!a && !c && ((h = o.findSvc) != null && h.isMatch(s, n))) {
      const m = this.createCellRendererParams();
      a = Ni(
        r,
        { ...n.getColDef(), cellRenderer: "agFindCellRenderer" },
        m
      );
    }
    if (this.hasEdit && this.editSvc.isBatchEditing() && this.editSvc.isRowEditing(s, { checkSiblings: !0 })) {
      const m = this.editSvc.prepDetailsDuringBatch(this, { compDetails: a, valueToDisplay: l });
      m && (m.compDetails ? a = m.compDetails : m.valueToDisplay && (l = m.valueToDisplay));
    }
    this.comp.setRenderDetails(a, l, e), (p = this.customRowDragComp) == null || p.refreshVisibility(), !t && i && yo(o, () => i == null ? void 0 : i.refreshHandle()), (C = this.rowResizeFeature) == null || C.refreshRowResizer();
  }
  setupControlComps() {
    const e = this.column.getColDef();
    this.includeSelection = this.isIncludeControl(this.isCheckboxSelection(e), !0), this.includeRowDrag = this.isIncludeControl(e.rowDrag), this.includeDndSource = this.isIncludeControl(e.dndSource), this.comp.setIncludeSelection(this.includeSelection), this.comp.setIncludeDndSource(this.includeDndSource), this.comp.setIncludeRowDrag(this.includeRowDrag);
  }
  isForceWrapper() {
    return this.beans.gos.get("enableCellTextSelection") || this.column.isAutoHeight();
  }
  /**
   * Wrapper providing general conditions under which control elements (e.g. checkboxes and drag handles)
   * are rendered for a particular cell.
   * @param value Whether to render the control in the specific context of the caller
   * @param allowManuallyPinned Whether manually pinned rows are permitted this form of control element
   */
  // eslint-disable-next-line @typescript-eslint/ban-types
  isIncludeControl(e, t = !1) {
    return (this.rowNode.rowPinned == null || t && p1(this.rowNode)) && !!e;
  }
  isCheckboxSelection(e) {
    const { rowSelection: t, groupDisplayType: o } = this.beans.gridOptions, n = Wr(t), s = hs(this.column);
    return o === "custom" && n !== "selectionColumn" && s ? !1 : e.checkboxSelection || s && typeof t == "object" && Os(t);
  }
  refreshShouldDestroy() {
    const e = this.column.getColDef(), t = this.includeSelection != this.isIncludeControl(this.isCheckboxSelection(e), !0), o = this.includeRowDrag != this.isIncludeControl(e.rowDrag), n = this.includeDndSource != this.isIncludeControl(e.dndSource), s = this.isAutoHeight != this.column.isAutoHeight();
    return t || o || n || s;
  }
  onPopupEditorClosed() {
    const { editSvc: e } = this.beans;
    e != null && e.isEditing(this, { withOpenEditor: !0 }) && (e == null || e.stopEditing(this, { source: e != null && e.isBatchEditing() ? "ui" : "api" }));
  }
  /**
   * Ends the Cell Editing
   * @param cancel `True` if the edit process is being canceled.
   * @returns `True` if the value of the `GridCell` has been updated, otherwise `False`.
   */
  stopEditing(e = !1) {
    const { editSvc: t } = this.beans;
    return (t == null ? void 0 : t.stopEditing(this, { cancel: e, source: t != null && t.isBatchEditing() ? "ui" : "api" })) ?? !1;
  }
  createCellRendererParams() {
    const {
      value: e,
      valueFormatted: t,
      column: o,
      rowNode: n,
      comp: s,
      eGui: i,
      beans: { valueSvc: r, gos: l, editSvc: a }
    } = this;
    return Pe(l, {
      value: e,
      valueFormatted: t,
      getValue: () => r.getValueForDisplay(o, n).value,
      setValue: (d) => (a == null ? void 0 : a.setDataValue({ rowNode: n, column: o }, d)) || n.setDataValue(o, d),
      formatValue: this.formatValue.bind(this),
      data: n.data,
      node: n,
      pinned: o.getPinned(),
      colDef: o.getColDef(),
      column: o,
      refreshCell: this.refreshCell.bind(this),
      eGridCell: i,
      eParentOfValue: s.getParentOfValue(),
      registerRowDragger: (d, u, h, p) => this.registerRowDragger(d, u, p),
      setTooltip: (d, u) => {
        var h;
        l.assertModuleRegistered("Tooltip", 3), this.tooltipFeature && this.disableTooltipFeature(), this.enableTooltipFeature(d, u), (h = this.tooltipFeature) == null || h.refreshTooltip();
      }
    });
  }
  onCellChanged(e) {
    e.column === this.column && this.refreshCell({});
  }
  refreshOrDestroyCell(e) {
    var t;
    if (this.refreshShouldDestroy() ? (t = this.rowCtrl) == null || t.recreateCell(this) : this.refreshCell(e), this.hasEdit && this.editCompDetails) {
      const { editSvc: o, comp: n } = this;
      !(n != null && n.getCellEditor()) && o.isEditing(this, { withOpenEditor: !0 }) && o.startEditing(this, { startedEdit: !1, source: "api", silent: !0 });
    }
  }
  // + stop editing {force: true, suppressFlash: true}
  // + event cellChanged {}
  // + cellRenderer.params.refresh() {} -> method passes 'as is' to the cellRenderer, so params could be anything
  // + rowCtrl: event dataChanged {suppressFlash: !update, newData: !update}
  // + rowCtrl: api refreshCells() {animate: true/false}
  // + rowRenderer: api softRefreshView() {}
  refreshCell({ force: e, suppressFlash: t, newData: o } = {}) {
    var c, d, u, h, p, C, m, w;
    if (this.suppressRefreshCell)
      return;
    const n = this.column.getColDef(), s = n.field == null && n.valueGetter == null && n.showRowGroup == null, i = e || s || o, r = !!this.comp, l = this.updateAndFormatValue(r), a = i || l;
    if (r) {
      if (a) {
        this.showValue(!!o, !1);
        const y = (c = this.beans.filterManager) == null ? void 0 : c.isSuppressFlashingCellsBecauseFiltering();
        !t && !y && n.enableCellChangeFlash && ((d = this.beans.cellFlashSvc) == null || d.flashCell(this)), (h = (u = this.editStyleFeature) == null ? void 0 : u.applyCellStyles) == null || h.call(u), (p = this.customStyleFeature) == null || p.applyUserStyles(), (C = this.customStyleFeature) == null || C.applyClassesFromColDef();
      }
      (m = this.tooltipFeature) == null || m.refreshTooltip(), (w = this.customStyleFeature) == null || w.applyCellClassRules();
    }
  }
  isCellEditable() {
    return this.column.isCellEditable(this.rowNode);
  }
  formatValue(e) {
    return this.callValueFormatter(e) ?? e;
  }
  callValueFormatter(e) {
    return this.beans.valueSvc.formatValue(this.column, this.rowNode, e);
  }
  updateAndFormatValue(e) {
    const t = this.value, o = this.valueFormatted, { value: n, valueFormatted: s } = this.beans.valueSvc.getValueForDisplay(this.column, this.rowNode, !0);
    return this.value = n, this.valueFormatted = s, e ? !this.valuesAreEqual(t, this.value) || this.valueFormatted != o : !0;
  }
  valuesAreEqual(e, t) {
    const o = this.column.getColDef();
    return o.equals ? o.equals(e, t) : e === t;
  }
  addDomData(e) {
    const t = this.eGui;
    Ys(this.beans.gos, t, Fl, this), e.addDestroyFunc(() => Ys(this.beans.gos, t, Fl, null));
  }
  createEvent(e, t) {
    const { rowNode: o, column: n, value: s, beans: i } = this;
    return MGe(i, e, t, { rowNode: o, column: n }, s);
  }
  processCharacter(e) {
    var t;
    (t = this.keyboardListener) == null || t.processCharacter(e);
  }
  onKeyDown(e) {
    var t;
    (t = this.keyboardListener) == null || t.onKeyDown(e);
  }
  onMouseEvent(e, t) {
    var o;
    (o = this.mouseListener) == null || o.onMouseEvent(e, t);
  }
  getColSpanningList() {
    var e;
    return ((e = this.positionFeature) == null ? void 0 : e.getColSpanningList()) ?? [];
  }
  onLeftChanged() {
    var e;
    this.comp && ((e = this.positionFeature) == null || e.onLeftChanged());
  }
  onDisplayedColumnsChanged() {
    this.eGui && (this.refreshAriaColIndex(), this.refreshFirstAndLastStyles());
  }
  refreshFirstAndLastStyles() {
    const { comp: e, column: t, beans: o } = this;
    Hb(e, t, o.visibleCols);
  }
  refreshAriaColIndex() {
    const e = this.beans.visibleCols.getAriaColIndex(this.column);
    v2(this.eGui, e);
  }
  onWidthChanged() {
    var e;
    return (e = this.positionFeature) == null ? void 0 : e.onWidthChanged();
  }
  getRowPosition() {
    const { rowIndex: e, rowPinned: t } = this.cellPosition;
    return {
      rowIndex: e,
      rowPinned: t
    };
  }
  updateRangeBordersIfRangeCount() {
    var e;
    this.comp && ((e = this.rangeFeature) == null || e.updateRangeBordersIfRangeCount());
  }
  onCellSelectionChanged() {
    var e;
    this.comp && ((e = this.rangeFeature) == null || e.onCellSelectionChanged());
  }
  isRangeSelectionEnabled() {
    return this.rangeFeature != null;
  }
  focusCell(e = !1, t) {
    var n;
    const o = (n = this.editSvc) == null ? void 0 : n.allowedFocusTargetOnValidation(this);
    o && o !== this || this.beans.focusSvc.setFocusedCell({
      ...this.getFocusedCellPosition(),
      forceBrowserFocus: e,
      sourceEvent: t
    });
  }
  /**
   * Restores focus to the cell, if it should have it
   * @param waitForRender if the cell has just setComp, it may not be rendered yet, so we wait for the next render
   */
  restoreFocus(e = !1) {
    const {
      beans: { editSvc: t, focusSvc: o },
      comp: n
    } = this;
    if (!n || t != null && t.isEditing(this) || !this.isCellFocused() || !o.shouldTakeFocus())
      return;
    const s = () => {
      if (!this.isAlive())
        return;
      const i = n.getFocusableElement();
      this.isCellFocused() && i.focus({ preventScroll: !0 });
    };
    if (e) {
      setTimeout(s, 0);
      return;
    }
    s();
  }
  onRowIndexChanged() {
    var e, t;
    this.createCellPosition(), this.onCellFocused(), this.restoreFocus(), (e = this.rangeFeature) == null || e.onCellSelectionChanged(), (t = this.rowResizeFeature) == null || t.refreshRowResizer();
  }
  onSuppressCellFocusChanged(e) {
    const t = this.eGui;
    t && (ns(this.column) && (e = !0), mo(t, "tabindex", e ? void 0 : -1));
  }
  onFirstRightPinnedChanged() {
    if (!this.comp)
      return;
    const e = this.column.isFirstRightPinned();
    this.comp.toggleCss(DGe, e);
  }
  onLastLeftPinnedChanged() {
    if (!this.comp)
      return;
    const e = this.column.isLastLeftPinned();
    this.comp.toggleCss(kGe, e);
  }
  /**
   * Returns whether cell is focused by the focusSvc, overridden by spannedCellCtrl
   */
  checkCellFocused() {
    return this.beans.focusSvc.isCellFocused(this.cellPosition);
  }
  isCellFocused() {
    const e = this.checkCellFocused();
    return this.hasBeenFocused || (this.hasBeenFocused = e), e;
  }
  setupFocus() {
    this.restoreFocus(!0), this.onCellFocused(this.focusEventWhileNotReady ?? void 0);
  }
  onCellFocused(e) {
    var s;
    const { beans: t } = this;
    if (ba(t))
      return;
    if (!this.comp) {
      e && (this.focusEventWhileNotReady = e);
      return;
    }
    const o = this.isCellFocused(), n = ((s = t.editSvc) == null ? void 0 : s.isEditing(this)) ?? !1;
    if (this.comp.toggleCss(IGe, o), o && e && e.forceBrowserFocus) {
      let i = this.comp.getFocusableElement();
      if (n) {
        const r = Fn(i, null, !0);
        r.length && (i = r[0]);
      }
      i.focus({ preventScroll: !!e.preventScrollOnBrowserFocus });
    }
    o && this.rowCtrl.announceDescription();
  }
  createCellPosition() {
    const { rowIndex: e, rowPinned: t } = this.rowNode;
    this.cellPosition = {
      rowIndex: e,
      rowPinned: Ft(t),
      column: this.column
    };
  }
  // CSS Classes that only get applied once, they never change
  applyStaticCssClasses() {
    const { comp: e } = this;
    e.toggleCss(RGe, !0), e.toggleCss(HGe, !0);
    const t = this.column.isAutoHeight() == !0;
    e.toggleCss(FGe, t), e.toggleCss(TGe, !t);
  }
  onColumnHover() {
    var e;
    (e = this.beans.colHover) == null || e.onCellColumnHover(this.column, this.comp);
  }
  onColDefChanged() {
    var e, t;
    this.comp && (this.column.isTooltipEnabled() ? (this.disableTooltipFeature(), this.enableTooltipFeature()) : this.disableTooltipFeature(), this.setWrapText(), (e = this.editSvc) != null && e.isEditing(this) ? (t = this.editSvc) == null || t.handleColDefChanged(this) : this.refreshOrDestroyCell({ force: !0, suppressFlash: !0 }));
  }
  setWrapText() {
    const e = this.column.getColDef().wrapText == !0;
    this.comp.toggleCss(VGe, e);
  }
  dispatchCellContextMenuEvent(e) {
    const t = this.column.getColDef(), o = this.createEvent(e, "cellContextMenu"), { beans: n } = this;
    n.eventSvc.dispatchEvent(o), t.onCellContextMenu && window.setTimeout(() => {
      n.frameworkOverrides.wrapOutgoing(() => {
        t.onCellContextMenu(o);
      });
    }, 0);
  }
  getCellRenderer() {
    var e;
    return ((e = this.comp) == null ? void 0 : e.getCellRenderer()) ?? null;
  }
  destroy() {
    this.onCompAttachedFuncs = [], this.onEditorAttachedFuncs = [], this.isCellFocused() && this.hasBrowserFocus() && this.beans.focusSvc.attemptToRecoverFocus(), super.destroy();
  }
  hasBrowserFocus() {
    var e;
    return ((e = this.eGui) == null ? void 0 : e.contains(Ue(this.beans))) ?? !1;
  }
  createSelectionCheckbox() {
    var t;
    const e = (t = this.beans.selectionSvc) == null ? void 0 : t.createCheckboxSelectionComponent();
    if (e)
      return this.beans.context.createBean(e), e.init({ rowNode: this.rowNode, column: this.column }), e;
  }
  createDndSource() {
    const e = this.beans.registry.createDynamicBean(
      "dndSourceComp",
      !1,
      this.rowNode,
      this.column,
      this.eGui
    );
    return e && this.beans.context.createBean(e), e;
  }
  registerRowDragger(e, t, o) {
    if (this.customRowDragComp) {
      this.customRowDragComp.setDragElement(e, t);
      return;
    }
    const n = this.createRowDragComp(e, t, o);
    n && (this.customRowDragComp = n, this.addDestroyFunc(() => {
      this.beans.context.destroyBean(n), this.customRowDragComp = null;
    }), n.refreshVisibility());
  }
  createRowDragComp(e, t, o) {
    var s;
    const n = (s = this.beans.rowDragSvc) == null ? void 0 : s.createRowDragCompForCell(
      this.rowNode,
      this.column,
      () => this.value,
      e,
      t,
      o
    );
    if (n)
      return this.beans.context.createBean(n), n;
  }
  cellEditorAttached() {
    this.onEditorAttachedFuncs.forEach((e) => e()), this.onEditorAttachedFuncs = [];
  }
  setFocusedCellPosition(e) {
  }
  getFocusedCellPosition() {
    return this.cellPosition;
  }
  // used by spannedCellCtrl
  refreshAriaRowIndex() {
  }
  /**
   * Returns the root element of the cell, could be a span container rather than the cell element.
   * @returns The root element of the cell.
   */
  getRootElement() {
    return this.eGui;
  }
};
function rc(e, t, o, n, s, i) {
  if (o == null && t == null)
    return;
  const r = {}, l = {}, a = (c, d) => {
    c.split(" ").forEach((u) => {
      u.trim() != "" && d(u);
    });
  };
  if (o) {
    const c = Object.keys(o);
    for (let d = 0; d < c.length; d++) {
      const u = c[d], h = o[u];
      let p;
      typeof h == "string" ? p = e ? e.evaluate(h, n) : !0 : typeof h == "function" && (p = h(n)), a(u, (C) => {
        p ? r[C] = !0 : l[C] = !0;
      });
    }
  }
  t && i && Object.keys(t).forEach(
    (c) => a(c, (d) => {
      r[d] || (l[d] = !0);
    })
  ), i && Object.keys(l).forEach(i), Object.keys(r).forEach(s);
}
function wu(e) {
  if (e.group)
    return e.level;
  const t = e.parent;
  return t ? t.level + 1 : 0;
}
var BGe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "rowStyleSvc";
  }
  processClassesFromGridOptions(e, t) {
    const o = this.gos, n = (r) => {
      typeof r == "string" ? e.push(r) : Array.isArray(r) && r.forEach((l) => e.push(l));
    }, s = o.get("rowClass");
    s && n(s);
    const i = o.getCallback("getRowClass");
    if (i) {
      const r = {
        data: t.data,
        node: t,
        rowIndex: t.rowIndex
      }, l = i(r);
      n(l);
    }
  }
  preProcessRowClassRules(e, t) {
    this.processRowClassRules(
      t,
      (o) => {
        e.push(o);
      },
      () => {
      }
    );
  }
  processRowClassRules(e, t, o) {
    const { gos: n, expressionSvc: s } = this.beans, i = Pe(n, {
      data: e.data,
      node: e,
      rowIndex: e.rowIndex
    });
    rc(
      s,
      void 0,
      n.get("rowClassRules"),
      i,
      t,
      o
    );
  }
  processStylesFromGridOptions(e) {
    const t = this.gos, o = t.get("rowStyle"), n = t.getCallback("getRowStyle");
    let s;
    if (n) {
      const i = {
        data: e.data,
        node: e,
        rowIndex: e.rowIndex
      };
      s = n(i);
    }
    if (s || o)
      return Object.assign({}, o, s);
  }
}, $Ge = 0, Vl = class extends K {
  constructor(e, t, o, n, s) {
    var i, r;
    super(), this.rowNode = e, this.useAnimationFrameForCreate = n, this.printLayout = s, this.allRowGuis = [], this.active = !0, this.centerCellCtrls = { list: [], map: {} }, this.leftCellCtrls = { list: [], map: {} }, this.rightCellCtrls = { list: [], map: {} }, this.slideInAnimation = {
      left: !1,
      center: !1,
      right: !1,
      fullWidth: !1
    }, this.fadeInAnimation = {
      left: !1,
      center: !1,
      right: !1,
      fullWidth: !1
    }, this.rowDragComps = [], this.lastMouseDownOnDragger = !1, this.emptyStyle = {}, this.updateColumnListsPending = !1, this.rowId = null, this.businessKey = null, this.beans = t, this.gos = t.gos, this.paginationPage = ((i = t.pagination) == null ? void 0 : i.getCurrentPage()) ?? 0, this.suppressRowTransform = this.gos.get("suppressRowTransform"), this.instanceId = e.id + "-" + $Ge++, this.rowId = xr(e.id), this.initRowBusinessKey(), this.rowFocused = t.focusSvc.isRowFocused(this.rowNode.rowIndex, this.rowNode.rowPinned), this.rowLevel = wu(this.rowNode), this.setRowType(), this.setAnimateFlags(o), this.rowStyles = this.processStylesFromGridOptions(), this.rowEditStyleFeature = (r = t.editSvc) == null ? void 0 : r.createRowStyleFeature(this, t), this.addListeners();
  }
  initRowBusinessKey() {
    this.businessKeyForNodeFunc = this.gos.get("getBusinessKeyForNode"), this.updateRowBusinessKey();
  }
  updateRowBusinessKey() {
    if (typeof this.businessKeyForNodeFunc != "function")
      return;
    const e = this.businessKeyForNodeFunc(this.rowNode);
    this.businessKey = xr(e);
  }
  updateGui(e, t) {
    e === "left" ? this.leftGui = t : e === "right" ? this.rightGui = t : e === "fullWidth" ? this.fullWidthGui = t : this.centerGui = t;
  }
  setComp(e, t, o, n) {
    var u, h;
    const { context: s, focusSvc: i } = this.beans;
    n = d1(this, s, n);
    const r = { rowComp: e, element: t, containerType: o, compBean: n };
    this.allRowGuis.push(r), this.updateGui(o, r), this.initialiseRowComp(r);
    const l = this.rowNode, a = this.rowType === "FullWidthLoading" || l.stub, c = !l.data && this.beans.rowModel.getType() === "infinite";
    !a && !c && !l.rowPinned && this.beans.rowRenderer.dispatchFirstDataRenderedEvent();
    const d = (u = this.fullWidthGui) == null ? void 0 : u.element;
    d && !((h = this.beans.editSvc) != null && h.isEditing(this)) && i.isRowFocused(l.rowIndex, l.rowPinned) && i.shouldTakeFocus() && setTimeout(() => d.focus({ preventScroll: !0 }), 0);
  }
  unsetComp(e) {
    this.allRowGuis = this.allRowGuis.filter((t) => t.containerType !== e), this.updateGui(e, void 0);
  }
  isCacheable() {
    return this.rowType === "FullWidthDetail" && this.gos.get("keepDetailRows");
  }
  setCached(e) {
    const t = e ? "none" : "";
    this.allRowGuis.forEach((o) => o.element.style.display = t);
  }
  initialiseRowComp(e) {
    const t = this.gos;
    this.onSuppressCellFocusChanged(this.beans.gos.get("suppressCellFocus")), this.listenOnDomOrder(e), this.onRowHeightChanged(e), this.updateRowIndexes(e), this.setFocusedClasses(e), this.setStylesFromGridOptions(!1, e), os(t) && this.rowNode.selectable && this.onRowSelected(e), this.updateColumnLists(!this.useAnimationFrameForCreate);
    const o = e.rowComp;
    this.getInitialRowClasses(e.containerType).forEach((s) => o.toggleCss(s, !0)), this.executeSlideAndFadeAnimations(e), this.rowNode.group && Fo(e.element, this.rowNode.expanded == !0), this.setRowCompRowId(o), this.setRowCompRowBusinessKey(o), Ys(t, e.element, Tl, this), e.compBean.addDestroyFunc(() => Ys(t, e.element, Tl, null)), this.useAnimationFrameForCreate ? this.beans.animationFrameSvc.createTask(
      this.addHoverFunctionality.bind(this, e),
      this.rowNode.rowIndex,
      "p2",
      !1
    ) : this.addHoverFunctionality(e), this.isFullWidth() && this.setupFullWidth(e), t.get("rowDragEntireRow") && this.addRowDraggerToRow(e), this.useAnimationFrameForCreate && this.beans.animationFrameSvc.addDestroyTask(() => {
      this.isAlive() && e.rowComp.toggleCss("ag-after-created", !0);
    }), this.executeProcessRowPostCreateFunc();
  }
  setRowCompRowBusinessKey(e) {
    this.businessKey != null && e.setRowBusinessKey(this.businessKey);
  }
  setRowCompRowId(e) {
    const t = xr(this.rowNode.id);
    this.rowId = t, t != null && e.setRowId(t);
  }
  executeSlideAndFadeAnimations(e) {
    const { containerType: t } = e;
    this.slideInAnimation[t] && (Q0(() => {
      this.onTopChanged();
    }), this.slideInAnimation[t] = !1), this.fadeInAnimation[t] && (Q0(() => {
      e.rowComp.toggleCss("ag-opacity-zero", !1);
    }), this.fadeInAnimation[t] = !1);
  }
  addRowDraggerToRow(e) {
    var n;
    const t = (n = this.beans.rowDragSvc) == null ? void 0 : n.createRowDragCompForRow(this.rowNode, e.element);
    if (!t)
      return;
    const o = this.createBean(t, this.beans.context);
    this.rowDragComps.push(o), e.compBean.addDestroyFunc(() => {
      this.rowDragComps = this.rowDragComps.filter((s) => s !== o), this.rowEditStyleFeature = this.destroyBean(this.rowEditStyleFeature, this.beans.context), this.destroyBean(o, this.beans.context);
    });
  }
  setupFullWidth(e) {
    const t = this.getPinnedForContainer(e.containerType), o = this.createFullWidthCompDetails(e.element, t);
    e.rowComp.showFullWidth(o);
  }
  getFullWidthCellRenderers() {
    var e, t;
    return this.gos.get("embedFullWidthRows") ? this.allRowGuis.map((o) => {
      var n;
      return (n = o == null ? void 0 : o.rowComp) == null ? void 0 : n.getFullWidthCellRenderer();
    }) : [(t = (e = this.fullWidthGui) == null ? void 0 : e.rowComp) == null ? void 0 : t.getFullWidthCellRenderer()];
  }
  executeProcessRowPostCreateFunc() {
    const e = this.gos.getCallback("processRowPostCreate");
    if (!e || !this.areAllContainersReady())
      return;
    const t = {
      // areAllContainersReady asserts that centerGui is not null
      eRow: this.centerGui.element,
      ePinnedLeftRow: this.leftGui ? this.leftGui.element : void 0,
      ePinnedRightRow: this.rightGui ? this.rightGui.element : void 0,
      node: this.rowNode,
      rowIndex: this.rowNode.rowIndex,
      addRenderedRowListener: this.addEventListener.bind(this)
    };
    e(t);
  }
  areAllContainersReady() {
    const {
      leftGui: e,
      centerGui: t,
      rightGui: o,
      beans: { visibleCols: n }
    } = this, s = !!e || !n.isPinningLeft(), i = !!t, r = !!o || !n.isPinningRight();
    return s && i && r;
  }
  isNodeFullWidthCell() {
    if (this.rowNode.detail)
      return !0;
    const e = this.beans.gos.getCallback("isFullWidthRow");
    return e ? e({ rowNode: this.rowNode }) : !1;
  }
  setRowType() {
    const e = this.rowNode.stub && !this.gos.get("suppressServerSideFullWidthLoadingRow") && !this.gos.get("groupHideOpenParents"), t = this.isNodeFullWidthCell(), o = this.gos.get("masterDetail") && this.rowNode.detail, n = this.beans.colModel.isPivotMode(), s = Ew(this.gos, this.rowNode, n);
    e ? this.rowType = "FullWidthLoading" : o ? this.rowType = "FullWidthDetail" : t ? this.rowType = "FullWidth" : s ? this.rowType = "FullWidthGroup" : this.rowType = "Normal";
  }
  updateColumnLists(e = !1, t = !1) {
    if (this.isFullWidth())
      return;
    const { animationFrameSvc: o } = this.beans;
    if (!(o != null && o.active) || e || this.printLayout) {
      this.updateColumnListsImpl(t);
      return;
    }
    this.updateColumnListsPending || (o.createTask(
      () => {
        this.active && this.updateColumnListsImpl(!0);
      },
      this.rowNode.rowIndex,
      "p1",
      !1
    ), this.updateColumnListsPending = !0);
  }
  /**
   * Overridden by SpannedRowCtrl
   */
  getNewCellCtrl(e) {
    var o;
    if (!((o = this.beans.rowSpanSvc) != null && o.isCellSpanning(e, this.rowNode)))
      return new Ii(e, this.rowNode, this.beans, this);
  }
  /**
   * Overridden by SpannedRowCtrl, if span context changes cell needs rebuilt
   */
  isCorrectCtrlForSpan(e) {
    var t;
    return !((t = this.beans.rowSpanSvc) != null && t.isCellSpanning(e.column, this.rowNode));
  }
  createCellCtrls(e, t, o = null) {
    const n = {
      list: [],
      map: {}
    }, s = (c, d, u) => {
      u != null ? n.list.splice(u, 0, d) : n.list.push(d), n.map[c] = d;
    }, i = [];
    for (const c of t) {
      const d = c.getInstanceId();
      let u = e.map[d];
      u && !this.isCorrectCtrlForSpan(u) && (u.destroy(), u = void 0), u || (u = this.getNewCellCtrl(c)), u && s(d, u);
    }
    for (const c of e.list) {
      const d = c.column.getInstanceId();
      if (n.map[d] != null)
        continue;
      !this.isCellEligibleToBeRemoved(c, o) ? i.push([d, c]) : c.destroy();
    }
    if (i.length)
      for (const [c, d] of i) {
        const u = n.list.findIndex((p) => p.column.getLeft() > d.column.getLeft()), h = u === -1 ? void 0 : Math.max(u - 1, 0);
        s(c, d, h);
      }
    const { focusSvc: r, visibleCols: l } = this.beans, a = r.getFocusedCell();
    if (a && a.column.getPinned() == o) {
      const c = a.column.getInstanceId();
      if (!n.map[c] && l.allCols.includes(a.column)) {
        const u = this.createFocusedCellCtrl();
        if (u) {
          const h = n.list.findIndex((C) => C.column.getLeft() > u.column.getLeft()), p = h === -1 ? void 0 : Math.max(h - 1, 0);
          s(c, u, p);
        }
      }
    }
    return n;
  }
  /**
   * Creates a new cell ctrl for the focused cell, if this is the correct row ctrl.
   * @returns a CellCtrl for the focused cell, if required.
   */
  createFocusedCellCtrl() {
    const { focusSvc: e, rowSpanSvc: t } = this.beans, o = e.getFocusedCell();
    if (!o)
      return;
    const n = t == null ? void 0 : t.getCellSpan(o.column, this.rowNode);
    if (n) {
      if (n.firstNode !== this.rowNode || !n.doesSpanContain(o))
        return;
    } else if (!e.isRowFocused(this.rowNode.rowIndex, this.rowNode.rowPinned))
      return;
    return this.getNewCellCtrl(o.column);
  }
  updateColumnListsImpl(e) {
    this.updateColumnListsPending = !1, this.createAllCellCtrls(), this.setCellCtrls(e);
  }
  setCellCtrls(e) {
    this.allRowGuis.forEach((t) => {
      const o = this.getCellCtrlsForContainer(t.containerType);
      t.rowComp.setCellCtrls(o, e);
    });
  }
  getCellCtrlsForContainer(e) {
    switch (e) {
      case "left":
        return this.leftCellCtrls.list;
      case "right":
        return this.rightCellCtrls.list;
      case "fullWidth":
        return [];
      case "center":
        return this.centerCellCtrls.list;
    }
  }
  createAllCellCtrls() {
    const e = this.beans.colViewport, t = this.beans.visibleCols;
    if (this.printLayout)
      this.centerCellCtrls = this.createCellCtrls(this.centerCellCtrls, t.allCols), this.leftCellCtrls = { list: [], map: {} }, this.rightCellCtrls = { list: [], map: {} };
    else {
      const o = e.getColsWithinViewport(this.rowNode);
      this.centerCellCtrls = this.createCellCtrls(this.centerCellCtrls, o);
      const n = t.getLeftColsForRow(this.rowNode);
      this.leftCellCtrls = this.createCellCtrls(this.leftCellCtrls, n, "left");
      const s = t.getRightColsForRow(this.rowNode);
      this.rightCellCtrls = this.createCellCtrls(this.rightCellCtrls, s, "right");
    }
  }
  isCellEligibleToBeRemoved(e, t) {
    const { column: s } = e;
    if (s.getPinned() != t || !this.isCorrectCtrlForSpan(e))
      return !0;
    const { visibleCols: i, editSvc: r } = this.beans, l = r == null ? void 0 : r.isEditing(e), a = e.isCellFocused();
    return l || a ? !(i.allCols.indexOf(s) >= 0) : !0;
  }
  getDomOrder() {
    return this.gos.get("ensureDomOrder") || jt(this.gos, "print");
  }
  listenOnDomOrder(e) {
    const t = () => {
      e.rowComp.setDomOrder(this.getDomOrder());
    };
    e.compBean.addManagedPropertyListeners(["domLayout", "ensureDomOrder"], t);
  }
  setAnimateFlags(e) {
    if (this.rowNode.sticky || !e)
      return;
    const t = ue(this.rowNode.oldRowTop), { visibleCols: o } = this.beans, n = o.isPinningLeft(), s = o.isPinningRight();
    if (t) {
      const { slideInAnimation: i } = this;
      if (this.isFullWidth() && !this.gos.get("embedFullWidthRows")) {
        i.fullWidth = !0;
        return;
      }
      i.center = !0, i.left = n, i.right = s;
    } else {
      const { fadeInAnimation: i } = this;
      if (this.isFullWidth() && !this.gos.get("embedFullWidthRows")) {
        i.fullWidth = !0;
        return;
      }
      i.center = !0, i.left = n, i.right = s;
    }
  }
  isFullWidth() {
    return this.rowType !== "Normal";
  }
  refreshFullWidth() {
    const e = (r, l) => r ? r.rowComp.refreshFullWidth(() => this.createFullWidthCompDetails(r.element, l).params) : !0, t = e(this.fullWidthGui, null), o = e(this.centerGui, null), n = e(this.leftGui, "left"), s = e(this.rightGui, "right");
    return t && o && n && s;
  }
  addListeners() {
    const { beans: e, gos: t, rowNode: o } = this, { expansionSvc: n, eventSvc: s, context: i, rowSpanSvc: r } = e;
    this.addManagedListeners(this.rowNode, {
      heightChanged: () => this.onRowHeightChanged(),
      rowSelected: () => this.onRowSelected(),
      rowIndexChanged: this.onRowIndexChanged.bind(this),
      topChanged: this.onTopChanged.bind(this),
      ...(n == null ? void 0 : n.getRowExpandedListeners(this)) ?? {}
    }), o.detail && this.addManagedListeners(o.parent, { dataChanged: this.onRowNodeDataChanged.bind(this) }), this.addManagedListeners(o, {
      dataChanged: this.onRowNodeDataChanged.bind(this),
      cellChanged: this.postProcessCss.bind(this),
      rowHighlightChanged: this.onRowNodeHighlightChanged.bind(this),
      draggingChanged: this.postProcessRowDragging.bind(this),
      uiLevelChanged: this.onUiLevelChanged.bind(this),
      rowPinned: this.onRowPinned.bind(this)
    }), this.addManagedListeners(s, {
      paginationPixelOffsetChanged: this.onPaginationPixelOffsetChanged.bind(this),
      heightScaleChanged: this.onTopChanged.bind(this),
      displayedColumnsChanged: this.onDisplayedColumnsChanged.bind(this),
      virtualColumnsChanged: this.onVirtualColumnsChanged.bind(this),
      cellFocused: this.onCellFocusChanged.bind(this),
      cellFocusCleared: this.onCellFocusChanged.bind(this),
      paginationChanged: this.onPaginationChanged.bind(this),
      modelUpdated: this.refreshFirstAndLastRowStyles.bind(this),
      columnMoved: () => this.updateColumnLists()
    }), r && this.addManagedListeners(r, {
      spannedCellsUpdated: ({ pinned: l }) => {
        l && !o.rowPinned || this.updateColumnLists();
      }
    }), this.addDestroyFunc(() => {
      this.rowDragComps = this.destroyBeans(this.rowDragComps, i), this.tooltipFeature = this.destroyBean(this.tooltipFeature, i), this.rowEditStyleFeature = this.destroyBean(this.rowEditStyleFeature, i);
    }), this.addManagedPropertyListeners(
      ["rowStyle", "getRowStyle", "rowClass", "getRowClass", "rowClassRules"],
      this.postProcessCss.bind(this)
    ), this.addManagedPropertyListener("rowDragEntireRow", () => {
      if (t.get("rowDragEntireRow")) {
        this.allRowGuis.forEach((a) => {
          this.addRowDraggerToRow(a);
        });
        return;
      }
      this.rowDragComps = this.destroyBeans(this.rowDragComps, i);
    }), this.addListenersForCellComps();
  }
  addListenersForCellComps() {
    this.addManagedListeners(this.rowNode, {
      rowIndexChanged: () => this.getAllCellCtrls().forEach((e) => e.onRowIndexChanged()),
      cellChanged: (e) => this.getAllCellCtrls().forEach((t) => t.onCellChanged(e))
    });
  }
  /** Should only ever be triggered on source rows (i.e. not on pinned siblings) */
  onRowPinned() {
    for (const e of this.allRowGuis)
      e.rowComp.toggleCss("ag-row-pinned-source", !!this.rowNode.pinnedSibling);
  }
  onRowNodeDataChanged(e) {
    this.refreshRow({
      suppressFlash: !e.update,
      newData: !e.update
    });
  }
  refreshRow(e) {
    if (this.isFullWidth() !== !!this.isNodeFullWidthCell()) {
      this.beans.rowRenderer.redrawRow(this.rowNode);
      return;
    }
    if (this.isFullWidth()) {
      this.refreshFullWidth() || this.beans.rowRenderer.redrawRow(this.rowNode);
      return;
    }
    this.getAllCellCtrls().forEach((o) => o.refreshCell(e)), this.allRowGuis.forEach((o) => {
      this.setRowCompRowId(o.rowComp), this.updateRowBusinessKey(), this.setRowCompRowBusinessKey(o.rowComp);
    }), this.onRowSelected(), this.postProcessCss();
  }
  postProcessCss() {
    var e;
    this.setStylesFromGridOptions(!0), this.postProcessClassesFromGridOptions(), this.postProcessRowClassRules(), (e = this.rowEditStyleFeature) == null || e.applyRowStyles(), this.postProcessRowDragging();
  }
  onRowNodeHighlightChanged() {
    const e = this.beans.rowDropHighlightSvc, t = (e == null ? void 0 : e.row) === this.rowNode ? e.position : "none", o = t === "above", n = t === "inside", s = t === "below", r = this.gos.get("treeData") && (s || o), l = this.rowNode.uiLevel.toString();
    this.allRowGuis.forEach((a) => {
      const c = a.rowComp;
      c.toggleCss("ag-row-highlight-above", o), c.toggleCss("ag-row-highlight-inside", n), c.toggleCss("ag-row-highlight-below", s), c.toggleCss("ag-row-highlight-indent", r), r ? a.element.style.setProperty("--ag-row-highlight-level", l) : a.element.style.removeProperty("--ag-row-highlight-level");
    });
  }
  postProcessRowDragging() {
    const e = this.rowNode.dragging;
    this.allRowGuis.forEach((t) => t.rowComp.toggleCss("ag-row-dragging", e));
  }
  onDisplayedColumnsChanged() {
    var e;
    this.updateColumnLists(!0), (e = this.beans.rowAutoHeight) == null || e.requestCheckAutoHeight();
  }
  onVirtualColumnsChanged() {
    this.updateColumnLists(!1, !0);
  }
  getRowPosition() {
    return {
      rowPinned: Ft(this.rowNode.rowPinned),
      rowIndex: this.rowNode.rowIndex
    };
  }
  onKeyboardNavigate(e) {
    const t = this.findFullWidthInfoForEvent(e);
    if (!t)
      return;
    const { rowGui: o, column: n } = t;
    if (!(o.element === e.target))
      return;
    const r = this.rowNode, { focusSvc: l, navigation: a } = this.beans, c = l.getFocusedCell(), d = {
      rowIndex: r.rowIndex,
      rowPinned: r.rowPinned,
      column: (c == null ? void 0 : c.column) ?? n
    };
    a == null || a.navigateToNextCell(e, e.key, d, !0), e.preventDefault();
  }
  onTabKeyDown(e) {
    var l;
    if (e.defaultPrevented || wo(e))
      return;
    const t = this.allRowGuis.find(
      (a) => a.element.contains(e.target)
    ), o = t ? t.element : null, n = o === e.target, s = Ue(this.beans);
    let i = !1;
    o && s && (i = o.contains(s) && s.classList.contains("ag-cell"));
    let r = null;
    !n && !i && (r = Yt(this.beans, o, !1, e.shiftKey)), (this.isFullWidth() && n || !r) && ((l = this.beans.navigation) == null || l.onTabKeyDown(this, e));
  }
  getFullWidthElement() {
    return this.fullWidthGui ? this.fullWidthGui.element : null;
  }
  getRowYPosition() {
    var t;
    const e = (t = this.allRowGuis.find((o) => ro(o.element))) == null ? void 0 : t.element;
    return e ? e.getBoundingClientRect().top : 0;
  }
  onSuppressCellFocusChanged(e) {
    const t = this.isFullWidth() && e ? void 0 : this.gos.get("tabIndex");
    this.allRowGuis.forEach((o) => {
      mo(o.element, "tabindex", t);
    });
  }
  onFullWidthRowFocused(e) {
    var s, i, r;
    const t = this.rowNode, o = e ? this.isFullWidth() && e.rowIndex === t.rowIndex && e.rowPinned == t.rowPinned : !1;
    let n;
    if (this.fullWidthGui)
      n = this.fullWidthGui.element;
    else {
      const l = this.beans.colModel.getCol(e == null ? void 0 : e.column), a = l == null ? void 0 : l.pinned;
      a ? n = a === "right" ? (s = this.rightGui) == null ? void 0 : s.element : (i = this.leftGui) == null ? void 0 : i.element : n = (r = this.centerGui) == null ? void 0 : r.element;
    }
    n && (n.classList.toggle("ag-full-width-focus", o), o && (e != null && e.forceBrowserFocus) && n.focus({ preventScroll: !0 }));
  }
  recreateCell(e) {
    this.centerCellCtrls = this.removeCellCtrl(this.centerCellCtrls, e), this.leftCellCtrls = this.removeCellCtrl(this.leftCellCtrls, e), this.rightCellCtrls = this.removeCellCtrl(this.rightCellCtrls, e), e.destroy(), this.updateColumnLists();
  }
  removeCellCtrl(e, t) {
    const o = {
      list: [],
      map: {}
    };
    return e.list.forEach((n) => {
      n !== t && (o.list.push(n), o.map[n.column.getInstanceId()] = n);
    }), o;
  }
  onMouseEvent(e, t) {
    switch (e) {
      case "dblclick":
        this.onRowDblClick(t);
        break;
      case "click":
        this.onRowClick(t);
        break;
      case "touchstart":
      case "mousedown":
        this.onRowMouseDown(t);
        break;
    }
  }
  createRowEvent(e, t) {
    const { rowNode: o } = this;
    return Pe(this.gos, {
      type: e,
      node: o,
      data: o.data,
      rowIndex: o.rowIndex,
      rowPinned: o.rowPinned,
      event: t
    });
  }
  createRowEventWithSource(e, t) {
    const o = this.createRowEvent(e, t);
    return o.source = this, o;
  }
  onRowDblClick(e) {
    if (wo(e))
      return;
    const t = this.createRowEventWithSource("rowDoubleClicked", e);
    t.isEventHandlingSuppressed = this.isSuppressMouseEvent(e), this.beans.eventSvc.dispatchEvent(t);
  }
  findFullWidthInfoForEvent(e) {
    if (!e)
      return;
    const t = this.findFullWidthRowGui(e.target), o = this.getColumnForFullWidth(t);
    if (!(!t || !o))
      return { rowGui: t, column: o };
  }
  findFullWidthRowGui(e) {
    return this.allRowGuis.find((t) => t.element.contains(e));
  }
  getColumnForFullWidth(e) {
    const { visibleCols: t } = this.beans;
    switch (e == null ? void 0 : e.containerType) {
      case "center":
        return t.centerCols[0];
      case "left":
        return t.leftCols[0];
      case "right":
        return t.rightCols[0];
      default:
        return t.allCols[0];
    }
  }
  onRowMouseDown(e) {
    if (this.lastMouseDownOnDragger = ks(e.target, "ag-row-drag", 3), !this.isFullWidth() || this.isSuppressMouseEvent(e))
      return;
    const { rangeSvc: t, focusSvc: o } = this.beans;
    t == null || t.removeAllCellRanges();
    const n = this.findFullWidthInfoForEvent(e);
    if (!n)
      return;
    const { rowGui: s, column: i } = n, r = s.element, l = e.target, a = this.rowNode;
    let c = e.defaultPrevented || Gn();
    r && r.contains(l) && w2(l) && (c = !1), o.setFocusedCell({
      rowIndex: a.rowIndex,
      column: i,
      rowPinned: a.rowPinned,
      forceBrowserFocus: c
    });
  }
  isSuppressMouseEvent(e) {
    const { gos: t, rowNode: o } = this;
    if (this.isFullWidth()) {
      const s = this.findFullWidthRowGui(e.target);
      return CHe(
        t,
        s == null ? void 0 : s.rowComp.getFullWidthCellRendererParams(),
        o,
        e
      );
    }
    const n = U2(t, e.target);
    return n != null && K1(t, n.column, o, e);
  }
  onRowClick(e) {
    if (wo(e) || this.lastMouseDownOnDragger)
      return;
    const o = this.isSuppressMouseEvent(e), { eventSvc: n, selectionSvc: s } = this.beans, i = this.createRowEventWithSource("rowClicked", e);
    i.isEventHandlingSuppressed = o, n.dispatchEvent(i), !o && (s == null || s.handleSelectionEvent(e, this.rowNode, "rowClicked"));
  }
  setupDetailRowAutoHeight(e) {
    var t;
    this.rowType === "FullWidthDetail" && ((t = this.beans.masterDetailSvc) == null || t.setupDetailRowAutoHeight(this, e));
  }
  createFullWidthCompDetails(e, t) {
    const { gos: o, rowNode: n } = this, s = Pe(o, {
      fullWidth: !0,
      data: n.data,
      node: n,
      value: n.key,
      valueFormatted: n.key,
      // these need to be taken out, as part of 'afterAttached' now
      eGridCell: e,
      eParentOfValue: e,
      pinned: t,
      addRenderedRowListener: this.addEventListener.bind(this),
      // This is not on the type of ICellRendererParams
      registerRowDragger: (r, l, a, c) => this.addFullWidthRowDragging(r, l, a, c),
      setTooltip: (r, l) => {
        o.assertModuleRegistered("Tooltip", 3), this.setupFullWidthRowTooltip(r, l);
      }
    }), i = this.beans.userCompFactory;
    switch (this.rowType) {
      case "FullWidthDetail":
        return TDe(i, s);
      case "FullWidthGroup": {
        const { value: r, valueFormatted: l } = this.beans.valueSvc.getValueForDisplay(void 0, this.rowNode, !0);
        return s.value = r, s.valueFormatted = l, FDe(i, s);
      }
      case "FullWidthLoading":
        return RDe(i, s);
      default:
        return PDe(i, s);
    }
  }
  setupFullWidthRowTooltip(e, t) {
    var o;
    this.fullWidthGui && (this.tooltipFeature = (o = this.beans.tooltipSvc) == null ? void 0 : o.setupFullWidthRowTooltip(
      this.tooltipFeature,
      this,
      e,
      t
    ));
  }
  addFullWidthRowDragging(e, t, o = "", n) {
    const { rowDragSvc: s, context: i } = this.beans;
    if (!s || !this.isFullWidth())
      return;
    const r = s.createRowDragComp(
      () => o,
      this.rowNode,
      void 0,
      e,
      t,
      n
    );
    this.createBean(r, i), this.addDestroyFunc(() => {
      this.destroyBean(r, i);
    });
  }
  onUiLevelChanged() {
    const e = wu(this.rowNode);
    if (this.rowLevel != e) {
      const t = "ag-row-level-" + e, o = "ag-row-level-" + this.rowLevel;
      this.allRowGuis.forEach((n) => {
        n.rowComp.toggleCss(t, !0), n.rowComp.toggleCss(o, !1);
      });
    }
    this.rowLevel = e;
  }
  isFirstRowOnPage() {
    return this.rowNode.rowIndex === this.beans.pageBounds.getFirstRow();
  }
  isLastRowOnPage() {
    return this.rowNode.rowIndex === this.beans.pageBounds.getLastRow();
  }
  refreshFirstAndLastRowStyles() {
    const e = this.isFirstRowOnPage(), t = this.isLastRowOnPage();
    this.firstRowOnPage !== e && (this.firstRowOnPage = e, this.allRowGuis.forEach((o) => o.rowComp.toggleCss("ag-row-first", e))), this.lastRowOnPage !== t && (this.lastRowOnPage = t, this.allRowGuis.forEach((o) => o.rowComp.toggleCss("ag-row-last", t)));
  }
  getAllCellCtrls() {
    return this.leftCellCtrls.list.length === 0 && this.rightCellCtrls.list.length === 0 ? this.centerCellCtrls.list : [...this.centerCellCtrls.list, ...this.leftCellCtrls.list, ...this.rightCellCtrls.list];
  }
  postProcessClassesFromGridOptions() {
    var t;
    const e = [];
    (t = this.beans.rowStyleSvc) == null || t.processClassesFromGridOptions(e, this.rowNode), e.length && e.forEach((o) => {
      this.allRowGuis.forEach((n) => n.rowComp.toggleCss(o, !0));
    });
  }
  postProcessRowClassRules() {
    var e;
    (e = this.beans.rowStyleSvc) == null || e.processRowClassRules(
      this.rowNode,
      (t) => {
        this.allRowGuis.forEach((o) => o.rowComp.toggleCss(t, !0));
      },
      (t) => {
        this.allRowGuis.forEach((o) => o.rowComp.toggleCss(t, !1));
      }
    );
  }
  setStylesFromGridOptions(e, t) {
    e && (this.rowStyles = this.processStylesFromGridOptions()), this.forEachGui(t, (o) => o.rowComp.setUserStyles(this.rowStyles));
  }
  getPinnedForContainer(e) {
    return e === "left" || e === "right" ? e : null;
  }
  getInitialRowClasses(e) {
    var l, a;
    const t = this.getPinnedForContainer(e), o = this.isFullWidth(), { rowNode: n, beans: s } = this, i = [];
    i.push("ag-row"), i.push(this.rowFocused ? "ag-row-focus" : "ag-row-no-focus"), this.fadeInAnimation[e] && i.push("ag-opacity-zero"), i.push(n.rowIndex % 2 === 0 ? "ag-row-even" : "ag-row-odd"), n.isRowPinned() && (i.push("ag-row-pinned"), (l = s.pinnedRowModel) != null && l.isManual() && i.push("ag-row-pinned-manual")), !n.isRowPinned() && n.pinnedSibling && i.push("ag-row-pinned-source"), n.isSelected() && i.push("ag-row-selected"), n.footer && i.push("ag-row-footer"), i.push("ag-row-level-" + this.rowLevel), n.stub && i.push("ag-row-loading"), o && i.push("ag-full-width-row"), (a = s.expansionSvc) == null || a.addExpandedCss(i, n), n.dragging && i.push("ag-row-dragging");
    const { rowStyleSvc: r } = s;
    return r && (r.processClassesFromGridOptions(i, n), r.preProcessRowClassRules(i, n)), i.push(this.printLayout ? "ag-row-position-relative" : "ag-row-position-absolute"), this.isFirstRowOnPage() && i.push("ag-row-first"), this.isLastRowOnPage() && i.push("ag-row-last"), o && (t === "left" && i.push("ag-cell-last-left-pinned"), t === "right" && i.push("ag-cell-first-right-pinned")), i;
  }
  processStylesFromGridOptions() {
    var e;
    return ((e = this.beans.rowStyleSvc) == null ? void 0 : e.processStylesFromGridOptions(this.rowNode)) ?? this.emptyStyle;
  }
  onRowSelected(e) {
    var t;
    (t = this.beans.selectionSvc) == null || t.onRowCtrlSelected(
      this,
      (o) => {
        (o === this.centerGui || o === this.fullWidthGui) && this.announceDescription();
      },
      e
    );
  }
  announceDescription() {
    var e;
    (e = this.beans.selectionSvc) == null || e.announceAriaRowSelection(this.rowNode);
  }
  addHoverFunctionality(e) {
    if (!this.active)
      return;
    const { element: t, compBean: o } = e, { rowNode: n, beans: s, gos: i } = this;
    o.addManagedListeners(t, {
      // We use pointer events here instead of mouse events, as pointer events
      // are more reliable for hover detection, especially with touch devices
      // or hybrid touch + mouse devices.
      pointerenter: (r) => {
        r.pointerType === "mouse" && n.dispatchRowEvent("mouseEnter");
      },
      pointerleave: (r) => {
        r.pointerType === "mouse" && n.dispatchRowEvent("mouseLeave");
      }
    }), o.addManagedListeners(n, {
      mouseEnter: () => {
        var r;
        !((r = s.dragSvc) != null && r.dragging) && !i.get("suppressRowHoverHighlight") && (t.classList.add("ag-row-hover"), n.setHovered(!0));
      },
      mouseLeave: () => {
        this.resetHoveredStatus(t);
      }
    });
  }
  resetHoveredStatus(e) {
    const t = e ? [e] : this.allRowGuis.map((o) => o.element);
    for (const o of t)
      o.classList.remove("ag-row-hover");
    this.rowNode.setHovered(!1);
  }
  // for animation, we don't want to animate entry or exit to a very far away pixel,
  // otherwise the row would move so fast, it would appear to disappear. so this method
  // moves the row closer to the viewport if it is far away, so the row slide in / out
  // at a speed the user can see.
  roundRowTopToBounds(e) {
    const t = this.beans.ctrlsSvc.getScrollFeature().getApproximateVScollPosition(), o = this.applyPaginationOffset(t.top, !0) - 100, n = this.applyPaginationOffset(t.bottom, !0) + 100;
    return Math.min(Math.max(o, e), n);
  }
  forEachGui(e, t) {
    e ? t(e) : this.allRowGuis.forEach(t);
  }
  isRowRendered() {
    return this.allRowGuis.length > 0;
  }
  onRowHeightChanged(e) {
    if (this.rowNode.rowHeight == null)
      return;
    const t = this.rowNode.rowHeight, o = this.beans.environment.getDefaultRowHeight(), s = xw(this.gos) ? Dn(this.beans, this.rowNode).height : void 0, i = s ? `${Math.min(o, s) - 2}px` : void 0;
    this.forEachGui(e, (r) => {
      r.element.style.height = `${t}px`, i && r.element.style.setProperty("--ag-line-height", i);
    });
  }
  // note - this is NOT called by context, as we don't wire / unwire the CellComp for performance reasons.
  destroyFirstPass(e = !1) {
    var n;
    this.active = !1;
    const { rowNode: t } = this;
    if (!e && Ei(this.gos) && !t.sticky)
      if (t.rowTop != null) {
        const i = this.roundRowTopToBounds(t.rowTop);
        this.setRowTop(i);
      } else
        this.allRowGuis.forEach((i) => i.rowComp.toggleCss("ag-opacity-zero", !0));
    (n = this.fullWidthGui) != null && n.element.contains(Ue(this.beans)) && this.beans.focusSvc.attemptToRecoverFocus(), t.setHovered(!1);
    const o = this.createRowEvent("virtualRowRemoved");
    this.dispatchLocalEvent(o), this.beans.eventSvc.dispatchEvent(o), super.destroy();
  }
  destroySecondPass() {
    this.allRowGuis.length = 0;
    const e = (t) => (t.list.forEach((o) => o.destroy()), { list: [], map: {} });
    this.centerCellCtrls = e(this.centerCellCtrls), this.leftCellCtrls = e(this.leftCellCtrls), this.rightCellCtrls = e(this.rightCellCtrls);
  }
  setFocusedClasses(e) {
    this.forEachGui(e, (t) => {
      t.rowComp.toggleCss("ag-row-focus", this.rowFocused), t.rowComp.toggleCss("ag-row-no-focus", !this.rowFocused);
    });
  }
  onCellFocusChanged() {
    const { focusSvc: e } = this.beans, t = e.isRowFocused(this.rowNode.rowIndex, this.rowNode.rowPinned);
    t !== this.rowFocused && (this.rowFocused = t, this.setFocusedClasses());
  }
  onPaginationChanged() {
    var t;
    const e = ((t = this.beans.pagination) == null ? void 0 : t.getCurrentPage()) ?? 0;
    this.paginationPage !== e && (this.paginationPage = e, this.onTopChanged()), this.refreshFirstAndLastRowStyles();
  }
  onTopChanged() {
    this.setRowTop(this.rowNode.rowTop);
  }
  onPaginationPixelOffsetChanged() {
    this.onTopChanged();
  }
  // applies pagination offset, eg if on second page, and page height is 500px, then removes
  // 500px from the top position, so a row with rowTop 600px is displayed at location 100px.
  // reverse will take the offset away rather than add.
  applyPaginationOffset(e, t = !1) {
    if (this.rowNode.isRowPinned() || this.rowNode.sticky)
      return e;
    const o = this.beans.pageBounds.getPixelOffset();
    return e + o * (t ? 1 : -1);
  }
  setRowTop(e) {
    if (!this.printLayout && ue(e)) {
      const t = this.applyPaginationOffset(e), s = `${this.rowNode.isRowPinned() || this.rowNode.sticky ? t : this.beans.rowContainerHeight.getRealPixelPosition(t)}px`;
      this.setRowTopStyle(s);
    }
  }
  // the top needs to be set into the DOM element when the element is created, not updated afterwards.
  // otherwise the transition would not work, as it would be transitioning from zero (the unset value).
  // for example, suppose a row that is outside the viewport, then user does a filter to remove other rows
  // and this row now appears in the viewport, and the row moves up (ie it was under the viewport and not rendered,
  // but now is in the viewport) then a new RowComp is created, however it should have it's position initialised
  // to below the viewport, so the row will appear to animate up. if we didn't set the initial position at creation
  // time, the row would animate down (ie from position zero).
  getInitialRowTop(e) {
    return this.suppressRowTransform ? this.getInitialRowTopShared(e) : void 0;
  }
  getInitialTransform(e) {
    return this.suppressRowTransform ? void 0 : `translateY(${this.getInitialRowTopShared(e)})`;
  }
  getInitialRowTopShared(e) {
    if (this.printLayout)
      return "";
    const t = this.rowNode;
    let o;
    if (t.sticky)
      o = t.stickyRowTop;
    else {
      const n = this.slideInAnimation[e] ? this.roundRowTopToBounds(t.oldRowTop) : t.rowTop, s = this.applyPaginationOffset(n);
      o = t.isRowPinned() ? s : this.beans.rowContainerHeight.getRealPixelPosition(s);
    }
    return o + "px";
  }
  setRowTopStyle(e) {
    this.allRowGuis.forEach(
      (t) => this.suppressRowTransform ? t.rowComp.setTop(e) : t.rowComp.setTransform(`translateY(${e})`)
    );
  }
  getCellCtrl(e, t = !1) {
    let o = null;
    return this.getAllCellCtrls().forEach((n) => {
      n.column == e && (o = n);
    }), o != null || t || this.getAllCellCtrls().forEach((n) => {
      (n == null ? void 0 : n.getColSpanningList().indexOf(e)) >= 0 && (o = n);
    }), o;
  }
  onRowIndexChanged() {
    this.rowNode.rowIndex != null && (this.onCellFocusChanged(), this.updateRowIndexes(), this.postProcessCss());
  }
  updateRowIndexes(e) {
    var i, r;
    const t = this.rowNode.getRowIndexString();
    if (t === null)
      return;
    const o = (((i = this.beans.ctrlsSvc.getHeaderRowContainerCtrl()) == null ? void 0 : i.getRowCount()) ?? 0) + (((r = this.beans.filterManager) == null ? void 0 : r.getHeaderRowCount()) ?? 0), n = this.rowNode.rowIndex % 2 === 0, s = o + this.rowNode.rowIndex + 1;
    this.forEachGui(e, (l) => {
      l.rowComp.setRowIndex(t), l.rowComp.toggleCss("ag-row-even", n), l.rowComp.toggleCss("ag-row-odd", !n), Gr(l.element, s);
    });
  }
}, ZGe = class extends K {
  constructor() {
    super(), this.beanName = "navigation", this.onPageDown = yd(this.onPageDown, 100), this.onPageUp = yd(this.onPageUp, 100);
  }
  postConstruct() {
    this.beans.ctrlsSvc.whenReady(this, (e) => {
      this.gridBodyCon = e.gridBodyCtrl;
    });
  }
  handlePageScrollingKey(e, t = !1) {
    const o = e.key, n = e.altKey, s = e.ctrlKey || e.metaKey, i = !!this.beans.rangeSvc && e.shiftKey, r = zHe(this.gos, e);
    let l = !1;
    switch (o) {
      case D.PAGE_HOME:
      case D.PAGE_END:
        !s && !n && (this.onHomeOrEndKey(o), l = !0);
        break;
      case D.LEFT:
      case D.RIGHT:
      case D.UP:
      case D.DOWN:
        if (!r)
          return !1;
        s && !n && !i && (this.onCtrlUpDownLeftRight(o, r), l = !0);
        break;
      case D.PAGE_DOWN:
      case D.PAGE_UP:
        !s && !n && (l = this.handlePageUpDown(o, r, t));
        break;
    }
    return l && e.preventDefault(), l;
  }
  handlePageUpDown(e, t, o) {
    return o && (t = this.beans.focusSvc.getFocusedCell()), t ? (e === D.PAGE_UP ? this.onPageUp(t) : this.onPageDown(t), !0) : !1;
  }
  navigateTo({
    scrollIndex: e,
    scrollType: t,
    scrollColumn: o,
    focusIndex: n,
    focusColumn: s,
    isAsync: i,
    rowPinned: r
  }) {
    const { scrollFeature: l } = this.gridBodyCon;
    ue(o) && !o.isPinned() && l.ensureColumnVisible(o), ue(e) && l.ensureIndexVisible(e, t), i || l.ensureIndexVisible(n);
    const { focusSvc: a, rangeSvc: c } = this.beans;
    a.setFocusedCell({
      rowIndex: n,
      column: s,
      rowPinned: r,
      forceBrowserFocus: !0
    }), c == null || c.setRangeToCell({ rowIndex: n, rowPinned: r, column: s });
  }
  // this method is throttled, see the `constructor`
  onPageDown(e) {
    const t = this.beans, o = w0(t), n = this.getViewportHeight(), { pageBounds: s, rowModel: i, rowAutoHeight: r } = t, l = s.getPixelOffset(), a = o.top + n, c = i.getRowIndexAtPixel(a + l);
    r != null && r.active ? this.navigateToNextPageWithAutoHeight(e, c) : this.navigateToNextPage(e, c);
  }
  // this method is throttled, see the `constructor`
  onPageUp(e) {
    const t = this.beans, o = w0(t), { pageBounds: n, rowModel: s, rowAutoHeight: i } = t, r = n.getPixelOffset(), l = o.top, a = s.getRowIndexAtPixel(l + r);
    i != null && i.active ? this.navigateToNextPageWithAutoHeight(e, a, !0) : this.navigateToNextPage(e, a, !0);
  }
  navigateToNextPage(e, t, o = !1) {
    const { pageBounds: n, rowModel: s } = this.beans, i = this.getViewportHeight(), r = n.getFirstRow(), l = n.getLastRow(), a = n.getPixelOffset(), c = s.getRow(e.rowIndex), d = o ? (
      // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
      (c == null ? void 0 : c.rowHeight) - i - a
    ) : i - a, u = (c == null ? void 0 : c.rowTop) + d;
    let h = s.getRowIndexAtPixel(u + a);
    if (h === e.rowIndex) {
      const C = o ? -1 : 1;
      t = h = e.rowIndex + C;
    }
    let p;
    o ? (p = "bottom", h < r && (h = r), t < r && (t = r)) : (p = "top", h > l && (h = l), t > l && (t = l)), this.isRowTallerThanView(s.getRow(h)) && (t = h, p = "top"), this.navigateTo({
      scrollIndex: t,
      scrollType: p,
      scrollColumn: null,
      focusIndex: h,
      focusColumn: e.column
    });
  }
  navigateToNextPageWithAutoHeight(e, t, o = !1) {
    this.navigateTo({
      scrollIndex: t,
      scrollType: o ? "bottom" : "top",
      scrollColumn: null,
      focusIndex: t,
      focusColumn: e.column
    }), setTimeout(() => {
      const n = this.getNextFocusIndexForAutoHeight(e, o);
      this.navigateTo({
        scrollIndex: t,
        scrollType: o ? "bottom" : "top",
        scrollColumn: null,
        focusIndex: n,
        focusColumn: e.column,
        isAsync: !0
      });
    }, 50);
  }
  getNextFocusIndexForAutoHeight(e, t = !1) {
    const o = t ? -1 : 1, n = this.getViewportHeight(), { pageBounds: s, rowModel: i } = this.beans, r = s.getLastRow();
    let l = 0, a = e.rowIndex;
    for (; a >= 0 && a <= r; ) {
      const c = i.getRow(a);
      if (c) {
        const d = c.rowHeight ?? 0;
        if (l + d > n)
          break;
        l += d;
      }
      a += o;
    }
    return Math.max(0, Math.min(a, r));
  }
  getViewportHeight() {
    const e = this.beans, t = w0(e), o = this.beans.scrollVisibleSvc.getScrollbarWidth();
    let n = t.bottom - t.top;
    return e.ctrlsSvc.get("center").isHorizontalScrollShowing() && (n -= o), n;
  }
  isRowTallerThanView(e) {
    if (!e)
      return !1;
    const t = e.rowHeight;
    return typeof t != "number" ? !1 : t > this.getViewportHeight();
  }
  onCtrlUpDownLeftRight(e, t) {
    const o = this.beans.cellNavigation.getNextCellToFocus(e, t, !0), n = this.getNormalisedPosition(o), { rowIndex: s, rowPinned: i, column: r } = n ?? o, l = r;
    this.navigateTo({
      scrollIndex: s,
      scrollType: null,
      scrollColumn: l,
      focusIndex: s,
      focusColumn: l,
      rowPinned: i
    });
  }
  // home brings focus to top left cell, end brings focus to bottom right, grid scrolled to bring
  // same cell into view (which means either scroll all the way up, or all the way down).
  onHomeOrEndKey(e) {
    const t = e === D.PAGE_HOME, { visibleCols: o, pageBounds: n, rowModel: s } = this.beans, i = o.allCols, r = t ? n.getFirstRow() : n.getLastRow(), l = s.getRow(r);
    if (!l)
      return;
    const a = (t ? i : [...i].reverse()).find(
      (c) => !c.isSuppressNavigable(l)
    );
    a && this.navigateTo({
      scrollIndex: r,
      scrollType: null,
      scrollColumn: a,
      focusIndex: r,
      focusColumn: a
    });
  }
  // result of keyboard event
  onTabKeyDown(e, t) {
    const o = t.shiftKey, n = this.tabToNextCellCommon(e, o, t), s = this.beans, { ctrlsSvc: i, pageBounds: r, focusSvc: l, gos: a } = s;
    if (n !== !1) {
      n ? t.preventDefault() : n === null && i.get("gridCtrl").allowFocusForNextCoreContainer(o);
      return;
    }
    if (o) {
      const { rowIndex: c, rowPinned: d } = e.getRowPosition();
      (d ? c === 0 : c === r.getFirstRow()) && (a.get("headerHeight") === 0 || $s(s) ? fn(s, !0, !0) : (t.preventDefault(), l.focusPreviousFromFirstCell(t)));
    } else
      e instanceof Ii && e.focusCell(!0), (!o && l.focusOverlay(!1) || fn(s, o)) && t.preventDefault();
  }
  // comes from API
  tabToNextCell(e, t) {
    const o = this.beans, { focusSvc: n, rowRenderer: s } = o, i = n.getFocusedCell();
    if (!i)
      return !1;
    let r = yi(o, i);
    return !r && (r = s.getRowByPosition(i), !r || !r.isFullWidth()) ? !1 : !!this.tabToNextCellCommon(r, e, t, "api");
  }
  tabToNextCellCommon(e, t, o, n = "ui") {
    var a;
    const { editSvc: s, focusSvc: i } = this.beans;
    let r;
    const l = e instanceof Ii ? e : (a = e.getAllCellCtrls()) == null ? void 0 : a[0];
    return s != null && s.isEditing() ? r = s == null ? void 0 : s.moveToNextCell(l, t, o, n) : r = this.moveToNextCellNotEditing(e, t, o), r === null ? r : r || !!i.focusedHeader;
  }
  // returns null if no navigation should be performed
  moveToNextCellNotEditing(e, t, o) {
    const n = this.beans.visibleCols.allCols;
    let s;
    if (e instanceof Vl) {
      if (s = {
        ...e.getRowPosition(),
        column: t ? n[0] : Ke(n)
      }, this.gos.get("embedFullWidthRows") && o) {
        const r = e.findFullWidthInfoForEvent(o);
        r && (s.column = r.column);
      }
    } else
      s = e.getFocusedCellPosition();
    const i = this.findNextCellToFocusOn(s, { backwards: t, startEditing: !1 });
    if (i === !1)
      return null;
    if (i instanceof Ii)
      i.focusCell(!0);
    else if (i)
      return this.tryToFocusFullWidthRow(i, t);
    return ue(i);
  }
  /**
   * called by the cell, when tab is pressed while editing.
   * @returns RenderedCell when navigation successful, false if navigation should not be performed, otherwise null
   */
  findNextCellToFocusOn(e, { backwards: t, startEditing: o, skipToNextEditableCell: n }) {
    let s = e;
    const i = this.beans, { cellNavigation: r, gos: l, focusSvc: a, rowRenderer: c, rangeSvc: d } = i;
    for (; ; ) {
      e !== s && (e = s), t || (s = this.getLastCellOfColSpan(s)), s = r.getNextTabbedCell(s, t);
      const u = l.getCallback("tabToNextCell");
      if (ue(u)) {
        const m = u({
          backwards: t,
          editing: o,
          previousCellPosition: e,
          nextCellPosition: s || null
        });
        if (m === !0)
          s = e;
        else {
          if (m === !1)
            return !1;
          s = {
            rowIndex: m.rowIndex,
            column: m.column,
            rowPinned: m.rowPinned
          };
        }
      }
      if (!s)
        return null;
      if (s.rowIndex < 0) {
        const C = nn(i);
        return a.focusHeaderPosition({
          headerPosition: {
            headerRowIndex: C + s.rowIndex,
            column: s.column
          },
          fromCell: !0
        }), null;
      }
      const h = l.get("editType") === "fullRow";
      if (o && (!h || n) && !this.isCellEditable(s))
        continue;
      this.ensureCellVisible(s);
      const p = yi(i, s);
      if (!p) {
        const C = c.getRowByPosition(s);
        if (!C || !C.isFullWidth() || o)
          continue;
        return { ...C.getRowPosition(), column: s == null ? void 0 : s.column };
      }
      if (!r.isSuppressNavigable(p.column, p.rowNode))
        return p.setFocusedCellPosition(s), d == null || d.setRangeToCell(s), p;
    }
  }
  isCellEditable(e) {
    const t = this.lookupRowNodeForCell(e);
    return t ? e.column.isCellEditable(t) : !1;
  }
  lookupRowNodeForCell({ rowIndex: e, rowPinned: t }) {
    const { pinnedRowModel: o, rowModel: n } = this.beans;
    return t === "top" ? o == null ? void 0 : o.getPinnedTopRow(e) : t === "bottom" ? o == null ? void 0 : o.getPinnedBottomRow(e) : n.getRow(e);
  }
  // we use index for rows, but column object for columns, as the next column (by index) might not
  // be visible (header grouping) so it's not reliable, so using the column object instead.
  navigateToNextCell(e, t, o, n) {
    let s = o, i = !1;
    const r = this.beans, { cellNavigation: l, focusSvc: a, gos: c } = r;
    for (; s && (s === o || !this.isValidNavigateCell(s)); )
      c.get("enableRtl") ? t === D.LEFT && (s = this.getLastCellOfColSpan(s)) : t === D.RIGHT && (s = this.getLastCellOfColSpan(s)), s = l.getNextCellToFocus(t, s), i = Xe(s);
    if (i && e && e.key === D.UP && (s = {
      rowIndex: -1,
      rowPinned: null,
      column: o.column
    }), n) {
      const u = c.getCallback("navigateToNextCell");
      if (ue(u)) {
        const p = u({
          key: t,
          previousCellPosition: o,
          nextCellPosition: s || null,
          event: e
        });
        ue(p) ? s = {
          rowPinned: p.rowPinned,
          rowIndex: p.rowIndex,
          column: p.column
        } : s = null;
      }
    }
    if (!s)
      return;
    if (s.rowIndex < 0) {
      const u = nn(r);
      a.focusHeaderPosition({
        headerPosition: { headerRowIndex: u + s.rowIndex, column: o.column },
        event: e || void 0,
        fromCell: !0
      });
      return;
    }
    const d = this.getNormalisedPosition(s);
    d ? this.focusPosition(d) : this.tryToFocusFullWidthRow(s);
  }
  getNormalisedPosition(e) {
    var n;
    if (!!((n = this.beans.spannedRowRenderer) != null && n.getCellByPosition(e)))
      return e;
    this.ensureCellVisible(e);
    const o = yi(this.beans, e);
    return o ? (e = o.getFocusedCellPosition(), this.ensureCellVisible(e), e) : null;
  }
  tryToFocusFullWidthRow(e, t) {
    const { visibleCols: o, rowRenderer: n, focusSvc: s, eventSvc: i } = this.beans, r = o.allCols, l = n.getRowByPosition(e);
    if (!l || !l.isFullWidth())
      return !1;
    const a = s.getFocusedCell(), c = {
      rowIndex: e.rowIndex,
      rowPinned: e.rowPinned,
      column: e.column || (t ? Ke(r) : r[0])
    };
    this.focusPosition(c);
    const d = t ?? (a != null && POe(c, a));
    return i.dispatchEvent({
      type: "fullWidthRowFocused",
      rowIndex: c.rowIndex,
      rowPinned: c.rowPinned,
      column: c.column,
      isFullWidthCell: !0,
      fromBelow: d
    }), !0;
  }
  focusPosition(e) {
    const { focusSvc: t, rangeSvc: o } = this.beans;
    t.setFocusedCell({
      rowIndex: e.rowIndex,
      column: e.column,
      rowPinned: e.rowPinned,
      forceBrowserFocus: !0
    }), o == null || o.setRangeToCell(e);
  }
  isValidNavigateCell(e) {
    return !!vn(this.beans, e);
  }
  getLastCellOfColSpan(e) {
    const t = yi(this.beans, e);
    if (!t)
      return e;
    const o = t.getColSpanningList();
    return o.length === 1 ? e : {
      rowIndex: e.rowIndex,
      column: Ke(o),
      rowPinned: e.rowPinned
    };
  }
  ensureCellVisible(e) {
    const t = ua(this.gos), o = this.beans.rowModel.getRow(e.rowIndex), n = t && (o == null ? void 0 : o.sticky), { scrollFeature: s } = this.gridBodyCon;
    !n && Xe(e.rowPinned) && s.ensureIndexVisible(e.rowIndex), e.column.isPinned() || s.ensureColumnVisible(e.column);
  }
  ensureColumnVisible(e) {
    const t = this.gridBodyCon.scrollFeature;
    e.isPinned() || t.ensureColumnVisible(e);
  }
  ensureRowVisible(e) {
    this.gridBodyCon.scrollFeature.ensureIndexVisible(e);
  }
};
function w0(e) {
  return e.ctrlsSvc.getScrollFeature().getVScrollPosition();
}
var GGe = {
  moduleName: "KeyboardNavigation",
  version: be,
  beans: [ZGe, dGe, _Ze],
  apiFunctions: {
    getFocusedCell: uGe,
    clearFocusedCell: hGe,
    setFocusedCell: gGe,
    setFocusedHeader: vGe,
    tabToNextCell: pGe,
    tabToPreviousCell: fGe
  }
}, NGe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "pageBoundsListener";
  }
  postConstruct() {
    this.addManagedEventListeners({
      modelUpdated: this.onModelUpdated.bind(this),
      recalculateRowBounds: this.calculatePages.bind(this)
    }), this.onModelUpdated();
  }
  onModelUpdated(e) {
    this.calculatePages(), this.eventSvc.dispatchEvent({
      type: "paginationChanged",
      animate: (e == null ? void 0 : e.animate) ?? !1,
      newData: (e == null ? void 0 : e.newData) ?? !1,
      newPage: (e == null ? void 0 : e.newPage) ?? !1,
      newPageSize: (e == null ? void 0 : e.newPageSize) ?? !1,
      keepRenderedRows: (e == null ? void 0 : e.keepRenderedRows) ?? !1
    });
  }
  calculatePages() {
    const { pageBounds: e, pagination: t, rowModel: o } = this.beans;
    t ? t.calculatePages() : e.calculateBounds(0, o.getRowCount() - 1);
  }
}, zGe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "pageBounds", this.pixelOffset = 0;
  }
  getFirstRow() {
    var e;
    return ((e = this.topRowBounds) == null ? void 0 : e.rowIndex) ?? -1;
  }
  getLastRow() {
    var e;
    return ((e = this.bottomRowBounds) == null ? void 0 : e.rowIndex) ?? -1;
  }
  getCurrentPageHeight() {
    const { topRowBounds: e, bottomRowBounds: t } = this;
    return !e || !t ? 0 : Math.max(t.rowTop + t.rowHeight - e.rowTop, 0);
  }
  getCurrentPagePixelRange() {
    const { topRowBounds: e, bottomRowBounds: t } = this, o = (e == null ? void 0 : e.rowTop) ?? 0, n = t ? t.rowTop + t.rowHeight : 0;
    return { pageFirstPixel: o, pageLastPixel: n };
  }
  calculateBounds(e, t) {
    const { rowModel: o } = this.beans, n = o.getRowBounds(e);
    n && (n.rowIndex = e), this.topRowBounds = n;
    const s = o.getRowBounds(t);
    s && (s.rowIndex = t), this.bottomRowBounds = s, this.calculatePixelOffset();
  }
  getPixelOffset() {
    return this.pixelOffset;
  }
  calculatePixelOffset() {
    var t;
    const e = ((t = this.topRowBounds) == null ? void 0 : t.rowTop) ?? 0;
    this.pixelOffset !== e && (this.pixelOffset = e, this.eventSvc.dispatchEvent({ type: "paginationPixelOffsetChanged" }));
  }
}, jGe = (
  /*css*/
  ".ag-pinned-left-floating-bottom,.ag-pinned-left-floating-top,.ag-pinned-right-floating-bottom,.ag-pinned-right-floating-top{min-width:0;overflow:hidden;position:relative}.ag-pinned-left-sticky-top,.ag-pinned-right-sticky-top{height:100%;overflow:hidden;position:relative}.ag-sticky-bottom-full-width-container,.ag-sticky-top-full-width-container{height:100%;overflow:hidden;width:100%}.ag-pinned-left-header,.ag-pinned-right-header{display:inline-block;height:100%;overflow:hidden;position:relative}.ag-body-horizontal-scroll:not(.ag-scrollbar-invisible){.ag-horizontal-left-spacer:not(.ag-scroller-corner){border-right:var(--ag-pinned-column-border)}.ag-horizontal-right-spacer:not(.ag-scroller-corner){border-left:var(--ag-pinned-column-border)}}.ag-pinned-right-header{border-left:var(--ag-pinned-column-border)}.ag-pinned-left-header{border-right:var(--ag-pinned-column-border)}.ag-cell.ag-cell-first-right-pinned:not(.ag-cell-range-left,.ag-cell-range-single-cell,.ag-cell-focus:not(.ag-cell-range-selected):focus-within){border-left:var(--ag-pinned-column-border)}.ag-cell.ag-cell-last-left-pinned:not(.ag-cell-range-right,.ag-cell-range-single-cell,.ag-cell-focus:not(.ag-cell-range-selected):focus-within){border-right:var(--ag-pinned-column-border)}.ag-pinned-left-header .ag-header-cell-resize:after{left:calc(50% - var(--ag-header-column-resize-handle-width))}.ag-pinned-right-header .ag-header-cell-resize:after{left:50%}.ag-pinned-left-header .ag-header-cell-resize{right:-3px}.ag-pinned-right-header .ag-header-cell-resize{left:-3px}"
), WGe = class extends K {
  constructor(e, t) {
    super(), this.isLeft = e, this.elements = t, this.getWidth = e ? () => this.beans.pinnedCols.leftWidth : () => this.beans.pinnedCols.rightWidth;
  }
  postConstruct() {
    this.addManagedEventListeners({
      [`${this.isLeft ? "left" : "right"}PinnedWidthChanged`]: this.onPinnedWidthChanged.bind(this)
    });
  }
  onPinnedWidthChanged() {
    const e = this.getWidth(), t = e > 0;
    for (const o of this.elements)
      o && (He(o, t), rn(o, e));
  }
}, UGe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "pinnedCols";
  }
  postConstruct() {
    this.beans.ctrlsSvc.whenReady(this, (t) => {
      this.gridBodyCtrl = t.gridBodyCtrl;
    });
    const e = this.checkContainerWidths.bind(this);
    this.addManagedEventListeners({
      displayedColumnsChanged: e,
      displayedColumnsWidthChanged: e
    }), this.addManagedPropertyListener("domLayout", e);
  }
  checkContainerWidths() {
    const { gos: e, visibleCols: t, eventSvc: o } = this.beans, n = jt(e, "print"), s = n ? 0 : t.getColsLeftWidth(), i = n ? 0 : t.getDisplayedColumnsRightWidth();
    s != this.leftWidth && (this.leftWidth = s, o.dispatchEvent({ type: "leftPinnedWidthChanged" })), i != this.rightWidth && (this.rightWidth = i, o.dispatchEvent({ type: "rightPinnedWidthChanged" }));
  }
  keepPinnedColumnsNarrowerThanViewport() {
    const e = this.gridBodyCtrl.eBodyViewport, t = Bi(e);
    if (t <= 50)
      return;
    const o = this.getPinnedColumnsOverflowingViewport(t - 50), n = this.gos.getCallback("processUnpinnedColumns"), { columns: s, hasLockedPinned: i } = o;
    let r = s;
    !r.length && !i || (n && (r = n({
      columns: r,
      viewportWidth: t
    })), !(!r || !r.length) && (r = r.filter((l) => !ns(l)), this.setColsPinned(r, null, "viewportSizeFeature")));
  }
  createPinnedWidthFeature(e, ...t) {
    return new WGe(e, t);
  }
  setColsPinned(e, t, o) {
    const { colModel: n, colAnimation: s, visibleCols: i, gos: r } = this.beans;
    if (!n.cols || !(e != null && e.length))
      return;
    if (jt(r, "print")) {
      X(37);
      return;
    }
    s == null || s.start();
    let l;
    t === !0 || t === "left" ? l = "left" : t === "right" ? l = "right" : l = null;
    const a = [];
    e.forEach((c) => {
      if (!c)
        return;
      const d = n.getCol(c);
      d && d.getPinned() !== l && (this.setColPinned(d, l), a.push(d));
    }), a.length && (i.refresh(o), Gw(this.eventSvc, a, o)), s == null || s.finish();
  }
  initCol(e) {
    const { pinned: t, initialPinned: o } = e.colDef;
    t !== void 0 ? this.setColPinned(e, t) : this.setColPinned(e, o);
  }
  setColPinned(e, t) {
    t === !0 || t === "left" ? e.pinned = "left" : t === "right" ? e.pinned = "right" : e.pinned = null, e.dispatchStateUpdatedEvent("pinned");
  }
  setupHeaderPinnedWidth(e) {
    const { scrollVisibleSvc: t } = this.beans;
    if (e.pinned == null)
      return;
    const o = e.pinned === "left", n = e.pinned === "right";
    e.hidden = !0;
    const s = () => {
      const i = o ? this.leftWidth : this.rightWidth;
      if (i == null)
        return;
      const r = i == 0, l = e.hidden !== r, a = this.gos.get("enableRtl"), c = t.getScrollbarWidth(), u = t.verticalScrollShowing && (a && o || !a && n) ? i + c : i;
      e.comp.setPinnedContainerWidth(`${u}px`), e.comp.setDisplayed(!r), l && (e.hidden = r, e.refresh());
    };
    e.addManagedEventListeners({
      leftPinnedWidthChanged: s,
      rightPinnedWidthChanged: s,
      scrollVisibilityChanged: s,
      scrollbarWidthChanged: s
    });
  }
  getHeaderResizeDiff(e, t) {
    if (t.getPinned()) {
      const { leftWidth: n, rightWidth: s } = this, i = Bi(this.beans.ctrlsSvc.getGridBodyCtrl().eBodyViewport) - 50;
      if (n + s + e > i)
        if (i > n + s)
          e = i - n - s;
        else
          return 0;
    }
    return e;
  }
  getPinnedColumnsOverflowingViewport(e) {
    const t = this.rightWidth ?? 0, o = this.leftWidth ?? 0, n = t + o;
    let s = !1;
    if (n < e)
      return { columns: [], hasLockedPinned: s };
    const { visibleCols: i } = this.beans, r = [...i.leftCols], l = [...i.rightCols];
    let a = 0, c = 0;
    const d = 0, u = [];
    let h = n - d - e;
    for (; (c < r.length || a < l.length) && h > 0; ) {
      if (a < l.length) {
        const p = l[a++];
        if (p.colDef.lockPinned) {
          s = !0;
          continue;
        }
        h -= p.getActualWidth(), u.push(p);
      }
      if (c < r.length && h > 0) {
        const p = r[c++];
        if (p.colDef.lockPinned) {
          s = !0;
          continue;
        }
        h -= p.getActualWidth(), u.push(p);
      }
    }
    return { columns: u, hasLockedPinned: s };
  }
}, KGe = {
  moduleName: "PinnedColumn",
  version: be,
  beans: [UGe],
  css: [jGe]
}, qGe = class extends K {
  constructor() {
    super(), this.beanName = "ariaAnnounce", this.descriptionContainer = null, this.pendingAnnouncements = /* @__PURE__ */ new Map(), this.lastAnnouncement = "", this.updateAnnouncement = Rt(this, this.updateAnnouncement.bind(this), 200);
  }
  postConstruct() {
    const e = this.beans, t = Pt(e), o = this.descriptionContainer = t.createElement("div");
    o.classList.add("ag-aria-description-container"), ew(o, "polite"), ZTe(o, "additions text"), $Te(o, !0), e.eGridDiv.appendChild(o);
  }
  /**
   * @param key used for debouncing calls
   */
  announceValue(e, t) {
    this.pendingAnnouncements.set(t, e), this.updateAnnouncement();
  }
  updateAnnouncement() {
    if (!this.descriptionContainer)
      return;
    const e = Array.from(this.pendingAnnouncements.values()).join(". ");
    this.pendingAnnouncements.clear(), this.descriptionContainer.textContent = "", setTimeout(() => {
      this.handleAnnouncementUpdate(e);
    }, 50);
  }
  handleAnnouncementUpdate(e) {
    if (!this.isAlive() || !this.descriptionContainer)
      return;
    let t = e;
    if (t == null || t.replace(/[ .]/g, "") == "") {
      this.lastAnnouncement = "";
      return;
    }
    this.lastAnnouncement === t && (t = `${t}​`), this.lastAnnouncement = t, this.descriptionContainer.textContent = t;
  }
  destroy() {
    var t;
    super.destroy();
    const { descriptionContainer: e } = this;
    e && (it(e), (t = e.parentElement) == null || t.removeChild(e)), this.descriptionContainer = null, this.pendingAnnouncements.clear();
  }
}, YGe = {
  moduleName: "Aria",
  version: be,
  beans: [qGe]
}, QGe = (
  /*css*/
  ":where(.ag-delay-render){.ag-cell,.ag-header-cell,.ag-header-group-cell,.ag-row,.ag-spanned-cell-wrapper{visibility:hidden}}"
), bu = "ag-delay-render", JGe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "colDelayRenderSvc", this.hideRequested = !1, this.alreadyRevealed = !1, this.timesRetried = 0, this.requesters = /* @__PURE__ */ new Set();
  }
  hideColumns(e) {
    this.alreadyRevealed || this.requesters.has(e) || (this.requesters.add(e), this.hideRequested || (this.beans.ctrlsSvc.whenReady(this, (t) => {
      t.gridBodyCtrl.eGridBody.classList.add(bu);
    }), this.hideRequested = !0));
  }
  revealColumns(e) {
    if (this.alreadyRevealed || !this.isAlive() || (this.requesters.delete(e), this.requesters.size > 0))
      return;
    const { renderStatus: t, ctrlsSvc: o } = this.beans;
    if (t) {
      if (!t.areHeaderCellsRendered() && this.timesRetried < 5) {
        this.timesRetried++, setTimeout(() => this.revealColumns(e));
        return;
      }
      this.timesRetried = 0;
    }
    o.getGridBodyCtrl().eGridBody.classList.remove(bu), this.alreadyRevealed = !0;
  }
}, XGe = {
  moduleName: "ColumnDelayRender",
  version: be,
  beans: [JGe],
  css: [QGe]
};
function eNe(e) {
  var t;
  (t = e.overlays) == null || t.showLoadingOverlay();
}
function tNe(e) {
  var t;
  (t = e.overlays) == null || t.showNoRowsOverlay();
}
function oNe(e) {
  var t;
  (t = e.overlays) == null || t.hideOverlay();
}
var nNe = (
  /*css*/
  ".ag-overlay{inset:0;pointer-events:none;position:absolute;z-index:2}.ag-overlay-panel,.ag-overlay-wrapper{display:flex;height:100%;width:100%}.ag-overlay-wrapper{align-items:center;flex:none;justify-content:center;text-align:center}.ag-overlay-loading-wrapper{pointer-events:all}.ag-overlay-loading-center{background:var(--ag-background-color);border:solid var(--ag-border-width) var(--ag-border-color);border-radius:var(--ag-border-radius);box-shadow:var(--ag-popup-shadow);padding:var(--ag-spacing)}"
), sNe = {
  tag: "div",
  cls: "ag-overlay",
  role: "presentation",
  children: [
    {
      tag: "div",
      cls: "ag-overlay-panel",
      role: "presentation",
      children: [{ tag: "div", ref: "eOverlayWrapper", cls: "ag-overlay-wrapper", role: "presentation" }]
    }
  ]
}, Sy = class extends Re {
  constructor() {
    super(sNe), this.eOverlayWrapper = J, this.activePromise = null, this.activeOverlay = null, this.updateListenerDestroyFunc = null, this.activeCssClass = null, this.elToFocusAfter = null, this.registerCSS(nNe);
  }
  handleKeyDown(e) {
    if (e.key !== D.TAB || e.defaultPrevented || wo(e))
      return;
    const t = this.beans;
    if (Yt(t, this.eOverlayWrapper, !1, e.shiftKey))
      return;
    let n = !1;
    e.shiftKey ? n = t.focusSvc.focusGridView({
      column: Ke(t.visibleCols.allCols),
      backwards: !0,
      canFocusOverlay: !1
    }) : n = fn(t, !1), n && e.preventDefault();
  }
  updateLayoutClasses(e, t) {
    const o = this.eOverlayWrapper.classList, { AUTO_HEIGHT: n, NORMAL: s, PRINT: i } = Ho;
    o.toggle(n, t.autoHeight), o.toggle(s, t.normal), o.toggle(i, t.print);
  }
  postConstruct() {
    this.createManagedBean(new j2(this)), this.setDisplayed(!1, { skipAriaHidden: !0 }), this.beans.overlays.setOverlayWrapperComp(this), this.addManagedElementListeners(this.getFocusableElement(), { keydown: this.handleKeyDown.bind(this) });
  }
  setWrapperTypeClass(e) {
    const t = this.eOverlayWrapper.classList;
    this.activeCssClass && t.toggle(this.activeCssClass, !1), this.activeCssClass = e, t.toggle(e, !0);
  }
  showOverlay(e, t, o, n) {
    if (this.setWrapperTypeClass(t), this.destroyActiveOverlay(), this.elToFocusAfter = null, this.activePromise = e, !!e) {
      if (this.setDisplayed(!0, { skipAriaHidden: !0 }), o && this.isGridFocused()) {
        const s = Ue(this.beans);
        s && !Oi(this.beans) && (this.elToFocusAfter = s);
      }
      e.then((s) => {
        if (this.activePromise !== e) {
          this.activeOverlay !== s && (this.destroyBean(s), s = null);
          return;
        }
        if (this.activePromise = null, !!s) {
          if (this.activeOverlay !== s && (this.eOverlayWrapper.appendChild(s.getGui()), this.activeOverlay = s, n)) {
            const i = s;
            this.updateListenerDestroyFunc = this.addManagedPropertyListener(n, ({ currentValue: r }) => {
              var l;
              (l = i.refresh) == null || l.call(i, Pe(this.gos, { ...r ?? {} }));
            });
          }
          o && this.isGridFocused() && so(this.eOverlayWrapper);
        }
      });
    }
  }
  updateOverlayWrapperPaddingTop(e) {
    this.eOverlayWrapper.style.setProperty("padding-top", `${e}px`);
  }
  destroyActiveOverlay() {
    var n;
    this.activePromise = null;
    const e = this.activeOverlay;
    if (!e)
      return;
    let t = this.elToFocusAfter;
    this.activeOverlay = null, this.elToFocusAfter = null, t && !this.isGridFocused() && (t = null);
    const o = this.updateListenerDestroyFunc;
    o && (o(), this.updateListenerDestroyFunc = null), this.destroyBean(e), it(this.eOverlayWrapper), (n = t == null ? void 0 : t.focus) == null || n.call(t, { preventScroll: !0 });
  }
  hideOverlay() {
    this.destroyActiveOverlay(), this.setDisplayed(!1, { skipAriaHidden: !0 });
  }
  isGridFocused() {
    const e = Ue(this.beans);
    return !!e && this.beans.eGridDiv.contains(e);
  }
  destroy() {
    this.elToFocusAfter = null, this.destroyActiveOverlay(), this.beans.overlays.setOverlayWrapperComp(void 0), super.destroy();
  }
}, iNe = {
  selector: "AG-OVERLAY-WRAPPER",
  component: Sy
}, rNe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "overlays", this.state = 0, this.showInitialOverlay = !0, this.wrapperPadding = 0;
  }
  postConstruct() {
    this.isClientSide = dt(this.gos), this.isServerSide = !this.isClientSide && $n(this.gos);
    const e = () => this.updateOverlayVisibility();
    this.addManagedEventListeners({
      newColumnsLoaded: e,
      rowDataUpdated: e,
      gridSizeChanged: this.refreshWrapperPadding.bind(this),
      rowCountReady: () => {
        this.showInitialOverlay = !1, this.updateOverlayVisibility();
      }
    }), this.addManagedPropertyListener("loading", e);
  }
  setOverlayWrapperComp(e) {
    this.eWrapper = e, this.updateOverlayVisibility();
  }
  /** Returns true if the overlay is visible. */
  isVisible() {
    return this.state !== 0 && !!this.eWrapper;
  }
  /** Returns true if the overlay is visible and is exclusive (popup over the grid) */
  isExclusive() {
    return this.state === 1 && !!this.eWrapper;
  }
  showLoadingOverlay() {
    this.showInitialOverlay = !1;
    const e = this.gos, t = e.get("loading");
    !t && (t !== void 0 || e.get("suppressLoadingOverlay")) || this.doShowLoadingOverlay();
  }
  showNoRowsOverlay() {
    this.showInitialOverlay = !1;
    const e = this.gos;
    e.get("loading") || e.get("suppressNoRowsOverlay") || this.doShowNoRowsOverlay();
  }
  hideOverlay() {
    if (this.showInitialOverlay = !1, this.gos.get("loading")) {
      X(99);
      return;
    }
    this.doHideOverlay();
  }
  getOverlayWrapperSelector() {
    return iNe;
  }
  getOverlayWrapperCompClass() {
    return Sy;
  }
  updateOverlayVisibility() {
    if (!this.eWrapper) {
      this.state = 0;
      return;
    }
    const {
      state: e,
      isClientSide: t,
      isServerSide: o,
      beans: { gos: n, colModel: s, rowModel: i }
    } = this;
    let r = this.gos.get("loading");
    r !== void 0 && (this.showInitialOverlay = !1), this.showInitialOverlay && r === void 0 && !n.get("suppressLoadingOverlay") && (r = !n.get("columnDefs") || !s.ready || !n.get("rowData") && t), r ? e !== 1 && this.doShowLoadingOverlay() : (this.showInitialOverlay = !1, t && i.isEmpty() && !n.get("suppressNoRowsOverlay") ? e !== 2 && this.doShowNoRowsOverlay() : (e === 1 || !o && e !== 0) && this.doHideOverlay());
  }
  doShowLoadingOverlay() {
    this.eWrapper && (this.state = 1, this.showOverlay(
      kDe(this.beans.userCompFactory, Pe(this.gos, {})),
      "ag-overlay-loading-wrapper",
      "loadingOverlayComponentParams"
    ), this.updateExclusive());
  }
  doShowNoRowsOverlay() {
    this.eWrapper && (this.state = 2, this.showOverlay(
      HDe(this.beans.userCompFactory, Pe(this.gos, {})),
      "ag-overlay-no-rows-wrapper",
      "noRowsOverlayComponentParams"
    ), this.updateExclusive());
  }
  doHideOverlay() {
    this.eWrapper && (this.state = 0, this.eWrapper.hideOverlay(), this.updateExclusive());
  }
  showOverlay(e, t, o) {
    var s;
    const n = (e == null ? void 0 : e.newAgStackInstance()) ?? null;
    (s = this.eWrapper) == null || s.showOverlay(n, t, this.isExclusive(), o), this.refreshWrapperPadding();
  }
  updateExclusive() {
    const e = this.exclusive;
    this.exclusive = this.isExclusive(), this.exclusive !== e && this.eventSvc.dispatchEvent({
      type: "overlayExclusiveChanged"
    });
  }
  refreshWrapperPadding() {
    const e = this.eWrapper;
    if (!e)
      return;
    let t = 0;
    if (this.state === 2) {
      const o = this.beans.ctrlsSvc.get("gridHeaderCtrl");
      t = (o == null ? void 0 : o.headerHeight) || 0;
    } else this.wrapperPadding !== 0 && (t = 0);
    this.wrapperPadding !== t && (this.wrapperPadding = t, e.updateOverlayWrapperPaddingTop(t));
  }
}, lNe = {
  moduleName: "Overlay",
  version: be,
  userComponents: {
    agLoadingOverlay: CVe,
    agNoRowsOverlay: bVe
  },
  apiFunctions: {
    showLoadingOverlay: eNe,
    showNoRowsOverlay: tNe,
    hideOverlay: oNe
  },
  beans: [rNe]
}, aNe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "rowContainerHeight", this.scrollY = 0, this.uiBodyHeight = 0;
  }
  postConstruct() {
    this.addManagedEventListeners({ bodyHeightChanged: this.updateOffset.bind(this) }), this.maxDivHeight = $De(), cs(this.gos, "RowContainerHeightService - maxDivHeight = " + this.maxDivHeight);
  }
  updateOffset() {
    if (!this.stretching)
      return;
    const e = this.beans.ctrlsSvc.getScrollFeature().getVScrollPosition().top, t = this.getUiBodyHeight();
    (e !== this.scrollY || t !== this.uiBodyHeight) && (this.scrollY = e, this.uiBodyHeight = t, this.calculateOffset());
  }
  calculateOffset() {
    this.setUiContainerHeight(this.maxDivHeight), this.pixelsToShave = this.modelHeight - this.uiContainerHeight, this.maxScrollY = this.uiContainerHeight - this.uiBodyHeight;
    const e = this.scrollY / this.maxScrollY, t = e * this.pixelsToShave;
    cs(
      this.gos,
      `RowContainerHeightService - Div Stretch Offset = ${t} (${this.pixelsToShave} * ${e})`
    ), this.setDivStretchOffset(t);
  }
  setUiContainerHeight(e) {
    e !== this.uiContainerHeight && (this.uiContainerHeight = e, this.eventSvc.dispatchEvent({ type: "rowContainerHeightChanged" }));
  }
  clearOffset() {
    this.setUiContainerHeight(this.modelHeight), this.pixelsToShave = 0, this.setDivStretchOffset(0);
  }
  setDivStretchOffset(e) {
    const t = typeof e == "number" ? Math.floor(e) : null;
    this.divStretchOffset !== t && (this.divStretchOffset = t, this.eventSvc.dispatchEvent({ type: "heightScaleChanged" }));
  }
  setModelHeight(e) {
    this.modelHeight = e, this.stretching = e != null && // null happens when in print layout
    this.maxDivHeight > 0 && e > this.maxDivHeight, this.stretching ? this.calculateOffset() : this.clearOffset();
  }
  getRealPixelPosition(e) {
    return e - this.divStretchOffset;
  }
  getUiBodyHeight() {
    const e = this.beans.ctrlsSvc.getScrollFeature().getVScrollPosition();
    return e.bottom - e.top;
  }
  getScrollPositionForPixel(e) {
    if (this.pixelsToShave <= 0)
      return e;
    const t = this.modelHeight - this.getUiBodyHeight(), o = e / t;
    return this.maxScrollY * o;
  }
}, cNe = 400, dNe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "rowRenderer", this.destroyFuncsForColumnListeners = [], this.rowCtrlsByRowIndex = {}, this.zombieRowCtrls = {}, this.allRowCtrls = [], this.topRowCtrls = [], this.bottomRowCtrls = [], this.refreshInProgress = !1, this.dataFirstRenderedFired = !1, this.setupRangeSelectionListeners = () => {
      const e = () => {
        this.getAllCellCtrls().forEach((i) => i.onCellSelectionChanged());
      }, t = () => {
        this.getAllCellCtrls().forEach((i) => i.updateRangeBordersIfRangeCount());
      }, o = () => {
        this.eventSvc.addListener("cellSelectionChanged", e), this.eventSvc.addListener("columnMoved", t), this.eventSvc.addListener("columnPinned", t), this.eventSvc.addListener("columnVisible", t);
      }, n = () => {
        this.eventSvc.removeListener("cellSelectionChanged", e), this.eventSvc.removeListener("columnMoved", t), this.eventSvc.removeListener("columnPinned", t), this.eventSvc.removeListener("columnVisible", t);
      };
      this.addDestroyFunc(() => n()), this.addManagedPropertyListeners(["enableRangeSelection", "cellSelection"], () => {
        kn(this.gos) ? o() : n();
      }), kn(this.gos) && o();
    };
  }
  wireBeans(e) {
    this.pageBounds = e.pageBounds, this.colModel = e.colModel, this.pinnedRowModel = e.pinnedRowModel, this.rowModel = e.rowModel, this.focusSvc = e.focusSvc, this.rowContainerHeight = e.rowContainerHeight, this.ctrlsSvc = e.ctrlsSvc, this.editSvc = e.editSvc;
  }
  postConstruct() {
    this.ctrlsSvc.whenReady(this, (e) => {
      this.gridBodyCtrl = e.gridBodyCtrl, this.initialise();
    });
  }
  initialise() {
    this.addManagedEventListeners({
      paginationChanged: this.onPageLoaded.bind(this),
      pinnedRowDataChanged: this.onPinnedRowDataChanged.bind(this),
      pinnedRowsChanged: this.onPinnedRowsChanged.bind(this),
      displayedColumnsChanged: this.onDisplayedColumnsChanged.bind(this),
      bodyScroll: this.onBodyScroll.bind(this),
      bodyHeightChanged: this.redraw.bind(this, {})
    }), this.addManagedPropertyListeners(["domLayout", "embedFullWidthRows"], () => this.onDomLayoutChanged()), this.addManagedPropertyListeners(["suppressMaxRenderedRowRestriction", "rowBuffer"], () => this.redraw()), this.addManagedPropertyListener("suppressCellFocus", (n) => this.onSuppressCellFocusChanged(n.currentValue)), this.addManagedPropertyListeners(
      [
        "groupSuppressBlankHeader",
        "getBusinessKeyForNode",
        "fullWidthCellRenderer",
        "fullWidthCellRendererParams",
        "suppressStickyTotalRow",
        "groupRowRenderer",
        "groupRowRendererParams",
        // maybe only needs to refresh FW rows...
        "loadingCellRenderer",
        "loadingCellRendererParams",
        "detailCellRenderer",
        "detailCellRendererParams",
        "enableRangeSelection",
        "enableCellTextSelection"
      ],
      () => this.redrawRows()
    ), this.addManagedPropertyListener("cellSelection", ({ currentValue: n, previousValue: s }) => {
      (!s && n || s && !n) && this.redrawRows();
    });
    const { stickyRowSvc: e, gos: t, showRowGroupCols: o } = this.beans;
    if (o && this.addManagedPropertyListener("showOpenedGroup", () => {
      const n = o.getShowRowGroupCols();
      n.length && this.refreshCells({ columns: n, force: !0 });
    }), e)
      this.stickyRowFeature = e.createStickyRowFeature(
        this,
        this.createRowCon.bind(this),
        this.destroyRowCtrls.bind(this)
      );
    else {
      const n = this.gridBodyCtrl;
      n.setStickyTopHeight(0), n.setStickyBottomHeight(0);
    }
    this.registerCellEventListeners(), this.initialiseCache(), this.printLayout = jt(t, "print"), this.embedFullWidthRows = this.printLayout || t.get("embedFullWidthRows"), this.redrawAfterModelUpdate();
  }
  initialiseCache() {
    if (this.gos.get("keepDetailRows")) {
      const e = this.getKeepDetailRowsCount(), t = e ?? 3;
      this.cachedRowCtrls = new uNe(t);
    }
  }
  getKeepDetailRowsCount() {
    return this.gos.get("keepDetailRowsCount");
  }
  getStickyTopRowCtrls() {
    var e;
    return ((e = this.stickyRowFeature) == null ? void 0 : e.stickyTopRowCtrls) ?? [];
  }
  getStickyBottomRowCtrls() {
    var e;
    return ((e = this.stickyRowFeature) == null ? void 0 : e.stickyBottomRowCtrls) ?? [];
  }
  updateAllRowCtrls() {
    var n;
    const e = Object.values(this.rowCtrlsByRowIndex), t = Object.values(this.zombieRowCtrls), o = ((n = this.cachedRowCtrls) == null ? void 0 : n.getEntries()) ?? [];
    t.length > 0 || o.length > 0 ? this.allRowCtrls = [...e, ...t, ...o] : this.allRowCtrls = e;
  }
  /**
   * Checks if the cell is rendered or not. Also returns true if row ctrl is present but has not rendered
   * cells yet.
   * @returns true if cellCtrl is present, or if the row is present but has not rendered rows yet
   */
  isCellBeingRendered(e, t) {
    var s;
    const o = this.rowCtrlsByRowIndex[e];
    return !t || !o ? !!o : o.isFullWidth() ? !0 : !!((s = this.beans.spannedRowRenderer) == null ? void 0 : s.getCellByPosition({ rowIndex: e, column: t, rowPinned: null })) || !!o.getCellCtrl(t) || !o.isRowRendered();
  }
  /**
   * Notifies all row and cell controls of any change in focused cell.
   * @param event cell focused event
   */
  updateCellFocus(e) {
    this.getAllCellCtrls().forEach((t) => t.onCellFocused(e)), this.getFullWidthRowCtrls().forEach((t) => t.onFullWidthRowFocused(e));
  }
  /**
   * Called when a new cell is focused in the grid
   * - if the focused cell isn't rendered; re-draw rows to dry to render it
   * - subsequently updates all cell and row controls with the new focused cell
   * @param event cell focused event
   */
  onCellFocusChanged(e) {
    if (e && e.rowIndex != null && !e.rowPinned) {
      const t = this.beans.colModel.getCol(e.column) ?? void 0;
      this.isCellBeingRendered(e.rowIndex, t) || this.redraw();
    }
    this.updateCellFocus(e);
  }
  onSuppressCellFocusChanged(e) {
    this.getAllCellCtrls().forEach((t) => t.onSuppressCellFocusChanged(e)), this.getFullWidthRowCtrls().forEach((t) => t.onSuppressCellFocusChanged(e));
  }
  // in a clean design, each cell would register for each of these events. however when scrolling, all the cells
  // registering and de-registering for events is a performance bottleneck. so we register here once and inform
  // all active cells.
  registerCellEventListeners() {
    this.addManagedEventListeners({
      cellFocused: (e) => this.onCellFocusChanged(e),
      cellFocusCleared: () => this.updateCellFocus(),
      flashCells: (e) => {
        const { cellFlashSvc: t } = this.beans;
        t && this.getAllCellCtrls().forEach((o) => t.onFlashCells(o, e));
      },
      columnHoverChanged: () => {
        this.getAllCellCtrls().forEach((e) => e.onColumnHover());
      },
      displayedColumnsChanged: () => {
        this.getAllCellCtrls().forEach((e) => e.onDisplayedColumnsChanged());
      },
      displayedColumnsWidthChanged: () => {
        this.printLayout && this.getAllCellCtrls().forEach((e) => e.onLeftChanged());
      }
    }), this.setupRangeSelectionListeners(), this.refreshListenersToColumnsForCellComps(), this.addManagedEventListeners({
      gridColumnsChanged: this.refreshListenersToColumnsForCellComps.bind(this)
    }), this.addDestroyFunc(this.removeGridColumnListeners.bind(this));
  }
  // executes all functions in destroyFuncsForColumnListeners and then clears the list
  removeGridColumnListeners() {
    this.destroyFuncsForColumnListeners.forEach((e) => e()), this.destroyFuncsForColumnListeners.length = 0;
  }
  // this function adds listeners onto all the grid columns, which are the column that we could have cellComps for.
  // when the grid columns change, we add listeners again. in an ideal design, each CellComp would just register to
  // the column it belongs to on creation, however this was a bottleneck with the number of cells, so do it here
  // once instead.
  refreshListenersToColumnsForCellComps() {
    this.removeGridColumnListeners(), this.colModel.getCols().forEach((t) => {
      const o = (a) => {
        this.getAllCellCtrls().forEach((c) => {
          c.column === t && a(c);
        });
      }, n = () => {
        o((a) => a.onLeftChanged());
      }, s = () => {
        o((a) => a.onWidthChanged());
      }, i = () => {
        o((a) => a.onFirstRightPinnedChanged());
      }, r = () => {
        o((a) => a.onLastLeftPinnedChanged());
      }, l = () => {
        o((a) => a.onColDefChanged());
      };
      t.__addEventListener("leftChanged", n), t.__addEventListener("widthChanged", s), t.__addEventListener("firstRightPinnedChanged", i), t.__addEventListener("lastLeftPinnedChanged", r), t.__addEventListener("colDefChanged", l), this.destroyFuncsForColumnListeners.push(() => {
        t.__removeEventListener("leftChanged", n), t.__removeEventListener("widthChanged", s), t.__removeEventListener("firstRightPinnedChanged", i), t.__removeEventListener("lastLeftPinnedChanged", r), t.__removeEventListener("colDefChanged", l);
      });
    });
  }
  onDomLayoutChanged() {
    const e = jt(this.gos, "print"), t = e || this.gos.get("embedFullWidthRows"), o = t !== this.embedFullWidthRows || this.printLayout !== e;
    this.printLayout = e, this.embedFullWidthRows = t, o && this.redrawAfterModelUpdate({ domLayoutChanged: !0 });
  }
  // for row models that have datasources, when we update the datasource, we need to force the rowRenderer
  // to redraw all rows. otherwise the old rows from the old datasource will stay displayed.
  datasourceChanged() {
    this.firstRenderedRow = 0, this.lastRenderedRow = -1;
    const e = Object.keys(this.rowCtrlsByRowIndex);
    this.removeRowCtrls(e);
  }
  onPageLoaded(e) {
    const t = {
      recycleRows: e.keepRenderedRows,
      animate: e.animate,
      newData: e.newData,
      newPage: e.newPage,
      // because this is a model updated event (not pinned rows), we
      // can skip updating the pinned rows. this is needed so that if user
      // is doing transaction updates, the pinned rows are not getting constantly
      // trashed - or editing cells in pinned rows are not refreshed and put into read mode
      onlyBody: !0
    };
    this.redrawAfterModelUpdate(t);
  }
  /**
   * @param column AgColumn
   * @returns An array with HTMLElement for every cell of the column passed as param.
   * If the cell is spanning across multiple columns, it only returns the html element
   * if the column passed is the first column of the span (used for auto width calculation).
   */
  getAllCellsNotSpanningForColumn(e) {
    const t = [];
    return this.getAllRowCtrls().forEach((o) => {
      var s;
      const n = (s = o.getCellCtrl(e, !0)) == null ? void 0 : s.eGui;
      n && t.push(n);
    }), t;
  }
  refreshFloatingRowComps(e = !0) {
    this.refreshFloatingRows(this.topRowCtrls, "top", e), this.refreshFloatingRows(this.bottomRowCtrls, "bottom", e);
  }
  /**
   * Determines which row controllers need to be destroyed and re-created vs which ones can
   * be re-used.
   *
   * This is operation is to pinned/floating rows as `this.recycleRows` is to normal/body rows.
   *
   * All `RowCtrl` instances in `rowCtrls` that don't correspond to `RowNode` instances in `rowNodes` are destroyed.
   * All `RowNode` instances in `rowNodes` that don't correspond to `RowCtrl` instances in `rowCtrls` are created.
   * All instances in `rowCtrls` must be in the same order as their corresponding nodes in `rowNodes`.
   *
   * @param rowCtrls The list of existing row controllers
   * @param rowNodes The canonical list of row nodes that should have associated controllers
   */
  refreshFloatingRows(e, t, o) {
    const { pinnedRowModel: n, beans: s, printLayout: i } = this, r = Object.fromEntries(e.map((a) => [a.rowNode.id, a]));
    n == null || n.forEachPinnedRow(t, (a, c) => {
      const d = e[c];
      d && n.getPinnedRowById(d.rowNode.id, t) === void 0 && (d.destroyFirstPass(), d.destroySecondPass()), a.id in r && o ? (e[c] = r[a.id], delete r[a.id]) : e[c] = new Vl(a, s, !1, !1, i);
    });
    const l = (t === "top" ? n == null ? void 0 : n.getPinnedTopRowCount() : n == null ? void 0 : n.getPinnedBottomRowCount()) ?? 0;
    e.length = l;
  }
  onPinnedRowDataChanged() {
    const e = {
      recycleRows: !0
    };
    this.redrawAfterModelUpdate(e);
  }
  onPinnedRowsChanged() {
    this.redrawAfterModelUpdate({ recycleRows: !0 });
  }
  redrawRow(e, t = !1) {
    var o, n;
    if (e.sticky)
      (o = this.stickyRowFeature) == null || o.refreshStickyNode(e);
    else if ((n = this.cachedRowCtrls) != null && n.has(e)) {
      this.cachedRowCtrls.removeRow(e);
      return;
    } else {
      const s = (i) => {
        const r = i[e.rowIndex];
        r && r.rowNode === e && (r.destroyFirstPass(), r.destroySecondPass(), i[e.rowIndex] = this.createRowCon(e, !1, !1));
      };
      switch (e.rowPinned) {
        case "top":
          s(this.topRowCtrls);
          break;
        case "bottom":
          s(this.bottomRowCtrls);
          break;
        default:
          s(this.rowCtrlsByRowIndex), this.updateAllRowCtrls();
      }
    }
    t || this.dispatchDisplayedRowsChanged(!1);
  }
  redrawRows(e) {
    const { editSvc: t } = this.beans;
    if (t != null && t.isEditing() && (t.isBatchEditing() ? t.cleanupEditors() : t.stopEditing(void 0, { source: "api" })), e != null) {
      e == null || e.forEach((n) => this.redrawRow(n, !0)), this.dispatchDisplayedRowsChanged(!1);
      return;
    }
    this.redrawAfterModelUpdate();
  }
  // gets called from:
  // +) initialisation (in registerGridComp) params = null
  // +) onDomLayoutChanged, params = null
  // +) onPageLoaded, recycleRows, animate, newData, newPage from event, onlyBody=true
  // +) onPinnedRowDataChanged, recycleRows = true
  // +) redrawRows (from Grid API), recycleRows = true/false
  redrawAfterModelUpdate(e = {}) {
    var l;
    this.getLockOnRefresh();
    const t = (l = this.beans.focusSvc) == null ? void 0 : l.getFocusCellToUseAfterRefresh();
    this.updateContainerHeights(), this.scrollToTopIfNewData(e);
    const o = !e.domLayoutChanged && !!e.recycleRows, n = e.animate && Ei(this.gos), s = o ? this.getRowsToRecycle() : null;
    o || this.removeAllRowComps(), this.workOutFirstAndLastRowsToRender();
    const { stickyRowFeature: i, gos: r } = this;
    if (i) {
      i.checkStickyRows();
      const a = i.extraTopHeight + i.extraBottomHeight;
      a && this.updateContainerHeights(a);
    }
    this.recycleRows(s, n), this.gridBodyCtrl.updateRowCount(), e.onlyBody || this.refreshFloatingRowComps(r.get("enableRowPinning") ? o : void 0), this.dispatchDisplayedRowsChanged(), t != null && this.restoreFocusedCell(t), this.releaseLockOnRefresh();
  }
  scrollToTopIfNewData(e) {
    var n;
    const t = e.newData || e.newPage, o = this.gos.get("suppressScrollOnNewData");
    t && !o && (this.gridBodyCtrl.scrollFeature.scrollToTop(), (n = this.stickyRowFeature) == null || n.resetOffsets());
  }
  updateContainerHeights(e = 0) {
    const { rowContainerHeight: t } = this;
    if (this.printLayout) {
      t.setModelHeight(null);
      return;
    }
    let o = this.pageBounds.getCurrentPageHeight();
    o === 0 && (o = 1), t.setModelHeight(o + e);
  }
  getLockOnRefresh() {
    var e, t;
    if (this.refreshInProgress)
      throw new Error(ln(252));
    this.refreshInProgress = !0, (t = (e = this.beans.frameworkOverrides).getLockOnRefresh) == null || t.call(e);
  }
  releaseLockOnRefresh() {
    var e, t;
    this.refreshInProgress = !1, (t = (e = this.beans.frameworkOverrides).releaseLockOnRefresh) == null || t.call(e);
  }
  isRefreshInProgress() {
    return this.refreshInProgress;
  }
  // sets the focus to the provided cell, if the cell is provided. this way, the user can call refresh without
  // worry about the focus been lost. this is important when the user is using keyboard navigation to do edits
  // and the cellEditor is calling 'refresh' to get other cells to update (as other cells might depend on the
  // edited cell).
  restoreFocusedCell(e) {
    if (!e)
      return;
    const t = this.beans.focusSvc, o = this.findPositionToFocus(e);
    if (!o) {
      t.focusHeaderPosition({
        headerPosition: {
          headerRowIndex: nn(this.beans) - 1,
          column: e.column
        }
      });
      return;
    }
    if (e.rowIndex !== o.rowIndex || e.rowPinned != o.rowPinned) {
      t.setFocusedCell({
        ...o,
        preventScrollOnBrowserFocus: !0,
        forceBrowserFocus: !0
      });
      return;
    }
    t.doesRowOrCellHaveBrowserFocus() || this.updateCellFocus(
      Pe(this.gos, {
        ...o,
        forceBrowserFocus: !0,
        preventScrollOnBrowserFocus: !0,
        type: "cellFocused"
      })
    );
  }
  findPositionToFocus(e) {
    const { pagination: t, pageBounds: o } = this.beans;
    let n = e;
    for (n.rowPinned == null && t && o && !t.isRowInPage(n.rowIndex) && (n = { rowPinned: null, rowIndex: o.getFirstRow() }); n; ) {
      if (n.rowPinned == null && o)
        if (n.rowIndex < o.getFirstRow()) {
          if (n = Dl(this.beans, { rowPinned: null, rowIndex: 0 }), !n)
            return null;
        } else n.rowIndex > o.getLastRow() && (n = { rowPinned: null, rowIndex: o.getLastRow() });
      const s = this.getRowByPosition(n);
      if (s != null && s.isAlive())
        return { ...s.getRowPosition(), column: e.column };
      n = Dl(this.beans, n);
    }
    return null;
  }
  getAllCellCtrls() {
    const e = [], t = this.getAllRowCtrls(), o = t.length;
    for (let n = 0; n < o; n++) {
      const s = t[n].getAllCellCtrls(), i = s.length;
      for (let r = 0; r < i; r++)
        e.push(s[r]);
    }
    return e;
  }
  getAllRowCtrls() {
    const { spannedRowRenderer: e } = this.beans, t = this.getStickyTopRowCtrls(), o = this.getStickyBottomRowCtrls();
    return [
      ...this.topRowCtrls,
      ...this.bottomRowCtrls,
      ...t,
      ...o,
      ...(e == null ? void 0 : e.getCtrls("top")) ?? [],
      ...(e == null ? void 0 : e.getCtrls("bottom")) ?? [],
      ...(e == null ? void 0 : e.getCtrls("center")) ?? [],
      ...Object.values(this.rowCtrlsByRowIndex)
    ];
  }
  addRenderedRowListener(e, t, o) {
    const n = this.rowCtrlsByRowIndex[t];
    n && n.addEventListener(e, o);
  }
  refreshCells({ rowNodes: e, columns: t, force: o, suppressFlash: n } = {}) {
    const s = {
      force: o,
      newData: !1,
      suppressFlash: n
    };
    for (const i of this.getCellCtrls(e, t))
      i.refreshOrDestroyCell(s);
    this.refreshFullWidth(e);
  }
  refreshRows(e = {}) {
    this.getRowCtrls(e.rowNodes).forEach((t) => t.refreshRow(e)), this.refreshFullWidth(e.rowNodes);
  }
  refreshFullWidth(e) {
    if (!e)
      return;
    let t = !1;
    for (const o of this.getRowCtrls(e)) {
      if (!o.isFullWidth())
        continue;
      o.refreshFullWidth() || (t = !0, this.redrawRow(o.rowNode, !0));
    }
    t && this.dispatchDisplayedRowsChanged(!1);
  }
  /**
   * @param rowNodes if provided, returns the RowCtrls for the provided rowNodes. otherwise returns all RowCtrls.
   */
  getRowCtrls(e) {
    const t = b5(e), o = this.getAllRowCtrls();
    return !e || !t ? o : o.filter((n) => {
      const s = n.rowNode;
      return y5(s, t);
    });
  }
  // returns CellCtrl's that match the provided rowNodes and columns. eg if one row node
  // and two columns provided, that identifies 4 cells, so 4 CellCtrl's returned.
  getCellCtrls(e, t) {
    let o;
    ue(t) && (o = {}, t.forEach((s) => {
      const i = this.colModel.getCol(s);
      ue(i) && (o[i.getId()] = !0);
    }));
    const n = [];
    return this.getRowCtrls(e).forEach((s) => {
      s.getAllCellCtrls().forEach((i) => {
        const r = i.column.getId();
        o && !o[r] || n.push(i);
      });
    }), n;
  }
  destroy() {
    this.removeAllRowComps(!0), super.destroy();
  }
  removeAllRowComps(e = !1) {
    var o;
    const t = Object.keys(this.rowCtrlsByRowIndex);
    this.removeRowCtrls(t, e), (o = this.stickyRowFeature) == null || o.destroyStickyCtrls();
  }
  getRowsToRecycle() {
    const e = [];
    for (const o of Object.keys(this.rowCtrlsByRowIndex))
      this.rowCtrlsByRowIndex[o].rowNode.id == null && e.push(o);
    this.removeRowCtrls(e);
    const t = {};
    for (const o of Object.values(this.rowCtrlsByRowIndex)) {
      const n = o.rowNode;
      t[n.id] = o;
    }
    return this.rowCtrlsByRowIndex = {}, t;
  }
  // takes array of row indexes
  removeRowCtrls(e, t = !1) {
    e.forEach((o) => {
      const n = this.rowCtrlsByRowIndex[o];
      n && (n.destroyFirstPass(t), n.destroySecondPass()), delete this.rowCtrlsByRowIndex[o];
    });
  }
  onBodyScroll(e) {
    e.direction === "vertical" && this.redraw({ afterScroll: !0 });
  }
  // gets called when rows don't change, but viewport does, so after:
  // 1) height of grid body changes, ie number of displayed rows has changed
  // 2) grid scrolled to new position
  // 3) ensure index visible (which is a scroll)
  redraw(e = {}) {
    const { focusSvc: t, animationFrameSvc: o } = this.beans, { afterScroll: n } = e;
    let s;
    const i = this.stickyRowFeature;
    i && (s = (t == null ? void 0 : t.getFocusCellToUseAfterRefresh()) || void 0);
    const r = this.firstRenderedRow, l = this.lastRenderedRow;
    this.workOutFirstAndLastRowsToRender();
    let a = !1;
    if (i) {
      a = i.checkStickyRows();
      const d = i.extraTopHeight + i.extraBottomHeight;
      d && this.updateContainerHeights(d);
    }
    const c = this.firstRenderedRow !== r || this.lastRenderedRow !== l;
    if (!(n && !a && !c) && (this.getLockOnRefresh(), this.recycleRows(null, !1, n), this.releaseLockOnRefresh(), this.dispatchDisplayedRowsChanged(n && !a), s != null)) {
      const d = t == null ? void 0 : t.getFocusCellToUseAfterRefresh();
      s != null && d == null && (o == null || o.flushAllFrames(), this.restoreFocusedCell(s));
    }
  }
  removeRowCompsNotToDraw(e, t) {
    const o = {};
    e.forEach((i) => o[i] = !0);
    const s = Object.keys(this.rowCtrlsByRowIndex).filter((i) => !o[i]);
    this.removeRowCtrls(s, t);
  }
  calculateIndexesToDraw(e) {
    var r, l;
    const t = [];
    for (let a = this.firstRenderedRow; a <= this.lastRenderedRow; a++)
      t.push(a);
    const o = this.beans.pagination, n = (l = (r = this.beans.focusSvc) == null ? void 0 : r.getFocusedCell()) == null ? void 0 : l.rowIndex;
    n != null && (n < this.firstRenderedRow || n > this.lastRenderedRow) && (!o || o.isRowInPage(n)) && n < this.rowModel.getRowCount() && t.push(n);
    const s = (a) => {
      const c = a.rowNode.rowIndex;
      c == null || c === n || (c < this.firstRenderedRow || c > this.lastRenderedRow) && this.doNotUnVirtualiseRow(a) && t.push(c);
    };
    for (const a of Object.values(this.rowCtrlsByRowIndex))
      s(a);
    if (e)
      for (const a of Object.values(e))
        s(a);
    t.sort((a, c) => a - c);
    const i = [];
    for (let a = 0; a < t.length; a++) {
      const c = t[a], d = this.rowModel.getRow(c);
      d && !d.sticky && i.push(c);
    }
    return i;
  }
  recycleRows(e, t = !1, o = !1) {
    const n = this.calculateIndexesToDraw(e);
    if ((this.printLayout || o) && (t = !1), this.removeRowCompsNotToDraw(n, !t), n.forEach((s) => {
      this.createOrUpdateRowCtrl(s, e, t, o);
    }), e) {
      const { animationFrameSvc: s } = this.beans;
      (s == null ? void 0 : s.active) && o && !this.printLayout ? s.addDestroyTask(() => {
        this.destroyRowCtrls(e, t), this.updateAllRowCtrls(), this.dispatchDisplayedRowsChanged();
      }) : this.destroyRowCtrls(e, t);
    }
    this.updateAllRowCtrls();
  }
  dispatchDisplayedRowsChanged(e = !1) {
    this.eventSvc.dispatchEvent({
      type: "displayedRowsChanged",
      afterScroll: e
    });
  }
  onDisplayedColumnsChanged() {
    const { visibleCols: e } = this.beans, t = e.isPinningLeft(), o = e.isPinningRight();
    (this.pinningLeft !== t || o !== this.pinningRight) && (this.pinningLeft = t, this.pinningRight = o, this.embedFullWidthRows && this.redrawFullWidthEmbeddedRows());
  }
  // when embedding, what gets showed in each section depends on what is pinned. eg if embedding group expand / collapse,
  // then it should go into the pinned left area if pinning left, or the center area if not pinning.
  redrawFullWidthEmbeddedRows() {
    const e = [];
    this.getFullWidthRowCtrls().forEach((t) => {
      const o = t.rowNode.rowIndex;
      e.push(o.toString());
    }), this.refreshFloatingRowComps(), this.removeRowCtrls(e), this.redraw({ afterScroll: !0 });
  }
  getFullWidthRowCtrls(e) {
    const t = b5(e);
    return this.getAllRowCtrls().filter((o) => {
      if (!o.isFullWidth())
        return !1;
      const n = o.rowNode;
      return !(t != null && !y5(n, t));
    });
  }
  createOrUpdateRowCtrl(e, t, o, n) {
    let s, i = this.rowCtrlsByRowIndex[e];
    if (i || (s = this.rowModel.getRow(e), ue(s) && ue(t) && t[s.id] && s.alreadyRendered && (i = t[s.id], t[s.id] = null)), !i)
      if (s || (s = this.rowModel.getRow(e)), ue(s))
        i = this.createRowCon(s, o, n);
      else
        return;
    return s && (s.alreadyRendered = !0), this.rowCtrlsByRowIndex[e] = i, i;
  }
  destroyRowCtrls(e, t) {
    const o = [];
    if (e) {
      for (const n of Object.values(e))
        if (n) {
          if (this.cachedRowCtrls && n.isCacheable()) {
            this.cachedRowCtrls.addRow(n);
            continue;
          }
          if (n.destroyFirstPass(!t), t) {
            const s = n.instanceId;
            this.zombieRowCtrls[s] = n, o.push(() => {
              n.destroySecondPass(), delete this.zombieRowCtrls[s];
            });
          } else
            n.destroySecondPass();
        }
    }
    t && (o.push(() => {
      this.isAlive() && (this.updateAllRowCtrls(), this.dispatchDisplayedRowsChanged());
    }), window.setTimeout(() => o.forEach((n) => n()), cNe));
  }
  getRowBuffer() {
    return this.gos.get("rowBuffer");
  }
  getRowBufferInPixels() {
    const e = this.getRowBuffer(), t = Vs(this.beans);
    return e * t;
  }
  workOutFirstAndLastRowsToRender() {
    const { rowContainerHeight: e, pageBounds: t, rowModel: o } = this;
    e.updateOffset();
    let n, s;
    if (!o.isRowsToRender())
      n = 0, s = -1;
    else if (this.printLayout)
      this.beans.environment.refreshRowHeightVariable(), n = t.getFirstRow(), s = t.getLastRow();
    else {
      const d = this.getRowBufferInPixels(), u = this.ctrlsSvc.getScrollFeature(), h = this.gos.get("suppressRowVirtualisation");
      let p = !1, C, m;
      do {
        const M = t.getPixelOffset(), { pageFirstPixel: x, pageLastPixel: L } = t.getCurrentPagePixelRange(), A = e.divStretchOffset, R = u.getVScrollPosition(), P = R.top, I = R.bottom;
        h ? (C = x + A, m = L + A) : (C = Math.max(P + M - d, x) + A, m = Math.min(I + M + d, L) + A), this.firstVisibleVPixel = Math.max(P + M, x) + A, this.lastVisibleVPixel = Math.min(I + M, L) + A, p = this.ensureAllRowsInRangeHaveHeightsCalculated(C, m);
      } while (p);
      let w = o.getRowIndexAtPixel(C), y = o.getRowIndexAtPixel(m);
      const b = t.getFirstRow(), _ = t.getLastRow();
      w < b && (w = b), y > _ && (y = _), n = w, s = y;
    }
    const i = jt(this.gos, "normal"), r = this.gos.get("suppressMaxRenderedRowRestriction"), l = Math.max(this.getRowBuffer(), 500);
    i && !r && s - n > l && (s = n + l);
    const a = n !== this.firstRenderedRow, c = s !== this.lastRenderedRow;
    (a || c) && (this.firstRenderedRow = n, this.lastRenderedRow = s, this.eventSvc.dispatchEvent({
      type: "viewportChanged",
      firstRow: n,
      lastRow: s
    }));
  }
  /**
   * This event will only be fired once, and is queued until after the browser next renders.
   * This allows us to fire an event during the start of the render cycle, when we first see data being rendered
   * but not execute the event until all of the data has finished being rendered to the dom.
   */
  dispatchFirstDataRenderedEvent() {
    this.dataFirstRenderedFired || (this.dataFirstRenderedFired = !0, yo(this.beans, () => {
      this.beans.eventSvc.dispatchEvent({
        type: "firstDataRendered",
        firstRow: this.firstRenderedRow,
        lastRow: this.lastRenderedRow
      });
    }));
  }
  ensureAllRowsInRangeHaveHeightsCalculated(e, t) {
    var l, a;
    const o = (l = this.pinnedRowModel) == null ? void 0 : l.ensureRowHeightsValid(), n = (a = this.stickyRowFeature) == null ? void 0 : a.ensureRowHeightsValid(), { pageBounds: s, rowModel: i } = this, r = i.ensureRowHeightsValid(
      e,
      t,
      s.getFirstRow(),
      s.getLastRow()
    );
    return (r || n) && this.eventSvc.dispatchEvent({
      type: "recalculateRowBounds"
    }), n || r || o ? (this.updateContainerHeights(), !0) : !1;
  }
  // check that none of the rows to remove are editing or focused as:
  // a) if editing, we want to keep them, otherwise the user will loose the context of the edit,
  //    eg user starts editing, enters some text, then scrolls down and then up, next time row rendered
  //    the edit is reset - so we want to keep it rendered.
  // b) if focused, we want ot keep keyboard focus, so if user ctrl+c, it goes to clipboard,
  //    otherwise the user can range select and drag (with focus cell going out of the viewport)
  //    and then ctrl+c, nothing will happen if cell is removed from dom.
  // c) if detail record of master detail, as users complained that the context of detail rows
  //    was getting lost when detail row out of view. eg user expands to show detail row,
  //    then manipulates the detail panel (eg sorts the detail grid), then context is lost
  //    after detail panel is scrolled out of / into view.
  doNotUnVirtualiseRow(e) {
    var c;
    const n = e.rowNode, s = this.focusSvc.isRowFocused(n.rowIndex, n.rowPinned), i = (c = this.editSvc) == null ? void 0 : c.isEditing(e), r = n.detail;
    return s || i || r ? !!this.isRowPresent(n) : !1;
  }
  isRowPresent(e) {
    var t;
    return this.rowModel.isRowPresent(e) ? ((t = this.beans.pagination) == null ? void 0 : t.isRowInPage(e.rowIndex)) ?? !0 : !1;
  }
  createRowCon(e, t, o) {
    var r, l;
    const n = ((r = this.cachedRowCtrls) == null ? void 0 : r.getRow(e)) ?? null;
    if (n)
      return n;
    const s = o && !this.printLayout && !!((l = this.beans.animationFrameSvc) != null && l.active);
    return new Vl(e, this.beans, t, s, this.printLayout);
  }
  getRenderedNodes() {
    const e = Object.values(this.rowCtrlsByRowIndex).map((n) => n.rowNode), t = this.getStickyTopRowCtrls().map((n) => n.rowNode), o = this.getStickyBottomRowCtrls().map((n) => n.rowNode);
    return [...t, ...e, ...o];
  }
  getRowByPosition(e) {
    let t;
    const { rowIndex: o } = e;
    switch (e.rowPinned) {
      case "top":
        t = this.topRowCtrls[o];
        break;
      case "bottom":
        t = this.bottomRowCtrls[o];
        break;
      default:
        t = this.rowCtrlsByRowIndex[o], t || (t = this.getStickyTopRowCtrls().find((n) => n.rowNode.rowIndex === o) || null, t || (t = this.getStickyBottomRowCtrls().find((n) => n.rowNode.rowIndex === o) || null));
        break;
    }
    return t;
  }
  // returns true if any row between startIndex and endIndex is rendered. used by
  // SSRM or IRM, as they don't want to purge visible blocks from cache.
  isRangeInRenderedViewport(e, t) {
    if (e == null || t == null)
      return !1;
    const n = e > this.lastRenderedRow;
    return !(t < this.firstRenderedRow) && !n;
  }
}, uNe = class {
  constructor(e) {
    this.entriesMap = {}, this.entriesList = [], this.maxCount = e;
  }
  addRow(e) {
    if (this.entriesMap[e.rowNode.id] = e, this.entriesList.push(e), e.setCached(!0), this.entriesList.length > this.maxCount) {
      const t = this.entriesList[0];
      t.destroyFirstPass(), t.destroySecondPass(), this.removeFromCache(t);
    }
  }
  getRow(e) {
    if (e == null || e.id == null)
      return null;
    const t = this.entriesMap[e.id];
    return t ? (this.removeFromCache(t), t.setCached(!1), t.rowNode != e ? null : t) : null;
  }
  has(e) {
    return this.entriesMap[e.id] != null;
  }
  removeRow(e) {
    const t = e.id, o = this.entriesMap[t];
    delete this.entriesMap[t], Zt(this.entriesList, o);
  }
  removeFromCache(e) {
    const t = e.rowNode.id;
    delete this.entriesMap[t], Zt(this.entriesList, e);
  }
  getEntries() {
    return this.entriesList;
  }
};
function b5(e) {
  if (!e)
    return;
  const t = {
    top: {},
    bottom: {},
    normal: {}
  };
  return e.forEach((o) => {
    const n = o.id;
    switch (o.rowPinned) {
      case "top":
        t.top[n] = o;
        break;
      case "bottom":
        t.bottom[n] = o;
        break;
      default:
        t.normal[n] = o;
        break;
    }
  }), t;
}
function y5(e, t) {
  const o = e.id;
  switch (e.rowPinned) {
    case "top":
      return t.top[o] != null;
    case "bottom":
      return t.bottom[o] != null;
    default:
      return t.normal[o] != null;
  }
}
var hNe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "rowNodeSorter";
  }
  postConstruct() {
    const { gos: e } = this;
    this.isAccentedSort = e.get("accentedSort"), this.primaryColumnsSortGroups = Oo(e), this.addManagedPropertyListener(
      "accentedSort",
      (t) => this.isAccentedSort = t.currentValue
    ), this.addManagedPropertyListener(
      "autoGroupColumnDef",
      () => this.primaryColumnsSortGroups = Oo(e)
    );
  }
  doFullSort(e, t) {
    const o = e.map((n, s) => ({
      currentPos: s,
      rowNode: n
    }));
    return o.sort(this.compareRowNodes.bind(this, t)), o.map((n) => n.rowNode);
  }
  compareRowNodes(e, t, o) {
    const n = t.rowNode, s = o.rowNode;
    for (let i = 0, r = e.length; i < r; i++) {
      const l = e[i], a = l.sort === "desc", c = this.getValue(n, l.column), d = this.getValue(s, l.column);
      let u;
      const h = this.getComparator(l, n);
      if (h ? u = h(c, d, n, s, a) : u = vl(c, d, this.isAccentedSort), !isNaN(u) && u !== 0)
        return l.sort === "asc" ? u : u * -1;
    }
    return t.currentPos - o.currentPos;
  }
  getComparator(e, t) {
    const o = e.column, n = o.getColDef().comparator;
    if (n != null)
      return n;
    if (!o.getColDef().showRowGroup)
      return;
    const s = !t.group && o.getColDef().field;
    if (!s)
      return;
    const i = this.beans.colModel.getColDefCol(s);
    if (i)
      return i.getColDef().comparator;
  }
  getValue(e, t) {
    var l, a;
    const { valueSvc: o, colModel: n, showRowGroupCols: s, gos: i } = this.beans;
    if (!this.primaryColumnsSortGroups)
      return o.getValue(t, e, !1);
    if (e.rowGroupColumn === t) {
      if (L2(i, n.isPivotActive())) {
        const u = (l = e.allLeafChildren) == null ? void 0 : l[0];
        return u ? o.getValue(t, u, !1) : void 0;
      }
      const d = s == null ? void 0 : s.getShowRowGroupCol(t.getId());
      return d ? (a = e.groupData) == null ? void 0 : a[d.getId()] : void 0;
    }
    if (!(e.group && t.getColDef().showRowGroup))
      return o.getValue(t, e, !1);
  }
};
function gNe(e) {
  var t;
  (t = e.sortSvc) == null || t.onSortChanged("api");
}
var xy = {
  moduleName: "Sort",
  version: be,
  beans: [FZe, hNe],
  apiFunctions: {
    onSortChanged: gNe
  },
  userComponents: {
    agSortIndicator: nc
  },
  icons: {
    // show on column header when column is sorted ascending
    sortAscending: "asc",
    // show on column header when column is sorted descending
    sortDescending: "desc",
    // show on column header when column has no sort, only when enabled with gridOptions.unSortIcon=true
    sortUnSort: "none"
  }
}, pNe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "syncSvc", this.waitingForColumns = !1;
  }
  postConstruct() {
    this.addManagedPropertyListener("columnDefs", (e) => this.setColumnDefs(e));
  }
  start() {
    this.beans.ctrlsSvc.whenReady(this, () => {
      const e = this.gos.get("columnDefs");
      e ? this.setColumnsAndData(e) : this.waitingForColumns = !0, this.gridReady();
    });
  }
  setColumnsAndData(e) {
    const { colModel: t, rowModel: o } = this.beans;
    t.setColumnDefs(e ?? [], "gridInitializing"), o.start();
  }
  gridReady() {
    const { eventSvc: e, gos: t } = this;
    e.dispatchEvent({
      type: "gridReady"
    }), cs(t, `initialised successfully, enterprise = ${t.isModuleRegistered("EnterpriseCore")}`);
  }
  setColumnDefs(e) {
    const t = this.gos.get("columnDefs");
    if (t) {
      if (this.waitingForColumns) {
        this.waitingForColumns = !1, this.setColumnsAndData(t);
        return;
      }
      this.beans.colModel.setColumnDefs(t, Bs(e.source));
    }
  }
};
function fNe(e) {
  var t;
  (t = e.valueCache) == null || t.expire();
}
function vNe(e, t) {
  const { colKey: o, rowNode: n, useFormatter: s } = t, i = e.colModel.getColDefCol(o) ?? e.colModel.getCol(o);
  if (Xe(i))
    return null;
  const r = e.valueSvc.getValueForDisplay(i, n, s);
  return s ? r.valueFormatted ?? ni(r.value) : r.value;
}
var mNe = "paste", CNe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "changeDetectionSvc", this.clientSideRowModel = null;
  }
  postConstruct() {
    const { gos: e, rowModel: t } = this.beans;
    dt(e) && (this.clientSideRowModel = t), this.addManagedEventListeners({ cellValueChanged: this.onCellValueChanged.bind(this) });
  }
  onCellValueChanged(e) {
    const { gos: t, rowRenderer: o } = this.beans;
    if (e.source === mNe || t.get("suppressChangeDetection"))
      return;
    const n = e.node, s = [n], i = this.clientSideRowModel, r = i == null ? void 0 : i.rootNode;
    if (r && !n.isRowPinned()) {
      const l = t.get("aggregateOnlyChangedColumns"), a = new Wi(l, r);
      a.addParentNode(n.parent, [e.column]), i.doAggregate(a), a.forEachChangedNodeDepthFirst((c) => {
        s.push(c), c.sibling && s.push(c.sibling);
      });
    }
    o.refreshCells({ rowNodes: s });
  }
}, wNe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "expressionSvc", this.cache = {};
  }
  evaluate(e, t) {
    if (typeof e == "string")
      return this.evaluateExpression(e, t);
    qe(15, { expression: e });
  }
  evaluateExpression(e, t) {
    try {
      return this.createExpressionFunction(e)(
        t.value,
        t.context,
        t.oldValue,
        t.newValue,
        t.value,
        t.node,
        t.data,
        t.colDef,
        t.rowIndex,
        t.api,
        t.getValue,
        t.column,
        t.columnGroup
      );
    } catch (o) {
      return qe(16, { expression: e, params: t, e: o }), null;
    }
  }
  createExpressionFunction(e) {
    const t = this.cache;
    if (t[e])
      return t[e];
    const o = this.createFunctionBody(e), n = new Function(
      "x, ctx, oldValue, newValue, value, node, data, colDef, rowIndex, api, getValue, column, columnGroup",
      o
    );
    return t[e] = n, n;
  }
  createFunctionBody(e) {
    return e.indexOf("return") >= 0 ? e : "return " + e + ";";
  }
}, bNe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "valueCache", this.cacheVersion = 0;
  }
  postConstruct() {
    const e = this.gos;
    this.active = e.get("valueCache"), this.neverExpires = e.get("valueCacheNeverExpires");
  }
  onDataChanged() {
    this.neverExpires || this.expire();
  }
  expire() {
    this.cacheVersion++;
  }
  setValue(e, t, o) {
    if (this.active) {
      const n = this.cacheVersion;
      e.__cacheVersion !== n && (e.__cacheVersion = n, e.__cacheData = {}), e.__cacheData[t] = o;
    }
  }
  getValue(e, t) {
    if (!(!this.active || e.__cacheVersion !== this.cacheVersion))
      return e.__cacheData[t];
  }
}, yNe = {
  moduleName: "ValueCache",
  version: be,
  beans: [bNe],
  apiFunctions: {
    expireValueCache: fNe
  }
}, _Ne = {
  moduleName: "Expression",
  version: be,
  beans: [wNe]
}, SNe = {
  moduleName: "ChangeDetection",
  version: be,
  beans: [CNe]
}, xNe = {
  moduleName: "CellApi",
  version: be,
  apiFunctions: {
    getCellValue: vNe
  }
}, MNe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "valueSvc", this.hasEditSvc = !1, this.initialised = !1, this.isSsrm = !1;
  }
  wireBeans(e) {
    this.expressionSvc = e.expressionSvc, this.colModel = e.colModel, this.valueCache = e.valueCache, this.dataTypeSvc = e.dataTypeSvc, this.editSvc = e.editSvc, this.hasEditSvc = !!e.editSvc;
  }
  postConstruct() {
    this.initialised || this.init();
  }
  init() {
    this.executeValueGetter = this.valueCache ? this.executeValueGetterWithValueCache.bind(this) : this.executeValueGetterWithoutValueCache.bind(this), this.isSsrm = $n(this.gos), this.cellExpressions = this.gos.get("enableCellExpressions"), this.isTreeData = this.gos.get("treeData"), this.initialised = !0;
    const e = (t) => this.callColumnCellValueChangedHandler(t);
    this.eventSvc.addListener("cellValueChanged", e, !0), this.addDestroyFunc(() => this.eventSvc.removeListener("cellValueChanged", e, !0)), this.addManagedPropertyListener("treeData", (t) => this.isTreeData = t.currentValue);
  }
  /**
   * Use this function to get a displayable cell value.
   * The values from this function are not used for sorting, filtering, or aggregation purposes.
   * Handles: groupHideOpenParents, showOpenedGroup and groupSuppressBlankHeader behaviours
   */
  getValueForDisplay(e, t, o = !1, n = !1, s = "ui") {
    const { showRowGroupColValueSvc: i } = this.beans, r = !e && t.group, l = e == null ? void 0 : e.colDef.showRowGroup, a = !this.isTreeData || t.footer;
    if (i && a && (r || l)) {
      const m = i.getGroupValue(t, e);
      if (m == null)
        return {
          value: null,
          valueFormatted: null
        };
      if (!o)
        return {
          value: m.value,
          valueFormatted: null
        };
      const w = i.formatAndPrefixGroupColValue(m, e, n);
      return {
        value: m.value,
        valueFormatted: w
      };
    }
    if (!e)
      return {
        value: t.key,
        valueFormatted: null
      };
    const c = t.leafGroup && this.colModel.isPivotMode(), d = t.group && t.expanded && !t.footer && !c, u = this.gos.get("groupSuppressBlankHeader") || !t.sibling, h = d && !u, p = this.getValue(e, t, h, s), C = o && !(n && e.colDef.useValueFormatterForExport === !1);
    return {
      value: p,
      valueFormatted: C ? this.formatValue(e, t, p) : null
    };
  }
  getValue(e, t, o = !1, n = "ui") {
    var m;
    if (this.initialised || this.init(), !t)
      return;
    const s = e.getColDef(), i = s.field, r = e.getColId(), l = t.data;
    if (this.hasEditSvc && n === "ui") {
      const w = this.editSvc;
      if (w.isEditing()) {
        const y = w.getCellDataValue({ rowNode: t, column: e }, !0);
        if (y !== void 0)
          return y;
      }
    }
    let a;
    const c = s.showRowGroup;
    if (typeof c == "string" && (((m = this.beans.rowGroupColsSvc) == null ? void 0 : m.getColumnIndex(c)) ?? -1) > t.level)
      return null;
    const d = typeof c != "string" || !t.group, u = t.groupData && r in t.groupData, h = !o && t.aggData && t.aggData[r] !== void 0, p = this.isSsrm && o && !!s.aggFunc, C = this.isSsrm && t.footer && t.field && (s.showRowGroup === !0 || s.showRowGroup === t.field);
    if (this.isTreeData && h)
      a = t.aggData[r];
    else if (this.isTreeData && s.valueGetter)
      a = this.executeValueGetter(s.valueGetter, l, e, t);
    else if (this.isTreeData && i && l)
      a = Pr(l, i, e.isFieldContainsDots());
    else if (u)
      a = t.groupData[r];
    else if (h)
      a = t.aggData[r];
    else if (s.valueGetter && !p) {
      if (!d)
        return a;
      a = this.executeValueGetter(s.valueGetter, l, e, t);
    } else if (C)
      a = Pr(l, t.field, e.isFieldContainsDots());
    else if (i && l && !p) {
      if (!d)
        return a;
      a = Pr(l, i, e.isFieldContainsDots());
    }
    if (this.cellExpressions && typeof a == "string" && a.indexOf("=") === 0) {
      const w = a.substring(1);
      a = this.executeValueGetter(w, l, e, t);
    }
    return a;
  }
  parseValue(e, t, o, n) {
    var r;
    const s = e.getColDef(), i = s.valueParser;
    if (ue(i)) {
      const l = Pe(this.gos, {
        node: t,
        data: t == null ? void 0 : t.data,
        oldValue: n,
        newValue: o,
        colDef: s,
        column: e
      });
      return typeof i == "function" ? i(l) : (r = this.expressionSvc) == null ? void 0 : r.evaluate(i, l);
    }
    return o;
  }
  getDeleteValue(e, t) {
    return ue(e.getColDef().valueParser) ? this.parseValue(e, t, "", this.getValueForDisplay(e, t).value) ?? null : null;
  }
  formatValue(e, t, o, n, s = !0) {
    const { expressionSvc: i } = this.beans;
    let r = null, l;
    const a = e.getColDef();
    if (n ? l = n : s && (l = a.valueFormatter), l) {
      const c = t ? t.data : null, d = Pe(this.gos, {
        value: o,
        node: t,
        data: c,
        colDef: a,
        column: e
      });
      typeof l == "function" ? r = l(d) : r = i ? i.evaluate(l, d) : null;
    } else if (a.refData)
      return a.refData[o] || "";
    return r == null && Array.isArray(o) && (r = o.join(", ")), r;
  }
  /**
   * Sets the value of a GridCell
   * @param rowNode The `RowNode` to be updated
   * @param colKey The `Column` to be updated
   * @param newValue The new value to be set
   * @param eventSource The event source
   * @returns `True` if the value has been updated, otherwise`False`.
   */
  setValue(e, t, o, n) {
    var d, u;
    const s = this.colModel.getColDefCol(t);
    if (!e || !s)
      return !1;
    Xe(e.data) && (e.data = {});
    const { field: i, valueSetter: r } = s.getColDef();
    if (Xe(i) && Xe(r))
      return X(17), !1;
    if (this.dataTypeSvc && !this.dataTypeSvc.checkType(s, o))
      return X(135), !1;
    const l = Pe(this.gos, {
      node: e,
      data: e.data,
      oldValue: this.getValue(s, e, void 0, n),
      newValue: o,
      colDef: s.getColDef(),
      column: s
    });
    l.newValue = o;
    let a;
    if (ue(r) ? typeof r == "function" ? a = r(l) : a = (d = this.expressionSvc) == null ? void 0 : d.evaluate(r, l) : a = this.setValueUsingField(e.data, i, o, s.isFieldContainsDots()), a === void 0 && (a = !0), !a)
      return !1;
    e.resetQuickFilterAggregateText(), (u = this.valueCache) == null || u.onDataChanged();
    const c = this.getValue(s, e);
    return this.dispatchCellValueChangedEvent(e, l, c, n), e.pinnedSibling && this.dispatchCellValueChangedEvent(e.pinnedSibling, l, c, n), !0;
  }
  dispatchCellValueChangedEvent(e, t, o, n) {
    this.eventSvc.dispatchEvent({
      type: "cellValueChanged",
      event: null,
      rowIndex: e.rowIndex,
      rowPinned: e.rowPinned,
      column: t.column,
      colDef: t.colDef,
      data: e.data,
      node: e,
      oldValue: t.oldValue,
      newValue: o,
      value: o,
      source: n
    });
  }
  callColumnCellValueChangedHandler(e) {
    const t = e.colDef.onCellValueChanged;
    typeof t == "function" && this.beans.frameworkOverrides.wrapOutgoing(() => {
      t({
        node: e.node,
        data: e.data,
        oldValue: e.oldValue,
        newValue: e.newValue,
        colDef: e.colDef,
        column: e.column,
        api: e.api,
        context: e.context
      });
    });
  }
  setValueUsingField(e, t, o, n) {
    if (!t)
      return !1;
    let s = !1;
    if (!n)
      s = e[t] === o, s || (e[t] = o);
    else {
      const i = t.split(".");
      let r = e;
      for (; i.length > 0 && r; ) {
        const l = i.shift();
        i.length === 0 ? (s = r[l] === o, s || (r[l] = o)) : r = r[l];
      }
    }
    return !s;
  }
  executeValueGetterWithValueCache(e, t, o, n) {
    const s = o.getColId(), i = this.valueCache.getValue(n, s);
    if (i !== void 0)
      return i;
    const r = this.executeValueGetterWithoutValueCache(e, t, o, n);
    return this.valueCache.setValue(n, s, r), r;
  }
  executeValueGetterWithoutValueCache(e, t, o, n) {
    var r;
    const s = Pe(this.gos, {
      data: t,
      node: n,
      column: o,
      colDef: o.getColDef(),
      getValue: this.getValueCallback.bind(this, n)
    });
    let i;
    return typeof e == "function" ? i = e(s) : i = (r = this.expressionSvc) == null ? void 0 : r.evaluate(e, s), i;
  }
  getValueCallback(e, t) {
    const o = this.colModel.getColDefCol(t);
    return o ? this.getValue(o, e) : null;
  }
  // used by row grouping and pivot, to get key for a row. col can be a pivot col or a row grouping col
  getKeyForNode(e, t) {
    const o = this.getValue(e, t), n = e.getColDef().keyCreator;
    let s = o;
    if (n) {
      const i = Pe(this.gos, {
        value: o,
        colDef: e.getColDef(),
        column: e,
        node: t,
        data: t.data
      });
      s = n(i);
    }
    return typeof s == "string" || s == null || (s = String(s), s === "[object Object]" && X(121)), s;
  }
}, ANe = {
  moduleName: "CommunityCore",
  version: be,
  beans: [
    LZe,
    cOe,
    b$e,
    sDe,
    aNe,
    TBe,
    yZe,
    YZe,
    XIe,
    zGe,
    NGe,
    dNe,
    MNe,
    MZe,
    bZe,
    AZe,
    _$e,
    pNe,
    f$e,
    v$e,
    lGe
  ],
  icons: {
    // icon on select dropdowns (select cell editor, charts tool panels)
    selectOpen: "small-down",
    /** @deprecated v33 */
    smallDown: "small-down",
    /** @deprecated v33 */
    colorPicker: "color-picker",
    /** @deprecated v33 */
    smallUp: "small-up",
    /** @deprecated v33 */
    checkboxChecked: "small-up",
    /** @deprecated v33 */
    checkboxIndeterminate: "checkbox-indeterminate",
    /** @deprecated v33 */
    checkboxUnchecked: "checkbox-unchecked",
    /** @deprecated v33 */
    radioButtonOn: "radio-button-on",
    /** @deprecated v33 */
    radioButtonOff: "radio-button-off",
    /** @deprecated v33 */
    smallLeft: "small-left",
    /** @deprecated v33 */
    smallRight: "small-right"
  },
  apiFunctions: {
    getGridId: dOe,
    destroy: uOe,
    isDestroyed: hOe,
    getGridOption: gOe,
    setGridOption: pOe,
    updateGridOptions: qb,
    isModuleRegistered: fOe
  },
  dependsOn: [
    h$e,
    tc,
    mBe,
    xy,
    nGe,
    DBe,
    sGe,
    lNe,
    SNe,
    rGe,
    GGe,
    KGe,
    YGe,
    cGe,
    w$e,
    g$e,
    _Ne,
    OBe,
    XGe
  ]
}, My = {
  AdvancedFilter: 1,
  AllEnterprise: 1,
  BatchEdit: 1,
  CellSelection: 1,
  Clipboard: 1,
  ColumnMenu: 1,
  ColumnsToolPanel: 1,
  ContextMenu: 1,
  ExcelExport: 1,
  FiltersToolPanel: 1,
  Find: 1,
  GridCharts: 1,
  IntegratedCharts: 1,
  GroupFilter: 1,
  MasterDetail: 1,
  Menu: 1,
  MultiFilter: 1,
  NewFiltersToolPanel: 1,
  Pivot: 1,
  RangeSelection: 1,
  RichSelect: 1,
  RowNumbers: 1,
  RowGrouping: 1,
  RowGroupingPanel: 1,
  ServerSideRowModelApi: 1,
  ServerSideRowModel: 1,
  SetFilter: 1,
  SideBar: 1,
  Sparklines: 1,
  StatusBar: 1,
  TreeData: 1,
  ViewportRowModel: 1
}, b0 = [
  "TextFilter",
  "NumberFilter",
  "DateFilter",
  "SetFilter",
  "MultiFilter",
  "GroupFilter",
  "CustomFilter"
], LNe = {
  EditCore: [
    "TextEditor",
    "NumberEditor",
    "DateEditor",
    "CheckboxEditor",
    "LargeTextEditor",
    "SelectEditor",
    "RichSelect",
    "CustomEditor"
  ],
  CheckboxCellRenderer: ["AllCommunity"],
  ClientSideRowModelHierarchy: ["RowGrouping", "Pivot", "TreeData"],
  ColumnFilter: b0,
  ColumnGroupHeaderComp: ["AllCommunity"],
  ColumnGroup: ["AllCommunity"],
  ColumnHeaderComp: ["AllCommunity"],
  ColumnMove: ["AllCommunity"],
  ColumnResize: ["AllCommunity"],
  CommunityCore: ["AllCommunity"],
  CsrmSsrmSharedApi: ["ClientSideRowModelApi", "ServerSideRowModelApi"],
  RowModelSharedApi: ["ClientSideRowModelApi", "ServerSideRowModelApi"],
  EnterpriseCore: ["AllEnterprise"],
  FilterCore: [...b0, "QuickFilter", "ExternalFilter", "AdvancedFilter"],
  GroupCellRenderer: ["RowGrouping", "Pivot", "TreeData", "MasterDetail", "ServerSideRowModel"],
  KeyboardNavigation: ["AllCommunity"],
  LoadingCellRenderer: ["ServerSideRowModel"],
  MenuCore: ["ColumnMenu", "ContextMenu"],
  MenuItem: ["ColumnMenu", "ContextMenu", "MultiFilter", "IntegratedCharts", "ColumnsToolPanel"],
  Overlay: ["AllCommunity"],
  PinnedColumn: ["AllCommunity"],
  SharedAggregation: ["RowGrouping", "Pivot", "TreeData", "ServerSideRowModel"],
  SharedDragAndDrop: ["AllCommunity"],
  SharedMasterDetail: ["MasterDetail", "ServerSideRowModel"],
  SharedMenu: [...b0, "ColumnMenu", "ContextMenu"],
  SharedPivot: ["Pivot", "ServerSideRowModel"],
  SharedRowGrouping: ["RowGrouping", "ServerSideRowModel"],
  SharedRowSelection: ["RowSelection", "ServerSideRowModel"],
  SkeletonCellRenderer: ["ServerSideRowModel"],
  Sort: ["AllCommunity"],
  SsrmInfiniteSharedApi: ["InfiniteRowModel", "ServerSideRowModelApi"],
  SharedTreeData: ["TreeData", "ServerSideRowModel"]
}, ENe = {
  InfiniteRowModel: "infinite",
  ClientSideRowModelApi: "clientSide",
  ClientSideRowModel: "clientSide",
  ServerSideRowModelApi: "serverSide",
  ServerSideRowModel: "serverSide",
  ViewportRowModel: "viewport"
};
function PNe(e, t) {
  const o = [];
  return (Array.isArray(e) ? e : [e]).forEach((n) => {
    const s = LNe[n];
    s ? s.forEach((i) => {
      const r = ENe[i];
      (!r || r === t) && o.push(i);
    }) : o.push(n);
  }), o;
}
var Ay = () => `No AG Grid modules are registered! It is recommended to start with all Community features via the AllCommunityModule:
                    
    import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community';
    
    ModuleRegistry.registerModules([ AllCommunityModule ]);
    `, RNe = (e) => {
  const t = e.map(
    (n) => `import { ${Fr(n)} } from '${My[n] ? "ag-grid-enterprise" : "ag-grid-community"}';`
  );
  return e.some((n) => n === "IntegratedCharts" || n === "Sparklines") && t.push("import { AgChartsEnterpriseModule } from 'ag-charts-enterprise';"), `import { ModuleRegistry } from 'ag-grid-community'; 
${t.join(` 
`)} 

ModuleRegistry.registerModules([ ${e.map((n) => Fr(n, !0)).join(", ")} ]); 

For more info see: ${Li}/modules/`;
};
function Fr(e, t = !1) {
  return t && (e === "IntegratedCharts" || e === "Sparklines") ? `${e}Module.with(AgChartsEnterpriseModule)` : `${e}Module`;
}
function FNe(e, t) {
  const o = t.filter((i) => i === "IntegratedCharts" || i === "Sparklines");
  let n = "";
  return !(globalThis == null ? void 0 : globalThis.agCharts) && o.length > 0 ? n = `Unable to use ${e} as either the ag-charts-community or ag-charts-enterprise script needs to be included alongside ag-grid-enterprise.
` : t.some((i) => My[i]) && (n = n + `Unable to use ${e} as that requires the ag-grid-enterprise script to be included.
`), n;
}
function Ly({
  moduleName: e,
  rowModelType: t
}) {
  return `To use the ${e}Module you must set the gridOption "rowModelType='${t}'"`;
}
var yu = ({
  reasonOrId: e,
  moduleName: t,
  gridScoped: o,
  gridId: n,
  rowModelType: s,
  additionalText: i,
  isUmd: r
}) => {
  const l = PNe(t, s), a = typeof e == "string" ? e : kNe[e];
  if (r)
    return FNe(a, l);
  const c = l.filter((h) => h === "IntegratedCharts" || h === "Sparklines"), d = c.length > 0 ? `${c.map((h) => Fr(h)).join()} must be initialised with an AG Charts module. One of 'AgChartsCommunityModule' / 'AgChartsEnterpriseModule'.` : "";
  return `${`Unable to use ${a} as ${l.length > 1 ? "one of " + l.map((h) => Fr(h)).join(", ") : Fr(l[0])} is not registered${o ? " for gridId: " + n : ""}. ${d} Check if you have registered the module:
`}
${RNe(l)}` + (i ? ` 

${i}` : "");
}, _u = (e) => `${e} must be initialised with an AG Charts module. One of 'AgChartsCommunityModule' / 'AgChartsEnterpriseModule'.

import { AgChartsEnterpriseModule } from 'ag-charts-enterprise';
import { ModuleRegistry } from 'ag-grid-community';
import { ${e} } from 'ag-grid-enterprise';
    
ModuleRegistry.registerModules([${e}.with(AgChartsEnterpriseModule)]);
    `, TNe = (e) => `AG Grid: Unable to use the Clipboard API (navigator.clipboard.${e}()). The reason why it could not be used has been logged in the previous line. For this reason the grid has defaulted to using a workaround which doesn't perform as well. Either fix why Clipboard API is blocked, OR stop this message from appearing by setting grid property suppressClipboardApi=true (which will default the grid to using the workaround rather than the API.`, INe = {
  1: () => "`rowData` must be an array",
  2: ({ nodeId: e }) => `Duplicate node id '${e}' detected from getRowId callback, this could cause issues in your grid.`,
  3: () => "Calling gridApi.resetRowHeights() makes no sense when using Auto Row Height.",
  4: ({ id: e }) => `Could not find row id=${e}, data item was not found for this id`,
  5: ({ data: e }) => [
    "Could not find data item as object was not found.",
    e,
    " Consider using getRowId to help the Grid find matching row data"
  ],
  6: () => "'groupHideOpenParents' only works when specifying specific columns for 'colDef.showRowGroup'",
  7: () => "Pivoting is not supported with aligned grids as it may produce different columns in each grid.",
  8: ({ key: e }) => `Unknown key for navigation ${e}`,
  9: ({ variable: e }) => `No value for ${e == null ? void 0 : e.cssName}. This usually means that the grid has been initialised before styles have been loaded. The default value of ${e == null ? void 0 : e.defaultValue} will be used and updated when styles load.`,
  10: ({ eventType: e }) => `As of v33, the '${e}' event is deprecated. Use the global 'modelUpdated' event to determine when row children have changed.`,
  11: () => "No gridOptions provided to createGrid",
  12: ({ colKey: e }) => ["column ", e, " not found"],
  13: () => "Could not find rowIndex, this means tasks are being executed on a rowNode that has been removed from the grid.",
  14: ({ groupPrefix: e }) => `Row IDs cannot start with ${e}, this is a reserved prefix for AG Grid's row grouping feature.`,
  15: ({ expression: e }) => ["value should be either a string or a function", e],
  16: ({ expression: e, params: t, e: o }) => [
    "Processing of the expression failed",
    "Expression = ",
    e,
    "Params = ",
    t,
    "Exception = ",
    o
  ],
  17: () => "you need either field or valueSetter set on colDef for editing to work",
  18: () => "alignedGrids contains an undefined option.",
  19: () => "alignedGrids - No api found on the linked grid.",
  20: () => `You may want to configure via a callback to avoid setup race conditions:
                     "alignedGrids: () => [linkedGrid]"`,
  21: () => "pivoting is not supported with aligned grids. You can only use one of these features at a time in a grid.",
  22: ({ key: e }) => `${e} is an initial property and cannot be updated.`,
  23: () => "The return of `getRowHeight` cannot be zero. If the intention is to hide rows, use a filter instead.",
  24: () => "row height must be a number if not using standard row model",
  25: ({ id: e }) => ["The getRowId callback must return a string. The ID ", e, " is being cast to a string."],
  26: ({ fnName: e, preDestroyLink: t }) => `Grid API function ${e}() cannot be called as the grid has been destroyed.
 Either clear local references to the grid api, when it is destroyed, or check gridApi.isDestroyed() to avoid calling methods against a destroyed grid.
 To run logic when the grid is about to be destroyed use the gridPreDestroy event. See: ${t}`,
  27: ({ fnName: e, module: t }) => `API function '${e}' not registered to module '${t}'`,
  28: () => "setRowCount cannot be used while using row grouping.",
  29: () => "tried to call sizeColumnsToFit() but the grid is coming back with zero width, maybe the grid is not visible yet on the screen?",
  30: ({ toIndex: e }) => [
    "tried to insert columns in invalid location, toIndex = ",
    e,
    "remember that you should not count the moving columns when calculating the new index"
  ],
  31: () => "infinite loop in resizeColumnSets",
  32: () => "applyColumnState() - the state attribute should be an array, however an array was not found. Please provide an array of items (one for each col you want to change) for state.",
  33: () => "stateItem.aggFunc must be a string. if using your own aggregation functions, register the functions first before using them in get/set state. This is because it is intended for the column state to be stored and retrieved as simple JSON.",
  34: ({ key: e }) => `the column type '${e}' is a default column type and cannot be overridden.`,
  35: () => "Column type definitions 'columnTypes' with a 'type' attribute are not supported because a column type cannot refer to another column type. Only column definitions 'columnDefs' can use the 'type' attribute to refer to a column type.",
  36: ({ t: e }) => "colDef.type '" + e + "' does not correspond to defined gridOptions.columnTypes",
  37: () => "Changing the column pinning status is not allowed with domLayout='print'",
  38: ({ iconName: e }) => `provided icon '${e}' needs to be a string or a function`,
  39: () => "Applying column order broke a group where columns should be married together. Applying new order has been discarded.",
  40: ({ e, method: t }) => `${e}
${TNe(t)}`,
  41: () => "Browser did not allow document.execCommand('copy'). Ensure 'api.copySelectedRowsToClipboard() is invoked via a user event, i.e. button click, otherwise the browser will prevent it for security reasons.",
  42: () => "Browser does not support document.execCommand('copy') for clipboard operations",
  43: ({ iconName: e }) => `As of v33, icon '${e}' is deprecated. Use the icon CSS name instead.`,
  44: () => 'Data type definition hierarchies (via the "extendsDataType" property) cannot contain circular references.',
  45: ({ parentCellDataType: e }) => `The data type definition ${e} does not exist.`,
  46: () => 'The "baseDataType" property of a data type definition must match that of its parent.',
  47: ({ cellDataType: e }) => `Missing data type definition - "${e}"`,
  48: ({ property: e }) => `Cell data type is "object" but no Value ${e} has been provided. Please either provide an object data type definition with a Value ${e}, or set "colDef.value${e}"`,
  49: ({ methodName: e }) => `Framework component is missing the method ${e}()`,
  50: ({ compName: e }) => `Could not find component ${e}, did you forget to configure this component?`,
  51: () => "Export cancelled. Export is not allowed as per your configuration.",
  52: () => "There is no `window` associated with the current `document`",
  53: () => "unknown value type during csv conversion",
  54: () => "Could not find document body, it is needed for drag and drop and context menu.",
  55: () => "addRowDropZone - A container target needs to be provided",
  56: () => "addRowDropZone - target already exists in the list of DropZones. Use `removeRowDropZone` before adding it again.",
  57: () => "unable to show popup filter, filter instantiation failed",
  58: () => "no values found for select cellEditor",
  59: () => "cannot select pinned rows",
  60: () => "cannot select node until it has finished loading",
  61: () => "since version v32.2.0, rowNode.isFullWidthCell() has been deprecated. Instead check `rowNode.detail` followed by the user provided `isFullWidthRow` grid option.",
  62: ({ colId: e }) => `setFilterModel() - no column found for colId: ${e}`,
  63: ({ colId: e }) => `setFilterModel() - unable to fully apply model, filtering disabled for colId: ${e}`,
  64: ({ colId: e }) => `setFilterModel() - unable to fully apply model, unable to create filter for colId: ${e}`,
  65: () => "filter missing setModel method, which is needed for setFilterModel",
  66: () => "filter API missing getModel method, which is needed for getFilterModel",
  67: () => "Filter is missing isFilterActive() method",
  68: () => "Column Filter API methods have been disabled as Advanced Filters are enabled.",
  69: ({ guiFromFilter: e }) => `getGui method from filter returned ${e}; it should be a DOM element.`,
  70: ({ newFilter: e }) => `Grid option quickFilterText only supports string inputs, received: ${typeof e}`,
  71: () => "debounceMs is ignored when apply button is present",
  72: ({ keys: e }) => ["ignoring FilterOptionDef as it doesn't contain one of ", e],
  73: () => "invalid FilterOptionDef supplied as it doesn't contain a 'displayKey'",
  74: () => "no filter options for filter",
  75: () => "Unknown button type specified",
  76: ({ filterModelType: e }) => [
    'Unexpected type of filter "',
    e,
    '", it looks like the filter was configured with incorrect Filter Options'
  ],
  77: () => "Filter model is missing 'conditions'",
  78: () => 'Filter Model contains more conditions than "filterParams.maxNumConditions". Additional conditions have been ignored.',
  79: () => '"filterParams.maxNumConditions" must be greater than or equal to zero.',
  80: () => '"filterParams.numAlwaysVisibleConditions" must be greater than or equal to zero.',
  81: () => '"filterParams.numAlwaysVisibleConditions" cannot be greater than "filterParams.maxNumConditions".',
  82: ({ param: e }) => `DateFilter ${e} is not a number`,
  83: () => "DateFilter minValidYear should be <= maxValidYear",
  84: () => "DateFilter minValidDate should be <= maxValidDate",
  85: () => "DateFilter should not have both minValidDate and minValidYear parameters set at the same time! minValidYear will be ignored.",
  86: () => "DateFilter should not have both maxValidDate and maxValidYear parameters set at the same time! maxValidYear will be ignored.",
  87: () => "DateFilter parameter minValidDate should always be lower than or equal to parameter maxValidDate.",
  88: ({ index: e }) => `Invalid row index for ensureIndexVisible: ${e}`,
  89: () => "A template was provided for Header Group Comp - templates are only supported for Header Comps (not groups)",
  90: () => "datasource is missing getRows method",
  91: () => "Filter is missing method doesFilterPass",
  92: () => "AnimationFrameService called but animation frames are off",
  93: () => "cannot add multiple ranges when `cellSelection.suppressMultiRanges = true`",
  94: ({
    paginationPageSizeOption: e,
    pageSizeSet: t,
    pageSizesSet: o,
    pageSizeOptions: n
  }) => `'paginationPageSize=${e}'${t ? "" : " (default value)"}, but ${e} is not included in${o ? "" : " the default"} paginationPageSizeSelector=[${n == null ? void 0 : n.join(", ")}].`,
  95: ({
    paginationPageSizeOption: e,
    paginationPageSizeSelector: t
  }) => `Either set '${t}' to an array that includes ${e} or to 'false' to disable the page size selector.`,
  96: ({ id: e, data: t }) => [
    "Duplicate ID",
    e,
    "found for pinned row with data",
    t,
    "When `getRowId` is defined, it must return unique IDs for all pinned rows. Use the `rowPinned` parameter."
  ],
  97: ({ colId: e }) => `cellEditor for column ${e} is missing getGui() method`,
  98: () => "popup cellEditor does not work with fullRowEdit - you cannot use them both - either turn off fullRowEdit, or stop using popup editors.",
  99: () => "Since v32, `api.hideOverlay()` does not hide the loading overlay when `loading=true`. Set `loading=false` instead.",
  // 100: ({ rowModelType }: { rowModelType: RowModelType }) =>
  //     `selectAll only available when rowModelType='clientSide', ie not ${rowModelType}` as const,
  101: ({
    propertyName: e,
    componentName: t,
    agGridDefaults: o,
    jsComps: n
  }) => {
    const s = [], i = [
      // Don't include the old names / internals in potential suggestions
      ...Object.keys(o ?? []).filter(
        (l) => !["agCellEditor", "agGroupRowRenderer", "agSortIndicator"].includes(l)
      ),
      ...Object.keys(n ?? []).filter((l) => !!n[l])
    ], r = Yr({
      inputValue: t,
      allSuggestions: i,
      hideIrrelevant: !0,
      filterByPercentageOfBestMatch: 0.8
    }).values;
    return s.push(
      `Could not find '${t}' component. It was configured as "${e}: '${t}'" but it wasn't found in the list of registered components.
`
    ), r.length > 0 && s.push(`         Did you mean: [${r.slice(0, 3)}]?
`), s.push("If using a custom component check it has been registered correctly."), s;
  },
  102: () => "selectAll: 'filtered' only works when gridOptions.rowModelType='clientSide'",
  103: () => "Invalid selection state. When using client-side row model, the state must conform to `string[]`.",
  104: ({ value: e, param: t }) => `Numeric value ${e} passed to ${t} param will be interpreted as ${e} seconds. If this is intentional use "${e}s" to silence this warning.`,
  105: ({ e }) => ["chart rendering failed", e],
  106: () => `Theming API and Legacy Themes are both used in the same page. A Theming API theme has been provided to the 'theme' grid option, but the file (ag-grid.css) is also included and will cause styling issues. Remove ag-grid.css from the page. See the migration guide: ${Li}/theming-migration/`,
  107: ({ key: e, value: t }) => `Invalid value for theme param ${e} - ${t}`,
  108: ({ e }) => ["chart update failed", e],
  109: ({ inputValue: e, allSuggestions: t }) => {
    const o = Yr({
      inputValue: e,
      allSuggestions: t,
      hideIrrelevant: !0,
      filterByPercentageOfBestMatch: 0.8
    }).values;
    return [
      `Could not find '${e}' aggregate function. It was configured as "aggFunc: '${e}'" but it wasn't found in the list of registered aggregations.`,
      o.length > 0 ? `         Did you mean: [${o.slice(0, 3)}]?` : "",
      "If using a custom aggregation function check it has been registered correctly."
    ].join(`
`);
  },
  110: () => "groupHideOpenParents only works when specifying specific columns for colDef.showRowGroup",
  111: () => "Invalid selection state. When `groupSelects` is enabled, the state must conform to `IServerSideGroupSelectionState`.",
  113: () => "Set Filter cannot initialise because you are using a row model that does not contain all rows in the browser. Either use a different filter type, or configure Set Filter such that you provide it with values",
  114: ({ component: e }) => `Could not find component with name of ${e}. Is it in Vue.components?`,
  // 115: () => 'The provided selection state should be an object.' as const,
  116: () => "Invalid selection state. The state must conform to `IServerSideSelectionState`.",
  117: () => "selectAll must be of boolean type.",
  118: () => "Infinite scrolling must be enabled in order to set the row count.",
  119: () => "Unable to instantiate filter",
  120: () => "MultiFloatingFilterComp expects MultiFilter as its parent",
  121: () => "a column you are grouping or pivoting by has objects as values. If you want to group by complex objects then either a) use a colDef.keyCreator (see AG Grid docs) or b) to toString() on the object to return a key",
  122: () => "could not find the document, document is empty",
  123: () => "Advanced Filter is only supported with the Client-Side Row Model or Server-Side Row Model.",
  124: () => "No active charts to update.",
  125: ({ chartId: e }) => `Unable to update chart. No active chart found with ID: ${e}.`,
  126: () => "unable to restore chart as no chart model is provided",
  127: ({ allRange: e }) => `unable to create chart as ${e ? "there are no columns in the grid" : "no range is selected"}.`,
  128: ({ feature: e }) => `${e} is only available if using 'multiRow' selection mode.`,
  129: ({ feature: e, rowModel: t }) => `${e} is only available if using 'clientSide' or 'serverSide' rowModelType, you are using ${t}.`,
  130: () => 'cannot multi select unless selection mode is "multiRow"',
  // 131: () => 'cannot range select while selecting multiple rows' as const,
  132: () => "Row selection features are not available unless `rowSelection` is enabled.",
  133: ({ iconName: e }) => `icon '${e}' function should return back a string or a dom object`,
  134: ({ iconName: e }) => `Did not find icon '${e}'`,
  135: () => "Data type of the new value does not match the cell data type of the column",
  136: () => "Unable to update chart as the 'type' is missing. It must be either 'rangeChartUpdate', 'pivotChartUpdate', or 'crossFilterChartUpdate'.",
  137: ({ type: e, currentChartType: t }) => `Unable to update chart as a '${e}' update type is not permitted on a ${t}.`,
  138: ({ chartType: e }) => `invalid chart type supplied: ${e}`,
  139: ({ customThemeName: e }) => `a custom chart theme with the name ${e} has been supplied but not added to the 'chartThemes' list`,
  140: ({ name: e }) => `no stock theme exists with the name '${e}' and no custom chart theme with that name was supplied to 'customChartThemes'`,
  141: () => "cross filtering with row grouping is not supported.",
  142: () => "cross filtering is only supported in the client side row model.",
  143: ({ panel: e }) => `'${e}' is not a valid Chart Tool Panel name`,
  144: ({ type: e }) => `Invalid charts data panel group name supplied: '${e}'`,
  145: ({ group: e }) => `As of v32, only one charts customize panel group can be expanded at a time. '${e}' will not be expanded.`,
  146: ({ comp: e }) => `Unable to instantiate component '${e}' as its module hasn't been loaded. Add 'ValidationModule' to see which module is required.`,
  147: ({ group: e }) => `Invalid charts customize panel group name supplied: '${e}'`,
  148: ({ group: e }) => `invalid chartGroupsDef config '${e}'`,
  149: ({ group: e, chartType: t }) => `invalid chartGroupsDef config '${e}.${t}'`,
  150: () => "'seriesChartTypes' are required when the 'customCombo' chart type is specified.",
  151: ({ chartType: e }) => `invalid chartType '${e}' supplied in 'seriesChartTypes', converting to 'line' instead.`,
  152: ({ colId: e }) => `no 'seriesChartType' found for colId = '${e}', defaulting to 'line'.`,
  153: ({ chartDataType: e }) => `unexpected chartDataType value '${e}' supplied, instead use 'category', 'series' or 'excluded'`,
  154: ({ colId: e }) => `cross filtering requires a 'agSetColumnFilter' or 'agMultiColumnFilter' to be defined on the column with id: ${e}`,
  155: ({ option: e }) => `'${e}' is not a valid Chart Toolbar Option`,
  156: ({ panel: e }) => `Invalid panel in chartToolPanelsDef.panels: '${e}'`,
  157: ({ unrecognisedGroupIds: e }) => ["unable to find group(s) for supplied groupIds:", e],
  158: () => "can not expand a column item that does not represent a column group header",
  159: () => "Invalid params supplied to createExcelFileForExcel() - `ExcelExportParams.data` is empty.",
  160: () => "Export cancelled. Export is not allowed as per your configuration.",
  161: () => "The Excel Exporter is currently on Multi Sheet mode. End that operation by calling 'api.getMultipleSheetAsExcel()' or 'api.exportMultipleSheetsAsExcel()'",
  162: ({ id: e, dataType: t }) => `Unrecognized data type for excel export [${e}.dataType=${t}]`,
  163: ({ featureName: e }) => `Excel table export does not work with ${e}. The exported Excel file will not contain any Excel tables.
 Please turn off ${e} to enable Excel table exports.`,
  164: () => "Unable to add data table to Excel sheet: A table already exists.",
  165: () => "Unable to add data table to Excel sheet: Missing required parameters.",
  166: ({ unrecognisedGroupIds: e }) => ["unable to find groups for these supplied groupIds:", e],
  167: ({ unrecognisedColIds: e }) => ["unable to find columns for these supplied colIds:", e],
  168: () => "detailCellRendererParams.template should be function or string",
  169: () => 'Reference to eDetailGrid was missing from the details template. Please add data-ref="eDetailGrid" to the template.',
  170: ({ providedStrategy: e }) => `invalid cellRendererParams.refreshStrategy = ${e} supplied, defaulting to refreshStrategy = 'rows'.`,
  171: () => "could not find detail grid options for master detail, please set gridOptions.detailCellRendererParams.detailGridOptions",
  172: () => "could not find getDetailRowData for master / detail, please set gridOptions.detailCellRendererParams.getDetailRowData",
  173: ({ group: e }) => `invalid chartGroupsDef config '${e}'`,
  174: ({ group: e, chartType: t }) => `invalid chartGroupsDef config '${e}.${t}'`,
  175: ({ menuTabName: e, itemsToConsider: t }) => [
    `Trying to render an invalid menu item '${e}'. Check that your 'menuTabs' contains one of `,
    t
  ],
  176: ({ key: e }) => `unknown menu item type ${e}`,
  177: () => "valid values for cellSelection.handle.direction are 'x', 'y' and 'xy'. Default to 'xy'.",
  178: ({ colId: e }) => `column ${e} is not visible`,
  179: () => "totalValueGetter should be either a function or a string (expression)",
  180: () => "agRichSelectCellEditor requires cellEditorParams.values to be set",
  181: () => "agRichSelectCellEditor cannot have `multiSelect` and `allowTyping` set to `true`. AllowTyping has been turned off.",
  182: () => 'you cannot mix groupDisplayType = "multipleColumns" with treeData, only one column can be used to display groups when doing tree data',
  183: () => "Group Column Filter only works on group columns. Please use a different filter.",
  184: ({ parentGroupData: e, childNodeData: t }) => ["duplicate group keys for row data, keys should be unique", [e, t]],
  185: ({ data: e }) => ["getDataPath() should not return an empty path", [e]],
  186: ({
    rowId: e,
    rowData: t,
    duplicateRowsData: o
  }) => [
    "duplicate group keys for row data, keys should be unique",
    e,
    t,
    ...o ?? []
  ],
  187: ({ rowId: e, firstData: t, secondData: o }) => [
    `Duplicate node id ${e}. Row IDs are provided via the getRowId() callback. Please modify the getRowId() callback code to provide unique row id values.`,
    "first instance",
    t,
    "second instance",
    o
  ],
  188: (e) => `getRowId callback must be provided for Server Side Row Model ${(e == null ? void 0 : e.feature) || "selection"} to work correctly.`,
  189: ({ startRow: e }) => `invalid value ${e} for startRow, the value should be >= 0`,
  190: ({ rowGroupId: e, data: t }) => [
    "null and undefined values are not allowed for server side row model keys",
    e ? `column = ${e}` : "",
    "data is ",
    t
  ],
  // 191: () => `cannot multi select unless selection mode is 'multiRow'` as const,
  // 192: () => `cannot use range selection when multi selecting rows` as const,
  // 193: () => "cannot multi select unless selection mode is 'multiRow'" as const,
  194: ({ method: e }) => `calling gridApi.${e}() is only possible when using rowModelType=\`clientSide\`.`,
  195: ({ justCurrentPage: e }) => `selecting just ${e ? "current page" : "filtered"} only works when gridOptions.rowModelType='clientSide'`,
  196: ({ key: e }) => `Provided ids must be of string type. Invalid id provided: ${e}`,
  197: () => "`toggledNodes` must be an array of string ids.",
  // 198: () => `cannot multi select unless selection mode is 'multiRow'` as const,
  199: () => "getSelectedNodes and getSelectedRows functions cannot be used with select all functionality with the server-side row model. Use `api.getServerSideSelectionState()` instead.",
  200: yu,
  201: ({ rowModelType: e }) => `Could not find row model for rowModelType = ${e}`,
  202: () => "`getSelectedNodes` and `getSelectedRows` functions cannot be used with `groupSelectsChildren` and the server-side row model. Use `api.getServerSideSelectionState()` instead.",
  203: () => "Server Side Row Model does not support Dynamic Row Height and Cache Purging. Either a) remove getRowHeight() callback or b) remove maxBlocksInCache property. Purging has been disabled.",
  204: () => "Server Side Row Model does not support Auto Row Height and Cache Purging. Either a) remove colDef.autoHeight or b) remove maxBlocksInCache property. Purging has been disabled.",
  205: ({ duplicateIdText: e }) => `Unable to display rows as duplicate row ids (${e}) were returned by the getRowId callback. Please modify the getRowId callback to provide unique ids.`,
  206: () => "getRowId callback must be implemented for transactions to work. Transaction was ignored.",
  207: () => 'The Set Filter Parameter "defaultToNothingSelected" value was ignored because it does not work when "excelMode" is used.',
  208: () => "Set Filter Value Formatter must return string values. Please ensure the Set Filter Value Formatter returns string values for complex objects.",
  209: () => `Set Filter Key Creator is returning null for provided values and provided values are primitives. Please provide complex objects. See ${Li}/filter-set-filter-list/#filter-value-types`,
  210: () => "Set Filter has a Key Creator, but provided values are primitives. Did you mean to provide complex objects?",
  211: () => "property treeList=true for Set Filter params, but you did not provide a treeListPathGetter or values of type Date.",
  212: () => "please review all your toolPanel components, it seems like at least one of them doesn't have an id",
  213: () => "Advanced Filter does not work with Filters Tool Panel. Filters Tool Panel has been disabled.",
  214: ({ key: e }) => `unable to lookup Tool Panel as invalid key supplied: ${e}`,
  215: ({ key: e, defaultByKey: t }) => `the key ${e} is not a valid key for specifying a tool panel, valid keys are: ${Object.keys(t ?? {}).join(",")}`,
  216: ({ name: e }) => `Missing component for '${e}'`,
  217: ({ invalidColIds: e }) => ["unable to find grid columns for the supplied colDef(s):", e],
  218: ({ property: e, defaultOffset: t }) => `${e} must be a number, the value you provided is not a valid number. Using the default of ${t}px.`,
  219: ({ property: e }) => `Property ${e} does not exist on the target object.`,
  220: ({ lineDash: e }) => `'${e}' is not a valid 'lineDash' option.`,
  221: () => "agAggregationComponent should only be used with the client and server side row model.",
  222: () => "agFilteredRowCountComponent should only be used with the client side row model.",
  223: () => "agSelectedRowCountComponent should only be used with the client and server side row model.",
  224: () => "agTotalAndFilteredRowCountComponent should only be used with the client side row model.",
  225: () => "agTotalRowCountComponent should only be used with the client side row model.",
  226: () => "viewport is missing init method.",
  227: () => "menu item icon must be DOM node or string",
  228: ({ menuItemOrString: e }) => `unrecognised menu item ${e}`,
  229: ({ index: e }) => ["invalid row index for ensureIndexVisible: ", e],
  230: () => "detailCellRendererParams.template is not supported by AG Grid React. To change the template, provide a Custom Detail Cell Renderer. See https://www.ag-grid.com/react-data-grid/master-detail-custom-detail/",
  // @deprecated v32 mark for removal as part of v32 deprecated features
  231: () => "As of v32, using custom components with `reactiveCustomComponents = false` is deprecated.",
  232: () => "Using both rowData and v-model. rowData will be ignored.",
  233: ({ methodName: e }) => `Framework component is missing the method ${e}()`,
  234: () => 'Group Column Filter does not work with the colDef property "field". This property will be ignored.',
  235: () => 'Group Column Filter does not work with the colDef property "filterValueGetter". This property will be ignored.',
  236: () => 'Group Column Filter does not work with the colDef property "filterParams". This property will be ignored.',
  237: () => "Group Column Filter does not work with Tree Data enabled. Please disable Tree Data, or use a different filter.",
  238: () => "setRowCount can only accept a positive row count.",
  239: () => 'Theming API and CSS File Themes are both used in the same page. In v33 we released the Theming API as the new default method of styling the grid. See the migration docs https://www.ag-grid.com/react-data-grid/theming-migration/. Because no value was provided to the `theme` grid option it defaulted to themeQuartz. But the file (ag-grid.css) is also included and will cause styling issues. Either pass the string "legacy" to the theme grid option to use v32 style themes, or remove ag-grid.css from the page to use Theming API.',
  240: ({ theme: e }) => `theme grid option must be a Theming API theme object or the string "legacy", received: ${e}`,
  // 241: () => `cannot select multiple rows when rowSelection.mode is set to 'singleRow'` as const,
  // 242: () => 'cannot select multiple rows when using rangeSelect' as const,
  243: () => "Failed to deserialize state - each provided state object must be an object.",
  244: () => "Failed to deserialize state - `selectAllChildren` must be a boolean value or undefined.",
  245: () => "Failed to deserialize state - `toggledNodes` must be an array.",
  246: () => "Failed to deserialize state - Every `toggledNode` requires an associated string id.",
  247: () => `Row selection state could not be parsed due to invalid data. Ensure all child state has toggledNodes or does not conform with the parent rule. 
Please rebuild the selection state and reapply it.`,
  248: () => "SetFloatingFilter expects SetFilter as its parent",
  249: () => "Must supply a Value Formatter in Set Filter params when using a Key Creator",
  250: () => "Must supply a Key Creator in Set Filter params when `treeList = true` on a group column, and Tree Data or Row Grouping is enabled.",
  251: ({ chartType: e }) => `AG Grid: Unable to create chart as an invalid chartType = '${e}' was supplied.`,
  252: () => `cannot get grid to draw rows when it is in the middle of drawing rows. 
Your code probably called a grid API method while the grid was in the render stage. 
To overcome this, put the API call into a timeout, e.g. instead of api.redrawRows(), call setTimeout(function() { api.redrawRows(); }, 0). 
To see what part of your code that caused the refresh check this stacktrace.`,
  253: ({ version: e }) => ["Illegal version string: ", e],
  254: () => "Cannot create chart: no chart themes available.",
  255: ({ point: e }) => `Lone surrogate U+${e == null ? void 0 : e.toString(16).toUpperCase()} is not a scalar value`,
  256: () => "Unable to initialise. See validation error, or load ValidationModule if missing.",
  257: () => _u("IntegratedChartsModule"),
  258: () => _u("SparklinesModule"),
  259: ({ part: e }) => `the argument to theme.withPart must be a Theming API part object, received: ${e}`,
  260: ({
    propName: e,
    compName: t,
    gridScoped: o,
    gridId: n,
    rowModelType: s
  }) => yu({
    reasonOrId: `AG Grid '${e}' component: ${t}`,
    moduleName: Fi[t],
    gridId: n,
    gridScoped: o,
    rowModelType: s
  }),
  261: () => "As of v33, `column.isHovered()` is deprecated. Use `api.isColumnHovered(column)` instead.",
  262: () => 'As of v33, icon key "smallDown" is deprecated. Use "advancedFilterBuilderSelect" for Advanced Filter Builder dropdown, "selectOpen" for Select cell editor and dropdowns (e.g. Integrated Charts menu), "richSelectOpen" for Rich Select cell editor.',
  263: () => 'As of v33, icon key "smallLeft" is deprecated. Use "panelDelimiterRtl" for Row Group Panel / Pivot Panel, "subMenuOpenRtl" for sub-menus.',
  264: () => 'As of v33, icon key "smallRight" is deprecated. Use "panelDelimiter" for Row Group Panel / Pivot Panel, "subMenuOpen" for sub-menus.',
  265: ({ colId: e }) => `Unable to infer chart data type for column '${e}' if first data entry is null. Please specify "chartDataType", or a "cellDataType" in the column definition. For more information, see ${Li}/integrated-charts-range-chart#coldefchartdatatype .`,
  266: () => 'As of v33.1, using "keyCreator" with the Rich Select Editor has been deprecated. It now requires the "formatValue" callback to convert complex data to strings.',
  267: () => "Detail grids can not use a different theme to the master grid, the `theme` detail grid option will be ignored.",
  268: () => "Transactions aren't supported with tree data when using treeDataChildrenField",
  269: () => "When `masterSelects: 'detail'`, detail grids must be configured with multi-row selection",
  270: ({ id: e, parentId: t }) => `Cycle detected for row with id='${e}' and parent id='${t}'. Resetting the parent for row with id='${e}' and showing it as a root-level node.`,
  271: ({ id: e, parentId: t }) => `Parent row not found for row with id='${e}' and parent id='${t}'. Showing row with id='${e}' as a root-level node.`,
  272: () => Ay(),
  273: ({ providedId: e, usedId: t }) => `Provided column id '${e}' was already in use, ensure all column and group ids are unique. Using '${t}' instead.`,
  274: ({ prop: e }) => {
    let t = `Since v33, ${e} has been deprecated.`;
    switch (e) {
      case "maxComponentCreationTimeMs":
        t += " This property is no longer required and so will be removed in a future version.";
        break;
      case "setGridApi":
        t += " This method is not called by AG Grid. To access the GridApi see: https://ag-grid.com/react-data-grid/grid-interface/#grid-api ";
        break;
      case "children":
        t += " For multiple versions AgGridReact does not support children.";
        break;
    }
    return t;
  },
  275: Ly,
  276: () => "Row Numbers Row Resizer cannot be used when Grid Columns have `autoHeight` enabled.",
  277: ({ colId: e }) => `'enableFilterHandlers' is set to true, but column '${e}' does not have 'filter.doesFilterPass' or 'filter.handler' set.`,
  278: ({ colId: e }) => `Unable to create filter handler for column '${e}'`,
  279: (e) => {
  },
  // `Unable to create dynamic bean '${name}' during module init lifecycle, dynamic beans must be initialised on first use.` as const,
  280: ({ colId: e }) => `'name' must be provided for custom filter components for column '${e}`,
  281: ({ colId: e }) => `Filter for column '${e}' does not have 'filterParams.buttons', but the new Filters Tool Panel has buttons configured. Either configure buttons for the filter, or disable buttons on the Filters Tool Panel.`,
  282: () => "New filter tool panel requires `enableFilterHandlers: true`.",
  283: () => "As of v34, use the same method on the filter handler (`api.getColumnFilterHandler(colKey)`) instead.",
  284: () => "As of v34, filters are active when they have a model. Use `api.getColumnFilterModel()` instead.",
  285: () => "As of v34, use (`api.getColumnFilterModel()`) instead.",
  286: () => "As of v34, use (`api.setColumnFilterModel()`) instead.",
  287: () => "`api.doFilterAction()` requires `enableFilterHandlers = true",
  288: () => "`api.getColumnFilterModel(key, true)` requires `enableFilterHandlers = true",
  289: ({ rowModelType: e }) => `Row Model '${e}' is not supported with Batch Editing`,
  290: ({ rowIndex: e, rowPinned: t }) => `Row with index '${e}' and pinned state '${t}' not found`
};
function DNe(e, t) {
  const o = INe[e];
  if (!o)
    return [`Missing error text for error id ${e}!`];
  const n = o(t), i = `
See ${_w(e, t)}`;
  return Array.isArray(n) ? n.concat(i) : [n, i];
}
var kNe = {
  1: "Charting Aggregation",
  2: "pivotResultFields",
  3: "setTooltip"
}, Su = /* @__PURE__ */ new WeakMap(), xu = /* @__PURE__ */ new WeakMap();
function Ey(e, t, o) {
  if (!t)
    return qe(11), {};
  const n = o;
  let s;
  if (!(n != null && n.setThemeOnGridDiv)) {
    const r = ze({ tag: "div" });
    r.style.height = "100%", e.appendChild(r), e = r, s = () => e.remove();
  }
  return new VNe().create(
    e,
    t,
    (r) => {
      const l = new lOe(e);
      r.createBean(l);
    },
    void 0,
    o,
    s
  );
}
var HNe = 1, VNe = class {
  create(e, t, o, n, s, i) {
    const r = gIe.applyGlobalGridOptions(t), l = r.gridId ?? String(HNe++), a = this.getRegisteredModules(s, l, r.rowModelType), c = this.createBeansList(r.rowModelType, a, l), d = this.createProvidedBeans(e, r, s);
    if (!c)
      return;
    const h = {
      providedBeanInstances: d,
      beanClasses: c,
      id: l,
      beanInitComparator: zVe,
      beanDestroyComparator: jVe,
      derivedBeans: [GVe],
      destroyCallback: () => {
        xu.delete(C), Su.delete(e), A$e(l), i == null || i();
      }
    }, p = new Bke(h);
    this.registerModuleFeatures(p, a), o(p), p.getBean("syncSvc").start(), n == null || n(p);
    const C = p.getBean("gridApi");
    return Su.set(e, C), xu.set(C, e), C;
  }
  getRegisteredModules(e, t, o) {
    var n;
    return Ui(ANe, void 0, !0), (n = e == null ? void 0 : e.modules) == null || n.forEach((s) => Ui(s, t)), L$e(t, Mu(o));
  }
  registerModuleFeatures(e, t) {
    const o = e.getBean("registry"), n = e.getBean("apiFunctionSvc");
    t.forEach((s) => {
      o.registerModule(s);
      const i = s.apiFunctions;
      i && Object.keys(i).forEach((l) => {
        n == null || n.addFunction(l, i[l]);
      });
    });
  }
  createProvidedBeans(e, t, o) {
    let n = o ? o.frameworkOverrides : null;
    Xe(n) && (n = new Ub());
    const s = {
      gridOptions: t,
      eGridDiv: e,
      eRootDiv: e,
      globalListener: o ? o.globalListener : null,
      globalSyncListener: o ? o.globalSyncListener : null,
      frameworkOverrides: n
    };
    return o && o.providedBeanInstances && Object.assign(s, o.providedBeanInstances), s;
  }
  createBeansList(e, t, o) {
    const n = {
      clientSide: "ClientSideRowModel",
      infinite: "InfiniteRowModel",
      serverSide: "ServerSideRowModel",
      viewport: "ViewportRowModel"
    }, s = Mu(e), i = n[s];
    if (!i) {
      Cr(201, { rowModelType: s }, `Unknown rowModelType ${s}.`);
      return;
    }
    if (!R$e()) {
      Cr(272, void 0, Ay());
      return;
    }
    if (!e) {
      const l = Object.entries(n).filter(
        ([a, c]) => v5(c, o, a)
      );
      if (l.length == 1) {
        const [a, c] = l[0];
        if (a !== s) {
          const d = {
            moduleName: c,
            rowModelType: a
          };
          Cr(275, d, Ly(d));
          return;
        }
      }
    }
    if (!v5(i, o, s)) {
      Cr(
        200,
        {
          reasonOrId: `rowModelType = '${s}'`,
          moduleName: i,
          gridScoped: oc(),
          gridId: o,
          rowModelType: s
        },
        `Missing module ${i}Module for rowModelType ${s}.`
      );
      return;
    }
    const r = /* @__PURE__ */ new Set();
    return t.forEach((l) => {
      var a;
      return (a = l.beans) == null ? void 0 : a.forEach((c) => r.add(c));
    }), Array.from(r);
  }
};
function Mu(e) {
  return e ?? "clientSide";
}
var ONe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "localeSvc";
  }
  getLocaleTextFunc() {
    const e = this.gos, t = e.getCallback("getLocaleText");
    return t ? rIe(t) : lIe(e.get("localeText"));
  }
};
function BNe(e, t = !1) {
  const o = [], n = [], s = [], i = [], r = [], l = [], a = [], c = [], d = [];
  let u = 0;
  for (let h = 0; h < e.length; h++) {
    const {
      colId: p,
      sort: C,
      sortIndex: m,
      rowGroup: w,
      rowGroupIndex: y,
      aggFunc: b,
      pivot: _,
      pivotIndex: M,
      pinned: x,
      hide: L,
      width: A,
      flex: R
    } = e[h];
    d.push(p), C && (o[m ?? u++] = { colId: p, sort: C }), w && (n[y ?? 0] = p), typeof b == "string" && s.push({ colId: p, aggFunc: b }), _ && (i[M ?? 0] = p), x && (x === "right" ? l : r).push(p), L && a.push(p), (R != null || A) && c.push({ colId: p, flex: R ?? void 0, width: A });
  }
  return {
    sort: o.length ? { sortModel: o } : void 0,
    rowGroup: n.length ? { groupColIds: n } : void 0,
    aggregation: s.length ? { aggregationModel: s } : void 0,
    pivot: i.length || t ? { pivotMode: t, pivotColIds: i } : void 0,
    columnPinning: r.length || l.length ? { leftColIds: r, rightColIds: l } : void 0,
    columnVisibility: a.length ? { hiddenColIds: a } : void 0,
    columnSizing: c.length ? { columnSizingModel: c } : void 0,
    columnOrder: d.length ? { orderedColIds: d } : void 0
  };
}
function $Ne(e) {
  const t = [];
  return e.forEach(({ groupId: o, open: n }) => {
    n && t.push(o);
  }), t.length ? { openColumnGroupIds: t } : void 0;
}
var ZNe = class {
  wrap(e, t, o, n) {
    const s = this.createWrapper(e, n);
    return t == null || t.forEach((i) => {
      this.createMethod(s, i, !0);
    }), o == null || o.forEach((i) => {
      this.createMethod(s, i, !1);
    }), s;
  }
  createMethod(e, t, o) {
    e.addMethod(t, this.createMethodProxy(e, t, o));
  }
  createMethodProxy(e, t, o) {
    return function() {
      return e.hasMethod(t) ? e.callMethod(t, arguments) : (o && X(49, { methodName: t }), null);
    };
  }
};
function Tr(e) {
  return e.get("tooltipShowMode") === "whenTruncated";
}
function lc(e, t) {
  return Tr(e) ? Hs(t) : void 0;
}
function GNe(e, t) {
  if (typeof e != "number")
    return "";
  const o = t(), n = o("thousandSeparator", ","), s = o("decimalSeparator", ".");
  return e.toString().replace(".", s).replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${n}`);
}
var NNe = class extends K {
  getFileName(e) {
    const t = this.getDefaultFileExtension();
    return (e == null || !e.length) && (e = this.getDefaultFileName()), e.indexOf(".") === -1 ? `${e}.${t}` : e;
  }
  getData(e) {
    const t = this.createSerializingSession(e);
    return this.beans.gridSerializer.serialize(t, e);
  }
  getDefaultFileName() {
    return `export.${this.getDefaultFileExtension()}`;
  }
}, zNe = class {
  constructor(e) {
    const {
      colModel: t,
      rowGroupColsSvc: o,
      colNames: n,
      valueSvc: s,
      gos: i,
      processCellCallback: r,
      processHeaderCallback: l,
      processGroupHeaderCallback: a,
      processRowGroupCallback: c
    } = e;
    this.colModel = t, this.rowGroupColsSvc = o, this.colNames = n, this.valueSvc = s, this.gos = i, this.processCellCallback = r, this.processHeaderCallback = l, this.processGroupHeaderCallback = a, this.processRowGroupCallback = c;
  }
  prepare(e) {
  }
  extractHeaderValue(e) {
    return this.getHeaderName(this.processHeaderCallback, e) ?? "";
  }
  extractRowCellValue(e, t, o, n, s) {
    var h;
    const i = t === 0 && Ew(this.gos, s, this.colModel.isPivotMode());
    if (this.processRowGroupCallback && (this.gos.get("treeData") || s.group) && (e.isRowGroupDisplayed(((h = s.rowGroupColumn) == null ? void 0 : h.getColId()) ?? "") || i))
      return { value: this.processRowGroupCallback(Pe(this.gos, { column: e, node: s })) ?? "" };
    if (this.processCellCallback)
      return {
        value: this.processCellCallback(
          Pe(this.gos, {
            accumulatedRowIndex: o,
            column: e,
            node: s,
            value: this.valueSvc.getValueForDisplay(e, s, void 0, void 0).value,
            type: n,
            parseValue: (p) => this.valueSvc.parseValue(
              e,
              s,
              p,
              this.valueSvc.getValue(e, s, void 0)
            ),
            formatValue: (p) => this.valueSvc.formatValue(e, s, p) ?? p
          })
        ) ?? ""
      };
    const r = this.gos.get("treeData"), l = this.valueSvc, a = s.level === -1 && s.footer, c = e.colDef.showRowGroup === !0 && (s.group || r);
    if (!a && (i || c)) {
      let p = "", C = s;
      for (; C && C.level !== -1; ) {
        const { value: m, valueFormatted: w } = l.getValueForDisplay(
          i ? void 0 : e,
          // full width group doesn't have a column
          C,
          !0,
          !0
        );
        p = ` -> ${w ?? m ?? ""}${p}`, C = C.parent;
      }
      return {
        value: p,
        // don't return the unformatted value; as if the grid detects number it'll not use the concatenated string
        valueFormatted: p
      };
    }
    const { value: d, valueFormatted: u } = l.getValueForDisplay(e, s, !0, !0);
    return {
      value: d ?? "",
      valueFormatted: u
    };
  }
  getHeaderName(e, t) {
    return e ? e(Pe(this.gos, { column: t })) : this.colNames.getDisplayNameForColumn(t, "csv", !0);
  }
};
function jNe(e, t) {
  const o = document.defaultView || window;
  if (!o) {
    X(52);
    return;
  }
  const n = document.createElement("a"), s = o.URL.createObjectURL(t);
  n.setAttribute("href", s), n.setAttribute("download", e), n.style.display = "none", document.body.appendChild(n), n.dispatchEvent(
    new MouseEvent("click", {
      bubbles: !1,
      cancelable: !0,
      view: o
    })
  ), document.body.removeChild(n), o.setTimeout(() => {
    o.URL.revokeObjectURL(s);
  }, 0);
}
var WNe = {
  enableBrowserTooltips: !0,
  tooltipTrigger: !0,
  tooltipMouseTrack: !0,
  tooltipShowMode: !0,
  tooltipInteraction: !0,
  defaultColGroupDef: !0,
  suppressAutoSize: !0,
  skipHeaderOnAutoSize: !0,
  autoSizeStrategy: !0,
  components: !0,
  stopEditingWhenCellsLoseFocus: !0,
  undoRedoCellEditing: !0,
  undoRedoCellEditingLimit: !0,
  excelStyles: !0,
  cacheQuickFilter: !0,
  customChartThemes: !0,
  chartThemeOverrides: !0,
  chartToolPanelsDef: !0,
  loadingCellRendererSelector: !0,
  localeText: !0,
  keepDetailRows: !0,
  keepDetailRowsCount: !0,
  detailRowHeight: !0,
  detailRowAutoHeight: !0,
  tabIndex: !0,
  valueCache: !0,
  valueCacheNeverExpires: !0,
  enableCellExpressions: !0,
  suppressTouch: !0,
  suppressBrowserResizeObserver: !0,
  suppressPropertyNamesCheck: !0,
  debug: !0,
  dragAndDropImageComponent: !0,
  loadingOverlayComponent: !0,
  suppressLoadingOverlay: !0,
  noRowsOverlayComponent: !0,
  paginationPageSizeSelector: !0,
  paginateChildRows: !0,
  pivotPanelShow: !0,
  pivotSuppressAutoColumn: !0,
  suppressExpandablePivotGroups: !0,
  aggFuncs: !0,
  allowShowChangeAfterFilter: !0,
  ensureDomOrder: !0,
  enableRtl: !0,
  suppressColumnVirtualisation: !0,
  suppressMaxRenderedRowRestriction: !0,
  suppressRowVirtualisation: !0,
  rowDragText: !0,
  groupLockGroupColumns: !0,
  suppressGroupRowsSticky: !0,
  rowModelType: !0,
  cacheOverflowSize: !0,
  infiniteInitialRowCount: !0,
  serverSideInitialRowCount: !0,
  maxBlocksInCache: !0,
  maxConcurrentDatasourceRequests: !0,
  blockLoadDebounceMillis: !0,
  serverSideOnlyRefreshFilteredGroups: !0,
  serverSidePivotResultFieldSeparator: !0,
  viewportRowModelPageSize: !0,
  viewportRowModelBufferSize: !0,
  debounceVerticalScrollbar: !0,
  suppressAnimationFrame: !0,
  suppressPreventDefaultOnMouseWheel: !0,
  scrollbarWidth: !0,
  icons: !0,
  suppressRowTransform: !0,
  gridId: !0,
  enableGroupEdit: !0,
  initialState: !0,
  processUnpinnedColumns: !0,
  createChartContainer: !0,
  getLocaleText: !0,
  getRowId: !0,
  reactiveCustomComponents: !0,
  renderingMode: !0,
  columnMenu: !0,
  suppressSetFilterByDefault: !0,
  getDataPath: !0,
  enableCellSpan: !0,
  enableFilterHandlers: !0,
  filterHandlers: !0
}, lo = "clientSide", Ut = "serverSide", gi = "infinite", UNe = {
  onGroupExpandedOrCollapsed: [lo],
  refreshClientSideRowModel: [lo],
  isRowDataEmpty: [lo],
  forEachLeafNode: [lo],
  forEachNodeAfterFilter: [lo],
  forEachNodeAfterFilterAndSort: [lo],
  resetRowHeights: [lo, Ut],
  applyTransaction: [lo],
  applyTransactionAsync: [lo],
  flushAsyncTransactions: [lo],
  getBestCostNodeSelection: [lo],
  getServerSideSelectionState: [Ut],
  setServerSideSelectionState: [Ut],
  applyServerSideTransaction: [Ut],
  applyServerSideTransactionAsync: [Ut],
  applyServerSideRowData: [Ut],
  retryServerSideLoads: [Ut],
  flushServerSideAsyncTransactions: [Ut],
  refreshServerSide: [Ut],
  getServerSideGroupLevelState: [Ut],
  refreshInfiniteCache: [gi],
  purgeInfiniteCache: [gi],
  getInfiniteRowCount: [gi],
  isLastRowIndexKnown: [gi, Ut],
  expandAll: [lo, Ut],
  collapseAll: [lo, Ut],
  onRowHeightChanged: [lo, Ut],
  setRowCount: [gi, Ut],
  getCacheBlockState: [gi, Ut]
}, KNe = {
  showLoadingOverlay: {
    version: "v32",
    message: '`showLoadingOverlay` is deprecated. Use the grid option "loading"=true instead or setGridOption("loading", true).'
  },
  clearRangeSelection: {
    version: "v32.2",
    message: "Use `clearCellSelection` instead."
  },
  getInfiniteRowCount: {
    version: "v32.2",
    old: "getInfiniteRowCount()",
    new: "getDisplayedRowCount()"
  },
  selectAllFiltered: {
    version: "v33",
    old: "selectAllFiltered()",
    new: 'selectAll("filtered")'
  },
  deselectAllFiltered: {
    version: "v33",
    old: "deselectAllFiltered()",
    new: 'deselectAll("filtered")'
  },
  selectAllOnCurrentPage: {
    version: "v33",
    old: "selectAllOnCurrentPage()",
    new: 'selectAll("currentPage")'
  },
  deselectAllOnCurrentPage: {
    version: "v33",
    old: "deselectAllOnCurrentPage()",
    new: 'deselectAll("currentPage")'
  }
};
function qNe(e, t, o) {
  const n = KNe[e];
  if (n) {
    const { version: i, new: r, old: l, message: a } = n, c = l ?? e;
    return (...d) => {
      const u = r ? `Please use ${r} instead. ` : "";
      return Ar(`Since ${i} api.${c} is deprecated. ${u}${a ?? ""}`), t.apply(t, d);
    };
  }
  const s = UNe[e];
  return s ? (...i) => {
    const r = o.rowModel.getType();
    if (!s.includes(r)) {
      Ai(
        `api.${e} can only be called when gridOptions.rowModelType is ${s.join(" or ")}`
      );
      return;
    }
    return t.apply(t, i);
  } : t;
}
var YNe = {
  detailCellRendererCtrl: "SharedMasterDetail",
  dndSourceComp: "DragAndDrop",
  fillHandle: "CellSelection",
  groupCellRendererCtrl: "GroupCellRenderer",
  headerFilterCellCtrl: "ColumnFilter",
  headerGroupCellCtrl: "ColumnGroup",
  rangeHandle: "CellSelection",
  tooltipFeature: "Tooltip",
  highlightTooltipFeature: "Tooltip",
  tooltipStateManager: "Tooltip",
  groupStrategy: "RowGrouping",
  treeGroupStrategy: "TreeData",
  rowNumberRowResizer: "RowNumbers",
  singleCell: "EditCore",
  fullRow: "EditCore",
  agSetColumnFilterHandler: "SetFilter",
  agMultiColumnFilterHandler: "MultiFilter",
  agGroupColumnFilterHandler: "GroupFilter",
  agNumberColumnFilterHandler: "NumberFilter",
  agDateColumnFilterHandler: "DateFilter",
  agTextColumnFilterHandler: "TextFilter"
}, QNe = {
  expanded: 1,
  contracted: 1,
  "tree-closed": 1,
  "tree-open": 1,
  "tree-indeterminate": 1,
  pin: 1,
  "eye-slash": 1,
  arrows: 1,
  left: 1,
  right: 1,
  group: 1,
  aggregation: 1,
  pivot: 1,
  "not-allowed": 1,
  chart: 1,
  cross: 1,
  cancel: 1,
  tick: 1,
  first: 1,
  previous: 1,
  next: 1,
  last: 1,
  linked: 1,
  unlinked: 1,
  "color-picker": 1,
  loading: 1,
  menu: 1,
  "menu-alt": 1,
  filter: 1,
  "filter-add": 1,
  columns: 1,
  maximize: 1,
  minimize: 1,
  copy: 1,
  cut: 1,
  paste: 1,
  grip: 1,
  save: 1,
  csv: 1,
  excel: 1,
  "small-down": 1,
  "small-left": 1,
  "small-right": 1,
  "small-up": 1,
  asc: 1,
  desc: 1,
  none: 1,
  up: 1,
  down: 1,
  plus: 1,
  minus: 1,
  settings: 1,
  "checkbox-checked": 1,
  "checkbox-indeterminate": 1,
  "checkbox-unchecked": 1,
  "radio-button-on": 1,
  "radio-button-off": 1,
  eye: 1,
  "column-arrow": 1,
  "un-pin": 1,
  "pinned-top": 1,
  "pinned-bottom": 1,
  "chevron-up": 1,
  "chevron-down": 1,
  "chevron-left": 1,
  "chevron-right": 1,
  edit: 1
}, JNe = {
  chart: "MenuCore",
  cancel: "EnterpriseCore",
  first: "Pagination",
  previous: "Pagination",
  next: "Pagination",
  last: "Pagination",
  linked: "IntegratedCharts",
  loadingMenuItems: "MenuCore",
  unlinked: "IntegratedCharts",
  menu: "ColumnHeaderComp",
  legacyMenu: "ColumnMenu",
  filter: "ColumnFilter",
  filterActive: "ColumnFilter",
  filterAdd: "NewFiltersToolPanel",
  filterCardCollapse: "NewFiltersToolPanel",
  filterCardExpand: "NewFiltersToolPanel",
  filterCardEditing: "NewFiltersToolPanel",
  filterTab: "ColumnMenu",
  filtersToolPanel: "FiltersToolPanel",
  columns: ["MenuCore"],
  columnsToolPanel: ["ColumnsToolPanel"],
  maximize: "EnterpriseCore",
  minimize: "EnterpriseCore",
  save: "MenuCore",
  columnGroupOpened: "ColumnGroupHeaderComp",
  columnGroupClosed: "ColumnGroupHeaderComp",
  accordionOpen: "EnterpriseCore",
  accordionClosed: "EnterpriseCore",
  accordionIndeterminate: "EnterpriseCore",
  columnSelectClosed: ["ColumnsToolPanel", "ColumnMenu"],
  columnSelectOpen: ["ColumnsToolPanel", "ColumnMenu"],
  columnSelectIndeterminate: ["ColumnsToolPanel", "ColumnMenu"],
  columnMovePin: "SharedDragAndDrop",
  columnMoveHide: "SharedDragAndDrop",
  columnMoveMove: "SharedDragAndDrop",
  columnMoveLeft: "SharedDragAndDrop",
  columnMoveRight: "SharedDragAndDrop",
  columnMoveGroup: "SharedDragAndDrop",
  columnMoveValue: "SharedDragAndDrop",
  columnMovePivot: "SharedDragAndDrop",
  dropNotAllowed: "SharedDragAndDrop",
  ensureColumnVisible: ["ColumnsToolPanel", "ColumnMenu"],
  groupContracted: "GroupCellRenderer",
  groupExpanded: "GroupCellRenderer",
  setFilterGroupClosed: "SetFilter",
  setFilterGroupOpen: "SetFilter",
  setFilterGroupIndeterminate: "SetFilter",
  setFilterLoading: "SetFilter",
  close: "EnterpriseCore",
  check: "MenuItem",
  colorPicker: "CommunityCore",
  groupLoading: "LoadingCellRenderer",
  menuAlt: "ColumnHeaderComp",
  menuPin: "MenuCore",
  menuValue: "MenuCore",
  menuAddRowGroup: ["MenuCore", "ColumnsToolPanel"],
  menuRemoveRowGroup: ["MenuCore", "ColumnsToolPanel"],
  clipboardCopy: "MenuCore",
  clipboardCut: "MenuCore",
  clipboardPaste: "MenuCore",
  pivotPanel: ["ColumnsToolPanel", "RowGroupingPanel"],
  rowGroupPanel: ["ColumnsToolPanel", "RowGroupingPanel"],
  valuePanel: "ColumnsToolPanel",
  columnDrag: "EnterpriseCore",
  rowDrag: ["RowDrag", "DragAndDrop"],
  csvExport: "MenuCore",
  excelExport: "MenuCore",
  smallDown: "CommunityCore",
  selectOpen: "CommunityCore",
  richSelectOpen: "RichSelect",
  richSelectRemove: "RichSelect",
  smallLeft: "CommunityCore",
  smallRight: "CommunityCore",
  subMenuOpen: "MenuItem",
  subMenuOpenRtl: "MenuItem",
  panelDelimiter: "RowGroupingPanel",
  panelDelimiterRtl: "RowGroupingPanel",
  smallUp: "CommunityCore",
  sortAscending: ["MenuCore", "Sort"],
  sortDescending: ["MenuCore", "Sort"],
  sortUnSort: ["MenuCore", "Sort"],
  advancedFilterBuilder: "AdvancedFilter",
  advancedFilterBuilderDrag: "AdvancedFilter",
  advancedFilterBuilderInvalid: "AdvancedFilter",
  advancedFilterBuilderMoveUp: "AdvancedFilter",
  advancedFilterBuilderMoveDown: "AdvancedFilter",
  advancedFilterBuilderAdd: "AdvancedFilter",
  advancedFilterBuilderRemove: "AdvancedFilter",
  advancedFilterBuilderSelectOpen: "AdvancedFilter",
  chartsMenu: "IntegratedCharts",
  chartsMenuEdit: "IntegratedCharts",
  chartsMenuAdvancedSettings: "IntegratedCharts",
  chartsMenuAdd: "IntegratedCharts",
  chartsColorPicker: "IntegratedCharts",
  chartsThemePrevious: "IntegratedCharts",
  chartsThemeNext: "IntegratedCharts",
  chartsDownload: "IntegratedCharts",
  checkboxChecked: "CommunityCore",
  checkboxIndeterminate: "CommunityCore",
  checkboxUnchecked: "CommunityCore",
  radioButtonOn: "CommunityCore",
  radioButtonOff: "CommunityCore",
  rowPin: "PinnedRow",
  rowUnpin: "PinnedRow",
  rowPinBottom: "PinnedRow",
  rowPinTop: "PinnedRow"
}, XNe = /* @__PURE__ */ new Set([
  "colorPicker",
  "smallUp",
  "checkboxChecked",
  "checkboxIndeterminate",
  "checkboxUnchecked",
  "radioButtonOn",
  "radioButtonOff",
  "smallDown",
  "smallLeft",
  "smallRight"
]), eze = class extends K {
  constructor() {
    super(...arguments), this.beanName = "validation";
  }
  wireBeans(e) {
    this.gridOptions = e.gridOptions, fIe(DNe);
  }
  warnOnInitialPropertyUpdate(e, t) {
    e === "api" && WNe[t] && X(22, { key: t });
  }
  processGridOptions(e) {
    this.processOptions(e, UZe());
  }
  validateApiFunction(e, t) {
    return qNe(e, t, this.beans);
  }
  missingUserComponent(e, t, o, n) {
    const s = Fi[t];
    s ? this.gos.assertModuleRegistered(
      s,
      `AG Grid '${e}' component: ${t}`
    ) : X(101, {
      propertyName: e,
      componentName: t,
      agGridDefaults: o,
      jsComps: n
    });
  }
  missingDynamicBean(e) {
    const t = YNe[e];
    return t ? ln(200, {
      ...this.gos.getModuleErrorParams(),
      moduleName: t,
      reasonOrId: e
    }) : void 0;
  }
  checkRowEvents(e) {
    oze.has(e) && X(10, { eventType: e });
  }
  validateIcon(e) {
    if (XNe.has(e) && X(43, { iconName: e }), QNe[e])
      return;
    const t = JNe[e];
    if (t) {
      qe(200, {
        reasonOrId: `icon '${e}'`,
        moduleName: t,
        gridScoped: oc(),
        gridId: this.beans.context.getId(),
        rowModelType: this.gos.get("rowModelType"),
        additionalText: "Alternatively, use the CSS icon name directly."
      });
      return;
    }
    X(134, { iconName: e });
  }
  isProvidedUserComp(e) {
    return !!Fi[e];
  }
  /** Should only be called via the GridOptionsService */
  validateColDef(e) {
    this.processOptions(e, VZe());
  }
  processOptions(e, t) {
    const { validations: o, deprecations: n, allProperties: s, propertyExceptions: i, objectName: r, docsUrl: l } = t;
    s && this.gridOptions.suppressPropertyNamesCheck !== !0 && this.checkProperties(
      e,
      [...i ?? [], ...Object.keys(n)],
      s,
      r,
      l
    );
    const a = /* @__PURE__ */ new Set();
    Object.keys(e).forEach((d) => {
      const u = n[d];
      if (u) {
        const { message: b, version: _ } = u;
        a.add(`As of v${_}, ${String(d)} is deprecated. ${b ?? ""}`);
      }
      const h = e[d];
      if (h == null || h === !1)
        return;
      const p = o[d];
      if (!p)
        return;
      const { dependencies: C, validate: m, supportedRowModels: w, expectedType: y } = p;
      if (y) {
        const b = typeof h;
        if (b !== y) {
          a.add(
            `${String(d)} should be of type '${y}' but received '${b}' (${h}).`
          );
          return;
        }
      }
      if (w) {
        const b = this.gridOptions.rowModelType ?? "clientSide";
        if (!w.includes(b)) {
          a.add(
            `${String(d)} is not supported with the '${b}' row model. It is only valid with: ${w.join(", ")}.`
          );
          return;
        }
      }
      if (C) {
        const b = this.checkForRequiredDependencies(d, C, e);
        if (b) {
          a.add(b);
          return;
        }
      }
      if (m) {
        const b = m(e, this.gridOptions, this.beans);
        if (b) {
          a.add(b);
          return;
        }
      }
    }), a.size > 0 && a.forEach((d) => {
      Ar(d);
    });
  }
  checkForRequiredDependencies(e, t, o) {
    const s = Object.entries(t).filter(([i, r]) => {
      const l = o[i];
      return !r.required.includes(l);
    });
    return s.length === 0 ? null : s.map(
      ([i, r]) => `'${String(e)}' requires '${i}' to be one of [${r.required.map((l) => l === null ? "null" : l === void 0 ? "undefined" : l).join(", ")}]. ${r.reason ?? ""}`
    ).join(`
           `);
  }
  checkProperties(e, t, o, n, s) {
    const i = ["__ob__", "__v_skip", "__metadata__"], r = tze(
      Object.getOwnPropertyNames(e),
      [...i, ...t, ...o],
      o
    ), l = Object.keys(r);
    for (const a of l) {
      const c = r[a];
      let d = `invalid ${n} property '${a}' did you mean any of these: ${c.slice(0, 8).join(", ")}.`;
      o.includes("context") && (d += `
If you are trying to annotate ${n} with application data, use the '${n}.context' property instead.`), Ar(d);
    }
    if (l.length > 0 && s) {
      const a = this.beans.frameworkOverrides.getDocLink(s);
      Ar(`to see all the valid ${n} properties please check: ${a}`);
    }
  }
};
function tze(e, t, o) {
  const n = {}, s = e.filter(
    (i) => !t.some((r) => r === i)
  );
  return s.length > 0 && s.forEach(
    (i) => n[i] = Yr({ inputValue: i, allSuggestions: o }).values
  ), n;
}
var oze = /* @__PURE__ */ new Set([
  "firstChildChanged",
  "lastChildChanged",
  "childIndexChanged"
]), nze = {
  moduleName: "Validation",
  version: be,
  beans: [eze]
};
function Py(e) {
  e.sibling && (e.sibling.childrenAfterFilter = e.childrenAfterFilter);
}
var sze = class extends K {
  constructor() {
    super(...arguments), this.beanName = "filterStage", this.refreshProps = /* @__PURE__ */ new Set(["excludeChildrenWhenTreeDataFiltering"]), this.step = "filter";
  }
  wireBeans(e) {
    this.filterManager = e.filterManager;
  }
  execute(e) {
    const { changedPath: t } = e;
    this.filter(t);
  }
  filter(e) {
    var o;
    const t = !!((o = this.filterManager) != null && o.isChildFilterPresent());
    this.filterNodes(t, e);
  }
  filterNodes(e, t) {
    const o = (n, s) => {
      n.hasChildren() && e && !s ? n.childrenAfterFilter = n.childrenAfterGroup.filter((i) => {
        const r = i.childrenAfterFilter && i.childrenAfterFilter.length > 0, l = i.data && this.filterManager.doesRowPassFilter({ rowNode: i });
        return r || l;
      }) : n.childrenAfterFilter = n.childrenAfterGroup, Py(n);
    };
    if (this.doingTreeDataFiltering()) {
      const n = (i, r) => {
        if (i.childrenAfterGroup)
          for (let l = 0; l < i.childrenAfterGroup.length; l++) {
            const a = i.childrenAfterGroup[l], c = r || this.filterManager.doesRowPassFilter({ rowNode: a });
            a.childrenAfterGroup ? n(i.childrenAfterGroup[l], c) : o(a, c);
          }
        o(i, r);
      }, s = (i) => n(i, !1);
      t.executeFromRootNode(s);
    } else {
      const n = (s) => o(s, !1);
      t.forEachChangedNodeDepthFirst(n, !0);
    }
  }
  doingTreeDataFiltering() {
    return this.gos.get("treeData") && !this.gos.get("excludeChildrenWhenTreeDataFiltering");
  }
}, ize = class extends X2 {
  constructor() {
    super(...arguments), this.iconCreated = !1;
  }
  wireComp(e, t, o, n, s) {
    this.comp = e;
    const i = d1(this, this.beans.context, s);
    this.eButtonShowMainFilter = o, this.eFloatingFilterBody = n, this.setGui(t, i), this.setupActive(), this.refreshHeaderStyles(), this.setupWidth(i), this.setupLeft(i), this.setupHover(i), this.setupFocus(i), this.setupAria(), this.setupFilterButton(), this.setupUserComp(), this.setupSyncWithFilter(i), this.setupUi(), i.addManagedElementListeners(this.eButtonShowMainFilter, { click: this.showParentFilter.bind(this) }), this.setupFilterChangedListener(i);
    const r = () => this.onColDefChanged(i);
    i.addManagedListeners(this.column, { colDefChanged: r }), i.addManagedEventListeners({
      filterSwitched: ({ column: l }) => {
        l === this.column && r();
      }
    }), i.addDestroyFunc(() => {
      this.eButtonShowMainFilter = null, this.eFloatingFilterBody = null, this.userCompDetails = null, this.clearComponent();
    });
  }
  // empty abstract method
  resizeHeader() {
  }
  moveHeader() {
  }
  getHeaderClassParams() {
    const { column: e, beans: t } = this, o = e.colDef;
    return Pe(t.gos, {
      colDef: o,
      column: e,
      floatingFilter: !0
    });
  }
  setupActive() {
    const e = this.column.getColDef(), t = !!e.filter, o = !!e.floatingFilter;
    this.active = t && o;
  }
  setupUi() {
    if (this.comp.setButtonWrapperDisplayed(!this.suppressFilterButton && this.active), this.comp.addOrRemoveBodyCssClass("ag-floating-filter-full-body", this.suppressFilterButton), this.comp.addOrRemoveBodyCssClass("ag-floating-filter-body", !this.suppressFilterButton), !this.active || this.iconCreated)
      return;
    const e = Ie("filter", this.beans, this.column);
    e && (this.iconCreated = !0, this.eButtonShowMainFilter.appendChild(e));
  }
  setupFocus(e) {
    e.createManagedBean(
      new gs(this.eGui, {
        shouldStopEventPropagation: this.shouldStopEventPropagation.bind(this),
        onTabKeyDown: this.onTabKeyDown.bind(this),
        handleKeyDown: this.handleKeyDown.bind(this),
        onFocusIn: this.onFocusIn.bind(this)
      })
    );
  }
  setupAria() {
    const e = this.getLocaleTextFunc();
    ft(this.eButtonShowMainFilter, e("ariaFilterMenuOpen", "Open Filter Menu"));
  }
  onTabKeyDown(e) {
    var r;
    const { beans: t } = this;
    if (Ue(t) === this.eGui)
      return;
    const s = Yt(t, this.eGui, null, e.shiftKey);
    if (s) {
      (r = t.headerNavigation) == null || r.scrollToColumn(this.column), e.preventDefault(), s.focus();
      return;
    }
    const i = this.findNextColumnWithFloatingFilter(e.shiftKey);
    i && t.focusSvc.focusHeaderPosition({
      headerPosition: {
        headerRowIndex: this.rowCtrl.rowIndex,
        column: i
      },
      event: e
    }) && e.preventDefault();
  }
  findNextColumnWithFloatingFilter(e) {
    const t = this.beans.visibleCols;
    let o = this.column;
    do
      if (o = e ? t.getColBefore(o) : t.getColAfter(o), !o)
        break;
    while (!o.getColDef().filter || !o.getColDef().floatingFilter);
    return o;
  }
  handleKeyDown(e) {
    super.handleKeyDown(e);
    const t = this.getWrapperHasFocus();
    switch (e.key) {
      case D.UP:
      case D.DOWN:
      case D.LEFT:
      case D.RIGHT:
        if (t)
          return;
        vt(e);
      case D.ENTER:
        t && so(this.eGui) && e.preventDefault();
        break;
      case D.ESCAPE:
        t || this.eGui.focus();
    }
  }
  onFocusIn(e) {
    if (this.eGui.contains(e.relatedTarget))
      return;
    const o = !!e.relatedTarget && !e.relatedTarget.classList.contains("ag-floating-filter"), n = !!e.relatedTarget && ks(e.relatedTarget, "ag-floating-filter");
    if (o && n && e.target === this.eGui) {
      const s = this.lastFocusEvent, i = !!(s && s.key === D.TAB);
      if (s && i) {
        const r = s.shiftKey;
        so(this.eGui, r);
      }
    }
    this.focusThis();
  }
  setupHover(e) {
    var t;
    (t = this.beans.colHover) == null || t.addHeaderFilterColumnHoverListener(e, this.comp, this.column, this.eGui);
  }
  setupLeft(e) {
    const t = new J2(this.column, this.eGui, this.beans);
    e.createManagedBean(t);
  }
  setupFilterButton() {
    var e;
    this.suppressFilterButton = !((e = this.beans.menuSvc) != null && e.isFloatingFilterButtonEnabled(this.column)), this.highlightFilterButtonWhenActive = !$t(this.gos);
  }
  setupUserComp() {
    var t;
    if (!this.active)
      return;
    const e = (t = this.beans.colFilter) == null ? void 0 : t.getFloatingFilterCompDetails(
      this.column,
      () => this.showParentFilter()
    );
    e && this.setCompDetails(e);
  }
  setCompDetails(e) {
    this.userCompDetails = e, this.comp.setCompDetails(e);
  }
  showParentFilter() {
    var t;
    const e = this.suppressFilterButton ? this.eFloatingFilterBody : this.eButtonShowMainFilter;
    (t = this.beans.menuSvc) == null || t.showFilterMenu({
      column: this.column,
      buttonElement: e,
      containerType: "floatingFilter",
      positionBy: "button"
    });
  }
  setupSyncWithFilter(e) {
    if (!this.active)
      return;
    const {
      beans: { colFilter: t },
      column: o,
      gos: n
    } = this, s = (i) => {
      if ((i == null ? void 0 : i.source) === "filterDestroyed" && (!this.isAlive() || !(t != null && t.isAlive())))
        return;
      const r = this.comp.getFloatingFilterComp();
      r && r.then((l) => {
        if (l) {
          if (n.get("enableFilterHandlers")) {
            const d = i;
            let u = "filter";
            d != null && d.afterFloatingFilter ? u = "ui" : d != null && d.afterDataChange ? u = "dataChanged" : (i == null ? void 0 : i.source) === "api" && (u = "api"), this.updateFloatingFilterParams(this.userCompDetails, u);
            return;
          }
          const a = t == null ? void 0 : t.getCurrentFloatingFilterParentModel(o), c = i ? {
            // event can have additional params like `afterDataChange` which need to be passed through
            ...i,
            columns: i.columns ?? [],
            source: i.source === "api" ? "api" : "columnFilter"
          } : null;
          l.onParentModelChanged(a, c);
        }
      });
    };
    [this.destroySyncListener] = e.addManagedListeners(o, { filterChanged: s }), t != null && t.isFilterActive(o) && s(null);
  }
  setupWidth(e) {
    const t = () => {
      const o = `${this.column.getActualWidth()}px`;
      this.comp.setWidth(o);
    };
    e.addManagedListeners(this.column, { widthChanged: t }), t();
  }
  setupFilterChangedListener(e) {
    this.active && ([this.destroyFilterChangedListener] = e.addManagedListeners(this.column, {
      filterChanged: this.updateFilterButton.bind(this)
    }), this.updateFilterButton());
  }
  updateFilterButton() {
    var e;
    if (!this.suppressFilterButton && this.comp) {
      const t = !!((e = this.beans.filterManager) != null && e.isFilterAllowed(this.column));
      this.comp.setButtonWrapperDisplayed(t), this.highlightFilterButtonWhenActive && t && this.eButtonShowMainFilter.classList.toggle("ag-filter-active", this.column.isFilterActive());
    }
  }
  onColDefChanged(e) {
    const t = this.active;
    this.setupActive();
    const o = !t && this.active;
    t && !this.active && (this.destroySyncListener(), this.destroyFilterChangedListener());
    const n = this.beans.colFilter, s = this.active ? n == null ? void 0 : n.getFloatingFilterCompDetails(this.column, () => this.showParentFilter()) : null, i = this.comp.getFloatingFilterComp();
    !i || !s ? this.updateCompDetails(e, s, o) : i.then((r) => {
      !r || n != null && n.areFilterCompsDifferent(this.userCompDetails ?? null, s) ? this.updateCompDetails(e, s, o) : this.updateFloatingFilterParams(s, "colDef");
    });
  }
  updateCompDetails(e, t, o) {
    this.isAlive() && (this.setCompDetails(t), this.setupFilterButton(), this.setupUi(), o && (this.setupSyncWithFilter(e), this.setupFilterChangedListener(e)));
  }
  updateFloatingFilterParams(e, t) {
    var n;
    if (!e)
      return;
    let o = e.params;
    (n = this.comp.getFloatingFilterComp()) == null || n.then((s) => {
      var i;
      typeof (s == null ? void 0 : s.refresh) == "function" && (this.gos.get("enableFilterHandlers") && (o = {
        ...o,
        model: Ot(((i = this.beans.colFilter) == null ? void 0 : i.model) ?? {}, this.column.getColId()),
        source: t
      }), s.refresh(o));
    });
  }
  addResizeAndMoveKeyboardListeners() {
  }
  destroy() {
    super.destroy(), this.destroySyncListener = null, this.destroyFilterChangedListener = null;
  }
};
function rze(e, t) {
  var n;
  const o = e.colModel.getCol(t);
  if (!o) {
    qe(12, { colKey: t });
    return;
  }
  (n = e.menuSvc) == null || n.showColumnMenu({
    column: o,
    positionBy: "auto"
  });
}
function lze(e) {
  var t;
  (t = e.menuSvc) == null || t.hidePopupMenu();
}
var Ry = {
  moduleName: "SharedMenu",
  version: be,
  beans: [vVe],
  apiFunctions: {
    showColumnMenu: rze,
    hidePopupMenu: lze
  }
}, aze = class extends qke {
  postConstruct() {
    this.beans.ctrlsSvc.whenReady(this, (e) => {
      this.gridCtrl = e.gridCtrl;
    }), this.addManagedEventListeners({ gridStylesChanged: this.handleThemeChange.bind(this) });
  }
  getDefaultPopupParent() {
    return this.gridCtrl.getGui();
  }
  positionPopupForMenu(e) {
    const { eventSource: t, ePopup: o, event: n } = e, s = t.getBoundingClientRect(), i = this.getParentRect();
    this.setAlignedTo(t, o);
    let r = !1;
    const l = () => {
      const a = this.keepXYWithinBounds(
        o,
        s.top - i.top,
        0
        /* Vertical */
      ), c = o.clientWidth > 0 ? o.clientWidth : 200;
      r || (o.style.minWidth = `${c}px`, r = !0);
      const u = i.right - i.left - c;
      let h;
      return this.gos.get("enableRtl") ? (h = C(), h < 0 && (h = p(), this.setAlignedStyles(o, "left")), h > u && (h = 0, this.setAlignedStyles(o, "right"))) : (h = p(), h > u && (h = C(), this.setAlignedStyles(o, "right")), h < 0 && (h = 0, this.setAlignedStyles(o, "left"))), { x: h, y: a };
      function p() {
        return s.right - i.left - 2;
      }
      function C() {
        return s.left - i.left - c;
      }
    };
    this.positionPopup({
      ePopup: o,
      keepWithinBounds: !0,
      updatePosition: l,
      postProcessCallback: () => this.callPostProcessPopup(
        e,
        "subMenu",
        o,
        t,
        n instanceof MouseEvent ? n : void 0
      )
    });
  }
  callPostProcessPopup(e, t, o, n, s) {
    const i = this.gos.getCallback("postProcessPopup");
    if (i) {
      const { column: r, rowNode: l } = e;
      i({
        column: r,
        rowNode: l,
        ePopup: o,
        type: t,
        eventSource: n,
        mouseEvent: s
      });
    }
  }
  getActivePopups() {
    return this.popupList.map((e) => e.element);
  }
  handleThemeChange(e) {
    if (e.themeChanged) {
      const t = this.beans.environment;
      for (const o of this.popupList)
        t.applyThemeClasses(o.wrapper);
    }
  }
  hasAnchoredPopup() {
    return this.popupList.some((e) => e.isAnchored);
  }
  isStopPropagation(e) {
    return wo(e);
  }
}, li = {
  moduleName: "Popup",
  version: be,
  beans: [aze]
}, cze = (
  /*css*/
  ".ag-set-filter{--ag-indentation-level:0}.ag-set-filter-item{align-items:center;display:flex;height:100%}:where(.ag-ltr) .ag-set-filter-item{padding-left:calc(var(--ag-widget-container-horizontal-padding) + var(--ag-indentation-level)*var(--ag-set-filter-indent-size))}:where(.ag-rtl) .ag-set-filter-item{padding-right:calc(var(--ag-widget-container-horizontal-padding) + var(--ag-indentation-level)*var(--ag-set-filter-indent-size))}.ag-set-filter-item-checkbox{display:flex;height:100%;width:100%}.ag-set-filter-group-icons{display:block;>*{cursor:pointer}}:where(.ag-ltr) .ag-set-filter-group-icons{margin-right:var(--ag-widget-container-horizontal-padding)}:where(.ag-rtl) .ag-set-filter-group-icons{margin-left:var(--ag-widget-container-horizontal-padding)}.ag-filter-body-wrapper{display:flex;flex-direction:column}:where(.ag-menu:not(.ag-tabs) .ag-filter) .ag-filter-body-wrapper,:where(.ag-menu:not(.ag-tabs) .ag-filter)>:not(.ag-filter-wrapper){min-width:180px}.ag-filter-filter{flex:1 1 0px}.ag-filter-condition{display:flex;justify-content:center}.ag-floating-filter-body{display:flex;flex:1 1 auto;height:100%;position:relative}.ag-floating-filter-full-body{align-items:center;display:flex;flex:1 1 auto;height:100%;overflow:hidden;width:100%}:where(.ag-floating-filter-full-body)>div{flex:1 1 auto}.ag-floating-filter-input{align-items:center;display:flex;width:100%;>*{flex:1 1 auto}:where(.ag-input-field-input[type=date]),:where(.ag-input-field-input[type=datetime-local]){width:1px}}.ag-floating-filter-button{display:flex;flex:none}.ag-date-floating-filter-wrapper{display:flex}.ag-set-floating-filter-input :where(input)[disabled]{pointer-events:none}.ag-floating-filter-button-button{-webkit-appearance:none;-moz-appearance:none;appearance:none;border:none;height:var(--ag-icon-size);width:var(--ag-icon-size)}.ag-filter-loading{align-items:unset;background-color:var(--ag-chrome-background-color);height:100%;padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding);position:absolute;width:100%;z-index:1;:where(.ag-menu) &{background-color:var(--ag-menu-background-color)}}.ag-filter-separator{border-top:solid var(--ag-border-width) var(--menu-separator-color)}:where(.ag-filter-select) .ag-picker-field-wrapper{width:0}.ag-filter-condition-operator{height:17px}:where(.ag-ltr) .ag-filter-condition-operator-or{margin-left:calc(var(--ag-spacing)*2)}:where(.ag-rtl) .ag-filter-condition-operator-or{margin-right:calc(var(--ag-spacing)*2)}.ag-set-filter-select-all{padding-top:var(--ag-widget-container-vertical-padding)}.ag-filter-no-matches,.ag-set-filter-list{height:calc(var(--ag-list-item-height)*6)}.ag-filter-no-matches{padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding)}.ag-set-filter-tree-list{height:calc(var(--ag-list-item-height)*10)}.ag-set-filter-filter{margin-left:var(--ag-widget-container-horizontal-padding);margin-right:var(--ag-widget-container-horizontal-padding);margin-top:var(--ag-widget-container-vertical-padding)}.ag-filter-to{margin-top:var(--ag-widget-vertical-spacing)}.ag-mini-filter{margin:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding)}:where(.ag-ltr) .ag-set-filter-add-group-indent{margin-left:calc(var(--ag-icon-size) + var(--ag-widget-container-horizontal-padding))}:where(.ag-rtl) .ag-set-filter-add-group-indent{margin-right:calc(var(--ag-icon-size) + var(--ag-widget-container-horizontal-padding))}:where(.ag-filter-menu) .ag-set-filter-list{min-width:200px}.ag-filter-virtual-list-item:focus-visible{box-shadow:inset var(--ag-focus-shadow)}.ag-filter-apply-panel{display:flex;justify-content:flex-end;overflow:hidden;padding:var(--ag-widget-vertical-spacing) var(--ag-widget-container-horizontal-padding) var(--ag-widget-container-vertical-padding)}.ag-filter-apply-panel-button{line-height:1.5}:where(.ag-ltr) .ag-filter-apply-panel-button{margin-left:calc(var(--ag-spacing)*2)}:where(.ag-rtl) .ag-filter-apply-panel-button{margin-right:calc(var(--ag-spacing)*2)}.ag-simple-filter-body-wrapper{display:flex;flex-direction:column;min-height:calc(var(--ag-list-item-height) + var(--ag-widget-container-vertical-padding) + var(--ag-widget-vertical-spacing));overflow-y:auto;padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding);padding-bottom:calc(var(--ag-widget-container-vertical-padding) - var(--ag-widget-vertical-spacing));&>*{margin-bottom:var(--ag-widget-vertical-spacing)}:where(.ag-resizer-wrapper){margin:0}}.ag-multi-filter-menu-item{margin:var(--ag-spacing) 0}.ag-multi-filter-group-title-bar{background-color:transparent;color:var(--ag-header-text-color);font-weight:500;padding:calc(var(--ag-spacing)*1.5) var(--ag-spacing)}.ag-group-filter-field-select-wrapper{display:flex;flex-direction:column;gap:var(--ag-widget-vertical-spacing);padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding)}"
);
function dze(e) {
  const t = e.filterManager;
  return !!(t != null && t.isColumnFilterPresent()) || !!(t != null && t.isAggregateFilterPresent());
}
function uze(e, t) {
  var o;
  return ((o = e.filterManager) == null ? void 0 : o.getColumnFilterInstance(t)) ?? Promise.resolve(void 0);
}
function hze(e, t) {
  var n;
  const o = e.colModel.getColDefCol(t);
  if (o)
    return (n = e.colFilter) == null ? void 0 : n.destroyFilter(o, "api");
}
function gze(e, t) {
  e.frameworkOverrides.wrapIncoming(() => {
    var o;
    return (o = e.filterManager) == null ? void 0 : o.setFilterModel(t);
  });
}
function pze(e) {
  var t;
  return ((t = e.filterManager) == null ? void 0 : t.getFilterModel()) ?? {};
}
function fze(e, t, o) {
  const { gos: n, colModel: s, colFilter: i } = e;
  o && !n.get("enableFilterHandlers") && (X(288), o = !1);
  const r = s.getColDefCol(t);
  return r ? (i == null ? void 0 : i.getModelForColumn(r, o)) ?? null : null;
}
function vze(e, t, o) {
  var n;
  return ((n = e.filterManager) == null ? void 0 : n.setColumnFilterModel(t, o)) ?? Promise.resolve();
}
function mze(e, t) {
  var n;
  const o = e.colModel.getCol(t);
  if (!o) {
    qe(12, { colKey: t });
    return;
  }
  (n = e.menuSvc) == null || n.showFilterMenu({
    column: o,
    containerType: "columnFilter",
    positionBy: "auto"
  });
}
function Cze(e) {
  var t;
  (t = e.menuSvc) == null || t.hideFilterMenu();
}
function wze(e, t) {
  var n;
  const o = e.colModel.getCol(t);
  if (!o) {
    qe(12, { colKey: t });
    return;
  }
  return (n = e.colFilter) == null ? void 0 : n.getHandler(o, !0);
}
function bze(e, t) {
  const { colModel: o, colFilter: n, gos: s } = e;
  if (!s.get("enableFilterHandlers")) {
    X(287);
    return;
  }
  const { colId: i, action: r } = t;
  if (i) {
    const l = o.getColById(i);
    l && (n == null || n.updateModel(l, r));
  } else
    n == null || n.updateAllModels(r);
}
var yze = {
  filterHandler: () => ({
    doesFilterPass: () => !0
  })
}, _ze = class extends K {
  constructor() {
    super(...arguments), this.beanName = "colFilter", this.allColumnFilters = /* @__PURE__ */ new Map(), this.allColumnListeners = /* @__PURE__ */ new Map(), this.activeAggregateFilters = [], this.activeColumnFilters = [], this.processingFilterChange = !1, this.modelUpdates = [], this.columnModelUpdates = [], this.state = /* @__PURE__ */ new Map(), this.handlerMap = {
      ...mb
    }, this.isGlobalButtons = !1, this.activeFilterComps = /* @__PURE__ */ new Set();
  }
  postConstruct() {
    var o, n;
    this.addManagedEventListeners({
      gridColumnsChanged: this.onColumnsChanged.bind(this),
      dataTypesInferred: this.processFilterModelUpdateQueue.bind(this)
    });
    const e = this.gos, t = {
      ...((n = (o = e.get("initialState")) == null ? void 0 : o.filter) == null ? void 0 : n.filterModel) ?? {}
    };
    this.initialModel = t, this.model = {
      ...t
    }, e.get("enableFilterHandlers") || delete this.handlerMap.agMultiColumnFilter;
  }
  refreshModel() {
    this.onNewRowsLoaded("rowDataUpdated");
  }
  setModel(e, t = "api", o) {
    const { colModel: n, dataTypeSvc: s, filterManager: i } = this.beans;
    if (s != null && s.isPendingInference) {
      this.modelUpdates.push({ model: e, source: t });
      return;
    }
    const r = [], l = this.getModel(!0);
    if (e) {
      const a = new Set(Object.keys(e));
      this.allColumnFilters.forEach((c, d) => {
        const u = e[d];
        r.push(this.setModelOnFilterWrapper(c, u)), a.delete(d);
      }), a.forEach((c) => {
        const d = n.getColDefCol(c) || n.getCol(c);
        if (!d) {
          X(62, { colId: c });
          return;
        }
        if (!d.isFilterAllowed()) {
          X(63, { colId: c });
          return;
        }
        const u = this.getOrCreateFilterWrapper(d, !0);
        if (!u) {
          X(64, { colId: c });
          return;
        }
        r.push(this.setModelOnFilterWrapper(u, e[c], !0));
      });
    } else
      this.model = {}, this.allColumnFilters.forEach((a) => {
        r.push(this.setModelOnFilterWrapper(a, null));
      });
    Ye.all(r).then(() => {
      const a = this.getModel(!0), c = [];
      this.allColumnFilters.forEach((d, u) => {
        const h = l ? l[u] : null, p = a ? a[u] : null;
        Zr(h, p) || c.push(d.column);
      }), c.length > 0 ? i == null || i.onFilterChanged({ columns: c, source: t }) : o && this.updateActive("filterChanged");
    });
  }
  getModel(e) {
    var i;
    const t = {}, {
      allColumnFilters: o,
      initialModel: n,
      beans: { colModel: s }
    } = this;
    if (o.forEach((r, l) => {
      const a = this.getModelFromFilterWrapper(r);
      ue(a) && (t[l] = a);
    }), !e)
      for (const r of Object.keys(n)) {
        const l = n[r];
        ue(l) && !o.has(r) && ((i = s.getCol(r)) != null && i.isFilterAllowed()) && (t[r] = l);
      }
    return t;
  }
  setState(e, t, o = "api") {
    if (this.state.clear(), t)
      for (const n of Object.keys(t)) {
        const s = t[n];
        this.state.set(n, {
          model: Ot(this.model, n),
          state: s
        });
      }
    this.setModel(e, o, !0);
  }
  getState() {
    const e = this.state;
    if (!e.size)
      return;
    const t = {};
    let o = !1;
    return e.forEach((n, s) => {
      const i = n.state;
      i != null && (o = !0, t[s] = i);
    }), o ? t : void 0;
  }
  getModelFromFilterWrapper(e) {
    const o = e.column.getColId();
    if (e.isHandler)
      return Ot(this.model, o);
    const n = e.filter;
    return n ? typeof n.getModel != "function" ? (X(66), null) : n.getModel() : Ot(this.initialModel, o);
  }
  isFilterPresent() {
    return this.activeColumnFilters.length > 0;
  }
  isAggFilterPresent() {
    return !!this.activeAggregateFilters.length;
  }
  disableFilters() {
    this.initialModel = {};
    const { allColumnFilters: e } = this;
    return e.size ? (e.forEach(
      (t) => this.disposeFilterWrapper(t, "advancedFilterEnabled")
    ), !0) : !1;
  }
  updateActiveFilters() {
    const e = (c) => c ? c.isFilterActive ? c.isFilterActive() : (X(67), !1) : !1, { colModel: t, gos: o } = this.beans, n = !!jr(o), s = (c) => {
      if (!c.isPrimary())
        return !0;
      const u = !t.isPivotActive();
      return !c.isValueActive() || !u ? !1 : t.isPivotMode() ? !0 : n;
    }, i = [], r = [], l = (c, d, u) => {
      d && (s(c) ? i.push(u) : r.push(u));
    }, a = [];
    return this.allColumnFilters.forEach((c) => {
      const d = c.column, u = d.getColId();
      if (c.isHandler)
        a.push(
          Ye.resolve().then(() => {
            l(d, this.isHandlerActive(d), {
              colId: u,
              isHandler: !0,
              handler: c.handler,
              handlerParams: c.handlerParams
            });
          })
        );
      else {
        const h = zn(c);
        h && a.push(
          h.then((p) => {
            l(d, e(p), {
              colId: u,
              isHandler: !1,
              comp: p
            });
          })
        );
      }
    }), Ye.all(a).then(() => {
      this.activeAggregateFilters = i, this.activeColumnFilters = r;
    });
  }
  updateFilterFlagInColumns(e, t) {
    var n;
    const o = [];
    return this.allColumnFilters.forEach((s) => {
      const i = s.column;
      if (s.isHandler)
        o.push(
          Ye.resolve().then(() => {
            this.setColFilterActive(
              i,
              this.isHandlerActive(i),
              e,
              t
            );
          })
        );
      else {
        const r = zn(s);
        r && o.push(
          r.then((l) => {
            this.setColFilterActive(
              i,
              l.isFilterActive(),
              e,
              t
            );
          })
        );
      }
    }), (n = this.beans.groupFilter) == null || n.updateFilterFlags(e, t), Ye.all(o);
  }
  doFiltersPass(e, t, o) {
    const { data: n, aggData: s } = e, i = o ? this.activeAggregateFilters : this.activeColumnFilters, r = o ? s : n, l = this.model;
    for (let a = 0; a < i.length; a++) {
      const c = i[a], { colId: d, isHandler: u } = c;
      if (d !== t)
        if (u) {
          const { handler: h, handlerParams: p } = c;
          if (!h.doesFilterPass({
            node: e,
            data: r,
            model: Ot(l, d),
            handlerParams: p
          }))
            return !1;
        } else {
          const h = c.comp;
          if (typeof h.doesFilterPass != "function") {
            qe(91);
            continue;
          }
          if (!h.doesFilterPass({ node: e, data: r }))
            return !1;
        }
    }
    return !0;
  }
  getHandlerParams(e) {
    const t = this.allColumnFilters.get(e.getColId());
    return t != null && t.isHandler ? t.handlerParams : void 0;
  }
  // sometimes (especially in React) the filter can call onFilterChanged when we are in the middle
  // of a render cycle. this would be bad, so we wait for render cycle to complete when this happens.
  // this happens in react when we change React State in the grid (eg setting RowCtrl's in RowContainer)
  // which results in React State getting applied in the main application, triggering a useEffect() to
  // be kicked off adn then the application calling the grid's API. in AG-6554, the custom filter was
  // getting it's useEffect() triggered in this way.
  callOnFilterChangedOutsideRenderCycle(e) {
    const { rowRenderer: t, filterManager: o } = this.beans, n = () => {
      this.isAlive() && (o == null || o.onFilterChanged(e));
    };
    t.isRefreshInProgress() ? setTimeout(n, 0) : n();
  }
  updateBeforeFilterChanged(e = {}) {
    const { column: t, additionalEventAttributes: o } = e, n = t == null ? void 0 : t.getColId();
    return this.updateActiveFilters().then(
      () => this.updateFilterFlagInColumns("filterChanged", o).then(() => {
        this.allColumnFilters.forEach((s) => {
          var l, a, c;
          const { column: i, isHandler: r } = s;
          n !== i.getColId() && (r && ((a = (l = s.handler).onAnyFilterChanged) == null || a.call(l)), (c = zn(s, r)) == null || c.then((d) => {
            typeof (d == null ? void 0 : d.onAnyFilterChanged) == "function" && d.onAnyFilterChanged();
          }));
        }), this.processingFilterChange = !0;
      })
    );
  }
  updateAfterFilterChanged() {
    this.processingFilterChange = !1;
  }
  isSuppressFlashingCellsBecauseFiltering() {
    return !(this.gos.get("allowShowChangeAfterFilter") ?? !1) && this.processingFilterChange;
  }
  onNewRowsLoaded(e) {
    const t = [];
    this.allColumnFilters.forEach((o) => {
      var i, r;
      const n = o.isHandler;
      n && ((r = (i = o.handler).onNewRowsLoaded) == null || r.call(i));
      const s = zn(o, n);
      s && t.push(
        s.then((l) => {
          var a;
          (a = l.onNewRowsLoaded) == null || a.call(l);
        })
      );
    }), Ye.all(t).then(() => this.updateActive(e, { afterDataChange: !0 }));
  }
  updateActive(e, t) {
    this.updateFilterFlagInColumns(e, t).then(() => this.updateActiveFilters());
  }
  createGetValue(e, t) {
    const { filterValueSvc: o, colModel: n } = this.beans;
    return (s, i) => {
      const r = i ? n.getCol(i) : e;
      return r ? o.getValue(r, s, t) : void 0;
    };
  }
  isFilterActive(e) {
    const t = this.cachedFilter(e);
    if (t != null && t.isHandler)
      return this.isHandlerActive(e);
    const o = t == null ? void 0 : t.filter;
    return o ? o.isFilterActive() : Ot(this.initialModel, e.getColId()) != null;
  }
  isHandlerActive(e) {
    const t = ue(Ot(this.model, e.getColId()));
    if (t)
      return t;
    const o = this.beans.groupFilter;
    return o != null && o.isGroupFilter(e) ? o.isFilterActive(e) : !1;
  }
  getOrCreateFilterUi(e) {
    const t = this.getOrCreateFilterWrapper(e, !0);
    return t ? zn(t) : null;
  }
  getFilterUiForDisplay(e) {
    const t = this.getOrCreateFilterWrapper(e, !0);
    if (!t)
      return null;
    const o = zn(t);
    return o ? o.then((n) => ({
      comp: n,
      params: t.filterUi.filterParams,
      isHandler: t.isHandler
    })) : null;
  }
  getHandler(e, t) {
    const o = this.getOrCreateFilterWrapper(e, t);
    return o != null && o.isHandler ? o.handler : void 0;
  }
  getOrCreateFilterWrapper(e, t) {
    if (!e.isFilterAllowed())
      return;
    let o = this.cachedFilter(e);
    return !o && t && (o = this.createFilterWrapper(e), this.setColumnFilterWrapper(e, o)), o;
  }
  cachedFilter(e) {
    return this.allColumnFilters.get(e.getColId());
  }
  getDefaultFilter(e, t = !1) {
    return this.getDefaultFilterFromDataType(() => {
      var o;
      return (o = this.beans.dataTypeSvc) == null ? void 0 : o.getBaseDataType(e);
    }, t);
  }
  getDefaultFilterFromDataType(e, t = !1) {
    return RIe(this.gos) ? t ? "agSetColumnFloatingFilter" : "agSetColumnFilter" : gHe(e(), t);
  }
  getDefaultFloatingFilter(e) {
    return this.getDefaultFilter(e, !0);
  }
  createFilterComp(e, t, o, n, s, i) {
    const r = () => {
      const c = this.createFilterCompParams(e, s, i), d = n(c, s);
      return IDe(this.beans.userCompFactory, t, d, o);
    }, l = r();
    return l ? {
      compDetails: l,
      createFilterUi: (c) => (c ? r() : l).newAgStackInstance()
    } : null;
  }
  createFilterInstance(e, t, o, n) {
    var u, h;
    const s = this.beans.selectableFilter;
    s != null && s.isSelectable(t) && (t = s.getFilterDef(e, t));
    const { handler: i, handlerParams: r, handlerGenerator: l } = this.createHandler(e, t, o) ?? {}, a = this.createFilterComp(
      e,
      t,
      o,
      n,
      !!i,
      "init"
    );
    if (!a)
      return {
        compDetails: null,
        createFilterUi: null,
        handler: i,
        handlerGenerator: l,
        handlerParams: r
      };
    const { compDetails: c, createFilterUi: d } = a;
    return this.isGlobalButtons && ((h = (u = c.params) == null ? void 0 : u.buttons) != null && h.length || X(281, { colId: e.getColId() })), {
      compDetails: c,
      handler: i,
      handlerGenerator: l,
      handlerParams: r,
      createFilterUi: d
    };
  }
  createBaseFilterParams(e, t) {
    const { filterManager: o, rowModel: n } = this.beans;
    return Pe(this.gos, {
      column: e,
      colDef: e.getColDef(),
      getValue: this.createGetValue(e),
      doesRowPassOtherFilter: t ? () => !0 : (s) => (o == null ? void 0 : o.doesRowPassOtherFilters(e.getColId(), s)) ?? !0,
      // to avoid breaking changes to `filterParams` defined as functions
      // we need to provide the below options even though they are not valid for handlers
      rowModel: n
    });
  }
  createFilterCompParams(e, t, o, n) {
    const s = this.filterChangedCallbackFactory(e), i = this.createBaseFilterParams(e, n);
    if (i.filterChangedCallback = s, i.filterModifiedCallback = n ? () => {
    } : (r) => this.filterModified(e, r), t) {
      const r = i, l = e.getColId(), a = Ot(this.model, l);
      r.model = a, r.state = this.state.get(l) ?? {
        model: a
      }, r.onModelChange = (c, d) => {
        this.updateStoredModel(l, c), this.refreshHandlerAndUi(e, c, "ui").then(() => {
          s({ ...d, source: "columnFilter" });
        });
      }, r.onStateChange = (c) => {
        this.updateState(e, c), this.updateOrRefreshFilterUi(e);
      }, r.onAction = (c, d, u) => {
        this.updateModel(e, c, d), this.dispatchLocalEvent({
          type: "filterAction",
          column: e,
          action: c,
          event: u
        });
      }, r.getHandler = () => this.getHandler(e, !0), r.onUiChange = (c) => this.filterUiChanged(e, c), r.source = o;
    }
    return i;
  }
  createFilterUiForHandler(e, t) {
    return t ? {
      created: !1,
      create: t,
      filterParams: e.params,
      compDetails: e
    } : null;
  }
  createFilterUiLegacy(e, t, o) {
    const n = t(), s = {
      created: !0,
      create: t,
      filterParams: e.params,
      compDetails: e,
      promise: n
    };
    return n.then(o), s;
  }
  createFilterWrapper(e) {
    var l;
    const { compDetails: t, handler: o, handlerGenerator: n, handlerParams: s, createFilterUi: i } = this.createFilterInstance(
      e,
      e.getColDef(),
      this.getDefaultFilter(e),
      (a) => a
    ), r = e.getColId();
    if (o)
      return delete this.initialModel[r], (l = o.init) == null || l.call(o, {
        ...s,
        source: "init",
        model: Ot(this.model, r)
      }), {
        column: e,
        isHandler: !0,
        handler: o,
        handlerGenerator: n,
        handlerParams: s,
        filterUi: this.createFilterUiForHandler(t, i)
      };
    if (i) {
      const a = {
        column: e,
        filterUi: null,
        isHandler: !1
      };
      return a.filterUi = this.createFilterUiLegacy(t, i, (c) => {
        a.filter = c ?? void 0;
      }), a;
    }
    return {
      column: e,
      filterUi: null,
      isHandler: !1
    };
  }
  createHandlerFunc(e, t, o) {
    var p;
    const { gos: n, frameworkOverrides: s, registry: i } = this.beans;
    let r;
    const l = (C) => {
      const m = C.filter;
      if (qw(m)) {
        const w = m.handler;
        return w || (r = m.doesFilterPass, r ? () => ({
          doesFilterPass: r
        }) : void 0);
      }
      return typeof m == "string" ? m : void 0;
    }, a = n.get("enableFilterHandlers"), c = a ? l(t) : void 0, d = (C) => () => this.createBean(i.createDynamicBean(C, !0));
    let u, h;
    if (typeof c == "string") {
      const C = (p = n.get("filterHandlers")) == null ? void 0 : p[c];
      C != null ? u = C : oHe.has(c) && (u = d(c), h = c);
    } else
      u = c;
    if (!u) {
      let C;
      const { compName: m, jsComp: w, fwComp: y } = Xw(s, t);
      m ? C = m : w == null && y == null && t.filter === !0 && (C = o), h = this.handlerMap[C], h && (u = d(h));
    }
    return u ? { filterHandler: u, handlerNameOrCallback: r ?? h } : a ? (dt(n) && X(277, { colId: e.getColId() }), yze) : void 0;
  }
  createHandler(e, t, o) {
    const n = this.createHandlerFunc(e, t, o);
    if (!n)
      return;
    const s = Ya(
      this.beans.userCompFactory,
      t,
      this.createFilterCompParams(e, !0, "init")
    ), { handlerNameOrCallback: i, filterHandler: r } = n, { handler: l, handlerParams: a } = this.createHandlerFromFunc(e, r, s);
    return {
      handler: l,
      handlerParams: a,
      handlerGenerator: i ?? r
    };
  }
  createHandlerFromFunc(e, t, o) {
    const n = e.getColDef(), s = t(Pe(this.gos, { column: e, colDef: n })), i = this.createHandlerParams(e, o);
    return { handler: s, handlerParams: i };
  }
  createHandlerParams(e, t) {
    const o = e.getColDef(), n = e.getColId(), s = this.filterChangedCallbackFactory(e);
    return Pe(this.gos, {
      colDef: o,
      column: e,
      getValue: this.createGetValue(e),
      doesRowPassOtherFilter: (i) => {
        var r;
        return ((r = this.beans.filterManager) == null ? void 0 : r.doesRowPassOtherFilters(n, i)) ?? !0;
      },
      onModelChange: (i, r) => {
        this.updateStoredModel(n, i), this.refreshHandlerAndUi(e, i, "handler").then(() => {
          s({ ...r, source: "columnFilter" });
        });
      },
      filterParams: t
    });
  }
  onColumnsChanged() {
    const e = [], { colModel: t, filterManager: o, groupFilter: n } = this.beans;
    this.allColumnFilters.forEach((i, r) => {
      let l;
      i.column.isPrimary() ? l = t.getColDefCol(r) : l = t.getCol(r), !(l && l === i.column) && (e.push(i.column), this.disposeFilterWrapper(i, "columnChanged"), this.disposeColumnListener(r));
    });
    const s = n && e.every((i) => n.isGroupFilter(i));
    e.length > 0 && !s && (o == null || o.onFilterChanged({ columns: e, source: "api" }));
  }
  isFilterAllowed(e) {
    if (!e.isFilterAllowed())
      return !1;
    const o = this.beans.groupFilter;
    return o != null && o.isGroupFilter(e) ? o.isFilterAllowed(e) : !0;
  }
  getFloatingFilterCompDetails(e, t) {
    const { userCompFactory: o, frameworkOverrides: n, selectableFilter: s } = this.beans, i = (h) => {
      const p = this.getOrCreateFilterUi(e);
      p != null && p.then((C) => {
        h(zi(C));
      });
    }, r = e.getColDef(), l = s != null && s.isSelectable(r) ? s.getFilterDef(e, r) : r, a = fHe(n, l, () => this.getDefaultFloatingFilter(e)) ?? "agReadOnlyFloatingFilter", c = this.gos.get("enableFilterHandlers"), d = Ya(
      o,
      l,
      this.createFilterCompParams(e, c, "init", !0)
    ), u = Pe(this.gos, {
      column: e,
      filterParams: d,
      currentParentModel: () => this.getCurrentFloatingFilterParentModel(e),
      parentFilterInstance: i,
      showParentFilter: t
    });
    if (c) {
      const h = u, p = e.getColId(), C = this.filterChangedCallbackFactory(e);
      h.onUiChange = (m) => this.floatingFilterUiChanged(e, m), h.model = Ot(this.model, p), h.onModelChange = (m, w) => {
        this.updateStoredModel(p, m), this.refreshHandlerAndUi(e, m, "floating", !0).then(() => {
          C({ ...w, source: "columnFilter" });
        });
      }, h.getHandler = () => this.getHandler(e, !0), h.source = "init";
    }
    return ODe(o, r, u, a);
  }
  getCurrentFloatingFilterParentModel(e) {
    return this.getModelFromFilterWrapper(this.cachedFilter(e) ?? { column: e });
  }
  destroyFilterUi(e, t, o, n) {
    if (e.isHandler) {
      const s = t.getColId();
      delete this.initialModel[s], this.state.delete(s);
      const i = e.filterUi, r = this.createFilterUiForHandler(o, n);
      e.filterUi = r, i != null && i.created && i.promise.then((l) => {
        this.destroyBean(l), this.eventSvc.dispatchEvent({
          type: "filterDestroyed",
          source: "paramsUpdated",
          column: e.column
        });
      });
    } else
      this.destroyFilter(t, "paramsUpdated");
  }
  // destroys the filter, so it no longer takes part
  destroyFilter(e, t = "api") {
    const o = e.getColId(), n = this.allColumnFilters.get(o);
    this.disposeColumnListener(o), delete this.initialModel[o], n && this.disposeFilterWrapper(n, t).then((s) => {
      var i;
      s && this.isAlive() && ((i = this.beans.filterManager) == null || i.onFilterChanged({
        columns: [e],
        source: "api"
      }));
    });
  }
  disposeColumnListener(e) {
    const t = this.allColumnListeners.get(e);
    t && (this.allColumnListeners.delete(e), t());
  }
  disposeFilterWrapper(e, t) {
    let o = !1;
    const { column: n, isHandler: s, filterUi: i } = e, r = n.getColId();
    s && (o = this.isHandlerActive(n), this.destroyBean(e.handler), delete this.model[r], this.state.delete(r));
    const l = () => {
      this.setColFilterActive(n, !1, "filterDestroyed"), this.allColumnFilters.delete(r), this.eventSvc.dispatchEvent({
        type: "filterDestroyed",
        source: t,
        column: n
      });
    };
    if (i) {
      if (i.created)
        return i.promise.then((a) => (o = s ? o : !!(a != null && a.isFilterActive()), this.destroyBean(a), l(), o));
      l();
    }
    return Ye.resolve(o);
  }
  filterChangedCallbackFactory(e) {
    return (t) => {
      this.callOnFilterChangedOutsideRenderCycle({
        additionalEventAttributes: t,
        columns: [e],
        column: e,
        source: (t == null ? void 0 : t.source) ?? "columnFilter"
      });
    };
  }
  filterParamsChanged(e, t = "api") {
    var w, y, b, _, M, x;
    const o = this.allColumnFilters.get(e);
    if (!o)
      return;
    const n = this.beans, s = o.column, i = s.getColDef(), r = s.isFilterAllowed(), l = this.getDefaultFilter(s), a = n.selectableFilter, c = a != null && a.isSelectable(i) ? a.getFilterDef(s, i) : i, d = r ? this.createHandlerFunc(s, c, this.getDefaultFilter(s)) : void 0, u = !!d, h = o.isHandler;
    if (h != u) {
      this.destroyFilter(s, "paramsUpdated");
      return;
    }
    const { compDetails: p, createFilterUi: C } = (r ? this.createFilterComp(s, c, l, (L) => L, u, "colDef") : null) ?? { compDetails: null, createFilterUi: null }, m = (p == null ? void 0 : p.params) ?? Ya(
      n.userCompFactory,
      c,
      this.createFilterCompParams(s, u, "colDef")
    );
    if (h) {
      const L = (d == null ? void 0 : d.handlerNameOrCallback) ?? (d == null ? void 0 : d.filterHandler), A = Ot(this.model, e);
      if (o.handlerGenerator != L) {
        const R = o.handler, { handler: P, handlerParams: I } = this.createHandlerFromFunc(
          s,
          d.filterHandler,
          m
        );
        o.handler = P, o.handlerParams = I, o.handlerGenerator = L, delete this.model[e], (w = P.init) == null || w.call(P, { ...I, source: "init", model: null }), this.destroyBean(R), A != null && ((y = this.beans.filterManager) == null || y.onFilterChanged({
          columns: [s],
          source: t
        }));
      } else {
        const R = this.createHandlerParams(s, p == null ? void 0 : p.params);
        o.handlerParams = R, (_ = (b = o.handler).refresh) == null || _.call(b, {
          ...R,
          source: "colDef",
          model: A
        });
      }
    }
    if (this.areFilterCompsDifferent(((M = o.filterUi) == null ? void 0 : M.compDetails) ?? null, p) || !o.filterUi || !p) {
      this.destroyFilterUi(o, s, p, C);
      return;
    }
    o.filterUi.filterParams = m, (x = zn(o, h)) == null || x.then((L) => {
      (L != null && L.refresh ? L.refresh(m) : !0) === !1 ? this.destroyFilterUi(o, s, p, C) : this.dispatchLocalEvent({
        type: "filterParamsChanged",
        column: s,
        params: m
      });
    });
  }
  refreshHandlerAndUi(e, t, o, n) {
    const s = this.cachedFilter(e);
    if (!s)
      return n && this.getOrCreateFilterWrapper(e, !0), Ye.resolve();
    if (!s.isHandler)
      return Ye.resolve();
    const { filterUi: i, handler: r, handlerParams: l } = s;
    return nHe(
      () => {
        if (i) {
          const { created: a, filterParams: c } = i;
          if (a)
            return i.promise.then((d) => d ? { filter: d, filterParams: c } : void 0);
          i.refreshed = !0;
        }
        return Ye.resolve(void 0);
      },
      r,
      l,
      t,
      this.state.get(e.getColId()) ?? { model: t },
      o
    );
  }
  setColumnFilterWrapper(e, t) {
    const o = e.getColId();
    this.allColumnFilters.set(o, t), this.allColumnListeners.set(
      o,
      this.addManagedListeners(e, { colDefChanged: () => this.filterParamsChanged(o) })[0]
    );
  }
  areFilterCompsDifferent(e, t) {
    if (!t || !e)
      return !0;
    const { componentClass: o } = e, { componentClass: n } = t;
    return !(o === n || // react hooks returns new wrappers, so check nested render method
    (o == null ? void 0 : o.render) && (n == null ? void 0 : n.render) && o.render === n.render);
  }
  hasFloatingFilters() {
    return this.beans.colModel.getCols().some((t) => t.getColDef().floatingFilter);
  }
  getFilterInstance(e) {
    const t = this.beans.colModel.getColDefCol(e);
    if (!t)
      return Promise.resolve(void 0);
    const o = this.getOrCreateFilterUi(t);
    return o ? new Promise((n) => {
      o.then((s) => {
        n(zi(s));
      });
    }) : Promise.resolve(null);
  }
  processFilterModelUpdateQueue() {
    this.modelUpdates.forEach(({ model: e, source: t }) => this.setModel(e, t)), this.modelUpdates = [], this.columnModelUpdates.forEach(({ key: e, model: t, resolve: o }) => {
      this.setModelForColumn(e, t).then(() => o());
    }), this.columnModelUpdates = [];
  }
  getModelForColumn(e, t) {
    if (t) {
      const { state: n, model: s } = this, i = e.getColId(), r = n.get(i);
      return r ? r.model ?? null : Ot(s, i);
    }
    const o = this.cachedFilter(e);
    return o ? this.getModelFromFilterWrapper(o) : null;
  }
  setModelForColumn(e, t) {
    var o;
    if ((o = this.beans.dataTypeSvc) != null && o.isPendingInference) {
      let n = () => {
      };
      const s = new Promise((i) => {
        n = i;
      });
      return this.columnModelUpdates.push({ key: e, model: t, resolve: n }), s;
    }
    return new Promise((n) => {
      this.setModelForColumnLegacy(e, t).then((s) => n(s));
    });
  }
  getStateForColumn(e) {
    return this.state.get(e) ?? {
      model: Ot(this.model, e)
    };
  }
  setModelForColumnLegacy(e, t) {
    const o = this.beans.colModel.getColDefCol(e), n = o ? this.getOrCreateFilterWrapper(o, !0) : null;
    return n ? this.setModelOnFilterWrapper(n, t) : Ye.resolve();
  }
  setColDefPropsForDataType(e, t, o) {
    var d;
    const n = e.filter, s = n === !0 ? this.getDefaultFilterFromDataType(() => t.baseDataType) : n;
    if (typeof s != "string")
      return;
    let i, r;
    const l = this.beans, { filterParams: a, filterValueGetter: c } = e;
    s === "agMultiColumnFilter" ? { filterParams: i, filterValueGetter: r } = ((d = l.multiFilter) == null ? void 0 : d.getParamsForDataType(
      a,
      c,
      t,
      o
    )) ?? {} : { filterParams: i, filterValueGetter: r } = dHe(
      s,
      a,
      c,
      t,
      o,
      l,
      this.getLocaleTextFunc()
    ), e.filterParams = i, r && (e.filterValueGetter = r);
  }
  // additionalEventAttributes is used by provided simple floating filter, so it can add 'floatingFilter=true' to the event
  setColFilterActive(e, t, o, n) {
    e.filterActive !== t && (e.filterActive = t, e.dispatchColEvent("filterActiveChanged", o)), e.dispatchColEvent("filterChanged", o, n);
  }
  setModelOnFilterWrapper(e, t, o) {
    return new Ye((n) => {
      if (e.isHandler) {
        const i = e.column, r = i.getColId(), l = this.model[r];
        if (this.updateStoredModel(r, t), o && t === l) {
          n();
          return;
        }
        this.refreshHandlerAndUi(i, t, "api").then(() => n());
        return;
      }
      const s = zn(e);
      if (s) {
        s.then((i) => {
          if (typeof (i == null ? void 0 : i.setModel) != "function") {
            X(65), n();
            return;
          }
          (i.setModel(t) || Ye.resolve()).then(() => n());
        });
        return;
      }
      n();
    });
  }
  /** for handlers only */
  updateStoredModel(e, t) {
    ue(t) ? this.model[e] = t : delete this.model[e];
    const o = this.state.get(e), n = {
      model: t,
      state: o == null ? void 0 : o.state
    };
    this.state.set(e, n);
  }
  filterModified(e, t) {
    var o;
    (o = this.getOrCreateFilterUi(e)) == null || o.then((n) => {
      this.eventSvc.dispatchEvent({
        type: "filterModified",
        column: e,
        filterInstance: n,
        ...t
      });
    });
  }
  filterUiChanged(e, t) {
    this.gos.get("enableFilterHandlers") && this.eventSvc.dispatchEvent({
      type: "filterUiChanged",
      column: e,
      ...t
    });
  }
  floatingFilterUiChanged(e, t) {
    this.gos.get("enableFilterHandlers") && this.eventSvc.dispatchEvent({
      type: "floatingFilterUiChanged",
      column: e,
      ...t
    });
  }
  updateModel(e, t, o) {
    var r;
    const n = e.getColId(), s = this.cachedFilter(e), i = () => s == null ? void 0 : s.filterUi;
    Od(
      t,
      i,
      () => Ot(this.model, n),
      () => this.state.get(n),
      (l) => this.updateState(e, l),
      (l) => {
        var a, c;
        return (c = (a = i()) == null ? void 0 : a.filterParams) == null ? void 0 : c.onModelChange(l, o);
      },
      s != null && s.isHandler ? (r = s.handler.processModelToApply) == null ? void 0 : r.bind(s.handler) : void 0
    );
  }
  updateAllModels(e, t) {
    const o = [];
    this.allColumnFilters.forEach((n, s) => {
      var r;
      const i = this.beans.colModel.getColDefCol(s);
      i && Od(
        e,
        () => n.filterUi,
        () => Ot(this.model, s),
        () => this.state.get(s),
        (l) => this.updateState(i, l),
        (l) => {
          this.updateStoredModel(s, l), this.dispatchLocalEvent({
            type: "filterAction",
            column: i,
            action: e
          }), o.push(this.refreshHandlerAndUi(i, l, "ui"));
        },
        n != null && n.isHandler ? (r = n.handler.processModelToApply) == null ? void 0 : r.bind(n.handler) : void 0
      );
    }), o.length && Ye.all(o).then(() => {
      this.callOnFilterChangedOutsideRenderCycle({
        source: "columnFilter",
        additionalEventAttributes: t,
        columns: []
      });
    });
  }
  updateOrRefreshFilterUi(e) {
    const t = e.getColId();
    wb(
      () => {
        var o;
        return (o = this.cachedFilter(e)) == null ? void 0 : o.filterUi;
      },
      () => Ot(this.model, t),
      () => this.state.get(t)
    );
  }
  updateState(e, t) {
    this.state.set(e.getColId(), t), this.dispatchLocalEvent({
      type: "filterStateChanged",
      column: e,
      state: t
    });
  }
  // for tool panel only
  canApplyAll() {
    const { state: e, model: t, activeFilterComps: o } = this;
    for (const s of o)
      if (s.source === "COLUMN_MENU")
        return !1;
    let n = !1;
    for (const s of e.keys()) {
      const i = e.get(s);
      if (i.valid === !1)
        return !1;
      (i.model ?? null) !== Ot(t, s) && (n = !0);
    }
    return n;
  }
  hasUnappliedModel(e) {
    var n;
    const { model: t, state: o } = this;
    return (((n = o.get(e)) == null ? void 0 : n.model) ?? null) !== Ot(t, e);
  }
  setGlobalButtons(e) {
    this.isGlobalButtons = e, this.dispatchLocalEvent({
      type: "filterGlobalButtons",
      isGlobal: e
    });
  }
  shouldKeepStateOnDetach(e, t) {
    if (t === "newFiltersToolPanel")
      return !0;
    const o = this.beans.filterPanelSvc;
    return o != null && o.isActive ? !!o.getState(e.getColId()) : !1;
  }
  destroy() {
    super.destroy(), this.allColumnFilters.forEach((e) => this.disposeFilterWrapper(e, "gridDestroyed")), this.allColumnListeners.clear(), this.state.clear(), this.activeFilterComps.clear();
  }
};
function Sze(e) {
  var t;
  return !!((t = e.filterManager) != null && t.isAnyFilterPresent());
}
function xze(e, t = "api") {
  var o;
  (o = e.filterManager) == null || o.onFilterChanged({ source: t });
}
var Mze = class extends K {
  constructor() {
    super(...arguments), this.beanName = "filterManager", this.advFilterModelUpdateQueue = [];
  }
  wireBeans(e) {
    this.quickFilter = e.quickFilter, this.advancedFilter = e.advancedFilter, this.colFilter = e.colFilter;
  }
  postConstruct() {
    const e = this.refreshFiltersForAggregations.bind(this), t = this.updateAdvFilterColumns.bind(this);
    this.addManagedEventListeners({
      columnValueChanged: e,
      columnPivotChanged: e,
      columnPivotModeChanged: e,
      newColumnsLoaded: t,
      columnVisible: t,
      advancedFilterEnabledChanged: ({ enabled: n }) => this.onAdvFilterEnabledChanged(n),
      dataTypesInferred: this.processFilterModelUpdateQueue.bind(this)
    }), this.externalFilterPresent = this.isExternalFilterPresentCallback(), this.addManagedPropertyListeners(["isExternalFilterPresent", "doesExternalFilterPass"], () => {
      this.onFilterChanged({ source: "api" });
    }), this.updateAggFiltering(), this.addManagedPropertyListener("groupAggFiltering", () => {
      this.updateAggFiltering(), this.onFilterChanged();
    }), this.quickFilter && this.addManagedListeners(this.quickFilter, {
      quickFilterChanged: () => this.onFilterChanged({ source: "quickFilter" })
    });
    const { gos: o } = this;
    this.alwaysPassFilter = o.get("alwaysPassFilter"), this.addManagedPropertyListener("alwaysPassFilter", () => {
      this.alwaysPassFilter = o.get("alwaysPassFilter"), this.onFilterChanged({ source: "api" });
    });
  }
  isExternalFilterPresentCallback() {
    const e = this.gos.getCallback("isExternalFilterPresent");
    return typeof e == "function" && e({});
  }
  doesExternalFilterPass(e) {
    const t = this.gos.get("doesExternalFilterPass");
    return typeof t == "function" && t(e);
  }
  setFilterState(e, t, o = "api") {
    var n;
    this.isAdvFilterEnabled() || (n = this.colFilter) == null || n.setState(e, t, o);
  }
  setFilterModel(e, t = "api", o) {
    var n;
    if (this.isAdvFilterEnabled()) {
      o || this.warnAdvFilters();
      return;
    }
    (n = this.colFilter) == null || n.setModel(e, t);
  }
  getFilterModel() {
    var e;
    return ((e = this.colFilter) == null ? void 0 : e.getModel()) ?? {};
  }
  getFilterState() {
    var e;
    return (e = this.colFilter) == null ? void 0 : e.getState();
  }
  isColumnFilterPresent() {
    var e;
    return !!((e = this.colFilter) != null && e.isFilterPresent());
  }
  isAggregateFilterPresent() {
    var e;
    return !!((e = this.colFilter) != null && e.isAggFilterPresent());
  }
  isChildFilterPresent() {
    return this.isColumnFilterPresent() || this.isQuickFilterPresent() || this.externalFilterPresent || this.isAdvFilterPresent();
  }
  isAnyFilterPresent() {
    return this.isChildFilterPresent() || this.isAggregateFilterPresent();
  }
  isAdvFilterPresent() {
    return this.isAdvFilterEnabled() && this.advancedFilter.isFilterPresent();
  }
  onAdvFilterEnabledChanged(e) {
    var t, o;
    e ? (t = this.colFilter) != null && t.disableFilters() && this.onFilterChanged({ source: "advancedFilter" }) : (o = this.advancedFilter) != null && o.isFilterPresent() && (this.advancedFilter.setModel(null), this.onFilterChanged({ source: "advancedFilter" }));
  }
  isAdvFilterEnabled() {
    var e;
    return !!((e = this.advancedFilter) != null && e.isEnabled());
  }
  isAdvFilterHeaderActive() {
    return this.isAdvFilterEnabled() && this.advancedFilter.isHeaderActive();
  }
  refreshFiltersForAggregations() {
    jr(this.gos) && this.isAnyFilterPresent() && this.onFilterChanged();
  }
  onFilterChanged(e = {}) {
    const { source: t, additionalEventAttributes: o, columns: n = [] } = e;
    this.externalFilterPresent = this.isExternalFilterPresentCallback(), (this.colFilter ? this.colFilter.updateBeforeFilterChanged(e) : Ye.resolve()).then(() => {
      var i;
      const s = {
        source: t,
        type: "filterChanged",
        columns: n
      };
      o && qt(s, o), this.eventSvc.dispatchEvent(s), (i = this.colFilter) == null || i.updateAfterFilterChanged();
    });
  }
  isSuppressFlashingCellsBecauseFiltering() {
    var e;
    return !!((e = this.colFilter) != null && e.isSuppressFlashingCellsBecauseFiltering());
  }
  isQuickFilterPresent() {
    var e;
    return !!((e = this.quickFilter) != null && e.isFilterPresent());
  }
  updateAggFiltering() {
    this.aggFiltering = !!jr(this.gos);
  }
  isAggregateQuickFilterPresent() {
    return this.isQuickFilterPresent() && this.shouldApplyQuickFilterAfterAgg();
  }
  isNonAggregateQuickFilterPresent() {
    return this.isQuickFilterPresent() && !this.shouldApplyQuickFilterAfterAgg();
  }
  shouldApplyQuickFilterAfterAgg() {
    return (this.aggFiltering || this.beans.colModel.isPivotMode()) && !this.gos.get("applyQuickFilterBeforePivotOrAgg");
  }
  doesRowPassOtherFilters(e, t) {
    return this.doesRowPassFilter({ rowNode: t, colIdToSkip: e });
  }
  doesRowPassAggregateFilters(e) {
    var o;
    const { rowNode: t } = e;
    return (o = this.alwaysPassFilter) != null && o.call(this, t) ? !0 : !(this.isAggregateQuickFilterPresent() && !this.quickFilter.doesRowPass(t) || this.isAggregateFilterPresent() && !this.colFilter.doFiltersPass(t, e.colIdToSkip, !0));
  }
  doesRowPassFilter(e) {
    var o;
    const { rowNode: t } = e;
    return (o = this.alwaysPassFilter) != null && o.call(this, t) ? !0 : !(this.isNonAggregateQuickFilterPresent() && !this.quickFilter.doesRowPass(t) || this.externalFilterPresent && !this.doesExternalFilterPass(t) || this.isColumnFilterPresent() && !this.colFilter.doFiltersPass(t, e.colIdToSkip) || this.isAdvFilterPresent() && !this.advancedFilter.doesFilterPass(t));
  }
  // for group filters, can change dynamically whether they are allowed or not
  isFilterAllowed(e) {
    var t;
    return this.isAdvFilterEnabled() ? !1 : !!((t = this.colFilter) != null && t.isFilterAllowed(e));
  }
  getAdvFilterModel() {
    return this.isAdvFilterEnabled() ? this.advancedFilter.getModel() : null;
  }
  setAdvFilterModel(e, t = "api") {
    var o;
    if (this.isAdvFilterEnabled()) {
      if ((o = this.beans.dataTypeSvc) != null && o.isPendingInference) {
        this.advFilterModelUpdateQueue.push(e);
        return;
      }
      this.advancedFilter.setModel(e ?? null), this.onFilterChanged({ source: t });
    }
  }
  toggleAdvFilterBuilder(e, t) {
    this.isAdvFilterEnabled() && this.advancedFilter.getCtrl().toggleFilterBuilder({ source: t, force: e });
  }
  updateAdvFilterColumns() {
    this.isAdvFilterEnabled() && this.advancedFilter.updateValidity() && this.onFilterChanged({ source: "advancedFilter" });
  }
  hasFloatingFilters() {
    var e;
    return this.isAdvFilterEnabled() ? !1 : !!((e = this.colFilter) != null && e.hasFloatingFilters());
  }
  getColumnFilterInstance(e) {
    var t;
    return this.isAdvFilterEnabled() ? (this.warnAdvFilters(), Promise.resolve(void 0)) : ((t = this.colFilter) == null ? void 0 : t.getFilterInstance(e)) ?? Promise.resolve(void 0);
  }
  warnAdvFilters() {
    X(68);
  }
  setupAdvFilterHeaderComp(e) {
    var t;
    (t = this.advancedFilter) == null || t.getCtrl().setupHeaderComp(e);
  }
  getHeaderRowCount() {
    return this.isAdvFilterHeaderActive() ? 1 : 0;
  }
  getHeaderHeight() {
    return this.isAdvFilterHeaderActive() ? this.advancedFilter.getCtrl().getHeaderHeight() : 0;
  }
  processFilterModelUpdateQueue() {
    this.advFilterModelUpdateQueue.forEach((e) => this.setAdvFilterModel(e)), this.advFilterModelUpdateQueue = [];
  }
  setColumnFilterModel(e, t) {
    var o;
    return this.isAdvFilterEnabled() ? (this.warnAdvFilters(), Promise.resolve()) : ((o = this.colFilter) == null ? void 0 : o.setModelForColumn(e, t)) ?? Promise.resolve();
  }
}, Aze = class extends K {
  constructor() {
    super(...arguments), this.beanName = "filterMenuFactory";
  }
  wireBeans(e) {
    this.popupSvc = e.popupSvc;
  }
  hideActiveMenu() {
    var e;
    (e = this.hidePopup) == null || e.call(this);
  }
  showMenuAfterMouseEvent(e, t, o, n) {
    e && !e.isColumn || this.showPopup(
      e,
      (s) => {
        var i;
        (i = this.popupSvc) == null || i.positionPopupUnderMouseEvent({
          column: e,
          type: o,
          mouseEvent: t,
          ePopup: s
        });
      },
      o,
      t.target,
      $t(this.gos),
      n
    );
  }
  showMenuAfterButtonClick(e, t, o, n) {
    if (e && !e.isColumn)
      return;
    let s = -1, i = "left";
    const r = $t(this.gos);
    !r && this.gos.get("enableRtl") && (s = 1, i = "right");
    const l = r ? void 0 : 4 * s, a = r ? void 0 : 4;
    this.showPopup(
      e,
      (c) => {
        var d;
        (d = this.popupSvc) == null || d.positionPopupByComponent({
          type: o,
          eventSource: t,
          ePopup: c,
          nudgeX: l,
          nudgeY: a,
          alignSide: i,
          keepWithinBounds: !0,
          position: "under",
          column: e
        });
      },
      o,
      t,
      r,
      n
    );
  }
  showPopup(e, t, o, n, s, i) {
    var m;
    const r = e ? this.createBean(new bb(e, "COLUMN_MENU")) : void 0;
    if (this.activeMenu = r, !(r != null && r.hasFilter()) || !e) {
      qe(57);
      return;
    }
    const l = ze({
      tag: "div",
      cls: `ag-menu${s ? "" : " ag-filter-menu"}`,
      role: "presentation"
    });
    [this.tabListener] = this.addManagedElementListeners(l, {
      keydown: (w) => this.trapFocusWithin(w, l)
    }), l.appendChild(r == null ? void 0 : r.getGui());
    let a;
    const c = () => r == null ? void 0 : r.afterGuiDetached(), d = Tw(this.gos) ? n ?? this.beans.ctrlsSvc.getGridBodyCtrl().eGridBody : void 0, u = (w) => {
      Il(e, !1, "contextMenu");
      const y = w instanceof KeyboardEvent;
      if (this.tabListener && (this.tabListener = this.tabListener()), y && n && ro(n)) {
        const b = H2(n);
        b == null || b.focus({ preventScroll: !0 });
      }
      c(), this.destroyBean(this.activeMenu), this.dispatchVisibleChangedEvent(!1, o, e), i == null || i();
    }, h = this.getLocaleTextFunc(), p = s && o !== "columnFilter" ? h("ariaLabelColumnMenu", "Column Menu") : h("ariaLabelColumnFilter", "Column Filter"), C = (m = this.popupSvc) == null ? void 0 : m.addPopup({
      modal: !0,
      eChild: l,
      closeOnEsc: !0,
      closedCallback: u,
      positionCallback: () => t(l),
      anchorToElement: d,
      ariaLabel: p
    });
    C && (this.hidePopup = a = C.hideFunc), r.afterInit().then(() => {
      t(l), r.afterGuiAttached({ container: o, hidePopup: a });
    }), Il(e, !0, "contextMenu"), this.dispatchVisibleChangedEvent(!0, o, e);
  }
  trapFocusWithin(e, t) {
    e.key !== D.TAB || e.defaultPrevented || Yt(this.beans, t, !1, e.shiftKey) || (e.preventDefault(), so(t, e.shiftKey));
  }
  dispatchVisibleChangedEvent(e, t, o) {
    this.eventSvc.dispatchEvent({
      type: "columnMenuVisibleChanged",
      visible: e,
      switchingTab: !1,
      key: t,
      column: o ?? null,
      columnGroup: null
    });
  }
  isMenuEnabled(e) {
    return e.isFilterAllowed() && (e.getColDef().menuTabs ?? ["filterMenuTab"]).includes("filterMenuTab");
  }
  showMenuAfterContextMenuEvent() {
  }
  destroy() {
    this.destroyBean(this.activeMenu), super.destroy();
  }
}, Lze = class extends K {
  constructor() {
    super(...arguments), this.beanName = "filterValueSvc";
  }
  getValue(e, t, o) {
    if (!t)
      return;
    const n = e.getColDef(), { selectableFilter: s, valueSvc: i } = this.beans, r = o ?? (s == null ? void 0 : s.getFilterValueGetter(e.getColId())) ?? n.filterValueGetter;
    return r ? this.executeFilterValueGetter(r, t.data, e, t, n) : i.getValue(e, t);
  }
  executeFilterValueGetter(e, t, o, n, s) {
    const { expressionSvc: i, valueSvc: r } = this.beans, l = Pe(this.gos, {
      data: t,
      node: n,
      column: o,
      colDef: s,
      getValue: r.getValueCallback.bind(r, n)
    });
    return typeof e == "function" ? e(l) : i == null ? void 0 : i.evaluate(e, l);
  }
}, Eze = {
  tag: "div",
  cls: "ag-floating-filter-input",
  role: "presentation",
  children: [
    {
      tag: "ag-input-text-field",
      ref: "eFloatingFilterText"
    }
  ]
}, Pze = class extends Re {
  constructor() {
    super(Eze, [zo]), this.eFloatingFilterText = J;
  }
  init(e) {
    this.params = e;
    const t = this.beans.colNames.getDisplayNameForColumn(e.column, "header", !0);
    if (this.eFloatingFilterText.setDisabled(!0).setInputAriaLabel(`${t} ${this.getLocaleTextFunc()("ariaFilterInput", "Filter Input")}`), this.gos.get("enableFilterHandlers")) {
      const o = e, n = o.getHandler();
      if (n.getModelAsString) {
        const s = n.getModelAsString(o.model);
        this.eFloatingFilterText.setValue(s);
      }
    }
  }
  onParentModelChanged(e) {
    if (e == null) {
      this.eFloatingFilterText.setValue("");
      return;
    }
    this.params.parentFilterInstance((t) => {
      if (t.getModelAsString) {
        const o = t.getModelAsString(e);
        this.eFloatingFilterText.setValue(o);
      }
    });
  }
  refresh(e) {
    this.init(e);
  }
}, ac = class {
  constructor() {
    this.customFilterOptions = {};
  }
  init(e, t) {
    this.filterOptions = e.filterOptions ?? t, this.mapCustomOptions(), this.defaultOption = this.getDefaultItem(e.defaultOption);
  }
  refresh(e, t) {
    const o = e.filterOptions ?? t;
    this.filterOptions !== o && (this.filterOptions = o, this.customFilterOptions = {}, this.mapCustomOptions()), this.defaultOption = this.getDefaultItem(e.defaultOption);
  }
  mapCustomOptions() {
    const { filterOptions: e } = this;
    e && e.forEach((t) => {
      if (typeof t == "string")
        return;
      const o = [["displayKey"], ["displayName"], ["predicate", "test"]], n = (s) => s.some((i) => t[i] != null) ? !0 : (X(72, { keys: s }), !1);
      if (!o.every(n)) {
        this.filterOptions = e.filter((s) => s === t) || [];
        return;
      }
      this.customFilterOptions[t.displayKey] = t;
    });
  }
  getDefaultItem(e) {
    const { filterOptions: t } = this;
    if (e)
      return e;
    if (t.length >= 1) {
      const o = t[0];
      if (typeof o == "string")
        return o;
      if (o.displayKey)
        return o.displayKey;
      X(73);
    } else
      X(74);
  }
  getCustomOption(e) {
    return this.customFilterOptions[e];
  }
};
function Ir(e, t, o) {
  return o == null ? e.splice(t) : e.splice(t, o);
}
function Ol(e) {
  return e == null || typeof e == "string" && e.trim().length === 0;
}
function Rze(e) {
  return e === "AND" || e === "OR" ? e : "AND";
}
function Fze(e, t, o) {
  if (e == null)
    return;
  const { predicate: n } = e;
  if (n != null && !t.some((s) => s == null))
    return n(t, o);
}
function Tze(e, t) {
  let o = e.length;
  return o > t && (e.splice(t), X(78), o = t), o;
}
function Xr(e, t) {
  const o = t.getCustomOption(e);
  if (o) {
    const { numberOfInputs: s } = o;
    return s ?? 1;
  }
  return e && ["empty", "notBlank", "blank"].indexOf(e) >= 0 ? 0 : e === "inRange" ? 2 : 1;
}
var cc = class extends xb {
  constructor(e, t, o) {
    super(e, "simple-filter"), this.mapValuesFromModel = t, this.defaultOptions = o, this.eTypes = [], this.eJoinPanels = [], this.eJoinAnds = [], this.eJoinOrs = [], this.eConditionBodies = [], this.listener = () => this.onUiChanged(), this.lastUiCompletePosition = null, this.joinOperatorId = 0;
  }
  setParams(e) {
    super.setParams(e);
    const t = new ac();
    this.optionsFactory = t, t.init(e, this.defaultOptions), this.commonUpdateSimpleParams(e), this.createOption(), this.createMissingConditionsAndOperators();
  }
  updateParams(e, t) {
    this.optionsFactory.refresh(e, this.defaultOptions), super.updateParams(e, t), this.commonUpdateSimpleParams(e);
  }
  commonUpdateSimpleParams(e) {
    this.setNumConditions(e), this.defaultJoinOperator = Rze(e.defaultJoinOperator), this.filterPlaceholder = e.filterPlaceholder, this.createFilterListOptions();
    const t = this.getGui();
    this.isReadOnly() ? t.setAttribute("tabindex", "-1") : t.removeAttribute("tabindex");
  }
  // floating filter calls this when user applies filter from floating filter
  onFloatingFilterChanged(e, t) {
    this.setTypeFromFloatingFilter(e), this.setValueFromFloatingFilter(t), this.onUiChanged("immediately", !0);
  }
  setTypeFromFloatingFilter(e) {
    this.eTypes.forEach((t, o) => {
      const n = o === 0 ? e : this.optionsFactory.defaultOption;
      t.setValue(n, !0);
    });
  }
  getModelFromUi() {
    const e = this.getUiCompleteConditions();
    return e.length === 0 ? null : this.maxNumConditions > 1 && e.length > 1 ? {
      filterType: this.filterType,
      operator: this.getJoinOperator(),
      conditions: e
    } : e[0];
  }
  getConditionTypes() {
    return this.eTypes.map((e) => e.getValue());
  }
  getConditionType(e) {
    return this.eTypes[e].getValue();
  }
  getJoinOperator() {
    const { eJoinOrs: e, defaultJoinOperator: t } = this;
    return e.length === 0 ? t : e[0].getValue() === !0 ? "OR" : "AND";
  }
  areNonNullModelsEqual(e, t) {
    const o = !e.operator, n = !t.operator;
    if (!o && n || o && !n)
      return !1;
    let i;
    if (o) {
      const r = e, l = t;
      i = this.areSimpleModelsEqual(r, l);
    } else {
      const r = e, l = t;
      i = r.operator === l.operator && No(
        r.conditions,
        l.conditions,
        (a, c) => this.areSimpleModelsEqual(a, c)
      );
    }
    return i;
  }
  setModelIntoUi(e, t) {
    if (e == null)
      return this.resetUiToDefaults(t), Ye.resolve();
    if (e.operator) {
      const n = e;
      let s = n.conditions;
      s == null && (s = [], X(77));
      const i = Tze(s, this.maxNumConditions), r = this.getNumConditions();
      if (i < r)
        this.removeConditionsAndOperators(i);
      else if (i > r)
        for (let a = r; a < i; a++)
          this.createJoinOperatorPanel(), this.createOption();
      const l = n.operator === "OR";
      this.eJoinAnds.forEach((a) => a.setValue(!l, !0)), this.eJoinOrs.forEach((a) => a.setValue(l, !0)), s.forEach((a, c) => {
        this.eTypes[c].setValue(a.type, !0), this.setConditionIntoUi(a, c);
      });
    } else {
      const n = e;
      this.getNumConditions() > 1 && this.removeConditionsAndOperators(1), this.eTypes[0].setValue(n.type, !0), this.setConditionIntoUi(n, 0);
    }
    return this.lastUiCompletePosition = this.getNumConditions() - 1, this.createMissingConditionsAndOperators(), this.updateUiVisibility(), t || this.params.onUiChange(this.getUiChangeEventParams()), Ye.resolve();
  }
  setNumConditions(e) {
    let t = e.maxNumConditions ?? 2;
    t < 1 && (X(79), t = 1), this.maxNumConditions = t;
    let o = e.numAlwaysVisibleConditions ?? 1;
    o < 1 && (X(80), o = 1), o > t && (X(81), o = t), this.numAlwaysVisibleConditions = o;
  }
  createOption() {
    const e = this.getGui(), t = this.createManagedBean(new V2());
    this.eTypes.push(t), t.addCss("ag-filter-select"), e.appendChild(t.getGui());
    const o = this.createEValue();
    this.eConditionBodies.push(o), e.appendChild(o), this.putOptionsIntoDropdown(t), this.resetType(t);
    const n = this.getNumConditions() - 1;
    this.forEachPositionInput(n, (s) => this.resetInput(s)), this.addChangedListeners(t, n);
  }
  createJoinOperatorPanel() {
    const e = ze({ tag: "div", cls: "ag-filter-condition" });
    this.eJoinPanels.push(e);
    const t = this.createJoinOperator(this.eJoinAnds, e, "and"), o = this.createJoinOperator(this.eJoinOrs, e, "or");
    this.getGui().appendChild(e);
    const n = this.eJoinPanels.length - 1, s = this.joinOperatorId++;
    this.resetJoinOperatorAnd(t, n, s), this.resetJoinOperatorOr(o, n, s), this.isReadOnly() || (t.onValueChange(this.listener), o.onValueChange(this.listener));
  }
  createJoinOperator(e, t, o) {
    const n = this.createManagedBean(new JDe());
    e.push(n);
    const s = "ag-filter-condition-operator";
    return n.addCss(s), n.addCss(`${s}-${o}`), t.appendChild(n.getGui()), n;
  }
  createFilterListOptions() {
    this.filterListOptions = this.optionsFactory.filterOptions.map(
      (e) => typeof e == "string" ? this.createBoilerplateListOption(e) : this.createCustomListOption(e)
    );
  }
  putOptionsIntoDropdown(e) {
    const { filterListOptions: t } = this;
    t.forEach((o) => {
      e.addOption(o);
    }), e.setDisabled(t.length <= 1);
  }
  createBoilerplateListOption(e) {
    return { value: e, text: this.translate(e) };
  }
  createCustomListOption(e) {
    const { displayKey: t } = e, o = this.optionsFactory.getCustomOption(e.displayKey);
    return {
      value: t,
      text: o ? this.getLocaleTextFunc()(o.displayKey, o.displayName) : this.translate(t)
    };
  }
  createBodyTemplate() {
    return null;
  }
  getAgComponents() {
    return [];
  }
  updateUiVisibility() {
    const e = this.getJoinOperator();
    this.updateNumConditions(), this.updateConditionStatusesAndValues(this.lastUiCompletePosition, e);
  }
  updateNumConditions() {
    let e = -1, t = !0;
    for (let o = 0; o < this.getNumConditions(); o++)
      this.isConditionUiComplete(o) ? e = o : t = !1;
    if (this.shouldAddNewConditionAtEnd(t))
      this.createJoinOperatorPanel(), this.createOption();
    else {
      const o = this.lastUiCompletePosition ?? this.getNumConditions() - 2;
      if (e < o) {
        this.removeConditionsAndOperators(o + 1);
        const n = e + 1, s = o - n;
        s > 0 && this.removeConditionsAndOperators(n, s), this.createMissingConditionsAndOperators();
      }
    }
    this.lastUiCompletePosition = e;
  }
  updateConditionStatusesAndValues(e, t) {
    this.eTypes.forEach((n, s) => {
      const i = this.isConditionDisabled(s, e);
      n.setDisabled(i || this.filterListOptions.length <= 1), s === 1 && (qs(this.eJoinPanels[0], i), this.eJoinAnds[0].setDisabled(i), this.eJoinOrs[0].setDisabled(i));
    }), this.eConditionBodies.forEach((n, s) => {
      He(n, this.isConditionBodyVisible(s));
    });
    const o = (t ?? this.getJoinOperator()) === "OR";
    this.eJoinAnds.forEach((n) => {
      n.setValue(!o, !0);
    }), this.eJoinOrs.forEach((n) => {
      n.setValue(o, !0);
    }), this.forEachInput((n, s, i, r) => {
      this.setElementDisplayed(n, s < r), this.setElementDisabled(n, this.isConditionDisabled(i, e));
    }), this.resetPlaceholder();
  }
  shouldAddNewConditionAtEnd(e) {
    return e && this.getNumConditions() < this.maxNumConditions && !this.isReadOnly();
  }
  removeConditionsAndOperators(e, t) {
    if (e >= this.getNumConditions())
      return;
    const {
      eTypes: o,
      eConditionBodies: n,
      eJoinPanels: s,
      eJoinAnds: i,
      eJoinOrs: r
    } = this;
    this.removeComponents(o, e, t), this.removeElements(n, e, t), this.removeEValues(e, t);
    const l = Math.max(e - 1, 0);
    this.removeElements(s, l, t), this.removeComponents(i, l, t), this.removeComponents(r, l, t);
  }
  removeElements(e, t, o) {
    Ir(e, t, o).forEach((s) => Kt(s));
  }
  removeComponents(e, t, o) {
    Ir(e, t, o).forEach((s) => {
      Kt(s.getGui()), this.destroyBean(s);
    });
  }
  afterGuiAttached(e) {
    var t;
    if (super.afterGuiAttached(e), this.resetPlaceholder(), !(e != null && e.suppressFocus)) {
      let o;
      if (!this.isReadOnly()) {
        const n = this.getInputs(0)[0];
        n instanceof Es && this.isConditionBodyVisible(0) ? o = n.getInputElement() : o = (t = this.eTypes[0]) == null ? void 0 : t.getFocusableElement();
      }
      (o ?? this.getGui()).focus({ preventScroll: !0 });
    }
  }
  afterGuiDetached() {
    var r;
    super.afterGuiDetached();
    const e = this.params;
    if ((r = this.beans.colFilter) != null && r.shouldKeepStateOnDetach(e.column))
      return;
    e.onStateChange({
      model: e.model
    });
    let t = -1, o = -1, n = !1;
    const s = this.getJoinOperator();
    for (let l = this.getNumConditions() - 1; l >= 0; l--)
      if (this.isConditionUiComplete(l))
        t === -1 && (t = l, o = l);
      else {
        const a = l >= this.numAlwaysVisibleConditions && !this.isConditionUiComplete(l - 1), c = l < t;
        (a || c) && (this.removeConditionsAndOperators(l, 1), n = !0, c && o--);
      }
    let i = !1;
    this.getNumConditions() < this.numAlwaysVisibleConditions && (this.createMissingConditionsAndOperators(), i = !0), this.shouldAddNewConditionAtEnd(o === this.getNumConditions() - 1) && (this.createJoinOperatorPanel(), this.createOption(), i = !0), i && this.updateConditionStatusesAndValues(o, s), n && this.updateJoinOperatorsDisabled(), this.lastUiCompletePosition = o;
  }
  getModelAsString(e) {
    var t, o;
    return ((o = (t = this.params.getHandler()) == null ? void 0 : t.getModelAsString) == null ? void 0 : o.call(t, e)) ?? "";
  }
  getPlaceholderText(e, t) {
    let o = this.translate(e);
    if (typeof this.filterPlaceholder == "function") {
      const n = this.eTypes[t].getValue(), s = this.translate(n);
      o = this.filterPlaceholder({
        filterOptionKey: n,
        filterOption: s,
        placeholder: o
      });
    } else typeof this.filterPlaceholder == "string" && (o = this.filterPlaceholder);
    return o;
  }
  // allow sub-classes to reset HTML placeholders after UI update.
  resetPlaceholder() {
    const e = this.getLocaleTextFunc();
    this.forEachInput((t, o, n, s) => {
      if (!(t instanceof Es))
        return;
      const i = o === 0 && s > 1 ? "inRangeStart" : o === 0 ? "filterOoo" : "inRangeEnd", r = o === 0 && s > 1 ? e("ariaFilterFromValue", "Filter from value") : o === 0 ? e("ariaFilterValue", "Filter Value") : e("ariaFilterToValue", "Filter to Value");
      t.setInputPlaceholder(this.getPlaceholderText(i, n)), t.setInputAriaLabel(r);
    });
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setElementValue(e, t, o) {
    e instanceof Es && e.setValue(t != null ? String(t) : null, !0);
  }
  setElementDisplayed(e, t) {
    Rd(e) && He(e.getGui(), t);
  }
  setElementDisabled(e, t) {
    Rd(e) && qs(e.getGui(), t);
  }
  attachElementOnChange(e, t) {
    e instanceof Es && e.onValueChange(t);
  }
  forEachInput(e) {
    this.getConditionTypes().forEach((t, o) => {
      this.forEachPositionTypeInput(o, t, e);
    });
  }
  forEachPositionInput(e, t) {
    const o = this.getConditionType(e);
    this.forEachPositionTypeInput(e, o, t);
  }
  forEachPositionTypeInput(e, t, o) {
    const n = Xr(t, this.optionsFactory), s = this.getInputs(e);
    for (let i = 0; i < s.length; i++) {
      const r = s[i];
      r != null && o(r, i, e, n);
    }
  }
  isConditionDisabled(e, t) {
    return this.isReadOnly() ? !0 : e === 0 ? !1 : e > t + 1;
  }
  isConditionBodyVisible(e) {
    const t = this.getConditionType(e);
    return Xr(t, this.optionsFactory) > 0;
  }
  // returns true if the UI represents a working filter, eg all parts are filled out.
  // eg if text filter and textfield blank then returns false.
  isConditionUiComplete(e) {
    return !(e >= this.getNumConditions() || this.getConditionType(e) === "empty" || this.getValues(e).some((o) => o == null));
  }
  getNumConditions() {
    return this.eTypes.length;
  }
  getUiCompleteConditions() {
    const e = [];
    for (let t = 0; t < this.getNumConditions(); t++)
      this.isConditionUiComplete(t) && e.push(this.createCondition(t));
    return e;
  }
  createMissingConditionsAndOperators() {
    if (!this.isReadOnly())
      for (let e = this.getNumConditions(); e < this.numAlwaysVisibleConditions; e++)
        this.createJoinOperatorPanel(), this.createOption();
  }
  resetUiToDefaults(e) {
    this.removeConditionsAndOperators(this.isReadOnly() ? 1 : this.numAlwaysVisibleConditions), this.eTypes.forEach((t) => this.resetType(t)), this.eJoinAnds.forEach(
      (t, o) => this.resetJoinOperatorAnd(t, o, this.joinOperatorId + o)
    ), this.eJoinOrs.forEach(
      (t, o) => this.resetJoinOperatorOr(t, o, this.joinOperatorId + o)
    ), this.joinOperatorId++, this.forEachInput((t) => this.resetInput(t)), this.resetPlaceholder(), this.createMissingConditionsAndOperators(), this.lastUiCompletePosition = null, this.updateUiVisibility(), e || this.params.onUiChange(this.getUiChangeEventParams());
  }
  resetType(e) {
    const o = this.getLocaleTextFunc()("ariaFilteringOperator", "Filtering operator");
    e.setValue(this.optionsFactory.defaultOption, !0).setAriaLabel(o).setDisabled(this.isReadOnly() || this.filterListOptions.length <= 1);
  }
  resetJoinOperatorAnd(e, t, o) {
    this.resetJoinOperator(
      e,
      t,
      this.defaultJoinOperator === "AND",
      this.translate("andCondition"),
      o
    );
  }
  resetJoinOperatorOr(e, t, o) {
    this.resetJoinOperator(
      e,
      t,
      this.defaultJoinOperator === "OR",
      this.translate("orCondition"),
      o
    );
  }
  resetJoinOperator(e, t, o, n, s) {
    this.updateJoinOperatorDisabled(
      e.setValue(o, !0).setName(`ag-simple-filter-and-or-${this.getCompId()}-${s}`).setLabel(n),
      t
    );
  }
  updateJoinOperatorsDisabled() {
    const e = (t, o) => this.updateJoinOperatorDisabled(t, o);
    this.eJoinAnds.forEach(e), this.eJoinOrs.forEach(e);
  }
  updateJoinOperatorDisabled(e, t) {
    e.setDisabled(this.isReadOnly() || t > 0);
  }
  resetInput(e) {
    this.setElementValue(e, null), this.setElementDisabled(e, this.isReadOnly());
  }
  // puts model values into the UI
  setConditionIntoUi(e, t) {
    const o = this.mapValuesFromModel(e, this.optionsFactory);
    this.forEachInput((n, s, i) => {
      i === t && this.setElementValue(n, o[s] != null ? o[s] : null);
    });
  }
  // after floating filter changes, this sets the 'value' section. this is implemented by the base class
  // (as that's where value is controlled), the 'type' part from the floating filter is dealt with in this class.
  setValueFromFloatingFilter(e) {
    this.forEachInput((t, o, n) => {
      this.setElementValue(t, o === 0 && n === 0 ? e : null, !0);
    });
  }
  addChangedListeners(e, t) {
    this.isReadOnly() || (e.onValueChange(this.listener), this.forEachPositionInput(t, (o) => {
      this.attachElementOnChange(o, this.listener);
    }));
  }
  hasInvalidInputs() {
    return !1;
  }
  isReadOnly() {
    return !!this.params.readOnly;
  }
}, Fy = class {
  constructor(e, t, o, n, s, i) {
    this.alive = !0, this.context = e, this.eParent = s;
    const r = DDe(t, o, n);
    r && r.newAgStackInstance().then((l) => {
      var d, u;
      if (!this.alive) {
        e.destroyBean(l);
        return;
      }
      if (this.dateComp = l, !l)
        return;
      s.appendChild(l.getGui()), (d = l == null ? void 0 : l.afterGuiAttached) == null || d.call(l);
      const { tempValue: a, disabled: c } = this;
      a && l.setDate(a), c != null && ((u = l.setDisabled) == null || u.call(l, c)), i == null || i(this);
    });
  }
  destroy() {
    this.alive = !1, this.dateComp = this.context.destroyBean(this.dateComp);
  }
  getDate() {
    return this.dateComp ? this.dateComp.getDate() : this.tempValue;
  }
  setDate(e) {
    const t = this.dateComp;
    t ? t.setDate(e) : this.tempValue = e;
  }
  setDisabled(e) {
    var o;
    const t = this.dateComp;
    t ? (o = t.setDisabled) == null || o.call(t, e) : this.disabled = e;
  }
  setDisplayed(e) {
    He(this.eParent, e);
  }
  setInputPlaceholder(e) {
    var t, o;
    (o = (t = this.dateComp) == null ? void 0 : t.setInputPlaceholder) == null || o.call(t, e);
  }
  setInputAriaLabel(e) {
    var t, o;
    (o = (t = this.dateComp) == null ? void 0 : t.setInputAriaLabel) == null || o.call(t, e);
  }
  afterGuiAttached(e) {
    var t, o;
    (o = (t = this.dateComp) == null ? void 0 : t.afterGuiAttached) == null || o.call(t, e);
  }
  updateParams(e) {
    var t, o;
    (o = (t = this.dateComp) == null ? void 0 : t.refresh) == null || o.call(t, e);
  }
}, dc = [
  "equals",
  "notEqual",
  "lessThan",
  "greaterThan",
  "inRange",
  "blank",
  "notBlank"
];
function Ty(e, t) {
  const { dateFrom: o, dateTo: n, type: s } = e || {};
  return [
    o && Wt(o, void 0, !0) || null,
    n && Wt(n, void 0, !0) || null
  ].slice(0, Xr(s, t));
}
var Au = 1e3, Lu = 1 / 0, Ize = class extends cc {
  constructor() {
    super("dateFilter", Ty, dc), this.eConditionPanelsFrom = [], this.eConditionPanelsTo = [], this.dateConditionFromComps = [], this.dateConditionToComps = [], this.minValidYear = Au, this.maxValidYear = Lu, this.minValidDate = null, this.maxValidDate = null, this.filterType = "date";
  }
  afterGuiAttached(e) {
    super.afterGuiAttached(e), this.dateConditionFromComps[0].afterGuiAttached(e);
  }
  commonUpdateSimpleParams(e) {
    super.commonUpdateSimpleParams(e);
    const t = (a, c) => {
      const d = e[a];
      if (d != null)
        if (isNaN(d))
          X(82, { param: a });
        else
          return d == null ? c : Number(d);
      return c;
    }, o = t("minValidYear", Au), n = t("maxValidYear", Lu);
    this.minValidYear = o, this.maxValidYear = n, o > n && X(83);
    const { minValidDate: s, maxValidDate: i } = e, r = s instanceof Date ? s : Wt(s);
    this.minValidDate = r;
    const l = i instanceof Date ? i : Wt(i);
    this.maxValidDate = l, r && l && r > l && X(84);
  }
  createDateCompWrapper(e) {
    const {
      beans: { userCompFactory: t, context: o, gos: n },
      params: s
    } = this, i = new Fy(
      o,
      t,
      s.colDef,
      Pe(n, {
        onDateChanged: () => this.onUiChanged(),
        filterParams: s,
        location: "filter"
      }),
      e
    );
    return this.addDestroyFunc(() => i.destroy()), i;
  }
  setElementValue(e, t) {
    e.setDate(t);
  }
  setElementDisplayed(e, t) {
    e.setDisplayed(t);
  }
  setElementDisabled(e, t) {
    e.setDisabled(t);
  }
  createEValue() {
    const e = ze({ tag: "div", cls: "ag-filter-body" });
    return this.createFromToElement(e, this.eConditionPanelsFrom, this.dateConditionFromComps, "from"), this.createFromToElement(e, this.eConditionPanelsTo, this.dateConditionToComps, "to"), e;
  }
  createFromToElement(e, t, o, n) {
    const s = ze({ tag: "div", cls: `ag-filter-${n} ag-filter-date-${n}` });
    t.push(s), e.appendChild(s), o.push(this.createDateCompWrapper(s));
  }
  removeEValues(e, t) {
    this.removeDateComps(this.dateConditionFromComps, e, t), this.removeDateComps(this.dateConditionToComps, e, t), Ir(this.eConditionPanelsFrom, e, t), Ir(this.eConditionPanelsTo, e, t);
  }
  removeDateComps(e, t, o) {
    Ir(e, t, o).forEach((s) => s.destroy());
  }
  isValidDateValue(e) {
    if (e === null)
      return !1;
    const { minValidDate: t, maxValidDate: o, minValidYear: n, maxValidYear: s } = this;
    if (t) {
      if (e < t)
        return !1;
    } else if (e.getUTCFullYear() < n)
      return !1;
    if (o) {
      if (e > o)
        return !1;
    } else if (e.getUTCFullYear() > s)
      return !1;
    return !0;
  }
  isConditionUiComplete(e) {
    if (!super.isConditionUiComplete(e))
      return !1;
    let t = !0;
    return this.forEachInput((o, n, s, i) => {
      s !== e || !t || n >= i || (t = t && this.isValidDateValue(o.getDate()));
    }), t;
  }
  areSimpleModelsEqual(e, t) {
    return e.dateFrom === t.dateFrom && e.dateTo === t.dateTo && e.type === t.type;
  }
  createCondition(e) {
    const t = this.getConditionType(e), o = {}, n = this.getValues(e), s = this.params.useIsoSeparator ? "T" : " ";
    return n.length > 0 && (o.dateFrom = to(n[0], !0, s)), n.length > 1 && (o.dateTo = to(n[1], !0, s)), {
      dateFrom: null,
      dateTo: null,
      filterType: this.filterType,
      type: t,
      ...o
    };
  }
  resetPlaceholder() {
    const e = this.getLocaleTextFunc(), t = this.translate("dateFormatOoo"), o = e("ariaFilterValue", "Filter Value");
    this.forEachInput((n) => {
      n.setInputPlaceholder(t), n.setInputAriaLabel(o);
    });
  }
  getInputs(e) {
    const { dateConditionFromComps: t, dateConditionToComps: o } = this;
    return e >= t.length ? [null, null] : [t[e], o[e]];
  }
  getValues(e) {
    const t = [];
    return this.forEachPositionInput(e, (o, n, s, i) => {
      n < i && t.push(o.getDate());
    }), t;
  }
  translate(e) {
    return e === "lessThan" ? super.translate("before") : e === "greaterThan" ? super.translate("after") : super.translate(e);
  }
}, Iy = class extends K {
  constructor(e, t) {
    super(), this.mapValuesFromModel = e, this.defaultOptions = t;
  }
  init(e) {
    const t = e.filterParams, o = new ac();
    this.optionsFactory = o, o.init(t, this.defaultOptions), this.filterModelFormatter = this.createManagedBean(
      new this.FilterModelFormatterClass(o, t)
    ), this.updateParams(e), this.validateModel(e);
  }
  refresh(e) {
    if (e.source === "colDef") {
      const t = e.filterParams, o = this.optionsFactory;
      o.refresh(t, this.defaultOptions), this.filterModelFormatter.updateParams({ optionsFactory: o, filterParams: t }), this.updateParams(e);
    }
    this.validateModel(e);
  }
  updateParams(e) {
    this.params = e;
  }
  doesFilterPass(e) {
    const t = e.model;
    if (t == null)
      return !0;
    const { operator: o } = t, n = [];
    if (o) {
      const r = t;
      n.push(...r.conditions ?? []);
    } else
      n.push(t);
    const s = o && o === "OR" ? "some" : "every", i = this.params.getValue(e.node);
    return n[s]((r) => this.individualConditionPasses(e, r, i));
  }
  getModelAsString(e, t) {
    return this.filterModelFormatter.getModelAsString(e, t) ?? "";
  }
  validateModel(e) {
    const {
      model: t,
      filterParams: { filterOptions: o, maxNumConditions: n }
    } = e;
    if (t == null)
      return;
    let i = Mb(t) ? t.conditions : [t];
    const r = (o == null ? void 0 : o.map((d) => typeof d == "string" ? d : d.displayKey)) ?? this.defaultOptions;
    if (!(!i || i.every((d) => r.find((u) => u === d.type) !== void 0))) {
      this.params = {
        ...e,
        model: null
      }, e.onModelChange(null);
      return;
    }
    let a = !1;
    const c = this.filterType;
    if ((i && !i.every((d) => d.filterType === c) || t.filterType !== c) && (i = i.map((d) => ({ ...d, filterType: c })), a = !0), typeof n == "number" && i && i.length > n && (i = i.slice(0, n), a = !0), a) {
      const d = i.length > 1 ? {
        ...t,
        filterType: c,
        conditions: i
      } : {
        ...i[0],
        filterType: c
      };
      this.params = {
        ...e,
        model: d
      }, e.onModelChange(d);
      return;
    }
  }
  /** returns true if the row passes the said condition */
  individualConditionPasses(e, t, o) {
    const n = this.optionsFactory, s = this.mapValuesFromModel(t, n), i = n.getCustomOption(t.type), r = Fze(i, s, o);
    return r ?? (o == null ? this.evaluateNullValue(t.type) : this.evaluateNonNullValue(s, o, t, e));
  }
}, Dy = class extends Iy {
  evaluateNullValue(e) {
    const {
      includeBlanksInEquals: t,
      includeBlanksInNotEqual: o,
      includeBlanksInGreaterThan: n,
      includeBlanksInLessThan: s,
      includeBlanksInRange: i
    } = this.params.filterParams;
    switch (e) {
      case "equals":
        if (t)
          return !0;
        break;
      case "notEqual":
        if (o)
          return !0;
        break;
      case "greaterThan":
      case "greaterThanOrEqual":
        if (n)
          return !0;
        break;
      case "lessThan":
      case "lessThanOrEqual":
        if (s)
          return !0;
        break;
      case "inRange":
        if (i)
          return !0;
        break;
      case "blank":
        return !0;
      case "notBlank":
        return !1;
    }
    return !1;
  }
  evaluateNonNullValue(e, t, o) {
    const n = o.type;
    if (!this.isValid(t))
      return n === "notEqual" || n === "notBlank";
    const s = this.comparator(), i = e[0] != null ? s(e[0], t) : 0;
    switch (n) {
      case "equals":
        return i === 0;
      case "notEqual":
        return i !== 0;
      case "greaterThan":
        return i > 0;
      case "greaterThanOrEqual":
        return i >= 0;
      case "lessThan":
        return i < 0;
      case "lessThanOrEqual":
        return i <= 0;
      case "inRange": {
        const r = s(e[1], t);
        return this.params.filterParams.inRangeInclusive ? i >= 0 && r <= 0 : i > 0 && r < 0;
      }
      case "blank":
        return Ol(t);
      case "notBlank":
        return !Ol(t);
      default:
        return X(76, { filterModelType: n }), !0;
    }
  }
}, ky = {
  equals: "Equals",
  notEqual: "NotEqual",
  greaterThan: "GreaterThan",
  greaterThanOrEqual: "GreaterThanOrEqual",
  lessThan: "LessThan",
  lessThanOrEqual: "LessThanOrEqual",
  inRange: "InRange"
}, Dze = {
  contains: "Contains",
  notContains: "NotContains",
  equals: "TextEquals",
  notEqual: "TextNotEqual",
  startsWith: "StartsWith",
  endsWith: "EndsWith",
  inRange: "InRange"
}, uc = class extends K {
  constructor(e, t, o) {
    super(), this.optionsFactory = e, this.filterParams = t, this.valueFormatter = o;
  }
  // used by:
  // 1) NumberFloatingFilter & TextFloatingFilter: Always, for both when editable and read only.
  // 2) DateFloatingFilter: Only when read only (as we show text rather than a date picker when read only)
  getModelAsString(e, t) {
    const o = this.getLocaleTextFunc(), n = t === "filterToolPanel";
    if (!e)
      return n ? ts(this, "filterSummaryInactive") : null;
    if (e.operator != null) {
      const i = e, l = (i.conditions ?? []).map((c) => this.getModelAsString(c, t)), a = i.operator === "AND" ? "andCondition" : "orCondition";
      return l.join(` ${ts(this, a)} `);
    } else {
      if (e.type === "blank" || e.type === "notBlank")
        return n ? ts(this, e.type === "blank" ? "filterSummaryBlank" : "filterSummaryNotBlank") : o(e.type, e.type);
      {
        const i = e, r = this.optionsFactory.getCustomOption(i.type), { displayKey: l, displayName: a, numberOfInputs: c } = r || {};
        return l && a && c === 0 ? o(l, a) : this.conditionToString(
          i,
          n,
          i.type === "inRange" || c === 2,
          l,
          a
        );
      }
    }
  }
  updateParams(e) {
    const { optionsFactory: t, filterParams: o } = e;
    this.optionsFactory = t, this.filterParams = o;
  }
  conditionForToolPanel(e, t, o, n, s, i) {
    let r;
    const l = this.getTypeKey(e);
    return l && (r = ts(this, l)), s && i && (r = this.getLocaleTextFunc()(s, i)), r != null ? t ? `${r} ${ts(this, "filterSummaryInRangeValues", [o(), n()])}` : `${r} ${o()}` : null;
  }
  getTypeKey(e) {
    const t = this.filterTypeKeys[e];
    return t ? `filterSummary${t}` : null;
  }
  formatValue(e) {
    const t = this.valueFormatter;
    return t ? t(e ?? null) ?? "" : String(e);
  }
}, Hy = class extends uc {
  constructor(e, t) {
    super(e, t, (o) => {
      const { dataTypeSvc: n, valueSvc: s } = this.beans, i = t.column, r = n == null ? void 0 : n.getDateFormatterFunction(i), l = r == null ? void 0 : r(o ?? void 0);
      return s.formatValue(i, null, l);
    }), this.filterTypeKeys = ky;
  }
  conditionToString(e, t, o, n, s) {
    const { type: i } = e, r = Wt(e.dateFrom), l = Wt(e.dateTo), a = this.filterParams.inRangeFloatingFilterDateFormat, c = t ? this.formatValue.bind(this) : (h) => s5(h, a), d = () => r !== null ? c(r) : "null", u = () => l !== null ? c(l) : "null";
    if (t) {
      const h = this.conditionForToolPanel(
        i,
        o,
        d,
        u,
        n,
        s
      );
      if (h != null)
        return h;
    }
    return o ? `${d()}-${u()}` : r != null ? c(r) : `${i}`;
  }
};
function kze(e, t) {
  const o = t;
  return o < e ? -1 : o > e ? 1 : 0;
}
var Hze = class extends Dy {
  constructor() {
    super(Ty, dc), this.filterType = "date", this.FilterModelFormatterClass = Hy;
  }
  comparator() {
    return this.params.filterParams.comparator ?? kze;
  }
  isValid(e) {
    const t = this.params.filterParams.isValidDate;
    return !t || t(e);
  }
}, Vy = class extends Re {
  constructor() {
    super(...arguments), this.defaultDebounceMs = 0;
  }
  setLastTypeFromModel(e) {
    if (!e) {
      this.lastType = this.optionsFactory.defaultOption;
      return;
    }
    const t = e.operator;
    let o;
    t ? o = e.conditions[0] : o = e, this.lastType = o.type;
  }
  canWeEditAfterModelFromParentFilter(e) {
    if (!e)
      return this.isTypeEditable(this.lastType);
    if (e.operator)
      return !1;
    const o = e;
    return this.isTypeEditable(o.type);
  }
  init(e) {
    this.params = e;
    const t = this.gos.get("enableFilterHandlers");
    if (this.reactive = t, this.setParams(e), t) {
      const o = e;
      this.onModelUpdated(o.model);
    }
  }
  setParams(e) {
    const t = new ac();
    this.optionsFactory = t, t.init(e.filterParams, this.defaultOptions), this.filterModelFormatter = this.createManagedBean(
      new this.FilterModelFormatterClass(t, e.filterParams)
    ), this.setSimpleParams(e, !1);
  }
  setSimpleParams(e, t = !0) {
    const o = this.optionsFactory.defaultOption;
    t || (this.lastType = o), this.readOnly = !!e.filterParams.readOnly;
    const n = this.isTypeEditable(o);
    this.setEditable(n);
  }
  refresh(e) {
    this.params = e;
    const t = e, o = this.reactive;
    if ((!o || t.source === "colDef") && this.updateParams(e), o) {
      const { source: n, model: s } = t;
      if (n === "dataChanged" || n === "ui")
        return;
      this.onModelUpdated(s);
    }
  }
  updateParams(e) {
    const t = this.optionsFactory;
    t.refresh(e.filterParams, this.defaultOptions), this.setSimpleParams(e), this.filterModelFormatter.updateParams({
      optionsFactory: t,
      filterParams: e.filterParams
    });
  }
  onParentModelChanged(e, t) {
    t != null && t.afterFloatingFilter || t != null && t.afterDataChange || this.onModelUpdated(e);
  }
  hasSingleInput(e) {
    var o;
    const t = (o = this.optionsFactory.getCustomOption(e)) == null ? void 0 : o.numberOfInputs;
    return t == null || t == 1;
  }
  isTypeEditable(e) {
    const t = ["inRange", "empty", "blank", "notBlank"];
    return !!e && !this.readOnly && this.hasSingleInput(e) && t.indexOf(e) < 0;
  }
  getAriaLabel(e) {
    return `${this.beans.colNames.getDisplayNameForColumn(e.column, "header", !0)} ${this.getLocaleTextFunc()("ariaFilterInput", "Filter Input")}`;
  }
}, Vze = {
  tag: "div",
  cls: "ag-floating-filter-input",
  role: "presentation",
  children: [
    {
      tag: "ag-input-text-field",
      ref: "eReadOnlyText"
    },
    { tag: "div", ref: "eDateWrapper", cls: "ag-date-floating-filter-wrapper" }
  ]
}, Oze = class extends Vy {
  constructor() {
    super(Vze, [zo]), this.eReadOnlyText = J, this.eDateWrapper = J, this.FilterModelFormatterClass = Hy, this.filterType = "date", this.defaultOptions = dc;
  }
  setParams(e) {
    super.setParams(e), this.createDateComponent();
    const t = this.getLocaleTextFunc();
    this.eReadOnlyText.setDisabled(!0).setInputAriaLabel(t("ariaDateFilterInput", "Date Filter Input"));
  }
  updateParams(e) {
    super.updateParams(e), this.dateComp.updateParams(this.getDateComponentParams()), this.updateCompOnModelChange(e.currentParentModel());
  }
  updateCompOnModelChange(e) {
    const t = !this.readOnly && this.canWeEditAfterModelFromParentFilter(e);
    if (this.setEditable(t), t) {
      const o = e ? Wt(e.dateFrom) : null;
      this.dateComp.setDate(o), this.eReadOnlyText.setValue("");
    } else
      this.eReadOnlyText.setValue(this.filterModelFormatter.getModelAsString(e)), this.dateComp.setDate(null);
  }
  setEditable(e) {
    He(this.eDateWrapper, e), He(this.eReadOnlyText.getGui(), !e);
  }
  onModelUpdated(e) {
    super.setLastTypeFromModel(e), this.updateCompOnModelChange(e);
  }
  onDateChanged() {
    const e = this.dateComp.getDate();
    if (this.reactive) {
      const t = this.params;
      t.onUiChange();
      const o = t.model, n = to(e), s = n == null ? null : {
        ...o ?? {
          filterType: this.filterType,
          type: this.lastType ?? this.optionsFactory.defaultOption
        },
        dateFrom: n
      };
      t.onModelChange(s, { afterFloatingFilter: !0 });
    } else
      this.params.parentFilterInstance((t) => {
        t == null || t.onFloatingFilterChanged(this.lastType || null, e);
      });
  }
  getDateComponentParams() {
    const { filterParams: e } = this.params, t = z2(e, this.defaultDebounceMs);
    return Pe(this.gos, {
      onDateChanged: Rt(this, this.onDateChanged.bind(this), t),
      filterParams: e,
      location: "floatingFilter"
    });
  }
  createDateComponent() {
    const {
      beans: { context: e, userCompFactory: t },
      eDateWrapper: o,
      params: n
    } = this;
    this.dateComp = new Fy(
      e,
      t,
      n.column.getColDef(),
      this.getDateComponentParams(),
      o,
      (s) => {
        s.setInputAriaLabel(this.getAriaLabel(n));
      }
    ), this.addDestroyFunc(() => this.dateComp.destroy());
  }
}, Bze = {
  tag: "div",
  cls: "ag-filter-filter",
  children: [
    {
      tag: "ag-input-text-field",
      ref: "eDateInput",
      cls: "ag-date-filter"
    }
  ]
}, $ze = class extends Re {
  constructor() {
    super(Bze, [zo]), this.eDateInput = J, this.isApply = !1, this.applyOnFocusOut = !1;
  }
  init(e) {
    this.params = e, this.setParams(e);
    const t = this.eDateInput.getInputElement();
    this.addManagedListeners(t, {
      // ensures that the input element is focussed when a clear button is clicked,
      // unless using safari as there is no clear button and focus does not work properly
      mouseDown: () => {
        this.eDateInput.isDisabled() || this.usingSafariDatePicker || t.focus({ preventScroll: !0 });
      },
      input: this.handleInput.bind(this, !1),
      change: this.handleInput.bind(this, !0),
      focusout: this.handleFocusOut.bind(this)
    });
  }
  handleInput(e) {
    if (!this.eDateInput.isDisabled()) {
      if (this.isApply) {
        this.applyOnFocusOut = !e, e && this.params.onDateChanged();
        return;
      }
      e || this.params.onDateChanged();
    }
  }
  handleFocusOut() {
    this.applyOnFocusOut && (this.applyOnFocusOut = !1, this.params.onDateChanged());
  }
  setParams(e) {
    var h;
    const t = this.eDateInput.getInputElement(), o = this.shouldUseBrowserDatePicker(e);
    this.usingSafariDatePicker = o && Gn();
    const { minValidYear: n, maxValidYear: s, minValidDate: i, maxValidDate: r, buttons: l, includeTime: a, colDef: c } = e.filterParams || {}, d = this.beans.dataTypeSvc, u = a ?? ((h = d == null ? void 0 : d.getDateIncludesTimeFlag) == null ? void 0 : h.call(d, c.cellDataType)) ?? !1;
    if (o ? u ? (t.type = "datetime-local", t.step = "1") : t.type = "date" : t.type = "text", i && n && X(85), r && s && X(86), i && r) {
      const [p, C] = [i, r].map(
        (m) => m instanceof Date ? m : Wt(m)
      );
      p && C && p.getTime() > C.getTime() && X(87);
    }
    i ? i instanceof Date ? t.min = s5(i) : t.min = i : n && (t.min = `${n}-01-01`), r ? r instanceof Date ? t.max = s5(r) : t.max = r : s && (t.max = `${s}-12-31`), this.isApply = e.location === "floatingFilter" && !!(l != null && l.includes("apply"));
  }
  refresh(e) {
    this.params = e, this.setParams(e);
  }
  getDate() {
    return Wt(this.eDateInput.getValue());
  }
  setDate(e) {
    var n;
    const t = this.params.filterParams.colDef.cellDataType, o = ((n = this.beans.dataTypeSvc) == null ? void 0 : n.getDateIncludesTimeFlag(t)) ?? !1;
    this.eDateInput.setValue(to(e, o));
  }
  setInputPlaceholder(e) {
    this.eDateInput.setInputPlaceholder(e);
  }
  setInputAriaLabel(e) {
    this.eDateInput.setAriaLabel(e);
  }
  setDisabled(e) {
    this.eDateInput.setDisabled(e);
  }
  afterGuiAttached(e) {
    (!e || !e.suppressFocus) && this.eDateInput.getInputElement().focus({ preventScroll: !0 });
  }
  shouldUseBrowserDatePicker(e) {
    var t;
    return ((t = e == null ? void 0 : e.filterParams) == null ? void 0 : t.browserDatePicker) ?? !0;
  }
}, hc = [
  "equals",
  "notEqual",
  "greaterThan",
  "greaterThanOrEqual",
  "lessThan",
  "lessThanOrEqual",
  "inRange",
  "blank",
  "notBlank"
];
function _5(e) {
  const { allowedCharPattern: t } = e ?? {};
  return t ?? null;
}
function S5(e) {
  return e == null || isNaN(e) ? null : e;
}
function Oy(e, t) {
  const { filter: o, filterTo: n, type: s } = e || {};
  return [S5(o), S5(n)].slice(
    0,
    Xr(s, t)
  );
}
var Zze = class extends cc {
  constructor() {
    super("numberFilter", Oy, hc), this.eValuesFrom = [], this.eValuesTo = [], this.filterType = "number", this.defaultDebounceMs = 500;
  }
  setElementValue(e, t, o) {
    const { numberFormatter: n } = this.params, s = !o && n ? n(t ?? null) : t;
    super.setElementValue(e, s);
  }
  createEValue() {
    const e = _5(this.params), t = ze({ tag: "div", cls: "ag-filter-body", role: "presentation" });
    return this.createFromToElement(t, this.eValuesFrom, "from", e), this.createFromToElement(t, this.eValuesTo, "to", e), t;
  }
  createFromToElement(e, t, o, n) {
    const s = this.createManagedBean(
      n ? new an({ allowedCharPattern: n }) : new va()
    );
    s.addCss(`ag-filter-${o}`), s.addCss("ag-filter-filter"), t.push(s), e.appendChild(s.getGui());
  }
  removeEValues(e, t) {
    const o = (n) => this.removeComponents(n, e, t);
    o(this.eValuesFrom), o(this.eValuesTo);
  }
  getValues(e) {
    const t = [];
    return this.forEachPositionInput(e, (o, n, s, i) => {
      n < i && t.push(S5(this.stringToFloat(o.getValue())));
    }), t;
  }
  areSimpleModelsEqual(e, t) {
    return e.filter === t.filter && e.filterTo === t.filterTo && e.type === t.type;
  }
  stringToFloat(e) {
    if (typeof e == "number")
      return e;
    let t = Ft(e);
    t != null && t.trim() === "" && (t = null);
    const o = this.params.numberParser;
    return o ? o(t) : t == null || t.trim() === "-" ? null : parseFloat(t);
  }
  createCondition(e) {
    const t = this.getConditionType(e), o = {
      filterType: this.filterType,
      type: t
    }, n = this.getValues(e);
    return n.length > 0 && (o.filter = n[0]), n.length > 1 && (o.filterTo = n[1]), o;
  }
  getInputs(e) {
    const { eValuesFrom: t, eValuesTo: o } = this;
    return e >= t.length ? [null, null] : [t[e], o[e]];
  }
  hasInvalidInputs() {
    let e = !1;
    return this.forEachInput((t) => {
      if (!t.getInputElement().validity.valid) {
        e = !0;
        return;
      }
    }), e;
  }
}, By = class extends uc {
  constructor(e, t) {
    super(e, t, t.numberFormatter), this.filterTypeKeys = ky;
  }
  conditionToString(e, t, o, n, s) {
    const { filter: i, filterTo: r, type: l } = e, a = this.formatValue.bind(this);
    if (t) {
      const c = this.conditionForToolPanel(
        l,
        o,
        () => a(i),
        () => a(r),
        n,
        s
      );
      if (c != null)
        return c;
    }
    return o ? `${a(i)}-${a(r)}` : i != null ? a(i) : `${l}`;
  }
}, Gze = class extends Dy {
  constructor() {
    super(Oy, hc), this.filterType = "number", this.FilterModelFormatterClass = By;
  }
  comparator() {
    return (e, t) => e === t ? 0 : e < t ? 1 : -1;
  }
  isValid(e) {
    return !isNaN(e);
  }
}, $y = class extends K {
  constructor(e) {
    super(), this.params = e, this.eInput = J, this.onValueChanged = () => {
    };
  }
  setupGui(e) {
    var n;
    this.eInput = this.createManagedBean(new an((n = this.params) == null ? void 0 : n.config));
    const t = this.eInput.getGui();
    e.appendChild(t);
    const o = (s) => this.onValueChanged(s);
    this.addManagedListeners(t, {
      input: o,
      keydown: o
    });
  }
  setEditable(e) {
    this.eInput.setDisabled(!e);
  }
  getValue() {
    return this.eInput.getValue();
  }
  setValue(e, t) {
    this.eInput.setValue(e, t);
  }
  setValueChangedListener(e) {
    this.onValueChanged = e;
  }
  setParams({ ariaLabel: e, autoComplete: t }) {
    const { eInput: o } = this;
    o.setInputAriaLabel(e), t !== void 0 && o.setAutoComplete(t);
  }
};
function x5(e) {
  const t = e == null ? void 0 : e.trim();
  return t === "" ? e : t;
}
function Zy(e, t) {
  const { filter: o, filterTo: n, type: s } = e || {};
  return [o || null, n || null].slice(0, Xr(s, t));
}
var Nze = {
  tag: "div",
  ref: "eFloatingFilterInputContainer",
  cls: "ag-floating-filter-input",
  role: "presentation"
}, Gy = class extends Vy {
  constructor() {
    super(...arguments), this.eFloatingFilterInputContainer = J, this.defaultDebounceMs = 500;
  }
  postConstruct() {
    this.setTemplate(Nze);
  }
  onModelUpdated(e) {
    this.setLastTypeFromModel(e), this.setEditable(this.canWeEditAfterModelFromParentFilter(e)), this.inputSvc.setValue(this.filterModelFormatter.getModelAsString(e));
  }
  setParams(e) {
    this.setupFloatingFilterInputService(e), super.setParams(e), this.setTextInputParams(e);
  }
  setupFloatingFilterInputService(e) {
    this.inputSvc = this.createFloatingFilterInputService(e), this.inputSvc.setupGui(this.eFloatingFilterInputContainer);
  }
  setTextInputParams(e) {
    const t = e.browserAutoComplete ?? !1, { inputSvc: o, defaultDebounceMs: n, readOnly: s } = this;
    if (o.setParams({
      ariaLabel: this.getAriaLabel(e),
      autoComplete: t
    }), this.applyActive = Ca(e.filterParams), !s) {
      const i = z2(e.filterParams, n), r = Rt(
        this,
        this.syncUpWithParentFilter.bind(this),
        i
      );
      o.setValueChangedListener(r);
    }
  }
  updateParams(e) {
    super.updateParams(e), this.setTextInputParams(e);
  }
  recreateFloatingFilterInputService(e) {
    const { inputSvc: t } = this, o = t.getValue();
    it(this.eFloatingFilterInputContainer), this.destroyBean(t), this.setupFloatingFilterInputService(e), t.setValue(o, !0);
  }
  syncUpWithParentFilter(e) {
    const t = e.key === D.ENTER, o = this.reactive;
    if (o && this.params.onUiChange(), this.applyActive && !t)
      return;
    const { inputSvc: n, params: s, lastType: i } = this;
    let r = n.getValue();
    if (s.filterParams.trimInput && (r = x5(r), n.setValue(r, !0)), o) {
      const l = s, a = l.model, c = this.convertValue(r), d = c == null ? null : {
        ...a ?? {
          filterType: this.filterType,
          type: i ?? this.optionsFactory.defaultOption
        },
        filter: c
      };
      l.onModelChange(d, { afterFloatingFilter: !0 });
    } else
      s.parentFilterInstance((l) => {
        l == null || l.onFloatingFilterChanged(i || null, r || null);
      });
  }
  convertValue(e) {
    return e || null;
  }
  setEditable(e) {
    this.inputSvc.setEditable(e);
  }
}, zze = class extends K {
  constructor() {
    super(...arguments), this.onValueChanged = () => {
    }, this.numberInputActive = !0;
  }
  setupGui(e) {
    this.eNumberInput = this.createManagedBean(new va()), this.eTextInput = this.createManagedBean(new an()), this.eTextInput.setDisabled(!0);
    const t = this.eNumberInput.getGui(), o = this.eTextInput.getGui();
    e.appendChild(t), e.appendChild(o), this.setupListeners(t, (n) => this.onValueChanged(n)), this.setupListeners(o, (n) => this.onValueChanged(n));
  }
  setEditable(e) {
    this.numberInputActive = e, this.eNumberInput.setDisplayed(this.numberInputActive), this.eTextInput.setDisplayed(!this.numberInputActive);
  }
  setAutoComplete(e) {
    this.eNumberInput.setAutoComplete(e), this.eTextInput.setAutoComplete(e);
  }
  getValue() {
    return this.getActiveInputElement().getValue();
  }
  setValue(e, t) {
    this.getActiveInputElement().setValue(e, t);
  }
  getActiveInputElement() {
    return this.numberInputActive ? this.eNumberInput : this.eTextInput;
  }
  setValueChangedListener(e) {
    this.onValueChanged = e;
  }
  setupListeners(e, t) {
    this.addManagedListeners(e, {
      input: t,
      keydown: t
    });
  }
  setParams(e) {
    this.setAriaLabel(e.ariaLabel), e.autoComplete !== void 0 && this.setAutoComplete(e.autoComplete);
  }
  setAriaLabel(e) {
    this.eNumberInput.setInputAriaLabel(e), this.eTextInput.setInputAriaLabel(e);
  }
}, jze = class extends Gy {
  constructor() {
    super(...arguments), this.FilterModelFormatterClass = By, this.filterType = "number", this.defaultOptions = hc;
  }
  updateParams(e) {
    _5(e.filterParams) !== this.allowedCharPattern && this.recreateFloatingFilterInputService(e), super.updateParams(e);
  }
  createFloatingFilterInputService(e) {
    return this.allowedCharPattern = _5(e.filterParams), this.allowedCharPattern ? this.createManagedBean(
      new $y({
        config: { allowedCharPattern: this.allowedCharPattern }
      })
    ) : this.createManagedBean(new zze());
  }
  convertValue(e) {
    return e ? Number(e) : null;
  }
}, gc = [
  "contains",
  "notContains",
  "equals",
  "notEqual",
  "startsWith",
  "endsWith",
  "blank",
  "notBlank"
], Wze = class extends cc {
  constructor() {
    super("textFilter", Zy, gc), this.filterType = "text", this.eValuesFrom = [], this.eValuesTo = [], this.defaultDebounceMs = 500;
  }
  createCondition(e) {
    const t = this.getConditionType(e), o = {
      filterType: this.filterType,
      type: t
    }, n = this.getValues(e);
    return n.length > 0 && (o.filter = n[0]), n.length > 1 && (o.filterTo = n[1]), o;
  }
  areSimpleModelsEqual(e, t) {
    return e.filter === t.filter && e.filterTo === t.filterTo && e.type === t.type;
  }
  getInputs(e) {
    const { eValuesFrom: t, eValuesTo: o } = this;
    return e >= t.length ? [null, null] : [t[e], o[e]];
  }
  getValues(e) {
    const t = [];
    return this.forEachPositionInput(e, (o, n, s, i) => {
      n < i && t.push(Ft(o.getValue()));
    }), t;
  }
  createEValue() {
    const e = ze({ tag: "div", cls: "ag-filter-body", role: "presentation" }), { eValuesFrom: t, eValuesTo: o } = this;
    return this.createFromToElement(e, t, "from"), this.createFromToElement(e, o, "to"), e;
  }
  createFromToElement(e, t, o) {
    const n = this.createManagedBean(new an());
    n.addCss(`ag-filter-${o}`), n.addCss("ag-filter-filter"), t.push(n), e.appendChild(n.getGui());
  }
  removeEValues(e, t) {
    const o = (i) => this.removeComponents(i, e, t), { eValuesFrom: n, eValuesTo: s } = this;
    o(n), o(s);
  }
}, Ny = class extends uc {
  constructor() {
    super(...arguments), this.filterTypeKeys = Dze;
  }
  conditionToString(e, t, o, n, s) {
    const { filter: i, filterTo: r, type: l } = e;
    if (t) {
      const a = (d) => () => ts(this, "filterSummaryTextQuote", [d]), c = this.conditionForToolPanel(
        l,
        o,
        a(i),
        a(r),
        n,
        s
      );
      if (c != null)
        return c;
    }
    return o ? `${i}-${r}` : i != null ? `${i}` : `${l}`;
  }
}, Uze = ({ filterOption: e, value: t, filterText: o }) => {
  if (o == null)
    return !1;
  switch (e) {
    case "contains":
      return t.indexOf(o) >= 0;
    case "notContains":
      return t.indexOf(o) < 0;
    case "equals":
      return t === o;
    case "notEqual":
      return t != o;
    case "startsWith":
      return t.indexOf(o) === 0;
    case "endsWith": {
      const n = t.lastIndexOf(o);
      return n >= 0 && n === t.length - o.length;
    }
    default:
      return !1;
  }
}, Kze = (e) => e, qze = (e) => e == null ? null : e.toString().toLowerCase(), Yze = class extends Iy {
  constructor() {
    super(Zy, gc), this.filterType = "text", this.FilterModelFormatterClass = Ny;
  }
  updateParams(e) {
    super.updateParams(e);
    const t = e.filterParams;
    this.matcher = t.textMatcher ?? Uze, this.formatter = t.textFormatter ?? (t.caseSensitive ? Kze : qze);
  }
  evaluateNullValue(e) {
    return e ? ["notEqual", "notContains", "blank"].indexOf(e) >= 0 : !1;
  }
  evaluateNonNullValue(e, t, o, n) {
    const s = e.map((h) => this.formatter(h)) || [], i = this.formatter(t), {
      api: r,
      colDef: l,
      column: a,
      context: c,
      filterParams: { textFormatter: d }
    } = this.params;
    if (o.type === "blank")
      return Ol(t);
    if (o.type === "notBlank")
      return !Ol(t);
    const u = {
      api: r,
      colDef: l,
      column: a,
      context: c,
      node: n.node,
      data: n.data,
      filterOption: o.type,
      value: i,
      textFormatter: d
    };
    return s.some((h) => this.matcher({ ...u, filterText: h }));
  }
  processModelToApply(e) {
    if (e && this.params.filterParams.trimInput) {
      const t = (o) => {
        const n = {
          ...o
        }, { filter: s, filterTo: i } = o;
        return s && (n.filter = x5(s) ?? null), i && (n.filterTo = x5(i) ?? null), n;
      };
      return Mb(e) ? {
        ...e,
        conditions: e.conditions.map(t)
      } : t(e);
    }
    return e;
  }
}, Qze = class extends Gy {
  constructor() {
    super(...arguments), this.FilterModelFormatterClass = Ny, this.filterType = "text", this.defaultOptions = gc;
  }
  createFloatingFilterInputService() {
    return this.createManagedBean(new $y());
  }
};
function Jze(e) {
  var t;
  return !!((t = e.quickFilter) != null && t.isFilterPresent());
}
function Xze(e) {
  var t;
  return (t = e.quickFilter) == null ? void 0 : t.getText();
}
function eje(e) {
  var t;
  (t = e.quickFilter) == null || t.resetCache();
}
var tje = class extends K {
  constructor() {
    super(...arguments), this.beanName = "quickFilter", this.quickFilter = null, this.quickFilterParts = null;
  }
  postConstruct() {
    const e = this.resetCache.bind(this), t = this.gos;
    this.addManagedEventListeners({
      columnPivotModeChanged: e,
      newColumnsLoaded: e,
      columnRowGroupChanged: e,
      columnVisible: () => {
        t.get("includeHiddenColumnsInQuickFilter") || this.resetCache();
      }
    }), this.addManagedPropertyListener("quickFilterText", (o) => this.setFilter(o.currentValue)), this.addManagedPropertyListeners(
      ["includeHiddenColumnsInQuickFilter", "applyQuickFilterBeforePivotOrAgg"],
      () => this.onColumnConfigChanged()
    ), this.quickFilter = this.parseFilter(t.get("quickFilterText")), this.parser = t.get("quickFilterParser"), this.matcher = t.get("quickFilterMatcher"), this.setFilterParts(), this.addManagedPropertyListeners(["quickFilterMatcher", "quickFilterParser"], () => this.setParserAndMatcher());
  }
  // if we are using autoGroupCols, then they should be included for quick filter. this covers the
  // following scenarios:
  // a) user provides 'field' into autoGroupCol of normal grid, so now because a valid col to filter leafs on
  // b) using tree data and user depends on autoGroupCol for first col, and we also want to filter on this
  //    (tree data is a bit different, as parent rows can be filtered on, unlike row grouping)
  refreshCols() {
    var a;
    const { autoColSvc: e, colModel: t, gos: o, pivotResultCols: n } = this.beans, s = t.isPivotMode(), i = e == null ? void 0 : e.getColumns(), r = t.getColDefCols();
    let l = (s && !o.get("applyQuickFilterBeforePivotOrAgg") ? (a = n == null ? void 0 : n.getPivotResultCols()) == null ? void 0 : a.list : r) ?? [];
    i && (l = l.concat(i)), this.colsToUse = o.get("includeHiddenColumnsInQuickFilter") ? l : l.filter((c) => c.isVisible() || c.isRowGroupActive());
  }
  isFilterPresent() {
    return this.quickFilter !== null;
  }
  doesRowPass(e) {
    const t = this.gos.get("cacheQuickFilter");
    return this.matcher ? this.doesRowPassMatcher(t, e) : this.quickFilterParts.every(
      (o) => t ? this.doesRowPassCache(e, o) : this.doesRowPassNoCache(e, o)
    );
  }
  resetCache() {
    this.beans.rowModel.forEachNode((e) => e.quickFilterAggregateText = null);
  }
  getText() {
    return this.gos.get("quickFilterText");
  }
  setFilterParts() {
    const { quickFilter: e, parser: t } = this;
    e ? this.quickFilterParts = t ? t(e) : e.split(" ") : this.quickFilterParts = null;
  }
  parseFilter(e) {
    return ue(e) ? e.toUpperCase() : null;
  }
  setFilter(e) {
    if (e != null && typeof e != "string") {
      X(70, { newFilter: e });
      return;
    }
    const t = this.parseFilter(e);
    this.quickFilter !== t && (this.quickFilter = t, this.setFilterParts(), this.dispatchLocalEvent({ type: "quickFilterChanged" }));
  }
  setParserAndMatcher() {
    const e = this.gos.get("quickFilterParser"), t = this.gos.get("quickFilterMatcher"), o = e !== this.parser || t !== this.matcher;
    this.parser = e, this.matcher = t, o && (this.setFilterParts(), this.dispatchLocalEvent({ type: "quickFilterChanged" }));
  }
  onColumnConfigChanged() {
    this.refreshCols(), this.resetCache(), this.isFilterPresent() && this.dispatchLocalEvent({ type: "quickFilterChanged" });
  }
  doesRowPassNoCache(e, t) {
    return this.colsToUse.some((o) => {
      const n = this.getTextForColumn(o, e);
      return ue(n) && n.indexOf(t) >= 0;
    });
  }
  doesRowPassCache(e, t) {
    return this.checkGenerateAggText(e), e.quickFilterAggregateText.indexOf(t) >= 0;
  }
  doesRowPassMatcher(e, t) {
    let o;
    e ? (this.checkGenerateAggText(t), o = t.quickFilterAggregateText) : o = this.getAggText(t);
    const { quickFilterParts: n, matcher: s } = this;
    return s(n, o);
  }
  checkGenerateAggText(e) {
    e.quickFilterAggregateText || (e.quickFilterAggregateText = this.getAggText(e));
  }
  getTextForColumn(e, t) {
    let o = this.beans.filterValueSvc.getValue(e, t);
    const n = e.getColDef();
    if (n.getQuickFilterText) {
      const s = Pe(this.gos, {
        value: o,
        node: t,
        data: t.data,
        column: e,
        colDef: n
      });
      o = n.getQuickFilterText(s);
    }
    return ue(o) ? o.toString().toUpperCase() : null;
  }
  getAggText(e) {
    const t = [];
    return this.colsToUse.forEach((o) => {
      const n = this.getTextForColumn(o, e);
      ue(n) && t.push(n);
    }), t.join(`
`);
  }
}, oje = {
  moduleName: "ClientSideRowModelFilter",
  version: be,
  rowModels: ["clientSide"],
  beans: [sze]
}, xa = {
  moduleName: "FilterCore",
  version: be,
  beans: [Mze],
  apiFunctions: {
    isAnyFilterPresent: Sze,
    onFilterChanged: xze
  },
  css: [cze],
  dependsOn: [oje]
}, pc = {
  moduleName: "FilterValue",
  version: be,
  beans: [Lze]
}, v1 = {
  moduleName: "ColumnFilter",
  version: be,
  beans: [_ze, Aze],
  dynamicBeans: { headerFilterCellCtrl: ize },
  icons: {
    // open filter button - header, floating filter, menu
    filter: "filter",
    // filter is applied - header (legacy column menu), filter tool panel
    filterActive: "filter"
  },
  apiFunctions: {
    isColumnFilterPresent: dze,
    getColumnFilterInstance: uze,
    destroyFilter: hze,
    setFilterModel: gze,
    getFilterModel: pze,
    getColumnFilterModel: fze,
    setColumnFilterModel: vze,
    showColumnFilter: mze,
    hideColumnFilter: Cze,
    getColumnFilterHandler: wze,
    doFilterAction: bze
  },
  dependsOn: [xa, li, pc, Ry]
}, nje = {
  moduleName: "CustomFilter",
  version: be,
  userComponents: { agReadOnlyFloatingFilter: Pze },
  dependsOn: [v1]
}, sje = {
  moduleName: "TextFilter",
  version: be,
  dependsOn: [v1],
  userComponents: {
    agTextColumnFilter: {
      classImp: Wze,
      params: {
        useForm: !0
      }
    },
    agTextColumnFloatingFilter: Qze
  },
  dynamicBeans: {
    agTextColumnFilterHandler: Yze
  }
}, ije = {
  moduleName: "NumberFilter",
  version: be,
  dependsOn: [v1],
  userComponents: {
    agNumberColumnFilter: {
      classImp: Zze,
      params: {
        useForm: !0
      }
    },
    agNumberColumnFloatingFilter: jze
  },
  dynamicBeans: {
    agNumberColumnFilterHandler: Gze
  }
}, rje = {
  moduleName: "DateFilter",
  version: be,
  dependsOn: [v1],
  userComponents: {
    agDateColumnFilter: {
      classImp: Ize,
      params: {
        useForm: !0
      }
    },
    agDateInput: $ze,
    agDateColumnFloatingFilter: Oze
  },
  dynamicBeans: {
    agDateColumnFilterHandler: Hze
  }
}, lje = {
  moduleName: "QuickFilterCore",
  version: be,
  rowModels: ["clientSide"],
  beans: [tje],
  dependsOn: [xa, pc]
}, aje = {
  moduleName: "QuickFilter",
  version: be,
  apiFunctions: {
    isQuickFilterPresent: Jze,
    getQuickFilter: Xze,
    resetQuickFilter: eje
  },
  dependsOn: [lje]
}, cje = {
  moduleName: "ExternalFilter",
  version: be,
  dependsOn: [xa]
}, dje = (
  /*css*/
  ".ag-tooltip{background-color:var(--ag-tooltip-background-color);border:var(--ag-tooltip-border);border-radius:var(--ag-border-radius);color:var(--ag-tooltip-text-color);padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding);position:absolute;white-space:normal;z-index:99999;&:where(.ag-cell-editor-tooltip){background-color:var(--ag-tooltip-error-background-color);border:var(--ag-tooltip-error-border);color:var(--ag-tooltip-error-text-color);font-weight:500}}.ag-tooltip-custom{position:absolute;z-index:99999}.ag-tooltip-custom:where(:not(.ag-tooltip-interactive)),.ag-tooltip:where(:not(.ag-tooltip-interactive)){pointer-events:none}.ag-tooltip-animate{transition:opacity 1s;&:where(.ag-tooltip-hiding){opacity:0}}"
), y0 = (e, t, o) => {
  var l, a, c;
  const { editModelSvc: n } = e, s = (a = (l = n == null ? void 0 : n.getCellValidationModel()) == null ? void 0 : l.getCellValidation(t)) == null ? void 0 : a.errorMessages, i = (c = n == null ? void 0 : n.getRowValidationModel().getRowValidation(t)) == null ? void 0 : c.errorMessages, r = s || i;
  return r && r.length ? r.join(o("tooltipValidationErrorSeparator", ". ")) : void 0;
}, uje = class extends K {
  constructor() {
    super(...arguments), this.beanName = "tooltipSvc";
  }
  setupHeaderTooltip(e, t, o, n) {
    e && t.destroyBean(e);
    const s = Tr(this.gos), { column: i, eGui: r } = t, l = i.getColDef();
    !n && s && !l.headerComponent && (n = Hs(
      () => r.querySelector(".ag-header-cell-text")
    ));
    const a = {
      getGui: () => r,
      getLocation: () => "header",
      getTooltipValue: () => o ?? i.getColDef().headerTooltip,
      shouldDisplayTooltip: n,
      getAdditionalParams: () => ({
        column: i,
        colDef: i.getColDef()
      })
    };
    let c = this.createTooltipFeature(a);
    return c && (c = t.createBean(c), t.setRefreshFunction("tooltip", () => c.refreshTooltip())), c;
  }
  setupHeaderGroupTooltip(e, t, o, n) {
    e && t.destroyBean(e);
    const s = Tr(this.gos), { column: i, eGui: r } = t, l = i.getColGroupDef();
    !n && s && !(l != null && l.headerGroupComponent) && (n = Hs(
      () => r.querySelector(".ag-header-group-text")
    ));
    const a = {
      getGui: () => r,
      getLocation: () => "headerGroup",
      getTooltipValue: () => o ?? (l && l.headerTooltip),
      shouldDisplayTooltip: n,
      getAdditionalParams: () => {
        const d = {
          column: i
        };
        return l && (d.colDef = l), d;
      }
    }, c = this.createTooltipFeature(a);
    return c && t.createBean(c);
  }
  enableCellTooltipFeature(e, t, o) {
    const { beans: n } = this, { gos: s, editSvc: i } = n, { column: r, rowNode: l } = e;
    let a = "cell";
    const c = () => {
      const p = !!!(i != null && i.isEditing(e)) && y0(n, e, this.getLocaleTextFunc());
      if (p)
        return a = "cellEditor", p;
      a = "cell";
      const C = r.getColDef(), m = l.data;
      if (C.tooltipField && ue(m))
        return Pr(m, C.tooltipField, r.isTooltipFieldContainsDots());
      const w = C.tooltipValueGetter;
      return w ? w(
        Pe(s, {
          location: "cell",
          colDef: r.getColDef(),
          column: r,
          rowIndex: e.cellPosition.rowIndex,
          node: l,
          data: l.data,
          value: e.value,
          valueFormatted: e.valueFormatted
        })
      ) : null;
    }, d = Tr(s);
    o || (d && !e.isCellRenderer() ? o = () => {
      const h = !!(i != null && i.isEditing(e));
      if (!h && y0(n, e, this.getLocaleTextFunc()))
        return !0;
      if (!r.isTooltipEnabled())
        return !1;
      const m = Hs(() => {
        const w = e.eGui;
        return w.children.length === 0 ? w : w.querySelector(".ag-cell-value");
      });
      return !h && m();
    } : o = () => !(i != null && i.isEditing(e)));
    const u = {
      getGui: () => e.eGui,
      getLocation: () => a,
      getTooltipValue: t != null ? () => t : c,
      shouldDisplayTooltip: o,
      getAdditionalParams: () => ({
        column: r,
        colDef: r.getColDef(),
        rowIndex: e.cellPosition.rowIndex,
        node: l,
        data: l.data,
        valueFormatted: e.valueFormatted
      })
    };
    return this.createTooltipFeature(u, n);
  }
  setupFullWidthRowTooltip(e, t, o, n) {
    const s = {
      getGui: () => t.getFullWidthElement(),
      getTooltipValue: () => o,
      getLocation: () => "fullWidthRow",
      shouldDisplayTooltip: n
    }, i = this.beans, r = i.context;
    e && t.destroyBean(e, r);
    const l = this.createTooltipFeature(s, i);
    if (l)
      return t.createBean(l, r);
  }
  setupCellEditorTooltip(e, t) {
    var l, a;
    const { beans: o } = this, { context: n } = o, s = ((l = t.getValidationElement) == null ? void 0 : l.call(t, !0)) || !((a = t.isPopup) != null && a.call(t)) && e.eGui;
    if (!s)
      return;
    const i = {
      getGui: () => s,
      getTooltipValue: () => y0(o, e, this.getLocaleTextFunc()),
      getLocation: () => "cellEditor",
      shouldDisplayTooltip: () => {
        var C, m;
        const { editModelSvc: c } = o, d = (C = c == null ? void 0 : c.getRowValidationModel()) == null ? void 0 : C.getRowValidationMap(), u = (m = c == null ? void 0 : c.getCellValidationModel()) == null ? void 0 : m.getCellValidationMap(), h = !!d && d.size > 0, p = !!u && u.size > 0;
        return h || p;
      }
    }, r = this.createTooltipFeature(i, o);
    if (r)
      return e.createBean(r, n);
  }
  initCol(e) {
    const { colDef: t } = e;
    e.tooltipEnabled = ue(t.tooltipField) || ue(t.tooltipValueGetter) || ue(t.tooltipComponent);
  }
  createTooltipFeature(e, t) {
    return this.beans.registry.createDynamicBean("tooltipFeature", !1, e, t);
  }
}, hje = class extends Wke {
  createTooltipComp(e, t) {
    const o = VDe(this.beans.userCompFactory, e);
    o == null || o.newAgStackInstance().then(t);
  }
  setEventHandlers(e) {
    [this.onColumnMovedEventCallback] = this.addManagedEventListeners({
      columnMoved: e
    });
  }
  clearEventHandlers() {
    var e;
    (e = this.onColumnMovedEventCallback) == null || e.call(this), this.onColumnMovedEventCallback = void 0;
  }
}, fc = {
  moduleName: "Tooltip",
  version: be,
  beans: [uje],
  dynamicBeans: {
    tooltipFeature: gb,
    highlightTooltipFeature: Uke,
    tooltipStateManager: hje
  },
  userComponents: {
    agTooltipComponent: Yke
  },
  dependsOn: [li],
  css: [dje]
}, mi = class {
  constructor(e) {
    this.cellValueChanges = e;
  }
}, _0 = class extends mi {
  constructor(e, t, o, n) {
    super(e), this.initialRange = t, this.finalRange = o, this.ranges = n;
  }
}, gje = 10, Eu = class {
  constructor(e) {
    this.actionStack = [], this.maxStackSize = e || gje, this.actionStack = new Array(this.maxStackSize);
  }
  pop() {
    return this.actionStack.pop();
  }
  push(e) {
    e.cellValueChanges && e.cellValueChanges.length > 0 && (this.actionStack.length === this.maxStackSize && this.actionStack.shift(), this.actionStack.push(e));
  }
  clear() {
    this.actionStack = [];
  }
  getCurrentStackSize() {
    return this.actionStack.length;
  }
}, pje = class extends K {
  constructor() {
    super(...arguments), this.beanName = "undoRedo", this.cellValueChanges = [], this.activeCellEdit = null, this.activeRowEdit = null, this.isPasting = !1, this.isRangeInAction = !1, this.batchEditing = !1, this.bulkEditing = !1, this.onCellValueChanged = (e) => {
      const t = { column: e.column, rowIndex: e.rowIndex, rowPinned: e.rowPinned }, o = this.activeCellEdit !== null && ec(this.activeCellEdit, t), n = this.activeRowEdit !== null && Yb(this.activeRowEdit, t);
      if (!(o || n || this.isPasting || this.isRangeInAction))
        return;
      const { rowPinned: i, rowIndex: r, column: l, oldValue: a, value: c } = e, d = {
        rowPinned: i,
        rowIndex: r,
        columnId: l.getColId(),
        newValue: c,
        oldValue: a
      };
      this.cellValueChanges.push(d);
    }, this.clearStacks = () => {
      this.undoStack.clear(), this.redoStack.clear();
    };
  }
  postConstruct() {
    const { gos: e, ctrlsSvc: t } = this.beans;
    if (!e.get("undoRedoCellEditing"))
      return;
    const o = e.get("undoRedoCellEditingLimit");
    if (o <= 0)
      return;
    this.undoStack = new Eu(o), this.redoStack = new Eu(o), this.addListeners();
    const n = this.clearStacks.bind(this);
    this.addManagedEventListeners({
      cellValueChanged: this.onCellValueChanged.bind(this),
      // undo / redo is restricted to actual editing so we clear the stacks when other operations are
      // performed that change the order of the row / cols.
      modelUpdated: (s) => {
        s.keepUndoRedoStack || this.clearStacks();
      },
      columnPivotModeChanged: n,
      newColumnsLoaded: n,
      columnGroupOpened: n,
      columnRowGroupChanged: n,
      columnMoved: n,
      columnPinned: n,
      columnVisible: n,
      rowDragEnd: n
    }), t.whenReady(this, (s) => {
      this.gridBodyCtrl = s.gridBodyCtrl;
    });
  }
  getCurrentUndoStackSize() {
    var e;
    return ((e = this.undoStack) == null ? void 0 : e.getCurrentStackSize()) ?? 0;
  }
  getCurrentRedoStackSize() {
    var e;
    return ((e = this.redoStack) == null ? void 0 : e.getCurrentStackSize()) ?? 0;
  }
  undo(e) {
    const { eventSvc: t, undoStack: o, redoStack: n } = this;
    t.dispatchEvent({
      type: "undoStarted",
      source: e
    });
    const s = this.undoRedo(o, n, "initialRange", "oldValue", "undo");
    t.dispatchEvent({
      type: "undoEnded",
      source: e,
      operationPerformed: s
    });
  }
  redo(e) {
    const { eventSvc: t, undoStack: o, redoStack: n } = this;
    t.dispatchEvent({
      type: "redoStarted",
      source: e
    });
    const s = this.undoRedo(n, o, "finalRange", "newValue", "redo");
    t.dispatchEvent({
      type: "redoEnded",
      source: e,
      operationPerformed: s
    });
  }
  undoRedo(e, t, o, n, s) {
    if (!e)
      return !1;
    const i = e.pop();
    return !i || !i.cellValueChanges ? !1 : (this.processAction(
      i,
      (r) => r[n],
      s
    ), i instanceof _0 ? this.processRange(i.ranges || [i[o]]) : this.processCell(i.cellValueChanges), t.push(i), !0);
  }
  processAction(e, t, o) {
    e.cellValueChanges.forEach((n) => {
      const { rowIndex: s, rowPinned: i, columnId: r } = n, l = { rowIndex: s, rowPinned: i }, a = vn(this.beans, l);
      a.displayed && a.setDataValue(r, t(n), o);
    });
  }
  processRange(e) {
    let t;
    const o = this.beans.rangeSvc;
    o.removeAllCellRanges(!0), e.forEach((n, s) => {
      if (!n)
        return;
      const i = n.startRow, r = n.endRow;
      s === e.length - 1 && (t = {
        rowPinned: i.rowPinned,
        rowIndex: i.rowIndex,
        columnId: n.startColumn.getColId()
      }, this.setLastFocusedCell(t));
      const l = {
        rowStartIndex: i.rowIndex,
        rowStartPinned: i.rowPinned,
        rowEndIndex: r.rowIndex,
        rowEndPinned: r.rowPinned,
        columnStart: n.startColumn,
        columns: n.columns
      };
      o.addCellRange(l);
    });
  }
  processCell(e) {
    const t = e[0], { rowIndex: o, rowPinned: n } = t, s = { rowIndex: o, rowPinned: n }, i = vn(this.beans, s), r = {
      rowPinned: t.rowPinned,
      rowIndex: i.rowIndex,
      columnId: t.columnId
    };
    this.setLastFocusedCell(r);
  }
  setLastFocusedCell(e) {
    const { rowIndex: t, columnId: o, rowPinned: n } = e, { colModel: s, focusSvc: i, rangeSvc: r } = this.beans, l = s.getCol(o);
    if (!l)
      return;
    const { scrollFeature: a } = this.gridBodyCtrl;
    a.ensureIndexVisible(t), a.ensureColumnVisible(l);
    const c = { rowIndex: t, column: l, rowPinned: n };
    i.setFocusedCell({ ...c, forceBrowserFocus: !0 }), r == null || r.setRangeToCell(c);
  }
  addListeners() {
    this.addManagedEventListeners({
      rowEditingStarted: (e) => {
        this.activeRowEdit = { rowIndex: e.rowIndex, rowPinned: e.rowPinned };
      },
      rowEditingStopped: () => {
        const e = new mi(this.cellValueChanges);
        this.pushActionsToUndoStack(e), this.activeRowEdit = null;
      },
      cellEditingStarted: (e) => {
        this.activeCellEdit = { column: e.column, rowIndex: e.rowIndex, rowPinned: e.rowPinned };
      },
      cellEditingStopped: (e) => {
        if (this.activeCellEdit = null, e.valueChanged && !this.activeRowEdit && !this.isPasting && !this.isRangeInAction) {
          const o = new mi(this.cellValueChanges);
          this.pushActionsToUndoStack(o);
        }
      },
      pasteStart: () => {
        this.isPasting = !0;
      },
      pasteEnd: () => {
        const e = new mi(this.cellValueChanges);
        this.pushActionsToUndoStack(e), this.isPasting = !1;
      },
      fillStart: () => {
        this.isRangeInAction = !0;
      },
      fillEnd: (e) => {
        const t = new _0(this.cellValueChanges, e.initialRange, e.finalRange);
        this.pushActionsToUndoStack(t), this.isRangeInAction = !1;
      },
      keyShortcutChangedCellStart: () => {
        this.isRangeInAction = !0;
      },
      keyShortcutChangedCellEnd: () => {
        let e;
        const { rangeSvc: t, gos: o } = this.beans;
        t && kn(o) ? e = new _0(this.cellValueChanges, void 0, void 0, [
          ...t.getCellRanges()
        ]) : e = new mi(this.cellValueChanges), this.pushActionsToUndoStack(e), this.isRangeInAction = !1;
      },
      batchEditingStarted: () => this.startBigChange("batchEditing"),
      batchEditingStopped: ({ changes: e }) => this.stopBigChange("batchEditing", e),
      bulkEditingStarted: () => this.startBigChange("bulkEditing"),
      bulkEditingStopped: ({ changes: e }) => this.stopBigChange("bulkEditing", e)
    });
  }
  startBigChange(e) {
    this[e] = !0;
  }
  stopBigChange(e, t) {
    if (!this[e] || (this[e] = !1, (t == null ? void 0 : t.length) === 0))
      return;
    const o = new mi(t ?? []);
    this.pushActionsToUndoStack(o), this.cellValueChanges = [];
  }
  pushActionsToUndoStack(e) {
    this.undoStack.push(e), this.cellValueChanges = [], this.redoStack.clear();
  }
}, fje = (
  /*css*/
  ".ag-cell-inline-editing{border:var(--ag-cell-editing-border)!important;border-radius:var(--ag-border-radius);box-shadow:var(--ag-cell-editing-shadow);padding:0;z-index:1;.ag-cell-edit-wrapper,.ag-cell-editor,.ag-cell-wrapper,:where(.ag-cell-editor) .ag-input-field-input,:where(.ag-cell-editor) .ag-wrapper{height:100%;line-height:normal;min-height:100%;width:100%}&.ag-cell-editing-error{border-color:var(--ag-invalid-color)!important}}:where(.ag-popup-editor) .ag-large-text{background-color:var(--ag-background-color);border-radius:var(--ag-border-radius);box-shadow:var(--ag-dropdown-shadow);padding:0}.ag-large-text-input{display:block;height:auto;padding:var(--ag-cell-horizontal-padding)}:where(.ag-rtl .ag-large-text-input) textarea{resize:none}:where(.ag-ltr) .ag-checkbox-edit{padding-left:var(--ag-cell-horizontal-padding)}:where(.ag-rtl) .ag-checkbox-edit{padding-right:var(--ag-cell-horizontal-padding)}:where(.ag-row.ag-row-editing-invalid .ag-cell-inline-editing){opacity:.8}.ag-popup-editor{position:absolute;-webkit-user-select:none;-moz-user-select:none;user-select:none}"
), vje = {
  tag: "div",
  cls: "ag-cell-wrapper ag-cell-edit-wrapper ag-checkbox-edit",
  children: [
    {
      tag: "ag-checkbox",
      ref: "eEditor",
      role: "presentation"
    }
  ]
}, mje = class extends ya {
  constructor() {
    super(vje, [ii]), this.eEditor = J;
  }
  initialiseEditor(e) {
    const t = e.value ?? void 0, o = this.eEditor;
    o.setValue(t), o.getInputElement().setAttribute("tabindex", "-1"), this.setAriaLabel(t), this.addManagedListeners(o, {
      fieldValueChanged: (s) => this.setAriaLabel(s.selected)
    });
  }
  getValue() {
    return this.eEditor.getValue();
  }
  focusIn() {
    this.eEditor.getFocusableElement().focus();
  }
  afterGuiAttached() {
    this.params.cellStartedEdit && this.focusIn();
  }
  isPopup() {
    return !1;
  }
  setAriaLabel(e) {
    const t = this.getLocaleTextFunc(), o = aa(t, e), n = t("ariaToggleCellValue", "Press SPACE to toggle cell value");
    this.eEditor.setInputAriaLabel(`${n} (${o})`);
  }
  getValidationElement(e) {
    return e ? this.params.eGridCell : this.eEditor.getInputElement();
  }
  getValidationErrors() {
    const { params: e } = this, { getValidationErrors: t } = e, o = this.getValue();
    return t ? t({
      value: o,
      internalErrors: null,
      cellEditorParams: e
    }) : null;
  }
}, Ma = class extends ya {
  constructor(e) {
    super(), this.cellEditorInput = e, this.eEditor = J;
  }
  initialiseEditor(e) {
    const { cellEditorInput: t } = this;
    this.setTemplate(
      { tag: "div", cls: "ag-cell-edit-wrapper", children: [t.getTemplate()] },
      t.getAgComponents()
    );
    const { eEditor: o } = this, { cellStartedEdit: n, eventKey: s, suppressPreventDefault: i } = e;
    o.getInputElement().setAttribute("title", ""), t.init(o, e);
    let r, l = !0;
    n ? (this.focusAfterAttached = !0, s === D.BACKSPACE || s === D.DELETE ? r = "" : s && s.length === 1 ? i ? l = !1 : r = s : (r = t.getStartValue(), s !== D.F2 && (this.highlightAllOnFocus = !0))) : (this.focusAfterAttached = !1, r = t.getStartValue()), l && r != null && o.setStartValue(r), this.addGuiEventListener("keydown", (a) => {
      const { key: c } = a;
      (c === D.PAGE_UP || c === D.PAGE_DOWN) && a.preventDefault();
    });
  }
  afterGuiAttached() {
    var n, s;
    const e = this.getLocaleTextFunc(), t = this.eEditor;
    if (t.setInputAriaLabel(e("ariaInputEditor", "Input Editor")), !this.focusAfterAttached)
      return;
    Gn() || t.getFocusableElement().focus();
    const o = t.getInputElement();
    this.highlightAllOnFocus ? o.select() : (s = (n = this.cellEditorInput).setCaret) == null || s.call(n);
  }
  // gets called when tabbing through cells and in full row edit mode
  focusIn() {
    const { eEditor: e } = this, t = e.getFocusableElement(), o = e.getInputElement();
    t.focus(), o.select();
  }
  getValue() {
    return this.cellEditorInput.getValue();
  }
  isPopup() {
    return !1;
  }
  getValidationElement() {
    return this.eEditor.getInputElement();
  }
  getValidationErrors() {
    return this.cellEditorInput.getValidationErrors();
  }
}, Cje = {
  tag: "ag-input-date-field",
  ref: "eEditor",
  cls: "ag-cell-editor"
}, wje = class {
  constructor(e, t) {
    this.getDataTypeService = e, this.getLocaleTextFunc = t;
  }
  getTemplate() {
    return Cje;
  }
  getAgComponents() {
    return [sb];
  }
  init(e, t) {
    var r, l;
    this.eEditor = e, this.params = t;
    const { min: o, max: n, step: s, colDef: i } = t;
    o != null && e.setMin(o), n != null && e.setMax(n), s != null && e.setStep(s), this.includeTime = t.includeTime ?? ((l = (r = this.getDataTypeService()) == null ? void 0 : r.getDateIncludesTimeFlag) == null ? void 0 : l.call(r, i.cellDataType)), this.includeTime != null && e.setIncludeTime(this.includeTime);
  }
  getValidationErrors() {
    const t = this.eEditor.getInputElement().valueAsDate, { params: o } = this, { min: n, max: s, getValidationErrors: i } = o;
    let r = [];
    const l = this.getLocaleTextFunc();
    if (t instanceof Date && !isNaN(t.getTime())) {
      if (n) {
        const a = n instanceof Date ? n : new Date(n);
        if (t < a) {
          const c = a.toLocaleDateString();
          r.push(
            l("minDateValidation", `Date must be after ${c}`, [c])
          );
        }
      }
      if (s) {
        const a = s instanceof Date ? s : new Date(s);
        if (t > a) {
          const c = a.toLocaleDateString();
          r.push(
            l("maxDateValidation", `Date must be before ${c}`, [c])
          );
        }
      }
    }
    return r.length || (r = null), i ? i({ value: t, cellEditorParams: o, internalErrors: r }) : r;
  }
  getValue() {
    const { eEditor: e, params: t } = this, o = e.getDate();
    return !ue(o) && !ue(t.value) ? t.value : o ?? null;
  }
  getStartValue() {
    const { value: e } = this.params;
    if (e instanceof Date)
      return to(e, this.includeTime ?? !1);
  }
}, bje = class extends Ma {
  constructor() {
    super(
      new wje(
        () => this.beans.dataTypeSvc,
        () => this.getLocaleTextFunc()
      )
    );
  }
}, yje = {
  tag: "ag-input-date-field",
  ref: "eEditor",
  cls: "ag-cell-editor"
}, _je = class {
  constructor(e, t) {
    this.getDataTypeService = e, this.getLocaleTextFunc = t;
  }
  getTemplate() {
    return yje;
  }
  getAgComponents() {
    return [sb];
  }
  init(e, t) {
    var r, l;
    this.eEditor = e, this.params = t;
    const { min: o, max: n, step: s, colDef: i } = t;
    o != null && e.setMin(o), n != null && e.setMax(n), s != null && e.setStep(s), this.includeTime = t.includeTime ?? ((l = (r = this.getDataTypeService()) == null ? void 0 : r.getDateIncludesTimeFlag) == null ? void 0 : l.call(r, i.cellDataType)), this.includeTime != null && e.setIncludeTime(this.includeTime);
  }
  getValidationErrors() {
    const { eEditor: e, params: t } = this, o = e.getInputElement().value, n = this.formatDate(this.parseDate(o ?? void 0)), { min: s, max: i, getValidationErrors: r } = t;
    let l = [];
    if (n) {
      const a = new Date(n), c = this.getLocaleTextFunc();
      if (s) {
        const d = new Date(s);
        if (a < d) {
          const u = d.toLocaleDateString();
          l.push(
            c("minDateValidation", `Date must be after ${u}`, [u])
          );
        }
      }
      if (i) {
        const d = new Date(i);
        if (a > d) {
          const u = d.toLocaleDateString();
          l.push(
            c("maxDateValidation", `Date must be before ${u}`, [u])
          );
        }
      }
    }
    return l.length || (l = null), r ? r({
      value: this.getValue(),
      cellEditorParams: t,
      internalErrors: l
    }) : l;
  }
  getValue() {
    const { params: e, eEditor: t } = this, o = this.formatDate(t.getDate());
    return !ue(o) && !ue(e.value) ? e.value : e.parseValue(o ?? "");
  }
  getStartValue() {
    return to(this.parseDate(this.params.value ?? void 0) ?? null, this.includeTime ?? !1);
  }
  parseDate(e) {
    const t = this.getDataTypeService();
    return t ? t.getDateParserFunction(this.params.column)(e) : Wt(e) ?? void 0;
  }
  formatDate(e) {
    const t = this.getDataTypeService();
    return t ? t.getDateFormatterFunction(this.params.column)(e) : to(e ?? null, this.includeTime ?? !1) ?? void 0;
  }
}, Sje = class extends Ma {
  constructor() {
    super(
      new _je(
        () => this.beans.dataTypeSvc,
        () => this.getLocaleTextFunc()
      )
    );
  }
}, xje = {
  tag: "div",
  cls: "ag-large-text",
  children: [
    {
      tag: "ag-input-text-area",
      ref: "eEditor",
      cls: "ag-large-text-input"
    }
  ]
}, Mje = class extends ya {
  constructor() {
    super(xje, [nke]), this.eEditor = J;
  }
  initialiseEditor(e) {
    const { eEditor: t } = this, { cellStartedEdit: o, eventKey: n, maxLength: s, cols: i, rows: r } = e;
    this.focusAfterAttached = o, t.getInputElement().setAttribute("title", ""), t.setMaxLength(s || 200).setCols(i || 60).setRows(r || 10);
    let l;
    o ? (this.focusAfterAttached = !0, n === D.BACKSPACE || n === D.DELETE ? l = "" : n && n.length === 1 ? l = n : (l = this.getStartValue(e), n !== D.F2 && (this.highlightAllOnFocus = !0))) : (this.focusAfterAttached = !1, l = this.getStartValue(e)), l != null && t.setValue(l, !0), this.addGuiEventListener("keydown", this.onKeyDown.bind(this)), this.activateTabIndex();
  }
  getStartValue(e) {
    const { value: t } = e;
    return (t == null ? void 0 : t.toString()) ?? t;
  }
  onKeyDown(e) {
    const t = e.key;
    (t === D.LEFT || t === D.UP || t === D.RIGHT || t === D.DOWN || e.shiftKey && t === D.ENTER) && e.stopPropagation();
  }
  afterGuiAttached() {
    const { eEditor: e, focusAfterAttached: t, highlightAllOnFocus: o } = this, n = this.getLocaleTextFunc();
    e.setInputAriaLabel(n("ariaInputEditor", "Input Editor")), t && (e.getFocusableElement().focus(), o && e.getInputElement().select());
  }
  getValue() {
    const { eEditor: e, params: t } = this, { value: o } = t, n = e.getValue();
    return !ue(n) && !ue(o) ? o : t.parseValue(n);
  }
  getValidationElement() {
    return this.eEditor.getInputElement();
  }
  getValidationErrors() {
    const { params: e } = this, { maxLength: t, getValidationErrors: o } = e, n = this.getLocaleTextFunc(), s = this.getValue();
    let i = [];
    return typeof s == "string" && t != null && s.length > t && i.push(
      n("maxLengthValidation", `Must be ${t} characters or fewer.`, [String(t)])
    ), i.length || (i = null), o ? o({
      value: s,
      internalErrors: i,
      cellEditorParams: e
    }) : i;
  }
}, Aje = {
  tag: "ag-input-number-field",
  ref: "eEditor",
  cls: "ag-cell-editor"
}, Lje = class {
  constructor(e) {
    this.getLocaleTextFunc = e;
  }
  getTemplate() {
    return Aje;
  }
  getAgComponents() {
    return [ske];
  }
  init(e, t) {
    this.eEditor = e, this.params = t;
    const { max: o, min: n, precision: s, step: i } = t;
    o != null && e.setMax(o), n != null && e.setMin(n), s != null && e.setPrecision(s), i != null && e.setStep(i);
    const r = e.getInputElement();
    t.preventStepping ? e.addManagedElementListeners(r, { keydown: this.preventStepping }) : t.showStepperButtons && r.classList.add("ag-number-field-input-stepper");
  }
  getValidationErrors() {
    const { params: e } = this, { min: t, max: o, getValidationErrors: n } = e, i = this.eEditor.getInputElement().valueAsNumber, r = this.getLocaleTextFunc();
    let l = [];
    return typeof i == "number" && (t != null && i < t && l.push(
      r("minValueValidation", `Must be greater than or equal to ${t}.`, [String(t)])
    ), o != null && i > o && l.push(
      r("maxValueValidation", `Must be less than or equal to ${o}.`, [String(o)])
    )), l.length || (l = null), n ? n({
      value: i,
      cellEditorParams: e,
      internalErrors: l
    }) : l;
  }
  preventStepping(e) {
    (e.key === D.UP || e.key === D.DOWN) && e.preventDefault();
  }
  getValue() {
    const { eEditor: e, params: t } = this, o = e.getValue();
    if (!ue(o) && !ue(t.value))
      return t.value;
    let n = t.parseValue(o);
    if (n == null)
      return n;
    if (typeof n == "string") {
      if (n === "")
        return null;
      n = Number(n);
    }
    return isNaN(n) ? null : n;
  }
  getStartValue() {
    return this.params.value;
  }
  setCaret() {
    Gn() && this.eEditor.getInputElement().focus({ preventScroll: !0 });
  }
}, Eje = class extends Ma {
  constructor() {
    super(new Lje(() => this.getLocaleTextFunc()));
  }
}, Pje = {
  tag: "div",
  cls: "ag-cell-edit-wrapper",
  children: [
    {
      tag: "ag-select",
      ref: "eEditor",
      cls: "ag-cell-editor"
    }
  ]
}, Rje = class extends ya {
  constructor() {
    super(Pje, [gke]), this.eEditor = J, this.startedByEnter = !1;
  }
  wireBeans(e) {
    this.valueSvc = e.valueSvc;
  }
  initialiseEditor(e) {
    this.focusAfterAttached = e.cellStartedEdit;
    const { eEditor: t, valueSvc: o, gos: n } = this, { values: s, value: i, eventKey: r } = e;
    if (Xe(s)) {
      X(58);
      return;
    }
    this.startedByEnter = r != null ? r === D.ENTER : !1;
    let l = !1;
    s.forEach((u) => {
      const h = { value: u }, p = o.formatValue(e.column, null, u), C = p != null;
      h.text = C ? p : u, t.addOption(h), l = l || i === u;
    }), l ? t.setValue(e.value, !0) : e.values.length && t.setValue(e.values[0], !0);
    const { valueListGap: a, valueListMaxWidth: c, valueListMaxHeight: d } = e;
    a != null && t.setPickerGap(a), d != null && t.setPickerMaxHeight(d), c != null && t.setPickerMaxWidth(c), n.get("editType") !== "fullRow" && this.addManagedListeners(this.eEditor, { selectedItem: () => e.stopEditing() });
  }
  afterGuiAttached() {
    this.focusAfterAttached && this.eEditor.getFocusableElement().focus(), this.startedByEnter && setTimeout(() => {
      this.isAlive() && this.eEditor.showPicker();
    });
  }
  focusIn() {
    this.eEditor.getFocusableElement().focus();
  }
  getValue() {
    return this.eEditor.getValue();
  }
  isPopup() {
    return !1;
  }
  getValidationElement() {
    return this.eEditor.getAriaElement();
  }
  getValidationErrors() {
    const { params: e } = this, { values: t, getValidationErrors: o } = e, n = this.getValue();
    let s = [];
    if (t && !t.includes(n)) {
      const i = this.getLocaleTextFunc();
      s.push(i("invalidSelectionValidation", "Invalid selection."));
    } else
      s = null;
    return o ? o({
      value: n,
      internalErrors: s,
      cellEditorParams: e
    }) : s;
  }
}, Fje = {
  tag: "ag-input-text-field",
  ref: "eEditor",
  cls: "ag-cell-editor"
}, Tje = class {
  constructor(e) {
    this.getLocaleTextFunc = e;
  }
  getTemplate() {
    return Fje;
  }
  getAgComponents() {
    return [zo];
  }
  init(e, t) {
    this.eEditor = e, this.params = t;
    const o = t.maxLength;
    o != null && e.setMaxLength(o);
  }
  getValidationErrors() {
    const { params: e } = this, { maxLength: t, getValidationErrors: o } = e, n = this.getValue(), s = this.getLocaleTextFunc();
    let i = [];
    return t != null && typeof n == "string" && n.length > t && i.push(
      s("maxLengthValidation", `Must be ${t} characters or fewer.`, [String(t)])
    ), i.length || (i = null), o ? o({ value: n, cellEditorParams: e, internalErrors: i }) : i;
  }
  getValue() {
    const { eEditor: e, params: t } = this, o = e.getValue();
    return !ue(o) && !ue(t.value) ? t.value : t.parseValue(o);
  }
  getStartValue() {
    const e = this.params;
    return e.useFormatter || e.column.getColDef().refData ? e.formatValue(e.value) : e.value;
  }
  setCaret() {
    Gn() && this.eEditor.getInputElement().focus({ preventScroll: !0 });
    const e = this.eEditor, t = e.getValue(), o = ue(t) && t.length || 0;
    o && e.getInputElement().setSelectionRange(o, o);
  }
}, Pu = class extends Ma {
  constructor() {
    super(new Tje(() => this.getLocaleTextFunc()));
  }
};
function Ije(e) {
  return e.ctrlsSvc.getScrollFeature().getVScrollPosition();
}
function Dje(e) {
  return e.ctrlsSvc.getScrollFeature().getHScrollPosition();
}
function zy(e, t, o = "auto") {
  e.frameworkOverrides.wrapIncoming(
    () => e.ctrlsSvc.getScrollFeature().ensureColumnVisible(t, o),
    "ensureVisible"
  );
}
function jy(e, t, o) {
  e.frameworkOverrides.wrapIncoming(
    () => e.ctrlsSvc.getScrollFeature().ensureIndexVisible(t, o),
    "ensureVisible"
  );
}
function kje(e, t, o = null) {
  e.frameworkOverrides.wrapIncoming(
    () => e.ctrlsSvc.getScrollFeature().ensureNodeVisible(t, o),
    "ensureVisible"
  );
}
function Hje(e) {
  var t;
  (t = e.undoRedo) == null || t.undo("api");
}
function Vje(e) {
  var t;
  (t = e.undoRedo) == null || t.redo("api");
}
function Oje(e, t) {
  var o;
  return (o = e.editModelSvc) == null ? void 0 : o.getEditRowDataValue(t, { checkSiblings: !0 });
}
function Bje(e) {
  var n;
  const t = (n = e.editModelSvc) == null ? void 0 : n.getEditMap(), o = [];
  return t == null || t.forEach((s, i) => {
    const { rowIndex: r, rowPinned: l } = i;
    s.forEach((a, c) => {
      const { editorValue: d, pendingValue: u, sourceValue: h, state: p } = a, C = An(a);
      let m = d ?? u;
      m === Io && (m = void 0);
      const w = {
        newValue: m,
        oldValue: h,
        state: p,
        column: c,
        colId: c.getColId(),
        colKey: c.getColId(),
        rowIndex: r,
        rowPinned: l
      };
      (p === "editing" || p === "changed" && C) && o.push(w);
    });
  }), o;
}
function $je(e, t = !1) {
  var n;
  const { editSvc: o } = e;
  o != null && o.isBatchEditing() ? (t ? (n = e.editModelSvc) == null || n.getEditPositions().forEach((s) => {
    s.state === "editing" && o.revertSingleCellEdit(s);
  }) : Ps(e, { persist: !0 }), Ti(e, void 0, { cancel: t })) : o == null || o.stopEditing(void 0, { cancel: t, source: "edit", forceStop: !t, forceCancel: t });
}
function Zje(e, t) {
  var n;
  const o = pt(e, t);
  return ((n = e.editSvc) == null ? void 0 : n.isEditing(o)) ?? !1;
}
function Gje(e, t) {
  const { key: o, colKey: n, rowIndex: s, rowPinned: i } = t, { editSvc: r, colModel: l } = e, a = l.getCol(n);
  if (!a) {
    X(12, { colKey: n });
    return;
  }
  const d = vn(e, {
    rowIndex: s,
    rowPinned: i || null
  });
  if (!d) {
    X(290, { rowIndex: s, rowPinned: i });
    return;
  }
  if (!a.isCellEditable(d))
    return;
  i == null && jy(e, s), zy(e, n), r == null || r.startEditing(
    {
      rowNode: d,
      column: a
    },
    {
      event: o ? new KeyboardEvent("keydown", { key: o }) : void 0,
      source: "api"
    }
  );
}
function Nje(e) {
  var t;
  return ((t = e.editSvc) == null ? void 0 : t.validateEdit()) || null;
}
function zje(e) {
  var t;
  return ((t = e.undoRedo) == null ? void 0 : t.getCurrentUndoStackSize()) ?? 0;
}
function jje(e) {
  var t;
  return ((t = e.undoRedo) == null ? void 0 : t.getCurrentRedoStackSize()) ?? 0;
}
var Wje = { tag: "div", cls: "ag-popup-editor", attrs: { tabindex: "-1" } }, Uje = class extends ga {
  constructor(e) {
    super(Wje), this.params = e;
  }
  postConstruct() {
    Ys(this.gos, this.getGui(), "popupEditorWrapper", !0), this.addKeyDownListener();
  }
  addKeyDownListener() {
    const e = this.getGui(), t = this.params, o = (n) => {
      c5(this.gos, n, t.node, t.column, !0) || t.onKeyDown(n);
    };
    this.addManagedElementListeners(e, { keydown: o });
  }
};
function Kje(e, { column: t }, o, n, s = "ui") {
  var c;
  if (o instanceof KeyboardEvent && (o.key === D.TAB || o.key === D.ENTER || o.key === D.F2 || o.key === D.BACKSPACE && n))
    return !0;
  if ((o == null ? void 0 : o.shiftKey) && ((c = e.rangeSvc) == null ? void 0 : c.getCellRanges().length) != 0)
    return !1;
  const r = t == null ? void 0 : t.getColDef(), l = qje(e.gos, r), a = o == null ? void 0 : o.type;
  return a === "click" && (o == null ? void 0 : o.detail) === 1 && l === 1 || a === "dblclick" && (o == null ? void 0 : o.detail) === 2 && l === 2 ? !0 : s === "api" ? n ?? !1 : !1;
}
function qje(e, t) {
  return e.get("suppressClickEdit") === !0 ? 0 : e.get("singleClickEdit") === !0 || t != null && t.singleClickEdit ? 1 : 2;
}
function M5(e, { rowNode: t, column: o }, n = "ui") {
  const s = o.getColDef().editable, i = e.editModelSvc;
  return o.isColumnFunc(t, s) || !!i && i.hasEdits({ rowNode: t, column: o }, { withOpenEditor: !0 });
}
function Yje(e, t, o = "ui") {
  const n = M5(e, t, o);
  return n === !0 || o === "ui" ? n : e.colModel.getCols().some((i) => M5(e, { rowNode: t.rowNode, column: i }, o));
}
var Bl = (e, t = !1) => {
  if (e !== void 0)
    return An(e) || t && e.state === "editing";
};
function Wy(e, t, o = !1) {
  var n;
  return Bl((n = e.editModelSvc) == null ? void 0 : n.getEdit(t), o);
}
function Uy(e, t) {
  const { editModelSvc: o } = e, { column: n, rowNode: s } = t;
  if (e.gos.get("groupTotalRow") && !(s != null && s.footer))
    return !1;
  for (const i of (s == null ? void 0 : s.allLeafChildren) ?? [])
    if (Bl(o == null ? void 0 : o.getEdit({ rowNode: i, column: n })) || Bl(o == null ? void 0 : o.getEdit({ rowNode: i.pinnedSibling, column: n })))
      return !0;
}
function Ky(e, { rowNode: t, column: o }) {
  var n;
  if (t = t.pinnedSibling, !!t)
    return Bl(
      (n = e.editModelSvc) == null ? void 0 : n.getEdit({
        rowNode: t,
        column: o
      })
    );
}
var Qje = class extends K {
  constructor(e, t) {
    super(), this.cellCtrl = e, this.beans = t, this.editSvc = t.editSvc, this.editModelSvc = t.editModelSvc;
  }
  setComp(e) {
    this.cellComp = e, this.applyCellStyles();
  }
  applyCellStyles() {
    var s;
    const { cellCtrl: e, editSvc: t, beans: o } = this;
    if (t != null && t.isBatchEditing() && t.isEditing()) {
      const i = Wy(o, e) || Uy(o, e) || Ky(o, e);
      this.applyBatchingStyle(i);
    } else
      this.applyBatchingStyle(!1);
    const n = !!((s = this.editModelSvc) != null && s.getCellValidationModel().hasCellValidation(this.cellCtrl));
    this.cellComp.toggleCss("ag-cell-editing-error", n);
  }
  applyBatchingStyle(e) {
    var t;
    this.cellComp.toggleCss("ag-cell-editing", e ?? !1), this.cellComp.toggleCss("ag-cell-batch-edit", (e && ((t = this.editSvc) == null ? void 0 : t.isBatchEditing())) ?? !1);
  }
}, Jje = class extends K {
  constructor(e, t) {
    super(), this.rowCtrl = e, this.beans = t, this.gos = t.gos, this.editSvc = t.editSvc, this.editModelSvc = t.editModelSvc;
  }
  applyRowStyles() {
    var r;
    const { rowCtrl: e, editModelSvc: t, beans: o } = this;
    let n = e.rowNode, s = t == null ? void 0 : t.getEditRow(n);
    const i = (r = this.editModelSvc) == null ? void 0 : r.getRowValidationModel().hasRowValidation({ rowNode: n });
    if (!s && n.pinnedSibling && (n = n.pinnedSibling, s = t == null ? void 0 : t.getEditRow(n)), s) {
      const l = Array.from(s.keys()).some((a) => {
        const c = { rowNode: n, column: a };
        return Wy(o, c, !0) || Uy(o, c) || Ky(o, c);
      });
      this.applyStyle(i, l);
      return;
    }
    this.applyStyle(i);
  }
  applyStyle(e = !1, t = !1) {
    var s, i;
    const o = ((s = this.editSvc) == null ? void 0 : s.isBatchEditing()) ?? !1, n = this.gos.get("editType") === "fullRow";
    (i = this.rowCtrl) == null || i.forEachGui(void 0, ({ rowComp: r }) => {
      r.toggleCss("ag-row-editing", n && t), r.toggleCss("ag-row-batch-edit", n && t && o), r.toggleCss("ag-row-inline-editing", t), r.toggleCss("ag-row-not-inline-editing", !t), r.toggleCss("ag-row-editing-invalid", n && t && e);
    });
  }
}, Xje = ({ rowModel: e, pinnedRowModel: t, editModelSvc: o }, n) => {
  const s = /* @__PURE__ */ new Set();
  return e.forEachNode((i) => n.has(i) && s.add(i)), t == null || t.forEachPinnedRow("top", (i) => n.has(i) && s.add(i)), t == null || t.forEachPinnedRow("bottom", (i) => n.has(i) && s.add(i)), n.forEach((i) => {
    s.has(i) || o.removeEdits({ rowNode: i });
  }), s;
}, eWe = ({ editModelSvc: e }, t, o) => {
  t.forEach(
    (n) => {
      var s;
      return (s = e == null ? void 0 : e.getEditRow(n)) == null ? void 0 : s.forEach((i, r) => !o.has(r) && e.removeEdits({ rowNode: n, column: r }));
    }
  );
}, tWe = (e) => () => {
  const t = new Set(e.colModel.getCols()), o = e.editModelSvc.getEditMap(!0), n = new Set(o.keys());
  eWe(e, Xje(e, n), t);
}, oWe = /* @__PURE__ */ new Set(["undo", "redo", "paste", "bulk", "rangeSvc"]), nWe = /* @__PURE__ */ new Set(["ui", "api"]), qy = {
  paste: "api",
  rangeSvc: "api",
  fillHandle: "api",
  cellClear: "api",
  bulk: "api"
}, sWe = new Set(Object.keys(qy)), iWe = /* @__PURE__ */ new Set([
  "paste",
  "rangeSvc",
  "renderer",
  "cellClear",
  "redo",
  "undo"
]), D1 = { cancel: !0, source: "api" }, rWe = { cancel: !1, source: "api" }, pi = { checkSiblings: !0 }, hr = { force: !0, suppressFlash: !0 }, lWe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "editSvc", this.batch = !1, this.stopping = !1, this.committing = !1;
  }
  postConstruct() {
    const { beans: e } = this;
    this.model = e.editModelSvc, this.valueSvc = e.valueSvc, this.rangeSvc = e.rangeSvc, this.addManagedPropertyListener("editType", ({ currentValue: n }) => {
      this.stopEditing(void 0, D1), this.createStrategy(n);
    });
    const t = tWe(e), o = () => {
      const n = this.model.getCellValidationModel().getCellValidationMap().size > 0, s = this.model.getRowValidationModel().getRowValidationMap().size > 0;
      return n || s ? this.stopEditing(void 0, D1) : this.isEditing() && (this.isBatchEditing() ? Ti(e, this.model.getEditPositions()) : this.stopEditing(void 0, rWe)), !1;
    };
    this.addManagedEventListeners({
      columnPinned: t,
      columnVisible: t,
      columnRowGroupChanged: t,
      rowExpansionStateChanged: t,
      pinnedRowsChanged: t,
      displayedRowsChanged: t,
      sortChanged: o,
      filterChanged: o,
      cellFocused: this.onCellFocused.bind(this)
    });
  }
  isBatchEditing() {
    return this.batch;
  }
  setBatchEditing(e) {
    e ? (this.batch = !0, this.stopEditing(void 0, D1)) : (this.stopEditing(void 0, D1), this.batch = !1);
  }
  createStrategy(e) {
    const { beans: t, gos: o, strategy: n } = this, s = Ru(o, e);
    if (n) {
      if (n.beanName === s)
        return n;
      this.destroyStrategy();
    }
    return this.strategy = this.createOptionalManagedBean(
      t.registry.createDynamicBean(s, !0)
    );
  }
  destroyStrategy() {
    this.strategy && (this.strategy.destroy(), this.strategy = this.destroyBean(this.strategy));
  }
  shouldStartEditing(e, t, o, n = "ui") {
    const s = Kje(this.beans, e, t, o, n);
    return s && (this.strategy ?? (this.strategy = this.createStrategy())), s;
  }
  shouldStopEditing(e, t, o = "ui") {
    var n;
    return ((n = this.strategy) == null ? void 0 : n.shouldStop(e, t, o)) ?? null;
  }
  shouldCancelEditing(e, t, o = "ui") {
    var n;
    return ((n = this.strategy) == null ? void 0 : n.shouldCancel(e, t, o)) ?? null;
  }
  validateEdit() {
    return xGe(this.beans);
  }
  isEditing(e, t) {
    return this.model.hasEdits(e, t ?? pi);
  }
  isRowEditing(e, t) {
    return (e && this.model.hasRowEdits(e, t)) ?? !1;
  }
  /** @returns whether to prevent default on event */
  startEditing(e, t) {
    const { startedEdit: o = !0, event: n = null, source: s = "ui", ignoreEventKey: i = !1, silent: r } = t;
    if (this.strategy ?? (this.strategy = this.createStrategy()), !this.isCellEditable(e, "api"))
      return;
    const l = pt(this.beans, e);
    if (l && !l.comp) {
      l.onCompAttachedFuncs.push(() => this.startEditing(e, t));
      return;
    }
    const a = this.shouldStartEditing(e, n, o, s);
    if (a === !1 && s !== "api") {
      this.isEditing(e) && this.stopEditing();
      return;
    }
    !this.batch && this.shouldStopEditing(e, void 0, s) && !t.continueEditing && this.stopEditing(void 0, { source: s }), a && this.isBatchEditing() && this.dispatchBatchEvent("batchEditingStarted", /* @__PURE__ */ new Map()), this.strategy.start({
      position: e,
      event: n,
      source: s,
      ignoreEventKey: i,
      startedEdit: o,
      silent: r
    });
  }
  stopEditing(e, t) {
    var y, b, _;
    const { event: o, cancel: n, source: s = "ui", suppressNavigateAfterEdit: i, forceCancel: r, forceStop: l } = t || {}, { beans: a, model: c } = this;
    if (sWe.has(s) && this.isBatchEditing())
      return this.bulkRefresh(e), !1;
    const d = this.committing ? qy[s] : s;
    if (!(this.committing || this.isEditing(e) || this.isBatchEditing() && c.hasEdits(e, pi)) || !this.strategy || this.stopping)
      return !1;
    this.stopping = !0;
    const h = pt(a, e);
    h && (h.onEditorAttachedFuncs = []);
    let p = c.getEditMap(!0), C = !1;
    const m = !n && (!!this.shouldStopEditing(e, o, d) || this.committing && !this.batch) || (l ?? !1), w = n && !!this.shouldCancelEditing(e, o, d) || (r ?? !1);
    if (m || w) {
      Ps(a, { persist: !0, isCancelling: w || n, isStopping: m });
      const M = c.getEditMap(), x = this.processEdits(M, n, s);
      (y = this.strategy) == null || y.stop(n, o), x.forEach((L) => {
        c.clearEditValue(L);
      }), this.bulkRefresh(void 0, p), c.getEditPositions(M).forEach((L) => {
        const A = pt(a, L), R = An(L);
        A == null || A.refreshCell({ force: !0, suppressFlash: !R });
      }), p = M, C || (C = m);
    } else if (o instanceof KeyboardEvent && this.batch && ((b = this.strategy) != null && b.midBatchInputsAllowed(e)) && this.isEditing(e, { withOpenEditor: !0 })) {
      const M = o.key, x = M === D.ENTER, L = M === D.ESCAPE, A = M === D.TAB;
      (x || A || L) && (x || A ? Ps(a, { persist: !0 }) : L && this.revertSingleCellEdit(h), this.isBatchEditing() ? (_ = this.strategy) == null || _.cleanupEditors() : Ti(a, c.getEditPositions(), { event: o, cancel: L }), o.preventDefault(), this.bulkRefresh(e, p, { suppressFlash: !0 }), p = c.getEditMap());
    } else
      Ps(a, { persist: !0 }), p = c.getEditMap();
    return C && e && this.model.removeEdits(e), !i && h && this.navigateAfterEdit(o instanceof KeyboardEvent && o.shiftKey, h.cellPosition), w5(a), this.model.hasEdits() || (this.model.getCellValidationModel().clearCellValidationMap(), this.model.getRowValidationModel().clearRowValidationMap()), this.bulkRefresh(), w && this.beans.rowRenderer.refreshRows({ rowNodes: Array.from(p.keys()) }), this.isBatchEditing() && (this.beans.rowRenderer.refreshRows({ suppressFlash: !0, force: !0 }), C && m && this.dispatchBatchEvent("batchEditingStopped", p)), this.stopping = !1, C;
  }
  navigateAfterEdit(e, t) {
    var n;
    if (this.gos.get("enterNavigatesVerticallyAfterEdit")) {
      const s = e ? D.UP : D.DOWN;
      (n = this.beans.navigation) == null || n.navigateToNextCell(null, s, t, !1);
    }
  }
  processEdits(e, t = !1, o) {
    const n = Array.from(e.keys()), s = this.model.getCellValidationModel().getCellValidationMap().size > 0 || this.model.getRowValidationModel().getRowValidationMap().size > 0, i = [];
    for (const r of n) {
      const l = e.get(r);
      for (const a of l.keys()) {
        const c = l.get(a), d = { rowNode: r, column: a }, u = An(c);
        !t && u && !s && (this.setNodeDataValue(r, a, c.pendingValue, void 0, o) || i.push(d));
      }
    }
    return i;
  }
  setNodeDataValue(e, t, o, n, s = "edit") {
    const { beans: i } = this, r = pt(i, { rowNode: e, column: t }), l = nWe.has(s) ? "edit" : s;
    r && (r.suppressRefreshCell = !0), this.commitNextEdit();
    const a = e.setDataValue(t, o, l);
    return r && (r.suppressRefreshCell = !1), n && (r == null || r.refreshCell(hr)), a;
  }
  setEditMap(e, t) {
    var n;
    this.strategy ?? (this.strategy = this.createStrategy()), (n = this.strategy) == null || n.setEditMap(e, t), this.bulkRefresh();
    let o = hr;
    t != null && t.forceRefreshOfEditCellsOnly && (o = {
      ...aWe(e),
      ...hr
    }), this.beans.rowRenderer.refreshCells(o);
  }
  dispatchEditValuesChanged({ rowNode: e, column: t }, o = {}) {
    if (!e || !t || !o)
      return;
    const { pendingValue: n, sourceValue: s } = o, { rowIndex: i, rowPinned: r, data: l } = e;
    this.beans.eventSvc.dispatchEvent({
      type: "cellEditValuesChanged",
      node: e,
      rowIndex: i,
      rowPinned: r,
      column: t,
      source: "api",
      data: l,
      newValue: n,
      oldValue: s,
      value: n,
      colDef: t.getColDef()
    });
  }
  bulkRefresh(e = {}, t, o = {}) {
    var l;
    const { beans: n, gos: s } = this, { editModelSvc: i, rowModel: r } = n;
    dt(s) && (e.rowNode && e.column ? this.refCell(e, this.model.getEdit(e), o) : t && ((l = i == null ? void 0 : i.getEditMap(!1)) == null || l.forEach((a, c) => {
      for (const d of a.keys())
        this.refCell({ rowNode: c, column: d }, a.get(d), o);
    })));
  }
  refCell({ rowNode: e, column: t }, o, n = {}) {
    var u;
    const { beans: s, gos: i } = this, r = /* @__PURE__ */ new Set([e]), l = /* @__PURE__ */ new Set(), a = e.pinnedSibling;
    a && r.add(a);
    const c = e.sibling;
    c && l.add(c);
    let d = e.parent;
    for (; d; )
      (u = d.sibling) != null && u.footer && i.get("groupTotalRow") || !d.parent && d.sibling && i.get("grandTotalRow") ? l.add(d.sibling) : l.add(d), d = d.parent;
    r.forEach((h) => this.dispatchEditValuesChanged({ rowNode: h, column: t }, o)), r.forEach((h) => {
      var p;
      return (p = pt(s, { rowNode: h, column: t })) == null ? void 0 : p.refreshCell(n);
    }), l.forEach((h) => {
      var p;
      return (p = pt(s, { rowNode: h, column: t })) == null ? void 0 : p.refreshCell(n);
    });
  }
  stopAllEditing(e = !1, t = "ui") {
    this.isEditing() && this.stopEditing(void 0, { cancel: e, source: t });
  }
  isCellEditable(e, t = "ui") {
    const { rowNode: o } = e, { gos: n, beans: s } = this;
    if (o.group) {
      if (n.get("treeData")) {
        if (!o.data && !n.get("enableGroupEdit"))
          return !1;
      } else if (!n.get("enableGroupEdit"))
        return !1;
    }
    const i = Ru(n) === "fullRow" ? Yje(s, e, t) : M5(s, e, t);
    return i && (this.strategy ?? (this.strategy = this.createStrategy())), i;
  }
  cellEditingInvalidCommitBlocks() {
    return this.gos.get("invalidEditValueMode") === "block";
  }
  checkNavWithValidation(e, t, o = !0) {
    var n, s, i, r;
    if (this.hasValidationErrors(e)) {
      const l = pt(this.beans, e);
      return this.cellEditingInvalidCommitBlocks() ? ((n = t == null ? void 0 : t.preventDefault) == null || n.call(t), o && (!(l != null && l.hasBrowserFocus()) && (l == null || l.focusCell()), (r = (i = (s = l == null ? void 0 : l.comp) == null ? void 0 : s.getCellEditor()) == null ? void 0 : i.focusIn) == null || r.call(i)), "block-stop") : (l && this.revertSingleCellEdit(l), "revert-continue");
    }
    return "continue";
  }
  revertSingleCellEdit(e, t = !1) {
    var n, s, i, r, l;
    const o = pt(this.beans, e);
    (n = o == null ? void 0 : o.comp) != null && n.getCellEditor() && (Ti(this.beans, [e], { silent: !0 }), this.model.clearEditValue(e), Ki(this.beans, e, { silent: !0 }), Xs(this.beans), o == null || o.refreshCell(hr), (s = o.rowCtrl.rowEditStyleFeature) == null || s.applyRowStyles(), t && (o == null || o.focusCell(), (l = (r = (i = o == null ? void 0 : o.comp) == null ? void 0 : i.getCellEditor()) == null ? void 0 : r.focusIn) == null || l.call(r)));
  }
  hasValidationErrors(e) {
    var n;
    Xs(this.beans);
    const t = pt(this.beans, e);
    t && (t.refreshCell(hr), (n = t.rowCtrl.rowEditStyleFeature) == null || n.applyRowStyles());
    let o = !1;
    return e != null && e.rowNode ? (o || (o = this.model.getRowValidationModel().hasRowValidation({ rowNode: e.rowNode })), e.column && (o || (o = this.model.getCellValidationModel().hasCellValidation({ rowNode: e.rowNode, column: e.column })))) : (o || (o = this.model.getCellValidationModel().getCellValidationMap().size > 0), o || (o = this.model.getRowValidationModel().getRowValidationMap().size > 0)), o;
  }
  moveToNextCell(e, t, o, n = "ui") {
    var l;
    let s;
    const i = this.isEditing(), r = i && this.checkNavWithValidation(void 0, o) === "block-stop";
    return e instanceof Ii && i && (s = (l = this.strategy) == null ? void 0 : l.moveToNextEditingCell(e, t, o, n, r)), s === null || (s = s || !!this.beans.focusSvc.focusedHeader, s === !1 && !r && this.stopEditing()), s;
  }
  getCellDataValue({ rowNode: e, column: t }, o = !0) {
    if (!e || !t)
      return;
    let n = this.model.getEdit({ rowNode: e, column: t });
    const s = e.pinnedSibling;
    if (s) {
      const r = this.model.getEdit({ rowNode: s, column: t });
      r && (n = r);
    }
    const i = o ? (n == null ? void 0 : n.editorValue) ?? (n == null ? void 0 : n.pendingValue) : n == null ? void 0 : n.pendingValue;
    return i === Io || !n ? (n == null ? void 0 : n.sourceValue) ?? this.valueSvc.getValue(t, e, !1, "api") : i;
  }
  addStopEditingWhenGridLosesFocus(e) {
    CGe(this, this.beans, e);
  }
  createPopupEditorWrapper(e) {
    return new Uje(e);
  }
  commitNextEdit() {
    this.committing = !0;
  }
  setDataValue(e, t, o) {
    var n;
    try {
      if ((!this.isEditing() || this.committing) && !iWe.has(o))
        return;
      const { beans: s } = this;
      this.strategy ?? (this.strategy = this.createStrategy());
      const i = this.isBatchEditing() ? "ui" : this.committing ? o ?? "api" : "api";
      if (!o || oWe.has(o))
        return X1(s, e, t, o, void 0, { persist: !0 }), this.setNodeDataValue(e.rowNode, e.column, t, !0, o);
      const r = this.model.getEdit(e);
      if (r) {
        if (r.pendingValue === t)
          return !1;
        if (r.sourceValue !== t)
          return X1(s, e, t, o, void 0, { persist: !0 }), this.stopEditing(e, { source: i, suppressNavigateAfterEdit: !0 }), !0;
        if (r.sourceValue === t)
          return (n = s.editModelSvc) == null || n.removeEdits(e), this.dispatchEditValuesChanged(e, {
            ...r,
            pendingValue: t
          }), !0;
      }
      return X1(s, e, t, o, void 0, { persist: !0 }), this.stopEditing(e, { source: i, suppressNavigateAfterEdit: !0 }), !0;
    } finally {
      this.committing = !1;
    }
  }
  handleColDefChanged(e) {
    yGe(this.beans, e);
  }
  destroy() {
    this.model.clear(), this.destroyStrategy(), super.destroy();
  }
  prepDetailsDuringBatch(e, t) {
    if (!this.batch || !this.model.hasRowEdits(e.rowNode, pi))
      return;
    const { rowNode: n, column: s } = e, { compDetails: i, valueToDisplay: r } = t;
    if (i) {
      const { params: a } = i;
      return a.data = this.model.getEditRowDataValue(n, pi), { compDetails: i };
    }
    const l = this.model.getEditRow(e.rowNode, pi);
    if (r !== void 0 && (l != null && l.has(s)))
      return { valueToDisplay: this.valueSvc.getValue(s, n) };
  }
  cleanupEditors() {
    var e;
    (e = this.strategy) == null || e.cleanupEditors();
  }
  dispatchCellEvent(e, t, o, n) {
    var s;
    (s = this.strategy) == null || s.dispatchCellEvent(e, t, o, n);
  }
  dispatchBatchEvent(e, t) {
    this.eventSvc.dispatchEvent(this.createBatchEditEvent(e, t));
  }
  createBatchEditEvent(e, t) {
    return Pe(this.gos, {
      type: e,
      ...e === "batchEditingStopped" ? {
        changes: this.toEventChangeList(t)
      } : {}
    });
  }
  toEventChangeList(e) {
    return this.model.getEditPositions(e).map((t) => ({
      rowIndex: t.rowNode.rowIndex,
      rowPinned: t.rowNode.rowPinned,
      columnId: t.column.getColId(),
      newValue: t.pendingValue,
      oldValue: t.sourceValue
    }));
  }
  applyBulkEdit({ rowNode: e, column: t }, o) {
    var c, d;
    if (!o || o.length === 0)
      return;
    const { beans: n, rangeSvc: s, valueSvc: i } = this;
    Ps(n, { persist: !0 });
    const r = this.model.getEditMap(!0), l = (d = (c = r.get(e)) == null ? void 0 : c.get(t)) == null ? void 0 : d.pendingValue;
    this.batch || this.eventSvc.dispatchEvent({ type: "bulkEditingStarted" }), o.forEach((u) => {
      if (s == null || s.forEachRowInRange(u, (h) => {
        const p = vn(n, h);
        if (p === void 0)
          return;
        const C = r.get(p) ?? /* @__PURE__ */ new Map();
        for (const m of u.columns)
          if (m && this.isCellEditable({ rowNode: p, column: m }, "api")) {
            const w = i.getValue(m, p, !0, "api");
            let y = i.parseValue(
              m,
              p ?? null,
              l,
              w
            );
            Number.isNaN(y) && (y = null), C.set(m, {
              editorValue: void 0,
              pendingValue: y,
              sourceValue: w,
              state: "changed",
              editorState: {
                isCancelAfterEnd: void 0,
                isCancelBeforeStart: void 0
              }
            });
          }
        C.size > 0 && r.set(p, C);
      }), this.setEditMap(r), this.batch) {
        this.cleanupEditors(), w5(n), this.bulkRefresh();
        return;
      }
      this.commitNextEdit(), this.stopEditing(void 0, { source: "bulk" }), this.eventSvc.dispatchEvent({ type: "bulkEditingStopped", changes: this.toEventChangeList(r) });
    }), this.bulkRefresh();
    const a = pt(n, { rowNode: e, column: t });
    a && a.focusCell(!0);
  }
  createCellStyleFeature(e, t) {
    return new Qje(e, t);
  }
  createRowStyleFeature(e, t) {
    return new Jje(e, t);
  }
  setEditingCells(e, t) {
    const { beans: o } = this, { colModel: n, valueSvc: s } = o, i = /* @__PURE__ */ new Map();
    e.forEach(({ colId: r, column: l, colKey: a, rowIndex: c, rowPinned: d, newValue: u, state: h }) => {
      const p = r ? n.getCol(r) : a ? n.getCol(a) : l;
      if (!p)
        return;
      const C = vn(o, { rowIndex: c, rowPinned: d });
      if (!C)
        return;
      const m = s.getValue(p, C, !0, "api");
      if (!(t != null && t.forceRefreshOfEditCellsOnly) && !An({ pendingValue: u, sourceValue: m }) && h !== "editing")
        return;
      let w = i.get(C);
      w || (w = /* @__PURE__ */ new Map(), i.set(C, w)), u === void 0 && (u = Io), w.set(p, {
        editorValue: void 0,
        pendingValue: u,
        sourceValue: m,
        state: h ?? "changed",
        editorState: {
          isCancelAfterEnd: void 0,
          isCancelBeforeStart: void 0
        }
      });
    }), this.setEditMap(i, t);
  }
  onCellFocused(e) {
    var i;
    const t = pt(this.beans, e);
    if (!t || !this.isEditing(t, pi))
      return;
    const o = this.model.getEdit(t);
    if (!o || !An(o))
      return;
    const s = this.getLocaleTextFunc()("ariaPendingChange", "Pending Change");
    (i = this.beans.ariaAnnounce) == null || i.announceValue(s, "pendingChange");
  }
  allowedFocusTargetOnValidation(e) {
    return pt(this.beans, e);
  }
};
function aWe(e) {
  return {
    rowNodes: e ? Array.from(e.keys()) : void 0,
    columns: e ? [...new Set(Array.from(e.values()).flatMap((t) => Array.from(t.keys())))] : void 0
  };
}
function Ru(e, t) {
  return t ?? e.get("editType") ?? "singleCell";
}
var Yy = class extends K {
  postConstruct() {
    var e, t;
    this.model = this.beans.editModelSvc, this.editSvc = this.beans.editSvc, this.addManagedEventListeners({
      cellFocused: (e = this.onCellFocusChanged) == null ? void 0 : e.bind(this),
      cellFocusCleared: (t = this.onCellFocusChanged) == null ? void 0 : t.bind(this)
    });
  }
  clearEdits(e) {
    this.model.clearEditValue(e);
  }
  onCellFocusChanged(e) {
    let t;
    const o = e.previousParams, { editSvc: n, beans: s } = this, i = e.type === "cellFocused" ? e.sourceEvent : null;
    o && (t = pt(s, o));
    const { gos: r, editModelSvc: l } = s, a = e.type === "cellFocusCleared";
    if (n.isEditing(void 0, { withOpenEditor: !0 })) {
      const { column: c, rowIndex: d, rowPinned: u } = e, h = {
        column: c,
        rowNode: vn(s, { rowIndex: d, rowPinned: u })
      }, p = r.get("invalidEditValueMode") === "block";
      if (p)
        return;
      const C = !p, m = !!(l != null && l.getCellValidationModel().hasCellValidation(h)), w = C && m;
      (o || a ? n.stopEditing(void 0, {
        cancel: w,
        source: a && C ? "api" : void 0,
        event: i
      }) : !0) || (n.isBatchEditing() ? n.cleanupEditors() : n.stopEditing(void 0, { source: "api" }));
    }
    t == null || t.refreshCell({ suppressFlash: !0, force: !0 });
  }
  stop(e, t) {
    const o = this.model.getEditPositions(), n = { all: [], pass: [], fail: [] };
    if (o.forEach((i) => {
      var l;
      n.all.push(i);
      const r = this.model.getCellValidationModel().getCellValidation(i);
      if ((((l = r == null ? void 0 : r.errorMessages) == null ? void 0 : l.length) ?? 0) > 0) {
        n.fail.push(i);
        return;
      }
      n.pass.push(i);
    }), e)
      return o.forEach((i) => {
        Hl(this.beans, i, { cancel: e }), this.model.stop(i);
      }), !0;
    const s = this.processValidationResults(n);
    return s.destroy.length > 0 && s.destroy.forEach((i) => {
      Hl(this.beans, i, { event: t, cancel: e }), this.model.stop(i);
    }), s.keep.length > 0 && s.keep.forEach((i) => {
      var l;
      const r = pt(this.beans, i);
      (l = this.editSvc) != null && l.cellEditingInvalidCommitBlocks() || r && this.editSvc.revertSingleCellEdit(r);
    }), !0;
  }
  cleanupEditors({ rowNode: e } = {}, t) {
    Ps(this.beans, { persist: !1 });
    const o = this.model.getEditPositions(), n = [];
    e ? o.forEach((s) => {
      !e || s.rowNode === e || n.push(s);
    }) : o.forEach((s) => {
      n.push(s);
    }), Ti(this.beans, n), w5(this.beans, t);
  }
  setFocusOutOnEditor(e) {
    var t, o, n;
    (n = (o = (t = e.comp) == null ? void 0 : t.getCellEditor()) == null ? void 0 : o.focusOut) == null || n.call(o);
  }
  setFocusInOnEditor(e) {
    const t = e.comp, o = t == null ? void 0 : t.getCellEditor();
    if (o != null && o.focusIn)
      o.focusIn();
    else {
      const n = this.beans.gos.get("editType") === "fullRow";
      e.focusCell(n), e.onEditorAttachedFuncs.push(() => {
        var s, i;
        return (i = (s = t == null ? void 0 : t.getCellEditor()) == null ? void 0 : s.focusIn) == null ? void 0 : i.call(s);
      });
    }
  }
  setupEditors(e) {
    const { event: t, ignoreEventKey: o = !1, startedEdit: n, position: s, cells: i = this.model.getEditPositions() } = e, r = t instanceof KeyboardEvent && !o && t.key || void 0;
    bGe(this.beans, i, s, r, t, n);
  }
  dispatchCellEvent(e, t, o, n) {
    const s = pt(this.beans, e);
    s && this.eventSvc.dispatchEvent({ ...s.createEvent(t ?? null, o), ...n });
  }
  dispatchRowEvent(e, t, o) {
    if (o)
      return;
    const n = sc(this.beans, e);
    n && this.eventSvc.dispatchEvent(n.createRowEvent(t));
  }
  shouldStop(e, t, o = "ui") {
    const n = this.editSvc.isBatchEditing();
    return n && o === "api" ? !0 : n && (o === "ui" || o === "edit") ? !1 : o === "api" ? !0 : t instanceof KeyboardEvent && !n ? t.key === D.ENTER : null;
  }
  shouldCancel(e, t, o = "ui") {
    const n = this.editSvc.isBatchEditing();
    return !!(t instanceof KeyboardEvent && !n && t.key === D.ESCAPE || n && o === "api" || o === "api");
  }
  setEditMap(e, t) {
    var n;
    t != null && t.update || this.editSvc.stopEditing(void 0, { cancel: !0, source: "api" });
    const o = [];
    if (e.forEach((s, i) => {
      s.forEach((r, l) => {
        r.state === "editing" && o.push({ ...r, rowNode: i, column: l });
      });
    }), t != null && t.update && (e = new Map([...this.model.getEditMap(), ...e])), (n = this.model) == null || n.setEditMap(e), o.length > 0) {
      const s = o.at(-1), i = s.pendingValue === Io ? void 0 : s.pendingValue;
      this.start({ position: s, event: new KeyboardEvent("keydown", { key: i }), source: "api" });
      const r = pt(this.beans, s);
      r && this.setFocusInOnEditor(r);
    }
  }
  destroy() {
    this.cleanupEditors(), super.destroy();
  }
}, cWe = class extends Yy {
  constructor() {
    super(...arguments), this.beanName = "fullRow", this.startedRows = [];
  }
  shouldStop(e, t, o = "ui") {
    const { rowNode: n } = e || {};
    if (!sc(this.beans, {
      rowNode: this.rowNode
    }))
      return !0;
    const i = super.shouldStop({ rowNode: this.rowNode }, t, o);
    return i !== null ? i : this.rowNode ? n !== this.rowNode : !1;
  }
  midBatchInputsAllowed({ rowNode: e }) {
    return e ? this.model.hasEdits({ rowNode: e }) : !1;
  }
  clearEdits(e) {
    this.model.clearEditValue(e);
  }
  start(e) {
    const { position: t, silent: o, startedEdit: n, event: s, ignoreEventKey: i } = e, { rowNode: r } = t;
    this.rowNode !== r && super.cleanupEditors(t), this.dispatchRowEvent({ rowNode: r }, "rowEditingStarted", o), this.startedRows.push(r);
    const l = this.beans.visibleCols.allCols, a = [];
    l.forEach((c) => {
      if (!c.isCellEditable(r))
        return;
      const d = {
        rowNode: r,
        column: c
      };
      a.push(d), this.model.hasEdits(d) || this.model.start(d);
    }), this.rowNode = r, this.setupEditors({ cells: a, position: t, startedEdit: n, event: s, ignoreEventKey: i });
  }
  processValidationResults(e) {
    return e.fail.length > 0 && this.editSvc.cellEditingInvalidCommitBlocks() ? {
      destroy: [],
      keep: e.all
    } : {
      destroy: e.all,
      keep: []
    };
  }
  stop(e, t) {
    var s;
    const { rowNode: o } = this;
    if (o && !this.model.hasRowEdits(o))
      return !1;
    const n = [];
    return e || this.model.getEditMap().forEach((i, r) => {
      if (!(!i || i.size === 0)) {
        for (const l of i.values())
          if (An(l)) {
            n.push(r);
            break;
          }
      }
    }), Xs(this.beans), !e && ((s = this.editSvc) == null ? void 0 : s.checkNavWithValidation({ rowNode: o })) === "block-stop" ? !1 : (super.stop(e, t), n.forEach((i) => this.dispatchRowEvent({ rowNode: i }, "rowValueChanged")), this.cleanupEditors({ rowNode: o }, !0), this.rowNode = void 0, !0);
  }
  onCellFocusChanged(e) {
    const { rowIndex: t } = e, o = e.previousParams;
    if ((o == null ? void 0 : o.rowIndex) === t || e.sourceEvent instanceof KeyboardEvent)
      return;
    const n = pt(this.beans, o);
    this.gos.get("invalidEditValueMode") === "block" && n && (this.model.getCellValidationModel().getCellValidation(n) || this.model.getRowValidationModel().getRowValidation(n)) || super.onCellFocusChanged(e);
  }
  cleanupEditors(e = {}, t) {
    super.cleanupEditors(e, t), this.startedRows.forEach((o) => this.dispatchRowEvent({ rowNode: o }, "rowEditingStopped")), this.startedRows.length = 0;
  }
  // returns null if no navigation should be performed
  moveToNextEditingCell(e, t, o, n = "ui", s = !1) {
    var h, p, C, m;
    const i = e.cellPosition;
    let r;
    this.model.suspend(!0);
    try {
      r = (h = this.beans.navigation) == null ? void 0 : h.findNextCellToFocusOn(i, {
        backwards: t,
        startEditing: !0,
        // Default behaviour for fullRow is skip to the next cell,
        // editable or not. FullRow editing might have some editable
        // and some not editable cells in the row.
        // More complex logic needed to skip to the
        // next FullRow editable cell,
        skipToNextEditableCell: !1
      });
    } finally {
      this.model.suspend(!1);
    }
    if (r === !1)
      return null;
    if (r == null)
      return !1;
    const l = r.cellPosition, a = e.isCellEditable(), c = r.isCellEditable(), d = l && i.rowIndex === l.rowIndex && i.rowPinned === l.rowPinned;
    a && this.setFocusOutOnEditor(e), this.restoreEditors();
    const u = this.gos.get("suppressStartEditOnTab");
    return c && !s ? u ? r.focusCell(!0, o) : ((p = r.comp) != null && p.getCellEditor() || Ki(this.beans, r, { event: o, cellStartedEdit: !0 }), this.setFocusInOnEditor(r), r.focusCell(!1, o)) : (c && s && this.setFocusInOnEditor(r), r.focusCell(!0, o)), !d && !s && ((C = this.editSvc) == null || C.stopEditing({ rowNode: e.rowNode }, { event: o }), this.cleanupEditors(r, !0), u ? r.focusCell(!0, o) : this.editSvc.startEditing(r, { startedEdit: !0, event: o, source: n, ignoreEventKey: !0 })), (m = e.rowCtrl) == null || m.refreshRow({ suppressFlash: !0, force: !0 }), !0;
  }
  restoreEditors() {
    this.model.getEditMap().forEach(
      (e, t) => e.forEach(({ state: o }, n) => {
        var i;
        if (o !== "editing")
          return;
        const s = pt(this.beans, {
          rowNode: t,
          column: n
        });
        s && !((i = s.comp) != null && i.getCellEditor()) && Ki(this.beans, s, { silent: !0 });
      })
    );
  }
  destroy() {
    super.destroy(), this.rowNode = void 0, this.startedRows.length = 0;
  }
}, dWe = class extends Yy {
  constructor() {
    super(...arguments), this.beanName = "singleCell";
  }
  shouldStop(e, t, o = "ui") {
    const n = super.shouldStop(e, t, o);
    if (n !== null)
      return n;
    const { rowNode: s, column: i } = e || {};
    return (!this.rowNode || !this.column) && s && i ? null : this.rowNode !== s || this.column !== i;
  }
  midBatchInputsAllowed(e) {
    return this.model.hasEdits(e);
  }
  start(e) {
    const { position: t, startedEdit: o, event: n, ignoreEventKey: s } = e;
    (this.rowNode !== t.rowNode || this.column !== t.column) && super.cleanupEditors(), this.rowNode = t.rowNode, this.column = t.column, this.model.start(t), this.setupEditors({ cells: [t], position: t, startedEdit: o, event: n, ignoreEventKey: s });
  }
  dispatchRowEvent(e, t, o) {
  }
  processValidationResults(e) {
    return e.fail.length > 0 && this.editSvc.cellEditingInvalidCommitBlocks() ? {
      destroy: [],
      keep: e.all
    } : {
      destroy: e.all,
      keep: []
    };
  }
  stop(e, t) {
    return super.stop(e, t), this.rowNode = void 0, this.column = void 0, !0;
  }
  onCellFocusChanged(e) {
    const { colModel: t, editSvc: o } = this.beans, { rowIndex: n, column: s, rowPinned: i } = e, r = vn(this.beans, { rowIndex: n, rowPinned: i }), l = C5(s), a = t.getCol(l), c = e.previousParams;
    if (c) {
      const d = C5(c.column);
      if ((c == null ? void 0 : c.rowIndex) === n && d === l && (c == null ? void 0 : c.rowPinned) === i)
        return;
    }
    o != null && o.isEditing({ rowNode: r, column: a }, { withOpenEditor: !0 }) && e.type === "cellFocused" || super.onCellFocusChanged(e);
  }
  // returns null if no navigation should be performed
  moveToNextEditingCell(e, t, o, n = "ui", s = !1) {
    var C, m, w, y, b, _;
    const i = this.beans.focusSvc.getFocusedCell();
    i && (e = yi(this.beans, i) ?? e);
    const r = e.cellPosition;
    let l;
    const a = this.beans.gos.get("editType") === "fullRow";
    a && this.model.suspend(!0), s || (e.eGui.focus(), (m = this.editSvc) == null || m.stopEditing(e, { source: (C = this.editSvc) != null && C.isBatchEditing() ? "ui" : "api", event: o }));
    try {
      l = (w = this.beans.navigation) == null ? void 0 : w.findNextCellToFocusOn(r, {
        backwards: t,
        startEditing: !0
        // Default behaviour for fullRow is skip to the next cell,
        // editable or not. FullRow editing might have some editable
        // and some not editable cells in the row.
        // More complex logic needed to skip to the
        // next FullRow editable cell,
        // skipToNextEditableCell: false,
      });
    } finally {
      a && this.model.suspend(!1);
    }
    if (l === !1)
      return null;
    if (l == null)
      return !1;
    const c = l.cellPosition, d = e.isCellEditable(), u = l.isCellEditable(), h = c && r.rowIndex === c.rowIndex && r.rowPinned === c.rowPinned;
    d && !s && this.setFocusOutOnEditor(e);
    const p = this.gos.get("suppressStartEditOnTab");
    if (!h && !s && (super.cleanupEditors(l, !0), p ? l.focusCell(!0, o) : this.editSvc.startEditing(l, { startedEdit: !0, event: o, source: n, ignoreEventKey: !0 })), u && !s) {
      if (l.focusCell(!1, o), p)
        l.focusCell(!0, o);
      else if (!((y = l.comp) != null && y.getCellEditor())) {
        const M = (b = this.editSvc) == null ? void 0 : b.isEditing(l, { withOpenEditor: !0 });
        Ki(this.beans, l, { event: o, cellStartedEdit: !0, silent: M }), this.setFocusInOnEditor(l), this.cleanupEditors(l);
      }
    } else
      u && s && this.setFocusInOnEditor(l), l.focusCell(!0, o);
    return (_ = e.rowCtrl) == null || _.refreshRow({ suppressFlash: !0, force: !0 }), !0;
  }
  destroy() {
    super.destroy(), this.rowNode = void 0, this.column = void 0;
  }
}, ps = {
  moduleName: "EditCore",
  version: be,
  beans: [mGe, lWe],
  apiFunctions: {
    getEditingCells: Bje,
    getEditRowValues: Oje,
    getCellEditorInstances: wGe,
    startEditingCell: Gje,
    stopEditing: $je,
    isEditing: Zje,
    validateEdit: Nje
  },
  dynamicBeans: {
    singleCell: dWe,
    fullRow: cWe
  },
  dependsOn: [li, fc],
  css: [fje]
}, uWe = {
  moduleName: "UndoRedoEdit",
  version: be,
  beans: [pje],
  apiFunctions: {
    undoCellEditing: Hje,
    redoCellEditing: Vje,
    getCurrentUndoSize: zje,
    getCurrentRedoSize: jje
  },
  dependsOn: [ps]
}, hWe = {
  moduleName: "TextEditor",
  version: be,
  userComponents: { agCellEditor: Pu, agTextCellEditor: Pu },
  dependsOn: [ps]
}, gWe = {
  moduleName: "NumberEditor",
  version: be,
  userComponents: {
    agNumberCellEditor: {
      classImp: Eje
    }
  },
  dependsOn: [ps]
}, pWe = {
  moduleName: "DateEditor",
  version: be,
  userComponents: {
    agDateCellEditor: bje,
    agDateStringCellEditor: Sje
  },
  dependsOn: [ps]
}, fWe = {
  moduleName: "CheckboxEditor",
  version: be,
  userComponents: {
    agCheckboxCellEditor: mje
  },
  dependsOn: [ps]
}, vWe = {
  moduleName: "SelectEditor",
  version: be,
  userComponents: { agSelectCellEditor: Rje },
  dependsOn: [ps]
}, mWe = {
  moduleName: "LargeTextEditor",
  version: be,
  userComponents: { agLargeTextCellEditor: Mje },
  dependsOn: [ps]
}, CWe = {
  moduleName: "CustomEditor",
  version: be,
  dependsOn: [ps]
}, wWe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "selectionColSvc";
  }
  postConstruct() {
    this.addManagedPropertyListener("rowSelection", (e) => {
      this.onSelectionOptionsChanged(
        e.currentValue,
        e.previousValue,
        Bs(e.source)
      );
    }), this.addManagedPropertyListener("selectionColumnDef", this.updateColumns.bind(this));
  }
  addColumns(e) {
    const t = this.columns;
    t != null && (e.list = t.list.concat(e.list), e.tree = t.tree.concat(e.tree), R2(e));
  }
  createColumns(e, t) {
    var h, p;
    const o = () => {
      var C;
      Js(this.beans, (C = this.columns) == null ? void 0 : C.tree), this.columns = null;
    }, n = e.treeDepth, i = (((h = this.columns) == null ? void 0 : h.treeDepth) ?? -1) == n, r = this.generateSelectionCols();
    if (P2(r, ((p = this.columns) == null ? void 0 : p.list) ?? []) && i)
      return;
    o();
    const { colGroupSvc: a } = this.beans, c = (a == null ? void 0 : a.findDepth(e.tree)) ?? 0, d = (a == null ? void 0 : a.balanceTreeForAutoCols(r, c)) ?? [];
    this.columns = {
      list: r,
      tree: d,
      treeDepth: c,
      map: {}
    }, t((C) => {
      if (!C)
        return null;
      const m = C.filter((w) => !hs(w));
      return [...r, ...m];
    });
  }
  updateColumns(e) {
    var o;
    const t = Bs(e.source);
    (o = this.columns) == null || o.list.forEach((n) => {
      const s = this.createSelectionColDef(e.currentValue);
      n.setColDef(s, null, t), eo(this.beans, { state: [{ ...s, colId: n.getColId() }] }, t);
    });
  }
  getColumn(e) {
    var t;
    return ((t = this.columns) == null ? void 0 : t.list.find((o) => qr(o, e))) ?? null;
  }
  getColumns() {
    var e;
    return ((e = this.columns) == null ? void 0 : e.list) ?? null;
  }
  isSelectionColumnEnabled() {
    var r, l;
    const { gos: e, beans: t } = this, o = e.get("rowSelection");
    if (typeof o != "object" || !os(e))
      return !1;
    const n = (((l = (r = t.autoColSvc) == null ? void 0 : r.getColumns()) == null ? void 0 : l.length) ?? 0) > 0;
    if (o.checkboxLocation === "autoGroupColumn" && n)
      return !1;
    const s = !!Os(o), i = W1(o);
    return s || i;
  }
  createSelectionColDef(e) {
    const { gos: t } = this, o = e ?? t.get("selectionColumnDef"), n = t.get("enableRtl"), { rowSpan: s, spanRows: i, ...r } = o ?? {};
    return {
      // overridable properties
      width: 50,
      resizable: !1,
      suppressHeaderMenuButton: !0,
      sortable: !1,
      suppressMovable: !0,
      lockPosition: n ? "right" : "left",
      comparator(l, a, c, d) {
        const u = c.isSelected(), h = d.isSelected();
        return u === h ? 0 : u ? 1 : -1;
      },
      editable: !1,
      suppressFillHandle: !0,
      pinned: null,
      // overrides
      ...r,
      // non-overridable properties
      colId: Dw,
      chartDataType: "excluded"
    };
  }
  generateSelectionCols() {
    if (!this.isSelectionColumnEnabled())
      return [];
    const e = this.createSelectionColDef(), t = e.colId;
    this.gos.validateColDef(e, t, !0);
    const o = new Zn(e, null, t, !1);
    return this.createBean(o), [o];
  }
  onSelectionOptionsChanged(e, t, o) {
    const n = t && typeof t != "string" ? Os(t) : void 0, s = e && typeof e != "string" ? Os(e) : void 0, i = n !== s, r = t && typeof t != "string" ? W1(t) : void 0, l = e && typeof e != "string" ? W1(e) : void 0, a = r !== l, c = Wr(e), d = Wr(t);
    (i || a || c !== d) && this.beans.colModel.refreshAll(o);
  }
  destroy() {
    var e;
    Js(this.beans, (e = this.columns) == null ? void 0 : e.tree), super.destroy();
  }
  /**
   * Refreshes visibility of the selection column based on which columns are currently visible.
   * Called by the VisibleColsService with the columns that are currently visible in left/center/right
   * containers. This method *MUTATES* those arrays directly.
   *
   * The selection column should be visible if all of the following are true
   * - The selection column is not disabled
   * - The number of visible columns excluding the selection column and row numbers column is greater than 0
   * @param leftCols Visible columns in the left-pinned container
   * @param centerCols Visible columns in the center viewport
   * @param rightCols Visible columns in the right-pinned container
   */
  refreshVisibility(e, t, o) {
    var a, c;
    if (!((a = this.columns) != null && a.list.length))
      return;
    const n = e.length + t.length + o.length;
    if (n === 0)
      return;
    const s = this.columns.list[0];
    if (!s.isVisible())
      return;
    const i = () => {
      let d;
      switch (s.pinned) {
        case "left":
        case !0:
          d = e;
          break;
        case "right":
          d = o;
          break;
        default:
          d = t;
      }
      d && Zt(d, s);
    };
    (((c = this.beans.rowNumbersSvc) == null ? void 0 : c.getColumn(kw)) ? 2 : 1) === n && i();
  }
};
function bWe(e, t) {
  var r;
  if (!t.nodes.every((l) => l.rowPinned && !p1(l) ? (X(59), !1) : l.id === void 0 ? (X(60), !1) : !0))
    return;
  const { nodes: n, source: s, newValue: i } = t;
  (r = e.selectionSvc) == null || r.setNodesSelected({ nodes: n, source: s ?? "api", newValue: i });
}
function yWe(e, t, o = "apiSelectAll") {
  var n;
  (n = e.selectionSvc) == null || n.selectAllRowNodes({ source: o, selectAll: t });
}
function _We(e, t, o = "apiSelectAll") {
  var n;
  (n = e.selectionSvc) == null || n.deselectAllRowNodes({ source: o, selectAll: t });
}
function SWe(e, t = "apiSelectAllFiltered") {
  var o;
  (o = e.selectionSvc) == null || o.selectAllRowNodes({ source: t, selectAll: "filtered" });
}
function xWe(e, t = "apiSelectAllFiltered") {
  var o;
  (o = e.selectionSvc) == null || o.deselectAllRowNodes({ source: t, selectAll: "filtered" });
}
function MWe(e, t = "apiSelectAllCurrentPage") {
  var o;
  (o = e.selectionSvc) == null || o.selectAllRowNodes({ source: t, selectAll: "currentPage" });
}
function AWe(e, t = "apiSelectAllCurrentPage") {
  var o;
  (o = e.selectionSvc) == null || o.deselectAllRowNodes({ source: t, selectAll: "currentPage" });
}
function LWe(e) {
  var t;
  return ((t = e.selectionSvc) == null ? void 0 : t.getSelectedNodes()) ?? [];
}
function EWe(e) {
  var t;
  return ((t = e.selectionSvc) == null ? void 0 : t.getSelectedRows()) ?? [];
}
var PWe = class extends $Ve {
  constructor() {
    super(...arguments), this.beanName = "selectionSvc", this.selectedNodes = /* @__PURE__ */ new Map(), this.detailSelection = /* @__PURE__ */ new Map(), this.masterSelectsDetail = !1;
  }
  postConstruct() {
    super.postConstruct();
    const { gos: e } = this;
    this.mode = _l(e), this.groupSelectsDescendants = Kr(e), this.groupSelectsFiltered = Sl(e) === "filteredDescendants", this.masterSelectsDetail = Md(e) === "detail", this.addManagedPropertyListeners(["groupSelectsChildren", "groupSelectsFiltered", "rowSelection"], () => {
      const t = Kr(e), o = _l(e), n = Sl(e) === "filteredDescendants";
      this.masterSelectsDetail = Md(e) === "detail", (t !== this.groupSelectsDescendants || n !== this.groupSelectsFiltered || o !== this.mode) && (this.deselectAllRowNodes({ source: "api" }), this.groupSelectsDescendants = t, this.groupSelectsFiltered = n, this.mode = o);
    }), this.addManagedEventListeners({ rowSelected: this.onRowSelected.bind(this) });
  }
  destroy() {
    super.destroy(), this.resetNodes();
  }
  handleSelectionEvent(e, t, o) {
    if (this.isRowSelectionBlocked(t))
      return 0;
    const n = this.inferNodeSelections(t, e.shiftKey, e.metaKey || e.ctrlKey, o);
    if (n == null)
      return 0;
    if (this.selectionCtx.selectAll = !1, "select" in n)
      return n.reset ? this.resetNodes() : this.selectRange(n.deselect, !1, o), this.selectRange(n.select, !0, o);
    {
      const s = n.checkFilteredNodes ? Jy(n.node) : n.newValue;
      return this.setNodesSelected({
        nodes: [n.node],
        newValue: s,
        clearSelection: n.clearSelection,
        keepDescendants: n.keepDescendants,
        event: e,
        source: o
      });
    }
  }
  setNodesSelected({
    newValue: e,
    clearSelection: t,
    suppressFinishActions: o,
    nodes: n,
    event: s,
    source: i,
    keepDescendants: r = !1
  }) {
    var c;
    const { gos: l } = this;
    if (!os(l) && e)
      return X(132), 0;
    if (n.length === 0)
      return 0;
    if (n.length > 1 && !this.isMultiSelect())
      return X(130), 0;
    let a = 0;
    for (let d = 0; d < n.length; d++) {
      const u = n[d], h = fi(u);
      if (h.rowPinned && !p1(h)) {
        X(59);
        continue;
      }
      if (h.id === void 0) {
        X(60);
        continue;
      }
      this.groupSelectsFiltered && h.group && !l.get("treeData") || this.selectRowNode(h, e, s, i) && (this.detailSelection.delete(h.id), a++), this.groupSelectsDescendants && ((c = h.childrenAfterGroup) != null && c.length) && (a += this.selectChildren(h, e, i));
    }
    return o || (n.length === 1 && i === "api" && this.selectionCtx.setRoot(fi(n[0])), e && (t || !this.isMultiSelect()) && (a += this.clearOtherNodes(fi(n[0]), r, i)), a > 0 && (this.updateGroupsFromChildrenSelections(i), this.dispatchSelectionChanged(i))), a;
  }
  // not to be mixed up with 'cell range selection' where you drag the mouse, this is row range selection, by
  // holding down 'shift'.
  selectRange(e, t, o) {
    let n = 0;
    return e.forEach((s) => {
      const i = fi(s);
      if (i.group && this.groupSelectsDescendants)
        return;
      this.selectRowNode(i, t, void 0, o) && n++;
    }), n > 0 && (this.updateGroupsFromChildrenSelections(o), this.dispatchSelectionChanged(o)), n;
  }
  selectChildren(e, t, o) {
    const n = this.groupSelectsFiltered ? e.childrenAfterAggFilter : e.childrenAfterGroup;
    return n ? this.setNodesSelected({
      newValue: t,
      clearSelection: !1,
      suppressFinishActions: !0,
      source: o,
      nodes: n
    }) : 0;
  }
  getSelectedNodes() {
    return Array.from(this.selectedNodes.values());
  }
  getSelectedRows() {
    const e = [];
    return this.selectedNodes.forEach((t) => t.data && e.push(t.data)), e;
  }
  getSelectionCount() {
    return this.selectedNodes.size;
  }
  /**
   * This method is used by the CSRM to remove groups which are being disposed of,
   * events do not need fired in this case
   */
  filterFromSelection(e) {
    const t = /* @__PURE__ */ new Map();
    this.selectedNodes.forEach((o, n) => {
      e(o) && t.set(n, o);
    }), this.selectedNodes = t;
  }
  updateGroupsFromChildrenSelections(e, t) {
    if (!this.groupSelectsDescendants)
      return !1;
    const { gos: o, rowModel: n } = this.beans;
    if (!dt(o))
      return !1;
    const s = n.rootNode;
    if (!s)
      return !1;
    t || (t = new Wi(!0, s), t.active = !1);
    let i = !1;
    return t.forEachChangedNodeDepthFirst((r) => {
      if (r !== s) {
        const l = this.calculateSelectedFromChildren(r);
        i = this.selectRowNode(r, l === null ? !1 : l, void 0, e) || i;
      }
    }), i;
  }
  clearOtherNodes(e, t, o) {
    const n = /* @__PURE__ */ new Map();
    let s = 0;
    return this.selectedNodes.forEach((i) => {
      const r = i.id == e.id;
      if ((t ? !FWe(e, i) : !0) && !r) {
        const a = this.selectedNodes.get(i.id);
        s += this.setNodesSelected({
          nodes: [a],
          newValue: !1,
          clearSelection: !1,
          suppressFinishActions: !0,
          source: o
        }), this.groupSelectsDescendants && i.parent && n.set(i.parent.id, i.parent);
      }
    }), n.forEach((i) => {
      const r = this.calculateSelectedFromChildren(i);
      this.selectRowNode(i, r === null ? !1 : r, void 0, o);
    }), s;
  }
  onRowSelected(e) {
    const t = e.node;
    this.groupSelectsDescendants && t.group || (t.isSelected() ? this.selectedNodes.set(t.id, t) : this.selectedNodes.delete(t.id));
  }
  syncInRowNode(e, t) {
    this.syncInOldRowNode(e, t), this.syncInNewRowNode(e);
  }
  createDaemonNode(e) {
    if (!e.id)
      return;
    const t = new pn(this.beans);
    return t.id = e.id, t.data = e.data, t.__daemon = !0, t.__selected = e.__selected, t.level = e.level, t;
  }
  // if the id has changed for the node, then this means the rowNode
  // is getting used for a different data item, which breaks
  // our selectedNodes, as the node now is mapped by the old id
  // which is inconsistent. so to keep the old node as selected,
  // we swap in the clone (with the old id and old data). this means
  // the oldNode is effectively a daemon we keep a reference to,
  // so if client calls api.getSelectedNodes(), it gets the daemon
  // in the result. when the client un-selects, the reference to the
  // daemon is removed. the daemon, because it's an oldNode, is not
  // used by the grid for rendering, it's a copy of what the node used
  // to be like before the id was changed.
  syncInOldRowNode(e, t) {
    t && e.id !== t.id && this.selectedNodes.get(t.id) == e && this.selectedNodes.set(t.id, t);
  }
  syncInNewRowNode(e) {
    this.selectedNodes.has(e.id) ? (e.__selected = !0, this.selectedNodes.set(e.id, e)) : e.__selected = !1;
  }
  reset(e) {
    const t = this.getSelectionCount();
    this.resetNodes(), t && this.dispatchSelectionChanged(e);
  }
  resetNodes() {
    this.selectedNodes.forEach((e) => {
      this.selectRowNode(e, !1);
    }), this.selectedNodes.clear();
  }
  // returns a list of all nodes at 'best cost' - a feature to be used
  // with groups / trees. if a group has all it's children selected,
  // then the group appears in the result, but not the children.
  // Designed for use with 'children' as the group selection type,
  // where groups don't actually appear in the selection normally.
  getBestCostNodeSelection() {
    const { gos: e, rowModel: t } = this.beans;
    if (!dt(e))
      return;
    const o = t.getTopLevelNodes();
    if (o === null)
      return;
    const n = [];
    function s(i) {
      for (let r = 0, l = i.length; r < l; r++) {
        const a = i[r];
        a.isSelected() ? n.push(a) : a.group && a.childrenAfterGroup && s(a.childrenAfterGroup);
      }
    }
    return s(o), n;
  }
  isEmpty() {
    return this.getSelectionCount() === 0;
  }
  deselectAllRowNodes({ source: e, selectAll: t }) {
    const o = dt(this.gos);
    let n = !1;
    const s = (i) => {
      const r = this.selectRowNode(fi(i), !1, void 0, e);
      n || (n = r);
    };
    if (t === "currentPage" || t === "filtered") {
      if (!o) {
        qe(102);
        return;
      }
      this.getNodesToSelect(t).forEach(s);
    } else
      this.selectedNodes.forEach(s), this.reset(e);
    if (this.selectionCtx.selectAll = !1, o && this.groupSelectsDescendants) {
      const i = this.updateGroupsFromChildrenSelections(e);
      n || (n = i);
    }
    n && this.dispatchSelectionChanged(e);
  }
  getSelectedCounts(e) {
    let t = 0, o = 0;
    return this.getNodesToSelect(e).forEach((n) => {
      this.groupSelectsDescendants && n.group || (n.isSelected() ? t++ : n.selectable && o++);
    }), { selectedCount: t, notSelectedCount: o };
  }
  getSelectAllState(e) {
    const { selectedCount: t, notSelectedCount: o } = this.getSelectedCounts(e);
    return Qy(t, o) ?? null;
  }
  hasNodesToSelect(e) {
    return this.getNodesToSelect(e).filter((t) => t.selectable).length > 0;
  }
  /**
   * @param selectAll See `MultiRowSelectionOptions.selectAll`
   * @returns all nodes including unselectable nodes which are the target of this selection attempt
   */
  getNodesToSelect(e) {
    if (!this.canSelectAll())
      return [];
    const t = [], o = (s) => t.push(s);
    if (e === "currentPage")
      return this.forEachNodeOnPage((s) => {
        if (!s.group) {
          o(s);
          return;
        }
        if (!s.expanded && !s.footer) {
          const i = (r) => {
            var l;
            o(r), (l = r.childrenAfterFilter) == null || l.forEach(i);
          };
          i(s);
          return;
        }
        this.groupSelectsDescendants || o(s);
      }), t;
    const n = this.beans.rowModel;
    return e === "filtered" ? (n.forEachNodeAfterFilter(o), t) : (n.forEachNode(o), t);
  }
  forEachNodeOnPage(e) {
    const { pageBounds: t, rowModel: o } = this.beans, n = t.getFirstRow(), s = t.getLastRow();
    for (let i = n; i <= s; i++) {
      const r = o.getRow(i);
      r && e(r);
    }
  }
  selectAllRowNodes(e) {
    const { gos: t, selectionCtx: o } = this;
    if (!os(t)) {
      X(132);
      return;
    }
    if (AIe(t) && !Ur(t)) {
      X(130);
      return;
    }
    if (!this.canSelectAll())
      return;
    const { source: n, selectAll: s } = e;
    let i = !1;
    if (this.getNodesToSelect(s).forEach((r) => {
      const l = this.selectRowNode(fi(r), !0, void 0, n);
      i || (i = l);
    }), o.selectAll = !0, dt(t) && this.groupSelectsDescendants) {
      const r = this.updateGroupsFromChildrenSelections(n);
      i || (i = r);
    }
    i && this.dispatchSelectionChanged(n);
  }
  getSelectionState() {
    return this.isEmpty() ? null : Array.from(this.selectedNodes.keys());
  }
  setSelectionState(e, t, o) {
    if (e || (e = []), !Array.isArray(e)) {
      qe(103);
      return;
    }
    const n = new Set(e), s = [];
    this.beans.rowModel.forEachNode((i) => {
      n.has(i.id) && s.push(i);
    }), o && this.resetNodes(), this.setNodesSelected({
      newValue: !0,
      nodes: s,
      source: t
    });
  }
  canSelectAll() {
    const { gos: e } = this.beans;
    return !!dt(e);
  }
  /**
   * Updates the selectable state for a node by invoking isRowSelectable callback.
   * If the node is not selectable, it will be deselected.
   *
   * Callers:
   *  - property isRowSelectable changed
   *  - after grouping / treeData via `updateSelectableAfterGrouping`
   */
  updateSelectable(e) {
    var a;
    const { gos: t, rowModel: o } = this.beans;
    if (!os(t))
      return;
    const n = "selectableChanged", s = e !== void 0, i = dt(t) && this.groupSelectsDescendants, r = [], l = (c) => {
      var u;
      if (s && !c.group)
        return;
      if (i && c.group) {
        const h = ((u = c.childrenAfterGroup) == null ? void 0 : u.some((p) => p.selectable)) ?? !1;
        this.setRowSelectable(c, h, !0);
        return;
      }
      !this.updateRowSelectable(c, !0) && c.isSelected() && r.push(c);
    };
    if (i) {
      if (e === void 0) {
        const c = o.rootNode;
        e = c ? new Wi(!1, c) : void 0;
      }
      e == null || e.forEachChangedNodeDepthFirst(l, !s, !s);
    } else
      o.forEachNode(l);
    r.length && this.setNodesSelected({
      nodes: r,
      newValue: !1,
      source: n
    }), !s && i && ((a = this.updateGroupsFromChildrenSelections) == null || a.call(this, n));
  }
  // only called by CSRM
  updateSelectableAfterGrouping(e) {
    var t;
    this.updateSelectable(e), this.groupSelectsDescendants && ((t = this.updateGroupsFromChildrenSelections) != null && t.call(this, "rowGroupChanged", e)) && this.dispatchSelectionChanged("rowGroupChanged");
  }
  refreshMasterNodeState(e, t) {
    var i, r;
    if (!this.masterSelectsDetail)
      return;
    const o = (r = (i = e.detailNode) == null ? void 0 : i.detailGridInfo) == null ? void 0 : r.api;
    if (!o)
      return;
    const n = RWe(o);
    if (e.isSelected() !== n && this.selectRowNode(e, n, t, "masterDetail") && this.dispatchSelectionChanged("masterDetail"), !n) {
      const l = this.detailSelection.get(e.id) ?? /* @__PURE__ */ new Set();
      for (const a of o.getSelectedNodes())
        l.add(a.id);
      this.detailSelection.set(e.id, l);
    }
  }
  setDetailSelectionState(e, t, o) {
    if (this.masterSelectsDetail) {
      if (!Ur(t)) {
        X(269);
        return;
      }
      switch (e.isSelected()) {
        case !0: {
          o.selectAll();
          break;
        }
        case !1: {
          o.deselectAll();
          break;
        }
        case void 0: {
          const n = this.detailSelection.get(e.id);
          if (n) {
            const s = [];
            for (const i of n) {
              const r = o.getRowNode(i);
              r && s.push(r);
            }
            o.setNodesSelected({ nodes: s, newValue: !0, source: "masterDetail" });
          }
          break;
        }
      }
    }
  }
  dispatchSelectionChanged(e) {
    this.eventSvc.dispatchEvent({
      type: "selectionChanged",
      source: e,
      selectedNodes: this.getSelectedNodes(),
      serverSideState: null
    });
  }
};
function fi(e) {
  return p1(e) ? e.pinnedSibling : e.footer ? e.sibling : e;
}
function RWe(e) {
  let t = 0, o = 0;
  return e.forEachNode((n) => {
    n.isSelected() ? t++ : n.selectable && o++;
  }), Qy(t, o);
}
function Qy(e, t) {
  if (e === 0 && t === 0)
    return !1;
  if (!(e > 0 && t > 0))
    return e > 0;
}
function FWe(e, t) {
  let o = t.parent;
  for (; o; ) {
    if (o === e)
      return !0;
    o = o.parent;
  }
  return !1;
}
function Jy(e) {
  var n;
  const t = e.isSelected() === !1, o = ((n = e.childrenAfterFilter) == null ? void 0 : n.some(Jy)) ?? !1;
  return t || o;
}
var TWe = {
  moduleName: "SharedRowSelection",
  version: be,
  beans: [wWe],
  apiFunctions: {
    setNodesSelected: bWe,
    selectAll: yWe,
    deselectAll: _We,
    selectAllFiltered: SWe,
    deselectAllFiltered: xWe,
    selectAllOnCurrentPage: MWe,
    deselectAllOnCurrentPage: AWe,
    getSelectedNodes: LWe,
    getSelectedRows: EWe
  }
}, IWe = {
  moduleName: "RowSelection",
  version: be,
  rowModels: ["clientSide", "infinite", "viewport"],
  beans: [PWe],
  dependsOn: [TWe]
};
function DWe(e) {
  var t;
  (t = e.expansionSvc) == null || t.expandAll(!0);
}
function kWe(e) {
  var t;
  (t = e.expansionSvc) == null || t.expandAll(!1);
}
function Xy(e) {
  var t;
  (t = e.rowModel) == null || t.onRowHeightChanged();
}
function e_(e) {
  var t, o;
  if ((t = e.rowAutoHeight) != null && t.active) {
    X(3);
    return;
  }
  (o = e.rowModel) == null || o.resetRowHeights();
}
function HWe(e, t, o) {
  var i;
  const n = LOe(e);
  if (n) {
    if (((i = e.rowGroupColsSvc) == null ? void 0 : i.columns.length) === 0) {
      if (t < 0) {
        qe(238);
        return;
      }
      n.setRowCount(t, o);
      return;
    }
    qe(28);
    return;
  }
  const s = _a(e);
  if (s) {
    s.setRowCount(t, o);
    return;
  }
}
function VWe(e) {
  var t;
  return $n(e.gos) ? e.rowModel.getBlockStates() : ((t = e.rowNodeBlockLoader) == null ? void 0 : t.getBlockState()) ?? {};
}
function OWe(e) {
  return e.rowModel.isLastRowIndexKnown();
}
var BWe = {
  moduleName: "CsrmSsrmSharedApi",
  version: be,
  apiFunctions: { expandAll: DWe, collapseAll: kWe }
}, $We = {
  moduleName: "RowModelSharedApi",
  version: be,
  apiFunctions: { onRowHeightChanged: Xy, resetRowHeights: e_ }
}, ZWe = {
  moduleName: "SsrmInfiniteSharedApi",
  version: be,
  apiFunctions: {
    setRowCount: HWe,
    getCacheBlockState: VWe,
    isLastRowIndexKnown: OWe
  }
}, GWe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "alignedGridsSvc", this.consuming = !1;
  }
  getAlignedGridApis() {
    let e = this.gos.get("alignedGrids") ?? [];
    const t = typeof e == "function";
    return typeof e == "function" && (e = e()), e.map((n) => {
      var i;
      if (!n) {
        qe(18), t || qe(20);
        return;
      }
      if (this.isGridApi(n))
        return n;
      const s = n;
      return "current" in s ? (i = s.current) == null ? void 0 : i.api : (s.api || qe(19), s.api);
    }).filter((n) => !!n && !n.isDestroyed());
  }
  isGridApi(e) {
    return !!e && !!e.dispatchEvent;
  }
  postConstruct() {
    const e = this.fireColumnEvent.bind(this);
    this.addManagedEventListeners({
      columnMoved: e,
      columnVisible: e,
      columnPinned: e,
      columnGroupOpened: e,
      columnResized: e,
      bodyScroll: this.fireScrollEvent.bind(this),
      alignedGridColumn: ({ event: t }) => this.onColumnEvent(t),
      alignedGridScroll: ({ event: t }) => this.onScrollEvent(t)
    });
  }
  // common logic across all the fire methods
  fireEvent(e) {
    this.consuming || this.getAlignedGridApis().forEach((t) => {
      t.isDestroyed() || t.dispatchEvent(e);
    });
  }
  // common logic across all consume methods. very little common logic, however extracting
  // guarantees consistency across the methods.
  onEvent(e) {
    this.consuming = !0, e(), this.consuming = !1;
  }
  fireColumnEvent(e) {
    this.fireEvent({
      type: "alignedGridColumn",
      event: e
    });
  }
  fireScrollEvent(e) {
    e.direction === "horizontal" && this.fireEvent({
      type: "alignedGridScroll",
      event: e
    });
  }
  onScrollEvent(e) {
    this.onEvent(() => {
      this.beans.ctrlsSvc.getScrollFeature().setHorizontalScrollPosition(e.left, !0);
    });
  }
  extractDataFromEvent(e, t) {
    const o = [];
    return e.columns ? e.columns.forEach((n) => {
      o.push(t(n));
    }) : e.column && o.push(t(e.column)), o;
  }
  getMasterColumns(e) {
    return this.extractDataFromEvent(e, (t) => t);
  }
  getColumnIds(e) {
    return this.extractDataFromEvent(e, (t) => t.getColId());
  }
  onColumnEvent(e) {
    this.onEvent(() => {
      switch (e.type) {
        case "columnMoved":
        case "columnVisible":
        case "columnPinned":
        case "columnResized": {
          this.processColumnEvent(e);
          break;
        }
        case "columnGroupOpened": {
          this.processGroupOpenedEvent(e);
          break;
        }
        case "columnPivotChanged":
          X(21);
          break;
      }
    });
  }
  processGroupOpenedEvent(e) {
    const { colGroupSvc: t } = this.beans;
    t && e.columnGroups.forEach((o) => {
      let n = null;
      o && (n = t.getProvidedColGroup(o.getGroupId())), !(o && !n) && t.setColumnGroupOpened(n, o.isExpanded(), "alignedGridChanged");
    });
  }
  processColumnEvent(e) {
    var d;
    const t = e.column;
    let o = null;
    const n = this.beans, { colResize: s, ctrlsSvc: i, colModel: r } = n;
    if (t && (o = r.getColDefCol(t.getColId())), t && !o)
      return;
    const l = this.getMasterColumns(e);
    switch (e.type) {
      case "columnMoved":
        {
          const h = e.api.getColumnState().map((p) => ({ colId: p.colId }));
          eo(n, { state: h, applyOrder: !0 }, "alignedGridChanged");
        }
        break;
      case "columnVisible":
        {
          const h = e.api.getColumnState().map((p) => ({ colId: p.colId, hide: p.hide }));
          eo(n, { state: h }, "alignedGridChanged");
        }
        break;
      case "columnPinned":
        {
          const h = e.api.getColumnState().map((p) => ({ colId: p.colId, pinned: p.pinned }));
          eo(n, { state: h }, "alignedGridChanged");
        }
        break;
      case "columnResized": {
        const u = e, h = {};
        l.forEach((p) => {
          h[p.getId()] = { key: p.getColId(), newWidth: p.getActualWidth() };
        }), (d = u.flexColumns) == null || d.forEach((p) => {
          h[p.getId()] && delete h[p.getId()];
        }), s == null || s.setColumnWidths(
          Object.values(h),
          !1,
          u.finished,
          "alignedGridChanged"
        );
        break;
      }
    }
    const c = i.getGridBodyCtrl().isVerticalScrollShowing();
    this.getAlignedGridApis().forEach((u) => {
      u.setGridOption("alwaysShowVerticalScroll", c);
    });
  }
}, NWe = {
  moduleName: "AlignedGrids",
  version: be,
  beans: [GWe],
  dependsOn: [ny]
}, zWe = class extends Nb {
  constructor() {
    super(...arguments), this.beanName = "csrmNodeSvc";
  }
}, S0 = class {
  constructor() {
    this.removals = /* @__PURE__ */ new Set(), this.updates = /* @__PURE__ */ new Set(), this.adds = /* @__PURE__ */ new Set();
  }
  /** Marks a row as removed. Order of operations is: remove, update, add */
  remove(e) {
    this.adds.delete(e) || (this.updates.delete(e), this.removals.add(e));
  }
  /** Marks a row as updated. Order of operations is: remove, update, add */
  update(e) {
    this.adds.has(e) || this.updates.add(e);
  }
  /** Marks a row as added. Order of operation is: remove, update, add */
  add(e) {
    this.adds.add(e);
  }
}, t_ = (e) => {
  const t = e.childrenAfterSort, o = e.sibling;
  if (o && (o.childrenAfterSort = t), !!t)
    for (let n = 0, s = t.length - 1; n <= s; n++) {
      const i = t[n], r = n === 0, l = n === s;
      i.firstChild !== r && (i.firstChild = r, i.dispatchRowEvent("firstChildChanged")), i.lastChild !== l && (i.lastChild = l, i.dispatchRowEvent("lastChildChanged")), i.childIndex !== n && (i.childIndex = n, i.dispatchRowEvent("childIndexChanged"));
    }
}, jWe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "sortStage", this.refreshProps = /* @__PURE__ */ new Set(["postSortRows", "groupDisplayType", "accentedSort"]), this.step = "sort";
  }
  execute(e) {
    const t = this.beans.sortSvc.getSortOptions(), o = t.length > 0 && !!e.changedRowNodes && // in time we can remove this check, so that delta sort is always
    // on if transactions are present. it's off for now so that we can
    // selectively turn it on and test it with some select users before
    // rolling out to everyone.
    this.gos.get("deltaSort");
    this.sort(t, o, e.changedRowNodes, e.changedPath);
  }
  sort(e, t, o, n) {
    const { gos: s, colModel: i, rowGroupColsSvc: r, rowNodeSorter: l, rowRenderer: a, showRowGroupCols: c } = this.beans, d = s.get("groupMaintainOrder"), u = i.getCols().some((b) => b.isRowGroupActive()), h = r == null ? void 0 : r.columns, p = i.isPivotMode(), C = s.getCallback("postSortRows");
    let m = !1, w;
    const y = (b) => {
      var L, A;
      const _ = p && b.leafGroup;
      let M = d && u && !b.leafGroup;
      M && (w ?? (w = this.shouldSortContainsGroupCols(e)), M && (M = !w));
      let x = null;
      if (M) {
        let R = !1;
        if (h) {
          const P = b.level + 1;
          P < h.length && (R = h[P].getSort() === null);
        }
        R || (x = KWe(b));
      } else !e.length || _ ? x = null : t && o ? x = WWe(l, b, o, n, e) : x = l.doFullSort(b.childrenAfterAggFilter, e);
      if (x || (x = ((L = b.childrenAfterAggFilter) == null ? void 0 : L.slice(0)) ?? []), m || (m = ((A = b.childrenAfterSort) == null ? void 0 : A[0]) !== x[0]), b.childrenAfterSort = x, t_(b), C) {
        const R = { nodes: b.childrenAfterSort };
        C(R);
      }
    };
    if (n == null || n.forEachChangedNodeDepthFirst(y), m && s.get("groupHideOpenParents")) {
      const b = c == null ? void 0 : c.getShowRowGroupCols();
      b != null && b.length && a.refreshCells({ columns: b, force: !0 });
    }
  }
  shouldSortContainsGroupCols(e) {
    const t = e.length;
    if (!t)
      return !1;
    if (Oo(this.gos)) {
      for (let o = 0; o < t; ++o) {
        const n = e[o].column;
        if (n.isPrimary() && n.isRowGroupActive())
          return !0;
      }
      return !1;
    }
    for (let o = 0; o < t; ++o)
      if (e[o].column.getColDef().showRowGroup)
        return !0;
    return !1;
  }
}, WWe = (e, t, o, n, s) => {
  const i = t.childrenAfterAggFilter, r = t.childrenAfterSort;
  if (!r)
    return e.doFullSort(i, s);
  const l = /* @__PURE__ */ new Set(), a = [], { updates: c, adds: d } = o;
  for (let h = 0, p = i.length; h < p; ++h) {
    const C = i[h];
    c.has(C) || d.has(C) || n && !n.canSkip(C) ? a.push({
      currentPos: a.length,
      rowNode: C
    }) : l.add(C);
  }
  const u = r.filter((h) => l.has(h)).map((h, p) => ({ currentPos: p, rowNode: h }));
  return a.sort((h, p) => e.compareRowNodes(s, h, p)), UWe(e, s, a, u);
}, UWe = (e, t, o, n) => {
  let s = 0, i = 0;
  const r = o.length, l = n.length, a = new Array(r + l);
  let c = 0;
  for (; s < r && i < l; ) {
    const d = o[s], u = n[i];
    e.compareRowNodes(t, d, u) < 0 ? (a[c++] = d.rowNode, ++s) : (a[c++] = u.rowNode, ++i);
  }
  for (; s < r; )
    a[c++] = o[s++].rowNode;
  for (; i < l; )
    a[c++] = n[i++].rowNode;
  return a;
}, KWe = (e) => {
  const t = e.childrenAfterSort, o = e.childrenAfterAggFilter, n = t == null ? void 0 : t.length, s = o == null ? void 0 : o.length;
  if (!n || !s)
    return null;
  const i = new Array(s), r = /* @__PURE__ */ new Set();
  for (let a = 0; a < s; ++a)
    r.add(o[a]);
  let l = 0;
  for (let a = 0; a < n; ++a) {
    const c = t[a];
    r.delete(c) && (i[l++] = c);
  }
  if (r.size === 0 && l === n)
    return t;
  for (const a of r)
    i[l++] = a;
  return i.length = l, i;
}, qWe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "rowModel", this.rootNode = null, this.rowsToDisplay = [], this.rowDataUpdatedPending = !1, this.started = !1, this.isRefreshingModel = !1, this.rowNodesCountReady = !1, this.rowCountReady = !1, this.onRowHeightChanged_debounced = Rt(this, this.onRowHeightChanged.bind(this), 100);
  }
  wireBeans(e) {
    this.colModel = e.colModel, this.valueCache = e.valueCache, this.filterStage = e.filterStage, this.sortStage = e.sortStage, this.flattenStage = e.flattenStage, this.groupStage = e.groupStage, this.aggStage = e.aggStage, this.pivotStage = e.pivotStage, this.filterAggStage = e.filterAggStage;
  }
  postConstruct() {
    this.orderedStages = [
      this.groupStage,
      this.filterStage,
      this.pivotStage,
      this.aggStage,
      this.sortStage,
      this.filterAggStage,
      this.flattenStage
    ].filter((n) => !!n);
    const e = this.refreshModel.bind(this, { step: "group" }), t = this.refreshModel.bind(this, {
      step: "group",
      // after cols change, row grouping (the first stage) could of changed
      afterColumnsChanged: !0,
      keepRenderedRows: !0,
      // we want animations cos sorting or filtering could be applied
      animate: !this.gos.get("suppressAnimationFrame")
    });
    this.addManagedEventListeners({
      newColumnsLoaded: t,
      columnRowGroupChanged: e,
      columnValueChanged: this.onValueChanged.bind(this),
      columnPivotChanged: this.refreshModel.bind(this, { step: "pivot" }),
      filterChanged: this.onFilterChanged.bind(this),
      sortChanged: this.onSortChanged.bind(this),
      columnPivotModeChanged: e,
      gridStylesChanged: this.onGridStylesChanges.bind(this),
      gridReady: this.onGridReady.bind(this),
      rowExpansionStateChanged: this.onRowGroupOpened.bind(this)
    }), this.addPropertyListeners(), this.rootNode = new pn(this.beans);
    const o = this.getNewNodeManager();
    this.nodeManager = o, o.activate(this.rootNode);
  }
  getNewNodeManager() {
    const { gos: e, beans: t } = this;
    return E2(e) === "treeNested" && t.csrmChildrenTreeNodeSvc || t.csrmNodeSvc;
  }
  addPropertyListeners() {
    const e = [
      "treeData",
      "treeDataChildrenField",
      ...this.orderedStages.flatMap(({ refreshProps: t }) => [...t])
    ];
    this.addManagedPropertyListeners(e, (t) => {
      var n;
      const o = (n = t.changeSet) == null ? void 0 : n.properties;
      o && this.onPropChange(o);
    }), this.addManagedPropertyListener("rowData", () => this.onPropChange(["rowData"])), this.addManagedPropertyListener("rowHeight", () => this.resetRowHeights());
  }
  start() {
    this.started = !0, this.rowNodesCountReady ? this.refreshModel({ step: "group", rowDataUpdated: !0, newData: !0 }) : this.setInitialData();
  }
  setInitialData() {
    this.gos.get("rowData") && this.onPropChange(["rowData"]);
  }
  ensureRowHeightsValid(e, t, o, n) {
    let s, i = !1;
    do {
      s = !1;
      const r = this.getRowIndexAtPixel(e), l = this.getRowIndexAtPixel(t), a = Math.max(r, o), c = Math.min(l, n);
      for (let d = a; d <= c; d++) {
        const u = this.getRow(d);
        if (u.rowHeightEstimated) {
          const h = Dn(this.beans, u);
          u.setRowHeight(h.height), s = !0, i = !0;
        }
      }
      s && this.setRowTopAndRowIndex();
    } while (s);
    return i;
  }
  onPropChange(e) {
    if (!this.rootNode)
      return;
    const t = this.gos, o = new Set(e), n = {
      step: "nothing",
      changedProps: o
    }, s = o.has("rowData"), i = this.nodeManager, r = this.getNewNodeManager(), l = i !== r || s && o.has("treeData") && t.get("treeData") || o.has("treeDataChildrenField") && t.get("treeData");
    let a;
    if ((l || s) && (a = t.get("rowData"), a != null && !Array.isArray(a) && (a = null, X(1))), l && (s || (a = (i == null ? void 0 : i.extractRowData()) ?? a), i !== r && (i == null || i.deactivate(), this.nodeManager = r), r.activate(this.rootNode)), a)
      if (!l && !this.isEmpty() && a.length > 0 && t.exists("getRowId") && // this property is a backwards compatibility property, for those who want
      // the old behaviour of Row IDs but NOT Immutable Data.
      !t.get("resetRowDataOnUpdate"))
        n.keepRenderedRows = !0, n.animate = !this.gos.get("suppressAnimationFrame"), n.changedRowNodes = new S0(), r.setImmutableRowData(n, a);
      else {
        n.rowDataUpdated = !0, n.newData = !0;
        const { selectionSvc: d, pinnedRowModel: u } = this.beans;
        d == null || d.reset("rowDataChanged"), u != null && u.isManual() && u.reset(), this.rowNodesCountReady = !0, r.setNewRowData(a);
      }
    if (n.rowDataUpdated)
      n.step = "group";
    else if (n.step === "nothing") {
      for (const { refreshProps: c, step: d } of this.orderedStages)
        if (e.some((u) => c.has(u))) {
          n.step = d;
          break;
        }
    }
    n.step !== "nothing" && this.refreshModel(n);
  }
  setRowTopAndRowIndex() {
    const { beans: e, rowsToDisplay: t } = this, o = e.environment.getDefaultRowHeight();
    let n = 0;
    const s = /* @__PURE__ */ new Set(), i = jt(this.gos, "normal");
    for (let r = 0, l = t.length; r < l; ++r) {
      const a = t[r];
      if (a.id != null && s.add(a.id), a.rowHeight == null) {
        const c = Dn(e, a, i, o);
        a.setRowHeight(c.height, c.estimated);
      }
      a.setRowTop(n), a.setRowIndex(r), n += a.rowHeight;
    }
    return s;
  }
  clearRowTopAndRowIndex(e, t) {
    const o = e.active, n = (i) => {
      i && i.id != null && !t.has(i.id) && i.clearRowTopAndRowIndex();
    }, s = (i) => {
      if (i !== null && (n(i), n(i.detailNode), n(i.sibling), i.hasChildren() && i.childrenAfterGroup)) {
        const r = i.level == -1;
        o && !r && !i.expanded || i.childrenAfterGroup.forEach(s);
      }
    };
    s(this.rootNode);
  }
  isLastRowIndexKnown() {
    return !0;
  }
  getRowCount() {
    return this.rowsToDisplay ? this.rowsToDisplay.length : 0;
  }
  /**
   * Returns the number of rows with level === 1
   */
  getTopLevelRowCount() {
    const e = this.rootNode;
    if (!e || this.rowsToDisplay.length === 0)
      return 0;
    if (this.rowsToDisplay && this.rowsToDisplay[0] === e)
      return 1;
    const o = e.childrenAfterSort, n = e.sibling && e.sibling.displayed ? 1 : 0;
    return (o ? o.length : 0) + n;
  }
  /**
   * Get the row display index by the top level index
   * top level index is the index of rows with level === 1
   */
  getTopLevelRowDisplayedIndex(e) {
    const { rootNode: t, rowsToDisplay: o } = this;
    if (!t || !o.length || o[0] === t)
      return e;
    const { childrenAfterSort: s } = t, i = (l) => {
      let a = s[l];
      if (this.gos.get("groupHideOpenParents"))
        for (; a.expanded && a.childrenAfterSort && a.childrenAfterSort.length > 0; )
          a = a.childrenAfterSort[0];
      return a.rowIndex;
    }, { footerSvc: r } = this.beans;
    return r ? r.getTopDisplayIndex(o, e, s, i) : i(e);
  }
  /**
   * The opposite of `getTopLevelRowDisplayedIndex`
   */
  getTopLevelIndexFromDisplayedIndex(e) {
    var r;
    const { rootNode: t, rowsToDisplay: o } = this;
    if (!t || !o.length || o[0] === t)
      return e;
    let s = this.getRow(e);
    for (s.footer && (s = s.sibling); s.parent && s.parent !== t; )
      s = s.parent;
    const i = (r = t.childrenAfterSort) == null ? void 0 : r.findIndex((l) => l === s);
    return i === -1 ? e : i ?? e;
  }
  getRowBounds(e) {
    const t = this.rowsToDisplay[e];
    return t ? {
      rowTop: t.rowTop,
      rowHeight: t.rowHeight
    } : null;
  }
  onRowGroupOpened() {
    const e = Ei(this.gos);
    this.refreshModel({ step: "map", keepRenderedRows: !0, animate: e });
  }
  onFilterChanged(e) {
    if (e.afterDataChange)
      return;
    const t = Ei(this.gos), n = e.columns.length === 0 || e.columns.some((s) => s.isPrimary()) ? "filter" : "filter_aggregates";
    this.refreshModel({ step: n, keepRenderedRows: !0, animate: t });
  }
  onSortChanged() {
    const e = Ei(this.gos);
    this.refreshModel({
      step: "sort",
      keepRenderedRows: !0,
      animate: e
    });
  }
  getType() {
    return "clientSide";
  }
  onValueChanged() {
    this.refreshModel({ step: this.colModel.isPivotActive() ? "pivot" : "aggregate" });
  }
  createChangePath(e) {
    const t = new Wi(!1, this.rootNode);
    return e || (t.active = !1), t;
  }
  isSuppressModelUpdateAfterUpdateTransaction(e) {
    if (!this.gos.get("suppressModelUpdateAfterUpdateTransaction"))
      return !1;
    const { changedRowNodes: t, newData: o, rowDataUpdated: n } = e;
    return !(!t || o || !n || t.removals.size || t.adds.size);
  }
  refreshModel(e) {
    var i, r, l;
    if (!this.rootNode)
      return;
    const t = this.beans;
    let o = !!e.rowDataUpdated;
    const n = e.changedPath ?? (e.changedPath = this.createChangePath(!e.newData && o));
    if (this.started && o && this.eventSvc.dispatchEvent({ type: "rowDataUpdated" }), !this.started || this.isRefreshingModel || this.colModel.changeEventsDispatching || this.isSuppressModelUpdateAfterUpdateTransaction(e)) {
      this.rowDataUpdatedPending || (this.rowDataUpdatedPending = o);
      return;
    }
    switch (this.rowDataUpdatedPending && (this.rowDataUpdatedPending = !1, e.rowDataUpdated = o = !0, e.step = "group"), this.isRefreshingModel = !0, (i = t.masterDetailSvc) == null || i.refreshModel(e), o && e.step !== "group" && ((r = t.colFilter) == null || r.refreshModel()), e.step) {
      case "group":
        (this.doRowGrouping(e) || o) && ((l = t.colFilter) == null || l.refreshModel()), !this.rowCountReady && this.rowNodesCountReady && (this.rowCountReady = !0, this.eventSvc.dispatchEventOnce({ type: "rowCountReady" }));
      case "filter":
        this.doFilter(n);
      case "pivot":
        this.doPivot(n);
      case "aggregate":
        this.doAggregate(n);
      case "filter_aggregates":
        this.doFilterAggregates(n);
      case "sort":
        this.doSort(e.changedRowNodes, n);
      case "map":
        this.doRowsToDisplay();
    }
    const s = this.setRowTopAndRowIndex();
    this.clearRowTopAndRowIndex(n, s), this.isRefreshingModel = !1, this.eventSvc.dispatchEvent({
      type: "modelUpdated",
      animate: e.animate,
      keepRenderedRows: e.keepRenderedRows,
      newData: e.newData,
      newPage: !1,
      keepUndoRedoStack: e.keepUndoRedoStack
    });
  }
  isEmpty() {
    var e, t, o;
    return !((t = (e = this.rootNode) == null ? void 0 : e.allLeafChildren) != null && t.length) || !((o = this.colModel) != null && o.ready);
  }
  isRowsToRender() {
    return this.rowsToDisplay.length > 0;
  }
  getNodesInRangeForSelection(e, t) {
    let o = !1, n = !1;
    const s = [], i = Kr(this.gos);
    return this.forEachNodeAfterFilterAndSort((r) => {
      if (n)
        return;
      if (o && (r === t || r === e) && (n = !0, r.group && i)) {
        s.push(...r.allLeafChildren);
        return;
      }
      if (!o) {
        if (r !== t && r !== e)
          return;
        o = !0, t === e && (n = !0);
      }
      if (!r.group || !i) {
        s.push(r);
        return;
      }
    }), s;
  }
  getTopLevelNodes() {
    var e;
    return ((e = this.rootNode) == null ? void 0 : e.childrenAfterGroup) ?? null;
  }
  getRow(e) {
    return this.rowsToDisplay[e];
  }
  isRowPresent(e) {
    return this.rowsToDisplay.indexOf(e) >= 0;
  }
  getRowIndexAtPixel(e) {
    const t = this.rowsToDisplay;
    if (this.isEmpty() || t.length === 0)
      return -1;
    let o = 0, n = t.length - 1;
    if (e <= 0)
      return 0;
    if (Ke(t).rowTop <= e)
      return t.length - 1;
    let i = -1, r = -1;
    for (; ; ) {
      const l = Math.floor((o + n) / 2), a = t[l];
      if (this.isRowInPixel(a, e) || (a.rowTop < e ? o = l + 1 : a.rowTop > e && (n = l - 1), i === o && r === n))
        return l;
      i = o, r = n;
    }
  }
  isRowInPixel(e, t) {
    const o = e.rowTop, n = e.rowTop + e.rowHeight;
    return o <= t && n > t;
  }
  forEachLeafNode(e) {
    var t, o;
    (o = (t = this.rootNode) == null ? void 0 : t.allLeafChildren) == null || o.forEach((n, s) => e(n, s));
  }
  forEachNode(e, t = !1) {
    this.depthFirstSearchRowNodes(e, t);
  }
  forEachDisplayedNode(e) {
    this.rowsToDisplay.forEach(e);
  }
  forEachNodeAfterFilter(e, t = !1) {
    this.depthFirstSearchRowNodes(e, t, (o) => o.childrenAfterAggFilter);
  }
  forEachNodeAfterFilterAndSort(e, t = !1) {
    this.depthFirstSearchRowNodes(e, t, (o) => o.childrenAfterSort);
  }
  forEachPivotNode(e, t = !1, o = !1) {
    const { colModel: n, rowGroupColsSvc: s } = this.beans;
    if (!n.isPivotMode())
      return;
    if (!(s != null && s.columns.length)) {
      e(this.rootNode, 0);
      return;
    }
    const i = o ? "childrenAfterSort" : "childrenAfterGroup";
    this.depthFirstSearchRowNodes(
      e,
      t,
      (r) => r.leafGroup ? null : r[i]
    );
  }
  /**
   * Iterate through each node and all of its children
   * @param callback the function to execute for each node
   * @param includeFooterNodes whether to also iterate over footer nodes
   * @param nodes the nodes to start iterating over
   * @param getChildren a function to determine the recursion strategy
   * @param startIndex the index to start from
   * @returns the index ended at
   */
  depthFirstSearchRowNodes(e, t = !1, o = (i) => i.childrenAfterGroup, n = this.rootNode, s = 0) {
    let i = s;
    if (!n)
      return i;
    const r = n === this.rootNode;
    r || e(n, i++);
    const { footerSvc: l } = this.beans;
    if (n.hasChildren() && !n.footer) {
      const a = o(n);
      if (a) {
        i = (l == null ? void 0 : l.addTotalRows(i, n, e, t, r, "top")) ?? i;
        for (const c of a)
          i = this.depthFirstSearchRowNodes(e, t, o, c, i);
        return (l == null ? void 0 : l.addTotalRows(i, n, e, t, r, "bottom")) ?? i;
      }
    }
    return i;
  }
  // it's possible to recompute the aggregate without doing the other parts
  // + api.refreshClientSideRowModel('aggregate')
  doAggregate(e) {
    var o;
    const t = this.rootNode;
    t && ((o = this.aggStage) == null || o.execute({ rowNode: t, changedPath: e }));
  }
  doFilterAggregates(e) {
    const t = this.rootNode;
    this.filterAggStage ? this.filterAggStage.execute({ rowNode: t, changedPath: e }) : t.childrenAfterAggFilter = t.childrenAfterFilter;
  }
  doSort(e, t) {
    this.sortStage ? this.sortStage.execute({
      rowNode: this.rootNode,
      changedRowNodes: e,
      changedPath: t
    }) : t.forEachChangedNodeDepthFirst((o) => {
      o.childrenAfterSort = o.childrenAfterAggFilter.slice(0), t_(o);
    });
  }
  doRowGrouping(e) {
    var s;
    const t = this.rootNode, o = (s = this.groupStage) == null ? void 0 : s.execute({
      rowNode: t,
      changedRowNodes: e.changedRowNodes,
      changedPath: e.changedPath,
      rowNodesOrderChanged: !!e.rowNodesOrderChanged,
      afterColumnsChanged: !!e.afterColumnsChanged
    });
    if (o !== void 0)
      return o;
    const n = t.sibling;
    return t.childrenAfterGroup = t.allLeafChildren, n && (n.childrenAfterGroup = t.childrenAfterGroup), t.updateHasChildren(), !1;
  }
  doFilter(e) {
    this.filterStage ? this.filterStage.execute({ rowNode: this.rootNode, changedPath: e }) : e.forEachChangedNodeDepthFirst((t) => {
      t.childrenAfterFilter = t.childrenAfterGroup, Py(t);
    }, !0);
  }
  doPivot(e) {
    var t;
    (t = this.pivotStage) == null || t.execute({ rowNode: this.rootNode, changedPath: e });
  }
  getRowNode(e) {
    var n;
    const t = this.nodeManager.getRowNode(e);
    return typeof t == "object" ? t : typeof e == "string" && e.indexOf(Rl) === 0 ? (n = this.groupStage) == null ? void 0 : n.getNode(e) : void 0;
  }
  batchUpdateRowData(e, t) {
    if (this.applyAsyncTransactionsTimeout == null) {
      this.rowDataTransactionBatch = [];
      const o = this.gos.get("asyncTransactionWaitMillis");
      this.applyAsyncTransactionsTimeout = window.setTimeout(() => {
        this.isAlive() && this.executeBatchUpdateRowData();
      }, o);
    }
    this.rowDataTransactionBatch.push({ rowDataTransaction: e, callback: t });
  }
  flushAsyncTransactions() {
    this.applyAsyncTransactionsTimeout != null && (clearTimeout(this.applyAsyncTransactionsTimeout), this.executeBatchUpdateRowData());
  }
  executeBatchUpdateRowData() {
    var s, i;
    (s = this.valueCache) == null || s.onDataChanged();
    const e = [], t = [], o = new S0();
    let n = !1;
    (i = this.rowDataTransactionBatch) == null || i.forEach((r) => {
      this.rowNodesCountReady = !0;
      const { rowNodeTransaction: l, rowsInserted: a } = this.nodeManager.updateRowData(
        r.rowDataTransaction,
        o
      );
      a && (n = !0), t.push(l), r.callback && e.push(r.callback.bind(null, l));
    }), this.commitTransactions(n, o), e.length > 0 && window.setTimeout(() => {
      e.forEach((r) => r());
    }, 0), t.length > 0 && this.eventSvc.dispatchEvent({
      type: "asyncTransactionsFlushed",
      results: t
    }), this.rowDataTransactionBatch = null, this.applyAsyncTransactionsTimeout = void 0;
  }
  /**
   * Used to apply transaction changes.
   * Called by gridApi & rowDragFeature
   */
  updateRowData(e) {
    var s;
    (s = this.valueCache) == null || s.onDataChanged(), this.rowNodesCountReady = !0;
    const t = new S0(), { rowNodeTransaction: o, rowsInserted: n } = this.nodeManager.updateRowData(e, t);
    return this.commitTransactions(n, t), o;
  }
  /**
   * Common to:
   * - executeBatchUpdateRowData (batch transactions)
   * - updateRowData (single transaction)
   * - setImmutableRowData (generated transaction)
   *
   * @param rowNodeTrans - the transactions to apply
   * @param orderChanged - whether the order of the rows has changed, either via generated transaction or user provided addIndex
   */
  commitTransactions(e, t) {
    this.refreshModel({
      step: "group",
      rowDataUpdated: !0,
      rowNodesOrderChanged: e,
      keepRenderedRows: !0,
      animate: !this.gos.get("suppressAnimationFrame"),
      changedRowNodes: t,
      changedPath: this.createChangePath(!0)
    });
  }
  doRowsToDisplay() {
    const { flattenStage: e, rootNode: t } = this;
    let o;
    if (e)
      o = e.execute({ rowNode: t });
    else {
      o = (t == null ? void 0 : t.childrenAfterSort) ?? [];
      for (const n of o)
        n.setUiLevel(0);
    }
    this.rowsToDisplay = o;
  }
  onRowHeightChanged() {
    this.refreshModel({
      step: "map",
      keepRenderedRows: !0,
      keepUndoRedoStack: !0
    });
  }
  resetRowHeights() {
    const e = this.rootNode;
    if (!e)
      return;
    const t = this.resetRowHeightsForAllRowNodes();
    e.setRowHeight(e.rowHeight, !0), e.sibling && e.sibling.setRowHeight(e.sibling.rowHeight, !0), t && this.onRowHeightChanged();
  }
  resetRowHeightsForAllRowNodes() {
    let e = !1;
    return this.forEachNode((t) => {
      t.setRowHeight(t.rowHeight, !0);
      const o = t.detailNode;
      o && o.setRowHeight(o.rowHeight, !0), t.sibling && t.sibling.setRowHeight(t.sibling.rowHeight, !0), e = !0;
    }), e;
  }
  onGridStylesChanges(e) {
    var t;
    if (e.rowHeightChanged) {
      if ((t = this.beans.rowAutoHeight) != null && t.active)
        return;
      this.resetRowHeights();
    }
  }
  onGridReady() {
    this.started || this.setInitialData();
  }
  isRowDataLoaded() {
    return this.rowCountReady;
  }
  destroy() {
    super.destroy(), this.started = !1, this.rootNode = null, this.nodeManager = null, this.rowDataTransactionBatch = null, this.orderedStages = bn, this.rowsToDisplay = bn;
  }
  /**
   * @deprecated v33.1
   */
  onRowHeightChangedDebounced() {
    this.onRowHeightChanged_debounced();
  }
};
function YWe(e) {
  var t;
  (t = e.expansionSvc) == null || t.onGroupExpandedOrCollapsed();
}
function QWe(e, t) {
  const o = wn(e);
  o && ((!t || t === "everything") && (t = "group"), o.refreshModel({
    step: t,
    keepRenderedRows: !0,
    animate: !e.gos.get("suppressAnimationFrame")
  }));
}
function JWe(e) {
  var t;
  return ((t = wn(e)) == null ? void 0 : t.isEmpty()) ?? !0;
}
function XWe(e, t) {
  var o;
  (o = wn(e)) == null || o.forEachLeafNode(t);
}
function eUe(e, t) {
  var o;
  (o = wn(e)) == null || o.forEachNodeAfterFilter(t);
}
function tUe(e, t) {
  var o;
  (o = wn(e)) == null || o.forEachNodeAfterFilterAndSort(t);
}
function oUe(e, t) {
  return e.frameworkOverrides.wrapIncoming(
    () => {
      var o;
      return (o = wn(e)) == null ? void 0 : o.updateRowData(t);
    }
  );
}
function nUe(e, t, o) {
  e.frameworkOverrides.wrapIncoming(
    () => {
      var n;
      return (n = wn(e)) == null ? void 0 : n.batchUpdateRowData(t, o);
    }
  );
}
function sUe(e) {
  e.frameworkOverrides.wrapIncoming(() => {
    var t;
    return (t = wn(e)) == null ? void 0 : t.flushAsyncTransactions();
  });
}
function iUe(e) {
  var t;
  return (t = e.selectionSvc) == null ? void 0 : t.getBestCostNodeSelection();
}
var rUe = {
  moduleName: "ClientSideRowModel",
  version: be,
  rowModels: ["clientSide"],
  beans: [zWe, qWe, jWe],
  dependsOn: [xy]
}, lUe = {
  moduleName: "ClientSideRowModelApi",
  version: be,
  apiFunctions: {
    onGroupExpandedOrCollapsed: YWe,
    refreshClientSideRowModel: QWe,
    isRowDataEmpty: JWe,
    forEachLeafNode: XWe,
    forEachNodeAfterFilter: eUe,
    forEachNodeAfterFilterAndSort: tUe,
    applyTransaction: oUe,
    applyTransactionAsync: nUe,
    flushAsyncTransactions: sUe,
    getBestCostNodeSelection: iUe,
    resetRowHeights: e_,
    onRowHeightChanged: Xy
  },
  dependsOn: [BWe, $We]
}, aUe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "gridSerializer";
  }
  wireBeans(e) {
    this.visibleCols = e.visibleCols, this.colModel = e.colModel, this.rowModel = e.rowModel, this.pinnedRowModel = e.pinnedRowModel;
  }
  serialize(e, t = {}) {
    const { allColumns: o, columnKeys: n, skipRowGroups: s, exportRowNumbers: i } = t, r = this.getColumnsToExport({
      allColumns: o,
      skipRowGroups: s,
      columnKeys: n,
      exportRowNumbers: i
    });
    return [
      // first pass, put in the header names of the cols
      this.prepareSession(r),
      this.prependContent(t),
      this.exportColumnGroups(t, r),
      this.exportHeaders(t, r),
      this.processPinnedTopRows(t, r),
      this.processRows(t, r),
      this.processPinnedBottomRows(t, r),
      this.appendContent(t)
    ].reduce((l, a) => a(l), e).parse();
  }
  processRow(e, t, o, n) {
    var C;
    const s = t.shouldRowBeSkipped || (() => !1), r = t.rowPositions != null || !!t.onlySelected, l = this.gos.get("groupHideOpenParents") && !r, a = this.colModel.isPivotMode() ? n.leafGroup : !n.group, c = !!n.footer, d = n.allChildrenCount === 1 && ((C = n.childrenAfterGroup) == null ? void 0 : C.length) === 1 && xIe(this.gos, n);
    if (!a && !c && (t.skipRowGroups || d || l) || t.onlySelected && !n.isSelected() || t.skipPinnedTop && n.rowPinned === "top" || t.skipPinnedBottom && n.rowPinned === "bottom" || n.stub || n.level === -1 && !a && !c || s(Pe(this.gos, { node: n })))
      return;
    const p = e.onNewBodyRow(n);
    if (o.forEach((m, w) => {
      p.onColumn(m, w, n);
    }), t.getCustomContentBelowRow) {
      const m = t.getCustomContentBelowRow(Pe(this.gos, { node: n }));
      m && e.addCustomContent(m);
    }
  }
  appendContent(e) {
    return (t) => {
      const o = e.appendContent;
      return o && t.addCustomContent(o), t;
    };
  }
  prependContent(e) {
    return (t) => {
      const o = e.prependContent;
      return o && t.addCustomContent(o), t;
    };
  }
  prepareSession(e) {
    return (t) => (t.prepare(e), t);
  }
  exportColumnGroups(e, t) {
    return (o) => {
      if (!e.skipColumnGroupHeaders) {
        const n = new Uw(), { colGroupSvc: s } = this.beans, i = s ? s.createColumnGroups({
          columns: t,
          idCreator: n,
          pinned: null,
          isStandaloneStructure: !0
        }) : t;
        this.recursivelyAddHeaderGroups(
          i,
          o,
          e.processGroupHeaderCallback
        );
      }
      return o;
    };
  }
  exportHeaders(e, t) {
    return (o) => {
      if (!e.skipColumnHeaders) {
        const n = o.onNewHeaderRow();
        t.forEach((s, i) => {
          n.onColumn(s, i, void 0);
        });
      }
      return o;
    };
  }
  processPinnedTopRows(e, t) {
    return (o) => {
      var s, i;
      const n = this.processRow.bind(this, o, e, t);
      return e.rowPositions ? e.rowPositions.filter((r) => r.rowPinned === "top").sort((r, l) => r.rowIndex - l.rowIndex).map((r) => {
        var l;
        return (l = this.pinnedRowModel) == null ? void 0 : l.getPinnedTopRow(r.rowIndex);
      }).forEach(n) : (s = this.pinnedRowModel) != null && s.isManual() || (i = this.pinnedRowModel) == null || i.forEachPinnedRow("top", n), o;
    };
  }
  processRows(e, t) {
    return (o) => {
      var c;
      const n = this.rowModel, s = dt(this.gos), i = $n(this.gos), r = !s && e.onlySelected, l = this.processRow.bind(this, o, e, t), { exportedRows: a = "filteredAndSorted" } = e;
      if (e.rowPositions)
        return e.rowPositions.filter((d) => d.rowPinned == null).sort((d, u) => d.rowIndex - u.rowIndex).map((d) => n.getRow(d.rowIndex)).forEach(l), o;
      if (this.colModel.isPivotMode())
        return s ? n.forEachPivotNode(l, !0, a === "filteredAndSorted") : i ? n.forEachNodeAfterFilterAndSort(l, !0) : n.forEachNode(l), o;
      if (e.onlySelectedAllPages || r) {
        const d = ((c = this.beans.selectionSvc) == null ? void 0 : c.getSelectedNodes()) ?? [];
        this.replicateSortedOrder(d), d.forEach(l);
      } else
        a === "all" ? n.forEachNode(l) : s || i ? n.forEachNodeAfterFilterAndSort(l, !0) : n.forEachNode(l);
      return o;
    };
  }
  replicateSortedOrder(e) {
    const { sortSvc: t, rowNodeSorter: o } = this.beans;
    if (!t || !o)
      return;
    const n = t.getSortOptions(), s = (i, r) => {
      var l, a;
      return i.rowIndex != null && r.rowIndex != null ? i.rowIndex - r.rowIndex : i.level === r.level ? ((l = i.parent) == null ? void 0 : l.id) === ((a = r.parent) == null ? void 0 : a.id) ? o.compareRowNodes(
        n,
        {
          rowNode: i,
          currentPos: i.rowIndex ?? -1
        },
        {
          rowNode: r,
          currentPos: r.rowIndex ?? -1
        }
      ) : s(i.parent, r.parent) : i.level > r.level ? s(i.parent, r) : s(i, r.parent);
    };
    e.sort(s);
  }
  processPinnedBottomRows(e, t) {
    return (o) => {
      var s, i;
      const n = this.processRow.bind(this, o, e, t);
      return e.rowPositions ? e.rowPositions.filter((r) => r.rowPinned === "bottom").sort((r, l) => r.rowIndex - l.rowIndex).map((r) => {
        var l;
        return (l = this.pinnedRowModel) == null ? void 0 : l.getPinnedBottomRow(r.rowIndex);
      }).forEach(n) : (s = this.pinnedRowModel) != null && s.isManual() || (i = this.pinnedRowModel) == null || i.forEachPinnedRow("bottom", n), o;
    };
  }
  getColumnsToExport(e) {
    const { allColumns: t = !1, skipRowGroups: o = !1, exportRowNumbers: n = !1, columnKeys: s } = e, { colModel: i, gos: r, visibleCols: l } = this, a = i.isPivotMode(), c = (h) => hs(h) ? !1 : !ns(h) || n;
    if (s && s.length)
      return i.getColsForKeys(s).filter(c);
    const d = r.get("treeData");
    let u = [];
    return t && !a ? u = i.getCols() : u = l.allCols, u = u.filter(
      (h) => c(h) && (o && !d ? !ha(h) : !0)
    ), u;
  }
  recursivelyAddHeaderGroups(e, t, o) {
    const n = [];
    e.forEach((s) => {
      const i = s;
      i.getChildren && i.getChildren().forEach((r) => n.push(r));
    }), e.length > 0 && St(e[0]) && this.doAddHeaderHeader(t, e, o), n && n.length > 0 && this.recursivelyAddHeaderGroups(
      n,
      t,
      o
    );
  }
  doAddHeaderHeader(e, t, o) {
    const n = e.onNewHeaderGroupingRow();
    let s = 0;
    t.forEach((i) => {
      const r = i;
      let l;
      o ? l = o(
        Pe(this.gos, {
          columnGroup: r
        })
      ) : l = this.beans.colNames.getDisplayNameForColumnGroup(r, "header");
      const c = (r.isExpandable() ? r.getLeafColumns() : []).reduce(
        (d, u, h, p) => {
          let C = Ke(d);
          return u.getColumnGroupShow() === "open" ? (!C || C[1] != null) && (C = [h], d.push(C)) : C && C[1] == null && (C[1] = h - 1), h === p.length - 1 && C && C[1] == null && (C[1] = h), d;
        },
        []
      );
      n.onColumn(
        r,
        l || "",
        s++,
        r.getLeafColumns().length - 1,
        c
      );
    });
  }
}, cUe = {
  moduleName: "SharedExport",
  version: be,
  beans: [aUe]
}, Fu = `\r
`, dUe = class extends zNe {
  constructor(e) {
    super(e), this.config = e, this.isFirstLine = !0, this.result = "";
    const { suppressQuotes: t, columnSeparator: o } = e;
    this.suppressQuotes = t, this.columnSeparator = o;
  }
  addCustomContent(e) {
    e && (typeof e == "string" ? (/^\s*\n/.test(e) || this.beginNewLine(), e = e.replace(/\r?\n/g, Fu), this.result += e) : e.forEach((t) => {
      this.beginNewLine(), t.forEach((o, n) => {
        n !== 0 && (this.result += this.columnSeparator), this.result += this.putInQuotes(o.data.value || ""), o.mergeAcross && this.appendEmptyCells(o.mergeAcross);
      });
    }));
  }
  onNewHeaderGroupingRow() {
    return this.beginNewLine(), {
      onColumn: this.onNewHeaderGroupingRowColumn.bind(this)
    };
  }
  onNewHeaderGroupingRowColumn(e, t, o, n) {
    o != 0 && (this.result += this.columnSeparator), this.result += this.putInQuotes(t), this.appendEmptyCells(n);
  }
  appendEmptyCells(e) {
    for (let t = 1; t <= e; t++)
      this.result += this.columnSeparator + this.putInQuotes("");
  }
  onNewHeaderRow() {
    return this.beginNewLine(), {
      onColumn: this.onNewHeaderRowColumn.bind(this)
    };
  }
  onNewHeaderRowColumn(e, t) {
    t != 0 && (this.result += this.columnSeparator), this.result += this.putInQuotes(this.extractHeaderValue(e));
  }
  onNewBodyRow() {
    return this.beginNewLine(), {
      onColumn: this.onNewBodyRowColumn.bind(this)
    };
  }
  onNewBodyRowColumn(e, t, o) {
    t != 0 && (this.result += this.columnSeparator);
    const n = this.extractRowCellValue(e, t, t, "csv", o);
    this.result += this.putInQuotes(n.valueFormatted ?? n.value);
  }
  putInQuotes(e) {
    if (this.suppressQuotes)
      return e;
    if (e == null)
      return '""';
    let t;
    return typeof e == "string" ? t = e : typeof e.toString == "function" ? t = e.toString() : (X(53), t = ""), '"' + t.replace(/"/g, '""') + '"';
  }
  parse() {
    return this.result;
  }
  beginNewLine() {
    this.isFirstLine || (this.result += Fu), this.isFirstLine = !1;
  }
}, uUe = class extends NNe {
  constructor() {
    super(...arguments), this.beanName = "csvCreator";
  }
  wireBeans(e) {
    this.colModel = e.colModel, this.colNames = e.colNames, this.rowGroupColsSvc = e.rowGroupColsSvc, this.valueSvc = e.valueSvc;
  }
  getMergedParams(e) {
    const t = this.gos.get("defaultCsvExportParams");
    return Object.assign({}, t, e);
  }
  export(e) {
    if (this.isExportSuppressed()) {
      X(51);
      return;
    }
    const t = this.getMergedParams(e), o = this.getData(t), n = new Blob(["\uFEFF", o], { type: "text/plain" }), s = typeof t.fileName == "function" ? t.fileName(Pe(this.gos, {})) : t.fileName;
    jNe(this.getFileName(s), n);
  }
  exportDataAsCsv(e) {
    this.export(e);
  }
  getDataAsCsv(e, t = !1) {
    const o = t ? Object.assign({}, e) : this.getMergedParams(e);
    return this.getData(o);
  }
  getDefaultFileExtension() {
    return "csv";
  }
  createSerializingSession(e) {
    const { colModel: t, colNames: o, rowGroupColsSvc: n, valueSvc: s, gos: i } = this, {
      processCellCallback: r,
      processHeaderCallback: l,
      processGroupHeaderCallback: a,
      processRowGroupCallback: c,
      suppressQuotes: d,
      columnSeparator: u
    } = e;
    return new dUe({
      colModel: t,
      colNames: o,
      valueSvc: s,
      gos: i,
      processCellCallback: r || void 0,
      processHeaderCallback: l || void 0,
      processGroupHeaderCallback: a || void 0,
      processRowGroupCallback: c || void 0,
      suppressQuotes: d || !1,
      columnSeparator: u || ",",
      rowGroupColsSvc: n
    });
  }
  isExportSuppressed() {
    return this.gos.get("suppressCsvExport");
  }
};
function hUe(e, t) {
  var o;
  return (o = e.csvCreator) == null ? void 0 : o.getDataAsCsv(t);
}
function gUe(e, t) {
  var o;
  (o = e.csvCreator) == null || o.exportDataAsCsv(t);
}
var pUe = {
  moduleName: "CsvExport",
  version: be,
  beans: [uUe],
  apiFunctions: {
    getDataAsCsv: hUe,
    exportDataAsCsv: gUe
  },
  dependsOn: [cUe]
}, fUe = class extends K {
  constructor(e, t, o) {
    super(), this.id = e, this.parentCache = t, this.params = o, this.state = "needsLoading", this.version = 0, this.startRow = e * o.blockSize, this.endRow = this.startRow + o.blockSize;
  }
  load() {
    this.state = "loading", this.loadFromDatasource();
  }
  setStateWaitingToLoad() {
    this.version++, this.state = "needsLoading";
  }
  pageLoadFailed(e) {
    this.isRequestMostRecentAndLive(e) && (this.state = "failed"), this.dispatchLocalEvent({ type: "loadComplete" });
  }
  pageLoaded(e, t, o) {
    this.successCommon(e, { rowData: t, rowCount: o });
  }
  isRequestMostRecentAndLive(e) {
    const t = e === this.version, o = this.isAlive();
    return t && o;
  }
  successCommon(e, t) {
    this.dispatchLocalEvent({ type: "loadComplete" }), this.isRequestMostRecentAndLive(e) && (this.state = "loaded", this.processServerResult(t));
  }
  postConstruct() {
    this.rowNodes = [];
    const {
      params: { blockSize: e, rowHeight: t },
      startRow: o,
      beans: n,
      rowNodes: s
    } = this;
    for (let i = 0; i < e; i++) {
      const r = o + i, l = new pn(n);
      l.setRowHeight(t), l.uiLevel = 0, l.setRowIndex(r), l.setRowTop(t * r), s.push(l);
    }
  }
  getBlockStateJson() {
    const { id: e, startRow: t, endRow: o, state: n } = this;
    return {
      id: "" + e,
      state: {
        blockNumber: e,
        startRow: t,
        endRow: o,
        pageStatus: n
      }
    };
  }
  setDataAndId(e, t, o) {
    ue(t) ? e.setDataAndId(t, o.toString()) : e.setDataAndId(void 0, void 0);
  }
  loadFromDatasource() {
    const e = this.createLoadParams();
    if (Xe(this.params.datasource.getRows)) {
      X(90);
      return;
    }
    window.setTimeout(() => {
      this.params.datasource.getRows(e);
    }, 0);
  }
  createLoadParams() {
    const {
      startRow: e,
      endRow: t,
      version: o,
      params: { sortModel: n, filterModel: s },
      gos: i
    } = this;
    return {
      startRow: e,
      endRow: t,
      successCallback: this.pageLoaded.bind(this, o),
      failCallback: this.pageLoadFailed.bind(this, o),
      sortModel: n,
      filterModel: s,
      context: Pe(i, {}).context
    };
  }
  forEachNode(e, t, o) {
    this.rowNodes.forEach((n, s) => {
      this.startRow + s < o && e(n, t.value++);
    });
  }
  getRow(e, t = !1) {
    t || (this.lastAccessed = this.params.lastAccessedSequence.value++);
    const o = e - this.startRow;
    return this.rowNodes[o];
  }
  processServerResult(e) {
    const { rowNodes: t, beans: o } = this;
    t.forEach((s, i) => {
      const r = e.rowData ? e.rowData[i] : void 0;
      !s.id && s.alreadyRendered && r && (t[i] = new pn(o), t[i].setRowIndex(s.rowIndex), t[i].setRowTop(s.rowTop), t[i].setRowHeight(s.rowHeight), s.clearRowTopAndRowIndex()), this.setDataAndId(t[i], r, this.startRow + i);
    });
    const n = e.rowCount != null && e.rowCount >= 0 ? e.rowCount : void 0;
    this.parentCache.pageLoaded(this, n);
  }
  destroy() {
    this.rowNodes.forEach((e) => {
      e.clearRowTopAndRowIndex();
    }), super.destroy();
  }
}, vUe = 2, mUe = class extends K {
  constructor(e) {
    super(), this.params = e, this.lastRowIndexKnown = !1, this.blocks = {}, this.blockCount = 0, this.rowCount = e.initialRowCount;
  }
  // the rowRenderer will not pass dontCreatePage, meaning when rendering the grid,
  // it will want new pages in the cache as it asks for rows. only when we are inserting /
  // removing rows via the api is dontCreatePage set, where we move rows between the pages.
  getRow(e, t = !1) {
    const o = Math.floor(e / this.params.blockSize);
    let n = this.blocks[o];
    if (!n) {
      if (t)
        return;
      n = this.createBlock(o);
    }
    return n.getRow(e);
  }
  createBlock(e) {
    const t = this.params, o = this.createBean(new fUe(e, this, t));
    return this.blocks[o.id] = o, this.blockCount++, this.purgeBlocksIfNeeded(o), t.rowNodeBlockLoader.addBlock(o), o;
  }
  // we have this on infinite row model only, not server side row model,
  // because for server side, it would leave the children in inconsistent
  // state - eg if a node had children, but after the refresh it had data
  // for a different row, then the children would be with the wrong row node.
  refreshCache() {
    if (this.blockCount == 0) {
      this.purgeCache();
      return;
    }
    this.getBlocksInOrder().forEach((t) => t.setStateWaitingToLoad()), this.params.rowNodeBlockLoader.checkBlockToLoad();
  }
  destroy() {
    this.getBlocksInOrder().forEach((e) => this.destroyBlock(e)), super.destroy();
  }
  getRowCount() {
    return this.rowCount;
  }
  isLastRowIndexKnown() {
    return this.lastRowIndexKnown;
  }
  // block calls this, when page loaded
  pageLoaded(e, t) {
    this.isAlive() && (cs(this.gos, `InfiniteCache - onPageLoaded: page = ${e.id}, lastRow = ${t}`), this.checkRowCount(e, t), this.onCacheUpdated());
  }
  purgeBlocksIfNeeded(e) {
    const t = this.getBlocksInOrder().filter((r) => r != e), o = (r, l) => l.lastAccessed - r.lastAccessed;
    t.sort(o);
    const n = this.params.maxBlocksInCache > 0, s = n ? this.params.maxBlocksInCache - 1 : null, i = vUe - 1;
    t.forEach((r, l) => {
      const a = r.state === "needsLoading" && l >= i, c = n ? l >= s : !1;
      if (a || c) {
        if (this.isBlockCurrentlyDisplayed(r) || this.isBlockFocused(r))
          return;
        this.removeBlockFromCache(r);
      }
    });
  }
  isBlockFocused(e) {
    const t = this.beans.focusSvc.getFocusCellToUseAfterRefresh();
    if (!t || t.rowPinned != null)
      return !1;
    const { startRow: o, endRow: n } = e;
    return t.rowIndex >= o && t.rowIndex < n;
  }
  isBlockCurrentlyDisplayed(e) {
    const { startRow: t, endRow: o } = e;
    return this.beans.rowRenderer.isRangeInRenderedViewport(t, o - 1);
  }
  removeBlockFromCache(e) {
    e && this.destroyBlock(e);
  }
  checkRowCount(e, t) {
    if (typeof t == "number" && t >= 0)
      this.rowCount = t, this.lastRowIndexKnown = !0;
    else if (!this.lastRowIndexKnown) {
      const { blockSize: o, overflowSize: n } = this.params, i = (e.id + 1) * o + n;
      this.rowCount < i && (this.rowCount = i);
    }
  }
  setRowCount(e, t) {
    this.rowCount = e, ue(t) && (this.lastRowIndexKnown = t), this.lastRowIndexKnown || this.rowCount % this.params.blockSize === 0 && this.rowCount++, this.onCacheUpdated();
  }
  forEachNodeDeep(e) {
    const t = { value: 0 };
    this.getBlocksInOrder().forEach((o) => o.forEachNode(e, t, this.rowCount));
  }
  getBlocksInOrder() {
    const e = (o, n) => o.id - n.id;
    return Object.values(this.blocks).sort(e);
  }
  destroyBlock(e) {
    delete this.blocks[e.id], this.destroyBean(e), this.blockCount--, this.params.rowNodeBlockLoader.removeBlock(e);
  }
  // gets called 1) row count changed 2) cache purged 3) items inserted
  onCacheUpdated() {
    this.isAlive() && (this.destroyAllBlocksPastVirtualRowCount(), this.eventSvc.dispatchEvent({
      type: "storeUpdated"
    }));
  }
  destroyAllBlocksPastVirtualRowCount() {
    const e = [];
    this.getBlocksInOrder().forEach((t) => {
      t.id * this.params.blockSize >= this.rowCount && e.push(t);
    }), e.length > 0 && e.forEach((t) => this.destroyBlock(t));
  }
  purgeCache() {
    this.getBlocksInOrder().forEach((e) => this.removeBlockFromCache(e)), this.lastRowIndexKnown = !1, this.rowCount === 0 && (this.rowCount = this.params.initialRowCount), this.onCacheUpdated();
  }
  getRowNodesInRange(e, t) {
    const o = [];
    let n = -1, s = !1;
    const i = { value: 0 };
    let r = !1;
    return this.getBlocksInOrder().forEach((a) => {
      if (!r) {
        if (s && n + 1 !== a.id) {
          r = !0;
          return;
        }
        n = a.id, a.forEachNode(
          (c) => {
            const d = c === e || c === t;
            (s || d) && o.push(c), d && (s = !s);
          },
          i,
          this.rowCount
        );
      }
    }), r || s ? [] : o;
  }
}, CUe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "rowModel";
  }
  getRowBounds(e) {
    return {
      rowHeight: this.rowHeight,
      rowTop: this.rowHeight * e
    };
  }
  // we don't implement as lazy row heights is not supported in this row model
  ensureRowHeightsValid() {
    return !1;
  }
  postConstruct() {
    this.gos.get("rowModelType") === "infinite" && (this.rowHeight = Vs(this.beans), this.addEventListeners(), this.addDestroyFunc(() => this.destroyCache()));
  }
  start() {
    this.setDatasource(this.gos.get("datasource"));
  }
  destroy() {
    this.destroyDatasource(), super.destroy();
  }
  destroyDatasource() {
    this.datasource && (this.destroyBean(this.datasource), this.beans.rowRenderer.datasourceChanged(), this.datasource = null);
  }
  addEventListeners() {
    this.addManagedEventListeners({
      filterChanged: this.reset.bind(this),
      sortChanged: this.reset.bind(this),
      newColumnsLoaded: this.onColumnEverything.bind(this),
      storeUpdated: this.dispatchModelUpdatedEvent.bind(this)
    }), this.addManagedPropertyListener("datasource", () => this.setDatasource(this.gos.get("datasource"))), this.addManagedPropertyListener("cacheBlockSize", () => this.resetCache()), this.addManagedPropertyListener("rowHeight", () => {
      this.rowHeight = Vs(this.beans), this.cacheParams.rowHeight = this.rowHeight, this.updateRowHeights();
    });
  }
  onColumnEverything() {
    var t;
    let e;
    this.cacheParams ? e = !Zr(this.cacheParams.sortModel, ((t = this.beans.sortSvc) == null ? void 0 : t.getSortModel()) ?? []) : e = !0, e && this.reset();
  }
  getType() {
    return "infinite";
  }
  setDatasource(e) {
    this.destroyDatasource(), this.datasource = e, e && this.reset();
  }
  isEmpty() {
    return !this.infiniteCache;
  }
  isRowsToRender() {
    return !!this.infiniteCache;
  }
  getNodesInRangeForSelection(e, t) {
    var o;
    return ((o = this.infiniteCache) == null ? void 0 : o.getRowNodesInRange(e, t)) ?? [];
  }
  reset() {
    var o;
    if (!this.datasource)
      return;
    Qs(this.gos) != null || (o = this.beans.selectionSvc) == null || o.reset("rowDataChanged"), this.resetCache();
  }
  dispatchModelUpdatedEvent() {
    this.eventSvc.dispatchEvent({
      type: "modelUpdated",
      // not sure if these should all be false - noticed if after implementing,
      // maybe they should be true?
      newPage: !1,
      newPageSize: !1,
      newData: !1,
      keepRenderedRows: !0,
      animate: !1
    });
  }
  resetCache() {
    this.destroyCache();
    const e = this.beans, { filterManager: t, sortSvc: o, rowNodeBlockLoader: n, eventSvc: s, gos: i } = e;
    this.cacheParams = {
      // the user provided datasource
      datasource: this.datasource,
      // sort and filter model
      filterModel: (t == null ? void 0 : t.getFilterModel()) ?? {},
      sortModel: (o == null ? void 0 : o.getSortModel()) ?? [],
      rowNodeBlockLoader: n,
      // properties - this way we take a snapshot of them, so if user changes any, they will be
      // used next time we create a new cache, which is generally after a filter or sort change,
      // or a new datasource is set
      initialRowCount: i.get("infiniteInitialRowCount"),
      maxBlocksInCache: i.get("maxBlocksInCache"),
      rowHeight: Vs(e),
      // if user doesn't provide overflow, we use default overflow of 1, so user can scroll past
      // the current page and request first row of next page
      overflowSize: i.get("cacheOverflowSize"),
      // page size needs to be 1 or greater. having it at 1 would be silly, as you would be hitting the
      // server for one page at a time. so the default if not specified is 100.
      blockSize: i.get("cacheBlockSize"),
      // the cache could create this, however it is also used by the pages, so handy to create it
      // here as the settings are also passed to the pages
      lastAccessedSequence: { value: 0 }
    }, this.infiniteCache = this.createBean(new mUe(this.cacheParams)), s.dispatchEventOnce({
      type: "rowCountReady"
    }), this.dispatchModelUpdatedEvent();
  }
  updateRowHeights() {
    this.forEachNode((e) => {
      e.setRowHeight(this.rowHeight), e.setRowTop(this.rowHeight * e.rowIndex);
    }), this.dispatchModelUpdatedEvent();
  }
  destroyCache() {
    this.infiniteCache = this.destroyBean(this.infiniteCache);
  }
  getRow(e) {
    const t = this.infiniteCache;
    if (t && !(e >= t.getRowCount()))
      return t.getRow(e);
  }
  getRowNode(e) {
    let t;
    return this.forEachNode((o) => {
      o.id === e && (t = o);
    }), t;
  }
  forEachNode(e) {
    var t;
    (t = this.infiniteCache) == null || t.forEachNodeDeep(e);
  }
  getTopLevelRowCount() {
    return this.getRowCount();
  }
  getTopLevelRowDisplayedIndex(e) {
    return e;
  }
  getRowIndexAtPixel(e) {
    if (this.rowHeight !== 0) {
      const t = Math.floor(e / this.rowHeight), o = this.getRowCount() - 1;
      return t > o ? o : t;
    }
    return 0;
  }
  getRowCount() {
    return this.infiniteCache ? this.infiniteCache.getRowCount() : 0;
  }
  isRowPresent(e) {
    return !!this.getRowNode(e.id);
  }
  refreshCache() {
    var e;
    (e = this.infiniteCache) == null || e.refreshCache();
  }
  purgeCache() {
    var e;
    (e = this.infiniteCache) == null || e.purgeCache();
  }
  // for iRowModel
  isLastRowIndexKnown() {
    var e;
    return ((e = this.infiniteCache) == null ? void 0 : e.isLastRowIndexKnown()) ?? !1;
  }
  setRowCount(e, t) {
    var o;
    (o = this.infiniteCache) == null || o.setRowCount(e, t);
  }
  resetRowHeights() {
  }
  onRowHeightChanged() {
  }
};
function wUe(e) {
  var t;
  (t = _a(e)) == null || t.refreshCache();
}
function bUe(e) {
  var t;
  (t = _a(e)) == null || t.purgeCache();
}
function yUe(e) {
  var t;
  return (t = _a(e)) == null ? void 0 : t.getRowCount();
}
var _Ue = class extends K {
  constructor() {
    super(...arguments), this.beanName = "rowNodeBlockLoader", this.activeBlockLoadsCount = 0, this.blocks = [], this.active = !0;
  }
  postConstruct() {
    this.maxConcurrentRequests = MIe(this.gos);
    const e = this.gos.get("blockLoadDebounceMillis");
    e && e > 0 && (this.checkBlockToLoadDebounce = Rt(
      this,
      this.performCheckBlocksToLoad.bind(this),
      e
    ));
  }
  addBlock(e) {
    this.blocks.push(e), e.addEventListener("loadComplete", this.loadComplete.bind(this)), this.checkBlockToLoad();
  }
  removeBlock(e) {
    Zt(this.blocks, e);
  }
  destroy() {
    super.destroy(), this.active = !1;
  }
  loadComplete() {
    this.activeBlockLoadsCount--, this.checkBlockToLoad();
  }
  checkBlockToLoad() {
    this.checkBlockToLoadDebounce ? this.checkBlockToLoadDebounce() : this.performCheckBlocksToLoad();
  }
  performCheckBlocksToLoad() {
    if (!this.active)
      return;
    if (this.printCacheStatus(), this.maxConcurrentRequests != null && this.activeBlockLoadsCount >= this.maxConcurrentRequests) {
      cs(this.gos, "RowNodeBlockLoader - checkBlockToLoad: max loads exceeded");
      return;
    }
    const e = this.maxConcurrentRequests != null ? this.maxConcurrentRequests - this.activeBlockLoadsCount : 1, t = this.blocks.filter((o) => o.state === "needsLoading").slice(0, e);
    this.activeBlockLoadsCount += t.length, t.forEach((o) => o.load()), this.printCacheStatus();
  }
  getBlockState() {
    const e = {};
    return this.blocks.forEach((t) => {
      const { id: o, state: n } = t.getBlockStateJson();
      e[o] = n;
    }), e;
  }
  printCacheStatus() {
    cs(
      this.gos,
      `RowNodeBlockLoader - printCacheStatus: activePageLoadsCount = ${this.activeBlockLoadsCount}, blocks = ${JSON.stringify(this.getBlockState())}`
    );
  }
}, SUe = {
  moduleName: "InfiniteRowModelCore",
  version: be,
  rowModels: ["infinite"],
  beans: [CUe, _Ue]
}, xUe = {
  moduleName: "InfiniteRowModel",
  version: be,
  apiFunctions: {
    refreshInfiniteCache: wUe,
    purgeInfiniteCache: bUe,
    getInfiniteRowCount: yUe
  },
  dependsOn: [SUe, ZWe]
}, MUe = "↑", AUe = "↓", LUe = {
  tag: "span",
  children: [
    { tag: "span", ref: "eDelta", cls: "ag-value-change-delta" },
    { tag: "span", ref: "eValue", cls: "ag-value-change-value" }
  ]
}, EUe = class extends Re {
  constructor() {
    super(LUe), this.eValue = J, this.eDelta = J, this.refreshCount = 0;
  }
  init(e) {
    this.refresh(e, !0);
  }
  showDelta(e, t) {
    const o = Math.abs(t), n = e.formatValue(o), s = ue(n) ? n : o, i = t >= 0, r = this.eDelta;
    i ? r.textContent = MUe + s : r.textContent = AUe + s, r.classList.toggle("ag-value-change-delta-up", i), r.classList.toggle("ag-value-change-delta-down", !i);
  }
  setTimerToRemoveDelta() {
    this.refreshCount++;
    const e = this.refreshCount;
    this.beans.frameworkOverrides.wrapIncoming(() => {
      window.setTimeout(() => {
        e === this.refreshCount && this.hideDeltaValue();
      }, 2e3);
    });
  }
  hideDeltaValue() {
    this.eValue.classList.remove("ag-value-change-value-highlight"), it(this.eDelta);
  }
  refresh(e, t = !1) {
    var c;
    const { value: o, valueFormatted: n } = e, { eValue: s, lastValue: i, beans: r } = this;
    if (o === i || (ue(n) ? s.textContent = n : ue(o) ? s.textContent = o : it(s), (c = r.filterManager) != null && c.isSuppressFlashingCellsBecauseFiltering()))
      return !1;
    const l = o && typeof o == "object" && "toNumber" in o ? o.toNumber() : o, a = i && typeof i == "object" && "toNumber" in i ? i.toNumber() : i;
    if (l === a)
      return !1;
    if (typeof l == "number" && typeof a == "number") {
      const d = l - a;
      this.showDelta(e, d);
    }
    return i && s.classList.add("ag-value-change-value-highlight"), t || this.setTimerToRemoveDelta(), this.lastValue = o, !0;
  }
}, PUe = (
  /*css*/
  ".ag-value-slide-out{opacity:1}:where(.ag-ltr) .ag-value-slide-out{margin-right:5px;transition:opacity 3s,margin-right 3s}:where(.ag-rtl) .ag-value-slide-out{margin-left:5px;transition:opacity 3s,margin-left 3s}:where(.ag-ltr,.ag-rtl) .ag-value-slide-out{transition-timing-function:linear}.ag-value-slide-out-end{opacity:0}:where(.ag-ltr) .ag-value-slide-out-end{margin-right:10px}:where(.ag-rtl) .ag-value-slide-out-end{margin-left:10px}"
), RUe = {
  tag: "span",
  children: [{ tag: "span", ref: "eCurrent", cls: "ag-value-slide-current" }]
}, FUe = class extends Re {
  constructor() {
    super(RUe), this.eCurrent = J, this.refreshCount = 0, this.registerCSS(PUe);
  }
  init(e) {
    this.refresh(e, !0);
  }
  addSlideAnimation() {
    this.refreshCount++;
    const e = this.refreshCount;
    this.ePrevious && this.getGui().removeChild(this.ePrevious);
    const { beans: t, eCurrent: o } = this, n = ze({ tag: "span", cls: "ag-value-slide-previous ag-value-slide-out" });
    this.ePrevious = n, n.textContent = o.textContent, this.getGui().insertBefore(n, o), t.frameworkOverrides.wrapIncoming(() => {
      window.setTimeout(() => {
        e === this.refreshCount && this.ePrevious.classList.add("ag-value-slide-out-end");
      }, 50), window.setTimeout(() => {
        e === this.refreshCount && (this.getGui().removeChild(this.ePrevious), this.ePrevious = null);
      }, 3e3);
    });
  }
  refresh(e, t = !1) {
    var s;
    let o = e.value;
    if (Xe(o) && (o = ""), o === this.lastValue || (s = this.beans.filterManager) != null && s.isSuppressFlashingCellsBecauseFiltering())
      return !1;
    t || this.addSlideAnimation(), this.lastValue = o;
    const n = this.eCurrent;
    return ue(e.valueFormatted) ? n.textContent = e.valueFormatted : ue(e.value) ? n.textContent = o : it(n), !0;
  }
}, TUe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "cellFlashSvc", this.nextAnimationTime = null, this.nextAnimationCycle = null, this.animations = {
      highlight: /* @__PURE__ */ new Map(),
      "data-changed": /* @__PURE__ */ new Map()
    };
  }
  animateCell(e, t, o = this.beans.gos.get("cellFlashDuration"), n = this.beans.gos.get("cellFadeDuration")) {
    const s = this.animations[t];
    s.delete(e);
    const i = Date.now(), r = i + o, l = i + o + n, a = {
      phase: "flash",
      flashEndTime: r,
      fadeEndTime: l
    };
    s.set(e, a);
    const c = `ag-cell-${t}`, d = `${c}-animation`, {
      comp: u,
      eGui: { style: h }
    } = e;
    u.toggleCss(c, !0), u.toggleCss(d, !1), h.removeProperty("transition"), h.removeProperty("transition-delay"), this.nextAnimationTime && r + 15 < this.nextAnimationTime && (clearTimeout(this.nextAnimationCycle), this.nextAnimationCycle = null, this.nextAnimationTime = null), this.nextAnimationCycle || (this.beans.frameworkOverrides.wrapIncoming(() => {
      this.nextAnimationCycle = setTimeout(this.advanceAnimations.bind(this), o);
    }), this.nextAnimationTime = r);
  }
  advanceAnimations() {
    const e = Date.now();
    let t = null;
    for (const o of Object.keys(this.animations)) {
      const n = this.animations[o], s = `ag-cell-${o}`, i = `${s}-animation`;
      for (const [r, l] of n) {
        if (!r.isAlive() || !r.comp) {
          n.delete(r);
          continue;
        }
        const { phase: a, flashEndTime: c, fadeEndTime: d } = l, u = a === "flash" ? c : d;
        if (!(e + 15 >= u)) {
          t = Math.min(u, t ?? 1 / 0);
          continue;
        }
        const {
          comp: p,
          eGui: { style: C }
        } = r;
        switch (a) {
          case "flash":
            p.toggleCss(s, !1), p.toggleCss(i, !0), C.transition = `background-color ${d - c}ms`, C.transitionDelay = `${c - e}ms`, t = Math.min(d, t ?? 1 / 0), l.phase = "fade";
            break;
          case "fade":
            p.toggleCss(s, !1), p.toggleCss(i, !1), C.removeProperty("transition"), C.removeProperty("transition-delay"), n.delete(r);
            break;
        }
      }
    }
    t == null ? (this.nextAnimationTime = null, this.nextAnimationCycle = null) : t && (this.nextAnimationCycle = setTimeout(this.advanceAnimations.bind(this), t - e), this.nextAnimationTime = t);
  }
  onFlashCells(e, t) {
    if (!e.comp)
      return;
    const o = EOe(e.cellPosition);
    t.cells[o] && this.animateCell(e, "highlight");
  }
  flashCell(e, t) {
    this.animateCell(e, "data-changed", t == null ? void 0 : t.flashDuration, t == null ? void 0 : t.fadeDuration);
  }
  destroy() {
    for (const e of Object.keys(this.animations))
      this.animations[e].clear();
  }
};
function IUe(e, t = {}) {
  const { cellFlashSvc: o } = e;
  o && e.frameworkOverrides.wrapIncoming(() => {
    e.rowRenderer.getCellCtrls(t.rowNodes, t.columns).forEach((n) => o.flashCell(n, t));
  });
}
var DUe = {
  moduleName: "HighlightChanges",
  version: be,
  beans: [TUe],
  userComponents: {
    agAnimateShowChangeCellRenderer: EUe,
    agAnimateSlideCellRenderer: FUe
  },
  apiFunctions: {
    flashCells: IUe
  }
};
function kUe(e) {
  var t;
  return ((t = e.stateSvc) == null ? void 0 : t.getState()) ?? {};
}
function HUe(e, t, o) {
  var n;
  return (n = e.stateSvc) == null ? void 0 : n.setState(t, o);
}
function Tu(e) {
  switch (e = { ...e }, e.version || (e.version = "32.1.0"), e.version) {
    case "32.1.0":
      e = VUe(e);
  }
  return e.version = be, e;
}
function VUe(e) {
  return e.cellSelection = OUe(e, "rangeSelection"), e;
}
function OUe(e, t) {
  if (e && typeof e == "object")
    return e[t];
}
var BUe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "stateSvc", this.updateRowGroupExpansionStateTimer = 0, this.suppressEvents = !0, this.queuedUpdateSources = /* @__PURE__ */ new Set(), this.dispatchStateUpdateEventDebounced = Rt(this, () => this.dispatchQueuedStateUpdateEvents(), 0), this.onRowGroupOpenedDebounced = Rt(
      this,
      () => {
        this.beans.gos.get("ssrmExpandAllAffectsAllRows") ? (this.updateCachedState("ssrmRowGroupExpansion", this.getRowGroupExpansionState()), this.updateCachedState("rowGroupExpansion", void 0)) : (this.updateCachedState("rowGroupExpansion", this.getRowGroupExpansionState()), this.updateCachedState("ssrmRowGroupExpansion", void 0));
      },
      0
    ), this.onRowSelectedDebounced = Rt(
      this,
      () => {
        this.staleStateKeys.delete("rowSelection"), this.updateCachedState("rowSelection", this.getRowSelectionState());
      },
      0
    ), this.staleStateKeys = /* @__PURE__ */ new Set();
  }
  postConstruct() {
    const { gos: e, ctrlsSvc: t, colDelayRenderSvc: o } = this.beans;
    this.isClientSideRowModel = dt(e);
    const n = Tu(e.get("initialState") ?? {}), s = n.partialColumnState;
    delete n.partialColumnState, this.cachedState = n;
    const i = this.suppressEventsAndDispatchInitEvent.bind(this);
    t.whenReady(
      this,
      () => i(() => this.setupStateOnGridReady(n))
    ), (n.columnOrder || n.columnVisibility || n.columnSizing || n.columnPinning || n.columnGroup) && (o == null || o.hideColumns("columnState"));
    const [r, l, a] = this.addManagedEventListeners({
      newColumnsLoaded: ({ source: c }) => {
        c === "gridInitializing" && (r(), i(() => {
          this.setupStateOnColumnsInitialised(n, !!s), o == null || o.revealColumns("columnState");
        }));
      },
      rowCountReady: () => {
        l == null || l(), i(() => this.setupStateOnRowCountReady(n));
      },
      firstDataRendered: () => {
        a == null || a(), i(() => this.setupStateOnFirstDataRendered(n));
      }
    });
  }
  destroy() {
    super.destroy(), clearTimeout(this.updateRowGroupExpansionStateTimer), this.queuedUpdateSources.clear();
  }
  getState() {
    return this.staleStateKeys.size && this.refreshStaleState(), this.cachedState;
  }
  setState(e, t) {
    const o = Tu(e);
    delete o.partialColumnState, this.cachedState = o, this.startSuppressEvents();
    const n = "api", s = t ? new Set(t) : void 0;
    this.setGridReadyState(o, n, s), this.setColumnsInitialisedState(o, n, !1, s), this.setRowCountState(o, n, s), setTimeout(() => {
      this.isAlive() && this.setFirstDataRenderedState(o, n, s), this.stopSuppressEvents(n);
    });
  }
  setGridReadyState(e, t, o) {
    var n, s;
    t === "api" && !(o != null && o.has("sideBar")) && ((s = (n = this.beans.sideBar) == null ? void 0 : n.comp) == null || s.setState(e.sideBar)), this.updateCachedState("sideBar", this.getSideBarState());
  }
  setupStateOnGridReady(e) {
    this.setGridReadyState(e, "gridInitializing");
    const t = () => this.updateCachedState("sideBar", this.getSideBarState());
    this.addManagedEventListeners({
      toolPanelVisibleChanged: t,
      sideBarUpdated: t
    });
  }
  updateColumnAndGroupState() {
    this.updateColumnState([
      "aggregation",
      "columnOrder",
      "columnPinning",
      "columnSizing",
      "columnVisibility",
      "pivot",
      "rowGroup",
      "sort"
    ]), this.updateCachedState("columnGroup", this.getColumnGroupState());
  }
  setColumnsInitialisedState(e, t, o, n) {
    this.setColumnState(e, t, o, n), this.setColumnGroupState(e, t, n), this.updateColumnAndGroupState();
  }
  setupStateOnColumnsInitialised(e, t) {
    this.setColumnsInitialisedState(e, "gridInitializing", t);
    const o = (n) => () => this.updateColumnState([n]);
    this.addManagedEventListeners({
      columnValueChanged: o("aggregation"),
      columnMoved: o("columnOrder"),
      columnPinned: o("columnPinning"),
      columnResized: o("columnSizing"),
      columnVisible: o("columnVisibility"),
      columnPivotChanged: o("pivot"),
      columnPivotModeChanged: o("pivot"),
      columnRowGroupChanged: o("rowGroup"),
      sortChanged: o("sort"),
      newColumnsLoaded: this.updateColumnAndGroupState.bind(this),
      columnGroupOpened: () => this.updateCachedState("columnGroup", this.getColumnGroupState())
    });
  }
  setRowCountState(e, t, o) {
    const {
      filter: n,
      rowGroupExpansion: s,
      ssrmRowGroupExpansion: i,
      rowSelection: r,
      pagination: l
    } = e, a = (d, u) => !(o != null && o.has(d)) && (u || t === "api");
    a("filter", n) && this.setFilterState(n), a("rowGroupExpansion", s) && this.setRowGroupExpansionState(i, s, t), a("rowSelection", r) && this.setRowSelectionState(r, t), a("pagination", l) && this.setPaginationState(l, t);
    const c = this.updateCachedState.bind(this);
    c("filter", this.getFilterState()), this.beans.gos.get("ssrmExpandAllAffectsAllRows") ? (c("ssrmRowGroupExpansion", this.getRowGroupExpansionState()), c("rowGroupExpansion", void 0)) : (c("rowGroupExpansion", this.getRowGroupExpansionState()), c("ssrmRowGroupExpansion", void 0)), c("rowSelection", this.getRowSelectionState()), c("pagination", this.getPaginationState());
  }
  setupStateOnRowCountReady(e) {
    this.setRowCountState(e, "gridInitializing");
    const t = this.updateCachedState.bind(this), o = () => {
      this.updateRowGroupExpansionStateTimer = 0, this.beans.gos.get("ssrmExpandAllAffectsAllRows") ? (t("ssrmRowGroupExpansion", this.getRowGroupExpansionState()), t("rowGroupExpansion", void 0)) : (t("rowGroupExpansion", this.getRowGroupExpansionState()), t("ssrmRowGroupExpansion", void 0));
    }, n = () => t("filter", this.getFilterState()), { gos: s, colFilter: i } = this.beans;
    this.addManagedEventListeners({
      filterChanged: n,
      rowExpansionStateChanged: this.onRowGroupOpenedDebounced,
      expandOrCollapseAll: o,
      // `groupDefaultExpanded`/`isGroupOpenByDefault` updates expansion state without an expansion event
      columnRowGroupChanged: o,
      rowDataUpdated: () => {
        (s.get("groupDefaultExpanded") !== 0 || s.get("isGroupOpenByDefault")) && (this.updateRowGroupExpansionStateTimer || (this.updateRowGroupExpansionStateTimer = setTimeout(o)));
      },
      selectionChanged: () => {
        this.staleStateKeys.add("rowSelection"), this.onRowSelectedDebounced();
      },
      paginationChanged: (r) => {
        (r.newPage || r.newPageSize) && t("pagination", this.getPaginationState());
      }
    }), i && this.addManagedListeners(i, {
      filterStateChanged: n
    });
  }
  setFirstDataRenderedState(e, t, o) {
    const {
      scroll: n,
      cellSelection: s,
      focusedCell: i,
      columnOrder: r,
      rowPinning: l
    } = e, a = (u, h) => !(o != null && o.has(u)) && (h || t === "api");
    a("focusedCell", i) && this.setFocusedCellState(i), a("cellSelection", s) && this.setCellSelectionState(s), a("scroll", n) && this.setScrollState(n), a("rowPinning", l) && this.setRowPinningState(l), this.setColumnPivotState(!!(r != null && r.orderedColIds), t);
    const c = this.updateCachedState.bind(this);
    c("sideBar", this.getSideBarState()), c("focusedCell", this.getFocusedCellState());
    const d = this.getRangeSelectionState();
    c("rangeSelection", d), c("cellSelection", d), c("scroll", this.getScrollState());
  }
  setupStateOnFirstDataRendered(e) {
    this.setFirstDataRenderedState(e, "gridInitializing");
    const t = this.updateCachedState.bind(this), o = () => t("focusedCell", this.getFocusedCellState());
    this.addManagedEventListeners({
      cellFocused: o,
      cellFocusCleared: o,
      cellSelectionChanged: (n) => {
        if (n.finished) {
          const s = this.getRangeSelectionState();
          t("rangeSelection", s), t("cellSelection", s);
        }
      },
      bodyScrollEnd: () => t("scroll", this.getScrollState()),
      pinnedRowsChanged: () => t("rowPinning", this.getRowPinningState())
    });
  }
  getColumnState() {
    const e = this.beans;
    return BNe(Ml(e), e.colModel.isPivotMode());
  }
  setColumnState(e, t, o, n) {
    const {
      sort: s,
      rowGroup: i,
      aggregation: r,
      pivot: l,
      columnPinning: a,
      columnVisibility: c,
      columnSizing: d,
      columnOrder: u
    } = e;
    let h = !1;
    const p = (B, H) => {
      const O = !(n != null && n.has(B)) && !!(H || t === "api");
      return h || (h = O), O;
    }, C = {}, m = (B) => {
      let H = C[B];
      return H || (H = { colId: B }, C[B] = H, H);
    }, w = {}, y = p("sort", s);
    y && (s == null || s.sortModel.forEach(({ colId: B, sort: H }, O) => {
      const N = m(B);
      N.sort = H, N.sortIndex = O;
    })), (y || !o) && (w.sort = null, w.sortIndex = null);
    const b = p("rowGroup", i);
    b && (i == null || i.groupColIds.forEach((B, H) => {
      const O = m(B);
      O.rowGroup = !0, O.rowGroupIndex = H;
    })), (b || !o) && (w.rowGroup = null, w.rowGroupIndex = null);
    const _ = p("aggregation", r);
    _ && (r == null || r.aggregationModel.forEach(({ colId: B, aggFunc: H }) => {
      m(B).aggFunc = H;
    })), (_ || !o) && (w.aggFunc = null);
    const M = p("pivot", l);
    M && (l == null || l.pivotColIds.forEach((B, H) => {
      const O = m(B);
      O.pivot = !0, O.pivotIndex = H;
    }), this.gos.updateGridOptions({
      options: { pivotMode: !!(l != null && l.pivotMode) },
      source: t
    })), (M || !o) && (w.pivot = null, w.pivotIndex = null);
    const x = p("columnPinning", a);
    x && (a == null || a.leftColIds.forEach((B) => {
      m(B).pinned = "left";
    }), a == null || a.rightColIds.forEach((B) => {
      m(B).pinned = "right";
    })), (x || !o) && (w.pinned = null);
    const L = p("columnVisibility", c);
    L && (c == null || c.hiddenColIds.forEach((B) => {
      m(B).hide = !0;
    })), (L || !o) && (w.hide = null);
    const A = p("columnSizing", d);
    A && (d == null || d.columnSizingModel.forEach(({ colId: B, flex: H, width: O }) => {
      const N = m(B);
      N.flex = H ?? null, N.width = O;
    })), (A || !o) && (w.flex = null);
    const R = u == null ? void 0 : u.orderedColIds, P = !!(R != null && R.length) && !(n != null && n.has("columnOrder")), I = P ? R.map((B) => m(B)) : Object.values(C);
    (I.length || h) && (this.columnStates = I, eo(
      this.beans,
      {
        state: I,
        applyOrder: P,
        defaultState: w
      },
      t
    ));
  }
  setColumnPivotState(e, t) {
    const o = this.columnStates;
    this.columnStates = void 0;
    const n = this.columnGroupStates;
    this.columnGroupStates = void 0;
    const s = this.beans, { pivotResultCols: i, colGroupSvc: r } = s;
    if (i != null && i.isPivotResultColsPresent()) {
      if (o) {
        const l = [];
        for (const a of o)
          i.getPivotResultCol(a.colId) && l.push(a);
        eo(
          s,
          {
            state: l,
            applyOrder: e
          },
          t
        );
      }
      n && (r == null || r.setColumnGroupState(n, t));
    }
  }
  getColumnGroupState() {
    const e = this.beans.colGroupSvc;
    if (!e)
      return;
    const t = e.getColumnGroupState();
    return $Ne(t);
  }
  setColumnGroupState(e, t, o) {
    var l;
    const n = this.beans.colGroupSvc;
    if (!n || o != null && o.has("columnGroup") || t !== "api" && !Object.prototype.hasOwnProperty.call(e, "columnGroup"))
      return;
    const s = new Set((l = e.columnGroup) == null ? void 0 : l.openColumnGroupIds), r = n.getColumnGroupState().map(({ groupId: a }) => {
      const c = s.has(a);
      return c && s.delete(a), {
        groupId: a,
        open: c
      };
    });
    s.forEach((a) => {
      r.push({
        groupId: a,
        open: !0
      });
    }), r.length && (this.columnGroupStates = r), n.setColumnGroupState(r, t);
  }
  getFilterState() {
    const e = this.beans.filterManager;
    let t = e == null ? void 0 : e.getFilterModel();
    t && Object.keys(t).length === 0 && (t = void 0);
    const o = e == null ? void 0 : e.getFilterState(), n = (e == null ? void 0 : e.getAdvFilterModel()) ?? void 0;
    return t || n || o ? { filterModel: t, columnFilterState: o, advancedFilterModel: n } : void 0;
  }
  setFilterState(e) {
    const t = this.beans.filterManager, { filterModel: o, columnFilterState: n, advancedFilterModel: s } = e ?? {
      filterModel: null,
      columnFilterState: null,
      advancedFilterModel: null
    };
    (o !== void 0 || n !== void 0) && (t == null || t.setFilterState(o ?? null, n ?? null, "columnFilter")), s !== void 0 && (t == null || t.setAdvFilterModel(s ?? null, "advancedFilter"));
  }
  getRangeSelectionState() {
    var t;
    const e = (t = this.beans.rangeSvc) == null ? void 0 : t.getCellRanges().map((o) => {
      const { id: n, type: s, startRow: i, endRow: r, columns: l, startColumn: a } = o;
      return {
        id: n,
        type: s,
        startRow: i,
        endRow: r,
        colIds: l.map((c) => c.getColId()),
        startColId: a.getColId()
      };
    });
    return e != null && e.length ? { cellRanges: e } : void 0;
  }
  setCellSelectionState(e) {
    const { gos: t, rangeSvc: o, colModel: n, visibleCols: s } = this.beans;
    if (!kn(t) || !o)
      return;
    const i = [];
    e == null || e.cellRanges.forEach((r) => {
      const l = [];
      if (r.colIds.forEach((c) => {
        const d = n.getCol(c);
        d && l.push(d);
      }), !l.length)
        return;
      let a = n.getCol(r.startColId);
      if (!a) {
        const c = s.allCols, d = new Set(l);
        a = c.find((u) => d.has(u));
      }
      i.push({
        ...r,
        columns: l,
        startColumn: a
      });
    }), o.setCellRanges(i);
  }
  getScrollState() {
    if (!this.isClientSideRowModel)
      return;
    const e = this.beans.ctrlsSvc.getScrollFeature(), { left: t } = (e == null ? void 0 : e.getHScrollPosition()) ?? { left: 0 }, { top: o } = (e == null ? void 0 : e.getVScrollPosition()) ?? { top: 0 };
    return o || t ? {
      top: o,
      left: t
    } : void 0;
  }
  setScrollState(e) {
    if (!this.isClientSideRowModel)
      return;
    const { top: t, left: o } = e ?? { top: 0, left: 0 }, { frameworkOverrides: n, rowRenderer: s, animationFrameSvc: i, ctrlsSvc: r } = this.beans;
    n.wrapIncoming(() => {
      var l;
      r.get("center").setCenterViewportScrollLeft(o), (l = r.getScrollFeature()) == null || l.setVerticalScrollPosition(t), s.redraw({ afterScroll: !0 }), i == null || i.flushAllFrames();
    });
  }
  getSideBarState() {
    var e, t;
    return (t = (e = this.beans.sideBar) == null ? void 0 : e.comp) == null ? void 0 : t.getState();
  }
  getFocusedCellState() {
    if (!this.isClientSideRowModel)
      return;
    const e = this.beans.focusSvc.getFocusedCell();
    if (e) {
      const { column: t, rowIndex: o, rowPinned: n } = e;
      return {
        colId: t.getColId(),
        rowIndex: o,
        rowPinned: n
      };
    }
  }
  setFocusedCellState(e) {
    if (!this.isClientSideRowModel)
      return;
    const { focusSvc: t, colModel: o } = this.beans;
    if (!e) {
      t.clearFocusedCell();
      return;
    }
    const { colId: n, rowIndex: s, rowPinned: i } = e;
    t.setFocusedCell({
      column: o.getCol(n),
      rowIndex: s,
      rowPinned: i,
      forceBrowserFocus: !0,
      preventScrollOnBrowserFocus: !0
    });
  }
  getPaginationState() {
    const { pagination: e, gos: t } = this.beans;
    if (!e)
      return;
    const o = e.getCurrentPage(), n = t.get("paginationAutoPageSize") ? void 0 : e.getPageSize();
    if (!(!o && !n))
      return { page: o, pageSize: n };
  }
  setPaginationState(e, t) {
    const { pagination: o, gos: n } = this.beans;
    if (!o)
      return;
    const { pageSize: s, page: i } = e ?? { page: 0, pageSize: n.get("paginationPageSize") }, r = t === "gridInitializing";
    s && !n.get("paginationAutoPageSize") && o.setPageSize(s, r ? "initialState" : "pageSizeSelector"), typeof i == "number" && (r ? o.setPage(i) : o.goToPage(i));
  }
  getRowSelectionState() {
    var n;
    const e = this.beans.selectionSvc;
    if (!e)
      return;
    const t = e.getSelectionState();
    return !t || !Array.isArray(t) && (t.selectAll === !1 || t.selectAllChildren === !1) && !((n = t == null ? void 0 : t.toggledNodes) != null && n.length) ? void 0 : t;
  }
  setRowSelectionState(e, t) {
    var o;
    (o = this.beans.selectionSvc) == null || o.setSelectionState(e, t, t === "api");
  }
  getRowGroupExpansionState() {
    const { expansionSvc: e } = this.beans;
    if (e)
      return e.getExpansionState();
  }
  getRowPinningState() {
    var e;
    return (e = this.beans.pinnedRowModel) == null ? void 0 : e.getPinnedState();
  }
  setRowPinningState(e) {
    const t = this.beans.pinnedRowModel;
    e ? t == null || t.setPinnedState(e) : t == null || t.reset();
  }
  setRowGroupExpansionState(e, t, o) {
    const n = this.beans.expansionSvc;
    if (!n)
      return;
    const s = t ?? { expandedRowGroupIds: [], collapsedRowGroupIds: [] };
    n.setExpansionState(s, o);
  }
  updateColumnState(e) {
    const t = this.getColumnState();
    let o = !1;
    const n = this.cachedState;
    for (const s of Object.keys(t)) {
      const i = t[s];
      Zr(i, n[s]) || (o = !0);
    }
    this.cachedState = {
      ...n,
      ...t
    }, o && this.dispatchStateUpdateEvent(e);
  }
  updateCachedState(e, t) {
    const o = this.cachedState[e];
    this.setCachedStateValue(e, t), Zr(t, o) || this.dispatchStateUpdateEvent([e]);
  }
  setCachedStateValue(e, t) {
    this.cachedState = {
      ...this.cachedState,
      [e]: t
    };
  }
  refreshStaleState() {
    const e = this.staleStateKeys;
    e.forEach((t) => {
      switch (t) {
        case "rowSelection":
          this.setCachedStateValue(t, this.getRowSelectionState());
          break;
      }
    }), e.clear();
  }
  dispatchStateUpdateEvent(e) {
    this.suppressEvents || (e.forEach((t) => this.queuedUpdateSources.add(t)), this.dispatchStateUpdateEventDebounced());
  }
  dispatchQueuedStateUpdateEvents() {
    const e = this.queuedUpdateSources, t = Array.from(e);
    e.clear(), this.eventSvc.dispatchEvent({
      type: "stateUpdated",
      sources: t,
      state: this.cachedState
    });
  }
  startSuppressEvents() {
    var e;
    this.suppressEvents = !0, (e = this.beans.colAnimation) == null || e.setSuppressAnimation(!0);
  }
  stopSuppressEvents(e) {
    setTimeout(() => {
      var t;
      this.suppressEvents = !1, this.queuedUpdateSources.clear(), this.isAlive() && ((t = this.beans.colAnimation) == null || t.setSuppressAnimation(!1), this.dispatchStateUpdateEvent([e]));
    });
  }
  suppressEventsAndDispatchInitEvent(e) {
    this.startSuppressEvents(), e(), this.stopSuppressEvents("gridInitializing");
  }
}, $Ue = {
  moduleName: "GridState",
  version: be,
  beans: [BUe],
  apiFunctions: {
    getState: kUe,
    setState: HUe
  }
};
function ZUe(e) {
  return e.rowModel.isLastRowIndexKnown();
}
function GUe(e) {
  var t;
  return ((t = e.pagination) == null ? void 0 : t.getPageSize()) ?? 100;
}
function NUe(e) {
  var t;
  return ((t = e.pagination) == null ? void 0 : t.getCurrentPage()) ?? 0;
}
function zUe(e) {
  var t;
  return ((t = e.pagination) == null ? void 0 : t.getTotalPages()) ?? 1;
}
function jUe(e) {
  return e.pagination ? e.pagination.getMasterRowCount() : e.rowModel.getRowCount();
}
function WUe(e) {
  var t;
  (t = e.pagination) == null || t.goToNextPage();
}
function UUe(e) {
  var t;
  (t = e.pagination) == null || t.goToPreviousPage();
}
function KUe(e) {
  var t;
  (t = e.pagination) == null || t.goToFirstPage();
}
function qUe(e) {
  var t;
  (t = e.pagination) == null || t.goToLastPage();
}
function YUe(e, t) {
  var o;
  (o = e.pagination) == null || o.goToPage(t);
}
var QUe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "paginationAutoPageSizeSvc";
  }
  postConstruct() {
    this.beans.ctrlsSvc.whenReady(this, (e) => {
      this.centerRowsCtrl = e.center;
      const t = this.checkPageSize.bind(this);
      this.addManagedEventListeners({
        bodyHeightChanged: t,
        scrollVisibilityChanged: t
      }), this.addManagedPropertyListener("paginationAutoPageSize", this.onPaginationAutoSizeChanged.bind(this)), this.checkPageSize();
    });
  }
  notActive() {
    return !this.gos.get("paginationAutoPageSize") || this.centerRowsCtrl == null;
  }
  onPaginationAutoSizeChanged() {
    this.notActive() ? this.beans.pagination.unsetAutoCalculatedPageSize() : this.checkPageSize();
  }
  checkPageSize() {
    if (this.notActive())
      return;
    const e = this.centerRowsCtrl.viewportSizeFeature.getBodyHeight();
    if (e > 0) {
      const t = this.beans, o = () => {
        const n = Math.max(Vs(t), 1), s = Math.floor(e / n);
        t.pagination.setPageSize(s, "autoCalculated");
      };
      this.isBodyRendered ? Rt(this, o, 50)() : (o(), this.isBodyRendered = !0);
    } else
      this.isBodyRendered = !1;
  }
}, gr = "paginationPageSizeSelector", JUe = { tag: "span", cls: "ag-paging-page-size" }, XUe = class extends Re {
  constructor() {
    super(JUe), this.hasEmptyOption = !1, this.handlePageSizeItemSelected = () => {
      if (!this.selectPageSizeComp)
        return;
      const e = this.selectPageSizeComp.getValue();
      if (!e)
        return;
      const t = Number(e);
      isNaN(t) || t < 1 || t === this.pagination.getPageSize() || (this.pagination.setPageSize(t, "pageSizeSelector"), this.hasEmptyOption && this.toggleSelectDisplay(!0), this.selectPageSizeComp.getFocusableElement().focus());
    };
  }
  wireBeans(e) {
    this.pagination = e.pagination;
  }
  postConstruct() {
    this.addManagedPropertyListener(gr, () => {
      this.onPageSizeSelectorValuesChange();
    }), this.addManagedEventListeners({ paginationChanged: (e) => this.handlePaginationChanged(e) });
  }
  handlePaginationChanged(e) {
    if (!this.selectPageSizeComp || !(e != null && e.newPageSize))
      return;
    const t = this.pagination.getPageSize();
    this.getPageSizeSelectorValues().includes(t) ? this.selectPageSizeComp.setValue(t.toString()) : this.hasEmptyOption ? this.selectPageSizeComp.setValue("") : this.toggleSelectDisplay(!0);
  }
  toggleSelectDisplay(e) {
    this.selectPageSizeComp && !e && this.reset(), e && (this.reloadPageSizesSelector(), this.selectPageSizeComp);
  }
  reset() {
    it(this.getGui()), this.selectPageSizeComp && (this.selectPageSizeComp = this.destroyBean(this.selectPageSizeComp));
  }
  onPageSizeSelectorValuesChange() {
    this.selectPageSizeComp && this.shouldShowPageSizeSelector() && this.reloadPageSizesSelector();
  }
  shouldShowPageSizeSelector() {
    return this.gos.get("pagination") && !this.gos.get("suppressPaginationPanel") && !this.gos.get("paginationAutoPageSize") && this.gos.get(gr) !== !1;
  }
  reloadPageSizesSelector() {
    const e = this.getPageSizeSelectorValues(), t = this.pagination.getPageSize(), o = !t || !e.includes(t);
    if (o) {
      const s = this.gos.exists("paginationPageSize"), i = this.gos.get(gr) !== !0;
      X(94, { pageSizeSet: s, pageSizesSet: i, pageSizeOptions: e, paginationPageSizeOption: t }), i || X(95, { paginationPageSizeOption: t, paginationPageSizeSelector: gr }), e.unshift("");
    }
    const n = String(o ? "" : t);
    this.selectPageSizeComp ? (No(this.pageSizeOptions, e) || (this.selectPageSizeComp.clearOptions().addOptions(this.createPageSizeSelectOptions(e)), this.pageSizeOptions = e), this.selectPageSizeComp.setValue(n, !0)) : this.createPageSizeSelectorComp(e, n), this.hasEmptyOption = o;
  }
  createPageSizeSelectOptions(e) {
    return e.map((t) => ({
      value: String(t)
    }));
  }
  createPageSizeSelectorComp(e, t) {
    const o = this.getLocaleTextFunc(), n = o("pageSizeSelectorLabel", "Page Size:"), s = o("ariaPageSizeSelectorLabel", "Page Size");
    this.selectPageSizeComp = this.createManagedBean(new V2()).addOptions(this.createPageSizeSelectOptions(e)).setValue(t).setAriaLabel(s).setLabel(n).onValueChange(() => this.handlePageSizeItemSelected()), this.appendChild(this.selectPageSizeComp);
  }
  getPageSizeSelectorValues() {
    const e = [20, 50, 100], t = this.gos.get(gr);
    return !Array.isArray(t) || !(t != null && t.length) ? e : [...t].sort((o, n) => o - n);
  }
  destroy() {
    this.toggleSelectDisplay(!1), super.destroy();
  }
}, eKe = {
  selector: "AG-PAGE-SIZE-SELECTOR",
  component: XUe
}, tKe = (
  /*css*/
  ".ag-paging-panel{align-items:center;border-top:var(--ag-footer-row-border);display:flex;gap:calc(var(--ag-spacing)*4);height:var(--ag-pagination-panel-height);justify-content:flex-end;padding:0 var(--ag-cell-horizontal-padding)}:where(.ag-paging-page-size) .ag-wrapper{min-width:50px}.ag-paging-page-summary-panel{align-items:center;display:flex;gap:var(--ag-cell-widget-spacing);.ag-disabled &{pointer-events:none}}.ag-paging-button{cursor:pointer;position:relative;&.ag-disabled{cursor:default;opacity:.5}}.ag-paging-number,.ag-paging-row-summary-panel-number{font-weight:500}"
), oKe = class extends ri {
  constructor() {
    super(), this.btFirst = J, this.btPrevious = J, this.btNext = J, this.btLast = J, this.lbRecordCount = J, this.lbFirstRowOnPage = J, this.lbLastRowOnPage = J, this.lbCurrent = J, this.lbTotal = J, this.pageSizeComp = J, this.previousAndFirstButtonsDisabled = !1, this.nextButtonDisabled = !1, this.lastButtonDisabled = !1, this.areListenersSetup = !1, this.allowFocusInnerElement = !1, this.registerCSS(tKe);
  }
  wireBeans(e) {
    this.rowModel = e.rowModel, this.pagination = e.pagination, this.ariaAnnounce = e.ariaAnnounce;
  }
  postConstruct() {
    const e = this.gos.get("enableRtl");
    this.setTemplate(this.getTemplate(), [eKe]);
    const { btFirst: t, btPrevious: o, btNext: n, btLast: s } = this;
    this.activateTabIndex([t, o, n, s]), t.insertAdjacentElement("afterbegin", Ie(e ? "last" : "first", this.beans)), o.insertAdjacentElement("afterbegin", Ie(e ? "next" : "previous", this.beans)), n.insertAdjacentElement("afterbegin", Ie(e ? "previous" : "next", this.beans)), s.insertAdjacentElement("afterbegin", Ie(e ? "first" : "last", this.beans)), this.addManagedPropertyListener("pagination", this.onPaginationChanged.bind(this)), this.addManagedPropertyListener("suppressPaginationPanel", this.onPaginationChanged.bind(this)), this.addManagedPropertyListeners(
      ["paginationPageSizeSelector", "paginationAutoPageSize", "suppressPaginationPanel"],
      () => this.onPageSizeRelatedOptionsChange()
    ), this.pageSizeComp.toggleSelectDisplay(this.pageSizeComp.shouldShowPageSizeSelector()), this.initialiseTabGuard({
      // prevent tab guard default logic
      onTabKeyDown: () => {
      },
      focusInnerElement: (i) => this.allowFocusInnerElement ? this.tabGuardFeature.getTabGuardCtrl().focusInnerElement(i) : eVe(this.beans, i),
      forceFocusOutWhenTabGuardsAreEmpty: !0
    }), this.onPaginationChanged();
  }
  setAllowFocus(e) {
    this.allowFocusInnerElement = e;
  }
  onPaginationChanged() {
    const t = this.gos.get("pagination") && !this.gos.get("suppressPaginationPanel");
    this.setDisplayed(t), t && (this.setupListeners(), this.enableOrDisableButtons(), this.updateLabels(), this.onPageSizeRelatedOptionsChange());
  }
  onPageSizeRelatedOptionsChange() {
    this.pageSizeComp.toggleSelectDisplay(this.pageSizeComp.shouldShowPageSizeSelector());
  }
  setupListeners() {
    this.areListenersSetup || (this.addManagedEventListeners({ paginationChanged: this.onPaginationChanged.bind(this) }), [
      { el: this.btFirst, fn: this.onBtFirst.bind(this) },
      { el: this.btPrevious, fn: this.onBtPrevious.bind(this) },
      { el: this.btNext, fn: this.onBtNext.bind(this) },
      { el: this.btLast, fn: this.onBtLast.bind(this) }
    ].forEach((e) => {
      const { el: t, fn: o } = e;
      this.addManagedListeners(t, {
        click: o,
        keydown: (n) => {
          (n.key === D.ENTER || n.key === D.SPACE) && (n.preventDefault(), o());
        }
      });
    }), Ob(this.beans, this, this.getGui()), this.areListenersSetup = !0);
  }
  onBtFirst() {
    this.previousAndFirstButtonsDisabled || this.pagination.goToFirstPage();
  }
  formatNumber(e) {
    const t = this.gos.getCallback("paginationNumberFormatter");
    return t ? t({ value: e }) : GNe(e, this.getLocaleTextFunc.bind(this));
  }
  getTemplate() {
    const e = this.getLocaleTextFunc(), t = `ag-${this.getCompId()}`;
    return {
      tag: "div",
      cls: "ag-paging-panel ag-unselectable",
      attrs: { id: `${t}` },
      children: [
        {
          tag: "ag-page-size-selector",
          ref: "pageSizeComp"
        },
        {
          tag: "span",
          cls: "ag-paging-row-summary-panel",
          children: [
            {
              tag: "span",
              ref: "lbFirstRowOnPage",
              cls: "ag-paging-row-summary-panel-number",
              attrs: { id: `${t}-first-row` }
            },
            { tag: "span", attrs: { id: `${t}-to` }, children: e("to", "to") },
            {
              tag: "span",
              ref: "lbLastRowOnPage",
              cls: "ag-paging-row-summary-panel-number",
              attrs: { id: `${t}-last-row` }
            },
            { tag: "span", attrs: { id: `${t}-of` }, children: e("of", "of") },
            {
              tag: "span",
              ref: "lbRecordCount",
              cls: "ag-paging-row-summary-panel-number",
              attrs: { id: `${t}-row-count` }
            }
          ]
        },
        {
          tag: "span",
          cls: "ag-paging-page-summary-panel",
          role: "presentation",
          children: [
            {
              tag: "div",
              ref: "btFirst",
              cls: "ag-button ag-paging-button",
              role: "button",
              attrs: { "aria-label": e("firstPage", "First Page") }
            },
            {
              tag: "div",
              ref: "btPrevious",
              cls: "ag-button ag-paging-button",
              role: "button",
              attrs: { "aria-label": e("previousPage", "Previous Page") }
            },
            {
              tag: "span",
              cls: "ag-paging-description",
              children: [
                {
                  tag: "span",
                  attrs: {
                    id: `${t}-start-page`
                  },
                  children: e("page", "Page")
                },
                {
                  tag: "span",
                  ref: "lbCurrent",
                  cls: "ag-paging-number",
                  attrs: { id: `${t}-start-page-number` }
                },
                {
                  tag: "span",
                  attrs: {
                    id: `${t}-of-page`
                  },
                  children: e("of", "of")
                },
                {
                  tag: "span",
                  ref: "lbTotal",
                  cls: "ag-paging-number",
                  attrs: { id: `${t}-of-page-number` }
                }
              ]
            },
            {
              tag: "div",
              ref: "btNext",
              cls: "ag-button ag-paging-button",
              role: "button",
              attrs: { "aria-label": e("nextPage", "Next Page") }
            },
            {
              tag: "div",
              ref: "btLast",
              cls: "ag-button ag-paging-button",
              role: "button",
              attrs: { "aria-label": e("lastPage", "Last Page") }
            }
          ]
        }
      ]
    };
  }
  onBtNext() {
    this.nextButtonDisabled || this.pagination.goToNextPage();
  }
  onBtPrevious() {
    this.previousAndFirstButtonsDisabled || this.pagination.goToPreviousPage();
  }
  onBtLast() {
    this.lastButtonDisabled || this.pagination.goToLastPage();
  }
  enableOrDisableButtons() {
    const e = this.pagination.getCurrentPage(), t = this.rowModel.isLastRowIndexKnown(), o = this.pagination.getTotalPages();
    this.previousAndFirstButtonsDisabled = e === 0, this.toggleButtonDisabled(this.btFirst, this.previousAndFirstButtonsDisabled), this.toggleButtonDisabled(this.btPrevious, this.previousAndFirstButtonsDisabled);
    const n = this.isZeroPagesToDisplay(), s = e === o - 1;
    this.nextButtonDisabled = s || n, this.lastButtonDisabled = !t || n || e === o - 1, this.toggleButtonDisabled(this.btNext, this.nextButtonDisabled), this.toggleButtonDisabled(this.btLast, this.lastButtonDisabled);
  }
  toggleButtonDisabled(e, t) {
    ml(e, t), e.classList.toggle("ag-disabled", t);
  }
  isZeroPagesToDisplay() {
    const e = this.rowModel.isLastRowIndexKnown(), t = this.pagination.getTotalPages();
    return e && t === 0;
  }
  updateLabels() {
    const e = this.rowModel.isLastRowIndexKnown(), t = this.pagination.getTotalPages(), o = this.pagination.getMasterRowCount(), n = e ? o : null, s = this.pagination.getCurrentPage(), i = this.pagination.getPageSize();
    let r, l;
    this.isZeroPagesToDisplay() ? r = l = 0 : (r = i * s + 1, l = r + i - 1, e && l > n && (l = n));
    const a = r + i - 1, c = !e && o < a, d = this.formatNumber(r);
    this.lbFirstRowOnPage.textContent = d;
    let u;
    const h = this.getLocaleTextFunc();
    c ? u = h("pageLastRowUnknown", "?") : u = this.formatNumber(l), this.lbLastRowOnPage.textContent = u;
    const C = t > 0 ? s + 1 : 0, m = this.formatNumber(C);
    this.lbCurrent.textContent = m;
    let w, y;
    if (e)
      w = this.formatNumber(t), y = this.formatNumber(n);
    else {
      const b = h("more", "more");
      w = b, y = b;
    }
    this.lbTotal.textContent = w, this.lbRecordCount.textContent = y, this.announceAriaStatus(d, u, y, m, w);
  }
  announceAriaStatus(e, t, o, n, s) {
    var u, h;
    const i = this.getLocaleTextFunc(), r = i("page", "Page"), l = i("to", "to"), a = i("of", "of"), c = `${e} ${l} ${t} ${a} ${o}`, d = `${r} ${n} ${a} ${s}`;
    c !== this.ariaRowStatus && (this.ariaRowStatus = c, (u = this.ariaAnnounce) == null || u.announceValue(c, "paginationRow")), d !== this.ariaPageStatus && (this.ariaPageStatus = d, (h = this.ariaAnnounce) == null || h.announceValue(d, "paginationPage"));
  }
}, nKe = {
  selector: "AG-PAGINATION",
  component: oKe
}, sKe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "pagination", this.currentPage = 0, this.topDisplayedRowIndex = 0, this.bottomDisplayedRowIndex = 0, this.masterRowCount = 0;
  }
  postConstruct() {
    const e = this.gos;
    this.active = e.get("pagination"), this.pageSizeFromGridOptions = e.get("paginationPageSize"), this.paginateChildRows = this.isPaginateChildRows(), this.addManagedPropertyListener("pagination", this.onPaginationGridOptionChanged.bind(this)), this.addManagedPropertyListener("paginationPageSize", this.onPageSizeGridOptionChanged.bind(this));
  }
  getPaginationSelector() {
    return nKe;
  }
  isPaginateChildRows() {
    const e = this.gos;
    return e.get("groupHideParentOfSingleChild") || // following two properties deprecated v32.3.0
    e.get("groupRemoveSingleChildren") || e.get("groupRemoveLowestSingleChildren") ? !0 : e.get("paginateChildRows");
  }
  onPaginationGridOptionChanged() {
    this.active = this.gos.get("pagination"), this.calculatePages(), this.dispatchPaginationChangedEvent({ keepRenderedRows: !0 });
  }
  onPageSizeGridOptionChanged() {
    this.setPageSize(this.gos.get("paginationPageSize"), "gridOptions");
  }
  goToPage(e) {
    const t = this.currentPage;
    if (!this.active || t === e || typeof t != "number")
      return;
    const { editSvc: o } = this.beans;
    o != null && o.isEditing() && (o.isBatchEditing() ? o.cleanupEditors() : o.stopEditing(void 0, { source: "api" })), this.currentPage = e, this.calculatePages(), this.dispatchPaginationChangedEvent({ newPage: !0 });
  }
  goToPageWithIndex(e) {
    var o, n;
    if (!this.active)
      return;
    let t = e;
    this.paginateChildRows || (t = ((n = (o = this.beans.rowModel).getTopLevelIndexFromDisplayedIndex) == null ? void 0 : n.call(o, e)) ?? e), this.goToPage(Math.floor(t / this.pageSize));
  }
  isRowInPage(e) {
    return this.active ? e >= this.topDisplayedRowIndex && e <= this.bottomDisplayedRowIndex : !0;
  }
  getCurrentPage() {
    return this.currentPage;
  }
  goToNextPage() {
    this.goToPage(this.currentPage + 1);
  }
  goToPreviousPage() {
    this.goToPage(this.currentPage - 1);
  }
  goToFirstPage() {
    this.goToPage(0);
  }
  goToLastPage() {
    const e = this.beans.rowModel.getRowCount(), t = Math.floor(e / this.pageSize);
    this.goToPage(t);
  }
  getPageSize() {
    return this.pageSize;
  }
  getTotalPages() {
    return this.totalPages;
  }
  /** This is only for state setting before data has been loaded */
  setPage(e) {
    this.currentPage = e;
  }
  get pageSize() {
    return ue(this.pageSizeAutoCalculated) && this.gos.get("paginationAutoPageSize") ? this.pageSizeAutoCalculated : ue(this.pageSizeFromPageSizeSelector) ? this.pageSizeFromPageSizeSelector : ue(this.pageSizeFromInitialState) ? this.pageSizeFromInitialState : ue(this.pageSizeFromGridOptions) ? this.pageSizeFromGridOptions : this.defaultPageSize;
  }
  calculatePages() {
    this.active ? this.paginateChildRows ? this.calculatePagesAllRows() : this.calculatePagesMasterRowsOnly() : this.calculatedPagesNotActive(), this.beans.pageBounds.calculateBounds(this.topDisplayedRowIndex, this.bottomDisplayedRowIndex);
  }
  unsetAutoCalculatedPageSize() {
    if (this.pageSizeAutoCalculated === void 0)
      return;
    const e = this.pageSizeAutoCalculated;
    this.pageSizeAutoCalculated = void 0, this.pageSize !== e && (this.calculatePages(), this.dispatchPaginationChangedEvent({ newPageSize: !0 }));
  }
  setPageSize(e, t) {
    const o = this.pageSize;
    switch (t) {
      case "autoCalculated":
        this.pageSizeAutoCalculated = e;
        break;
      case "pageSizeSelector":
        this.pageSizeFromPageSizeSelector = e, this.currentPage !== 0 && this.goToFirstPage();
        break;
      case "initialState":
        this.pageSizeFromInitialState = e;
        break;
      case "gridOptions":
        this.pageSizeFromGridOptions = e, this.pageSizeFromInitialState = void 0, this.pageSizeFromPageSizeSelector = void 0, this.currentPage !== 0 && this.goToFirstPage();
        break;
    }
    o !== this.pageSize && (this.calculatePages(), this.dispatchPaginationChangedEvent({ newPageSize: !0, keepRenderedRows: !0 }));
  }
  setZeroRows() {
    this.masterRowCount = 0, this.topDisplayedRowIndex = 0, this.bottomDisplayedRowIndex = -1, this.currentPage = 0, this.totalPages = 0;
  }
  adjustCurrentPageIfInvalid() {
    const e = this.totalPages;
    this.currentPage >= e && (this.currentPage = e - 1);
    const t = this.currentPage;
    (!isFinite(t) || isNaN(t) || t < 0) && (this.currentPage = 0);
  }
  calculatePagesMasterRowsOnly() {
    const e = this.beans.rowModel, t = e.getTopLevelRowCount();
    if (this.masterRowCount = t, t <= 0) {
      this.setZeroRows();
      return;
    }
    const o = this.pageSize, n = t - 1;
    this.totalPages = Math.floor(n / o) + 1, this.adjustCurrentPageIfInvalid();
    const s = this.currentPage, i = o * s;
    let r = o * (s + 1) - 1;
    if (r > n && (r = n), this.topDisplayedRowIndex = e.getTopLevelRowDisplayedIndex(i), r === n)
      this.bottomDisplayedRowIndex = e.getRowCount() - 1;
    else {
      const l = e.getTopLevelRowDisplayedIndex(r + 1);
      this.bottomDisplayedRowIndex = l - 1;
    }
  }
  getMasterRowCount() {
    return this.masterRowCount;
  }
  calculatePagesAllRows() {
    const e = this.beans.rowModel.getRowCount();
    if (this.masterRowCount = e, e === 0) {
      this.setZeroRows();
      return;
    }
    const { pageSize: t, currentPage: o } = this, n = e - 1;
    this.totalPages = Math.floor(n / t) + 1, this.adjustCurrentPageIfInvalid(), this.topDisplayedRowIndex = t * o, this.bottomDisplayedRowIndex = t * (o + 1) - 1, this.bottomDisplayedRowIndex > n && (this.bottomDisplayedRowIndex = n);
  }
  calculatedPagesNotActive() {
    this.setPageSize(void 0, "autoCalculated"), this.totalPages = 1, this.currentPage = 0, this.topDisplayedRowIndex = 0, this.bottomDisplayedRowIndex = this.beans.rowModel.getRowCount() - 1;
  }
  dispatchPaginationChangedEvent(e) {
    const { keepRenderedRows: t = !1, newPage: o = !1, newPageSize: n = !1 } = e;
    this.eventSvc.dispatchEvent({
      type: "paginationChanged",
      animate: !1,
      newData: !1,
      newPage: o,
      newPageSize: n,
      keepRenderedRows: t
    });
  }
}, iKe = {
  moduleName: "Pagination",
  version: be,
  beans: [sKe, QUe],
  icons: {
    // "go to first" button in pagination controls
    first: "first",
    // "go to previous" button in pagination controls
    previous: "previous",
    // "go to next" button in pagination controls
    next: "next",
    // "go to last" button in pagination controls
    last: "last"
  },
  apiFunctions: {
    paginationIsLastPageFound: ZUe,
    paginationGetPageSize: GUe,
    paginationGetCurrentPage: NUe,
    paginationGetTotalPages: zUe,
    paginationGetRowCount: jUe,
    paginationGoToNextPage: WUe,
    paginationGoToPreviousPage: UUe,
    paginationGoToFirstPage: KUe,
    paginationGoToLastPage: qUe,
    paginationGoToPage: YUe
  },
  dependsOn: [li]
};
function rKe(e, t = {}) {
  const o = t ? t.rowNodes : void 0;
  e.frameworkOverrides.wrapIncoming(() => e.rowRenderer.redrawRows(o));
}
function o_(e, t, o, n, s) {
  t && (n && t.parent && t.parent.level !== -1 && o_(e, t.parent, o, n, s), t.setExpanded(o, void 0, s));
}
function lKe(e, t) {
  return e.rowModel.getRowNode(t);
}
function aKe(e, t, o, n) {
  e.rowRenderer.addRenderedRowListener(t, o, n);
}
function cKe(e) {
  return e.rowRenderer.getRenderedNodes();
}
function dKe(e, t, o) {
  e.rowModel.forEachNode(t, o);
}
function uKe(e) {
  return e.rowRenderer.firstRenderedRow;
}
function hKe(e) {
  return e.rowRenderer.lastRenderedRow;
}
function gKe(e, t) {
  return e.rowModel.getRow(t);
}
function pKe(e) {
  return e.rowModel.getRowCount();
}
var n_ = {
  moduleName: "RowApi",
  version: be,
  apiFunctions: {
    redrawRows: rKe,
    setRowNodeExpanded: o_,
    getRowNode: lKe,
    addRenderedRowListener: aKe,
    getRenderedNodes: cKe,
    forEachNode: dKe,
    getFirstDisplayedRowIndex: uKe,
    getLastDisplayedRowIndex: hKe,
    getDisplayedRowAtIndex: gKe,
    getDisplayedRowCount: pKe
  }
}, fKe = {
  moduleName: "ScrollApi",
  version: be,
  apiFunctions: {
    getVerticalPixelRange: Ije,
    getHorizontalPixelRange: Dje,
    ensureColumnVisible: zy,
    ensureIndexVisible: jy,
    ensureNodeVisible: kje
  }
};
function vKe(e, t, o) {
  if (!t)
    return;
  const n = e.ctrlsSvc.getGridBodyCtrl().eGridBody, s = `aria-${t}`;
  o === null ? n.removeAttribute(s) : n.setAttribute(s, o);
}
function mKe(e, t = {}) {
  e.frameworkOverrides.wrapIncoming(() => e.rowRenderer.refreshCells(t));
}
function CKe(e) {
  e.frameworkOverrides.wrapIncoming(
    () => e.ctrlsSvc.getHeaderRowContainerCtrls().forEach((t) => t.refresh())
  );
}
function wKe(e) {
  var t;
  return ((t = e.animationFrameSvc) == null ? void 0 : t.isQueueEmpty()) ?? !0;
}
function bKe(e) {
  var t;
  (t = e.animationFrameSvc) == null || t.flushAllFrames();
}
function yKe(e) {
  return {
    rowHeight: Vs(e),
    headerHeight: g1(e)
  };
}
function _Ke(e, t = {}) {
  var i;
  const o = [];
  if (e.rowRenderer.getCellCtrls(t.rowNodes, t.columns).forEach((r) => {
    const l = r.getCellRenderer();
    l != null && o.push(zi(l));
  }), (i = t.columns) != null && i.length)
    return o;
  const n = [], s = b5(t.rowNodes);
  return e.rowRenderer.getAllRowCtrls().forEach((r) => {
    if (s && !y5(r.rowNode, s) || !r.isFullWidth())
      return;
    const l = r.getFullWidthCellRenderers();
    for (let a = 0; a < l.length; a++) {
      const c = l[a];
      c != null && n.push(zi(c));
    }
  }), [...n, ...o];
}
var SKe = {
  moduleName: "RenderApi",
  version: be,
  apiFunctions: {
    setGridAriaProperty: vKe,
    refreshCells: mKe,
    refreshHeader: CKe,
    isAnimationFrameQueueEmpty: wKe,
    flushAllAnimationFrames: bKe,
    getSizesForCurrentTheme: yKe,
    getCellRendererInstances: _Ke
  }
};
function xKe(e, t) {
  var o, n;
  typeof t == "number" ? (o = e.colAutosize) == null || o.sizeColumnsToFit(t, "api") : (n = e.colAutosize) == null || n.sizeColumnsToFitGridBody(t);
}
function s_({ colAutosize: e, visibleCols: t }, o, n) {
  Array.isArray(o) ? e == null || e.autoSizeCols({ colKeys: o, skipHeader: n, source: "api" }) : e == null || e.autoSizeCols({
    colKeys: o.colIds ?? t.allCols,
    skipHeader: o.skipHeader,
    defaultMaxWidth: o.defaultMaxWidth,
    defaultMinWidth: o.defaultMinWidth,
    columnLimits: o.columnLimits,
    source: "api"
  });
}
function MKe(e, t) {
  var o;
  t && typeof t == "object" ? s_(e, t) : (o = e.colAutosize) == null || o.autoSizeAllColumns({ source: "api", skipHeader: t });
}
var AKe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "colAutosize", this.timesDelayed = 0, this.shouldQueueResizeOperations = !1, this.resizeOperationQueue = [];
  }
  postConstruct() {
    var t;
    const e = this.gos.get("autoSizeStrategy");
    if (e) {
      let o = !1;
      const n = e.type;
      n === "fitGridWidth" || n === "fitProvidedWidth" ? o = !0 : n === "fitCellContents" && this.addManagedEventListeners({ firstDataRendered: () => this.onFirstDataRendered(e) }), o && ((t = this.beans.colDelayRenderSvc) == null || t.hideColumns(n));
    }
  }
  autoSizeCols(e) {
    if (this.shouldQueueResizeOperations) {
      this.pushResizeOperation(() => this.autoSizeCols(e));
      return;
    }
    const {
      colKeys: t,
      skipHeader: o,
      skipHeaderGroups: n,
      stopAtGroup: s,
      defaultMaxWidth: i,
      defaultMinWidth: r,
      columnLimits: l = [],
      source: a = "api"
    } = e, { animationFrameSvc: c, renderStatus: d, colModel: u, autoWidthCalc: h, visibleCols: p } = this.beans;
    if (c == null || c.flushAllFrames(), this.timesDelayed < 5 && d && (!d.areHeaderCellsRendered() || !d.areCellsRendered())) {
      this.timesDelayed++, setTimeout(() => {
        this.isAlive() && this.autoSizeCols(e);
      });
      return;
    }
    this.timesDelayed = 0;
    const C = [];
    let m = -1;
    const w = Object.fromEntries(
      l.map(({ colId: _, maxWidth: M, minWidth: x }) => [_, { maxWidth: M, minWidth: x }])
    ), y = o ?? this.gos.get("skipHeaderOnAutoSize"), b = n ?? y;
    for (; m !== 0; ) {
      m = 0;
      const _ = [];
      t.forEach((M) => {
        if (!M || BIe(M))
          return;
        const x = u.getCol(M);
        if (!x || C.indexOf(x) >= 0)
          return;
        const L = h.getPreferredWidthForColumn(x, y);
        if (L > 0) {
          const A = w[x.colId] ?? {};
          A.minWidth ?? (A.minWidth = r), A.maxWidth ?? (A.maxWidth = i);
          const R = LKe(x, L, A);
          x.setActualWidth(R, a), C.push(x), m++;
        }
        _.push(x);
      }), _.length && p.refresh(a);
    }
    b || this.autoSizeColumnGroupsByColumns(t, a, s), Gi(this.eventSvc, C, !0, "autosizeColumns");
  }
  autoSizeColumn(e, t, o) {
    e && this.autoSizeCols({ colKeys: [e], skipHeader: o, skipHeaderGroups: !0, source: t });
  }
  autoSizeColumnGroupsByColumns(e, t, o) {
    const { colModel: n, ctrlsSvc: s } = this.beans, i = /* @__PURE__ */ new Set();
    n.getColsForKeys(e).forEach((c) => {
      let d = c.getParent();
      for (; d && d != o; )
        d.isPadding() || i.add(d), d = d.getParent();
    });
    let l;
    const a = [];
    for (const c of i) {
      for (const d of s.getHeaderRowContainerCtrls())
        if (l = d.getHeaderCtrlForColumn(c), l)
          break;
      l && l.resizeLeafColumnsToFit(t);
    }
    return a;
  }
  autoSizeAllColumns(e) {
    if (this.shouldQueueResizeOperations) {
      this.pushResizeOperation(() => this.autoSizeAllColumns(e));
      return;
    }
    const t = this.beans.visibleCols.allCols;
    this.autoSizeCols({ colKeys: t, ...e });
  }
  addColumnAutosize(e, t) {
    const o = this.gos.get("skipHeaderOnAutoSize"), n = () => {
      this.autoSizeColumn(t, "uiColumnResized", o);
    };
    e.addEventListener("dblclick", n);
    const s = new _n(e);
    return s.addEventListener("doubleTap", n), () => {
      e.removeEventListener("dblclick", n), s.removeEventListener("doubleTap", n), s.destroy();
    };
  }
  addColumnGroupResize(e, t, o) {
    const n = this.gos.get("skipHeaderOnAutoSize"), s = () => {
      const i = [];
      t.getDisplayedLeafColumns().forEach((l) => {
        l.getColDef().suppressAutoSize || i.push(l.getColId());
      }), i.length > 0 && this.autoSizeCols({
        colKeys: i,
        skipHeader: n,
        stopAtGroup: t,
        source: "uiColumnResized"
      }), o();
    };
    return e.addEventListener("dblclick", s), () => e.removeEventListener("dblclick", s);
  }
  // method will call itself if no available width. this covers if the grid
  // isn't visible, but is just about to be visible.
  sizeColumnsToFitGridBody(e, t) {
    if (!this.isAlive())
      return;
    const { ctrlsSvc: o, scrollVisibleSvc: n } = this.beans, s = o.getGridBodyCtrl(), r = s.isVerticalScrollShowing() ? n.getScrollbarWidth() : 0, a = Bi(s.eGridBody) - r;
    if (a > 0) {
      this.sizeColumnsToFit(a, "sizeColumnsToFit", !1, e);
      return;
    }
    t === void 0 ? window.setTimeout(() => {
      this.sizeColumnsToFitGridBody(e, 100);
    }, 0) : t === 100 ? window.setTimeout(() => {
      this.sizeColumnsToFitGridBody(e, 500);
    }, 100) : t === 500 ? window.setTimeout(() => {
      this.sizeColumnsToFitGridBody(e, -1);
    }, 500) : X(29);
  }
  // called from api
  sizeColumnsToFit(e, t = "sizeColumnsToFit", o, n) {
    var p;
    if (this.shouldQueueResizeOperations) {
      this.pushResizeOperation(() => this.sizeColumnsToFit(e, t, o, n));
      return;
    }
    const s = {};
    n && ((p = n == null ? void 0 : n.columnLimits) == null || p.forEach(({ key: C, ...m }) => {
      s[typeof C == "string" ? C : C.getColId()] = m;
    }));
    const i = this.beans.visibleCols.allCols;
    if (e <= 0 || !i.length || e === yn(i) && i.every((m) => {
      if (m.colDef.suppressSizeToFit)
        return !0;
      const w = s == null ? void 0 : s[m.getId()], y = (w == null ? void 0 : w.minWidth) ?? (n == null ? void 0 : n.defaultMinWidth), b = (w == null ? void 0 : w.maxWidth) ?? (n == null ? void 0 : n.defaultMaxWidth), _ = m.getActualWidth();
      return (y == null || _ >= y) && (b == null || _ <= b);
    }))
      return;
    const l = [], a = [];
    i.forEach((C) => {
      C.getColDef().suppressSizeToFit === !0 ? a.push(C) : l.push(C);
    });
    const c = l.slice(0);
    let d = !1;
    const u = (C) => {
      Zt(l, C), a.push(C);
    };
    for (l.forEach((C) => {
      C.resetActualWidth(t);
      const m = s == null ? void 0 : s[C.getId()], w = (m == null ? void 0 : m.minWidth) ?? (n == null ? void 0 : n.defaultMinWidth), y = (m == null ? void 0 : m.maxWidth) ?? (n == null ? void 0 : n.defaultMaxWidth), b = C.getActualWidth();
      typeof w == "number" && b < w ? C.setActualWidth(w, t, !0) : typeof y == "number" && b > y && C.setActualWidth(y, t, !0);
    }); !d; ) {
      d = !0;
      const C = e - yn(a);
      if (C <= 0)
        l.forEach((m) => {
          var y;
          const w = ((y = s == null ? void 0 : s[m.getId()]) == null ? void 0 : y.minWidth) ?? (n == null ? void 0 : n.defaultMinWidth);
          if (typeof w == "number") {
            m.setActualWidth(w, t, !0);
            return;
          }
          m.setActualWidth(m.minWidth, t);
        });
      else {
        const m = C / yn(l);
        let w = C;
        for (let y = l.length - 1; y >= 0; y--) {
          const b = l[y], _ = s == null ? void 0 : s[b.getId()], M = (_ == null ? void 0 : _.minWidth) ?? (n == null ? void 0 : n.defaultMinWidth), x = (_ == null ? void 0 : _.maxWidth) ?? (n == null ? void 0 : n.defaultMaxWidth), L = b.getMinWidth(), A = b.getMaxWidth(), R = typeof M == "number" && M > L ? M : L, P = typeof x == "number" && x < A ? x : A;
          let I = Math.round(b.getActualWidth() * m);
          I < R ? (I = R, u(b), d = !1) : I > P ? (I = P, u(b), d = !1) : y === 0 && (I = w), b.setActualWidth(I, t, !0), w -= I;
        }
      }
    }
    c.forEach((C) => {
      C.fireColumnWidthChangedEvent(t);
    });
    const h = this.beans.visibleCols;
    h.setLeftValues(t), h.updateBodyWidths(), !o && Gi(this.eventSvc, c, !0, t);
  }
  applyAutosizeStrategy() {
    const { gos: e, colDelayRenderSvc: t } = this.beans, o = e.get("autoSizeStrategy");
    !o || o.type === "fitCellContents" || setTimeout(() => {
      if (!this.isAlive())
        return;
      const n = o.type;
      if (n === "fitGridWidth") {
        const { columnLimits: s, defaultMinWidth: i, defaultMaxWidth: r } = o, l = s == null ? void 0 : s.map(({ colId: a, minWidth: c, maxWidth: d }) => ({
          key: a,
          minWidth: c,
          maxWidth: d
        }));
        this.sizeColumnsToFitGridBody({
          defaultMinWidth: i,
          defaultMaxWidth: r,
          columnLimits: l
        });
      } else n === "fitProvidedWidth" && this.sizeColumnsToFit(o.width, "sizeColumnsToFit");
      t == null || t.revealColumns(n);
    });
  }
  onFirstDataRendered(e) {
    const { colIds: t, skipHeader: o, defaultMaxWidth: n, defaultMinWidth: s, columnLimits: i } = e;
    setTimeout(() => {
      if (!this.isAlive())
        return;
      const r = {
        skipHeader: o,
        source: "autosizeColumns",
        defaultMaxWidth: n,
        defaultMinWidth: s,
        columnLimits: i
      };
      t ? this.autoSizeCols({ colKeys: t, ...r }) : this.autoSizeAllColumns(r);
    });
  }
  processResizeOperations() {
    this.shouldQueueResizeOperations = !1, this.resizeOperationQueue.forEach((e) => e()), this.resizeOperationQueue = [];
  }
  pushResizeOperation(e) {
    this.resizeOperationQueue.push(e);
  }
  destroy() {
    this.resizeOperationQueue.length = 0, super.destroy();
  }
};
function LKe(e, t, o = {}) {
  const n = o.minWidth ?? e.getMinWidth();
  t < n && (t = n);
  const s = o.maxWidth ?? e.getMaxWidth();
  return t > s && (t = s), t;
}
var EKe = {
  moduleName: "ColumnAutoSize",
  version: be,
  beans: [AKe],
  apiFunctions: {
    sizeColumnsToFit: xKe,
    autoSizeColumns: s_,
    autoSizeAllColumns: MKe
  },
  dependsOn: [oy]
}, PKe = (
  /*css*/
  ".ag-row-pinned-source{background-color:var(--ag-pinned-source-row-background-color);color:var(--ag-pinned-source-row-text-color);font-weight:var(--ag-pinned-source-row-font-weight)}.ag-row-pinned-manual{background-color:var(--ag-pinned-row-background-color);color:var(--ag-pinned-row-text-color);font-weight:var(--ag-pinned-row-font-weight)}"
);
function RKe(e) {
  var t;
  return ((t = e.pinnedRowModel) == null ? void 0 : t.getPinnedTopRowCount()) ?? 0;
}
function FKe(e) {
  var t;
  return ((t = e.pinnedRowModel) == null ? void 0 : t.getPinnedBottomRowCount()) ?? 0;
}
function TKe(e, t) {
  var o;
  return (o = e.pinnedRowModel) == null ? void 0 : o.getPinnedTopRow(t);
}
function IKe(e, t) {
  var o;
  return (o = e.pinnedRowModel) == null ? void 0 : o.getPinnedBottomRow(t);
}
function DKe(e, t, o) {
  var n;
  return (n = e.pinnedRowModel) == null ? void 0 : n.forEachPinnedRow(t, o);
}
var kKe = {
  moduleName: "PinnedRow",
  version: be,
  beans: [DVe],
  css: [PKe],
  apiFunctions: {
    getPinnedTopRowCount: RKe,
    getPinnedBottomRowCount: FKe,
    getPinnedTopRow: TKe,
    getPinnedBottomRow: IKe,
    forEachPinnedRow: DKe
  },
  icons: {
    rowPin: "pin",
    rowPinTop: "pinned-top",
    rowPinBottom: "pinned-bottom",
    rowUnpin: "un-pin"
  }
}, HKe = class extends Ii {
  constructor(e, t, o) {
    super(e.col, e.firstNode, o, t), this.cellSpan = e, this.SPANNED_CELL_CSS_CLASS = "ag-spanned-cell";
  }
  setComp(e, t, o, n, s, i, r) {
    this.eWrapper = o, super.setComp(e, t, o, n, s, i, r), this.setAriaRowSpan(), this.refreshAriaRowIndex();
  }
  isCellSpanning() {
    return !0;
  }
  getCellSpan() {
    return this.cellSpan;
  }
  /**
   * When cell is spanning, ensure row index is also available on the cell
   */
  refreshAriaRowIndex() {
    this.rowNode.rowIndex != null && Gr(this.eGui, this.rowNode.rowIndex);
  }
  /**
   * When cell is spanning, ensure row index is also available on the cell
   */
  setAriaRowSpan() {
    jTe(this.eGui, this.cellSpan.spannedNodes.size);
  }
  // not ideal, for tabbing need to force the focused position
  setFocusedCellPosition(e) {
    this.focusedCellPosition = e;
  }
  getFocusedCellPosition() {
    return this.focusedCellPosition ?? this.cellPosition;
  }
  checkCellFocused() {
    const e = this.beans.focusSvc.getFocusedCell();
    return !!e && this.cellSpan.doesSpanContain(e);
  }
  applyStaticCssClasses() {
    super.applyStaticCssClasses(), this.comp.toggleCss(this.SPANNED_CELL_CSS_CLASS, !0);
  }
  onCellFocused(e) {
    const { beans: t } = this;
    if (ba(t)) {
      this.focusedCellPosition = void 0;
      return;
    }
    const o = this.isCellFocused();
    o || (this.focusedCellPosition = void 0), e && o && (this.focusedCellPosition = {
      rowIndex: e.rowIndex,
      rowPinned: e.rowPinned,
      column: e.column
      // fix
    }), super.onCellFocused(e);
  }
  getRootElement() {
    return this.eWrapper;
  }
}, VKe = class extends Vl {
  onRowIndexChanged() {
    super.onRowIndexChanged(), this.getAllCellCtrls().forEach((e) => e.refreshAriaRowIndex());
  }
  getInitialRowClasses(e) {
    return ["ag-spanned-row"];
  }
  getNewCellCtrl(e) {
    var n;
    const t = (n = this.beans.rowSpanSvc) == null ? void 0 : n.getCellSpan(e, this.rowNode);
    if (!(!t || t.firstNode !== this.rowNode))
      return new HKe(t, this, this.beans);
  }
  isCorrectCtrlForSpan(e) {
    var n;
    const t = (n = this.beans.rowSpanSvc) == null ? void 0 : n.getCellSpan(e.column, this.rowNode);
    return !t || t.firstNode !== this.rowNode ? !1 : e.getCellSpan() === t;
  }
  /**
   * Below overrides are explicitly disabling styling and other unwanted behaviours for spannedRowCtrl
   */
  // row height should be 0 in spanned row - they're only included for purpose of aria
  onRowHeightChanged() {
  }
  // no styling spanned rows
  refreshFirstAndLastRowStyles() {
  }
  // no hover functionality for spanned rows
  addHoverFunctionality() {
  }
  resetHoveredStatus() {
  }
}, OKe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "spannedRowRenderer", this.topCtrls = /* @__PURE__ */ new Map(), this.bottomCtrls = /* @__PURE__ */ new Map(), this.centerCtrls = /* @__PURE__ */ new Map();
  }
  postConstruct() {
    this.addManagedEventListeners({
      displayedRowsChanged: this.createAllCtrls.bind(this)
    });
  }
  createAllCtrls() {
    this.createCtrls("top"), this.createCtrls("bottom"), this.createCtrls("center");
  }
  /**
   * When displayed rows or cols change, the spanned cell ctrls need to update
   */
  createCtrls(e) {
    const { rowSpanSvc: t } = this.beans, o = `${e}Ctrls`, n = this[o], s = n.size, i = this.getAllRelevantRowControls(e), r = /* @__PURE__ */ new Map();
    let l = !1;
    for (const c of i)
      c.isAlive() && (t == null || t.forEachSpannedColumn(c.rowNode, (d, u) => {
        if (r.has(u.firstNode))
          return;
        const h = n.get(u.firstNode);
        if (h) {
          r.set(u.firstNode, h), n.delete(u.firstNode);
          return;
        }
        l = !0;
        const p = new VKe(u.firstNode, this.beans, !1, !1, !1);
        r.set(u.firstNode, p);
      }));
    this[o] = r;
    const a = r.size === s;
    if (!(!l && a)) {
      for (const c of n.values())
        c.destroyFirstPass(!0), c.destroySecondPass();
      this.dispatchLocalEvent({
        type: "spannedRowsUpdated",
        ctrlsKey: e
      });
    }
  }
  // cannot use getAllRowCtrls as it returns this services row ctrls.
  getAllRelevantRowControls(e) {
    const { rowRenderer: t } = this.beans;
    switch (e) {
      case "top":
        return t.topRowCtrls;
      case "bottom":
        return t.bottomRowCtrls;
      case "center":
        return t.allRowCtrls;
    }
  }
  getCellByPosition(e) {
    const { rowSpanSvc: t } = this.beans, o = t == null ? void 0 : t.getCellSpanByPosition(e);
    if (!o)
      return;
    const n = `${i_(e.rowPinned)}Ctrls`, s = this[n].get(o.firstNode);
    if (s)
      return s.getAllCellCtrls().find((i) => i.column === e.column);
  }
  getCtrls(e) {
    const t = `${e}Ctrls`;
    return [...this[t].values()];
  }
  destroyRowCtrls(e) {
    const t = `${e}Ctrls`;
    for (const o of this[t].values())
      o.destroyFirstPass(!0), o.destroySecondPass();
    this[t] = /* @__PURE__ */ new Map();
  }
  destroy() {
    super.destroy(), this.destroyRowCtrls("top"), this.destroyRowCtrls("bottom"), this.destroyRowCtrls("center");
  }
}, i_ = (e) => e ?? "center", BKe = class {
  constructor(e, t) {
    this.col = e, this.firstNode = t, this.cellSpan = !0, this.spannedNodes = /* @__PURE__ */ new Set(), this.addSpannedNode(t);
  }
  /**
   * Reset the span leaving only the head.
   * Head is used as a comparison as this is the row used to render this cell
   * Even if the row data changes, the cell will properly reflect the correct value.
   */
  reset() {
    this.spannedNodes.clear(), this.addSpannedNode(this.firstNode);
  }
  addSpannedNode(e) {
    this.spannedNodes.add(e), this.lastNode = e;
  }
  getLastNode() {
    return this.lastNode;
  }
  getCellHeight() {
    return this.lastNode.rowTop + this.lastNode.rowHeight - this.firstNode.rowTop - 1;
  }
  doesSpanContain(e) {
    return e.column !== this.col || e.rowPinned != this.firstNode.rowPinned ? !1 : this.firstNode.rowIndex <= e.rowIndex && e.rowIndex <= this.lastNode.rowIndex;
  }
  /**
   * Gets the auto height value for last node in the spanned cell.
   * The first node is used to store the auto height for the cell, but the additional height for this cell
   * needs applied to the last row in the span.
   */
  getLastNodeAutoHeight() {
    var o;
    const e = (o = this.firstNode.__autoHeights) == null ? void 0 : o[this.col.getColId()];
    if (e == null)
      return;
    let t = 0;
    return this.spannedNodes.forEach((n) => {
      n !== this.lastNode && (t += n.rowHeight);
    }), e - t;
  }
}, $Ke = class extends K {
  constructor(e) {
    super(), this.column = e;
  }
  buildCache(e) {
    var _;
    const {
      column: t,
      beans: { gos: o, pinnedRowModel: n, rowModel: s, valueSvc: i, pagination: r }
    } = this, { colDef: l } = t, a = this[`${e}ValueNodeMap`], c = /* @__PURE__ */ new Map(), d = o.getCallback("isFullWidthRow"), u = l.equals, h = l.spanRows, p = typeof h == "function";
    let C = null, m = null, w;
    const y = (M, x) => {
      C = M, m = null, w = x;
    }, b = (M) => {
      const x = !M.isExpandable() && !M.group && !M.detail && (d ? !d({ rowNode: M }) : !0);
      if (M.rowIndex == null || !x) {
        y(null, null);
        return;
      }
      if (C == null || M.level !== C.level || // no span across groups
      M.footer || m && M.rowIndex - 1 !== (m == null ? void 0 : m.getLastNode().rowIndex)) {
        y(M, i.getValue(t, M));
        return;
      }
      const L = i.getValue(t, M);
      if (p) {
        const A = Pe(o, {
          valueA: w,
          nodeA: C,
          valueB: L,
          nodeB: M,
          column: t,
          colDef: l
        });
        if (!h(A)) {
          y(M, L);
          return;
        }
      } else if (u ? !u(w, L) : w !== L) {
        y(M, L);
        return;
      }
      if (!m) {
        const A = a == null ? void 0 : a.get(C);
        (A == null ? void 0 : A.firstNode) === C ? (A.reset(), m = A) : m = new BKe(t, C), c.set(C, m);
      }
      m.addSpannedNode(M), c.set(M, m);
    };
    switch (e) {
      case "center":
        (_ = s.forEachDisplayedNode) == null || _.call(s, (M) => {
          (!r || r.isRowInPage(M.rowIndex)) && b(M);
        });
        break;
      case "top":
        n == null || n.forEachPinnedRow("top", b);
        break;
      case "bottom":
        n == null || n.forEachPinnedRow("bottom", b);
        break;
    }
    this[`${e}ValueNodeMap`] = c;
  }
  isCellSpanning(e) {
    return !!this.getCellSpan(e);
  }
  getCellSpan(e) {
    return this[`${i_(e.rowPinned)}ValueNodeMap`].get(e);
  }
}, ZKe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "rowSpanSvc", this.spanningColumns = /* @__PURE__ */ new Map(), this.debouncePinnedEvent = Rt(this, this.dispatchCellsUpdatedEvent.bind(this, !0), 0), this.debounceModelEvent = Rt(this, this.dispatchCellsUpdatedEvent.bind(this, !1), 0), this.pinnedTimeout = null, this.modelTimeout = null;
  }
  postConstruct() {
    const e = this.onRowDataUpdated.bind(this), t = this.buildPinnedCaches.bind(this);
    this.addManagedEventListeners({
      paginationChanged: this.buildModelCaches.bind(this),
      pinnedRowDataChanged: t,
      pinnedRowsChanged: t,
      rowNodeDataChanged: e,
      cellValueChanged: e
    });
  }
  /**
   * When a new column is created with spanning (or spanning changes for a column)
   * @param column column that is now spanning
   */
  register(e) {
    const { gos: t } = this.beans;
    if (!t.get("enableCellSpan") || this.spanningColumns.has(e))
      return;
    const o = this.createManagedBean(new $Ke(e));
    this.spanningColumns.set(e, o), o.buildCache("top"), o.buildCache("bottom"), o.buildCache("center"), this.debouncePinnedEvent(), this.debounceModelEvent();
  }
  dispatchCellsUpdatedEvent(e) {
    this.dispatchLocalEvent({ type: "spannedCellsUpdated", pinned: e });
  }
  /**
   * When a new column is destroyed with spanning (or spanning changes for a column)
   * @param column column that is now spanning
   */
  deregister(e) {
    this.spanningColumns.delete(e);
  }
  // called when data changes, as this could be a hot path it's debounced
  // it uses timeouts instead of debounce so that it can be cancelled by `modelUpdated`
  // which is expected to run immediately (to exec before the rowRenderer)
  onRowDataUpdated({ node: e }) {
    const { spannedRowRenderer: t } = this.beans;
    if (e.rowPinned) {
      if (this.pinnedTimeout != null)
        return;
      this.pinnedTimeout = window.setTimeout(() => {
        this.pinnedTimeout = null, this.buildPinnedCaches(), t == null || t.createCtrls("top"), t == null || t.createCtrls("bottom");
      }, 0);
      return;
    }
    this.modelTimeout == null && (this.modelTimeout = window.setTimeout(() => {
      this.modelTimeout = null, this.buildModelCaches(), t == null || t.createCtrls("center");
    }, 0));
  }
  buildModelCaches() {
    this.modelTimeout != null && clearTimeout(this.modelTimeout), this.spanningColumns.forEach((e) => e.buildCache("center")), this.debounceModelEvent();
  }
  buildPinnedCaches() {
    this.pinnedTimeout != null && clearTimeout(this.pinnedTimeout), this.spanningColumns.forEach((e) => {
      e.buildCache("top"), e.buildCache("bottom");
    }), this.debouncePinnedEvent();
  }
  isCellSpanning(e, t) {
    const o = this.spanningColumns.get(e);
    return o ? o.isCellSpanning(t) : !1;
  }
  getCellSpanByPosition(e) {
    const { pinnedRowModel: t, rowModel: o } = this.beans, n = e.column, s = e.rowIndex, i = this.spanningColumns.get(n);
    if (!i)
      return;
    let r;
    switch (e.rowPinned) {
      case "top":
        r = t == null ? void 0 : t.getPinnedTopRow(s);
        break;
      case "bottom":
        r = t == null ? void 0 : t.getPinnedBottomRow(s);
        break;
      default:
        r = o.getRow(s);
    }
    if (r)
      return i.getCellSpan(r);
  }
  getCellStart(e) {
    const t = this.getCellSpanByPosition(e);
    return t ? { ...e, rowIndex: t.firstNode.rowIndex } : e;
  }
  getCellEnd(e) {
    const t = this.getCellSpanByPosition(e);
    return t ? { ...e, rowIndex: t.getLastNode().rowIndex } : e;
  }
  /**
   * Look-up a spanned cell given a col and node as position indicators
   *
   * @param col a column to lookup a span at this position
   * @param rowNode a node that may be spanned at this position
   * @returns the CellSpan object if one exists
   */
  getCellSpan(e, t) {
    const o = this.spanningColumns.get(e);
    if (o)
      return o.getCellSpan(t);
  }
  forEachSpannedColumn(e, t) {
    for (const [o, n] of this.spanningColumns)
      if (n.isCellSpanning(e)) {
        const s = n.getCellSpan(e);
        t(o, s);
      }
  }
  destroy() {
    super.destroy(), this.spanningColumns.clear();
  }
}, GKe = {
  moduleName: "CellSpan",
  version: be,
  beans: [ZKe, OKe]
}, NKe = class extends K {
  constructor(e, t) {
    super(), this.cellCtrl = e, this.staticClasses = [], this.beans = t, this.column = e.column;
  }
  setComp(e) {
    this.cellComp = e, this.applyUserStyles(), this.applyCellClassRules(), this.applyClassesFromColDef();
  }
  applyCellClassRules() {
    const { column: e, cellComp: t } = this, o = e.colDef, n = o.cellClassRules, s = this.getCellClassParams(e, o);
    rc(
      this.beans.expressionSvc,
      // if current was previous, skip
      n === this.cellClassRules ? void 0 : this.cellClassRules,
      n,
      s,
      (i) => t.toggleCss(i, !0),
      (i) => t.toggleCss(i, !1)
    ), this.cellClassRules = n;
  }
  applyUserStyles() {
    const e = this.column, t = e.colDef, o = t.cellStyle;
    if (!o)
      return;
    let n;
    if (typeof o == "function") {
      const s = this.getCellClassParams(e, t);
      n = o(s);
    } else
      n = o;
    n && this.cellComp.setUserStyles(n);
  }
  applyClassesFromColDef() {
    const { column: e, cellComp: t } = this, o = e.colDef, n = this.getCellClassParams(e, o);
    this.staticClasses.forEach((i) => t.toggleCss(i, !1));
    const s = this.beans.cellStyles.getStaticCellClasses(o, n);
    this.staticClasses = s, s.forEach((i) => t.toggleCss(i, !0));
  }
  getCellClassParams(e, t) {
    const { value: o, rowNode: n } = this.cellCtrl;
    return Pe(this.beans.gos, {
      value: o,
      data: n.data,
      node: n,
      colDef: t,
      column: e,
      rowIndex: n.rowIndex
    });
  }
}, zKe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "cellStyles";
  }
  processAllCellClasses(e, t, o, n) {
    rc(
      this.beans.expressionSvc,
      void 0,
      e.cellClassRules,
      t,
      o,
      n
    ), this.processStaticCellClasses(e, t, o);
  }
  getStaticCellClasses(e, t) {
    const { cellClass: o } = e;
    if (!o)
      return [];
    let n;
    return typeof o == "function" ? n = o(t) : n = o, typeof n == "string" && (n = [n]), n || [];
  }
  createCellCustomStyleFeature(e, t) {
    return new NKe(e, t);
  }
  processStaticCellClasses(e, t, o) {
    this.getStaticCellClasses(e, t).forEach((s) => {
      o(s);
    });
  }
}, jKe = {
  moduleName: "CellStyle",
  version: be,
  beans: [zKe]
}, WKe = {
  moduleName: "RowStyle",
  version: be,
  beans: [BGe]
};
function UKe(e, t) {
  var o;
  return !!((o = e.colHover) != null && o.isHovered(t));
}
var KKe = class extends K {
  constructor(e, t) {
    super(), this.columns = e, this.element = t, this.destroyManagedListeners = [], this.enableFeature = (o) => {
      const { beans: n, gos: s, element: i, columns: r } = this, l = n.colHover;
      o ?? !!s.get("columnHoverHighlight") ? this.destroyManagedListeners = this.addManagedElementListeners(i, {
        mouseover: l.setMouseOver.bind(l, r),
        mouseout: l.clearMouseOver.bind(l)
      }) : (this.destroyManagedListeners.forEach((c) => c()), this.destroyManagedListeners = []);
    };
  }
  postConstruct() {
    this.addManagedPropertyListener("columnHoverHighlight", ({ currentValue: e }) => {
      this.enableFeature(e);
    }), this.enableFeature();
  }
  destroy() {
    super.destroy(), this.destroyManagedListeners = null;
  }
}, qKe = "ag-column-hover", YKe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "colHover";
  }
  postConstruct() {
    this.addManagedPropertyListener("columnHoverHighlight", ({ currentValue: e }) => {
      e || this.clearMouseOver();
    });
  }
  setMouseOver(e) {
    this.updateState(e);
  }
  clearMouseOver() {
    this.updateState(null);
  }
  isHovered(e) {
    if (!this.gos.get("columnHoverHighlight"))
      return !1;
    const t = this.selectedColumns;
    return !!t && t.indexOf(e) >= 0;
  }
  addHeaderColumnHoverListener(e, t, o) {
    const n = () => {
      const s = this.isHovered(o);
      t.toggleCss("ag-column-hover", s);
    };
    e.addManagedEventListeners({ columnHoverChanged: n }), n();
  }
  onCellColumnHover(e, t) {
    if (!t)
      return;
    const o = this.isHovered(e);
    t.toggleCss(qKe, o);
  }
  addHeaderFilterColumnHoverListener(e, t, o, n) {
    this.createHoverFeature(e, [o], n);
    const s = () => {
      const i = this.isHovered(o);
      t.toggleCss("ag-column-hover", i);
    };
    e.addManagedEventListeners({ columnHoverChanged: s }), s();
  }
  createHoverFeature(e, t, o) {
    e.createManagedBean(new KKe(t, o));
  }
  updateState(e) {
    this.selectedColumns = e, this.eventSvc.dispatchEvent({
      type: "columnHoverChanged"
    });
  }
}, QKe = {
  moduleName: "ColumnHover",
  version: be,
  beans: [YKe],
  apiFunctions: {
    isColumnHovered: UKe
  }
}, JKe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "apiEventSvc", this.syncListeners = /* @__PURE__ */ new Map(), this.asyncListeners = /* @__PURE__ */ new Map(), this.syncGlobalListeners = /* @__PURE__ */ new Set(), this.globalListenerPairs = /* @__PURE__ */ new Map();
  }
  postConstruct() {
    var e, t;
    this.wrapSvc = (t = (e = this.beans.frameworkOverrides).createGlobalEventListenerWrapper) == null ? void 0 : t.call(e);
  }
  addListener(e, t) {
    var i;
    const o = ((i = this.wrapSvc) == null ? void 0 : i.wrap(e, t)) ?? t, n = !Rr.has(e), s = n ? this.asyncListeners : this.syncListeners;
    s.has(e) || s.set(e, /* @__PURE__ */ new Set()), s.get(e).add(o), this.eventSvc.addListener(e, o, n);
  }
  removeListener(e, t) {
    var i, r;
    const o = ((i = this.wrapSvc) == null ? void 0 : i.unwrap(e, t)) ?? t, n = this.asyncListeners.get(e), s = !!(n != null && n.delete(o));
    s || (r = this.syncListeners.get(e)) == null || r.delete(o), this.eventSvc.removeListener(e, o, s);
  }
  addGlobalListener(e) {
    var i;
    const t = ((i = this.wrapSvc) == null ? void 0 : i.wrapGlobal(e)) ?? e, o = (r, l) => {
      Rr.has(r) && t(r, l);
    }, n = (r, l) => {
      Rr.has(r) || t(r, l);
    };
    this.globalListenerPairs.set(e, { syncListener: o, asyncListener: n });
    const s = this.eventSvc;
    s.addGlobalListener(o, !1), s.addGlobalListener(n, !0);
  }
  removeGlobalListener(e) {
    const { eventSvc: t, wrapSvc: o, globalListenerPairs: n } = this, s = (o == null ? void 0 : o.unwrapGlobal(e)) ?? e;
    if (n.has(s)) {
      const { syncListener: r, asyncListener: l } = n.get(s);
      t.removeGlobalListener(r, !1), t.removeGlobalListener(l, !0), n.delete(e);
    } else
      this.syncGlobalListeners.delete(s), t.removeGlobalListener(s, !1);
  }
  destroyEventListeners(e, t) {
    e.forEach((o, n) => {
      o.forEach((s) => this.eventSvc.removeListener(n, s, t)), o.clear();
    }), e.clear();
  }
  destroyGlobalListeners(e, t) {
    e.forEach((o) => this.eventSvc.removeGlobalListener(o, t)), e.clear();
  }
  destroy() {
    super.destroy(), this.destroyEventListeners(this.syncListeners, !1), this.destroyEventListeners(this.asyncListeners, !0), this.destroyGlobalListeners(this.syncGlobalListeners, !1);
    const { globalListenerPairs: e, eventSvc: t } = this;
    e.forEach(({ syncListener: o, asyncListener: n }) => {
      t.removeGlobalListener(o, !1), t.removeGlobalListener(n, !0);
    }), e.clear();
  }
};
function XKe(e, t, o) {
  var n;
  (n = e.apiEventSvc) == null || n.addListener(t, o);
}
function eqe(e, t, o) {
  var n;
  (n = e.apiEventSvc) == null || n.removeListener(t, o);
}
function tqe(e, t) {
  var o;
  (o = e.apiEventSvc) == null || o.addGlobalListener(t);
}
function oqe(e, t) {
  var o;
  (o = e.apiEventSvc) == null || o.removeGlobalListener(t);
}
var r_ = {
  moduleName: "EventApi",
  version: be,
  apiFunctions: {
    addEventListener: XKe,
    addGlobalListener: tqe,
    removeEventListener: eqe,
    removeGlobalListener: oqe
  },
  beans: [JKe]
}, nqe = {
  moduleName: "Locale",
  version: be,
  beans: [ONe]
}, sqe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "rowAutoHeight", this.wasEverActive = !1, this._debouncedCalculateRowHeights = Rt(this, this.calculateRowHeights.bind(this), 1);
  }
  /**
   * If row height has been active, request a refresh of the row heights.
   */
  requestCheckAutoHeight() {
    this.wasEverActive && this._debouncedCalculateRowHeights();
  }
  calculateRowHeights() {
    var l, a, c, d;
    const { visibleCols: e, rowModel: t, rowSpanSvc: o, pinnedRowModel: n } = this.beans, s = e.autoHeightCols;
    let i = !1;
    const r = (u) => {
      var C;
      const h = u.__autoHeights;
      let p = Dn(this.beans, u).height;
      for (const m of s) {
        let w = h == null ? void 0 : h[m.getColId()];
        const y = o == null ? void 0 : o.getCellSpan(m, u);
        if (y) {
          if (y.getLastNode() !== u)
            continue;
          if (w = (C = o == null ? void 0 : o.getCellSpan(m, u)) == null ? void 0 : C.getLastNodeAutoHeight(), !w)
            return;
        }
        if (w == null) {
          if (this.colSpanSkipCell(m, u))
            continue;
          return;
        }
        p = Math.max(w, p);
      }
      p !== u.rowHeight && (u.setRowHeight(p), i = !0);
    };
    (l = n == null ? void 0 : n.forEachPinnedRow) == null || l.call(n, "top", r), (a = n == null ? void 0 : n.forEachPinnedRow) == null || a.call(n, "bottom", r), (c = t.forEachDisplayedNode) == null || c.call(t, r), i && ((d = t.onRowHeightChanged) == null || d.call(t));
  }
  /**
   * Set the cell height into the row node, and request a refresh of the row heights if there's been a change.
   * @param rowNode the node to set the auto height on
   * @param cellHeight the height to set, undefined if the cell has just been destroyed
   * @param column the column of the cell
   */
  setRowAutoHeight(e, t, o) {
    if (e.__autoHeights ?? (e.__autoHeights = {}), t == null) {
      delete e.__autoHeights[o.getId()];
      return;
    }
    const n = e.__autoHeights[o.getId()];
    e.__autoHeights[o.getId()] = t, n !== t && this.requestCheckAutoHeight();
  }
  /**
   * If using col span, then cells which have been spanned over do not need an auto height value
   * @param col the column of the cell
   * @param node the node of the cell
   * @returns whether the row needs auto height value for that column
   */
  colSpanSkipCell(e, t) {
    const { colModel: o, colViewport: n, visibleCols: s } = this.beans;
    if (!o.colSpanActive)
      return !1;
    let i = [];
    switch (e.getPinned()) {
      case "left":
        i = s.getLeftColsForRow(t);
        break;
      case "right":
        i = s.getRightColsForRow(t);
        break;
      case null:
        i = n.getColsWithinViewport(t);
        break;
    }
    return !i.includes(e);
  }
  /**
   * If required, sets up observers to continuously measure changes in the cell height.
   * @param cellCtrl the cellCtrl of the cell
   * @param eCellWrapper the HTMLElement to track the height of
   * @param compBean the component bean to add the destroy/cleanup function to
   * @returns whether or not auto height has been set up on this cell
   */
  setupCellAutoHeight(e, t, o) {
    if (!e.column.isAutoHeight() || !t)
      return !1;
    this.wasEverActive = !0;
    const n = t.parentElement, { rowNode: s, column: i } = e, r = this.beans, l = (d) => {
      var b;
      if ((b = this.beans.editSvc) != null && b.isEditing(e) || !e.isAlive() || !o.isAlive())
        return;
      const { paddingTop: u, paddingBottom: h, borderBottomWidth: p, borderTopWidth: C } = si(n), m = u + h + p + C, y = t.offsetHeight + m;
      if (d < 5) {
        const _ = Pt(r), M = !_ || !_.contains(t), x = y == 0;
        if (M || x) {
          window.setTimeout(() => l(d + 1), 0);
          return;
        }
      }
      this.setRowAutoHeight(s, y, i);
    }, a = () => l(0);
    a();
    const c = mn(r, t, a);
    return o.addDestroyFunc(() => {
      c(), this.setRowAutoHeight(s, void 0, i);
    }), !0;
  }
  setAutoHeightActive(e) {
    this.active = e.list.some((t) => t.isVisible() && t.isAutoHeight());
  }
  /**
   * Determines if the row auto height service has cells to grow.
   * @returns true if all of the rendered rows are at least as tall as their rendered cells.
   */
  areRowsMeasured() {
    if (!this.active)
      return !0;
    const e = this.beans.rowRenderer.getAllRowCtrls();
    let t = null;
    for (const { rowNode: o } of e)
      if ((!t || this.beans.colModel.colSpanActive) && (t = this.beans.colViewport.getColsWithinViewport(o).filter((s) => s.isAutoHeight())), t.length !== 0) {
        if (!o.__autoHeights)
          return !1;
        for (const n of t) {
          const s = o.__autoHeights[n.getColId()];
          if (!s || o.rowHeight < s)
            return !1;
        }
      }
    return !0;
  }
}, iqe = {
  moduleName: "RowAutoHeight",
  version: be,
  beans: [sqe]
}, rqe = {
  moduleName: "AllCommunity",
  version: be,
  dependsOn: [
    rUe,
    pUe,
    xUe,
    nze,
    hWe,
    gWe,
    pWe,
    fWe,
    vWe,
    mWe,
    CWe,
    uWe,
    sje,
    ije,
    rje,
    nje,
    aje,
    cje,
    $Ue,
    NWe,
    iKe,
    ny,
    n_,
    fKe,
    SKe,
    EKe,
    NOe,
    kKe,
    IWe,
    yNe,
    jKe,
    QKe,
    WKe,
    r_,
    xNe,
    DUe,
    fc,
    nqe,
    iqe,
    GOe,
    lUe,
    GKe
  ]
}, lqe = class {
  constructor() {
    this.ieCompatibility = !1;
  }
  init() {
    this.ieCompatibility = this.md5("hello") != "5d41402abc4b2a76b9719d911017c592";
  }
  md5cycle(e, t) {
    let o = e[0], n = e[1], s = e[2], i = e[3];
    o = this.ff(o, n, s, i, t[0], 7, -680876936), i = this.ff(i, o, n, s, t[1], 12, -389564586), s = this.ff(s, i, o, n, t[2], 17, 606105819), n = this.ff(n, s, i, o, t[3], 22, -1044525330), o = this.ff(o, n, s, i, t[4], 7, -176418897), i = this.ff(i, o, n, s, t[5], 12, 1200080426), s = this.ff(s, i, o, n, t[6], 17, -1473231341), n = this.ff(n, s, i, o, t[7], 22, -45705983), o = this.ff(o, n, s, i, t[8], 7, 1770035416), i = this.ff(i, o, n, s, t[9], 12, -1958414417), s = this.ff(s, i, o, n, t[10], 17, -42063), n = this.ff(n, s, i, o, t[11], 22, -1990404162), o = this.ff(o, n, s, i, t[12], 7, 1804603682), i = this.ff(i, o, n, s, t[13], 12, -40341101), s = this.ff(s, i, o, n, t[14], 17, -1502002290), n = this.ff(n, s, i, o, t[15], 22, 1236535329), o = this.gg(o, n, s, i, t[1], 5, -165796510), i = this.gg(i, o, n, s, t[6], 9, -1069501632), s = this.gg(s, i, o, n, t[11], 14, 643717713), n = this.gg(n, s, i, o, t[0], 20, -373897302), o = this.gg(o, n, s, i, t[5], 5, -701558691), i = this.gg(i, o, n, s, t[10], 9, 38016083), s = this.gg(s, i, o, n, t[15], 14, -660478335), n = this.gg(n, s, i, o, t[4], 20, -405537848), o = this.gg(o, n, s, i, t[9], 5, 568446438), i = this.gg(i, o, n, s, t[14], 9, -1019803690), s = this.gg(s, i, o, n, t[3], 14, -187363961), n = this.gg(n, s, i, o, t[8], 20, 1163531501), o = this.gg(o, n, s, i, t[13], 5, -1444681467), i = this.gg(i, o, n, s, t[2], 9, -51403784), s = this.gg(s, i, o, n, t[7], 14, 1735328473), n = this.gg(n, s, i, o, t[12], 20, -1926607734), o = this.hh(o, n, s, i, t[5], 4, -378558), i = this.hh(i, o, n, s, t[8], 11, -2022574463), s = this.hh(s, i, o, n, t[11], 16, 1839030562), n = this.hh(n, s, i, o, t[14], 23, -35309556), o = this.hh(o, n, s, i, t[1], 4, -1530992060), i = this.hh(i, o, n, s, t[4], 11, 1272893353), s = this.hh(s, i, o, n, t[7], 16, -155497632), n = this.hh(n, s, i, o, t[10], 23, -1094730640), o = this.hh(o, n, s, i, t[13], 4, 681279174), i = this.hh(i, o, n, s, t[0], 11, -358537222), s = this.hh(s, i, o, n, t[3], 16, -722521979), n = this.hh(n, s, i, o, t[6], 23, 76029189), o = this.hh(o, n, s, i, t[9], 4, -640364487), i = this.hh(i, o, n, s, t[12], 11, -421815835), s = this.hh(s, i, o, n, t[15], 16, 530742520), n = this.hh(n, s, i, o, t[2], 23, -995338651), o = this.ii(o, n, s, i, t[0], 6, -198630844), i = this.ii(i, o, n, s, t[7], 10, 1126891415), s = this.ii(s, i, o, n, t[14], 15, -1416354905), n = this.ii(n, s, i, o, t[5], 21, -57434055), o = this.ii(o, n, s, i, t[12], 6, 1700485571), i = this.ii(i, o, n, s, t[3], 10, -1894986606), s = this.ii(s, i, o, n, t[10], 15, -1051523), n = this.ii(n, s, i, o, t[1], 21, -2054922799), o = this.ii(o, n, s, i, t[8], 6, 1873313359), i = this.ii(i, o, n, s, t[15], 10, -30611744), s = this.ii(s, i, o, n, t[6], 15, -1560198380), n = this.ii(n, s, i, o, t[13], 21, 1309151649), o = this.ii(o, n, s, i, t[4], 6, -145523070), i = this.ii(i, o, n, s, t[11], 10, -1120210379), s = this.ii(s, i, o, n, t[2], 15, 718787259), n = this.ii(n, s, i, o, t[9], 21, -343485551), e[0] = this.add32(o, e[0]), e[1] = this.add32(n, e[1]), e[2] = this.add32(s, e[2]), e[3] = this.add32(i, e[3]);
  }
  cmn(e, t, o, n, s, i) {
    return t = this.add32(this.add32(t, e), this.add32(n, i)), this.add32(t << s | t >>> 32 - s, o);
  }
  ff(e, t, o, n, s, i, r) {
    return this.cmn(t & o | ~t & n, e, t, s, i, r);
  }
  gg(e, t, o, n, s, i, r) {
    return this.cmn(t & n | o & ~n, e, t, s, i, r);
  }
  hh(e, t, o, n, s, i, r) {
    return this.cmn(t ^ o ^ n, e, t, s, i, r);
  }
  ii(e, t, o, n, s, i, r) {
    return this.cmn(o ^ (t | ~n), e, t, s, i, r);
  }
  md51(e) {
    const t = e.length, o = [1732584193, -271733879, -1732584194, 271733878];
    let n;
    for (n = 64; n <= e.length; n += 64)
      this.md5cycle(o, this.md5blk(e.substring(n - 64, n)));
    e = e.substring(n - 64);
    const s = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    for (n = 0; n < e.length; n++)
      s[n >> 2] |= e.charCodeAt(n) << (n % 4 << 3);
    if (s[n >> 2] |= 128 << (n % 4 << 3), n > 55)
      for (this.md5cycle(o, s), n = 0; n < 16; n++)
        s[n] = 0;
    return s[14] = t * 8, this.md5cycle(o, s), o;
  }
  /* there needs to be support for Unicode here, * unless we pretend that we can redefine the MD-5
   * algorithm for multi-byte characters (perhaps by adding every four 16-bit characters and
   * shortening the sum to 32 bits). Otherwise I suthis.ggest performing MD-5 as if every character
   * was two bytes--e.g., 0040 0025 = @%--but then how will an ordinary MD-5 sum be matched?
   * There is no way to standardize text to something like UTF-8 before transformation; speed cost is
   * utterly prohibitive. The JavaScript standard itself needs to look at this: it should start
   * providing access to strings as preformed UTF-8 8-bit unsigned value arrays.
   */
  md5blk(e) {
    const t = [];
    for (let o = 0; o < 64; o += 4)
      t[o >> 2] = e.charCodeAt(o) + (e.charCodeAt(o + 1) << 8) + (e.charCodeAt(o + 2) << 16) + (e.charCodeAt(o + 3) << 24);
    return t;
  }
  rhex(e) {
    const t = "0123456789abcdef".split("");
    let o = "", n = 0;
    for (; n < 4; n++)
      o += t[e >> n * 8 + 4 & 15] + t[e >> n * 8 & 15];
    return o;
  }
  hex(e) {
    for (let t = 0; t < e.length; t++)
      e[t] = this.rhex(e[t]);
    return e.join("");
  }
  md5(e) {
    return this.hex(this.md51(e));
  }
  add32(e, t) {
    return this.ieCompatibility ? this.add32Compat(e, t) : this.add32Std(e, t);
  }
  /* this function is much faster, so if possible we use it. Some IEs are the only ones I know of that
   need the idiotic second function, generated by an if clause.  */
  add32Std(e, t) {
    return e + t & 4294967295;
  }
  add32Compat(e, t) {
    const o = (e & 65535) + (t & 65535);
    return (e >> 16) + (t >> 16) + (o >> 16) << 16 | o & 65535;
  }
}, k1 = {
  "01": "GRID",
  "02": "CHARTS",
  "0102": "BOTH"
}, Iu = "https://www.ag-grid.com/licensing/", l_ = class co {
  constructor(t) {
    this.watermarkMessage = void 0, this.totalMessageLength = 124, this.document = t, this.md5 = new lqe(), this.md5.init();
  }
  validateLicense() {
    const t = this.getLicenseDetails(co.licenseKey), o = `AG Grid ${t.currentLicenseType === "BOTH" ? "and AG Charts " : ""}Enterprise`, n = t.suppliedLicenseType === void 0 ? "" : `AG ${t.suppliedLicenseType === "BOTH" ? "Grid and AG Charts" : t.suppliedLicenseType === "GRID" ? "Grid" : "Charts"} Enterprise`;
    if (t.missing)
      (!this.isWebsiteUrl() || this.isForceWatermark()) && this.outputMissingLicenseKey(o);
    else if (t.expired) {
      const s = co.getGridReleaseDate(), i = co.formatDate(s);
      this.outputExpiredKey(t.expiry, i, o, n);
    } else t.valid ? t.isTrial && t.trialExpired && this.outputExpiredTrialKey(t.expiry, o, n) : this.outputInvalidLicenseKey(
      !!t.incorrectLicenseType,
      o,
      n
    );
  }
  static extractExpiry(t) {
    const o = t.substring(t.lastIndexOf("_") + 1, t.length);
    return new Date(parseInt(co.decode(o), 10));
  }
  static extractLicenseComponents(t) {
    let o = t.replace(/[\u200B-\u200D\uFEFF]/g, "");
    if (o = o.replace(/\r?\n|\r/g, ""), t.length <= 32)
      return { md5: null, license: t, version: null, isTrial: null };
    const n = o.length - 32, s = o.substring(n), i = o.substring(0, n), [r, l, a] = co.extractBracketedInformation(o);
    return { md5: s, license: i, version: r, isTrial: l, type: a };
  }
  getLicenseDetails(t) {
    const o = co.chartsLicenseManager ? "BOTH" : "GRID";
    if (!(t != null && t.length))
      return {
        licenseKey: t,
        valid: !1,
        missing: !0,
        currentLicenseType: o
      };
    const n = co.getGridReleaseDate(), { md5: s, license: i, version: r, isTrial: l, type: a } = co.extractLicenseComponents(t);
    let c = s === this.md5.md5(i) && t.indexOf("For_Trialing_ag-Grid_Only") === -1, d, u, h = null, p = !1, C;
    function m() {
      d = h < /* @__PURE__ */ new Date(), u = void 0;
    }
    if (c && (h = co.extractExpiry(i), c = !isNaN(h.getTime()), c))
      switch (u = n > h, r) {
        case "legacy":
        case "2": {
          l && m();
          break;
        }
        case "3":
          a != null && a.length ? (C = a, a !== k1["01"] && a !== k1["0102"] || o === "BOTH" && C !== "BOTH" ? (c = !1, p = !0) : l && m()) : c = !1;
      }
    return c ? {
      licenseKey: t,
      valid: c,
      expiry: co.formatDate(h),
      expired: u,
      version: r,
      isTrial: l,
      trialExpired: d,
      incorrectLicenseType: p,
      currentLicenseType: o,
      suppliedLicenseType: C
    } : {
      licenseKey: t,
      valid: c,
      incorrectLicenseType: p,
      currentLicenseType: o,
      suppliedLicenseType: C
    };
  }
  isDisplayWatermark() {
    var t;
    return this.isForceWatermark() || !this.isLocalhost() && !this.isWebsiteUrl() && !!((t = this.watermarkMessage) != null && t.length);
  }
  getWatermarkMessage() {
    return this.watermarkMessage || "";
  }
  getHostname() {
    const o = (this.document.defaultView || window).location, { hostname: n = "" } = o;
    return n;
  }
  isForceWatermark() {
    const o = (this.document.defaultView || window).location, { pathname: n } = o;
    return n ? n.indexOf("forceWatermark") !== -1 : !1;
  }
  isWebsiteUrl() {
    return this.getHostname().match(/^((?:[\w-]+\.)?ag-grid\.com)$/) !== null;
  }
  isLocalhost() {
    return this.getHostname().match(/^(?:127\.0\.0\.1|localhost)$/) !== null;
  }
  static formatDate(t) {
    const o = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ], n = t.getDate(), s = t.getMonth(), i = t.getFullYear();
    return n + " " + o[s] + " " + i;
  }
  static getGridReleaseDate() {
    return new Date(parseInt(co.decode(co.RELEASE_INFORMATION), 10));
  }
  static decode(t) {
    const o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    let n = "", s, i, r, l, a, c, d, u = 0;
    const h = t.replace(/[^A-Za-z0-9+/=]/g, "");
    for (; u < h.length; )
      l = o.indexOf(h.charAt(u++)), a = o.indexOf(h.charAt(u++)), c = o.indexOf(h.charAt(u++)), d = o.indexOf(h.charAt(u++)), s = l << 2 | a >> 4, i = (a & 15) << 4 | c >> 2, r = (c & 3) << 6 | d, n = n + String.fromCharCode(s), c != 64 && (n = n + String.fromCharCode(i)), d != 64 && (n = n + String.fromCharCode(r));
    return n = co.utf8_decode(n), n;
  }
  static utf8_decode(t) {
    t = t.replace(/rn/g, "n");
    let o = "";
    for (let n = 0; n < t.length; n++) {
      const s = t.charCodeAt(n);
      s < 128 ? o += String.fromCharCode(s) : s > 127 && s < 2048 ? (o += String.fromCharCode(s >> 6 | 192), o += String.fromCharCode(s & 63 | 128)) : (o += String.fromCharCode(s >> 12 | 224), o += String.fromCharCode(s >> 6 & 63 | 128), o += String.fromCharCode(s & 63 | 128));
    }
    return o;
  }
  static setChartsLicenseManager(t) {
    var o;
    this.chartsLicenseManager = t, (o = this.chartsLicenseManager) == null || o.setLicenseKey(this.licenseKey, !0);
  }
  static setLicenseKey(t) {
    var o;
    this.licenseKey = t, (o = this.chartsLicenseManager) == null || o.setLicenseKey(t, !0);
  }
  static extractBracketedInformation(t) {
    if (!t.includes("["))
      return ["legacy", !1, void 0];
    const o = t.match(/\[(.*?)\]/g).map((l) => l.replace("[", "").replace("]", ""));
    if (!o || o.length === 0)
      return ["legacy", !1, void 0];
    const n = o.filter((l) => l === "TRIAL").length === 1, s = o.filter((l) => l.indexOf("v") === 0)[0], i = s ? s.replace("v", "") : "legacy", r = k1[o.filter((l) => k1[l])[0]];
    return [i, n, r];
  }
  centerPadAndOutput(t) {
    const o = this.totalMessageLength - t.length;
    console.error(t.padStart(o / 2 + t.length, "*").padEnd(this.totalMessageLength, "*"));
  }
  padAndOutput(t, o = "*", n = "") {
    console.error(
      t.padEnd(this.totalMessageLength - n.length, o) + n
    );
  }
  outputInvalidLicenseKey(t, o, n) {
    t ? (this.centerPadAndOutput(""), this.centerPadAndOutput(` ${o} License `), this.centerPadAndOutput(" Incompatible License Key "), this.padAndOutput(
      `* Your license key is for ${n} only and does not cover you for ${o}.`,
      " ",
      "*"
    ), this.padAndOutput(`* To troubleshoot your license key visit ${Iu}.`, " ", "*"), this.centerPadAndOutput(""), this.centerPadAndOutput("")) : (this.centerPadAndOutput(""), this.centerPadAndOutput(` ${o} License `), this.centerPadAndOutput(" Invalid License Key "), this.padAndOutput("* Your license key is not valid.", " ", "*"), this.padAndOutput(`* To troubleshoot your license key visit ${Iu}.`, " ", "*"), this.centerPadAndOutput(""), this.centerPadAndOutput("")), this.watermarkMessage = "Invalid License";
  }
  outputExpiredTrialKey(t, o, n) {
    this.centerPadAndOutput(""), this.centerPadAndOutput(` ${o} License `), this.centerPadAndOutput(" Trial Period Expired. "), this.padAndOutput(
      `* Your trial only license for ${n} expired on ${t}.`,
      " ",
      "*"
    ), this.padAndOutput("* Please email info@ag-grid.com to purchase a license.", " ", "*"), this.centerPadAndOutput(""), this.centerPadAndOutput(""), this.watermarkMessage = "Trial Period Expired";
  }
  outputMissingLicenseKey(t) {
    this.centerPadAndOutput(""), this.centerPadAndOutput(` ${t} License `), this.centerPadAndOutput(" License Key Not Found "), this.padAndOutput(`* All ${t} features are unlocked for trial.`, " ", "*"), this.padAndOutput(
      "* If you want to hide the watermark please email info@ag-grid.com for a trial license key.",
      " ",
      "*"
    ), this.centerPadAndOutput(""), this.centerPadAndOutput(""), this.watermarkMessage = "For Trial Use Only";
  }
  outputExpiredKey(t, o, n, s) {
    this.centerPadAndOutput(""), this.centerPadAndOutput(` ${n} License `), this.centerPadAndOutput(" Incompatible Software Version "), this.padAndOutput(
      `* Your license key works with versions${s == "" ? "" : ` of ${s}`} released before ${t}.`,
      " ",
      "*"
    ), this.padAndOutput(`* The version you are trying to use was released on ${o}.`, " ", "*"), this.padAndOutput("* Please contact info@ag-grid.com to renew your license key.", " ", "*"), this.centerPadAndOutput(""), this.centerPadAndOutput(""), this.watermarkMessage = "License Expired";
  }
};
l_.RELEASE_INFORMATION = "MTc1NzA4ODUwMDMzNw==";
var H1 = l_, aqe = (
  /*css*/
  '.ag-watermark{bottom:20px;color:#9b9b9b;opacity:.7;position:absolute;transition:opacity 1s ease-out 3s;&:before{background-image:url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMDkiIGhlaWdodD0iMzYiIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAyMDkgMzYiPjxwYXRoIGZpbGw9IiM5YjliOWIiIGQ9Ik0xOTIuOTkzIDIzLjY1OHYtNy45NDZoLTEzLjU0MWwtNy45NDcgNy45NDZ6TTIwOC4yNSAzLjk1aC0xNi45NzRsLTguMDEgNy45NDdoMjQuOTg0ek0xNjMuNjIyIDMxLjYwNWw0LjA2OS00LjA2OWgxMy43MzJ2Ny45NDdoLTE3LjgwMXoiLz48cGF0aCBmaWxsPSIjOWI5YjliIiBkPSJNMTY2LjYxIDE5Ljc4aDguNzczbDguMDEtNy45NDZIMTY2LjYxek0xNTcuMDExIDMxLjYwNWg2LjYxMWw3Ljg4My03Ljk0N2gtMTQuNDk0ek0xOTEuMjc2IDMuOTVsLTQuMDY4IDQuMDdIMTYxLjI3Vi4wNzJoMzAuMDA2ek0yMC44NCAzMC4yMDZIOC4zNzhsLTIuMTYyIDUuMzRILjc1TDEyLjI1NyA4LjU5Mmg0Ljc2OEwyOC41MyAzNS41NDZoLTUuNTN6bS0xLjcxNy00LjI2TDE0LjYwOSAxNC45NWwtNC41MTQgMTAuOTk4ek0xMDQuNDM3IDE4LjUwOWMxLjU4OS0yLjM1MiA1LjU5NC0yLjYwNyA3LjI0Ny0yLjYwN3Y0LjU3OGMtMi4wMzQgMC00LjA2OS4wNjMtNS4yNzcuOTUzLTEuMjA3Ljg5LTEuODQzIDIuMDk4LTEuODQzIDMuNTZ2MTAuNTUzaC00Ljk1OVYxNS45MDJoNC43Njh6TTExOS4zNzYgMTUuOTAyaC00Ljk1OHYxOS42NDRoNC45NTh6TTExOS4zNzYgNy4xM2gtNC45NTh2NS44NDhoNC45NTh6TTE0My45NzkgNy4xM3YyOC40MTZoLTQuNzY4bC0uMTI3LTIuOTg4YTguMyA4LjMgMCAwIDEtMi42NyAyLjQ4Yy0xLjA4MS41NzItMi40MTYuODktMy45NDIuODktMS4zMzUgMC0yLjYwNi0uMjU1LTMuNjg3LS43LTEuMTQ0LS41MDgtMi4xNjItMS4xNDQtMi45ODgtMi4wMzRhOS42IDkuNiAwIDAgMS0xLjk3MS0zLjE3OWMtLjUwOC0xLjIwNy0uNjk5LTIuNjA2LS42OTktNC4xMzJzLjI1NC0yLjkyNC42OTktNC4xOTZjLjUwOS0xLjI3MSAxLjE0NS0yLjM1MiAxLjk3MS0zLjI0MnMxLjg0NC0xLjU4OSAyLjk4OC0yLjA5OCAyLjM1Mi0uNzYzIDMuNjg3LS43NjNjMS41MjYgMCAyLjc5Ny4yNTUgMy44NzguODI3czEuOTcxIDEuMzM1IDIuNjcgMi40MTZWNy4xOTNoNC45NTl6bS0xMC40MjYgMjQuNTM4YzEuNjUzIDAgMi45MjQtLjU3MiAzLjk0MS0xLjY1M3MxLjUyNi0yLjU0MyAxLjUyNi00LjMyMy0uNTA5LTMuMTc4LTEuNTI2LTQuMzIyYy0xLjAxNy0xLjA4MS0yLjI4OC0xLjY1My0zLjk0MS0xLjY1My0xLjU5IDAtMi45MjUuNTcyLTMuODc4IDEuNjUzLTEuMDE3IDEuMDgtMS41MjYgMi41NDMtMS41MjYgNC4zMjIgMCAxLjc4LjUwOSAzLjE4IDEuNTI2IDQuMjYgMS4wMTcgMS4xNDQgMi4yODggMS43MTYgMy44NzggMS43MTZNNTcuMjAyIDIwLjM1M0g0NC45MzN2NC4yNTloNi45OTNjLS4xOSAyLjE2MS0xLjAxNyAzLjgxNC0yLjQxNiA1LjE1LTEuMzk4IDEuMjctMy4xNzggMS45MDYtNS40NjcgMS45MDYtMS4yNzEgMC0yLjQ4LS4yNTQtMy40OTYtLjY5OWE3IDcgMCAwIDEtMi43MzQtMS45N2MtLjc2My0uODI3LTEuMzM1LTEuODQ0LTEuNzgtMy4wNTJzLS42MzYtMi40OC0uNjM2LTMuOTQyLjE5LTIuNzMzLjYzNi0zLjk0MWMuMzgxLTEuMjA4IDEuMDE3LTIuMTYyIDEuNzgtMy4wNTIuNzYzLS44MjYgMS42NTMtMS40NjIgMi43MzMtMS45N2E5LjEgOS4xIDAgMCAxIDMuNTYtLjdxNC4wMDUgMCA2LjEwMyAxLjkwN2wzLjMwNi0zLjMwNWMtMi40OC0xLjkwNy01LjY1OC0yLjkyNS05LjQwOS0yLjkyNS0yLjA5NyAwLTQuMDA0LjMxOC01LjcyMSAxLjAxOC0xLjcxNi42OTktMy4xNzkgMS41ODktNC4zODYgMi43OTdBMTIuMSAxMi4xIDAgMCAwIDMxLjIgMTYuMjJjLS42MzUgMS43MTctLjk1MyAzLjYyNC0uOTUzIDUuNjU4cy4zMTggMy45NDIgMS4wMTcgNS42NThjLjcgMS43MTcgMS41OSAzLjE3OSAyLjc5NyA0LjM4N2ExMi4xIDEyLjEgMCAwIDAgNC4zODcgMi43OTdjMS43MTYuNyAzLjYyMyAxLjAxNyA1LjY1NyAxLjAxNyAyLjAzNSAwIDMuODc4LS4zMTggNS41MzEtMS4wMTcgMS42NTMtLjcgMy4wNTItMS41OSA0LjE5Ni0yLjc5N3ExLjcxNi0xLjgxMiAyLjY3LTQuMzg3Yy42MzYtMS43MTYuOTU0LTMuNjIzLjk1NC01LjY1OHYtLjgyNmMtLjE5MS0uMTI3LS4yNTUtLjQ0NS0uMjU1LS43TTk1Ljk4MiAyMC4zNTNoLTEyLjI3djQuMjU5aDYuOTkzYy0uMTkgMi4xNjEtMS4wMTcgMy44MTQtMi40MTYgNS4xNS0xLjM5OCAxLjI3LTMuMTc4IDEuOTA2LTUuNDY3IDEuOTA2LTEuMjcxIDAtMi40OC0uMjU0LTMuNDk2LS42OTlhNyA3IDAgMCAxLTIuNzM0LTEuOTdjLS43NjMtLjgyNy0xLjMzNS0xLjg0NC0xLjc4LTMuMDUycy0uNjM2LTIuNDgtLjYzNi0zLjk0Mi4xOS0yLjczMy42MzYtMy45NDFjLjM4MS0xLjIwOCAxLjAxNy0yLjE2MiAxLjc4LTMuMDUyLjc2My0uODI2IDEuNjUzLTEuNDYyIDIuNzM0LTEuOTdhOS4xIDkuMSAwIDAgMSAzLjU2LS43cTQuMDA1IDAgNi4xMDMgMS45MDdsMy4zMDUtMy4zMDVjLTIuNDc5LTEuOTA3LTUuNjU4LTIuOTI1LTkuNDA4LTIuOTI1LTIuMDk4IDAtNC4wMDUuMzE4LTUuNzIyIDEuMDE4LTEuNzE2LjY5OS0zLjE3OCAxLjU4OS00LjM4NiAyLjc5N2ExMi4xIDEyLjEgMCAwIDAtMi43OTcgNC4zODZjLS42MzYgMS43MTctLjk1NCAzLjYyNC0uOTU0IDUuNjU4cy4zMTggMy45NDIgMS4wMTcgNS42NThjLjcgMS43MTcgMS41OSAzLjE3OSAyLjc5NyA0LjM4N2ExMi4xIDEyLjEgMCAwIDAgNC4zODcgMi43OTdjMS43MTYuNyAzLjYyMyAxLjAxNyA1LjY1OCAxLjAxNyAyLjAzNCAwIDMuODc4LS4zMTggNS41My0xLjAxNyAxLjY1My0uNyAzLjA1Mi0xLjU5IDQuMTk2LTIuNzk3cTEuNzE4LTEuODEyIDIuNjctNC4zODdjLjYzNi0xLjcxNi45NTQtMy42MjMuOTU0LTUuNjU4di0uODI2Yy0uMTktLjEyNy0uMjU1LS40NDUtLjI1NS0uNyIvPjwvc3ZnPg==");background-repeat:no-repeat;background-size:170px 40px;content:"";display:block;height:40px;width:170px}}:where(.ag-ltr) .ag-watermark{right:25px}:where(.ag-rtl) .ag-watermark{left:25px}.ag-watermark-text{font-family:Impact,sans-serif;font-size:19px;font-weight:700;opacity:.5}:where(.ag-ltr) .ag-watermark-text{padding-left:.7rem}:where(.ag-rtl) .ag-watermark-text{padding-right:.7rem}'
), cqe = {
  tag: "div",
  cls: "ag-watermark",
  children: [{ tag: "div", ref: "eLicenseTextRef", cls: "ag-watermark-text" }]
}, dqe = class extends Re {
  constructor() {
    super(cqe), this.eLicenseTextRef = J, this.registerCSS(aqe);
  }
  wireBeans(e) {
    this.licenseManager = e.licenseManager;
  }
  postConstruct() {
    const e = this.shouldDisplayWatermark();
    this.setDisplayed(e), e && (this.eLicenseTextRef.textContent = this.licenseManager.getWatermarkMessage(), window.setTimeout(() => this.addCss("ag-opacity-zero"), 0), window.setTimeout(() => this.setDisplayed(!1), 5e3));
  }
  shouldDisplayWatermark() {
    return this.licenseManager.isDisplayWatermark();
  }
}, uqe = {
  selector: "AG-WATERMARK",
  component: dqe
}, a_ = class extends K {
  constructor() {
    super(...arguments), this.beanName = "licenseManager";
  }
  postConstruct() {
    this.validateLicense();
  }
  validateLicense() {
    this.licenseManager = new H1(Pt(this.beans)), this.licenseManager.validateLicense();
  }
  static getLicenseDetails(e) {
    return new H1(null).getLicenseDetails(e);
  }
  getWatermarkSelector() {
    return uqe;
  }
  isDisplayWatermark() {
    return this.licenseManager.isDisplayWatermark();
  }
  getWatermarkMessage() {
    return this.licenseManager.getWatermarkMessage();
  }
  static setLicenseKey(e) {
    H1.setLicenseKey(e);
  }
  static setChartsLicenseManager(e) {
    H1.setChartsLicenseManager(e);
  }
}, yt = "34.2.0", ko = {
  moduleName: "EnterpriseCore",
  version: yt,
  beans: [a_],
  icons: {
    // accordion open (filter tool panel group, charts group)
    accordionOpen: "tree-open",
    // accordion closed (filter tool panel group, charts group)
    accordionClosed: "tree-closed",
    // accordion indeterminate - shown when some children are expanded and
    //     others are collapsed (filter tool panel group, charts group)
    accordionIndeterminate: "tree-indeterminate",
    // dialog title bar
    close: "cross",
    // X (remove) on column 'pill' after adding it to a drop zone list
    cancel: "cancel",
    // button in chart regular size window title bar (click to maximise)
    maximize: "maximize",
    // button in chart maximised window title bar (click to make regular size)
    minimize: "minimize",
    // drag handle used to pick up draggable columns
    columnDrag: "grip"
  },
  dependsOn: []
}, hqe = (
  /*css*/
  '.ag-advanced-filter-header{align-items:center;background-color:var(--ag-header-background-color);border-bottom:var(--ag-header-row-border);display:flex;position:relative}.ag-advanced-filter{align-items:center;display:flex;width:100%}.ag-advanced-filter-buttons{display:contents}.ag-advanced-filter-header-cell{height:100%;padding-left:var(--ag-cell-horizontal-padding);padding-right:var(--ag-cell-horizontal-padding)}.ag-advanced-filter-apply-button,.ag-advanced-filter-builder-button{align-items:center;background-color:unset;border:0;display:flex;font-size:var(--ag-font-size);font-weight:600;line-height:normal;padding:var(--ag-spacing);white-space:nowrap;&:where(:not(:disabled)){cursor:pointer;&:hover{background-color:var(--ag-row-hover-color)}}}:where(.ag-ltr) .ag-advanced-filter-apply-button,:where(.ag-ltr) .ag-advanced-filter-builder-button{margin-left:calc(var(--ag-spacing)*2)}:where(.ag-rtl) .ag-advanced-filter-apply-button,:where(.ag-rtl) .ag-advanced-filter-builder-button{margin-right:calc(var(--ag-spacing)*2)}:where(.ag-ltr) .ag-advanced-filter-builder-button-label{margin-left:var(--ag-spacing)}:where(.ag-rtl) .ag-advanced-filter-builder-button-label{margin-right:var(--ag-spacing)}.ag-advanced-filter-builder{display:flex;flex-direction:column;-webkit-user-select:none;-moz-user-select:none;user-select:none;width:100%}.ag-advanced-filter-builder-list{flex:1;overflow:auto}.ag-advanced-filter-builder-button-panel{border-top:var(--ag-advanced-filter-builder-button-bar-border);display:flex;justify-content:flex-end;padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding)}:where(.ag-ltr) .ag-advanced-filter-builder-apply-button,:where(.ag-ltr) .ag-advanced-filter-builder-cancel-button{margin-left:calc(var(--ag-spacing)*2)}:where(.ag-rtl) .ag-advanced-filter-builder-apply-button,:where(.ag-rtl) .ag-advanced-filter-builder-cancel-button{margin-right:calc(var(--ag-spacing)*2)}.ag-advanced-filter-builder-item-wrapper{align-items:center;display:flex;flex:1 1 auto;justify-content:space-between;overflow:hidden}:where(.ag-ltr) .ag-advanced-filter-builder-item-wrapper{padding-left:calc(var(--ag-icon-size)/2);padding-right:var(--ag-icon-size)}:where(.ag-rtl) .ag-advanced-filter-builder-item-wrapper{padding-left:var(--ag-icon-size);padding-right:calc(var(--ag-icon-size)/2)}:where(.ag-virtual-list-viewport .ag-advanced-filter-builder-item-wrapper) .ag-tab-guard{position:absolute}.ag-advanced-filter-builder-item-tree-lines>*{width:var(--ag-advanced-filter-builder-indent-size)}.ag-advanced-filter-builder-item-tree-line-root{width:var(--ag-icon-size);&:before{height:50%;top:50%}}.ag-advanced-filter-builder-item-tree-line-horizontal,.ag-advanced-filter-builder-item-tree-line-vertical,.ag-advanced-filter-builder-item-tree-line-vertical-bottom,.ag-advanced-filter-builder-item-tree-line-vertical-top{align-items:center;display:flex;height:100%;position:relative;&:after,&:before{content:"";height:100%;position:absolute}}.ag-advanced-filter-builder-item-tree-line-horizontal:after{border-bottom:var(--ag-border-width) solid var(--ag-border-color);height:50%;top:0;width:calc(var(--ag-advanced-filter-builder-indent-size) - var(--ag-icon-size))}:where(.ag-ltr) .ag-advanced-filter-builder-item-tree-line-horizontal:after{left:calc(var(--ag-icon-size)/2)}:where(.ag-rtl) .ag-advanced-filter-builder-item-tree-line-horizontal:after{right:calc(var(--ag-icon-size)/2)}.ag-advanced-filter-builder-item-tree-line-vertical:before{top:0;width:calc(var(--ag-advanced-filter-builder-indent-size) - var(--ag-icon-size)/2)}:where(.ag-ltr) .ag-advanced-filter-builder-item-tree-line-vertical:before{border-left:var(--ag-border-width) solid var(--ag-border-color);left:calc(var(--ag-icon-size)/2)}:where(.ag-rtl) .ag-advanced-filter-builder-item-tree-line-vertical:before{border-right:var(--ag-border-width) solid var(--ag-border-color);right:calc(var(--ag-icon-size)/2)}.ag-advanced-filter-builder-item-tree-line-vertical-top:before{height:50%;top:0;width:calc(var(--ag-advanced-filter-builder-indent-size) - var(--ag-icon-size)/2)}:where(.ag-ltr) .ag-advanced-filter-builder-item-tree-line-vertical-top:before{border-left:var(--ag-border-width) solid var(--ag-border-color);left:calc(var(--ag-icon-size)/2)}:where(.ag-rtl) .ag-advanced-filter-builder-item-tree-line-vertical-top:before{border-right:var(--ag-border-width) solid var(--ag-border-color);right:calc(var(--ag-icon-size)/2)}.ag-advanced-filter-builder-item-tree-line-vertical-bottom:before{height:calc(50% - var(--ag-icon-size)*1.5/2);top:calc(50% + var(--ag-icon-size)*1.5/2);width:calc(var(--ag-icon-size)/2)}:where(.ag-ltr) .ag-advanced-filter-builder-item-tree-line-vertical-bottom:before{border-left:var(--ag-border-width) solid var(--ag-border-color);left:calc(var(--ag-icon-size)/2)}:where(.ag-rtl) .ag-advanced-filter-builder-item-tree-line-vertical-bottom:before{border-right:var(--ag-border-width) solid var(--ag-border-color);right:calc(var(--ag-icon-size)/2)}.ag-advanced-filter-builder-item-condition{padding-bottom:var(--ag-spacing);padding-top:var(--ag-spacing)}.ag-advanced-filter-builder-item,.ag-advanced-filter-builder-item-buttons,.ag-advanced-filter-builder-item-condition,.ag-advanced-filter-builder-item-tree-lines,.ag-advanced-filter-builder-pill,.ag-advanced-filter-builder-pill-wrapper{align-items:center;display:flex;height:100%}.ag-advanced-filter-builder-pill-wrapper{margin:0 var(--ag-spacing)}.ag-advanced-filter-builder-pill{border-radius:var(--ag-border-radius);min-height:calc(100% - var(--ag-spacing)*3);min-width:calc(var(--ag-spacing)*2);padding:var(--ag-spacing) calc(var(--ag-spacing)*2);position:relative}:where(.ag-advanced-filter-builder-pill){.ag-advanced-filter-builder-value-number{font-family:monospace;font-weight:700}.ag-advanced-filter-builder-value-empty{color:var(--ag-subtle-text-color)}}:where(.ag-ltr) :where(.ag-advanced-filter-builder-pill){.ag-picker-field-display{margin-right:var(--ag-spacing)}}:where(.ag-rtl) :where(.ag-advanced-filter-builder-pill){.ag-picker-field-display{margin-left:var(--ag-spacing)}}.ag-advanced-filter-builder-pill-display{font-weight:500;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ag-advanced-filter-builder-join-pill{background-color:var(--ag-advanced-filter-builder-join-pill-color);cursor:pointer}.ag-advanced-filter-builder-column-pill{background-color:var(--ag-advanced-filter-builder-column-pill-color);cursor:pointer}.ag-advanced-filter-builder-option-pill{background-color:var(--ag-advanced-filter-builder-option-pill-color);cursor:pointer}.ag-advanced-filter-builder-value-pill{background-color:var(--ag-advanced-filter-builder-value-pill-color);cursor:text;max-width:140px;:where(.ag-advanced-filter-builder-pill-display){display:block}}.ag-advanced-filter-builder-item-buttons>*{margin:0 calc(var(--ag-spacing)*.5)}.ag-advanced-filter-builder-item-button{color:var(--ag-subtle-text-color);cursor:pointer;position:relative}.ag-advanced-filter-builder-item-button,.ag-advanced-filter-builder-pill{&:focus-visible{box-shadow:var(--ag-focus-shadow)}}.ag-advanced-filter-builder-item-button-disabled{cursor:default;opacity:.5}.ag-advanced-filter-builder-virtual-list-container{top:var(--ag-spacing)}.ag-advanced-filter-builder-virtual-list-item{cursor:default;display:flex;height:var(--ag-list-item-height);&:hover{background-color:var(--ag-row-hover-color);:where(.ag-advanced-filter-builder-item-button){opacity:1}}}.ag-advanced-filter-builder-invalid{color:var(--ag-subtle-text-color);cursor:default;margin:0 var(--ag-spacing)}:where(.ag-advanced-filter-builder-validation) .ag-advanced-filter-builder-invalid{color:var(--ag-invalid-color)}:where(.ag-advanced-filter-builder-virtual-list-item-highlight) .ag-advanced-filter-builder-item-button:focus-visible{opacity:1}'
);
function gqe(e) {
  var t;
  return ((t = e.filterManager) == null ? void 0 : t.getAdvFilterModel()) ?? null;
}
function pqe(e, t) {
  var o;
  (o = e.filterManager) == null || o.setAdvFilterModel(t);
}
function fqe(e) {
  var t;
  (t = e.filterManager) == null || t.toggleAdvFilterBuilder(!0, "api");
}
function vqe(e) {
  var t;
  (t = e.filterManager) == null || t.toggleAdvFilterBuilder(!1, "api");
}
var mqe = {
  ariaAdvancedFilterBuilderItem: (e) => `${e[0]}. Level ${e[1]}. Press ENTER to edit`,
  ariaAdvancedFilterBuilderItemValidation: (e) => `${e[0]}. Level ${e[1]}. ${e[2]} Press ENTER to edit`,
  ariaAdvancedFilterBuilderList: "Advanced Filter Builder List",
  ariaAdvancedFilterBuilderFilterItem: "Filter Condition",
  ariaAdvancedFilterBuilderGroupItem: "Filter Group",
  ariaAdvancedFilterBuilderColumn: "Column",
  ariaAdvancedFilterBuilderOption: "Option",
  ariaAdvancedFilterBuilderValue: "Value",
  ariaAdvancedFilterBuilderJoinOperator: "Join Operator",
  ariaAdvancedFilterInput: "Advanced Filter Input",
  ariaLabelAdvancedFilterAutocomplete: "Advanced Filter Autocomplete",
  advancedFilterContains: "contains",
  advancedFilterNotContains: "does not contain",
  advancedFilterTextEquals: "equals",
  advancedFilterTextNotEqual: "does not equal",
  advancedFilterStartsWith: "begins with",
  advancedFilterEndsWith: "ends with",
  advancedFilterBlank: "is blank",
  advancedFilterNotBlank: "is not blank",
  advancedFilterEquals: "=",
  advancedFilterNotEqual: "!=",
  advancedFilterGreaterThan: ">",
  advancedFilterGreaterThanOrEqual: ">=",
  advancedFilterLessThan: "<",
  advancedFilterLessThanOrEqual: "<=",
  advancedFilterTrue: "is true",
  advancedFilterFalse: "is false",
  advancedFilterAnd: "AND",
  advancedFilterOr: "OR",
  advancedFilterApply: "Apply",
  advancedFilterReset: "Reset",
  advancedFilterCancel: "Cancel",
  advancedFilterClear: "Clear",
  advancedFilterBuilder: "Builder",
  advancedFilterValidationMissingColumn: "Column is missing",
  advancedFilterValidationMissingOption: "Option is missing",
  advancedFilterValidationMissingValue: "Value is missing",
  advancedFilterValidationInvalidColumn: "Column not found",
  advancedFilterValidationInvalidOption: "Option not found",
  advancedFilterValidationMissingQuote: "Value is missing an end quote",
  advancedFilterValidationNotANumber: "Value is not a number",
  advancedFilterValidationInvalidDate: "Value is not a valid date",
  advancedFilterValidationMissingCondition: "Condition is missing",
  advancedFilterValidationJoinOperatorMismatch: "Join operators within a condition must be the same",
  advancedFilterValidationInvalidJoinOperator: "Join operator not found",
  advancedFilterValidationMissingEndBracket: "Missing end bracket",
  advancedFilterValidationExtraEndBracket: "Too many end brackets",
  advancedFilterValidationMessage: (e) => `Expression has an error. ${e[0]} - ${e[1]}.`,
  advancedFilterValidationMessageAtEnd: (e) => `Expression has an error. ${e[0]} at end of expression.`,
  advancedFilterBuilderTitle: "Advanced Filter",
  advancedFilterBuilderApply: "Apply",
  advancedFilterBuilderCancel: "Cancel",
  advancedFilterBuilderClear: "Clear",
  advancedFilterBuilderReset: "Reset",
  advancedFilterBuilderAddButtonTooltip: "Add Filter or Group",
  advancedFilterBuilderRemoveButtonTooltip: "Remove",
  advancedFilterBuilderMoveUpButtonTooltip: "Move Up",
  advancedFilterBuilderMoveDownButtonTooltip: "Move Down",
  advancedFilterBuilderAddJoin: "Add Group",
  advancedFilterBuilderAddCondition: "Add Filter",
  advancedFilterBuilderSelectColumn: "Select a column",
  advancedFilterBuilderSelectOption: "Select an option",
  advancedFilterBuilderEnterValue: "Enter a value...",
  advancedFilterBuilderValidationAlreadyApplied: "Current filter already applied.",
  advancedFilterBuilderValidationIncomplete: "Not all conditions are complete.",
  advancedFilterBuilderValidationSelectColumn: "Must select a column.",
  advancedFilterBuilderValidationSelectOption: "Must select an option.",
  advancedFilterBuilderValidationEnterValue: "Must enter a value."
};
function A5(e, t, o) {
  if (!e)
    return "";
  const n = o - t;
  return n ? e.slice(0, e.length - n) : e;
}
function is(e, t, o, n, s, i, r) {
  const l = o + (!e.length || r ? 0 : 1);
  let a = 0;
  return s && (e[l] === " " ? a = 1 : (n += " ", i && (n += '"'))), { updatedValue: e.slice(0, t) + n + e.slice(l), updatedPosition: t + n.length + a };
}
function Cqe(e, t, o) {
  let n = t;
  for (; n < o && e[n] === " "; )
    n++;
  return n;
}
function L5(e, t, o, n) {
  let s = t, i = !1;
  for (; s < e.length; ) {
    const r = e[s];
    if (r === "(") {
      n && e[s - 1] === " " ? i = !0 : s = s - 1;
      break;
    } else if (r === " " || o && r === ")") {
      s = s - 1;
      break;
    }
    s++;
  }
  return { endPosition: s, isEmpty: i };
}
function vc(e, t, o, n) {
  o !== t && (e.expression = is(
    e.expression,
    n - t.length + 1,
    n,
    o
  ).updatedValue);
}
var wqe = class {
  constructor(e, t) {
    this.params = e, this.startPosition = t, this.type = "column", this.valid = !0, this.hasStartChar = !1, this.hasEndChar = !1, this.colName = "";
  }
  parse(e, t) {
    if (e === E5 && !this.colName)
      this.hasStartChar = !0;
    else if (e === P5 && this.hasStartChar) {
      if (this.parseColumn(!1, t))
        return this.hasEndChar = !0, !1;
      this.colName += e;
    } else
      this.colName += e;
  }
  getDisplayValue() {
    return (this.hasStartChar ? E5 : "") + this.colName + (this.hasEndChar ? P5 : "");
  }
  getColId() {
    return this.colId;
  }
  complete(e) {
    this.parseColumn(!0, e);
  }
  getValidationError() {
    return this.valid ? null : {
      message: this.params.advFilterExpSvc.translate("advancedFilterValidationInvalidColumn"),
      startPosition: this.startPosition,
      endPosition: this.endPosition ?? this.params.expression.length - 1
    };
  }
  parseColumn(e, t) {
    var n;
    this.endPosition = t;
    const o = this.params.advFilterExpSvc.getColId(this.colName);
    return o && this.hasStartChar && (this.colId = o.colId, vc(this.params, this.colName, o.columnName, t - 1), this.colName = o.columnName, this.column = this.params.colModel.getColDefCol(this.colId), this.column) ? (this.baseCellDataType = ((n = this.params.dataTypeSvc) == null ? void 0 : n.getBaseDataType(this.column)) ?? "text", !0) : (e && (this.valid = !1), this.baseCellDataType = "text", !1);
  }
}, bqe = class {
  constructor(e, t, o) {
    this.params = e, this.startPosition = t, this.baseCellDataType = o, this.type = "operator", this.valid = !0, this.expectedNumOperands = 0, this.operator = "";
  }
  parse(e, t) {
    if (e === " " || e === ")") {
      if (this.parseOperator(!1, t - 1))
        return !0;
      this.operator += e;
    } else
      this.operator += e;
  }
  complete(e) {
    this.parseOperator(!0, e);
  }
  getValidationError() {
    return this.valid ? null : {
      message: this.params.advFilterExpSvc.translate("advancedFilterValidationInvalidOption"),
      startPosition: this.startPosition,
      endPosition: this.endPosition ?? this.params.expression.length - 1
    };
  }
  getDisplayValue() {
    return this.operator;
  }
  getOperatorKey() {
    return this.parsedOperator;
  }
  parseOperator(e, t) {
    const o = this.params.advFilterExpSvc.getDataTypeExpressionOperator(this.baseCellDataType), n = o.findOperator(this.operator);
    if (this.endPosition = t, n) {
      this.parsedOperator = n;
      const i = o.operators[n];
      this.expectedNumOperands = i.numOperands;
      const r = i.displayValue;
      return vc(this.params, this.operator, r, t), this.operator = r, !0;
    }
    return (e || !(n === null)) && (this.valid = !1), !1;
  }
}, yqe = class {
  constructor(e, t, o, n) {
    this.params = e, this.startPosition = t, this.baseCellDataType = o, this.column = n, this.type = "operand", this.valid = !0, this.operand = "", this.validationMessage = null, this.filterValidationSetters = {
      number: () => {
        (this.quotes || isNaN(this.modelValue)) && (this.valid = !1, this.validationMessage = this.params.advFilterExpSvc.translate("advancedFilterValidationNotANumber"));
      },
      date: (s) => {
        s == null && (this.valid = !1, this.validationMessage = this.params.advFilterExpSvc.translate("advancedFilterValidationInvalidDate"));
      },
      dateString: (...s) => this.filterValidationSetters.date(...s),
      dateTime: (...s) => this.filterValidationSetters.date(...s),
      dateTimeString: (...s) => this.filterValidationSetters.date(...s),
      boolean() {
      },
      object() {
      },
      text() {
      }
    };
  }
  parse(e, t) {
    if (e === " ")
      if (this.quotes)
        this.operand += e;
      else
        return this.parseOperand(!1, t), !0;
    else if (e === ")") {
      if (this.baseCellDataType === "number" || !this.quotes)
        return this.parseOperand(!1, t - 1), !0;
      this.operand += e;
    } else if (!this.operand && !this.quotes && (e === "'" || e === '"'))
      this.quotes = e;
    else {
      if (this.quotes && e === this.quotes)
        return this.parseOperand(!1, t), !1;
      this.operand += e;
    }
  }
  complete(e) {
    this.parseOperand(!0, e);
  }
  getValidationError() {
    return this.validationMessage ? {
      message: this.validationMessage,
      startPosition: this.startPosition,
      endPosition: this.endPosition ?? this.params.expression.length - 1
    } : null;
  }
  getRawValue() {
    return this.operand;
  }
  getModelValue() {
    return this.modelValue;
  }
  parseOperand(e, t) {
    const { advFilterExpSvc: o } = this.params;
    if (this.endPosition = t, this.modelValue = this.operand, e && this.quotes)
      this.valid = !1, this.validationMessage = o.translate("advancedFilterValidationMissingQuote");
    else if (this.modelValue === "")
      this.valid = !1, this.validationMessage = o.translate("advancedFilterValidationMissingValue");
    else {
      const n = o.getOperandModelValue(this.operand, this.baseCellDataType, this.column);
      n != null && (this.modelValue = n), this.filterValidationSetters[this.baseCellDataType](n);
    }
  }
}, E5 = "[", P5 = "]", _qe = class {
  constructor(e, t) {
    this.params = e, this.startPosition = t, this.isAwaiting = !0, this.operandValueGetters = {
      number: Number,
      date: (o) => this.params.valueSvc.parseValue(this.columnParser.column, null, o, void 0),
      dateString: (...o) => this.operandValueGetters.date(...o),
      dateTime: (...o) => this.operandValueGetters.date(...o),
      dateTimeString: (...o) => this.operandValueGetters.date(...o),
      boolean: (o) => o,
      object: (o) => o,
      text: (o) => o
    };
  }
  parseExpression() {
    var o, n;
    let e = this.startPosition;
    const { expression: t } = this.params;
    for (; e < t.length; ) {
      const s = t[e];
      if (!(s === " " && this.isAwaiting)) {
        if (this.isAwaiting = !1, !this.parser) {
          let r;
          this.columnParser ? this.operatorParser ? (this.operandParser = new yqe(
            this.params,
            e,
            this.columnParser.baseCellDataType,
            this.columnParser.column
          ), r = this.operandParser) : (this.operatorParser = new bqe(this.params, e, this.columnParser.baseCellDataType), r = this.operatorParser) : (this.columnParser = new wqe(this.params, e), r = this.columnParser), this.parser = r;
        }
        const i = this.parser.parse(s, e);
        if (i != null) {
          if (this.isComplete())
            return this.returnEndPosition(i ? e - 1 : e, !0);
          this.parser = void 0, this.isAwaiting = !0;
        }
      }
      e++;
    }
    return (n = (o = this.parser) == null ? void 0 : o.complete) == null || n.call(o, e - 1), this.returnEndPosition(e);
  }
  isValid() {
    return this.isComplete() && this.columnParser.valid && this.operatorParser.valid && (!this.operandParser || this.operandParser.valid);
  }
  getValidationError() {
    var n, s, i;
    const e = ((n = this.columnParser) == null ? void 0 : n.getValidationError()) ?? ((s = this.operatorParser) == null ? void 0 : s.getValidationError()) ?? ((i = this.operandParser) == null ? void 0 : i.getValidationError());
    if (e)
      return e;
    const t = this.params.expression.length;
    let o;
    return this.columnParser ? this.operatorParser ? this.operatorParser.expectedNumOperands && !this.operandParser && (o = "advancedFilterValidationMissingValue") : o = "advancedFilterValidationMissingOption" : o = "advancedFilterValidationMissingColumn", o ? {
      message: this.params.advFilterExpSvc.translate(o),
      startPosition: t,
      endPosition: t
    } : null;
  }
  getFunction(e) {
    return this.getFunctionCommon(e, (t, o, n, s) => (i, r, l) => l.operators[o].evaluator(
      i.getValue(n, r),
      r,
      l.evaluatorParams[s],
      t == null ? void 0 : l.operands[t]
    ));
  }
  getAutocompleteListParams(e) {
    if (this.isColumnPosition(e))
      return this.getColumnAutocompleteListParams(e);
    if (this.isOperatorPosition(e))
      return this.getOperatorAutocompleteListParams(e);
    if (!this.isBeyondEndPosition(e))
      return { enabled: !1 };
  }
  updateExpression(e, t, o) {
    var s, i, r;
    const { expression: n } = this.params;
    if (this.isColumnPosition(e))
      return is(
        this.params.expression,
        this.startPosition,
        (s = this.columnParser) != null && s.getColId() ? this.columnParser.endPosition : L5(n, e).endPosition,
        this.params.advFilterExpSvc.getColumnValue(t),
        !0
      );
    if (this.isOperatorPosition(e)) {
      const l = this.getBaseCellDataTypeFromOperatorAutocompleteType(o), a = this.hasOperand(l, t.key), c = a && this.doesOperandNeedQuotes(l);
      let d;
      if (((i = this.operatorParser) == null ? void 0 : i.startPosition) != null && e < this.operatorParser.startPosition)
        d = is(
          n,
          e,
          e,
          t.displayValue ?? t.key,
          a,
          c
        );
      else {
        let u, h = !1;
        if ((r = this.operatorParser) != null && r.getOperatorKey())
          u = this.operatorParser.endPosition;
        else {
          const { endPosition: p, isEmpty: C } = L5(
            n,
            e,
            !0,
            !0
          );
          u = p, h = C;
        }
        d = is(
          n,
          Cqe(n, this.columnParser.endPosition + 1, u),
          u,
          t.displayValue ?? t.key,
          a,
          c,
          h
        );
      }
      return { ...d, hideAutocomplete: !a };
    }
    return null;
  }
  getModel() {
    const e = this.columnParser.getColId(), t = {
      filterType: this.columnParser.baseCellDataType,
      colId: e,
      type: this.operatorParser.getOperatorKey()
    };
    return this.operatorParser.expectedNumOperands && (t.filter = this.operandParser.getModelValue()), t;
  }
  getFunctionCommon(e, t) {
    var h, p;
    const o = this.columnParser.getColId(), n = (h = this.operatorParser) == null ? void 0 : h.getOperatorKey(), { operators: s, evaluatorParams: i, operands: r } = e, l = this.params.advFilterExpSvc.getExpressionOperator(
      this.columnParser.baseCellDataType,
      n
    ), a = this.addToListAndGetIndex(s, l), c = this.params.advFilterExpSvc.getExpressionEvaluatorParams(o), d = this.addToListAndGetIndex(i, c), u = ((p = this.operatorParser) == null ? void 0 : p.expectedNumOperands) === 0 ? void 0 : this.addToListAndGetIndex(r, this.getOperandValue());
    return t(u, a, o, d);
  }
  getOperandValue() {
    var n;
    const { baseCellDataType: e, column: t } = this.columnParser, o = this.operandValueGetters[e](this.operandParser.getRawValue());
    return e === "dateString" || e === "dateTimeString" ? ((n = this.params.dataTypeSvc) == null ? void 0 : n.getDateParserFunction(t)(o)) ?? o : o;
  }
  isComplete() {
    return !!(this.operatorParser && (!this.operatorParser.expectedNumOperands || this.operatorParser.expectedNumOperands && this.operandParser));
  }
  isColumnPosition(e) {
    return !this.columnParser || this.columnParser.endPosition == null || e <= this.columnParser.endPosition + 1;
  }
  isOperatorPosition(e) {
    return !this.operatorParser || this.operatorParser.endPosition == null || e <= this.operatorParser.endPosition + 1;
  }
  isBeyondEndPosition(e) {
    return this.isComplete() && this.endPosition != null && e > this.endPosition + 1 && this.endPosition + 1 < this.params.expression.length;
  }
  returnEndPosition(e, t) {
    return this.endPosition = t ? e : e - 1, e;
  }
  getColumnAutocompleteListParams(e) {
    return this.params.advFilterExpSvc.generateAutocompleteListParams(
      this.params.advFilterExpSvc.getColumnAutocompleteEntries(),
      "column",
      this.getColumnSearchString(e)
    );
  }
  getColumnSearchString(e) {
    var i, r, l, a;
    const t = ((i = this.columnParser) == null ? void 0 : i.getDisplayValue()) ?? "", o = A5(
      t,
      e,
      ((r = this.columnParser) == null ? void 0 : r.endPosition) == null ? this.params.expression.length : this.columnParser.endPosition + 1
    ), n = ((l = this.columnParser) == null ? void 0 : l.hasStartChar) && o.length > 0, s = ((a = this.columnParser) == null ? void 0 : a.hasEndChar) && o.length === t.length + 2;
    return n ? o.slice(1, s ? -1 : void 0) : o;
  }
  getOperatorAutocompleteListParams(e) {
    var s, i, r, l;
    const t = (s = this.columnParser) == null ? void 0 : s.column;
    if (!t)
      return { enabled: !1 };
    const o = this.columnParser.baseCellDataType, n = ((i = this.operatorParser) == null ? void 0 : i.startPosition) != null && e < this.operatorParser.startPosition ? "" : A5(
      ((r = this.operatorParser) == null ? void 0 : r.getDisplayValue()) ?? "",
      e,
      ((l = this.operatorParser) == null ? void 0 : l.endPosition) == null ? this.params.expression.length : this.operatorParser.endPosition + 1
    );
    return this.params.advFilterExpSvc.generateAutocompleteListParams(
      this.params.advFilterExpSvc.getOperatorAutocompleteEntries(t, o),
      `operator-${o}`,
      n
    );
  }
  getBaseCellDataTypeFromOperatorAutocompleteType(e) {
    return e == null ? void 0 : e.replace("operator-", "");
  }
  hasOperand(e, t) {
    var o;
    return !e || !t || (((o = this.params.advFilterExpSvc.getExpressionOperator(e, t)) == null ? void 0 : o.numOperands) ?? 0) > 0;
  }
  doesOperandNeedQuotes(e) {
    return e !== "number";
  }
  addToListAndGetIndex(e, t) {
    const o = e.length;
    return e.push(t), o;
  }
};
function Aa(e, t, o) {
  let n = !1;
  const s = e.toLocaleLowerCase(), i = s + " ", r = Object.keys(t).find((l) => {
    const a = t[l], c = o(a).toLocaleLowerCase();
    return c.startsWith(i) && (n = !0), c === s;
  });
  return r || (n ? null : void 0);
}
function mc(e, t) {
  return (t ?? Object.keys(e)).map((n) => ({
    key: n,
    displayValue: e[n].displayValue
  }));
}
var Du = class {
  constructor(e) {
    this.params = e, this.initOperators();
  }
  getEntries(e) {
    return mc(this.operators, e);
  }
  findOperator(e) {
    return Aa(e, this.operators, ({ displayValue: t }) => t);
  }
  initOperators() {
    const { translate: e } = this.params;
    this.operators = {
      contains: {
        displayValue: e("advancedFilterContains"),
        evaluator: (t, o, n, s) => this.evaluateExpression(t, o, n, s, !1, (i, r) => i.includes(r)),
        numOperands: 1
      },
      notContains: {
        displayValue: e("advancedFilterNotContains"),
        evaluator: (t, o, n, s) => this.evaluateExpression(t, o, n, s, !0, (i, r) => !i.includes(r)),
        numOperands: 1
      },
      equals: {
        displayValue: e("advancedFilterTextEquals"),
        evaluator: (t, o, n, s) => this.evaluateExpression(t, o, n, s, !1, (i, r) => i === r),
        numOperands: 1
      },
      notEqual: {
        displayValue: e("advancedFilterTextNotEqual"),
        evaluator: (t, o, n, s) => this.evaluateExpression(t, o, n, s, !0, (i, r) => i != r),
        numOperands: 1
      },
      startsWith: {
        displayValue: e("advancedFilterStartsWith"),
        evaluator: (t, o, n, s) => this.evaluateExpression(t, o, n, s, !1, (i, r) => i.startsWith(r)),
        numOperands: 1
      },
      endsWith: {
        displayValue: e("advancedFilterEndsWith"),
        evaluator: (t, o, n, s) => this.evaluateExpression(t, o, n, s, !1, (i, r) => i.endsWith(r)),
        numOperands: 1
      },
      blank: {
        displayValue: e("advancedFilterBlank"),
        evaluator: (t) => t == null || typeof t == "string" && t.trim().length === 0,
        numOperands: 0
      },
      notBlank: {
        displayValue: e("advancedFilterNotBlank"),
        evaluator: (t) => t != null && (typeof t != "string" || t.trim().length > 0),
        numOperands: 0
      }
    };
  }
  evaluateExpression(e, t, o, n, s, i) {
    return e == null ? s : o.caseSensitive ? i(o.valueConverter(e, t), n) : i(o.valueConverter(e, t).toLocaleLowerCase(), n.toLocaleLowerCase());
  }
}, pr = class {
  constructor(e) {
    this.params = e, this.initOperators();
  }
  getEntries(e) {
    return mc(this.operators, e);
  }
  findOperator(e) {
    return Aa(e, this.operators, ({ displayValue: t }) => t);
  }
  initOperators() {
    const { translate: e, equals: t } = this.params;
    this.operators = {
      equals: {
        displayValue: e("advancedFilterEquals"),
        evaluator: (o, n, s, i) => this.evaluateSingleOperandExpression(
          o,
          n,
          s,
          i,
          !!s.includeBlanksInEquals,
          t
        ),
        numOperands: 1
      },
      notEqual: {
        displayValue: e("advancedFilterNotEqual"),
        evaluator: (o, n, s, i) => this.evaluateSingleOperandExpression(
          o,
          n,
          s,
          i,
          !!s.includeBlanksInEquals,
          (r, l) => !t(r, l)
        ),
        numOperands: 1
      },
      greaterThan: {
        displayValue: e("advancedFilterGreaterThan"),
        evaluator: (o, n, s, i) => this.evaluateSingleOperandExpression(
          o,
          n,
          s,
          i,
          !!s.includeBlanksInGreaterThan,
          (r, l) => r > l
        ),
        numOperands: 1
      },
      greaterThanOrEqual: {
        displayValue: e("advancedFilterGreaterThanOrEqual"),
        evaluator: (o, n, s, i) => this.evaluateSingleOperandExpression(
          o,
          n,
          s,
          i,
          !!s.includeBlanksInGreaterThan,
          (r, l) => r >= l
        ),
        numOperands: 1
      },
      lessThan: {
        displayValue: e("advancedFilterLessThan"),
        evaluator: (o, n, s, i) => this.evaluateSingleOperandExpression(
          o,
          n,
          s,
          i,
          !!s.includeBlanksInLessThan,
          (r, l) => r < l
        ),
        numOperands: 1
      },
      lessThanOrEqual: {
        displayValue: e("advancedFilterLessThanOrEqual"),
        evaluator: (o, n, s, i) => this.evaluateSingleOperandExpression(
          o,
          n,
          s,
          i,
          !!s.includeBlanksInLessThan,
          (r, l) => r <= l
        ),
        numOperands: 1
      },
      blank: {
        displayValue: e("advancedFilterBlank"),
        evaluator: (o) => o == null,
        numOperands: 0
      },
      notBlank: {
        displayValue: e("advancedFilterNotBlank"),
        evaluator: (o) => o != null,
        numOperands: 0
      }
    };
  }
  evaluateSingleOperandExpression(e, t, o, n, s, i) {
    return e == null ? s : i(o.valueConverter(e, t), n);
  }
}, Sqe = class {
  constructor(e) {
    this.params = e, this.initOperators();
  }
  getEntries(e) {
    return mc(this.operators, e);
  }
  findOperator(e) {
    return Aa(e, this.operators, ({ displayValue: t }) => t);
  }
  initOperators() {
    const { translate: e } = this.params;
    this.operators = {
      true: {
        displayValue: e("advancedFilterTrue"),
        evaluator: (t) => !!t,
        numOperands: 0
      },
      false: {
        displayValue: e("advancedFilterFalse"),
        evaluator: (t) => t === !1,
        numOperands: 0
      },
      blank: {
        displayValue: e("advancedFilterBlank"),
        evaluator: (t) => t == null,
        numOperands: 0
      },
      notBlank: {
        displayValue: e("advancedFilterNotBlank"),
        evaluator: (t) => t != null,
        numOperands: 0
      }
    };
  }
}, xqe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "advFilterExpSvc", this.filterOperandGetters = {
      number: (e) => Co(e.filter) ?? "",
      date: (e) => {
        const t = this.colModel.getColDefCol(e.colId);
        return t ? this.valueSvc.formatValue(t, null, Wt(e.filter)) : null;
      },
      dateTime: (e) => this.filterOperandGetters.date(e),
      dateString: (e) => {
        var i;
        const t = this.colModel.getColDefCol(e.colId);
        if (!t)
          return null;
        const { filter: o } = e, n = (i = this.dataTypeSvc) == null ? void 0 : i.getDateFormatterFunction(t), s = (n == null ? void 0 : n(Wt(o) ?? void 0)) ?? o;
        return this.valueSvc.formatValue(t, null, s);
      },
      dateTimeString: (e) => this.filterOperandGetters.dateString(e),
      boolean: () => null,
      object: () => null,
      text: () => null
    }, this.operandModelValueGetters = {
      number: (e) => ue(e) ? Number(e) : null,
      date: (e, t, o) => {
        var n;
        return to(
          this.valueSvc.parseValue(t, null, e, void 0),
          !!((n = this.dataTypeSvc) != null && n.getDateIncludesTimeFlag(o))
        );
      },
      dateTime: (...e) => this.operandModelValueGetters.date(...e),
      dateString: (e, t, o) => {
        const n = this.valueSvc.parseValue(t, null, e, void 0);
        return this.dataTypeSvc ? to(
          this.dataTypeSvc.getDateParserFunction(t)(n) ?? null,
          this.dataTypeSvc.getDateIncludesTimeFlag(o)
        ) : n;
      },
      dateTimeString: (...e) => this.operandModelValueGetters.dateString(...e),
      boolean: (e) => e,
      object: (e) => e,
      text: (e) => e
    }, this.columnNameToIdMap = {}, this.columnAutocompleteEntries = null, this.expressionEvaluatorParams = {};
  }
  wireBeans(e) {
    this.valueSvc = e.valueSvc, this.colModel = e.colModel, this.colNames = e.colNames, this.dataTypeSvc = e.dataTypeSvc;
  }
  postConstruct() {
    this.expressionJoinOperators = this.generateExpressionJoinOperators(), this.expressionOperators = this.generateExpressionOperators();
  }
  parseJoinOperator(e) {
    const { type: t } = e;
    return this.expressionJoinOperators[t] ?? t;
  }
  getColumnDisplayValue(e) {
    const { colId: t } = e, n = this.getColumnAutocompleteEntries().find(({ key: i }) => i === t);
    let s;
    return n ? (s = n.displayValue, this.columnNameToIdMap[s.toLocaleUpperCase()] = { colId: t, columnName: s }) : s = t, s;
  }
  getOperatorDisplayValue(e) {
    var t;
    return ((t = this.getExpressionOperator(e.filterType, e.type)) == null ? void 0 : t.displayValue) ?? e.type;
  }
  getOperandModelValue(e, t, o) {
    return this.operandModelValueGetters[t](e, o, t);
  }
  getOperandDisplayValue(e, t) {
    const { filter: o } = e;
    if (o == null)
      return "";
    let n = this.filterOperandGetters[e.filterType](e);
    return e.filterType !== "number" && (n ?? (n = Co(o) ?? ""), t || (n = `"${n}"`)), t ? n : ` ${n}`;
  }
  parseColumnFilterModel(e) {
    const t = this.getColumnDisplayValue(e) ?? "", o = this.getOperatorDisplayValue(e) ?? "", n = this.getOperandDisplayValue(e);
    return `[${t}] ${o}${n}`;
  }
  updateAutocompleteCache(e, t) {
    if (t === "column") {
      const { key: o, displayValue: n } = e;
      this.columnNameToIdMap[e.displayValue.toLocaleUpperCase()] = {
        colId: o,
        columnName: n
      };
    }
  }
  translate(e, t) {
    let o = mqe[e];
    return typeof o == "function" && (o = o(t)), this.getLocaleTextFunc()(e, o, t);
  }
  generateAutocompleteListParams(e, t, o) {
    return {
      enabled: !0,
      type: t,
      searchString: o,
      entries: e
    };
  }
  getColumnAutocompleteEntries() {
    if (this.columnAutocompleteEntries)
      return this.columnAutocompleteEntries;
    const e = this.colModel.getColDefCols() ?? [], t = [], o = this.gos.get("includeHiddenColumnsInAdvancedFilter");
    return e.forEach((n) => {
      n.getColDef().filter && (o || n.isVisible() || n.isRowGroupActive()) && t.push({
        key: n.getColId(),
        displayValue: this.colNames.getDisplayNameForColumn(n, "advancedFilter")
      });
    }), t.sort((n, s) => {
      const i = n.displayValue ?? "", r = s.displayValue ?? "";
      return i < r ? -1 : r > i ? 1 : 0;
    }), t;
  }
  getOperatorAutocompleteEntries(e, t) {
    const o = this.getActiveOperators(e);
    return this.getDataTypeExpressionOperator(t).getEntries(o);
  }
  getJoinOperatorAutocompleteEntries() {
    return Object.entries(this.expressionJoinOperators).map(([e, t]) => ({ key: e, displayValue: t }));
  }
  getDefaultAutocompleteListParams(e) {
    return this.generateAutocompleteListParams(this.getColumnAutocompleteEntries(), "column", e);
  }
  getDataTypeExpressionOperator(e) {
    return this.expressionOperators[e];
  }
  getExpressionOperator(e, t) {
    var o, n;
    return (n = (o = this.getDataTypeExpressionOperator(e)) == null ? void 0 : o.operators) == null ? void 0 : n[t];
  }
  getExpressionJoinOperators() {
    return this.expressionJoinOperators;
  }
  getColId(e) {
    const t = e.toLocaleUpperCase(), o = this.columnNameToIdMap[t];
    if (o)
      return o;
    const s = this.getColumnAutocompleteEntries().find(
      ({ displayValue: i }) => i.toLocaleUpperCase() === t
    );
    if (s) {
      const { key: i, displayValue: r } = s, l = { colId: i, columnName: r };
      return this.columnNameToIdMap[t] = l, l;
    }
    return null;
  }
  getExpressionEvaluatorParams(e) {
    var i, r;
    let t = this.expressionEvaluatorParams[e];
    if (t)
      return t;
    const o = this.colModel.getColDefCol(e);
    if (!o)
      return { valueConverter: (l) => l };
    switch ((i = this.dataTypeSvc) == null ? void 0 : i.getBaseDataType(o)) {
      case "dateTimeString":
      case "dateString":
        t = {
          valueConverter: ((r = this.dataTypeSvc) == null ? void 0 : r.getDateParserFunction(o)) ?? ((l) => l)
        };
        break;
      case "object":
        o.getColDef().filterValueGetter ? t = { valueConverter: (l) => l } : t = {
          valueConverter: (l, a) => this.valueSvc.formatValue(o, a, l) ?? (typeof l.toString == "function" ? l.toString() : "")
        };
        break;
      case "text":
      case void 0:
        t = { valueConverter: (l) => Co(l) };
        break;
      default:
        t = { valueConverter: (l) => l };
        break;
    }
    const { filterParams: s } = o.getColDef();
    return s && ["caseSensitive", "includeBlanksInEquals", "includeBlanksInLessThan", "includeBlanksInGreaterThan"].forEach(
      (l) => {
        const a = s[l];
        a && (t[l] = a);
      }
    ), this.expressionEvaluatorParams[e] = t, t;
  }
  getColumnDetails(e) {
    var n;
    const t = this.colModel.getColDefCol(e) ?? void 0, o = (t ? (n = this.dataTypeSvc) == null ? void 0 : n.getBaseDataType(t) : void 0) ?? "text";
    return { column: t, baseCellDataType: o };
  }
  generateExpressionOperators() {
    const e = (o, n) => this.translate(o, n), t = {
      translate: e,
      equals: (o, n) => o.getTime() === n.getTime()
    };
    return {
      text: new Du({ translate: e }),
      boolean: new Sqe({ translate: e }),
      object: new Du({ translate: e }),
      number: new pr({ translate: e, equals: (o, n) => o === n }),
      date: new pr(t),
      dateString: new pr(t),
      dateTime: new pr(t),
      dateTimeString: new pr(t)
    };
  }
  getColumnValue({ displayValue: e }) {
    return `${E5}${e}${P5}`;
  }
  generateExpressionJoinOperators() {
    return {
      AND: this.translate("advancedFilterAnd"),
      OR: this.translate("advancedFilterOr")
    };
  }
  getActiveOperators(e) {
    var n;
    const t = (n = e.getColDef().filterParams) == null ? void 0 : n.filterOptions;
    return t && t.every((s) => typeof s == "string") ? t : void 0;
  }
  resetColumnCaches() {
    this.columnAutocompleteEntries = null, this.columnNameToIdMap = {}, this.expressionEvaluatorParams = {};
  }
}, Mqe = (
  /*css*/
  ".ag-panel{background-color:var(--ag-panel-background-color);display:flex;flex-direction:column;overflow:hidden;position:relative}.ag-dialog{border:var(--ag-dialog-border);border-radius:var(--ag-border-radius);box-shadow:var(--ag-dialog-shadow);position:absolute}.ag-panel-title-bar{align-items:center;background-color:var(--ag-panel-title-bar-background-color);border-bottom:var(--ag-panel-title-bar-border);color:var(--ag-panel-title-bar-text-color);cursor:default;display:flex;flex:none;font-weight:var(--ag-panel-title-bar-font-weight);height:var(--ag-header-height);padding:var(--ag-spacing) var(--ag-cell-horizontal-padding)}.ag-panel-title-bar-button{cursor:pointer;:where(.ag-icon){color:var(--ag-panel-title-bar-icon-color)}}:where(.ag-ltr) .ag-panel-title-bar-button{margin-left:calc(var(--ag-spacing)*2);margin-right:var(--ag-spacing)}:where(.ag-rtl) .ag-panel-title-bar-button{margin-left:var(--ag-spacing);margin-right:calc(var(--ag-spacing)*2)}.ag-panel-title-bar-title{flex:1 1 auto}.ag-panel-title-bar-buttons{display:flex}.ag-panel-content-wrapper{display:flex;flex:1 1 auto;overflow:hidden;position:relative}:where(.ag-dragging-fill-handle) .ag-dialog,:where(.ag-dragging-range-handle) .ag-dialog{opacity:.7;pointer-events:none}"
);
function Aqe(e) {
  const t = e.cssIdentifier || "default";
  return {
    tag: "div",
    cls: `ag-panel ag-${t}-panel`,
    attrs: { tabindex: "-1" },
    children: [
      {
        tag: "div",
        ref: "eTitleBar",
        cls: `ag-panel-title-bar ag-${t}-panel-title-bar ag-unselectable`,
        children: [
          {
            tag: "span",
            ref: "eTitle",
            cls: `ag-panel-title-bar-title ag-${t}-panel-title-bar-title`
          },
          {
            tag: "div",
            ref: "eTitleBarButtons",
            cls: `ag-panel-title-bar-buttons ag-${t}-panel-title-bar-buttons`
          }
        ]
      },
      {
        tag: "div",
        ref: "eContentWrapper",
        cls: `ag-panel-content-wrapper ag-${t}-panel-content-wrapper`
      }
    ]
  };
}
var Lqe = class extends Re {
  constructor(e) {
    super(Aqe(e)), this.config = e, this.closable = !0, this.eContentWrapper = J, this.eTitleBar = J, this.eTitleBarButtons = J, this.eTitle = J, this.registerCSS(Mqe);
  }
  postConstruct() {
    const {
      component: e,
      closable: t,
      hideTitleBar: o,
      title: n,
      minWidth: s = 250,
      width: i,
      minHeight: r = 250,
      height: l,
      centered: a,
      popup: c,
      x: d,
      y: u,
      postProcessPopupParams: h
    } = this.config, p = this.beans, C = this.createManagedBean(
      new wa(this.getGui(), {
        minWidth: s,
        width: i,
        minHeight: r,
        height: l,
        centered: a,
        x: d,
        y: u,
        popup: c,
        calculateTopBuffer: () => this.positionableFeature.getHeight() - this.getBodyHeight()
      })
    );
    this.positionableFeature = C;
    const m = this.getGui();
    if (e && this.setBodyComponent(e), o ? He(this.eTitleBar, !1) : (n && this.setTitle(n), this.setClosable(t ?? this.closable)), this.addManagedElementListeners(this.eTitleBar, {
      mousedown: (y) => {
        if (m.contains(y.relatedTarget) || m.contains(Ue(p)) || this.eTitleBarButtons.contains(y.target)) {
          y.preventDefault();
          return;
        }
        const b = this.eContentWrapper.querySelector(
          "button, [href], input, select, textarea, [tabindex]"
        );
        b && b.focus();
      }
    }), c && C.isPositioned())
      return;
    this.renderComponent && this.renderComponent();
    let w;
    if (h) {
      const { type: y, eventSource: b, mouseEvent: _ } = h;
      w = () => {
        var M;
        return (M = p.popupSvc) == null ? void 0 : M.callPostProcessPopup(h, y, m, b, _);
      };
    }
    C.initialisePosition(w), this.eContentWrapper.style.height = "0";
  }
  renderComponent() {
    const e = this.getGui();
    e.focus(), this.close = () => {
      e.parentElement.removeChild(e), this.destroy();
    };
  }
  getHeight() {
    return this.positionableFeature.getHeight();
  }
  setHeight(e) {
    this.positionableFeature.setHeight(e);
  }
  getWidth() {
    return this.positionableFeature.getWidth();
  }
  setWidth(e) {
    this.positionableFeature.setWidth(e);
  }
  setClosable(e) {
    if (e !== this.closable && (this.closable = e), e) {
      const t = this.closeButtonComp = new Re({ tag: "div", cls: "ag-button" });
      this.createBean(t);
      const o = t.getGui(), n = Ie("close", this.beans);
      n.classList.add("ag-panel-title-bar-button-icon"), o.appendChild(n), this.addTitleBarButton(t), t.addManagedElementListeners(o, { click: this.onBtClose.bind(this) });
    } else if (this.closeButtonComp) {
      const t = this.closeButtonComp.getGui();
      t.parentElement.removeChild(t), this.closeButtonComp = this.destroyBean(this.closeButtonComp);
    }
  }
  setBodyComponent(e) {
    e.setParentComponent(this), this.eContentWrapper.appendChild(e.getGui());
  }
  addTitleBarButton(e, t) {
    const o = this.eTitleBarButtons, n = o.children, s = n.length;
    t == null && (t = s), t = Math.max(0, Math.min(t, s)), e.addCss("ag-panel-title-bar-button");
    const i = e.getGui();
    t === 0 ? o.insertAdjacentElement("afterbegin", i) : t === s ? o.insertAdjacentElement("beforeend", i) : n[t - 1].insertAdjacentElement("afterend", i), e.setParentComponent(this);
  }
  getBodyHeight() {
    return ca(this.eContentWrapper);
  }
  getBodyWidth() {
    return Bi(this.eContentWrapper);
  }
  setTitle(e) {
    this.eTitle.innerText = e;
  }
  // called when user hits the 'x' in the top right
  onBtClose() {
    this.close();
  }
  destroy() {
    this.closeButtonComp && (this.closeButtonComp = this.destroyBean(this.closeButtonComp));
    const e = this.getGui();
    e && ro(e) && this.close(), super.destroy();
  }
}, c_ = class extends Lqe {
  constructor(e) {
    super({ ...e, popup: !0 }), this.isMaximizable = !1, this.isMaximized = !1, this.maximizeListeners = [], this.resizeListenerDestroy = null, this.lastPosition = {
      x: 0,
      y: 0,
      width: 0,
      height: 0
    };
  }
  wireBeans(e) {
    this.popupSvc = e.popupSvc;
  }
  postConstruct() {
    const e = this.getGui(), { movable: t, resizable: o, maximizable: n, modal: s } = this.config;
    if (this.addCss("ag-dialog"), super.postConstruct(), this.tabGuardFeature = this.createManagedBean(new jb(this)), this.tabGuardFeature.initialiseTabGuard({
      isFocusableContainer: !0,
      onFocusIn: () => {
        var i;
        (i = this.popupSvc) == null || i.bringPopupToFront(e);
      },
      onTabKeyDown: (i) => {
        if (s)
          return;
        const r = i.shiftKey, l = Yt(this.beans, e, !1, r);
        (!l || this.tabGuardFeature.getTabGuardCtrl().isTabGuard(l)) && fn(this.beans, r) && i.preventDefault();
      }
    }), t && this.setMovable(t), n && this.setMaximizable(n), o && this.setResizable(o), !this.config.modal) {
      const i = this.beans.ctrlsSvc.get("gridCtrl");
      i.addFocusableContainer(this), this.addDestroyFunc(() => i.removeFocusableContainer(this));
    }
  }
  setAllowFocus(e) {
    this.tabGuardFeature.getTabGuardCtrl().setAllowFocus(e);
  }
  renderComponent() {
    var l;
    const e = this.getGui(), { alwaysOnTop: t, modal: o, title: n, afterGuiAttached: s } = this.config, i = this.getLocaleTextFunc(), r = (l = this.popupSvc) == null ? void 0 : l.addPopup({
      modal: o,
      eChild: e,
      closeOnEsc: !0,
      closedCallback: this.onClosed.bind(this),
      alwaysOnTop: t,
      ariaLabel: n || i("ariaLabelDialog", "Dialog"),
      afterGuiAttached: s
    });
    r && (this.close = r.hideFunc);
  }
  onClosed(e) {
    var t, o;
    this.destroy(), (o = (t = this.config).closedCallback) == null || o.call(t, e);
  }
  setMaximized(e) {
    this.isMaximizable && e !== this.isMaximized && this.toggleMaximize();
  }
  toggleMaximize() {
    const e = this.positionableFeature.getPosition();
    if (this.isMaximized) {
      const { x: t, y: o, width: n, height: s } = this.lastPosition;
      this.setWidth(n), this.setHeight(s), this.positionableFeature.offsetElement(t, o);
    } else
      this.lastPosition.width = this.getWidth(), this.lastPosition.height = this.getHeight(), this.lastPosition.x = e.x, this.lastPosition.y = e.y, this.positionableFeature.offsetElement(0, 0), this.setHeight("100%"), this.setWidth("100%");
    this.isMaximized = !this.isMaximized, this.refreshMaximizeIcon();
  }
  refreshMaximizeIcon() {
    He(this.maximizeIcon, !this.isMaximized), He(this.minimizeIcon, this.isMaximized);
  }
  clearMaximizebleListeners() {
    this.maximizeListeners.length && (this.maximizeListeners.forEach((e) => e()), this.maximizeListeners.length = 0), this.resizeListenerDestroy && (this.resizeListenerDestroy(), this.resizeListenerDestroy = null);
  }
  destroy() {
    this.maximizeButtonComp = this.destroyBean(this.maximizeButtonComp), this.clearMaximizebleListeners(), super.destroy();
  }
  setResizable(e) {
    this.positionableFeature.setResizable(e);
  }
  setMovable(e) {
    this.positionableFeature.setMovable(e, this.eTitleBar);
  }
  setMaximizable(e) {
    if (!e) {
      this.clearMaximizebleListeners(), this.maximizeButtonComp && (this.destroyBean(this.maximizeButtonComp), this.maximizeButtonComp = this.maximizeIcon = this.minimizeIcon = void 0);
      return;
    }
    const t = this.eTitleBar;
    if (!t || e === this.isMaximizable)
      return;
    this.isMaximizable = e;
    const o = this.buildMaximizeAndMinimizeElements();
    this.refreshMaximizeIcon(), o.addManagedElementListeners(o.getGui(), {
      click: this.toggleMaximize.bind(this)
    }), this.addTitleBarButton(o, 0), this.maximizeListeners.push(
      ...this.addManagedElementListeners(t, {
        dblclick: this.toggleMaximize.bind(this)
      })
    ), [this.resizeListenerDestroy] = this.addManagedListeners(this.positionableFeature, {
      resize: () => {
        this.isMaximized = !1, this.refreshMaximizeIcon();
      }
    });
  }
  buildMaximizeAndMinimizeElements() {
    const e = this.maximizeButtonComp = this.createBean(
      new Re({ tag: "div", cls: "ag-dialog-button" })
    ), t = e.getGui();
    return this.maximizeIcon = Ie("maximize", this.beans), t.appendChild(this.maximizeIcon), this.maximizeIcon.classList.add("ag-panel-title-bar-button-icon"), this.minimizeIcon = Ie("minimize", this.beans), t.appendChild(this.minimizeIcon), this.minimizeIcon.classList.add("ag-panel-title-bar-button-icon"), e;
  }
}, Eqe = (
  /*css*/
  ".ag-autocomplete{align-items:center;display:flex;width:100%;>*{flex:1 1 auto}}.ag-autocomplete-list-popup{background-color:var(--ag-background-color);border-radius:var(--ag-border-radius);box-shadow:var(--ag-dropdown-shadow);padding:0;position:absolute;-webkit-user-select:none;-moz-user-select:none;user-select:none}.ag-autocomplete-list{height:calc(var(--ag-row-height)*6.5);min-width:200px;position:relative;width:100%}.ag-autocomplete-virtual-list-item{cursor:default;display:flex;height:var(--ag-list-item-height);&:focus-visible:after{content:none}&:hover{background-color:var(--ag-row-hover-color)}}.ag-autocomplete-row{align-items:center;display:flex;flex:1 1 auto;overflow:hidden}.ag-autocomplete-row-label{margin:0 var(--ag-widget-container-horizontal-padding);overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ag-autocomplete-row-selected{background-color:var(--ag-selected-row-background-color)}"
);
function Pqe(e) {
  return {
    tag: "div",
    cls: `ag-virtual-list-viewport ag-${e}-virtual-list-viewport`,
    role: "presentation",
    children: [
      {
        tag: "div",
        ref: "eContainer",
        cls: `ag-virtual-list-container ag-${e}-virtual-list-container`
      }
    ]
  };
}
var nr = class extends ri {
  constructor(e) {
    super(Pqe((e == null ? void 0 : e.cssIdentifier) || "default")), this.renderedRows = /* @__PURE__ */ new Map(), this.rowHeight = 20, this.pageSize = -1, this.isScrolling = !1, this.isHeightFromTheme = !0, this.eContainer = J, this.awaitStableCallbacks = [];
    const { cssIdentifier: t = "default", ariaRole: o = "listbox", listName: n, moveItemCallback: s } = e || {};
    this.cssIdentifier = t, this.ariaRole = o, this.listName = n, this.moveItemCallback = s;
  }
  wireBeans(e) {
    this.environment = e.environment;
  }
  postConstruct() {
    this.addScrollListener(), this.rowHeight = this.getItemHeight(), this.addResizeObserver(), this.initialiseTabGuard({
      onFocusIn: (e) => this.onFocusIn(e),
      onFocusOut: (e) => this.onFocusOut(e),
      focusInnerElement: (e) => this.focusInnerElement(e),
      onTabKeyDown: (e) => this.onTabKeyDown(e),
      handleKeyDown: (e) => this.handleKeyDown(e)
    }), this.refreshAriaProperties(), this.addManagedEventListeners({ gridStylesChanged: this.onGridStylesChanged.bind(this) });
  }
  onGridStylesChanged(e) {
    e.listItemHeightChanged && (this.rowHeight = this.getItemHeight(), this.refresh());
  }
  refreshAriaProperties() {
    var n;
    const t = this.getLocaleTextFunc()("ariaDefaultListName", this.listName || "List"), o = this.eContainer;
    no(o, ((n = this.model) == null ? void 0 : n.getRowCount()) > 0 ? this.ariaRole : "presentation"), ft(o, t);
  }
  addResizeObserver() {
    const e = () => yo(this.beans, () => this.drawVirtualRows()), t = mn(this.beans, this.getGui(), e);
    this.addDestroyFunc(t);
  }
  focusInnerElement(e) {
    return this.focusRow(e ? this.model.getRowCount() - 1 : 0), !0;
  }
  onFocusIn(e) {
    const t = e.target;
    t.classList.contains("ag-virtual-list-item") && (this.lastFocusedRowIndex = OTe(t) - 1);
  }
  onFocusOut(e) {
    this.getFocusableElement().contains(e.relatedTarget) || (this.lastFocusedRowIndex = null);
  }
  handleKeyDown(e) {
    const { key: t, shiftKey: o } = e;
    switch (t) {
      case D.UP:
      case D.DOWN:
        {
          const n = t === D.UP;
          e.preventDefault(), o ? this.moveItem(n) : this.navigate(n);
        }
        break;
      case D.PAGE_HOME:
      case D.PAGE_END:
      case D.PAGE_UP:
      case D.PAGE_DOWN:
        this.navigateToPage(t) !== null && e.preventDefault();
        break;
    }
  }
  onTabKeyDown(e) {
    vt(e), this.forceFocusOutOfContainer(e.shiftKey);
  }
  getNextRow(e) {
    if (this.lastFocusedRowIndex == null)
      return;
    const t = this.lastFocusedRowIndex + (e ? -1 : 1);
    if (!(t < 0 || t >= this.model.getRowCount()))
      return t;
  }
  moveItem(e) {
    if (!this.moveItemCallback)
      return;
    const t = this.getComponentAt(this.lastFocusedRowIndex);
    t && this.moveItemCallback(t, e);
  }
  navigate(e) {
    const t = this.getNextRow(e);
    t !== void 0 && this.focusRow(t);
  }
  navigateToPage(e, t = "focused") {
    let o = !1;
    t === "focused" && (t = this.getLastFocusedRow(), o = !0);
    const n = this.model.getRowCount() - 1;
    let s = -1;
    return e === D.PAGE_HOME ? s = 0 : e === D.PAGE_END ? s = n : e === D.PAGE_DOWN ? s = Math.min(t + this.pageSize, n) : e === D.PAGE_UP && (s = Math.max(t - this.pageSize, 0)), s === -1 ? null : (o ? this.focusRow(s) : this.ensureIndexVisible(s), s);
  }
  getLastFocusedRow() {
    return this.lastFocusedRowIndex;
  }
  focusRow(e) {
    this.isScrolling || (this.isScrolling = !0, this.ensureIndexVisible(e), yo(this.beans, () => {
      if (this.isScrolling = !1, !this.isAlive())
        return;
      const t = this.renderedRows.get(e);
      t && t.eDiv.focus();
    }));
  }
  getComponentAt(e) {
    const t = this.renderedRows.get(e);
    return t && t.rowComponent;
  }
  forEachRenderedRow(e) {
    this.renderedRows.forEach((t, o) => e(t.rowComponent, o));
  }
  getItemHeight() {
    return this.isHeightFromTheme ? this.environment.getDefaultListItemHeight() : this.rowHeight;
  }
  /**
   * Returns true if the view had to be scrolled, otherwise, false.
   */
  ensureIndexVisible(e, t = !0) {
    const o = this.model.getRowCount();
    if (typeof e != "number" || e < 0 || e >= o)
      return X(229, { index: e }), !1;
    const n = e * this.rowHeight, s = n + this.rowHeight, i = this.getGui(), r = i.scrollTop, l = i.offsetHeight, a = r + l, c = t ? 0 : this.rowHeight, d = r > n + c, u = a < s - c;
    if (d)
      return i.scrollTop = n, !0;
    if (u) {
      const h = s - l;
      return i.scrollTop = h, !0;
    }
    return !1;
  }
  setComponentCreator(e) {
    this.componentCreator = e;
  }
  setComponentUpdater(e) {
    this.componentUpdater = e;
  }
  getRowHeight() {
    return this.rowHeight;
  }
  getScrollTop() {
    return this.getGui().scrollTop;
  }
  setRowHeight(e) {
    this.isHeightFromTheme = !1, this.rowHeight = e, this.refresh();
  }
  refresh(e) {
    if (this.model == null || !this.isAlive())
      return;
    const t = this.model.getRowCount();
    this.eContainer.style.height = `${t * this.rowHeight}px`, this.refreshAriaProperties(), this.awaitStable(() => {
      this.isAlive() && (this.canSoftRefresh(e) ? this.drawVirtualRows(!0) : (this.clearVirtualRows(), this.drawVirtualRows()));
    });
  }
  awaitStable(e) {
    if (this.awaitStableCallbacks.push(e), this.awaitStableCallbacks.length > 1)
      return;
    const t = this.model.getRowCount();
    mw(
      this,
      () => this.eContainer.clientHeight >= t * this.rowHeight,
      () => {
        if (!this.isAlive())
          return;
        const o = this.awaitStableCallbacks;
        this.awaitStableCallbacks = [], o.forEach((n) => n());
      }
    );
  }
  canSoftRefresh(e) {
    return !!(e && this.renderedRows.size && typeof this.model.areRowsEqual == "function" && this.componentUpdater);
  }
  clearVirtualRows() {
    this.renderedRows.forEach((e, t) => this.removeRow(t));
  }
  drawVirtualRows(e) {
    if (!this.isAlive() || !this.model)
      return;
    const t = this.getGui(), o = t.scrollTop, n = o + t.offsetHeight;
    if (o === n)
      this.clearVirtualRows();
    else {
      const s = Math.floor(o / this.rowHeight), i = Math.floor(n / this.rowHeight);
      this.pageSize = Math.floor((n - o) / this.rowHeight), this.ensureRowsRendered(s, i, e);
    }
  }
  ensureRowsRendered(e, t, o) {
    this.renderedRows.forEach((n, s) => {
      (s < e || s > t) && s !== this.lastFocusedRowIndex && this.removeRow(s);
    }), o && this.refreshRows();
    for (let n = e; n <= t; n++)
      this.renderedRows.has(n) || n < this.model.getRowCount() && this.insertRow(n);
  }
  insertRow(e) {
    const t = this.model.getRow(e), o = this.ariaRole === "tree" ? "treeitem" : "option", n = ze({
      tag: "div",
      cls: `ag-virtual-list-item ag-${this.cssIdentifier}-virtual-list-item`,
      role: o,
      attrs: { tabindex: "-1" }
    });
    ra(n, this.model.getRowCount()), la(n, e + 1), n.style.height = `${this.rowHeight}px`, n.style.top = `${this.rowHeight * e}px`;
    const s = this.componentCreator(t, n);
    s.addGuiEventListener("focusin", () => this.lastFocusedRowIndex = e), n.appendChild(s.getGui()), this.renderedRows.has(e - 1) ? this.renderedRows.get(e - 1).eDiv.insertAdjacentElement("afterend", n) : this.renderedRows.has(e + 1) ? this.renderedRows.get(e + 1).eDiv.insertAdjacentElement("beforebegin", n) : this.eContainer.appendChild(n), this.renderedRows.set(e, { rowComponent: s, eDiv: n, value: t });
  }
  removeRow(e) {
    const t = this.renderedRows.get(e);
    this.eContainer.removeChild(t.eDiv), this.destroyBean(t.rowComponent), this.renderedRows.delete(e);
  }
  refreshRows() {
    const e = this.model.getRowCount();
    this.renderedRows.forEach((t, o) => {
      var n, s;
      if (o >= e)
        this.removeRow(o);
      else {
        const i = this.model.getRow(o);
        (s = (n = this.model).areRowsEqual) != null && s.call(n, t.value, i) ? this.componentUpdater(i, t.rowComponent) : this.removeRow(o);
      }
    });
  }
  addScrollListener() {
    this.addGuiEventListener("scroll", () => this.drawVirtualRows(), { passive: !0 });
  }
  setModel(e) {
    this.model = e;
  }
  getAriaElement() {
    return this.eContainer;
  }
  destroy() {
    this.isAlive() && (this.clearVirtualRows(), this.awaitStableCallbacks.length = 0, super.destroy());
  }
}, Rqe = {
  tag: "div",
  cls: "ag-autocomplete-row",
  role: "presentation",
  children: [{ tag: "div", cls: "ag-autocomplete-row-label" }]
}, Fqe = class extends Re {
  constructor() {
    super(Rqe), this.hasHighlighting = !1;
  }
  setState(e, t) {
    this.value = e, this.render(), this.updateSelected(t);
  }
  updateSelected(e) {
    this.toggleCss("ag-autocomplete-row-selected", e);
  }
  setSearchString(e) {
    let t = !1;
    const { value: o } = this;
    if (o && ue(e)) {
      const n = o.toLocaleLowerCase().indexOf(e.toLocaleLowerCase());
      if (n >= 0) {
        t = !0, this.hasHighlighting = !0;
        const s = n + e.length, i = this.getGui().lastElementChild;
        it(i), i.append(
          // Start part
          o.slice(0, n),
          // Highlighted part wrapped in bold tag
          ze({ tag: "b", children: o.slice(n, s) }),
          // End part
          o.slice(s)
        );
      }
    }
    !t && this.hasHighlighting && (this.hasHighlighting = !1, this.render());
  }
  render() {
    this.getGui().lastElementChild.textContent = this.value ?? " ";
  }
}, Tqe = {
  tag: "div",
  cls: "ag-autocomplete-list-popup",
  children: [
    {
      tag: "div",
      ref: "eList",
      cls: "ag-autocomplete-list"
    }
  ]
}, Iqe = class extends ga {
  constructor(e) {
    super(Tqe), this.params = e, this.eList = J, this.searchString = "";
  }
  postConstruct() {
    this.autocompleteEntries = this.params.autocompleteEntries, this.virtualList = this.createManagedBean(new nr({ cssIdentifier: "autocomplete" })), this.virtualList.setComponentCreator(this.createRowComponent.bind(this)), this.eList.appendChild(this.virtualList.getGui()), this.virtualList.setModel({
      getRowCount: () => this.autocompleteEntries.length,
      getRow: (t) => this.autocompleteEntries[t]
    });
    const e = this.virtualList.getGui();
    this.addManagedListeners(e, {
      click: () => this.params.onConfirmed(),
      mousemove: this.onMouseMove.bind(this),
      mousedown: (t) => t.preventDefault()
    }), this.setSelectedValue(0);
  }
  onNavigationKeyDown(e, t) {
    e.preventDefault();
    const o = this.autocompleteEntries.indexOf(this.selectedValue), n = t === D.UP ? o - 1 : o + 1;
    this.checkSetSelectedValue(n);
  }
  setSearch(e) {
    this.searchString = e, ue(e) ? this.runSearch() : (this.autocompleteEntries = this.params.autocompleteEntries, this.virtualList.refresh(), this.checkSetSelectedValue(0)), this.updateSearchInList();
  }
  runContainsSearch(e, t) {
    let o, n = !1;
    const s = e.toLocaleLowerCase(), i = t.filter((r) => {
      const a = r.toLocaleLowerCase().indexOf(s), c = a === 0, d = a >= 0;
      return d && (!o || !n && c || n === c && r.length < o.length) && (o = r, n = c), d;
    });
    return !o && i.length && (o = i[0]), { topMatch: o, allMatches: i };
  }
  runSearch() {
    const { autocompleteEntries: e, useFuzzySearch: t, forceLastSelection: o } = this.params, n = e.map((a) => a.displayValue ?? a.key);
    let s, i;
    if (t)
      s = Yr({
        inputValue: this.searchString,
        allSuggestions: n,
        hideIrrelevant: !0
      }).values, i = s.length ? s[0] : void 0;
    else {
      const a = this.runContainsSearch(this.searchString, n);
      s = a.allMatches, i = a.topMatch;
    }
    let r = e.filter(
      ({ key: a, displayValue: c }) => s.includes(c ?? a)
    );
    if (!r.length && this.selectedValue && (o != null && o(this.selectedValue, this.searchString)) && (r = [this.selectedValue]), this.autocompleteEntries = r, this.virtualList.refresh(), !i)
      return;
    const l = s.indexOf(i);
    this.checkSetSelectedValue(l);
  }
  updateSearchInList() {
    this.virtualList.forEachRenderedRow((e) => e.setSearchString(this.searchString));
  }
  checkSetSelectedValue(e) {
    e >= 0 && e < this.autocompleteEntries.length && this.setSelectedValue(e);
  }
  setSelectedValue(e) {
    const t = this.autocompleteEntries[e];
    this.selectedValue !== t && (this.selectedValue = t, this.virtualList.ensureIndexVisible(e), this.virtualList.forEachRenderedRow((o, n) => {
      o.updateSelected(e === n);
    }));
  }
  createRowComponent(e) {
    const t = new Fqe();
    return this.createBean(t), t.setState(e.displayValue ?? e.key, e === this.selectedValue), t;
  }
  onMouseMove(e) {
    const t = this.virtualList, o = t.getGui().getBoundingClientRect(), n = t.getScrollTop(), s = e.clientY - o.top + n, i = Math.floor(s / t.getRowHeight());
    this.checkSetSelectedValue(i);
  }
  afterGuiAttached() {
    this.virtualList.refresh();
  }
  getSelectedValue() {
    return this.autocompleteEntries.length ? this.selectedValue ?? null : null;
  }
}, Dqe = {
  tag: "div",
  cls: "ag-autocomplete",
  role: "presentation",
  children: [
    {
      tag: "ag-input-text-field",
      ref: "eAutocompleteInput"
    }
  ]
}, kqe = class extends Re {
  constructor() {
    super(Dqe, [zo]), this.eAutocompleteInput = J, this.isListOpen = !1, this.lastPosition = 0, this.valid = !0, this.registerCSS(Eqe);
  }
  wireBeans(e) {
    this.popupSvc = e.popupSvc;
  }
  postConstruct() {
    this.eAutocompleteInput.onValueChange((e) => this.onValueChanged(e)), this.eAutocompleteInput.getInputElement().setAttribute("autocomplete", "off"), this.addGuiEventListener("keydown", this.onKeyDown.bind(this)), this.addGuiEventListener("click", this.updatePositionAndList.bind(this)), this.addDestroyFunc(() => {
      this.destroyBean(this.autocompleteList);
    }), this.addGuiEventListener("focusout", () => this.onFocusOut());
  }
  onValueChanged(e) {
    const t = Ft(e);
    this.updateValue(t), this.updateAutocompleteList(t);
  }
  updateValue(e) {
    this.updateLastPosition(), this.dispatchLocalEvent({
      type: "eventValueChanged",
      value: e
    }), this.validate(e);
  }
  updateAutocompleteList(e) {
    var n, s;
    const t = ((n = this.listGenerator) == null ? void 0 : n.call(this, e, this.lastPosition)) ?? { enabled: !1 };
    (!t.type || t.type !== ((s = this.autocompleteListParams) == null ? void 0 : s.type)) && this.isListOpen && this.closeList();
    const o = this.isListOpen;
    if (this.autocompleteListParams = t, t != null && t.enabled) {
      o || this.openList();
      const { searchString: i } = t;
      this.autocompleteList.setSearch(i ?? "");
    } else
      o && this.closeList();
  }
  onKeyDown(e) {
    const t = e.key;
    switch (this.updateLastPosition(), t) {
      case D.ENTER:
        this.onEnterKeyDown(e);
        break;
      case D.TAB:
        this.onTabKeyDown(e);
        break;
      case D.DOWN:
      case D.UP:
        this.onUpDownKeyDown(e, t);
        break;
      case D.LEFT:
      case D.RIGHT:
      case D.PAGE_HOME:
      case D.PAGE_END:
        setTimeout(() => {
          this.updatePositionAndList();
        });
        break;
      case D.ESCAPE:
        this.onEscapeKeyDown(e);
        break;
      case D.SPACE:
        e.ctrlKey && !this.isListOpen && (e.preventDefault(), this.forceOpenList());
        break;
    }
  }
  confirmSelection() {
    var t;
    const e = (t = this.autocompleteList) == null ? void 0 : t.getSelectedValue();
    e && (this.closeList(), this.dispatchLocalEvent({
      type: "eventOptionSelected",
      value: this.getValue(),
      position: this.lastPosition,
      updateEntry: e,
      autocompleteType: this.autocompleteListParams.type
    }));
  }
  onTabKeyDown(e) {
    this.isListOpen && (e.preventDefault(), e.stopPropagation(), this.confirmSelection());
  }
  onEnterKeyDown(e) {
    e.preventDefault(), this.isListOpen ? this.confirmSelection() : this.onCompleted();
  }
  onUpDownKeyDown(e, t) {
    var o;
    e.preventDefault(), this.isListOpen ? (o = this.autocompleteList) == null || o.onNavigationKeyDown(e, t) : this.forceOpenList();
  }
  onEscapeKeyDown(e) {
    this.isListOpen && (e.preventDefault(), e.stopPropagation(), this.closeList(), this.setCaret(this.lastPosition, !0));
  }
  onFocusOut() {
    this.isListOpen && this.closeList();
  }
  updatePositionAndList() {
    this.updateLastPosition(), this.updateAutocompleteList(this.eAutocompleteInput.getValue() ?? null);
  }
  setCaret(e, t) {
    (t || Oi(this.beans)) && this.eAutocompleteInput.getFocusableElement().focus();
    const o = this.eAutocompleteInput.getInputElement();
    o.setSelectionRange(e, e), e === o.value.length && (o.scrollLeft = o.scrollWidth);
  }
  forceOpenList() {
    this.onValueChanged(this.eAutocompleteInput.getValue());
  }
  updateLastPosition() {
    this.lastPosition = this.eAutocompleteInput.getInputElement().selectionStart ?? 0;
  }
  validate(e) {
    if (!this.validator)
      return;
    const t = this.validationMessage = this.validator(e);
    this.eAutocompleteInput.getInputElement().setCustomValidity(t ?? ""), this.valid = !t, this.dispatchLocalEvent({
      type: "eventValidChanged",
      isValid: this.valid,
      validationMessage: t
    });
  }
  openList() {
    this.isListOpen = !0, this.autocompleteList = this.createBean(
      new Iqe({
        autocompleteEntries: this.autocompleteListParams.entries,
        onConfirmed: () => this.confirmSelection(),
        forceLastSelection: this.forceLastSelection
      })
    );
    const e = this.autocompleteList.getGui(), t = {
      ePopup: e,
      type: "autocomplete",
      eventSource: this.getGui(),
      position: "under",
      alignSide: this.gos.get("enableRtl") ? "right" : "left",
      keepWithinBounds: !0
    }, o = this.popupSvc.addPopup({
      eChild: e,
      anchorToElement: this.getGui(),
      positionCallback: () => this.popupSvc.positionPopupByComponent(t),
      ariaLabel: this.listAriaLabel
    });
    this.hidePopup = o.hideFunc, this.autocompleteList.afterGuiAttached();
  }
  closeList() {
    this.isListOpen = !1, this.hidePopup(), this.destroyBean(this.autocompleteList), this.autocompleteList = null;
  }
  onCompleted() {
    this.isListOpen && this.closeList(), this.dispatchLocalEvent({
      type: "eventValueConfirmed",
      value: this.getValue(),
      isValid: this.isValid()
    });
  }
  getValue() {
    return Ft(this.eAutocompleteInput.getValue());
  }
  setInputPlaceholder(e) {
    return this.eAutocompleteInput.setInputPlaceholder(e), this;
  }
  setInputAriaLabel(e) {
    return this.eAutocompleteInput.setInputAriaLabel(e), this;
  }
  setListAriaLabel(e) {
    return this.listAriaLabel = e, this;
  }
  setListGenerator(e) {
    return this.listGenerator = e, this;
  }
  setValidator(e) {
    return this.validator = e, this;
  }
  isValid() {
    return this.valid;
  }
  setValue(e) {
    const { value: t, position: o, silent: n, updateListOnlyIfOpen: s, restoreFocus: i } = e;
    this.eAutocompleteInput.setValue(t, !0), this.setCaret(o ?? this.lastPosition, i), n || this.updateValue(t), (!s || this.isListOpen) && this.updateAutocompleteList(t);
  }
  setForceLastSelection(e) {
    return this.forceLastSelection = e, this;
  }
  setInputDisabled(e) {
    return this.eAutocompleteInput.setDisabled(e), this;
  }
}, Hqe = {
  selector: "AG-AUTOCOMPLETE",
  component: kqe
}, x0 = {
  buttons: ["apply"],
  suppressBuilderButton: !1
}, ku = {
  apply: "advancedFilterApply",
  clear: "advancedFilterClear",
  cancel: "advancedFilterCancel",
  reset: "advancedFilterReset"
}, Vqe = {
  tag: "div",
  cls: "ag-advanced-filter",
  role: "presentation",
  attrs: { tabindex: "-1" },
  children: [
    { tag: "ag-autocomplete", ref: "eAutocomplete" },
    {
      tag: "ag-filter-button",
      ref: "eButtons",
      cls: "ag-advanced-filter-buttons"
    },
    {
      tag: "button",
      ref: "eBuilderFilterButton",
      cls: "ag-button ag-advanced-filter-builder-button",
      children: [
        { tag: "span", ref: "eBuilderFilterButtonIcon", attrs: { "aria-hidden": "true" } },
        { tag: "span", ref: "eBuilderFilterButtonLabel", cls: "ag-advanced-filter-builder-button-label" }
      ]
    }
  ]
}, d_ = class extends Re {
  constructor() {
    super(Vqe, [Hqe, iHe]), this.eAutocomplete = J, this.eButtons = J, this.eBuilderFilterButton = J, this.eBuilderFilterButtonIcon = J, this.eBuilderFilterButtonLabel = J, this.expressionParser = null, this.isApplyDisabled = !0, this.builderOpen = !1;
  }
  wireBeans(e) {
    this.advFilterExpSvc = e.advFilterExpSvc, this.advancedFilter = e.advancedFilter, this.filterManager = e.filterManager, this.registry = e.registry;
  }
  postConstruct() {
    this.tooltipFeature = this.createOptionalManagedBean(
      this.registry.createDynamicBean("tooltipFeature", !1, {
        getGui: () => this.getGui(),
        getTooltipShowDelayOverride: () => 1e3,
        getLocation: () => "advancedFilter"
      })
    ), this.eAutocomplete.setListGenerator((o, n) => this.generateAutocompleteListParams(n)).setValidator(() => this.validateValue()).setForceLastSelection(
      (o, n) => this.forceLastSelection(o, n)
    ).setInputAriaLabel(this.advFilterExpSvc.translate("ariaAdvancedFilterInput")).setListAriaLabel(this.advFilterExpSvc.translate("ariaLabelAdvancedFilterAutocomplete")), this.refresh(), this.addManagedListeners(this.eAutocomplete, {
      eventValueChanged: ({ value: o }) => this.onValueChanged(o),
      eventValueConfirmed: ({ isValid: o }) => this.onValueConfirmed(o),
      eventOptionSelected: ({ position: o, updateEntry: n, autocompleteType: s }) => this.onOptionSelected(o, n, s),
      eventValidChanged: ({ isValid: o, validationMessage: n }) => this.onValidChanged(o, n)
    });
    const { buttons: e, suppressBuilderButton: t } = {
      ...x0,
      ...this.gos.get("advancedFilterParams")
    };
    this.setupButtons(e), this.setupBuilderButton(t), this.beans.gos.addManagedPropertyListener("advancedFilterParams", (o) => {
      const n = { ...x0, ...o.currentValue }, s = { ...x0, ...o.previousValue };
      if (n.buttons !== s.buttons) {
        const i = n.buttons.map((r) => ({
          type: r,
          label: this.advFilterExpSvc.translate(ku[r])
        }));
        this.eButtons.updateButtons(i);
      }
      n.suppressBuilderButton !== s.suppressBuilderButton && He(this.eBuilderFilterButton, !n.suppressBuilderButton);
    });
  }
  refresh() {
    const e = this.advancedFilter.getExpressionDisplayValue();
    this.eAutocomplete.setValue({
      value: e ?? "",
      position: e == null ? void 0 : e.length,
      updateListOnlyIfOpen: !0
    });
  }
  setInputDisabled(e) {
    this.eAutocomplete.setInputDisabled(e), this.eButtons.updateValidity(
      !e && !this.isApplyDisabled && !this.advancedFilter.isCurrentExpressionApplied()
    );
  }
  setupButtons(e) {
    const t = e.map((n) => ({
      type: n,
      label: this.advFilterExpSvc.translate(ku[n])
    })), o = (n) => () => {
      this.updateModel(n);
    };
    this.eButtons.addManagedListeners(this.eButtons, {
      apply: o("apply"),
      clear: o("clear"),
      reset: o("reset"),
      cancel: o("cancel")
    }), this.eButtons.updateButtons(t);
  }
  updateModel(e) {
    var t, o;
    switch (e) {
      case "apply":
        this.onValueConfirmed(this.eAutocomplete.isValid());
        break;
      case "reset":
        this.advancedFilter.setModel(null), (t = this.filterManager) == null || t.onFilterChanged({ source: "advancedFilter" });
        break;
      case "cancel":
        this.advancedFilter.setModel(this.advancedFilter.getModel()), (o = this.filterManager) == null || o.onFilterChanged({ source: "advancedFilter" });
        break;
      case "clear":
        this.eAutocomplete.setValue({
          value: "",
          restoreFocus: !0
        });
        break;
    }
  }
  setupBuilderButton(e) {
    this.eBuilderFilterButtonIcon.appendChild(Ie("advancedFilterBuilder", this.beans)), this.eBuilderFilterButtonLabel.textContent = this.advFilterExpSvc.translate("advancedFilterBuilder"), this.activateTabIndex([this.eBuilderFilterButton]), this.addManagedElementListeners(this.eBuilderFilterButton, { click: () => this.openBuilder() }), this.addManagedListeners(this.advancedFilter.getCtrl(), {
      advancedFilterBuilderClosed: () => this.closeBuilder()
    }), He(this.eBuilderFilterButton, !e);
  }
  onValueChanged(e) {
    var o;
    e = Ft(e), this.advancedFilter.setExpressionDisplayValue(e), this.expressionParser = this.advancedFilter.createExpressionParser(e);
    const t = (o = this.expressionParser) == null ? void 0 : o.parseExpression();
    t && t !== e && this.eAutocomplete.setValue({ value: t, silent: !0, restoreFocus: !0 });
  }
  onValueConfirmed(e) {
    var t, o;
    !e || this.isApplyDisabled || ((t = this.eButtons) == null || t.updateValidity(!1), this.advancedFilter.applyExpression(), (o = this.filterManager) == null || o.onFilterChanged({ source: "advancedFilter" }));
  }
  onOptionSelected(e, t, o) {
    const { updatedValue: n, updatedPosition: s, hideAutocomplete: i } = this.updateExpression(e, t, o);
    this.eAutocomplete.setValue({
      value: n,
      position: s,
      updateListOnlyIfOpen: i,
      restoreFocus: !0
    });
  }
  validateValue() {
    var e, t;
    return (e = this.expressionParser) != null && e.isValid() ? null : ((t = this.expressionParser) == null ? void 0 : t.getValidationMessage()) ?? null;
  }
  onValidChanged(e, t) {
    var o;
    this.isApplyDisabled = !e || this.advancedFilter.isCurrentExpressionApplied(), this.eButtons.updateValidity(!this.isApplyDisabled), (o = this.tooltipFeature) == null || o.setTooltipAndRefresh(t);
  }
  generateAutocompleteListParams(e) {
    return this.expressionParser ? this.expressionParser.getAutocompleteListParams(e) : this.advFilterExpSvc.getDefaultAutocompleteListParams("");
  }
  updateExpression(e, t, o) {
    var n;
    return this.advFilterExpSvc.updateAutocompleteCache(t, o), ((n = this.expressionParser) == null ? void 0 : n.updateExpression(e, t, o)) ?? this.advancedFilter.getDefaultExpression(t);
  }
  forceLastSelection({ key: e, displayValue: t }, o) {
    return !!o.toLocaleLowerCase().match(`^${(t ?? e).toLocaleLowerCase()}\\s*$`);
  }
  openBuilder() {
    this.builderOpen || (this.builderOpen = !0, qs(this.eBuilderFilterButton, !0), this.advancedFilter.getCtrl().toggleFilterBuilder({ source: "ui", eventSource: this.eBuilderFilterButton }));
  }
  closeBuilder() {
    this.builderOpen && (this.builderOpen = !1, qs(this.eBuilderFilterButton, !1), this.eBuilderFilterButton.focus());
  }
}, Oqe = {
  tag: "div",
  cls: "ag-advanced-filter-header",
  role: "row"
}, Bqe = class extends Re {
  constructor(e) {
    super(Oqe), this.enabled = e;
  }
  wireBeans(e) {
    this.colModel = e.colModel, this.focusSvc = e.focusSvc, this.ctrlsSvc = e.ctrlsSvc;
  }
  postConstruct() {
    this.setupAdvancedFilter(this.enabled), this.addDestroyFunc(() => this.destroyBean(this.eAdvancedFilter));
    const e = () => {
      this.enabled && this.setEnabledHeight();
    };
    this.addManagedEventListeners({
      gridColumnsChanged: () => this.onGridColumnsChanged(),
      columnHeaderHeightChanged: e,
      gridStylesChanged: e
    }), this.addManagedPropertyListener("headerHeight", e), this.addManagedPropertyListener("floatingFiltersHeight", e), this.addGuiEventListener("keydown", (t) => this.onKeyDown(t)), this.addGuiEventListener("focusout", (t) => {
      this.getFocusableElement().contains(t.relatedTarget) || this.focusSvc.clearAdvancedFilterColumn();
    });
  }
  getFocusableElement() {
    var e;
    return ((e = this.eAdvancedFilter) == null ? void 0 : e.getGui()) ?? this.getGui();
  }
  setEnabled(e) {
    e !== this.enabled && this.setupAdvancedFilter(e);
  }
  refresh() {
    var e;
    (e = this.eAdvancedFilter) == null || e.refresh();
  }
  getHeight() {
    return this.height;
  }
  setInputDisabled(e) {
    var t;
    (t = this.eAdvancedFilter) == null || t.setInputDisabled(e);
  }
  setupAdvancedFilter(e) {
    const t = this.getGui();
    if (e) {
      this.eAdvancedFilter = this.createBean(new d_());
      const o = this.eAdvancedFilter.getGui();
      this.eAdvancedFilter.addCss("ag-advanced-filter-header-cell"), this.setEnabledHeight(), this.setAriaRowIndex(), no(o, "gridcell"), v2(o, 1), this.setAriaColumnCount(o), t.appendChild(o);
    } else
      it(t), this.destroyBean(this.eAdvancedFilter), this.height = 0;
    He(t, e), this.enabled = e;
  }
  setEnabledHeight() {
    const e = this.getGui();
    this.height = Y2(this.beans);
    const t = `${this.height}px`;
    e.style.height = t, e.style.minHeight = t;
  }
  setAriaColumnCount(e) {
    nw(e, this.colModel.getCols().length);
  }
  setAriaRowIndex() {
    var e;
    Gr(this.getGui(), ((e = this.ctrlsSvc.getHeaderRowContainerCtrl()) == null ? void 0 : e.getRowCount()) ?? 0);
  }
  onGridColumnsChanged() {
    this.eAdvancedFilter && (this.setAriaColumnCount(this.eAdvancedFilter.getGui()), this.setAriaRowIndex());
  }
  onKeyDown(e) {
    switch (e.key) {
      case D.ENTER: {
        this.hasFocus() && so(this.getFocusableElement()) && e.preventDefault();
        break;
      }
      case D.ESCAPE:
        this.hasFocus() || this.getFocusableElement().focus();
        break;
      case D.UP:
        this.navigateUpDown(!0, e);
        break;
      case D.DOWN:
        this.navigateUpDown(!1, e);
        break;
      case D.TAB:
        if (this.hasFocus())
          this.navigateLeftRight(e);
        else {
          const t = Yt(
            this.beans,
            this.getFocusableElement(),
            null,
            e.shiftKey
          );
          t ? (e.preventDefault(), t.focus()) : this.navigateLeftRight(e);
        }
        break;
    }
  }
  navigateUpDown(e, t) {
    this.hasFocus() && this.focusSvc.focusNextFromAdvancedFilter(e) && t.preventDefault();
  }
  navigateLeftRight(e) {
    (e.shiftKey ? this.focusSvc.focusLastHeader() : this.focusSvc.focusNextFromAdvancedFilter(!1, !0)) && e.preventDefault();
  }
  hasFocus() {
    return Ue(this.beans) === this.getFocusableElement();
  }
}, M0 = "ag-list-item-hovered", u_ = class extends K {
  constructor(e, t, o) {
    super(), this.comp = e, this.virtualList = t, this.params = o, this.currentDragValue = null, this.lastHoveredListItem = null;
  }
  wireBeans(e) {
    this.dragAndDrop = e.dragAndDrop;
  }
  postConstruct() {
    this.addManagedListeners(this.params.eventSource, {
      [this.params.listItemDragStartEvent]: this.listItemDragStart.bind(this),
      [this.params.listItemDragEndEvent]: this.listItemDragEnd.bind(this)
    }), this.createDropTarget(), this.createAutoScrollService();
  }
  listItemDragStart(e) {
    this.currentDragValue = this.params.getCurrentDragValue(e), this.moveBlocked = this.params.isMoveBlocked(this.currentDragValue);
  }
  listItemDragEnd() {
    window.setTimeout(() => {
      this.currentDragValue = null, this.moveBlocked = !1;
    }, 10);
  }
  createDropTarget() {
    var t;
    const e = {
      isInterestedIn: (o) => o === this.params.dragSourceType,
      getIconName: () => this.moveBlocked ? "pinned" : "move",
      getContainer: () => this.comp.getGui(),
      onDragging: (o) => this.onDragging(o),
      onDragStop: () => this.onDragStop(),
      onDragLeave: () => this.onDragLeave(),
      onDragCancel: () => this.onDragCancel()
    };
    (t = this.dragAndDrop) == null || t.addDropTarget(e);
  }
  createAutoScrollService() {
    const e = this.virtualList.getGui();
    this.autoScrollService = new Wb({
      scrollContainer: e,
      scrollAxis: "y",
      getVerticalPosition: () => e.scrollTop,
      setVerticalPosition: (t) => e.scrollTop = t
    });
  }
  onDragging(e) {
    if (!this.currentDragValue || this.moveBlocked)
      return;
    const t = this.getListDragItem(e), o = this.virtualList.getComponentAt(t.rowIndex);
    if (!o)
      return;
    const n = o.getGui().parentElement;
    this.lastHoveredListItem && this.lastHoveredListItem.rowIndex === t.rowIndex && this.lastHoveredListItem.position === t.position || (this.autoScrollService.check(e.event), this.clearHoveredItems(), this.lastHoveredListItem = t, Cd(n, M0), Cd(n, `ag-item-highlight-${t.position}`));
  }
  getListDragItem(e) {
    const t = this.virtualList.getGui(), o = parseFloat(window.getComputedStyle(t).paddingTop), n = this.virtualList.getRowHeight(), s = this.virtualList.getScrollTop(), i = Math.max(0, (e.y - o + s) / n), r = this.params.getNumRows(this.comp) - 1, l = Math.min(r, i) | 0;
    return {
      rowIndex: l,
      position: Math.round(i) > i || i > r ? "bottom" : "top",
      component: this.virtualList.getComponentAt(l)
    };
  }
  onDragStop() {
    this.moveBlocked || (this.params.moveItem(this.currentDragValue, this.lastHoveredListItem), this.clearDragProperties());
  }
  onDragCancel() {
    this.clearDragProperties();
  }
  onDragLeave() {
    this.clearDragProperties();
  }
  clearDragProperties() {
    this.clearHoveredItems(), this.autoScrollService.ensureCleared();
  }
  clearHoveredItems() {
    this.virtualList.getGui().querySelectorAll(`.${M0}`).forEach((t) => {
      [M0, "ag-item-highlight-top", "ag-item-highlight-bottom"].forEach((o) => {
        t.classList.remove(o);
      });
    }), this.lastHoveredListItem = null;
  }
}, $qe = class extends K {
  constructor(e, t) {
    super(), this.comp = e, this.virtualList = t;
  }
  postConstruct() {
    this.createManagedBean(
      new u_(this.comp, this.virtualList, {
        dragSourceType: Hn.AdvancedFilterBuilder,
        listItemDragStartEvent: "advancedFilterBuilderDragStarted",
        listItemDragEndEvent: "advancedFilterBuilderDragEnded",
        eventSource: this,
        getCurrentDragValue: (e) => this.getCurrentDragValue(e),
        isMoveBlocked: () => !1,
        getNumRows: (e) => e.getNumItems(),
        moveItem: (e, t) => this.moveItem(e, t)
      })
    );
  }
  getCurrentDragValue(e) {
    return e.item;
  }
  moveItem(e, t) {
    this.comp.moveItem(e, t);
  }
}, Zqe = {
  tag: "div",
  cls: "ag-pill",
  role: "option",
  children: [
    {
      tag: "span",
      ref: "eText",
      cls: "ag-pill-text"
    },
    {
      tag: "span",
      ref: "eButton",
      cls: "ag-button ag-pill-button",
      role: "presentation"
    }
  ]
}, Gqe = class extends Re {
  constructor(e) {
    super(Zqe), this.config = e, this.eText = J, this.eButton = J;
  }
  postConstruct() {
    const { config: e, eButton: t } = this, { onKeyDown: o, onButtonClick: n } = e;
    this.getGui().setAttribute("tabindex", String(this.gos.get("tabIndex"))), this.addGuiEventListener("focus", () => {
      this.eButton.focus();
    }), o && this.addGuiEventListener("keydown", o), n && this.addManagedElementListeners(t, {
      click: n
    });
  }
  toggleCloseButtonClass(e, t) {
    this.eButton.classList.toggle(e, t);
  }
  setText(e) {
    this.eText.textContent = e;
  }
  getText() {
    return this.eText.textContent;
  }
}, Nqe = {
  tag: "div",
  cls: "ag-pill-container"
}, zqe = class extends Re {
  constructor() {
    super(Nqe), this.pills = [];
  }
  init(e) {
    this.params = e, this.refresh();
  }
  refresh() {
    this.clearPills();
    const { params: e, onPillKeyDown: t } = this;
    let o = e.getValue();
    if (!Array.isArray(o)) {
      if (o == null)
        return;
      o = [o];
    }
    const n = e.valueFormatter ?? ((i) => String(i)), s = o.length;
    no(this.getGui(), s === 0 ? "presentation" : "listbox");
    for (let i = 0; i < s; i++) {
      const r = o[i], l = this.createBean(
        new Gqe({
          onButtonClick: () => this.onPillButtonClick(l),
          onKeyDown: t.bind(this)
        })
      ), a = l.getGui();
      la(a, i + 1), ra(a, s), e.onPillMouseDown && l.addGuiEventListener("mousedown", e.onPillMouseDown), e.announceItemFocus && l.addGuiEventListener("focus", e.announceItemFocus), l.setText(n(r) ?? ""), l.toggleCloseButtonClass("ag-icon-cancel", !0), this.appendChild(a), this.pills.push(l);
    }
  }
  onNavigationKeyDown(e) {
    const { key: t } = e;
    if (!this.pills.length || t !== D.LEFT && t !== D.RIGHT)
      return;
    e.preventDefault();
    const { params: o, beans: n } = this, s = Ue(n), i = this.getGui();
    if (i.contains(s)) {
      const r = Yt(n, i, !1, t === D.LEFT);
      r ? r.focus() : o.eWrapper && o.eWrapper.focus();
    } else {
      const r = Fn(i);
      r.length > 0 && r[t === D.RIGHT ? 0 : r.length - 1].focus();
    }
  }
  clearPills() {
    const e = this.getGui();
    e.contains(Ue(this.beans)) && this.params.eWrapper && this.params.eWrapper.focus(), it(e), this.destroyBeans(this.pills), this.pills = [];
  }
  onPillButtonClick(e) {
    this.deletePill(e);
  }
  onPillKeyDown(e) {
    const t = e.key;
    if (t !== D.DELETE && t !== D.BACKSPACE)
      return;
    e.preventDefault();
    const o = Pt(this.beans), n = this.pills.findIndex((i) => i.getGui().contains(o.activeElement));
    if (n === -1)
      return;
    const s = this.pills[n];
    s && this.deletePill(s, n);
  }
  deletePill(e, t) {
    const o = e.getText(), n = (this.params.getValue() || []).filter((s) => s !== o);
    if (this.params.setValue(n), !n.length && this.params.eWrapper)
      this.params.eWrapper.focus();
    else if (t != null) {
      const s = this.pills[Math.min(t, this.pills.length - 1)];
      s && s.getFocusableElement().focus();
    }
  }
  destroy() {
    this.clearPills(), super.destroy();
  }
}, jqe = (
  /*css*/
  ".ag-rich-select{cursor:default;height:100%}.ag-rich-select-value{align-items:center;background-color:var(--ag-picker-button-background-color);display:flex;height:100%;padding:var(--ag-spacing);:where(.ag-picker-field-display){overflow:hidden;text-overflow:ellipsis;&:where(.ag-display-as-placeholder){opacity:.5}}}.ag-rich-select-list{background-color:var(--ag-picker-list-background-color);border:var(--ag-picker-list-border);border-radius:var(--ag-input-border-radius);box-shadow:var(--ag-dropdown-shadow);height:auto;position:relative;width:100%;:where(.ag-loading-text){padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding)}}.ag-rich-select-row{align-items:center;display:flex;flex:1 1 auto;height:100%;overflow:hidden;padding:0 var(--ag-spacing);white-space:nowrap}.ag-rich-select-row-selected{background-color:var(--ag-selected-row-background-color)}.ag-rich-select-row-highlighted,.ag-rich-select-row:hover{background-image:linear-gradient(var(--ag-row-hover-color),var(--ag-row-hover-color))}.ag-rich-select-row-text-highlight{font-weight:700}.ag-rich-select-field-input{flex:1 1 auto;:where(.ag-input-field-input){border:none!important;box-shadow:none!important;padding:0!important;text-overflow:ellipsis;&::-moz-placeholder{opacity:.8}&::placeholder{opacity:.8}}}:where(.ag-ltr) .ag-rich-select-field-input{left:var(--ag-spacing)}:where(.ag-rtl) .ag-rich-select-field-input{right:var(--ag-spacing)}:where(.ag-popup-editor) .ag-rich-select-value{height:var(--ag-row-height);min-width:200px}.ag-rich-select-virtual-list-item{cursor:default;height:var(--ag-list-item-height)}.ag-pill-container{display:flex;flex-wrap:nowrap;gap:.25rem}.ag-pill{align-items:center;background:var(--ag-select-cell-background-color);border:var(--ag-select-cell-border);border-radius:var(--ag-border-radius);display:flex;padding:0 .25rem;white-space:nowrap}.ag-pill-button{border:none;padding:0;&:hover{color:var(--ag-accent-color);cursor:pointer}}:where(.ag-ltr) .ag-pill-button{margin-left:var(--ag-spacing)}:where(.ag-rtl) .ag-pill-button{margin-right:var(--ag-spacing)}"
), Wqe = { tag: "div", cls: "ag-rich-select-row", role: "presentation" }, Uqe = class extends Re {
  constructor(e) {
    super(Wqe), this.params = e;
  }
  wireBeans(e) {
    this.userCompFactory = e.userCompFactory, this.registry = e.registry;
  }
  postConstruct() {
    this.tooltipFeature = this.createOptionalManagedBean(
      this.registry.createDynamicBean(
        "highlightTooltipFeature",
        !1,
        {
          getGui: () => this.getGui(),
          shouldDisplayTooltip: () => {
            var e;
            return ((e = this.shouldDisplayTooltip) == null ? void 0 : e.call(this)) ?? !0;
          }
        },
        this
      )
    );
  }
  setState(e) {
    var s;
    const { params: t } = this, o = ((s = t.valueFormatter) == null ? void 0 : s.call(t, e)) ?? "";
    this.populateWithRenderer(e, o) || this.populateWithoutRenderer(e, o), this.value = e;
  }
  highlightString(e) {
    const { parsedValue: t, params: o } = this;
    if (o.cellRenderer || !ue(t))
      return;
    let n = ue(e);
    if (n) {
      const s = t == null ? void 0 : t.toLocaleLowerCase().indexOf(e.toLocaleLowerCase());
      if (s >= 0) {
        const i = s + e.length, r = this.getGui().querySelector("span");
        r && (it(r), r.append(
          // Start part
          t.slice(0, s),
          // Highlighted part wrapped in bold tag
          ze({
            tag: "span",
            cls: "ag-rich-select-row-text-highlight",
            children: t.slice(s, i)
          }),
          // End part
          t.slice(i)
        ));
      } else
        n = !1;
    }
    n || this.renderValueWithoutRenderer(t);
  }
  updateSelected(e) {
    const t = this.getGui();
    m2(t.parentElement, e), this.toggleCss("ag-rich-select-row-selected", e);
  }
  getValue() {
    return this.value;
  }
  toggleHighlighted(e) {
    this.toggleCss("ag-rich-select-row-highlighted", e), this.dispatchLocalEvent({
      type: "itemHighlighted",
      highlighted: e
    });
  }
  populateWithoutRenderer(e, t) {
    var i;
    const o = this.getGui(), n = ze({ tag: "span" });
    n.style.overflow = "hidden", n.style.textOverflow = "ellipsis";
    const s = ni(ue(t) ? t : e);
    this.parsedValue = ue(s) ? s : null, o.appendChild(n), this.renderValueWithoutRenderer(s), this.shouldDisplayTooltip = Hs(() => n), (i = this.tooltipFeature) == null || i.setTooltipAndRefresh(this.parsedValue);
  }
  renderValueWithoutRenderer(e) {
    const t = this.getGui().querySelector("span");
    t && (t.textContent = ue(e) ? e : " ");
  }
  populateWithRenderer(e, t) {
    var s;
    let o, n;
    if (this.params.cellRenderer) {
      const i = (s = this.getParentComponent()) == null ? void 0 : s.getParentComponent();
      n = Qw(
        this.userCompFactory,
        this.params,
        Pe(this.gos, {
          value: e,
          valueFormatted: t,
          getValue: () => i == null ? void 0 : i.getValue(),
          setValue: (r) => {
            i == null || i.setValue(r, !0);
          },
          setTooltip: (r, l) => {
            var a;
            this.gos.assertModuleRegistered("Tooltip", 3), this.shouldDisplayTooltip = l, (a = this.tooltipFeature) == null || a.setTooltipAndRefresh(r);
          }
        })
      );
    }
    return n && (o = n.newAgStackInstance()), o && g_(o, this.getGui()), o ? (o.then((i) => {
      this.addDestroyFunc(() => {
        this.destroyBean(i);
      });
    }), !0) : !1;
  }
}, Hu = "ag-rich-select-list", Vu = "ag-rich-select-row", Kqe = class extends nr {
  constructor(e, t, o) {
    super({ cssIdentifier: "rich-select" }), this.params = e, this.richSelectWrapper = t, this.getSearchString = o, this.lastRowHovered = -1, this.selectedItems = /* @__PURE__ */ new Set(), this.params = e, this.setComponentCreator(this.createRowComponent.bind(this)), this.setComponentUpdater(() => {
    });
  }
  postConstruct() {
    super.postConstruct(), this.eLoading = ze({
      tag: "div",
      cls: "ag-loading-text",
      children: this.getLocaleTextFunc()("loadingOoo", "Loading...")
    });
    const { cellRowHeight: e, pickerAriaLabelKey: t, pickerAriaLabelValue: o } = this.params;
    e && this.setRowHeight(e);
    const n = this.getGui(), s = this.getAriaElement();
    this.addManagedListeners(n, {
      mousemove: this.onMouseMove.bind(this),
      mouseout: this.onMouseOut.bind(this),
      mousedown: this.onMouseDown.bind(this),
      click: this.onClick.bind(this)
    }), n.classList.add(Hu);
    const i = `${Hu}-${this.getCompId()}`;
    s.setAttribute("id", i);
    const l = this.getLocaleTextFunc()(t, o);
    ft(s, l), C2(this.richSelectWrapper, s);
  }
  navigateToPage(e) {
    const t = super.navigateToPage(e, this.lastRowHovered);
    return t != null && yo(this.beans, () => {
      if (!this.isAlive())
        return null;
      this.highlightIndex(t);
    }), t;
  }
  drawVirtualRows(e) {
    super.drawVirtualRows(e), this.refreshSelectedItems();
  }
  highlightFilterMatch(e) {
    this.forEachRenderedRow((t) => {
      t.highlightString(e);
    });
  }
  onNavigationKeyDown(e, t) {
    yo(this.beans, () => {
      if (!this.currentList || !this.isAlive())
        return;
      const o = this.currentList.length, n = this.lastRowHovered, s = e === D.DOWN ? 1 : -1, i = Math.min(Math.max(n === -1 ? 0 : n + s, 0), o - 1);
      this.highlightIndex(i), t();
    });
  }
  selectValue(e) {
    var n, s;
    if (!this.currentList)
      return this.eLoading && this.appendChild(this.eLoading), !1;
    if ((n = this.eLoading) != null && n.offsetParent && ((s = this.eLoading.parentElement) == null || s.removeChild(this.eLoading)), e == null)
      return !1;
    const t = this.getIndicesForValues(e), o = t.length > 0;
    return o && (this.refresh(), this.ensureIndexVisible(t[0]), this.refresh(!0)), this.selectListItems(Array.isArray(e) ? e : [e]), o;
  }
  selectListItems(e, t = !1) {
    t || this.selectedItems.clear();
    for (let o = 0; o < e.length; o++) {
      const n = e[o];
      this.findItemInSelected(n) === void 0 && this.selectedItems.add(n);
    }
    this.refreshSelectedItems();
  }
  getCurrentList() {
    return this.currentList;
  }
  setCurrentList(e) {
    this.currentList = e, this.setModel({
      getRowCount: () => e.length,
      getRow: (t) => e[t],
      areRowsEqual: (t, o) => t === o
    });
  }
  getSelectedItems() {
    return this.selectedItems;
  }
  getLastItemHovered() {
    return this.currentList[this.lastRowHovered];
  }
  highlightIndex(e, t) {
    this.currentList && (e < 0 || e >= this.currentList.length ? this.lastRowHovered = -1 : (this.lastRowHovered = e, this.ensureIndexVisible(e, !t) && !t && this.refresh(!0)), this.forEachRenderedRow((o, n) => {
      const s = e === n;
      if (o.toggleHighlighted(s), s) {
        const i = `${Vu}-${o.getCompId()}`;
        tw(this.richSelectWrapper, i), this.richSelectWrapper.setAttribute("data-active-option", i);
      }
    }));
  }
  getIndicesForValues(e) {
    const { currentList: t } = this;
    if (!t || t.length === 0 || e == null)
      return [];
    if (Array.isArray(e) || (e = [e]), e.length === 0)
      return [];
    const { valueFormatter: o } = this.params, n = [], s = typeof e[0] == "object", i = t.map(o);
    for (const r of e) {
      let l = -1;
      s ? l = i.indexOf(o(r)) : l = t.indexOf(r), l >= 0 && n.push(l);
    }
    return n;
  }
  toggleListItemSelection(e) {
    const t = this.findItemInSelected(e);
    t !== void 0 ? this.selectedItems.delete(t) : this.selectedItems.add(e), this.refreshSelectedItems(), this.dispatchValueSelected();
  }
  refreshSelectedItems() {
    this.forEachRenderedRow((e) => {
      const t = this.findItemInSelected(e.getValue()) !== void 0;
      e.updateSelected(t);
    });
  }
  findItemInSelected(e) {
    if (typeof e == "object") {
      const t = this.params.valueFormatter, o = t(e);
      for (const n of this.selectedItems)
        if (t(n) === o)
          return n;
    } else
      return this.selectedItems.has(e) ? e : void 0;
  }
  createRowComponent(e, t) {
    const o = new Uqe(this.params);
    t.setAttribute("id", `${Vu}-${o.getCompId()}`), o.setParentComponent(this), this.createBean(o), o.setState(e);
    const { highlightMatch: n, searchType: s = "fuzzy" } = this.params;
    return n && s !== "fuzzy" && o.highlightString(this.getSearchString()), o;
  }
  getRowForMouseEvent(e) {
    if (!this.model)
      return -1;
    const o = this.getGui().getBoundingClientRect(), n = this.getScrollTop(), s = e.clientY - o.top + n;
    return Math.min(Math.floor(s / this.getRowHeight()), this.model.getRowCount() - 1);
  }
  onMouseMove(e) {
    const t = this.getRowForMouseEvent(e);
    t !== -1 && t != this.lastRowHovered && (this.lastRowHovered = t, this.highlightIndex(t, !0));
  }
  onMouseDown(e) {
    e.preventDefault();
  }
  onMouseOut(e) {
    this.getGui().contains(e.relatedTarget) || this.highlightIndex(-1);
  }
  onClick(e) {
    const { multiSelect: t } = this.params;
    if (!this.currentList)
      return;
    const o = this.getRowForMouseEvent(e), n = this.currentList[o];
    t ? this.toggleListItemSelection(n) : (this.selectListItems([n]), this.dispatchValueSelected());
  }
  dispatchValueSelected() {
    this.dispatchLocalEvent({
      type: "richSelectListRowSelected",
      fromEnterKey: !1,
      value: this.selectedItems
    });
  }
  destroy() {
    super.destroy(), this.eLoading = void 0;
  }
}, qqe = {
  tag: "div",
  cls: "ag-picker-field",
  role: "presentation",
  children: [
    { tag: "div", ref: "eLabel" },
    {
      tag: "div",
      ref: "eWrapper",
      cls: "ag-wrapper ag-picker-field-wrapper ag-rich-select-value ag-picker-collapsed",
      children: [
        { tag: "span", ref: "eDisplayField", cls: "ag-picker-field-display" },
        { tag: "ag-input-text-field", ref: "eInput", cls: "ag-rich-select-field-input" },
        {
          tag: "span",
          ref: "eDeselect",
          cls: "ag-rich-select-deselect-button ag-picker-field-icon",
          role: "presentation"
        },
        { tag: "span", ref: "eIcon", cls: "ag-picker-field-icon", attrs: { "aria-hidden": "true" } }
      ]
    }
  ]
}, h_ = class extends ib {
  constructor(e) {
    super({
      pickerAriaLabelKey: "ariaLabelRichSelectField",
      pickerAriaLabelValue: "Rich Select Field",
      pickerType: "ag-list",
      className: "ag-rich-select",
      pickerIcon: "richSelectOpen",
      ariaRole: "combobox",
      template: (e == null ? void 0 : e.template) ?? qqe,
      agComponents: [zo],
      modalPicker: !1,
      ...e,
      // maxPickerHeight needs to be set after expanding `config`
      maxPickerHeight: (e == null ? void 0 : e.maxPickerHeight) ?? "calc(var(--ag-row-height) * 6.5)"
    }), this.searchString = "", this.searchStringCreator = null, this.eInput = J, this.eDeselect = J, this.skipWrapperAnnouncement = !1;
    const { value: t, valueList: o, searchStringCreator: n } = e || {};
    t !== void 0 && (this.value = t), n && (this.searchStringCreator = n), o != null && this.setValues(o), this.registerCSS(jqe);
  }
  wireBeans(e) {
    this.userCompFactory = e.userCompFactory, this.ariaAnnounce = e.ariaAnnounce, this.registry = e.registry;
  }
  postConstruct() {
    this.tooltipFeature = this.createOptionalManagedBean(
      this.registry.createDynamicBean("tooltipFeature", !1, {
        getGui: () => this.getGui(),
        shouldDisplayTooltip: () => {
          var s;
          return ((s = this.shouldDisplayTooltip) == null ? void 0 : s.call(this)) ?? !0;
        }
      })
    ), super.postConstruct(), this.createListComponent(), this.eDeselect.appendChild(Ie("richSelectRemove", this.beans));
    const { allowTyping: e, placeholder: t, suppressDeselectAll: o } = this.config;
    this.eDeselect.classList.add("ag-hidden"), e ? (this.eInput.setAutoComplete(!1).setInputPlaceholder(t), this.eDisplayField.classList.add("ag-hidden")) : this.eInput.setDisplayed(!1), this.setupAriaProperties();
    const { searchDebounceDelay: n = 300 } = this.config;
    this.clearSearchString = Rt(this, this.clearSearchString.bind(this), n), this.renderSelectedValue(), e && this.eInput.onValueChange((s) => this.searchTextFromString(s)), this.addManagedElementListeners(this.eWrapper, { focus: this.onWrapperFocus.bind(this) }), this.addManagedElementListeners(this.eWrapper, { focusout: this.onWrapperFocusOut.bind(this) }), o || this.addManagedElementListeners(this.eDeselect, {
      mousedown: this.onDeselectAllMouseDown.bind(this),
      click: this.onDeselectAllClick.bind(this)
    });
  }
  setupAriaProperties() {
    const { eWrapper: e, gos: t } = this;
    e.tabIndex = t.get("tabIndex");
    const o = this.getLocaleTextFunc();
    this.ariaDeleteSelection = o("ariaLabelRichSelectDeleteSelection", "Press DELETE to deselect item"), this.ariaDeselectAllItems = o(
      "ariaLabelRichSelectDeselectAllItems",
      "Press DELETE to deselect all items"
    ), this.ariaToggleSelection = o("ariaLabelRichSelectToggleSelection", "Press SPACE to toggle selection");
  }
  createListComponent() {
    this.listComponent = this.createBean(
      new Kqe(this.config, this.getFocusableElement(), () => this.searchString)
    ), this.listComponent.setParentComponent(this), this.addManagedListeners(this.listComponent, {
      richSelectListRowSelected: (e) => {
        this.onListValueSelected(e.value, e.fromEnterKey);
      }
    });
  }
  renderSelectedValue() {
    var C;
    const { value: e, eDisplayField: t, config: o, gos: n } = this, {
      allowTyping: s,
      cellRenderer: i,
      initialInputValue: r,
      multiSelect: l,
      suppressDeselectAll: a,
      suppressMultiSelectPillRenderer: c,
      valueFormatter: d
    } = o, u = Ou(e, d);
    if (s) {
      this.eInput.setValue(r ?? u);
      return;
    }
    if (l && !a) {
      const m = e == null || Array.isArray(e) && e.length === 0;
      this.eDeselect.classList.toggle("ag-hidden", m);
    }
    let h;
    if (l && !c) {
      this.createOrUpdatePillContainer(t);
      return;
    }
    i && (h = Qw(
      this.userCompFactory,
      o,
      Pe(this.gos, {
        value: e,
        valueFormatted: u,
        getValue: () => this.getValue(),
        setValue: (m) => {
          this.setValue(m, !0);
        },
        setTooltip: (m, w) => {
          var y;
          n.assertModuleRegistered("Tooltip", 3), this.shouldDisplayTooltip = w, (y = this.tooltipFeature) == null || y.setTooltipAndRefresh(m);
        }
      })
    ));
    let p;
    if (h && (p = h.newAgStackInstance()), p)
      it(t), g_(p, t), p.then((m) => {
        this.addDestroyFunc(() => this.destroyBean(m));
      });
    else {
      if (ue(this.value))
        t.innerText = u, t.classList.remove("ag-display-as-placeholder");
      else {
        const { placeholder: m } = o;
        ue(m) ? (t.textContent = m, t.classList.add("ag-display-as-placeholder")) : it(t);
      }
      this.shouldDisplayTooltip = Hs(() => this.eDisplayField), (C = this.tooltipFeature) == null || C.setTooltipAndRefresh(u ?? null);
    }
  }
  createPickerComponent() {
    const { values: e } = this;
    return e && this.setValueList({ valueList: e }), this.listComponent;
  }
  setSearchStringCreator(e) {
    this.searchStringCreator = e;
  }
  setValueList(e) {
    const { valueList: t, refresh: o } = e;
    !this.listComponent || this.listComponent.getCurrentList() === t || (this.listComponent.setCurrentList(t), o && (this.values ? this.listComponent.refresh(!0) : (this.setValues(t), this.isPickerDisplayed && (this.listComponent.selectValue(this.value) || this.listComponent.refresh())), this.alignPickerToComponent()));
  }
  /**
   * This method updates the list of values
   */
  setValues(e) {
    this.values = e, this.searchStrings = this.getSearchStringsFromValues(e);
  }
  showPicker() {
    var n;
    super.showPicker();
    const { listComponent: e, value: t } = this;
    if (!e)
      return;
    let o = null;
    e.selectValue(this.value), this.value != null && (o = e.getIndicesForValues(Array.isArray(t) ? t : [t])[0]), o != null ? ((n = this.tooltipFeature) == null || n.attemptToHideTooltip(), e.highlightIndex(o)) : e.refresh(), this.displayOrHidePicker();
  }
  createOrUpdatePillContainer(e) {
    if (!this.pillContainer) {
      const t = this.pillContainer = this.createBean(new zqe());
      this.addDestroyFunc(() => {
        this.destroyBean(this.pillContainer), this.pillContainer = null;
      }), it(e), e.appendChild(t.getGui());
      const { config: o, eWrapper: n, ariaDeleteSelection: s } = this, { valueFormatter: i } = o;
      t.init({
        eWrapper: n,
        valueFormatter: i,
        onPillMouseDown: (r) => {
          r.stopImmediatePropagation();
        },
        announceItemFocus: () => {
          this.announceAriaValue(s);
        },
        getValue: () => this.getValue(),
        setValue: (r) => this.setValue(r, !0)
      });
    }
    this.doWhileBlockingAnnouncement(() => {
      var t;
      return (t = this.pillContainer) == null ? void 0 : t.refresh();
    });
  }
  doWhileBlockingAnnouncement(e) {
    this.skipWrapperAnnouncement = !0, e(), this.skipWrapperAnnouncement = !1;
  }
  onWrapperFocus() {
    const { eInput: e, config: t } = this, { allowTyping: o, multiSelect: n, suppressDeselectAll: s } = t;
    if (o) {
      const i = e.getFocusableElement();
      i.focus(), i.select();
    } else n && !s && !this.skipWrapperAnnouncement && this.announceAriaValue(this.ariaDeselectAllItems);
  }
  onWrapperFocusOut(e) {
    this.eWrapper.contains(e.relatedTarget) || this.hidePicker();
  }
  onDeselectAllMouseDown(e) {
    e.stopImmediatePropagation();
  }
  onDeselectAllClick() {
    this.setValue([], !0);
  }
  buildSearchStringFromKeyboardEvent(e) {
    let { key: t } = e;
    if (t === D.BACKSPACE)
      this.searchString = this.searchString.slice(0, -1), t = "";
    else if (!k2(e))
      return;
    e.preventDefault(), this.searchTextFromCharacter(t);
  }
  searchTextFromCharacter(e) {
    this.searchString += e, this.runSearch(), this.clearSearchString();
  }
  searchTextFromString(e) {
    e == null && (e = ""), this.searchString = e, this.runSearch();
  }
  getSearchStringsFromValues(e) {
    const {
      config: { valueFormatter: t }
    } = this;
    return typeof e[0] == "object" && this.searchStringCreator ? this.searchStringCreator(e) : e.map((o) => Ou(o, t));
  }
  filterListModel(e) {
    const { filterList: t } = this.config;
    t && this.setValueList({ valueList: e, refresh: !0 });
  }
  runSearch() {
    var a;
    if (!this.listComponent)
      return;
    const { values: e } = this, t = this.searchStrings;
    if (!t) {
      this.listComponent.highlightIndex(-1);
      return;
    }
    const { suggestions: o, filteredValues: n } = this.getSuggestionsAndFilteredValues(this.searchString, t), { filterList: s, highlightMatch: i, searchType: r = "fuzzy" } = this.config, l = !!(s && this.searchString !== "");
    this.filterListModel(l ? n : e), this.highlightEmptyValue() || this.highlightListValue(o, n, l), i && r !== "fuzzy" && ((a = this.listComponent) == null || a.highlightFilterMatch(this.searchString)), this.displayOrHidePicker();
  }
  highlightEmptyValue() {
    var e, t;
    if (this.searchString === "") {
      const o = (e = this.searchStrings) == null ? void 0 : e.indexOf("");
      if (o !== void 0 && o !== -1)
        return (t = this.listComponent) == null || t.highlightIndex(o), !0;
    }
    return !1;
  }
  highlightListValue(e, t, o) {
    var n, s, i, r, l;
    if (e.length) {
      const a = o ? 0 : (n = this.searchStrings) == null ? void 0 : n.indexOf(e[0]);
      a !== void 0 && ((s = this.listComponent) == null || s.highlightIndex(a));
    } else if ((i = this.listComponent) == null || i.highlightIndex(-1), !o || t.length)
      (r = this.listComponent) == null || r.ensureIndexVisible(0);
    else if (o) {
      this.getAriaElement().removeAttribute("data-active-option");
      const a = (l = this.listComponent) == null ? void 0 : l.getAriaElement();
      a && tw(a, null);
    }
  }
  getSuggestionsAndFilteredValues(e, t) {
    let o = [];
    const n = [];
    if (!e.length)
      return { suggestions: o, filteredValues: n };
    const { searchType: s = "fuzzy", filterList: i } = this.config;
    if (s === "fuzzy") {
      const r = Yr({
        inputValue: e,
        allSuggestions: t,
        hideIrrelevant: !0
      });
      o = r.values;
      const l = r.indices;
      if (i && l.length)
        for (let a = 0; a < l.length; a++)
          n.push(this.values[l[a]]);
    } else
      o = t.filter((r, l) => {
        const a = r.toLocaleLowerCase(), c = this.searchString.toLocaleLowerCase(), d = s === "match" ? a.startsWith(c) : a.indexOf(c) !== -1;
        return i && d && n.push(this.values[l]), d;
      });
    return { suggestions: o, filteredValues: n };
  }
  displayOrHidePicker() {
    if (!this.listComponent)
      return;
    const e = this.listComponent.getGui(), t = this.listComponent.getCurrentList(), o = t ? t.length === 0 : !1;
    e.classList.toggle("ag-hidden", o);
  }
  clearSearchString() {
    this.searchString = "";
  }
  setValue(e, t, o, n) {
    var i, r;
    if (this.value === e)
      return this;
    const s = Array.isArray(e);
    if (e != null) {
      if (!s) {
        const l = (i = this.listComponent) == null ? void 0 : i.getCurrentList();
        if ((l ? l.indexOf(e) : -1) === -1)
          return this;
      }
      o || (r = this.listComponent) == null || r.selectValue(e);
    }
    return super.setValue(e, t), n || this.renderSelectedValue(), this;
  }
  onNavigationKeyDown(e, t, o) {
    var s;
    e.preventDefault();
    const n = t === D.DOWN;
    if (!this.isPickerDisplayed && n) {
      this.showPicker();
      return;
    }
    (s = this.listComponent) == null || s.onNavigationKeyDown(t, o);
  }
  onEnterKeyDown(e) {
    var t;
    if (this.isPickerDisplayed && (e.preventDefault(), (t = this.listComponent) != null && t.getCurrentList())) {
      const o = this.listComponent.getLastItemHovered();
      this.config.multiSelect || o == null ? this.dispatchPickerEventAndHidePicker(this.value, !0) : this.onListValueSelected(/* @__PURE__ */ new Set([o]), !0);
    }
  }
  onDeleteKeyDown(e) {
    const { eWrapper: t, beans: o } = this;
    Ue(o) === t && (e.preventDefault(), this.setValue([], !0));
  }
  onTabKeyDown() {
    const { config: e, isPickerDisplayed: t, listComponent: o } = this, { multiSelect: n } = e;
    if (!(!t || !o)) {
      if (n) {
        const s = this.getValueFromSet(o.getSelectedItems());
        s && this.setValue(s, !1, !0, !0);
      } else {
        const s = o.getLastItemHovered();
        s && this.setValue(s, !1, !0);
      }
      this.hidePicker();
    }
  }
  getValueFromSet(e) {
    const { multiSelect: t } = this.config;
    let o = null;
    for (const n of e) {
      if (e.size === 1 && !t) {
        o = n;
        break;
      }
      o || (o = []), o.push(n);
    }
    return Array.isArray(o) && o.sort(), o;
  }
  onListValueSelected(e, t) {
    const o = this.getValueFromSet(e);
    this.setValue(o, !1, !0), this.config.multiSelect || this.dispatchPickerEventAndHidePicker(o, t);
  }
  dispatchPickerEventAndHidePicker(e, t) {
    const o = {
      type: "fieldPickerValueSelected",
      fromEnterKey: t,
      value: e
    };
    this.dispatchLocalEvent(o), this.hidePicker();
  }
  getFocusableElement() {
    const { allowTyping: e } = this.config;
    return e ? this.eInput.getFocusableElement() : super.getFocusableElement();
  }
  onKeyDown(e) {
    var c;
    const { key: t, isComposing: o } = e, {
      isPickerDisplayed: n,
      config: { allowTyping: s, multiSelect: i, suppressDeselectAll: r },
      listComponent: l,
      pickerComponent: a
    } = this;
    switch (t) {
      case D.LEFT:
      case D.RIGHT:
        (!s || this.pillContainer) && (e.preventDefault(), this.pillContainer && ((c = this.listComponent) == null || c.highlightIndex(-1), this.pillContainer.onNavigationKeyDown(e)));
        break;
      case D.PAGE_HOME:
      case D.PAGE_END:
        if (s) {
          e.preventDefault();
          const d = this.eInput.getInputElement(), u = t === D.PAGE_HOME ? 0 : d.value.length;
          d.setSelectionRange(u, u);
          break;
        }
      case D.PAGE_UP:
      case D.PAGE_DOWN:
        e.preventDefault(), a && (l == null || l.navigateToPage(t));
        break;
      case D.DOWN:
      case D.UP:
        o || this.onNavigationKeyDown(e, t, () => {
          i && (this.doWhileBlockingAnnouncement(() => this.eWrapper.focus()), this.announceAriaValue(this.ariaToggleSelection));
        });
        break;
      case D.ESCAPE:
        n && (ro(this.listComponent.getGui()) && (e.preventDefault(), vt(e)), this.hidePicker());
        break;
      case D.ENTER:
        o ? e.preventDefault() : this.onEnterKeyDown(e);
        break;
      case D.SPACE:
        if ((!s || o) && e.preventDefault(), !o && n && i && l) {
          const d = l.getLastItemHovered();
          d && l.toggleListItemSelection(d);
        }
        break;
      case D.TAB:
        this.onTabKeyDown();
        break;
      case D.DELETE:
        i && !r && this.onDeleteKeyDown(e);
        break;
      default:
        s || this.buildSearchStringFromKeyboardEvent(e);
    }
  }
  announceAriaValue(e) {
    var t;
    (t = this.ariaAnnounce) == null || t.announceValue(e, "richSelect");
  }
  destroy() {
    this.listComponent && (this.listComponent = this.destroyBean(this.listComponent)), this.searchStrings = void 0, super.destroy();
  }
}, Ou = (e, t) => (t == null ? void 0 : t(e)) ?? String(e ?? "");
function g_(e, t) {
  e.then((o) => {
    const n = o.getGui();
    n != null && t.appendChild(n);
  });
}
var Yqe = {
  tag: "div",
  cls: "ag-picker-field",
  role: "presentation",
  children: [
    { tag: "div", ref: "eLabel" },
    {
      tag: "div",
      ref: "eWrapper",
      cls: "ag-wrapper ag-picker-collapsed",
      children: [
        { tag: "div", ref: "eDisplayField", cls: "ag-picker-field-display" },
        { tag: "ag-input-text-field", ref: "eInput", cls: "ag-rich-select-field-input" },
        {
          tag: "span",
          ref: "eDeselect",
          cls: "ag-rich-select-deselect-button ag-picker-field-icon",
          role: "presentation"
        },
        { tag: "div", ref: "eIcon", cls: "ag-picker-field-icon", attrs: { "aria-hidden": "true" } }
      ]
    }
  ]
}, p_ = class extends h_ {
  constructor(e) {
    super({
      ...e,
      template: Yqe,
      agComponents: [zo]
    }), this.params = e;
  }
  showPicker() {
    setTimeout(() => super.showPicker());
  }
  hidePicker() {
    setTimeout(() => super.hidePicker());
  }
  postConstruct() {
    super.postConstruct();
    const { wrapperClassName: e, ariaLabel: t } = this.params;
    He(this.eDisplayField, !1), e && this.eWrapper.classList.add(e), as(this.eWrapper, ""), ft(this.eWrapper, t);
  }
  onEnterKeyDown(e) {
    vt(e), this.isPickerDisplayed ? super.onEnterKeyDown(e) : (e.preventDefault(), this.showPicker());
  }
}, f_ = class extends K {
  constructor(e, t, o) {
    super(), this.eGui = e, this.focusWrapper = t, this.eFocusableComp = o;
  }
  postConstruct() {
    this.addManagedElementListeners(this.eGui, {
      keydown: (t) => {
        switch (t.key) {
          case D.TAB:
            t.defaultPrevented || vt(t);
            break;
          case D.UP:
          case D.DOWN:
            vt(t);
            break;
          case D.ESCAPE:
            if (wo(t))
              return;
            this.eGui.contains(Ue(this.beans)) && (t.preventDefault(), vt(t), this.focusWrapper.focus());
            break;
        }
      }
    });
    const e = "ag-advanced-filter-builder-virtual-list-item-highlight";
    this.addManagedListeners(this.focusWrapper, {
      keydown: (t) => {
        switch (t.key) {
          case D.ENTER:
            if (wo(t))
              return;
            Ue(this.beans) === this.focusWrapper && (t.preventDefault(), vt(t), this.eFocusableComp.getFocusableElement().focus());
            break;
        }
      },
      focusin: () => {
        this.focusWrapper.classList.add(e);
      },
      focusout: (t) => {
        this.focusWrapper.contains(t.relatedTarget) || this.focusWrapper.classList.remove(e);
      }
    });
  }
};
function v_(e, t) {
  return {
    pickerAriaLabelKey: "ariaLabelAdvancedFilterBuilderAddField",
    pickerAriaLabelValue: "Advanced Filter Builder Add Field",
    pickerType: "ag-list",
    valueList: [
      {
        key: "condition",
        displayValue: e("advancedFilterBuilderAddCondition")
      },
      {
        key: "join",
        displayValue: e("advancedFilterBuilderAddJoin")
      }
    ],
    valueFormatter: (o) => o == null ? "" : o.displayValue ?? o.key,
    pickerIcon: "advancedFilterBuilderAdd",
    maxPickerWidth: `${t ?? 120}px`,
    wrapperClassName: "ag-advanced-filter-builder-item-button",
    ariaLabel: e("advancedFilterBuilderAddButtonTooltip")
  };
}
var Qqe = {
  tag: "div",
  cls: "ag-advanced-filter-builder-item-wrapper",
  role: "presentation",
  children: [
    {
      tag: "div",
      ref: "eItem",
      cls: "ag-advanced-filter-builder-item",
      role: "presentation",
      children: [
        {
          tag: "div",
          cls: "ag-advanced-filter-builder-item-tree-lines",
          attrs: { "aria-hidden": "true" },
          children: [
            {
              tag: "div",
              cls: "ag-advanced-filter-builder-item-tree-line-vertical-top ag-advanced-filter-builder-item-tree-line-horizontal"
            }
          ]
        }
      ]
    }
  ]
}, Jqe = class extends Re {
  constructor(e, t) {
    super(Qqe), this.item = e, this.focusWrapper = t, this.eItem = J;
  }
  wireBeans(e) {
    this.advFilterExpSvc = e.advFilterExpSvc, this.registry = e.registry;
  }
  postConstruct() {
    var o;
    ia(this.focusWrapper, 2);
    const e = v_(
      (n) => this.advFilterExpSvc.translate(n),
      (o = this.gos.get("advancedFilterBuilderParams")) == null ? void 0 : o.addSelectWidth
    ), t = this.createManagedBean(new p_(e));
    this.addManagedListeners(t, {
      fieldPickerValueSelected: ({ value: n }) => {
        this.dispatchLocalEvent({
          type: "advancedFilterBuilderAdded",
          item: this.item,
          isJoin: n.key === "join"
        });
      }
    }), this.eItem.appendChild(t.getGui()), this.createOptionalManagedBean(
      this.registry.createDynamicBean("tooltipFeature", !1, {
        getGui: () => t.getGui(),
        getLocation: () => "advancedFilter",
        getTooltipValue: () => this.advFilterExpSvc.translate("advancedFilterBuilderAddButtonTooltip")
      })
    ), this.createManagedBean(
      new f_(this.getGui(), this.focusWrapper, t)
    ), ft(
      this.focusWrapper,
      this.advFilterExpSvc.translate("ariaAdvancedFilterBuilderItem", [
        this.advFilterExpSvc.translate("advancedFilterBuilderAddButtonTooltip"),
        `${this.item.level + 1}`
      ])
    );
  }
  afterAdd() {
  }
}, Xqe = class extends Re {
  constructor() {
    super({ tag: "div", cls: "ag-advanced-filter-builder-item-condition", role: "presentation" }), this.validationMessage = null;
  }
  wireBeans(e) {
    this.advFilterExpSvc = e.advFilterExpSvc;
  }
  init(e) {
    const { item: t, createPill: o } = e;
    this.item = t, this.createPill = o, this.filterModel = t.filterModel, this.setupColumnCondition(this.filterModel), this.validate(), this.addDestroyFunc(() => this.destroyBeans([this.eColumnPill, this.eOperatorPill, this.eOperandPill]));
  }
  getDragName() {
    return this.filterModel.colId ? this.advFilterExpSvc.parseColumnFilterModel(this.filterModel) : this.getDefaultColumnDisplayValue();
  }
  getAriaLabel() {
    return `${this.advFilterExpSvc.translate("ariaAdvancedFilterBuilderFilterItem")} ${this.getDragName()}`;
  }
  getValidationMessage() {
    return this.validationMessage;
  }
  getFocusableElement() {
    return this.eColumnPill.getFocusableElement();
  }
  setupColumnCondition(e) {
    const t = this.advFilterExpSvc.getColumnDetails(e.colId);
    this.baseCellDataType = t.baseCellDataType, this.column = t.column, this.numOperands = this.getNumOperands(this.getOperatorKey()), this.eColumnPill = this.createPill({
      key: this.getColumnKey(),
      displayValue: this.getColumnDisplayValue() ?? this.getDefaultColumnDisplayValue(),
      cssClass: "ag-advanced-filter-builder-column-pill",
      isSelect: !0,
      getEditorParams: () => ({ values: this.advFilterExpSvc.getColumnAutocompleteEntries() }),
      update: (o) => this.setColumnKey(o),
      pickerAriaLabelKey: "ariaLabelAdvancedFilterBuilderColumnSelectField",
      pickerAriaLabelValue: "Advanced Filter Builder Column Select Field",
      ariaLabel: this.advFilterExpSvc.translate("ariaAdvancedFilterBuilderColumn")
    }), this.getGui().appendChild(this.eColumnPill.getGui()), ue(this.getColumnKey()) && (this.createOperatorPill(), this.hasOperand() && this.createOperandPill());
  }
  createOperatorPill() {
    this.eOperatorPill = this.createPill({
      key: this.getOperatorKey(),
      displayValue: this.getOperatorDisplayValue() ?? this.getDefaultOptionSelectValue(),
      cssClass: "ag-advanced-filter-builder-option-pill",
      isSelect: !0,
      getEditorParams: () => ({ values: this.getOperatorAutocompleteEntries() }),
      update: (e) => this.setOperatorKey(e),
      pickerAriaLabelKey: "ariaLabelAdvancedFilterBuilderOptionSelectField",
      pickerAriaLabelValue: "Advanced Filter Builder Option Select Field",
      ariaLabel: this.advFilterExpSvc.translate("ariaAdvancedFilterBuilderOption")
    }), this.eColumnPill.getGui().insertAdjacentElement("afterend", this.eOperatorPill.getGui());
  }
  createOperandPill() {
    const { filter: e } = this.filterModel, t = (typeof e == "number" ? Co(e) : e) ?? "";
    this.eOperandPill = this.createPill({
      key: t,
      // Convert from the input format to display format.
      // Input format matches model format except for numbers, but these get stringified anyway
      valueFormatter: (o) => this.advFilterExpSvc.getOperandDisplayValue({ ...this.filterModel, filter: o }, !0),
      baseCellDataType: this.baseCellDataType,
      cssClass: "ag-advanced-filter-builder-value-pill",
      isSelect: !1,
      update: (o) => this.setOperand(o),
      ariaLabel: this.advFilterExpSvc.translate("ariaAdvancedFilterBuilderValue")
    }), this.getGui().appendChild(this.eOperandPill.getGui());
  }
  getColumnKey() {
    return this.filterModel.colId;
  }
  getColumnDisplayValue() {
    return this.advFilterExpSvc.getColumnDisplayValue(this.filterModel);
  }
  getOperatorKey() {
    return this.filterModel.type;
  }
  getOperatorDisplayValue() {
    return this.advFilterExpSvc.getOperatorDisplayValue(this.filterModel);
  }
  getOperandDisplayValue() {
    return this.advFilterExpSvc.getOperandDisplayValue(this.filterModel, !0);
  }
  hasOperand() {
    return this.numOperands > 0;
  }
  getOperatorAutocompleteEntries() {
    return this.column ? this.advFilterExpSvc.getOperatorAutocompleteEntries(this.column, this.baseCellDataType) : [];
  }
  setColumnKey(e) {
    this.eOperatorPill || this.createOperatorPill();
    const t = this.advFilterExpSvc.getColumnDetails(e);
    this.column = t.column;
    const o = t.baseCellDataType;
    this.baseCellDataType !== o && (this.baseCellDataType = o, this.setOperatorKey(void 0), this.eOperatorPill && (Kt(this.eOperatorPill.getGui()), this.destroyBean(this.eOperatorPill), this.createOperatorPill()), this.validate()), this.filterModel.colId = e, this.filterModel.filterType = this.baseCellDataType;
  }
  setOperatorKey(e) {
    const t = this.getNumOperands(e);
    t !== this.numOperands && (this.numOperands = t, t === 0 ? this.destroyOperandPill() : (this.createOperandPill(), this.baseCellDataType !== "number" && this.setOperand(""))), this.filterModel.type = e, this.validate();
  }
  setOperand(e) {
    let t = e;
    this.baseCellDataType === "number" && (t = ue(e) ? Number(e) : ""), this.filterModel.filter = t, this.validate();
  }
  getNumOperands(e) {
    var t;
    return ((t = this.advFilterExpSvc.getExpressionOperator(this.baseCellDataType, e)) == null ? void 0 : t.numOperands) ?? 0;
  }
  destroyOperandPill() {
    delete this.filterModel.filter, this.getGui().removeChild(this.eOperandPill.getGui()), this.destroyBean(this.eOperandPill), this.eOperandPill = void 0;
  }
  validate() {
    let e = null;
    ue(this.getColumnKey()) ? ue(this.getOperatorKey()) ? this.numOperands > 0 && !ue(this.getOperandDisplayValue()) && (e = this.advFilterExpSvc.translate("advancedFilterBuilderValidationEnterValue")) : e = this.advFilterExpSvc.translate("advancedFilterBuilderValidationSelectOption") : e = this.advFilterExpSvc.translate("advancedFilterBuilderValidationSelectColumn"), this.item.valid = !e, e !== this.validationMessage && (this.validationMessage = e, this.dispatchLocalEvent({
      type: "advancedFilterBuilderValidChanged"
    }));
  }
  getDefaultColumnDisplayValue() {
    return this.advFilterExpSvc.translate("advancedFilterBuilderSelectColumn");
  }
  getDefaultOptionSelectValue() {
    return this.advFilterExpSvc.translate("advancedFilterBuilderSelectOption");
  }
}, eYe = {
  number: [va],
  boolean: [an],
  object: [an],
  text: [an],
  date: [br],
  dateString: [br],
  dateTime: [br, (e) => e.setIncludeTime(!0)],
  dateTimeString: [br, (e) => e.setIncludeTime(!0)]
}, tYe = {
  tag: "div",
  cls: "ag-advanced-filter-builder-pill-wrapper",
  role: "presentation",
  children: [
    {
      tag: "div",
      ref: "ePill",
      cls: "ag-advanced-filter-builder-pill",
      role: "button",
      children: [
        {
          tag: "span",
          ref: "eLabel",
          cls: "ag-advanced-filter-builder-pill-display"
        }
      ]
    }
  ]
}, oYe = class extends Re {
  constructor(e) {
    super(tYe), this.params = e, this.ePill = J, this.eLabel = J;
    const { value: t, valueFormatter: o } = e;
    this.value = t, this.displayValue = o(t);
  }
  wireBeans(e) {
    this.advFilterExpSvc = e.advFilterExpSvc;
  }
  postConstruct() {
    const { cssClass: e, ariaLabel: t } = this.params;
    this.ePill.classList.add(e), this.activateTabIndex([this.ePill]), this.eLabel.id = `${this.getCompId()}`, sa(this.ePill, this.eLabel.id), ft(this.ePill, t), this.renderValue(), this.addManagedListeners(this.ePill, {
      click: (o) => {
        o.preventDefault(), this.showEditor();
      },
      keydown: (o) => {
        switch (o.key) {
          case D.ENTER:
            o.preventDefault(), vt(o), this.showEditor();
            break;
        }
      }
    }), this.addDestroyFunc(() => this.destroyBean(this.eEditor));
  }
  getFocusableElement() {
    return this.ePill;
  }
  showEditor() {
    if (this.eEditor)
      return;
    He(this.ePill, !1), this.eEditor = this.createEditorComp(this.params.type), this.eEditor.setValue(this.value);
    const e = this.eEditor.getGui();
    this.eEditor.addManagedElementListeners(e, {
      keydown: (t) => {
        switch (t.key) {
          case D.ENTER:
            t.preventDefault(), vt(t), this.updateValue(!0);
            break;
          case D.ESCAPE:
            t.preventDefault(), vt(t), this.hideEditor(!0);
            break;
        }
      },
      focusout: () => this.updateValue(!1)
    }), this.getGui().appendChild(e), this.eEditor.getFocusableElement().focus();
  }
  /**
   * Responsible for instantiating an InputField and calling some of the setup methods
   */
  createEditorComp(e) {
    const [t, o] = eYe[e], n = this.createBean(new t());
    return o && o(n), n;
  }
  hideEditor(e) {
    const { eEditor: t } = this;
    t && (this.eEditor = void 0, this.getGui().removeChild(t.getGui()), this.destroyBean(t), He(this.ePill, !0), e && this.ePill.focus());
  }
  renderValue() {
    let e;
    const { displayValue: t, eLabel: o } = this, { classList: n } = o;
    n.remove(
      "ag-advanced-filter-builder-value-empty",
      "ag-advanced-filter-builder-value-number",
      "ag-advanced-filter-builder-value-text"
    ), ue(t) ? this.params.type === "number" ? (e = t, n.add("ag-advanced-filter-builder-value-number")) : (e = `"${t}"`, n.add("ag-advanced-filter-builder-value-text")) : (e = this.advFilterExpSvc.translate("advancedFilterBuilderEnterValue"), n.add("ag-advanced-filter-builder-value-empty")), o.textContent = e;
  }
  updateValue(e) {
    if (!this.eEditor)
      return;
    const t = this.eEditor.getValue() ?? "";
    this.dispatchLocalEvent({
      type: "fieldValueChanged",
      value: t
    }), this.value = t, this.displayValue = this.params.valueFormatter(t), this.renderValue(), this.hideEditor(e);
  }
}, nYe = class extends Re {
  wireBeans(e) {
    this.advFilterExpSvc = e.advFilterExpSvc;
  }
  constructor() {
    super({
      tag: "div",
      cls: "ag-advanced-filter-builder-item-condition",
      role: "presentation"
    });
  }
  init(e) {
    const { item: t, createPill: o } = e, n = t.filterModel;
    this.filterModel = n, this.ePill = o({
      key: n.type,
      displayValue: this.advFilterExpSvc.parseJoinOperator(n),
      cssClass: "ag-advanced-filter-builder-join-pill",
      isSelect: !0,
      getEditorParams: () => ({
        values: this.advFilterExpSvc.getJoinOperatorAutocompleteEntries()
      }),
      update: (s) => n.type = s,
      pickerAriaLabelKey: "ariaLabelAdvancedFilterBuilderJoinSelectField",
      pickerAriaLabelValue: "Advanced Filter Builder Join Operator Select Field",
      ariaLabel: this.advFilterExpSvc.translate("ariaAdvancedFilterBuilderJoinOperator")
    }), this.getGui().appendChild(this.ePill.getGui()), this.addDestroyFunc(() => this.destroyBean(this.ePill));
  }
  getDragName() {
    return this.advFilterExpSvc.parseJoinOperator(this.filterModel);
  }
  getAriaLabel() {
    return `${this.advFilterExpSvc.translate("ariaAdvancedFilterBuilderGroupItem")} ${this.getDragName()}`;
  }
  getValidationMessage() {
    return null;
  }
  getFocusableElement() {
    return this.ePill.getFocusableElement();
  }
}, sYe = {
  tag: "div",
  cls: "ag-picker-field ag-advanced-filter-builder-pill-wrapper",
  role: "presentation",
  children: [
    { tag: "div", ref: "eLabel" },
    {
      tag: "div",
      ref: "eWrapper",
      cls: "ag-wrapper ag-advanced-filter-builder-pill ag-picker-collapsed",
      children: [
        {
          tag: "div",
          ref: "eDisplayField",
          cls: "ag-picker-field-display ag-advanced-filter-builder-pill-display"
        },
        { tag: "ag-input-text-field", ref: "eInput", cls: "ag-rich-select-field-input" },
        {
          tag: "span",
          ref: "eDeselect",
          cls: "ag-rich-select-deselect-button ag-picker-field-icon",
          role: "presentation"
        },
        { tag: "div", ref: "eIcon", cls: "ag-picker-field-icon", attrs: { "aria-hidden": "true" } }
      ]
    }
  ]
}, iYe = class extends h_ {
  constructor(e) {
    super({
      ...e,
      template: sYe,
      agComponents: [zo]
    }), this.params = e;
  }
  getFocusableElement() {
    return this.eWrapper;
  }
  showPicker() {
    setTimeout(() => super.showPicker());
  }
  hidePicker() {
    setTimeout(() => super.hidePicker());
  }
  postConstruct() {
    super.postConstruct();
    const { wrapperClassName: e, ariaLabel: t } = this.params;
    this.eWrapper.classList.add(e), as(this.eWrapper, ""), ft(this.eWrapper, t);
  }
  createPickerComponent() {
    if (!this.values) {
      const { values: e } = this.params.getEditorParams();
      this.values = e;
      const t = this.value.key, o = e.find((n) => n.key === t) ?? {
        key: t,
        displayValue: this.value.displayValue
      };
      this.value = o;
    }
    return super.createPickerComponent();
  }
  onEnterKeyDown(e) {
    vt(e), this.isPickerDisplayed ? super.onEnterKeyDown(e) : (e.preventDefault(), this.showPicker());
  }
}, rYe = {
  tag: "div",
  cls: "ag-advanced-filter-builder-item-wrapper",
  role: "presentation",
  children: [
    {
      tag: "div",
      cls: "ag-advanced-filter-builder-item",
      role: "presentation",
      children: [
        {
          tag: "div",
          ref: "eTreeLines",
          cls: "ag-advanced-filter-builder-item-tree-lines",
          attrs: { "aria-hidden": "true" }
        },
        {
          tag: "span",
          ref: "eDragHandle",
          cls: "ag-drag-handle",
          attrs: { "aria-hidden": "true" }
        },
        {
          tag: "span",
          ref: "eValidation",
          cls: "ag-advanced-filter-builder-item-button ag-advanced-filter-builder-invalid",
          attrs: { "aria-hidden": "true" }
        }
      ]
    },
    {
      tag: "div",
      ref: "eButtons",
      cls: "ag-advanced-filter-builder-item-buttons",
      children: [
        { tag: "span", ref: "eMoveUpButton", cls: "ag-advanced-filter-builder-item-button", role: "button" },
        { tag: "span", ref: "eMoveDownButton", cls: "ag-advanced-filter-builder-item-button", role: "button" },
        { tag: "div", ref: "eAddButton", role: "presentation" },
        { tag: "span", ref: "eRemoveButton", cls: "ag-advanced-filter-builder-item-button", role: "button" }
      ]
    }
  ]
}, A0 = class extends ri {
  constructor(e, t, o) {
    super(rYe), this.item = e, this.dragFeature = t, this.focusWrapper = o, this.eTreeLines = J, this.eDragHandle = J, this.eButtons = J, this.eValidation = J, this.eMoveUpButton = J, this.eMoveDownButton = J, this.eAddButton = J, this.eRemoveButton = J, this.moveUpDisabled = !1, this.moveDownDisabled = !1;
  }
  wireBeans(e) {
    this.dragAndDrop = e.dragAndDrop, this.advFilterExpSvc = e.advFilterExpSvc, this.registry = e.registry;
  }
  postConstruct() {
    const { filterModel: e, level: t, showMove: o } = this.item, n = e.filterType === "join";
    if (this.ePillWrapper = this.createManagedBean(n ? new nYe() : new Xqe()), this.ePillWrapper.init({ item: this.item, createPill: (s) => this.createPill(s) }), this.eDragHandle.insertAdjacentElement("afterend", this.ePillWrapper.getGui()), t === 0) {
      const s = ze({
        tag: "div",
        cls: "ag-advanced-filter-builder-item-tree-line-vertical-bottom ag-advanced-filter-builder-item-tree-line-root"
      });
      this.eTreeLines.appendChild(s), He(this.eDragHandle, !1), He(this.eButtons, !1), Fo(this.focusWrapper, !0);
    } else
      this.setupTreeLines(t), this.eDragHandle.appendChild(Ie("advancedFilterBuilderDrag", this.beans)), this.setupValidation(), this.setupMoveButtons(o), this.setupAddButton(), this.setupRemoveButton(), this.setupDragging(), this.updateAriaExpanded();
    ia(this.focusWrapper, t + 1), this.initialiseTabGuard({}), this.createManagedBean(
      new f_(this.getGui(), this.focusWrapper, this.ePillWrapper)
    ), this.updateAriaLabel(), this.addManagedListeners(this.ePillWrapper, {
      advancedFilterBuilderValueChanged: () => this.dispatchLocalEvent({
        type: "advancedFilterBuilderValueChanged"
      }),
      advancedFilterBuilderValidChanged: () => this.updateValidity()
    });
  }
  setState(e) {
    var l, a;
    const { level: t } = this.item;
    if (t === 0)
      return;
    const { showMove: o } = this.item, { disableMoveUp: n, disableMoveDown: s, treeLines: i, showStartTreeLine: r } = e;
    this.updateTreeLines(i, r), this.updateAriaExpanded(), o && (this.moveUpDisabled = !!n, this.moveDownDisabled = !!s, this.eMoveUpButton.classList.toggle("ag-advanced-filter-builder-item-button-disabled", n), this.eMoveDownButton.classList.toggle("ag-advanced-filter-builder-item-button-disabled", s), ml(this.eMoveUpButton, !!n), ml(this.eMoveDownButton, !!s), (l = this.moveUpTooltipFeature) == null || l.refreshTooltip(), (a = this.moveDownTooltipFeature) == null || a.refreshTooltip());
  }
  focusMoveButton(e) {
    (e ? this.eMoveUpButton : this.eMoveDownButton).focus();
  }
  afterAdd() {
    this.ePillWrapper.getFocusableElement().focus();
  }
  setupTreeLines(e) {
    for (let t = 0; t < e; t++)
      this.eTreeLines.appendChild(ze({ tag: "div" }));
  }
  updateTreeLines(e, t) {
    const o = e.length - 1, { children: n } = this.eTreeLines;
    for (let i = 0; i < o; i++) {
      const r = n.item(i);
      r && r.classList.toggle("ag-advanced-filter-builder-item-tree-line-vertical", !e[i]);
    }
    const s = n.item(o);
    if (s) {
      s.classList.add("ag-advanced-filter-builder-item-tree-line-horizontal");
      const i = e[o];
      s.classList.toggle("ag-advanced-filter-builder-item-tree-line-vertical-top", i), s.classList.toggle("ag-advanced-filter-builder-item-tree-line-vertical", !i);
    }
    this.eDragHandle.classList.toggle(
      "ag-advanced-filter-builder-item-tree-line-vertical-bottom",
      t
    );
  }
  setupValidation() {
    this.eValidation.appendChild(Ie("advancedFilterBuilderInvalid", this.beans)), this.validationTooltipFeature = this.createOptionalManagedBean(
      this.registry.createDynamicBean("tooltipFeature", !1, {
        getGui: () => this.eValidation,
        getLocation: () => "advancedFilter",
        getTooltipValue: () => this.ePillWrapper.getValidationMessage(),
        getTooltipShowDelayOverride: () => 1e3
      })
    ), this.updateValidity();
  }
  setupAddButton() {
    var o;
    const e = v_(
      (n) => this.advFilterExpSvc.translate(n),
      (o = this.gos.get("advancedFilterBuilderParams")) == null ? void 0 : o.addSelectWidth
    ), t = this.createManagedBean(new p_(e));
    this.addManagedListeners(t, {
      fieldPickerValueSelected: ({ value: n }) => this.dispatchLocalEvent({
        type: "advancedFilterBuilderAdded",
        item: this.item,
        isJoin: n.key === "join"
      })
    }), this.eAddButton.appendChild(t.getGui()), this.createOptionalManagedBean(
      this.registry.createDynamicBean("tooltipFeature", !1, {
        getGui: () => this.eAddButton,
        getLocation: () => "advancedFilter",
        getTooltipValue: () => this.advFilterExpSvc.translate("advancedFilterBuilderAddButtonTooltip")
      })
    );
  }
  setupRemoveButton() {
    this.eRemoveButton.appendChild(Ie("advancedFilterBuilderRemove", this.beans)), this.addManagedListeners(this.eRemoveButton, {
      click: () => this.removeItem(),
      keydown: (e) => {
        switch (e.key) {
          case D.ENTER:
            e.preventDefault(), vt(e), this.removeItem();
            break;
        }
      }
    }), this.createOptionalManagedBean(
      this.registry.createDynamicBean("tooltipFeature", !1, {
        getGui: () => this.eRemoveButton,
        getLocation: () => "advancedFilter",
        getTooltipValue: () => this.advFilterExpSvc.translate("advancedFilterBuilderRemoveButtonTooltip")
      })
    ), ft(this.eRemoveButton, this.advFilterExpSvc.translate("advancedFilterBuilderRemoveButtonTooltip")), this.activateTabIndex([this.eRemoveButton]);
  }
  setupMoveButtons(e) {
    e ? (this.eMoveUpButton.appendChild(Ie("advancedFilterBuilderMoveUp", this.beans)), this.addManagedListeners(this.eMoveUpButton, {
      click: () => this.moveItem(!0),
      keydown: (t) => {
        switch (t.key) {
          case D.ENTER:
            t.preventDefault(), vt(t), this.moveItem(!0);
            break;
        }
      }
    }), this.moveUpTooltipFeature = this.createOptionalManagedBean(
      this.registry.createDynamicBean("tooltipFeature", !1, {
        getGui: () => this.eMoveUpButton,
        getLocation: () => "advancedFilter",
        getTooltipValue: () => this.moveUpDisabled ? null : this.advFilterExpSvc.translate("advancedFilterBuilderMoveUpButtonTooltip")
      })
    ), ft(
      this.eMoveUpButton,
      this.advFilterExpSvc.translate("advancedFilterBuilderMoveUpButtonTooltip")
    ), this.eMoveDownButton.appendChild(Ie("advancedFilterBuilderMoveDown", this.beans)), this.addManagedListeners(this.eMoveDownButton, {
      click: () => this.moveItem(!1),
      keydown: (t) => {
        switch (t.key) {
          case D.ENTER:
            t.preventDefault(), vt(t), this.moveItem(!1);
            break;
        }
      }
    }), this.moveDownTooltipFeature = this.createOptionalManagedBean(
      this.registry.createDynamicBean("tooltipFeature", !1, {
        getGui: () => this.eMoveDownButton,
        getLocation: () => "advancedFilter",
        getTooltipValue: () => this.moveDownDisabled ? null : this.advFilterExpSvc.translate("advancedFilterBuilderMoveDownButtonTooltip")
      })
    ), ft(
      this.eMoveDownButton,
      this.advFilterExpSvc.translate("advancedFilterBuilderMoveDownButtonTooltip")
    ), this.activateTabIndex([this.eMoveUpButton, this.eMoveDownButton])) : (He(this.eMoveUpButton, !1), He(this.eMoveDownButton, !1));
  }
  updateValidity() {
    var e;
    rw(this.eValidation, !this.item.valid), (e = this.validationTooltipFeature) == null || e.refreshTooltip(), this.updateAriaLabel();
  }
  createPill(e) {
    const { key: t, cssClass: o, update: n, ariaLabel: s } = e, i = (r) => {
      r != null && (n(r), this.dispatchLocalEvent({
        type: "advancedFilterBuilderValueChanged"
      }));
    };
    if (e.isSelect) {
      const { getEditorParams: r, pickerAriaLabelKey: l, pickerAriaLabelValue: a, displayValue: c } = e, d = this.gos.get("advancedFilterBuilderParams"), u = `${(d == null ? void 0 : d.pillSelectMinWidth) ?? 140}px`, h = `${(d == null ? void 0 : d.pillSelectMaxWidth) ?? 200}px`, p = this.createBean(
        new iYe({
          pickerAriaLabelKey: l,
          pickerAriaLabelValue: a,
          pickerType: "ag-list",
          value: {
            key: t,
            displayValue: c
          },
          valueFormatter: (C) => C == null ? "" : C.displayValue ?? C.key,
          variableWidth: !0,
          minPickerWidth: u,
          maxPickerWidth: h,
          getEditorParams: r,
          wrapperClassName: o,
          ariaLabel: s,
          pickerIcon: "advancedFilterBuilderSelectOpen"
        })
      );
      return this.addManagedListeners(p, {
        fieldPickerValueSelected: ({ value: C }) => i(C == null ? void 0 : C.key)
      }), p;
    } else {
      const { baseCellDataType: r, valueFormatter: l } = e, a = this.createBean(
        new oYe({
          value: t,
          valueFormatter: l,
          cssClass: o,
          type: r,
          ariaLabel: s
        })
      );
      return this.addManagedListeners(a, { fieldValueChanged: ({ value: c }) => i(c) }), a;
    }
  }
  setupDragging() {
    const e = {
      type: Hn.AdvancedFilterBuilder,
      eElement: this.eDragHandle,
      dragItemName: () => this.ePillWrapper.getDragName(),
      getDefaultIconName: () => "notAllowed",
      getDragItem: () => ({}),
      onDragStarted: () => this.dragFeature.dispatchLocalEvent({
        type: "advancedFilterBuilderDragStarted",
        item: this.item
      }),
      onDragStopped: () => this.dragFeature.dispatchLocalEvent({
        type: "advancedFilterBuilderDragEnded"
      })
    };
    this.dragAndDrop.addDragSource(e, !0), this.addDestroyFunc(() => this.dragAndDrop.removeDragSource(e));
  }
  updateAriaLabel() {
    const e = this.ePillWrapper.getAriaLabel(), t = `${this.item.level + 1}`, o = this.ePillWrapper.getValidationMessage();
    let n;
    o ? n = this.advFilterExpSvc.translate("ariaAdvancedFilterBuilderItemValidation", [
      e,
      t,
      o
    ]) : n = this.advFilterExpSvc.translate("ariaAdvancedFilterBuilderItem", [e, t]), ft(this.focusWrapper, n);
  }
  updateAriaExpanded() {
    ow(this.focusWrapper);
    const { filterModel: e } = this.item;
    (e == null ? void 0 : e.filterType) === "join" && e.conditions.length && Fo(this.focusWrapper, !0);
  }
  removeItem() {
    this.dispatchLocalEvent({
      type: "advancedFilterBuilderRemoved",
      item: this.item
    });
  }
  moveItem(e) {
    this.dispatchLocalEvent({
      type: "advancedFilterBuilderMoved",
      item: this.item,
      backwards: e
    });
  }
}, lYe = {
  apply: "advancedFilterBuilderApply",
  clear: "advancedFilterBuilderClear",
  cancel: "advancedFilterBuilderCancel",
  reset: "advancedFilterBuilderReset"
}, aYe = {
  tag: "div",
  cls: "ag-advanced-filter-builder",
  role: "presentation",
  attrs: { tabindex: "-1" },
  children: [
    {
      tag: "div",
      ref: "eList",
      cls: "ag-advanced-filter-builder-list",
      role: "presentation"
    }
  ]
}, cYe = class extends Re {
  constructor() {
    super(aYe), this.eList = J;
  }
  wireBeans(e) {
    this.filterManager = e.filterManager, this.advancedFilter = e.advancedFilter, this.advFilterExpSvc = e.advFilterExpSvc;
  }
  postConstruct() {
    const e = this.gos.get("advancedFilterBuilderParams");
    this.params = { buttons: ["apply", "cancel"], ...e }, this.addManagedPropertyListener("advancedFilterBuilderParams", ({ currentValue: t }) => {
      this.params.showMoveButtons = !!(t != null && t.showMoveButtons), this.params.buttons = (t == null ? void 0 : t.buttons) ?? ["apply", "cancel"], this.refreshList(!1);
    }), this.filterModel = this.setupFilterModel(), this.setupVirtualList(), this.dragFeature = this.createManagedBean(new $qe(this, this.virtualList)), this.resetButtonsPanel(this.params.buttons);
  }
  refresh() {
    const e = this.virtualList;
    let t = e.getLastFocusedRow();
    this.setupFilterModel(), this.validateItems(), this.refreshList(!1), t != null && (e.getComponentAt(t) || (t = 0), e.focusRow(t));
  }
  getNumItems() {
    return this.items.length;
  }
  moveItem(e, t) {
    !t || !e || this.moveItemToIndex(e, t.rowIndex, t.position);
  }
  afterGuiAttached() {
    this.virtualList.awaitStable(() => this.virtualList.focusRow(0));
  }
  setupVirtualList() {
    const e = this.virtualList = this.createManagedBean(
      new nr({
        cssIdentifier: "advanced-filter-builder",
        ariaRole: "tree",
        listName: this.advFilterExpSvc.translate("ariaAdvancedFilterBuilderList"),
        moveItemCallback: this.virtualListMoveItemCallback.bind(this)
      })
    );
    e.setComponentCreator(this.createItemComponent.bind(this)), e.setComponentUpdater(this.updateItemComponent.bind(this)), e.setRowHeight(40), this.eList.appendChild(e.getGui()), e.setModel({
      getRowCount: () => {
        var t;
        return ((t = this.items) == null ? void 0 : t.length) || 0;
      },
      getRow: (t) => this.items[t],
      areRowsEqual: (t, o) => t === o
    }), this.buildList(), e.refresh();
  }
  resetButtonsPanel(e) {
    const t = e && e.length > 0;
    let o = this.eButtons;
    if (t) {
      const n = e.map((i) => ({
        type: i,
        label: this.advFilterExpSvc.translate(lYe[i])
      }));
      if (!o) {
        o = this.createBean(new N2()), this.appendChild(o.getGui());
        const i = (r) => ({ event: l }) => {
          this.updateModel(r), this.afterAction(r, l);
        };
        o.addManagedListeners(o, {
          apply: i("apply"),
          clear: i("clear"),
          reset: i("reset"),
          cancel: i("cancel")
        }), this.eButtons = o;
      }
      o.updateButtons(n);
      const s = o.getApplyButton();
      if (s) {
        const i = (r) => this.toggleCss("ag-advanced-filter-builder-validation", r);
        this.addManagedElementListeners(s, {
          mouseenter: () => i(!0),
          mouseleave: () => i(!1)
        });
      }
    } else
      o && (Kt(o.getGui()), this.eButtons = this.destroyBean(o));
  }
  updateModel(e) {
    var t, o;
    switch (e) {
      case "apply":
        this.advancedFilter.setModel(this.filterModel), (t = this.filterManager) == null || t.onFilterChanged({ source: "advancedFilter" });
        break;
      case "reset":
        this.advancedFilter.setModel(null), (o = this.filterManager) == null || o.onFilterChanged({ source: "advancedFilter" });
        break;
      case "cancel":
        break;
      case "clear":
        this.filterModel = this.formatFilterModel(null), this.refreshList(!1);
        break;
    }
  }
  afterAction(e, t) {
    switch (e) {
      case "apply": {
        t == null || t.preventDefault(), this.close();
        break;
      }
      case "reset": {
        this.close();
        break;
      }
      case "cancel": {
        this.close();
        break;
      }
    }
  }
  removeItemFromParent(e) {
    const t = e.parent.conditions.indexOf(e.filterModel);
    return e.parent.conditions.splice(t, 1), t;
  }
  moveItemToIndex(e, t, o) {
    var l;
    const n = this.items[t], s = ((l = n.filterModel) == null ? void 0 : l.filterType) === "join" && o === "bottom", i = s ? n.filterModel : n.parent;
    if (!i || this.isChildOrSelf(i, e.filterModel) || n === e)
      return;
    this.removeItemFromParent(e);
    let r;
    s ? r = 0 : (r = i.conditions.indexOf(n.filterModel), r === -1 ? r = i.conditions.length : o === "bottom" && (r += 1)), i.conditions.splice(r, 0, e.filterModel), this.refreshList(!1);
  }
  isChildOrSelf(e, t) {
    return e === t || t.filterType === "join" && t.conditions.some((o) => this.isChildOrSelf(e, o));
  }
  setupFilterModel() {
    const e = this.formatFilterModel(this.advancedFilter.getModel());
    return this.stringifiedModel = JSON.stringify(e), e;
  }
  formatFilterModel(e) {
    return e = e ?? {
      filterType: "join",
      type: "AND",
      conditions: []
    }, e.filterType !== "join" && (e = {
      filterType: "join",
      type: "AND",
      conditions: [e]
    }), e;
  }
  buildList() {
    const e = (t, o, n, s) => {
      o.push({ filterModel: t, level: n, parent: s, valid: !0, showMove: this.params.showMoveButtons }), t.filterType === "join" && (t.conditions.forEach(
        (i) => e(i, o, n + 1, t)
      ), n === 0 && o.push({ filterModel: null, level: n + 1, parent: t, valid: !0 }));
    };
    this.items = [], e(this.filterModel, this.items, 0);
  }
  refreshList(e) {
    if (!e) {
      const t = [];
      this.items.forEach((o) => {
        o.valid || t.push(o.filterModel);
      }), this.buildList(), t.length && this.items.forEach((o) => {
        o.filterModel && t.includes(o.filterModel) && (o.valid = !1);
      });
    }
    this.virtualList.refresh(e), this.validate();
  }
  updateItemComponent(e, t) {
    const o = this.items.indexOf(e), n = (l, a) => {
      const c = this.items.find((u) => u.filterModel === l), d = c == null ? void 0 : c.parent;
      if (d) {
        const { conditions: u } = d;
        n(d, a), a.push(u[u.length - 1] === l);
      }
    }, s = [], { filterModel: i } = e;
    i && (n(i, s), s[0] = !1);
    const r = (i == null ? void 0 : i.filterType) === "join" && !!i.conditions.length;
    t.setState({
      disableMoveUp: o === 1,
      disableMoveDown: !this.canMoveDown(e, o),
      treeLines: s,
      showStartTreeLine: r
    });
  }
  createItemComponent(e, t) {
    const o = this.createBean(
      e.filterModel ? new A0(e, this.dragFeature, t) : new Jqe(e, t)
    );
    return o.addManagedListeners(o, {
      advancedFilterBuilderRemoved: ({ item: n }) => this.removeItem(n),
      advancedFilterBuilderValueChanged: () => this.validate(),
      advancedFilterBuilderAdded: ({ item: n, isJoin: s }) => this.addItem(n, s),
      advancedFilterBuilderMoved: ({ item: n, backwards: s }) => this.moveItemUpDown(n, s)
    }), o instanceof A0 && this.updateItemComponent(e, o), o;
  }
  addItem(e, t) {
    var u;
    const { parent: o, level: n, filterModel: s } = e, i = (s == null ? void 0 : s.filterType) === "join", r = t ? {
      filterType: "join",
      type: "AND",
      conditions: []
    } : {}, l = i ? s : o;
    let a = i ? 0 : l.conditions.indexOf(s);
    a >= 0 ? (i || (a += 1), l.conditions.splice(a, 0, r)) : l.conditions.push(r);
    let c = this.items.indexOf(e);
    const d = c >= 0;
    if (d) {
      e.filterModel && c++;
      const h = [
        {
          filterModel: r,
          level: i ? n + 1 : n,
          parent: l,
          valid: t,
          showMove: this.params.showMoveButtons
        }
      ];
      this.items.splice(c, 0, ...h);
    }
    this.refreshList(d), d && ((u = this.virtualList.getComponentAt(c)) == null || u.afterAdd());
  }
  removeItem(e) {
    var l;
    const t = e.parent, { filterModel: o } = e, n = t.conditions.indexOf(o);
    t.conditions.splice(n, 1);
    const s = ((l = e.filterModel) == null ? void 0 : l.filterType) === "join", i = this.items.indexOf(e), r = !s && i >= 0;
    r && this.items.splice(i, 1), this.refreshList(r), i >= 0 && this.virtualList.focusRow(i);
  }
  moveItemUpDown(e, t, o) {
    const n = this.items.indexOf(e), s = t ? n - 1 : n + 1;
    if (s === 0 || !t && !this.canMoveDown(e, n))
      return;
    const i = this.items[s], r = this.removeItemFromParent(e), { level: l, filterModel: a, parent: c } = e, {
      level: d,
      filterModel: u,
      parent: h
    } = i;
    if (t)
      if (d === l && u.filterType === "join")
        u.conditions.push(a);
      else if (d <= l) {
        const m = h.conditions.indexOf(u);
        h.conditions.splice(m, 0, a);
      } else
        c.conditions[r - 1].conditions.push(a);
    else if (d === l)
      if (u.filterType === "join")
        u.conditions.splice(0, 0, a);
      else {
        const m = h.conditions.indexOf(u);
        h.conditions.splice(m + 1, 0, a);
      }
    else if (r < c.conditions.length)
      c.conditions.splice(r + 1, 0, a);
    else {
      const m = this.items.find((y) => y.filterModel === c), w = m.parent.conditions.indexOf(m.filterModel) + 1;
      m.parent.conditions.splice(w, 0, a);
    }
    this.refreshList(!1);
    const p = this.items.findIndex(
      ({ filterModel: m }) => m === a
    );
    if (p < 0)
      return;
    const C = this.virtualList.getComponentAt(p);
    C instanceof A0 && (o || C.focusMoveButton(t));
  }
  virtualListMoveItemCallback(e, t) {
    const o = e.item, n = this.items.indexOf(o);
    n <= 0 || n === this.items.length - 1 || t && n === 1 || !t && !this.canMoveDown(o, n) || (this.moveItemUpDown(o, t, !0), this.virtualList.focusRow(n + (t ? -1 : 1)));
  }
  canMoveDown(e, t) {
    return !(e.level === 1 && t === this.items.length - 2 || e.level === 1 && e.parent.conditions[e.parent.conditions.length - 1] === e.filterModel);
  }
  close() {
    this.advancedFilter.getCtrl().toggleFilterBuilder({ source: "ui" });
  }
  validate() {
    var o;
    let e = this.items.every(({ valid: n }) => n), t = null;
    e ? (e = JSON.stringify(this.filterModel) !== this.stringifiedModel, e ? t = null : t = this.advFilterExpSvc.translate("advancedFilterBuilderValidationAlreadyApplied")) : t = this.advFilterExpSvc.translate("advancedFilterBuilderValidationIncomplete"), (o = this.eButtons) == null || o.updateValidity(e, t);
  }
  validateItems() {
    const e = (o) => {
      o.type = void 0;
    }, t = (o) => {
      delete o.filter;
    };
    this.items.forEach((o) => {
      if (!o.valid || !o.filterModel || o.filterModel.filterType === "join")
        return;
      const { filterModel: n } = o, { colId: s } = n, i = this.advFilterExpSvc.getColumnAutocompleteEntries().find(({ key: c }) => c === s), r = this.advFilterExpSvc.getColumnDetails(n.colId);
      if (!i || !r.column) {
        o.valid = !1, n.colId = void 0, e(n), t(n);
        return;
      }
      const a = this.advFilterExpSvc.getDataTypeExpressionOperator(r.baseCellDataType).operators[n.type];
      if (!a) {
        o.valid = !1, e(n), t(n);
        return;
      }
      if (a.numOperands > 0 && !ue(n.filter)) {
        o.valid = !1;
        return;
      }
    });
  }
}, dYe = class extends K {
  constructor(e) {
    super(), this.enabled = e;
  }
  wireBeans(e) {
    this.ctrlsSvc = e.ctrlsSvc, this.popupSvc = e.popupSvc, this.advFilterExpSvc = e.advFilterExpSvc, this.environment = e.environment;
  }
  postConstruct() {
    this.hasAdvancedFilterParent = !!this.gos.get("advancedFilterParent"), this.ctrlsSvc.whenReady(this, () => this.setAdvancedFilterComp()), this.addManagedEventListeners({
      advancedFilterEnabledChanged: ({ enabled: e }) => this.onEnabledChanged(e)
    }), this.addManagedPropertyListener("advancedFilterParent", () => this.updateComps()), this.addManagedPropertyListener("advancedFilterBuilderParams", (e) => {
      var t, o, n, s;
      ((t = e.currentValue) == null ? void 0 : t.suppressFullScreenButton) !== ((o = e.previousValue) == null ? void 0 : o.suppressFullScreenButton) && ((s = this.eBuilderDialog) == null || s.setMaximizable(((n = e.currentValue) == null ? void 0 : n.suppressFullScreenButton) ?? !0));
    }), this.addDestroyFunc(() => {
      this.destroyAdvancedFilterComp(), this.destroyBean(this.eBuilderComp), this.eBuilderDialog && this.eBuilderDialog.isAlive() && this.destroyBean(this.eBuilderDialog);
    });
  }
  setupHeaderComp(e) {
    var t;
    this.eHeaderComp && ((t = this.eHeaderComp) == null || t.getGui().remove(), this.destroyBean(this.eHeaderComp)), this.eHeaderComp = this.createManagedBean(
      new Bqe(this.enabled && !this.hasAdvancedFilterParent)
    ), e.insertAdjacentElement("beforebegin", this.eHeaderComp.getGui());
  }
  focusHeaderComp() {
    return this.eHeaderComp ? (this.eHeaderComp.getFocusableElement().focus(), !0) : !1;
  }
  refreshComp() {
    var e, t;
    (e = this.eFilterComp) == null || e.refresh(), (t = this.eHeaderComp) == null || t.refresh();
  }
  refreshBuilderComp() {
    var e;
    (e = this.eBuilderComp) == null || e.refresh();
  }
  getHeaderHeight() {
    var e;
    return ((e = this.eHeaderComp) == null ? void 0 : e.getHeight()) ?? 0;
  }
  setInputDisabled(e) {
    var t, o;
    (t = this.eFilterComp) == null || t.setInputDisabled(e), (o = this.eHeaderComp) == null || o.setInputDisabled(e);
  }
  toggleFilterBuilder(e) {
    const { source: t, force: o, eventSource: n } = e;
    if (o && this.eBuilderDialog || o === !1 && !this.eBuilderDialog)
      return;
    if (this.eBuilderDialog) {
      this.builderDestroySource = t, this.destroyBean(this.eBuilderDialog);
      return;
    }
    this.setInputDisabled(!0);
    const { width: s, height: i, minWidth: r } = this.getBuilderDialogSize(), { suppressFullScreenButton: l } = {
      suppressFullScreenButton: !1,
      ...this.gos.get("advancedFilterBuilderParams")
    };
    this.eBuilderComp = this.createBean(new cYe()), this.eBuilderDialog = this.createBean(
      new c_({
        title: this.advFilterExpSvc.translate("advancedFilterBuilderTitle"),
        component: this.eBuilderComp,
        width: s,
        height: i,
        resizable: !0,
        movable: !0,
        maximizable: !l,
        centered: !0,
        closable: !0,
        minWidth: r,
        afterGuiAttached: () => {
          var a;
          return (a = this.eBuilderComp) == null ? void 0 : a.afterGuiAttached();
        },
        postProcessPopupParams: {
          type: "advancedFilterBuilder",
          eventSource: n
        }
      })
    ), this.dispatchFilterBuilderVisibleChangedEvent(t, !0), this.eBuilderDialog.addEventListener("destroyed", () => {
      this.destroyBean(this.eBuilderComp), this.eBuilderComp = void 0, this.eBuilderDialog = void 0, this.setInputDisabled(!1), this.dispatchLocalEvent({
        type: "advancedFilterBuilderClosed"
      }), this.dispatchFilterBuilderVisibleChangedEvent(this.builderDestroySource ?? "ui", !1), this.builderDestroySource = void 0;
    });
  }
  dispatchFilterBuilderVisibleChangedEvent(e, t) {
    this.eventSvc.dispatchEvent({
      type: "advancedFilterBuilderVisibleChanged",
      source: e,
      visible: t
    });
  }
  getBuilderDialogSize() {
    var r;
    const e = ((r = this.gos.get("advancedFilterBuilderParams")) == null ? void 0 : r.minWidth) ?? 500, t = this.popupSvc.getPopupParent(), o = Math.round(Nr(t)) - 2, n = Math.round(b2(t) * 0.75) - 2, s = Math.min(Math.max(700, e), o), i = Math.min(600, n);
    return { width: s, height: i, minWidth: e };
  }
  onEnabledChanged(e) {
    this.enabled = e, this.updateComps();
  }
  updateComps() {
    this.setAdvancedFilterComp(), this.setHeaderCompEnabled(), this.eventSvc.dispatchEvent({
      type: "headerHeightChanged"
    });
  }
  setAdvancedFilterComp() {
    if (this.destroyAdvancedFilterComp(), !this.enabled)
      return;
    const e = this.gos.get("advancedFilterParent");
    if (this.hasAdvancedFilterParent = !!e, e) {
      const t = this.createBean(new d_()), o = t.getGui();
      this.environment.applyThemeClasses(o), o.classList.add(this.gos.get("enableRtl") ? "ag-rtl" : "ag-ltr"), e.appendChild(o), this.eFilterComp = t;
    }
  }
  setHeaderCompEnabled() {
    var e;
    (e = this.eHeaderComp) == null || e.setEnabled(this.enabled && !this.hasAdvancedFilterParent);
  }
  destroyAdvancedFilterComp() {
    this.eFilterComp && (Kt(this.eFilterComp.getGui()), this.destroyBean(this.eFilterComp));
  }
}, uYe = class {
  constructor(e) {
    this.params = e, this.operators = [], this.operatorStartPositions = [], this.operatorEndPositions = [], this.activeOperator = 0, this.validationError = null;
  }
  parseExpression(e) {
    this.operators.push(""), this.operatorStartPositions.push(e), this.operatorEndPositions.push(void 0);
    const { expression: t } = this.params;
    for (; e < t.length; ) {
      const o = t[e];
      if (o === " ") {
        if (this.parseOperator(e - 1))
          return this.activeOperator++, e - 1;
        this.operators[this.activeOperator] += o;
      } else
        this.operators[this.activeOperator] += o;
      e++;
    }
    return this.parseOperator(e - 1), e;
  }
  isValid() {
    return !this.validationError && (!this.operators.length || !!this.parsedOperator);
  }
  getValidationError() {
    return this.validationError;
  }
  getFunction() {
    return this.parsedOperator === "OR" ? "||" : "&&";
  }
  getModel() {
    return this.parsedOperator === "OR" ? "OR" : "AND";
  }
  getAutocompleteListParams(e, t) {
    let o;
    if (t == null)
      o = "";
    else {
      const s = this.operators[t], i = this.operatorEndPositions[t];
      o = A5(
        s,
        e,
        i == null ? this.params.expression.length : i + 1
      );
    }
    let n = this.params.advFilterExpSvc.getJoinOperatorAutocompleteEntries();
    return (t || t == null && this.activeOperator) && (n = n.filter(({ key: s }) => s === this.parsedOperator)), this.params.advFilterExpSvc.generateAutocompleteListParams(n, "join", o);
  }
  updateExpression(e, t, o) {
    let { expression: n } = this.params;
    const s = t.displayValue ?? t.key;
    if (o === 0)
      for (let l = this.operatorEndPositions.length - 1; l > 0; l--) {
        const a = this.operatorEndPositions[l];
        a != null && (n = is(
          n,
          this.operatorStartPositions[l],
          a,
          s
        ).updatedValue);
      }
    const i = this.operatorStartPositions.length > o ? this.operatorStartPositions[o] : e, r = (this.operatorEndPositions.length > o ? this.operatorEndPositions[o] : void 0) ?? L5(n, e, !0).endPosition;
    return is(n, i, r, s, !0);
  }
  getNumOperators() {
    return this.operators.length;
  }
  getLastOperatorEndPosition() {
    return this.operatorEndPositions[this.operatorEndPositions.length - 1];
  }
  parseOperator(e) {
    const t = this.operators.length > this.activeOperator ? this.operators[this.activeOperator] : "", o = this.params.advFilterExpSvc.getExpressionJoinOperators(), n = Aa(t, o, (s) => s);
    if (n) {
      this.operatorEndPositions[this.activeOperator] = e;
      const s = o[n];
      if (this.activeOperator) {
        if (n !== this.parsedOperator)
          return this.validationError || (this.validationError = {
            message: this.params.advFilterExpSvc.translate(
              "advancedFilterValidationJoinOperatorMismatch"
            ),
            startPosition: e - t.length + 1,
            endPosition: e
          }), !1;
      } else
        this.parsedOperator = n;
      return t !== s && (vc(this.params, t, s, e), this.operators[this.activeOperator] = s), !0;
    } else return n === null ? !1 : (this.validationError || (this.validationError = {
      message: this.params.advFilterExpSvc.translate("advancedFilterValidationInvalidJoinOperator"),
      startPosition: e - t.length + 1,
      endPosition: e
    }), !0);
  }
}, hYe = class m_ {
  constructor(t, o) {
    this.params = t, this.startPosition = o, this.expectingExpression = !0, this.expectingOperator = !1, this.expressionParsers = [], this.operatorParser = new uYe(this.params), this.missingEndBracket = !1, this.extraEndBracket = !1;
  }
  parseExpression() {
    let t = this.startPosition;
    const { expression: o } = this.params;
    for (; t < o.length; ) {
      const n = o[t];
      if (n === "(" && !this.expectingOperator) {
        const s = new m_(this.params, t + 1);
        t = s.parseExpression(), this.expressionParsers.push(s), this.expectingExpression = !1, this.expectingOperator = !0;
      } else {
        if (n === ")")
          return this.endPosition = t - 1, this.startPosition === 0 && (this.extraEndBracket = !0), t;
        if (n !== " ") if (this.expectingExpression) {
          const s = new _qe(this.params, t);
          t = s.parseExpression(), this.expressionParsers.push(s), this.expectingExpression = !1, this.expectingOperator = !0;
        } else this.expectingOperator && (t = this.operatorParser.parseExpression(t), this.expectingOperator = !1, this.expectingExpression = !0);
      }
      t++;
    }
    return this.startPosition > 0 && (this.missingEndBracket = !0), t;
  }
  isValid() {
    return !this.missingEndBracket && !this.extraEndBracket && this.expressionParsers.length === this.operatorParser.getNumOperators() + 1 && this.operatorParser.isValid() && this.expressionParsers.every((t) => t.isValid());
  }
  getValidationError() {
    const t = this.operatorParser.getValidationError();
    for (let n = 0; n < this.expressionParsers.length; n++) {
      const s = this.expressionParsers[n].getValidationError();
      if (s)
        return t && t.startPosition < s.startPosition ? t : s;
    }
    if (t)
      return t;
    if (this.extraEndBracket)
      return {
        message: this.params.advFilterExpSvc.translate("advancedFilterValidationExtraEndBracket"),
        startPosition: this.endPosition + 1,
        endPosition: this.endPosition + 1
      };
    let o;
    return this.expressionParsers.length === this.operatorParser.getNumOperators() ? o = "advancedFilterValidationMissingCondition" : this.missingEndBracket && (o = "advancedFilterValidationMissingEndBracket"), o ? {
      message: this.params.advFilterExpSvc.translate(o),
      startPosition: this.params.expression.length,
      endPosition: this.params.expression.length
    } : null;
  }
  getFunction(t) {
    const o = this.operatorParser.getFunction(), n = this.expressionParsers.map((i) => i.getFunction(t)), s = o === "&&" ? "every" : "some";
    return (i, r, l) => n[s]((a) => a(i, r, l));
  }
  getAutocompleteListParams(t) {
    if (this.endPosition != null && t > this.endPosition + 1)
      return;
    if (!this.expressionParsers.length)
      return this.getColumnAutocompleteListParams();
    const o = this.getExpressionParserIndex(t);
    if (o == null)
      return this.params.expression[t] === "(" ? { enabled: !1 } : this.getColumnAutocompleteListParams();
    const s = this.expressionParsers[o].getAutocompleteListParams(t);
    if (!s) {
      if (o < this.expressionParsers.length - 1)
        return this.operatorParser.getAutocompleteListParams(t, o);
      if (this.expressionParsers.length === this.operatorParser.getNumOperators()) {
        const i = this.operatorParser.getLastOperatorEndPosition();
        return i == null || t <= i + 1 ? this.operatorParser.getAutocompleteListParams(t, this.operatorParser.getNumOperators() - 1) : this.getColumnAutocompleteListParams();
      }
      return this.params.expression[t - 1] === ")" ? { enabled: !1 } : this.operatorParser.getAutocompleteListParams(t);
    }
    return s;
  }
  updateExpression(t, o, n) {
    const s = this.params.expression, i = this.getExpressionParserIndex(t);
    if (i == null) {
      const a = n === "column" ? this.params.advFilterExpSvc.getColumnValue(o) : o.displayValue ?? o.key;
      return is(s, this.startPosition, this.startPosition, a, !0);
    }
    const l = this.expressionParsers[i].updateExpression(t, o, n);
    return l ?? (n === "column" ? is(
      s,
      t,
      s.length - 1,
      this.params.advFilterExpSvc.getColumnValue(o),
      !0
    ) : this.endPosition != null && t > this.endPosition + 1 ? null : this.operatorParser.updateExpression(t, o, i));
  }
  getModel() {
    return this.expressionParsers.length > 1 ? {
      filterType: "join",
      type: this.operatorParser.getModel(),
      conditions: this.expressionParsers.map((t) => t.getModel())
    } : this.expressionParsers[0].getModel();
  }
  getColumnAutocompleteListParams() {
    return this.params.advFilterExpSvc.generateAutocompleteListParams(
      this.params.advFilterExpSvc.getColumnAutocompleteEntries(),
      "column",
      ""
    );
  }
  getExpressionParserIndex(t) {
    let o;
    for (let n = 0; n < this.expressionParsers.length && !(this.expressionParsers[n].startPosition > t); n++)
      o = n;
    return o;
  }
}, gYe = class {
  constructor(e) {
    this.params = e, this.valid = !1;
  }
  parseExpression() {
    this.joinExpressionParser = new hYe(this.params, 0);
    const e = this.joinExpressionParser.parseExpression();
    return this.valid = e >= this.params.expression.length - 1 && this.joinExpressionParser.isValid(), this.params.expression;
  }
  isValid() {
    return this.valid;
  }
  getValidationMessage() {
    const e = this.joinExpressionParser.getValidationError();
    if (!e)
      return null;
    const { message: t, startPosition: o, endPosition: n } = e;
    return o < this.params.expression.length ? this.params.advFilterExpSvc.translate("advancedFilterValidationMessage", [
      t,
      this.params.expression.slice(o, n + 1).trim()
    ]) : this.params.advFilterExpSvc.translate("advancedFilterValidationMessageAtEnd", [t]);
  }
  getFunction() {
    const e = this.createFunctionParams();
    return {
      expressionFunction: this.joinExpressionParser.getFunction(e),
      params: e
    };
  }
  getAutocompleteListParams(e) {
    return this.joinExpressionParser.getAutocompleteListParams(e) ?? { enabled: !1 };
  }
  updateExpression(e, t, o) {
    return this.joinExpressionParser.updateExpression(e, t, o);
  }
  getModel() {
    return this.isValid() ? this.joinExpressionParser.getModel() : null;
  }
  createFunctionParams() {
    return {
      operands: [],
      operators: [],
      evaluatorParams: []
    };
  }
}, pYe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "advancedFilter", this.appliedExpression = null, this.expression = null, this.isValid = !0;
  }
  wireBeans(e) {
    this.valueSvc = e.valueSvc, this.colModel = e.colModel, this.dataTypeSvc = e.dataTypeSvc, this.advFilterExpSvc = e.advFilterExpSvc, this.filterValueSvc = e.filterValueSvc, this.filterManager = e.filterManager;
  }
  postConstruct() {
    this.setEnabled(this.gos.get("enableAdvancedFilter"), !0), this.ctrl = this.createManagedBean(new dYe(this.enabled)), this.expressionProxy = {
      getValue: (e, t) => {
        const o = this.colModel.getColDefCol(e);
        return o ? this.filterValueSvc.getValue(o, t) : void 0;
      }
    }, this.addManagedPropertyListener("enableAdvancedFilter", (e) => this.setEnabled(!!e.currentValue)), this.addManagedEventListeners({
      newColumnsLoaded: (e) => this.onNewColumnsLoaded(e)
    }), this.addManagedPropertyListener("includeHiddenColumnsInAdvancedFilter", () => {
      var t;
      this.updateValidity() && ((t = this.filterManager) == null || t.onFilterChanged({ source: "advancedFilter" }));
    });
  }
  isEnabled() {
    return this.enabled;
  }
  isFilterPresent() {
    return !!this.expressionFunction;
  }
  doesFilterPass(e) {
    return this.expressionFunction(this.expressionProxy, e, this.expressionParams);
  }
  getModel() {
    const e = this.createExpressionParser(this.appliedExpression);
    return e == null || e.parseExpression(), (e == null ? void 0 : e.getModel()) ?? null;
  }
  setModel(e) {
    const t = (n, s) => {
      if (n.filterType === "join") {
        const i = this.advFilterExpSvc.parseJoinOperator(n), r = n.conditions.map((l) => t(l)).filter((l) => ue(l)).join(` ${i} `);
        return s || n.conditions.length <= 1 ? r : `(${r})`;
      } else
        return this.advFilterExpSvc.parseColumnFilterModel(n);
    }, o = e ? t(e, !0) : null;
    this.setExpressionDisplayValue(o), this.applyExpression(), this.ctrl.refreshComp(), this.ctrl.refreshBuilderComp();
  }
  getExpressionDisplayValue() {
    return this.expression;
  }
  setExpressionDisplayValue(e) {
    this.expression = e;
  }
  isCurrentExpressionApplied() {
    return this.appliedExpression === this.expression;
  }
  createExpressionParser(e) {
    return e ? new gYe({
      expression: e,
      colModel: this.colModel,
      dataTypeSvc: this.dataTypeSvc,
      valueSvc: this.valueSvc,
      advFilterExpSvc: this.advFilterExpSvc
    }) : null;
  }
  getDefaultExpression(e) {
    const t = this.advFilterExpSvc.getColumnValue(e) + " ";
    return {
      updatedValue: t,
      updatedPosition: t.length
    };
  }
  isHeaderActive() {
    return !this.gos.get("advancedFilterParent");
  }
  getCtrl() {
    return this.ctrl;
  }
  setEnabled(e, t) {
    const o = this.enabled, n = dt(this.gos) || $n(this.gos);
    e && !n && X(123), this.enabled = e && n, !t && this.enabled !== o && this.eventSvc.dispatchEvent({
      type: "advancedFilterEnabledChanged",
      enabled: this.enabled
    });
  }
  applyExpression() {
    const e = this.createExpressionParser(this.expression);
    e == null || e.parseExpression(), this.applyExpressionFromParser(e);
  }
  getAppliedExpressionDisplayValue() {
    return this.appliedExpression;
  }
  applyExpressionFromParser(e) {
    if (this.isValid = !e || e.isValid(), !e || !this.isValid) {
      this.expressionFunction = null, this.expressionParams = null, this.appliedExpression = null;
      return;
    }
    const { expressionFunction: t, params: o } = e.getFunction();
    this.expressionFunction = t, this.expressionParams = o, this.appliedExpression = this.expression;
  }
  updateValidity() {
    this.advFilterExpSvc.resetColumnCaches();
    const e = this.createExpressionParser(this.expression);
    e == null || e.parseExpression();
    const o = (!e || e.isValid()) !== this.isValid;
    return this.applyExpressionFromParser(e), this.ctrl.refreshComp(), this.ctrl.refreshBuilderComp(), o;
  }
  onNewColumnsLoaded(e) {
    var o;
    if (e.source !== "gridInitializing" || !((o = this.dataTypeSvc) != null && o.isPendingInference))
      return;
    this.ctrl.setInputDisabled(!0);
    const [t] = this.addManagedEventListeners({
      dataTypesInferred: () => {
        t == null || t(), this.ctrl.setInputDisabled(!1);
      }
    });
  }
}, fYe = {
  moduleName: "AdvancedFilter",
  version: yt,
  beans: [pYe, xqe],
  icons: {
    // Builder button in Advanced Filter
    advancedFilterBuilder: "group",
    // drag handle used to pick up Advanced Filter Builder rows
    advancedFilterBuilderDrag: "grip",
    // Advanced Filter Builder row validation error
    advancedFilterBuilderInvalid: "not-allowed",
    // shown on Advanced Filter Builder rows to move them up
    advancedFilterBuilderMoveUp: "up",
    // shown on Advanced Filter Builder rows to move them down
    advancedFilterBuilderMoveDown: "down",
    // shown on Advanced Filter Builder rows to add new rows
    advancedFilterBuilderAdd: "plus",
    // shown on Advanced Filter Builder rows to remove row
    advancedFilterBuilderRemove: "minus",
    // shown on Advanced Filter Builder selection pills
    advancedFilterBuilderSelectOpen: "small-down",
    // remove for rich select editor pills
    richSelectRemove: "cancel"
  },
  apiFunctions: {
    getAdvancedFilterModel: gqe,
    setAdvancedFilterModel: pqe,
    showAdvancedFilterBuilder: fqe,
    hideAdvancedFilterBuilder: vqe
  },
  dependsOn: [
    ko,
    xa,
    f1,
    li,
    pc,
    fc
  ],
  css: [hqe]
};
function vYe(e) {
  var t;
  return ((t = e.sideBar) == null ? void 0 : t.comp.isDisplayed()) ?? !1;
}
function mYe(e, t) {
  var o;
  (o = e.sideBar) == null || o.comp.setDisplayed(t);
}
function CYe(e, t) {
  var o;
  (o = e.sideBar) == null || o.comp.setSideBarPosition(t);
}
function wYe(e, t, o) {
  var n;
  (n = e.sideBar) == null || n.comp.openToolPanel(t, "api", o);
}
function bYe(e) {
  var t;
  (t = e.sideBar) == null || t.comp.close("api");
}
function yYe(e) {
  var t;
  return ((t = e.sideBar) == null ? void 0 : t.comp.openedItem()) ?? null;
}
function _Ye(e) {
  var t;
  (t = e.sideBar) == null || t.comp.refresh();
}
function SYe(e) {
  var t;
  return ((t = e.sideBar) == null ? void 0 : t.comp.isToolPanelShowing()) ?? !1;
}
function xYe(e, t) {
  var n;
  const o = (n = e.sideBar) == null ? void 0 : n.comp.getToolPanelInstance(t);
  return zi(o);
}
function MYe(e) {
  var t;
  return (t = e.sideBar) == null ? void 0 : t.comp.getDef();
}
function R5(e, t) {
  if (!t)
    return null;
  const o = Fn(e), n = o.indexOf(t);
  if (n === -1)
    return null;
  let s = -1;
  for (let i = n - 1; i >= 0; i--)
    if (o[i].classList.contains(Y1.TAB_GUARD_TOP)) {
      s = i;
      break;
    }
  return s <= 0 ? null : o[s - 1];
}
function C_(e, t) {
  if (!t)
    return !1;
  const o = e.querySelectorAll(`.${Sb}`);
  if (!o.length)
    return !1;
  for (let n = 0; n < o.length; n++)
    if (o[n].contains(t))
      return !0;
  return !1;
}
var AYe = (
  /*css*/
  '.ag-tool-panel-wrapper{display:flex;overflow:hidden auto;-webkit-user-select:none;-moz-user-select:none;user-select:none;width:var(--ag-side-bar-panel-width)}.ag-tool-panel-external{display:flex;flex-direction:row}:where(.ag-tool-panel-external) .ag-tool-panel-wrapper{flex-grow:1}.ag-select-agg-func-item{align-items:center;display:flex;flex:1 1 auto;flex-flow:row nowrap;height:100%;overflow:hidden;position:relative;text-overflow:ellipsis;white-space:nowrap;>*{flex:none}}.ag-tool-panel-horizontal-resize{cursor:ew-resize;height:100%;position:absolute;top:0;width:5px;z-index:1}.ag-side-bar{background-color:var(--ag-side-bar-background-color);display:flex;flex-direction:row-reverse;position:relative}:where(.ag-ltr) :where(.ag-side-bar-left) .ag-tool-panel-horizontal-resize{right:-3px}:where(.ag-rtl) :where(.ag-side-bar-left) .ag-tool-panel-horizontal-resize{left:-3px}:where(.ag-ltr) :where(.ag-side-bar-right) .ag-tool-panel-horizontal-resize{left:-3px}:where(.ag-rtl) :where(.ag-side-bar-right) .ag-tool-panel-horizontal-resize{right:-3px}.ag-side-bar-left{flex-direction:row;order:-1}.ag-side-buttons{background-color:var(--ag-side-button-bar-background-color);padding-top:var(--ag-side-button-bar-top-padding);position:relative}.ag-side-button{background-color:var(--ag-side-button-background-color);border-bottom:var(--ag-side-button-border);border-top:var(--ag-side-button-border);color:var(--ag-side-button-text-color);margin-top:-1px;position:relative;&:before{background-color:transparent;bottom:0;content:"";display:block;position:absolute;top:0;transition:background-color var(--ag-side-button-selected-underline-transition-duration);width:var(--ag-side-button-selected-underline-width)}&:hover{background-color:var(--ag-side-button-hover-background-color);color:var(--ag-side-button-hover-text-color)}&.ag-selected{background-color:var(--ag-side-button-selected-background-color);border-bottom:var(--ag-side-button-selected-border);border-top:var(--ag-side-button-selected-border);color:var(--ag-side-button-selected-text-color);&:before{background-color:var(--ag-side-button-selected-underline-color)}}}:where(.ag-ltr) .ag-side-button{&:before{left:0}}:where(.ag-rtl) .ag-side-button{&:before{right:0}}.ag-side-button-button{align-items:center;display:flex;flex-direction:column;gap:var(--ag-spacing);position:relative;white-space:nowrap;width:100%;&:focus{box-shadow:none}}:where(.ag-ltr) .ag-side-button-button{padding:var(--ag-side-button-vertical-padding) var(--ag-side-button-right-padding) var(--ag-side-button-vertical-padding) var(--ag-side-button-left-padding)}:where(.ag-rtl) .ag-side-button-button{padding:var(--ag-side-button-vertical-padding) var(--ag-side-button-left-padding) var(--ag-side-button-vertical-padding) var(--ag-side-button-right-padding)}.ag-side-button-button:focus-visible{box-shadow:inset var(--ag-focus-shadow)}.ag-side-button-label{writing-mode:vertical-lr}@media (resolution <= 1.5x){.ag-side-button-label{font-family:"Segoe UI",var(--ag-font-family)}:where(.ag-ltr) .ag-side-button-label{transform:rotate(.05deg)}:where(.ag-rtl) .ag-side-button-label{transform:rotate(-.05deg)}}:where(.ag-ltr) .ag-side-bar-left,:where(.ag-rtl) .ag-side-bar-right{border-right:var(--ag-side-panel-border);:where(.ag-tool-panel-wrapper){border-left:var(--ag-side-panel-border)}}:where(.ag-ltr) .ag-side-bar-right,:where(.ag-rtl) .ag-side-bar-left{border-left:var(--ag-side-panel-border);:where(.ag-tool-panel-wrapper){border-right:var(--ag-side-panel-border)}}'
), LYe = {
  tag: "div",
  cls: "ag-side-button",
  role: "presentation",
  children: [
    {
      tag: "button",
      ref: "eToggleButton",
      cls: "ag-button ag-side-button-button",
      role: "tab",
      attrs: { type: "button", tabindex: "-1", "aria-expanded": "false" },
      children: [
        {
          tag: "div",
          ref: "eIconWrapper",
          cls: "ag-side-button-icon-wrapper",
          attrs: { "aria-hidden": "true" }
        },
        { tag: "span", ref: "eLabel", cls: "ag-side-button-label" }
      ]
    }
  ]
}, EYe = class extends Re {
  constructor(e) {
    super(), this.toolPanelDef = e, this.eToggleButton = J, this.eIconWrapper = J, this.eLabel = J;
  }
  getToolPanelId() {
    return this.toolPanelDef.id;
  }
  postConstruct() {
    this.setTemplate(LYe, []), this.setLabel(), this.setIcon(), this.addManagedElementListeners(this.eToggleButton, { click: this.onButtonPressed.bind(this) }), this.eToggleButton.setAttribute("id", `ag-${this.getCompId()}-button`);
  }
  setLabel() {
    const e = this.toolPanelDef, t = this.getLocaleTextFunc()(e.labelKey, e.labelDefault);
    this.eLabel.textContent = t;
  }
  setIcon() {
    this.eIconWrapper.insertAdjacentElement(
      "afterbegin",
      Ie(this.toolPanelDef.iconKey, this.beans)
    );
  }
  onButtonPressed() {
    this.dispatchLocalEvent({ type: "toggleButtonClicked" });
  }
  setSelected(e) {
    this.toggleCss("ag-selected", e), Fo(this.eToggleButton, e);
  }
}, PYe = { tag: "div", cls: "ag-side-buttons", role: "tablist" }, RYe = class extends Re {
  constructor() {
    super(PYe), this.buttonComps = [];
  }
  postConstruct() {
    this.addManagedElementListeners(this.getFocusableElement(), { keydown: this.handleKeyDown.bind(this) });
  }
  handleKeyDown(e) {
    if (!(e.key !== D.TAB || !e.shiftKey)) {
      if (fn(this.beans, !0)) {
        e.preventDefault();
        return;
      }
      vt(e);
    }
  }
  setActiveButton(e) {
    this.buttonComps.forEach((t) => {
      t.setSelected(e === t.getToolPanelId());
    });
  }
  addButtonComp(e) {
    const t = this.createBean(new EYe(e));
    return this.buttonComps.push(t), this.appendChild(t), t.addEventListener("toggleButtonClicked", () => {
      this.dispatchLocalEvent({
        type: "sideBarButtonClicked",
        toolPanelId: e.id
      });
    }), t;
  }
  clearButtons() {
    this.buttonComps = this.destroyBeans(this.buttonComps), it(this.getGui());
  }
  destroy() {
    this.clearButtons(), super.destroy();
  }
}, FYe = {
  selector: "AG-SIDE-BAR-BUTTONS",
  component: RYe
}, w_ = {
  id: "columns",
  labelDefault: "Columns",
  labelKey: "columns",
  iconKey: "columnsToolPanel",
  toolPanel: "agColumnsToolPanel"
}, b_ = {
  id: "filters",
  labelDefault: "Filters",
  labelKey: "filters",
  iconKey: "filtersToolPanel",
  toolPanel: "agFiltersToolPanel"
}, TYe = {
  id: "filters-new",
  labelDefault: "Filters",
  labelKey: "filters",
  iconKey: "filtersToolPanel",
  toolPanel: "agNewFiltersToolPanel"
}, Dr = {
  columns: w_,
  filters: b_,
  "filters-new": TYe
};
function F5(e) {
  if (e) {
    if (e === !0)
      return {
        toolPanels: [w_, b_],
        defaultToolPanel: "columns"
      };
    if (typeof e == "string")
      return F5([e]);
    if (Array.isArray(e)) {
      const t = [];
      return e.forEach((o) => {
        const n = Dr[o];
        if (!n) {
          X(215, { key: o, defaultByKey: Dr });
          return;
        }
        t.push(n);
      }), t.length === 0 ? void 0 : {
        toolPanels: t,
        defaultToolPanel: t[0].id
      };
    }
    return {
      toolPanels: IYe(e.toolPanels),
      defaultToolPanel: e.defaultToolPanel,
      hiddenByDefault: e.hiddenByDefault,
      position: e.position,
      hideButtons: e.hideButtons
    };
  }
}
function IYe(e) {
  const t = [];
  return e && e.forEach((o) => {
    const n = y_(o);
    n && t.push(n);
  }), t;
}
function y_(e) {
  return typeof e != "string" ? e : Dr[e] ? Dr[e] : (X(215, { key: e, defaultByKey: Dr }), null);
}
var DYe = class extends Re {
  constructor() {
    super({ tag: "div", cls: "ag-tool-panel-horizontal-resize" }), this.minWidth = 100, this.maxWidth = null;
  }
  postConstruct() {
    const e = this.beans.horizontalResizeSvc.addResizeBar({
      eResizeBar: this.getGui(),
      dragStartPixels: 1,
      onResizeStart: this.onResizeStart.bind(this),
      onResizing: this.onResizing.bind(this),
      onResizeEnd: this.onResizeEnd.bind(this)
    });
    this.addDestroyFunc(e), this.inverted = this.gos.get("enableRtl");
  }
  dispatchResizeEvent(e, t, o) {
    this.eventSvc.dispatchEvent({
      type: "toolPanelSizeChanged",
      width: o,
      started: e,
      ended: t
    });
  }
  onResizeStart() {
    this.startingWidth = this.elementToResize.offsetWidth, this.dispatchResizeEvent(!0, !1, this.startingWidth);
  }
  onResizeEnd(e) {
    return this.onResizing(e, !0);
  }
  onResizing(e, t = !1) {
    const o = this.inverted ? -1 : 1;
    let n = Math.max(this.minWidth, Math.floor(this.startingWidth - e * o));
    this.maxWidth != null && (n = Math.min(this.maxWidth, n)), this.elementToResize.style.width = `${n}px`, this.dispatchResizeEvent(!1, t, n);
  }
};
function kYe(e, t, o) {
  return e.getCompDetails(t, HYe, void 0, o, !0);
}
var HYe = {
  name: "toolPanel",
  optionalMethods: ["refresh", "getState"]
}, VYe = {
  tag: "div",
  cls: "ag-tool-panel-wrapper",
  role: "tabpanel"
}, OYe = class extends Re {
  constructor() {
    super(VYe);
  }
  postConstruct() {
    const e = this.getGui(), t = this.resizeBar = this.createManagedBean(new DYe());
    e.setAttribute("id", `ag-${this.getCompId()}`), t.elementToResize = e, this.appendChild(t);
  }
  getToolPanelId() {
    return this.toolPanelId;
  }
  setToolPanelDef(e, t) {
    const { id: o, minWidth: n, maxWidth: s, width: i } = e;
    this.toolPanelId = o, this.width = i;
    const r = kYe(this.beans.userCompFactory, e, t);
    if (r == null)
      return !1;
    const l = r.newAgStackInstance();
    this.params = r.params, l.then(this.setToolPanelComponent.bind(this));
    const a = this.resizeBar;
    return n != null && (a.minWidth = n), s != null && (a.maxWidth = s), !0;
  }
  setToolPanelComponent(e) {
    this.toolPanelCompInstance = e, this.appendChild(e.getGui()), this.addDestroyFunc(() => {
      this.destroyBean(e);
    });
    const t = this.width;
    t && (this.getGui().style.width = `${t}px`);
  }
  getToolPanelInstance() {
    return this.toolPanelCompInstance;
  }
  setResizerSizerSide(e) {
    const t = this.gos.get("enableRtl"), o = e === "left", n = t ? o : !o;
    this.resizeBar.inverted = n;
  }
  refresh() {
    var e;
    (e = this.toolPanelCompInstance) == null || e.refresh(this.params);
  }
}, BYe = {
  tag: "div",
  cls: "ag-side-bar ag-unselectable",
  children: [
    {
      tag: "ag-side-bar-buttons",
      ref: "sideBarButtons"
    }
  ]
}, $Ye = class extends Re {
  constructor() {
    super(BYe, [FYe]), this.sideBarButtons = J, this.toolPanelWrappers = [], this.registerCSS(AYe);
  }
  postConstruct() {
    this.sideBarButtons.addEventListener("sideBarButtonClicked", this.onToolPanelButtonClicked.bind(this));
    const { beans: e, gos: t } = this, { sideBar: o } = t.get("initialState") ?? {};
    this.setSideBarDef({
      sideBarDef: F5(t.get("sideBar")),
      sideBarState: o
    }), this.addManagedPropertyListener("sideBar", () => this.setState()), e.sideBar.comp = this;
    const n = this.getFocusableElement();
    this.createManagedBean(
      new gs(n, {
        onTabKeyDown: this.onTabKeyDown.bind(this),
        handleKeyDown: this.handleKeyDown.bind(this)
      })
    ), Ob(e, this, n);
  }
  onTabKeyDown(e) {
    if (e.defaultPrevented)
      return;
    const { beans: t, sideBarButtons: o } = this, n = this.getGui(), s = o.getGui(), i = Ue(t), r = n.querySelector(".ag-tool-panel-wrapper:not(.ag-hidden)"), l = e.target, a = e.shiftKey;
    if (!r)
      return fn(t, a) ? (e.preventDefault(), !0) : fn(t, a, !0);
    if (s.contains(i)) {
      so(r, a) && e.preventDefault();
      return;
    }
    if (!a)
      return;
    let c = null;
    r.contains(i) ? c = Yt(t, r, void 0, !0) : C_(r, l) && (c = R5(r, l)), c || (c = s.querySelector(".ag-selected button"), c = ro(c) ? c : null), c && c !== e.target && (e.preventDefault(), c.focus());
  }
  handleKeyDown(e) {
    const t = Ue(this.beans), o = this.sideBarButtons;
    if (!o.getGui().contains(t))
      return;
    const n = o.getGui(), s = Array.prototype.slice.call(n.querySelectorAll(".ag-side-button")), i = s.findIndex((a) => a.contains(t));
    let r = null;
    switch (e.key) {
      case D.LEFT:
      case D.UP:
        r = Math.max(0, i - 1);
        break;
      case D.RIGHT:
      case D.DOWN:
        r = Math.min(i + 1, s.length - 1);
        break;
    }
    if (r === null)
      return;
    const l = s[r].querySelector("button");
    l && (l.focus(), e.preventDefault());
  }
  onToolPanelButtonClicked(e) {
    const t = e.toolPanelId;
    this.openedItem() === t ? this.openToolPanel(void 0, "sideBarButtonClicked") : this.openToolPanel(t, "sideBarButtonClicked");
  }
  clearDownUi() {
    this.sideBarButtons.clearButtons(), this.destroyToolPanelWrappers();
  }
  setSideBarDef({
    sideBarDef: e,
    sideBarState: t,
    existingToolPanelWrappers: o
  }) {
    if (this.setDisplayed(!1), this.sideBar = e, e && this.sideBarButtons.setDisplayed(!e.hideButtons), e != null && e.toolPanels) {
      const n = e.toolPanels;
      if (this.createToolPanelsAndSideButtons(n, t, o), !this.toolPanelWrappers.length)
        return;
      const s = t ? t.visible : !e.hiddenByDefault;
      if (this.setDisplayed(s), this.setSideBarPosition(t ? t.position : e.position), s)
        if (t) {
          const { openToolPanel: i } = t;
          i && this.openToolPanel(i, "sideBarInitializing");
        } else
          this.openToolPanel(e.defaultToolPanel, "sideBarInitializing");
    }
  }
  getDef() {
    return this.sideBar;
  }
  setSideBarPosition(e) {
    e || (e = "right"), this.position = e;
    const t = e === "left", o = t ? "right" : "left";
    return this.toggleCss("ag-side-bar-left", t), this.toggleCss("ag-side-bar-right", !t), this.toolPanelWrappers.forEach((n) => {
      n.setResizerSizerSide(o);
    }), this.dispatchSideBarUpdated(), this;
  }
  setDisplayed(e, t) {
    super.setDisplayed(e, t), this.dispatchSideBarUpdated();
  }
  getState() {
    const e = {};
    return this.toolPanelWrappers.forEach((t) => {
      var o, n;
      e[t.getToolPanelId()] = (n = (o = t.getToolPanelInstance()) == null ? void 0 : o.getState) == null ? void 0 : n.call(o);
    }), {
      visible: this.isDisplayed(),
      position: this.position,
      openToolPanel: this.openedItem(),
      toolPanels: e
    };
  }
  createToolPanelsAndSideButtons(e, t, o) {
    var n;
    for (const s of e)
      this.createToolPanelAndSideButton(
        s,
        (n = t == null ? void 0 : t.toolPanels) == null ? void 0 : n[s.id],
        o == null ? void 0 : o[s.id]
      );
  }
  validateDef(e) {
    var n;
    const { id: t, toolPanel: o } = e;
    return t == null ? (X(212), !1) : (o === "agFiltersToolPanel" || o === "agNewFiltersToolPanel") && (n = this.beans.filterManager) != null && n.isAdvFilterEnabled() ? (X(213), !1) : !0;
  }
  createToolPanelAndSideButton(e, t, o) {
    if (!this.validateDef(e))
      return;
    let n;
    if (o)
      n = o;
    else if (n = this.createBean(new OYe()), !n.setToolPanelDef(
      e,
      Pe(this.gos, {
        initialState: t,
        onStateUpdated: () => this.dispatchSideBarUpdated()
      })
    ))
      return;
    n.setDisplayed(!1);
    const s = n.getGui(), i = e.parent instanceof HTMLElement ? e.parent : this;
    i === e.parent && (this.beans.environment.applyThemeClasses(i, ["ag-external", "ag-tool-panel-external"]), s.classList.add(this.gos.get("enableRtl") ? "ag-rtl" : "ag-ltr")), i.appendChild(s), this.toolPanelWrappers.push(n);
    const r = this.sideBarButtons.addButtonComp(e);
    C2(r.eToggleButton, s);
  }
  refresh() {
    this.toolPanelWrappers.forEach((e) => e.refresh());
  }
  renderToolPanelUnderParent(e, t) {
    var n, s, i, r;
    const o = (s = (n = this.sideBar) == null ? void 0 : n.toolPanels) == null ? void 0 : s.find((l) => (typeof l == "string" ? l : l.id) === e);
    if (o) {
      const l = y_(o);
      if (l) {
        const a = (r = (i = (this.gos.get("initialState") ?? {}).sideBar) == null ? void 0 : i.toolPanels) == null ? void 0 : r[l.id];
        l.parent = t;
        const c = this.toolPanelWrappers.find((d) => d.getToolPanelId() === e);
        this.createToolPanelAndSideButton(l, a, c);
      }
    }
  }
  openToolPanel(e, t = "api", o) {
    o && e && this.renderToolPanelUnderParent(e, o);
    const n = this.openedItem();
    if (n === e)
      return;
    this.toolPanelWrappers.forEach((r) => {
      const l = e === r.getToolPanelId();
      r.setDisplayed(l);
    });
    const s = this.openedItem();
    n !== s && (this.sideBarButtons.setActiveButton(e), this.raiseToolPanelVisibleEvent(e, n ?? void 0, t));
  }
  getToolPanelInstance(e) {
    const t = this.toolPanelWrappers.filter((o) => o.getToolPanelId() === e)[0];
    if (!t) {
      X(214, { key: e });
      return;
    }
    return t.getToolPanelInstance();
  }
  raiseToolPanelVisibleEvent(e, t, o) {
    const n = !!e && !!t, s = this.eventSvc;
    t && s.dispatchEvent({
      type: "toolPanelVisibleChanged",
      source: o,
      key: t,
      visible: !1,
      switchingToolPanel: n
    }), e && s.dispatchEvent({
      type: "toolPanelVisibleChanged",
      source: o,
      key: e,
      visible: !0,
      switchingToolPanel: n
    });
  }
  close(e = "api") {
    this.openToolPanel(void 0, e);
  }
  isToolPanelShowing() {
    return !!this.openedItem();
  }
  openedItem() {
    let e = null;
    return this.toolPanelWrappers.forEach((t) => {
      t.isDisplayed() && (e = t.getToolPanelId());
    }), e;
  }
  setState(e) {
    var n;
    const t = F5(this.gos.get("sideBar")), o = {};
    t && this.sideBar && ((n = t.toolPanels) == null || n.forEach((s) => {
      var d, u;
      const { id: i } = s;
      if (!i)
        return;
      const r = (d = this.sideBar.toolPanels) == null ? void 0 : d.find(
        (h) => h.id === i
      );
      if (!r || s.toolPanel !== r.toolPanel)
        return;
      const l = this.toolPanelWrappers.find((h) => h.getToolPanelId() === i);
      if (!l)
        return;
      const a = Pe(this.gos, {
        ...s.toolPanelParams ?? {},
        onStateUpdated: () => this.dispatchSideBarUpdated()
      });
      ((u = l.getToolPanelInstance()) == null ? void 0 : u.refresh(a)) === !0 && (this.toolPanelWrappers = this.toolPanelWrappers.filter((h) => h !== l), Kt(l.getGui()), o[i] = l);
    })), this.clearDownUi(), this.setSideBarDef({ sideBarDef: t, sideBarState: e, existingToolPanelWrappers: o });
  }
  dispatchSideBarUpdated() {
    this.eventSvc.dispatchEvent({ type: "sideBarUpdated" });
  }
  destroyToolPanelWrappers() {
    this.toolPanelWrappers.forEach((e) => {
      Kt(e.getGui()), this.destroyBean(e);
    }), this.toolPanelWrappers.length = 0;
  }
  destroy() {
    this.destroyToolPanelWrappers(), super.destroy();
  }
}, ZYe = {
  selector: "AG-SIDE-BAR",
  component: $Ye
}, GYe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "sideBar";
  }
  getSelector() {
    return ZYe;
  }
}, NYe = {
  moduleName: "SideBar",
  version: yt,
  beans: [GYe],
  apiFunctions: {
    isSideBarVisible: vYe,
    setSideBarVisible: mYe,
    setSideBarPosition: CYe,
    openToolPanel: wYe,
    closeToolPanel: bYe,
    getOpenedToolPanel: yYe,
    refreshToolPanel: _Ye,
    isToolPanelShowing: SYe,
    getToolPanelInstance: xYe,
    getSideBar: MYe
  },
  dependsOn: [ko, Xb]
}, zYe = { tag: "div" }, jYe = class extends Re {
  constructor() {
    super(zYe);
  }
  init(e) {
    this.params = e, this.cssClassPrefix = this.params.cssClassPrefix ?? "ag-menu-option", this.addAriaAttributes(), this.addIcon(), this.addName(), this.addShortcut(), this.addSubMenu();
  }
  configureDefaults() {
    return !0;
  }
  addAriaAttributes() {
    const { checked: e, subMenu: t } = this.params, o = this.getGui();
    e && sw(o, e), t && Fo(o, !1);
  }
  addIcon() {
    if (this.params.isCompact)
      return;
    const e = ze({
      tag: "span",
      ref: "eIcon",
      cls: `${this.getClassName("part")} ${this.getClassName("icon")}`,
      role: "presentation"
    }), { checked: t, icon: o } = this.params;
    t ? e.appendChild(Ie("check", this.beans)) : o && (da(o) ? e.appendChild(o) : typeof o == "string" ? e.innerHTML = o : X(227)), this.getGui().appendChild(e);
  }
  addName() {
    const e = ze({
      tag: "span",
      ref: "eName",
      cls: `${this.getClassName("part")} ${this.getClassName("text")}`,
      children: this.params.name || ""
    });
    this.getGui().appendChild(e);
  }
  addShortcut() {
    if (this.params.isCompact)
      return;
    const e = ze({
      tag: "span",
      ref: "eShortcut",
      cls: `${this.getClassName("part")} ${this.getClassName("shortcut")}`,
      children: this.params.shortcut || ""
    });
    this.getGui().appendChild(e);
  }
  addSubMenu() {
    const e = ze({
      tag: "span",
      ref: "ePopupPointer",
      cls: `${this.getClassName("part")} ${this.getClassName("popup-pointer")}`
    }), t = this.getGui();
    if (this.params.subMenu) {
      const o = this.gos.get("enableRtl") ? "subMenuOpenRtl" : "subMenuOpen";
      e.appendChild(Ie(o, this.beans));
    }
    t.appendChild(e);
  }
  getClassName(e) {
    return `${this.cssClassPrefix}-${e}`;
  }
}, WYe = (
  /*css*/
  '.ag-menu-list{cursor:default;display:table;padding:var(--ag-spacing) 0;width:100%}.ag-menu-option,.ag-menu-separator{display:table-row}.ag-menu-option-part,.ag-menu-separator-part{display:table-cell;vertical-align:middle}.ag-menu-option{cursor:pointer;font-weight:500}:where(.ag-ltr) :where(.ag-menu-option-popup-pointer) .ag-icon{text-align:right}:where(.ag-rtl) :where(.ag-menu-option-popup-pointer) .ag-icon{text-align:left}.ag-menu-option-text{white-space:nowrap}.ag-menu-option-custom{display:contents}.ag-compact-menu-option{display:flex;flex-wrap:nowrap;width:100%}.ag-compact-menu-option-text{flex:1 1 auto;white-space:nowrap}.ag-menu-separator{height:calc(var(--ag-spacing)*2 + 1px)}.ag-menu-separator-part:after{border-top:solid var(--ag-border-width) var(--ag-menu-separator-color);content:"";display:block}.ag-compact-menu-option-active,.ag-menu-option-active{background-color:var(--ag-row-hover-color)}.ag-compact-menu-option-part,.ag-menu-option-part{line-height:var(--ag-icon-size);padding:calc(var(--ag-spacing) + 2px) 0}.ag-compact-menu-option-disabled,.ag-menu-option-disabled{cursor:not-allowed;opacity:.5}.ag-compact-menu-option-icon,.ag-menu-option-icon{width:var(--ag-icon-size)}:where(.ag-ltr) .ag-compact-menu-option-icon,:where(.ag-ltr) .ag-menu-option-icon{padding-left:calc(var(--ag-spacing)*2)}:where(.ag-rtl) .ag-compact-menu-option-icon,:where(.ag-rtl) .ag-menu-option-icon{padding-right:calc(var(--ag-spacing)*2)}.ag-compact-menu-option-text,.ag-menu-option-text{padding-left:calc(var(--ag-spacing)*2);padding-right:calc(var(--ag-spacing)*2)}:where(.ag-ltr) .ag-compact-menu-option-shortcut,:where(.ag-ltr) .ag-menu-option-shortcut{padding-right:var(--ag-spacing)}:where(.ag-rtl) .ag-compact-menu-option-shortcut,:where(.ag-rtl) .ag-menu-option-shortcut{padding-left:var(--ag-spacing)}:where(.ag-ltr) .ag-compact-menu-option-popup-pointer,:where(.ag-ltr) .ag-menu-option-popup-pointer{padding-right:var(--ag-spacing)}:where(.ag-rtl) .ag-compact-menu-option-popup-pointer,:where(.ag-rtl) .ag-menu-option-popup-pointer{padding-left:var(--ag-spacing)}.ag-menu-column-select-wrapper{height:265px;overflow:auto;:where(.ag-column-select){height:100%}}.ag-menu:where(.ag-tabs){min-width:290px}.ag-context-menu-loading-icon{pointer-events:none;position:absolute}'
), __ = {
  moduleName: "MenuItem",
  version: yt,
  userComponents: {
    agMenuItem: jYe
  },
  icons: {
    // indicates the currently active pin state in the "Pin column" sub-menu of the column menu
    check: "tick",
    // icon for sub menu item
    subMenuOpen: "small-right",
    // version of subMenuOpen used in RTL mode
    subMenuOpenRtl: "small-left"
  },
  css: [WYe]
}, UYe = (
  /*css*/
  ".ag-column-select{display:flex;flex:3 1 0px;flex-direction:column;overflow:hidden;position:relative}.ag-column-select-header{align-items:center;display:flex;flex:none;gap:var(--ag-widget-horizontal-spacing);height:var(--ag-header-height);padding-left:var(--ag-widget-container-horizontal-padding);padding-right:var(--ag-widget-container-horizontal-padding);position:relative}.ag-column-select-column,.ag-column-select-column-group{align-items:center;display:flex;gap:var(--ag-widget-horizontal-spacing);height:100%;position:relative;&:where(:not(:last-child)){margin-bottom:var(--ag-widget-vertical-spacing)}}:where(.ag-ltr) .ag-column-select-column,:where(.ag-ltr) .ag-column-select-column-group{padding-left:calc(var(--ag-indentation-level)*var(--ag-column-select-indent-size))}:where(.ag-rtl) .ag-column-select-column,:where(.ag-rtl) .ag-column-select-column-group{padding-right:calc(var(--ag-indentation-level)*var(--ag-column-select-indent-size))}.ag-column-select-header-icon{border-radius:var(--ag-border-radius);cursor:pointer;height:var(--ag-icon-size);position:relative;width:var(--ag-icon-size);&:focus-visible{box-shadow:var(--ag-focus-shadow)}}.ag-column-select-header-filter-wrapper{flex:1 1 auto}.ag-column-select-header-filter{width:100%}.ag-column-select-list{flex:1 1 0px;overflow:hidden}:where(.ag-ltr) .ag-column-select-add-group-indent{margin-left:calc(var(--ag-icon-size) + var(--ag-spacing)*1.5)}:where(.ag-rtl) .ag-column-select-add-group-indent{margin-right:calc(var(--ag-icon-size) + var(--ag-spacing)*1.5)}.ag-column-select-column-group-readonly,.ag-column-select-column-readonly{opacity:.5;pointer-events:none;.ag-icon{opacity:.5}&.ag-icon-grip{opacity:.35}}.ag-column-select-column-readonly{&.ag-icon-grip,.ag-icon-grip{opacity:.35}}.ag-column-select-virtual-list-viewport{padding:calc(var(--ag-widget-container-vertical-padding)*.5) 0}.ag-column-select-virtual-list-item{padding:0 var(--ag-widget-container-horizontal-padding)}.ag-column-select-column-label{flex:1 1 auto;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ag-column-select-checkbox{display:flex}"
), KYe = 300, qYe = {
  tag: "div",
  cls: "ag-column-select-header",
  role: "presentation",
  children: [
    { tag: "div", ref: "eExpand", cls: "ag-column-select-header-icon" },
    { tag: "ag-checkbox", ref: "eSelect", cls: "ag-column-select-header-checkbox" },
    { tag: "ag-input-text-field", ref: "eFilterTextField", cls: "ag-column-select-header-filter-wrapper" }
  ]
}, YYe = class extends Re {
  constructor() {
    super(qYe, [ii, zo]), this.eExpand = J, this.eSelect = J, this.eFilterTextField = J;
  }
  postConstruct() {
    this.createExpandIcons(), this.addManagedListeners(this.eExpand, {
      click: this.onExpandClicked.bind(this),
      keydown: (t) => {
        t.key === D.SPACE && (t.preventDefault(), this.onExpandClicked());
      }
    }), this.addManagedElementListeners(this.eSelect.getInputElement(), { click: this.onSelectClicked.bind(this) }), this.addManagedPropertyListener("functionsReadOnly", () => this.onFunctionsReadOnlyPropChanged()), this.eFilterTextField.setAutoComplete(!1).onValueChange(() => this.onFilterTextChanged()), this.addManagedEventListeners({ newColumnsLoaded: this.showOrHideOptions.bind(this) });
    const e = this.getLocaleTextFunc();
    this.eSelect.setInputAriaLabel(e("ariaColumnSelectAll", "Toggle All Columns Visibility")), this.eFilterTextField.setInputAriaLabel(e("ariaFilterColumnsInput", "Filter Columns Input")), this.activateTabIndex([this.eExpand]);
  }
  onFunctionsReadOnlyPropChanged() {
    const e = this.gos.get("functionsReadOnly");
    this.eSelect.setReadOnly(e), this.eSelect.toggleCss("ag-column-select-column-readonly", e);
  }
  init(e) {
    this.params = e;
    const t = this.gos.get("functionsReadOnly");
    this.eSelect.setReadOnly(t), this.eSelect.toggleCss("ag-column-select-column-readonly", t), this.beans.colModel.ready && this.showOrHideOptions();
  }
  createExpandIcons() {
    const e = this.beans;
    this.eExpand.appendChild(this.eExpandChecked = Ie("columnSelectOpen", e)), this.eExpand.appendChild(this.eExpandUnchecked = Ie("columnSelectClosed", e)), this.eExpand.appendChild(this.eExpandIndeterminate = Ie("columnSelectIndeterminate", e)), this.setExpandState(
      0
      /* EXPANDED */
    );
  }
  // we only show expand / collapse if we are showing columns
  showOrHideOptions() {
    var r;
    const e = this.params, t = !e.suppressColumnFilter, o = !e.suppressColumnSelectAll, n = !e.suppressColumnExpandAll, s = !!((r = this.beans.colModel.colDefCols) != null && r.treeDepth), i = this.getLocaleTextFunc();
    this.eFilterTextField.setInputPlaceholder(i("searchOoo", "Search...")), He(this.eFilterTextField.getGui(), t), He(this.eSelect.getGui(), o), He(this.eExpand, n && s);
  }
  onFilterTextChanged() {
    this.onFilterTextChangedDebounced || (this.onFilterTextChangedDebounced = Rt(
      this,
      () => {
        const e = this.eFilterTextField.getValue();
        this.dispatchLocalEvent({ type: "filterChanged", filterText: e });
      },
      KYe
    )), this.onFilterTextChangedDebounced();
  }
  onSelectClicked() {
    this.dispatchLocalEvent({ type: this.selectState ? "unselectAll" : "selectAll" });
  }
  onExpandClicked() {
    this.dispatchLocalEvent({ type: this.expandState === 0 ? "collapseAll" : "expandAll" });
  }
  setExpandState(e) {
    this.expandState = e, He(
      this.eExpandChecked,
      e === 0
      /* EXPANDED */
    ), He(
      this.eExpandUnchecked,
      e === 1
      /* COLLAPSED */
    ), He(
      this.eExpandIndeterminate,
      e === 2
      /* INDETERMINATE */
    );
  }
  setSelectionState(e) {
    this.selectState = e, this.eSelect.setValue(this.selectState);
  }
}, QYe = {
  selector: "AG-PRIMARY-COLS-HEADER",
  component: YYe
};
function Di(e) {
  return !!e && typeof e.children < "u";
}
function Jn(e) {
  return Di(e) ? e.groupId : e.colId;
}
function S_(e, t, o) {
  const n = (r, l) => {
    const c = r.children.map(Jn).includes(Jn(l)), d = Ke(r.children), u = d && Jn(d) !== Jn(l);
    return c && u;
  };
  if (!Di(e))
    return !0;
  const s = e, i = o;
  if (n(s, i) || s.groupId === t && !s.children.map(Jn).includes(Jn(i)))
    return s.children.push(i), !0;
  for (let r = s.children.length - 1; r >= 0 && !S_(s.children[r], t, o); r--)
    ;
  return !1;
}
function JYe(e) {
  const t = (s, i) => Di(s) && Di(i) && Jn(s) === Jn(i), o = (s, i) => {
    if (!Di(i))
      return s;
    const r = s, l = i;
    return l.children && l.groupId && S_(r, l.groupId, l.children[0]) || l.children.forEach((a) => o(r, a)), r;
  }, n = [];
  for (let s = 1; s <= e.length; s++) {
    const i = e[s - 1], r = e[s];
    t(i, r) ? e[s] = o(i, r) : n.push(i);
  }
  return n;
}
function XYe(e, t) {
  const o = [], n = (i, r) => {
    if (Di(i)) {
      const l = i, a = typeof l.groupId < "u" ? l.groupId : l.headerName, c = new Lr(l, a, !1, r), d = [];
      return l.children.forEach((u) => {
        const h = n(u, r + 1);
        h && d.push(h);
      }), c.setChildren(d), c;
    } else {
      const l = i, a = l.colId ? l.colId : l.field, c = e.getColDefCol(a);
      return c || o.push(l), c;
    }
  }, s = [];
  return t.forEach((i) => {
    const r = n(i, 0);
    r && s.push(r);
  }), o.length > 0 && X(217, { invalidColIds: o }), s;
}
function eQe(e, t) {
  const o = tQe(e), n = JYe(o);
  t(n);
}
function tQe(e) {
  const t = (s, i) => {
    let r;
    if (Lt(s))
      if (s.isPadding())
        r = i;
      else {
        const a = Object.assign({}, s.getColGroupDef());
        a.groupId = s.getGroupId(), a.children = [i], r = a;
      }
    else {
      const a = Object.assign({}, s.getColDef());
      a.colId = s.getColId(), r = a;
    }
    const l = s.getOriginalParent();
    return l ? t(l, r) : r;
  };
  return e.getCols().filter((s) => {
    const i = s.getColDef();
    return s.isPrimary() && !i.showRowGroup;
  }).map((s) => t(s, s.getColDef()));
}
var Bu = class {
  constructor(e, t, o, n = !1, s) {
    this.displayName = e, this.depth = o, this.group = n, this.localEventService = new ls(), n ? (this.columnGroup = t, this._expanded = s, this.children = []) : this.column = t;
  }
  get expanded() {
    return !!this._expanded;
  }
  set expanded(e) {
    e !== this._expanded && (this._expanded = e, this.localEventService.dispatchEvent({ type: "expandedChanged" }));
  }
  addEventListener(e, t) {
    this.localEventService.addEventListener(e, t);
  }
  removeEventListener(e, t) {
    this.localEventService.removeEventListener(e, t);
  }
};
function x_(e, t, o, n) {
  const s = oQe(t);
  M_(e, s, o, n);
}
function M_(e, t, o, n) {
  e.colModel.isPivotMode() ? sQe(e, t, o, n) : nQe(e, t, o, n);
}
function oQe(e) {
  const t = [], o = (n) => {
    n.forEach((s) => {
      s.passesFilter && (s.group ? o(s.children) : t.push(s.column));
    });
  };
  return o(e), t;
}
function nQe(e, t, o, n) {
  const s = [];
  t.forEach((i) => {
    i.getColDef().lockVisible || i.isVisible() != o && s.push({
      colId: i.getId(),
      hide: !o
    });
  }), s.length > 0 && eo(e, { state: s }, n);
}
function sQe(e, t, o, n) {
  iQe(e, t, o, n);
}
function iQe(e, t, o, n) {
  const s = [], l = o ? (a) => {
    var c;
    if (!a.isAnyFunctionActive())
      if (a.isAllowValue()) {
        const d = typeof a.getAggFunc() == "string" ? a.getAggFunc() : (c = e.aggFuncSvc) == null ? void 0 : c.getDefaultAggFunc(a);
        s.push({
          colId: a.getId(),
          aggFunc: d
        });
      } else a.isAllowRowGroup() ? s.push({
        colId: a.getId(),
        rowGroup: !0
      }) : a.isAllowPivot() && s.push({
        colId: a.getId(),
        pivot: !0
      });
  } : (a) => {
    (a.isPivotActive() || a.isRowGroupActive() || a.isValueActive()) && s.push({
      colId: a.getId(),
      pivot: !1,
      rowGroup: !1,
      aggFunc: null
    });
  };
  t.forEach(l), s.length > 0 && eo(e, { state: s }, n);
}
function A_(e, t) {
  const { columns: o, visibleState: n, pivotState: s, eventType: i } = t, r = o.map((l) => {
    const a = l.getColId();
    if (e.colModel.isPivotMode()) {
      const c = s == null ? void 0 : s[a];
      return {
        colId: a,
        pivot: c == null ? void 0 : c.pivot,
        rowGroup: c == null ? void 0 : c.rowGroup,
        aggFunc: c == null ? void 0 : c.aggFunc
      };
    } else
      return {
        colId: a,
        hide: !(n != null && n[a])
      };
  });
  eo(e, { state: r }, i);
}
function L_(e) {
  return {
    pivot: e.isPivotActive(),
    rowGroup: e.isRowGroupActive(),
    aggFunc: e.isValueActive() ? e.getAggFunc() : void 0
  };
}
function E_(e, t, o) {
  var n;
  e.group !== o && (e.group && !o && (e.expanded = !1), e.group = o, e.updateHasChildren(), (n = t.selectionSvc) == null || n.updateRowSelectable(e), e.dispatchRowEvent("groupChanged"));
}
function e1(e, t) {
  const { gos: o, rowGroupColsSvc: n } = t;
  if (!n || !e)
    return !1;
  const s = o.get("groupLockGroupColumns");
  if (!e.isRowGroupActive() || s === 0)
    return !1;
  if (s === -1)
    return !0;
  const i = n.columns.findIndex((r) => r.getColId() === e.getColId());
  return s > i;
}
function rQe(e) {
  const t = Ks(e), o = "getSelection" in t ? t.getSelection() : null, n = [];
  for (let s = 0; s < ((o == null ? void 0 : o.rangeCount) ?? 0); s++) {
    const i = o == null ? void 0 : o.getRangeAt(s);
    i && n.push(i);
  }
  return { selection: o, ranges: n };
}
function La(e, t) {
  if (!e.gos.get("enableCellTextSelection") || !I2() && !Gn())
    return t();
  const { selection: n, ranges: s } = rQe(e);
  t(), n == null || n.removeAllRanges();
  for (const i of s)
    n == null || n.addRange(i);
}
var lQe = class extends ri {
  constructor(e) {
    super(), this.setTemplateFromElement(e.getGui(), void 0, void 0, !0);
  }
  postConstruct() {
    this.initialiseTabGuard({
      onTabKeyDown: (e) => this.onTabKeyDown(e),
      handleKeyDown: (e) => this.handleKeyDown(e)
    });
  }
  handleKeyDown(e) {
    e.key === D.ESCAPE && this.closePanel();
  }
  onTabKeyDown(e) {
    e.defaultPrevented || (this.closePanel(), e.preventDefault());
  }
  closePanel() {
    const e = this.parentComponent;
    e.closeSubMenu(), setTimeout(() => e.getGui().focus(), 0);
  }
};
function aQe(e, t, o) {
  return e.getCompDetails(t, cQe, "agMenuItem", o, !0);
}
var cQe = {
  name: "menuItem",
  optionalMethods: ["setActive", "select", "setExpanded", "configureDefaults"]
}, dQe = { tag: "div", cls: "ag-menu", role: "presentation" }, $u = class extends K {
  constructor() {
    super(...arguments), this.ACTIVATION_DELAY = 80, this.isActive = !1, this.subMenuIsOpen = !1, this.subMenuIsOpening = !1, this.suppressRootStyles = !0, this.suppressAria = !0, this.suppressFocus = !0;
  }
  wireBeans(e) {
    this.popupSvc = e.popupSvc, this.userCompFactory = e.userCompFactory, this.registry = e.registry;
  }
  init(e) {
    var l;
    const { menuItemDef: t, isAnotherSubMenuOpen: o, level: n, childComponent: s, contextParams: i } = e;
    this.params = e.menuItemDef, this.level = n, this.isAnotherSubMenuOpen = o, this.childComponent = s, this.contextParams = i, this.cssClassPrefix = ((l = this.params.menuItemParams) == null ? void 0 : l.cssClassPrefix) ?? "ag-menu-option";
    const r = aQe(
      this.userCompFactory,
      this.params,
      Pe(this.gos, {
        ...t,
        level: n,
        isAnotherSubMenuOpen: o,
        openSubMenu: (a) => this.openSubMenu(a),
        closeSubMenu: () => this.closeSubMenu(),
        closeMenu: (a) => this.closeMenu(a),
        updateTooltip: (a, c) => this.refreshTooltip(a, c),
        onItemActivated: () => this.onItemActivated()
      })
    );
    return (r == null ? void 0 : r.newAgStackInstance().then((a) => {
      var d;
      this.menuItemComp = a;
      const c = (d = a.configureDefaults) == null ? void 0 : d.call(a);
      c && this.configureDefaults(c === !0 ? void 0 : c);
    })) ?? Ye.resolve();
  }
  addListeners(e, t) {
    t != null && t.suppressClick || this.addManagedElementListeners(e, { click: (o) => this.onItemSelected(o) }), t != null && t.suppressKeyboardSelect || this.addManagedElementListeners(e, {
      keydown: (o) => {
        (o.key === D.ENTER || o.key === D.SPACE) && (o.preventDefault(), this.onItemSelected(o));
      }
    }), t != null && t.suppressMouseDown || this.addManagedElementListeners(e, {
      mousedown: (o) => {
        o.stopPropagation(), o.preventDefault();
      }
    }), t != null && t.suppressMouseOver || this.addManagedElementListeners(e, {
      mouseenter: () => this.onMouseEnter(),
      mouseleave: () => this.onMouseLeave()
    });
  }
  isDisabled() {
    return !!this.params.disabled;
  }
  openSubMenu(e = !1, t) {
    var c, d;
    if (this.closeSubMenu(), !this.params.subMenu)
      return;
    this.subMenuIsOpening = !0;
    const o = ze(dQe);
    this.eSubMenuGui = o;
    let n, s = () => {
      this.subMenuIsOpening = !1;
    };
    if (this.childComponent) {
      const u = this.createBean(new lQe(this.childComponent));
      u.setParentComponent(this);
      const h = u.getGui(), p = "mouseenter", C = () => this.cancelDeactivate();
      h.addEventListener(p, C), n = () => {
        h.removeEventListener(p, C), this.destroyBean(u);
      }, o.appendChild(h), this.childComponent.afterGuiAttached && (s = () => {
        this.childComponent.afterGuiAttached(), this.subMenuIsOpening = !1;
      });
    } else if (this.params.subMenu) {
      const u = this.createBean(new Ea(this.level + 1, this.contextParams));
      u.setParentComponent(this), u.addMenuItems(this.params.subMenu), o.appendChild(u.getGui()), this.addManagedListeners(u, { closeMenu: (h) => this.dispatchLocalEvent(h) }), u.addGuiEventListener("mouseenter", () => this.cancelDeactivate()), n = () => this.destroyBean(u), e && (s = () => {
        u.activateFirstItem(), this.subMenuIsOpening = !1;
      });
    }
    const { popupSvc: i } = this, r = () => {
      const u = this.eGui, { column: h, node: p } = this.contextParams;
      i == null || i.positionPopupForMenu({
        eventSource: u,
        ePopup: o,
        event: t instanceof MouseEvent ? t : void 0,
        column: h,
        rowNode: p
      });
    }, l = this.getLocaleTextFunc(), a = i == null ? void 0 : i.addPopup({
      modal: !0,
      eChild: o,
      positionCallback: r,
      anchorToElement: this.eGui,
      ariaLabel: l("ariaLabelSubMenu", "SubMenu"),
      afterGuiAttached: s
    });
    this.subMenuIsOpen = !0, this.setAriaExpanded(!0), this.hideSubMenu = () => {
      var u, h;
      a && a.hideFunc(), this.subMenuIsOpen = !1, this.setAriaExpanded(!1), n(), (h = (u = this.menuItemComp).setExpanded) == null || h.call(u, !1), this.eSubMenuGui = void 0;
    }, (d = (c = this.menuItemComp).setExpanded) == null || d.call(c, !0);
  }
  setAriaExpanded(e) {
    this.suppressAria || Fo(this.eGui, e);
  }
  closeSubMenu() {
    this.hideSubMenu && (this.hideSubMenu(), this.hideSubMenu = null, this.setAriaExpanded(!1));
  }
  isSubMenuOpen() {
    return this.subMenuIsOpen;
  }
  isSubMenuOpening() {
    return this.subMenuIsOpening;
  }
  activate(e, t) {
    var o, n;
    this.cancelActivate(), !(this.params.disabled && !t) && (this.isActive = !0, this.suppressRootStyles || this.eGui.classList.add(`${this.cssClassPrefix}-active`), (n = (o = this.menuItemComp).setActive) == null || n.call(o, !0), this.suppressFocus || La(this.beans, () => this.eGui.focus({ preventScroll: !t })), e && this.params.subMenu && window.setTimeout(() => {
      this.isAlive() && this.isActive && this.openSubMenu();
    }, 300), this.onItemActivated());
  }
  deactivate() {
    var e, t;
    this.cancelDeactivate(), this.suppressRootStyles || this.eGui.classList.remove(`${this.cssClassPrefix}-active`), (t = (e = this.menuItemComp).setActive) == null || t.call(e, !1), this.isActive = !1, this.subMenuIsOpen && this.closeSubMenu();
  }
  getGui() {
    return this.menuItemComp.getGui();
  }
  getParentComponent() {
    return this.parentComponent;
  }
  setParentComponent(e) {
    this.parentComponent = e;
  }
  getSubMenuGui() {
    return this.eSubMenuGui;
  }
  onItemSelected(e) {
    var t, o;
    (o = (t = this.menuItemComp).select) == null || o.call(t), this.params.action ? this.beans.frameworkOverrides.wrapOutgoing(
      () => this.params.action(
        Pe(this.gos, {
          ...this.contextParams
        })
      )
    ) : this.openSubMenu(e && e.type === "keydown", e), !(this.params.subMenu && !this.params.action || this.params.suppressCloseOnSelect) && this.closeMenu(e);
  }
  closeMenu(e) {
    const t = {
      type: "closeMenu"
    };
    e && (e instanceof MouseEvent ? t.mouseEvent = e : t.keyboardEvent = e), this.dispatchLocalEvent(t);
  }
  onItemActivated() {
    const e = {
      type: "menuItemActivated",
      menuItem: this
    };
    this.dispatchLocalEvent(e);
  }
  cancelActivate() {
    this.activateTimeoutId && (window.clearTimeout(this.activateTimeoutId), this.activateTimeoutId = 0);
  }
  cancelDeactivate() {
    this.deactivateTimeoutId && (window.clearTimeout(this.deactivateTimeoutId), this.deactivateTimeoutId = 0);
  }
  onMouseEnter() {
    this.cancelDeactivate(), this.isAnotherSubMenuOpen() ? this.activateTimeoutId = window.setTimeout(() => this.activate(!0), this.ACTIVATION_DELAY) : this.activate(!0);
  }
  onMouseLeave() {
    this.cancelActivate(), this.isSubMenuOpen() ? this.deactivateTimeoutId = window.setTimeout(() => this.deactivate(), this.ACTIVATION_DELAY) : this.deactivate();
  }
  refreshRootElementGui(e) {
    var r, l;
    let t = this.menuItemComp.getGui();
    const {
      cssClassPrefix: o,
      params: { cssClasses: n, disabled: s }
    } = this, i = (l = (r = this.menuItemComp).getRootElement) == null ? void 0 : l.call(r);
    return i && (e || t.classList.add("ag-menu-option-custom"), t = i), this.suppressRootStyles = !!e, this.suppressRootStyles || (t.classList.add(o), n == null || n.forEach((a) => t.classList.add(a)), s && t.classList.add(`${o}-disabled`)), t;
  }
  applyAriaProperties(e) {
    const {
      params: { checked: t, subMenu: o, subMenuRole: n, disabled: s }
    } = this, i = t != null;
    no(e, i ? "menuitemcheckbox" : "menuitem"), o && YTe(e, n ?? "menu"), s && ml(e, !0);
  }
  configureDefaults(e) {
    if (!this.menuItemComp) {
      setTimeout(() => this.configureDefaults(e));
      return;
    }
    const { suppressRootStyles: t, suppressTooltip: o, suppressAria: n, suppressTabIndex: s, suppressFocus: i } = e || {}, {
      params: { tooltip: r, disabled: l }
    } = this, a = this.eGui = this.refreshRootElementGui(!!t);
    this.suppressAria = !!n, n || this.applyAriaProperties(a), s || a.setAttribute("tabindex", "-1"), o || this.refreshTooltip(r), l || this.addListeners(a, e), this.suppressFocus = !!i;
  }
  refreshTooltip(e, t) {
    if (this.tooltip = e, this.tooltipFeature = this.destroyBean(this.tooltipFeature), !e || !this.menuItemComp)
      return;
    const o = this.registry.createDynamicBean("tooltipFeature", !1, {
      getGui: () => this.getGui(),
      getTooltipValue: () => this.tooltip,
      getLocation: () => "menu",
      shouldDisplayTooltip: t
    });
    o && (this.tooltipFeature = this.createBean(o));
  }
  destroy() {
    var e, t;
    this.tooltipFeature = this.destroyBean(this.tooltipFeature), (t = (e = this.menuItemComp) == null ? void 0 : e.destroy) == null || t.call(e), super.destroy();
  }
}, Ea = class extends ri {
  constructor(e = 0, t) {
    super({ tag: "div", cls: "ag-menu-list", role: "menu" }), this.level = e, this.menuItems = [], this.params = t ?? {
      column: null,
      node: null,
      value: null
    };
  }
  postConstruct() {
    this.initialiseTabGuard({
      onTabKeyDown: (e) => this.onTabKeyDown(e),
      handleKeyDown: (e) => La(this.beans, () => this.handleKeyDown(e)),
      onFocusIn: (e) => this.handleFocusIn(e),
      onFocusOut: (e) => this.handleFocusOut(e)
    });
  }
  onTabKeyDown(e) {
    var n;
    const t = this.getParentComponent();
    ((n = t == null ? void 0 : t.getGui()) == null ? void 0 : n.classList.contains("ag-focus-managed")) || e.preventDefault(), e.shiftKey && this.closeIfIsChild(e);
  }
  handleKeyDown(e) {
    switch (e.key) {
      case D.UP:
      case D.RIGHT:
      case D.DOWN:
      case D.LEFT:
        e.preventDefault(), this.handleNavKey(e.key);
        break;
      case D.ESCAPE:
        this.closeIfIsChild() && vt(e);
        break;
    }
  }
  handleFocusIn(e) {
    var o, n;
    const t = e.relatedTarget;
    !this.tabGuardFeature.getTabGuardCtrl().isTabGuard(t) && (this.getGui().contains(t) || (n = (o = this.activeMenuItem) == null ? void 0 : o.getSubMenuGui()) != null && n.contains(t)) || (this.activeMenuItem ? this.activeMenuItem.activate() : this.activateFirstItem());
  }
  handleFocusOut(e) {
    var o;
    const t = e.relatedTarget;
    !this.activeMenuItem || this.getGui().contains(t) || (o = this.activeMenuItem.getSubMenuGui()) != null && o.contains(t) || this.activeMenuItem.isSubMenuOpening() || this.activeMenuItem.deactivate();
  }
  clearActiveItem() {
    this.activeMenuItem && (this.activeMenuItem.deactivate(), this.activeMenuItem = null);
  }
  addMenuItems(e) {
    e != null && Ye.all(
      e.map((t) => t === "separator" ? Ye.resolve({ eGui: this.createSeparator() }) : typeof t == "string" ? (X(228, { menuItemOrString: t }), Ye.resolve({ eGui: null })) : this.addItem(t))
    ).then((t) => {
      (t ?? []).forEach((o) => {
        o != null && o.eGui && (this.appendChild(o.eGui), o.comp && this.menuItems.push(o.comp));
      });
    });
  }
  addItem(e) {
    const t = this.createManagedBean(new $u());
    return t.init({
      menuItemDef: e,
      isAnotherSubMenuOpen: () => this.menuItems.some((o) => o.isSubMenuOpen()),
      level: this.level,
      contextParams: this.params
    }).then(() => (t.setParentComponent(this), this.addManagedListeners(t, {
      closeMenu: (o) => {
        this.dispatchLocalEvent(o);
      },
      menuItemActivated: (o) => {
        this.activeMenuItem && this.activeMenuItem !== o.menuItem && this.activeMenuItem.deactivate(), this.activeMenuItem = o.menuItem;
      }
    }), {
      comp: t,
      eGui: t.getGui()
    }));
  }
  activateFirstItem() {
    const e = this.menuItems.filter((t) => !t.isDisabled())[0];
    e && e.activate();
  }
  createSeparator() {
    const e = { tag: "div", cls: "ag-menu-separator-part" };
    return ze({
      tag: "div",
      cls: "ag-menu-separator",
      attrs: {
        "aria-hidden": "true"
      },
      children: [e, e, e, e]
    });
  }
  handleNavKey(e) {
    switch (e) {
      case D.UP:
      case D.DOWN: {
        const o = this.findNextItem(e === D.UP);
        o && o !== this.activeMenuItem && o.activate(!1, !0);
        return;
      }
    }
    const t = this.gos.get("enableRtl") ? D.RIGHT : D.LEFT;
    e === t ? this.closeIfIsChild() : this.openChild();
  }
  closeIfIsChild(e) {
    const t = this.getParentComponent();
    return t && t instanceof $u ? (e && e.preventDefault(), t.closeSubMenu(), t.getGui().focus(), !0) : !1;
  }
  openChild() {
    this.activeMenuItem && this.activeMenuItem.openSubMenu(!0);
  }
  findNextItem(e) {
    const t = [...this.menuItems];
    if (!t.length)
      return;
    if (!this.activeMenuItem)
      return e ? Ke(t) : t[0];
    e && t.reverse();
    let o, n = !1;
    for (const s of t) {
      if (!n) {
        s === this.activeMenuItem && (n = !0);
        continue;
      }
      o = s;
      break;
    }
    return n && !o ? t[0] : o || this.activeMenuItem;
  }
  destroy() {
    this.clearActiveItem(), super.destroy();
  }
}, P_ = class extends Re {
  constructor(e, t, o) {
    super({ tag: "div", cls: "ag-menu" }), this.column = e, this.mouseEvent = t, this.parentEl = o, this.displayName = null;
  }
  postConstruct() {
    const {
      column: e,
      beans: { colNames: t }
    } = this;
    this.initializeProperties(e);
    let o;
    if (hn(e) ? o = t.getDisplayNameForColumn(e, "columnToolPanel") : o = t.getDisplayNameForProvidedColumnGroup(null, e, "columnToolPanel"), this.displayName = o, this.buildMenuItemMap(), this.isActive()) {
      this.mouseEvent.preventDefault();
      const n = this.getMappedMenuItems();
      if (n.length === 0)
        return;
      this.displayContextMenu(n);
    }
  }
  initializeProperties(e) {
    let t;
    Lt(e) ? t = e.getLeafColumns() : t = [e], this.columns = t;
    const o = this.beans.colModel.isPivotMode();
    this.allowScrollIntoView = !o && t.some(this.isColumnValidForScrollIntoView), this.allowGrouping = t.some((n) => n.isPrimary() && n.isAllowRowGroup()), this.allowValues = t.some((n) => n.isPrimary() && n.isAllowValue()), this.allowPivoting = o && t.some((n) => n.isPrimary() && n.isAllowPivot());
  }
  buildMenuItemMap() {
    const e = this.getLocaleTextFunc(), { beans: t, displayName: o } = this, { rowGroupColsSvc: n, valueColsSvc: s, pivotColsSvc: i, colModel: r } = t, l = /* @__PURE__ */ new Map();
    this.menuItemMap = l;
    const a = r.isPivotMode();
    l.set("scrollIntoView", {
      allowedFunction: (c) => !c.isPinned() && !a && this.isColumnValidForScrollIntoView(c),
      activeFunction: () => !1,
      activateLabel: () => e("scrollColumnIntoView", `Scroll ${o} into View`, [o]),
      activateFunction: () => {
        const c = this.columns.find(this.isColumnValidForScrollIntoView);
        c && this.beans.ctrlsSvc.getScrollFeature().ensureColumnVisible(c);
      },
      deActivateFunction: () => {
      },
      addIcon: "ensureColumnVisible"
    }), l.set("rowGroup", {
      allowedFunction: (c) => c.isPrimary() && c.isAllowRowGroup() && !e1(c, t),
      activeFunction: (c) => c.isRowGroupActive(),
      activateLabel: () => `${e("groupBy", "Group by")} ${o}`,
      deactivateLabel: () => `${e("ungroupBy", "Un-Group by")} ${o}`,
      activateFunction: () => n == null ? void 0 : n.setColumns(this.addColumnsToList(n.columns), "toolPanelUi"),
      deActivateFunction: () => n == null ? void 0 : n.setColumns(this.removeColumnsFromList(n.columns), "toolPanelUi"),
      addIcon: "menuAddRowGroup",
      removeIcon: "menuRemoveRowGroup"
    }), l.set("value", {
      allowedFunction: (c) => c.isPrimary() && c.isAllowValue(),
      activeFunction: (c) => c.isValueActive(),
      activateLabel: () => e("addToValues", `Add ${o} to values`, [o]),
      deactivateLabel: () => e("removeFromValues", `Remove ${o} from values`, [o]),
      activateFunction: () => s == null ? void 0 : s.setColumns(this.addColumnsToList(s.columns), "toolPanelUi"),
      deActivateFunction: () => s == null ? void 0 : s.setColumns(this.removeColumnsFromList(s.columns), "toolPanelUi"),
      addIcon: "valuePanel",
      removeIcon: "valuePanel"
    }), l.set("pivot", {
      allowedFunction: (c) => a && c.isPrimary() && c.isAllowPivot(),
      activeFunction: (c) => c.isPivotActive(),
      activateLabel: () => e("addToLabels", `Add ${o} to labels`, [o]),
      deactivateLabel: () => e("removeFromLabels", `Remove ${o} from labels`, [o]),
      activateFunction: () => i == null ? void 0 : i.setColumns(this.addColumnsToList(i.columns), "toolPanelUi"),
      deActivateFunction: () => i == null ? void 0 : i.setColumns(this.removeColumnsFromList(i.columns), "toolPanelUi"),
      addIcon: "pivotPanel",
      removeIcon: "pivotPanel"
    });
  }
  isColumnValidForScrollIntoView(e) {
    var n;
    if (!e.isVisible())
      return !1;
    const o = e.getParent();
    return o ? ((n = o.getDisplayedChildren()) == null ? void 0 : n.indexOf(e)) !== -1 : !0;
  }
  addColumnsToList(e) {
    return [...e].concat(this.columns.filter((t) => e.indexOf(t) === -1));
  }
  removeColumnsFromList(e) {
    return e.filter((t) => this.columns.indexOf(t) === -1);
  }
  displayContextMenu(e) {
    const t = this.getGui(), o = this.createBean(new Ea()), n = this.getLocaleTextFunc();
    let s = () => {
    };
    t.appendChild(o.getGui()), o.addMenuItems(e), o.addManagedListeners(o, {
      closeMenu: () => {
        this.parentEl.focus(), s();
      }
    });
    const i = this.beans.popupSvc, r = i.addPopup({
      modal: !0,
      eChild: t,
      closeOnEsc: !0,
      afterGuiAttached: () => so(o.getGui()),
      ariaLabel: n("ariaLabelContextMenu", "Context Menu"),
      closedCallback: (l) => {
        l instanceof KeyboardEvent && this.parentEl.focus(), this.destroyBean(o);
      }
    });
    r && (s = r.hideFunc), i.positionPopupUnderMouseEvent({
      type: "columnContextMenu",
      mouseEvent: this.mouseEvent,
      ePopup: t
    });
  }
  isActive() {
    return this.allowScrollIntoView || this.allowGrouping || this.allowValues || this.allowPivoting;
  }
  getMappedMenuItems() {
    const e = [], { menuItemMap: t, columns: o, displayName: n, beans: s } = this;
    for (const i of t.values()) {
      const r = o.some((a) => i.allowedFunction(a) && !i.activeFunction(a)), l = o.some((a) => i.allowedFunction(a) && i.activeFunction(a));
      r && e.push({
        name: i.activateLabel(n),
        icon: Ie(i.addIcon, s, null),
        action: () => i.activateFunction()
      }), l && i.removeIcon && i.deactivateLabel && e.push({
        name: i.deactivateLabel(n),
        icon: Ie(i.removeIcon, s, null),
        action: () => {
          var a;
          return (a = i.deActivateFunction) == null ? void 0 : a.call(i);
        }
      });
    }
    return e;
  }
}, uQe = {
  tag: "div",
  cls: "ag-column-select-column-group",
  children: [
    {
      tag: "span",
      ref: "eColumnGroupIcons",
      cls: "ag-column-group-icons",
      children: [
        { tag: "span", ref: "eGroupClosedIcon", cls: "ag-column-group-closed-icon" },
        { tag: "span", ref: "eGroupOpenedIcon", cls: "ag-column-group-opened-icon" }
      ]
    },
    { tag: "ag-checkbox", ref: "cbSelect", cls: "ag-column-select-checkbox" },
    { tag: "span", ref: "eLabel", cls: "ag-column-select-column-label" }
  ]
}, R_ = class extends Re {
  constructor(e, t, o, n) {
    super(), this.modelItem = e, this.allowDragging = t, this.eventType = o, this.focusWrapper = n, this.cbSelect = J, this.eLabel = J, this.eGroupOpenedIcon = J, this.eGroupClosedIcon = J, this.eColumnGroupIcons = J, this.processingColumnStateChange = !1;
    const { columnGroup: s, depth: i, displayName: r } = e;
    this.columnGroup = s, this.columnDepth = i, this.displayName = r;
  }
  postConstruct() {
    this.setTemplate(uQe, [ii]);
    const { beans: e, cbSelect: t, eLabel: o, displayName: n, columnDepth: s, modelItem: i, focusWrapper: r, columnGroup: l } = this, { registry: a, gos: c } = e, d = Ie("columnDrag", e);
    this.eDragHandle = d, d.classList.add("ag-drag-handle", "ag-column-select-column-group-drag-handle");
    const u = t.getGui(), h = t.getInputElement();
    u.insertAdjacentElement("afterend", d), h.setAttribute("tabindex", "-1"), o.textContent = n ?? "", this.setupExpandContract(), this.addCss("ag-column-select-indent-" + s), this.getGui().style.setProperty("--ag-indentation-level", String(s)), this.tooltipFeature = this.createOptionalManagedBean(
      a.createDynamicBean("tooltipFeature", !1, {
        getGui: () => this.focusWrapper,
        getLocation: () => "columnToolPanelColumnGroup",
        shouldDisplayTooltip: lc(c, () => o)
      })
    ), this.addManagedEventListeners({ columnPivotModeChanged: this.onColumnStateChanged.bind(this) }), this.addManagedElementListeners(o, { click: this.onLabelClicked.bind(this) }), this.addManagedListeners(t, { fieldValueChanged: this.onCheckboxChanged.bind(this) }), this.addManagedListeners(i, { expandedChanged: this.onExpandChanged.bind(this) }), this.addManagedListeners(r, {
      keydown: this.handleKeyDown.bind(this),
      contextmenu: this.onContextMenu.bind(this)
    }), this.setOpenClosedIcons(), this.setupDragging(), this.onColumnStateChanged(), this.addVisibilityListenersToAllChildren(), this.refreshAriaExpanded(), this.refreshAriaLabel(), this.setupTooltip(), kb(l.getColGroupDef(), c, null, l).forEach((C) => this.toggleCss(C, !0));
  }
  getColumns() {
    return this.columnGroup.getLeafColumns();
  }
  setupTooltip() {
    const e = this.columnGroup.getColGroupDef();
    if (!e)
      return;
    const t = () => {
      var o;
      return (o = this.tooltipFeature) == null ? void 0 : o.setTooltipAndRefresh(e.headerTooltip);
    };
    t(), this.addManagedEventListeners({ newColumnsLoaded: t });
  }
  handleKeyDown(e) {
    switch (e.key) {
      case D.LEFT:
        e.preventDefault(), this.modelItem.expanded = !1;
        break;
      case D.RIGHT:
        e.preventDefault(), this.modelItem.expanded = !0;
        break;
      case D.SPACE:
        e.preventDefault(), this.isSelectable() && this.onSelectAllChanged(!this.isSelected());
        break;
    }
  }
  onContextMenu(e) {
    const { columnGroup: t, gos: o } = this;
    if (o.get("functionsReadOnly"))
      return;
    const n = this.createBean(new P_(t, e, this.focusWrapper));
    this.addDestroyFunc(() => {
      n.isAlive() && this.destroyBean(n);
    });
  }
  addVisibilityListenersToAllChildren() {
    const e = this.onColumnStateChanged.bind(this);
    this.columnGroup.getLeafColumns().forEach((t) => {
      this.addManagedListeners(t, {
        visibleChanged: e,
        columnValueChanged: e,
        columnPivotChanged: e,
        columnRowGroupChanged: e
      });
    });
  }
  setupDragging() {
    if (!this.allowDragging) {
      He(this.eDragHandle, !1);
      return;
    }
    const e = this.beans, { gos: t, eventSvc: o, dragAndDrop: n } = e;
    let s = !t.get("suppressDragLeaveHidesColumns");
    const i = {
      type: Hn.ToolPanel,
      eElement: this.eDragHandle,
      dragItemName: this.displayName,
      getDefaultIconName: () => s ? "hide" : "notAllowed",
      getDragItem: () => this.createDragItem(),
      onDragStarted: () => {
        s = !t.get("suppressDragLeaveHidesColumns"), o.dispatchEvent({
          type: "columnPanelItemDragStart",
          column: this.columnGroup
        });
      },
      onDragStopped: () => {
        o.dispatchEvent({
          type: "columnPanelItemDragEnd"
        });
      },
      onGridEnter: (r) => {
        s && A_(e, {
          columns: this.columnGroup.getLeafColumns(),
          visibleState: r == null ? void 0 : r.visibleState,
          pivotState: r == null ? void 0 : r.pivotState,
          eventType: this.eventType
        });
      },
      onGridExit: () => {
        s && this.onChangeCommon(!1);
      }
    };
    n.addDragSource(i, !0), this.addDestroyFunc(() => n.removeDragSource(i));
  }
  createDragItem() {
    const e = this.columnGroup.getLeafColumns(), t = {}, o = {};
    return e.forEach((n) => {
      const s = n.getId();
      t[s] = n.isVisible(), o[s] = L_(n);
    }), {
      columns: e,
      visibleState: t,
      pivotState: o
    };
  }
  setupExpandContract() {
    const { beans: e, eGroupClosedIcon: t, eGroupOpenedIcon: o, eColumnGroupIcons: n } = this;
    t.appendChild(Ri("columnSelectClosed", e, null)), o.appendChild(Ri("columnSelectOpen", e, null));
    const s = this.onExpandOrContractClicked.bind(this);
    this.addManagedElementListeners(t, { click: s }), this.addManagedElementListeners(o, { click: s });
    const i = new _n(n, !0);
    this.addManagedListeners(i, { tap: s }), this.addDestroyFunc(i.destroy.bind(i));
  }
  onLabelClicked() {
    const e = !this.cbSelect.getValue();
    this.onChangeCommon(e);
  }
  onCheckboxChanged(e) {
    this.onChangeCommon(e.selected);
  }
  getVisibleLeafColumns() {
    const e = [], t = (o) => {
      o.forEach((n) => {
        n.passesFilter && (n.group ? t(n.children) : e.push(n.column));
      });
    };
    return t(this.modelItem.children), e;
  }
  onChangeCommon(e) {
    this.refreshAriaLabel(), !this.processingColumnStateChange && x_(this.beans, this.modelItem.children, e, this.eventType);
  }
  refreshAriaLabel() {
    const { cbSelect: e, focusWrapper: t, displayName: o } = this, n = this.getLocaleTextFunc(), s = n("ariaColumnGroup", "Column Group"), i = e.getValue(), r = i === void 0 ? n("ariaIndeterminate", "indeterminate") : i ? n("ariaVisible", "visible") : n("ariaHidden", "hidden"), l = n("ariaToggleVisibility", "Press SPACE to toggle visibility");
    ft(t, `${o} ${s}`), e.setInputAriaLabel(`${l} (${r})`), sa(t, e.getInputElement().id);
  }
  onColumnStateChanged() {
    const e = this.workOutSelectedValue(), t = this.workOutReadOnlyValue();
    this.processingColumnStateChange = !0;
    const o = this.cbSelect;
    o.setValue(e), o.setReadOnly(t), this.toggleCss("ag-column-select-column-group-readonly", t), this.processingColumnStateChange = !1;
  }
  workOutSelectedValue() {
    const e = this.beans.colModel.isPivotMode(), t = this.getVisibleLeafColumns();
    let o = 0, n = 0;
    if (t.forEach((s) => {
      !e && s.getColDef().lockVisible || (this.isColumnChecked(s, e) ? o++ : n++);
    }), !(o > 0 && n > 0))
      return o > 0;
  }
  workOutReadOnlyValue() {
    const e = this.beans.colModel.isPivotMode();
    let t = 0;
    return this.columnGroup.getLeafColumns().forEach((o) => {
      e ? o.isAnyFunctionAllowed() && t++ : o.getColDef().lockVisible || t++;
    }), t === 0;
  }
  isColumnChecked(e, t) {
    if (t) {
      const o = e.isPivotActive(), n = e.isRowGroupActive(), s = e.isValueActive();
      return o || n || s;
    }
    return e.isVisible();
  }
  onExpandOrContractClicked() {
    const e = this.modelItem, t = e.expanded;
    e.expanded = !t;
  }
  onExpandChanged() {
    this.setOpenClosedIcons(), this.refreshAriaExpanded();
  }
  setOpenClosedIcons() {
    const e = this.modelItem.expanded;
    He(this.eGroupClosedIcon, !e), He(this.eGroupOpenedIcon, e);
  }
  refreshAriaExpanded() {
    Fo(this.focusWrapper, this.modelItem.expanded);
  }
  getDisplayName() {
    return this.displayName;
  }
  onSelectAllChanged(e) {
    const t = this.cbSelect, o = t.getValue();
    !t.isReadOnly() && (e && !o || !e && o) && t.toggle();
  }
  isSelected() {
    return this.cbSelect.getValue();
  }
  isSelectable() {
    return !this.cbSelect.isReadOnly();
  }
  setSelected(e) {
    this.cbSelect.setValue(e, !0);
  }
}, L0 = (e) => Lt(e) ? e.getLeafColumns() : e ? [e] : [], hQe = (e, t, o, n) => {
  if (!o || !t)
    return null;
  const s = e.colModel.getCols(), i = s.indexOf(o), r = n ? i : i + 1, l = gQe(s, t, r);
  return r - l;
}, gQe = (e, t, o) => {
  if (!t)
    return 0;
  const n = t[0], s = t.length;
  return e.indexOf(n) < o ? s : 0;
}, Zu = (e, t, o) => e.get("suppressMovableColumns") || t.colModel.isPivotMode() ? !0 : !!o.find(({ colDef: i }) => !!i.suppressMovable || !!i.lockPosition), Gu = (e, t, o) => {
  var l;
  if (!o)
    return;
  const { component: n } = o;
  let s = null, i = o.position === "top";
  if (n instanceof R_ ? (s = n.getColumns()[0], i = !0) : n && (s = n.column), !s)
    return;
  const r = hQe(e, t, s, i);
  r != null && ((l = e.colMoves) == null || l.moveColumns(t, r, "toolPanelUi"));
}, pQe = (e) => e.column, fQe = {
  tag: "div",
  cls: "ag-column-select-column",
  children: [
    { tag: "ag-checkbox", ref: "cbSelect", cls: "ag-column-select-checkbox" },
    { tag: "span", ref: "eLabel", cls: "ag-column-select-column-label" }
  ]
}, vQe = class extends Re {
  constructor(e, t, o, n) {
    super(), this.modelItem = e, this.allowDragging = t, this.groupsExist = o, this.focusWrapper = n, this.eLabel = J, this.cbSelect = J, this.processingColumnStateChange = !1;
    const { column: s, depth: i, displayName: r } = e;
    this.column = s, this.columnDepth = i, this.displayName = r;
  }
  postConstruct() {
    this.setTemplate(fQe, [ii]);
    const {
      beans: e,
      cbSelect: t,
      displayName: o,
      eLabel: n,
      columnDepth: s,
      groupsExist: i,
      column: r,
      gos: l,
      focusWrapper: a
    } = this, c = Ie("columnDrag", e);
    this.eDragHandle = c, c.classList.add("ag-drag-handle", "ag-column-select-column-drag-handle");
    const d = t.getGui(), u = t.getInputElement();
    d.insertAdjacentElement("afterend", c), u.setAttribute("tabindex", "-1"), n.textContent = o, i && this.addCss("ag-column-select-add-group-indent"), this.addCss(`ag-column-select-indent-${s}`), this.getGui().style.setProperty("--ag-indentation-level", String(s)), this.tooltipFeature = this.createOptionalManagedBean(
      e.registry.createDynamicBean("tooltipFeature", !1, {
        getGui: () => this.focusWrapper,
        getLocation: () => "columnToolPanelColumn",
        shouldDisplayTooltip: lc(l, () => n),
        getAdditionalParams: () => ({
          colDef: r.getColDef()
        })
      })
    ), this.setupDragging();
    const h = this.onColumnStateChanged.bind(this);
    this.addManagedEventListeners({ columnPivotModeChanged: h }), this.addManagedListeners(r, {
      columnValueChanged: h,
      columnPivotChanged: h,
      columnRowGroupChanged: h,
      visibleChanged: h
    }), this.addManagedListeners(a, {
      keydown: this.handleKeyDown.bind(this),
      contextmenu: this.onContextMenu.bind(this)
    }), this.addManagedPropertyListener("functionsReadOnly", this.onColumnStateChanged.bind(this)), this.addManagedListeners(t, { fieldValueChanged: this.onCheckboxChanged.bind(this) }), this.addManagedElementListeners(n, { click: this.onLabelClicked.bind(this) }), this.onColumnStateChanged(), this.refreshAriaLabel(), this.setupTooltip(), kb(r.getColDef(), l, r, null).forEach((C) => this.toggleCss(C, !0));
  }
  getColumn() {
    return this.column;
  }
  setupTooltip() {
    const e = () => {
      var t;
      return (t = this.tooltipFeature) == null ? void 0 : t.setTooltipAndRefresh(this.column.getColDef().headerTooltip);
    };
    e(), this.addManagedEventListeners({ newColumnsLoaded: e });
  }
  onContextMenu(e) {
    const { column: t, gos: o } = this;
    if (o.get("functionsReadOnly"))
      return;
    const n = this.createBean(new P_(t, e, this.focusWrapper));
    this.addDestroyFunc(() => {
      n.isAlive() && this.destroyBean(n);
    });
  }
  handleKeyDown(e) {
    e.key === D.SPACE && (e.preventDefault(), this.isSelectable() && this.onSelectAllChanged(!this.isSelected()));
  }
  onLabelClicked() {
    if (this.gos.get("functionsReadOnly"))
      return;
    const e = !this.cbSelect.getValue();
    this.onChangeCommon(e);
  }
  onCheckboxChanged(e) {
    this.onChangeCommon(e.selected);
  }
  onChangeCommon(e) {
    this.cbSelect.isReadOnly() || (this.refreshAriaLabel(), !this.processingColumnStateChange && M_(this.beans, [this.column], e, "toolPanelUi"));
  }
  refreshAriaLabel() {
    const { cbSelect: e, focusWrapper: t, displayName: o } = this, n = this.getLocaleTextFunc(), s = n("ariaColumn", "Column"), i = e.getValue() ? n("ariaVisible", "visible") : n("ariaHidden", "hidden"), r = n("ariaToggleVisibility", "Press SPACE to toggle visibility");
    ft(t, `${o} ${s}`), this.cbSelect.setInputAriaLabel(`${r} (${i})`), sa(t, e.getInputElement().id);
  }
  setupDragging() {
    const e = this.eDragHandle;
    if (!this.allowDragging) {
      He(e, !1);
      return;
    }
    const t = this.beans, { gos: o, eventSvc: n, dragAndDrop: s } = t;
    let i = !o.get("suppressDragLeaveHidesColumns");
    const r = {
      type: Hn.ToolPanel,
      eElement: e,
      dragItemName: this.displayName,
      getDefaultIconName: () => i ? "hide" : "notAllowed",
      getDragItem: () => this.createDragItem(),
      onDragStarted: () => {
        i = !o.get("suppressDragLeaveHidesColumns"), n.dispatchEvent({
          type: "columnPanelItemDragStart",
          column: this.column
        });
      },
      onDragStopped: () => {
        n.dispatchEvent({
          type: "columnPanelItemDragEnd"
        });
      },
      onGridEnter: (l) => {
        i && A_(t, {
          columns: [this.column],
          visibleState: l == null ? void 0 : l.visibleState,
          pivotState: l == null ? void 0 : l.pivotState,
          eventType: "toolPanelUi"
        });
      },
      onGridExit: () => {
        i && this.onChangeCommon(!1);
      }
    };
    s.addDragSource(r, !0), this.addDestroyFunc(() => s.removeDragSource(r));
  }
  createDragItem() {
    const e = this.column.getColId(), t = { [e]: this.column.isVisible() }, o = { [e]: L_(this.column) };
    return {
      columns: [this.column],
      visibleState: t,
      pivotState: o
    };
  }
  onColumnStateChanged() {
    this.processingColumnStateChange = !0;
    const e = this.beans.colModel.isPivotMode();
    if (e) {
      const n = this.column.isAnyFunctionActive();
      this.cbSelect.setValue(n);
    } else
      this.cbSelect.setValue(this.column.isVisible());
    let t = !0, o = !0;
    if (e) {
      const n = this.gos.get("functionsReadOnly"), s = !this.column.isAnyFunctionAllowed();
      t = !n && !s, o = t;
    } else {
      const { enableRowGroup: n, enableValue: s, lockPosition: i, suppressMovable: r, lockVisible: l } = this.column.getColDef(), a = !!n || !!s, c = !!i || !!r;
      t = !l, o = a || !c;
    }
    this.cbSelect.setReadOnly(!t), this.eDragHandle.classList.toggle("ag-column-select-column-readonly", !o), this.toggleCss("ag-column-select-column-readonly", !o && !t), this.cbSelect.setPassive(!1), this.processingColumnStateChange = !1;
  }
  getDisplayName() {
    return this.displayName;
  }
  onSelectAllChanged(e) {
    const t = this.cbSelect;
    e !== t.getValue() && (t.isReadOnly() || t.toggle());
  }
  isSelected() {
    return this.cbSelect.getValue();
  }
  isSelectable() {
    return !this.cbSelect.isReadOnly();
  }
  isExpandable() {
    return !1;
  }
  setExpanded(e) {
    X(158);
  }
}, mQe = class {
  constructor(e) {
    this.items = e;
  }
  getRowCount() {
    return this.items.length;
  }
  getRow(e) {
    return this.items[e];
  }
}, CQe = "ag-column-select-list", wQe = class extends Re {
  constructor() {
    super({ tag: "div", cls: CQe, role: "presentation" }), this.destroyColumnItemFuncs = [], this.hasLoadedInitialState = !1, this.isInitialState = !1, this.skipRefocus = !1;
  }
  wireBeans(e) {
    this.colModel = e.colModel;
  }
  destroy() {
    this.destroyColumnTree(), super.destroy();
  }
  destroyColumnTree() {
    this.allColsTree = [], this.destroyColumnItemFuncs.forEach((e) => e()), this.destroyColumnItemFuncs = [];
  }
  init(e, t, o) {
    this.params = e;
    const { suppressSyncLayoutWithGrid: n, contractColumnSelection: s, suppressColumnMove: i } = e;
    this.allowDragging = t, this.eventType = o, n || this.addManagedEventListeners({ columnMoved: this.onColumnsChanged.bind(this) }), this.addManagedEventListeners({
      newColumnsLoaded: this.onColumnsChanged.bind(this)
    });
    const r = this.fireSelectionChangedEvent.bind(this);
    this.addManagedEventListeners({
      columnPivotChanged: r,
      columnPivotModeChanged: r,
      columnRowGroupChanged: r,
      columnValueChanged: r,
      columnVisible: r,
      newColumnsLoaded: r
    }), this.expandGroupsByDefault = !s;
    const l = i || n, a = this.createManagedBean(
      new nr({
        cssIdentifier: "column-select",
        ariaRole: "tree",
        moveItemCallback: (c, d) => {
          l || this.moveItems(c, d);
        }
      })
    );
    this.virtualList = a, this.appendChild(a.getGui()), a.setComponentCreator((c, d) => (ia(d, c.depth + 1), this.createComponentFromItem(c, d))), this.colModel.ready && this.onColumnsChanged(), !l && this.createItemDragFeature();
  }
  createItemDragFeature() {
    const { gos: e, beans: t, eventSvc: o, virtualList: n } = this;
    this.createManagedBean(
      new u_(this, n, {
        dragSourceType: Hn.ToolPanel,
        listItemDragStartEvent: "columnPanelItemDragStart",
        listItemDragEndEvent: "columnPanelItemDragEnd",
        eventSource: o,
        getCurrentDragValue: (s) => pQe(s),
        isMoveBlocked: (s) => Zu(e, t, L0(s)),
        getNumRows: (s) => s.getDisplayedColsList().length,
        moveItem: (s, i) => Gu(t, L0(s), i)
      })
    );
  }
  moveItems(e, t) {
    var C;
    const { gos: o, beans: n } = this, { modelItem: s } = e, { group: i, columnGroup: r, column: l, expanded: a } = s, c = L0(i ? r : l);
    if (Zu(o, n, c))
      return;
    const d = this.displayedColsList.indexOf(s), u = t ? -1 : 1;
    let h = 0;
    if (t) {
      const m = e.columnDepth > 0 && ((C = l.getParent()) == null ? void 0 : C.getChildren());
      m && m.length && l === m[0] && (h = -1);
    } else i && (h = a ? s.children.length : 0);
    const p = Math.min(Math.max(d + h + u, 0), this.displayedColsList.length - 1);
    this.skipRefocus = !0, Gu(n, c, {
      position: t ? "top" : "bottom",
      component: this.virtualList.getComponentAt(p)
    }), this.focusRowIfAlive(p - h).then(() => {
      this.skipRefocus = !1;
    });
  }
  createComponentFromItem(e, t) {
    const o = this.allowDragging;
    if (e.group) {
      const s = new R_(e, o, this.eventType, t);
      return this.createBean(s), s;
    }
    const n = new vQe(e, o, this.groupsExist, t);
    return this.createBean(n), n;
  }
  onColumnsChanged() {
    const e = this.params;
    this.hasLoadedInitialState || (this.hasLoadedInitialState = !0, this.isInitialState = !!e.initialState);
    const t = this.getExpandedStates(), o = this.colModel.isPivotMode();
    !e.suppressSyncLayoutWithGrid && !o ? this.buildTreeFromWhatGridIsDisplaying() : this.buildTreeFromProvidedColumnDefs(), this.setExpandedStates(t), this.markFilteredColumns(), this.flattenAndFilterModel(), this.isInitialState = !1;
  }
  getDisplayedColsList() {
    return this.displayedColsList;
  }
  getExpandedStates() {
    const e = {};
    if (this.isInitialState) {
      const { expandedGroupIds: t } = this.params.initialState;
      return t.forEach((o) => {
        e[o] = !0;
      }), e;
    }
    return this.allColsTree ? (this.forEachItem((t) => {
      if (!t.group)
        return;
      const o = t.columnGroup;
      o && (e[o.getId()] = t.expanded);
    }), e) : {};
  }
  setExpandedStates(e) {
    if (!this.allColsTree)
      return;
    const { isInitialState: t } = this;
    this.forEachItem((o) => {
      if (!o.group)
        return;
      const n = o.columnGroup;
      if (n) {
        const s = e[n.getId()];
        (s != null || t) && (o.expanded = !!s);
      }
    });
  }
  buildTreeFromWhatGridIsDisplaying() {
    eQe(this.colModel, this.setColumnLayout.bind(this));
  }
  setColumnLayout(e) {
    const t = XYe(this.colModel, e);
    this.buildListModel(t), this.groupsExist = e.some((o) => o && typeof o.children < "u"), this.markFilteredColumns(), this.flattenAndFilterModel();
  }
  buildTreeFromProvidedColumnDefs() {
    var t;
    const e = this.colModel;
    this.buildListModel(e.getColDefColTree()), this.groupsExist = !!((t = e.colDefCols) != null && t.treeDepth);
  }
  buildListModel(e) {
    const t = this.onColumnExpanded.bind(this), o = (l) => {
      l.addEventListener("expandedChanged", t);
      const a = l.removeEventListener.bind(l, "expandedChanged", t);
      this.destroyColumnItemFuncs.push(a);
    }, n = this.beans.colNames, s = (l, a, c) => {
      l.forEach((d) => {
        Lt(d) ? i(d, a, c) : r(d, a, c);
      });
    }, i = (l, a, c) => {
      const d = l.getColGroupDef();
      if (d && d.suppressColumnsToolPanel)
        return;
      if (l.isPadding()) {
        s(l.getChildren(), a, c);
        return;
      }
      const h = n.getDisplayNameForProvidedColumnGroup(null, l, "columnToolPanel"), p = new Bu(
        h,
        l,
        a,
        !0,
        this.expandGroupsByDefault
      );
      c.push(p), o(p), s(l.getChildren(), a + 1, p.children);
    }, r = (l, a, c) => {
      if (l.getColDef() && l.getColDef().suppressColumnsToolPanel)
        return;
      const u = n.getDisplayNameForColumn(l, "columnToolPanel");
      c.push(new Bu(u, l, a));
    };
    this.destroyColumnTree(), s(e, 0, this.allColsTree);
  }
  onColumnExpanded() {
    this.flattenAndFilterModel();
  }
  flattenAndFilterModel() {
    this.displayedColsList = [];
    const e = (n) => {
      n.passesFilter && (this.displayedColsList.push(n), n.group && n.expanded && n.children.forEach(e));
    }, t = this.virtualList;
    this.allColsTree.forEach(e), t.setModel(new mQe(this.displayedColsList));
    let o = null;
    this.skipRefocus || (o = t.getLastFocusedRow()), t.refresh(), o != null && this.focusRowIfAlive(o), this.notifyListeners(), this.refreshAriaLabel();
  }
  refreshAriaLabel() {
    const e = this.getLocaleTextFunc(), t = e("ariaColumnPanelList", "Column List"), o = e("columns", "Columns"), n = this.displayedColsList.length;
    ft(this.virtualList.getAriaElement(), `${t} ${n} ${o}`);
  }
  focusRowIfAlive(e) {
    return e === -1 ? Promise.resolve() : new Promise((t) => {
      window.setTimeout(() => {
        this.isAlive() && this.virtualList.focusRow(e), t();
      }, 0);
    });
  }
  forEachItem(e) {
    const t = (n) => {
      n.forEach((s) => {
        e(s), s.group && t(s.children);
      });
    }, o = this.allColsTree;
    o && t(o);
  }
  doSetExpandedAll(e) {
    this.forEachItem((t) => {
      t.group && (t.expanded = e);
    });
  }
  setGroupsExpanded(e, t) {
    if (!t) {
      this.doSetExpandedAll(e);
      return;
    }
    const o = [];
    this.forEachItem((s) => {
      if (!s.group)
        return;
      const i = s.columnGroup.getId();
      t.indexOf(i) >= 0 && (s.expanded = e, o.push(i));
    });
    const n = t.filter((s) => !o.includes(s));
    n.length > 0 && X(157, { unrecognisedGroupIds: n });
  }
  getExpandState() {
    let e = 0, t = 0;
    return this.forEachItem((o) => {
      o.group && (o.expanded ? e++ : t++);
    }), e > 0 && t > 0 ? 2 : t > 0 ? 1 : 0;
  }
  doSetSelectedAll(e) {
    x_(this.beans, this.allColsTree, e, this.eventType);
  }
  getSelectionState() {
    let e = 0, t = 0;
    const o = this.colModel.isPivotMode();
    if (this.forEachItem((n) => {
      if (n.group || !n.passesFilter)
        return;
      const s = n.column, i = s.getColDef();
      let r;
      if (o) {
        if (!s.isAllowPivot() && !s.isAllowRowGroup() && !s.isAllowValue())
          return;
        r = s.isValueActive() || s.isPivotActive() || s.isRowGroupActive();
      } else {
        if (i.lockVisible)
          return;
        r = s.isVisible();
      }
      r ? e++ : t++;
    }), !(e > 0 && t > 0))
      return !(e === 0 || t > 0);
  }
  setFilterText(e) {
    this.filterText = ue(e) ? e.toLowerCase() : null, this.markFilteredColumns(), this.flattenAndFilterModel();
  }
  markFilteredColumns() {
    const e = (o) => {
      if (!ue(this.filterText))
        return !0;
      const n = o.displayName;
      return n == null || n.toLowerCase().indexOf(this.filterText) !== -1;
    }, t = (o, n) => {
      let s = !1;
      if (o.group) {
        const r = e(o);
        o.children.forEach((l) => {
          const a = t(l, r || n);
          a && (s = a);
        });
      }
      const i = n || s ? !0 : e(o);
      return o.passesFilter = i, i;
    };
    this.allColsTree.forEach((o) => t(o, !1));
  }
  notifyListeners() {
    this.fireGroupExpandedEvent(), this.fireSelectionChangedEvent();
  }
  fireGroupExpandedEvent() {
    const e = this.getExpandState();
    this.dispatchLocalEvent({ type: "groupExpanded", state: e });
  }
  fireSelectionChangedEvent() {
    if (!this.allColsTree)
      return;
    const e = this.getSelectionState();
    this.dispatchLocalEvent({ type: "selectionChanged", state: e });
  }
  getExpandedGroups() {
    const e = [];
    return this.allColsTree && this.forEachItem((t) => {
      t.group && t.expanded && e.push(t.columnGroup.getId());
    }), e;
  }
}, bQe = {
  selector: "AG-PRIMARY-COLS-LIST",
  component: wQe
}, yQe = {
  tag: "div",
  cls: "ag-column-select",
  children: [
    { tag: "ag-primary-cols-header", ref: "primaryColsHeaderPanel" },
    { tag: "ag-primary-cols-list", ref: "primaryColsListPanel" }
  ]
}, F_ = class extends Re {
  constructor() {
    super(yQe, [QYe, bQe]), this.primaryColsHeaderPanel = J, this.primaryColsListPanel = J, this.registerCSS(UYe);
  }
  // we allow dragging in the toolPanel, but not when this component appears in the column menu
  init(e, t, o) {
    const { primaryColsHeaderPanel: n, primaryColsListPanel: s } = this;
    n.init(t);
    const i = t.suppressColumnFilter, r = t.suppressColumnSelectAll;
    t.suppressColumnExpandAll && i && r && n.setDisplayed(!1), this.addManagedListeners(s, {
      groupExpanded: (a) => {
        n.setExpandState(a.state), t.onStateUpdated();
      },
      selectionChanged: (a) => n.setSelectionState(a.state)
    }), s.init(t, e, o), this.addManagedListeners(n, {
      expandAll: s.doSetExpandedAll.bind(s, !0),
      collapseAll: s.doSetExpandedAll.bind(s, !1),
      selectAll: s.doSetSelectedAll.bind(s, !0),
      unselectAll: s.doSetSelectedAll.bind(s, !1),
      filterChanged: (a) => s.setFilterText(a.filterText)
    }), this.positionableFeature = this.createManagedBean(new wa(this.getGui(), { minHeight: 100 }));
  }
  toggleResizable(e) {
    this.positionableFeature.setResizable(e ? { bottom: !0 } : !1);
  }
  expandGroups(e) {
    this.primaryColsListPanel.setGroupsExpanded(!0, e);
  }
  collapseGroups(e) {
    this.primaryColsListPanel.setGroupsExpanded(!1, e);
  }
  setColumnLayout(e) {
    this.primaryColsListPanel.setColumnLayout(e);
  }
  syncLayoutWithGrid() {
    this.primaryColsListPanel.onColumnsChanged();
  }
  getExpandedGroups() {
    return this.primaryColsListPanel.getExpandedGroups();
  }
}, _Qe = (
  /*css*/
  ".ag-column-panel{display:flex;flex:1 1 auto;flex-direction:column;overflow:hidden}.ag-pivot-mode-panel{display:flex;height:var(--ag-header-height)}.ag-pivot-mode-select{align-items:center;display:flex}:where(.ag-ltr) .ag-pivot-mode-select{margin-left:var(--ag-widget-container-horizontal-padding)}:where(.ag-rtl) .ag-pivot-mode-select{margin-right:var(--ag-widget-container-horizontal-padding)}.ag-column-panel-column-select{border-bottom:var(--ag-tool-panel-separator-border)}.ag-column-panel-column-select:where(:nth-child(n+2 of :not(.ag-hidden))){border-top:var(--ag-tool-panel-separator-border)}:where(.ag-column-panel) .ag-column-drop-vertical{flex:1 1 0px;min-height:50px;&:where(:not(.ag-last-column-drop)){border-bottom:var(--ag-tool-panel-separator-border)}}"
), SQe = class extends Re {
  constructor() {
    super({ tag: "div", cls: "ag-column-panel" }), this.initialised = !1, this.childDestroyFuncs = [], this.registerCSS(_Qe);
  }
  wireBeans(e) {
    this.colToolPanelFactory = e.colToolPanelFactory;
  }
  // lazy initialise the panel
  setVisible(e) {
    super.setDisplayed(e), e && !this.initialised && this.init(this.params);
  }
  init(e) {
    const o = {
      ...Pe(this.gos, {
        suppressColumnMove: !1,
        suppressColumnSelectAll: !1,
        suppressColumnFilter: !1,
        suppressColumnExpandAll: !1,
        contractColumnSelection: !1,
        suppressPivotMode: !1,
        suppressRowGroups: !1,
        suppressValues: !1,
        suppressPivots: !1,
        suppressSyncLayoutWithGrid: !1
      }),
      ...e
    };
    this.params = o;
    const { childDestroyFuncs: n, colToolPanelFactory: s, gos: i } = this, r = i.isModuleRegistered("SharedPivot"), l = r || i.isModuleRegistered("SharedRowGrouping");
    !o.suppressPivotMode && s && r && (this.pivotModePanel = s.createPivotModePanel(this, n));
    const a = this.createBean(new F_());
    if (this.primaryColsPanel = a, n.push(() => this.destroyBean(this.primaryColsPanel)), a.init(!0, o, "toolPanelUi"), a.addCss("ag-column-panel-column-select"), this.appendChild(a), s) {
      !o.suppressRowGroups && l && (this.rowGroupDropZonePanel = s.createRowGroupPanel(this, n)), !o.suppressValues && l && (this.valuesDropZonePanel = s.createValuesPanel(this, n)), !o.suppressPivots && r && (this.pivotDropZonePanel = s.createPivotPanel(this, n)), this.setLastVisible();
      const [c] = this.addManagedEventListeners({
        columnPivotModeChanged: () => {
          this.resetChildrenHeight(), this.setLastVisible();
        }
      });
      n.push(() => c());
    }
    this.initialised = !0;
  }
  setPivotModeSectionVisible(e) {
    const t = this.colToolPanelFactory;
    t && (this.pivotModePanel = t.setPanelVisible(
      this.pivotModePanel,
      e,
      t.createPivotModePanel.bind(t, this, this.childDestroyFuncs, !0)
    ), this.setLastVisible());
  }
  setRowGroupsSectionVisible(e) {
    const t = this.colToolPanelFactory;
    t && (this.rowGroupDropZonePanel = t.setPanelVisible(
      this.rowGroupDropZonePanel,
      e,
      t.createRowGroupPanel.bind(t, this, this.childDestroyFuncs)
    ), this.setLastVisible());
  }
  setValuesSectionVisible(e) {
    const t = this.colToolPanelFactory;
    t && (this.valuesDropZonePanel = t.setPanelVisible(
      this.valuesDropZonePanel,
      e,
      t.createValuesPanel.bind(t, this, this.childDestroyFuncs)
    ), this.setLastVisible());
  }
  setPivotSectionVisible(e) {
    var o;
    const t = this.colToolPanelFactory;
    t && (this.pivotDropZonePanel = t.setPanelVisible(
      this.pivotDropZonePanel,
      e,
      t.createPivotPanel.bind(t, this, this.childDestroyFuncs)
    ), (o = this.pivotDropZonePanel) == null || o.setDisplayed(e), this.setLastVisible());
  }
  setResizers() {
    [this.primaryColsPanel, this.rowGroupDropZonePanel, this.valuesDropZonePanel, this.pivotDropZonePanel].forEach(
      (e) => {
        if (!e)
          return;
        const t = e.getGui();
        e.toggleResizable(
          !t.classList.contains("ag-last-column-drop") && !t.classList.contains("ag-hidden")
        );
      }
    );
  }
  setLastVisible() {
    const e = this.getGui();
    Array.prototype.slice.call(e.querySelectorAll(".ag-column-drop")).forEach((s) => s.classList.remove("ag-last-column-drop"));
    const o = e.querySelectorAll(".ag-column-drop:not(.ag-hidden)"), n = Ke(o);
    n && n.classList.add("ag-last-column-drop"), this.setResizers();
  }
  resetChildrenHeight() {
    const t = this.getGui().children;
    for (let o = 0; o < t.length; o++) {
      const { style: n } = t[o];
      n.removeProperty("height"), n.removeProperty("flex");
    }
  }
  expandColumnGroups(e) {
    this.primaryColsPanel.expandGroups(e);
  }
  collapseColumnGroups(e) {
    this.primaryColsPanel.collapseGroups(e);
  }
  setColumnLayout(e) {
    this.primaryColsPanel.setColumnLayout(e);
  }
  syncLayoutWithGrid() {
    this.primaryColsPanel.syncLayoutWithGrid();
  }
  destroyChildren() {
    const e = this.childDestroyFuncs;
    e.forEach((t) => t()), e.length = 0, it(this.getGui());
  }
  refresh(e) {
    return this.destroyChildren(), this.init(e), !0;
  }
  getState() {
    return {
      expandedGroupIds: this.primaryColsPanel.getExpandedGroups()
    };
  }
  destroy() {
    this.destroyChildren(), super.destroy();
  }
}, xQe = (
  /*css*/
  ".ag-column-drop{align-items:center;display:inline-flex;overflow:auto;position:relative;width:100%}.ag-column-drop-list{align-items:center;display:flex}.ag-column-drop-cell{align-items:center;background-color:var(--ag-column-drop-cell-background-color);border:var(--ag-column-drop-cell-border);border-radius:500px;color:var(--ag-column-drop-cell-text-color);display:flex;padding:calc(var(--ag-spacing)*.25);position:relative;&:focus-visible{box-shadow:var(--ag-focus-shadow)}:where(.ag-drag-handle){color:var(--ag-column-drop-cell-drag-handle-color)}}:where(.ag-ltr) .ag-column-drop-cell{padding-left:calc(var(--ag-spacing)*.75)}:where(.ag-rtl) .ag-column-drop-cell{padding-right:calc(var(--ag-spacing)*.75)}.ag-column-drop-cell-text{flex:1 1 auto;margin:0 var(--ag-spacing);overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ag-column-drop-vertical{align-items:stretch;display:flex;flex-direction:column;min-height:75px;overflow:hidden}.ag-column-drop-vertical-title-bar{align-items:center;display:flex;flex:none;padding:var(--ag-widget-container-vertical-padding) calc(var(--ag-spacing)*2) 0}.ag-column-drop-vertical-list{align-items:stretch;flex-direction:column;flex-grow:1;overflow-x:auto;padding-bottom:var(--ag-spacing);padding-left:var(--ag-spacing);padding-right:var(--ag-spacing);position:relative;>*{flex:none}}:where(.ag-column-drop-empty) .ag-column-drop-vertical-list{overflow:hidden}.ag-column-drop-cell-button{cursor:pointer;min-width:0;opacity:.75;&:hover{opacity:1}}:where(.ag-ltr) .ag-column-drop-cell-button{margin-right:calc(var(--ag-spacing)/4)}:where(.ag-rtl) .ag-column-drop-cell-button{margin-left:calc(var(--ag-spacing)/4)}:where(.ag-ltr) .ag-column-drop-cell-drag-handle{margin-left:calc(var(--ag-spacing)/4)}:where(.ag-rtl) .ag-column-drop-cell-drag-handle{margin-right:calc(var(--ag-spacing)/4)}.ag-column-drop-wrapper{display:flex}.ag-column-drop-horizontal-half-width{width:50%!important}.ag-column-drop-cell-ghost{opacity:.5}.ag-column-drop-horizontal{background-color:var(--ag-header-background-color);border-bottom:var(--ag-header-row-border);gap:var(--ag-cell-widget-spacing);height:var(--ag-header-height);overflow:hidden;white-space:nowrap}:where(.ag-ltr) .ag-column-drop-horizontal{padding-left:var(--ag-cell-horizontal-padding)}:where(.ag-rtl) .ag-column-drop-horizontal{padding-right:var(--ag-cell-horizontal-padding)}.ag-column-drop-horizontal-list{gap:var(--ag-cell-widget-spacing)}.ag-column-drop-vertical-cell{margin-top:var(--ag-spacing)}:where(.ag-ltr) .ag-column-drop-vertical-icon{margin-right:var(--ag-widget-horizontal-spacing)}:where(.ag-rtl) .ag-column-drop-vertical-icon{margin-left:var(--ag-widget-horizontal-spacing)}.ag-select-agg-func-popup{background:var(--ag-background-color);border:solid var(--ag-border-width) var(--ag-border-color);border-radius:var(--ag-border-radius);box-shadow:var(--ag-dropdown-shadow);height:calc(var(--ag-spacing)*5*3.5);padding:0;position:absolute}.ag-select-agg-func-virtual-list-item{cursor:default;&:hover{background-color:var(--ag-selected-row-background-color)}}:where(.ag-ltr) .ag-select-agg-func-virtual-list-item{padding-left:calc(var(--ag-spacing)*2)}:where(.ag-rtl) .ag-select-agg-func-virtual-list-item{padding-right:calc(var(--ag-spacing)*2)}:where(.ag-ltr) .ag-column-drop-horizontal-half-width:where(:not(:last-child)){border-right:solid var(--ag-border-width) var(--ag-border-color)}:where(.ag-rtl) .ag-column-drop-horizontal-half-width:where(:not(:last-child)){border-left:solid var(--ag-border-width) var(--ag-border-color)}"
);
function Nu(e, t, o) {
  e == null || t == null || e.splice(o, 0, ...t);
}
var MQe = { tag: "div", cls: "ag-unselectable", role: "presentation" }, AQe = class extends Re {
  constructor(e) {
    super(MQe), this.horizontal = e, this.state = "notDragging", this.guiDestroyFunctions = [], this.childPillComponents = [], this.resizeEnabled = !1, this.addElementClasses(this.getGui()), this.ePillDropList = ze({ tag: "div" }), this.addElementClasses(this.ePillDropList, "list"), this.registerCSS(xQe);
  }
  toggleResizable(e) {
    this.positionableFeature.setResizable(e ? { bottom: !0 } : !1), this.resizeEnabled = e;
  }
  isSourceEventFromTarget(e) {
    const { dropZoneTarget: t, dragSource: o } = e;
    return t.contains(o.eElement);
  }
  destroy() {
    this.destroyGui(), super.destroy();
  }
  destroyGui() {
    this.guiDestroyFunctions.forEach((e) => e()), this.guiDestroyFunctions.length = 0, this.childPillComponents.length = 0, it(this.getGui()), it(this.ePillDropList);
  }
  init(e) {
    this.params = e ?? {}, this.createManagedBean(
      new gs(this.getFocusableElement(), {
        onTabKeyDown: this.onTabKeyDown.bind(this),
        handleKeyDown: this.onKeyDown.bind(this)
      })
    ), this.setupDropTarget(), this.positionableFeature = new wa(this.getGui()), this.createManagedBean(this.positionableFeature), this.refreshGui(), ft(this.ePillDropList, this.getAriaLabel());
  }
  onTabKeyDown(e) {
    const t = Fn(this.getFocusableElement(), null, !0), o = t.length;
    if (o === 0)
      return;
    const { shiftKey: n } = e, s = Ue(this.beans), i = s === t[0], r = s === Ke(t);
    o === 1 || i && n || r && !n || t[n ? 0 : o - 1].focus();
  }
  onKeyDown(e) {
    const { key: t } = e, o = !this.horizontal;
    let n = t === D.DOWN, s = t === D.UP;
    if (!o) {
      const i = this.gos.get("enableRtl");
      n = !i && t === D.RIGHT || i && t === D.LEFT, s = !i && t === D.LEFT || i && t === D.RIGHT;
    }
    if (!(!n && !s))
      if (e.preventDefault(), e.shiftKey)
        this.moveFocusedItem(s);
      else {
        const i = Yt(this.beans, this.getFocusableElement(), !1, s);
        i && i.focus();
      }
  }
  moveFocusedItem(e) {
    const t = this.getFocusedItem();
    if (t === -1)
      return;
    const o = e ? -1 : 1;
    if (!this.normalizeAndUpdateInsertIndex(t, t + o))
      return;
    const s = this.childPillComponents[t];
    if (!s.isMovable())
      return;
    const i = s.getItem();
    this.focusItemAtIndex(this.insertIndex), this.rearrangeItems([i], !0);
  }
  addElementClasses(e, t) {
    t = t ? `-${t}` : "";
    const o = this.horizontal ? "horizontal" : "vertical";
    e.classList.add(`ag-column-drop${t}`, `ag-column-drop-${o}${t}`);
  }
  setupDropTarget() {
    var e;
    this.dropTarget = {
      getContainer: this.getGui.bind(this),
      getIconName: this.getIconName.bind(this),
      onDragging: this.onDragging.bind(this),
      onDragEnter: this.onDragEnter.bind(this),
      onDragLeave: this.onDragLeave.bind(this),
      onDragStop: this.onDragStop.bind(this),
      onDragCancel: this.onDragCancel.bind(this),
      isInterestedIn: this.isInterestedIn.bind(this)
    }, (e = this.beans.dragAndDrop) == null || e.addDropTarget(this.dropTarget);
  }
  minimumAllowedNewInsertIndex() {
    return 0;
  }
  checkInsertIndex(e) {
    const t = this.getNewInsertIndex(e);
    return t < 0 ? !1 : this.normalizeAndUpdateInsertIndex(this.insertIndex, t);
  }
  normalizeAndUpdateInsertIndex(e, t) {
    const o = this.minimumAllowedNewInsertIndex(), n = Math.max(o, t), s = n !== e;
    return s && (this.insertIndex = n), s;
  }
  getNewInsertIndex(e) {
    const t = e.event, o = this.horizontal ? t.clientX : t.clientY, n = this.childPillComponents.map((i) => i.getGui().getBoundingClientRect()), s = n.findIndex(
      (i) => this.horizontal ? i.right > o && i.left < o : i.top < o && i.bottom > o
    );
    if (s === -1) {
      const i = this.gos.get("enableRtl");
      return n.every((a) => o > (this.horizontal ? a.right : a.bottom)) ? i && this.horizontal ? 0 : this.childPillComponents.length : n.every((a) => o < (this.horizontal ? a.left : a.top)) ? i && this.horizontal ? this.childPillComponents.length : 0 : this.insertIndex;
    }
    return this.insertIndex <= s ? s + 1 : s;
  }
  checkDragStartedBySelf(e) {
    this.state === "notDragging" && (this.state = "rearrangeItems", this.potentialDndItems = this.getItems(e.dragSource.getDragItem()), this.refreshGui(), this.checkInsertIndex(e), this.refreshGui());
  }
  onDragging(e) {
    this.checkDragStartedBySelf(e), this.checkInsertIndex(e) && this.refreshGui();
  }
  handleDragEnterEnd(e) {
  }
  onDragEnter(e) {
    const t = this.getItems(e.dragSource.getDragItem());
    this.state = "newItemsIn";
    const o = t.filter((s) => this.isItemDroppable(s, e)), n = o.every(
      (s) => this.childPillComponents.map((i) => i.getItem()).indexOf(s) !== -1
    );
    if (o.length !== 0) {
      if (this.potentialDndItems = o, n) {
        this.state = "notDragging";
        return;
      }
      this.handleDragEnterEnd(e), this.checkInsertIndex(e), this.refreshGui();
    }
  }
  isPotentialDndItems() {
    var e;
    return !!((e = this.potentialDndItems) != null && e.length);
  }
  handleDragLeaveEnd(e) {
  }
  onDragLeave(e) {
    if (this.state === "rearrangeItems") {
      const t = this.getItems(e.dragSource.getDragItem());
      this.removeItems(t);
    }
    this.isPotentialDndItems() && (this.handleDragLeaveEnd(e), this.potentialDndItems = [], this.refreshGui()), this.state = "notDragging";
  }
  onDragCancel(e) {
    this.isPotentialDndItems() && (this.state === "newItemsIn" && this.handleDragLeaveEnd(e), this.potentialDndItems = [], this.refreshGui()), this.state = "notDragging";
  }
  onDragStop() {
    this.isPotentialDndItems() && (this.state === "newItemsIn" ? this.addItems(this.potentialDndItems) : this.rearrangeItems(this.potentialDndItems), this.potentialDndItems = [], this.refreshGui()), this.state = "notDragging";
  }
  removeItems(e) {
    const t = this.getExistingItems().filter((o) => !e.includes(o));
    this.updateItems(t);
  }
  addItems(e) {
    if (!e)
      return;
    const t = this.getExistingItems().slice(), o = e.filter((n) => t.indexOf(n) < 0);
    Nu(t, o, this.insertIndex), this.updateItems(t);
  }
  addItem(e) {
    this.insertIndex = this.getExistingItems().length, this.addItems([e]), this.refreshGui();
  }
  rearrangeItems(e, t) {
    let o;
    return t ? o = this.getExistingItems().filter((n) => e.indexOf(n) === -1) : o = this.getNonGhostItems().slice(), Nu(o, e, this.insertIndex), No(o, this.getExistingItems()) ? !1 : (this.updateItems(o), !0);
  }
  refreshGui() {
    let e = 0;
    this.horizontal || (e = this.ePillDropList.scrollTop);
    const t = this.resizeEnabled, o = this.getFocusedItem(), { eGridDiv: n } = this.beans, s = pa();
    let i = null;
    s && (i = Yt(this.beans, n) ?? Yt(this.beans, n, !1, !0)), this.toggleResizable(!1), this.destroyGui(), this.addIconAndTitleToGui(), this.addEmptyMessageToGui(), this.addItemsToGui(), e !== 0 && (this.ePillDropList.scrollTop = e), t && this.toggleResizable(t), s && this.restoreFocus(o, i);
  }
  getFocusedItem() {
    const e = this.getGui(), t = Ue(this.beans);
    return e.contains(t) ? Array.from(e.querySelectorAll(".ag-column-drop-cell")).indexOf(t) : -1;
  }
  focusItemAtIndex(e) {
    const t = this.getGui(), n = Array.from(t.querySelectorAll(".ag-column-drop-cell"))[e];
    n && n.focus({ preventScroll: !0 });
  }
  restoreFocus(e, t) {
    const o = this.getGui(), n = Array.from(o.querySelectorAll(".ag-column-drop-cell"));
    if (e === -1)
      return;
    n.length === 0 && t.focus();
    const s = Math.min(n.length - 1, e), i = n[s];
    i && i.focus();
  }
  focusList(e) {
    const t = e ? this.childPillComponents.length - 1 : 0;
    this.restoreFocus(t, this.getFocusableElement());
  }
  getNonGhostItems() {
    const e = this.getExistingItems();
    return this.isPotentialDndItems() ? e.filter((t) => !this.potentialDndItems.includes(t)) : e;
  }
  addItemsToGui() {
    const t = this.getNonGhostItems().map((o) => this.createItemComponent(o, !1));
    if (this.isPotentialDndItems()) {
      const o = this.potentialDndItems.map((n) => this.createItemComponent(n, !0));
      this.insertIndex >= t.length ? t.push(...o) : t.splice(this.insertIndex, 0, ...o);
    }
    this.appendChild(this.ePillDropList), t.forEach((o, n) => {
      n > 0 && this.addArrow(this.ePillDropList), this.ePillDropList.appendChild(o.getGui());
    }), this.addAriaLabelsToComponents();
  }
  addAriaLabelsToComponents() {
    const { childPillComponents: e, ePillDropList: t } = this, o = e.length;
    no(t, o === 0 ? "presentation" : "listbox");
    for (let n = 0; n < o; n++) {
      const i = e[n].getGui();
      la(i, n + 1), ra(i, o);
    }
  }
  createItemComponent(e, t) {
    const o = this.createPillComponent(e, this.dropTarget, t, this.horizontal);
    return o.addEventListener("columnRemove", this.removeItems.bind(this, [e])), this.createBean(o), this.guiDestroyFunctions.push(() => this.destroyBean(o)), t || this.childPillComponents.push(o), o;
  }
  addIconAndTitleToGui() {
    const { title: e, icon: t } = this.params;
    if (!e || !t)
      return;
    const o = ze({ tag: "div" });
    if (f2(o, !0), this.addElementClasses(o, "title-bar"), this.addElementClasses(t, "icon"), this.toggleCss("ag-column-drop-empty", this.isExistingItemsEmpty()), o.appendChild(t), !this.horizontal) {
      const n = ze({ tag: "span" });
      this.addElementClasses(n, "title"), n.textContent = e, o.appendChild(n);
    }
    this.appendChild(o);
  }
  isExistingItemsEmpty() {
    return this.getExistingItems().length === 0;
  }
  addEmptyMessageToGui() {
    const { emptyMessage: e } = this.params;
    if (!e || !this.isExistingItemsEmpty() || this.isPotentialDndItems())
      return;
    const t = ze({ tag: "span" });
    t.textContent = e, this.addElementClasses(t, "empty-message"), this.ePillDropList.appendChild(t);
  }
  addArrow(e) {
    if (this.horizontal) {
      const t = this.gos.get("enableRtl"), o = Ie(t ? "panelDelimiterRtl" : "panelDelimiter", this.beans);
      this.addElementClasses(o, "cell-separator"), e.appendChild(o);
    }
  }
}, LQe = {
  tag: "span",
  role: "option",
  children: [
    {
      tag: "span",
      ref: "eDragHandle",
      cls: "ag-drag-handle ag-column-drop-cell-drag-handle",
      role: "presentation"
    },
    { tag: "span", ref: "eText", cls: "ag-column-drop-cell-text", attrs: { "aria-hidden": "true" } },
    { tag: "span", ref: "eButton", cls: "ag-column-drop-cell-button", role: "presentation" }
  ]
}, EQe = class extends Re {
  constructor(e, t, o, n, s) {
    super(), this.dragSourceDropTarget = e, this.ghost = t, this.horizontal = o, this.template = n, this.agComponents = s, this.eText = J, this.eDragHandle = J, this.eButton = J;
  }
  postConstruct() {
    this.setTemplate(this.template ?? LQe, this.agComponents);
    const e = this.getGui(), { beans: t, eDragHandle: o, eText: n, eButton: s } = this;
    this.addElementClasses(e), this.addElementClasses(o, "drag-handle"), this.addElementClasses(n, "text"), this.addElementClasses(s, "button"), o.appendChild(Ie("columnDrag", t)), s.appendChild(Ie("cancel", t)), this.tooltipFeature = this.createOptionalManagedBean(
      t.registry.createDynamicBean("tooltipFeature", !1, {
        getGui: () => this.getGui()
      })
    ), this.setupComponents(), !this.ghost && this.isDraggable() && this.addDragSource(), this.setupAria(), this.setupTooltip(), this.activateTabIndex(), this.refreshDraggable();
  }
  isDraggable() {
    return !0;
  }
  refreshDraggable() {
    this.eDragHandle.classList.toggle("ag-column-select-column-readonly", !this.isDraggable());
  }
  setupAria() {
    const e = this.getLocaleTextFunc(), t = [this.getAriaDisplayName()];
    this.addAdditionalAriaInstructions(t, e), ft(this.getGui(), t.join(". "));
  }
  addAdditionalAriaInstructions(e, t) {
    if (this.isRemovable()) {
      const o = t("ariaDropZoneColumnComponentDescription", "Press DELETE to remove");
      e.push(o);
    }
  }
  setupTooltip() {
    const e = () => {
      var t;
      return (t = this.tooltipFeature) == null ? void 0 : t.setTooltipAndRefresh(this.getTooltip());
    };
    e(), this.addManagedEventListeners({ newColumnsLoaded: e });
  }
  getDragSourceId() {
  }
  getDefaultIconName() {
    return "notAllowed";
  }
  addDragSource() {
    const {
      beans: { dragAndDrop: e },
      eDragHandle: t
    } = this, o = this.createGetDragItem(), n = this.getDefaultIconName(), s = {
      type: this.getDragSourceType(),
      sourceId: this.getDragSourceId(),
      eElement: t,
      getDefaultIconName: () => n,
      getDragItem: o,
      dragItemName: this.getDisplayName()
    };
    e == null || e.addDragSource(s, !0), this.addDestroyFunc(() => e == null ? void 0 : e.removeDragSource(s));
  }
  setupComponents() {
    this.eText.textContent = this.getDisplayValue(), this.setupRemove(), this.ghost && this.addCss("ag-column-drop-cell-ghost");
  }
  isRemovable() {
    return !0;
  }
  refreshRemove() {
    He(this.eButton, this.isRemovable());
  }
  setupRemove() {
    this.refreshRemove();
    const e = { type: "columnRemove" };
    this.addGuiEventListener("keydown", (o) => this.onKeyDown(o)), this.addManagedElementListeners(this.eButton, {
      click: (o) => {
        this.dispatchLocalEvent(e), o.stopPropagation();
      }
    });
    const t = new _n(this.eButton);
    this.addManagedListeners(t, {
      tap: () => this.dispatchLocalEvent(e)
    }), this.addDestroyFunc(t.destroy.bind(t));
  }
  onKeyDown(e) {
    e.key === D.DELETE && this.isRemovable() && (e.preventDefault(), this.dispatchLocalEvent({ type: "columnRemove" }));
  }
  getDisplayValue() {
    return this.getDisplayName();
  }
  addElementClasses(e, t) {
    t = t ? `-${t}` : "";
    const o = this.horizontal ? "horizontal" : "vertical";
    e.classList.add(`ag-column-drop-cell${t}`, `ag-column-drop-${o}-cell${t}`);
  }
  destroy() {
    super.destroy(), this.dragSourceDropTarget = null;
  }
}, PQe = class extends EQe {
  constructor(e, t, o, n, s) {
    super(t, o, s), this.column = e, this.dropZonePurpose = n, this.eSortIndicator = J, this.popupShowing = !1;
  }
  postConstruct() {
    const { sortSvc: e, colNames: t } = this.beans;
    this.template = {
      tag: "span",
      role: "option",
      children: [
        {
          tag: "span",
          ref: "eDragHandle",
          cls: "ag-drag-handle ag-column-drop-cell-drag-handle",
          role: "presentation"
        },
        { tag: "span", ref: "eText", cls: "ag-column-drop-cell-text", attrs: { "aria-hidden": "true" } },
        e ? { tag: "ag-sort-indicator", ref: "eSortIndicator" } : void 0,
        { tag: "span", ref: "eButton", cls: "ag-column-drop-cell-button", role: "presentation" }
      ]
    }, e && (this.agComponents = [e.getSortIndicatorSelector()]), this.displayName = t.getDisplayNameForColumn(this.column, "columnDrop"), super.postConstruct(), e && (this.setupSort(), this.addManagedEventListeners({
      sortChanged: () => {
        this.setupAria();
      }
    })), this.isGroupingZone() && this.addManagedPropertyListener("groupLockGroupColumns", () => {
      this.refreshRemove(), this.refreshDraggable(), this.setupAria();
    });
  }
  getItem() {
    return this.column;
  }
  getDisplayName() {
    return this.displayName;
  }
  getTooltip() {
    return this.column.getColDef().headerTooltip;
  }
  addAdditionalAriaInstructions(e, t) {
    const o = this.gos.get("rowGroupPanelSuppressSort"), n = this.gos.get("functionsReadOnly");
    if (this.isAggregationZone() && !n) {
      const s = t(
        "ariaDropZoneColumnValueItemDescription",
        "Press ENTER to change the aggregation type"
      );
      e.push(s);
    }
    if (this.isGroupingZone() && this.column.isSortable() && !o) {
      const s = t("ariaDropZoneColumnGroupItemDescription", "Press ENTER to sort");
      e.push(s);
    }
    super.addAdditionalAriaInstructions(e, t);
  }
  isMovable() {
    return this.isDraggable();
  }
  isDraggable() {
    return this.isReadOnly();
  }
  isRemovable() {
    return this.isReadOnly();
  }
  isReadOnly() {
    return !this.isGroupingAndLocked() && !this.gos.get("functionsReadOnly");
  }
  getAriaDisplayName() {
    const e = this.getLocaleTextFunc(), { name: t, aggFuncName: o } = this.getColumnAndAggFuncName(), n = e("ariaDropZoneColumnComponentAggFuncSeparator", " of "), s = {
      asc: e("ariaDropZoneColumnComponentSortAscending", "ascending"),
      desc: e("ariaDropZoneColumnComponentSortDescending", "descending")
    }, i = this.column.getSort(), r = this.gos.get("rowGroupPanelSuppressSort");
    return [
      o && `${o}${n}`,
      t,
      this.isGroupingZone() && !r && i && `, ${s[i]}`
    ].filter((l) => !!l).join("");
  }
  getColumnAndAggFuncName() {
    const e = this.displayName;
    let t = "";
    if (this.isAggregationZone()) {
      const o = this.column.getAggFunc(), n = typeof o == "string" ? o : "agg";
      t = this.getLocaleTextFunc()(n, n);
    }
    return { name: e, aggFuncName: t };
  }
  setupSort() {
    if (!(!this.column.isSortable() || !this.isGroupingZone()) && !this.gos.get("rowGroupPanelSuppressSort")) {
      this.eSortIndicator.setupSort(this.column, !0);
      const e = (t) => {
        t.preventDefault(), this.beans.sortSvc.progressSortFromEvent(this.column, t);
      };
      this.addGuiEventListener("click", e), this.addGuiEventListener("keydown", (t) => {
        t.key === D.ENTER && this.isGroupingZone() && e(t);
      });
    }
  }
  getDefaultIconName() {
    return "hide";
  }
  createGetDragItem() {
    const { column: e } = this;
    return () => {
      const t = {};
      return t[e.getId()] = e.isVisible(), {
        columns: [e],
        visibleState: t
      };
    };
  }
  setupComponents() {
    super.setupComponents(), this.isAggregationZone() && !this.gos.get("functionsReadOnly") && this.addGuiEventListener("click", this.onShowAggFuncSelection.bind(this));
  }
  onKeyDown(e) {
    super.onKeyDown(e), e.key === D.ENTER && this.isAggregationZone() && !this.gos.get("functionsReadOnly") && (e.preventDefault(), this.onShowAggFuncSelection());
  }
  getDisplayValue() {
    const { name: e, aggFuncName: t } = this.getColumnAndAggFuncName();
    return this.isAggregationZone() ? `${t}(${e})` : e;
  }
  onShowAggFuncSelection() {
    if (this.popupShowing)
      return;
    this.popupShowing = !0;
    const { aggFuncSvc: e, popupSvc: t } = this.beans, o = new nr({ cssIdentifier: "select-agg-func" }), n = e.getFuncNames(this.column), s = this.getGui(), i = o.getGui();
    o.setModel({
      getRow: function(h) {
        return n[h];
      },
      getRowCount: function() {
        return n.length;
      }
    }), this.createBean(o);
    const r = ze({ tag: "div", cls: "ag-select-agg-func-popup" });
    r.style.top = "0px", r.style.left = "0px", r.appendChild(i), r.style.width = `${s.clientWidth}px`;
    const [l] = this.addManagedElementListeners(r, {
      focusout: (h) => {
        !r.contains(h.relatedTarget) && d && d.hideFunc();
      }
    }), a = (h) => {
      this.destroyBean(o), this.popupShowing = !1, (h == null ? void 0 : h.key) === "Escape" && s.focus(), l && l();
    }, c = this.getLocaleTextFunc(), d = t.addPopup({
      modal: !0,
      eChild: r,
      closeOnEsc: !0,
      closedCallback: a,
      ariaLabel: c("ariaLabelAggregationFunction", "Aggregation Function")
    });
    d && o.setComponentCreator(this.createAggSelect.bind(this, d.hideFunc)), o.addGuiEventListener("keydown", (h) => {
      if (h.key === D.ENTER || h.key === D.SPACE) {
        const p = o.getLastFocusedRow();
        if (p == null)
          return;
        const C = o.getComponentAt(p);
        C && C.selectItem();
      }
    }), t.positionPopupByComponent({
      type: "aggFuncSelect",
      eventSource: s,
      ePopup: r,
      keepWithinBounds: !0,
      column: this.column,
      position: "under"
    }), o.refresh();
    let u = n.findIndex((h) => h === this.column.getAggFunc());
    u === -1 && (u = 0), o.focusRow(u);
  }
  createAggSelect(e, t) {
    const o = () => {
      var l, a;
      e(), this.getGui().focus(), (a = (l = this.beans.valueColsSvc) == null ? void 0 : l.setColumnAggFunc) == null || a.call(l, this.column, t, "toolPanelDragAndDrop");
    }, n = this.getLocaleTextFunc(), s = t.toString(), i = n(s, s);
    return new RQe(o, i);
  }
  isGroupingAndLocked() {
    return this.isGroupingZone() && e1(this.column, this.beans);
  }
  isAggregationZone() {
    return this.dropZonePurpose === "aggregation";
  }
  isGroupingZone() {
    return this.dropZonePurpose === "rowGroup";
  }
  getDragSourceType() {
    return Hn.ToolPanel;
  }
  destroy() {
    super.destroy(), this.column = null;
  }
}, RQe = class extends Re {
  constructor(e, t) {
    super({ tag: "div", cls: "ag-select-agg-func-item", children: t }), this.selectItem = e, this.addGuiEventListener("click", this.selectItem);
  }
}, Cc = class extends AQe {
  constructor(e, t) {
    super(e), this.dropZonePurpose = t, this.addElementClasses(this.getGui(), this.dropZonePurpose.toLowerCase());
  }
  init(e) {
    super.init(e), this.addManagedEventListeners({ newColumnsLoaded: this.refreshGui.bind(this) }), this.addManagedPropertyListeners(
      ["functionsReadOnly", "rowGroupPanelSuppressSort", "groupLockGroupColumns"],
      this.refreshGui.bind(this)
    );
  }
  getItems(e) {
    return e.columns ?? [];
  }
  isInterestedIn(e) {
    return e === Hn.HeaderCell || e === Hn.ToolPanel;
  }
  minimumAllowedNewInsertIndex() {
    const { gos: e, rowGroupColsSvc: t } = this.beans, o = e.get("groupLockGroupColumns"), n = (t == null ? void 0 : t.columns.length) ?? 0;
    return o === -1 ? n : Math.min(o, n);
  }
  showOrHideColumnOnExit(e) {
    return this.isRowGroupPanel() && Pw(this.gos, !0) && !e.fromNudge;
  }
  handleDragEnterEnd(e) {
    if (this.showOrHideColumnOnExit(e)) {
      const n = e.dragSource.getDragItem().columns;
      this.setColumnsVisible(n, !1, "uiColumnDragged");
    }
  }
  handleDragLeaveEnd(e) {
    if (this.showOrHideColumnOnExit(e)) {
      const o = e.dragSource.getDragItem();
      this.setColumnsVisible(o.columns, !0, "uiColumnDragged");
    }
  }
  setColumnsVisible(e, t, o) {
    if (e) {
      const n = e.filter((s) => !s.getColDef().lockVisible);
      this.beans.colModel.setColsVisible(n, t, o);
    }
  }
  isRowGroupPanel() {
    return this.dropZonePurpose === "rowGroup";
  }
  createPillComponent(e, t, o, n) {
    return new PQe(e, t, o, this.dropZonePurpose, n);
  }
}, FQe = class extends Cc {
  constructor(e) {
    super(e, "pivot");
  }
  postConstruct() {
    const e = this.getLocaleTextFunc(), t = e("pivotColumnsEmptyMessage", "Drag here to set column labels"), o = e("pivots", "Column Labels");
    super.init({
      icon: Ie("pivotPanel", this.beans, null),
      emptyMessage: t,
      title: o
    }), this.addManagedEventListeners({
      newColumnsLoaded: this.refresh.bind(this),
      columnPivotChanged: this.refresh.bind(this),
      columnPivotModeChanged: this.checkVisibility.bind(this)
    }), this.refresh();
  }
  getAriaLabel() {
    return this.getLocaleTextFunc()("ariaPivotDropZonePanelLabel", "Column Labels");
  }
  refresh() {
    this.checkVisibility(), this.refreshGui();
  }
  checkVisibility() {
    const e = this.beans.colModel, t = e.isPivotMode();
    if (this.horizontal)
      switch (this.gos.get("pivotPanelShow")) {
        case "always":
          this.setDisplayed(t);
          break;
        case "onlyWhenPivoting": {
          const o = e.isPivotActive();
          this.setDisplayed(t && o);
          break;
        }
        default:
          this.setDisplayed(!1);
          break;
      }
    else
      this.setDisplayed(t);
  }
  isItemDroppable(e, t) {
    return this.gos.get("functionsReadOnly") || !e.isPrimary() ? !1 : e.isAllowPivot() && (!e.isPivotActive() || this.isSourceEventFromTarget(t));
  }
  updateItems(e) {
    var t;
    (t = this.beans.pivotColsSvc) == null || t.setColumns(e, "toolPanelUi");
  }
  getIconName() {
    return this.isPotentialDndItems() ? "pivot" : "notAllowed";
  }
  getExistingItems() {
    var e;
    return ((e = this.beans.pivotColsSvc) == null ? void 0 : e.columns) ?? [];
  }
}, TQe = class extends Cc {
  constructor(e) {
    super(e, "rowGroup");
  }
  postConstruct() {
    const e = this.getLocaleTextFunc(), t = e("rowGroupColumnsEmptyMessage", "Drag here to set row groups"), o = e("groups", "Row Groups");
    super.init({
      icon: Ie("rowGroupPanel", this.beans, null),
      emptyMessage: t,
      title: o
    }), this.addManagedEventListeners({ columnRowGroupChanged: this.refreshGui.bind(this) });
  }
  getAriaLabel() {
    return this.getLocaleTextFunc()("ariaRowGroupDropZonePanelLabel", "Row Groups");
  }
  isItemDroppable(e, t) {
    return this.gos.get("functionsReadOnly") || !e.isPrimary() || e.colDef.showRowGroup ? !1 : e.isAllowRowGroup() && (!e.isRowGroupActive() || this.isSourceEventFromTarget(t));
  }
  updateItems(e) {
    var t;
    (t = this.beans.rowGroupColsSvc) == null || t.setColumns(e, "toolPanelUi");
  }
  getIconName() {
    return this.isPotentialDndItems() ? "group" : "notAllowed";
  }
  getExistingItems() {
    var e;
    return ((e = this.beans.rowGroupColsSvc) == null ? void 0 : e.columns) ?? [];
  }
}, IQe = class extends Cc {
  constructor(e) {
    super(e, "aggregation");
  }
  postConstruct() {
    const e = this.getLocaleTextFunc(), t = e("valueColumnsEmptyMessage", "Drag here to aggregate"), o = e("values", "Values");
    super.init({
      icon: Ie("valuePanel", this.beans, null),
      emptyMessage: t,
      title: o
    }), this.addManagedEventListeners({ columnValueChanged: this.refreshGui.bind(this) });
  }
  getAriaLabel() {
    return this.getLocaleTextFunc()("ariaValuesDropZonePanelLabel", "Values");
  }
  getIconName() {
    return this.isPotentialDndItems() ? "aggregate" : "notAllowed";
  }
  isItemDroppable(e, t) {
    return this.gos.get("functionsReadOnly") || !e.isPrimary() ? !1 : e.isAllowValue() && (!e.isValueActive() || this.isSourceEventFromTarget(t));
  }
  updateItems(e) {
    var t;
    (t = this.beans.valueColsSvc) == null || t.setColumns(e, "toolPanelUi");
  }
  getExistingItems() {
    var e;
    return ((e = this.beans.valueColsSvc) == null ? void 0 : e.columns) ?? [];
  }
}, DQe = {
  tag: "div",
  cls: "ag-pivot-mode-panel",
  children: [
    {
      tag: "ag-toggle-button",
      ref: "cbPivotMode",
      cls: "ag-pivot-mode-select"
    }
  ]
}, kQe = class extends Re {
  constructor() {
    super(...arguments), this.cbPivotMode = J;
  }
  postConstruct() {
    this.setTemplate(DQe, [tke]);
    const e = this.cbPivotMode, { colModel: t, ctrlsSvc: o, gos: n } = this.beans;
    e.setValue(t.isPivotMode());
    const s = this.getLocaleTextFunc();
    e.setLabel(s("pivotMode", "Pivot Mode"));
    const i = () => {
      const l = !!e.getValue();
      l !== t.isPivotMode() && (n.updateGridOptions({ options: { pivotMode: l }, source: "toolPanelUi" }), o.getHeaderRowContainerCtrls().forEach((a) => a.refresh()));
    }, r = () => {
      const l = t.isPivotMode();
      e.setValue(l);
    };
    this.addManagedListeners(e, { fieldValueChanged: i }), this.addManagedEventListeners({
      newColumnsLoaded: r,
      columnPivotModeChanged: r
    });
  }
}, HQe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "colToolPanelFactory";
  }
  setPanelVisible(e, t, o) {
    return e ? e.setDisplayed(t) : t && (e = o()), e;
  }
  createRowGroupPanel(e, t) {
    return this.createPanel(e, t, new TQe(!1));
  }
  createValuesPanel(e, t) {
    return this.createPanel(e, t, new IQe(!1));
  }
  createPivotPanel(e, t) {
    return this.createPanel(e, t, new FQe(!1));
  }
  createPivotModePanel(e, t, o) {
    return this.createPanel(e, t, new kQe(), o);
  }
  createPanel(e, t, o, n) {
    return o = e.createBean(o), t.push(() => e.destroyBean(o)), n ? e.prependChild(o) : e.appendChild(o), o;
  }
}, VQe = {
  moduleName: "ColumnsToolPanel",
  version: yt,
  beans: [HQe],
  userComponents: { agColumnsToolPanel: SQe },
  icons: {
    ensureColumnVisible: "column-arrow",
    // column tool panel tab
    columnsToolPanel: "columns",
    // "Group by {column-name}" item in column header menu
    menuAddRowGroup: "group",
    // "Un-Group by {column-name}" item in column header menu
    menuRemoveRowGroup: "group",
    // identifies the pivot drop zone
    pivotPanel: "pivot",
    // "Row groups" drop zone in column tool panel
    rowGroupPanel: "group",
    // columns tool panel Values drop zone
    valuePanel: "aggregation",
    // column tool panel column group contracted (click to expand)
    columnSelectClosed: "tree-closed",
    // column tool panel column group expanded (click to contract)
    columnSelectOpen: "tree-open",
    // column tool panel header expand/collapse all button, shown when some children are expanded and
    //     others are collapsed
    columnSelectIndeterminate: "tree-indeterminate"
  },
  dependsOn: [
    ko,
    NYe,
    tc,
    f1,
    li,
    __
  ]
}, OQe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "chartMenuItemMapper";
  }
  getChartItems(e) {
    var c, d;
    const t = this.beans, o = t.chartSvc, n = e === "pivotChart";
    if (!o)
      return null;
    const s = this.getLocaleTextFunc.bind(this), i = n ? new BQe(t, o, s) : new $Qe(t, o, s), r = o.isEnterprise();
    let l = i.getMenuItem();
    if (l && l.subMenu && !r) {
      const u = (h) => {
        var p;
        return {
          ...h,
          subMenu: (p = h.subMenu) == null ? void 0 : p.filter((C) => !C._enterprise).map((C) => u(C))
        };
      };
      l = u(l);
    }
    const a = (d = (c = this.gos.get("chartToolPanelsDef")) == null ? void 0 : c.settingsPanel) == null ? void 0 : d.chartGroupsDef;
    return a && (l = this.filterAndOrderChartMenu(
      l,
      a,
      i.getConfigLookup()
    )), this.cleanInternals(l);
  }
  // Remove our internal _key and _enterprise properties so this does not leak out of the class on the menu items.
  cleanInternals(e) {
    if (!e)
      return e;
    const t = (o) => {
      var n;
      return o == null || delete o._key, o == null || delete o._enterprise, (n = o == null ? void 0 : o.subMenu) == null || n.forEach((s) => t(s)), o;
    };
    return t(e);
  }
  buildLookup(e) {
    const t = {}, o = (n) => {
      t[n._key] = n, n.subMenu && n.subMenu.forEach((s) => o(s));
    };
    return o(e), t;
  }
  /**
   * Make the MenuItem match the charts provided and their ordering on the ChartGroupsDef config object as provided by the user.
   */
  filterAndOrderChartMenu(e, t, o) {
    var i, r, l;
    const n = this.buildLookup(e), s = { ...e, subMenu: [] };
    for (const a of Object.keys(t)) {
      const c = t[a], d = o[a];
      if (d === null)
        continue;
      if (d == null) {
        X(173, { group: a });
        continue;
      }
      const u = n[d._key];
      if (u)
        if (u.subMenu) {
          const h = c.map((p) => {
            const C = d[p];
            if (C == null) {
              X(174, { group: a, chartType: p });
              return;
            }
            return n[C];
          }).filter((p) => p !== void 0);
          h.length > 0 && (u.subMenu = h, (i = s.subMenu) == null || i.push(u));
        } else
          (r = s.subMenu) == null || r.push(u);
    }
    return ((l = s.subMenu) == null ? void 0 : l.length) == 0 ? null : s;
  }
}, BQe = class {
  constructor(e, t, o) {
    this.beans = e, this.chartSvc = t, this.getLocaleTextFunc = o;
  }
  getMenuItem() {
    const e = this.getLocaleTextFunc(), t = (o, n, s, i, r = !1) => ({
      // will have a LRM character appended to ensure correct display in RTL languages
      name: e(o, n + "‎"),
      action: () => this.chartSvc.createPivotChart({ chartType: s }),
      _key: i,
      _enterprise: r
    });
    return {
      name: e("pivotChart", "Pivot Chart"),
      _key: "pivotChart",
      subMenu: [
        {
          _key: "pivotColumnChart",
          name: e("columnChart", "Column"),
          subMenu: [
            t("groupedColumn", "Grouped", "groupedColumn", "pivotGroupedColumn"),
            t("stackedColumn", "Stacked", "stackedColumn", "pivotStackedColumn"),
            t("normalizedColumn", "100% Stacked", "normalizedColumn", "pivotNormalizedColumn")
          ]
        },
        {
          _key: "pivotBarChart",
          name: e("barChart", "Bar"),
          subMenu: [
            t("groupedBar", "Grouped", "groupedBar", "pivotGroupedBar"),
            t("stackedBar", "Stacked", "stackedBar", "pivotStackedBar"),
            t("normalizedBar", "100% Stacked", "normalizedBar", "pivotNormalizedBar")
          ]
        },
        {
          _key: "pivotPieChart",
          name: e("pieChart", "Pie"),
          subMenu: [
            t("pie", "Pie", "pie", "pivotPie"),
            t("donut", "Donut", "donut", "pivotDonut")
          ]
        },
        {
          _key: "pivotLineChart",
          name: e("lineChart", "Line"),
          subMenu: [
            t("lineChart", "Line", "line", "pivotLineChart"),
            t("stackedLine", "Stacked", "stackedLine", "pivotStackedLine"),
            t("normalizedLine", "100% Stacked", "normalizedLine", "pivotNormalizedLine")
          ]
        },
        {
          _key: "pivotAreaChart",
          name: e("areaChart", "Area"),
          subMenu: [
            t("areaChart", "Area", "area", "pivotArea"),
            t("stackedArea", "Stacked", "stackedArea", "pivotStackedArea"),
            t("normalizedArea", "100% Stacked", "normalizedArea", "pivotNormalizedArea")
          ]
        },
        {
          _key: "pivotXYChart",
          name: e("xyChart", "X Y (Scatter)"),
          subMenu: [
            t("scatter", "Scatter", "scatter", "pivotScatter"),
            t("bubble", "Bubble", "bubble", "pivotBubble")
          ]
        },
        {
          _key: "pivotStatisticalChart",
          _enterprise: !1,
          // histogram chart is available in both community and enterprise distributions
          name: e("statisticalChart", "Statistical"),
          subMenu: [t("histogramChart", "Histogram", "histogram", "pivotHistogram", !1)]
        },
        {
          _key: "pivotHierarchicalChart",
          _enterprise: !0,
          name: e("hierarchicalChart", "Hierarchical"),
          subMenu: [
            t("treemapChart", "Treemap", "treemap", "pivotTreemap", !0),
            t("sunburstChart", "Sunburst", "sunburst", "pivotSunburst", !0)
          ]
        },
        {
          _key: "pivotFunnel",
          name: e("funnel", "Funnel"),
          subMenu: [
            t("funnel", "Funnel", "funnel", "pivotFunnel"),
            t("coneFunnel", "Cone Funnel", "coneFunnel", "pivotConeFunnel"),
            t("pyramid", "Pyramid", "pyramid", "pivotPyramid")
          ]
        },
        {
          _key: "pivotCombinationChart",
          name: e("combinationChart", "Combination"),
          subMenu: [
            t("columnLineCombo", "Column & Line", "columnLineCombo", "pivotColumnLineCombo"),
            t("AreaColumnCombo", "Area & Column", "areaColumnCombo", "pivotAreaColumnCombo")
          ]
        }
      ],
      icon: Ie("chart", this.beans, void 0)
    };
  }
  getConfigLookup() {
    return {
      columnGroup: {
        _key: "pivotColumnChart",
        column: "pivotGroupedColumn",
        stackedColumn: "pivotStackedColumn",
        normalizedColumn: "pivotNormalizedColumn"
      },
      barGroup: {
        _key: "pivotBarChart",
        bar: "pivotGroupedBar",
        stackedBar: "pivotStackedBar",
        normalizedBar: "pivotNormalizedBar"
      },
      pieGroup: {
        _key: "pivotPieChart",
        pie: "pivotPie",
        donut: "pivotDonut",
        doughnut: "pivotDonut"
      },
      lineGroup: {
        _key: "pivotLineChart",
        line: "pivotLineChart",
        stackedLine: "pivotStackedLine",
        normalizedLine: "pivotNormalizedLine"
      },
      areaGroup: {
        _key: "pivotAreaChart",
        area: "pivotArea",
        stackedArea: "pivotStackedArea",
        normalizedArea: "pivotNormalizedArea"
      },
      scatterGroup: {
        _key: "pivotXYChart",
        bubble: "pivotBubble",
        scatter: "pivotScatter"
      },
      combinationGroup: {
        _key: "pivotCombinationChart",
        columnLineCombo: "pivotColumnLineCombo",
        areaColumnCombo: "pivotAreaColumnCombo",
        customCombo: null
        // Not currently supported
      },
      hierarchicalGroup: {
        _key: "pivotHierarchicalChart",
        treemap: "pivotTreemap",
        sunburst: "pivotSunburst"
      },
      statisticalGroup: {
        _key: "pivotStatisticalChart",
        histogram: "pivotHistogram",
        // Some statistical charts do not currently support pivot mode
        rangeBar: null,
        rangeArea: null,
        boxPlot: null
      },
      funnelGroup: {
        _key: "pivotFunnel",
        funnel: "pivotFunnel",
        coneFunnel: "pivotConeFunnel",
        pyramid: "pivotPyramid"
      },
      // Polar charts do not support pivot mode
      polarGroup: null,
      // Specialized charts do not currently support pivot mode
      specializedGroup: null
    };
  }
}, $Qe = class {
  constructor(e, t, o) {
    this.beans = e, this.chartSvc = t, this.getLocaleTextFunc = o;
  }
  getMenuItem() {
    const e = this.getLocaleTextFunc(), t = (o, n, s, i, r = !1) => ({
      name: e(o, n),
      action: () => this.chartSvc.createChartFromCurrentRange(s),
      _key: i,
      _enterprise: r
    });
    return {
      name: e("chartRange", "Chart Range"),
      _key: "chartRange",
      subMenu: [
        {
          name: e("columnChart", "Column"),
          subMenu: [
            t("groupedColumn", "Grouped", "groupedColumn", "rangeGroupedColumn"),
            t("stackedColumn", "Stacked", "stackedColumn", "rangeStackedColumn"),
            t("normalizedColumn", "100% Stacked", "normalizedColumn", "rangeNormalizedColumn")
          ],
          _key: "rangeColumnChart"
        },
        {
          name: e("barChart", "Bar"),
          subMenu: [
            t("groupedBar", "Grouped", "groupedBar", "rangeGroupedBar"),
            t("stackedBar", "Stacked", "stackedBar", "rangeStackedBar"),
            t("normalizedBar", "100% Stacked", "normalizedBar", "rangeNormalizedBar")
          ],
          _key: "rangeBarChart"
        },
        {
          name: e("pieChart", "Pie"),
          subMenu: [
            t("pie", "Pie", "pie", "rangePie"),
            t("donut", "Donut", "donut", "rangeDonut")
          ],
          _key: "rangePieChart"
        },
        {
          name: e("lineChart", "Line"),
          subMenu: [
            t("lineChart", "Line", "line", "rangeLineChart"),
            t("stackedLine", "Stacked", "stackedLine", "rangeStackedLine"),
            t("normalizedLine", "100% Stacked", "normalizedLine", "rangeNormalizedLine")
          ],
          _key: "rangeLineChart"
        },
        {
          name: e("areaChart", "Area"),
          subMenu: [
            t("areaChart", "Area", "area", "rangeArea"),
            t("stackedArea", "Stacked", "stackedArea", "rangeStackedArea"),
            t("normalizedArea", "100% Stacked", "normalizedArea", "rangeNormalizedArea")
          ],
          _key: "rangeAreaChart"
        },
        {
          name: e("xyChart", "X Y (Scatter)"),
          subMenu: [
            t("scatter", "Scatter", "scatter", "rangeScatter"),
            t("bubble", "Bubble", "bubble", "rangeBubble")
          ],
          _key: "rangeXYChart"
        },
        {
          name: e("polarChart", "Polar"),
          subMenu: [
            t("radarLine", "Radar Line", "radarLine", "rangeRadarLine"),
            t("radarArea", "Radar Area", "radarArea", "rangeRadarArea"),
            t("nightingale", "Nightingale", "nightingale", "rangeNightingale"),
            t("radialColumn", "Radial Column", "radialColumn", "rangeRadialColumn"),
            t("radialBar", "Radial Bar", "radialBar", "rangeRadialBar")
          ],
          _key: "rangePolarChart",
          _enterprise: !0
        },
        {
          name: e("statisticalChart", "Statistical"),
          subMenu: [
            t("boxPlot", "Box Plot", "boxPlot", "rangeBoxPlot", !0),
            t("histogramChart", "Histogram", "histogram", "rangeHistogram", !1),
            t("rangeBar", "Range Bar", "rangeBar", "rangeRangeBar", !0),
            t("rangeArea", "Range Area", "rangeArea", "rangeRangeArea", !0)
          ],
          _key: "rangeStatisticalChart",
          _enterprise: !1
          // histogram chart is available in both community and enterprise distributions
        },
        {
          name: e("hierarchicalChart", "Hierarchical"),
          subMenu: [
            t("treemap", "Treemap", "treemap", "rangeTreemap"),
            t("sunburst", "Sunburst", "sunburst", "rangeSunburst")
          ],
          _key: "rangeHierarchicalChart",
          _enterprise: !0
        },
        {
          name: e("specializedChart", "Specialized"),
          subMenu: [
            t("heatmap", "Heatmap", "heatmap", "rangeHeatmap"),
            t("waterfall", "Waterfall", "waterfall", "rangeWaterfall")
          ],
          _key: "rangeSpecializedChart",
          _enterprise: !0
        },
        {
          name: e("funnel", "Funnel"),
          subMenu: [
            t("funnel", "Funnel", "funnel", "rangeFunnel"),
            t("coneFunnel", "Cone Funnel", "coneFunnel", "rangeConeFunnel"),
            t("pyramid", "Pyramid", "pyramid", "rangePyramid")
          ],
          _key: "rangeFunnel",
          _enterprise: !0
        },
        {
          name: e("combinationChart", "Combination"),
          subMenu: [
            t("columnLineCombo", "Column & Line", "columnLineCombo", "rangeColumnLineCombo"),
            t("AreaColumnCombo", "Area & Column", "areaColumnCombo", "rangeAreaColumnCombo")
          ],
          _key: "rangeCombinationChart"
        }
      ],
      icon: Ie("chart", this.beans, void 0)
    };
  }
  getConfigLookup() {
    return {
      columnGroup: {
        _key: "rangeColumnChart",
        column: "rangeGroupedColumn",
        stackedColumn: "rangeStackedColumn",
        normalizedColumn: "rangeNormalizedColumn"
      },
      barGroup: {
        _key: "rangeBarChart",
        bar: "rangeGroupedBar",
        stackedBar: "rangeStackedBar",
        normalizedBar: "rangeNormalizedBar"
      },
      pieGroup: {
        _key: "rangePieChart",
        pie: "rangePie",
        donut: "rangeDonut",
        doughnut: "rangeDonut"
      },
      lineGroup: {
        _key: "rangeLineChart",
        line: "rangeLineChart",
        stackedLine: "rangeStackedLine",
        normalizedLine: "rangeNormalizedLine"
      },
      areaGroup: {
        _key: "rangeAreaChart",
        area: "rangeArea",
        stackedArea: "rangeStackedArea",
        normalizedArea: "rangeNormalizedArea"
      },
      scatterGroup: {
        _key: "rangeXYChart",
        bubble: "rangeBubble",
        scatter: "rangeScatter"
      },
      polarGroup: {
        _key: "rangePolarChart",
        radarLine: "rangeRadarLine",
        radarArea: "rangeRadarArea",
        nightingale: "rangeNightingale",
        radialColumn: "rangeRadialColumn",
        radialBar: "rangeRadialBar"
      },
      statisticalGroup: {
        _key: "rangeStatisticalChart",
        boxPlot: "rangeBoxPlot",
        histogram: "rangeHistogram",
        rangeBar: "rangeRangeBar",
        rangeArea: "rangeRangeArea"
      },
      hierarchicalGroup: {
        _key: "rangeHierarchicalChart",
        treemap: "rangeTreemap",
        sunburst: "rangeSunburst"
      },
      specializedGroup: {
        _key: "rangeSpecializedChart",
        heatmap: "rangeHeatmap",
        waterfall: "rangeWaterfall"
      },
      funnelGroup: {
        _key: "rangeFunnel",
        funnel: "rangeFunnel",
        coneFunnel: "rangeConeFunnel",
        pyramid: "rangePyramid"
      },
      combinationGroup: {
        _key: "rangeCombinationChart",
        columnLineCombo: "rangeColumnLineCombo",
        areaColumnCombo: "rangeAreaColumnCombo",
        customCombo: null
        // Not currently supported
      }
    };
  }
}, ZQe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "colChooserFactory";
  }
  createColumnSelectPanel(e, t, o, n) {
    const s = e.createManagedBean(new F_()), i = n ?? (t == null ? void 0 : t.getColDef().columnChooserParams) ?? {}, {
      contractColumnSelection: r,
      suppressColumnExpandAll: l,
      suppressColumnFilter: a,
      suppressColumnSelectAll: c,
      suppressSyncLayoutWithGrid: d,
      columnLayout: u
    } = i;
    return s.init(
      !!o,
      Pe(this.gos, {
        suppressColumnMove: !1,
        suppressValues: !1,
        suppressPivots: !1,
        suppressRowGroups: !1,
        suppressPivotMode: !1,
        contractColumnSelection: !!r,
        suppressColumnExpandAll: !!l,
        suppressColumnFilter: !!a,
        suppressColumnSelectAll: !!c,
        suppressSyncLayoutWithGrid: !!u || !!d,
        onStateUpdated: () => {
        }
      }),
      "columnMenu"
    ), u && s.setColumnLayout(u), s;
  }
  showColumnChooser({
    column: e,
    chooserParams: t,
    eventSource: o,
    headerPosition: n
  }) {
    this.hideActiveColumnChooser();
    const s = this.createColumnSelectPanel(this, e, !0, t), i = this.getLocaleTextFunc(), r = this.beans, { visibleCols: l, focusSvc: a, menuUtils: c } = r, d = l.allCols.indexOf(e), u = e ? a.focusedHeader ?? n ?? null : null;
    this.activeColumnChooserDialog = this.createBean(
      new c_({
        title: i("chooseColumns", "Choose Columns"),
        component: s,
        width: 300,
        height: 300,
        resizable: !0,
        movable: !0,
        centered: !0,
        closable: !0,
        afterGuiAttached: () => {
          var h;
          (h = Yt(r, s.getGui())) == null || h.focus({
            preventScroll: !0
          }), this.dispatchVisibleChangedEvent(!0, e);
        },
        closedCallback: (h) => {
          const p = this.activeColumnChooser.getGui();
          this.destroyBean(this.activeColumnChooser), this.activeColumnChooser = void 0, this.activeColumnChooserDialog = void 0, this.dispatchVisibleChangedEvent(!1, e), e && c.restoreFocusOnClose(
            { column: e, headerPosition: u, columnIndex: d, eventSource: o },
            p,
            h,
            !0
          );
        },
        postProcessPopupParams: {
          type: "columnChooser",
          column: e,
          eventSource: o
        }
      })
    ), this.activeColumnChooser = s;
  }
  hideActiveColumnChooser() {
    this.destroyBean(this.activeColumnChooserDialog);
  }
  dispatchVisibleChangedEvent(e, t) {
    this.eventSvc.dispatchEvent({
      type: "columnMenuVisibleChanged",
      visible: e,
      switchingTab: !1,
      key: "columnChooser",
      column: t ?? null
    });
  }
}, GQe = {
  pinSubMenu: "PinnedColumn",
  pinLeft: "PinnedColumn",
  pinRight: "PinnedColumn",
  clearPinned: "PinnedColumn",
  pinRowSubMenu: "PinnedRow",
  pinBottom: "PinnedRow",
  pinTop: "PinnedRow",
  unpinRow: "PinnedRow",
  valueAggSubMenu: "SharedAggregation",
  autoSizeThis: "ColumnAutoSize",
  autoSizeAll: "ColumnAutoSize",
  rowGroup: "SharedRowGrouping",
  rowUnGroup: "SharedRowGrouping",
  resetColumns: "CommunityCore",
  expandAll: ["ClientSideRowModelHierarchy", "ServerSideRowModel"],
  contractAll: ["ClientSideRowModelHierarchy", "ServerSideRowModel"],
  copy: "Clipboard",
  copyWithHeaders: "Clipboard",
  copyWithGroupHeaders: "Clipboard",
  cut: "Clipboard",
  paste: "Clipboard",
  export: ["CsvExport", "ExcelExport"],
  csvExport: "CsvExport",
  excelExport: "ExcelExport",
  separator: "CommunityCore",
  pivotChart: "IntegratedCharts",
  chartRange: "IntegratedCharts",
  columnFilter: "ColumnFilter",
  columnChooser: "ColumnMenu",
  sortAscending: "Sort",
  sortDescending: "Sort",
  sortUnSort: "Sort"
};
function NQe(e, t) {
  const o = GQe[t];
  o && e.assertModuleRegistered(o, `menu item '${t}'`);
}
var xs = "separator";
function T_(e, t) {
  if (e)
    for (let o = e.length - 2; o >= 0; o--) {
      const n = e[o] === t, s = e[o + 1] === t;
      n && s && e.splice(o + 1, 1);
    }
}
var zQe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "menuItemMapper";
  }
  mapWithStockItems(e, t, o, n, s) {
    if (!e)
      return [];
    const i = [], r = this.getLocaleTextFunc(), { beans: l, gos: a } = this, {
      pinnedCols: c,
      colAutosize: d,
      aggFuncSvc: u,
      rowGroupColsSvc: h,
      colNames: p,
      colModel: C,
      clipboardSvc: m,
      expansionSvc: w,
      focusSvc: y,
      csvCreator: b,
      excelCreator: _,
      menuSvc: M,
      colChooserFactory: x,
      sortSvc: L,
      chartMenuItemMapper: A,
      valueColsSvc: R,
      pinnedRowModel: P
    } = l, I = (B, H, O, N) => {
      var te;
      switch (NQe(a, B), B) {
        case "pinSubMenu":
          return c && H ? {
            name: r("pinColumn", "Pin Column"),
            icon: Ie("menuPin", l, null),
            subMenu: ["clearPinned", "pinLeft", "pinRight"]
          } : null;
        case "pinLeft":
          return c && H ? {
            name: r("pinLeft", "Pin Left"),
            action: () => c.setColsPinned([H], "left", N),
            checked: !!H && H.isPinnedLeft()
          } : null;
        case "pinRight":
          return c && H ? {
            name: r("pinRight", "Pin Right"),
            action: () => c.setColsPinned([H], "right", N),
            checked: !!H && H.isPinnedRight()
          } : null;
        case "clearPinned":
          return c && H ? {
            name: r("noPin", "No Pin"),
            action: () => c.setColsPinned([H], null, N),
            checked: !!H && !H.isPinned()
          } : null;
        case "pinRowSubMenu": {
          const E = a.get("enableRowPinning"), j = [], Z = (o == null ? void 0 : o.rowPinned) ?? ((te = o == null ? void 0 : o.pinnedSibling) == null ? void 0 : te.rowPinned);
          return Z && j.push("unpinRow"), E && E !== "bottom" && Z != "top" && j.push("pinTop"), E && E !== "top" && Z != "bottom" && j.push("pinBottom"), P != null && P.isManual() ? {
            name: r("pinRow", "Pin Row"),
            icon: Ie("rowPin", l, H),
            subMenu: j
          } : null;
        }
        case "pinTop":
          return P != null && P.isManual() ? {
            name: r("pinTop", "Pin to Top"),
            icon: Ie("rowPinTop", l, H),
            action: ({ node: E, column: j }) => E && P.pinRow(E, "top", j)
          } : null;
        case "pinBottom":
          return P != null && P.isManual() ? {
            name: r("pinBottom", "Pin to Bottom"),
            icon: Ie("rowPinBottom", l, H),
            action: ({ node: E, column: j }) => E && P.pinRow(E, "bottom", j)
          } : null;
        case "unpinRow":
          return P != null && P.isManual() ? {
            name: r("unpinRow", "Unpin Row"),
            icon: Ie("rowUnpin", l, H),
            action: ({ node: E, column: j }) => E && P.pinRow(E, null, j)
          } : null;
        case "valueAggSubMenu":
          return u && R && (H != null && H.isPrimary() || H != null && H.getColDef().pivotValueColumn) ? {
            name: r("valueAggregation", "Value Aggregation"),
            icon: Ie("menuValue", l, null),
            subMenu: jQe(H, u, R, r),
            disabled: a.get("functionsReadOnly")
          } : null;
        case "autoSizeThis":
          return d ? {
            name: r("autosizeThisColumn", "Autosize This Column"),
            action: () => d.autoSizeColumn(H, N, a.get("skipHeaderOnAutoSize"))
          } : null;
        case "autoSizeAll":
          return d ? {
            name: r("autosizeAllColumns", "Autosize All Columns"),
            action: () => d.autoSizeAllColumns({
              source: N,
              skipHeader: a.get("skipHeaderOnAutoSize")
            })
          } : null;
        case "rowGroup":
          return h ? {
            name: r("groupBy", "Group by") + " " + p.getDisplayNameForColumn(H, "header"),
            disabled: a.get("functionsReadOnly") || (H == null ? void 0 : H.isRowGroupActive()) || !(H != null && H.getColDef().enableRowGroup),
            action: () => h.addColumns([H], N),
            icon: Ie("menuAddRowGroup", l, null)
          } : null;
        case "rowUnGroup":
          if (h && a.isModuleRegistered("SharedRowGrouping")) {
            const E = H == null ? void 0 : H.getColDef().showRowGroup, j = a.get("groupLockGroupColumns");
            let Z, Y, le;
            if (E === !0)
              Z = r("ungroupAll", "Un-Group All"), Y = a.get("functionsReadOnly") || j === -1 || j >= (h.columns.length ?? 0), le = () => h.setColumns(h.columns.slice(0, j), N);
            else if (typeof E == "string") {
              const ge = C.getColDefCol(E), ce = ge != null ? p.getDisplayNameForColumn(ge, "header") : E;
              Z = r("ungroupBy", "Un-Group by") + " " + ce, Y = a.get("functionsReadOnly") || e1(ge, l), le = () => {
                h.removeColumns([E], N);
              };
            } else
              Z = r("ungroupBy", "Un-Group by") + " " + p.getDisplayNameForColumn(H, "header"), Y = a.get("functionsReadOnly") || !(H != null && H.isRowGroupActive()) || !(H != null && H.getColDef().enableRowGroup) || e1(H, l), le = () => h.removeColumns([H], N);
            return {
              name: Z,
              disabled: Y,
              action: le,
              icon: Ie("menuRemoveRowGroup", l, null)
            };
          } else
            return null;
        case "resetColumns":
          return {
            name: r("resetColumns", "Reset Columns"),
            action: () => zw(l, N)
          };
        case "expandAll":
          return w ? {
            name: r("expandAll", "Expand All Row Groups"),
            action: () => w.expandAll(!0)
          } : null;
        case "contractAll":
          return w ? {
            name: r("collapseAll", "Collapse All Row Groups"),
            action: () => w.expandAll(!1)
          } : null;
        case "copy":
          return m ? {
            name: r("copy", "Copy"),
            shortcut: r("ctrlC", "Ctrl+C"),
            icon: Ie("clipboardCopy", l, null),
            action: () => m.copyToClipboard()
          } : null;
        case "copyWithHeaders":
          return m ? {
            name: r("copyWithHeaders", "Copy with Headers"),
            // shortcut: localeTextFunc('ctrlC','Ctrl+C'),
            icon: Ie("clipboardCopy", l, null),
            action: () => m.copyToClipboard({ includeHeaders: !0 })
          } : null;
        case "copyWithGroupHeaders":
          return m ? {
            name: r("copyWithGroupHeaders", "Copy with Group Headers"),
            // shortcut: localeTextFunc('ctrlC','Ctrl+C'),
            icon: Ie("clipboardCopy", l, null),
            action: () => m.copyToClipboard({ includeHeaders: !0, includeGroupHeaders: !0 })
          } : null;
        case "cut":
          if (m) {
            const E = y.getFocusedCell(), j = E ? vn(l, E) : null, Z = j ? E == null ? void 0 : E.column.isCellEditable(j) : !1;
            return {
              name: r("cut", "Cut"),
              shortcut: r("ctrlX", "Ctrl+X"),
              icon: Ie("clipboardCut", l, null),
              disabled: !Z || a.get("suppressCutToClipboard"),
              action: () => m.cutToClipboard(void 0, "contextMenu")
            };
          } else
            return null;
        case "paste":
          if (m) {
            const E = a.get("suppressClipboardApi") || a.get("suppressClipboardPaste") || !H || !o || !H.isCellEditable(o) || H.isSuppressPaste(o);
            return {
              name: r("paste", "Paste"),
              shortcut: r("ctrlV", "Ctrl+V"),
              icon: Ie("clipboardPaste", l, null),
              disabled: E,
              action: () => m.pasteFromClipboard()
            };
          } else
            return null;
        case "export": {
          const E = [];
          return !a.get("suppressCsvExport") && b && E.push("csvExport"), !a.get("suppressExcelExport") && _ && E.push("excelExport"), E.length ? {
            name: r("export", "Export"),
            subMenu: E,
            icon: Ie("save", l, null)
          } : null;
        }
        case "csvExport":
          return b ? {
            name: r("csvExport", "CSV Export"),
            icon: Ie("csvExport", l, null),
            action: () => b.exportDataAsCsv()
          } : null;
        case "excelExport":
          return _ ? {
            name: r("excelExport", "Excel Export"),
            icon: Ie("excelExport", l, null),
            action: () => _.exportDataAsExcel()
          } : null;
        case "separator":
          return B;
        case "pivotChart":
        case "chartRange":
          return A.getChartItems(B);
        case "columnFilter":
          return M && H ? {
            name: r("columnFilter", "Column Filter"),
            icon: Ie("filter", l, null),
            action: () => M.showFilterMenu({
              column: H,
              buttonElement: O(),
              containerType: "columnFilter",
              positionBy: "button"
            })
          } : null;
        case "columnChooser": {
          const E = y.focusedHeader;
          return x ? {
            name: r("columnChooser", "Choose Columns"),
            icon: Ie("columns", l, null),
            action: () => x.showColumnChooser({
              column: H,
              eventSource: O(),
              headerPosition: E
            })
          } : null;
        }
        case "sortAscending":
          return L ? {
            name: r("sortAscending", "Sort Ascending"),
            icon: Ie("sortAscending", l, null),
            action: () => L.setSortForColumn(H, "asc", !1, N)
          } : null;
        case "sortDescending":
          return L ? {
            name: r("sortDescending", "Sort Descending"),
            icon: Ie("sortDescending", l, null),
            action: () => L.setSortForColumn(H, "desc", !1, N)
          } : null;
        case "sortUnSort":
          return L ? {
            name: r("sortUnSort", "Clear Sort"),
            icon: Ie("sortUnSort", l, null),
            action: () => L.setSortForColumn(H, null, !1, N)
          } : null;
        default:
          return X(176, { key: B }), null;
      }
    };
    return e.forEach((B) => {
      let H;
      if (typeof B == "string" ? H = I(B, t, n, s) : H = { ...B }, !H)
        return;
      const O = H, { subMenu: N } = O;
      N && N instanceof Array && (O.subMenu = this.mapWithStockItems(
        N,
        t,
        o,
        n,
        s
      )), H != null && i.push(H);
    }), T_(i, xs), i;
  }
};
function jQe(e, t, o, n) {
  let s;
  if (e.isPrimary())
    s = e;
  else {
    const r = e.getColDef().pivotValueColumn;
    s = ue(r) ? r : void 0;
  }
  const i = [];
  if (s) {
    const r = s.isValueActive(), l = t.getFuncNames(s);
    i.push({
      name: n("noAggregation", "None"),
      action: () => {
        o.removeColumns([s], "contextMenu"), o.setColumnAggFunc(s, void 0, "contextMenu");
      },
      checked: !r
    }), l.forEach((a) => {
      i.push({
        name: n(a, t.getDefaultFuncLabel(a)),
        action: () => {
          o.setColumnAggFunc(s, a, "contextMenu"), o.addColumns([s], "contextMenu");
        },
        checked: r && s.getAggFunc() === a
      });
    });
  }
  return i;
}
var WQe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "colMenuFactory";
  }
  createMenu(e, t, o, n) {
    const s = e.createManagedBean(
      new Ea(0, {
        column: o ?? null,
        node: null,
        value: null
      })
    ), i = this.beans.menuItemMapper.mapWithStockItems(
      t,
      o ?? null,
      null,
      n,
      "columnMenu"
    );
    return s.addMenuItems(i), s;
  }
  getMenuItems(e = null, t = null) {
    var i;
    const o = this.getDefaultMenuOptions(e);
    let n;
    const s = (i = (e == null ? void 0 : e.getColDef()) ?? (t == null ? void 0 : t.getColGroupDef())) == null ? void 0 : i.mainMenuItems;
    if (Array.isArray(s))
      n = s;
    else if (typeof s == "function")
      n = s(
        Pe(this.gos, {
          column: e,
          columnGroup: t,
          defaultItems: o
        })
      );
    else {
      const r = this.gos.getCallback("getMainMenuItems");
      r ? n = r({
        column: e,
        columnGroup: t,
        defaultItems: o
      }) : n = o;
    }
    return T_(n, xs), n;
  }
  getDefaultMenuOptions(e) {
    const t = [], { beans: o, gos: n } = this, {
      colChooserFactory: s,
      rowGroupColsSvc: i,
      colModel: r,
      expansionSvc: l,
      sortSvc: a,
      menuSvc: c,
      pinnedCols: d,
      aggFuncSvc: u,
      colAutosize: h
    } = o, p = $t(n), C = () => {
      !p && s && t.push("columnChooser"), t.push("resetColumns");
    };
    if (!e)
      return C(), t;
    const { colDef: m } = e, w = d && !m.lockPinned, y = (i == null ? void 0 : i.columns.length) ?? 0, b = y > 0, _ = e.isPrimary(), M = u && // if primary, then only allow aggValue if grouping and it's a value columns
    _ && b && e.isAllowValue() || // secondary columns can always have aggValue, as it means it's a pivot value column
    !_;
    if (a && !p && e.isSortable()) {
      const x = e.getSort();
      x !== "asc" && t.push("sortAscending"), x !== "desc" && t.push("sortDescending"), x && t.push("sortUnSort"), t.push(xs);
    }
    if (c != null && c.isFilterMenuItemEnabled(e) && (t.push("columnFilter"), t.push(xs)), w && t.push("pinSubMenu"), M && t.push("valueAggSubMenu"), (w || M) && t.push(xs), h && (t.push("autoSizeThis"), t.push("autoSizeAll"), t.push(xs)), i && n.isModuleRegistered("SharedRowGrouping")) {
      const x = t.length;
      m.showRowGroup ? t.push("rowUnGroup") : e.isAllowRowGroup() && _ && (e.isRowGroupActive() ? e1(e, o) || t.push("rowUnGroup") : t.push("rowGroup")), t.length > x && t.push(xs);
    }
    return C(), l && (dt(n) || n.get("ssrmExpandAllAffectsAllRows")) && (n.get("treeData") || y > (r.isPivotMode() ? 1 : 0)) && (t.push("expandAll"), t.push("contractAll")), t;
  }
}, UQe = "ag-menu", zu = "ag-context-menu-open", KQe = "ag-context-menu-loading-icon", qQe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "contextMenuSvc", this.destroyLoadingSpinner = null, this.lastPromise = 0;
  }
  hideActiveMenu() {
    this.destroyBean(this.activeMenu);
  }
  getMenuItems(e, t, o, n) {
    const s = [], { clipboardSvc: i, chartSvc: r, csvCreator: l, excelCreator: a, colModel: c, rangeSvc: d, gos: u } = this.beans;
    if (ue(e) && i && t && (u.get("suppressCutToClipboard") || s.push("cut"), s.push("copy", "copyWithHeaders", "copyWithGroupHeaders", "paste", "separator")), u.get("enableCharts") && r && (c.isPivotMode() && s.push("pivotChart"), d && !d.isEmpty() && s.push("chartRange")), ue(e)) {
      const m = u.get("enableRowPinning"), w = u.get("isRowPinnable");
      if (m) {
        const x = e.level > -1 && e.footer, L = e.level === -1 && e.footer, A = or(u);
        (L && !(A === "pinnedBottom" || A === "pinnedTop") || !L && !x) && ((w == null ? void 0 : w(e)) ?? !0) && s.push("pinRowSubMenu");
      }
      const y = u.get("suppressExcelExport") || !a, b = u.get("suppressCsvExport") || !l;
      !ss() && (!y || !b) && s.push("export");
    }
    const h = s.length ? s : void 0, p = t == null ? void 0 : t.getColDef().contextMenuItems;
    if (Array.isArray(p))
      return p;
    if (typeof p == "function")
      return p(
        Pe(u, {
          column: t,
          node: e,
          value: o,
          defaultItems: h,
          event: n
        })
      );
    const C = u.getCallback("getContextMenuItems");
    return (C == null ? void 0 : C({ column: t, node: e, value: o, defaultItems: h, event: n })) ?? s;
  }
  getContextMenuPosition(e, t) {
    const o = this.getRowCtrl(e), n = this.getCellGui(o, t);
    if (!n)
      return { x: 0, y: (o == null ? void 0 : o.getRowYPosition()) ?? 0 };
    const s = n.getBoundingClientRect();
    return {
      x: s.x + s.width / 2,
      y: s.y + s.height / 2
    };
  }
  showContextMenu(e) {
    const t = e.rowNode ?? null, o = e.column ?? null;
    let { anchorToElement: n, value: s, source: i } = e;
    t && o && s == null && (s = this.beans.valueSvc.getValueForDisplay(o, t).value), n == null && (n = this.getContextMenuAnchorElement(t, o)), this.beans.menuUtils.onContextMenu({
      mouseEvent: e.mouseEvent ?? null,
      touchEvent: e.touchEvent ?? null,
      showMenuCallback: (r) => this.showMenu(t, o, s, r, n),
      source: i
    });
  }
  handleContextMenuMouseEvent(e, t, o, n) {
    var u;
    const s = (n == null ? void 0 : n.rowNode) ?? (o == null ? void 0 : o.rowNode) ?? null, i = (n == null ? void 0 : n.column) ?? ((u = o == null ? void 0 : o.findFullWidthInfoForEvent(e || t)) == null ? void 0 : u.column) ?? null, { valueSvc: r, ctrlsSvc: l } = this.beans, a = i ? r.getValue(i, s) : null, c = l.getGridBodyCtrl(), d = n ? n.eGui : c.eGridBody;
    this.showContextMenu({
      mouseEvent: e,
      touchEvent: t,
      rowNode: s,
      column: i,
      value: a,
      anchorToElement: d,
      source: "ui"
    });
  }
  showMenu(e, t, o, n, s) {
    const i = this.getMenuItems(e, t, o, n);
    if (tDe(i)) {
      const r = this.lastPromise + 1;
      return this.lastPromise = r, this.destroyLoadingSpinner || this.createLoadingIcon(n), i.then((l) => {
        var u, h;
        if (this.lastPromise !== r)
          return;
        const { target: a } = n, c = !a;
        // check if there are actual menu items to be displayed
        l && l.length && // check if the element that triggered the context menu was removed from the DOM
        (c || ro(a)) && // overlay was displayed
        !((u = this.beans.overlays) != null && u.isExclusive()) && this.createContextMenu({ menuItems: l, node: e, column: t, value: o, mouseEvent: n, anchorToElement: s }), (h = this.destroyLoadingSpinner) == null || h.call(this);
      }), !0;
    }
    return i === void 0 || !(i != null && i.length) ? !1 : (this.createContextMenu({ menuItems: i, node: e, column: t, value: o, mouseEvent: n, anchorToElement: s }), !0);
  }
  createLoadingIcon(e) {
    var a;
    const { beans: t } = this, o = this.getLocaleTextFunc(), n = Ie("loadingMenuItems", t), s = ze({ tag: "div", cls: KQe });
    s.appendChild(n);
    const i = Ks(t), r = na(t);
    if (!r) {
      X(54);
      return;
    }
    r.appendChild(s), (a = t.ariaAnnounce) == null || a.announceValue(
      o("ariaLabelLoadingContextMenu", "Loading Context Menu"),
      "contextmenu"
    ), t.environment.applyThemeClasses(s), Y0(s, e, t);
    const l = (c) => {
      Y0(s, c, t);
    };
    i.addEventListener("mousemove", l), this.destroyLoadingSpinner = () => {
      i.removeEventListener("mousemove", l), r.removeChild(s), this.destroyLoadingSpinner = null;
    };
  }
  createContextMenu(e) {
    const { menuItems: t, node: o, column: n, value: s, mouseEvent: i, anchorToElement: r } = e, { ctrlsSvc: l, focusSvc: a, popupSvc: c } = this.beans, d = l.getGridBodyCtrl().eGridBody, u = new YQe(t, n, o, s);
    this.createBean(u);
    const h = u.getGui();
    n || a.clearFocusedCell();
    const p = {
      column: n,
      rowNode: o,
      type: "contextMenu",
      mouseEvent: i,
      ePopup: h,
      // move one pixel away so that accidentally double clicking
      // won't show the browser's contextmenu
      nudgeY: 1
    }, C = this.getLocaleTextFunc(), m = c == null ? void 0 : c.addPopup({
      modal: !0,
      eChild: h,
      closeOnEsc: !0,
      closedCallback: (y) => {
        La(this.beans, () => {
          d.classList.remove(zu), this.destroyBean(u), this.dispatchVisibleChangedEvent(!1, y === void 0 ? "api" : "ui");
        });
      },
      click: i,
      positionCallback: () => {
        const y = this.gos.get("enableRtl");
        c == null || c.positionPopupUnderMouseEvent({
          ...p,
          nudgeX: y ? (h.offsetWidth + 1) * -1 : 1
        });
      },
      // so when browser is scrolled down, or grid is scrolled, context menu stays with cell
      anchorToElement: r,
      ariaLabel: C("ariaLabelContextMenu", "Context Menu")
    });
    m && (d.classList.add(zu), u.afterGuiAttached({ container: "contextMenu", hidePopup: m.hideFunc })), this.activeMenu && this.hideActiveMenu(), this.activeMenu = u, u.addEventListener("destroyed", () => {
      this.activeMenu === u && (this.activeMenu = null);
    }), m && u.addEventListener(
      "closeMenu",
      (y) => m.hideFunc({
        mouseEvent: y.mouseEvent ?? void 0,
        keyboardEvent: y.keyboardEvent ?? void 0,
        forceHide: !0
      })
    );
    const w = i && i instanceof MouseEvent && i.type === "mousedown";
    this.dispatchVisibleChangedEvent(!0, w ? "api" : "ui");
  }
  dispatchVisibleChangedEvent(e, t = "ui") {
    this.eventSvc.dispatchEvent({
      type: "contextMenuVisibleChanged",
      visible: e,
      source: t
    });
  }
  getRowCtrl(e) {
    const { rowIndex: t, rowPinned: o } = e || {};
    if (t != null)
      return this.beans.rowRenderer.getRowByPosition({ rowIndex: t, rowPinned: o }) || void 0;
  }
  getCellGui(e, t) {
    if (!e || !t)
      return;
    const o = e.getCellCtrl(t);
    return (o == null ? void 0 : o.eGui) || void 0;
  }
  getContextMenuAnchorElement(e, t) {
    const o = this.beans.ctrlsSvc.getGridBodyCtrl().eGridBody, n = this.getRowCtrl(e);
    if (!n)
      return o;
    const s = this.getCellGui(n, t);
    return s || (n.isFullWidth() ? n.getFullWidthElement() : o);
  }
  destroy() {
    var e;
    (e = this.destroyLoadingSpinner) == null || e.call(this), super.destroy();
  }
}, YQe = class extends Re {
  constructor(e, t, o, n) {
    super({ tag: "div", cls: UQe, role: "presentation" }), this.menuItems = e, this.column = t, this.node = o, this.value = n, this.menuList = null, this.focusedCell = null;
  }
  postConstruct() {
    const e = this.createManagedBean(
      new Ea(0, {
        column: this.column,
        node: this.node,
        value: this.value
      })
    ), t = this.beans.menuItemMapper.mapWithStockItems(
      this.menuItems,
      this.column,
      this.node,
      () => this.getGui(),
      "contextMenu"
    );
    e.addMenuItems(t), this.appendChild(e), this.menuList = e, e.addEventListener("closeMenu", (o) => this.dispatchLocalEvent(o));
  }
  afterGuiAttached({ hidePopup: e }) {
    e && this.addDestroyFunc(e), this.focusedCell = this.beans.focusSvc.getFocusedCell();
    const t = this.menuList;
    t && La(this.beans, () => so(t.getGui()));
  }
  restoreFocusedCell() {
    const { beans: e, focusedCell: t } = this, o = e.focusSvc, n = o.getFocusedCell();
    if (n && t && ec(n, t)) {
      const { rowIndex: s, rowPinned: i, column: r } = t;
      Oi(e) && o.setFocusedCell({
        rowIndex: s,
        column: r,
        rowPinned: i,
        forceBrowserFocus: !0,
        preventScrollOnBrowserFocus: !pa()
      });
    }
  }
  destroy() {
    super.destroy(), this.restoreFocusedCell();
  }
};
function QQe(e) {
  return {
    tag: "div",
    cls: `ag-tabs ${e}`,
    children: [
      { tag: "div", ref: "eHeader" },
      {
        tag: "div",
        ref: "eBody",
        role: "presentation",
        cls: `ag-tabs-body ${e ? `${e}-body` : ""}`
      }
    ]
  };
}
var JQe = class extends ri {
  constructor(e) {
    super(QQe(e.cssClass)), this.eHeader = J, this.eBody = J, this.items = [], this.tabbedItemScrollMap = /* @__PURE__ */ new Map(), this.params = e;
  }
  postConstruct() {
    this.setupHeader(), this.params.items && this.params.items.forEach((e) => this.addItem(e)), this.initialiseTabGuard({
      onTabKeyDown: this.onTabKeyDown.bind(this),
      handleKeyDown: this.handleKeyDown.bind(this),
      focusInnerElement: this.focusInnerElement.bind(this),
      focusTrapActive: !0
    }), this.addDestroyFunc(() => {
      var e, t, o;
      return (o = (t = (e = this.activeItem) == null ? void 0 : e.tabbedItem) == null ? void 0 : t.afterDetachedCallback) == null ? void 0 : o.call(t);
    });
  }
  setupHeader() {
    const { enableCloseButton: e, cssClass: t } = this.params, o = (n, s) => {
      n.classList.add(`ag-tabs-${s}`), t && n.classList.add(`${t}-${s}`);
    };
    e ? (this.setupCloseButton(o), this.eTabHeader = ze({ tag: "div", role: "presentation" }), o(this.eHeader, "header-wrapper"), this.eHeader.appendChild(this.eTabHeader)) : this.eTabHeader = this.eHeader, no(this.eTabHeader, "tablist"), o(this.eTabHeader, "header");
  }
  setupCloseButton(e) {
    const t = ze({ tag: "button" });
    e(t, "close-button");
    const o = Ie("close", this.beans);
    ft(t, this.params.closeButtonAriaLabel), t.appendChild(o), this.addManagedElementListeners(t, { click: () => {
      var s, i;
      return (i = (s = this.params).onCloseClicked) == null ? void 0 : i.call(s);
    } });
    const n = ze({ tag: "div", role: "presentation" });
    e(n, "close-button-wrapper"), n.appendChild(t), this.eHeader.appendChild(n), this.eCloseButton = t;
  }
  handleKeyDown(e) {
    switch (e.key) {
      case D.RIGHT:
      case D.LEFT: {
        if (!this.eTabHeader.contains(Ue(this.beans)))
          return;
        const t = e.key === D.RIGHT, o = this.gos.get("enableRtl"), n = this.items.indexOf(this.activeItem), s = t !== o ? Math.min(n + 1, this.items.length - 1) : Math.max(n - 1, 0);
        if (n === s)
          return;
        e.preventDefault();
        const i = this.items[s];
        this.showItemWrapper(i), i.eHeaderButton.focus();
        break;
      }
      case D.UP:
      case D.DOWN:
        e.stopPropagation();
        break;
    }
  }
  onTabKeyDown(e) {
    var h, p, C, m;
    if (e.defaultPrevented)
      return;
    const { beans: t, eHeader: o, eBody: n, activeItem: s, params: i } = this, { suppressTrapFocus: r, enableCloseButton: l } = i, a = Ue(t), c = e.target, d = e.shiftKey;
    if (o.contains(a)) {
      e.preventDefault(), l && d && !((h = this.eCloseButton) != null && h.contains(a)) ? (p = this.eCloseButton) == null || p.focus() : r && d ? (C = R5(Pt(t).body, c)) == null || C.focus() : this.focusBody(e.shiftKey);
      return;
    }
    let u = null;
    if (C_(n, c) && (d && (u = R5(n, c)), !u && !r && (u = s.eHeaderButton)), !u && n.contains(a) && (u = Yt(t, n, !1, d), !u)) {
      r && !d ? this.forceFocusOutOfContainer(d) : l && !d ? (e.preventDefault(), (m = this.eCloseButton) == null || m.focus()) : (e.preventDefault(), this.focusHeader());
      return;
    }
    u && (e.preventDefault(), u.focus());
  }
  focusInnerElement(e) {
    return e ? this.focusBody(!0) : (this.focusHeader(), !0);
  }
  focusHeader(e) {
    this.activeItem.eHeaderButton.focus({ preventScroll: e });
  }
  focusBody(e) {
    return so(this.eBody, e);
  }
  setAfterAttachedParams(e) {
    this.afterAttachedParams = e;
  }
  showFirstItem() {
    this.items.length > 0 && this.showItemWrapper(this.items[0]);
  }
  addItem(e) {
    const t = ze({
      tag: "span",
      cls: "ag-tab",
      role: "tab",
      attrs: { tabindex: "-1" }
    });
    t.appendChild(e.title), this.eTabHeader.appendChild(t), ft(t, e.titleLabel);
    const o = {
      tabbedItem: e,
      eHeaderButton: t
    };
    this.items.push(o), t.addEventListener("click", this.showItemWrapper.bind(this, o));
  }
  showItem(e) {
    const t = this.items.find((o) => o.tabbedItem === e);
    t && this.showItemWrapper(t);
  }
  showItemWrapper(e) {
    var n, s, i, r, l, a;
    const { tabbedItem: t, eHeaderButton: o } = e;
    if ((s = (n = this.params).onItemClicked) == null || s.call(n, { item: t }), this.activeItem === e) {
      (r = (i = this.params).onActiveItemClicked) == null || r.call(i);
      return;
    }
    this.lastScrollListener && (this.lastScrollListener = this.lastScrollListener()), it(this.eBody), t.bodyPromise.then((c) => {
      this.eBody.appendChild(c);
      const d = !pa();
      if (this.params.suppressFocusBodyOnOpen || so(this.eBody, !1, d), t.afterAttachedCallback && t.afterAttachedCallback(this.afterAttachedParams), this.params.keepScrollPosition) {
        const u = t.getScrollableContainer && t.getScrollableContainer() || c;
        [this.lastScrollListener] = this.addManagedElementListeners(u, {
          scroll: () => {
            this.tabbedItemScrollMap.set(t.name, u.scrollTop);
          }
        });
        const h = this.tabbedItemScrollMap.get(t.name);
        h !== void 0 && setTimeout(() => {
          u.scrollTop = h;
        }, 0);
      }
    }), this.activeItem && (this.activeItem.eHeaderButton.classList.remove("ag-tab-selected"), (a = (l = this.activeItem.tabbedItem).afterDetachedCallback) == null || a.call(l)), o.classList.add("ag-tab-selected"), this.activeItem = e;
  }
}, Xn = "filterMenuTab", es = "generalMenuTab", Ms = "columnsMenuTab", el = [es, Xn, Ms], XQe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "enterpriseMenuFactory";
  }
  hideActiveMenu() {
    this.destroyBean(this.activeMenu);
  }
  showMenuAfterMouseEvent(e, t, o, n, s) {
    const { column: i, columnGroup: r } = this.splitColumnOrGroup(e), l = s ? "filterMenuTab" : void 0;
    this.showMenu(
      i,
      r,
      (a) => {
        var d;
        const c = a.getGui();
        this.beans.popupSvc.positionPopupUnderMouseEvent({
          type: o,
          column: i,
          mouseEvent: t,
          ePopup: c
        }), l && ((d = a.showTab) == null || d.call(a, l)), this.dispatchVisibleChangedEvent(!0, !1, i, r, l);
      },
      o,
      l,
      void 0,
      t.target,
      n
    );
  }
  splitColumnOrGroup(e) {
    const t = e && hn(e);
    return { column: t ? e : void 0, columnGroup: t ? void 0 : e };
  }
  showMenuAfterButtonClick(e, t, o, n, s) {
    let i = -1, r = "left";
    this.gos.get("enableRtl") && (i = 1, r = "right");
    const l = s ? "filterMenuTab" : void 0, a = l ? [l] : void 0, c = $t(this.gos), d = (c ? 9 : 4) * i, u = c ? -23 : 4, { column: h, columnGroup: p } = this.splitColumnOrGroup(e);
    this.showMenu(
      h,
      p,
      (C) => {
        var w;
        const m = C.getGui();
        this.beans.popupSvc.positionPopupByComponent({
          type: o,
          column: h,
          eventSource: t,
          ePopup: m,
          alignSide: r,
          nudgeX: d,
          nudgeY: u,
          position: "under",
          keepWithinBounds: !0
        }), l && ((w = C.showTab) == null || w.call(C, l)), this.dispatchVisibleChangedEvent(!0, !1, h, p, l);
      },
      o,
      l,
      a,
      t,
      n
    );
  }
  showMenu(e, t, o, n, s, i, r, l) {
    var y;
    const a = this.getMenuParams(e, t, i, r);
    if (!a)
      return;
    const { menu: c, eMenuGui: d, anchorToElement: u, restoreFocusParams: h } = a, p = [], { menuUtils: C, popupSvc: m } = this.beans;
    p.push((b) => {
      const _ = c.getGui();
      this.destroyBean(c), e && (Il(e, !1, "contextMenu"), C.restoreFocusOnClose(h, _, b)), l == null || l();
    });
    const w = this.getLocaleTextFunc();
    if (m.addPopup({
      modal: !0,
      eChild: d,
      closeOnEsc: !0,
      closedCallback: (b) => {
        p.forEach((_) => _(b)), this.dispatchVisibleChangedEvent(!1, !1, e, t, s);
      },
      afterGuiAttached: (b) => c.afterGuiAttached(Object.assign({}, { container: n }, b)),
      // if defaultTab is not present, positionCallback will be called
      // after `showTabBasedOnPreviousSelection` is called.
      positionCallback: s ? () => o(c) : void 0,
      ariaLabel: w("ariaLabelColumnMenu", "Column Menu")
    }), s || ((y = c.showTabBasedOnPreviousSelection) == null || y.call(c), o(c)), Tw(this.gos)) {
      const b = m.setPopupPositionRelatedToElement(d, u);
      b && e && this.addStopAnchoring(b, e, p);
    }
    c.addEventListener("tabSelected", (b) => {
      this.dispatchVisibleChangedEvent(!1, !0, e), this.lastSelectedTab = b.key, this.dispatchVisibleChangedEvent(!0, !0, e);
    }), e && Il(e, !0, "contextMenu"), this.activeMenu = c, c.addEventListener("destroyed", () => {
      this.activeMenu === c && (this.activeMenu = null);
    });
  }
  addStopAnchoring(e, t, o) {
    e.then((n) => {
      t.__addEventListener("leftChanged", n), t.__addEventListener("visibleChanged", n), o.push(() => {
        t.__removeEventListener("leftChanged", n), t.__removeEventListener("visibleChanged", n);
      });
    });
  }
  getMenuParams(e, t, o, n) {
    const { focusSvc: s, visibleCols: i, ctrlsSvc: r } = this.beans, l = {
      column: e,
      headerPosition: s.focusedHeader,
      columnIndex: i.allCols.indexOf(e),
      eventSource: n
    }, a = this.createMenu(e, t, l, o, n);
    return a ? {
      menu: a,
      eMenuGui: a.getGui(),
      anchorToElement: n || r.getGridBodyCtrl().eGridBody,
      restoreFocusParams: l
    } : void 0;
  }
  createMenu(e, t, o, n, s) {
    if ($t(this.gos))
      return this.createBean(
        new eJe(e, o, this.lastSelectedTab, n, s)
      );
    {
      const i = this.beans.colMenuFactory.getMenuItems(e, t);
      return i.length ? this.createBean(new tJe(i, e, o, s)) : void 0;
    }
  }
  dispatchVisibleChangedEvent(e, t, o, n, s) {
    this.eventSvc.dispatchEvent({
      type: "columnMenuVisibleChanged",
      visible: e,
      switchingTab: t,
      key: this.lastSelectedTab ?? s ?? ($t(this.gos) ? es : "columnMenu"),
      column: o ?? null,
      columnGroup: n ?? null
    });
  }
  isMenuEnabled(e) {
    var s;
    if (!$t(this.gos))
      return !0;
    const t = !((s = this.beans.filterManager) != null && s.isFilterAllowed(e)), o = e.getColDef().menuTabs ?? el;
    return (t && o.includes(Xn) ? o.length - 1 : o.length) > 0;
  }
  showMenuAfterContextMenuEvent(e, t, o) {
    this.beans.menuUtils.onContextMenu({
      mouseEvent: t,
      touchEvent: o,
      source: "ui",
      showMenuCallback: (n) => (this.showMenuAfterMouseEvent(e, n, "columnMenu"), !0)
    });
  }
}, eJe = class extends K {
  constructor(e, t, o, n, s) {
    super(), this.column = e, this.restoreFocusParams = t, this.initialSelection = o, this.restrictTo = n, this.sourceElement = s, this.tabFactories = {}, this.includeChecks = {};
    const { tabFactories: i, includeChecks: r } = this;
    i[es] = this.createMainPanel.bind(this), i[Xn] = this.createFilterPanel.bind(this), i[Ms] = this.createColumnsPanel.bind(this), r[es] = () => !0, r[Xn] = () => {
      var l;
      return e ? !!((l = this.beans.filterManager) != null && l.isFilterAllowed(e)) : !1;
    }, r[Ms] = () => !0;
  }
  postConstruct() {
    var o;
    const e = this.getTabsToCreate().map((n) => this.createTab(n)), t = new JQe({
      items: e,
      cssClass: "ag-menu",
      onActiveItemClicked: this.onHidePopup.bind(this),
      onItemClicked: this.onTabItemClicked.bind(this)
    });
    this.tabbedLayout = this.createBean(t), (o = this.mainMenuList) == null || o.setParentComponent(t), this.addDestroyFunc(() => this.destroyBean(t));
  }
  getTabsToCreate() {
    var e;
    return this.restrictTo ? this.restrictTo : (((e = this.column) == null ? void 0 : e.getColDef().menuTabs) ?? el).filter(
      (t) => this.isValidMenuTabItem(t) && this.isNotSuppressed(t)
    );
  }
  isValidMenuTabItem(e) {
    let t = !0, o = el;
    return this.restrictTo != null && (t = this.restrictTo.indexOf(e) > -1, o = this.restrictTo), t = t && el.indexOf(e) > -1, t || X(175, { menuTabName: e, itemsToConsider: o }), t;
  }
  isNotSuppressed(e) {
    return this.includeChecks[e]();
  }
  createTab(e) {
    return this.tabFactories[e]();
  }
  showTabBasedOnPreviousSelection() {
    this.showTab(this.initialSelection);
  }
  showTab(e) {
    const { tabItemColumns: t, tabbedLayout: o, tabItemFilter: n, tabItemGeneral: s } = this;
    t && e === Ms ? o.showItem(t) : n && e === Xn ? o.showItem(n) : s && e === es ? o.showItem(s) : o.showFirstItem();
  }
  onTabItemClicked(e) {
    let t = null;
    switch (e.item) {
      case this.tabItemColumns:
        t = Ms;
        break;
      case this.tabItemFilter:
        t = Xn;
        break;
      case this.tabItemGeneral:
        t = es;
        break;
    }
    t && this.activateTab(t);
  }
  activateTab(e) {
    const t = {
      type: "tabSelected",
      key: e
    };
    this.dispatchLocalEvent(t);
  }
  createMainPanel() {
    const { beans: e, column: t } = this, o = e.colMenuFactory, n = o.createMenu(
      this,
      o.getMenuItems(t),
      this.column,
      () => this.sourceElement ?? this.getGui()
    );
    this.mainMenuList = n, n.addEventListener("closeMenu", this.onHidePopup.bind(this));
    const s = {
      title: Ie("legacyMenu", e, t),
      titleLabel: es.replace("MenuTab", ""),
      bodyPromise: Ye.resolve(n.getGui()),
      name: es
    };
    return this.tabItemGeneral = s, s;
  }
  onHidePopup(e) {
    this.beans.menuUtils.closePopupAndRestoreFocusOnSelect(
      this.hidePopupFunc,
      this.restoreFocusParams,
      e
    );
  }
  createFilterPanel() {
    const e = this.column ? this.createBean(new bb(this.column, "COLUMN_MENU")) : null;
    this.filterComp = e, e != null && e.hasFilter() || qe(119);
    const t = (n) => e == null ? void 0 : e.afterGuiAttached(n), o = () => e == null ? void 0 : e.afterGuiDetached();
    return this.tabItemFilter = {
      title: Ie("filterTab", this.beans, this.column),
      titleLabel: Xn.replace("MenuTab", ""),
      bodyPromise: Ye.resolve(e == null ? void 0 : e.getGui()),
      afterAttachedCallback: t,
      afterDetachedCallback: o,
      name: Xn
    }, this.tabItemFilter;
  }
  createColumnsPanel() {
    const e = ze({ tag: "div", cls: "ag-menu-column-select-wrapper" }), { beans: t, column: o } = this, s = t.colChooserFactory.createColumnSelectPanel(
      this,
      o
    ).getGui();
    s.classList.add("ag-menu-column-select"), e.appendChild(s);
    const i = {
      title: Ie("columns", t, o),
      //createColumnsIcon(),
      titleLabel: Ms.replace("MenuTab", ""),
      bodyPromise: Ye.resolve(e),
      name: Ms
    };
    return this.tabItemColumns = i, i;
  }
  afterGuiAttached(e) {
    const { container: t, hidePopup: o } = e;
    this.tabbedLayout.setAfterAttachedParams({ container: t, hidePopup: o }), o && (this.hidePopupFunc = o, this.addDestroyFunc(o));
  }
  getGui() {
    return this.tabbedLayout.getGui();
  }
  destroy() {
    super.destroy(), this.destroyBean(this.filterComp);
  }
}, tJe = class extends Re {
  constructor(e, t, o, n) {
    super({ tag: "div", ref: "eColumnMenu", cls: "ag-menu ag-column-menu", role: "presentation" }), this.menuItems = e, this.column = t, this.restoreFocusParams = o, this.sourceElement = n, this.eColumnMenu = J;
  }
  postConstruct() {
    const e = this.beans.colMenuFactory.createMenu(
      this,
      this.menuItems,
      this.column,
      () => this.sourceElement ?? this.getGui()
    );
    this.mainMenuList = e, e.addEventListener("closeMenu", this.onHidePopup.bind(this)), this.eColumnMenu.appendChild(e.getGui());
  }
  onHidePopup(e) {
    this.beans.menuUtils.closePopupAndRestoreFocusOnSelect(
      this.hidePopupFunc,
      this.restoreFocusParams,
      e
    );
  }
  afterGuiAttached({ hidePopup: e }) {
    e && (this.hidePopupFunc = e, this.addDestroyFunc(e)), so(this.mainMenuList.getGui());
  }
};
function oJe(e, t) {
  const { contextMenuSvc: o } = e;
  if (!o)
    return;
  const { rowNode: n, column: s, value: i, x: r, y: l } = t || {};
  let { x: a, y: c } = o.getContextMenuPosition(n, s);
  r != null && (a = r), l != null && (c = l), o.showContextMenu({
    mouseEvent: new MouseEvent("mousedown", { clientX: a, clientY: c }),
    rowNode: n,
    column: s,
    value: i,
    source: "api"
  });
}
function nJe(e, t) {
  var o;
  (o = e.colChooserFactory) == null || o.showColumnChooser({ chooserParams: t });
}
function sJe(e) {
  var t;
  (t = e.colChooserFactory) == null || t.hideActiveColumnChooser();
}
var iJe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "menuUtils";
  }
  restoreFocusOnClose(e, t, o, n) {
    const { eventSource: s } = e, i = o instanceof KeyboardEvent;
    if (!n && !i || !s)
      return;
    const r = Ue(this.beans);
    // focus is outside of comp
    !t.contains(r) && // something else has focus
    !Oi(this.beans) || this.focusHeaderCell(e);
  }
  closePopupAndRestoreFocusOnSelect(e, t, o) {
    let n;
    o && o.keyboardEvent && (n = o.keyboardEvent), e(n && { keyboardEvent: n });
    const s = this.beans, i = s.focusSvc, r = i.getFocusedCell();
    if (Oi(s))
      if (r) {
        const { rowIndex: l, rowPinned: a, column: c } = r;
        i.setFocusedCell({
          rowIndex: l,
          column: c,
          rowPinned: a,
          forceBrowserFocus: !0,
          preventScrollOnBrowserFocus: !0
        });
      } else
        this.focusHeaderCell(t);
  }
  onContextMenu(e) {
    const { mouseEvent: t, touchEvent: o, showMenuCallback: n, source: s } = e;
    if (!this.gos.get("allowContextMenuWithControlKey") && t && (t.ctrlKey || t.metaKey) || (t && this.blockMiddleClickScrollsIfNeeded(t), s === "ui" && this.gos.get("suppressContextMenu")))
      return;
    const i = t ?? o.touches[0];
    if (n(i)) {
      const r = t ?? o;
      r && r.cancelable && r.preventDefault();
    }
  }
  // make this async for react
  async focusHeaderCell(e) {
    const { column: t, columnIndex: o, headerPosition: n, eventSource: s } = e, { visibleCols: i, headerNavigation: r, focusSvc: l } = this.beans, a = await i.allCols.some((c) => c === t);
    if (this.isAlive()) {
      if (t != null && t.isAlive() && a && s && ro(s)) {
        const c = H2(s);
        c && (r == null || r.scrollToColumn(t), c.focus());
      } else if (n && o !== -1) {
        const c = i.allCols, d = c[o] || Ke(c);
        d && l.focusHeaderPosition({
          headerPosition: {
            headerRowIndex: n.headerRowIndex,
            column: d
          }
        });
      }
    }
  }
  blockMiddleClickScrollsIfNeeded(e) {
    this.gos.get("suppressMiddleClickScrolls") && e.which === 2 && e.preventDefault();
  }
}, I_ = {
  moduleName: "MenuCore",
  version: yt,
  beans: [zQe, OQe, iJe],
  icons: {
    // context menu chart item
    chart: "chart",
    // columns in menu (column chooser / columns tab)
    columns: "columns",
    // loading async menu items
    loadingMenuItems: "loading",
    // "Pin column" item in column header menu
    menuPin: "pin",
    // "Value aggregation" column menu item (shown on numeric columns when grouping is active)"
    menuValue: "aggregation",
    // "Group by {column-name}" item in column header menu
    menuAddRowGroup: "group",
    // "Un-Group by {column-name}" item in column header menu
    menuRemoveRowGroup: "group",
    // context menu copy item
    clipboardCopy: "copy",
    // context menu cut item
    clipboardCut: "cut",
    // context menu paste item
    clipboardPaste: "paste",
    // context menu export item
    save: "save",
    // csv export
    csvExport: "csv",
    // excel export,
    excelExport: "excel",
    // show on column header when column is sorted ascending
    sortAscending: "asc",
    // show on column header when column is sorted descending
    sortDescending: "desc",
    // show on column header when column has no sort, only when enabled with colDef.unSortIcon=true
    sortUnSort: "none"
  },
  dependsOn: [ko, li, Ry, __]
}, rJe = {
  moduleName: "ColumnMenu",
  version: yt,
  beans: [XQe, WQe, ZQe],
  icons: {
    ensureColumnVisible: "column-arrow",
    // menu tab icon in legacy tabbed enterprise column menu
    legacyMenu: "menu",
    // filter tab icon in legacy tabbed enterprise column menu
    filterTab: "filter",
    // column tool panel column group contracted (click to expand)
    columnSelectClosed: "tree-closed",
    // column tool panel column group expanded (click to contract)
    columnSelectOpen: "tree-open",
    // column tool panel header expand/collapse all button, shown when some children are expanded and
    //     others are collapsed
    columnSelectIndeterminate: "tree-indeterminate"
  },
  apiFunctions: {
    showColumnChooser: nJe,
    hideColumnChooser: sJe
  },
  dependsOn: [I_, f1, tc]
}, lJe = {
  moduleName: "ContextMenu",
  version: yt,
  beans: [qQe],
  apiFunctions: {
    showContextMenu: oJe
  },
  dependsOn: [I_]
}, Rs = "__AG_SELECT_ALL__", Fs = "__AG_ADD_SELECTION_TO_FILTER__", aJe = class {
  constructor(e, t, o, n) {
    this.valueSvc = e, this.getValueFormatter = t, this.formatter = o, this.column = n, this.displayedKeys = [];
  }
  updateDisplayedValuesToAllAvailable(e, t, o) {
    this.displayedKeys = Array.from(o);
  }
  updateDisplayedValuesToMatchMiniFilter(e, t, o, n, s) {
    this.displayedKeys = [];
    const i = this.getValueFormatter();
    for (const r of o)
      if (r == null)
        s && this.displayedKeys.push(r);
      else {
        const l = e(r), a = this.valueSvc.formatValue(this.column, null, l, i, !1), c = this.formatter(a);
        n(c) && this.displayedKeys.push(r);
      }
  }
  getDisplayedValueCount() {
    return this.displayedKeys.length;
  }
  getDisplayedItem(e) {
    return this.displayedKeys[e];
  }
  getSelectAllItem() {
    return Rs;
  }
  getAddSelectionToFilterItem() {
    return Fs;
  }
  getDisplayedKeys() {
    return this.displayedKeys;
  }
  forEachDisplayedKey(e) {
    this.displayedKeys.forEach(e);
  }
  someDisplayedKey(e) {
    return this.displayedKeys.some(e);
  }
  hasGroups() {
    return !1;
  }
  refresh() {
  }
}, cJe = {
  tag: "div",
  cls: "ag-set-filter-item",
  attrs: { "aria-hidden": "true" },
  children: [
    {
      tag: "span",
      cls: "ag-set-filter-group-icons",
      children: [
        { tag: "span", ref: "eGroupClosedIcon", cls: "ag-set-filter-group-closed-icon" },
        { tag: "span", ref: "eGroupOpenedIcon", cls: "ag-set-filter-group-opened-icon" },
        { tag: "span", ref: "eGroupIndeterminateIcon", cls: "ag-set-filter-group-indeterminate-icon" }
      ]
    },
    { tag: "ag-checkbox", ref: "eCheckbox", cls: "ag-set-filter-item-checkbox" }
  ]
}, dJe = {
  tag: "div",
  cls: "ag-set-filter-item",
  children: [{ tag: "ag-checkbox", ref: "eCheckbox", cls: "ag-set-filter-item-checkbox" }]
}, uJe = class extends Re {
  constructor(e) {
    super(e.isGroup ? cJe : dJe, [ii]), this.eCheckbox = J, this.eGroupOpenedIcon = J, this.eGroupClosedIcon = J, this.eGroupIndeterminateIcon = J, this.formattedValue = null, this.focusWrapper = e.focusWrapper, this.value = e.value, this.params = e.params, this.translate = e.translate, this.valueFormatter = e.valueFormatter, this.item = e.item, this.isSelected = e.isSelected, this.isTree = e.isTree, this.depth = e.depth ?? 0, this.isGroup = e.isGroup, this.groupsExist = e.groupsExist, this.isExpanded = e.isExpanded, this.hasIndeterminateExpandState = e.hasIndeterminateExpandState;
  }
  postConstruct() {
    this.tooltipFeature = this.createOptionalManagedBean(
      this.beans.registry.createDynamicBean("tooltipFeature", !1, {
        getGui: () => this.focusWrapper,
        getLocation: () => "setFilterValue",
        shouldDisplayTooltip: () => {
          var e;
          return ((e = this.shouldDisplayTooltip) == null ? void 0 : e.call(this)) ?? !0;
        },
        getAdditionalParams: () => {
          const { colDef: e, column: t } = this.params, o = {
            colDef: e,
            column: t,
            valueFormatted: this.formattedValue ?? void 0
          };
          return this.isTree && (o.level = this.depth), o;
        }
      })
    ), this.addDestroyFunc(() => {
      var e;
      return (e = this.destroyCellRendererComponent) == null ? void 0 : e.call(this);
    }), this.render(), this.eCheckbox.setLabelEllipsis(!0).setValue(this.isSelected, !0).setDisabled(!!this.params.readOnly).getInputElement().setAttribute("tabindex", "-1"), this.refreshVariableAriaLabels(), this.isTree && (this.depth > 0 && (this.addCss("ag-set-filter-indent-" + this.depth), this.getGui().style.setProperty("--ag-indentation-level", String(this.depth))), this.isGroup ? this.setupExpansion() : this.groupsExist && this.addCss("ag-set-filter-add-group-indent"), ia(this.getAriaElement(), this.depth + 1)), this.refreshAriaChecked(), !this.params.readOnly && this.eCheckbox.onValueChange((e) => this.onCheckboxChanged(!!e));
  }
  getFocusableElement() {
    return this.focusWrapper;
  }
  setupExpansion() {
    const { eGroupClosedIcon: e, eGroupOpenedIcon: t, eGroupIndeterminateIcon: o, hasIndeterminateExpandState: n, beans: s } = this;
    e.appendChild(Ri("setFilterGroupClosed", s, null)), t.appendChild(Ri("setFilterGroupOpen", s, null));
    const i = this.onExpandOrContractClicked.bind(this);
    this.addManagedElementListeners(e, { click: i }), this.addManagedElementListeners(t, { click: i }), n && (o.appendChild(Ri("setFilterGroupIndeterminate", s, null)), this.addManagedElementListeners(o, {
      click: i
    })), this.setExpandedIcons(), this.refreshAriaExpanded();
  }
  onExpandOrContractClicked() {
    this.setExpanded(!this.isExpanded);
  }
  setExpanded(e, t) {
    if (this.isGroup && e !== this.isExpanded) {
      this.isExpanded = e;
      const o = {
        type: "expandedChanged",
        isExpanded: !!e,
        item: this.item
      };
      t || this.dispatchLocalEvent(o), this.setExpandedIcons(), this.refreshAriaExpanded();
    }
  }
  setExpandedIcons() {
    const { isExpanded: e, hasIndeterminateExpandState: t, eGroupClosedIcon: o, eGroupOpenedIcon: n, eGroupIndeterminateIcon: s } = this;
    He(o, t ? e === !1 : !e), He(n, e === !0), t && He(s, e === void 0);
  }
  onCheckboxChanged(e) {
    this.isSelected = e;
    const t = {
      type: "selectionChanged",
      isSelected: e,
      item: this.item
    };
    this.dispatchLocalEvent(t), this.refreshVariableAriaLabels(), this.refreshAriaChecked();
  }
  toggleSelected() {
    this.params.readOnly || this.setSelected(!this.isSelected);
  }
  setSelected(e, t) {
    this.isSelected = e, this.eCheckbox.setValue(e, t), this.refreshAriaChecked();
  }
  refreshVariableAriaLabels() {
    if (!this.isTree)
      return;
    const e = this.getLocaleTextFunc(), t = this.eCheckbox.getValue(), o = t === void 0 ? e("ariaIndeterminate", "indeterminate") : t ? e("ariaVisible", "visible") : e("ariaHidden", "hidden"), n = e("ariaToggleVisibility", "Press SPACE to toggle visibility");
    as(this.eCheckbox.getInputElement(), void 0), this.eCheckbox.setInputAriaLabel(`${n} (${o})`);
  }
  setupFixedAriaLabels(e) {
    if (!this.isTree)
      return;
    const o = this.getLocaleTextFunc()("ariaFilterValue", "Filter Value"), n = this.getAriaElement();
    ft(n, `${e} ${o}`), sa(n, this.eCheckbox.getInputElement().id);
  }
  refreshAriaChecked() {
    const e = this.getAriaElement();
    sw(e, this.eCheckbox.getValue());
  }
  refreshAriaExpanded() {
    Fo(this.getAriaElement(), !!this.isExpanded);
  }
  refresh(e, t, o) {
    var l;
    this.item = e, t !== this.isSelected && this.setSelected(t, !0), this.setExpanded(o, !0);
    const { cellRendererComponent: n, cellRendererParams: s, beans: i, params: r } = this;
    if (this.valueFunction) {
      const a = this.valueFunction();
      this.setTooltipAndCellRendererParams(a, a), n || this.renderCellWithoutCellRenderer();
    }
    if (n) {
      const a = Ni(i.userCompFactory, r, s);
      if (!((l = n.refresh) == null ? void 0 : l.call(n, (a == null ? void 0 : a.params) ?? s))) {
        const d = n;
        this.renderCell(), this.destroyBean(d);
      }
    }
  }
  render() {
    const {
      params: { column: e }
    } = this;
    let { value: t } = this, o = null;
    typeof t == "function" ? (this.valueFunction = t, o = this.valueFunction(), t = o) : this.isTree ? o = Co(t) : o = this.getFormattedValue(e, t), this.formattedValue = o, this.setTooltipAndCellRendererParams(t, o), this.renderCell();
  }
  setTooltipAndCellRendererParams(e, t) {
    var n;
    const o = this.gos;
    if (this.params.showTooltips && (!Tr(o) || !this.params.cellRenderer)) {
      const s = t ?? Co(e);
      this.shouldDisplayTooltip = lc(
        o,
        () => this.eCheckbox.getGui().querySelector(".ag-label")
      ), (n = this.tooltipFeature) == null || n.setTooltipAndRefresh(s);
    }
    this.cellRendererParams = Pe(o, {
      value: e,
      valueFormatted: t,
      colDef: this.params.colDef,
      column: this.params.column,
      setTooltip: (s, i) => {
        var r;
        o.assertModuleRegistered("Tooltip", 3), this.shouldDisplayTooltip = i, (r = this.tooltipFeature) == null || r.setTooltipAndRefresh(s);
      }
    });
  }
  getFormattedValue(e, t) {
    return this.beans.valueSvc.formatValue(e, null, t, this.valueFormatter, !1);
  }
  renderCell() {
    const e = Ni(this.beans.userCompFactory, this.params, this.cellRendererParams), t = e == null ? void 0 : e.newAgStackInstance();
    if (t == null) {
      this.renderCellWithoutCellRenderer();
      return;
    }
    t.then((o) => {
      o && (this.cellRendererComponent = o, this.eCheckbox.setLabel(o.getGui()), this.destroyCellRendererComponent = () => this.destroyBean(o));
    });
  }
  renderCellWithoutCellRenderer() {
    const { valueFormatted: e, value: t } = this.cellRendererParams;
    let o = e ?? t ?? this.translate("blanks");
    typeof o != "string" && (X(208), o = ""), this.eCheckbox.setLabel(o), this.setupFixedAriaLabels(o);
  }
  getComponentHolder() {
    return this.params.column.getColDef();
  }
}, hJe = {
  loadingOoo: "Loading...",
  blanks: "(Blanks)",
  searchOoo: "Search...",
  selectAll: "(Select All)",
  selectAllSearchResults: "(Select All Search Results)",
  addCurrentSelectionToFilter: "Add current selection to filter",
  noMatches: "No matches.",
  ariaSearchFilterValues: "Search filter values",
  ariaFilterList: "Filter List",
  filterSummaryListInactive: "is (All)",
  filterSummaryListSeparator: ", ",
  filterSummaryListShort: (e) => `is (${e[0]})`,
  filterSummaryListLong: (e) => `is (${e[0]}) and ${e[1]} more`
};
function T5(e, t, o) {
  let n = e;
  return n ? (n = n.map((s) => Co(Ft(s))), !t && o && n.some((s) => s == null) ? Ke(n) == null ? null : n.filter((s) => s != null) : n) : null;
}
function ho(e, t, o) {
  return vw(e, hJe, t, o);
}
function gJe(e) {
  e.excelMode === "windows" ? (e.buttons || (e.buttons = ["apply", "cancel"]), e.closeOnApply == null && (e.closeOnApply = !0)) : e.excelMode === "mac" && (e.buttons || (e.buttons = ["reset"]), e.applyMiniFilterWhileTyping == null && (e.applyMiniFilterWhileTyping = !0), e.debounceMs == null && (e.debounceMs = 500)), e.excelMode && e.defaultToNothingSelected && (e.defaultToNothingSelected = !1, X(207));
}
function pJe() {
  return ([e, t], [o, n]) => {
    if (t == null)
      return n == null ? 0 : -1;
    if (n == null)
      return 1;
    for (let s = 0; s < t.length; s++) {
      if (s >= n.length)
        return 1;
      const i = vl(t[s], n[s]);
      if (i !== 0)
        return i;
    }
    return 0;
  };
}
var ju = class {
  constructor(e, t, o, n) {
    this.formatter = e, this.treeListPathGetter = t, this.treeListFormatter = o, this.treeDataOrGrouping = n, this.allDisplayedItemsTree = /* @__PURE__ */ new Map(), this.activeDisplayedItemsFlat = [], this.selectAllItem = {
      depth: 0,
      filterPasses: !0,
      available: !0,
      treeKey: Rs,
      children: this.allDisplayedItemsTree,
      expanded: !0,
      key: Rs,
      parentTreeKeys: []
    }, this.addSelectionToFilterItem = {
      depth: 0,
      filterPasses: !0,
      available: !0,
      treeKey: Fs,
      expanded: !0,
      key: Fs,
      parentTreeKeys: []
    };
  }
  updateParams(e, t) {
    this.treeListPathGetter = e, this.treeListFormatter = t;
  }
  updateDisplayedValuesToAllAvailable(e, t, o, n) {
    n === "reload" ? this.generateItemTree(e, t, o) : n === "otherFilter" ? (this.updateAvailable(o), this.updateExpandAll()) : n === "miniFilter" && (this.resetFilter(), this.updateExpandAll()), this.flattenItems();
  }
  updateDisplayedValuesToMatchMiniFilter(e, t, o, n, s, i) {
    i === "reload" ? this.generateItemTree(e, t, o) : i === "otherFilter" && this.updateAvailable(o), this.updateFilter(n, s), this.updateExpandAll(), this.flattenItems();
  }
  generateItemTree(e, t, o) {
    const n = /* @__PURE__ */ new Map();
    this.allDisplayedItemsTree = n;
    let s = !1;
    const i = this.getTreeListPathGetter(e, o);
    for (const r of t) {
      const l = e(r), a = i(l) ?? [null], c = a.length;
      c > 1 && (s = !0);
      const d = o.has(r);
      let u = n, h, p = [];
      for (let C = 0; C < c; C++) {
        const m = a[C];
        u || (u = /* @__PURE__ */ new Map(), h.children = u);
        const w = (m == null ? void 0 : m.toUpperCase()) ?? null;
        h = u.get(w), h || (h = {
          treeKey: m,
          depth: C,
          filterPasses: !0,
          expanded: !1,
          available: d,
          parentTreeKeys: p
        }, C === a.length - 1 && (h.key = r), u.set(w, h)), u = h.children, p = [...p, m];
      }
    }
    this.groupsExist = s, this.updateAvailable(o), this.selectAllItem.children = n, this.selectAllItem.expanded = !1;
  }
  getTreeListPathGetter(e, t) {
    if (this.treeListPathGetter)
      return this.treeListPathGetter;
    if (this.treeDataOrGrouping)
      return (n) => n;
    let o = !1;
    for (const n of t) {
      const s = e(n);
      if (s instanceof Date) {
        o = !0;
        break;
      } else if (s != null)
        break;
    }
    return o ? (n) => Ci(n, !1) : (X(211), (n) => [String(n)]);
  }
  flattenItems() {
    this.activeDisplayedItemsFlat = [];
    const e = (t) => {
      for (const o of t.values())
        !o.filterPasses || !o.available || (this.activeDisplayedItemsFlat.push(o), o.children && o.expanded && e(o.children));
    };
    e(this.allDisplayedItemsTree);
  }
  resetFilter() {
    const e = (t) => {
      const o = t.children;
      if (o)
        for (const n of o.values())
          e(n);
      t.filterPasses = !0;
    };
    for (const t of this.allDisplayedItemsTree.values())
      e(t);
  }
  updateFilter(e, t) {
    const o = (n) => n.available ? n.treeKey == null ? t : e(
      this.formatter(
        this.treeListFormatter ? this.treeListFormatter(n.treeKey, n.depth, n.parentTreeKeys) : n.treeKey
      )
    ) : !1;
    for (const n of this.allDisplayedItemsTree.values())
      this.recursiveItemCheck(n, !1, o, "filterPasses");
  }
  getDisplayedValueCount() {
    return this.activeDisplayedItemsFlat.length;
  }
  getDisplayedItem(e) {
    return this.activeDisplayedItemsFlat[e];
  }
  getSelectAllItem() {
    return this.selectAllItem;
  }
  getAddSelectionToFilterItem() {
    return this.addSelectionToFilterItem;
  }
  getDisplayedKeys() {
    const e = [];
    return this.forEachDisplayedKey((t) => e.push(t)), e;
  }
  forEachDisplayedKey(e) {
    const t = (o, n) => {
      const s = o.children;
      if (s) {
        if (!o.expanded || !n)
          for (const i of s.values())
            i.filterPasses && t(i, !1);
      } else
        e(o.key);
    };
    this.activeDisplayedItemsFlat.forEach((o) => t(o, !0));
  }
  someDisplayedKey(e) {
    const t = (o, n) => {
      const s = o.children;
      if (s) {
        if (!o.expanded || !n) {
          for (const i of s.values())
            if (i.filterPasses && t(i, !1))
              return !0;
          return !1;
        }
      } else
        return e(o.key);
      return !1;
    };
    return this.activeDisplayedItemsFlat.some((o) => t(o, !0));
  }
  hasGroups() {
    return this.groupsExist;
  }
  refresh() {
    this.updateExpandAll(), this.flattenItems();
  }
  updateExpandAll() {
    const e = (o, n, s) => {
      for (const i of o.values()) {
        if (!i.filterPasses || !i.available || !i.children)
          continue;
        if (n = n || !!i.expanded, s = s || !i.expanded, n && s)
          return;
        const r = e(i.children, n, s);
        if (r === void 0)
          return;
        r ? n = !0 : s = !0;
      }
      return n && s ? void 0 : n;
    }, t = this.getSelectAllItem();
    t.expanded = e(t.children, !1, !1);
  }
  recursiveItemCheck(e, t, o, n) {
    let s = !1;
    const i = e.children;
    if (i)
      for (const l of i.values()) {
        const a = this.recursiveItemCheck(
          l,
          t || o(e),
          o,
          n
        );
        s = s || a;
      }
    const r = t || s || o(e);
    return e[n] = r, r;
  }
  updateAvailable(e) {
    const t = (o) => e.has(o.key);
    for (const o of this.allDisplayedItemsTree.values())
      this.recursiveItemCheck(o, !1, t, "available");
  }
}, D_ = class extends xb {
  constructor() {
    super("setFilter", "set-filter"), this.filterType = "set", this.eMiniFilter = J, this.eFilterLoading = J, this.eFilterLoadingIcon = J, this.eSetFilterList = J, this.eFilterNoMatches = J, this.hardRefreshVirtualList = !1, this.miniFilterText = null, this.addCurrentSelectionToFilter = !1, this.selectedKeys = /* @__PURE__ */ new Set();
  }
  setParams(e) {
    super.setParams(e);
    const t = this.updateHandler(e.getHandler()), { column: o, textFormatter: n, treeList: s, treeListPathGetter: i, treeListFormatter: r } = e;
    this.formatter = n ?? ((l) => l ?? null), this.displayValueModel = s ? new ju(
      this.formatter,
      i,
      r,
      t.isTreeDataOrGrouping()
    ) : new aJe(
      this.beans.valueSvc,
      () => this.handler.valueFormatter,
      this.formatter,
      o
    ), t.valueModel.allKeys.then((l) => {
      this.updateDisplayedValues("reload", l ?? []), this.resetSelectionState(l ?? []);
    }), t.valueModel.isLoading() && this.setIsLoading(!0), this.initialiseFilterBodyUi();
  }
  refresh(e) {
    return this.params.treeList !== e.treeList ? !1 : (this.updateHandler(
      e.getHandler()
    ), super.refresh(e));
  }
  updateParams(e, t) {
    super.updateParams(e, t), this.updateMiniFilter(), e.suppressSelectAll !== t.suppressSelectAll && this.createVirtualListModel(e);
    const { textFormatter: o, treeListPathGetter: n, treeListFormatter: s } = e;
    this.formatter = o ?? ((i) => i ?? null), this.displayValueModel instanceof ju && this.displayValueModel.updateParams(n, s), this.handler.refreshFilterValues(!0);
  }
  updateHandler(e) {
    var o;
    return this.handler !== e && ((o = this.handlerDestroyFuncs) == null || o.forEach((n) => n()), this.handlerDestroyFuncs = [
      ...this.addManagedListeners(e, {
        anyFilterChanged: (n) => {
          e.valueModel.allKeys.then((s) => {
            this.isAlive() && (this.updateDisplayedValues("otherFilter", s ?? []), n.updated && (this.checkAndRefreshVirtualList(), this.showOrHideResults()));
          });
        },
        dataChanged: ({ hardRefresh: n }) => {
          e.valueModel.allKeys.then((s) => {
            var i;
            this.isAlive() && (this.updateDisplayedValues("reload", s ?? []), this.setSelectedModel(((i = this.state.model) == null ? void 0 : i.values) ?? null), n && (this.hardRefreshVirtualList = !0), this.checkAndRefreshVirtualList());
          });
        }
      }),
      ...this.addManagedListeners(e.valueModel, {
        loadingStart: () => this.setIsLoading(!0),
        loadingEnd: () => this.setIsLoading(!1)
      })
    ], this.handler = e), e;
  }
  // unlike the simple filters, nothing in the set filter UI shows/hides.
  // maybe this method belongs in abstractSimpleFilter???
  updateUiVisibility() {
  }
  createBodyTemplate() {
    return {
      tag: "div",
      cls: "ag-set-filter",
      children: [
        {
          tag: "div",
          ref: "eFilterLoading",
          cls: "ag-filter-loading ag-loading ag-hidden",
          children: [
            { tag: "span", ref: "eFilterLoadingIcon", cls: "ag-loading-icon" },
            { tag: "span", cls: "ag-loading-text", children: ho(this, "loadingOoo") }
          ]
        },
        { tag: "ag-input-text-field", ref: "eMiniFilter", cls: "ag-mini-filter" },
        {
          tag: "div",
          ref: "eFilterNoMatches",
          cls: "ag-filter-no-matches ag-hidden",
          children: ho(this, "noMatches")
        },
        { tag: "div", ref: "eSetFilterList", cls: "ag-set-filter-list", role: "presentation" }
      ]
    };
  }
  getAgComponents() {
    return [zo];
  }
  handleKeyDown(e) {
    var o, n, s;
    if (super.handleKeyDown(e), e.defaultPrevented)
      return;
    const t = () => {
      if (!this.eSetFilterList.contains(Ue(this.beans)))
        return;
      const i = this.virtualList.getLastFocusedRow();
      if (i == null)
        return;
      const r = this.virtualList.getComponentAt(i);
      if (r == null)
        return;
      e.preventDefault();
      const { readOnly: l } = this.params;
      if (!l)
        return r;
    };
    switch (e.key) {
      case D.SPACE:
        (o = t()) == null || o.toggleSelected();
        break;
      case D.ENTER:
        this.handleKeyEnter(e);
        break;
      case D.LEFT:
        (n = t()) == null || n.setExpanded(!1);
        break;
      case D.RIGHT:
        (s = t()) == null || s.setExpanded(!0);
        break;
    }
  }
  handleKeyEnter(e) {
    e.preventDefault();
    const { excelMode: t, readOnly: o } = this.params;
    !t || o || (this.params.onAction("apply", void 0, e), this.params.excelMode === "mac" && this.eMiniFilter.getInputElement().select());
  }
  setModelAndRefresh(e) {
    return this.setSelectedModel(e).then(() => {
      this.isAlive() && this.checkAndRefreshVirtualList();
    });
  }
  setModelIntoUi(e) {
    var o;
    this.setMiniFilter(((o = this.params.state.state) == null ? void 0 : o.miniFilterValue) ?? null, !0);
    const t = e == null ? null : e.values;
    return this.setModelAndRefresh(t);
  }
  getModelFromUi() {
    const e = this.getSelectedModel();
    return e ? { values: e, filterType: this.filterType } : null;
  }
  areNonNullModelsEqual(e, t) {
    return No(e.values, t.values);
  }
  setIsLoading(e) {
    He(this.eFilterLoading, e), e || (this.hardRefreshVirtualList = !0);
  }
  initialiseFilterBodyUi() {
    this.initVirtualList(), this.initMiniFilter(), this.initLoading();
  }
  initLoading() {
    const e = Ie("setFilterLoading", this.beans, this.params.column);
    e && this.eFilterLoadingIcon.appendChild(e);
  }
  initVirtualList() {
    const e = ho(this, "ariaFilterList"), t = !!this.params.treeList, o = this.virtualList = this.createBean(
      new nr({
        cssIdentifier: "filter",
        ariaRole: t ? "tree" : "listbox",
        listName: e
      })
    ), n = this.eSetFilterList;
    t && n.classList.add("ag-set-filter-tree-list"), n.appendChild(o.getGui());
    const { cellHeight: s } = this.params;
    s != null && o.setRowHeight(s);
    const i = (l, a) => this.createSetListItem(l, t, a);
    o.setComponentCreator(i);
    const r = (l, a) => this.updateSetListItem(l, a);
    o.setComponentUpdater(r), this.createVirtualListModel(this.params);
  }
  createVirtualListModel(e) {
    let t;
    e.suppressSelectAll ? t = new fJe(this.displayValueModel) : t = new vJe(
      this.displayValueModel,
      this.showAddCurrentSelectionToFilter.bind(this)
    ), e.treeList && (t = new mJe(t)), this.virtualList.setModel(t);
  }
  getSelectAllLabel() {
    const e = this.miniFilterText == null || !this.params.excelMode ? "selectAll" : "selectAllSearchResults";
    return ho(this, e);
  }
  getAddSelectionToFilterLabel() {
    return ho(this, "addCurrentSelectionToFilter");
  }
  createSetListItem(e, t, o) {
    const n = this.displayValueModel.hasGroups(), { isSelected: s, isExpanded: i } = this.isSelectedExpanded(e), { value: r, depth: l, isGroup: a, hasIndeterminateExpandState: c, selectedListener: d, expandedListener: u } = this.newSetListItemAttributes(e), h = {
      focusWrapper: o,
      value: r,
      params: this.params,
      translate: (C) => ho(this, C),
      valueFormatter: this.handler.valueFormatter,
      item: e,
      isSelected: s,
      isTree: t,
      depth: l,
      groupsExist: n,
      isGroup: a,
      isExpanded: i,
      hasIndeterminateExpandState: c
    }, p = this.createBean(new uJe(h));
    return p.addEventListener("selectionChanged", d), u && p.addEventListener("expandedChanged", u), p;
  }
  newSetTreeItemAttributes(e) {
    var o, n, s, i;
    const t = this.displayValueModel.hasGroups();
    return e.key === Rs ? {
      value: () => this.getSelectAllLabel(),
      isGroup: t,
      depth: e.depth,
      hasIndeterminateExpandState: !0,
      selectedListener: (r) => this.onSelectAll(r.isSelected),
      expandedListener: (r) => this.onExpandAll(r.item, r.isExpanded)
    } : e.key === Fs ? {
      value: () => this.getAddSelectionToFilterLabel(),
      depth: e.depth,
      isGroup: !1,
      hasIndeterminateExpandState: !1,
      selectedListener: (r) => {
        this.addCurrentSelectionToFilter = r.isSelected, this.refreshAfterSelection();
      }
    } : e.children ? {
      value: ((n = (o = this.params).treeListFormatter) == null ? void 0 : n.call(o, e.treeKey, e.depth, e.parentTreeKeys)) ?? e.treeKey,
      depth: e.depth,
      isGroup: !0,
      selectedListener: (r) => this.onGroupItemSelected(r.item, r.isSelected),
      expandedListener: (r) => this.onExpandedChanged(r.item, r.isExpanded)
    } : {
      value: ((i = (s = this.params).treeListFormatter) == null ? void 0 : i.call(s, e.treeKey, e.depth, e.parentTreeKeys)) ?? e.treeKey,
      depth: e.depth,
      selectedListener: (r) => this.onItemSelected(r.item.key, r.isSelected)
    };
  }
  newSetListItemAttributes(e) {
    return this.isSetFilterModelTreeItem(e) ? this.newSetTreeItemAttributes(e) : e === Rs ? {
      value: () => this.getSelectAllLabel(),
      selectedListener: (t) => this.onSelectAll(t.isSelected)
    } : e === Fs ? {
      value: () => this.getAddSelectionToFilterLabel(),
      selectedListener: (t) => {
        this.addCurrentSelectionToFilter = t.isSelected, this.refreshAfterSelection();
      }
    } : {
      value: this.handler.valueModel.allValues.get(e) ?? null,
      selectedListener: (t) => this.onItemSelected(t.item, t.isSelected)
    };
  }
  updateSetListItem(e, t) {
    const { isSelected: o, isExpanded: n } = this.isSelectedExpanded(e);
    t.refresh(e, o, n);
  }
  isSelectedExpanded(e) {
    let t, o;
    return this.isSetFilterModelTreeItem(e) ? (o = e.expanded, e.key === Rs ? t = this.isSelectAllSelected() : e.key === Fs ? t = this.isAddCurrentSelectionToFilterChecked() : e.children ? t = this.areAllChildrenSelected(e) : t = this.selectedKeys.has(e.key)) : e === Rs ? t = this.isSelectAllSelected() : e === Fs ? t = this.isAddCurrentSelectionToFilterChecked() : t = this.selectedKeys.has(e), { isSelected: t, isExpanded: o };
  }
  isSetFilterModelTreeItem(e) {
    return (e == null ? void 0 : e.treeKey) !== void 0;
  }
  initMiniFilter() {
    const { eMiniFilter: e } = this;
    this.updateMiniFilter(), e.onValueChange(() => this.onMiniFilterInput()), e.setInputAriaLabel(ho(this, "ariaSearchFilterValues")), this.addManagedElementListeners(e.getInputElement(), {
      keydown: (t) => this.onMiniFilterKeyDown(t)
    });
  }
  updateMiniFilter() {
    const { eMiniFilter: e, miniFilterText: t, params: o } = this;
    e.setDisplayed(!o.suppressMiniFilter), e.setValue(t);
  }
  // we need to have the GUI attached before we can draw the virtual rows, as the
  // virtual row logic needs info about the GUI state
  afterGuiAttached(e) {
    super.afterGuiAttached(e), this.resetExpansion(), this.refreshVirtualList();
    const { eMiniFilter: t } = this;
    t.setInputPlaceholder(ho(this, "searchOoo")), (!e || !e.suppressFocus) && (t.isDisplayed() ? t.getFocusableElement().focus() : this.virtualList.awaitStable(() => this.virtualList.focusRow(0)));
  }
  afterGuiDetached() {
    var s;
    super.afterGuiDetached();
    const { column: e, excelMode: t, model: o, onStateChange: n } = this.params;
    (s = this.beans.colFilter) != null && s.shouldKeepStateOnDetach(e) || (t && this.resetMiniFilter(), (t || o !== this.state.model) && (n({
      model: o,
      state: this.getState()
    }), this.showOrHideResults()));
  }
  canApply(e) {
    return this.params.excelMode ? e == null || e.values.length > 0 : !0;
  }
  /**
   * @deprecated v34 Internal method - should only be called by the grid.
   */
  onNewRowsLoaded() {
  }
  /**
   * @deprecated v34 Use the same method on the filter handler (`api.getColumnFilterHandler()`) instead.
   */
  setFilterValues(e) {
    X(283), this.handler.setFilterValues(e);
  }
  /**
   * @deprecated v34 Use the same method on the filter handler (`api.getColumnFilterHandler()`) instead.
   */
  resetFilterValues() {
    X(283), this.handler.resetFilterValues();
  }
  /**
   * @deprecated v34 Use the same method on the filter handler (`api.getColumnFilterHandler()`) instead.
   */
  refreshFilterValues() {
    X(283), this.doRefreshFilterValues();
  }
  doRefreshFilterValues() {
    this.handler.refreshFilterValues();
  }
  /**
   * @deprecated v34 Internal method - should only be called by the grid.
   */
  onAnyFilterChanged() {
  }
  onMiniFilterInput(e) {
    if (!this.doSetMiniFilter(this.eMiniFilter.getValue()))
      return;
    if (e) {
      this.showOrHideResults();
      return;
    }
    const { applyMiniFilterWhileTyping: t, readOnly: o, excelMode: n } = this.params, s = !o && (t || !!n), i = t && !o ? "debounce" : void 0;
    this.updateUiAfterMiniFilterChange(s, i);
  }
  updateUiAfterMiniFilterChange(e, t) {
    if (e) {
      const { excelMode: o, readOnly: n, model: s } = this.params;
      o && !n && this.miniFilterText == null ? this.setModelAndRefresh((s == null ? void 0 : s.values) ?? null) : this.selectAllMatchingMiniFilter(!0);
    }
    this.checkAndRefreshVirtualList(), this.onUiChanged(e ? t : "prevent"), this.showOrHideResults();
  }
  showOrHideResults() {
    const e = this.miniFilterText != null && this.displayValueModel.getDisplayedValueCount() < 1;
    He(this.eFilterNoMatches, e), He(this.eSetFilterList, !e);
  }
  resetMiniFilter() {
    this.eMiniFilter.setValue(null, !0), this.doSetMiniFilter(null);
  }
  onMiniFilterKeyDown(e) {
    const { excelMode: t, readOnly: o } = this.params;
    e.key === D.ENTER && !t && !o && this.updateUiAfterMiniFilterChange(!0, "immediately");
  }
  focusRowIfAlive(e) {
    return e == null ? Promise.resolve() : new Promise((t) => {
      window.setTimeout(() => {
        this.isAlive() && this.virtualList.focusRow(e), t();
      }, 0);
    });
  }
  onSelectAll(e) {
    e ? this.selectAllMatchingMiniFilter() : this.deselectAllMatchingMiniFilter(), this.refreshAfterSelection();
  }
  onGroupItemSelected(e, t) {
    const o = (n) => {
      if (!n.filterPasses)
        return;
      const s = n.children;
      if (s)
        for (const i of s.values())
          o(i);
      else
        this.setKeySelected(n.key, t);
    };
    o(e), this.refreshAfterSelection();
  }
  onItemSelected(e, t) {
    this.setKeySelected(e, t), this.refreshAfterSelection();
  }
  onExpandAll(e, t) {
    const o = (n) => {
      if (n.filterPasses && n.available && n.children) {
        for (const s of n.children.values())
          o(s);
        n.expanded = t;
      }
    };
    o(e), this.refreshAfterExpansion();
  }
  onExpandedChanged(e, t) {
    e.expanded = t, this.refreshAfterExpansion();
  }
  refreshAfterExpansion() {
    const e = this.virtualList.getLastFocusedRow();
    this.updateDisplayedValues("expansion"), this.checkAndRefreshVirtualList(), this.focusRowIfAlive(e);
  }
  refreshAfterSelection() {
    const e = this.virtualList.getLastFocusedRow();
    this.checkAndRefreshVirtualList(), this.onUiChanged(), this.focusRowIfAlive(e);
  }
  setMiniFilter(e, t) {
    this.eMiniFilter.setValue(e, t), this.onMiniFilterInput(t);
  }
  /** Sets mini filter value. Returns true if it changed from last value, otherwise false. */
  doSetMiniFilter(e) {
    return e = Ft(e), this.miniFilterText === e ? !1 : (e === null && (this.addCurrentSelectionToFilter = !1), this.miniFilterText = e, this.updateDisplayedValues("miniFilter"), !0);
  }
  getMiniFilter() {
    return this.miniFilterText;
  }
  getUiChangeEventParams() {
    return {
      miniFilterValue: this.miniFilterText
    };
  }
  getState() {
    const e = this.miniFilterText;
    return e ? { miniFilterValue: e } : void 0;
  }
  checkAndRefreshVirtualList() {
    this.virtualList.refresh(!this.hardRefreshVirtualList), this.hardRefreshVirtualList && (this.hardRefreshVirtualList = !1);
  }
  /**
   * @deprecated v34 Use the same method on the filter handler (`api.getColumnFilterHandler()`) instead.
   */
  getFilterKeys() {
    return X(283), this.handler.getFilterKeys();
  }
  /**
   * @deprecated v34 Use the same method on the filter handler (`api.getColumnFilterHandler()`) instead.
   */
  getFilterValues() {
    return X(283), this.handler.getFilterValues();
  }
  refreshVirtualList() {
    this.params.refreshValuesOnOpen ? this.doRefreshFilterValues() : this.checkAndRefreshVirtualList();
  }
  isSelectAllSelected() {
    if (this.params.defaultToNothingSelected) {
      if (this.hasSelections() && this.isEverythingVisibleSelected())
        return !0;
      if (this.isNothingVisibleSelected())
        return !1;
    } else {
      if (this.hasSelections() && this.isNothingVisibleSelected())
        return !1;
      if (this.isEverythingVisibleSelected())
        return !0;
    }
  }
  areAllChildrenSelected(e) {
    const t = (o) => {
      if (o.children) {
        let n = !1, s = !1;
        for (const i of o.children.values()) {
          if (!i.filterPasses || !i.available)
            continue;
          const r = t(i);
          if (r === void 0 || (r ? n = !0 : s = !0, n && s))
            return;
        }
        return n;
      } else
        return this.selectedKeys.has(o.key);
    };
    return this.params.defaultToNothingSelected ? this.hasSelections() && t(e) : t(e);
  }
  resetExpansion() {
    if (!this.params.treeList)
      return;
    const e = this.displayValueModel.getSelectAllItem();
    if (this.isSetFilterModelTreeItem(e)) {
      const t = (o) => {
        const n = o.children;
        if (n) {
          for (const s of n.values())
            t(s);
          o.expanded = !1;
        }
      };
      t(e), this.updateDisplayedValues("expansion");
    }
  }
  getModelAsString(e) {
    return this.handler.getModelAsString(e);
  }
  getPositionableElement() {
    return this.eSetFilterList;
  }
  updateDisplayedValues(e, t) {
    if (e === "expansion") {
      this.displayValueModel.refresh();
      return;
    }
    const o = this.handler, n = o.valueModel;
    if (this.miniFilterText == null) {
      this.displayValueModel.updateDisplayedValuesToAllAvailable(
        (l) => n.allValues.get(l) ?? null,
        t,
        n.availableKeys,
        e
      );
      return;
    }
    const s = o.caseFormat(this.formatter(this.miniFilterText) || ""), i = (l) => l != null && o.caseFormat(l).indexOf(s) >= 0, r = !!this.params.excelMode && i(ho(this, "blanks"));
    this.displayValueModel.updateDisplayedValuesToMatchMiniFilter(
      (l) => n.allValues.get(l) ?? null,
      t,
      n.availableKeys,
      i,
      r,
      e
    );
  }
  hasSelections() {
    return this.params.defaultToNothingSelected ? this.selectedKeys.size > 0 : this.handler.valueModel.allValues.size !== this.selectedKeys.size;
  }
  isInWindowsExcelMode() {
    return this.params.excelMode === "windows";
  }
  isAddCurrentSelectionToFilterChecked() {
    return this.isInWindowsExcelMode() && this.addCurrentSelectionToFilter;
  }
  showAddCurrentSelectionToFilter() {
    return this.isInWindowsExcelMode() && ue(this.miniFilterText) && this.miniFilterText.length > 0;
  }
  selectAllMatchingMiniFilter(e = !1) {
    this.miniFilterText == null ? this.selectedKeys = new Set(this.handler.valueModel.allValues.keys()) : (e && this.selectedKeys.clear(), this.displayValueModel.forEachDisplayedKey((t) => this.selectedKeys.add(t)));
  }
  deselectAllMatchingMiniFilter() {
    this.miniFilterText == null ? this.selectedKeys.clear() : this.displayValueModel.forEachDisplayedKey((e) => this.selectedKeys.delete(e));
  }
  setKeySelected(e, t) {
    t ? this.selectedKeys.add(e) : (this.params.excelMode && this.isEverythingVisibleSelected() && this.resetSelectionState(this.displayValueModel.getDisplayedKeys()), this.selectedKeys.delete(e));
  }
  isEverythingVisibleSelected() {
    return !this.displayValueModel.someDisplayedKey((e) => !this.selectedKeys.has(e));
  }
  isNothingVisibleSelected() {
    return !this.displayValueModel.someDisplayedKey((e) => this.selectedKeys.has(e));
  }
  getSelectedModel() {
    var t;
    if (!this.hasSelections())
      return null;
    const e = this.isAddCurrentSelectionToFilterChecked() ? (t = this.params.model) == null ? void 0 : t.values : void 0;
    if (e != null && e.length) {
      if (this.selectedKeys) {
        const o = /* @__PURE__ */ new Set([...e, ...this.selectedKeys]);
        return Array.from(o);
      }
      return Array.from(e);
    }
    return Array.from(this.selectedKeys);
  }
  setSelectedModel(e) {
    const t = this.handler, o = t.valueModel;
    return o.allKeys.then((n) => {
      if (e == null)
        this.resetSelectionState(n ?? []);
      else {
        this.selectedKeys.clear();
        const s = /* @__PURE__ */ new Map();
        o.allValues.forEach((i, r) => {
          s.set(t.caseFormat(r), r);
        }), e.forEach((i) => {
          const r = t.caseFormat(Ft(i)), l = s.get(r);
          l !== void 0 && this.selectedKeys.add(l);
        });
      }
    });
  }
  resetSelectionState(e) {
    this.params.defaultToNothingSelected ? this.selectedKeys.clear() : this.selectedKeys = new Set(e);
  }
  getFilterHandler() {
    return this.handler;
  }
  destroy() {
    var e;
    this.virtualList = this.destroyBean(this.virtualList), (e = this.handlerDestroyFuncs) == null || e.forEach((t) => t()), this.handler = void 0, this.displayValueModel = void 0, this.selectedKeys.clear(), super.destroy();
  }
}, fJe = class {
  constructor(e) {
    this.model = e;
  }
  getRowCount() {
    return this.model.getDisplayedValueCount();
  }
  getRow(e) {
    return this.model.getDisplayedItem(e);
  }
  areRowsEqual(e, t) {
    return e === t;
  }
}, vJe = class {
  constructor(e, t) {
    this.model = e, this.showAddCurrentSelectionToFilter = t;
  }
  getRowCount() {
    const t = this.showAddCurrentSelectionToFilter() ? 2 : 1;
    return this.model.getDisplayedValueCount() + t;
  }
  getRow(e) {
    if (e === 0)
      return this.model.getSelectAllItem();
    const t = this.showAddCurrentSelectionToFilter(), o = t ? 2 : 1;
    return e === 1 && t ? this.model.getAddSelectionToFilterItem() : this.model.getDisplayedItem(e - o);
  }
  areRowsEqual(e, t) {
    return e === t;
  }
}, mJe = class {
  constructor(e) {
    this.model = e;
  }
  getRowCount() {
    return this.model.getRowCount();
  }
  getRow(e) {
    return this.model.getRow(e);
  }
  areRowsEqual(e, t) {
    return e == null && t == null ? !0 : e != null && t != null && e.treeKey === t.treeKey && e.depth === t.depth;
  }
}, CJe = class extends K {
  constructor(e, t, o, n, s) {
    super(), this.createKey = e, this.caseFormat = t, this.getValue = o, this.isTreeDataOrGrouping = n, this.isTreeData = s;
  }
  extractUniqueValuesAsync(e, t) {
    return new Ye((o) => {
      if (this.beans.rowModel.isRowDataLoaded())
        o(this.extractUniqueValues(e, t));
      else {
        const [n] = this.addManagedEventListeners({
          rowCountReady: () => {
            n == null || n(), o(this.extractUniqueValues(e, t));
          }
        });
      }
    });
  }
  extractUniqueValues(e, t) {
    var d;
    const o = /* @__PURE__ */ new Map(), n = this.extractExistingFormattedKeys(t), s = /* @__PURE__ */ new Set(), i = this.isTreeData(), r = this.isTreeDataOrGrouping(), l = (d = this.beans.rowGroupColsSvc) == null ? void 0 : d.columns, a = this.gos.get("groupAllowUnbalanced"), c = (u, h) => {
      const p = this.caseFormat(u);
      if (!s.has(p)) {
        s.add(p);
        let C = u, m = Ft(h);
        const w = n == null ? void 0 : n.get(p);
        w != null && (C = w, m = t.get(w)), o.set(C, m);
      }
    };
    return this.beans.rowModel.forEachLeafNode((u) => {
      if (!u.data || !e(u))
        return;
      if (r) {
        this.addValueForTreeDataOrGrouping(u, i, l, c, a);
        return;
      }
      const h = this.getValue(u);
      h != null && Array.isArray(h) ? (h.forEach((p) => {
        c(this.createKey(p, u), p);
      }), h.length === 0 && c(null, null)) : c(this.createKey(h, u), h);
    }), o;
  }
  addValueForTreeDataOrGrouping(e, t, o = [], n, s) {
    var l;
    let i;
    if (t) {
      if ((l = e.childrenAfterGroup) != null && l.length)
        return;
      i = e.getRoute() ?? [e.key ?? e.id];
    } else
      i = o.map((a) => this.beans.valueSvc.getKeyForNode(a, e)), i.push(this.getValue(e));
    const r = T5(i, t, s);
    n(this.createKey(r), r);
  }
  extractExistingFormattedKeys(e) {
    if (!e)
      return null;
    const t = /* @__PURE__ */ new Map();
    return e.forEach((o, n) => {
      t.set(this.caseFormat(n), n);
    }), t;
  }
}, wJe = class {
  constructor(e) {
    this.caseFormat = e, this.keys = null;
  }
  /** No model applied */
  isNull() {
    return this.keys == null;
  }
  /** Nothing selected */
  isEmpty() {
    var e;
    return !((e = this.keys) != null && e.size);
  }
  update(e) {
    const t = /* @__PURE__ */ new Set();
    this.keys = t;
    const o = e == null ? void 0 : e.values;
    if (o) {
      const n = this.caseFormat;
      for (let s = 0, i = o.length; s < i; s++)
        t.add(n(o[s]));
    }
  }
  has(e) {
    var t;
    return !!((t = this.keys) != null && t.has(this.caseFormat(e)));
  }
  destroy() {
    this.keys = null;
  }
}, k_ = /* @__PURE__ */ ((e) => (e[e.PROVIDED_LIST = 0] = "PROVIDED_LIST", e[e.PROVIDED_CALLBACK = 1] = "PROVIDED_CALLBACK", e[e.TAKEN_FROM_GRID_VALUES = 2] = "TAKEN_FROM_GRID_VALUES", e))(k_ || {}), E0 = k_, bJe = class extends K {
  constructor(e, t, o, n, s) {
    super(), this.clientSideValuesExtractor = e, this.caseFormat = t, this.createKey = o, this.isTreeDataOrGrouping = n, this.params = s, this.allValues = /* @__PURE__ */ new Map(), this.availableKeys = /* @__PURE__ */ new Set(), this.providedValues = null, this.initialised = !1;
  }
  postConstruct() {
    const e = this.params, t = e.handlerParams.filterParams.values;
    this.updateParams(e), t == null ? this.valuesType = 2 : (this.valuesType = Array.isArray(t) ? 0 : 1, this.providedValues = t), this.updateAllValues();
  }
  refresh(e) {
    const t = e.handlerParams;
    if (t.source !== "colDef")
      return;
    const { values: o, suppressSorting: n } = t.filterParams, s = this.providedValues, i = this.params.handlerParams.filterParams.suppressSorting;
    this.params = e, this.updateParams(e), this.providedValues = o ?? null, (this.providedValues !== s || n !== i) && (!o || o.length === 0 ? (this.valuesType = 2, this.providedValues = null) : this.valuesType = Array.isArray(o) ? 0 : 1, this.updateAllValues());
  }
  updateParams(e) {
    const {
      handlerParams: {
        colDef: t,
        filterParams: { comparator: o, treeList: n, treeListPathGetter: s }
      },
      usingComplexObjects: i
    } = e, r = o ?? t.comparator, l = this.isTreeDataOrGrouping();
    let a;
    l && !r ? a = pJe() : n && !s && !r ? a = ([c, d], [u, h]) => vl(d, h) : a = ([c, d], [u, h]) => r(d, h), this.entryComparator = a, this.keyComparator = r ?? vl, this.compareByValue = !!(i && r || l || n && !s);
  }
  updateAllValues() {
    return this.allKeys = new Ye((e) => {
      switch (this.valuesType) {
        case 2:
          this.getValuesFromRowsAsync().then((t) => e(this.processAllValues(t)));
          break;
        case 0: {
          e(
            this.processAllValues(
              this.uniqueValues(this.validateProvidedValues(this.providedValues))
            )
          );
          break;
        }
        case 1: {
          this.dispatchLocalEvent({ type: "loadingStart" });
          const t = this.providedValues, { column: o, colDef: n } = this.params.handlerParams, s = Pe(this.gos, {
            success: (i) => {
              this.dispatchLocalEvent({ type: "loadingEnd" }), e(this.processAllValues(this.uniqueValues(this.validateProvidedValues(i))));
            },
            colDef: n,
            column: o
          });
          window.setTimeout(() => t(s), 0);
          break;
        }
      }
    }), this.allKeys.then((e) => {
      this.updateAvailableKeys(e ?? []), this.initialised = !0;
    }), this.allKeys;
  }
  getAvailableValues(e) {
    return this.sortKeys(this.getValuesFromRows(e));
  }
  overrideValues(e) {
    return this.allKeys.then(() => {
      this.valuesType = 0, this.providedValues = e;
    });
  }
  refreshAvailable() {
    return new Ye((e) => {
      if (this.showAvailableOnly()) {
        this.allKeys.then((t) => {
          const o = t ?? [];
          this.updateAvailableKeys(o), e(!0);
        });
        return;
      }
      e(!1);
    });
  }
  refreshAll() {
    return new Ye((e) => {
      this.allKeys.then(() => {
        this.updateAllValues().then(() => {
          e();
        });
      });
    });
  }
  isLoading() {
    return !this.initialised && this.valuesType === 1;
  }
  isInitialised() {
    return this.initialised;
  }
  getValueForFormatter(e) {
    return this.initialised ? this.allValues.get(e) : e;
  }
  getAvailableKeys(e) {
    return this.initialised ? e.filter((t) => this.availableKeys.has(t)) : e;
  }
  getParamsForValuesFromRows(e) {
    if (!this.clientSideValuesExtractor) {
      qe(113);
      return;
    }
    return e && !this.params.handlerParams.filterParams.caseSensitive ? this.allValues : void 0;
  }
  getValuesFromRows(e) {
    var o;
    const t = this.getParamsForValuesFromRows(!0);
    return ((o = this.clientSideValuesExtractor) == null ? void 0 : o.extractUniqueValues(e, t)) ?? null;
  }
  getValuesFromRowsAsync() {
    var t;
    const e = this.getParamsForValuesFromRows(!1);
    return ((t = this.clientSideValuesExtractor) == null ? void 0 : t.extractUniqueValuesAsync(() => !0, e)) ?? Ye.resolve(null);
  }
  processAllValues(e) {
    const t = this.sortKeys(e);
    return this.allValues = e ?? /* @__PURE__ */ new Map(), t;
  }
  uniqueValues(e) {
    const t = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Set(), { caseFormat: n, createKey: s } = this;
    return (e ?? []).forEach((i) => {
      const r = Ft(i), l = s(r), a = n(l);
      o.has(a) || (o.add(a), t.set(l, r));
    }), t;
  }
  validateProvidedValues(e) {
    if (this.params.usingComplexObjects && (e != null && e.length)) {
      const t = e[0];
      t && typeof t != "object" && typeof t != "function" && (this.createKey(t) == null ? X(209) : X(210));
    }
    return e;
  }
  sortKeys(e) {
    const t = e ?? /* @__PURE__ */ new Map(), o = this.params.handlerParams.filterParams;
    if (o.suppressSorting)
      return Array.from(t.keys());
    let n;
    return this.compareByValue ? n = Array.from(t.entries()).sort(this.entryComparator).map(([s]) => s) : n = Array.from(t.keys()).sort(this.keyComparator), o.excelMode && t.has(null) && (n = n.filter((s) => s != null), n.push(null)), n;
  }
  showAvailableOnly() {
    return this.valuesType === 2;
  }
  updateAvailableKeys(e) {
    const t = this.showAvailableOnly() ? this.getAvailableValues((o) => this.params.handlerParams.doesRowPassOtherFilter(o)) : e;
    this.availableKeys = new Set(t), this.dispatchLocalEvent({ type: "availableValuesChanged" });
  }
}, yJe = class extends K {
  constructor() {
    super(...arguments), this.filterType = "set", this.treeDataTreeList = !1, this.groupingTreeList = !1, this.caseSensitive = !1, this.noValueFormatterSupplied = !1;
  }
  init(e) {
    this.updateParams(e);
    const t = this.isTreeDataOrGrouping.bind(this), o = () => this.treeDataTreeList, n = this.createKey, s = this.caseFormat.bind(this), { gos: i, beans: r } = this, l = dt(i, r.rowModel) ? this.createManagedBean(
      new CJe(
        n,
        s,
        e.getValue,
        t,
        o
      )
    ) : void 0;
    this.valueModel = this.createManagedBean(
      new bJe(l, s, n, t, {
        handlerParams: e,
        usingComplexObjects: !!(e.filterParams.keyCreator ?? e.colDef.keyCreator)
      })
    ), this.appliedModel = new wJe(this.caseFormat.bind(this)), this.appliedModel.update(e.model), this.validateModel(e), this.addEventListenersForDataChanges();
  }
  refresh(e) {
    this.updateParams(e), this.valueModel.refresh({
      handlerParams: e,
      usingComplexObjects: !!(e.filterParams.keyCreator ?? e.colDef.keyCreator)
    }), this.appliedModel.update(e.model), this.validateModel(e);
  }
  updateParams(e) {
    var a;
    this.params = e;
    const {
      colDef: t,
      filterParams: { caseSensitive: o, treeList: n, keyCreator: s, valueFormatter: i }
    } = e;
    this.caseSensitive = !!o;
    const r = !!t.showRowGroup;
    this.treeDataTreeList = this.gos.get("treeData") && !!n && r, this.groupingTreeList = !!((a = this.beans.rowGroupColsSvc) != null && a.columns.length) && !!n && r;
    const l = s ?? t.keyCreator;
    this.createKey = this.generateCreateKey(l, this.isTreeDataOrGrouping()), this.setValueFormatter(i, l, !!n, !!t.refData);
  }
  doesFilterPass(e) {
    const { appliedModel: t, treeDataTreeList: o, groupingTreeList: n } = this;
    if (t.isNull())
      return !0;
    if (t.isEmpty())
      return !1;
    const { node: s } = e;
    if (o)
      return this.doesFilterPassForTreeData(s);
    if (n)
      return this.doesFilterPassForGrouping(s);
    const i = this.params.getValue(s);
    return i != null && Array.isArray(i) ? i.length === 0 ? t.has(null) : i.some((r) => t.has(this.createKey(r, s))) : t.has(this.createKey(i, s));
  }
  getFormattedValue(e) {
    let t = this.valueModel.getValueForFormatter(e);
    this.noValueFormatterSupplied && this.isTreeDataOrGrouping() && Array.isArray(t) && (t = Ke(t));
    const o = this.beans.valueSvc.formatValue(
      this.params.column,
      null,
      t,
      this.valueFormatter,
      !1
    );
    return o ?? Co(t) ?? ho(this, "blanks");
  }
  getModelAsString(e, t) {
    const { values: o } = e ?? {}, n = t === "filterToolPanel";
    if (o == null)
      return n ? ho(this, "filterSummaryListInactive") : "";
    const s = this.valueModel.getAvailableKeys(o), i = s.length, r = n ? 3 : 10, l = s.slice(0, r).map((a) => this.getFormattedValue(a));
    if (n) {
      const a = l.join(ho(this, "filterSummaryListSeparator"));
      return i > 3 ? ho(this, "filterSummaryListLong", [a, String(i - 3)]) : ho(this, "filterSummaryListShort", [a]);
    }
    return `(${i}) ${l.join(",")}${i > 10 ? ",..." : ""}`;
  }
  onAnyFilterChanged() {
    window.setTimeout(() => {
      this.isAlive() && this.valueModel.refreshAvailable().then((e) => {
        this.dispatchLocalEvent({ type: "anyFilterChanged", updated: !!e });
      });
    });
  }
  onNewRowsLoaded() {
    this.syncAfterDataChange();
  }
  setFilterValues(e) {
    this.valueModel.overrideValues(e).then(() => {
      this.refreshFilterValues();
    });
  }
  resetFilterValues() {
    this.valueModel.valuesType = E0.TAKEN_FROM_GRID_VALUES, this.syncAfterDataChange();
  }
  /**
   * @param suppressAvailableValuesCheck when refreshing values via the API, the model will be reset if all available values are selected.
   * When refreshing due to internal changes, set this to `true` to do the reset check based on all values instead.
   */
  refreshFilterValues(e) {
    this.valueModel.isInitialised() && this.valueModel.refreshAll().then(() => {
      this.dispatchLocalEvent({ type: "dataChanged", hardRefresh: !0 }), this.validateModel(this.params, void 0, !e);
    });
  }
  getFilterKeys() {
    return Array.from(this.valueModel.allValues.keys());
  }
  getFilterValues() {
    return Array.from(this.valueModel.allValues.values());
  }
  isTreeDataOrGrouping() {
    return this.treeDataTreeList || this.groupingTreeList;
  }
  caseFormat(e) {
    return e == null || typeof e != "string" || this.caseSensitive ? e : e.toUpperCase();
  }
  addEventListenersForDataChanges() {
    this.addManagedPropertyListeners(["groupAllowUnbalanced"], () => this.syncAfterDataChange());
    const e = Rt(this, this.syncAfterDataChange.bind(this), 0);
    this.addManagedEventListeners({
      cellValueChanged: (t) => {
        t.column === this.params.column && e();
      }
    });
  }
  syncAfterDataChange() {
    this.isValuesTakenFromGrid() && this.valueModel.refreshAll().then(() => {
      this.dispatchLocalEvent({ type: "dataChanged" }), this.validateModel(this.params, { afterDataChange: !0 });
    });
  }
  validateModel(e, t, o) {
    const n = this.valueModel;
    n.allKeys.then(() => {
      const s = e.model;
      if (s == null)
        return;
      const i = /* @__PURE__ */ new Map(), r = (h) => i.set(this.caseFormat(h), h);
      if (o)
        for (const h of n.availableKeys)
          r(h);
      else
        n.allValues.forEach((h, p) => r(p));
      const l = [];
      let a = !1;
      for (const h of s.values) {
        const p = this.caseFormat(Ft(h)), C = i.get(p);
        C !== void 0 ? (l.push(C), C !== h && (a = !0)) : a = !0;
      }
      const c = l.length;
      if (c === 0 && e.filterParams.excelMode) {
        e.onModelChange(null, t);
        return;
      }
      const u = (this.valueModel.valuesType === E0.TAKEN_FROM_GRID_VALUES || !e.filterParams.suppressClearModelOnRefreshValues) && c === i.size;
      if (a || !s.filterType || u) {
        const h = u ? null : { filterType: this.filterType, values: l };
        e.onModelChange(h, t);
        return;
      }
    });
  }
  isValuesTakenFromGrid() {
    return this.valueModel.valuesType === E0.TAKEN_FROM_GRID_VALUES;
  }
  doesFilterPassForTreeData(e) {
    var n;
    if ((n = e.childrenAfterGroup) != null && n.length)
      return !1;
    const { gos: t, appliedModel: o } = this;
    return o.has(
      this.createKey(
        T5(
          e.getRoute() ?? [e.key ?? e.id],
          !0,
          t.get("groupAllowUnbalanced")
        )
      )
    );
  }
  doesFilterPassForGrouping(e) {
    const {
      appliedModel: t,
      params: o,
      gos: n,
      beans: { rowGroupColsSvc: s, valueSvc: i }
    } = this, r = ((s == null ? void 0 : s.columns) ?? []).map((l) => i.getKeyForNode(l, e));
    return r.push(o.getValue(e)), t.has(
      this.createKey(T5(r, !1, n.get("groupAllowUnbalanced")))
    );
  }
  generateCreateKey(e, t) {
    return t && !e ? (qe(250), () => null) : e ? (o, n = null) => {
      const s = this.getKeyCreatorParams(o, n);
      return Ft(e(s));
    } : (o) => Ft(Co(o));
  }
  getKeyCreatorParams(e, t = null) {
    const { colDef: o, column: n } = this.params;
    return Pe(this.gos, {
      value: e,
      colDef: o,
      column: n,
      node: t,
      data: t == null ? void 0 : t.data
    });
  }
  setValueFormatter(e, t, o, n) {
    let s = e;
    if (!s) {
      if (t && !o) {
        qe(249);
        return;
      }
      this.noValueFormatterSupplied = !0, n || (s = (i) => Co(i.value));
    }
    this.valueFormatter = s;
  }
  getCrossFilterModel(e) {
    var s;
    const { createKey: t, valueModel: o, params: n } = this;
    return e(t, o.availableKeys, (s = n.model) == null ? void 0 : s.values);
  }
  destroy() {
    this.appliedModel.destroy(), super.destroy(), this.valueModel = void 0;
  }
}, _Je = {
  tag: "div",
  cls: "ag-floating-filter-input ag-set-floating-filter-input",
  role: "presentation",
  children: [
    {
      tag: "ag-input-text-field",
      ref: "eFloatingFilterText"
    }
  ]
}, SJe = class extends Re {
  constructor() {
    super(_Je, [zo]), this.eFloatingFilterText = J, this.listenerAdded = !1;
  }
  init(e) {
    this.params = e, this.eFloatingFilterText.setDisabled(!0).addGuiEventListener("click", () => this.params.showParentFilter()), this.setParams(e);
  }
  setParams(e) {
    const t = this.beans.colNames.getDisplayNameForColumn(e.column, "header", !0), o = this.getLocaleTextFunc();
    if (this.eFloatingFilterText.setInputAriaLabel(`${t} ${o("ariaFilterInput", "Filter Input")}`), this.gos.get("enableFilterHandlers")) {
      const n = e;
      this.updateFloatingFilterText(n.model);
    }
  }
  refresh(e) {
    this.params = e, this.setParams(e);
  }
  onParentModelChanged(e) {
    this.updateFloatingFilterText(e);
  }
  parentSetFilterInstance(e) {
    this.params.parentFilterInstance((t) => {
      if (!(t instanceof D_)) {
        qe(248);
        return;
      }
      e(t);
    });
  }
  addAvailableValuesListener() {
    const e = (t) => {
      if (t == null || !t.isAlive())
        return;
      const o = t.valueModel;
      this.destroyListeners = o.addManagedListeners(o, {
        availableValuesChanged: () => this.updateFloatingFilterText(t.params.model),
        destroyed: () => {
          this.listenerAdded = !1, this.destroyListeners = void 0;
        }
      });
    };
    this.gos.get("enableFilterHandlers") ? e(this.params.getHandler()) : this.parentSetFilterInstance((t) => {
      e(t.handler);
    }), this.listenerAdded = !0;
  }
  updateFloatingFilterText(e) {
    var t, o;
    e == null ? this.eFloatingFilterText.setValue("") : (this.listenerAdded || this.addAvailableValuesListener(), this.gos.get("enableFilterHandlers") ? this.eFloatingFilterText.setValue(
      ((o = (t = this.params.getHandler()).getModelAsString) == null ? void 0 : o.call(t, e)) ?? ""
    ) : this.parentSetFilterInstance((n) => {
      this.eFloatingFilterText.setValue(n.getModelAsString(e));
    }));
  }
  destroy() {
    const e = this.destroyListeners;
    e && (e.forEach((t) => t()), e.length = 0), super.destroy();
  }
}, xJe = {
  moduleName: "SetFilter",
  version: yt,
  userComponents: {
    agSetColumnFilter: {
      classImp: D_,
      params: {
        useForm: !0
      },
      processParams: (e) => (gJe(e), e)
    },
    agSetColumnFloatingFilter: SJe
  },
  dynamicBeans: {
    agSetColumnFilterHandler: yJe
  },
  icons: {
    // set filter tree list group contracted (click to expand)
    setFilterGroupClosed: "tree-closed",
    // set filter tree list group expanded (click to contract)
    setFilterGroupOpen: "tree-open",
    // set filter tree list expand/collapse all button, shown when some children are expanded and
    //     others are collapsed
    setFilterGroupIndeterminate: "tree-indeterminate",
    // set filter async values loading
    setFilterLoading: "loading"
  },
  dependsOn: [ko, v1]
}, MJe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "aggColNameSvc";
  }
  getHeaderName(e, t) {
    if (this.gos.get("suppressAggFuncInHeader"))
      return t;
    const { valueColsSvc: o, colModel: n, rowGroupColsSvc: s } = this.beans, i = e.getColDef().pivotValueColumn, r = ue(i);
    let l = null, a;
    if (r) {
      const c = (o == null ? void 0 : o.columns) ?? [], d = this.gos.get("removePivotHeaderRowWhenSingleValueColumn") && c.length === 1, u = e.getColDef().pivotTotalColumnIds !== void 0;
      if (d && !u)
        return t;
      l = i ? i.getAggFunc() : null, a = !0;
    } else {
      const c = e.isValueActive(), d = n.isPivotMode() || (s == null ? void 0 : s.columns.length) !== 0;
      c && d ? (l = e.getAggFunc(), a = !0) : a = !1;
    }
    if (a) {
      const c = typeof l == "string" ? l : "func";
      return `${this.getLocaleTextFunc()(c, c)}(${t})`;
    }
    return t;
  }
}, AJe = {
  sum: "Sum",
  first: "First",
  last: "Last",
  min: "Min",
  max: "Max",
  count: "Count",
  avg: "Average"
}, LJe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "aggFuncSvc", this.aggFuncsMap = {}, this.initialised = !1;
  }
  postConstruct() {
    this.init();
  }
  init() {
    this.initialised || (this.initialiseWithDefaultAggregations(), this.addAggFuncs(this.gos.get("aggFuncs")));
  }
  initialiseWithDefaultAggregations() {
    const e = this.aggFuncsMap;
    e.sum = EJe, e.first = PJe, e.last = RJe, e.min = FJe, e.max = TJe, e.count = DJe, e.avg = HJe, this.initialised = !0;
  }
  isAggFuncPossible(e, t) {
    const n = this.getFuncNames(e).includes(t), s = ue(this.aggFuncsMap[t]);
    return n && s;
  }
  getDefaultFuncLabel(e) {
    return AJe[e] ?? e;
  }
  getDefaultAggFunc(e) {
    const t = e.getColDef().defaultAggFunc;
    if (ue(t) && this.isAggFuncPossible(e, t))
      return t;
    if (this.isAggFuncPossible(e, "sum"))
      return "sum";
    const o = this.getFuncNames(e);
    return o != null && o.length ? o[0] : null;
  }
  addAggFuncs(e) {
    if (this.init(), !!e)
      for (const t of Object.keys(e))
        e[t] && (this.aggFuncsMap[t] = e[t]);
  }
  getAggFunc(e) {
    return this.init(), this.aggFuncsMap[e];
  }
  getFuncNames(e) {
    const t = e.getColDef().allowedAggFuncs;
    return t ?? Object.keys(this.aggFuncsMap).sort();
  }
  clear() {
    this.aggFuncsMap = {};
  }
};
function EJe(e) {
  const { values: t } = e;
  let o = null;
  for (let n = 0; n < t.length; n++) {
    const s = t[n];
    typeof s == "number" ? o === null ? o = s : o += typeof o == "number" ? s : BigInt(s) : typeof s == "bigint" && (o === null ? o = s : o = (typeof o == "bigint" ? o : BigInt(o)) + s);
  }
  return o;
}
function PJe(e) {
  return e.values.length > 0 ? e.values[0] : null;
}
function RJe(e) {
  return e.values.length > 0 ? Ke(e.values) : null;
}
function FJe(e) {
  const { values: t } = e;
  let o = null;
  for (let n = 0; n < t.length; n++) {
    const s = t[n];
    (typeof s == "number" || typeof s == "bigint") && (o === null || o > s) && (o = s);
  }
  return o;
}
function TJe(e) {
  const { values: t } = e;
  let o = null;
  for (let n = 0; n < t.length; n++) {
    const s = t[n];
    (typeof s == "number" || typeof s == "bigint") && (o === null || o < s) && (o = s);
  }
  return o;
}
var IJe = Object.freeze({
  // the grid by default uses toString to render values for an object, so this
  // is a trick to get the default cellRenderer to display the avg value
  toString: function() {
    return this.value.toString();
  },
  // used for sorting
  toNumber: function() {
    return this.value;
  }
});
function DJe(e) {
  var i, r;
  const { values: t } = e;
  let o = 0;
  for (let l = 0; l < t.length; l++) {
    const a = t[l];
    o += a != null && typeof a.value == "number" ? a.value : 1;
  }
  const n = (r = (i = e.rowNode) == null ? void 0 : i.aggData) == null ? void 0 : r[e.column.getColId()];
  if (n && n.value === o)
    return n;
  const s = Object.create(IJe);
  return s.value = o, s;
}
var kJe = Object.freeze({
  // the grid by default uses toString to render values for an object, so this
  // is a trick to get the default cellRenderer to display the avg value
  toString: function() {
    return typeof this.value == "number" || typeof this.value == "bigint" ? this.value.toString() : "";
  },
  // used for sorting
  toNumber: function() {
    return this.value;
  }
});
function HJe(e) {
  var l, a, c;
  const { values: t } = e;
  let o = 0, n = 0;
  for (let d = 0; d < t.length; d++) {
    const u = t[d];
    let h = null;
    typeof u == "number" || typeof u == "bigint" ? (h = u, n++) : u != null && (typeof u.value == "number" || typeof u.value == "bigint") && typeof u.count == "number" && (h = u.value * (typeof u.value == "number" ? u.count : BigInt(u.count)), n += u.count), typeof h == "number" ? o += typeof o == "number" ? h : BigInt(h) : typeof h == "bigint" && (o = (typeof o == "bigint" ? o : BigInt(o)) + h);
  }
  let s = null;
  n > 0 && (s = o / (typeof o == "number" ? n : BigInt(n)));
  const i = (c = (l = e.rowNode) == null ? void 0 : l.aggData) == null ? void 0 : c[(a = e.column) == null ? void 0 : a.getColId()];
  if (i && i.count === n && i.value === s)
    return i;
  const r = Object.create(kJe);
  return r.count = n, r.value = s, r;
}
function VJe(e, t) {
  e.aggFuncSvc && e.aggFuncSvc.addAggFuncs(t);
}
function OJe(e) {
  e.aggFuncSvc && e.aggFuncSvc.clear();
}
function BJe(e, t, o) {
  var n, s;
  (s = (n = e.valueColsSvc) == null ? void 0 : n.setColumnAggFunc) == null || s.call(n, t, o, "api");
}
function P0(e, t, o, n, s, i) {
  const r = typeof o == "string" ? e.aggFuncSvc.getAggFunc(o) : o;
  if (typeof r != "function")
    return X(109, { inputValue: o.toString(), allSuggestions: e.aggFuncSvc.getFuncNames(n) }), null;
  const l = Pe(e.gos, {
    values: t,
    column: n,
    colDef: n.colDef,
    pivotResultColumn: i,
    rowNode: s,
    // this is typed incorrectly. Within CSRM, this will always be defined. When called from integrated charts, this will never be defined.
    data: s == null ? void 0 : s.data
  });
  return r(l);
}
var $Je = class extends K {
  constructor() {
    super(...arguments), this.beanName = "aggStage", this.refreshProps = /* @__PURE__ */ new Set([
      "getGroupRowAgg",
      "alwaysAggregateAtRootLevel",
      "suppressAggFilteredOnly",
      "grandTotalRow"
    ]), this.step = "aggregate";
  }
  wireBeans(e) {
    this.colModel = e.colModel, this.pivotColsSvc = e.pivotColsSvc, this.valueColsSvc = e.valueColsSvc, this.pivotResultCols = e.pivotResultCols, this.valueSvc = e.valueSvc;
  }
  // it's possible to recompute the aggregate without doing the other parts
  // + api.refreshClientSideRowModel('aggregate')
  execute(e) {
    var s, i, r;
    const t = !((i = (s = this.valueColsSvc) == null ? void 0 : s.columns) != null && i.length), o = !this.gos.getCallback("getGroupRowAgg");
    if (t && o && ((r = e.changedPath) != null && r.active))
      return;
    const n = this.createAggDetails(e);
    this.recursivelyCreateAggData(n);
  }
  createAggDetails(e) {
    var i;
    const t = this.colModel.isPivotActive(), o = (i = this.valueColsSvc) == null ? void 0 : i.columns, n = t && this.pivotColsSvc ? this.pivotColsSvc.columns : [];
    return {
      alwaysAggregateAtRootLevel: this.gos.get("alwaysAggregateAtRootLevel"),
      groupIncludeTotalFooter: !!or(this.gos),
      changedPath: e.changedPath,
      valueColumns: o ?? [],
      pivotColumns: n,
      filteredOnly: !this.isSuppressAggFilteredOnly(),
      userAggFunc: this.gos.getCallback("getGroupRowAgg")
    };
  }
  isSuppressAggFilteredOnly() {
    return jr(this.gos) !== void 0 || this.gos.get("suppressAggFilteredOnly");
  }
  recursivelyCreateAggData(e) {
    const t = (o) => {
      if (!o.hasChildren()) {
        o.aggData && this.setAggData(o, null);
        return;
      }
      if (o.level === -1 && !e.groupIncludeTotalFooter) {
        const i = !this.colModel.isPivotMode();
        if (!e.alwaysAggregateAtRootLevel && i) {
          this.setAggData(o, null);
          return;
        }
      }
      this.aggregateRowNode(o, e);
    };
    e.changedPath.forEachChangedNodeDepthFirst(t, !0);
  }
  aggregateRowNode(e, t) {
    const o = t.valueColumns.length === 0, n = t.pivotColumns.length === 0;
    let s;
    t.userAggFunc ? s = t.userAggFunc({ nodes: e.childrenAfterFilter }) : o ? s = null : n ? s = this.aggregateRowNodeUsingValuesOnly(e, t) : s = this.aggregateRowNodeUsingValuesAndPivot(e), this.setAggData(e, s), e.sibling && (this.setAggData(e.sibling, s), e.sibling.pinnedSibling && this.setAggData(e.sibling.pinnedSibling, s));
  }
  aggregateRowNodeUsingValuesAndPivot(e) {
    var i, r;
    const t = {}, o = ((r = (i = this.pivotResultCols) == null ? void 0 : i.getPivotResultCols()) == null ? void 0 : r.list) ?? [];
    let n = !0;
    const s = this.beans;
    for (let l = 0; l < o.length; l++) {
      const a = o[l], c = a.getColDef();
      if (c.pivotTotalColumnIds != null) {
        n = !1;
        continue;
      }
      const d = c.pivotKeys ?? [];
      let u;
      e.leafGroup ? u = this.getValuesFromMappedSet(e.childrenMapped, d, c.pivotValueColumn) : u = this.getValuesPivotNonLeaf(e, c.colId), t[c.colId] = P0(
        s,
        u,
        c.pivotValueColumn.getAggFunc(),
        c.pivotValueColumn,
        e,
        a
      );
    }
    if (!n)
      for (let l = 0; l < o.length; l++) {
        const a = o[l], c = a.getColDef();
        if (c.pivotTotalColumnIds == null || !c.pivotTotalColumnIds.length)
          continue;
        const d = c.pivotTotalColumnIds.map(
          (u) => t[u]
        );
        t[c.colId] = P0(
          s,
          d,
          c.pivotValueColumn.getAggFunc(),
          c.pivotValueColumn,
          e,
          a
        );
      }
    return t;
  }
  aggregateRowNodeUsingValuesOnly(e, t) {
    const o = {}, { changedPath: n, valueColumns: s, filteredOnly: i } = t, r = n.active ? n.getValueColumnsForNode(e, s) : s, l = n.active ? n.getNotValueColumnsForNode(e, s) : null, a = this.getValuesNormal(e, r, i), c = e.aggData, d = this.beans;
    return r.forEach((u, h) => {
      o[u.getId()] = P0(
        d,
        a[h],
        u.getAggFunc(),
        u,
        e
      );
    }), l && c && l.forEach((u) => {
      o[u.getId()] = c[u.getId()];
    }), o;
  }
  getValuesPivotNonLeaf(e, t) {
    return e.childrenAfterFilter.map((o) => o.aggData[t]);
  }
  getValuesFromMappedSet(e, t, o) {
    let n = e;
    for (let s = 0; s < t.length; s++) {
      const i = t[s];
      n = n ? n[i] : null;
    }
    return n ? n.map((s) => this.valueSvc.getValue(o, s)) : [];
  }
  getValuesNormal(e, t, o) {
    const n = [];
    t.forEach(() => n.push([]));
    const s = t.length, i = o ? e.childrenAfterFilter : e.childrenAfterGroup, r = i.length;
    for (let l = 0; l < r; l++) {
      const a = i[l];
      for (let c = 0; c < s; c++) {
        const d = t[c], u = this.valueSvc.getValue(d, a);
        n[c].push(u);
      }
    }
    return n;
  }
  setAggData(e, t) {
    const o = e.aggData;
    if (e.aggData = t, e.__localEventService) {
      const n = (s) => {
        const i = e.aggData ? e.aggData[s] : void 0, r = o ? o[s] : void 0;
        if (i === r)
          return;
        const l = this.colModel.getColById(s);
        l && e.dispatchCellChangedEvent(l, i, r);
      };
      if (o)
        for (const s of Object.keys(o))
          n(s);
      if (t)
        for (const s of Object.keys(t))
          (!o || !(s in o)) && n(s);
    }
  }
}, ZJe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "filterAggStage", this.refreshProps = /* @__PURE__ */ new Set([]), this.step = "filter_aggregates";
  }
  wireBeans(e) {
    this.filterManager = e.filterManager;
  }
  execute(e) {
    var c, d;
    const t = this.beans.colModel.isPivotMode(), o = ((c = this.filterManager) == null ? void 0 : c.isAggregateFilterPresent()) || ((d = this.filterManager) == null ? void 0 : d.isAggregateQuickFilterPresent()), n = (u) => !u.node.group, s = (u) => u.node.leafGroup, i = jr(this.gos) || (t ? s : n), { changedPath: r } = e, l = (u, h = !1) => {
      u.childrenAfterFilter && (u.childrenAfterAggFilter = u.childrenAfterFilter, h && u.childrenAfterAggFilter.forEach((p) => l(p, h)), this.setAllChildrenCount(u)), u.sibling && (u.sibling.childrenAfterAggFilter = u.childrenAfterAggFilter);
    }, a = (u) => {
      var h;
      u.childrenAfterAggFilter = ((h = u.childrenAfterFilter) == null ? void 0 : h.filter((p) => {
        var w;
        return i({ node: p }) && this.filterManager.doesRowPassAggregateFilters({ rowNode: p }) ? (l(p, !0), !0) : (w = p.childrenAfterAggFilter) == null ? void 0 : w.length;
      })) || null, this.setAllChildrenCount(u), u.sibling && (u.sibling.childrenAfterAggFilter = u.childrenAfterAggFilter);
    };
    r.forEachChangedNodeDepthFirst(o ? a : l, !0);
  }
  /** for tree data, we include all children, groups and leafs */
  setAllChildrenCountTreeData(e) {
    const t = e.childrenAfterAggFilter;
    let o = 0;
    if (t) {
      const n = t.length;
      o = n;
      for (let s = 0; s < n; ++s)
        o += t[s].allChildrenCount ?? 0;
    }
    e.setAllChildrenCount(
      // Maintain the historical behaviour:
      // - allChildrenCount is 0 in the root if there are no children
      // - allChildrenCount is null in any non-root row if there are no children
      o === 0 && e.level >= 0 ? null : o
    );
  }
  /* for grid data, we only count the leafs */
  setAllChildrenCountGridGrouping(e) {
    let t = 0;
    e.childrenAfterAggFilter.forEach((o) => {
      o.group ? t += o.allChildrenCount : t++;
    }), e.setAllChildrenCount(t);
  }
  setAllChildrenCount(e) {
    if (!e.hasChildren()) {
      e.setAllChildrenCount(null);
      return;
    }
    this.gos.get("treeData") ? this.setAllChildrenCountTreeData(e) : this.setAllChildrenCountGridGrouping(e);
  }
};
function kr(e, t) {
  if (e.sibling)
    return;
  const o = vb(e, t);
  o.footer = !0, o.setRowTop(null), o.setRowIndex(null), o.oldRowTop = null, o.id = "rowGroupFooter_" + e.id, o.sibling = e, e.sibling = o;
}
function GJe(e) {
  e.sibling && (e.sibling.setRowTop(null), e.sibling.setRowIndex(null), e.sibling = void 0);
}
var NJe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "footerSvc";
  }
  addTotalRows(e, t, o, n, s, i) {
    let r = e;
    if (s) {
      const c = n && or(this.gos);
      return zJe(i, c) && (kr(t, this.beans), o(t.sibling, r++)), r;
    }
    const l = Aw(this.gos);
    return (n && l({ node: t })) === i && (kr(t, this.beans), o(t.sibling, r++)), r;
  }
  getTopDisplayIndex(e, t, o, n) {
    let s = t;
    if (e[0].footer) {
      if (t === 0)
        return 0;
      s -= 1;
    }
    const i = e[e.length - 1], r = s >= o.length;
    return i.footer && r ? i.rowIndex : n(s);
  }
  doesCellShowTotalPrefix(e, t) {
    var o;
    return !e.footer || !(t != null && t.getColDef().showRowGroup) ? !1 : this.gos.get("treeData") ? !0 : e.level === -1 ? ((o = this.beans.showRowGroupCols) == null ? void 0 : o.getShowRowGroupCols()[0]) === t : !!e.rowGroupColumn && t && t.isRowGroupDisplayed(e.rowGroupColumn.getId());
  }
  applyTotalPrefix(e, t, o, n) {
    var i, r;
    const s = (i = n.getColDef().cellRendererParams) == null ? void 0 : i.totalValueGetter;
    if (s) {
      const l = Pe(this.gos, { column: n, node: o, value: e, formattedValue: t });
      if (typeof s === "function")
        return s(l);
      if (typeof s == "string")
        return (r = this.beans.expressionSvc) == null ? void 0 : r.evaluate(s, l);
      X(179);
    }
    return o.level === -1 ? this.getLocaleTextFunc()("footerTotal", "Total") + " " : this.getTotalValue(t ?? e) ?? "";
  }
  getTotalValue(e) {
    return this.getLocaleTextFunc()("footerTotal", "Total") + " " + (e ?? "");
  }
};
function zJe(e, t) {
  switch (t) {
    case "top":
    case "pinnedTop":
      return e === "top";
    case "bottom":
    case "pinnedBottom":
      return e === "bottom";
    default:
      return !1;
  }
}
var H_ = class extends F2 {
  constructor() {
    super(...arguments), this.beanName = "valueColsSvc", this.eventName = "columnValueChanged", this.columnProcessors = {
      set: (e, t, o) => this.setValueActive(t, e, o),
      add: (e, t, o) => this.setValueActive(!0, e, o),
      remove: (e, t, o) => this.setValueActive(!1, e, o)
    }, this.columnExtractors = {
      setFlagFunc: (e, t, o) => this.setColValueActive(e, t, o),
      getIndexFunc: () => {
      },
      getInitialIndexFunc: () => {
      },
      getValueFunc: (e) => {
        const t = e.aggFunc;
        if (t === null || t === "")
          return null;
        if (t !== void 0)
          return !!t;
      },
      getInitialValueFunc: (e) => e.initialAggFunc != null && e.initialAggFunc != ""
    }, this.modifyColumnsNoEventsCallbacks = {
      addCol: (e) => this.columns.push(e),
      removeCol: (e) => Zt(this.columns, e)
    };
  }
  extractCols(e, t) {
    return this.columns = super.extractCols(e, t), this.columns.forEach((o) => {
      const n = o.getColDef();
      n.aggFunc != null && n.aggFunc != "" ? this.setColAggFunc(o, n.aggFunc) : o.getAggFunc() || this.setColAggFunc(o, n.initialAggFunc);
    }), this.columns;
  }
  setColumnAggFunc(e, t, o) {
    if (!e)
      return;
    const n = this.colModel.getColDefCol(e);
    n && (this.setColAggFunc(n, t), this.dispatchColumnChangedEvent(this.eventSvc, this.eventName, [n], o));
  }
  syncColumnWithState(e, t, o) {
    const n = o("aggFunc").value1;
    n !== void 0 && (typeof n == "string" ? (this.setColAggFunc(e, n), e.isValueActive() || (this.setColValueActive(e, !0, t), this.modifyColumnsNoEventsCallbacks.addCol(e))) : (ue(n) && X(33), e.isValueActive() && (this.setColValueActive(e, !1, t), this.modifyColumnsNoEventsCallbacks.removeCol(e))));
  }
  setValueActive(e, t, o) {
    if (e !== t.isValueActive() && (this.setColValueActive(t, e, o), e && !t.getAggFunc() && this.aggFuncSvc)) {
      const n = this.aggFuncSvc.getDefaultAggFunc(t);
      this.setColAggFunc(t, n);
    }
  }
  setColAggFunc(e, t) {
    e.aggFunc = t, e.dispatchStateUpdatedEvent("aggFunc");
  }
  setColValueActive(e, t, o) {
    e.aggregationActive !== t && (e.aggregationActive = t, e.dispatchColEvent("columnValueChanged", o));
  }
}, wc = {
  moduleName: "SharedAggregation",
  version: yt,
  beans: [LJe, MJe, NJe, H_],
  apiFunctions: {
    addAggFuncs: VJe,
    clearAggFuncs: OJe,
    setColumnAggFunc: BJe
  },
  dependsOn: [ko]
}, V_ = {
  moduleName: "Aggregation",
  version: yt,
  beans: [$Je, ZJe],
  rowModels: ["clientSide"],
  dependsOn: [wc]
}, jJe = ({ valueSvc: e }, t, o) => {
  const n = e.getValue(t, o);
  let s = null;
  return n instanceof Date ? s = n : typeof n == "string" && (s = Wt(n)), s;
}, Un = (e, t, o, n) => (s) => {
  const i = jJe(e, t, s.node), r = Ci(i);
  return r ? (n == null ? void 0 : n(r[o])) ?? r[o] : null;
}, Kn = ({ colNames: e }, t, o) => (n) => {
  const s = e.getDisplayNameForColumn(t, n.location);
  return s ? `${s} (${o})` : "";
}, WJe = Object.fromEntries(Al.map((e) => [e, e.toLowerCase()])), UJe = (e) => {
  const t = Al[parseInt(e, 10) - 1] ?? e, o = WJe[t] ?? e;
  return { month: t, localeKey: o };
}, KJe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "groupHierarchyColSvc", this.columns = null, this.sourceColumnMap = /* @__PURE__ */ new WeakMap(), this.inverseColumnMap = /* @__PURE__ */ new WeakMap();
  }
  addColumns(e) {
    const t = this.columns;
    t != null && (e.list = t.list.filter((o) => !e.list.some((n) => n.getColId() === o.getColId())).concat(e.list), e.tree = t.tree.filter((o) => !e.tree.some((n) => n.getId() === o.getId())).concat(e.tree), R2(e));
  }
  createColumns(e) {
    var r, l;
    this.sourceColumnMap = /* @__PURE__ */ new WeakMap(), this.inverseColumnMap = /* @__PURE__ */ new WeakMap();
    const t = this.createGroupHierarchyColumns(e);
    if (P2(t, ((r = this.columns) == null ? void 0 : r.list) ?? []))
      return;
    Js(this.beans, (l = this.columns) == null ? void 0 : l.tree), this.columns = null;
    const { colGroupSvc: n } = this.beans, s = (n == null ? void 0 : n.findDepth(e.tree)) ?? 0, i = (n == null ? void 0 : n.balanceTreeForAutoCols(t, s)) ?? [];
    this.columns = {
      list: t,
      tree: i,
      treeDepth: s,
      map: {}
    };
  }
  updateColumns(e) {
  }
  getColumn(e) {
    var t;
    return ((t = this.columns) == null ? void 0 : t.list.find((o) => qr(o, e))) ?? null;
  }
  getColumns() {
    var e;
    return ((e = this.columns) == null ? void 0 : e.list) ?? null;
  }
  expandColumnInto(e, t) {
    const o = this.getVirtualColumnsForColumn(t).concat(t);
    for (const n of o)
      e.some((s) => qr(s, n) || s.getColId() === n.getColId()) || e.push(n);
  }
  compareVirtualColumns(e, t) {
    var s, i;
    const o = this.inverseColumnMap.get(e), n = this.inverseColumnMap.get(t);
    if (o && o === n) {
      const r = this.sourceColumnMap.get(o) ?? [];
      return (r == null ? void 0 : r.indexOf(e)) - (r == null ? void 0 : r.indexOf(t));
    }
    return (s = this.sourceColumnMap.get(e)) != null && s.includes(t) ? 1 : (i = this.sourceColumnMap.get(t)) != null && i.includes(e) ? -1 : null;
  }
  insertVirtualColumnsForCol(e, t) {
    const o = this.getVirtualColumnsForColumn(t) ?? [];
    for (const n of o)
      e.includes(n) || e.push(n);
  }
  getVirtualColumnsForColumn(e) {
    return this.isGroupHierarchyColsEnabledForCol(e) ? this.sourceColumnMap.get(e) ?? [] : [];
  }
  isGroupHierarchyColsEnabled(e) {
    return e.list.some((t) => this.isGroupHierarchyColsEnabledForCol(t));
  }
  isGroupHierarchyColsEnabledForCol(e) {
    const t = e.getColDef();
    return !!(t.rowGroupingHierarchy && (t.rowGroup || t.enableRowGroup));
  }
  createGroupHierarchyColDefs(e) {
    const t = [], o = e.getColDef();
    if (!o.rowGroupingHierarchy || !this.isGroupHierarchyColsEnabledForCol(e))
      return t;
    for (const n of o.rowGroupingHierarchy) {
      let s = null;
      typeof n == "string" ? s = this.createColDefForPart(n, e, o) : s = n, s && t.push(s);
    }
    return t;
  }
  createGroupHierarchyColumns(e) {
    if (!this.isGroupHierarchyColsEnabled(e))
      return [];
    const t = [];
    for (const o of e.list)
      this.createGroupHierarchyColDefs(o).forEach((n) => {
        const s = n.colId;
        this.gos.validateColDef(n, s, !0);
        const i = new Zn(n, null, s, !0);
        this.createBean(i), t.push(i), qJe(this.sourceColumnMap, o, i), this.inverseColumnMap.set(i, o);
      });
    return t;
  }
  createColDefForPart(e, t, o) {
    var d;
    const { beans: n, gos: s } = this, i = `${OIe}-${t.getColId()}-${e}`, r = {
      enableRowGroup: !0,
      rowGroup: o.rowGroup,
      enablePivot: o.enablePivot,
      hide: !0,
      editable: !1
    }, l = s.get("groupHierarchyConfig") ?? {};
    if (e in l) {
      const u = l[e];
      return u.colId ?? (u.colId = i), Zi(this.beans, { ...r, ...u }, u.colId, !0);
    }
    const a = Zi(n, { colId: i, ...r }, i, !0), c = (d = n.localeSvc) == null ? void 0 : d.getLocaleTextFunc();
    switch (e) {
      case "year":
        return {
          ...a,
          headerValueGetter: Kn(n, t, "Year"),
          valueGetter: Un(n, t, 0)
        };
      case "quarter":
        return {
          ...a,
          headerValueGetter: Kn(n, t, "Quarter"),
          valueGetter: Un(
            n,
            t,
            1,
            (u) => (Math.floor(Number(u) / 4) + 1).toString()
          )
        };
      case "month":
        return {
          ...a,
          headerValueGetter: Kn(n, t, "Month"),
          valueGetter: Un(n, t, 1)
        };
      case "formattedMonth":
        return {
          ...a,
          headerValueGetter: Kn(n, t, "Month"),
          valueGetter: Un(n, t, 1, (u) => {
            const h = UJe(u);
            return (c == null ? void 0 : c(h.localeKey, h.month)) ?? h.month;
          })
        };
      case "day":
        return {
          ...a,
          headerValueGetter: Kn(n, t, "Day"),
          valueGetter: Un(n, t, 2)
        };
      case "hour":
        return {
          ...a,
          headerValueGetter: Kn(n, t, "Hour"),
          valueGetter: Un(n, t, 3)
        };
      case "minute":
        return {
          ...a,
          headerValueGetter: Kn(n, t, "Minute"),
          valueGetter: Un(n, t, 4)
        };
      case "second":
        return {
          ...a,
          headerValueGetter: Kn(n, t, "Second"),
          valueGetter: Un(n, t, 5)
        };
      default:
        return null;
    }
  }
};
function qJe(e, t, o) {
  const n = e.get(t);
  e.set(t, (n ?? []).concat(o));
}
var YJe = {
  moduleName: "GroupHierarchy",
  version: yt,
  beans: [KJe]
}, QJe = class extends F2 {
  constructor() {
    super(...arguments), this.beanName = "pivotColsSvc", this.eventName = "columnPivotChanged", this.columnProcessors = {
      set: (e, t, o) => this.setColPivotActive(e, t, o),
      add: (e, t, o) => this.setColPivotActive(e, !0, o),
      remove: (e, t, o) => this.setColPivotActive(e, !1, o)
    }, this.columnOrdering = {
      enableProp: "pivot",
      initialEnableProp: "initialPivot",
      indexProp: "pivotIndex",
      initialIndexProp: "initialPivotIndex"
    }, this.columnExtractors = {
      setFlagFunc: (e, t, o) => this.setColPivotActive(e, t, o),
      getIndexFunc: (e) => e.pivotIndex,
      getInitialIndexFunc: (e) => e.initialPivotIndex,
      getValueFunc: (e) => e.pivot,
      getInitialValueFunc: (e) => e.initialPivot
    }, this.modifyColumnsNoEventsCallbacks = {
      addCol: (e) => this.columns.push(e),
      removeCol: (e) => Zt(this.columns, e)
    };
  }
  syncColumnWithState(e, t, o, n) {
    const { value1: s, value2: i } = o("pivot", "pivotIndex");
    (s !== void 0 || i !== void 0) && (typeof i == "number" || s ? (e.isPivotActive() || (this.setColPivotActive(e, !0, t), this.modifyColumnsNoEventsCallbacks.addCol(e)), n && typeof i == "number" && (n[e.getId()] = i)) : e.isPivotActive() && (this.setColPivotActive(e, !1, t), this.modifyColumnsNoEventsCallbacks.removeCol(e)));
  }
  setColPivotActive(e, t, o) {
    e.pivotActive !== t && (e.pivotActive = t, e.dispatchColEvent("columnPivotChanged", o)), e.dispatchStateUpdatedEvent("pivot");
  }
}, JJe = class extends F2 {
  constructor() {
    super(...arguments), this.beanName = "rowGroupColsSvc", this.eventName = "columnRowGroupChanged", this.columnProcessors = {
      set: (e, t, o) => this.setActive(t, e, o),
      add: (e, t, o) => this.setActive(!0, e, o),
      remove: (e, t, o) => this.setActive(!1, e, o)
    }, this.columnOrdering = {
      enableProp: "rowGroup",
      initialEnableProp: "initialRowGroup",
      indexProp: "rowGroupIndex",
      initialIndexProp: "initialRowGroupIndex"
    }, this.columnExtractors = {
      setFlagFunc: (e, t, o) => this.setColRowGroupActive(e, t, o),
      getIndexFunc: (e) => e.rowGroupIndex,
      getInitialIndexFunc: (e) => e.initialRowGroupIndex,
      getValueFunc: (e) => e.rowGroup,
      getInitialValueFunc: (e) => e.initialRowGroup
    }, this.modifyColumnsNoEventsCallbacks = {
      addCol: (e) => {
        var t;
        (t = this.beans.groupHierarchyColSvc) == null || t.insertVirtualColumnsForCol(this.columns, e), this.columns.includes(e) || this.columns.push(e);
      },
      removeCol: (e) => Zt(this.columns, e)
    };
  }
  moveColumn(e, t, o) {
    if (this.columns.length === 0)
      return;
    const n = this.columns[e], s = this.columns.slice(e, t);
    this.columns.splice(e, 1), this.columns.splice(t, 0, n), this.updateIndexMap(), this.eventSvc.dispatchEvent({
      type: this.eventName,
      columns: s,
      column: s.length === 1 ? s[0] : null,
      source: o
    });
  }
  syncColumnWithState(e, t, o, n) {
    const { value1: s, value2: i } = o("rowGroup", "rowGroupIndex");
    (s !== void 0 || i !== void 0) && (typeof i == "number" || s ? (e.isRowGroupActive() || (this.setColRowGroupActive(e, !0, t), this.modifyColumnsNoEventsCallbacks.addCol(e)), n && typeof i == "number" && (n[e.getId()] = i)) : e.isRowGroupActive() && (this.setColRowGroupActive(e, !1, t), this.modifyColumnsNoEventsCallbacks.removeCol(e)));
  }
  setActive(e, t, o) {
    var s;
    if (e === t.isRowGroupActive())
      return;
    this.setColRowGroupActive(t, e, o);
    const n = (s = this.beans.groupHierarchyColSvc) == null ? void 0 : s.getColumn(t);
    Pw(this.gos, e) && !n && this.colModel.setColsVisible([t], !e, o);
  }
  setColRowGroupActive(e, t, o) {
    var n;
    e.rowGroupActive !== t && (e.rowGroupActive = t, t && ((n = this.beans.groupHierarchyColSvc) == null || n.insertVirtualColumnsForCol(this.columns, e)), e.dispatchColEvent("columnRowGroupChanged", o)), e.dispatchStateUpdatedEvent("rowGroup");
  }
}, XJe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "autoColSvc";
  }
  postConstruct() {
    this.addManagedPropertyListener("autoGroupColumnDef", this.updateColumns.bind(this));
  }
  addColumns(e) {
    this.columns != null && (e.list = this.columns.list.concat(e.list), e.tree = this.columns.tree.concat(e.tree), R2(e));
  }
  createColumns(e, t) {
    var L;
    const o = this.beans, { colModel: n, gos: s, rowGroupColsSvc: i, colGroupSvc: r } = o, l = n.isPivotMode(), a = L2(s, l), c = l ? s.get("pivotSuppressAutoColumn") : this.isSuppressAutoCol(), d = i == null ? void 0 : i.columns, h = !(d && d.length > 0 || s.get("treeData")) || c || a, p = () => {
      this.columns && (Js(o, this.columns.tree), this.columns = null);
    };
    if (h) {
      p();
      return;
    }
    const C = this.generateAutoCols(d), m = P2(C, ((L = this.columns) == null ? void 0 : L.list) || null), w = e.treeDepth, b = (this.columns ? this.columns.treeDepth : -1) == w;
    if (m && b)
      return;
    p();
    const _ = (r == null ? void 0 : r.findDepth(e.tree)) ?? 0, M = (r == null ? void 0 : r.balanceTreeForAutoCols(C, _)) ?? [];
    this.columns = {
      list: C,
      tree: M,
      treeDepth: _,
      map: {}
    }, t((A) => {
      if (!A)
        return null;
      const R = A.filter((P) => !ha(P));
      return [...C, ...R];
    });
  }
  updateColumns(e) {
    var o;
    const t = Bs(e.source);
    (o = this.columns) == null || o.list.forEach((n, s) => this.updateOneAutoCol(n, s, t));
  }
  getColumn(e) {
    var t;
    return ((t = this.columns) == null ? void 0 : t.list.find((o) => qr(o, e))) ?? null;
  }
  getColumns() {
    var e;
    return ((e = this.columns) == null ? void 0 : e.list) ?? null;
  }
  generateAutoCols(e = []) {
    const t = [], o = this.gos.get("treeData");
    let n = Lw(this.gos);
    return o && n && (X(182), n = !1), n ? e.forEach((s, i) => {
      t.push(this.createOneAutoCol(s, i));
    }) : t.push(this.createOneAutoCol()), t;
  }
  isSuppressAutoCol() {
    const e = this.gos;
    return e.get("groupDisplayType") === "custom" ? !0 : e.get("treeDataDisplayType") === "custom";
  }
  // rowGroupCol and index are missing if groupDisplayType != "multipleColumns"
  createOneAutoCol(e, t) {
    let o;
    e ? o = `${$i}-${e.getId()}` : o = $i;
    const n = this.createAutoColDef(o, e, t);
    n.colId = o;
    const s = new Zn(n, null, o, !0);
    return this.createBean(s), s;
  }
  /**
   * Refreshes an auto group col to load changes from defaultColDef or autoGroupColDef
   */
  updateOneAutoCol(e, t, o) {
    const n = e.getColDef(), s = typeof n.showRowGroup == "string" ? n.showRowGroup : void 0, i = this.beans, r = s != null ? i.colModel.getColDefCol(s) : void 0, l = e.getId(), a = this.createAutoColDef(l, r ?? void 0, t);
    e.setColDef(a, null, o), eo(i, { state: [{ colId: l, ...a }] }, o);
  }
  createAutoColDef(e, t, o) {
    let n = this.createBaseColDef(t);
    const s = this.gos.get("autoGroupColumnDef");
    qt(n, s), n = Zi(this.beans, n, e, !0), this.gos.get("treeData") || Xe(n.field) && Xe(n.valueGetter) && Xe(n.filterValueGetter) && n.filter !== "agGroupColumnFilter" && (n.filter = !1), o && o > 0 && (n.headerCheckboxSelection = !1);
    const i = Oo(this.gos), r = n.valueGetter || n.field != null;
    return i && !r && (n.sortIndex = void 0, n.initialSort = void 0), n;
  }
  createBaseColDef(e) {
    const t = this.gos.get("autoGroupColumnDef"), n = {
      headerName: this.getLocaleTextFunc()("group", "Group"),
      showRowGroup: (e == null ? void 0 : e.getColId()) ?? !0
    };
    return t && (t.cellRenderer || t.cellRendererSelector) || (n.cellRenderer = "agGroupCellRenderer"), e && (n.headerName = this.beans.colNames.getDisplayNameForColumn(e, "header") ?? void 0, n.headerValueGetter = e.colDef.headerValueGetter), n;
  }
  destroy() {
    var e;
    Js(this.beans, (e = this.columns) == null ? void 0 : e.tree), super.destroy();
  }
}, eXe = class extends K {
  addExpandedCss(e, t) {
    t.isExpandable() && (e.push("ag-row-group"), e.push(t.expanded ? "ag-row-group-expanded" : "ag-row-group-contracted"));
  }
  getRowExpandedListeners(e) {
    const { rowNode: t } = e, o = this.updateExpandedCss.bind(this, e, t);
    return {
      expandedChanged: o,
      hasChildrenChanged: o
    };
  }
  setExpanded(e, t, o, n) {
    if (e.expanded === t)
      return;
    e.expanded = t, e.dispatchRowEvent("expandedChanged");
    const s = { ...fb(e, this.gos, "rowGroupOpened"), expanded: t, event: o || null };
    this.dispatchExpandedEvent(s, n);
  }
  isExpandable(e) {
    return e.footer ? !1 : this.beans.colModel.isPivotMode() ? e.hasChildren() && !e.leafGroup : e.hasChildren() || e.master;
  }
  updateExpandedCss(e, t) {
    const o = t.isExpandable(), n = t.expanded == !0;
    e.forEachGui(void 0, (s) => {
      const i = s.rowComp;
      i.toggleCss("ag-row-group", o), i.toggleCss("ag-row-group-expanded", o && n), i.toggleCss("ag-row-group-contracted", o && !n), Fo(s.element, o && n);
    });
  }
  dispatchStateUpdatedEvent() {
    this.eventSvc.dispatchEvent({ type: "rowExpansionStateChanged" });
  }
}, tXe = class extends eXe {
  constructor() {
    super(...arguments), this.beanName = "expansionSvc", this.events = [];
  }
  wireBeans(e) {
    this.rowModel = e.rowModel;
  }
  setExpansionState(e) {
    const t = new Set(e.expandedRowGroupIds);
    this.rowModel.forEachNode((o) => {
      const n = o.id;
      n && (o.expanded = t.has(n));
    }), this.onGroupExpandedOrCollapsed();
  }
  getExpansionState() {
    const e = [];
    return this.rowModel.forEachNode((t) => {
      const o = t.id;
      o && t.expanded && e.push(o);
    }), { expandedRowGroupIds: e };
  }
  expandAll(e) {
    const { gos: t, colModel: o, eventSvc: n } = this.beans, s = this.rowModel, i = t.get("treeData"), r = o.isPivotActive(), l = (c) => {
      c && c.forEach((d) => {
        const u = () => {
          d.expanded = e, l(d.childrenAfterGroup);
        };
        if (i) {
          ue(d.childrenAfterGroup) && u();
          return;
        }
        if (r) {
          !d.leafGroup && u();
          return;
        }
        d.group && u();
      });
    }, a = s.rootNode;
    a && l(a.childrenAfterGroup), this.onGroupExpandedOrCollapsed(), n.dispatchEvent({
      type: "expandOrCollapseAll",
      source: e ? "expandAll" : "collapseAll"
    });
  }
  onGroupExpandedOrCollapsed() {
    this.dispatchStateUpdatedEvent(), this.rowModel.refreshModel({ step: "map" });
  }
  // because the user can call rowNode.setExpanded() many times in one VM turn,
  // we throttle the calls to ClientSideRowModel using animationFrameSvc. this means for 100
  // row nodes getting expanded, we only update the CSRM once, and then we fire all events after
  // CSRM has updated.
  //
  // if we did not do this, then the user could call setExpanded on 100+ rows, causing the grid
  // to re-render 100+ times, which would be a performance lag.
  //
  // we use animationFrameService
  // rather than debounce() so this will get done if anyone flushes the animationFrameService
  // (eg user calls api.ensureRowVisible(), which in turn flushes ).
  dispatchExpandedEvent(e, t) {
    this.events.push(e);
    const o = () => {
      this.events.forEach((s) => this.eventSvc.dispatchEvent(s));
      const n = this.events.map((s) => s.node);
      this.beans.rowRenderer.refreshCells({ rowNodes: n }), this.events = [], this.dispatchStateUpdatedEvent();
    };
    t ? o() : (this.dispatchExpandedDebounced == null && (this.dispatchExpandedDebounced = this.debounce(o)), this.dispatchExpandedDebounced());
  }
  // the advantage over normal debounce is the client can call flushAllFrames()
  // to make sure all rendering is complete. we don't wait any milliseconds,
  // as this is intended to batch calls in one VM turn.
  debounce(e) {
    const t = this.beans.animationFrameSvc;
    if (!t)
      return () => window.setTimeout(e, 0);
    let o = !1;
    return () => {
      if (!t.active) {
        window.setTimeout(e, 0);
        return;
      }
      o || (o = !0, t.addDestroyTask(() => {
        o = !1, e();
      }));
    };
  }
};
function oXe(e) {
  let t = e.get("groupHideParentOfSingleChild");
  return t || (t = e.get("groupRemoveSingleChildren"), !t && e.get("groupRemoveLowestSingleChildren") && (t = "leafGroupsOnly")), {
    groupHideParentOfSingleChild: t,
    isGroupMultiAutoColumn: Lw(e),
    hideOpenParents: e.get("groupHideOpenParents"),
    grandTotalRow: or(e),
    groupTotalRow: Aw(e)
  };
}
function nXe(e, t, o) {
  return e.groupHideParentOfSingleChild === !0 && o && t.childrenAfterGroup.length === 1;
}
function sXe(e, t, o) {
  return e.groupHideParentOfSingleChild === "leafGroupsOnly" && o && t.leafGroup && t.childrenAfterGroup.length === 1;
}
function iXe(e, t, o, n, s, i) {
  const r = n && !o, l = n && t.leafGroup, a = e.hideOpenParents && t.expanded && !t.master && !l;
  return !r && !a && !s && !i;
}
var rXe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "flattenStage", this.refreshProps = /* @__PURE__ */ new Set([
      "groupHideParentOfSingleChild",
      "groupRemoveSingleChildren",
      "groupRemoveLowestSingleChildren",
      "groupTotalRow",
      "masterDetail"
    ]), this.step = "map";
  }
  execute(e) {
    var d;
    const t = e.rowNode, o = [], n = this.beans.colModel.isPivotMode(), s = n && t.leafGroup && t.aggData, i = s ? [t] : t.childrenAfterSort, r = oXe(this.gos);
    this.recursivelyAddToRowsToDisplay(r, i, o, n, 0);
    const l = o.length > 0, a = r.grandTotalRow;
    if (!s && // don't show total footer when showRootNode is true (i.e. in pivot mode and no groups)
    l && a)
      if (kr(t, this.beans), a === "pinnedBottom" || a === "pinnedTop")
        (d = this.beans.pinnedRowModel) == null || d.setGrandTotalPinned(a === "pinnedBottom" ? "bottom" : "top");
      else {
        const u = a === "top";
        this.addRowNodeToRowsToDisplay(r, t.sibling, o, 0, u);
      }
    return o;
  }
  recursivelyAddToRowsToDisplay(e, t, o, n, s) {
    if (!(t != null && t.length))
      return;
    const i = this.beans.masterDetailSvc;
    for (let r = 0; r < t.length; r++) {
      const l = t[r], a = l.hasChildren(), c = nXe(e, l, a), d = sXe(e, l, a);
      if (iXe(
        e,
        l,
        a,
        n,
        c,
        d
      ) && this.addRowNodeToRowsToDisplay(e, l, o, s), !(n && l.leafGroup))
        if (a) {
          const h = c || d;
          if (l.expanded || h) {
            const p = e.groupTotalRow({ node: l });
            p || GJe(l);
            const C = h ? s : s + 1;
            p === "top" && (kr(l, this.beans), this.addRowNodeToRowsToDisplay(e, l.sibling, o, C));
            const m = i == null ? void 0 : i.getDetail(l);
            m && this.addRowNodeToRowsToDisplay(e, m, o, s), this.recursivelyAddToRowsToDisplay(
              e,
              l.childrenAfterSort,
              o,
              n,
              C
            ), p === "bottom" && (kr(l, this.beans), this.addRowNodeToRowsToDisplay(e, l.sibling, o, C));
          }
        } else {
          const h = i == null ? void 0 : i.getDetail(l);
          h && this.addRowNodeToRowsToDisplay(e, h, o, s);
        }
    }
  }
  // duplicated method, it's also in floatingRowModel
  addRowNodeToRowsToDisplay(e, t, o, n, s) {
    s ? o.unshift(t) : o.push(t), t.setUiLevel(e.isGroupMultiAutoColumn ? 0 : n);
  }
}, lXe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "groupStage", this.refreshProps = /* @__PURE__ */ new Set([
      "groupDefaultExpanded",
      "groupAllowUnbalanced",
      "initialGroupOrderComparator",
      "groupHideOpenParents",
      "groupDisplayType",
      "treeData",
      "treeDataChildrenField",
      "treeDataParentIdField"
    ]), this.step = "group", this.approach = null, this.strategyBeanName = null, this.strategy = void 0;
  }
  /** Gets a filler row by id */
  getNode(e) {
    var t;
    return (t = this.strategy) == null ? void 0 : t.getNode(e);
  }
  destroy() {
    super.destroy(), this.strategy = void 0;
  }
  execute(e) {
    const t = E2(this.gos), o = this.approach !== t, n = o ? this.changeApproach(e, t) : this.strategy;
    if (n)
      return n.execute(e, t) || o;
  }
  getStrategyBeanName(e) {
    switch (e) {
      case "group":
        return "groupStrategy";
      case "treePath":
      case "treeNested":
      case "treeSelfRef":
        return "treeGroupStrategy";
      default:
        return null;
    }
  }
  changeApproach({ rowNode: e }, t) {
    var i;
    this.approach = t;
    const o = this.getStrategyBeanName(t), n = this.strategy;
    let s = n;
    return this.strategyBeanName !== o ? (this.destroyBean(s), s = void 0, o && (s = this.beans.registry.createDynamicBean(o, !1), this.createOptionalManagedBean(s)), this.strategy = s, this.strategyBeanName = o) : (i = s == null ? void 0 : s.reset) == null || i.call(s), n && aXe(e, t !== "treeNested"), s;
  }
}, aXe = (e, t) => {
  const o = e.allLeafChildren, n = e.sibling;
  e.treeNodeFlags = 0, e.childrenAfterGroup = o, e.childrenMapped = null, e.groupData = null, n && (n.childrenAfterGroup = e.childrenAfterGroup, n.childrenAfterAggFilter = e.childrenAfterAggFilter, n.childrenAfterFilter = e.childrenAfterFilter, n.childrenAfterSort = e.childrenAfterSort, n.childrenMapped = null);
  for (const s of o) {
    const i = s.sibling;
    Wu(s), i && Wu(i), s.parent = e, t && (s.treeParent = null), (s.group || s.hasChildren()) && (s.group = !1, s.updateHasChildren());
  }
  e.updateHasChildren();
}, Wu = (e) => {
  e.key = null, e.treeNodeFlags = 0, e.allChildrenCount = null, e.allLeafChildren = null, e.childrenAfterGroup = null, e.childrenAfterAggFilter = null, e.childrenAfterFilter = null, e.childrenAfterSort = null, e.childrenMapped = null, e.level = 0, e.groupData && (e.groupData = null);
};
function Uu(e, t, o) {
  var r;
  let n = e;
  const s = n.level - t.level;
  if (s <= 0 || !o.get("groupHideOpenParents"))
    return !1;
  for (let l = 0; l < s; l++) {
    if (!(((r = n.parent) == null ? void 0 : r.getFirstChild()) === n))
      return !1;
    n = n.parent;
  }
  return n === t;
}
var bc = (e, t, o, n = t.group) => {
  const s = e.gos, i = n && s.get("isGroupOpenByDefault");
  if (!i) {
    const l = s.get("groupDefaultExpanded");
    return l === -1 || o < l;
  }
  const r = {
    api: e.gridApi,
    context: e.gridOptions.context,
    rowNode: t,
    field: t.field,
    key: t.key,
    level: o,
    rowGroupColumn: t.rowGroupColumn
  };
  return i(r) == !0;
}, O_ = class extends K {
  constructor() {
    super(...arguments), this.indentClass = null;
  }
  init(e, t, o, n, s, i, r) {
    var d;
    this.params = r, this.eGui = t, this.eCheckbox = o, this.eExpanded = n, this.eContracted = s, this.comp = e, this.compClass = i;
    const { node: l, column: a } = r;
    if (this.node = l, this.displayedNode = l, !this.isEmbeddedRowMismatch()) {
      if (l.footer) {
        this.initFooterCell();
        return;
      }
      if (!a) {
        this.initFullWidthCell();
        return;
      }
      this.displayedNode = ((d = this.beans.showRowGroupColValueSvc) == null ? void 0 : d.getDisplayedNode(l, a)) ?? this.node, this.setupExpand(), this.setupCheckbox(), this.addGroupValue(), this.setupIndent();
    }
  }
  initFooterCell() {
    const { node: e } = this.params;
    this.addGroupValue(), this.setupIndent(), e.level === -1 || this.comp.toggleCss("ag-row-group-leaf-indent", !0);
  }
  initFullWidthCell() {
    const e = () => {
      const { rowDragSvc: t } = this.beans;
      if (!this.params.rowDrag || !t)
        return;
      const o = t.createRowDragComp(() => this.params.value, this.params.node);
      this.createManagedBean(o), this.eGui.insertAdjacentElement("afterbegin", o.getGui());
    };
    this.setupExpand(), e(), this.setupCheckbox(), this.addGroupValue(), this.setupIndent();
  }
  /**
   * Returns an aria "role" to place on full width group cells, or the parent wrapper.
   * @returns the aria role to place on the parent wrapper
   */
  getCellAriaRole() {
    var o, n;
    const e = (o = this.params.colDef) == null ? void 0 : o.cellAriaRole, t = (n = this.params.column) == null ? void 0 : n.getColDef().cellAriaRole;
    return e || t || "gridcell";
  }
  /**
   * Determines if this cell should be rendered, as when using embeddedFullWidthRows
   * only one group cell should be rendered.
   *
   * if [enableRTL] all but pinned right cells should be skipped if available
   * otherwise prioritise pinned left cell if available
   * otherwise center viewport.
   *
   * @returns whether the cell should be skipped due to embedded full width rows
   */
  isEmbeddedRowMismatch() {
    if (!this.params.fullWidth || !this.gos.get("embedFullWidthRows"))
      return !1;
    const { visibleCols: e } = this.beans, t = this.params.pinned === "left", o = this.params.pinned === "right", n = !t && !o;
    return this.gos.get("enableRtl") ? e.isPinningLeft() ? !o : !n : e.isPinningLeft() ? !t : !n;
  }
  /**
   * Displays the group value for the displayed node
   */
  addGroupValue() {
    const {
      params: { value: e, valueFormatted: t }
    } = this, o = this.getInnerCompDetails();
    this.comp.setInnerRenderer(o, t ?? e ?? null);
  }
  /**
   * Sets up expand/collapse:
   * Chevron
   * Aria-expanded
   * Child count
   */
  setupExpand() {
    const { colModel: e } = this.beans, { eGridCell: t, column: o, suppressDoubleClickExpand: n } = this.params, s = (c, d) => {
      const u = Ie(c, this.beans, null);
      u && (d.appendChild(u), this.addDestroyFunc(() => d.removeChild(u)));
    };
    s("groupExpanded", this.eExpanded), s("groupContracted", this.eContracted);
    const i = this.comp, r = () => {
      if (!this.isExpandable())
        return;
      const d = this.displayedNode.expanded;
      i.setExpandedDisplayed(d), i.setContractedDisplayed(!d), Fo(t, !!this.displayedNode.expanded);
    }, l = () => {
      const c = this.isExpandable();
      i.toggleCss("ag-cell-expandable", c), i.toggleCss("ag-row-group", c);
      const d = !c && e.isPivotMode();
      i.toggleCss("ag-pivot-leaf-group", d);
      const u = !e.isPivotMode() && (!this.displayedNode.footer || this.displayedNode.level !== -1);
      i.toggleCss("ag-row-group-leaf-indent", !c && u);
      const h = this.getChildCount(), p = h > 0 ? `(${h})` : "";
      i.setChildCount(p), c ? r() : (i.setExpandedDisplayed(!1), i.setContractedDisplayed(!1), ow(t));
    };
    (() => {
      !((o == null ? void 0 : o.isCellEditable(this.displayedNode)) && this.gos.get("enableGroupEdit")) && !n && this.addManagedListeners(t, { dblclick: this.onCellDblClicked.bind(this) }), this.addManagedListeners(this.eExpanded, { click: this.onExpandClicked.bind(this) }), this.addManagedListeners(this.eContracted, { click: this.onExpandClicked.bind(this) }), this.addManagedListeners(t, { keydown: this.onKeyDown.bind(this) }), this.addManagedListeners(this.displayedNode, {
        // Expandable state has changed
        allChildrenCountChanged: l,
        masterChanged: l,
        groupChanged: l,
        hasChildrenChanged: l,
        // Node expanded changed
        expandedChanged: r
      });
    })(), l();
  }
  /**
   * Return the inner renderer details for the cell
   *
   * Prioritises:
   * 1. Group row renderer for group rows
   * 2. agFindCellRenderer for find results in group rows
   * 3. Provided innerRenderer (i.e, cellRendererParams.innerRenderer)
   * 4. Cell renderer of the grouped column
   * 5. Inner renderer of the grouped column
   * 6. agFindCellRenderer for find results
   */
  getInnerCompDetails() {
    var a, c;
    const { userCompFactory: e, findSvc: t } = this.beans, o = this.params;
    if (o.fullWidth) {
      const d = this.gos.get("groupRowRendererParams"), u = M1(
        e,
        d,
        o
      );
      return u || (t != null && t.isMatch(o.node, null) ? M1(
        e,
        { ...d, innerRenderer: "agFindCellRenderer" },
        o
      ) : void 0);
    }
    const n = (d) => d && d.componentClass == this.compClass, s = M1(e, o, o);
    if (s && !n(s))
      return s;
    const {
      displayedNode: { rowGroupColumn: i }
    } = this, r = i == null ? void 0 : i.colDef, l = i && ((a = o.column) == null ? void 0 : a.isRowGroupDisplayed(i.getId()));
    if (r && l) {
      const d = Ni(e, r, o);
      if (d)
        if (n(d)) {
          if ((c = r == null ? void 0 : r.cellRendererParams) != null && c.innerRenderer)
            return M1(
              e,
              r.cellRendererParams,
              o
            );
        } else
          return d;
    }
    if (t != null && t.isMatch(o.node, o.column))
      return Ni(
        e,
        { ...r ?? o.colDef, cellRenderer: "agFindCellRenderer" },
        o
      );
  }
  /**
   * Get the allChildCount of a given node
   * @param node the node to return the count for
   * @returns 0 if the count should not be displayed, otherwise the count
   */
  getChildCount() {
    const { column: e, suppressCount: t } = this.params;
    if (t)
      return 0;
    const { allChildrenCount: o, rowGroupColumn: n } = this.displayedNode;
    return !((o ?? 0) > 0 && (!n || !e || (e == null ? void 0 : e.isRowGroupDisplayed(n.getId())))) || this.gos.get("showOpenedGroup") && this.displayedNode !== this.node && !Uu(this.node, this.displayedNode, this.gos) ? 0 : o ?? 0;
  }
  /**
   * Checks whether the current cell is expandable, either due to [groupHideOpenParent] control or otherwise.
   * @returns whether this cell is expandable
   */
  isExpandable() {
    const { node: e, column: t, colDef: o } = this.params;
    if (!this.displayedNode.isExpandable() || e.rowPinned)
      return !1;
    if (!t)
      return !0;
    if (e.hasChildren() && o) {
      const { showRowGroup: i } = o;
      if (!i)
        return !1;
      if (i === !0)
        return !0;
    }
    return e === this.displayedNode ? e.rowGroupColumn && (t == null ? void 0 : t.isRowGroupDisplayed(e.rowGroupColumn.getId())) ? !0 : e.master ? (o == null ? void 0 : o.showRowGroup) === !0 || (o == null ? void 0 : o.showRowGroup) == null : !1 : Uu(this.node, this.displayedNode, this.gos);
  }
  /**
   * For full width group cells & single group column, indents child groups based on uiLevel
   */
  setupIndent() {
    const { suppressPadding: e, node: t, colDef: o } = this.params;
    if (e)
      return;
    const n = () => {
      let s = 0;
      o && o.showRowGroup !== !0 ? s = 0 : s = t.uiLevel;
      const i = "ag-row-group-indent-" + s;
      i !== this.indentClass && (this.indentClass && this.comp.toggleCss(this.indentClass, !1), this.indentClass = i, this.comp.toggleCss(i, !0), this.eGui.style.setProperty("--ag-indentation-level", String(s)));
    };
    this.addManagedListeners(t, { uiLevelChanged: n.bind(this) }), n();
  }
  /**
   * Selection checkboxes
   */
  setupCheckbox() {
    const { node: e } = this.params;
    !e.footer && !e.rowPinned && !e.detail && (this.addManagedPropertyListener("rowSelection", ({ currentValue: o, previousValue: n }) => {
      const s = typeof o == "object" ? o : void 0, i = typeof n == "object" ? n : void 0;
      (s == null ? void 0 : s.checkboxLocation) !== (i == null ? void 0 : i.checkboxLocation) && (this.destroyCheckbox(), this.addCheckbox());
    }), this.addCheckbox());
  }
  addCheckbox() {
    const { selectionSvc: e } = this.beans;
    if (!e || !os(this.gos))
      return;
    const { node: t, column: o } = this.params, n = this.gos.get("rowSelection"), s = Wr(n);
    if (s === "selectionColumn")
      return;
    if (s === "autoGroupColumn") {
      const c = (o == null ? void 0 : o.getColDef().showRowGroup) != null, d = !o && t.group;
      if (!(c || d))
        return;
    }
    const i = typeof n == "object" ? Os(n) : this.params.checkbox;
    if (!(typeof i == "function" || i === !0))
      return;
    if (typeof (o == null ? void 0 : o.getColDef().showRowGroup) == "string" && !this.isExpandable()) {
      this.comp.setCheckboxSpacing(!0);
      return;
    }
    const a = e.createCheckboxSelectionComponent();
    this.cbComp = a, this.createBean(a), a.init({
      rowNode: t,
      // when groupHideOpenParents = true and group expanded, we want the checkbox to refer to leaf node state (not group node state)
      column: o,
      overrides: {
        isVisible: i,
        callbackParams: this.params,
        removeHidden: !0
      }
    }), this.eCheckbox.appendChild(a.getGui()), this.comp.setCheckboxVisible(!0);
  }
  destroyCheckbox() {
    this.comp.setCheckboxSpacing(!1), this.comp.setCheckboxVisible(!1), this.cbComp && this.eCheckbox.removeChild(this.cbComp.getGui()), this.cbComp = this.destroyBean(this.cbComp);
  }
  /**
   * Called when the expand / contract icon is clicked.
   */
  onExpandClicked(e) {
    wo(e) || (vt(e), this.onExpandOrContract(e));
  }
  /**
   * Called on cell key press - only handles 'Enter' key for expand/collapse
   */
  onKeyDown(e) {
    !(e.key === D.ENTER) || this.params.suppressEnterExpand || this.params.column && this.params.column.isCellEditable(this.params.node) || this.onExpandOrContract(e);
  }
  /**
   * Called on cell double click - only expands/collapses if the event is not on the expand / contract icon
   */
  onCellDblClicked(e) {
    if (wo(e))
      return;
    q0(this.eExpanded, e) || q0(this.eContracted, e) || this.onExpandOrContract(e);
  }
  /**
   * Called when expand or contract is attempted, to scroll the row and update the node state
   * @param e originating event
   */
  onExpandOrContract(e) {
    if (!this.isExpandable())
      return;
    const t = this.displayedNode, o = !t.expanded;
    !o && t.sticky && this.beans.ctrlsSvc.getScrollFeature().setVerticalScrollPosition(t.rowTop - t.stickyRowTop), t.setExpanded(o, e);
  }
  destroy() {
    super.destroy(), this.destroyCheckbox();
  }
}, cXe = {
  tag: "span",
  cls: "ag-cell-wrapper",
  children: [
    { tag: "span", ref: "eExpanded", cls: "ag-group-expanded ag-hidden" },
    { tag: "span", ref: "eContracted", cls: "ag-group-contracted ag-hidden" },
    { tag: "span", ref: "eCheckbox", cls: "ag-group-checkbox ag-invisible" },
    { tag: "span", ref: "eValue", cls: "ag-group-value" },
    { tag: "span", ref: "eChildCount", cls: "ag-group-child-count" }
  ]
}, Ku = class extends Re {
  constructor() {
    super(cXe), this.eExpanded = J, this.eContracted = J, this.eCheckbox = J, this.eValue = J, this.eChildCount = J;
  }
  init(e) {
    const t = {
      setInnerRenderer: (i, r) => this.setRenderDetails(i, r),
      setChildCount: (i) => this.eChildCount.textContent = i,
      toggleCss: (i, r) => this.toggleCss(i, r),
      setContractedDisplayed: (i) => He(this.eContracted, i),
      setExpandedDisplayed: (i) => He(this.eExpanded, i),
      setCheckboxVisible: (i) => this.eCheckbox.classList.toggle("ag-invisible", !i),
      setCheckboxSpacing: (i) => this.eCheckbox.classList.toggle("ag-group-checkbox-spacing", i)
    }, o = this.createManagedBean(new O_()), n = !e.colDef, s = this.getGui();
    o.init(t, s, this.eCheckbox, this.eExpanded, this.eContracted, this.constructor, e), n && no(s, o.getCellAriaRole());
  }
  setRenderDetails(e, t) {
    e ? e.newAgStackInstance().then((o) => {
      if (!o)
        return;
      const n = () => this.destroyBean(o);
      this.isAlive() ? (this.eValue.appendChild(o.getGui()), this.addDestroyFunc(n)) : n();
    }) : this.eValue.innerText = t;
  }
  destroy() {
    this.destroyBean(this.innerCellRenderer), super.destroy();
  }
  refresh() {
    return !1;
  }
}, dXe = (
  /*css*/
  ".ag-group-checkbox-spacing{width:var(--ag-icon-size)}:where(.ag-ltr) .ag-group-checkbox-spacing{margin-right:var(--ag-cell-widget-spacing)}:where(.ag-rtl) .ag-group-checkbox-spacing{margin-left:var(--ag-cell-widget-spacing)}"
), uXe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "showRowGroupColValueSvc";
  }
  /**
   * Get the value for format in the group column, also returns the displayedNode from which the value was
   * taken in cases of groupHideOpenParents and showOpenedGroup.
   */
  getGroupValue(e, t) {
    var i;
    if (!t)
      return e.group ? { displayedNode: e, value: e.groupValue } : null;
    const o = this.beans.valueSvc, n = t.colDef.showRowGroup;
    if (!n)
      return null;
    if (e.level === -1 && e.footer)
      return { displayedNode: e, value: null };
    if (typeof n == "string") {
      if ((((i = this.beans.rowGroupColsSvc) == null ? void 0 : i.getColumnIndex(n)) ?? -1) > e.level)
        return null;
      const l = this.getDisplayedNode(e, t, !0);
      if (l)
        return {
          displayedNode: l,
          value: o.getValue(t, l)
        };
    }
    const s = o.getValue(t, e);
    if (s == null) {
      const r = this.getDisplayedNode(e, t);
      if (r)
        return {
          displayedNode: r,
          value: o.getValue(t, r)
        };
    }
    return {
      displayedNode: e,
      value: s
    };
  }
  /**
   * Formats a group col value, and prefixes it with the "Total" prefix if applicable
   */
  formatAndPrefixGroupColValue(e, t, o = !1) {
    const n = this.formatGroupColValue(e, t, o), { value: s, displayedNode: i } = e, r = this.beans.footerSvc;
    return r != null && r.doesCellShowTotalPrefix(i, t) ? r.applyTotalPrefix(s, n, i, t) : i.footer && i.level === -1 ? null : n;
  }
  /**
   * Formats the group col value using the underlying column's value formatter
   */
  formatGroupColValue(e, t, o = !1) {
    const n = this.beans.valueSvc, { displayedNode: s, value: i } = e, r = s.rowGroupColumn, l = s.group && !t;
    if (r && (l || (t == null ? void 0 : t.isRowGroupDisplayed(r.colId)))) {
      if (o && r.colDef.useValueFormatterForExport === !1)
        return null;
      const c = n.formatValue(r, s, i);
      return c == null && s.key === "" ? this.getLocaleTextFunc()("blanks", "(Blanks)") : c;
    }
    return !t || s.group || o && t.colDef.useValueFormatterForExport === !1 ? null : n.formatValue(t, s, i);
  }
  /**
   * Checks if the node has a value to inherit from the parent node for display in the given column
   *
   * This is used when [groupHideOpenParents] or [showOpenedGroup] are enabled
   *
   * @param node node to check for preferential nodes to display
   * @param column column to get the displayed node for
   * @returns a parent node of node to display the value from, or undefined if no value will be inherited
   */
  getDisplayedNode(e, t, o = !1) {
    var a, c;
    const n = this.gos, s = n.get("groupHideOpenParents"), i = n.get("showOpenedGroup") && !o;
    if (!s && !i)
      return;
    const r = t.colDef.showRowGroup;
    if (r === !0)
      return e.group ? void 0 : e.parent ?? void 0;
    let l = e;
    for (; l && ((a = l.rowGroupColumn) == null ? void 0 : a.getId()) != r; ) {
      const d = l === ((c = l.parent) == null ? void 0 : c.getFirstChild());
      if (!i && !d)
        return;
      l = l.parent;
    }
    if (l !== e)
      return l ?? void 0;
  }
}, hXe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "showRowGroupCols";
  }
  refresh() {
    this.showRowGroupCols = [], this.showRowGroupColsMap = {};
    const { colModel: e, rowGroupColsSvc: t } = this.beans;
    e.getCols().forEach((o) => {
      const s = o.getColDef().showRowGroup, i = typeof s == "string";
      !i && !(s === !0) || (this.showRowGroupCols.push(o), i ? this.showRowGroupColsMap[s] = o : t && t.columns.forEach((l) => {
        this.showRowGroupColsMap[l.getId()] = o;
      }));
    });
  }
  getShowRowGroupCols() {
    return this.showRowGroupCols;
  }
  getShowRowGroupCol(e) {
    return this.showRowGroupColsMap[e];
  }
  getSourceColumnsForGroupColumn(e) {
    const t = e.getColDef().showRowGroup;
    if (!t)
      return null;
    const { rowGroupColsSvc: o, colModel: n } = this.beans;
    if (t === !0 && o)
      return o.columns.slice(0);
    const s = n.getColDefCol(t);
    return s ? [s] : null;
  }
  isRowGroupDisplayed(e, t) {
    const { colDef: o } = e;
    if ((o == null ? void 0 : o.showRowGroup) == null)
      return !1;
    const n = o.showRowGroup === !0, s = o.showRowGroup === t;
    return n || s;
  }
}, gXe = class extends K {
  constructor(e, t) {
    super(), this.createRowCon = e, this.destroyRowCtrls = t, this.stickyTopRowCtrls = [], this.stickyBottomRowCtrls = [], this.extraTopHeight = 0, this.extraBottomHeight = 0;
  }
  postConstruct() {
    this.isClientSide = dt(this.gos), this.beans.ctrlsSvc.whenReady(this, (e) => {
      this.gridBodyCtrl = e.gridBodyCtrl;
    }), this.resetStickyContainers();
  }
  setOffsetTop(e) {
    this.extraTopHeight !== e && (this.extraTopHeight = e, this.eventSvc.dispatchEvent({
      type: "stickyTopOffsetChanged",
      offset: e
    }));
  }
  setOffsetBottom(e) {
    this.extraBottomHeight !== e && (this.extraBottomHeight = e);
  }
  resetOffsets() {
    this.setOffsetBottom(0), this.setOffsetTop(0);
  }
  /**
   * Get the last pixel of the group, this pixel is used to push the sticky node up out of the viewport.
   */
  getLastPixelOfGroup(e) {
    return this.isClientSide ? fXe(e) : pXe(e);
  }
  /**
   * Get the first pixel of the group, this pixel is used to push the sticky node down out of the viewport
   */
  getFirstPixelOfGroup(e) {
    return e.footer ? e.sibling.rowTop + e.sibling.rowHeight - 1 : e.hasChildren() ? e.rowTop - 1 : 0;
  }
  updateStickyRows(e) {
    const t = e === "top";
    let o = 0;
    if (!this.canRowsBeSticky())
      return this.refreshNodesAndContainerHeight(e, /* @__PURE__ */ new Set(), o);
    const { rowModel: n, rowRenderer: s, pinnedRowModel: i } = this.beans, r = t ? s.firstVisibleVPixel - this.extraTopHeight : s.lastVisibleVPixel - this.extraTopHeight, l = /* @__PURE__ */ new Set(), a = (h) => {
      if (l.add(h), t) {
        const p = this.getLastPixelOfGroup(h), C = r + o + h.rowHeight;
        p < C ? h.stickyRowTop = o + (p - C) : h.stickyRowTop = o;
      } else {
        const p = this.getFirstPixelOfGroup(h), C = r - (o + h.rowHeight);
        p > C ? h.stickyRowTop = o - (p - C) : h.stickyRowTop = o;
      }
      o = 0, l.forEach((p) => {
        const C = p.stickyRowTop + p.rowHeight;
        o < C && (o = C);
      });
    }, c = this.areFooterRowsStickySuppressed(), d = this.gos.get("suppressGroupRowsSticky"), u = (h) => {
      if (!h.displayed)
        return !1;
      if (h.footer) {
        if (c === !0 || c === "grand" && h.level === -1 || c === "group" && h.level > -1)
          return !1;
        const p = h.sibling.rowIndex ? h.sibling.rowIndex + 1 === h.rowIndex : !1;
        return e === "bottom" && p || h.level === -1 && (i != null && i.getGrandTotalPinned()) ? !1 : !l.has(h);
      }
      return h.isExpandable() ? d === !0 || e === "bottom" ? !1 : !l.has(h) && h.expanded : !1;
    };
    for (let h = 0; h < 100; h++) {
      let p = r + o;
      t || (p = r - o);
      const C = n.getRowIndexAtPixel(p), m = n.getRow(C);
      if (m == null)
        break;
      const y = this.getStickyAncestors(m).find(
        (_) => (t ? _.rowIndex < C : _.rowIndex > C) && u(_)
      );
      if (y) {
        a(y);
        continue;
      }
      if ((t ? m.rowTop < p : m.rowTop + m.rowHeight > p) && u(m)) {
        a(m);
        continue;
      }
      break;
    }
    return t || l.forEach((h) => {
      h.stickyRowTop = o - (h.stickyRowTop + h.rowHeight);
    }), this.refreshNodesAndContainerHeight(e, l, o);
  }
  areFooterRowsStickySuppressed() {
    const e = this.gos.get("suppressStickyTotalRow");
    if (e === !0)
      return !0;
    const t = e === "group", o = e === "grand";
    return t && o ? !0 : o ? "grand" : t ? "group" : !1;
  }
  canRowsBeSticky() {
    const e = ua(this.gos), t = this.areFooterRowsStickySuppressed(), o = this.gos.get("suppressGroupRowsSticky");
    return e && (!t || !o);
  }
  getStickyAncestors(e) {
    const t = [];
    let o = e.footer ? e.sibling : e.parent;
    for (; o; )
      o.sibling && t.push(o.sibling), t.push(o), o = o.parent;
    return t.reverse();
  }
  checkStickyRows() {
    const e = this.updateStickyRows("top"), t = this.updateStickyRows("bottom");
    return e || t;
  }
  destroyStickyCtrls() {
    this.resetStickyContainers();
  }
  resetStickyContainers() {
    this.refreshNodesAndContainerHeight("top", /* @__PURE__ */ new Set(), 0), this.refreshNodesAndContainerHeight("bottom", /* @__PURE__ */ new Set(), 0);
  }
  refreshStickyNode(e) {
    const t = /* @__PURE__ */ new Set();
    if (this.stickyTopRowCtrls.some((o) => o.rowNode === e)) {
      for (let o = 0; o < this.stickyTopRowCtrls.length; o++) {
        const n = this.stickyTopRowCtrls[o].rowNode;
        n !== e && t.add(n);
      }
      this.refreshNodesAndContainerHeight("top", t, this.topContainerHeight) && this.checkStickyRows();
      return;
    }
    for (let o = 0; o < this.stickyBottomRowCtrls.length; o++) {
      const n = this.stickyBottomRowCtrls[o].rowNode;
      n !== e && t.add(n);
    }
    this.refreshNodesAndContainerHeight("bottom", t, this.bottomContainerHeight) && this.checkStickyRows();
  }
  /**
   * Destroy old ctrls and create new ctrls where necessary.
   */
  refreshNodesAndContainerHeight(e, t, o) {
    const n = e === "top", s = n ? this.stickyTopRowCtrls : this.stickyBottomRowCtrls, i = {}, r = [];
    for (let p = 0; p < s.length; p++) {
      const C = s[p].rowNode;
      if (!t.has(C)) {
        i[C.id] = s[p], C.sticky = !1;
        continue;
      }
      r.push(s[p]);
    }
    const l = /* @__PURE__ */ new Set();
    for (let p = 0; p < r.length; p++)
      l.add(r[p].rowNode);
    const a = [];
    t.forEach((p) => {
      l.has(p) || (p.sticky = !0, a.push(this.createRowCon(p, !1, !1)));
    });
    let c = !!a.length || r.length !== s.length;
    n ? this.topContainerHeight !== o && (this.topContainerHeight = o, this.gridBodyCtrl.setStickyTopHeight(o), c = !0) : this.bottomContainerHeight !== o && (this.bottomContainerHeight = o, this.gridBodyCtrl.setStickyBottomHeight(o), c = !0), this.destroyRowCtrls(i, !1);
    const d = [...r, ...a];
    d.sort((p, C) => C.rowNode.rowIndex - p.rowNode.rowIndex), n || d.reverse(), d.forEach((p) => p.setRowTop(p.rowNode.stickyRowTop));
    const u = this.beans.pageBounds;
    let h = 0;
    return n ? (t.forEach((p) => {
      p.rowIndex < u.getFirstRow() && (h += p.rowHeight);
    }), h > this.topContainerHeight && (h = this.topContainerHeight), this.setOffsetTop(h)) : (t.forEach((p) => {
      p.rowIndex > u.getLastRow() && (h += p.rowHeight);
    }), h > this.bottomContainerHeight && (h = this.bottomContainerHeight), this.setOffsetBottom(h)), c ? (n ? this.stickyTopRowCtrls = d : this.stickyBottomRowCtrls = d, !0) : !1;
  }
  ensureRowHeightsValid() {
    let e = !1;
    const t = (o) => {
      const n = o.rowNode;
      if (n.rowHeightEstimated) {
        const s = Dn(this.beans, n);
        n.setRowHeight(s.height), e = !0;
      }
    };
    return this.stickyTopRowCtrls.forEach(t), this.stickyBottomRowCtrls.forEach(t), e;
  }
};
function pXe(e) {
  var t, o;
  if (e.isExpandable() || e.footer) {
    if (e.master && e.detailNode)
      return e.detailNode.rowTop + e.detailNode.rowHeight;
    if (!e.sibling || Math.abs(e.sibling.rowIndex - e.rowIndex) === 1) {
      let s = (t = e.childStore) == null ? void 0 : t.getStoreBounds();
      return e.footer && (s = (o = e.sibling.childStore) == null ? void 0 : o.getStoreBounds()), ((s == null ? void 0 : s.heightPx) ?? 0) + ((s == null ? void 0 : s.topPx) ?? 0);
    }
    return e.footer ? e.rowTop + e.rowHeight : e.sibling.rowTop + e.sibling.rowHeight;
  }
  return Number.MAX_SAFE_INTEGER;
}
function fXe(e) {
  if (e.isExpandable() || e.footer) {
    if (e.footer && e.rowIndex === 0)
      return Number.MAX_SAFE_INTEGER;
    if (!e.sibling || Math.abs(e.sibling.rowIndex - e.rowIndex) === 1) {
      let n = e.footer ? e.sibling : e;
      for (; n.isExpandable() && n.expanded; )
        if (n.master && n.detailNode)
          n = n.detailNode;
        else if (n.childrenAfterSort) {
          if (n.childrenAfterSort.length === 0)
            break;
          n = Ke(n.childrenAfterSort);
        }
      return n.rowTop + n.rowHeight;
    }
    return e.footer ? e.rowTop + e.rowHeight : e.sibling.rowTop + e.sibling.rowHeight;
  }
  return Number.MAX_SAFE_INTEGER;
}
var vXe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "stickyRowSvc";
  }
  createStickyRowFeature(e, t, o) {
    const n = this.gos;
    if (ua(n) && dt(n) || $n(n))
      return e.createManagedBean(new gXe(t, o));
  }
}, B_ = {
  moduleName: "GroupCellRenderer",
  version: yt,
  userComponents: {
    agGroupRowRenderer: Ku,
    agGroupCellRenderer: Ku
  },
  dynamicBeans: { groupCellRendererCtrl: O_ },
  icons: {
    // shown on row group when contracted (click to expand)
    groupContracted: "tree-closed",
    // shown on row group when expanded (click to contract)
    groupExpanded: "tree-open"
  },
  css: [dXe],
  dependsOn: [ko]
}, $_ = {
  moduleName: "GroupColumn",
  version: yt,
  beans: [
    XJe,
    hXe,
    uXe,
    JJe,
    QJe,
    H_
  ],
  dependsOn: [ko, B_]
}, yc = {
  moduleName: "ClientSideRowModelHierarchy",
  version: yt,
  rowModels: ["clientSide"],
  beans: [lXe, rXe, tXe],
  dependsOn: [ko]
}, _c = {
  moduleName: "StickyRow",
  version: yt,
  beans: [vXe]
}, R0 = class {
  constructor() {
    this.allSets = /* @__PURE__ */ new Map();
  }
  removeFromChildrenAfterGroup(e, t) {
    const o = this.getSet(e);
    (o.fromChildrenAfterGroup ?? (o.fromChildrenAfterGroup = /* @__PURE__ */ new Set())).add(t);
  }
  isRemoveFromAllLeafChildren(e, t) {
    var o, n;
    return !!((n = (o = this.allSets.get(e)) == null ? void 0 : o.fromAllLeafChildren) != null && n.has(t));
  }
  preventRemoveFromAllLeafChildren(e, t) {
    var o, n;
    (n = (o = this.allSets.get(e)) == null ? void 0 : o.fromAllLeafChildren) == null || n.delete(t);
  }
  removeFromAllLeafChildren(e, t) {
    const o = this.getSet(e);
    (o.fromAllLeafChildren ?? (o.fromAllLeafChildren = /* @__PURE__ */ new Set())).add(t);
  }
  getSet(e) {
    let t = this.allSets.get(e);
    return t || (t = {
      fromChildrenAfterGroup: null,
      fromAllLeafChildren: null
    }, this.allSets.set(e, t)), t;
  }
  getAllParents() {
    return Array.from(this.allSets.keys());
  }
  flush() {
    const e = this.allSets;
    for (const t of e.keys()) {
      const o = e.get(t);
      if (o) {
        const { fromChildrenAfterGroup: n, fromAllLeafChildren: s } = o, { childrenAfterGroup: i, allLeafChildren: r } = t;
        i && n && (qu(i, n), t.updateHasChildren()), r && s && qu(r, s);
      }
    }
    e.clear();
  }
};
function qu(e, t) {
  let o = 0;
  for (let n = 0, s = e.length; n < s; ++n) {
    const i = e[n];
    t.has(i) || (e[o++] = i);
  }
  e.length = o;
}
var Yu = (e) => {
  if (!e)
    return [];
  const t = e.length, o = new Array(t);
  for (let n = 0; n < t; n++) {
    const s = e[n], i = s.getColDef();
    o[n] = {
      col: s,
      field: i.field,
      type: i.type,
      keyCreator: i.keyCreator,
      valueGetter: i.valueGetter
    };
  }
  return o;
}, Qu = (e, t) => {
  const o = e.length;
  if (o !== (t == null ? void 0 : t.length))
    return !0;
  for (let n = 0; n < o; n++) {
    const s = e[n], i = t[n];
    if (s.col !== i)
      return !0;
    const r = i.getColDef();
    if (s.field !== r.field || s.type !== r.type || s.valueGetter !== r.valueGetter || s.keyCreator !== r.keyCreator)
      return !0;
  }
  return !1;
};
function mXe(e) {
  if (!e)
    return !1;
  const t = e.length;
  if (t < 2)
    return !1;
  let o = !1;
  for (let n = 1; n < t; n++)
    if (Ju(e[n - 1], e[n]) > 0) {
      o = !0;
      break;
    }
  return o ? (e.sort(Ju), !0) : !1;
}
function Ju(e, t) {
  const o = e.sourceRowIndex, n = t.sourceRowIndex, s = o >= 0, i = n >= 0, r = s && i, l = !s && !i;
  return r ? o - n : l ? e.__objectId - t.__objectId : s ? 1 : -1;
}
var CXe = class extends K {
  constructor() {
    super(...arguments), this.prevGroupCols = null, this.prevShowGroupCols = null;
  }
  wireBeans(e) {
    this.colModel = e.colModel, this.valueSvc = e.valueSvc, this.selectionSvc = e.selectionSvc, this.showRowGroupCols = e.showRowGroupCols;
  }
  getNode(e) {
    let t;
    return this.beans.rowModel.forEachNode((o) => {
      o.id === e && (t = o);
    }), t;
  }
  execute(e) {
    var s;
    const t = this.createGroupingDetails(e), o = e.changedRowNodes;
    o ? this.handleDeltaUpdate(t, o) : this.shotgunResetEverything(t, !!e.afterColumnsChanged);
    const n = e.changedPath;
    this.positionLeafsAndGroups(n), this.orderGroups(t), (s = this.selectionSvc) == null || s.updateSelectableAfterGrouping(n);
  }
  positionLeafsAndGroups(e) {
    e.forEachChangedNodeDepthFirst((t) => {
      if (t.childrenAfterGroup) {
        const o = [], n = [];
        let s;
        t.childrenAfterGroup.forEach((r) => {
          var l;
          (l = r.childrenAfterGroup) != null && l.length ? r.key === "" && !s ? s = r : n.push(r) : o.push(r);
        }), s && n.push(s), t.childrenAfterGroup = [...o, ...n];
        const i = t.sibling;
        i && (i.childrenAfterGroup = t.childrenAfterGroup);
      }
    }, !1);
  }
  createGroupingDetails(e) {
    var a;
    const { rowNode: t, changedPath: o, rowNodesOrderChanged: n } = e;
    let s = !1;
    const i = (a = this.beans.rowGroupColsSvc) == null ? void 0 : a.columns;
    let r = this.prevGroupCols;
    return (!r || Qu(r, i)) && (s = !!r, this.prevGroupCols = r = Yu(i)), {
      groupCols: r,
      rootNode: t,
      pivotMode: this.colModel.isPivotMode(),
      rowNodesOrderChanged: !!n,
      groupColsChanged: s,
      // if no transaction and not immutable row data set, then it's shotgun, changed path would be 'not active' at this point anyway
      changedPath: o,
      groupAllowUnbalanced: this.gos.get("groupAllowUnbalanced"),
      isGroupOpenByDefault: this.gos.getCallback("isGroupOpenByDefault"),
      initialGroupOrderComparator: this.gos.getCallback("initialGroupOrderComparator")
    };
  }
  handleDeltaUpdate(e, { removals: t, updates: o, adds: n }) {
    const s = new R0();
    t.size && this.removeNodes(t, e, s);
    for (const l of o)
      this.moveNodeInWrongPath(l, e, s);
    const i = e.changedPath;
    for (const l of n)
      this.insertOneNode(l, e), i.active && i.addParentNode(l.parent);
    const r = s.getAllParents();
    s.flush(), this.removeEmptyGroups(r, e), e.rowNodesOrderChanged && this.sortChildren(e);
  }
  // this is used when doing delta updates, eg Redux, keeps nodes in right order
  sortChildren(e) {
    e.changedPath.forEachChangedNodeDepthFirst(
      (t) => {
        mXe(t.childrenAfterGroup) && e.changedPath.addParentNode(t);
      },
      !1,
      !0
    );
  }
  orderGroups(e) {
    const t = e.initialGroupOrderComparator;
    ue(t) && o(e.rootNode);
    function o(n) {
      ue(n.childrenAfterGroup) && // we only want to sort groups, so we do not sort leafs (a leaf group has leafs as children)
      !n.leafGroup && (n.childrenAfterGroup.sort((i, r) => t({ nodeA: i, nodeB: r })), n.childrenAfterGroup.forEach((i) => o(i)));
    }
  }
  getExistingPathForNode(e, t) {
    const o = [];
    let n = e.parent;
    for (; n && n !== t.rootNode; )
      o.push({
        key: n.key,
        rowGroupColumn: n.rowGroupColumn,
        field: n.field
      }), n = n.parent;
    return o.reverse(), o;
  }
  moveNodeInWrongPath(e, t, o) {
    t.changedPath.active && t.changedPath.addParentNode(e.parent);
    const n = (l) => l.key, s = this.getExistingPathForNode(e, t).map(n), i = this.getGroupInfo(e, t).map(n);
    No(s, i) || this.moveNode(e, t, o);
  }
  moveNode(e, t, o) {
    if (this.removeNodesFromParents([e], t, o), this.insertOneNode(e, t, o), e.setData(e.data), t.changedPath.active) {
      const n = e.parent;
      t.changedPath.addParentNode(n);
    }
  }
  removeNodes(e, t, o) {
    if (this.removeNodesFromParents(e, t, o), t.changedPath.active)
      for (const n of e)
        t.changedPath.addParentNode(n.parent);
  }
  forEachParentGroup(e, t, o) {
    let n = t;
    for (; n && n !== e.rootNode; )
      o(n), n = n.parent;
  }
  removeNodesFromParents(e, t, o) {
    const n = o == null, s = o || new R0();
    for (const i of e)
      this.removeFromParent(i, s), this.forEachParentGroup(t, i.parent, (r) => {
        s.removeFromAllLeafChildren(r, i);
      });
    n && s.flush();
  }
  removeEmptyGroups(e, t) {
    let o = !0;
    const n = (s) => {
      var a, c;
      const i = this.getChildrenMappedKey(s.key, s.rowGroupColumn), r = (a = s.parent) == null ? void 0 : a.childrenMapped;
      return (r ? !r[i] : !0) ? !1 : !!s.group && (((c = s.childrenAfterGroup) == null ? void 0 : c.length) ?? 0) === 0;
    };
    for (; o; ) {
      o = !1;
      const s = new R0();
      e.forEach((i) => {
        this.forEachParentGroup(t, i, (r) => {
          var l;
          n(r) && (o = !0, this.removeFromParent(r, s), (l = this.selectionSvc) == null || l.setNodesSelected({
            nodes: [r],
            newValue: !1,
            source: "rowGroupChanged"
          }));
        });
      }), s.flush();
    }
  }
  // removes the node from the parent by:
  // a) removing from childrenAfterGroup (using batchRemover if present, otherwise immediately)
  // b) removing from childrenMapped (immediately)
  // c) setRowTop(null) - as the rowRenderer uses this to know the RowNode is no longer needed
  // d) setRowIndex(null) - as the rowNode will no longer be displayed.
  removeFromParent(e, t) {
    var s;
    e.parent && (t ? t.removeFromChildrenAfterGroup(e.parent, e) : (Zt(e.parent.childrenAfterGroup, e), e.parent.updateHasChildren()));
    const o = this.getChildrenMappedKey(e.key, e.rowGroupColumn), n = (s = e.parent) == null ? void 0 : s.childrenMapped;
    n && delete n[o], e.setRowTop(null), e.setRowIndex(null);
  }
  /**
   * This is idempotent, but relies on the `key` field being the same throughout a RowNode's lifetime
   */
  addToParent(e, t) {
    const o = t.childrenMapped ?? (t.childrenMapped = {}), n = this.getChildrenMappedKey(e.key, e.rowGroupColumn);
    if (o[n] !== e) {
      o[n] = e;
      let s = t.childrenAfterGroup;
      if (!s) {
        t.childrenAfterGroup = s = [];
        const i = t.sibling;
        i && (i.childrenAfterGroup = t.childrenAfterGroup);
      }
      s.push(e), E_(t, this.beans, !0);
    }
  }
  checkAllGroupDataAfterColsChanged(e) {
    const t = (o) => {
      o && o.forEach((n) => {
        var r;
        if (!n.group)
          return;
        const i = {
          field: n.field,
          key: n.key,
          rowGroupColumn: n.rowGroupColumn,
          leafNode: (r = n.allLeafChildren) == null ? void 0 : r[0]
        };
        this.setGroupData(n, i), t(n.childrenAfterGroup);
      });
    };
    t(e.rootNode.childrenAfterGroup);
  }
  shotgunResetEverything(e, t) {
    var s, i;
    if (this.noChangeInGroupingColumns(e, t))
      return;
    (i = (s = this.selectionSvc) == null ? void 0 : s.filterFromSelection) == null || i.call(s, (r) => !r.group);
    const o = e.rootNode;
    o.leafGroup = e.groupCols.length === 0, o.childrenAfterGroup = [], o.childrenMapped = {}, o.updateHasChildren();
    const n = o.sibling;
    n && (n.childrenAfterGroup = o.childrenAfterGroup, n.childrenMapped = o.childrenMapped), this.insertNodes(o.allLeafChildren, e);
  }
  noChangeInGroupingColumns(e, t) {
    let o = !1;
    const n = this.prevShowGroupCols, s = this.showRowGroupCols.getShowRowGroupCols();
    return (!n || Qu(n, s)) && (o = !!n, this.prevShowGroupCols = Yu(s)), !t || e.groupColsChanged ? !1 : (o && this.checkAllGroupDataAfterColsChanged(e), !0);
  }
  insertNodes(e, t) {
    e.forEach((o) => {
      this.insertOneNode(o, t), t.changedPath.active && t.changedPath.addParentNode(o.parent);
    });
  }
  insertOneNode(e, t, o) {
    const n = this.getGroupInfo(e, t), s = this.findParentForNode(e, n, t, o);
    s.group || X(184, { parentGroupData: s.data, childNodeData: e.data }), e.parent = s, e.level = n.length, s.childrenAfterGroup.push(e), s.updateHasChildren();
  }
  findParentForNode(e, t, o, n) {
    let s = o.rootNode;
    return t.forEach((i, r) => {
      s = this.getOrCreateNextNode(s, i, r, o), n != null && n.isRemoveFromAllLeafChildren(s, e) ? n == null || n.preventRemoveFromAllLeafChildren(s, e) : s.allLeafChildren.push(e);
    }), s;
  }
  getOrCreateNextNode(e, t, o, n) {
    const s = this.getChildrenMappedKey(t.key, t.rowGroupColumn), i = e == null ? void 0 : e.childrenMapped;
    let r = i == null ? void 0 : i[s];
    return r || (r = this.createGroup(t, e, o, n), this.addToParent(r, e)), r;
  }
  createGroup(e, t, o, n) {
    const s = new pn(this.beans);
    return s.group = !0, s.field = e.field, s.rowGroupColumn = e.rowGroupColumn, this.setGroupData(s, e), s.key = e.key, s.id = this.createGroupId(s, t, o), s.level = o, s.leafGroup = o === n.groupCols.length - 1, s.allLeafChildren = [], s.setAllChildrenCount(0), s.rowGroupIndex = o, s.childrenAfterGroup = [], s.childrenMapped = {}, s.updateHasChildren(), s.parent = t, this.setExpandedInitialValue(n, s), s;
  }
  createGroupId(e, t, o) {
    const n = (s, i) => {
      if (!s.rowGroupColumn)
        return null;
      const r = i ? n(i, i.parent) : null;
      return `${r == null ? "" : r + "-"}${s.rowGroupColumn.getColId()}-${s.key}`;
    };
    return Rl + n(e, t);
  }
  setGroupData(e, t) {
    const o = t.rowGroupColumn;
    o && t.leafNode && (e.groupValue = this.valueSvc.getValue(o, t.leafNode)), e.groupData = {}, this.showRowGroupCols.getShowRowGroupCols().forEach((s) => {
      const i = e.rowGroupColumn;
      i !== null && s.isRowGroupDisplayed(i.getId()) && (e.groupData[s.getColId()] = this.valueSvc.getValue(i, t.leafNode));
    });
  }
  getChildrenMappedKey(e, t) {
    return t ? t.getId() + "-" + e : e;
  }
  setExpandedInitialValue(e, t) {
    if (e.pivotMode && t.leafGroup) {
      t.expanded = !1;
      return;
    }
    t.expanded = bc(this.beans, t, t.level);
  }
  getGroupInfo(e, t) {
    const o = [];
    for (const { col: n, field: s } of t.groupCols) {
      let i = this.valueSvc.getKeyForNode(n, e), r = i != null && i !== "";
      if ((t.pivotMode || !t.groupAllowUnbalanced) && !r && (i = "", r = !0), r) {
        const a = {
          key: i,
          field: s,
          rowGroupColumn: n,
          leafNode: e
        };
        o.push(a);
      }
    }
    return o;
  }
};
function wXe(e, t) {
  var o;
  (o = e.rowGroupColsSvc) == null || o.setColumns(t, "api");
}
function bXe(e, t) {
  var o;
  (o = e.rowGroupColsSvc) == null || o.removeColumns(t, "api");
}
function yXe(e, t) {
  var o;
  (o = e.rowGroupColsSvc) == null || o.addColumns(t, "api");
}
function _Xe(e, t, o) {
  var n, s;
  (s = (n = e.rowGroupColsSvc) == null ? void 0 : n.moveColumn) == null || s.call(n, t, o, "api");
}
function SXe(e) {
  var t;
  return ((t = e.rowGroupColsSvc) == null ? void 0 : t.columns) ?? [];
}
var xXe = {
  moduleName: "SharedRowGrouping",
  version: yt,
  apiFunctions: {
    setRowGroupColumns: wXe,
    removeRowGroupColumns: bXe,
    addRowGroupColumns: yXe,
    getRowGroupColumns: SXe,
    moveRowGroupColumn: _Xe
  },
  dependsOn: [
    ko,
    wc,
    $_,
    _c,
    YJe
  ]
}, MXe = {
  moduleName: "RowGrouping",
  version: yt,
  dynamicBeans: { groupStrategy: CXe },
  rowModels: ["clientSide"],
  dependsOn: [xXe, V_, yc]
}, Z_ = class extends K {
  constructor() {
    super(...arguments), this.loadRowDataVersion = 0;
  }
  wireBeans(e) {
    this.environment = e.environment;
  }
  init(e, t) {
    this.params = t, this.comp = e, t.pinned == null && (this.setAutoHeightClasses(), this.setupRefreshStrategy(), this.createDetailGrid(), this.loadRowData(), this.addManagedEventListeners({ fullWidthRowFocused: this.onFullWidthRowFocused.bind(this) }));
  }
  onFullWidthRowFocused(e) {
    const t = this.params, o = { rowIndex: t.node.rowIndex, rowPinned: t.node.rowPinned }, n = { rowIndex: e.rowIndex, rowPinned: e.rowPinned };
    Yb(o, n) && so(this.comp.getGui(), e.fromBelow);
  }
  setAutoHeightClasses() {
    const e = this.gos.get("detailRowAutoHeight"), t = e ? "ag-details-row-auto-height" : "ag-details-row-fixed-height", o = e ? "ag-details-grid-auto-height" : "ag-details-grid-fixed-height", n = this.comp;
    n.toggleCss(t, !0), n.toggleDetailGridCss(o, !0);
  }
  setupRefreshStrategy() {
    const e = this.params.refreshStrategy;
    if (e == "everything" || e == "nothing" || e == "rows") {
      this.refreshStrategy = e;
      return;
    }
    e != null && X(170, { providedStrategy: e }), this.refreshStrategy = "rows";
  }
  createDetailGrid() {
    const { params: e, gos: t } = this;
    if (Xe(e.detailGridOptions)) {
      X(171);
      return;
    }
    const o = t.get("theme"), n = e.detailGridOptions.theme;
    n && n !== o && X(267);
    const s = {
      themeStyleContainer: this.environment.eStyleContainer,
      ...e.detailGridOptions,
      theme: o
    };
    t.get("detailRowAutoHeight") && (s.domLayout = "autoHeight"), this.comp.setDetailGrid(s);
  }
  registerDetailWithMaster(e) {
    const {
      params: t,
      beans: { selectionSvc: o, findSvc: n }
    } = this, s = t.node.id, i = t.api, r = {
      id: s,
      api: e
    }, l = t.node;
    if (i.isDestroyed())
      return;
    i.addDetailGridInfo(s, r), l.detailGridInfo = r;
    const a = l.parent;
    n == null || n.registerDetailGrid(l, e);
    function c() {
      a && (o == null || o.refreshMasterNodeState(a));
    }
    function d({ node: u, source: h }) {
      u !== a || h === "masterDetail" || e.isDestroyed() || o == null || o.setDetailSelectionState(a, t.detailGridOptions, e);
    }
    e.addEventListener("firstDataRendered", () => {
      e.isDestroyed() || i.isDestroyed() || (o == null || o.setDetailSelectionState(a, t.detailGridOptions, e), e.addEventListener("selectionChanged", c), i.addEventListener("rowSelected", d));
    }), this.addDestroyFunc(() => {
      l.detailGridInfo === r && (i.isDestroyed() || i.removeDetailGridInfo(s), l.detailGridInfo = null);
    });
  }
  loadRowData() {
    var i, r, l;
    this.loadRowDataVersion++;
    const e = this.loadRowDataVersion, t = this.params;
    if (((i = t.detailGridOptions) == null ? void 0 : i.rowModelType) === "serverSide") {
      (l = (r = t.node.detailGridInfo) == null ? void 0 : r.api) == null || l.refreshServerSide({ purge: !0 });
      return;
    }
    const o = t.getDetailRowData;
    if (!o) {
      X(172);
      return;
    }
    const n = (a) => {
      this.loadRowDataVersion === e && this.comp.setRowData(a);
    }, s = {
      node: t.node,
      // we take data from node, rather than params.data
      // as the data could have been updated with new instance
      data: t.node.data,
      successCallback: n,
      context: Pe(this.gos, {}).context
    };
    o(s);
  }
  refresh() {
    switch (this.refreshStrategy) {
      case "nothing":
        return !0;
      case "everything":
        return !1;
    }
    return this.loadRowData(), !0;
  }
}, AXe = class {
  constructor(e) {
    this.parentWrapper = e;
  }
  wrap(e, t, o, n) {
    return this.parentWrapper.wrap(e, t, o, n);
  }
}, LXe = { tag: "div", cls: "ag-details-row" }, EXe = {
  tag: "div",
  cls: "ag-details-row",
  role: "gridcell",
  children: [{ tag: "div", ref: "eDetailGrid", cls: "ag-details-grid", role: "presentation" }]
}, PXe = class extends Re {
  constructor() {
    super(...arguments), this.eDetailGrid = J;
  }
  wireBeans(e) {
    this.context = e.context;
  }
  init(e) {
    this.params = e, this.selectAndSetTemplate();
    const t = {
      toggleCss: (o, n) => this.toggleCss(o, n),
      toggleDetailGridCss: (o, n) => this.eDetailGrid.classList.toggle(o, n),
      setDetailGrid: (o) => this.setDetailGrid(o),
      setRowData: (o) => this.setRowData(o),
      getGui: () => this.eDetailGrid
    };
    this.ctrl = this.createManagedBean(new Z_()), this.ctrl.init(t, e);
  }
  refresh() {
    var e;
    return ((e = this.ctrl) == null ? void 0 : e.refresh()) ?? !1;
  }
  selectAndSetTemplate() {
    const e = this.params;
    if (e.pinned) {
      this.setTemplate(LXe);
      return;
    }
    const t = () => {
      this.setTemplate(EXe);
    };
    if (Xe(e.template))
      t();
    else if (typeof e.template == "string")
      this.setTemplate(e.template, []);
    else if (typeof e.template == "function") {
      const o = e.template, n = o(e);
      this.setTemplate(n, []);
    } else
      X(168), t();
    this.eDetailGrid == null && X(169);
  }
  setDetailGrid(e) {
    var i;
    if (!this.eDetailGrid)
      return;
    const t = this.context.getBean("frameworkCompWrapper"), o = new AXe(t), { frameworkOverrides: n } = this.beans, s = Ey(this.eDetailGrid, e, {
      frameworkOverrides: n,
      providedBeanInstances: { frameworkCompWrapper: o },
      modules: P$e(this.params.api.getGridId(), e.rowModelType ?? "clientSide")
    });
    this.detailApi = s, (i = this.ctrl) == null || i.registerDetailWithMaster(s), this.addDestroyFunc(() => {
      s.destroy();
    });
  }
  setRowData(e) {
    var t;
    (t = this.detailApi) == null || t.setGridOption("rowData", e);
  }
};
function Pa(e, t) {
  var n;
  const o = (n = e.masterDetailSvc) == null ? void 0 : n.store;
  return o ? t(o) : void 0;
}
function RXe(e, t, o) {
  Pa(e, (n) => {
    n[t] = o;
  });
}
function FXe(e, t) {
  Pa(e, (o) => {
    delete o[t];
  });
}
function TXe(e, t) {
  return Pa(e, (o) => o[t]);
}
function IXe(e, t) {
  Pa(e, (o) => {
    let n = 0;
    Object.values(o).forEach((s) => {
      s && t(s, n++);
    });
  });
}
var DXe = (
  /*css*/
  ".ag-details-row{width:100%}.ag-details-row-fixed-height{height:100%}.ag-details-grid{width:100%}.ag-details-grid-fixed-height{height:100%}"
), kXe = class extends K {
  constructor() {
    super(...arguments), this.beanName = "masterDetailSvc", this.store = {};
  }
  isEnabled() {
    return !!this.gos.get("masterDetail");
  }
  postConstruct() {
    dt(this.gos) && (this.enabled = this.isEnabled());
  }
  refreshModel(e) {
    if (e.changedProps) {
      const t = this.isEnabled();
      if (this.enabled !== t) {
        this.setMasters(null);
        return;
      }
    }
    e.rowDataUpdated && this.setMasters(e.changedRowNodes);
  }
  setMasters(e) {
    var r, l;
    const t = this.isEnabled();
    this.enabled = t;
    const o = this.gos, n = o.get("isRowMaster"), s = o.get("treeData"), i = (a, c, d) => {
      var p;
      const u = a.master;
      let h = t;
      if (t)
        if (c || d) {
          if (n) {
            const C = a.data;
            h = !!C && !!n(C);
          }
        } else
          h = u;
      if (!s)
        if (h && c) {
          const C = ((p = this.beans.rowGroupColsSvc) == null ? void 0 : p.columns.length) ?? 0;
          a.expanded = bc(this.beans, a, C, !1);
        } else !h && u && (a.expanded = !1);
      h !== u && (a.master = h, a.dispatchRowEvent("masterChanged"));
    };
    if (e) {
      for (const a of e.updates)
        i(a, !1, !0);
      for (const a of e.adds)
        i(a, !0, !1);
    } else {
      const a = (l = (r = wn(this.beans)) == null ? void 0 : r.rootNode) == null ? void 0 : l.allLeafChildren;
      if (a)
        for (let c = 0, d = a.length; c < d; ++c)
          i(a[c], !0, !1);
    }
  }
  /** Used by flatten stage to get or create a detail node from a master node */
  getDetail(e) {
    if (!e.master || !e.expanded)
      return null;
    let t = e.detailNode;
    return t || (t = new pn(this.beans), t.detail = !0, t.selectable = !1, t.parent = e, ue(e.id) && (t.id = "detail_" + e.id), t.data = e.data, t.level = e.level + 1, e.detailNode = t, t);
  }
  setupDetailRowAutoHeight(e, t) {
    const { gos: o, beans: n } = this;
    if (!o.get("detailRowAutoHeight"))
      return;
    const s = () => {
      const r = t.clientHeight;
      if (r != null && r > 0) {
        const l = () => {
          const { rowModel: a } = this.beans, { rowNode: c } = e;
          c.setRowHeight(r), (dt(o) || $n(o)) && a.onRowHeightChanged();
        };
        window.setTimeout(l, 0);
      }
    }, i = mn(n, t, s);
    e.addDestroyFunc(i), s();
  }
  destroy() {
    this.store = {}, super.destroy();
  }
}, HXe = {
  moduleName: "SharedMasterDetail",
  version: yt,
  beans: [kXe],
  userComponents: { agDetailCellRenderer: PXe },
  dynamicBeans: { detailCellRendererCtrl: Z_ },
  apiFunctions: {
    addDetailGridInfo: RXe,
    removeDetailGridInfo: FXe,
    getDetailGridInfo: TXe,
    forEachDetailGridInfo: IXe
  },
  dependsOn: [ko, B_, _c],
  css: [DXe]
}, VXe = {
  moduleName: "MasterDetail",
  version: yt,
  dependsOn: [HXe, yc, r_]
}, OXe = (e) => {
  if (typeof e != "string" || !e.length)
    return [];
  const t = e.split(".");
  return t.includes("__proto__") ? [] : t;
}, G_ = (e) => {
  const t = OXe(e);
  let o = null;
  const n = t.length - 1;
  return n === 0 ? o = (s) => s == null ? void 0 : s[e] : n > 0 ? o = (s) => {
    let i = s;
    for (let r = 0; r <= n && i !== null && i !== void 0; ++r)
      if (i = i[t[r]], r < n && typeof i != "object" && i !== void 0)
        return null;
    return i;
  } : o = () => {
  }, o.path = e, o;
}, BXe = class extends Nb {
  constructor() {
    super(...arguments), this.beanName = "csrmChildrenTreeNodeSvc", this.childrenGetter = null;
  }
  destroy() {
    super.destroy(), this.childrenGetter = null;
  }
  extractRowData() {
    var e, t;
    return (t = (e = this.rootNode) == null ? void 0 : e.childrenAfterGroup) == null ? void 0 : t.map(({ data: o }) => o);
  }
  activate(e) {
    const t = this.childrenGetter, o = this.gos.get("treeDataChildrenField") ?? null;
    (!t || t.path !== o) && (this.childrenGetter = G_(o)), super.activate(e);
  }
  deactivate() {
    this.childrenGetter = null, super.deactivate();
  }
  updateRowData(e, t) {
    return X(268), {
      changedRowNodes: t,
      rowNodeTransaction: { add: [], remove: [], update: [] },
      rowsInserted: !1
    };
  }
  loadNewRowData(e) {
    const t = this.rootNode, o = this.childrenGetter, n = /* @__PURE__ */ new Map(), s = [];
    t.allLeafChildren = s;
    const i = (r, l) => {
      let a = n.get(l);
      if (a !== void 0) {
        qe(2, { nodeId: a.id });
        return;
      }
      a = this.createRowNode(l, s.length), a.treeParent = r, n.set(l, a), s.push(a);
      const c = o == null ? void 0 : o(l);
      if (c)
        for (let d = 0, u = c.length; d < u; ++d)
          i(a, c[d]);
    };
    for (let r = 0, l = e.length; r < l; ++r)
      i(t, e[r]);
  }
  setImmutableRowData(e, t) {
    this.dispatchRowDataUpdateStartedEvent(t);
    const o = this.gos, n = this.rootNode, s = this.childrenGetter, i = Qs(o), r = !o.get("suppressMaintainUnsortedOrder"), l = /* @__PURE__ */ new Map(), a = new Wi(!1, n);
    e.changedPath = a;
    const c = e.changedRowNodes, d = n.allLeafChildren, u = [], h = [];
    let p = !1, C = !1;
    const m = (b, _, M) => {
      const x = _ == null ? void 0 : _.length;
      let L = !0, A = -1;
      for (let R = 0; R < x; ++R) {
        const P = w(b, _[R], M);
        r && P >= 0 && (P < A && (L = !1), A = P);
      }
      L || (p = !0);
    }, w = (b, _, M) => {
      let x = l.get(_);
      if (x !== void 0)
        return X(2, { nodeId: x.id }), -1;
      const L = i({ data: _, level: M });
      if (x = this.getRowNode(L), x) {
        let P = !1;
        x.data !== _ && (P = !0, x.updateData(_), !x.selectable && x.isSelected() && h.push(x)), x.treeParent !== b && (x.treeParent = b, P = !0), P && (C = !0, c.update(x));
      } else
        x = this.createRowNode(_, -1), x.treeParent = b, C = !0, c.add(x);
      l.set(_, x);
      let A;
      r ? (A = x.sourceRowIndex, x.sourceRowIndex = u.push(x) - 1) : A = -1;
      const R = s == null ? void 0 : s(_);
      return R && m(x, R, M + 1), A;
    };
    if (m(n, t, 0), d) {
      const b = this.beans.pinnedRowModel;
      for (let _ = 0, M = d.length; _ < M; ++_) {
        const x = d[_];
        if (!l.has(x.data)) {
          x.treeParent = null, x.treeNodeFlags = 0;
          const L = x.pinnedSibling;
          L && (b == null || b.pinRow(L, null)), x.clearRowTopAndRowIndex(), this.rowNodeDeleted(x), x.isSelected() && h.push(x), c.remove(x);
        }
      }
    }
    if (!r) {
      if (d) {
        const b = c.removals;
        for (let _ = 0, M = d.length; _ < M; ++_) {
          const x = d[_];
          b.has(x) || (x.sourceRowIndex = u.push(x) - 1);
        }
      }
      for (const b of c.adds)
        b.sourceRowIndex = u.push(b) - 1;
    }
    n.allLeafChildren = u, h.length && this.deselectNodes(h);
    const y = n.sibling;
    y && (y.allLeafChildren = u), (C || p) && (e.rowDataUpdated = !0, e.rowNodesOrderChanged || (e.rowNodesOrderChanged = p));
  }
}, Jt = 2147483648, ao = 1073741824, V1 = 536870912, qn = 268435456, fr = 268435455, O1 = String.fromCharCode(31, 4096 + Math.random() * 61440, 4096 + Math.random() * 61440, 8291), F0 = 4, $Xe = class extends K {
  constructor() {
    super(...arguments), this.groupColsIds = "", this.groupColsChanged = !0, this.parentIdGetter = null, this.fillerNodesById = null, this.nodesToUnselect = null;
  }
  destroy() {
    super.destroy(), this.groupColsIds = "", this.parentIdGetter = null, this.fillerNodesById = null, this.nodesToUnselect = null;
  }
  reset() {
    this.destroyFillerRows(), this.deselectHiddenNodes(!1), this.groupColsIds = "", this.groupColsChanged = !0, this.parentIdGetter = null;
  }
  getNode(e) {
    var t;
    return (t = this.fillerNodesById) == null ? void 0 : t.get(e);
  }
  execute(e, t) {
    const { changedRowNodes: o, changedPath: n, afterColumnsChanged: s } = e;
    this.checkGroupColsUpdated(s);
    const i = e.rowNode, r = n != null && n.active ? n : void 0, l = !o && !r, a = !!o && this.flagUpdatedNodes(o);
    (l || a) && (t === "treeNested" ? this.loadNested(e, l) : t === "treeSelfRef" ? this.loadSelfRef(e, l) : this.loadDataPath(e, l));
    const c = this.initRowsParents(i);
    this.destroyFillerRows(), this.initRowsChildrenSize(i);
    let d = this.preprocessRows(i);
    const u = c || (d & Jt) !== 0;
    d &= ~Jt;
    const h = this.traverseRoot(i, r);
    return d > 0 && d !== h && (this.handleCycles(i), this.traverseRoot(i, r)), i.treeNodeFlags = 0, this.deselectHiddenNodes(c || l), u;
  }
  flagUpdatedNodes(e) {
    const { adds: t, updates: o, removals: n } = e;
    let s = n.size > 0;
    if (t.size > 0) {
      s = !0;
      for (const i of t)
        i.treeNodeFlags |= ao;
    }
    if (o.size > 0) {
      s = !0;
      for (const i of o)
        i.treeNodeFlags |= ao;
    }
    return s;
  }
  initRowsParents(e) {
    const t = e.allLeafChildren, o = t.length;
    let n = !1;
    for (let s = 0; s < o; ++s) {
      let i = t[s];
      for (; ; ) {
        const r = i.parent, l = i.treeParent;
        if (l === null) {
          r && (n = !0, this.hideRow(i));
          break;
        }
        let a = l.treeNodeFlags + 1;
        if (r !== l && (n = !0, a |= ao, i.parent = l, r)) {
          const c = r.treeNodeFlags;
          (c & qn) !== 0 && (a & qn) === 0 && l.treeParent !== null && !l.data && (l.expanded = r.expanded, a |= qn), r.treeNodeFlags = c | ao;
        }
        if (l.data || (l.treeNodeFlags & V1) !== 0 || l.treeParent === null) {
          l.treeNodeFlags = a;
          break;
        }
        l.treeNodeFlags = a | V1 | i.treeNodeFlags & ao, i = l;
      }
    }
    return n;
  }
  destroyFillerRows() {
    const e = this.fillerNodesById;
    if (e) {
      for (const t of e.values())
        (t.treeParent === null || (t.treeNodeFlags & fr) === 0) && (e.delete(t.id), this.hideRow(t));
      e.size === 0 && (this.fillerNodesById = null);
    }
  }
  initRowsChildrenSize(e) {
    this.initRowChildrenSize(e);
    const t = e.allLeafChildren, o = t.length;
    for (let s = 0; s < o; ++s)
      this.initRowChildrenSize(t[s]);
    const n = this.fillerNodesById;
    if (n !== null)
      for (const s of n.values())
        this.initRowChildrenSize(s);
  }
  initRowChildrenSize(e) {
    let { childrenAfterGroup: t, allLeafChildren: o, treeNodeFlags: n } = e;
    const s = t == null ? void 0 : t.length, i = n & fr;
    if (e.treeNodeFlags = n & ~fr | ((s || 0) !== i ? Jt : 0), i === 0 && e.level >= 0) {
      if (t !== bn) {
        e.childrenAfterGroup = bn;
        const r = e.sibling;
        r && (r.childrenAfterGroup = bn);
      }
    } else if (s !== i || t === o)
      if (!t || t === bn || t === o) {
        e.childrenAfterGroup = t = new Array(i);
        const r = e.sibling;
        r && (r.childrenAfterGroup = t);
      } else
        t.length = i;
  }
  preprocessRows(e) {
    const t = e.allLeafChildren, o = t.length, n = this.groupColsChanged;
    let s = 0, i = !1;
    for (let r = 0; r < o; ++r) {
      let l = t[r];
      for (; ; ) {
        const a = l.treeParent;
        if (a === null)
          break;
        ++s;
        let c = a.treeNodeFlags;
        const d = a.childrenAfterGroup, u = c & fr;
        if (c = c & ~fr | u + 1, (c & Jt || d[u] !== l) && (c |= Jt, d[u] = l, i = !0), a.treeNodeFlags = c, (!l.groupData || n) && (l.treeNodeFlags |= ao, this.setGroupData(l, l.key)), a.data || (a.treeNodeFlags & V1) === 0 || a.treeParent === null)
          break;
        a.treeNodeFlags = c & ~V1 | l.treeNodeFlags & ao, l = a;
      }
    }
    return s | (i ? Jt : 0);
  }
  traverseRoot(e, t) {
    let o = 0;
    const n = e.childrenAfterGroup;
    for (let s = 0, i = n.length; s < i; ++s)
      o += this.traverse(n[s], 0, !1, t);
    return o & ~Jt;
  }
  /**
   * After all the rows are initialized and treeParent is set and childrenAfterGroup is filled,
   * we traverse the tree to finalize it
   * @returns the number of leaf nodes processed, which is used to detect cycles in the tree, and a flag set if leaf children were changed.
   */
  traverse(e, t, o, n) {
    var c;
    const s = e.childrenAfterGroup, i = s.length;
    let r = e.treeNodeFlags;
    e.treeNodeFlags = r & qn, e.level = t, e.group !== !!i ? (E_(e, this.beans, !!i), r |= ao) : e.hasChildren() !== !!i && (e.updateHasChildren(), r |= ao), (r & (ao | Jt)) !== 0 && (n == null || n.addParentNode(e)), i !== 0 || e.master ? (r & qn) === 0 && (e.treeNodeFlags |= qn, e.expanded = bc(this.beans, e, t)) : (e.expanded && (e.expanded = !1), (r & qn) !== 0 && (e.treeNodeFlags &= ~qn)), o && e.rowIndex !== null && e.clearRowTopAndRowIndex(), o || (o = e.expanded === !1), ++t, r &= Jt;
    let a = 0;
    for (let d = 0; d < i; ++d) {
      const u = s[d], h = this.traverse(u, t, o, n);
      r = r + (h & ~Jt) | h & Jt, a += (((c = u.allLeafChildren) == null ? void 0 : c.length) || 0) + (u.data ? 1 : 0);
    }
    return this.updateAllLeafChildren(e, a, (r & Jt) !== 0) ? (r | Jt) + 1 : (r & ~Jt) + 1;
  }
  updateAllLeafChildren(e, t, o) {
    let n = e.allLeafChildren, s = ((n == null ? void 0 : n.length) || 0) !== t;
    if (t === 0) {
      if (n !== null) {
        e.allLeafChildren = null;
        const i = e.sibling;
        i && (i.allLeafChildren = null);
      }
    } else if (s || o) {
      if (n)
        s && (n.length = t);
      else {
        e.allLeafChildren = n = new Array(t);
        const r = e.sibling;
        r && (r.allLeafChildren = n);
      }
      const i = e.childrenAfterGroup;
      for (let r = 0, l = 0, a = i.length; r < a; ++r) {
        const c = i[r];
        c.data && ((s || (s = n[l] !== c)) && (n[l] = c), ++l);
        const d = c.allLeafChildren;
        if (d)
          for (let u = 0, h = d.length; u < h; ++u, ++l) {
            const p = d[u];
            (s || (s = n[l] !== p)) && (n[l] = p);
          }
      }
    }
    return s;
  }
  /** Handle cycles in a tree. Is not optimal for performance but this is an edge case that shouldn't happen as is a warning. */
  handleCycles(e) {
    const t = /* @__PURE__ */ new Set(), o = (s) => t.has(s) ? !1 : (t.add(s), s.childrenAfterGroup.forEach(o), !0);
    o(e);
    const n = e.childrenAfterGroup;
    n.length = 0;
    for (const s of e.allLeafChildren) {
      const i = s.treeParent;
      i && o(s) ? (i.treeNodeFlags |= Jt | ao, s.parent = e, Zt(i.childrenAfterGroup, s), n.push(s), X(270, { id: s.id, parentId: (i == null ? void 0 : i.id) ?? "" })) : i === e && n.push(s);
    }
  }
  setGroupData(e, t) {
    var s;
    const o = {}, n = (s = this.beans.showRowGroupCols) == null ? void 0 : s.getShowRowGroupCols();
    if (e.groupData = o, n)
      for (const i of n)
        o[i.getColId()] = t;
  }
  /** Load the tree structure for nested groups, aka children property */
  loadNested({ rowNode: e, changedRowNodes: t }, o) {
    if (!o && t) {
      for (const s of t.adds)
        s.key = s.id;
      return;
    }
    const n = e.allLeafChildren;
    for (let s = 0, i = n.length; s < i; ++s) {
      const r = n[s], l = r.id;
      r.key !== l && (r.key = l, r.groupData = null);
    }
  }
  /** Load the tree structure for self-referencing data, aka parentId field */
  loadSelfRef({ rowNode: e, changedRowNodes: t }, o) {
    const n = e.allLeafChildren, s = this.gos;
    if (!s.get("getRowId")) {
      for (let c = 0, d = n.length; c < d; ++c)
        n[c].treeParent = null;
      return;
    }
    const i = this.beans.rowModel, r = t == null ? void 0 : t.removals;
    let l = this.parentIdGetter;
    const a = s.get("treeDataParentIdField") || null;
    (l == null ? void 0 : l.path) !== a && (this.parentIdGetter = l = G_(a), o = !0);
    for (let c = 0, d = n.length; c < d; ++c) {
      const u = n[c];
      if (o || u.treeNodeFlags & ao || r != null && r.has(u.treeParent)) {
        let h;
        const p = l(u.data);
        p != null && (h = i.getRowNode(p), h || X(271, { id: u.id, parentId: p })), u.treeParent = h ?? e;
        const C = u.id;
        u.key !== C && (u.key = C, u.groupData = null);
      } else
        u.treeParent ?? (u.treeParent = e);
    }
  }
  loadFlattened(e) {
    const t = e.allLeafChildren;
    for (let o = 0, n = t.length; o < n; ++o) {
      const s = t[o];
      s.treeParent = e;
      const i = s.id;
      s.key !== i && (s.key = i, s.groupData = null);
    }
  }
  /** Load the tree structure for data paths, aka getDataPath callback */
  loadDataPath({ rowNode: e }, t) {
    const o = this.gos.get("getDataPath");
    if (!o) {
      this.loadFlattened(e);
      return;
    }
    const n = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Map();
    let i;
    t || (i = this.loadExistingDataPath(e, n, s));
    const r = e.allLeafChildren;
    for (let l = 0, a = r.length; l < a; ++l) {
      const c = r[l];
      if (!t && c.treeParent !== null && (c.treeNodeFlags & ao) === 0)
        continue;
      const d = o(c.data), u = d == null ? void 0 : d.length;
      if (!u) {
        X(185, { data: c.data });
        continue;
      }
      const h = d[u - 1];
      c.key !== h && (c.key = h, c.groupData = null);
      const p = d.join(O1);
      s.set(c, p);
      const C = n.get(p);
      C === void 0 ? n.set(p, c) : C !== c && (i = this.duplicatedPath(n, i, C, c, p));
    }
    i && this.processDuplicatePaths(i, s), this.buildFromPaths(e, n, s);
  }
  loadExistingDataPath(e, t, o) {
    let n;
    const s = e.allLeafChildren;
    for (let i = 0, r = s.length; i < r; ++i) {
      const l = s[i], a = l.treeParent;
      if (a === null || (l.treeNodeFlags & ao) !== 0)
        continue;
      let c = l.key, d = a;
      for (; d && d !== e && d !== l; ) {
        c = O1 + c;
        const u = o.get(d);
        if (u !== void 0) {
          c = u + c;
          break;
        }
        c = d.key + c, d = d.treeParent;
      }
      if (d !== l) {
        o.set(l, c);
        const u = t.get(c);
        u === void 0 ? t.set(c, l) : u !== l && (n = this.duplicatedPath(t, n, u, l, c));
      }
    }
    return n;
  }
  duplicatedPath(e, t, o, n, s) {
    n.sourceRowIndex < o.sourceRowIndex && e.set(s, n);
    const i = (t ?? (t = /* @__PURE__ */ new Map())).get(s);
    return i === void 0 ? t.set(s, [o, n]) : i.push(n), t;
  }
  buildFromPaths(e, t, o) {
    const n = new Array(48), s = e.allLeafChildren;
    for (let i = 0, r = s.length; i < r; ++i) {
      const l = s[i], a = o.get(l);
      if (a === void 0)
        continue;
      const c = this.splitPathKey(n, a);
      let d = 0, u = e;
      for (let h = c - 1; h >= 0; --h) {
        const p = t.get(a.slice(0, n[h]));
        if (p) {
          u = p, d = h + 1;
          break;
        }
      }
      d < c && (u = this.buildMissingFillers(
        t,
        a,
        n,
        c,
        d,
        u
      )), l.treeParent = u;
    }
  }
  /** Collect separators positions, fast string split without allocations */
  splitPathKey(e, t) {
    let o = 0, n = 0;
    const s = t.length;
    for (; n < s; ) {
      const i = t.indexOf(O1, n);
      if (i === -1)
        break;
      e[o++] = i, n = i + F0;
    }
    return o;
  }
  /** Walk forward from startLevel to segmentsLen creating missing filler nodes and return the final parent. */
  buildMissingFillers(e, t, o, n, s, i) {
    let r = 0, l = "row-group";
    i.sourceRowIndex < 0 && i.treeParent && (r = s, l = i.id);
    do {
      const a = s === 0 ? 0 : o[s - 1] + F0, c = o[s], d = t.slice(0, c);
      let u = e.get(d);
      if (u !== void 0)
        u.sourceRowIndex < 0 && (l = u.id, r = s + 1);
      else {
        const h = a === 0 ? d : t.slice(a, c);
        l = this.makeFillerIdBase(t, o, s, l, r) + h, u = this.getOrCreateFiller(h, l), e.set(d, u), r = s + 1;
      }
      u.treeParent = i, i = u, ++s;
    } while (s < n);
    return i;
  }
  processDuplicatePaths(e, t) {
    for (const o of e.values()) {
      o.sort(ZXe);
      const n = o.length, s = new Array(n - 1);
      for (let r = 1; r < n; ++r) {
        const l = o[r];
        t.delete(l), l.treeParent = null, s[r - 1] = l.data;
      }
      const i = o[0];
      X(186, { rowId: i.id, rowData: i.data, duplicateRowsData: s });
    }
  }
  getOrCreateFiller(e, t) {
    const o = this.fillerNodesById ?? (this.fillerNodesById = /* @__PURE__ */ new Map());
    let n = o.get(t);
    return n === void 0 && (n = new pn(this.beans), n.id = t, n.key = e, n.group = !0, n.leafGroup = !1, n.rowGroupIndex = null, o.set(t, n)), n;
  }
  /**
   * Build the base filler ID up to the given 'level' and include the final level separator prefix.
   * Caller should append only the 'fillerKey' after this base.
   * Result format:
   * - With no prefix and level === 0: _ROW_ID_PREFIX_ROW_GROUP + '0-'
   * - With no prefix and level > 0: _ROW_ID_PREFIX_ROW_GROUP + '0-key0-1-key1-...-(level-1)-key(level-1)-level-'
   * - With prefix present: prefixId + '-level-'
   */
  makeFillerIdBase(e, t, o, n, s) {
    for (; s < o; ) {
      const i = s > 0 ? t[s - 1] + F0 : 0, r = t[s];
      n += "-" + s + "-" + e.slice(i, r), ++s;
    }
    return n + "-" + o + "-";
  }
  deselectHiddenNodes(e) {
    var s;
    const t = this.beans.selectionSvc, o = this.nodesToUnselect, n = "rowDataChanged";
    if (o && (this.nodesToUnselect = null, t == null || t.setNodesSelected({ newValue: !1, nodes: o, suppressFinishActions: !0, source: n })), (o || e) && ((s = t == null ? void 0 : t.updateGroupsFromChildrenSelections) == null || s.call(t, n)), o) {
      const i = (t == null ? void 0 : t.getSelectedNodes()) ?? null;
      this.eventSvc.dispatchEvent({ type: "selectionChanged", source: n, selectedNodes: i, serverSideState: null });
    }
  }
  hideRow(e) {
    e.isSelected() && (this.nodesToUnselect ?? (this.nodesToUnselect = [])).push(e), e.parent = null, e.group = !1, e.groupData = null, e.treeParent = null, e.treeNodeFlags = 0, e.allLeafChildren = null, e.childrenAfterGroup = bn;
    const t = e.sibling;
    t && (t.allLeafChildren = null, t.childrenAfterGroup = bn), e.updateHasChildren(), e.rowIndex !== null && e.clearRowTopAndRowIndex();
  }
  checkGroupColsUpdated(e) {
    var t;
    if (this.groupColsChanged = !1, e || !this.groupColsIds) {
      const o = ((t = this.beans.showRowGroupCols) == null ? void 0 : t.getShowRowGroupCols()) ?? bn;
      let n = "";
      for (let s = 0, i = o.length; s < i; ++s)
        n += o[s].getId() + O1;
      this.groupColsIds !== n && (this.groupColsIds = n, this.groupColsChanged = !0);
    }
  }
}, ZXe = (e, t) => e.sourceRowIndex - t.sourceRowIndex, GXe = {
  moduleName: "SharedTreeData",
  version: yt,
  dependsOn: [ko, wc, $_, _c]
}, NXe = {
  moduleName: "TreeData",
  version: yt,
  beans: [BXe],
  dynamicBeans: { treeGroupStrategy: $Xe },
  rowModels: ["clientSide"],
  dependsOn: [GXe, V_, yc]
}, zXe = ["number", "category", "grouped-category", "log", "time"];
zXe.reduce(
  (e, t) => ({ ...e, [t]: { title: { _enabledFromTheme: !0 } } }),
  {}
);
function N_(e) {
  return e.map(
    (t, o, n) => t.map((s, i) => n.slice(0, o + 1).reduce((r, l) => r + l[i], 0))
  );
}
function z_(e) {
  const t = e.map((o, n) => e.reduce((s, i) => Math.max(s, i[n]), 0));
  return e.map((o) => o.map((n, s) => n / t[s] * 19));
}
var j_ = [
  [1, 3, 5],
  [2, 6, 4],
  [5, 3, 1]
], jXe = N_(j_);
z_(jXe);
var WXe = j_, UXe = N_(WXe);
z_(UXe);
var KXe = Object.defineProperty, qXe = (e, t, o) => t in e ? KXe(e, t, { enumerable: !0, configurable: !0, writable: !0, value: o }) : e[t] = o, ki = (e, t, o) => qXe(e, typeof t != "symbol" ? t + "" : t, o);
class t1 {
  static getComponentDefinition(t, o) {
    let n;
    return typeof t == "string" ? n = this.searchForComponentInstance(o, t) : n = { extends: pe({ ...t }) }, n || qe(114, { component: t }), n.extends ? (n.extends.setup && (n.setup = n.extends.setup), n.extends.props = this.addParamsToProps(n.extends.props)) : n.props = this.addParamsToProps(n.props), n;
  }
  static addParamsToProps(t) {
    return !t || Array.isArray(t) && t.indexOf("params") === -1 ? t = ["params", ...t || []] : typeof t == "object" && !t.params && (t.params = {
      type: Object
    }), t;
  }
  static createAndMountComponent(t, o, n, s) {
    const i = t1.getComponentDefinition(t, n);
    if (!i)
      return;
    const { vNode: r, destroy: l, el: a } = this.mount(
      i,
      { params: Object.freeze(o) },
      n,
      s || {}
    );
    return {
      componentInstance: r.component.proxy,
      element: a,
      destroy: l
    };
  }
  static mount(t, o, n, s) {
    let i = de(t, o);
    i.appContext = { ...n.appContext, provides: s };
    let r = document.createDocumentFragment();
    return il(i, r), { vNode: i, destroy: () => {
      r && il(null, r), r = null, i = null;
    }, el: r };
  }
  static searchForComponentInstance(t, o, n = 10, s = !1) {
    let i = null, r = 0, l = t.parent;
    for (; !i && l && l.components && ++r < n; )
      l.components && l.components[o] && (i = l.components[o]), l = l.parent;
    for (r = 0, l = t.parent; !i && l && l.$options && ++r < n; ) {
      const a = l;
      a.$options && a.$options.components && a.$options.components[o] ? i = a.$options.components[o] : a[o] && (i = a[o]), l = l.parent;
    }
    for (r = 0, l = t.parent; !i && l && ++r < n; ) {
      if (l.exposed) {
        const a = l;
        a.exposed && a.exposed[o] ? i = a.exposed[o] : a[o] && (i = a[o]);
      }
      l = l.parent;
    }
    if (!i) {
      const a = t.appContext.components;
      a && a[o] && (i = a[o]);
    }
    return !i && !s ? (qe(114, { component: o }), null) : i;
  }
}
class YXe extends ZNe {
  constructor(t, o) {
    super(), ki(this, "parent"), ki(this, "provides"), this.parent = t, this.provides = o;
  }
  createWrapper(t) {
    const o = this;
    class n extends QXe {
      init(r) {
        super.init(r);
      }
      hasMethod(r) {
        var l, a;
        const c = s.getFrameworkComponentInstance();
        return c[r] ? !0 : ((l = c.$.exposed) == null ? void 0 : l[r]) != null || ((a = c.exposed) == null ? void 0 : a[r]) != null || c.$.setupState[r] != null;
      }
      callMethod(r, l) {
        var a, c;
        const d = this.getFrameworkComponentInstance(), u = s.getFrameworkComponentInstance();
        if (u[r])
          return u[r].apply(d, l);
        {
          const h = ((a = d.$.exposed) == null ? void 0 : a[r]) || ((c = d.exposed) == null ? void 0 : c[r]) || d.$.setupState[r];
          return h == null ? void 0 : h.apply(d, l);
        }
      }
      addMethod(r, l) {
        s[r] = l;
      }
      processMethod(r, l) {
        return r === "refresh" && (this.getFrameworkComponentInstance().params = l[0]), this.hasMethod(r) ? this.callMethod(r, l) : r === "refresh";
      }
      createComponent(r) {
        return o.createComponent(t, r);
      }
    }
    const s = new n();
    return s;
  }
  createComponent(t, o) {
    return t1.createAndMountComponent(t, o, this.parent, this.provides);
  }
  createMethodProxy(t, o, n) {
    return function() {
      return t.hasMethod(o) ? t.callMethod(o, arguments) : (n && X(233, { methodName: o }), null);
    };
  }
  destroy() {
    this.parent = null;
  }
}
class QXe {
  constructor() {
    ki(this, "componentInstance"), ki(this, "element"), ki(this, "unmount");
  }
  getGui() {
    return this.element;
  }
  destroy() {
    this.getFrameworkComponentInstance() && typeof this.getFrameworkComponentInstance().destroy == "function" && this.getFrameworkComponentInstance().destroy(), this.unmount();
  }
  getFrameworkComponentInstance() {
    return this.componentInstance;
  }
  init(t) {
    const { componentInstance: o, element: n, destroy: s } = this.createComponent(t);
    this.componentInstance = o, this.unmount = s, this.element = n.firstElementChild ?? n;
  }
}
class JXe extends Ub {
  constructor(t) {
    super("vue"), ki(this, "parent"), this.parent = t;
  }
  /*
   * vue components are specified in the "components" part of the vue component - as such we need a way to determine
   * if a given component is within that context - this method provides this
   * Note: This is only really used/necessary with cellRendererSelectors
   */
  frameworkComponent(t, o) {
    let n = t1.searchForComponentInstance(this.parent, t, 10, !0) ? t : null;
    if (!n && o && o[t]) {
      const s = o[t];
      n = t1.searchForComponentInstance(this.parent, s, 10, !0) ? s : null;
    }
    return n;
  }
  isFrameworkComponent(t) {
    return typeof t == "object";
  }
}
function XXe() {
  return {
    gridOptions: {},
    modules: [],
    // @START_DEFAULTS@
    statusBar: void 0,
    sideBar: void 0,
    suppressContextMenu: void 0,
    preventDefaultOnContextMenu: void 0,
    allowContextMenuWithControlKey: void 0,
    columnMenu: void 0,
    suppressMenuHide: void 0,
    enableBrowserTooltips: void 0,
    tooltipTrigger: void 0,
    tooltipShowDelay: void 0,
    tooltipHideDelay: void 0,
    tooltipMouseTrack: void 0,
    tooltipShowMode: void 0,
    tooltipInteraction: void 0,
    popupParent: void 0,
    copyHeadersToClipboard: void 0,
    copyGroupHeadersToClipboard: void 0,
    clipboardDelimiter: void 0,
    suppressCopyRowsToClipboard: void 0,
    suppressCopySingleCellRanges: void 0,
    suppressLastEmptyLineOnPaste: void 0,
    suppressClipboardPaste: void 0,
    suppressClipboardApi: void 0,
    suppressCutToClipboard: void 0,
    columnDefs: void 0,
    defaultColDef: void 0,
    defaultColGroupDef: void 0,
    columnTypes: void 0,
    dataTypeDefinitions: void 0,
    maintainColumnOrder: void 0,
    enableStrictPivotColumnOrder: void 0,
    suppressFieldDotNotation: void 0,
    headerHeight: void 0,
    groupHeaderHeight: void 0,
    floatingFiltersHeight: void 0,
    pivotHeaderHeight: void 0,
    pivotGroupHeaderHeight: void 0,
    hidePaddedHeaderRows: void 0,
    allowDragFromColumnsToolPanel: void 0,
    suppressMovableColumns: void 0,
    suppressColumnMoveAnimation: void 0,
    suppressMoveWhenColumnDragging: void 0,
    suppressDragLeaveHidesColumns: void 0,
    suppressGroupChangesColumnVisibility: void 0,
    suppressMakeColumnVisibleAfterUnGroup: void 0,
    suppressRowGroupHidesColumns: void 0,
    colResizeDefault: void 0,
    suppressAutoSize: void 0,
    autoSizePadding: void 0,
    skipHeaderOnAutoSize: void 0,
    autoSizeStrategy: void 0,
    components: void 0,
    editType: void 0,
    suppressStartEditOnTab: void 0,
    getFullRowEditValidationErrors: void 0,
    invalidEditValueMode: void 0,
    singleClickEdit: void 0,
    suppressClickEdit: void 0,
    readOnlyEdit: void 0,
    stopEditingWhenCellsLoseFocus: void 0,
    enterNavigatesVertically: void 0,
    enterNavigatesVerticallyAfterEdit: void 0,
    enableCellEditingOnBackspace: void 0,
    undoRedoCellEditing: void 0,
    undoRedoCellEditingLimit: void 0,
    defaultCsvExportParams: void 0,
    suppressCsvExport: void 0,
    defaultExcelExportParams: void 0,
    suppressExcelExport: void 0,
    excelStyles: void 0,
    findSearchValue: void 0,
    findOptions: void 0,
    quickFilterText: void 0,
    cacheQuickFilter: void 0,
    includeHiddenColumnsInQuickFilter: void 0,
    quickFilterParser: void 0,
    quickFilterMatcher: void 0,
    applyQuickFilterBeforePivotOrAgg: void 0,
    excludeChildrenWhenTreeDataFiltering: void 0,
    enableAdvancedFilter: void 0,
    alwaysPassFilter: void 0,
    includeHiddenColumnsInAdvancedFilter: void 0,
    advancedFilterParent: void 0,
    advancedFilterBuilderParams: void 0,
    advancedFilterParams: void 0,
    suppressAdvancedFilterEval: void 0,
    suppressSetFilterByDefault: void 0,
    enableFilterHandlers: void 0,
    filterHandlers: void 0,
    enableCharts: void 0,
    chartThemes: void 0,
    customChartThemes: void 0,
    chartThemeOverrides: void 0,
    chartToolPanelsDef: void 0,
    chartMenuItems: void 0,
    loadingCellRenderer: void 0,
    loadingCellRendererParams: void 0,
    loadingCellRendererSelector: void 0,
    localeText: void 0,
    masterDetail: void 0,
    keepDetailRows: void 0,
    keepDetailRowsCount: void 0,
    detailCellRenderer: void 0,
    detailCellRendererParams: void 0,
    detailRowHeight: void 0,
    detailRowAutoHeight: void 0,
    context: void 0,
    alignedGrids: void 0,
    tabIndex: void 0,
    rowBuffer: void 0,
    valueCache: void 0,
    valueCacheNeverExpires: void 0,
    enableCellExpressions: void 0,
    suppressTouch: void 0,
    suppressFocusAfterRefresh: void 0,
    suppressBrowserResizeObserver: void 0,
    suppressPropertyNamesCheck: void 0,
    suppressChangeDetection: void 0,
    debug: void 0,
    loading: void 0,
    overlayLoadingTemplate: void 0,
    loadingOverlayComponent: void 0,
    loadingOverlayComponentParams: void 0,
    suppressLoadingOverlay: void 0,
    overlayNoRowsTemplate: void 0,
    noRowsOverlayComponent: void 0,
    noRowsOverlayComponentParams: void 0,
    suppressNoRowsOverlay: void 0,
    pagination: void 0,
    paginationPageSize: void 0,
    paginationPageSizeSelector: void 0,
    paginationAutoPageSize: void 0,
    paginateChildRows: void 0,
    suppressPaginationPanel: void 0,
    pivotMode: void 0,
    pivotPanelShow: void 0,
    pivotMaxGeneratedColumns: void 0,
    pivotDefaultExpanded: void 0,
    pivotColumnGroupTotals: void 0,
    pivotRowTotals: void 0,
    pivotSuppressAutoColumn: void 0,
    suppressExpandablePivotGroups: void 0,
    functionsReadOnly: void 0,
    aggFuncs: void 0,
    suppressAggFuncInHeader: void 0,
    alwaysAggregateAtRootLevel: void 0,
    aggregateOnlyChangedColumns: void 0,
    suppressAggFilteredOnly: void 0,
    removePivotHeaderRowWhenSingleValueColumn: void 0,
    animateRows: void 0,
    cellFlashDuration: void 0,
    cellFadeDuration: void 0,
    allowShowChangeAfterFilter: void 0,
    domLayout: void 0,
    ensureDomOrder: void 0,
    enableCellSpan: void 0,
    enableRtl: void 0,
    suppressColumnVirtualisation: void 0,
    suppressMaxRenderedRowRestriction: void 0,
    suppressRowVirtualisation: void 0,
    rowDragManaged: void 0,
    rowDragInsertDelay: void 0,
    suppressRowDrag: void 0,
    suppressMoveWhenRowDragging: void 0,
    rowDragEntireRow: void 0,
    rowDragMultiRow: void 0,
    rowDragText: void 0,
    dragAndDropImageComponent: void 0,
    dragAndDropImageComponentParams: void 0,
    fullWidthCellRenderer: void 0,
    fullWidthCellRendererParams: void 0,
    embedFullWidthRows: void 0,
    groupDisplayType: void 0,
    groupDefaultExpanded: void 0,
    autoGroupColumnDef: void 0,
    groupMaintainOrder: void 0,
    groupSelectsChildren: void 0,
    groupLockGroupColumns: void 0,
    groupAggFiltering: void 0,
    groupTotalRow: void 0,
    grandTotalRow: void 0,
    suppressStickyTotalRow: void 0,
    groupSuppressBlankHeader: void 0,
    groupSelectsFiltered: void 0,
    showOpenedGroup: void 0,
    groupHideParentOfSingleChild: void 0,
    groupRemoveSingleChildren: void 0,
    groupRemoveLowestSingleChildren: void 0,
    groupHideOpenParents: void 0,
    groupAllowUnbalanced: void 0,
    rowGroupPanelShow: void 0,
    groupRowRenderer: void 0,
    groupRowRendererParams: void 0,
    treeData: void 0,
    treeDataChildrenField: void 0,
    treeDataParentIdField: void 0,
    rowGroupPanelSuppressSort: void 0,
    suppressGroupRowsSticky: void 0,
    groupHierarchyConfig: void 0,
    pinnedTopRowData: void 0,
    pinnedBottomRowData: void 0,
    enableRowPinning: void 0,
    isRowPinnable: void 0,
    isRowPinned: void 0,
    rowModelType: void 0,
    rowData: void 0,
    asyncTransactionWaitMillis: void 0,
    suppressModelUpdateAfterUpdateTransaction: void 0,
    datasource: void 0,
    cacheOverflowSize: void 0,
    infiniteInitialRowCount: void 0,
    serverSideInitialRowCount: void 0,
    suppressServerSideFullWidthLoadingRow: void 0,
    cacheBlockSize: void 0,
    maxBlocksInCache: void 0,
    maxConcurrentDatasourceRequests: void 0,
    blockLoadDebounceMillis: void 0,
    purgeClosedRowNodes: void 0,
    serverSideDatasource: void 0,
    serverSideSortAllLevels: void 0,
    serverSideEnableClientSideSort: void 0,
    serverSideOnlyRefreshFilteredGroups: void 0,
    serverSidePivotResultFieldSeparator: void 0,
    viewportDatasource: void 0,
    viewportRowModelPageSize: void 0,
    viewportRowModelBufferSize: void 0,
    alwaysShowHorizontalScroll: void 0,
    alwaysShowVerticalScroll: void 0,
    debounceVerticalScrollbar: void 0,
    suppressHorizontalScroll: void 0,
    suppressScrollOnNewData: void 0,
    suppressScrollWhenPopupsAreOpen: void 0,
    suppressAnimationFrame: void 0,
    suppressMiddleClickScrolls: void 0,
    suppressPreventDefaultOnMouseWheel: void 0,
    scrollbarWidth: void 0,
    rowSelection: void 0,
    cellSelection: void 0,
    rowMultiSelectWithClick: void 0,
    suppressRowDeselection: void 0,
    suppressRowClickSelection: void 0,
    suppressCellFocus: void 0,
    suppressHeaderFocus: void 0,
    selectionColumnDef: void 0,
    rowNumbers: void 0,
    suppressMultiRangeSelection: void 0,
    enableCellTextSelection: void 0,
    enableRangeSelection: void 0,
    enableRangeHandle: void 0,
    enableFillHandle: void 0,
    fillHandleDirection: void 0,
    suppressClearOnFillReduction: void 0,
    sortingOrder: void 0,
    accentedSort: void 0,
    unSortIcon: void 0,
    suppressMultiSort: void 0,
    alwaysMultiSort: void 0,
    multiSortKey: void 0,
    suppressMaintainUnsortedOrder: void 0,
    icons: void 0,
    rowHeight: void 0,
    rowStyle: void 0,
    rowClass: void 0,
    rowClassRules: void 0,
    suppressRowHoverHighlight: void 0,
    suppressRowTransform: void 0,
    columnHoverHighlight: void 0,
    gridId: void 0,
    deltaSort: void 0,
    treeDataDisplayType: void 0,
    enableGroupEdit: void 0,
    initialState: void 0,
    theme: void 0,
    loadThemeGoogleFonts: void 0,
    themeCssLayer: void 0,
    styleNonce: void 0,
    themeStyleContainer: void 0,
    getContextMenuItems: void 0,
    getMainMenuItems: void 0,
    postProcessPopup: void 0,
    processUnpinnedColumns: void 0,
    processCellForClipboard: void 0,
    processHeaderForClipboard: void 0,
    processGroupHeaderForClipboard: void 0,
    processCellFromClipboard: void 0,
    sendToClipboard: void 0,
    processDataFromClipboard: void 0,
    isExternalFilterPresent: void 0,
    doesExternalFilterPass: void 0,
    getChartToolbarItems: void 0,
    createChartContainer: void 0,
    focusGridInnerElement: void 0,
    navigateToNextHeader: void 0,
    tabToNextHeader: void 0,
    navigateToNextCell: void 0,
    tabToNextCell: void 0,
    getLocaleText: void 0,
    getDocument: void 0,
    paginationNumberFormatter: void 0,
    getGroupRowAgg: void 0,
    isGroupOpenByDefault: void 0,
    ssrmExpandAllAffectsAllRows: void 0,
    initialGroupOrderComparator: void 0,
    processPivotResultColDef: void 0,
    processPivotResultColGroupDef: void 0,
    getDataPath: void 0,
    getChildCount: void 0,
    getServerSideGroupLevelParams: void 0,
    isServerSideGroupOpenByDefault: void 0,
    isApplyServerSideTransaction: void 0,
    isServerSideGroup: void 0,
    getServerSideGroupKey: void 0,
    getBusinessKeyForNode: void 0,
    getRowId: void 0,
    resetRowDataOnUpdate: void 0,
    processRowPostCreate: void 0,
    isRowSelectable: void 0,
    isRowMaster: void 0,
    fillOperation: void 0,
    postSortRows: void 0,
    getRowStyle: void 0,
    getRowClass: void 0,
    getRowHeight: void 0,
    isFullWidthRow: void 0,
    isRowValidDropPosition: void 0,
    // @END_DEFAULTS@
    // @START_EVENT_PROPS@
    "onColumn-everything-changed": void 0,
    "onNew-columns-loaded": void 0,
    "onColumn-pivot-mode-changed": void 0,
    "onPivot-max-columns-exceeded": void 0,
    "onColumn-row-group-changed": void 0,
    "onExpand-or-collapse-all": void 0,
    "onColumn-pivot-changed": void 0,
    "onGrid-columns-changed": void 0,
    "onColumn-value-changed": void 0,
    "onColumn-moved": void 0,
    "onColumn-visible": void 0,
    "onColumn-pinned": void 0,
    "onColumn-group-opened": void 0,
    "onColumn-resized": void 0,
    "onDisplayed-columns-changed": void 0,
    "onVirtual-columns-changed": void 0,
    "onColumn-header-mouse-over": void 0,
    "onColumn-header-mouse-leave": void 0,
    "onColumn-header-clicked": void 0,
    "onColumn-header-context-menu": void 0,
    "onAsync-transactions-flushed": void 0,
    "onRow-group-opened": void 0,
    "onRow-data-updated": void 0,
    "onPinned-row-data-changed": void 0,
    "onPinned-rows-changed": void 0,
    "onRange-selection-changed": void 0,
    "onCell-selection-changed": void 0,
    "onChart-created": void 0,
    "onChart-range-selection-changed": void 0,
    "onChart-options-changed": void 0,
    "onChart-destroyed": void 0,
    "onTool-panel-visible-changed": void 0,
    "onTool-panel-size-changed": void 0,
    "onModel-updated": void 0,
    "onCut-start": void 0,
    "onCut-end": void 0,
    "onPaste-start": void 0,
    "onPaste-end": void 0,
    "onFill-start": void 0,
    "onFill-end": void 0,
    "onCell-selection-delete-start": void 0,
    "onCell-selection-delete-end": void 0,
    "onRange-delete-start": void 0,
    "onRange-delete-end": void 0,
    "onUndo-started": void 0,
    "onUndo-ended": void 0,
    "onRedo-started": void 0,
    "onRedo-ended": void 0,
    "onCell-clicked": void 0,
    "onCell-double-clicked": void 0,
    "onCell-mouse-down": void 0,
    "onCell-context-menu": void 0,
    "onCell-value-changed": void 0,
    "onCell-edit-request": void 0,
    "onRow-value-changed": void 0,
    "onHeader-focused": void 0,
    "onCell-focused": void 0,
    "onRow-selected": void 0,
    "onSelection-changed": void 0,
    "onTooltip-show": void 0,
    "onTooltip-hide": void 0,
    "onCell-key-down": void 0,
    "onCell-mouse-over": void 0,
    "onCell-mouse-out": void 0,
    "onFilter-changed": void 0,
    "onFilter-modified": void 0,
    "onFilter-ui-changed": void 0,
    "onFilter-opened": void 0,
    "onFloating-filter-ui-changed": void 0,
    "onAdvanced-filter-builder-visible-changed": void 0,
    "onSort-changed": void 0,
    "onVirtual-row-removed": void 0,
    "onRow-clicked": void 0,
    "onRow-double-clicked": void 0,
    "onGrid-ready": void 0,
    "onGrid-pre-destroyed": void 0,
    "onGrid-size-changed": void 0,
    "onViewport-changed": void 0,
    "onFirst-data-rendered": void 0,
    "onDrag-started": void 0,
    "onDrag-stopped": void 0,
    "onDrag-cancelled": void 0,
    "onRow-editing-started": void 0,
    "onRow-editing-stopped": void 0,
    "onCell-editing-started": void 0,
    "onCell-editing-stopped": void 0,
    "onBody-scroll": void 0,
    "onBody-scroll-end": void 0,
    "onPagination-changed": void 0,
    "onComponent-state-changed": void 0,
    "onStore-refreshed": void 0,
    "onState-updated": void 0,
    "onColumn-menu-visible-changed": void 0,
    "onContext-menu-visible-changed": void 0,
    "onRow-drag-enter": void 0,
    "onRow-drag-move": void 0,
    "onRow-drag-leave": void 0,
    "onRow-drag-end": void 0,
    "onRow-drag-cancel": void 0,
    "onFind-changed": void 0,
    "onRow-resize-started": void 0,
    "onRow-resize-ended": void 0,
    "onColumns-reset": void 0,
    "onBulk-editing-started": void 0,
    "onBulk-editing-stopped": void 0,
    "onBatch-editing-started": void 0,
    "onBatch-editing-stopped": void 0
    // @END_EVENT_PROPS@
  };
}
const eet = (e, t) => {
  let o;
  return () => {
    const n = function() {
      e();
    };
    window.clearTimeout(o), o = window.setTimeout(n, t);
  };
};
function tet(e) {
  return e && e.constructor && e.constructor.toString().substring(0, 5) === "class";
}
function vr(e) {
  const t = (o) => tet(o) ? Mc(o) : Array.isArray(o) ? o.map((n) => t(n)) : Tn(o) || cS(o) || dS(o) ? t(Mc(o)) : o;
  return t(e);
}
const oet = { ref: "root" }, net = /* @__PURE__ */ pe({
  __name: "AgGridVue",
  props: /* @__PURE__ */ Ct(/* @__PURE__ */ aS({
    gridOptions: {},
    modules: {},
    statusBar: {},
    sideBar: { type: [Object, String, Array, Boolean, null] },
    suppressContextMenu: { type: Boolean },
    preventDefaultOnContextMenu: { type: Boolean },
    allowContextMenuWithControlKey: { type: Boolean },
    columnMenu: {},
    suppressMenuHide: { type: Boolean },
    enableBrowserTooltips: { type: Boolean },
    tooltipTrigger: {},
    tooltipShowDelay: {},
    tooltipHideDelay: {},
    tooltipMouseTrack: { type: Boolean },
    tooltipShowMode: {},
    tooltipInteraction: { type: Boolean },
    popupParent: {},
    copyHeadersToClipboard: { type: Boolean },
    copyGroupHeadersToClipboard: { type: Boolean },
    clipboardDelimiter: {},
    suppressCopyRowsToClipboard: { type: Boolean },
    suppressCopySingleCellRanges: { type: Boolean },
    suppressLastEmptyLineOnPaste: { type: Boolean },
    suppressClipboardPaste: { type: Boolean },
    suppressClipboardApi: { type: Boolean },
    suppressCutToClipboard: { type: Boolean },
    columnDefs: {},
    defaultColDef: {},
    defaultColGroupDef: {},
    columnTypes: {},
    dataTypeDefinitions: {},
    maintainColumnOrder: { type: Boolean },
    enableStrictPivotColumnOrder: { type: Boolean },
    suppressFieldDotNotation: { type: Boolean },
    headerHeight: {},
    groupHeaderHeight: {},
    floatingFiltersHeight: {},
    pivotHeaderHeight: {},
    pivotGroupHeaderHeight: {},
    hidePaddedHeaderRows: { type: Boolean },
    allowDragFromColumnsToolPanel: { type: Boolean },
    suppressMovableColumns: { type: Boolean },
    suppressColumnMoveAnimation: { type: Boolean },
    suppressMoveWhenColumnDragging: { type: Boolean },
    suppressDragLeaveHidesColumns: { type: Boolean },
    suppressGroupChangesColumnVisibility: { type: [Boolean, String] },
    suppressMakeColumnVisibleAfterUnGroup: { type: Boolean },
    suppressRowGroupHidesColumns: { type: Boolean },
    colResizeDefault: {},
    suppressAutoSize: { type: Boolean },
    autoSizePadding: {},
    skipHeaderOnAutoSize: { type: Boolean },
    autoSizeStrategy: {},
    components: {},
    editType: {},
    suppressStartEditOnTab: { type: Boolean },
    getFullRowEditValidationErrors: { type: Function },
    invalidEditValueMode: {},
    singleClickEdit: { type: Boolean },
    suppressClickEdit: { type: Boolean },
    readOnlyEdit: { type: Boolean },
    stopEditingWhenCellsLoseFocus: { type: Boolean },
    enterNavigatesVertically: { type: Boolean },
    enterNavigatesVerticallyAfterEdit: { type: Boolean },
    enableCellEditingOnBackspace: { type: Boolean },
    undoRedoCellEditing: { type: Boolean },
    undoRedoCellEditingLimit: {},
    defaultCsvExportParams: {},
    suppressCsvExport: { type: Boolean },
    defaultExcelExportParams: {},
    suppressExcelExport: { type: Boolean },
    excelStyles: {},
    findSearchValue: {},
    findOptions: {},
    quickFilterText: {},
    cacheQuickFilter: { type: Boolean },
    includeHiddenColumnsInQuickFilter: { type: Boolean },
    quickFilterParser: { type: Function },
    quickFilterMatcher: { type: Function },
    applyQuickFilterBeforePivotOrAgg: { type: Boolean },
    excludeChildrenWhenTreeDataFiltering: { type: Boolean },
    enableAdvancedFilter: { type: Boolean },
    alwaysPassFilter: { type: Function },
    includeHiddenColumnsInAdvancedFilter: { type: Boolean },
    advancedFilterParent: {},
    advancedFilterBuilderParams: {},
    advancedFilterParams: {},
    suppressAdvancedFilterEval: { type: Boolean },
    suppressSetFilterByDefault: { type: Boolean },
    enableFilterHandlers: { type: Boolean },
    filterHandlers: {},
    enableCharts: { type: Boolean },
    chartThemes: {},
    customChartThemes: {},
    chartThemeOverrides: {},
    chartToolPanelsDef: {},
    chartMenuItems: { type: [Array, Function] },
    loadingCellRenderer: {},
    loadingCellRendererParams: {},
    loadingCellRendererSelector: { type: Function },
    localeText: {},
    masterDetail: { type: Boolean },
    keepDetailRows: { type: Boolean },
    keepDetailRowsCount: {},
    detailCellRenderer: {},
    detailCellRendererParams: {},
    detailRowHeight: {},
    detailRowAutoHeight: { type: Boolean },
    context: {},
    alignedGrids: { type: [Array, Function] },
    tabIndex: {},
    rowBuffer: {},
    valueCache: { type: Boolean },
    valueCacheNeverExpires: { type: Boolean },
    enableCellExpressions: { type: Boolean },
    suppressTouch: { type: Boolean },
    suppressFocusAfterRefresh: { type: Boolean },
    suppressBrowserResizeObserver: { type: Boolean },
    suppressPropertyNamesCheck: { type: Boolean },
    suppressChangeDetection: { type: Boolean },
    debug: { type: Boolean },
    loading: { type: Boolean },
    overlayLoadingTemplate: {},
    loadingOverlayComponent: {},
    loadingOverlayComponentParams: {},
    suppressLoadingOverlay: { type: Boolean },
    overlayNoRowsTemplate: {},
    noRowsOverlayComponent: {},
    noRowsOverlayComponentParams: {},
    suppressNoRowsOverlay: { type: Boolean },
    pagination: { type: Boolean },
    paginationPageSize: {},
    paginationPageSizeSelector: { type: [Array, Boolean] },
    paginationAutoPageSize: { type: Boolean },
    paginateChildRows: { type: Boolean },
    suppressPaginationPanel: { type: Boolean },
    pivotMode: { type: Boolean },
    pivotPanelShow: {},
    pivotMaxGeneratedColumns: {},
    pivotDefaultExpanded: {},
    pivotColumnGroupTotals: {},
    pivotRowTotals: {},
    pivotSuppressAutoColumn: { type: Boolean },
    suppressExpandablePivotGroups: { type: Boolean },
    functionsReadOnly: { type: Boolean },
    aggFuncs: {},
    suppressAggFuncInHeader: { type: Boolean },
    alwaysAggregateAtRootLevel: { type: Boolean },
    aggregateOnlyChangedColumns: { type: Boolean },
    suppressAggFilteredOnly: { type: Boolean },
    removePivotHeaderRowWhenSingleValueColumn: { type: Boolean },
    animateRows: { type: Boolean },
    cellFlashDuration: {},
    cellFadeDuration: {},
    allowShowChangeAfterFilter: { type: Boolean },
    domLayout: {},
    ensureDomOrder: { type: Boolean },
    enableCellSpan: { type: Boolean },
    enableRtl: { type: Boolean },
    suppressColumnVirtualisation: { type: Boolean },
    suppressMaxRenderedRowRestriction: { type: Boolean },
    suppressRowVirtualisation: { type: Boolean },
    rowDragManaged: { type: Boolean },
    rowDragInsertDelay: {},
    suppressRowDrag: { type: Boolean },
    suppressMoveWhenRowDragging: { type: Boolean },
    rowDragEntireRow: { type: Boolean },
    rowDragMultiRow: { type: Boolean },
    rowDragText: { type: Function },
    dragAndDropImageComponent: {},
    dragAndDropImageComponentParams: {},
    fullWidthCellRenderer: {},
    fullWidthCellRendererParams: {},
    embedFullWidthRows: { type: Boolean },
    groupDisplayType: {},
    groupDefaultExpanded: {},
    autoGroupColumnDef: {},
    groupMaintainOrder: { type: Boolean },
    groupSelectsChildren: { type: Boolean },
    groupLockGroupColumns: {},
    groupAggFiltering: { type: [Boolean, Function] },
    groupTotalRow: { type: [String, Function] },
    grandTotalRow: {},
    suppressStickyTotalRow: { type: [Boolean, String] },
    groupSuppressBlankHeader: { type: Boolean },
    groupSelectsFiltered: { type: Boolean },
    showOpenedGroup: { type: Boolean },
    groupHideParentOfSingleChild: { type: [Boolean, String] },
    groupRemoveSingleChildren: { type: Boolean },
    groupRemoveLowestSingleChildren: { type: Boolean },
    groupHideOpenParents: { type: Boolean },
    groupAllowUnbalanced: { type: Boolean },
    rowGroupPanelShow: {},
    groupRowRenderer: {},
    groupRowRendererParams: {},
    treeData: { type: Boolean },
    treeDataChildrenField: {},
    treeDataParentIdField: {},
    rowGroupPanelSuppressSort: { type: Boolean },
    suppressGroupRowsSticky: { type: Boolean },
    groupHierarchyConfig: {},
    pinnedTopRowData: {},
    pinnedBottomRowData: {},
    enableRowPinning: { type: [Boolean, String] },
    isRowPinnable: { type: Function },
    isRowPinned: { type: Function },
    rowModelType: {},
    rowData: {},
    asyncTransactionWaitMillis: {},
    suppressModelUpdateAfterUpdateTransaction: { type: Boolean },
    datasource: {},
    cacheOverflowSize: {},
    infiniteInitialRowCount: {},
    serverSideInitialRowCount: {},
    suppressServerSideFullWidthLoadingRow: { type: Boolean },
    cacheBlockSize: {},
    maxBlocksInCache: {},
    maxConcurrentDatasourceRequests: {},
    blockLoadDebounceMillis: {},
    purgeClosedRowNodes: { type: Boolean },
    serverSideDatasource: {},
    serverSideSortAllLevels: { type: Boolean },
    serverSideEnableClientSideSort: { type: Boolean },
    serverSideOnlyRefreshFilteredGroups: { type: Boolean },
    serverSidePivotResultFieldSeparator: {},
    viewportDatasource: {},
    viewportRowModelPageSize: {},
    viewportRowModelBufferSize: {},
    alwaysShowHorizontalScroll: { type: Boolean },
    alwaysShowVerticalScroll: { type: Boolean },
    debounceVerticalScrollbar: { type: Boolean },
    suppressHorizontalScroll: { type: Boolean },
    suppressScrollOnNewData: { type: Boolean },
    suppressScrollWhenPopupsAreOpen: { type: Boolean },
    suppressAnimationFrame: { type: Boolean },
    suppressMiddleClickScrolls: { type: Boolean },
    suppressPreventDefaultOnMouseWheel: { type: Boolean },
    scrollbarWidth: {},
    rowSelection: {},
    cellSelection: { type: [Boolean, Object] },
    rowMultiSelectWithClick: { type: Boolean },
    suppressRowDeselection: { type: Boolean },
    suppressRowClickSelection: { type: Boolean },
    suppressCellFocus: { type: Boolean },
    suppressHeaderFocus: { type: Boolean },
    selectionColumnDef: {},
    rowNumbers: { type: [Boolean, Object] },
    suppressMultiRangeSelection: { type: Boolean },
    enableCellTextSelection: { type: Boolean },
    enableRangeSelection: { type: Boolean },
    enableRangeHandle: { type: Boolean },
    enableFillHandle: { type: Boolean },
    fillHandleDirection: {},
    suppressClearOnFillReduction: { type: Boolean },
    sortingOrder: {},
    accentedSort: { type: Boolean },
    unSortIcon: { type: Boolean },
    suppressMultiSort: { type: Boolean },
    alwaysMultiSort: { type: Boolean },
    multiSortKey: {},
    suppressMaintainUnsortedOrder: { type: Boolean },
    icons: {},
    rowHeight: {},
    rowStyle: {},
    rowClass: {},
    rowClassRules: {},
    suppressRowHoverHighlight: { type: Boolean },
    suppressRowTransform: { type: Boolean },
    columnHoverHighlight: { type: Boolean },
    gridId: {},
    deltaSort: { type: Boolean },
    treeDataDisplayType: {},
    enableGroupEdit: { type: Boolean },
    initialState: {},
    theme: {},
    loadThemeGoogleFonts: { type: Boolean },
    themeCssLayer: {},
    styleNonce: {},
    themeStyleContainer: {},
    getContextMenuItems: { type: Function },
    getMainMenuItems: { type: Function },
    postProcessPopup: { type: Function },
    processUnpinnedColumns: { type: Function },
    processCellForClipboard: { type: Function },
    processHeaderForClipboard: { type: Function },
    processGroupHeaderForClipboard: { type: Function },
    processCellFromClipboard: { type: Function },
    sendToClipboard: { type: Function },
    processDataFromClipboard: { type: Function },
    isExternalFilterPresent: { type: Function },
    doesExternalFilterPass: { type: Function },
    getChartToolbarItems: { type: Function },
    createChartContainer: { type: Function },
    focusGridInnerElement: { type: Function },
    navigateToNextHeader: { type: Function },
    tabToNextHeader: { type: Function },
    navigateToNextCell: { type: Function },
    tabToNextCell: { type: Function },
    getLocaleText: { type: Function },
    getDocument: { type: Function },
    paginationNumberFormatter: { type: Function },
    getGroupRowAgg: { type: Function },
    isGroupOpenByDefault: { type: Function },
    ssrmExpandAllAffectsAllRows: { type: Boolean },
    initialGroupOrderComparator: { type: Function },
    processPivotResultColDef: { type: Function },
    processPivotResultColGroupDef: { type: Function },
    getDataPath: { type: Function },
    getChildCount: { type: Function },
    getServerSideGroupLevelParams: { type: Function },
    isServerSideGroupOpenByDefault: { type: Function },
    isApplyServerSideTransaction: { type: Function },
    isServerSideGroup: { type: Function },
    getServerSideGroupKey: { type: Function },
    getBusinessKeyForNode: { type: Function },
    getRowId: { type: Function },
    resetRowDataOnUpdate: { type: Boolean },
    processRowPostCreate: { type: Function },
    isRowSelectable: { type: Function },
    isRowMaster: { type: Function },
    fillOperation: { type: Function },
    postSortRows: { type: Function },
    getRowStyle: { type: Function },
    getRowClass: { type: Function },
    getRowHeight: { type: Function },
    isFullWidthRow: { type: Function },
    isRowValidDropPosition: { type: Function },
    "onTool-panel-visible-changed": {},
    "onTool-panel-size-changed": {},
    "onColumn-menu-visible-changed": {},
    "onContext-menu-visible-changed": {},
    "onCut-start": {},
    "onCut-end": {},
    "onPaste-start": {},
    "onPaste-end": {},
    "onColumn-visible": {},
    "onColumn-pinned": {},
    "onColumn-resized": {},
    "onColumn-moved": {},
    "onColumn-value-changed": {},
    "onColumn-pivot-mode-changed": {},
    "onColumn-pivot-changed": {},
    "onColumn-group-opened": {},
    "onNew-columns-loaded": {},
    "onGrid-columns-changed": {},
    "onDisplayed-columns-changed": {},
    "onVirtual-columns-changed": {},
    "onColumn-everything-changed": {},
    "onColumns-reset": {},
    "onColumn-header-mouse-over": {},
    "onColumn-header-mouse-leave": {},
    "onColumn-header-clicked": {},
    "onColumn-header-context-menu": {},
    "onComponent-state-changed": {},
    "onCell-value-changed": {},
    "onCell-edit-request": {},
    "onRow-value-changed": {},
    "onCell-editing-started": {},
    "onCell-editing-stopped": {},
    "onRow-editing-started": {},
    "onRow-editing-stopped": {},
    "onBulk-editing-started": {},
    "onBulk-editing-stopped": {},
    "onBatch-editing-started": {},
    "onBatch-editing-stopped": {},
    "onUndo-started": {},
    "onUndo-ended": {},
    "onRedo-started": {},
    "onRedo-ended": {},
    "onCell-selection-delete-start": {},
    "onCell-selection-delete-end": {},
    "onRange-delete-start": {},
    "onRange-delete-end": {},
    "onFill-start": {},
    "onFill-end": {},
    "onFilter-opened": {},
    "onFilter-changed": {},
    "onFilter-modified": {},
    "onFilter-ui-changed": {},
    "onFloating-filter-ui-changed": {},
    "onAdvanced-filter-builder-visible-changed": {},
    "onFind-changed": {},
    "onChart-created": {},
    "onChart-range-selection-changed": {},
    "onChart-options-changed": {},
    "onChart-destroyed": {},
    "onCell-key-down": {},
    "onGrid-ready": {},
    "onGrid-pre-destroyed": {},
    "onFirst-data-rendered": {},
    "onGrid-size-changed": {},
    "onModel-updated": {},
    "onVirtual-row-removed": {},
    "onViewport-changed": {},
    "onBody-scroll": {},
    "onBody-scroll-end": {},
    "onDrag-started": {},
    "onDrag-stopped": {},
    "onDrag-cancelled": {},
    "onState-updated": {},
    "onPagination-changed": {},
    "onRow-drag-enter": {},
    "onRow-drag-move": {},
    "onRow-drag-leave": {},
    "onRow-drag-end": {},
    "onRow-drag-cancel": {},
    "onRow-resize-started": {},
    "onRow-resize-ended": {},
    "onColumn-row-group-changed": {},
    "onRow-group-opened": {},
    "onExpand-or-collapse-all": {},
    "onPivot-max-columns-exceeded": {},
    "onPinned-row-data-changed": {},
    "onPinned-rows-changed": {},
    "onRow-data-updated": {},
    "onAsync-transactions-flushed": {},
    "onStore-refreshed": {},
    "onHeader-focused": {},
    "onCell-clicked": {},
    "onCell-double-clicked": {},
    "onCell-focused": {},
    "onCell-mouse-over": {},
    "onCell-mouse-out": {},
    "onCell-mouse-down": {},
    "onRow-clicked": {},
    "onRow-double-clicked": {},
    "onRow-selected": {},
    "onSelection-changed": {},
    "onCell-context-menu": {},
    "onRange-selection-changed": {},
    "onCell-selection-changed": {},
    "onTooltip-show": {},
    "onTooltip-hide": {},
    "onSort-changed": {}
  }, XXe()), {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Ct(["update:modelValue"], ["update:modelValue"]),
  setup(e, { expose: t, emit: o }) {
    const n = e, s = Ro("root"), i = W(void 0), r = W(!1), l = W(!1), a = W(!1), c = W({}), d = W(null), u = d7(n);
    m5().filter((P) => P != "gridOptions").forEach((P) => {
      Me(
        () => u[P],
        (I, B) => {
          (P === "rowData" && !m.value || P !== "rowData") && A(P, I), m.value = !1;
        },
        { deep: !0 }
      );
    });
    const h = /* @__PURE__ */ new Set(["rowDataUpdated", "cellValueChanged", "rowValueChanged"]), p = ct(e, "modelValue"), C = W(!1), m = W(!1), w = o;
    Me(
      p,
      (P, I) => {
        r.value && (m.value || (C.value = !0, A("rowData", vr(P), vr(I))), m.value = !1);
      },
      { deep: !0 }
    );
    const y = eet(() => {
      m.value = !0, w("update:modelValue", x());
    }, 10), b = Bo(), _ = (P) => {
      var I, B;
      a.value && h.has(P) && (B = (I = b == null ? void 0 : b.vnode) == null ? void 0 : I.props) != null && B["onUpdate:modelValue"] && y();
    }, M = () => p.value || n.rowData || n.gridOptions.rowData, x = () => {
      const P = [];
      return i == null || i.value.forEachLeafNode((I) => {
        P.push(I.data);
      }), P;
    }, L = (P) => (I) => {
      if (l.value)
        return;
      I === "gridReady" && (a.value = !0);
      const B = Rr.has(I);
      B && !P || !B && P || h.has(I) && (C.value || _(I), C.value = !1);
    }, A = (P, I, B) => {
      if (r.value) {
        let H = I.value || I;
        P === "rowData" && H != null && (H = vr(H)), c.value[P] = H, d.value == null && (d.value = window.setTimeout(() => {
          d.value = null, IIe(c.value, i.value), c.value = {};
        }, 0));
      }
    }, R = () => Object.create(Bo().provides);
    return At(() => {
      Ui(n_, void 0, !0);
      const P = new YXe(Bo(), R()), I = {
        globalListener: L(),
        globalSyncListener: L(!0),
        frameworkOverrides: new JXe(Bo()),
        providedBeanInstances: {
          frameworkCompWrapper: P
        },
        modules: n.modules
      }, B = lS(
        TIe(vr(n.gridOptions), n, [
          ...m5(),
          // we could have replaced it with GRID_OPTIONS_VALIDATORS().allProperties,
          // but that prevents tree shaking of validation code in Vue
          ...Object.values(Sa)
        ])
      ), H = M();
      H !== void 0 && (B.rowData = vr(H)), i.value = Ey(s.value, B, I), r.value = !0;
    }), Qi(() => {
      var P;
      r.value && ((P = i == null ? void 0 : i.value) == null || P.destroy(), l.value = !0);
    }), t({
      api: i
    }), (P, I) => (f(), v("div", oet, null, 512));
  }
}), $l = "dd.MM.yyyy";
function Xu(e, t) {
  if (t && t !== $l) {
    const s = Zc(e, t);
    if (s) return s;
  }
  const o = Zc(e, $l);
  if (o) return o;
  const n = new Date(e);
  return isNaN(n.getTime()) ? void 0 : n;
}
function set(e) {
  return {
    number: {
      baseDataType: "number",
      extendsDataType: "number",
      // Preserve raw value from cell editor without AG Grid's built-in numeric coercion
      valueParser: (t) => t.newValue
    },
    dateString: {
      baseDataType: "dateString",
      extendsDataType: "dateString",
      dateParser: (t) => {
        if (t)
          return Xu(t, e);
      },
      dateFormatter: (t) => {
        if (!(!t || !V5(t)))
          return Q5(t, e ?? $l);
      },
      valueParser: (t) => {
        if (!t.newValue) return In(/* @__PURE__ */ new Date(), "yyyy-MM-dd");
        const o = Xu(String(t.newValue), e);
        return In(o ?? /* @__PURE__ */ new Date(), "yyyy-MM-dd");
      }
    }
  };
}
const iet = /^\d{4}-\d{2}-\d{2}/;
function W_(e, t) {
  if (!e) return null;
  if ("conditions" in e && Array.isArray(e.conditions)) {
    let n = !1;
    const s = e.conditions.map((i) => {
      const r = W_(i, t);
      return r && (n = !0), r ?? i;
    });
    return n ? { ...e, conditions: s } : null;
  }
  const o = e;
  if (o.filterType === "dateString" && typeof o.filter == "string" && iet.test(o.filter)) {
    const n = new Date(o.filter);
    if (!isNaN(n.getTime()))
      return { ...e, filter: Q5(n, t ?? $l) };
  }
  return null;
}
function qi(e) {
  var t, o;
  return ((t = e.floatingFilterComponentParams) == null ? void 0 : t.advancedFilterColumnType) ?? ((o = e.floatingFilterComponentParams) == null ? void 0 : o.columnType);
}
function e7(e) {
  var t;
  if (qi(e) === void 0 || (t = e.floatingFilterComponentParams) != null && t.hide) return !1;
  switch (qi(e)) {
    case "number":
      return "agNumberColumnFilter";
    case "birthday":
    case "date":
      return "agDateColumnFilter";
    case "datetime":
      return "agDateColumnFilter";
    case "customList":
      return !1;
    // Not AG Grid's boolean data type: that one offers only "is true"/"is false"/"is blank", while
    // the value travels to the API as the text "true"/"false" and reads better as equals/not equals.
    case "boolean":
      return "agTextColumnFilter";
    default:
      return "agTextColumnFilter";
  }
}
function t7(e) {
  if (qi(e) === void 0)
    return {
      filterOptions: []
    };
  switch (qi(e)) {
    case "number":
      return {
        filterOptions: ["equals", "notEqual", "greaterThan", "lessThan", "greaterThanOrEqual", "lessThanOrEqual"]
      };
    case "birthday":
    case "date":
      return {
        filterOptions: ["equals", "notEqual", "greaterThan", "lessThan", "greaterThanOrEqual", "lessThanOrEqual"]
      };
    case "customList":
      return {
        filterOptions: []
      };
    case "datetime":
      return {
        filterOptions: ["equals", "notEqual", "greaterThan", "lessThan", "greaterThanOrEqual", "lessThanOrEqual"]
      };
    // filterOptions doubles as the advanced filter's operator allowlist — a Yes/No column compares
    // for equality only.
    case "boolean":
      return {
        filterOptions: ["equals", "notEqual"]
      };
    default:
      return {
        filterOptions: ["contains", "notContains", "equals", "notEqual"]
      };
  }
}
function o7(e) {
  if (qi(e) !== void 0)
    switch (qi(e)) {
      case "number":
        return "number";
      case "birthday":
      case "date":
        return "dateString";
      case "datetime":
        return "dateString";
      // See getColumnFilter: compared as the text "true"/"false", not as AG Grid's boolean type.
      case "boolean":
        return "text";
      case "customList":
        return;
      default:
        return "text";
    }
}
const ret = {
  showMoveButtons: !0,
  suppressFullScreenButton: !0,
  buttons: ["clear", "apply", "cancel"]
}, aet = { suppressBuilderButton: !0, buttons: [] };
class n7 {
  constructor() {
    _e(this, "model", null);
    _e(this, "params");
  }
  init(t) {
    this.params = t;
  }
  getModel() {
    return this.model;
  }
  setModel(t) {
    this.model = t, this.params.filterChangedCallback();
  }
  isFilterActive() {
    return this.model != null && this.model.length > 0;
  }
  doesFilterPass() {
    return !0;
  }
  getGui() {
    const t = document.createElement("div");
    return t.style.display = "none", t;
  }
}
const cet = { label: { optional: "(optional)", help: "Hilfe", maxSizeOf: "Maximale Grösse von {size}.", after: "Nach", and: "UND", autosizeColumns: "Alle Spalten automatisch anpassen", autosizeColumn: "Diese Spalte automatisch anpassen", before: "Vor", between: "Zwischen", contains: "Enthält", false: "Falsch", greaterEquals: "Grösser oder gleich", greaterEqual: "Grösser oder gleich", lessEquals: "Weniger oder gleich", lessEqual: "Weniger oder gleich", options: "Mehr Optionen", pin: "Kein pin", contains2: "Enthält nicht", equals: "Entspricht nicht", or: "ODER", pinColumn: "Spalte anheften", pinLeft: "Links anheften", pinRight: "Rechts anheften", pleaseConfirmAction: "Bitte bestätigen Sie Ihre Aktion.", selected: "Ausgewählt", tabLabel: "Tab-Bezeichnung", tabRenameReorderHint: "Doppelklicken zum Umbenennen & Ziehen zum Neuordnen", stepCannotUndone: "Dieser Schritt kann nicht rückgängig gemacht werden.", true: "Wahr", valuesBracketsRepresent: "Werte in Klammern stellen verschachtelte Datensätze dar", unsavedChangesLike: "Sie haben ungesicherte Änderungen. Möchten Sie diese vor dem Verlassen speichern?" }, action: { selectAll: "(Alle auswählen)", start: "Start", end: "Ende", addFilter: "Filter hinzufügen", addFilter2: "Filter oder Gruppe hinzufügen", addGroup2: "Gruppe hinzufügen", addTab2: "Neuen Tab hinzufügen", apply: "Anwenden", cancel: "Abbrechen", clear: "Zurücksetzen", close: "Schliessen", collapseRow: "Alle Zeilengruppen einklappen", confirm: "Bestätigen", continueEditing: "Bearbeitung fortsetzen", delete: "Löschen", deleteRecord: "Beleg löschen?", dragDrop: "Ziehen & Loslassen oder", enterValue: "Wert eingeben...", expandRow: "Alle Zeilengruppen ausklappen", filter: "Filter...", hideColumn: "Spalte ausblenden", moveDown: "Nach unten bewegen", moveUp: "Nach oben bewegen", ok: "OK", remove: "Entfernen", removeTab: "Tab entfernen", resetColumns: "Spalten zurücksetzen", save: "Speichern", saveChanges: "Änderung speichern?", search: "Suchen", selectColumn: "Spalte auswählen", selectOption: "Option auswählen", showLess: "Weniger anzeigen", show: "Mehr anzeigen", sortAscending: "Aufsteigend sortieren", sortDescending: "Absteigend sortieren", upload2: "Hochladen" }, message: { confirmDiscardChanges: "Sind Sie sicher, dass Sie Ihre Änderungen verwerfen möchten? Dieser schritt kann nicht Rückgängig gemacht werden.", errorError2: "Fehler!" }, placeholder: { file: "Anhang auswählen" }, emptyState: { empty2: "Keine Einträge vorhanden" } }, det = { today: "Heute", settings: "Kalendereinstellungen", months: "Monate", columns: "Spalten", start: "Start", end: "Ende", h: "h", hours: "Stunden", m: "min", minutes: "Minuten", seconds: "Sekunden", allDay: "Ganztg.", weekShort: "KW", previousMonth: "Voriger Monat", nextMonth: "Nächster Monat", sectionChars: { day: "T", month: "M", year: "J" }, sectionNames: { day: "Tag", month: "Monat", year: "Jahr", hours: "Stunden", minutes: "Minuten", seconds: "Sekunden", milliseconds: "Millisekunden", meridiem: "AM/PM" } }, uet = { tableBar: { label: { discard: "Verwerfen", discardChanges2: "Änderungen verwerfen?" } } }, het = { filter: { label: { equal: "Entspricht nicht" } }, src: { label: { equals: "Entspricht", greater: "Grösser als", less: "Kleiner als" } } }, get = { plainFallbackNotice: "Die Formatierung ist derzeit nicht verfügbar, daher wird der zugrunde liegende HTML-Code als reiner Text angezeigt." }, pet = {
  common: cet,
  datetimePicker: det,
  settings: uet,
  record: het,
  richText: get
}, fet = { label: { optional: "(optional)", help: "Help", maxSizeOf: "Max Size of {size}.", after: "After", and: "AND", autosizeColumns: "Autosize all columns", autosizeColumn: "Autosize this column", before: "Before", between: "Between", contains: "Contains", false: "False", greaterEquals: "Greater or equals", greaterEqual: "Greater or equals", lessEquals: "Less or equals", lessEqual: "Less or equals", options: "More options", pin: "No pin", contains2: "Not contains", equals: "Not equals", or: "OR", pinColumn: "Pin column", pinLeft: "Pin left", pinRight: "Pin right", pleaseConfirmAction: "Please confirm your action.", selected: "Selected", tabLabel: "Tab label", tabRenameReorderHint: "Rename on double click & Drag to reorder", stepCannotUndone: "This step cannot be undone.", true: "True", valuesBracketsRepresent: "Values in brackets represent nested records", unsavedChangesLike: "You have unsaved changes. Would you like to save them before leaving?" }, action: { selectAll: "(Select All)", start: "Start", end: "End", addFilter: "Add filter", addFilter2: "Add filter or group", addGroup2: "Add group", addTab2: "Add new tab", apply: "Apply", cancel: "Cancel", clear: "Clear", close: "Close", collapseRow: "Collapse all row groups", confirm: "Confirm", continueEditing: "Continue editing", delete: "Delete", deleteRecord: "Delete record?", dragDrop: "Drag & Drop or", enterValue: "Enter a value...", expandRow: "Expand all row groups", filter: "Filter…", hideColumn: "Hide column", moveDown: "Move down", moveUp: "Move up", ok: "OK", remove: "Remove", removeTab: "Remove tab", resetColumns: "Reset columns", save: "Save", saveChanges: "Save changes before leaving?", search: "Search", selectColumn: "Select a column", selectOption: "Select an option", showLess: "Show less", show: "Show more", sortAscending: "Sort ascending", sortDescending: "Sort descending", upload2: "to upload" }, message: { confirmDiscardChanges: "Are you sure you want to discard your changes? These changes cannot be undone.", errorError2: "Error!" }, placeholder: { file: "Choose attachment" }, emptyState: { empty2: "No items available" } }, vet = { today: "Today", settings: "Calendar settings", months: "Months", columns: "Columns", start: "Start", end: "End", h: "h", hours: "Hours", m: "min", minutes: "Minutes", seconds: "Seconds", allDay: "All day", weekShort: "Wk", previousMonth: "Previous month", nextMonth: "Next month", sectionChars: { day: "D", month: "M", year: "Y" }, sectionNames: { day: "Day", month: "Month", year: "Year", hours: "Hours", minutes: "Minutes", seconds: "Seconds", milliseconds: "Milliseconds", meridiem: "AM/PM" } }, met = { tableBar: { label: { discard: "Discard", discardChanges2: "Discard changes?" } } }, Cet = { filter: { label: { equal: "Does not equal" } }, src: { label: { equals: "Equals", greater: "Greater than", less: "Less than" } } }, wet = { plainFallbackNotice: "Formatting is unavailable right now, so this shows the underlying HTML as plain text." }, bet = {
  common: fet,
  datetimePicker: vet,
  settings: met,
  record: Cet,
  richText: wet
}, Sc = h7({
  legacy: !1,
  locale: "en",
  fallbackLocale: "en",
  messages: { de: pet, en: bet },
  missingWarn: !1,
  fallbackWarn: !1
}), go = (e, t) => Sc.global.t(e, t ?? {}), zst = (e) => {
  Sc.global.locale.value = e;
};
var Tt = /* @__PURE__ */ ((e) => (e.AND = "AND", e.OR = "OR", e))(Tt || {}), fe = /* @__PURE__ */ ((e) => (e.TEXT = "text", e.TEXT_ARRAY = "textArray", e.TYPED_TEXT = "typedText", e.TEXT_AREA = "textArea", e.NUMBER = "number", e.DATE = "date", e.DATETIME = "datetime", e.BIRTHDAY = "birthday", e.TIME = "time", e.CALCULATION = "calculation", e.RECORD_REFERENCES = "recordReferences", e.TAG_REFERENCES = "tagReferences", e.CATEGORY_REFERENCES = "categoryReferences", e.ORGANIZATION_REFERENCES = "organizationReferences", e.STATUS_REFERENCE = "statusReference", e.PRIORITY_REFERENCE = "priorityReference", e.TENANT_REFERENCE = "tenantReference", e.ACCOUNT_REPORT_TEMPLATE_REFERENCE = "accountReportTemplateReference", e.USER_REFERENCE = "userReferences", e.EMAIL_CONTACT_REFERENCES = "emailContactReferences", e.URL = "url", e.EMAIL = "email", e.PHONE = "phone", e.CHECKBOX = "checkbox", e.MULTI_CHECKBOX = "multiCheckbox", e.LIST = "list", e.CUSTOM_LIST = "customList", e.RADIO = "radio", e.FILE = "file", e.FILE_LIST = "fileList", e.MONEY = "money", e.CURRENCY = "currency", e.CHILD_TREE = "childTree", e.SPECIAL = "special", e.GROUP = "group", e.GROUP_LIST = "groupList", e.AVATAR = "avatar", e.ATTACHMENT_AMOUNT = "attachment_amount", e.OTHER = "other", e))(fe || {});
function U_(e) {
  return Object.values(fe).includes(e) ? e : "other";
}
var K_ = /* @__PURE__ */ ((e) => (e.COUNTRY = "contactAddress_country", e))(K_ || {}), Se = /* @__PURE__ */ ((e) => (e.EQUALS = "EQ", e.NOT_EQUALS = "NEQ", e.GREATER_THAN = "GT", e.LESS_THAN = "LT", e.GREATER_OR_EQUALS = "GTE", e.LESS_OR_EQUALS = "LTE", e.CONTAINS = "CONTAINS", e.NOT_CONTAINS = "NOT_CONTAINS", e.IN_RANGE = "IN_RANGE", e))(Se || {});
const As = (e, t) => {
  if (t)
    return yet(e, t);
}, yet = (e, t) => {
  if (!e || !t) return;
  let o = e;
  const n = t.replace(/\[/g, ".").replace(/]/g, "").split(".");
  for (const s of n) {
    if (o == null)
      return;
    o = o[s];
  }
  return o;
}, Hr = ["year", "month", "day"], o1 = ["hour", "minute", "second", "millisecond"], s7 = {
  year: 4,
  month: 2,
  day: 2,
  hour: 2,
  minute: 2,
  second: 2,
  millisecond: 3
}, _et = {
  year: "year",
  month: "month",
  day: "day",
  hours: "hour",
  minutes: "minute",
  seconds: "second",
  milliseconds: "millisecond"
}, xet = "X", Met = /(Z|[+-]\d{2}:\d{2})(?:\[[A-Za-z0-9_+\-/]+\])?$/;
function Aet(e) {
  const t = In(e, "xxx"), o = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return o ? `${t}[${o}]` : t;
}
function Let(e, t, o) {
  const n = /* @__PURE__ */ new Set(), s = (i, r) => {
    for (const l of Z7($7(i))) {
      const a = _et[l.type];
      a && r.includes(a) && n.add(a);
    }
  };
  return e !== "time" && s(t, Hr), e !== "date" && s(o, o1), n;
}
function i7(e) {
  return o1.some((t) => e.has(t));
}
function q_(e, t) {
  let o = -1;
  return e.forEach((n, s) => {
    t.has(n) && (o = s);
  }), o;
}
function Y_(e, t, o) {
  const n = {
    year: e.getFullYear(),
    month: e.getMonth() + 1,
    day: e.getDate(),
    hour: e.getHours(),
    minute: e.getMinutes(),
    second: e.getSeconds(),
    millisecond: e.getMilliseconds()
  }, s = (c) => o.has(c) ? String(n[c]).padStart(s7[c], "0") : xet.repeat(s7[c]), i = Eet(o, s);
  if (t === "time") return i;
  const r = q_(Hr, o), l = (i ? Hr : Hr.slice(0, r + 1)).map(s).join("-");
  if (!l) return "";
  const a = [l];
  return i && a.push("T", i), t === "datetime" && a.push(Aet(e)), a.join("");
}
function Eet(e, t) {
  const o = q_(o1, e);
  if (o < 0) return "";
  let n = t("hour");
  return o >= 1 && (n += `:${t("minute")}`), o >= 2 && (n += `:${t("second")}`), o >= 3 && (n += `.${t("millisecond")}`), n;
}
const Pet = (e) => /^X+$/.test(e);
function Ret(e, t) {
  const o = t === "time" ? null : Met.exec(e), n = (o == null ? void 0 : o[1]) ?? "", s = o ? e.slice(0, o.index) : e, [i, r = ""] = t === "time" ? ["", s] : s.split("T"), l = {};
  let a = !1;
  const c = (d, u) => d ? Pet(u) ? (a = !0, !0) : /^\d+$/.test(u) ? (l[d] = Number(u), !0) : !1 : !1;
  if (t !== "time") {
    const d = i ? i.split("-") : [];
    if (!d.length) return null;
    const u = d.length === 1 && d[0].length <= 2 ? ["month"] : Hr;
    if (d.length > u.length) return null;
    for (const [h, p] of d.entries())
      if (!c(u[h], p)) return null;
  }
  if (r) {
    const d = r.split(/[:.]/);
    if (d.length > o1.length) return null;
    for (const [u, h] of d.entries())
      if (!c(o1[u], h)) return null;
  }
  return { values: l, zone: n, masked: a };
}
const ws = (e, t = 2) => String(e).padStart(t, "0");
function tl(e, t) {
  if (!e) return null;
  const o = Ret(e, t);
  if (!o) {
    const m = new Date(e);
    return isNaN(m.getTime()) ? null : m;
  }
  const { values: n, zone: s, masked: i } = o, r = n.year ?? (/* @__PURE__ */ new Date()).getFullYear(), l = n.month ?? 1, a = n.day ?? 1, c = n.hour ?? 0, d = n.minute ?? 0, u = n.second ?? 0, h = n.millisecond ?? 0, p = `${ws(r, 4)}-${ws(l)}-${ws(a)}T${ws(c)}:${ws(d)}:${ws(u)}`, C = s && !i ? /* @__PURE__ */ new Date(`${p}.${ws(h, 3)}${s}`) : new Date(r, l - 1, a, c, d, u, h);
  return isNaN(C.getTime()) ? null : C;
}
function Fet(e, t, o) {
  const n = tl(e, t);
  return n ? Y_(n, t, o) : "";
}
const Zl = () => ({
  operator: Se.EQUALS,
  start: "",
  end: ""
});
function Tet(e, t) {
  if (!e || !t.start) return null;
  const o = (s, i) => ({ colKey: e, filterTerm: i, operator: s });
  let n;
  if (t.operator === Se.IN_RANGE) {
    if (!t.end) return null;
    n = [
      o(Se.GREATER_OR_EQUALS, t.start),
      o(Se.LESS_OR_EQUALS, t.end)
    ];
  } else
    n = [o(t.operator, t.start)];
  return [{ colKey: e, logicalOperator: Tt.AND, conditions: n }];
}
function Iet(e, t, o, n) {
  const s = (e == null ? void 0 : e.find((h) => h.colKey === t)) ?? (e == null ? void 0 : e[0]), i = s == null ? void 0 : s.conditions;
  if (!(i != null && i.length)) return Zl();
  const r = (h) => i.find((p) => p.operator === h), l = (h) => h ? Fet(h.filterTerm, o, n) : "", a = r(Se.GREATER_OR_EQUALS), c = r(Se.LESS_OR_EQUALS), d = r(Se.LESS_THAN), u = r(Se.GREATER_THAN);
  if (a && c) {
    const h = l(a), p = l(c);
    return h && h === p ? { operator: Se.EQUALS, start: h, end: "" } : { operator: Se.IN_RANGE, start: h, end: p };
  }
  if (d && u) return { operator: Se.NOT_EQUALS, start: l(u), end: "" };
  for (const h of [
    Se.EQUALS,
    Se.NOT_EQUALS,
    Se.LESS_THAN,
    Se.GREATER_THAN
  ]) {
    const p = r(h);
    if (p) return { operator: h, start: l(p), end: "" };
  }
  return Zl();
}
const Det = 500;
function ket(e) {
  const t = F(() => ke(e.kind)), o = F(
    () => Ul(ke(e.dateFormat), ke(e.datePrecision))
  ), n = F(
    () => q5(ke(e.timeFormat), ke(e.timePrecision))
  ), s = F(() => Let(t.value, o.value, n.value)), i = W(Zl()), r = F(() => i.value.operator === Se.IN_RANGE), l = F(() => [
    { value: Se.EQUALS, label: go("record.src.label.equals"), icon: "phosphor/equals" },
    { value: Se.NOT_EQUALS, label: go("record.filter.label.equal"), icon: "phosphor/not-equals" },
    { value: Se.LESS_THAN, label: go("common.label.before"), icon: "phosphor/less-than" },
    { value: Se.GREATER_THAN, label: go("common.label.after"), icon: "phosphor/greater-than" },
    { value: Se.IN_RANGE, label: go("common.label.between"), icon: "phosphor/arrows-horizontal" }
  ]), a = F(
    () => {
      var y;
      return ((y = l.value.find((b) => b.value === i.value.operator)) == null ? void 0 : y.icon) ?? "phosphor/funnel";
    }
  ), c = F(() => t.value === "time" ? r.value ? "timeRange" : "time" : t.value === "datetime" && i7(s.value) ? r.value ? "datetimeRange" : "datetime" : r.value ? "dateRange" : "date"), d = F({
    get: () => {
      const y = tl(i.value.start, t.value);
      return r.value ? [y, tl(i.value.end, t.value)] : y;
    },
    set: (y) => {
      const b = (_) => _ ? Y_(_, t.value, s.value) : "";
      Array.isArray(y) ? i.value = { ...i.value, start: b(y[0]), end: b(y[1]) } : i.value = { ...i.value, start: b(y), end: "" };
    }
  }), u = F(() => {
    let y;
    return t.value === "time" ? y = n.value : i7(s.value) ? y = `${o.value} ${n.value}` : y = o.value, r.value ? y.replace(/yyyy/g, "yy") : y;
  }), h = F(() => {
    const y = (M) => {
      const x = tl(M, t.value);
      return x ? Y5(x, u.value) : M;
    }, b = i.value.start ? y(i.value.start) : "", _ = r.value && i.value.end ? y(i.value.end) : "";
    return _ ? `${b} – ${_}` : b;
  });
  function p(y) {
    e.onModelChange(y);
  }
  const C = Us(
    () => p(Tet(ke(e.colKey), i.value)),
    Det
  );
  function m(y) {
    i.value = { ...i.value, operator: y, end: y === Se.IN_RANGE ? i.value.end : "" }, y !== Se.IN_RANGE && C();
  }
  function w() {
    i.value = Zl(), p(null);
  }
  return Me(
    [() => ke(e.model), s],
    () => {
      const y = Iet(ke(e.model), ke(e.colKey), t.value, s.value), b = i.value;
      y.operator === b.operator && y.start === b.start && y.end === b.end || (i.value = y);
    },
    { deep: !0, immediate: !0 }
  ), { state: i, operatorOptions: l, operatorIcon: a, pickerMode: c, pickerModel: d, displayValue: h, apply: C, setOperator: m, clear: w };
}
const Het = ["popovertarget"], Vet = /* @__PURE__ */ pe({
  __name: "SCADateFloatingFilter",
  props: /* @__PURE__ */ Ct({
    colKey: {},
    kind: {},
    dateFormat: {},
    timeFormat: {},
    datePrecision: {},
    timePrecision: {},
    model: {},
    onModelChange: { type: Function },
    hovered: { type: Boolean }
  }, {
    focused: { type: Boolean, default: !1 },
    focusedModifiers: {},
    open: { type: Boolean, default: !1 },
    openModifiers: {}
  }),
  emits: ["update:focused", "update:open"],
  setup(e) {
    const t = e, o = ct(e, "focused"), n = ct(e, "open"), { state: s, operatorOptions: i, operatorIcon: r, pickerMode: l, pickerModel: a, displayValue: c, apply: d, setOperator: u, clear: h } = ket({
      colKey: () => t.colKey,
      kind: () => t.kind,
      dateFormat: () => t.dateFormat,
      timeFormat: () => t.timeFormat,
      datePrecision: () => t.datePrecision,
      timePrecision: () => t.timePrecision,
      model: () => t.model,
      onModelChange: (M) => t.onModelChange(M)
    }), p = W(null), C = F(
      () => i.value.map((M) => ({ id: M.value, label: M.label, icon: M.icon }))
    ), m = F(() => t.hovered || !!s.value.start || n.value || o.value), w = F(() => !!s.value.start && (t.hovered || n.value || o.value));
    function y() {
      var M;
      h(), (M = document.activeElement) == null || M.blur();
    }
    function b() {
      rt(() => {
        var M;
        (M = p.value) == null || M.focus(), o.value = !0;
      });
    }
    function _(M) {
      u(M), b();
    }
    return Me(n, (M, x) => {
      if (M) {
        b();
        return;
      }
      x && (o.value = !1, d());
    }), (M, x) => (f(), v(we, null, [
      de(zt, {
        "is-open": n.value,
        "onUpdate:isOpen": x[4] || (x[4] = (L) => n.value = L),
        placement: "bottom-start",
        "close-on-click-outside": !1,
        trigger: "click",
        style: Ge(k(s).start ? {} : { width: "100%" })
      }, {
        trigger: ee(({ target: L }) => [
          g("div", {
            class: S(M.$style.trigger)
          }, [
            de(It, {
              popovertarget: L,
              type: "bare",
              size: "xsmall",
              intent: "none",
              appearance: "secondary",
              class: S([M.$style.icon, M.$style.triggerButton]),
              "icon-left": k(s).start ? k(r) : "phosphor/funnel",
              style: Ge({ opacity: m.value ? 1 : 0 })
            }, null, 8, ["popovertarget", "class", "icon-left", "style"]),
            k(s).start ? $("", !0) : (f(), v("button", {
              key: 0,
              type: "button",
              tabindex: "-1",
              popovertarget: L,
              class: S(M.$style.hitArea)
            }, null, 10, Het))
          ], 2)
        ]),
        default: ee(() => [
          de(Ds, {
            "model-value": k(s).operator,
            items: C.value,
            icon: k(r),
            appearance: "border",
            class: S(M.$style.icon),
            "onUpdate:modelValue": _
          }, null, 8, ["model-value", "items", "icon", "class"]),
          g("div", {
            class: S(M.$style.pickerRow),
            onFocusin: x[1] || (x[1] = (L) => o.value = !0),
            onFocusout: x[2] || (x[2] = (L) => o.value = !1),
            onKeydown: x[3] || (x[3] = ol(xe((L) => n.value = !1, ["prevent"]), ["enter"]))
          }, [
            de(I3e, {
              ref_key: "picker",
              ref: p,
              modelValue: k(a),
              "onUpdate:modelValue": x[0] || (x[0] = (L) => Tn(a) ? a.value = L : null),
              mode: k(l),
              "date-format": e.dateFormat,
              "time-format": e.timeFormat,
              "date-precision": e.datePrecision,
              "time-precision": e.timePrecision,
              clearable: !1,
              appearance: "border",
              "manual-input": "",
              "test-id": "floating-filter-date"
            }, null, 8, ["modelValue", "mode", "date-format", "time-format", "date-precision", "time-precision"])
          ], 34)
        ]),
        _: 1
      }, 8, ["is-open", "style"]),
      g("div", {
        class: S(M.$style.value),
        onClick: x[5] || (x[5] = (L) => n.value = !0)
      }, se(k(c)), 3),
      de(Ae, {
        class: S(M.$style.clear),
        style: Ge({ opacity: w.value ? 1 : 0, pointerEvents: w.value ? "auto" : "none" }),
        icon: "phosphor/x",
        onClick: y
      }, null, 8, ["class", "style"])
    ], 64));
  }
}), Oet = "_trigger_3kmnp_1", Bet = "_icon_3kmnp_7", $et = "_triggerButton_3kmnp_12", Zet = "_hitArea_3kmnp_19", Get = "_pickerRow_3kmnp_31", Net = "_value_3kmnp_36", zet = "_clear_3kmnp_42", jet = {
  trigger: Oet,
  icon: Bet,
  triggerButton: $et,
  hitArea: Zet,
  pickerRow: Get,
  value: Net,
  clear: zet
}, Wet = {
  $style: jet
}, Uet = /* @__PURE__ */ Ce(Vet, [["__cssModules", Wet]]), Ket = ["min", "step", "type"], qet = { style: { display: "flex", width: "100%", position: "relative" } }, Yet = ["checked"], Qet = ["checked", "onChange"], Jet = ["min", "type"], B1 = "#959595", Xet = /* @__PURE__ */ pe({
  __name: "SCAFloatingFilter",
  props: {
    model: {},
    onModelChange: { type: Function },
    params: {},
    filterParams: {},
    currentParentModel: { type: Function },
    parentFilterInstance: { type: Function },
    column: {},
    showParentFilter: { type: Function },
    api: {},
    context: {}
  },
  setup(e) {
    Vn((Le) => ({
      v5e90789c: B1
    }));
    const t = e, o = W(""), n = W(), s = W(!1), i = W(!1), r = W(!1), l = W(!1), a = W(!1), c = W(!1), d = W(null), u = W(!1), h = F(() => [fe.NUMBER, fe.MONEY].includes(w.value) ? "number" : [fe.DATE, fe.BIRTHDAY].includes(w.value) ? "date" : [fe.DATETIME].includes(w.value) ? "datetime-local" : w.value === fe.TIME ? "time" : [fe.CUSTOM_LIST, fe.MULTI_CHECKBOX, fe.RADIO, fe.LIST].includes(w.value) ? "custom-list" : "text"), p = F(() => h.value === "number" || h.value === "text"), C = F(
      () => h.value === "date" || h.value === "datetime-local" || h.value === "time"
    ), m = F(() => h.value === "custom-list"), w = F(() => U_(t.params.columnType)), y = F(() => w.value === fe.DATETIME ? "datetime" : w.value === fe.TIME ? "time" : "date"), b = F(() => t.params.dateFormat ?? "dd.MM.yyyy"), _ = F(() => t.params.timeFormat ?? "HH:mm"), M = F(() => t.params.datePrecision), x = F(() => t.params.timePrecision), L = F(() => t.model.value), A = F(() => [
      fe.TEXT,
      fe.TEXT_ARRAY,
      fe.TEXT_AREA,
      fe.DATE,
      fe.DATETIME,
      fe.TYPED_TEXT,
      fe.LIST,
      fe.CUSTOM_LIST,
      fe.TEXT_AREA,
      fe.URL,
      fe.EMAIL,
      fe.PHONE,
      fe.CURRENCY,
      fe.MONEY,
      fe.RECORD_REFERENCES,
      fe.EMAIL_CONTACT_REFERENCES,
      fe.USER_REFERENCE,
      fe.TAG_REFERENCES,
      fe.CATEGORY_REFERENCES,
      fe.ORGANIZATION_REFERENCES,
      fe.STATUS_REFERENCE,
      fe.PRIORITY_REFERENCE,
      fe.NUMBER,
      fe.ATTACHMENT_AMOUNT,
      fe.CHECKBOX,
      fe.MULTI_CHECKBOX,
      fe.RADIO,
      fe.TIME,
      fe.BIRTHDAY
    ].includes(w.value)), R = F(() => {
      var jo, So, _t;
      const Le = ((_t = (So = (jo = t.params) == null ? void 0 : jo.column) == null ? void 0 : So.getColId) == null ? void 0 : _t.call(So)) ?? "", Te = t.params, Be = typeof (Te == null ? void 0 : Te.filterColKey) == "string" ? Te.filterColKey : void 0;
      if (Be) return Be;
      const ht = typeof (Te == null ? void 0 : Te.originalHiddenColId) == "string" ? Te.originalHiddenColId : void 0;
      return Le === "ag-Grid-AutoColumn" && ht ? ht : Le;
    }), P = F(() => {
      const Le = [
        { value: Se.EQUALS, label: go("record.src.label.equals"), icon: "phosphor/equals" },
        { value: Se.NOT_EQUALS, label: go("common.label.equals"), icon: "phosphor/not-equals" }
      ];
      return [fe.DATE, fe.DATETIME, fe.NUMBER, fe.MONEY].includes(w.value) ? [
        ...Le,
        { value: Se.GREATER_THAN, label: go("record.src.label.greater"), icon: "phosphor/greater-than" },
        { value: Se.LESS_THAN, label: go("record.src.label.less"), icon: "phosphor/less-than" },
        {
          value: Se.GREATER_OR_EQUALS,
          label: go("common.label.greaterEqual"),
          icon: "phosphor/greater-than-or-equal"
        },
        {
          value: Se.LESS_OR_EQUALS,
          label: go("common.label.lessEqual"),
          icon: "phosphor/less-than-or-equal"
        }
      ] : [
        { value: Se.CONTAINS, label: go("common.label.contains"), icon: "phosphor/brackets-square" },
        { value: Se.NOT_CONTAINS, label: go("common.label.contains2"), icon: "phosphor/text-t-slash" },
        ...Le
      ];
    }), I = F(() => {
      switch (w.value) {
        case fe.DATE:
        case fe.DATETIME:
          return Se.EQUALS;
        case fe.NUMBER:
          return Se.EQUALS;
        case fe.ATTACHMENT_AMOUNT:
          return Se.EQUALS;
        case fe.CUSTOM_LIST:
          return Se.EQUALS;
        default:
          return Se.CONTAINS;
      }
    }), B = F(() => {
      const Le = P.value.find((Te) => Te.value === n.value);
      return (Le == null ? void 0 : Le.icon) ?? "phosphor/funnel";
    }), H = F(() => r.value || a.value || l.value || c.value ? "inset 0px 0px 0px 2px var(--color-blue-p1)" : i.value ? "inset 0px 0px 0px 1px var(--color-blue-p1)" : "none"), O = (Le) => {
      u.value = !0, t.onModelChange(Le);
    }, N = Us(() => {
      if (p.value) {
        if (o.value === "" || o.value === null || o.value === void 0) {
          O(null);
          return;
        }
        const Le = n.value ?? I.value, Te = [
          {
            colKey: R.value,
            logicalOperator: Tt.AND,
            conditions: [
              {
                colKey: R.value,
                filterTerm: String(o.value),
                operator: Le
              }
            ]
          }
        ];
        O(Te);
      }
    }, 500);
    function te() {
      if (o.value === "" || o.value === null || o.value === void 0) {
        O(null);
        return;
      }
      N();
    }
    function E(Le) {
      n.value = Le, j(), o.value && N();
    }
    function j() {
      var Le;
      (Le = d.value) == null || Le.focus(), r.value = !0;
    }
    function Z() {
      var Le, Te;
      o.value = "", n.value = void 0, (Le = d.value) == null || Le.blur(), (Te = document.activeElement) == null || Te.blur(), O(null);
    }
    function Y() {
      r.value = !0;
    }
    function le() {
      r.value = !0;
    }
    function ge() {
      r.value = !1;
    }
    const ce = F(() => !!t.params.searchColKey), G = W([]), z = W("");
    function oe() {
      var Be, ht, jo, So;
      const Le = t.model.value;
      if (!Le || Le.length === 0 || !((ht = (Be = Le[0]) == null ? void 0 : Be.conditions) != null && ht.length)) {
        o.value = "", n.value = void 0, G.value = [], z.value = "";
        return;
      }
      const Te = Le[0].conditions;
      if (m.value) {
        const _t = Le.find((gt) => gt.colKey === R.value);
        if (G.value = ((_t == null ? void 0 : _t.conditions) ?? []).map((gt) => gt.filterTerm).filter(Boolean), ce.value) {
          const gt = Le.find((ci) => ci.colKey === t.params.searchColKey);
          z.value = ((So = (jo = gt == null ? void 0 : gt.conditions) == null ? void 0 : jo[0]) == null ? void 0 : So.filterTerm) ?? "";
        }
      } else if (p.value) {
        const _t = Te[0];
        o.value = (_t == null ? void 0 : _t.filterTerm) ?? "", n.value = _t == null ? void 0 : _t.operator;
      }
    }
    Me([o, n], () => {
      s.value || te();
    }), Me(
      () => t.model.value,
      () => {
        if (u.value) {
          u.value = !1;
          return;
        }
        s.value = !0, oe(), rt(() => {
          s.value = !1;
        });
      },
      { deep: !0, immediate: !0 }
    ), Me(l, () => {
      j();
    }), Me([o], () => {
      s.value || (o.value && !n.value && (n.value = I.value), te());
    });
    const q = F(() => !!t.params.compactListFilter), ne = W(""), Fe = F(() => t.params.listOptions ?? []), We = F(() => {
      if (!ne.value) return Fe.value;
      const Le = ne.value.toLowerCase();
      return Fe.value.filter((Te) => Te.label.toLowerCase().includes(Le));
    }), Qe = F(() => G.value.length === Fe.value.length), nt = F(
      () => G.value.length > 0 && G.value.length < Fe.value.length
    );
    function ut(Le) {
      G.value = Le ? Fe.value.map((Te) => Te.id) : [];
    }
    function V(Le, Te) {
      Te ? G.value.includes(Le) || G.value.push(Le) : G.value = G.value.filter((Be) => Be !== Le);
    }
    const Q = F(() => {
      const Le = Fe.value.filter((Te) => G.value.includes(Te.id));
      if (Le.length !== 0 && G.value.length !== Fe.value.length)
        return `(${Le.length}) ${Le.map((Te) => Te.label).join(", ")}`;
    }), ye = F(
      () => ce.value ? G.value.length > 0 || !!z.value : !!Q.value
    );
    function ae() {
      return G.value.length === 0 || G.value.length === Fe.value.length ? null : [
        {
          colKey: R.value,
          logicalOperator: Tt.OR,
          conditions: G.value.map((Le) => ({
            colKey: R.value,
            filterTerm: Le,
            operator: Se.EQUALS
          }))
        }
      ];
    }
    function ie() {
      const Le = t.params.searchColKey;
      return !Le || !z.value ? null : {
        colKey: Le,
        logicalOperator: Tt.AND,
        conditions: [{ colKey: Le, filterTerm: z.value, operator: Se.CONTAINS }]
      };
    }
    function Oe() {
      const Le = [...ae() ?? []], Te = ie();
      Te && Le.push(Te), O(Le.length > 0 ? Le : null);
    }
    Me(
      G,
      () => {
        !m.value || s.value || Oe();
      },
      { deep: !0 }
    );
    const Dt = Us(() => {
      Oe();
    }, 500);
    Me(z, () => {
      !m.value || !ce.value || Dt();
    });
    function ai() {
      G.value = [], z.value = "", O(null);
    }
    const fs = W(null);
    return Me([Qe, nt], () => {
      fs.value && (fs.value.indeterminate = nt.value ?? !1);
    }), (Le, Te) => (f(), v("div", {
      style: Ge({
        width: "100%",
        height: "28px",
        overflow: "hidden",
        padding: "0 8px",
        boxShadow: H.value,
        borderRadius: "8px",
        transform: "translateZ(0)"
      })
    }, [
      A.value ? (f(), v("div", {
        key: 0,
        style: Ge({
          display: "flex",
          alignItems: "center",
          gap: "8px",
          width: "100%",
          height: "28px",
          position: "relative",
          cursor: "pointer",
          padding: "0px",
          color: B1
        }),
        onMouseleave: Te[14] || (Te[14] = (Be) => i.value = !1),
        onMouseenter: Te[15] || (Te[15] = (Be) => i.value = !0)
      }, [
        p.value ? (f(), v(we, { key: 0 }, [
          de(zt, {
            "is-open": l.value,
            "onUpdate:isOpen": Te[0] || (Te[0] = (Be) => l.value = Be),
            placement: "bottom-start"
          }, {
            trigger: ee(({ target: Be }) => [
              de(It, {
                popovertarget: Be,
                type: "bare",
                size: "xsmall",
                intent: "none",
                appearance: "secondary",
                class: S(Le.$style.icon),
                "icon-left": B.value,
                style: Ge({
                  backgroundColor: "white",
                  color: B1,
                  opacity: i.value || n.value || l.value || r.value ? 1 : 0,
                  paddingLeft: "0px",
                  paddingRight: "0px",
                  width: "16px",
                  height: "16px"
                })
              }, null, 8, ["popovertarget", "class", "icon-left", "style"])
            ]),
            default: ee(({ popover: Be }) => [
              (f(!0), v(we, null, Ze(P.value, (ht) => (f(), U(d2, {
                key: ht.value,
                selected: ht.value === n.value,
                label: ht.label,
                icon: ht.icon,
                "use-higher-option": !0,
                type: "action",
                appearance: "secondary",
                class: S(Le.$style.icon),
                onClick: (jo) => {
                  E(ht.value), Be == null || Be.hidePopover();
                }
              }, null, 8, ["selected", "label", "icon", "class", "onClick"]))), 128))
            ]),
            _: 1
          }, 8, ["is-open"]),
          Et((f(), v("input", {
            ref_key: "filterInput",
            ref: d,
            key: R.value + "_input",
            "onUpdate:modelValue": Te[1] || (Te[1] = (Be) => o.value = Be),
            min: h.value === "number" ? 0 : void 0,
            step: h.value === "number" ? "any" : void 0,
            type: h.value,
            style: {
              border: "none",
              outline: "none",
              color: "#272e35",
              width: "calc(100% - 40px)"
            },
            onClick: Te[2] || (Te[2] = xe(() => {
            }, ["stop"])),
            onMousedownCapture: Y,
            onFocus: le,
            onBlur: ge
          }, null, 40, Ket)), [
            [Ac, o.value]
          ]),
          i.value && (o.value || n.value) ? (f(), U(Ae, {
            key: 0,
            style: Ge({
              position: "absolute",
              right: "0px",
              backgroundColor: "white",
              pointerEvents: i.value && (o.value || n.value) ? "auto" : "none",
              color: "#272e35",
              width: "12px"
            }),
            icon: "phosphor/x",
            onClick: Z
          }, null, 8, ["style"])) : $("", !0)
        ], 64)) : C.value ? (f(), U(Uet, {
          key: 1,
          focused: r.value,
          "onUpdate:focused": Te[3] || (Te[3] = (Be) => r.value = Be),
          open: a.value,
          "onUpdate:open": Te[4] || (Te[4] = (Be) => a.value = Be),
          "col-key": R.value,
          kind: y.value,
          "date-format": b.value,
          "time-format": _.value,
          "date-precision": M.value,
          "time-precision": x.value,
          model: L.value,
          "on-model-change": O,
          hovered: i.value
        }, null, 8, ["focused", "open", "col-key", "kind", "date-format", "time-format", "date-precision", "time-precision", "model", "hovered"])) : m.value ? (f(), v(we, { key: 2 }, [
          de(zt, {
            "is-open": c.value,
            "onUpdate:isOpen": Te[9] || (Te[9] = (Be) => c.value = Be),
            placement: "bottom-start",
            "close-on-click-outside": !1,
            trigger: "click",
            "no-padding": !0,
            style: Ge(ce.value || Q.value ? {} : { width: "100%" })
          }, {
            trigger: ee(({ target: Be }) => [
              g("div", qet, [
                de(It, {
                  popovertarget: Be,
                  type: "bare",
                  size: "xsmall",
                  intent: "none",
                  appearance: "secondary",
                  "icon-left": "phosphor/list-dashes",
                  style: Ge({
                    backgroundColor: "white",
                    color: B1,
                    opacity: i.value || Q.value || c.value || r.value ? 1 : 0,
                    paddingLeft: "0px",
                    paddingRight: "0px"
                  })
                }, null, 8, ["popovertarget", "style"])
              ])
            ]),
            default: ee(({}) => [
              g("div", {
                class: S([Le.$style.listDropdown, q.value && Le.$style.listDropdownCompact])
              }, [
                g("div", {
                  class: S([
                    Le.$style.listFilterSearch,
                    q.value ? Le.$style.searchContainer : Le.$style.listFilterSearchDefault
                  ])
                }, [
                  g("div", {
                    class: S(q.value && Le.$style.searchRow)
                  }, [
                    de(oa, {
                      appearance: "border",
                      "show-clear-icon": ne.value.length > 0,
                      onClear: Te[6] || (Te[6] = (Be) => ne.value = "")
                    }, {
                      default: ee(() => [
                        Et(g("input", {
                          "onUpdate:modelValue": Te[5] || (Te[5] = (Be) => ne.value = Be),
                          type: "text",
                          placeholder: "Search",
                          style: { width: "100%", border: "none", outline: "none" }
                        }, null, 512), [
                          [xn, ne.value]
                        ])
                      ]),
                      _: 1
                    }, 8, ["show-clear-icon"]),
                    q.value ? (f(), v("button", {
                      key: 0,
                      type: "button",
                      class: S(Le.$style.resetButton),
                      onClick: ai
                    }, [
                      de(Ae, {
                        icon: "phosphor/arrow-counter-clockwise",
                        class: S(Le.$style.resetIcon)
                      }, null, 8, ["class"])
                    ], 2)) : $("", !0)
                  ], 2)
                ], 2),
                g("div", {
                  class: S([Le.$style.selectAllRow, q.value && Le.$style.selectAllRowCompact])
                }, [
                  nt.value ? (f(), U(Zo, {
                    key: 0,
                    deselect: !0,
                    checked: !0,
                    style: { "--color-interaction-default-normal": "#cfd6dd" }
                  }, {
                    default: ee(() => [
                      g("input", {
                        type: "checkbox",
                        checked: !0,
                        onChange: Te[7] || (Te[7] = () => ut(!1))
                      }, null, 32)
                    ]),
                    _: 1
                  })) : (f(), U(Zo, {
                    key: 1,
                    deselect: !1,
                    checked: Qe.value
                  }, {
                    default: ee(() => [
                      g("input", {
                        type: "checkbox",
                        checked: Qe.value,
                        onChange: Te[8] || (Te[8] = (Be) => ut(Be.target.checked))
                      }, null, 40, Yet)
                    ]),
                    _: 1
                  }, 8, ["checked"])),
                  g("span", null, se(k(go)("common.action.selectAll")), 1)
                ], 2),
                g("div", {
                  class: S([Le.$style.itemsList, q.value && Le.$style.itemsListCompact])
                }, [
                  (f(!0), v(we, null, Ze(We.value, (Be) => (f(), v("div", {
                    key: Be.id,
                    class: S([Le.$style.listItem, q.value && Le.$style.listItemCompact])
                  }, [
                    de(iLe, {
                      label: Be.label
                    }, {
                      default: ee(() => [
                        g("input", {
                          type: "checkbox",
                          checked: G.value.includes(Be.id),
                          onChange: (ht) => V(Be.id, ht.target.checked)
                        }, null, 40, Qet)
                      ]),
                      _: 2
                    }, 1032, ["label"])
                  ], 2))), 128))
                ], 2)
              ], 2)
            ]),
            _: 1
          }, 8, ["is-open", "style"]),
          g("div", {
            style: { "font-weight": "450", "letter-spacing": "0.24px", color: "#272e35", "white-space": "nowrap", overflow: "hidden", "text-overflow": "ellipsis", flex: "1 1 0", "min-width": "0", display: "flex", "align-items": "center", gap: "4px" },
            onClick: Te[13] || (Te[13] = (Be) => !ce.value && (c.value = !0))
          }, [
            ce.value ? (f(), v(we, { key: 0 }, [
              G.value.length > 0 ? (f(), v("span", {
                key: 0,
                class: S(Le.$style.selectedCount)
              }, "(" + se(G.value.length) + ")", 3)) : $("", !0),
              Et((f(), v("input", {
                ref_key: "filterInput",
                ref: d,
                key: R.value + "_search_input",
                "onUpdate:modelValue": Te[10] || (Te[10] = (Be) => z.value = Be),
                type: "text",
                style: { border: "none", outline: "none", color: "#272e35", width: "100%" },
                onClick: Te[11] || (Te[11] = xe(() => {
                }, ["stop"])),
                onMousedownCapture: Y,
                onFocus: le,
                onBlur: ge
              }, null, 32)), [
                [xn, z.value]
              ])
            ], 64)) : Et((f(), v("input", {
              ref_key: "filterInput",
              ref: d,
              key: R.value + "_input",
              "onUpdate:modelValue": Te[12] || (Te[12] = (Be) => Q.value = Be),
              min: h.value === "number" ? 0 : void 0,
              type: h.value,
              readonly: "",
              style: {
                border: "none",
                outline: "none",
                color: "#272e35",
                width: "calc(100% - 16px)"
              }
            }, null, 8, Jet)), [
              [Ac, Q.value]
            ])
          ]),
          de(Ae, {
            style: Ge({
              position: "absolute",
              right: "0px",
              backgroundColor: "white",
              opacity: i.value && ye.value ? 1 : 0,
              pointerEvents: i.value && ye.value ? "auto" : "none",
              color: "#272e35"
            }),
            size: "12px",
            icon: "phosphor/x",
            onClick: ai
          }, null, 8, ["style"])
        ], 64)) : $("", !0)
      ], 36)) : $("", !0)
    ], 4));
  }
}), ett = "_icon_1l6cn_1", ttt = "_selectedCount_1l6cn_6", ott = "_searchContainer_1l6cn_11", ntt = "_searchRow_1l6cn_28", stt = "_resetButton_1l6cn_34", itt = "_resetIcon_1l6cn_48", rtt = "_listDropdown_1l6cn_55", ltt = "_listDropdownCompact_1l6cn_63", att = "_listFilterSearch_1l6cn_68", ctt = "_listFilterSearchDefault_1l6cn_73", dtt = "_selectAllRow_1l6cn_77", utt = "_selectAllRowCompact_1l6cn_85", htt = "_itemsList_1l6cn_92", gtt = "_itemsListCompact_1l6cn_101", ptt = "_listItem_1l6cn_106", ftt = "_listItemCompact_1l6cn_112", vtt = {
  icon: ett,
  selectedCount: ttt,
  searchContainer: ott,
  searchRow: ntt,
  resetButton: stt,
  resetIcon: itt,
  listDropdown: rtt,
  listDropdownCompact: ltt,
  listFilterSearch: att,
  listFilterSearchDefault: ctt,
  selectAllRow: dtt,
  selectAllRowCompact: utt,
  itemsList: htt,
  itemsListCompact: gtt,
  listItem: ptt,
  listItemCompact: ftt
}, mtt = {
  $style: vtt
}, Ctt = /* @__PURE__ */ Ce(Xet, [["__cssModules", mtt]]), wtt = (() => {
  const e = uS({ render: () => null });
  return e.use(Sc), e._context;
})();
class btt {
  constructor() {
    _e(this, "eGui");
    _e(this, "container");
    _e(this, "params");
    _e(this, "vnodeRoot");
    _e(this, "modelRef", W(null));
    _e(this, "focusHandler");
  }
  init(t) {
    this.params = t, this.eGui = document.createElement("div"), this.container = document.createElement("div"), this.eGui.appendChild(this.container), this.modelRef.value = t.currentParentModel() ?? null, this.renderComponent();
  }
  renderComponent() {
    var o;
    const t = {
      model: this.modelRef,
      onModelChange: (n) => {
        this.params.parentFilterInstance((s) => {
          s.setModel(n);
        });
      },
      params: this.params,
      key: (o = this.params.column) == null ? void 0 : o.getColId()
    };
    this.vnodeRoot = vo(Ctt, t), this.vnodeRoot.appContext = wtt, il(this.vnodeRoot, this.container);
  }
  refresh(t) {
    return this.params = t, !0;
  }
  onParentModelChanged(t) {
    this.modelRef.value = t;
  }
  getGui() {
    return this.eGui;
  }
  /**
   * Called by AG Grid after the floating filter GUI has been attached to the DOM.
   * We use this hook to implement focus redirection: AG Grid intentionally focuses
   * the header cell container (.ag-header-cell) for keyboard navigation and accessibility
   * after any UI changes (e.g., when the user enters search text).
   * However, for our custom floating filters, the expected user experience is to have
   * the focus land directly on the <input> element so the user can continue typing.
   */
  afterGuiAttached(t) {
    if (t != null && t.suppressFocus)
      return;
    let o = this.eGui;
    for (; o && !o.classList.contains("ag-header-cell"); )
      o = o.parentElement;
    o && (this.focusHandler = (n) => {
      const s = n.relatedTarget;
      if (!(!s || !this.eGui.contains(s)) && n.target === o) {
        const i = this.eGui.querySelector('input[type="text"]');
        i && i.focus();
      }
    }, o.addEventListener("focusin", this.focusHandler));
  }
  destroy() {
    if (il(null, this.container), this.focusHandler) {
      let t = this.eGui;
      for (; t && !t.classList.contains("ag-header-cell"); )
        t = t.parentElement;
      t && this.focusHandler && t.removeEventListener("focusin", this.focusHandler);
    }
  }
}
const ytt = { class: "sca-ag-grid-header-tooltip" }, _tt = /* @__PURE__ */ pe({
  __name: "SCAAgGridHeaderTooltip",
  props: {
    params: {}
  },
  setup(e) {
    return (t, o) => (f(), v("div", ytt, se(e.params.value), 1));
  }
}), Stt = { key: 1 }, xtt = /* @__PURE__ */ pe({
  __name: "TotalRowValueCell",
  props: {
    params: {}
  },
  setup(e) {
    const t = e, o = F(() => ({
      display: "flex",
      alignItems: "center",
      justifyContent: t.params.align === "right" ? "flex-end" : "flex-start",
      gap: "4px",
      width: "100%",
      height: "100%"
    })), n = F(() => t.params.icon), s = F(() => t.params.iconSize ?? "20px"), i = F(() => {
      let r = t.params.value;
      if (r !== null && typeof r == "object" && "value" in r && (r = r.value), r == null || r === "") return "";
      if (t.params.formatValue) return t.params.formatValue(r);
      const l = typeof r == "number" ? r : typeof r == "string" ? Number(r) : NaN;
      return Number.isNaN(l) ? "" : String(l);
    });
    return (r, l) => (f(), v("span", {
      style: Ge(o.value)
    }, [
      n.value ? (f(), U(Ae, {
        key: 0,
        icon: n.value,
        size: s.value
      }, null, 8, ["icon", "size"])) : $("", !0),
      i.value ? (f(), v("span", Stt, se(i.value), 1)) : $("", !0)
    ], 4));
  }
}), Mtt = 'a[href], [col-id="ag-Grid-SelectionColumn"]', Att = /* @__PURE__ */ pe({
  __name: "SCAAgGridTable",
  props: {
    colDefs: {},
    rowData: {},
    rowSelection: {},
    pagination: { type: Boolean },
    paginationPageSize: {},
    treeMode: { type: Boolean },
    filterRow: { type: Boolean },
    masterDetail: { type: Boolean },
    getRowNodeId: {},
    autoGroupColumnDef: {},
    licenseKey: {},
    getDataPath: { type: Function },
    domLayout: {},
    gridOptions: {},
    minRowCount: {},
    compactBody: { type: Boolean },
    suppressColumnHide: { type: Boolean },
    columnIdsSuppressHide: {},
    suppressColumnReset: { type: Boolean },
    suppressExpandCollapseMenuItems: { type: Boolean },
    suppressRowFocus: { type: Boolean },
    selectedRowId: {},
    advancedFilterOpen: { type: Boolean },
    userDateFormat: {},
    agGridHeaderStickyTop: {},
    filterRowReadOnly: { type: Boolean },
    tableColumnLayout: {},
    transitioning: { type: Boolean },
    totalRowState: {},
    hasEligibleTotalRowColumn: { type: Boolean },
    detailCellRendererComponent: {},
    detailCellRendererParams: { type: [Object, Function] }
  },
  emits: ["update:modelValue", "grid-ready", "column-moved", "column-visible", "row-click", "sort-changed", "selection-changed", "filter-changed", "column-resized", "reset-columns", "advanced-filter-changed", "expand-all", "collapse-all", "update:total-row-state", "manage-columns"],
  setup(e, { emit: t }) {
    Vn((T) => ({
      v47666e30: O.value
    }));
    const { t: o } = Go(), n = e, s = t, i = F(() => set(n.userDateFormat));
    let r = !1;
    r || (a_.setLicenseKey(n.licenseKey), r = !0, du.registerModules([rqe]), du.registerModules([
      NXe,
      rJe,
      VQe,
      lJe,
      xJe,
      MXe,
      VXe,
      fYe
    ]));
    const l = W(/* @__PURE__ */ new Set()), a = W(null), c = W(null), d = W(null), u = Je(null), h = Je(null), p = pe({
      setup() {
        const T = W(null);
        return () => vo(
          "div",
          {
            // Exact Figma spec (node 40018355:59438, CellAction/Summe): 20px icon, centered both
            // axes, 4px right padding only (no left) — that asymmetry is intentional in the design.
            ref: T,
            style: {
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
              height: "100%",
              paddingRight: "4px"
            }
          },
          [
            vo(Ae, { icon: "phosphor/sigma", size: "20px" }),
            vo(bo, {
              target: T.value,
              text: o("common.label.totalRowTooltip"),
              linkLabel: o("common.label.openColumnManager"),
              onLinkClick: () => s("manage-columns")
            })
          ]
        );
      }
    }), C = {
      pinned: "left",
      suppressSizeToFit: !0,
      width: 30,
      minWidth: 30,
      maxWidth: 30,
      cellRendererSelector: (T) => T.node.rowPinned && n.totalRowState !== void 0 ? { component: p } : void 0,
      // The Σ icon on the pinned total row is a static summary, not an interactive cell.
      suppressNavigable: (T) => !!T.node.rowPinned
    }, m = Je(null), w = Je(null), y = Je(null), b = W(!1), _ = W(!0), M = {
      sortable: !0,
      resizable: !0,
      filter: n7,
      floatingFilterComponent: btt,
      suppressFloatingFilterButton: !0,
      cellDataType: !1,
      // Grid-wide header tooltip for truncated column labels.
      tooltipComponent: _tt,
      // Keeps keyboard Tab from landing on the pinned total row (click-focus is blocked separately
      // via CSS — see ag-grid-theme.scss's .ag-row-pinned .ag-cell border rule).
      suppressNavigable: (T) => !!T.node.rowPinned
    };
    function x(T) {
      const re = T.cellRendererSelector;
      return {
        ...T,
        cellRendererSelector: (me) => {
          if (me.node.rowPinned && n.totalRowState !== void 0) {
            const Ee = T.context ?? {};
            return {
              component: xtt,
              params: {
                icon: Ee.totalRowIcon,
                iconSize: Ee.totalRowIconSize,
                formatValue: Ee.totalRowValueFormatter,
                align: Ee.totalRowAlign
              }
            };
          }
          return re == null ? void 0 : re(me);
        }
      };
    }
    function L(T) {
      return T.headerTooltip === void 0 && typeof T.headerName == "string" && (T.headerTooltip = T.headerName), T;
    }
    const A = F(
      () => n.autoGroupColumnDef ? L({ ...n.autoGroupColumnDef }) : void 0
    ), R = F(
      () => n.colDefs.map((T) => {
        var me;
        const re = L(x({ ...T }));
        return re.colId ?? (re.colId = re.field), n.advancedFilterOpen ? re.hide ? (n.treeMode && re.field && re.field === ((me = n.autoGroupColumnDef) == null ? void 0 : me.field) ? (re.filter = e7(T), re.filterParams = t7(T), re.cellDataType = o7(T)) : re.filter = !1, re) : (re.filter = e7(T), re.filterParams = t7(T), re.cellDataType = o7(T), re) : (re.filter = n7, re);
      })
    ), P = F(() => {
      if (n.rowSelection)
        return n.rowSelection === "single" ? { mode: "singleRow", pinned: "left", lockPosition: !0 } : n.rowSelection === "multiple" ? { mode: "multiRow", pinned: "left", lockPosition: !0 } : n.rowSelection;
    }), I = W("#6792f4");
    let B = null;
    At(() => {
      const T = () => getComputedStyle(document.documentElement).getPropertyValue("--color-blue-p1").trim();
      I.value = T(), B = new MutationObserver(() => {
        I.value = T();
      }), B.observe(document.documentElement, {
        attributes: !0,
        attributeFilter: ["class", "data-theme", "style"]
      }), requestAnimationFrame(() => {
        _t();
      });
    });
    const H = {
      sortAscending: Vt["phosphor/arrow-up"] ?? "",
      sortDescending: Vt["phosphor/arrow-down"] ?? "",
      menuAlt: Vt["phosphor/dots-three-vertical"] ?? ""
    }, O = F(
      () => `url("data:image/svg+xml;utf8,${encodeURIComponent(Vt["phosphor/sigma"] ?? "")}")`
    ), N = F(
      () => hy.withPart(X$e).withPart(
        eZe({
          icons: {
            menuAlt: {
              url: "data:image/svg+xml;utf8," + encodeURIComponent(Vt["phosphor/dots-three-vertical"] ?? "")
            },
            sortAscending: {
              url: "data:image/svg+xml;utf8," + encodeURIComponent(Vt["phosphor/arrow-up"] ?? "")
            },
            sortDescending: {
              url: "data:image/svg+xml;utf8," + encodeURIComponent(Vt["phosphor/arrow-down"] ?? "")
            },
            none: { url: "data:image/svg+xml;utf8," + encodeURIComponent(Vt["phosphor/broom"] ?? "") },
            pin: { url: "data:image/svg+xml;utf8," + encodeURIComponent(Vt["phosphor/push-pin"] ?? "") },
            autosize: {
              url: "data:image/svg+xml;utf8," + encodeURIComponent(Vt["phosphor/split-horizontal"] ?? "")
            },
            autosizeall: {
              url: "data:image/svg+xml;utf8," + encodeURIComponent(Vt["phosphor/text-columns"] ?? "")
            },
            reset: {
              url: "data:image/svg+xml;utf8," + encodeURIComponent(Vt["phosphor/arrows-counter-clockwise"] ?? "")
            },
            hidecolumn: { url: "data:image/svg+xml;utf8," + encodeURIComponent(Vt["phosphor/eye-menu"] ?? "") },
            expandall: {
              url: "data:image/svg+xml;utf8," + encodeURIComponent(Vt["phosphor/arrows-out-line-vertical-menu"] ?? "")
            },
            collapseall: {
              url: "data:image/svg+xml;utf8," + encodeURIComponent(Vt["phosphor/arrows-in-line-vertical-menu"] ?? "")
            },
            "small-right": {
              url: "data:image/svg+xml;utf8," + encodeURIComponent(Vt["phosphor/caret-right-menu"] ?? "")
            },
            sigma: { url: "data:image/svg+xml;utf8," + encodeURIComponent(Vt["phosphor/sigma"] ?? "") }
          }
        })
      ).withParams({
        borderColor: "#EAEDF0",
        accentColor: I.value,
        browserColorScheme: "light",
        fontFamily: { googleFont: "Inter" },
        fontSize: 12,
        headerBackgroundColor: "#F1F1F1",
        headerFontSize: 12,
        headerHeight: 28,
        iconSize: 16,
        rowHeight: 40
      })
    );
    function te(T) {
      s("update:total-row-state", T);
    }
    const E = F(
      () => R.value.some((T) => {
        var me;
        const re = T.context;
        return re != null && re.totalRowExcluded ? !1 : T.cellDataType === "number" || ((me = T.floatingFilterComponentParams) == null ? void 0 : me.columnType) === "number" || (re == null ? void 0 : re.totalRowForced);
      })
    ), j = F(() => {
      var T;
      return (T = n.gridOptions) == null ? void 0 : T.pinnedTopRowData;
    }), Z = F(() => {
      var T;
      return (T = n.gridOptions) == null ? void 0 : T.pinnedBottomRowData;
    }), Y = (T) => {
      var di, xc;
      const re = T.defaultItems.filter((je) => !(je === "rowGroup" || je === "rowUnGroup" || je === "columnFilter" || je === "columnChooser" || n.suppressExpandCollapseMenuItems && (je === "expandAll" || je === "contractAll")));
      re[0] === "separator" && re.shift();
      const me = re.findIndex((je) => je === "autoSizeThis");
      me >= 0 && (re[me] = {
        name: o("common.label.autosizeColumn"),
        icon: '<span class="ag-icon ag-icon-autosize"></span>',
        action: () => {
          var at;
          const je = (at = T.column) == null ? void 0 : at.getColId();
          je && (T.api.autoSizeColumns([je]), l.value.add(je));
        },
        disabled: T.column ? l.value.has(T.column.getColId()) : !1
      });
      const Ee = re.findIndex((je) => je === "autoSizeAll");
      if (Ee >= 0) {
        const je = T.api.getColumns() ?? [], at = je.length > 0 && je.every((ui) => l.value.has(ui.getColId()));
        re[Ee] = {
          name: o("common.label.autosizeColumns"),
          icon: '<span class="ag-icon ag-icon-autosizeall"></span>',
          action: () => {
            T.api.autoSizeAllColumns(!1), l.value.clear(), je.forEach((ui) => {
              l.value.add(ui.getColId());
            });
          },
          disabled: at
        };
      }
      let Ne = !1;
      T.api.forEachNode((je) => {
        je.data && "template" in je.data && (Ne = !0);
      });
      const De = re.findIndex((je) => je === "contractAll");
      if (De >= 0) {
        let je = !0;
        Ne ? T.api.forEachNode((at) => {
          at.data && "template" in at.data && at.expanded && (je = !1);
        }) : T.api.forEachNode((at) => {
          at.expanded && (je = !1);
        }), re[De] = {
          name: o("common.action.collapseRow"),
          icon: '<span class="ag-icon ag-icon-collapseall"></span>',
          action: () => {
            s("collapse-all"), Ne || T.api.collapseAll();
          },
          disabled: je
        };
      }
      const kt = re.findIndex((je) => je === "expandAll");
      if (kt >= 0) {
        let je = !0;
        Ne ? T.api.forEachNode((at) => {
          at.data && "template" in at.data && !at.expanded && (je = !1);
        }) : T.api.forEachNode((at) => {
          var ui;
          (((ui = at.childrenAfterGroup) == null ? void 0 : ui.length) ?? 0) > 0 && !at.expanded && (je = !1);
        }), re[kt] = {
          name: o("common.action.expandRow"),
          icon: '<span class="ag-icon ag-icon-expandall"></span>',
          action: () => {
            s("expand-all"), Ne || T.api.expandAll();
          },
          disabled: je
        };
      }
      re.push("separator");
      {
        const je = n.totalRowState ?? { enabled: !1, position: "bottom" }, at = !E.value || n.totalRowState === void 0 || n.hasEligibleTotalRowColumn === !1;
        re.push({
          name: o("common.label.totalRow"),
          icon: '<span class="ag-icon ag-icon-sigma"></span>',
          disabled: at,
          // AG Grid doesn't propagate a parent MenuItemDef's `disabled` down into its subMenu — each
          // entry has its own independent `action`, so without repeating the flag here the submenu still
          // opens and "Top"/"Bottom" still fire setTotalRowState even though the parent row reads disabled.
          subMenu: [
            {
              name: o("common.label.noTotalRow"),
              checked: !je.enabled,
              disabled: at,
              action: () => te({ enabled: !1, position: je.position })
            },
            {
              name: o("common.label.totalRowOnTop"),
              checked: je.enabled && je.position === "top",
              disabled: at,
              action: () => te({ enabled: !0, position: "top" })
            },
            {
              name: o("common.label.totalRowAtBottom"),
              checked: je.enabled && je.position === "bottom",
              disabled: at,
              action: () => te({ enabled: !0, position: "bottom" })
            }
          ]
        });
      }
      re.push({
        name: o("common.action.hideColumn"),
        icon: '<span class="ag-icon ag-icon-hidecolumn"></span>',
        action: () => {
          var je, at;
          ((je = T.column) == null ? void 0 : je.getColId()) !== "ag-Grid-AutoColumn" ? T.api.setColumnsVisible([((at = T.column) == null ? void 0 : at.getColId()) ?? ""], !1) : s("column-visible", {
            visible: !1,
            column: T.column,
            columns: [T.column],
            source: "columnMenu",
            api: T.api,
            context: T.context,
            type: "columnVisible"
          });
        },
        disabled: n.suppressColumnHide || !!((di = T.column) != null && di.getColId()) && ((xc = n.columnIdsSuppressHide) == null ? void 0 : xc.includes(T.column.getColId()))
      });
      const Ht = re.indexOf("resetColumns");
      return Ht >= 0 && re.splice(Ht, 1), re.push({
        name: o("common.action.resetColumns"),
        icon: '<span class="ag-icon ag-icon-reset"></span>',
        action: () => {
          s("reset-columns");
        },
        disabled: n.suppressColumnHide || n.suppressColumnReset
      }), re;
    }, le = (T) => T.replace(/ /g, " "), ge = F(() => ({
      sortAscending: o("common.action.sortAscending"),
      sortDescending: o("common.action.sortDescending"),
      pinLeft: o("common.label.pinLeft"),
      pinRight: o("common.label.pinRight"),
      noPin: o("common.label.pin"),
      pinColumn: o("common.label.pinColumn"),
      advancedFilterContains: le(o("common.label.contains")),
      advancedFilterNotContains: le(o("common.label.contains2")),
      advancedFilterTextEquals: le(o("record.src.label.equals")),
      advancedFilterTextNotEqual: le(o("common.label.equals")),
      advancedFilterEquals: le(o("record.src.label.equals")),
      advancedFilterNotEqual: le(o("common.label.equals")),
      advancedFilterGreaterThan: le(o("record.src.label.greater")),
      advancedFilterGreaterThanOrEqual: le(o("common.label.greaterEquals")),
      advancedFilterLessThan: le(o("record.src.label.less")),
      advancedFilterLessThanOrEqual: le(o("common.label.lessEquals")),
      advancedFilterAnd: o("common.label.and"),
      advancedFilterOr: o("common.label.or"),
      advancedFilterBuilderAddJoin: o("common.action.addGroup2"),
      advancedFilterBuilderAddCondition: o("common.action.addFilter"),
      advancedFilterBuilderSelectColumn: o("common.action.selectColumn"),
      advancedFilterBuilderSelectOption: o("common.action.selectOption"),
      advancedFilterBuilderEnterValue: o("common.action.enterValue"),
      advancedFilterBuilderClear: o("common.action.clear"),
      advancedFilterBuilderApply: o("common.action.apply"),
      advancedFilterBuilderCancel: o("common.action.cancel"),
      advancedFilterBuilderAddButtonTooltip: o("common.action.addFilter2"),
      advancedFilterBuilderRemoveButtonTooltip: o("common.action.remove"),
      advancedFilterBuilderMoveUpButtonTooltip: o("common.action.moveUp"),
      advancedFilterBuilderMoveDownButtonTooltip: o("common.action.moveDown")
    })), ce = pe({
      props: {
        data: { type: Object, required: !0 }
      },
      setup() {
        return () => vo("div", {}, "details component");
      }
    }), G = F(() => {
      var re;
      return {
        ...{
          headerHeight: 28,
          floatingFiltersHeight: n.filterRow && !n.advancedFilterOpen ? 28 : 0,
          // Headers (unlike cells) render through ag-Grid's own default markup, not a custom
          // cellRenderer, so its built-in truncation check against .ag-header-cell-text is accurate.
          tooltipShowMode: "whenTruncated",
          tooltipShowDelay: 600,
          icons: H,
          getMainMenuItems: Y,
          detailCellRenderer: n.detailCellRendererComponent ?? ce,
          detailCellRendererParams: n.detailCellRendererParams,
          getRowHeight: (me) => {
            var De;
            if (!((De = me == null ? void 0 : me.node) != null && De.detail)) return;
            const Ee = n.filterRow && !n.advancedFilterOpen ? 80 : 40, Ne = me == null ? void 0 : me.node;
            return me.node.level === 1 ? 1 : Math.min((Ne.__visibleRows ?? 1) * 40 + Ee + 4, 494);
          },
          detailRowAutoHeight: !0,
          suppressScrollOnNewData: !0,
          // Pinned rows are synthetic and may not carry the caller's own `path` convention — give
          // them a stable id directly instead of crashing on `.path` being undefined.
          getRowId: (me) => me.rowPinned ? `__pinned_${me.rowPinned}__` : me.data.path.join(">"),
          animateRows: !1,
          localeText: ge.value,
          suppressContextMenu: !0,
          suppressDragLeaveHidesColumns: !0,
          processUnpinnedColumns: () => [],
          enableAdvancedFilter: n.filterRow && n.advancedFilterOpen,
          advancedFilterBuilderParams: ret,
          advancedFilterParams: aet,
          onAdvancedFilterBuilderVisibleChanged: (me) => {
            b.value = me.visible;
          },
          dataTypeDefinitions: i.value,
          alwaysPassFilter: () => !0,
          includeHiddenColumnsInAdvancedFilter: !0,
          rowClassRules: {
            "row-selected-custom": (me) => {
              const Ee = n.selectedRowId ?? We.value;
              return Ee !== void 0 ? Qe(me.data, Ee) : me.data === ne.value;
            },
            "row-draft": (me) => {
              var Ee, Ne;
              return ((Ne = (Ee = me.data) == null ? void 0 : Ee.record) == null ? void 0 : Ne.state) === "draft";
            }
          }
        },
        ...n.gridOptions,
        localeText: {
          ...ge.value,
          ...((re = n.gridOptions) == null ? void 0 : re.localeText) ?? {}
        }
      };
    }), z = W(0), oe = () => {
      requestAnimationFrame(() => {
        var re;
        let T = 0;
        m.value && !m.value.isDestroyed() && (T = ((re = m.value) == null ? void 0 : re.getDisplayedRowCount()) ?? 0), z.value = T;
      });
    }, q = F(() => {
      const T = n.filterRow && !n.advancedFilterOpen ? "60px" : "28px", re = n.filterRow && !n.advancedFilterOpen ? 80 : 40, me = z.value || 2;
      return {
        "--floating-height": T,
        "--sticky-top": n.filterRow ? "60px" : "28px",
        ...n.pagination ? {} : {
          display: "grid"
        },
        ...n.minRowCount ? {
          minHeight: Math.min((me ?? 1) * 40 + re + 4, 494) + "px"
        } : {}
      };
    }), ne = W(void 0), Fe = W(null), We = W(n.selectedRowId), Qe = (T, re) => {
      var Ee;
      if (re === void 0 || T == null) return !1;
      const me = T;
      return ((Ee = me.record) == null ? void 0 : Ee.id) === re || me.id === re || me.uiId === re;
    }, nt = (T) => {
      var Ne;
      if ((Ne = T.node) != null && Ne.rowPinned || fs(T.event) || n.suppressRowFocus || Le(T.event) || !ht(T.rowIndex)) return;
      if (n.selectedRowId !== void 0) {
        s("row-click", T);
        return;
      }
      const re = Fe.value ?? null, me = T.node ?? null;
      ne.value = T.data, Fe.value = me;
      const Ee = [];
      if (m.value) {
        if ((re == null ? void 0 : re.rowIndex) != null) {
          const De = m.value.getDisplayedRowAtIndex(re.rowIndex);
          De && Ee.push(De);
        }
        if ((me == null ? void 0 : me.rowIndex) != null) {
          const De = m.value.getDisplayedRowAtIndex(me.rowIndex);
          De && Ee.push(De);
        }
        Ee.length && m.value.redrawRows({ rowNodes: Ee });
      }
      s("row-click", T);
    }, ut = (T) => {
      s("selection-changed", T);
    }, V = (T) => {
      s("column-moved", T);
    }, Q = (T) => {
      s("column-visible", T);
    }, ye = async (T) => {
      const { api: re } = T;
      if (m.value = T.api, await rt(), gt(), T.api.addEventListener("columnResized", gt), T.api.addEventListener("columnMoved", gt), T.api.addEventListener("gridSizeChanged", gt), T.api.addEventListener("gridColumnsChanged", ci), n.advancedFilterOpen && w.value) {
        const me = W_(w.value, n.userDateFormat) ?? w.value;
        re.setAdvancedFilterModel(me);
      }
      n.filterRow && !n.advancedFilterOpen && y.value && re.setFilterModel(y.value), requestAnimationFrame(() => {
        _t();
      }), requestAnimationFrame(() => {
        s("grid-ready", { api: re });
      });
    }, ae = (T) => {
      T.api.removeEventListener("columnResized", gt), T.api.removeEventListener("columnMoved", gt), T.api.removeEventListener("gridSizeChanged", gt), T.api.removeEventListener("gridColumnsChanged", ci);
    }, ie = (T) => {
      s("sort-changed", T);
    }, Oe = (T) => {
      T.finished && T.source !== "autosizeColumns" && (T.column ? [T.column] : T.columns ?? []).forEach((me) => l.value.delete(me.getColId())), s("column-resized", T);
    }, Dt = () => {
      var Ee, Ne, De;
      const T = Object.values(((Ee = m.value) == null ? void 0 : Ee.getFilterModel()) ?? {}).flat(), re = (Ne = m.value) == null ? void 0 : Ne.getFilterModel(), me = re != null && Object.keys(re).length > 0;
      if (n.filterRow && n.advancedFilterOpen) {
        const kt = (De = m.value) == null ? void 0 : De.getAdvancedFilterModel();
        w.value = kt ?? null, kt ? s("advanced-filter-changed", kt) : s("advanced-filter-changed", { filterType: "join", type: "AND", conditions: [] });
      }
      n.filterRow && !n.advancedFilterOpen ? (y.value = me ? re : null, s("filter-changed", T)) : n.filterRow || (me ? s("filter-changed", T) : y.value = null);
    };
    Me(
      () => n.selectedRowId,
      (T, re) => {
        const me = T === void 0 && re !== void 0, Ee = re ?? We.value, Ne = ne.value;
        me || (T !== void 0 && (We.value = T), ne.value = void 0, Fe.value = null), !((n.selectedRowId ?? We.value) === Ee && Ne === ne.value) && rt(() => {
          !m.value || m.value.isDestroyed() || m.value.setGridOption("rowClassRules", G.value.rowClassRules);
        });
      }
    ), Me(
      () => n.filterRow,
      (T) => {
        var me;
        if (n.advancedFilterOpen) return;
        const re = T ? 28 : 0;
        G.value.floatingFiltersHeight = re, (me = m.value) == null || me.setGridOption("floatingFiltersHeight", re);
      }
    ), Me(
      () => n.advancedFilterOpen,
      async (T) => {
        T || (w.value = null), T && (y.value = null), G.value.floatingFiltersHeight = n.filterRow && !n.advancedFilterOpen ? 28 : 0, G.value.enableAdvancedFilter = n.filterRow && n.advancedFilterOpen, _.value = !1, await rt(), _t(), _.value = !0;
      }
    ), Me(
      () => [j.value, Z.value],
      ([T, re]) => {
        setTimeout(() => {
          if (!m.value || m.value.isDestroyed()) return;
          m.value.setGridOption("pinnedTopRowData", T), m.value.setGridOption("pinnedBottomRowData", re);
          const me = [];
          for (let Ee = 0; Ee < m.value.getPinnedTopRowCount(); Ee++) {
            const Ne = m.value.getPinnedTopRow(Ee);
            Ne && me.push(Ne);
          }
          for (let Ee = 0; Ee < m.value.getPinnedBottomRowCount(); Ee++) {
            const Ne = m.value.getPinnedBottomRow(Ee);
            Ne && me.push(Ne);
          }
          me.length && m.value.redrawRows({ rowNodes: me });
        }, 0);
      }
    );
    const ai = () => "ontouchstart" in window || navigator.maxTouchPoints > 0, fs = (T) => T ? T && T instanceof MouseEvent && T.button === 2 : !1, Le = (T) => {
      const re = T == null ? void 0 : T.target;
      return re instanceof Element && !!re.closest(Mtt);
    };
    let Te = 0, Be = null;
    function ht(T) {
      const re = T ?? null, me = Date.now();
      return re !== null && re === Be && me - Te < 50 ? !1 : (Be = re, Te = me, !0);
    }
    const jo = (T) => {
      var De, kt;
      if (T.rowPinned || ai() || fs(T.sourceEvent) || n.suppressRowFocus || !m.value || T.rowIndex == null || T.column && typeof T.column != "string" && T.column.getColId() === "ag-Grid-SelectionColumn" || Le(T.sourceEvent)) return;
      const re = (De = Fe.value) == null ? void 0 : De.rowIndex;
      let me;
      const Ee = m.value.getDisplayedRowAtIndex(T.rowIndex);
      if (!Ee) return;
      if (n.selectedRowId !== void 0) {
        if (!ht(T.rowIndex)) return;
        s("row-click", { data: Ee.data, type: "rowClicked", event: T.sourceEvent ?? null });
        return;
      }
      if (((kt = Fe.value) == null ? void 0 : kt.rowIndex) === T.rowIndex || (re != null && (me = m.value.getDisplayedRowAtIndex(re)), !Ee)) return;
      ne.value = Ee.data, Fe.value = Ee;
      const Ne = [];
      me && Ne.push(me), Ne.push(Ee), m.value.redrawRows({ rowNodes: Ne }), ht(T.rowIndex), s("row-click", {
        data: Ee.data,
        type: "rowClicked",
        event: T.sourceEvent ?? null
      });
    }, So = () => {
      u.value && (u.value.removeEventListener("click", vs), u.value.remove(), u.value = null), h.value && (h.value.removeEventListener("click", he), h.value.remove(), h.value = null);
    }, _t = () => {
      var De, kt;
      const T = a.value;
      if (!T) return;
      const re = T.querySelector(".ag-advanced-filter-header");
      if (!re) return;
      const me = re.querySelector(".ag-advanced-filter");
      if (!me) return;
      So();
      const Ee = (De = c.value) == null ? void 0 : De.$el, Ne = (kt = d.value) == null ? void 0 : kt.$el;
      if (Ee) {
        const Ht = Ee.cloneNode(!0);
        Ht.classList.add("SCAOpenFilterBuilder-clone"), Ht.style.display = "inline-flex", Ht.addEventListener("click", vs), re.insertBefore(Ht, me), u.value = Ht;
      }
      if (Ne) {
        const Ht = Ne.cloneNode(!0);
        Ht.classList.add("SCAClearFilter-clone"), Ht.style.display = "inline-flex", Ht.addEventListener("click", he), re.appendChild(Ht), h.value = Ht;
      }
    };
    ei(() => {
      B == null || B.disconnect(), So();
    });
    const gt = () => {
      const T = a.value;
      if (!T) return;
      const re = T.querySelector(".ag-header"), me = T.querySelector(".ag-advanced-filter-header");
      !re || !me || (me.style.width = re.offsetWidth + "px");
    }, ci = () => requestAnimationFrame(gt), vs = () => {
      var T;
      (T = m.value) == null || T.showAdvancedFilterBuilder();
    }, he = () => {
      var T;
      (T = m.value) == null || T.setAdvancedFilterModel(null);
    };
    return (T, re) => {
      var me, Ee;
      return f(), v("div", {
        ref_key: "gridWrapperRef",
        ref: a,
        class: S([
          T.$style.gridWrapper,
          e.transitioning && T.$style.transitioning,
          e.agGridHeaderStickyTop && T.$style.gridHeaderSticky,
          e.filterRowReadOnly && T.$style.filterRowReadOnly
        ]),
        style: Ge({
          "--ag-header-sticky-top": e.agGridHeaderStickyTop ?? "initial",
          "--auto-height-valign": e.tableColumnLayout === "top" ? "flex-start" : void 0
        })
      }, [
        _.value ? (f(), U(k(net), {
          key: 0,
          class: S([
            T.$style.grid,
            e.compactBody && T.$style.gridCompact,
            n.totalRowState !== void 0 && T.$style.gridHasTotalRow,
            n.totalRowState !== void 0 && (((me = j.value) == null ? void 0 : me.length) ?? 0) > 0 && T.$style.hasPinnedTop,
            n.totalRowState !== void 0 && (((Ee = Z.value) == null ? void 0 : Ee.length) ?? 0) > 0 && T.$style.hasPinnedBottom
          ]),
          style: Ge(q.value),
          "column-defs": R.value,
          "default-col-def": M,
          "row-data": e.rowData,
          theme: N.value,
          "row-selection": P.value,
          pagination: e.pagination,
          "pagination-page-size": e.paginationPageSize ?? 1,
          "tree-data": e.treeMode,
          "floating-filter": !e.advancedFilterOpen,
          icons: H,
          "get-row-node-id": e.getRowNodeId,
          "get-data-path": e.getDataPath,
          "auto-group-column-def": A.value,
          "grid-options": G.value,
          "selection-column-def": C,
          "dom-layout": e.domLayout,
          "master-detail": e.masterDetail ?? !1,
          onRowClicked: nt,
          onSelectionChanged: ut,
          onGridReady: ye,
          onGridPreDestroyed: ae,
          onColumnMoved: V,
          onSortChanged: ie,
          onColumnVisible: Q,
          onColumnResized: Oe,
          onCellFocused: jo,
          onFilterChanged: Dt,
          onModelUpdated: oe
        }, null, 8, ["class", "style", "column-defs", "row-data", "theme", "row-selection", "pagination", "pagination-page-size", "tree-data", "floating-filter", "get-row-node-id", "get-data-path", "auto-group-column-def", "grid-options", "dom-layout", "master-detail"])) : $("", !0),
        Et(de(It, {
          ref_key: "builderButtonRef",
          ref: c,
          appearance: "secondary",
          size: "small",
          "icon-left": "phosphor/funnel-simple",
          "padding-left": "8px",
          "padding-right": "8px",
          onClick: vs
        }, {
          default: ee(() => [
            Ve(se(k(o)("common.label.builder")), 1)
          ]),
          _: 1
        }, 512), [
          [Hi, !1]
        ]),
        Et(de(Ae, {
          ref_key: "clearButtonRef",
          ref: d,
          size: "12px",
          style: {
            position: "absolute",
            right: "8px",
            backgroundColor: "transparent",
            color: "var(--color-coolGrey-m3)"
          },
          icon: "phosphor/x",
          onClick: he
        }, null, 512), [
          [Hi, !1]
        ]),
        (f(), U(D5, { to: "body" }, [
          b.value ? (f(), v("div", {
            key: 0,
            class: S(T.$style.filterBuilderBackdrop),
            onClick: re[0] || (re[0] = (Ne) => {
              var De;
              return (De = m.value) == null ? void 0 : De.hideAdvancedFilterBuilder();
            })
          }, null, 2)) : $("", !0)
        ]))
      ], 6);
    };
  }
}), Ltt = "_grid_1mqpx_53", Ett = "_gridHasTotalRow_1mqpx_456", Ptt = "_gridCompact_1mqpx_463", Rtt = "_filterBuilderBackdrop_1mqpx_473", Ftt = "_hasPinnedBottom_1mqpx_489", Ttt = "_hasPinnedTop_1mqpx_510", Itt = "_gridHeaderSticky_1mqpx_597", Dtt = "_gridWrapper_1mqpx_658", ktt = "_transitioning_1mqpx_663", Htt = "_filterRowReadOnly_1mqpx_687", Vtt = {
  grid: Ltt,
  "ag-header-cell-resize-ghost": "_ag-header-cell-resize-ghost_1mqpx_186",
  gridHasTotalRow: Ett,
  gridCompact: Ptt,
  filterBuilderBackdrop: Rtt,
  hasPinnedBottom: Ftt,
  hasPinnedTop: Ttt,
  gridHeaderSticky: Itt,
  gridWrapper: Dtt,
  transitioning: ktt,
  filterRowReadOnly: Htt
}, Ott = {
  $style: Vtt
}, jst = /* @__PURE__ */ Ce(Att, [["__cssModules", Ott]]), Btt = /* @__PURE__ */ pe({
  __name: "SCATableRowField",
  props: {
    colType: { default: "text" },
    value: {},
    dateFormat: { default: "dd.MM.yyyy" },
    timeFormat: { default: "HH:mm" }
  },
  setup(e) {
    const t = e, o = F(() => t.value), n = F(() => t.value), s = F(() => t.value), i = F(() => t.value), r = F(() => {
      if (t.colType !== "attachment_amount")
        return !1;
      switch (typeof t.value) {
        case "string":
          return parseInt(t.value, 10) > 0;
        case "number":
          return t.value > 0;
        default:
          return !1;
      }
    });
    return (l, a) => e.colType === "datetime" && typeof e.value == "string" ? (f(), v("span", {
      key: 0,
      class: S(l.$style.text)
    }, se(k(KA)(e.value, t.dateFormat, t.timeFormat)), 3)) : e.colType === "date" && typeof e.value == "string" ? (f(), v("span", {
      key: 1,
      class: S(l.$style.text)
    }, se(k(Q5)(e.value, t.dateFormat)), 3)) : e.colType === "recordReferences" ? (f(), v("span", {
      key: 2,
      class: S(l.$style.text)
    }, [
      (f(!0), v(we, null, Ze(i.value, (c) => (f(), U(Pn, {
        key: c.id,
        avatar: { initials: k(dl)(c.name, { charCount: 1 }) },
        class: S(l.$style.tag)
      }, {
        default: ee(() => [
          Ve(se(c.name), 1)
        ]),
        _: 2
      }, 1032, ["avatar", "class"]))), 128))
    ], 2)) : e.colType === "list" ? (f(), v("span", {
      key: 3,
      class: S(l.$style.text)
    }, se(n.value ? n.value.label : ""), 3)) : e.colType === "typedText" ? (f(), v("span", {
      key: 4,
      class: S(l.$style.text)
    }, se(s.value && s.value.length > 0 ? s.value[0].value : ""), 3)) : e.colType === "attachment_amount" ? (f(), v("span", {
      key: 5,
      class: S([l.$style.text, l.$style.spanGap])
    }, [
      de(Ae, {
        class: S(r.value ? "" : l.$style.disabled),
        icon: "tetrisly/attachment",
        size: "20px"
      }, null, 8, ["class"]),
      Ve(" " + se(o.value), 1)
    ], 2)) : e.colType === "translated_objects" ? (f(), v("span", {
      key: 6,
      class: S([l.$style.text, l.$style.spanGap])
    }, [
      (f(!0), v(we, null, Ze(i.value, (c) => (f(), U(Pn, {
        key: c.id,
        avatar: { initials: k(dl)(c.name, { charCount: 1 }) }
      }, {
        default: ee(() => [
          Ve(se(c.name), 1)
        ]),
        _: 2
      }, 1032, ["avatar"]))), 128))
    ], 2)) : (f(), v("span", {
      key: 7,
      class: S(l.$style.text)
    }, se(o.value), 3));
  }
}), $tt = "_spanGap_107mc_1", Ztt = "_text_107mc_7", Gtt = "_disabled_107mc_14", Ntt = "_tag_107mc_18", ztt = {
  spanGap: $tt,
  text: Ztt,
  disabled: Gtt,
  tag: Ntt
}, jtt = {
  $style: ztt
}, r7 = /* @__PURE__ */ Ce(Btt, [["__cssModules", jtt]]), Wtt = ["checked"], Utt = /* @__PURE__ */ pe({
  __name: "SCATableRow",
  props: {
    row: {},
    indent: {},
    selectedKeys: {},
    cols: {},
    keyProp: {},
    rowsClickable: { type: Boolean, default: !1 },
    selectable: { type: Boolean, default: !1 },
    hierarchy: { type: Boolean, default: !1 },
    childrenKeyProp: { default: void 0 },
    hasChildren: { type: Function, default: void 0 },
    expanded: { type: Boolean, default: !1 },
    dateFormat: { default: "dd.MM.yyyy" },
    timeFormat: { default: "HH:mm" }
  },
  emits: ["update:expanded", "rowClick", "toggleSelect"],
  setup(e, { emit: t }) {
    const o = e, n = t, s = W(o.selectedKeys), i = F(() => o.cols[0]);
    Me(
      () => o.selectedKeys,
      () => {
        s.value = o.selectedKeys;
      }
    );
    const r = F(() => {
      if (!o.childrenKeyProp)
        return !1;
      const a = As(o.row, o.childrenKeyProp);
      return o.childrenKeyProp in o.row && Array.isArray(a) && a.length > 0 ? !0 : o.hasChildren ? o.hasChildren(o.row) : !1;
    });
    function l(a) {
      return typeof o.keyProp == "function" ? o.keyProp(a) : a[o.keyProp];
    }
    return (a, c) => (f(), v("div", {
      role: "gridrow",
      class: S([
        a.$style.row,
        {
          [a.$style.clickable]: e.rowsClickable,
          [a.$style.selected]: s.value.includes(l(e.row)),
          [a.$style.expanded]: e.expanded
        }
      ]),
      onClick: c[4] || (c[4] = (d) => n("rowClick", e.row))
    }, [
      g("div", {
        role: "gridcell",
        class: S([a.$style.td, a.$style.tdGap])
      }, [
        e.hierarchy ? (f(), v(we, { key: 0 }, [
          e.indent ? (f(), v("div", {
            key: 0,
            class: S([a.$style.indented, a.$style.noShrink]),
            style: Ge(`--indent: ${o.indent}`)
          }, null, 6)) : $("", !0),
          r.value ? (f(), U(ot, {
            key: 1,
            size: "small",
            icon: e.expanded ? "tetrisly/16-arrowhead-down-small" : "tetrisly/16-arrowhead-right-small",
            appearance: "secondary",
            type: "bare",
            class: S(a.$style.noShrink),
            onClick: [
              c[0] || (c[0] = xe(() => {
              }, ["stop"])),
              c[1] || (c[1] = (d) => n("update:expanded", !e.expanded))
            ]
          }, null, 8, ["icon", "class"])) : (f(), v("div", {
            key: 2,
            class: S(a.$style.noShrink),
            style: "width: 20px"
          }, null, 2))
        ], 64)) : $("", !0),
        e.selectable ? (f(), U(Zo, {
          key: 1,
          class: S(a.$style.checkbox)
        }, {
          default: ee(() => [
            g("input", {
              checked: s.value.includes(l(e.row)),
              type: "checkbox",
              onClick: c[2] || (c[2] = xe(() => {
              }, ["stop"])),
              onChange: c[3] || (c[3] = (d) => n("toggleSelect", l(e.row)))
            }, null, 40, Wtt)
          ]),
          _: 1
        }, 8, ["class"])) : $("", !0),
        i.value ? ve(a.$slots, i.value.key, {
          key: 2,
          col: i.value,
          row: e.row,
          value: k(As)(e.row, i.value.property)
        }, () => [
          de(r7, {
            "col-type": i.value.type,
            value: k(As)(e.row, i.value.property),
            "date-format": o.dateFormat,
            "time-format": o.timeFormat
          }, null, 8, ["col-type", "value", "date-format", "time-format"])
        ]) : $("", !0)
      ], 2),
      (f(!0), v(we, null, Ze(e.cols.slice(1), (d) => (f(), v("div", {
        key: `${d.key}`,
        role: "gridcell",
        class: S(a.$style.td)
      }, [
        ve(a.$slots, d.key, {
          col: d,
          row: e.row,
          value: k(As)(e.row, d.property)
        }, () => [
          de(r7, {
            "col-type": d.type,
            value: k(As)(e.row, d.property),
            "date-format": o.dateFormat,
            "time-format": o.timeFormat
          }, null, 8, ["col-type", "value", "date-format", "time-format"])
        ])
      ], 2))), 128))
    ], 2));
  }
}), Ktt = "_row_1o39d_747", qtt = "_clickable_1o39d_750", Ytt = "_td_1o39d_753", Qtt = "_expanded_1o39d_756", Jtt = "_selected_1o39d_759", Xtt = "_value_1o39d_785", eot = "_tdGap_1o39d_792", tot = "_indented_1o39d_796", oot = "_noShrink_1o39d_801", not = "_checkbox_1o39d_805", sot = {
  row: Ktt,
  clickable: qtt,
  td: Ytt,
  expanded: Qtt,
  selected: Jtt,
  value: Xtt,
  tdGap: eot,
  indented: tot,
  noShrink: oot,
  checkbox: not
}, iot = {
  $style: sot
}, rot = /* @__PURE__ */ Ce(Utt, [["__cssModules", iot]]), lot = {
  key: 0,
  style: "width: 20px"
}, aot = ["checked"], cot = ["title"], dot = ["title"], uot = ["onClick"], hot = /* @__PURE__ */ pe({
  __name: "SCATable",
  props: {
    items: { default: () => [] },
    selectedKeys: { default: () => [] },
    cols: {},
    keyProp: {},
    rowsClickable: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    sortState: { default: void 0 },
    selectable: { type: Boolean, default: !1 },
    hierarchy: { type: Boolean, default: !1 },
    childrenKeyProp: { default: void 0 },
    colFilters: { default: () => [] },
    hasChildren: { type: Function, default: void 0 },
    hideHeader: { type: Boolean, default: !1 },
    initiallyExpanded: { type: Boolean, default: !1 },
    dateFormat: { default: "dd.MM.yyyy" },
    timeFormat: { default: "HH:mm" }
  },
  emits: ["rowClick", "update:selectedKeys", "update:sortState", "update:colFilters", "loadChildren"],
  setup(e, { emit: t }) {
    const o = e, n = t, s = oo(o, "selectedKeys", n, { passive: !0 }), i = W({}), r = W({}), l = W({});
    function a(A, R) {
      const P = b(A);
      r.value[P] = R, R && !l.value[P] && (n("loadChildren", A), l.value[P] = !0);
    }
    function c(A) {
      return o.childrenKeyProp ? As(A, o.childrenKeyProp) ?? [] : [];
    }
    Me(
      () => o.items,
      () => {
        i.value = {}, d(o.items, 0);
      },
      { immediate: !0, deep: !0 }
    );
    function d(A, R = 0) {
      A && A.forEach((P) => {
        const I = b(P);
        if (i.value[I] = R, o.childrenKeyProp) {
          const B = c(P);
          d(B, R + 1);
        }
      });
    }
    Me(
      () => o.items,
      (A) => {
        s.value = s.value.filter((R) => A.find((P) => b(P) === R));
      }
    );
    const u = F(() => h(o.items));
    function h(A) {
      return A.reduce((R, P) => [...R, P, ...p(P) ? h(c(P)) : []], []);
    }
    function p(A) {
      return !!r.value[b(A)];
    }
    {
      let A = function(I) {
        return I.reduce((B, H) => [...B, H, ...A(c(H))], []);
      }, R = function(I, B) {
        Object.entries(B.value).forEach(([H]) => {
          I.find((N) => b(N) === H) || delete B.value[H];
        });
      }, P = function(I) {
        const B = A(I);
        R(B, i), R(B, r), R(B, l);
      };
      Me(
        () => o.items,
        (I) => {
          P(I);
        },
        { deep: !0 }
      );
    }
    Me(
      () => o.items,
      (A) => {
        i.value = {}, d(A, 0), o.initiallyExpanded && C(A);
      },
      { immediate: !0, deep: !0 }
    );
    function C(A) {
      for (const R of A) {
        const P = b(R);
        r.value[P] = !0, l.value[P] = !0;
        const I = c(R);
        I != null && I.length && C(I);
      }
    }
    const m = oo(o, "sortState", n, { passive: !0, deep: !0 }), w = F(() => o.cols.map((A) => `${A.width ?? "minmax(min-content, 1fr)"}`).join(" "));
    function y(A) {
      n("rowClick", A);
    }
    function b(A) {
      return typeof o.keyProp == "function" ? o.keyProp(A) : A[o.keyProp];
    }
    function _(A) {
      return A.reduce((R, P) => {
        const I = c(P);
        return [...R, P, ..._(I)];
      }, []);
    }
    function M() {
      if (s.value.length > 0) {
        s.value = [];
        return;
      }
      s.value = _(o.items).map((A) => b(A));
    }
    function x(A) {
      const R = s.value.indexOf(A);
      if (R >= 0) {
        s.value.splice(R, 1);
        return;
      }
      s.value.push(A);
    }
    function L(A) {
      var R;
      if ($o(A, "col"), !!A.sortable) {
        if (((R = m.value) == null ? void 0 : R.colKey) === A.key) {
          switch (m.value.asc) {
            case !1:
              m.value.asc = !0;
              break;
            case !0:
              m.value = void 0;
              break;
          }
          return;
        }
        m.value = {
          colKey: A.key,
          asc: !1
        };
      }
    }
    return (A, R) => (f(), U(g2, {
      class: S([A.$style.wrapper, "w-full"]),
      loading: e.loading,
      overlay: ""
    }, {
      default: ee(() => {
        var P, I;
        return [
          (f(), v("div", {
            key: e.cols.length,
            role: "grid",
            class: S(A.$style.table),
            style: Ge({ gridTemplateColumns: w.value })
          }, [
            !e.hideHeader && e.cols[0] ? (f(), v("div", {
              key: 0,
              class: S(A.$style.headerRow)
            }, [
              g("div", {
                class: S(A.$style.th)
              }, [
                g("div", {
                  role: "heading",
                  class: S(A.$style.firstHeader)
                }, [
                  e.hierarchy ? (f(), v("div", lot)) : $("", !0),
                  e.selectable ? (f(), U(Zo, {
                    key: 1,
                    deselect: "",
                    class: S(A.$style.checkbox),
                    onClick: M
                  }, {
                    default: ee(() => [
                      g("input", {
                        checked: k(s).length > 0,
                        type: "checkbox"
                      }, null, 8, aot)
                    ]),
                    _: 1
                  }, 8, ["class"])) : $("", !0),
                  g("div", {
                    title: e.cols[0].caption
                  }, [
                    g("div", {
                      class: S([A.$style.thLabel, { [A.$style.sortable]: e.cols[0].sortable }]),
                      onClick: R[0] || (R[0] = (B) => L(e.cols[0]))
                    }, [
                      Et(de(Ae, {
                        size: "20px",
                        icon: (P = k(m)) != null && P.asc ? "tetrisly/arrow-up" : "tetrisly/arrow-down"
                      }, null, 8, ["icon"]), [
                        [Hi, ((I = k(m)) == null ? void 0 : I.colKey) === e.cols[0].key]
                      ]),
                      ve(A.$slots, `${e.cols[0].key}_header`, {
                        col: e.cols[0]
                      }, () => [
                        Ve(se(e.cols[0].caption), 1)
                      ])
                    ], 2)
                  ], 8, cot)
                ], 2)
              ], 2),
              (f(!0), v(we, null, Ze(e.cols.slice(1), (B) => {
                var H, O;
                return f(), v("div", {
                  key: B.key,
                  class: S(A.$style.th)
                }, [
                  g("div", {
                    role: "heading",
                    title: B.caption
                  }, [
                    g("div", {
                      class: S([A.$style.thLabel, { [A.$style.sortable]: B.sortable }]),
                      onClick: (N) => L(B)
                    }, [
                      Et(de(Ae, {
                        size: "20px",
                        icon: (H = k(m)) != null && H.asc ? "tetrisly/arrow-up" : "tetrisly/arrow-down"
                      }, null, 8, ["icon"]), [
                        [Hi, ((O = k(m)) == null ? void 0 : O.colKey) === B.key]
                      ]),
                      ve(A.$slots, `${B.key}_header`, { col: B }, () => [
                        Ve(se(B.caption), 1)
                      ])
                    ], 10, uot)
                  ], 8, dot)
                ], 2);
              }), 128))
            ], 2)) : $("", !0),
            (f(!0), v(we, null, Ze(u.value, (B) => (f(), U(rot, {
              key: `${String(b(B))}`,
              "selected-keys": k(s),
              row: B,
              cols: e.cols,
              indent: i.value[b(B)],
              expanded: r.value[b(B)],
              "key-prop": e.keyProp,
              "children-key-prop": e.childrenKeyProp,
              hierarchy: e.hierarchy,
              selectable: e.selectable,
              "rows-clickable": e.rowsClickable,
              "has-children": e.hasChildren,
              "date-format": e.dateFormat,
              "time-format": e.timeFormat,
              onToggleSelect: x,
              onRowClick: y,
              "onUpdate:expanded": (H) => a(B, H)
            }, sn({ _: 2 }, [
              Ze(e.cols, (H) => ({
                name: H.key,
                fn: ee(() => [
                  ve(A.$slots, H.key, {
                    col: H,
                    row: B,
                    value: k(As)(B, H.property)
                  })
                ])
              }))
            ]), 1032, ["selected-keys", "row", "cols", "indent", "expanded", "key-prop", "children-key-prop", "hierarchy", "selectable", "rows-clickable", "has-children", "date-format", "time-format", "onUpdate:expanded"]))), 128)),
            e.items.length === 0 && !e.loading ? (f(), v("div", {
              key: 1,
              class: S(A.$style.empty),
              style: Ge({ gridColumn: `span ${e.cols.length}` })
            }, [
              ve(A.$slots, "_empty")
            ], 6)) : $("", !0)
          ], 6))
        ];
      }),
      _: 3
    }, 8, ["class", "loading"]));
  }
}), got = "_wrapper_ri9sy_747", pot = "_table_ri9sy_751", fot = "_headerRow_ri9sy_757", vot = "_th_ri9sy_760", mot = "_firstHeader_ri9sy_785", Cot = "_thLabel_ri9sy_790", wot = "_sortable_ri9sy_795", bot = "_empty_ri9sy_798", yot = "_loadingIndicator_ri9sy_802", _ot = "_checkbox_ri9sy_808", Sot = {
  wrapper: got,
  table: pot,
  headerRow: fot,
  th: vot,
  firstHeader: mot,
  thLabel: Cot,
  sortable: wot,
  empty: bot,
  loadingIndicator: yot,
  checkbox: _ot
}, xot = {
  $style: Sot
}, Wst = /* @__PURE__ */ Ce(hot, [["__cssModules", xot]]);
/**
   * vue-table
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
const Q_ = pe({
  props: ["render", "props"],
  setup: (e) => () => typeof e.render == "function" || typeof e.render == "object" ? vo(e.render, e.props) : e.render
}), Mot = ["placeholder"], Aot = ["placeholder"], Lot = /* @__PURE__ */ pe({
  __name: "SCAFilterRowItem",
  props: {
    colKey: {},
    colType: {},
    placeholder: {},
    customListOptions: {}
  },
  emits: ["update:filters"],
  setup(e, { emit: t }) {
    const { t: o } = Go(), n = e, s = t, i = W(""), r = W(), l = W([]), a = W(""), c = F(() => n.customListOptions ?? []), d = F(() => U_(n.colType)), u = F(() => n.colKey === K_.COUNTRY), h = F(() => d.value === fe.CUSTOM_LIST), p = F(() => d.value === fe.CHECKBOX), C = [
      { id: "true", label: o("common.label.true") },
      { id: "false", label: o("common.label.false") }
    ], m = W([]);
    At(() => {
      var oe, q;
      if (!u.value)
        return;
      const z = (((q = (oe = navigator == null ? void 0 : navigator.language) == null ? void 0 : oe.split) == null ? void 0 : q.call(oe, "-")[0]) ?? "en").toLowerCase();
      m.value = GA(z);
    });
    const w = F(() => [
      fe.TEXT,
      fe.TEXT_ARRAY,
      fe.TEXT_AREA,
      fe.DATE,
      fe.DATETIME,
      fe.TYPED_TEXT,
      fe.LIST,
      fe.CUSTOM_LIST,
      fe.TEXT_AREA,
      fe.URL,
      fe.CURRENCY,
      fe.MONEY,
      fe.RECORD_REFERENCES,
      fe.USER_REFERENCE,
      fe.EMAIL_CONTACT_REFERENCES,
      fe.TAG_REFERENCES,
      fe.CATEGORY_REFERENCES,
      fe.ORGANIZATION_REFERENCES,
      fe.STATUS_REFERENCE,
      fe.PRIORITY_REFERENCE,
      fe.NUMBER,
      fe.ATTACHMENT_AMOUNT,
      fe.CHECKBOX
    ].includes(d.value)), y = F(() => {
      const z = [
        { value: Se.EQUALS, label: o("record.src.label.equals"), icon: "generic/operator-eq" },
        { value: Se.NOT_EQUALS, label: o("common.label.equals"), icon: "generic/operator-neq" }
      ];
      return [fe.DATE, fe.DATETIME, fe.NUMBER, fe.MONEY].includes(d.value) ? [
        ...z,
        { value: Se.GREATER_THAN, label: o("record.src.label.greater"), icon: "generic/operator-gt" },
        { value: Se.LESS_THAN, label: o("record.src.label.less"), icon: "generic/operator-lt" },
        {
          value: Se.GREATER_OR_EQUALS,
          label: o("common.label.greaterEquals"),
          icon: "generic/operator-gte"
        },
        { value: Se.LESS_OR_EQUALS, label: o("common.label.lessEquals"), icon: "generic/operator-lte" }
      ] : [
        { value: Se.CONTAINS, label: o("common.label.contains"), icon: "generic/operator-contains" },
        { value: Se.NOT_CONTAINS, label: o("common.label.contains2"), icon: "generic/operator-not-contains" },
        ...z
      ];
    }), b = F(() => {
      switch (d.value) {
        case fe.DATE:
        case fe.DATETIME:
          return Se.EQUALS;
        case fe.NUMBER:
          return Se.EQUALS;
        case fe.ATTACHMENT_AMOUNT:
          return Se.EQUALS;
        case fe.CUSTOM_LIST:
          return Se.EQUALS;
        default:
          return Se.CONTAINS;
      }
    }), _ = F(() => {
      const z = y.value.find((oe) => oe.value === r.value);
      return (z == null ? void 0 : z.icon) ?? "tetrisly/search";
    }), M = F({
      get: () => i.value,
      set: (z) => {
        i.value = z, te();
      }
    }), x = (z) => {
      const oe = new Date(z);
      return oe.setSeconds(0), oe.toISOString();
    }, L = (z) => {
      const oe = new Date(z);
      return oe.setSeconds(59), oe.toISOString();
    }, A = (z) => {
      const oe = new Date(z);
      return oe.setMinutes(oe.getMinutes() - 1), oe.toISOString();
    }, R = (z) => {
      const oe = new Date(z);
      return oe.setMinutes(oe.getMinutes() + 1), oe.toISOString();
    }, P = (z) => {
      const oe = new Date(z);
      return oe.setHours(0, 0, 0, 0), oe.toISOString();
    }, I = (z) => {
      const oe = new Date(z);
      return oe.setHours(23, 59, 59, 999), oe.toISOString();
    }, B = (z) => {
      const oe = new Date(z);
      return oe.setDate(oe.getDate() + 1), oe.setHours(0, 0, 0, 0), oe.toISOString();
    }, H = (z) => {
      const oe = new Date(z);
      return oe.setDate(oe.getDate() - 1), oe.setHours(23, 59, 59, 999), oe.toISOString();
    }, O = (z) => {
      if (!z) return "";
      const oe = new Date(z);
      if (isNaN(oe.getTime())) return z;
      const q = oe.getFullYear(), ne = String(oe.getMonth() + 1).padStart(2, "0"), Fe = String(oe.getDate()).padStart(2, "0");
      return `${q}-${ne}-${Fe}`;
    }, N = () => {
      if (!i.value)
        return [];
      const z = r.value ?? b.value;
      if (h.value)
        return [
          {
            colKey: n.colKey,
            logicalOperator: Tt.AND,
            conditions: [
              {
                colKey: n.colKey,
                filterTerm: i.value,
                operator: Se.EQUALS
              }
            ]
          }
        ];
      if (d.value === fe.DATE)
        switch (z) {
          case Se.EQUALS:
            return [
              {
                colKey: n.colKey,
                logicalOperator: Tt.AND,
                conditions: [
                  {
                    colKey: n.colKey,
                    filterTerm: P(i.value),
                    operator: Se.GREATER_OR_EQUALS
                  },
                  {
                    colKey: n.colKey,
                    filterTerm: I(i.value),
                    operator: Se.LESS_OR_EQUALS
                  }
                ]
              }
            ];
          case Se.NOT_EQUALS:
            return [
              {
                colKey: n.colKey,
                logicalOperator: Tt.OR,
                conditions: [
                  {
                    colKey: n.colKey,
                    filterTerm: P(i.value),
                    operator: Se.LESS_THAN
                  },
                  {
                    colKey: n.colKey,
                    filterTerm: I(i.value),
                    operator: Se.GREATER_THAN
                  }
                ]
              }
            ];
          case Se.GREATER_THAN:
            return [
              {
                colKey: n.colKey,
                logicalOperator: Tt.AND,
                conditions: [
                  {
                    colKey: n.colKey,
                    filterTerm: B(i.value),
                    operator: Se.GREATER_THAN
                  }
                ]
              }
            ];
          case Se.LESS_THAN:
            return [
              {
                colKey: n.colKey,
                logicalOperator: Tt.AND,
                conditions: [
                  {
                    colKey: n.colKey,
                    filterTerm: H(i.value),
                    operator: Se.LESS_THAN
                  }
                ]
              }
            ];
          case Se.GREATER_OR_EQUALS:
            return [
              {
                colKey: n.colKey,
                logicalOperator: Tt.AND,
                conditions: [
                  {
                    colKey: n.colKey,
                    filterTerm: P(i.value),
                    operator: Se.GREATER_OR_EQUALS
                  }
                ]
              }
            ];
          case Se.LESS_OR_EQUALS:
            return [
              {
                colKey: n.colKey,
                logicalOperator: Tt.AND,
                conditions: [
                  {
                    colKey: n.colKey,
                    filterTerm: I(i.value),
                    operator: Se.LESS_OR_EQUALS
                  }
                ]
              }
            ];
        }
      if (d.value === fe.DATETIME)
        switch (z) {
          case Se.EQUALS:
            return [
              {
                colKey: n.colKey,
                logicalOperator: Tt.AND,
                conditions: [
                  {
                    colKey: n.colKey,
                    filterTerm: x(i.value),
                    operator: Se.GREATER_OR_EQUALS
                  },
                  {
                    colKey: n.colKey,
                    filterTerm: L(i.value),
                    operator: Se.LESS_OR_EQUALS
                  }
                ]
              }
            ];
          case Se.NOT_EQUALS:
            return [
              {
                colKey: n.colKey,
                logicalOperator: Tt.OR,
                conditions: [
                  {
                    colKey: n.colKey,
                    filterTerm: x(i.value),
                    operator: Se.LESS_THAN
                  },
                  {
                    colKey: n.colKey,
                    filterTerm: L(i.value),
                    operator: Se.GREATER_THAN
                  }
                ]
              }
            ];
          case Se.GREATER_THAN:
            return [
              {
                colKey: n.colKey,
                logicalOperator: Tt.AND,
                conditions: [
                  {
                    colKey: n.colKey,
                    filterTerm: R(i.value),
                    operator: Se.GREATER_THAN
                  }
                ]
              }
            ];
          case Se.LESS_THAN:
            return [
              {
                colKey: n.colKey,
                logicalOperator: Tt.AND,
                conditions: [
                  {
                    colKey: n.colKey,
                    filterTerm: A(i.value),
                    operator: Se.LESS_THAN
                  }
                ]
              }
            ];
          case Se.GREATER_OR_EQUALS:
            return [
              {
                colKey: n.colKey,
                logicalOperator: Tt.AND,
                conditions: [
                  {
                    colKey: n.colKey,
                    filterTerm: x(i.value),
                    operator: Se.GREATER_OR_EQUALS
                  }
                ]
              }
            ];
          case Se.LESS_OR_EQUALS:
            return [
              {
                colKey: n.colKey,
                logicalOperator: Tt.AND,
                conditions: [
                  {
                    colKey: n.colKey,
                    filterTerm: L(i.value),
                    operator: Se.LESS_OR_EQUALS
                  }
                ]
              }
            ];
        }
      return [
        {
          colKey: n.colKey,
          logicalOperator: Tt.AND,
          conditions: [
            {
              colKey: n.colKey,
              filterTerm: i.value,
              operator: z
            }
          ]
        }
      ];
    }, te = Us(() => {
      const z = N();
      s("update:filters", z), l.value = z;
    }, 1e3), E = (z) => {
      let oe = "";
      if (z instanceof Event ? oe = z.target.value : oe = z, !oe) {
        Y();
        return;
      }
      i.value = oe, te();
    }, j = (z) => {
      const oe = new Date(z);
      isNaN(oe.getTime()) || (i.value = oe.toISOString(), te());
    }, Z = (z) => {
      r.value = z, i.value && te();
    }, Y = () => {
      i.value = "", a.value = "", s("update:filters", []), l.value = [];
    };
    Me(
      i,
      (z) => {
        if (d.value === fe.DATE)
          if (z) {
            const oe = new Date(z);
            isNaN(oe.getTime()) || (a.value = O(z));
          } else
            a.value = "";
      },
      { immediate: !0 }
    ), Me(a, (z) => {
      if (d.value === fe.DATE)
        if (z) {
          if (!le(z)) return;
          j(z);
        } else
          i.value = "";
      if (d.value === fe.DATETIME)
        if (z) {
          if (!ge(z)) return;
          j(z);
        } else
          i.value = "";
    });
    function le(z) {
      const q = /^(\d{4})-(\d{2})-(\d{2})$/.exec(z);
      if (!q) return !1;
      const ne = Number(q[1]), Fe = Number(q[2]), We = Number(q[3]);
      if (ne < 1900 || ne > 2100) return !1;
      const Qe = new Date(z);
      return !(isNaN(Qe.getTime()) || Qe.getFullYear() !== ne || Qe.getMonth() + 1 !== Fe || Qe.getDate() !== We);
    }
    function ge(z) {
      const q = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/.exec(z);
      if (!q) return !1;
      const ne = Number(q[1]), Fe = Number(q[2]), We = Number(q[3]), Qe = Number(q[4]), nt = Number(q[5]);
      if (ne < 1900 || ne > 2100) return !1;
      const ut = new Date(z);
      return !(isNaN(ut.getTime()) || ut.getFullYear() !== ne || ut.getMonth() + 1 !== Fe || ut.getDate() !== We || ut.getHours() != Qe || ut.getMinutes() != nt);
    }
    const ce = F(() => le(a.value)), G = F(() => ge(a.value));
    return (z, oe) => w.value ? (f(), v("div", {
      key: 0,
      class: S(z.$style.filterItem)
    }, [
      h.value ? $("", !0) : (f(), U(zt, {
        key: 0,
        placement: "bottom-start",
        class: S(z.$style.operatorDropdown)
      }, {
        trigger: ee(({ target: q }) => [
          de(It, {
            popovertarget: q,
            type: "ghost",
            size: "small",
            intent: "none",
            appearance: "secondary",
            "icon-left": _.value,
            class: S(z.$style.filterTrigger)
          }, null, 8, ["popovertarget", "icon-left", "class"])
        ]),
        default: ee(({ popover: q }) => [
          (f(!0), v(we, null, Ze(y.value, (ne) => (f(), U(d2, {
            key: ne.value,
            selected: ne.value === r.value,
            label: ne.label,
            type: "action",
            appearance: "secondary",
            onClick: (Fe) => {
              Z(ne.value), q == null || q.hidePopover();
            }
          }, null, 8, ["selected", "label", "onClick"]))), 128))
        ]),
        _: 1
      }, 8, ["class"])),
      u.value ? (f(), v("div", {
        key: 1,
        class: S(z.$style.filterCountrySelect)
      }, [
        de(Is, null, {
          default: ee(() => [
            m.value.length ? (f(), U(Ds, {
              key: 0,
              modelValue: M.value,
              "onUpdate:modelValue": oe[0] || (oe[0] = (q) => M.value = q),
              "item-value": "id",
              "item-title": "label",
              search: "client",
              items: m.value,
              placeholder: e.placeholder
            }, null, 8, ["modelValue", "items", "placeholder"])) : $("", !0)
          ]),
          _: 1
        }),
        i.value ? (f(), U(ot, {
          key: 0,
          icon: "tetrisly/close",
          size: "small",
          appearance: "secondary",
          intent: "destructive",
          type: "ghost",
          onClick: Y
        })) : $("", !0)
      ], 2)) : h.value ? (f(), v("div", {
        key: 2,
        class: S(z.$style.filterCountrySelect)
      }, [
        de(Is, null, {
          default: ee(() => [
            de(Ds, {
              modelValue: i.value,
              "onUpdate:modelValue": [
                oe[1] || (oe[1] = (q) => i.value = q),
                oe[2] || (oe[2] = (q) => E(q))
              ],
              "item-value": "id",
              "item-title": "label",
              search: "client",
              items: c.value,
              placeholder: e.placeholder
            }, null, 8, ["modelValue", "items", "placeholder"])
          ]),
          _: 1
        }),
        i.value ? (f(), U(ot, {
          key: 0,
          icon: "tetrisly/close",
          size: "small",
          appearance: "secondary",
          intent: "destructive",
          type: "ghost",
          onClick: Y
        })) : $("", !0)
      ], 2)) : p.value ? (f(), v("div", {
        key: 3,
        class: S(z.$style.filterCountrySelect)
      }, [
        de(Is, null, {
          default: ee(() => [
            de(Ds, {
              modelValue: i.value,
              "onUpdate:modelValue": [
                oe[3] || (oe[3] = (q) => i.value = q),
                oe[4] || (oe[4] = (q) => E(q))
              ],
              "item-value": "id",
              "item-title": "label",
              search: "client",
              items: C,
              placeholder: e.placeholder
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }),
        i.value ? (f(), U(ot, {
          key: 0,
          icon: "tetrisly/close",
          size: "small",
          appearance: "secondary",
          intent: "destructive",
          type: "ghost",
          onClick: Y
        })) : $("", !0)
      ], 2)) : (f(), U(oa, {
        key: 4,
        "show-clear-icon": !!i.value,
        class: S(z.$style.filterInput),
        "show-search-icon": !1,
        onClear: Y
      }, {
        default: ee(() => [
          d.value === k(fe).DATE ? Et((f(), v("input", {
            key: 0,
            "onUpdate:modelValue": oe[5] || (oe[5] = (q) => a.value = q),
            type: "date",
            class: S({ [z.$style.invalid]: !ce.value && a.value.length > 0 })
          }, null, 2)), [
            [xn, a.value]
          ]) : d.value === k(fe).DATETIME ? Et((f(), v("input", {
            key: 1,
            "onUpdate:modelValue": oe[6] || (oe[6] = (q) => a.value = q),
            type: "datetime-local",
            class: S({ [z.$style.invalid]: !G.value && a.value.length > 0 })
          }, null, 2)), [
            [xn, a.value]
          ]) : d.value === k(fe).NUMBER || d.value === k(fe).ATTACHMENT_AMOUNT ? Et((f(), v("input", {
            key: 2,
            "onUpdate:modelValue": oe[7] || (oe[7] = (q) => i.value = q),
            placeholder: e.placeholder,
            type: "number",
            onInput: E
          }, null, 40, Mot)), [
            [
              xn,
              i.value,
              void 0,
              { trim: !0 }
            ]
          ]) : Et((f(), v("input", {
            key: 3,
            "onUpdate:modelValue": oe[8] || (oe[8] = (q) => i.value = q),
            placeholder: e.placeholder,
            onInput: E
          }, null, 40, Aot)), [
            [
              xn,
              i.value,
              void 0,
              { trim: !0 }
            ]
          ])
        ]),
        _: 1
      }, 8, ["show-clear-icon", "class"]))
    ], 2)) : $("", !0);
  }
}), Eot = "_filterItem_10a37_1", Pot = "_filterCountrySelect_10a37_2", Rot = "_operatorDropdown_10a37_14", Fot = "_filterInput_10a37_18", Tot = "_filterTrigger_10a37_23", Iot = "_invalid_10a37_31", Dot = {
  filterItem: Eot,
  filterCountrySelect: Pot,
  operatorDropdown: Rot,
  filterInput: Fot,
  filterTrigger: Tot,
  invalid: Iot
}, kot = {
  $style: Dot
}, Hot = /* @__PURE__ */ Ce(Lot, [["__cssModules", kot]]), Vot = /* @__PURE__ */ pe({
  __name: "SCAFilterRow",
  props: {
    cols: {},
    colFilters: {},
    order: {}
  },
  emits: ["update:colFilters"],
  setup(e, { emit: t }) {
    const o = e, n = F(() => [
      ...o.cols.filter((l) => {
        var a;
        return (a = l.columnDef.meta) == null ? void 0 : a.helper;
      }),
      ...o.order.map((l) => o.cols.find((a) => a.id === l)).filter((l) => l !== void 0)
    ]), i = oo(o, "colFilters", t, { passive: !0, deep: !0 }), r = (l, a) => {
      i.value ?? (i.value = []);
      const c = i.value.filter((d) => d.colKey !== l);
      i.value = [...c, ...a];
    };
    return (l, a) => (f(), v("div", {
      role: "row",
      class: S(l.$style.filterRow)
    }, [
      (f(!0), v(we, null, Ze(n.value, (c) => {
        var d, u, h;
        return f(), v("div", {
          key: c.id,
          role: "cell",
          class: S(l.$style.filterCell)
        }, [
          de(Hot, {
            "col-key": c.id,
            "col-type": (u = (d = e.cols.find((p) => p.id === c.id)) == null ? void 0 : d.columnDef.meta) == null ? void 0 : u.type,
            placeholder: l.$t("common.action.filter"),
            "custom-list-options": (h = c.columnDef.meta) == null ? void 0 : h.customListOptions,
            "onUpdate:filters": (p) => r(c.id, p)
          }, null, 8, ["col-key", "col-type", "placeholder", "custom-list-options", "onUpdate:filters"])
        ], 2);
      }), 128))
    ], 2));
  }
}), Oot = "_filterRow_19m76_1", Bot = "_filterCell_19m76_5", $ot = {
  filterRow: Oot,
  filterCell: Bot
}, Zot = {
  $style: $ot
}, Got = /* @__PURE__ */ Ce(Vot, [["__cssModules", Zot]]), Not = ["draggable", "onMouseenter", "onMouseleave"], zot = ["checked", "disabled", "onChange"], jot = /* @__PURE__ */ pe({
  __name: "SCATableRowNew",
  props: {
    row: {},
    dragOverPosition: { default: null },
    setDragOverPosition: { type: [Function, null], default: null },
    dragOverRowId: { default: null },
    setDragOverRowId: { type: [Function, null], default: null },
    draggable: { type: Boolean, default: !1 },
    hierarchical: { type: Boolean, default: !1 },
    selectableRows: { type: Boolean, default: !1 },
    isParentHovered: { type: Boolean, default: !1 },
    focusedRowId: { default: null }
  },
  emits: ["rowClick", "cell-mouseenter", "cell-mouseleave"],
  setup(e, { emit: t }) {
    const o = W(null), n = W(null), s = e, i = t, r = F(() => s.row.getVisibleCells()), l = F(() => s.row.getCanExpand()), a = F(() => s.row.getIsExpanded()), c = F(() => s.row.getIsSelected()), d = F(() => s.row.getCanSelect()), u = F(() => s.row.subRows), h = F(() => s.row.depth), p = {
      onDragover: b,
      onDragleave: _,
      onDrop: M
    };
    let C = null;
    const m = F(
      () => s.dragOverRowId === s.row.id && L(s.row.original) || s.isParentHovered
    ), w = F(() => m.value || s.isParentHovered), y = H5();
    function b(A) {
      var O;
      if (A.preventDefault(), !o.value || !s.setDragOverRowId) return;
      const P = o.value;
      if (!P) return;
      let I = 40;
      for (const N of P.childNodes)
        if (N.nodeType === Node.ELEMENT_NODE) {
          const te = N;
          if (te.getAttribute("role") === "cell") {
            I = te.getBoundingClientRect().height;
            break;
          }
        }
      const B = A.offsetY, H = 12;
      B < H ? n.value = "top" : B > I - H ? n.value = "bottom" : n.value = "on", s.setDragOverRowId(s.row.id), (O = s.setDragOverPosition) == null || O.call(s, n.value), l.value && !a.value && !C && (C = setTimeout(() => {
        s.row.toggleExpanded(!0), C = null;
      }, 2e3));
    }
    function _() {
      var A, R;
      (A = s.setDragOverRowId) == null || A.call(s, null), (R = s.setDragOverPosition) == null || R.call(s, null), C && (clearTimeout(C), C = null), n.value = null;
    }
    function M() {
      n.value = null;
    }
    function x(A) {
      var N;
      if (!s.draggable || !A.dataTransfer) return;
      A.dataTransfer.setData("text/plain", s.row.id);
      const R = document.createElement("div"), P = o.value;
      if (!P) return;
      let I = 0, B = 0;
      P.childNodes.forEach((te) => {
        if (te.nodeType === Node.ELEMENT_NODE) {
          const E = te;
          if (E.getAttribute("role") === "cell") {
            if (I === 0 && B === 0) {
              const Z = E.getBoundingClientRect();
              I = Z.left, B = Z.top;
            }
            const j = E.cloneNode(!0);
            j.classList.add(y.dragCellClone), R.appendChild(j);
          }
        }
      });
      const H = A.clientX - I, O = A.offsetY;
      R.className = P.className, R.classList.add(y.dragGhost), document.body.appendChild(R), A.dataTransfer.setDragImage(R, H, O), setTimeout(() => {
        document.body.removeChild(R);
      }, 0), (N = s.setDragOverPosition) == null || N.call(s, null), n.value = null;
    }
    function L(A) {
      return typeof A == "object" && A !== null && "parentId" in A && typeof A.parentId == "string";
    }
    return (A, R) => {
      const P = hS("SCATableRowNew", !0);
      return f(), v("div", {
        ref_key: "rowElement",
        ref: o
      }, [
        (f(!0), v(we, null, Ze(r.value, (I, B) => (f(), v("div", Bt({
          key: I.id,
          role: "cell",
          class: [
            A.$style.td,
            A.$style.tdGap,
            { [A.$style.focused]: e.row.id === e.focusedRowId },
            { [A.$style.selected]: e.row.getIsSelected() },
            { [A.$style.borderTop]: n.value === "top" },
            { [A.$style.borderBottom]: n.value === "bottom" },
            { [A.$style.defaultBottomBorder]: n.value !== "bottom" },
            { [A.$style.dragHover]: w.value && n.value !== "top" && n.value !== "bottom" }
          ],
          style: B === 0 ? `--indent: ${h.value}; --is-root: 1` : `--indent: ${h.value}; --is-root: 0`,
          draggable: s.draggable
        }, { ref_for: !0 }, p, {
          onDragstart: x,
          onMouseenter: (H) => i("cell-mouseenter", s.row, I, H),
          onMouseleave: (H) => i("cell-mouseleave", I)
        }), [
          B === 0 ? (f(), v(we, { key: 0 }, [
            e.hierarchical ? (f(), v("div", {
              key: 0,
              class: S([A.$style.indentDiv, A.$style.noShrink])
            }, [
              g("div", {
                class: S([A.$style.indented, A.$style.noShrink]),
                style: Ge(`--indent: ${h.value}`)
              }, null, 6),
              l.value ? (f(), U(ot, {
                key: 0,
                size: "small",
                icon: a.value ? "tetrisly/16-arrowhead-down-small" : "tetrisly/16-arrowhead-right-small",
                appearance: "secondary",
                type: "bare",
                class: S(A.$style.noShrink),
                onClick: [
                  R[0] || (R[0] = xe(() => {
                  }, ["stop"])),
                  R[1] || (R[1] = (H) => e.row.toggleExpanded())
                ]
              }, null, 8, ["icon", "class"])) : (f(), v("div", {
                key: 1,
                class: S(A.$style.noShrink),
                style: "width: 20px"
              }, null, 2))
            ], 2)) : $("", !0),
            e.selectableRows ? (f(), U(Zo, {
              key: 1,
              checked: c.value,
              disabled: !d.value,
              class: S(A.$style.checkbox)
            }, {
              default: ee(() => [
                g("input", {
                  checked: c.value,
                  disabled: !d.value,
                  onChange: e.row.getToggleSelectedHandler(),
                  type: "checkbox",
                  onClick: R[2] || (R[2] = xe(() => {
                  }, ["stop"]))
                }, null, 40, zot)
              ]),
              _: 1
            }, 8, ["checked", "disabled", "class"])) : $("", !0)
          ], 64)) : $("", !0),
          ve(A.$slots, I.column.id, { cell: I }, () => [
            g("div", {
              class: S(A.$style.value)
            }, [
              de(k(Q_), {
                render: I.column.columnDef.cell,
                props: I.getContext()
              }, null, 8, ["render", "props"])
            ], 2)
          ])
        ], 16, Not))), 128)),
        a.value ? (f(!0), v(we, { key: 0 }, Ze(u.value, (I) => (f(), U(P, {
          key: I.id,
          role: "row",
          row: I,
          "focused-row-id": e.focusedRowId,
          "drag-over-row-id": e.dragOverRowId,
          "set-drag-over-row-id": e.setDragOverRowId,
          "drag-over-position": e.dragOverPosition,
          "set-drag-over-position": e.setDragOverPosition,
          class: S([A.$style.row, { [A.$style.selected]: I.getIsSelected() }]),
          hierarchical: e.hierarchical,
          "selectable-rows": e.selectableRows,
          draggable: s.draggable,
          "is-parent-hovered": m.value && n.value !== "top" && n.value !== "bottom",
          onDragover: R[3] || (R[3] = xe(() => {
          }, ["prevent"])),
          onClick: xe((B) => i("rowClick", I), ["stop"]),
          onRowClick: R[4] || (R[4] = (B) => i("rowClick", B))
        }, null, 8, ["row", "focused-row-id", "drag-over-row-id", "set-drag-over-row-id", "drag-over-position", "set-drag-over-position", "class", "hierarchical", "selectable-rows", "draggable", "is-parent-hovered", "onClick"]))), 128)) : $("", !0)
      ], 512);
    };
  }
}), Wot = "_row_hn106_747", Uot = "_clickable_hn106_750", Kot = "_td_hn106_753", qot = "_expanded_hn106_756", Yot = "_selected_hn106_759", Qot = "_value_hn106_785", Jot = "_borderTop_hn106_791", Xot = "_borderBottom_hn106_791", ent = "_focused_hn106_803", tnt = "_tdGap_hn106_807", ont = "_expandedRow_hn106_811", nnt = "_indentDiv_hn106_815", snt = "_indented_hn106_819", int = "_noShrink_hn106_824", rnt = "_checkbox_hn106_828", lnt = "_defaultBottomBorder_hn106_860", ant = "_dragHover_hn106_874", cnt = "_dragGhost_hn106_879", dnt = "_dragCellClone_hn106_892", unt = {
  row: Wot,
  clickable: Uot,
  td: Kot,
  expanded: qot,
  selected: Yot,
  value: Qot,
  borderTop: Jot,
  borderBottom: Xot,
  focused: ent,
  tdGap: tnt,
  expandedRow: ont,
  indentDiv: nnt,
  indented: snt,
  noShrink: int,
  checkbox: rnt,
  defaultBottomBorder: lnt,
  dragHover: ant,
  dragGhost: cnt,
  dragCellClone: dnt
}, hnt = {
  $style: unt
}, gnt = /* @__PURE__ */ Ce(jot, [["__cssModules", hnt]]), pnt = ["colSpan"], fnt = ["onClick"], vnt = ["checked", "onChange"], mnt = ["onDblclick", "onMousedown", "onTouchstartPassive"], l7 = 36, Cnt = /* @__PURE__ */ pe({
  __name: "SCATableNew",
  props: {
    table: {},
    loading: { type: Boolean, default: !1 },
    hideHeader: { type: Boolean, default: !1 },
    showFilterRow: { type: Boolean, default: !1 },
    colFilters: { default: () => [] },
    order: {},
    hierarchical: { type: Boolean, default: !1 },
    selectableRows: { type: Boolean, default: !1 },
    draggable: { type: Boolean, default: !1 },
    autoselect: { type: Boolean, default: !0 },
    initialFocusedRowId: { default: null },
    emitRowOnArrow: { type: Boolean, default: !1 }
  },
  emits: ["rowClick", "update:colFilters", "drop:file", "drop:row", "cell-mouseenter", "cell-mouseleave"],
  setup(e, { emit: t }) {
    const o = e, n = t, s = oo(o, "colFilters", n, { passive: !0, deep: !0 }), i = W(o.initialFocusedRowId ?? null);
    Me(
      () => o.initialFocusedRowId,
      (Z) => {
        i.value = Z;
      }
    ), Me(i, () => {
      E();
    });
    const r = W(null), l = gS({
      isHovered: !1,
      dragOverRowId: null,
      dragOverPosition: null,
      isDragOver: !1,
      dragCounter: 0
    }), a = F(() => o.table.getRowModel().rows), c = F(() => o.table.getHeaderGroups()), d = F(() => o.table.getFlatHeaders());
    let u = "", h = [];
    const p = F(() => {
      const Z = d.value.map((Y) => Y.column.getSize());
      return Z.length === h.length && Z.every((Y, le) => Y === h[le]) || (h = Z, u = d.value.map((Y) => {
        var G, z;
        const le = Y.column.getSize(), ge = ((G = Y.column.columnDef.meta) == null ? void 0 : G.autoSize) ?? !1, ce = (z = Y.column.columnDef.meta) == null ? void 0 : z.explicitSize;
        return ge ? "minmax(min-content, max-content)" : ce || `${le}px`;
      }).join(" ")), u;
    });
    function C(Z) {
      l.dragOverRowId = Z;
    }
    function m(Z) {
      l.dragOverPosition = Z;
    }
    const w = F(() => l.isHovered), y = F(() => l.dragOverRowId), b = F(() => l.dragOverPosition), _ = F(() => l.isDragOver);
    function M(Z, Y) {
      var ge, ce, G;
      Z.preventDefault();
      const le = (ge = Z.dataTransfer) == null ? void 0 : ge.files;
      if (l.isHovered = !1, !le || le.length === 0)
        if ((ce = Z.dataTransfer) != null && ce.getData("text/plain"))
          n("drop:row", {
            rowId: (G = Z.dataTransfer) == null ? void 0 : G.getData("text/plain"),
            rowOverId: l.dragOverRowId ?? "",
            position: l.dragOverPosition ?? "on"
          }), l.dragOverRowId = null;
        else
          return;
      else {
        l.dragOverRowId = null;
        const z = Array.from(le);
        n("drop:file", { files: z, row: Y });
      }
    }
    function x(Z) {
      var Y, le, ge;
      if (Z.preventDefault(), (Y = Z.dataTransfer) != null && Y.getData("text/plain"))
        n("drop:row", {
          rowId: (le = Z.dataTransfer) == null ? void 0 : le.getData("text/plain"),
          rowOverId: "__root_folder__",
          position: l.dragOverPosition ?? "on"
        }), l.dragOverRowId = null, l.isHovered = !1;
      else {
        const ce = (ge = Z.dataTransfer) == null ? void 0 : ge.files;
        ce && ce.length > 0 && B(Z), l.isHovered = !1;
        return;
      }
    }
    function L(Z) {
      l.dragOverRowId = Z;
    }
    function A(Z, Y) {
      const le = Y.relatedTarget;
      !(le != null && le.closest(`[data-row-id="${Z}"]`)) && (l.dragOverRowId = null);
    }
    function R(Z) {
      Z.preventDefault(), Z.dataTransfer && (Z.dataTransfer.dropEffect = "copy");
    }
    function P(Z) {
      var Y;
      Z.preventDefault(), l.dragCounter++, (Y = Z.dataTransfer) != null && Y.types.includes("Files") && (l.isDragOver = !0);
    }
    function I(Z) {
      Z.preventDefault(), l.dragCounter--, l.dragCounter === 0 && (l.isDragOver = !1);
    }
    function B(Z) {
      var le;
      Z.preventDefault(), l.isDragOver = !1, l.dragCounter = 0;
      const Y = Array.from(((le = Z.dataTransfer) == null ? void 0 : le.files) ?? []);
      Y.length > 0 && n("drop:file", { files: Y, row: {
        id: "__empty_zone__",
        original: null
      } });
    }
    function H() {
      l.isHovered = !0;
    }
    function O() {
      l.isHovered = !1;
    }
    function N(Z) {
      if (document.activeElement !== Z.currentTarget || !["ArrowUp", "ArrowDown", "Enter"].includes(Z.key))
        return;
      Z.preventDefault();
      const Y = o.table.getRowModel().flatRows;
      if (Y.length === 0)
        return;
      if (Z.key === "Enter") {
        if (o.autoselect)
          return;
        const G = Y.find((z) => z.id === i.value);
        G && j(G);
        return;
      }
      let le = 0;
      i.value && (le = Y.findIndex((G) => G.id === i.value));
      const ge = Math.min(
        Math.max(Z.key === "ArrowUp" ? le - 1 : le + 1, 0),
        Y.length - 1
      ), ce = Y[ge];
      ce && (i.value = ce.id, rt(() => te(ce.id)), o.emitRowOnArrow && j(ce));
    }
    function te(Z) {
      const Y = r.value;
      if (!Y)
        return;
      const le = Y.$el, ge = le.querySelector(`[data-row-id="${Z}"]`);
      if (!ge)
        return;
      const ce = ge.querySelector('[role="cell"]');
      if (!ce)
        return;
      const { top: G, bottom: z } = ce.getBoundingClientRect(), { top: oe, bottom: q } = le.getBoundingClientRect();
      G < oe + l7 ? le.scrollTop += G - oe - l7 : z > q && (le.scrollTop += z - q);
    }
    const E = Us(() => {
      if (o.autoselect && i.value) {
        const Z = o.table.getRowModel().flatRows.find((Y) => Y.id === i.value);
        Z && j(Z);
      }
    }, 500);
    function j(Z) {
      i.value = Z.id, n("rowClick", Z);
    }
    return (Z, Y) => (f(), U(g2, {
      ref_key: "wrapperRef",
      ref: r,
      class: S([Z.$style.wrapper, "w-full"]),
      loading: !1,
      overlay: ""
    }, {
      default: ee(() => [
        g("div", {
          role: "grid",
          class: S(Z.$style.table),
          style: Ge({ gridTemplateColumns: p.value }),
          tabIndex: "0",
          onKeydown: N
        }, [
          !e.hideHeader && c.value.length > 0 ? (f(!0), v(we, { key: 0 }, Ze(c.value, (le) => (f(), v("div", {
            key: le.id,
            role: "row",
            class: S(Z.$style.headerRow)
          }, [
            (f(!0), v(we, null, Ze(le.headers, (ge, ce) => (f(), v("div", {
              key: ge.id,
              colSpan: ge.colSpan,
              role: "heading",
              class: S([Z.$style.th])
            }, [
              g("div", {
                class: S([Z.$style.thLabel, { [Z.$style.sortable]: ge.column.getCanSort() }]),
                onClick: (G) => {
                  var z;
                  return (z = ge.column.getToggleSortingHandler()) == null ? void 0 : z(G);
                }
              }, [
                ce === 0 ? (f(), v("div", {
                  key: 0,
                  class: S(Z.$style.firstHeader)
                }, [
                  e.hierarchical ? (f(), U(ot, {
                    key: 0,
                    size: "small",
                    icon: e.table.getIsAllRowsExpanded() ? "tetrisly/16-arrowhead-down-small" : "tetrisly/16-arrowhead-right-small",
                    appearance: "secondary",
                    type: "bare",
                    class: S(Z.$style.noShrink),
                    onClick: [
                      Y[0] || (Y[0] = xe(() => {
                      }, ["stop"])),
                      Y[1] || (Y[1] = (G) => e.table.toggleAllRowsExpanded())
                    ]
                  }, null, 8, ["icon", "class"])) : $("", !0),
                  e.selectableRows ? (f(), U(Zo, {
                    key: 1,
                    checked: e.table.getIsAllRowsSelected() || e.table.getIsSomeRowsSelected(),
                    deselect: e.table.getIsSomeRowsSelected(),
                    class: S(Z.$style.checkbox)
                  }, {
                    default: ee(() => [
                      g("input", {
                        checked: e.table.getIsAllRowsSelected() || e.table.getIsSomeRowsSelected(),
                        onChange: e.table.getToggleAllRowsSelectedHandler(),
                        type: "checkbox",
                        onClick: Y[2] || (Y[2] = xe(() => {
                        }, ["stop"]))
                      }, null, 40, vnt)
                    ]),
                    _: 1
                  }, 8, ["checked", "deselect", "class"])) : $("", !0)
                ], 2)) : $("", !0),
                ve(Z.$slots, `${ge.id}_header`, { header: ge }, () => [
                  de(k(Q_), {
                    render: ge.column.columnDef.header,
                    props: ge.getContext()
                  }, null, 8, ["render", "props"])
                ]),
                ge.column.getIsSorted() ? (f(), U(Ae, {
                  key: 1,
                  size: "20px",
                  icon: ge.column.getIsSorted() === "asc" ? "tetrisly/arrow-up" : "tetrisly/arrow-down"
                }, null, 8, ["icon"])) : $("", !0)
              ], 10, fnt),
              ge.column.getCanResize() ? (f(), v("div", {
                key: 0,
                class: S(Z.$style.resizer),
                onDblclick: (G) => ge.column.resetSize(),
                onMousedown: (G) => {
                  var z;
                  return (z = ge.getResizeHandler()) == null ? void 0 : z(G);
                },
                onTouchstartPassive: (G) => {
                  var z;
                  return (z = ge.getResizeHandler()) == null ? void 0 : z(G);
                }
              }, null, 42, mnt)) : $("", !0)
            ], 10, pnt))), 128))
          ], 2))), 128)) : $("", !0),
          e.showFilterRow ? (f(), U(Got, {
            key: "_filter_row_key",
            cols: e.table.getVisibleFlatColumns(),
            order: e.order,
            "col-filters": k(s),
            "onUpdate:colFilters": Y[3] || (Y[3] = (le) => s.value = le)
          }, null, 8, ["cols", "order", "col-filters"])) : $("", !0),
          (f(!0), v(we, null, Ze(a.value, (le) => {
            var ge;
            return f(), U(gnt, {
              key: le.id,
              role: "row",
              row: le,
              "focused-row-id": i.value,
              hierarchical: e.hierarchical,
              "selectable-rows": e.selectableRows,
              class: S([
                Z.$style.row,
                { [Z.$style.clickable]: (ge = e.table.options.meta) == null ? void 0 : ge.rowClickable },
                { [Z.$style.selected]: le.getIsSelected() }
              ]),
              "data-row-id": le.id,
              "drag-over-row-id": y.value,
              "set-drag-over-row-id": C,
              "drag-over-position": b.value,
              "set-drag-over-position": m,
              draggable: o.draggable,
              "is-parent-hovered": w.value,
              onClick: (ce) => j(le),
              onRowClick: Y[4] || (Y[4] = (ce) => j(ce)),
              onCellMouseenter: (ce, G, z) => n("cell-mouseenter", ce, G, z),
              onCellMouseleave: Y[5] || (Y[5] = (ce) => n("cell-mouseleave", ce)),
              onDragover: Y[6] || (Y[6] = xe(() => {
              }, ["prevent"])),
              onDrop: (ce) => M(ce, le),
              onDragenter: xe((ce) => L(le.id), ["prevent"]),
              onDragleave: (ce) => A(le.id, ce)
            }, null, 8, ["row", "focused-row-id", "hierarchical", "selectable-rows", "class", "data-row-id", "drag-over-row-id", "drag-over-position", "draggable", "is-parent-hovered", "onClick", "onCellMouseenter", "onDrop", "onDragenter", "onDragleave"]);
          }), 128)),
          o.draggable && e.hierarchical ? (f(), v("div", {
            key: 2,
            class: S([Z.$style.rootDrop, { [Z.$style.rootDropHovered]: w.value }]),
            onDragover: xe(H, ["prevent"]),
            onDragenter: xe(P, ["prevent"]),
            onDragleave: O,
            onDrop: Y[7] || (Y[7] = xe((le) => x(le), ["prevent"]))
          }, null, 34)) : $("", !0),
          e.table.getRowModel().rows.length <= 0 && !e.loading ? (f(), v("div", {
            key: 3,
            class: S([Z.$style.empty, { [Z.$style.emptyDragOver]: _.value }]),
            onDragover: xe(R, ["prevent"]),
            onDragenter: xe(P, ["prevent"]),
            onDragleave: I,
            onDrop: xe(B, ["prevent"])
          }, [
            ve(Z.$slots, "_empty", {}, () => [
              de(tr, {
                title: Z.$t("common.emptyState.empty2")
              }, null, 8, ["title"])
            ])
          ], 34)) : $("", !0)
        ], 38)
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), wnt = "_wrapper_32fp8_747", bnt = "_table_32fp8_753", ynt = "_headerRow_32fp8_760", _nt = "_th_32fp8_763", Snt = "_firstHeader_32fp8_788", xnt = "_thLabel_32fp8_793", Mnt = "_sortable_32fp8_798", Ant = "_row_32fp8_801", Lnt = "_clickable_32fp8_804", Ent = "_td_32fp8_807", Pnt = "_expanded_32fp8_810", Rnt = "_selected_32fp8_816", Fnt = "_value_32fp8_841", Tnt = "_tdGap_32fp8_847", Int = "_indented_32fp8_850", Dnt = "_noShrink_32fp8_854", knt = "_checkbox_32fp8_857", Hnt = "_empty_32fp8_860", Vnt = "_emptyDragOver_32fp8_866", Ont = "_rootDrop_32fp8_871", Bnt = "_loadingIndicator_32fp8_879", $nt = "_resizer_32fp8_889", Znt = "_isResizing_32fp8_901", Gnt = "_rootDropHovered_32fp8_912", Nnt = {
  wrapper: wnt,
  table: bnt,
  headerRow: ynt,
  th: _nt,
  firstHeader: Snt,
  thLabel: xnt,
  sortable: Mnt,
  row: Ant,
  clickable: Lnt,
  td: Ent,
  expanded: Pnt,
  selected: Rnt,
  value: Fnt,
  tdGap: Tnt,
  indented: Int,
  noShrink: Dnt,
  checkbox: knt,
  empty: Hnt,
  emptyDragOver: Vnt,
  rootDrop: Ont,
  loadingIndicator: Bnt,
  resizer: $nt,
  isResizing: Znt,
  rootDropHovered: Gnt
}, znt = {
  $style: Nnt
}, Ust = /* @__PURE__ */ Ce(Cnt, [["__cssModules", znt]]);
var uo = /* @__PURE__ */ ((e) => (e.EMAIL = "email", e.PHONE = "phone", e.ADDRESS = "address", e.TEMPLATE = "template", e.PARENT = "parent", e.OTHER = "other", e))(uo || {});
const jnt = ["href"], Wnt = ["src", "alt"], Unt = /* @__PURE__ */ pe({
  __name: "SCADetailsTooltip",
  props: {
    visible: { type: Boolean },
    content: {},
    targetRect: {},
    placement: {},
    loading: { type: Boolean },
    avatarType: {},
    instant: { type: Boolean },
    onMouseEnter: { type: Function },
    onMouseLeave: { type: Function },
    onNavigate: { type: Function },
    href: {}
  },
  emits: ["mouseEnter", "mouseLeave"],
  setup(e, { emit: t }) {
    const o = e, n = t, s = W(!1), i = F(() => (o.avatarType ?? "initials") === "special" && !u()), r = () => {
      s.value = !0;
    }, l = () => {
      s.value = !1;
    }, a = (N) => {
      switch (N) {
        case uo.EMAIL:
          return "phosphor/envelope";
        case uo.PHONE:
          return "phosphor/phone";
        case uo.ADDRESS:
          return "phosphor/map-pin-simple-area";
        case uo.TEMPLATE:
          return "phosphor/notebook";
        case uo.PARENT:
          return "phosphor/tree-view";
        default:
          return "phosphor/clipboard-text";
      }
    }, c = (N) => {
      switch (N.type) {
        case uo.EMAIL:
          return {
            render: () => vo("a", { href: N.href ?? `mailto:${N.text}` }, N.text)
          };
        case uo.PHONE:
          return {
            render: () => vo("a", { href: `tel:${N.text}` }, N.text)
          };
        case uo.ADDRESS:
          return {
            render: () => {
              const te = Array.isArray(N.text) ? N.text.filter(Boolean) : [N.text], E = te.join(", ");
              return vo(
                "a",
                {
                  href: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(E)}`,
                  target: "_blank",
                  rel: "noopener noreferrer"
                },
                te.map((j, Z) => Z < te.length - 1 ? [j, vo("br")] : j)
              );
            }
          };
        default:
          return {
            render: () => vo("div", N.text)
          };
      }
    }, d = () => o.loading ? "" : o.content.title, u = () => o.loading ? void 0 : o.content.avatarUrl, h = () => o.loading ? void 0 : o.content.avatarColorIdx, p = () => o.loading ? "" : o.content.defaultModuleIcon ?? "", C = async () => {
      var N;
      await ((N = o.onNavigate) == null ? void 0 : N.call(o));
    }, m = (N, te) => {
      N.stopPropagation(), te.action && (N.defaultPrevented || N.button !== 0 || N.metaKey || N.ctrlKey || N.shiftKey || N.altKey || (N.preventDefault(), te.action()));
    }, w = W(null), y = W(null), b = W({ position: "absolute", top: "0", left: "0" }), _ = W({ position: "absolute", top: "0", left: "0" }), M = W(null);
    let x = null;
    const L = () => {
      A();
    }, A = async () => {
      if (!w.value || !M.value) return;
      const { x: N, y: te, middlewareData: E, placement: j } = await t3(M.value, w.value, {
        placement: o.placement,
        middleware: [
          J7({ mainAxis: 14, crossAxis: -20 }),
          e3(),
          X7({ padding: 0 }),
          IE({ element: y.value })
        ]
      });
      b.value = {
        position: "absolute",
        top: `${te}px`,
        left: `${N}px`
      };
      const Z = E.arrow;
      if (Z) {
        const { x: Y, y: le } = Z, ge = j.split("-")[0], ce = R(ge), G = P(ge);
        _.value = {
          position: "absolute",
          left: Y != null ? `${Y}px` : "",
          top: le != null ? `${le}px` : "",
          [ce]: "-8px",
          transform: `rotate(${G}deg)`
        };
      }
    }, R = (N) => {
      switch (N.split("-")[0]) {
        case "top":
          return "bottom";
        case "bottom":
          return "top";
        case "left":
          return "right";
        case "right":
          return "left";
        default:
          return "bottom";
      }
    }, P = (N) => {
      switch (N) {
        case "top":
          return 0;
        case "bottom":
          return 180;
        case "left":
          return 90;
        case "right":
          return -90;
        default:
          return 0;
      }
    };
    Me(
      () => o.visible,
      async (N) => {
        N ? (o.targetRect && (M.value = {
          getBoundingClientRect: () => o.targetRect
        }), await A(), w.value && M.value && (await rt(), x = W0(M.value, w.value, L)), document.addEventListener("click", H)) : (M.value = null, x && x(), document.removeEventListener("click", H));
      }
    );
    const I = () => {
      o.onMouseEnter(), n("mouseEnter");
    }, B = () => {
      o.onMouseLeave(), n("mouseLeave");
    }, H = (N) => {
      w.value && !w.value.contains(N.target) && o.onMouseLeave();
    }, O = (N) => [
      uo.EMAIL,
      uo.PHONE,
      uo.ADDRESS
    ].includes(N.type) || !!N.action;
    return At(async () => {
      o.visible && o.targetRect && (M.value = {
        getBoundingClientRect: () => o.targetRect
      }, await A(), w.value && M.value && (await rt(), x = W0(M.value, w.value, L)), document.addEventListener("click", H));
    }), Qi(() => {
      M.value = null, x && x(), document.removeEventListener("click", H);
    }), (N, te) => (f(), U(D5, { to: "body" }, [
      de(I0, {
        name: e.instant ? "tooltip-instant" : "tooltip-fade",
        appear: ""
      }, {
        default: ee(() => {
          var E, j;
          return [
            e.visible && !e.loading ? (f(), v("div", {
              key: 0,
              ref_key: "popoverRef",
              ref: w,
              class: S(N.$style.popover),
              style: Ge(b.value),
              onMouseenter: I,
              onMouseleave: B
            }, [
              g("a", {
                class: S([N.$style.avatarAndTitle, { [N.$style.withBorder]: (j = (E = e.content) == null ? void 0 : E.items) == null ? void 0 : j.length }]),
                href: o.href || void 0,
                role: "link",
                onClick: xe(C, ["prevent"]),
                onMouseenter: r,
                onMouseleave: l
              }, [
                i.value ? (f(), U(Ae, {
                  key: 0,
                  class: S(N.$style.specAvatarIcon),
                  icon: e.content.specialIcon ?? "",
                  size: "80px"
                }, null, 8, ["class", "icon"])) : (f(), U(oi, {
                  key: 1,
                  initials: k(dl)(d()),
                  "color-idx": h(),
                  shape: "rounded",
                  size: "80",
                  bordered: !!u(),
                  hovered: s.value
                }, {
                  default: ee(() => [
                    u() ? (f(), v("img", {
                      key: 0,
                      src: u(),
                      alt: d(),
                      loading: "lazy"
                    }, null, 8, Wnt)) : !d() && p() ? (f(), U(Ae, {
                      key: 1,
                      icon: p(),
                      size: "36px"
                    }, null, 8, ["icon"])) : $("", !0)
                  ]),
                  _: 1
                }, 8, ["initials", "color-idx", "bordered", "hovered"])),
                g("div", {
                  class: S(N.$style.title)
                }, se(d()), 3)
              ], 42, jnt),
              e.content.items.length ? (f(), v("div", {
                key: 0,
                class: S(N.$style.content)
              }, [
                (f(!0), v(we, null, Ze(e.content.items, (Z, Y) => (f(), v("div", {
                  key: Y,
                  class: S([N.$style.contentItem, { [N.$style.interactive]: O(Z) }])
                }, [
                  g("div", {
                    class: S(N.$style.itemIconContainer)
                  }, [
                    de(Ae, {
                      class: S(N.$style.itemIcon),
                      icon: a(Z.type)
                    }, null, 8, ["class", "icon"])
                  ], 2),
                  (f(), U(Po(c(Z)), {
                    item: Z,
                    class: S([
                      N.$style.itemText,
                      {
                        [N.$style.nowrap]: Z.type === k(uo).EMAIL || Z.type === k(uo).PHONE,
                        [N.$style.hasAction]: O(Z)
                      }
                    ]),
                    onClick: (le) => m(le, Z)
                  }, null, 8, ["item", "class", "onClick"]))
                ], 2))), 128))
              ], 2)) : $("", !0),
              g("div", {
                ref_key: "arrowRef",
                ref: y,
                class: S(N.$style.arrow),
                style: Ge(_.value)
              }, null, 6)
            ], 38)) : $("", !0)
          ];
        }),
        _: 1
      }, 8, ["name"])
    ]));
  }
}), Knt = "_popover_1ffyn_2", qnt = "_arrow_1ffyn_18", Ynt = "_avatarAndTitle_1ffyn_27", Qnt = "_specAvatarIcon_1ffyn_40", Jnt = "_withBorder_1ffyn_44", Xnt = "_title_1ffyn_48", est = "_content_1ffyn_60", tst = "_contentItem_1ffyn_70", ost = "_itemIconContainer_1ffyn_77", nst = "_itemIcon_1ffyn_77", sst = "_interactive_1ffyn_90", ist = "_itemText_1ffyn_94", rst = "_hasAction_1ffyn_119", lst = "_nowrap_1ffyn_125", ast = {
  popover: Knt,
  arrow: qnt,
  avatarAndTitle: Ynt,
  specAvatarIcon: Qnt,
  withBorder: Jnt,
  title: Xnt,
  content: est,
  contentItem: tst,
  itemIconContainer: ost,
  itemIcon: nst,
  interactive: sst,
  itemText: ist,
  hasAction: rst,
  nowrap: lst
}, cst = {
  $style: ast
}, Kst = /* @__PURE__ */ Ce(Unt, [["__cssModules", cst]]), qst = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" }));
export {
  uo as DetailsTooltipContentItemType,
  jst as SCAAgGridTable,
  Sst as SCAAlertBanner,
  oi as SCAAvatar,
  pst as SCAAvatarDialog,
  xst as SCABadge,
  It as SCAButton,
  Mst as SCAButtonGroup,
  iLe as SCACheckbox,
  Zo as SCACheckboxBase,
  Ast as SCACheckboxGroup,
  fst as SCAConfirmationDialog,
  Oa as SCADatetimeInputInline,
  I3e as SCADatetimePicker,
  Kst as SCADetailsTooltip,
  whe as SCADialog,
  Sr as SCADivider,
  m8e as SCADragAndDropField,
  Lst as SCADragAndDropList,
  zt as SCADropdown,
  vst as SCADropdownDivider,
  mst as SCADropdownGroupHeader,
  d2 as SCADropdownItem,
  Cst as SCAEditableTabsBar,
  Est as SCAFileGallery,
  T8e as SCAFileItem,
  wst as SCAFileUploader,
  x1 as SCAFilterSetItem,
  r1 as SCAHelperText,
  ot as SCAIconButton,
  hEe as SCAInlineBanner,
  wpe as SCAInlineMessage,
  c2 as SCAInput,
  $r as SCAInputBase,
  bst as SCAInputTags,
  yst as SCAInputTagsInline,
  Is as SCAInputWrapper,
  h2e as SCALabel,
  i1 as SCALoader,
  tr as SCANoItems,
  Pst as SCAOverflowContainer,
  Rst as SCAPagination,
  Fst as SCAPill,
  Tst as SCAProgressBar,
  Ist as SCARadioButton,
  BC as SCARadioButtonBase,
  Dst as SCARadioButtonGroup,
  _st as SCARichText,
  oa as SCASearchInput,
  Ds as SCASelect,
  ZC as SCASelectBase,
  kst as SCASidebarNavigationItem,
  Hst as SCASkeletonItem,
  Vst as SCASplitButton,
  Zst as SCASplitter,
  Gst as SCASplitterPanel,
  Nst as SCASplitterResizer,
  g2 as SCAStateBox,
  Ost as SCAStatus,
  Ae as SCASvgIcon,
  PEe as SCATab,
  VEe as SCATabGroup,
  Wst as SCATable,
  Ust as SCATableNew,
  Pn as SCATag,
  fl as SCATextHighlighter,
  t8e as SCAToast,
  $C as SCAToggle,
  bo as SCATooltip,
  Bst as SCATopNavigationItem,
  $st as SCAWorkspaceItem,
  o8e as TOAST_DURATION_MS,
  mS as avatarColorPalette,
  pet as componentsDeMessages,
  bet as componentsEnMessages,
  qst as helpers,
  zst as setComponentsLocale,
  gd as showToast,
  h2 as useDropdownHandle,
  u2 as useDropdownKeyboard
};
